
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9f81"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9f81"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("9vyMc", function(module, exports) {
//region block: polyfills
(function() {
    if (typeof globalThis === "object") return;
    Object.defineProperty(Object.prototype, "__magic__", {
        get: function() {
            return this;
        },
        configurable: true
    });
    __magic__.globalThis = __magic__;
    delete Object.prototype.__magic__;
})();
if (typeof Math.imul === "undefined") Math.imul = function imul(a, b) {
    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
};
if (typeof ArrayBuffer.isView === "undefined") ArrayBuffer.isView = function(a) {
    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
};
if (typeof Array.prototype.fill === "undefined") // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
Object.defineProperty(Array.prototype, "fill", {
    value: function(value) {
        // Steps 1-2.
        if (this == null) throw new TypeError("this is null or not defined");
        var O = Object(this); // Steps 3-5.
        var len = O.length >>> 0; // Steps 6-7.
        var start = arguments[1];
        var relativeStart = start >> 0; // Step 8.
        var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
        var end = arguments[2];
        var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
        var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
        while(k < finalValue){
            O[k] = value;
            k++;
        }
        return O;
    }
});
[
    Int8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Float32Array,
    Float64Array
].forEach(function(TypedArray) {
    if (typeof TypedArray.prototype.fill === "undefined") Object.defineProperty(TypedArray.prototype, "fill", {
        value: Array.prototype.fill
    });
});
if (typeof Math.clz32 === "undefined") Math.clz32 = function(log, LN2) {
    return function(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
    };
}(Math.log, Math.LN2);
if (typeof String.prototype.startsWith === "undefined") Object.defineProperty(String.prototype, "startsWith", {
    value: function(searchString, position) {
        position = position || 0;
        return this.lastIndexOf(searchString, position) === position;
    }
});
if (typeof String.prototype.endsWith === "undefined") Object.defineProperty(String.prototype, "endsWith", {
    value: function(searchString, position) {
        var subjectString = this.toString();
        if (position === undefined || position > subjectString.length) position = subjectString.length;
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    }
});
//endregion
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else factory(module.exports);
})(globalThis, function(_) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var isView = ArrayBuffer.isView;
    var clz32 = Math.clz32;
    //endregion
    //region block: pre-declaration
    initMetadataForInterface(CharSequence, "CharSequence");
    initMetadataForInterface(Comparable, "Comparable");
    initMetadataForClass(Number_0, "Number");
    initMetadataForObject(Unit, "Unit");
    initMetadataForClass(_no_name_provided__qut3iv);
    initMetadataForInterface(Iterable, "Iterable");
    initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [
        Iterable
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForClass(Char, "Char", VOID, VOID, [
        Comparable
    ]);
    initMetadataForInterface(Collection, "Collection", VOID, VOID, [
        Iterable
    ]);
    initMetadataForInterface(KtList, "List", VOID, VOID, [
        Collection
    ]);
    initMetadataForInterface(KtSet, "Set", VOID, VOID, [
        Collection
    ]);
    initMetadataForInterface(Entry, "Entry");
    initMetadataForInterface(KtMap, "Map");
    initMetadataForInterface(MutableIterable, "MutableIterable", VOID, VOID, [
        Iterable
    ]);
    initMetadataForInterface(KtMutableList, "MutableList", VOID, VOID, [
        KtList,
        Collection,
        MutableIterable
    ]);
    initMetadataForInterface(KtMutableSet, "MutableSet", VOID, VOID, [
        KtSet,
        Collection,
        MutableIterable
    ]);
    initMetadataForInterface(KtMutableMap, "MutableMap", VOID, VOID, [
        KtMap
    ]);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(Enum, "Enum", VOID, VOID, [
        Comparable
    ]);
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(Long, "Long", VOID, Number_0, [
        Number_0,
        Comparable
    ]);
    initMetadataForClass(arrayIterator$1);
    initMetadataForObject(ByteCompanionObject, "ByteCompanionObject");
    initMetadataForObject(ShortCompanionObject, "ShortCompanionObject");
    initMetadataForObject(IntCompanionObject, "IntCompanionObject");
    initMetadataForObject(FloatCompanionObject, "FloatCompanionObject");
    initMetadataForObject(DoubleCompanionObject, "DoubleCompanionObject");
    initMetadataForObject(StringCompanionObject, "StringCompanionObject");
    initMetadataForObject(BooleanCompanionObject, "BooleanCompanionObject");
    initMetadataForObject(Digit, "Digit");
    initMetadataForObject(Letter, "Letter");
    initMetadataForObject(OtherLowercase, "OtherLowercase");
    initMetadataForClass(AbstractCollection, "AbstractCollection", VOID, VOID, [
        Collection
    ]);
    initMetadataForClass(AbstractMutableCollection, "AbstractMutableCollection", VOID, AbstractCollection, [
        AbstractCollection,
        Collection,
        MutableIterable
    ]);
    initMetadataForClass(IteratorImpl, "IteratorImpl");
    initMetadataForClass(ListIteratorImpl, "ListIteratorImpl", VOID, IteratorImpl);
    initMetadataForClass(AbstractMutableList, "AbstractMutableList", VOID, AbstractMutableCollection, [
        AbstractMutableCollection,
        KtMutableList
    ]);
    initMetadataForInterface(RandomAccess, "RandomAccess");
    initMetadataForClass(SubList, "SubList", VOID, AbstractMutableList, [
        AbstractMutableList,
        RandomAccess
    ]);
    initMetadataForClass(AbstractMap, "AbstractMap", VOID, VOID, [
        KtMap
    ]);
    initMetadataForClass(AbstractMutableMap, "AbstractMutableMap", VOID, AbstractMap, [
        AbstractMap,
        KtMutableMap
    ]);
    initMetadataForClass(AbstractMutableSet, "AbstractMutableSet", VOID, AbstractMutableCollection, [
        AbstractMutableCollection,
        KtMutableSet
    ]);
    initMetadataForCompanion(Companion_2);
    initMetadataForClass(ArrayList, "ArrayList", ArrayList_init_$Create$, AbstractMutableList, [
        AbstractMutableList,
        KtMutableList,
        RandomAccess
    ]);
    initMetadataForClass(HashMap, "HashMap", HashMap_init_$Create$, AbstractMutableMap, [
        AbstractMutableMap,
        KtMutableMap
    ]);
    initMetadataForClass(HashMapKeys, "HashMapKeys", VOID, AbstractMutableSet, [
        KtMutableSet,
        AbstractMutableSet
    ]);
    initMetadataForClass(HashMapValues, "HashMapValues", VOID, AbstractMutableCollection, [
        Collection,
        MutableIterable,
        AbstractMutableCollection
    ]);
    initMetadataForClass(HashMapEntrySetBase, "HashMapEntrySetBase", VOID, AbstractMutableSet, [
        KtMutableSet,
        AbstractMutableSet
    ]);
    initMetadataForClass(HashMapEntrySet, "HashMapEntrySet", VOID, HashMapEntrySetBase);
    initMetadataForClass(HashMapKeysDefault$iterator$1);
    initMetadataForClass(HashMapKeysDefault, "HashMapKeysDefault", VOID, AbstractMutableSet);
    initMetadataForClass(HashMapValuesDefault$iterator$1);
    initMetadataForClass(HashMapValuesDefault, "HashMapValuesDefault", VOID, AbstractMutableCollection);
    initMetadataForClass(HashSet, "HashSet", HashSet_init_$Create$, AbstractMutableSet, [
        AbstractMutableSet,
        KtMutableSet
    ]);
    initMetadataForCompanion(Companion_3);
    initMetadataForClass(Itr, "Itr");
    initMetadataForClass(KeysItr, "KeysItr", VOID, Itr);
    initMetadataForClass(ValuesItr, "ValuesItr", VOID, Itr);
    initMetadataForClass(EntriesItr, "EntriesItr", VOID, Itr);
    initMetadataForClass(EntryRef, "EntryRef", VOID, VOID, [
        Entry
    ]);
    function containsAllEntries(m) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(m, Collection)) tmp = m.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = m.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.InternalMap.containsAllEntries.<anonymous>' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var entry = element;
                var tmp_0;
                if (!(entry == null) ? isInterface(entry, Entry) : false) tmp_0 = this.j8(entry);
                else tmp_0 = false;
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    }
    initMetadataForInterface(InternalMap, "InternalMap");
    initMetadataForClass(InternalHashMap, "InternalHashMap", InternalHashMap_init_$Create$, VOID, [
        InternalMap
    ]);
    initMetadataForObject(EmptyHolder, "EmptyHolder");
    initMetadataForClass(LinkedHashMap, "LinkedHashMap", LinkedHashMap_init_$Create$, HashMap, [
        HashMap,
        KtMutableMap
    ]);
    initMetadataForClass(LinkedHashSet, "LinkedHashSet", LinkedHashSet_init_$Create$, HashSet, [
        HashSet,
        KtMutableSet
    ]);
    initMetadataForInterface(Continuation, "Continuation");
    initMetadataForClass(InterceptedCoroutine, "InterceptedCoroutine", VOID, VOID, [
        Continuation
    ]);
    initMetadataForClass(CoroutineImpl, "CoroutineImpl", VOID, InterceptedCoroutine, [
        InterceptedCoroutine,
        Continuation
    ]);
    initMetadataForObject(CompletedContinuation, "CompletedContinuation", VOID, VOID, [
        Continuation
    ]);
    initMetadataForClass(Exception, "Exception", Exception_init_$Create$, Error);
    initMetadataForClass(RuntimeException, "RuntimeException", RuntimeException_init_$Create$, Exception);
    initMetadataForClass(IllegalStateException, "IllegalStateException", IllegalStateException_init_$Create$, RuntimeException);
    initMetadataForClass(CancellationException, "CancellationException", CancellationException_init_$Create$, IllegalStateException);
    initMetadataForClass(_no_name_provided__qut3iv_1, VOID, VOID, CoroutineImpl);
    initMetadataForClass(IllegalArgumentException, "IllegalArgumentException", IllegalArgumentException_init_$Create$, RuntimeException);
    initMetadataForClass(IndexOutOfBoundsException, "IndexOutOfBoundsException", IndexOutOfBoundsException_init_$Create$, RuntimeException);
    initMetadataForClass(UnsupportedOperationException, "UnsupportedOperationException", UnsupportedOperationException_init_$Create$, RuntimeException);
    initMetadataForClass(NoSuchElementException, "NoSuchElementException", NoSuchElementException_init_$Create$, RuntimeException);
    initMetadataForClass(Error_0, "Error", Error_init_$Create$, Error);
    initMetadataForClass(AssertionError, "AssertionError", AssertionError_init_$Create$, Error_0);
    initMetadataForClass(ConcurrentModificationException, "ConcurrentModificationException", ConcurrentModificationException_init_$Create$, RuntimeException);
    initMetadataForClass(ArithmeticException, "ArithmeticException", ArithmeticException_init_$Create$, RuntimeException);
    initMetadataForClass(NumberFormatException, "NumberFormatException", NumberFormatException_init_$Create$, IllegalArgumentException);
    initMetadataForClass(NullPointerException, "NullPointerException", NullPointerException_init_$Create$, RuntimeException);
    initMetadataForClass(NoWhenBranchMatchedException, "NoWhenBranchMatchedException", NoWhenBranchMatchedException_init_$Create$, RuntimeException);
    initMetadataForClass(ClassCastException, "ClassCastException", ClassCastException_init_$Create$, RuntimeException);
    initMetadataForClass(UninitializedPropertyAccessException, "UninitializedPropertyAccessException", UninitializedPropertyAccessException_init_$Create$, RuntimeException);
    initMetadataForInterface(KClass, "KClass");
    initMetadataForClass(KClassImpl, "KClassImpl", VOID, VOID, [
        KClass
    ]);
    initMetadataForObject(NothingKClassImpl, "NothingKClassImpl", VOID, KClassImpl);
    initMetadataForClass(ErrorKClass, "ErrorKClass", ErrorKClass, VOID, [
        KClass
    ]);
    initMetadataForClass(PrimitiveKClassImpl, "PrimitiveKClassImpl", VOID, KClassImpl);
    initMetadataForClass(SimpleKClassImpl, "SimpleKClassImpl", VOID, KClassImpl);
    initMetadataForInterface(KProperty1, "KProperty1");
    initMetadataForClass(KTypeImpl, "KTypeImpl");
    initMetadataForObject(PrimitiveClasses, "PrimitiveClasses");
    initMetadataForClass(CharacterCodingException, "CharacterCodingException", CharacterCodingException_init_$Create$, Exception);
    initMetadataForClass(StringBuilder, "StringBuilder", StringBuilder_init_$Create$_0, VOID, [
        CharSequence
    ]);
    initMetadataForCompanion(Companion_4);
    initMetadataForClass(Regex, "Regex");
    initMetadataForClass(MatchGroup, "MatchGroup");
    initMetadataForClass(findNext$1$groups$1, VOID, VOID, AbstractCollection, [
        Collection,
        AbstractCollection
    ]);
    initMetadataForClass(AbstractList, "AbstractList", VOID, AbstractCollection, [
        AbstractCollection,
        KtList
    ]);
    initMetadataForClass(findNext$1$groupValues$1, VOID, VOID, AbstractList);
    initMetadataForClass(findNext$1);
    initMetadataForClass(sam$kotlin_Comparator$0, "sam$kotlin_Comparator$0");
    initMetadataForClass(ExceptionTraceBuilder, "ExceptionTraceBuilder", ExceptionTraceBuilder);
    initMetadataForClass(DurationUnit, "DurationUnit", VOID, Enum);
    initMetadataForClass(SubList_0, "SubList", VOID, AbstractList, [
        AbstractList,
        RandomAccess
    ]);
    initMetadataForClass(IteratorImpl_0, "IteratorImpl");
    initMetadataForClass(ListIteratorImpl_0, "ListIteratorImpl", VOID, IteratorImpl_0);
    initMetadataForCompanion(Companion_5);
    initMetadataForClass(AbstractMap$keys$1$iterator$1);
    initMetadataForClass(AbstractMap$values$1$iterator$1);
    initMetadataForCompanion(Companion_6);
    initMetadataForClass(AbstractSet, "AbstractSet", VOID, AbstractCollection, [
        AbstractCollection,
        KtSet
    ]);
    initMetadataForClass(AbstractMap$keys$1, VOID, VOID, AbstractSet);
    initMetadataForClass(AbstractMap$values$1, VOID, VOID, AbstractCollection);
    initMetadataForCompanion(Companion_7);
    initMetadataForCompanion(Companion_8);
    initMetadataForClass(ArrayDeque, "ArrayDeque", ArrayDeque_init_$Create$, AbstractMutableList);
    initMetadataForObject(EmptyList, "EmptyList", VOID, VOID, [
        KtList,
        RandomAccess
    ]);
    initMetadataForObject(EmptyIterator, "EmptyIterator");
    initMetadataForClass(ArrayAsCollection, "ArrayAsCollection", VOID, VOID, [
        Collection
    ]);
    initMetadataForClass(IndexedValue, "IndexedValue");
    initMetadataForClass(IndexingIterable, "IndexingIterable", VOID, VOID, [
        Iterable
    ]);
    initMetadataForClass(IndexingIterator, "IndexingIterator");
    initMetadataForInterface(MapWithDefault, "MapWithDefault", VOID, VOID, [
        KtMap
    ]);
    initMetadataForObject(EmptyMap, "EmptyMap", VOID, VOID, [
        KtMap
    ]);
    initMetadataForClass(IntIterator, "IntIterator");
    initMetadataForClass(CharIterator, "CharIterator");
    initMetadataForClass(SequenceScope, "SequenceScope", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(SequenceBuilderIterator, "SequenceBuilderIterator", SequenceBuilderIterator, SequenceScope, [
        SequenceScope,
        Continuation
    ], [
        1
    ]);
    initMetadataForClass(TransformingSequence$iterator$1);
    initMetadataForClass(TransformingSequence, "TransformingSequence");
    initMetadataForObject(EmptySet, "EmptySet", VOID, VOID, [
        KtSet
    ]);
    initMetadataForObject(Key, "Key");
    function plus(context) {
        var tmp;
        if (context === EmptyCoroutineContext_getInstance()) tmp = this;
        else tmp = context.uf(this, CoroutineContext$plus$lambda);
        return tmp;
    }
    initMetadataForInterface(CoroutineContext, "CoroutineContext");
    function get(key) {
        var tmp;
        if (equals(this.a1(), key)) tmp = isInterface(this, Element) ? this : THROW_CCE();
        else tmp = null;
        return tmp;
    }
    function fold(initial, operation) {
        return operation(initial, this);
    }
    function minusKey(key) {
        return equals(this.a1(), key) ? EmptyCoroutineContext_getInstance() : this;
    }
    initMetadataForInterface(Element, "Element", VOID, VOID, [
        CoroutineContext
    ]);
    function releaseInterceptedContinuation(continuation) {}
    function get_0(key) {
        if (key instanceof AbstractCoroutineContextKey) {
            var tmp;
            if (key.sf(this.a1())) {
                var tmp_0 = key.rf(this);
                tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element) : false) ? tmp_0 : null;
            } else tmp = null;
            return tmp;
        }
        var tmp_1;
        if (Key_instance === key) tmp_1 = isInterface(this, Element) ? this : THROW_CCE();
        else tmp_1 = null;
        return tmp_1;
    }
    function minusKey_0(key) {
        if (key instanceof AbstractCoroutineContextKey) return key.sf(this.a1()) && !(key.rf(this) == null) ? EmptyCoroutineContext_getInstance() : this;
        return Key_instance === key ? EmptyCoroutineContext_getInstance() : this;
    }
    initMetadataForInterface(ContinuationInterceptor, "ContinuationInterceptor", VOID, VOID, [
        Element
    ]);
    initMetadataForObject(EmptyCoroutineContext, "EmptyCoroutineContext", VOID, VOID, [
        CoroutineContext
    ]);
    initMetadataForClass(CombinedContext, "CombinedContext", VOID, VOID, [
        CoroutineContext
    ]);
    initMetadataForClass(AbstractCoroutineContextKey, "AbstractCoroutineContextKey");
    initMetadataForClass(AbstractCoroutineContextElement, "AbstractCoroutineContextElement", VOID, VOID, [
        Element
    ]);
    initMetadataForClass(CoroutineSingletons, "CoroutineSingletons", VOID, Enum);
    initMetadataForClass(EnumEntriesList, "EnumEntriesList", VOID, AbstractList, [
        KtList,
        AbstractList
    ]);
    initMetadataForClass(Base64, "Base64");
    initMetadataForObject(Default, "Default", VOID, Base64);
    initMetadataForClass(Random, "Random");
    initMetadataForObject(Default_0, "Default", VOID, Random);
    initMetadataForCompanion(Companion_9);
    initMetadataForClass(XorWowRandom, "XorWowRandom", VOID, Random);
    initMetadataForCompanion(Companion_10);
    initMetadataForClass(IntProgression, "IntProgression", VOID, VOID, [
        Iterable
    ]);
    function contains(value) {
        return compareTo(value, this.t()) >= 0 && compareTo(value, this.u()) <= 0;
    }
    initMetadataForInterface(ClosedRange, "ClosedRange");
    initMetadataForClass(IntRange, "IntRange", VOID, IntProgression, [
        IntProgression,
        ClosedRange
    ]);
    initMetadataForCompanion(Companion_11);
    initMetadataForClass(CharProgression, "CharProgression", VOID, VOID, [
        Iterable
    ]);
    initMetadataForClass(CharRange, "CharRange", VOID, CharProgression, [
        CharProgression,
        ClosedRange
    ]);
    initMetadataForClass(IntProgressionIterator, "IntProgressionIterator", VOID, IntIterator);
    initMetadataForClass(CharProgressionIterator, "CharProgressionIterator", VOID, CharIterator);
    initMetadataForCompanion(Companion_12);
    initMetadataForCompanion(Companion_13);
    initMetadataForInterface(KTypeParameter, "KTypeParameter");
    initMetadataForCompanion(Companion_14);
    initMetadataForClass(KTypeProjection, "KTypeProjection");
    initMetadataForClass(KVariance, "KVariance", VOID, Enum);
    initMetadataForClass(DelimitedRangesSequence$iterator$1);
    initMetadataForClass(DelimitedRangesSequence, "DelimitedRangesSequence");
    initMetadataForCompanion(Companion_15);
    initMetadataForClass(Duration, "Duration", VOID, VOID, [
        Comparable
    ]);
    initMetadataForClass(DeepRecursiveScope, "DeepRecursiveScope", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(DeepRecursiveFunction, "DeepRecursiveFunction");
    initMetadataForClass(DeepRecursiveScopeImpl, "DeepRecursiveScopeImpl", VOID, DeepRecursiveScope, [
        DeepRecursiveScope,
        Continuation
    ], [
        1
    ]);
    initMetadataForClass(LazyThreadSafetyMode, "LazyThreadSafetyMode", VOID, Enum);
    initMetadataForClass(UnsafeLazyImpl, "UnsafeLazyImpl");
    initMetadataForObject(UNINITIALIZED_VALUE, "UNINITIALIZED_VALUE");
    initMetadataForCompanion(Companion_16);
    initMetadataForClass(Failure, "Failure");
    initMetadataForClass(Result, "Result");
    initMetadataForClass(NotImplementedError, "NotImplementedError", NotImplementedError, Error_0);
    initMetadataForClass(Pair, "Pair");
    initMetadataForClass(Triple, "Triple");
    initMetadataForCompanion(Companion_17);
    initMetadataForClass(UByte, "UByte", VOID, VOID, [
        Comparable
    ]);
    initMetadataForClass(Iterator, "Iterator");
    initMetadataForClass(UByteArray, "UByteArray", VOID, VOID, [
        Collection
    ]);
    initMetadataForCompanion(Companion_18);
    initMetadataForClass(UInt, "UInt", VOID, VOID, [
        Comparable
    ]);
    initMetadataForClass(Iterator_0, "Iterator");
    initMetadataForClass(UIntArray, "UIntArray", VOID, VOID, [
        Collection
    ]);
    initMetadataForCompanion(Companion_19);
    initMetadataForClass(ULong, "ULong", VOID, VOID, [
        Comparable
    ]);
    initMetadataForClass(Iterator_1, "Iterator");
    initMetadataForClass(ULongArray, "ULongArray", VOID, VOID, [
        Collection
    ]);
    initMetadataForCompanion(Companion_20);
    initMetadataForClass(UShort, "UShort", VOID, VOID, [
        Comparable
    ]);
    initMetadataForClass(Iterator_2, "Iterator");
    initMetadataForClass(UShortArray, "UShortArray", VOID, VOID, [
        Collection
    ]);
    //endregion
    function CharSequence() {}
    function Comparable() {}
    function Number_0() {}
    function Unit() {}
    protoOf(Unit).toString = function() {
        return "kotlin.Unit";
    };
    var Unit_instance;
    function Unit_getInstance() {
        return Unit_instance;
    }
    function toList(_this__u8e3s4) {
        switch(_this__u8e3s4.length){
            case 0:
                return emptyList();
            case 1:
                return listOf(_this__u8e3s4[0]);
            default:
                return toMutableList(_this__u8e3s4);
        }
    }
    function withIndex(_this__u8e3s4) {
        return new IndexingIterable(withIndex$lambda(_this__u8e3s4));
    }
    function get_indices(_this__u8e3s4) {
        return new IntRange(0, get_lastIndex(_this__u8e3s4));
    }
    function get_indices_0(_this__u8e3s4) {
        return new IntRange(0, get_lastIndex_0(_this__u8e3s4));
    }
    function toSet(_this__u8e3s4) {
        switch(_this__u8e3s4.length){
            case 0:
                return emptySet();
            case 1:
                return setOf(_this__u8e3s4[0]);
            default:
                return toCollection(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.length)));
        }
    }
    function contains_0(_this__u8e3s4, element) {
        return indexOf(_this__u8e3s4, element) >= 0;
    }
    function contains_1(_this__u8e3s4, element) {
        return indexOf_0(_this__u8e3s4, element) >= 0;
    }
    function contains_2(_this__u8e3s4, element) {
        return indexOf_1(_this__u8e3s4, element) >= 0;
    }
    function contains_3(_this__u8e3s4, element) {
        return indexOf_2(_this__u8e3s4, element) >= 0;
    }
    function contains_4(_this__u8e3s4, element) {
        return indexOf_3(_this__u8e3s4, element) >= 0;
    }
    function indexOf(_this__u8e3s4, element) {
        if (element == null) {
            var inductionVariable = 0;
            var last = _this__u8e3s4.length - 1 | 0;
            if (inductionVariable <= last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (_this__u8e3s4[index] == null) return index;
            }while (inductionVariable <= last);
        } else {
            var inductionVariable_0 = 0;
            var last_0 = _this__u8e3s4.length - 1 | 0;
            if (inductionVariable_0 <= last_0) do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (equals(element, _this__u8e3s4[index_0])) return index_0;
            }while (inductionVariable_0 <= last_0);
        }
        return -1;
    }
    function toCollection(_this__u8e3s4, destination) {
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        while(inductionVariable < last){
            var item = _this__u8e3s4[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            destination.e(item);
        }
        return destination;
    }
    function single(_this__u8e3s4) {
        var tmp;
        switch(_this__u8e3s4.length){
            case 0:
                throw NoSuchElementException_init_$Create$_0("Array is empty.");
            case 1:
                tmp = _this__u8e3s4[0];
                break;
            default:
                throw IllegalArgumentException_init_$Create$_0("Array has more than one element.");
        }
        return tmp;
    }
    function toMutableList(_this__u8e3s4) {
        return ArrayList_init_$Create$_1(asCollection(_this__u8e3s4));
    }
    function get_lastIndex(_this__u8e3s4) {
        return _this__u8e3s4.length - 1 | 0;
    }
    function get_lastIndex_0(_this__u8e3s4) {
        return _this__u8e3s4.length - 1 | 0;
    }
    function indexOf_0(_this__u8e3s4, element) {
        var inductionVariable = 0;
        var last = _this__u8e3s4.length - 1 | 0;
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (element.equals(_this__u8e3s4[index])) return index;
        }while (inductionVariable <= last);
        return -1;
    }
    function indexOf_1(_this__u8e3s4, element) {
        var inductionVariable = 0;
        var last = _this__u8e3s4.length - 1 | 0;
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (element === _this__u8e3s4[index]) return index;
        }while (inductionVariable <= last);
        return -1;
    }
    function indexOf_2(_this__u8e3s4, element) {
        var inductionVariable = 0;
        var last = _this__u8e3s4.length - 1 | 0;
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (element === _this__u8e3s4[index]) return index;
        }while (inductionVariable <= last);
        return -1;
    }
    function indexOf_3(_this__u8e3s4, element) {
        var inductionVariable = 0;
        var last = _this__u8e3s4.length - 1 | 0;
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (element === _this__u8e3s4[index]) return index;
        }while (inductionVariable <= last);
        return -1;
    }
    function get_lastIndex_1(_this__u8e3s4) {
        return _this__u8e3s4.length - 1 | 0;
    }
    function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
        separator = separator === VOID ? ", " : separator;
        prefix = prefix === VOID ? "" : prefix;
        postfix = postfix === VOID ? "" : postfix;
        limit = limit === VOID ? -1 : limit;
        truncated = truncated === VOID ? "..." : truncated;
        transform = transform === VOID ? null : transform;
        return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
    }
    function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
        separator = separator === VOID ? ", " : separator;
        prefix = prefix === VOID ? "" : prefix;
        postfix = postfix === VOID ? "" : postfix;
        limit = limit === VOID ? -1 : limit;
        truncated = truncated === VOID ? "..." : truncated;
        transform = transform === VOID ? null : transform;
        buffer.f(prefix);
        var count = 0;
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        $l$loop: while(inductionVariable < last){
            var element = _this__u8e3s4[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            count = count + 1 | 0;
            if (count > 1) buffer.f(separator);
            if (limit < 0 || count <= limit) appendElement(buffer, element, transform);
            else break $l$loop;
        }
        if (limit >= 0 && count > limit) buffer.f(truncated);
        buffer.f(postfix);
        return buffer;
    }
    function zip(_this__u8e3s4, other) {
        // Inline function 'kotlin.collections.zip' call
        // Inline function 'kotlin.comparisons.minOf' call
        var a = _this__u8e3s4.length;
        var b = other.length;
        var size = Math.min(a, b);
        var list = ArrayList_init_$Create$_0(size);
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.zip.<anonymous>' call
            var t1 = _this__u8e3s4[i];
            var t2 = other[i];
            var tmp$ret$1 = to(t1, t2);
            list.e(tmp$ret$1);
        }while (inductionVariable < size);
        return list;
    }
    function firstOrNull(_this__u8e3s4) {
        var tmp;
        // Inline function 'kotlin.collections.isEmpty' call
        if (_this__u8e3s4.length === 0) tmp = null;
        else tmp = _this__u8e3s4[0];
        return tmp;
    }
    function getOrNull(_this__u8e3s4, index) {
        return (0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false) ? _this__u8e3s4[index] : null;
    }
    function withIndex$lambda($this_withIndex) {
        return function() {
            return arrayIterator($this_withIndex);
        };
    }
    function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
        separator = separator === VOID ? ", " : separator;
        prefix = prefix === VOID ? "" : prefix;
        postfix = postfix === VOID ? "" : postfix;
        limit = limit === VOID ? -1 : limit;
        truncated = truncated === VOID ? "..." : truncated;
        transform = transform === VOID ? null : transform;
        return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
    }
    function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
        separator = separator === VOID ? ", " : separator;
        prefix = prefix === VOID ? "" : prefix;
        postfix = postfix === VOID ? "" : postfix;
        limit = limit === VOID ? -1 : limit;
        truncated = truncated === VOID ? "..." : truncated;
        transform = transform === VOID ? null : transform;
        buffer.f(prefix);
        var count = 0;
        var tmp0_iterator = _this__u8e3s4.j();
        $l$loop: while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            count = count + 1 | 0;
            if (count > 1) buffer.f(separator);
            if (limit < 0 || count <= limit) appendElement(buffer, element, transform);
            else break $l$loop;
        }
        if (limit >= 0 && count > limit) buffer.f(truncated);
        buffer.f(postfix);
        return buffer;
    }
    function toHashSet(_this__u8e3s4) {
        return toCollection_0(_this__u8e3s4, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
    }
    function toBooleanArray(_this__u8e3s4) {
        var result = booleanArray(_this__u8e3s4.m());
        var index = 0;
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            result[tmp1] = element;
        }
        return result;
    }
    function plus_0(_this__u8e3s4, element) {
        var result = ArrayList_init_$Create$_0(_this__u8e3s4.m() + 1 | 0);
        result.n(_this__u8e3s4);
        result.e(element);
        return result;
    }
    function toSet_0(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, Collection)) {
            var tmp;
            switch(_this__u8e3s4.m()){
                case 0:
                    tmp = emptySet();
                    break;
                case 1:
                    var tmp_0;
                    if (isInterface(_this__u8e3s4, KtList)) tmp_0 = _this__u8e3s4.o(0);
                    else tmp_0 = _this__u8e3s4.j().l();
                    tmp = setOf(tmp_0);
                    break;
                default:
                    tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.m())));
                    break;
            }
            return tmp;
        }
        return optimizeReadOnlySet(toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$()));
    }
    function union(_this__u8e3s4, other) {
        var set = toMutableSet(_this__u8e3s4);
        addAll(set, other);
        return set;
    }
    function slice(_this__u8e3s4, indices) {
        if (indices.s()) // Inline function 'kotlin.collections.listOf' call
        return emptyList();
        return toList_0(_this__u8e3s4.v(indices.t(), indices.u() + 1 | 0));
    }
    function singleOrNull(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, KtList)) return _this__u8e3s4.m() === 1 ? _this__u8e3s4.o(0) : null;
        else {
            var iterator = _this__u8e3s4.j();
            if (!iterator.k()) return null;
            var single = iterator.l();
            if (iterator.k()) return null;
            return single;
        }
    }
    function toList_0(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, Collection)) {
            var tmp;
            switch(_this__u8e3s4.m()){
                case 0:
                    tmp = emptyList();
                    break;
                case 1:
                    var tmp_0;
                    if (isInterface(_this__u8e3s4, KtList)) tmp_0 = _this__u8e3s4.o(0);
                    else tmp_0 = _this__u8e3s4.j().l();
                    tmp = listOf(tmp_0);
                    break;
                default:
                    tmp = toMutableList_0(_this__u8e3s4);
                    break;
            }
            return tmp;
        }
        return optimizeReadOnlyList(toMutableList_1(_this__u8e3s4));
    }
    function firstOrNull_0(_this__u8e3s4) {
        return _this__u8e3s4.s() ? null : _this__u8e3s4.o(0);
    }
    function first(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, KtList)) return first_0(_this__u8e3s4);
        else {
            var iterator = _this__u8e3s4.j();
            if (!iterator.k()) throw NoSuchElementException_init_$Create$_0("Collection is empty.");
            return iterator.l();
        }
    }
    function asSequence(_this__u8e3s4) {
        // Inline function 'kotlin.sequences.Sequence' call
        return new _no_name_provided__qut3iv(_this__u8e3s4);
    }
    function plus_1(_this__u8e3s4, elements) {
        if (isInterface(elements, Collection)) {
            var result = ArrayList_init_$Create$_0(_this__u8e3s4.m() + elements.m() | 0);
            result.n(_this__u8e3s4);
            result.n(elements);
            return result;
        } else {
            var result_0 = ArrayList_init_$Create$_1(_this__u8e3s4);
            addAll(result_0, elements);
            return result_0;
        }
    }
    function plus_2(_this__u8e3s4, elements) {
        if (isInterface(_this__u8e3s4, Collection)) return plus_1(_this__u8e3s4, elements);
        var result = ArrayList_init_$Create$();
        addAll(result, _this__u8e3s4);
        addAll(result, elements);
        return result;
    }
    function last(_this__u8e3s4) {
        if (_this__u8e3s4.s()) throw NoSuchElementException_init_$Create$_0("List is empty.");
        return _this__u8e3s4.o(get_lastIndex_2(_this__u8e3s4));
    }
    function reversed(_this__u8e3s4) {
        var tmp;
        if (isInterface(_this__u8e3s4, Collection)) tmp = _this__u8e3s4.m() <= 1;
        else tmp = false;
        if (tmp) return toList_0(_this__u8e3s4);
        var list = toMutableList_1(_this__u8e3s4);
        reverse(list);
        return list;
    }
    function singleOrNull_0(_this__u8e3s4) {
        return _this__u8e3s4.m() === 1 ? _this__u8e3s4.o(0) : null;
    }
    function first_0(_this__u8e3s4) {
        if (_this__u8e3s4.s()) throw NoSuchElementException_init_$Create$_0("List is empty.");
        return _this__u8e3s4.o(0);
    }
    function getOrNull_0(_this__u8e3s4, index) {
        return (0 <= index ? index < _this__u8e3s4.m() : false) ? _this__u8e3s4.o(index) : null;
    }
    function intersect(_this__u8e3s4, other) {
        var set = toMutableSet(_this__u8e3s4);
        retainAll(set, other);
        return set;
    }
    function toCollection_0(_this__u8e3s4, destination) {
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            destination.e(item);
        }
        return destination;
    }
    function toMutableSet(_this__u8e3s4) {
        var tmp;
        if (isInterface(_this__u8e3s4, Collection)) tmp = LinkedHashSet_init_$Create$_0(_this__u8e3s4);
        else tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$());
        return tmp;
    }
    function toMutableList_0(_this__u8e3s4) {
        return ArrayList_init_$Create$_1(_this__u8e3s4);
    }
    function toMutableList_1(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, Collection)) return toMutableList_0(_this__u8e3s4);
        return toCollection_0(_this__u8e3s4, ArrayList_init_$Create$());
    }
    function sortedWith(_this__u8e3s4, comparator) {
        if (isInterface(_this__u8e3s4, Collection)) {
            if (_this__u8e3s4.m() <= 1) return toList_0(_this__u8e3s4);
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.collections.toTypedArray' call
            var tmp = copyToArray(_this__u8e3s4);
            var this_0 = isArray(tmp) ? tmp : THROW_CCE();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.sortedWith.<anonymous>' call
            sortWith(this_0, comparator);
            return asList(this_0);
        }
        // Inline function 'kotlin.apply' call
        var this_1 = toMutableList_1(_this__u8e3s4);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.sortedWith.<anonymous>' call
        sortWith_0(this_1, comparator);
        return this_1;
    }
    function single_0(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, KtList)) return single_1(_this__u8e3s4);
        else {
            var iterator = _this__u8e3s4.j();
            if (!iterator.k()) throw NoSuchElementException_init_$Create$_0("Collection is empty.");
            var single = iterator.l();
            if (iterator.k()) throw IllegalArgumentException_init_$Create$_0("Collection has more than one element.");
            return single;
        }
    }
    function minOrNull(_this__u8e3s4) {
        var iterator = _this__u8e3s4.j();
        if (!iterator.k()) return null;
        var min = iterator.l();
        while(iterator.k()){
            var e = iterator.l();
            if (compareTo(min, e) > 0) min = e;
        }
        return min;
    }
    function single_1(_this__u8e3s4) {
        var tmp;
        switch(_this__u8e3s4.m()){
            case 0:
                throw NoSuchElementException_init_$Create$_0("List is empty.");
            case 1:
                tmp = _this__u8e3s4.o(0);
                break;
            default:
                throw IllegalArgumentException_init_$Create$_0("List has more than one element.");
        }
        return tmp;
    }
    function drop(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.collections.drop.<anonymous>' call
            var message = "Requested element count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        if (n === 0) return toList_0(_this__u8e3s4);
        var list;
        if (isInterface(_this__u8e3s4, Collection)) {
            var resultSize = _this__u8e3s4.m() - n | 0;
            if (resultSize <= 0) return emptyList();
            if (resultSize === 1) return listOf(last_0(_this__u8e3s4));
            list = ArrayList_init_$Create$_0(resultSize);
            if (isInterface(_this__u8e3s4, KtList)) {
                if (isInterface(_this__u8e3s4, RandomAccess)) {
                    var inductionVariable = n;
                    var last = _this__u8e3s4.m();
                    if (inductionVariable < last) do {
                        var index = inductionVariable;
                        inductionVariable = inductionVariable + 1 | 0;
                        list.e(_this__u8e3s4.o(index));
                    }while (inductionVariable < last);
                } else {
                    // Inline function 'kotlin.collections.iterator' call
                    var tmp1_iterator = _this__u8e3s4.w(n);
                    while(tmp1_iterator.k()){
                        var item = tmp1_iterator.l();
                        list.e(item);
                    }
                }
                return list;
            }
        } else list = ArrayList_init_$Create$();
        var count = 0;
        var tmp2_iterator = _this__u8e3s4.j();
        while(tmp2_iterator.k()){
            var item_0 = tmp2_iterator.l();
            if (count >= n) list.e(item_0);
            else count = count + 1 | 0;
        }
        return optimizeReadOnlyList(list);
    }
    function dropLast(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.collections.dropLast.<anonymous>' call
            var message = "Requested element count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.m() - n | 0, 0));
    }
    function lastOrNull(_this__u8e3s4) {
        return _this__u8e3s4.s() ? null : _this__u8e3s4.o(_this__u8e3s4.m() - 1 | 0);
    }
    function random(_this__u8e3s4, random) {
        if (_this__u8e3s4.s()) throw NoSuchElementException_init_$Create$_0("Collection is empty.");
        return elementAt(_this__u8e3s4, random.x(_this__u8e3s4.m()));
    }
    function last_0(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, KtList)) return last(_this__u8e3s4);
        else {
            var iterator = _this__u8e3s4.j();
            if (!iterator.k()) throw NoSuchElementException_init_$Create$_0("Collection is empty.");
            var last_0 = iterator.l();
            while(iterator.k())last_0 = iterator.l();
            return last_0;
        }
    }
    function take(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.collections.take.<anonymous>' call
            var message = "Requested element count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        if (n === 0) return emptyList();
        if (isInterface(_this__u8e3s4, Collection)) {
            if (n >= _this__u8e3s4.m()) return toList_0(_this__u8e3s4);
            if (n === 1) return listOf(first(_this__u8e3s4));
        }
        var count = 0;
        var list = ArrayList_init_$Create$_0(n);
        var tmp0_iterator = _this__u8e3s4.j();
        $l$loop: while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            list.e(item);
            count = count + 1 | 0;
            if (count === n) break $l$loop;
        }
        return optimizeReadOnlyList(list);
    }
    function elementAt(_this__u8e3s4, index) {
        if (isInterface(_this__u8e3s4, KtList)) return _this__u8e3s4.o(index);
        return elementAtOrElse(_this__u8e3s4, index, elementAt$lambda(index));
    }
    function elementAtOrElse(_this__u8e3s4, index, defaultValue) {
        // Inline function 'kotlin.contracts.contract' call
        if (isInterface(_this__u8e3s4, KtList)) // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        return (0 <= index ? index < _this__u8e3s4.m() : false) ? _this__u8e3s4.o(index) : defaultValue(index);
        if (index < 0) return defaultValue(index);
        var iterator = _this__u8e3s4.j();
        var count = 0;
        while(iterator.k()){
            var element = iterator.l();
            var tmp0 = count;
            count = tmp0 + 1 | 0;
            if (index === tmp0) return element;
        }
        return defaultValue(index);
    }
    function filterNotNull(_this__u8e3s4) {
        return filterNotNullTo(_this__u8e3s4, ArrayList_init_$Create$());
    }
    function filterNotNullTo(_this__u8e3s4, destination) {
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            if (!(element == null)) destination.e(element);
        }
        return destination;
    }
    function _no_name_provided__qut3iv($this_asSequence) {
        this.y_1 = $this_asSequence;
    }
    protoOf(_no_name_provided__qut3iv).j = function() {
        // Inline function 'kotlin.collections.asSequence.<anonymous>' call
        return this.y_1.j();
    };
    function elementAt$lambda($index) {
        return function(it) {
            throw IndexOutOfBoundsException_init_$Create$_0("Collection doesn't contain element at index " + $index + ".");
        };
    }
    function toList_1(_this__u8e3s4) {
        if (_this__u8e3s4.m() === 0) return emptyList();
        var iterator = _this__u8e3s4.z().j();
        if (!iterator.k()) return emptyList();
        var first = iterator.l();
        if (!iterator.k()) {
            // Inline function 'kotlin.collections.toPair' call
            var tmp$ret$0 = new Pair(first.a1(), first.b1());
            return listOf(tmp$ret$0);
        }
        var result = ArrayList_init_$Create$_0(_this__u8e3s4.m());
        // Inline function 'kotlin.collections.toPair' call
        var tmp$ret$1 = new Pair(first.a1(), first.b1());
        result.e(tmp$ret$1);
        do {
            // Inline function 'kotlin.collections.toPair' call
            var this_0 = iterator.l();
            var tmp$ret$2 = new Pair(this_0.a1(), this_0.b1());
            result.e(tmp$ret$2);
        }while (iterator.k());
        return result;
    }
    function titlecaseImpl(_this__u8e3s4) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var uppercase = toString(_this__u8e3s4).toUpperCase();
        if (uppercase.length > 1) {
            var tmp;
            if (_this__u8e3s4 === _Char___init__impl__6a9atx(329)) tmp = uppercase;
            else {
                // Inline function 'kotlin.text.plus' call
                var this_0 = charSequenceGet(uppercase, 0);
                // Inline function 'kotlin.text.lowercase' call
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                var other = uppercase.substring(1).toLowerCase();
                tmp = toString(this_0) + other;
            }
            return tmp;
        }
        return toString(titlecaseChar(_this__u8e3s4));
    }
    function until(_this__u8e3s4, to) {
        if (to <= -2147483648) return Companion_getInstance_10().c1_1;
        return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
    }
    function step(_this__u8e3s4, step) {
        checkStepIsPositive(step > 0, step);
        return Companion_instance_12.g1(_this__u8e3s4.d1_1, _this__u8e3s4.e1_1, _this__u8e3s4.f1_1 > 0 ? step : -step | 0);
    }
    function coerceAtLeast(_this__u8e3s4, minimumValue) {
        return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
    }
    function downTo(_this__u8e3s4, to) {
        return Companion_instance_12.g1(_this__u8e3s4, to, -1);
    }
    function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
        if (minimumValue.j1(maximumValue) > 0) throw IllegalArgumentException_init_$Create$_0("Cannot coerce value to an empty range: maximum " + maximumValue.toString() + " is less than minimum " + minimumValue.toString() + ".");
        if (_this__u8e3s4.j1(minimumValue) < 0) return minimumValue;
        if (_this__u8e3s4.j1(maximumValue) > 0) return maximumValue;
        return _this__u8e3s4;
    }
    function coerceAtMost(_this__u8e3s4, maximumValue) {
        return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
    }
    function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
        if (minimumValue > maximumValue) throw IllegalArgumentException_init_$Create$_0("Cannot coerce value to an empty range: maximum " + maximumValue + " is less than minimum " + minimumValue + ".");
        if (_this__u8e3s4 < minimumValue) return minimumValue;
        if (_this__u8e3s4 > maximumValue) return maximumValue;
        return _this__u8e3s4;
    }
    function coerceAtMost_0(_this__u8e3s4, maximumValue) {
        return _this__u8e3s4.j1(maximumValue) > 0 ? maximumValue : _this__u8e3s4;
    }
    function contains_5(_this__u8e3s4, value) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.ranges.contains.<anonymous>' call
        var it = toIntExactOrNull(value);
        return !(it == null) ? _this__u8e3s4.k1(it) : false;
    }
    function toIntExactOrNull(_this__u8e3s4) {
        return (new Long(-2147483648, -1).j1(_this__u8e3s4) <= 0 ? _this__u8e3s4.j1(new Long(2147483647, 0)) <= 0 : false) ? _this__u8e3s4.l1() : null;
    }
    function toList_2(_this__u8e3s4) {
        var it = _this__u8e3s4.j();
        if (!it.k()) return emptyList();
        var element = it.l();
        if (!it.k()) return listOf(element);
        var dst = ArrayList_init_$Create$();
        dst.e(element);
        while(it.k())dst.e(it.l());
        return dst;
    }
    function map(_this__u8e3s4, transform) {
        return new TransformingSequence(_this__u8e3s4, transform);
    }
    function asIterable(_this__u8e3s4) {
        // Inline function 'kotlin.collections.Iterable' call
        return new _no_name_provided__qut3iv_0(_this__u8e3s4);
    }
    function toSet_1(_this__u8e3s4) {
        var it = _this__u8e3s4.j();
        if (!it.k()) return emptySet();
        var element = it.l();
        if (!it.k()) return setOf(element);
        var dst = LinkedHashSet_init_$Create$();
        dst.e(element);
        while(it.k())dst.e(it.l());
        return dst;
    }
    function _no_name_provided__qut3iv_0($this_asIterable) {
        this.n1_1 = $this_asIterable;
    }
    protoOf(_no_name_provided__qut3iv_0).j = function() {
        // Inline function 'kotlin.sequences.asIterable.<anonymous>' call
        return this.n1_1.j();
    };
    function plus_3(_this__u8e3s4, elements) {
        var tmp0_safe_receiver = collectionSizeOrNull(elements);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.plus.<anonymous>' call
        tmp = _this__u8e3s4.m() + tmp0_safe_receiver | 0;
        var tmp1_elvis_lhs = tmp;
        var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.m(), 2) : tmp1_elvis_lhs));
        result.n(_this__u8e3s4);
        addAll(result, elements);
        return result;
    }
    function last_1(_this__u8e3s4) {
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(_this__u8e3s4) === 0) throw NoSuchElementException_init_$Create$_0("Char sequence is empty.");
        return charSequenceGet(_this__u8e3s4, get_lastIndex_3(_this__u8e3s4));
    }
    function first_1(_this__u8e3s4) {
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(_this__u8e3s4) === 0) throw NoSuchElementException_init_$Create$_0("Char sequence is empty.");
        return charSequenceGet(_this__u8e3s4, 0);
    }
    function drop_0(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.text.drop.<anonymous>' call
            var message = "Requested character count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlin.text.substring' call
        var startIndex = coerceAtMost(n, _this__u8e3s4.length);
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.substring(startIndex);
    }
    function dropLast_0(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.text.dropLast.<anonymous>' call
            var message = "Requested character count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return take_0(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.length - n | 0, 0));
    }
    function take_0(_this__u8e3s4, n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'kotlin.text.take.<anonymous>' call
            var message = "Requested character count " + n + " is less than zero.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlin.text.substring' call
        var endIndex = coerceAtMost(n, _this__u8e3s4.length);
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.substring(0, endIndex);
    }
    function single_2(_this__u8e3s4) {
        var tmp;
        switch(charSequenceLength(_this__u8e3s4)){
            case 0:
                throw NoSuchElementException_init_$Create$_0("Char sequence is empty.");
            case 1:
                tmp = charSequenceGet(_this__u8e3s4, 0);
                break;
            default:
                throw IllegalArgumentException_init_$Create$_0("Char sequence has more than one element.");
        }
        return tmp;
    }
    function _Char___init__impl__6a9atx(value) {
        return value;
    }
    function _get_value__a43j40($this) {
        return $this;
    }
    function _Char___init__impl__6a9atx_0(code) {
        // Inline function 'kotlin.UShort.toInt' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
        return _Char___init__impl__6a9atx(tmp$ret$0);
    }
    function Char__compareTo_impl_ypi4mb($this, other) {
        return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
    }
    function Char__compareTo_impl_ypi4mb_0($this, other) {
        return Char__compareTo_impl_ypi4mb($this.o1_1, other instanceof Char ? other.o1_1 : THROW_CCE());
    }
    function Char__plus_impl_qi7pgj($this, other) {
        return numberToChar(_get_value__a43j40($this) + other | 0);
    }
    function Char__minus_impl_a2frrh($this, other) {
        return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
    }
    function Char__minus_impl_a2frrh_0($this, other) {
        return numberToChar(_get_value__a43j40($this) - other | 0);
    }
    function Char__rangeTo_impl_tkncvp($this, other) {
        return new CharRange($this, other);
    }
    function Char__toInt_impl_vasixd($this) {
        return _get_value__a43j40($this);
    }
    function toString($this) {
        // Inline function 'kotlin.js.unsafeCast' call
        return String.fromCharCode(_get_value__a43j40($this));
    }
    function Char__equals_impl_x6719k($this, other) {
        if (!(other instanceof Char)) return false;
        return _get_value__a43j40($this) === _get_value__a43j40(other.o1_1);
    }
    function Char__hashCode_impl_otmys($this) {
        return _get_value__a43j40($this);
    }
    function Companion() {
        Companion_instance = this;
        this.p1_1 = _Char___init__impl__6a9atx(0);
        this.q1_1 = _Char___init__impl__6a9atx(65535);
        this.r1_1 = _Char___init__impl__6a9atx(55296);
        this.s1_1 = _Char___init__impl__6a9atx(56319);
        this.t1_1 = _Char___init__impl__6a9atx(56320);
        this.u1_1 = _Char___init__impl__6a9atx(57343);
        this.v1_1 = _Char___init__impl__6a9atx(55296);
        this.w1_1 = _Char___init__impl__6a9atx(57343);
        this.x1_1 = 2;
        this.y1_1 = 16;
    }
    var Companion_instance;
    function Companion_getInstance() {
        if (Companion_instance == null) new Companion();
        return Companion_instance;
    }
    function Char(value) {
        Companion_getInstance();
        this.o1_1 = value;
    }
    protoOf(Char).z1 = function(other) {
        return Char__compareTo_impl_ypi4mb(this.o1_1, other);
    };
    protoOf(Char).d = function(other) {
        return Char__compareTo_impl_ypi4mb_0(this, other);
    };
    protoOf(Char).toString = function() {
        return toString(this.o1_1);
    };
    protoOf(Char).equals = function(other) {
        return Char__equals_impl_x6719k(this.o1_1, other);
    };
    protoOf(Char).hashCode = function() {
        return Char__hashCode_impl_otmys(this.o1_1);
    };
    function KtList() {}
    function Iterable() {}
    function Collection() {}
    function KtSet() {}
    function Entry() {}
    function KtMap() {}
    function KtMutableList() {}
    function KtMutableSet() {}
    function KtMutableMap() {}
    function MutableIterable() {}
    function Companion_0() {}
    var Companion_instance_0;
    function Companion_getInstance_0() {
        return Companion_instance_0;
    }
    function Enum(name, ordinal) {
        this.p2_1 = name;
        this.q2_1 = ordinal;
    }
    protoOf(Enum).r2 = function() {
        return this.p2_1;
    };
    protoOf(Enum).s2 = function() {
        return this.q2_1;
    };
    protoOf(Enum).t2 = function(other) {
        return compareTo(this.q2_1, other.q2_1);
    };
    protoOf(Enum).d = function(other) {
        return this.t2(other instanceof Enum ? other : THROW_CCE());
    };
    protoOf(Enum).equals = function(other) {
        return this === other;
    };
    protoOf(Enum).hashCode = function() {
        return identityHashCode(this);
    };
    protoOf(Enum).toString = function() {
        return this.p2_1;
    };
    function arrayOf(elements) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return elements;
    }
    function toString_0(_this__u8e3s4) {
        var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
        return tmp1_elvis_lhs == null ? "null" : tmp1_elvis_lhs;
    }
    function plus_4(_this__u8e3s4, other) {
        var tmp3_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
        var tmp = tmp3_elvis_lhs == null ? "null" : tmp3_elvis_lhs;
        var tmp1_elvis_lhs = other == null ? null : toString_1(other);
        return tmp + (tmp1_elvis_lhs == null ? "null" : tmp1_elvis_lhs);
    }
    function Companion_1() {
        Companion_instance_1 = this;
        this.u2_1 = new Long(0, -2147483648);
        this.v2_1 = new Long(-1, 2147483647);
        this.w2_1 = 8;
        this.x2_1 = 64;
    }
    var Companion_instance_1;
    function Companion_getInstance_1() {
        if (Companion_instance_1 == null) new Companion_1();
        return Companion_instance_1;
    }
    function Long(low, high) {
        Companion_getInstance_1();
        Number_0.call(this);
        this.h1_1 = low;
        this.i1_1 = high;
    }
    protoOf(Long).j1 = function(other) {
        return compare(this, other);
    };
    protoOf(Long).d = function(other) {
        return this.j1(other instanceof Long ? other : THROW_CCE());
    };
    protoOf(Long).y2 = function(other) {
        return add(this, other);
    };
    protoOf(Long).z2 = function(other) {
        return subtract(this, other);
    };
    protoOf(Long).a3 = function(other) {
        return multiply(this, other);
    };
    protoOf(Long).b3 = function(other) {
        return divide(this, other);
    };
    protoOf(Long).c3 = function(other) {
        return modulo(this, other);
    };
    protoOf(Long).d3 = function() {
        return this.y2(new Long(1, 0));
    };
    protoOf(Long).e3 = function() {
        return this.z2(new Long(1, 0));
    };
    protoOf(Long).f3 = function() {
        return this.g3().y2(new Long(1, 0));
    };
    protoOf(Long).h3 = function(bitCount) {
        return shiftLeft(this, bitCount);
    };
    protoOf(Long).i3 = function(bitCount) {
        return shiftRight(this, bitCount);
    };
    protoOf(Long).j3 = function(bitCount) {
        return shiftRightUnsigned(this, bitCount);
    };
    protoOf(Long).k3 = function(other) {
        return new Long(this.h1_1 & other.h1_1, this.i1_1 & other.i1_1);
    };
    protoOf(Long).l3 = function(other) {
        return new Long(this.h1_1 | other.h1_1, this.i1_1 | other.i1_1);
    };
    protoOf(Long).m3 = function(other) {
        return new Long(this.h1_1 ^ other.h1_1, this.i1_1 ^ other.i1_1);
    };
    protoOf(Long).g3 = function() {
        return new Long(~this.h1_1, ~this.i1_1);
    };
    protoOf(Long).n3 = function() {
        return toByte(this.h1_1);
    };
    protoOf(Long).o3 = function() {
        return toShort(this.h1_1);
    };
    protoOf(Long).l1 = function() {
        return this.h1_1;
    };
    protoOf(Long).p3 = function() {
        return toNumber(this);
    };
    protoOf(Long).toString = function() {
        return toStringImpl(this, 10);
    };
    protoOf(Long).equals = function(other) {
        var tmp;
        if (other instanceof Long) tmp = equalsLong(this, other);
        else tmp = false;
        return tmp;
    };
    protoOf(Long).hashCode = function() {
        return hashCode_0(this);
    };
    protoOf(Long).valueOf = function() {
        return this.p3();
    };
    function implement(interfaces) {
        var maxSize = 1;
        var masks = [];
        var inductionVariable = 0;
        var last = interfaces.length;
        while(inductionVariable < last){
            var i = interfaces[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var currentSize = maxSize;
            var tmp1_elvis_lhs = i.prototype.$imask$;
            var imask = tmp1_elvis_lhs == null ? i.$imask$ : tmp1_elvis_lhs;
            if (!(imask == null)) {
                masks.push(imask);
                currentSize = imask.length;
            }
            var iid = i.$metadata$.iid;
            var tmp;
            if (iid == null) tmp = null;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.js.implement.<anonymous>' call
            tmp = bitMaskWith(iid);
            var iidImask = tmp;
            if (!(iidImask == null)) {
                masks.push(iidImask);
                currentSize = Math.max(currentSize, iidImask.length);
            }
            if (currentSize > maxSize) maxSize = currentSize;
        }
        return compositeBitMask(maxSize, masks);
    }
    function bitMaskWith(activeBit) {
        var numberIndex = activeBit >> 5;
        var intArray = new Int32Array(numberIndex + 1 | 0);
        var positionInNumber = activeBit & 31;
        var numberWithSettledBit = 1 << positionInNumber;
        intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
        return intArray;
    }
    function compositeBitMask(capacity, masks) {
        var tmp = 0;
        var tmp_0 = new Int32Array(capacity);
        while(tmp < capacity){
            var tmp_1 = tmp;
            var result = 0;
            var inductionVariable = 0;
            var last = masks.length;
            while(inductionVariable < last){
                var mask = masks[inductionVariable];
                inductionVariable = inductionVariable + 1 | 0;
                if (tmp_1 < mask.length) result = result | mask[tmp_1];
            }
            tmp_0[tmp_1] = result;
            tmp = tmp + 1 | 0;
        }
        return tmp_0;
    }
    function isBitSet(_this__u8e3s4, possibleActiveBit) {
        var numberIndex = possibleActiveBit >> 5;
        if (numberIndex > _this__u8e3s4.length) return false;
        var positionInNumber = possibleActiveBit & 31;
        var numberWithSettledBit = 1 << positionInNumber;
        return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
    }
    function fillArrayVal(array, initValue) {
        var inductionVariable = 0;
        var last = array.length - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            array[i] = initValue;
        }while (!(i === last));
        return array;
    }
    function arrayIterator(array) {
        return new arrayIterator$1(array);
    }
    function booleanArray(size) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'withType' call
        var type = "BooleanArray";
        var array = fillArrayVal(Array(size), false);
        array.$type$ = type;
        return array;
    }
    function charArray(size) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'withType' call
        var type = "CharArray";
        var array = new Uint16Array(size);
        array.$type$ = type;
        return array;
    }
    function longArray(size) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'withType' call
        var type = "LongArray";
        var array = fillArrayVal(Array(size), new Long(0, 0));
        array.$type$ = type;
        return array;
    }
    function charArrayOf(arr) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'withType' call
        var type = "CharArray";
        var array = new Uint16Array(arr);
        array.$type$ = type;
        return array;
    }
    function arrayIterator$1($array) {
        this.r3_1 = $array;
        this.q3_1 = 0;
    }
    protoOf(arrayIterator$1).k = function() {
        return !(this.q3_1 === this.r3_1.length);
    };
    protoOf(arrayIterator$1).l = function() {
        var tmp;
        if (!(this.q3_1 === this.r3_1.length)) {
            var tmp1 = this.q3_1;
            this.q3_1 = tmp1 + 1 | 0;
            tmp = this.r3_1[tmp1];
        } else throw NoSuchElementException_init_$Create$_0("" + this.q3_1);
        return tmp;
    };
    function get_buf() {
        _init_properties_bitUtils_kt__nfcg4k();
        return buf;
    }
    var buf;
    function get_bufFloat64() {
        _init_properties_bitUtils_kt__nfcg4k();
        return bufFloat64;
    }
    var bufFloat64;
    var bufFloat32;
    function get_bufInt32() {
        _init_properties_bitUtils_kt__nfcg4k();
        return bufInt32;
    }
    var bufInt32;
    function get_lowIndex() {
        _init_properties_bitUtils_kt__nfcg4k();
        return lowIndex;
    }
    var lowIndex;
    function get_highIndex() {
        _init_properties_bitUtils_kt__nfcg4k();
        return highIndex;
    }
    var highIndex;
    function getNumberHashCode(obj) {
        _init_properties_bitUtils_kt__nfcg4k();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.jsBitwiseOr' call
        // Inline function 'kotlin.js.asDynamic' call
        if ((obj | 0) === obj) return numberToInt(obj);
        get_bufFloat64()[0] = obj;
        return imul(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
    }
    var properties_initialized_bitUtils_kt_i2bo3e;
    function _init_properties_bitUtils_kt__nfcg4k() {
        if (!properties_initialized_bitUtils_kt_i2bo3e) {
            properties_initialized_bitUtils_kt_i2bo3e = true;
            buf = new ArrayBuffer(8);
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            bufFloat64 = new Float64Array(get_buf());
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            bufFloat32 = new Float32Array(get_buf());
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            bufInt32 = new Int32Array(get_buf());
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.js.lowIndex.<anonymous>' call
            get_bufFloat64()[0] = -1;
            lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
            highIndex = 1 - get_lowIndex() | 0;
        }
    }
    function charSequenceGet(a, index) {
        var tmp;
        if (isString(a)) {
            // Inline function 'kotlin.Char' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var code = a.charCodeAt(index);
            var tmp_0;
            // Inline function 'kotlin.code' call
            var this_0 = _Char___init__impl__6a9atx(0);
            if (code < Char__toInt_impl_vasixd(this_0)) tmp_0 = true;
            else {
                // Inline function 'kotlin.code' call
                var this_1 = _Char___init__impl__6a9atx(65535);
                tmp_0 = code > Char__toInt_impl_vasixd(this_1);
            }
            if (tmp_0) throw IllegalArgumentException_init_$Create$_0("Invalid Char code: " + code);
            tmp = numberToChar(code);
        } else tmp = a.b(index);
        return tmp;
    }
    function isString(a) {
        return typeof a === "string";
    }
    function charSequenceLength(a) {
        var tmp;
        if (isString(a)) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = a.length;
        else tmp = a.a();
        return tmp;
    }
    function charSequenceSubSequence(a, startIndex, endIndex) {
        var tmp;
        if (isString(a)) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = a.substring(startIndex, endIndex);
        else tmp = a.c(startIndex, endIndex);
        return tmp;
    }
    function arrayToString(array) {
        return joinToString(array, ", ", "[", "]", VOID, VOID, arrayToString$lambda);
    }
    function contentEqualsInternal(_this__u8e3s4, other) {
        // Inline function 'kotlin.js.asDynamic' call
        var a = _this__u8e3s4;
        // Inline function 'kotlin.js.asDynamic' call
        var b = other;
        if (a === b) return true;
        if (a == null || b == null || !isArrayish(b) || a.length != b.length) return false;
        var inductionVariable = 0;
        var last = a.length;
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals(a[i], b[i])) return false;
        }while (inductionVariable < last);
        return true;
    }
    function contentHashCodeInternal(_this__u8e3s4) {
        // Inline function 'kotlin.js.asDynamic' call
        var a = _this__u8e3s4;
        if (a == null) return 0;
        var result = 1;
        var inductionVariable = 0;
        var last = a.length;
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            result = imul(result, 31) + hashCode(a[i]) | 0;
        }while (inductionVariable < last);
        return result;
    }
    function arrayToString$lambda(it) {
        return toString_1(it);
    }
    function compareTo(a, b) {
        var tmp;
        switch(typeof a){
            case "number":
                var tmp_0;
                if (typeof b === "number") tmp_0 = doubleCompareTo(a, b);
                else if (b instanceof Long) tmp_0 = doubleCompareTo(a, b.p3());
                else tmp_0 = primitiveCompareTo(a, b);
                tmp = tmp_0;
                break;
            case "string":
            case "boolean":
                tmp = primitiveCompareTo(a, b);
                break;
            default:
                tmp = compareToDoNotIntrinsicify(a, b);
                break;
        }
        return tmp;
    }
    function doubleCompareTo(a, b) {
        var tmp;
        if (a < b) tmp = -1;
        else if (a > b) tmp = 1;
        else if (a === b) {
            var tmp_0;
            if (a !== 0) tmp_0 = 0;
            else {
                // Inline function 'kotlin.js.asDynamic' call
                var ia = 1 / a;
                var tmp_1;
                // Inline function 'kotlin.js.asDynamic' call
                if (ia === 1 / b) tmp_1 = 0;
                else if (ia < 0) tmp_1 = -1;
                else tmp_1 = 1;
                tmp_0 = tmp_1;
            }
            tmp = tmp_0;
        } else if (a !== a) tmp = b !== b ? 0 : 1;
        else tmp = -1;
        return tmp;
    }
    function primitiveCompareTo(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }
    function compareToDoNotIntrinsicify(a, b) {
        return a.d(b);
    }
    function identityHashCode(obj) {
        return getObjectHashCode(obj);
    }
    function getObjectHashCode(obj) {
        // Inline function 'kotlin.js.jsIn' call
        if (!("kotlinHashCodeValue$" in obj)) {
            var hash = calculateRandomHash();
            var descriptor = new Object();
            descriptor.value = hash;
            descriptor.enumerable = false;
            Object.defineProperty(obj, "kotlinHashCodeValue$", descriptor);
        }
        // Inline function 'kotlin.js.unsafeCast' call
        return obj["kotlinHashCodeValue$"];
    }
    function calculateRandomHash() {
        // Inline function 'kotlin.js.jsBitwiseOr' call
        return Math.random() * 4.294967296E9 | 0;
    }
    function objectCreate(proto) {
        proto = proto === VOID ? null : proto;
        return Object.create(proto);
    }
    function defineProp(obj, name, getter, setter) {
        return Object.defineProperty(obj, name, {
            configurable: true,
            get: getter,
            set: setter
        });
    }
    function toString_1(o) {
        var tmp;
        if (o == null) tmp = "null";
        else if (isArrayish(o)) tmp = "[...]";
        else if (!(typeof o.toString === "function")) tmp = anyToString(o);
        else // Inline function 'kotlin.js.unsafeCast' call
        tmp = o.toString();
        return tmp;
    }
    function equals(obj1, obj2) {
        if (obj1 == null) return obj2 == null;
        if (obj2 == null) return false;
        if (typeof obj1 === "object" && typeof obj1.equals === "function") return obj1.equals(obj2);
        if (obj1 !== obj1) return obj2 !== obj2;
        if (typeof obj1 === "number" && typeof obj2 === "number") {
            var tmp;
            if (obj1 === obj2) {
                var tmp_0;
                if (obj1 !== 0) tmp_0 = true;
                else {
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp_1 = 1 / obj1;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp_0 = tmp_1 === 1 / obj2;
                }
                tmp = tmp_0;
            } else tmp = false;
            return tmp;
        }
        return obj1 === obj2;
    }
    function hashCode(obj) {
        if (obj == null) return 0;
        var typeOf = typeof obj;
        var tmp;
        switch(typeOf){
            case "object":
                tmp = "function" === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
                break;
            case "function":
                tmp = getObjectHashCode(obj);
                break;
            case "number":
                tmp = getNumberHashCode(obj);
                break;
            case "boolean":
                // Inline function 'kotlin.js.unsafeCast' call
                tmp = getBooleanHashCode(obj);
                break;
            case "string":
                tmp = getStringHashCode(String(obj));
                break;
            case "bigint":
                tmp = getBigIntHashCode(obj);
                break;
            case "symbol":
                tmp = getSymbolHashCode(obj);
                break;
            default:
                tmp = function() {
                    throw new Error("Unexpected typeof `" + typeOf + "`");
                }();
                break;
        }
        return tmp;
    }
    function anyToString(o) {
        return Object.prototype.toString.call(o);
    }
    function getBooleanHashCode(value) {
        return value ? 1231 : 1237;
    }
    function getStringHashCode(str) {
        var hash = 0;
        var length = str.length;
        var inductionVariable = 0;
        var last = length - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            var code = str.charCodeAt(i);
            hash = imul(hash, 31) + code | 0;
        }while (!(i === last));
        return hash;
    }
    function getBigIntHashCode(value) {
        var shiftNumber = BigInt(32);
        var MASK = BigInt(4.294967295E9);
        var bigNumber = value < 0 ? -value : value;
        var hashCode = 0;
        var signum = value < 0 ? -1 : 1;
        while(bigNumber != 0){
            // Inline function 'kotlin.js.unsafeCast' call
            var chunk = Number(bigNumber & MASK);
            hashCode = imul(31, hashCode) + chunk | 0;
            bigNumber = bigNumber >> shiftNumber;
        }
        return imul(hashCode, signum);
    }
    function getSymbolHashCode(value) {
        var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
        var cachedHashCode = hashCodeMap.get(value);
        if (cachedHashCode !== VOID) return cachedHashCode;
        var hash = calculateRandomHash();
        hashCodeMap.set(value, hash);
        return hash;
    }
    function symbolIsSharable(symbol) {
        return Symbol.keyFor(symbol) != VOID;
    }
    function getSymbolMap() {
        if (symbolMap === VOID) symbolMap = new Map();
        return symbolMap;
    }
    function getSymbolWeakMap() {
        if (symbolWeakMap === VOID) symbolWeakMap = new WeakMap();
        return symbolWeakMap;
    }
    var symbolMap;
    var symbolWeakMap;
    function boxIntrinsic(x) {
        var message = "Should be lowered";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    function unboxIntrinsic(x) {
        var message = "Should be lowered";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    function captureStack(instance, constructorFunction) {
        if (Error.captureStackTrace != null) Error.captureStackTrace(instance, constructorFunction);
        else // Inline function 'kotlin.js.asDynamic' call
        instance.stack = new Error().stack;
    }
    function protoOf(constructor) {
        return constructor.prototype;
    }
    function extendThrowable(this_, message, cause) {
        Error.call(this_);
        setPropertiesToThrowableInstance(this_, message, cause);
    }
    function setPropertiesToThrowableInstance(this_, message, cause) {
        var errorInfo = calculateErrorInfo(Object.getPrototypeOf(this_));
        if ((errorInfo & 1) === 0) {
            var tmp;
            if (message == null) {
                var tmp_0;
                if (!(message === null)) {
                    var tmp1_elvis_lhs = cause == null ? null : cause.toString();
                    tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
                } else tmp_0 = VOID;
                tmp = tmp_0;
            } else tmp = message;
            this_.message = tmp;
        }
        if ((errorInfo & 2) === 0) this_.cause = cause;
        this_.name = Object.getPrototypeOf(this_).constructor.name;
    }
    function returnIfSuspended(argument, $completion) {
        return (argument == null ? true : !(argument == null)) ? argument : THROW_CCE();
    }
    function ensureNotNull(v) {
        var tmp;
        if (v == null) THROW_NPE();
        else tmp = v;
        return tmp;
    }
    function THROW_NPE() {
        throw NullPointerException_init_$Create$();
    }
    function noWhenBranchMatchedException() {
        throw NoWhenBranchMatchedException_init_$Create$();
    }
    function THROW_CCE() {
        throw ClassCastException_init_$Create$();
    }
    function throwUninitializedPropertyAccessException(name) {
        throw UninitializedPropertyAccessException_init_$Create$_0("lateinit property " + name + " has not been initialized");
    }
    function THROW_IAE(msg) {
        throw IllegalArgumentException_init_$Create$_0(msg);
    }
    function get_ZERO() {
        _init_properties_longJs_kt__elc2w5();
        return ZERO;
    }
    var ZERO;
    function get_ONE() {
        _init_properties_longJs_kt__elc2w5();
        return ONE;
    }
    var ONE;
    function get_NEG_ONE() {
        _init_properties_longJs_kt__elc2w5();
        return NEG_ONE;
    }
    var NEG_ONE;
    function get_MAX_VALUE() {
        _init_properties_longJs_kt__elc2w5();
        return MAX_VALUE;
    }
    var MAX_VALUE;
    function get_MIN_VALUE() {
        _init_properties_longJs_kt__elc2w5();
        return MIN_VALUE;
    }
    var MIN_VALUE;
    function get_TWO_PWR_24_() {
        _init_properties_longJs_kt__elc2w5();
        return TWO_PWR_24_;
    }
    var TWO_PWR_24_;
    function compare(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        if (equalsLong(_this__u8e3s4, other)) return 0;
        var thisNeg = isNegative(_this__u8e3s4);
        var otherNeg = isNegative(other);
        return thisNeg && !otherNeg ? -1 : !thisNeg && otherNeg ? 1 : isNegative(subtract(_this__u8e3s4, other)) ? -1 : 1;
    }
    function add(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        var a48 = _this__u8e3s4.i1_1 >>> 16 | 0;
        var a32 = _this__u8e3s4.i1_1 & 65535;
        var a16 = _this__u8e3s4.h1_1 >>> 16 | 0;
        var a00 = _this__u8e3s4.h1_1 & 65535;
        var b48 = other.i1_1 >>> 16 | 0;
        var b32 = other.i1_1 & 65535;
        var b16 = other.h1_1 >>> 16 | 0;
        var b00 = other.h1_1 & 65535;
        var c48 = 0;
        var c32 = 0;
        var c16 = 0;
        var c00 = 0;
        c00 = c00 + (a00 + b00 | 0) | 0;
        c16 = c16 + (c00 >>> 16 | 0) | 0;
        c00 = c00 & 65535;
        c16 = c16 + (a16 + b16 | 0) | 0;
        c32 = c32 + (c16 >>> 16 | 0) | 0;
        c16 = c16 & 65535;
        c32 = c32 + (a32 + b32 | 0) | 0;
        c48 = c48 + (c32 >>> 16 | 0) | 0;
        c32 = c32 & 65535;
        c48 = c48 + (a48 + b48 | 0) | 0;
        c48 = c48 & 65535;
        return new Long(c16 << 16 | c00, c48 << 16 | c32);
    }
    function subtract(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return add(_this__u8e3s4, other.f3());
    }
    function multiply(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        if (isZero(_this__u8e3s4)) return get_ZERO();
        else if (isZero(other)) return get_ZERO();
        if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
        else if (equalsLong(other, get_MIN_VALUE())) return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
        if (isNegative(_this__u8e3s4)) {
            var tmp;
            if (isNegative(other)) tmp = multiply(negate(_this__u8e3s4), negate(other));
            else tmp = negate(multiply(negate(_this__u8e3s4), other));
            return tmp;
        } else if (isNegative(other)) return negate(multiply(_this__u8e3s4, negate(other)));
        if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) && lessThan(other, get_TWO_PWR_24_())) return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
        var a48 = _this__u8e3s4.i1_1 >>> 16 | 0;
        var a32 = _this__u8e3s4.i1_1 & 65535;
        var a16 = _this__u8e3s4.h1_1 >>> 16 | 0;
        var a00 = _this__u8e3s4.h1_1 & 65535;
        var b48 = other.i1_1 >>> 16 | 0;
        var b32 = other.i1_1 & 65535;
        var b16 = other.h1_1 >>> 16 | 0;
        var b00 = other.h1_1 & 65535;
        var c48 = 0;
        var c32 = 0;
        var c16 = 0;
        var c00 = 0;
        c00 = c00 + imul(a00, b00) | 0;
        c16 = c16 + (c00 >>> 16 | 0) | 0;
        c00 = c00 & 65535;
        c16 = c16 + imul(a16, b00) | 0;
        c32 = c32 + (c16 >>> 16 | 0) | 0;
        c16 = c16 & 65535;
        c16 = c16 + imul(a00, b16) | 0;
        c32 = c32 + (c16 >>> 16 | 0) | 0;
        c16 = c16 & 65535;
        c32 = c32 + imul(a32, b00) | 0;
        c48 = c48 + (c32 >>> 16 | 0) | 0;
        c32 = c32 & 65535;
        c32 = c32 + imul(a16, b16) | 0;
        c48 = c48 + (c32 >>> 16 | 0) | 0;
        c32 = c32 & 65535;
        c32 = c32 + imul(a00, b32) | 0;
        c48 = c48 + (c32 >>> 16 | 0) | 0;
        c32 = c32 & 65535;
        c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
        c48 = c48 & 65535;
        return new Long(c16 << 16 | c00, c48 << 16 | c32);
    }
    function divide(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        if (isZero(other)) throw Exception_init_$Create$_0("division by zero");
        else if (isZero(_this__u8e3s4)) return get_ZERO();
        if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
            if (equalsLong(other, get_ONE()) || equalsLong(other, get_NEG_ONE())) return get_MIN_VALUE();
            else if (equalsLong(other, get_MIN_VALUE())) return get_ONE();
            else {
                var halfThis = shiftRight(_this__u8e3s4, 1);
                var approx = shiftLeft(halfThis.b3(other), 1);
                if (equalsLong(approx, get_ZERO())) return isNegative(other) ? get_ONE() : get_NEG_ONE();
                else {
                    var rem = subtract(_this__u8e3s4, multiply(other, approx));
                    return add(approx, rem.b3(other));
                }
            }
        } else if (equalsLong(other, get_MIN_VALUE())) return get_ZERO();
        if (isNegative(_this__u8e3s4)) {
            var tmp;
            if (isNegative(other)) tmp = negate(_this__u8e3s4).b3(negate(other));
            else tmp = negate(negate(_this__u8e3s4).b3(other));
            return tmp;
        } else if (isNegative(other)) return negate(_this__u8e3s4.b3(negate(other)));
        var res = get_ZERO();
        var rem_0 = _this__u8e3s4;
        while(greaterThanOrEqual(rem_0, other)){
            var approxDouble = toNumber(rem_0) / toNumber(other);
            var approx2 = Math.max(1.0, Math.floor(approxDouble));
            var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
            var delta = log2 <= 48 ? 1.0 : Math.pow(2.0, log2 - 48);
            var approxRes = fromNumber(approx2);
            var approxRem = multiply(approxRes, other);
            while(isNegative(approxRem) || greaterThan(approxRem, rem_0)){
                approx2 = approx2 - delta;
                approxRes = fromNumber(approx2);
                approxRem = multiply(approxRes, other);
            }
            if (isZero(approxRes)) approxRes = get_ONE();
            res = add(res, approxRes);
            rem_0 = subtract(rem_0, approxRem);
        }
        return res;
    }
    function modulo(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return subtract(_this__u8e3s4, multiply(_this__u8e3s4.b3(other), other));
    }
    function shiftLeft(_this__u8e3s4, numBits) {
        _init_properties_longJs_kt__elc2w5();
        var numBits_0 = numBits & 63;
        if (numBits_0 === 0) return _this__u8e3s4;
        else {
            if (numBits_0 < 32) return new Long(_this__u8e3s4.h1_1 << numBits_0, _this__u8e3s4.i1_1 << numBits_0 | (_this__u8e3s4.h1_1 >>> (32 - numBits_0 | 0) | 0));
            else return new Long(0, _this__u8e3s4.h1_1 << (numBits_0 - 32 | 0));
        }
    }
    function shiftRight(_this__u8e3s4, numBits) {
        _init_properties_longJs_kt__elc2w5();
        var numBits_0 = numBits & 63;
        if (numBits_0 === 0) return _this__u8e3s4;
        else {
            if (numBits_0 < 32) return new Long(_this__u8e3s4.h1_1 >>> numBits_0 | 0 | _this__u8e3s4.i1_1 << (32 - numBits_0 | 0), _this__u8e3s4.i1_1 >> numBits_0);
            else return new Long(_this__u8e3s4.i1_1 >> (numBits_0 - 32 | 0), _this__u8e3s4.i1_1 >= 0 ? 0 : -1);
        }
    }
    function shiftRightUnsigned(_this__u8e3s4, numBits) {
        _init_properties_longJs_kt__elc2w5();
        var numBits_0 = numBits & 63;
        if (numBits_0 === 0) return _this__u8e3s4;
        else {
            if (numBits_0 < 32) return new Long(_this__u8e3s4.h1_1 >>> numBits_0 | 0 | _this__u8e3s4.i1_1 << (32 - numBits_0 | 0), _this__u8e3s4.i1_1 >>> numBits_0 | 0);
            else {
                var tmp;
                if (numBits_0 === 32) tmp = new Long(_this__u8e3s4.i1_1, 0);
                else tmp = new Long(_this__u8e3s4.i1_1 >>> (numBits_0 - 32 | 0) | 0, 0);
                return tmp;
            }
        }
    }
    function toNumber(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.i1_1 * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
    }
    function toStringImpl(_this__u8e3s4, radix) {
        _init_properties_longJs_kt__elc2w5();
        if (radix < 2 || 36 < radix) throw Exception_init_$Create$_0("radix out of range: " + radix);
        if (isZero(_this__u8e3s4)) return "0";
        if (isNegative(_this__u8e3s4)) {
            if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
                var radixLong = fromInt(radix);
                var div = _this__u8e3s4.b3(radixLong);
                var rem = subtract(multiply(div, radixLong), _this__u8e3s4).l1();
                var tmp = toStringImpl(div, radix);
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                return tmp + rem.toString(radix);
            } else return "-" + toStringImpl(negate(_this__u8e3s4), radix);
        }
        var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
        var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
        var rem_0 = _this__u8e3s4;
        var result = "";
        while(true){
            var remDiv = rem_0.b3(radixToPower);
            var intval = subtract(rem_0, multiply(remDiv, radixToPower)).l1();
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var digits = intval.toString(radix);
            rem_0 = remDiv;
            if (isZero(rem_0)) return digits + result;
            else {
                while(digits.length < digitsPerTime)digits = "0" + digits;
                result = digits + result;
            }
        }
    }
    function equalsLong(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.i1_1 === other.i1_1 && _this__u8e3s4.h1_1 === other.h1_1;
    }
    function hashCode_0(l) {
        _init_properties_longJs_kt__elc2w5();
        return l.h1_1 ^ l.i1_1;
    }
    function fromInt(value) {
        _init_properties_longJs_kt__elc2w5();
        return new Long(value, value < 0 ? -1 : 0);
    }
    function isNegative(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.i1_1 < 0;
    }
    function isZero(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.i1_1 === 0 && _this__u8e3s4.h1_1 === 0;
    }
    function isOdd(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return (_this__u8e3s4.h1_1 & 1) === 1;
    }
    function negate(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.f3();
    }
    function lessThan(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return compare(_this__u8e3s4, other) < 0;
    }
    function fromNumber(value) {
        _init_properties_longJs_kt__elc2w5();
        if (isNaN_0(value)) return get_ZERO();
        else if (value <= -9223372036854776000) return get_MIN_VALUE();
        else if (value + 1 >= 9.223372036854776E18) return get_MAX_VALUE();
        else if (value < 0) return negate(fromNumber(-value));
        else {
            var twoPwr32 = 4.294967296E9;
            // Inline function 'kotlin.js.jsBitwiseOr' call
            var tmp = value % twoPwr32 | 0;
            // Inline function 'kotlin.js.jsBitwiseOr' call
            var tmp$ret$1 = value / twoPwr32 | 0;
            return new Long(tmp, tmp$ret$1);
        }
    }
    function greaterThan(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return compare(_this__u8e3s4, other) > 0;
    }
    function greaterThanOrEqual(_this__u8e3s4, other) {
        _init_properties_longJs_kt__elc2w5();
        return compare(_this__u8e3s4, other) >= 0;
    }
    function getLowBitsUnsigned(_this__u8e3s4) {
        _init_properties_longJs_kt__elc2w5();
        return _this__u8e3s4.h1_1 >= 0 ? _this__u8e3s4.h1_1 : 4.294967296E9 + _this__u8e3s4.h1_1;
    }
    var properties_initialized_longJs_kt_4syf89;
    function _init_properties_longJs_kt__elc2w5() {
        if (!properties_initialized_longJs_kt_4syf89) {
            properties_initialized_longJs_kt_4syf89 = true;
            ZERO = fromInt(0);
            ONE = fromInt(1);
            NEG_ONE = fromInt(-1);
            MAX_VALUE = new Long(-1, 2147483647);
            MIN_VALUE = new Long(0, -2147483648);
            TWO_PWR_24_ = fromInt(16777216);
        }
    }
    function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
        var undef = VOID;
        var iid = kind === "interface" ? generateInterfaceId() : VOID;
        return {
            kind: kind,
            simpleName: name,
            associatedObjectKey: associatedObjectKey,
            associatedObjects: associatedObjects,
            suspendArity: suspendArity,
            $kClass$: undef,
            defaultConstructor: defaultConstructor,
            iid: iid
        };
    }
    function generateInterfaceId() {
        if (globalInterfaceId === VOID) globalInterfaceId = 0;
        // Inline function 'kotlin.js.unsafeCast' call
        globalInterfaceId = globalInterfaceId + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        return globalInterfaceId;
    }
    var globalInterfaceId;
    function initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
        if (!(parent == null)) {
            ctor.prototype = Object.create(parent.prototype);
            ctor.prototype.constructor = ctor;
        }
        var metadata = createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
        ctor.$metadata$ = metadata;
        if (!(interfaces == null)) {
            var receiver = !equals(metadata.iid, VOID) ? ctor : ctor.prototype;
            receiver.$imask$ = implement(interfaces);
        }
    }
    function initMetadataForClass(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
        var kind = "class";
        initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
    }
    function initMetadataForObject(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
        var kind = "object";
        initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
    }
    function initMetadataForInterface(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
        var kind = "interface";
        initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
    }
    function initMetadataForLambda(ctor, parent, interfaces, suspendArity) {
        initMetadataForClass(ctor, "Lambda", VOID, parent, interfaces, suspendArity, VOID, VOID);
    }
    function initMetadataForCoroutine(ctor, parent, interfaces, suspendArity) {
        initMetadataForClass(ctor, "Coroutine", VOID, parent, interfaces, suspendArity, VOID, VOID);
    }
    function initMetadataForFunctionReference(ctor, parent, interfaces, suspendArity) {
        initMetadataForClass(ctor, "FunctionReference", VOID, parent, interfaces, suspendArity, VOID, VOID);
    }
    function initMetadataForCompanion(ctor, parent, interfaces, suspendArity) {
        initMetadataForObject(ctor, "Companion", VOID, parent, interfaces, suspendArity, VOID, VOID);
    }
    function classMeta(name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
        return createMetadata("class", name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
    }
    function toByte(a) {
        // Inline function 'kotlin.js.unsafeCast' call
        return a << 24 >> 24;
    }
    function numberToInt(a) {
        var tmp;
        if (a instanceof Long) tmp = a.l1();
        else tmp = doubleToInt(a);
        return tmp;
    }
    function doubleToInt(a) {
        var tmp;
        if (a > 2147483647) tmp = 2147483647;
        else if (a < -2147483648) tmp = -2147483648;
        else // Inline function 'kotlin.js.jsBitwiseOr' call
        tmp = a | 0;
        return tmp;
    }
    function toShort(a) {
        // Inline function 'kotlin.js.unsafeCast' call
        return a << 16 >> 16;
    }
    function numberToLong(a) {
        var tmp;
        if (a instanceof Long) tmp = a;
        else tmp = fromNumber(a);
        return tmp;
    }
    function numberToChar(a) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = numberToInt(a);
        var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
        return _Char___init__impl__6a9atx_0(tmp$ret$0);
    }
    function toLong(a) {
        return fromInt(a);
    }
    function ByteCompanionObject() {
        this.MIN_VALUE = -128;
        this.MAX_VALUE = 127;
        this.SIZE_BYTES = 1;
        this.SIZE_BITS = 8;
    }
    protoOf(ByteCompanionObject).s3 = function() {
        return this.MIN_VALUE;
    };
    protoOf(ByteCompanionObject).t3 = function() {
        return this.MAX_VALUE;
    };
    protoOf(ByteCompanionObject).u3 = function() {
        return this.SIZE_BYTES;
    };
    protoOf(ByteCompanionObject).v3 = function() {
        return this.SIZE_BITS;
    };
    var ByteCompanionObject_instance;
    function ByteCompanionObject_getInstance() {
        return ByteCompanionObject_instance;
    }
    function ShortCompanionObject() {
        this.MIN_VALUE = -32768;
        this.MAX_VALUE = 32767;
        this.SIZE_BYTES = 2;
        this.SIZE_BITS = 16;
    }
    protoOf(ShortCompanionObject).s3 = function() {
        return this.MIN_VALUE;
    };
    protoOf(ShortCompanionObject).t3 = function() {
        return this.MAX_VALUE;
    };
    protoOf(ShortCompanionObject).u3 = function() {
        return this.SIZE_BYTES;
    };
    protoOf(ShortCompanionObject).v3 = function() {
        return this.SIZE_BITS;
    };
    var ShortCompanionObject_instance;
    function ShortCompanionObject_getInstance() {
        return ShortCompanionObject_instance;
    }
    function IntCompanionObject() {
        this.MIN_VALUE = -2147483648;
        this.MAX_VALUE = 2147483647;
        this.SIZE_BYTES = 4;
        this.SIZE_BITS = 32;
    }
    protoOf(IntCompanionObject).s3 = function() {
        return this.MIN_VALUE;
    };
    protoOf(IntCompanionObject).t3 = function() {
        return this.MAX_VALUE;
    };
    protoOf(IntCompanionObject).u3 = function() {
        return this.SIZE_BYTES;
    };
    protoOf(IntCompanionObject).v3 = function() {
        return this.SIZE_BITS;
    };
    var IntCompanionObject_instance;
    function IntCompanionObject_getInstance() {
        return IntCompanionObject_instance;
    }
    function FloatCompanionObject() {
        this.MIN_VALUE = 1.4E-45;
        this.MAX_VALUE = 3.4028235E38;
        this.POSITIVE_INFINITY = Infinity;
        this.NEGATIVE_INFINITY = -Infinity;
        this.NaN = NaN;
        this.SIZE_BYTES = 4;
        this.SIZE_BITS = 32;
    }
    protoOf(FloatCompanionObject).s3 = function() {
        return this.MIN_VALUE;
    };
    protoOf(FloatCompanionObject).t3 = function() {
        return this.MAX_VALUE;
    };
    protoOf(FloatCompanionObject).w3 = function() {
        return this.POSITIVE_INFINITY;
    };
    protoOf(FloatCompanionObject).x3 = function() {
        return this.NEGATIVE_INFINITY;
    };
    protoOf(FloatCompanionObject).y3 = function() {
        return this.NaN;
    };
    protoOf(FloatCompanionObject).u3 = function() {
        return this.SIZE_BYTES;
    };
    protoOf(FloatCompanionObject).v3 = function() {
        return this.SIZE_BITS;
    };
    var FloatCompanionObject_instance;
    function FloatCompanionObject_getInstance() {
        return FloatCompanionObject_instance;
    }
    function DoubleCompanionObject() {
        this.MIN_VALUE = 4.9E-324;
        this.MAX_VALUE = 1.7976931348623157E308;
        this.POSITIVE_INFINITY = Infinity;
        this.NEGATIVE_INFINITY = -Infinity;
        this.NaN = NaN;
        this.SIZE_BYTES = 8;
        this.SIZE_BITS = 64;
    }
    protoOf(DoubleCompanionObject).s3 = function() {
        return this.MIN_VALUE;
    };
    protoOf(DoubleCompanionObject).t3 = function() {
        return this.MAX_VALUE;
    };
    protoOf(DoubleCompanionObject).w3 = function() {
        return this.POSITIVE_INFINITY;
    };
    protoOf(DoubleCompanionObject).x3 = function() {
        return this.NEGATIVE_INFINITY;
    };
    protoOf(DoubleCompanionObject).y3 = function() {
        return this.NaN;
    };
    protoOf(DoubleCompanionObject).u3 = function() {
        return this.SIZE_BYTES;
    };
    protoOf(DoubleCompanionObject).v3 = function() {
        return this.SIZE_BITS;
    };
    var DoubleCompanionObject_instance;
    function DoubleCompanionObject_getInstance() {
        return DoubleCompanionObject_instance;
    }
    function StringCompanionObject() {}
    var StringCompanionObject_instance;
    function StringCompanionObject_getInstance() {
        return StringCompanionObject_instance;
    }
    function BooleanCompanionObject() {}
    var BooleanCompanionObject_instance;
    function BooleanCompanionObject_getInstance() {
        return BooleanCompanionObject_instance;
    }
    function numberRangeToNumber(start, endInclusive) {
        return new IntRange(start, endInclusive);
    }
    function get_propertyRefClassMetadataCache() {
        _init_properties_reflectRuntime_kt__5r4uu3();
        return propertyRefClassMetadataCache;
    }
    var propertyRefClassMetadataCache;
    function metadataObject() {
        _init_properties_reflectRuntime_kt__5r4uu3();
        return classMeta(VOID, VOID, VOID, VOID, VOID);
    }
    function getPropertyCallableRef(name, paramCount, superType, getter, setter) {
        _init_properties_reflectRuntime_kt__5r4uu3();
        getter.get = getter;
        getter.set = setter;
        getter.callableName = name;
        // Inline function 'kotlin.js.unsafeCast' call
        return getPropertyRefClass(getter, getKPropMetadata(paramCount, setter), getInterfaceMaskFor(getter, superType));
    }
    function getPropertyRefClass(obj, metadata, imask) {
        _init_properties_reflectRuntime_kt__5r4uu3();
        obj.$metadata$ = metadata;
        obj.constructor = obj;
        obj.$imask$ = imask;
        return obj;
    }
    function getKPropMetadata(paramCount, setter) {
        _init_properties_reflectRuntime_kt__5r4uu3();
        return get_propertyRefClassMetadataCache()[paramCount][setter == null ? 0 : 1];
    }
    function getInterfaceMaskFor(obj, superType) {
        _init_properties_reflectRuntime_kt__5r4uu3();
        var tmp0_elvis_lhs = obj.$imask$;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$2 = [
                superType
            ];
            tmp = implement(tmp$ret$2);
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    var properties_initialized_reflectRuntime_kt_inkhwd;
    function _init_properties_reflectRuntime_kt__5r4uu3() {
        if (!properties_initialized_reflectRuntime_kt_inkhwd) {
            properties_initialized_reflectRuntime_kt_inkhwd = true;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp = [
                metadataObject(),
                metadataObject()
            ];
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_0 = [
                metadataObject(),
                metadataObject()
            ];
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            propertyRefClassMetadataCache = [
                tmp,
                tmp_0,
                [
                    metadataObject(),
                    metadataObject()
                ]
            ];
        }
    }
    function isArrayish(o) {
        return isJsArray(o) || isView(o);
    }
    function isJsArray(obj) {
        // Inline function 'kotlin.js.unsafeCast' call
        return Array.isArray(obj);
    }
    function isInterface(obj, iface) {
        return isInterfaceImpl(obj, iface.$metadata$.iid);
    }
    function isInterfaceImpl(obj, iface) {
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp0_elvis_lhs = obj.$imask$;
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var mask = tmp;
        return isBitSet(mask, iface);
    }
    function isArray(obj) {
        var tmp;
        if (isJsArray(obj)) // Inline function 'kotlin.js.asDynamic' call
        tmp = !obj.$type$;
        else tmp = false;
        return tmp;
    }
    function isSuspendFunction(obj, arity) {
        var objTypeOf = typeof obj;
        if (objTypeOf === "function") // Inline function 'kotlin.js.unsafeCast' call
        return obj.$arity === arity;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp1_safe_receiver = obj == null ? null : obj.constructor;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.$metadata$;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.suspendArity;
        var tmp;
        if (tmp3_elvis_lhs == null) return false;
        else tmp = tmp3_elvis_lhs;
        var suspendArity = tmp;
        var result = false;
        var inductionVariable = 0;
        var last = suspendArity.length;
        $l$loop: while(inductionVariable < last){
            var item = suspendArity[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            if (arity === item) {
                result = true;
                break $l$loop;
            }
        }
        return result;
    }
    function isNumber(a) {
        var tmp;
        if (typeof a === "number") tmp = true;
        else tmp = a instanceof Long;
        return tmp;
    }
    function isComparable(value) {
        var type = typeof value;
        return type === "string" || type === "boolean" || isNumber(value) || isInterface(value, Comparable);
    }
    function isCharSequence(value) {
        return typeof value === "string" || isInterface(value, CharSequence);
    }
    function isBooleanArray(a) {
        return isJsArray(a) && a.$type$ === "BooleanArray";
    }
    function isByteArray(a) {
        // Inline function 'kotlin.js.jsInstanceOf' call
        return a instanceof Int8Array;
    }
    function isShortArray(a) {
        // Inline function 'kotlin.js.jsInstanceOf' call
        return a instanceof Int16Array;
    }
    function isCharArray(a) {
        var tmp;
        // Inline function 'kotlin.js.jsInstanceOf' call
        if (a instanceof Uint16Array) tmp = a.$type$ === "CharArray";
        else tmp = false;
        return tmp;
    }
    function isIntArray(a) {
        // Inline function 'kotlin.js.jsInstanceOf' call
        return a instanceof Int32Array;
    }
    function isFloatArray(a) {
        // Inline function 'kotlin.js.jsInstanceOf' call
        return a instanceof Float32Array;
    }
    function isLongArray(a) {
        return isJsArray(a) && a.$type$ === "LongArray";
    }
    function isDoubleArray(a) {
        // Inline function 'kotlin.js.jsInstanceOf' call
        return a instanceof Float64Array;
    }
    function jsIsType(obj, jsClass) {
        if (jsClass === Object) return obj != null;
        var objType = typeof obj;
        var jsClassType = typeof jsClass;
        if (obj == null || jsClass == null || !(objType === "object") && !(objType === "function")) return false;
        var constructor = jsClassType === "object" ? jsGetPrototypeOf(jsClass) : jsClass;
        var klassMetadata = constructor.$metadata$;
        if ((klassMetadata == null ? null : klassMetadata.kind) === "interface") {
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp1_elvis_lhs = klassMetadata.iid;
            var tmp;
            if (tmp1_elvis_lhs == null) return false;
            else tmp = tmp1_elvis_lhs;
            var iid = tmp;
            return isInterfaceImpl(obj, iid);
        }
        // Inline function 'kotlin.js.jsInstanceOf' call
        return obj instanceof constructor;
    }
    function jsGetPrototypeOf(jsClass) {
        return Object.getPrototypeOf(jsClass);
    }
    function calculateErrorInfo(proto) {
        var tmp0_safe_receiver = proto.constructor;
        var metadata = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.$metadata$;
        var tmp2_safe_receiver = metadata == null ? null : metadata.errorInfo;
        if (tmp2_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp2_safe_receiver;
        var result = 0;
        if (hasProp(proto, "message")) result = result | 1;
        if (hasProp(proto, "cause")) result = result | 2;
        if (!(result === 3)) {
            var parentProto = getPrototypeOf(proto);
            if (parentProto != Error.prototype) result = result | calculateErrorInfo(parentProto);
        }
        if (!(metadata == null)) metadata.errorInfo = result;
        return result;
    }
    function hasProp(proto, propName) {
        return proto.hasOwnProperty(propName);
    }
    function getPrototypeOf(obj) {
        return Object.getPrototypeOf(obj);
    }
    function get_VOID() {
        _init_properties_void_kt__3zg9as();
        return VOID;
    }
    var VOID;
    var properties_initialized_void_kt_e4ret2;
    function _init_properties_void_kt__3zg9as() {
        if (!properties_initialized_void_kt_e4ret2) {
            properties_initialized_void_kt_e4ret2 = true;
            VOID = void 0;
        }
    }
    function fill(_this__u8e3s4, element, fromIndex, toIndex) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
        Companion_instance_5.a4(fromIndex, toIndex, _this__u8e3s4.length);
        // Inline function 'kotlin.js.nativeFill' call
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4.fill(element, fromIndex, toIndex);
    }
    function asList(_this__u8e3s4) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return new ArrayList(_this__u8e3s4);
    }
    function copyOf(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'withType' call
        var type = "CharArray";
        var array = fillFrom(_this__u8e3s4, charArray(newSize));
        array.$type$ = type;
        return array;
    }
    function copyOf_0(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return fillFrom(_this__u8e3s4, new Float64Array(newSize));
    }
    function copyOf_1(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return fillFrom(_this__u8e3s4, new Float32Array(newSize));
    }
    function copyOf_2(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'withType' call
        var type = "LongArray";
        var array = arrayCopyResize(_this__u8e3s4, newSize, new Long(0, 0));
        array.$type$ = type;
        return array;
    }
    function copyOf_3(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return fillFrom(_this__u8e3s4, new Int32Array(newSize));
    }
    function copyOf_4(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return fillFrom(_this__u8e3s4, new Int16Array(newSize));
    }
    function copyOf_5(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return fillFrom(_this__u8e3s4, new Int8Array(newSize));
    }
    function copyOf_6(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'withType' call
        var type = "BooleanArray";
        var array = arrayCopyResize(_this__u8e3s4, newSize, false);
        array.$type$ = type;
        return array;
    }
    function contentEquals(_this__u8e3s4, other) {
        return contentEqualsInternal(_this__u8e3s4, other);
    }
    function contentHashCode(_this__u8e3s4) {
        return contentHashCodeInternal(_this__u8e3s4);
    }
    function sortWith(_this__u8e3s4, comparator) {
        if (_this__u8e3s4.length > 1) sortArrayWith(_this__u8e3s4, comparator);
    }
    function fill_0(_this__u8e3s4, element, fromIndex, toIndex) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
        Companion_instance_5.a4(fromIndex, toIndex, _this__u8e3s4.length);
        // Inline function 'kotlin.js.nativeFill' call
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4.fill(element, fromIndex, toIndex);
    }
    function copyOf_7(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newSize >= 0)) {
            // Inline function 'kotlin.collections.copyOf.<anonymous>' call
            var message = "Invalid new array size: " + newSize + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return arrayCopyResize(_this__u8e3s4, newSize, null);
    }
    function contentToString(_this__u8e3s4) {
        var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : joinToString(_this__u8e3s4, ", ", "[", "]");
        return tmp1_elvis_lhs == null ? "null" : tmp1_elvis_lhs;
    }
    function toTypedArray(_this__u8e3s4) {
        return [].slice.call(_this__u8e3s4);
    }
    function decodeVarLenBase64(base64, fromBase64, resultLength) {
        var result = new Int32Array(resultLength);
        var index = 0;
        var int = 0;
        var shift = 0;
        var inductionVariable = 0;
        var last = base64.length;
        while(inductionVariable < last){
            var char = charSequenceGet(base64, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var sixBit = fromBase64[Char__toInt_impl_vasixd(char)];
            int = int | (sixBit & 31) << shift;
            if (sixBit < 32) {
                var tmp1 = index;
                index = tmp1 + 1 | 0;
                result[tmp1] = int;
                int = 0;
                shift = 0;
            } else shift = shift + 5 | 0;
        }
        return result;
    }
    function reverse(_this__u8e3s4) {
        var midPoint = (_this__u8e3s4.m() / 2 | 0) - 1 | 0;
        if (midPoint < 0) return Unit_instance;
        var reverseIndex = get_lastIndex_2(_this__u8e3s4);
        var inductionVariable = 0;
        if (inductionVariable <= midPoint) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = _this__u8e3s4.o(index);
            _this__u8e3s4.j2(index, _this__u8e3s4.o(reverseIndex));
            _this__u8e3s4.j2(reverseIndex, tmp);
            reverseIndex = reverseIndex - 1 | 0;
        }while (!(index === midPoint));
    }
    function digitToIntImpl(_this__u8e3s4) {
        // Inline function 'kotlin.code' call
        var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
        var index = binarySearchRange(Digit_getInstance().b4_1, ch);
        var diff = ch - Digit_getInstance().b4_1[index] | 0;
        return diff < 10 ? diff : -1;
    }
    function binarySearchRange(array, needle) {
        var bottom = 0;
        var top = array.length - 1 | 0;
        var middle = -1;
        var value = 0;
        while(bottom <= top){
            middle = (bottom + top | 0) / 2 | 0;
            value = array[middle];
            if (needle > value) bottom = middle + 1 | 0;
            else if (needle === value) return middle;
            else top = middle - 1 | 0;
        }
        return middle - (needle < value ? 1 : 0) | 0;
    }
    function Digit() {
        Digit_instance = this;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.b4_1 = new Int32Array([
            48,
            1632,
            1776,
            1984,
            2406,
            2534,
            2662,
            2790,
            2918,
            3046,
            3174,
            3302,
            3430,
            3558,
            3664,
            3792,
            3872,
            4160,
            4240,
            6112,
            6160,
            6470,
            6608,
            6784,
            6800,
            6992,
            7088,
            7232,
            7248,
            42528,
            43216,
            43264,
            43472,
            43504,
            43600,
            44016,
            65296
        ]);
    }
    var Digit_instance;
    function Digit_getInstance() {
        if (Digit_instance == null) new Digit();
        return Digit_instance;
    }
    function getLetterType(_this__u8e3s4) {
        // Inline function 'kotlin.code' call
        var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
        var index = binarySearchRange(Letter_getInstance().c4_1, ch);
        var rangeStart = Letter_getInstance().c4_1[index];
        var rangeEnd = (rangeStart + Letter_getInstance().d4_1[index] | 0) - 1 | 0;
        var code = Letter_getInstance().e4_1[index];
        if (ch > rangeEnd) return 0;
        var lastTwoBits = code & 3;
        if (lastTwoBits === 0) {
            var shift = 2;
            var threshold = rangeStart;
            var inductionVariable = 0;
            if (inductionVariable <= 1) do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                threshold = threshold + (code >> shift & 127) | 0;
                if (threshold > ch) return 3;
                shift = shift + 7 | 0;
                threshold = threshold + (code >> shift & 127) | 0;
                if (threshold > ch) return 0;
                shift = shift + 7 | 0;
            }while (inductionVariable <= 1);
            return 3;
        }
        if (code <= 7) return lastTwoBits;
        var distance = ch - rangeStart | 0;
        var shift_0 = code <= 31 ? distance % 2 | 0 : distance;
        return code >> imul(2, shift_0) & 3;
    }
    function Letter() {
        Letter_instance = this;
        var toBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var fromBase64 = new Int32Array(128);
        var inductionVariable = 0;
        var last = charSequenceLength(toBase64) - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_0 = charSequenceGet(toBase64, i);
            fromBase64[Char__toInt_impl_vasixd(this_0)] = i;
        }while (inductionVariable <= last);
        var rangeStartDiff = "hCgBpCQGYHZH5BRpBPPPPPPRMP5BPPlCPP6BkEPPPPcPXPzBvBrB3BOiDoBHwD+E3DauCnFmBmB2D6E1BlBTiBmBlBP5BhBiBrBvBjBqBnBPRtBiCmCtBlB0BmB5BiB7BmBgEmChBZgCoEoGVpBSfRhBPqKQ2BwBYoFgB4CJuTiEvBuCuDrF5DgEgFlJ1DgFmBQtBsBRGsB+BPiBlD1EIjDPRPPPQPPPPPGQSQS/DxENVNU+B9zCwBwBPPCkDPNnBPqDYY1R8B7FkFgTgwGgwUwmBgKwBuBScmEP/BPPPPPPrBP8B7F1B/ErBqC6B7BiBmBfQsBUwCw/KwqIwLwETPcPjQgJxFgBlBsD";
        var diff = decodeVarLenBase64(rangeStartDiff, fromBase64, 222);
        var start = new Int32Array(diff.length);
        var inductionVariable_0 = 0;
        var last_0 = diff.length - 1 | 0;
        if (inductionVariable_0 <= last_0) do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (i_0 === 0) start[i_0] = diff[i_0];
            else start[i_0] = start[i_0 - 1 | 0] + diff[i_0] | 0;
        }while (inductionVariable_0 <= last_0);
        this.c4_1 = start;
        var rangeLength = "aaMBXHYH5BRpBPPPPPPRMP5BPPlCPPzBDOOPPcPXPzBvBjB3BOhDmBBpB7DoDYxB+EiBP1DoExBkBQhBekBPmBgBhBctBiBMWOOXhCsBpBkBUV3Ba4BkB0DlCgBXgBtD4FSdBfPhBPpKP0BvBXjEQ2CGsT8DhBtCqDpFvD1D3E0IrD2EkBJrBDOBsB+BPiBlB1EIjDPPPPPPPPPPPGPPMNLsBNPNPKCvBvBPPCkDPBmBPhDXXgD4B6FzEgDguG9vUtkB9JcuBSckEP/BPPPPPPBPf4FrBjEhBpC3B5BKaWPrBOwCk/KsCuLqDHPbPxPsFtEaaqDL";
        this.d4_1 = decodeVarLenBase64(rangeLength, fromBase64, 222);
        var rangeCategory = "GFjgggUHGGFFZZZmzpz5qB6s6020B60ptltB6smt2sB60mz22B1+vv+8BZZ5s2850BW5q1ymtB506smzBF3q1q1qB1q1q1+Bgii4wDTm74g3KiggxqM60q1q1Bq1o1q1BF1qlrqrBZ2q5wprBGFZWWZGHFsjiooLowgmOowjkwCkgoiIk7ligGogiioBkwkiYkzj2oNoi+sbkwj04DghhkQ8wgiYkgoioDsgnkwC4gikQ//v+85BkwvoIsgoyI4yguI0whiwEowri4CoghsJowgqYowgm4DkwgsY/nwnzPowhmYkg6wI8yggZswikwHgxgmIoxgqYkwgk4DkxgmIkgoioBsgssoBgzgyI8g9gL8g9kI0wgwJoxgkoC0wgioFkw/wI0w53iF4gioYowjmgBHGq1qkgwBF1q1q8qBHwghuIwghyKk0goQkwgoQk3goQHGFHkyg0pBgxj6IoinkxDswno7Ikwhz9Bo0gioB8z48Rwli0xN0mpjoX8w78pDwltoqKHFGGwwgsIHFH3q1q16BFHWFZ1q10q1B2qlwq1B1q10q1B2q1yq1B6q1gq1Biq1qhxBir1qp1Bqt1q1qB1g1q1+B//3q16B///q1qBH/qlqq9Bholqq9B1i00a1q10qD1op1HkwmigEigiy6Cptogq1Bixo1kDq7/j00B2qgoBWGFm1lz50B6s5q1+BGWhggzhwBFFhgk4//Bo2jigE8wguI8wguI8wgugUog1qoB4qjmIwwi2KgkYHHH4lBgiFWkgIWoghssMmz5smrBZ3q1y50B5sm7gzBtz1smzB5smz50BqzqtmzB5sgzqzBF2/9//5BowgoIwmnkzPkwgk4C8ys65BkgoqI0wgy6FghquZo2giY0ghiIsgh24B4ghsQ8QF/v1q1OFs0O8iCHHF1qggz/B8wg6Iznv+//B08QgohsjK0QGFk7hsQ4gB";
        this.e4_1 = decodeVarLenBase64(rangeCategory, fromBase64, 222);
    }
    var Letter_instance;
    function Letter_getInstance() {
        if (Letter_instance == null) new Letter();
        return Letter_instance;
    }
    function isLowerCaseImpl(_this__u8e3s4) {
        var tmp;
        if (getLetterType(_this__u8e3s4) === 1) tmp = true;
        else {
            // Inline function 'kotlin.code' call
            var tmp$ret$0 = Char__toInt_impl_vasixd(_this__u8e3s4);
            tmp = isOtherLowercase(tmp$ret$0);
        }
        return tmp;
    }
    function isOtherLowercase(_this__u8e3s4) {
        var index = binarySearchRange(OtherLowercase_getInstance().f4_1, _this__u8e3s4);
        return index >= 0 && _this__u8e3s4 < (OtherLowercase_getInstance().f4_1[index] + OtherLowercase_getInstance().g4_1[index] | 0);
    }
    function OtherLowercase() {
        OtherLowercase_instance = this;
        var tmp = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp.f4_1 = new Int32Array([
            170,
            186,
            688,
            704,
            736,
            837,
            890,
            7468,
            7544,
            7579,
            8305,
            8319,
            8336,
            8560,
            9424,
            11388,
            42652,
            42864,
            43000,
            43868
        ]);
        var tmp_0 = this;
        // Inline function 'kotlin.intArrayOf' call
        tmp_0.g4_1 = new Int32Array([
            1,
            1,
            9,
            2,
            5,
            1,
            1,
            63,
            1,
            37,
            1,
            1,
            13,
            16,
            26,
            2,
            2,
            1,
            2,
            4
        ]);
    }
    var OtherLowercase_instance;
    function OtherLowercase_getInstance() {
        if (OtherLowercase_instance == null) new OtherLowercase();
        return OtherLowercase_instance;
    }
    function titlecaseCharImpl(_this__u8e3s4) {
        // Inline function 'kotlin.code' call
        var code = Char__toInt_impl_vasixd(_this__u8e3s4);
        if ((452 <= code ? code <= 460 : false) || (497 <= code ? code <= 499 : false)) return numberToChar(imul(3, (code + 1 | 0) / 3 | 0));
        if ((4304 <= code ? code <= 4346 : false) || (4349 <= code ? code <= 4351 : false)) return _this__u8e3s4;
        return uppercaseChar(_this__u8e3s4);
    }
    function isWhitespaceImpl(_this__u8e3s4) {
        // Inline function 'kotlin.code' call
        var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
        return (9 <= ch ? ch <= 13 : false) || (28 <= ch ? ch <= 32 : false) || ch === 160 || ch > 4096 && (ch === 5760 || (8192 <= ch ? ch <= 8202 : false) || ch === 8232 || ch === 8233 || ch === 8239 || ch === 8287 || ch === 12288);
    }
    function isNaN_0(_this__u8e3s4) {
        return !(_this__u8e3s4 === _this__u8e3s4);
    }
    function isInfinite(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4 === Infinity) tmp = true;
        else tmp = _this__u8e3s4 === -Infinity;
        return tmp;
    }
    function isFinite(_this__u8e3s4) {
        return !isInfinite(_this__u8e3s4) && !isNaN_0(_this__u8e3s4);
    }
    function takeHighestOneBit(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4 === 0) tmp = 0;
        else // Inline function 'kotlin.countLeadingZeroBits' call
        tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
        return tmp;
    }
    function isFinite_0(_this__u8e3s4) {
        return !isInfinite_0(_this__u8e3s4) && !isNaN_1(_this__u8e3s4);
    }
    function isInfinite_0(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4 === Infinity) tmp = true;
        else tmp = _this__u8e3s4 === -Infinity;
        return tmp;
    }
    function isNaN_1(_this__u8e3s4) {
        return !(_this__u8e3s4 === _this__u8e3s4);
    }
    function countTrailingZeroBits(_this__u8e3s4) {
        var low = _this__u8e3s4.h1_1;
        return low === 0 ? 32 + countTrailingZeroBits_0(_this__u8e3s4.i1_1) | 0 : countTrailingZeroBits_0(low);
    }
    function countTrailingZeroBits_0(_this__u8e3s4) {
        // Inline function 'kotlin.countLeadingZeroBits' call
        var this_0 = ~(_this__u8e3s4 | (-_this__u8e3s4 | 0));
        return 32 - clz32(this_0) | 0;
    }
    function uintCompare(v1, v2) {
        return compareTo(v1 ^ -2147483648, v2 ^ -2147483648);
    }
    function uintDivide(v1, v2) {
        // Inline function 'kotlin.toUInt' call
        // Inline function 'kotlin.UInt.toLong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(v1);
        var tmp = toLong(value).k3(new Long(-1, 0));
        // Inline function 'kotlin.UInt.toLong' call
        // Inline function 'kotlin.uintToLong' call
        var value_0 = _UInt___get_data__impl__f0vqqw(v2);
        var tmp$ret$3 = toLong(value_0).k3(new Long(-1, 0));
        var this_0 = tmp.b3(tmp$ret$3);
        return _UInt___init__impl__l7qpdl(this_0.l1());
    }
    function ulongCompare(v1, v2) {
        return v1.m3(new Long(0, -2147483648)).j1(v2.m3(new Long(0, -2147483648)));
    }
    function ulongDivide(v1, v2) {
        // Inline function 'kotlin.ULong.toLong' call
        var dividend = _ULong___get_data__impl__fggpzb(v1);
        // Inline function 'kotlin.ULong.toLong' call
        var divisor = _ULong___get_data__impl__fggpzb(v2);
        if (divisor.j1(new Long(0, 0)) < 0) {
            var tmp;
            // Inline function 'kotlin.ULong.compareTo' call
            if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) tmp = _ULong___init__impl__c78o9k(new Long(0, 0));
            else tmp = _ULong___init__impl__c78o9k(new Long(1, 0));
            return tmp;
        }
        if (dividend.j1(new Long(0, 0)) >= 0) return _ULong___init__impl__c78o9k(dividend.b3(divisor));
        var quotient = dividend.j3(1).b3(divisor).h3(1);
        var rem = dividend.z2(quotient.a3(divisor));
        // Inline function 'kotlin.Long.plus' call
        var tmp_0;
        // Inline function 'kotlin.ULong.compareTo' call
        var this_0 = _ULong___init__impl__c78o9k(rem);
        var other = _ULong___init__impl__c78o9k(divisor);
        if (ulongCompare(_ULong___get_data__impl__fggpzb(this_0), _ULong___get_data__impl__fggpzb(other)) >= 0) tmp_0 = 1;
        else tmp_0 = 0;
        var other_0 = tmp_0;
        var tmp$ret$4 = quotient.y2(toLong(other_0));
        return _ULong___init__impl__c78o9k(tmp$ret$4);
    }
    function ulongToString(value, base) {
        if (value.j1(new Long(0, 0)) >= 0) return toString_3(value, base);
        // Inline function 'kotlin.Long.div' call
        var quotient = value.j3(1).b3(toLong(base)).h3(1);
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$1 = quotient.a3(toLong(base));
        var rem = value.z2(tmp$ret$1);
        if (rem.j1(toLong(base)) >= 0) {
            // Inline function 'kotlin.Long.minus' call
            rem = rem.z2(toLong(base));
            // Inline function 'kotlin.Long.plus' call
            quotient = quotient.y2(toLong(1));
        }
        return toString_3(quotient, base) + toString_3(rem, base);
    }
    function collectionToArray(collection) {
        return collectionToArrayCommonImpl(collection);
    }
    function terminateCollectionToArray(collectionSize, array) {
        return array;
    }
    function arrayOfNulls(reference, size) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOfNulls' call
        // Inline function 'kotlin.js.asDynamic' call
        return fillArrayVal(Array(size), null);
    }
    function listOf(element) {
        return arrayListOf([
            element
        ]);
    }
    function mapOf(pair) {
        return hashMapOf([
            pair
        ]);
    }
    function setOf(element) {
        return hashSetOf([
            element
        ]);
    }
    function mapCapacity(expectedSize) {
        return expectedSize;
    }
    function checkIndexOverflow(index) {
        if (index < 0) throwIndexOverflow();
        return index;
    }
    function sortWith_0(_this__u8e3s4, comparator) {
        collectionsSort(_this__u8e3s4, comparator);
    }
    function copyToArray(collection) {
        var tmp;
        // Inline function 'kotlin.js.asDynamic' call
        if (collection.toArray !== undefined) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = collection.toArray();
        else // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = collectionToArray(collection);
        return tmp;
    }
    function collectionsSort(list, comparator) {
        if (list.m() <= 1) return Unit_instance;
        var array = copyToArray(list);
        sortArrayWith(array, comparator);
        var inductionVariable = 0;
        var last = array.length;
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            list.j2(i, array[i]);
        }while (inductionVariable < last);
    }
    function arrayCopy(source, destination, destinationOffset, startIndex, endIndex) {
        Companion_instance_5.a4(startIndex, endIndex, source.length);
        var rangeSize = endIndex - startIndex | 0;
        Companion_instance_5.a4(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
        if (isView(destination) && isView(source)) {
            // Inline function 'kotlin.js.asDynamic' call
            var subrange = source.subarray(startIndex, endIndex);
            // Inline function 'kotlin.js.asDynamic' call
            destination.set(subrange, destinationOffset);
        } else if (!(source === destination) || destinationOffset <= startIndex) {
            var inductionVariable = 0;
            if (inductionVariable < rangeSize) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                destination[destinationOffset + index | 0] = source[startIndex + index | 0];
            }while (inductionVariable < rangeSize);
        } else {
            var inductionVariable_0 = rangeSize - 1 | 0;
            if (0 <= inductionVariable_0) do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + -1 | 0;
                destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
            }while (0 <= inductionVariable_0);
        }
    }
    function AbstractMutableCollection$retainAll$lambda($elements) {
        return function(it) {
            return !$elements.a2(it);
        };
    }
    function AbstractMutableCollection() {
        AbstractCollection.call(this);
    }
    protoOf(AbstractMutableCollection).n = function(elements) {
        this.h4();
        var modified = false;
        var tmp0_iterator = elements.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            if (this.e(element)) modified = true;
        }
        return modified;
    };
    protoOf(AbstractMutableCollection).h2 = function(elements) {
        this.h4();
        var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
        return removeAll_0(tmp, AbstractMutableCollection$retainAll$lambda(elements));
    };
    protoOf(AbstractMutableCollection).i2 = function() {
        this.h4();
        var iterator = this.j();
        while(iterator.k()){
            iterator.l();
            iterator.i4();
        }
    };
    protoOf(AbstractMutableCollection).toJSON = function() {
        return this.toArray();
    };
    protoOf(AbstractMutableCollection).h4 = function() {};
    function IteratorImpl($outer) {
        this.l4_1 = $outer;
        this.j4_1 = 0;
        this.k4_1 = -1;
    }
    protoOf(IteratorImpl).k = function() {
        return this.j4_1 < this.l4_1.m();
    };
    protoOf(IteratorImpl).l = function() {
        if (!this.k()) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j4_1;
        this.j4_1 = tmp1 + 1 | 0;
        tmp.k4_1 = tmp1;
        return this.l4_1.o(this.k4_1);
    };
    protoOf(IteratorImpl).i4 = function() {
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(this.k4_1 === -1)) {
            // Inline function 'kotlin.collections.IteratorImpl.remove.<anonymous>' call
            var message = "Call next() or previous() before removing element from the iterator.";
            throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        this.l4_1.l2(this.k4_1);
        this.j4_1 = this.k4_1;
        this.k4_1 = -1;
    };
    function ListIteratorImpl($outer, index) {
        this.q4_1 = $outer;
        IteratorImpl.call(this, $outer);
        Companion_instance_5.r4(index, this.q4_1.m());
        this.j4_1 = index;
    }
    protoOf(ListIteratorImpl).s4 = function() {
        return this.j4_1 > 0;
    };
    protoOf(ListIteratorImpl).t4 = function() {
        return this.j4_1;
    };
    protoOf(ListIteratorImpl).u4 = function() {
        if (!this.s4()) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        this.j4_1 = this.j4_1 - 1 | 0;
        tmp.k4_1 = this.j4_1;
        return this.q4_1.o(this.k4_1);
    };
    function SubList(list, fromIndex, toIndex) {
        AbstractMutableList.call(this);
        this.w4_1 = list;
        this.x4_1 = fromIndex;
        this.y4_1 = 0;
        Companion_instance_5.a4(this.x4_1, toIndex, this.w4_1.m());
        this.y4_1 = toIndex - this.x4_1 | 0;
    }
    protoOf(SubList).k2 = function(index, element) {
        Companion_instance_5.r4(index, this.y4_1);
        this.w4_1.k2(this.x4_1 + index | 0, element);
        this.y4_1 = this.y4_1 + 1 | 0;
    };
    protoOf(SubList).o = function(index) {
        Companion_instance_5.z4(index, this.y4_1);
        return this.w4_1.o(this.x4_1 + index | 0);
    };
    protoOf(SubList).l2 = function(index) {
        Companion_instance_5.z4(index, this.y4_1);
        var result = this.w4_1.l2(this.x4_1 + index | 0);
        this.y4_1 = this.y4_1 - 1 | 0;
        return result;
    };
    protoOf(SubList).j2 = function(index, element) {
        Companion_instance_5.z4(index, this.y4_1);
        return this.w4_1.j2(this.x4_1 + index | 0, element);
    };
    protoOf(SubList).a5 = function(fromIndex, toIndex) {
        this.w4_1.a5(this.x4_1 + fromIndex | 0, this.x4_1 + toIndex | 0);
        this.y4_1 = this.y4_1 - (toIndex - fromIndex | 0) | 0;
    };
    protoOf(SubList).m = function() {
        return this.y4_1;
    };
    protoOf(SubList).h4 = function() {
        return this.w4_1.h4();
    };
    function AbstractMutableList$retainAll$lambda($elements) {
        return function(it) {
            return !$elements.a2(it);
        };
    }
    function AbstractMutableList() {
        AbstractMutableCollection.call(this);
        this.m4_1 = 0;
    }
    protoOf(AbstractMutableList).e = function(element) {
        this.h4();
        this.k2(this.m(), element);
        return true;
    };
    protoOf(AbstractMutableList).i2 = function() {
        this.h4();
        this.a5(0, this.m());
    };
    protoOf(AbstractMutableList).h2 = function(elements) {
        this.h4();
        return removeAll(this, AbstractMutableList$retainAll$lambda(elements));
    };
    protoOf(AbstractMutableList).j = function() {
        return new IteratorImpl(this);
    };
    protoOf(AbstractMutableList).a2 = function(element) {
        return this.b5(element) >= 0;
    };
    protoOf(AbstractMutableList).b5 = function(element) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.indexOfFirst' call
            var index = 0;
            var tmp0_iterator = this.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractMutableList.indexOf.<anonymous>' call
                if (equals(item, element)) {
                    tmp$ret$1 = index;
                    break $l$block;
                }
                index = index + 1 | 0;
            }
            tmp$ret$1 = -1;
        }
        return tmp$ret$1;
    };
    protoOf(AbstractMutableList).w = function(index) {
        return new ListIteratorImpl(this, index);
    };
    protoOf(AbstractMutableList).v = function(fromIndex, toIndex) {
        return new SubList(this, fromIndex, toIndex);
    };
    protoOf(AbstractMutableList).a5 = function(fromIndex, toIndex) {
        var iterator = this.w(fromIndex);
        // Inline function 'kotlin.repeat' call
        var times = toIndex - fromIndex | 0;
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < times) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.AbstractMutableList.removeRange.<anonymous>' call
            iterator.l();
            iterator.i4();
        }while (inductionVariable < times);
    };
    protoOf(AbstractMutableList).equals = function(other) {
        if (other === this) return true;
        if (!(!(other == null) ? isInterface(other, KtList) : false)) return false;
        return Companion_instance_5.c5(this, other);
    };
    protoOf(AbstractMutableList).hashCode = function() {
        return Companion_instance_5.d5(this);
    };
    function AbstractMutableMap() {
        AbstractMap.call(this);
        this.g5_1 = null;
        this.h5_1 = null;
    }
    protoOf(AbstractMutableMap).i5 = function() {
        return new HashMapKeysDefault(this);
    };
    protoOf(AbstractMutableMap).j5 = function() {
        return new HashMapValuesDefault(this);
    };
    protoOf(AbstractMutableMap).f2 = function() {
        var tmp0_elvis_lhs = this.g5_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = this.i5();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.AbstractMutableMap.<get-keys>.<anonymous>' call
            this.g5_1 = this_0;
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(AbstractMutableMap).g2 = function() {
        var tmp0_elvis_lhs = this.h5_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = this.j5();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.AbstractMutableMap.<get-values>.<anonymous>' call
            this.h5_1 = this_0;
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(AbstractMutableMap).i2 = function() {
        this.z().i2();
    };
    protoOf(AbstractMutableMap).o2 = function(from) {
        this.h4();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = from.z().j();
        while(tmp0_iterator.k()){
            var tmp1_loop_parameter = tmp0_iterator.l();
            // Inline function 'kotlin.collections.component1' call
            var key = tmp1_loop_parameter.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = tmp1_loop_parameter.b1();
            this.m2(key, value);
        }
    };
    protoOf(AbstractMutableMap).n2 = function(key) {
        this.h4();
        var iter = this.z().j();
        while(iter.k()){
            var entry = iter.l();
            var k = entry.a1();
            if (equals(key, k)) {
                var value = entry.b1();
                iter.i4();
                return value;
            }
        }
        return null;
    };
    protoOf(AbstractMutableMap).h4 = function() {};
    function AbstractMutableSet() {
        AbstractMutableCollection.call(this);
    }
    protoOf(AbstractMutableSet).equals = function(other) {
        if (other === this) return true;
        if (!(!(other == null) ? isInterface(other, KtSet) : false)) return false;
        return Companion_instance_7.n5(this, other);
    };
    protoOf(AbstractMutableSet).hashCode = function() {
        return Companion_instance_7.o5(this);
    };
    function arrayOfUninitializedElements(capacity) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(capacity >= 0)) {
            // Inline function 'kotlin.collections.arrayOfUninitializedElements.<anonymous>' call
            var message = "capacity must be non-negative.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOfNulls' call
        // Inline function 'kotlin.js.asDynamic' call
        return fillArrayVal(Array(capacity), null);
    }
    function resetRange(_this__u8e3s4, fromIndex, toIndex) {
        // Inline function 'kotlin.js.nativeFill' call
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4.fill(null, fromIndex, toIndex);
    }
    function copyOfUninitializedElements(_this__u8e3s4, newSize) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return copyOf_7(_this__u8e3s4, newSize);
    }
    function resetAt(_this__u8e3s4, index) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4[index] = null;
    }
    function Companion_2() {
        Companion_instance_2 = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList_init_$Create$_0(0);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.Companion.Empty.<anonymous>' call
        this_0.i_1 = true;
        tmp.p5_1 = this_0;
    }
    var Companion_instance_2;
    function Companion_getInstance_2() {
        if (Companion_instance_2 == null) new Companion_2();
        return Companion_instance_2;
    }
    function ArrayList_init_$Init$($this) {
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        ArrayList.call($this, tmp$ret$0);
        return $this;
    }
    function ArrayList_init_$Create$() {
        return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
    }
    function ArrayList_init_$Init$_0(initialCapacity, $this) {
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        ArrayList.call($this, tmp$ret$0);
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(initialCapacity >= 0)) {
            // Inline function 'kotlin.collections.ArrayList.<init>.<anonymous>' call
            var message = "Negative initial capacity: " + initialCapacity;
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return $this;
    }
    function ArrayList_init_$Create$_0(initialCapacity) {
        return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
    }
    function ArrayList_init_$Init$_1(elements, $this) {
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(elements);
        ArrayList.call($this, tmp$ret$0);
        return $this;
    }
    function ArrayList_init_$Create$_1(elements) {
        return ArrayList_init_$Init$_1(elements, objectCreate(protoOf(ArrayList)));
    }
    function increaseLength($this, amount) {
        var previous = $this.m();
        // Inline function 'kotlin.js.asDynamic' call
        $this.h_1.length = $this.m() + amount | 0;
        return previous;
    }
    function rangeCheck($this, index) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.ArrayList.rangeCheck.<anonymous>' call
        Companion_instance_5.z4(index, $this.m());
        return index;
    }
    function insertionRangeCheck($this, index) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.ArrayList.insertionRangeCheck.<anonymous>' call
        Companion_instance_5.r4(index, $this.m());
        return index;
    }
    function ArrayList(array) {
        Companion_getInstance_2();
        AbstractMutableList.call(this);
        this.h_1 = array;
        this.i_1 = false;
    }
    protoOf(ArrayList).q5 = function(minCapacity) {};
    protoOf(ArrayList).m = function() {
        return this.h_1.length;
    };
    protoOf(ArrayList).o = function(index) {
        var tmp = this.h_1[rangeCheck(this, index)];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(ArrayList).j2 = function(index, element) {
        this.h4();
        rangeCheck(this, index);
        // Inline function 'kotlin.apply' call
        var this_0 = this.h_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.ArrayList.set.<anonymous>' call
        this.h_1[index] = element;
        var tmp = this_0;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(ArrayList).e = function(element) {
        this.h4();
        // Inline function 'kotlin.js.asDynamic' call
        this.h_1.push(element);
        this.m4_1 = this.m4_1 + 1 | 0;
        return true;
    };
    protoOf(ArrayList).k2 = function(index, element) {
        this.h4();
        // Inline function 'kotlin.js.asDynamic' call
        this.h_1.splice(insertionRangeCheck(this, index), 0, element);
        this.m4_1 = this.m4_1 + 1 | 0;
    };
    protoOf(ArrayList).n = function(elements) {
        this.h4();
        if (elements.s()) return false;
        var offset = increaseLength(this, elements.m());
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var tmp0_iterator = elements.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlin.collections.ArrayList.addAll.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            var index_0 = checkIndexOverflow(tmp1);
            this.h_1[offset + index_0 | 0] = item;
        }
        this.m4_1 = this.m4_1 + 1 | 0;
        return true;
    };
    protoOf(ArrayList).l2 = function(index) {
        this.h4();
        rangeCheck(this, index);
        this.m4_1 = this.m4_1 + 1 | 0;
        var tmp;
        if (index === get_lastIndex_2(this)) // Inline function 'kotlin.js.asDynamic' call
        tmp = this.h_1.pop();
        else // Inline function 'kotlin.js.asDynamic' call
        tmp = this.h_1.splice(index, 1)[0];
        return tmp;
    };
    protoOf(ArrayList).a5 = function(fromIndex, toIndex) {
        this.h4();
        this.m4_1 = this.m4_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        this.h_1.splice(fromIndex, toIndex - fromIndex | 0);
    };
    protoOf(ArrayList).i2 = function() {
        this.h4();
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.h_1 = [];
        this.m4_1 = this.m4_1 + 1 | 0;
    };
    protoOf(ArrayList).b5 = function(element) {
        return indexOf(this.h_1, element);
    };
    protoOf(ArrayList).toString = function() {
        return arrayToString(this.h_1);
    };
    protoOf(ArrayList).r5 = function() {
        return [].slice.call(this.h_1);
    };
    protoOf(ArrayList).toArray = function() {
        return this.r5();
    };
    protoOf(ArrayList).h4 = function() {
        if (this.i_1) throw UnsupportedOperationException_init_$Create$();
    };
    var _stableSortingIsSupported;
    function sortArrayWith(array, comparator) {
        if (getStableSortingIsSupported()) {
            var comparison = sortArrayWith$lambda(comparator);
            // Inline function 'kotlin.js.asDynamic' call
            array.sort(comparison);
        } else // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        mergeSort(array, 0, get_lastIndex(array), comparator);
    }
    function getStableSortingIsSupported() {
        var tmp0_safe_receiver = _stableSortingIsSupported;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp0_safe_receiver;
        _stableSortingIsSupported = false;
        // Inline function 'kotlin.js.unsafeCast' call
        var array = [];
        var inductionVariable = 0;
        if (inductionVariable < 600) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            array.push(index);
        }while (inductionVariable < 600);
        var comparison = getStableSortingIsSupported$lambda;
        // Inline function 'kotlin.js.asDynamic' call
        array.sort(comparison);
        var inductionVariable_0 = 1;
        var last = array.length;
        if (inductionVariable_0 < last) do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = array[index_0 - 1 | 0];
            var b = array[index_0];
            if ((a & 3) === (b & 3) && a >= b) return false;
        }while (inductionVariable_0 < last);
        _stableSortingIsSupported = true;
        return true;
    }
    function mergeSort(array, start, endInclusive, comparator) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOfNulls' call
        var size = array.length;
        // Inline function 'kotlin.js.asDynamic' call
        var buffer = fillArrayVal(Array(size), null);
        var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
        if (!(result === array)) {
            var inductionVariable = start;
            if (inductionVariable <= endInclusive) do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                array[i] = result[i];
            }while (!(i === endInclusive));
        }
    }
    function mergeSort_0(array, buffer, start, end, comparator) {
        if (start === end) return array;
        var median = (start + end | 0) / 2 | 0;
        var left = mergeSort_0(array, buffer, start, median, comparator);
        var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
        var target = left === buffer ? array : buffer;
        var leftIndex = start;
        var rightIndex = median + 1 | 0;
        var inductionVariable = start;
        if (inductionVariable <= end) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (leftIndex <= median && rightIndex <= end) {
                var leftValue = left[leftIndex];
                var rightValue = right[rightIndex];
                if (comparator.compare(leftValue, rightValue) <= 0) {
                    target[i] = leftValue;
                    leftIndex = leftIndex + 1 | 0;
                } else {
                    target[i] = rightValue;
                    rightIndex = rightIndex + 1 | 0;
                }
            } else if (leftIndex <= median) {
                target[i] = left[leftIndex];
                leftIndex = leftIndex + 1 | 0;
            } else {
                target[i] = right[rightIndex];
                rightIndex = rightIndex + 1 | 0;
            }
        }while (!(i === end));
        return target;
    }
    function sortArrayWith$lambda($comparator) {
        return function(a, b) {
            return $comparator.compare(a, b);
        };
    }
    function getStableSortingIsSupported$lambda(a, b) {
        return (a & 3) - (b & 3) | 0;
    }
    function HashMap_init_$Init$(internalMap, $this) {
        AbstractMutableMap.call($this);
        HashMap.call($this);
        $this.w5_1 = internalMap;
        return $this;
    }
    function HashMap_init_$Init$_0($this) {
        HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
        return $this;
    }
    function HashMap_init_$Create$() {
        return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
    }
    function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
        HashMap_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
        return $this;
    }
    function HashMap_init_$Init$_2(initialCapacity, $this) {
        HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
        return $this;
    }
    function HashMap_init_$Create$_0(initialCapacity) {
        return HashMap_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashMap)));
    }
    function HashMap_init_$Init$_3(original, $this) {
        HashMap_init_$Init$(InternalHashMap_init_$Create$_1(original), $this);
        return $this;
    }
    function HashMap_init_$Create$_1(original) {
        return HashMap_init_$Init$_3(original, objectCreate(protoOf(HashMap)));
    }
    protoOf(HashMap).i2 = function() {
        this.w5_1.i2();
    };
    protoOf(HashMap).c2 = function(key) {
        return this.w5_1.y5(key);
    };
    protoOf(HashMap).d2 = function(value) {
        return this.w5_1.d2(value);
    };
    protoOf(HashMap).i5 = function() {
        return new HashMapKeys(this.w5_1);
    };
    protoOf(HashMap).j5 = function() {
        return new HashMapValues(this.w5_1);
    };
    protoOf(HashMap).z = function() {
        var tmp0_elvis_lhs = this.x5_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = new HashMapEntrySet(this.w5_1);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.HashMap.<get-entries>.<anonymous>' call
            this.x5_1 = this_0;
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(HashMap).e2 = function(key) {
        return this.w5_1.e2(key);
    };
    protoOf(HashMap).m2 = function(key, value) {
        return this.w5_1.m2(key, value);
    };
    protoOf(HashMap).n2 = function(key) {
        return this.w5_1.n2(key);
    };
    protoOf(HashMap).m = function() {
        return this.w5_1.m();
    };
    protoOf(HashMap).o2 = function(from) {
        return this.w5_1.o2(from);
    };
    function HashMap() {
        this.x5_1 = null;
    }
    function HashMapKeys(backing) {
        AbstractMutableSet.call(this);
        this.z5_1 = backing;
    }
    protoOf(HashMapKeys).m = function() {
        return this.z5_1.m();
    };
    protoOf(HashMapKeys).s = function() {
        return this.z5_1.m() === 0;
    };
    protoOf(HashMapKeys).a2 = function(element) {
        return this.z5_1.y5(element);
    };
    protoOf(HashMapKeys).i2 = function() {
        return this.z5_1.i2();
    };
    protoOf(HashMapKeys).e = function(element) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapKeys).n = function(elements) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapKeys).j = function() {
        return this.z5_1.a6();
    };
    protoOf(HashMapKeys).h4 = function() {
        return this.z5_1.b6();
    };
    function HashMapValues(backing) {
        AbstractMutableCollection.call(this);
        this.c6_1 = backing;
    }
    protoOf(HashMapValues).m = function() {
        return this.c6_1.m();
    };
    protoOf(HashMapValues).s = function() {
        return this.c6_1.m() === 0;
    };
    protoOf(HashMapValues).d6 = function(element) {
        return this.c6_1.d2(element);
    };
    protoOf(HashMapValues).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.d6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapValues).e6 = function(element) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapValues).e = function(element) {
        return this.e6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapValues).f6 = function(elements) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapValues).n = function(elements) {
        return this.f6(elements);
    };
    protoOf(HashMapValues).j = function() {
        return this.c6_1.g6();
    };
    protoOf(HashMapValues).h4 = function() {
        return this.c6_1.b6();
    };
    function HashMapEntrySet(backing) {
        HashMapEntrySetBase.call(this, backing);
    }
    protoOf(HashMapEntrySet).j = function() {
        return this.i6_1.j6();
    };
    function HashMapEntrySetBase(backing) {
        AbstractMutableSet.call(this);
        this.i6_1 = backing;
    }
    protoOf(HashMapEntrySetBase).m = function() {
        return this.i6_1.m();
    };
    protoOf(HashMapEntrySetBase).s = function() {
        return this.i6_1.m() === 0;
    };
    protoOf(HashMapEntrySetBase).k6 = function(element) {
        return this.i6_1.m6(element);
    };
    protoOf(HashMapEntrySetBase).a2 = function(element) {
        if (!(!(element == null) ? isInterface(element, Entry) : false)) return false;
        return this.k6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
    };
    protoOf(HashMapEntrySetBase).i2 = function() {
        return this.i6_1.i2();
    };
    protoOf(HashMapEntrySetBase).l6 = function(element) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapEntrySetBase).e = function(element) {
        return this.l6((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
    };
    protoOf(HashMapEntrySetBase).n = function(elements) {
        throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(HashMapEntrySetBase).b2 = function(elements) {
        return this.i6_1.n6(elements);
    };
    protoOf(HashMapEntrySetBase).h4 = function() {
        return this.i6_1.b6();
    };
    function HashMapKeysDefault$iterator$1($entryIterator) {
        this.o6_1 = $entryIterator;
    }
    protoOf(HashMapKeysDefault$iterator$1).k = function() {
        return this.o6_1.k();
    };
    protoOf(HashMapKeysDefault$iterator$1).l = function() {
        return this.o6_1.l().a1();
    };
    protoOf(HashMapKeysDefault$iterator$1).i4 = function() {
        return this.o6_1.i4();
    };
    function HashMapKeysDefault(backingMap) {
        AbstractMutableSet.call(this);
        this.p6_1 = backingMap;
    }
    protoOf(HashMapKeysDefault).q6 = function(element) {
        throw UnsupportedOperationException_init_$Create$_0("Add is not supported on keys");
    };
    protoOf(HashMapKeysDefault).e = function(element) {
        return this.q6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapKeysDefault).i2 = function() {
        return this.p6_1.i2();
    };
    protoOf(HashMapKeysDefault).y5 = function(element) {
        return this.p6_1.c2(element);
    };
    protoOf(HashMapKeysDefault).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.y5((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapKeysDefault).j = function() {
        var entryIterator = this.p6_1.z().j();
        return new HashMapKeysDefault$iterator$1(entryIterator);
    };
    protoOf(HashMapKeysDefault).m = function() {
        return this.p6_1.m();
    };
    protoOf(HashMapKeysDefault).h4 = function() {
        return this.p6_1.h4();
    };
    function HashMapValuesDefault$iterator$1($entryIterator) {
        this.r6_1 = $entryIterator;
    }
    protoOf(HashMapValuesDefault$iterator$1).k = function() {
        return this.r6_1.k();
    };
    protoOf(HashMapValuesDefault$iterator$1).l = function() {
        return this.r6_1.l().b1();
    };
    protoOf(HashMapValuesDefault$iterator$1).i4 = function() {
        return this.r6_1.i4();
    };
    function HashMapValuesDefault(backingMap) {
        AbstractMutableCollection.call(this);
        this.s6_1 = backingMap;
    }
    protoOf(HashMapValuesDefault).e6 = function(element) {
        throw UnsupportedOperationException_init_$Create$_0("Add is not supported on values");
    };
    protoOf(HashMapValuesDefault).e = function(element) {
        return this.e6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapValuesDefault).d6 = function(element) {
        return this.s6_1.d2(element);
    };
    protoOf(HashMapValuesDefault).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.d6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(HashMapValuesDefault).j = function() {
        var entryIterator = this.s6_1.z().j();
        return new HashMapValuesDefault$iterator$1(entryIterator);
    };
    protoOf(HashMapValuesDefault).m = function() {
        return this.s6_1.m();
    };
    protoOf(HashMapValuesDefault).h4 = function() {
        return this.s6_1.h4();
    };
    function HashSet_init_$Init$(map, $this) {
        AbstractMutableSet.call($this);
        HashSet.call($this);
        $this.m1_1 = map;
        return $this;
    }
    function HashSet_init_$Init$_0($this) {
        HashSet_init_$Init$(InternalHashMap_init_$Create$(), $this);
        return $this;
    }
    function HashSet_init_$Create$() {
        return HashSet_init_$Init$_0(objectCreate(protoOf(HashSet)));
    }
    function HashSet_init_$Init$_1(elements, $this) {
        HashSet_init_$Init$(InternalHashMap_init_$Create$_0(elements.m()), $this);
        var tmp0_iterator = elements.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            $this.m1_1.m2(element, true);
        }
        return $this;
    }
    function HashSet_init_$Create$_0(elements) {
        return HashSet_init_$Init$_1(elements, objectCreate(protoOf(HashSet)));
    }
    function HashSet_init_$Init$_2(initialCapacity, loadFactor, $this) {
        HashSet_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
        return $this;
    }
    function HashSet_init_$Init$_3(initialCapacity, $this) {
        HashSet_init_$Init$_2(initialCapacity, 1.0, $this);
        return $this;
    }
    function HashSet_init_$Create$_1(initialCapacity) {
        return HashSet_init_$Init$_3(initialCapacity, objectCreate(protoOf(HashSet)));
    }
    protoOf(HashSet).e = function(element) {
        return this.m1_1.m2(element, true) == null;
    };
    protoOf(HashSet).i2 = function() {
        this.m1_1.i2();
    };
    protoOf(HashSet).a2 = function(element) {
        return this.m1_1.y5(element);
    };
    protoOf(HashSet).s = function() {
        return this.m1_1.m() === 0;
    };
    protoOf(HashSet).j = function() {
        return this.m1_1.a6();
    };
    protoOf(HashSet).m = function() {
        return this.m1_1.m();
    };
    function HashSet() {}
    function computeHashSize($this, capacity) {
        return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
    }
    function computeShift($this, hashSize) {
        // Inline function 'kotlin.countLeadingZeroBits' call
        return clz32(hashSize) + 1 | 0;
    }
    function InternalHashMap_init_$Init$($this) {
        InternalHashMap_init_$Init$_0(8, $this);
        return $this;
    }
    function InternalHashMap_init_$Create$() {
        return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
    }
    function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
        InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_3, initialCapacity)), 2, 0);
        return $this;
    }
    function InternalHashMap_init_$Create$_0(initialCapacity) {
        return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
    }
    function InternalHashMap_init_$Init$_1(original, $this) {
        InternalHashMap_init_$Init$_0(original.m(), $this);
        $this.o2(original);
        return $this;
    }
    function InternalHashMap_init_$Create$_1(original) {
        return InternalHashMap_init_$Init$_1(original, objectCreate(protoOf(InternalHashMap)));
    }
    function InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, $this) {
        InternalHashMap_init_$Init$_0(initialCapacity, $this);
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(loadFactor > 0)) {
            // Inline function 'kotlin.collections.InternalHashMap.<init>.<anonymous>' call
            var message = "Non-positive load factor: " + loadFactor;
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return $this;
    }
    function InternalHashMap_init_$Create$_2(initialCapacity, loadFactor) {
        return InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
    }
    function _get_capacity__a9k9f3($this) {
        return $this.t6_1.length;
    }
    function _get_hashSize__tftcho($this) {
        return $this.w6_1.length;
    }
    function registerModification($this) {
        $this.a7_1 = $this.a7_1 + 1 | 0;
    }
    function ensureExtraCapacity($this, n) {
        if (shouldCompact($this, n)) rehash($this, _get_hashSize__tftcho($this));
        else ensureCapacity($this, $this.y6_1 + n | 0);
    }
    function shouldCompact($this, extraCapacity) {
        var spareCapacity = _get_capacity__a9k9f3($this) - $this.y6_1 | 0;
        var gaps = $this.y6_1 - $this.m() | 0;
        return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
    }
    function ensureCapacity($this, minCapacity) {
        if (minCapacity < 0) throw RuntimeException_init_$Create$_0("too many elements");
        if (minCapacity > _get_capacity__a9k9f3($this)) {
            var newSize = Companion_instance_5.d7(_get_capacity__a9k9f3($this), minCapacity);
            $this.t6_1 = copyOfUninitializedElements($this.t6_1, newSize);
            var tmp = $this;
            var tmp0_safe_receiver = $this.u6_1;
            tmp.u6_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
            $this.v6_1 = copyOf_3($this.v6_1, newSize);
            var newHashSize = computeHashSize(Companion_instance_3, newSize);
            if (newHashSize > _get_hashSize__tftcho($this)) rehash($this, newHashSize);
        }
    }
    function allocateValuesArray($this) {
        var curValuesArray = $this.u6_1;
        if (!(curValuesArray == null)) return curValuesArray;
        var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
        $this.u6_1 = newValuesArray;
        return newValuesArray;
    }
    function hash($this, key) {
        return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.z6_1 | 0;
    }
    function compact($this) {
        var i = 0;
        var j = 0;
        var valuesArray = $this.u6_1;
        while(i < $this.y6_1){
            if ($this.v6_1[i] >= 0) {
                $this.t6_1[j] = $this.t6_1[i];
                if (!(valuesArray == null)) valuesArray[j] = valuesArray[i];
                j = j + 1 | 0;
            }
            i = i + 1 | 0;
        }
        resetRange($this.t6_1, j, $this.y6_1);
        if (valuesArray == null) ;
        else resetRange(valuesArray, j, $this.y6_1);
        $this.y6_1 = j;
    }
    function rehash($this, newHashSize) {
        registerModification($this);
        if ($this.y6_1 > $this.b7_1) compact($this);
        if (!(newHashSize === _get_hashSize__tftcho($this))) {
            $this.w6_1 = new Int32Array(newHashSize);
            $this.z6_1 = computeShift(Companion_instance_3, newHashSize);
        } else fill($this.w6_1, 0, 0, _get_hashSize__tftcho($this));
        var i = 0;
        while(i < $this.y6_1){
            var tmp0 = i;
            i = tmp0 + 1 | 0;
            if (!putRehash($this, tmp0)) throw IllegalStateException_init_$Create$_0("This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?");
        }
    }
    function putRehash($this, i) {
        var hash_0 = hash($this, $this.t6_1[i]);
        var probesLeft = $this.x6_1;
        while(true){
            var index = $this.w6_1[hash_0];
            if (index === 0) {
                $this.w6_1[hash_0] = i + 1 | 0;
                $this.v6_1[i] = hash_0;
                return true;
            }
            probesLeft = probesLeft - 1 | 0;
            if (probesLeft < 0) return false;
            var tmp0 = hash_0;
            hash_0 = tmp0 - 1 | 0;
            if (tmp0 === 0) hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
        }
    }
    function findKey($this, key) {
        var hash_0 = hash($this, key);
        var probesLeft = $this.x6_1;
        while(true){
            var index = $this.w6_1[hash_0];
            if (index === 0) return -1;
            if (index > 0 && equals($this.t6_1[index - 1 | 0], key)) return index - 1 | 0;
            probesLeft = probesLeft - 1 | 0;
            if (probesLeft < 0) return -1;
            var tmp0 = hash_0;
            hash_0 = tmp0 - 1 | 0;
            if (tmp0 === 0) hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
        }
    }
    function findValue($this, value) {
        var i = $this.y6_1;
        $l$loop: while(true){
            i = i - 1 | 0;
            if (!(i >= 0)) break $l$loop;
            if ($this.v6_1[i] >= 0 && equals(ensureNotNull($this.u6_1)[i], value)) return i;
        }
        return -1;
    }
    function addKey($this, key) {
        $this.b6();
        retry: while(true){
            var hash_0 = hash($this, key);
            var tentativeMaxProbeDistance = coerceAtMost(imul($this.x6_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
            var probeDistance = 0;
            while(true){
                var index = $this.w6_1[hash_0];
                if (index <= 0) {
                    if ($this.y6_1 >= _get_capacity__a9k9f3($this)) {
                        ensureExtraCapacity($this, 1);
                        continue retry;
                    }
                    var tmp1 = $this.y6_1;
                    $this.y6_1 = tmp1 + 1 | 0;
                    var putIndex = tmp1;
                    $this.t6_1[putIndex] = key;
                    $this.v6_1[putIndex] = hash_0;
                    $this.w6_1[hash_0] = putIndex + 1 | 0;
                    $this.b7_1 = $this.b7_1 + 1 | 0;
                    registerModification($this);
                    if (probeDistance > $this.x6_1) $this.x6_1 = probeDistance;
                    return putIndex;
                }
                if (equals($this.t6_1[index - 1 | 0], key)) return -index | 0;
                probeDistance = probeDistance + 1 | 0;
                if (probeDistance > tentativeMaxProbeDistance) {
                    rehash($this, imul(_get_hashSize__tftcho($this), 2));
                    continue retry;
                }
                var tmp4 = hash_0;
                hash_0 = tmp4 - 1 | 0;
                if (tmp4 === 0) hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
            }
        }
    }
    function removeEntryAt($this, index) {
        resetAt($this.t6_1, index);
        var tmp0_safe_receiver = $this.u6_1;
        if (tmp0_safe_receiver == null) ;
        else resetAt(tmp0_safe_receiver, index);
        removeHashAt($this, $this.v6_1[index]);
        $this.v6_1[index] = -1;
        $this.b7_1 = $this.b7_1 - 1 | 0;
        registerModification($this);
    }
    function removeHashAt($this, removedHash) {
        var hash_0 = removedHash;
        var hole = removedHash;
        var probeDistance = 0;
        var patchAttemptsLeft = coerceAtMost(imul($this.x6_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
        while(true){
            var tmp0 = hash_0;
            hash_0 = tmp0 - 1 | 0;
            if (tmp0 === 0) hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
            probeDistance = probeDistance + 1 | 0;
            if (probeDistance > $this.x6_1) {
                $this.w6_1[hole] = 0;
                return Unit_instance;
            }
            var index = $this.w6_1[hash_0];
            if (index === 0) {
                $this.w6_1[hole] = 0;
                return Unit_instance;
            }
            if (index < 0) {
                $this.w6_1[hole] = -1;
                hole = hash_0;
                probeDistance = 0;
            } else {
                var otherHash = hash($this, $this.t6_1[index - 1 | 0]);
                if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
                    $this.w6_1[hole] = index;
                    $this.v6_1[index - 1 | 0] = hole;
                    hole = hash_0;
                    probeDistance = 0;
                }
            }
            patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
            if (patchAttemptsLeft < 0) {
                $this.w6_1[hole] = -1;
                return Unit_instance;
            }
        }
    }
    function contentEquals_0($this, other) {
        return $this.b7_1 === other.m() && $this.n6(other.z());
    }
    function putEntry($this, entry) {
        var index = addKey($this, entry.a1());
        var valuesArray = allocateValuesArray($this);
        if (index >= 0) {
            valuesArray[index] = entry.b1();
            return true;
        }
        var oldValue = valuesArray[(-index | 0) - 1 | 0];
        if (!equals(entry.b1(), oldValue)) {
            valuesArray[(-index | 0) - 1 | 0] = entry.b1();
            return true;
        }
        return false;
    }
    function putAllEntries($this, from) {
        if (from.s()) return false;
        ensureExtraCapacity($this, from.m());
        var it = from.j();
        var updated = false;
        while(it.k())if (putEntry($this, it.l())) updated = true;
        return updated;
    }
    function Companion_3() {
        this.e7_1 = -1640531527;
        this.f7_1 = 8;
        this.g7_1 = 2;
        this.h7_1 = -1;
    }
    var Companion_instance_3;
    function Companion_getInstance_3() {
        return Companion_instance_3;
    }
    function Itr(map) {
        this.i7_1 = map;
        this.j7_1 = 0;
        this.k7_1 = -1;
        this.l7_1 = this.i7_1.a7_1;
        this.m7();
    }
    protoOf(Itr).m7 = function() {
        while(this.j7_1 < this.i7_1.y6_1 && this.i7_1.v6_1[this.j7_1] < 0)this.j7_1 = this.j7_1 + 1 | 0;
    };
    protoOf(Itr).k = function() {
        return this.j7_1 < this.i7_1.y6_1;
    };
    protoOf(Itr).i4 = function() {
        this.n7();
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(this.k7_1 === -1)) {
            // Inline function 'kotlin.collections.Itr.remove.<anonymous>' call
            var message = "Call next() before removing element from the iterator.";
            throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        this.i7_1.b6();
        removeEntryAt(this.i7_1, this.k7_1);
        this.k7_1 = -1;
        this.l7_1 = this.i7_1.a7_1;
    };
    protoOf(Itr).n7 = function() {
        if (!(this.i7_1.a7_1 === this.l7_1)) throw ConcurrentModificationException_init_$Create$();
    };
    function KeysItr(map) {
        Itr.call(this, map);
    }
    protoOf(KeysItr).l = function() {
        this.n7();
        if (this.j7_1 >= this.i7_1.y6_1) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j7_1;
        this.j7_1 = tmp1 + 1 | 0;
        tmp.k7_1 = tmp1;
        var result = this.i7_1.t6_1[this.k7_1];
        this.m7();
        return result;
    };
    function ValuesItr(map) {
        Itr.call(this, map);
    }
    protoOf(ValuesItr).l = function() {
        this.n7();
        if (this.j7_1 >= this.i7_1.y6_1) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j7_1;
        this.j7_1 = tmp1 + 1 | 0;
        tmp.k7_1 = tmp1;
        var result = ensureNotNull(this.i7_1.u6_1)[this.k7_1];
        this.m7();
        return result;
    };
    function EntriesItr(map) {
        Itr.call(this, map);
    }
    protoOf(EntriesItr).l = function() {
        this.n7();
        if (this.j7_1 >= this.i7_1.y6_1) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j7_1;
        this.j7_1 = tmp1 + 1 | 0;
        tmp.k7_1 = tmp1;
        var result = new EntryRef(this.i7_1, this.k7_1);
        this.m7();
        return result;
    };
    protoOf(EntriesItr).a8 = function() {
        if (this.j7_1 >= this.i7_1.y6_1) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j7_1;
        this.j7_1 = tmp1 + 1 | 0;
        tmp.k7_1 = tmp1;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.i7_1.t6_1[this.k7_1];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = ensureNotNull(this.i7_1.u6_1)[this.k7_1];
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
        this.m7();
        return result;
    };
    protoOf(EntriesItr).b8 = function(sb) {
        if (this.j7_1 >= this.i7_1.y6_1) throw NoSuchElementException_init_$Create$();
        var tmp = this;
        var tmp1 = this.j7_1;
        this.j7_1 = tmp1 + 1 | 0;
        tmp.k7_1 = tmp1;
        var key = this.i7_1.t6_1[this.k7_1];
        if (equals(key, this.i7_1)) sb.e8("(this Map)");
        else sb.d8(key);
        sb.f8(_Char___init__impl__6a9atx(61));
        var value = ensureNotNull(this.i7_1.u6_1)[this.k7_1];
        if (equals(value, this.i7_1)) sb.e8("(this Map)");
        else sb.d8(value);
        this.m7();
    };
    function EntryRef(map, index) {
        this.g8_1 = map;
        this.h8_1 = index;
    }
    protoOf(EntryRef).a1 = function() {
        return this.g8_1.t6_1[this.h8_1];
    };
    protoOf(EntryRef).b1 = function() {
        return ensureNotNull(this.g8_1.u6_1)[this.h8_1];
    };
    protoOf(EntryRef).equals = function(other) {
        var tmp;
        var tmp_0;
        if (!(other == null) ? isInterface(other, Entry) : false) tmp_0 = equals(other.a1(), this.a1());
        else tmp_0 = false;
        if (tmp_0) tmp = equals(other.b1(), this.b1());
        else tmp = false;
        return tmp;
    };
    protoOf(EntryRef).hashCode = function() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.a1();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver_0 = this.b1();
        var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
        return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
    };
    protoOf(EntryRef).toString = function() {
        return toString_0(this.a1()) + "=" + toString_0(this.b1());
    };
    function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
        this.t6_1 = keysArray;
        this.u6_1 = valuesArray;
        this.v6_1 = presenceArray;
        this.w6_1 = hashArray;
        this.x6_1 = maxProbeDistance;
        this.y6_1 = length;
        this.z6_1 = computeShift(Companion_instance_3, _get_hashSize__tftcho(this));
        this.a7_1 = 0;
        this.b7_1 = 0;
        this.c7_1 = false;
    }
    protoOf(InternalHashMap).m = function() {
        return this.b7_1;
    };
    protoOf(InternalHashMap).i8 = function() {
        this.b6();
        this.c7_1 = true;
    };
    protoOf(InternalHashMap).d2 = function(value) {
        return findValue(this, value) >= 0;
    };
    protoOf(InternalHashMap).e2 = function(key) {
        var index = findKey(this, key);
        if (index < 0) return null;
        return ensureNotNull(this.u6_1)[index];
    };
    protoOf(InternalHashMap).y5 = function(key) {
        return findKey(this, key) >= 0;
    };
    protoOf(InternalHashMap).m2 = function(key, value) {
        var index = addKey(this, key);
        var valuesArray = allocateValuesArray(this);
        if (index < 0) {
            var oldValue = valuesArray[(-index | 0) - 1 | 0];
            valuesArray[(-index | 0) - 1 | 0] = value;
            return oldValue;
        } else {
            valuesArray[index] = value;
            return null;
        }
    };
    protoOf(InternalHashMap).o2 = function(from) {
        this.b6();
        putAllEntries(this, from.z());
    };
    protoOf(InternalHashMap).n2 = function(key) {
        this.b6();
        var index = findKey(this, key);
        if (index < 0) return null;
        var oldValue = ensureNotNull(this.u6_1)[index];
        removeEntryAt(this, index);
        return oldValue;
    };
    protoOf(InternalHashMap).i2 = function() {
        this.b6();
        var inductionVariable = 0;
        var last = this.y6_1 - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var hash = this.v6_1[i];
            if (hash >= 0) {
                this.w6_1[hash] = 0;
                this.v6_1[i] = -1;
            }
        }while (!(i === last));
        resetRange(this.t6_1, 0, this.y6_1);
        var tmp1_safe_receiver = this.u6_1;
        if (tmp1_safe_receiver == null) ;
        else resetRange(tmp1_safe_receiver, 0, this.y6_1);
        this.b7_1 = 0;
        this.y6_1 = 0;
        registerModification(this);
    };
    protoOf(InternalHashMap).equals = function(other) {
        var tmp;
        if (other === this) tmp = true;
        else {
            var tmp_0;
            if (!(other == null) ? isInterface(other, KtMap) : false) tmp_0 = contentEquals_0(this, other);
            else tmp_0 = false;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(InternalHashMap).hashCode = function() {
        var result = 0;
        var it = this.j6();
        while(it.k())result = result + it.a8() | 0;
        return result;
    };
    protoOf(InternalHashMap).toString = function() {
        var sb = StringBuilder_init_$Create$(2 + imul(this.b7_1, 3) | 0);
        sb.e8("{");
        var i = 0;
        var it = this.j6();
        while(it.k()){
            if (i > 0) sb.e8(", ");
            it.b8(sb);
            i = i + 1 | 0;
        }
        sb.e8("}");
        return sb.toString();
    };
    protoOf(InternalHashMap).b6 = function() {
        if (this.c7_1) throw UnsupportedOperationException_init_$Create$();
    };
    protoOf(InternalHashMap).m6 = function(entry) {
        var index = findKey(this, entry.a1());
        if (index < 0) return false;
        return equals(ensureNotNull(this.u6_1)[index], entry.b1());
    };
    protoOf(InternalHashMap).j8 = function(entry) {
        return this.m6(isInterface(entry, Entry) ? entry : THROW_CCE());
    };
    protoOf(InternalHashMap).a6 = function() {
        return new KeysItr(this);
    };
    protoOf(InternalHashMap).g6 = function() {
        return new ValuesItr(this);
    };
    protoOf(InternalHashMap).j6 = function() {
        return new EntriesItr(this);
    };
    function InternalMap() {}
    function LinkedHashMap_init_$Init$($this) {
        HashMap_init_$Init$_0($this);
        LinkedHashMap.call($this);
        return $this;
    }
    function LinkedHashMap_init_$Create$() {
        return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
    }
    function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
        HashMap_init_$Init$_2(initialCapacity, $this);
        LinkedHashMap.call($this);
        return $this;
    }
    function LinkedHashMap_init_$Create$_0(initialCapacity) {
        return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
    }
    function LinkedHashMap_init_$Init$_1(original, $this) {
        HashMap_init_$Init$_3(original, $this);
        LinkedHashMap.call($this);
        return $this;
    }
    function LinkedHashMap_init_$Create$_1(original) {
        return LinkedHashMap_init_$Init$_1(original, objectCreate(protoOf(LinkedHashMap)));
    }
    function LinkedHashMap_init_$Init$_2(internalMap, $this) {
        HashMap_init_$Init$(internalMap, $this);
        LinkedHashMap.call($this);
        return $this;
    }
    function LinkedHashMap_init_$Create$_2(internalMap) {
        return LinkedHashMap_init_$Init$_2(internalMap, objectCreate(protoOf(LinkedHashMap)));
    }
    function EmptyHolder() {
        EmptyHolder_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = InternalHashMap_init_$Create$_0(0);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.EmptyHolder.value.<anonymous>' call
        this_0.i8();
        tmp.k8_1 = LinkedHashMap_init_$Create$_2(this_0);
    }
    var EmptyHolder_instance;
    function EmptyHolder_getInstance() {
        if (EmptyHolder_instance == null) new EmptyHolder();
        return EmptyHolder_instance;
    }
    protoOf(LinkedHashMap).r8 = function() {
        this.w5_1.i8();
        var tmp;
        if (this.m() > 0) tmp = this;
        else // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = EmptyHolder_getInstance().k8_1;
        return tmp;
    };
    protoOf(LinkedHashMap).h4 = function() {
        return this.w5_1.b6();
    };
    function LinkedHashMap() {}
    function LinkedHashSet_init_$Init$($this) {
        HashSet_init_$Init$_0($this);
        LinkedHashSet.call($this);
        return $this;
    }
    function LinkedHashSet_init_$Create$() {
        return LinkedHashSet_init_$Init$(objectCreate(protoOf(LinkedHashSet)));
    }
    function LinkedHashSet_init_$Init$_0(elements, $this) {
        HashSet_init_$Init$_1(elements, $this);
        LinkedHashSet.call($this);
        return $this;
    }
    function LinkedHashSet_init_$Create$_0(elements) {
        return LinkedHashSet_init_$Init$_0(elements, objectCreate(protoOf(LinkedHashSet)));
    }
    function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
        HashSet_init_$Init$_2(initialCapacity, loadFactor, $this);
        LinkedHashSet.call($this);
        return $this;
    }
    function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
        LinkedHashSet_init_$Init$_1(initialCapacity, 1.0, $this);
        return $this;
    }
    function LinkedHashSet_init_$Create$_1(initialCapacity) {
        return LinkedHashSet_init_$Init$_2(initialCapacity, objectCreate(protoOf(LinkedHashSet)));
    }
    protoOf(LinkedHashSet).h4 = function() {
        return this.m1_1.b6();
    };
    function LinkedHashSet() {}
    function RandomAccess() {}
    function CoroutineImpl(resultContinuation) {
        InterceptedCoroutine.call(this);
        this.u8_1 = resultContinuation;
        this.v8_1 = 0;
        this.w8_1 = 0;
        this.x8_1 = null;
        this.y8_1 = null;
        this.z8_1 = null;
        var tmp = this;
        var tmp0_safe_receiver = this.u8_1;
        tmp.a9_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b9();
    }
    protoOf(CoroutineImpl).b9 = function() {
        return ensureNotNull(this.a9_1);
    };
    protoOf(CoroutineImpl).c9 = function(result) {
        var current = this;
        // Inline function 'kotlin.Result.getOrNull' call
        var tmp;
        if (_Result___get_isFailure__impl__jpiriv(result)) tmp = null;
        else {
            var tmp_0 = _Result___get_value__impl__bjfvqg(result);
            tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        }
        var currentResult = tmp;
        var currentException = Result__exceptionOrNull_impl_p6xea9(result);
        while(true){
            // Inline function 'kotlin.with' call
            // Inline function 'kotlin.contracts.contract' call
            var $this$with = current;
            if (currentException == null) $this$with.x8_1 = currentResult;
            else {
                $this$with.v8_1 = $this$with.w8_1;
                $this$with.y8_1 = currentException;
            }
            try {
                var outcome = $this$with.d9();
                if (outcome === get_COROUTINE_SUSPENDED()) return Unit_instance;
                currentResult = outcome;
                currentException = null;
            } catch ($p) {
                var exception = $p;
                currentResult = null;
                // Inline function 'kotlin.js.unsafeCast' call
                currentException = exception;
            }
            $this$with.f9();
            var completion = ensureNotNull($this$with.u8_1);
            if (completion instanceof CoroutineImpl) current = completion;
            else {
                if (!(currentException == null)) {
                    // Inline function 'kotlin.coroutines.resumeWithException' call
                    // Inline function 'kotlin.Companion.failure' call
                    var exception_0 = ensureNotNull(currentException);
                    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception_0));
                    completion.g9(tmp$ret$2);
                } else {
                    // Inline function 'kotlin.coroutines.resume' call
                    // Inline function 'kotlin.Companion.success' call
                    var value = currentResult;
                    var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
                    completion.g9(tmp$ret$4);
                }
                return Unit_instance;
            }
        }
    };
    protoOf(CoroutineImpl).g9 = function(result) {
        return this.c9(result);
    };
    function CompletedContinuation() {}
    protoOf(CompletedContinuation).b9 = function() {
        var message = "This continuation is already complete";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
    protoOf(CompletedContinuation).c9 = function(result) {
        // Inline function 'kotlin.error' call
        var message = "This continuation is already complete";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
    protoOf(CompletedContinuation).g9 = function(result) {
        return this.c9(result);
    };
    protoOf(CompletedContinuation).toString = function() {
        return "This continuation is already complete";
    };
    var CompletedContinuation_instance;
    function CompletedContinuation_getInstance() {
        return CompletedContinuation_instance;
    }
    function InterceptedCoroutine() {
        this.e9_1 = null;
    }
    protoOf(InterceptedCoroutine).h9 = function() {
        var tmp2_elvis_lhs = this.e9_1;
        var tmp;
        if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var tmp0_safe_receiver = this.b9().i9(Key_instance);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j9(this);
            var this_0 = tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.coroutines.InterceptedCoroutine.intercepted.<anonymous>' call
            this.e9_1 = this_0;
            tmp = this_0;
        } else tmp = tmp2_elvis_lhs;
        return tmp;
    };
    protoOf(InterceptedCoroutine).f9 = function() {
        var intercepted = this.e9_1;
        if (!(intercepted == null) && !(intercepted === this)) ensureNotNull(this.b9().i9(Key_instance)).k9(intercepted);
        this.e9_1 = CompletedContinuation_instance;
    };
    function CancellationException_init_$Init$($this) {
        IllegalStateException_init_$Init$($this);
        CancellationException.call($this);
        return $this;
    }
    function CancellationException_init_$Create$() {
        var tmp = CancellationException_init_$Init$(objectCreate(protoOf(CancellationException)));
        captureStack(tmp, CancellationException_init_$Create$);
        return tmp;
    }
    function CancellationException_init_$Init$_0(message, $this) {
        IllegalStateException_init_$Init$_0(message, $this);
        CancellationException.call($this);
        return $this;
    }
    function CancellationException_init_$Create$_0(message) {
        var tmp = CancellationException_init_$Init$_0(message, objectCreate(protoOf(CancellationException)));
        captureStack(tmp, CancellationException_init_$Create$_0);
        return tmp;
    }
    function CancellationException_init_$Init$_1(message, cause, $this) {
        IllegalStateException_init_$Init$_1(message, cause, $this);
        CancellationException.call($this);
        return $this;
    }
    function CancellationException_init_$Create$_1(message, cause) {
        var tmp = CancellationException_init_$Init$_1(message, cause, objectCreate(protoOf(CancellationException)));
        captureStack(tmp, CancellationException_init_$Create$_1);
        return tmp;
    }
    function CancellationException() {
        captureStack(this, CancellationException);
    }
    function intercepted(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine ? _this__u8e3s4 : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h9();
        return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    }
    function createCoroutineUnintercepted(_this__u8e3s4, receiver, completion) {
        // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromSuspendFunction' call
        return new _no_name_provided__qut3iv_1(completion, _this__u8e3s4, receiver, completion);
    }
    function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
        throw new NotImplementedError("It is intrinsic method");
    }
    function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
        throw new NotImplementedError("It is intrinsic method");
    }
    function _no_name_provided__qut3iv_1($completion, $this_createCoroutineUnintercepted, $receiver, $completion$1) {
        this.v9_1 = $this_createCoroutineUnintercepted;
        this.w9_1 = $receiver;
        this.x9_1 = $completion$1;
        CoroutineImpl.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
    }
    protoOf(_no_name_provided__qut3iv_1).d9 = function() {
        if (this.y8_1 != null) throw this.y8_1;
        // Inline function 'kotlin.coroutines.intrinsics.createCoroutineUnintercepted.<anonymous>' call
        // Inline function 'kotlin.js.asDynamic' call
        var a = this.v9_1;
        return typeof a === "function" ? a(this.w9_1, this.x9_1) : this.v9_1.y9(this.w9_1, this.x9_1);
    };
    function iterator(_this__u8e3s4) {
        var r = _this__u8e3s4;
        var tmp;
        if (_this__u8e3s4["iterator"] != null) tmp = _this__u8e3s4["iterator"]();
        else if (isArrayish(r)) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = arrayIterator(r);
        else tmp = ((!(r == null) ? isInterface(r, Iterable) : false) ? r : THROW_CCE()).j();
        return tmp;
    }
    function Exception_init_$Init$($this) {
        extendThrowable($this);
        Exception.call($this);
        return $this;
    }
    function Exception_init_$Create$() {
        var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
        captureStack(tmp, Exception_init_$Create$);
        return tmp;
    }
    function Exception_init_$Init$_0(message, $this) {
        extendThrowable($this, message);
        Exception.call($this);
        return $this;
    }
    function Exception_init_$Create$_0(message) {
        var tmp = Exception_init_$Init$_0(message, objectCreate(protoOf(Exception)));
        captureStack(tmp, Exception_init_$Create$_0);
        return tmp;
    }
    function Exception_init_$Init$_1(message, cause, $this) {
        extendThrowable($this, message, cause);
        Exception.call($this);
        return $this;
    }
    function Exception_init_$Init$_2(cause, $this) {
        extendThrowable($this, VOID, cause);
        Exception.call($this);
        return $this;
    }
    function Exception() {
        captureStack(this, Exception);
    }
    function IllegalArgumentException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        IllegalArgumentException.call($this);
        return $this;
    }
    function IllegalArgumentException_init_$Create$() {
        var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
        captureStack(tmp, IllegalArgumentException_init_$Create$);
        return tmp;
    }
    function IllegalArgumentException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        IllegalArgumentException.call($this);
        return $this;
    }
    function IllegalArgumentException_init_$Create$_0(message) {
        var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
        captureStack(tmp, IllegalArgumentException_init_$Create$_0);
        return tmp;
    }
    function IllegalArgumentException_init_$Init$_1(message, cause, $this) {
        RuntimeException_init_$Init$_1(message, cause, $this);
        IllegalArgumentException.call($this);
        return $this;
    }
    function IllegalArgumentException_init_$Create$_1(message, cause) {
        var tmp = IllegalArgumentException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalArgumentException)));
        captureStack(tmp, IllegalArgumentException_init_$Create$_1);
        return tmp;
    }
    function IllegalArgumentException_init_$Init$_2(cause, $this) {
        RuntimeException_init_$Init$_2(cause, $this);
        IllegalArgumentException.call($this);
        return $this;
    }
    function IllegalArgumentException() {
        captureStack(this, IllegalArgumentException);
    }
    function IndexOutOfBoundsException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        IndexOutOfBoundsException.call($this);
        return $this;
    }
    function IndexOutOfBoundsException_init_$Create$() {
        var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
        captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
        return tmp;
    }
    function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        IndexOutOfBoundsException.call($this);
        return $this;
    }
    function IndexOutOfBoundsException_init_$Create$_0(message) {
        var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
        captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
        return tmp;
    }
    function IndexOutOfBoundsException() {
        captureStack(this, IndexOutOfBoundsException);
    }
    function IllegalStateException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        IllegalStateException.call($this);
        return $this;
    }
    function IllegalStateException_init_$Create$() {
        var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
        captureStack(tmp, IllegalStateException_init_$Create$);
        return tmp;
    }
    function IllegalStateException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        IllegalStateException.call($this);
        return $this;
    }
    function IllegalStateException_init_$Create$_0(message) {
        var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
        captureStack(tmp, IllegalStateException_init_$Create$_0);
        return tmp;
    }
    function IllegalStateException_init_$Init$_1(message, cause, $this) {
        RuntimeException_init_$Init$_1(message, cause, $this);
        IllegalStateException.call($this);
        return $this;
    }
    function IllegalStateException_init_$Create$_1(message, cause) {
        var tmp = IllegalStateException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalStateException)));
        captureStack(tmp, IllegalStateException_init_$Create$_1);
        return tmp;
    }
    function IllegalStateException() {
        captureStack(this, IllegalStateException);
    }
    function UnsupportedOperationException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        UnsupportedOperationException.call($this);
        return $this;
    }
    function UnsupportedOperationException_init_$Create$() {
        var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
        captureStack(tmp, UnsupportedOperationException_init_$Create$);
        return tmp;
    }
    function UnsupportedOperationException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        UnsupportedOperationException.call($this);
        return $this;
    }
    function UnsupportedOperationException_init_$Create$_0(message) {
        var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
        captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
        return tmp;
    }
    function UnsupportedOperationException() {
        captureStack(this, UnsupportedOperationException);
    }
    function RuntimeException_init_$Init$($this) {
        Exception_init_$Init$($this);
        RuntimeException.call($this);
        return $this;
    }
    function RuntimeException_init_$Create$() {
        var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
        captureStack(tmp, RuntimeException_init_$Create$);
        return tmp;
    }
    function RuntimeException_init_$Init$_0(message, $this) {
        Exception_init_$Init$_0(message, $this);
        RuntimeException.call($this);
        return $this;
    }
    function RuntimeException_init_$Create$_0(message) {
        var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
        captureStack(tmp, RuntimeException_init_$Create$_0);
        return tmp;
    }
    function RuntimeException_init_$Init$_1(message, cause, $this) {
        Exception_init_$Init$_1(message, cause, $this);
        RuntimeException.call($this);
        return $this;
    }
    function RuntimeException_init_$Create$_1(message, cause) {
        var tmp = RuntimeException_init_$Init$_1(message, cause, objectCreate(protoOf(RuntimeException)));
        captureStack(tmp, RuntimeException_init_$Create$_1);
        return tmp;
    }
    function RuntimeException_init_$Init$_2(cause, $this) {
        Exception_init_$Init$_2(cause, $this);
        RuntimeException.call($this);
        return $this;
    }
    function RuntimeException() {
        captureStack(this, RuntimeException);
    }
    function NoSuchElementException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        NoSuchElementException.call($this);
        return $this;
    }
    function NoSuchElementException_init_$Create$() {
        var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
        captureStack(tmp, NoSuchElementException_init_$Create$);
        return tmp;
    }
    function NoSuchElementException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        NoSuchElementException.call($this);
        return $this;
    }
    function NoSuchElementException_init_$Create$_0(message) {
        var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
        captureStack(tmp, NoSuchElementException_init_$Create$_0);
        return tmp;
    }
    function NoSuchElementException() {
        captureStack(this, NoSuchElementException);
    }
    function Error_init_$Init$($this) {
        extendThrowable($this);
        Error_0.call($this);
        return $this;
    }
    function Error_init_$Create$() {
        var tmp = Error_init_$Init$(objectCreate(protoOf(Error_0)));
        captureStack(tmp, Error_init_$Create$);
        return tmp;
    }
    function Error_init_$Init$_0(message, $this) {
        extendThrowable($this, message);
        Error_0.call($this);
        return $this;
    }
    function Error_init_$Create$_0(message) {
        var tmp = Error_init_$Init$_0(message, objectCreate(protoOf(Error_0)));
        captureStack(tmp, Error_init_$Create$_0);
        return tmp;
    }
    function Error_init_$Init$_1(message, cause, $this) {
        extendThrowable($this, message, cause);
        Error_0.call($this);
        return $this;
    }
    function Error_init_$Create$_1(message, cause) {
        var tmp = Error_init_$Init$_1(message, cause, objectCreate(protoOf(Error_0)));
        captureStack(tmp, Error_init_$Create$_1);
        return tmp;
    }
    function Error_0() {
        captureStack(this, Error_0);
    }
    function AssertionError_init_$Init$($this) {
        Error_init_$Init$($this);
        AssertionError.call($this);
        return $this;
    }
    function AssertionError_init_$Create$() {
        var tmp = AssertionError_init_$Init$(objectCreate(protoOf(AssertionError)));
        captureStack(tmp, AssertionError_init_$Create$);
        return tmp;
    }
    function AssertionError_init_$Init$_0(message, $this) {
        Error_init_$Init$_0(message, $this);
        AssertionError.call($this);
        return $this;
    }
    function AssertionError_init_$Create$_0(message) {
        var tmp = AssertionError_init_$Init$_0(message, objectCreate(protoOf(AssertionError)));
        captureStack(tmp, AssertionError_init_$Create$_0);
        return tmp;
    }
    function AssertionError() {
        captureStack(this, AssertionError);
    }
    function ConcurrentModificationException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        ConcurrentModificationException.call($this);
        return $this;
    }
    function ConcurrentModificationException_init_$Create$() {
        var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
        captureStack(tmp, ConcurrentModificationException_init_$Create$);
        return tmp;
    }
    function ConcurrentModificationException() {
        captureStack(this, ConcurrentModificationException);
    }
    function ArithmeticException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        ArithmeticException.call($this);
        return $this;
    }
    function ArithmeticException_init_$Create$() {
        var tmp = ArithmeticException_init_$Init$(objectCreate(protoOf(ArithmeticException)));
        captureStack(tmp, ArithmeticException_init_$Create$);
        return tmp;
    }
    function ArithmeticException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        ArithmeticException.call($this);
        return $this;
    }
    function ArithmeticException_init_$Create$_0(message) {
        var tmp = ArithmeticException_init_$Init$_0(message, objectCreate(protoOf(ArithmeticException)));
        captureStack(tmp, ArithmeticException_init_$Create$_0);
        return tmp;
    }
    function ArithmeticException() {
        captureStack(this, ArithmeticException);
    }
    function NumberFormatException_init_$Init$($this) {
        IllegalArgumentException_init_$Init$($this);
        NumberFormatException.call($this);
        return $this;
    }
    function NumberFormatException_init_$Create$() {
        var tmp = NumberFormatException_init_$Init$(objectCreate(protoOf(NumberFormatException)));
        captureStack(tmp, NumberFormatException_init_$Create$);
        return tmp;
    }
    function NumberFormatException_init_$Init$_0(message, $this) {
        IllegalArgumentException_init_$Init$_0(message, $this);
        NumberFormatException.call($this);
        return $this;
    }
    function NumberFormatException_init_$Create$_0(message) {
        var tmp = NumberFormatException_init_$Init$_0(message, objectCreate(protoOf(NumberFormatException)));
        captureStack(tmp, NumberFormatException_init_$Create$_0);
        return tmp;
    }
    function NumberFormatException() {
        captureStack(this, NumberFormatException);
    }
    function NullPointerException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        NullPointerException.call($this);
        return $this;
    }
    function NullPointerException_init_$Create$() {
        var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
        captureStack(tmp, NullPointerException_init_$Create$);
        return tmp;
    }
    function NullPointerException() {
        captureStack(this, NullPointerException);
    }
    function NoWhenBranchMatchedException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        NoWhenBranchMatchedException.call($this);
        return $this;
    }
    function NoWhenBranchMatchedException_init_$Create$() {
        var tmp = NoWhenBranchMatchedException_init_$Init$(objectCreate(protoOf(NoWhenBranchMatchedException)));
        captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
        return tmp;
    }
    function NoWhenBranchMatchedException() {
        captureStack(this, NoWhenBranchMatchedException);
    }
    function ClassCastException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        ClassCastException.call($this);
        return $this;
    }
    function ClassCastException_init_$Create$() {
        var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
        captureStack(tmp, ClassCastException_init_$Create$);
        return tmp;
    }
    function ClassCastException() {
        captureStack(this, ClassCastException);
    }
    function UninitializedPropertyAccessException_init_$Init$($this) {
        RuntimeException_init_$Init$($this);
        UninitializedPropertyAccessException.call($this);
        return $this;
    }
    function UninitializedPropertyAccessException_init_$Create$() {
        var tmp = UninitializedPropertyAccessException_init_$Init$(objectCreate(protoOf(UninitializedPropertyAccessException)));
        captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
        return tmp;
    }
    function UninitializedPropertyAccessException_init_$Init$_0(message, $this) {
        RuntimeException_init_$Init$_0(message, $this);
        UninitializedPropertyAccessException.call($this);
        return $this;
    }
    function UninitializedPropertyAccessException_init_$Create$_0(message) {
        var tmp = UninitializedPropertyAccessException_init_$Init$_0(message, objectCreate(protoOf(UninitializedPropertyAccessException)));
        captureStack(tmp, UninitializedPropertyAccessException_init_$Create$_0);
        return tmp;
    }
    function UninitializedPropertyAccessException() {
        captureStack(this, UninitializedPropertyAccessException);
    }
    function json(pairs) {
        var res = {};
        var inductionVariable = 0;
        var last = pairs.length;
        while(inductionVariable < last){
            var tmp1_loop_parameter = pairs[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var name = tmp1_loop_parameter.ba();
            var value = tmp1_loop_parameter.ca();
            res[name] = value;
        }
        return res;
    }
    function lazy(mode, initializer) {
        return new UnsafeLazyImpl(initializer);
    }
    function lazy_0(initializer) {
        return new UnsafeLazyImpl(initializer);
    }
    function fillFrom(src, dst) {
        var srcLen = src.length;
        var dstLen = dst.length;
        var index = 0;
        // Inline function 'kotlin.js.unsafeCast' call
        var arr = dst;
        while(index < srcLen && index < dstLen){
            var tmp = index;
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            arr[tmp] = src[tmp0];
        }
        return dst;
    }
    function arrayCopyResize(source, newSize, defaultValue) {
        // Inline function 'kotlin.js.unsafeCast' call
        var result = source.slice(0, newSize);
        // Inline function 'kotlin.copyArrayType' call
        if (source.$type$ !== undefined) result.$type$ = source.$type$;
        var index = source.length;
        if (newSize > index) {
            // Inline function 'kotlin.js.asDynamic' call
            result.length = newSize;
            while(index < newSize){
                var tmp0 = index;
                index = tmp0 + 1 | 0;
                result[tmp0] = defaultValue;
            }
        }
        return result;
    }
    function roundToInt(_this__u8e3s4) {
        var tmp;
        if (isNaN_0(_this__u8e3s4)) throw IllegalArgumentException_init_$Create$_0("Cannot round NaN value.");
        else if (_this__u8e3s4 > 2147483647) tmp = 2147483647;
        else if (_this__u8e3s4 < -2147483648) tmp = -2147483648;
        else tmp = numberToInt(Math.round(_this__u8e3s4));
        return tmp;
    }
    function roundToLong(_this__u8e3s4) {
        var tmp;
        if (isNaN_0(_this__u8e3s4)) throw IllegalArgumentException_init_$Create$_0("Cannot round NaN value.");
        else if (_this__u8e3s4 > new Long(-1, 2147483647).p3()) tmp = new Long(-1, 2147483647);
        else if (_this__u8e3s4 < new Long(0, -2147483648).p3()) tmp = new Long(0, -2147483648);
        else tmp = numberToLong(Math.round(_this__u8e3s4));
        return tmp;
    }
    var INV_2_26;
    var INV_2_53;
    function defaultPlatformRandom() {
        _init_properties_PlatformRandom_kt__6kjv62();
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$0 = Math.random() * Math.pow(2, 32) | 0;
        return Random_0(tmp$ret$0);
    }
    var properties_initialized_PlatformRandom_kt_uibhw8;
    function _init_properties_PlatformRandom_kt__6kjv62() {
        if (!properties_initialized_PlatformRandom_kt_uibhw8) {
            properties_initialized_PlatformRandom_kt_uibhw8 = true;
            // Inline function 'kotlin.math.pow' call
            INV_2_26 = Math.pow(2.0, -26);
            // Inline function 'kotlin.math.pow' call
            INV_2_53 = Math.pow(2.0, -53);
        }
    }
    function get_js(_this__u8e3s4) {
        return (_this__u8e3s4 instanceof KClassImpl ? _this__u8e3s4 : THROW_CCE()).ea();
    }
    function KClass() {}
    function KClassImpl(jClass) {
        this.da_1 = jClass;
    }
    protoOf(KClassImpl).ea = function() {
        return this.da_1;
    };
    protoOf(KClassImpl).equals = function(other) {
        var tmp;
        if (other instanceof NothingKClassImpl) tmp = false;
        else {
            if (other instanceof ErrorKClass) tmp = false;
            else if (other instanceof KClassImpl) tmp = equals(this.ea(), other.ea());
            else tmp = false;
        }
        return tmp;
    };
    protoOf(KClassImpl).hashCode = function() {
        var tmp0_safe_receiver = this.fa();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    };
    protoOf(KClassImpl).toString = function() {
        return "class " + this.fa();
    };
    function NothingKClassImpl() {
        NothingKClassImpl_instance = this;
        KClassImpl.call(this, Object);
        this.ia_1 = "Nothing";
    }
    protoOf(NothingKClassImpl).fa = function() {
        return this.ia_1;
    };
    protoOf(NothingKClassImpl).ga = function(value) {
        return false;
    };
    protoOf(NothingKClassImpl).ea = function() {
        throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
    };
    protoOf(NothingKClassImpl).equals = function(other) {
        return other === this;
    };
    protoOf(NothingKClassImpl).hashCode = function() {
        return 0;
    };
    var NothingKClassImpl_instance;
    function NothingKClassImpl_getInstance() {
        if (NothingKClassImpl_instance == null) new NothingKClassImpl();
        return NothingKClassImpl_instance;
    }
    function ErrorKClass() {}
    protoOf(ErrorKClass).fa = function() {
        var message = "Unknown simpleName for ErrorKClass";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
    protoOf(ErrorKClass).ga = function(value) {
        var message = "Can's check isInstance on ErrorKClass";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
    protoOf(ErrorKClass).equals = function(other) {
        return other === this;
    };
    protoOf(ErrorKClass).hashCode = function() {
        return 0;
    };
    function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
        KClassImpl.call(this, jClass);
        this.ka_1 = givenSimpleName;
        this.la_1 = isInstanceFunction;
    }
    protoOf(PrimitiveKClassImpl).equals = function(other) {
        if (!(other instanceof PrimitiveKClassImpl)) return false;
        return protoOf(KClassImpl).equals.call(this, other) && this.ka_1 === other.ka_1;
    };
    protoOf(PrimitiveKClassImpl).fa = function() {
        return this.ka_1;
    };
    protoOf(PrimitiveKClassImpl).ga = function(value) {
        return this.la_1(value);
    };
    function SimpleKClassImpl(jClass) {
        KClassImpl.call(this, jClass);
        var tmp = this;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = jClass.$metadata$;
        tmp.na_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    }
    protoOf(SimpleKClassImpl).fa = function() {
        return this.na_1;
    };
    protoOf(SimpleKClassImpl).ga = function(value) {
        return jsIsType(value, this.ea());
    };
    function KProperty1() {}
    function createKType(classifier, arguments_0, isMarkedNullable) {
        return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
    }
    function createInvariantKTypeProjection(type) {
        return Companion_getInstance_14().pa(type);
    }
    function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
        this.qa_1 = classifier;
        this.ra_1 = arguments_0;
        this.sa_1 = isMarkedNullable;
    }
    protoOf(KTypeImpl).ta = function() {
        return this.qa_1;
    };
    protoOf(KTypeImpl).ua = function() {
        return this.ra_1;
    };
    protoOf(KTypeImpl).va = function() {
        return this.sa_1;
    };
    protoOf(KTypeImpl).equals = function(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof KTypeImpl) tmp_1 = equals(this.qa_1, other.qa_1);
        else tmp_1 = false;
        if (tmp_1) tmp_0 = equals(this.ra_1, other.ra_1);
        else tmp_0 = false;
        if (tmp_0) tmp = this.sa_1 === other.sa_1;
        else tmp = false;
        return tmp;
    };
    protoOf(KTypeImpl).hashCode = function() {
        return imul(imul(hashCode(this.qa_1), 31) + hashCode(this.ra_1) | 0, 31) + getBooleanHashCode(this.sa_1) | 0;
    };
    protoOf(KTypeImpl).toString = function() {
        var tmp = this.qa_1;
        var kClass = isInterface(tmp, KClass) ? tmp : null;
        var classifierName = kClass == null ? toString_1(this.qa_1) : !(kClass.fa() == null) ? kClass.fa() : "(non-denotable type)";
        var args = this.ra_1.s() ? "" : joinToString_0(this.ra_1, ", ", "<", ">");
        var nullable = this.sa_1 ? "?" : "";
        return plus_4(classifierName, args) + nullable;
    };
    function get_functionClasses() {
        _init_properties_primitives_kt__3fums4();
        return functionClasses;
    }
    var functionClasses;
    function PrimitiveClasses$anyClass$lambda(it) {
        return !(it == null);
    }
    function PrimitiveClasses$numberClass$lambda(it) {
        return isNumber(it);
    }
    function PrimitiveClasses$booleanClass$lambda(it) {
        return !(it == null) ? typeof it === "boolean" : false;
    }
    function PrimitiveClasses$byteClass$lambda(it) {
        return !(it == null) ? typeof it === "number" : false;
    }
    function PrimitiveClasses$shortClass$lambda(it) {
        return !(it == null) ? typeof it === "number" : false;
    }
    function PrimitiveClasses$intClass$lambda(it) {
        return !(it == null) ? typeof it === "number" : false;
    }
    function PrimitiveClasses$floatClass$lambda(it) {
        return !(it == null) ? typeof it === "number" : false;
    }
    function PrimitiveClasses$doubleClass$lambda(it) {
        return !(it == null) ? typeof it === "number" : false;
    }
    function PrimitiveClasses$arrayClass$lambda(it) {
        return !(it == null) ? isArray(it) : false;
    }
    function PrimitiveClasses$stringClass$lambda(it) {
        return !(it == null) ? typeof it === "string" : false;
    }
    function PrimitiveClasses$throwableClass$lambda(it) {
        return it instanceof Error;
    }
    function PrimitiveClasses$booleanArrayClass$lambda(it) {
        return !(it == null) ? isBooleanArray(it) : false;
    }
    function PrimitiveClasses$charArrayClass$lambda(it) {
        return !(it == null) ? isCharArray(it) : false;
    }
    function PrimitiveClasses$byteArrayClass$lambda(it) {
        return !(it == null) ? isByteArray(it) : false;
    }
    function PrimitiveClasses$shortArrayClass$lambda(it) {
        return !(it == null) ? isShortArray(it) : false;
    }
    function PrimitiveClasses$intArrayClass$lambda(it) {
        return !(it == null) ? isIntArray(it) : false;
    }
    function PrimitiveClasses$longArrayClass$lambda(it) {
        return !(it == null) ? isLongArray(it) : false;
    }
    function PrimitiveClasses$floatArrayClass$lambda(it) {
        return !(it == null) ? isFloatArray(it) : false;
    }
    function PrimitiveClasses$doubleArrayClass$lambda(it) {
        return !(it == null) ? isDoubleArray(it) : false;
    }
    function PrimitiveClasses$functionClass$lambda($arity) {
        return function(it) {
            var tmp;
            if (typeof it === "function") // Inline function 'kotlin.js.asDynamic' call
            tmp = it.length === $arity;
            else tmp = false;
            return tmp;
        };
    }
    function PrimitiveClasses() {
        PrimitiveClasses_instance = this;
        var tmp = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_0 = Object;
        tmp.anyClass = new PrimitiveKClassImpl(tmp_0, "Any", PrimitiveClasses$anyClass$lambda);
        var tmp_1 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_2 = Number;
        tmp_1.numberClass = new PrimitiveKClassImpl(tmp_2, "Number", PrimitiveClasses$numberClass$lambda);
        this.nothingClass = NothingKClassImpl_getInstance();
        var tmp_3 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_4 = Boolean;
        tmp_3.booleanClass = new PrimitiveKClassImpl(tmp_4, "Boolean", PrimitiveClasses$booleanClass$lambda);
        var tmp_5 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_6 = Number;
        tmp_5.byteClass = new PrimitiveKClassImpl(tmp_6, "Byte", PrimitiveClasses$byteClass$lambda);
        var tmp_7 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_8 = Number;
        tmp_7.shortClass = new PrimitiveKClassImpl(tmp_8, "Short", PrimitiveClasses$shortClass$lambda);
        var tmp_9 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_10 = Number;
        tmp_9.intClass = new PrimitiveKClassImpl(tmp_10, "Int", PrimitiveClasses$intClass$lambda);
        var tmp_11 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_12 = Number;
        tmp_11.floatClass = new PrimitiveKClassImpl(tmp_12, "Float", PrimitiveClasses$floatClass$lambda);
        var tmp_13 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_14 = Number;
        tmp_13.doubleClass = new PrimitiveKClassImpl(tmp_14, "Double", PrimitiveClasses$doubleClass$lambda);
        var tmp_15 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_16 = Array;
        tmp_15.arrayClass = new PrimitiveKClassImpl(tmp_16, "Array", PrimitiveClasses$arrayClass$lambda);
        var tmp_17 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_18 = String;
        tmp_17.stringClass = new PrimitiveKClassImpl(tmp_18, "String", PrimitiveClasses$stringClass$lambda);
        var tmp_19 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_20 = Error;
        tmp_19.throwableClass = new PrimitiveKClassImpl(tmp_20, "Throwable", PrimitiveClasses$throwableClass$lambda);
        var tmp_21 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_22 = Array;
        tmp_21.booleanArrayClass = new PrimitiveKClassImpl(tmp_22, "BooleanArray", PrimitiveClasses$booleanArrayClass$lambda);
        var tmp_23 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_24 = Uint16Array;
        tmp_23.charArrayClass = new PrimitiveKClassImpl(tmp_24, "CharArray", PrimitiveClasses$charArrayClass$lambda);
        var tmp_25 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_26 = Int8Array;
        tmp_25.byteArrayClass = new PrimitiveKClassImpl(tmp_26, "ByteArray", PrimitiveClasses$byteArrayClass$lambda);
        var tmp_27 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_28 = Int16Array;
        tmp_27.shortArrayClass = new PrimitiveKClassImpl(tmp_28, "ShortArray", PrimitiveClasses$shortArrayClass$lambda);
        var tmp_29 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_30 = Int32Array;
        tmp_29.intArrayClass = new PrimitiveKClassImpl(tmp_30, "IntArray", PrimitiveClasses$intArrayClass$lambda);
        var tmp_31 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_32 = Array;
        tmp_31.longArrayClass = new PrimitiveKClassImpl(tmp_32, "LongArray", PrimitiveClasses$longArrayClass$lambda);
        var tmp_33 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_34 = Float32Array;
        tmp_33.floatArrayClass = new PrimitiveKClassImpl(tmp_34, "FloatArray", PrimitiveClasses$floatArrayClass$lambda);
        var tmp_35 = this;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp_36 = Float64Array;
        tmp_35.doubleArrayClass = new PrimitiveKClassImpl(tmp_36, "DoubleArray", PrimitiveClasses$doubleArrayClass$lambda);
    }
    protoOf(PrimitiveClasses).wa = function() {
        return this.anyClass;
    };
    protoOf(PrimitiveClasses).xa = function() {
        return this.numberClass;
    };
    protoOf(PrimitiveClasses).ya = function() {
        return this.nothingClass;
    };
    protoOf(PrimitiveClasses).za = function() {
        return this.booleanClass;
    };
    protoOf(PrimitiveClasses).ab = function() {
        return this.byteClass;
    };
    protoOf(PrimitiveClasses).bb = function() {
        return this.shortClass;
    };
    protoOf(PrimitiveClasses).cb = function() {
        return this.intClass;
    };
    protoOf(PrimitiveClasses).db = function() {
        return this.floatClass;
    };
    protoOf(PrimitiveClasses).eb = function() {
        return this.doubleClass;
    };
    protoOf(PrimitiveClasses).fb = function() {
        return this.arrayClass;
    };
    protoOf(PrimitiveClasses).gb = function() {
        return this.stringClass;
    };
    protoOf(PrimitiveClasses).hb = function() {
        return this.throwableClass;
    };
    protoOf(PrimitiveClasses).ib = function() {
        return this.booleanArrayClass;
    };
    protoOf(PrimitiveClasses).jb = function() {
        return this.charArrayClass;
    };
    protoOf(PrimitiveClasses).kb = function() {
        return this.byteArrayClass;
    };
    protoOf(PrimitiveClasses).lb = function() {
        return this.shortArrayClass;
    };
    protoOf(PrimitiveClasses).mb = function() {
        return this.intArrayClass;
    };
    protoOf(PrimitiveClasses).nb = function() {
        return this.longArrayClass;
    };
    protoOf(PrimitiveClasses).ob = function() {
        return this.floatArrayClass;
    };
    protoOf(PrimitiveClasses).pb = function() {
        return this.doubleArrayClass;
    };
    protoOf(PrimitiveClasses).functionClass = function(arity) {
        var tmp0_elvis_lhs = get_functionClasses()[arity];
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.reflect.js.internal.PrimitiveClasses.functionClass.<anonymous>' call
            // Inline function 'kotlin.js.unsafeCast' call
            var tmp_0 = Function;
            var tmp_1 = "Function" + arity;
            var result = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
            // Inline function 'kotlin.js.asDynamic' call
            get_functionClasses()[arity] = result;
            tmp = result;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    var PrimitiveClasses_instance;
    function PrimitiveClasses_getInstance() {
        if (PrimitiveClasses_instance == null) new PrimitiveClasses();
        return PrimitiveClasses_instance;
    }
    var properties_initialized_primitives_kt_jle18u;
    function _init_properties_primitives_kt__3fums4() {
        if (!properties_initialized_primitives_kt_jle18u) {
            properties_initialized_primitives_kt_jle18u = true;
            // Inline function 'kotlin.arrayOfNulls' call
            functionClasses = fillArrayVal(Array(0), null);
        }
    }
    function getKClass(jClass) {
        var tmp;
        if (Array.isArray(jClass)) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = getKClassM(jClass);
        else // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = getKClass1(jClass);
        return tmp;
    }
    function getKClassM(jClasses) {
        var tmp;
        switch(jClasses.length){
            case 1:
                tmp = getKClass1(jClasses[0]);
                break;
            case 0:
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp = NothingKClassImpl_getInstance();
                break;
            default:
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp = new ErrorKClass();
                break;
        }
        return tmp;
    }
    function getKClass1(jClass) {
        if (jClass === String) // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return PrimitiveClasses_getInstance().stringClass;
        // Inline function 'kotlin.js.asDynamic' call
        var metadata = jClass.$metadata$;
        var tmp;
        if (metadata != null) {
            var tmp_0;
            if (metadata.$kClass$ == null) {
                var kClass = new SimpleKClassImpl(jClass);
                metadata.$kClass$ = kClass;
                tmp_0 = kClass;
            } else tmp_0 = metadata.$kClass$;
            tmp = tmp_0;
        } else tmp = new SimpleKClassImpl(jClass);
        return tmp;
    }
    function getKClassFromExpression(e) {
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp;
        switch(typeof e){
            case "string":
                tmp = PrimitiveClasses_getInstance().stringClass;
                break;
            case "number":
                var tmp_0;
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.jsBitwiseOr' call
                if ((e | 0) === e) tmp_0 = PrimitiveClasses_getInstance().intClass;
                else tmp_0 = PrimitiveClasses_getInstance().doubleClass;
                tmp = tmp_0;
                break;
            case "boolean":
                tmp = PrimitiveClasses_getInstance().booleanClass;
                break;
            case "function":
                var tmp_1 = PrimitiveClasses_getInstance();
                // Inline function 'kotlin.js.asDynamic' call
                tmp = tmp_1.functionClass(e.length);
                break;
            default:
                var tmp_2;
                if (isBooleanArray(e)) tmp_2 = PrimitiveClasses_getInstance().booleanArrayClass;
                else if (isCharArray(e)) tmp_2 = PrimitiveClasses_getInstance().charArrayClass;
                else {
                    if (isByteArray(e)) tmp_2 = PrimitiveClasses_getInstance().byteArrayClass;
                    else if (isShortArray(e)) tmp_2 = PrimitiveClasses_getInstance().shortArrayClass;
                    else {
                        if (isIntArray(e)) tmp_2 = PrimitiveClasses_getInstance().intArrayClass;
                        else if (isLongArray(e)) tmp_2 = PrimitiveClasses_getInstance().longArrayClass;
                        else {
                            if (isFloatArray(e)) tmp_2 = PrimitiveClasses_getInstance().floatArrayClass;
                            else if (isDoubleArray(e)) tmp_2 = PrimitiveClasses_getInstance().doubleArrayClass;
                            else {
                                if (isInterface(e, KClass)) tmp_2 = getKClass(KClass);
                                else if (isArray(e)) tmp_2 = PrimitiveClasses_getInstance().arrayClass;
                                else {
                                    var constructor = Object.getPrototypeOf(e).constructor;
                                    var tmp_3;
                                    if (constructor === Object) tmp_3 = PrimitiveClasses_getInstance().anyClass;
                                    else if (constructor === Error) tmp_3 = PrimitiveClasses_getInstance().throwableClass;
                                    else {
                                        var jsClass = constructor;
                                        tmp_3 = getKClass1(jsClass);
                                    }
                                    tmp_2 = tmp_3;
                                }
                            }
                        }
                    }
                }
                tmp = tmp_2;
                break;
        }
        // Inline function 'kotlin.js.asDynamic' call
        return tmp;
    }
    function findAssociatedObject(_this__u8e3s4, annotationClass) {
        var tmp;
        var tmp_0;
        if (_this__u8e3s4 instanceof KClassImpl) tmp_0 = annotationClass instanceof KClassImpl;
        else tmp_0 = false;
        if (tmp_0) {
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_safe_receiver = annotationClass.ea().$metadata$;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
            var tmp_1;
            if (tmp1_safe_receiver == null) tmp_1 = null;
            else // Inline function 'kotlin.js.unsafeCast' call
            tmp_1 = tmp1_safe_receiver;
            var tmp2_elvis_lhs = tmp_1;
            var tmp_2;
            if (tmp2_elvis_lhs == null) return null;
            else tmp_2 = tmp2_elvis_lhs;
            var key = tmp_2;
            // Inline function 'kotlin.js.asDynamic' call
            var tmp3_safe_receiver = _this__u8e3s4.ea().$metadata$;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
            var tmp_3;
            if (tmp4_elvis_lhs == null) return null;
            else tmp_3 = tmp4_elvis_lhs;
            var map = tmp_3;
            var tmp5_elvis_lhs = map[key];
            var tmp_4;
            if (tmp5_elvis_lhs == null) return null;
            else tmp_4 = tmp5_elvis_lhs;
            var factory = tmp_4;
            return factory();
        } else tmp = null;
        return tmp;
    }
    function reset(_this__u8e3s4) {
        _this__u8e3s4.lastIndex = 0;
    }
    function CharacterCodingException_init_$Init$($this) {
        CharacterCodingException.call($this, null);
        return $this;
    }
    function CharacterCodingException_init_$Create$() {
        var tmp = CharacterCodingException_init_$Init$(objectCreate(protoOf(CharacterCodingException)));
        captureStack(tmp, CharacterCodingException_init_$Create$);
        return tmp;
    }
    function CharacterCodingException(message) {
        Exception_init_$Init$_0(message, this);
        captureStack(this, CharacterCodingException);
    }
    function StringBuilder_init_$Init$(capacity, $this) {
        StringBuilder_init_$Init$_0($this);
        return $this;
    }
    function StringBuilder_init_$Create$(capacity) {
        return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
    }
    function StringBuilder_init_$Init$_0($this) {
        StringBuilder.call($this, "");
        return $this;
    }
    function StringBuilder_init_$Create$_0() {
        return StringBuilder_init_$Init$_0(objectCreate(protoOf(StringBuilder)));
    }
    function StringBuilder(content) {
        this.c8_1 = !(content === undefined) ? content : "";
    }
    protoOf(StringBuilder).a = function() {
        // Inline function 'kotlin.js.asDynamic' call
        return this.c8_1.length;
    };
    protoOf(StringBuilder).b = function(index) {
        // Inline function 'kotlin.text.getOrElse' call
        var this_0 = this.c8_1;
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) tmp = charSequenceGet(this_0, index);
        else throw IndexOutOfBoundsException_init_$Create$_0("index: " + index + ", length: " + this.a() + "}");
        return tmp;
    };
    protoOf(StringBuilder).c = function(startIndex, endIndex) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        return this.c8_1.substring(startIndex, endIndex);
    };
    protoOf(StringBuilder).f8 = function(value) {
        this.c8_1 = this.c8_1 + toString(value);
        return this;
    };
    protoOf(StringBuilder).f = function(value) {
        this.c8_1 = this.c8_1 + toString_0(value);
        return this;
    };
    protoOf(StringBuilder).qb = function(value, startIndex, endIndex) {
        return this.rb(value == null ? "null" : value, startIndex, endIndex);
    };
    protoOf(StringBuilder).d8 = function(value) {
        this.c8_1 = this.c8_1 + toString_0(value);
        return this;
    };
    protoOf(StringBuilder).sb = function(value) {
        return this.e8(value.toString());
    };
    protoOf(StringBuilder).tb = function(value) {
        return this.e8(value.toString());
    };
    protoOf(StringBuilder).e8 = function(value) {
        var tmp = this;
        var tmp_0 = this.c8_1;
        tmp.c8_1 = tmp_0 + (value == null ? "null" : value);
        return this;
    };
    protoOf(StringBuilder).ub = function(index, value) {
        Companion_instance_5.r4(index, this.a());
        var tmp = this;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = this.c8_1.substring(0, index) + toString(value);
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c8_1 = tmp_0 + this.c8_1.substring(index);
        return this;
    };
    protoOf(StringBuilder).vb = function(newLength) {
        if (newLength < 0) throw IllegalArgumentException_init_$Create$_0("Negative new length: " + newLength + ".");
        if (newLength <= this.a()) {
            var tmp = this;
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp.c8_1 = this.c8_1.substring(0, newLength);
        } else {
            var inductionVariable = this.a();
            if (inductionVariable < newLength) do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                this.c8_1 = this.c8_1 + toString(_Char___init__impl__6a9atx(0));
            }while (inductionVariable < newLength);
        }
    };
    protoOf(StringBuilder).toString = function() {
        return this.c8_1;
    };
    protoOf(StringBuilder).wb = function() {
        this.c8_1 = "";
        return this;
    };
    protoOf(StringBuilder).xb = function(index) {
        Companion_instance_5.z4(index, this.a());
        var tmp = this;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = this.c8_1.substring(0, index);
        // Inline function 'kotlin.text.substring' call
        var this_0 = this.c8_1;
        var startIndex = index + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c8_1 = tmp_0 + this_0.substring(startIndex);
        return this;
    };
    protoOf(StringBuilder).rb = function(value, startIndex, endIndex) {
        var stringCsq = toString_1(value);
        Companion_instance_5.yb(startIndex, endIndex, stringCsq.length);
        var tmp = this;
        var tmp_0 = this.c8_1;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c8_1 = tmp_0 + stringCsq.substring(startIndex, endIndex);
        return this;
    };
    function uppercaseChar(_this__u8e3s4) {
        // Inline function 'kotlin.text.uppercase' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var uppercase = toString(_this__u8e3s4).toUpperCase();
        return uppercase.length > 1 ? _this__u8e3s4 : charSequenceGet(uppercase, 0);
    }
    function isLowSurrogate(_this__u8e3s4) {
        return _Char___init__impl__6a9atx(56320) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
    }
    function isHighSurrogate(_this__u8e3s4) {
        return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(56319) : false;
    }
    function isWhitespace(_this__u8e3s4) {
        return isWhitespaceImpl(_this__u8e3s4);
    }
    function isLowerCase(_this__u8e3s4) {
        if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) return true;
        if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) return false;
        return isLowerCaseImpl(_this__u8e3s4);
    }
    function titlecaseChar(_this__u8e3s4) {
        return titlecaseCharImpl(_this__u8e3s4);
    }
    function toString_2(_this__u8e3s4, radix) {
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.toString(checkRadix(radix));
    }
    function checkRadix(radix) {
        if (!(2 <= radix ? radix <= 36 : false)) throw IllegalArgumentException_init_$Create$_0("radix " + radix + " was not in valid range 2..36");
        return radix;
    }
    function toString_3(_this__u8e3s4, radix) {
        return toStringImpl(_this__u8e3s4, checkRadix(radix));
    }
    function toDoubleOrNull(_this__u8e3s4) {
        // Inline function 'kotlin.takeIf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var this_0 = +_this__u8e3s4;
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'kotlin.text.toDoubleOrNull.<anonymous>' call
        if (!(isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || this_0 === 0.0 && isBlank(_this__u8e3s4))) tmp = this_0;
        else tmp = null;
        return tmp;
    }
    function toLong_0(_this__u8e3s4) {
        var tmp0_elvis_lhs = toLongOrNull(_this__u8e3s4);
        var tmp;
        if (tmp0_elvis_lhs == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toInt(_this__u8e3s4) {
        var tmp0_elvis_lhs = toIntOrNull(_this__u8e3s4);
        var tmp;
        if (tmp0_elvis_lhs == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toDouble(_this__u8e3s4) {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var this_0 = +_this__u8e3s4;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.text.toDouble.<anonymous>' call
        if (isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || this_0 === 0.0 && isBlank(_this__u8e3s4)) numberFormatError(_this__u8e3s4);
        return this_0;
    }
    function digitOf(char, radix) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.text.digitOf.<anonymous>' call
        var it = Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(57)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48)) : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(90)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(97)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(122)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(128)) < 0 ? -1 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65313)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65338)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65313)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65345)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65370)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65345)) + 10 | 0 : digitToIntImpl(char);
        return it >= radix ? -1 : it;
    }
    function isNaN_2(_this__u8e3s4) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        switch(_this__u8e3s4.toLowerCase()){
            case "nan":
            case "+nan":
            case "-nan":
                return true;
            default:
                return false;
        }
    }
    function Regex_init_$Init$(pattern, $this) {
        Regex.call($this, pattern, emptySet());
        return $this;
    }
    function Regex_init_$Create$(pattern) {
        return Regex_init_$Init$(pattern, objectCreate(protoOf(Regex)));
    }
    function Companion_4() {
        Companion_instance_4 = this;
        this.zb_1 = new RegExp("[\\\\^$*+?.()|[\\]{}]", "g");
        this.ac_1 = new RegExp("[\\\\$]", "g");
        this.bc_1 = new RegExp("\\$", "g");
    }
    protoOf(Companion_4).cc = function(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.zb_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, "\\$&");
    };
    var Companion_instance_4;
    function Companion_getInstance_4() {
        if (Companion_instance_4 == null) new Companion_4();
        return Companion_instance_4;
    }
    function Regex(pattern, options) {
        Companion_getInstance_4();
        this.dc_1 = pattern;
        this.ec_1 = toSet_0(options);
        this.fc_1 = new RegExp(pattern, toFlags(options, "gu"));
        this.gc_1 = null;
        this.hc_1 = null;
    }
    protoOf(Regex).ic = function(input) {
        reset(this.fc_1);
        var match = this.fc_1.exec(toString_1(input));
        return !(match == null) && match.index === 0 && this.fc_1.lastIndex === charSequenceLength(input);
    };
    protoOf(Regex).jc = function(input, startIndex) {
        if (startIndex < 0 || startIndex > charSequenceLength(input)) throw IndexOutOfBoundsException_init_$Create$_0("Start index out of bounds: " + startIndex + ", input length: " + charSequenceLength(input));
        return findNext(this.fc_1, toString_1(input), startIndex, this.fc_1);
    };
    protoOf(Regex).kc = function(input, startIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        return $super === VOID ? this.jc(input, startIndex) : $super.jc.call(this, input, startIndex);
    };
    protoOf(Regex).toString = function() {
        return this.fc_1.toString();
    };
    function MatchGroup(value) {
        this.lc_1 = value;
    }
    protoOf(MatchGroup).toString = function() {
        return "MatchGroup(value=" + this.lc_1 + ")";
    };
    protoOf(MatchGroup).hashCode = function() {
        return getStringHashCode(this.lc_1);
    };
    protoOf(MatchGroup).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof MatchGroup)) return false;
        var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
        if (!(this.lc_1 === tmp0_other_with_cast.lc_1)) return false;
        return true;
    };
    function toFlags(_this__u8e3s4, prepend) {
        return joinToString_0(_this__u8e3s4, "", prepend, VOID, VOID, VOID, toFlags$lambda);
    }
    function findNext(_this__u8e3s4, input, from, nextPattern) {
        _this__u8e3s4.lastIndex = from;
        var match = _this__u8e3s4.exec(input);
        if (match == null) return null;
        var range = numberRangeToNumber(match.index, _this__u8e3s4.lastIndex - 1 | 0);
        return new findNext$1(range, match, nextPattern, input);
    }
    function toFlags$lambda(it) {
        return it.oc_1;
    }
    function findNext$o$groups$o$iterator$lambda(this$0) {
        return function(it) {
            return this$0.o(it);
        };
    }
    function findNext$1$groups$1($match, this$0) {
        this.pc_1 = $match;
        this.qc_1 = this$0;
        AbstractCollection.call(this);
    }
    protoOf(findNext$1$groups$1).m = function() {
        return this.pc_1.length;
    };
    protoOf(findNext$1$groups$1).j = function() {
        var tmp = asSequence(get_indices_1(this));
        return map(tmp, findNext$o$groups$o$iterator$lambda(this)).j();
    };
    protoOf(findNext$1$groups$1).o = function(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = this.pc_1[index];
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.text.<no name provided>.get.<anonymous>' call
        tmp = new MatchGroup(tmp0_safe_receiver);
        return tmp;
    };
    function findNext$1$groupValues$1($match) {
        this.rc_1 = $match;
        AbstractList.call(this);
    }
    protoOf(findNext$1$groupValues$1).m = function() {
        return this.rc_1.length;
    };
    protoOf(findNext$1$groupValues$1).o = function(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = this.rc_1[index];
        return tmp0_elvis_lhs == null ? "" : tmp0_elvis_lhs;
    };
    function findNext$1($range, $match, $nextPattern, $input) {
        this.vc_1 = $range;
        this.wc_1 = $match;
        this.xc_1 = $nextPattern;
        this.yc_1 = $input;
        this.sc_1 = $range;
        var tmp = this;
        tmp.tc_1 = new findNext$1$groups$1($match, this);
        this.uc_1 = null;
    }
    protoOf(findNext$1).zc = function() {
        if (this.uc_1 == null) {
            var tmp = this;
            tmp.uc_1 = new findNext$1$groupValues$1(this.wc_1);
        }
        return ensureNotNull(this.uc_1);
    };
    var STRING_CASE_INSENSITIVE_ORDER;
    function compareTo_0(_this__u8e3s4, other, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        _init_properties_stringJs_kt__bg7zye();
        if (ignoreCase) {
            var n1 = _this__u8e3s4.length;
            var n2 = other.length;
            // Inline function 'kotlin.comparisons.minOf' call
            var min = Math.min(n1, n2);
            if (min === 0) return n1 - n2 | 0;
            var inductionVariable = 0;
            if (inductionVariable < min) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var thisChar = charSequenceGet(_this__u8e3s4, index);
                var otherChar = charSequenceGet(other, index);
                if (!(thisChar === otherChar)) {
                    thisChar = uppercaseChar(thisChar);
                    otherChar = uppercaseChar(otherChar);
                    if (!(thisChar === otherChar)) {
                        // Inline function 'kotlin.text.lowercaseChar' call
                        // Inline function 'kotlin.text.lowercase' call
                        var this_0 = thisChar;
                        // Inline function 'kotlin.js.unsafeCast' call
                        // Inline function 'kotlin.js.asDynamic' call
                        var tmp$ret$3 = toString(this_0).toLowerCase();
                        thisChar = charSequenceGet(tmp$ret$3, 0);
                        // Inline function 'kotlin.text.lowercaseChar' call
                        // Inline function 'kotlin.text.lowercase' call
                        var this_1 = otherChar;
                        // Inline function 'kotlin.js.unsafeCast' call
                        // Inline function 'kotlin.js.asDynamic' call
                        var tmp$ret$7 = toString(this_1).toLowerCase();
                        otherChar = charSequenceGet(tmp$ret$7, 0);
                        if (!(thisChar === otherChar)) return Char__compareTo_impl_ypi4mb(thisChar, otherChar);
                    }
                }
            }while (inductionVariable < min);
            return n1 - n2 | 0;
        } else return compareTo(_this__u8e3s4, other);
    }
    function concatToString(_this__u8e3s4) {
        _init_properties_stringJs_kt__bg7zye();
        var result = "";
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        while(inductionVariable < last){
            var char = _this__u8e3s4[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            result = result + toString(char);
        }
        return result;
    }
    function encodeToByteArray(_this__u8e3s4) {
        _init_properties_stringJs_kt__bg7zye();
        return encodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
    }
    function contentEquals_1(_this__u8e3s4, other, ignoreCase) {
        _init_properties_stringJs_kt__bg7zye();
        return ignoreCase ? contentEqualsIgnoreCaseImpl(_this__u8e3s4, other) : contentEqualsImpl(_this__u8e3s4, other);
    }
    function decodeToString(_this__u8e3s4) {
        _init_properties_stringJs_kt__bg7zye();
        return decodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
    }
    function sam$kotlin_Comparator$0(function_0) {
        this.ad_1 = function_0;
    }
    protoOf(sam$kotlin_Comparator$0).bd = function(a, b) {
        return this.ad_1(a, b);
    };
    protoOf(sam$kotlin_Comparator$0).compare = function(a, b) {
        return this.bd(a, b);
    };
    function STRING_CASE_INSENSITIVE_ORDER$lambda(a, b) {
        _init_properties_stringJs_kt__bg7zye();
        return compareTo_0(a, b, true);
    }
    var properties_initialized_stringJs_kt_nta8o4;
    function _init_properties_stringJs_kt__bg7zye() {
        if (!properties_initialized_stringJs_kt_nta8o4) {
            properties_initialized_stringJs_kt_nta8o4 = true;
            var tmp = STRING_CASE_INSENSITIVE_ORDER$lambda;
            STRING_CASE_INSENSITIVE_ORDER = new sam$kotlin_Comparator$0(tmp);
        }
    }
    function equals_0(_this__u8e3s4, other, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        if (_this__u8e3s4 == null) return other == null;
        if (other == null) return false;
        if (!ignoreCase) return _this__u8e3s4 == other;
        if (!(_this__u8e3s4.length === other.length)) return false;
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var thisChar = charSequenceGet(_this__u8e3s4, index);
            var otherChar = charSequenceGet(other, index);
            if (!equals_1(thisChar, otherChar, ignoreCase)) return false;
        }while (inductionVariable < last);
        return true;
    }
    function startsWith(_this__u8e3s4, prefix, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        if (!ignoreCase) // Inline function 'kotlin.text.nativeStartsWith' call
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.startsWith(prefix, 0);
        else return regionMatches(_this__u8e3s4, 0, prefix, 0, prefix.length, ignoreCase);
    }
    function regionMatches(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        return regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase);
    }
    function startsWith_0(_this__u8e3s4, prefix, startIndex, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        if (!ignoreCase) // Inline function 'kotlin.text.nativeStartsWith' call
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.startsWith(prefix, startIndex);
        else return regionMatches(_this__u8e3s4, startIndex, prefix, 0, prefix.length, ignoreCase);
    }
    function replace(_this__u8e3s4, oldChar, newChar, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = new RegExp(Companion_getInstance_4().cc(toString(oldChar)), ignoreCase ? "gui" : "gu");
        var replacement = toString(newChar);
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.replace(pattern, replacement);
    }
    function endsWith(_this__u8e3s4, suffix, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        if (!ignoreCase) // Inline function 'kotlin.text.nativeEndsWith' call
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.endsWith(suffix);
        else return regionMatches(_this__u8e3s4, _this__u8e3s4.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
    }
    function get_REPLACEMENT_BYTE_SEQUENCE() {
        _init_properties_utf8Encoding_kt__9thjs4();
        return REPLACEMENT_BYTE_SEQUENCE;
    }
    var REPLACEMENT_BYTE_SEQUENCE;
    function encodeUtf8(string, startIndex, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(startIndex >= 0 && endIndex <= string.length && startIndex <= endIndex)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        var bytes = new Int8Array(imul(endIndex - startIndex | 0, 3));
        var byteIndex = 0;
        var charIndex = startIndex;
        while(charIndex < endIndex){
            // Inline function 'kotlin.code' call
            var tmp0 = charIndex;
            charIndex = tmp0 + 1 | 0;
            var this_0 = charSequenceGet(string, tmp0);
            var code = Char__toInt_impl_vasixd(this_0);
            if (code < 128) {
                var tmp1 = byteIndex;
                byteIndex = tmp1 + 1 | 0;
                bytes[tmp1] = toByte(code);
            } else if (code < 2048) {
                var tmp2 = byteIndex;
                byteIndex = tmp2 + 1 | 0;
                bytes[tmp2] = toByte(code >> 6 | 192);
                var tmp3 = byteIndex;
                byteIndex = tmp3 + 1 | 0;
                bytes[tmp3] = toByte(code & 63 | 128);
            } else if (code < 55296 || code >= 57344) {
                var tmp4 = byteIndex;
                byteIndex = tmp4 + 1 | 0;
                bytes[tmp4] = toByte(code >> 12 | 224);
                var tmp5 = byteIndex;
                byteIndex = tmp5 + 1 | 0;
                bytes[tmp5] = toByte(code >> 6 & 63 | 128);
                var tmp6 = byteIndex;
                byteIndex = tmp6 + 1 | 0;
                bytes[tmp6] = toByte(code & 63 | 128);
            } else {
                var codePoint = codePointFromSurrogate(string, code, charIndex, endIndex, throwOnMalformed);
                if (codePoint <= 0) {
                    var tmp7 = byteIndex;
                    byteIndex = tmp7 + 1 | 0;
                    bytes[tmp7] = get_REPLACEMENT_BYTE_SEQUENCE()[0];
                    var tmp8 = byteIndex;
                    byteIndex = tmp8 + 1 | 0;
                    bytes[tmp8] = get_REPLACEMENT_BYTE_SEQUENCE()[1];
                    var tmp9 = byteIndex;
                    byteIndex = tmp9 + 1 | 0;
                    bytes[tmp9] = get_REPLACEMENT_BYTE_SEQUENCE()[2];
                } else {
                    var tmp10 = byteIndex;
                    byteIndex = tmp10 + 1 | 0;
                    bytes[tmp10] = toByte(codePoint >> 18 | 240);
                    var tmp11 = byteIndex;
                    byteIndex = tmp11 + 1 | 0;
                    bytes[tmp11] = toByte(codePoint >> 12 & 63 | 128);
                    var tmp12 = byteIndex;
                    byteIndex = tmp12 + 1 | 0;
                    bytes[tmp12] = toByte(codePoint >> 6 & 63 | 128);
                    var tmp13 = byteIndex;
                    byteIndex = tmp13 + 1 | 0;
                    bytes[tmp13] = toByte(codePoint & 63 | 128);
                    charIndex = charIndex + 1 | 0;
                }
            }
        }
        return bytes.length === byteIndex ? bytes : copyOf_5(bytes, byteIndex);
    }
    function decodeUtf8(bytes, startIndex, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(startIndex >= 0 && endIndex <= bytes.length && startIndex <= endIndex)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        var byteIndex = startIndex;
        var stringBuilder = StringBuilder_init_$Create$_0();
        while(byteIndex < endIndex){
            var tmp0 = byteIndex;
            byteIndex = tmp0 + 1 | 0;
            var byte = bytes[tmp0];
            if (byte >= 0) stringBuilder.f8(numberToChar(byte));
            else if (byte >> 5 === -2) {
                var code = codePointFrom2(bytes, byte, byteIndex, endIndex, throwOnMalformed);
                if (code <= 0) {
                    stringBuilder.f8(_Char___init__impl__6a9atx(65533));
                    byteIndex = byteIndex + (-code | 0) | 0;
                } else {
                    stringBuilder.f8(numberToChar(code));
                    byteIndex = byteIndex + 1 | 0;
                }
            } else if (byte >> 4 === -2) {
                var code_0 = codePointFrom3(bytes, byte, byteIndex, endIndex, throwOnMalformed);
                if (code_0 <= 0) {
                    stringBuilder.f8(_Char___init__impl__6a9atx(65533));
                    byteIndex = byteIndex + (-code_0 | 0) | 0;
                } else {
                    stringBuilder.f8(numberToChar(code_0));
                    byteIndex = byteIndex + 2 | 0;
                }
            } else if (byte >> 3 === -2) {
                var code_1 = codePointFrom4(bytes, byte, byteIndex, endIndex, throwOnMalformed);
                if (code_1 <= 0) {
                    stringBuilder.f8(_Char___init__impl__6a9atx(65533));
                    byteIndex = byteIndex + (-code_1 | 0) | 0;
                } else {
                    var high = (code_1 - 65536 | 0) >> 10 | 55296;
                    var low = code_1 & 1023 | 56320;
                    stringBuilder.f8(numberToChar(high));
                    stringBuilder.f8(numberToChar(low));
                    byteIndex = byteIndex + 3 | 0;
                }
            } else {
                malformed(0, byteIndex, throwOnMalformed);
                stringBuilder.f8(_Char___init__impl__6a9atx(65533));
            }
        }
        return stringBuilder.toString();
    }
    function codePointFromSurrogate(string, high, index, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        if (!(55296 <= high ? high <= 56319 : false) || index >= endIndex) return malformed(0, index, throwOnMalformed);
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(string, index);
        var low = Char__toInt_impl_vasixd(this_0);
        if (!(56320 <= low ? low <= 57343 : false)) return malformed(0, index, throwOnMalformed);
        return 65536 + ((high & 1023) << 10) | 0 | low & 1023;
    }
    function codePointFrom2(bytes, byte1, index, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        if ((byte1 & 30) === 0 || index >= endIndex) return malformed(0, index, throwOnMalformed);
        var byte2 = bytes[index];
        if (!((byte2 & 192) === 128)) return malformed(0, index, throwOnMalformed);
        return byte1 << 6 ^ byte2 ^ 3968;
    }
    function codePointFrom3(bytes, byte1, index, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        if (index >= endIndex) return malformed(0, index, throwOnMalformed);
        var byte2 = bytes[index];
        if ((byte1 & 15) === 0) {
            if (!((byte2 & 224) === 160)) return malformed(0, index, throwOnMalformed);
        } else if ((byte1 & 15) === 13) {
            if (!((byte2 & 224) === 128)) return malformed(0, index, throwOnMalformed);
        } else if (!((byte2 & 192) === 128)) return malformed(0, index, throwOnMalformed);
        if ((index + 1 | 0) === endIndex) return malformed(1, index, throwOnMalformed);
        var byte3 = bytes[index + 1 | 0];
        if (!((byte3 & 192) === 128)) return malformed(1, index, throwOnMalformed);
        return byte1 << 12 ^ byte2 << 6 ^ byte3 ^ -123008;
    }
    function codePointFrom4(bytes, byte1, index, endIndex, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        if (index >= endIndex) malformed(0, index, throwOnMalformed);
        var byte2 = bytes[index];
        if ((byte1 & 15) === 0) {
            if ((byte2 & 240) <= 128) return malformed(0, index, throwOnMalformed);
        } else if ((byte1 & 15) === 4) {
            if (!((byte2 & 240) === 128)) return malformed(0, index, throwOnMalformed);
        } else if ((byte1 & 15) > 4) return malformed(0, index, throwOnMalformed);
        else if (!((byte2 & 192) === 128)) return malformed(0, index, throwOnMalformed);
        if ((index + 1 | 0) === endIndex) return malformed(1, index, throwOnMalformed);
        var byte3 = bytes[index + 1 | 0];
        if (!((byte3 & 192) === 128)) return malformed(1, index, throwOnMalformed);
        if ((index + 2 | 0) === endIndex) return malformed(2, index, throwOnMalformed);
        var byte4 = bytes[index + 2 | 0];
        if (!((byte4 & 192) === 128)) return malformed(2, index, throwOnMalformed);
        return byte1 << 18 ^ byte2 << 12 ^ byte3 << 6 ^ byte4 ^ 3678080;
    }
    function malformed(size, index, throwOnMalformed) {
        _init_properties_utf8Encoding_kt__9thjs4();
        if (throwOnMalformed) throw new CharacterCodingException("Malformed sequence starting at " + (index - 1 | 0));
        return -size | 0;
    }
    var properties_initialized_utf8Encoding_kt_eee1vq;
    function _init_properties_utf8Encoding_kt__9thjs4() {
        if (!properties_initialized_utf8Encoding_kt_eee1vq) {
            properties_initialized_utf8Encoding_kt_eee1vq = true;
            // Inline function 'kotlin.byteArrayOf' call
            REPLACEMENT_BYTE_SEQUENCE = new Int8Array([
                -17,
                -65,
                -67
            ]);
        }
    }
    function addSuppressed(_this__u8e3s4, exception) {
        if (!(_this__u8e3s4 === exception)) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var suppressed = _this__u8e3s4._suppressed;
            if (suppressed == null) // Inline function 'kotlin.js.asDynamic' call
            _this__u8e3s4._suppressed = mutableListOf([
                exception
            ]);
            else suppressed.e(exception);
        }
    }
    function printStackTrace(_this__u8e3s4) {
        console.error(stackTraceToString(_this__u8e3s4));
    }
    function stackTraceToString(_this__u8e3s4) {
        return new ExceptionTraceBuilder().gd(_this__u8e3s4);
    }
    function hasSeen($this, exception) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.any' call
            var indexedObject = $this.dd_1;
            var inductionVariable = 0;
            var last = indexedObject.length;
            while(inductionVariable < last){
                var element = indexedObject[inductionVariable];
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.ExceptionTraceBuilder.hasSeen.<anonymous>' call
                if (element === exception) {
                    tmp$ret$1 = true;
                    break $l$block;
                }
            }
            tmp$ret$1 = false;
        }
        return tmp$ret$1;
    }
    function dumpFullTrace(_this__u8e3s4, $this, indent, qualifier) {
        if (dumpSelfTrace(_this__u8e3s4, $this, indent, qualifier)) ;
        else return Unit_instance;
        var cause = _this__u8e3s4.cause;
        while(!(cause == null)){
            if (dumpSelfTrace(cause, $this, indent, "Caused by: ")) ;
            else return Unit_instance;
            cause = cause.cause;
        }
    }
    function dumpSelfTrace(_this__u8e3s4, $this, indent, qualifier) {
        $this.cd_1.e8(indent).e8(qualifier);
        var shortInfo = _this__u8e3s4.toString();
        if (hasSeen($this, _this__u8e3s4)) {
            $this.cd_1.e8("[CIRCULAR REFERENCE, SEE ABOVE: ").e8(shortInfo).e8("]\n");
            return false;
        }
        // Inline function 'kotlin.js.asDynamic' call
        $this.dd_1.push(_this__u8e3s4);
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = _this__u8e3s4.stack;
        var stack = (tmp == null ? true : typeof tmp === "string") ? tmp : THROW_CCE();
        if (!(stack == null)) {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
            var it = indexOf_5(stack, shortInfo);
            var stackStart = it < 0 ? 0 : it + shortInfo.length | 0;
            if (stackStart === 0) $this.cd_1.e8(shortInfo).e8("\n");
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = $this.ed_1;
            if (charSequenceLength(this_0) === 0) {
                $this.ed_1 = stack;
                $this.fd_1 = stackStart;
            } else stack = dropCommonFrames($this, stack, stackStart);
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(indent) > 0) {
                var tmp_0;
                if (stackStart === 0) tmp_0 = 0;
                else {
                    // Inline function 'kotlin.text.count' call
                    var count = 0;
                    var inductionVariable = 0;
                    while(inductionVariable < charSequenceLength(shortInfo)){
                        var element = charSequenceGet(shortInfo, inductionVariable);
                        inductionVariable = inductionVariable + 1 | 0;
                        // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
                        if (element === _Char___init__impl__6a9atx(10)) count = count + 1 | 0;
                    }
                    tmp_0 = 1 + count | 0;
                }
                var messageLines = tmp_0;
                // Inline function 'kotlin.sequences.forEachIndexed' call
                var index = 0;
                var tmp0_iterator = lineSequence(stack).j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'kotlin.ExceptionTraceBuilder.dumpSelfTrace.<anonymous>' call
                    var tmp1 = index;
                    index = tmp1 + 1 | 0;
                    if (checkIndexOverflow(tmp1) >= messageLines) $this.cd_1.e8(indent);
                    $this.cd_1.e8(item).e8("\n");
                }
            } else $this.cd_1.e8(stack).e8("\n");
        } else $this.cd_1.e8(shortInfo).e8("\n");
        var suppressed = get_suppressedExceptions(_this__u8e3s4);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!suppressed.s()) {
            var suppressedIndent = indent + "    ";
            var tmp0_iterator_0 = suppressed.j();
            while(tmp0_iterator_0.k()){
                var s = tmp0_iterator_0.l();
                dumpFullTrace(s, $this, suppressedIndent, "Suppressed: ");
            }
        }
        return true;
    }
    function dropCommonFrames($this, stack, stackStart) {
        var commonFrames = 0;
        var lastBreak = 0;
        var preLastBreak = 0;
        var inductionVariable = 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var a = $this.ed_1.length - $this.fd_1 | 0;
        var b = stack.length - stackStart | 0;
        var last = Math.min(a, b);
        if (inductionVariable < last) $l$loop: do {
            var pos = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var c = charSequenceGet(stack, get_lastIndex_3(stack) - pos | 0);
            if (!(c === charSequenceGet($this.ed_1, get_lastIndex_3($this.ed_1) - pos | 0))) break $l$loop;
            if (c === _Char___init__impl__6a9atx(10)) {
                commonFrames = commonFrames + 1 | 0;
                preLastBreak = lastBreak;
                lastBreak = pos;
            }
        }while (inductionVariable < last);
        if (commonFrames <= 1) return stack;
        while(preLastBreak > 0 && charSequenceGet(stack, get_lastIndex_3(stack) - (preLastBreak - 1 | 0) | 0) === _Char___init__impl__6a9atx(32))preLastBreak = preLastBreak - 1 | 0;
        return dropLast_0(stack, preLastBreak) + ("... and " + (commonFrames - 1 | 0) + " more common stack frames skipped");
    }
    function ExceptionTraceBuilder() {
        this.cd_1 = StringBuilder_init_$Create$_0();
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.dd_1 = [];
        this.ed_1 = "";
        this.fd_1 = 0;
    }
    protoOf(ExceptionTraceBuilder).gd = function(exception) {
        dumpFullTrace(exception, this, "", "");
        return this.cd_1.toString();
    };
    function get_suppressedExceptions(_this__u8e3s4) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = _this__u8e3s4._suppressed;
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.js.unsafeCast' call
        tmp = tmp0_safe_receiver;
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    }
    var DurationUnit_NANOSECONDS_instance;
    var DurationUnit_MICROSECONDS_instance;
    var DurationUnit_MILLISECONDS_instance;
    var DurationUnit_SECONDS_instance;
    var DurationUnit_MINUTES_instance;
    var DurationUnit_HOURS_instance;
    var DurationUnit_DAYS_instance;
    var DurationUnit_entriesInitialized;
    function DurationUnit_initEntries() {
        if (DurationUnit_entriesInitialized) return Unit_instance;
        DurationUnit_entriesInitialized = true;
        DurationUnit_NANOSECONDS_instance = new DurationUnit("NANOSECONDS", 0, 1.0);
        DurationUnit_MICROSECONDS_instance = new DurationUnit("MICROSECONDS", 1, 1000.0);
        DurationUnit_MILLISECONDS_instance = new DurationUnit("MILLISECONDS", 2, 1000000.0);
        DurationUnit_SECONDS_instance = new DurationUnit("SECONDS", 3, 1.0E9);
        DurationUnit_MINUTES_instance = new DurationUnit("MINUTES", 4, 6.0E10);
        DurationUnit_HOURS_instance = new DurationUnit("HOURS", 5, 3.6E12);
        DurationUnit_DAYS_instance = new DurationUnit("DAYS", 6, 8.64E13);
    }
    function DurationUnit(name, ordinal, scale) {
        Enum.call(this, name, ordinal);
        this.jd_1 = scale;
    }
    function convertDurationUnit(value, sourceUnit, targetUnit) {
        var sourceCompareTarget = compareTo(sourceUnit.jd_1, targetUnit.jd_1);
        return sourceCompareTarget > 0 ? value * (sourceUnit.jd_1 / targetUnit.jd_1) : sourceCompareTarget < 0 ? value / (targetUnit.jd_1 / sourceUnit.jd_1) : value;
    }
    function convertDurationUnit_0(value, sourceUnit, targetUnit) {
        var sourceCompareTarget = compareTo(sourceUnit.jd_1, targetUnit.jd_1);
        var tmp;
        if (sourceCompareTarget > 0) {
            var scale = numberToLong(sourceUnit.jd_1 / targetUnit.jd_1);
            var result = value.a3(scale);
            tmp = result.b3(scale).equals(value) ? result : value.j1(new Long(0, 0)) > 0 ? new Long(-1, 2147483647) : new Long(0, -2147483648);
        } else if (sourceCompareTarget < 0) tmp = value.b3(numberToLong(targetUnit.jd_1 / sourceUnit.jd_1));
        else tmp = value;
        return tmp;
    }
    function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
        var sourceCompareTarget = compareTo(sourceUnit.jd_1, targetUnit.jd_1);
        return sourceCompareTarget > 0 ? value.a3(numberToLong(sourceUnit.jd_1 / targetUnit.jd_1)) : sourceCompareTarget < 0 ? value.b3(numberToLong(targetUnit.jd_1 / sourceUnit.jd_1)) : value;
    }
    function DurationUnit_NANOSECONDS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_NANOSECONDS_instance;
    }
    function DurationUnit_MICROSECONDS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_MICROSECONDS_instance;
    }
    function DurationUnit_MILLISECONDS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_MILLISECONDS_instance;
    }
    function DurationUnit_SECONDS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_SECONDS_instance;
    }
    function DurationUnit_MINUTES_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_MINUTES_instance;
    }
    function DurationUnit_HOURS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_HOURS_instance;
    }
    function DurationUnit_DAYS_getInstance() {
        DurationUnit_initEntries();
        return DurationUnit_DAYS_instance;
    }
    function AbstractCollection$toString$lambda(this$0) {
        return function(it) {
            return it === this$0 ? "(this Collection)" : toString_0(it);
        };
    }
    function AbstractCollection() {}
    protoOf(AbstractCollection).a2 = function(element) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(this, Collection)) tmp = this.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = false;
                break $l$block_0;
            }
            var tmp0_iterator = this.j();
            while(tmp0_iterator.k()){
                var element_0 = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractCollection.contains.<anonymous>' call
                if (equals(element_0, element)) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = false;
        }
        return tmp$ret$0;
    };
    protoOf(AbstractCollection).b2 = function(elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(elements, Collection)) tmp = elements.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = elements.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractCollection.containsAll.<anonymous>' call
                if (!this.a2(element)) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(AbstractCollection).s = function() {
        return this.m() === 0;
    };
    protoOf(AbstractCollection).toString = function() {
        return joinToString_0(this, ", ", "[", "]", VOID, VOID, AbstractCollection$toString$lambda(this));
    };
    protoOf(AbstractCollection).toArray = function() {
        return collectionToArray(this);
    };
    function SubList_0(list, fromIndex, toIndex) {
        AbstractList.call(this);
        this.kd_1 = list;
        this.ld_1 = fromIndex;
        this.md_1 = 0;
        Companion_instance_5.a4(this.ld_1, toIndex, this.kd_1.m());
        this.md_1 = toIndex - this.ld_1 | 0;
    }
    protoOf(SubList_0).o = function(index) {
        Companion_instance_5.z4(index, this.md_1);
        return this.kd_1.o(this.ld_1 + index | 0);
    };
    protoOf(SubList_0).m = function() {
        return this.md_1;
    };
    function IteratorImpl_0($outer) {
        this.od_1 = $outer;
        this.nd_1 = 0;
    }
    protoOf(IteratorImpl_0).k = function() {
        return this.nd_1 < this.od_1.m();
    };
    protoOf(IteratorImpl_0).l = function() {
        if (!this.k()) throw NoSuchElementException_init_$Create$();
        var tmp1 = this.nd_1;
        this.nd_1 = tmp1 + 1 | 0;
        return this.od_1.o(tmp1);
    };
    function ListIteratorImpl_0($outer, index) {
        this.rd_1 = $outer;
        IteratorImpl_0.call(this, $outer);
        Companion_instance_5.r4(index, this.rd_1.m());
        this.nd_1 = index;
    }
    protoOf(ListIteratorImpl_0).s4 = function() {
        return this.nd_1 > 0;
    };
    protoOf(ListIteratorImpl_0).t4 = function() {
        return this.nd_1;
    };
    protoOf(ListIteratorImpl_0).u4 = function() {
        if (!this.s4()) throw NoSuchElementException_init_$Create$();
        this.nd_1 = this.nd_1 - 1 | 0;
        return this.rd_1.o(this.nd_1);
    };
    function Companion_5() {
        this.z3_1 = 2147483639;
    }
    protoOf(Companion_5).z4 = function(index, size) {
        if (index < 0 || index >= size) throw IndexOutOfBoundsException_init_$Create$_0("index: " + index + ", size: " + size);
    };
    protoOf(Companion_5).r4 = function(index, size) {
        if (index < 0 || index > size) throw IndexOutOfBoundsException_init_$Create$_0("index: " + index + ", size: " + size);
    };
    protoOf(Companion_5).a4 = function(fromIndex, toIndex, size) {
        if (fromIndex < 0 || toIndex > size) throw IndexOutOfBoundsException_init_$Create$_0("fromIndex: " + fromIndex + ", toIndex: " + toIndex + ", size: " + size);
        if (fromIndex > toIndex) throw IllegalArgumentException_init_$Create$_0("fromIndex: " + fromIndex + " > toIndex: " + toIndex);
    };
    protoOf(Companion_5).yb = function(startIndex, endIndex, size) {
        if (startIndex < 0 || endIndex > size) throw IndexOutOfBoundsException_init_$Create$_0("startIndex: " + startIndex + ", endIndex: " + endIndex + ", size: " + size);
        if (startIndex > endIndex) throw IllegalArgumentException_init_$Create$_0("startIndex: " + startIndex + " > endIndex: " + endIndex);
    };
    protoOf(Companion_5).d7 = function(oldCapacity, minCapacity) {
        var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
        if ((newCapacity - minCapacity | 0) < 0) newCapacity = minCapacity;
        if ((newCapacity - 2147483639 | 0) > 0) newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
        return newCapacity;
    };
    protoOf(Companion_5).d5 = function(c) {
        var hashCode_0 = 1;
        var tmp0_iterator = c.j();
        while(tmp0_iterator.k()){
            var e = tmp0_iterator.l();
            var tmp = imul(31, hashCode_0);
            var tmp2_elvis_lhs = e == null ? null : hashCode(e);
            hashCode_0 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
        }
        return hashCode_0;
    };
    protoOf(Companion_5).c5 = function(c, other) {
        if (!(c.m() === other.m())) return false;
        var otherIterator = other.j();
        var tmp0_iterator = c.j();
        while(tmp0_iterator.k()){
            var elem = tmp0_iterator.l();
            var elemOther = otherIterator.l();
            if (!equals(elem, elemOther)) return false;
        }
        return true;
    };
    var Companion_instance_5;
    function Companion_getInstance_5() {
        return Companion_instance_5;
    }
    function AbstractList() {
        AbstractCollection.call(this);
    }
    protoOf(AbstractList).j = function() {
        return new IteratorImpl_0(this);
    };
    protoOf(AbstractList).w = function(index) {
        return new ListIteratorImpl_0(this, index);
    };
    protoOf(AbstractList).v = function(fromIndex, toIndex) {
        return new SubList_0(this, fromIndex, toIndex);
    };
    protoOf(AbstractList).equals = function(other) {
        if (other === this) return true;
        if (!(!(other == null) ? isInterface(other, KtList) : false)) return false;
        return Companion_instance_5.c5(this, other);
    };
    protoOf(AbstractList).hashCode = function() {
        return Companion_instance_5.d5(this);
    };
    function AbstractMap$keys$1$iterator$1($entryIterator) {
        this.sd_1 = $entryIterator;
    }
    protoOf(AbstractMap$keys$1$iterator$1).k = function() {
        return this.sd_1.k();
    };
    protoOf(AbstractMap$keys$1$iterator$1).l = function() {
        return this.sd_1.l().a1();
    };
    function AbstractMap$values$1$iterator$1($entryIterator) {
        this.td_1 = $entryIterator;
    }
    protoOf(AbstractMap$values$1$iterator$1).k = function() {
        return this.td_1.k();
    };
    protoOf(AbstractMap$values$1$iterator$1).l = function() {
        return this.td_1.l().b1();
    };
    function toString_4($this, o) {
        return o === $this ? "(this Map)" : toString_0(o);
    }
    function implFindEntry($this, key) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = $this.z().j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractMap.implFindEntry.<anonymous>' call
                if (equals(element.a1(), key)) {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        return tmp$ret$1;
    }
    function Companion_6() {}
    var Companion_instance_6;
    function Companion_getInstance_6() {
        return Companion_instance_6;
    }
    function AbstractMap$keys$1(this$0) {
        this.ud_1 = this$0;
        AbstractSet.call(this);
    }
    protoOf(AbstractMap$keys$1).y5 = function(element) {
        return this.ud_1.c2(element);
    };
    protoOf(AbstractMap$keys$1).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.y5((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(AbstractMap$keys$1).j = function() {
        var entryIterator = this.ud_1.z().j();
        return new AbstractMap$keys$1$iterator$1(entryIterator);
    };
    protoOf(AbstractMap$keys$1).m = function() {
        return this.ud_1.m();
    };
    function AbstractMap$toString$lambda(this$0) {
        return function(it) {
            return this$0.vd(it);
        };
    }
    function AbstractMap$values$1(this$0) {
        this.wd_1 = this$0;
        AbstractCollection.call(this);
    }
    protoOf(AbstractMap$values$1).d6 = function(element) {
        return this.wd_1.d2(element);
    };
    protoOf(AbstractMap$values$1).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.d6((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(AbstractMap$values$1).j = function() {
        var entryIterator = this.wd_1.z().j();
        return new AbstractMap$values$1$iterator$1(entryIterator);
    };
    protoOf(AbstractMap$values$1).m = function() {
        return this.wd_1.m();
    };
    function AbstractMap() {
        this.k5_1 = null;
        this.l5_1 = null;
    }
    protoOf(AbstractMap).c2 = function(key) {
        return !(implFindEntry(this, key) == null);
    };
    protoOf(AbstractMap).d2 = function(value) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var this_0 = this.z();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = false;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractMap.containsValue.<anonymous>' call
                if (equals(element.b1(), value)) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = false;
        }
        return tmp$ret$0;
    };
    protoOf(AbstractMap).m5 = function(entry) {
        if (!(!(entry == null) ? isInterface(entry, Entry) : false)) return false;
        var key = entry.a1();
        var value = entry.b1();
        // Inline function 'kotlin.collections.get' call
        var ourValue = (isInterface(this, KtMap) ? this : THROW_CCE()).e2(key);
        if (!equals(value, ourValue)) return false;
        var tmp;
        if (ourValue == null) // Inline function 'kotlin.collections.containsKey' call
        tmp = !(isInterface(this, KtMap) ? this : THROW_CCE()).c2(key);
        else tmp = false;
        if (tmp) return false;
        return true;
    };
    protoOf(AbstractMap).equals = function(other) {
        if (other === this) return true;
        if (!(!(other == null) ? isInterface(other, KtMap) : false)) return false;
        if (!(this.m() === other.m())) return false;
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var this_0 = other.z();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.AbstractMap.equals.<anonymous>' call
                if (!this.m5(element)) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(AbstractMap).e2 = function(key) {
        var tmp0_safe_receiver = implFindEntry(this, key);
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1();
    };
    protoOf(AbstractMap).hashCode = function() {
        return hashCode(this.z());
    };
    protoOf(AbstractMap).s = function() {
        return this.m() === 0;
    };
    protoOf(AbstractMap).m = function() {
        return this.z().m();
    };
    protoOf(AbstractMap).f2 = function() {
        if (this.k5_1 == null) {
            var tmp = this;
            tmp.k5_1 = new AbstractMap$keys$1(this);
        }
        return ensureNotNull(this.k5_1);
    };
    protoOf(AbstractMap).toString = function() {
        var tmp = this.z();
        return joinToString_0(tmp, ", ", "{", "}", VOID, VOID, AbstractMap$toString$lambda(this));
    };
    protoOf(AbstractMap).vd = function(entry) {
        return toString_4(this, entry.a1()) + "=" + toString_4(this, entry.b1());
    };
    protoOf(AbstractMap).g2 = function() {
        if (this.l5_1 == null) {
            var tmp = this;
            tmp.l5_1 = new AbstractMap$values$1(this);
        }
        return ensureNotNull(this.l5_1);
    };
    function Companion_7() {}
    protoOf(Companion_7).o5 = function(c) {
        var hashCode_0 = 0;
        var tmp0_iterator = c.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            var tmp = hashCode_0;
            var tmp2_elvis_lhs = element == null ? null : hashCode(element);
            hashCode_0 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
        }
        return hashCode_0;
    };
    protoOf(Companion_7).n5 = function(c, other) {
        if (!(c.m() === other.m())) return false;
        // Inline function 'kotlin.collections.containsAll' call
        return c.b2(other);
    };
    var Companion_instance_7;
    function Companion_getInstance_7() {
        return Companion_instance_7;
    }
    function AbstractSet() {
        AbstractCollection.call(this);
    }
    protoOf(AbstractSet).equals = function(other) {
        if (other === this) return true;
        if (!(!(other == null) ? isInterface(other, KtSet) : false)) return false;
        return Companion_instance_7.n5(this, other);
    };
    protoOf(AbstractSet).hashCode = function() {
        return Companion_instance_7.o5(this);
    };
    function ArrayDeque_init_$Init$($this) {
        AbstractMutableList.call($this);
        ArrayDeque.call($this);
        $this.zd_1 = Companion_getInstance_8().be_1;
        return $this;
    }
    function ArrayDeque_init_$Create$() {
        return ArrayDeque_init_$Init$(objectCreate(protoOf(ArrayDeque)));
    }
    function ensureCapacity_0($this, minCapacity) {
        if (minCapacity < 0) throw IllegalStateException_init_$Create$_0("Deque is too big.");
        if (minCapacity <= $this.zd_1.length) return Unit_instance;
        if ($this.zd_1 === Companion_getInstance_8().be_1) {
            var tmp = $this;
            // Inline function 'kotlin.arrayOfNulls' call
            var size = coerceAtLeast(minCapacity, 10);
            tmp.zd_1 = fillArrayVal(Array(size), null);
            return Unit_instance;
        }
        var newCapacity = Companion_instance_5.d7($this.zd_1.length, minCapacity);
        copyElements($this, newCapacity);
    }
    function copyElements($this, newCapacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var newElements = fillArrayVal(Array(newCapacity), null);
        // Inline function 'kotlin.collections.copyInto' call
        var this_0 = $this.zd_1;
        var startIndex = $this.yd_1;
        var endIndex = $this.zd_1.length;
        arrayCopy(this_0, newElements, 0, startIndex, endIndex);
        // Inline function 'kotlin.collections.copyInto' call
        var this_1 = $this.zd_1;
        var destinationOffset = $this.zd_1.length - $this.yd_1 | 0;
        var endIndex_0 = $this.yd_1;
        arrayCopy(this_1, newElements, destinationOffset, 0, endIndex_0);
        $this.yd_1 = 0;
        $this.zd_1 = newElements;
    }
    function positiveMod($this, index) {
        return index >= $this.zd_1.length ? index - $this.zd_1.length | 0 : index;
    }
    function negativeMod($this, index) {
        return index < 0 ? index + $this.zd_1.length | 0 : index;
    }
    function incremented($this, index) {
        return index === get_lastIndex($this.zd_1) ? 0 : index + 1 | 0;
    }
    function decremented($this, index) {
        return index === 0 ? get_lastIndex($this.zd_1) : index - 1 | 0;
    }
    function copyCollectionElements($this, internalIndex, elements) {
        var iterator = elements.j();
        var inductionVariable = internalIndex;
        var last = $this.zd_1.length;
        if (inductionVariable < last) $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!iterator.k()) break $l$loop;
            $this.zd_1[index] = iterator.l();
        }while (inductionVariable < last);
        var inductionVariable_0 = 0;
        var last_0 = $this.yd_1;
        if (inductionVariable_0 < last_0) $l$loop_0: do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!iterator.k()) break $l$loop_0;
            $this.zd_1[index_0] = iterator.l();
        }while (inductionVariable_0 < last_0);
        $this.ae_1 = $this.ae_1 + elements.m() | 0;
    }
    function removeRangeShiftPreceding($this, fromIndex, toIndex) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = fromIndex - 1 | 0;
        var copyFromIndex = positiveMod($this, $this.yd_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index_0 = toIndex - 1 | 0;
        var copyToIndex = positiveMod($this, $this.yd_1 + index_0 | 0);
        var copyCount = fromIndex;
        while(copyCount > 0){
            // Inline function 'kotlin.comparisons.minOf' call
            var a = copyCount;
            var b = copyFromIndex + 1 | 0;
            var c = copyToIndex + 1 | 0;
            var segmentLength = Math.min(a, b, c);
            // Inline function 'kotlin.collections.copyInto' call
            var this_0 = $this.zd_1;
            var destination = $this.zd_1;
            var destinationOffset = (copyToIndex - segmentLength | 0) + 1 | 0;
            var startIndex = (copyFromIndex - segmentLength | 0) + 1 | 0;
            var endIndex = copyFromIndex + 1 | 0;
            arrayCopy(this_0, destination, destinationOffset, startIndex, endIndex);
            copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
            copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
            copyCount = copyCount - segmentLength | 0;
        }
    }
    function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var copyFromIndex = positiveMod($this, $this.yd_1 + toIndex | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var copyToIndex = positiveMod($this, $this.yd_1 + fromIndex | 0);
        var copyCount = $this.ae_1 - toIndex | 0;
        while(copyCount > 0){
            // Inline function 'kotlin.comparisons.minOf' call
            var a = copyCount;
            var b = $this.zd_1.length - copyFromIndex | 0;
            var c = $this.zd_1.length - copyToIndex | 0;
            var segmentLength = Math.min(a, b, c);
            // Inline function 'kotlin.collections.copyInto' call
            var this_0 = $this.zd_1;
            var destination = $this.zd_1;
            var destinationOffset = copyToIndex;
            var startIndex = copyFromIndex;
            var endIndex = copyFromIndex + segmentLength | 0;
            arrayCopy(this_0, destination, destinationOffset, startIndex, endIndex);
            copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
            copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
            copyCount = copyCount - segmentLength | 0;
        }
    }
    function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
        if (internalFromIndex < internalToIndex) fill_0($this.zd_1, null, internalFromIndex, internalToIndex);
        else {
            fill_0($this.zd_1, null, internalFromIndex, $this.zd_1.length);
            fill_0($this.zd_1, null, 0, internalToIndex);
        }
    }
    function registerModification_0($this) {
        $this.m4_1 = $this.m4_1 + 1 | 0;
    }
    function Companion_8() {
        Companion_instance_8 = this;
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.be_1 = [];
        this.ce_1 = 10;
    }
    var Companion_instance_8;
    function Companion_getInstance_8() {
        if (Companion_instance_8 == null) new Companion_8();
        return Companion_instance_8;
    }
    protoOf(ArrayDeque).m = function() {
        return this.ae_1;
    };
    protoOf(ArrayDeque).s = function() {
        return this.ae_1 === 0;
    };
    protoOf(ArrayDeque).de = function(element) {
        registerModification_0(this);
        ensureCapacity_0(this, this.ae_1 + 1 | 0);
        this.yd_1 = decremented(this, this.yd_1);
        this.zd_1[this.yd_1] = element;
        this.ae_1 = this.ae_1 + 1 | 0;
    };
    protoOf(ArrayDeque).ee = function(element) {
        registerModification_0(this);
        ensureCapacity_0(this, this.ae_1 + 1 | 0);
        var tmp = this.zd_1;
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.ae_1;
        tmp[positiveMod(this, this.yd_1 + index | 0)] = element;
        this.ae_1 = this.ae_1 + 1 | 0;
    };
    protoOf(ArrayDeque).fe = function() {
        if (this.s()) throw NoSuchElementException_init_$Create$_0("ArrayDeque is empty.");
        registerModification_0(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var internalIndex = this.yd_1;
        var tmp = this.zd_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.zd_1[this.yd_1] = null;
        this.yd_1 = incremented(this, this.yd_1);
        this.ae_1 = this.ae_1 - 1 | 0;
        return element;
    };
    protoOf(ArrayDeque).ge = function() {
        return this.s() ? null : this.fe();
    };
    protoOf(ArrayDeque).he = function() {
        if (this.s()) throw NoSuchElementException_init_$Create$_0("ArrayDeque is empty.");
        registerModification_0(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = get_lastIndex_2(this);
        var internalLastIndex = positiveMod(this, this.yd_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.zd_1[internalLastIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.zd_1[internalLastIndex] = null;
        this.ae_1 = this.ae_1 - 1 | 0;
        return element;
    };
    protoOf(ArrayDeque).e = function(element) {
        this.ee(element);
        return true;
    };
    protoOf(ArrayDeque).k2 = function(index, element) {
        Companion_instance_5.r4(index, this.ae_1);
        if (index === this.ae_1) {
            this.ee(element);
            return Unit_instance;
        } else if (index === 0) {
            this.de(element);
            return Unit_instance;
        }
        registerModification_0(this);
        ensureCapacity_0(this, this.ae_1 + 1 | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.yd_1 + index | 0);
        if (index < (this.ae_1 + 1 | 0) >> 1) {
            var decrementedInternalIndex = decremented(this, internalIndex);
            var decrementedHead = decremented(this, this.yd_1);
            if (decrementedInternalIndex >= this.yd_1) {
                this.zd_1[decrementedHead] = this.zd_1[this.yd_1];
                // Inline function 'kotlin.collections.copyInto' call
                var this_0 = this.zd_1;
                var destination = this.zd_1;
                var destinationOffset = this.yd_1;
                var startIndex = this.yd_1 + 1 | 0;
                var endIndex = decrementedInternalIndex + 1 | 0;
                arrayCopy(this_0, destination, destinationOffset, startIndex, endIndex);
            } else {
                // Inline function 'kotlin.collections.copyInto' call
                var this_1 = this.zd_1;
                var destination_0 = this.zd_1;
                var destinationOffset_0 = this.yd_1 - 1 | 0;
                var startIndex_0 = this.yd_1;
                var endIndex_0 = this.zd_1.length;
                arrayCopy(this_1, destination_0, destinationOffset_0, startIndex_0, endIndex_0);
                this.zd_1[this.zd_1.length - 1 | 0] = this.zd_1[0];
                // Inline function 'kotlin.collections.copyInto' call
                var this_2 = this.zd_1;
                var destination_1 = this.zd_1;
                var endIndex_1 = decrementedInternalIndex + 1 | 0;
                arrayCopy(this_2, destination_1, 0, 1, endIndex_1);
            }
            this.zd_1[decrementedInternalIndex] = element;
            this.yd_1 = decrementedHead;
        } else {
            // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
            var index_0 = this.ae_1;
            var tail = positiveMod(this, this.yd_1 + index_0 | 0);
            if (internalIndex < tail) {
                // Inline function 'kotlin.collections.copyInto' call
                var this_3 = this.zd_1;
                var destination_2 = this.zd_1;
                var destinationOffset_1 = internalIndex + 1 | 0;
                arrayCopy(this_3, destination_2, destinationOffset_1, internalIndex, tail);
            } else {
                // Inline function 'kotlin.collections.copyInto' call
                var this_4 = this.zd_1;
                var destination_3 = this.zd_1;
                arrayCopy(this_4, destination_3, 1, 0, tail);
                this.zd_1[0] = this.zd_1[this.zd_1.length - 1 | 0];
                // Inline function 'kotlin.collections.copyInto' call
                var this_5 = this.zd_1;
                var destination_4 = this.zd_1;
                var destinationOffset_2 = internalIndex + 1 | 0;
                var endIndex_2 = this.zd_1.length - 1 | 0;
                arrayCopy(this_5, destination_4, destinationOffset_2, internalIndex, endIndex_2);
            }
            this.zd_1[internalIndex] = element;
        }
        this.ae_1 = this.ae_1 + 1 | 0;
    };
    protoOf(ArrayDeque).n = function(elements) {
        if (elements.s()) return false;
        registerModification_0(this);
        ensureCapacity_0(this, this.ae_1 + elements.m() | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.ae_1;
        var tmp$ret$0 = positiveMod(this, this.yd_1 + index | 0);
        copyCollectionElements(this, tmp$ret$0, elements);
        return true;
    };
    protoOf(ArrayDeque).o = function(index) {
        Companion_instance_5.z4(index, this.ae_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.yd_1 + index | 0);
        var tmp = this.zd_1[internalIndex];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(ArrayDeque).j2 = function(index, element) {
        Companion_instance_5.z4(index, this.ae_1);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.yd_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.zd_1[internalIndex];
        var oldElement = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.zd_1[internalIndex] = element;
        return oldElement;
    };
    protoOf(ArrayDeque).a2 = function(element) {
        return !(this.b5(element) === -1);
    };
    protoOf(ArrayDeque).b5 = function(element) {
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.ae_1;
        var tail = positiveMod(this, this.yd_1 + index | 0);
        if (this.yd_1 < tail) {
            var inductionVariable = this.yd_1;
            if (inductionVariable < tail) do {
                var index_0 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (equals(element, this.zd_1[index_0])) return index_0 - this.yd_1 | 0;
            }while (inductionVariable < tail);
        } else if (this.yd_1 >= tail) {
            var inductionVariable_0 = this.yd_1;
            var last = this.zd_1.length;
            if (inductionVariable_0 < last) do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                if (equals(element, this.zd_1[index_1])) return index_1 - this.yd_1 | 0;
            }while (inductionVariable_0 < last);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < tail) do {
                var index_2 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                if (equals(element, this.zd_1[index_2])) return (index_2 + this.zd_1.length | 0) - this.yd_1 | 0;
            }while (inductionVariable_1 < tail);
        }
        return -1;
    };
    protoOf(ArrayDeque).l2 = function(index) {
        Companion_instance_5.z4(index, this.ae_1);
        if (index === get_lastIndex_2(this)) return this.he();
        else if (index === 0) return this.fe();
        registerModification_0(this);
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var internalIndex = positiveMod(this, this.yd_1 + index | 0);
        // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
        var tmp = this.zd_1[internalIndex];
        var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        if (index < this.ae_1 >> 1) {
            if (internalIndex >= this.yd_1) {
                // Inline function 'kotlin.collections.copyInto' call
                var this_0 = this.zd_1;
                var destination = this.zd_1;
                var destinationOffset = this.yd_1 + 1 | 0;
                var startIndex = this.yd_1;
                arrayCopy(this_0, destination, destinationOffset, startIndex, internalIndex);
            } else {
                // Inline function 'kotlin.collections.copyInto' call
                var this_1 = this.zd_1;
                var destination_0 = this.zd_1;
                arrayCopy(this_1, destination_0, 1, 0, internalIndex);
                this.zd_1[0] = this.zd_1[this.zd_1.length - 1 | 0];
                // Inline function 'kotlin.collections.copyInto' call
                var this_2 = this.zd_1;
                var destination_1 = this.zd_1;
                var destinationOffset_0 = this.yd_1 + 1 | 0;
                var startIndex_0 = this.yd_1;
                var endIndex = this.zd_1.length - 1 | 0;
                arrayCopy(this_2, destination_1, destinationOffset_0, startIndex_0, endIndex);
            }
            this.zd_1[this.yd_1] = null;
            this.yd_1 = incremented(this, this.yd_1);
        } else {
            // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
            var index_0 = get_lastIndex_2(this);
            var internalLastIndex = positiveMod(this, this.yd_1 + index_0 | 0);
            if (internalIndex <= internalLastIndex) {
                // Inline function 'kotlin.collections.copyInto' call
                var this_3 = this.zd_1;
                var destination_2 = this.zd_1;
                var startIndex_1 = internalIndex + 1 | 0;
                var endIndex_0 = internalLastIndex + 1 | 0;
                arrayCopy(this_3, destination_2, internalIndex, startIndex_1, endIndex_0);
            } else {
                // Inline function 'kotlin.collections.copyInto' call
                var this_4 = this.zd_1;
                var destination_3 = this.zd_1;
                var startIndex_2 = internalIndex + 1 | 0;
                var endIndex_1 = this.zd_1.length;
                arrayCopy(this_4, destination_3, internalIndex, startIndex_2, endIndex_1);
                this.zd_1[this.zd_1.length - 1 | 0] = this.zd_1[0];
                // Inline function 'kotlin.collections.copyInto' call
                var this_5 = this.zd_1;
                var destination_4 = this.zd_1;
                var endIndex_2 = internalLastIndex + 1 | 0;
                arrayCopy(this_5, destination_4, 0, 1, endIndex_2);
            }
            this.zd_1[internalLastIndex] = null;
        }
        this.ae_1 = this.ae_1 - 1 | 0;
        return element;
    };
    protoOf(ArrayDeque).h2 = function(elements) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
            var tmp;
            if (this.s()) tmp = true;
            else // Inline function 'kotlin.collections.isEmpty' call
            tmp = this.zd_1.length === 0;
            if (tmp) {
                tmp$ret$1 = false;
                break $l$block;
            }
            // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
            var index = this.ae_1;
            var tail = positiveMod(this, this.yd_1 + index | 0);
            var newTail = this.yd_1;
            var modified = false;
            if (this.yd_1 < tail) {
                var inductionVariable = this.yd_1;
                if (inductionVariable < tail) do {
                    var index_0 = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var element = this.zd_1[index_0];
                    // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
                    var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
                    if (elements.a2(it)) {
                        var tmp_0 = this.zd_1;
                        var tmp1 = newTail;
                        newTail = tmp1 + 1 | 0;
                        tmp_0[tmp1] = element;
                    } else modified = true;
                }while (inductionVariable < tail);
                fill_0(this.zd_1, null, newTail, tail);
            } else {
                var inductionVariable_0 = this.yd_1;
                var last = this.zd_1.length;
                if (inductionVariable_0 < last) do {
                    var index_1 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var element_0 = this.zd_1[index_1];
                    this.zd_1[index_1] = null;
                    // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
                    var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
                    if (elements.a2(it_0)) {
                        var tmp_1 = this.zd_1;
                        var tmp3 = newTail;
                        newTail = tmp3 + 1 | 0;
                        tmp_1[tmp3] = element_0;
                    } else modified = true;
                }while (inductionVariable_0 < last);
                newTail = positiveMod(this, newTail);
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < tail) do {
                    var index_2 = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var element_1 = this.zd_1[index_2];
                    this.zd_1[index_2] = null;
                    // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
                    var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
                    if (elements.a2(it_1)) {
                        this.zd_1[newTail] = element_1;
                        newTail = incremented(this, newTail);
                    } else modified = true;
                }while (inductionVariable_1 < tail);
            }
            if (modified) {
                registerModification_0(this);
                this.ae_1 = negativeMod(this, newTail - this.yd_1 | 0);
            }
            tmp$ret$1 = modified;
        }
        return tmp$ret$1;
    };
    protoOf(ArrayDeque).i2 = function() {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.s()) {
            registerModification_0(this);
            // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
            var index = this.ae_1;
            var tail = positiveMod(this, this.yd_1 + index | 0);
            nullifyNonEmpty(this, this.yd_1, tail);
        }
        this.yd_1 = 0;
        this.ae_1 = 0;
    };
    protoOf(ArrayDeque).ie = function(array) {
        var tmp = array.length >= this.ae_1 ? array : arrayOfNulls(array, this.ae_1);
        var dest = isArray(tmp) ? tmp : THROW_CCE();
        // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
        var index = this.ae_1;
        var tail = positiveMod(this, this.yd_1 + index | 0);
        if (this.yd_1 < tail) {
            // Inline function 'kotlin.collections.copyInto' call
            var this_0 = this.zd_1;
            var startIndex = this.yd_1;
            arrayCopy(this_0, dest, 0, startIndex, tail);
        } else // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.s()) {
            // Inline function 'kotlin.collections.copyInto' call
            var this_1 = this.zd_1;
            var startIndex_0 = this.yd_1;
            var endIndex = this.zd_1.length;
            arrayCopy(this_1, dest, 0, startIndex_0, endIndex);
            // Inline function 'kotlin.collections.copyInto' call
            var this_2 = this.zd_1;
            var destinationOffset = this.zd_1.length - this.yd_1 | 0;
            arrayCopy(this_2, dest, destinationOffset, 0, tail);
        }
        var tmp_0 = terminateCollectionToArray(this.ae_1, dest);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
    };
    protoOf(ArrayDeque).r5 = function() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.ae_1;
        var tmp$ret$0 = fillArrayVal(Array(size), null);
        return this.ie(tmp$ret$0);
    };
    protoOf(ArrayDeque).toArray = function() {
        return this.r5();
    };
    protoOf(ArrayDeque).a5 = function(fromIndex, toIndex) {
        Companion_instance_5.a4(fromIndex, toIndex, this.ae_1);
        var length = toIndex - fromIndex | 0;
        if (length === 0) return Unit_instance;
        else if (length === this.ae_1) {
            this.i2();
            return Unit_instance;
        } else if (length === 1) {
            this.l2(fromIndex);
            return Unit_instance;
        }
        registerModification_0(this);
        if (fromIndex < (this.ae_1 - toIndex | 0)) {
            removeRangeShiftPreceding(this, fromIndex, toIndex);
            var newHead = positiveMod(this, this.yd_1 + length | 0);
            nullifyNonEmpty(this, this.yd_1, newHead);
            this.yd_1 = newHead;
        } else {
            removeRangeShiftSucceeding(this, fromIndex, toIndex);
            // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
            var index = this.ae_1;
            var tail = positiveMod(this, this.yd_1 + index | 0);
            nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
        }
        this.ae_1 = this.ae_1 - length | 0;
    };
    function ArrayDeque() {
        Companion_getInstance_8();
        this.yd_1 = 0;
        this.ae_1 = 0;
    }
    function collectionToArrayCommonImpl(collection) {
        if (collection.s()) // Inline function 'kotlin.emptyArray' call
        return [];
        // Inline function 'kotlin.arrayOfNulls' call
        var size = collection.m();
        var destination = fillArrayVal(Array(size), null);
        var iterator = collection.j();
        var index = 0;
        while(iterator.k()){
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            destination[tmp0] = iterator.l();
        }
        return destination;
    }
    function emptyList() {
        return EmptyList_getInstance();
    }
    function listOf_0(elements) {
        return elements.length > 0 ? asList(elements) : emptyList();
    }
    function get_lastIndex_2(_this__u8e3s4) {
        return _this__u8e3s4.m() - 1 | 0;
    }
    function EmptyList() {
        EmptyList_instance = this;
        this.je_1 = new Long(-1478467534, -1720727600);
    }
    protoOf(EmptyList).equals = function(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtList) : false) tmp = other.s();
        else tmp = false;
        return tmp;
    };
    protoOf(EmptyList).hashCode = function() {
        return 1;
    };
    protoOf(EmptyList).toString = function() {
        return "[]";
    };
    protoOf(EmptyList).m = function() {
        return 0;
    };
    protoOf(EmptyList).s = function() {
        return true;
    };
    protoOf(EmptyList).ke = function(element) {
        return false;
    };
    protoOf(EmptyList).a2 = function(element) {
        var tmp;
        return false;
    };
    protoOf(EmptyList).le = function(elements) {
        return elements.s();
    };
    protoOf(EmptyList).b2 = function(elements) {
        return this.le(elements);
    };
    protoOf(EmptyList).o = function(index) {
        throw IndexOutOfBoundsException_init_$Create$_0("Empty list doesn't contain element at index " + index + ".");
    };
    protoOf(EmptyList).j = function() {
        return EmptyIterator_instance;
    };
    protoOf(EmptyList).w = function(index) {
        if (!(index === 0)) throw IndexOutOfBoundsException_init_$Create$_0("Index: " + index);
        return EmptyIterator_instance;
    };
    protoOf(EmptyList).v = function(fromIndex, toIndex) {
        if (fromIndex === 0 && toIndex === 0) return this;
        throw IndexOutOfBoundsException_init_$Create$_0("fromIndex: " + fromIndex + ", toIndex: " + toIndex);
    };
    var EmptyList_instance;
    function EmptyList_getInstance() {
        if (EmptyList_instance == null) new EmptyList();
        return EmptyList_instance;
    }
    function EmptyIterator() {}
    protoOf(EmptyIterator).k = function() {
        return false;
    };
    protoOf(EmptyIterator).s4 = function() {
        return false;
    };
    protoOf(EmptyIterator).t4 = function() {
        return 0;
    };
    protoOf(EmptyIterator).l = function() {
        throw NoSuchElementException_init_$Create$();
    };
    protoOf(EmptyIterator).u4 = function() {
        throw NoSuchElementException_init_$Create$();
    };
    var EmptyIterator_instance;
    function EmptyIterator_getInstance() {
        return EmptyIterator_instance;
    }
    function optimizeReadOnlyList(_this__u8e3s4) {
        switch(_this__u8e3s4.m()){
            case 0:
                return emptyList();
            case 1:
                return listOf(_this__u8e3s4.o(0));
            default:
                return _this__u8e3s4;
        }
    }
    function arrayListOf(elements) {
        return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
    }
    function throwIndexOverflow() {
        throw ArithmeticException_init_$Create$_0("Index overflow has happened.");
    }
    function asCollection(_this__u8e3s4) {
        return new ArrayAsCollection(_this__u8e3s4, false);
    }
    function mutableListOf(elements) {
        return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
    }
    function get_indices_1(_this__u8e3s4) {
        return numberRangeToNumber(0, _this__u8e3s4.m() - 1 | 0);
    }
    function ArrayAsCollection(values, isVarargs) {
        this.me_1 = values;
        this.ne_1 = isVarargs;
    }
    protoOf(ArrayAsCollection).m = function() {
        return this.me_1.length;
    };
    protoOf(ArrayAsCollection).s = function() {
        // Inline function 'kotlin.collections.isEmpty' call
        return this.me_1.length === 0;
    };
    protoOf(ArrayAsCollection).oe = function(element) {
        return contains_0(this.me_1, element);
    };
    protoOf(ArrayAsCollection).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.oe((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(ArrayAsCollection).pe = function(elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(elements, Collection)) tmp = elements.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = elements.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.ArrayAsCollection.containsAll.<anonymous>' call
                if (!this.oe(element)) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(ArrayAsCollection).b2 = function(elements) {
        return this.pe(elements);
    };
    protoOf(ArrayAsCollection).j = function() {
        return arrayIterator(this.me_1);
    };
    function IndexedValue(index, value) {
        this.qe_1 = index;
        this.re_1 = value;
    }
    protoOf(IndexedValue).toString = function() {
        return "IndexedValue(index=" + this.qe_1 + ", value=" + toString_0(this.re_1) + ")";
    };
    protoOf(IndexedValue).hashCode = function() {
        var result = this.qe_1;
        result = imul(result, 31) + (this.re_1 == null ? 0 : hashCode(this.re_1)) | 0;
        return result;
    };
    protoOf(IndexedValue).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof IndexedValue)) return false;
        var tmp0_other_with_cast = other instanceof IndexedValue ? other : THROW_CCE();
        if (!(this.qe_1 === tmp0_other_with_cast.qe_1)) return false;
        if (!equals(this.re_1, tmp0_other_with_cast.re_1)) return false;
        return true;
    };
    function collectionSizeOrDefault(_this__u8e3s4, default_0) {
        var tmp;
        if (isInterface(_this__u8e3s4, Collection)) tmp = _this__u8e3s4.m();
        else tmp = default_0;
        return tmp;
    }
    function IndexingIterable(iteratorFactory) {
        this.se_1 = iteratorFactory;
    }
    protoOf(IndexingIterable).j = function() {
        return new IndexingIterator(this.se_1());
    };
    function collectionSizeOrNull(_this__u8e3s4) {
        var tmp;
        if (isInterface(_this__u8e3s4, Collection)) tmp = _this__u8e3s4.m();
        else tmp = null;
        return tmp;
    }
    function flatten(_this__u8e3s4) {
        var result = ArrayList_init_$Create$();
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            addAll(result, element);
        }
        return result;
    }
    function IndexingIterator(iterator) {
        this.te_1 = iterator;
        this.ue_1 = 0;
    }
    protoOf(IndexingIterator).k = function() {
        return this.te_1.k();
    };
    protoOf(IndexingIterator).l = function() {
        var tmp1 = this.ue_1;
        this.ue_1 = tmp1 + 1 | 0;
        return new IndexedValue(checkIndexOverflow(tmp1), this.te_1.l());
    };
    function getOrImplicitDefault(_this__u8e3s4, key) {
        if (isInterface(_this__u8e3s4, MapWithDefault)) return _this__u8e3s4.ve(key);
        var tmp$ret$0;
        $l$block: {
            // Inline function 'kotlin.collections.getOrElseNullable' call
            var value = _this__u8e3s4.e2(key);
            if (value == null && !_this__u8e3s4.c2(key)) throw NoSuchElementException_init_$Create$_0("Key " + toString_0(key) + " is missing in the map.");
            else {
                tmp$ret$0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
                break $l$block;
            }
        }
        return tmp$ret$0;
    }
    function MapWithDefault() {}
    function mapOf_0(pairs) {
        return pairs.length > 0 ? toMap_1(pairs, LinkedHashMap_init_$Create$_0(mapCapacity(pairs.length))) : emptyMap();
    }
    function emptyMap() {
        var tmp = EmptyMap_getInstance();
        return isInterface(tmp, KtMap) ? tmp : THROW_CCE();
    }
    function getValue(_this__u8e3s4, key) {
        return getOrImplicitDefault(_this__u8e3s4, key);
    }
    function toMap(_this__u8e3s4) {
        if (isInterface(_this__u8e3s4, Collection)) {
            var tmp;
            switch(_this__u8e3s4.m()){
                case 0:
                    tmp = emptyMap();
                    break;
                case 1:
                    var tmp_0;
                    if (isInterface(_this__u8e3s4, KtList)) tmp_0 = _this__u8e3s4.o(0);
                    else tmp_0 = _this__u8e3s4.j().l();
                    tmp = mapOf(tmp_0);
                    break;
                default:
                    tmp = toMap_2(_this__u8e3s4, LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.m())));
                    break;
            }
            return tmp;
        }
        return optimizeReadOnlyMap(toMap_2(_this__u8e3s4, LinkedHashMap_init_$Create$()));
    }
    function toMutableMap(_this__u8e3s4) {
        return LinkedHashMap_init_$Create$_1(_this__u8e3s4);
    }
    function toMap_0(_this__u8e3s4) {
        var tmp;
        switch(_this__u8e3s4.m()){
            case 0:
                tmp = emptyMap();
                break;
            case 1:
                // Inline function 'kotlin.collections.toSingletonMap' call
                tmp = toMutableMap(_this__u8e3s4);
                break;
            default:
                tmp = toMutableMap(_this__u8e3s4);
                break;
        }
        return tmp;
    }
    function toMap_1(_this__u8e3s4, destination) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.toMap.<anonymous>' call
        putAll(destination, _this__u8e3s4);
        return destination;
    }
    function EmptyMap() {
        EmptyMap_instance = this;
        this.we_1 = new Long(-888910638, 1920087921);
    }
    protoOf(EmptyMap).equals = function(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtMap) : false) tmp = other.s();
        else tmp = false;
        return tmp;
    };
    protoOf(EmptyMap).hashCode = function() {
        return 0;
    };
    protoOf(EmptyMap).toString = function() {
        return "{}";
    };
    protoOf(EmptyMap).m = function() {
        return 0;
    };
    protoOf(EmptyMap).s = function() {
        return true;
    };
    protoOf(EmptyMap).xe = function(key) {
        return false;
    };
    protoOf(EmptyMap).c2 = function(key) {
        if (!(key == null ? true : !(key == null))) return false;
        return this.xe((key == null ? true : !(key == null)) ? key : THROW_CCE());
    };
    protoOf(EmptyMap).ye = function(key) {
        return null;
    };
    protoOf(EmptyMap).e2 = function(key) {
        if (!(key == null ? true : !(key == null))) return null;
        return this.ye((key == null ? true : !(key == null)) ? key : THROW_CCE());
    };
    protoOf(EmptyMap).z = function() {
        return EmptySet_getInstance();
    };
    protoOf(EmptyMap).f2 = function() {
        return EmptySet_getInstance();
    };
    protoOf(EmptyMap).g2 = function() {
        return EmptyList_getInstance();
    };
    var EmptyMap_instance;
    function EmptyMap_getInstance() {
        if (EmptyMap_instance == null) new EmptyMap();
        return EmptyMap_instance;
    }
    function toMap_2(_this__u8e3s4, destination) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.toMap.<anonymous>' call
        putAll_0(destination, _this__u8e3s4);
        return destination;
    }
    function optimizeReadOnlyMap(_this__u8e3s4) {
        var tmp;
        switch(_this__u8e3s4.m()){
            case 0:
                tmp = emptyMap();
                break;
            case 1:
                // Inline function 'kotlin.collections.toSingletonMapOrSelf' call
                tmp = _this__u8e3s4;
                break;
            default:
                tmp = _this__u8e3s4;
                break;
        }
        return tmp;
    }
    function putAll(_this__u8e3s4, pairs) {
        var inductionVariable = 0;
        var last = pairs.length;
        while(inductionVariable < last){
            var tmp1_loop_parameter = pairs[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var key = tmp1_loop_parameter.ba();
            var value = tmp1_loop_parameter.ca();
            _this__u8e3s4.m2(key, value);
        }
    }
    function putAll_0(_this__u8e3s4, pairs) {
        var tmp0_iterator = pairs.j();
        while(tmp0_iterator.k()){
            var tmp1_loop_parameter = tmp0_iterator.l();
            var key = tmp1_loop_parameter.ba();
            var value = tmp1_loop_parameter.ca();
            _this__u8e3s4.m2(key, value);
        }
    }
    function hashMapOf(pairs) {
        // Inline function 'kotlin.apply' call
        var this_0 = HashMap_init_$Create$_0(mapCapacity(pairs.length));
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.hashMapOf.<anonymous>' call
        putAll(this_0, pairs);
        return this_0;
    }
    function removeFirstOrNull(_this__u8e3s4) {
        return _this__u8e3s4.s() ? null : _this__u8e3s4.l2(0);
    }
    function addAll(_this__u8e3s4, elements) {
        if (isInterface(elements, Collection)) return _this__u8e3s4.n(elements);
        else {
            var result = false;
            var tmp1_iterator = elements.j();
            while(tmp1_iterator.k()){
                var item = tmp1_iterator.l();
                if (_this__u8e3s4.e(item)) result = true;
            }
            return result;
        }
    }
    function retainAll(_this__u8e3s4, elements) {
        return _this__u8e3s4.h2(convertToListIfNotCollection(elements));
    }
    function convertToListIfNotCollection(_this__u8e3s4) {
        var tmp;
        if (isInterface(_this__u8e3s4, Collection)) tmp = _this__u8e3s4;
        else tmp = toList_0(_this__u8e3s4);
        return tmp;
    }
    function removeAll(_this__u8e3s4, predicate) {
        return filterInPlace(_this__u8e3s4, predicate, true);
    }
    function removeAll_0(_this__u8e3s4, predicate) {
        return filterInPlace_0(_this__u8e3s4, predicate, true);
    }
    function filterInPlace(_this__u8e3s4, predicate, predicateResultToRemove) {
        if (!isInterface(_this__u8e3s4, RandomAccess)) return filterInPlace_0(isInterface(_this__u8e3s4, MutableIterable) ? _this__u8e3s4 : THROW_CCE(), predicate, predicateResultToRemove);
        var writeIndex = 0;
        var inductionVariable = 0;
        var last = get_lastIndex_2(_this__u8e3s4);
        if (inductionVariable <= last) $l$loop: do {
            var readIndex = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = _this__u8e3s4.o(readIndex);
            if (predicate(element) === predicateResultToRemove) continue $l$loop;
            if (!(writeIndex === readIndex)) _this__u8e3s4.j2(writeIndex, element);
            writeIndex = writeIndex + 1 | 0;
        }while (!(readIndex === last));
        if (writeIndex < _this__u8e3s4.m()) {
            var inductionVariable_0 = get_lastIndex_2(_this__u8e3s4);
            var last_0 = writeIndex;
            if (last_0 <= inductionVariable_0) do {
                var removeIndex = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + -1 | 0;
                _this__u8e3s4.l2(removeIndex);
            }while (!(removeIndex === last_0));
            return true;
        } else return false;
    }
    function filterInPlace_0(_this__u8e3s4, predicate, predicateResultToRemove) {
        var result = false;
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$with = _this__u8e3s4.j();
        while($this$with.k())if (predicate($this$with.l()) === predicateResultToRemove) {
            $this$with.i4();
            result = true;
        }
        return result;
    }
    function removeLast(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4.s()) throw NoSuchElementException_init_$Create$_0("List is empty.");
        else tmp = _this__u8e3s4.l2(get_lastIndex_2(_this__u8e3s4));
        return tmp;
    }
    function IntIterator() {}
    protoOf(IntIterator).l = function() {
        return this.ze();
    };
    function CharIterator() {}
    protoOf(CharIterator).af = function() {
        return this.bf();
    };
    protoOf(CharIterator).l = function() {
        return new Char(this.af());
    };
    function SequenceScope() {}
    protoOf(SequenceScope).ef = function(elements, $completion) {
        var tmp;
        if (isInterface(elements, Collection)) tmp = elements.s();
        else tmp = false;
        if (tmp) return Unit_instance;
        return this.df(elements.j(), $completion);
    };
    function iterator_0(block) {
        var iterator = new SequenceBuilderIterator();
        iterator.if_1 = createCoroutineUnintercepted(block, iterator, iterator);
        return iterator;
    }
    function nextNotReady($this) {
        if (!$this.k()) throw NoSuchElementException_init_$Create$();
        else return $this.l();
    }
    function exceptionalState($this) {
        switch($this.ff_1){
            case 4:
                return NoSuchElementException_init_$Create$();
            case 5:
                return IllegalStateException_init_$Create$_0("Iterator has failed.");
            default:
                return IllegalStateException_init_$Create$_0("Unexpected state of the iterator: " + $this.ff_1);
        }
    }
    function SequenceBuilderIterator() {
        SequenceScope.call(this);
        this.ff_1 = 0;
        this.gf_1 = null;
        this.hf_1 = null;
        this.if_1 = null;
    }
    protoOf(SequenceBuilderIterator).k = function() {
        while(true){
            switch(this.ff_1){
                case 0:
                    break;
                case 1:
                    if (ensureNotNull(this.hf_1).k()) {
                        this.ff_1 = 2;
                        return true;
                    } else this.hf_1 = null;
                    break;
                case 4:
                    return false;
                case 3:
                case 2:
                    return true;
                default:
                    throw exceptionalState(this);
            }
            this.ff_1 = 5;
            var step = ensureNotNull(this.if_1);
            this.if_1 = null;
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
            step.g9(tmp$ret$0);
        }
    };
    protoOf(SequenceBuilderIterator).l = function() {
        switch(this.ff_1){
            case 0:
            case 1:
                return nextNotReady(this);
            case 2:
                this.ff_1 = 1;
                return ensureNotNull(this.hf_1).l();
            case 3:
                this.ff_1 = 0;
                var tmp = this.gf_1;
                var result = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
                this.gf_1 = null;
                return result;
            default:
                throw exceptionalState(this);
        }
    };
    protoOf(SequenceBuilderIterator).cf = function(value, $completion) {
        this.gf_1 = value;
        this.ff_1 = 3;
        // Inline function 'kotlin.sequences.SequenceBuilderIterator.yield.<anonymous>' call
        this.if_1 = $completion;
        return get_COROUTINE_SUSPENDED();
    };
    protoOf(SequenceBuilderIterator).df = function(iterator, $completion) {
        if (!iterator.k()) return Unit_instance;
        this.hf_1 = iterator;
        this.ff_1 = 2;
        // Inline function 'kotlin.sequences.SequenceBuilderIterator.yieldAll.<anonymous>' call
        this.if_1 = $completion;
        return get_COROUTINE_SUSPENDED();
    };
    protoOf(SequenceBuilderIterator).jf = function(result) {
        // Inline function 'kotlin.getOrThrow' call
        throwOnFailure(result);
        var tmp = _Result___get_value__impl__bjfvqg(result);
        (tmp == null ? true : !(tmp == null)) || THROW_CCE();
        this.ff_1 = 4;
    };
    protoOf(SequenceBuilderIterator).g9 = function(result) {
        return this.jf(result);
    };
    protoOf(SequenceBuilderIterator).b9 = function() {
        return EmptyCoroutineContext_getInstance();
    };
    function TransformingSequence$iterator$1(this$0) {
        this.lf_1 = this$0;
        this.kf_1 = this$0.mf_1.j();
    }
    protoOf(TransformingSequence$iterator$1).l = function() {
        return this.lf_1.nf_1(this.kf_1.l());
    };
    protoOf(TransformingSequence$iterator$1).k = function() {
        return this.kf_1.k();
    };
    function TransformingSequence(sequence, transformer) {
        this.mf_1 = sequence;
        this.nf_1 = transformer;
    }
    protoOf(TransformingSequence).j = function() {
        return new TransformingSequence$iterator$1(this);
    };
    function setOf_0(elements) {
        return toSet(elements);
    }
    function emptySet() {
        return EmptySet_getInstance();
    }
    function EmptySet() {
        EmptySet_instance = this;
        this.of_1 = new Long(1993859828, 793161749);
    }
    protoOf(EmptySet).equals = function(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, KtSet) : false) tmp = other.s();
        else tmp = false;
        return tmp;
    };
    protoOf(EmptySet).hashCode = function() {
        return 0;
    };
    protoOf(EmptySet).toString = function() {
        return "[]";
    };
    protoOf(EmptySet).m = function() {
        return 0;
    };
    protoOf(EmptySet).s = function() {
        return true;
    };
    protoOf(EmptySet).ke = function(element) {
        return false;
    };
    protoOf(EmptySet).a2 = function(element) {
        var tmp;
        return false;
    };
    protoOf(EmptySet).le = function(elements) {
        return elements.s();
    };
    protoOf(EmptySet).b2 = function(elements) {
        return this.le(elements);
    };
    protoOf(EmptySet).j = function() {
        return EmptyIterator_instance;
    };
    var EmptySet_instance;
    function EmptySet_getInstance() {
        if (EmptySet_instance == null) new EmptySet();
        return EmptySet_instance;
    }
    function optimizeReadOnlySet(_this__u8e3s4) {
        switch(_this__u8e3s4.m()){
            case 0:
                return emptySet();
            case 1:
                return setOf(_this__u8e3s4.j().l());
            default:
                return _this__u8e3s4;
        }
    }
    function hashSetOf(elements) {
        return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
    }
    function compareValues(a, b) {
        if (a === b) return 0;
        if (a == null) return -1;
        if (b == null) return 1;
        return compareTo((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
    }
    function Continuation() {}
    function startCoroutine(_this__u8e3s4, receiver, completion) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.g9(tmp$ret$0);
    }
    function Key() {}
    var Key_instance;
    function Key_getInstance() {
        return Key_instance;
    }
    function ContinuationInterceptor() {}
    function Element() {}
    function CoroutineContext$plus$lambda(acc, element) {
        var removed = acc.tf(element.a1());
        var tmp;
        if (removed === EmptyCoroutineContext_getInstance()) tmp = element;
        else {
            var interceptor = removed.i9(Key_instance);
            var tmp_0;
            if (interceptor == null) tmp_0 = new CombinedContext(removed, element);
            else {
                var left = removed.tf(Key_instance);
                tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
            }
            tmp = tmp_0;
        }
        return tmp;
    }
    function CoroutineContext() {}
    function EmptyCoroutineContext() {
        EmptyCoroutineContext_instance = this;
        this.wf_1 = new Long(0, 0);
    }
    protoOf(EmptyCoroutineContext).i9 = function(key) {
        return null;
    };
    protoOf(EmptyCoroutineContext).uf = function(initial, operation) {
        return initial;
    };
    protoOf(EmptyCoroutineContext).vf = function(context) {
        return context;
    };
    protoOf(EmptyCoroutineContext).tf = function(key) {
        return this;
    };
    protoOf(EmptyCoroutineContext).hashCode = function() {
        return 0;
    };
    protoOf(EmptyCoroutineContext).toString = function() {
        return "EmptyCoroutineContext";
    };
    var EmptyCoroutineContext_instance;
    function EmptyCoroutineContext_getInstance() {
        if (EmptyCoroutineContext_instance == null) new EmptyCoroutineContext();
        return EmptyCoroutineContext_instance;
    }
    function size($this) {
        var cur = $this;
        var size = 2;
        while(true){
            var tmp = cur.xf_1;
            var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
            var tmp_0;
            if (tmp0_elvis_lhs == null) return size;
            else tmp_0 = tmp0_elvis_lhs;
            cur = tmp_0;
            size = size + 1 | 0;
        }
    }
    function contains_6($this, element) {
        return equals($this.i9(element.a1()), element);
    }
    function containsAll($this, context) {
        var cur = context;
        while(true){
            if (!contains_6($this, cur.yf_1)) return false;
            var next = cur.xf_1;
            if (next instanceof CombinedContext) cur = next;
            else return contains_6($this, isInterface(next, Element) ? next : THROW_CCE());
        }
    }
    function CombinedContext$toString$lambda(acc, element) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(acc) === 0) tmp = toString_1(element);
        else tmp = acc + ", " + toString_1(element);
        return tmp;
    }
    function CombinedContext(left, element) {
        this.xf_1 = left;
        this.yf_1 = element;
    }
    protoOf(CombinedContext).i9 = function(key) {
        var cur = this;
        while(true){
            var tmp0_safe_receiver = cur.yf_1.i9(key);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver;
            var next = cur.xf_1;
            if (next instanceof CombinedContext) cur = next;
            else return next.i9(key);
        }
    };
    protoOf(CombinedContext).uf = function(initial, operation) {
        return operation(this.xf_1.uf(initial, operation), this.yf_1);
    };
    protoOf(CombinedContext).tf = function(key) {
        if (this.yf_1.i9(key) == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return this.xf_1;
        var newLeft = this.xf_1.tf(key);
        return newLeft === this.xf_1 ? this : newLeft === EmptyCoroutineContext_getInstance() ? this.yf_1 : new CombinedContext(newLeft, this.yf_1);
    };
    protoOf(CombinedContext).equals = function(other) {
        var tmp;
        if (this === other) tmp = true;
        else {
            var tmp_0;
            var tmp_1;
            if (other instanceof CombinedContext) tmp_1 = size(other) === size(this);
            else tmp_1 = false;
            if (tmp_1) tmp_0 = containsAll(other, this);
            else tmp_0 = false;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(CombinedContext).hashCode = function() {
        return hashCode(this.xf_1) + hashCode(this.yf_1) | 0;
    };
    protoOf(CombinedContext).toString = function() {
        return "[" + this.uf("", CombinedContext$toString$lambda) + "]";
    };
    function AbstractCoroutineContextKey(baseKey, safeCast) {
        this.pf_1 = safeCast;
        var tmp = this;
        var tmp_0;
        if (baseKey instanceof AbstractCoroutineContextKey) tmp_0 = baseKey.qf_1;
        else tmp_0 = baseKey;
        tmp.qf_1 = tmp_0;
    }
    protoOf(AbstractCoroutineContextKey).rf = function(element) {
        return this.pf_1(element);
    };
    protoOf(AbstractCoroutineContextKey).sf = function(key) {
        return key === this || this.qf_1 === key;
    };
    function AbstractCoroutineContextElement(key) {
        this.zf_1 = key;
    }
    protoOf(AbstractCoroutineContextElement).a1 = function() {
        return this.zf_1;
    };
    function get_COROUTINE_SUSPENDED() {
        return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
    }
    var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
    var CoroutineSingletons_UNDECIDED_instance;
    var CoroutineSingletons_RESUMED_instance;
    var CoroutineSingletons_entriesInitialized;
    function CoroutineSingletons_initEntries() {
        if (CoroutineSingletons_entriesInitialized) return Unit_instance;
        CoroutineSingletons_entriesInitialized = true;
        CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons("COROUTINE_SUSPENDED", 0);
        CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons("UNDECIDED", 1);
        CoroutineSingletons_RESUMED_instance = new CoroutineSingletons("RESUMED", 2);
    }
    function CoroutineSingletons(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
        CoroutineSingletons_initEntries();
        return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
    }
    function enumEntries(entries) {
        return new EnumEntriesList(entries);
    }
    function EnumEntriesList(entries) {
        AbstractList.call(this);
        this.ag_1 = entries;
    }
    protoOf(EnumEntriesList).m = function() {
        return this.ag_1.length;
    };
    protoOf(EnumEntriesList).o = function(index) {
        Companion_instance_5.z4(index, this.ag_1.length);
        return this.ag_1[index];
    };
    protoOf(EnumEntriesList).bg = function(element) {
        if (element === null) return false;
        var target = getOrNull(this.ag_1, element.q2_1);
        return target === element;
    };
    protoOf(EnumEntriesList).a2 = function(element) {
        if (!(element instanceof Enum)) return false;
        return this.bg(element instanceof Enum ? element : THROW_CCE());
    };
    function getProgressionLastElement(start, end, step) {
        var tmp;
        if (step > 0) tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
        else if (step < 0) tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
        else throw IllegalArgumentException_init_$Create$_0("Step is zero.");
        return tmp;
    }
    function differenceModulo(a, b, c) {
        return mod(mod(a, c) - mod(b, c) | 0, c);
    }
    function mod(a, b) {
        var mod = a % b | 0;
        return mod >= 0 ? mod : mod + b | 0;
    }
    function get_base64EncodeMap() {
        _init_properties_Base64_kt__ymmsz3();
        return base64EncodeMap;
    }
    var base64EncodeMap;
    function get_base64DecodeMap() {
        _init_properties_Base64_kt__ymmsz3();
        return base64DecodeMap;
    }
    var base64DecodeMap;
    function get_base64UrlEncodeMap() {
        _init_properties_Base64_kt__ymmsz3();
        return base64UrlEncodeMap;
    }
    var base64UrlEncodeMap;
    function get_base64UrlDecodeMap() {
        _init_properties_Base64_kt__ymmsz3();
        return base64UrlDecodeMap;
    }
    var base64UrlDecodeMap;
    function encodeSize($this, sourceSize) {
        var groups = ((sourceSize + 3 | 0) - 1 | 0) / 3 | 0;
        var lineSeparators = $this.dg_1 ? (groups - 1 | 0) / 19 | 0 : 0;
        var size = imul(groups, 4) + imul(lineSeparators, 2) | 0;
        if (size < 0) throw IllegalArgumentException_init_$Create$_0("Input is too big");
        return size;
    }
    function decodeImpl($this, source, destination, destinationOffset, startIndex, endIndex) {
        var decodeMap = $this.cg_1 ? get_base64UrlDecodeMap() : get_base64DecodeMap();
        var payload = 0;
        var byteStart = -8;
        var sourceIndex = startIndex;
        var destinationIndex = destinationOffset;
        $l$loop_1: while(sourceIndex < endIndex){
            if (byteStart === -8 && (sourceIndex + 3 | 0) < endIndex) {
                var tmp0 = sourceIndex;
                sourceIndex = tmp0 + 1 | 0;
                var symbol1 = decodeMap[source[tmp0] & 255];
                var tmp1 = sourceIndex;
                sourceIndex = tmp1 + 1 | 0;
                var symbol2 = decodeMap[source[tmp1] & 255];
                var tmp2 = sourceIndex;
                sourceIndex = tmp2 + 1 | 0;
                var symbol3 = decodeMap[source[tmp2] & 255];
                var tmp3 = sourceIndex;
                sourceIndex = tmp3 + 1 | 0;
                var symbol4 = decodeMap[source[tmp3] & 255];
                var bits = symbol1 << 18 | symbol2 << 12 | symbol3 << 6 | symbol4;
                if (bits >= 0) {
                    var tmp4 = destinationIndex;
                    destinationIndex = tmp4 + 1 | 0;
                    destination[tmp4] = toByte(bits >> 16);
                    var tmp5 = destinationIndex;
                    destinationIndex = tmp5 + 1 | 0;
                    destination[tmp5] = toByte(bits >> 8);
                    var tmp6 = destinationIndex;
                    destinationIndex = tmp6 + 1 | 0;
                    destination[tmp6] = toByte(bits);
                    continue $l$loop_1;
                }
                sourceIndex = sourceIndex - 4 | 0;
            }
            var symbol = source[sourceIndex] & 255;
            var symbolBits = decodeMap[symbol];
            if (symbolBits < 0) {
                if (symbolBits === -2) {
                    sourceIndex = handlePaddingSymbol($this, source, sourceIndex, endIndex, byteStart);
                    break $l$loop_1;
                } else if ($this.dg_1) {
                    sourceIndex = sourceIndex + 1 | 0;
                    continue $l$loop_1;
                } else throw IllegalArgumentException_init_$Create$_0("Invalid symbol '" + toString(numberToChar(symbol)) + "'(" + toString_2(symbol, 8) + ") at index " + sourceIndex);
            } else sourceIndex = sourceIndex + 1 | 0;
            payload = payload << 6 | symbolBits;
            byteStart = byteStart + 6 | 0;
            if (byteStart >= 0) {
                var tmp7 = destinationIndex;
                destinationIndex = tmp7 + 1 | 0;
                destination[tmp7] = toByte(payload >>> byteStart | 0);
                payload = payload & ((1 << byteStart) - 1 | 0);
                byteStart = byteStart - 8 | 0;
            }
        }
        if (byteStart === -2) throw IllegalArgumentException_init_$Create$_0("The last unit of input does not have enough bits");
        sourceIndex = skipIllegalSymbolsIfMime($this, source, sourceIndex, endIndex);
        if (sourceIndex < endIndex) {
            var symbol_0 = source[sourceIndex] & 255;
            throw IllegalArgumentException_init_$Create$_0("Symbol '" + toString(numberToChar(symbol_0)) + "'(" + toString_2(symbol_0, 8) + ") at index " + (sourceIndex - 1 | 0) + " is prohibited after the pad character");
        }
        return destinationIndex - destinationOffset | 0;
    }
    function decodeSize($this, source, startIndex, endIndex) {
        var symbols = endIndex - startIndex | 0;
        if (symbols === 0) return 0;
        if (symbols === 1) throw IllegalArgumentException_init_$Create$_0("Input should have at list 2 symbols for Base64 decoding, startIndex: " + startIndex + ", endIndex: " + endIndex);
        if ($this.dg_1) {
            var inductionVariable = startIndex;
            if (inductionVariable < endIndex) $l$loop: do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var symbol = source[index] & 255;
                var symbolBits = get_base64DecodeMap()[symbol];
                if (symbolBits < 0) {
                    if (symbolBits === -2) {
                        symbols = symbols - (endIndex - index | 0) | 0;
                        break $l$loop;
                    }
                    symbols = symbols - 1 | 0;
                }
            }while (inductionVariable < endIndex);
        } else if (source[endIndex - 1 | 0] === 61) {
            symbols = symbols - 1 | 0;
            if (source[endIndex - 2 | 0] === 61) symbols = symbols - 1 | 0;
        }
        // Inline function 'kotlin.Long.div' call
        // Inline function 'kotlin.Long.times' call
        return toLong(symbols).a3(toLong(6)).b3(toLong(8)).l1();
    }
    function handlePaddingSymbol($this, source, padIndex, endIndex, byteStart) {
        var tmp;
        switch(byteStart){
            case -8:
                throw IllegalArgumentException_init_$Create$_0("Redundant pad character at index " + padIndex);
            case -2:
                tmp = padIndex + 1 | 0;
                break;
            case -4:
                var secondPadIndex = skipIllegalSymbolsIfMime($this, source, padIndex + 1 | 0, endIndex);
                if (secondPadIndex === endIndex || !(source[secondPadIndex] === 61)) throw IllegalArgumentException_init_$Create$_0("Missing one pad character at index " + secondPadIndex);
                tmp = secondPadIndex + 1 | 0;
                break;
            case -6:
                tmp = padIndex + 1 | 0;
                break;
            default:
                var message = "Unreachable";
                throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return tmp;
    }
    function skipIllegalSymbolsIfMime($this, source, startIndex, endIndex) {
        if (!$this.dg_1) return startIndex;
        var sourceIndex = startIndex;
        while(sourceIndex < endIndex){
            var symbol = source[sourceIndex] & 255;
            if (!(get_base64DecodeMap()[symbol] === -1)) return sourceIndex;
            sourceIndex = sourceIndex + 1 | 0;
        }
        return sourceIndex;
    }
    function checkDestinationBounds($this, destinationSize, destinationOffset, capacityNeeded) {
        if (destinationOffset < 0 || destinationOffset > destinationSize) throw IndexOutOfBoundsException_init_$Create$_0("destination offset: " + destinationOffset + ", destination size: " + destinationSize);
        var destinationEndIndex = destinationOffset + capacityNeeded | 0;
        if (destinationEndIndex < 0 || destinationEndIndex > destinationSize) throw IndexOutOfBoundsException_init_$Create$_0("The destination array does not have enough capacity, " + ("destination offset: " + destinationOffset + ", destination size: " + destinationSize + ", capacity needed: " + capacityNeeded));
    }
    function Default() {
        Default_instance = this;
        Base64.call(this, false, false);
        this.gg_1 = 8;
        this.hg_1 = 6;
        this.ig_1 = 3;
        this.jg_1 = 4;
        this.kg_1 = 61;
        this.lg_1 = 76;
        this.mg_1 = 19;
        var tmp = this;
        // Inline function 'kotlin.byteArrayOf' call
        tmp.ng_1 = new Int8Array([
            13,
            10
        ]);
        this.og_1 = new Base64(true, false);
        this.pg_1 = new Base64(false, true);
    }
    var Default_instance;
    function Default_getInstance() {
        if (Default_instance == null) new Default();
        return Default_instance;
    }
    function Base64(isUrlSafe, isMimeScheme) {
        Default_getInstance();
        this.cg_1 = isUrlSafe;
        this.dg_1 = isMimeScheme;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(!this.cg_1 || !this.dg_1)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
    }
    protoOf(Base64).qg = function(source, startIndex, endIndex) {
        // Inline function 'kotlin.io.encoding.platformEncodeToString' call
        var byteResult = this.wg(source, startIndex, endIndex);
        return this.zg(byteResult);
    };
    protoOf(Base64).rg = function(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? source.length : endIndex;
        return $super === VOID ? this.qg(source, startIndex, endIndex) : $super.qg.call(this, source, startIndex, endIndex);
    };
    protoOf(Base64).sg = function(source, startIndex, endIndex) {
        this.ah(source.length, startIndex, endIndex);
        var decodeSize_0 = decodeSize(this, source, startIndex, endIndex);
        var destination = new Int8Array(decodeSize_0);
        var bytesWritten = decodeImpl(this, source, destination, 0, startIndex, endIndex);
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(bytesWritten === destination.length)) {
            // Inline function 'kotlin.check.<anonymous>' call
            var message = "Check failed.";
            throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return destination;
    };
    protoOf(Base64).tg = function(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? source.length : endIndex;
        return $super === VOID ? this.sg(source, startIndex, endIndex) : $super.sg.call(this, source, startIndex, endIndex);
    };
    protoOf(Base64).ug = function(source, startIndex, endIndex) {
        // Inline function 'kotlin.io.encoding.platformCharsToBytes' call
        var byteSource = this.yg(source, startIndex, endIndex);
        return this.tg(byteSource);
    };
    protoOf(Base64).vg = function(source, startIndex, endIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? charSequenceLength(source) : endIndex;
        return $super === VOID ? this.ug(source, startIndex, endIndex) : $super.ug.call(this, source, startIndex, endIndex);
    };
    protoOf(Base64).wg = function(source, startIndex, endIndex) {
        this.ah(source.length, startIndex, endIndex);
        var encodeSize_0 = encodeSize(this, endIndex - startIndex | 0);
        var destination = new Int8Array(encodeSize_0);
        this.xg(source, destination, 0, startIndex, endIndex);
        return destination;
    };
    protoOf(Base64).xg = function(source, destination, destinationOffset, startIndex, endIndex) {
        this.ah(source.length, startIndex, endIndex);
        checkDestinationBounds(this, destination.length, destinationOffset, encodeSize(this, endIndex - startIndex | 0));
        var encodeMap = this.cg_1 ? get_base64UrlEncodeMap() : get_base64EncodeMap();
        var sourceIndex = startIndex;
        var destinationIndex = destinationOffset;
        var groupsPerLine = this.dg_1 ? 19 : 2147483647;
        while((sourceIndex + 2 | 0) < endIndex){
            // Inline function 'kotlin.comparisons.minOf' call
            var a = (endIndex - sourceIndex | 0) / 3 | 0;
            var groups = Math.min(a, groupsPerLine);
            var inductionVariable = 0;
            if (inductionVariable < groups) do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp1 = sourceIndex;
                sourceIndex = tmp1 + 1 | 0;
                var byte1 = source[tmp1] & 255;
                var tmp2 = sourceIndex;
                sourceIndex = tmp2 + 1 | 0;
                var byte2 = source[tmp2] & 255;
                var tmp3 = sourceIndex;
                sourceIndex = tmp3 + 1 | 0;
                var byte3 = source[tmp3] & 255;
                var bits = byte1 << 16 | byte2 << 8 | byte3;
                var tmp4 = destinationIndex;
                destinationIndex = tmp4 + 1 | 0;
                destination[tmp4] = encodeMap[bits >>> 18 | 0];
                var tmp5 = destinationIndex;
                destinationIndex = tmp5 + 1 | 0;
                destination[tmp5] = encodeMap[(bits >>> 12 | 0) & 63];
                var tmp6 = destinationIndex;
                destinationIndex = tmp6 + 1 | 0;
                destination[tmp6] = encodeMap[(bits >>> 6 | 0) & 63];
                var tmp7 = destinationIndex;
                destinationIndex = tmp7 + 1 | 0;
                destination[tmp7] = encodeMap[bits & 63];
            }while (inductionVariable < groups);
            if (groups === groupsPerLine && !(sourceIndex === endIndex)) {
                var tmp8 = destinationIndex;
                destinationIndex = tmp8 + 1 | 0;
                destination[tmp8] = Default_getInstance().ng_1[0];
                var tmp9 = destinationIndex;
                destinationIndex = tmp9 + 1 | 0;
                destination[tmp9] = Default_getInstance().ng_1[1];
            }
        }
        var tmp10_subject = endIndex - sourceIndex | 0;
        if (tmp10_subject === 1) {
            var tmp11 = sourceIndex;
            sourceIndex = tmp11 + 1 | 0;
            var byte1_0 = source[tmp11] & 255;
            var bits_0 = byte1_0 << 4;
            var tmp12 = destinationIndex;
            destinationIndex = tmp12 + 1 | 0;
            destination[tmp12] = encodeMap[bits_0 >>> 6 | 0];
            var tmp13 = destinationIndex;
            destinationIndex = tmp13 + 1 | 0;
            destination[tmp13] = encodeMap[bits_0 & 63];
            var tmp14 = destinationIndex;
            destinationIndex = tmp14 + 1 | 0;
            destination[tmp14] = 61;
            var tmp15 = destinationIndex;
            destinationIndex = tmp15 + 1 | 0;
            destination[tmp15] = 61;
        } else if (tmp10_subject === 2) {
            var tmp16 = sourceIndex;
            sourceIndex = tmp16 + 1 | 0;
            var byte1_1 = source[tmp16] & 255;
            var tmp17 = sourceIndex;
            sourceIndex = tmp17 + 1 | 0;
            var byte2_0 = source[tmp17] & 255;
            var bits_1 = byte1_1 << 10 | byte2_0 << 2;
            var tmp18 = destinationIndex;
            destinationIndex = tmp18 + 1 | 0;
            destination[tmp18] = encodeMap[bits_1 >>> 12 | 0];
            var tmp19 = destinationIndex;
            destinationIndex = tmp19 + 1 | 0;
            destination[tmp19] = encodeMap[(bits_1 >>> 6 | 0) & 63];
            var tmp20 = destinationIndex;
            destinationIndex = tmp20 + 1 | 0;
            destination[tmp20] = encodeMap[bits_1 & 63];
            var tmp21 = destinationIndex;
            destinationIndex = tmp21 + 1 | 0;
            destination[tmp21] = 61;
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(sourceIndex === endIndex)) {
            // Inline function 'kotlin.check.<anonymous>' call
            var message = "Check failed.";
            throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return destinationIndex - destinationOffset | 0;
    };
    protoOf(Base64).yg = function(source, startIndex, endIndex) {
        this.ah(charSequenceLength(source), startIndex, endIndex);
        var byteArray = new Int8Array(endIndex - startIndex | 0);
        var length = 0;
        var inductionVariable = startIndex;
        if (inductionVariable < endIndex) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_0 = charSequenceGet(source, index);
            var symbol = Char__toInt_impl_vasixd(this_0);
            if (symbol <= 255) {
                var tmp1 = length;
                length = tmp1 + 1 | 0;
                byteArray[tmp1] = toByte(symbol);
            } else {
                var tmp2 = length;
                length = tmp2 + 1 | 0;
                byteArray[tmp2] = 63;
            }
        }while (inductionVariable < endIndex);
        return byteArray;
    };
    protoOf(Base64).zg = function(source) {
        var stringBuilder = StringBuilder_init_$Create$(source.length);
        var inductionVariable = 0;
        var last = source.length;
        while(inductionVariable < last){
            var byte = source[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            stringBuilder.f8(numberToChar(byte));
        }
        return stringBuilder.toString();
    };
    protoOf(Base64).ah = function(sourceSize, startIndex, endIndex) {
        Companion_instance_5.yb(startIndex, endIndex, sourceSize);
    };
    var properties_initialized_Base64_kt_5g824v;
    function _init_properties_Base64_kt__ymmsz3() {
        if (!properties_initialized_Base64_kt_5g824v) {
            properties_initialized_Base64_kt_5g824v = true;
            // Inline function 'kotlin.byteArrayOf' call
            base64EncodeMap = new Int8Array([
                65,
                66,
                67,
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79,
                80,
                81,
                82,
                83,
                84,
                85,
                86,
                87,
                88,
                89,
                90,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                106,
                107,
                108,
                109,
                110,
                111,
                112,
                113,
                114,
                115,
                116,
                117,
                118,
                119,
                120,
                121,
                122,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                43,
                47
            ]);
            // Inline function 'kotlin.apply' call
            var this_0 = new Int32Array(256);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.io.encoding.base64DecodeMap.<anonymous>' call
            fill(this_0, -1);
            this_0[61] = -2;
            // Inline function 'kotlin.collections.forEachIndexed' call
            var index = 0;
            var indexedObject = get_base64EncodeMap();
            var inductionVariable = 0;
            var last = indexedObject.length;
            while(inductionVariable < last){
                var item = indexedObject[inductionVariable];
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.io.encoding.base64DecodeMap.<anonymous>.<anonymous>' call
                var tmp1 = index;
                index = tmp1 + 1 | 0;
                this_0[item] = tmp1;
            }
            base64DecodeMap = this_0;
            // Inline function 'kotlin.byteArrayOf' call
            base64UrlEncodeMap = new Int8Array([
                65,
                66,
                67,
                68,
                69,
                70,
                71,
                72,
                73,
                74,
                75,
                76,
                77,
                78,
                79,
                80,
                81,
                82,
                83,
                84,
                85,
                86,
                87,
                88,
                89,
                90,
                97,
                98,
                99,
                100,
                101,
                102,
                103,
                104,
                105,
                106,
                107,
                108,
                109,
                110,
                111,
                112,
                113,
                114,
                115,
                116,
                117,
                118,
                119,
                120,
                121,
                122,
                48,
                49,
                50,
                51,
                52,
                53,
                54,
                55,
                56,
                57,
                45,
                95
            ]);
            // Inline function 'kotlin.apply' call
            var this_1 = new Int32Array(256);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.io.encoding.base64UrlDecodeMap.<anonymous>' call
            fill(this_1, -1);
            this_1[61] = -2;
            // Inline function 'kotlin.collections.forEachIndexed' call
            var index_0 = 0;
            var indexedObject_0 = get_base64UrlEncodeMap();
            var inductionVariable_0 = 0;
            var last_0 = indexedObject_0.length;
            while(inductionVariable_0 < last_0){
                var item_0 = indexedObject_0[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'kotlin.io.encoding.base64UrlDecodeMap.<anonymous>.<anonymous>' call
                var tmp1_0 = index_0;
                index_0 = tmp1_0 + 1 | 0;
                this_1[item_0] = tmp1_0;
            }
            base64UrlDecodeMap = this_1;
        }
    }
    function Default_0() {
        Default_instance_0 = this;
        Random.call(this);
        this.bh_1 = defaultPlatformRandom();
    }
    protoOf(Default_0).ch = function(bitCount) {
        return this.bh_1.ch(bitCount);
    };
    protoOf(Default_0).ze = function() {
        return this.bh_1.ze();
    };
    protoOf(Default_0).x = function(until) {
        return this.bh_1.x(until);
    };
    protoOf(Default_0).dh = function(from, until) {
        return this.bh_1.dh(from, until);
    };
    protoOf(Default_0).eh = function(array) {
        return this.bh_1.eh(array);
    };
    protoOf(Default_0).fh = function(size) {
        return this.bh_1.fh(size);
    };
    protoOf(Default_0).gh = function(array, fromIndex, toIndex) {
        return this.bh_1.gh(array, fromIndex, toIndex);
    };
    var Default_instance_0;
    function Default_getInstance_0() {
        if (Default_instance_0 == null) new Default_0();
        return Default_instance_0;
    }
    function Random() {
        Default_getInstance_0();
    }
    protoOf(Random).ze = function() {
        return this.ch(32);
    };
    protoOf(Random).x = function(until) {
        return this.dh(0, until);
    };
    protoOf(Random).dh = function(from, until) {
        checkRangeBounds(from, until);
        var n = until - from | 0;
        if (n > 0 || n === -2147483648) {
            var tmp;
            if ((n & (-n | 0)) === n) {
                var bitCount = fastLog2(n);
                tmp = this.ch(bitCount);
            } else {
                var v;
                do {
                    var bits = this.ze() >>> 1 | 0;
                    v = bits % n | 0;
                }while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
                tmp = v;
            }
            var rnd = tmp;
            return from + rnd | 0;
        } else while(true){
            var rnd_0 = this.ze();
            if (from <= rnd_0 ? rnd_0 < until : false) return rnd_0;
        }
    };
    protoOf(Random).gh = function(array, fromIndex, toIndex) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!((0 <= fromIndex ? fromIndex <= array.length : false) && (0 <= toIndex ? toIndex <= array.length : false))) {
            // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
            var message = "fromIndex (" + fromIndex + ") or toIndex (" + toIndex + ") are out of range: 0.." + array.length + ".";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(fromIndex <= toIndex)) {
            // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
            var message_0 = "fromIndex (" + fromIndex + ") must be not greater than toIndex (" + toIndex + ").";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
        }
        var steps = (toIndex - fromIndex | 0) / 4 | 0;
        var position = fromIndex;
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < steps) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
            var v = this.ze();
            array[position] = toByte(v);
            array[position + 1 | 0] = toByte(v >>> 8 | 0);
            array[position + 2 | 0] = toByte(v >>> 16 | 0);
            array[position + 3 | 0] = toByte(v >>> 24 | 0);
            position = position + 4 | 0;
        }while (inductionVariable < steps);
        var remainder = toIndex - position | 0;
        var vr = this.ch(imul(remainder, 8));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < remainder) do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            array[position + i | 0] = toByte(vr >>> imul(i, 8) | 0);
        }while (inductionVariable_0 < remainder);
        return array;
    };
    protoOf(Random).eh = function(array) {
        return this.gh(array, 0, array.length);
    };
    protoOf(Random).fh = function(size) {
        return this.eh(new Int8Array(size));
    };
    function checkRangeBounds(from, until) {
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (!(until > from)) {
            // Inline function 'kotlin.random.checkRangeBounds.<anonymous>' call
            var message = boundsErrorMessage(from, until);
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return tmp;
    }
    function fastLog2(value) {
        // Inline function 'kotlin.countLeadingZeroBits' call
        return 31 - clz32(value) | 0;
    }
    function boundsErrorMessage(from, until) {
        return "Random range is empty: [" + toString_1(from) + ", " + toString_1(until) + ").";
    }
    function Random_0(seed) {
        return XorWowRandom_init_$Create$(seed, seed >> 31);
    }
    function takeUpperBits(_this__u8e3s4, bitCount) {
        return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
    }
    function XorWowRandom_init_$Init$(seed1, seed2, $this) {
        XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
        return $this;
    }
    function XorWowRandom_init_$Create$(seed1, seed2) {
        return XorWowRandom_init_$Init$(seed1, seed2, objectCreate(protoOf(XorWowRandom)));
    }
    function Companion_9() {
        Companion_instance_9 = this;
        this.hh_1 = new Long(0, 0);
    }
    var Companion_instance_9;
    function Companion_getInstance_9() {
        if (Companion_instance_9 == null) new Companion_9();
        return Companion_instance_9;
    }
    function XorWowRandom(x, y, z, w, v, addend) {
        Companion_getInstance_9();
        Random.call(this);
        this.ih_1 = x;
        this.jh_1 = y;
        this.kh_1 = z;
        this.lh_1 = w;
        this.mh_1 = v;
        this.nh_1 = addend;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!((this.ih_1 | this.jh_1 | this.kh_1 | this.lh_1 | this.mh_1) === 0)) {
            // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
            var message = "Initial state must have at least one non-zero element.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < 64) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
            this.ze();
        }while (inductionVariable < 64);
    }
    protoOf(XorWowRandom).ze = function() {
        var t = this.ih_1;
        t = t ^ (t >>> 2 | 0);
        this.ih_1 = this.jh_1;
        this.jh_1 = this.kh_1;
        this.kh_1 = this.lh_1;
        var v0 = this.mh_1;
        this.lh_1 = v0;
        t = t ^ t << 1 ^ v0 ^ v0 << 4;
        this.mh_1 = t;
        this.nh_1 = this.nh_1 + 362437 | 0;
        return t + this.nh_1 | 0;
    };
    protoOf(XorWowRandom).ch = function(bitCount) {
        return takeUpperBits(this.ze(), bitCount);
    };
    function Companion_10() {
        Companion_instance_10 = this;
        this.c1_1 = new IntRange(1, 0);
    }
    var Companion_instance_10;
    function Companion_getInstance_10() {
        if (Companion_instance_10 == null) new Companion_10();
        return Companion_instance_10;
    }
    function IntRange(start, endInclusive) {
        Companion_getInstance_10();
        IntProgression.call(this, start, endInclusive, 1);
    }
    protoOf(IntRange).t = function() {
        return this.d1_1;
    };
    protoOf(IntRange).u = function() {
        return this.e1_1;
    };
    protoOf(IntRange).oh = function(value) {
        return this.d1_1 <= value && value <= this.e1_1;
    };
    protoOf(IntRange).k1 = function(value) {
        return this.oh(typeof value === "number" ? value : THROW_CCE());
    };
    protoOf(IntRange).s = function() {
        return this.d1_1 > this.e1_1;
    };
    protoOf(IntRange).equals = function(other) {
        var tmp;
        if (other instanceof IntRange) tmp = this.s() && other.s() || this.d1_1 === other.d1_1 && this.e1_1 === other.e1_1;
        else tmp = false;
        return tmp;
    };
    protoOf(IntRange).hashCode = function() {
        return this.s() ? -1 : imul(31, this.d1_1) + this.e1_1 | 0;
    };
    protoOf(IntRange).toString = function() {
        return "" + this.d1_1 + ".." + this.e1_1;
    };
    function Companion_11() {
        Companion_instance_11 = this;
        this.ph_1 = new CharRange(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
    }
    var Companion_instance_11;
    function Companion_getInstance_11() {
        if (Companion_instance_11 == null) new Companion_11();
        return Companion_instance_11;
    }
    function CharRange(start, endInclusive) {
        Companion_getInstance_11();
        CharProgression.call(this, start, endInclusive, 1);
    }
    protoOf(CharRange).th = function() {
        return this.uh_1;
    };
    protoOf(CharRange).t = function() {
        return new Char(this.th());
    };
    protoOf(CharRange).xh = function() {
        return this.vh_1;
    };
    protoOf(CharRange).u = function() {
        return new Char(this.xh());
    };
    protoOf(CharRange).yh = function(value) {
        return Char__compareTo_impl_ypi4mb(this.uh_1, value) <= 0 && Char__compareTo_impl_ypi4mb(value, this.vh_1) <= 0;
    };
    protoOf(CharRange).k1 = function(value) {
        return this.yh(value instanceof Char ? value.o1_1 : THROW_CCE());
    };
    protoOf(CharRange).s = function() {
        return Char__compareTo_impl_ypi4mb(this.uh_1, this.vh_1) > 0;
    };
    protoOf(CharRange).equals = function(other) {
        var tmp;
        if (other instanceof CharRange) tmp = this.s() && other.s() || this.uh_1 === other.uh_1 && this.vh_1 === other.vh_1;
        else tmp = false;
        return tmp;
    };
    protoOf(CharRange).hashCode = function() {
        var tmp;
        if (this.s()) tmp = -1;
        else {
            // Inline function 'kotlin.code' call
            var this_0 = this.uh_1;
            var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
            var tmp_0 = imul(31, tmp$ret$0);
            // Inline function 'kotlin.code' call
            var this_1 = this.vh_1;
            tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
        }
        return tmp;
    };
    protoOf(CharRange).toString = function() {
        return toString(this.uh_1) + ".." + toString(this.vh_1);
    };
    function IntProgressionIterator(first, last, step) {
        IntIterator.call(this);
        this.zh_1 = step;
        this.ai_1 = last;
        this.bi_1 = this.zh_1 > 0 ? first <= last : first >= last;
        this.ci_1 = this.bi_1 ? first : this.ai_1;
    }
    protoOf(IntProgressionIterator).k = function() {
        return this.bi_1;
    };
    protoOf(IntProgressionIterator).ze = function() {
        var value = this.ci_1;
        if (value === this.ai_1) {
            if (!this.bi_1) throw NoSuchElementException_init_$Create$();
            this.bi_1 = false;
        } else this.ci_1 = this.ci_1 + this.zh_1 | 0;
        return value;
    };
    function CharProgressionIterator(first, last, step) {
        CharIterator.call(this);
        this.di_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.ei_1 = Char__toInt_impl_vasixd(last);
        this.fi_1 = this.di_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.fi_1) // Inline function 'kotlin.code' call
        tmp_1 = Char__toInt_impl_vasixd(first);
        else tmp_1 = this.ei_1;
        tmp_0.gi_1 = tmp_1;
    }
    protoOf(CharProgressionIterator).k = function() {
        return this.fi_1;
    };
    protoOf(CharProgressionIterator).bf = function() {
        var value = this.gi_1;
        if (value === this.ei_1) {
            if (!this.fi_1) throw NoSuchElementException_init_$Create$();
            this.fi_1 = false;
        } else this.gi_1 = this.gi_1 + this.di_1 | 0;
        return numberToChar(value);
    };
    function Companion_12() {}
    protoOf(Companion_12).g1 = function(rangeStart, rangeEnd, step) {
        return new IntProgression(rangeStart, rangeEnd, step);
    };
    var Companion_instance_12;
    function Companion_getInstance_12() {
        return Companion_instance_12;
    }
    function IntProgression(start, endInclusive, step) {
        if (step === 0) throw IllegalArgumentException_init_$Create$_0("Step must be non-zero.");
        if (step === -2147483648) throw IllegalArgumentException_init_$Create$_0("Step must be greater than Int.MIN_VALUE to avoid overflow on negation.");
        this.d1_1 = start;
        this.e1_1 = getProgressionLastElement(start, endInclusive, step);
        this.f1_1 = step;
    }
    protoOf(IntProgression).j = function() {
        return new IntProgressionIterator(this.d1_1, this.e1_1, this.f1_1);
    };
    protoOf(IntProgression).s = function() {
        return this.f1_1 > 0 ? this.d1_1 > this.e1_1 : this.d1_1 < this.e1_1;
    };
    protoOf(IntProgression).equals = function(other) {
        var tmp;
        if (other instanceof IntProgression) tmp = this.s() && other.s() || this.d1_1 === other.d1_1 && this.e1_1 === other.e1_1 && this.f1_1 === other.f1_1;
        else tmp = false;
        return tmp;
    };
    protoOf(IntProgression).hashCode = function() {
        return this.s() ? -1 : imul(31, imul(31, this.d1_1) + this.e1_1 | 0) + this.f1_1 | 0;
    };
    protoOf(IntProgression).toString = function() {
        return this.f1_1 > 0 ? "" + this.d1_1 + ".." + this.e1_1 + " step " + this.f1_1 : "" + this.d1_1 + " downTo " + this.e1_1 + " step " + (-this.f1_1 | 0);
    };
    function Companion_13() {}
    var Companion_instance_13;
    function Companion_getInstance_13() {
        return Companion_instance_13;
    }
    function CharProgression(start, endInclusive, step) {
        if (step === 0) throw IllegalArgumentException_init_$Create$_0("Step must be non-zero.");
        if (step === -2147483648) throw IllegalArgumentException_init_$Create$_0("Step must be greater than Int.MIN_VALUE to avoid overflow on negation.");
        this.uh_1 = start;
        var tmp = this;
        // Inline function 'kotlin.code' call
        var tmp_0 = Char__toInt_impl_vasixd(start);
        // Inline function 'kotlin.code' call
        var tmp$ret$1 = Char__toInt_impl_vasixd(endInclusive);
        tmp.vh_1 = numberToChar(getProgressionLastElement(tmp_0, tmp$ret$1, step));
        this.wh_1 = step;
    }
    protoOf(CharProgression).j = function() {
        return new CharProgressionIterator(this.uh_1, this.vh_1, this.wh_1);
    };
    protoOf(CharProgression).s = function() {
        return this.wh_1 > 0 ? Char__compareTo_impl_ypi4mb(this.uh_1, this.vh_1) > 0 : Char__compareTo_impl_ypi4mb(this.uh_1, this.vh_1) < 0;
    };
    protoOf(CharProgression).equals = function(other) {
        var tmp;
        if (other instanceof CharProgression) tmp = this.s() && other.s() || this.uh_1 === other.uh_1 && this.vh_1 === other.vh_1 && this.wh_1 === other.wh_1;
        else tmp = false;
        return tmp;
    };
    protoOf(CharProgression).hashCode = function() {
        var tmp;
        if (this.s()) tmp = -1;
        else {
            // Inline function 'kotlin.code' call
            var this_0 = this.uh_1;
            var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
            var tmp_0 = imul(31, tmp$ret$0);
            // Inline function 'kotlin.code' call
            var this_1 = this.vh_1;
            var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
            tmp = imul(31, tmp_0 + tmp$ret$1 | 0) + this.wh_1 | 0;
        }
        return tmp;
    };
    protoOf(CharProgression).toString = function() {
        return this.wh_1 > 0 ? toString(this.uh_1) + ".." + toString(this.vh_1) + " step " + this.wh_1 : toString(this.uh_1) + " downTo " + toString(this.vh_1) + " step " + (-this.wh_1 | 0);
    };
    function ClosedRange() {}
    function checkStepIsPositive(isPositive, step) {
        if (!isPositive) throw IllegalArgumentException_init_$Create$_0("Step must be positive, was: " + toString_1(step) + ".");
    }
    function KTypeParameter() {}
    function Companion_14() {
        Companion_instance_14 = this;
        this.oa_1 = new KTypeProjection(null, null);
    }
    protoOf(Companion_14).pa = function(type) {
        return new KTypeProjection(KVariance_INVARIANT_getInstance(), type);
    };
    var Companion_instance_14;
    function Companion_getInstance_14() {
        if (Companion_instance_14 == null) new Companion_14();
        return Companion_instance_14;
    }
    function KTypeProjection(variance, type) {
        Companion_getInstance_14();
        this.hi_1 = variance;
        this.ii_1 = type;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.hi_1 == null === (this.ii_1 == null))) {
            // Inline function 'kotlin.reflect.KTypeProjection.<anonymous>' call
            var message = this.hi_1 == null ? "Star projection must have no type specified." : "The projection variance " + toString_0(this.hi_1) + " requires type to be specified.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
    }
    protoOf(KTypeProjection).toString = function() {
        var tmp0_subject = this.hi_1;
        var tmp;
        switch(tmp0_subject == null ? -1 : tmp0_subject.q2_1){
            case -1:
                tmp = "*";
                break;
            case 0:
                tmp = toString_0(this.ii_1);
                break;
            case 1:
                tmp = "in " + toString_0(this.ii_1);
                break;
            case 2:
                tmp = "out " + toString_0(this.ii_1);
                break;
            default:
                noWhenBranchMatchedException();
                break;
        }
        return tmp;
    };
    protoOf(KTypeProjection).hashCode = function() {
        var result = this.hi_1 == null ? 0 : this.hi_1.hashCode();
        result = imul(result, 31) + (this.ii_1 == null ? 0 : hashCode(this.ii_1)) | 0;
        return result;
    };
    protoOf(KTypeProjection).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof KTypeProjection)) return false;
        var tmp0_other_with_cast = other instanceof KTypeProjection ? other : THROW_CCE();
        if (!equals(this.hi_1, tmp0_other_with_cast.hi_1)) return false;
        if (!equals(this.ii_1, tmp0_other_with_cast.ii_1)) return false;
        return true;
    };
    var KVariance_INVARIANT_instance;
    var KVariance_IN_instance;
    var KVariance_OUT_instance;
    var KVariance_entriesInitialized;
    function KVariance_initEntries() {
        if (KVariance_entriesInitialized) return Unit_instance;
        KVariance_entriesInitialized = true;
        KVariance_INVARIANT_instance = new KVariance("INVARIANT", 0);
        KVariance_IN_instance = new KVariance("IN", 1);
        KVariance_OUT_instance = new KVariance("OUT", 2);
    }
    function KVariance(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function KVariance_INVARIANT_getInstance() {
        KVariance_initEntries();
        return KVariance_INVARIANT_instance;
    }
    function appendElement(_this__u8e3s4, element, transform) {
        if (!(transform == null)) _this__u8e3s4.f(transform(element));
        else {
            if (element == null ? true : isCharSequence(element)) _this__u8e3s4.f(element);
            else if (element instanceof Char) _this__u8e3s4.f8(element.o1_1);
            else _this__u8e3s4.f(toString_0(element));
        }
    }
    function equals_1(_this__u8e3s4, other, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        if (_this__u8e3s4 === other) return true;
        if (!ignoreCase) return false;
        var thisUpper = uppercaseChar(_this__u8e3s4);
        var otherUpper = uppercaseChar(other);
        var tmp;
        if (thisUpper === otherUpper) tmp = true;
        else {
            // Inline function 'kotlin.text.lowercaseChar' call
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$2 = toString(thisUpper).toLowerCase();
            var tmp_0 = charSequenceGet(tmp$ret$2, 0);
            // Inline function 'kotlin.text.lowercaseChar' call
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$6 = toString(otherUpper).toLowerCase();
            tmp = tmp_0 === charSequenceGet(tmp$ret$6, 0);
        }
        return tmp;
    }
    function isSurrogate(_this__u8e3s4) {
        return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
    }
    function titlecase(_this__u8e3s4) {
        return titlecaseImpl(_this__u8e3s4);
    }
    function trimMargin(_this__u8e3s4, marginPrefix) {
        marginPrefix = marginPrefix === VOID ? "|" : marginPrefix;
        return replaceIndentByMargin(_this__u8e3s4, "", marginPrefix);
    }
    function trimIndent(_this__u8e3s4) {
        return replaceIndent(_this__u8e3s4, "");
    }
    function replaceIndentByMargin(_this__u8e3s4, newIndent, marginPrefix) {
        newIndent = newIndent === VOID ? "" : newIndent;
        marginPrefix = marginPrefix === VOID ? "|" : marginPrefix;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!isBlank(marginPrefix)) {
            // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>' call
            var message = "marginPrefix must be non-blank string.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        var lines_0 = lines(_this__u8e3s4);
        // Inline function 'kotlin.text.reindent' call
        var resultSizeEstimate = _this__u8e3s4.length + imul(newIndent.length, lines_0.m()) | 0;
        var indentAddFunction = getIndentFunction(newIndent);
        var lastIndex = get_lastIndex_2(lines_0);
        // Inline function 'kotlin.collections.mapIndexedNotNull' call
        // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var tmp0_iterator = lines_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            // Inline function 'kotlin.text.reindent.<anonymous>' call
            var index_0 = checkIndexOverflow(tmp1);
            var tmp;
            if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item)) tmp = null;
            else {
                // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>' call
                var tmp$ret$3;
                $l$block: {
                    // Inline function 'kotlin.text.indexOfFirst' call
                    var inductionVariable = 0;
                    var last = charSequenceLength(item) - 1 | 0;
                    if (inductionVariable <= last) do {
                        var index_1 = inductionVariable;
                        inductionVariable = inductionVariable + 1 | 0;
                        // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>.<anonymous>' call
                        var it = charSequenceGet(item, index_1);
                        if (!isWhitespace(it)) {
                            tmp$ret$3 = index_1;
                            break $l$block;
                        }
                    }while (inductionVariable <= last);
                    tmp$ret$3 = -1;
                }
                var firstNonWhitespaceIndex = tmp$ret$3;
                var tmp_0;
                if (firstNonWhitespaceIndex === -1) tmp_0 = null;
                else if (startsWith_0(item, marginPrefix, firstNonWhitespaceIndex)) {
                    // Inline function 'kotlin.text.substring' call
                    var startIndex = firstNonWhitespaceIndex + marginPrefix.length | 0;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp_0 = item.substring(startIndex);
                } else tmp_0 = null;
                var tmp0_safe_receiver = tmp_0;
                var tmp_1;
                if (tmp0_safe_receiver == null) tmp_1 = null;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                tmp_1 = indentAddFunction(tmp0_safe_receiver);
                var tmp1_elvis_lhs = tmp_1;
                tmp = tmp1_elvis_lhs == null ? item : tmp1_elvis_lhs;
            }
            var tmp0_safe_receiver_0 = tmp;
            if (tmp0_safe_receiver_0 == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.e(tmp0_safe_receiver_0);
        }
        return joinTo_0(destination, StringBuilder_init_$Create$(resultSizeEstimate), "\n").toString();
    }
    function replaceIndent(_this__u8e3s4, newIndent) {
        newIndent = newIndent === VOID ? "" : newIndent;
        var lines_0 = lines(_this__u8e3s4);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = lines_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element)) destination.e(element);
        }
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
        var tmp0_iterator_0 = destination.j();
        while(tmp0_iterator_0.k()){
            var item = tmp0_iterator_0.l();
            var tmp$ret$3 = indentWidth(item);
            destination_0.e(tmp$ret$3);
        }
        var tmp0_elvis_lhs = minOrNull(destination_0);
        var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.text.reindent' call
        var resultSizeEstimate = _this__u8e3s4.length + imul(newIndent.length, lines_0.m()) | 0;
        var indentAddFunction = getIndentFunction(newIndent);
        var lastIndex = get_lastIndex_2(lines_0);
        // Inline function 'kotlin.collections.mapIndexedNotNull' call
        // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
        var destination_1 = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var tmp0_iterator_1 = lines_0.j();
        while(tmp0_iterator_1.k()){
            var item_0 = tmp0_iterator_1.l();
            // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            // Inline function 'kotlin.text.reindent.<anonymous>' call
            var index_0 = checkIndexOverflow(tmp1);
            var tmp;
            if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item_0)) tmp = null;
            else {
                // Inline function 'kotlin.text.replaceIndent.<anonymous>' call
                var tmp0_safe_receiver = drop_0(item_0, minCommonIndent);
                var tmp_0;
                if (tmp0_safe_receiver == null) tmp_0 = null;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                tmp_0 = indentAddFunction(tmp0_safe_receiver);
                var tmp1_elvis_lhs = tmp_0;
                tmp = tmp1_elvis_lhs == null ? item_0 : tmp1_elvis_lhs;
            }
            var tmp0_safe_receiver_0 = tmp;
            if (tmp0_safe_receiver_0 == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination_1.e(tmp0_safe_receiver_0);
        }
        return joinTo_0(destination_1, StringBuilder_init_$Create$(resultSizeEstimate), "\n").toString();
    }
    function getIndentFunction(indent) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(indent) === 0) tmp = getIndentFunction$lambda;
        else tmp = getIndentFunction$lambda_0(indent);
        return tmp;
    }
    function indentWidth(_this__u8e3s4) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.indexOfFirst' call
            var inductionVariable = 0;
            var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
            if (inductionVariable <= last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.text.indentWidth.<anonymous>' call
                var it = charSequenceGet(_this__u8e3s4, index);
                if (!isWhitespace(it)) {
                    tmp$ret$1 = index;
                    break $l$block;
                }
            }while (inductionVariable <= last);
            tmp$ret$1 = -1;
        }
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.text.indentWidth.<anonymous>' call
        var it_0 = tmp$ret$1;
        return it_0 === -1 ? _this__u8e3s4.length : it_0;
    }
    function getIndentFunction$lambda(line) {
        return line;
    }
    function getIndentFunction$lambda_0($indent) {
        return function(line) {
            return $indent + line;
        };
    }
    function toIntOrNull(_this__u8e3s4) {
        return toIntOrNull_0(_this__u8e3s4, 10);
    }
    function toLongOrNull(_this__u8e3s4) {
        return toLongOrNull_0(_this__u8e3s4, 10);
    }
    function toIntOrNull_0(_this__u8e3s4, radix) {
        checkRadix(radix);
        var length = _this__u8e3s4.length;
        if (length === 0) return null;
        var start;
        var isNegative;
        var limit;
        var firstChar = charSequenceGet(_this__u8e3s4, 0);
        if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
            if (length === 1) return null;
            start = 1;
            if (firstChar === _Char___init__impl__6a9atx(45)) {
                isNegative = true;
                limit = -2147483648;
            } else if (firstChar === _Char___init__impl__6a9atx(43)) {
                isNegative = false;
                limit = -2147483647;
            } else return null;
        } else {
            start = 0;
            isNegative = false;
            limit = -2147483647;
        }
        var limitForMaxRadix = -59652323;
        var limitBeforeMul = limitForMaxRadix;
        var result = 0;
        var inductionVariable = start;
        if (inductionVariable < length) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
            if (digit < 0) return null;
            if (result < limitBeforeMul) {
                if (limitBeforeMul === limitForMaxRadix) {
                    limitBeforeMul = limit / radix | 0;
                    if (result < limitBeforeMul) return null;
                } else return null;
            }
            result = imul(result, radix);
            if (result < (limit + digit | 0)) return null;
            result = result - digit | 0;
        }while (inductionVariable < length);
        return isNegative ? result : -result | 0;
    }
    function toLongOrNull_0(_this__u8e3s4, radix) {
        checkRadix(radix);
        var length = _this__u8e3s4.length;
        if (length === 0) return null;
        var start;
        var isNegative;
        var limit;
        var firstChar = charSequenceGet(_this__u8e3s4, 0);
        if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
            if (length === 1) return null;
            start = 1;
            if (firstChar === _Char___init__impl__6a9atx(45)) {
                isNegative = true;
                limit = new Long(0, -2147483648);
            } else if (firstChar === _Char___init__impl__6a9atx(43)) {
                isNegative = false;
                limit = new Long(1, -2147483648);
            } else return null;
        } else {
            start = 0;
            isNegative = false;
            limit = new Long(1, -2147483648);
        }
        // Inline function 'kotlin.Long.div' call
        var limitForMaxRadix = new Long(1, -2147483648).b3(toLong(36));
        var limitBeforeMul = limitForMaxRadix;
        var result = new Long(0, 0);
        var inductionVariable = start;
        if (inductionVariable < length) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
            if (digit < 0) return null;
            if (result.j1(limitBeforeMul) < 0) {
                if (limitBeforeMul.equals(limitForMaxRadix)) {
                    // Inline function 'kotlin.Long.div' call
                    limitBeforeMul = limit.b3(toLong(radix));
                    if (result.j1(limitBeforeMul) < 0) return null;
                } else return null;
            }
            // Inline function 'kotlin.Long.times' call
            result = result.a3(toLong(radix));
            var tmp = result;
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$3 = limit.y2(toLong(digit));
            if (tmp.j1(tmp$ret$3) < 0) return null;
            // Inline function 'kotlin.Long.minus' call
            result = result.z2(toLong(digit));
        }while (inductionVariable < length);
        return isNegative ? result : result.f3();
    }
    function numberFormatError(input) {
        throw NumberFormatException_init_$Create$_0("Invalid number format: '" + input + "'");
    }
    function split(_this__u8e3s4, delimiters, ignoreCase, limit) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        limit = limit === VOID ? 0 : limit;
        if (delimiters.length === 1) {
            var delimiter = delimiters[0];
            // Inline function 'kotlin.text.isEmpty' call
            if (!(charSequenceLength(delimiter) === 0)) return split_0(_this__u8e3s4, delimiter, ignoreCase, limit);
        }
        // Inline function 'kotlin.collections.map' call
        var this_0 = asIterable(rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlin.text.split.<anonymous>' call
            var tmp$ret$1 = substring(_this__u8e3s4, item);
            destination.e(tmp$ret$1);
        }
        return destination;
    }
    function indexOf_4(_this__u8e3s4, char, startIndex, ignoreCase) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var tmp;
        var tmp_0;
        if (ignoreCase) tmp_0 = true;
        else tmp_0 = !(typeof _this__u8e3s4 === "string");
        if (tmp_0) {
            // Inline function 'kotlin.charArrayOf' call
            var tmp$ret$0 = charArrayOf([
                char
            ]);
            tmp = indexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
        } else {
            // Inline function 'kotlin.text.nativeIndexOf' call
            // Inline function 'kotlin.text.nativeIndexOf' call
            var str = toString(char);
            // Inline function 'kotlin.js.asDynamic' call
            tmp = _this__u8e3s4.indexOf(str, startIndex);
        }
        return tmp;
    }
    function lineSequence(_this__u8e3s4) {
        return splitToSequence(_this__u8e3s4, [
            "\r\n",
            "\n",
            "\r"
        ]);
    }
    function isBlank(_this__u8e3s4) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while(inductionVariable < charSequenceLength(_this__u8e3s4)){
                var element = charSequenceGet(_this__u8e3s4, inductionVariable);
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.text.isBlank.<anonymous>' call
                if (!isWhitespace(element)) {
                    tmp$ret$1 = false;
                    break $l$block;
                }
            }
            tmp$ret$1 = true;
        }
        return tmp$ret$1;
    }
    function contains_7(_this__u8e3s4, char, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        return indexOf_4(_this__u8e3s4, char, VOID, ignoreCase) >= 0;
    }
    function get_lastIndex_3(_this__u8e3s4) {
        return charSequenceLength(_this__u8e3s4) - 1 | 0;
    }
    function padStart(_this__u8e3s4, length, padChar) {
        padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
        return toString_1(padStart_0(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE(), length, padChar));
    }
    function startsWith_1(_this__u8e3s4, char, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        return charSequenceLength(_this__u8e3s4) > 0 && equals_1(charSequenceGet(_this__u8e3s4, 0), char, ignoreCase);
    }
    function split_0(_this__u8e3s4, delimiter, ignoreCase, limit) {
        requireNonNegativeLimit(limit);
        var currentOffset = 0;
        var nextIndex = indexOf_5(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
        if (nextIndex === -1 || limit === 1) return listOf(toString_1(_this__u8e3s4));
        var isLimited = limit > 0;
        var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
        $l$loop: do {
            // Inline function 'kotlin.text.substring' call
            var startIndex = currentOffset;
            var endIndex = nextIndex;
            var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
            result.e(tmp$ret$0);
            currentOffset = nextIndex + delimiter.length | 0;
            if (isLimited && result.m() === (limit - 1 | 0)) break $l$loop;
            nextIndex = indexOf_5(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
        }while (!(nextIndex === -1));
        // Inline function 'kotlin.text.substring' call
        var startIndex_0 = currentOffset;
        var endIndex_0 = charSequenceLength(_this__u8e3s4);
        var tmp$ret$1 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex_0, endIndex_0));
        result.e(tmp$ret$1);
        return result;
    }
    function substring(_this__u8e3s4, range) {
        return toString_1(charSequenceSubSequence(_this__u8e3s4, range.t(), range.u() + 1 | 0));
    }
    function rangesDelimitedBy(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        limit = limit === VOID ? 0 : limit;
        requireNonNegativeLimit(limit);
        var delimitersList = asList(delimiters);
        return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda(delimitersList, ignoreCase));
    }
    function indexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var tmp;
        if (!ignoreCase && chars.length === 1) tmp = typeof _this__u8e3s4 === "string";
        else tmp = false;
        if (tmp) {
            var char = single(chars);
            // Inline function 'kotlin.text.nativeIndexOf' call
            // Inline function 'kotlin.text.nativeIndexOf' call
            var str = toString(char);
            // Inline function 'kotlin.js.asDynamic' call
            return _this__u8e3s4.indexOf(str, startIndex);
        }
        var inductionVariable = coerceAtLeast(startIndex, 0);
        var last = get_lastIndex_3(_this__u8e3s4);
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var charAtIndex = charSequenceGet(_this__u8e3s4, index);
            var tmp$ret$4;
            $l$block: {
                // Inline function 'kotlin.collections.any' call
                var inductionVariable_0 = 0;
                var last_0 = chars.length;
                while(inductionVariable_0 < last_0){
                    var element = chars[inductionVariable_0];
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'kotlin.text.indexOfAny.<anonymous>' call
                    if (equals_1(element, charAtIndex, ignoreCase)) {
                        tmp$ret$4 = true;
                        break $l$block;
                    }
                }
                tmp$ret$4 = false;
            }
            if (tmp$ret$4) return index;
        }while (!(index === last));
        return -1;
    }
    function trim(_this__u8e3s4) {
        // Inline function 'kotlin.text.trim' call
        var startIndex = 0;
        var endIndex = charSequenceLength(_this__u8e3s4) - 1 | 0;
        var startFound = false;
        $l$loop: while(startIndex <= endIndex){
            var index = !startFound ? startIndex : endIndex;
            var match = isWhitespace(charSequenceGet(_this__u8e3s4, index));
            if (!startFound) {
                if (!match) startFound = true;
                else startIndex = startIndex + 1 | 0;
            } else {
                if (!match) break $l$loop;
                else endIndex = endIndex - 1 | 0;
            }
        }
        return charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex + 1 | 0);
    }
    function splitToSequence(_this__u8e3s4, delimiters, ignoreCase, limit) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        limit = limit === VOID ? 0 : limit;
        var tmp = rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit);
        return map(tmp, splitToSequence$lambda(_this__u8e3s4));
    }
    function padStart_0(_this__u8e3s4, length, padChar) {
        padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
        if (length < 0) throw IllegalArgumentException_init_$Create$_0("Desired length " + length + " is less than zero.");
        if (length <= charSequenceLength(_this__u8e3s4)) return charSequenceSubSequence(_this__u8e3s4, 0, charSequenceLength(_this__u8e3s4));
        var sb = StringBuilder_init_$Create$(length);
        var inductionVariable = 1;
        var last = length - charSequenceLength(_this__u8e3s4) | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            sb.f8(padChar);
        }while (!(i === last));
        sb.f(_this__u8e3s4);
        return sb;
    }
    function requireNonNegativeLimit(limit) {
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (!(limit >= 0)) {
            // Inline function 'kotlin.text.requireNonNegativeLimit.<anonymous>' call
            var message = "Limit must be non-negative, but was " + limit;
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return tmp;
    }
    function indexOf_5(_this__u8e3s4, string, startIndex, ignoreCase) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var tmp;
        var tmp_0;
        if (ignoreCase) tmp_0 = true;
        else tmp_0 = !(typeof _this__u8e3s4 === "string");
        if (tmp_0) tmp = indexOf_6(_this__u8e3s4, string, startIndex, charSequenceLength(_this__u8e3s4), ignoreCase);
        else // Inline function 'kotlin.text.nativeIndexOf' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = _this__u8e3s4.indexOf(string, startIndex);
        return tmp;
    }
    function calcNext($this) {
        if ($this.li_1 < 0) {
            $this.ji_1 = 0;
            $this.mi_1 = null;
        } else {
            var tmp;
            var tmp_0;
            if ($this.oi_1.ri_1 > 0) {
                $this.ni_1 = $this.ni_1 + 1 | 0;
                tmp_0 = $this.ni_1 >= $this.oi_1.ri_1;
            } else tmp_0 = false;
            if (tmp_0) tmp = true;
            else tmp = $this.li_1 > charSequenceLength($this.oi_1.pi_1);
            if (tmp) {
                $this.mi_1 = numberRangeToNumber($this.ki_1, get_lastIndex_3($this.oi_1.pi_1));
                $this.li_1 = -1;
            } else {
                var match = $this.oi_1.si_1($this.oi_1.pi_1, $this.li_1);
                if (match == null) {
                    $this.mi_1 = numberRangeToNumber($this.ki_1, get_lastIndex_3($this.oi_1.pi_1));
                    $this.li_1 = -1;
                } else {
                    var index = match.ba();
                    var length = match.ca();
                    $this.mi_1 = until($this.ki_1, index);
                    $this.ki_1 = index + length | 0;
                    $this.li_1 = $this.ki_1 + (length === 0 ? 1 : 0) | 0;
                }
            }
            $this.ji_1 = 1;
        }
    }
    function DelimitedRangesSequence$iterator$1(this$0) {
        this.oi_1 = this$0;
        this.ji_1 = -1;
        this.ki_1 = coerceIn_0(this$0.qi_1, 0, charSequenceLength(this$0.pi_1));
        this.li_1 = this.ki_1;
        this.mi_1 = null;
        this.ni_1 = 0;
    }
    protoOf(DelimitedRangesSequence$iterator$1).l = function() {
        if (this.ji_1 === -1) calcNext(this);
        if (this.ji_1 === 0) throw NoSuchElementException_init_$Create$();
        var tmp = this.mi_1;
        var result = tmp instanceof IntRange ? tmp : THROW_CCE();
        this.mi_1 = null;
        this.ji_1 = -1;
        return result;
    };
    protoOf(DelimitedRangesSequence$iterator$1).k = function() {
        if (this.ji_1 === -1) calcNext(this);
        return this.ji_1 === 1;
    };
    function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
        this.pi_1 = input;
        this.qi_1 = startIndex;
        this.ri_1 = limit;
        this.si_1 = getNextMatch;
    }
    protoOf(DelimitedRangesSequence).j = function() {
        return new DelimitedRangesSequence$iterator$1(this);
    };
    function findAnyOf(_this__u8e3s4, strings, startIndex, ignoreCase, last) {
        if (!ignoreCase && strings.m() === 1) {
            var string = single_0(strings);
            var index = !last ? indexOf_5(_this__u8e3s4, string, startIndex) : lastIndexOf(_this__u8e3s4, string, startIndex);
            return index < 0 ? null : to(index, string);
        }
        var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this__u8e3s4)) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), 0);
        if (typeof _this__u8e3s4 === "string") {
            var inductionVariable = indices.d1_1;
            var last_0 = indices.e1_1;
            var step = indices.f1_1;
            if (step > 0 && inductionVariable <= last_0 || step < 0 && last_0 <= inductionVariable) do {
                var index_0 = inductionVariable;
                inductionVariable = inductionVariable + step | 0;
                var tmp$ret$1;
                $l$block: {
                    // Inline function 'kotlin.collections.firstOrNull' call
                    var tmp0_iterator = strings.j();
                    while(tmp0_iterator.k()){
                        var element = tmp0_iterator.l();
                        // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
                        if (regionMatches(element, 0, _this__u8e3s4, index_0, element.length, ignoreCase)) {
                            tmp$ret$1 = element;
                            break $l$block;
                        }
                    }
                    tmp$ret$1 = null;
                }
                var matchingString = tmp$ret$1;
                if (!(matchingString == null)) return to(index_0, matchingString);
            }while (!(index_0 === last_0));
        } else {
            var inductionVariable_0 = indices.d1_1;
            var last_1 = indices.e1_1;
            var step_0 = indices.f1_1;
            if (step_0 > 0 && inductionVariable_0 <= last_1 || step_0 < 0 && last_1 <= inductionVariable_0) do {
                var index_1 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_0 | 0;
                var tmp$ret$3;
                $l$block_0: {
                    // Inline function 'kotlin.collections.firstOrNull' call
                    var tmp0_iterator_0 = strings.j();
                    while(tmp0_iterator_0.k()){
                        var element_0 = tmp0_iterator_0.l();
                        // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
                        if (regionMatchesImpl(element_0, 0, _this__u8e3s4, index_1, element_0.length, ignoreCase)) {
                            tmp$ret$3 = element_0;
                            break $l$block_0;
                        }
                    }
                    tmp$ret$3 = null;
                }
                var matchingString_0 = tmp$ret$3;
                if (!(matchingString_0 == null)) return to(index_1, matchingString_0);
            }while (!(index_1 === last_1));
        }
        return null;
    }
    function regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
        if (otherOffset < 0 || thisOffset < 0 || thisOffset > (charSequenceLength(_this__u8e3s4) - length | 0) || otherOffset > (charSequenceLength(other) - length | 0)) return false;
        var inductionVariable = 0;
        if (inductionVariable < length) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals_1(charSequenceGet(_this__u8e3s4, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase)) return false;
        }while (inductionVariable < length);
        return true;
    }
    function indexOf_6(_this__u8e3s4, other, startIndex, endIndex, ignoreCase, last) {
        last = last === VOID ? false : last;
        var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this__u8e3s4))) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), coerceAtLeast(endIndex, 0));
        var tmp;
        if (typeof _this__u8e3s4 === "string") tmp = typeof other === "string";
        else tmp = false;
        if (tmp) {
            var inductionVariable = indices.d1_1;
            var last_0 = indices.e1_1;
            var step = indices.f1_1;
            if (step > 0 && inductionVariable <= last_0 || step < 0 && last_0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + step | 0;
                if (regionMatches(other, 0, _this__u8e3s4, index, charSequenceLength(other), ignoreCase)) return index;
            }while (!(index === last_0));
        } else {
            var inductionVariable_0 = indices.d1_1;
            var last_1 = indices.e1_1;
            var step_0 = indices.f1_1;
            if (step_0 > 0 && inductionVariable_0 <= last_1 || step_0 < 0 && last_1 <= inductionVariable_0) do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_0 | 0;
                if (regionMatchesImpl(other, 0, _this__u8e3s4, index_0, charSequenceLength(other), ignoreCase)) return index_0;
            }while (!(index_0 === last_1));
        }
        return -1;
    }
    function lastIndexOf(_this__u8e3s4, string, startIndex, ignoreCase) {
        startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var tmp;
        var tmp_0;
        if (ignoreCase) tmp_0 = true;
        else tmp_0 = !(typeof _this__u8e3s4 === "string");
        if (tmp_0) tmp = indexOf_6(_this__u8e3s4, string, startIndex, 0, ignoreCase, true);
        else // Inline function 'kotlin.text.nativeLastIndexOf' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = _this__u8e3s4.lastIndexOf(string, startIndex);
        return tmp;
    }
    function contentEqualsIgnoreCaseImpl(_this__u8e3s4, other) {
        var tmp;
        if (!(_this__u8e3s4 == null) ? typeof _this__u8e3s4 === "string" : false) tmp = !(other == null) ? typeof other === "string" : false;
        else tmp = false;
        if (tmp) return equals_0(_this__u8e3s4, other, true);
        if (_this__u8e3s4 === other) return true;
        if (_this__u8e3s4 == null || other == null || !(charSequenceLength(_this__u8e3s4) === charSequenceLength(other))) return false;
        var inductionVariable = 0;
        var last = charSequenceLength(_this__u8e3s4);
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals_1(charSequenceGet(_this__u8e3s4, i), charSequenceGet(other, i), true)) return false;
        }while (inductionVariable < last);
        return true;
    }
    function contentEqualsImpl(_this__u8e3s4, other) {
        var tmp;
        if (!(_this__u8e3s4 == null) ? typeof _this__u8e3s4 === "string" : false) tmp = !(other == null) ? typeof other === "string" : false;
        else tmp = false;
        if (tmp) return equals(_this__u8e3s4, other);
        if (_this__u8e3s4 === other) return true;
        if (_this__u8e3s4 == null || other == null || !(charSequenceLength(_this__u8e3s4) === charSequenceLength(other))) return false;
        var inductionVariable = 0;
        var last = charSequenceLength(_this__u8e3s4);
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(charSequenceGet(_this__u8e3s4, i) === charSequenceGet(other, i))) return false;
        }while (inductionVariable < last);
        return true;
    }
    function lines(_this__u8e3s4) {
        return toList_2(lineSequence(_this__u8e3s4));
    }
    function toBooleanStrictOrNull(_this__u8e3s4) {
        switch(_this__u8e3s4){
            case "true":
                return true;
            case "false":
                return false;
            default:
                return null;
        }
    }
    function contains_8(_this__u8e3s4, other, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var tmp;
        if (typeof other === "string") tmp = indexOf_5(_this__u8e3s4, other, VOID, ignoreCase) >= 0;
        else tmp = indexOf_6(_this__u8e3s4, other, 0, charSequenceLength(_this__u8e3s4), ignoreCase) >= 0;
        return tmp;
    }
    function split_1(_this__u8e3s4, delimiters, ignoreCase, limit) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        limit = limit === VOID ? 0 : limit;
        if (delimiters.length === 1) return split_0(_this__u8e3s4, toString(delimiters[0]), ignoreCase, limit);
        // Inline function 'kotlin.collections.map' call
        var this_0 = asIterable(rangesDelimitedBy_0(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlin.text.split.<anonymous>' call
            var tmp$ret$0 = substring(_this__u8e3s4, item);
            destination.e(tmp$ret$0);
        }
        return destination;
    }
    function rangesDelimitedBy_0(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        limit = limit === VOID ? 0 : limit;
        requireNonNegativeLimit(limit);
        return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda_0(delimiters, ignoreCase));
    }
    function rangesDelimitedBy$lambda($delimitersList, $ignoreCase) {
        return function($this$$receiver, currentIndex) {
            var tmp0_safe_receiver = findAnyOf($this$$receiver, $delimitersList, currentIndex, $ignoreCase, false);
            var tmp;
            if (tmp0_safe_receiver == null) tmp = null;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.text.rangesDelimitedBy.<anonymous>.<anonymous>' call
            tmp = to(tmp0_safe_receiver.z9_1, tmp0_safe_receiver.aa_1.length);
            return tmp;
        };
    }
    function splitToSequence$lambda($this_splitToSequence) {
        return function(it) {
            return substring($this_splitToSequence, it);
        };
    }
    function rangesDelimitedBy$lambda_0($delimiters, $ignoreCase) {
        return function($this$$receiver, currentIndex) {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.text.rangesDelimitedBy.<anonymous>.<anonymous>' call
            var it = indexOfAny($this$$receiver, $delimiters, currentIndex, $ignoreCase);
            return it < 0 ? null : to(it, 1);
        };
    }
    function _Duration___init__impl__kdtzql(rawValue) {
        {
            if (isInNanos(rawValue)) {
                var containsArg = _get_value__a43j40_0(rawValue);
                if (!(new Long(387905, -1073741824).j1(containsArg) <= 0 ? containsArg.j1(new Long(-387905, 1073741823)) <= 0 : false)) throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + " ns is out of nanoseconds range");
            } else {
                var containsArg_0 = _get_value__a43j40_0(rawValue);
                if (!(new Long(1, -1073741824).j1(containsArg_0) <= 0 ? containsArg_0.j1(new Long(-1, 1073741823)) <= 0 : false)) throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + " ms is out of milliseconds range");
                var containsArg_1 = _get_value__a43j40_0(rawValue);
                if (new Long(1108857478, -1074).j1(containsArg_1) <= 0 ? containsArg_1.j1(new Long(-1108857478, 1073)) <= 0 : false) throw AssertionError_init_$Create$_0(_get_value__a43j40_0(rawValue).toString() + " ms is denormalized");
            }
        }
        return rawValue;
    }
    function _get_rawValue__5zfu4e($this) {
        return $this;
    }
    function _get_value__a43j40_0($this) {
        return _get_rawValue__5zfu4e($this).i3(1);
    }
    function isInNanos($this) {
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        return (_get_rawValue__5zfu4e($this).l1() & 1) === 0;
    }
    function isInMillis($this) {
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        return (_get_rawValue__5zfu4e($this).l1() & 1) === 1;
    }
    function _get_storageUnit__szjgha($this) {
        return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
    }
    function Companion_15() {
        Companion_instance_15 = this;
        this.ti_1 = _Duration___init__impl__kdtzql(new Long(0, 0));
        this.ui_1 = durationOfMillis(new Long(-1, 1073741823));
        this.vi_1 = durationOfMillis(new Long(1, -1073741824));
    }
    protoOf(Companion_15).wi = function(value) {
        var tmp;
        try {
            tmp = parseDuration(value, true);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throw IllegalArgumentException_init_$Create$_1("Invalid ISO duration string format: '" + value + "'.", e);
            } else throw $p;
        }
        return tmp;
    };
    var Companion_instance_15;
    function Companion_getInstance_15() {
        if (Companion_instance_15 == null) new Companion_15();
        return Companion_instance_15;
    }
    function Duration__unaryMinus_impl_x2k1y0($this) {
        var tmp = _get_value__a43j40_0($this).f3();
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        var tmp$ret$0 = _get_rawValue__5zfu4e($this).l1() & 1;
        return durationOf(tmp, tmp$ret$0);
    }
    function Duration__plus_impl_yu9v8f($this, other) {
        if (Duration__isInfinite_impl_tsn9y3($this)) {
            if (Duration__isFinite_impl_rzjsps(other) || _get_rawValue__5zfu4e($this).m3(_get_rawValue__5zfu4e(other)).j1(new Long(0, 0)) >= 0) return $this;
            else throw IllegalArgumentException_init_$Create$_0("Summing infinite durations of different signs yields an undefined result.");
        } else if (Duration__isInfinite_impl_tsn9y3(other)) return other;
        var tmp;
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        var tmp_0 = _get_rawValue__5zfu4e($this).l1() & 1;
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        if (tmp_0 === (_get_rawValue__5zfu4e(other).l1() & 1)) {
            var result = _get_value__a43j40_0($this).y2(_get_value__a43j40_0(other));
            tmp = isInNanos($this) ? durationOfNanosNormalized(result) : durationOfMillisNormalized(result);
        } else if (isInMillis($this)) tmp = addValuesMixedRanges($this, _get_value__a43j40_0($this), _get_value__a43j40_0(other));
        else tmp = addValuesMixedRanges($this, _get_value__a43j40_0(other), _get_value__a43j40_0($this));
        return tmp;
    }
    function addValuesMixedRanges($this, thisMillis, otherNanos) {
        var otherMillis = nanosToMillis(otherNanos);
        var resultMillis = thisMillis.y2(otherMillis);
        var tmp;
        if (new Long(1108857478, -1074).j1(resultMillis) <= 0 ? resultMillis.j1(new Long(-1108857478, 1073)) <= 0 : false) {
            var otherNanoRemainder = otherNanos.z2(millisToNanos(otherMillis));
            tmp = durationOfNanos(millisToNanos(resultMillis).y2(otherNanoRemainder));
        } else tmp = durationOfMillis(coerceIn(resultMillis, new Long(1, -1073741824), new Long(-1, 1073741823)));
        return tmp;
    }
    function Duration__isNegative_impl_pbysfa($this) {
        return _get_rawValue__5zfu4e($this).j1(new Long(0, 0)) < 0;
    }
    function Duration__isInfinite_impl_tsn9y3($this) {
        return _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_15().ui_1)) || _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_15().vi_1));
    }
    function Duration__isFinite_impl_rzjsps($this) {
        return !Duration__isInfinite_impl_tsn9y3($this);
    }
    function _Duration___get_absoluteValue__impl__vr7i6w($this) {
        return Duration__isNegative_impl_pbysfa($this) ? Duration__unaryMinus_impl_x2k1y0($this) : $this;
    }
    function Duration__compareTo_impl_pchp0f($this, other) {
        var compareBits = _get_rawValue__5zfu4e($this).m3(_get_rawValue__5zfu4e(other));
        if (compareBits.j1(new Long(0, 0)) < 0 || (compareBits.l1() & 1) === 0) return _get_rawValue__5zfu4e($this).j1(_get_rawValue__5zfu4e(other));
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        var tmp = _get_rawValue__5zfu4e($this).l1() & 1;
        // Inline function 'kotlin.time.Duration.unitDiscriminator' call
        var r = tmp - (_get_rawValue__5zfu4e(other).l1() & 1) | 0;
        return Duration__isNegative_impl_pbysfa($this) ? -r | 0 : r;
    }
    function Duration__compareTo_impl_pchp0f_0($this, other) {
        return Duration__compareTo_impl_pchp0f($this.xi_1, other instanceof Duration ? other.xi_1 : THROW_CCE());
    }
    function _Duration___get_hoursComponent__impl__7hllxa($this) {
        var tmp;
        if (Duration__isInfinite_impl_tsn9y3($this)) tmp = 0;
        else // Inline function 'kotlin.Long.rem' call
        tmp = _Duration___get_inWholeHours__impl__kb9f3j($this).c3(toLong(24)).l1();
        return tmp;
    }
    function _Duration___get_minutesComponent__impl__ctvd8u($this) {
        var tmp;
        if (Duration__isInfinite_impl_tsn9y3($this)) tmp = 0;
        else // Inline function 'kotlin.Long.rem' call
        tmp = _Duration___get_inWholeMinutes__impl__dognoh($this).c3(toLong(60)).l1();
        return tmp;
    }
    function _Duration___get_secondsComponent__impl__if34a6($this) {
        var tmp;
        if (Duration__isInfinite_impl_tsn9y3($this)) tmp = 0;
        else // Inline function 'kotlin.Long.rem' call
        tmp = _Duration___get_inWholeSeconds__impl__hpy7b3($this).c3(toLong(60)).l1();
        return tmp;
    }
    function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
        var tmp;
        if (Duration__isInfinite_impl_tsn9y3($this)) tmp = 0;
        else if (isInMillis($this)) {
            // Inline function 'kotlin.Long.rem' call
            var tmp$ret$0 = _get_value__a43j40_0($this).c3(toLong(1000));
            tmp = millisToNanos(tmp$ret$0).l1();
        } else {
            // Inline function 'kotlin.Long.rem' call
            var this_0 = _get_value__a43j40_0($this);
            var other = 1000000000;
            tmp = this_0.c3(toLong(other)).l1();
        }
        return tmp;
    }
    function Duration__toLong_impl_shr43i($this, unit) {
        var tmp0_subject = _get_rawValue__5zfu4e($this);
        return tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_15().ui_1)) ? new Long(-1, 2147483647) : tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_15().vi_1)) ? new Long(0, -2147483648) : convertDurationUnit_0(_get_value__a43j40_0($this), _get_storageUnit__szjgha($this), unit);
    }
    function _Duration___get_inWholeDays__impl__7bvpxz($this) {
        return Duration__toLong_impl_shr43i($this, DurationUnit_DAYS_getInstance());
    }
    function _Duration___get_inWholeHours__impl__kb9f3j($this) {
        return Duration__toLong_impl_shr43i($this, DurationUnit_HOURS_getInstance());
    }
    function _Duration___get_inWholeMinutes__impl__dognoh($this) {
        return Duration__toLong_impl_shr43i($this, DurationUnit_MINUTES_getInstance());
    }
    function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
        return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
    }
    function Duration__toString_impl_8d916b($this) {
        var tmp0_subject = _get_rawValue__5zfu4e($this);
        var tmp;
        if (tmp0_subject.equals(new Long(0, 0))) tmp = "0s";
        else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_15().ui_1))) tmp = "Infinity";
        else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_15().vi_1))) tmp = "-Infinity";
        else {
            var isNegative = Duration__isNegative_impl_pbysfa($this);
            // Inline function 'kotlin.text.buildString' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.apply' call
            var this_0 = StringBuilder_init_$Create$_0();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.time.Duration.toString.<anonymous>' call
            if (isNegative) this_0.f8(_Char___init__impl__6a9atx(45));
            // Inline function 'kotlin.time.Duration.toComponents' call
            var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
            // Inline function 'kotlin.contracts.contract' call
            var days = _Duration___get_inWholeDays__impl__7bvpxz(this_1);
            var hours = _Duration___get_hoursComponent__impl__7hllxa(this_1);
            var minutes = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
            var seconds = _Duration___get_secondsComponent__impl__if34a6(this_1);
            var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
            var hasDays = !days.equals(new Long(0, 0));
            var hasHours = !(hours === 0);
            var hasMinutes = !(minutes === 0);
            var hasSeconds = !(seconds === 0) || !(nanoseconds === 0);
            var components = 0;
            if (hasDays) {
                this_0.tb(days).f8(_Char___init__impl__6a9atx(100));
                components = components + 1 | 0;
            }
            if (hasHours || hasDays && (hasMinutes || hasSeconds)) {
                var tmp1 = components;
                components = tmp1 + 1 | 0;
                if (tmp1 > 0) this_0.f8(_Char___init__impl__6a9atx(32));
                this_0.sb(hours).f8(_Char___init__impl__6a9atx(104));
            }
            if (hasMinutes || hasSeconds && (hasHours || hasDays)) {
                var tmp2 = components;
                components = tmp2 + 1 | 0;
                if (tmp2 > 0) this_0.f8(_Char___init__impl__6a9atx(32));
                this_0.sb(minutes).f8(_Char___init__impl__6a9atx(109));
            }
            if (hasSeconds) {
                var tmp3 = components;
                components = tmp3 + 1 | 0;
                if (tmp3 > 0) this_0.f8(_Char___init__impl__6a9atx(32));
                if (!(seconds === 0) || hasDays || hasHours || hasMinutes) appendFractional(this_0, $this, seconds, nanoseconds, 9, "s", false);
                else if (nanoseconds >= 1000000) appendFractional(this_0, $this, nanoseconds / 1000000 | 0, nanoseconds % 1000000 | 0, 6, "ms", false);
                else if (nanoseconds >= 1000) appendFractional(this_0, $this, nanoseconds / 1000 | 0, nanoseconds % 1000 | 0, 3, "us", false);
                else this_0.sb(nanoseconds).e8("ns");
            }
            if (isNegative && components > 1) this_0.ub(1, _Char___init__impl__6a9atx(40)).f8(_Char___init__impl__6a9atx(41));
            tmp = this_0.toString();
        }
        return tmp;
    }
    function appendFractional(_this__u8e3s4, $this, whole, fractional, fractionalSize, unit, isoZeroes) {
        _this__u8e3s4.sb(whole);
        if (!(fractional === 0)) {
            _this__u8e3s4.f8(_Char___init__impl__6a9atx(46));
            var fracString = padStart(fractional.toString(), fractionalSize, _Char___init__impl__6a9atx(48));
            var tmp$ret$1;
            $l$block: {
                // Inline function 'kotlin.text.indexOfLast' call
                var inductionVariable = charSequenceLength(fracString) - 1 | 0;
                if (0 <= inductionVariable) do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + -1 | 0;
                    // Inline function 'kotlin.time.Duration.appendFractional.<anonymous>' call
                    if (!(charSequenceGet(fracString, index) === _Char___init__impl__6a9atx(48))) {
                        tmp$ret$1 = index;
                        break $l$block;
                    }
                }while (0 <= inductionVariable);
                tmp$ret$1 = -1;
            }
            var nonZeroDigits = tmp$ret$1 + 1 | 0;
            if (!isoZeroes && nonZeroDigits < 3) _this__u8e3s4.rb(fracString, 0, nonZeroDigits);
            else _this__u8e3s4.rb(fracString, 0, imul((nonZeroDigits + 2 | 0) / 3 | 0, 3));
        }
        _this__u8e3s4.e8(unit);
    }
    function Duration__toIsoString_impl_9h6wsm($this) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$_0();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.time.Duration.toIsoString.<anonymous>' call
        if (Duration__isNegative_impl_pbysfa($this)) this_0.f8(_Char___init__impl__6a9atx(45));
        this_0.e8("PT");
        // Inline function 'kotlin.time.Duration.toComponents' call
        var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
        // Inline function 'kotlin.contracts.contract' call
        var hours = _Duration___get_inWholeHours__impl__kb9f3j(this_1);
        var minutes = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
        var seconds = _Duration___get_secondsComponent__impl__if34a6(this_1);
        var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
        var hours_0 = hours;
        if (Duration__isInfinite_impl_tsn9y3($this)) hours_0 = new Long(1316134911, 2328);
        var hasHours = !hours_0.equals(new Long(0, 0));
        var hasSeconds = !(seconds === 0) || !(nanoseconds === 0);
        var hasMinutes = !(minutes === 0) || hasSeconds && hasHours;
        if (hasHours) this_0.tb(hours_0).f8(_Char___init__impl__6a9atx(72));
        if (hasMinutes) this_0.sb(minutes).f8(_Char___init__impl__6a9atx(77));
        if (hasSeconds || !hasHours && !hasMinutes) appendFractional(this_0, $this, seconds, nanoseconds, 9, "S", true);
        return this_0.toString();
    }
    function Duration__hashCode_impl_u4exz6($this) {
        return $this.hashCode();
    }
    function Duration__equals_impl_ygj6w6($this, other) {
        if (!(other instanceof Duration)) return false;
        var tmp0_other_with_cast = other instanceof Duration ? other.xi_1 : THROW_CCE();
        if (!$this.equals(tmp0_other_with_cast)) return false;
        return true;
    }
    function Duration(rawValue) {
        Companion_getInstance_15();
        this.xi_1 = rawValue;
    }
    protoOf(Duration).yi = function(other) {
        return Duration__compareTo_impl_pchp0f(this.xi_1, other);
    };
    protoOf(Duration).d = function(other) {
        return Duration__compareTo_impl_pchp0f_0(this, other);
    };
    protoOf(Duration).toString = function() {
        return Duration__toString_impl_8d916b(this.xi_1);
    };
    protoOf(Duration).hashCode = function() {
        return Duration__hashCode_impl_u4exz6(this.xi_1);
    };
    protoOf(Duration).equals = function(other) {
        return Duration__equals_impl_ygj6w6(this.xi_1, other);
    };
    function durationOfMillis(normalMillis) {
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$0 = normalMillis.h3(1).y2(toLong(1));
        return _Duration___init__impl__kdtzql(tmp$ret$0);
    }
    function toDuration(_this__u8e3s4, unit) {
        var maxNsInUnit = convertDurationUnitOverflow(new Long(-387905, 1073741823), DurationUnit_NANOSECONDS_getInstance(), unit);
        if (maxNsInUnit.f3().j1(_this__u8e3s4) <= 0 ? _this__u8e3s4.j1(maxNsInUnit) <= 0 : false) return durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
        else {
            var millis = convertDurationUnit_0(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance());
            return durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
        }
    }
    function toDuration_0(_this__u8e3s4, unit) {
        var valueInNs = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance());
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!isNaN_0(valueInNs)) {
            // Inline function 'kotlin.time.toDuration.<anonymous>' call
            var message = "Duration value cannot be NaN.";
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        var nanos = roundToLong(valueInNs);
        var tmp;
        if (new Long(387905, -1073741824).j1(nanos) <= 0 ? nanos.j1(new Long(-387905, 1073741823)) <= 0 : false) tmp = durationOfNanos(nanos);
        else {
            var millis = roundToLong(convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()));
            tmp = durationOfMillisNormalized(millis);
        }
        return tmp;
    }
    function parseDuration(value, strictIso) {
        var length = value.length;
        if (length === 0) throw IllegalArgumentException_init_$Create$_0("The string is empty");
        var index = 0;
        var result = Companion_getInstance_15().ti_1;
        var infinityString = "Infinity";
        var tmp0_subject = charSequenceGet(value, index);
        if (tmp0_subject === _Char___init__impl__6a9atx(43) ? true : tmp0_subject === _Char___init__impl__6a9atx(45)) index = index + 1 | 0;
        var hasSign = index > 0;
        var isNegative = hasSign && startsWith_1(value, _Char___init__impl__6a9atx(45));
        if (length <= index) throw IllegalArgumentException_init_$Create$_0("No components");
        else if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(80)) {
            index = index + 1 | 0;
            if (index === length) throw IllegalArgumentException_init_$Create$();
            var nonDigitSymbols = "+-.";
            var isTimeComponent = false;
            var prevUnit = null;
            $l$loop: while(index < length){
                if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(84)) {
                    var tmp;
                    if (isTimeComponent) tmp = true;
                    else {
                        index = index + 1 | 0;
                        tmp = index === length;
                    }
                    if (tmp) throw IllegalArgumentException_init_$Create$();
                    isTimeComponent = true;
                    continue $l$loop;
                }
                // Inline function 'kotlin.time.substringWhile' call
                var startIndex = index;
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.time.skipWhile' call
                var i = startIndex;
                $l$loop_0: while(true){
                    var tmp_0;
                    if (i < value.length) {
                        // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                        var it = charSequenceGet(value, i);
                        tmp_0 = (_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false) || contains_7(nonDigitSymbols, it);
                    } else tmp_0 = false;
                    if (!tmp_0) break $l$loop_0;
                    i = i + 1 | 0;
                }
                var endIndex = i;
                // Inline function 'kotlin.js.asDynamic' call
                var component = value.substring(startIndex, endIndex);
                // Inline function 'kotlin.text.isEmpty' call
                if (charSequenceLength(component) === 0) throw IllegalArgumentException_init_$Create$();
                index = index + component.length | 0;
                // Inline function 'kotlin.text.getOrElse' call
                var index_0 = index;
                // Inline function 'kotlin.contracts.contract' call
                var tmp_1;
                if (0 <= index_0 ? index_0 <= (charSequenceLength(value) - 1 | 0) : false) tmp_1 = charSequenceGet(value, index_0);
                else throw IllegalArgumentException_init_$Create$_0("Missing unit for value " + component);
                var unitChar = tmp_1;
                index = index + 1 | 0;
                var unit = durationUnitByIsoChar(unitChar, isTimeComponent);
                if (!(prevUnit == null) && prevUnit.t2(unit) <= 0) throw IllegalArgumentException_init_$Create$_0("Unexpected order of duration components");
                prevUnit = unit;
                var dotIndex = indexOf_4(component, _Char___init__impl__6a9atx(46));
                if (unit.equals(DurationUnit_SECONDS_getInstance()) && dotIndex > 0) {
                    // Inline function 'kotlin.text.substring' call
                    // Inline function 'kotlin.js.asDynamic' call
                    var whole = component.substring(0, dotIndex);
                    result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(whole), unit));
                    var tmp_2 = result;
                    // Inline function 'kotlin.text.substring' call
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp$ret$10 = component.substring(dotIndex);
                    result = Duration__plus_impl_yu9v8f(tmp_2, toDuration_0(toDouble(tmp$ret$10), unit));
                } else result = Duration__plus_impl_yu9v8f(result, toDuration(parseOverLongIsoComponent(component), unit));
            }
        } else {
            if (strictIso) throw IllegalArgumentException_init_$Create$();
            else {
                var tmp_3 = index;
                // Inline function 'kotlin.comparisons.maxOf' call
                var a = length - index | 0;
                var b = infinityString.length;
                var tmp$ret$11 = Math.max(a, b);
                if (regionMatches(value, tmp_3, infinityString, 0, tmp$ret$11, true)) result = Companion_getInstance_15().ui_1;
                else {
                    var prevUnit_0 = null;
                    var afterFirst = false;
                    var allowSpaces = !hasSign;
                    if (hasSign && charSequenceGet(value, index) === _Char___init__impl__6a9atx(40) && last_1(value) === _Char___init__impl__6a9atx(41)) {
                        allowSpaces = true;
                        index = index + 1 | 0;
                        var tmp_4 = index;
                        length = length - 1 | 0;
                        if (tmp_4 === length) throw IllegalArgumentException_init_$Create$_0("No components");
                    }
                    while(index < length){
                        if (afterFirst && allowSpaces) {
                            // Inline function 'kotlin.time.skipWhile' call
                            var i_0 = index;
                            $l$loop_1: while(true){
                                var tmp_5;
                                if (i_0 < value.length) // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                                tmp_5 = charSequenceGet(value, i_0) === _Char___init__impl__6a9atx(32);
                                else tmp_5 = false;
                                if (!tmp_5) break $l$loop_1;
                                i_0 = i_0 + 1 | 0;
                            }
                            index = i_0;
                        }
                        afterFirst = true;
                        // Inline function 'kotlin.time.substringWhile' call
                        var startIndex_0 = index;
                        // Inline function 'kotlin.text.substring' call
                        // Inline function 'kotlin.time.skipWhile' call
                        var i_1 = startIndex_0;
                        $l$loop_2: while(true){
                            var tmp_6;
                            if (i_1 < value.length) {
                                // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                                var it_0 = charSequenceGet(value, i_1);
                                tmp_6 = (_Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false) || it_0 === _Char___init__impl__6a9atx(46);
                            } else tmp_6 = false;
                            if (!tmp_6) break $l$loop_2;
                            i_1 = i_1 + 1 | 0;
                        }
                        var endIndex_0 = i_1;
                        // Inline function 'kotlin.js.asDynamic' call
                        var component_0 = value.substring(startIndex_0, endIndex_0);
                        // Inline function 'kotlin.text.isEmpty' call
                        if (charSequenceLength(component_0) === 0) throw IllegalArgumentException_init_$Create$();
                        index = index + component_0.length | 0;
                        // Inline function 'kotlin.time.substringWhile' call
                        var startIndex_1 = index;
                        // Inline function 'kotlin.text.substring' call
                        // Inline function 'kotlin.time.skipWhile' call
                        var i_2 = startIndex_1;
                        $l$loop_3: while(true){
                            var tmp_7;
                            if (i_2 < value.length) {
                                // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                                var it_1 = charSequenceGet(value, i_2);
                                tmp_7 = _Char___init__impl__6a9atx(97) <= it_1 ? it_1 <= _Char___init__impl__6a9atx(122) : false;
                            } else tmp_7 = false;
                            if (!tmp_7) break $l$loop_3;
                            i_2 = i_2 + 1 | 0;
                        }
                        var endIndex_1 = i_2;
                        // Inline function 'kotlin.js.asDynamic' call
                        var unitName = value.substring(startIndex_1, endIndex_1);
                        index = index + unitName.length | 0;
                        var unit_0 = durationUnitByShortName(unitName);
                        if (!(prevUnit_0 == null) && prevUnit_0.t2(unit_0) <= 0) throw IllegalArgumentException_init_$Create$_0("Unexpected order of duration components");
                        prevUnit_0 = unit_0;
                        var dotIndex_0 = indexOf_4(component_0, _Char___init__impl__6a9atx(46));
                        if (dotIndex_0 > 0) {
                            // Inline function 'kotlin.text.substring' call
                            // Inline function 'kotlin.js.asDynamic' call
                            var whole_0 = component_0.substring(0, dotIndex_0);
                            result = Duration__plus_impl_yu9v8f(result, toDuration(toLong_0(whole_0), unit_0));
                            var tmp_8 = result;
                            // Inline function 'kotlin.text.substring' call
                            // Inline function 'kotlin.js.asDynamic' call
                            var tmp$ret$28 = component_0.substring(dotIndex_0);
                            result = Duration__plus_impl_yu9v8f(tmp_8, toDuration_0(toDouble(tmp$ret$28), unit_0));
                            if (index < length) throw IllegalArgumentException_init_$Create$_0("Fractional component must be last");
                        } else result = Duration__plus_impl_yu9v8f(result, toDuration(toLong_0(component_0), unit_0));
                    }
                }
            }
        }
        return isNegative ? Duration__unaryMinus_impl_x2k1y0(result) : result;
    }
    function durationOf(normalValue, unitDiscriminator) {
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$0 = normalValue.h3(1).y2(toLong(unitDiscriminator));
        return _Duration___init__impl__kdtzql(tmp$ret$0);
    }
    function durationOfNanosNormalized(nanos) {
        var tmp;
        if (new Long(387905, -1073741824).j1(nanos) <= 0 ? nanos.j1(new Long(-387905, 1073741823)) <= 0 : false) tmp = durationOfNanos(nanos);
        else tmp = durationOfMillis(nanosToMillis(nanos));
        return tmp;
    }
    function durationOfMillisNormalized(millis) {
        var tmp;
        if (new Long(1108857478, -1074).j1(millis) <= 0 ? millis.j1(new Long(-1108857478, 1073)) <= 0 : false) tmp = durationOfNanos(millisToNanos(millis));
        else tmp = durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
        return tmp;
    }
    function nanosToMillis(nanos) {
        // Inline function 'kotlin.Long.div' call
        return nanos.b3(toLong(1000000));
    }
    function millisToNanos(millis) {
        // Inline function 'kotlin.Long.times' call
        return millis.a3(toLong(1000000));
    }
    function durationOfNanos(normalNanos) {
        return _Duration___init__impl__kdtzql(normalNanos.h3(1));
    }
    function parseOverLongIsoComponent(value) {
        var length = value.length;
        var startIndex = 0;
        if (length > 0 && contains_7("+-", charSequenceGet(value, 0))) startIndex = startIndex + 1 | 0;
        var tmp;
        if ((length - startIndex | 0) > 16) {
            var tmp$ret$0;
            $l$block_0: {
                // Inline function 'kotlin.collections.all' call
                var this_0 = numberRangeToNumber(startIndex, get_lastIndex_3(value));
                var tmp_0;
                if (isInterface(this_0, Collection)) tmp_0 = this_0.s();
                else tmp_0 = false;
                if (tmp_0) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                }
                var tmp0_iterator = this_0.j();
                while(tmp0_iterator.k()){
                    var element = tmp0_iterator.l();
                    // Inline function 'kotlin.time.parseOverLongIsoComponent.<anonymous>' call
                    var containsArg = charSequenceGet(value, element);
                    if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false)) {
                        tmp$ret$0 = false;
                        break $l$block_0;
                    }
                }
                tmp$ret$0 = true;
            }
            tmp = tmp$ret$0;
        } else tmp = false;
        if (tmp) return charSequenceGet(value, 0) === _Char___init__impl__6a9atx(45) ? new Long(0, -2147483648) : new Long(-1, 2147483647);
        return startsWith(value, "+") ? toLong_0(drop_0(value, 1)) : toLong_0(value);
    }
    function durationUnitByIsoChar(isoChar, isTimeComponent) {
        var tmp;
        if (!isTimeComponent) {
            var tmp_0;
            if (isoChar === _Char___init__impl__6a9atx(68)) tmp_0 = DurationUnit_DAYS_getInstance();
            else throw IllegalArgumentException_init_$Create$_0("Invalid or unsupported duration ISO non-time unit: " + toString(isoChar));
            tmp = tmp_0;
        } else {
            var tmp_1;
            if (isoChar === _Char___init__impl__6a9atx(72)) tmp_1 = DurationUnit_HOURS_getInstance();
            else if (isoChar === _Char___init__impl__6a9atx(77)) tmp_1 = DurationUnit_MINUTES_getInstance();
            else if (isoChar === _Char___init__impl__6a9atx(83)) tmp_1 = DurationUnit_SECONDS_getInstance();
            else throw IllegalArgumentException_init_$Create$_0("Invalid duration ISO time unit: " + toString(isoChar));
            tmp = tmp_1;
        }
        return tmp;
    }
    function durationUnitByShortName(shortName) {
        var tmp;
        switch(shortName){
            case "ns":
                tmp = DurationUnit_NANOSECONDS_getInstance();
                break;
            case "us":
                tmp = DurationUnit_MICROSECONDS_getInstance();
                break;
            case "ms":
                tmp = DurationUnit_MILLISECONDS_getInstance();
                break;
            case "s":
                tmp = DurationUnit_SECONDS_getInstance();
                break;
            case "m":
                tmp = DurationUnit_MINUTES_getInstance();
                break;
            case "h":
                tmp = DurationUnit_HOURS_getInstance();
                break;
            case "d":
                tmp = DurationUnit_DAYS_getInstance();
                break;
            default:
                throw IllegalArgumentException_init_$Create$_0("Unknown duration unit short name: " + shortName);
        }
        return tmp;
    }
    function get_UNDEFINED_RESULT() {
        _init_properties_DeepRecursive_kt__zbwcac();
        return UNDEFINED_RESULT;
    }
    var UNDEFINED_RESULT;
    function DeepRecursiveScope() {}
    function invoke(_this__u8e3s4, value) {
        _init_properties_DeepRecursive_kt__zbwcac();
        return new DeepRecursiveScopeImpl(_this__u8e3s4.aj_1, value).fj();
    }
    function DeepRecursiveFunction(block) {
        this.aj_1 = block;
    }
    function DeepRecursiveScopeImpl(block, value) {
        DeepRecursiveScope.call(this);
        var tmp = this;
        tmp.bj_1 = isSuspendFunction(block, 2) ? block : THROW_CCE();
        this.cj_1 = value;
        var tmp_0 = this;
        tmp_0.dj_1 = isInterface(this, Continuation) ? this : THROW_CCE();
        this.ej_1 = get_UNDEFINED_RESULT();
    }
    protoOf(DeepRecursiveScopeImpl).b9 = function() {
        return EmptyCoroutineContext_getInstance();
    };
    protoOf(DeepRecursiveScopeImpl).gj = function(result) {
        this.dj_1 = null;
        this.ej_1 = result;
    };
    protoOf(DeepRecursiveScopeImpl).g9 = function(result) {
        return this.gj(result);
    };
    protoOf(DeepRecursiveScopeImpl).zi = function(value, $completion) {
        // Inline function 'kotlin.DeepRecursiveScopeImpl.callRecursive.<anonymous>' call
        var tmp = this;
        tmp.dj_1 = isInterface($completion, Continuation) ? $completion : THROW_CCE();
        this.cj_1 = value;
        return get_COROUTINE_SUSPENDED();
    };
    protoOf(DeepRecursiveScopeImpl).fj = function() {
        $l$loop: while(true){
            var result = this.ej_1;
            var tmp0_elvis_lhs = this.dj_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.getOrThrow' call
                var this_0 = new Result(result) instanceof Result ? result : THROW_CCE();
                throwOnFailure(this_0);
                var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
                return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            } else tmp = tmp0_elvis_lhs;
            var cont = tmp;
            if (equals(get_UNDEFINED_RESULT(), result)) {
                var tmp_1;
                try {
                    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
                    var this_1 = this.bj_1;
                    var param = this.cj_1;
                    // Inline function 'kotlin.js.asDynamic' call
                    var a = this_1;
                    tmp_1 = typeof a === "function" ? a(this, param, cont) : this_1.hj(this, param, cont);
                } catch ($p) {
                    var tmp_2;
                    if ($p instanceof Error) {
                        var e = $p;
                        // Inline function 'kotlin.coroutines.resumeWithException' call
                        // Inline function 'kotlin.Companion.failure' call
                        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(e));
                        cont.g9(tmp$ret$3);
                        continue $l$loop;
                    } else throw $p;
                }
                var r = tmp_1;
                if (!(r === get_COROUTINE_SUSPENDED())) {
                    // Inline function 'kotlin.coroutines.resume' call
                    // Inline function 'kotlin.Companion.success' call
                    var value = (r == null ? true : !(r == null)) ? r : THROW_CCE();
                    var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
                    cont.g9(tmp$ret$5);
                }
            } else {
                this.ej_1 = get_UNDEFINED_RESULT();
                cont.g9(result);
            }
        }
    };
    var properties_initialized_DeepRecursive_kt_5z0al2;
    function _init_properties_DeepRecursive_kt__zbwcac() {
        if (!properties_initialized_DeepRecursive_kt_5z0al2) {
            properties_initialized_DeepRecursive_kt_5z0al2 = true;
            // Inline function 'kotlin.Companion.success' call
            var value = get_COROUTINE_SUSPENDED();
            UNDEFINED_RESULT = _Result___init__impl__xyqfz8(value);
        }
    }
    var LazyThreadSafetyMode_SYNCHRONIZED_instance;
    var LazyThreadSafetyMode_PUBLICATION_instance;
    var LazyThreadSafetyMode_NONE_instance;
    var LazyThreadSafetyMode_entriesInitialized;
    function LazyThreadSafetyMode_initEntries() {
        if (LazyThreadSafetyMode_entriesInitialized) return Unit_instance;
        LazyThreadSafetyMode_entriesInitialized = true;
        LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode("SYNCHRONIZED", 0);
        LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode("PUBLICATION", 1);
        LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode("NONE", 2);
    }
    function LazyThreadSafetyMode(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function UnsafeLazyImpl(initializer) {
        this.ij_1 = initializer;
        this.jj_1 = UNINITIALIZED_VALUE_instance;
    }
    protoOf(UnsafeLazyImpl).b1 = function() {
        if (this.jj_1 === UNINITIALIZED_VALUE_instance) {
            this.jj_1 = ensureNotNull(this.ij_1)();
            this.ij_1 = null;
        }
        var tmp = this.jj_1;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(UnsafeLazyImpl).kj = function() {
        return !(this.jj_1 === UNINITIALIZED_VALUE_instance);
    };
    protoOf(UnsafeLazyImpl).toString = function() {
        return this.kj() ? toString_0(this.b1()) : "Lazy value not initialized yet.";
    };
    function UNINITIALIZED_VALUE() {}
    var UNINITIALIZED_VALUE_instance;
    function UNINITIALIZED_VALUE_getInstance() {
        return UNINITIALIZED_VALUE_instance;
    }
    function LazyThreadSafetyMode_PUBLICATION_getInstance() {
        LazyThreadSafetyMode_initEntries();
        return LazyThreadSafetyMode_PUBLICATION_instance;
    }
    function LazyThreadSafetyMode_NONE_getInstance() {
        LazyThreadSafetyMode_initEntries();
        return LazyThreadSafetyMode_NONE_instance;
    }
    function _Result___init__impl__xyqfz8(value) {
        return value;
    }
    function _Result___get_value__impl__bjfvqg($this) {
        return $this;
    }
    function _Result___get_isFailure__impl__jpiriv($this) {
        var tmp = _Result___get_value__impl__bjfvqg($this);
        return tmp instanceof Failure;
    }
    function Result__exceptionOrNull_impl_p6xea9($this) {
        var tmp;
        if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) tmp = _Result___get_value__impl__bjfvqg($this).lj_1;
        else tmp = null;
        return tmp;
    }
    function Result__toString_impl_yu5r8k($this) {
        var tmp;
        if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) tmp = toString_1(_Result___get_value__impl__bjfvqg($this));
        else tmp = "Success(" + toString_0(_Result___get_value__impl__bjfvqg($this)) + ")";
        return tmp;
    }
    function Companion_16() {}
    var Companion_instance_16;
    function Companion_getInstance_16() {
        return Companion_instance_16;
    }
    function Failure(exception) {
        this.lj_1 = exception;
    }
    protoOf(Failure).equals = function(other) {
        var tmp;
        if (other instanceof Failure) tmp = equals(this.lj_1, other.lj_1);
        else tmp = false;
        return tmp;
    };
    protoOf(Failure).hashCode = function() {
        return hashCode(this.lj_1);
    };
    protoOf(Failure).toString = function() {
        return "Failure(" + this.lj_1.toString() + ")";
    };
    function Result__hashCode_impl_d2zufp($this) {
        return $this == null ? 0 : hashCode($this);
    }
    function Result__equals_impl_bxgmep($this, other) {
        if (!(other instanceof Result)) return false;
        var tmp0_other_with_cast = other instanceof Result ? other.mj_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function Result(value) {
        this.mj_1 = value;
    }
    protoOf(Result).toString = function() {
        return Result__toString_impl_yu5r8k(this.mj_1);
    };
    protoOf(Result).hashCode = function() {
        return Result__hashCode_impl_d2zufp(this.mj_1);
    };
    protoOf(Result).equals = function(other) {
        return Result__equals_impl_bxgmep(this.mj_1, other);
    };
    function createFailure(exception) {
        return new Failure(exception);
    }
    function throwOnFailure(_this__u8e3s4) {
        var tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
        if (tmp instanceof Failure) throw _Result___get_value__impl__bjfvqg(_this__u8e3s4).lj_1;
    }
    function NotImplementedError(message) {
        message = message === VOID ? "An operation is not implemented." : message;
        Error_init_$Init$_0(message, this);
        captureStack(this, NotImplementedError);
    }
    function Pair(first, second) {
        this.z9_1 = first;
        this.aa_1 = second;
    }
    protoOf(Pair).toString = function() {
        return "(" + toString_0(this.z9_1) + ", " + toString_0(this.aa_1) + ")";
    };
    protoOf(Pair).ba = function() {
        return this.z9_1;
    };
    protoOf(Pair).ca = function() {
        return this.aa_1;
    };
    protoOf(Pair).hashCode = function() {
        var result = this.z9_1 == null ? 0 : hashCode(this.z9_1);
        result = imul(result, 31) + (this.aa_1 == null ? 0 : hashCode(this.aa_1)) | 0;
        return result;
    };
    protoOf(Pair).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Pair)) return false;
        var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
        if (!equals(this.z9_1, tmp0_other_with_cast.z9_1)) return false;
        if (!equals(this.aa_1, tmp0_other_with_cast.aa_1)) return false;
        return true;
    };
    function to(_this__u8e3s4, that) {
        return new Pair(_this__u8e3s4, that);
    }
    function Triple(first, second, third) {
        this.nj_1 = first;
        this.oj_1 = second;
        this.pj_1 = third;
    }
    protoOf(Triple).toString = function() {
        return "(" + toString_0(this.nj_1) + ", " + toString_0(this.oj_1) + ", " + toString_0(this.pj_1) + ")";
    };
    protoOf(Triple).ba = function() {
        return this.nj_1;
    };
    protoOf(Triple).ca = function() {
        return this.oj_1;
    };
    protoOf(Triple).qj = function() {
        return this.pj_1;
    };
    protoOf(Triple).hashCode = function() {
        var result = this.nj_1 == null ? 0 : hashCode(this.nj_1);
        result = imul(result, 31) + (this.oj_1 == null ? 0 : hashCode(this.oj_1)) | 0;
        result = imul(result, 31) + (this.pj_1 == null ? 0 : hashCode(this.pj_1)) | 0;
        return result;
    };
    protoOf(Triple).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Triple)) return false;
        var tmp0_other_with_cast = other instanceof Triple ? other : THROW_CCE();
        if (!equals(this.nj_1, tmp0_other_with_cast.nj_1)) return false;
        if (!equals(this.oj_1, tmp0_other_with_cast.oj_1)) return false;
        if (!equals(this.pj_1, tmp0_other_with_cast.pj_1)) return false;
        return true;
    };
    function _UByte___init__impl__g9hnc4(data) {
        return data;
    }
    function _UByte___get_data__impl__jof9qr($this) {
        return $this;
    }
    function Companion_17() {
        Companion_instance_17 = this;
        this.rj_1 = _UByte___init__impl__g9hnc4(0);
        this.sj_1 = _UByte___init__impl__g9hnc4(-1);
        this.tj_1 = 1;
        this.uj_1 = 8;
    }
    var Companion_instance_17;
    function Companion_getInstance_17() {
        if (Companion_instance_17 == null) new Companion_17();
        return Companion_instance_17;
    }
    function UByte__compareTo_impl_5w5192($this, other) {
        // Inline function 'kotlin.UByte.toInt' call
        var tmp = _UByte___get_data__impl__jof9qr($this) & 255;
        // Inline function 'kotlin.UByte.toInt' call
        var tmp$ret$1 = _UByte___get_data__impl__jof9qr(other) & 255;
        return compareTo(tmp, tmp$ret$1);
    }
    function UByte__compareTo_impl_5w5192_0($this, other) {
        return UByte__compareTo_impl_5w5192($this.vj_1, other instanceof UByte ? other.vj_1 : THROW_CCE());
    }
    function UByte__toString_impl_v72jg($this) {
        // Inline function 'kotlin.UByte.toInt' call
        return (_UByte___get_data__impl__jof9qr($this) & 255).toString();
    }
    function UByte__hashCode_impl_mmczcb($this) {
        return $this;
    }
    function UByte__equals_impl_nvqtsf($this, other) {
        if (!(other instanceof UByte)) return false;
        if (!($this === (other instanceof UByte ? other.vj_1 : THROW_CCE()))) return false;
        return true;
    }
    function UByte(data) {
        Companion_getInstance_17();
        this.vj_1 = data;
    }
    protoOf(UByte).wj = function(other) {
        return UByte__compareTo_impl_5w5192(this.vj_1, other);
    };
    protoOf(UByte).d = function(other) {
        return UByte__compareTo_impl_5w5192_0(this, other);
    };
    protoOf(UByte).toString = function() {
        return UByte__toString_impl_v72jg(this.vj_1);
    };
    protoOf(UByte).hashCode = function() {
        return UByte__hashCode_impl_mmczcb(this.vj_1);
    };
    protoOf(UByte).equals = function(other) {
        return UByte__equals_impl_nvqtsf(this.vj_1, other);
    };
    function _UByteArray___init__impl__ip4y9n(storage) {
        return storage;
    }
    function _UByteArray___get_storage__impl__d4kctt($this) {
        return $this;
    }
    function _UByteArray___init__impl__ip4y9n_0(size) {
        return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
    }
    function UByteArray__get_impl_t5f3hv($this, index) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
        return _UByte___init__impl__g9hnc4(this_0);
    }
    function UByteArray__set_impl_jvcicn($this, index, value) {
        var tmp = _UByteArray___get_storage__impl__d4kctt($this);
        // Inline function 'kotlin.UByte.toByte' call
        tmp[index] = _UByte___get_data__impl__jof9qr(value);
    }
    function _UByteArray___get_size__impl__h6pkdv($this) {
        return _UByteArray___get_storage__impl__d4kctt($this).length;
    }
    function UByteArray__iterator_impl_509y1p($this) {
        return new Iterator(_UByteArray___get_storage__impl__d4kctt($this));
    }
    function Iterator(array) {
        this.xj_1 = array;
        this.yj_1 = 0;
    }
    protoOf(Iterator).k = function() {
        return this.yj_1 < this.xj_1.length;
    };
    protoOf(Iterator).zj = function() {
        var tmp;
        if (this.yj_1 < this.xj_1.length) {
            // Inline function 'kotlin.toUByte' call
            var tmp1 = this.yj_1;
            this.yj_1 = tmp1 + 1 | 0;
            var this_0 = this.xj_1[tmp1];
            tmp = _UByte___init__impl__g9hnc4(this_0);
        } else throw NoSuchElementException_init_$Create$_0(this.yj_1.toString());
        return tmp;
    };
    protoOf(Iterator).l = function() {
        return new UByte(this.zj());
    };
    function UByteArray__contains_impl_njh19q($this, element) {
        var tmp = (new UByte(element), new UByte(element));
        if (!(tmp instanceof UByte)) return false;
        var tmp_0 = _UByteArray___get_storage__impl__d4kctt($this);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(element);
        return contains_4(tmp_0, tmp$ret$0);
    }
    function UByteArray__contains_impl_njh19q_0($this, element) {
        if (!(element instanceof UByte)) return false;
        return UByteArray__contains_impl_njh19q($this.ak_1, element instanceof UByte ? element.vj_1 : THROW_CCE());
    }
    function UByteArray__containsAll_impl_v9s6dj($this, elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.UByteArray.containsAll.<anonymous>' call
                var tmp_0;
                if (element instanceof UByte) {
                    var tmp_1 = _UByteArray___get_storage__impl__d4kctt($this);
                    // Inline function 'kotlin.UByte.toByte' call
                    var this_1 = element.vj_1;
                    var tmp$ret$1 = _UByte___get_data__impl__jof9qr(this_1);
                    tmp_0 = contains_4(tmp_1, tmp$ret$1);
                } else tmp_0 = false;
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    }
    function UByteArray__containsAll_impl_v9s6dj_0($this, elements) {
        return UByteArray__containsAll_impl_v9s6dj($this.ak_1, elements);
    }
    function UByteArray__isEmpty_impl_nbfqsa($this) {
        return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
    }
    function UByteArray__toString_impl_ukpl97($this) {
        return "UByteArray(storage=" + toString_1($this) + ")";
    }
    function UByteArray__hashCode_impl_ip8jx2($this) {
        return hashCode($this);
    }
    function UByteArray__equals_impl_roka4u($this, other) {
        if (!(other instanceof UByteArray)) return false;
        var tmp0_other_with_cast = other instanceof UByteArray ? other.ak_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function UByteArray(storage) {
        this.ak_1 = storage;
    }
    protoOf(UByteArray).m = function() {
        return _UByteArray___get_size__impl__h6pkdv(this.ak_1);
    };
    protoOf(UByteArray).j = function() {
        return UByteArray__iterator_impl_509y1p(this.ak_1);
    };
    protoOf(UByteArray).bk = function(element) {
        return UByteArray__contains_impl_njh19q(this.ak_1, element);
    };
    protoOf(UByteArray).a2 = function(element) {
        return UByteArray__contains_impl_njh19q_0(this, element);
    };
    protoOf(UByteArray).ck = function(elements) {
        return UByteArray__containsAll_impl_v9s6dj(this.ak_1, elements);
    };
    protoOf(UByteArray).b2 = function(elements) {
        return UByteArray__containsAll_impl_v9s6dj_0(this, elements);
    };
    protoOf(UByteArray).s = function() {
        return UByteArray__isEmpty_impl_nbfqsa(this.ak_1);
    };
    protoOf(UByteArray).toString = function() {
        return UByteArray__toString_impl_ukpl97(this.ak_1);
    };
    protoOf(UByteArray).hashCode = function() {
        return UByteArray__hashCode_impl_ip8jx2(this.ak_1);
    };
    protoOf(UByteArray).equals = function(other) {
        return UByteArray__equals_impl_roka4u(this.ak_1, other);
    };
    function _UInt___init__impl__l7qpdl(data) {
        return data;
    }
    function _UInt___get_data__impl__f0vqqw($this) {
        return $this;
    }
    function Companion_18() {
        Companion_instance_18 = this;
        this.dk_1 = _UInt___init__impl__l7qpdl(0);
        this.ek_1 = _UInt___init__impl__l7qpdl(-1);
        this.fk_1 = 4;
        this.gk_1 = 32;
    }
    var Companion_instance_18;
    function Companion_getInstance_18() {
        if (Companion_instance_18 == null) new Companion_18();
        return Companion_instance_18;
    }
    function UInt__compareTo_impl_yacclj($this, other) {
        return uintCompare(_UInt___get_data__impl__f0vqqw($this), _UInt___get_data__impl__f0vqqw(other));
    }
    function UInt__compareTo_impl_yacclj_0($this, other) {
        return UInt__compareTo_impl_yacclj($this.hk_1, other instanceof UInt ? other.hk_1 : THROW_CCE());
    }
    function UInt__toString_impl_dbgl21($this) {
        // Inline function 'kotlin.uintToString' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw($this);
        return toLong(value).k3(new Long(-1, 0)).toString();
    }
    function UInt__hashCode_impl_z2mhuw($this) {
        return $this;
    }
    function UInt__equals_impl_ffdoxg($this, other) {
        if (!(other instanceof UInt)) return false;
        if (!($this === (other instanceof UInt ? other.hk_1 : THROW_CCE()))) return false;
        return true;
    }
    function UInt(data) {
        Companion_getInstance_18();
        this.hk_1 = data;
    }
    protoOf(UInt).ik = function(other) {
        return UInt__compareTo_impl_yacclj(this.hk_1, other);
    };
    protoOf(UInt).d = function(other) {
        return UInt__compareTo_impl_yacclj_0(this, other);
    };
    protoOf(UInt).toString = function() {
        return UInt__toString_impl_dbgl21(this.hk_1);
    };
    protoOf(UInt).hashCode = function() {
        return UInt__hashCode_impl_z2mhuw(this.hk_1);
    };
    protoOf(UInt).equals = function(other) {
        return UInt__equals_impl_ffdoxg(this.hk_1, other);
    };
    function _UIntArray___init__impl__ghjpc6(storage) {
        return storage;
    }
    function _UIntArray___get_storage__impl__92a0v0($this) {
        return $this;
    }
    function _UIntArray___init__impl__ghjpc6_0(size) {
        return _UIntArray___init__impl__ghjpc6(new Int32Array(size));
    }
    function UIntArray__get_impl_gp5kza($this, index) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = _UIntArray___get_storage__impl__92a0v0($this)[index];
        return _UInt___init__impl__l7qpdl(this_0);
    }
    function UIntArray__set_impl_7f2zu2($this, index, value) {
        var tmp = _UIntArray___get_storage__impl__92a0v0($this);
        // Inline function 'kotlin.UInt.toInt' call
        tmp[index] = _UInt___get_data__impl__f0vqqw(value);
    }
    function _UIntArray___get_size__impl__r6l8ci($this) {
        return _UIntArray___get_storage__impl__92a0v0($this).length;
    }
    function UIntArray__iterator_impl_tkdv7k($this) {
        return new Iterator_0(_UIntArray___get_storage__impl__92a0v0($this));
    }
    function Iterator_0(array) {
        this.jk_1 = array;
        this.kk_1 = 0;
    }
    protoOf(Iterator_0).k = function() {
        return this.kk_1 < this.jk_1.length;
    };
    protoOf(Iterator_0).lk = function() {
        var tmp;
        if (this.kk_1 < this.jk_1.length) {
            // Inline function 'kotlin.toUInt' call
            var tmp1 = this.kk_1;
            this.kk_1 = tmp1 + 1 | 0;
            var this_0 = this.jk_1[tmp1];
            tmp = _UInt___init__impl__l7qpdl(this_0);
        } else throw NoSuchElementException_init_$Create$_0(this.kk_1.toString());
        return tmp;
    };
    protoOf(Iterator_0).l = function() {
        return new UInt(this.lk());
    };
    function UIntArray__contains_impl_b16rzj($this, element) {
        var tmp = (new UInt(element), new UInt(element));
        if (!(tmp instanceof UInt)) return false;
        var tmp_0 = _UIntArray___get_storage__impl__92a0v0($this);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(element);
        return contains_2(tmp_0, tmp$ret$0);
    }
    function UIntArray__contains_impl_b16rzj_0($this, element) {
        if (!(element instanceof UInt)) return false;
        return UIntArray__contains_impl_b16rzj($this.mk_1, element instanceof UInt ? element.hk_1 : THROW_CCE());
    }
    function UIntArray__containsAll_impl_414g22($this, elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.UIntArray.containsAll.<anonymous>' call
                var tmp_0;
                if (element instanceof UInt) {
                    var tmp_1 = _UIntArray___get_storage__impl__92a0v0($this);
                    // Inline function 'kotlin.UInt.toInt' call
                    var this_1 = element.hk_1;
                    var tmp$ret$1 = _UInt___get_data__impl__f0vqqw(this_1);
                    tmp_0 = contains_2(tmp_1, tmp$ret$1);
                } else tmp_0 = false;
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    }
    function UIntArray__containsAll_impl_414g22_0($this, elements) {
        return UIntArray__containsAll_impl_414g22($this.mk_1, elements);
    }
    function UIntArray__isEmpty_impl_vd8j4n($this) {
        return _UIntArray___get_storage__impl__92a0v0($this).length === 0;
    }
    function UIntArray__toString_impl_3zy802($this) {
        return "UIntArray(storage=" + toString_1($this) + ")";
    }
    function UIntArray__hashCode_impl_hr7ost($this) {
        return hashCode($this);
    }
    function UIntArray__equals_impl_flcmof($this, other) {
        if (!(other instanceof UIntArray)) return false;
        var tmp0_other_with_cast = other instanceof UIntArray ? other.mk_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function UIntArray(storage) {
        this.mk_1 = storage;
    }
    protoOf(UIntArray).m = function() {
        return _UIntArray___get_size__impl__r6l8ci(this.mk_1);
    };
    protoOf(UIntArray).j = function() {
        return UIntArray__iterator_impl_tkdv7k(this.mk_1);
    };
    protoOf(UIntArray).nk = function(element) {
        return UIntArray__contains_impl_b16rzj(this.mk_1, element);
    };
    protoOf(UIntArray).a2 = function(element) {
        return UIntArray__contains_impl_b16rzj_0(this, element);
    };
    protoOf(UIntArray).ok = function(elements) {
        return UIntArray__containsAll_impl_414g22(this.mk_1, elements);
    };
    protoOf(UIntArray).b2 = function(elements) {
        return UIntArray__containsAll_impl_414g22_0(this, elements);
    };
    protoOf(UIntArray).s = function() {
        return UIntArray__isEmpty_impl_vd8j4n(this.mk_1);
    };
    protoOf(UIntArray).toString = function() {
        return UIntArray__toString_impl_3zy802(this.mk_1);
    };
    protoOf(UIntArray).hashCode = function() {
        return UIntArray__hashCode_impl_hr7ost(this.mk_1);
    };
    protoOf(UIntArray).equals = function(other) {
        return UIntArray__equals_impl_flcmof(this.mk_1, other);
    };
    function _ULong___init__impl__c78o9k(data) {
        return data;
    }
    function _ULong___get_data__impl__fggpzb($this) {
        return $this;
    }
    function Companion_19() {
        Companion_instance_19 = this;
        this.pk_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
        this.qk_1 = _ULong___init__impl__c78o9k(new Long(-1, -1));
        this.rk_1 = 8;
        this.sk_1 = 64;
    }
    var Companion_instance_19;
    function Companion_getInstance_19() {
        if (Companion_instance_19 == null) new Companion_19();
        return Companion_instance_19;
    }
    function ULong__compareTo_impl_38i7tu($this, other) {
        return ulongCompare(_ULong___get_data__impl__fggpzb($this), _ULong___get_data__impl__fggpzb(other));
    }
    function ULong__compareTo_impl_38i7tu_0($this, other) {
        return ULong__compareTo_impl_38i7tu($this.tk_1, other instanceof ULong ? other.tk_1 : THROW_CCE());
    }
    function ULong__toString_impl_f9au7k($this) {
        // Inline function 'kotlin.ulongToString' call
        var value = _ULong___get_data__impl__fggpzb($this);
        return ulongToString(value, 10);
    }
    function ULong__hashCode_impl_6hv2lb($this) {
        return $this.hashCode();
    }
    function ULong__equals_impl_o0gnyb($this, other) {
        if (!(other instanceof ULong)) return false;
        var tmp0_other_with_cast = other instanceof ULong ? other.tk_1 : THROW_CCE();
        if (!$this.equals(tmp0_other_with_cast)) return false;
        return true;
    }
    function ULong(data) {
        Companion_getInstance_19();
        this.tk_1 = data;
    }
    protoOf(ULong).uk = function(other) {
        return ULong__compareTo_impl_38i7tu(this.tk_1, other);
    };
    protoOf(ULong).d = function(other) {
        return ULong__compareTo_impl_38i7tu_0(this, other);
    };
    protoOf(ULong).toString = function() {
        return ULong__toString_impl_f9au7k(this.tk_1);
    };
    protoOf(ULong).hashCode = function() {
        return ULong__hashCode_impl_6hv2lb(this.tk_1);
    };
    protoOf(ULong).equals = function(other) {
        return ULong__equals_impl_o0gnyb(this.tk_1, other);
    };
    function _ULongArray___init__impl__twm1l3(storage) {
        return storage;
    }
    function _ULongArray___get_storage__impl__28e64j($this) {
        return $this;
    }
    function _ULongArray___init__impl__twm1l3_0(size) {
        return _ULongArray___init__impl__twm1l3(longArray(size));
    }
    function ULongArray__get_impl_pr71q9($this, index) {
        // Inline function 'kotlin.toULong' call
        var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
        return _ULong___init__impl__c78o9k(this_0);
    }
    function ULongArray__set_impl_z19mvh($this, index, value) {
        var tmp = _ULongArray___get_storage__impl__28e64j($this);
        // Inline function 'kotlin.ULong.toLong' call
        tmp[index] = _ULong___get_data__impl__fggpzb(value);
    }
    function _ULongArray___get_size__impl__ju6dtr($this) {
        return _ULongArray___get_storage__impl__28e64j($this).length;
    }
    function ULongArray__iterator_impl_cq4d2h($this) {
        return new Iterator_1(_ULongArray___get_storage__impl__28e64j($this));
    }
    function Iterator_1(array) {
        this.vk_1 = array;
        this.wk_1 = 0;
    }
    protoOf(Iterator_1).k = function() {
        return this.wk_1 < this.vk_1.length;
    };
    protoOf(Iterator_1).xk = function() {
        var tmp;
        if (this.wk_1 < this.vk_1.length) {
            // Inline function 'kotlin.toULong' call
            var tmp1 = this.wk_1;
            this.wk_1 = tmp1 + 1 | 0;
            var this_0 = this.vk_1[tmp1];
            tmp = _ULong___init__impl__c78o9k(this_0);
        } else throw NoSuchElementException_init_$Create$_0(this.wk_1.toString());
        return tmp;
    };
    protoOf(Iterator_1).l = function() {
        return new ULong(this.xk());
    };
    function ULongArray__contains_impl_v9bgai($this, element) {
        var tmp = (new ULong(element), new ULong(element));
        if (!(tmp instanceof ULong)) return false;
        var tmp_0 = _ULongArray___get_storage__impl__28e64j($this);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
        return contains_1(tmp_0, tmp$ret$0);
    }
    function ULongArray__contains_impl_v9bgai_0($this, element) {
        if (!(element instanceof ULong)) return false;
        return ULongArray__contains_impl_v9bgai($this.yk_1, element instanceof ULong ? element.tk_1 : THROW_CCE());
    }
    function ULongArray__containsAll_impl_xx8ztf($this, elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.ULongArray.containsAll.<anonymous>' call
                var tmp_0;
                if (element instanceof ULong) {
                    var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
                    // Inline function 'kotlin.ULong.toLong' call
                    var this_1 = element.tk_1;
                    var tmp$ret$1 = _ULong___get_data__impl__fggpzb(this_1);
                    tmp_0 = contains_1(tmp_1, tmp$ret$1);
                } else tmp_0 = false;
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    }
    function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
        return ULongArray__containsAll_impl_xx8ztf($this.yk_1, elements);
    }
    function ULongArray__isEmpty_impl_c3yngu($this) {
        return _ULongArray___get_storage__impl__28e64j($this).length === 0;
    }
    function ULongArray__toString_impl_wqk1p5($this) {
        return "ULongArray(storage=" + toString_1($this) + ")";
    }
    function ULongArray__hashCode_impl_aze4wa($this) {
        return hashCode($this);
    }
    function ULongArray__equals_impl_vwitwa($this, other) {
        if (!(other instanceof ULongArray)) return false;
        var tmp0_other_with_cast = other instanceof ULongArray ? other.yk_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function ULongArray(storage) {
        this.yk_1 = storage;
    }
    protoOf(ULongArray).m = function() {
        return _ULongArray___get_size__impl__ju6dtr(this.yk_1);
    };
    protoOf(ULongArray).j = function() {
        return ULongArray__iterator_impl_cq4d2h(this.yk_1);
    };
    protoOf(ULongArray).zk = function(element) {
        return ULongArray__contains_impl_v9bgai(this.yk_1, element);
    };
    protoOf(ULongArray).a2 = function(element) {
        return ULongArray__contains_impl_v9bgai_0(this, element);
    };
    protoOf(ULongArray).al = function(elements) {
        return ULongArray__containsAll_impl_xx8ztf(this.yk_1, elements);
    };
    protoOf(ULongArray).b2 = function(elements) {
        return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
    };
    protoOf(ULongArray).s = function() {
        return ULongArray__isEmpty_impl_c3yngu(this.yk_1);
    };
    protoOf(ULongArray).toString = function() {
        return ULongArray__toString_impl_wqk1p5(this.yk_1);
    };
    protoOf(ULongArray).hashCode = function() {
        return ULongArray__hashCode_impl_aze4wa(this.yk_1);
    };
    protoOf(ULongArray).equals = function(other) {
        return ULongArray__equals_impl_vwitwa(this.yk_1, other);
    };
    function _UShort___init__impl__jigrne(data) {
        return data;
    }
    function _UShort___get_data__impl__g0245($this) {
        return $this;
    }
    function Companion_20() {
        Companion_instance_20 = this;
        this.bl_1 = _UShort___init__impl__jigrne(0);
        this.cl_1 = _UShort___init__impl__jigrne(-1);
        this.dl_1 = 2;
        this.el_1 = 16;
    }
    var Companion_instance_20;
    function Companion_getInstance_20() {
        if (Companion_instance_20 == null) new Companion_20();
        return Companion_instance_20;
    }
    function UShort__compareTo_impl_1pfgyc($this, other) {
        // Inline function 'kotlin.UShort.toInt' call
        var tmp = _UShort___get_data__impl__g0245($this) & 65535;
        // Inline function 'kotlin.UShort.toInt' call
        var tmp$ret$1 = _UShort___get_data__impl__g0245(other) & 65535;
        return compareTo(tmp, tmp$ret$1);
    }
    function UShort__compareTo_impl_1pfgyc_0($this, other) {
        return UShort__compareTo_impl_1pfgyc($this.fl_1, other instanceof UShort ? other.fl_1 : THROW_CCE());
    }
    function UShort__toString_impl_edaoee($this) {
        // Inline function 'kotlin.UShort.toInt' call
        return (_UShort___get_data__impl__g0245($this) & 65535).toString();
    }
    function UShort__hashCode_impl_ywngrv($this) {
        return $this;
    }
    function UShort__equals_impl_7t9pdz($this, other) {
        if (!(other instanceof UShort)) return false;
        if (!($this === (other instanceof UShort ? other.fl_1 : THROW_CCE()))) return false;
        return true;
    }
    function UShort(data) {
        Companion_getInstance_20();
        this.fl_1 = data;
    }
    protoOf(UShort).gl = function(other) {
        return UShort__compareTo_impl_1pfgyc(this.fl_1, other);
    };
    protoOf(UShort).d = function(other) {
        return UShort__compareTo_impl_1pfgyc_0(this, other);
    };
    protoOf(UShort).toString = function() {
        return UShort__toString_impl_edaoee(this.fl_1);
    };
    protoOf(UShort).hashCode = function() {
        return UShort__hashCode_impl_ywngrv(this.fl_1);
    };
    protoOf(UShort).equals = function(other) {
        return UShort__equals_impl_7t9pdz(this.fl_1, other);
    };
    function _UShortArray___init__impl__9b26ef(storage) {
        return storage;
    }
    function _UShortArray___get_storage__impl__t2jpv5($this) {
        return $this;
    }
    function _UShortArray___init__impl__9b26ef_0(size) {
        return _UShortArray___init__impl__9b26ef(new Int16Array(size));
    }
    function UShortArray__get_impl_fnbhmx($this, index) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
        return _UShort___init__impl__jigrne(this_0);
    }
    function UShortArray__set_impl_6d8whp($this, index, value) {
        var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
        // Inline function 'kotlin.UShort.toShort' call
        tmp[index] = _UShort___get_data__impl__g0245(value);
    }
    function _UShortArray___get_size__impl__jqto1b($this) {
        return _UShortArray___get_storage__impl__t2jpv5($this).length;
    }
    function UShortArray__iterator_impl_ktpenn($this) {
        return new Iterator_2(_UShortArray___get_storage__impl__t2jpv5($this));
    }
    function Iterator_2(array) {
        this.hl_1 = array;
        this.il_1 = 0;
    }
    protoOf(Iterator_2).k = function() {
        return this.il_1 < this.hl_1.length;
    };
    protoOf(Iterator_2).jl = function() {
        var tmp;
        if (this.il_1 < this.hl_1.length) {
            // Inline function 'kotlin.toUShort' call
            var tmp1 = this.il_1;
            this.il_1 = tmp1 + 1 | 0;
            var this_0 = this.hl_1[tmp1];
            tmp = _UShort___init__impl__jigrne(this_0);
        } else throw NoSuchElementException_init_$Create$_0(this.il_1.toString());
        return tmp;
    };
    protoOf(Iterator_2).l = function() {
        return new UShort(this.jl());
    };
    function UShortArray__contains_impl_vo7k3g($this, element) {
        var tmp = (new UShort(element), new UShort(element));
        if (!(tmp instanceof UShort)) return false;
        var tmp_0 = _UShortArray___get_storage__impl__t2jpv5($this);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(element);
        return contains_3(tmp_0, tmp$ret$0);
    }
    function UShortArray__contains_impl_vo7k3g_0($this, element) {
        if (!(element instanceof UShort)) return false;
        return UShortArray__contains_impl_vo7k3g($this.kl_1, element instanceof UShort ? element.fl_1 : THROW_CCE());
    }
    function UShortArray__containsAll_impl_vlaaxp($this, elements) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var this_0 = isInterface(elements, Collection) ? elements : THROW_CCE();
            var tmp;
            if (isInterface(this_0, Collection)) tmp = this_0.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.UShortArray.containsAll.<anonymous>' call
                var tmp_0;
                if (element instanceof UShort) {
                    var tmp_1 = _UShortArray___get_storage__impl__t2jpv5($this);
                    // Inline function 'kotlin.UShort.toShort' call
                    var this_1 = element.fl_1;
                    var tmp$ret$1 = _UShort___get_data__impl__g0245(this_1);
                    tmp_0 = contains_3(tmp_1, tmp$ret$1);
                } else tmp_0 = false;
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    }
    function UShortArray__containsAll_impl_vlaaxp_0($this, elements) {
        return UShortArray__containsAll_impl_vlaaxp($this.kl_1, elements);
    }
    function UShortArray__isEmpty_impl_cdd9l0($this) {
        return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
    }
    function UShortArray__toString_impl_omz03z($this) {
        return "UShortArray(storage=" + toString_1($this) + ")";
    }
    function UShortArray__hashCode_impl_2vt3b4($this) {
        return hashCode($this);
    }
    function UShortArray__equals_impl_tyc3mk($this, other) {
        if (!(other instanceof UShortArray)) return false;
        var tmp0_other_with_cast = other instanceof UShortArray ? other.kl_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function UShortArray(storage) {
        this.kl_1 = storage;
    }
    protoOf(UShortArray).m = function() {
        return _UShortArray___get_size__impl__jqto1b(this.kl_1);
    };
    protoOf(UShortArray).j = function() {
        return UShortArray__iterator_impl_ktpenn(this.kl_1);
    };
    protoOf(UShortArray).ll = function(element) {
        return UShortArray__contains_impl_vo7k3g(this.kl_1, element);
    };
    protoOf(UShortArray).a2 = function(element) {
        return UShortArray__contains_impl_vo7k3g_0(this, element);
    };
    protoOf(UShortArray).ml = function(elements) {
        return UShortArray__containsAll_impl_vlaaxp(this.kl_1, elements);
    };
    protoOf(UShortArray).b2 = function(elements) {
        return UShortArray__containsAll_impl_vlaaxp_0(this, elements);
    };
    protoOf(UShortArray).s = function() {
        return UShortArray__isEmpty_impl_cdd9l0(this.kl_1);
    };
    protoOf(UShortArray).toString = function() {
        return UShortArray__toString_impl_omz03z(this.kl_1);
    };
    protoOf(UShortArray).hashCode = function() {
        return UShortArray__hashCode_impl_2vt3b4(this.kl_1);
    };
    protoOf(UShortArray).equals = function(other) {
        return UShortArray__equals_impl_tyc3mk(this.kl_1, other);
    };
    function toULongOrNull(_this__u8e3s4) {
        return toULongOrNull_0(_this__u8e3s4, 10);
    }
    function toUInt(_this__u8e3s4) {
        var tmp0_elvis_lhs = toUIntOrNull(_this__u8e3s4);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toULong(_this__u8e3s4) {
        var tmp0_elvis_lhs = toULongOrNull(_this__u8e3s4);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new ULong(tmp_0)) == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toUByte(_this__u8e3s4) {
        var tmp0_elvis_lhs = toUByteOrNull(_this__u8e3s4);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new UByte(tmp_0)) == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toUShort(_this__u8e3s4) {
        var tmp0_elvis_lhs = toUShortOrNull(_this__u8e3s4);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new UShort(tmp_0)) == null) numberFormatError(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function toULongOrNull_0(_this__u8e3s4, radix) {
        checkRadix(radix);
        var length = _this__u8e3s4.length;
        if (length === 0) return null;
        var limit = _ULong___init__impl__c78o9k(new Long(-1, -1));
        var start;
        var firstChar = charSequenceGet(_this__u8e3s4, 0);
        if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
            if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43))) return null;
            start = 1;
        } else start = 0;
        var limitForMaxRadix = _ULong___init__impl__c78o9k(new Long(477218588, 119304647));
        var limitBeforeMul = limitForMaxRadix;
        // Inline function 'kotlin.toULong' call
        var uradix = _ULong___init__impl__c78o9k(toLong(radix));
        var result = _ULong___init__impl__c78o9k(new Long(0, 0));
        var inductionVariable = start;
        if (inductionVariable < length) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
            if (digit < 0) return null;
            // Inline function 'kotlin.ULong.compareTo' call
            var this_0 = result;
            var other = limitBeforeMul;
            if (ulongCompare(_ULong___get_data__impl__fggpzb(this_0), _ULong___get_data__impl__fggpzb(other)) > 0) {
                if (equals(limitBeforeMul, limitForMaxRadix)) {
                    // Inline function 'kotlin.ULong.div' call
                    limitBeforeMul = ulongDivide(limit, uradix);
                    // Inline function 'kotlin.ULong.compareTo' call
                    var this_1 = result;
                    var other_0 = limitBeforeMul;
                    if (ulongCompare(_ULong___get_data__impl__fggpzb(this_1), _ULong___get_data__impl__fggpzb(other_0)) > 0) return null;
                } else return null;
            }
            // Inline function 'kotlin.ULong.times' call
            var this_2 = result;
            result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).a3(_ULong___get_data__impl__fggpzb(uradix)));
            var beforeAdding = result;
            // Inline function 'kotlin.ULong.plus' call
            var this_3 = result;
            // Inline function 'kotlin.toUInt' call
            // Inline function 'kotlin.ULong.plus' call
            // Inline function 'kotlin.UInt.toULong' call
            var this_4 = _UInt___init__impl__l7qpdl(digit);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value = _UInt___get_data__impl__f0vqqw(this_4);
            var tmp$ret$6 = toLong(value).k3(new Long(-1, 0));
            var other_1 = _ULong___init__impl__c78o9k(tmp$ret$6);
            result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).y2(_ULong___get_data__impl__fggpzb(other_1)));
            // Inline function 'kotlin.ULong.compareTo' call
            var this_5 = result;
            if (ulongCompare(_ULong___get_data__impl__fggpzb(this_5), _ULong___get_data__impl__fggpzb(beforeAdding)) < 0) return null;
        }while (inductionVariable < length);
        return result;
    }
    function toUIntOrNull(_this__u8e3s4) {
        return toUIntOrNull_0(_this__u8e3s4, 10);
    }
    function toUByteOrNull(_this__u8e3s4) {
        return toUByteOrNull_0(_this__u8e3s4, 10);
    }
    function toUShortOrNull(_this__u8e3s4) {
        return toUShortOrNull_0(_this__u8e3s4, 10);
    }
    function toUIntOrNull_0(_this__u8e3s4, radix) {
        checkRadix(radix);
        var length = _this__u8e3s4.length;
        if (length === 0) return null;
        var limit = _UInt___init__impl__l7qpdl(-1);
        var start;
        var firstChar = charSequenceGet(_this__u8e3s4, 0);
        if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
            if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43))) return null;
            start = 1;
        } else start = 0;
        var limitForMaxRadix = _UInt___init__impl__l7qpdl(119304647);
        var limitBeforeMul = limitForMaxRadix;
        // Inline function 'kotlin.toUInt' call
        var uradix = _UInt___init__impl__l7qpdl(radix);
        var result = _UInt___init__impl__l7qpdl(0);
        var inductionVariable = start;
        if (inductionVariable < length) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
            if (digit < 0) return null;
            // Inline function 'kotlin.UInt.compareTo' call
            var this_0 = result;
            var other = limitBeforeMul;
            if (uintCompare(_UInt___get_data__impl__f0vqqw(this_0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
                if (limitBeforeMul === limitForMaxRadix) {
                    // Inline function 'kotlin.UInt.div' call
                    limitBeforeMul = uintDivide(limit, uradix);
                    // Inline function 'kotlin.UInt.compareTo' call
                    var this_1 = result;
                    var other_0 = limitBeforeMul;
                    if (uintCompare(_UInt___get_data__impl__f0vqqw(this_1), _UInt___get_data__impl__f0vqqw(other_0)) > 0) return null;
                } else return null;
            }
            // Inline function 'kotlin.UInt.times' call
            var this_2 = result;
            result = _UInt___init__impl__l7qpdl(imul(_UInt___get_data__impl__f0vqqw(this_2), _UInt___get_data__impl__f0vqqw(uradix)));
            var beforeAdding = result;
            // Inline function 'kotlin.UInt.plus' call
            var this_3 = result;
            // Inline function 'kotlin.toUInt' call
            var other_1 = _UInt___init__impl__l7qpdl(digit);
            result = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) + _UInt___get_data__impl__f0vqqw(other_1) | 0);
            // Inline function 'kotlin.UInt.compareTo' call
            var this_4 = result;
            if (uintCompare(_UInt___get_data__impl__f0vqqw(this_4), _UInt___get_data__impl__f0vqqw(beforeAdding)) < 0) return null;
        }while (inductionVariable < length);
        return result;
    }
    function toUByteOrNull_0(_this__u8e3s4, radix) {
        var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) return null;
        else tmp = tmp0_elvis_lhs;
        var int = tmp;
        // Inline function 'kotlin.UInt.compareTo' call
        // Inline function 'kotlin.UInt.compareTo' call
        // Inline function 'kotlin.UByte.toUInt' call
        var this_0 = _UByte___init__impl__g9hnc4(-1);
        var other = _UInt___init__impl__l7qpdl(_UByte___get_data__impl__jof9qr(this_0) & 255);
        if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0) return null;
        // Inline function 'kotlin.UInt.toUByte' call
        // Inline function 'kotlin.toUByte' call
        var this_1 = _UInt___get_data__impl__f0vqqw(int);
        return _UByte___init__impl__g9hnc4(toByte(this_1));
    }
    function toUShortOrNull_0(_this__u8e3s4, radix) {
        var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) return null;
        else tmp = tmp0_elvis_lhs;
        var int = tmp;
        // Inline function 'kotlin.UInt.compareTo' call
        // Inline function 'kotlin.UInt.compareTo' call
        // Inline function 'kotlin.UShort.toUInt' call
        var this_0 = _UShort___init__impl__jigrne(-1);
        var other = _UInt___init__impl__l7qpdl(_UShort___get_data__impl__g0245(this_0) & 65535);
        if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0) return null;
        // Inline function 'kotlin.UInt.toUShort' call
        // Inline function 'kotlin.toUShort' call
        var this_1 = _UInt___get_data__impl__f0vqqw(int);
        return _UShort___init__impl__jigrne(toShort(this_1));
    }
    //region block: post-declaration
    protoOf(InternalHashMap).n6 = containsAllEntries;
    protoOf(CombinedContext).vf = plus;
    protoOf(AbstractCoroutineContextElement).i9 = get;
    protoOf(AbstractCoroutineContextElement).uf = fold;
    protoOf(AbstractCoroutineContextElement).tf = minusKey;
    protoOf(AbstractCoroutineContextElement).vf = plus;
    //endregion
    //region block: init
    Unit_instance = new Unit();
    Companion_instance_0 = new Companion_0();
    ByteCompanionObject_instance = new ByteCompanionObject();
    ShortCompanionObject_instance = new ShortCompanionObject();
    IntCompanionObject_instance = new IntCompanionObject();
    FloatCompanionObject_instance = new FloatCompanionObject();
    DoubleCompanionObject_instance = new DoubleCompanionObject();
    StringCompanionObject_instance = new StringCompanionObject();
    BooleanCompanionObject_instance = new BooleanCompanionObject();
    _stableSortingIsSupported = null;
    Companion_instance_3 = new Companion_3();
    CompletedContinuation_instance = new CompletedContinuation();
    Companion_instance_5 = new Companion_5();
    Companion_instance_6 = new Companion_6();
    Companion_instance_7 = new Companion_7();
    EmptyIterator_instance = new EmptyIterator();
    Key_instance = new Key();
    Companion_instance_12 = new Companion_12();
    Companion_instance_13 = new Companion_13();
    UNINITIALIZED_VALUE_instance = new UNINITIALIZED_VALUE();
    Companion_instance_16 = new Companion_16();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = createInvariantKTypeProjection;
    _.$_$.b = createKType;
    _.$_$.c = findAssociatedObject;
    _.$_$.d = getKClassFromExpression;
    _.$_$.e = getKClass;
    _.$_$.f = VOID;
    _.$_$.g = DurationUnit_NANOSECONDS_getInstance;
    _.$_$.h = DurationUnit_SECONDS_getInstance;
    _.$_$.i = LazyThreadSafetyMode_NONE_getInstance;
    _.$_$.j = LazyThreadSafetyMode_PUBLICATION_getInstance;
    _.$_$.k = returnIfSuspended;
    _.$_$.l = ArrayDeque_init_$Create$;
    _.$_$.m = ArrayList_init_$Create$_0;
    _.$_$.n = ArrayList_init_$Create$;
    _.$_$.o = ArrayList_init_$Create$_1;
    _.$_$.p = HashMap_init_$Create$_0;
    _.$_$.q = HashMap_init_$Create$;
    _.$_$.r = HashMap_init_$Create$_1;
    _.$_$.s = HashSet_init_$Create$_1;
    _.$_$.t = HashSet_init_$Create$;
    _.$_$.u = HashSet_init_$Create$_0;
    _.$_$.v = LinkedHashMap_init_$Create$_0;
    _.$_$.w = LinkedHashMap_init_$Create$;
    _.$_$.x = LinkedHashMap_init_$Create$_1;
    _.$_$.y = LinkedHashSet_init_$Create$;
    _.$_$.z = LinkedHashSet_init_$Create$_0;
    _.$_$.a1 = CancellationException_init_$Init$;
    _.$_$.b1 = CancellationException_init_$Init$_0;
    _.$_$.c1 = CancellationException_init_$Create$_0;
    _.$_$.d1 = CancellationException_init_$Init$_1;
    _.$_$.e1 = CancellationException_init_$Create$_1;
    _.$_$.f1 = Regex_init_$Create$;
    _.$_$.g1 = StringBuilder_init_$Create$;
    _.$_$.h1 = StringBuilder_init_$Create$_0;
    _.$_$.i1 = ArithmeticException_init_$Create$_0;
    _.$_$.j1 = Error_init_$Create$_0;
    _.$_$.k1 = Error_init_$Init$_1;
    _.$_$.l1 = Error_init_$Create$_1;
    _.$_$.m1 = Exception_init_$Init$_0;
    _.$_$.n1 = Exception_init_$Create$_0;
    _.$_$.o1 = Exception_init_$Init$_1;
    _.$_$.p1 = IllegalArgumentException_init_$Init$_2;
    _.$_$.q1 = IllegalArgumentException_init_$Init$;
    _.$_$.r1 = IllegalArgumentException_init_$Create$;
    _.$_$.s1 = IllegalArgumentException_init_$Init$_0;
    _.$_$.t1 = IllegalArgumentException_init_$Create$_0;
    _.$_$.u1 = IllegalArgumentException_init_$Init$_1;
    _.$_$.v1 = IllegalArgumentException_init_$Create$_1;
    _.$_$.w1 = IllegalStateException_init_$Init$;
    _.$_$.x1 = IllegalStateException_init_$Init$_0;
    _.$_$.y1 = IllegalStateException_init_$Create$_0;
    _.$_$.z1 = IllegalStateException_init_$Init$_1;
    _.$_$.a2 = IllegalStateException_init_$Create$_1;
    _.$_$.b2 = IndexOutOfBoundsException_init_$Create$;
    _.$_$.c2 = IndexOutOfBoundsException_init_$Create$_0;
    _.$_$.d2 = NoSuchElementException_init_$Create$;
    _.$_$.e2 = NoSuchElementException_init_$Init$_0;
    _.$_$.f2 = NumberFormatException_init_$Create$_0;
    _.$_$.g2 = RuntimeException_init_$Init$_0;
    _.$_$.h2 = RuntimeException_init_$Create$_0;
    _.$_$.i2 = RuntimeException_init_$Init$_1;
    _.$_$.j2 = RuntimeException_init_$Create$_1;
    _.$_$.k2 = UnsupportedOperationException_init_$Init$;
    _.$_$.l2 = UnsupportedOperationException_init_$Create$;
    _.$_$.m2 = UnsupportedOperationException_init_$Create$_0;
    _.$_$.n2 = _Duration___get_absoluteValue__impl__vr7i6w;
    _.$_$.o2 = _Duration___get_inWholeSeconds__impl__hpy7b3;
    _.$_$.p2 = Duration__plus_impl_yu9v8f;
    _.$_$.q2 = Duration__toIsoString_impl_9h6wsm;
    _.$_$.r2 = _Char___init__impl__6a9atx;
    _.$_$.s2 = Char__compareTo_impl_ypi4mb;
    _.$_$.t2 = Char__minus_impl_a2frrh;
    _.$_$.u2 = Char__minus_impl_a2frrh_0;
    _.$_$.v2 = Char__plus_impl_qi7pgj;
    _.$_$.w2 = Char__rangeTo_impl_tkncvp;
    _.$_$.x2 = Char__toInt_impl_vasixd;
    _.$_$.y2 = toString;
    _.$_$.z2 = _Result___init__impl__xyqfz8;
    _.$_$.a3 = Result__exceptionOrNull_impl_p6xea9;
    _.$_$.b3 = _Result___get_isFailure__impl__jpiriv;
    _.$_$.c3 = _Result___get_value__impl__bjfvqg;
    _.$_$.d3 = _UByte___init__impl__g9hnc4;
    _.$_$.e3 = _UByte___get_data__impl__jof9qr;
    _.$_$.f3 = UByte__toString_impl_v72jg;
    _.$_$.g3 = _UByteArray___init__impl__ip4y9n;
    _.$_$.h3 = _UByteArray___init__impl__ip4y9n_0;
    _.$_$.i3 = UByteArray__get_impl_t5f3hv;
    _.$_$.j3 = UByteArray__set_impl_jvcicn;
    _.$_$.k3 = _UByteArray___get_size__impl__h6pkdv;
    _.$_$.l3 = _UByteArray___get_storage__impl__d4kctt;
    _.$_$.m3 = _UInt___init__impl__l7qpdl;
    _.$_$.n3 = _UInt___get_data__impl__f0vqqw;
    _.$_$.o3 = UInt__toString_impl_dbgl21;
    _.$_$.p3 = _UIntArray___init__impl__ghjpc6_0;
    _.$_$.q3 = _UIntArray___init__impl__ghjpc6;
    _.$_$.r3 = UIntArray__get_impl_gp5kza;
    _.$_$.s3 = UIntArray__set_impl_7f2zu2;
    _.$_$.t3 = _UIntArray___get_size__impl__r6l8ci;
    _.$_$.u3 = _UIntArray___get_storage__impl__92a0v0;
    _.$_$.v3 = _ULong___init__impl__c78o9k;
    _.$_$.w3 = _ULong___get_data__impl__fggpzb;
    _.$_$.x3 = ULong__toString_impl_f9au7k;
    _.$_$.y3 = _ULongArray___init__impl__twm1l3_0;
    _.$_$.z3 = _ULongArray___init__impl__twm1l3;
    _.$_$.a4 = ULongArray__get_impl_pr71q9;
    _.$_$.b4 = ULongArray__set_impl_z19mvh;
    _.$_$.c4 = _ULongArray___get_size__impl__ju6dtr;
    _.$_$.d4 = _ULongArray___get_storage__impl__28e64j;
    _.$_$.e4 = _UShort___init__impl__jigrne;
    _.$_$.f4 = _UShort___get_data__impl__g0245;
    _.$_$.g4 = UShort__toString_impl_edaoee;
    _.$_$.h4 = _UShortArray___init__impl__9b26ef_0;
    _.$_$.i4 = _UShortArray___init__impl__9b26ef;
    _.$_$.j4 = UShortArray__get_impl_fnbhmx;
    _.$_$.k4 = UShortArray__set_impl_6d8whp;
    _.$_$.l4 = _UShortArray___get_size__impl__jqto1b;
    _.$_$.m4 = _UShortArray___get_storage__impl__t2jpv5;
    _.$_$.n4 = Key_instance;
    _.$_$.o4 = EmptyCoroutineContext_getInstance;
    _.$_$.p4 = Default_getInstance;
    _.$_$.q4 = BooleanCompanionObject_instance;
    _.$_$.r4 = ByteCompanionObject_instance;
    _.$_$.s4 = DoubleCompanionObject_instance;
    _.$_$.t4 = FloatCompanionObject_instance;
    _.$_$.u4 = IntCompanionObject_instance;
    _.$_$.v4 = ShortCompanionObject_instance;
    _.$_$.w4 = StringCompanionObject_instance;
    _.$_$.x4 = Default_getInstance_0;
    _.$_$.y4 = PrimitiveClasses_getInstance;
    _.$_$.z4 = Companion_getInstance_15;
    _.$_$.a5 = Companion_getInstance;
    _.$_$.b5 = Companion_getInstance_1;
    _.$_$.c5 = Companion_instance_16;
    _.$_$.d5 = Companion_getInstance_17;
    _.$_$.e5 = Companion_getInstance_18;
    _.$_$.f5 = Companion_getInstance_19;
    _.$_$.g5 = Companion_getInstance_20;
    _.$_$.h5 = Unit_instance;
    _.$_$.i5 = ArrayList;
    _.$_$.j5 = Collection;
    _.$_$.k5 = HashMap;
    _.$_$.l5 = HashSet;
    _.$_$.m5 = Iterable;
    _.$_$.n5 = LinkedHashMap;
    _.$_$.o5 = LinkedHashSet;
    _.$_$.p5 = KtList;
    _.$_$.q5 = Entry;
    _.$_$.r5 = KtMap;
    _.$_$.s5 = KtMutableList;
    _.$_$.t5 = KtMutableMap;
    _.$_$.u5 = KtMutableSet;
    _.$_$.v5 = KtSet;
    _.$_$.w5 = addAll;
    _.$_$.x5 = asList;
    _.$_$.y5 = asSequence;
    _.$_$.z5 = checkIndexOverflow;
    _.$_$.a6 = collectionSizeOrDefault;
    _.$_$.b6 = contains_0;
    _.$_$.c6 = contentEquals;
    _.$_$.d6 = contentHashCode;
    _.$_$.e6 = contentToString;
    _.$_$.f6 = copyOf_4;
    _.$_$.g6 = copyOf_2;
    _.$_$.h6 = copyOf_6;
    _.$_$.i6 = copyOf;
    _.$_$.j6 = copyOf_5;
    _.$_$.k6 = copyOf_0;
    _.$_$.l6 = copyOf_1;
    _.$_$.m6 = copyOf_7;
    _.$_$.n6 = copyOf_3;
    _.$_$.o6 = copyToArray;
    _.$_$.p6 = dropLast;
    _.$_$.q6 = drop;
    _.$_$.r6 = emptyList;
    _.$_$.s6 = emptyMap;
    _.$_$.t6 = emptySet;
    _.$_$.u6 = filterNotNull;
    _.$_$.v6 = firstOrNull_0;
    _.$_$.w6 = firstOrNull;
    _.$_$.x6 = first_0;
    _.$_$.y6 = first;
    _.$_$.z6 = flatten;
    _.$_$.a7 = getOrNull_0;
    _.$_$.b7 = getValue;
    _.$_$.c7 = indexOf;
    _.$_$.d7 = get_indices_0;
    _.$_$.e7 = get_indices;
    _.$_$.f7 = intersect;
    _.$_$.g7 = joinToString_0;
    _.$_$.h7 = joinTo_0;
    _.$_$.i7 = get_lastIndex_1;
    _.$_$.j7 = get_lastIndex_2;
    _.$_$.k7 = get_lastIndex;
    _.$_$.l7 = lastOrNull;
    _.$_$.m7 = last;
    _.$_$.n7 = listOf;
    _.$_$.o7 = listOf_0;
    _.$_$.p7 = mapCapacity;
    _.$_$.q7 = mapOf;
    _.$_$.r7 = mapOf_0;
    _.$_$.s7 = mutableListOf;
    _.$_$.t7 = plus_3;
    _.$_$.u7 = plus_2;
    _.$_$.v7 = plus_1;
    _.$_$.w7 = plus_0;
    _.$_$.x7 = random;
    _.$_$.y7 = removeFirstOrNull;
    _.$_$.z7 = removeLast;
    _.$_$.a8 = reversed;
    _.$_$.b8 = setOf;
    _.$_$.c8 = setOf_0;
    _.$_$.d8 = singleOrNull_0;
    _.$_$.e8 = singleOrNull;
    _.$_$.f8 = slice;
    _.$_$.g8 = sortedWith;
    _.$_$.h8 = toBooleanArray;
    _.$_$.i8 = toHashSet;
    _.$_$.j8 = toList_1;
    _.$_$.k8 = toList_0;
    _.$_$.l8 = toList;
    _.$_$.m8 = toMap_0;
    _.$_$.n8 = toMap;
    _.$_$.o8 = toMutableList_0;
    _.$_$.p8 = toMutableMap;
    _.$_$.q8 = toMutableSet;
    _.$_$.r8 = toSet_0;
    _.$_$.s8 = toSet;
    _.$_$.t8 = toTypedArray;
    _.$_$.u8 = union;
    _.$_$.v8 = withIndex;
    _.$_$.w8 = zip;
    _.$_$.x8 = compareValues;
    _.$_$.y8 = CancellationException;
    _.$_$.z8 = get_COROUTINE_SUSPENDED;
    _.$_$.a9 = createCoroutineUnintercepted;
    _.$_$.b9 = intercepted;
    _.$_$.c9 = AbstractCoroutineContextElement;
    _.$_$.d9 = AbstractCoroutineContextKey;
    _.$_$.e9 = get_0;
    _.$_$.f9 = minusKey_0;
    _.$_$.g9 = ContinuationInterceptor;
    _.$_$.h9 = Continuation;
    _.$_$.i9 = fold;
    _.$_$.j9 = get;
    _.$_$.k9 = minusKey;
    _.$_$.l9 = Element;
    _.$_$.m9 = plus;
    _.$_$.n9 = CoroutineImpl;
    _.$_$.o9 = startCoroutine;
    _.$_$.p9 = enumEntries;
    _.$_$.q9 = anyToString;
    _.$_$.r9 = arrayIterator;
    _.$_$.s9 = booleanArray;
    _.$_$.t9 = captureStack;
    _.$_$.u9 = charArrayOf;
    _.$_$.v9 = charArray;
    _.$_$.w9 = charSequenceGet;
    _.$_$.x9 = charSequenceLength;
    _.$_$.y9 = charSequenceSubSequence;
    _.$_$.z9 = compareTo;
    _.$_$.aa = defineProp;
    _.$_$.ba = equals;
    _.$_$.ca = extendThrowable;
    _.$_$.da = fillArrayVal;
    _.$_$.ea = getBooleanHashCode;
    _.$_$.fa = getPropertyCallableRef;
    _.$_$.ga = getStringHashCode;
    _.$_$.ha = hashCode;
    _.$_$.ia = initMetadataForClass;
    _.$_$.ja = initMetadataForCompanion;
    _.$_$.ka = initMetadataForCoroutine;
    _.$_$.la = initMetadataForFunctionReference;
    _.$_$.ma = initMetadataForInterface;
    _.$_$.na = initMetadataForLambda;
    _.$_$.oa = initMetadataForObject;
    _.$_$.pa = isArray;
    _.$_$.qa = isBooleanArray;
    _.$_$.ra = isByteArray;
    _.$_$.sa = isCharArray;
    _.$_$.ta = isCharSequence;
    _.$_$.ua = isDoubleArray;
    _.$_$.va = isFloatArray;
    _.$_$.wa = isIntArray;
    _.$_$.xa = isInterface;
    _.$_$.ya = isLongArray;
    _.$_$.za = isNumber;
    _.$_$.ab = isShortArray;
    _.$_$.bb = isSuspendFunction;
    _.$_$.cb = iterator;
    _.$_$.db = get_js;
    _.$_$.eb = json;
    _.$_$.fb = longArray;
    _.$_$.gb = numberRangeToNumber;
    _.$_$.hb = numberToChar;
    _.$_$.ib = numberToLong;
    _.$_$.jb = objectCreate;
    _.$_$.kb = protoOf;
    _.$_$.lb = toByte;
    _.$_$.mb = toLong;
    _.$_$.nb = toShort;
    _.$_$.ob = toString_1;
    _.$_$.pb = roundToInt;
    _.$_$.qb = ClosedRange;
    _.$_$.rb = coerceAtLeast;
    _.$_$.sb = coerceAtMost_0;
    _.$_$.tb = coerceAtMost;
    _.$_$.ub = coerceIn;
    _.$_$.vb = contains_5;
    _.$_$.wb = downTo;
    _.$_$.xb = step;
    _.$_$.yb = until;
    _.$_$.zb = KClass;
    _.$_$.ac = KProperty1;
    _.$_$.bc = KTypeParameter;
    _.$_$.cc = SequenceScope;
    _.$_$.dc = iterator_0;
    _.$_$.ec = map;
    _.$_$.fc = toList_2;
    _.$_$.gc = toSet_1;
    _.$_$.hc = StringBuilder;
    _.$_$.ic = concatToString;
    _.$_$.jc = contains_8;
    _.$_$.kc = contains_7;
    _.$_$.lc = contentEquals_1;
    _.$_$.mc = decodeToString;
    _.$_$.nc = encodeToByteArray;
    _.$_$.oc = endsWith;
    _.$_$.pc = equals_0;
    _.$_$.qc = first_1;
    _.$_$.rc = indexOfAny;
    _.$_$.sc = indexOf_5;
    _.$_$.tc = indexOf_4;
    _.$_$.uc = isBlank;
    _.$_$.vc = isHighSurrogate;
    _.$_$.wc = isLowSurrogate;
    _.$_$.xc = isLowerCase;
    _.$_$.yc = isSurrogate;
    _.$_$.zc = isWhitespace;
    _.$_$.ad = get_lastIndex_3;
    _.$_$.bd = lastIndexOf;
    _.$_$.cd = last_1;
    _.$_$.dd = replace;
    _.$_$.ed = single_2;
    _.$_$.fd = split_1;
    _.$_$.gd = split;
    _.$_$.hd = startsWith;
    _.$_$.id = startsWith_1;
    _.$_$.jd = take_0;
    _.$_$.kd = titlecase;
    _.$_$.ld = toBooleanStrictOrNull;
    _.$_$.md = toDoubleOrNull;
    _.$_$.nd = toDouble;
    _.$_$.od = toIntOrNull;
    _.$_$.pd = toInt;
    _.$_$.qd = toLongOrNull;
    _.$_$.rd = toLong_0;
    _.$_$.sd = toString_2;
    _.$_$.td = toUByte;
    _.$_$.ud = toUInt;
    _.$_$.vd = toULongOrNull;
    _.$_$.wd = toULong;
    _.$_$.xd = toUShort;
    _.$_$.yd = trimIndent;
    _.$_$.zd = trimMargin;
    _.$_$.ae = trim;
    _.$_$.be = Duration;
    _.$_$.ce = toDuration_0;
    _.$_$.de = ArithmeticException;
    _.$_$.ee = Char;
    _.$_$.fe = Comparable;
    _.$_$.ge = DeepRecursiveFunction;
    _.$_$.he = DeepRecursiveScope;
    _.$_$.ie = Enum;
    _.$_$.je = Error_0;
    _.$_$.ke = Exception;
    _.$_$.le = IllegalArgumentException;
    _.$_$.me = IllegalStateException;
    _.$_$.ne = Long;
    _.$_$.oe = NoSuchElementException;
    _.$_$.pe = NotImplementedError;
    _.$_$.qe = Pair;
    _.$_$.re = Result;
    _.$_$.se = RuntimeException;
    _.$_$.te = THROW_CCE;
    _.$_$.ue = THROW_IAE;
    _.$_$.ve = Triple;
    _.$_$.we = UByteArray;
    _.$_$.xe = UByte;
    _.$_$.ye = UIntArray;
    _.$_$.ze = UInt;
    _.$_$.af = ULongArray;
    _.$_$.bf = ULong;
    _.$_$.cf = UShortArray;
    _.$_$.df = UShort;
    _.$_$.ef = Unit;
    _.$_$.ff = UnsupportedOperationException;
    _.$_$.gf = addSuppressed;
    _.$_$.hf = arrayOf;
    _.$_$.if = countTrailingZeroBits;
    _.$_$.jf = createFailure;
    _.$_$.kf = ensureNotNull;
    _.$_$.lf = invoke;
    _.$_$.mf = isFinite;
    _.$_$.nf = isFinite_0;
    _.$_$.of = isNaN_0;
    _.$_$.pf = lazy;
    _.$_$.qf = lazy_0;
    _.$_$.rf = noWhenBranchMatchedException;
    _.$_$.sf = plus_4;
    _.$_$.tf = printStackTrace;
    _.$_$.uf = throwUninitializedPropertyAccessException;
    _.$_$.vf = toString_0;
    _.$_$.wf = to;
    //endregion
    return _;
});

});

parcelRegister("lm0Zq", function(module, exports) {







(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "node-jose",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./curity-ssi-libs-core-json.js",
        "./curity-ssi-libs-core.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("gOLPe")), (parcelRequire("9vyMc")), (parcelRequire("2VOQS")), (parcelRequire("3kJd2")), (parcelRequire("fcWHW")), (parcelRequire("iuiRe")), (parcelRequire("ctZcf")));
})(globalThis, function(_, Jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var protoOf = kotlin_kotlin.$_$.kb;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var Default_getInstance = kotlin_kotlin.$_$.p4;
    var get_lastIndex = kotlin_kotlin.$_$.ad;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var VOID = kotlin_kotlin.$_$.f;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var extendThrowable = kotlin_kotlin.$_$.ca;
    var captureStack = kotlin_kotlin.$_$.t9;
    var defineProp = kotlin_kotlin.$_$.aa;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var Char__rangeTo_impl_tkncvp = kotlin_kotlin.$_$.w2;
    var plus = kotlin_kotlin.$_$.u7;
    var plus_0 = kotlin_kotlin.$_$.v7;
    var numberRangeToNumber = kotlin_kotlin.$_$.gb;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
    var random = kotlin_kotlin.$_$.x7;
    var Char = kotlin_kotlin.$_$.ee;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var joinToString = kotlin_kotlin.$_$.g7;
    var toString = kotlin_kotlin.$_$.ob;
    var hashCode = kotlin_kotlin.$_$.ha;
    var equals = kotlin_kotlin.$_$.ba;
    var Default_getInstance_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var getKClass = kotlin_kotlin.$_$.e;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var setOf = kotlin_kotlin.$_$.c8;
    var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
    var toMutableMap = kotlin_kotlin.$_$.p8;
    var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
    var toMap = kotlin_kotlin.$_$.m8;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var toJson = kotlin_io_curity_ssi_core_json.$_$.c1;
    var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
    var union = kotlin_kotlin.$_$.u8;
    var Collection = kotlin_kotlin.$_$.j5;
    var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
    var get = kotlin_io_curity_ssi_core_json.$_$.q;
    var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
    var toJson_0 = kotlin_io_curity_ssi_core_json.$_$.s;
    var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
    var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
    var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var unwrapString = kotlin_io_curity_ssi_core_json.$_$.p1;
    var unwrapOptionalJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.h1;
    var unwrapOptionalStringList = kotlin_io_curity_ssi_core_json.$_$.l1;
    var toSet = kotlin_kotlin.$_$.r8;
    var toJson_1 = kotlin_io_curity_ssi_core_json.$_$.z;
    var unwrapOptionalMultiValueString = kotlin_io_curity_ssi_core_json.$_$.j1;
    var unwrapOptionalLong = kotlin_io_curity_ssi_core_json.$_$.i1;
    var unwrapJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.e1;
    var toJson_2 = kotlin_io_curity_ssi_core_json.$_$.a1;
    var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var lazy = kotlin_kotlin.$_$.qf;
    var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
    var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var JsToJsonConverter_instance = kotlin_io_curity_ssi_core_json.$_$.c;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var isByteArray = kotlin_kotlin.$_$.ra;
    var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
    var to = kotlin_kotlin.$_$.wf;
    var mapOf = kotlin_kotlin.$_$.r7;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var toSet_0 = kotlin_kotlin.$_$.s8;
    var contains = kotlin_kotlin.$_$.b6;
    var json = kotlin_kotlin.$_$.eb;
    var split = kotlin_kotlin.$_$.gd;
    var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(JWK, "JWK");
    initMetadataForCompanion(Companion);
    initMetadataForClass(CryptoException, "CryptoException", VOID, Error);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(SigningKeyPair, "SigningKeyPair");
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(JsonJwk, "JsonJwk", JsonJwk, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonJwkSerializer_getInstance
    });
    initMetadataForCompanion(Companion_2);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonJwks, "JsonJwks", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance
    });
    initMetadataForCompanion(Companion_3);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(Jws, "Jws", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_0
    });
    initMetadataForCompanion(Companion_4);
    initMetadataForClass(JsonJwsHeader, "JsonJwsHeader", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonJwsHeaderSerializer_getInstance
    });
    initMetadataForCompanion(Companion_5);
    initMetadataForClass(JsonJwtClaimsSet, "JsonJwtClaimsSet", JsonJwtClaimsSet, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonJwtClaimsSetSerializer_getInstance
    });
    initMetadataForObject(JsonJwsHeaderSerializer, "JsonJwsHeaderSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonJwtClaimsSetSerializer, "JsonJwtClaimsSetSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonJwkSerializer, "JsonJwkSerializer", VOID, JsonSerializer);
    initMetadataForInterface(JsSigningKey, "JsSigningKey");
    initMetadataForInterface(JsVerificationKey, "JsVerificationKey");
    initMetadataForClass(JsSigningKeyPair, "JsSigningKeyPair");
    initMetadataForInterface(JsKeyStore, "JsKeyStore");
    initMetadataForClass(JsJwsHeaderAndPayload, "JsJwsHeaderAndPayload");
    initMetadataForLambda(JsDefaultKeyStore$getSigningKeyPairById$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsDefaultKeyStore$importSigningKeySpec$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsDefaultKeyStore, "JsDefaultKeyStore", JsDefaultKeyStore, VOID, [
        JsKeyStore
    ]);
    initMetadataForLambda(createSigningKeyFromJwk$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(createVerificationKeyFromJwk$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(createJws$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(verifyJws$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(createHashFunction$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_6);
    initMetadataForCoroutine($importSigningKeyPairCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(NodeJoseKeyStore, "NodeJoseKeyStore", VOID, VOID, VOID, [
        2,
        1
    ]);
    initMetadataForCoroutine($createJsSigningKeyCOROUTINE$2, CoroutineImpl);
    initMetadataForCompanion(Companion_7, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($createJsVerificationKeyCOROUTINE$3, CoroutineImpl);
    initMetadataForCompanion(Companion_8, VOID, VOID, [
        1
    ]);
    initMetadataForInterface(VerificationKey, "VerificationKey");
    initMetadataForCoroutine($fromJwksCOROUTINE$4, CoroutineImpl);
    initMetadataForCompanion(Companion_9, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($verifyJwsCOROUTINE$5, CoroutineImpl);
    initMetadataForCoroutine($verifyJwsCOROUTINE$6, CoroutineImpl);
    initMetadataForObject(JwsUtil, "JwsUtil", VOID, VOID, VOID, [
        3,
        2
    ]);
    initMetadataForClass(NativeSigningKey, "NativeSigningKey", VOID, VOID, [
        JsSigningKey
    ]);
    initMetadataForClass(NativeVerificationKey, "NativeVerificationKey", VOID, VOID, [
        VerificationKey,
        JsVerificationKey
    ]);
    initMetadataForClass(DefaultVerificationKeySet, "DefaultVerificationKeySet");
    //endregion
    function JWK(jsonString) {
        this.o28_1 = jsonString;
    }
    protoOf(JWK).toString = function() {
        return "JWK(jsonString=" + this.o28_1 + ")";
    };
    protoOf(JWK).hashCode = function() {
        return getStringHashCode(this.o28_1);
    };
    protoOf(JWK).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JWK)) return false;
        var tmp0_other_with_cast = other instanceof JWK ? other : THROW_CCE();
        if (!(this.o28_1 === tmp0_other_with_cast.o28_1)) return false;
        return true;
    };
    function encodeBase64url(bytes) {
        var tmp$ret$3;
        $l$block: {
            // Inline function 'kotlin.text.dropLastWhile' call
            var this_0 = Default_getInstance().og_1.rg(bytes);
            var inductionVariable = get_lastIndex(this_0);
            if (0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                // Inline function 'io.curity.ssi.crypto.encodeBase64url.<anonymous>' call
                if (!(charSequenceGet(this_0, index) === _Char___init__impl__6a9atx(61))) {
                    // Inline function 'kotlin.text.substring' call
                    var endIndex = index + 1 | 0;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp$ret$3 = this_0.substring(0, endIndex);
                    break $l$block;
                }
            }while (0 <= inductionVariable);
            tmp$ret$3 = "";
        }
        return tmp$ret$3;
    }
    function decodeBase64Url(string) {
        return Default_getInstance().og_1.vg(string);
    }
    function Companion() {}
    protoOf(Companion).p28 = function(msg) {
        return new CryptoException("JWK does not contain a signing key ('" + (msg == null ? "no extra information" : msg) + "')");
    };
    protoOf(Companion).q28 = function(msg, $super) {
        msg = msg === VOID ? null : msg;
        return $super === VOID ? this.p28(msg) : $super.p28.call(this, msg);
    };
    protoOf(Companion).r28 = function(msg) {
        return new CryptoException("JWK does not contain a verification key ('" + (msg == null ? "no extra information" : msg) + "')");
    };
    var Companion_instance;
    function Companion_getInstance() {
        return Companion_instance;
    }
    function CryptoException(msg, cause) {
        cause = cause === VOID ? null : cause;
        extendThrowable(this, msg, cause);
        captureStack(this, CryptoException);
        this.s28_1 = msg;
    }
    protoOf(CryptoException).l9 = function() {
        return this.s28_1;
    };
    function sha256() {
        var tmp0_elvis_lhs = createHashFunction("sha-256");
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalStateException_init_$Create$("sha-256 not supported");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function Companion_0() {}
    protoOf(Companion_0).t28 = function(length) {
        var allowedChars = plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
        // Inline function 'kotlin.collections.map' call
        var this_0 = numberRangeToNumber(1, length);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.crypto.Companion.uniqueAlphanumericId.<anonymous>' call
            // Inline function 'kotlin.collections.random' call
            var tmp$ret$0 = random(allowedChars, Default_getInstance_0()).o1_1;
            var tmp$ret$1 = new Char(tmp$ret$0);
            destination.e(tmp$ret$1);
        }
        return joinToString(destination, "");
    };
    var Companion_instance_0;
    function Companion_getInstance_0() {
        return Companion_instance_0;
    }
    function SigningKeyPair(signingKey, verificationKey, id) {
        this.u28_1 = signingKey;
        this.v28_1 = verificationKey;
        this.w28_1 = id;
    }
    protoOf(SigningKeyPair).toString = function() {
        return "SigningKeyPair(signingKey=" + toString(this.u28_1) + ", verificationKey=" + toString(this.v28_1) + ", id=" + this.w28_1 + ")";
    };
    protoOf(SigningKeyPair).hashCode = function() {
        var result = hashCode(this.u28_1);
        result = imul(result, 31) + hashCode(this.v28_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w28_1) | 0;
        return result;
    };
    protoOf(SigningKeyPair).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SigningKeyPair)) return false;
        var tmp0_other_with_cast = other instanceof SigningKeyPair ? other : THROW_CCE();
        if (!equals(this.u28_1, tmp0_other_with_cast.u28_1)) return false;
        if (!equals(this.v28_1, tmp0_other_with_cast.v28_1)) return false;
        if (!(this.w28_1 === tmp0_other_with_cast.w28_1)) return false;
        return true;
    };
    function fromJwkDictionary(_this__u8e3s4, jwk, $completion) {
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance_1();
        var value = new JsonObject(jwk.xl());
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonObject), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        return _this__u8e3s4.x28(tmp$ret$2, $completion);
    }
    function Companion_1() {
        Companion_instance_1 = this;
        this.y28_1 = setOf([
            "use",
            "alg"
        ]);
    }
    protoOf(Companion_1).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "Jwk"));
        return new JsonJwk(unwrapOptionalString(map, "kid"), toMap(map));
    };
    var Companion_instance_1;
    function Companion_getInstance_1() {
        if (Companion_instance_1 == null) new Companion_1();
        return Companion_instance_1;
    }
    function JsonJwk(kid, customClaims) {
        Companion_getInstance_1();
        kid = kid === VOID ? null : kid;
        customClaims = customClaims === VOID ? emptyMap() : customClaims;
        this.z28_1 = kid;
        this.a29_1 = customClaims;
    }
    protoOf(JsonJwk).y26 = function() {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwk.toJsonDictionary.<anonymous>' call
        this_0.o2(this.a29_1);
        var tmp0_safe_receiver = this.z28_1;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.m2("kid", toJson(tmp0_safe_receiver));
        var tmp$ret$3 = this_0.r8();
        return new JsonDictionary(tmp$ret$3);
    };
    protoOf(JsonJwk).b29 = function(other) {
        var allKeys = union(this.a29_1.f2(), other.a29_1.f2());
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(allKeys, Collection)) tmp = allKeys.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$0 = true;
                break $l$block_0;
            }
            var tmp0_iterator = allKeys.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.jose.JsonJwk.matches.<anonymous>' call
                var thisValue = this.a29_1.e2(element);
                var otherValue = other.a29_1.e2(element);
                var tmp_0;
                if ((thisValue == null || otherValue == null) && Companion_getInstance_1().y28_1.a2(element)) tmp_0 = true;
                else tmp_0 = equals(thisValue, otherValue);
                if (!tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
            }
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(JsonJwk).toString = function() {
        return "JsonJwk(kid=" + this.z28_1 + ", customClaims=" + toString(this.a29_1) + ")";
    };
    protoOf(JsonJwk).hashCode = function() {
        var result = this.z28_1 == null ? 0 : getStringHashCode(this.z28_1);
        result = imul(result, 31) + hashCode(this.a29_1) | 0;
        return result;
    };
    protoOf(JsonJwk).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonJwk)) return false;
        var tmp0_other_with_cast = other instanceof JsonJwk ? other : THROW_CCE();
        if (!(this.z28_1 == tmp0_other_with_cast.z28_1)) return false;
        if (!equals(this.a29_1, tmp0_other_with_cast.a29_1)) return false;
        return true;
    };
    function Companion_2() {
        Companion_instance_2 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.c29_1 = [
            new ArrayListSerializer(JsonJwkSerializer_getInstance())
        ];
    }
    var Companion_instance_2;
    function Companion_getInstance_2() {
        if (Companion_instance_2 == null) new Companion_2();
        return Companion_instance_2;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.jose.JsonJwks", this, 1);
        tmp0_serialDesc.wy("keys", false);
        this.d29_1 = tmp0_serialDesc;
    }
    protoOf($serializer).e29 = function(encoder, value) {
        var tmp0_desc = this.d29_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().c29_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.f29_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.e29(encoder, value instanceof JsonJwks ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.d29_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_2().c29_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return JsonJwks_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer).yn = function() {
        return this.d29_1;
    };
    protoOf($serializer).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_2().c29_1[0]
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function JsonJwks_init_$Init$(seen0, keys, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance().d29_1);
        $this.f29_1 = keys;
        return $this;
    }
    function JsonJwks_init_$Create$(seen0, keys, serializationConstructorMarker) {
        return JsonJwks_init_$Init$(seen0, keys, serializationConstructorMarker, objectCreate(protoOf(JsonJwks)));
    }
    function JsonJwks() {}
    protoOf(JsonJwks).g29 = function(id) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = this.f29_1.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.jose.JsonJwks.getKeyWithKid.<anonymous>' call
                if (element.z28_1 === id) {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        return tmp$ret$1;
    };
    function Companion_3() {}
    var Companion_instance_3;
    function Companion_getInstance_3() {
        return Companion_instance_3;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.jose.JsonJwt.Jws", this, 4);
        tmp0_serialDesc.wy("header", true);
        tmp0_serialDesc.wy("payload", false);
        tmp0_serialDesc.wy("unprotectedHeader", true);
        tmp0_serialDesc.wy("signature", true);
        this.h29_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).i29 = function(encoder, value) {
        var tmp0_desc = this.h29_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.j29_1 == null)) tmp1_output.dt(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), value.j29_1);
        tmp1_output.bt(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), value.k29_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.l29_1 == null)) tmp1_output.dt(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), value.l29_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.m29_1 == null)) tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.m29_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.i29(encoder, value instanceof Jws ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.h29_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return Jws_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.h29_1;
    };
    protoOf($serializer_0).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(JsonJwsHeaderSerializer_getInstance()),
            JsonJwtClaimsSetSerializer_getInstance(),
            get_nullable(JsonJwsHeaderSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_0() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function Jws_init_$Init$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker, $this) {
        if (!(2 === (2 & seen0))) throwMissingFieldException(seen0, 2, $serializer_getInstance_0().h29_1);
        if (0 === (seen0 & 1)) $this.j29_1 = null;
        else $this.j29_1 = header;
        $this.k29_1 = payload;
        if (0 === (seen0 & 4)) $this.l29_1 = null;
        else $this.l29_1 = unprotectedHeader;
        if (0 === (seen0 & 8)) $this.m29_1 = null;
        else $this.m29_1 = signature;
        return $this;
    }
    function Jws_init_$Create$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker) {
        return Jws_init_$Init$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker, objectCreate(protoOf(Jws)));
    }
    function Jws(header, payload, unprotectedHeader, signature) {
        header = header === VOID ? null : header;
        unprotectedHeader = unprotectedHeader === VOID ? null : unprotectedHeader;
        signature = signature === VOID ? null : signature;
        this.j29_1 = header;
        this.k29_1 = payload;
        this.l29_1 = unprotectedHeader;
        this.m29_1 = signature;
    }
    protoOf(Jws).toString = function() {
        return "Jws(header=" + toString_0(this.j29_1) + ", payload=" + this.k29_1.toString() + ", unprotectedHeader=" + toString_0(this.l29_1) + ", signature=" + this.m29_1 + ")";
    };
    protoOf(Jws).hashCode = function() {
        var result = this.j29_1 == null ? 0 : this.j29_1.hashCode();
        result = imul(result, 31) + this.k29_1.hashCode() | 0;
        result = imul(result, 31) + (this.l29_1 == null ? 0 : this.l29_1.hashCode()) | 0;
        result = imul(result, 31) + (this.m29_1 == null ? 0 : getStringHashCode(this.m29_1)) | 0;
        return result;
    };
    protoOf(Jws).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Jws)) return false;
        var tmp0_other_with_cast = other instanceof Jws ? other : THROW_CCE();
        if (!equals(this.j29_1, tmp0_other_with_cast.j29_1)) return false;
        if (!this.k29_1.equals(tmp0_other_with_cast.k29_1)) return false;
        if (!equals(this.l29_1, tmp0_other_with_cast.l29_1)) return false;
        if (!(this.m29_1 == tmp0_other_with_cast.m29_1)) return false;
        return true;
    };
    function Companion_4() {}
    protoOf(Companion_4).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JwsHeader"));
        var tmp2_typ = unwrapOptionalString(map, "typ");
        var tmp3_cty = unwrapOptionalString(map, "cty");
        var tmp4_alg = unwrapString(map, "alg");
        var tmp5_jku = unwrapOptionalString(map, "jku");
        var tmp6_jwk = unwrapOptionalJsonDictionary(map, "jwk");
        var tmp7_kid = unwrapOptionalString(map, "kid");
        var tmp8_x5u = unwrapOptionalString(map, "x5u");
        var tmp9_x5c = unwrapOptionalString(map, "x5c");
        var tmp10_x5t = unwrapOptionalString(map, "x5t");
        var tmp11_x5tS256 = unwrapOptionalString(map, "x5t#s256");
        var tmp1_safe_receiver = unwrapOptionalStringList(map, "crit");
        var tmp12_crit = tmp1_safe_receiver == null ? null : toSet(tmp1_safe_receiver);
        var tmp13_customClaims = toMap(map);
        return new JsonJwsHeader(tmp4_alg, tmp2_typ, tmp3_cty, tmp5_jku, tmp6_jwk, tmp7_kid, tmp8_x5u, tmp9_x5c, tmp10_x5t, tmp11_x5tS256, tmp12_crit, tmp13_customClaims);
    };
    var Companion_instance_4;
    function Companion_getInstance_4() {
        return Companion_instance_4;
    }
    function JsonJwsHeader(alg, typ, cty, jku, jwk, kid, x5u, x5c, x5t, x5tS256, crit, customClaims) {
        typ = typ === VOID ? null : typ;
        cty = cty === VOID ? null : cty;
        jku = jku === VOID ? null : jku;
        jwk = jwk === VOID ? null : jwk;
        kid = kid === VOID ? null : kid;
        x5u = x5u === VOID ? null : x5u;
        x5c = x5c === VOID ? null : x5c;
        x5t = x5t === VOID ? null : x5t;
        x5tS256 = x5tS256 === VOID ? null : x5tS256;
        crit = crit === VOID ? null : crit;
        customClaims = customClaims === VOID ? emptyMap() : customClaims;
        this.n29_1 = alg;
        this.o29_1 = typ;
        this.p29_1 = cty;
        this.q29_1 = jku;
        this.r29_1 = jwk;
        this.s29_1 = kid;
        this.t29_1 = x5u;
        this.u29_1 = x5c;
        this.v29_1 = x5t;
        this.w29_1 = x5tS256;
        this.x29_1 = crit;
        this.y29_1 = customClaims;
    }
    protoOf(JsonJwsHeader).y26 = function() {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>' call
        this_0.o2(this.y29_1);
        var tmp14_safe_receiver = this.o29_1;
        if (tmp14_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("typ", toJson(tmp14_safe_receiver));
        var tmp15_safe_receiver = this.p29_1;
        if (tmp15_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("cty", toJson(tmp15_safe_receiver));
        this_0.m2("alg", toJson(this.n29_1));
        var tmp16_safe_receiver = this.q29_1;
        if (tmp16_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("jku", toJson(tmp16_safe_receiver));
        var tmp17_safe_receiver = this.r29_1;
        if (tmp17_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("jwk", tmp17_safe_receiver.a27());
        var tmp18_safe_receiver = this.s29_1;
        if (tmp18_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("kid", toJson(tmp18_safe_receiver));
        var tmp19_safe_receiver = this.t29_1;
        if (tmp19_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("x5u", toJson(tmp19_safe_receiver));
        var tmp20_safe_receiver = this.v29_1;
        if (tmp20_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("x5t", toJson(tmp20_safe_receiver));
        var tmp21_safe_receiver = this.w29_1;
        if (tmp21_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("x5t#s256", toJson(tmp21_safe_receiver));
        var tmp22_safe_receiver = this.x29_1;
        if (tmp22_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.m2("crit", toJson_1(tmp22_safe_receiver));
        var tmp$ret$19 = this_0.r8();
        return new JsonDictionary(tmp$ret$19);
    };
    protoOf(JsonJwsHeader).toString = function() {
        return "JsonJwsHeader(alg=" + this.n29_1 + ", typ=" + this.o29_1 + ", cty=" + this.p29_1 + ", jku=" + this.q29_1 + ", jwk=" + toString_0(this.r29_1) + ", kid=" + this.s29_1 + ", x5u=" + this.t29_1 + ", x5c=" + this.u29_1 + ", x5t=" + this.v29_1 + ", x5tS256=" + this.w29_1 + ", crit=" + toString_0(this.x29_1) + ", customClaims=" + toString(this.y29_1) + ")";
    };
    protoOf(JsonJwsHeader).hashCode = function() {
        var result = getStringHashCode(this.n29_1);
        result = imul(result, 31) + (this.o29_1 == null ? 0 : getStringHashCode(this.o29_1)) | 0;
        result = imul(result, 31) + (this.p29_1 == null ? 0 : getStringHashCode(this.p29_1)) | 0;
        result = imul(result, 31) + (this.q29_1 == null ? 0 : getStringHashCode(this.q29_1)) | 0;
        result = imul(result, 31) + (this.r29_1 == null ? 0 : hashCode(this.r29_1)) | 0;
        result = imul(result, 31) + (this.s29_1 == null ? 0 : getStringHashCode(this.s29_1)) | 0;
        result = imul(result, 31) + (this.t29_1 == null ? 0 : getStringHashCode(this.t29_1)) | 0;
        result = imul(result, 31) + (this.u29_1 == null ? 0 : getStringHashCode(this.u29_1)) | 0;
        result = imul(result, 31) + (this.v29_1 == null ? 0 : getStringHashCode(this.v29_1)) | 0;
        result = imul(result, 31) + (this.w29_1 == null ? 0 : getStringHashCode(this.w29_1)) | 0;
        result = imul(result, 31) + (this.x29_1 == null ? 0 : hashCode(this.x29_1)) | 0;
        result = imul(result, 31) + hashCode(this.y29_1) | 0;
        return result;
    };
    protoOf(JsonJwsHeader).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonJwsHeader)) return false;
        var tmp0_other_with_cast = other instanceof JsonJwsHeader ? other : THROW_CCE();
        if (!(this.n29_1 === tmp0_other_with_cast.n29_1)) return false;
        if (!(this.o29_1 == tmp0_other_with_cast.o29_1)) return false;
        if (!(this.p29_1 == tmp0_other_with_cast.p29_1)) return false;
        if (!(this.q29_1 == tmp0_other_with_cast.q29_1)) return false;
        if (!equals(this.r29_1, tmp0_other_with_cast.r29_1)) return false;
        if (!(this.s29_1 == tmp0_other_with_cast.s29_1)) return false;
        if (!(this.t29_1 == tmp0_other_with_cast.t29_1)) return false;
        if (!(this.u29_1 == tmp0_other_with_cast.u29_1)) return false;
        if (!(this.v29_1 == tmp0_other_with_cast.v29_1)) return false;
        if (!(this.w29_1 == tmp0_other_with_cast.w29_1)) return false;
        if (!equals(this.x29_1, tmp0_other_with_cast.x29_1)) return false;
        if (!equals(this.y29_1, tmp0_other_with_cast.y29_1)) return false;
        return true;
    };
    function Companion_5() {}
    protoOf(Companion_5).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JwsHeader"));
        return new JsonJwtClaimsSet(unwrapOptionalString(map, "iss"), unwrapOptionalString(map, "sub"), unwrapOptionalMultiValueString(map, "aud"), unwrapOptionalLong(map, "exp"), unwrapOptionalLong(map, "nbf"), unwrapOptionalLong(map, "iat"), unwrapOptionalString(map, "jti"), unwrapJsonDictionary(map, "cnf"), toMap(map));
    };
    var Companion_instance_5;
    function Companion_getInstance_5() {
        return Companion_instance_5;
    }
    function JsonJwtClaimsSet$toJsonDictionary$lambda(item) {
        return toJson(item);
    }
    function JsonJwtClaimsSet(iss, sub, aud, exp, nbf, iat, jti, cnf, customClaims) {
        iss = iss === VOID ? null : iss;
        sub = sub === VOID ? null : sub;
        aud = aud === VOID ? null : aud;
        exp = exp === VOID ? null : exp;
        nbf = nbf === VOID ? null : nbf;
        iat = iat === VOID ? null : iat;
        jti = jti === VOID ? null : jti;
        cnf = cnf === VOID ? null : cnf;
        customClaims = customClaims === VOID ? emptyMap() : customClaims;
        this.z29_1 = iss;
        this.a2a_1 = sub;
        this.b2a_1 = aud;
        this.c2a_1 = exp;
        this.d2a_1 = nbf;
        this.e2a_1 = iat;
        this.f2a_1 = jti;
        this.g2a_1 = cnf;
        this.h2a_1 = customClaims;
    }
    protoOf(JsonJwtClaimsSet).y26 = function() {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>' call
        this_0.o2(this.h2a_1);
        var tmp23_safe_receiver = this.z29_1;
        if (tmp23_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("iss", toJson(tmp23_safe_receiver));
        var tmp24_safe_receiver = this.a2a_1;
        if (tmp24_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("sub", toJson(tmp24_safe_receiver));
        var tmp25_safe_receiver = this.b2a_1;
        if (tmp25_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("aud", tmp25_safe_receiver.l27(JsonJwtClaimsSet$toJsonDictionary$lambda));
        var tmp26_safe_receiver = this.c2a_1;
        if (tmp26_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("exp", toJson_2(tmp26_safe_receiver));
        var tmp27_safe_receiver = this.d2a_1;
        if (tmp27_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("nbf", toJson_2(tmp27_safe_receiver));
        var tmp28_safe_receiver = this.e2a_1;
        if (tmp28_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("iat", toJson_2(tmp28_safe_receiver));
        var tmp29_safe_receiver = this.f2a_1;
        if (tmp29_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
        this_0.m2("jti", toJson(tmp29_safe_receiver));
        var tmp30_safe_receiver = this.g2a_1;
        if (tmp30_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.m2("cnf", tmp30_safe_receiver.a27());
        var tmp$ret$17 = this_0.r8();
        return new JsonDictionary(tmp$ret$17);
    };
    protoOf(JsonJwtClaimsSet).toString = function() {
        return "JsonJwtClaimsSet(iss=" + this.z29_1 + ", sub=" + this.a2a_1 + ", aud=" + toString_0(this.b2a_1) + ", exp=" + toString_0(this.c2a_1) + ", nbf=" + toString_0(this.d2a_1) + ", iat=" + toString_0(this.e2a_1) + ", jti=" + this.f2a_1 + ", cnf=" + toString_0(this.g2a_1) + ", customClaims=" + toString(this.h2a_1) + ")";
    };
    protoOf(JsonJwtClaimsSet).hashCode = function() {
        var result = this.z29_1 == null ? 0 : getStringHashCode(this.z29_1);
        result = imul(result, 31) + (this.a2a_1 == null ? 0 : getStringHashCode(this.a2a_1)) | 0;
        result = imul(result, 31) + (this.b2a_1 == null ? 0 : this.b2a_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c2a_1 == null ? 0 : this.c2a_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d2a_1 == null ? 0 : this.d2a_1.hashCode()) | 0;
        result = imul(result, 31) + (this.e2a_1 == null ? 0 : this.e2a_1.hashCode()) | 0;
        result = imul(result, 31) + (this.f2a_1 == null ? 0 : getStringHashCode(this.f2a_1)) | 0;
        result = imul(result, 31) + (this.g2a_1 == null ? 0 : hashCode(this.g2a_1)) | 0;
        result = imul(result, 31) + hashCode(this.h2a_1) | 0;
        return result;
    };
    protoOf(JsonJwtClaimsSet).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonJwtClaimsSet)) return false;
        var tmp0_other_with_cast = other instanceof JsonJwtClaimsSet ? other : THROW_CCE();
        if (!(this.z29_1 == tmp0_other_with_cast.z29_1)) return false;
        if (!(this.a2a_1 == tmp0_other_with_cast.a2a_1)) return false;
        if (!equals(this.b2a_1, tmp0_other_with_cast.b2a_1)) return false;
        if (!equals(this.c2a_1, tmp0_other_with_cast.c2a_1)) return false;
        if (!equals(this.d2a_1, tmp0_other_with_cast.d2a_1)) return false;
        if (!equals(this.e2a_1, tmp0_other_with_cast.e2a_1)) return false;
        if (!(this.f2a_1 == tmp0_other_with_cast.f2a_1)) return false;
        if (!equals(this.g2a_1, tmp0_other_with_cast.g2a_1)) return false;
        if (!equals(this.h2a_1, tmp0_other_with_cast.h2a_1)) return false;
        return true;
    };
    function JsonJwsHeaderSerializer() {
        JsonJwsHeaderSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_4);
    }
    var JsonJwsHeaderSerializer_instance;
    function JsonJwsHeaderSerializer_getInstance() {
        if (JsonJwsHeaderSerializer_instance == null) new JsonJwsHeaderSerializer();
        return JsonJwsHeaderSerializer_instance;
    }
    function JsonJwtClaimsSetSerializer() {
        JsonJwtClaimsSetSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_5);
    }
    var JsonJwtClaimsSetSerializer_instance;
    function JsonJwtClaimsSetSerializer_getInstance() {
        if (JsonJwtClaimsSetSerializer_instance == null) new JsonJwtClaimsSetSerializer();
        return JsonJwtClaimsSetSerializer_instance;
    }
    function JsonJwkSerializer() {
        JsonJwkSerializer_instance = this;
        JsonSerializer.call(this, Companion_getInstance_1());
    }
    var JsonJwkSerializer_instance;
    function JsonJwkSerializer_getInstance() {
        if (JsonJwkSerializer_instance == null) new JsonJwkSerializer();
        return JsonJwkSerializer_instance;
    }
    function JsSigningKey() {}
    function JsVerificationKey() {}
    function JsSigningKeyPair(signingKey, verificationKey, id) {
        this.signingKey = signingKey;
        this.verificationKey = verificationKey;
        this.id = id;
    }
    protoOf(JsSigningKeyPair).i2a = function() {
        return this.signingKey;
    };
    protoOf(JsSigningKeyPair).j2a = function() {
        return this.verificationKey;
    };
    protoOf(JsSigningKeyPair).k2a = function() {
        return this.id;
    };
    protoOf(JsSigningKeyPair).ba = function() {
        return this.signingKey;
    };
    protoOf(JsSigningKeyPair).ca = function() {
        return this.verificationKey;
    };
    protoOf(JsSigningKeyPair).qj = function() {
        return this.id;
    };
    protoOf(JsSigningKeyPair).l2a = function(signingKey, verificationKey, id) {
        return new JsSigningKeyPair(signingKey, verificationKey, id);
    };
    protoOf(JsSigningKeyPair).copy = function(signingKey, verificationKey, id, $super) {
        signingKey = signingKey === VOID ? this.signingKey : signingKey;
        verificationKey = verificationKey === VOID ? this.verificationKey : verificationKey;
        id = id === VOID ? this.id : id;
        return this.l2a(signingKey, verificationKey, id);
    };
    protoOf(JsSigningKeyPair).toString = function() {
        return "JsSigningKeyPair(signingKey=" + toString(this.signingKey) + ", verificationKey=" + toString(this.verificationKey) + ", id=" + this.id + ")";
    };
    protoOf(JsSigningKeyPair).hashCode = function() {
        var result = hashCode(this.signingKey);
        result = imul(result, 31) + hashCode(this.verificationKey) | 0;
        result = imul(result, 31) + getStringHashCode(this.id) | 0;
        return result;
    };
    protoOf(JsSigningKeyPair).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsSigningKeyPair)) return false;
        var tmp0_other_with_cast = other instanceof JsSigningKeyPair ? other : THROW_CCE();
        if (!equals(this.signingKey, tmp0_other_with_cast.signingKey)) return false;
        if (!equals(this.verificationKey, tmp0_other_with_cast.verificationKey)) return false;
        if (!(this.id === tmp0_other_with_cast.id)) return false;
        return true;
    };
    function JsKeyStore() {}
    function JsJwsHeaderAndPayload$header$delegate$lambda($inner) {
        return function() {
            return JsonToJsConverter_instance.n28(ensureNotNull($inner.j29_1).xl());
        };
    }
    function JsJwsHeaderAndPayload$payload$delegate$lambda($inner) {
        return function() {
            return JsonToJsConverter_instance.n28($inner.k29_1.xl());
        };
    }
    function JsJwsHeaderAndPayload(inner) {
        var tmp = this;
        tmp.m2a_1 = lazy(JsJwsHeaderAndPayload$header$delegate$lambda(inner));
        var tmp_0 = this;
        tmp_0.n2a_1 = lazy(JsJwsHeaderAndPayload$payload$delegate$lambda(inner));
    }
    protoOf(JsJwsHeaderAndPayload).o2a = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.m2a_1;
        header$factory();
        return this_0.b1();
    };
    protoOf(JsJwsHeaderAndPayload).p2a = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.n2a_1;
        payload$factory();
        return this_0.b1();
    };
    function createSigningKeyFromJwk(jwkString) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, createSigningKeyFromJwk$slambda_0(jwkString, null));
    }
    function createVerificationKeyFromJwk(jwkString) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, createVerificationKeyFromJwk$slambda_0(jwkString, null));
    }
    function createJws(key, header, payload) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, createJws$slambda_0(header, payload, key, null));
    }
    function unsafeParseJws(jws) {
        var result = JwsUtil_getInstance().r2a(jws);
        return new JsJwsHeaderAndPayload(result);
    }
    function verifyJws(key, jws) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, verifyJws$slambda_0(key, jws, null));
    }
    function JsDefaultKeyStore$getSigningKeyPairById$slambda(this$0, $id, resultContinuation) {
        this.a2b_1 = this$0;
        this.b2b_1 = $id;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).d2b = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).y9 = function(p1, $completion) {
        return this.d2b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.a2b_1.f2b_1.g2b(this.b2b_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var tmp0_safe_receiver = suspendResult;
                    var tmp_0;
                    if (tmp0_safe_receiver == null) tmp_0 = null;
                    else {
                        var tmp_1 = tmp0_safe_receiver.u28_1;
                        var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
                        var tmp_3 = tmp0_safe_receiver.v28_1;
                        tmp_0 = new JsSigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), tmp0_safe_receiver.w28_1);
                    }
                    return tmp_0;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).e2b = function($this$promise, completion) {
        var i = new JsDefaultKeyStore$getSigningKeyPairById$slambda(this.a2b_1, this.b2b_1, completion);
        i.c2b_1 = $this$promise;
        return i;
    };
    function JsDefaultKeyStore$getSigningKeyPairById$slambda_0(this$0, $id, resultContinuation) {
        var i = new JsDefaultKeyStore$getSigningKeyPairById$slambda(this$0, $id, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.d2b($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsDefaultKeyStore$importSigningKeySpec$slambda(this$0, $id, $jwkString, resultContinuation) {
        this.p2b_1 = this$0;
        this.q2b_1 = $id;
        this.r2b_1 = $jwkString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).t2b = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).y9 = function(p1, $completion) {
        return this.t2b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.p2b_1.f2b_1.u2b(this.q2b_1, new JWK(this.r2b_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var it = suspendResult;
                    var tmp_0 = it.u28_1;
                    var tmp_1 = tmp_0 instanceof NativeSigningKey ? tmp_0 : THROW_CCE();
                    var tmp_2 = it.v28_1;
                    return new JsSigningKeyPair(tmp_1, tmp_2 instanceof NativeVerificationKey ? tmp_2 : THROW_CCE(), it.w28_1);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).e2b = function($this$promise, completion) {
        var i = new JsDefaultKeyStore$importSigningKeySpec$slambda(this.p2b_1, this.q2b_1, this.r2b_1, completion);
        i.s2b_1 = $this$promise;
        return i;
    };
    function JsDefaultKeyStore$importSigningKeySpec$slambda_0(this$0, $id, $jwkString, resultContinuation) {
        var i = new JsDefaultKeyStore$importSigningKeySpec$slambda(this$0, $id, $jwkString, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.t2b($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsDefaultKeyStore() {
        this.f2b_1 = Companion_instance_6.v2b();
    }
    protoOf(JsDefaultKeyStore).getSigningKeyPairById = function(id) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsDefaultKeyStore$getSigningKeyPairById$slambda_0(this, id, null));
    };
    protoOf(JsDefaultKeyStore).importSigningKeySpec = function(id, jwkString) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsDefaultKeyStore$importSigningKeySpec$slambda_0(this, id, jwkString, null));
    };
    function createSigningKeyFromJwk$slambda($jwkString, resultContinuation) {
        this.e2c_1 = $jwkString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(createSigningKeyFromJwk$slambda).g2c = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(createSigningKeyFromJwk$slambda).y9 = function(p1, $completion) {
        return this.g2c((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(createSigningKeyFromJwk$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = Companion_instance_7.h2c(this.e2c_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(createSigningKeyFromJwk$slambda).e2b = function($this$promise, completion) {
        var i = new createSigningKeyFromJwk$slambda(this.e2c_1, completion);
        i.f2c_1 = $this$promise;
        return i;
    };
    function createSigningKeyFromJwk$slambda_0($jwkString, resultContinuation) {
        var i = new createSigningKeyFromJwk$slambda($jwkString, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.g2c($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function createVerificationKeyFromJwk$slambda($jwkString, resultContinuation) {
        this.q2c_1 = $jwkString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(createVerificationKeyFromJwk$slambda).s2c = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(createVerificationKeyFromJwk$slambda).y9 = function(p1, $completion) {
        return this.s2c((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(createVerificationKeyFromJwk$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = Companion_instance_8.t2c(this.q2c_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(createVerificationKeyFromJwk$slambda).e2b = function($this$promise, completion) {
        var i = new createVerificationKeyFromJwk$slambda(this.q2c_1, completion);
        i.r2c_1 = $this$promise;
        return i;
    };
    function createVerificationKeyFromJwk$slambda_0($jwkString, resultContinuation) {
        var i = new createVerificationKeyFromJwk$slambda($jwkString, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.s2c($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function createJws$slambda($header, $payload, $key, resultContinuation) {
        this.c2d_1 = $header;
        this.d2d_1 = $payload;
        this.e2d_1 = $key;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(createJws$slambda).i2d = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(createJws$slambda).y9 = function(p1, $completion) {
        return this.i2d((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(createJws$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.g2d_1 = JsToJsonConverter_instance.l28(this.c2d_1);
                    this.h2d_1 = JsToJsonConverter_instance.l28(this.d2d_1);
                    this.v8_1 = 1;
                    var tmp_0 = JwsUtil_getInstance();
                    var tmp_1 = this.e2d_1;
                    suspendResult = tmp_0.j2d(tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE(), Companion_instance_4.d27(this.g2d_1), Companion_instance_5.d27(this.h2d_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(createJws$slambda).e2b = function($this$promise, completion) {
        var i = new createJws$slambda(this.c2d_1, this.d2d_1, this.e2d_1, completion);
        i.f2d_1 = $this$promise;
        return i;
    };
    function createJws$slambda_0($header, $payload, $key, resultContinuation) {
        var i = new createJws$slambda($header, $payload, $key, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.i2d($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function verifyJws$slambda($key, $jws, resultContinuation) {
        this.s2d_1 = $key;
        this.t2d_1 = $jws;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(verifyJws$slambda).v2d = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(verifyJws$slambda).y9 = function(p1, $completion) {
        return this.v2d((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(verifyJws$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    var tmp_0 = JwsUtil_getInstance();
                    var tmp_1 = this.s2d_1;
                    suspendResult = tmp_0.w2d(isInterface(tmp_1, VerificationKey) ? tmp_1 : THROW_CCE(), this.t2d_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var result = suspendResult;
                    return new JsJwsHeaderAndPayload(result);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(verifyJws$slambda).e2b = function($this$promise, completion) {
        var i = new verifyJws$slambda(this.s2d_1, this.t2d_1, completion);
        i.u2d_1 = $this$promise;
        return i;
    };
    function verifyJws$slambda_0($key, $jws, resultContinuation) {
        var i = new verifyJws$slambda($key, $jws, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.v2d($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function header$factory() {
        return getPropertyCallableRef("header", 1, KProperty1, function(receiver) {
            return receiver.header;
        }, null);
    }
    function payload$factory() {
        return getPropertyCallableRef("payload", 1, KProperty1, function(receiver) {
            return receiver.payload;
        }, null);
    }
    function get_ianaNamesToWebCryptoNames() {
        _init_properties_HashFunctions_kt__715y2t();
        return ianaNamesToWebCryptoNames;
    }
    var ianaNamesToWebCryptoNames;
    function createHashFunction(algorithm) {
        _init_properties_HashFunctions_kt__715y2t();
        var tmp0_elvis_lhs = get_ianaNamesToWebCryptoNames().e2(algorithm);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var webCryptoName = tmp;
        return createHashFunction$slambda_0(webCryptoName, null);
    }
    function createHashFunction$slambda($webCryptoName, resultContinuation) {
        this.f2e_1 = $webCryptoName;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(createHashFunction$slambda).i2e = function(input, $completion) {
        var tmp = this.j2e(input, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(createHashFunction$slambda).y9 = function(p1, $completion) {
        return this.i2e((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(createHashFunction$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.h2e_1 = this.g2e_1;
                    this.v8_1 = 1;
                    suspendResult = await_0(get_portableCrypto().subtle.digest(this.f2e_1, this.h2e_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var arrayBuffer = suspendResult;
                    return new Int8Array(arrayBuffer);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(createHashFunction$slambda).j2e = function(input, completion) {
        var i = new createHashFunction$slambda(this.f2e_1, completion);
        i.g2e_1 = input;
        return i;
    };
    function createHashFunction$slambda_0($webCryptoName, resultContinuation) {
        var i = new createHashFunction$slambda($webCryptoName, resultContinuation);
        var l = function(input, $completion) {
            return i.i2e(input, $completion);
        };
        l.$arity = 1;
        return l;
    }
    var properties_initialized_HashFunctions_kt_isn33x;
    function _init_properties_HashFunctions_kt__715y2t() {
        if (!properties_initialized_HashFunctions_kt_isn33x) {
            properties_initialized_HashFunctions_kt_isn33x = true;
            ianaNamesToWebCryptoNames = mapOf([
                to("sha-256", "SHA-256"),
                to("sha-384", "SHA-384"),
                to("sha-384", "SHA-512")
            ]);
        }
    }
    function Companion_6() {}
    protoOf(Companion_6).v2b = function() {
        return new NodeJoseKeyStore(Jose.JWK.createKeyStore());
    };
    var Companion_instance_6;
    function Companion_getInstance_6() {
        return Companion_instance_6;
    }
    function $importSigningKeyPairCOROUTINE$1(_this__u8e3s4, id, spec, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.s2e_1 = _this__u8e3s4;
        this.t2e_1 = id;
        this.u2e_1 = spec;
    }
    protoOf($importSigningKeyPairCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v2e_1 = this.u2e_1;
                    var tmp_0 = this.v2e_1;
                    if (tmp_0 instanceof JWK) {
                        this.v8_1 = 1;
                        var it = JSON.parse(this.u2e_1.o28_1);
                        it["kid"] = this.t2e_1;
                        suspendResult = await_0(this.s2e_1.x2e_1.add(JSON.stringify(it)), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_1 = this;
                        noWhenBranchMatchedException();
                    }
                    break;
                case 1:
                    this.w2e_1 = suspendResult;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    var nativeKey = this.w2e_1;
                    return new SigningKeyPair(new NativeSigningKey(nativeKey), new NativeVerificationKey(nativeKey), this.t2e_1);
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function NodeJoseKeyStore(keyStore) {
        this.x2e_1 = keyStore;
    }
    protoOf(NodeJoseKeyStore).g2b = function(id, $completion) {
        var tmp2_safe_receiver = this.x2e_1.get(id);
        var tmp;
        if (tmp2_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return new SigningKeyPair(new NativeSigningKey(tmp2_safe_receiver), new NativeVerificationKey(tmp2_safe_receiver), id);
        return tmp;
    };
    protoOf(NodeJoseKeyStore).u2b = function(id, spec, $completion) {
        var tmp = new $importSigningKeyPairCOROUTINE$1(this, id, spec, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function get_portableCrypto() {
        _init_properties_PortableCrypto_kt__13g90k();
        return portableCrypto;
    }
    var portableCrypto;
    var properties_initialized_PortableCrypto_kt_ubyltq;
    function _init_properties_PortableCrypto_kt__13g90k() {
        if (!properties_initialized_PortableCrypto_kt_ubyltq) {
            properties_initialized_PortableCrypto_kt_ubyltq = true;
            // Inline function 'kotlin.js.unsafeCast' call
            portableCrypto = globalThis.crypto;
        }
    }
    function secureRandom(len) {
        var bytes = new Int8Array(len);
        get_portableCrypto().getRandomValues(bytes);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return bytes;
    }
    function $createJsSigningKeyCOROUTINE$2(_this__u8e3s4, jwkString, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.g2f_1 = _this__u8e3s4;
        this.h2f_1 = jwkString;
    }
    protoOf($createJsSigningKeyCOROUTINE$2).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = await_0(Jose.JWK.asKey(this.h2f_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var key = suspendResult;
                    if (JSON.stringify(key.toJSON()) === JSON.stringify(key.toJSON(true))) throw Companion_instance.q28();
                    this.i2f_1 = new NativeSigningKey(key);
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof Error) {
                        var ex = this.y8_1;
                        var tmp_1 = this;
                        throw Companion_instance.p28(ex.message);
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    return this.i2f_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_7() {}
    protoOf(Companion_7).h2c = function(jwkString, $completion) {
        var tmp = new $createJsSigningKeyCOROUTINE$2(this, jwkString, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_7;
    function Companion_getInstance_7() {
        return Companion_instance_7;
    }
    function $createJsVerificationKeyCOROUTINE$3(_this__u8e3s4, jwkString, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.r2f_1 = _this__u8e3s4;
        this.s2f_1 = jwkString;
    }
    protoOf($createJsVerificationKeyCOROUTINE$3).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = await_0(Jose.JWK.asKey(this.s2f_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var key = suspendResult;
                    this.t2f_1 = new NativeVerificationKey(key);
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof Error) {
                        var ex = this.y8_1;
                        var tmp_1 = this;
                        throw Companion_instance.r28(ex.message);
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    return this.t2f_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_8() {}
    protoOf(Companion_8).x28 = function(jwkString, $completion) {
        return this.t2c(jwkString, $completion);
    };
    protoOf(Companion_8).t2c = function(jwkString, $completion) {
        var tmp = new $createJsVerificationKeyCOROUTINE$3(this, jwkString, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_8;
    function Companion_getInstance_8() {
        return Companion_instance_8;
    }
    function VerificationKey() {}
    function $fromJwksCOROUTINE$4(_this__u8e3s4, jwksString, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.d2g_1 = _this__u8e3s4;
        this.e2g_1 = jwksString;
    }
    protoOf($fromJwksCOROUTINE$4).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = await_0(Jose.JWK.asKeyStore(this.e2g_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    var ARGUMENT_0 = new NodeJoseKeyStore(ARGUMENT);
                    return new DefaultVerificationKeySet(ARGUMENT_0);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_9() {}
    protoOf(Companion_9).f2g = function(jwksString, $completion) {
        var tmp = new $fromJwksCOROUTINE$4(this, jwksString, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_9;
    function Companion_getInstance_9() {
        return Companion_instance_9;
    }
    function $verifyJwsCOROUTINE$5(_this__u8e3s4, key, jws, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.o2g_1 = _this__u8e3s4;
        this.p2g_1 = key;
        this.q2g_1 = jws;
    }
    protoOf($verifyJwsCOROUTINE$5).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    var tmp_1 = this.p2g_1;
                    tmp_0.r2g_1 = (tmp_1 instanceof NativeVerificationKey ? tmp_1 : THROW_CCE()).u2g_1;
                    var tmp_2 = this;
                    tmp_2.s2g_1 = "Error verifying JWS";
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = await_0(Jose.JWS.createVerify(this.r2g_1).verify(this.q2g_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.t2g_1 = suspendResult;
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 4;
                    var tmp_3 = this.y8_1;
                    if (tmp_3 instanceof Error) {
                        var ex = this.y8_1;
                        var tmp_4 = this;
                        throw new CryptoException(this.s2g_1 + " (" + ex.message + ")", ex);
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 4;
                    var result = this.t2g_1;
                    var tmp_5 = JsToJsonConverter_instance.k28(result.header);
                    var header = tmp_5 instanceof JsonObject ? tmp_5 : THROW_CCE();
                    var protectedHeaders = toSet_0(result.protected);
                    if (!equals(header.f2(), protectedHeaders)) throw new CryptoException("Header properties don't match protected header properties");
                    var msg = "Payload must be a JSON object";
                    var tmp_6;
                    try {
                        var this_0 = Default_getInstance_1();
                        var string = JwsUtil_getInstance().q2a_1.decode(result.payload);
                        var this_1 = this_0.dp();
                        var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
                        tmp_6 = this_0.cp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
                    } catch ($p) {
                        var tmp_7;
                        if ($p instanceof Error) {
                            var ex_0 = $p;
                            throw new CryptoException(msg + " (" + ex_0.message + ")", ex_0);
                        } else throw $p;
                    }
                    var payload = tmp_6;
                    if (!equals(result.key, this.r2g_1)) throw new CryptoException("Key mismatch");
                    return new Jws(Companion_instance_4.d27(header), payload);
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $verifyJwsCOROUTINE$6(_this__u8e3s4, keySet, jws, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.e2h_1 = _this__u8e3s4;
        this.f2h_1 = keySet;
        this.g2h_1 = jws;
    }
    protoOf($verifyJwsCOROUTINE$6).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.h2h_1 = this.f2h_1.k2h().x2e_1;
                    var tmp_0 = this;
                    tmp_0.i2h_1 = "Error verifying JWS";
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = await_0(Jose.JWS.createVerify(this.h2h_1).verify(this.g2h_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.j2h_1 = suspendResult;
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 4;
                    var tmp_1 = this.y8_1;
                    if (tmp_1 instanceof Error) {
                        var ex = this.y8_1;
                        var tmp_2 = this;
                        throw new CryptoException(this.i2h_1 + " (" + ex.message + ")", ex);
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 4;
                    var result = this.j2h_1;
                    var tmp_3 = JsToJsonConverter_instance.k28(result.header);
                    var header = tmp_3 instanceof JsonObject ? tmp_3 : THROW_CCE();
                    var protectedHeaders = toSet_0(result.protected);
                    if (!equals(header.f2(), protectedHeaders)) throw new CryptoException("Header properties don't match protected header properties");
                    var msg = "Payload must be a JSON object";
                    var tmp_4;
                    try {
                        var this_0 = Default_getInstance_1();
                        var string = JwsUtil_getInstance().q2a_1.decode(result.payload);
                        var this_1 = this_0.dp();
                        var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
                        tmp_4 = this_0.cp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
                    } catch ($p) {
                        var tmp_5;
                        if ($p instanceof Error) {
                            var ex_0 = $p;
                            throw new CryptoException(msg + " (" + ex_0.message + ")", ex_0);
                        } else throw $p;
                    }
                    var payload = tmp_4;
                    if (!contains(this.h2h_1.all(), result.key)) throw new CryptoException("Key mismatch");
                    return new Jws(Companion_instance_4.d27(header), payload);
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function JwsUtil() {
        JwsUtil_instance = this;
        this.q2a_1 = new TextDecoder();
    }
    protoOf(JwsUtil).j2d = function(key, header, payload, $completion) {
        var privateKey = (key instanceof NativeSigningKey ? key : THROW_CCE()).key;
        var opt = json([
            to("compact", true),
            to("fields", JsonToJsConverter_instance.n28(header.xl()))
        ]);
        var keyOpt = json([
            to("key", privateKey),
            to("reference", false)
        ]);
        var tmp = Jose.JWS.createSign(opt, keyOpt);
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance_1();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, payload);
        return await_0(tmp.update(tmp$ret$2).final(), $completion);
    };
    protoOf(JwsUtil).r2a = function(jws) {
        var parts = split(jws, [
            "."
        ]);
        if (!(parts.m() === 3)) throw new CryptoException("JWS must have three parts, however has " + parts.m() + " parts");
        // Inline function 'io.curity.ssi.crypto.tryAndMapToCryptoException' call
        var msg = "First part must be a JSON object";
        var tmp;
        try {
            // Inline function 'io.curity.ssi.jose.JwsUtil.unsafeParseJws.<anonymous>' call
            // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
            var this_0 = Default_getInstance_1();
            var string = JwsUtil_getInstance().q2a_1.decode(Jose.util.base64url.decode(parts.o(0)));
            // Inline function 'kotlinx.serialization.serializer' call
            var this_1 = this_0.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_2 = serializer(this_1, createKType(getKClass(JsonJwsHeader), arrayOf([]), false));
            var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
            tmp = this_0.cp(tmp$ret$1, string);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var ex = $p;
                throw new CryptoException(msg + " (" + ex.message + ")", ex);
            } else throw $p;
        }
        var header = tmp;
        // Inline function 'io.curity.ssi.crypto.tryAndMapToCryptoException' call
        var msg_0 = "Second part must be a JSON object";
        var tmp_1;
        try {
            // Inline function 'io.curity.ssi.jose.JwsUtil.unsafeParseJws.<anonymous>' call
            // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
            var this_3 = Default_getInstance_1();
            var string_0 = JwsUtil_getInstance().q2a_1.decode(Jose.util.base64url.decode(parts.o(1)));
            // Inline function 'kotlinx.serialization.serializer' call
            var this_4 = this_3.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_5 = serializer(this_4, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
            var tmp$ret$6 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
            tmp_1 = this_3.cp(tmp$ret$6, string_0);
        } catch ($p) {
            var tmp_2;
            if ($p instanceof Error) {
                var ex_0 = $p;
                throw new CryptoException(msg_0 + " (" + ex_0.message + ")", ex_0);
            } else throw $p;
        }
        var payload = tmp_1;
        return new Jws(header, payload);
    };
    protoOf(JwsUtil).w2d = function(key, jws, $completion) {
        var tmp = new $verifyJwsCOROUTINE$5(this, key, jws, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JwsUtil).l2h = function(keySet, jws, $completion) {
        var tmp = new $verifyJwsCOROUTINE$6(this, keySet, jws, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var JwsUtil_instance;
    function JwsUtil_getInstance() {
        if (JwsUtil_instance == null) new JwsUtil();
        return JwsUtil_instance;
    }
    function NativeSigningKey(key) {
        this.key = key;
    }
    protoOf(NativeSigningKey).a1 = function() {
        return this.key;
    };
    protoOf(NativeSigningKey).ba = function() {
        return this.key;
    };
    protoOf(NativeSigningKey).m2h = function(key) {
        return new NativeSigningKey(key);
    };
    protoOf(NativeSigningKey).copy = function(key, $super) {
        key = key === VOID ? this.key : key;
        return this.m2h(key);
    };
    protoOf(NativeSigningKey).toString = function() {
        return "NativeSigningKey(key=" + toString(this.key) + ")";
    };
    protoOf(NativeSigningKey).hashCode = function() {
        return hashCode(this.key);
    };
    protoOf(NativeSigningKey).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof NativeSigningKey)) return false;
        var tmp0_other_with_cast = other instanceof NativeSigningKey ? other : THROW_CCE();
        if (!equals(this.key, tmp0_other_with_cast.key)) return false;
        return true;
    };
    function NativeVerificationKey$jwk$delegate$lambda(this$0) {
        return function() {
            var jsonElement = JsToJsonConverter_instance.k28(this$0.u2g_1.toJSON());
            var tmp;
            if (jsonElement instanceof JsonObject) tmp = Companion_getInstance_1().d27(jsonElement);
            else throw Exception_init_$Create$("Unexpected JWT format");
            return tmp;
        };
    }
    function NativeVerificationKey(key) {
        this.u2g_1 = key;
        var tmp = this;
        tmp.v2g_1 = lazy(NativeVerificationKey$jwk$delegate$lambda(this));
    }
    protoOf(NativeVerificationKey).u2f = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.v2g_1;
        jwk$factory();
        return this_0.b1();
    };
    protoOf(NativeVerificationKey).toString = function() {
        return "NativeVerificationKey(key=" + toString(this.u2g_1) + ")";
    };
    protoOf(NativeVerificationKey).hashCode = function() {
        return hashCode(this.u2g_1);
    };
    protoOf(NativeVerificationKey).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof NativeVerificationKey)) return false;
        var tmp0_other_with_cast = other instanceof NativeVerificationKey ? other : THROW_CCE();
        if (!equals(this.u2g_1, tmp0_other_with_cast.u2g_1)) return false;
        return true;
    };
    function jwk$factory() {
        return getPropertyCallableRef("jwk", 1, KProperty1, function(receiver) {
            return receiver.u2f();
        }, null);
    }
    function DefaultVerificationKeySet(keyStore) {
        this.n2h_1 = keyStore;
    }
    protoOf(DefaultVerificationKeySet).k2h = function() {
        return this.n2h_1;
    };
    protoOf(DefaultVerificationKeySet).toString = function() {
        return "DefaultVerificationKeySet(keyStore=" + toString(this.n2h_1) + ")";
    };
    protoOf(DefaultVerificationKeySet).hashCode = function() {
        return hashCode(this.n2h_1);
    };
    protoOf(DefaultVerificationKeySet).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DefaultVerificationKeySet)) return false;
        var tmp0_other_with_cast = other instanceof DefaultVerificationKeySet ? other : THROW_CCE();
        if (!equals(this.n2h_1, tmp0_other_with_cast.n2h_1)) return false;
        return true;
    };
    //region block: post-declaration
    defineProp(protoOf(CryptoException), "message", function() {
        return this.l9();
    });
    protoOf(JsonJwk).f2 = get_keys;
    protoOf(JsonJwk).vl = get;
    protoOf(JsonJwk).xl = toMap_0;
    protoOf(JsonJwk).a27 = toJson_0;
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    protoOf(JsonJwsHeader).f2 = get_keys;
    protoOf(JsonJwsHeader).vl = get;
    protoOf(JsonJwsHeader).xl = toMap_0;
    protoOf(JsonJwsHeader).a27 = toJson_0;
    protoOf(JsonJwtClaimsSet).f2 = get_keys;
    protoOf(JsonJwtClaimsSet).vl = get;
    protoOf(JsonJwtClaimsSet).xl = toMap_0;
    protoOf(JsonJwtClaimsSet).a27 = toJson_0;
    defineProp(protoOf(JsJwsHeaderAndPayload), "header", protoOf(JsJwsHeaderAndPayload).o2a);
    defineProp(protoOf(JsJwsHeaderAndPayload), "payload", protoOf(JsJwsHeaderAndPayload).p2a);
    //endregion
    //region block: init
    Companion_instance = new Companion();
    Companion_instance_0 = new Companion_0();
    Companion_instance_3 = new Companion_3();
    Companion_instance_4 = new Companion_4();
    Companion_instance_5 = new Companion_5();
    Companion_instance_6 = new Companion_6();
    Companion_instance_7 = new Companion_7();
    Companion_instance_8 = new Companion_8();
    Companion_instance_9 = new Companion_9();
    //endregion
    //region block: exports
    function $jsExportAll$(_) {
        _.JsSigningKeyPair = JsSigningKeyPair;
        _.JsJwsHeaderAndPayload = JsJwsHeaderAndPayload;
        _.createSigningKeyFromJwk = createSigningKeyFromJwk;
        _.createVerificationKeyFromJwk = createVerificationKeyFromJwk;
        _.createJws = createJws;
        _.unsafeParseJws = unsafeParseJws;
        _.verifyJws = verifyJws;
        var $io = _.io || (_.io = {});
        var $io$curity = $io.curity || ($io.curity = {});
        var $io$curity$ssi = $io$curity.ssi || ($io$curity.ssi = {});
        var $io$curity$ssi$jose = $io$curity$ssi.jose || ($io$curity$ssi.jose = {});
        $io$curity$ssi$jose.NativeSigningKey = NativeSigningKey;
    }
    $jsExportAll$(_);
    _.$jsExportAll$ = $jsExportAll$;
    _.$_$ = _.$_$ || {};
    _.$_$.a = JsDefaultKeyStore;
    _.$_$.b = JsJwsHeaderAndPayload;
    _.$_$.c = fromJwkDictionary;
    _.$_$.d = Companion_instance_0;
    _.$_$.e = Companion_instance_8;
    _.$_$.f = Companion_instance_9;
    _.$_$.g = Companion_getInstance_1;
    _.$_$.h = $serializer_getInstance;
    _.$_$.i = $serializer_getInstance_0;
    _.$_$.j = JwsUtil_getInstance;
    _.$_$.k = CryptoException;
    _.$_$.l = SigningKeyPair;
    _.$_$.m = createHashFunction;
    _.$_$.n = decodeBase64Url;
    _.$_$.o = encodeBase64url;
    _.$_$.p = secureRandom;
    _.$_$.q = sha256;
    _.$_$.r = JsonJwk;
    _.$_$.s = JsonJwsHeader;
    _.$_$.t = Jws;
    _.$_$.u = JsonJwtClaimsSet;
    _.$_$.v = NativeSigningKey;
    _.$_$.w = NativeVerificationKey;
    //endregion
    return _;
});

});
parcelRegister("gOLPe", function(module, exports) {
/*!
 * index.js - Main Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $c3e669f35a801371$require$Buffer = (parcelRequire("6ZWSX")).Buffer;

"use strict";

if (typeof Promise === "undefined") (parcelRequire("lcSRC")).polyfill();

if (typeof $c3e669f35a801371$require$Buffer === "undefined") ($parcel$global || window).Buffer = (parcelRequire("6ZWSX")).Buffer;

if (typeof (parcelRequire("hPtJY")) === "undefined") ($parcel$global || window).process = (parcelRequire("hPtJY"));
if (!(parcelRequire("hPtJY")).version) (parcelRequire("hPtJY")).version = "";

var $3jdDF = parcelRequire("3jdDF");





module.exports = {
    JWA: (parcelRequire("5s97J")),
    JWE: (parcelRequire("d4JNN")),
    JWK: (parcelRequire("dXx0Z")),
    JWS: $3jdDF,
    util: (parcelRequire("jIqqR")),
    parse: (parcelRequire("km0rz")),
    canYouSee: $3jdDF.createVerify
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("lcSRC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $hPtJY !== "undefined" && ({}).toString.call($hPtJY) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $hPtJY.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});

parcelRegister("3jdDF", function(module, exports) {
/*!
 * jws/index.js - JSON Web Signature (JWS) Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";


var $268db9ce2f7a4ac3$var$JWS = {
    createSign: (parcelRequire("hesQ4")).createSign,
    createVerify: (parcelRequire("cV9MM")).createVerify
};
module.exports = $268db9ce2f7a4ac3$var$JWS;

});
parcelRegister("hesQ4", function(module, exports) {
/*!
 * jws/sign.js - Sign to JWS
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c8ba1d3e88fce772$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $2rglK = parcelRequire("2rglK");

var $jIqqR = parcelRequire("jIqqR");

var $dXx0Z = parcelRequire("dXx0Z");

var $jJIby = parcelRequire("jJIby");
var $c8ba1d3e88fce772$require$slice = $jJIby.slice;

var $bTYY2 = parcelRequire("bTYY2");

var $8l7PP = parcelRequire("8l7PP");

var $hsmwv = parcelRequire("hsmwv");
/**
 * @class JWS.Signer
 * @classdesc Generator of signed content.
 *
 * @description
 * **NOTE:** this class cannot be instantiated directly. Instead call {@link
 * JWS.createSign}.
 */ var $c8ba1d3e88fce772$var$JWSSigner = function(cfg, signatories) {
    var finalized = false, format = cfg.format || "general", content = $c8ba1d3e88fce772$require$Buffer.alloc(0);
    /**
  * @member {Boolean} JWS.Signer#compact
  * @description
  * Indicates whether the outuput of this signature generator is using
  * the Compact serialization (`true`) or the JSON serialization
  * (`false`).
  */ Object.defineProperty(this, "compact", {
        get: function() {
            return "compact" === format;
        },
        enumerable: true
    });
    Object.defineProperty(this, "format", {
        get: function() {
            return format;
        },
        enumerable: true
    });
    /**
  * @method JWS.Signer#update
  * @description
  * Updates the signing content for this signature content. The content
  * is appended to the end of any other content already applied.
  *
  * If {data} is a Buffer, {encoding} is ignored. Otherwise, {data} is
  * converted to a Buffer internally to {encoding}.
  *
  * @param {Buffer|String} data The data to sign.
  * @param {String} [encoding="binary"] The encoding of {data}.
  * @returns {JWS.Signer} This signature generator.
  * @throws {Error} If a signature has already been generated.
  */ Object.defineProperty(this, "update", {
        value: function(data, encoding) {
            if (finalized) throw new Error("already final");
            if (data != null) {
                data = $jIqqR.asBuffer(data, encoding);
                if (content.length) content = $c8ba1d3e88fce772$require$Buffer.concat([
                    content,
                    data
                ], content.length + data.length);
                else content = data;
            }
            return this;
        }
    });
    /**
  * @method JWS.Signer#final
  * @description
  * Finishes the signature operation.
  *
  * The returned Promise, when fulfilled, is the JSON Web Signature (JWS)
  * object, either in the Compact (if {@link JWS.Signer#format} is
  * `"compact"`), the flattened JSON (if {@link JWS.Signer#format} is
  * "flattened"), or the general JSON serialization.
  *
  * @param {Buffer|String} [data] The final content to apply.
  * @param {String} [encoding="binary"] The encoding of the final content
  *        (if any).
  * @returns {Promise} The promise for the signatures
  * @throws {Error} If a signature has already been generated.
  */ Object.defineProperty(this, "final", {
        value: function(data, encoding) {
            if (finalized) return Promise.reject(new Error("already final"));
            // last-minute data
            this.update(data, encoding);
            // mark as done...ish
            finalized = true;
            var promise;
            // map signatory promises to just signatories
            promise = Promise.all(signatories);
            promise = promise.then(function(sigs) {
                // prepare content
                content = $jIqqR.base64url.encode(content);
                sigs = sigs.map(function(s) {
                    // prepare protected
                    var protect = {}, lenProtect = 0, unprotect = $bTYY2(s.header), lenUnprotect = Object.keys(unprotect).length;
                    s.protected.forEach(function(h) {
                        if (!(h in unprotect)) return;
                        protect[h] = unprotect[h];
                        lenProtect++;
                        delete unprotect[h];
                        lenUnprotect--;
                    });
                    if (lenProtect > 0) {
                        protect = JSON.stringify(protect);
                        protect = $jIqqR.base64url.encode(protect);
                    } else protect = "";
                    // signit!
                    var data = $c8ba1d3e88fce772$require$Buffer.from(protect + "." + content, "ascii");
                    s = s.key.sign(s.header.alg, data, s.header);
                    s = s.then(function(result) {
                        var sig = {};
                        if (0 < lenProtect) sig.protected = protect;
                        if (0 < lenUnprotect) sig.header = unprotect;
                        sig.signature = $jIqqR.base64url.encode(result.mac);
                        return sig;
                    });
                    return s;
                });
                sigs = [
                    Promise.resolve(content)
                ].concat(sigs);
                return Promise.all(sigs);
            });
            promise = promise.then(function(results) {
                var content = results[0];
                return {
                    payload: content,
                    signatures: results.slice(1)
                };
            });
            switch(format){
                case "compact":
                    promise = promise.then(function(jws) {
                        var compact = [
                            jws.signatures[0].protected,
                            jws.payload,
                            jws.signatures[0].signature
                        ];
                        compact = compact.join(".");
                        return compact;
                    });
                    break;
                case "flattened":
                    promise = promise.then(function(jws) {
                        var flattened = {};
                        flattened.payload = jws.payload;
                        var sig = jws.signatures[0];
                        if (sig.protected) flattened.protected = sig.protected;
                        if (sig.header) flattened.header = sig.header;
                        flattened.signature = sig.signature;
                        return flattened;
                    });
                    break;
            }
            return promise;
        }
    });
};
/**
 * @description
 * Creates a new JWS.Signer with the given options and signatories.
 *
 * @param {Object} [opts] The signing options
 * @param {Boolean} [opts.compact] Use compact serialization?
 * @param {String} [opts.format] The serialization format to use ("compact",
 *                 "flattened", "general")
 * @param {Object} [opts.fields] Additional header fields
 * @param {JWK.Key[]|Object[]} [signs] Signatories, either as an array of
 *        JWK.Key instances; or an array of objects, each with the following
 *        properties
 * @param {JWK.Key} signs.key Key used to sign content
 * @param {Object} [signs.header] Per-signatory header fields
 * @param {String} [signs.reference] Reference field to identify the key
 * @param {String[]|String} [signs.protect] List of fields to integrity
 *        protect ("*" to protect all fields)
 * @returns {JWS.Signer} The signature generator.
 * @throws {Error} If Compact serialization is requested but there are
 *         multiple signatories
 */ function $c8ba1d3e88fce772$var$createSign(opts, signs) {
    // fixup signatories
    var options = opts, signStart = 1, signList = signs;
    if (arguments.length === 0) throw new Error("at least one signatory must be provided");
    if (arguments.length === 1) {
        signList = opts;
        signStart = 0;
        options = {};
    } else if ($dXx0Z.isKey(opts) || opts && "kty" in opts || opts && "key" in opts && ($dXx0Z.isKey(opts.key) || "kty" in opts.key)) {
        signList = opts;
        signStart = 0;
        options = {};
    } else options = $bTYY2(opts);
    if (!Array.isArray(signList)) signList = $c8ba1d3e88fce772$require$slice(arguments, signStart);
    // fixup options
    options = $2rglK($bTYY2($hsmwv), options);
    // setup header fields
    var allFields = options.fields || {};
    // setup serialization format
    var format = options.format;
    if (!format) format = options.compact ? "compact" : "general";
    if (("compact" === format || "flattened" === format) && 1 < signList.length) throw new Error("too many signatories for compact or flattened JSON serialization");
    // note protected fields (globally)
    // protected fields are per signature
    var protectAll = "*" === options.protect;
    if (options.compact) protectAll = true;
    signList = signList.map(function(s, idx) {
        var p;
        // resolve a key
        if (s && "kty" in s) {
            p = $dXx0Z.asKey(s);
            p = p.then(function(k) {
                return {
                    key: k
                };
            });
        } else if (s) {
            p = $dXx0Z.asKey(s.key);
            p = p.then(function(k) {
                return {
                    header: s.header,
                    reference: s.reference,
                    protect: s.protect,
                    key: k
                };
            });
        } else p = Promise.reject(new Error("missing key for signatory " + idx));
        // resolve the complete signatory
        p = p.then(function(signatory) {
            var key = signatory.key;
            // make sure there is a header
            var header = signatory.header || {};
            header = $2rglK($2rglK({}, allFields), header);
            signatory.header = header;
            // ensure an algorithm
            if (!header.alg) header.alg = key.algorithms($dXx0Z.MODE_SIGN)[0] || "";
            // determine the key reference
            var ref = signatory.reference;
            delete signatory.reference;
            if (undefined === ref) {
                // header already contains the key reference
                ref = [
                    "kid",
                    "jku",
                    "x5c",
                    "x5t",
                    "x5u"
                ].some(function(k) {
                    return k in header;
                });
                ref = !ref ? "kid" : null;
            } else if ("boolean" === typeof ref) // explicit (positive | negative) request for key reference
            ref = ref ? "kid" : null;
            var jwk;
            if (ref) {
                jwk = key.toJSON();
                if ("jwk" === ref) {
                    if ("oct" === key.kty) return Promise.reject(new Error("cannot embed key"));
                    header.jwk = jwk;
                } else if (ref in jwk) header[ref] = jwk[ref];
            }
            // determine protected fields
            var protect = signatory.protect;
            if (protectAll || "*" === protect) protect = Object.keys(header);
            else if ("string" === protect) protect = [
                protect
            ];
            else if (Array.isArray(protect)) protect = protect.concat();
            else if (!protect) protect = [];
            else return Promise.reject(new Error("protect must be a list of fields"));
            protect = $8l7PP(protect);
            signatory.protected = protect;
            // freeze signatory
            signatory = Object.freeze(signatory);
            return signatory;
        });
        return p;
    });
    var cfg = {
        format: format
    };
    return new $c8ba1d3e88fce772$var$JWSSigner(cfg, signList);
}
module.exports = {
    signer: $c8ba1d3e88fce772$var$JWSSigner,
    createSign: $c8ba1d3e88fce772$var$createSign
};

});
parcelRegister("2rglK", function(module, exports) {
/*!
 * util/utf8.js - Implementation of UTF-8 Encoder/Decoder
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1c6ac91b65ebd1aa$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $crE1u = parcelRequire("crE1u");

var $5W3lT = parcelRequire("5W3lT");
var $1c6ac91b65ebd1aa$var$typedArrayCtors = function() {
    var ctors = [];
    if ("undefined" !== typeof Uint8ClampedArray) ctors.push(Uint8ClampedArray);
    if ("undefined" !== typeof Uint8Array) ctors.push(Uint8Array);
    if ("undefined" !== typeof Uint16Array) ctors.push(Uint16Array);
    if ("undefined" !== typeof Uint32Array) ctors.push(Uint32Array);
    if ("undefined" !== typeof Float32Array) ctors.push(Float32Array);
    if ("undefined" !== typeof Float64Array) ctors.push(Float64Array);
    return ctors;
}();
function $1c6ac91b65ebd1aa$var$findTypedArrayFor(ta) {
    var ctor;
    for(var idx = 0; !ctor && $1c6ac91b65ebd1aa$var$typedArrayCtors.length > idx; idx++)if (ta instanceof $1c6ac91b65ebd1aa$var$typedArrayCtors[idx]) ctor = $1c6ac91b65ebd1aa$var$typedArrayCtors[idx];
    return ctor;
}
function $1c6ac91b65ebd1aa$var$mergeBuffer(a, b) {
    // TODO: should this be a copy, or the reference itself?
    if ($1c6ac91b65ebd1aa$require$Buffer.isBuffer(b)) b = $1c6ac91b65ebd1aa$require$Buffer.from(b);
    else {
        var Ctor = $1c6ac91b65ebd1aa$var$findTypedArrayFor(b);
        b = Ctor ? new Ctor(b, b.byteOffset, b.byteLength) : undefined;
    }
    // TODO: QUESTION: create a merged <whatever-a-is>??
    // for now, a is b
    a = b;
    return b;
}
module.exports = $crE1u($5W3lT, $1c6ac91b65ebd1aa$var$mergeBuffer);

});
parcelRegister("crE1u", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $8Eez4 = parcelRequire("8Eez4");

var $gouWF = parcelRequire("gouWF");

var $ld4gQ = parcelRequire("ld4gQ");
/** Used to compose bitmasks for function metadata. */ var $90f70d613584bed0$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */ var $90f70d613584bed0$var$partialRight = $5iyRF(function(func, partials) {
    var holders = $ld4gQ(partials, $gouWF($90f70d613584bed0$var$partialRight));
    return $8Eez4(func, $90f70d613584bed0$var$WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});
// Assign default placeholders.
$90f70d613584bed0$var$partialRight.placeholder = {};
module.exports = $90f70d613584bed0$var$partialRight;

});
parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + "");
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});
parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});

parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $9HRmE(string),
        "writable": true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});
parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});




parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});



parcelRegister("8Eez4", function(module, exports) {

var $chNEK = parcelRequire("chNEK");

var $b7vOf = parcelRequire("b7vOf");

var $kRl9d = parcelRequire("kRl9d");

var $5zmg4 = parcelRequire("5zmg4");

var $a84EQ = parcelRequire("a84EQ");

var $cW0XY = parcelRequire("cW0XY");

var $lMyBN = parcelRequire("lMyBN");

var $GgyWv = parcelRequire("GgyWv");

var $939hr = parcelRequire("939hr");

var $2MGGR = parcelRequire("2MGGR");
/** Error message constants. */ var $64bd5b6036bdbf9d$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to compose bitmasks for function metadata. */ var $64bd5b6036bdbf9d$var$WRAP_BIND_FLAG = 1, $64bd5b6036bdbf9d$var$WRAP_BIND_KEY_FLAG = 2, $64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG = 8, $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG = 16, $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG = 32, $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $64bd5b6036bdbf9d$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $64bd5b6036bdbf9d$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $64bd5b6036bdbf9d$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != "function") throw new TypeError($64bd5b6036bdbf9d$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG | $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $64bd5b6036bdbf9d$var$nativeMax($2MGGR(ary), 0);
    arity = arity === undefined ? arity : $2MGGR(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $64bd5b6036bdbf9d$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $cW0XY(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $lMyBN(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $64bd5b6036bdbf9d$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG | $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG | $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $64bd5b6036bdbf9d$var$WRAP_BIND_FLAG) var result = $b7vOf(func, bitmask, thisArg);
    else if (bitmask == $64bd5b6036bdbf9d$var$WRAP_CURRY_FLAG || bitmask == $64bd5b6036bdbf9d$var$WRAP_CURRY_RIGHT_FLAG) result = $kRl9d(func, bitmask, arity);
    else if ((bitmask == $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG || bitmask == ($64bd5b6036bdbf9d$var$WRAP_BIND_FLAG | $64bd5b6036bdbf9d$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $a84EQ(func, bitmask, thisArg, partials);
    else result = $5zmg4.apply(undefined, newData);
    var setter = data ? $chNEK : $GgyWv;
    return $939hr(setter(result, newData), func, bitmask);
}
module.exports = $64bd5b6036bdbf9d$var$createWrap;

});
parcelRegister("chNEK", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $gBAZQ = parcelRequire("gBAZQ");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8f1d974446c092f9$var$baseSetData = !$gBAZQ ? $4Nq5y : function(func, data) {
    $gBAZQ.set(func, data);
    return func;
};
module.exports = $8f1d974446c092f9$var$baseSetData;

});
parcelRegister("gBAZQ", function(module, exports) {

var $f0N2p = parcelRequire("f0N2p");
/** Used to store function metadata. */ var $031ea876c9117ba4$var$metaMap = $f0N2p && new $f0N2p;
module.exports = $031ea876c9117ba4$var$metaMap;

});
parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, "WeakMap");
module.exports = $aedce50092a1e6a6$var$WeakMap;

});



parcelRegister("b7vOf", function(module, exports) {

var $eJUGC = parcelRequire("eJUGC");

var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $818905d6edb24a46$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $818905d6edb24a46$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $818905d6edb24a46$var$WRAP_BIND_FLAG, Ctor = $eJUGC(func);
    function wrapper() {
        var fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $818905d6edb24a46$var$createBind;

});
parcelRegister("eJUGC", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $abb13d5f92d6242d$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $4XGZt(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $lsJ54(result) ? result : thisBinding;
    };
}
module.exports = $abb13d5f92d6242d$var$createCtor;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});



parcelRegister("kRl9d", function(module, exports) {

var $jpWht = parcelRequire("jpWht");

var $eJUGC = parcelRequire("eJUGC");

var $5zmg4 = parcelRequire("5zmg4");

var $2zF8O = parcelRequire("2zF8O");

var $gouWF = parcelRequire("gouWF");

var $ld4gQ = parcelRequire("ld4gQ");

var $23YZo = parcelRequire("23YZo");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $f2f9295ccbd7047e$var$createCurry(func, bitmask, arity) {
    var Ctor = $eJUGC(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $gouWF(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $ld4gQ(args, placeholder);
        length -= holders.length;
        if (length < arity) return $2zF8O(func, bitmask, $5zmg4, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        return $jpWht(fn, this, args);
    }
    return wrapper;
}
module.exports = $f2f9295ccbd7047e$var$createCurry;

});
parcelRegister("5zmg4", function(module, exports) {

var $dJg2t = parcelRequire("dJg2t");

var $dHJiW = parcelRequire("dHJiW");

var $39b6b = parcelRequire("39b6b");

var $eJUGC = parcelRequire("eJUGC");

var $2zF8O = parcelRequire("2zF8O");

var $gouWF = parcelRequire("gouWF");

var $pbZps = parcelRequire("pbZps");

var $ld4gQ = parcelRequire("ld4gQ");

var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $40e17ca020405bb7$var$WRAP_BIND_FLAG = 1, $40e17ca020405bb7$var$WRAP_BIND_KEY_FLAG = 2, $40e17ca020405bb7$var$WRAP_CURRY_FLAG = 8, $40e17ca020405bb7$var$WRAP_CURRY_RIGHT_FLAG = 16, $40e17ca020405bb7$var$WRAP_ARY_FLAG = 128, $40e17ca020405bb7$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $40e17ca020405bb7$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $40e17ca020405bb7$var$WRAP_ARY_FLAG, isBind = bitmask & $40e17ca020405bb7$var$WRAP_BIND_FLAG, isBindKey = bitmask & $40e17ca020405bb7$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($40e17ca020405bb7$var$WRAP_CURRY_FLAG | $40e17ca020405bb7$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $40e17ca020405bb7$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $eJUGC(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $gouWF(wrapper), holdersCount = $39b6b(args, placeholder);
        if (partials) args = $dJg2t(args, partials, holders, isCurried);
        if (partialsRight) args = $dHJiW(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $ld4gQ(args, placeholder);
            return $2zF8O(func, bitmask, $40e17ca020405bb7$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $pbZps(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $23YZo && this instanceof wrapper) fn = Ctor || $eJUGC(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $40e17ca020405bb7$var$createHybrid;

});
parcelRegister("dJg2t", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9febeb5629b7a37f$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $9febeb5629b7a37f$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $9febeb5629b7a37f$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $9febeb5629b7a37f$var$composeArgs;

});

parcelRegister("dHJiW", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9fa26f0fcdcfef63$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $9fa26f0fcdcfef63$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $9fa26f0fcdcfef63$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $9fa26f0fcdcfef63$var$composeArgsRight;

});

parcelRegister("39b6b", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $24aad2532b3518f1$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $24aad2532b3518f1$var$countHolders;

});

parcelRegister("2zF8O", function(module, exports) {

var $in5KH = parcelRequire("in5KH");

var $GgyWv = parcelRequire("GgyWv");

var $939hr = parcelRequire("939hr");
/** Used to compose bitmasks for function metadata. */ var $1dfec37085ff9232$var$WRAP_BIND_FLAG = 1, $1dfec37085ff9232$var$WRAP_BIND_KEY_FLAG = 2, $1dfec37085ff9232$var$WRAP_CURRY_BOUND_FLAG = 4, $1dfec37085ff9232$var$WRAP_CURRY_FLAG = 8, $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG = 32, $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $1dfec37085ff9232$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $1dfec37085ff9232$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG : $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $1dfec37085ff9232$var$WRAP_PARTIAL_RIGHT_FLAG : $1dfec37085ff9232$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $1dfec37085ff9232$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($1dfec37085ff9232$var$WRAP_BIND_FLAG | $1dfec37085ff9232$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($in5KH(func)) $GgyWv(result, newData);
    result.placeholder = placeholder;
    return $939hr(result, func, bitmask);
}
module.exports = $1dfec37085ff9232$var$createRecurry;

});
parcelRegister("in5KH", function(module, exports) {

var $eisoZ = parcelRequire("eisoZ");

var $cW0XY = parcelRequire("cW0XY");

var $f5V0U = parcelRequire("f5V0U");

var $7IKDO = parcelRequire("7IKDO");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $d5fed6392e1281d7$var$isLaziable(func) {
    var funcName = $f5V0U(func), other = $7IKDO[funcName];
    if (typeof other != "function" || !(funcName in $eisoZ.prototype)) return false;
    if (func === other) return true;
    var data = $cW0XY(other);
    return !!data && func === data[0];
}
module.exports = $d5fed6392e1281d7$var$isLaziable;

});
parcelRegister("eisoZ", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $d1gS2 = parcelRequire("d1gS2");
/** Used as references for the maximum length and index of an array. */ var $a688c734ec374fd4$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $a688c734ec374fd4$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $a688c734ec374fd4$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$a688c734ec374fd4$var$LazyWrapper.prototype = $4XGZt($d1gS2.prototype);
$a688c734ec374fd4$var$LazyWrapper.prototype.constructor = $a688c734ec374fd4$var$LazyWrapper;
module.exports = $a688c734ec374fd4$var$LazyWrapper;

});
parcelRegister("d1gS2", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $97a874876d05d0d4$var$baseLodash() {
// No operation performed.
}
module.exports = $97a874876d05d0d4$var$baseLodash;

});


parcelRegister("cW0XY", function(module, exports) {

var $gBAZQ = parcelRequire("gBAZQ");

var $9iECD = parcelRequire("9iECD");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $96aba6b902e52ad0$var$getData = !$gBAZQ ? $9iECD : function(func) {
    return $gBAZQ.get(func);
};
module.exports = $96aba6b902e52ad0$var$getData;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});


parcelRegister("f5V0U", function(module, exports) {

var $bSu47 = parcelRequire("bSu47");
/** Used for built-in method references. */ var $afd38c5e3d2ed256$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $afd38c5e3d2ed256$var$hasOwnProperty = $afd38c5e3d2ed256$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $afd38c5e3d2ed256$var$getFuncName(func) {
    var result = func.name + "", array = $bSu47[result], length = $afd38c5e3d2ed256$var$hasOwnProperty.call($bSu47, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $afd38c5e3d2ed256$var$getFuncName;

});
parcelRegister("bSu47", function(module, exports) {
/** Used to lookup unminified function names. */ var $8a5c0f3c41d7b4c1$var$realNames = {};
module.exports = $8a5c0f3c41d7b4c1$var$realNames;

});


parcelRegister("7IKDO", function(module, exports) {

var $eisoZ = parcelRequire("eisoZ");

var $7HFP9 = parcelRequire("7HFP9");

var $d1gS2 = parcelRequire("d1gS2");

var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");

var $l457Y = parcelRequire("l457Y");
/** Used for built-in method references. */ var $59f0d26926dc3a0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59f0d26926dc3a0c$var$hasOwnProperty = $59f0d26926dc3a0c$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $59f0d26926dc3a0c$var$lodash(value) {
    if ($8l89S(value) && !$o8HxT(value) && !(value instanceof $eisoZ)) {
        if (value instanceof $7HFP9) return value;
        if ($59f0d26926dc3a0c$var$hasOwnProperty.call(value, "__wrapped__")) return $l457Y(value);
    }
    return new $7HFP9(value);
}
// Ensure wrappers are instances of `baseLodash`.
$59f0d26926dc3a0c$var$lodash.prototype = $d1gS2.prototype;
$59f0d26926dc3a0c$var$lodash.prototype.constructor = $59f0d26926dc3a0c$var$lodash;
module.exports = $59f0d26926dc3a0c$var$lodash;

});
parcelRegister("7HFP9", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $d1gS2 = parcelRequire("d1gS2");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $59bcfdf0c565caf8$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$59bcfdf0c565caf8$var$LodashWrapper.prototype = $4XGZt($d1gS2.prototype);
$59bcfdf0c565caf8$var$LodashWrapper.prototype.constructor = $59bcfdf0c565caf8$var$LodashWrapper;
module.exports = $59bcfdf0c565caf8$var$LodashWrapper;

});

parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});

parcelRegister("l457Y", function(module, exports) {

var $eisoZ = parcelRequire("eisoZ");

var $7HFP9 = parcelRequire("7HFP9");

var $aA0pv = parcelRequire("aA0pv");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $f55df2f31b700310$var$wrapperClone(wrapper) {
    if (wrapper instanceof $eisoZ) return wrapper.clone();
    var result = new $7HFP9(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $aA0pv(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $f55df2f31b700310$var$wrapperClone;

});
parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});




parcelRegister("GgyWv", function(module, exports) {

var $chNEK = parcelRequire("chNEK");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $07f0c55826027de7$var$setData = $7WhTB($chNEK);
module.exports = $07f0c55826027de7$var$setData;

});

parcelRegister("939hr", function(module, exports) {

var $jkzRp = parcelRequire("jkzRp");

var $dIk8u = parcelRequire("dIk8u");

var $iGMVy = parcelRequire("iGMVy");

var $aEjK2 = parcelRequire("aEjK2");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $696b97c20a313755$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + "";
    return $iGMVy(wrapper, $dIk8u(source, $aEjK2($jkzRp(source), bitmask)));
}
module.exports = $696b97c20a313755$var$setWrapToString;

});
parcelRegister("jkzRp", function(module, exports) {
/** Used to match wrap detail comments. */ var $e12bb3bc395fd1b9$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $e12bb3bc395fd1b9$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $e12bb3bc395fd1b9$var$getWrapDetails(source) {
    var match = source.match($e12bb3bc395fd1b9$var$reWrapDetails);
    return match ? match[1].split($e12bb3bc395fd1b9$var$reSplitDetails) : [];
}
module.exports = $e12bb3bc395fd1b9$var$getWrapDetails;

});

parcelRegister("dIk8u", function(module, exports) {
/** Used to match wrap detail comments. */ var $9fbf010585c1ecd7$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $9fbf010585c1ecd7$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
    details = details.join(length > 2 ? ", " : " ");
    return source.replace($9fbf010585c1ecd7$var$reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
}
module.exports = $9fbf010585c1ecd7$var$insertWrapDetails;

});

parcelRegister("aEjK2", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $ebE2M = parcelRequire("ebE2M");
/** Used to compose bitmasks for function metadata. */ var $7c0cf40da5f8aa6c$var$WRAP_BIND_FLAG = 1, $7c0cf40da5f8aa6c$var$WRAP_BIND_KEY_FLAG = 2, $7c0cf40da5f8aa6c$var$WRAP_CURRY_FLAG = 8, $7c0cf40da5f8aa6c$var$WRAP_CURRY_RIGHT_FLAG = 16, $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_FLAG = 32, $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $7c0cf40da5f8aa6c$var$WRAP_ARY_FLAG = 128, $7c0cf40da5f8aa6c$var$WRAP_REARG_FLAG = 256, $7c0cf40da5f8aa6c$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $7c0cf40da5f8aa6c$var$wrapFlags = [
    [
        "ary",
        $7c0cf40da5f8aa6c$var$WRAP_ARY_FLAG
    ],
    [
        "bind",
        $7c0cf40da5f8aa6c$var$WRAP_BIND_FLAG
    ],
    [
        "bindKey",
        $7c0cf40da5f8aa6c$var$WRAP_BIND_KEY_FLAG
    ],
    [
        "curry",
        $7c0cf40da5f8aa6c$var$WRAP_CURRY_FLAG
    ],
    [
        "curryRight",
        $7c0cf40da5f8aa6c$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        "flip",
        $7c0cf40da5f8aa6c$var$WRAP_FLIP_FLAG
    ],
    [
        "partial",
        $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_FLAG
    ],
    [
        "partialRight",
        $7c0cf40da5f8aa6c$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        "rearg",
        $7c0cf40da5f8aa6c$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $7c0cf40da5f8aa6c$var$updateWrapDetails(details, bitmask) {
    $bFZGr($7c0cf40da5f8aa6c$var$wrapFlags, function(pair) {
        var value = "_." + pair[0];
        if (bitmask & pair[1] && !$ebE2M(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $7c0cf40da5f8aa6c$var$updateWrapDetails;

});
parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});






parcelRegister("gouWF", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $bef6e44f852309be$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $bef6e44f852309be$var$getHolder;

});

parcelRegister("pbZps", function(module, exports) {

var $aA0pv = parcelRequire("aA0pv");

var $iyUuu = parcelRequire("iyUuu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $04bba2c64082f641$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $04bba2c64082f641$var$reorder(array, indexes) {
    var arrLength = array.length, length = $04bba2c64082f641$var$nativeMin(indexes.length, arrLength), oldArray = $aA0pv(array);
    while(length--){
        var index = indexes[length];
        array[length] = $iyUuu(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $04bba2c64082f641$var$reorder;

});
parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});


parcelRegister("ld4gQ", function(module, exports) {
/** Used as the internal argument placeholder. */ var $f70e1ff2ede69093$var$PLACEHOLDER = "__lodash_placeholder__";
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $f70e1ff2ede69093$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $f70e1ff2ede69093$var$PLACEHOLDER) {
            array[index] = $f70e1ff2ede69093$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $f70e1ff2ede69093$var$replaceHolders;

});



parcelRegister("a84EQ", function(module, exports) {

var $jpWht = parcelRequire("jpWht");

var $eJUGC = parcelRequire("eJUGC");

var $23YZo = parcelRequire("23YZo");
/** Used to compose bitmasks for function metadata. */ var $75fe43ab8fadbeb8$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $75fe43ab8fadbeb8$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $75fe43ab8fadbeb8$var$WRAP_BIND_FLAG, Ctor = $eJUGC(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $23YZo && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $jpWht(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $75fe43ab8fadbeb8$var$createPartial;

});

parcelRegister("lMyBN", function(module, exports) {

var $dJg2t = parcelRequire("dJg2t");

var $dHJiW = parcelRequire("dHJiW");

var $ld4gQ = parcelRequire("ld4gQ");
/** Used as the internal argument placeholder. */ var $fdb8ed38e46ba210$var$PLACEHOLDER = "__lodash_placeholder__";
/** Used to compose bitmasks for function metadata. */ var $fdb8ed38e46ba210$var$WRAP_BIND_FLAG = 1, $fdb8ed38e46ba210$var$WRAP_BIND_KEY_FLAG = 2, $fdb8ed38e46ba210$var$WRAP_CURRY_BOUND_FLAG = 4, $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG = 8, $fdb8ed38e46ba210$var$WRAP_ARY_FLAG = 128, $fdb8ed38e46ba210$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $fdb8ed38e46ba210$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $fdb8ed38e46ba210$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($fdb8ed38e46ba210$var$WRAP_BIND_FLAG | $fdb8ed38e46ba210$var$WRAP_BIND_KEY_FLAG | $fdb8ed38e46ba210$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $fdb8ed38e46ba210$var$WRAP_ARY_FLAG && bitmask == $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG || srcBitmask == $fdb8ed38e46ba210$var$WRAP_ARY_FLAG && bitmask == $fdb8ed38e46ba210$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($fdb8ed38e46ba210$var$WRAP_ARY_FLAG | $fdb8ed38e46ba210$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $fdb8ed38e46ba210$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $fdb8ed38e46ba210$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $fdb8ed38e46ba210$var$WRAP_BIND_FLAG ? 0 : $fdb8ed38e46ba210$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $dJg2t(partials, value, source[4]) : value;
        data[4] = partials ? $ld4gQ(data[3], $fdb8ed38e46ba210$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $dHJiW(partials, value, source[6]) : value;
        data[6] = partials ? $ld4gQ(data[5], $fdb8ed38e46ba210$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $fdb8ed38e46ba210$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $fdb8ed38e46ba210$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $fdb8ed38e46ba210$var$mergeData;

});

parcelRegister("2MGGR", function(module, exports) {

var $9lLgO = parcelRequire("9lLgO");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $9lLgO(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $20712de2064d78dd$var$toInteger;

});
parcelRegister("9lLgO", function(module, exports) {

var $iV4PZ = parcelRequire("iV4PZ");
/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $iV4PZ(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $6ceabe126a95a54e$var$toFinite;

});
parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $lsJ54(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, "") : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});


parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});






parcelRegister("5W3lT", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $i1jm6(function(object, source, srcIndex) {
    $4uZ7x(object, source, srcIndex);
});
module.exports = $4524f833ae45779b$var$merge;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, "Map");
module.exports = $19b02faa57603249$var$Map;

});

parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype["delete"] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $c8dKl,
        "map": new ($2cJKd || $iYOpJ),
        "string": new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, "create");
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4hwTc) $4hwTc(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});


parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});


parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});



parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});


parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});


parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});
parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});



parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});

parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});


parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});
parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});


parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});


parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});






parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});
parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == "number" ? $eMthh(object) && $iyUuu(index, object.length) : type == "string" && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});




parcelRegister("jIqqR", function(module, exports) {
/*!
 * util/index.js - Utilities Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $e5a6a1464a5a30d8$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");
var $e5a6a1464a5a30d8$var$util;
function $e5a6a1464a5a30d8$var$asBuffer(input, encoding) {
    if ($e5a6a1464a5a30d8$require$Buffer.isBuffer(input)) return input;
    if ("string" === typeof input) {
        encoding = encoding || "binary";
        if ("base64url" === encoding) return $e5a6a1464a5a30d8$var$util.base64url.decode(input);
        return $e5a6a1464a5a30d8$require$Buffer.from(input, encoding);
    }
    // assume input is an Array, ArrayBuffer, or ArrayBufferView
    if ($as9F1.util.isArrayBufferView(input)) input = input instanceof Uint8Array ? input : new Uint8Array(input.buffer, input.byteOffset, input.byteOffset + input.byteLength);
    else if ($as9F1.util.isArrayBuffer(input)) input = new Uint8Array(input);
    var output;
    output = $e5a6a1464a5a30d8$require$Buffer.from(input);
    return output;
}
function $e5a6a1464a5a30d8$var$randomBytes(len) {
    return $e5a6a1464a5a30d8$require$Buffer.from($as9F1.random.getBytes(len), "binary");
}


$e5a6a1464a5a30d8$var$util = {
    base64url: (parcelRequire("gS7wL")),
    utf8: (parcelRequire("916AZ")),
    asBuffer: $e5a6a1464a5a30d8$var$asBuffer,
    randomBytes: $e5a6a1464a5a30d8$var$randomBytes
};
module.exports = $e5a6a1464a5a30d8$var$util;

});
parcelRegister("as9F1", function(module, exports) {
/*!
 * deps/forge.js - Forge Package Customization
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";

var $dEd5p = parcelRequire("dEd5p");
parcelRequire("7vq5X");
parcelRequire("8QTFz");
parcelRequire("c5Ms4");
parcelRequire("aMLbo");
parcelRequire("8yafv");
parcelRequire("9Lx2j");
parcelRequire("fYcEB");
parcelRequire("gDTs5");
parcelRequire("8p5fL");
parcelRequire("lAXzO");
parcelRequire("1VPPt");
parcelRequire("eZJY9");
parcelRequire("54e3h");
parcelRequire("4N8iP");
parcelRequire("dggUt");
parcelRequire("guEzu");
parcelRequire("fC5f3");
parcelRequire("kvSv3");
// Define AES "raw" cipher mode
function $79c40351416187eb$var$modeRaw(options) {
    options = options || {};
    this.name = "";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._blocks = this.blockSize / 4;
    this._inBlock = new Array(this._blocks);
    this._outBlock = new Array(this._blocks);
}
$79c40351416187eb$var$modeRaw.prototype.start = function() {};
$79c40351416187eb$var$modeRaw.prototype.encrypt = function(input, output, finish) {
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    var i;
    // get next block
    for(i = 0; i < this._blocks; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(i = 0; i < this._blocks; ++i)output.putInt32(this._outBlock[i]);
};
$79c40351416187eb$var$modeRaw.prototype.decrypt = function(input, output, finish) {
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    var i;
    // get next block
    for(i = 0; i < this._blocks; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(i = 0; i < this._blocks; ++i)output.putInt32(this._outBlock[i]);
};
(function() {
    var name = "AES", mode = $79c40351416187eb$var$modeRaw, factory;
    factory = function() {
        return new $dEd5p.aes.Algorithm(name, mode);
    };
    $dEd5p.cipher.registerAlgorithm(name, factory);
})();
// Ensure that the jsbn modInverse function always returns a positive result
const $79c40351416187eb$var$originalModInverse = $dEd5p.jsbn.BigInteger.prototype.modInverse;
const $79c40351416187eb$var$positiveModInverse = function(m) {
    const inv = $79c40351416187eb$var$originalModInverse.apply(this, [
        m
    ]);
    return inv.mod(m);
};
$dEd5p.jsbn.BigInteger.prototype.modInverse = $79c40351416187eb$var$positiveModInverse;
module.exports = $dEd5p;

});
parcelRegister("dEd5p", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ module.exports = {
    // default options
    options: {
        usePureJavaScript: false
    }
};

});

parcelRegister("7vq5X", function(module, exports) {
/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("c5Ms4");
parcelRequire("g1HTO");
parcelRequire("kvSv3");
/* AES API */ module.exports = $dEd5p.aes = $dEd5p.aes || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.aes.startEncrypting = function(key, iv, output, mode) {
    var cipher = $576fab9e1599f140$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.aes.createEncryptionCipher = function(key, mode) {
    return $576fab9e1599f140$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.aes.startDecrypting = function(key, iv, output, mode) {
    var cipher = $576fab9e1599f140$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.aes.createDecryptionCipher = function(key, mode) {
    return $576fab9e1599f140$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */ $dEd5p.aes.Algorithm = function(name, mode) {
    if (!$576fab9e1599f140$var$init) $576fab9e1599f140$var$initialize();
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 16,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $576fab9e1599f140$var$_updateBlock(self._w, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $576fab9e1599f140$var$_updateBlock(self._w, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $dEd5p.aes.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */ if (typeof key === "string" && (key.length === 16 || key.length === 24 || key.length === 32)) // convert key string into byte buffer
    key = $dEd5p.util.createBuffer(key);
    else if ($dEd5p.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
        // convert key integer array into byte buffer
        tmp = key;
        key = $dEd5p.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
    }
    // convert key byte buffer into 32-bit integer array
    if (!$dEd5p.util.isArray(key)) {
        tmp = key;
        key = [];
        // key lengths of 16, 24, 32 bytes allowed
        var len = tmp.length();
        if (len === 16 || len === 24 || len === 32) {
            len = len >>> 2;
            for(var i = 0; i < len; ++i)key.push(tmp.getInt32());
        }
    }
    // key must be an array of 32-bit integers by now
    if (!$dEd5p.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) throw new Error("Invalid key parameter.");
    // encryption operation is always used for these modes
    var mode = this.mode.name;
    var encryptOp = [
        "CFB",
        "OFB",
        "CTR",
        "GCM"
    ].indexOf(mode) !== -1;
    // do key expansion
    this._w = $576fab9e1599f140$var$_expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
};
/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */ $dEd5p.aes._expandKey = function(key, decrypt) {
    if (!$576fab9e1599f140$var$init) $576fab9e1599f140$var$initialize();
    return $576fab9e1599f140$var$_expandKey(key, decrypt);
};
/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */ $dEd5p.aes._updateBlock = $576fab9e1599f140$var$_updateBlock;
/** Register AES algorithms **/ $576fab9e1599f140$var$registerAlgorithm("AES-ECB", $dEd5p.cipher.modes.ecb);
$576fab9e1599f140$var$registerAlgorithm("AES-CBC", $dEd5p.cipher.modes.cbc);
$576fab9e1599f140$var$registerAlgorithm("AES-CFB", $dEd5p.cipher.modes.cfb);
$576fab9e1599f140$var$registerAlgorithm("AES-OFB", $dEd5p.cipher.modes.ofb);
$576fab9e1599f140$var$registerAlgorithm("AES-CTR", $dEd5p.cipher.modes.ctr);
$576fab9e1599f140$var$registerAlgorithm("AES-GCM", $dEd5p.cipher.modes.gcm);
function $576fab9e1599f140$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $dEd5p.aes.Algorithm(name, mode);
    };
    $dEd5p.cipher.registerAlgorithm(name, factory);
}
/** AES implementation **/ var $576fab9e1599f140$var$init = false; // not yet initialized
var $576fab9e1599f140$var$Nb = 4; // number of words comprising the state (AES = 4)
var $576fab9e1599f140$var$sbox; // non-linear substitution table used in key expansion
var $576fab9e1599f140$var$isbox; // inversion of sbox
var $576fab9e1599f140$var$rcon; // round constant word array
var $576fab9e1599f140$var$mix; // mix-columns table
var $576fab9e1599f140$var$imix; // inverse mix-columns table
/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebriac expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */ function $576fab9e1599f140$var$initialize() {
    $576fab9e1599f140$var$init = true;
    /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */ $576fab9e1599f140$var$rcon = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1B,
        0x36
    ];
    // compute xtime table which maps i onto GF(i, 0x02)
    var xtime = new Array(256);
    for(var i = 0; i < 128; ++i){
        xtime[i] = i << 1;
        xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    }
    // compute all other tables
    $576fab9e1599f140$var$sbox = new Array(256);
    $576fab9e1599f140$var$isbox = new Array(256);
    $576fab9e1599f140$var$mix = new Array(4);
    $576fab9e1599f140$var$imix = new Array(4);
    for(var i = 0; i < 4; ++i){
        $576fab9e1599f140$var$mix[i] = new Array(256);
        $576fab9e1599f140$var$imix[i] = new Array(256);
    }
    var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
    for(var i = 0; i < 256; ++i){
        /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */ // apply affine transformation
        sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
        sx = sx >> 8 ^ sx & 255 ^ 0x63;
        // update tables
        $576fab9e1599f140$var$sbox[e] = sx;
        $576fab9e1599f140$var$isbox[sx] = e;
        /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */ // calculate mix and imix table values
        sx2 = xtime[sx];
        e2 = xtime[e];
        e4 = xtime[e2];
        e8 = xtime[e4];
        me = sx2 << 24 ^ // 2
        sx << 16 ^ // 1
        sx << 8 ^ // 1
        (sx ^ sx2); // 3
        ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
        (e ^ e8) << 16 ^ // 9
        (e ^ e4 ^ e8) << 8 ^ // D (13)
        (e ^ e2 ^ e8); // B (11)
        // produce each of the mix tables by rotating the 2,1,1,3 value
        for(var n = 0; n < 4; ++n){
            $576fab9e1599f140$var$mix[n][e] = me;
            $576fab9e1599f140$var$imix[n][sx] = ime;
            // cycle the right most byte to the left most position
            // ie: 2,1,1,3 becomes 3,2,1,1
            me = me << 24 | me >>> 8;
            ime = ime << 24 | ime >>> 8;
        }
        // get next element and inverse
        if (e === 0) // 1 is the inverse of 1
        e = ei = 1;
        else {
            // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
            // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
            e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
            ei ^= xtime[xtime[ei]];
        }
    }
}
/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 <= i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */ function $576fab9e1599f140$var$_expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */ // go through the rounds expanding the key
    var temp, iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = $576fab9e1599f140$var$Nb * Nr1;
    for(var i = Nk; i < end; ++i){
        temp = w[i - 1];
        if (i % Nk === 0) {
            // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
            temp = $576fab9e1599f140$var$sbox[temp >>> 16 & 255] << 24 ^ $576fab9e1599f140$var$sbox[temp >>> 8 & 255] << 16 ^ $576fab9e1599f140$var$sbox[temp & 255] << 8 ^ $576fab9e1599f140$var$sbox[temp >>> 24] ^ $576fab9e1599f140$var$rcon[iNk] << 24;
            iNk++;
        } else if (Nk > 6 && i % Nk === 4) // temp = SubWord(temp)
        temp = $576fab9e1599f140$var$sbox[temp >>> 24] << 24 ^ $576fab9e1599f140$var$sbox[temp >>> 16 & 255] << 16 ^ $576fab9e1599f140$var$sbox[temp >>> 8 & 255] << 8 ^ $576fab9e1599f140$var$sbox[temp & 255];
        w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */ if (decrypt) {
        var tmp;
        var m0 = $576fab9e1599f140$var$imix[0];
        var m1 = $576fab9e1599f140$var$imix[1];
        var m2 = $576fab9e1599f140$var$imix[2];
        var m3 = $576fab9e1599f140$var$imix[3];
        var wnew = w.slice(0);
        end = w.length;
        for(var i = 0, wi = end - $576fab9e1599f140$var$Nb; i < end; i += $576fab9e1599f140$var$Nb, wi -= $576fab9e1599f140$var$Nb){
            // do not sub the first or last round key (round keys are Nb
            // words) as no column mixing is performed before they are added,
            // but do change the key order
            if (i === 0 || i === end - $576fab9e1599f140$var$Nb) {
                wnew[i] = w[wi];
                wnew[i + 1] = w[wi + 3];
                wnew[i + 2] = w[wi + 2];
                wnew[i + 3] = w[wi + 1];
            } else // substitute each round key byte because the inverse-mix
            // table will inverse-substitute it (effectively cancel the
            // substitution because round key bytes aren't sub'd in
            // decryption mode) and swap indexes 3 and 1
            for(var n = 0; n < $576fab9e1599f140$var$Nb; ++n){
                tmp = w[wi + n];
                wnew[i + (3 & -n)] = m0[$576fab9e1599f140$var$sbox[tmp >>> 24]] ^ m1[$576fab9e1599f140$var$sbox[tmp >>> 16 & 255]] ^ m2[$576fab9e1599f140$var$sbox[tmp >>> 8 & 255]] ^ m3[$576fab9e1599f140$var$sbox[tmp & 255]];
            }
        }
        w = wnew;
    }
    return w;
}
/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $576fab9e1599f140$var$_updateBlock(w, input, output, decrypt) {
    /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr-1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */ // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;
    if (decrypt) {
        m0 = $576fab9e1599f140$var$imix[0];
        m1 = $576fab9e1599f140$var$imix[1];
        m2 = $576fab9e1599f140$var$imix[2];
        m3 = $576fab9e1599f140$var$imix[3];
        sub = $576fab9e1599f140$var$isbox;
    } else {
        m0 = $576fab9e1599f140$var$mix[0];
        m1 = $576fab9e1599f140$var$mix[1];
        m2 = $576fab9e1599f140$var$mix[2];
        m3 = $576fab9e1599f140$var$mix[3];
        sub = $576fab9e1599f140$var$sbox;
    }
    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */ for(var round = 1; round < Nr; ++round){
        /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */ a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
        b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
        c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
        d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
        a = a2;
        b = b2;
        c = c2;
    }
    /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */ // Note: rows are shifted inline
    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $576fab9e1599f140$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "AES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $dEd5p.cipher.createDecipher(algorithm, options.key);
    else cipher = $dEd5p.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $dEd5p.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});
parcelRegister("c5Ms4", function(module, exports) {
/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
module.exports = $dEd5p.cipher = $dEd5p.cipher || {};
// registered algorithms
$dEd5p.cipher.algorithms = $dEd5p.cipher.algorithms || {};
/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $dEd5p.cipher.createCipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $dEd5p.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $dEd5p.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: false
    });
};
/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $dEd5p.cipher.createDecipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $dEd5p.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $dEd5p.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: true
    });
};
/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */ $dEd5p.cipher.registerAlgorithm = function(name, algorithm) {
    name = name.toUpperCase();
    $dEd5p.cipher.algorithms[name] = algorithm;
};
/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */ $dEd5p.cipher.getAlgorithm = function(name) {
    name = name.toUpperCase();
    if (name in $dEd5p.cipher.algorithms) return $dEd5p.cipher.algorithms[name];
    return null;
};
var $8cdb892763e76f53$var$BlockCipher = $dEd5p.cipher.BlockCipher = function(options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
};
/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */ $8cdb892763e76f53$var$BlockCipher.prototype.start = function(options) {
    options = options || {};
    var opts = {};
    for(var key in options)opts[key] = options[key];
    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = $dEd5p.util.createBuffer();
    this.output = options.output || $dEd5p.util.createBuffer();
    this.mode.start(opts);
};
/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */ $8cdb892763e76f53$var$BlockCipher.prototype.update = function(input) {
    if (input) // input given, so empty it into the input buffer
    this._input.putBuffer(input);
    // do cipher operation until it needs more input and not finished
    while(!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish);
    // free consumed memory from input buffer
    this._input.compact();
};
/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */ $8cdb892763e76f53$var$BlockCipher.prototype.finish = function(pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === "ECB" || this.mode.name === "CBC")) {
        this.mode.pad = function(input) {
            return pad(this.blockSize, input, false);
        };
        this.mode.unpad = function(output) {
            return pad(this.blockSize, output, true);
        };
    }
    // build options for padding and afterFinish functions
    var options = {};
    options.decrypt = this._decrypt;
    // get # of bytes that won't fill a block
    options.overflow = this._input.length() % this.blockSize;
    if (!this._decrypt && this.mode.pad) {
        if (!this.mode.pad(this._input, options)) return false;
    }
    // do final update
    this._finish = true;
    this.update();
    if (this._decrypt && this.mode.unpad) {
        if (!this.mode.unpad(this.output, options)) return false;
    }
    if (this.mode.afterFinish) {
        if (!this.mode.afterFinish(this.output, options)) return false;
    }
    return true;
};

});
parcelRegister("kvSv3", function(module, exports) {
/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2018 Digital Bazaar, Inc.
 */ 
var $kjyEk = parcelRequire("kjyEk");

var $kjyEk = parcelRequire("kjyEk");
var $eef0fa7557056871$require$Buffer = $kjyEk.Buffer;

var $dEd5p = parcelRequire("dEd5p");

var $bqBKL = parcelRequire("bqBKL");
/* Utilities API */ var $eef0fa7557056871$var$util = module.exports = $dEd5p.util = $dEd5p.util || {};
// define setImmediate and nextTick
(function() {
    // use native nextTick (unless we're in webpack)
    // webpack (or better node-libs-browser polyfill) sets process.browser.
    // this way we can detect webpack properly
    typeof $kjyEk !== "undefined" && $kjyEk.nextTick;
    // polyfill nextTick with native setImmediate
    if (typeof setImmediate === "function") {
        $eef0fa7557056871$var$util.setImmediate = function() {
            return setImmediate.apply(undefined, arguments);
        };
        $eef0fa7557056871$var$util.nextTick = function(callback) {
            return setImmediate(callback);
        };
        return;
    }
    /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */ // polyfill with setTimeout
    $eef0fa7557056871$var$util.setImmediate = function(callback) {
        setTimeout(callback, 0);
    };
    // upgrade polyfill to use postMessage
    if (typeof window !== "undefined" && typeof window.postMessage === "function") {
        var msg = "forge.setImmediate";
        var callbacks = [];
        $eef0fa7557056871$var$util.setImmediate = function(callback) {
            callbacks.push(callback);
            // only send message when one hasn't been sent in
            // the current turn of the event loop
            if (callbacks.length === 1) window.postMessage(msg, "*");
        };
        function handler(event) {
            if (event.source === window && event.data === msg) {
                event.stopPropagation();
                var copy = callbacks.slice();
                callbacks.length = 0;
                copy.forEach(function(callback) {
                    callback();
                });
            }
        }
        window.addEventListener("message", handler, true);
    }
    // upgrade polyfill to use MutationObserver
    if (typeof MutationObserver !== "undefined") {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement("div");
        var callbacks = [];
        new MutationObserver(function() {
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function(callback) {
                callback();
            });
        }).observe(div, {
            attributes: true
        });
        var oldSetImmediate = $eef0fa7557056871$var$util.setImmediate;
        $eef0fa7557056871$var$util.setImmediate = function(callback) {
            if (Date.now() - now > 15) {
                now = Date.now();
                oldSetImmediate(callback);
            } else {
                callbacks.push(callback);
                // only trigger observer when it hasn't been triggered in
                // the current turn of the event loop
                if (callbacks.length === 1) div.setAttribute("a", attr = !attr);
            }
        };
    }
    $eef0fa7557056871$var$util.nextTick = $eef0fa7557056871$var$util.setImmediate;
})();
// check if running under Node.js
$eef0fa7557056871$var$util.isNodejs = typeof $kjyEk !== "undefined" && $kjyEk.versions && $kjyEk.versions.node;
// 'self' will also work in Web Workers (instance of WorkerGlobalScope) while
// it will point to `window` in the main thread.
// To remain compatible with older browsers, we fall back to 'window' if 'self'
// is not available.
$eef0fa7557056871$var$util.globalScope = function() {
    if ($eef0fa7557056871$var$util.isNodejs) return $parcel$global;
    return typeof self === "undefined" ? window : self;
}();
// define isArray
$eef0fa7557056871$var$util.isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
// define isArrayBuffer
$eef0fa7557056871$var$util.isArrayBuffer = function(x) {
    return typeof ArrayBuffer !== "undefined" && x instanceof ArrayBuffer;
};
// define isArrayBufferView
$eef0fa7557056871$var$util.isArrayBufferView = function(x) {
    return x && $eef0fa7557056871$var$util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};
/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */ function $eef0fa7557056871$var$_checkBitsParam(n) {
    if (!(n === 8 || n === 16 || n === 24 || n === 32)) throw new Error("Only 8, 16, 24, or 32 bits supported: " + n);
}
// TODO: set ByteBuffer to best available backing
$eef0fa7557056871$var$util.ByteBuffer = $eef0fa7557056871$var$ByteStringBuffer;
/** Buffer w/BinaryString backing */ /**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */ function $eef0fa7557056871$var$ByteStringBuffer(b) {
    // TODO: update to match DataBuffer API
    // the data in this buffer
    this.data = "";
    // the pointer for reading from this buffer
    this.read = 0;
    if (typeof b === "string") this.data = b;
    else if ($eef0fa7557056871$var$util.isArrayBuffer(b) || $eef0fa7557056871$var$util.isArrayBufferView(b)) {
        if (typeof $eef0fa7557056871$require$Buffer !== "undefined" && b instanceof $eef0fa7557056871$require$Buffer) this.data = b.toString("binary");
        else {
            // convert native buffer to forge buffer
            // FIXME: support native buffers internally instead
            var arr = new Uint8Array(b);
            try {
                this.data = String.fromCharCode.apply(null, arr);
            } catch (e) {
                for(var i = 0; i < arr.length; ++i)this.putByte(arr[i]);
            }
        }
    } else if (b instanceof $eef0fa7557056871$var$ByteStringBuffer || typeof b === "object" && typeof b.data === "string" && typeof b.read === "number") {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
    }
    // used for v8 optimization
    this._constructedStringLength = 0;
}
$eef0fa7557056871$var$util.ByteStringBuffer = $eef0fa7557056871$var$ByteStringBuffer;
/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */ var $eef0fa7557056871$var$_MAX_CONSTRUCTED_STRING_LENGTH = 4096;
$eef0fa7557056871$var$util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
    this._constructedStringLength += x;
    if (this._constructedStringLength > $eef0fa7557056871$var$_MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
    }
};
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.length = function() {
    return this.data.length - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putByte = function(b) {
    return this.putBytes(String.fromCharCode(b));
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
    b = String.fromCharCode(b);
    var d = this.data;
    while(n > 0){
        if (n & 1) d += b;
        n >>>= 1;
        if (n > 0) b += b;
    }
    this.data = d;
    this._optimizeConstructedString(n);
    return this;
};
/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a binary encoded string) to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putBytes = function(bytes) {
    this.data += bytes;
    this._optimizeConstructedString(bytes.length);
    return this;
};
/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putString = function(str) {
    return this.putBytes($eef0fa7557056871$var$util.encodeUtf8(str));
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt16 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt24 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt32 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt16Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt24Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt32Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putInt = function(i, n) {
    $eef0fa7557056871$var$_checkBitsParam(n);
    var bytes = "";
    do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
    }while (n > 0);
    return this.putBytes(bytes);
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
    // putInt checks n
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
    return this.putBytes(buffer.getBytes());
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getByte = function() {
    return this.data.charCodeAt(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt16 = function() {
    var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt24 = function() {
    var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt32 = function() {
    var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt16Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt24Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt32Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getInt = function(n) {
    $eef0fa7557056871$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer. Note that the resulting string is binary encoded (in node.js this
 * encoding is referred to as `binary`, it is *not* `utf8`).
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.getBytes = function(count) {
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.bytes = function(count) {
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.at = function(i) {
    return this.data.charCodeAt(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.setAt = function(i, b) {
    this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.last = function() {
    return this.data.charCodeAt(this.data.length - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.copy = function() {
    var c = $eef0fa7557056871$var$util.createBuffer(this.data);
    c.read = this.read;
    return c;
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.compact = function() {
    if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.clear = function() {
    this.data = "";
    this.read = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.truncate = function(count) {
    var len = Math.max(0, this.length() - count);
    this.data = this.data.substr(this.read, len);
    this.read = 0;
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.length; ++i){
        var b = this.data.charCodeAt(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */ $eef0fa7557056871$var$util.ByteStringBuffer.prototype.toString = function() {
    return $eef0fa7557056871$var$util.decodeUtf8(this.bytes());
};
/** End Buffer w/BinaryString backing */ /** Buffer w/UInt8Array backing */ /**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */ function $eef0fa7557056871$var$DataBuffer(b, options) {
    // default options
    options = options || {};
    // pointers for read from/write to buffer
    this.read = options.readOffset || 0;
    this.growSize = options.growSize || 1024;
    var isArrayBuffer = $eef0fa7557056871$var$util.isArrayBuffer(b);
    var isArrayBufferView = $eef0fa7557056871$var$util.isArrayBufferView(b);
    if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) this.data = new DataView(b);
        else // TODO: adjust read/write offset based on the type of view
        // or specify that this must be done in the options ... that the
        // offsets are byte-based
        this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        this.write = "writeOffset" in options ? options.writeOffset : this.data.byteLength;
        return;
    }
    // initialize to empty array buffer and add any given bytes using putBytes
    this.data = new DataView(new ArrayBuffer(0));
    this.write = 0;
    if (b !== null && b !== undefined) this.putBytes(b);
    if ("writeOffset" in options) this.write = options.writeOffset;
}
$eef0fa7557056871$var$util.DataBuffer = $eef0fa7557056871$var$DataBuffer;
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.accommodate = function(amount, growSize) {
    if (this.length() >= amount) return this;
    growSize = Math.max(growSize || this.growSize, amount);
    // grow buffer
    var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
    var dst = new Uint8Array(this.length() + growSize);
    dst.set(src);
    this.data = new DataView(dst.buffer);
    return this;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data.setUint8(this.write++, b);
    return this;
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.fillWithByte = function(b, n) {
    this.accommodate(n);
    for(var i = 0; i < n; ++i)this.data.setUint8(b);
    return this;
};
/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ($eef0fa7557056871$var$util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
    }
    if ($eef0fa7557056871$var$util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
    }
    // bytes is a util.DataBuffer or equivalent
    if (bytes instanceof $eef0fa7557056871$var$util.DataBuffer || typeof bytes === "object" && typeof bytes.read === "number" && typeof bytes.write === "number" && $eef0fa7557056871$var$util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
    }
    if (bytes instanceof $eef0fa7557056871$var$util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = "binary";
    }
    // string conversion
    encoding = encoding || "binary";
    if (typeof bytes === "string") {
        var view;
        // decode from string
        if (encoding === "hex") {
            this.accommodate(Math.ceil(bytes.length / 2));
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $eef0fa7557056871$var$util.binary.hex.decode(bytes, view, this.write);
            return this;
        }
        if (encoding === "base64") {
            this.accommodate(Math.ceil(bytes.length / 4) * 3);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $eef0fa7557056871$var$util.binary.base64.decode(bytes, view, this.write);
            return this;
        }
        // encode text as UTF-8 bytes
        if (encoding === "utf8") {
            // encode as UTF-8 then decode string as raw binary
            bytes = $eef0fa7557056871$var$util.encodeUtf8(bytes);
            encoding = "binary";
        }
        // decode string as raw binary
        if (encoding === "binary" || encoding === "raw") {
            // one byte per character
            this.accommodate(bytes.length);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $eef0fa7557056871$var$util.binary.raw.decode(view);
            return this;
        }
        // encode text as UTF-16 bytes
        if (encoding === "utf16") {
            // two bytes per character
            this.accommodate(bytes.length * 2);
            view = new Uint16Array(this.data.buffer, this.write);
            this.write += $eef0fa7557056871$var$util.text.utf16.encode(view);
            return this;
        }
        throw new Error("Invalid encoding: " + encoding);
    }
    throw Error("Invalid parameter: " + bytes);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putBuffer = function(buffer) {
    this.putBytes(buffer);
    buffer.clear();
    return this;
};
/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, "utf16");
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt16 = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt24 = function(i) {
    this.accommodate(3);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt32 = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i);
    this.write += 4;
    return this;
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt16Le = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i, true);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt24Le = function(i) {
    this.accommodate(3);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt32Le = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i, true);
    this.write += 4;
    return this;
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putInt = function(i, n) {
    $eef0fa7557056871$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
    }while (n > 0);
    return this;
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.putSignedInt = function(i, n) {
    $eef0fa7557056871$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getByte = function() {
    return this.data.getInt8(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt16 = function() {
    var rval = this.data.getInt16(this.read);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt24 = function() {
    var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt32 = function() {
    var rval = this.data.getInt32(this.read);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt16Le = function() {
    var rval = this.data.getInt16(this.read, true);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt24Le = function() {
    var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt32Le = function() {
    var rval = this.data.getInt32(this.read, true);
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getInt = function(n) {
    $eef0fa7557056871$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.getBytes = function(count) {
    // TODO: deprecate this method, it is poorly named and
    // this.toString('binary') replaces it
    // add a toTypedArray()/toArrayBuffer() function
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.bytes = function(count) {
    // TODO: deprecate this method, it is poorly named, add "getString()"
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.at = function(i) {
    return this.data.getUint8(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.setAt = function(i, b) {
    this.data.setUint8(i, b);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.last = function() {
    return this.data.getUint8(this.write - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.copy = function() {
    return new $eef0fa7557056871$var$util.DataBuffer(this);
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.clear = function() {
    this.data = new DataView(new ArrayBuffer(0));
    this.read = this.write = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.truncate = function(count) {
    this.write = Math.max(0, this.length() - count);
    this.read = Math.min(this.read, this.write);
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.byteLength; ++i){
        var b = this.data.getUint8(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */ $eef0fa7557056871$var$util.DataBuffer.prototype.toString = function(encoding) {
    var view = new Uint8Array(this.data, this.read, this.length());
    encoding = encoding || "utf8";
    // encode to string
    if (encoding === "binary" || encoding === "raw") return $eef0fa7557056871$var$util.binary.raw.encode(view);
    if (encoding === "hex") return $eef0fa7557056871$var$util.binary.hex.encode(view);
    if (encoding === "base64") return $eef0fa7557056871$var$util.binary.base64.encode(view);
    // decode to text
    if (encoding === "utf8") return $eef0fa7557056871$var$util.text.utf8.decode(view);
    if (encoding === "utf16") return $eef0fa7557056871$var$util.text.utf16.decode(view);
    throw new Error("Invalid encoding: " + encoding);
};
/** End Buffer w/UInt8Array backing */ /**
 * Creates a buffer that stores bytes. A value may be given to populate the
 * buffer with data. This value can either be string of encoded bytes or a
 * regular string of characters. When passing a string of binary encoded
 * bytes, the encoding `raw` should be given. This is also the default. When
 * passing a string of characters, the encoding `utf8` should be given.
 *
 * @param [input] a string with encoded bytes to store in the buffer.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */ $eef0fa7557056871$var$util.createBuffer = function(input, encoding) {
    // TODO: deprecate, use new ByteBuffer() instead
    encoding = encoding || "raw";
    if (input !== undefined && encoding === "utf8") input = $eef0fa7557056871$var$util.encodeUtf8(input);
    return new $eef0fa7557056871$var$util.ByteBuffer(input);
};
/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */ $eef0fa7557056871$var$util.fillString = function(c, n) {
    var s = "";
    while(n > 0){
        if (n & 1) s += c;
        n >>>= 1;
        if (n > 0) c += c;
    }
    return s;
};
/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */ $eef0fa7557056871$var$util.xorBytes = function(s1, s2, n) {
    var s3 = "";
    var b = "";
    var t = "";
    var i = 0;
    var c = 0;
    for(; n > 0; --n, ++i){
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
        if (c >= 10) {
            s3 += t;
            t = "";
            c = 0;
        }
        t += String.fromCharCode(b);
        ++c;
    }
    s3 += t;
    return s3;
};
/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */ $eef0fa7557056871$var$util.hexToBytes = function(hex) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
    var rval = "";
    var i = 0;
    if (hex.length & true) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return rval;
};
/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */ $eef0fa7557056871$var$util.bytesToHex = function(bytes) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
    return $eef0fa7557056871$var$util.createBuffer(bytes).toHex();
};
/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */ $eef0fa7557056871$var$util.int32ToBytes = function(i) {
    return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
};
// base64 characters, reverse mapping
var $eef0fa7557056871$var$_base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $eef0fa7557056871$var$_base64Idx = [
    /*43 -43 = 0*/ /*'+',  1,  2,  3,'/' */ 62,
    -1,
    -1,
    -1,
    63,
    /*'0','1','2','3','4','5','6','7','8','9' */ 52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    /*15, 16, 17,'=', 19, 20, 21 */ -1,
    -1,
    -1,
    64,
    -1,
    -1,
    -1,
    /*65 - 43 = 22*/ /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */ 13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    /*91 - 43 = 48 */ /*48, 49, 50, 51, 52, 53 */ -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    /*97 - 43 = 54*/ /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */ 26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */ 39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51
];
// base58 characters (Bitcoin alphabet)
var $eef0fa7557056871$var$_base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */ $eef0fa7557056871$var$util.encode64 = function(input, maxline) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        // encode 4 character group
        line += $eef0fa7557056871$var$_base64.charAt(chr1 >> 2);
        line += $eef0fa7557056871$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $eef0fa7557056871$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $eef0fa7557056871$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */ $eef0fa7557056871$var$util.decode64 = function(input) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var output = "";
    var enc1, enc2, enc3, enc4;
    var i = 0;
    while(i < input.length){
        enc1 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
            if (enc4 !== 64) // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
        }
    }
    return output;
};
/**
 * Encodes the given string of characters (a standard JavaScript
 * string) as a binary encoded string where the bytes represent
 * a UTF-8 encoded string of characters. Non-ASCII characters will be
 * encoded as multiple bytes according to UTF-8.
 *
 * @param str a standard string of characters to encode.
 *
 * @return the binary encoded string.
 */ $eef0fa7557056871$var$util.encodeUtf8 = function(str) {
    return unescape(encodeURIComponent(str));
};
/**
 * Decodes a binary encoded string that contains bytes that
 * represent a UTF-8 encoded string of characters -- into a
 * string of characters (a standard JavaScript string).
 *
 * @param str the binary encoded string to decode.
 *
 * @return the resulting standard string of characters.
 */ $eef0fa7557056871$var$util.decodeUtf8 = function(str) {
    return decodeURIComponent(escape(str));
};
// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$eef0fa7557056871$var$util.binary = {
    raw: {},
    hex: {},
    base64: {},
    base58: {},
    baseN: {
        encode: $bqBKL.encode,
        decode: $bqBKL.decode
    }
};
/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */ $eef0fa7557056871$var$util.binary.raw.encode = function(bytes) {
    return String.fromCharCode.apply(null, bytes);
};
/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $eef0fa7557056871$var$util.binary.raw.decode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */ $eef0fa7557056871$var$util.binary.hex.encode = $eef0fa7557056871$var$util.bytesToHex;
/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $eef0fa7557056871$var$util.binary.hex.decode = function(hex, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(hex.length / 2));
    offset = offset || 0;
    var i = 0, j = offset;
    if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)out[j++] = parseInt(hex.substr(i, 2), 16);
    return output ? j - offset : out;
};
/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */ $eef0fa7557056871$var$util.binary.base64.encode = function(input, maxline) {
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.byteLength){
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        // encode 4 character group
        line += $eef0fa7557056871$var$_base64.charAt(chr1 >> 2);
        line += $eef0fa7557056871$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $eef0fa7557056871$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $eef0fa7557056871$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $eef0fa7557056871$var$util.binary.base64.decode = function(input, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(input.length / 4) * 3);
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    offset = offset || 0;
    var enc1, enc2, enc3, enc4;
    var i = 0, j = offset;
    while(i < input.length){
        enc1 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $eef0fa7557056871$var$_base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
            if (enc4 !== 64) // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
        }
    }
    // make sure result is the exact decoded length
    return output ? j - offset : out.subarray(0, j);
};
// add support for base58 encoding/decoding with Bitcoin alphabet
$eef0fa7557056871$var$util.binary.base58.encode = function(input, maxline) {
    return $eef0fa7557056871$var$util.binary.baseN.encode(input, $eef0fa7557056871$var$_base58, maxline);
};
$eef0fa7557056871$var$util.binary.base58.decode = function(input, maxline) {
    return $eef0fa7557056871$var$util.binary.baseN.decode(input, $eef0fa7557056871$var$_base58, maxline);
};
// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$eef0fa7557056871$var$util.text = {
    utf8: {},
    utf16: {}
};
/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $eef0fa7557056871$var$util.text.utf8.encode = function(str, output, offset) {
    str = $eef0fa7557056871$var$util.encodeUtf8(str);
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $eef0fa7557056871$var$util.text.utf8.decode = function(bytes) {
    return $eef0fa7557056871$var$util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $eef0fa7557056871$var$util.text.utf16.encode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length * 2);
    var view = new Uint16Array(out.buffer);
    offset = offset || 0;
    var j = offset;
    var k = offset;
    for(var i = 0; i < str.length; ++i){
        view[k++] = str.charCodeAt(i);
        j += 2;
    }
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $eef0fa7557056871$var$util.text.utf16.decode = function(bytes) {
    return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */ $eef0fa7557056871$var$util.deflate = function(api, bytes, raw) {
    bytes = $eef0fa7557056871$var$util.decode64(api.deflate($eef0fa7557056871$var$util.encode64(bytes)).rval);
    // strip zlib header and trailer if necessary
    if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);
        if (flg & 0x20) start = 6;
        // zlib trailer is 4 bytes of adler-32
        bytes = bytes.substring(start, bytes.length - 4);
    }
    return bytes;
};
/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */ $eef0fa7557056871$var$util.inflate = function(api, bytes, raw) {
    // TODO: add zlib header and trailer if necessary/possible
    var rval = api.inflate($eef0fa7557056871$var$util.encode64(bytes)).rval;
    return rval === null ? null : $eef0fa7557056871$var$util.decode64(rval);
};
/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */ var $eef0fa7557056871$var$_setStorageObject = function(api, id, obj) {
    if (!api) throw new Error("WebStorage not available.");
    var rval;
    if (obj === null) rval = api.removeItem(id);
    else {
        // json-encode and base64-encode object
        obj = $eef0fa7557056871$var$util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
    }
    // handle potential flash error
    if (typeof rval !== "undefined" && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
    }
};
/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */ var $eef0fa7557056871$var$_getStorageObject = function(api, id) {
    if (!api) throw new Error("WebStorage not available.");
    // get the existing entry
    var rval = api.getItem(id);
    /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */ // flash returns item wrapped in an object, handle special case
    if (api.init) {
        if (rval.rval === null) {
            if (rval.error) {
                var error = new Error(rval.error.message);
                error.id = rval.error.id;
                error.name = rval.error.name;
                throw error;
            }
            // no error, but also no item
            rval = null;
        } else rval = rval.rval;
    }
    // handle decoding
    if (rval !== null) // base64-decode and json-decode data
    rval = JSON.parse($eef0fa7557056871$var$util.decode64(rval));
    return rval;
};
/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */ var $eef0fa7557056871$var$_setItem = function(api, id, key, data) {
    // get storage object
    var obj = $eef0fa7557056871$var$_getStorageObject(api, id);
    if (obj === null) // create a new storage object
    obj = {};
    // update key
    obj[key] = data;
    // set storage object
    $eef0fa7557056871$var$_setStorageObject(api, id, obj);
};
/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */ var $eef0fa7557056871$var$_getItem = function(api, id, key) {
    // get storage object
    var rval = $eef0fa7557056871$var$_getStorageObject(api, id);
    if (rval !== null) // return data at key
    rval = key in rval ? rval[key] : null;
    return rval;
};
/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */ var $eef0fa7557056871$var$_removeItem = function(api, id, key) {
    // get storage object
    var obj = $eef0fa7557056871$var$_getStorageObject(api, id);
    if (obj !== null && key in obj) {
        // remove key
        delete obj[key];
        // see if entry has no keys remaining
        var empty = true;
        for(var prop in obj){
            empty = false;
            break;
        }
        if (empty) // remove entry entirely if no keys are left
        obj = null;
        // set storage object
        $eef0fa7557056871$var$_setStorageObject(api, id, obj);
    }
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */ var $eef0fa7557056871$var$_clearItems = function(api, id) {
    $eef0fa7557056871$var$_setStorageObject(api, id, null);
};
/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */ var $eef0fa7557056871$var$_callStorageFunction = function(func, args, location) {
    var rval = null;
    // default storage types
    if (typeof location === "undefined") location = [
        "web",
        "flash"
    ];
    // apply storage types in order of preference
    var type;
    var done = false;
    var exception = null;
    for(var idx in location){
        type = location[idx];
        try {
            if (type === "flash" || type === "both") {
                if (args[0] === null) throw new Error("Flash local storage not available.");
                rval = func.apply(this, args);
                done = type === "flash";
            }
            if (type === "web" || type === "both") {
                args[0] = localStorage;
                rval = func.apply(this, args);
                done = true;
            }
        } catch (ex) {
            exception = ex;
        }
        if (done) break;
    }
    if (!done) throw exception;
    return rval;
};
/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */ $eef0fa7557056871$var$util.setItem = function(api, id, key, data, location) {
    $eef0fa7557056871$var$_callStorageFunction($eef0fa7557056871$var$_setItem, arguments, location);
};
/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */ $eef0fa7557056871$var$util.getItem = function(api, id, key, location) {
    return $eef0fa7557056871$var$_callStorageFunction($eef0fa7557056871$var$_getItem, arguments, location);
};
/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */ $eef0fa7557056871$var$util.removeItem = function(api, id, key, location) {
    $eef0fa7557056871$var$_callStorageFunction($eef0fa7557056871$var$_removeItem, arguments, location);
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */ $eef0fa7557056871$var$util.clearItems = function(api, id, location) {
    $eef0fa7557056871$var$_callStorageFunction($eef0fa7557056871$var$_clearItems, arguments, location);
};
/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */ $eef0fa7557056871$var$util.isEmpty = function(obj) {
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
};
/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */ $eef0fa7557056871$var$util.format = function(format) {
    var re = /%./g;
    // current match
    var match;
    // current part
    var part;
    // current arg index
    var argi = 0;
    // collected parts to recombine later
    var parts = [];
    // last index found
    var last = 0;
    // loop while matches remain
    while(match = re.exec(format)){
        part = format.substring(last, re.lastIndex - 2);
        // don't add empty strings (ie, parts between %s%s)
        if (part.length > 0) parts.push(part);
        last = re.lastIndex;
        // switch on % code
        var code = match[0][1];
        switch(code){
            case "s":
            case "o":
                // check if enough arguments were given
                if (argi < arguments.length) parts.push(arguments[argi++ + 1]);
                else parts.push("<?>");
                break;
            // FIXME: do proper formating for numbers, etc
            //case 'f':
            //case 'd':
            case "%":
                parts.push("%");
                break;
            default:
                parts.push("<%" + code + "?>");
        }
    }
    // add trailing part of format string
    parts.push(format.substring(last));
    return parts.join("");
};
/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */ $eef0fa7557056871$var$util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // *     example 1: number_format(1234.5678, 2, '.', '');
    // *     returns 1: 1234.57
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point === undefined ? "," : dec_point;
    var t = thousands_sep === undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */ $eef0fa7557056871$var$util.formatSize = function(size) {
    if (size >= 1073741824) size = $eef0fa7557056871$var$util.formatNumber(size / 1073741824, 2, ".", "") + " GiB";
    else if (size >= 1048576) size = $eef0fa7557056871$var$util.formatNumber(size / 1048576, 2, ".", "") + " MiB";
    else if (size >= 1024) size = $eef0fa7557056871$var$util.formatNumber(size / 1024, 0) + " KiB";
    else size = $eef0fa7557056871$var$util.formatNumber(size, 0) + " bytes";
    return size;
};
/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */ $eef0fa7557056871$var$util.bytesFromIP = function(ip) {
    if (ip.indexOf(".") !== -1) return $eef0fa7557056871$var$util.bytesFromIPv4(ip);
    if (ip.indexOf(":") !== -1) return $eef0fa7557056871$var$util.bytesFromIPv6(ip);
    return null;
};
/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */ $eef0fa7557056871$var$util.bytesFromIPv4 = function(ip) {
    ip = ip.split(".");
    if (ip.length !== 4) return null;
    var b = $eef0fa7557056871$var$util.createBuffer();
    for(var i = 0; i < ip.length; ++i){
        var num = parseInt(ip[i], 10);
        if (isNaN(num)) return null;
        b.putByte(num);
    }
    return b.getBytes();
};
/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */ $eef0fa7557056871$var$util.bytesFromIPv6 = function(ip) {
    var blanks = 0;
    ip = ip.split(":").filter(function(e) {
        if (e.length === 0) ++blanks;
        return true;
    });
    var zeros = (8 - ip.length + blanks) * 2;
    var b = $eef0fa7557056871$var$util.createBuffer();
    for(var i = 0; i < 8; ++i){
        if (!ip[i] || ip[i].length === 0) {
            b.fillWithByte(0, zeros);
            zeros = 0;
            continue;
        }
        var bytes = $eef0fa7557056871$var$util.hexToBytes(ip[i]);
        if (bytes.length < 2) b.putByte(0);
        b.putBytes(bytes);
    }
    return b.getBytes();
};
/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */ $eef0fa7557056871$var$util.bytesToIP = function(bytes) {
    if (bytes.length === 4) return $eef0fa7557056871$var$util.bytesToIPv4(bytes);
    if (bytes.length === 16) return $eef0fa7557056871$var$util.bytesToIPv6(bytes);
    return null;
};
/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */ $eef0fa7557056871$var$util.bytesToIPv4 = function(bytes) {
    if (bytes.length !== 4) return null;
    var ip = [];
    for(var i = 0; i < bytes.length; ++i)ip.push(bytes.charCodeAt(i));
    return ip.join(".");
};
/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */ $eef0fa7557056871$var$util.bytesToIPv6 = function(bytes) {
    if (bytes.length !== 16) return null;
    var ip = [];
    var zeroGroups = [];
    var zeroMaxGroup = 0;
    for(var i = 0; i < bytes.length; i += 2){
        var hex = $eef0fa7557056871$var$util.bytesToHex(bytes[i] + bytes[i + 1]);
        // canonicalize zero representation
        while(hex[0] === "0" && hex !== "0")hex = hex.substr(1);
        if (hex === "0") {
            var last = zeroGroups[zeroGroups.length - 1];
            var idx = ip.length;
            if (!last || idx !== last.end + 1) zeroGroups.push({
                start: idx,
                end: idx
            });
            else {
                last.end = idx;
                if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) zeroMaxGroup = zeroGroups.length - 1;
            }
        }
        ip.push(hex);
    }
    if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup];
        // only shorten group of length > 0
        if (group.end - group.start > 0) {
            ip.splice(group.start, group.end - group.start + 1, "");
            if (group.start === 0) ip.unshift("");
            if (group.end === 7) ip.push("");
        }
    }
    return ip.join(":");
};
/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */ $eef0fa7557056871$var$util.estimateCores = function(options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    if ("cores" in $eef0fa7557056871$var$util && !options.update) return callback(null, $eef0fa7557056871$var$util.cores);
    if (typeof navigator !== "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) {
        $eef0fa7557056871$var$util.cores = navigator.hardwareConcurrency;
        return callback(null, $eef0fa7557056871$var$util.cores);
    }
    if (typeof Worker === "undefined") {
        // workers not available
        $eef0fa7557056871$var$util.cores = 1;
        return callback(null, $eef0fa7557056871$var$util.cores);
    }
    if (typeof Blob === "undefined") {
        // can't estimate, default to 2
        $eef0fa7557056871$var$util.cores = 2;
        return callback(null, $eef0fa7557056871$var$util.cores);
    }
    // create worker concurrency estimation code as blob
    var blobUrl = URL.createObjectURL(new Blob([
        "(",
        (function() {
            self.addEventListener("message", function(e) {
                // run worker for 4 ms
                var st = Date.now();
                var et = st + 4;
                while(Date.now() < et);
                self.postMessage({
                    st: st,
                    et: et
                });
            });
        }).toString(),
        ")()"
    ], {
        type: "application/javascript"
    }));
    // take 5 samples using 16 workers
    sample([], 5, 16);
    function sample(max, samples, numWorkers) {
        if (samples === 0) {
            // get overlap average
            var avg = Math.floor(max.reduce(function(avg, x) {
                return avg + x;
            }, 0) / max.length);
            $eef0fa7557056871$var$util.cores = Math.max(1, avg);
            URL.revokeObjectURL(blobUrl);
            return callback(null, $eef0fa7557056871$var$util.cores);
        }
        map(numWorkers, function(err, results) {
            max.push(reduce(numWorkers, results));
            sample(max, samples - 1, numWorkers);
        });
    }
    function map(numWorkers, callback) {
        var workers = [];
        var results = [];
        for(var i = 0; i < numWorkers; ++i){
            var worker = new Worker(blobUrl);
            worker.addEventListener("message", function(e) {
                results.push(e.data);
                if (results.length === numWorkers) {
                    for(var i = 0; i < numWorkers; ++i)workers[i].terminate();
                    callback(null, results);
                }
            });
            workers.push(worker);
        }
        for(var i = 0; i < numWorkers; ++i)workers[i].postMessage(i);
    }
    function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n){
            var r1 = results[n];
            var overlap = overlaps[n] = [];
            for(var i = 0; i < numWorkers; ++i){
                if (n === i) continue;
                var r2 = results[i];
                if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) overlap.push(i);
            }
        }
        // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway
        return overlaps.reduce(function(max, overlap) {
            return Math.max(max, overlap.length);
        }, 0);
    }
};

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("bqBKL", function(module, exports) {
/**
 * Base-N/Base-X encoding/decoding functions.
 *
 * Original implementation from base-x:
 * https://github.com/cryptocoinjs/base-x
 *
 * Which is MIT licensed:
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ 
var $kjyEk = parcelRequire("kjyEk");
var $851f686aa009b4a1$require$Buffer = $kjyEk.Buffer;
var $851f686aa009b4a1$var$api = {};
module.exports = $851f686aa009b4a1$var$api;
// baseN alphabet indexes
var $851f686aa009b4a1$var$_reverseAlphabets = {};
/**
 * BaseN-encodes a Uint8Array using the given alphabet.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the baseN-encoded output string.
 */ $851f686aa009b4a1$var$api.encode = function(input, alphabet, maxline) {
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    if (maxline !== undefined && typeof maxline !== "number") throw new TypeError('"maxline" must be a number.');
    var output = "";
    if (!(input instanceof Uint8Array)) // assume forge byte buffer
    output = $851f686aa009b4a1$var$_encodeWithByteBuffer(input, alphabet);
    else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [
            0
        ];
        for(i = 0; i < input.length; ++i){
            for(var j = 0, carry = input[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % base;
                carry = carry / base | 0;
            }
            while(carry > 0){
                digits.push(carry % base);
                carry = carry / base | 0;
            }
        }
        // deal with leading zeros
        for(i = 0; input[i] === 0 && i < input.length - 1; ++i)output += first;
        // convert digits to a string
        for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    }
    if (maxline) {
        var regex = new RegExp(".{1," + maxline + "}", "g");
        output = output.match(regex).join("\r\n");
    }
    return output;
};
/**
 * Decodes a baseN-encoded (using the given alphabet) string to a
 * Uint8Array.
 *
 * @param input the baseN-encoded input string.
 *
 * @return the Uint8Array.
 */ $851f686aa009b4a1$var$api.decode = function(input, alphabet) {
    if (typeof input !== "string") throw new TypeError('"input" must be a string.');
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    var table = $851f686aa009b4a1$var$_reverseAlphabets[alphabet];
    if (!table) {
        // compute reverse alphabet
        table = $851f686aa009b4a1$var$_reverseAlphabets[alphabet] = [];
        for(var i = 0; i < alphabet.length; ++i)table[alphabet.charCodeAt(i)] = i;
    }
    // remove whitespace characters
    input = input.replace(/\s/g, "");
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var bytes = [
        0
    ];
    for(var i = 0; i < input.length; i++){
        var value = table[input.charCodeAt(i)];
        if (value === undefined) return;
        for(var j = 0, carry = value; j < bytes.length; ++j){
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while(carry > 0){
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for(var k = 0; input[k] === first && k < input.length - 1; ++k)bytes.push(0);
    if (typeof $851f686aa009b4a1$require$Buffer !== "undefined") return $851f686aa009b4a1$require$Buffer.from(bytes.reverse());
    return new Uint8Array(bytes.reverse());
};
function $851f686aa009b4a1$var$_encodeWithByteBuffer(input, alphabet) {
    var i = 0;
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [
        0
    ];
    for(i = 0; i < input.length(); ++i){
        for(var j = 0, carry = input.at(i); j < digits.length; ++j){
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
        }
        while(carry > 0){
            digits.push(carry % base);
            carry = carry / base | 0;
        }
    }
    var output = "";
    // deal with leading zeros
    for(i = 0; input.at(i) === 0 && i < input.length() - 1; ++i)output += first;
    // convert digits to a string
    for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    return output;
}

});



parcelRegister("g1HTO", function(module, exports) {
/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
$dEd5p.cipher = $dEd5p.cipher || {};
// supported cipher modes
var $baaecac778e6bbb7$var$modes = module.exports = $dEd5p.cipher.modes = $dEd5p.cipher.modes || {};
/** Electronic codebook (ECB) (Don't use this; it's not secure) **/ $baaecac778e6bbb7$var$modes.ecb = function(options) {
    options = options || {};
    this.name = "ECB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$baaecac778e6bbb7$var$modes.ecb.prototype.start = function(options) {};
$baaecac778e6bbb7$var$modes.ecb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$baaecac778e6bbb7$var$modes.ecb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$baaecac778e6bbb7$var$modes.ecb.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$baaecac778e6bbb7$var$modes.ecb.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher-block Chaining (CBC) **/ $baaecac778e6bbb7$var$modes.cbc = function(options) {
    options = options || {};
    this.name = "CBC";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$baaecac778e6bbb7$var$modes.cbc.prototype.start = function(options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
        // must have a previous block
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
    } else if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    else {
        // save IV as "previous" block
        this._iv = $baaecac778e6bbb7$var$transformIV(options.iv, this.blockSize);
        this._prev = this._iv.slice(0);
    }
};
$baaecac778e6bbb7$var$modes.cbc.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    // CBC XOR's IV (or previous block) with plaintext
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._prev[i] ^ input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output, save previous block
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
    this._prev = this._outBlock;
};
$baaecac778e6bbb7$var$modes.cbc.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._prev[i] ^ this._outBlock[i]);
    this._prev = this._inBlock.slice(0);
};
$baaecac778e6bbb7$var$modes.cbc.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$baaecac778e6bbb7$var$modes.cbc.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher feedback (CFB) **/ $baaecac778e6bbb7$var$modes.cfb = function(options) {
    options = options || {};
    this.name = "CFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = $dEd5p.util.createBuffer();
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.cfb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $baaecac778e6bbb7$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.cfb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
            output.putInt32(this._inBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
        this._partialOutput.putInt32(this._partialBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.cfb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32();
            output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32();
        this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
/** Output feedback (OFB) **/ $baaecac778e6bbb7$var$modes.ofb = function(options) {
    options = options || {};
    this.name = "OFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $dEd5p.util.createBuffer();
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.ofb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $baaecac778e6bbb7$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.ofb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (input.length() === 0) return true;
    // encrypt block (OFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output and update next input
        for(var i = 0; i < this._ints; ++i){
            output.putInt32(input.getInt32() ^ this._outBlock[i]);
            this._inBlock[i] = this._outBlock[i];
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._outBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.ofb.prototype.decrypt = $baaecac778e6bbb7$var$modes.ofb.prototype.encrypt;
/** Counter (CTR) **/ $baaecac778e6bbb7$var$modes.ctr = function(options) {
    options = options || {};
    this.name = "CTR";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $dEd5p.util.createBuffer();
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.ctr.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $baaecac778e6bbb7$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$baaecac778e6bbb7$var$modes.ctr.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CTR always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) // XOR input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(input.getInt32() ^ this._outBlock[i]);
    else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes > 0) // block still incomplete, restore input buffer
        input.read -= this.blockSize;
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // block complete, increment counter (input block)
    $baaecac778e6bbb7$var$inc32(this._inBlock);
};
$baaecac778e6bbb7$var$modes.ctr.prototype.decrypt = $baaecac778e6bbb7$var$modes.ctr.prototype.encrypt;
/** Galois/Counter Mode (GCM) **/ $baaecac778e6bbb7$var$modes.gcm = function(options) {
    options = options || {};
    this.name = "GCM";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = $dEd5p.util.createBuffer();
    this._partialBytes = 0;
    // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block
    this._R = 0xE1000000;
};
$baaecac778e6bbb7$var$modes.gcm.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // ensure IV is a byte buffer
    var iv = $dEd5p.util.createBuffer(options.iv);
    // no ciphered data processed yet
    this._cipherLength = 0;
    // default additional data is none
    var additionalData;
    if ("additionalData" in options) additionalData = $dEd5p.util.createBuffer(options.additionalData);
    else additionalData = $dEd5p.util.createBuffer();
    // default tag length is 128 bits
    if ("tagLength" in options) this._tagLength = options.tagLength;
    else this._tagLength = 128;
    // if tag is given, ensure tag matches tag length
    this._tag = null;
    if (options.decrypt) {
        // save tag to check later
        this._tag = $dEd5p.util.createBuffer(options.tag).getBytes();
        if (this._tag.length !== this._tagLength / 8) throw new Error("Authentication tag does not match tag length.");
    }
    // create tmp storage for hash calculation
    this._hashBlock = new Array(this._ints);
    // no tag generated yet
    this.tag = null;
    // generate hash subkey
    // (apply block cipher to "zero" block)
    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([
        0,
        0,
        0,
        0
    ], this._hashSubkey);
    // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)
    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
    // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0
    var ivLength = iv.length();
    if (ivLength === 12) // 96-bit IV
    this._j0 = [
        iv.getInt32(),
        iv.getInt32(),
        iv.getInt32(),
        1
    ];
    else {
        // IV is NOT 96-bits
        this._j0 = [
            0,
            0,
            0,
            0
        ];
        while(iv.length() > 0)this._j0 = this.ghash(this._hashSubkey, this._j0, [
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32()
        ]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [
            0,
            0
        ].concat($baaecac778e6bbb7$var$from64To32(ivLength * 8)));
    }
    // generate ICB (initial counter block)
    this._inBlock = this._j0.slice(0);
    $baaecac778e6bbb7$var$inc32(this._inBlock);
    this._partialBytes = 0;
    // consume authentication data
    additionalData = $dEd5p.util.createBuffer(additionalData);
    // save additional data length as a BE 64-bit number
    this._aDataLength = $baaecac778e6bbb7$var$from64To32(additionalData.length() * 8);
    // pad additional data to 128 bit (16 byte) block size
    var overflow = additionalData.length() % this.blockSize;
    if (overflow) additionalData.fillWithByte(0, this.blockSize - overflow);
    this._s = [
        0,
        0,
        0,
        0
    ];
    while(additionalData.length() > 0)this._s = this.ghash(this._hashSubkey, this._s, [
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32()
    ]);
};
$baaecac778e6bbb7$var$modes.gcm.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output
        for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^= input.getInt32());
        this._cipherLength += this.blockSize;
    } else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes <= 0 || finish) {
            // handle overflow prior to hashing
            if (finish) {
                // get block overflow
                var overflow = inputLength % this.blockSize;
                this._cipherLength += overflow;
                // truncate for hash function
                this._partialOutput.truncate(this.blockSize - overflow);
            } else this._cipherLength += this.blockSize;
            // get output block for hashing
            for(var i = 0; i < this._ints; ++i)this._outBlock[i] = this._partialOutput.getInt32();
            this._partialOutput.read -= this.blockSize;
        }
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            // block still incomplete, restore input buffer, get partial output,
            // and return early
            input.read -= this.blockSize;
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // update hash block S
    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
    // increment counter (input block)
    $baaecac778e6bbb7$var$inc32(this._inBlock);
};
$baaecac778e6bbb7$var$modes.gcm.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength < this.blockSize && !(finish && inputLength > 0)) return true;
    // encrypt block (GCM always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // increment counter (input block)
    $baaecac778e6bbb7$var$inc32(this._inBlock);
    // update hash block S
    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
    // XOR hash input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    // increment cipher data length
    if (inputLength < this.blockSize) this._cipherLength += inputLength % this.blockSize;
    else this._cipherLength += this.blockSize;
};
$baaecac778e6bbb7$var$modes.gcm.prototype.afterFinish = function(output, options) {
    var rval = true;
    // handle overflow
    if (options.decrypt && options.overflow) output.truncate(this.blockSize - options.overflow);
    // handle authentication tag
    this.tag = $dEd5p.util.createBuffer();
    // concatenate additional data length with cipher length
    var lengths = this._aDataLength.concat($baaecac778e6bbb7$var$from64To32(this._cipherLength * 8));
    // include lengths in hash
    this._s = this.ghash(this._hashSubkey, this._s, lengths);
    // do GCTR(J_0, S)
    var tag = [];
    this.cipher.encrypt(this._j0, tag);
    for(var i = 0; i < this._ints; ++i)this.tag.putInt32(this._s[i] ^ tag[i]);
    // trim tag to length
    this.tag.truncate(this.tag.length() % (this._tagLength / 8));
    // check authentication tag
    if (options.decrypt && this.tag.bytes() !== this._tag) rval = false;
    return rval;
};
/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */ $baaecac778e6bbb7$var$modes.gcm.prototype.multiply = function(x, y) {
    var z_i = [
        0,
        0,
        0,
        0
    ];
    var v_i = y.slice(0);
    // calculate Z_128 (block has 128 bits)
    for(var i = 0; i < 128; ++i){
        // if x_i is 0, Z_{i+1} = Z_i (unchanged)
        // else Z_{i+1} = Z_i ^ V_i
        // get x_i by finding 32-bit int position, then left shift 1 by remainder
        var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;
        if (x_i) {
            z_i[0] ^= v_i[0];
            z_i[1] ^= v_i[1];
            z_i[2] ^= v_i[2];
            z_i[3] ^= v_i[3];
        }
        // if LSB(V_i) is 1, V_i = V_i >> 1
        // else V_i = (V_i >> 1) ^ R
        this.pow(v_i, v_i);
    }
    return z_i;
};
$baaecac778e6bbb7$var$modes.gcm.prototype.pow = function(x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1;
    // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)
    for(var i = 3; i > 0; --i)out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    // shift the first integer normally
    out[0] = x[0] >>> 1;
    // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits
    if (lsb) out[0] ^= this._R;
};
$baaecac778e6bbb7$var$modes.gcm.prototype.tableMultiply = function(x) {
    // assumes 4-bit tables are used
    var z = [
        0,
        0,
        0,
        0
    ];
    for(var i = 0; i < 32; ++i){
        var idx = i / 8 | 0;
        var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
        var ah = this._m[i][x_i];
        z[0] ^= ah[0];
        z[1] ^= ah[1];
        z[2] ^= ah[2];
        z[3] ^= ah[3];
    }
    return z;
};
/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */ $baaecac778e6bbb7$var$modes.gcm.prototype.ghash = function(h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y);
//return this.multiply(y, h);
};
/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */ $baaecac778e6bbb7$var$modes.gcm.prototype.generateHashTable = function(h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);
    for(var i = 0; i < size; ++i){
        var tmp = [
            0,
            0,
            0,
            0
        ];
        var idx = i / perInt | 0;
        var shft = (perInt - 1 - i % perInt) * bits;
        tmp[idx] = 1 << bits - 1 << shft;
        m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }
    return m;
};
/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */ $baaecac778e6bbb7$var$modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;
    while(i > 0){
        // raise m0[2 * i] and store in m0[i]
        this.pow(m[2 * i], m[i] = []);
        i >>= 1;
    }
    i = 2;
    while(i < half){
        for(var j = 1; j < i; ++j){
            var m_i = m[i];
            var m_j = m[j];
            m[i + j] = [
                m_i[0] ^ m_j[0],
                m_i[1] ^ m_j[1],
                m_i[2] ^ m_j[2],
                m_i[3] ^ m_j[3]
            ];
        }
        i *= 2;
    }
    m[0] = [
        0,
        0,
        0,
        0
    ];
    /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */ for(i = half + 1; i < size; ++i){
        var c = m[i ^ half];
        m[i] = [
            mid[0] ^ c[0],
            mid[1] ^ c[1],
            mid[2] ^ c[2],
            mid[3] ^ c[3]
        ];
    }
    return m;
};
/** Utility functions */ function $baaecac778e6bbb7$var$transformIV(iv, blockSize) {
    if (typeof iv === "string") // convert iv string into byte buffer
    iv = $dEd5p.util.createBuffer(iv);
    if ($dEd5p.util.isArray(iv) && iv.length > 4) {
        // convert iv byte array into byte buffer
        var tmp = iv;
        iv = $dEd5p.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)iv.putByte(tmp[i]);
    }
    if (iv.length() < blockSize) throw new Error("Invalid IV length; got " + iv.length() + " bytes and expected " + blockSize + " bytes.");
    if (!$dEd5p.util.isArray(iv)) {
        // convert iv byte buffer into 32-bit integer array
        var ints = [];
        var blocks = blockSize / 4;
        for(var i = 0; i < blocks; ++i)ints.push(iv.getInt32());
        iv = ints;
    }
    return iv;
}
function $baaecac778e6bbb7$var$inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
}
function $baaecac778e6bbb7$var$from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [
        num / 0x100000000 | 0,
        num & 0xFFFFFFFF
    ];
}

});


parcelRegister("8QTFz", function(module, exports) {
/**
 * Javascript implementation of Abstract Syntax Notation Number One.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 *
 * An API for storing data using the Abstract Syntax Notation Number One
 * format using DER (Distinguished Encoding Rules) encoding. This encoding is
 * commonly used to store data for PKI, i.e. X.509 Certificates, and this
 * implementation exists for that purpose.
 *
 * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
 * syntax of information without restricting the way the information is encoded
 * for transmission. It provides a standard that allows for open systems
 * communication. ASN.1 defines the syntax of information data and a number of
 * simple data types as well as a notation for describing them and specifying
 * values for them.
 *
 * The RSA algorithm creates public and private keys that are often stored in
 * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
 * class provides the most basic functionality required to store and load DSA
 * keys that are encoded according to ASN.1.
 *
 * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
 * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
 * has stricter requirements for how data must be encoded.
 *
 * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
 * and a byte array for the value of this ASN1 structure which may be data or a
 * list of ASN.1 structures.
 *
 * Each ASN.1 structure using BER is (Tag-Length-Value):
 *
 * | byte 0 | bytes X | bytes Y |
 * |--------|---------|----------
 * |  tag   | length  |  value  |
 *
 * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
 * be two or more octets, but that is not supported by this class. A tag is
 * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
 * particular 'class'), 6 indicates whether or not the ASN.1 value is
 * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
 * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
 * then the class is APPLICATION. If only bit 8 is set, then the class is
 * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
 * The tag numbers for the data types for the class UNIVERSAL are listed below:
 *
 * UNIVERSAL 0 Reserved for use by the encoding rules
 * UNIVERSAL 1 Boolean type
 * UNIVERSAL 2 Integer type
 * UNIVERSAL 3 Bitstring type
 * UNIVERSAL 4 Octetstring type
 * UNIVERSAL 5 Null type
 * UNIVERSAL 6 Object identifier type
 * UNIVERSAL 7 Object descriptor type
 * UNIVERSAL 8 External type and Instance-of type
 * UNIVERSAL 9 Real type
 * UNIVERSAL 10 Enumerated type
 * UNIVERSAL 11 Embedded-pdv type
 * UNIVERSAL 12 UTF8String type
 * UNIVERSAL 13 Relative object identifier type
 * UNIVERSAL 14-15 Reserved for future editions
 * UNIVERSAL 16 Sequence and Sequence-of types
 * UNIVERSAL 17 Set and Set-of types
 * UNIVERSAL 18-22, 25-30 Character string types
 * UNIVERSAL 23-24 Time types
 *
 * The length of an ASN.1 structure is specified after the tag identifier.
 * There is a definite form and an indefinite form. The indefinite form may
 * be used if the encoding is constructed and not all immediately available.
 * The indefinite form is encoded using a length byte with only the 8th bit
 * set. The end of the constructed object is marked using end-of-contents
 * octets (two zero bytes).
 *
 * The definite form looks like this:
 *
 * The length may take up 1 or more bytes, it depends on the length of the
 * value of the ASN.1 structure. DER encoding requires that if the ASN.1
 * structure has a value that has a length greater than 127, more than 1 byte
 * will be used to store its length, otherwise just one byte will be used.
 * This is strict.
 *
 * In the case that the length of the ASN.1 value is less than 127, 1 octet
 * (byte) is used to store the "short form" length. The 8th bit has a value of
 * 0 indicating the length is "short form" and not "long form" and bits 7-1
 * give the length of the data. (The 8th bit is the left-most, most significant
 * bit: also known as big endian or network format).
 *
 * In the case that the length of the ASN.1 value is greater than 127, 2 to
 * 127 octets (bytes) are used to store the "long form" length. The first
 * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
 * give the number of additional octets. All following octets are in base 256
 * with the most significant digit first (typical big-endian binary unsigned
 * integer storage). So, for instance, if the length of a value was 257, the
 * first byte would be set to:
 *
 * 10000010 = 130 = 0x82.
 *
 * This indicates there are 2 octets (base 256) for the length. The second and
 * third bytes (the octets just mentioned) would store the length in base 256:
 *
 * octet 2: 00000001 = 1 * 256^1 = 256
 * octet 3: 00000001 = 1 * 256^0 = 1
 * total = 257
 *
 * The algorithm for converting a js integer value of 257 to base-256 is:
 *
 * var value = 257;
 * var bytes = [];
 * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
 * bytes[1] = value & 0xFF;        // least significant byte last
 *
 * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
 *
 * An OID can be written like: "value1.value2.value3...valueN"
 *
 * The DER encoding rules:
 *
 * The first byte has the value 40 * value1 + value2.
 * The following bytes, if any, encode the remaining values. Each value is
 * encoded in base 128, most significant digit first (big endian), with as
 * few digits as possible, and the most significant bit of each byte set
 * to 1 except the last in each value's encoding. For example: Given the
 * OID "1.2.840.113549", its DER encoding is (remember each byte except the
 * last one in each encoding is OR'd with 0x80):
 *
 * byte 1: 40 * 1 + 2 = 42 = 0x2A.
 * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
 * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
 *
 * The final value is: 0x2A864886F70D.
 * The full OID (including ASN.1 tag and length of 6 bytes) is:
 * 0x06062A864886F70D
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
parcelRequire("ggdRy");
/* ASN.1 API */ var $671e5cded9a558d9$var$asn1 = module.exports = $dEd5p.asn1 = $dEd5p.asn1 || {};
/**
 * ASN.1 classes.
 */ $671e5cded9a558d9$var$asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
};
/**
 * ASN.1 types. Not all types are supported by this implementation, only
 * those necessary to implement a simple PKI are implemented.
 */ $671e5cded9a558d9$var$asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
};
/**
 * Creates a new asn1 object.
 *
 * @param tagClass the tag class for the object.
 * @param type the data type (tag number) for the object.
 * @param constructed true if the asn1 object is in constructed form.
 * @param value the value for the object, if it is not constructed.
 * @param [options] the options to use:
 *          [bitStringContents] the plain BIT STRING content including padding
 *            byte.
 *
 * @return the asn1 object.
 */ $671e5cded9a558d9$var$asn1.create = function(tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
    value. The value's type depends on the constructed flag. If
    constructed, it will contain a list of other asn1 objects. If not,
    it will contain the ASN.1 value as an array of bytes formatted
    according to the ASN.1 data type. */ // remove undefined values
    if ($dEd5p.util.isArray(value)) {
        var tmp = [];
        for(var i = 0; i < value.length; ++i)if (value[i] !== undefined) tmp.push(value[i]);
        value = tmp;
    }
    var obj = {
        tagClass: tagClass,
        type: type,
        constructed: constructed,
        composed: constructed || $dEd5p.util.isArray(value),
        value: value
    };
    if (options && "bitStringContents" in options) {
        // TODO: copy byte buffer if it's a buffer not a string
        obj.bitStringContents = options.bitStringContents;
        // TODO: add readonly flag to avoid this overhead
        // save copy to detect changes
        obj.original = $671e5cded9a558d9$var$asn1.copy(obj);
    }
    return obj;
};
/**
 * Copies an asn1 object.
 *
 * @param obj the asn1 object.
 * @param [options] copy options:
 *          [excludeBitStringContents] true to not copy bitStringContents
 *
 * @return the a copy of the asn1 object.
 */ $671e5cded9a558d9$var$asn1.copy = function(obj, options) {
    var copy;
    if ($dEd5p.util.isArray(obj)) {
        copy = [];
        for(var i = 0; i < obj.length; ++i)copy.push($671e5cded9a558d9$var$asn1.copy(obj[i], options));
        return copy;
    }
    if (typeof obj === "string") // TODO: copy byte buffer if it's a buffer not a string
    return obj;
    copy = {
        tagClass: obj.tagClass,
        type: obj.type,
        constructed: obj.constructed,
        composed: obj.composed,
        value: $671e5cded9a558d9$var$asn1.copy(obj.value, options)
    };
    if (options && !options.excludeBitStringContents) // TODO: copy byte buffer if it's a buffer not a string
    copy.bitStringContents = obj.bitStringContents;
    return copy;
};
/**
 * Compares asn1 objects for equality.
 *
 * Note this function does not run in constant time.
 *
 * @param obj1 the first asn1 object.
 * @param obj2 the second asn1 object.
 * @param [options] compare options:
 *          [includeBitStringContents] true to compare bitStringContents
 *
 * @return true if the asn1 objects are equal.
 */ $671e5cded9a558d9$var$asn1.equals = function(obj1, obj2, options) {
    if ($dEd5p.util.isArray(obj1)) {
        if (!$dEd5p.util.isArray(obj2)) return false;
        if (obj1.length !== obj2.length) return false;
        for(var i = 0; i < obj1.length; ++i){
            if (!$671e5cded9a558d9$var$asn1.equals(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if (typeof obj1 !== typeof obj2) return false;
    if (typeof obj1 === "string") return obj1 === obj2;
    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && $671e5cded9a558d9$var$asn1.equals(obj1.value, obj2.value);
    if (options && options.includeBitStringContents) equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    return equal;
};
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param b the BER-encoded ASN.1 byte buffer, starting with the first
 *          length byte.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ $671e5cded9a558d9$var$asn1.getBerValueLength = function(b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else // the number of bytes the length is specified in bits 7 through 1
    // and each length byte is in big-endian base-256
    length = b.getInt((b2 & 0x7F) << 3);
    return length;
};
/**
 * Check if the byte buffer has enough bytes. Throws an Error if not.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 * @param n the number of bytes the buffer must have.
 */ function $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
        var error = new Error("Too few bytes to parse DER.");
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = n;
        throw error;
    }
}
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ var $671e5cded9a558d9$var$_getValueLength = function(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else {
        // the number of bytes the length is specified in bits 7 through 1
        // and each length byte is in big-endian base-256
        var longFormBytes = b2 & 0x7F;
        $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, longFormBytes);
        length = bytes.getInt(longFormBytes << 3);
    }
    // FIXME: this will only happen for 32 bit getInt with high bit set
    if (length < 0) throw new Error("Negative length: " + length);
    return length;
};
/**
 * Parses an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param [strict] true to be strict when checking value lengths, false to
 *          allow truncated values (default: true).
 * @param [options] object with options or boolean strict flag
 *          [strict] true to be strict when checking value lengths, false to
 *            allow truncated values (default: true).
 *          [parseAllBytes] true to ensure all bytes are parsed
 *            (default: true)
 *          [decodeBitStrings] true to attempt to decode the content of
 *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
 *            without schema support to understand the data context this can
 *            erroneously decode values that happen to be valid ASN.1. This
 *            flag will be deprecated or removed as soon as schema support is
 *            available. (default: true)
 *
 * @throws Will throw an error for various malformed input conditions.
 *
 * @return the parsed asn1 object.
 */ $671e5cded9a558d9$var$asn1.fromDer = function(bytes, options) {
    if (options === undefined) options = {
        strict: true,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (typeof options === "boolean") options = {
        strict: options,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (!("strict" in options)) options.strict = true;
    if (!("parseAllBytes" in options)) options.parseAllBytes = true;
    if (!("decodeBitStrings" in options)) options.decodeBitStrings = true;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $dEd5p.util.createBuffer(bytes);
    var byteCount = bytes.length();
    var value = $671e5cded9a558d9$var$_fromDer(bytes, bytes.length(), 0, options);
    if (options.parseAllBytes && bytes.length() !== 0) {
        var error = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
        error.byteCount = byteCount;
        error.remaining = bytes.length();
        throw error;
    }
    return value;
};
/**
 * Internal function to parse an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the number of bytes remaining for this chunk.
 * @param depth the current parsing depth.
 * @param options object with same options as fromDer().
 *
 * @return the parsed asn1 object.
 */ function $671e5cded9a558d9$var$_fromDer(bytes, remaining, depth, options) {
    // temporary storage for consumption calculations
    var start;
    // minimum length for ASN.1 DER structure is 2
    $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, 2);
    // get the first byte
    var b1 = bytes.getByte();
    // consumed one byte
    remaining--;
    // get the tag class
    var tagClass = b1 & 0xC0;
    // get the type (bits 1-5)
    var type = b1 & 0x1F;
    // get the variable value length and adjust remaining bytes
    start = bytes.length();
    var length = $671e5cded9a558d9$var$_getValueLength(bytes, remaining);
    remaining -= start - bytes.length();
    // ensure there are enough bytes to get the value
    if (length !== undefined && length > remaining) {
        if (options.strict) {
            var error = new Error("Too few bytes to read ASN.1 value.");
            error.available = bytes.length();
            error.remaining = remaining;
            error.requested = length;
            throw error;
        }
        // Note: be lenient with truncated values and use remaining state bytes
        length = remaining;
    }
    // value storage
    var value;
    // possible BIT STRING contents storage
    var bitStringContents;
    // constructed flag is bit 6 (32 = 0x20) of the first byte
    var constructed = (b1 & 0x20) === 0x20;
    if (constructed) {
        // parse child asn1 objects from the value
        value = [];
        if (length === undefined) // asn1 object of indefinite length, read until end tag
        for(;;){
            $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, 2);
            if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
                bytes.getBytes(2);
                remaining -= 2;
                break;
            }
            start = bytes.length();
            value.push($671e5cded9a558d9$var$_fromDer(bytes, remaining, depth + 1, options));
            remaining -= start - bytes.length();
        }
        else // parsing asn1 object of definite length
        while(length > 0){
            start = bytes.length();
            value.push($671e5cded9a558d9$var$_fromDer(bytes, length, depth + 1, options));
            remaining -= start - bytes.length();
            length -= start - bytes.length();
        }
    }
    // if a BIT STRING, save the contents including padding
    if (value === undefined && tagClass === $671e5cded9a558d9$var$asn1.Class.UNIVERSAL && type === $671e5cded9a558d9$var$asn1.Type.BITSTRING) bitStringContents = bytes.bytes(length);
    // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.
    if (value === undefined && options.decodeBitStrings && tagClass === $671e5cded9a558d9$var$asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === $671e5cded9a558d9$var$asn1.Type.BITSTRING /*|| type === asn1.Type.OCTETSTRING*/  && length > 1) {
        // save read position
        var savedRead = bytes.read;
        var savedRemaining = remaining;
        var unused = 0;
        if (type === $671e5cded9a558d9$var$asn1.Type.BITSTRING) {
            /* The first octet gives the number of bits by which the length of the
        bit string is less than the next multiple of eight (this is called
        the "number of unused bits").

        The second and following octets give the value of the bit string
        converted to an octet string. */ $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, 1);
            unused = bytes.getByte();
            remaining--;
        }
        // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs
        if (unused === 0) try {
            // attempt to parse child asn1 object from the value
            // (stored in array to signal composed value)
            start = bytes.length();
            var subOptions = {
                // enforce strict mode to avoid parsing ASN.1 from plain data
                strict: true,
                decodeBitStrings: true
            };
            var composed = $671e5cded9a558d9$var$_fromDer(bytes, remaining, depth + 1, subOptions);
            var used = start - bytes.length();
            remaining -= used;
            if (type == $671e5cded9a558d9$var$asn1.Type.BITSTRING) used++;
            // if the data all decoded and the class indicates UNIVERSAL or
            // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object
            var tc = composed.tagClass;
            if (used === length && (tc === $671e5cded9a558d9$var$asn1.Class.UNIVERSAL || tc === $671e5cded9a558d9$var$asn1.Class.CONTEXT_SPECIFIC)) value = [
                composed
            ];
        } catch (ex) {}
        if (value === undefined) {
            // restore read position
            bytes.read = savedRead;
            remaining = savedRemaining;
        }
    }
    if (value === undefined) {
        // asn1 not constructed or composed, get raw value
        // TODO: do DER to OID conversion and vice-versa in .toDer?
        if (length === undefined) {
            if (options.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
            // be lenient and use remaining state bytes
            length = remaining;
        }
        if (type === $671e5cded9a558d9$var$asn1.Type.BMPSTRING) {
            value = "";
            for(; length > 0; length -= 2){
                $671e5cded9a558d9$var$_checkBufferLength(bytes, remaining, 2);
                value += String.fromCharCode(bytes.getInt16());
                remaining -= 2;
            }
        } else {
            value = bytes.getBytes(length);
            remaining -= length;
        }
    }
    // add BIT STRING contents if available
    var asn1Options = bitStringContents === undefined ? null : {
        bitStringContents: bitStringContents
    };
    // create and return asn1 object
    return $671e5cded9a558d9$var$asn1.create(tagClass, type, constructed, value, asn1Options);
}
/**
 * Converts the given asn1 object to a buffer of bytes in DER format.
 *
 * @param asn1 the asn1 object to convert to bytes.
 *
 * @return the buffer of bytes.
 */ $671e5cded9a558d9$var$asn1.toDer = function(obj) {
    var bytes = $dEd5p.util.createBuffer();
    // build the first byte
    var b1 = obj.tagClass | obj.type;
    // for storing the ASN.1 value
    var value = $dEd5p.util.createBuffer();
    // use BIT STRING contents if available and data not changed
    var useBitStringContents = false;
    if ("bitStringContents" in obj) {
        useBitStringContents = true;
        if (obj.original) useBitStringContents = $671e5cded9a558d9$var$asn1.equals(obj, obj.original);
    }
    if (useBitStringContents) value.putBytes(obj.bitStringContents);
    else if (obj.composed) {
        // if composed, use each child asn1 object's DER bytes as value
        // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
        // from other asn1 objects
        if (obj.constructed) b1 |= 0x20;
        else // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
        // add all of the child DER bytes together
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) value.putBuffer($671e5cded9a558d9$var$asn1.toDer(obj.value[i]));
    } else {
        // use asn1.value directly
        if (obj.type === $671e5cded9a558d9$var$asn1.Type.BMPSTRING) for(var i = 0; i < obj.value.length; ++i)value.putInt16(obj.value.charCodeAt(i));
        else // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === $671e5cded9a558d9$var$asn1.Type.INTEGER && obj.value.length > 1 && // leading 0x00 for positive integer
        (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) value.putBytes(obj.value.substr(1));
        else value.putBytes(obj.value);
    }
    // add tag byte
    bytes.putByte(b1);
    // use "short form" encoding
    if (value.length() <= 127) // one byte describes the length
    // bit 8 = 0 and bits 7-1 = length
    bytes.putByte(value.length() & 0x7F);
    else {
        // use "long form" encoding
        // 2 to 127 bytes describe the length
        // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
        // other bytes: length in base 256, big-endian
        var len = value.length();
        var lenBytes = "";
        do {
            lenBytes += String.fromCharCode(len & 0xFF);
            len = len >>> 8;
        }while (len > 0);
        // set first byte to # bytes used to store the length and turn on
        // bit 8 to indicate long-form length is used
        bytes.putByte(lenBytes.length | 0x80);
        // concatenate length bytes in reverse since they were generated
        // little endian and we need big endian
        for(var i = lenBytes.length - 1; i >= 0; --i)bytes.putByte(lenBytes.charCodeAt(i));
    }
    // concatenate value bytes
    bytes.putBuffer(value);
    return bytes;
};
/**
 * Converts an OID dot-separated string to a byte buffer. The byte buffer
 * contains only the DER-encoded value, not any tag or length bytes.
 *
 * @param oid the OID dot-separated string.
 *
 * @return the byte buffer.
 */ $671e5cded9a558d9$var$asn1.oidToDer = function(oid) {
    // split OID into individual values
    var values = oid.split(".");
    var bytes = $dEd5p.util.createBuffer();
    // first byte is 40 * value1 + value2
    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var last, valueBytes, value, b;
    for(var i = 2; i < values.length; ++i){
        // produce value bytes in reverse because we don't know how many
        // bytes it will take to store the value
        last = true;
        valueBytes = [];
        value = parseInt(values[i], 10);
        do {
            b = value & 0x7F;
            value = value >>> 7;
            // if value is not last, then turn on 8th bit
            if (!last) b |= 0x80;
            valueBytes.push(b);
            last = false;
        }while (value > 0);
        // add value bytes in reverse (needs to be in big endian)
        for(var n = valueBytes.length - 1; n >= 0; --n)bytes.putByte(valueBytes[n]);
    }
    return bytes;
};
/**
 * Converts a DER-encoded byte buffer to an OID dot-separated string. The
 * byte buffer should contain only the DER-encoded value, not any tag or
 * length bytes.
 *
 * @param bytes the byte buffer.
 *
 * @return the OID dot-separated string.
 */ $671e5cded9a558d9$var$asn1.derToOid = function(bytes) {
    var oid;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $dEd5p.util.createBuffer(bytes);
    // first byte is 40 * value1 + value2
    var b = bytes.getByte();
    oid = Math.floor(b / 40) + "." + b % 40;
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var value = 0;
    while(bytes.length() > 0){
        b = bytes.getByte();
        value = value << 7;
        // not the last byte for the value
        if (b & 0x80) value += b & 0x7F;
        else {
            // last byte
            oid += "." + (value + b);
            value = 0;
        }
    }
    return oid;
};
/**
 * Converts a UTCTime value to a date.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Parsing that structure hasn't been implemented yet.
 *
 * @param utc the UTCTime value to convert.
 *
 * @return the date.
 */ $671e5cded9a558d9$var$asn1.utcTimeToDate = function(utc) {
    /* The following formats can be used:

    YYMMDDhhmmZ
    YYMMDDhhmm+hh'mm'
    YYMMDDhhmm-hh'mm'
    YYMMDDhhmmssZ
    YYMMDDhhmmss+hh'mm'
    YYMMDDhhmmss-hh'mm'

    Where:

    YY is the least significant two digits of the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    // if YY >= 50 use 19xx, if YY < 50 use 20xx
    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0;
    // not just YYMMDDhhmmZ
    if (utc.length > 11) {
        // get character after minutes
        var c = utc.charAt(10);
        var end = 10;
        // see if seconds are present
        if (c !== "+" && c !== "-") {
            // get seconds
            ss = parseInt(utc.substr(10, 2), 10);
            end += 2;
        }
    }
    // update date
    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);
    if (end) {
        // get +/- after end of time
        c = utc.charAt(end);
        if (c === "+" || c === "-") {
            // get hours+minutes offset
            var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
            var mmoffset = parseInt(utc.substr(end + 4, 2), 10);
            // calculate offset in milliseconds
            var offset = hhoffset * 60 + mmoffset;
            offset *= 60000;
            // apply offset
            if (c === "+") date.setTime(+date - offset);
            else date.setTime(+date + offset);
        }
    }
    return date;
};
/**
 * Converts a GeneralizedTime value to a date.
 *
 * @param gentime the GeneralizedTime value to convert.
 *
 * @return the date.
 */ $671e5cded9a558d9$var$asn1.generalizedTimeToDate = function(gentime) {
    /* The following formats can be used:

    YYYYMMDDHHMMSS
    YYYYMMDDHHMMSS.fff
    YYYYMMDDHHMMSSZ
    YYYYMMDDHHMMSS.fffZ
    YYYYMMDDHHMMSS+hh'mm'
    YYYYMMDDHHMMSS.fff+hh'mm'
    YYYYMMDDHHMMSS-hh'mm'
    YYYYMMDDHHMMSS.fff-hh'mm'

    Where:

    YYYY is the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    .fff is the second fraction, accurate to three decimal places
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;
    if (gentime.charAt(gentime.length - 1) === "Z") isUTC = true;
    var end = gentime.length - 5, c = gentime.charAt(end);
    if (c === "+" || c === "-") {
        // get hours+minutes offset
        var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
        var mmoffset = parseInt(gentime.substr(end + 4, 2), 10);
        // calculate offset in milliseconds
        offset = hhoffset * 60 + mmoffset;
        offset *= 60000;
        // apply offset
        if (c === "+") offset *= -1;
        isUTC = true;
    }
    // check for second fraction
    if (gentime.charAt(14) === ".") fff = parseFloat(gentime.substr(14), 10) * 1000;
    if (isUTC) {
        date.setUTCFullYear(YYYY, MM, DD);
        date.setUTCHours(hh, mm, ss, fff);
        // apply offset
        date.setTime(+date + offset);
    } else {
        date.setFullYear(YYYY, MM, DD);
        date.setHours(hh, mm, ss, fff);
    }
    return date;
};
/**
 * Converts a date to a UTCTime value.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Converting to a GeneralizedTime hasn't been
 * implemented yet.
 *
 * @param date the date to convert.
 *
 * @return the UTCTime value.
 */ $671e5cded9a558d9$var$asn1.dateToUtcTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYMMDDhhmmssZ
    var format = [];
    format.push(("" + date.getUTCFullYear()).substr(2));
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a date to a GeneralizedTime value.
 *
 * @param date the date to convert.
 *
 * @return the GeneralizedTime value as a string.
 */ $671e5cded9a558d9$var$asn1.dateToGeneralizedTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYYYMMDDHHMMSSZ
    var format = [];
    format.push("" + date.getUTCFullYear());
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a javascript integer to a DER-encoded byte buffer to be used
 * as the value for an INTEGER type.
 *
 * @param x the integer.
 *
 * @return the byte buffer.
 */ $671e5cded9a558d9$var$asn1.integerToDer = function(x) {
    var rval = $dEd5p.util.createBuffer();
    if (x >= -128 && x < 0x80) return rval.putSignedInt(x, 8);
    if (x >= -32768 && x < 0x8000) return rval.putSignedInt(x, 16);
    if (x >= -8388608 && x < 0x800000) return rval.putSignedInt(x, 24);
    if (x >= -2147483648 && x < 0x80000000) return rval.putSignedInt(x, 32);
    var error = new Error("Integer too large; max is 32-bits.");
    error.integer = x;
    throw error;
};
/**
 * Converts a DER-encoded byte buffer to a javascript integer. This is
 * typically used to decode the value of an INTEGER type.
 *
 * @param bytes the byte buffer.
 *
 * @return the integer.
 */ $671e5cded9a558d9$var$asn1.derToInteger = function(bytes) {
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $dEd5p.util.createBuffer(bytes);
    var n = bytes.length() * 8;
    if (n > 32) throw new Error("Integer too large; max is 32-bits.");
    return bytes.getSignedInt(n);
};
/**
 * Validates that the given ASN.1 object is at least a super set of the
 * given ASN.1 structure. Only tag classes and types are checked. An
 * optional map may also be provided to capture ASN.1 values while the
 * structure is checked.
 *
 * To capture an ASN.1 value, set an object in the validator's 'capture'
 * parameter to the key to use in the capture map. To capture the full
 * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
 * the leading unused bits counter byte, specify 'captureBitStringContents'.
 * To capture BIT STRING bytes, without the leading unused bits counter byte,
 * specify 'captureBitStringValue'.
 *
 * Objects in the validator may set a field 'optional' to true to indicate
 * that it isn't necessary to pass validation.
 *
 * @param obj the ASN.1 object to validate.
 * @param v the ASN.1 structure validator.
 * @param capture an optional map to capture values in.
 * @param errors an optional array for storing validation errors.
 *
 * @return true on success, false on failure.
 */ $671e5cded9a558d9$var$asn1.validate = function(obj, v, capture, errors) {
    var rval = false;
    // ensure tag class and type are the same if specified
    if ((obj.tagClass === v.tagClass || typeof v.tagClass === "undefined") && (obj.type === v.type || typeof v.type === "undefined")) {
        // ensure constructed flag is the same if specified
        if (obj.constructed === v.constructed || typeof v.constructed === "undefined") {
            rval = true;
            // handle sub values
            if (v.value && $dEd5p.util.isArray(v.value)) {
                var j = 0;
                for(var i = 0; rval && i < v.value.length; ++i){
                    rval = v.value[i].optional || false;
                    if (obj.value[j]) {
                        rval = $671e5cded9a558d9$var$asn1.validate(obj.value[j], v.value[i], capture, errors);
                        if (rval) ++j;
                        else if (v.value[i].optional) rval = true;
                    }
                    if (!rval && errors) errors.push("[" + v.name + "] " + 'Tag class "' + v.tagClass + '", type "' + v.type + '" expected value length "' + v.value.length + '", got "' + obj.value.length + '"');
                }
            }
            if (rval && capture) {
                if (v.capture) capture[v.capture] = obj.value;
                if (v.captureAsn1) capture[v.captureAsn1] = obj;
                if (v.captureBitStringContents && "bitStringContents" in obj) capture[v.captureBitStringContents] = obj.bitStringContents;
                if (v.captureBitStringValue && "bitStringContents" in obj) {
                    var value;
                    if (obj.bitStringContents.length < 2) capture[v.captureBitStringValue] = "";
                    else {
                        // FIXME: support unused bits with data shifting
                        var unused = obj.bitStringContents.charCodeAt(0);
                        if (unused !== 0) throw new Error("captureBitStringValue only supported for zero unused bits");
                        capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
                    }
                }
            }
        } else if (errors) errors.push("[" + v.name + "] " + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
    } else if (errors) {
        if (obj.tagClass !== v.tagClass) errors.push("[" + v.name + "] " + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
        if (obj.type !== v.type) errors.push("[" + v.name + "] " + 'Expected type "' + v.type + '", got "' + obj.type + '"');
    }
    return rval;
};
// regex for testing for non-latin characters
var $671e5cded9a558d9$var$_nonLatinRegex = /[^\\u0000-\\u00ff]/;
/**
 * Pretty prints an ASN.1 object to a string.
 *
 * @param obj the object to write out.
 * @param level the level in the tree.
 * @param indentation the indentation to use.
 *
 * @return the string.
 */ $671e5cded9a558d9$var$asn1.prettyPrint = function(obj, level, indentation) {
    var rval = "";
    // set default level and indentation
    level = level || 0;
    indentation = indentation || 2;
    // start new line for deep levels
    if (level > 0) rval += "\n";
    // create indent
    var indent = "";
    for(var i = 0; i < level * indentation; ++i)indent += " ";
    // print class:type
    rval += indent + "Tag: ";
    switch(obj.tagClass){
        case $671e5cded9a558d9$var$asn1.Class.UNIVERSAL:
            rval += "Universal:";
            break;
        case $671e5cded9a558d9$var$asn1.Class.APPLICATION:
            rval += "Application:";
            break;
        case $671e5cded9a558d9$var$asn1.Class.CONTEXT_SPECIFIC:
            rval += "Context-Specific:";
            break;
        case $671e5cded9a558d9$var$asn1.Class.PRIVATE:
            rval += "Private:";
            break;
    }
    if (obj.tagClass === $671e5cded9a558d9$var$asn1.Class.UNIVERSAL) {
        rval += obj.type;
        // known types
        switch(obj.type){
            case $671e5cded9a558d9$var$asn1.Type.NONE:
                rval += " (None)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.BOOLEAN:
                rval += " (Boolean)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.INTEGER:
                rval += " (Integer)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.BITSTRING:
                rval += " (Bit string)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.OCTETSTRING:
                rval += " (Octet string)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.NULL:
                rval += " (Null)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.OID:
                rval += " (Object Identifier)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.ODESC:
                rval += " (Object Descriptor)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.EXTERNAL:
                rval += " (External or Instance of)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.REAL:
                rval += " (Real)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.ENUMERATED:
                rval += " (Enumerated)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.EMBEDDED:
                rval += " (Embedded PDV)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.UTF8:
                rval += " (UTF8)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.ROID:
                rval += " (Relative Object Identifier)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.SEQUENCE:
                rval += " (Sequence)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.SET:
                rval += " (Set)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.PRINTABLESTRING:
                rval += " (Printable String)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.IA5String:
                rval += " (IA5String (ASCII))";
                break;
            case $671e5cded9a558d9$var$asn1.Type.UTCTIME:
                rval += " (UTC time)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.GENERALIZEDTIME:
                rval += " (Generalized time)";
                break;
            case $671e5cded9a558d9$var$asn1.Type.BMPSTRING:
                rval += " (BMP String)";
                break;
        }
    } else rval += obj.type;
    rval += "\n";
    rval += indent + "Constructed: " + obj.constructed + "\n";
    if (obj.composed) {
        var subvalues = 0;
        var sub = "";
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) {
            subvalues += 1;
            sub += $671e5cded9a558d9$var$asn1.prettyPrint(obj.value[i], level + 1, indentation);
            if (i + 1 < obj.value.length) sub += ",";
        }
        rval += indent + "Sub values: " + subvalues + sub;
    } else {
        rval += indent + "Value: ";
        if (obj.type === $671e5cded9a558d9$var$asn1.Type.OID) {
            var oid = $671e5cded9a558d9$var$asn1.derToOid(obj.value);
            rval += oid;
            if ($dEd5p.pki && $dEd5p.pki.oids) {
                if (oid in $dEd5p.pki.oids) rval += " (" + $dEd5p.pki.oids[oid] + ") ";
            }
        }
        if (obj.type === $671e5cded9a558d9$var$asn1.Type.INTEGER) try {
            rval += $671e5cded9a558d9$var$asn1.derToInteger(obj.value);
        } catch (ex) {
            rval += "0x" + $dEd5p.util.bytesToHex(obj.value);
        }
        else if (obj.type === $671e5cded9a558d9$var$asn1.Type.BITSTRING) {
            // TODO: shift bits as needed to display without padding
            if (obj.value.length > 1) // remove unused bits field
            rval += "0x" + $dEd5p.util.bytesToHex(obj.value.slice(1));
            else rval += "(none)";
            // show unused bit count
            if (obj.value.length > 0) {
                var unused = obj.value.charCodeAt(0);
                if (unused == 1) rval += " (1 unused bit shown)";
                else if (unused > 1) rval += " (" + unused + " unused bits shown)";
            }
        } else if (obj.type === $671e5cded9a558d9$var$asn1.Type.OCTETSTRING) {
            if (!$671e5cded9a558d9$var$_nonLatinRegex.test(obj.value)) rval += "(" + obj.value + ") ";
            rval += "0x" + $dEd5p.util.bytesToHex(obj.value);
        } else if (obj.type === $671e5cded9a558d9$var$asn1.Type.UTF8) try {
            rval += $dEd5p.util.decodeUtf8(obj.value);
        } catch (e) {
            if (e.message === "URI malformed") rval += "0x" + $dEd5p.util.bytesToHex(obj.value) + " (malformed UTF8)";
            else throw e;
        }
        else if (obj.type === $671e5cded9a558d9$var$asn1.Type.PRINTABLESTRING || obj.type === $671e5cded9a558d9$var$asn1.Type.IA5String) rval += obj.value;
        else if ($671e5cded9a558d9$var$_nonLatinRegex.test(obj.value)) rval += "0x" + $dEd5p.util.bytesToHex(obj.value);
        else if (obj.value.length === 0) rval += "[null]";
        else rval += obj.value;
    }
    return rval;
};

});
parcelRegister("ggdRy", function(module, exports) {
/**
 * Object IDs for ASN.1.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
$dEd5p.pki = $dEd5p.pki || {};
var $bd68e4d8b5cf3bc6$var$oids = module.exports = $dEd5p.pki.oids = $dEd5p.oids = $dEd5p.oids || {};
// set id to name mapping and name to id mapping
function $bd68e4d8b5cf3bc6$var$_IN(id, name) {
    $bd68e4d8b5cf3bc6$var$oids[id] = name;
    $bd68e4d8b5cf3bc6$var$oids[name] = id;
}
// set id to name mapping only
function $bd68e4d8b5cf3bc6$var$_I_(id, name) {
    $bd68e4d8b5cf3bc6$var$oids[id] = name;
}
// algorithm OIDs
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.1", "rsaEncryption");
// Note: md2 & md4 not implemented
//_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
//_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.8", "mgf1");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.9", "pSpecified");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
// Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519
$bd68e4d8b5cf3bc6$var$_IN("1.3.101.112", "EdDSA25519");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.10040.4.3", "dsa-with-sha1");
$bd68e4d8b5cf3bc6$var$_IN("1.3.14.3.2.7", "desCBC");
$bd68e4d8b5cf3bc6$var$_IN("1.3.14.3.2.26", "sha1");
// Deprecated equivalent of sha1WithRSAEncryption
$bd68e4d8b5cf3bc6$var$_IN("1.3.14.3.2.29", "sha1WithRSASignature");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.1", "sha256");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.2", "sha384");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.3", "sha512");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.4", "sha224");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.5", "sha512-224");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.2.6", "sha512-256");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.2", "md2");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.5", "md5");
// pkcs#7 content types
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.1", "data");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.2", "signedData");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.3", "envelopedData");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.5", "digestedData");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.7.6", "encryptedData");
// pkcs#9 oids
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.1", "emailAddress");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.2", "unstructuredName");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.3", "contentType");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.4", "messageDigest");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.5", "signingTime");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.6", "counterSignature");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.7", "challengePassword");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.14", "extensionRequest");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.20", "friendlyName");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.21", "localKeyId");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
// pkcs#12 safe bags
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.3", "certBag");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
// password-based-encryption for pkcs#12
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
// hmac OIDs
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.7", "hmacWithSHA1");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.8", "hmacWithSHA224");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.9", "hmacWithSHA256");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.10", "hmacWithSHA384");
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.2.11", "hmacWithSHA512");
// symmetric key algorithm oids
$bd68e4d8b5cf3bc6$var$_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
// certificate issuer/subject OIDs
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.3", "commonName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.4", "surname");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.5", "serialNumber");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.6", "countryName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.7", "localityName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.8", "stateOrProvinceName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.9", "streetAddress");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.10", "organizationName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.11", "organizationalUnitName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.12", "title");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.13", "description");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.15", "businessCategory");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.17", "postalCode");
$bd68e4d8b5cf3bc6$var$_IN("2.5.4.42", "givenName");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
// X.509 extension OIDs
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.113730.1.1", "nsCertType");
$bd68e4d8b5cf3bc6$var$_IN("2.16.840.1.113730.1.13", "nsComment"); // deprecated in theory; still widely used
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.1", "authorityKeyIdentifier"); // deprecated, use .35
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.2", "keyAttributes"); // obsolete use .37 or .15
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.3", "certificatePolicies"); // deprecated, use .32
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.4", "keyUsageRestriction"); // obsolete use .37 or .15
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.5", "policyMapping"); // deprecated use .33
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.6", "subtreesConstraint"); // obsolete use .30
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.7", "subjectAltName"); // deprecated use .17
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.8", "issuerAltName"); // deprecated use .18
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.9", "subjectDirectoryAttributes");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.10", "basicConstraints"); // deprecated use .19
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.11", "nameConstraints"); // deprecated use .30
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.12", "policyConstraints"); // deprecated use .36
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.13", "basicConstraints"); // deprecated use .19
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.14", "subjectKeyIdentifier");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.15", "keyUsage");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.16", "privateKeyUsagePeriod");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.17", "subjectAltName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.18", "issuerAltName");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.19", "basicConstraints");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.20", "cRLNumber");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.21", "cRLReason");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.22", "expirationDate");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.23", "instructionCode");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.24", "invalidityDate");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.25", "cRLDistributionPoints"); // deprecated use .31
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.26", "issuingDistributionPoint"); // deprecated use .28
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.27", "deltaCRLIndicator");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.28", "issuingDistributionPoint");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.29", "certificateIssuer");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.30", "nameConstraints");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.31", "cRLDistributionPoints");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.32", "certificatePolicies");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.33", "policyMappings");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.34", "policyConstraints"); // deprecated use .36
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.35", "authorityKeyIdentifier");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.36", "policyConstraints");
$bd68e4d8b5cf3bc6$var$_IN("2.5.29.37", "extKeyUsage");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.46", "freshestCRL");
$bd68e4d8b5cf3bc6$var$_I_("2.5.29.54", "inhibitAnyPolicy");
// extKeyUsage purposes
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
$bd68e4d8b5cf3bc6$var$_IN("1.3.6.1.5.5.7.3.8", "timeStamping");

});


parcelRegister("aMLbo", function(module, exports) {
/**
 * Hash-based Message Authentication Code implementation. Requires a message
 * digest object that can be obtained, for example, from forge.md.sha1 or
 * forge.md.md5.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("jaAdc");
parcelRequire("kvSv3");
/* HMAC API */ var $7da2fc9470b5528b$var$hmac = module.exports = $dEd5p.hmac = $dEd5p.hmac || {};
/**
 * Creates an HMAC object that uses the given message digest object.
 *
 * @return an HMAC object.
 */ $7da2fc9470b5528b$var$hmac.create = function() {
    // the hmac key to use
    var _key = null;
    // the message digest to use
    var _md = null;
    // the inner padding
    var _ipadding = null;
    // the outer padding
    var _opadding = null;
    // hmac context
    var ctx = {};
    /**
   * Starts or restarts the HMAC with the given key and message digest.
   *
   * @param md the message digest to use, null to reuse the previous one,
   *           a string to use builtin 'sha1', 'md5', 'sha256'.
   * @param key the key to use as a string, array of bytes, byte buffer,
   *           or null to reuse the previous key.
   */ ctx.start = function(md, key) {
        if (md !== null) {
            if (typeof md === "string") {
                // create builtin message digest
                md = md.toLowerCase();
                if (md in $dEd5p.md.algorithms) _md = $dEd5p.md.algorithms[md].create();
                else throw new Error('Unknown hash algorithm "' + md + '"');
            } else // store message digest
            _md = md;
        }
        if (key === null) // reuse previous key
        key = _key;
        else {
            if (typeof key === "string") // convert string into byte buffer
            key = $dEd5p.util.createBuffer(key);
            else if ($dEd5p.util.isArray(key)) {
                // convert byte array into byte buffer
                var tmp = key;
                key = $dEd5p.util.createBuffer();
                for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
            }
            // if key is longer than blocksize, hash it
            var keylen = key.length();
            if (keylen > _md.blockLength) {
                _md.start();
                _md.update(key.bytes());
                key = _md.digest();
            }
            // mix key into inner and outer padding
            // ipadding = [0x36 * blocksize] ^ key
            // opadding = [0x5C * blocksize] ^ key
            _ipadding = $dEd5p.util.createBuffer();
            _opadding = $dEd5p.util.createBuffer();
            keylen = key.length();
            for(var i = 0; i < keylen; ++i){
                var tmp = key.at(i);
                _ipadding.putByte(0x36 ^ tmp);
                _opadding.putByte(0x5C ^ tmp);
            }
            // if key is shorter than blocksize, add additional padding
            if (keylen < _md.blockLength) {
                var tmp = _md.blockLength - keylen;
                for(var i = 0; i < tmp; ++i){
                    _ipadding.putByte(0x36);
                    _opadding.putByte(0x5C);
                }
            }
            _key = key;
            _ipadding = _ipadding.bytes();
            _opadding = _opadding.bytes();
        }
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // prepare to do inner hash
        // hash(ipadding | message)
        _md.start();
        _md.update(_ipadding);
    };
    /**
   * Updates the HMAC with the given message bytes.
   *
   * @param bytes the bytes to update with.
   */ ctx.update = function(bytes) {
        _md.update(bytes);
    };
    /**
   * Produces the Message Authentication Code (MAC).
   *
   * @return a byte buffer containing the digest value.
   */ ctx.getMac = function() {
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // here we do the outer hashing
        var inner = _md.digest().bytes();
        _md.start();
        _md.update(_opadding);
        _md.update(inner);
        return _md.digest();
    };
    // alias for getMac
    ctx.digest = ctx.getMac;
    return ctx;
};

});
parcelRegister("jaAdc", function(module, exports) {
/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
module.exports = $dEd5p.md = $dEd5p.md || {};
$dEd5p.md.algorithms = $dEd5p.md.algorithms || {};

});


parcelRegister("8yafv", function(module, exports) {
/**
 * Javascript implementation of mask generation function MGF1.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
$dEd5p.mgf = $dEd5p.mgf || {};
var $639972f698cacfd2$var$mgf1 = module.exports = $dEd5p.mgf.mgf1 = $dEd5p.mgf1 = $dEd5p.mgf1 || {};
/**
 * Creates a MGF1 mask generation function object.
 *
 * @param md the message digest API to use (eg: forge.md.sha1.create()).
 *
 * @return a mask generation function object.
 */ $639972f698cacfd2$var$mgf1.create = function(md) {
    var mgf = {
        /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */ generate: function(seed, maskLen) {
            /* 2. Let T be the empty octet string. */ var t = new $dEd5p.util.ByteBuffer();
            /* 3. For counter from 0 to ceil(maskLen / hLen), do the following: */ var len = Math.ceil(maskLen / md.digestLength);
            for(var i = 0; i < len; i++){
                /* a. Convert counter to an octet string C of length 4 octets */ var c = new $dEd5p.util.ByteBuffer();
                c.putInt32(i);
                /* b. Concatenate the hash of the seed mgfSeed and C to the octet
         * string T: */ md.start();
                md.update(seed + c.getBytes());
                t.putBuffer(md.digest());
            }
            /* Output the leading maskLen octets of T as the octet string mask. */ t.truncate(t.length() - maskLen);
            return t.getBytes();
        }
    };
    return mgf;
};

});

parcelRegister("9Lx2j", function(module, exports) {
/**
 * Password-Based Key-Derivation Function #2 implementation.
 *
 * See RFC 2898 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $kjyEk = parcelRequire("kjyEk");
var $71c2212fa31b6011$require$Buffer = $kjyEk.Buffer;

var $dEd5p = parcelRequire("dEd5p");
parcelRequire("aMLbo");
parcelRequire("jaAdc");
parcelRequire("kvSv3");
var $71c2212fa31b6011$var$pkcs5 = $dEd5p.pkcs5 = $dEd5p.pkcs5 || {};
var $71c2212fa31b6011$var$crypto;

if ($dEd5p.util.isNodejs && !$dEd5p.options.usePureJavaScript) $71c2212fa31b6011$var$crypto = (parcelRequire("kjyEk"));
/**
 * Derives a key from a password.
 *
 * @param p the password as a binary-encoded string of bytes.
 * @param s the salt as a binary-encoded string of bytes.
 * @param c the iteration count, a positive integer.
 * @param dkLen the intended length, in bytes, of the derived key,
 *          (max: 2^32 - 1) * hash length of the PRF.
 * @param [md] the message digest (or algorithm identifier as a string) to use
 *          in the PRF, defaults to SHA-1.
 * @param [callback(err, key)] presence triggers asynchronous version, called
 *          once the operation completes.
 *
 * @return the derived key, as a binary-encoded string of bytes, for the
 *           synchronous version (if no callback is specified).
 */ module.exports = $dEd5p.pbkdf2 = $71c2212fa31b6011$var$pkcs5.pbkdf2 = function(p, s, c, dkLen, md, callback) {
    if (typeof md === "function") {
        callback = md;
        md = null;
    }
    // use native implementation if possible and not disabled, note that
    // some node versions only support SHA-1, others allow digest to be changed
    if ($dEd5p.util.isNodejs && !$dEd5p.options.usePureJavaScript && $71c2212fa31b6011$var$crypto.pbkdf2 && (md === null || typeof md !== "object") && ($71c2212fa31b6011$var$crypto.pbkdf2Sync.length > 4 || !md || md === "sha1")) {
        if (typeof md !== "string") // default prf to SHA-1
        md = "sha1";
        p = $71c2212fa31b6011$require$Buffer.from(p, "binary");
        s = $71c2212fa31b6011$require$Buffer.from(s, "binary");
        if (!callback) {
            if ($71c2212fa31b6011$var$crypto.pbkdf2Sync.length === 4) return $71c2212fa31b6011$var$crypto.pbkdf2Sync(p, s, c, dkLen).toString("binary");
            return $71c2212fa31b6011$var$crypto.pbkdf2Sync(p, s, c, dkLen, md).toString("binary");
        }
        if ($71c2212fa31b6011$var$crypto.pbkdf2Sync.length === 4) return $71c2212fa31b6011$var$crypto.pbkdf2(p, s, c, dkLen, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
        return $71c2212fa31b6011$var$crypto.pbkdf2(p, s, c, dkLen, md, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
    }
    if (typeof md === "undefined" || md === null) // default prf to SHA-1
    md = "sha1";
    if (typeof md === "string") {
        if (!(md in $dEd5p.md.algorithms)) throw new Error("Unknown hash algorithm: " + md);
        md = $dEd5p.md[md].create();
    }
    var hLen = md.digestLength;
    /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
    stop. */ if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error("Derived key is too long.");
        if (callback) return callback(err);
        throw err;
    }
    /* 2. Let len be the number of hLen-octet blocks in the derived key,
    rounding up, and let r be the number of octets in the last
    block:

    len = CEIL(dkLen / hLen),
    r = dkLen - (len - 1) * hLen. */ var len = Math.ceil(dkLen / hLen);
    var r = dkLen - (len - 1) * hLen;
    /* 3. For each block of the derived key apply the function F defined
    below to the password P, the salt S, the iteration count c, and
    the block index to compute the block:

    T_1 = F(P, S, c, 1),
    T_2 = F(P, S, c, 2),
    ...
    T_len = F(P, S, c, len),

    where the function F is defined as the exclusive-or sum of the
    first c iterates of the underlying pseudorandom function PRF
    applied to the password P and the concatenation of the salt S
    and the block index i:

    F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c

    where

    u_1 = PRF(P, S || INT(i)),
    u_2 = PRF(P, u_1),
    ...
    u_c = PRF(P, u_{c-1}).

    Here, INT(i) is a four-octet encoding of the integer i, most
    significant octet first. */ var prf = $dEd5p.hmac.create();
    prf.start(md, p);
    var dk = "";
    var xor, u_c, u_c1;
    // sync version
    if (!callback) {
        for(var i = 1; i <= len; ++i){
            // PRF(P, S || INT(i)) (first iteration)
            prf.start(null, null);
            prf.update(s);
            prf.update($dEd5p.util.int32ToBytes(i));
            xor = u_c1 = prf.digest().getBytes();
            // PRF(P, u_{c-1}) (other iterations)
            for(var j = 2; j <= c; ++j){
                prf.start(null, null);
                prf.update(u_c1);
                u_c = prf.digest().getBytes();
                // F(p, s, c, i)
                xor = $dEd5p.util.xorBytes(xor, u_c, hLen);
                u_c1 = u_c;
            }
            /* 4. Concatenate the blocks and extract the first dkLen octets to
        produce a derived key DK:

        DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */ return dk;
    }
    // async version
    var i = 1, j;
    function outer() {
        if (i > len) // done
        return callback(null, dk);
        // PRF(P, S || INT(i)) (first iteration)
        prf.start(null, null);
        prf.update(s);
        prf.update($dEd5p.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes();
        // PRF(P, u_{c-1}) (other iterations)
        j = 2;
        inner();
    }
    function inner() {
        if (j <= c) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes();
            // F(p, s, c, i)
            xor = $dEd5p.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
            ++j;
            return $dEd5p.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
      produce a derived key DK:

      DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
    }
    outer();
};

});

parcelRegister("fYcEB", function(module, exports) {
/**
 * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
 *
 * See: RFC 1421.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 *
 * A Forge PEM object has the following fields:
 *
 * type: identifies the type of message (eg: "RSA PRIVATE KEY").
 *
 * procType: identifies the type of processing performed on the message,
 *   it has two subfields: version and type, eg: 4,ENCRYPTED.
 *
 * contentDomain: identifies the type of content in the message, typically
 *   only uses the value: "RFC822".
 *
 * dekInfo: identifies the message encryption algorithm and mode and includes
 *   any parameters for the algorithm, it has two subfields: algorithm and
 *   parameters, eg: DES-CBC,F8143EDE5960C597.
 *
 * headers: contains all other PEM encapsulated headers -- where order is
 *   significant (for pairing data like recipient ID + key info).
 *
 * body: the binary-encoded body.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
// shortcut for pem API
var $ba06466b5c748d08$var$pem = module.exports = $dEd5p.pem = $dEd5p.pem || {};
/**
 * Encodes (serializes) the given PEM object.
 *
 * @param msg the PEM message object to encode.
 * @param options the options to use:
 *          maxline the maximum characters per line for the body, (default: 64).
 *
 * @return the PEM-formatted string.
 */ $ba06466b5c748d08$var$pem.encode = function(msg, options) {
    options = options || {};
    var rval = "-----BEGIN " + msg.type + "-----\r\n";
    // encode special headers
    var header;
    if (msg.procType) {
        header = {
            name: "Proc-Type",
            values: [
                String(msg.procType.version),
                msg.procType.type
            ]
        };
        rval += $ba06466b5c748d08$var$foldHeader(header);
    }
    if (msg.contentDomain) {
        header = {
            name: "Content-Domain",
            values: [
                msg.contentDomain
            ]
        };
        rval += $ba06466b5c748d08$var$foldHeader(header);
    }
    if (msg.dekInfo) {
        header = {
            name: "DEK-Info",
            values: [
                msg.dekInfo.algorithm
            ]
        };
        if (msg.dekInfo.parameters) header.values.push(msg.dekInfo.parameters);
        rval += $ba06466b5c748d08$var$foldHeader(header);
    }
    if (msg.headers) // encode all other headers
    for(var i = 0; i < msg.headers.length; ++i)rval += $ba06466b5c748d08$var$foldHeader(msg.headers[i]);
    // terminate header
    if (msg.procType) rval += "\r\n";
    // add body
    rval += $dEd5p.util.encode64(msg.body, options.maxline || 64) + "\r\n";
    rval += "-----END " + msg.type + "-----\r\n";
    return rval;
};
/**
 * Decodes (deserializes) all PEM messages found in the given string.
 *
 * @param str the PEM-formatted string to decode.
 *
 * @return the PEM message objects in an array.
 */ $ba06466b5c748d08$var$pem.decode = function(str) {
    var rval = [];
    // split string into PEM messages (be lenient w/EOF on BEGIN line)
    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;
    while(true){
        match = rMessage.exec(str);
        if (!match) break;
        // accept "NEW CERTIFICATE REQUEST" as "CERTIFICATE REQUEST"
        // https://datatracker.ietf.org/doc/html/rfc7468#section-7
        var type = match[1];
        if (type === "NEW CERTIFICATE REQUEST") type = "CERTIFICATE REQUEST";
        var msg = {
            type: type,
            procType: null,
            contentDomain: null,
            dekInfo: null,
            headers: [],
            body: $dEd5p.util.decode64(match[3])
        };
        rval.push(msg);
        // no headers
        if (!match[2]) continue;
        // parse headers
        var lines = match[2].split(rCRLF);
        var li = 0;
        while(match && li < lines.length){
            // get line, trim any rhs whitespace
            var line = lines[li].replace(/\s+$/, "");
            // RFC2822 unfold any following folded lines
            for(var nl = li + 1; nl < lines.length; ++nl){
                var next = lines[nl];
                if (!/\s/.test(next[0])) break;
                line += next;
                li = nl;
            }
            // parse header
            match = line.match(rHeader);
            if (match) {
                var header = {
                    name: match[1],
                    values: []
                };
                var values = match[2].split(",");
                for(var vi = 0; vi < values.length; ++vi)header.values.push($ba06466b5c748d08$var$ltrim(values[vi]));
                // Proc-Type must be the first header
                if (!msg.procType) {
                    if (header.name !== "Proc-Type") throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                    else if (header.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                    msg.procType = {
                        version: values[0],
                        type: values[1]
                    };
                } else if (!msg.contentDomain && header.name === "Content-Domain") // special-case Content-Domain
                msg.contentDomain = values[0] || "";
                else if (!msg.dekInfo && header.name === "DEK-Info") {
                    // special-case DEK-Info
                    if (header.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    msg.dekInfo = {
                        algorithm: values[0],
                        parameters: values[1] || null
                    };
                } else msg.headers.push(header);
            }
            ++li;
        }
        if (msg.procType === "ENCRYPTED" && !msg.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
    if (rval.length === 0) throw new Error("Invalid PEM formatted message.");
    return rval;
};
function $ba06466b5c748d08$var$foldHeader(header) {
    var rval = header.name + ": ";
    // ensure values with CRLF are folded
    var values = [];
    var insertSpace = function(match, $1) {
        return " " + $1;
    };
    for(var i = 0; i < header.values.length; ++i)values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    rval += values.join(",") + "\r\n";
    // do folding
    var length = 0;
    var candidate = -1;
    for(var i = 0; i < rval.length; ++i, ++length){
        if (length > 65 && candidate !== -1) {
            var insert = rval[candidate];
            if (insert === ",") {
                ++candidate;
                rval = rval.substr(0, candidate) + "\r\n " + rval.substr(candidate);
            } else rval = rval.substr(0, candidate) + "\r\n" + insert + rval.substr(candidate + 1);
            length = i - candidate - 1;
            candidate = -1;
            ++i;
        } else if (rval[i] === " " || rval[i] === "	" || rval[i] === ",") candidate = i;
    }
    return rval;
}
function $ba06466b5c748d08$var$ltrim(str) {
    return str.replace(/^\s+/, "");
}

});

parcelRegister("gDTs5", function(module, exports) {
/**
 * Partial implementation of PKCS#1 v2.2: RSA-OEAP
 *
 * Modified but based on the following MIT and BSD licensed code:
 *
 * https://github.com/kjur/jsjws/blob/master/rsa.js:
 *
 * The 'jsjws'(JSON Web Signature JavaScript Library) License
 *
 * Copyright (c) 2012 Kenji Urushima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
 *
 * RSAES-OAEP.js
 * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
 * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
 * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
 * Contact: ellis@nukinetics.com
 * Distributed under the BSD License.
 *
 * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
 *
 * @author Evan Jones (http://evanjones.ca/)
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
parcelRequire("4N8iP");
parcelRequire("dggUt");
// shortcut for PKCS#1 API
var $c1db4d77417c6cc6$var$pkcs1 = module.exports = $dEd5p.pkcs1 = $dEd5p.pkcs1 || {};
/**
 * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
 * and seed.
 *
 * This method does not perform RSA encryption, it only encodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param message the message to encode.
 * @param options the options to use:
 *          label an optional label to use.
 *          seed the seed to use.
 *          md the message digest object to use, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the encoded message bytes.
 */ $c1db4d77417c6cc6$var$pkcs1.encode_rsa_oaep = function(key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md;
    // legacy args (label, seed, md)
    if (typeof options === "string") {
        label = options;
        seed = arguments[3] || undefined;
        md = arguments[4] || undefined;
    } else if (options) {
        label = options.label || undefined;
        seed = options.seed || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // default OAEP to SHA-1 message digest
    if (!md) md = $dEd5p.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    // compute length in bytes and check output
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;
    if (message.length > maxLength) {
        var error = new Error("RSAES-OAEP input message length is too long.");
        error.length = message.length;
        error.maxLength = maxLength;
        throw error;
    }
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest();
    var PS = "";
    var PS_length = maxLength - message.length;
    for(var i = 0; i < PS_length; i++)PS += "\x00";
    var DB = lHash.getBytes() + PS + "\x01" + message;
    if (!seed) seed = $dEd5p.random.getBytes(md.digestLength);
    else if (seed.length !== md.digestLength) {
        var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
        error.seedLength = seed.length;
        error.digestLength = md.digestLength;
        throw error;
    }
    var dbMask = $c1db4d77417c6cc6$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = $dEd5p.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = $c1db4d77417c6cc6$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = $dEd5p.util.xorBytes(seed, seedMask, seed.length);
    // return encoded message
    return "\x00" + maskedSeed + maskedDB;
};
/**
 * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
 * label (L).
 *
 * This method does not perform RSA decryption, it only decodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param em the encoded message to decode.
 * @param options the options to use:
 *          label an optional label to use.
 *          md the message digest object to use for OAEP, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the decoded message bytes.
 */ $c1db4d77417c6cc6$var$pkcs1.decode_rsa_oaep = function(key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md;
    // legacy args
    if (typeof options === "string") {
        label = options;
        md = arguments[3] || undefined;
    } else if (options) {
        label = options.label || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // compute length in bytes
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    if (em.length !== keyLength) {
        var error = new Error("RSAES-OAEP encoded message length is invalid.");
        error.length = em.length;
        error.expectedLength = keyLength;
        throw error;
    }
    // default OAEP to SHA-1 message digest
    if (md === undefined) md = $dEd5p.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    if (keyLength < 2 * md.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest().getBytes();
    // split the message into its parts
    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = $c1db4d77417c6cc6$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = $dEd5p.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = $c1db4d77417c6cc6$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = $dEd5p.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength);
    // constant time check that all values match what is expected
    var error = y !== "\x00";
    // constant time check lHash vs lHashPrime
    for(var i = 0; i < md.digestLength; ++i)error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?
    var in_ps = 1;
    var index = md.digestLength;
    for(var j = md.digestLength; j < db.length; j++){
        var code = db.charCodeAt(j);
        var is_0 = code & 0x1 ^ 0x1;
        // non-zero if not 0 or 1 in the ps section
        var error_mask = in_ps ? 0xfffe : 0x0000;
        error |= code & error_mask;
        // latch in_ps to zero after we find 0x1
        in_ps = in_ps & is_0;
        index += in_ps;
    }
    if (error || db.charCodeAt(index) !== 0x1) throw new Error("Invalid RSAES-OAEP padding.");
    return db.substring(index + 1);
};
function $c1db4d77417c6cc6$var$rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) hash = $dEd5p.md.sha1.create();
    var t = "";
    var count = Math.ceil(maskLength / hash.digestLength);
    for(var i = 0; i < count; ++i){
        var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
        hash.start();
        hash.update(seed + c);
        t += hash.digest().getBytes();
    }
    return t.substring(0, maskLength);
}

});
parcelRegister("4N8iP", function(module, exports) {
/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("7vq5X");
parcelRequire("guEzu");
parcelRequire("eZJY9");
parcelRequire("kvSv3");
(function() {
    // forge.random already defined
    if ($dEd5p.random && $dEd5p.random.getBytes) {
        module.exports = $dEd5p.random;
        return;
    }
    (function(jQuery1) {
        // the default prng plugin, uses AES-128
        var prng_aes = {};
        var _prng_aes_output = new Array(4);
        var _prng_aes_buffer = $dEd5p.util.createBuffer();
        prng_aes.formatKey = function(key) {
            // convert the key into 32-bit integers
            var tmp = $dEd5p.util.createBuffer(key);
            key = new Array(4);
            key[0] = tmp.getInt32();
            key[1] = tmp.getInt32();
            key[2] = tmp.getInt32();
            key[3] = tmp.getInt32();
            // return the expanded key
            return $dEd5p.aes._expandKey(key, false);
        };
        prng_aes.formatSeed = function(seed) {
            // convert seed into 32-bit integers
            var tmp = $dEd5p.util.createBuffer(seed);
            seed = new Array(4);
            seed[0] = tmp.getInt32();
            seed[1] = tmp.getInt32();
            seed[2] = tmp.getInt32();
            seed[3] = tmp.getInt32();
            return seed;
        };
        prng_aes.cipher = function(key, seed) {
            $dEd5p.aes._updateBlock(key, seed, _prng_aes_output, false);
            _prng_aes_buffer.putInt32(_prng_aes_output[0]);
            _prng_aes_buffer.putInt32(_prng_aes_output[1]);
            _prng_aes_buffer.putInt32(_prng_aes_output[2]);
            _prng_aes_buffer.putInt32(_prng_aes_output[3]);
            return _prng_aes_buffer.getBytes();
        };
        prng_aes.increment = function(seed) {
            // FIXME: do we care about carry or signed issues?
            ++seed[3];
            return seed;
        };
        prng_aes.md = $dEd5p.md.sha256;
        /**
 * Creates a new PRNG.
 */ function spawnPrng() {
            var ctx = $dEd5p.prng.create(prng_aes);
            /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */ ctx.getBytes = function(count, callback) {
                return ctx.generate(count, callback);
            };
            /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */ ctx.getBytesSync = function(count) {
                return ctx.generate(count);
            };
            return ctx;
        }
        // create default prng context
        var _ctx = spawnPrng();
        // add other sources of entropy only if window.crypto.getRandomValues is not
        // available -- otherwise this source will be automatically used by the prng
        var getRandomValues = null;
        var globalScope = $dEd5p.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        if ($dEd5p.options.usePureJavaScript || !$dEd5p.util.isNodejs && !getRandomValues) {
            // if this is a web worker, do not use weak entropy, instead register to
            // receive strong entropy asynchronously from the main thread
            typeof window === "undefined" || window.document;
            // get load time entropy
            _ctx.collectInt(+new Date(), 32);
            // add some entropy from navigator object
            if (typeof navigator !== "undefined") {
                var _navBytes = "";
                for(var key in navigator)try {
                    if (typeof navigator[key] == "string") _navBytes += navigator[key];
                } catch (e) {
                /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */ }
                _ctx.collect(_navBytes);
                _navBytes = null;
            }
            // add mouse and keyboard collectors if jquery is available
            if (jQuery1) {
                // set up mouse entropy capture
                jQuery1().mousemove(function(e) {
                    // add mouse coords
                    _ctx.collectInt(e.clientX, 16);
                    _ctx.collectInt(e.clientY, 16);
                });
                // set up keyboard entropy capture
                jQuery1().keypress(function(e) {
                    _ctx.collectInt(e.charCode, 8);
                });
            }
        }
        /* Random API */ if (!$dEd5p.random) $dEd5p.random = _ctx;
        else // extend forge.random with _ctx
        for(var key in _ctx)$dEd5p.random[key] = _ctx[key];
        // expose spawn PRNG
        $dEd5p.random.createInstance = spawnPrng;
        module.exports = $dEd5p.random;
    })(typeof jQuery !== "undefined" ? jQuery : null);
})();

});
parcelRegister("guEzu", function(module, exports) {
/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("jaAdc");
parcelRequire("kvSv3");
var $c01eeb4c4987f8e3$var$sha256 = module.exports = $dEd5p.sha256 = $dEd5p.sha256 || {};
$dEd5p.md.sha256 = $dEd5p.md.algorithms.sha256 = $c01eeb4c4987f8e3$var$sha256;
/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */ $c01eeb4c4987f8e3$var$sha256.create = function() {
    // do initialization as necessary
    if (!$c01eeb4c4987f8e3$var$_initialized) $c01eeb4c4987f8e3$var$_init();
    // SHA-256 state contains eight 32-bit integers
    var _state = null;
    // input buffer
    var _input = $dEd5p.util.createBuffer();
    // used for word storage
    var _w = new Array(64);
    // message digest object
    var md = {
        algorithm: "sha256",
        blockLength: 64,
        digestLength: 32,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $dEd5p.util.createBuffer();
        _state = {
            h0: 0x6A09E667,
            h1: 0xBB67AE85,
            h2: 0x3C6EF372,
            h3: 0xA54FF53A,
            h4: 0x510E527F,
            h5: 0x9B05688C,
            h6: 0x1F83D9AB,
            h7: 0x5BE0CD19
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $dEd5p.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $c01eeb4c4987f8e3$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $dEd5p.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($c01eeb4c4987f8e3$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4,
            h5: _state.h5,
            h6: _state.h6,
            h7: _state.h7
        };
        $c01eeb4c4987f8e3$var$_update(s2, _w, finalBlock);
        var rval = $dEd5p.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        rval.putInt32(s2.h5);
        rval.putInt32(s2.h6);
        rval.putInt32(s2.h7);
        return rval;
    };
    return md;
};
// sha-256 padding bytes not initialized yet
var $c01eeb4c4987f8e3$var$_padding = null;
var $c01eeb4c4987f8e3$var$_initialized = false;
// table of constants
var $c01eeb4c4987f8e3$var$_k = null;
/**
 * Initializes the constant tables.
 */ function $c01eeb4c4987f8e3$var$_init() {
    // create padding
    $c01eeb4c4987f8e3$var$_padding = String.fromCharCode(128);
    $c01eeb4c4987f8e3$var$_padding += $dEd5p.util.fillString(String.fromCharCode(0x00), 64);
    // create K table for SHA-256
    $c01eeb4c4987f8e3$var$_k = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    // now initialized
    $c01eeb4c4987f8e3$var$_initialized = true;
}
/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $c01eeb4c4987f8e3$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 64 32-bit words according to SHA-256
        for(i = 0; i < 16; ++i)w[i] = bytes.getInt32();
        for(; i < 64; ++i){
            // XOR word 2 words ago rot right 17, rot right 19, shft right 10
            t1 = w[i - 2];
            t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            // XOR word 15 words ago rot right 7, rot right 18, shft right 3
            t2 = w[i - 15];
            t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
            w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
        }
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        f = s.h5;
        g = s.h6;
        h = s.h7;
        // round function
        for(i = 0; i < 64; ++i){
            // Sum1(e)
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch = g ^ e & (f ^ g);
            // Sum0(a)
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj = a & b | c & (a ^ b);
            // main algorithm
            t1 = h + s1 + ch + $c01eeb4c4987f8e3$var$_k[i] + w[i];
            t2 = s0 + maj;
            h = g;
            g = f;
            f = e;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            e = d + t1 >>> 0;
            d = c;
            c = b;
            b = a;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            a = t1 + t2 >>> 0;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        s.h5 = s.h5 + f | 0;
        s.h6 = s.h6 + g | 0;
        s.h7 = s.h7 + h | 0;
        len -= 64;
    }
}

});

parcelRegister("eZJY9", function(module, exports) {
/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $kjyEk = parcelRequire("kjyEk");

var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
var $aeaa6bb5548c31c8$var$_crypto = null;

if ($dEd5p.util.isNodejs && !$dEd5p.options.usePureJavaScript && !$kjyEk.versions["node-webkit"]) $aeaa6bb5548c31c8$var$_crypto = (parcelRequire("kjyEk"));
/* PRNG API */ var $aeaa6bb5548c31c8$var$prng = module.exports = $dEd5p.prng = $dEd5p.prng || {};
/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */ $aeaa6bb5548c31c8$var$prng.create = function(plugin) {
    var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ""
    };
    // create 32 entropy pools (each is a message digest)
    var md = plugin.md;
    var pools = new Array(32);
    for(var i = 0; i < 32; ++i)pools[i] = md.create();
    ctx.pools = pools;
    // entropy pools are written to cyclically, starting at index 0
    ctx.pool = 0;
    /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */ ctx.generate = function(count, callback) {
        // do synchronously
        if (!callback) return ctx.generateSync(count);
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = $dEd5p.util.createBuffer();
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call
        ctx.key = null;
        generate();
        function generate(err) {
            if (err) return callback(err);
            // sufficient bytes generated
            if (b.length() >= count) return callback(null, b.getBytes(count));
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) // prevent stack overflow
            return $dEd5p.util.nextTick(function() {
                _reseed(generate);
            });
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
            $dEd5p.util.setImmediate(generate);
        }
    };
    /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */ ctx.generateSync = function(count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call
        ctx.key = null;
        var b = $dEd5p.util.createBuffer();
        while(b.length() < count){
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) _reseedSync();
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }
        return b.getBytes(count);
    };
    /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */ function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
            _seed();
            return callback();
        }
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function(err, bytes) {
            if (err) return callback(err);
            ctx.collect(bytes);
            _seed();
            callback();
        });
    }
    /**
   * Private function that synchronously reseeds a generator.
   */ function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) return _seed();
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));
        _seed();
    }
    /**
   * Private function that seeds a generator once enough bytes are available.
   */ function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1;
        // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest
        var md = ctx.plugin.md.create();
        // consume current key bytes
        md.update(ctx.keyBytes);
        // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds
        var _2powK = 1;
        for(var k = 0; k < 32; ++k){
            if (ctx.reseeds % _2powK === 0) {
                md.update(ctx.pools[k].digest().getBytes());
                ctx.pools[k].start();
            }
            _2powK = _2powK << 1;
        }
        // get digest for key bytes
        ctx.keyBytes = md.digest().getBytes();
        // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it
        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes();
        // update state
        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
    }
    /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */ function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;
        var globalScope = $dEd5p.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        var b = $dEd5p.util.createBuffer();
        if (getRandomValues) while(b.length() < needed){
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));
            try {
                getRandomValues(entropy);
                for(var i = 0; i < entropy.length; ++i)b.putInt32(entropy[i]);
            } catch (e) {
                /* only ignore QuotaExceededError */ if (!(typeof QuotaExceededError !== "undefined" && e instanceof QuotaExceededError)) throw e;
            }
        }
        // be sad and add some weak random data
        if (b.length() < needed) {
            /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */ var hi, lo, next;
            var seed = Math.floor(Math.random() * 0x010000);
            while(b.length() < needed){
                lo = 16807 * (seed & 0xFFFF);
                hi = 16807 * (seed >> 16);
                lo += (hi & 0x7FFF) << 16;
                lo += hi >> 15;
                lo = (lo & 0x7FFFFFFF) + (lo >> 31);
                seed = lo & 0xFFFFFFFF;
                // consume lower 3 bytes of seed
                for(var i = 0; i < 3; ++i){
                    // throw in more pseudo random
                    next = seed >>> (i << 3);
                    next ^= Math.floor(Math.random() * 0x0100);
                    b.putByte(next & 0xFF);
                }
            }
        }
        return b.getBytes(needed);
    }
    // initialize seed file APIs
    if ($aeaa6bb5548c31c8$var$_crypto) {
        // use nodejs async API
        ctx.seedFile = function(needed, callback) {
            $aeaa6bb5548c31c8$var$_crypto.randomBytes(needed, function(err, bytes) {
                if (err) return callback(err);
                callback(null, bytes.toString());
            });
        };
        // use nodejs sync API
        ctx.seedFileSync = function(needed) {
            return $aeaa6bb5548c31c8$var$_crypto.randomBytes(needed).toString();
        };
    } else {
        ctx.seedFile = function(needed, callback) {
            try {
                callback(null, defaultSeedFile(needed));
            } catch (e) {
                callback(e);
            }
        };
        ctx.seedFileSync = defaultSeedFile;
    }
    /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */ ctx.collect = function(bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;
        for(var i = 0; i < count; ++i){
            ctx.pools[ctx.pool].update(bytes.substr(i, 1));
            ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
    };
    /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */ ctx.collectInt = function(i, n) {
        var bytes = "";
        for(var x = 0; x < n; x += 8)bytes += String.fromCharCode(i >> x & 0xFF);
        ctx.collect(bytes);
    };
    /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */ ctx.registerWorker = function(worker) {
        // worker receives random bytes
        if (worker === self) ctx.seedFile = function(needed, callback) {
            function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) {
                    self.removeEventListener("message", listener);
                    callback(data.forge.prng.err, data.forge.prng.bytes);
                }
            }
            self.addEventListener("message", listener);
            self.postMessage({
                forge: {
                    prng: {
                        needed: needed
                    }
                }
            });
        };
        else {
            // main thread sends random bytes upon request
            var listener = function(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
                    worker.postMessage({
                        forge: {
                            prng: {
                                err: err,
                                bytes: bytes
                            }
                        }
                    });
                });
            };
            // TODO: do we need to remove the event listener when the worker dies?
            worker.addEventListener("message", listener);
        }
    };
    return ctx;
};

});


parcelRegister("dggUt", function(module, exports) {
/**
 * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("jaAdc");
parcelRequire("kvSv3");
var $9a79e2ebcd54baba$var$sha1 = module.exports = $dEd5p.sha1 = $dEd5p.sha1 || {};
$dEd5p.md.sha1 = $dEd5p.md.algorithms.sha1 = $9a79e2ebcd54baba$var$sha1;
/**
 * Creates a SHA-1 message digest object.
 *
 * @return a message digest object.
 */ $9a79e2ebcd54baba$var$sha1.create = function() {
    // do initialization as necessary
    if (!$9a79e2ebcd54baba$var$_initialized) $9a79e2ebcd54baba$var$_init();
    // SHA-1 state contains five 32-bit integers
    var _state = null;
    // input buffer
    var _input = $dEd5p.util.createBuffer();
    // used for word storage
    var _w = new Array(80);
    // message digest object
    var md = {
        algorithm: "sha1",
        blockLength: 64,
        digestLength: 20,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $dEd5p.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476,
            h4: 0xC3D2E1F0
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $dEd5p.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $9a79e2ebcd54baba$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-1 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $dEd5p.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($9a79e2ebcd54baba$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4
        };
        $9a79e2ebcd54baba$var$_update(s2, _w, finalBlock);
        var rval = $dEd5p.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        return rval;
    };
    return md;
};
// sha-1 padding bytes not initialized yet
var $9a79e2ebcd54baba$var$_padding = null;
var $9a79e2ebcd54baba$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $9a79e2ebcd54baba$var$_init() {
    // create padding
    $9a79e2ebcd54baba$var$_padding = String.fromCharCode(128);
    $9a79e2ebcd54baba$var$_padding += $dEd5p.util.fillString(String.fromCharCode(0x00), 64);
    // now initialized
    $9a79e2ebcd54baba$var$_initialized = true;
}
/**
 * Updates a SHA-1 state with the given byte buffer.
 *
 * @param s the SHA-1 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $9a79e2ebcd54baba$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 80 32-bit words according to SHA-1 algorithm
        // and for 32-79 using Max Locktyukhin's optimization
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        // round 1
        for(i = 0; i < 16; ++i){
            t = bytes.getInt32();
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 20; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 2
        for(; i < 32; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 40; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 3
        for(; i < 60; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b & c | d & (b ^ c);
            t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 4
        for(; i < 80; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        len -= 64;
    }
}

});


parcelRegister("8p5fL", function(module, exports) {
/**
 * Javascript implementation of PKCS#7 v1.5.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 *
 * Currently this implementation only supports ContentType of EnvelopedData,
 * EncryptedData, or SignedData at the root level. The top level elements may
 * contain only a ContentInfo of ContentType Data, i.e. plain data. Further
 * nesting is not (yet) supported.
 *
 * The Forge validators for PKCS #7's ASN.1 structures are available from
 * a separate file pkcs7asn1.js, since those are referenced from other
 * PKCS standards like PKCS #12.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("7vq5X");
parcelRequire("8QTFz");
parcelRequire("bweuJ");
parcelRequire("ggdRy");
parcelRequire("fYcEB");
parcelRequire("hGwt9");
parcelRequire("4N8iP");
parcelRequire("kvSv3");
parcelRequire("1p4rv");
// shortcut for ASN.1 API
var $61e4bbb3bed3b029$var$asn1 = $dEd5p.asn1;
// shortcut for PKCS#7 API
var $61e4bbb3bed3b029$var$p7 = module.exports = $dEd5p.pkcs7 = $dEd5p.pkcs7 || {};
/**
 * Converts a PKCS#7 message from PEM format.
 *
 * @param pem the PEM-formatted PKCS#7 message.
 *
 * @return the PKCS#7 message.
 */ $61e4bbb3bed3b029$var$p7.messageFromPem = function(pem) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "PKCS7") {
        var error = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $61e4bbb3bed3b029$var$asn1.fromDer(msg.body);
    return $61e4bbb3bed3b029$var$p7.messageFromAsn1(obj);
};
/**
 * Converts a PKCS#7 message to PEM format.
 *
 * @param msg The PKCS#7 message object
 * @param maxline The maximum characters per line, defaults to 64.
 *
 * @return The PEM-formatted PKCS#7 message.
 */ $61e4bbb3bed3b029$var$p7.messageToPem = function(msg, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var pemObj = {
        type: "PKCS7",
        body: $61e4bbb3bed3b029$var$asn1.toDer(msg.toAsn1()).getBytes()
    };
    return $dEd5p.pem.encode(pemObj, {
        maxline: maxline
    });
};
/**
 * Converts a PKCS#7 message from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a ContentInfo.
 *
 * @return the PKCS#7 message.
 */ $61e4bbb3bed3b029$var$p7.messageFromAsn1 = function(obj) {
    // validate root level ContentInfo and capture data
    var capture = {};
    var errors = [];
    if (!$61e4bbb3bed3b029$var$asn1.validate(obj, $61e4bbb3bed3b029$var$p7.asn1.contentInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        error.errors = errors;
        throw error;
    }
    var contentType = $61e4bbb3bed3b029$var$asn1.derToOid(capture.contentType);
    var msg;
    switch(contentType){
        case $dEd5p.pki.oids.envelopedData:
            msg = $61e4bbb3bed3b029$var$p7.createEnvelopedData();
            break;
        case $dEd5p.pki.oids.encryptedData:
            msg = $61e4bbb3bed3b029$var$p7.createEncryptedData();
            break;
        case $dEd5p.pki.oids.signedData:
            msg = $61e4bbb3bed3b029$var$p7.createSignedData();
            break;
        default:
            throw new Error("Cannot read PKCS#7 message. ContentType with OID " + contentType + " is not (yet) supported.");
    }
    msg.fromAsn1(capture.content.value[0]);
    return msg;
};
$61e4bbb3bed3b029$var$p7.createSignedData = function() {
    var msg = null;
    msg = {
        type: $dEd5p.pki.oids.signedData,
        version: 1,
        certificates: [],
        crls: [],
        // TODO: add json-formatted signer stuff here?
        signers: [],
        // populated during sign()
        digestAlgorithmIdentifiers: [],
        contentInfo: null,
        signerInfos: [],
        fromAsn1: function(obj) {
            // validate SignedData content block and capture data.
            $61e4bbb3bed3b029$var$_fromAsn1(msg, obj, $61e4bbb3bed3b029$var$p7.asn1.signedDataValidator);
            msg.certificates = [];
            msg.crls = [];
            msg.digestAlgorithmIdentifiers = [];
            msg.contentInfo = null;
            msg.signerInfos = [];
            if (msg.rawCapture.certificates) {
                var certs = msg.rawCapture.certificates.value;
                for(var i = 0; i < certs.length; ++i)msg.certificates.push($dEd5p.pki.certificateFromAsn1(certs[i]));
            }
        // TODO: parse crls
        },
        toAsn1: function() {
            // degenerate case with no content
            if (!msg.contentInfo) msg.sign();
            var certs = [];
            for(var i = 0; i < msg.certificates.length; ++i)certs.push($dEd5p.pki.certificateToAsn1(msg.certificates[i]));
            var crls = [];
            // TODO: implement CRLs
            // [0] SignedData
            var signedData = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
                    // Version
                    $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $61e4bbb3bed3b029$var$asn1.integerToDer(msg.version).getBytes()),
                    // DigestAlgorithmIdentifiers
                    $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SET, true, msg.digestAlgorithmIdentifiers),
                    // ContentInfo
                    msg.contentInfo
                ])
            ]);
            if (certs.length > 0) // [0] IMPLICIT ExtendedCertificatesAndCertificates OPTIONAL
            signedData.value[0].value.push($61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
            if (crls.length > 0) // [1] IMPLICIT CertificateRevocationLists OPTIONAL
            signedData.value[0].value.push($61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
            // SignerInfos
            signedData.value[0].value.push($61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SET, true, msg.signerInfos));
            // ContentInfo
            return $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] SignedData
                signedData
            ]);
        },
        /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */ addSigner: function(signer) {
            var issuer = signer.issuer;
            var serialNumber = signer.serialNumber;
            if (signer.certificate) {
                var cert = signer.certificate;
                if (typeof cert === "string") cert = $dEd5p.pki.certificateFromPem(cert);
                issuer = cert.issuer.attributes;
                serialNumber = cert.serialNumber;
            }
            var key = signer.key;
            if (!key) throw new Error("Could not add PKCS#7 signer; no private key specified.");
            if (typeof key === "string") key = $dEd5p.pki.privateKeyFromPem(key);
            // ensure OID known for digest algorithm
            var digestAlgorithm = signer.digestAlgorithm || $dEd5p.pki.oids.sha1;
            switch(digestAlgorithm){
                case $dEd5p.pki.oids.sha1:
                case $dEd5p.pki.oids.sha256:
                case $dEd5p.pki.oids.sha384:
                case $dEd5p.pki.oids.sha512:
                case $dEd5p.pki.oids.md5:
                    break;
                default:
                    throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + digestAlgorithm);
            }
            // if authenticatedAttributes is present, then the attributes
            // must contain at least PKCS #9 content-type and message-digest
            var authenticatedAttributes = signer.authenticatedAttributes || [];
            if (authenticatedAttributes.length > 0) {
                var contentType = false;
                var messageDigest = false;
                for(var i = 0; i < authenticatedAttributes.length; ++i){
                    var attr = authenticatedAttributes[i];
                    if (!contentType && attr.type === $dEd5p.pki.oids.contentType) {
                        contentType = true;
                        if (messageDigest) break;
                        continue;
                    }
                    if (!messageDigest && attr.type === $dEd5p.pki.oids.messageDigest) {
                        messageDigest = true;
                        if (contentType) break;
                        continue;
                    }
                }
                if (!contentType || !messageDigest) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
            }
            msg.signers.push({
                key: key,
                version: 1,
                issuer: issuer,
                serialNumber: serialNumber,
                digestAlgorithm: digestAlgorithm,
                signatureAlgorithm: $dEd5p.pki.oids.rsaEncryption,
                signature: null,
                authenticatedAttributes: authenticatedAttributes,
                unauthenticatedAttributes: []
            });
        },
        /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */ sign: function(options) {
            options = options || {};
            // auto-generate content info
            if (typeof msg.content !== "object" || msg.contentInfo === null) {
                // use Data ContentInfo
                msg.contentInfo = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
                    // ContentType
                    $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer($dEd5p.pki.oids.data).getBytes())
                ]);
                // add actual content, if present
                if ("content" in msg) {
                    var content;
                    if (msg.content instanceof $dEd5p.util.ByteBuffer) content = msg.content.bytes();
                    else if (typeof msg.content === "string") content = $dEd5p.util.encodeUtf8(msg.content);
                    if (options.detached) msg.detachedContent = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, content);
                    else msg.contentInfo.value.push(// [0] EXPLICIT content
                    $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, content)
                    ]));
                }
            }
            // no signers, return early (degenerate case for certificate container)
            if (msg.signers.length === 0) return;
            // generate digest algorithm identifiers
            var mds = addDigestAlgorithmIds();
            // generate signerInfos
            addSignerInfos(mds);
        },
        verify: function() {
            throw new Error("PKCS#7 signature verification not yet implemented.");
        },
        /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */ addCertificate: function(cert) {
            // convert from PEM
            if (typeof cert === "string") cert = $dEd5p.pki.certificateFromPem(cert);
            msg.certificates.push(cert);
        },
        /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */ addCertificateRevokationList: function(crl) {
            throw new Error("PKCS#7 CRL support not yet implemented.");
        }
    };
    return msg;
    function addDigestAlgorithmIds() {
        var mds = {};
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            var oid = signer.digestAlgorithm;
            if (!(oid in mds)) // content digest
            mds[oid] = $dEd5p.md[$dEd5p.pki.oids[oid]].create();
            if (signer.authenticatedAttributes.length === 0) // no custom attributes to digest; use content message digest
            signer.md = mds[oid];
            else // custom attributes to be digested; use own message digest
            // TODO: optimize to just copy message digest state if that
            // feature is ever supported with message digests
            signer.md = $dEd5p.md[$dEd5p.pki.oids[oid]].create();
        }
        // add unique digest algorithm identifiers
        msg.digestAlgorithmIdentifiers = [];
        for(var oid in mds)msg.digestAlgorithmIdentifiers.push(// AlgorithmIdentifier
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(oid).getBytes()),
            // parameters (null)
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.NULL, false, "")
        ]));
        return mds;
    }
    function addSignerInfos(mds) {
        var content;
        if (msg.detachedContent) // Signature has been made in detached mode.
        content = msg.detachedContent;
        else {
            // Note: ContentInfo is a SEQUENCE with 2 values, second value is
            // the content field and is optional for a ContentInfo but required here
            // since signers are present
            // get ContentInfo content
            content = msg.contentInfo.value[1];
            // skip [0] EXPLICIT content wrapper
            content = content.value[0];
        }
        if (!content) throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
        // get ContentInfo content type
        var contentType = $61e4bbb3bed3b029$var$asn1.derToOid(msg.contentInfo.value[0].value);
        // serialize content
        var bytes = $61e4bbb3bed3b029$var$asn1.toDer(content);
        // skip identifier and length per RFC 2315 9.3
        // skip identifier (1 byte)
        bytes.getByte();
        // read and discard length bytes
        $61e4bbb3bed3b029$var$asn1.getBerValueLength(bytes);
        bytes = bytes.getBytes();
        // digest content DER value bytes
        for(var oid in mds)mds[oid].start().update(bytes);
        // sign content
        var signingTime = new Date();
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            if (signer.authenticatedAttributes.length === 0) {
                // if ContentInfo content type is not "Data", then
                // authenticatedAttributes must be present per RFC 2315
                if (contentType !== $dEd5p.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
                // process authenticated attributes
                // [0] IMPLICIT
                signer.authenticatedAttributesAsn1 = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
                // per RFC 2315, attributes are to be digested using a SET container
                // not the above [0] IMPLICIT container
                var attrsAsn1 = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SET, true, []);
                for(var ai = 0; ai < signer.authenticatedAttributes.length; ++ai){
                    var attr = signer.authenticatedAttributes[ai];
                    if (attr.type === $dEd5p.pki.oids.messageDigest) // use content message digest as value
                    attr.value = mds[signer.digestAlgorithm].digest();
                    else if (attr.type === $dEd5p.pki.oids.signingTime) // auto-populate signing time if not already set
                    {
                        if (!attr.value) attr.value = signingTime;
                    }
                    // convert to ASN.1 and push onto Attributes SET (for signing) and
                    // onto authenticatedAttributesAsn1 to complete SignedData ASN.1
                    // TODO: optimize away duplication
                    attrsAsn1.value.push($61e4bbb3bed3b029$var$_attributeToAsn1(attr));
                    signer.authenticatedAttributesAsn1.value.push($61e4bbb3bed3b029$var$_attributeToAsn1(attr));
                }
                // DER-serialize and digest SET OF attributes only
                bytes = $61e4bbb3bed3b029$var$asn1.toDer(attrsAsn1).getBytes();
                signer.md.start().update(bytes);
            }
            // sign digest
            signer.signature = signer.key.sign(signer.md, "RSASSA-PKCS1-V1_5");
        }
        // add signer info
        msg.signerInfos = $61e4bbb3bed3b029$var$_signersToAsn1(msg.signers);
    }
};
/**
 * Creates an empty PKCS#7 message of type EncryptedData.
 *
 * @return the message.
 */ $61e4bbb3bed3b029$var$p7.createEncryptedData = function() {
    var msg = null;
    msg = {
        type: $dEd5p.pki.oids.encryptedData,
        version: 0,
        encryptedContent: {
            algorithm: $dEd5p.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */ fromAsn1: function(obj) {
            // Validate EncryptedData content block and capture data.
            $61e4bbb3bed3b029$var$_fromAsn1(msg, obj, $61e4bbb3bed3b029$var$p7.asn1.encryptedDataValidator);
        },
        /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */ decrypt: function(key) {
            if (key !== undefined) msg.encryptedContent.key = key;
            $61e4bbb3bed3b029$var$_decryptContent(msg);
        }
    };
    return msg;
};
/**
 * Creates an empty PKCS#7 message of type EnvelopedData.
 *
 * @return the message.
 */ $61e4bbb3bed3b029$var$p7.createEnvelopedData = function() {
    var msg = null;
    msg = {
        type: $dEd5p.pki.oids.envelopedData,
        version: 0,
        recipients: [],
        encryptedContent: {
            algorithm: $dEd5p.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */ fromAsn1: function(obj) {
            // validate EnvelopedData content block and capture data
            var capture = $61e4bbb3bed3b029$var$_fromAsn1(msg, obj, $61e4bbb3bed3b029$var$p7.asn1.envelopedDataValidator);
            msg.recipients = $61e4bbb3bed3b029$var$_recipientsFromAsn1(capture.recipientInfos.value);
        },
        toAsn1: function() {
            // ContentInfo
            return $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] EnvelopedData
                $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                    $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
                        // Version
                        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $61e4bbb3bed3b029$var$asn1.integerToDer(msg.version).getBytes()),
                        // RecipientInfos
                        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SET, true, $61e4bbb3bed3b029$var$_recipientsToAsn1(msg.recipients)),
                        // EncryptedContentInfo
                        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, $61e4bbb3bed3b029$var$_encryptedContentToAsn1(msg.encryptedContent))
                    ])
                ])
            ]);
        },
        /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */ findRecipient: function(cert) {
            var sAttr = cert.issuer.attributes;
            for(var i = 0; i < msg.recipients.length; ++i){
                var r = msg.recipients[i];
                var rAttr = r.issuer;
                if (r.serialNumber !== cert.serialNumber) continue;
                if (rAttr.length !== sAttr.length) continue;
                var match = true;
                for(var j = 0; j < sAttr.length; ++j)if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
                    match = false;
                    break;
                }
                if (match) return r;
            }
            return null;
        },
        /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */ decrypt: function(recipient, privKey) {
            if (msg.encryptedContent.key === undefined && recipient !== undefined && privKey !== undefined) switch(recipient.encryptedContent.algorithm){
                case $dEd5p.pki.oids.rsaEncryption:
                case $dEd5p.pki.oids.desCBC:
                    var key = privKey.decrypt(recipient.encryptedContent.content);
                    msg.encryptedContent.key = $dEd5p.util.createBuffer(key);
                    break;
                default:
                    throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
            }
            $61e4bbb3bed3b029$var$_decryptContent(msg);
        },
        /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */ addRecipient: function(cert) {
            msg.recipients.push({
                version: 0,
                issuer: cert.issuer.attributes,
                serialNumber: cert.serialNumber,
                encryptedContent: {
                    // We simply assume rsaEncryption here, since forge.pki only
                    // supports RSA so far.  If the PKI module supports other
                    // ciphers one day, we need to modify this one as well.
                    algorithm: $dEd5p.pki.oids.rsaEncryption,
                    key: cert.publicKey
                }
            });
        },
        /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */ encrypt: function(key, cipher) {
            // Part 1: Symmetric encryption
            if (msg.encryptedContent.content === undefined) {
                cipher = cipher || msg.encryptedContent.algorithm;
                key = key || msg.encryptedContent.key;
                var keyLen, ivLen, ciphFn;
                switch(cipher){
                    case $dEd5p.pki.oids["aes128-CBC"]:
                        keyLen = 16;
                        ivLen = 16;
                        ciphFn = $dEd5p.aes.createEncryptionCipher;
                        break;
                    case $dEd5p.pki.oids["aes192-CBC"]:
                        keyLen = 24;
                        ivLen = 16;
                        ciphFn = $dEd5p.aes.createEncryptionCipher;
                        break;
                    case $dEd5p.pki.oids["aes256-CBC"]:
                        keyLen = 32;
                        ivLen = 16;
                        ciphFn = $dEd5p.aes.createEncryptionCipher;
                        break;
                    case $dEd5p.pki.oids["des-EDE3-CBC"]:
                        keyLen = 24;
                        ivLen = 8;
                        ciphFn = $dEd5p.des.createEncryptionCipher;
                        break;
                    default:
                        throw new Error("Unsupported symmetric cipher, OID " + cipher);
                }
                if (key === undefined) key = $dEd5p.util.createBuffer($dEd5p.random.getBytes(keyLen));
                else if (key.length() != keyLen) throw new Error("Symmetric key has wrong length; got " + key.length() + " bytes, expected " + keyLen + ".");
                // Keep a copy of the key & IV in the object, so the caller can
                // use it for whatever reason.
                msg.encryptedContent.algorithm = cipher;
                msg.encryptedContent.key = key;
                msg.encryptedContent.parameter = $dEd5p.util.createBuffer($dEd5p.random.getBytes(ivLen));
                var ciph = ciphFn(key);
                ciph.start(msg.encryptedContent.parameter.copy());
                ciph.update(msg.content);
                // The finish function does PKCS#7 padding by default, therefore
                // no action required by us.
                if (!ciph.finish()) throw new Error("Symmetric encryption failed.");
                msg.encryptedContent.content = ciph.output;
            }
            // Part 2: asymmetric encryption for each recipient
            for(var i = 0; i < msg.recipients.length; ++i){
                var recipient = msg.recipients[i];
                // Nothing to do, encryption already done.
                if (recipient.encryptedContent.content !== undefined) continue;
                switch(recipient.encryptedContent.algorithm){
                    case $dEd5p.pki.oids.rsaEncryption:
                        recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
                        break;
                    default:
                        throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
                }
            }
        }
    };
    return msg;
};
/**
 * Converts a single recipient from an ASN.1 object.
 *
 * @param obj the ASN.1 RecipientInfo.
 *
 * @return the recipient object.
 */ function $61e4bbb3bed3b029$var$_recipientFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$61e4bbb3bed3b029$var$asn1.validate(obj, $61e4bbb3bed3b029$var$p7.asn1.recipientInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        error.errors = errors;
        throw error;
    }
    return {
        version: capture.version.charCodeAt(0),
        issuer: $dEd5p.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $dEd5p.util.createBuffer(capture.serial).toHex(),
        encryptedContent: {
            algorithm: $61e4bbb3bed3b029$var$asn1.derToOid(capture.encAlgorithm),
            parameter: capture.encParameter ? capture.encParameter.value : undefined,
            content: capture.encKey
        }
    };
}
/**
 * Converts a single recipient object to an ASN.1 object.
 *
 * @param obj the recipient object.
 *
 * @return the ASN.1 RecipientInfo.
 */ function $61e4bbb3bed3b029$var$_recipientToAsn1(obj) {
    return $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
        // Version
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $61e4bbb3bed3b029$var$asn1.integerToDer(obj.version).getBytes()),
        // IssuerAndSerialNumber
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // Name
            $dEd5p.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // Serial
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $dEd5p.util.hexToBytes(obj.serialNumber))
        ]),
        // KeyEncryptionAlgorithmIdentifier
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()),
            // Parameter, force NULL, only RSA supported for now.
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.NULL, false, "")
        ]),
        // EncryptedKey
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)
    ]);
}
/**
 * Map a set of RecipientInfo ASN.1 objects to recipient objects.
 *
 * @param infos an array of ASN.1 representations RecipientInfo (i.e. SET OF).
 *
 * @return an array of recipient objects.
 */ function $61e4bbb3bed3b029$var$_recipientsFromAsn1(infos) {
    var ret = [];
    for(var i = 0; i < infos.length; ++i)ret.push($61e4bbb3bed3b029$var$_recipientFromAsn1(infos[i]));
    return ret;
}
/**
 * Map an array of recipient objects to ASN.1 RecipientInfo objects.
 *
 * @param recipients an array of recipientInfo objects.
 *
 * @return an array of ASN.1 RecipientInfos.
 */ function $61e4bbb3bed3b029$var$_recipientsToAsn1(recipients) {
    var ret = [];
    for(var i = 0; i < recipients.length; ++i)ret.push($61e4bbb3bed3b029$var$_recipientToAsn1(recipients[i]));
    return ret;
}
/**
 * Converts a single signer from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a SignerInfo.
 *
 * @return the signer object.
 */ function $61e4bbb3bed3b029$var$_signerFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$61e4bbb3bed3b029$var$asn1.validate(obj, $61e4bbb3bed3b029$var$p7.asn1.signerInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 SignerInfo. ASN.1 object is not an PKCS#7 SignerInfo.");
        error.errors = errors;
        throw error;
    }
    var rval = {
        version: capture.version.charCodeAt(0),
        issuer: $dEd5p.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $dEd5p.util.createBuffer(capture.serial).toHex(),
        digestAlgorithm: $61e4bbb3bed3b029$var$asn1.derToOid(capture.digestAlgorithm),
        signatureAlgorithm: $61e4bbb3bed3b029$var$asn1.derToOid(capture.signatureAlgorithm),
        signature: capture.signature,
        authenticatedAttributes: [],
        unauthenticatedAttributes: []
    };
    // TODO: convert attributes
    var authenticatedAttributes = capture.authenticatedAttributes || [];
    var unauthenticatedAttributes = capture.unauthenticatedAttributes || [];
    return rval;
}
/**
 * Converts a single signerInfo object to an ASN.1 object.
 *
 * @param obj the signerInfo object.
 *
 * @return the ASN.1 representation of a SignerInfo.
 */ function $61e4bbb3bed3b029$var$_signerToAsn1(obj) {
    // SignerInfo
    var rval = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
        // version
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $61e4bbb3bed3b029$var$asn1.integerToDer(obj.version).getBytes()),
        // issuerAndSerialNumber
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // name
            $dEd5p.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // serial
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.INTEGER, false, $dEd5p.util.hexToBytes(obj.serialNumber))
        ]),
        // digestAlgorithm
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(obj.digestAlgorithm).getBytes()),
            // parameters (null)
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.NULL, false, "")
        ])
    ]);
    // authenticatedAttributes (OPTIONAL)
    if (obj.authenticatedAttributesAsn1) // add ASN.1 previously generated during signing
    rval.value.push(obj.authenticatedAttributesAsn1);
    // digestEncryptionAlgorithm
    rval.value.push($61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(obj.signatureAlgorithm).getBytes()),
        // parameters (null)
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.NULL, false, "")
    ]));
    // encryptedDigest
    rval.value.push($61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, obj.signature));
    // unauthenticatedAttributes (OPTIONAL)
    if (obj.unauthenticatedAttributes.length > 0) {
        // [1] IMPLICIT
        var attrsAsn1 = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, []);
        for(var i = 0; i < obj.unauthenticatedAttributes.length; ++i){
            var attr = obj.unauthenticatedAttributes[i];
            attrsAsn1.values.push($61e4bbb3bed3b029$var$_attributeToAsn1(attr));
        }
        rval.value.push(attrsAsn1);
    }
    return rval;
}
/**
 * Map a set of SignerInfo ASN.1 objects to an array of signer objects.
 *
 * @param signerInfoAsn1s an array of ASN.1 SignerInfos (i.e. SET OF).
 *
 * @return an array of signers objects.
 */ function $61e4bbb3bed3b029$var$_signersFromAsn1(signerInfoAsn1s) {
    var ret = [];
    for(var i = 0; i < signerInfoAsn1s.length; ++i)ret.push($61e4bbb3bed3b029$var$_signerFromAsn1(signerInfoAsn1s[i]));
    return ret;
}
/**
 * Map an array of signer objects to ASN.1 objects.
 *
 * @param signers an array of signer objects.
 *
 * @return an array of ASN.1 SignerInfos.
 */ function $61e4bbb3bed3b029$var$_signersToAsn1(signers) {
    var ret = [];
    for(var i = 0; i < signers.length; ++i)ret.push($61e4bbb3bed3b029$var$_signerToAsn1(signers[i]));
    return ret;
}
/**
 * Convert an attribute object to an ASN.1 Attribute.
 *
 * @param attr the attribute object.
 *
 * @return the ASN.1 Attribute.
 */ function $61e4bbb3bed3b029$var$_attributeToAsn1(attr) {
    var value;
    // TODO: generalize to support more attributes
    if (attr.type === $dEd5p.pki.oids.contentType) value = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(attr.value).getBytes());
    else if (attr.type === $dEd5p.pki.oids.messageDigest) value = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, attr.value.bytes());
    else if (attr.type === $dEd5p.pki.oids.signingTime) {
        /* Note per RFC 2985: Dates between 1 January 1950 and 31 December 2049
      (inclusive) MUST be encoded as UTCTime. Any dates with year values
      before 1950 or after 2049 MUST be encoded as GeneralizedTime. [Further,]
      UTCTime values MUST be expressed in Greenwich Mean Time (Zulu) and MUST
      include seconds (i.e., times are YYMMDDHHMMSSZ), even where the
      number of seconds is zero.  Midnight (GMT) must be represented as
      "YYMMDD000000Z". */ // TODO: make these module-level constants
        var jan_1_1950 = new Date("1950-01-01T00:00:00Z");
        var jan_1_2050 = new Date("2050-01-01T00:00:00Z");
        var date = attr.value;
        if (typeof date === "string") {
            // try to parse date
            var timestamp = Date.parse(date);
            if (!isNaN(timestamp)) date = new Date(timestamp);
            else if (date.length === 13) // YYMMDDHHMMSSZ (13 chars for UTCTime)
            date = $61e4bbb3bed3b029$var$asn1.utcTimeToDate(date);
            else // assume generalized time
            date = $61e4bbb3bed3b029$var$asn1.generalizedTimeToDate(date);
        }
        if (date >= jan_1_1950 && date < jan_1_2050) value = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.UTCTIME, false, $61e4bbb3bed3b029$var$asn1.dateToUtcTime(date));
        else value = $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.GENERALIZEDTIME, false, $61e4bbb3bed3b029$var$asn1.dateToGeneralizedTime(date));
    }
    // TODO: expose as common API call
    // create a RelativeDistinguishedName set
    // each value in the set is an AttributeTypeAndValue first
    // containing the type (an OID) and second the value
    return $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
        // AttributeType
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(attr.type).getBytes()),
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SET, true, [
            // AttributeValue
            value
        ])
    ]);
}
/**
 * Map messages encrypted content to ASN.1 objects.
 *
 * @param ec The encryptedContent object of the message.
 *
 * @return ASN.1 representation of the encryptedContent object (SEQUENCE).
 */ function $61e4bbb3bed3b029$var$_encryptedContentToAsn1(ec) {
    return [
        // ContentType, always Data for the moment
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer($dEd5p.pki.oids.data).getBytes()),
        // ContentEncryptionAlgorithmIdentifier
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OID, false, $61e4bbb3bed3b029$var$asn1.oidToDer(ec.algorithm).getBytes()),
            // Parameters (IV)
            !ec.parameter ? undefined : $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())
        ]),
        // [0] EncryptedContent
        $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            $61e4bbb3bed3b029$var$asn1.create($61e4bbb3bed3b029$var$asn1.Class.UNIVERSAL, $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING, false, ec.content.getBytes())
        ])
    ];
}
/**
 * Reads the "common part" of an PKCS#7 content block (in ASN.1 format)
 *
 * This function reads the "common part" of the PKCS#7 content blocks
 * EncryptedData and EnvelopedData, i.e. version number and symmetrically
 * encrypted content block.
 *
 * The result of the ASN.1 validate and capture process is returned
 * to allow the caller to extract further data, e.g. the list of recipients
 * in case of a EnvelopedData object.
 *
 * @param msg the PKCS#7 object to read the data to.
 * @param obj the ASN.1 representation of the content block.
 * @param validator the ASN.1 structure validator object to use.
 *
 * @return the value map captured by validator object.
 */ function $61e4bbb3bed3b029$var$_fromAsn1(msg, obj, validator) {
    var capture = {};
    var errors = [];
    if (!$61e4bbb3bed3b029$var$asn1.validate(obj, validator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        error.errors = error;
        throw error;
    }
    // Check contentType, so far we only support (raw) Data.
    var contentType = $61e4bbb3bed3b029$var$asn1.derToOid(capture.contentType);
    if (contentType !== $dEd5p.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
    if (capture.encryptedContent) {
        var content = "";
        if ($dEd5p.util.isArray(capture.encryptedContent)) for(var i = 0; i < capture.encryptedContent.length; ++i){
            if (capture.encryptedContent[i].type !== $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
            content += capture.encryptedContent[i].value;
        }
        else content = capture.encryptedContent;
        msg.encryptedContent = {
            algorithm: $61e4bbb3bed3b029$var$asn1.derToOid(capture.encAlgorithm),
            parameter: $dEd5p.util.createBuffer(capture.encParameter.value),
            content: $dEd5p.util.createBuffer(content)
        };
    }
    if (capture.content) {
        var content = "";
        if ($dEd5p.util.isArray(capture.content)) for(var i = 0; i < capture.content.length; ++i){
            if (capture.content[i].type !== $61e4bbb3bed3b029$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
            content += capture.content[i].value;
        }
        else content = capture.content;
        msg.content = $dEd5p.util.createBuffer(content);
    }
    msg.version = capture.version.charCodeAt(0);
    msg.rawCapture = capture;
    return capture;
}
/**
 * Decrypt the symmetrically encrypted content block of the PKCS#7 message.
 *
 * Decryption is skipped in case the PKCS#7 message object already has a
 * (decrypted) content attribute.  The algorithm, key and cipher parameters
 * (probably the iv) are taken from the encryptedContent attribute of the
 * message object.
 *
 * @param The PKCS#7 message object.
 */ function $61e4bbb3bed3b029$var$_decryptContent(msg) {
    if (msg.encryptedContent.key === undefined) throw new Error("Symmetric key not available.");
    if (msg.content === undefined) {
        var ciph;
        switch(msg.encryptedContent.algorithm){
            case $dEd5p.pki.oids["aes128-CBC"]:
            case $dEd5p.pki.oids["aes192-CBC"]:
            case $dEd5p.pki.oids["aes256-CBC"]:
                ciph = $dEd5p.aes.createDecryptionCipher(msg.encryptedContent.key);
                break;
            case $dEd5p.pki.oids["desCBC"]:
            case $dEd5p.pki.oids["des-EDE3-CBC"]:
                ciph = $dEd5p.des.createDecryptionCipher(msg.encryptedContent.key);
                break;
            default:
                throw new Error("Unsupported symmetric cipher, OID " + msg.encryptedContent.algorithm);
        }
        ciph.start(msg.encryptedContent.parameter);
        ciph.update(msg.encryptedContent.content);
        if (!ciph.finish()) throw new Error("Symmetric decryption failed.");
        msg.content = ciph.output;
    }
}

});
parcelRegister("bweuJ", function(module, exports) {
/**
 * DES (Data Encryption Standard) implementation.
 *
 * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
 * It is based on the BSD-licensed implementation by Paul Tero:
 *
 * Paul Tero, July 2001
 * http://www.tero.co.uk/des/
 *
 * Optimised for performance with large blocks by
 * Michael Hayworth, November 2001
 * http://www.netdealing.com
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("c5Ms4");
parcelRequire("g1HTO");
parcelRequire("kvSv3");
/* DES API */ module.exports = $dEd5p.des = $dEd5p.des || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $dEd5p.des.startEncrypting = function(key, iv, output, mode) {
    var cipher = $862ded3807c6cd62$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.des.createEncryptionCipher = function(key, mode) {
    return $862ded3807c6cd62$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $dEd5p.des.startDecrypting = function(key, iv, output, mode) {
    var cipher = $862ded3807c6cd62$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $dEd5p.des.createDecryptionCipher = function(key, mode) {
    return $862ded3807c6cd62$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new DES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the DES algorithm object.
 */ $dEd5p.des.Algorithm = function(name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 8,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $862ded3807c6cd62$var$_updateBlock(self._keys, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $862ded3807c6cd62$var$_updateBlock(self._keys, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this DES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $dEd5p.des.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = $dEd5p.util.createBuffer(options.key);
    if (this.name.indexOf("3DES") === 0) {
        if (key.length() !== 24) throw new Error("Invalid Triple-DES key size: " + key.length() * 8);
    }
    // do key expansion to 16 or 48 subkeys (single or triple DES)
    this._keys = $862ded3807c6cd62$var$_createKeys(key);
    this._init = true;
};
/** Register DES algorithms **/ $862ded3807c6cd62$var$registerAlgorithm("DES-ECB", $dEd5p.cipher.modes.ecb);
$862ded3807c6cd62$var$registerAlgorithm("DES-CBC", $dEd5p.cipher.modes.cbc);
$862ded3807c6cd62$var$registerAlgorithm("DES-CFB", $dEd5p.cipher.modes.cfb);
$862ded3807c6cd62$var$registerAlgorithm("DES-OFB", $dEd5p.cipher.modes.ofb);
$862ded3807c6cd62$var$registerAlgorithm("DES-CTR", $dEd5p.cipher.modes.ctr);
$862ded3807c6cd62$var$registerAlgorithm("3DES-ECB", $dEd5p.cipher.modes.ecb);
$862ded3807c6cd62$var$registerAlgorithm("3DES-CBC", $dEd5p.cipher.modes.cbc);
$862ded3807c6cd62$var$registerAlgorithm("3DES-CFB", $dEd5p.cipher.modes.cfb);
$862ded3807c6cd62$var$registerAlgorithm("3DES-OFB", $dEd5p.cipher.modes.ofb);
$862ded3807c6cd62$var$registerAlgorithm("3DES-CTR", $dEd5p.cipher.modes.ctr);
function $862ded3807c6cd62$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $dEd5p.des.Algorithm(name, mode);
    };
    $dEd5p.cipher.registerAlgorithm(name, factory);
}
/** DES implementation **/ var $862ded3807c6cd62$var$spfunction1 = [
    0x1010400,
    0,
    0x10000,
    0x1010404,
    0x1010004,
    0x10404,
    0x4,
    0x10000,
    0x400,
    0x1010400,
    0x1010404,
    0x400,
    0x1000404,
    0x1010004,
    0x1000000,
    0x4,
    0x404,
    0x1000400,
    0x1000400,
    0x10400,
    0x10400,
    0x1010000,
    0x1010000,
    0x1000404,
    0x10004,
    0x1000004,
    0x1000004,
    0x10004,
    0,
    0x404,
    0x10404,
    0x1000000,
    0x10000,
    0x1010404,
    0x4,
    0x1010000,
    0x1010400,
    0x1000000,
    0x1000000,
    0x400,
    0x1010004,
    0x10000,
    0x10400,
    0x1000004,
    0x400,
    0x4,
    0x1000404,
    0x10404,
    0x1010404,
    0x10004,
    0x1010000,
    0x1000404,
    0x1000004,
    0x404,
    0x10404,
    0x1010400,
    0x404,
    0x1000400,
    0x1000400,
    0,
    0x10004,
    0x10400,
    0,
    0x1010004
];
var $862ded3807c6cd62$var$spfunction2 = [
    -2146402272,
    -2147450880,
    0x8000,
    0x108020,
    0x100000,
    0x20,
    -2146435040,
    -2147450848,
    -2147483616,
    -2146402272,
    -2146402304,
    -2147483648,
    -2147450880,
    0x100000,
    0x20,
    -2146435040,
    0x108000,
    0x100020,
    -2147450848,
    0,
    -2147483648,
    0x8000,
    0x108020,
    -2146435072,
    0x100020,
    -2147483616,
    0,
    0x108000,
    0x8020,
    -2146402304,
    -2146435072,
    0x8020,
    0,
    0x108020,
    -2146435040,
    0x100000,
    -2147450848,
    -2146435072,
    -2146402304,
    0x8000,
    -2146435072,
    -2147450880,
    0x20,
    -2146402272,
    0x108020,
    0x20,
    0x8000,
    -2147483648,
    0x8020,
    -2146402304,
    0x100000,
    -2147483616,
    0x100020,
    -2147450848,
    -2147483616,
    0x100020,
    0x108000,
    0,
    -2147450880,
    0x8020,
    -2147483648,
    -2146435040,
    -2146402272,
    0x108000
];
var $862ded3807c6cd62$var$spfunction3 = [
    0x208,
    0x8020200,
    0,
    0x8020008,
    0x8000200,
    0,
    0x20208,
    0x8000200,
    0x20008,
    0x8000008,
    0x8000008,
    0x20000,
    0x8020208,
    0x20008,
    0x8020000,
    0x208,
    0x8000000,
    0x8,
    0x8020200,
    0x200,
    0x20200,
    0x8020000,
    0x8020008,
    0x20208,
    0x8000208,
    0x20200,
    0x20000,
    0x8000208,
    0x8,
    0x8020208,
    0x200,
    0x8000000,
    0x8020200,
    0x8000000,
    0x20008,
    0x208,
    0x20000,
    0x8020200,
    0x8000200,
    0,
    0x200,
    0x20008,
    0x8020208,
    0x8000200,
    0x8000008,
    0x200,
    0,
    0x8020008,
    0x8000208,
    0x20000,
    0x8000000,
    0x8020208,
    0x8,
    0x20208,
    0x20200,
    0x8000008,
    0x8020000,
    0x8000208,
    0x208,
    0x8020000,
    0x20208,
    0x8,
    0x8020008,
    0x20200
];
var $862ded3807c6cd62$var$spfunction4 = [
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802080,
    0x800081,
    0x800001,
    0x2001,
    0,
    0x802000,
    0x802000,
    0x802081,
    0x81,
    0,
    0x800080,
    0x800001,
    0x1,
    0x2000,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2001,
    0x2080,
    0x800081,
    0x1,
    0x2080,
    0x800080,
    0x2000,
    0x802080,
    0x802081,
    0x81,
    0x800080,
    0x800001,
    0x802000,
    0x802081,
    0x81,
    0,
    0,
    0x802000,
    0x2080,
    0x800080,
    0x800081,
    0x1,
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802081,
    0x81,
    0x1,
    0x2000,
    0x800001,
    0x2001,
    0x802080,
    0x800081,
    0x2001,
    0x2080,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2000,
    0x802080
];
var $862ded3807c6cd62$var$spfunction5 = [
    0x100,
    0x2080100,
    0x2080000,
    0x42000100,
    0x80000,
    0x100,
    0x40000000,
    0x2080000,
    0x40080100,
    0x80000,
    0x2000100,
    0x40080100,
    0x42000100,
    0x42080000,
    0x80100,
    0x40000000,
    0x2000000,
    0x40080000,
    0x40080000,
    0,
    0x40000100,
    0x42080100,
    0x42080100,
    0x2000100,
    0x42080000,
    0x40000100,
    0,
    0x42000000,
    0x2080100,
    0x2000000,
    0x42000000,
    0x80100,
    0x80000,
    0x42000100,
    0x100,
    0x2000000,
    0x40000000,
    0x2080000,
    0x42000100,
    0x40080100,
    0x2000100,
    0x40000000,
    0x42080000,
    0x2080100,
    0x40080100,
    0x100,
    0x2000000,
    0x42080000,
    0x42080100,
    0x80100,
    0x42000000,
    0x42080100,
    0x2080000,
    0,
    0x40080000,
    0x42000000,
    0x80100,
    0x2000100,
    0x40000100,
    0x80000,
    0,
    0x40080000,
    0x2080100,
    0x40000100
];
var $862ded3807c6cd62$var$spfunction6 = [
    0x20000010,
    0x20400000,
    0x4000,
    0x20404010,
    0x20400000,
    0x10,
    0x20404010,
    0x400000,
    0x20004000,
    0x404010,
    0x400000,
    0x20000010,
    0x400010,
    0x20004000,
    0x20000000,
    0x4010,
    0,
    0x400010,
    0x20004010,
    0x4000,
    0x404000,
    0x20004010,
    0x10,
    0x20400010,
    0x20400010,
    0,
    0x404010,
    0x20404000,
    0x4010,
    0x404000,
    0x20404000,
    0x20000000,
    0x20004000,
    0x10,
    0x20400010,
    0x404000,
    0x20404010,
    0x400000,
    0x4010,
    0x20000010,
    0x400000,
    0x20004000,
    0x20000000,
    0x4010,
    0x20000010,
    0x20404010,
    0x404000,
    0x20400000,
    0x404010,
    0x20404000,
    0,
    0x20400010,
    0x10,
    0x4000,
    0x20400000,
    0x404010,
    0x4000,
    0x400010,
    0x20004010,
    0,
    0x20404000,
    0x20000000,
    0x400010,
    0x20004010
];
var $862ded3807c6cd62$var$spfunction7 = [
    0x200000,
    0x4200002,
    0x4000802,
    0,
    0x800,
    0x4000802,
    0x200802,
    0x4200800,
    0x4200802,
    0x200000,
    0,
    0x4000002,
    0x2,
    0x4000000,
    0x4200002,
    0x802,
    0x4000800,
    0x200802,
    0x200002,
    0x4000800,
    0x4000002,
    0x4200000,
    0x4200800,
    0x200002,
    0x4200000,
    0x800,
    0x802,
    0x4200802,
    0x200800,
    0x2,
    0x4000000,
    0x200800,
    0x4000000,
    0x200800,
    0x200000,
    0x4000802,
    0x4000802,
    0x4200002,
    0x4200002,
    0x2,
    0x200002,
    0x4000000,
    0x4000800,
    0x200000,
    0x4200800,
    0x802,
    0x200802,
    0x4200800,
    0x802,
    0x4000002,
    0x4200802,
    0x4200000,
    0x200800,
    0,
    0x2,
    0x4200802,
    0,
    0x200802,
    0x4200000,
    0x800,
    0x4000002,
    0x4000800,
    0x800,
    0x200002
];
var $862ded3807c6cd62$var$spfunction8 = [
    0x10001040,
    0x1000,
    0x40000,
    0x10041040,
    0x10000000,
    0x10001040,
    0x40,
    0x10000000,
    0x40040,
    0x10040000,
    0x10041040,
    0x41000,
    0x10041000,
    0x41040,
    0x1000,
    0x40,
    0x10040000,
    0x10000040,
    0x10001000,
    0x1040,
    0x41000,
    0x40040,
    0x10040040,
    0x10041000,
    0x1040,
    0,
    0,
    0x10040040,
    0x10000040,
    0x10001000,
    0x41040,
    0x40000,
    0x41040,
    0x40000,
    0x10041000,
    0x1000,
    0x40,
    0x10040040,
    0x1000,
    0x41040,
    0x10001000,
    0x40,
    0x10000040,
    0x10040000,
    0x10040040,
    0x10000000,
    0x40000,
    0x10001040,
    0,
    0x10041040,
    0x40040,
    0x10000040,
    0x10040000,
    0x10001000,
    0x10001040,
    0,
    0x10041040,
    0x41000,
    0x41000,
    0x1040,
    0x1040,
    0x40040,
    0x10000000,
    0x10041000
];
/**
 * Create necessary sub keys.
 *
 * @param key the 64-bit or 192-bit key.
 *
 * @return the expanded keys.
 */ function $862ded3807c6cd62$var$_createKeys(key) {
    var pc2bytes0 = [
        0,
        0x4,
        0x20000000,
        0x20000004,
        0x10000,
        0x10004,
        0x20010000,
        0x20010004,
        0x200,
        0x204,
        0x20000200,
        0x20000204,
        0x10200,
        0x10204,
        0x20010200,
        0x20010204
    ], pc2bytes1 = [
        0,
        0x1,
        0x100000,
        0x100001,
        0x4000000,
        0x4000001,
        0x4100000,
        0x4100001,
        0x100,
        0x101,
        0x100100,
        0x100101,
        0x4000100,
        0x4000101,
        0x4100100,
        0x4100101
    ], pc2bytes2 = [
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808,
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808
    ], pc2bytes3 = [
        0,
        0x200000,
        0x8000000,
        0x8200000,
        0x2000,
        0x202000,
        0x8002000,
        0x8202000,
        0x20000,
        0x220000,
        0x8020000,
        0x8220000,
        0x22000,
        0x222000,
        0x8022000,
        0x8222000
    ], pc2bytes4 = [
        0,
        0x40000,
        0x10,
        0x40010,
        0,
        0x40000,
        0x10,
        0x40010,
        0x1000,
        0x41000,
        0x1010,
        0x41010,
        0x1000,
        0x41000,
        0x1010,
        0x41010
    ], pc2bytes5 = [
        0,
        0x400,
        0x20,
        0x420,
        0,
        0x400,
        0x20,
        0x420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420
    ], pc2bytes6 = [
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002,
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002
    ], pc2bytes7 = [
        0,
        0x10000,
        0x800,
        0x10800,
        0x20000000,
        0x20010000,
        0x20000800,
        0x20010800,
        0x20000,
        0x30000,
        0x20800,
        0x30800,
        0x20020000,
        0x20030000,
        0x20020800,
        0x20030800
    ], pc2bytes8 = [
        0,
        0x40000,
        0,
        0x40000,
        0x2,
        0x40002,
        0x2,
        0x40002,
        0x2000000,
        0x2040000,
        0x2000000,
        0x2040000,
        0x2000002,
        0x2040002,
        0x2000002,
        0x2040002
    ], pc2bytes9 = [
        0,
        0x10000000,
        0x8,
        0x10000008,
        0,
        0x10000000,
        0x8,
        0x10000008,
        0x400,
        0x10000400,
        0x408,
        0x10000408,
        0x400,
        0x10000400,
        0x408,
        0x10000408
    ], pc2bytes10 = [
        0,
        0x20,
        0,
        0x20,
        0x100000,
        0x100020,
        0x100000,
        0x100020,
        0x2000,
        0x2020,
        0x2000,
        0x2020,
        0x102000,
        0x102020,
        0x102000,
        0x102020
    ], pc2bytes11 = [
        0,
        0x1000000,
        0x200,
        0x1000200,
        0x200000,
        0x1200000,
        0x200200,
        0x1200200,
        0x4000000,
        0x5000000,
        0x4000200,
        0x5000200,
        0x4200000,
        0x5200000,
        0x4200200,
        0x5200200
    ], pc2bytes12 = [
        0,
        0x1000,
        0x8000000,
        0x8001000,
        0x80000,
        0x81000,
        0x8080000,
        0x8081000,
        0x10,
        0x1010,
        0x8000010,
        0x8001010,
        0x80010,
        0x81010,
        0x8080010,
        0x8081010
    ], pc2bytes13 = [
        0,
        0x4,
        0x100,
        0x104,
        0,
        0x4,
        0x100,
        0x104,
        0x1,
        0x5,
        0x101,
        0x105,
        0x1,
        0x5,
        0x101,
        0x105
    ];
    // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
    var iterations = key.length() > 8 ? 3 : 1;
    // stores the return keys
    var keys = [];
    // now define the left shifts which need to be done
    var shifts = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    var n = 0, tmp;
    for(var j = 0; j < iterations; j++){
        var left = key.getInt32();
        var right = key.getInt32();
        tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
        right ^= tmp;
        left ^= tmp << 4;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 2 ^ right) & 0x33333333;
        right ^= tmp;
        left ^= tmp << 2;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        tmp = (right >>> 8 ^ left) & 0x00ff00ff;
        left ^= tmp;
        right ^= tmp << 8;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        // right needs to be shifted and OR'd with last four bits of left
        tmp = left << 8 | right >>> 20 & 0x000000f0;
        // left needs to be put upside down
        left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
        right = tmp;
        // now go through and perform these shifts on the left and right keys
        for(var i = 0; i < shifts.length; ++i){
            //shift the keys either one or two bits to the left
            if (shifts[i]) {
                left = left << 2 | left >>> 26;
                right = right << 2 | right >>> 26;
            } else {
                left = left << 1 | left >>> 27;
                right = right << 1 | right >>> 27;
            }
            left &= -15;
            right &= -15;
            // now apply PC-2, in such a way that E is easier when encrypting or
            // decrypting this conversion will look like PC-2 except only the last 6
            // bits of each byte are used rather than 48 consecutive bits and the
            // order of lines will be according to how the S selection functions will
            // be applied: S2, S4, S6, S8, S1, S3, S5, S7
            var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
            var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
            tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
            keys[n++] = lefttmp ^ tmp;
            keys[n++] = righttmp ^ tmp << 16;
        }
    }
    return keys;
}
/**
 * Updates a single block (1 byte) using DES. The update will either
 * encrypt or decrypt the block.
 *
 * @param keys the expanded keys.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $862ded3807c6cd62$var$_updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;
    if (iterations === 3) looping = decrypt ? [
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2
    ];
    else looping = decrypt ? [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ];
    var tmp;
    var left = input[0];
    var right = input[1];
    // first each 64 bit chunk of the message must be permuted according to IP
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    // rotate left 1 bit
    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;
    for(var j = 0; j < iterations; j += 3){
        var endloop = looping[j + 1];
        var loopinc = looping[j + 2];
        // now go through and perform the encryption or decryption
        for(var i = looping[j]; i != endloop; i += loopinc){
            var right1 = right ^ keys[i];
            var right2 = (right >>> 4 | right << 28) ^ keys[i + 1];
            // passing these bytes through the S selection functions
            tmp = left;
            left = right;
            right = tmp ^ ($862ded3807c6cd62$var$spfunction2[right1 >>> 24 & 0x3f] | $862ded3807c6cd62$var$spfunction4[right1 >>> 16 & 0x3f] | $862ded3807c6cd62$var$spfunction6[right1 >>> 8 & 0x3f] | $862ded3807c6cd62$var$spfunction8[right1 & 0x3f] | $862ded3807c6cd62$var$spfunction1[right2 >>> 24 & 0x3f] | $862ded3807c6cd62$var$spfunction3[right2 >>> 16 & 0x3f] | $862ded3807c6cd62$var$spfunction5[right2 >>> 8 & 0x3f] | $862ded3807c6cd62$var$spfunction7[right2 & 0x3f]);
        }
        // unreverse left and right
        tmp = left;
        left = right;
        right = tmp;
    }
    // rotate right 1 bit
    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31;
    // now perform IP-1, which is IP in the opposite direction
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('DES-<mode>', key);
 * forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates a deprecated DES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param options the options to use.
 *          key the symmetric key to use (64 or 192 bits).
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $862ded3807c6cd62$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "DES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $dEd5p.cipher.createDecipher(algorithm, options.key);
    else cipher = $dEd5p.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $dEd5p.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});

parcelRegister("hGwt9", function(module, exports) {
/**
 * Javascript implementation of ASN.1 validators for PKCS#7 v1.5.
 *
 * @author Dave Longley
 * @author Stefan Siegl
 *
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#7 is as follows
 * (see RFC #2315 for details, http://www.ietf.org/rfc/rfc2315.txt):
 *
 * A PKCS#7 message consists of a ContentInfo on root level, which may
 * contain any number of further ContentInfo nested into it.
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType                ContentType,
 *   content               [0]  EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * EnvelopedData ::= SEQUENCE {
 *   version                    Version,
 *   recipientInfos             RecipientInfos,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * EncryptedData ::= SEQUENCE {
 *   version                    Version,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * id-signedData OBJECT IDENTIFIER ::= { iso(1) member-body(2)
 *   us(840) rsadsi(113549) pkcs(1) pkcs7(7) 2 }
 *
 * SignedData ::= SEQUENCE {
 *   version           INTEGER,
 *   digestAlgorithms  DigestAlgorithmIdentifiers,
 *   contentInfo       ContentInfo,
 *   certificates      [0] IMPLICIT Certificates OPTIONAL,
 *   crls              [1] IMPLICIT CertificateRevocationLists OPTIONAL,
 *   signerInfos       SignerInfos
 * }
 *
 * SignerInfos ::= SET OF SignerInfo
 *
 * SignerInfo ::= SEQUENCE {
 *   version                    Version,
 *   issuerAndSerialNumber      IssuerAndSerialNumber,
 *   digestAlgorithm            DigestAlgorithmIdentifier,
 *   authenticatedAttributes    [0] IMPLICIT Attributes OPTIONAL,
 *   digestEncryptionAlgorithm  DigestEncryptionAlgorithmIdentifier,
 *   encryptedDigest            EncryptedDigest,
 *   unauthenticatedAttributes  [1] IMPLICIT Attributes OPTIONAL
 * }
 *
 * EncryptedDigest ::= OCTET STRING
 *
 * Attributes ::= SET OF Attribute
 *
 * Attribute ::= SEQUENCE {
 *   attrType    OBJECT IDENTIFIER,
 *   attrValues  SET OF AttributeValue
 * }
 *
 * AttributeValue ::= ANY
 *
 * Version ::= INTEGER
 *
 * RecipientInfos ::= SET OF RecipientInfo
 *
 * EncryptedContentInfo ::= SEQUENCE {
 *   contentType                 ContentType,
 *   contentEncryptionAlgorithm  ContentEncryptionAlgorithmIdentifier,
 *   encryptedContent       [0]  IMPLICIT EncryptedContent OPTIONAL
 * }
 *
 * ContentEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of AES and DES3, there is only one,
 * the IV.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * EncryptedContent ::= OCTET STRING
 *
 * RecipientInfo ::= SEQUENCE {
 *   version                     Version,
 *   issuerAndSerialNumber       IssuerAndSerialNumber,
 *   keyEncryptionAlgorithm      KeyEncryptionAlgorithmIdentifier,
 *   encryptedKey                EncryptedKey
 * }
 *
 * IssuerAndSerialNumber ::= SEQUENCE {
 *   issuer                      Name,
 *   serialNumber                CertificateSerialNumber
 * }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * KeyEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedKey ::= OCTET STRING
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("8QTFz");
parcelRequire("kvSv3");
// shortcut for ASN.1 API
var $cdff8b9b34bda92f$var$asn1 = $dEd5p.asn1;
// shortcut for PKCS#7 API
var $cdff8b9b34bda92f$var$p7v = module.exports = $dEd5p.pkcs7asn1 = $dEd5p.pkcs7asn1 || {};
$dEd5p.pkcs7 = $dEd5p.pkcs7 || {};
$dEd5p.pkcs7.asn1 = $cdff8b9b34bda92f$var$p7v;
var $cdff8b9b34bda92f$var$contentInfoValidator = {
    name: "ContentInfo",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "ContentInfo.ContentType",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "ContentInfo.content",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            captureAsn1: "content"
        }
    ]
};
$cdff8b9b34bda92f$var$p7v.contentInfoValidator = $cdff8b9b34bda92f$var$contentInfoValidator;
var $cdff8b9b34bda92f$var$encryptedContentInfoValidator = {
    name: "EncryptedContentInfo",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedContentInfo.contentType",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "EncryptedContentInfo.contentEncryptionAlgorithm",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    captureAsn1: "encParameter"
                }
            ]
        },
        {
            name: "EncryptedContentInfo.encryptedContent",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */ capture: "encryptedContent",
            captureAsn1: "encryptedContentAsn1"
        }
    ]
};
$cdff8b9b34bda92f$var$p7v.envelopedDataValidator = {
    name: "EnvelopedData",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EnvelopedData.Version",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "EnvelopedData.RecipientInfos",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "recipientInfos"
        }
    ].concat($cdff8b9b34bda92f$var$encryptedContentInfoValidator)
};
$cdff8b9b34bda92f$var$p7v.encryptedDataValidator = {
    name: "EncryptedData",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedData.Version",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        }
    ].concat($cdff8b9b34bda92f$var$encryptedContentInfoValidator)
};
var $cdff8b9b34bda92f$var$signerValidator = {
    name: "SignerInfo",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignerInfo.version",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
            constructed: false
        },
        {
            name: "SignerInfo.issuerAndSerialNumber",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.issuerAndSerialNumber.issuer",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "SignerInfo.issuerAndSerialNumber.serialNumber",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "SignerInfo.digestAlgorithm",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.digestAlgorithm.algorithm",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "digestAlgorithm"
                },
                {
                    name: "SignerInfo.digestAlgorithm.parameter",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "digestParameter",
                    optional: true
                }
            ]
        },
        {
            name: "SignerInfo.authenticatedAttributes",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "authenticatedAttributes"
        },
        {
            name: "SignerInfo.digestEncryptionAlgorithm",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            capture: "signatureAlgorithm"
        },
        {
            name: "SignerInfo.encryptedDigest",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "signature"
        },
        {
            name: "SignerInfo.unauthenticatedAttributes",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            optional: true,
            capture: "unauthenticatedAttributes"
        }
    ]
};
$cdff8b9b34bda92f$var$p7v.signedDataValidator = {
    name: "SignedData",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignedData.Version",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "SignedData.DigestAlgorithms",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "digestAlgorithms"
        },
        $cdff8b9b34bda92f$var$contentInfoValidator,
        {
            name: "SignedData.Certificates",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            optional: true,
            captureAsn1: "certificates"
        },
        {
            name: "SignedData.CertificateRevocationLists",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            optional: true,
            captureAsn1: "crls"
        },
        {
            name: "SignedData.SignerInfos",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SET,
            capture: "signerInfos",
            optional: true,
            value: [
                $cdff8b9b34bda92f$var$signerValidator
            ]
        }
    ]
};
$cdff8b9b34bda92f$var$p7v.recipientInfoValidator = {
    name: "RecipientInfo",
    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "RecipientInfo.version",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "RecipientInfo.issuerAndSerial",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.issuerAndSerial.issuer",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "RecipientInfo.issuerAndSerial.serialNumber",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "RecipientInfo.keyEncryptionAlgorithm",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    type: $cdff8b9b34bda92f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
                    tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "encParameter",
                    optional: true
                }
            ]
        },
        {
            name: "RecipientInfo.encryptedKey",
            tagClass: $cdff8b9b34bda92f$var$asn1.Class.UNIVERSAL,
            type: $cdff8b9b34bda92f$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encKey"
        }
    ]
};

});

parcelRegister("1p4rv", function(module, exports) {
/**
 * Javascript implementation of X.509 and related components (such as
 * Certification Signing Requests) of a Public Key Infrastructure.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The ASN.1 representation of an X.509v3 certificate is as follows
 * (see RFC 2459):
 *
 * Certificate ::= SEQUENCE {
 *   tbsCertificate       TBSCertificate,
 *   signatureAlgorithm   AlgorithmIdentifier,
 *   signatureValue       BIT STRING
 * }
 *
 * TBSCertificate ::= SEQUENCE {
 *   version         [0]  EXPLICIT Version DEFAULT v1,
 *   serialNumber         CertificateSerialNumber,
 *   signature            AlgorithmIdentifier,
 *   issuer               Name,
 *   validity             Validity,
 *   subject              Name,
 *   subjectPublicKeyInfo SubjectPublicKeyInfo,
 *   issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   extensions      [3]  EXPLICIT Extensions OPTIONAL
 *                        -- If present, version shall be v3
 * }
 *
 * Version ::= INTEGER  { v1(0), v2(1), v3(2) }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * Name ::= CHOICE {
 *   // only one possible choice for now
 *   RDNSequence
 * }
 *
 * RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
 *
 * RelativeDistinguishedName ::= SET OF AttributeTypeAndValue
 *
 * AttributeTypeAndValue ::= SEQUENCE {
 *   type     AttributeType,
 *   value    AttributeValue
 * }
 * AttributeType ::= OBJECT IDENTIFIER
 * AttributeValue ::= ANY DEFINED BY AttributeType
 *
 * Validity ::= SEQUENCE {
 *   notBefore      Time,
 *   notAfter       Time
 * }
 *
 * Time ::= CHOICE {
 *   utcTime        UTCTime,
 *   generalTime    GeneralizedTime
 * }
 *
 * UniqueIdentifier ::= BIT STRING
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm            AlgorithmIdentifier,
 *   subjectPublicKey     BIT STRING
 * }
 *
 * Extensions ::= SEQUENCE SIZE (1..MAX) OF Extension
 *
 * Extension ::= SEQUENCE {
 *   extnID      OBJECT IDENTIFIER,
 *   critical    BOOLEAN DEFAULT FALSE,
 *   extnValue   OCTET STRING
 * }
 *
 * The only key algorithm currently supported for PKI is RSA.
 *
 * RSASSA-PSS signatures are described in RFC 3447 and RFC 4055.
 *
 * PKCS#10 v1.7 describes certificate signing requests:
 *
 * CertificationRequestInfo:
 *
 * CertificationRequestInfo ::= SEQUENCE {
 *   version       INTEGER { v1(0) } (v1,...),
 *   subject       Name,
 *   subjectPKInfo SubjectPublicKeyInfo{{ PKInfoAlgorithms }},
 *   attributes    [0] Attributes{{ CRIAttributes }}
 * }
 *
 * Attributes { ATTRIBUTE:IOSet } ::= SET OF Attribute{{ IOSet }}
 *
 * CRIAttributes  ATTRIBUTE  ::= {
 *   ... -- add any locally defined attributes here -- }
 *
 * Attribute { ATTRIBUTE:IOSet } ::= SEQUENCE {
 *   type   ATTRIBUTE.&id({IOSet}),
 *   values SET SIZE(1..MAX) OF ATTRIBUTE.&Type({IOSet}{@type})
 * }
 *
 * CertificationRequest ::= SEQUENCE {
 *   certificationRequestInfo CertificationRequestInfo,
 *   signatureAlgorithm AlgorithmIdentifier{{ SignatureAlgorithms }},
 *   signature          BIT STRING
 * }
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("7vq5X");
parcelRequire("8QTFz");
parcelRequire("bweuJ");
parcelRequire("jaAdc");
parcelRequire("3jreJ");
parcelRequire("ggdRy");
parcelRequire("fYcEB");
parcelRequire("54e3h");
parcelRequire("ad5x8");
parcelRequire("kvSv3");
// shortcut for asn.1 API
var $105b92724c1ce1a5$var$asn1 = $dEd5p.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $105b92724c1ce1a5$var$pki = module.exports = $dEd5p.pki = $dEd5p.pki || {};
var $105b92724c1ce1a5$var$oids = $105b92724c1ce1a5$var$pki.oids;
// short name OID mappings
var $105b92724c1ce1a5$var$_shortNames = {};
$105b92724c1ce1a5$var$_shortNames["CN"] = $105b92724c1ce1a5$var$oids["commonName"];
$105b92724c1ce1a5$var$_shortNames["commonName"] = "CN";
$105b92724c1ce1a5$var$_shortNames["C"] = $105b92724c1ce1a5$var$oids["countryName"];
$105b92724c1ce1a5$var$_shortNames["countryName"] = "C";
$105b92724c1ce1a5$var$_shortNames["L"] = $105b92724c1ce1a5$var$oids["localityName"];
$105b92724c1ce1a5$var$_shortNames["localityName"] = "L";
$105b92724c1ce1a5$var$_shortNames["ST"] = $105b92724c1ce1a5$var$oids["stateOrProvinceName"];
$105b92724c1ce1a5$var$_shortNames["stateOrProvinceName"] = "ST";
$105b92724c1ce1a5$var$_shortNames["O"] = $105b92724c1ce1a5$var$oids["organizationName"];
$105b92724c1ce1a5$var$_shortNames["organizationName"] = "O";
$105b92724c1ce1a5$var$_shortNames["OU"] = $105b92724c1ce1a5$var$oids["organizationalUnitName"];
$105b92724c1ce1a5$var$_shortNames["organizationalUnitName"] = "OU";
$105b92724c1ce1a5$var$_shortNames["E"] = $105b92724c1ce1a5$var$oids["emailAddress"];
$105b92724c1ce1a5$var$_shortNames["emailAddress"] = "E";
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $105b92724c1ce1a5$var$publicKeyValidator = $dEd5p.pki.rsa.publicKeyValidator;
// validator for an X.509v3 certificate
var $105b92724c1ce1a5$var$x509CertificateValidator = {
    name: "Certificate",
    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Certificate.TBSCertificate",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "tbsCertificate",
            value: [
                {
                    name: "Certificate.TBSCertificate.version",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 0,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.version.integer",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "certVersion"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.serialNumber",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "certSerialNumber"
                },
                {
                    name: "Certificate.TBSCertificate.signature",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.signature.algorithm",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.OID,
                            constructed: false,
                            capture: "certinfoSignatureOid"
                        },
                        {
                            name: "Certificate.TBSCertificate.signature.parameters",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            optional: true,
                            captureAsn1: "certinfoSignatureParams"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.issuer",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certIssuer"
                },
                {
                    name: "Certificate.TBSCertificate.validity",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    // Note: UTC and generalized times may both appear so the capture
                    // names are based on their detected order, the names used below
                    // are only for the common case, which validity time really means
                    // "notBefore" and which means "notAfter" will be determined by order
                    value: [
                        {
                            // notBefore (Time) (UTC time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity1UTCTime"
                        },
                        {
                            // notBefore (Time) (generalized time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity2GeneralizedTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity3UTCTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity4GeneralizedTime"
                        }
                    ]
                },
                {
                    // Name (subject) (RDNSequence)
                    name: "Certificate.TBSCertificate.subject",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certSubject"
                },
                // SubjectPublicKeyInfo
                $105b92724c1ce1a5$var$publicKeyValidator,
                {
                    // issuerUniqueID (optional)
                    name: "Certificate.TBSCertificate.issuerUniqueID",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 1,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.issuerUniqueID.id",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certIssuerUniqueId"
                        }
                    ]
                },
                {
                    // subjectUniqueID (optional)
                    name: "Certificate.TBSCertificate.subjectUniqueID",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 2,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.subjectUniqueID.id",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certSubjectUniqueId"
                        }
                    ]
                },
                {
                    // Extensions (optional)
                    name: "Certificate.TBSCertificate.extensions",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 3,
                    constructed: true,
                    captureAsn1: "certExtensions",
                    optional: true
                }
            ]
        },
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "Certificate.signatureAlgorithm",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "Certificate.signatureAlgorithm.algorithm",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.OID,
                    constructed: false,
                    capture: "certSignatureOid"
                },
                {
                    name: "Certificate.TBSCertificate.signature.parameters",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "certSignatureParams"
                }
            ]
        },
        {
            // SignatureValue
            name: "Certificate.signatureValue",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "certSignature"
        }
    ]
};
var $105b92724c1ce1a5$var$rsassaPssParameterValidator = {
    name: "rsapss",
    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "rsapss.hashAlgorithm",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            value: [
                {
                    name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.OID,
                            constructed: false,
                            capture: "hashOid"
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.maskGenAlgorithm",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            value: [
                {
                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.OID,
                            constructed: false,
                            capture: "maskGenOid"
                        },
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
                                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                                    type: $105b92724c1ce1a5$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "maskGenHashOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.saltLength",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 2,
            optional: true,
            value: [
                {
                    name: "rsapss.saltLength.saltLength",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "saltLength"
                }
            ]
        },
        {
            name: "rsapss.trailerField",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 3,
            optional: true,
            value: [
                {
                    name: "rsapss.trailer.trailer",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "trailer"
                }
            ]
        }
    ]
};
// validator for a CertificationRequestInfo structure
var $105b92724c1ce1a5$var$certificationRequestInfoValidator = {
    name: "CertificationRequestInfo",
    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "certificationRequestInfo",
    value: [
        {
            name: "CertificationRequestInfo.integer",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "certificationRequestInfoVersion"
        },
        {
            // Name (subject) (RDNSequence)
            name: "CertificationRequestInfo.subject",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "certificationRequestInfoSubject"
        },
        // SubjectPublicKeyInfo
        $105b92724c1ce1a5$var$publicKeyValidator,
        {
            name: "CertificationRequestInfo.attributes",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "certificationRequestInfoAttributes",
            value: [
                {
                    name: "CertificationRequestInfo.attributes",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "CertificationRequestInfo.attributes.type",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.OID,
                            constructed: false
                        },
                        {
                            name: "CertificationRequestInfo.attributes.value",
                            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                            type: $105b92724c1ce1a5$var$asn1.Type.SET,
                            constructed: true
                        }
                    ]
                }
            ]
        }
    ]
};
// validator for a CertificationRequest structure
var $105b92724c1ce1a5$var$certificationRequestValidator = {
    name: "CertificationRequest",
    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
    type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "csr",
    value: [
        $105b92724c1ce1a5$var$certificationRequestInfoValidator,
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "CertificationRequest.signatureAlgorithm",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "CertificationRequest.signatureAlgorithm.algorithm",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    type: $105b92724c1ce1a5$var$asn1.Type.OID,
                    constructed: false,
                    capture: "csrSignatureOid"
                },
                {
                    name: "CertificationRequest.signatureAlgorithm.parameters",
                    tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "csrSignatureParams"
                }
            ]
        },
        {
            // signature
            name: "CertificationRequest.signature",
            tagClass: $105b92724c1ce1a5$var$asn1.Class.UNIVERSAL,
            type: $105b92724c1ce1a5$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "csrSignature"
        }
    ]
};
/**
 * Converts an RDNSequence of ASN.1 DER-encoded RelativeDistinguishedName
 * sets into an array with objects that have type and value properties.
 *
 * @param rdn the RDNSequence to convert.
 * @param md a message digest to append type and value to if provided.
 */ $105b92724c1ce1a5$var$pki.RDNAttributesAsArray = function(rdn, md) {
    var rval = [];
    // each value in 'rdn' in is a SET of RelativeDistinguishedName
    var set, attr, obj;
    for(var si = 0; si < rdn.value.length; ++si){
        // get the RelativeDistinguishedName set
        set = rdn.value[si];
        // each value in the SET is an AttributeTypeAndValue sequence
        // containing first a type (an OID) and second a value (defined by
        // the OID)
        for(var i = 0; i < set.value.length; ++i){
            obj = {};
            attr = set.value[i];
            obj.type = $105b92724c1ce1a5$var$asn1.derToOid(attr.value[0].value);
            obj.value = attr.value[1].value;
            obj.valueTagClass = attr.value[1].type;
            // if the OID is known, get its name and short name
            if (obj.type in $105b92724c1ce1a5$var$oids) {
                obj.name = $105b92724c1ce1a5$var$oids[obj.type];
                if (obj.name in $105b92724c1ce1a5$var$_shortNames) obj.shortName = $105b92724c1ce1a5$var$_shortNames[obj.name];
            }
            if (md) {
                md.update(obj.type);
                md.update(obj.value);
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Converts ASN.1 CRIAttributes into an array with objects that have type and
 * value properties.
 *
 * @param attributes the CRIAttributes to convert.
 */ $105b92724c1ce1a5$var$pki.CRIAttributesAsArray = function(attributes) {
    var rval = [];
    // each value in 'attributes' in is a SEQUENCE with an OID and a SET
    for(var si = 0; si < attributes.length; ++si){
        // get the attribute sequence
        var seq = attributes[si];
        // each value in the SEQUENCE containing first a type (an OID) and
        // second a set of values (defined by the OID)
        var type = $105b92724c1ce1a5$var$asn1.derToOid(seq.value[0].value);
        var values = seq.value[1].value;
        for(var vi = 0; vi < values.length; ++vi){
            var obj = {};
            obj.type = type;
            obj.value = values[vi].value;
            obj.valueTagClass = values[vi].type;
            // if the OID is known, get its name and short name
            if (obj.type in $105b92724c1ce1a5$var$oids) {
                obj.name = $105b92724c1ce1a5$var$oids[obj.type];
                if (obj.name in $105b92724c1ce1a5$var$_shortNames) obj.shortName = $105b92724c1ce1a5$var$_shortNames[obj.name];
            }
            // parse extensions
            if (obj.type === $105b92724c1ce1a5$var$oids.extensionRequest) {
                obj.extensions = [];
                for(var ei = 0; ei < obj.value.length; ++ei)obj.extensions.push($105b92724c1ce1a5$var$pki.certificateExtensionFromAsn1(obj.value[ei]));
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Gets an issuer or subject attribute from its name, type, or short name.
 *
 * @param obj the issuer or subject object.
 * @param options a short name string or an object with:
 *          shortName the short name for the attribute.
 *          name the name for the attribute.
 *          type the type for the attribute.
 *
 * @return the attribute.
 */ function $105b92724c1ce1a5$var$_getAttribute(obj, options) {
    if (typeof options === "string") options = {
        shortName: options
    };
    var rval = null;
    var attr;
    for(var i = 0; rval === null && i < obj.attributes.length; ++i){
        attr = obj.attributes[i];
        if (options.type && options.type === attr.type) rval = attr;
        else if (options.name && options.name === attr.name) rval = attr;
        else if (options.shortName && options.shortName === attr.shortName) rval = attr;
    }
    return rval;
}
/**
 * Converts signature parameters from ASN.1 structure.
 *
 * Currently only RSASSA-PSS supported.  The PKCS#1 v1.5 signature scheme had
 * no parameters.
 *
 * RSASSA-PSS-params  ::=  SEQUENCE  {
 *   hashAlgorithm      [0] HashAlgorithm DEFAULT
 *                             sha1Identifier,
 *   maskGenAlgorithm   [1] MaskGenAlgorithm DEFAULT
 *                             mgf1SHA1Identifier,
 *   saltLength         [2] INTEGER DEFAULT 20,
 *   trailerField       [3] INTEGER DEFAULT 1
 * }
 *
 * HashAlgorithm  ::=  AlgorithmIdentifier
 *
 * MaskGenAlgorithm  ::=  AlgorithmIdentifier
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * @param oid The OID specifying the signature algorithm
 * @param obj The ASN.1 structure holding the parameters
 * @param fillDefaults Whether to use return default values where omitted
 * @return signature parameter object
 */ var $105b92724c1ce1a5$var$_readSignatureParameters = function(oid, obj, fillDefaults) {
    var params = {};
    if (oid !== $105b92724c1ce1a5$var$oids["RSASSA-PSS"]) return params;
    if (fillDefaults) params = {
        hash: {
            algorithmOid: $105b92724c1ce1a5$var$oids["sha1"]
        },
        mgf: {
            algorithmOid: $105b92724c1ce1a5$var$oids["mgf1"],
            hash: {
                algorithmOid: $105b92724c1ce1a5$var$oids["sha1"]
            }
        },
        saltLength: 20
    };
    var capture = {};
    var errors = [];
    if (!$105b92724c1ce1a5$var$asn1.validate(obj, $105b92724c1ce1a5$var$rsassaPssParameterValidator, capture, errors)) {
        var error = new Error("Cannot read RSASSA-PSS parameter block.");
        error.errors = errors;
        throw error;
    }
    if (capture.hashOid !== undefined) {
        params.hash = params.hash || {};
        params.hash.algorithmOid = $105b92724c1ce1a5$var$asn1.derToOid(capture.hashOid);
    }
    if (capture.maskGenOid !== undefined) {
        params.mgf = params.mgf || {};
        params.mgf.algorithmOid = $105b92724c1ce1a5$var$asn1.derToOid(capture.maskGenOid);
        params.mgf.hash = params.mgf.hash || {};
        params.mgf.hash.algorithmOid = $105b92724c1ce1a5$var$asn1.derToOid(capture.maskGenHashOid);
    }
    if (capture.saltLength !== undefined) params.saltLength = capture.saltLength.charCodeAt(0);
    return params;
};
/**
 * Create signature digest for OID.
 *
 * @param options
 *   signatureOid: the OID specifying the signature algorithm.
 *   type: a human readable type for error messages
 * @return a created md instance. throws if unknown oid.
 */ var $105b92724c1ce1a5$var$_createSignatureDigest = function(options) {
    switch($105b92724c1ce1a5$var$oids[options.signatureOid]){
        case "sha1WithRSAEncryption":
        // deprecated alias
        case "sha1WithRSASignature":
            return $dEd5p.md.sha1.create();
        case "md5WithRSAEncryption":
            return $dEd5p.md.md5.create();
        case "sha256WithRSAEncryption":
            return $dEd5p.md.sha256.create();
        case "sha384WithRSAEncryption":
            return $dEd5p.md.sha384.create();
        case "sha512WithRSAEncryption":
            return $dEd5p.md.sha512.create();
        case "RSASSA-PSS":
            return $dEd5p.md.sha256.create();
        default:
            var error = new Error("Could not compute " + options.type + " digest. " + "Unknown signature OID.");
            error.signatureOid = options.signatureOid;
            throw error;
    }
};
/**
 * Verify signature on certificate or CSR.
 *
 * @param options:
 *   certificate the certificate or CSR to verify.
 *   md the signature digest.
 *   signature the signature
 * @return a created md instance. throws if unknown oid.
 */ var $105b92724c1ce1a5$var$_verifySignature = function(options) {
    var cert = options.certificate;
    var scheme;
    switch(cert.signatureOid){
        case $105b92724c1ce1a5$var$oids.sha1WithRSAEncryption:
        // deprecated alias
        case $105b92724c1ce1a5$var$oids.sha1WithRSASignature:
            break;
        case $105b92724c1ce1a5$var$oids["RSASSA-PSS"]:
            var hash, mgf;
            /* initialize mgf */ hash = $105b92724c1ce1a5$var$oids[cert.signatureParameters.mgf.hash.algorithmOid];
            if (hash === undefined || $dEd5p.md[hash] === undefined) {
                var error = new Error("Unsupported MGF hash function.");
                error.oid = cert.signatureParameters.mgf.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            mgf = $105b92724c1ce1a5$var$oids[cert.signatureParameters.mgf.algorithmOid];
            if (mgf === undefined || $dEd5p.mgf[mgf] === undefined) {
                var error = new Error("Unsupported MGF function.");
                error.oid = cert.signatureParameters.mgf.algorithmOid;
                error.name = mgf;
                throw error;
            }
            mgf = $dEd5p.mgf[mgf].create($dEd5p.md[hash].create());
            /* initialize hash function */ hash = $105b92724c1ce1a5$var$oids[cert.signatureParameters.hash.algorithmOid];
            if (hash === undefined || $dEd5p.md[hash] === undefined) {
                var error = new Error("Unsupported RSASSA-PSS hash function.");
                error.oid = cert.signatureParameters.hash.algorithmOid;
                error.name = hash;
                throw error;
            }
            scheme = $dEd5p.pss.create($dEd5p.md[hash].create(), mgf, cert.signatureParameters.saltLength);
            break;
    }
    // verify signature on cert using public key
    return cert.publicKey.verify(options.md.digest().getBytes(), options.signature, scheme);
};
/**
 * Converts an X.509 certificate from PEM format.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. This will scan the TBSCertificate part of the ASN.1
 * object while it is converted so it doesn't need to be converted back
 * to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certificate.
 */ $105b92724c1ce1a5$var$pki.certificateFromPem = function(pem, computeHash, strict) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
        var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $105b92724c1ce1a5$var$asn1.fromDer(msg.body, strict);
    return $105b92724c1ce1a5$var$pki.certificateFromAsn1(obj, computeHash);
};
/**
 * Converts an X.509 certificate to PEM format.
 *
 * @param cert the certificate.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certificate.
 */ $105b92724c1ce1a5$var$pki.certificateToPem = function(cert, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE",
        body: $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificateToAsn1(cert)).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key from PEM format.
 *
 * @param pem the PEM-formatted public key.
 *
 * @return the public key.
 */ $105b92724c1ce1a5$var$pki.publicKeyFromPem = function(pem) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "PUBLIC KEY" && msg.type !== "RSA PUBLIC KEY") {
        var error = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert public key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $105b92724c1ce1a5$var$asn1.fromDer(msg.body);
    return $105b92724c1ce1a5$var$pki.publicKeyFromAsn1(obj);
};
/**
 * Converts an RSA public key to PEM format (using a SubjectPublicKeyInfo).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $105b92724c1ce1a5$var$pki.publicKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "PUBLIC KEY",
        body: $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.publicKeyToAsn1(key)).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key to PEM format (using an RSAPublicKey).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $105b92724c1ce1a5$var$pki.publicKeyToRSAPublicKeyPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "RSA PUBLIC KEY",
        body: $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.publicKeyToRSAPublicKey(key)).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Gets a fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.sha1).
 *          [type] the type of fingerprint, such as 'RSAPublicKey',
 *            'SubjectPublicKeyInfo' (defaults to 'RSAPublicKey').
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $105b92724c1ce1a5$var$pki.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $dEd5p.md.sha1.create();
    var type = options.type || "RSAPublicKey";
    var bytes;
    switch(type){
        case "RSAPublicKey":
            bytes = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.publicKeyToRSAPublicKey(key)).getBytes();
            break;
        case "SubjectPublicKeyInfo":
            bytes = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.publicKeyToAsn1(key)).getBytes();
            break;
        default:
            throw new Error('Unknown fingerprint type "' + options.type + '".');
    }
    // hash public key bytes
    md.start();
    md.update(bytes);
    var digest = md.digest();
    if (options.encoding === "hex") {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === "binary") return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Converts a PKCS#10 certification request (CSR) from PEM format.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. This will scan the CertificationRequestInfo part of
 * the ASN.1 object while it is converted so it doesn't need to be converted
 * back to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certification request (CSR).
 */ $105b92724c1ce1a5$var$pki.certificationRequestFromPem = function(pem, computeHash, strict) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE REQUEST") {
        var error = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $105b92724c1ce1a5$var$asn1.fromDer(msg.body, strict);
    return $105b92724c1ce1a5$var$pki.certificationRequestFromAsn1(obj, computeHash);
};
/**
 * Converts a PKCS#10 certification request (CSR) to PEM format.
 *
 * @param csr the certification request.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certification request.
 */ $105b92724c1ce1a5$var$pki.certificationRequestToPem = function(csr, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE REQUEST",
        body: $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificationRequestToAsn1(csr)).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Creates an empty X.509v3 RSA certificate.
 *
 * @return the certificate.
 */ $105b92724c1ce1a5$var$pki.createCertificate = function() {
    var cert = {};
    cert.version = 0x02;
    cert.serialNumber = "00";
    cert.signatureOid = null;
    cert.signature = null;
    cert.siginfo = {};
    cert.siginfo.algorithmOid = null;
    cert.validity = {};
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.issuer = {};
    cert.issuer.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = [];
    cert.issuer.hash = null;
    cert.subject = {};
    cert.subject.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = [];
    cert.subject.hash = null;
    cert.extensions = [];
    cert.publicKey = null;
    cert.md = null;
    /**
   * Sets the subject of this certificate.
   *
   * @param attrs the array of subject attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setSubject = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $105b92724c1ce1a5$var$_fillMissingFields(attrs);
        cert.subject.attributes = attrs;
        delete cert.subject.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.subject.uniqueId = uniqueId;
        cert.subject.hash = null;
    };
    /**
   * Sets the issuer of this certificate.
   *
   * @param attrs the array of issuer attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setIssuer = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $105b92724c1ce1a5$var$_fillMissingFields(attrs);
        cert.issuer.attributes = attrs;
        delete cert.issuer.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.issuer.uniqueId = uniqueId;
        cert.issuer.hash = null;
    };
    /**
   * Sets the extensions of this certificate.
   *
   * @param exts the array of extensions to use.
   */ cert.setExtensions = function(exts) {
        for(var i = 0; i < exts.length; ++i)$105b92724c1ce1a5$var$_fillMissingExtensionFields(exts[i], {
            cert: cert
        });
        // set new extensions
        cert.extensions = exts;
    };
    /**
   * Gets an extension by its name or id.
   *
   * @param options the name to use or an object with:
   *          name the name to use.
   *          id the id to use.
   *
   * @return the extension or null if not found.
   */ cert.getExtension = function(options) {
        if (typeof options === "string") options = {
            name: options
        };
        var rval = null;
        var ext;
        for(var i = 0; rval === null && i < cert.extensions.length; ++i){
            ext = cert.extensions[i];
            if (options.id && ext.id === options.id) rval = ext;
            else if (options.name && ext.name === options.name) rval = ext;
        }
        return rval;
    };
    /**
   * Signs this certificate using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ cert.sign = function(key, md) {
        // TODO: get signature OID from private key
        cert.md = md || $dEd5p.md.sha1.create();
        var algorithmOid = $105b92724c1ce1a5$var$oids[cert.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
            error.algorithm = cert.md.algorithm;
            throw error;
        }
        cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid;
        // get TBSCertificate, convert to DER
        cert.tbsCertificate = $105b92724c1ce1a5$var$pki.getTBSCertificate(cert);
        var bytes = $105b92724c1ce1a5$var$asn1.toDer(cert.tbsCertificate);
        // digest and sign
        cert.md.update(bytes.getBytes());
        cert.signature = key.sign(cert.md);
    };
    /**
   * Attempts verify the signature on the passed certificate using this
   * certificate's public key.
   *
   * @param child the certificate to verify.
   *
   * @return true if verified, false if not.
   */ cert.verify = function(child) {
        var rval = false;
        if (!cert.issued(child)) {
            var issuer = child.issuer;
            var subject = cert.subject;
            var error = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
            error.expectedIssuer = subject.attributes;
            error.actualIssuer = issuer.attributes;
            throw error;
        }
        var md = child.md;
        if (md === null) {
            // create digest for OID signature types
            md = $105b92724c1ce1a5$var$_createSignatureDigest({
                signatureOid: child.signatureOid,
                type: "certificate"
            });
            // produce DER formatted TBSCertificate and digest it
            var tbsCertificate = child.tbsCertificate || $105b92724c1ce1a5$var$pki.getTBSCertificate(child);
            var bytes = $105b92724c1ce1a5$var$asn1.toDer(tbsCertificate);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $105b92724c1ce1a5$var$_verifySignature({
            certificate: cert,
            md: md,
            signature: child.signature
        });
        return rval;
    };
    /**
   * Returns true if this certificate's issuer matches the passed
   * certificate's subject. Note that no signature check is performed.
   *
   * @param parent the certificate to check.
   *
   * @return true if this certificate's issuer matches the passed certificate's
   *         subject.
   */ cert.isIssuer = function(parent) {
        var rval = false;
        var i = cert.issuer;
        var s = parent.subject;
        // compare hashes if present
        if (i.hash && s.hash) rval = i.hash === s.hash;
        else if (i.attributes.length === s.attributes.length) {
            // all attributes are the same so issuer matches subject
            rval = true;
            var iattr, sattr;
            for(var n = 0; rval && n < i.attributes.length; ++n){
                iattr = i.attributes[n];
                sattr = s.attributes[n];
                if (iattr.type !== sattr.type || iattr.value !== sattr.value) // attribute mismatch
                rval = false;
            }
        }
        return rval;
    };
    /**
   * Returns true if this certificate's subject matches the issuer of the
   * given certificate). Note that not signature check is performed.
   *
   * @param child the certificate to check.
   *
   * @return true if this certificate's subject matches the passed
   *         certificate's issuer.
   */ cert.issued = function(child) {
        return child.isIssuer(cert);
    };
    /**
   * Generates the subjectKeyIdentifier for this certificate as byte buffer.
   *
   * @return the subjectKeyIdentifier for this certificate as byte buffer.
   */ cert.generateSubjectKeyIdentifier = function() {
        /* See: 4.2.1.2 section of the the RFC3280, keyIdentifier is either:

      (1) The keyIdentifier is composed of the 160-bit SHA-1 hash of the
        value of the BIT STRING subjectPublicKey (excluding the tag,
        length, and number of unused bits).

      (2) The keyIdentifier is composed of a four bit type field with
        the value 0100 followed by the least significant 60 bits of the
        SHA-1 hash of the value of the BIT STRING subjectPublicKey
        (excluding the tag, length, and number of unused bit string bits).
    */ // skipping the tag, length, and number of unused bits is the same
        // as just using the RSAPublicKey (for RSA keys, which are the
        // only ones supported)
        return $105b92724c1ce1a5$var$pki.getPublicKeyFingerprint(cert.publicKey, {
            type: "RSAPublicKey"
        });
    };
    /**
   * Verifies the subjectKeyIdentifier extension value for this certificate
   * against its public key. If no extension is found, false will be
   * returned.
   *
   * @return true if verified, false if not.
   */ cert.verifySubjectKeyIdentifier = function() {
        var oid = $105b92724c1ce1a5$var$oids["subjectKeyIdentifier"];
        for(var i = 0; i < cert.extensions.length; ++i){
            var ext = cert.extensions[i];
            if (ext.id === oid) {
                var ski = cert.generateSubjectKeyIdentifier().getBytes();
                return $dEd5p.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
            }
        }
        return false;
    };
    return cert;
};
/**
 * Converts an X.509v3 RSA certificate from an ASN.1 object.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the TBSCertificate part of the ASN.1
 * object needs to be scanned before the cert object is created.
 *
 * @param obj the asn1 representation of an X.509v3 RSA certificate.
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certificate.
 */ $105b92724c1ce1a5$var$pki.certificateFromAsn1 = function(obj, computeHash) {
    // validate certificate and capture data
    var capture = {};
    var errors = [];
    if (!$105b92724c1ce1a5$var$asn1.validate(obj, $105b92724c1ce1a5$var$x509CertificateValidator, capture, errors)) {
        var error = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $105b92724c1ce1a5$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $105b92724c1ce1a5$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certificate
    var cert = $105b92724c1ce1a5$var$pki.createCertificate();
    cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
    var serial = $dEd5p.util.createBuffer(capture.certSerialNumber);
    cert.serialNumber = serial.toHex();
    cert.signatureOid = $dEd5p.asn1.derToOid(capture.certSignatureOid);
    cert.signatureParameters = $105b92724c1ce1a5$var$_readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
    cert.siginfo.algorithmOid = $dEd5p.asn1.derToOid(capture.certinfoSignatureOid);
    cert.siginfo.parameters = $105b92724c1ce1a5$var$_readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
    cert.signature = capture.certSignature;
    var validity = [];
    if (capture.certValidity1UTCTime !== undefined) validity.push($105b92724c1ce1a5$var$asn1.utcTimeToDate(capture.certValidity1UTCTime));
    if (capture.certValidity2GeneralizedTime !== undefined) validity.push($105b92724c1ce1a5$var$asn1.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
    if (capture.certValidity3UTCTime !== undefined) validity.push($105b92724c1ce1a5$var$asn1.utcTimeToDate(capture.certValidity3UTCTime));
    if (capture.certValidity4GeneralizedTime !== undefined) validity.push($105b92724c1ce1a5$var$asn1.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
    if (validity.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
    if (validity.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
    cert.validity.notBefore = validity[0];
    cert.validity.notAfter = validity[1];
    // keep TBSCertificate to preserve signature when exporting
    cert.tbsCertificate = capture.tbsCertificate;
    if (computeHash) {
        // create digest for OID signature type
        cert.md = $105b92724c1ce1a5$var$_createSignatureDigest({
            signatureOid: cert.signatureOid,
            type: "certificate"
        });
        // produce DER formatted TBSCertificate and digest it
        var bytes = $105b92724c1ce1a5$var$asn1.toDer(cert.tbsCertificate);
        cert.md.update(bytes.getBytes());
    }
    // handle issuer, build issuer message digest
    var imd = $dEd5p.md.sha1.create();
    var ibytes = $105b92724c1ce1a5$var$asn1.toDer(capture.certIssuer);
    imd.update(ibytes.getBytes());
    cert.issuer.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = $105b92724c1ce1a5$var$pki.RDNAttributesAsArray(capture.certIssuer);
    if (capture.certIssuerUniqueId) cert.issuer.uniqueId = capture.certIssuerUniqueId;
    cert.issuer.hash = imd.digest().toHex();
    // handle subject, build subject message digest
    var smd = $dEd5p.md.sha1.create();
    var sbytes = $105b92724c1ce1a5$var$asn1.toDer(capture.certSubject);
    smd.update(sbytes.getBytes());
    cert.subject.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = $105b92724c1ce1a5$var$pki.RDNAttributesAsArray(capture.certSubject);
    if (capture.certSubjectUniqueId) cert.subject.uniqueId = capture.certSubjectUniqueId;
    cert.subject.hash = smd.digest().toHex();
    // handle extensions
    if (capture.certExtensions) cert.extensions = $105b92724c1ce1a5$var$pki.certificateExtensionsFromAsn1(capture.certExtensions);
    else cert.extensions = [];
    // convert RSA public key from ASN.1
    cert.publicKey = $105b92724c1ce1a5$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    return cert;
};
/**
 * Converts an ASN.1 extensions object (with extension sequences as its
 * values) into an array of extension objects with types and values.
 *
 * Supported extensions:
 *
 * id-ce-keyUsage OBJECT IDENTIFIER ::=  { id-ce 15 }
 * KeyUsage ::= BIT STRING {
 *   digitalSignature        (0),
 *   nonRepudiation          (1),
 *   keyEncipherment         (2),
 *   dataEncipherment        (3),
 *   keyAgreement            (4),
 *   keyCertSign             (5),
 *   cRLSign                 (6),
 *   encipherOnly            (7),
 *   decipherOnly            (8)
 * }
 *
 * id-ce-basicConstraints OBJECT IDENTIFIER ::=  { id-ce 19 }
 * BasicConstraints ::= SEQUENCE {
 *   cA                      BOOLEAN DEFAULT FALSE,
 *   pathLenConstraint       INTEGER (0..MAX) OPTIONAL
 * }
 *
 * subjectAltName EXTENSION ::= {
 *   SYNTAX GeneralNames
 *   IDENTIFIED BY id-ce-subjectAltName
 * }
 *
 * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
 *
 * GeneralName ::= CHOICE {
 *   otherName      [0] INSTANCE OF OTHER-NAME,
 *   rfc822Name     [1] IA5String,
 *   dNSName        [2] IA5String,
 *   x400Address    [3] ORAddress,
 *   directoryName  [4] Name,
 *   ediPartyName   [5] EDIPartyName,
 *   uniformResourceIdentifier [6] IA5String,
 *   IPAddress      [7] OCTET STRING,
 *   registeredID   [8] OBJECT IDENTIFIER
 * }
 *
 * OTHER-NAME ::= TYPE-IDENTIFIER
 *
 * EDIPartyName ::= SEQUENCE {
 *   nameAssigner [0] DirectoryString {ub-name} OPTIONAL,
 *   partyName    [1] DirectoryString {ub-name}
 * }
 *
 * @param exts the extensions ASN.1 with extension sequences to parse.
 *
 * @return the array.
 */ $105b92724c1ce1a5$var$pki.certificateExtensionsFromAsn1 = function(exts) {
    var rval = [];
    for(var i = 0; i < exts.value.length; ++i){
        // get extension sequence
        var extseq = exts.value[i];
        for(var ei = 0; ei < extseq.value.length; ++ei)rval.push($105b92724c1ce1a5$var$pki.certificateExtensionFromAsn1(extseq.value[ei]));
    }
    return rval;
};
/**
 * Parses a single certificate extension from ASN.1.
 *
 * @param ext the extension in ASN.1 format.
 *
 * @return the parsed extension as an object.
 */ $105b92724c1ce1a5$var$pki.certificateExtensionFromAsn1 = function(ext) {
    // an extension has:
    // [0] extnID      OBJECT IDENTIFIER
    // [1] critical    BOOLEAN DEFAULT FALSE
    // [2] extnValue   OCTET STRING
    var e = {};
    e.id = $105b92724c1ce1a5$var$asn1.derToOid(ext.value[0].value);
    e.critical = false;
    if (ext.value[1].type === $105b92724c1ce1a5$var$asn1.Type.BOOLEAN) {
        e.critical = ext.value[1].value.charCodeAt(0) !== 0x00;
        e.value = ext.value[2].value;
    } else e.value = ext.value[1].value;
    // if the oid is known, get its name
    if (e.id in $105b92724c1ce1a5$var$oids) {
        e.name = $105b92724c1ce1a5$var$oids[e.id];
        // handle key usage
        if (e.name === "keyUsage") {
            // get value as BIT STRING
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            var b3 = 0x00;
            if (ev.value.length > 1) {
                // skip first byte, just indicates unused bits which
                // will be padded with 0s anyway
                // get bytes with flag bits
                b2 = ev.value.charCodeAt(1);
                b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
            }
            // set flags
            e.digitalSignature = (b2 & 0x80) === 0x80;
            e.nonRepudiation = (b2 & 0x40) === 0x40;
            e.keyEncipherment = (b2 & 0x20) === 0x20;
            e.dataEncipherment = (b2 & 0x10) === 0x10;
            e.keyAgreement = (b2 & 0x08) === 0x08;
            e.keyCertSign = (b2 & 0x04) === 0x04;
            e.cRLSign = (b2 & 0x02) === 0x02;
            e.encipherOnly = (b2 & 0x01) === 0x01;
            e.decipherOnly = (b3 & 0x80) === 0x80;
        } else if (e.name === "basicConstraints") {
            // handle basic constraints
            // get value as SEQUENCE
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            // get cA BOOLEAN flag (defaults to false)
            if (ev.value.length > 0 && ev.value[0].type === $105b92724c1ce1a5$var$asn1.Type.BOOLEAN) e.cA = ev.value[0].value.charCodeAt(0) !== 0x00;
            else e.cA = false;
            // get path length constraint
            var value = null;
            if (ev.value.length > 0 && ev.value[0].type === $105b92724c1ce1a5$var$asn1.Type.INTEGER) value = ev.value[0].value;
            else if (ev.value.length > 1) value = ev.value[1].value;
            if (value !== null) e.pathLenConstraint = $105b92724c1ce1a5$var$asn1.derToInteger(value);
        } else if (e.name === "extKeyUsage") {
            // handle extKeyUsage
            // value is a SEQUENCE of OIDs
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            for(var vi = 0; vi < ev.value.length; ++vi){
                var oid = $105b92724c1ce1a5$var$asn1.derToOid(ev.value[vi].value);
                if (oid in $105b92724c1ce1a5$var$oids) e[$105b92724c1ce1a5$var$oids[oid]] = true;
                else e[oid] = true;
            }
        } else if (e.name === "nsCertType") {
            // handle nsCertType
            // get value as BIT STRING
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            if (ev.value.length > 1) // skip first byte, just indicates unused bits which
            // will be padded with 0s anyway
            // get bytes with flag bits
            b2 = ev.value.charCodeAt(1);
            // set flags
            e.client = (b2 & 0x80) === 0x80;
            e.server = (b2 & 0x40) === 0x40;
            e.email = (b2 & 0x20) === 0x20;
            e.objsign = (b2 & 0x10) === 0x10;
            e.reserved = (b2 & 0x08) === 0x08;
            e.sslCA = (b2 & 0x04) === 0x04;
            e.emailCA = (b2 & 0x02) === 0x02;
            e.objCA = (b2 & 0x01) === 0x01;
        } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
            // handle subjectAltName/issuerAltName
            e.altNames = [];
            // ev is a SYNTAX SEQUENCE
            var gn;
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            for(var n = 0; n < ev.value.length; ++n){
                // get GeneralName
                gn = ev.value[n];
                var altName = {
                    type: gn.type,
                    value: gn.value
                };
                e.altNames.push(altName);
                // Note: Support for types 1,2,6,7,8
                switch(gn.type){
                    // rfc822Name
                    case 1:
                    // dNSName
                    case 2:
                    // uniformResourceIdentifier (URI)
                    case 6:
                        break;
                    // IPAddress
                    case 7:
                        // convert to IPv4/IPv6 string representation
                        altName.ip = $dEd5p.util.bytesToIP(gn.value);
                        break;
                    // registeredID
                    case 8:
                        altName.oid = $105b92724c1ce1a5$var$asn1.derToOid(gn.value);
                        break;
                    default:
                }
            }
        } else if (e.name === "subjectKeyIdentifier") {
            // value is an OCTETSTRING w/the hash of the key-type specific
            // public key structure (eg: RSAPublicKey)
            var ev = $105b92724c1ce1a5$var$asn1.fromDer(e.value);
            e.subjectKeyIdentifier = $dEd5p.util.bytesToHex(ev.value);
        }
    }
    return e;
};
/**
 * Converts a PKCS#10 certification request (CSR) from an ASN.1 object.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the CertificationRequestInfo part of the
 * ASN.1 object needs to be scanned before the csr object is created.
 *
 * @param obj the asn1 representation of a PKCS#10 certification request (CSR).
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certification request (CSR).
 */ $105b92724c1ce1a5$var$pki.certificationRequestFromAsn1 = function(obj, computeHash) {
    // validate certification request and capture data
    var capture = {};
    var errors = [];
    if (!$105b92724c1ce1a5$var$asn1.validate(obj, $105b92724c1ce1a5$var$certificationRequestValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $105b92724c1ce1a5$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $105b92724c1ce1a5$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certification request
    var csr = $105b92724c1ce1a5$var$pki.createCertificationRequest();
    csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
    csr.signatureOid = $dEd5p.asn1.derToOid(capture.csrSignatureOid);
    csr.signatureParameters = $105b92724c1ce1a5$var$_readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
    csr.siginfo.algorithmOid = $dEd5p.asn1.derToOid(capture.csrSignatureOid);
    csr.siginfo.parameters = $105b92724c1ce1a5$var$_readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
    csr.signature = capture.csrSignature;
    // keep CertificationRequestInfo to preserve signature when exporting
    csr.certificationRequestInfo = capture.certificationRequestInfo;
    if (computeHash) {
        // create digest for OID signature type
        csr.md = $105b92724c1ce1a5$var$_createSignatureDigest({
            signatureOid: csr.signatureOid,
            type: "certification request"
        });
        // produce DER formatted CertificationRequestInfo and digest it
        var bytes = $105b92724c1ce1a5$var$asn1.toDer(csr.certificationRequestInfo);
        csr.md.update(bytes.getBytes());
    }
    // handle subject, build subject message digest
    var smd = $dEd5p.md.sha1.create();
    csr.subject.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = $105b92724c1ce1a5$var$pki.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
    csr.subject.hash = smd.digest().toHex();
    // convert RSA public key from ASN.1
    csr.publicKey = $105b92724c1ce1a5$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    // convert attributes from ASN.1
    csr.getAttribute = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.attributes = $105b92724c1ce1a5$var$pki.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
    return csr;
};
/**
 * Creates an empty certification request (a CSR or certificate signing
 * request). Once created, its public key and attributes can be set and then
 * it can be signed.
 *
 * @return the empty certification request.
 */ $105b92724c1ce1a5$var$pki.createCertificationRequest = function() {
    var csr = {};
    csr.version = 0x00;
    csr.signatureOid = null;
    csr.signature = null;
    csr.siginfo = {};
    csr.siginfo.algorithmOid = null;
    csr.subject = {};
    csr.subject.getField = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = [];
    csr.subject.hash = null;
    csr.publicKey = null;
    csr.attributes = [];
    csr.getAttribute = function(sn) {
        return $105b92724c1ce1a5$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $105b92724c1ce1a5$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.md = null;
    /**
   * Sets the subject of this certification request.
   *
   * @param attrs the array of subject attributes to use.
   */ csr.setSubject = function(attrs) {
        // set new attributes
        $105b92724c1ce1a5$var$_fillMissingFields(attrs);
        csr.subject.attributes = attrs;
        csr.subject.hash = null;
    };
    /**
   * Sets the attributes of this certification request.
   *
   * @param attrs the array of attributes to use.
   */ csr.setAttributes = function(attrs) {
        // set new attributes
        $105b92724c1ce1a5$var$_fillMissingFields(attrs);
        csr.attributes = attrs;
    };
    /**
   * Signs this certification request using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ csr.sign = function(key, md) {
        // TODO: get signature OID from private key
        csr.md = md || $dEd5p.md.sha1.create();
        var algorithmOid = $105b92724c1ce1a5$var$oids[csr.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
            error.algorithm = csr.md.algorithm;
            throw error;
        }
        csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid;
        // get CertificationRequestInfo, convert to DER
        csr.certificationRequestInfo = $105b92724c1ce1a5$var$pki.getCertificationRequestInfo(csr);
        var bytes = $105b92724c1ce1a5$var$asn1.toDer(csr.certificationRequestInfo);
        // digest and sign
        csr.md.update(bytes.getBytes());
        csr.signature = key.sign(csr.md);
    };
    /**
   * Attempts verify the signature on the passed certification request using
   * its public key.
   *
   * A CSR that has been exported to a file in PEM format can be verified using
   * OpenSSL using this command:
   *
   * openssl req -in <the-csr-pem-file> -verify -noout -text
   *
   * @return true if verified, false if not.
   */ csr.verify = function() {
        var rval = false;
        var md = csr.md;
        if (md === null) {
            md = $105b92724c1ce1a5$var$_createSignatureDigest({
                signatureOid: csr.signatureOid,
                type: "certification request"
            });
            // produce DER formatted CertificationRequestInfo and digest it
            var cri = csr.certificationRequestInfo || $105b92724c1ce1a5$var$pki.getCertificationRequestInfo(csr);
            var bytes = $105b92724c1ce1a5$var$asn1.toDer(cri);
            md.update(bytes.getBytes());
        }
        if (md !== null) rval = $105b92724c1ce1a5$var$_verifySignature({
            certificate: csr,
            md: md,
            signature: csr.signature
        });
        return rval;
    };
    return csr;
};
/**
 * Converts an X.509 subject or issuer to an ASN.1 RDNSequence.
 *
 * @param obj the subject or issuer (distinguished name).
 *
 * @return the ASN.1 RDNSequence.
 */ function $105b92724c1ce1a5$var$_dnToAsn1(obj) {
    // create an empty RDNSequence
    var rval = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
    // iterate over attributes
    var attr, set;
    var attrs = obj.attributes;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $105b92724c1ce1a5$var$asn1.Type.PRINTABLESTRING;
        if ("valueTagClass" in attr) {
            valueTagClass = attr.valueTagClass;
            if (valueTagClass === $105b92724c1ce1a5$var$asn1.Type.UTF8) value = $dEd5p.util.encodeUtf8(value);
        // FIXME: handle more encodings
        }
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        set = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SET, true, [
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
                // AttributeType
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(attr.type).getBytes()),
                // AttributeValue
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, valueTagClass, false, value)
            ])
        ]);
        rval.value.push(set);
    }
    return rval;
}
/**
 * Gets all printable attributes (typically of an issuer or subject) in a
 * simplified JSON format for display.
 *
 * @param attrs the attributes.
 *
 * @return the JSON for display.
 */ function $105b92724c1ce1a5$var$_getAttributesAsJson(attrs) {
    var rval = {};
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        if (attr.shortName && (attr.valueTagClass === $105b92724c1ce1a5$var$asn1.Type.UTF8 || attr.valueTagClass === $105b92724c1ce1a5$var$asn1.Type.PRINTABLESTRING || attr.valueTagClass === $105b92724c1ce1a5$var$asn1.Type.IA5STRING)) {
            var value = attr.value;
            if (attr.valueTagClass === $105b92724c1ce1a5$var$asn1.Type.UTF8) value = $dEd5p.util.encodeUtf8(attr.value);
            if (!(attr.shortName in rval)) rval[attr.shortName] = value;
            else if ($dEd5p.util.isArray(rval[attr.shortName])) rval[attr.shortName].push(value);
            else rval[attr.shortName] = [
                rval[attr.shortName],
                value
            ];
        }
    }
    return rval;
}
/**
 * Fills in missing fields in attributes.
 *
 * @param attrs the attributes to fill missing fields in.
 */ function $105b92724c1ce1a5$var$_fillMissingFields(attrs) {
    var attr;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        // populate missing name
        if (typeof attr.name === "undefined") {
            if (attr.type && attr.type in $105b92724c1ce1a5$var$pki.oids) attr.name = $105b92724c1ce1a5$var$pki.oids[attr.type];
            else if (attr.shortName && attr.shortName in $105b92724c1ce1a5$var$_shortNames) attr.name = $105b92724c1ce1a5$var$pki.oids[$105b92724c1ce1a5$var$_shortNames[attr.shortName]];
        }
        // populate missing type (OID)
        if (typeof attr.type === "undefined") {
            if (attr.name && attr.name in $105b92724c1ce1a5$var$pki.oids) attr.type = $105b92724c1ce1a5$var$pki.oids[attr.name];
            else {
                var error = new Error("Attribute type not specified.");
                error.attribute = attr;
                throw error;
            }
        }
        // populate missing shortname
        if (typeof attr.shortName === "undefined") {
            if (attr.name && attr.name in $105b92724c1ce1a5$var$_shortNames) attr.shortName = $105b92724c1ce1a5$var$_shortNames[attr.name];
        }
        // convert extensions to value
        if (attr.type === $105b92724c1ce1a5$var$oids.extensionRequest) {
            attr.valueConstructed = true;
            attr.valueTagClass = $105b92724c1ce1a5$var$asn1.Type.SEQUENCE;
            if (!attr.value && attr.extensions) {
                attr.value = [];
                for(var ei = 0; ei < attr.extensions.length; ++ei)attr.value.push($105b92724c1ce1a5$var$pki.certificateExtensionToAsn1($105b92724c1ce1a5$var$_fillMissingExtensionFields(attr.extensions[ei])));
            }
        }
        if (typeof attr.value === "undefined") {
            var error = new Error("Attribute value not specified.");
            error.attribute = attr;
            throw error;
        }
    }
}
/**
 * Fills in missing fields in certificate extensions.
 *
 * @param e the extension.
 * @param [options] the options to use.
 *          [cert] the certificate the extensions are for.
 *
 * @return the extension.
 */ function $105b92724c1ce1a5$var$_fillMissingExtensionFields(e, options) {
    options = options || {};
    // populate missing name
    if (typeof e.name === "undefined") {
        if (e.id && e.id in $105b92724c1ce1a5$var$pki.oids) e.name = $105b92724c1ce1a5$var$pki.oids[e.id];
    }
    // populate missing id
    if (typeof e.id === "undefined") {
        if (e.name && e.name in $105b92724c1ce1a5$var$pki.oids) e.id = $105b92724c1ce1a5$var$pki.oids[e.name];
        else {
            var error = new Error("Extension ID not specified.");
            error.extension = e;
            throw error;
        }
    }
    if (typeof e.value !== "undefined") return e;
    // handle missing value:
    // value is a BIT STRING
    if (e.name === "keyUsage") {
        // build flags
        var unused = 0;
        var b2 = 0x00;
        var b3 = 0x00;
        if (e.digitalSignature) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.nonRepudiation) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.keyEncipherment) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.dataEncipherment) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.keyAgreement) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.keyCertSign) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.cRLSign) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.encipherOnly) {
            b2 |= 0x01;
            unused = 0;
        }
        if (e.decipherOnly) {
            b3 |= 0x80;
            unused = 7;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b3 !== 0) value += String.fromCharCode(b2) + String.fromCharCode(b3);
        else if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "basicConstraints") {
        // basicConstraints is a SEQUENCE
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        // cA BOOLEAN flag defaults to false
        if (e.cA) e.value.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
        if ("pathLenConstraint" in e) e.value.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.INTEGER, false, $105b92724c1ce1a5$var$asn1.integerToDer(e.pathLenConstraint).getBytes()));
    } else if (e.name === "extKeyUsage") {
        // extKeyUsage is a SEQUENCE of OIDs
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        for(var key in e){
            if (e[key] !== true) continue;
            // key is name in OID map
            if (key in $105b92724c1ce1a5$var$oids) seq.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer($105b92724c1ce1a5$var$oids[key]).getBytes()));
            else if (key.indexOf(".") !== -1) // assume key is an OID
            seq.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(key).getBytes()));
        }
    } else if (e.name === "nsCertType") {
        // nsCertType is a BIT STRING
        // build flags
        var unused = 0;
        var b2 = 0x00;
        if (e.client) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.server) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.email) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.objsign) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.reserved) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.sslCA) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.emailCA) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.objCA) {
            b2 |= 0x01;
            unused = 0;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
        // SYNTAX SEQUENCE
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $dEd5p.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $105b92724c1ce1a5$var$asn1.oidToDer($105b92724c1ce1a5$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $105b92724c1ce1a5$var$asn1.oidToDer(value);
            }
            e.value.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
    } else if (e.name === "nsComment" && options.cert) {
        // sanity check value is ASCII (req'd) and not too big
        if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        // IA5STRING opaque comment
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.IA5STRING, false, e.comment);
    } else if (e.name === "subjectKeyIdentifier" && options.cert) {
        var ski = options.cert.generateSubjectKeyIdentifier();
        e.subjectKeyIdentifier = ski.toHex();
        // OCTETSTRING w/digest
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OCTETSTRING, false, ski.getBytes());
    } else if (e.name === "authorityKeyIdentifier" && options.cert) {
        // SYNTAX SEQUENCE
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        if (e.keyIdentifier) {
            var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
            seq.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
        }
        if (e.authorityCertIssuer) {
            var authorityCertIssuer = [
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 4, true, [
                    $105b92724c1ce1a5$var$_dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)
                ])
            ];
            seq.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
        }
        if (e.serialNumber) {
            var serialNumber = $dEd5p.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
            seq.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
        }
    } else if (e.name === "cRLDistributionPoints") {
        e.value = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        // Create sub SEQUENCE of DistributionPointName
        var subSeq = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
        // Create fullName CHOICE
        var fullNameGeneralNames = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $dEd5p.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $105b92724c1ce1a5$var$asn1.oidToDer($105b92724c1ce1a5$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $105b92724c1ce1a5$var$asn1.oidToDer(value);
            }
            fullNameGeneralNames.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
        // Add to the parent SEQUENCE
        subSeq.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            fullNameGeneralNames
        ]));
        seq.push(subSeq);
    }
    // ensure value has been defined by now
    if (typeof e.value === "undefined") {
        var error = new Error("Extension value not specified.");
        error.extension = e;
        throw error;
    }
    return e;
}
/**
 * Convert signature parameters object to ASN.1
 *
 * @param {String} oid Signature algorithm OID
 * @param params The signature parametrs object
 * @return ASN.1 object representing signature parameters
 */ function $105b92724c1ce1a5$var$_signatureParametersToAsn1(oid, params) {
    switch(oid){
        case $105b92724c1ce1a5$var$oids["RSASSA-PSS"]:
            var parts = [];
            if (params.hash.algorithmOid !== undefined) parts.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
                    $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(params.hash.algorithmOid).getBytes()),
                    $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.NULL, false, "")
                ])
            ]));
            if (params.mgf.algorithmOid !== undefined) parts.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
                    $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(params.mgf.algorithmOid).getBytes()),
                    $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
                        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(params.mgf.hash.algorithmOid).getBytes()),
                        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.NULL, false, "")
                    ])
                ])
            ]));
            if (params.saltLength !== undefined) parts.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.INTEGER, false, $105b92724c1ce1a5$var$asn1.integerToDer(params.saltLength).getBytes())
            ]));
            return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, parts);
        default:
            return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.NULL, false, "");
    }
}
/**
 * Converts a certification request's attributes to an ASN.1 set of
 * CRIAttributes.
 *
 * @param csr certification request.
 *
 * @return the ASN.1 set of CRIAttributes.
 */ function $105b92724c1ce1a5$var$_CRIAttributesToAsn1(csr) {
    // create an empty context-specific container
    var rval = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
    // no attributes, return empty container
    if (csr.attributes.length === 0) return rval;
    // each attribute has a sequence with a type and a set of values
    var attrs = csr.attributes;
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $105b92724c1ce1a5$var$asn1.Type.UTF8;
        if ("valueTagClass" in attr) valueTagClass = attr.valueTagClass;
        if (valueTagClass === $105b92724c1ce1a5$var$asn1.Type.UTF8) value = $dEd5p.util.encodeUtf8(value);
        var valueConstructed = false;
        if ("valueConstructed" in attr) valueConstructed = attr.valueConstructed;
        // FIXME: handle more encodings
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        var seq = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
            // AttributeType
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(attr.type).getBytes()),
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SET, true, [
                // AttributeValue
                $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, valueTagClass, valueConstructed, value)
            ])
        ]);
        rval.value.push(seq);
    }
    return rval;
}
var $105b92724c1ce1a5$var$jan_1_1950 = new Date("1950-01-01T00:00:00Z");
var $105b92724c1ce1a5$var$jan_1_2050 = new Date("2050-01-01T00:00:00Z");
/**
 * Converts a Date object to ASN.1
 * Handles the different format before and after 1st January 2050
 *
 * @param date date object.
 *
 * @return the ASN.1 object representing the date.
 */ function $105b92724c1ce1a5$var$_dateToAsn1(date) {
    if (date >= $105b92724c1ce1a5$var$jan_1_1950 && date < $105b92724c1ce1a5$var$jan_1_2050) return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.UTCTIME, false, $105b92724c1ce1a5$var$asn1.dateToUtcTime(date));
    else return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.GENERALIZEDTIME, false, $105b92724c1ce1a5$var$asn1.dateToGeneralizedTime(date));
}
/**
 * Gets the ASN.1 TBSCertificate part of an X.509v3 certificate.
 *
 * @param cert the certificate.
 *
 * @return the asn1 TBSCertificate.
 */ $105b92724c1ce1a5$var$pki.getTBSCertificate = function(cert) {
    // TBSCertificate
    var notBefore = $105b92724c1ce1a5$var$_dateToAsn1(cert.validity.notBefore);
    var notAfter = $105b92724c1ce1a5$var$_dateToAsn1(cert.validity.notAfter);
    var tbs = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
        // version
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            // integer
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.INTEGER, false, $105b92724c1ce1a5$var$asn1.integerToDer(cert.version).getBytes())
        ]),
        // serialNumber
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.INTEGER, false, $dEd5p.util.hexToBytes(cert.serialNumber)),
        // signature
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(cert.siginfo.algorithmOid).getBytes()),
            // parameters
            $105b92724c1ce1a5$var$_signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)
        ]),
        // issuer
        $105b92724c1ce1a5$var$_dnToAsn1(cert.issuer),
        // validity
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
            notBefore,
            notAfter
        ]),
        // subject
        $105b92724c1ce1a5$var$_dnToAsn1(cert.subject),
        // SubjectPublicKeyInfo
        $105b92724c1ce1a5$var$pki.publicKeyToAsn1(cert.publicKey)
    ]);
    if (cert.issuer.uniqueId) // issuerUniqueID (optional)
    tbs.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.issuer.uniqueId)
    ]));
    if (cert.subject.uniqueId) // subjectUniqueID (optional)
    tbs.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.subject.uniqueId)
    ]));
    if (cert.extensions.length > 0) // extensions (optional)
    tbs.value.push($105b92724c1ce1a5$var$pki.certificateExtensionsToAsn1(cert.extensions));
    return tbs;
};
/**
 * Gets the ASN.1 CertificationRequestInfo part of a
 * PKCS#10 CertificationRequest.
 *
 * @param csr the certification request.
 *
 * @return the asn1 CertificationRequestInfo.
 */ $105b92724c1ce1a5$var$pki.getCertificationRequestInfo = function(csr) {
    // CertificationRequestInfo
    var cri = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
        // version
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.INTEGER, false, $105b92724c1ce1a5$var$asn1.integerToDer(csr.version).getBytes()),
        // subject
        $105b92724c1ce1a5$var$_dnToAsn1(csr.subject),
        // SubjectPublicKeyInfo
        $105b92724c1ce1a5$var$pki.publicKeyToAsn1(csr.publicKey),
        // attributes
        $105b92724c1ce1a5$var$_CRIAttributesToAsn1(csr)
    ]);
    return cri;
};
/**
 * Converts a DistinguishedName (subject or issuer) to an ASN.1 object.
 *
 * @param dn the DistinguishedName.
 *
 * @return the asn1 representation of a DistinguishedName.
 */ $105b92724c1ce1a5$var$pki.distinguishedNameToAsn1 = function(dn) {
    return $105b92724c1ce1a5$var$_dnToAsn1(dn);
};
/**
 * Converts an X.509v3 RSA certificate to an ASN.1 object.
 *
 * @param cert the certificate.
 *
 * @return the asn1 representation of an X.509v3 RSA certificate.
 */ $105b92724c1ce1a5$var$pki.certificateToAsn1 = function(cert) {
    // prefer cached TBSCertificate over generating one
    var tbsCertificate = cert.tbsCertificate || $105b92724c1ce1a5$var$pki.getTBSCertificate(cert);
    // Certificate
    return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
        // TBSCertificate
        tbsCertificate,
        // AlgorithmIdentifier (signature algorithm)
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(cert.signatureOid).getBytes()),
            // parameters
            $105b92724c1ce1a5$var$_signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)
        ]),
        // SignatureValue
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + cert.signature)
    ]);
};
/**
 * Converts X.509v3 certificate extensions to ASN.1.
 *
 * @param exts the extensions to convert.
 *
 * @return the extensions in ASN.1 format.
 */ $105b92724c1ce1a5$var$pki.certificateExtensionsToAsn1 = function(exts) {
    // create top-level extension container
    var rval = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.CONTEXT_SPECIFIC, 3, true, []);
    // create extension sequence (stores a sequence for each extension)
    var seq = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
    rval.value.push(seq);
    for(var i = 0; i < exts.length; ++i)seq.value.push($105b92724c1ce1a5$var$pki.certificateExtensionToAsn1(exts[i]));
    return rval;
};
/**
 * Converts a single certificate extension to ASN.1.
 *
 * @param ext the extension to convert.
 *
 * @return the extension in ASN.1 format.
 */ $105b92724c1ce1a5$var$pki.certificateExtensionToAsn1 = function(ext) {
    // create a sequence for each extension
    var extseq = $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, []);
    // extnID (OID)
    extseq.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(ext.id).getBytes()));
    // critical defaults to false
    if (ext.critical) // critical BOOLEAN DEFAULT FALSE
    extseq.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
    var value = ext.value;
    if (typeof ext.value !== "string") // value is asn.1
    value = $105b92724c1ce1a5$var$asn1.toDer(value).getBytes();
    // extnValue (OCTET STRING)
    extseq.value.push($105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OCTETSTRING, false, value));
    return extseq;
};
/**
 * Converts a PKCS#10 certification request to an ASN.1 object.
 *
 * @param csr the certification request.
 *
 * @return the asn1 representation of a certification request.
 */ $105b92724c1ce1a5$var$pki.certificationRequestToAsn1 = function(csr) {
    // prefer cached CertificationRequestInfo over generating one
    var cri = csr.certificationRequestInfo || $105b92724c1ce1a5$var$pki.getCertificationRequestInfo(csr);
    // Certificate
    return $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
        // CertificationRequestInfo
        cri,
        // AlgorithmIdentifier (signature algorithm)
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.OID, false, $105b92724c1ce1a5$var$asn1.oidToDer(csr.signatureOid).getBytes()),
            // parameters
            $105b92724c1ce1a5$var$_signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)
        ]),
        // signature
        $105b92724c1ce1a5$var$asn1.create($105b92724c1ce1a5$var$asn1.Class.UNIVERSAL, $105b92724c1ce1a5$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + csr.signature)
    ]);
};
/**
 * Creates a CA store.
 *
 * @param certs an optional array of certificate objects or PEM-formatted
 *          certificate strings to add to the CA store.
 *
 * @return the CA store.
 */ $105b92724c1ce1a5$var$pki.createCaStore = function(certs) {
    // create CA store
    var caStore = {
        // stored certificates
        certs: {}
    };
    /**
   * Gets the certificate that issued the passed certificate or its
   * 'parent'.
   *
   * @param cert the certificate to get the parent for.
   *
   * @return the parent certificate or null if none was found.
   */ caStore.getIssuer = function(cert) {
        var rval = getBySubject(cert.issuer);
        // see if there are multiple matches
        /*if(forge.util.isArray(rval)) {
      // TODO: resolve multiple matches by checking
      // authorityKey/subjectKey/issuerUniqueID/other identifiers, etc.
      // FIXME: or alternatively do authority key mapping
      // if possible (X.509v1 certs can't work?)
      throw new Error('Resolving multiple issuer matches not implemented yet.');
    }*/ return rval;
    };
    /**
   * Adds a trusted certificate to the store.
   *
   * @param cert the certificate to add as a trusted certificate (either a
   *          pki.certificate object or a PEM-formatted certificate).
   */ caStore.addCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $dEd5p.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) {
            if (cert.subject.hash in caStore.certs) {
                // subject hash already exists, append to array
                var tmp = caStore.certs[cert.subject.hash];
                if (!$dEd5p.util.isArray(tmp)) tmp = [
                    tmp
                ];
                tmp.push(cert);
                caStore.certs[cert.subject.hash] = tmp;
            } else caStore.certs[cert.subject.hash] = cert;
        }
    };
    /**
   * Checks to see if the given certificate is in the store.
   *
   * @param cert the certificate to check (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return true if the certificate is in the store, false if not.
   */ caStore.hasCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $dEd5p.pki.certificateFromPem(cert);
        var match = getBySubject(cert.subject);
        if (!match) return false;
        if (!$dEd5p.util.isArray(match)) match = [
            match
        ];
        // compare DER-encoding of certificates
        var der1 = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) return true;
        }
        return false;
    };
    /**
   * Lists all of the certificates kept in the store.
   *
   * @return an array of all of the pki.certificate objects in the store.
   */ caStore.listAllCertificates = function() {
        var certList = [];
        for(var hash in caStore.certs)if (caStore.certs.hasOwnProperty(hash)) {
            var value = caStore.certs[hash];
            if (!$dEd5p.util.isArray(value)) certList.push(value);
            else for(var i = 0; i < value.length; ++i)certList.push(value[i]);
        }
        return certList;
    };
    /**
   * Removes a certificate from the store.
   *
   * @param cert the certificate to remove (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return the certificate that was removed or null if the certificate
   *           wasn't in store.
   */ caStore.removeCertificate = function(cert) {
        var result;
        // convert from pem if necessary
        if (typeof cert === "string") cert = $dEd5p.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) return null;
        var match = getBySubject(cert.subject);
        if (!$dEd5p.util.isArray(match)) {
            result = caStore.certs[cert.subject.hash];
            delete caStore.certs[cert.subject.hash];
            return result;
        }
        // compare DER-encoding of certificates
        var der1 = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $105b92724c1ce1a5$var$asn1.toDer($105b92724c1ce1a5$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) {
                result = match[i];
                match.splice(i, 1);
            }
        }
        if (match.length === 0) delete caStore.certs[cert.subject.hash];
        return result;
    };
    function getBySubject(subject) {
        ensureSubjectHasHash(subject);
        return caStore.certs[subject.hash] || null;
    }
    function ensureSubjectHasHash(subject) {
        // produce subject hash if it doesn't exist
        if (!subject.hash) {
            var md = $dEd5p.md.sha1.create();
            subject.attributes = $105b92724c1ce1a5$var$pki.RDNAttributesAsArray($105b92724c1ce1a5$var$_dnToAsn1(subject), md);
            subject.hash = md.digest().toHex();
        }
    }
    // auto-add passed in certs
    if (certs) // parse PEM-formatted certificates as necessary
    for(var i = 0; i < certs.length; ++i){
        var cert = certs[i];
        caStore.addCertificate(cert);
    }
    return caStore;
};
/**
 * Certificate verification errors, based on TLS.
 */ $105b92724c1ce1a5$var$pki.certificateError = {
    bad_certificate: "forge.pki.BadCertificate",
    unsupported_certificate: "forge.pki.UnsupportedCertificate",
    certificate_revoked: "forge.pki.CertificateRevoked",
    certificate_expired: "forge.pki.CertificateExpired",
    certificate_unknown: "forge.pki.CertificateUnknown",
    unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
/**
 * Verifies a certificate chain against the given Certificate Authority store
 * with an optional custom verify callback.
 *
 * @param caStore a certificate store to verify against.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end (an array of certificates).
 * @param options a callback to be called for every certificate in the chain or
 *                  an object with:
 *                  verify a callback to be called for every certificate in the
 *                    chain
 *                  validityCheckDate the date against which the certificate
 *                    validity period should be checked. Pass null to not check
 *                    the validity period. By default, the current date is used.
 *
 * The verify callback has the following signature:
 *
 * verified - Set to true if certificate was verified, otherwise the
 *   pki.certificateError for why the certificate failed.
 * depth - The current index in the chain, where 0 is the end point's cert.
 * certs - The certificate chain, *NOTE* an empty chain indicates an anonymous
 *   end point.
 *
 * The function returns true on success and on failure either the appropriate
 * pki.certificateError or an object with 'error' set to the appropriate
 * pki.certificateError and 'message' set to a custom error message.
 *
 * @return true if successful, error thrown if not.
 */ $105b92724c1ce1a5$var$pki.verifyCertificateChain = function(caStore, chain, options) {
    /* From: RFC3280 - Internet X.509 Public Key Infrastructure Certificate
    Section 6: Certification Path Validation
    See inline parentheticals related to this particular implementation.

    The primary goal of path validation is to verify the binding between
    a subject distinguished name or a subject alternative name and subject
    public key, as represented in the end entity certificate, based on the
    public key of the trust anchor. This requires obtaining a sequence of
    certificates that support that binding. That sequence should be provided
    in the passed 'chain'. The trust anchor should be in the given CA
    store. The 'end entity' certificate is the certificate provided by the
    end point (typically a server) and is the first in the chain.

    To meet this goal, the path validation process verifies, among other
    things, that a prospective certification path (a sequence of n
    certificates or a 'chain') satisfies the following conditions:

    (a) for all x in {1, ..., n-1}, the subject of certificate x is
          the issuer of certificate x+1;

    (b) certificate 1 is issued by the trust anchor;

    (c) certificate n is the certificate to be validated; and

    (d) for all x in {1, ..., n}, the certificate was valid at the
          time in question.

    Note that here 'n' is index 0 in the chain and 1 is the last certificate
    in the chain and it must be signed by a certificate in the connection's
    CA store.

    The path validation process also determines the set of certificate
    policies that are valid for this path, based on the certificate policies
    extension, policy mapping extension, policy constraints extension, and
    inhibit any-policy extension.

    Note: Policy mapping extension not supported (Not Required).

    Note: If the certificate has an unsupported critical extension, then it
    must be rejected.

    Note: A certificate is self-issued if the DNs that appear in the subject
    and issuer fields are identical and are not empty.

    The path validation algorithm assumes the following seven inputs are
    provided to the path processing logic. What this specific implementation
    will use is provided parenthetically:

    (a) a prospective certification path of length n (the 'chain')
    (b) the current date/time: ('now').
    (c) user-initial-policy-set: A set of certificate policy identifiers
          naming the policies that are acceptable to the certificate user.
          The user-initial-policy-set contains the special value any-policy
          if the user is not concerned about certificate policy
          (Not implemented. Any policy is accepted).
    (d) trust anchor information, describing a CA that serves as a trust
          anchor for the certification path. The trust anchor information
          includes:

      (1)  the trusted issuer name,
      (2)  the trusted public key algorithm,
      (3)  the trusted public key, and
      (4)  optionally, the trusted public key parameters associated
             with the public key.

      (Trust anchors are provided via certificates in the CA store).

      The trust anchor information may be provided to the path processing
      procedure in the form of a self-signed certificate. The trusted anchor
      information is trusted because it was delivered to the path processing
      procedure by some trustworthy out-of-band procedure. If the trusted
      public key algorithm requires parameters, then the parameters are
      provided along with the trusted public key (No parameters used in this
      implementation).

    (e) initial-policy-mapping-inhibit, which indicates if policy mapping is
          allowed in the certification path.
          (Not implemented, no policy checking)

    (f) initial-explicit-policy, which indicates if the path must be valid
          for at least one of the certificate policies in the user-initial-
          policy-set.
          (Not implemented, no policy checking)

    (g) initial-any-policy-inhibit, which indicates whether the
          anyPolicy OID should be processed if it is included in a
          certificate.
          (Not implemented, so any policy is valid provided that it is
          not marked as critical) */ /* Basic Path Processing:

    For each certificate in the 'chain', the following is checked:

    1. The certificate validity period includes the current time.
    2. The certificate was signed by its parent (where the parent is either
       the next in the chain or from the CA store). Allow processing to
       continue to the next step if no parent is found but the certificate is
       in the CA store.
    3. TODO: The certificate has not been revoked.
    4. The certificate issuer name matches the parent's subject name.
    5. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is within one of the permitted subtrees of X.500 distinguished names
       and that each of the alternative names in the subjectAltName extension
       (critical or non-critical) is within one of the permitted subtrees for
       that name type.
    6. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is not within one of the excluded subtrees for X.500 distinguished
       names and none of the subjectAltName extension names are excluded for
       that name type.
    7. The other steps in the algorithm for basic path processing involve
       handling the policy extension which is not presently supported in this
       implementation. Instead, if a critical policy extension is found, the
       certificate is rejected as not supported.
    8. If the certificate is not the first or if its the only certificate in
       the chain (having no parent from the CA store or is self-signed) and it
       has a critical key usage extension, verify that the keyCertSign bit is
       set. If the key usage extension exists, verify that the basic
       constraints extension exists. If the basic constraints extension exists,
       verify that the cA flag is set. If pathLenConstraint is set, ensure that
       the number of certificates that precede in the chain (come earlier
       in the chain as implemented below), excluding the very first in the
       chain (typically the end-entity one), isn't greater than the
       pathLenConstraint. This constraint limits the number of intermediate
       CAs that may appear below a CA before only end-entity certificates
       may be issued. */ // if a verify callback is passed as the third parameter, package it within
    // the options object. This is to support a legacy function signature that
    // expected the verify callback as the third parameter.
    if (typeof options === "function") options = {
        verify: options
    };
    options = options || {};
    // copy cert chain references to another array to protect against changes
    // in verify callback
    chain = chain.slice(0);
    var certs = chain.slice(0);
    var validityCheckDate = options.validityCheckDate;
    // if no validityCheckDate is specified, default to the current date. Make
    // sure to maintain the value null because it indicates that the validity
    // period should not be checked.
    if (typeof validityCheckDate === "undefined") validityCheckDate = new Date();
    // verify each cert in the chain using its parent, where the parent
    // is either the next in the chain or from the CA store
    var first = true;
    var error = null;
    var depth = 0;
    do {
        var cert = chain.shift();
        var parent = null;
        var selfSigned = false;
        if (validityCheckDate) // 1. check valid time
        {
            if (validityCheckDate < cert.validity.notBefore || validityCheckDate > cert.validity.notAfter) error = {
                message: "Certificate is not valid yet or has expired.",
                error: $105b92724c1ce1a5$var$pki.certificateError.certificate_expired,
                notBefore: cert.validity.notBefore,
                notAfter: cert.validity.notAfter,
                // TODO: we might want to reconsider renaming 'now' to
                // 'validityCheckDate' should this API be changed in the future.
                now: validityCheckDate
            };
        }
        // 2. verify with parent from chain or CA store
        if (error === null) {
            parent = chain[0] || caStore.getIssuer(cert);
            if (parent === null) // check for self-signed cert
            {
                if (cert.isIssuer(cert)) {
                    selfSigned = true;
                    parent = cert;
                }
            }
            if (parent) {
                // FIXME: current CA store implementation might have multiple
                // certificates where the issuer can't be determined from the
                // certificate (happens rarely with, eg: old certificates) so normalize
                // by always putting parents into an array
                // TODO: there's may be an extreme degenerate case currently uncovered
                // where an old intermediate certificate seems to have a matching parent
                // but none of the parents actually verify ... but the intermediate
                // is in the CA and it should pass this check; needs investigation
                var parents = parent;
                if (!$dEd5p.util.isArray(parents)) parents = [
                    parents
                ];
                // try to verify with each possible parent (typically only one)
                var verified = false;
                while(!verified && parents.length > 0){
                    parent = parents.shift();
                    try {
                        verified = parent.verify(cert);
                    } catch (ex) {
                    // failure to verify, don't care why, try next one
                    }
                }
                if (!verified) error = {
                    message: "Certificate signature is invalid.",
                    error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
                };
            }
            if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) // no parent issuer and certificate itself is not trusted
            error = {
                message: "Certificate is not trusted.",
                error: $105b92724c1ce1a5$var$pki.certificateError.unknown_ca
            };
        }
        // TODO: 3. check revoked
        // 4. check for matching issuer/subject
        if (error === null && parent && !cert.isIssuer(parent)) // parent is not issuer
        error = {
            message: "Certificate issuer is invalid.",
            error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
        };
        // 5. TODO: check names with permitted names tree
        // 6. TODO: check names against excluded names tree
        // 7. check for unsupported critical extensions
        if (error === null) {
            // supported extensions
            var se = {
                keyUsage: true,
                basicConstraints: true
            };
            for(var i = 0; error === null && i < cert.extensions.length; ++i){
                var ext = cert.extensions[i];
                if (ext.critical && !(ext.name in se)) error = {
                    message: "Certificate has an unsupported critical extension.",
                    error: $105b92724c1ce1a5$var$pki.certificateError.unsupported_certificate
                };
            }
        }
        // 8. check for CA if cert is not first or is the only certificate
        // remaining in chain with no parent or is self-signed
        if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
            // first check keyUsage extension and then basic constraints
            var bcExt = cert.getExtension("basicConstraints");
            var keyUsageExt = cert.getExtension("keyUsage");
            if (keyUsageExt !== null) // keyCertSign must be true and there must be a basic
            // constraints extension
            {
                if (!keyUsageExt.keyCertSign || bcExt === null) // bad certificate
                error = {
                    message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
                    error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
                };
            }
            // basic constraints cA flag must be set
            if (error === null && bcExt !== null && !bcExt.cA) // bad certificate
            error = {
                message: "Certificate basicConstraints indicates the certificate is not a CA.",
                error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
            };
            // if error is not null and keyUsage is available, then we know it
            // has keyCertSign and there is a basic constraints extension too,
            // which means we can check pathLenConstraint (if it exists)
            if (error === null && keyUsageExt !== null && "pathLenConstraint" in bcExt) {
                // pathLen is the maximum # of intermediate CA certs that can be
                // found between the current certificate and the end-entity (depth 0)
                // certificate; this number does not include the end-entity (depth 0,
                // last in the chain) even if it happens to be a CA certificate itself
                var pathLen = depth - 1;
                if (pathLen > bcExt.pathLenConstraint) // pathLenConstraint violated, bad certificate
                error = {
                    message: "Certificate basicConstraints pathLenConstraint violated.",
                    error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
                };
            }
        }
        // call application callback
        var vfd = error === null ? true : error.error;
        var ret = options.verify ? options.verify(vfd, depth, certs) : vfd;
        if (ret === true) // clear any set error
        error = null;
        else {
            // if passed basic tests, set default message and alert
            if (vfd === true) error = {
                message: "The application rejected the certificate.",
                error: $105b92724c1ce1a5$var$pki.certificateError.bad_certificate
            };
            // check for custom error info
            if (ret || ret === 0) {
                // set custom message and error
                if (typeof ret === "object" && !$dEd5p.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.error) error.error = ret.error;
                } else if (typeof ret === "string") // set custom error
                error.error = ret;
            }
            // throw error
            throw error;
        }
        // no longer first cert in chain
        first = false;
        ++depth;
    }while (chain.length > 0);
    return true;
};

});
parcelRegister("3jreJ", function(module, exports) {
/**
 * Node.js module for Forge mask generation functions.
 *
 * @author Stefan Siegl
 *
 * Copyright 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("8yafv");
module.exports = $dEd5p.mgf = $dEd5p.mgf || {};
$dEd5p.mgf.mgf1 = $dEd5p.mgf1;

});

parcelRegister("54e3h", function(module, exports) {
/**
 * Javascript implementation of PKCS#1 PSS signature padding.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("4N8iP");
parcelRequire("kvSv3");
// shortcut for PSS API
var $3b0839e14af9472d$var$pss = module.exports = $dEd5p.pss = $dEd5p.pss || {};
/**
 * Creates a PSS signature scheme object.
 *
 * There are several ways to provide a salt for encoding:
 *
 * 1. Specify the saltLength only and the built-in PRNG will generate it.
 * 2. Specify the saltLength and a custom PRNG with 'getBytesSync' defined that
 *   will be used.
 * 3. Specify the salt itself as a forge.util.ByteBuffer.
 *
 * @param options the options to use:
 *          md the message digest object to use, a forge md instance.
 *          mgf the mask generation function to use, a forge mgf instance.
 *          [saltLength] the length of the salt in octets.
 *          [prng] the pseudo-random number generator to use to produce a salt.
 *          [salt] the salt to use when encoding.
 *
 * @return a signature scheme object.
 */ $3b0839e14af9472d$var$pss.create = function(options) {
    // backwards compatibility w/legacy args: hash, mgf, sLen
    if (arguments.length === 3) options = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
    };
    var hash = options.md;
    var mgf = options.mgf;
    var hLen = hash.digestLength;
    var salt_ = options.salt || null;
    if (typeof salt_ === "string") // assume binary-encoded string
    salt_ = $dEd5p.util.createBuffer(salt_);
    var sLen;
    if ("saltLength" in options) sLen = options.saltLength;
    else if (salt_ !== null) sLen = salt_.length();
    else throw new Error("Salt length not specified or specific salt not given.");
    if (salt_ !== null && salt_.length() !== sLen) throw new Error("Given salt length does not match length of given salt.");
    var prng = options.prng || $dEd5p.random;
    var pssobj = {};
    /**
   * Encodes a PSS signature.
   *
   * This function implements EMSA-PSS-ENCODE as per RFC 3447, section 9.1.1.
   *
   * @param md the message digest object with the hash to sign.
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return the encoded message as a binary-encoded string of length
   *           ceil((modBits - 1) / 8).
   */ pssobj.encode = function(md, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* 2. Let mHash = Hash(M), an octet string of length hLen. */ var mHash = md.digest().getBytes();
        /* 3. If emLen < hLen + sLen + 2, output "encoding error" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Message is too long to encrypt.");
        /* 4. Generate a random octet string salt of length sLen; if sLen = 0,
     *    then salt is the empty string. */ var salt;
        if (salt_ === null) salt = prng.getBytesSync(sLen);
        else salt = salt_.bytes();
        /* 5. Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt; */ var m_ = new $dEd5p.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 6. Let H = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h = hash.digest().getBytes();
        /* 7. Generate an octet string PS consisting of emLen - sLen - hLen - 2
     *    zero octets.  The length of PS may be 0. */ var ps = new $dEd5p.util.ByteBuffer();
        ps.fillWithByte(0, emLen - sLen - hLen - 2);
        /* 8. Let DB = PS || 0x01 || salt; DB is an octet string of length
     *    emLen - hLen - 1. */ ps.putByte(0x01);
        ps.putBytes(salt);
        var db = ps.getBytes();
        /* 9. Let dbMask = MGF(H, emLen - hLen - 1). */ var maskLen = emLen - hLen - 1;
        var dbMask = mgf.generate(h, maskLen);
        /* 10. Let maskedDB = DB \xor dbMask. */ var maskedDB = "";
        for(i = 0; i < maskLen; i++)maskedDB += String.fromCharCode(db.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 11. Set the leftmost 8emLen - emBits bits of the leftmost octet in
     *     maskedDB to zero. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
        /* 12. Let EM = maskedDB || H || 0xbc.
     * 13. Output EM. */ return maskedDB + h + String.fromCharCode(0xbc);
    };
    /**
   * Verifies a PSS signature.
   *
   * This function implements EMSA-PSS-VERIFY as per RFC 3447, section 9.1.2.
   *
   * @param mHash the message digest hash, as a binary-encoded string, to
   *         compare against the signature.
   * @param em the encoded message, as a binary-encoded string
   *          (RSA decryption result).
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return true if the signature was verified, false if not.
   */ pssobj.verify = function(mHash, em, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* c. Convert the message representative m to an encoded message EM
     *    of length emLen = ceil((modBits - 1) / 8) octets, where modBits
     *    is the length in bits of the RSA modulus n */ em = em.substr(-emLen);
        /* 3. If emLen < hLen + sLen + 2, output "inconsistent" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Inconsistent parameters to PSS signature verification.");
        /* 4. If the rightmost octet of EM does not have hexadecimal value
     *    0xbc, output "inconsistent" and stop. */ if (em.charCodeAt(emLen - 1) !== 0xbc) throw new Error("Encoded message does not end in 0xBC.");
        /* 5. Let maskedDB be the leftmost emLen - hLen - 1 octets of EM, and
     *    let H be the next hLen octets. */ var maskLen = emLen - hLen - 1;
        var maskedDB = em.substr(0, maskLen);
        var h = em.substr(maskLen, hLen);
        /* 6. If the leftmost 8emLen - emBits bits of the leftmost octet in
     *    maskedDB are not all equal to zero, output "inconsistent" and stop. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        if ((maskedDB.charCodeAt(0) & mask) !== 0) throw new Error("Bits beyond keysize not zero as expected.");
        /* 7. Let dbMask = MGF(H, emLen - hLen - 1). */ var dbMask = mgf.generate(h, maskLen);
        /* 8. Let DB = maskedDB \xor dbMask. */ var db = "";
        for(i = 0; i < maskLen; i++)db += String.fromCharCode(maskedDB.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 9. Set the leftmost 8emLen - emBits bits of the leftmost octet
     * in DB to zero. */ db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
        /* 10. If the emLen - hLen - sLen - 2 leftmost octets of DB are not zero
     * or if the octet at position emLen - hLen - sLen - 1 (the leftmost
     * position is "position 1") does not have hexadecimal value 0x01,
     * output "inconsistent" and stop. */ var checkLen = emLen - hLen - sLen - 2;
        for(i = 0; i < checkLen; i++){
            if (db.charCodeAt(i) !== 0x00) throw new Error("Leftmost octets not zero as expected");
        }
        if (db.charCodeAt(checkLen) !== 0x01) throw new Error("Inconsistent PSS signature, 0x01 marker not found");
        /* 11. Let salt be the last sLen octets of DB. */ var salt = db.substr(-sLen);
        /* 12.  Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt */ var m_ = new $dEd5p.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 13. Let H' = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h_ = hash.digest().getBytes();
        /* 14. If H = H', output "consistent." Otherwise, output "inconsistent." */ return h === h_;
    };
    return pssobj;
};

});

parcelRegister("ad5x8", function(module, exports) {
/**
 * Javascript implementation of basic RSA algorithms.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The only algorithm currently supported for PKI is RSA.
 *
 * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
 * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
 * and a subjectPublicKey of type bit string.
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of RSA, there aren't any.
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm AlgorithmIdentifier,
 *   subjectPublicKey BIT STRING
 * }
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * For an RSA public key, the subjectPublicKey is:
 *
 * RSAPublicKey ::= SEQUENCE {
 *   modulus            INTEGER,    -- n
 *   publicExponent     INTEGER     -- e
 * }
 *
 * PrivateKeyInfo ::= SEQUENCE {
 *   version                   Version,
 *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
 *   privateKey                PrivateKey,
 *   attributes           [0]  IMPLICIT Attributes OPTIONAL
 * }
 *
 * Version ::= INTEGER
 * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
 * PrivateKey ::= OCTET STRING
 * Attributes ::= SET OF Attribute
 *
 * An RSA private key as the following structure:
 *
 * RSAPrivateKey ::= SEQUENCE {
 *   version Version,
 *   modulus INTEGER, -- n
 *   publicExponent INTEGER, -- e
 *   privateExponent INTEGER, -- d
 *   prime1 INTEGER, -- p
 *   prime2 INTEGER, -- q
 *   exponent1 INTEGER, -- d mod (p-1)
 *   exponent2 INTEGER, -- d mod (q-1)
 *   coefficient INTEGER -- (inverse of q) mod p
 * }
 *
 * Version ::= INTEGER
 *
 * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("8QTFz");
parcelRequire("jAgzQ");
parcelRequire("ggdRy");
parcelRequire("gDTs5");
parcelRequire("1VPPt");
parcelRequire("4N8iP");
parcelRequire("kvSv3");
if (typeof $76ef6919167a33e0$var$BigInteger === "undefined") var $76ef6919167a33e0$var$BigInteger = $dEd5p.jsbn.BigInteger;

var $76ef6919167a33e0$var$_crypto = $dEd5p.util.isNodejs ? (parcelRequire("kjyEk")) : null;
// shortcut for asn.1 API
var $76ef6919167a33e0$var$asn1 = $dEd5p.asn1;
// shortcut for util API
var $76ef6919167a33e0$var$util = $dEd5p.util;
/*
 * RSA encryption and decryption, see RFC 2313.
 */ $dEd5p.pki = $dEd5p.pki || {};
module.exports = $dEd5p.pki.rsa = $dEd5p.rsa = $dEd5p.rsa || {};
var $76ef6919167a33e0$var$pki = $dEd5p.pki;
// for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
var $76ef6919167a33e0$var$GCD_30_DELTA = [
    6,
    4,
    2,
    4,
    2,
    4,
    6,
    2
];
// validator for a PrivateKeyInfo structure
var $76ef6919167a33e0$var$privateKeyValidator = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
                    type: $76ef6919167a33e0$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
// validator for an RSA private key
var $76ef6919167a33e0$var$rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: "RSAPrivateKey",
    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "RSAPrivateKey.version",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // modulus (n)
            name: "RSAPrivateKey.modulus",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPrivateKey.publicExponent",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPublicExponent"
        },
        {
            // privateExponent (d)
            name: "RSAPrivateKey.privateExponent",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrivateExponent"
        },
        {
            // prime1 (p)
            name: "RSAPrivateKey.prime1",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime1"
        },
        {
            // prime2 (q)
            name: "RSAPrivateKey.prime2",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime2"
        },
        {
            // exponent1 (d mod (p-1))
            name: "RSAPrivateKey.exponent1",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent1"
        },
        {
            // exponent2 (d mod (q-1))
            name: "RSAPrivateKey.exponent2",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent2"
        },
        {
            // coefficient ((inverse of q) mod p)
            name: "RSAPrivateKey.coefficient",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyCoefficient"
        }
    ]
};
// validator for an RSA public key
var $76ef6919167a33e0$var$rsaPublicKeyValidator = {
    // RSAPublicKey
    name: "RSAPublicKey",
    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // modulus (n)
            name: "RSAPublicKey.modulus",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPublicKey.exponent",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyExponent"
        }
    ]
};
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $76ef6919167a33e0$var$publicKeyValidator = $dEd5p.pki.rsa.publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
                    type: $76ef6919167a33e0$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        {
            // subjectPublicKey
            name: "SubjectPublicKeyInfo.subjectPublicKey",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.BITSTRING,
            constructed: false,
            value: [
                {
                    // RSAPublicKey
                    name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
                    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
                    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    optional: true,
                    captureAsn1: "rsaPublicKey"
                }
            ]
        }
    ]
};
// validator for a DigestInfo structure
var $76ef6919167a33e0$var$digestInfoValidator = {
    name: "DigestInfo",
    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
    type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "DigestInfo.DigestAlgorithm",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
                    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
                    type: $76ef6919167a33e0$var$asn1.Type.OID,
                    constructed: false,
                    capture: "algorithmIdentifier"
                },
                {
                    // NULL paramters
                    name: "DigestInfo.DigestAlgorithm.parameters",
                    tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
                    type: $76ef6919167a33e0$var$asn1.Type.NULL,
                    // captured only to check existence for md2 and md5
                    capture: "parameters",
                    optional: true,
                    constructed: false
                }
            ]
        },
        {
            // digest
            name: "DigestInfo.digest",
            tagClass: $76ef6919167a33e0$var$asn1.Class.UNIVERSAL,
            type: $76ef6919167a33e0$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "digest"
        }
    ]
};
/**
 * Wrap digest in DigestInfo object.
 *
 * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 * Digest ::= OCTET STRING
 *
 * @param md the message digest object with the hash to sign.
 *
 * @return the encoded message (ready for RSA encrytion)
 */ var $76ef6919167a33e0$var$emsaPkcs1v15encode = function(md) {
    // get the oid for the algorithm
    var oid;
    if (md.algorithm in $76ef6919167a33e0$var$pki.oids) oid = $76ef6919167a33e0$var$pki.oids[md.algorithm];
    else {
        var error = new Error("Unknown message digest algorithm.");
        error.algorithm = md.algorithm;
        throw error;
    }
    var oidBytes = $76ef6919167a33e0$var$asn1.oidToDer(oid).getBytes();
    // create the digest info
    var digestInfo = $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push($76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push($76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.NULL, false, ""));
    var digest = $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest);
    // encode digest info
    return $76ef6919167a33e0$var$asn1.toDer(digestInfo).getBytes();
};
/**
 * Performs x^c mod n (RSA encryption or decryption operation).
 *
 * @param x the number to raise and mod.
 * @param key the key to use.
 * @param pub true if the key is public, false if private.
 *
 * @return the result of x^c mod n.
 */ var $76ef6919167a33e0$var$_modPow = function(x, key, pub) {
    if (pub) return x.modPow(key.e, key.n);
    if (!key.p || !key.q) // allow calculation without CRT params (slow)
    return x.modPow(key.d, key.n);
    // pre-compute dP, dQ, and qInv if necessary
    if (!key.dP) key.dP = key.d.mod(key.p.subtract($76ef6919167a33e0$var$BigInteger.ONE));
    if (!key.dQ) key.dQ = key.d.mod(key.q.subtract($76ef6919167a33e0$var$BigInteger.ONE));
    if (!key.qInv) key.qInv = key.q.modInverse(key.p);
    /* Chinese remainder theorem (CRT) states:

    Suppose n1, n2, ..., nk are positive integers which are pairwise
    coprime (n1 and n2 have no common factors other than 1). For any
    integers x1, x2, ..., xk there exists an integer x solving the
    system of simultaneous congruences (where ~= means modularly
    congruent so a ~= b mod n means a mod n = b mod n):

    x ~= x1 mod n1
    x ~= x2 mod n2
    ...
    x ~= xk mod nk

    This system of congruences has a single simultaneous solution x
    between 0 and n - 1. Furthermore, each xk solution and x itself
    is congruent modulo the product n = n1*n2*...*nk.
    So x1 mod n = x2 mod n = xk mod n = x mod n.

    The single simultaneous solution x can be solved with the following
    equation:

    x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.

    Where x is less than n, xi = x mod ni.

    For RSA we are only concerned with k = 2. The modulus n = pq, where
    p and q are coprime. The RSA decryption algorithm is:

    y = x^d mod n

    Given the above:

    x1 = x^d mod p
    r1 = n/p = q
    s1 = q^-1 mod p
    x2 = x^d mod q
    r2 = n/q = p
    s2 = p^-1 mod q

    So y = (x1r1s1 + x2r2s2) mod n
         = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n

    According to Fermat's Little Theorem, if the modulus P is prime,
    for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
    Since A is not divisible by P it follows that if:
    N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:

    A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
    to calculate). In order to calculate x^d mod p more quickly the
    exponent d mod (p - 1) is stored in the RSA private key (the same
    is done for x^d mod q). These values are referred to as dP and dQ
    respectively. Therefore we now have:

    y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n

    Since we'll be reducing x^dP by modulo p (same for q) we can also
    reduce x by p (and q respectively) before hand. Therefore, let

    xp = ((x mod p)^dP mod p), and
    xq = ((x mod q)^dQ mod q), yielding:

    y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n

    This can be further reduced to a simple algorithm that only
    requires 1 inverse (the q inverse is used) to be used and stored.
    The algorithm is called Garner's algorithm. If qInv is the
    inverse of q, we simply calculate:

    y = (qInv*(xp - xq) mod p) * q + xq

    However, there are two further complications. First, we need to
    ensure that xp > xq to prevent signed BigIntegers from being used
    so we add p until this is true (since we will be mod'ing with
    p anyway). Then, there is a known timing attack on algorithms
    using the CRT. To mitigate this risk, "cryptographic blinding"
    should be used. This requires simply generating a random number r
    between 0 and n-1 and its inverse and multiplying x by r^e before
    calculating y and then multiplying y by r^-1 afterwards. Note that
    r must be coprime with n (gcd(r, n) === 1) in order to have an
    inverse.
  */ // cryptographic blinding
    var r;
    do r = new $76ef6919167a33e0$var$BigInteger($dEd5p.util.bytesToHex($dEd5p.random.getBytes(key.n.bitLength() / 8)), 16);
    while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals($76ef6919167a33e0$var$BigInteger.ONE));
    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n);
    // calculate xp and xq
    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q);
    // xp must be larger than xq to avoid signed bit usage
    while(xp.compareTo(xq) < 0)xp = xp.add(key.p);
    // do last step
    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
    // remove effect of random for cryptographic blinding
    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
 * 'encrypt' on a public key object instead.
 *
 * Performs RSA encryption.
 *
 * The parameter bt controls whether to put padding bytes before the
 * message passed in. Set bt to either true or false to disable padding
 * completely (in order to handle e.g. EMSA-PSS encoding seperately before),
 * signaling whether the encryption operation is a public key operation
 * (i.e. encrypting data) or not, i.e. private key operation (data signing).
 *
 * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
 * (for signing) or 0x02 (for encryption). The key operation mode (private
 * or public) is derived from this flag in that case).
 *
 * @param m the message to encrypt as a byte string.
 * @param key the RSA key to use.
 * @param bt for PKCS#1 v1.5 padding, the block type to use
 *   (0x01 for private key, 0x02 for public),
 *   to disable padding: true = public key, false = private key.
 *
 * @return the encrypted bytes as a string.
 */ $76ef6919167a33e0$var$pki.rsa.encrypt = function(m, key, bt) {
    var pub = bt;
    var eb;
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    if (bt !== false && bt !== true) {
        // legacy, default to PKCS#1 v1.5 padding
        pub = bt === 0x02;
        eb = $76ef6919167a33e0$var$_encodePkcs1_v1_5(m, key, bt);
    } else {
        eb = $dEd5p.util.createBuffer();
        eb.putBytes(m);
    }
    // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var x = new $76ef6919167a33e0$var$BigInteger(eb.toHex(), 16);
    // do RSA encryption
    var y = $76ef6919167a33e0$var$_modPow(x, key, pub);
    // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var yhex = y.toString(16);
    var ed = $dEd5p.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);
    while(zeros > 0){
        ed.putByte(0x00);
        --zeros;
    }
    ed.putBytes($dEd5p.util.hexToBytes(yhex));
    return ed.getBytes();
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
 * 'verify' on a public key object instead.
 *
 * Performs RSA decryption.
 *
 * The parameter ml controls whether to apply PKCS#1 v1.5 padding
 * or not.  Set ml = false to disable padding removal completely
 * (in order to handle e.g. EMSA-PSS later on) and simply pass back
 * the RSA encryption block.
 *
 * @param ed the encrypted data to decrypt in as a byte string.
 * @param key the RSA key to use.
 * @param pub true for a public key operation, false for private.
 * @param ml the message length, if known, false to disable padding.
 *
 * @return the decrypted message as a byte string.
 */ $76ef6919167a33e0$var$pki.rsa.decrypt = function(ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    // error if the length of the encrypted data ED is not k
    if (ed.length !== k) {
        var error = new Error("Encrypted message length is invalid.");
        error.length = ed.length;
        error.expected = k;
        throw error;
    }
    // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var y = new $76ef6919167a33e0$var$BigInteger($dEd5p.util.createBuffer(ed).toHex(), 16);
    // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus
    if (y.compareTo(key.n) >= 0) throw new Error("Encrypted message is invalid.");
    // do RSA decryption
    var x = $76ef6919167a33e0$var$_modPow(y, key, pub);
    // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var xhex = x.toString(16);
    var eb = $dEd5p.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);
    while(zeros > 0){
        eb.putByte(0x00);
        --zeros;
    }
    eb.putBytes($dEd5p.util.hexToBytes(xhex));
    if (ml !== false) // legacy, default to PKCS#1 v1.5 padding
    return $76ef6919167a33e0$var$_decodePkcs1_v1_5(eb.getBytes(), key, pub);
    // return message
    return eb.getBytes();
};
/**
 * Creates an RSA key-pair generation state object. It is used to allow
 * key-generation to be performed in steps. It also allows for a UI to
 * display progress updates.
 *
 * @param bits the size for the private key in bits, defaults to 2048.
 * @param e the public exponent to use, defaults to 65537 (0x10001).
 * @param [options] the options to use.
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 *
 * @return the state object to use to generate the key-pair.
 */ $76ef6919167a33e0$var$pki.rsa.createKeyPairGenerationState = function(bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === "string") bits = parseInt(bits, 10);
    bits = bits || 2048;
    // create prng with api that matches BigInteger secure random
    options = options || {};
    var prng = options.prng || $dEd5p.random;
    var rng = {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            var b = prng.getBytesSync(x.length);
            for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
        }
    };
    var algorithm = options.algorithm || "PRIMEINC";
    // create PRIMEINC algorithm state
    var rval;
    if (algorithm === "PRIMEINC") {
        rval = {
            algorithm: algorithm,
            state: 0,
            bits: bits,
            rng: rng,
            eInt: e || 65537,
            e: new $76ef6919167a33e0$var$BigInteger(null),
            p: null,
            q: null,
            qBits: bits >> 1,
            pBits: bits - (bits >> 1),
            pqState: 0,
            num: null,
            keys: null
        };
        rval.e.fromInt(rval.eInt);
    } else throw new Error("Invalid key generation algorithm: " + algorithm);
    return rval;
};
/**
 * Attempts to runs the key-generation algorithm for at most n seconds
 * (approximately) using the given state. When key-generation has completed,
 * the keys will be stored in state.keys.
 *
 * To use this function to update a UI while generating a key or to prevent
 * causing browser lockups/warnings, set "n" to a value other than 0. A
 * simple pattern for generating a key and showing a progress indicator is:
 *
 * var state = pki.rsa.createKeyPairGenerationState(2048);
 * var step = function() {
 *   // step key-generation, run algorithm for 100 ms, repeat
 *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
 *     setTimeout(step, 1);
 *   } else {
 *     // key-generation complete
 *     // TODO: turn off progress indicator here
 *     // TODO: use the generated key-pair in "state.keys"
 *   }
 * };
 * // TODO: turn on progress indicator here
 * setTimeout(step, 0);
 *
 * @param state the state to use.
 * @param n the maximum number of milliseconds to run the algorithm for, 0
 *          to run the algorithm to completion.
 *
 * @return true if the key-generation completed, false if not.
 */ $76ef6919167a33e0$var$pki.rsa.stepKeyPairGenerationState = function(state, n) {
    // set default algorithm if not set
    if (!("algorithm" in state)) state.algorithm = "PRIMEINC";
    // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars
    var THIRTY = new $76ef6919167a33e0$var$BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;
    var op_or = function(x, y) {
        return x | y;
    };
    // keep stepping until time limit is reached or done
    var t1 = +new Date();
    var t2;
    var total = 0;
    while(state.keys === null && (n <= 0 || total < n)){
        // generate p or q
        if (state.state === 0) {
            /* Note: All primes are of the form:

        30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i

        When we generate a random number, we always align it at 30k + 1. Each
        time the number is determined not to be prime we add to get to the
        next 'i', eg: if the number was at 30k + 1 we add 6. */ var bits = state.p === null ? state.pBits : state.qBits;
            var bits1 = bits - 1;
            // get a random number
            if (state.pqState === 0) {
                state.num = new $76ef6919167a33e0$var$BigInteger(bits, state.rng);
                // force MSB set
                if (!state.num.testBit(bits1)) state.num.bitwiseTo($76ef6919167a33e0$var$BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
                // align number on 30k+1 boundary
                state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
                deltaIdx = 0;
                ++state.pqState;
            } else if (state.pqState === 1) {
                // try to make the number a prime
                if (state.num.bitLength() > bits) // overflow, try again
                state.pqState = 0;
                else if (state.num.isProbablePrime($76ef6919167a33e0$var$_getMillerRabinTests(state.num.bitLength()))) ++state.pqState;
                else // get next potential prime
                state.num.dAddOffset($76ef6919167a33e0$var$GCD_30_DELTA[deltaIdx++ % 8], 0);
            } else if (state.pqState === 2) // ensure number is coprime with e
            state.pqState = state.num.subtract($76ef6919167a33e0$var$BigInteger.ONE).gcd(state.e).compareTo($76ef6919167a33e0$var$BigInteger.ONE) === 0 ? 3 : 0;
            else if (state.pqState === 3) {
                // store p or q
                state.pqState = 0;
                if (state.p === null) state.p = state.num;
                else state.q = state.num;
                // advance state if both p and q are ready
                if (state.p !== null && state.q !== null) ++state.state;
                state.num = null;
            }
        } else if (state.state === 1) {
            // ensure p is larger than q (swap them if not)
            if (state.p.compareTo(state.q) < 0) {
                state.num = state.p;
                state.p = state.q;
                state.q = state.num;
            }
            ++state.state;
        } else if (state.state === 2) {
            // compute phi: (p - 1)(q - 1) (Euler's totient function)
            state.p1 = state.p.subtract($76ef6919167a33e0$var$BigInteger.ONE);
            state.q1 = state.q.subtract($76ef6919167a33e0$var$BigInteger.ONE);
            state.phi = state.p1.multiply(state.q1);
            ++state.state;
        } else if (state.state === 3) {
            // ensure e and phi are coprime
            if (state.phi.gcd(state.e).compareTo($76ef6919167a33e0$var$BigInteger.ONE) === 0) // phi and e are coprime, advance
            ++state.state;
            else {
                // phi and e aren't coprime, so generate a new p and q
                state.p = null;
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 4) {
            // create n, ensure n is has the right number of bits
            state.n = state.p.multiply(state.q);
            // ensure n is right number of bits
            if (state.n.bitLength() === state.bits) // success, advance
            ++state.state;
            else {
                // failed, get new q
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 5) {
            // set keys
            var d = state.e.modInverse(state.phi);
            state.keys = {
                privateKey: $76ef6919167a33e0$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
                publicKey: $76ef6919167a33e0$var$pki.rsa.setPublicKey(state.n, state.e)
            };
        }
        // update timing
        t2 = +new Date();
        total += t2 - t1;
        t1 = t2;
    }
    return state.keys !== null;
};
/**
 * Generates an RSA public-private key pair in a single call.
 *
 * To generate a key-pair in steps (to allow for progress updates and to
 * prevent blocking or warnings in slow browsers) then use the key-pair
 * generation state functions.
 *
 * To generate a key-pair asynchronously (either through web-workers, if
 * available, or by breaking up the work on the main thread), pass a
 * callback function.
 *
 * @param [bits] the size for the private key in bits, defaults to 2048.
 * @param [e] the public exponent to use, defaults to 65537.
 * @param [options] options for key-pair generation, if given then 'bits'
 *            and 'e' must *not* be given:
 *          bits the size for the private key in bits, (default: 2048).
 *          e the public exponent to use, (default: 65537 (0x10001)).
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync". Disables use of native APIs.
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 * @param [callback(err, keypair)] called once the operation completes.
 *
 * @return an object with privateKey and publicKey properties.
 */ $76ef6919167a33e0$var$pki.rsa.generateKeyPair = function(bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
        if (typeof bits === "object") {
            options = bits;
            bits = undefined;
        } else if (typeof bits === "function") {
            callback = bits;
            bits = undefined;
        }
    } else if (arguments.length === 2) {
        // (bits, e), (bits, options), (bits, callback), (options, callback)
        if (typeof bits === "number") {
            if (typeof e === "function") {
                callback = e;
                e = undefined;
            } else if (typeof e !== "number") {
                options = e;
                e = undefined;
            }
        } else {
            options = bits;
            callback = e;
            bits = undefined;
            e = undefined;
        }
    } else if (arguments.length === 3) {
        // (bits, e, options), (bits, e, callback), (bits, options, callback)
        if (typeof e === "number") {
            if (typeof options === "function") {
                callback = options;
                options = undefined;
            }
        } else {
            callback = options;
            options = e;
            e = undefined;
        }
    }
    options = options || {};
    if (bits === undefined) bits = options.bits || 2048;
    if (e === undefined) e = options.e || 0x10001;
    // use native code if permitted, available, and parameters are acceptable
    if (!$dEd5p.options.usePureJavaScript && !options.prng && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
        if (callback) {
            // try native async
            if ($76ef6919167a33e0$var$_detectNodeCrypto("generateKeyPair")) return $76ef6919167a33e0$var$_crypto.generateKeyPair("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            }, function(err, pub, priv) {
                if (err) return callback(err);
                callback(null, {
                    privateKey: $76ef6919167a33e0$var$pki.privateKeyFromPem(priv),
                    publicKey: $76ef6919167a33e0$var$pki.publicKeyFromPem(pub)
                });
            });
            if ($76ef6919167a33e0$var$_detectSubtleCrypto("generateKey") && $76ef6919167a33e0$var$_detectSubtleCrypto("exportKey")) // use standard native generateKey
            return $76ef6919167a33e0$var$util.globalScope.crypto.subtle.generateKey({
                name: "RSASSA-PKCS1-v1_5",
                modulusLength: bits,
                publicExponent: $76ef6919167a33e0$var$_intToUint8Array(e),
                hash: {
                    name: "SHA-256"
                }
            }, true, [
                "sign",
                "verify"
            ]).then(function(pair) {
                return $76ef6919167a33e0$var$util.globalScope.crypto.subtle.exportKey("pkcs8", pair.privateKey);
            // avoiding catch(function(err) {...}) to support IE <= 8
            }).then(undefined, function(err) {
                callback(err);
            }).then(function(pkcs8) {
                if (pkcs8) {
                    var privateKey = $76ef6919167a33e0$var$pki.privateKeyFromAsn1($76ef6919167a33e0$var$asn1.fromDer($dEd5p.util.createBuffer(pkcs8)));
                    callback(null, {
                        privateKey: privateKey,
                        publicKey: $76ef6919167a33e0$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                    });
                }
            });
            if ($76ef6919167a33e0$var$_detectSubtleMsCrypto("generateKey") && $76ef6919167a33e0$var$_detectSubtleMsCrypto("exportKey")) {
                var genOp = $76ef6919167a33e0$var$util.globalScope.msCrypto.subtle.generateKey({
                    name: "RSASSA-PKCS1-v1_5",
                    modulusLength: bits,
                    publicExponent: $76ef6919167a33e0$var$_intToUint8Array(e),
                    hash: {
                        name: "SHA-256"
                    }
                }, true, [
                    "sign",
                    "verify"
                ]);
                genOp.oncomplete = function(e) {
                    var pair = e.target.result;
                    var exportOp = $76ef6919167a33e0$var$util.globalScope.msCrypto.subtle.exportKey("pkcs8", pair.privateKey);
                    exportOp.oncomplete = function(e) {
                        var pkcs8 = e.target.result;
                        var privateKey = $76ef6919167a33e0$var$pki.privateKeyFromAsn1($76ef6919167a33e0$var$asn1.fromDer($dEd5p.util.createBuffer(pkcs8)));
                        callback(null, {
                            privateKey: privateKey,
                            publicKey: $76ef6919167a33e0$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                        });
                    };
                    exportOp.onerror = function(err) {
                        callback(err);
                    };
                };
                genOp.onerror = function(err) {
                    callback(err);
                };
                return;
            }
        } else // try native sync
        if ($76ef6919167a33e0$var$_detectNodeCrypto("generateKeyPairSync")) {
            var keypair = $76ef6919167a33e0$var$_crypto.generateKeyPairSync("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            });
            return {
                privateKey: $76ef6919167a33e0$var$pki.privateKeyFromPem(keypair.privateKey),
                publicKey: $76ef6919167a33e0$var$pki.publicKeyFromPem(keypair.publicKey)
            };
        }
    }
    // use JavaScript implementation
    var state = $76ef6919167a33e0$var$pki.rsa.createKeyPairGenerationState(bits, e, options);
    if (!callback) {
        $76ef6919167a33e0$var$pki.rsa.stepKeyPairGenerationState(state, 0);
        return state.keys;
    }
    $76ef6919167a33e0$var$_generateKeyPair(state, options, callback);
};
/**
 * Sets an RSA public key from BigIntegers modulus and exponent.
 *
 * @param n the modulus.
 * @param e the exponent.
 *
 * @return the public key.
 */ $76ef6919167a33e0$var$pki.setRsaPublicKey = $76ef6919167a33e0$var$pki.rsa.setPublicKey = function(n, e) {
    var key = {
        n: n,
        e: e
    };
    /**
   * Encrypts the given data with this public key. Newer applications
   * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
   * legacy applications.
   *
   * @param data the byte string to encrypt.
   * @param scheme the encryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA encryption,
   *          an object with an 'encode' property set to a function
   *          with the signature 'function(data, key)' that returns
   *          a binary-encoded string representing the encoded data.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the encrypted byte string.
   */ key.encrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            encode: function(m, key, pub) {
                return $76ef6919167a33e0$var$_encodePkcs1_v1_5(m, key, 0x02).getBytes();
            }
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            encode: function(m, key) {
                return $dEd5p.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            encode: function(e) {
                return e;
            }
        };
        else if (typeof scheme === "string") throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // do scheme-based encoding then rsa encryption
        var e = scheme.encode(data, key, true);
        return $76ef6919167a33e0$var$pki.rsa.encrypt(e, key, true);
    };
    /**
   * Verifies the given signature against the given digest.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
   * signature is an OCTET STRING that holds a DigestInfo.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * To perform PSS signature verification, provide an instance
   * of Forge PSS object as the scheme parameter.
   *
   * @param digest the message digest hash to compare against the signature,
   *          as a binary-encoded string.
   * @param signature the signature to verify, as a binary-encoded string.
   * @param scheme signature verification scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be expected, but
   *            PKCS#1 v1.5 padding will still be used.
   * @param options optional verify options
   *          _parseAllDigestBytes testing flag to control parsing of all
   *            digest bytes. Unsupported and not for general usage.
   *            (default: true)
   *
   * @return true if the signature was verified, false if not.
   */ key.verify = function(digest, signature, scheme, options) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSASSA-PKCS1-V1_5";
        if (options === undefined) options = {
            _parseAllDigestBytes: true
        };
        if (!("_parseAllDigestBytes" in options)) options._parseAllDigestBytes = true;
        if (scheme === "RSASSA-PKCS1-V1_5") scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $76ef6919167a33e0$var$_decodePkcs1_v1_5(d, key, true);
                // d is ASN.1 BER-encoded DigestInfo
                var obj = $76ef6919167a33e0$var$asn1.fromDer(d, {
                    parseAllBytes: options._parseAllDigestBytes
                });
                // validate DigestInfo
                var capture = {};
                var errors = [];
                if (!$76ef6919167a33e0$var$asn1.validate(obj, $76ef6919167a33e0$var$digestInfoValidator, capture, errors)) {
                    var error = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.");
                    error.errors = errors;
                    throw error;
                }
                // check hash algorithm identifier
                // see PKCS1-v1-5DigestAlgorithms in RFC 8017
                // FIXME: add support to vaidator for strict value choices
                var oid = $76ef6919167a33e0$var$asn1.derToOid(capture.algorithmIdentifier);
                if (!(oid === $dEd5p.oids.md2 || oid === $dEd5p.oids.md5 || oid === $dEd5p.oids.sha1 || oid === $dEd5p.oids.sha224 || oid === $dEd5p.oids.sha256 || oid === $dEd5p.oids.sha384 || oid === $dEd5p.oids.sha512 || oid === $dEd5p.oids["sha512-224"] || oid === $dEd5p.oids["sha512-256"])) {
                    var error = new Error("Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.");
                    error.oid = oid;
                    throw error;
                }
                // special check for md2 and md5 that NULL parameters exist
                if (oid === $dEd5p.oids.md2 || oid === $dEd5p.oids.md5) {
                    if (!("parameters" in capture)) throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters.");
                }
                // compare the given digest to the decrypted one
                return digest === capture.digest;
            }
        };
        else if (scheme === "NONE" || scheme === "NULL" || scheme === null) scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $76ef6919167a33e0$var$_decodePkcs1_v1_5(d, key, true);
                return digest === d;
            }
        };
        // do rsa decryption w/o any decoding, then verify -- which does decoding
        var d = $76ef6919167a33e0$var$pki.rsa.decrypt(signature, key, true, false);
        return scheme.verify(digest, d, key.n.bitLength());
    };
    return key;
};
/**
 * Sets an RSA private key from BigIntegers modulus, exponent, primes,
 * prime exponents, and modular multiplicative inverse.
 *
 * @param n the modulus.
 * @param e the public exponent.
 * @param d the private exponent ((inverse of e) mod n).
 * @param p the first prime.
 * @param q the second prime.
 * @param dP exponent1 (d mod (p-1)).
 * @param dQ exponent2 (d mod (q-1)).
 * @param qInv ((inverse of q) mod p)
 *
 * @return the private key.
 */ $76ef6919167a33e0$var$pki.setRsaPrivateKey = $76ef6919167a33e0$var$pki.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
    var key = {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dP: dP,
        dQ: dQ,
        qInv: qInv
    };
    /**
   * Decrypts the given data with this private key. The decryption scheme
   * must match the one used to encrypt the data.
   *
   * @param data the byte string to decrypt.
   * @param scheme the decryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA decryption.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the decrypted byte string.
   */ key.decrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        // do rsa decryption w/o any decoding
        var d = $76ef6919167a33e0$var$pki.rsa.decrypt(data, key, false, false);
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            decode: $76ef6919167a33e0$var$_decodePkcs1_v1_5
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            decode: function(d, key) {
                return $dEd5p.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            decode: function(d) {
                return d;
            }
        };
        else throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // decode according to scheme
        return scheme.decode(d, key, false);
    };
    /**
   * Signs the given digest, producing a signature.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
   * an instance of Forge PSS object as the scheme parameter.
   *
   * @param md the message digest object with the hash to sign.
   * @param scheme the signature scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be used but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return the signature as a byte string.
   */ key.sign = function(md, scheme) {
        /* Note: The internal implementation of RSA operations is being
      transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
      code like the use of an encoding block identifier 'bt' will eventually
      be removed. */ // private key operation
        var bt = false;
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        if (scheme === undefined || scheme === "RSASSA-PKCS1-V1_5") {
            scheme = {
                encode: $76ef6919167a33e0$var$emsaPkcs1v15encode
            };
            bt = 0x01;
        } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
            scheme = {
                encode: function() {
                    return md;
                }
            };
            bt = 0x01;
        }
        // encode and then encrypt
        var d = scheme.encode(md, key.n.bitLength());
        return $76ef6919167a33e0$var$pki.rsa.encrypt(d, key, bt);
    };
    return key;
};
/**
 * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
 *
 * @param rsaKey the ASN.1 RSAPrivateKey.
 *
 * @return the ASN.1 PrivateKeyInfo.
 */ $76ef6919167a33e0$var$pki.wrapRsaPrivateKey = function(rsaKey) {
    // PrivateKeyInfo
    return $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
        // version (0)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$asn1.integerToDer(0).getBytes()),
        // privateKeyAlgorithm
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
            $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.OID, false, $76ef6919167a33e0$var$asn1.oidToDer($76ef6919167a33e0$var$pki.oids.rsaEncryption).getBytes()),
            $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.NULL, false, "")
        ]),
        // PrivateKey
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.OCTETSTRING, false, $76ef6919167a33e0$var$asn1.toDer(rsaKey).getBytes())
    ]);
};
/**
 * Converts a private key from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
 *          RSAPrivateKey or an RSAPrivateKey.
 *
 * @return the private key.
 */ $76ef6919167a33e0$var$pki.privateKeyFromAsn1 = function(obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];
    if ($76ef6919167a33e0$var$asn1.validate(obj, $76ef6919167a33e0$var$privateKeyValidator, capture, errors)) obj = $76ef6919167a33e0$var$asn1.fromDer($dEd5p.util.createBuffer(capture.privateKey));
    // get RSAPrivateKey
    capture = {};
    errors = [];
    if (!$76ef6919167a33e0$var$asn1.validate(obj, $76ef6919167a33e0$var$rsaPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        error.errors = errors;
        throw error;
    }
    // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n, e, d, p, q, dP, dQ, qInv;
    n = $dEd5p.util.createBuffer(capture.privateKeyModulus).toHex();
    e = $dEd5p.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = $dEd5p.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = $dEd5p.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = $dEd5p.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = $dEd5p.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = $dEd5p.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = $dEd5p.util.createBuffer(capture.privateKeyCoefficient).toHex();
    // set private key
    return $76ef6919167a33e0$var$pki.setRsaPrivateKey(new $76ef6919167a33e0$var$BigInteger(n, 16), new $76ef6919167a33e0$var$BigInteger(e, 16), new $76ef6919167a33e0$var$BigInteger(d, 16), new $76ef6919167a33e0$var$BigInteger(p, 16), new $76ef6919167a33e0$var$BigInteger(q, 16), new $76ef6919167a33e0$var$BigInteger(dP, 16), new $76ef6919167a33e0$var$BigInteger(dQ, 16), new $76ef6919167a33e0$var$BigInteger(qInv, 16));
};
/**
 * Converts a private key to an ASN.1 RSAPrivateKey.
 *
 * @param key the private key.
 *
 * @return the ASN.1 representation of an RSAPrivateKey.
 */ $76ef6919167a33e0$var$pki.privateKeyToAsn1 = $76ef6919167a33e0$var$pki.privateKeyToRSAPrivateKey = function(key) {
    // RSAPrivateKey
    return $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
        // version (0 = only 2 primes, 1 multiple primes)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$asn1.integerToDer(0).getBytes()),
        // modulus (n)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.e)),
        // privateExponent (d)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.d)),
        // privateKeyPrime1 (p)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.p)),
        // privateKeyPrime2 (q)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.q)),
        // privateKeyExponent1 (dP)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.dP)),
        // privateKeyExponent2 (dQ)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.dQ)),
        // coefficient (qInv)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.qInv))
    ]);
};
/**
 * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @return the public key.
 */ $76ef6919167a33e0$var$pki.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    if ($76ef6919167a33e0$var$asn1.validate(obj, $76ef6919167a33e0$var$publicKeyValidator, capture, errors)) {
        // get oid
        var oid = $76ef6919167a33e0$var$asn1.derToOid(capture.publicKeyOid);
        if (oid !== $76ef6919167a33e0$var$pki.oids.rsaEncryption) {
            var error = new Error("Cannot read public key. Unknown OID.");
            error.oid = oid;
            throw error;
        }
        obj = capture.rsaPublicKey;
    }
    // get RSA params
    errors = [];
    if (!$76ef6919167a33e0$var$asn1.validate(obj, $76ef6919167a33e0$var$rsaPublicKeyValidator, capture, errors)) {
        var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
        error.errors = errors;
        throw error;
    }
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n = $dEd5p.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = $dEd5p.util.createBuffer(capture.publicKeyExponent).toHex();
    // set public key
    return $76ef6919167a33e0$var$pki.setRsaPublicKey(new $76ef6919167a33e0$var$BigInteger(n, 16), new $76ef6919167a33e0$var$BigInteger(e, 16));
};
/**
 * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a SubjectPublicKeyInfo.
 */ $76ef6919167a33e0$var$pki.publicKeyToAsn1 = $76ef6919167a33e0$var$pki.publicKeyToSubjectPublicKeyInfo = function(key) {
    // SubjectPublicKeyInfo
    return $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
        // AlgorithmIdentifier
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.OID, false, $76ef6919167a33e0$var$asn1.oidToDer($76ef6919167a33e0$var$pki.oids.rsaEncryption).getBytes()),
            // parameters (null)
            $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.NULL, false, "")
        ]),
        // subjectPublicKey
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.BITSTRING, false, [
            $76ef6919167a33e0$var$pki.publicKeyToRSAPublicKey(key)
        ])
    ]);
};
/**
 * Converts a public key to an ASN.1 RSAPublicKey.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a RSAPublicKey.
 */ $76ef6919167a33e0$var$pki.publicKeyToRSAPublicKey = function(key) {
    // RSAPublicKey
    return $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.SEQUENCE, true, [
        // modulus (n)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $76ef6919167a33e0$var$asn1.create($76ef6919167a33e0$var$asn1.Class.UNIVERSAL, $76ef6919167a33e0$var$asn1.Type.INTEGER, false, $76ef6919167a33e0$var$_bnToBytes(key.e))
    ]);
};
/**
 * Encodes a message using PKCS#1 v1.5 padding.
 *
 * @param m the message to encode.
 * @param key the RSA key to use.
 * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
 *          (for encryption).
 *
 * @return the padded byte buffer.
 */ function $76ef6919167a33e0$var$_encodePkcs1_v1_5(m, key, bt) {
    var eb = $dEd5p.util.createBuffer();
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */ if (m.length > k - 11) {
        var error = new Error("Message is too long for PKCS#1 v1.5 padding.");
        error.length = m.length;
        error.max = k - 11;
        throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
    formatted into an octet string EB, the encryption block:

    EB = 00 || BT || PS || 00 || D

    The block type BT shall be a single octet indicating the structure of
    the encryption block. For this version of the document it shall have
    value 00, 01, or 02. For a private-key operation, the block type
    shall be 00 or 01. For a public-key operation, it shall be 02.

    The padding string PS shall consist of k-3-||D|| octets. For block
    type 00, the octets shall have value 00; for block type 01, they
    shall have value FF; and for block type 02, they shall be
    pseudorandomly generated and nonzero. This makes the length of the
    encryption block EB equal to k. */ // build the encryption block
    eb.putByte(0x00);
    eb.putByte(bt);
    // create the padding
    var padNum = k - 3 - m.length;
    var padByte;
    // private key op
    if (bt === 0x00 || bt === 0x01) {
        padByte = bt === 0x00 ? 0x00 : 0xFF;
        for(var i = 0; i < padNum; ++i)eb.putByte(padByte);
    } else // public key op
    // pad with random non-zero values
    while(padNum > 0){
        var numZeros = 0;
        var padBytes = $dEd5p.random.getBytes(padNum);
        for(var i = 0; i < padNum; ++i){
            padByte = padBytes.charCodeAt(i);
            if (padByte === 0) ++numZeros;
            else eb.putByte(padByte);
        }
        padNum = numZeros;
    }
    // zero followed by message
    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
}
/**
 * Decodes a message using PKCS#1 v1.5 padding.
 *
 * @param em the message to decode.
 * @param key the RSA key to use.
 * @param pub true if the key is a public key, false if it is private.
 * @param ml the message length, if specified.
 *
 * @return the decoded bytes.
 */ function $76ef6919167a33e0$var$_decodePkcs1_v1_5(em, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:

    1. The encryption block EB cannot be parsed unambiguously.
    2. The padding string PS consists of fewer than eight octets
      or is inconsisent with the block type BT.
    3. The decryption process is a public-key operation and the block
      type BT is not 00 or 01, or the decryption process is a
      private-key operation and the block type is not 02.
   */ // parse the encryption block
    var eb = $dEd5p.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();
    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt != 0x02 || pub && bt === 0x00 && typeof ml === "undefined") throw new Error("Encryption block is invalid.");
    var padNum = 0;
    if (bt === 0x00) {
        // check all padding bytes for 0x00
        padNum = k - 3 - ml;
        for(var i = 0; i < padNum; ++i){
            if (eb.getByte() !== 0x00) throw new Error("Encryption block is invalid.");
        }
    } else if (bt === 0x01) {
        // find the first byte that isn't 0xFF, should be after all padding
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() !== 0xFF) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    } else if (bt === 0x02) {
        // look for 0x00 byte
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() === 0x00) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    }
    // zero must be 0x00 and padNum must be (k - 3 - message length)
    var zero = eb.getByte();
    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) throw new Error("Encryption block is invalid.");
    return eb.getBytes();
}
/**
 * Runs the key-generation algorithm asynchronously, either in the background
 * via Web Workers, or using the main thread and setImmediate.
 *
 * @param state the key-pair generation state.
 * @param [options] options for key-pair generation:
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2, -1 to use estimated cores minus one).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 * @param callback(err, keypair) called once the operation completes.
 */ function $76ef6919167a33e0$var$_generateKeyPair(state, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    var opts = {
        algorithm: {
            name: options.algorithm || "PRIMEINC",
            options: {
                workers: options.workers || 2,
                workLoad: options.workLoad || 100,
                workerScript: options.workerScript
            }
        }
    };
    if ("prng" in options) opts.prng = options.prng;
    generate();
    function generate() {
        // find p and then q (done in series to simplify)
        getPrime(state.pBits, function(err, num) {
            if (err) return callback(err);
            state.p = num;
            if (state.q !== null) return finish(err, state.q);
            getPrime(state.qBits, finish);
        });
    }
    function getPrime(bits, callback) {
        $dEd5p.prime.generateProbablePrime(bits, opts, callback);
    }
    function finish(err, num) {
        if (err) return callback(err);
        // set q
        state.q = num;
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
            var tmp = state.p;
            state.p = state.q;
            state.q = tmp;
        }
        // ensure p is coprime with e
        if (state.p.subtract($76ef6919167a33e0$var$BigInteger.ONE).gcd(state.e).compareTo($76ef6919167a33e0$var$BigInteger.ONE) !== 0) {
            state.p = null;
            generate();
            return;
        }
        // ensure q is coprime with e
        if (state.q.subtract($76ef6919167a33e0$var$BigInteger.ONE).gcd(state.e).compareTo($76ef6919167a33e0$var$BigInteger.ONE) !== 0) {
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract($76ef6919167a33e0$var$BigInteger.ONE);
        state.q1 = state.q.subtract($76ef6919167a33e0$var$BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo($76ef6919167a33e0$var$BigInteger.ONE) !== 0) {
            // phi and e aren't coprime, so generate a new p and q
            state.p = state.q = null;
            generate();
            return;
        }
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q);
        if (state.n.bitLength() !== state.bits) {
            // failed, get new q
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
            privateKey: $76ef6919167a33e0$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
            publicKey: $76ef6919167a33e0$var$pki.rsa.setPublicKey(state.n, state.e)
        };
        callback(null, state.keys);
    }
}
/**
 * Converts a positive BigInteger into 2's-complement big-endian bytes.
 *
 * @param b the big integer to convert.
 *
 * @return the bytes.
 */ function $76ef6919167a33e0$var$_bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);
    if (hex[0] >= "8") hex = "00" + hex;
    var bytes = $dEd5p.util.hexToBytes(hex);
    // ensure integer is minimally-encoded
    if (bytes.length > 1 && // leading 0x00 for positive integer
    (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) return bytes.substr(1);
    return bytes;
}
/**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function $76ef6919167a33e0$var$_getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
}
/**
 * Performs feature detection on the Node crypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $76ef6919167a33e0$var$_detectNodeCrypto(fn) {
    return $dEd5p.util.isNodejs && typeof $76ef6919167a33e0$var$_crypto[fn] === "function";
}
/**
 * Performs feature detection on the SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $76ef6919167a33e0$var$_detectSubtleCrypto(fn) {
    return typeof $76ef6919167a33e0$var$util.globalScope !== "undefined" && typeof $76ef6919167a33e0$var$util.globalScope.crypto === "object" && typeof $76ef6919167a33e0$var$util.globalScope.crypto.subtle === "object" && typeof $76ef6919167a33e0$var$util.globalScope.crypto.subtle[fn] === "function";
}
/**
 * Performs feature detection on the deprecated Microsoft Internet Explorer
 * outdated SubtleCrypto interface. This function should only be used after
 * checking for the modern, standard SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $76ef6919167a33e0$var$_detectSubtleMsCrypto(fn) {
    return typeof $76ef6919167a33e0$var$util.globalScope !== "undefined" && typeof $76ef6919167a33e0$var$util.globalScope.msCrypto === "object" && typeof $76ef6919167a33e0$var$util.globalScope.msCrypto.subtle === "object" && typeof $76ef6919167a33e0$var$util.globalScope.msCrypto.subtle[fn] === "function";
}
function $76ef6919167a33e0$var$_intToUint8Array(x) {
    var bytes = $dEd5p.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; ++i)buffer[i] = bytes.charCodeAt(i);
    return buffer;
}
function $76ef6919167a33e0$var$_privateKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    return $76ef6919167a33e0$var$pki.setRsaPrivateKey($76ef6919167a33e0$var$_base64ToBigInt(jwk.n), $76ef6919167a33e0$var$_base64ToBigInt(jwk.e), $76ef6919167a33e0$var$_base64ToBigInt(jwk.d), $76ef6919167a33e0$var$_base64ToBigInt(jwk.p), $76ef6919167a33e0$var$_base64ToBigInt(jwk.q), $76ef6919167a33e0$var$_base64ToBigInt(jwk.dp), $76ef6919167a33e0$var$_base64ToBigInt(jwk.dq), $76ef6919167a33e0$var$_base64ToBigInt(jwk.qi));
}
function $76ef6919167a33e0$var$_publicKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Key algorithm must be "RSA".');
    return $76ef6919167a33e0$var$pki.setRsaPublicKey($76ef6919167a33e0$var$_base64ToBigInt(jwk.n), $76ef6919167a33e0$var$_base64ToBigInt(jwk.e));
}
function $76ef6919167a33e0$var$_base64ToBigInt(b64) {
    return new $76ef6919167a33e0$var$BigInteger($dEd5p.util.bytesToHex($dEd5p.util.decode64(b64)), 16);
}

});
parcelRegister("jAgzQ", function(module, exports) {
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
/*
Licensing (LICENSE)
-------------------

This software is covered under the following copyright:
*/ /*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ /*
Address all questions regarding this license to:

  Tom Wu
  tjw@cs.Stanford.EDU
*/ 
var $dEd5p = parcelRequire("dEd5p");
module.exports = $dEd5p.jsbn = $dEd5p.jsbn || {};
// Bits per digit
var $e41e3cfd1190157d$var$dbits;
// JavaScript engine analysis
var $e41e3cfd1190157d$var$canary = 0xdeadbeefcafe;
var $e41e3cfd1190157d$var$j_lm = ($e41e3cfd1190157d$var$canary & 0xffffff) == 0xefcafe;
// (public) Constructor
function $e41e3cfd1190157d$var$BigInteger(a, b, c) {
    this.data = [];
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
$dEd5p.jsbn.BigInteger = $e41e3cfd1190157d$var$BigInteger;
// return new, unset BigInteger
function $e41e3cfd1190157d$var$nbi() {
    return new $e41e3cfd1190157d$var$BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $e41e3cfd1190157d$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this.data[i++] + w.data[j] + c;
        c = Math.floor(v / 0x4000000);
        w.data[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $e41e3cfd1190157d$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this.data[i] & 0x7fff;
        var h = this.data[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w.data[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $e41e3cfd1190157d$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this.data[i] & 0x3fff;
        var h = this.data[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w.data[j++] = l & 0xfffffff;
    }
    return c;
}
// node.js (no browser)
if (typeof navigator === "undefined") {
    $e41e3cfd1190157d$var$BigInteger.prototype.am = $e41e3cfd1190157d$var$am3;
    $e41e3cfd1190157d$var$dbits = 28;
} else if ($e41e3cfd1190157d$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $e41e3cfd1190157d$var$BigInteger.prototype.am = $e41e3cfd1190157d$var$am2;
    $e41e3cfd1190157d$var$dbits = 30;
} else if ($e41e3cfd1190157d$var$j_lm && navigator.appName != "Netscape") {
    $e41e3cfd1190157d$var$BigInteger.prototype.am = $e41e3cfd1190157d$var$am1;
    $e41e3cfd1190157d$var$dbits = 26;
} else {
    $e41e3cfd1190157d$var$BigInteger.prototype.am = $e41e3cfd1190157d$var$am3;
    $e41e3cfd1190157d$var$dbits = 28;
}
$e41e3cfd1190157d$var$BigInteger.prototype.DB = $e41e3cfd1190157d$var$dbits;
$e41e3cfd1190157d$var$BigInteger.prototype.DM = (1 << $e41e3cfd1190157d$var$dbits) - 1;
$e41e3cfd1190157d$var$BigInteger.prototype.DV = 1 << $e41e3cfd1190157d$var$dbits;
var $e41e3cfd1190157d$var$BI_FP = 52;
$e41e3cfd1190157d$var$BigInteger.prototype.FV = Math.pow(2, $e41e3cfd1190157d$var$BI_FP);
$e41e3cfd1190157d$var$BigInteger.prototype.F1 = $e41e3cfd1190157d$var$BI_FP - $e41e3cfd1190157d$var$dbits;
$e41e3cfd1190157d$var$BigInteger.prototype.F2 = 2 * $e41e3cfd1190157d$var$dbits - $e41e3cfd1190157d$var$BI_FP;
// Digit conversions
var $e41e3cfd1190157d$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $e41e3cfd1190157d$var$BI_RC = new Array();
var $e41e3cfd1190157d$var$rr, $e41e3cfd1190157d$var$vv;
$e41e3cfd1190157d$var$rr = "0".charCodeAt(0);
for($e41e3cfd1190157d$var$vv = 0; $e41e3cfd1190157d$var$vv <= 9; ++$e41e3cfd1190157d$var$vv)$e41e3cfd1190157d$var$BI_RC[$e41e3cfd1190157d$var$rr++] = $e41e3cfd1190157d$var$vv;
$e41e3cfd1190157d$var$rr = "a".charCodeAt(0);
for($e41e3cfd1190157d$var$vv = 10; $e41e3cfd1190157d$var$vv < 36; ++$e41e3cfd1190157d$var$vv)$e41e3cfd1190157d$var$BI_RC[$e41e3cfd1190157d$var$rr++] = $e41e3cfd1190157d$var$vv;
$e41e3cfd1190157d$var$rr = "A".charCodeAt(0);
for($e41e3cfd1190157d$var$vv = 10; $e41e3cfd1190157d$var$vv < 36; ++$e41e3cfd1190157d$var$vv)$e41e3cfd1190157d$var$BI_RC[$e41e3cfd1190157d$var$rr++] = $e41e3cfd1190157d$var$vv;
function $e41e3cfd1190157d$var$int2char(n) {
    return $e41e3cfd1190157d$var$BI_RM.charAt(n);
}
function $e41e3cfd1190157d$var$intAt(s, i) {
    var c = $e41e3cfd1190157d$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $e41e3cfd1190157d$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r.data[i] = this.data[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $e41e3cfd1190157d$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;
    else if (x < -1) this.data[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $e41e3cfd1190157d$var$nbv(i) {
    var r = $e41e3cfd1190157d$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $e41e3cfd1190157d$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $e41e3cfd1190157d$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this.data[this.t++] = x;
        else if (sh + k > this.DB) {
            this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this.data[this.t++] = x >> this.DB - sh;
        } else this.data[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $e41e3cfd1190157d$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this.data[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $e41e3cfd1190157d$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return this.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) > 0) {
            m = true;
            r = $e41e3cfd1190157d$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this.data[i] & (1 << p) - 1) << k - p;
                d |= this.data[--i] >> (p += this.DB - k);
            } else {
                d = this.data[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $e41e3cfd1190157d$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $e41e3cfd1190157d$var$bnNegate() {
    var r = $e41e3cfd1190157d$var$nbi();
    $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $e41e3cfd1190157d$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $e41e3cfd1190157d$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this.data[i] - a.data[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $e41e3cfd1190157d$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $e41e3cfd1190157d$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $e41e3cfd1190157d$var$nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $e41e3cfd1190157d$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r.data[i + n] = this.data[i];
    for(i = n - 1; i >= 0; --i)r.data[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $e41e3cfd1190157d$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r.data[i - n] = this.data[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $e41e3cfd1190157d$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r.data[i + ds + 1] = this.data[i] >> cbs | c;
        c = (this.data[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r.data[i] = 0;
    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $e41e3cfd1190157d$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
        r.data[i - ds] = this.data[i] >> bs;
    }
    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $e41e3cfd1190157d$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] - a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;
    else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $e41e3cfd1190157d$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < y.t; ++i)r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $e41e3cfd1190157d$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x.data[i], r, 2 * i, 0, 1);
        if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r.data[i + x.t] -= x.DV;
            r.data[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $e41e3cfd1190157d$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $e41e3cfd1190157d$var$nbi();
    var y = $e41e3cfd1190157d$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $e41e3cfd1190157d$var$nbits(pm.data[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $e41e3cfd1190157d$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r.data[r.t++] = 1;
        r.subTo(t, r);
    }
    $e41e3cfd1190157d$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y.data[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);
        if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r.data[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $e41e3cfd1190157d$var$bnMod(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($e41e3cfd1190157d$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $e41e3cfd1190157d$var$Classic(m) {
    this.m = m;
}
function $e41e3cfd1190157d$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $e41e3cfd1190157d$var$cRevert(x) {
    return x;
}
function $e41e3cfd1190157d$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $e41e3cfd1190157d$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $e41e3cfd1190157d$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$e41e3cfd1190157d$var$Classic.prototype.convert = $e41e3cfd1190157d$var$cConvert;
$e41e3cfd1190157d$var$Classic.prototype.revert = $e41e3cfd1190157d$var$cRevert;
$e41e3cfd1190157d$var$Classic.prototype.reduce = $e41e3cfd1190157d$var$cReduce;
$e41e3cfd1190157d$var$Classic.prototype.mulTo = $e41e3cfd1190157d$var$cMulTo;
$e41e3cfd1190157d$var$Classic.prototype.sqrTo = $e41e3cfd1190157d$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $e41e3cfd1190157d$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $e41e3cfd1190157d$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $e41e3cfd1190157d$var$montConvert(x) {
    var r = $e41e3cfd1190157d$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($e41e3cfd1190157d$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $e41e3cfd1190157d$var$montRevert(x) {
    var r = $e41e3cfd1190157d$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $e41e3cfd1190157d$var$montReduce(x) {
    while(x.t <= this.mt2)x.data[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x.data[i]*mp mod DV
        var j = x.data[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x.data[j] >= x.DV){
            x.data[j] -= x.DV;
            x.data[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $e41e3cfd1190157d$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $e41e3cfd1190157d$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$e41e3cfd1190157d$var$Montgomery.prototype.convert = $e41e3cfd1190157d$var$montConvert;
$e41e3cfd1190157d$var$Montgomery.prototype.revert = $e41e3cfd1190157d$var$montRevert;
$e41e3cfd1190157d$var$Montgomery.prototype.reduce = $e41e3cfd1190157d$var$montReduce;
$e41e3cfd1190157d$var$Montgomery.prototype.mulTo = $e41e3cfd1190157d$var$montMulTo;
$e41e3cfd1190157d$var$Montgomery.prototype.sqrTo = $e41e3cfd1190157d$var$montSqrTo;
// (protected) true iff this is even
function $e41e3cfd1190157d$var$bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $e41e3cfd1190157d$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $e41e3cfd1190157d$var$BigInteger.ONE;
    var r = $e41e3cfd1190157d$var$nbi(), r2 = $e41e3cfd1190157d$var$nbi(), g = z.convert(this), i = $e41e3cfd1190157d$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $e41e3cfd1190157d$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $e41e3cfd1190157d$var$Classic(m);
    else z = new $e41e3cfd1190157d$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$e41e3cfd1190157d$var$BigInteger.prototype.copyTo = $e41e3cfd1190157d$var$bnpCopyTo;
$e41e3cfd1190157d$var$BigInteger.prototype.fromInt = $e41e3cfd1190157d$var$bnpFromInt;
$e41e3cfd1190157d$var$BigInteger.prototype.fromString = $e41e3cfd1190157d$var$bnpFromString;
$e41e3cfd1190157d$var$BigInteger.prototype.clamp = $e41e3cfd1190157d$var$bnpClamp;
$e41e3cfd1190157d$var$BigInteger.prototype.dlShiftTo = $e41e3cfd1190157d$var$bnpDLShiftTo;
$e41e3cfd1190157d$var$BigInteger.prototype.drShiftTo = $e41e3cfd1190157d$var$bnpDRShiftTo;
$e41e3cfd1190157d$var$BigInteger.prototype.lShiftTo = $e41e3cfd1190157d$var$bnpLShiftTo;
$e41e3cfd1190157d$var$BigInteger.prototype.rShiftTo = $e41e3cfd1190157d$var$bnpRShiftTo;
$e41e3cfd1190157d$var$BigInteger.prototype.subTo = $e41e3cfd1190157d$var$bnpSubTo;
$e41e3cfd1190157d$var$BigInteger.prototype.multiplyTo = $e41e3cfd1190157d$var$bnpMultiplyTo;
$e41e3cfd1190157d$var$BigInteger.prototype.squareTo = $e41e3cfd1190157d$var$bnpSquareTo;
$e41e3cfd1190157d$var$BigInteger.prototype.divRemTo = $e41e3cfd1190157d$var$bnpDivRemTo;
$e41e3cfd1190157d$var$BigInteger.prototype.invDigit = $e41e3cfd1190157d$var$bnpInvDigit;
$e41e3cfd1190157d$var$BigInteger.prototype.isEven = $e41e3cfd1190157d$var$bnpIsEven;
$e41e3cfd1190157d$var$BigInteger.prototype.exp = $e41e3cfd1190157d$var$bnpExp;
// public
$e41e3cfd1190157d$var$BigInteger.prototype.toString = $e41e3cfd1190157d$var$bnToString;
$e41e3cfd1190157d$var$BigInteger.prototype.negate = $e41e3cfd1190157d$var$bnNegate;
$e41e3cfd1190157d$var$BigInteger.prototype.abs = $e41e3cfd1190157d$var$bnAbs;
$e41e3cfd1190157d$var$BigInteger.prototype.compareTo = $e41e3cfd1190157d$var$bnCompareTo;
$e41e3cfd1190157d$var$BigInteger.prototype.bitLength = $e41e3cfd1190157d$var$bnBitLength;
$e41e3cfd1190157d$var$BigInteger.prototype.mod = $e41e3cfd1190157d$var$bnMod;
$e41e3cfd1190157d$var$BigInteger.prototype.modPowInt = $e41e3cfd1190157d$var$bnModPowInt;
// "constants"
$e41e3cfd1190157d$var$BigInteger.ZERO = $e41e3cfd1190157d$var$nbv(0);
$e41e3cfd1190157d$var$BigInteger.ONE = $e41e3cfd1190157d$var$nbv(1);
// jsbn2 lib
//Copyright (c) 2005-2009  Tom Wu
//All Rights Reserved.
//See "LICENSE" for details (See jsbn.js for LICENSE).
//Extended JavaScript BN functions, required for RSA private ops.
//Version 1.1: new BigInteger("0", 10) returns "proper" zero
//(public)
function $e41e3cfd1190157d$var$bnClone() {
    var r = $e41e3cfd1190157d$var$nbi();
    this.copyTo(r);
    return r;
}
//(public) return value as integer
function $e41e3cfd1190157d$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
//(public) return value as byte
function $e41e3cfd1190157d$var$bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
//(public) return value as short (assumes DB>=16)
function $e41e3cfd1190157d$var$bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
//(protected) return x s.t. r^x < DV
function $e41e3cfd1190157d$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
//(public) 0 if this == 0, 1 if this > 0
function $e41e3cfd1190157d$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;
    else return 1;
}
//(protected) convert to radix string
function $e41e3cfd1190157d$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $e41e3cfd1190157d$var$nbv(a), y = $e41e3cfd1190157d$var$nbi(), z = $e41e3cfd1190157d$var$nbi(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
//(protected) convert from radix string
function $e41e3cfd1190157d$var$bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $e41e3cfd1190157d$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) $e41e3cfd1190157d$var$BigInteger.ZERO.subTo(this, this);
}
//(protected) alternate constructor
function $e41e3cfd1190157d$var$bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);
        else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) this.bitwiseTo($e41e3cfd1190157d$var$BigInteger.ONE.shiftLeft(a - 1), $e41e3cfd1190157d$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while(!this.isProbablePrime(b)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo($e41e3cfd1190157d$var$BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        this.fromString(x, 256);
    }
}
//(public) convert to bigendian byte array
function $e41e3cfd1190157d$var$bnToByteArray() {
    var i = this.t, r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (this.data[i] & (1 << p) - 1) << 8 - p;
                d |= this.data[--i] >> (p += this.DB - 8);
            } else {
                d = this.data[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}
function $e41e3cfd1190157d$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $e41e3cfd1190157d$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $e41e3cfd1190157d$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
//(protected) r = this op a (bitwise)
function $e41e3cfd1190157d$var$bnpBitwiseTo(a, op, r) {
    var i, f, m = Math.min(a.t, this.t);
    for(i = 0; i < m; ++i)r.data[i] = op(this.data[i], a.data[i]);
    if (a.t < this.t) {
        f = a.s & this.DM;
        for(i = m; i < this.t; ++i)r.data[i] = op(this.data[i], f);
        r.t = this.t;
    } else {
        f = this.s & this.DM;
        for(i = m; i < a.t; ++i)r.data[i] = op(f, a.data[i]);
        r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}
//(public) this & a
function $e41e3cfd1190157d$var$op_and(x, y) {
    return x & y;
}
function $e41e3cfd1190157d$var$bnAnd(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.bitwiseTo(a, $e41e3cfd1190157d$var$op_and, r);
    return r;
}
//(public) this | a
function $e41e3cfd1190157d$var$op_or(x, y) {
    return x | y;
}
function $e41e3cfd1190157d$var$bnOr(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.bitwiseTo(a, $e41e3cfd1190157d$var$op_or, r);
    return r;
}
//(public) this ^ a
function $e41e3cfd1190157d$var$op_xor(x, y) {
    return x ^ y;
}
function $e41e3cfd1190157d$var$bnXor(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.bitwiseTo(a, $e41e3cfd1190157d$var$op_xor, r);
    return r;
}
//(public) this & ~a
function $e41e3cfd1190157d$var$op_andnot(x, y) {
    return x & ~y;
}
function $e41e3cfd1190157d$var$bnAndNot(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.bitwiseTo(a, $e41e3cfd1190157d$var$op_andnot, r);
    return r;
}
//(public) ~this
function $e41e3cfd1190157d$var$bnNot() {
    var r = $e41e3cfd1190157d$var$nbi();
    for(var i = 0; i < this.t; ++i)r.data[i] = this.DM & ~this.data[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
//(public) this << n
function $e41e3cfd1190157d$var$bnShiftLeft(n) {
    var r = $e41e3cfd1190157d$var$nbi();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
//(public) this >> n
function $e41e3cfd1190157d$var$bnShiftRight(n) {
    var r = $e41e3cfd1190157d$var$nbi();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
//return index of lowest 1-bit in x, x < 2^31
function $e41e3cfd1190157d$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
//(public) returns index of lowest 1-bit (or -1 if none)
function $e41e3cfd1190157d$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this.data[i] != 0) return i * this.DB + $e41e3cfd1190157d$var$lbit(this.data[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
//return number of 1 bits in x
function $e41e3cfd1190157d$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
//(public) return number of set bits
function $e41e3cfd1190157d$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $e41e3cfd1190157d$var$cbit(this.data[i] ^ x);
    return r;
}
//(public) true iff nth bit is set
function $e41e3cfd1190157d$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
}
//(protected) this op (1<<n)
function $e41e3cfd1190157d$var$bnpChangeBit(n, op) {
    var r = $e41e3cfd1190157d$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
//(public) this | (1<<n)
function $e41e3cfd1190157d$var$bnSetBit(n) {
    return this.changeBit(n, $e41e3cfd1190157d$var$op_or);
}
//(public) this & ~(1<<n)
function $e41e3cfd1190157d$var$bnClearBit(n) {
    return this.changeBit(n, $e41e3cfd1190157d$var$op_andnot);
}
//(public) this ^ (1<<n)
function $e41e3cfd1190157d$var$bnFlipBit(n) {
    return this.changeBit(n, $e41e3cfd1190157d$var$op_xor);
}
//(protected) r = this + a
function $e41e3cfd1190157d$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] + a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;
    else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
//(public) this + a
function $e41e3cfd1190157d$var$bnAdd(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.addTo(a, r);
    return r;
}
//(public) this - a
function $e41e3cfd1190157d$var$bnSubtract(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.subTo(a, r);
    return r;
}
//(public) this * a
function $e41e3cfd1190157d$var$bnMultiply(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
//(public) this / a
function $e41e3cfd1190157d$var$bnDivide(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
//(public) this % a
function $e41e3cfd1190157d$var$bnRemainder(a) {
    var r = $e41e3cfd1190157d$var$nbi();
    this.divRemTo(a, null, r);
    return r;
}
//(public) [this/a,this%a]
function $e41e3cfd1190157d$var$bnDivideAndRemainder(a) {
    var q = $e41e3cfd1190157d$var$nbi(), r = $e41e3cfd1190157d$var$nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
//(protected) this *= n, this >= 0, 1 < n < DV
function $e41e3cfd1190157d$var$bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
//(protected) this += n << w words, this >= 0
function $e41e3cfd1190157d$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this.data[this.t++] = 0;
    this.data[w] += n;
    while(this.data[w] >= this.DV){
        this.data[w] -= this.DV;
        if (++w >= this.t) this.data[this.t++] = 0;
        ++this.data[w];
    }
}
//A "null" reducer
function $e41e3cfd1190157d$var$NullExp() {}
function $e41e3cfd1190157d$var$nNop(x) {
    return x;
}
function $e41e3cfd1190157d$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $e41e3cfd1190157d$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$e41e3cfd1190157d$var$NullExp.prototype.convert = $e41e3cfd1190157d$var$nNop;
$e41e3cfd1190157d$var$NullExp.prototype.revert = $e41e3cfd1190157d$var$nNop;
$e41e3cfd1190157d$var$NullExp.prototype.mulTo = $e41e3cfd1190157d$var$nMulTo;
$e41e3cfd1190157d$var$NullExp.prototype.sqrTo = $e41e3cfd1190157d$var$nSqrTo;
//(public) this^e
function $e41e3cfd1190157d$var$bnPow(e) {
    return this.exp(e, new $e41e3cfd1190157d$var$NullExp());
}
//(protected) r = lower n words of "this * a", a.t <= n
//"this" should be the larger one if appropriate.
function $e41e3cfd1190157d$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r.data[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a.data[i], r, i, 0, n - i);
    r.clamp();
}
//(protected) r = "this * a" without lower n words, n > 0
//"this" should be the larger one if appropriate.
function $e41e3cfd1190157d$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r.data[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
//Barrett modular reduction
function $e41e3cfd1190157d$var$Barrett(m) {
    // setup Barrett
    this.r2 = $e41e3cfd1190157d$var$nbi();
    this.q3 = $e41e3cfd1190157d$var$nbi();
    $e41e3cfd1190157d$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $e41e3cfd1190157d$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $e41e3cfd1190157d$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $e41e3cfd1190157d$var$barrettRevert(x) {
    return x;
}
//x = x mod m (HAC 14.42)
function $e41e3cfd1190157d$var$barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
//r = x^2 mod m; x != r
function $e41e3cfd1190157d$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
//r = x*y mod m; x,y != r
function $e41e3cfd1190157d$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$e41e3cfd1190157d$var$Barrett.prototype.convert = $e41e3cfd1190157d$var$barrettConvert;
$e41e3cfd1190157d$var$Barrett.prototype.revert = $e41e3cfd1190157d$var$barrettRevert;
$e41e3cfd1190157d$var$Barrett.prototype.reduce = $e41e3cfd1190157d$var$barrettReduce;
$e41e3cfd1190157d$var$Barrett.prototype.mulTo = $e41e3cfd1190157d$var$barrettMulTo;
$e41e3cfd1190157d$var$Barrett.prototype.sqrTo = $e41e3cfd1190157d$var$barrettSqrTo;
//(public) this^e % m (HAC 14.85)
function $e41e3cfd1190157d$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $e41e3cfd1190157d$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $e41e3cfd1190157d$var$Classic(m);
    else if (m.isEven()) z = new $e41e3cfd1190157d$var$Barrett(m);
    else z = new $e41e3cfd1190157d$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $e41e3cfd1190157d$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $e41e3cfd1190157d$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $e41e3cfd1190157d$var$nbi(), t;
    i = $e41e3cfd1190157d$var$nbits(e.data[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e.data[j] >> i - k1 & km;
        else {
            w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e.data[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
//(public) gcd(this,a) (HAC 14.54)
function $e41e3cfd1190157d$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
//(protected) this % n, n < 2^26
function $e41e3cfd1190157d$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this.data[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this.data[i]) % n;
    }
    return r;
}
//(public) 1/this % m (HAC 14.61)
function $e41e3cfd1190157d$var$bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return $e41e3cfd1190157d$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $e41e3cfd1190157d$var$nbv(1), b = $e41e3cfd1190157d$var$nbv(0), c = $e41e3cfd1190157d$var$nbv(0), d = $e41e3cfd1190157d$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($e41e3cfd1190157d$var$BigInteger.ONE) != 0) return $e41e3cfd1190157d$var$BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);
    else return d;
    if (d.signum() < 0) return d.add(m);
    else return d;
}
var $e41e3cfd1190157d$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509
];
var $e41e3cfd1190157d$var$lplim = 67108864 / $e41e3cfd1190157d$var$lowprimes[$e41e3cfd1190157d$var$lowprimes.length - 1];
//(public) test primality with certainty >= 1-.5^t
function $e41e3cfd1190157d$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x.data[0] <= $e41e3cfd1190157d$var$lowprimes[$e41e3cfd1190157d$var$lowprimes.length - 1]) {
        for(i = 0; i < $e41e3cfd1190157d$var$lowprimes.length; ++i)if (x.data[0] == $e41e3cfd1190157d$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $e41e3cfd1190157d$var$lowprimes.length){
        var m = $e41e3cfd1190157d$var$lowprimes[i], j = i + 1;
        while(j < $e41e3cfd1190157d$var$lowprimes.length && m < $e41e3cfd1190157d$var$lplim)m *= $e41e3cfd1190157d$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $e41e3cfd1190157d$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
//(protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $e41e3cfd1190157d$var$bnpMillerRabin(t) {
    var n1 = this.subtract($e41e3cfd1190157d$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = $e41e3cfd1190157d$var$bnGetPrng();
    var a;
    for(var i = 0; i < t; ++i){
        // select witness 'a' at random from between 1 and n1
        do a = new $e41e3cfd1190157d$var$BigInteger(this.bitLength(), prng);
        while (a.compareTo($e41e3cfd1190157d$var$BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);
        var y = a.modPow(r, this);
        if (y.compareTo($e41e3cfd1190157d$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($e41e3cfd1190157d$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// get pseudo random number generator
function $e41e3cfd1190157d$var$bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            for(var i = 0; i < x.length; ++i)x[i] = Math.floor(Math.random() * 0x0100);
        }
    };
}
//protected
$e41e3cfd1190157d$var$BigInteger.prototype.chunkSize = $e41e3cfd1190157d$var$bnpChunkSize;
$e41e3cfd1190157d$var$BigInteger.prototype.toRadix = $e41e3cfd1190157d$var$bnpToRadix;
$e41e3cfd1190157d$var$BigInteger.prototype.fromRadix = $e41e3cfd1190157d$var$bnpFromRadix;
$e41e3cfd1190157d$var$BigInteger.prototype.fromNumber = $e41e3cfd1190157d$var$bnpFromNumber;
$e41e3cfd1190157d$var$BigInteger.prototype.bitwiseTo = $e41e3cfd1190157d$var$bnpBitwiseTo;
$e41e3cfd1190157d$var$BigInteger.prototype.changeBit = $e41e3cfd1190157d$var$bnpChangeBit;
$e41e3cfd1190157d$var$BigInteger.prototype.addTo = $e41e3cfd1190157d$var$bnpAddTo;
$e41e3cfd1190157d$var$BigInteger.prototype.dMultiply = $e41e3cfd1190157d$var$bnpDMultiply;
$e41e3cfd1190157d$var$BigInteger.prototype.dAddOffset = $e41e3cfd1190157d$var$bnpDAddOffset;
$e41e3cfd1190157d$var$BigInteger.prototype.multiplyLowerTo = $e41e3cfd1190157d$var$bnpMultiplyLowerTo;
$e41e3cfd1190157d$var$BigInteger.prototype.multiplyUpperTo = $e41e3cfd1190157d$var$bnpMultiplyUpperTo;
$e41e3cfd1190157d$var$BigInteger.prototype.modInt = $e41e3cfd1190157d$var$bnpModInt;
$e41e3cfd1190157d$var$BigInteger.prototype.millerRabin = $e41e3cfd1190157d$var$bnpMillerRabin;
//public
$e41e3cfd1190157d$var$BigInteger.prototype.clone = $e41e3cfd1190157d$var$bnClone;
$e41e3cfd1190157d$var$BigInteger.prototype.intValue = $e41e3cfd1190157d$var$bnIntValue;
$e41e3cfd1190157d$var$BigInteger.prototype.byteValue = $e41e3cfd1190157d$var$bnByteValue;
$e41e3cfd1190157d$var$BigInteger.prototype.shortValue = $e41e3cfd1190157d$var$bnShortValue;
$e41e3cfd1190157d$var$BigInteger.prototype.signum = $e41e3cfd1190157d$var$bnSigNum;
$e41e3cfd1190157d$var$BigInteger.prototype.toByteArray = $e41e3cfd1190157d$var$bnToByteArray;
$e41e3cfd1190157d$var$BigInteger.prototype.equals = $e41e3cfd1190157d$var$bnEquals;
$e41e3cfd1190157d$var$BigInteger.prototype.min = $e41e3cfd1190157d$var$bnMin;
$e41e3cfd1190157d$var$BigInteger.prototype.max = $e41e3cfd1190157d$var$bnMax;
$e41e3cfd1190157d$var$BigInteger.prototype.and = $e41e3cfd1190157d$var$bnAnd;
$e41e3cfd1190157d$var$BigInteger.prototype.or = $e41e3cfd1190157d$var$bnOr;
$e41e3cfd1190157d$var$BigInteger.prototype.xor = $e41e3cfd1190157d$var$bnXor;
$e41e3cfd1190157d$var$BigInteger.prototype.andNot = $e41e3cfd1190157d$var$bnAndNot;
$e41e3cfd1190157d$var$BigInteger.prototype.not = $e41e3cfd1190157d$var$bnNot;
$e41e3cfd1190157d$var$BigInteger.prototype.shiftLeft = $e41e3cfd1190157d$var$bnShiftLeft;
$e41e3cfd1190157d$var$BigInteger.prototype.shiftRight = $e41e3cfd1190157d$var$bnShiftRight;
$e41e3cfd1190157d$var$BigInteger.prototype.getLowestSetBit = $e41e3cfd1190157d$var$bnGetLowestSetBit;
$e41e3cfd1190157d$var$BigInteger.prototype.bitCount = $e41e3cfd1190157d$var$bnBitCount;
$e41e3cfd1190157d$var$BigInteger.prototype.testBit = $e41e3cfd1190157d$var$bnTestBit;
$e41e3cfd1190157d$var$BigInteger.prototype.setBit = $e41e3cfd1190157d$var$bnSetBit;
$e41e3cfd1190157d$var$BigInteger.prototype.clearBit = $e41e3cfd1190157d$var$bnClearBit;
$e41e3cfd1190157d$var$BigInteger.prototype.flipBit = $e41e3cfd1190157d$var$bnFlipBit;
$e41e3cfd1190157d$var$BigInteger.prototype.add = $e41e3cfd1190157d$var$bnAdd;
$e41e3cfd1190157d$var$BigInteger.prototype.subtract = $e41e3cfd1190157d$var$bnSubtract;
$e41e3cfd1190157d$var$BigInteger.prototype.multiply = $e41e3cfd1190157d$var$bnMultiply;
$e41e3cfd1190157d$var$BigInteger.prototype.divide = $e41e3cfd1190157d$var$bnDivide;
$e41e3cfd1190157d$var$BigInteger.prototype.remainder = $e41e3cfd1190157d$var$bnRemainder;
$e41e3cfd1190157d$var$BigInteger.prototype.divideAndRemainder = $e41e3cfd1190157d$var$bnDivideAndRemainder;
$e41e3cfd1190157d$var$BigInteger.prototype.modPow = $e41e3cfd1190157d$var$bnModPow;
$e41e3cfd1190157d$var$BigInteger.prototype.modInverse = $e41e3cfd1190157d$var$bnModInverse;
$e41e3cfd1190157d$var$BigInteger.prototype.pow = $e41e3cfd1190157d$var$bnPow;
$e41e3cfd1190157d$var$BigInteger.prototype.gcd = $e41e3cfd1190157d$var$bnGCD;
$e41e3cfd1190157d$var$BigInteger.prototype.isProbablePrime = $e41e3cfd1190157d$var$bnIsProbablePrime; //BigInteger interfaces not implemented in jsbn:
 //BigInteger(int signum, byte[] magnitude)
 //double doubleValue()
 //float floatValue()
 //int hashCode()
 //long longValue()
 //static BigInteger valueOf(long val)

});

parcelRegister("1VPPt", function(module, exports) {
/**
 * Prime number generation API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
parcelRequire("jAgzQ");
parcelRequire("4N8iP");
(function() {
    // forge.prime already defined
    if ($dEd5p.prime) {
        module.exports = $dEd5p.prime;
        return;
    }
    /* PRIME API */ var prime = module.exports = $dEd5p.prime = $dEd5p.prime || {};
    var BigInteger = $dEd5p.jsbn.BigInteger;
    // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
    var GCD_30_DELTA = [
        6,
        4,
        2,
        4,
        2,
        4,
        6,
        2
    ];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var op_or = function(x, y) {
        return x | y;
    };
    /**
 * Generates a random probable prime with the given number of bits.
 *
 * Alternative algorithms can be specified by name as a string or as an
 * object with custom options like so:
 *
 * {
 *   name: 'PRIMEINC',
 *   options: {
 *     maxBlockTime: <the maximum amount of time to block the main
 *       thread before allowing I/O other JS to run>,
 *     millerRabinTests: <the number of miller-rabin tests to run>,
 *     workerScript: <the worker script URL>,
 *     workers: <the number of web workers (if supported) to use,
 *       -1 to use estimated cores minus one>.
 *     workLoad: the size of the work load, ie: number of possible prime
 *       numbers for each web worker to check per work assignment,
 *       (default: 100).
 *   }
 * }
 *
 * @param bits the number of bits for the prime number.
 * @param options the options to use.
 *          [algorithm] the algorithm to use (default: 'PRIMEINC').
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *
 * @return callback(err, num) called once the operation completes.
 */ prime.generateProbablePrime = function(bits, options, callback) {
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        options = options || {};
        // default to PRIMEINC algorithm
        var algorithm = options.algorithm || "PRIMEINC";
        if (typeof algorithm === "string") algorithm = {
            name: algorithm
        };
        algorithm.options = algorithm.options || {};
        // create prng with api that matches BigInteger secure random
        var prng = options.prng || $dEd5p.random;
        var rng = {
            // x is an array to fill with bytes
            nextBytes: function(x) {
                var b = prng.getBytesSync(x.length);
                for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
            }
        };
        if (algorithm.name === "PRIMEINC") return primeincFindPrime(bits, rng, algorithm.options, callback);
        throw new Error("Invalid prime generation algorithm: " + algorithm.name);
    };
    function primeincFindPrime(bits, rng, options, callback) {
        if ("workers" in options) return primeincFindPrimeWithWorkers(bits, rng, options, callback);
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
        // initialize random number
        var num = generateRandom(bits, rng);
        /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
  number we are given is always aligned at 30k + 1. Each time the number is
  determined not to be prime we add to get to the next 'i', eg: if the number
  was at 30k + 1 we add 6. */ var deltaIdx = 0;
        // get required number of MR tests
        var mrTests = getMillerRabinTests(num.bitLength());
        if ("millerRabinTests" in options) mrTests = options.millerRabinTests;
        // find prime nearest to 'num' for maxBlockTime ms
        // 10 ms gives 5ms of leeway for other calculations before dropping
        // below 60fps (1000/60 == 16.67), but in reality, the number will
        // likely be higher due to an 'atomic' big int modPow
        var maxBlockTime = 10;
        if ("maxBlockTime" in options) maxBlockTime = options.maxBlockTime;
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }
    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
        var start = +new Date();
        do {
            // overflow, regenerate random number
            if (num.bitLength() > bits) num = generateRandom(bits, rng);
            // do primality test
            if (num.isProbablePrime(mrTests)) return callback(null, num);
            // get next potential prime
            num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }while (maxBlockTime < 0 || +new Date() - start < maxBlockTime);
        // keep trying later
        $dEd5p.util.setImmediate(function() {
            _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
        });
    }
    // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.
    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
        // web workers unavailable
        if (typeof Worker === "undefined") return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
        // initialize random number
        var num = generateRandom(bits, rng);
        // use web workers to generate keys
        var numWorkers = options.workers;
        var workLoad = options.workLoad || 100;
        var range = workLoad * 30 / 8;
        var workerScript = options.workerScript || "forge/prime.worker.js";
        if (numWorkers === -1) return $dEd5p.util.estimateCores(function(err, cores) {
            if (err) // default to 2
            cores = 2;
            numWorkers = cores - 1;
            generate();
        });
        generate();
        function generate() {
            // require at least 1 worker
            numWorkers = Math.max(1, numWorkers);
            // TODO: consider optimizing by starting workers outside getPrime() ...
            // note that in order to clean up they will have to be made internally
            // asynchronous which may actually be slower
            // start workers immediately
            var workers = [];
            for(var i = 0; i < numWorkers; ++i)// FIXME: fix path or use blob URLs
            workers[i] = new Worker(workerScript);
            var running = numWorkers;
            // listen for requests from workers and assign ranges to find prime
            for(var i = 0; i < numWorkers; ++i)workers[i].addEventListener("message", workerMessage);
            /* Note: The distribution of random numbers is unknown. Therefore, each
    web worker is continuously allocated a range of numbers to check for a
    random number until one is found.

    Every 30 numbers will be checked just 8 times, because prime numbers
    have the form:

    30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)

    Therefore, if we want a web worker to run N checks before asking for
    a new range of numbers, each range must contain N*30/8 numbers.

    For 100 checks (workLoad), this is a range of 375. */ var found = false;
            function workerMessage(e) {
                // ignore message, prime already found
                if (found) return;
                --running;
                var data = e.data;
                if (data.found) {
                    // terminate all workers
                    for(var i = 0; i < workers.length; ++i)workers[i].terminate();
                    found = true;
                    return callback(null, new BigInteger(data.prime, 16));
                }
                // overflow, regenerate random number
                if (num.bitLength() > bits) num = generateRandom(bits, rng);
                // assign new range to check
                var hex = num.toString(16);
                // start prime search
                e.target.postMessage({
                    hex: hex,
                    workLoad: workLoad
                });
                num.dAddOffset(range, 0);
            }
        }
    }
    /**
 * Generates a random number using the given number of bits and RNG.
 *
 * @param bits the number of bits for the number.
 * @param rng the random number generator to use.
 *
 * @return the random number.
 */ function generateRandom(bits, rng) {
        var num = new BigInteger(bits, rng);
        // force MSB set
        var bits1 = bits - 1;
        if (!num.testBit(bits1)) num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
        // align number on 30k+1 boundary
        num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
        return num;
    }
    /**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function getMillerRabinTests(bits) {
        if (bits <= 100) return 27;
        if (bits <= 150) return 18;
        if (bits <= 200) return 15;
        if (bits <= 250) return 12;
        if (bits <= 300) return 9;
        if (bits <= 350) return 8;
        if (bits <= 400) return 7;
        if (bits <= 500) return 6;
        if (bits <= 600) return 5;
        if (bits <= 800) return 4;
        if (bits <= 1250) return 3;
        return 2;
    }
})();

});




parcelRegister("lAXzO", function(module, exports) {
/**
 * Javascript implementation of a basic Public Key Infrastructure, including
 * support for RSA public and private keys.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("8QTFz");
parcelRequire("ggdRy");
parcelRequire("egSpF");
parcelRequire("fYcEB");
parcelRequire("9Lx2j");
parcelRequire("5J3Rq");
parcelRequire("54e3h");
parcelRequire("ad5x8");
parcelRequire("kvSv3");
parcelRequire("1p4rv");
// shortcut for asn.1 API
var $fb8b2c76a3fceaa0$var$asn1 = $dEd5p.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $fb8b2c76a3fceaa0$var$pki = module.exports = $dEd5p.pki = $dEd5p.pki || {};
/**
 * NOTE: THIS METHOD IS DEPRECATED. Use pem.decode() instead.
 *
 * Converts PEM-formatted data to DER.
 *
 * @param pem the PEM-formatted data.
 *
 * @return the DER-formatted data.
 */ $fb8b2c76a3fceaa0$var$pki.pemToDer = function(pem) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert PEM to DER; PEM is encrypted.");
    return $dEd5p.util.createBuffer(msg.body);
};
/**
 * Converts an RSA private key from PEM format.
 *
 * @param pem the PEM-formatted private key.
 *
 * @return the private key.
 */ $fb8b2c76a3fceaa0$var$pki.privateKeyFromPem = function(pem) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $fb8b2c76a3fceaa0$var$asn1.fromDer(msg.body);
    return $fb8b2c76a3fceaa0$var$pki.privateKeyFromAsn1(obj);
};
/**
 * Converts an RSA private key to PEM format.
 *
 * @param key the private key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $fb8b2c76a3fceaa0$var$pki.privateKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "RSA PRIVATE KEY",
        body: $fb8b2c76a3fceaa0$var$asn1.toDer($fb8b2c76a3fceaa0$var$pki.privateKeyToAsn1(key)).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PrivateKeyInfo to PEM format.
 *
 * @param pki the PrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted private key.
 */ $fb8b2c76a3fceaa0$var$pki.privateKeyInfoToPem = function(pki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "PRIVATE KEY",
        body: $fb8b2c76a3fceaa0$var$asn1.toDer(pki).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};

});
parcelRegister("egSpF", function(module, exports) {
/**
 * Password-based encryption functions.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * An EncryptedPrivateKeyInfo:
 *
 * EncryptedPrivateKeyInfo ::= SEQUENCE {
 *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
 *   encryptedData        EncryptedData }
 *
 * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedData ::= OCTET STRING
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("7vq5X");
parcelRequire("8QTFz");
parcelRequire("bweuJ");
parcelRequire("jaAdc");
parcelRequire("ggdRy");
parcelRequire("9Lx2j");
parcelRequire("fYcEB");
parcelRequire("4N8iP");
parcelRequire("afsa3");
parcelRequire("ad5x8");
parcelRequire("kvSv3");
if (typeof $a63cc49700fd0ee3$var$BigInteger === "undefined") var $a63cc49700fd0ee3$var$BigInteger = $dEd5p.jsbn.BigInteger;
// shortcut for asn.1 API
var $a63cc49700fd0ee3$var$asn1 = $dEd5p.asn1;
/* Password-based encryption implementation. */ var $a63cc49700fd0ee3$var$pki = $dEd5p.pki = $dEd5p.pki || {};
module.exports = $a63cc49700fd0ee3$var$pki.pbe = $dEd5p.pbe = $dEd5p.pbe || {};
var $a63cc49700fd0ee3$var$oids = $a63cc49700fd0ee3$var$pki.oids;
// validator for an EncryptedPrivateKeyInfo structure
// Note: Currently only works w/algorithm params
var $a63cc49700fd0ee3$var$encryptedPrivateKeyValidator = {
    name: "EncryptedPrivateKeyInfo",
    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
    type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encryptionOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "encryptionParams"
                }
            ]
        },
        {
            // encryptedData
            name: "EncryptedPrivateKeyInfo.encryptedData",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encryptedData"
        }
    ]
};
// validator for a PBES2Algorithms structure
// Note: Currently only works w/PBKDF2 + AES encryption schemes
var $a63cc49700fd0ee3$var$PBES2AlgorithmsValidator = {
    name: "PBES2Algorithms",
    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
    type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PBES2Algorithms.keyDerivationFunc",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.keyDerivationFunc.oid",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.OID,
                    constructed: false,
                    capture: "kdfOid"
                },
                {
                    name: "PBES2Algorithms.params",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PBES2Algorithms.params.salt",
                            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                            type: $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "kdfSalt"
                        },
                        {
                            name: "PBES2Algorithms.params.iterationCount",
                            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                            type: $a63cc49700fd0ee3$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "kdfIterationCount"
                        },
                        {
                            name: "PBES2Algorithms.params.keyLength",
                            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                            type: $a63cc49700fd0ee3$var$asn1.Type.INTEGER,
                            constructed: false,
                            optional: true,
                            capture: "keyLength"
                        },
                        {
                            // prf
                            name: "PBES2Algorithms.params.prf",
                            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                            type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            optional: true,
                            value: [
                                {
                                    name: "PBES2Algorithms.params.prf.algorithm",
                                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                                    type: $a63cc49700fd0ee3$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "prfOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "PBES2Algorithms.encryptionScheme",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.encryptionScheme.oid",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encOid"
                },
                {
                    name: "PBES2Algorithms.encryptionScheme.iv",
                    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
                    type: $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "encIv"
                }
            ]
        }
    ]
};
var $a63cc49700fd0ee3$var$pkcs12PbeParamsValidator = {
    name: "pkcs-12PbeParams",
    tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
    type: $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "pkcs-12PbeParams.salt",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "salt"
        },
        {
            name: "pkcs-12PbeParams.iterations",
            tagClass: $a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL,
            type: $a63cc49700fd0ee3$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "iterations"
        }
    ]
};
/**
 * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
 *
 * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
 *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
 *
 * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
 *
 * PBES2-params ::= SEQUENCE {
 *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
 *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
 * }
 *
 * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
 *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
 *
 * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
 *
 * PBKDF2-params ::= SEQUENCE {
 *   salt CHOICE {
 *     specified OCTET STRING,
 *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
 *   },
 *   iterationCount INTEGER (1..MAX),
 *   keyLength INTEGER (1..MAX) OPTIONAL,
 *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
 * }
 *
 * @param obj the ASN.1 PrivateKeyInfo object.
 * @param password the password to encrypt with.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          prfAlgorithm the PRF message digest algorithm to use
 *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $a63cc49700fd0ee3$var$pki.encryptPrivateKeyInfo = function(obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || "aes128";
    options.prfAlgorithm = options.prfAlgorithm || "sha1";
    // generate PBE params
    var salt = $dEd5p.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = $a63cc49700fd0ee3$var$asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;
    if (options.algorithm.indexOf("aes") === 0 || options.algorithm === "des") {
        // do PBES2
        var ivLen, encOid, cipherFn;
        switch(options.algorithm){
            case "aes128":
                dkLen = 16;
                ivLen = 16;
                encOid = $a63cc49700fd0ee3$var$oids["aes128-CBC"];
                cipherFn = $dEd5p.aes.createEncryptionCipher;
                break;
            case "aes192":
                dkLen = 24;
                ivLen = 16;
                encOid = $a63cc49700fd0ee3$var$oids["aes192-CBC"];
                cipherFn = $dEd5p.aes.createEncryptionCipher;
                break;
            case "aes256":
                dkLen = 32;
                ivLen = 16;
                encOid = $a63cc49700fd0ee3$var$oids["aes256-CBC"];
                cipherFn = $dEd5p.aes.createEncryptionCipher;
                break;
            case "des":
                dkLen = 8;
                ivLen = 8;
                encOid = $a63cc49700fd0ee3$var$oids["desCBC"];
                cipherFn = $dEd5p.des.createEncryptionCipher;
                break;
            default:
                var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
                error.algorithm = options.algorithm;
                throw error;
        }
        // get PRF message digest
        var prfAlgorithm = "hmacWith" + options.prfAlgorithm.toUpperCase();
        var md = $a63cc49700fd0ee3$var$prfAlgorithmToMessageDigest(prfAlgorithm);
        // encrypt private key using pbe SHA-1 and AES/DES
        var dk = $dEd5p.pkcs5.pbkdf2(password, salt, count, dkLen, md);
        var iv = $dEd5p.random.getBytesSync(ivLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($a63cc49700fd0ee3$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        // get PBKDF2-params
        var params = $a63cc49700fd0ee3$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
        encryptionAlgorithm = $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
            $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OID, false, $a63cc49700fd0ee3$var$asn1.oidToDer($a63cc49700fd0ee3$var$oids["pkcs5PBES2"]).getBytes()),
            $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
                // keyDerivationFunc
                $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
                    $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OID, false, $a63cc49700fd0ee3$var$asn1.oidToDer($a63cc49700fd0ee3$var$oids["pkcs5PBKDF2"]).getBytes()),
                    // PBKDF2-params
                    params
                ]),
                // encryptionScheme
                $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
                    $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OID, false, $a63cc49700fd0ee3$var$asn1.oidToDer(encOid).getBytes()),
                    // iv
                    $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING, false, iv)
                ])
            ])
        ]);
    } else if (options.algorithm === "3des") {
        // Do PKCS12 PBE
        dkLen = 24;
        var saltBytes = new $dEd5p.util.ByteBuffer(salt);
        var dk = $a63cc49700fd0ee3$var$pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
        var iv = $a63cc49700fd0ee3$var$pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
        var cipher = $dEd5p.des.createEncryptionCipher(dk);
        cipher.start(iv);
        cipher.update($a63cc49700fd0ee3$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        encryptionAlgorithm = $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
            $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OID, false, $a63cc49700fd0ee3$var$asn1.oidToDer($a63cc49700fd0ee3$var$oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()),
            // pkcs-12PbeParams
            $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
                // salt
                $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING, false, salt),
                // iteration count
                $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.INTEGER, false, countBytes.getBytes())
            ])
        ]);
    } else {
        var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        error.algorithm = options.algorithm;
        throw error;
    }
    // EncryptedPrivateKeyInfo
    var rval = $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
        // encryptionAlgorithm
        encryptionAlgorithm,
        // encryptedData
        $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING, false, encryptedData)
    ]);
    return rval;
};
/**
 * Decrypts a ASN.1 PrivateKeyInfo object.
 *
 * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
 * @param password the password to decrypt with.
 *
 * @return the ASN.1 PrivateKeyInfo on success, null on failure.
 */ $a63cc49700fd0ee3$var$pki.decryptPrivateKeyInfo = function(obj, password) {
    var rval = null;
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$a63cc49700fd0ee3$var$asn1.validate(obj, $a63cc49700fd0ee3$var$encryptedPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // get cipher
    var oid = $a63cc49700fd0ee3$var$asn1.derToOid(capture.encryptionOid);
    var cipher = $a63cc49700fd0ee3$var$pki.pbe.getCipher(oid, capture.encryptionParams, password);
    // get encrypted data
    var encrypted = $dEd5p.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);
    if (cipher.finish()) rval = $a63cc49700fd0ee3$var$asn1.fromDer(cipher.output);
    return rval;
};
/**
 * Converts a EncryptedPrivateKeyInfo to PEM format.
 *
 * @param epki the EncryptedPrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted encrypted private key.
 */ $a63cc49700fd0ee3$var$pki.encryptedPrivateKeyToPem = function(epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "ENCRYPTED PRIVATE KEY",
        body: $a63cc49700fd0ee3$var$asn1.toDer(epki).getBytes()
    };
    return $dEd5p.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
 * is not performed.
 *
 * @param pem the EncryptedPrivateKeyInfo in PEM-format.
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $a63cc49700fd0ee3$var$pki.encryptedPrivateKeyFromPem = function(pem) {
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY") {
        var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    return $a63cc49700fd0ee3$var$asn1.fromDer(msg.body);
};
/**
 * Encrypts an RSA private key. By default, the key will be wrapped in
 * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
 * This is the standard, preferred way to encrypt a private key.
 *
 * To produce a non-standard PEM-encrypted private key that uses encapsulated
 * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
 * private key encryption), set the 'legacy' option to true. Note: Using this
 * option will cause the iteration count to be forced to 1.
 *
 * Note: The 'des' algorithm is supported, but it is not considered to be
 * secure because it only uses a single 56-bit key. If possible, it is highly
 * recommended that a different algorithm be used.
 *
 * @param rsaKey the RSA key to encrypt.
 * @param password the password to use.
 * @param options:
 *          algorithm: the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des', 'des').
 *          count: the iteration count to use.
 *          saltSize: the salt size to use.
 *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
 *            headers (DEK-Info) private key.
 *
 * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
 */ $a63cc49700fd0ee3$var$pki.encryptRsaPrivateKey = function(rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};
    if (!options.legacy) {
        // encrypt PrivateKeyInfo
        var rval = $a63cc49700fd0ee3$var$pki.wrapRsaPrivateKey($a63cc49700fd0ee3$var$pki.privateKeyToAsn1(rsaKey));
        rval = $a63cc49700fd0ee3$var$pki.encryptPrivateKeyInfo(rval, password, options);
        return $a63cc49700fd0ee3$var$pki.encryptedPrivateKeyToPem(rval);
    }
    // legacy non-PKCS#8
    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;
    switch(options.algorithm){
        case "aes128":
            algorithm = "AES-128-CBC";
            dkLen = 16;
            iv = $dEd5p.random.getBytesSync(16);
            cipherFn = $dEd5p.aes.createEncryptionCipher;
            break;
        case "aes192":
            algorithm = "AES-192-CBC";
            dkLen = 24;
            iv = $dEd5p.random.getBytesSync(16);
            cipherFn = $dEd5p.aes.createEncryptionCipher;
            break;
        case "aes256":
            algorithm = "AES-256-CBC";
            dkLen = 32;
            iv = $dEd5p.random.getBytesSync(16);
            cipherFn = $dEd5p.aes.createEncryptionCipher;
            break;
        case "3des":
            algorithm = "DES-EDE3-CBC";
            dkLen = 24;
            iv = $dEd5p.random.getBytesSync(8);
            cipherFn = $dEd5p.des.createEncryptionCipher;
            break;
        case "des":
            algorithm = "DES-CBC";
            dkLen = 8;
            iv = $dEd5p.random.getBytesSync(8);
            cipherFn = $dEd5p.des.createEncryptionCipher;
            break;
        default:
            var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
            error.algorithm = options.algorithm;
            throw error;
    }
    // encrypt private key using OpenSSL legacy key derivation
    var dk = $dEd5p.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update($a63cc49700fd0ee3$var$asn1.toDer($a63cc49700fd0ee3$var$pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
        type: "RSA PRIVATE KEY",
        procType: {
            version: "4",
            type: "ENCRYPTED"
        },
        dekInfo: {
            algorithm: algorithm,
            parameters: $dEd5p.util.bytesToHex(iv).toUpperCase()
        },
        body: cipher.output.getBytes()
    };
    return $dEd5p.pem.encode(msg);
};
/**
 * Decrypts an RSA private key.
 *
 * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
 * @param password the password to use.
 *
 * @return the RSA key on success, null on failure.
 */ $a63cc49700fd0ee3$var$pki.decryptRsaPrivateKey = function(pem, password) {
    var rval = null;
    var msg = $dEd5p.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY" && msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
        error.headerType = error;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") {
        var dkLen;
        var cipherFn;
        switch(msg.dekInfo.algorithm){
            case "DES-CBC":
                dkLen = 8;
                cipherFn = $dEd5p.des.createDecryptionCipher;
                break;
            case "DES-EDE3-CBC":
                dkLen = 24;
                cipherFn = $dEd5p.des.createDecryptionCipher;
                break;
            case "AES-128-CBC":
                dkLen = 16;
                cipherFn = $dEd5p.aes.createDecryptionCipher;
                break;
            case "AES-192-CBC":
                dkLen = 24;
                cipherFn = $dEd5p.aes.createDecryptionCipher;
                break;
            case "AES-256-CBC":
                dkLen = 32;
                cipherFn = $dEd5p.aes.createDecryptionCipher;
                break;
            case "RC2-40-CBC":
                dkLen = 5;
                cipherFn = function(key) {
                    return $dEd5p.rc2.createDecryptionCipher(key, 40);
                };
                break;
            case "RC2-64-CBC":
                dkLen = 8;
                cipherFn = function(key) {
                    return $dEd5p.rc2.createDecryptionCipher(key, 64);
                };
                break;
            case "RC2-128-CBC":
                dkLen = 16;
                cipherFn = function(key) {
                    return $dEd5p.rc2.createDecryptionCipher(key, 128);
                };
                break;
            default:
                var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
                error.algorithm = msg.dekInfo.algorithm;
                throw error;
        }
        // use OpenSSL legacy key derivation
        var iv = $dEd5p.util.hexToBytes(msg.dekInfo.parameters);
        var dk = $dEd5p.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($dEd5p.util.createBuffer(msg.body));
        if (cipher.finish()) rval = cipher.output.getBytes();
        else return rval;
    } else rval = msg.body;
    if (msg.type === "ENCRYPTED PRIVATE KEY") rval = $a63cc49700fd0ee3$var$pki.decryptPrivateKeyInfo($a63cc49700fd0ee3$var$asn1.fromDer(rval), password);
    else // decryption already performed above
    rval = $a63cc49700fd0ee3$var$asn1.fromDer(rval);
    if (rval !== null) rval = $a63cc49700fd0ee3$var$pki.privateKeyFromAsn1(rval);
    return rval;
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $a63cc49700fd0ee3$var$pki.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
    var j, l;
    if (typeof md === "undefined" || md === null) {
        if (!("sha1" in $dEd5p.md)) throw new Error('"sha1" hash algorithm unavailable.');
        md = $dEd5p.md.sha1.create();
    }
    var u = md.digestLength;
    var v = md.blockLength;
    var result = new $dEd5p.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */ var passBuf = new $dEd5p.util.ByteBuffer();
    if (password !== null && password !== undefined) {
        for(l = 0; l < password.length; l++)passBuf.putInt16(password.charCodeAt(l));
        passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */ var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
        v copies of ID. */ var D = new $dEd5p.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
        v * ceil(s / v) bytes (the final copy of the salt may be trunacted
        to create S).
        Note that if the salt is the empty string, then so is S. */ var Slen = v * Math.ceil(s / v);
    var S = new $dEd5p.util.ByteBuffer();
    for(l = 0; l < Slen; l++)S.putByte(salt.at(l % s));
    /* 3. Concatenate copies of the password together to create a string P of
        length v * ceil(p / v) bytes (the final copy of the password may be
        truncated to create P).
        Note that if the password is the empty string, then so is P. */ var Plen = v * Math.ceil(p / v);
    var P = new $dEd5p.util.ByteBuffer();
    for(l = 0; l < Plen; l++)P.putByte(passBuf.at(l % p));
    /* 4. Set I=S||P to be the concatenation of S and P. */ var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */ var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */ for(var i = 1; i <= c; i++){
        /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */ var buf = new $dEd5p.util.ByteBuffer();
        buf.putBytes(D.bytes());
        buf.putBytes(I.bytes());
        for(var round = 0; round < iter; round++){
            md.start();
            md.update(buf.getBytes());
            buf = md.digest();
        }
        /* b) Concatenate copies of Ai to create a string B of length v bytes (the
          final copy of Ai may be truncated to create B). */ var B = new $dEd5p.util.ByteBuffer();
        for(l = 0; l < v; l++)B.putByte(buf.at(l % u));
        /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
          where k=ceil(s / v) + ceil(p / v), modify I by setting
          Ij=(Ij+B+1) mod 2v for each j.  */ var k = Math.ceil(s / v) + Math.ceil(p / v);
        var Inew = new $dEd5p.util.ByteBuffer();
        for(j = 0; j < k; j++){
            var chunk = new $dEd5p.util.ByteBuffer(I.getBytes(v));
            var x = 0x1ff;
            for(l = B.length() - 1; l >= 0; l--){
                x = x >> 8;
                x += B.at(l) + chunk.at(l);
                chunk.setAt(l, x & 0xff);
            }
            Inew.putBuffer(chunk);
        }
        I = Inew;
        /* Add Ai to A. */ result.putBuffer(buf);
    }
    result.truncate(result.length() - n);
    return result;
};
/**
 * Get new Forge cipher object instance.
 *
 * @param oid the OID (in string notation).
 * @param params the ASN.1 params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $a63cc49700fd0ee3$var$pki.pbe.getCipher = function(oid, params, password) {
    switch(oid){
        case $a63cc49700fd0ee3$var$pki.oids["pkcs5PBES2"]:
            return $a63cc49700fd0ee3$var$pki.pbe.getCipherForPBES2(oid, params, password);
        case $a63cc49700fd0ee3$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case $a63cc49700fd0ee3$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            return $a63cc49700fd0ee3$var$pki.pbe.getCipherForPKCS12PBE(oid, params, password);
        default:
            var error = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
            error.oid = oid;
            error.supportedOids = [
                "pkcs5PBES2",
                "pbeWithSHAAnd3-KeyTripleDES-CBC",
                "pbewithSHAAnd40BitRC2-CBC"
            ];
            throw error;
    }
};
/**
 * Get new Forge cipher object instance according to PBES2 params block.
 *
 * The returned cipher instance is already started using the IV
 * from PBES2 parameter block.
 *
 * @param oid the PKCS#5 PBKDF2 OID (in string notation).
 * @param params the ASN.1 PBES2-params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $a63cc49700fd0ee3$var$pki.pbe.getCipherForPBES2 = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$a63cc49700fd0ee3$var$asn1.validate(params, $a63cc49700fd0ee3$var$PBES2AlgorithmsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // check oids
    oid = $a63cc49700fd0ee3$var$asn1.derToOid(capture.kdfOid);
    if (oid !== $a63cc49700fd0ee3$var$pki.oids["pkcs5PBKDF2"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
        error.oid = oid;
        error.supportedOids = [
            "pkcs5PBKDF2"
        ];
        throw error;
    }
    oid = $a63cc49700fd0ee3$var$asn1.derToOid(capture.encOid);
    if (oid !== $a63cc49700fd0ee3$var$pki.oids["aes128-CBC"] && oid !== $a63cc49700fd0ee3$var$pki.oids["aes192-CBC"] && oid !== $a63cc49700fd0ee3$var$pki.oids["aes256-CBC"] && oid !== $a63cc49700fd0ee3$var$pki.oids["des-EDE3-CBC"] && oid !== $a63cc49700fd0ee3$var$pki.oids["desCBC"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
        error.oid = oid;
        error.supportedOids = [
            "aes128-CBC",
            "aes192-CBC",
            "aes256-CBC",
            "des-EDE3-CBC",
            "desCBC"
        ];
        throw error;
    }
    // set PBE params
    var salt = capture.kdfSalt;
    var count = $dEd5p.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;
    switch($a63cc49700fd0ee3$var$pki.oids[oid]){
        case "aes128-CBC":
            dkLen = 16;
            cipherFn = $dEd5p.aes.createDecryptionCipher;
            break;
        case "aes192-CBC":
            dkLen = 24;
            cipherFn = $dEd5p.aes.createDecryptionCipher;
            break;
        case "aes256-CBC":
            dkLen = 32;
            cipherFn = $dEd5p.aes.createDecryptionCipher;
            break;
        case "des-EDE3-CBC":
            dkLen = 24;
            cipherFn = $dEd5p.des.createDecryptionCipher;
            break;
        case "desCBC":
            dkLen = 8;
            cipherFn = $dEd5p.des.createDecryptionCipher;
            break;
    }
    // get PRF message digest
    var md = $a63cc49700fd0ee3$var$prfOidToMessageDigest(capture.prfOid);
    // decrypt private key using pbe with chosen PRF and AES/DES
    var dk = $dEd5p.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
};
/**
 * Get new Forge cipher object instance for PKCS#12 PBE.
 *
 * The returned cipher instance is already started using the key & IV
 * derived from the provided password and PKCS#12 PBE salt.
 *
 * @param oid The PKCS#12 PBE OID (in string notation).
 * @param params The ASN.1 PKCS#12 PBE-params object.
 * @param password The password to decrypt with.
 *
 * @return the new cipher object instance.
 */ $a63cc49700fd0ee3$var$pki.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$a63cc49700fd0ee3$var$asn1.validate(params, $a63cc49700fd0ee3$var$pkcs12PbeParamsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    var salt = $dEd5p.util.createBuffer(capture.salt);
    var count = $dEd5p.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;
    switch(oid){
        case $a63cc49700fd0ee3$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
            dkLen = 24;
            dIvLen = 8;
            cipherFn = $dEd5p.des.startDecrypting;
            break;
        case $a63cc49700fd0ee3$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            dkLen = 5;
            dIvLen = 8;
            cipherFn = function(key, iv) {
                var cipher = $dEd5p.rc2.createDecryptionCipher(key, 40);
                cipher.start(iv, null);
                return cipher;
            };
            break;
        default:
            var error = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
            error.oid = oid;
            throw error;
    }
    // get PRF message digest
    var md = $a63cc49700fd0ee3$var$prfOidToMessageDigest(capture.prfOid);
    var key = $a63cc49700fd0ee3$var$pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = $a63cc49700fd0ee3$var$pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
};
/**
 * OpenSSL's legacy key derivation function.
 *
 * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
 *
 * @param password the password to derive the key from.
 * @param salt the salt to use, null for none.
 * @param dkLen the number of bytes needed for the derived key.
 * @param [options] the options to use:
 *          [md] an optional message digest object to use.
 */ $a63cc49700fd0ee3$var$pki.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
    if (typeof md === "undefined" || md === null) {
        if (!("md5" in $dEd5p.md)) throw new Error('"md5" hash algorithm unavailable.');
        md = $dEd5p.md.md5.create();
    }
    if (salt === null) salt = "";
    var digests = [
        $a63cc49700fd0ee3$var$hash(md, password + salt)
    ];
    for(var length = 16, i = 1; length < dkLen; ++i, length += 16)digests.push($a63cc49700fd0ee3$var$hash(md, digests[i - 1] + password + salt));
    return digests.join("").substr(0, dkLen);
};
function $a63cc49700fd0ee3$var$hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
}
function $a63cc49700fd0ee3$var$prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;
    if (!prfOid) prfAlgorithm = "hmacWithSHA1";
    else {
        prfAlgorithm = $a63cc49700fd0ee3$var$pki.oids[$a63cc49700fd0ee3$var$asn1.derToOid(prfOid)];
        if (!prfAlgorithm) {
            var error = new Error("Unsupported PRF OID.");
            error.oid = prfOid;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
        }
    }
    return $a63cc49700fd0ee3$var$prfAlgorithmToMessageDigest(prfAlgorithm);
}
function $a63cc49700fd0ee3$var$prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = $dEd5p.md;
    switch(prfAlgorithm){
        case "hmacWithSHA224":
            factory = $dEd5p.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
            prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
            break;
        default:
            var error = new Error("Unsupported PRF algorithm.");
            error.algorithm = prfAlgorithm;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
    }
    if (!factory || !(prfAlgorithm in factory)) throw new Error("Unknown hash algorithm: " + prfAlgorithm);
    return factory[prfAlgorithm].create();
}
function $a63cc49700fd0ee3$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
        // salt
        $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OCTETSTRING, false, salt),
        // iteration count
        $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.INTEGER, false, countBytes.getBytes())
    ]);
    // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm
    if (prfAlgorithm !== "hmacWithSHA1") params.value.push(// key length
    $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.INTEGER, false, $dEd5p.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
    $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.OID, false, $a63cc49700fd0ee3$var$asn1.oidToDer($a63cc49700fd0ee3$var$pki.oids[prfAlgorithm]).getBytes()),
        // parameters (null)
        $a63cc49700fd0ee3$var$asn1.create($a63cc49700fd0ee3$var$asn1.Class.UNIVERSAL, $a63cc49700fd0ee3$var$asn1.Type.NULL, false, "")
    ]));
    return params;
}

});
parcelRegister("afsa3", function(module, exports) {
/**
 * RC2 implementation.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * Information on the RC2 cipher is available from RFC #2268,
 * http://www.ietf.org/rfc/rfc2268.txt
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("kvSv3");
var $7761265598072947$var$piTable = [
    0xd9,
    0x78,
    0xf9,
    0xc4,
    0x19,
    0xdd,
    0xb5,
    0xed,
    0x28,
    0xe9,
    0xfd,
    0x79,
    0x4a,
    0xa0,
    0xd8,
    0x9d,
    0xc6,
    0x7e,
    0x37,
    0x83,
    0x2b,
    0x76,
    0x53,
    0x8e,
    0x62,
    0x4c,
    0x64,
    0x88,
    0x44,
    0x8b,
    0xfb,
    0xa2,
    0x17,
    0x9a,
    0x59,
    0xf5,
    0x87,
    0xb3,
    0x4f,
    0x13,
    0x61,
    0x45,
    0x6d,
    0x8d,
    0x09,
    0x81,
    0x7d,
    0x32,
    0xbd,
    0x8f,
    0x40,
    0xeb,
    0x86,
    0xb7,
    0x7b,
    0x0b,
    0xf0,
    0x95,
    0x21,
    0x22,
    0x5c,
    0x6b,
    0x4e,
    0x82,
    0x54,
    0xd6,
    0x65,
    0x93,
    0xce,
    0x60,
    0xb2,
    0x1c,
    0x73,
    0x56,
    0xc0,
    0x14,
    0xa7,
    0x8c,
    0xf1,
    0xdc,
    0x12,
    0x75,
    0xca,
    0x1f,
    0x3b,
    0xbe,
    0xe4,
    0xd1,
    0x42,
    0x3d,
    0xd4,
    0x30,
    0xa3,
    0x3c,
    0xb6,
    0x26,
    0x6f,
    0xbf,
    0x0e,
    0xda,
    0x46,
    0x69,
    0x07,
    0x57,
    0x27,
    0xf2,
    0x1d,
    0x9b,
    0xbc,
    0x94,
    0x43,
    0x03,
    0xf8,
    0x11,
    0xc7,
    0xf6,
    0x90,
    0xef,
    0x3e,
    0xe7,
    0x06,
    0xc3,
    0xd5,
    0x2f,
    0xc8,
    0x66,
    0x1e,
    0xd7,
    0x08,
    0xe8,
    0xea,
    0xde,
    0x80,
    0x52,
    0xee,
    0xf7,
    0x84,
    0xaa,
    0x72,
    0xac,
    0x35,
    0x4d,
    0x6a,
    0x2a,
    0x96,
    0x1a,
    0xd2,
    0x71,
    0x5a,
    0x15,
    0x49,
    0x74,
    0x4b,
    0x9f,
    0xd0,
    0x5e,
    0x04,
    0x18,
    0xa4,
    0xec,
    0xc2,
    0xe0,
    0x41,
    0x6e,
    0x0f,
    0x51,
    0xcb,
    0xcc,
    0x24,
    0x91,
    0xaf,
    0x50,
    0xa1,
    0xf4,
    0x70,
    0x39,
    0x99,
    0x7c,
    0x3a,
    0x85,
    0x23,
    0xb8,
    0xb4,
    0x7a,
    0xfc,
    0x02,
    0x36,
    0x5b,
    0x25,
    0x55,
    0x97,
    0x31,
    0x2d,
    0x5d,
    0xfa,
    0x98,
    0xe3,
    0x8a,
    0x92,
    0xae,
    0x05,
    0xdf,
    0x29,
    0x10,
    0x67,
    0x6c,
    0xba,
    0xc9,
    0xd3,
    0x00,
    0xe6,
    0xcf,
    0xe1,
    0x9e,
    0xa8,
    0x2c,
    0x63,
    0x16,
    0x01,
    0x3f,
    0x58,
    0xe2,
    0x89,
    0xa9,
    0x0d,
    0x38,
    0x34,
    0x1b,
    0xab,
    0x33,
    0xff,
    0xb0,
    0xbb,
    0x48,
    0x0c,
    0x5f,
    0xb9,
    0xb1,
    0xcd,
    0x2e,
    0xc5,
    0xf3,
    0xdb,
    0x47,
    0xe5,
    0xa5,
    0x9c,
    0x77,
    0x0a,
    0xa6,
    0x20,
    0x68,
    0xfe,
    0x7f,
    0xc1,
    0xad
];
var $7761265598072947$var$s = [
    1,
    2,
    3,
    5
];
/**
 * Rotate a word left by given number of bits.
 *
 * Bits that are shifted out on the left are put back in on the right
 * hand side.
 *
 * @param word The word to shift left.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $7761265598072947$var$rol = function(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
};
/**
 * Rotate a word right by given number of bits.
 *
 * Bits that are shifted out on the right are put back in on the left
 * hand side.
 *
 * @param word The word to shift right.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $7761265598072947$var$ror = function(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
};
/* RC2 API */ module.exports = $dEd5p.rc2 = $dEd5p.rc2 || {};
/**
 * Perform RC2 key expansion as per RFC #2268, section 2.
 *
 * @param key variable-length user key (between 1 and 128 bytes)
 * @param effKeyBits number of effective key bits (default: 128)
 * @return the expanded RC2 key (ByteBuffer of 128 bytes)
 */ $dEd5p.rc2.expandKey = function(key, effKeyBits) {
    if (typeof key === "string") key = $dEd5p.util.createBuffer(key);
    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */ var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;
    for(i = T; i < 128; i++)L.putByte($7761265598072947$var$piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    L.setAt(128 - T8, $7761265598072947$var$piTable[L.at(128 - T8) & TM]);
    for(i = 127 - T8; i >= 0; i--)L.setAt(i, $7761265598072947$var$piTable[L.at(i + 1) ^ L.at(i + T8)]);
    return L;
};
/**
 * Creates a RC2 cipher object.
 *
 * @param key the symmetric key to use (as base for key generation).
 * @param bits the number of effective key bits.
 * @param encrypt false for decryption, true for encryption.
 *
 * @return the cipher.
 */ var $7761265598072947$var$createCipher = function(key, bits, encrypt) {
    var _finish = false, _input = null, _output = null, _iv = null;
    var mixRound, mashRound;
    var i, j, K = [];
    /* Expand key and fill into K[] Array */ key = $dEd5p.rc2.expandKey(key, bits);
    for(i = 0; i < 64; i++)K.push(key.getInt16Le());
    if (encrypt) {
        /**
     * Perform one mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 0; i < 4; i++){
                R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                R[i] = $7761265598072947$var$rol(R[i], $7761265598072947$var$s[i]);
                j++;
            }
        };
        /**
     * Perform one mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 0; i < 4; i++)R[i] += K[R[(i + 3) % 4] & 63];
        };
    } else {
        /**
     * Perform one r-mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 3; i >= 0; i--){
                R[i] = $7761265598072947$var$ror(R[i], $7761265598072947$var$s[i]);
                R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                j--;
            }
        };
        /**
     * Perform one r-mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 3; i >= 0; i--)R[i] -= K[R[(i + 3) % 4] & 63];
        };
    }
    /**
   * Run the specified cipher execution plan.
   *
   * This function takes four words from the input buffer, applies the IV on
   * it (if requested) and runs the provided execution plan.
   *
   * The plan must be put together in form of a array of arrays.  Where the
   * outer one is simply a list of steps to perform and the inner one needs
   * to have two elements: the first one telling how many rounds to perform,
   * the second one telling what to do (i.e. the function to call).
   *
   * @param {Array} plan The plan to execute.
   */ var runPlan = function(plan) {
        var R = [];
        /* Get data from input buffer and fill the four words into R */ for(i = 0; i < 4; i++){
            var val = _input.getInt16Le();
            if (_iv !== null) {
                if (encrypt) /* We're encrypting, apply the IV first. */ val ^= _iv.getInt16Le();
                else /* We're decryption, keep cipher text for next block. */ _iv.putInt16Le(val);
            }
            R.push(val & 0xffff);
        }
        /* Reset global "j" variable as per spec. */ j = encrypt ? 0 : 63;
        /* Run execution plan. */ for(var ptr = 0; ptr < plan.length; ptr++)for(var ctr = 0; ctr < plan[ptr][0]; ctr++)plan[ptr][1](R);
        /* Write back result to output buffer. */ for(i = 0; i < 4; i++){
            if (_iv !== null) {
                if (encrypt) /* We're encrypting in CBC-mode, feed back encrypted bytes into
             IV buffer to carry it forward to next block. */ _iv.putInt16Le(R[i]);
                else R[i] ^= _iv.getInt16Le();
            }
            _output.putInt16Le(R[i]);
        }
    };
    /* Create cipher object */ var cipher = null;
    cipher = {
        /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */ start: function(iv, output) {
            if (iv) /* CBC mode */ {
                if (typeof iv === "string") iv = $dEd5p.util.createBuffer(iv);
            }
            _finish = false;
            _input = $dEd5p.util.createBuffer();
            _output = output || new $dEd5p.util.createBuffer();
            _iv = iv;
            cipher.output = _output;
        },
        /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */ update: function(input) {
            if (!_finish) // not finishing, so fill the input buffer with more input
            _input.putBuffer(input);
            while(_input.length() >= 8)runPlan([
                [
                    5,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    6,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    5,
                    mixRound
                ]
            ]);
        },
        /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */ finish: function(pad) {
            var rval = true;
            if (encrypt) {
                if (pad) rval = pad(8, _input, !encrypt);
                else {
                    // add PKCS#7 padding to block (each pad byte is the
                    // value of the number of pad bytes)
                    var padding = _input.length() === 8 ? 8 : 8 - _input.length();
                    _input.fillWithByte(padding, padding);
                }
            }
            if (rval) {
                // do final update
                _finish = true;
                cipher.update();
            }
            if (!encrypt) {
                // check for error: input data not a multiple of block size
                rval = _input.length() === 0;
                if (rval) {
                    if (pad) rval = pad(8, _output, !encrypt);
                    else {
                        // ensure padding byte count is valid
                        var len = _output.length();
                        var count = _output.at(len - 1);
                        if (count > len) rval = false;
                        else // trim off padding bytes
                        _output.truncate(count);
                    }
                }
            }
            return rval;
        }
    };
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $dEd5p.rc2.startEncrypting = function(key, iv, output) {
    var cipher = $dEd5p.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start encrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $dEd5p.rc2.createEncryptionCipher = function(key, bits) {
    return $7761265598072947$var$createCipher(key, bits, true);
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $dEd5p.rc2.startDecrypting = function(key, iv, output) {
    var cipher = $dEd5p.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start decrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $dEd5p.rc2.createDecryptionCipher = function(key, bits) {
    return $7761265598072947$var$createCipher(key, bits, false);
};

});


parcelRegister("5J3Rq", function(module, exports) {
/**
 * Javascript implementation of PKCS#12.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#12 is as follows
 * (see ftp://ftp.rsasecurity.com/pub/pkcs/pkcs-12/pkcs-12-tc1.pdf for details)
 *
 * PFX ::= SEQUENCE {
 *   version  INTEGER {v3(3)}(v3,...),
 *   authSafe ContentInfo,
 *   macData  MacData OPTIONAL
 * }
 *
 * MacData ::= SEQUENCE {
 *   mac DigestInfo,
 *   macSalt OCTET STRING,
 *   iterations INTEGER DEFAULT 1
 * }
 * Note: The iterations default is for historical reasons and its use is
 * deprecated. A higher value, like 1024, is recommended.
 *
 * DigestInfo is defined in PKCS#7 as follows:
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of SHA1 there is none.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * Digest ::= OCTET STRING
 *
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType ContentType,
 *   content     [0] EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * AuthenticatedSafe ::= SEQUENCE OF ContentInfo
 * -- Data if unencrypted
 * -- EncryptedData if password-encrypted
 * -- EnvelopedData if public key-encrypted
 *
 *
 * SafeContents ::= SEQUENCE OF SafeBag
 *
 * SafeBag ::= SEQUENCE {
 *   bagId     BAG-TYPE.&id ({PKCS12BagSet})
 *   bagValue  [0] EXPLICIT BAG-TYPE.&Type({PKCS12BagSet}{@bagId}),
 *   bagAttributes SET OF PKCS12Attribute OPTIONAL
 * }
 *
 * PKCS12Attribute ::= SEQUENCE {
 *   attrId ATTRIBUTE.&id ({PKCS12AttrSet}),
 *   attrValues SET OF ATTRIBUTE.&Type ({PKCS12AttrSet}{@attrId})
 * } -- This type is compatible with the X.500 type 'Attribute'
 *
 * PKCS12AttrSet ATTRIBUTE ::= {
 *   friendlyName | -- from PKCS #9
 *   localKeyId, -- from PKCS #9
 *   ... -- Other attributes are allowed
 * }
 *
 * CertBag ::= SEQUENCE {
 *   certId    BAG-TYPE.&id   ({CertTypes}),
 *   certValue [0] EXPLICIT BAG-TYPE.&Type ({CertTypes}{@certId})
 * }
 *
 * x509Certificate BAG-TYPE ::= {OCTET STRING IDENTIFIED BY {certTypes 1}}
 *   -- DER-encoded X.509 certificate stored in OCTET STRING
 *
 * sdsiCertificate BAG-TYPE ::= {IA5String IDENTIFIED BY {certTypes 2}}
 * -- Base64-encoded SDSI certificate stored in IA5String
 *
 * CertTypes BAG-TYPE ::= {
 *   x509Certificate |
 *   sdsiCertificate,
 *   ... -- For future extensions
 * }
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("8QTFz");
parcelRequire("aMLbo");
parcelRequire("ggdRy");
parcelRequire("hGwt9");
parcelRequire("egSpF");
parcelRequire("4N8iP");
parcelRequire("ad5x8");
parcelRequire("dggUt");
parcelRequire("kvSv3");
parcelRequire("1p4rv");
// shortcut for asn.1 & PKI API
var $42b4265ab516a1f2$var$asn1 = $dEd5p.asn1;
var $42b4265ab516a1f2$var$pki = $dEd5p.pki;
// shortcut for PKCS#12 API
var $42b4265ab516a1f2$var$p12 = module.exports = $dEd5p.pkcs12 = $dEd5p.pkcs12 || {};
var $42b4265ab516a1f2$var$contentInfoValidator = {
    name: "ContentInfo",
    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "ContentInfo.contentType",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "ContentInfo.content",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: "content"
        }
    ]
};
var $42b4265ab516a1f2$var$pfxValidator = {
    name: "PFX",
    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PFX.version",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        $42b4265ab516a1f2$var$contentInfoValidator,
        {
            name: "PFX.macData",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
            constructed: true,
            optional: true,
            captureAsn1: "mac",
            value: [
                {
                    name: "PFX.macData.mac",
                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PFX.macData.mac.digestAlgorithm",
                            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                            type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: "PFX.macData.mac.digestAlgorithm.algorithm",
                                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                                    type: $42b4265ab516a1f2$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "macAlgorithm"
                                },
                                {
                                    name: "PFX.macData.mac.digestAlgorithm.parameters",
                                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                                    captureAsn1: "macAlgorithmParameters"
                                }
                            ]
                        },
                        {
                            name: "PFX.macData.mac.digest",
                            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                            type: $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "macDigest"
                        }
                    ]
                },
                {
                    name: "PFX.macData.macSalt",
                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                    type: $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "macSalt"
                },
                {
                    name: "PFX.macData.iterations",
                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                    type: $42b4265ab516a1f2$var$asn1.Type.INTEGER,
                    constructed: false,
                    optional: true,
                    capture: "macIterations"
                }
            ]
        }
    ]
};
var $42b4265ab516a1f2$var$safeBagValidator = {
    name: "SafeBag",
    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SafeBag.bagId",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.OID,
            constructed: false,
            capture: "bagId"
        },
        {
            name: "SafeBag.bagValue",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            captureAsn1: "bagValue"
        },
        {
            name: "SafeBag.bagAttributes",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.SET,
            constructed: true,
            optional: true,
            capture: "bagAttributes"
        }
    ]
};
var $42b4265ab516a1f2$var$attributeValidator = {
    name: "Attribute",
    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Attribute.attrId",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.OID,
            constructed: false,
            capture: "oid"
        },
        {
            name: "Attribute.attrValues",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.SET,
            constructed: true,
            capture: "values"
        }
    ]
};
var $42b4265ab516a1f2$var$certBagValidator = {
    name: "CertBag",
    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
    type: $42b4265ab516a1f2$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "CertBag.certId",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
            type: $42b4265ab516a1f2$var$asn1.Type.OID,
            constructed: false,
            capture: "certId"
        },
        {
            name: "CertBag.certValue",
            tagClass: $42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC,
            constructed: true,
            /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */ value: [
                {
                    name: "CertBag.certValue[0]",
                    tagClass: $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL,
                    type: $42b4265ab516a1f2$var$asn1.Class.OCTETSTRING,
                    constructed: false,
                    capture: "cert"
                }
            ]
        }
    ]
};
/**
 * Search SafeContents structure for bags with matching attributes.
 *
 * The search can optionally be narrowed by a certain bag type.
 *
 * @param safeContents the SafeContents structure to search in.
 * @param attrName the name of the attribute to compare against.
 * @param attrValue the attribute value to search for.
 * @param [bagType] bag type to narrow search by.
 *
 * @return an array of matching bags.
 */ function $42b4265ab516a1f2$var$_getBagsByAttribute(safeContents, attrName, attrValue, bagType) {
    var result = [];
    for(var i = 0; i < safeContents.length; i++)for(var j = 0; j < safeContents[i].safeBags.length; j++){
        var bag = safeContents[i].safeBags[j];
        if (bagType !== undefined && bag.type !== bagType) continue;
        // only filter by bag type, no attribute specified
        if (attrName === null) {
            result.push(bag);
            continue;
        }
        if (bag.attributes[attrName] !== undefined && bag.attributes[attrName].indexOf(attrValue) >= 0) result.push(bag);
    }
    return result;
}
/**
 * Converts a PKCS#12 PFX in ASN.1 notation into a PFX object.
 *
 * @param obj The PKCS#12 PFX in ASN.1 notation.
 * @param strict true to use strict DER decoding, false not to (default: true).
 * @param {String} password Password to decrypt with (optional).
 *
 * @return PKCS#12 PFX object.
 */ $42b4265ab516a1f2$var$p12.pkcs12FromAsn1 = function(obj, strict, password) {
    // handle args
    if (typeof strict === "string") {
        password = strict;
        strict = true;
    } else if (strict === undefined) strict = true;
    // validate PFX and capture data
    var capture = {};
    var errors = [];
    if (!$42b4265ab516a1f2$var$asn1.validate(obj, $42b4265ab516a1f2$var$pfxValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
        error.errors = error;
        throw error;
    }
    var pfx = {
        version: capture.version.charCodeAt(0),
        safeContents: [],
        /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */ getBags: function(filter) {
            var rval = {};
            var localKeyId;
            if ("localKeyId" in filter) localKeyId = filter.localKeyId;
            else if ("localKeyIdHex" in filter) localKeyId = $dEd5p.util.hexToBytes(filter.localKeyIdHex);
            // filter on bagType only
            if (localKeyId === undefined && !("friendlyName" in filter) && "bagType" in filter) rval[filter.bagType] = $42b4265ab516a1f2$var$_getBagsByAttribute(pfx.safeContents, null, null, filter.bagType);
            if (localKeyId !== undefined) rval.localKeyId = $42b4265ab516a1f2$var$_getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, filter.bagType);
            if ("friendlyName" in filter) rval.friendlyName = $42b4265ab516a1f2$var$_getBagsByAttribute(pfx.safeContents, "friendlyName", filter.friendlyName, filter.bagType);
            return rval;
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */ getBagsByFriendlyName: function(friendlyName, bagType) {
            return $42b4265ab516a1f2$var$_getBagsByAttribute(pfx.safeContents, "friendlyName", friendlyName, bagType);
        },
        /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */ getBagsByLocalKeyId: function(localKeyId, bagType) {
            return $42b4265ab516a1f2$var$_getBagsByAttribute(pfx.safeContents, "localKeyId", localKeyId, bagType);
        }
    };
    if (capture.version.charCodeAt(0) !== 3) {
        var error = new Error("PKCS#12 PFX of version other than 3 not supported.");
        error.version = capture.version.charCodeAt(0);
        throw error;
    }
    if ($42b4265ab516a1f2$var$asn1.derToOid(capture.contentType) !== $42b4265ab516a1f2$var$pki.oids.data) {
        var error = new Error("Only PKCS#12 PFX in password integrity mode supported.");
        error.oid = $42b4265ab516a1f2$var$asn1.derToOid(capture.contentType);
        throw error;
    }
    var data = capture.content.value[0];
    if (data.tagClass !== $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL || data.type !== $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING) throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
    data = $42b4265ab516a1f2$var$_decodePkcs7Data(data);
    // check for MAC
    if (capture.mac) {
        var md = null;
        var macKeyBytes = 0;
        var macAlgorithm = $42b4265ab516a1f2$var$asn1.derToOid(capture.macAlgorithm);
        switch(macAlgorithm){
            case $42b4265ab516a1f2$var$pki.oids.sha1:
                md = $dEd5p.md.sha1.create();
                macKeyBytes = 20;
                break;
            case $42b4265ab516a1f2$var$pki.oids.sha256:
                md = $dEd5p.md.sha256.create();
                macKeyBytes = 32;
                break;
            case $42b4265ab516a1f2$var$pki.oids.sha384:
                md = $dEd5p.md.sha384.create();
                macKeyBytes = 48;
                break;
            case $42b4265ab516a1f2$var$pki.oids.sha512:
                md = $dEd5p.md.sha512.create();
                macKeyBytes = 64;
                break;
            case $42b4265ab516a1f2$var$pki.oids.md5:
                md = $dEd5p.md.md5.create();
                macKeyBytes = 16;
                break;
        }
        if (md === null) throw new Error("PKCS#12 uses unsupported MAC algorithm: " + macAlgorithm);
        // verify MAC (iterations default to 1)
        var macSalt = new $dEd5p.util.ByteBuffer(capture.macSalt);
        var macIterations = "macIterations" in capture ? parseInt($dEd5p.util.bytesToHex(capture.macIterations), 16) : 1;
        var macKey = $42b4265ab516a1f2$var$p12.generateKey(password, macSalt, 3, macIterations, macKeyBytes, md);
        var mac = $dEd5p.hmac.create();
        mac.start(md, macKey);
        mac.update(data.value);
        var macValue = mac.getMac();
        if (macValue.getBytes() !== capture.macDigest) throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
    }
    $42b4265ab516a1f2$var$_decodeAuthenticatedSafe(pfx, data.value, strict, password);
    return pfx;
};
/**
 * Decodes PKCS#7 Data. PKCS#7 (RFC 2315) defines "Data" as an OCTET STRING,
 * but it is sometimes an OCTET STRING that is composed/constructed of chunks,
 * each its own OCTET STRING. This is BER-encoding vs. DER-encoding. This
 * function transforms this corner-case into the usual simple,
 * non-composed/constructed OCTET STRING.
 *
 * This function may be moved to ASN.1 at some point to better deal with
 * more BER-encoding issues, should they arise.
 *
 * @param data the ASN.1 Data object to transform.
 */ function $42b4265ab516a1f2$var$_decodePkcs7Data(data) {
    // handle special case of "chunked" data content: an octet string composed
    // of other octet strings
    if (data.composed || data.constructed) {
        var value = $dEd5p.util.createBuffer();
        for(var i = 0; i < data.value.length; ++i)value.putBytes(data.value[i].value);
        data.composed = data.constructed = false;
        data.value = value.getBytes();
    }
    return data;
}
/**
 * Decode PKCS#12 AuthenticatedSafe (BER encoded) into PFX object.
 *
 * The AuthenticatedSafe is a BER-encoded SEQUENCE OF ContentInfo.
 *
 * @param pfx The PKCS#12 PFX object to fill.
 * @param {String} authSafe BER-encoded AuthenticatedSafe.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 */ function $42b4265ab516a1f2$var$_decodeAuthenticatedSafe(pfx, authSafe, strict, password) {
    authSafe = $42b4265ab516a1f2$var$asn1.fromDer(authSafe, strict); /* actually it's BER encoded */ 
    if (authSafe.tagClass !== $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL || authSafe.type !== $42b4265ab516a1f2$var$asn1.Type.SEQUENCE || authSafe.constructed !== true) throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
    for(var i = 0; i < authSafe.value.length; i++){
        var contentInfo = authSafe.value[i];
        // validate contentInfo and capture data
        var capture = {};
        var errors = [];
        if (!$42b4265ab516a1f2$var$asn1.validate(contentInfo, $42b4265ab516a1f2$var$contentInfoValidator, capture, errors)) {
            var error = new Error("Cannot read ContentInfo.");
            error.errors = errors;
            throw error;
        }
        var obj = {
            encrypted: false
        };
        var safeContents = null;
        var data = capture.content.value[0];
        switch($42b4265ab516a1f2$var$asn1.derToOid(capture.contentType)){
            case $42b4265ab516a1f2$var$pki.oids.data:
                if (data.tagClass !== $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL || data.type !== $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING) throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
                safeContents = $42b4265ab516a1f2$var$_decodePkcs7Data(data).value;
                break;
            case $42b4265ab516a1f2$var$pki.oids.encryptedData:
                safeContents = $42b4265ab516a1f2$var$_decryptSafeContents(data, password);
                obj.encrypted = true;
                break;
            default:
                var error = new Error("Unsupported PKCS#12 contentType.");
                error.contentType = $42b4265ab516a1f2$var$asn1.derToOid(capture.contentType);
                throw error;
        }
        obj.safeBags = $42b4265ab516a1f2$var$_decodeSafeContents(safeContents, strict, password);
        pfx.safeContents.push(obj);
    }
}
/**
 * Decrypt PKCS#7 EncryptedData structure.
 *
 * @param data ASN.1 encoded EncryptedContentInfo object.
 * @param password The user-provided password.
 *
 * @return The decrypted SafeContents (ASN.1 object).
 */ function $42b4265ab516a1f2$var$_decryptSafeContents(data, password) {
    var capture = {};
    var errors = [];
    if (!$42b4265ab516a1f2$var$asn1.validate(data, $dEd5p.pkcs7.asn1.encryptedDataValidator, capture, errors)) {
        var error = new Error("Cannot read EncryptedContentInfo.");
        error.errors = errors;
        throw error;
    }
    var oid = $42b4265ab516a1f2$var$asn1.derToOid(capture.contentType);
    if (oid !== $42b4265ab516a1f2$var$pki.oids.data) {
        var error = new Error("PKCS#12 EncryptedContentInfo ContentType is not Data.");
        error.oid = oid;
        throw error;
    }
    // get cipher
    oid = $42b4265ab516a1f2$var$asn1.derToOid(capture.encAlgorithm);
    var cipher = $42b4265ab516a1f2$var$pki.pbe.getCipher(oid, capture.encParameter, password);
    // get encrypted data
    var encryptedContentAsn1 = $42b4265ab516a1f2$var$_decodePkcs7Data(capture.encryptedContentAsn1);
    var encrypted = $dEd5p.util.createBuffer(encryptedContentAsn1.value);
    cipher.update(encrypted);
    if (!cipher.finish()) throw new Error("Failed to decrypt PKCS#12 SafeContents.");
    return cipher.output.getBytes();
}
/**
 * Decode PKCS#12 SafeContents (BER-encoded) into array of Bag objects.
 *
 * The safeContents is a BER-encoded SEQUENCE OF SafeBag.
 *
 * @param {String} safeContents BER-encoded safeContents.
 * @param strict true to use strict DER decoding, false not to.
 * @param {String} password Password to decrypt with (optional).
 *
 * @return {Array} Array of Bag objects.
 */ function $42b4265ab516a1f2$var$_decodeSafeContents(safeContents, strict, password) {
    // if strict and no safe contents, return empty safes
    if (!strict && safeContents.length === 0) return [];
    // actually it's BER-encoded
    safeContents = $42b4265ab516a1f2$var$asn1.fromDer(safeContents, strict);
    if (safeContents.tagClass !== $42b4265ab516a1f2$var$asn1.Class.UNIVERSAL || safeContents.type !== $42b4265ab516a1f2$var$asn1.Type.SEQUENCE || safeContents.constructed !== true) throw new Error("PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag.");
    var res = [];
    for(var i = 0; i < safeContents.value.length; i++){
        var safeBag = safeContents.value[i];
        // validate SafeBag and capture data
        var capture = {};
        var errors = [];
        if (!$42b4265ab516a1f2$var$asn1.validate(safeBag, $42b4265ab516a1f2$var$safeBagValidator, capture, errors)) {
            var error = new Error("Cannot read SafeBag.");
            error.errors = errors;
            throw error;
        }
        /* Create bag object and push to result array. */ var bag = {
            type: $42b4265ab516a1f2$var$asn1.derToOid(capture.bagId),
            attributes: $42b4265ab516a1f2$var$_decodeBagAttributes(capture.bagAttributes)
        };
        res.push(bag);
        var validator, decoder;
        var bagAsn1 = capture.bagValue.value[0];
        switch(bag.type){
            case $42b4265ab516a1f2$var$pki.oids.pkcs8ShroudedKeyBag:
                /* bagAsn1 has a EncryptedPrivateKeyInfo, which we need to decrypt.
           Afterwards we can handle it like a keyBag,
           which is a PrivateKeyInfo. */ bagAsn1 = $42b4265ab516a1f2$var$pki.decryptPrivateKeyInfo(bagAsn1, password);
                if (bagAsn1 === null) throw new Error("Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?");
            /* fall through */ case $42b4265ab516a1f2$var$pki.oids.keyBag:
                /* A PKCS#12 keyBag is a simple PrivateKeyInfo as understood by our
           PKI module, hence we don't have to do validation/capturing here,
           just pass what we already got. */ try {
                    bag.key = $42b4265ab516a1f2$var$pki.privateKeyFromAsn1(bagAsn1);
                } catch (e) {
                    // ignore unknown key type, pass asn1 value
                    bag.key = null;
                    bag.asn1 = bagAsn1;
                }
                continue; /* Nothing more to do. */ 
            case $42b4265ab516a1f2$var$pki.oids.certBag:
                /* A PKCS#12 certBag can wrap both X.509 and sdsi certificates.
           Therefore put the SafeBag content through another validator to
           capture the fields.  Afterwards check & store the results. */ validator = $42b4265ab516a1f2$var$certBagValidator;
                decoder = function() {
                    if ($42b4265ab516a1f2$var$asn1.derToOid(capture.certId) !== $42b4265ab516a1f2$var$pki.oids.x509Certificate) {
                        var error = new Error("Unsupported certificate type, only X.509 supported.");
                        error.oid = $42b4265ab516a1f2$var$asn1.derToOid(capture.certId);
                        throw error;
                    }
                    // true=produce cert hash
                    var certAsn1 = $42b4265ab516a1f2$var$asn1.fromDer(capture.cert, strict);
                    try {
                        bag.cert = $42b4265ab516a1f2$var$pki.certificateFromAsn1(certAsn1, true);
                    } catch (e) {
                        // ignore unknown cert type, pass asn1 value
                        bag.cert = null;
                        bag.asn1 = certAsn1;
                    }
                };
                break;
            default:
                var error = new Error("Unsupported PKCS#12 SafeBag type.");
                error.oid = bag.type;
                throw error;
        }
        /* Validate SafeBag value (i.e. CertBag, etc.) and capture data if needed. */ if (validator !== undefined && !$42b4265ab516a1f2$var$asn1.validate(bagAsn1, validator, capture, errors)) {
            var error = new Error("Cannot read PKCS#12 " + validator.name);
            error.errors = errors;
            throw error;
        }
        /* Call decoder function from above to store the results. */ decoder();
    }
    return res;
}
/**
 * Decode PKCS#12 SET OF PKCS12Attribute into JavaScript object.
 *
 * @param attributes SET OF PKCS12Attribute (ASN.1 object).
 *
 * @return the decoded attributes.
 */ function $42b4265ab516a1f2$var$_decodeBagAttributes(attributes) {
    var decodedAttrs = {};
    if (attributes !== undefined) for(var i = 0; i < attributes.length; ++i){
        var capture = {};
        var errors = [];
        if (!$42b4265ab516a1f2$var$asn1.validate(attributes[i], $42b4265ab516a1f2$var$attributeValidator, capture, errors)) {
            var error = new Error("Cannot read PKCS#12 BagAttribute.");
            error.errors = errors;
            throw error;
        }
        var oid = $42b4265ab516a1f2$var$asn1.derToOid(capture.oid);
        if ($42b4265ab516a1f2$var$pki.oids[oid] === undefined) continue;
        decodedAttrs[$42b4265ab516a1f2$var$pki.oids[oid]] = [];
        for(var j = 0; j < capture.values.length; ++j)decodedAttrs[$42b4265ab516a1f2$var$pki.oids[oid]].push(capture.values[j].value);
    }
    return decodedAttrs;
}
/**
 * Wraps a private key and certificate in a PKCS#12 PFX wrapper. If a
 * password is provided then the private key will be encrypted.
 *
 * An entire certificate chain may also be included. To do this, pass
 * an array for the "cert" parameter where the first certificate is
 * the one that is paired with the private key and each subsequent one
 * verifies the previous one. The certificates may be in PEM format or
 * have been already parsed by Forge.
 *
 * @todo implement password-based-encryption for the whole package
 *
 * @param key the private key.
 * @param cert the certificate (may be an array of certificates in order
 *          to specify a certificate chain).
 * @param password the password to use, null for none.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          useMac true to include a MAC, false not to, defaults to true.
 *          localKeyId the local key ID to use, in hex.
 *          friendlyName the friendly name to use.
 *          generateLocalKeyId true to generate a random local key ID,
 *            false not to, defaults to true.
 *
 * @return the PKCS#12 PFX ASN.1 object.
 */ $42b4265ab516a1f2$var$p12.toPkcs12Asn1 = function(key, cert, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || options.encAlgorithm || "aes128";
    if (!("useMac" in options)) options.useMac = true;
    if (!("localKeyId" in options)) options.localKeyId = null;
    if (!("generateLocalKeyId" in options)) options.generateLocalKeyId = true;
    var localKeyId = options.localKeyId;
    var bagAttrs;
    if (localKeyId !== null) localKeyId = $dEd5p.util.hexToBytes(localKeyId);
    else if (options.generateLocalKeyId) {
        // use SHA-1 of paired cert, if available
        if (cert) {
            var pairedCert = $dEd5p.util.isArray(cert) ? cert[0] : cert;
            if (typeof pairedCert === "string") pairedCert = $42b4265ab516a1f2$var$pki.certificateFromPem(pairedCert);
            var sha1 = $dEd5p.md.sha1.create();
            sha1.update($42b4265ab516a1f2$var$asn1.toDer($42b4265ab516a1f2$var$pki.certificateToAsn1(pairedCert)).getBytes());
            localKeyId = sha1.digest().getBytes();
        } else // FIXME: consider using SHA-1 of public key (which can be generated
        // from private key components), see: cert.generateSubjectKeyIdentifier
        // generate random bytes
        localKeyId = $dEd5p.random.getBytes(20);
    }
    var attrs = [];
    if (localKeyId !== null) attrs.push(// localKeyID
    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.localKeyId).getBytes()),
        // attrValues
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SET, true, [
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, localKeyId)
        ])
    ]));
    if ("friendlyName" in options) attrs.push(// friendlyName
    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
        // attrId
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.friendlyName).getBytes()),
        // attrValues
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SET, true, [
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.BMPSTRING, false, options.friendlyName)
        ])
    ]));
    if (attrs.length > 0) bagAttrs = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SET, true, attrs);
    // collect contents for AuthenticatedSafe
    var contents = [];
    // create safe bag(s) for certificate chain
    var chain = [];
    if (cert !== null) {
        if ($dEd5p.util.isArray(cert)) chain = cert;
        else chain = [
            cert
        ];
    }
    var certSafeBags = [];
    for(var i = 0; i < chain.length; ++i){
        // convert cert from PEM as necessary
        cert = chain[i];
        if (typeof cert === "string") cert = $42b4265ab516a1f2$var$pki.certificateFromPem(cert);
        // SafeBag
        var certBagAttrs = i === 0 ? bagAttrs : undefined;
        var certAsn1 = $42b4265ab516a1f2$var$pki.certificateToAsn1(cert);
        var certSafeBag = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.certBag).getBytes()),
            // bagValue
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // CertBag
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
                    // certId
                    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.x509Certificate).getBytes()),
                    // certValue (x509Certificate)
                    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, $42b4265ab516a1f2$var$asn1.toDer(certAsn1).getBytes())
                    ])
                ])
            ]),
            // bagAttributes (OPTIONAL)
            certBagAttrs
        ]);
        certSafeBags.push(certSafeBag);
    }
    if (certSafeBags.length > 0) {
        // SafeContents
        var certSafeContents = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, certSafeBags);
        // ContentInfo
        var certCI = // PKCS#7 ContentInfo
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.data).getBytes()),
            // content
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, $42b4265ab516a1f2$var$asn1.toDer(certSafeContents).getBytes())
            ])
        ]);
        contents.push(certCI);
    }
    // create safe contents for private key
    var keyBag = null;
    if (key !== null) {
        // SafeBag
        var pkAsn1 = $42b4265ab516a1f2$var$pki.wrapRsaPrivateKey($42b4265ab516a1f2$var$pki.privateKeyToAsn1(key));
        if (password === null) // no encryption
        keyBag = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.keyBag).getBytes()),
            // bagValue
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // PrivateKeyInfo
                pkAsn1
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        else // encrypted PrivateKeyInfo
        keyBag = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // bagId
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.pkcs8ShroudedKeyBag).getBytes()),
            // bagValue
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                // EncryptedPrivateKeyInfo
                $42b4265ab516a1f2$var$pki.encryptPrivateKeyInfo(pkAsn1, password, options)
            ]),
            // bagAttributes (OPTIONAL)
            bagAttrs
        ]);
        // SafeContents
        var keySafeContents = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            keyBag
        ]);
        // ContentInfo
        var keyCI = // PKCS#7 ContentInfo
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.data).getBytes()),
            // content
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, $42b4265ab516a1f2$var$asn1.toDer(keySafeContents).getBytes())
            ])
        ]);
        contents.push(keyCI);
    }
    // create AuthenticatedSafe by stringing together the contents
    var safe = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, contents);
    var macData;
    if (options.useMac) {
        // MacData
        var sha1 = $dEd5p.md.sha1.create();
        var macSalt = new $dEd5p.util.ByteBuffer($dEd5p.random.getBytes(options.saltSize));
        var count = options.count;
        // 160-bit key
        var key = $42b4265ab516a1f2$var$p12.generateKey(password, macSalt, 3, count, 20);
        var mac = $dEd5p.hmac.create();
        mac.start(sha1, key);
        mac.update($42b4265ab516a1f2$var$asn1.toDer(safe).getBytes());
        var macValue = mac.getMac();
        macData = $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // mac DigestInfo
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
                // digestAlgorithm
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
                    // algorithm = SHA-1
                    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.sha1).getBytes()),
                    // parameters = Null
                    $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.NULL, false, "")
                ]),
                // digest
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, macValue.getBytes())
            ]),
            // macSalt OCTET STRING
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, macSalt.getBytes()),
            // iterations INTEGER (XXX: Only support count < 65536)
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.INTEGER, false, $42b4265ab516a1f2$var$asn1.integerToDer(count).getBytes())
        ]);
    }
    // PFX
    return $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
        // version (3)
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.INTEGER, false, $42b4265ab516a1f2$var$asn1.integerToDer(3).getBytes()),
        // PKCS#7 ContentInfo
        $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.SEQUENCE, true, [
            // contentType
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OID, false, // OID for the content type is 'data'
            $42b4265ab516a1f2$var$asn1.oidToDer($42b4265ab516a1f2$var$pki.oids.data).getBytes()),
            // content
            $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $42b4265ab516a1f2$var$asn1.create($42b4265ab516a1f2$var$asn1.Class.UNIVERSAL, $42b4265ab516a1f2$var$asn1.Type.OCTETSTRING, false, $42b4265ab516a1f2$var$asn1.toDer(safe).getBytes())
            ])
        ]),
        macData
    ]);
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $42b4265ab516a1f2$var$p12.generateKey = $dEd5p.pbe.generatePkcs12Key;

});


parcelRegister("fC5f3", function(module, exports) {
/**
 * Secure Hash Algorithm with a 1024-bit block size implementation.
 *
 * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
 * SHA-256 (block size 512 bits), see sha256.js.
 *
 * See FIPS 180-4 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014-2015 Digital Bazaar, Inc.
 */ 
var $dEd5p = parcelRequire("dEd5p");
parcelRequire("jaAdc");
parcelRequire("kvSv3");
var $b5de788c51d924be$var$sha512 = module.exports = $dEd5p.sha512 = $dEd5p.sha512 || {};
// SHA-512
$dEd5p.md.sha512 = $dEd5p.md.algorithms.sha512 = $b5de788c51d924be$var$sha512;
// SHA-384
var $b5de788c51d924be$var$sha384 = $dEd5p.sha384 = $dEd5p.sha512.sha384 = $dEd5p.sha512.sha384 || {};
$b5de788c51d924be$var$sha384.create = function() {
    return $b5de788c51d924be$var$sha512.create("SHA-384");
};
$dEd5p.md.sha384 = $dEd5p.md.algorithms.sha384 = $b5de788c51d924be$var$sha384;
// SHA-512/256
$dEd5p.sha512.sha256 = $dEd5p.sha512.sha256 || {
    create: function() {
        return $b5de788c51d924be$var$sha512.create("SHA-512/256");
    }
};
$dEd5p.md["sha512/256"] = $dEd5p.md.algorithms["sha512/256"] = $dEd5p.sha512.sha256;
// SHA-512/224
$dEd5p.sha512.sha224 = $dEd5p.sha512.sha224 || {
    create: function() {
        return $b5de788c51d924be$var$sha512.create("SHA-512/224");
    }
};
$dEd5p.md["sha512/224"] = $dEd5p.md.algorithms["sha512/224"] = $dEd5p.sha512.sha224;
/**
 * Creates a SHA-2 message digest object.
 *
 * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
 *          SHA-512/256).
 *
 * @return a message digest object.
 */ $b5de788c51d924be$var$sha512.create = function(algorithm) {
    // do initialization as necessary
    if (!$b5de788c51d924be$var$_initialized) $b5de788c51d924be$var$_init();
    if (typeof algorithm === "undefined") algorithm = "SHA-512";
    if (!(algorithm in $b5de788c51d924be$var$_states)) throw new Error("Invalid SHA-512 algorithm: " + algorithm);
    // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)
    var _state = $b5de788c51d924be$var$_states[algorithm];
    var _h = null;
    // input buffer
    var _input = $dEd5p.util.createBuffer();
    // used for 64-bit word storage
    var _w = new Array(80);
    for(var wi = 0; wi < 80; ++wi)_w[wi] = new Array(2);
    // determine digest length by algorithm name (default)
    var digestLength = 64;
    switch(algorithm){
        case "SHA-384":
            digestLength = 48;
            break;
        case "SHA-512/256":
            digestLength = 32;
            break;
        case "SHA-512/224":
            digestLength = 28;
            break;
    }
    // message digest object
    var md = {
        // SHA-512 => sha512
        algorithm: algorithm.replace("-", "").toLowerCase(),
        blockLength: 128,
        digestLength: digestLength,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 16
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength128 for backwards-compatibility)
        md.fullMessageLength = md.messageLength128 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $dEd5p.util.createBuffer();
        _h = new Array(_state.length);
        for(var i = 0; i < _state.length; ++i)_h[i] = _state[i].slice(0);
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $dEd5p.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $b5de788c51d924be$var$_update(_h, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-512 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 896 mod 1024. In other words,
    the data to be digested must be a multiple of 1024 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 16 bytes (128
    bits), that means that the last segment of the data must have 112 bytes
    (896 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 896 mod 1024 because
    1024 - 128 = 896.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 896 mod 1024, then 1024 padding bits must be added. */ var finalBlock = $dEd5p.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($b5de788c51d924be$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var h = new Array(_h.length);
        for(var i = 0; i < _h.length; ++i)h[i] = _h[i].slice(0);
        $b5de788c51d924be$var$_update(h, _w, finalBlock);
        var rval = $dEd5p.util.createBuffer();
        var hlen;
        if (algorithm === "SHA-512") hlen = h.length;
        else if (algorithm === "SHA-384") hlen = h.length - 2;
        else hlen = h.length - 4;
        for(var i = 0; i < hlen; ++i){
            rval.putInt32(h[i][0]);
            if (i !== hlen - 1 || algorithm !== "SHA-512/224") rval.putInt32(h[i][1]);
        }
        return rval;
    };
    return md;
};
// sha-512 padding bytes not initialized yet
var $b5de788c51d924be$var$_padding = null;
var $b5de788c51d924be$var$_initialized = false;
// table of constants
var $b5de788c51d924be$var$_k = null;
// initial hash states
var $b5de788c51d924be$var$_states = null;
/**
 * Initializes the constant tables.
 */ function $b5de788c51d924be$var$_init() {
    // create padding
    $b5de788c51d924be$var$_padding = String.fromCharCode(128);
    $b5de788c51d924be$var$_padding += $dEd5p.util.fillString(String.fromCharCode(0x00), 128);
    // create K table for SHA-512
    $b5de788c51d924be$var$_k = [
        [
            0x428a2f98,
            0xd728ae22
        ],
        [
            0x71374491,
            0x23ef65cd
        ],
        [
            0xb5c0fbcf,
            0xec4d3b2f
        ],
        [
            0xe9b5dba5,
            0x8189dbbc
        ],
        [
            0x3956c25b,
            0xf348b538
        ],
        [
            0x59f111f1,
            0xb605d019
        ],
        [
            0x923f82a4,
            0xaf194f9b
        ],
        [
            0xab1c5ed5,
            0xda6d8118
        ],
        [
            0xd807aa98,
            0xa3030242
        ],
        [
            0x12835b01,
            0x45706fbe
        ],
        [
            0x243185be,
            0x4ee4b28c
        ],
        [
            0x550c7dc3,
            0xd5ffb4e2
        ],
        [
            0x72be5d74,
            0xf27b896f
        ],
        [
            0x80deb1fe,
            0x3b1696b1
        ],
        [
            0x9bdc06a7,
            0x25c71235
        ],
        [
            0xc19bf174,
            0xcf692694
        ],
        [
            0xe49b69c1,
            0x9ef14ad2
        ],
        [
            0xefbe4786,
            0x384f25e3
        ],
        [
            0x0fc19dc6,
            0x8b8cd5b5
        ],
        [
            0x240ca1cc,
            0x77ac9c65
        ],
        [
            0x2de92c6f,
            0x592b0275
        ],
        [
            0x4a7484aa,
            0x6ea6e483
        ],
        [
            0x5cb0a9dc,
            0xbd41fbd4
        ],
        [
            0x76f988da,
            0x831153b5
        ],
        [
            0x983e5152,
            0xee66dfab
        ],
        [
            0xa831c66d,
            0x2db43210
        ],
        [
            0xb00327c8,
            0x98fb213f
        ],
        [
            0xbf597fc7,
            0xbeef0ee4
        ],
        [
            0xc6e00bf3,
            0x3da88fc2
        ],
        [
            0xd5a79147,
            0x930aa725
        ],
        [
            0x06ca6351,
            0xe003826f
        ],
        [
            0x14292967,
            0x0a0e6e70
        ],
        [
            0x27b70a85,
            0x46d22ffc
        ],
        [
            0x2e1b2138,
            0x5c26c926
        ],
        [
            0x4d2c6dfc,
            0x5ac42aed
        ],
        [
            0x53380d13,
            0x9d95b3df
        ],
        [
            0x650a7354,
            0x8baf63de
        ],
        [
            0x766a0abb,
            0x3c77b2a8
        ],
        [
            0x81c2c92e,
            0x47edaee6
        ],
        [
            0x92722c85,
            0x1482353b
        ],
        [
            0xa2bfe8a1,
            0x4cf10364
        ],
        [
            0xa81a664b,
            0xbc423001
        ],
        [
            0xc24b8b70,
            0xd0f89791
        ],
        [
            0xc76c51a3,
            0x0654be30
        ],
        [
            0xd192e819,
            0xd6ef5218
        ],
        [
            0xd6990624,
            0x5565a910
        ],
        [
            0xf40e3585,
            0x5771202a
        ],
        [
            0x106aa070,
            0x32bbd1b8
        ],
        [
            0x19a4c116,
            0xb8d2d0c8
        ],
        [
            0x1e376c08,
            0x5141ab53
        ],
        [
            0x2748774c,
            0xdf8eeb99
        ],
        [
            0x34b0bcb5,
            0xe19b48a8
        ],
        [
            0x391c0cb3,
            0xc5c95a63
        ],
        [
            0x4ed8aa4a,
            0xe3418acb
        ],
        [
            0x5b9cca4f,
            0x7763e373
        ],
        [
            0x682e6ff3,
            0xd6b2b8a3
        ],
        [
            0x748f82ee,
            0x5defb2fc
        ],
        [
            0x78a5636f,
            0x43172f60
        ],
        [
            0x84c87814,
            0xa1f0ab72
        ],
        [
            0x8cc70208,
            0x1a6439ec
        ],
        [
            0x90befffa,
            0x23631e28
        ],
        [
            0xa4506ceb,
            0xde82bde9
        ],
        [
            0xbef9a3f7,
            0xb2c67915
        ],
        [
            0xc67178f2,
            0xe372532b
        ],
        [
            0xca273ece,
            0xea26619c
        ],
        [
            0xd186b8c7,
            0x21c0c207
        ],
        [
            0xeada7dd6,
            0xcde0eb1e
        ],
        [
            0xf57d4f7f,
            0xee6ed178
        ],
        [
            0x06f067aa,
            0x72176fba
        ],
        [
            0x0a637dc5,
            0xa2c898a6
        ],
        [
            0x113f9804,
            0xbef90dae
        ],
        [
            0x1b710b35,
            0x131c471b
        ],
        [
            0x28db77f5,
            0x23047d84
        ],
        [
            0x32caab7b,
            0x40c72493
        ],
        [
            0x3c9ebe0a,
            0x15c9bebc
        ],
        [
            0x431d67c4,
            0x9c100d4c
        ],
        [
            0x4cc5d4be,
            0xcb3e42b6
        ],
        [
            0x597f299c,
            0xfc657e2a
        ],
        [
            0x5fcb6fab,
            0x3ad6faec
        ],
        [
            0x6c44198c,
            0x4a475817
        ]
    ];
    // initial hash states
    $b5de788c51d924be$var$_states = {};
    $b5de788c51d924be$var$_states["SHA-512"] = [
        [
            0x6a09e667,
            0xf3bcc908
        ],
        [
            0xbb67ae85,
            0x84caa73b
        ],
        [
            0x3c6ef372,
            0xfe94f82b
        ],
        [
            0xa54ff53a,
            0x5f1d36f1
        ],
        [
            0x510e527f,
            0xade682d1
        ],
        [
            0x9b05688c,
            0x2b3e6c1f
        ],
        [
            0x1f83d9ab,
            0xfb41bd6b
        ],
        [
            0x5be0cd19,
            0x137e2179
        ]
    ];
    $b5de788c51d924be$var$_states["SHA-384"] = [
        [
            0xcbbb9d5d,
            0xc1059ed8
        ],
        [
            0x629a292a,
            0x367cd507
        ],
        [
            0x9159015a,
            0x3070dd17
        ],
        [
            0x152fecd8,
            0xf70e5939
        ],
        [
            0x67332667,
            0xffc00b31
        ],
        [
            0x8eb44a87,
            0x68581511
        ],
        [
            0xdb0c2e0d,
            0x64f98fa7
        ],
        [
            0x47b5481d,
            0xbefa4fa4
        ]
    ];
    $b5de788c51d924be$var$_states["SHA-512/256"] = [
        [
            0x22312194,
            0xFC2BF72C
        ],
        [
            0x9F555FA3,
            0xC84C64C2
        ],
        [
            0x2393B86B,
            0x6F53B151
        ],
        [
            0x96387719,
            0x5940EABD
        ],
        [
            0x96283EE2,
            0xA88EFFE3
        ],
        [
            0xBE5E1E25,
            0x53863992
        ],
        [
            0x2B0199FC,
            0x2C85B8AA
        ],
        [
            0x0EB72DDC,
            0x81C52CA2
        ]
    ];
    $b5de788c51d924be$var$_states["SHA-512/224"] = [
        [
            0x8C3D37C8,
            0x19544DA2
        ],
        [
            0x73E19966,
            0x89DCD4D6
        ],
        [
            0x1DFAB7AE,
            0x32FF9C82
        ],
        [
            0x679DD514,
            0x582F9FCF
        ],
        [
            0x0F6D2B69,
            0x7BD44DA8
        ],
        [
            0x77E36F73,
            0x04C48942
        ],
        [
            0x3F9D85A8,
            0x6A1D36C8
        ],
        [
            0x1112E6AD,
            0x91D692A1
        ]
    ];
    // now initialized
    $b5de788c51d924be$var$_initialized = true;
}
/**
 * Updates a SHA-512 state with the given byte buffer.
 *
 * @param s the SHA-512 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $b5de788c51d924be$var$_update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();
    while(len >= 128){
        // the w array will be populated with sixteen 64-bit big-endian words
        // and then extended into 64 64-bit words according to SHA-512
        for(i = 0; i < 16; ++i){
            w[i][0] = bytes.getInt32() >>> 0;
            w[i][1] = bytes.getInt32() >>> 0;
        }
        for(; i < 80; ++i){
            // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
            w2 = w[i - 2];
            hi = w2[0];
            lo = w2[1];
            // high bits
            t1_hi = ((hi >>> 19 | lo << 13) ^ // ROTR 19
            (lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
            hi >>> 6) >>> 0; // SHR 6
            // low bits
            t1_lo = ((hi << 13 | lo >>> 19) ^ // ROTR 19
            (lo << 3 | hi >>> 29) ^ // ROTR 61/(swap + ROTR 29)
            (hi << 26 | lo >>> 6)) >>> 0; // SHR 6
            // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)
            w15 = w[i - 15];
            hi = w15[0];
            lo = w15[1];
            // high bits
            t2_hi = ((hi >>> 1 | lo << 31) ^ // ROTR 1
            (hi >>> 8 | lo << 24) ^ // ROTR 8
            hi >>> 7) >>> 0; // SHR 7
            // low bits
            t2_lo = ((hi << 31 | lo >>> 1) ^ // ROTR 1
            (hi << 24 | lo >>> 8) ^ // ROTR 8
            (hi << 25 | lo >>> 7)) >>> 0; // SHR 7
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)
            w7 = w[i - 7];
            w16 = w[i - 16];
            lo = t1_lo + w7[1] + t2_lo + w16[1];
            w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
            w[i][1] = lo >>> 0;
        }
        // initialize hash value for this chunk
        a_hi = s[0][0];
        a_lo = s[0][1];
        b_hi = s[1][0];
        b_lo = s[1][1];
        c_hi = s[2][0];
        c_lo = s[2][1];
        d_hi = s[3][0];
        d_lo = s[3][1];
        e_hi = s[4][0];
        e_lo = s[4][1];
        f_hi = s[5][0];
        f_lo = s[5][1];
        g_hi = s[6][0];
        g_lo = s[6][1];
        h_hi = s[7][0];
        h_lo = s[7][1];
        // round function
        for(i = 0; i < 80; ++i){
            // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
            s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ // ROTR 14
            (e_hi >>> 18 | e_lo << 14) ^ // ROTR 18
            (e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)
            s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ // ROTR 14
            (e_hi << 14 | e_lo >>> 18) ^ // ROTR 18
            (e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
            ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
            // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)
            s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ // ROTR 28
            (a_lo >>> 2 | a_hi << 30) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)
            s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ // ROTR 28
            (a_lo << 30 | a_hi >>> 2) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
            maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
            // main algorithm
            // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)
            lo = h_lo + s1_lo + ch_lo + $b5de788c51d924be$var$_k[i][1] + w[i][1];
            t1_hi = h_hi + s1_hi + ch_hi + $b5de788c51d924be$var$_k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
            t1_lo = lo >>> 0;
            // t2 = s0 + maj modulo 2^64 (carry lo overflow)
            lo = s0_lo + maj_lo;
            t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
            t2_lo = lo >>> 0;
            h_hi = g_hi;
            h_lo = g_lo;
            g_hi = f_hi;
            g_lo = f_lo;
            f_hi = e_hi;
            f_lo = e_lo;
            // e = (d + t1) modulo 2^64 (carry lo overflow)
            lo = d_lo + t1_lo;
            e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
            e_lo = lo >>> 0;
            d_hi = c_hi;
            d_lo = c_lo;
            c_hi = b_hi;
            c_lo = b_lo;
            b_hi = a_hi;
            b_lo = a_lo;
            // a = (t1 + t2) modulo 2^64 (carry lo overflow)
            lo = t1_lo + t2_lo;
            a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
            a_lo = lo >>> 0;
        }
        // update hash state (additional modulo 2^64)
        lo = s[0][1] + a_lo;
        s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[0][1] = lo >>> 0;
        lo = s[1][1] + b_lo;
        s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[1][1] = lo >>> 0;
        lo = s[2][1] + c_lo;
        s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[2][1] = lo >>> 0;
        lo = s[3][1] + d_lo;
        s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[3][1] = lo >>> 0;
        lo = s[4][1] + e_lo;
        s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[4][1] = lo >>> 0;
        lo = s[5][1] + f_lo;
        s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[5][1] = lo >>> 0;
        lo = s[6][1] + g_lo;
        s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[6][1] = lo >>> 0;
        lo = s[7][1] + h_lo;
        s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[7][1] = lo >>> 0;
        len -= 128;
    }
}

});


parcelRegister("gS7wL", function(module, exports) {
/*!
 * util/base64url.js - Implementation of web-safe Base64 Encoder/Decoder
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c487874bee9d44bb$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $dKZPt = parcelRequire("dKZPt");
/**
 * @namespace base64url
 * @description
 * Provides methods to encode and decode data according to the
 * base64url alphabet.
 */ var $c487874bee9d44bb$var$base64url = {
    /**
   * @function
   * Encodes the input to base64url.
   *
   * If {input} is a Buffer, then {encoding} is ignored. Otherwise,
   * {encoding} can be one of "binary", "base64", "hex", "utf8".
   *
   * @param {Buffer|String} input The data to encode.
   * @param {String} [encoding = binary] The input encoding format.
   * @returns {String} the base64url encoding of {input}.
   */ encode: function encode(buffer, encoding) {
        if (buffer instanceof ArrayBuffer) buffer = new Uint8Array(buffer);
        if (!$c487874bee9d44bb$require$Buffer.isBuffer(buffer)) buffer = $c487874bee9d44bb$require$Buffer.from(buffer, encoding);
        return $dKZPt.encode(buffer);
    },
    /**
   * @function
   * Decodes the input from base64url.
   *
   * @param {String} input The data to decode.
   * @returns {Buffer|String} the base64url decoding of {input}.
   */ decode: $dKZPt.toBuffer
};
module.exports = $c487874bee9d44bb$var$base64url;

});
parcelRegister("dKZPt", function(module, exports) {

module.exports = (parcelRequire("2e6QR")).default;
module.exports.default = module.exports;

});
parcelRegister("2e6QR", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $19f2342a059e7a9e$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fwxWp = parcelRequire("fwxWp");
function $19f2342a059e7a9e$var$encode(input, encoding) {
    if (encoding === void 0) encoding = "utf8";
    if ($19f2342a059e7a9e$require$Buffer.isBuffer(input)) return $19f2342a059e7a9e$var$fromBase64(input.toString("base64"));
    return $19f2342a059e7a9e$var$fromBase64($19f2342a059e7a9e$require$Buffer.from(input, encoding).toString("base64"));
}
function $19f2342a059e7a9e$var$decode(base64url, encoding) {
    if (encoding === void 0) encoding = "utf8";
    return $19f2342a059e7a9e$require$Buffer.from($19f2342a059e7a9e$var$toBase64(base64url), "base64").toString(encoding);
}
function $19f2342a059e7a9e$var$toBase64(base64url) {
    base64url = base64url.toString();
    return $fwxWp.default(base64url).replace(/\-/g, "+").replace(/_/g, "/");
}
function $19f2342a059e7a9e$var$fromBase64(base64) {
    return base64.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $19f2342a059e7a9e$var$toBuffer(base64url) {
    return $19f2342a059e7a9e$require$Buffer.from($19f2342a059e7a9e$var$toBase64(base64url), "base64");
}
var $19f2342a059e7a9e$var$base64url = $19f2342a059e7a9e$var$encode;
$19f2342a059e7a9e$var$base64url.encode = $19f2342a059e7a9e$var$encode;
$19f2342a059e7a9e$var$base64url.decode = $19f2342a059e7a9e$var$decode;
$19f2342a059e7a9e$var$base64url.toBase64 = $19f2342a059e7a9e$var$toBase64;
$19f2342a059e7a9e$var$base64url.fromBase64 = $19f2342a059e7a9e$var$fromBase64;
$19f2342a059e7a9e$var$base64url.toBuffer = $19f2342a059e7a9e$var$toBuffer;
module.exports.default = $19f2342a059e7a9e$var$base64url;

});
parcelRegister("fwxWp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b4d42c25693a9111$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $b4d42c25693a9111$var$padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) return input;
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = $b4d42c25693a9111$require$Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while(padLength--)buffer.write("=", position++);
    return buffer.toString();
}
module.exports.default = $b4d42c25693a9111$var$padString;

});




parcelRegister("916AZ", function(module, exports) {
/*!
 * util/utf8.js - Implementation of UTF-8 Encoder/Decoder
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
var $690952ca43bbff61$var$utf8 = module.exports;
$690952ca43bbff61$var$utf8.encode = function(input) {
    var output = encodeURIComponent(input || "");
    output = output.replace(/%([0-9a-fA-F]{2})/g, function(m, code) {
        code = parseInt(code, 16);
        return String.fromCharCode(code);
    });
    return output;
};
$690952ca43bbff61$var$utf8.decode = function(input) {
    var output = (input || "").replace(/[\u0080-\u00ff]/g, function(m) {
        var code = (0x100 | m.charCodeAt(0)).toString(16).substring(1);
        return "%" + code;
    });
    output = decodeURIComponent(output);
    return output;
};

});


parcelRegister("dXx0Z", function(module, exports) {
/*!
 * jwk/index.js - JSON Web Key (JWK) Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";

var $2bizm = parcelRequire("2bizm");
// Public API -- Key and KeyStore methods
Object.keys($2bizm.KeyStore).forEach(function(name) {
    module.exports[name] = $2bizm.KeyStore[name];
});

var $e1ACC = parcelRequire("e1ACC");
Object.keys($e1ACC).forEach(function(name) {
    module.exports[name] = $e1ACC[name];
});
parcelRequire("cXohl");
parcelRequire("hOkjG");
parcelRequire("f8Ul6");

});
parcelRegister("2bizm", function(module, exports) {
/*!
 * jwk/keystore.js - JWK KeyStore Implementation
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $196b03540b0a7179$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $bTYY2 = parcelRequire("bTYY2");

var $2rglK = parcelRequire("2rglK");

var $as9F1 = parcelRequire("as9F1");

var $jIqqR = parcelRequire("jIqqR");


var $196b03540b0a7179$var$JWK = {
    BaseKey: (parcelRequire("lQKdq")),
    helpers: (parcelRequire("kFzkW"))
};
/**
 * @class JWK.KeyStoreRegistry
 * @classdesc
 * A registry of JWK.Key types that can be used.
 *
 * @description
 * **NOTE:** This constructor cannot be called directly. Instead use the
 * global {JWK.registry}
 */ var $196b03540b0a7179$var$JWKRegistry = function() {
    var types = {};
    Object.defineProperty(this, "register", {
        value: function(factory) {
            if (!factory || "string" !== typeof factory.kty || !factory.kty) throw new Error("invalid Key factory");
            var kty = factory.kty;
            types[kty] = factory;
            return this;
        }
    });
    Object.defineProperty(this, "unregister", {
        value: function(factory) {
            if (!factory || "string" !== typeof factory.kty || !factory.kty) throw new Error("invalid Key factory");
            var kty = factory.kty;
            if (factory === types[kty]) delete types[kty];
            return this;
        }
    });
    Object.defineProperty(this, "get", {
        value: function(kty) {
            return types[kty || ""] || undefined;
        }
    });
    Object.defineProperty(this, "all", {
        value: function() {
            return Object.keys(types).map(function(t) {
                return types[t];
            });
        }
    });
};
// Globals
var $196b03540b0a7179$var$GLOBAL_REGISTRY = new $196b03540b0a7179$var$JWKRegistry();
// importer
function $196b03540b0a7179$var$processCert(input) {
    // convert certIssuer to readable attributes
    [
        "certIssuer",
        "certSubject"
    ].forEach(function(field) {
        /* eslint new-cap: [0] */ var attrs = $as9F1.pki.RDNAttributesAsArray(input[field]);
        var result = input[field] = {};
        attrs.forEach(function(a) {
            result[a.name || a.type] = a.value;
        });
    });
    return input;
}
function $196b03540b0a7179$var$fromPEM(input) {
    var result = {};
    var pems = $as9F1.pem.decode(input);
    var found = pems.some(function(p) {
        switch(p.type){
            case "CERTIFICATE":
                result.form = "pkix";
                break;
            case "PUBLIC KEY":
                result.form = "spki";
                break;
            case "PRIVATE KEY":
                result.form = "pkcs8";
                break;
            case "EC PRIVATE KEY":
            /* eslint no-fallthrough: [0] */ case "RSA PRIVATE KEY":
                result.form = "private";
                break;
            default:
                return false;
        }
        result.body = p.body;
        return true;
    });
    if (!found) throw new Error("supported PEM type not found");
    return result;
}
function $196b03540b0a7179$var$importFrom(registry, input) {
    // form can be one of:
    //  'private' | 'pkcs8' | 'public' | 'spki' | 'pkix' | 'x509'
    var capture = {}, errors = [], result;
    // conver from DER to ASN1
    var form = input.form, der = input.body, thumbprint = null;
    input = $as9F1.asn1.fromDer(der);
    switch(form){
        case "private":
            registry.all().some(function(factory) {
                if (result) return false;
                if (!factory.validators) return false;
                var oid = factory.validators.oid, validator = factory.validators.privateKey;
                if (!validator) return false;
                capture = {};
                errors = [];
                result = $as9F1.asn1.validate(input, validator, capture, errors);
                if (result) {
                    capture.keyOid = $as9F1.asn1.oidToDer(oid);
                    capture.parsed = true;
                }
                return result;
            });
            capture.type = "private";
            break;
        case "pkcs8":
            result = $as9F1.asn1.validate(input, $196b03540b0a7179$var$JWK.helpers.validators.privateKey, capture, errors);
            capture.type = "private";
            break;
        case "public":
        // eslint no-fallthrough: [0] */
        case "spki":
            result = $as9F1.asn1.validate(input, $196b03540b0a7179$var$JWK.helpers.validators.publicKey, capture, errors);
            capture.type = "public";
            break;
        case "pkix":
        /* eslint no-fallthrough: [0] */ case "x509":
            result = $as9F1.asn1.validate(input, $196b03540b0a7179$var$JWK.helpers.validators.certificate, capture, errors);
            if (result) {
                capture = $196b03540b0a7179$var$processCert(capture);
                var md = $as9F1.md.sha1.create();
                md.update(der);
                thumbprint = $jIqqR.base64url.encode($196b03540b0a7179$require$Buffer.from(md.digest().toHex(), "hex"));
            }
            capture.type = "public";
            break;
    }
    if (!result) return null;
    // convert oids
    if (capture.keyOid) capture.keyOid = $as9F1.asn1.derToOid(capture.keyOid);
    // find and invoke the importer
    result = null;
    $196b03540b0a7179$var$GLOBAL_REGISTRY.all().forEach(function(factory) {
        if (result) return;
        if (!factory) return;
        if ("function" !== typeof factory.import) return;
        result = factory.import(capture);
    });
    if (result && capture.certSubject && capture.certSubject.commonName) result.kid = capture.certSubject.commonName;
    if (result && thumbprint) result.x5t = thumbprint;
    return result;
}
/**
 * @class JWK.KeyStore
 * @classdesc
 * Represents a collection of Keys.
 *
 * @description
 * **NOTE:** This constructor cannot be called directly. Instead call {@link
 * JWK.createKeyStore}.
 */ var $196b03540b0a7179$var$JWKStore = function(registry, parent) {
    var keysets = {};
    /**
   * @method JWK.KeyStore#generate
   * @description
   * Generates a new random Key into this KeyStore.
   *
   * The type of {size} depends on the value of {kty}:
   *
   * + **`EC`**: String naming the curve to use, which can be one of:
   *   `"P-256"`, `"P-384"`, or `"P-521"` (default is **`"P-256"`**).
   * + **`RSA`**: Number describing the size of the key, in bits (default is
   *   **`2048`**).
   * + **`oct`**: Number describing the size of the key, in bits (default is
   *   **`256`**).
   *
   * Any properties in {props} are applied before the key is generated,
   * and are expected to be data types acceptable in JSON.  This allows the
   * generated key to have a specific key identifier, or to specify its
   * acceptable usage.
   *
   * The returned Promise, when fulfilled, returns the generated Key.
   *
   * @param {String} kty The type of generated key
   * @param {String|Number} [size] The size of the generated key
   * @param {Object} [props] Additional properties to apply to the generated
   *        key.
   * @returns {Promise} The promise for the generated Key
   * @throws {Error} If {kty} is not supported
   */ Object.defineProperty(this, "generate", {
        value: function(kty, size, props) {
            var keytype = registry.get(kty);
            if (!keytype) return Promise.reject(new Error("unsupported key type"));
            props = $bTYY2(props || {});
            props.kty = kty;
            var self = this, promise = keytype.generate(size);
            return promise.then(function(jwk) {
                jwk = $2rglK(props, jwk, {
                    kty: kty
                });
                return self.add(jwk);
            });
        }
    });
    /**
   * @method JWK.KeyStore#add
   * @description
   * Adds a Key to this KeyStore. If {jwk} is a string, it is first
   * parsed into a plain JSON object. If {jwk} is already an instance
   * of JWK.Key, its (public) JSON representation is first obtained
   * then applied to a new JWK.Key object within this KeyStore.
   *
   * @param {String|Object} jwk The JSON Web Key (JWK)
   * @param {String} [form] The format of a String key to expect
   * @param {Object} [extras] extra jwk fields inserted when importing from a non json string (eg "pem")
   * @returns {Promise} The promise for the added key
   */ Object.defineProperty(this, "add", {
        value: function(jwk, form, extras) {
            extras = extras || {};
            var factors;
            if ($196b03540b0a7179$require$Buffer.isBuffer(jwk) || typeof jwk === "string") {
                // form can be 'json', 'pkcs8', 'spki', 'pkix', 'x509', 'pem'
                form = (form || "json").toLowerCase();
                if ("json" === form) jwk = JSON.parse(jwk.toString("utf8"));
                else try {
                    if ("pem" === form) // convert *first* PEM -> DER
                    factors = $196b03540b0a7179$var$fromPEM(jwk);
                    else factors = {
                        body: jwk.toString("binary"),
                        form: form
                    };
                    jwk = $196b03540b0a7179$var$importFrom(registry, factors);
                    if (!jwk) throw new Error("no importer for key");
                    Object.keys(extras).forEach(function(field) {
                        jwk[field] = extras[field];
                    });
                } catch (err) {
                    return Promise.reject(err);
                }
            } else if ($196b03540b0a7179$var$JWKStore.isKey(jwk)) // assume a complete duplicate is desired
            jwk = jwk.toJSON(true);
            else jwk = $bTYY2(jwk);
            var keytype = registry.get(jwk.kty);
            if (!keytype) return Promise.reject(new Error("unsupported key type"));
            var self = this, promise = keytype.prepare(jwk);
            return promise.then(function(cfg) {
                return new $196b03540b0a7179$var$JWK.BaseKey(jwk.kty, self, jwk, cfg);
            }).then(function(jwk) {
                var kid = jwk.kid || "";
                var keys = keysets[kid] = keysets[kid] || [];
                keys.push(jwk);
                return jwk;
            });
        }
    });
    /**
   * @method JWK.KeyStore#remove
   * @description
   * Removes a Key from this KeyStore.
   *
   * **NOTE:** The removed Key's {keystore} property is not changed.
   *
   * @param {JWK.Key} jwk The key to remove.
   */ Object.defineProperty(this, "remove", {
        value: function(jwk) {
            if (!jwk) return;
            var keys = keysets[jwk.kid];
            if (!keys) return;
            var pos = keys.indexOf(jwk);
            if (pos === -1) return;
            keys.splice(pos, 1);
            if (!keys.length) delete keysets[jwk.kid];
        }
    });
    /**
   * @method JWK.KeyStore#all
   * @description
   * Retrieves all of the contained Keys that optinally match all of the
   * given properties.
   *
   * If {props} are specified, this method only returns Keys which exactly
   * match the given properties. The properties can be any of the
   * following:
   *
   * + **alg**: The algorithm for the Key.
   * + **use**: The usage for the Key.
   * + **kid**: The identifier for the Key.
   *
   * If no properties are given, this method returns all of the Keys for this
   * KeyStore.
   *
   * @param {Object} [props] The properties to match against
   * @param {Boolean} [local = false] `true` if only the Keys
   *        directly contained by this KeyStore should be returned, or
   *        `false` if it should return all Keys of this KeyStore and
   *        its ancestors.
   * @returns {JWK.Key[]} The list of matching Keys, or an empty array if no
   *          matches are found.
   */ Object.defineProperty(this, "all", {
        value: function(props, local) {
            props = props || {};
            // workaround for issues/109
            if (props.kid !== undefined && props.kid !== null && typeof props.kid !== "string") props.kid = String(props.kid);
            var candidates = [];
            var matches = function(key) {
                // match on 'kty'
                if (props.kty && key.kty && props.kty !== key.kty) return false;
                // match on 'use'
                if (props.use && key.use && props.use !== key.use) return false;
                // match on 'alg'
                if (props.alg) {
                    if (props.alg !== "dir" && key.alg && props.alg !== key.alg) return false;
                    return key.supports(props.alg);
                }
                //TODO: match on 'key_ops'
                return true;
            };
            Object.keys(keysets).forEach(function(id) {
                if (props.kid && props.kid !== id) return;
                var keys = keysets[id].filter(matches);
                if (keys.length) candidates = candidates.concat(keys);
            });
            if (!local && parent) candidates = candidates.concat(parent.all(props));
            return candidates;
        }
    });
    /**
   * @method JWK.KeyStore#get
   * @description
   * Retrieves the contained Key matching the given {kid}, and optionally
   * all of the given properties.  This method equivalent to calling
   * {@link JWK.Store#all}, then returning the first Key whose
   * "kid" is {kid}. If {kid} is undefined, then the first Key that
   * is returned from `all()` is returned.
   *
   * @param {String} [kid] The key identifier to match against.
   * @param {Object} [props] The properties to match against.
   * @param {Boolean} [local = false] `true` if only the Keys
   *        directly contained by this KeyStore should be returned, or
   *        `false` if it should return all Keys of this KeyStore and
   *        its ancestors.
   * @returns {JWK.Key} The Key matching {kid} and {props}, or `null`
   *          if no match is found.
   */ Object.defineProperty(this, "get", {
        value: function(kid, props, local) {
            // reconcile arguments
            if (typeof kid === "boolean") {
                local = kid;
                props = kid = null;
            } else if (typeof kid === "object") {
                local = props;
                props = kid;
                kid = null;
            }
            // fixup props
            props = props || {};
            if (kid) props.kid = kid;
            // workaround for issues/109
            if (props.kid !== undefined && props.kid !== null && typeof props.kid !== "string") props.kid = String(props.kid);
            var candidates = this.all(props, true);
            if (!candidates.length && parent && !local) candidates = parent.get(props, local);
            return candidates[0] || null;
        }
    });
    /**
   * @method JWK.KeyStore#temp
   * @description
   * Creates a temporary KeyStore based on this KeyStore.
   *
   * @returns {JWK.KeyStore} The temporary KeyStore.
   */ Object.defineProperty(this, "temp", {
        value: function() {
            return new $196b03540b0a7179$var$JWKStore(registry, this);
        }
    });
    /**
   * @method JWK.KeyStore#toJSON
   * @description
   * Generates a JSON representation of this KeyStore, which conforms
   * to a JWK Set from {I-D.ietf-jose-json-web-key}.
   *
   * @param {Boolean} [isPrivate = false] `true` if the private fields
   *        of stored keys are to be included.
   * @returns {Object} The JSON representation of this KeyStore.
   */ Object.defineProperty(this, "toJSON", {
        value: function(isPrivate) {
            var keys = [];
            Object.keys(keysets).forEach(function(kid) {
                var items = keysets[kid].map(function(k) {
                    return k.toJSON(isPrivate);
                });
                keys = keys.concat(items);
            });
            return {
                keys: keys
            };
        }
    });
};
/**
 * Determines if the given object is an instance of JWK.KeyStore.
 *
 * @param {Object} obj The object to test
 * @returns {Boolean} `true` if {obj} is an instance of JWK.KeyStore,
 *          and `false` otherwise.
 */ $196b03540b0a7179$var$JWKStore.isKeyStore = function(obj) {
    if (!obj) return false;
    if ("object" !== typeof obj) return false;
    if ("function" !== typeof obj.get || "function" !== typeof obj.all || "function" !== typeof obj.generate || "function" !== typeof obj.add || "function" !== typeof obj.remove) return false;
    return true;
};
/**
 * Creates a new empty KeyStore.
 *
 * @returns {JWK.KeyStore} The empty KeyStore.
 */ $196b03540b0a7179$var$JWKStore.createKeyStore = function() {
    return new $196b03540b0a7179$var$JWKStore($196b03540b0a7179$var$GLOBAL_REGISTRY);
};
/**
 * Coerces the given object into a KeyStore. This method uses the following
 * algorithm to coerce {ks}:
 *
 * 1. if {ks} is an instance of JWK.KeyStore, it is returned directly
 * 2. if {ks} is a string, it is parsed into a JSON value
 * 3. if {ks} is an array, it creates a new JWK.KeyStore and calls {@link
 *    JWK.KeyStore#add} for each element in the {ks} array.
 * 4. if {ks} is a JSON object, it creates a new JWK.KeyStore and calls {@link
 *    JWK.KeyStore#add} for each element in the "keys" property.
 *
 * @param {Object|String} ks The value to coerce into a
 *        KeyStore
 * @returns {Promise(JWK.KeyStore)} A promise for the coerced KeyStore.
 */ $196b03540b0a7179$var$JWKStore.asKeyStore = function(ks) {
    if ($196b03540b0a7179$var$JWKStore.isKeyStore(ks)) return Promise.resolve(ks);
    var store = $196b03540b0a7179$var$JWKStore.createKeyStore(), keys;
    if (typeof ks === "string") ks = JSON.parse(ks);
    if (Array.isArray(ks)) keys = ks;
    else if ("keys" in ks) keys = ks.keys;
    else return Promise.reject(new Error("invalid keystore"));
    keys = keys.map(function(k) {
        return store.add(k);
    });
    var promise = Promise.all(keys);
    promise = promise.then(function() {
        return store;
    });
    return promise;
};
/**
 * Determines if the given object is a JWK.Key instance.
 *
 * @param {Object} obj The object to test
 * @returns `true` if {obj} is a JWK.Key
 */ $196b03540b0a7179$var$JWKStore.isKey = function(obj) {
    if (!obj) return false;
    if ("object" !== typeof obj) return false;
    if (!$196b03540b0a7179$var$JWKStore.isKeyStore(obj.keystore)) return false;
    if ("string" !== typeof obj.kty || "number" !== typeof obj.length || "function" !== typeof obj.algorithms || "function" !== typeof obj.supports || "function" !== typeof obj.encrypt || "function" !== typeof obj.decrypt || "function" !== typeof obj.wrap || "function" !== typeof obj.unwrap || "function" !== typeof obj.sign || "function" !== typeof obj.verify) return false;
    return true;
};
/**
 * Creates a new key with the given properties.  This method is a convenience
 * to calling `JWK.createKeyStore()` then `generate()` on the returned keystore.
 *
 * @param {String} kty The type of generated key
 * @param {String|Number} [size] The size of the generated key
 * @param {Object} [props] Additional properties to apply to the generated
 *        key.
 * @returns {Promise} The promise for the generated Key
 * @throws {Error} If {kty} is not supported
 * @see JWKStore#generate
 */ $196b03540b0a7179$var$JWKStore.createKey = function(kty, size, props) {
    var ks = $196b03540b0a7179$var$JWKStore.createKeyStore();
    return ks.generate(kty, size, props);
};
/**
 * Coerces the given object into a Key. If {key} is an instance of JWK.Key,
 * it is returned directly. Otherwise, this method first creates a new
 * JWK.KeyStore and calls {@link JWK.KeyStore#add} on this new KeyStore.
 *
 * @param {Object|String} key The value to coerce into a Key
 * @param {String} [form] The format of a String Key to expect
 * @param {Object} [extras] extra jwk fields inserted when importing from a non json string (eg "pem")
 * @returns {Promise(JWK.Key)} A promise for the coerced Key.
 */ $196b03540b0a7179$var$JWKStore.asKey = function(key, form, extras) {
    if ($196b03540b0a7179$var$JWKStore.isKey(key)) return Promise.resolve(key);
    var ks = $196b03540b0a7179$var$JWKStore.createKeyStore();
    key = ks.add(key, form, extras);
    return key;
};
module.exports = {
    KeyRegistry: $196b03540b0a7179$var$JWKRegistry,
    KeyStore: $196b03540b0a7179$var$JWKStore,
    registry: $196b03540b0a7179$var$GLOBAL_REGISTRY
};

});
parcelRegister("bTYY2", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8aa41f9fe04bb5cc$var$clone(value) {
    return $kqX4j(value, $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8aa41f9fe04bb5cc$var$clone;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = "[object Arguments]", $ee040e257a097984$var$arrayTag = "[object Array]", $ee040e257a097984$var$boolTag = "[object Boolean]", $ee040e257a097984$var$dateTag = "[object Date]", $ee040e257a097984$var$errorTag = "[object Error]", $ee040e257a097984$var$funcTag = "[object Function]", $ee040e257a097984$var$genTag = "[object GeneratorFunction]", $ee040e257a097984$var$mapTag = "[object Map]", $ee040e257a097984$var$numberTag = "[object Number]", $ee040e257a097984$var$objectTag = "[object Object]", $ee040e257a097984$var$regexpTag = "[object RegExp]", $ee040e257a097984$var$setTag = "[object Set]", $ee040e257a097984$var$stringTag = "[object String]", $ee040e257a097984$var$symbolTag = "[object Symbol]", $ee040e257a097984$var$weakMapTag = "[object WeakMap]";
var $ee040e257a097984$var$arrayBufferTag = "[object ArrayBuffer]", $ee040e257a097984$var$dataViewTag = "[object DataView]", $ee040e257a097984$var$float32Tag = "[object Float32Array]", $ee040e257a097984$var$float64Tag = "[object Float64Array]", $ee040e257a097984$var$int8Tag = "[object Int8Array]", $ee040e257a097984$var$int16Tag = "[object Int16Array]", $ee040e257a097984$var$int32Tag = "[object Int32Array]", $ee040e257a097984$var$uint8Tag = "[object Uint8Array]", $ee040e257a097984$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ee040e257a097984$var$uint16Tag = "[object Uint16Array]", $ee040e257a097984$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});




parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, "DataView");
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, "Promise");
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, "Set");
module.exports = $05f44e958da968eb$var$Set;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $392dfd68f4953502$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = "[object Boolean]", $85aa01d56b12d536$var$dateTag = "[object Date]", $85aa01d56b12d536$var$mapTag = "[object Map]", $85aa01d56b12d536$var$numberTag = "[object Number]", $85aa01d56b12d536$var$regexpTag = "[object RegExp]", $85aa01d56b12d536$var$setTag = "[object Set]", $85aa01d56b12d536$var$stringTag = "[object String]", $85aa01d56b12d536$var$symbolTag = "[object Symbol]";
var $85aa01d56b12d536$var$arrayBufferTag = "[object ArrayBuffer]", $85aa01d56b12d536$var$dataViewTag = "[object DataView]", $85aa01d56b12d536$var$float32Tag = "[object Float32Array]", $85aa01d56b12d536$var$float64Tag = "[object Float64Array]", $85aa01d56b12d536$var$int8Tag = "[object Int8Array]", $85aa01d56b12d536$var$int16Tag = "[object Int16Array]", $85aa01d56b12d536$var$int32Tag = "[object Int32Array]", $85aa01d56b12d536$var$uint8Tag = "[object Uint8Array]", $85aa01d56b12d536$var$uint8ClampedTag = "[object Uint8ClampedArray]", $85aa01d56b12d536$var$uint16Tag = "[object Uint16Array]", $85aa01d56b12d536$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("lQKdq", function(module, exports) {
/*!
 * jwk/basekey.js - JWK Key Base Class Implementation
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $fe824dc054661b1f$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $2rglK = parcelRequire("2rglK");

var $5sKyw = parcelRequire("5sKyw");
var $fe824dc054661b1f$require$uuidv4 = $5sKyw.default;

var $8DQVZ = parcelRequire("8DQVZ");

var $bTYY2 = parcelRequire("bTYY2");

var $20Rgr = parcelRequire("20Rgr");

var $aJAVg = parcelRequire("aJAVg");

var $5c7W3 = parcelRequire("5c7W3");

var $12eN8 = parcelRequire("12eN8");

var $8l7PP = parcelRequire("8l7PP");

var $5s97J = parcelRequire("5s97J");

var $e1ACC = parcelRequire("e1ACC");

var $kFzkW = parcelRequire("kFzkW");

var $jIqqR = parcelRequire("jIqqR");
/**
 * @class JWK.Key
 * @classdesc
 * Represents a JSON Web Key instance.
 *
 * @description
 * **NOTE:** This class cannot be instantiated directly. Instead call
 * {@link JWK.asKey}, {@link JWK.KeyStore#add}, or
 * {@link JWK.KeyStore#generate}.
 */ var $fe824dc054661b1f$var$JWKBaseKeyObject = function(kty, ks, props, cfg) {
    // ### validate/coerce arguments ###
    if (!kty) throw new Error("kty cannot be null");
    if (!ks) throw new Error("keystore cannot be null");
    if (!props) throw new Error("props cannot be null");
    else if ("string" === typeof props) props = JSON.parse(props);
    if (!cfg) throw new Error("cfg cannot be null");
    var excluded = [];
    var keys = {}, json = {}, prints, kid;
    props = $bTYY2(props);
    // strip thumbprints if present
    prints = $8DQVZ({}, props[$kFzkW.INTERNALS.THUMBPRINT_KEY] || {});
    delete props[$kFzkW.INTERNALS.THUMBPRINT_KEY];
    Object.keys(prints).forEach(function(a) {
        var h = prints[a];
        if (!kid) {
            kid = h;
            if ($fe824dc054661b1f$require$Buffer.isBuffer(kid)) kid = $jIqqR.base64url.encode(kid);
        }
        if (!$fe824dc054661b1f$require$Buffer.isBuffer(h)) {
            h = $jIqqR.base64url.decode(h);
            prints[a] = h;
        }
    });
    // force certain values
    props.kty = kty;
    props.kid = props.kid || kid || $fe824dc054661b1f$require$uuidv4();
    // setup base info
    var included = Object.keys($kFzkW.COMMON_PROPS).map(function(p) {
        return $kFzkW.COMMON_PROPS[p].name;
    });
    json.base = $12eN8(props, included);
    excluded = excluded.concat(Object.keys(json.base));
    // setup public information
    json.public = $bTYY2(props);
    keys.public = cfg.publicKey(json.public);
    if (keys.public) // exclude public values from extra
    excluded = excluded.concat(Object.keys(json.public));
    // setup private information
    json.private = $bTYY2(props);
    keys.private = cfg.privateKey(json.private);
    if (keys.private) // exclude private values from extra
    excluded = excluded.concat(Object.keys(json.private));
    // setup extra information
    json.extra = $5c7W3(props, excluded);
    // TODO: validate 'alg' against supported algorithms
    // setup calculated values
    var keyLen;
    if (keys.public && "length" in keys.public) keyLen = keys.public.length;
    else if (keys.private && "length" in keys.private) keyLen = keys.private.length;
    else keyLen = NaN;
    // ### Public Properties ###
    /**
   * @member {JWK.KeyStore} JWK.Key#keystore
   * @description
   * The owning keystore.
   */ Object.defineProperty(this, "keystore", {
        value: ks,
        enumerable: true
    });
    /**
   * @member {Number} JWK.Key#length
   * @description
   * The size of this Key, in bits.
   */ Object.defineProperty(this, "length", {
        value: keyLen,
        enumerable: true
    });
    /**
   * @member {String} JWK.Key#kty
   * @description
   * The type of Key.
   */ Object.defineProperty(this, "kty", {
        value: kty,
        enumerable: true
    });
    /**
   * @member {String} JWK.Key#kid
   * @description
   * The identifier for this Key.
   */ Object.defineProperty(this, "kid", {
        value: json.base.kid,
        enumerable: true
    });
    /**
   * @member {String} JWK.Key#use
   * @description
   * The usage for this Key.
   */ Object.defineProperty(this, "use", {
        value: json.base.use || "",
        enumerable: true
    });
    /**
   * @member {String} JWK.Key#alg
   * @description
   * The sole algorithm this key can be used for.
   */ Object.defineProperty(this, "alg", {
        value: json.base.alg || "",
        enumerable: true
    });
    // ### Public Methods ###
    /**
   * Generates the thumbprint of this Key.
   *
   * @param {String} [] The hash algorithm to use
   * @returns {Promise} The promise for the thumbprint generation.
   */ Object.defineProperty(this, "thumbprint", {
        value: function(hash) {
            hash = (hash || $kFzkW.INTERNALS.THUMBPRINT_HASH).toUpperCase();
            if (prints[hash]) // return cached value
            return Promise.resolve(prints[hash]);
            var p = $kFzkW.thumbprint(cfg, json, hash);
            p = p.then(function(result) {
                if (result) prints[hash] = result;
                return result;
            });
            return p;
        }
    });
    /**
   * @method JWK.Key#algorithms
   * @description
   * The possible algorithms this Key can be used for. The returned
   * list is not any particular order, but is filtered based on the
   * Key's intended usage.
   *
   * @param {String} mode The operation mode
   * @returns {String[]} The list of supported algorithms
   * @see JWK.Key#supports
   */ Object.defineProperty(this, "algorithms", {
        value: function(mode) {
            var modes = [];
            if (!this.use || this.use === "sig") {
                if (!mode || $e1ACC.MODE_SIGN === mode) modes.push($e1ACC.MODE_SIGN);
                if (!mode || $e1ACC.MODE_VERIFY === mode) modes.push($e1ACC.MODE_VERIFY);
            }
            if (!this.use || this.use === "enc") {
                if (!mode || $e1ACC.MODE_ENCRYPT === mode) modes.push($e1ACC.MODE_ENCRYPT);
                if (!mode || $e1ACC.MODE_DECRYPT === mode) modes.push($e1ACC.MODE_DECRYPT);
                if (!mode || $e1ACC.MODE_WRAP === mode) modes.push($e1ACC.MODE_WRAP);
                if (!mode || $e1ACC.MODE_UNWRAP === mode) modes.push($e1ACC.MODE_UNWRAP);
            }
            var self = this;
            var algs = modes.map(function(m) {
                return cfg.algorithms.call(self, keys, m);
            });
            algs = $20Rgr(algs);
            algs = $8l7PP(algs);
            if (this.alg) {
                // TODO: fix this correctly
                var valid;
                if ("oct" === kty) valid = [
                    this.alg,
                    "dir"
                ];
                else valid = [
                    this.alg
                ];
                algs = $aJAVg(algs, valid);
            }
            return algs;
        }
    });
    /**
   * @method JWK.Key#supports
   * @description
   * Determines if the given algorithm is supported.
   *
   * @param {String} alg The algorithm in question
   * @param {String} [mode] The operation mode
   * @returns {Boolean} `true` if {alg} is supported, and `false` otherwise.
   * @see JWK.Key#algorithms
   */ Object.defineProperty(this, "supports", {
        value: function(alg, mode) {
            return this.algorithms(mode).indexOf(alg) !== -1;
        }
    });
    /**
   * @method JWK.Key#has
   * @description
   * Determines if this Key contains the given parameter.
   *
   * @param {String} name The name of the parameter
   * @param {Boolean} [isPrivate=false] `true` if private parameters should be
   *        checked.
   * @returns {Boolean} `true` if the given parameter is present; `false`
   *          otherwise.
   */ Object.defineProperty(this, "has", {
        value: function(name, isPrivate) {
            var contains = false;
            contains = contains || !!(json.base && name in json.base);
            contains = contains || !!(keys.public && name in keys.public);
            contains = contains || !!(json.extra && name in json.extra);
            contains = contains || !!(isPrivate && keys.private && name in keys.private);
            // TODO: check for export restrictions
            return contains;
        }
    });
    /**
   * @method JWK.Key#get
   * @description
   * Retrieves the value of the given parameter. The value returned by this
   * method is in its natural format, which might not exactly match its
   * JSON encoding (e.g., a binary string rather than a base64url-encoded
   * string).
   *
   * **NOTE:** This method can return `false`. Call
   * {@link JWK.Key#has} to determine if the parameter is present.
   *
   * @param {String} name The name of the parameter
   * @param {Boolean} [isPrivate=false] `true` if private parameters should
   *        be checked.
   * @returns {any} The value of the named parameter, or undefined if
   *          it is not present.
   */ Object.defineProperty(this, "get", {
        value: function(name, isPrivate) {
            var src;
            if (json.base && name in json.base) src = json.base;
            else if (keys.public && name in keys.public) src = keys.public;
            else if (json.extra && name in json.extra) src = json.extra;
            else if (isPrivate && keys.private && name in keys.private) // TODO: check for export restrictions
            src = keys.private;
            return src && src[name] || null;
        }
    });
    /**
   * @method JWK.Key#toJSON
   * @description
   * Returns the JSON representation of this Key.  All properties of the
   * returned JSON object are properly encoded (e.g., base64url encoding for
   * any binary strings).
   *
   * @param {Boolean} [isPrivate=false] `true` if private parameters should be
   *        included.
   * @param {String[]} [excluded] The list of parameters to exclude from
   *        the returned JSON.
   * @returns {Object} The plain JSON object
   */ Object.defineProperty(this, "toJSON", {
        value: function(isPrivate, excluded) {
            // coerce arguments
            if (Array.isArray(isPrivate)) {
                excluded = isPrivate;
                isPrivate = false;
            }
            var result = {};
            // TODO: check for export restrictions
            result = $2rglK(result, json.base, json.public, "boolean" === typeof isPrivate && isPrivate ? json.private : {}, json.extra);
            result = $5c7W3(result, excluded || []);
            return result;
        }
    });
    /**
   * @method JWK.Key#toPEM
   * @description
   * Returns the PEM representation of this Key as a string.
   *
   * @param {Boolean} [isPrivate=false] `true` if private parameters should be
   *        included.
   * @returns {string} The PEM-encoded string
   */ Object.defineProperty(this, "toPEM", {
        value: function(isPrivate) {
            if (isPrivate === null) isPrivate = false;
            if (!cfg.convertToPEM) throw new Error("Unsupported key type for PEM encoding");
            var k = isPrivate ? keys.private : keys.public;
            if (!k) throw new Error("Invalid key");
            return cfg.convertToPEM.call(this, k, isPrivate);
        }
    });
    /**
   * @method JWK.Key#toObject
   * @description
   * Returns the plain object representing this Key.  All properties of the
   * returned object are in their natural encoding (e.g., binary strings
   * instead of base64url encoded).
   *
   * @param {Boolean} [isPrivate=false] `true` if private parameters should be
   *        included.
   * @param {String[]} [excluded] The list of parameters to exclude from
   *        the returned object.
   * @returns {Object} The plain Object.
   */ Object.defineProperty(this, "toObject", {
        value: function(isPrivate, excluded) {
            // coerce arguments
            if (Array.isArray(isPrivate)) {
                excluded = isPrivate;
                isPrivate = false;
            }
            var result = {};
            // TODO: check for export restrictions
            result = $2rglK(result, json.base, keys.public, "boolean" === typeof isPrivate && isPrivate ? keys.private : {}, json.extra);
            result = $5c7W3(result, (excluded || []).concat("length"));
            return result;
        }
    });
    /**
   * @method JWK.Key#sign
   * @description
   * Sign the given data using the specified algorithm.
   *
   * **NOTE:** This is the primitive signing operation; the output is
   * _**NOT**_ a JSON Web Signature (JWS) object.
   *
   * The Promise, when fulfilled, returns an Object with the following
   * properties:
   *
   * + **data**: The data that was signed (and should be equal to {data}).
   * + **mac**: The signature or message authentication code (MAC).
   *
   * @param {String} alg The signing algorithm
   * @param {String|Buffer} data The data to sign
   * @param {Object} [props] Additional properties for the signing
   *        algorithm.
   * @returns {Promise} The promise for the signing operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         this Key does not contain the appropriate parameters.
   */ Object.defineProperty(this, "sign", {
        value: function(alg, data, props) {
            // validate appropriateness
            if (this.algorithms("sign").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.signKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.signProps) props = $2rglK(props, cfg.signProps.call(this, alg, props));
            return $5s97J.sign(alg, k, data, props);
        }
    });
    /**
   * @method JWK.Key#verify
   * @description
   * Verify the given data and signature using the specified algorithm.
   *
   * **NOTE:** This is the primitive verification operation; the input is
   * _**NOT**_ a JSON Web Signature.</p>
   *
   * The Promise, when fulfilled, returns an Object with the following
   * properties:
   *
   * + **data**: The data that was verified (and should be equal to
   *   {data}).
   * + **mac**: The signature or MAC that was verified (and should be equal
   *   to {mac}).
   * + **valid**: `true` if {mac} is valid for {data}.
   *
   * @param {String} alg The verification algorithm
   * @param {String|Buffer} data The data to verify
   * @param {String|Buffer} mac The signature or MAC to verify
   * @param {Object} [props] Additional properties for the verification
   *        algorithm.
   * @returns {Promise} The promise for the verification operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         the Key does not contain the appropriate properties.
   */ Object.defineProperty(this, "verify", {
        value: function(alg, data, mac, props) {
            // validate appropriateness
            if (this.algorithms("verify").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.verifyKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.verifyProps) props = $2rglK(props, cfg.verifyProps.call(this, alg, props));
            return $5s97J.verify(alg, k, data, mac, props);
        }
    });
    /**
   * @method JWK.Key#encrypt
   * @description
   * Encrypts the given data using the specified algorithm.
   *
   * **NOTE:** This is the primitive encryption operation; the output is
   * _**NOT**_ a JSON Web Encryption (JWE) object.
   *
   * **NOTE:** This operation is treated as distinct from {@link
   * JWK.Key#wrap}, as different algorithms and properties are often
   * used for wrapping a key versues encrypting arbitrary data.
   *
   * The Promise, when fulfilled, returns an object with the following
   * properties:
   *
   * + **data**: The ciphertext data
   * + **mac**: The associated message authentication code (MAC).
   *
   * @param {String} alg The encryption algorithm
   * @param {Buffer|String} data The data to encrypt
   * @param {Object} [props] Additional properties for the encryption
   *        algorithm.
   * @returns {Promise} The promise for the encryption operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         this Key does not contain the appropriate parameters.
   */ Object.defineProperty(this, "encrypt", {
        value: function(alg, data, props) {
            // validate appropriateness
            if (this.algorithms("encrypt").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.encryptKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.encryptProps) props = $2rglK(props, cfg.encryptProps.call(this, alg, props));
            return $5s97J.encrypt(alg, k, data, props);
        }
    });
    /**
   * @method JWK.Key#decrypt
   * @description
   * Decrypts the given data using the specified algorithm.
   *
   * **NOTE:** This is the primitive decryption operation; the input is
   * _**NOT**_ a JSON Web Encryption (JWE) object.
   *
   * **NOTE:** This operation is treated as distinct from {@link
   * JWK.Key#unwrap}, as different algorithms and properties are often used
   * for unwrapping a key versues decrypting arbitrary data.
   *
   * The Promise, when fulfilled, returns the plaintext data.
   *
   * @param {String} alg The decryption algorithm.
   * @param {Buffer|String} data The data to decypt.
   * @param {Object} [props] Additional data for the decryption operation.
   * @returns {Promise} The promise for the decryption operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         the Key does not contain the appropriate properties.
   */ Object.defineProperty(this, "decrypt", {
        value: function(alg, data, props) {
            // validate appropriateness
            if (this.algorithms("decrypt").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.decryptKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.decryptProps) props = $2rglK(props, cfg.decryptProps.call(this, alg, props));
            return $5s97J.decrypt(alg, k, data, props);
        }
    });
    /**
   * @method JWK.Key#wrap
   * @description
   * Wraps the given key using the specified algorithm.
   *
   * **NOTE:** This is the primitive encryption operation; the output is
   * _**NOT**_ a JSON Web Encryption (JWE) object.
   *
   * **NOTE:** This operation is treated as distinct from {@link
   * JWK.Key#encrypt}, as different algorithms and properties are
   * often used for wrapping a key versues encrypting arbitrary data.
   *
   * The Promise, when fulfilled, returns an object with the following
   * properties:
   *
   * + **data**: The ciphertext data
   * + **headers**: The additional header parameters to apply to a JWE.
   *
   * @param {String} alg The encryption algorithm
   * @param {Buffer|String} data The data to encrypt
   * @param {Object} [props] Additional properties for the encryption
   *        algorithm.
   * @returns {Promise} The promise for the encryption operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         this Key does not contain the appropriate parameters.
   */ Object.defineProperty(this, "wrap", {
        value: function(alg, data, props) {
            // validate appropriateness
            if (this.algorithms("wrap").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.wrapKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.wrapProps) props = $2rglK(props, cfg.wrapProps.call(this, alg, props));
            return $5s97J.encrypt(alg, k, data, props);
        }
    });
    /**
   * @method JWK.Key#unwrap
   * @description
   * Unwraps the given key using the specified algorithm.
   *
   * **NOTE:** This is the primitive unwrap operation; the input is
   * _**NOT**_ a JSON Web Encryption (JWE) object.
   *
   * **NOTE:** This operation is treated as distinct from {@link
   * JWK.Key#decrypt}, as different algorithms and properties are often used
   * for unwrapping a key versues decrypting arbitrary data.
   *
   * The Promise, when fulfilled, returns the unwrapped key.
   *
   * @param {String} alg The unwrap algorithm.
   * @param {Buffer|String} data The data to unwrap.
   * @param {Object} [props] Additional data for the unwrap operation.
   * @returns {Promise} The promise for the unwrap operation.
   * @throws {Error} If {alg} is not appropriate for this Key; or if
   *         the Key does not contain the appropriate properties.
   */ Object.defineProperty(this, "unwrap", {
        value: function(alg, data, props) {
            // validate appropriateness
            if (this.algorithms("unwrap").indexOf(alg) === -1) return Promise.reject(new Error("unsupported algorithm"));
            var k = cfg.unwrapKey.call(this, alg, keys);
            if (!k) return Promise.reject(new Error("improper key"));
            // prepare properties (if any)
            props = props ? $bTYY2(props) : {};
            if (cfg.unwrapProps) props = $2rglK(props, cfg.unwrapProps.call(this, alg, props));
            return $5s97J.decrypt(alg, k, data, props);
        }
    });
};
module.exports = $fe824dc054661b1f$var$JWKBaseKeyObject;

});
parcelRegister("5sKyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa3ae484854b431$export$2e2bcd8739ae039);

var $aZg8W = parcelRequire("aZg8W");

var $7qKRb = parcelRequire("7qKRb");

var $2uohp = parcelRequire("2uohp");
function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $aZg8W.default).randomUUID && !buf && !options) return (0, $aZg8W.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7qKRb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $2uohp.unsafeStringify)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;

});
parcelRegister("aZg8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ffc1f94643dc7e4$export$2e2bcd8739ae039);
const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};

});

parcelRegister("7qKRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f4ee4022ba00e$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}

});

parcelRegister("2uohp", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $1d0137947e8554ce$export$8fb373d660548968);

var $64ZUg = parcelRequire("64ZUg");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $64ZUg.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;

});
parcelRegister("64ZUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d323206dcbf256$export$2e2bcd8739ae039);

var $4meF0 = parcelRequire("4meF0");
function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $4meF0.default).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;

});
parcelRegister("4meF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c496bfb6c27b56$export$2e2bcd8739ae039);
var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("8DQVZ", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cYlGN = parcelRequire("cYlGN");

var $i1jm6 = parcelRequire("i1jm6");

var $eMthh = parcelRequire("eMthh");

var $3wZFp = parcelRequire("3wZFp");

var $LAMcS = parcelRequire("LAMcS");
/** Used for built-in method references. */ var $64ab06e3276f1fef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64ab06e3276f1fef$var$hasOwnProperty = $64ab06e3276f1fef$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $64ab06e3276f1fef$var$assign = $i1jm6(function(object, source) {
    if ($3wZFp(source) || $eMthh(source)) {
        $cYlGN(source, $LAMcS(source), object);
        return;
    }
    for(var key in source)if ($64ab06e3276f1fef$var$hasOwnProperty.call(source, key)) $5i71d(object, key, source[key]);
});
module.exports = $64ab06e3276f1fef$var$assign;

});

parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});



parcelRegister("aJAVg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $6Ikd8 = parcelRequire("6Ikd8");

var $5iyRF = parcelRequire("5iyRF");

var $2lqgl = parcelRequire("2lqgl");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $7d0abf6a6db17d41$var$intersection = $5iyRF(function(arrays) {
    var mapped = $i46jW(arrays, $2lqgl);
    return mapped.length && mapped[0] === arrays[0] ? $6Ikd8(mapped) : [];
});
module.exports = $7d0abf6a6db17d41$var$intersection;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});

parcelRegister("6Ikd8", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $i46jW = parcelRequire("i46jW");

var $91Qdd = parcelRequire("91Qdd");

var $2l8n7 = parcelRequire("2l8n7");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4e36879618b4e4e6$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $4e36879618b4e4e6$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $eSdxB : $ebE2M, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $i46jW(array, $91Qdd(iteratee));
        maxLength = $4e36879618b4e4e6$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $dXA7v(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $2l8n7(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $2l8n7(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $4e36879618b4e4e6$var$baseIntersection;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("2lqgl", function(module, exports) {

var $jGP9B = parcelRequire("jGP9B");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $1b51ea2925b1420f$var$castArrayLikeObject(value) {
    return $jGP9B(value) ? value : [];
}
module.exports = $1b51ea2925b1420f$var$castArrayLikeObject;

});


parcelRegister("5c7W3", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $kqX4j = parcelRequire("kqX4j");

var $gSeoX = parcelRequire("gSeoX");

var $4RK0h = parcelRequire("4RK0h");

var $cYlGN = parcelRequire("cYlGN");

var $lJ3Ig = parcelRequire("lJ3Ig");

var $8KK0w = parcelRequire("8KK0w");

var $i0kKc = parcelRequire("i0kKc");
/** Used to compose bitmasks for cloning. */ var $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG = 1, $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG = 2, $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3c843a8ff84cd42d$var$omit = $8KK0w(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $i46jW(paths, function(path) {
        path = $4RK0h(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $cYlGN(object, $i0kKc(object), result);
    if (isDeep) result = $kqX4j(result, $3c843a8ff84cd42d$var$CLONE_DEEP_FLAG | $3c843a8ff84cd42d$var$CLONE_FLAT_FLAG | $3c843a8ff84cd42d$var$CLONE_SYMBOLS_FLAG, $lJ3Ig);
    var length = paths.length;
    while(length--)$gSeoX(result, paths[length]);
    return result;
});
module.exports = $3c843a8ff84cd42d$var$omit;

});
parcelRegister("gSeoX", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $hkfXi = parcelRequire("hkfXi");

var $f865s = parcelRequire("f865s");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c48cdc53eae67a7f$var$baseUnset(object, path) {
    path = $4RK0h(path, object);
    object = $f865s(object, path);
    return object == null || delete object[$6DSvu($hkfXi(path))];
}
module.exports = $c48cdc53eae67a7f$var$baseUnset;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});

parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + "";
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});



parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("f865s", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $1quiu = parcelRequire("1quiu");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $b03c5325a6e99e83$var$parent(object, path) {
    return path.length < 2 ? object : $lJEX1(object, $1quiu(path, 0, -1));
}
module.exports = $b03c5325a6e99e83$var$parent;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $9dr3u(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});


parcelRegister("1quiu", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $109fb88fe59de104$var$baseSlice;

});



parcelRegister("lJ3Ig", function(module, exports) {

var $xMy82 = parcelRequire("xMy82");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $fd10ae4394ad99ac$var$customOmitClone(value) {
    return $xMy82(value) ? undefined : value;
}
module.exports = $fd10ae4394ad99ac$var$customOmitClone;

});

parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + "");
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});


parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});


parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});




parcelRegister("8l7PP", function(module, exports) {

var $5VSS6 = parcelRequire("5VSS6");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $61265cbd5811e578$var$uniq(array) {
    return array && array.length ? $5VSS6(array) : [];
}
module.exports = $61265cbd5811e578$var$uniq;

});
parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});




parcelRegister("5s97J", function(module, exports) {

$parcel$export(module.exports, "digest", () => $3f86a51223a3dfa6$export$4dc2d9f0820a4918, (v) => $3f86a51223a3dfa6$export$4dc2d9f0820a4918 = v);
$parcel$export(module.exports, "derive", () => $3f86a51223a3dfa6$export$78ed5b3305815fc7, (v) => $3f86a51223a3dfa6$export$78ed5b3305815fc7 = v);
$parcel$export(module.exports, "sign", () => $3f86a51223a3dfa6$export$c5552dfdbc7cec71, (v) => $3f86a51223a3dfa6$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "verify", () => $3f86a51223a3dfa6$export$532244b5b8b0b4b6, (v) => $3f86a51223a3dfa6$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "encrypt", () => $3f86a51223a3dfa6$export$5b0f6292f11d1d18, (v) => $3f86a51223a3dfa6$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $3f86a51223a3dfa6$export$e85a0c9a1067c5d3, (v) => $3f86a51223a3dfa6$export$e85a0c9a1067c5d3 = v);
/*!
 * algorithms/index.js - Cryptographic Algorithms Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ // public API
var $3f86a51223a3dfa6$export$4dc2d9f0820a4918;
var $3f86a51223a3dfa6$export$78ed5b3305815fc7;
var $3f86a51223a3dfa6$export$c5552dfdbc7cec71;
var $3f86a51223a3dfa6$export$532244b5b8b0b4b6;
var $3f86a51223a3dfa6$export$5b0f6292f11d1d18;
var $3f86a51223a3dfa6$export$e85a0c9a1067c5d3;
"use strict";













// setup implementations
var $3f86a51223a3dfa6$var$implementations = [
    (parcelRequire("diu5g")),
    (parcelRequire("gQv4Y")),
    (parcelRequire("8eyMA")),
    (parcelRequire("kwDeH")),
    (parcelRequire("hR9hg")),
    (parcelRequire("vlNNp")),
    (parcelRequire("emih6")),
    (parcelRequire("klWr4")),
    (parcelRequire("ky6eE")),
    (parcelRequire("4gqAU")),
    (parcelRequire("lInl9")),
    (parcelRequire("96ReK")),
    (parcelRequire("f4IS9"))
];
var $3f86a51223a3dfa6$var$ALGS_DIGEST = {};
var $3f86a51223a3dfa6$var$ALGS_DERIVE = {};
var $3f86a51223a3dfa6$var$ALGS_SIGN = {}, $3f86a51223a3dfa6$var$ALGS_VRFY = {};
var $3f86a51223a3dfa6$var$ALGS_ENC = {}, $3f86a51223a3dfa6$var$ALGS_DEC = {};
$3f86a51223a3dfa6$var$implementations.forEach(function(mod) {
    Object.keys(mod).forEach(function(alg) {
        var op = mod[alg];
        if ("function" === typeof op.encrypt) $3f86a51223a3dfa6$var$ALGS_ENC[alg] = op.encrypt;
        if ("function" === typeof op.decrypt) $3f86a51223a3dfa6$var$ALGS_DEC[alg] = op.decrypt;
        if ("function" === typeof op.sign) $3f86a51223a3dfa6$var$ALGS_SIGN[alg] = op.sign;
        if ("function" === typeof op.verify) $3f86a51223a3dfa6$var$ALGS_VRFY[alg] = op.verify;
        if ("function" === typeof op.digest) $3f86a51223a3dfa6$var$ALGS_DIGEST[alg] = op.digest;
        if ("function" === typeof op.derive) $3f86a51223a3dfa6$var$ALGS_DERIVE[alg] = op.derive;
    });
});
$3f86a51223a3dfa6$export$4dc2d9f0820a4918 = function(alg, data, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_DIGEST[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(data, props);
};
$3f86a51223a3dfa6$export$78ed5b3305815fc7 = function(alg, key, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_DERIVE[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(key, props);
};
$3f86a51223a3dfa6$export$c5552dfdbc7cec71 = function(alg, key, pdata, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_SIGN[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(key, pdata, props || {});
};
$3f86a51223a3dfa6$export$532244b5b8b0b4b6 = function(alg, key, pdata, mac, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_VRFY[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(key, pdata, mac, props || {});
};
$3f86a51223a3dfa6$export$5b0f6292f11d1d18 = function(alg, key, pdata, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_ENC[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(key, pdata, props || {});
};
$3f86a51223a3dfa6$export$e85a0c9a1067c5d3 = function(alg, key, cdata, props) {
    var op = $3f86a51223a3dfa6$var$ALGS_DEC[alg];
    if (!op) return Promise.reject(new Error("unsupported algorithm: " + alg));
    return op(key, cdata, props || {});
};

});
parcelRegister("diu5g", function(module, exports) {
/*!
 * algorithms/aes-cbc-hmac-sha2.js - AES-CBC-HMAC-SHA2 Composited Encryption
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $9ae44ad747048f28$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $7gM1u = parcelRequire("7gM1u");

var $ky6eE = parcelRequire("ky6eE");

var $f4IS9 = parcelRequire("f4IS9");

var $as9F1 = parcelRequire("as9F1");

var $7y5jX = parcelRequire("7y5jX");

var $jIqqR = parcelRequire("jIqqR");
function $9ae44ad747048f28$var$checkIv(iv) {
    if (16 !== iv.length) throw new Error("invalid iv");
}
function $9ae44ad747048f28$var$commonCbcEncryptFN(size) {
    // ### 'fallback' implementation -- uses forge
    var fallback = function(encKey, pdata, iv) {
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve();
        promise = promise.then(function() {
            var cipher = $as9F1.cipher.createCipher("AES-CBC", new $7y5jX(encKey));
            cipher.start({
                iv: new $7y5jX(iv)
            });
            // TODO: chunk data
            cipher.update(new $7y5jX(pdata));
            if (!cipher.finish()) return Promise.reject(new Error("encryption failed"));
            var cdata = $9ae44ad747048f28$require$Buffer.from(cipher.output.bytes(), "binary");
            return cdata;
        });
        return promise;
    };
    // ### WebCryptoAPI implementation
    // TODO: cache CryptoKey sooner
    var webcrypto = function(encKey, pdata, iv) {
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve();
        promise = promise.then(function() {
            var alg = {
                name: "AES-CBC"
            };
            return $7gM1u.subtleCrypto.importKey("raw", encKey, alg, true, [
                "encrypt"
            ]);
        });
        promise = promise.then(function(key) {
            var alg = {
                name: "AES-CBC",
                iv: iv
            };
            return $7gM1u.subtleCrypto.encrypt(alg, key, pdata);
        });
        promise = promise.then(function(cdata) {
            cdata = $9ae44ad747048f28$require$Buffer.from(cdata);
            return cdata;
        });
        return promise;
    };
    // ### NodeJS implementation
    var nodejs = function(encKey, pdata, iv) {
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve(pdata);
        promise = promise.then(function(pdata) {
            var name = "AES-" + size + "-CBC";
            var cipher = $7gM1u.nodeCrypto.createCipheriv(name, encKey, iv);
            var cdata = $9ae44ad747048f28$require$Buffer.concat([
                cipher.update(pdata),
                cipher.final()
            ]);
            return cdata;
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $9ae44ad747048f28$var$commonCbcDecryptFN(size) {
    // ### 'fallback' implementation -- uses forge
    var fallback = function(encKey, cdata, iv) {
        // validate inputs
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve();
        promise = promise.then(function() {
            var cipher = $as9F1.cipher.createDecipher("AES-CBC", new $7y5jX(encKey));
            cipher.start({
                iv: new $7y5jX(iv)
            });
            // TODO: chunk data
            cipher.update(new $7y5jX(cdata));
            if (!cipher.finish()) return Promise.reject(new Error("encryption failed"));
            var pdata = $9ae44ad747048f28$require$Buffer.from(cipher.output.bytes(), "binary");
            return pdata;
        });
        return promise;
    };
    // ### WebCryptoAPI implementation
    // TODO: cache CryptoKey sooner
    var webcrypto = function(encKey, cdata, iv) {
        // validate inputs
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve();
        promise = promise.then(function() {
            var alg = {
                name: "AES-CBC"
            };
            return $7gM1u.subtleCrypto.importKey("raw", encKey, alg, true, [
                "decrypt"
            ]);
        });
        promise = promise.then(function(key) {
            var alg = {
                name: "AES-CBC",
                iv: iv
            };
            return $7gM1u.subtleCrypto.decrypt(alg, key, cdata);
        });
        promise = promise.then(function(pdata) {
            pdata = $9ae44ad747048f28$require$Buffer.from(pdata);
            return pdata;
        });
        return promise;
    };
    // ### NodeJS implementation
    var nodejs = function(encKey, cdata, iv) {
        // validate inputs
        try {
            $9ae44ad747048f28$var$checkIv(iv);
        } catch (err) {
            return Promise.reject(err);
        }
        var promise = Promise.resolve();
        promise = promise.then(function() {
            var name = "AES-" + size + "-CBC";
            var cipher = $7gM1u.nodeCrypto.createDecipheriv(name, encKey, iv);
            var pdata = $9ae44ad747048f28$require$Buffer.concat([
                cipher.update(cdata),
                cipher.final()
            ]);
            return pdata;
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $9ae44ad747048f28$var$checkKey(key, size) {
    if (size << 1 !== key.length << 3) throw new Error("invalid encryption key size");
}
function $9ae44ad747048f28$var$cbcHmacEncryptFN(size) {
    var commonEncrypt = $9ae44ad747048f28$var$commonCbcEncryptFN(size);
    return function(key, pdata, props) {
        // validate inputs
        try {
            $9ae44ad747048f28$var$checkKey(key, size);
        } catch (err) {
            return Promise.reject(err);
        }
        var eKey = key.slice(size / 8), iKey = key.slice(0, size / 8), iv = props.iv || $9ae44ad747048f28$require$Buffer.alloc(0), adata = props.aad || props.adata || $9ae44ad747048f28$require$Buffer.alloc(0);
        // STEP 1 -- Encrypt
        var promise = commonEncrypt(eKey, pdata, iv);
        // STEP 2 -- MAC
        promise = promise.then(function(cdata) {
            var mdata = $9ae44ad747048f28$require$Buffer.concat([
                adata,
                iv,
                cdata,
                $7gM1u.int64ToBuffer(adata.length * 8)
            ]);
            var promise;
            promise = $ky6eE["HS" + size * 2].sign(iKey, mdata, {
                length: size
            });
            promise = promise.then(function(result) {
                // TODO: move slice to hmac.js
                var tag = result.mac.slice(0, size / 8);
                return {
                    data: cdata,
                    tag: tag
                };
            });
            return promise;
        });
        return promise;
    };
}
function $9ae44ad747048f28$var$cbcHmacDecryptFN(size) {
    var commonDecrypt = $9ae44ad747048f28$var$commonCbcDecryptFN(size);
    return function(key, cdata, props) {
        // validate inputs
        try {
            $9ae44ad747048f28$var$checkKey(key, size);
        } catch (err) {
            return Promise.reject(err);
        }
        var eKey = key.slice(size / 8), iKey = key.slice(0, size / 8), iv = props.iv || $9ae44ad747048f28$require$Buffer.alloc(0), adata = props.aad || props.adata || $9ae44ad747048f28$require$Buffer.alloc(0), tag = props.tag || props.mac || $9ae44ad747048f28$require$Buffer.alloc(0);
        var promise = Promise.resolve();
        // STEP 1 -- MAC
        promise = promise.then(function() {
            var promise;
            // construct MAC input
            var mdata = $9ae44ad747048f28$require$Buffer.concat([
                adata,
                iv,
                cdata,
                $7gM1u.int64ToBuffer(adata.length * 8)
            ]);
            promise = $ky6eE["HS" + size * 2].verify(iKey, mdata, tag, {
                length: size
            });
            promise = promise.then(function() {
                return cdata;
            }, function() {
                // failure -- invalid tag error
                throw new Error("mac check failed");
            });
            return promise;
        });
        // STEP 2 -- Decrypt
        promise = promise.then(function() {
            return commonDecrypt(eKey, cdata, iv);
        });
        return promise;
    };
}
var $9ae44ad747048f28$var$EncryptionLabel = $9ae44ad747048f28$require$Buffer.from("Encryption", "utf8");
var $9ae44ad747048f28$var$IntegrityLabel = $9ae44ad747048f28$require$Buffer.from("Integrity", "utf8");
var $9ae44ad747048f28$var$DotLabel = $9ae44ad747048f28$require$Buffer.from(".", "utf8");
function $9ae44ad747048f28$var$generateCek(masterKey, alg, epu, epv) {
    var masterSize = masterKey.length * 8;
    var cekSize = masterSize / 2;
    var promise = Promise.resolve();
    promise = promise.then(function() {
        var input = $9ae44ad747048f28$require$Buffer.concat([
            $7gM1u.int32ToBuffer(1),
            masterKey,
            $7gM1u.int32ToBuffer(cekSize),
            $9ae44ad747048f28$require$Buffer.from(alg, "utf8"),
            epu,
            epv,
            $9ae44ad747048f28$var$EncryptionLabel
        ]);
        return input;
    });
    promise = promise.then(function(input) {
        return $f4IS9["SHA-" + masterSize].digest(input).then(function(digest) {
            return digest.slice(0, cekSize / 8);
        });
    });
    promise = Promise.resolve(promise);
    return promise;
}
function $9ae44ad747048f28$var$generateCik(masterKey, alg, epu, epv) {
    var masterSize = masterKey.length * 8;
    var cikSize = masterSize;
    var promise = Promise.resolve();
    promise = promise.then(function() {
        var input = $9ae44ad747048f28$require$Buffer.concat([
            $7gM1u.int32ToBuffer(1),
            masterKey,
            $7gM1u.int32ToBuffer(cikSize),
            $9ae44ad747048f28$require$Buffer.from(alg, "utf8"),
            epu,
            epv,
            $9ae44ad747048f28$var$IntegrityLabel
        ]);
        return input;
    });
    promise = promise.then(function(input) {
        return $f4IS9["SHA-" + masterSize].digest(input).then(function(digest) {
            return digest.slice(0, cikSize / 8);
        });
    });
    promise = Promise.resolve(promise);
    return promise;
}
function $9ae44ad747048f28$var$concatKdfCbcHmacEncryptFN(size, alg) {
    var commonEncrypt = $9ae44ad747048f28$var$commonCbcEncryptFN(size);
    return function(key, pdata, props) {
        var epu = props.epu || $7gM1u.int32ToBuffer(0), epv = props.epv || $7gM1u.int32ToBuffer(0), iv = props.iv || $9ae44ad747048f28$require$Buffer.alloc(0), adata = props.aad || props.adata || $9ae44ad747048f28$require$Buffer.alloc(0), kdata = props.kdata || $9ae44ad747048f28$require$Buffer.alloc(0);
        // Pre Step 1 -- Generate Keys
        var promises = [
            $9ae44ad747048f28$var$generateCek(key, alg, epu, epv),
            $9ae44ad747048f28$var$generateCik(key, alg, epu, epv)
        ];
        var cek, cik;
        var promise = Promise.all(promises).then(function(keys) {
            cek = keys[0];
            cik = keys[1];
        });
        // STEP 1 -- Encrypt
        promise = promise.then(function() {
            return commonEncrypt(cek, pdata, iv);
        });
        // STEP 2 -- Mac
        promise = promise.then(function(cdata) {
            var mdata = $9ae44ad747048f28$require$Buffer.concat([
                adata,
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from(kdata),
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from($jIqqR.base64url.encode(iv), "utf8"),
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from($jIqqR.base64url.encode(cdata), "utf8")
            ]);
            return Promise.all([
                Promise.resolve(cdata),
                $ky6eE["HS" + size * 2].sign(cik, mdata, {
                    length: size
                })
            ]);
        });
        promise = promise.then(function(result) {
            return {
                data: result[0],
                tag: result[1].mac
            };
        });
        return promise;
    };
}
function $9ae44ad747048f28$var$concatKdfCbcHmacDecryptFN(size, alg) {
    var commonDecrypt = $9ae44ad747048f28$var$commonCbcDecryptFN(size);
    return function(key, cdata, props) {
        var epu = props.epu || $7gM1u.int32ToBuffer(0), epv = props.epv || $7gM1u.int32ToBuffer(0), iv = props.iv || $9ae44ad747048f28$require$Buffer.alloc(0), adata = props.aad || props.adata || $9ae44ad747048f28$require$Buffer.alloc(0), kdata = props.kdata || $9ae44ad747048f28$require$Buffer.alloc(0), tag = props.tag || props.mac || $9ae44ad747048f28$require$Buffer.alloc(0);
        // Pre Step 1 -- Generate Keys
        var promises = [
            $9ae44ad747048f28$var$generateCek(key, alg, epu, epv),
            $9ae44ad747048f28$var$generateCik(key, alg, epu, epv)
        ];
        var cek, cik;
        var promise = Promise.all(promises).then(function(keys) {
            cek = keys[0];
            cik = keys[1];
        });
        // STEP 1 -- MAC
        promise = promise.then(function() {
            // construct MAC input
            var mdata = $9ae44ad747048f28$require$Buffer.concat([
                adata,
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from(kdata),
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from($jIqqR.base64url.encode(iv), "utf8"),
                $9ae44ad747048f28$var$DotLabel,
                $9ae44ad747048f28$require$Buffer.from($jIqqR.base64url.encode(cdata), "utf8")
            ]);
            try {
                return $ky6eE["HS" + size * 2].verify(cik, mdata, tag, {
                    loose: false
                });
            } catch (e) {
                throw new Error("mac check failed");
            }
        });
        // STEP 2 -- Decrypt
        promise = promise.then(function() {
            return commonDecrypt(cek, cdata, iv);
        });
        return promise;
    };
}
// ### Public API
// * [name].encrypt
// * [name].decrypt
var $9ae44ad747048f28$var$aesCbcHmacSha2 = {};
[
    "A128CBC-HS256",
    "A192CBC-HS384",
    "A256CBC-HS512"
].forEach(function(alg) {
    var size = parseInt(/A(\d+)CBC-HS(\d+)?/g.exec(alg)[1]);
    $9ae44ad747048f28$var$aesCbcHmacSha2[alg] = {
        encrypt: $9ae44ad747048f28$var$cbcHmacEncryptFN(size),
        decrypt: $9ae44ad747048f28$var$cbcHmacDecryptFN(size)
    };
});
[
    "A128CBC+HS256",
    "A192CBC+HS384",
    "A256CBC+HS512"
].forEach(function(alg) {
    var size = parseInt(/A(\d+)CBC\+HS(\d+)?/g.exec(alg)[1]);
    $9ae44ad747048f28$var$aesCbcHmacSha2[alg] = {
        encrypt: $9ae44ad747048f28$var$concatKdfCbcHmacEncryptFN(size, alg),
        decrypt: $9ae44ad747048f28$var$concatKdfCbcHmacDecryptFN(size, alg)
    };
});
module.exports = $9ae44ad747048f28$var$aesCbcHmacSha2;

});
parcelRegister("7gM1u", function(module, exports) {
/*!
 * algorithms/helpers.js - Internal functions and fields used in Cryptographic
 * Algorithms
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $54af476bfdbc0543$require$Buffer = $6ZWSX.Buffer;
"use strict";

if (typeof Promise === "undefined") (parcelRequire("lcSRC")).polyfill();
// ###
module.exports.int32ToBuffer = function(v, b) {
    b = b || $54af476bfdbc0543$require$Buffer.alloc(4);
    b[0] = v >>> 24 & 0xff;
    b[1] = v >>> 16 & 0xff;
    b[2] = v >>> 8 & 0xff;
    b[3] = v & 0xff;
    return b;
};
var $54af476bfdbc0543$var$MAX_INT32 = Math.pow(2, 32);
module.exports.int64ToBuffer = function(v, b) {
    b = b || $54af476bfdbc0543$require$Buffer.alloc(8);
    var hi = Math.floor(v / $54af476bfdbc0543$var$MAX_INT32), lo = v % $54af476bfdbc0543$var$MAX_INT32;
    hi = module.exports.int32ToBuffer(hi);
    lo = module.exports.int32ToBuffer(lo);
    b = $54af476bfdbc0543$require$Buffer.concat([
        hi,
        lo
    ]);
    return b;
};
// ### crypto and DOMException in browsers ###
/* global crypto:false, DOMException:false */ function $54af476bfdbc0543$var$getCryptoSubtle() {
    if ("undefined" !== typeof crypto) {
        if ("undefined" !== typeof crypto.subtle) return crypto.subtle;
    }
    return undefined;
}

function $54af476bfdbc0543$var$getCryptoNodeJS() {
    var crypto1;
    try {
        crypto1 = (parcelRequire("kjyEk"));
    } catch (err) {
        return undefined;
    }
    if (!Object.keys(crypto1).length) // treat empty the same as missing
    return undefined;
    return crypto1;
}
var $54af476bfdbc0543$var$supported = {};
Object.defineProperty(module.exports, "subtleCrypto", {
    get: function() {
        var result;
        if ("subtleCrypto" in $54af476bfdbc0543$var$supported) result = $54af476bfdbc0543$var$supported.subtleCrypto;
        else result = $54af476bfdbc0543$var$supported.subtleCrypto = $54af476bfdbc0543$var$getCryptoSubtle();
        return result;
    },
    enumerable: true
});
Object.defineProperty(module.exports, "nodeCrypto", {
    get: function() {
        var result;
        if ("nodeCrypto" in $54af476bfdbc0543$var$supported) result = $54af476bfdbc0543$var$supported.nodeCrypto;
        else result = $54af476bfdbc0543$var$supported.nodeCrypto = $54af476bfdbc0543$var$getCryptoNodeJS();
        return result;
    },
    enumerable: true
});
module.exports.setupFallback = function(nodejs, webcrypto, fallback) {
    var impl;
    if (nodejs && module.exports.nodeCrypto) impl = function main() {
        var args = arguments, promise;
        function check(err) {
            if (0 === err.message.indexOf("unsupported algorithm:")) {
                impl = fallback;
                return impl.apply(null, args);
            }
            return Promise.reject(err);
        }
        try {
            promise = Promise.resolve(nodejs.apply(null, args));
        } catch (err) {
            promise = check(err);
        }
        return promise;
    };
    else if (webcrypto && module.exports.subtleCrypto) impl = function main() {
        var args = arguments, promise;
        function check(err) {
            if (err.code === DOMException.NOT_SUPPORTED_ERR || // Firefox rejects some operations erroneously complaining about inputs
            err.message === "Only ArrayBuffer and ArrayBufferView objects can be passed as CryptoOperationData" || // MS Edge rejects with not an Error
            !(err instanceof Error)) {
                // not actually supported -- always use fallback
                impl = fallback;
                return impl.apply(null, args);
            }
            return Promise.reject(err);
        }
        try {
            promise = webcrypto.apply(null, args);
            promise = promise.catch(check);
        } catch (err) {
            promise = check(err);
        }
        return promise;
    };
    else impl = fallback;
    return impl;
};

});

parcelRegister("ky6eE", function(module, exports) {
/*!
 * algorithms/hmac.js - HMAC-based "signatures"
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ef5bd1d8f979d852$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1YNha = parcelRequire("1YNha");

var $as9F1 = parcelRequire("as9F1");

var $7y5jX = parcelRequire("7y5jX");

var $7gM1u = parcelRequire("7gM1u");
function $ef5bd1d8f979d852$var$hmacSignFN(name) {
    var md = name.replace("HS", "SHA").toLowerCase(), hash = name.replace("HS", "SHA-");
    function checkKeyLength(len, key) {
        len = (len || $1YNha.HASHLENGTH[hash]) / 8;
        if (len > key.length) return Promise.reject(new Error("invalid key length"));
        return Promise.resolve(key);
    }
    // ### Fallback Implementation -- uses forge
    var fallback = function(key, pdata, props) {
        props = props || {};
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function() {
            var sig = $as9F1.hmac.create();
            sig.start(md, key.toString("binary"));
            sig.update(pdata.toString("binary"));
            sig = $ef5bd1d8f979d852$require$Buffer.from(sig.digest().bytes(), "binary");
            return {
                data: pdata,
                mac: sig
            };
        });
        return promise;
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(key, pdata, props) {
        props = props || {};
        var alg = {
            name: "HMAC",
            hash: {
                name: hash
            }
        };
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function() {
            return $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
                "sign"
            ]);
        });
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var sig = $ef5bd1d8f979d852$require$Buffer.from(result);
            return {
                data: pdata,
                mac: sig
            };
        });
        return promise;
    };
    // ### NodeJS implementation
    var nodejs = function(key, pdata, props) {
        props = props || {};
        var promise;
        promise = checkKeyLength(props.length, key);
        promise = promise.then(function() {
            var hmac = $7gM1u.nodeCrypto.createHmac(md, key);
            hmac.update(pdata);
            var sig = hmac.digest();
            return {
                data: pdata,
                mac: sig
            };
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $ef5bd1d8f979d852$var$hmacVerifyFN(name) {
    var md = name.replace("HS", "SHA").toLowerCase(), hash = name.replace("HS", "SHA-");
    function compare(len, expected, actual) {
        len = (len || $1YNha.HASHLENGTH[hash]) / 8;
        var valid = true;
        for(var idx = 0; len > idx; idx++)valid = valid && expected[idx] === actual[idx];
        return valid;
    }
    // ### Fallback Implementation -- uses forge
    var fallback = function(key, pdata, mac, props) {
        props = props || {};
        var vrfy = $as9F1.hmac.create();
        vrfy.start(md, new $7y5jX(key));
        vrfy.update(pdata.toString("binary"));
        vrfy = $ef5bd1d8f979d852$require$Buffer.from(vrfy.digest().bytes(), "binary");
        if (compare(props.length, mac, vrfy)) return Promise.resolve({
            data: pdata,
            mac: mac,
            valid: true
        });
        else return Promise.reject(new Error("verification failed"));
    };
    var webcrypto = function(key, pdata, mac, props) {
        props = props || {};
        var alg = {
            name: "HMAC",
            hash: {
                name: hash
            }
        };
        var promise;
        if (props.length) {
            promise = $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
                "sign"
            ]);
            promise = promise.then(function(key) {
                return $7gM1u.subtleCrypto.sign(alg, key, pdata);
            });
            promise = promise.then(function(result) {
                var sig = $ef5bd1d8f979d852$require$Buffer.from(result);
                return compare(props.length, mac, sig);
            });
        } else {
            promise = $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
                "verify"
            ]);
            promise = promise.then(function(key) {
                return $7gM1u.subtleCrypto.verify(alg, key, mac, pdata);
            });
        }
        promise = promise.then(function(result) {
            if (!result) return Promise.reject(new Error("verifaction failed"));
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    var nodejs = function(key, pdata, mac, props) {
        props = props || {};
        var hmac = $7gM1u.nodeCrypto.createHmac(md, key);
        hmac.update(pdata);
        var sig = hmac.digest();
        if (!compare(props.length, mac, sig)) throw new Error("verification failed");
        return {
            data: pdata,
            mac: sig,
            valid: true
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### Public API
// * [name].sign
// * [name].verify
var $ef5bd1d8f979d852$var$hmac = {};
[
    "HS1",
    "HS256",
    "HS384",
    "HS512"
].forEach(function(alg) {
    $ef5bd1d8f979d852$var$hmac[alg] = {
        sign: $ef5bd1d8f979d852$var$hmacSignFN(alg),
        verify: $ef5bd1d8f979d852$var$hmacVerifyFN(alg)
    };
});
module.exports = $ef5bd1d8f979d852$var$hmac;

});
parcelRegister("1YNha", function(module, exports) {
/*!
 * algorithms/constants.js - Constants used in Cryptographic Algorithms
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";
module.exports = {
    CHUNK_SIZE: 1024,
    HASHLENGTH: {
        "SHA-1": 160,
        "SHA-256": 256,
        "SHA-384": 384,
        "SHA-512": 512
    },
    ENCLENGTH: {
        "AES-128-CBC": 128,
        "AES-192-CBC": 192,
        "AES-256-CBC": 256,
        "AES-128-KW": 128,
        "AES-192-KW": 192,
        "AES-256-KW": 256
    },
    KEYLENGTH: {
        "A128CBC-HS256": 256,
        "A192CBC-HS384": 384,
        "A256CBC-HS512": 512,
        "A128CBC+HS256": 256,
        "A192CBC+HS384": 384,
        "A256CBC+HS512": 512,
        "A128GCM": 128,
        "A192GCM": 192,
        "A256GCM": 256,
        "A128KW": 128,
        "A192KW": 192,
        "A256KW": 256,
        "ECDH-ES+A128KW": 128,
        "ECDH-ES+A192KW": 192,
        "ECDH-ES+A256KW": 256
    },
    NONCELENGTH: {
        "A128CBC-HS256": 128,
        "A192CBC-HS384": 128,
        "A256CBC-HS512": 128,
        "A128CBC+HS256": 128,
        "A192CBC+HS384": 128,
        "A256CBC+HS512": 128,
        "A128GCM": 96,
        "A192GCM": 96,
        "A256GCM": 96
    }
};

});

parcelRegister("7y5jX", function(module, exports) {
/*!
 * util/databuffer.js - Forge-compatible Buffer based on Node.js Buffers
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $57efd5fb7797ddf9$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $gS7wL = parcelRequire("gS7wL");
/**
 *
 */ function $57efd5fb7797ddf9$var$DataBuffer(b, options) {
    options = options || {};
    // treat (views of) (Array)Buffers special
    // NOTE: default implementation creates copies, but efficiently
    //       wherever possible
    if ($57efd5fb7797ddf9$require$Buffer.isBuffer(b)) this.data = b;
    else if ($as9F1.util.isArrayBuffer(b)) {
        b = new Uint8Array(b);
        this.data = $57efd5fb7797ddf9$require$Buffer.from(b);
    } else if ($as9F1.util.isArrayBufferView(b)) {
        b = new Uint8Array(b.buffer, b.byteOffset, b.byteLength);
        this.data = $57efd5fb7797ddf9$require$Buffer.from(b);
    }
    if (this.data) {
        this.write = this.data.length;
        b = undefined;
    }
    // setup growth rate
    this.growSize = options.growSize || $57efd5fb7797ddf9$var$DataBuffer.DEFAULT_GROW_SIZE;
    // initialize pointers and data
    this.write = this.write || 0;
    this.read = this.read || 0;
    if (b) this.putBytes(b);
    else if (!this.data) this.accommodate(0);
    // massage read/write pointers
    options.readOffset = "readOffset" in options ? options.readOffset : this.read;
    this.write = "writeOffset" in options ? options.writeOffset : this.write;
    this.read = Math.min(options.readOffset, this.write);
}
$57efd5fb7797ddf9$var$DataBuffer.DEFAULT_GROW_SIZE = 16;
$57efd5fb7797ddf9$var$DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.available = function() {
    return this.data.length - this.write;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.accommodate = function(length) {
    if (!this.data) {
        // initializes a new buffer
        length = Math.max(this.write + length, this.growSize);
        this.data = $57efd5fb7797ddf9$require$Buffer.alloc(length);
    } else if (this.available() < length) {
        length = Math.max(length, this.growSize);
        // create a new empty buffer, and copy current one into it
        var src = this.data;
        var dst = $57efd5fb7797ddf9$require$Buffer.alloc(src.length + length);
        src.copy(dst, 0);
        // set data as the new buffer
        this.data = dst;
    }
    // ensure the rest is 0
    this.data.fill(0, this.write);
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.clear = function() {
    this.read = this.write = 0;
    this.data = $57efd5fb7797ddf9$require$Buffer.alloc(0);
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.truncate = function(count) {
    // chop off <count> bytes from the end
    this.write = this.read + Math.max(0, this.length() - count);
    // ensure the remainder is 0
    this.data.fill(0, this.write);
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        if (this.write === this.read) this.read = this.write = 0;
        else {
            this.data.copy(this.data, 0, this.read, this.write);
            this.write = this.write - this.read;
            this.read = 0;
        }
        // ensure remainder is 0
        this.data.fill(0, this.write);
    }
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.copy = function() {
    return new $57efd5fb7797ddf9$var$DataBuffer(this, {
        readOffset: this.read,
        writeOffset: this.write,
        growSize: this.growSize
    });
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.equals = function(test) {
    if (!$57efd5fb7797ddf9$var$DataBuffer.isBuffer(test)) return false;
    if (test.length() !== this.length()) return false;
    var rval = true, delta = this.read - test.read;
    // constant time
    for(var idx = test.read; test.write > idx; idx++)rval = rval && this.data[idx + delta] === test.data[idx];
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.at = function(idx) {
    return this.data[this.read + idx];
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.setAt = function(idx, b) {
    this.data[this.read + idx] = b;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.last = function() {
    return this.data[this.write - 1];
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.bytes = function(count) {
    var rval;
    if (undefined === count) count = this.length();
    else if (count) count = Math.min(count, this.length());
    if (0 === count) rval = "";
    else {
        var begin = this.read, end = begin + count, data = this.data.slice(begin, end);
        rval = String.fromCharCode.apply(null, data);
    }
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.buffer = function(count) {
    var rval;
    if (undefined === count) count = this.length();
    else if (count) count = Math.min(count, this.length());
    if (0 === count) rval = new ArrayBuffer(0);
    else {
        var begin = this.read, end = begin + count, data = this.data.slice(begin, end);
        rval = new Uint8Array(end - begin);
        rval.set(data);
    }
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.native = function(count) {
    var rval;
    if ("undefined" === typeof count) count = this.length();
    else if (count) count = Math.min(count, this.length());
    if (0 === count) rval = $57efd5fb7797ddf9$require$Buffer.alloc(0);
    else {
        var begin = this.read, end = begin + count;
        rval = this.data.slice(begin, end);
    }
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.toHex = function() {
    return this.toString("hex");
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.toString = function(encoding) {
    // short circuit empty string
    if (0 === this.length()) return "";
    var view = this.data.slice(this.read, this.write);
    encoding = encoding || "utf8";
    // special cases, then built-in support
    switch(encoding){
        case "raw":
            return view.toString("binary");
        case "base64url":
            return $gS7wL.encode(view);
        case "utf16":
            return view.toString("ucs2");
        default:
            return view.toString(encoding);
    }
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.fillWithByte = function(b, n) {
    if (!n) n = this.available();
    this.accommodate(n);
    this.data.fill(b, this.write, this.write + n);
    this.write += n;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getBuffer = function(count) {
    var rval = this.buffer(count);
    this.read += rval.byteLength;
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putBuffer = function(bytes) {
    return this.putBytes(bytes);
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getBytes = function(count) {
    var rval = this.bytes(count);
    this.read += rval.length;
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ("string" === typeof bytes) {
        // fixup encoding
        encoding = encoding || "binary";
        switch(encoding){
            case "utf16":
                // treat as UCS-2/UTF-16BE
                encoding = "ucs-2";
                break;
            case "raw":
                encoding = "binary";
                break;
            case "base64url":
                // NOTE: this returns a Buffer
                bytes = $gS7wL.decode(bytes);
                break;
        }
        // replace bytes with decoded Buffer (if not already)
        if (!$57efd5fb7797ddf9$require$Buffer.isBuffer(bytes)) bytes = $57efd5fb7797ddf9$require$Buffer.from(bytes, encoding);
    }
    var src, dst;
    if (bytes instanceof $57efd5fb7797ddf9$var$DataBuffer) {
        // be slightly more efficient
        var orig = bytes;
        bytes = orig.data.slice(orig.read, orig.write);
        orig.read = orig.write;
    } else if (bytes instanceof $as9F1.util.ByteStringBuffer) bytes = bytes.getBytes();
    // process array
    if ($57efd5fb7797ddf9$require$Buffer.isBuffer(bytes)) src = bytes;
    else if (Array.isArray(bytes)) src = $57efd5fb7797ddf9$require$Buffer.from(bytes);
    else if ($as9F1.util.isArrayBuffer(bytes)) {
        src = new Uint8Array(bytes);
        src = $57efd5fb7797ddf9$require$Buffer.from(src);
    } else if ($as9F1.util.isArrayBufferView(bytes)) {
        src = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        src = $57efd5fb7797ddf9$require$Buffer.from(src);
    } else throw new TypeError("invalid source type");
    this.accommodate(src.length);
    dst = this.data;
    src.copy(dst, this.write);
    this.write += src.length;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getNative = function(count) {
    var rval = this.native(count);
    this.read += rval.length;
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putNative = $57efd5fb7797ddf9$var$DataBuffer.prototype.putBuffer;
$57efd5fb7797ddf9$var$DataBuffer.prototype.getByte = function() {
    var b = this.data[this.read];
    this.read = Math.min(this.read + 1, this.write);
    return b;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data[this.write] = b & 0xff;
    this.write++;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt16 = function() {
    var n = this.data[this.read] << 8 ^ this.data[this.read + 1];
    this.read = Math.min(this.read + 2, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt16 = function(n) {
    this.accommodate(2);
    this.data[this.write] = n >>> 8 & 0xff;
    this.data[this.write + 1] = n & 0xff;
    this.write += 2;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt24 = function() {
    var n = this.data[this.read] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read + 2];
    this.read = Math.min(this.read + 3, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt24 = function(n) {
    this.accommodate(3);
    this.data[this.write] = n >>> 16 & 0xff;
    this.data[this.write + 1] = n >>> 8 & 0xff;
    this.data[this.write + 2] = n & 0xff;
    this.write += 3;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt32 = function() {
    var n = this.data[this.read] << 24 ^ this.data[this.read + 1] << 16 ^ this.data[this.read + 2] << 8 ^ this.data[this.read + 3];
    this.read = Math.min(this.read + 4, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt32 = function(n) {
    this.accommodate(4);
    this.data[this.write] = n >>> 24 & 0xff;
    this.data[this.write + 1] = n >>> 16 & 0xff;
    this.data[this.write + 2] = n >>> 8 & 0xff;
    this.data[this.write + 3] = n & 0xff;
    this.write += 4;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt16Le = function() {
    var n = this.data[this.read + 1] << 8 ^ this.data[this.read];
    this.read = Math.min(this.read + 2, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt16Le = function(n) {
    this.accommodate(2);
    this.data[this.write + 1] = n >>> 8 & 0xff;
    this.data[this.write] = n & 0xff;
    this.write += 2;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt24Le = function() {
    var n = this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
    this.read = Math.min(this.read + 3, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt24Le = function(n) {
    this.accommodate(3);
    this.data[this.write + 2] = n >>> 16 & 0xff;
    this.data[this.write + 1] = n >>> 8 & 0xff;
    this.data[this.write] = n & 0xff;
    this.write += 3;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt32Le = function() {
    var n = this.data[this.read + 3] << 24 ^ this.data[this.read + 2] << 16 ^ this.data[this.read + 1] << 8 ^ this.data[this.read];
    this.read = Math.min(this.read + 4, this.write);
    return n;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt32Le = function(n) {
    this.accommodate(4);
    this.data[this.write + 3] = n >>> 24 & 0xff;
    this.data[this.write + 2] = n >>> 16 & 0xff;
    this.data[this.write + 1] = n >>> 8 & 0xff;
    this.data[this.write] = n & 0xff;
    this.write += 4;
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.getInt = function(bits) {
    var rval = 0;
    do {
        rval = rval << 8 | this.getByte();
        bits -= 8;
    }while (bits > 0);
    return rval;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putInt = function(n, bits) {
    this.accommodate(Math.ceil(bits / 8));
    do {
        bits -= 8;
        this.putByte(n >> bits & 0xff);
    }while (bits > 0);
    return this;
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putSignedInt = function(n, bits) {
    if (n < 0) n += 2 << bits - 1;
    return this.putInt(n, bits);
};
$57efd5fb7797ddf9$var$DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, "utf16");
};
$57efd5fb7797ddf9$var$DataBuffer.isBuffer = function(test) {
    return test instanceof $57efd5fb7797ddf9$var$DataBuffer;
};
$57efd5fb7797ddf9$var$DataBuffer.asBuffer = function(orig) {
    return $57efd5fb7797ddf9$var$DataBuffer.isBuffer(orig) ? orig : orig ? new $57efd5fb7797ddf9$var$DataBuffer(orig) : new $57efd5fb7797ddf9$var$DataBuffer();
};
module.exports = $57efd5fb7797ddf9$var$DataBuffer;

});


parcelRegister("f4IS9", function(module, exports) {
/*!
 * algorithms/sha.js - Cryptographic Secure Hash Algorithms, versions 1 and 2
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $af9a097ba806b926$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $7gM1u = parcelRequire("7gM1u");
function $af9a097ba806b926$var$hashDigestFN(hash) {
    var md = hash.replace("SHA-", "SHA").toLowerCase();
    var alg = {
        name: hash
    };
    // ### Fallback Implementation -- uses forge
    var fallback = function(pdata /* props */ ) {
        var digest = $as9F1.md[md].create();
        digest.update(pdata.toString("binary"));
        digest = $af9a097ba806b926$require$Buffer.from(digest.digest().bytes(), "binary");
        return Promise.resolve(digest);
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(pdata /* props */ ) {
        var promise;
        promise = $7gM1u.subtleCrypto.digest(alg, pdata);
        promise = promise.then(function(result) {
            result = $af9a097ba806b926$require$Buffer.from(result);
            return result;
        });
        return promise;
    };
    // ### nodejs Implementation
    var nodejs = function(pdata /* props */ ) {
        var digest = $7gM1u.nodeCrypto.createHash(md);
        digest.update(pdata);
        return digest.digest();
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// Public API
// * [name].digest
var $af9a097ba806b926$var$sha = {};
[
    "SHA-1",
    "SHA-256",
    "SHA-384",
    "SHA-512"
].forEach(function(name) {
    $af9a097ba806b926$var$sha[name] = {
        digest: $af9a097ba806b926$var$hashDigestFN(name)
    };
});
module.exports = $af9a097ba806b926$var$sha;

});


parcelRegister("gQv4Y", function(module, exports) {
/*!
 * algorithms/aes-gcm.js - AES-GCM Encryption and Key-Wrapping
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c4399c5b7f632bd5$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $7gM1u = parcelRequire("7gM1u");

var $jIqqR = parcelRequire("jIqqR");

var $1YNha = parcelRequire("1YNha");

var $7MhM2 = parcelRequire("7MhM2");
function $c4399c5b7f632bd5$var$gcmEncryptFN(size, wrap) {
    function commonChecks(key, iv) {
        if (size !== key.length << 3) throw new Error("invalid key size");
        if (!iv && !wrap) throw new Error("invalid iv");
        if (iv && 12 !== iv.length) throw new Error("invalid iv");
    }
    function prepareResults(results) {
        if (wrap) {
            var iv = $jIqqR.base64url.encode(results.iv);
            var tag = $jIqqR.base64url.encode(results.tag);
            results = {
                data: results.data,
                header: {
                    iv: iv,
                    tag: tag
                }
            };
        }
        return results;
    }
    // ### 'fallback' implementation -- uses forge
    var fallback = function(key, pdata, props) {
        var iv = props.iv, adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0), cipher, cdata;
        // validate inputs
        try {
            commonChecks(key, iv, adata);
        } catch (err) {
            return Promise.reject(err);
        }
        iv = iv || $jIqqR.randomBytes(12);
        // setup cipher
        cipher = $7MhM2.createCipher({
            key: key,
            iv: iv,
            additionalData: adata
        });
        // ciphertext is the same length as plaintext
        cdata = $c4399c5b7f632bd5$require$Buffer.alloc(pdata.length);
        var promise = new Promise(function(resolve, reject) {
            var amt = $1YNha.CHUNK_SIZE, clen = 0, poff = 0;
            (function doChunk() {
                var plen = Math.min(amt, pdata.length - poff);
                clen += cipher.update(pdata, poff, plen, cdata, clen);
                poff += plen;
                if (pdata.length > poff) {
                    setTimeout(doChunk, 0);
                    return;
                }
                // finish it
                clen += cipher.finish(cdata, clen);
                if (clen !== pdata.length) {
                    reject(new Error("encryption failed"));
                    return;
                }
                // resolve with output
                var tag = cipher.tag;
                resolve(prepareResults({
                    data: cdata,
                    iv: iv,
                    tag: tag
                }));
            })();
        });
        return promise;
    };
    // ### WebCryptoAPI implementation
    // TODO: cache CryptoKey sooner
    var webcrypto = function(key, pdata, props) {
        var iv = props.iv, adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0);
        try {
            commonChecks(key, iv, adata);
        } catch (err) {
            return Promise.reject(err);
        }
        iv = iv || $jIqqR.randomBytes(12);
        var alg = {
            name: "AES-GCM"
        };
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
            "encrypt"
        ]);
        promise = promise.then(function(key) {
            alg.iv = iv;
            alg.tagLength = 128;
            if (adata.length) alg.additionalData = adata;
            return $7gM1u.subtleCrypto.encrypt(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var tagStart = result.byteLength - 16;
            var tag = result.slice(tagStart);
            tag = $c4399c5b7f632bd5$require$Buffer.from(tag);
            var cdata = result.slice(0, tagStart);
            cdata = $c4399c5b7f632bd5$require$Buffer.from(cdata);
            return prepareResults({
                data: cdata,
                iv: iv,
                tag: tag
            });
        });
        return promise;
    };
    // ### NodeJS implementation
    var nodejs = function(key, pdata, props) {
        var iv = props.iv, adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0);
        try {
            commonChecks(key, iv, adata);
        } catch (err) {
            return Promise.reject(err);
        }
        iv = iv || $jIqqR.randomBytes(12);
        var alg = "aes-" + key.length * 8 + "-gcm";
        var cipher;
        try {
            cipher = $7gM1u.nodeCrypto.createCipheriv(alg, key, iv);
        } catch (err) {
            throw new Error("unsupported algorithm: " + alg);
        }
        if ("function" !== typeof cipher.setAAD) throw new Error("unsupported algorithm: " + alg);
        if (adata.length) cipher.setAAD(adata);
        var cdata = $c4399c5b7f632bd5$require$Buffer.concat([
            cipher.update(pdata),
            cipher.final()
        ]);
        var tag = cipher.getAuthTag();
        return prepareResults({
            data: cdata,
            iv: iv,
            tag: tag
        });
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $c4399c5b7f632bd5$var$gcmDecryptFN(size) {
    function commonChecks(key, iv, tag) {
        if (size !== key.length << 3) throw new Error("invalid key size");
        if (12 !== iv.length) throw new Error("invalid iv");
        if (16 !== tag.length) throw new Error("invalid tag length");
    }
    // ### fallback implementation -- uses forge
    var fallback = function(key, cdata, props) {
        var adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0), iv = props.iv || $c4399c5b7f632bd5$require$Buffer.alloc(0), tag = props.tag || props.mac || $c4399c5b7f632bd5$require$Buffer.alloc(0), cipher, pdata;
        // validate inputs
        try {
            commonChecks(key, iv, tag);
        } catch (err) {
            return Promise.reject(err);
        }
        // setup cipher
        cipher = $7MhM2.createDecipher({
            key: key,
            iv: iv,
            additionalData: adata,
            tag: tag
        });
        // plaintext is the same length as ciphertext
        pdata = $c4399c5b7f632bd5$require$Buffer.alloc(cdata.length);
        var promise = new Promise(function(resolve, reject) {
            var amt = $1YNha.CHUNK_SIZE, plen = 0, coff = 0;
            (function doChunk() {
                var clen = Math.min(amt, cdata.length - coff);
                plen += cipher.update(cdata, coff, clen, pdata, plen);
                coff += clen;
                if (cdata.length > coff) {
                    setTimeout(doChunk, 0);
                    return;
                }
                try {
                    plen += cipher.finish(pdata, plen);
                } catch (err) {
                    reject(new Error("decryption failed"));
                    return;
                }
                if (plen !== cdata.length) {
                    reject(new Error("decryption failed"));
                    return;
                }
                // resolve with output
                resolve(pdata);
            })();
        });
        return promise;
    };
    // ### WebCryptoAPI implementation
    // TODO: cache CryptoKey sooner
    var webcrypto = function(key, cdata, props) {
        var adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0), iv = props.iv || $c4399c5b7f632bd5$require$Buffer.alloc(0), tag = props.tag || props.mac || $c4399c5b7f632bd5$require$Buffer.alloc(0);
        // validate inputs
        try {
            commonChecks(key, iv, tag);
        } catch (err) {
            return Promise.reject(err);
        }
        var alg = {
            name: "AES-GCM"
        };
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
            "decrypt"
        ]);
        promise = promise.then(function(key) {
            alg.iv = iv;
            alg.tagLength = 128;
            if (adata.length) alg.additionalData = adata;
            // concatenate cdata and tag
            cdata = $c4399c5b7f632bd5$require$Buffer.concat([
                cdata,
                tag
            ], cdata.length + tag.length);
            return $7gM1u.subtleCrypto.decrypt(alg, key, cdata);
        });
        promise = promise.then(function(pdata) {
            pdata = $c4399c5b7f632bd5$require$Buffer.from(pdata);
            return pdata;
        });
        return promise;
    };
    var nodejs = function(key, cdata, props) {
        var adata = props.aad || props.adata || $c4399c5b7f632bd5$require$Buffer.alloc(0), iv = props.iv || $c4399c5b7f632bd5$require$Buffer.alloc(0), tag = props.tag || props.mac || $c4399c5b7f632bd5$require$Buffer.alloc(0);
        // validate inputs
        try {
            commonChecks(key, iv, tag);
        } catch (err) {
            return Promise.reject(err);
        }
        var alg = "aes-" + key.length * 8 + "-gcm";
        var cipher;
        try {
            cipher = $7gM1u.nodeCrypto.createDecipheriv(alg, key, iv);
        } catch (err) {
            throw new Error("unsupported algorithm: " + alg);
        }
        if ("function" !== typeof cipher.setAAD) throw new Error("unsupported algorithm: " + alg);
        cipher.setAuthTag(tag);
        if (adata.length) cipher.setAAD(adata);
        try {
            var pdata = $c4399c5b7f632bd5$require$Buffer.concat([
                cipher.update(cdata),
                cipher.final()
            ]);
            return pdata;
        } catch (err) {
            throw new Error("decryption failed");
        }
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### Public API
// * [name].encrypt
// * [name].decrypt
var $c4399c5b7f632bd5$var$aesGcm = {};
[
    "A128GCM",
    "A192GCM",
    "A256GCM",
    "A128GCMKW",
    "A192GCMKW",
    "A256GCMKW"
].forEach(function(alg) {
    var parts = /A(\d+)GCM(KW)?/g.exec(alg);
    var size = parseInt(parts[1]);
    var wrap = parts[2] === "KW";
    $c4399c5b7f632bd5$var$aesGcm[alg] = {
        encrypt: $c4399c5b7f632bd5$var$gcmEncryptFN(size, wrap),
        decrypt: $c4399c5b7f632bd5$var$gcmDecryptFN(size, wrap)
    };
});
module.exports = $c4399c5b7f632bd5$var$aesGcm;

});
parcelRegister("7MhM2", function(module, exports) {
/*!
 * deps/ciphermodes/gcm/index.js - AES-GCM implementation Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $5a9acd952112d763$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $lkntF = parcelRequire("lkntF");

var $as9F1 = parcelRequire("as9F1");

var $aANAM = parcelRequire("aANAM");

var $5EhDd = parcelRequire("5EhDd");

var $5f7Xh = parcelRequire("5f7Xh");

var $7y5jX = parcelRequire("7y5jX");

var $73rhU = parcelRequire("73rhU");
var $5a9acd952112d763$var$BLOCK_SIZE = 16;
// ### GCM Mode
// ### Constructor
function $5a9acd952112d763$var$Gcm(options) {
    options = options || {};
    this.name = "GCM";
    this.cipher = options.cipher;
    this.blockSize = this.blockSize || 16;
}
// ### exports
module.exports = {
    createCipher: function(options) {
        var alg = new $as9F1.aes.Algorithm("AES-GCM", $5a9acd952112d763$var$Gcm);
        alg.initialize({
            key: new $7y5jX(options.key)
        });
        alg.mode.start(options);
        return alg.mode;
    },
    createDecipher: function(options) {
        var alg = new $as9F1.aes.Algorithm("AES-GCM", $5a9acd952112d763$var$Gcm);
        alg.initialize({
            key: new $7y5jX(options.key)
        });
        alg.mode._decrypt = true;
        alg.mode.start(options);
        return alg.mode;
    }
};
// ### Public API
$5a9acd952112d763$var$Gcm.prototype.start = function(options) {
    this.tag = null;
    options = options || {};
    if (!("iv" in options)) throw new Error("Gcm needs ParametersWithIV or AEADParameters");
    this.nonce = options.iv;
    if (this.nonce == null || this.nonce.length < 1) throw new Error("IV must be at least 1 byte");
    // TODO: variable tagLength?
    this.tagLength = 16;
    // TODO: validate tag
    if ("tag" in options) this.tag = $5a9acd952112d763$require$Buffer.from(options.tag);
    var bufLength = !this._decrypt ? this.blockSize : this.blockSize + this.tagLength;
    this.bufBlock = $5a9acd952112d763$require$Buffer.alloc(bufLength);
    var multiplier = options.multiplier;
    if (multiplier == null) multiplier = new $aANAM["8k"]();
    this.multiplier = multiplier;
    this.H = this.zeroBlock();
    $73rhU.encrypt(this.cipher, this.H, 0, this.H, 0);
    // GcmMultiplier tables don"t change unless the key changes
    // (and are expensive to init)
    this.multiplier.init(this.H);
    this.exp = null;
    this.J0 = this.zeroBlock();
    if (this.nonce.length === 12) {
        this.nonce.copy(this.J0, 0, 0, this.nonce.length);
        this.J0[this.blockSize - 1] = 0x01;
    } else {
        this.gHASH(this.J0, this.nonce, this.nonce.length);
        var X = this.zeroBlock();
        $5f7Xh.longToBigEndian(new $lkntF(this.nonce.length).multiply(8), X, 8);
        this.gHASHBlock(this.J0, X);
    }
    this.S = this.zeroBlock();
    this.SAt = this.zeroBlock();
    this.SAtPre = this.zeroBlock();
    this.atBlock = this.zeroBlock();
    this.atBlockPos = 0;
    this.atLength = $lkntF.ZERO;
    this.atLengthPre = $lkntF.ZERO;
    this.counter = $5a9acd952112d763$require$Buffer.from(this.J0);
    this.bufOff = 0;
    this.totalLength = $lkntF.ZERO;
    if ("additionalData" in options) this.processAADBytes(options.additionalData, 0, options.additionalData.length);
};
$5a9acd952112d763$var$Gcm.prototype.update = function(inV, inOff, len, out, outOff) {
    var resultLen = 0;
    while(len > 0){
        var inLen = Math.min(len, this.bufBlock.length - this.bufOff);
        inV.copy(this.bufBlock, this.bufOff, inOff, inOff + inLen);
        len -= inLen;
        inOff += inLen;
        this.bufOff += inLen;
        if (this.bufOff === this.bufBlock.length) {
            this.outputBlock(out, outOff + resultLen);
            resultLen += this.blockSize;
        }
    }
    return resultLen;
};
$5a9acd952112d763$var$Gcm.prototype.finish = function(out, outOff) {
    var resultLen = 0;
    if (this._decrypt) // append tag
    resultLen += this.update(this.tag, 0, this.tag.length, out, outOff);
    if (this.totalLength.isZero()) this.initCipher();
    var extra = this.bufOff;
    if (this._decrypt) {
        if (extra < this.tagLength) throw new Error("data too short");
        extra -= this.tagLength;
    }
    if (extra > 0) {
        this.gCTRPartial(this.bufBlock, 0, extra, out, outOff + resultLen);
        resultLen += extra;
    }
    this.atLength = this.atLength.add(this.atBlockPos);
    // Final gHASH
    var X = this.zeroBlock();
    $5f7Xh.longToBigEndian(this.atLength.multiply(8), X, 0);
    $5f7Xh.longToBigEndian(this.totalLength.multiply(8), X, 8);
    this.gHASHBlock(this.S, X);
    // TODO Fix this if tagLength becomes configurable
    // T = MSBt(GCTRk(J0,S))
    var tag = $5a9acd952112d763$require$Buffer.alloc(this.blockSize);
    $73rhU.encrypt(this.cipher, this.J0, 0, tag, 0);
    this.xor(tag, this.S);
    if (this._decrypt) {
        if (!$5EhDd.arrayEqual(this.tag, tag)) throw new Error("mac check in Gcm failed");
    } else {
        // We place into tag our calculated value for T
        this.tag = $5a9acd952112d763$require$Buffer.alloc(this.tagLength);
        tag.copy(this.tag, 0, 0, this.tagLength);
    }
    return resultLen;
};
// ### "Internal" Helper Functions
$5a9acd952112d763$var$Gcm.prototype.initCipher = function() {
    if (this.atLength.greaterThan($lkntF.ZERO)) {
        this.SAt.copy(this.SAtPre, 0, 0, this.blockSize);
        this.atLengthPre = this.atLength.add($lkntF.ZERO);
    }
    // Finish hash for partial AAD block
    if (this.atBlockPos > 0) {
        this.gHASHPartial(this.SAtPre, this.atBlock, 0, this.atBlockPos);
        this.atLengthPre = this.atLengthPre.add(this.atBlockPos);
    }
    if (this.atLengthPre.greaterThan($lkntF.ZERO)) this.SAtPre.copy(this.S, 0, 0, this.blockSize);
};
$5a9acd952112d763$var$Gcm.prototype.outputBlock = function(output, offset) {
    if (this.totalLength.isZero()) this.initCipher();
    this.gCTRBlock(this.bufBlock, output, offset);
    if (!this._decrypt) this.bufOff = 0;
    else {
        this.bufBlock.copy(this.bufBlock, 0, this.blockSize, this.blockSize + this.tagLength);
        this.bufOff = this.tagLength;
    }
};
$5a9acd952112d763$var$Gcm.prototype.processAADBytes = function(inV, inOff, len) {
    for(var i = 0; i < len; ++i){
        this.atBlock[this.atBlockPos] = inV[inOff + i];
        if (++this.atBlockPos === this.blockSize) {
            // Hash each block as it fills
            this.gHASHBlock(this.SAt, this.atBlock);
            this.atBlockPos = 0;
            this.atLength = this.atLength.add(this.blockSize);
        }
    }
};
$5a9acd952112d763$var$Gcm.prototype.getNextCounterBlock = function() {
    for(var i = 15; i >= 12; --i){
        var b = this.counter[i] + 1 & 0xff;
        this.counter[i] = b;
        if (b !== 0) break;
    }
    // encrypt counter
    var outb = $5a9acd952112d763$require$Buffer.alloc(this.blockSize);
    $73rhU.encrypt(this.cipher, this.counter, 0, outb, 0);
    return outb;
};
$5a9acd952112d763$var$Gcm.prototype.gCTRBlock = function(block, out, outOff) {
    var tmp = this.getNextCounterBlock();
    this.xor(tmp, block);
    tmp.copy(out, outOff, 0, this.blockSize);
    this.gHASHBlock(this.S, !this._decrypt ? tmp : block);
    this.totalLength = this.totalLength.add(this.blockSize);
};
$5a9acd952112d763$var$Gcm.prototype.gCTRPartial = function(buf, off, len, out, outOff) {
    var tmp = this.getNextCounterBlock();
    this.xor(tmp, buf, off, len);
    tmp.copy(out, outOff, 0, len);
    this.gHASHPartial(this.S, !this._decrypt ? tmp : buf, 0, len);
    this.totalLength = this.totalLength.add(len);
};
$5a9acd952112d763$var$Gcm.prototype.gHASHBlock = function(Y, b) {
    this.xor(Y, b);
    this.multiplier.multiplyH(Y);
};
$5a9acd952112d763$var$Gcm.prototype.gHASHPartial = function(Y, b, off, len) {
    this.xor(Y, b, off, len);
    this.multiplier.multiplyH(Y);
};
$5a9acd952112d763$var$Gcm.prototype.xor = function(block, val, off, len) {
    switch(arguments.length){
        case 2:
            for(var i = 15; i >= 0; --i)block[i] ^= val[i];
            break;
        case 4:
            while(len-- > 0)block[len] ^= val[off + len];
            break;
        default:
            throw new TypeError("Expected 2 or 4 arguments.");
    }
    return block;
};
$5a9acd952112d763$var$Gcm.prototype.zeroBlock = function() {
    var block = $5a9acd952112d763$require$Buffer.alloc($5a9acd952112d763$var$BLOCK_SIZE);
    return block;
};

});
parcelRegister("lkntF", function(module, exports) {
// GENERATED FILE. DO NOT EDIT.
var $f86dad645c495d09$var$Long = function(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = void 0;
    /**
   * @license
   * Copyright 2009 The Closure Library Authors
   * Copyright 2020 Daniel Wirtz / The long.js Authors.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *
   * SPDX-License-Identifier: Apache-2.0
   */ // WebAssembly optimizations to do native i64 multiplication and divide
    var wasm = null;
    try {
        wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
            0,
            97,
            115,
            109,
            1,
            0,
            0,
            0,
            1,
            13,
            2,
            96,
            0,
            1,
            127,
            96,
            4,
            127,
            127,
            127,
            127,
            1,
            127,
            3,
            7,
            6,
            0,
            1,
            1,
            1,
            1,
            1,
            6,
            6,
            1,
            127,
            1,
            65,
            0,
            11,
            7,
            50,
            6,
            3,
            109,
            117,
            108,
            0,
            1,
            5,
            100,
            105,
            118,
            95,
            115,
            0,
            2,
            5,
            100,
            105,
            118,
            95,
            117,
            0,
            3,
            5,
            114,
            101,
            109,
            95,
            115,
            0,
            4,
            5,
            114,
            101,
            109,
            95,
            117,
            0,
            5,
            8,
            103,
            101,
            116,
            95,
            104,
            105,
            103,
            104,
            0,
            0,
            10,
            191,
            1,
            6,
            4,
            0,
            35,
            0,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            126,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            127,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            128,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            129,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            130,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11
        ])), {}).exports;
    } catch (e) {}
    /**
   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
   *  See the from* functions below for more convenient ways of constructing Longs.
   * @exports Long
   * @class A Long class for representing a 64 bit two's-complement integer value.
   * @param {number} low The low (signed) 32 bits of the long
   * @param {number} high The high (signed) 32 bits of the long
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @constructor
   */ function Long(low, high, unsigned) {
        /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
        /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
        /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
    } // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.
    /**
   * An indicator used to reliably determine if an object is a Long or not.
   * @type {boolean}
   * @const
   * @private
   */ Long.prototype.__isLong__;
    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true
    });
    /**
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   * @inner
   */ function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    }
    /**
   * @function
   * @param {*} value number
   * @returns {number}
   * @inner
   */ function ctz32(value) {
        var c = Math.clz32(value & -value);
        return value ? 31 - c : c;
    }
    /**
   * Tests if the specified object is a Long.
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   */ Long.isLong = isLong;
    /**
   * A cache of the Long representations of small integer values.
   * @type {!Object}
   * @inner
   */ var INT_CACHE = {};
    /**
   * A cache of the Long representations of small unsigned integer values.
   * @type {!Object}
   * @inner
   */ var UINT_CACHE = {};
    /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromInt(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, 0, true);
            if (cache) UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) INT_CACHE[value] = obj;
            return obj;
        }
    }
    /**
   * Returns a Long representing the given 32 bit integer value.
   * @function
   * @param {number} value The 32 bit integer in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromInt = fromInt;
    /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromNumber(value, unsigned) {
        if (isNaN(value)) return unsigned ? UZERO : ZERO;
        if (unsigned) {
            if (value < 0) return UZERO;
            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
        }
        if (value < 0) return fromNumber(-value, unsigned).neg();
        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
    }
    /**
   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
   * @function
   * @param {number} value The number in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromNumber = fromNumber;
    /**
   * @param {number} lowBits
   * @param {number} highBits
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    }
    /**
   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
   *  assumed to use 32 bits.
   * @function
   * @param {number} lowBits The low 32 bits
   * @param {number} highBits The high 32 bits
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromBits = fromBits;
    /**
   * @function
   * @param {number} base
   * @param {number} exponent
   * @returns {number}
   * @inner
   */ var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
    /**
   * @param {string} str
   * @param {(boolean|number)=} unsigned
   * @param {number=} radix
   * @returns {!Long}
   * @inner
   */ function fromString(str, unsigned, radix) {
        if (str.length === 0) throw Error("empty string");
        if (typeof unsigned === "number") {
            // For goog.math.long compatibility
            radix = unsigned;
            unsigned = false;
        } else unsigned = !!unsigned;
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? UZERO : ZERO;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        var p;
        if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
        else if (p === 0) return fromString(str.substring(1), unsigned, radix).neg();
         // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 8));
        var result = ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = fromNumber(pow_dbl(radix, size));
                result = result.mul(power).add(fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    }
    /**
   * Returns a Long representation of the given string, written using the specified radix.
   * @function
   * @param {string} str The textual representation of the Long
   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
   * @returns {!Long} The corresponding Long value
   */ Long.fromString = fromString;
    /**
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromValue(val, unsigned) {
        if (typeof val === "number") return fromNumber(val, unsigned);
        if (typeof val === "string") return fromString(val, unsigned); // Throws for non-objects, converts non-instanceof Long:
        return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
    }
    /**
   * Converts the specified value to a Long using the appropriate from* function for its type.
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long}
   */ Long.fromValue = fromValue; // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_16_DBL = 65536;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_24_DBL = 16777216;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
    /**
   * @type {!Long}
   * @const
   * @inner
   */ var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
    /**
   * @type {!Long}
   * @inner
   */ var ZERO = fromInt(0);
    /**
   * Signed zero.
   * @type {!Long}
   */ Long.ZERO = ZERO;
    /**
   * @type {!Long}
   * @inner
   */ var UZERO = fromInt(0, true);
    /**
   * Unsigned zero.
   * @type {!Long}
   */ Long.UZERO = UZERO;
    /**
   * @type {!Long}
   * @inner
   */ var ONE = fromInt(1);
    /**
   * Signed one.
   * @type {!Long}
   */ Long.ONE = ONE;
    /**
   * @type {!Long}
   * @inner
   */ var UONE = fromInt(1, true);
    /**
   * Unsigned one.
   * @type {!Long}
   */ Long.UONE = UONE;
    /**
   * @type {!Long}
   * @inner
   */ var NEG_ONE = fromInt(-1);
    /**
   * Signed negative one.
   * @type {!Long}
   */ Long.NEG_ONE = NEG_ONE;
    /**
   * @type {!Long}
   * @inner
   */ var MAX_VALUE = fromBits(-1, 2147483647, false);
    /**
   * Maximum signed value.
   * @type {!Long}
   */ Long.MAX_VALUE = MAX_VALUE;
    /**
   * @type {!Long}
   * @inner
   */ var MAX_UNSIGNED_VALUE = fromBits(-1, -1, true);
    /**
   * Maximum unsigned value.
   * @type {!Long}
   */ Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
    /**
   * @type {!Long}
   * @inner
   */ var MIN_VALUE = fromBits(0, -2147483648, false);
    /**
   * Minimum signed value.
   * @type {!Long}
   */ Long.MIN_VALUE = MIN_VALUE;
    /**
   * @alias Long.prototype
   * @inner
   */ var LongPrototype = Long.prototype;
    /**
   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /**
   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.toNumber = function toNumber() {
        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /**
   * Converts the Long to a string written in the specified radix.
   * @this {!Long}
   * @param {number=} radix Radix (2-36), defaults to 10
   * @returns {string}
   * @override
   * @throws {RangeError} If `radix` is out of range
   */ LongPrototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return "-" + this.neg().toString(radix);
        } // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
        var result = "";
        while(true){
            var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = "0" + digits;
                result = "" + digits + result;
            }
        }
    };
    /**
   * Gets the high 32 bits as a signed integer.
   * @this {!Long}
   * @returns {number} Signed high bits
   */ LongPrototype.getHighBits = function getHighBits() {
        return this.high;
    };
    /**
   * Gets the high 32 bits as an unsigned integer.
   * @this {!Long}
   * @returns {number} Unsigned high bits
   */ LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };
    /**
   * Gets the low 32 bits as a signed integer.
   * @this {!Long}
   * @returns {number} Signed low bits
   */ LongPrototype.getLowBits = function getLowBits() {
        return this.low;
    };
    /**
   * Gets the low 32 bits as an unsigned integer.
   * @this {!Long}
   * @returns {number} Unsigned low bits
   */ LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };
    /**
   * Gets the number of bits needed to represent the absolute value of this Long.
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };
    /**
   * Tests if this Long's value equals zero.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };
    /**
   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
   * @returns {boolean}
   */ LongPrototype.eqz = LongPrototype.isZero;
    /**
   * Tests if this Long's value is negative.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };
    /**
   * Tests if this Long's value is positive or zero.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };
    /**
   * Tests if this Long's value is odd.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };
    /**
   * Tests if this Long's value is even.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };
    /**
   * Tests if this Long's value equals the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.equals = function equals(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /**
   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.eq = LongPrototype.equals;
    /**
   * Tests if this Long's value differs from the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.notEquals = function notEquals(other) {
        return !this.eq(/* validates */ other);
    };
    /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.neq = LongPrototype.notEquals;
    /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.ne = LongPrototype.notEquals;
    /**
   * Tests if this Long's value is less than the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lessThan = function lessThan(other) {
        return this.comp(/* validates */ other) < 0;
    };
    /**
   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lt = LongPrototype.lessThan;
    /**
   * Tests if this Long's value is less than or equal the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.comp(/* validates */ other) <= 0;
    };
    /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lte = LongPrototype.lessThanOrEqual;
    /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.le = LongPrototype.lessThanOrEqual;
    /**
   * Tests if this Long's value is greater than the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.greaterThan = function greaterThan(other) {
        return this.comp(/* validates */ other) > 0;
    };
    /**
   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.gt = LongPrototype.greaterThan;
    /**
   * Tests if this Long's value is greater than or equal the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.comp(/* validates */ other) >= 0;
    };
    /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.gte = LongPrototype.greaterThanOrEqual;
    /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.ge = LongPrototype.greaterThanOrEqual;
    /**
   * Compares this Long's value with the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */ LongPrototype.compare = function compare(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1; // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1; // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /**
   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */ LongPrototype.comp = LongPrototype.compare;
    /**
   * Negates this Long's value.
   * @this {!Long}
   * @returns {!Long} Negated Long
   */ LongPrototype.negate = function negate() {
        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
        return this.not().add(ONE);
    };
    /**
   * Negates this Long's value. This is an alias of {@link Long#negate}.
   * @function
   * @returns {!Long} Negated Long
   */ LongPrototype.neg = LongPrototype.negate;
    /**
   * Returns the sum of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} addend Addend
   * @returns {!Long} Sum
   */ LongPrototype.add = function add(addend) {
        if (!isLong(addend)) addend = fromValue(addend); // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xFFFF;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xFFFF;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 + b48;
        c48 &= 0xFFFF;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
   * Returns the difference of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */ LongPrototype.subtract = function subtract(subtrahend) {
        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /**
   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
   * @function
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */ LongPrototype.sub = LongPrototype.subtract;
    /**
   * Returns the product of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */ LongPrototype.multiply = function multiply(multiplier) {
        if (this.isZero()) return this;
        if (!isLong(multiplier)) multiplier = fromValue(multiplier); // use wasm support if present
        if (wasm) {
            var low = wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (multiplier.isZero()) return this.unsigned ? UZERO : ZERO;
        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg(); // If both longs are small, use float multiplication
        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned); // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xFFFF;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xFFFF;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xFFFF;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
   * @function
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */ LongPrototype.mul = LongPrototype.multiply;
    /**
   * Returns this Long divided by the specified. The result is signed if this Long is signed or
   *  unsigned if this Long is unsigned.
   * @this {!Long}
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */ LongPrototype.divide = function divide(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        if (divisor.isZero()) throw Error("division by zero"); // use wasm support if present
        if (wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(MIN_VALUE)) {
                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                else if (divisor.eq(MIN_VALUE)) return ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(ZERO)) return divisor.isNegative() ? ONE : NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return UZERO;
            if (divisor.gt(this.shru(1))) return UONE;
            res = UZERO;
        } // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber())); // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            } // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**
   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */ LongPrototype.div = LongPrototype.divide;
    /**
   * Returns this Long modulo the specified.
   * @this {!Long}
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.modulo = function modulo(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor); // use wasm support if present
        if (wasm) {
            var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.mod = LongPrototype.modulo;
    /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.rem = LongPrototype.modulo;
    /**
   * Returns the bitwise NOT of this Long.
   * @this {!Long}
   * @returns {!Long}
   */ LongPrototype.not = function not() {
        return fromBits(~this.low, ~this.high, this.unsigned);
    };
    /**
   * Returns count leading zeros of this Long.
   * @this {!Long}
   * @returns {!number}
   */ LongPrototype.countLeadingZeros = function countLeadingZeros() {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
    };
    /**
   * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
   * @function
   * @param {!Long}
   * @returns {!number}
   */ LongPrototype.clz = LongPrototype.countLeadingZeros;
    /**
   * Returns count trailing zeros of this Long.
   * @this {!Long}
   * @returns {!number}
   */ LongPrototype.countTrailingZeros = function countTrailingZeros() {
        return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
    };
    /**
   * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
   * @function
   * @param {!Long}
   * @returns {!number}
   */ LongPrototype.ctz = LongPrototype.countTrailingZeros;
    /**
   * Returns the bitwise AND of this Long and the specified.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.and = function and(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
   * Returns the bitwise OR of this Long and the specified.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.or = function or(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
   * Returns the bitwise XOR of this Long and the given one.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.xor = function xor(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /**
   * Returns this Long with bits shifted to the left by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftLeft = function shiftLeft(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /**
   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shl = LongPrototype.shiftLeft;
    /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftRight = function shiftRight(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shr = LongPrototype.shiftRight;
    /**
   * Returns this Long with bits logically shifted to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
        if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
        return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
    };
    /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shru = LongPrototype.shiftRightUnsigned;
    /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
    /**
   * Returns this Long with bits rotated to the left by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotateLeft = function rotateLeft(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
    };
    /**
   * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotl = LongPrototype.rotateLeft;
    /**
   * Returns this Long with bits rotated to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotateRight = function rotateRight(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
    };
    /**
   * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotr = LongPrototype.rotateRight;
    /**
   * Converts this Long to signed.
   * @this {!Long}
   * @returns {!Long} Signed long
   */ LongPrototype.toSigned = function toSigned() {
        if (!this.unsigned) return this;
        return fromBits(this.low, this.high, false);
    };
    /**
   * Converts this Long to unsigned.
   * @this {!Long}
   * @returns {!Long} Unsigned long
   */ LongPrototype.toUnsigned = function toUnsigned() {
        if (this.unsigned) return this;
        return fromBits(this.low, this.high, true);
    };
    /**
   * Converts this Long to its byte representation.
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @this {!Long}
   * @returns {!Array.<number>} Byte representation
   */ LongPrototype.toBytes = function toBytes(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
   * Converts this Long to its little endian byte representation.
   * @this {!Long}
   * @returns {!Array.<number>} Little endian byte representation
   */ LongPrototype.toBytesLE = function toBytesLE() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
   * Converts this Long to its big endian byte representation.
   * @this {!Long}
   * @returns {!Array.<number>} Big endian byte representation
   */ LongPrototype.toBytesBE = function toBytesBE() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
   * Creates a Long from its byte representation.
   * @param {!Array.<number>} bytes Byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {Long} The corresponding Long value
   */ Long.fromBytes = function fromBytes(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
   * Creates a Long from its little endian byte representation.
   * @param {!Array.<number>} bytes Little endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */ Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
   * Creates a Long from its big endian byte representation.
   * @param {!Array.<number>} bytes Big endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */ Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    var _default = Long;
    exports.default = _default;
    return "default" in exports ? exports.default : exports;
}({});
if (typeof define === "function" && define.amd) define([], function() {
    return $f86dad645c495d09$var$Long;
});
else module.exports = $f86dad645c495d09$var$Long;

});

parcelRegister("aANAM", function(module, exports) {
/*!
 * deps/ciphermodes/gcm/multipliers.js - AES-GCM Multipliers
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";

var $5EhDd = parcelRequire("5EhDd");

var $5f7Xh = parcelRequire("5f7Xh");
// ### 8K Table Multiplier
function $7b63bc24fec93452$var$Gcm8KMultiplier() {
    this.H = [];
    this.M = null;
}
$7b63bc24fec93452$var$Gcm8KMultiplier.prototype.init = function(H) {
    var i, j, k;
    if (this.M == null) {
        // sc: I realize this UGLY...
        //M = new int[32][16][4];
        this.M = [];
        for(i = 0; i < 32; ++i){
            this.M[i] = [];
            for(j = 0; j < 16; ++j){
                this.M[i][j] = [];
                for(k = 0; k < 4; ++k)this.M[i][j][k] = 0;
            }
        }
    } else if ($5EhDd.arrayEqual(this.H, H)) return;
    this.H = H.slice();
    // M[0][0] is ZEROES;
    // M[1][0] is ZEROES;
    $5EhDd.asInts(H, this.M[1][8]);
    for(j = 4; j >= 1; j >>= 1)$5EhDd.multiplyP(this.M[1][j + j], this.M[1][j]);
    $5EhDd.multiplyP(this.M[1][1], this.M[0][8]);
    for(j = 4; j >= 1; j >>= 1)$5EhDd.multiplyP(this.M[0][j + j], this.M[0][j]);
    i = 0;
    for(;;){
        for(j = 2; j < 16; j += j)for(k = 1; k < j; ++k)$5EhDd.xor(this.M[i][j], this.M[i][k], this.M[i][j + k]);
        if (++i === 32) return;
        if (i > 1) // M[i][0] is ZEROES;
        for(j = 8; j > 0; j >>= 1)$5EhDd.multiplyP8(this.M[i - 2][j], this.M[i][j]);
    }
};
$7b63bc24fec93452$var$Gcm8KMultiplier.prototype.multiplyH = function(x) {
    var z = [];
    for(var i = 15; i >= 0; --i){
        var m = this.M[i + i][x[i] & 0x0f];
        z[0] ^= m[0];
        z[1] ^= m[1];
        z[2] ^= m[2];
        z[3] ^= m[3];
        m = this.M[i + i + 1][(x[i] & 0xf0) >>> 4];
        z[0] ^= m[0];
        z[1] ^= m[1];
        z[2] ^= m[2];
        z[3] ^= m[3];
    }
    $5f7Xh.intToBigEndian(z, x, 0);
};
module.exports = {
    "8k": $7b63bc24fec93452$var$Gcm8KMultiplier
};

});
parcelRegister("5EhDd", function(module, exports) {
/*!
 * deps/ciphermodes/gcm/helpers.js - AES-GCM Helper Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $41ce5d682e4f1f81$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $lkntF = parcelRequire("lkntF");

var $eoBtM = parcelRequire("eoBtM");

var $5f7Xh = parcelRequire("5f7Xh");
var $41ce5d682e4f1f81$var$E1 = 0xe1000000, $41ce5d682e4f1f81$var$E1B = 0xe1, $41ce5d682e4f1f81$var$E1L = new $lkntF($41ce5d682e4f1f81$var$E1 >> 8);
function $41ce5d682e4f1f81$var$generateLookup() {
    var lookup = [];
    for(var c = 0; c < 256; ++c){
        var v = 0;
        for(var i = 7; i >= 0; --i)if ((c & 1 << i) !== 0) v ^= $41ce5d682e4f1f81$var$E1 >>> 7 - i;
        lookup.push(v);
    }
    return lookup;
}
var $41ce5d682e4f1f81$var$helpers = module.exports = {
    // ### Constants
    E1: $41ce5d682e4f1f81$var$E1,
    E1B: $41ce5d682e4f1f81$var$E1B,
    E1L: $41ce5d682e4f1f81$var$E1L,
    LOOKUP: $41ce5d682e4f1f81$var$generateLookup(),
    // ### Array Helpers
    arrayCopy: function(src, srcPos, dest, destPos, length) {
        // Start by checking for negatives since arrays in JS auto-expand
        if (srcPos < 0 || destPos < 0 || length < 0) throw new TypeError("Invalid input.");
        if (dest instanceof Uint8Array) {
            // Check for overflow if dest is a typed-array
            if (destPos >= dest.length || destPos + length > dest.length) throw new TypeError("Invalid input.");
            if (srcPos !== 0 || length < src.length) {
                if (src instanceof Uint8Array) src = src.subarray(srcPos, srcPos + length);
                else src = src.slice(srcPos, srcPos + length);
            }
            dest.set(src, destPos);
        } else for(var i = 0; i < length; ++i)dest[destPos + i] = src[srcPos + i];
    },
    arrayEqual: function(a1, a2) {
        a1 = a1 || [];
        a2 = a2 || [];
        var len = Math.min(a1.length, a2.length), result = a1.length === a2.length;
        for(var idx = 0; idx < len; idx++)result = result && "undefined" !== typeof a1[idx] && "undefined" !== typeof a2[idx] && a1[idx] === a2[idx];
        return result;
    },
    // ### Conversions
    asBytes: function(x, z) {
        switch(arguments.length){
            case 1:
                z = $41ce5d682e4f1f81$require$Buffer.alloc(16);
                $5f7Xh.intToBigEndian(x, z, 0);
                return z;
            case 2:
                $5f7Xh.intToBigEndian(x, z, 0);
                break;
            default:
                throw new TypeError("Expected 1 or 2 arguments.");
        }
    },
    asInts: function(x, z) {
        switch(arguments.length){
            case 1:
                z = [];
                $eoBtM(z, 0, 0, 4);
                $5f7Xh.bigEndianToInt(x, 0, z);
                return z;
            case 2:
                $5f7Xh.bigEndianToInt(x, 0, z);
                break;
            default:
                throw new TypeError("Expected 1 or 2 arguments.");
        }
    },
    oneAsInts: function() {
        var tmp = [];
        for(var c = 0; c < 4; ++c)tmp.push(-2147483648);
        return tmp;
    },
    // ## Bit-wise
    shiftRight: function(x, z) {
        var b, c;
        switch(arguments.length){
            case 1:
                b = x[0];
                x[0] = b >>> 1;
                c = b << 31;
                b = x[1];
                x[1] = b >>> 1 | c;
                c = b << 31;
                b = x[2];
                x[2] = b >>> 1 | c;
                c = b << 31;
                b = x[3];
                x[3] = b >>> 1 | c;
                return b << 31 & 0xffffffff;
            case 2:
                b = x[0];
                z[0] = b >>> 1;
                c = b << 31;
                b = x[1];
                z[1] = b >>> 1 | c;
                c = b << 31;
                b = x[2];
                z[2] = b >>> 1 | c;
                c = b << 31;
                b = x[3];
                z[3] = b >>> 1 | c;
                return b << 31 & 0xffffffff;
            default:
                throw new TypeError("Expected 1 or 2 arguments.");
        }
    },
    shiftRightN: function(x, n, z) {
        var nInv, b, c;
        switch(arguments.length){
            case 2:
                b = x[0];
                nInv = 32 - n;
                x[0] = b >>> n;
                c = b << nInv;
                b = x[1];
                x[1] = b >>> n | c;
                c = b << nInv;
                b = x[2];
                x[2] = b >>> n | c;
                c = b << nInv;
                b = x[3];
                x[3] = b >>> n | c;
                return b << nInv;
            case 3:
                b = x[0];
                nInv = 32 - n;
                z[0] = b >>> n;
                c = b << nInv;
                b = x[1];
                z[1] = b >>> n | c;
                c = b << nInv;
                b = x[2];
                z[2] = b >>> n | c;
                c = b << nInv;
                b = x[3];
                z[3] = b >>> n | c;
                return b << nInv;
            default:
                throw new TypeError("Expected 2 or 3 arguments.");
        }
    },
    xor: function(x, y, z) {
        switch(arguments.length){
            case 2:
                x[0] ^= y[0];
                x[1] ^= y[1];
                x[2] ^= y[2];
                x[3] ^= y[3];
                break;
            case 3:
                z[0] = x[0] ^ y[0];
                z[1] = x[1] ^ y[1];
                z[2] = x[2] ^ y[2];
                z[3] = x[3] ^ y[3];
                break;
            default:
                throw new TypeError("Expected 2 or 3 arguments.");
        }
    },
    multiply: function(x, y) {
        var r0 = x.slice();
        var r1 = [];
        for(var i = 0; i < 4; ++i){
            var bits = y[i];
            for(var j = 31; j >= 0; --j){
                if ((bits & 1 << j) !== 0) $41ce5d682e4f1f81$var$helpers.xor(r1, r0);
                if ($41ce5d682e4f1f81$var$helpers.shiftRight(r0) !== 0) r0[0] ^= $41ce5d682e4f1f81$var$helpers.E1;
            }
        }
        $41ce5d682e4f1f81$var$helpers.arrayCopy(r1, 0, x, 0, 4);
    },
    multiplyP: function(x, y) {
        switch(arguments.length){
            case 1:
                if ($41ce5d682e4f1f81$var$helpers.shiftRight(x) !== 0) x[0] ^= $41ce5d682e4f1f81$var$helpers.E1;
                break;
            case 2:
                if ($41ce5d682e4f1f81$var$helpers.shiftRight(x, y) !== 0) y[0] ^= $41ce5d682e4f1f81$var$helpers.E1;
                break;
            default:
                throw new TypeError("Expected 1 or 2 arguments.");
        }
    },
    multiplyP8: function(x, y) {
        var c;
        switch(arguments.length){
            case 1:
                c = $41ce5d682e4f1f81$var$helpers.shiftRightN(x, 8);
                x[0] ^= $41ce5d682e4f1f81$var$helpers.LOOKUP[c >>> 24];
                break;
            case 2:
                c = $41ce5d682e4f1f81$var$helpers.shiftRightN(x, 8, y);
                y[0] ^= $41ce5d682e4f1f81$var$helpers.LOOKUP[c >>> 24];
                break;
            default:
                throw new TypeError("Expected 1 or 2 arguments.");
        }
    }
};

});
parcelRegister("eoBtM", function(module, exports) {

var $2ezZz = parcelRequire("2ezZz");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */ function $a7b0612d73a91239$var$fill(array, value, start, end) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    if (start && typeof start != "number" && $b8mN0(array, value, start)) {
        start = 0;
        end = length;
    }
    return $2ezZz(array, value, start, end);
}
module.exports = $a7b0612d73a91239$var$fill;

});
parcelRegister("2ezZz", function(module, exports) {

var $2MGGR = parcelRequire("2MGGR");

var $46sJo = parcelRequire("46sJo");
/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */ function $1a08cee077fc98c8$var$baseFill(array, value, start, end) {
    var length = array.length;
    start = $2MGGR(start);
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : $2MGGR(end);
    if (end < 0) end += length;
    end = start > end ? 0 : $46sJo(end);
    while(start < end)array[start++] = value;
    return array;
}
module.exports = $1a08cee077fc98c8$var$baseFill;

});
parcelRegister("46sJo", function(module, exports) {

var $fI3u2 = parcelRequire("fI3u2");

var $2MGGR = parcelRequire("2MGGR");
/** Used as references for the maximum length and index of an array. */ var $2fce0258317d5d8d$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */ function $2fce0258317d5d8d$var$toLength(value) {
    return value ? $fI3u2($2MGGR(value), 0, $2fce0258317d5d8d$var$MAX_ARRAY_LENGTH) : 0;
}
module.exports = $2fce0258317d5d8d$var$toLength;

});
parcelRegister("fI3u2", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $b6fdaad7ef55e8b6$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $b6fdaad7ef55e8b6$var$baseClamp;

});




parcelRegister("5f7Xh", function(module, exports) {
/*!
 * deps/ciphermodes/pack.js - Pack/Unpack Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $3d14862d956caebc$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $lkntF = parcelRequire("lkntF");
var $3d14862d956caebc$var$pack = module.exports = {
    intToBigEndian: function(n, bs, off) {
        if (typeof n === "number") switch(arguments.length){
            case 1:
                bs = $3d14862d956caebc$require$Buffer.alloc(4);
                $3d14862d956caebc$var$pack.intToBigEndian(n, bs, 0);
                break;
            case 3:
                bs[off] = 0xff & n >>> 24;
                bs[++off] = 0xff & n >>> 16;
                bs[++off] = 0xff & n >>> 8;
                bs[++off] = 0xff & n;
                break;
            default:
                throw new TypeError("Expected 1 or 3 arguments.");
        }
        else switch(arguments.length){
            case 1:
                bs = $3d14862d956caebc$require$Buffer.alloc(4 * n.length);
                $3d14862d956caebc$var$pack.intToBigEndian(n, bs, 0);
                break;
            case 3:
                for(var i = 0; i < n.length; ++i){
                    $3d14862d956caebc$var$pack.intToBigEndian(n[i], bs, off);
                    off += 4;
                }
                break;
            default:
                throw new TypeError("Expected 1 or 3 arguments.");
        }
        return bs;
    },
    longToBigEndian: function(n, bs, off) {
        if (!Array.isArray(n)) // Single
        switch(arguments.length){
            case 1:
                bs = $3d14862d956caebc$require$Buffer.alloc(8);
                $3d14862d956caebc$var$pack.longToBigEndian(n, bs, 0);
                break;
            case 3:
                var lo = n.low, hi = n.high;
                $3d14862d956caebc$var$pack.intToBigEndian(hi, bs, off);
                $3d14862d956caebc$var$pack.intToBigEndian(lo, bs, off + 4);
                break;
            default:
                throw new TypeError("Expected 1 or 3 arguments.");
        }
        else // Array
        switch(arguments.length){
            case 1:
                bs = $3d14862d956caebc$require$Buffer.alloc(8 * n.length);
                $3d14862d956caebc$var$pack.longToBigEndian(n, bs, 0);
                break;
            case 3:
                for(var i = 0; i < n.length; ++i){
                    $3d14862d956caebc$var$pack.longToBigEndian(n[i], bs, off);
                    off += 8;
                }
                break;
            default:
                throw new TypeError("Expected 1 or 3 arguments.");
        }
        return bs;
    },
    bigEndianToInt: function(bs, off, ns) {
        switch(arguments.length){
            case 2:
                var n = bs[off] << 24;
                n |= (bs[++off] & 0xff) << 16;
                n |= (bs[++off] & 0xff) << 8;
                n |= bs[++off] & 0xff;
                return n;
            case 3:
                for(var i = 0; i < ns.length; ++i){
                    ns[i] = $3d14862d956caebc$var$pack.bigEndianToInt(bs, off);
                    off += 4;
                }
                break;
            default:
                throw new TypeError("Expected 2 or 3 arguments.");
        }
    },
    bigEndianToLong: function(bs, off, ns) {
        switch(arguments.length){
            case 2:
                var hi = $3d14862d956caebc$var$pack.bigEndianToInt(bs, off);
                var lo = $3d14862d956caebc$var$pack.bigEndianToInt(bs, off + 4);
                var num = new $lkntF(lo, hi);
                return num;
            case 3:
                for(var i = 0; i < ns.length; ++i){
                    ns[i] = $3d14862d956caebc$var$pack.bigEndianToLong(bs, off);
                    off += 8;
                }
                break;
            default:
                throw new TypeError("Expected 2 or 3 arguments.");
        }
    }
};

});



parcelRegister("73rhU", function(module, exports) {
/*!
 * deps/ciphermodes/helpers.js - Cipher Helper Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";

var $5f7Xh = parcelRequire("5f7Xh");
function $522dfb00124acd91$var$doEncrypt(cipher, inb, inOff, outb, outOff) {
    var input = new Array(4), output = new Array(4);
    $5f7Xh.bigEndianToInt(inb, inOff, input);
    cipher.encrypt(input, output);
    $5f7Xh.intToBigEndian(output, outb, outOff);
}
module.exports = {
    encrypt: $522dfb00124acd91$var$doEncrypt
};

});



parcelRegister("8eyMA", function(module, exports) {
/*!
 * algorithms/aes-kw.js - AES-KW Key-Wrapping
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $5fea9cab96006e58$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $7gM1u = parcelRequire("7gM1u");

var $as9F1 = parcelRequire("as9F1");

var $7y5jX = parcelRequire("7y5jX");
var $5fea9cab96006e58$var$A0 = $5fea9cab96006e58$require$Buffer.from("a6a6a6a6a6a6a6a6", "hex");
// ### helpers
function $5fea9cab96006e58$var$xor(a, b) {
    var len = Math.max(a.length, b.length);
    var result = $5fea9cab96006e58$require$Buffer.alloc(len);
    for(var idx = 0; len > idx; idx++)result[idx] = (a[idx] || 0) ^ (b[idx] || 0);
    return result;
}
function $5fea9cab96006e58$var$split(input, size) {
    var output = [];
    for(var idx = 0; input.length > idx; idx += size)output.push(input.slice(idx, idx + size));
    return output;
}
function $5fea9cab96006e58$var$longToBigEndian(input) {
    var hi = Math.floor(input / 4294967296), lo = input % 4294967296;
    var output = $5fea9cab96006e58$require$Buffer.alloc(8);
    output[0] = 0xff & hi >>> 24;
    output[1] = 0xff & hi >>> 16;
    output[2] = 0xff & hi >>> 8;
    output[3] = 0xff & hi >>> 0;
    output[4] = 0xff & lo >>> 24;
    output[5] = 0xff & lo >>> 16;
    output[6] = 0xff & lo >>> 8;
    output[7] = 0xff & lo >>> 0;
    return output;
}
function $5fea9cab96006e58$var$kwEncryptFN(size) {
    function commonChecks(key, data) {
        if (size !== key.length << 3) throw new Error("invalid key size");
        if (0 < data.length && 0 !== data.length % 8) throw new Error("invalid data length");
    }
    // ### 'fallback' implementation -- uses forge
    var fallback = function(key, pdata) {
        try {
            commonChecks(key, pdata);
        } catch (err) {
            return Promise.reject(err);
        }
        // setup cipher
        var cipher = $as9F1.cipher.createCipher("AES", new $7y5jX(key));
        // split input into chunks
        var R = $5fea9cab96006e58$var$split(pdata, 8);
        var A, B, count;
        A = $5fea9cab96006e58$var$A0;
        for(var jdx = 0; 6 > jdx; jdx++)for(var idx = 0; R.length > idx; idx++){
            count = R.length * jdx + idx + 1;
            B = $5fea9cab96006e58$require$Buffer.concat([
                A,
                R[idx]
            ]);
            cipher.start();
            cipher.update(new $7y5jX(B));
            cipher.finish();
            B = $5fea9cab96006e58$require$Buffer.from(cipher.output.bytes(), "binary");
            A = $5fea9cab96006e58$var$xor(B.slice(0, 8), $5fea9cab96006e58$var$longToBigEndian(count));
            R[idx] = B.slice(8, 16);
        }
        R = [
            A
        ].concat(R);
        var cdata = $5fea9cab96006e58$require$Buffer.concat(R);
        return Promise.resolve({
            data: cdata
        });
    };
    // ### WebCryptoAPI implementation
    var webcrypto = function(key, pdata) {
        try {
            commonChecks(key, pdata);
        } catch (err) {
            return Promise.reject(err);
        }
        var alg = {
            name: "AES-KW"
        };
        var promise = [
            $7gM1u.subtleCrypto.importKey("raw", pdata, {
                name: "HMAC",
                hash: "SHA-256"
            }, true, [
                "sign"
            ]),
            $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
                "wrapKey"
            ])
        ];
        promise = Promise.all(promise);
        promise = promise.then(function(keys) {
            return $7gM1u.subtleCrypto.wrapKey("raw", keys[0], keys[1], alg);
        });
        promise = promise.then(function(result) {
            result = $5fea9cab96006e58$require$Buffer.from(result);
            return {
                data: result
            };
        });
        return promise;
    };
    var node = function(key, pdata) {
        try {
            commonChecks(key, pdata);
        } catch (err) {
            return Promise.reject(err);
        }
        // split input into chunks
        var R = $5fea9cab96006e58$var$split(pdata, 8), iv = $5fea9cab96006e58$require$Buffer.alloc(16);
        var A, B, count;
        A = $5fea9cab96006e58$var$A0;
        for(var jdx = 0; 6 > jdx; jdx++)for(var idx = 0; R.length > idx; idx++){
            count = R.length * jdx + idx + 1;
            B = $5fea9cab96006e58$require$Buffer.concat([
                A,
                R[idx]
            ]);
            var cipher = $7gM1u.nodeCrypto.createCipheriv("AES" + size, key, iv);
            B = cipher.update(B);
            A = $5fea9cab96006e58$var$xor(B.slice(0, 8), $5fea9cab96006e58$var$longToBigEndian(count));
            R[idx] = B.slice(8, 16);
        }
        R = [
            A
        ].concat(R);
        var cdata = $5fea9cab96006e58$require$Buffer.concat(R);
        return Promise.resolve({
            data: cdata
        });
    };
    return $7gM1u.setupFallback(node, webcrypto, fallback);
}
function $5fea9cab96006e58$var$kwDecryptFN(size) {
    function commonChecks(key, data) {
        if (size !== key.length << 3) throw new Error("invalid key size");
        if (0 < data.length - 8 && 0 !== data.length % 8) throw new Error("invalid data length");
    }
    // ### 'fallback' implementation -- uses forge
    var fallback = function(key, cdata) {
        try {
            commonChecks(key, cdata);
        } catch (err) {
            return Promise.reject(err);
        }
        // setup cipher
        var cipher = $as9F1.cipher.createDecipher("AES", new $7y5jX(key));
        // prepare inputs
        var R = $5fea9cab96006e58$var$split(cdata, 8), A, B, count;
        A = R[0];
        R = R.slice(1);
        for(var jdx = 5; 0 <= jdx; --jdx)for(var idx = R.length - 1; 0 <= idx; --idx){
            count = R.length * jdx + idx + 1;
            B = $5fea9cab96006e58$var$xor(A, $5fea9cab96006e58$var$longToBigEndian(count));
            B = $5fea9cab96006e58$require$Buffer.concat([
                B,
                R[idx]
            ]);
            cipher.start();
            cipher.update(new $7y5jX(B));
            cipher.finish();
            B = $5fea9cab96006e58$require$Buffer.from(cipher.output.bytes(), "binary");
            A = B.slice(0, 8);
            R[idx] = B.slice(8, 16);
        }
        if (A.toString() !== $5fea9cab96006e58$var$A0.toString()) return Promise.reject(new Error("decryption failed"));
        var pdata = $5fea9cab96006e58$require$Buffer.concat(R);
        return Promise.resolve(pdata);
    };
    // ### WebCryptoAPI implementation
    var webcrypto = function(key, cdata) {
        try {
            commonChecks(key, cdata);
        } catch (err) {
            return Promise.reject(err);
        }
        var alg = {
            name: "AES-KW"
        };
        var promise = $7gM1u.subtleCrypto.importKey("raw", key, alg, true, [
            "unwrapKey"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.unwrapKey("raw", cdata, key, alg, {
                name: "HMAC",
                hash: "SHA-256"
            }, true, [
                "sign"
            ]);
        });
        promise = promise.then(function(result) {
            // unwrapped CryptoKey -- extract raw
            return $7gM1u.subtleCrypto.exportKey("raw", result);
        });
        promise = promise.then(function(result) {
            result = $5fea9cab96006e58$require$Buffer.from(result);
            return result;
        });
        return promise;
    };
    var node = function(key, cdata) {
        try {
            commonChecks(key, cdata);
        } catch (err) {
            return Promise.reject(err);
        }
        // prepare inputs
        var R = $5fea9cab96006e58$var$split(cdata, 8), iv = $5fea9cab96006e58$require$Buffer.alloc(16), A, B, count;
        A = R[0];
        R = R.slice(1);
        for(var jdx = 5; 0 <= jdx; --jdx)for(var idx = R.length - 1; 0 <= idx; --idx){
            count = R.length * jdx + idx + 1;
            B = $5fea9cab96006e58$var$xor(A, $5fea9cab96006e58$var$longToBigEndian(count));
            B = $5fea9cab96006e58$require$Buffer.concat([
                B,
                R[idx],
                iv
            ]);
            var cipher = $7gM1u.nodeCrypto.createDecipheriv("AES" + size, key, iv);
            B = cipher.update(B);
            A = B.slice(0, 8);
            R[idx] = B.slice(8, 16);
        }
        if (A.toString() !== $5fea9cab96006e58$var$A0.toString()) return Promise.reject(new Error("decryption failed"));
        var pdata = $5fea9cab96006e58$require$Buffer.concat(R);
        return Promise.resolve(pdata);
    };
    return $7gM1u.setupFallback(node, webcrypto, fallback);
}
// ### Public API
// * [name].encrypt
// * [name].decrypt
var $5fea9cab96006e58$var$aesKw = {};
[
    "A128KW",
    "A192KW",
    "A256KW"
].forEach(function(alg) {
    var size = parseInt(/A(\d+)KW/g.exec(alg)[1]);
    $5fea9cab96006e58$var$aesKw[alg] = {
        encrypt: $5fea9cab96006e58$var$kwEncryptFN(size),
        decrypt: $5fea9cab96006e58$var$kwDecryptFN(size)
    };
});
module.exports = $5fea9cab96006e58$var$aesKw;

});

parcelRegister("kwDeH", function(module, exports) {
/*!
 * algorithms/concat.js - Concat Key Derivation
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ef153b47a24faf58$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1YNha = parcelRequire("1YNha");

var $f4IS9 = parcelRequire("f4IS9");
function $ef153b47a24faf58$var$concatDeriveFn(name) {
    name = name.replace("CONCAT-", "");
    // NOTE: no nodejs/webcrypto/fallback model, since ConcatKDF is
    //       implemented using the SHA algorithms
    var fn = function(key, props) {
        props = props || {};
        var keyLen = props.length, hashLen = $1YNha.HASHLENGTH[name];
        if (!keyLen) return Promise.reject(new Error("invalid key length"));
        // setup otherInfo
        if (!props.otherInfo) return Promise.reject(new Error("invalid otherInfo"));
        var otherInfo = props.otherInfo;
        var op = $f4IS9[name].digest;
        var N = Math.ceil(keyLen / hashLen), idx = 0, okm = [];
        function step() {
            if (N === idx++) return $ef153b47a24faf58$require$Buffer.concat(okm).slice(0, keyLen);
            var T = $ef153b47a24faf58$require$Buffer.alloc(4 + key.length + otherInfo.length);
            T.writeUInt32BE(idx, 0);
            key.copy(T, 4);
            otherInfo.copy(T, 4 + key.length);
            return op(T).then(function(result) {
                okm.push(result);
                return step();
            });
        }
        return step();
    };
    return fn;
}
// Public API
// * [name].derive
var $ef153b47a24faf58$var$concat = {};
[
    "CONCAT-SHA-1",
    "CONCAT-SHA-256",
    "CONCAT-SHA-384",
    "CONCAT-SHA-512"
].forEach(function(name) {
    $ef153b47a24faf58$var$concat[name] = {
        derive: $ef153b47a24faf58$var$concatDeriveFn(name)
    };
});
module.exports = $ef153b47a24faf58$var$concat;

});

parcelRegister("hR9hg", function(module, exports) {
/*!
 * algorithms/dir.js - Direct key mode
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";
function $cffe953be6980395$var$dirEncryptFN(key) {
    // NOTE: pdata unused
    // NOTE: props unused
    return Promise.resolve({
        data: key,
        once: true,
        direct: true
    });
}
function $cffe953be6980395$var$dirDecryptFN(key) {
    // NOTE: pdata unused
    // NOTE: props unused
    return Promise.resolve(key);
}
// ### Public API
// * [name].encrypt
// * [name].decrypt
var $cffe953be6980395$var$direct = {
    dir: {
        encrypt: $cffe953be6980395$var$dirEncryptFN,
        decrypt: $cffe953be6980395$var$dirDecryptFN
    }
};
module.exports = $cffe953be6980395$var$direct;

});

parcelRegister("vlNNp", function(module, exports) {
/*!
 * algorithms/ecdh.js - Elliptic Curve Diffie-Hellman algorithms
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $05e3ced1dd343c97$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $2rglK = parcelRequire("2rglK");

var $jIqqR = parcelRequire("jIqqR");

var $kHHwO = parcelRequire("kHHwO");

var $klWr4 = parcelRequire("klWr4");

var $kwDeH = parcelRequire("kwDeH");

var $8eyMA = parcelRequire("8eyMA");

var $7gM1u = parcelRequire("7gM1u");

var $1YNha = parcelRequire("1YNha");

var $bTYY2 = parcelRequire("bTYY2");

var $5c7W3 = parcelRequire("5c7W3");

var $12eN8 = parcelRequire("12eN8");
function $05e3ced1dd343c97$var$idealHash(curve) {
    switch(curve){
        case "P-256":
            return "SHA-256";
        case "P-384":
            return "SHA-384";
        case "P-521":
            return "SHA-512";
        default:
            throw new Error("unsupported curve: " + curve);
    }
}
// ### Exported
var $05e3ced1dd343c97$var$ecdh = module.exports = {};
// ### Derivation algorithms
// ### "raw" ECDH
function $05e3ced1dd343c97$var$ecdhDeriveFn() {
    var alg = {
        name: "ECDH"
    };
    var validatePublic = function(pk, form) {
        var pubKey = pk && $kHHwO.convertToForge(pk, true);
        if (!pubKey || !pubKey.isValid()) return Promise.reject(new Error("invalid EC public key"));
        switch(form){
            case "jwk":
                pubKey = $kHHwO.convertToJWK(pk, true);
                break;
            case "buffer":
                pubKey = $kHHwO.convertToBuffer(pk, true);
                break;
        }
        return Promise.resolve(pubKey);
    };
    // ### fallback implementation -- uses ecc + forge
    var fallback = function(key, props) {
        props = props || {};
        var keyLen = props.length || 0;
        // assume {key} is privateKey
        // assume {props.public} is publicKey
        var privKey = $kHHwO.convertToForge(key, false);
        var p = validatePublic(props.public, "forge");
        p = p.then(function(pubKey) {
            // {pubKey} is "forge"
            var secret = privKey.computeSecret(pubKey);
            if (keyLen) {
                // truncate to requested key length
                if (secret.length < keyLen) return Promise.reject(new Error("key length too large: " + keyLen));
                secret = secret.slice(0, keyLen);
            }
            return secret;
        });
        return p;
    };
    // ### WebCryptoAPI implementation
    // TODO: cache CryptoKey sooner
    var webcrypto = function(key, props) {
        key = key || {};
        props = props || {};
        var keyLen = props.length || 0, algParams = $2rglK($bTYY2(alg), {
            namedCurve: key.crv
        });
        // assume {key} is privateKey
        if (!keyLen) // calculate key length from private key size
        keyLen = key.d.length;
        var privKey = $kHHwO.convertToJWK(key, false);
        privKey = $7gM1u.subtleCrypto.importKey("jwk", privKey, algParams, false, [
            "deriveBits"
        ]);
        // assume {props.public} is publicKey
        var pubKey = validatePublic(props.public, "jwk");
        pubKey = pubKey.then(function(pubKey) {
            // {pubKey} is "jwk"
            return $7gM1u.subtleCrypto.importKey("jwk", pubKey, algParams, false, []);
        });
        var p = Promise.all([
            privKey,
            pubKey
        ]);
        p = p.then(function(keypair) {
            var privKey = keypair[0], pubKey = keypair[1];
            var algParams = $2rglK($bTYY2(alg), {
                public: pubKey
            });
            return $7gM1u.subtleCrypto.deriveBits(algParams, privKey, keyLen * 8);
        });
        p = p.then(function(result) {
            result = $05e3ced1dd343c97$require$Buffer.from(result);
            return result;
        });
        return p;
    };
    var nodejs = function(key, props) {
        if ("function" !== typeof $7gM1u.nodeCrypto.createECDH) throw new Error("unsupported algorithm: ECDH");
        props = props || {};
        var keyLen = props.length || 0;
        var curve;
        switch(key.crv){
            case "P-256":
                curve = "prime256v1";
                break;
            case "P-384":
                curve = "secp384r1";
                break;
            case "P-521":
                curve = "secp521r1";
                break;
            default:
                return Promise.reject(new Error("invalid curve: " + curve));
        }
        // assume {key} is privateKey
        // assume {props.public} is publicKey
        var privKey = $kHHwO.convertToBuffer(key, false);
        var p = validatePublic(props.public, "buffer");
        p = p.then(function(pubKey) {
            // {pubKey} is "buffer"
            var ecdh = $7gM1u.nodeCrypto.createECDH(curve);
            // dummy call so computeSecret doesn't fail
            // ecdh.generateKeys();
            ecdh.setPrivateKey(privKey);
            var secret = ecdh.computeSecret(pubKey);
            if (keyLen) {
                if (secret.length < keyLen) return Promise.reject(new Error("key length too large: " + keyLen));
                secret = secret.slice(0, keyLen);
            }
            return secret;
        });
        return p;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $05e3ced1dd343c97$var$ecdhConcatDeriveFn() {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, props) {
        props = props || {};
        var hash;
        try {
            hash = props.hash || $05e3ced1dd343c97$var$idealHash(key.crv);
            if (!hash) throw new Error("invalid hash: " + hash);
            hash.toUpperCase();
        } catch (ex) {
            return Promise.reject(ex);
        }
        var params = [
            "public"
        ];
        // derive shared secret
        // NOTE: whitelist items from {props} for ECDH
        var promise = $05e3ced1dd343c97$var$ecdh.ECDH.derive(key, $12eN8(props, params));
        // expand
        promise = promise.then(function(shared) {
            // NOTE: blacklist items from {props} for ECDH
            return $kwDeH["CONCAT-" + hash].derive(shared, $5c7W3(props, params));
        });
        return promise;
    };
    return fn;
}
function $05e3ced1dd343c97$var$ecdhHkdfDeriveFn() {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, props) {
        props = props || {};
        var hash;
        try {
            hash = props.hash || $05e3ced1dd343c97$var$idealHash(key.crv);
            if (!hash) throw new Error("invalid hash: " + hash);
            hash.toUpperCase();
        } catch (ex) {
            return Promise.reject(ex);
        }
        var params = [
            "public"
        ];
        // derive shared secret
        // NOTE: whitelist items from {props} for ECDH
        var promise = $05e3ced1dd343c97$var$ecdh.ECDH.derive(key, $12eN8(props, params));
        // extract-and-expand
        promise = promise.then(function(shared) {
            // NOTE: blacklist items from {props} for ECDH
            return $klWr4["HKDF-" + hash].derive(shared, $5c7W3(props, params));
        });
        return promise;
    };
    return fn;
}
// ### Wrap/Unwrap algorithms
function $05e3ced1dd343c97$var$doEcdhesCommonDerive(privKey, pubKey, props) {
    function prependLen(input) {
        return $05e3ced1dd343c97$require$Buffer.concat([
            $7gM1u.int32ToBuffer(input.length),
            input
        ]);
    }
    var algId = props.algorithm || "", keyLen = $1YNha.KEYLENGTH[algId], apu = $jIqqR.asBuffer(props.apu || "", "base64url"), apv = $jIqqR.asBuffer(props.apv || "", "base64url");
    var otherInfo = $05e3ced1dd343c97$require$Buffer.concat([
        prependLen($05e3ced1dd343c97$require$Buffer.from(algId, "utf8")),
        prependLen(apu),
        prependLen(apv),
        $7gM1u.int32ToBuffer(keyLen)
    ]);
    var params = {
        public: pubKey,
        length: keyLen / 8,
        hash: "SHA-256",
        otherInfo: otherInfo
    };
    return $05e3ced1dd343c97$var$ecdh["ECDH-CONCAT"].derive(privKey, params);
}
function $05e3ced1dd343c97$var$ecdhesDirEncryptFn() {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, pdata, props) {
        props = props || {};
        // {props.epk} is private
        if (!props.epk || !props.epk.d) return Promise.reject(new Error("missing ephemeral private key"));
        var epk = $kHHwO.convertToObj(props.epk, false);
        // {key} is public
        if (!key || !key.x || !key.y) return Promise.reject(new Error("missing static public key"));
        var spk = $kHHwO.convertToObj(key, true);
        // derive ECDH shared
        var promise = $05e3ced1dd343c97$var$doEcdhesCommonDerive(epk, spk, {
            algorithm: props.enc,
            apu: props.apu,
            apv: props.apv
        });
        promise = promise.then(function(shared) {
            return {
                data: shared,
                once: true,
                direct: true
            };
        });
        return promise;
    };
    return fn;
}
function $05e3ced1dd343c97$var$ecdhesDirDecryptFn() {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, cdata, props) {
        props = props || {};
        // {props.epk} is public
        if (!props.epk || !props.epk.x || !props.epk.y) return Promise.reject(new Error("missing ephemeral public key"));
        var epk = $kHHwO.convertToObj(props.epk, true);
        // {key} is private
        if (!key || !key.d) return Promise.reject(new Error("missing static private key"));
        var spk = $kHHwO.convertToObj(key, false);
        // derive ECDH shared
        var promise = $05e3ced1dd343c97$var$doEcdhesCommonDerive(spk, epk, {
            algorithm: props.enc,
            apu: props.apu,
            apv: props.apv
        });
        promise = promise.then(function(shared) {
            return shared;
        });
        return promise;
    };
    return fn;
}
function $05e3ced1dd343c97$var$ecdhesKwEncryptFn(wrap) {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, pdata, props) {
        props = props || {};
        // {props.epk} is private
        if (!props.epk || !props.epk.d) return Promise.reject(new Error("missing ephemeral private key"));
        var epk = $kHHwO.convertToObj(props.epk, false);
        // {key} is public
        if (!key || !key.x || !key.y) return Promise.reject(new Error("missing static public key"));
        var spk = $kHHwO.convertToObj(key, true);
        // derive ECDH shared
        var promise = $05e3ced1dd343c97$var$doEcdhesCommonDerive(epk, spk, {
            algorithm: props.alg,
            apu: props.apu,
            apv: props.apv
        });
        promise = promise.then(function(shared) {
            // wrap provided key with ECDH shared
            return wrap(shared, pdata);
        });
        return promise;
    };
    return fn;
}
function $05e3ced1dd343c97$var$ecdhesKwDecryptFn(unwrap) {
    // NOTE: no nodejs/webcrypto/fallback model, since this algorithm is
    //       implemented using other primitives
    var fn = function(key, cdata, props) {
        props = props || {};
        // {props.epk} is public
        if (!props.epk || !props.epk.x || !props.epk.y) return Promise.reject(new Error("missing ephemeral public key"));
        var epk = $kHHwO.convertToObj(props.epk, true);
        // {key} is private
        if (!key || !key.d) return Promise.reject(new Error("missing static private key"));
        var spk = $kHHwO.convertToObj(key, false);
        // derive ECDH shared
        var promise = $05e3ced1dd343c97$var$doEcdhesCommonDerive(spk, epk, {
            algorithm: props.alg,
            apu: props.apu,
            apv: props.apv
        });
        promise = promise.then(function(shared) {
            // unwrap provided key with ECDH shared
            return unwrap(shared, cdata);
        });
        return promise;
    };
    return fn;
}
// ### Public API
// * [name].derive
[
    "ECDH",
    "ECDH-HKDF",
    "ECDH-CONCAT"
].forEach(function(name) {
    var kdf = /^ECDH(?:-(\w+))?$/g.exec(name || "")[1];
    var op = $05e3ced1dd343c97$var$ecdh[name] = $05e3ced1dd343c97$var$ecdh[name] || {};
    switch(kdf || ""){
        case "CONCAT":
            op.derive = $05e3ced1dd343c97$var$ecdhConcatDeriveFn();
            break;
        case "HKDF":
            op.derive = $05e3ced1dd343c97$var$ecdhHkdfDeriveFn();
            break;
        case "":
            op.derive = $05e3ced1dd343c97$var$ecdhDeriveFn();
            break;
        default:
            op.derive = null;
    }
});
// * [name].encrypt
// * [name].decrypt
[
    "ECDH-ES",
    "ECDH-ES+A128KW",
    "ECDH-ES+A192KW",
    "ECDH-ES+A256KW"
].forEach(function(name) {
    var kw = /^ECDH-ES(?:\+(.+))?/g.exec(name || "")[1];
    var op = $05e3ced1dd343c97$var$ecdh[name] = $05e3ced1dd343c97$var$ecdh[name] || {};
    if (!kw) {
        op.encrypt = $05e3ced1dd343c97$var$ecdhesDirEncryptFn();
        op.decrypt = $05e3ced1dd343c97$var$ecdhesDirDecryptFn();
    } else {
        kw = $8eyMA[kw];
        if (kw) {
            op.encrypt = $05e3ced1dd343c97$var$ecdhesKwEncryptFn(kw.encrypt);
            op.decrypt = $05e3ced1dd343c97$var$ecdhesKwDecryptFn(kw.decrypt);
        } else op.ecrypt = op.decrypt = null;
    }
}); //*/

});
parcelRegister("kHHwO", function(module, exports) {
/*!
 * algorithms/ec-util.js - Elliptic Curve Utility Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $f12996991b3064d4$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $bTYY2 = parcelRequire("bTYY2");

var $fwJVv = parcelRequire("fwJVv");

var $as9F1 = parcelRequire("as9F1");

var $jIqqR = parcelRequire("jIqqR");
var $f12996991b3064d4$var$EC_KEYSIZES = {
    "P-256": 256,
    "P-384": 384,
    "P-521": 521
};
function $f12996991b3064d4$var$convertToForge(key, isPublic) {
    var parts = isPublic ? [
        "x",
        "y"
    ] : [
        "d"
    ];
    parts = parts.map(function(f) {
        return new $as9F1.jsbn.BigInteger(key[f].toString("hex"), 16);
    });
    // prefix with curve
    parts = [
        key.crv
    ].concat(parts);
    var fn = isPublic ? $fwJVv.asPublicKey : $fwJVv.asPrivateKey;
    return fn.apply($fwJVv, parts);
}
function $f12996991b3064d4$var$convertToJWK(key, isPublic) {
    var result = $bTYY2(key);
    var parts = isPublic ? [
        "x",
        "y"
    ] : [
        "x",
        "y",
        "d"
    ];
    parts.forEach(function(f) {
        result[f] = $jIqqR.base64url.encode(result[f]);
    });
    // remove potentially troublesome properties
    delete result.key_ops;
    delete result.use;
    delete result.alg;
    if (isPublic) delete result.d;
    return result;
}
function $f12996991b3064d4$var$convertToObj(key, isPublic) {
    var result = $bTYY2(key);
    var parts = isPublic ? [
        "x",
        "y"
    ] : [
        "d"
    ];
    parts.forEach(function(f) {
        // assume string if base64url-encoded
        result[f] = $jIqqR.asBuffer(result[f], "base64url");
    });
    return result;
}
var $f12996991b3064d4$var$UNCOMPRESSED = $f12996991b3064d4$require$Buffer.from([
    0x04
]);
function $f12996991b3064d4$var$convertToBuffer(key, isPublic) {
    key = $f12996991b3064d4$var$convertToObj(key, isPublic);
    var result = isPublic ? $f12996991b3064d4$require$Buffer.concat([
        $f12996991b3064d4$var$UNCOMPRESSED,
        key.x,
        key.y
    ]) : key.d;
    return result;
}
function $f12996991b3064d4$var$curveSize(crv) {
    return $f12996991b3064d4$var$EC_KEYSIZES[crv || ""] || NaN;
}
function $f12996991b3064d4$var$curveNameToOid(crv) {
    switch(crv){
        case "P-256":
            return "1.2.840.10045.3.1.7";
        case "P-384":
            return "1.3.132.0.34";
        case "P-521":
            return "1.3.132.0.35";
        default:
            return null;
    }
}
var $f12996991b3064d4$var$EC_OID = "1.2.840.10045.2.1";
function $f12996991b3064d4$var$convertToPEM(key, isPrivate) {
    // curveName to OID
    var oid = key.crv;
    oid = $f12996991b3064d4$var$curveNameToOid(oid);
    oid = $as9F1.asn1.oidToDer(oid);
    // key as bytes
    var type, pub, asn1;
    if (isPrivate) {
        type = "EC PRIVATE KEY";
        pub = $f12996991b3064d4$require$Buffer.concat([
            $f12996991b3064d4$require$Buffer.from([
                0x00,
                0x04
            ]),
            key.x,
            key.y
        ]).toString("binary");
        key = key.d.toString("binary");
        asn1 = $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.SEQUENCE, true, [
            $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.INTEGER, false, "\x01"),
            $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.OCTETSTRING, false, key),
            $as9F1.asn1.create($as9F1.asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.OID, false, oid.bytes())
            ]),
            $as9F1.asn1.create($as9F1.asn1.Class.CONTEXT_SPECIFIC, 1, true, [
                $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.BITSTRING, false, pub)
            ])
        ]);
    } else {
        type = "PUBLIC KEY";
        key = $f12996991b3064d4$require$Buffer.concat([
            $f12996991b3064d4$require$Buffer.from([
                0x00,
                0x04
            ]),
            key.x,
            key.y
        ]).toString("binary");
        asn1 = $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.SEQUENCE, true, [
            $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.SEQUENCE, true, [
                $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.OID, false, $as9F1.asn1.oidToDer($f12996991b3064d4$var$EC_OID).bytes()),
                $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.OID, false, oid.bytes())
            ]),
            $as9F1.asn1.create($as9F1.asn1.Class.UNIVERSAL, $as9F1.asn1.Type.BITSTRING, false, key)
        ]);
    }
    asn1 = $as9F1.asn1.toDer(asn1).bytes();
    var pem = $as9F1.pem.encode({
        type: type,
        body: asn1
    });
    return pem;
}
// Inspired by teifip/node-webtokens/blob/master/lib/ecdsa.js
var $f12996991b3064d4$var$ERR_MSG = "Could not extract parameters from DER signature";
function $f12996991b3064d4$var$derToConcat(signature, size) {
    var offset = 0;
    if (signature[offset++] !== 0x30) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var seqLength = signature[offset++];
    if (seqLength === 0x81) seqLength = signature[offset++];
    if (seqLength > signature.length - offset) throw new Error($f12996991b3064d4$var$ERR_MSG);
    if (signature[offset++] !== 0x02) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var rLength = signature[offset++];
    if (rLength > signature.length - offset - 2) throw new Error($f12996991b3064d4$var$ERR_MSG);
    if (rLength > size + 1) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== 0x02) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var sLength = signature[offset++];
    if (sLength !== signature.length - offset) throw new Error($f12996991b3064d4$var$ERR_MSG);
    if (sLength > size + 1) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var sOffset = offset;
    offset += sLength;
    if (offset !== signature.length) throw new Error($f12996991b3064d4$var$ERR_MSG);
    var rPadding = size - rLength;
    var sPadding = size - sLength;
    var dst = $f12996991b3064d4$require$Buffer.alloc(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    var rPad = Math.max(-rPadding, 0);
    signature.copy(dst, offset, rOffset + rPad, rOffset + rLength);
    offset = size;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    var sPad = Math.max(-sPadding, 0);
    signature.copy(dst, offset, sOffset + sPad, sOffset + sLength);
    return dst;
}
function $f12996991b3064d4$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= 0x80;
    if (needsSign) --padding;
    return padding;
}
function $f12996991b3064d4$var$concatToDer(signature, size) {
    var rPadding = $f12996991b3064d4$var$countPadding(signature, 0, size);
    var sPadding = $f12996991b3064d4$var$countPadding(signature, size, signature.length);
    var rLength = size - rPadding;
    var sLength = size - sPadding;
    var rsBytes = rLength + sLength + 4;
    var shortLength = rsBytes < 0x80;
    var dst = $f12996991b3064d4$require$Buffer.alloc((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = 0x30;
    if (shortLength) dst[offset++] = rsBytes;
    else {
        dst[offset++] = 0x81;
        dst[offset++] = rsBytes & 0xFF;
    }
    dst[offset++] = 0x02;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, size);
    } else offset += signature.copy(dst, offset, rPadding, size);
    dst[offset++] = 0x02;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, size);
    } else signature.copy(dst, offset, size + sPadding);
    return dst;
}
module.exports = {
    convertToForge: $f12996991b3064d4$var$convertToForge,
    convertToJWK: $f12996991b3064d4$var$convertToJWK,
    convertToObj: $f12996991b3064d4$var$convertToObj,
    convertToBuffer: $f12996991b3064d4$var$convertToBuffer,
    curveSize: $f12996991b3064d4$var$curveSize,
    derToConcat: $f12996991b3064d4$var$derToConcat,
    concatToDer: $f12996991b3064d4$var$concatToDer,
    convertToPEM: $f12996991b3064d4$var$convertToPEM,
    EC_OID: $f12996991b3064d4$var$EC_OID
};

});
parcelRegister("fwJVv", function(module, exports) {

$parcel$export(module.exports, "generateKeyPair", () => $b4dd783c65b45764$export$a949d36eab55b41f, (v) => $b4dd783c65b45764$export$a949d36eab55b41f = v);
$parcel$export(module.exports, "asPublicKey", () => $b4dd783c65b45764$export$1df34d9e815d316f, (v) => $b4dd783c65b45764$export$1df34d9e815d316f = v);
$parcel$export(module.exports, "asPrivateKey", () => $b4dd783c65b45764$export$c94ac3431fe3e569, (v) => $b4dd783c65b45764$export$c94ac3431fe3e569 = v);
/**
 * deps/ecc/index.js - Elliptic Curve Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ // ### Public API
var $b4dd783c65b45764$export$a949d36eab55b41f;
var $b4dd783c65b45764$export$1df34d9e815d316f;
var $b4dd783c65b45764$export$c94ac3431fe3e569;

var $6ZWSX = parcelRequire("6ZWSX");
var $b4dd783c65b45764$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");
var $b4dd783c65b45764$var$BigInteger = $as9F1.jsbn.BigInteger;

var $jBdzf = parcelRequire("jBdzf");

var $hV5GJ = parcelRequire("hV5GJ");
// ### Helpers
function $b4dd783c65b45764$var$hex2bn(s) {
    return new $b4dd783c65b45764$var$BigInteger(s, 16);
}
function $b4dd783c65b45764$var$bn2bin(bn, len) {
    if (!len) len = Math.ceil(bn.bitLength() / 8);
    len = len * 2;
    var hex = bn.toString(16);
    // truncate-left if too large
    hex = hex.substring(Math.max(hex.length - len, 0));
    // pad-left if too small
    while(len > hex.length)hex = "0" + hex;
    return $b4dd783c65b45764$require$Buffer.from(hex, "hex");
}
function $b4dd783c65b45764$var$bin2bn(s) {
    if ("string" === typeof s) s = $b4dd783c65b45764$require$Buffer.from(s, "binary");
    return $b4dd783c65b45764$var$hex2bn(s.toString("hex"));
}
function $b4dd783c65b45764$var$keySizeBytes(params) {
    return Math.ceil(params.getN().bitLength() / 8);
}
function $b4dd783c65b45764$var$namedCurve(curve) {
    var params = $hV5GJ[curve];
    if (!params) throw new TypeError("unsupported named curve: " + curve);
    return params;
}
function $b4dd783c65b45764$var$normalizeEcdsa(params, md) {
    var log2n = params.getN().bitLength(), mdLen = md.length * 8;
    var e = $b4dd783c65b45764$var$bin2bn(md);
    if (log2n < mdLen) e = e.shiftRight(mdLen - log2n);
    return e;
}
// ### EC Public Key
/**
 *
 * @param {String} curve The named curve
 * @param {BigInteger} x The X coordinate
 * @param {BigInteger} y The Y coordinate
 */ function $b4dd783c65b45764$var$ECPublicKey(curve, x, y) {
    var params = $b4dd783c65b45764$var$namedCurve(curve), c = params.getCurve();
    var key = new $jBdzf.ECPointFp(c, c.fromBigInteger(x), c.fromBigInteger(y));
    this.curve = curve;
    this.params = params;
    this.point = key;
    var size = $b4dd783c65b45764$var$keySizeBytes(params);
    this.x = $b4dd783c65b45764$var$bn2bin(x, size);
    this.y = $b4dd783c65b45764$var$bn2bin(y, size);
}
// basics
$b4dd783c65b45764$var$ECPublicKey.prototype.isValid = function() {
    return this.params.curve.contains(this.point);
};
// ECDSA
$b4dd783c65b45764$var$ECPublicKey.prototype.verify = function(md, sig) {
    var N = this.params.getN(), G = this.params.getG();
    // prepare and validate (r, s)
    var r = $b4dd783c65b45764$var$bin2bn(sig.r), s = $b4dd783c65b45764$var$bin2bn(sig.s);
    if (r.compareTo($b4dd783c65b45764$var$BigInteger.ONE) < 0 || r.compareTo(N) >= 0) return false;
    if (s.compareTo($b4dd783c65b45764$var$BigInteger.ONE) < 0 || r.compareTo(N) >= 0) return false;
    // normalize input
    var e = $b4dd783c65b45764$var$normalizeEcdsa(this.params, md);
    // verify (r, s)
    var w = s.modInverse(N), u1 = e.multiply(w).mod(N), u2 = r.multiply(w).mod(N);
    var v = G.multiplyTwo(u1, this.point, u2).getX().toBigInteger();
    v = v.mod(N);
    return v.equals(r);
};
// ### EC Private Key
/**
 * @param {String} curve The named curve
 * @param {Buffer} key The private key value
 */ function $b4dd783c65b45764$var$ECPrivateKey(curve, key) {
    var params = $b4dd783c65b45764$var$namedCurve(curve);
    this.curve = curve;
    this.params = params;
    var size = $b4dd783c65b45764$var$keySizeBytes(params);
    this.d = $b4dd783c65b45764$var$bn2bin(key, size);
}
$b4dd783c65b45764$var$ECPrivateKey.prototype.toPublicKey = function() {
    var d = $b4dd783c65b45764$var$bin2bn(this.d);
    var P = this.params.getG().multiply(d);
    return new $b4dd783c65b45764$var$ECPublicKey(this.curve, P.getX().toBigInteger(), P.getY().toBigInteger());
};
// ECDSA
$b4dd783c65b45764$var$ECPrivateKey.prototype.sign = function(md) {
    var keysize = $b4dd783c65b45764$var$keySizeBytes(this.params), N = this.params.getN(), G = this.params.getG(), e = $b4dd783c65b45764$var$normalizeEcdsa(this.params, md), d = $b4dd783c65b45764$var$bin2bn(this.d);
    var r, s;
    var k, x1, z;
    do {
        do {
            // determine random nonce
            do k = $b4dd783c65b45764$var$bin2bn($as9F1.random.getBytes(keysize));
            while (k.equals($b4dd783c65b45764$var$BigInteger.ZERO) || k.compareTo(N) >= 0);
            // (x1, y1) = k * G
            x1 = G.multiply(k).getX().toBigInteger();
            // r = x1 mod N
            r = x1.mod(N);
        }while (r.equals($b4dd783c65b45764$var$BigInteger.ZERO));
        // s = (k^-1 * (e + r * d)) mod N
        z = d.multiply(r);
        z = e.add(z);
        s = k.modInverse(N).multiply(z).mod(N);
    }while (s.equals($b4dd783c65b45764$var$BigInteger.ONE));
    // convert (r, s) to bytes
    var len = $b4dd783c65b45764$var$keySizeBytes(this.params);
    r = $b4dd783c65b45764$var$bn2bin(r, len);
    s = $b4dd783c65b45764$var$bn2bin(s, len);
    return {
        r: r,
        s: s
    };
};
// basics
$b4dd783c65b45764$var$ECPrivateKey.prototype.isValid = function() {
    var d = $b4dd783c65b45764$var$bin2bn(this.d), n1 = this.params.getN().subtract($b4dd783c65b45764$var$BigInteger.ONE);
    return d.compareTo($b4dd783c65b45764$var$BigInteger.ONE) >= 0 && d.compareTo(n1) < 0;
};
// ECDH
$b4dd783c65b45764$var$ECPrivateKey.prototype.computeSecret = function(pubkey) {
    var d = $b4dd783c65b45764$var$bin2bn(this.d);
    var S = pubkey.point.multiply(d).getX().toBigInteger();
    S = $b4dd783c65b45764$var$bn2bin(S, $b4dd783c65b45764$var$keySizeBytes(this.params));
    return S;
};
$b4dd783c65b45764$export$a949d36eab55b41f = function(curve) {
    var params = $b4dd783c65b45764$var$namedCurve(curve), n = params.getN();
    // generate random within range [1, N-1)
    var r = $as9F1.random.getBytes($b4dd783c65b45764$var$keySizeBytes(params));
    r = $b4dd783c65b45764$var$bin2bn(r);
    var n1 = n.subtract($b4dd783c65b45764$var$BigInteger.ONE);
    var d = r.mod(n1).add($b4dd783c65b45764$var$BigInteger.ONE);
    var privkey = new $b4dd783c65b45764$var$ECPrivateKey(curve, d), pubkey = privkey.toPublicKey();
    return {
        "private": privkey,
        "public": pubkey
    };
};
$b4dd783c65b45764$export$1df34d9e815d316f = function(curve, x, y) {
    if ("string" === typeof x) x = $b4dd783c65b45764$var$hex2bn(x);
    else if ($b4dd783c65b45764$require$Buffer.isBuffer(x)) x = $b4dd783c65b45764$var$bin2bn(x);
    if ("string" === typeof y) y = $b4dd783c65b45764$var$hex2bn(y);
    else if ($b4dd783c65b45764$require$Buffer.isBuffer(y)) y = $b4dd783c65b45764$var$bin2bn(y);
    var pubkey = new $b4dd783c65b45764$var$ECPublicKey(curve, x, y);
    return pubkey;
};
$b4dd783c65b45764$export$c94ac3431fe3e569 = function(curve, d) {
    // Elaborate way to get to a Buffer from a (String|Buffer|BigInteger)
    if ("string" === typeof d) d = $b4dd783c65b45764$var$hex2bn(d);
    else if ($b4dd783c65b45764$require$Buffer.isBuffer(d)) d = $b4dd783c65b45764$var$bin2bn(d);
    var privkey = new $b4dd783c65b45764$var$ECPrivateKey(curve, d);
    return privkey;
};

});
parcelRegister("jBdzf", function(module, exports) {
/**
 * deps/ecc/math.js - Elliptic Curve Math
 * Original Copyright (c) 2003-2005  Tom Wu.
 * Modifications Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 *
 * Ported from Tom Wu, which is ported from BouncyCastle
 * Modified to reuse existing external NPM modules, restricted to the
 * NIST//SECG/X9.62 prime curves only, and formatted to match project
 * coding styles.
 */ "use strict";

// Basic Javascript Elliptic Curve implementation
// Ported loosely from BouncyCastle's Java EC code
// Only Fp curves implemented for now
var $e44bff392aa298e7$var$BigInteger = (parcelRequire("as9F1")).jsbn.BigInteger;
// ----------------
// Helpers
function $e44bff392aa298e7$var$nbi() {
    return new $e44bff392aa298e7$var$BigInteger(null);
}
// ----------------
// Barrett modular reduction
// constructor
function $e44bff392aa298e7$var$Barrett(m) {
    // setup Barrett
    this.r2 = $e44bff392aa298e7$var$nbi();
    this.q3 = $e44bff392aa298e7$var$nbi();
    $e44bff392aa298e7$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $e44bff392aa298e7$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $e44bff392aa298e7$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $e44bff392aa298e7$var$barrettRevert(x) {
    return x;
}
// x = x mod m (HAC 14.42)
function $e44bff392aa298e7$var$barrettReduce(x) {
    if (x.s < 0) throw Error("Barrett reduction on negative input");
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
// r = x^2 mod m; x != r
function $e44bff392aa298e7$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = x*y mod m; x,y != r
function $e44bff392aa298e7$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$e44bff392aa298e7$var$Barrett.prototype.convert = $e44bff392aa298e7$var$barrettConvert;
$e44bff392aa298e7$var$Barrett.prototype.revert = $e44bff392aa298e7$var$barrettRevert;
$e44bff392aa298e7$var$Barrett.prototype.reduce = $e44bff392aa298e7$var$barrettReduce;
$e44bff392aa298e7$var$Barrett.prototype.mulTo = $e44bff392aa298e7$var$barrettMulTo;
$e44bff392aa298e7$var$Barrett.prototype.sqrTo = $e44bff392aa298e7$var$barrettSqrTo;
// ----------------
// ECFieldElementFp
// constructor
function $e44bff392aa298e7$var$ECFieldElementFp(q, x) {
    this.x = x;
    // TODO if(x.compareTo(q) >= 0) error
    this.p = q;
}
function $e44bff392aa298e7$var$feFpEquals(other) {
    if (other === this) return true;
    return this.p.equals(other.p) && this.x.equals(other.x);
}
function $e44bff392aa298e7$var$feFpToBigInteger() {
    return this.x;
}
function $e44bff392aa298e7$var$feFpNegate() {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.negate().mod(this.p));
}
function $e44bff392aa298e7$var$feFpAdd(b) {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.add(b.toBigInteger()).mod(this.p));
}
function $e44bff392aa298e7$var$feFpSubtract(b) {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.subtract(b.toBigInteger()).mod(this.p));
}
function $e44bff392aa298e7$var$feFpMultiply(b) {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.multiply(b.toBigInteger()).mod(this.p));
}
function $e44bff392aa298e7$var$feFpSquare() {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.pow(2).mod(this.p));
}
function $e44bff392aa298e7$var$feFpDivide(b) {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, this.x.multiply(b.toBigInteger().modInverse(this.p)).mod(this.p));
}
$e44bff392aa298e7$var$ECFieldElementFp.prototype.equals = $e44bff392aa298e7$var$feFpEquals;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.toBigInteger = $e44bff392aa298e7$var$feFpToBigInteger;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.negate = $e44bff392aa298e7$var$feFpNegate;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.add = $e44bff392aa298e7$var$feFpAdd;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.subtract = $e44bff392aa298e7$var$feFpSubtract;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.multiply = $e44bff392aa298e7$var$feFpMultiply;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.square = $e44bff392aa298e7$var$feFpSquare;
$e44bff392aa298e7$var$ECFieldElementFp.prototype.divide = $e44bff392aa298e7$var$feFpDivide;
// ----------------
// ECPointFp
// constructor
function $e44bff392aa298e7$var$ECPointFp(curve, x, y, z) {
    this.curve = curve;
    this.x = x;
    this.y = y;
    // Projective coordinates: either zinv == null or z * zinv == 1
    // z and zinv are just BigIntegers, not fieldElements
    if (!z) this.z = $e44bff392aa298e7$var$BigInteger.ONE;
    else this.z = z;
    this.zinv = null;
//TODO: compression flag
}
function $e44bff392aa298e7$var$pointFpGetX() {
    if (!this.zinv) this.zinv = this.z.modInverse(this.curve.p);
    var r = this.x.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}
function $e44bff392aa298e7$var$pointFpGetY() {
    if (!this.zinv) this.zinv = this.z.modInverse(this.curve.p);
    var r = this.y.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}
function $e44bff392aa298e7$var$pointFpEquals(other) {
    if (other === this) return true;
    if (this.isInfinity()) return other.isInfinity();
    if (other.isInfinity()) return this.isInfinity();
    var u, v;
    // u = Y2 * Z1 - Y1 * Z2
    u = other.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(other.z)).mod(this.curve.p);
    if (!u.equals($e44bff392aa298e7$var$BigInteger.ZERO)) return false;
    // v = X2 * Z1 - X1 * Z2
    v = other.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(other.z)).mod(this.curve.p);
    return v.equals($e44bff392aa298e7$var$BigInteger.ZERO);
}
function $e44bff392aa298e7$var$pointFpIsInfinity() {
    if (this.x == null && this.y == null) return true;
    return this.z.equals($e44bff392aa298e7$var$BigInteger.ZERO) && !this.y.toBigInteger().equals($e44bff392aa298e7$var$BigInteger.ZERO);
}
function $e44bff392aa298e7$var$pointFpNegate() {
    return new $e44bff392aa298e7$var$ECPointFp(this.curve, this.x, this.y.negate(), this.z);
}
function $e44bff392aa298e7$var$pointFpAdd(b) {
    if (this.isInfinity()) return b;
    if (b.isInfinity()) return this;
    // u = Y2 * Z1 - Y1 * Z2
    var u = b.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(b.z)).mod(this.curve.p);
    // v = X2 * Z1 - X1 * Z2
    var v = b.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(b.z)).mod(this.curve.p);
    if ($e44bff392aa298e7$var$BigInteger.ZERO.equals(v)) {
        if ($e44bff392aa298e7$var$BigInteger.ZERO.equals(u)) return this.twice(); // this == b, so double
        return this.curve.getInfinity(); // this = -b, so infinity
    }
    var THREE = new $e44bff392aa298e7$var$BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var v2 = v.pow(2);
    var v3 = v2.multiply(v);
    var x1v2 = x1.multiply(v2);
    var zu2 = u.pow(2).multiply(this.z);
    // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
    var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.p);
    // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
    var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.p);
    // z3 = v^3 * z1 * z2
    var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.p);
    return new $e44bff392aa298e7$var$ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}
function $e44bff392aa298e7$var$pointFpTwice() {
    if (this.isInfinity()) return this;
    if (this.y.toBigInteger().signum() === 0) return this.curve.getInfinity();
    // TODO: optimized handling of constants
    var THREE = new $e44bff392aa298e7$var$BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var y1z1 = y1.multiply(this.z);
    var y1sqz1 = y1z1.multiply(y1).mod(this.curve.p);
    var a = this.curve.a.toBigInteger();
    // w = 3 * x1^2 + a * z1^2
    var w = x1.pow(2).multiply(THREE);
    if (!$e44bff392aa298e7$var$BigInteger.ZERO.equals(a)) w = w.add(this.z.pow(2).multiply(a));
    w = w.mod(this.curve.p);
    //this.curve.reduce(w);
    // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
    var x3 = w.pow(2).subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.p);
    // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
    var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.pow(2).multiply(w)).mod(this.curve.p);
    // z3 = 8 * (y1 * z1)^3
    var z3 = y1z1.pow(2).multiply(y1z1).shiftLeft(3).mod(this.curve.p);
    return new $e44bff392aa298e7$var$ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}
// Simple NAF (Non-Adjacent Form) multiplication algorithm
// TODO: modularize the multiplication algorithm
function $e44bff392aa298e7$var$pointFpMultiply(k) {
    if (this.isInfinity()) return this;
    if (k.signum() === 0) return this.curve.getInfinity();
    var e = k;
    var h = e.multiply(new $e44bff392aa298e7$var$BigInteger("3"));
    var neg = this.negate();
    var R = this;
    var i;
    for(i = h.bitLength() - 2; i > 0; --i){
        R = R.twice();
        var hBit = h.testBit(i);
        var eBit = e.testBit(i);
        if (hBit !== eBit) R = R.add(hBit ? this : neg);
    }
    return R;
}
// Compute this*j + x*k (simultaneous multiplication)
function $e44bff392aa298e7$var$pointFpMultiplyTwo(j, x, k) {
    var i;
    if (j.bitLength() > k.bitLength()) i = j.bitLength() - 1;
    else i = k.bitLength() - 1;
    var R = this.curve.getInfinity();
    var both = this.add(x);
    while(i >= 0){
        R = R.twice();
        if (j.testBit(i)) {
            if (k.testBit(i)) R = R.add(both);
            else R = R.add(this);
        } else if (k.testBit(i)) R = R.add(x);
        --i;
    }
    return R;
}
$e44bff392aa298e7$var$ECPointFp.prototype.getX = $e44bff392aa298e7$var$pointFpGetX;
$e44bff392aa298e7$var$ECPointFp.prototype.getY = $e44bff392aa298e7$var$pointFpGetY;
$e44bff392aa298e7$var$ECPointFp.prototype.equals = $e44bff392aa298e7$var$pointFpEquals;
$e44bff392aa298e7$var$ECPointFp.prototype.isInfinity = $e44bff392aa298e7$var$pointFpIsInfinity;
$e44bff392aa298e7$var$ECPointFp.prototype.negate = $e44bff392aa298e7$var$pointFpNegate;
$e44bff392aa298e7$var$ECPointFp.prototype.add = $e44bff392aa298e7$var$pointFpAdd;
$e44bff392aa298e7$var$ECPointFp.prototype.twice = $e44bff392aa298e7$var$pointFpTwice;
$e44bff392aa298e7$var$ECPointFp.prototype.multiply = $e44bff392aa298e7$var$pointFpMultiply;
$e44bff392aa298e7$var$ECPointFp.prototype.multiplyTwo = $e44bff392aa298e7$var$pointFpMultiplyTwo;
// ----------------
// ECCurveFp
// constructor
function $e44bff392aa298e7$var$ECCurveFp(p, a, b) {
    this.p = p;
    this.a = this.fromBigInteger(a);
    this.b = this.fromBigInteger(b);
    this.infinity = new $e44bff392aa298e7$var$ECPointFp(this, null, null);
    this.reducer = new $e44bff392aa298e7$var$Barrett(this.p);
}
function $e44bff392aa298e7$var$curveFpgetP() {
    return this.p;
}
function $e44bff392aa298e7$var$curveFpGetA() {
    return this.a;
}
function $e44bff392aa298e7$var$curveFpGetB() {
    return this.b;
}
function $e44bff392aa298e7$var$curveFpEquals(other) {
    if (other === this) return true;
    return this.p.equals(other.p) && this.a.equals(other.a) && this.b.equals(other.b);
}
function $e44bff392aa298e7$var$curveFpContains(pt) {
    // y^2 = x^3 + a*x + b mod p
    var x = pt.getX().toBigInteger(), y = pt.getY().toBigInteger(), a = this.a.toBigInteger(), b = this.b.toBigInteger(), p = this.p;
    var left = y.pow(2).mod(p), right = x.pow(3).add(a.multiply(x)).add(b).mod(p);
    return left.equals(right);
}
function $e44bff392aa298e7$var$curveFpGetInfinity() {
    return this.infinity;
}
function $e44bff392aa298e7$var$curveFpFromBigInteger(x) {
    return new $e44bff392aa298e7$var$ECFieldElementFp(this.p, x);
}
function $e44bff392aa298e7$var$curveReduce(x) {
    this.reducer.reduce(x);
}
// for now, work with hex strings because they're easier in JS
function $e44bff392aa298e7$var$curveFpDecodePointHex(s) {
    switch(parseInt(s.substring(0, 2), 16)){
        // first byte
        case 0:
            return this.infinity;
        case 2:
        case 3:
            // point compression not supported yet
            return null;
        case 4:
        case 6:
        case 7:
            var len = (s.length - 2) / 2;
            var xHex = s.substr(2, len);
            var yHex = s.substr(len + 2, len);
            return new $e44bff392aa298e7$var$ECPointFp(this, this.fromBigInteger(new $e44bff392aa298e7$var$BigInteger(xHex, 16)), this.fromBigInteger(new $e44bff392aa298e7$var$BigInteger(yHex, 16)));
        default:
            return null;
    }
}
function $e44bff392aa298e7$var$curveFpEncodePointHex(p) {
    if (p.isInfinity()) return "00";
    var xHex = p.getX().toBigInteger().toString(16);
    var yHex = p.getY().toBigInteger().toString(16);
    var oLen = this.getP().toString(16).length;
    if (oLen % 2 !== 0) oLen++;
    while(xHex.length < oLen)xHex = "0" + xHex;
    while(yHex.length < oLen)yHex = "0" + yHex;
    return "04" + xHex + yHex;
}
$e44bff392aa298e7$var$ECCurveFp.prototype.getP = $e44bff392aa298e7$var$curveFpgetP;
$e44bff392aa298e7$var$ECCurveFp.prototype.getA = $e44bff392aa298e7$var$curveFpGetA;
$e44bff392aa298e7$var$ECCurveFp.prototype.getB = $e44bff392aa298e7$var$curveFpGetB;
$e44bff392aa298e7$var$ECCurveFp.prototype.equals = $e44bff392aa298e7$var$curveFpEquals;
$e44bff392aa298e7$var$ECCurveFp.prototype.contains = $e44bff392aa298e7$var$curveFpContains;
$e44bff392aa298e7$var$ECCurveFp.prototype.getInfinity = $e44bff392aa298e7$var$curveFpGetInfinity;
$e44bff392aa298e7$var$ECCurveFp.prototype.fromBigInteger = $e44bff392aa298e7$var$curveFpFromBigInteger;
$e44bff392aa298e7$var$ECCurveFp.prototype.reduce = $e44bff392aa298e7$var$curveReduce;
$e44bff392aa298e7$var$ECCurveFp.prototype.decodePointHex = $e44bff392aa298e7$var$curveFpDecodePointHex;
$e44bff392aa298e7$var$ECCurveFp.prototype.encodePointHex = $e44bff392aa298e7$var$curveFpEncodePointHex;
// Exports
module.exports = {
    ECFieldElementFp: $e44bff392aa298e7$var$ECFieldElementFp,
    ECPointFp: $e44bff392aa298e7$var$ECPointFp,
    ECCurveFp: $e44bff392aa298e7$var$ECCurveFp
};

});

parcelRegister("hV5GJ", function(module, exports) {
/**
 * deps/ecc/curves.js - Elliptic Curve NIST/SECG/X9.62 Parameters
 * Original Copyright (c) 2003-2005  Tom Wu.
 * Modifications Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 *
 * Ported from Tom Wu, which is ported from BouncyCastle
 * Modified to reuse existing external NPM modules, restricted to the
 * NIST//SECG/X9.62 prime curves only, and formatted to match project
 * coding styles.
 */ "use strict";

// Named EC curves
var $d0bc2c184db42dfb$var$BigInteger = (parcelRequire("as9F1")).jsbn.BigInteger;

var $jBdzf = parcelRequire("jBdzf");
// ----------------
// X9ECParameters
// constructor
function $d0bc2c184db42dfb$var$X9ECParameters(curve, g, n, h) {
    this.curve = curve;
    this.g = g;
    this.n = n;
    this.h = h;
}
function $d0bc2c184db42dfb$var$x9getCurve() {
    return this.curve;
}
function $d0bc2c184db42dfb$var$x9getG() {
    return this.g;
}
function $d0bc2c184db42dfb$var$x9getN() {
    return this.n;
}
function $d0bc2c184db42dfb$var$x9getH() {
    return this.h;
}
$d0bc2c184db42dfb$var$X9ECParameters.prototype.getCurve = $d0bc2c184db42dfb$var$x9getCurve;
$d0bc2c184db42dfb$var$X9ECParameters.prototype.getG = $d0bc2c184db42dfb$var$x9getG;
$d0bc2c184db42dfb$var$X9ECParameters.prototype.getN = $d0bc2c184db42dfb$var$x9getN;
$d0bc2c184db42dfb$var$X9ECParameters.prototype.getH = $d0bc2c184db42dfb$var$x9getH;
// ----------------
// SECNamedCurves
function $d0bc2c184db42dfb$var$fromHex(s) {
    return new $d0bc2c184db42dfb$var$BigInteger(s, 16);
}
function $d0bc2c184db42dfb$var$secp256r1() {
    // p = 2^224 (2^32 - 1) + 2^192 + 2^96 - 1
    var p = $d0bc2c184db42dfb$var$fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF");
    var a = $d0bc2c184db42dfb$var$fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC");
    var b = $d0bc2c184db42dfb$var$fromHex("5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B");
    var n = $d0bc2c184db42dfb$var$fromHex("FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551");
    var h = $d0bc2c184db42dfb$var$BigInteger.ONE;
    var curve = new $jBdzf.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("046B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C2964FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5");
    return new $d0bc2c184db42dfb$var$X9ECParameters(curve, G, n, h);
}
function $d0bc2c184db42dfb$var$secp384r1() {
    // p = 2^384 - 2^128 - 2^96 + 2^32 - 1
    var p = $d0bc2c184db42dfb$var$fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF");
    var a = $d0bc2c184db42dfb$var$fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC");
    var b = $d0bc2c184db42dfb$var$fromHex("B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF");
    var n = $d0bc2c184db42dfb$var$fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973");
    var h = $d0bc2c184db42dfb$var$BigInteger.ONE;
    var curve = new $jBdzf.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB73617DE4A96262C6F5D9E98BF9292DC29F8F41DBD289A147CE9DA3113B5F0B8C00A60B1CE1D7E819D7A431D7C90EA0E5F");
    return new $d0bc2c184db42dfb$var$X9ECParameters(curve, G, n, h);
}
function $d0bc2c184db42dfb$var$secp521r1() {
    // p = 2^521 - 1
    var p = $d0bc2c184db42dfb$var$fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF");
    var a = $d0bc2c184db42dfb$var$fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC");
    var b = $d0bc2c184db42dfb$var$fromHex("0051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00");
    var n = $d0bc2c184db42dfb$var$fromHex("01FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409");
    var h = $d0bc2c184db42dfb$var$BigInteger.ONE;
    var curve = new $jBdzf.ECCurveFp(p, a, b);
    var G = curve.decodePointHex("0400C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66011839296A789A3BC0045C8A5FB42C7D1BD998F54449579B446817AFBD17273E662C97EE72995EF42640C550B9013FAD0761353C7086A272C24088BE94769FD16650");
    return new $d0bc2c184db42dfb$var$X9ECParameters(curve, G, n, h);
}
// ----------------
// Public API
var $d0bc2c184db42dfb$var$CURVES = module.exports = {
    "secp256r1": $d0bc2c184db42dfb$var$secp256r1(),
    "secp384r1": $d0bc2c184db42dfb$var$secp384r1(),
    "secp521r1": $d0bc2c184db42dfb$var$secp521r1()
};
// also export NIST names
$d0bc2c184db42dfb$var$CURVES["P-256"] = $d0bc2c184db42dfb$var$CURVES.secp256r1;
$d0bc2c184db42dfb$var$CURVES["P-384"] = $d0bc2c184db42dfb$var$CURVES.secp384r1;
$d0bc2c184db42dfb$var$CURVES["P-521"] = $d0bc2c184db42dfb$var$CURVES.secp521r1;

});



parcelRegister("klWr4", function(module, exports) {
/*!
 * algorithms/hkdf.js - HMAC-based Extract-and-Expand Key Derivation
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ed1318eef8a815f8$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1YNha = parcelRequire("1YNha");

var $ky6eE = parcelRequire("ky6eE");
function $ed1318eef8a815f8$var$hkdfDeriveFn(name) {
    var hash = name.replace("HKDF-", ""), op = name.replace("HKDF-SHA-", "HS");
    // NOTE: no nodejs/webcrypto/fallback model, since this HKDF is
    //       implemented using the HMAC algorithms
    var fn = function(key, props) {
        var hashLen = $1YNha.HASHLENGTH[hash] / 8;
        if ("string" === typeof op) op = $ky6eE[op].sign;
        // prepare options
        props = props || {};
        var salt = props.salt;
        if (!salt || 0 === salt.length) salt = $ed1318eef8a815f8$require$Buffer.alloc(hashLen);
        var info = props.info || $ed1318eef8a815f8$require$Buffer.alloc(0);
        var keyLen = props.length || hashLen;
        var promise;
        // Setup Expansion
        var N = Math.ceil(keyLen / hashLen), okm = [], idx = 0;
        function expand(key, T) {
            if (N === idx++) return $ed1318eef8a815f8$require$Buffer.concat(okm).slice(0, keyLen);
            if (!T) T = $ed1318eef8a815f8$require$Buffer.alloc(0);
            T = $ed1318eef8a815f8$require$Buffer.concat([
                T,
                info,
                $ed1318eef8a815f8$require$Buffer.from([
                    idx
                ])
            ]);
            T = op(key, T);
            T = T.then(function(result) {
                T = result.mac;
                okm.push(T);
                return expand(key, T);
            });
            return T;
        }
        // Step 1: Extract
        promise = op(salt, key, {
            length: salt.length * 8
        });
        promise = promise.then(function(result) {
            // Step 2: Expand
            return expand(result.mac);
        });
        return promise;
    };
    return fn;
}
// Public API
// * [name].derive
var $ed1318eef8a815f8$var$hkdf = {};
[
    "HKDF-SHA-1",
    "HKDF-SHA-256",
    "HKDF-SHA-384",
    "HKDF-SHA-512"
].forEach(function(name) {
    $ed1318eef8a815f8$var$hkdf[name] = {
        derive: $ed1318eef8a815f8$var$hkdfDeriveFn(name)
    };
});
module.exports = $ed1318eef8a815f8$var$hkdf;

});


parcelRegister("emih6", function(module, exports) {
/*!
 * algorithms/ecdsa.js - Elliptic Curve Digitial Signature Algorithms
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $a7414bc38a038bb6$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $kHHwO = parcelRequire("kHHwO");

var $7gM1u = parcelRequire("7gM1u");

var $f4IS9 = parcelRequire("f4IS9");
function $a7414bc38a038bb6$var$idealCurve(hash) {
    switch(hash){
        case "SHA-256":
            return "P-256";
        case "SHA-384":
            return "P-384";
        case "SHA-512":
            return "P-521";
        default:
            throw new Error("unsupported hash: " + hash);
    }
}
function $a7414bc38a038bb6$var$ecdsaSignFN(hash) {
    var curve = $a7414bc38a038bb6$var$idealCurve(hash);
    // ### Fallback implementation -- uses forge
    var fallback = function(key, pdata /*, props */ ) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var pk = $kHHwO.convertToForge(key, false);
        var promise;
        // generate hash
        promise = $f4IS9[hash].digest(pdata);
        // sign hash
        promise = promise.then(function(result) {
            result = pk.sign(result);
            result = $a7414bc38a038bb6$require$Buffer.concat([
                result.r,
                result.s
            ]);
            return {
                data: pdata,
                mac: result
            };
        });
        return promise;
    };
    // ### WebCrypto API implementation
    var webcrypto = function(key, pdata /*, props */ ) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var pk = $kHHwO.convertToJWK(key, false);
        var promise;
        var alg = {
            name: "ECDSA",
            namedCurve: pk.crv,
            hash: {
                name: hash
            }
        };
        promise = $7gM1u.subtleCrypto.importKey("jwk", pk, alg, true, [
            "sign"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            result = $a7414bc38a038bb6$require$Buffer.from(result);
            return {
                data: pdata,
                mac: result
            };
        });
        return promise;
    };
    var nodejs;
    var nodeHash = hash.toLowerCase().replace("-", "");
    if ($7gM1u.nodeCrypto && $7gM1u.nodeCrypto.getHashes().indexOf(nodeHash) > -1) nodejs = function(key, pdata) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var promise;
        promise = Promise.resolve($7gM1u.nodeCrypto.createSign(nodeHash));
        promise = promise.then(function(sign) {
            sign.update(pdata);
            return sign;
        });
        var size;
        switch(nodeHash.slice(-3)){
            case "384":
                size = 48;
                break;
            case "512":
                size = 66;
                break;
            default:
                size = 32;
        }
        promise = promise.then(function(sign) {
            return $kHHwO.derToConcat(sign.sign($kHHwO.convertToPEM(key, true)), size);
        });
        promise = promise.then(function(result) {
            return {
                data: pdata,
                mac: result
            };
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $a7414bc38a038bb6$var$ecdsaVerifyFN(hash) {
    var curve = $a7414bc38a038bb6$var$idealCurve(hash);
    // ### Fallback implementation -- uses forge
    var fallback = function(key, pdata, mac /*, props */ ) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var pk = $kHHwO.convertToForge(key, true);
        var promise;
        // generate hash
        promise = $f4IS9[hash].digest(pdata);
        // verify hash
        promise = promise.then(function(result) {
            var len = mac.length / 2;
            var rs = {
                r: mac.slice(0, len),
                s: mac.slice(len)
            };
            if (!pk.verify(result, rs)) return Promise.reject(new Error("verification failed"));
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    // ### WebCrypto API implementation
    var webcrypto = function(key, pdata, mac /* , props */ ) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var pk = $kHHwO.convertToJWK(key, true);
        var promise;
        var alg = {
            name: "ECDSA",
            namedCurve: pk.crv,
            hash: {
                name: hash
            }
        };
        promise = $7gM1u.subtleCrypto.importKey("jwk", pk, alg, true, [
            "verify"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function(result) {
            if (!result) return Promise.reject(new Error("verification failed"));
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    var nodejs;
    var nodeHash = hash.toLowerCase().replace("-", "");
    if ($7gM1u.nodeCrypto && $7gM1u.nodeCrypto.getHashes().indexOf(nodeHash) > -1) nodejs = function(key, pdata, mac /* , props */ ) {
        if (curve !== key.crv) return Promise.reject(new Error("invalid curve"));
        var size;
        switch(nodeHash.slice(-3)){
            case "384":
                size = 48;
                break;
            case "512":
                size = 66;
                break;
            default:
                size = 32;
        }
        var promise;
        promise = Promise.resolve($7gM1u.nodeCrypto.createVerify(nodeHash));
        promise = promise.then(function(verify) {
            verify.update(pdata);
            verify.end();
            return verify.verify($kHHwO.convertToPEM(key, false), $kHHwO.concatToDer(mac, size));
        });
        promise = promise.then(function(result) {
            if (!result) throw new Error("verification failed");
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### Public API
var $a7414bc38a038bb6$var$ecdsa = {};
// * [name].sign
// * [name].verify
[
    "ES256",
    "ES384",
    "ES512"
].forEach(function(name) {
    var hash = name.replace(/ES(\d+)/g, function(m, size) {
        return "SHA-" + size;
    });
    $a7414bc38a038bb6$var$ecdsa[name] = {
        sign: $a7414bc38a038bb6$var$ecdsaSignFN(hash),
        verify: $a7414bc38a038bb6$var$ecdsaVerifyFN(hash)
    };
});
module.exports = $a7414bc38a038bb6$var$ecdsa;

});

parcelRegister("4gqAU", function(module, exports) {
/*!
 * algorithms/pbes2.js - Password-Based Encryption (v2) Algorithms
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $31ad4920afdf5920$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $2rglK = parcelRequire("2rglK");

var $jIqqR = parcelRequire("jIqqR");

var $7gM1u = parcelRequire("7gM1u");

var $1YNha = parcelRequire("1YNha");

var $8eyMA = parcelRequire("8eyMA");
var $31ad4920afdf5920$var$NULL_BUFFER = $31ad4920afdf5920$require$Buffer.from([
    0
]);
var $31ad4920afdf5920$var$DEFAULT_ITERATIONS = 8192;
var $31ad4920afdf5920$var$DEFAULT_SALT_LENGTH = 16;
function $31ad4920afdf5920$var$fixSalt(hmac, kw, salt) {
    var alg = "PBES2-" + hmac + "+" + kw;
    var output = [
        $31ad4920afdf5920$require$Buffer.from(alg, "utf8"),
        $31ad4920afdf5920$var$NULL_BUFFER,
        salt
    ];
    return $31ad4920afdf5920$require$Buffer.concat(output);
}
function $31ad4920afdf5920$var$pbkdf2Fn(hash) {
    function prepareProps(props) {
        props = props || {};
        var keyLen = props.length || 0;
        var salt = $jIqqR.asBuffer(props.salt || $31ad4920afdf5920$require$Buffer.alloc(0), "base64u4l"), itrs = props.iterations || 0;
        if (0 >= keyLen) throw new Error("invalid key length");
        if (0 >= itrs) throw new Error("invalid iteration count");
        props.length = keyLen;
        props.salt = salt;
        props.iterations = itrs;
        return props;
    }
    var fallback = function(key, props) {
        try {
            props = prepareProps(props);
        } catch (err) {
            return Promise.reject(err);
        }
        var keyLen = props.length, salt = props.salt, itrs = props.iterations;
        var promise = new Promise(function(resolve, reject) {
            var md = $as9F1.md[hash.replace("-", "").toLowerCase()].create();
            var cb = function(err, dk) {
                if (err) reject(err);
                else {
                    dk = $31ad4920afdf5920$require$Buffer.from(dk, "binary");
                    resolve(dk);
                }
            };
            $as9F1.pkcs5.pbkdf2(key.toString("binary"), salt.toString("binary"), itrs, keyLen, md, cb);
        });
        return promise;
    };
    var webcrypto = function(key, props) {
        try {
            props = prepareProps(props);
        } catch (err) {
            return Promise.reject(err);
        }
        var keyLen = props.length, salt = props.salt, itrs = props.iterations;
        var promise = Promise.resolve(key);
        promise = promise.then(function(keyval) {
            return $7gM1u.subtleCrypto.importKey("raw", keyval, "PBKDF2", false, [
                "deriveBits"
            ]);
        });
        promise = promise.then(function(key) {
            var mainAlgo = {
                name: "PBKDF2",
                salt: new Uint8Array(salt),
                iterations: itrs,
                hash: hash
            };
            return $7gM1u.subtleCrypto.deriveBits(mainAlgo, key, keyLen * 8);
        });
        promise = promise.then(function(result) {
            return $jIqqR.asBuffer(result);
        });
        return promise;
    };
    var nodejs = function(key, props) {
        if (6 > $7gM1u.nodeCrypto.pbkdf2.length) throw new Error("unsupported algorithm: PBKDF2-" + hash);
        try {
            props = prepareProps(props);
        } catch (err) {
            return Promise.reject(err);
        }
        var keyLen = props.length, salt = props.salt, itrs = props.iterations;
        var md = hash.replace("-", "");
        var promise = new Promise(function(resolve, reject) {
            function cb(err, dk) {
                if (err) reject(err);
                else resolve(dk);
            }
            $7gM1u.nodeCrypto.pbkdf2(key, salt, itrs, keyLen, md, cb);
        });
        return promise;
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $31ad4920afdf5920$var$pbes2EncryptFN(hmac, kw) {
    var deriveAlg = "PBKDF2-" + hmac.replace("HS", "SHA-");
    var keyLen = $1YNha.KEYLENGTH[kw] / 8;
    return function(key, pdata, props) {
        props = props || {};
        var salt = $jIqqR.asBuffer(props.p2s || $31ad4920afdf5920$require$Buffer.alloc(0), "base64url"), itrs = props.p2c || $31ad4920afdf5920$var$DEFAULT_ITERATIONS;
        if (0 >= itrs) throw new Error("invalid iteration count");
        if (0 === salt.length) salt = $jIqqR.randomBytes($31ad4920afdf5920$var$DEFAULT_SALT_LENGTH);
        else if (8 > salt.length) throw new Error("salt too small");
        var header = {
            p2s: $jIqqR.base64url.encode(salt),
            p2c: itrs
        };
        salt = $31ad4920afdf5920$var$fixSalt(hmac, kw, salt);
        props = $2rglK(props, {
            salt: salt,
            iterations: itrs,
            length: keyLen
        });
        var promise = Promise.resolve(key);
        // STEP 1: derive shared key
        promise = promise.then(function(key) {
            return $31ad4920afdf5920$var$pbes2[deriveAlg].derive(key, props);
        });
        // STEP 2: encrypt cek
        promise = promise.then(function(dk) {
            return $8eyMA[kw].encrypt(dk, pdata);
        });
        // STEP 3: (re-)apply headers
        promise = promise.then(function(results) {
            results.header = $2rglK(results.header || {}, header);
            return results;
        });
        return promise;
    };
}
function $31ad4920afdf5920$var$pbes2DecryptFN(hmac, kw) {
    var deriveAlg = "PBKDF2-" + hmac.replace("HS", "SHA-");
    var keyLen = $1YNha.KEYLENGTH[kw] / 8;
    return function(key, cdata, props) {
        props = props || {};
        var salt = $jIqqR.asBuffer(props.p2s || $31ad4920afdf5920$require$Buffer.alloc(0), "base64url"), itrs = props.p2c || 0;
        if (0 >= itrs) return Promise.reject(new Error("invalid iteration count"));
        if (8 > salt.length) return Promise.reject(new Error("salt too small"));
        salt = $31ad4920afdf5920$var$fixSalt(hmac, kw, salt);
        props = $2rglK(props, {
            salt: salt,
            iterations: itrs,
            length: keyLen
        });
        var promise = Promise.resolve(key);
        // STEP 1: derived shared key
        promise = promise.then(function(key) {
            return $31ad4920afdf5920$var$pbes2[deriveAlg].derive(key, props);
        });
        // STEP 2: decrypt cek
        promise = promise.then(function(dk) {
            return $8eyMA[kw].decrypt(dk, cdata);
        });
        return promise;
    };
}
// ### Public API
var $31ad4920afdf5920$var$pbes2 = {};
// * [name].derive
[
    "PBKDF2-SHA-256",
    "PBKDF2-SHA-384",
    "PBKDF2-SHA-512"
].forEach(function(alg) {
    var hash = alg.replace("PBKDF2-", "");
    $31ad4920afdf5920$var$pbes2[alg] = {
        derive: $31ad4920afdf5920$var$pbkdf2Fn(hash)
    };
});
// [name].encrypt
// [name].decrypt
[
    "PBES2-HS256+A128KW",
    "PBES2-HS384+A192KW",
    "PBES2-HS512+A256KW"
].forEach(function(alg) {
    var parts = /PBES2-(HS\d+)\+(A\d+KW)/g.exec(alg);
    var hmac = parts[1], kw = parts[2];
    $31ad4920afdf5920$var$pbes2[alg] = {
        encrypt: $31ad4920afdf5920$var$pbes2EncryptFN(hmac, kw),
        decrypt: $31ad4920afdf5920$var$pbes2DecryptFN(hmac, kw)
    };
});
module.exports = $31ad4920afdf5920$var$pbes2;

});

parcelRegister("lInl9", function(module, exports) {
/*!
 * algorithms/rsaes.js - RSA Signatures
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $fcefcfe7f20158ca$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $7gM1u = parcelRequire("7gM1u");

var $7y5jX = parcelRequire("7y5jX");

var $lndkx = parcelRequire("lndkx");
var $fcefcfe7f20158ca$var$nodeSupport = {
    "RSA-OAEP": "RSA_PKCS1_OAEP_PADDING",
    RSA1_5: "RSA_PKCS1_PADDING"
};
function $fcefcfe7f20158ca$var$nodeSupportCheck(name) {
    return $7gM1u.nodeCrypto && $7gM1u.nodeCrypto.constants && Object.keys($fcefcfe7f20158ca$var$nodeSupport).indexOf(name) !== -1;
}
// ### RSAES-PKCS1-v1_5
// ### RSAES-OAEP
function $fcefcfe7f20158ca$var$rsaesEncryptFn(name) {
    var alg = {
        name: name
    };
    if ("RSA-OAEP-256" === name) {
        alg.name = "RSA-OAEP";
        alg.hash = {
            name: "SHA-256"
        };
    } else if ("RSA-OAEP" === name) alg.hash = {
        name: "SHA-1"
    };
    else alg.name = "RSAES-PKCS1-v1_5";
    // ### Fallback Implementation -- uses forge
    var fallback = function(key, pdata) {
        // convert pdata to byte string
        pdata = new $7y5jX(pdata).bytes();
        // encrypt it
        var pki = $lndkx.convertToForge(key, true), params = {};
        if ("RSA-OAEP" === alg.name) {
            params.md = alg.hash.name.toLowerCase().replace(/-/g, "");
            params.md = $as9F1.md[params.md].create();
        }
        var cdata = pki.encrypt(pdata, alg.name.toUpperCase(), params);
        // convert cdata to Buffer
        cdata = new $7y5jX(cdata).native();
        return Promise.resolve({
            data: cdata
        });
    };
    // ### WebCryptoAPI Implementation
    var webcrypto;
    if ("RSAES-PKCS1-v1_5" !== alg.name) webcrypto = function(key, pdata) {
        key = $lndkx.convertToJWK(key, true);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "encrypt"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.encrypt(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var cdata = $fcefcfe7f20158ca$require$Buffer.from(result);
            return {
                data: cdata
            };
        });
        return promise;
    };
    else webcrypto = null;
    var nodejs;
    if ($fcefcfe7f20158ca$var$nodeSupportCheck(name)) nodejs = function(key, pdata) {
        key = $lndkx.convertToPem(key, true);
        var cdata = $7gM1u.nodeCrypto.publicEncrypt({
            key: key,
            padding: $7gM1u.nodeCrypto.constants[$fcefcfe7f20158ca$var$nodeSupport[name]]
        }, pdata);
        return {
            data: cdata
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $fcefcfe7f20158ca$var$rsaesDecryptFn(name) {
    var alg = {
        name: name
    };
    if ("RSA-OAEP-256" === name) {
        alg.name = "RSA-OAEP";
        alg.hash = {
            name: "SHA-256"
        };
    } else if ("RSA-OAEP" === name) alg.hash = {
        name: "SHA-1"
    };
    else alg.name = "RSAES-PKCS1-v1_5";
    // ### Fallback Implementation -- uses forge
    var fallback = function(key, cdata) {
        // convert cdata to byte string
        cdata = new $7y5jX(cdata).bytes();
        // decrypt it
        var pki = $lndkx.convertToForge(key, false), params = {};
        if ("RSA-OAEP" === alg.name) {
            params.md = alg.hash.name.toLowerCase().replace(/-/g, "");
            params.md = $as9F1.md[params.md].create();
        }
        var pdata = pki.decrypt(cdata, alg.name.toUpperCase(), params);
        // convert pdata to Buffer
        pdata = new $7y5jX(pdata).native();
        return Promise.resolve(pdata);
    };
    // ### WebCryptoAPI Implementation
    var webcrypto;
    if ("RSAES-PKCS1-v1_5" !== alg.name) webcrypto = function(key, pdata) {
        key = $lndkx.convertToJWK(key, false);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "decrypt"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.decrypt(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var pdata = $fcefcfe7f20158ca$require$Buffer.from(result);
            return pdata;
        });
        return promise;
    };
    else webcrypto = null;
    var nodejs;
    if ($fcefcfe7f20158ca$var$nodeSupportCheck(name)) nodejs = function(key, pdata) {
        key = $lndkx.convertToPem(key, false);
        return $7gM1u.nodeCrypto.privateDecrypt({
            key: key,
            padding: $7gM1u.nodeCrypto.constants[$fcefcfe7f20158ca$var$nodeSupport[name]]
        }, pdata);
    };
    else if ($7gM1u.nodeCrypto && name === "RSA-OAEP") nodejs = function(key, pdata) {
        key = $lndkx.convertToPem(key, false);
        return $7gM1u.nodeCrypto.privateDecrypt(key, pdata);
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### Public API
// * [name].encrypt
// * [name].decrypt
var $fcefcfe7f20158ca$var$rsaes = {};
[
    "RSA-OAEP",
    "RSA-OAEP-256",
    "RSA1_5"
].forEach(function(name) {
    $fcefcfe7f20158ca$var$rsaes[name] = {
        encrypt: $fcefcfe7f20158ca$var$rsaesEncryptFn(name),
        decrypt: $fcefcfe7f20158ca$var$rsaesDecryptFn(name)
    };
});
module.exports = $fcefcfe7f20158ca$var$rsaes;

});
parcelRegister("lndkx", function(module, exports) {
/*!
 * algorithms/rsa-util.js - RSA Utility Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ "use strict";

var $bTYY2 = parcelRequire("bTYY2");

var $as9F1 = parcelRequire("as9F1");

var $jIqqR = parcelRequire("jIqqR");
// ### RSA-specific Helpers
function $f8f6160e0949fdb3$var$convertToForge(key, isPublic) {
    var parts = isPublic ? [
        "n",
        "e"
    ] : [
        "n",
        "e",
        "d",
        "p",
        "q",
        "dp",
        "dq",
        "qi"
    ];
    parts = parts.map(function(f) {
        return new $as9F1.jsbn.BigInteger(key[f].toString("hex"), 16);
    });
    var fn = isPublic ? $as9F1.pki.rsa.setPublicKey : $as9F1.pki.rsa.setPrivateKey;
    return fn.apply($as9F1.pki.rsa, parts);
}
function $f8f6160e0949fdb3$var$convertToJWK(key, isPublic) {
    var result = $bTYY2(key);
    var parts = isPublic ? [
        "n",
        "e"
    ] : [
        "n",
        "e",
        "d",
        "p",
        "q",
        "dp",
        "dq",
        "qi"
    ];
    parts.forEach(function(f) {
        result[f] = $jIqqR.base64url.encode(result[f]);
    });
    // remove potentially troublesome properties
    delete result.key_ops;
    delete result.use;
    delete result.alg;
    if (isPublic) {
        delete result.d;
        delete result.p;
        delete result.q;
        delete result.dp;
        delete result.dq;
        delete result.qi;
    }
    return result;
}
function $f8f6160e0949fdb3$var$convertToPem(key, isPublic) {
    var cacheKey = isPublic ? "__cachedPublicPem" : "__cachedPrivatePem";
    if (key[cacheKey]) return key[cacheKey];
    var value;
    if (isPublic) value = $as9F1.pki.publicKeyToPem($f8f6160e0949fdb3$var$convertToForge(key, isPublic));
    else value = $as9F1.pki.privateKeyToPem($f8f6160e0949fdb3$var$convertToForge(key, isPublic));
    Object.defineProperty(key, cacheKey, {
        value: value
    });
    return value;
}
module.exports = {
    convertToForge: $f8f6160e0949fdb3$var$convertToForge,
    convertToJWK: $f8f6160e0949fdb3$var$convertToJWK,
    convertToPem: $f8f6160e0949fdb3$var$convertToPem
};

});


parcelRegister("96ReK", function(module, exports) {
/*!
 * algorithms/rsassa.js - RSA Signatures
 *
 * Copyright (c) 2015 Cisco Systems, Inc.  See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $6a1df84efbf17b2d$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $1YNha = parcelRequire("1YNha");

var $7gM1u = parcelRequire("7gM1u");

var $lndkx = parcelRequire("lndkx");
function $6a1df84efbf17b2d$var$nodePSSsupport() {
    return $7gM1u.nodeCrypto && $7gM1u.nodeCrypto.constants && $7gM1u.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST;
}
// ### RSASSA-PKCS1-v1_5
function $6a1df84efbf17b2d$var$rsassaV15SignFn(name) {
    var md = name.replace("RS", "SHA").toLowerCase(), hash = name.replace("RS", "SHA-");
    var alg = {
        name: "RSASSA-PKCS1-V1_5",
        hash: {
            name: hash
        }
    };
    // ### Fallback Implementation -- uses forge
    var fallback = function(key, pdata) {
        // create the digest
        var digest = $as9F1.md[md].create();
        digest.start();
        digest.update(pdata);
        // sign it
        var pki = $lndkx.convertToForge(key, false);
        var sig = pki.sign(digest, "RSASSA-PKCS1-V1_5");
        sig = $6a1df84efbf17b2d$require$Buffer.from(sig, "binary");
        return Promise.resolve({
            data: pdata,
            mac: sig
        });
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(key, pdata) {
        key = $lndkx.convertToJWK(key, false);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "sign"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var sig = $6a1df84efbf17b2d$require$Buffer.from(result);
            return {
                data: pdata,
                mac: sig
            };
        });
        return promise;
    };
    var nodejs;
    var nodeHash = "RSA-" + hash.replace("-", "");
    if ($7gM1u.nodeCrypto && $7gM1u.nodeCrypto.getHashes().indexOf(nodeHash) > -1) nodejs = function(key, pdata) {
        var sign = $7gM1u.nodeCrypto.createSign(nodeHash);
        sign.update(pdata);
        return {
            data: pdata,
            mac: sign.sign($lndkx.convertToPem(key, false))
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $6a1df84efbf17b2d$var$rsassaV15VerifyFn(name) {
    var md = name.replace("RS", "SHA").toLowerCase(), hash = name.replace("RS", "SHA-");
    var alg = {
        name: "RSASSA-PKCS1-V1_5",
        hash: {
            name: hash
        }
    };
    // ### Fallback implementation -- uses forge
    var fallback = function(key, pdata, mac) {
        // create the digest
        var digest = $as9F1.md[md].create();
        digest.start();
        digest.update(pdata);
        digest = digest.digest().bytes();
        // verify it
        var pki = $lndkx.convertToForge(key, true);
        var sig = mac.toString("binary");
        var result = pki.verify(digest, sig, "RSASSA-PKCS1-V1_5");
        if (!result) return Promise.reject(new Error("verification failed"));
        return Promise.resolve({
            data: pdata,
            mac: mac,
            valid: true
        });
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(key, pdata, mac) {
        key = $lndkx.convertToJWK(key, true);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "verify"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function(result) {
            if (!result) return Promise.reject(new Error("verification failed"));
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    var nodejs;
    if ($7gM1u.nodeCrypto && $7gM1u.nodeCrypto.getHashes().indexOf(md) > -1) nodejs = function(key, pdata, mac) {
        var verify = $7gM1u.nodeCrypto.createVerify(md);
        verify.update(pdata);
        verify.end();
        var result = verify.verify($lndkx.convertToPem(key, true), mac);
        if (!result) return Promise.reject(new Error("verification failed"));
        return {
            data: pdata,
            mac: mac,
            valid: true
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### RSA-PSS
function $6a1df84efbf17b2d$var$rsassaPssSignFn(name) {
    var md = name.replace("PS", "SHA").toLowerCase(), hash = name.replace("PS", "SHA-");
    var alg = {
        name: "RSA-PSS",
        hash: {
            name: hash
        },
        saltLength: $1YNha.HASHLENGTH[hash] / 8
    };
    // ### Fallback implementation -- uses forge
    var fallback = function(key, pdata) {
        // create the digest
        var digest = $as9F1.md[md].create();
        digest.start();
        digest.update(pdata);
        // setup padding
        var pss = $as9F1.pss.create({
            md: $as9F1.md[md].create(),
            mgf: $as9F1.mgf.mgf1.create($as9F1.md[md].create()),
            saltLength: $1YNha.HASHLENGTH[hash] / 8
        });
        // sign it
        var pki = $lndkx.convertToForge(key, false);
        var sig = pki.sign(digest, pss);
        sig = $6a1df84efbf17b2d$require$Buffer.from(sig, "binary");
        return Promise.resolve({
            data: pdata,
            mac: sig
        });
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(key, pdata) {
        key = $lndkx.convertToJWK(key, false);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "sign"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.sign(alg, key, pdata);
        });
        promise = promise.then(function(result) {
            var sig = $6a1df84efbf17b2d$require$Buffer.from(result);
            return {
                data: pdata,
                mac: sig
            };
        });
        return promise;
    };
    var nodejs;
    var nodeHash = "RSA-" + hash.replace("-", "");
    if ($6a1df84efbf17b2d$var$nodePSSsupport()) nodejs = function(key, pdata) {
        var sign = $7gM1u.nodeCrypto.createSign(nodeHash);
        sign.update(pdata);
        var sig = sign.sign({
            key: $lndkx.convertToPem(key, false),
            padding: $7gM1u.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $7gM1u.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST
        });
        return {
            data: pdata,
            mac: sig
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
function $6a1df84efbf17b2d$var$rsassaPssVerifyFn(name) {
    var md = name.replace("PS", "SHA").toLowerCase(), hash = name.replace("PS", "SHA-");
    var alg = {
        name: "RSA-PSS",
        hash: {
            name: hash
        },
        saltLength: $1YNha.HASHLENGTH[hash] / 8
    };
    // ### Fallback implementation -- uses forge
    var fallback = function(key, pdata, mac) {
        // create the digest
        var digest = $as9F1.md[md].create();
        digest.start();
        digest.update(pdata);
        digest = digest.digest().bytes();
        // setup padding
        var pss = $as9F1.pss.create({
            md: $as9F1.md[md].create(),
            mgf: $as9F1.mgf.mgf1.create($as9F1.md[md].create()),
            saltLength: $1YNha.HASHLENGTH[hash] / 8
        });
        // verify it
        var pki = $lndkx.convertToForge(key, true);
        var sig = mac.toString("binary");
        var result = pki.verify(digest, sig, pss);
        if (!result) return Promise.reject(new Error("verification failed"));
        return Promise.resolve({
            data: pdata,
            mac: mac,
            valid: true
        });
    };
    // ### WebCryptoAPI Implementation
    var webcrypto = function(key, pdata, mac) {
        key = $lndkx.convertToJWK(key, true);
        var promise;
        promise = $7gM1u.subtleCrypto.importKey("jwk", key, alg, true, [
            "verify"
        ]);
        promise = promise.then(function(key) {
            return $7gM1u.subtleCrypto.verify(alg, key, mac, pdata);
        });
        promise = promise.then(function(result) {
            if (!result) return Promise.reject(new Error("verification failed"));
            return {
                data: pdata,
                mac: mac,
                valid: true
            };
        });
        return promise;
    };
    var nodejs;
    if ($6a1df84efbf17b2d$var$nodePSSsupport()) nodejs = function(key, pdata, mac) {
        var verify = $7gM1u.nodeCrypto.createVerify(md);
        verify.update(pdata);
        verify.end();
        var result = verify.verify({
            key: $lndkx.convertToPem(key, true),
            padding: $7gM1u.nodeCrypto.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $7gM1u.nodeCrypto.constants.RSA_PSS_SALTLEN_DIGEST
        }, mac);
        if (!result) return Promise.reject(new Error("verification failed"));
        return {
            data: pdata,
            mac: mac,
            valid: true
        };
    };
    return $7gM1u.setupFallback(nodejs, webcrypto, fallback);
}
// ### Public API
// * [name].sign
// * [name].verify
var $6a1df84efbf17b2d$var$rsassa = {};
[
    "PS256",
    "PS384",
    "PS512"
].forEach(function(name) {
    $6a1df84efbf17b2d$var$rsassa[name] = {
        sign: $6a1df84efbf17b2d$var$rsassaPssSignFn(name),
        verify: $6a1df84efbf17b2d$var$rsassaPssVerifyFn(name)
    };
});
[
    "RS256",
    "RS384",
    "RS512"
].forEach(function(name) {
    $6a1df84efbf17b2d$var$rsassa[name] = {
        sign: $6a1df84efbf17b2d$var$rsassaV15SignFn(name),
        verify: $6a1df84efbf17b2d$var$rsassaV15VerifyFn(name)
    };
});
module.exports = $6a1df84efbf17b2d$var$rsassa;

});


parcelRegister("e1ACC", function(module, exports) {
/*!
 * jwk/constants.js - Constants for JWKs
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
module.exports = {
    MODE_SIGN: "sign",
    MODE_VERIFY: "verify",
    MODE_ENCRYPT: "encrypt",
    MODE_DECRYPT: "decrypt",
    MODE_WRAP: "wrap",
    MODE_UNWRAP: "unwrap"
};

});

parcelRegister("kFzkW", function(module, exports) {
/*!
 * jwk/helpers.js - JWK Internal Helper Functions and Constants
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $f0c30c1e8594ad01$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $bTYY2 = parcelRequire("bTYY2");

var $jIqqR = parcelRequire("jIqqR");

var $as9F1 = parcelRequire("as9F1");

var $5s97J = parcelRequire("5s97J");
// ### ASN.1 Validators
// Adapted from digitalbazaar/node-forge/js/asn1.js
// PrivateKeyInfo
var $f0c30c1e8594ad01$var$privateKeyValidator = {
    name: "PrivateKeyInfo",
    tagClass: $as9F1.asn1.Class.UNIVERSAL,
    type: $as9F1.asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.INTEGER,
            constructed: false,
            capture: "keyVersion"
        },
        {
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.OID,
                    constructed: false,
                    capture: "keyOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    captureAsn1: "keyParams"
                }
            ]
        },
        {
            name: "PrivateKeyInfo",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "keyValue"
        }
    ]
};
// Adapted from digitalbazaar/node-forge/x509.js
var $f0c30c1e8594ad01$var$publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: $as9F1.asn1.Class.UNIVERSAL,
    type: $as9F1.asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.OID,
                    constructed: false,
                    capture: "keyOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    captureAsn1: "keyParams"
                }
            ]
        },
        {
            name: "SubjectPublicKeyInfo.subjectPublicKey",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.BITSTRING,
            constructed: false,
            capture: "keyValue"
        }
    ]
};
// Adapted from digitalbazaar/node-forge/x509.js
var $f0c30c1e8594ad01$var$X509CertificateValidator = {
    name: "Certificate",
    tagClass: $as9F1.asn1.Class.UNIVERSAL,
    type: $as9F1.asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Certificate.TBSCertificate",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "certificate",
            value: [
                {
                    name: "Certificate.TBSCertificate.version",
                    tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                    type: 0,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.version.integer",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.INTEGER,
                            constructed: false,
                            capture: "certVersion"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.serialNumber",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.INTEGER,
                    constructed: false,
                    capture: "certSerialNumber"
                },
                {
                    name: "Certificate.TBSCertificate.signature",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.signature.algorithm",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.OID,
                            constructed: false,
                            capture: "certSignatureOid"
                        },
                        {
                            name: "Certificate.TBSCertificate.signature.parameters",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            optional: true,
                            captureAsn1: "certSignatureParams"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.issuer",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certIssuer"
                },
                {
                    name: "Certificate.TBSCertificate.validity",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.SEQUENCE,
                    constructed: true,
                    // Note: UTC and generalized times may both appear so the capture
                    // names are based on their detected order, the names used below
                    // are only for the common case, which validity time really means
                    // "notBefore" and which means "notAfter" will be determined by order
                    value: [
                        {
                            // notBefore (Time) (UTC time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity1UTCTime"
                        },
                        {
                            // notBefore (Time) (generalized time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity2GeneralizedTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity3UTCTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity4GeneralizedTime"
                        }
                    ]
                },
                {
                    // Name (subject) (RDNSequence)
                    name: "Certificate.TBSCertificate.subject",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certSubject"
                },
                // SubjectPublicKeyInfo
                $f0c30c1e8594ad01$var$publicKeyValidator,
                {
                    // issuerUniqueID (optional)
                    name: "Certificate.TBSCertificate.issuerUniqueID",
                    tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                    type: 1,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.issuerUniqueID.id",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.BITSTRING,
                            constructed: false,
                            capture: "certIssuerUniqueId"
                        }
                    ]
                },
                {
                    // subjectUniqueID (optional)
                    name: "Certificate.TBSCertificate.subjectUniqueID",
                    tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                    type: 2,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.subjectUniqueID.id",
                            tagClass: $as9F1.asn1.Class.UNIVERSAL,
                            type: $as9F1.asn1.Type.BITSTRING,
                            constructed: false,
                            capture: "certSubjectUniqueId"
                        }
                    ]
                },
                {
                    // Extensions (optional)
                    name: "Certificate.TBSCertificate.extensions",
                    tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                    type: 3,
                    constructed: true,
                    captureAsn1: "certExtensions",
                    optional: true
                }
            ]
        },
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "Certificate.signatureAlgorithm",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "Certificate.signatureAlgorithm.algorithm",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    type: $as9F1.asn1.Type.OID,
                    constructed: false,
                    capture: "certSignatureOid"
                },
                {
                    name: "Certificate.TBSCertificate.signature.parameters",
                    tagClass: $as9F1.asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "certSignatureParams"
                }
            ]
        },
        {
            // SignatureValue
            name: "Certificate.signatureValue",
            tagClass: $as9F1.asn1.Class.UNIVERSAL,
            type: $as9F1.asn1.Type.BITSTRING,
            constructed: false,
            capture: "certSignature"
        }
    ]
};
var $f0c30c1e8594ad01$var$INTERNALS = {
    THUMBPRINT_KEY: "internal\x00thumbprint",
    THUMBPRINT_HASH: "SHA-256"
};
module.exports = {
    validators: {
        privateKey: $f0c30c1e8594ad01$var$privateKeyValidator,
        publicKey: $f0c30c1e8594ad01$var$publicKeyValidator,
        certificate: $f0c30c1e8594ad01$var$X509CertificateValidator
    },
    thumbprint: function(cfg, json, hash) {
        if ("function" !== typeof cfg.thumbprint) return Promise.reject(new Error("thumbprint not supported"));
        hash = (hash || $f0c30c1e8594ad01$var$INTERNALS.THUMBPRINT_HASH).toUpperCase();
        var fields = cfg.thumbprint(json);
        var input = Object.keys(fields).sort().map(function(k) {
            var v = fields[k];
            if ($f0c30c1e8594ad01$require$Buffer.isBuffer(v)) v = $jIqqR.base64url.encode(v);
            return JSON.stringify(k) + ":" + JSON.stringify(v);
        });
        input = "{" + input.join(",") + "}";
        try {
            return $5s97J.digest(hash, $f0c30c1e8594ad01$require$Buffer.from(input, "utf8"));
        } catch (err) {
            return Promise.reject(err);
        }
    },
    unpackProps: function(props, allowed) {
        var output;
        // apply all of the existing values
        allowed.forEach(function(cfg) {
            if (!(cfg.name in props)) return;
            output = output || {};
            var value = props[cfg.name];
            switch(cfg.type){
                case "binary":
                    if ($f0c30c1e8594ad01$require$Buffer.isBuffer(value)) props[cfg.name] = $jIqqR.base64url.encode(value);
                    else value = $jIqqR.base64url.decode(value);
                    break;
                case "string":
                case "number":
                case "boolean":
                    break;
                case "array":
                    value = [].concat(value);
                    break;
                case "object":
                    value = $bTYY2(value);
                    break;
                default:
                    break;
            }
            output[cfg.name] = value;
        });
        // remove any from json that didn't apply
        var check = output || {};
        Object.keys(props).forEach(function(n) {
            if (n in check) return;
            delete props[n];
        });
        return output;
    },
    COMMON_PROPS: [
        {
            name: "kty",
            type: "string"
        },
        {
            name: "kid",
            type: "string"
        },
        {
            name: "use",
            type: "string"
        },
        {
            name: "alg",
            type: "string"
        },
        {
            name: "x5c",
            type: "array"
        },
        {
            name: "x5t",
            type: "binary"
        },
        {
            name: "x5u",
            type: "string"
        },
        {
            name: "key_ops",
            type: "array"
        }
    ],
    INTERNALS: $f0c30c1e8594ad01$var$INTERNALS
};

});



parcelRegister("cXohl", function(module, exports) {
/*!
 * jwk/octkey.js - Symmetric Octet Key Representation
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $96edd3f3fc4d2164$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $jIqqR = parcelRequire("jIqqR");


var $96edd3f3fc4d2164$var$JWK = {
    BaseKey: (parcelRequire("lQKdq")),
    helpers: (parcelRequire("kFzkW"))
};
var $96edd3f3fc4d2164$var$SIG_ALGS = [
    "HS256",
    "HS384",
    "HS512"
];
var $96edd3f3fc4d2164$var$ENC_ALGS = [
    "A128GCM",
    "A192GCM",
    "A256GCM",
    "A128CBC-HS256",
    "A192CBC-HS384",
    "A256CBC-HS512",
    "A128CBC+HS256",
    "A192CBC+HS384",
    "A256CBC+HS512"
];
var $96edd3f3fc4d2164$var$WRAP_ALGS = [
    "A128KW",
    "A192KW",
    "A256KW",
    "A128GCMKW",
    "A192GCMKW",
    "A256GCMKW",
    "PBES2-HS256+A128KW",
    "PBES2-HS384+A192KW",
    "PBES2-HS512+A256KW",
    "dir"
];
function $96edd3f3fc4d2164$var$adjustDecryptProps(alg, props) {
    if ("iv" in props) props.iv = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.iv) ? props.iv : $jIqqR.base64url.decode(props.iv || "");
    if ("adata" in props) props.adata = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.adata) ? props.adata : $96edd3f3fc4d2164$require$Buffer.from(props.adata || "", "utf8");
    if ("mac" in props) props.mac = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.mac) ? props.mac : $jIqqR.base64url.decode(props.mac || "");
    if ("tag" in props) props.tag = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.tag) ? props.tag : $jIqqR.base64url.decode(props.tag || "");
    return props;
}
function $96edd3f3fc4d2164$var$adjustEncryptProps(alg, props) {
    if ("iv" in props) props.iv = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.iv) ? props.iv : $jIqqR.base64url.decode(props.iv || "");
    if ("adata" in props) props.adata = $96edd3f3fc4d2164$require$Buffer.isBuffer(props.adata) ? props.adata : $96edd3f3fc4d2164$require$Buffer.from(props.adata || "", "utf8");
    return props;
}
var $96edd3f3fc4d2164$var$JWKOctetCfg = {
    publicKey: function(props) {
        var fields = $96edd3f3fc4d2164$var$JWK.helpers.COMMON_PROPS.concat([]);
        var pk;
        pk = $96edd3f3fc4d2164$var$JWK.helpers.unpackProps(props, fields);
        return pk;
    },
    privateKey: function(props) {
        var fields = $96edd3f3fc4d2164$var$JWK.helpers.COMMON_PROPS.concat([
            {
                name: "k",
                type: "binary"
            }
        ]);
        var pk;
        pk = $96edd3f3fc4d2164$var$JWK.helpers.unpackProps(props, fields);
        if (pk && pk.k) pk.length = pk.k.length * 8;
        else pk = undefined;
        return pk;
    },
    thumbprint: function(json) {
        if (json.private) json = json.private;
        var fields;
        fields = {
            k: json.k || "",
            kty: "oct"
        };
        return fields;
    },
    algorithms: function(keys, mode) {
        var len = keys.private && keys.private.k.length * 8;
        var mins = [
            256,
            384,
            512
        ];
        if (!len) return [];
        switch(mode){
            case "encrypt":
            case "decrypt":
                return $96edd3f3fc4d2164$var$ENC_ALGS.filter(function(a) {
                    return a === "A" + len / 2 + "CBC-HS" + len || a === "A" + len / 2 + "CBC+HS" + len || a === "A" + len + "GCM";
                });
            case "sign":
            case "verify":
                // TODO: allow for HS{less-than-keysize}
                return $96edd3f3fc4d2164$var$SIG_ALGS.filter(function(a) {
                    var result = false;
                    mins.forEach(function(m) {
                        if (m > len) return;
                        result = result | a === "HS" + m;
                    });
                    return result;
                });
            case "wrap":
            case "unwrap":
                return $96edd3f3fc4d2164$var$WRAP_ALGS.filter(function(a) {
                    return a === "A" + len + "KW" || a === "A" + len + "GCMKW" || a.indexOf("PBES2-") === 0 || a === "dir";
                });
        }
        return [];
    },
    encryptKey: function(alg, keys) {
        return keys.private && keys.private.k;
    },
    encryptProps: $96edd3f3fc4d2164$var$adjustEncryptProps,
    decryptKey: function(alg, keys) {
        return keys.private && keys.private.k;
    },
    decryptProps: $96edd3f3fc4d2164$var$adjustDecryptProps,
    wrapKey: function(alg, keys) {
        return keys.private && keys.private.k;
    },
    wrapProps: $96edd3f3fc4d2164$var$adjustEncryptProps,
    unwrapKey: function(alg, keys) {
        return keys.private && keys.private.k;
    },
    unwrapProps: $96edd3f3fc4d2164$var$adjustDecryptProps,
    signKey: function(alg, keys) {
        return keys.private && keys.private.k;
    },
    verifyKey: function(alg, keys) {
        return keys.private && keys.private.k;
    }
};
// Factory
var $96edd3f3fc4d2164$var$JWKOctetFactory = {
    kty: "oct",
    prepare: function(props) {
        // TODO: validate key properties
        var cfg = $96edd3f3fc4d2164$var$JWKOctetCfg;
        var p = Promise.resolve(props);
        p = p.then(function(json) {
            return $96edd3f3fc4d2164$var$JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function(hash) {
            var prints = {};
            prints[$96edd3f3fc4d2164$var$JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
            props[$96edd3f3fc4d2164$var$JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
            return cfg;
        });
        return p;
    },
    generate: function(size) {
        // TODO: validate key sizes
        var key = $jIqqR.randomBytes(size / 8);
        return Promise.resolve({
            k: key
        });
    }
};
// public API
module.exports = Object.freeze({
    config: $96edd3f3fc4d2164$var$JWKOctetCfg,
    factory: $96edd3f3fc4d2164$var$JWKOctetFactory
});

// registration
(function(REGISTRY) {
    REGISTRY.register($96edd3f3fc4d2164$var$JWKOctetFactory);
})((parcelRequire("2bizm")).registry);

});

parcelRegister("hOkjG", function(module, exports) {
/*!
 * jwk/rsa.js - RSA Key Representation
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $cf76dd9f1511171c$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $as9F1 = parcelRequire("as9F1");

var $lndkx = parcelRequire("lndkx");

var $7gM1u = parcelRequire("7gM1u");
var $cf76dd9f1511171c$require$nodeCrypto = $7gM1u.nodeCrypto;


var $cf76dd9f1511171c$var$JWK = {
    BaseKey: (parcelRequire("lQKdq")),
    helpers: (parcelRequire("kFzkW"))
};
var $cf76dd9f1511171c$var$SIG_ALGS = [
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512"
];
var $cf76dd9f1511171c$var$WRAP_ALGS = [
    "RSA-OAEP",
    "RSA-OAEP-256",
    "RSA1_5"
];
var $cf76dd9f1511171c$var$JWKRsaCfg = {
    publicKey: function(props) {
        var fields = $cf76dd9f1511171c$var$JWK.helpers.COMMON_PROPS.concat([
            {
                name: "n",
                type: "binary"
            },
            {
                name: "e",
                type: "binary"
            }
        ]);
        var pk;
        pk = $cf76dd9f1511171c$var$JWK.helpers.unpackProps(props, fields);
        if (pk && pk.n && pk.e) pk.length = pk.n.length * 8;
        else {
            delete pk.e;
            delete pk.n;
        }
        return pk;
    },
    privateKey: function(props) {
        var fields = $cf76dd9f1511171c$var$JWK.helpers.COMMON_PROPS.concat([
            {
                name: "n",
                type: "binary"
            },
            {
                name: "e",
                type: "binary"
            },
            {
                name: "d",
                type: "binary"
            },
            {
                name: "p",
                type: "binary"
            },
            {
                name: "q",
                type: "binary"
            },
            {
                name: "dp",
                type: "binary"
            },
            {
                name: "dq",
                type: "binary"
            },
            {
                name: "qi",
                type: "binary"
            }
        ]);
        var pk;
        pk = $cf76dd9f1511171c$var$JWK.helpers.unpackProps(props, fields);
        if (pk && pk.d && pk.n && pk.e && pk.p && pk.q && pk.dp && pk.dq && pk.qi) pk.length = pk.d.length * 8;
        else pk = undefined;
        return pk;
    },
    thumbprint: function(json) {
        if (json.public) json = json.public;
        var fields = {
            e: json.e,
            kty: "RSA",
            n: json.n
        };
        return fields;
    },
    algorithms: function(keys, mode) {
        switch(mode){
            case "encrypt":
            case "decrypt":
                return [];
            case "wrap":
                return keys.public && $cf76dd9f1511171c$var$WRAP_ALGS.slice() || [];
            case "unwrap":
                return keys.private && $cf76dd9f1511171c$var$WRAP_ALGS.slice() || [];
            case "sign":
                return keys.private && $cf76dd9f1511171c$var$SIG_ALGS.slice() || [];
            case "verify":
                return keys.public && $cf76dd9f1511171c$var$SIG_ALGS.slice() || [];
        }
        return [];
    },
    wrapKey: function(alg, keys) {
        return keys.public;
    },
    unwrapKey: function(alg, keys) {
        return keys.private;
    },
    signKey: function(alg, keys) {
        return keys.private;
    },
    verifyKey: function(alg, keys) {
        return keys.public;
    },
    convertToPEM: function(key, isPrivate) {
        var k = $lndkx.convertToForge(key, !isPrivate);
        if (!isPrivate) return $as9F1.pki.publicKeyToPem(k);
        return $as9F1.pki.privateKeyToPem(k);
    }
};
function $cf76dd9f1511171c$var$convertBNtoBuffer(bn) {
    bn = bn.toString(16);
    if (bn.length % 2) bn = "0" + bn;
    return $cf76dd9f1511171c$require$Buffer.from(bn, "hex");
}
// Adapted from digitalbaazar/node-forge/js/rsa.js
var $cf76dd9f1511171c$var$validators = {
    oid: "1.2.840.113549.1.1.1",
    privateKey: {
        name: "RSAPrivateKey",
        tagClass: $as9F1.asn1.Class.UNIVERSAL,
        type: $as9F1.asn1.Type.SEQUENCE,
        constructed: true,
        value: [
            {
                // Version (INTEGER)
                name: "RSAPrivateKey.version",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "version"
            },
            {
                // modulus (n)
                name: "RSAPrivateKey.modulus",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "n"
            },
            {
                // publicExponent (e)
                name: "RSAPrivateKey.publicExponent",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "e"
            },
            {
                // privateExponent (d)
                name: "RSAPrivateKey.privateExponent",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "d"
            },
            {
                // prime1 (p)
                name: "RSAPrivateKey.prime1",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "p"
            },
            {
                // prime2 (q)
                name: "RSAPrivateKey.prime2",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "q"
            },
            {
                // exponent1 (d mod (p-1))
                name: "RSAPrivateKey.exponent1",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "dp"
            },
            {
                // exponent2 (d mod (q-1))
                name: "RSAPrivateKey.exponent2",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "dq"
            },
            {
                // coefficient ((inverse of q) mod p)
                name: "RSAPrivateKey.coefficient",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "qi"
            }
        ]
    },
    publicKey: {
        // RSAPublicKey
        name: "RSAPublicKey",
        tagClass: $as9F1.asn1.Class.UNIVERSAL,
        type: $as9F1.asn1.Type.SEQUENCE,
        constructed: true,
        value: [
            {
                // modulus (n)
                name: "RSAPublicKey.modulus",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "n"
            },
            {
                // publicExponent (e)
                name: "RSAPublicKey.exponent",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false,
                capture: "e"
            }
        ]
    }
};
// Factory
var $cf76dd9f1511171c$var$JWKRsaFactory = {
    kty: "RSA",
    validators: $cf76dd9f1511171c$var$validators,
    prepare: function(props) {
        // TODO: validate key properties
        var cfg = $cf76dd9f1511171c$var$JWKRsaCfg;
        var p = Promise.resolve(props);
        p = p.then(function(json) {
            return $cf76dd9f1511171c$var$JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function(hash) {
            var prints = {};
            prints[$cf76dd9f1511171c$var$JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
            props[$cf76dd9f1511171c$var$JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
            return cfg;
        });
        return p;
    },
    generate: function(size) {
        // TODO: validate key sizes
        var promise;
        if ($cf76dd9f1511171c$require$nodeCrypto) promise = new Promise(function(resolve, reject) {
            $as9F1.pki.rsa.generateKeyPair({
                bits: size,
                e: 0x010001
            }, function(err, key) {
                if (err) return reject(err);
                resolve(key.privateKey);
            });
        });
        else {
            var key = $as9F1.pki.rsa.generateKeyPair({
                bits: size,
                e: 0x010001
            });
            promise = Promise.resolve(key.privateKey);
        }
        return promise.then(function(key) {
            // convert to JSON-ish
            var result = {};
            [
                "e",
                "n",
                "d",
                "p",
                "q",
                {
                    incoming: "dP",
                    outgoing: "dp"
                },
                {
                    incoming: "dQ",
                    outgoing: "dq"
                },
                {
                    incoming: "qInv",
                    outgoing: "qi"
                }
            ].forEach(function(f) {
                var incoming, outgoing;
                if ("string" === typeof f) incoming = outgoing = f;
                else {
                    incoming = f.incoming;
                    outgoing = f.outgoing;
                }
                if (incoming in key) result[outgoing] = $cf76dd9f1511171c$var$convertBNtoBuffer(key[incoming]);
            });
            return result;
        });
    },
    import: function(input) {
        if ($cf76dd9f1511171c$var$validators.oid !== input.keyOid) return null;
        if (!input.parsed) {
            // coerce capture.keyValue to DER
            if ("string" === typeof input.keyValue) input.keyValue = $as9F1.asn1.fromDer(input.keyValue);
            else if (Array.isArray(input.keyValue)) input.keyValue = input.keyValue[0];
            // capture key factors
            var validator = "private" === input.type ? $cf76dd9f1511171c$var$validators.privateKey : $cf76dd9f1511171c$var$validators.publicKey;
            var capture = {}, errors = [];
            if (!$as9F1.asn1.validate(input.keyValue, validator, capture, errors)) return null;
            input = capture;
        }
        // convert factors to Buffers
        var output = {
            kty: "RSA"
        };
        [
            "n",
            "e",
            "d",
            "p",
            "q",
            "dp",
            "dq",
            "qi"
        ].forEach(function(f) {
            if (!(f in input)) return;
            var b = $cf76dd9f1511171c$require$Buffer.from(input[f], "binary");
            // remove leading zero padding if any
            if (0 === b[0]) b = b.slice(1);
            output[f] = b;
        });
        return output;
    }
};
// public API
module.exports = Object.freeze({
    config: $cf76dd9f1511171c$var$JWKRsaCfg,
    factory: $cf76dd9f1511171c$var$JWKRsaFactory
});

// registration
(function(REGISTRY) {
    REGISTRY.register($cf76dd9f1511171c$var$JWKRsaFactory);
})((parcelRequire("2bizm")).registry);

});

parcelRegister("f8Ul6", function(module, exports) {
/*!
 * jwk/rsa.js - RSA Key Representation
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $b0634e2c4337a908$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $kHHwO = parcelRequire("kHHwO");

var $as9F1 = parcelRequire("as9F1");

var $fwJVv = parcelRequire("fwJVv");


var $b0634e2c4337a908$var$JWK = {
    BaseKey: (parcelRequire("lQKdq")),
    helpers: (parcelRequire("kFzkW"))
};
var $b0634e2c4337a908$var$SIG_ALGS = [
    "ES256",
    "ES384",
    "ES512"
];
var $b0634e2c4337a908$var$WRAP_ALGS = [
    "ECDH-ES",
    "ECDH-ES+A128KW",
    "ECDH-ES+A192KW",
    "ECDH-ES+A256KW"
];
var $b0634e2c4337a908$var$EC_OID = $kHHwO.EC_OID;
function $b0634e2c4337a908$var$oidToCurveName(oid) {
    switch(oid){
        case "1.2.840.10045.3.1.7":
            return "P-256";
        case "1.3.132.0.34":
            return "P-384";
        case "1.3.132.0.35":
            return "P-521";
        default:
            return null;
    }
}
var $b0634e2c4337a908$var$JWKEcCfg = {
    publicKey: function(props) {
        var fields = $b0634e2c4337a908$var$JWK.helpers.COMMON_PROPS.concat([
            {
                name: "crv",
                type: "string"
            },
            {
                name: "x",
                type: "binary"
            },
            {
                name: "y",
                type: "binary"
            }
        ]);
        var pk = $b0634e2c4337a908$var$JWK.helpers.unpackProps(props, fields);
        if (pk && pk.crv && pk.x && pk.y) pk.length = $kHHwO.curveSize(pk.crv);
        else {
            delete pk.crv;
            delete pk.x;
            delete pk.y;
        }
        return pk;
    },
    privateKey: function(props) {
        var fields = $b0634e2c4337a908$var$JWK.helpers.COMMON_PROPS.concat([
            {
                name: "crv",
                type: "string"
            },
            {
                name: "x",
                type: "binary"
            },
            {
                name: "y",
                type: "binary"
            },
            {
                name: "d",
                type: "binary"
            }
        ]);
        var pk = $b0634e2c4337a908$var$JWK.helpers.unpackProps(props, fields);
        if (pk && pk.crv && pk.x && pk.y && pk.d) pk.length = $kHHwO.curveSize(pk.crv);
        else pk = undefined;
        return pk;
    },
    thumbprint: function(json) {
        if (json.public) json = json.public;
        var fields = {
            crv: json.crv,
            kty: "EC",
            x: json.x,
            y: json.y
        };
        return fields;
    },
    algorithms: function(keys, mode) {
        var len = keys.public && keys.public.length || keys.private && keys.private.length || 0;
        // NOTE: 521 is the actual, but 512 is the expected
        if (len === 521) len = 512;
        switch(mode){
            case "encrypt":
            case "decrypt":
                return [];
            case "wrap":
                return keys.public && $b0634e2c4337a908$var$WRAP_ALGS || [];
            case "unwrap":
                return keys.private && $b0634e2c4337a908$var$WRAP_ALGS || [];
            case "sign":
                if (!keys.private) return [];
                return $b0634e2c4337a908$var$SIG_ALGS.filter(function(a) {
                    return a === "ES" + len;
                });
            case "verify":
                if (!keys.public) return [];
                return $b0634e2c4337a908$var$SIG_ALGS.filter(function(a) {
                    return a === "ES" + len;
                });
        }
    },
    encryptKey: function(alg, keys) {
        return keys.public;
    },
    decryptKey: function(alg, keys) {
        return keys.private;
    },
    wrapKey: function(alg, keys) {
        return keys.public;
    },
    unwrapKey: function(alg, keys) {
        return keys.private;
    },
    signKey: function(alg, keys) {
        return keys.private;
    },
    verifyKey: function(alg, keys) {
        return keys.public;
    }
};
$b0634e2c4337a908$var$JWKEcCfg.convertToPEM = $kHHwO.convertToPEM;
// Inspired by digitalbaazar/node-forge/js/rsa.js
var $b0634e2c4337a908$var$validators = {
    oid: $b0634e2c4337a908$var$EC_OID,
    privateKey: {
        // ECPrivateKey
        name: "ECPrivateKey",
        tagClass: $as9F1.asn1.Class.UNIVERSAL,
        type: $as9F1.asn1.Type.SEQUENCE,
        constructed: true,
        value: [
            {
                // EC version
                name: "ECPrivateKey.version",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false
            },
            {
                // private value (d)
                name: "ECPrivateKey.private",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.OCTETSTRING,
                constructed: false,
                capture: "d"
            },
            {
                // EC parameters
                tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                name: "ECPrivateKey.parameters",
                constructed: true,
                value: [
                    {
                        // namedCurve (crv)
                        name: "ECPrivateKey.namedCurve",
                        tagClass: $as9F1.asn1.Class.UNIVERSAL,
                        type: $as9F1.asn1.Type.OID,
                        constructed: false,
                        capture: "crv"
                    }
                ]
            },
            {
                // publicKey
                name: "ECPrivateKey.publicKey",
                tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                constructed: true,
                value: [
                    {
                        name: "ECPrivateKey.point",
                        tagClass: $as9F1.asn1.Class.UNIVERSAL,
                        type: $as9F1.asn1.Type.BITSTRING,
                        constructed: false,
                        capture: "point"
                    }
                ]
            }
        ]
    },
    embeddedPrivateKey: {
        // ECPrivateKey
        name: "ECPrivateKey",
        tagClass: $as9F1.asn1.Class.UNIVERSAL,
        type: $as9F1.asn1.Type.SEQUENCE,
        constructed: true,
        value: [
            {
                // EC version
                name: "ECPrivateKey.version",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.INTEGER,
                constructed: false
            },
            {
                // private value (d)
                name: "ECPrivateKey.private",
                tagClass: $as9F1.asn1.Class.UNIVERSAL,
                type: $as9F1.asn1.Type.OCTETSTRING,
                constructed: false,
                capture: "d"
            },
            {
                // publicKey
                name: "ECPrivateKey.publicKey",
                tagClass: $as9F1.asn1.Class.CONTEXT_SPECIFIC,
                constructed: true,
                value: [
                    {
                        name: "ECPrivateKey.point",
                        tagClass: $as9F1.asn1.Class.UNIVERSAL,
                        type: $as9F1.asn1.Type.BITSTRING,
                        constructed: false,
                        capture: "point"
                    }
                ]
            }
        ]
    }
};
var $b0634e2c4337a908$var$JWKEcFactory = {
    kty: "EC",
    validators: $b0634e2c4337a908$var$validators,
    prepare: function(props) {
        // TODO: validate key properties
        var cfg = $b0634e2c4337a908$var$JWKEcCfg;
        var p = Promise.resolve(props);
        p = p.then(function(json) {
            return $b0634e2c4337a908$var$JWK.helpers.thumbprint(cfg, json);
        });
        p = p.then(function(hash) {
            var prints = {};
            prints[$b0634e2c4337a908$var$JWK.helpers.INTERNALS.THUMBPRINT_HASH] = hash;
            props[$b0634e2c4337a908$var$JWK.helpers.INTERNALS.THUMBPRINT_KEY] = prints;
            return cfg;
        });
        return p;
    },
    generate: function(size) {
        var keypair = $fwJVv.generateKeyPair(size);
        var result = {
            "crv": size,
            "x": keypair.public.x,
            "y": keypair.public.y,
            "d": keypair.private.d
        };
        return Promise.resolve(result);
    },
    import: function(input) {
        if ($b0634e2c4337a908$var$validators.oid !== input.keyOid) return null;
        // coerce key params to OID
        var crv;
        if (input.keyParams && $as9F1.asn1.Type.OID === input.keyParams.type) {
            crv = $as9F1.asn1.derToOid(input.keyParams.value);
            crv = $b0634e2c4337a908$var$oidToCurveName(crv);
        } else if (input.crv) {
            crv = $as9F1.asn1.derToOid(input.crv);
            crv = $b0634e2c4337a908$var$oidToCurveName(crv);
        }
        if (!crv) return null;
        if (!input.parsed) {
            var capture = {}, errors = [];
            if ("private" === input.type) {
                // coerce capture.value to DER *iff* private
                if ("string" === typeof input.keyValue) input.keyValue = $as9F1.asn1.fromDer(input.keyValue);
                else if (Array.isArray(input.keyValue)) input.keyValue = input.keyValue[0];
                if (!$as9F1.asn1.validate(input.keyValue, $b0634e2c4337a908$var$validators.embeddedPrivateKey, capture, errors)) return null;
            } else capture.point = input.keyValue;
            input = capture;
        }
        // convert factors to Buffers
        var output = {
            kty: "EC",
            crv: crv
        };
        if (input.d) output.d = $b0634e2c4337a908$require$Buffer.from(input.d, "binary");
        if (input.point) {
            var pt = $b0634e2c4337a908$require$Buffer.from(input.point, "binary");
            // only support uncompressed
            if (4 !== pt.readUInt16BE(0)) return null;
            pt = pt.slice(2);
            var len = pt.length / 2;
            output.x = pt.slice(0, len);
            output.y = pt.slice(len);
        }
        return output;
    }
};
// public API
module.exports = Object.freeze({
    config: $b0634e2c4337a908$var$JWKEcCfg,
    factory: $b0634e2c4337a908$var$JWKEcFactory
});

// registration
(function(REGISTRY) {
    REGISTRY.register($b0634e2c4337a908$var$JWKEcFactory);
})((parcelRequire("2bizm")).registry);

});


parcelRegister("jJIby", function(module, exports) {
/*!
 * jws/helpers.js - JWS Internal Helper Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
module.exports = {
    slice: function(input, start) {
        return Array.prototype.slice.call(input, start || 0);
    }
};

});

parcelRegister("hsmwv", function(module, exports) {
/*!
 * jws/defaults.js - Defaults for JWSs
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
/**
 * @description
 * The default options for {@link JWS.createSign}.
 *
 * @property {Boolean} compact Determines if the output is the Compact
 *           serialization (`true`) or the JSON serialization (**`false`**,
 *           the default).
 * @property {String|String[]} protect The names of the headers to integrity
 *           protect.  The value `""` means that none of header parameters
 *           are integrity protected, while `"*"` (the default) means that all
 *           headers parameter sare integrity protected.
 */ var $cb5685da2c91b29a$var$JWSDefaults = {
    compact: false,
    protect: "*"
};
module.exports = $cb5685da2c91b29a$var$JWSDefaults;

});


parcelRegister("cV9MM", function(module, exports) {
/*!
 * jws/verify.js - Verifies from a JWS
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $96826628c335785c$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $bTYY2 = parcelRequire("bTYY2");

var $2rglK = parcelRequire("2rglK");

var $gS7wL = parcelRequire("gS7wL");

var $d1TAe = parcelRequire("d1TAe");

var $dXx0Z = parcelRequire("dXx0Z");
var $96826628c335785c$var$DEFAULT_OPTIONS = {
    algorithms: "*",
    allowEmbeddedKey: false
};
/**
 * @class JWS.Verifier
 * @classdesc Parser of signed content.
 *
 * @description
 * **NOTE:** this class cannot be instantiated directly. Instead call {@link
 * JWS.createVerify}.
 */ var $96826628c335785c$var$JWSVerifier = function(ks, globalOpts) {
    var assumedKey, keystore;
    if ($dXx0Z.isKey(ks)) {
        assumedKey = ks;
        keystore = assumedKey.keystore;
    } else if ($dXx0Z.isKeyStore(ks)) keystore = ks;
    else keystore = $dXx0Z.createKeyStore();
    globalOpts = $2rglK($96826628c335785c$var$DEFAULT_OPTIONS, globalOpts);
    Object.defineProperty(this, "defaultKey", {
        value: assumedKey || undefined,
        enumerable: true
    });
    Object.defineProperty(this, "keystore", {
        value: keystore,
        enumerable: true
    });
    Object.defineProperty(this, "verify", {
        value: function(input, opts) {
            opts = $2rglK({}, globalOpts, opts || {});
            var extraHandlers = opts.handlers || {};
            var handlerKeys = Object.keys(extraHandlers);
            var algSpec = new $d1TAe(opts.algorithms);
            if ("string" === typeof input) {
                input = input.split(".");
                input = {
                    payload: input[1],
                    signatures: [
                        {
                            protected: input[0],
                            signature: input[2]
                        }
                    ]
                };
            } else if (!input || "object" !== typeof input) throw new Error("invalid input");
            // fixup "flattened JSON" to look like "general JSON"
            if (input.signature) input.signatures = [
                {
                    protected: input.protected || undefined,
                    header: input.header || undefined,
                    signature: input.signature
                }
            ];
            // ensure signatories exists
            var sigList = input.signatures || [
                {}
            ];
            // combine fields and decode signature per signatory
            sigList = sigList.map(function(s) {
                var header = $bTYY2(s.header || {});
                var protect = s.protected ? JSON.parse($gS7wL.decode(s.protected, "utf8")) : {};
                header = $2rglK(header, protect);
                var signature = $gS7wL.decode(s.signature);
                // process allowed algorithims
                if (!algSpec.match(header.alg)) return Promise.reject(new Error("Algorithm not allowed: " + header.alg));
                // process "crit" first
                var crit = protect.crit;
                if (crit) {
                    if (!Array.isArray(crit)) return Promise.reject(new Error("Invalid 'crit' header"));
                    for(var idx = 0; crit.length > idx; idx++){
                        if (-1 === handlerKeys.indexOf(crit[idx])) return Promise.reject(new Error("Critical extension is not supported: " + crit[idx]));
                    }
                }
                protect = Object.keys(protect);
                return Promise.resolve({
                    protected: protect,
                    aad: s.protected || "",
                    header: header,
                    signature: signature
                });
            });
            var promise = Promise.all(sigList);
            promise = promise.then(function(sigList) {
                return new Promise(function(resolve, reject) {
                    var processSig = function() {
                        var sig = sigList.shift();
                        if (!sig) {
                            reject(new Error("no key found"));
                            return;
                        }
                        sig = $2rglK({}, sig, {
                            payload: input.payload
                        });
                        var p = Promise.resolve(sig);
                        // find the key
                        p = p.then(function(sig) {
                            var algKey;
                            // TODO: resolve jku, x5c, x5u
                            if (opts.allowEmbeddedKey && sig.header.jwk) algKey = $dXx0Z.asKey(sig.header.jwk);
                            else if (opts.allowEmbeddedKey && sig.header.x5c) {
                                algKey = sig.header.x5c[0];
                                algKey = $96826628c335785c$require$Buffer.from(algKey, "base64");
                                // TODO: callback to validate chain
                                algKey = $dXx0Z.asKey(algKey, "pkix");
                            } else algKey = Promise.resolve(assumedKey || keystore.get({
                                use: "sig",
                                alg: sig.header.alg,
                                kid: sig.header.kid
                            }));
                            return algKey.then(function(k) {
                                if (!k) return Promise.reject(new Error("key does not match"));
                                sig.key = k;
                                return sig;
                            });
                        });
                        // process any prepare-verify handlers
                        p = p.then(function(sig) {
                            var processing = [];
                            handlerKeys.forEach(function(h) {
                                h = extraHandlers[h];
                                var p;
                                if ("function" === typeof h) p = h(sig);
                                else if ("object" === typeof h && "function" === typeof h.prepare) p = h.prepare(sig);
                                if (p) processing.push(Promise.resolve(p));
                            });
                            return Promise.all(processing).then(function() {
                                // don't actually care about individual handler results
                                // assume {sig} is updated
                                return sig;
                            });
                        });
                        // prepare verify inputs
                        p = p.then(function(sig) {
                            var aad = sig.aad || "", payload = sig.payload || "";
                            var content = $96826628c335785c$require$Buffer.alloc(1 + aad.length + payload.length), pos = 0;
                            content.write(aad, pos, "ascii");
                            pos += aad.length;
                            content.write(".", pos, "ascii");
                            pos++;
                            if ($96826628c335785c$require$Buffer.isBuffer(payload)) payload.copy(content, pos);
                            else content.write(payload, pos, "binary");
                            sig.content = content;
                            return sig;
                        });
                        p = p.then(function(sig) {
                            return sig.key.verify(sig.header.alg, sig.content, sig.signature);
                        });
                        p = p.then(function(result) {
                            var payload = sig.payload;
                            payload = $gS7wL.decode(payload);
                            return {
                                protected: sig.protected,
                                header: sig.header,
                                payload: payload,
                                signature: result.mac,
                                key: sig.key
                            };
                        });
                        // process any post-verify handlers
                        p = p.then(function(jws) {
                            var processing = [];
                            handlerKeys.forEach(function(h) {
                                h = extraHandlers[h];
                                var p;
                                if ("object" === typeof h && "function" === typeof h.complete) p = h.complete(jws);
                                if (p) processing.push(Promise.resolve(p));
                            });
                            return Promise.all(processing).then(function() {
                                // don't actually care about individual handler results
                                // assume {jws} is updated
                                return jws;
                            });
                        });
                        p.then(resolve, processSig);
                    };
                    processSig();
                });
            });
            return promise;
        }
    });
};
/**
 * @description
 * Creates a new JWS.Verifier with the given Key or KeyStore.
 *
 * @param {JWK.Key|JWK.KeyStore} ks The Key or KeyStore to use for verification.
 * @returns {JWS.Verifier} The new Verifier.
 */ function $96826628c335785c$var$createVerify(ks, opts) {
    var vfy = new $96826628c335785c$var$JWSVerifier(ks, opts);
    return vfy;
}
module.exports = {
    verifier: $96826628c335785c$var$JWSVerifier,
    createVerify: $96826628c335785c$var$createVerify
};

});
parcelRegister("d1TAe", function(module, exports) {
/*!
 * util/algconfig.js - Functions for managing algorithm set options
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
function $97c67c11fb460428$var$quoteRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
function $97c67c11fb460428$var$makeRE(prefix, wildcard, suffix) {
    var parts = [];
    parts.push("^");
    if (prefix) {
        prefix = $97c67c11fb460428$var$quoteRE(prefix);
        parts.push(prefix);
    }
    if (wildcard) parts.push(prefix || suffix ? ".*" : ".+");
    if (suffix) {
        suffix = $97c67c11fb460428$var$quoteRE(suffix);
        parts.push(suffix);
    }
    parts.push("$");
    return parts.join("");
}
var $97c67c11fb460428$var$AlgConfig = function(algspec) {
    if (!algspec) algspec = [];
    else if ("string" === typeof algspec) algspec = algspec.split(" ");
    var specAllowed = [], specDisallowed = [];
    var ptnAllowed = [], ptnDisallowed = [];
    var ptn = /^(!)?([^*]*)(\*?)([^*]*)$/, fmt;
    algspec.forEach(function(a) {
        if (!a) return;
        ptn.lastIndex = 0;
        var parts = ptn.exec(a);
        if (!parts) return;
        fmt = "(" + $97c67c11fb460428$var$makeRE(parts[2], parts[3], parts[4]) + ")";
        if (!parts[1]) {
            // allowed pattern
            ptnAllowed.push(fmt);
            specAllowed.push(parts[0]);
        } else {
            // disallowed pattern
            ptnDisallowed.push(fmt);
            specDisallowed.push(parts[0]);
        }
    });
    ptnAllowed = ptnAllowed.length ? new RegExp(ptnAllowed.join("|")) : null;
    ptnDisallowed = ptnDisallowed.length ? new RegExp(ptnDisallowed.join("|")) : null;
    if (!specAllowed.length) specAllowed = [
        "*"
    ];
    Object.defineProperty(this, "spec", {
        value: specAllowed.join(" ") + " " + specDisallowed.join(" "),
        enumerable: true
    });
    Object.defineProperty(this, "match", {
        value: function(alg) {
            var result = Boolean(alg);
            if (result && ptnAllowed) {
                ptnAllowed.lastIndex = 0;
                result = ptnAllowed.test(alg);
            }
            if (result && ptnDisallowed) {
                ptnDisallowed.lastIndex = 0;
                result = !ptnDisallowed.test(alg);
            }
            return result;
        }
    });
};
module.exports = $97c67c11fb460428$var$AlgConfig;

});



parcelRegister("d4JNN", function(module, exports) {
/*!
 * jwe/index.js - JSON Web Encryption (JWE) Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";


var $984f2d7479445d33$var$JWE = {
    createEncrypt: (parcelRequire("cNB3I")).createEncrypt,
    createDecrypt: (parcelRequire("pCSHk")).createDecrypt
};
module.exports = $984f2d7479445d33$var$JWE;

});
parcelRegister("cNB3I", function(module, exports) {
/*!
 * jwe/encrypt.js - Encrypt to a JWE
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $9516cec49532fc60$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $jIqqR = parcelRequire("jIqqR");

var $1kpTw = parcelRequire("1kpTw");
var $9516cec49532fc60$require$generateCEK = $1kpTw.generateCEK;

var $dXx0Z = parcelRequire("dXx0Z");

var $1kpTw = parcelRequire("1kpTw");
var $9516cec49532fc60$require$slice = $1kpTw.slice;

var $e4ypD = parcelRequire("e4ypD");

var $1YNha = parcelRequire("1YNha");

var $8DQVZ = parcelRequire("8DQVZ");

var $bTYY2 = parcelRequire("bTYY2");

var $e1Wzw = parcelRequire("e1Wzw");
/**
 * @class JWE.Encrypter
 * @classdesc
 * Generator of encrypted data.
 *
 * @description
 * **NOTE:** This class cannot be instantiated directly. Instead call {@link
 * JWE.createEncrypt}.
 */ function $9516cec49532fc60$var$JWEEncrypter(cfg, fields, recipients) {
    var finalized = false, format = cfg.format || "general", protectAll = !!cfg.protectAll, content = $9516cec49532fc60$require$Buffer.alloc(0);
    /**
   * @member {String} JWE.Encrypter#zip
   * @readonly
   * @description
   * Indicates the compression algorithm applied to the plaintext
   * before it is encrypted.  The possible values are:
   *
   * + **`"DEF"`**: Compress the plaintext using the DEFLATE algorithm.
   * + **`""`**: Do not compress the plaintext.
   */ Object.defineProperty(this, "zip", {
        get: function() {
            return fields.zip || "";
        },
        enumerable: true
    });
    /**
   * @member {Boolean} JWE.Encrypter#compact
   * @readonly
   * @description
   * Indicates whether the output of this encryption generator is
   * using the Compact serialization (`true`) or the JSON
   * serialization (`false`).
   */ Object.defineProperty(this, "compact", {
        get: function() {
            return "compact" === format;
        },
        enumerable: true
    });
    /**
   * @member {String} JWE.Encrypter#format
   * @readonly
   * @description
   * Indicates the format the output of this encryption generator takes.
   */ Object.defineProperty(this, "format", {
        get: function() {
            return format;
        },
        enumerable: true
    });
    /**
   * @member {String[]} JWE.Encrypter#protected
   * @readonly
   * @description
   * The header parameter names that are protected. Protected header fields
   * are first serialized to UTF-8 then encoded as util.base64url, then used as
   * the additional authenticated data in the encryption operation.
   */ Object.defineProperty(this, "protected", {
        get: function() {
            return $bTYY2(cfg.protect);
        },
        enumerable: true
    });
    /**
   * @member {Object} JWE.Encrypter#header
   * @readonly
   * @description
   * The global header parameters, both protected and unprotected. Call
   * {@link JWE.Encrypter#protected} to determine which parameters will
   * be protected.
   */ Object.defineProperty(this, "header", {
        get: function() {
            return $bTYY2(fields);
        },
        enumerable: true
    });
    /**
   * @method JWE.Encrypter#update
   * @description
   * Updates the plaintext data for the encryption generator. The plaintext
   * is appended to the end of any other plaintext already applied.
   *
   * If {data} is a Buffer, {encoding} is ignored. Otherwise, {data} is
   * converted to a Buffer internally to {encoding}.
   *
   * @param {Buffer|String} [data] The plaintext to apply.
   * @param {String} [encoding] The encoding of the plaintext.
   * @returns {JWE.Encrypter} This encryption generator.
   * @throws {Error} If ciphertext has already been generated.
   */ Object.defineProperty(this, "update", {
        value: function(data, encoding) {
            if (finalized) throw new Error("already final");
            if (data != null) {
                data = $jIqqR.asBuffer(data, encoding);
                if (content.length) content = $9516cec49532fc60$require$Buffer.concat([
                    content,
                    data
                ], content.length + data.length);
                else content = data;
            }
            return this;
        }
    });
    /**
   * @method JWE.Encrypter#final
   * @description
   * Finishes the encryption operation.
   *
   * The returned Promise, when fulfilled, is the JSON Web Encryption (JWE)
   * object, either in the Compact (if {@link JWE.Encrypter#compact} is
   * `true`) or the JSON serialization.
   *
   * @param {Buffer|String} [data] The final plaintext data to apply.
   * @param {String} [encoding] The encoding of the final plaintext data
   *        (if any).
   * @returns {Promise} A promise for the encryption operation.
   * @throws {Error} If ciphertext has already been generated.
   */ Object.defineProperty(this, "final", {
        value: function(data, encoding) {
            if (finalized) return Promise.reject(new Error("already final"));
            // last-minute data
            this.update(data, encoding);
            // mark as done...ish
            finalized = true;
            var promise = Promise.resolve({});
            // determine CEK and IV
            var encAlg = fields.enc;
            var encKey;
            promise = promise.then(function(jwe) {
                if (cfg.cek) encKey = $dXx0Z.asKey(cfg.cek);
                return jwe;
            });
            // process recipients
            promise = promise.then(function(jwe) {
                var procR = function(r, one) {
                    var props = {};
                    props = $8DQVZ(props, fields);
                    props = $8DQVZ(props, r.header);
                    var algKey = r.key, algAlg = props.alg;
                    // generate Ephemeral EC Key
                    var tks, rpromise;
                    if ((props.alg || "").indexOf("ECDH-ES") === 0) {
                        tks = algKey.keystore.temp();
                        if (r.epk) rpromise = Promise.resolve(r.epk).then(function(epk) {
                            r.header.epk = epk.toJSON(false, [
                                "kid"
                            ]);
                            props.epk = epk.toObject(true, [
                                "kid"
                            ]);
                        });
                        else rpromise = tks.generate("EC", algKey.get("crv")).then(function(epk) {
                            r.header.epk = epk.toJSON(false, [
                                "kid"
                            ]);
                            props.epk = epk.toObject(true, [
                                "kid"
                            ]);
                        });
                    } else rpromise = Promise.resolve();
                    // encrypt the CEK
                    rpromise = rpromise.then(function() {
                        var cek, p;
                        // special case 'alg=dir'
                        if ("dir" === algAlg && one) {
                            encKey = Promise.resolve(algKey);
                            p = encKey.then(function(jwk) {
                                // fixup encAlg
                                if (!encAlg) props.enc = fields.enc = encAlg = jwk.algorithms($dXx0Z.MODE_ENCRYPT)[0];
                                return {
                                    once: true,
                                    direct: true
                                };
                            });
                        } else {
                            if (!encKey) {
                                if (!encAlg) props.enc = fields.enc = encAlg = cfg.contentAlg;
                                encKey = $9516cec49532fc60$require$generateCEK(encAlg);
                            }
                            p = encKey.then(function(jwk) {
                                cek = jwk.get("k", true);
                                // algKey may or may not be a promise
                                return algKey;
                            });
                            p = p.then(function(algKey) {
                                return algKey.wrap(algAlg, cek, props);
                            });
                        }
                        return p;
                    });
                    rpromise = rpromise.then(function(wrapped) {
                        if (wrapped.once && !one) return Promise.reject(new Error("cannot use 'alg':'" + algAlg + "' with multiple recipients"));
                        var rjwe = {}, cek;
                        if (wrapped.data) {
                            cek = wrapped.data;
                            cek = $jIqqR.base64url.encode(cek);
                        }
                        if (wrapped.direct && cek) // replace content key
                        encKey = $dXx0Z.asKey({
                            kty: "oct",
                            k: cek
                        });
                        else if (cek) /* eslint camelcase: [0] */ rjwe.encrypted_key = cek;
                        if (r.header && Object.keys(r.header).length) rjwe.header = $bTYY2(r.header || {});
                        if (wrapped.header) rjwe.header = $8DQVZ(rjwe.header || {}, wrapped.header);
                        return rjwe;
                    });
                    return rpromise;
                };
                var p = Promise.all(recipients);
                p = p.then(function(rcpts) {
                    var single = 1 === rcpts.length;
                    rcpts = rcpts.map(function(r) {
                        return procR(r, single);
                    });
                    return Promise.all(rcpts);
                });
                p = p.then(function(rcpts) {
                    jwe.recipients = rcpts.filter(function(r) {
                        return !!r;
                    });
                    return jwe;
                });
                return p;
            });
            // normalize headers
            var props = {};
            promise = promise.then(function(jwe) {
                var protect, lenProtect, unprotect, lenUnprotect;
                unprotect = $bTYY2(fields);
                if (protectAll && jwe.recipients.length === 1 || "compact" === format) {
                    // merge single recipient into fields
                    protect = {};
                    protect = $8DQVZ({}, unprotect, jwe.recipients[0].header);
                    lenProtect = Object.keys(protect).length;
                    unprotect = undefined;
                    lenUnprotect = 0;
                    delete jwe.recipients[0].header;
                    if (Object.keys(jwe.recipients[0]).length === 0) jwe.recipients.splice(0, 1);
                } else {
                    protect = {};
                    lenProtect = 0;
                    lenUnprotect = Object.keys(unprotect).length;
                    cfg.protect.forEach(function(f) {
                        // remove protected header values from body unprotected header
                        if (!(f in unprotect)) return;
                        protect[f] = unprotect[f];
                        lenProtect++;
                        delete unprotect[f];
                        lenUnprotect--;
                    });
                    jwe.recipients = (jwe.recipients || []).map(function(rcpt) {
                        rcpt = rcpt || {};
                        var header = rcpt.header;
                        if (header) {
                            Object.keys(header).forEach(function(f) {
                                if (f in protect) delete header[f];
                            });
                            if (!Object.keys(header).length) delete rcpt.header;
                        }
                        return rcpt;
                    });
                }
                if (!jwe.recipients || jwe.recipients.length === 0) delete jwe.recipients;
                // "serialize" (and setup merged props)
                if (unprotect && lenUnprotect > 0) {
                    props = $8DQVZ(props, unprotect);
                    jwe.unprotected = unprotect;
                }
                if (protect && lenProtect > 0) {
                    props = $8DQVZ(props, protect);
                    protect = JSON.stringify(protect);
                    jwe.protected = $jIqqR.base64url.encode(protect, "utf8");
                }
                return jwe;
            });
            // (OPTIONAL) compress plaintext
            promise = promise.then(function(jwe) {
                var pdata = content;
                if (!props.zip) {
                    jwe.plaintext = pdata;
                    return jwe;
                } else if (props.zip === "DEF") return new Promise(function(resolve, reject) {
                    try {
                        var data = $e4ypD.deflateRaw($9516cec49532fc60$require$Buffer.from(pdata, "binary"));
                        jwe.plaintext = $9516cec49532fc60$require$Buffer.from(data);
                        resolve(jwe);
                    } catch (error) {
                        reject(error);
                    }
                });
                return Promise.reject(new Error("unsupported 'zip' mode"));
            });
            // encrypt plaintext
            promise = promise.then(function(jwe) {
                props.adata = jwe.protected;
                if ("aad" in cfg && cfg.aad != null) {
                    props.adata += "." + cfg.aad;
                    props.adata = $9516cec49532fc60$require$Buffer.from(props.adata, "utf8");
                }
                // calculate IV
                var iv = cfg.iv || $jIqqR.randomBytes($1YNha.NONCELENGTH[encAlg] / 8);
                if ("string" === typeof iv) iv = $jIqqR.base64url.decode(iv);
                props.iv = iv;
                if ("recipients" in jwe && jwe.recipients.length === 1) props.kdata = jwe.recipients[0].encrypted_key;
                if ("epu" in cfg && cfg.epu != null) props.epu = cfg.epu;
                if ("epv" in cfg && cfg.epv != null) props.epv = cfg.epv;
                var pdata = jwe.plaintext;
                delete jwe.plaintext;
                return encKey.then(function(encKey) {
                    var p = encKey.encrypt(encAlg, pdata, props);
                    p = p.then(function(result) {
                        jwe.iv = $jIqqR.base64url.encode(iv, "binary");
                        if ("aad" in cfg && cfg.aad != null) jwe.aad = cfg.aad;
                        jwe.ciphertext = $jIqqR.base64url.encode(result.data, "binary");
                        jwe.tag = $jIqqR.base64url.encode(result.tag, "binary");
                        return jwe;
                    });
                    return p;
                });
            });
            // (OPTIONAL) compact/flattened results
            switch(format){
                case "compact":
                    promise = promise.then(function(jwe) {
                        var compact = new Array(5);
                        compact[0] = jwe.protected;
                        if (jwe.recipients && jwe.recipients[0]) compact[1] = jwe.recipients[0].encrypted_key;
                        compact[2] = jwe.iv;
                        compact[3] = jwe.ciphertext;
                        compact[4] = jwe.tag;
                        compact = compact.join(".");
                        return compact;
                    });
                    break;
                case "flattened":
                    promise = promise.then(function(jwe) {
                        var flattened = {}, rcpt = jwe.recipients && jwe.recipients[0];
                        if (jwe.protected) flattened.protected = jwe.protected;
                        if (jwe.unprotected) flattened.unprotected = jwe.unprotected;
                        [
                            "header",
                            "encrypted_key"
                        ].forEach(function(f) {
                            if (!rcpt) return;
                            if (!(f in rcpt)) return;
                            if (!rcpt[f]) return;
                            if ("object" === typeof rcpt[f] && !Object.keys(rcpt[f]).length) return;
                            flattened[f] = rcpt[f];
                        });
                        if (jwe.aad) flattened.aad = jwe.aad;
                        flattened.iv = jwe.iv;
                        flattened.ciphertext = jwe.ciphertext;
                        flattened.tag = jwe.tag;
                        return flattened;
                    });
                    break;
                case "general":
                    promise = promise.then(function(jwe) {
                        var recipients = jwe.recipients || [];
                        recipients = recipients.map(function(rcpt) {
                            if (!Object.keys(rcpt).length) return undefined;
                            return rcpt;
                        });
                        recipients = recipients.filter(function(rcpt) {
                            return !!rcpt;
                        });
                        if (recipients.length) jwe.recipients = recipients;
                        else delete jwe.recipients;
                        return jwe;
                    });
            }
            return promise;
        }
    });
}
function $9516cec49532fc60$var$createEncrypt(opts, rcpts) {
    // fixup recipients
    var options = opts, rcptStart = 1, rcptList = rcpts;
    if (arguments.length === 0) throw new Error("at least one recipient must be provided");
    if (arguments.length === 1) {
        // assume opts is the recipient list
        rcptList = opts;
        rcptStart = 0;
        options = {};
    } else if ($dXx0Z.isKey(opts) || opts && "kty" in opts || opts && "key" in opts && ($dXx0Z.isKey(opts.key) || "kty" in opts.key)) {
        rcptList = opts;
        rcptStart = 0;
        options = {};
    } else options = $bTYY2(opts);
    if (!Array.isArray(rcptList)) rcptList = $9516cec49532fc60$require$slice(arguments, rcptStart);
    // fixup options
    options = $8DQVZ($bTYY2($e1Wzw), options);
    // setup header fields
    var fields = $bTYY2(options.fields || {});
    if (options.zip) fields.zip = typeof options.zip === "boolean" ? options.zip ? "DEF" : false : options.zip;
    options.format = (options.compact ? "compact" : options.format) || "general";
    switch(options.format){
        case "compact":
            if ("aad" in opts) throw new Error("additional authenticated data cannot be used for compact serialization");
        /* eslint no-fallthrough: [0] */ case "flattened":
            if (rcptList.length > 1) throw new Error("too many recipients for compact serialization");
            break;
    }
    // note protected fields (globally)
    // protected fields are global only
    var protectAll = false;
    if ("compact" === options.format || "*" === options.protect) {
        protectAll = true;
        options.protect = Object.keys(fields).concat("enc");
    } else if (typeof options.protect === "string") options.protect = [
        options.protect
    ];
    else if (Array.isArray(options.protect)) options.protect = options.protect.concat();
    else if (!options.protect) options.protect = [];
    else throw new Error("protect must be a list of fields");
    if (protectAll && 1 < rcptList.length) throw new Error("too many recipients to protect all header parameters");
    rcptList = rcptList.map(function(r, idx) {
        var p;
        // resolve a key
        if (r && "kty" in r) {
            p = $dXx0Z.asKey(r);
            p = p.then(function(k) {
                return {
                    key: k
                };
            });
        } else if (r) {
            p = $dXx0Z.asKey(r.key);
            p = p.then(function(k) {
                return {
                    header: r.header,
                    reference: r.reference,
                    key: k
                };
            });
        } else p = Promise.reject(new Error("missing key for recipient " + idx));
        // convert ephemeral key (if present)
        if (r.epk) p = p.then(function(recipient) {
            return $dXx0Z.asKey(r.epk).then(function(epk) {
                recipient.epk = epk;
                return recipient;
            });
        });
        // resolve the complete recipient
        p = p.then(function(recipient) {
            var key = recipient.key;
            // prepare the recipient header
            var header = recipient.header || {};
            recipient.header = header;
            var props = {};
            props = $8DQVZ(props, fields);
            props = $8DQVZ(props, recipient.header);
            // ensure key protection algorithm is set
            if (!props.alg) {
                props.alg = key.algorithms($dXx0Z.MODE_WRAP)[0];
                header.alg = props.alg;
            }
            if (!props.alg) return Promise.reject(new Error("key not valid for encrypting to recipient " + idx));
            header.alg = props.alg;
            // determine the key reference
            var ref = recipient.reference;
            delete recipient.reference;
            if (undefined === ref) {
                // header already contains the key reference
                ref = [
                    "kid",
                    "jku",
                    "x5c",
                    "x5t",
                    "x5u"
                ].some(function(k) {
                    return k in header;
                });
                ref = !ref ? "kid" : null;
            } else if ("boolean" === typeof ref) // explicit (positive | negative) request for key reference
            ref = ref ? "kid" : null;
            var jwk;
            if (ref) {
                jwk = key.toJSON();
                if ("jwk" === ref) {
                    if ("oct" === key.kty) return Promise.reject(new Error("cannot embed key"));
                    header.jwk = jwk;
                } else if (ref in jwk) header[ref] = jwk[ref];
            }
            // freeze recipient
            recipient = Object.freeze(recipient);
            return recipient;
        });
        return p;
    });
    // create and configure encryption
    var cfg = {
        aad: "aad" in options ? $jIqqR.base64url.encode(options.aad || "") : null,
        contentAlg: options.contentAlg,
        format: options.format,
        protect: options.protect,
        cek: options.cek,
        iv: options.iv,
        protectAll: protectAll
    };
    var enc = new $9516cec49532fc60$var$JWEEncrypter(cfg, fields, rcptList);
    return enc;
}
module.exports = {
    encrypter: $9516cec49532fc60$var$JWEEncrypter,
    createEncrypt: $9516cec49532fc60$var$createEncrypt
};

});
parcelRegister("1kpTw", function(module, exports) {
/*!
 * jwe/helpers.js - JWE Internal Helper Functions
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";

var $1YNha = parcelRequire("1YNha");

var $dXx0Z = parcelRequire("dXx0Z");
module.exports = {
    slice: function(input, start) {
        return Array.prototype.slice.call(input, start || 0);
    },
    generateCEK: function(enc) {
        var ks = $dXx0Z.createKeyStore();
        var len = $1YNha.KEYLENGTH[enc];
        if (len) return ks.generate("oct", len);
        throw new Error("unsupported encryption algorithm");
    }
};

});

parcelRegister("e4ypD", function(module, exports) {

$parcel$export(module.exports, "deflateRaw", () => $2dd4f45c8894762f$export$e95d6a8f69fb340a);
$parcel$export(module.exports, "inflateRaw", () => $2dd4f45c8894762f$export$d0f0aa2d05c905c5);
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $2dd4f45c8894762f$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $2dd4f45c8894762f$var$Z_BINARY = 0;
const $2dd4f45c8894762f$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $2dd4f45c8894762f$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $2dd4f45c8894762f$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $2dd4f45c8894762f$var$STORED_BLOCK = 0;
const $2dd4f45c8894762f$var$STATIC_TREES = 1;
const $2dd4f45c8894762f$var$DYN_TREES = 2;
/* The three kinds of block type */ const $2dd4f45c8894762f$var$MIN_MATCH$1 = 3;
const $2dd4f45c8894762f$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $2dd4f45c8894762f$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES$1 = $2dd4f45c8894762f$var$LITERALS$1 + 1 + $2dd4f45c8894762f$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES$1 = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE$1 = 2 * $2dd4f45c8894762f$var$L_CODES$1 + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $2dd4f45c8894762f$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $2dd4f45c8894762f$var$END_BLOCK = 256;
/* end of block literal code */ const $2dd4f45c8894762f$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $2dd4f45c8894762f$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $2dd4f45c8894762f$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $2dd4f45c8894762f$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $2dd4f45c8894762f$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $2dd4f45c8894762f$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $2dd4f45c8894762f$var$static_ltree = new Array(($2dd4f45c8894762f$var$L_CODES$1 + 2) * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $2dd4f45c8894762f$var$static_dtree = new Array($2dd4f45c8894762f$var$D_CODES$1 * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $2dd4f45c8894762f$var$_dist_code = new Array($2dd4f45c8894762f$var$DIST_CODE_LEN);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $2dd4f45c8894762f$var$_length_code = new Array($2dd4f45c8894762f$var$MAX_MATCH$1 - $2dd4f45c8894762f$var$MIN_MATCH$1 + 1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $2dd4f45c8894762f$var$base_length = new Array($2dd4f45c8894762f$var$LENGTH_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $2dd4f45c8894762f$var$base_dist = new Array($2dd4f45c8894762f$var$D_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $2dd4f45c8894762f$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $2dd4f45c8894762f$var$static_l_desc;
let $2dd4f45c8894762f$var$static_d_desc;
let $2dd4f45c8894762f$var$static_bl_desc;
function $2dd4f45c8894762f$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $2dd4f45c8894762f$var$d_code = (dist)=>{
    return dist < 256 ? $2dd4f45c8894762f$var$_dist_code[dist] : $2dd4f45c8894762f$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $2dd4f45c8894762f$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $2dd4f45c8894762f$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $2dd4f45c8894762f$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $2dd4f45c8894762f$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $2dd4f45c8894762f$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $2dd4f45c8894762f$var$send_code = (s, c, tree)=>{
    $2dd4f45c8894762f$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $2dd4f45c8894762f$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $2dd4f45c8894762f$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $2dd4f45c8894762f$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $2dd4f45c8894762f$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $2dd4f45c8894762f$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $2dd4f45c8894762f$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $2dd4f45c8894762f$var$LENGTH_CODES$1 - 1; code++){
        $2dd4f45c8894762f$var$base_length[code] = length;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_lbits[code]; n++)$2dd4f45c8894762f$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $2dd4f45c8894762f$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code]; n++)$2dd4f45c8894762f$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $2dd4f45c8894762f$var$D_CODES$1; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code] - 7; n++)$2dd4f45c8894762f$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $2dd4f45c8894762f$var$gen_codes($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++){
        $2dd4f45c8894762f$var$static_dtree[n * 2 + 1] = 5;
        $2dd4f45c8894762f$var$static_dtree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $2dd4f45c8894762f$var$static_l_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$extra_lbits, $2dd4f45c8894762f$var$LITERALS$1 + 1, $2dd4f45c8894762f$var$L_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_d_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_dtree, $2dd4f45c8894762f$var$extra_dbits, 0, $2dd4f45c8894762f$var$D_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_bl_desc = new $2dd4f45c8894762f$var$StaticTreeDesc(new Array(0), $2dd4f45c8894762f$var$extra_blbits, 0, $2dd4f45c8894762f$var$BL_CODES$1, $2dd4f45c8894762f$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $2dd4f45c8894762f$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $2dd4f45c8894762f$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$2dd4f45c8894762f$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $2dd4f45c8894762f$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $2dd4f45c8894762f$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $2dd4f45c8894762f$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $2dd4f45c8894762f$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($2dd4f45c8894762f$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $2dd4f45c8894762f$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $2dd4f45c8894762f$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $2dd4f45c8894762f$var$_length_code[lc];
            $2dd4f45c8894762f$var$send_code(s, code + $2dd4f45c8894762f$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $2dd4f45c8894762f$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $2dd4f45c8894762f$var$base_length[code];
                $2dd4f45c8894762f$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $2dd4f45c8894762f$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $2dd4f45c8894762f$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $2dd4f45c8894762f$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $2dd4f45c8894762f$var$base_dist[code];
                $2dd4f45c8894762f$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $2dd4f45c8894762f$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $2dd4f45c8894762f$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$2dd4f45c8894762f$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $2dd4f45c8894762f$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $2dd4f45c8894762f$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $2dd4f45c8894762f$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$2dd4f45c8894762f$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$2dd4f45c8894762f$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$2dd4f45c8894762f$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $2dd4f45c8894762f$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REP_3_6, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_3_10, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 3);
        } else {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_11_138, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $2dd4f45c8894762f$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $2dd4f45c8894762f$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $2dd4f45c8894762f$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $2dd4f45c8894762f$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $2dd4f45c8894762f$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$2dd4f45c8894762f$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $2dd4f45c8894762f$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $2dd4f45c8894762f$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $2dd4f45c8894762f$var$send_bits(s, dcodes - 1, 5);
    $2dd4f45c8894762f$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $2dd4f45c8894762f$var$send_bits(s, s.bl_tree[$2dd4f45c8894762f$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $2dd4f45c8894762f$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    for(n = 32; n < $2dd4f45c8894762f$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $2dd4f45c8894762f$var$Z_BINARY;
};
let $2dd4f45c8894762f$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $2dd4f45c8894762f$var$_tr_init$1 = (s)=>{
    if (!$2dd4f45c8894762f$var$static_init_done) {
        $2dd4f45c8894762f$var$tr_static_init();
        $2dd4f45c8894762f$var$static_init_done = true;
    }
    s.l_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_ltree, $2dd4f45c8894762f$var$static_l_desc);
    s.d_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_dtree, $2dd4f45c8894762f$var$static_d_desc);
    s.bl_desc = new $2dd4f45c8894762f$var$TreeDesc(s.bl_tree, $2dd4f45c8894762f$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $2dd4f45c8894762f$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $2dd4f45c8894762f$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $2dd4f45c8894762f$var$bi_windup(s); /* align on byte boundary */ 
    $2dd4f45c8894762f$var$put_short(s, stored_len);
    $2dd4f45c8894762f$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $2dd4f45c8894762f$var$_tr_align$1 = (s)=>{
    $2dd4f45c8894762f$var$send_bits(s, $2dd4f45c8894762f$var$STATIC_TREES << 1, 3);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, $2dd4f45c8894762f$var$static_ltree);
    $2dd4f45c8894762f$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $2dd4f45c8894762f$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $2dd4f45c8894762f$var$Z_UNKNOWN$1) s.strm.data_type = $2dd4f45c8894762f$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $2dd4f45c8894762f$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $2dd4f45c8894762f$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $2dd4f45c8894762f$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $2dd4f45c8894762f$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $2dd4f45c8894762f$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$compress_block(s, $2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$static_dtree);
    } else {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $2dd4f45c8894762f$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $2dd4f45c8894762f$var$init_block(s);
    if (last) $2dd4f45c8894762f$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $2dd4f45c8894762f$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($2dd4f45c8894762f$var$_length_code[lc] + $2dd4f45c8894762f$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$2dd4f45c8894762f$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $2dd4f45c8894762f$var$_tr_init_1 = $2dd4f45c8894762f$var$_tr_init$1;
var $2dd4f45c8894762f$var$_tr_stored_block_1 = $2dd4f45c8894762f$var$_tr_stored_block$1;
var $2dd4f45c8894762f$var$_tr_flush_block_1 = $2dd4f45c8894762f$var$_tr_flush_block$1;
var $2dd4f45c8894762f$var$_tr_tally_1 = $2dd4f45c8894762f$var$_tr_tally$1;
var $2dd4f45c8894762f$var$_tr_align_1 = $2dd4f45c8894762f$var$_tr_align$1;
var $2dd4f45c8894762f$var$trees = {
    _tr_init: $2dd4f45c8894762f$var$_tr_init_1,
    _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block_1,
    _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block_1,
    _tr_tally: $2dd4f45c8894762f$var$_tr_tally_1,
    _tr_align: $2dd4f45c8894762f$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $2dd4f45c8894762f$var$adler32_1 = $2dd4f45c8894762f$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $2dd4f45c8894762f$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $2dd4f45c8894762f$var$crcTable = new Uint32Array($2dd4f45c8894762f$var$makeTable());
const $2dd4f45c8894762f$var$crc32 = (crc, buf, len, pos)=>{
    const t = $2dd4f45c8894762f$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $2dd4f45c8894762f$var$crc32_1 = $2dd4f45c8894762f$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $2dd4f45c8894762f$var$_tr_init, _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block, _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block, _tr_tally: $2dd4f45c8894762f$var$_tr_tally, _tr_align: $2dd4f45c8894762f$var$_tr_align } = $2dd4f45c8894762f$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH$1, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$3, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK$1, Z_OK: $2dd4f45c8894762f$var$Z_OK$3, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$3, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $2dd4f45c8894762f$var$Z_FILTERED, Z_HUFFMAN_ONLY: $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY, Z_RLE: $2dd4f45c8894762f$var$Z_RLE, Z_FIXED: $2dd4f45c8894762f$var$Z_FIXED, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $2dd4f45c8894762f$var$Z_UNKNOWN, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$2 } = $2dd4f45c8894762f$var$constants$2;
/*============================================================================*/ const $2dd4f45c8894762f$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $2dd4f45c8894762f$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_MEM_LEVEL = 8;
const $2dd4f45c8894762f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES = $2dd4f45c8894762f$var$LITERALS + 1 + $2dd4f45c8894762f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE = 2 * $2dd4f45c8894762f$var$L_CODES + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$MIN_MATCH = 3;
const $2dd4f45c8894762f$var$MAX_MATCH = 258;
const $2dd4f45c8894762f$var$MIN_LOOKAHEAD = $2dd4f45c8894762f$var$MAX_MATCH + $2dd4f45c8894762f$var$MIN_MATCH + 1;
const $2dd4f45c8894762f$var$PRESET_DICT = 0x20;
const $2dd4f45c8894762f$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $2dd4f45c8894762f$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $2dd4f45c8894762f$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $2dd4f45c8894762f$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $2dd4f45c8894762f$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $2dd4f45c8894762f$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $2dd4f45c8894762f$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $2dd4f45c8894762f$var$FINISH_STATE = 666; /* stream complete */ 
const $2dd4f45c8894762f$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $2dd4f45c8894762f$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $2dd4f45c8894762f$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $2dd4f45c8894762f$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $2dd4f45c8894762f$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $2dd4f45c8894762f$var$err = (strm, errorCode)=>{
    strm.msg = $2dd4f45c8894762f$var$messages[errorCode];
    return errorCode;
};
const $2dd4f45c8894762f$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $2dd4f45c8894762f$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $2dd4f45c8894762f$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $2dd4f45c8894762f$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $2dd4f45c8894762f$var$HASH = $2dd4f45c8894762f$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $2dd4f45c8894762f$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $2dd4f45c8894762f$var$flush_block_only = (s, last)=>{
    $2dd4f45c8894762f$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $2dd4f45c8894762f$var$flush_pending(s.strm);
};
const $2dd4f45c8894762f$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $2dd4f45c8894762f$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $2dd4f45c8894762f$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $2dd4f45c8894762f$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
        scan = strend - $2dd4f45c8894762f$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $2dd4f45c8894762f$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $2dd4f45c8894762f$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $2dd4f45c8894762f$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $2dd4f45c8894762f$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $2dd4f45c8894762f$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 || flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $2dd4f45c8894762f$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $2dd4f45c8894762f$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $2dd4f45c8894762f$var$Z_FINISH$3) && flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $2dd4f45c8894762f$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $2dd4f45c8894762f$var$BS_FINISH_STARTED : $2dd4f45c8894762f$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $2dd4f45c8894762f$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
        if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $2dd4f45c8894762f$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $2dd4f45c8894762f$var$Z_FILTERED || s.match_length === $2dd4f45c8894762f$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $2dd4f45c8894762f$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $2dd4f45c8894762f$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $2dd4f45c8894762f$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $2dd4f45c8894762f$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 1, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $2dd4f45c8894762f$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $2dd4f45c8894762f$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $2dd4f45c8894762f$var$configuration_table = [
    /*      good lazy nice chain */ new $2dd4f45c8894762f$var$Config(0, 0, 0, 0, $2dd4f45c8894762f$var$deflate_stored),
    /* 0 store only */ new $2dd4f45c8894762f$var$Config(4, 4, 8, 4, $2dd4f45c8894762f$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $2dd4f45c8894762f$var$Config(4, 5, 16, 8, $2dd4f45c8894762f$var$deflate_fast),
    /* 2 */ new $2dd4f45c8894762f$var$Config(4, 6, 32, 32, $2dd4f45c8894762f$var$deflate_fast),
    /* 3 */ new $2dd4f45c8894762f$var$Config(4, 4, 16, 16, $2dd4f45c8894762f$var$deflate_slow),
    /* 4 lazy matches */ new $2dd4f45c8894762f$var$Config(8, 16, 32, 32, $2dd4f45c8894762f$var$deflate_slow),
    /* 5 */ new $2dd4f45c8894762f$var$Config(8, 16, 128, 128, $2dd4f45c8894762f$var$deflate_slow),
    /* 6 */ new $2dd4f45c8894762f$var$Config(8, 32, 128, 256, $2dd4f45c8894762f$var$deflate_slow),
    /* 7 */ new $2dd4f45c8894762f$var$Config(32, 128, 258, 1024, $2dd4f45c8894762f$var$deflate_slow),
    /* 8 */ new $2dd4f45c8894762f$var$Config(32, 258, 258, 4096, $2dd4f45c8894762f$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $2dd4f45c8894762f$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $2dd4f45c8894762f$var$configuration_table[s.level].max_lazy;
    s.good_match = $2dd4f45c8894762f$var$configuration_table[s.level].good_length;
    s.nice_match = $2dd4f45c8894762f$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $2dd4f45c8894762f$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $2dd4f45c8894762f$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $2dd4f45c8894762f$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($2dd4f45c8894762f$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $2dd4f45c8894762f$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $2dd4f45c8894762f$var$BL_CODES + 1) * 2);
    $2dd4f45c8894762f$var$zero(this.dyn_ltree);
    $2dd4f45c8894762f$var$zero(this.dyn_dtree);
    $2dd4f45c8894762f$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($2dd4f45c8894762f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $2dd4f45c8894762f$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $2dd4f45c8894762f$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $2dd4f45c8894762f$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $2dd4f45c8894762f$var$INIT_STATE && //#ifdef GZIP
    s.status !== $2dd4f45c8894762f$var$GZIP_STATE && //#endif
    s.status !== $2dd4f45c8894762f$var$EXTRA_STATE && s.status !== $2dd4f45c8894762f$var$NAME_STATE && s.status !== $2dd4f45c8894762f$var$COMMENT_STATE && s.status !== $2dd4f45c8894762f$var$HCRC_STATE && s.status !== $2dd4f45c8894762f$var$BUSY_STATE && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$deflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $2dd4f45c8894762f$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $2dd4f45c8894762f$var$GZIP_STATE : //#endif
    s.wrap ? $2dd4f45c8894762f$var$INIT_STATE : $2dd4f45c8894762f$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $2dd4f45c8894762f$var$_tr_init(s);
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateReset = (strm)=>{
    const ret = $2dd4f45c8894762f$var$deflateResetKeep(strm);
    if (ret === $2dd4f45c8894762f$var$Z_OK$3) $2dd4f45c8894762f$var$lm_init(strm.state);
    return ret;
};
const $2dd4f45c8894762f$var$deflateSetHeader = (strm, head)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $2dd4f45c8894762f$var$MAX_MEM_LEVEL || method !== $2dd4f45c8894762f$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $2dd4f45c8894762f$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $2dd4f45c8894762f$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $2dd4f45c8894762f$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $2dd4f45c8894762f$var$MIN_MATCH - 1) / $2dd4f45c8894762f$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $2dd4f45c8894762f$var$deflateReset(strm);
};
const $2dd4f45c8894762f$var$deflateInit = (strm, level)=>{
    return $2dd4f45c8894762f$var$deflateInit2(strm, level, $2dd4f45c8894762f$var$Z_DEFLATED$2, $2dd4f45c8894762f$var$MAX_WBITS$1, $2dd4f45c8894762f$var$DEF_MEM_LEVEL, $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $2dd4f45c8894762f$var$deflate$2 = (strm, flush)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || flush > $2dd4f45c8894762f$var$Z_BLOCK$1 || flush < 0) return strm ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2) : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $2dd4f45c8894762f$var$FINISH_STATE && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, strm.avail_out === 0 ? $2dd4f45c8894762f$var$Z_BUF_ERROR$1 : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $2dd4f45c8894762f$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $2dd4f45c8894762f$var$rank(flush) <= $2dd4f45c8894762f$var$rank(old_flush) && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $2dd4f45c8894762f$var$FINISH_STATE && strm.avail_in !== 0) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $2dd4f45c8894762f$var$INIT_STATE && s.wrap === 0) s.status = $2dd4f45c8894762f$var$BUSY_STATE;
    if (s.status === $2dd4f45c8894762f$var$INIT_STATE) {
        /* zlib header */ let header = $2dd4f45c8894762f$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $2dd4f45c8894762f$var$PRESET_DICT;
        header += 31 - header % 31;
        $2dd4f45c8894762f$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $2dd4f45c8894762f$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $2dd4f45c8894762f$var$put_byte(s, 31);
        $2dd4f45c8894762f$var$put_byte(s, 139);
        $2dd4f45c8894762f$var$put_byte(s, 8);
        if (!s.gzhead) {
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, $2dd4f45c8894762f$var$OS_CODE);
            s.status = $2dd4f45c8894762f$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        } else {
            $2dd4f45c8894762f$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $2dd4f45c8894762f$var$EXTRA_STATE;
        }
    }
    if (s.status === $2dd4f45c8894762f$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$NAME_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$COMMENT_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $2dd4f45c8894762f$var$HCRC_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
            }
            $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $2dd4f45c8894762f$var$deflate_stored(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY ? $2dd4f45c8894762f$var$deflate_huff(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_RLE ? $2dd4f45c8894762f$var$deflate_rle(s, flush) : $2dd4f45c8894762f$var$configuration_table[s.level].func(s, flush);
        if (bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED || bstate === $2dd4f45c8894762f$var$BS_FINISH_DONE) s.status = $2dd4f45c8894762f$var$FINISH_STATE;
        if (bstate === $2dd4f45c8894762f$var$BS_NEED_MORE || bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $2dd4f45c8894762f$var$BS_BLOCK_DONE) {
            if (flush === $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH) $2dd4f45c8894762f$var$_tr_align(s);
            else if (flush !== $2dd4f45c8894762f$var$Z_BLOCK$1) {
                $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $2dd4f45c8894762f$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $2dd4f45c8894762f$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        }
    }
    if (flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$Z_OK$3;
    if (s.wrap <= 0) return $2dd4f45c8894762f$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 24 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $2dd4f45c8894762f$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $2dd4f45c8894762f$var$Z_OK$3 : $2dd4f45c8894762f$var$Z_STREAM_END$3;
};
const $2dd4f45c8894762f$var$deflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $2dd4f45c8894762f$var$BUSY_STATE ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_DATA_ERROR$2) : $2dd4f45c8894762f$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $2dd4f45c8894762f$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $2dd4f45c8894762f$var$INIT_STATE || s.lookahead) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $2dd4f45c8894762f$var$fill_window(s);
    while(s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($2dd4f45c8894762f$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        $2dd4f45c8894762f$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
var $2dd4f45c8894762f$var$deflateInit_1 = $2dd4f45c8894762f$var$deflateInit;
var $2dd4f45c8894762f$var$deflateInit2_1 = $2dd4f45c8894762f$var$deflateInit2;
var $2dd4f45c8894762f$var$deflateReset_1 = $2dd4f45c8894762f$var$deflateReset;
var $2dd4f45c8894762f$var$deflateResetKeep_1 = $2dd4f45c8894762f$var$deflateResetKeep;
var $2dd4f45c8894762f$var$deflateSetHeader_1 = $2dd4f45c8894762f$var$deflateSetHeader;
var $2dd4f45c8894762f$var$deflate_2$1 = $2dd4f45c8894762f$var$deflate$2;
var $2dd4f45c8894762f$var$deflateEnd_1 = $2dd4f45c8894762f$var$deflateEnd;
var $2dd4f45c8894762f$var$deflateSetDictionary_1 = $2dd4f45c8894762f$var$deflateSetDictionary;
var $2dd4f45c8894762f$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $2dd4f45c8894762f$var$deflate_1$2 = {
    deflateInit: $2dd4f45c8894762f$var$deflateInit_1,
    deflateInit2: $2dd4f45c8894762f$var$deflateInit2_1,
    deflateReset: $2dd4f45c8894762f$var$deflateReset_1,
    deflateResetKeep: $2dd4f45c8894762f$var$deflateResetKeep_1,
    deflateSetHeader: $2dd4f45c8894762f$var$deflateSetHeader_1,
    deflate: $2dd4f45c8894762f$var$deflate_2$1,
    deflateEnd: $2dd4f45c8894762f$var$deflateEnd_1,
    deflateSetDictionary: $2dd4f45c8894762f$var$deflateSetDictionary_1,
    deflateInfo: $2dd4f45c8894762f$var$deflateInfo
};
const $2dd4f45c8894762f$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $2dd4f45c8894762f$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($2dd4f45c8894762f$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $2dd4f45c8894762f$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $2dd4f45c8894762f$var$common = {
    assign: $2dd4f45c8894762f$var$assign,
    flattenChunks: $2dd4f45c8894762f$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $2dd4f45c8894762f$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$2dd4f45c8894762f$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$2dd4f45c8894762f$var$_utf8len[254] = $2dd4f45c8894762f$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $2dd4f45c8894762f$var$string2buf = (str)=>{
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $2dd4f45c8894762f$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $2dd4f45c8894762f$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $2dd4f45c8894762f$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $2dd4f45c8894762f$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $2dd4f45c8894762f$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $2dd4f45c8894762f$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $2dd4f45c8894762f$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $2dd4f45c8894762f$var$strings = {
    string2buf: $2dd4f45c8894762f$var$string2buf,
    buf2string: $2dd4f45c8894762f$var$buf2string,
    utf8border: $2dd4f45c8894762f$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $2dd4f45c8894762f$var$zstream = $2dd4f45c8894762f$var$ZStream;
const $2dd4f45c8894762f$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $2dd4f45c8894762f$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$2, Z_OK: $2dd4f45c8894762f$var$Z_OK$2, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$1 } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Deflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        level: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION,
        method: $2dd4f45c8894762f$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
    if (opt.header) $2dd4f45c8894762f$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $2dd4f45c8894762f$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH$2 : $2dd4f45c8894762f$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $2dd4f45c8894762f$var$strings.string2buf(data);
    else if ($2dd4f45c8894762f$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $2dd4f45c8894762f$var$Z_SYNC_FLUSH || _flush_mode === $2dd4f45c8894762f$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $2dd4f45c8894762f$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $2dd4f45c8894762f$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $2dd4f45c8894762f$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK$2) this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $2dd4f45c8894762f$var$deflate$1(input, options) {
    const deflator = new $2dd4f45c8894762f$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $2dd4f45c8894762f$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $2dd4f45c8894762f$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
var $2dd4f45c8894762f$var$Deflate_1$1 = $2dd4f45c8894762f$var$Deflate$1;
var $2dd4f45c8894762f$var$deflate_2 = $2dd4f45c8894762f$var$deflate$1;
var $2dd4f45c8894762f$var$deflateRaw_1$1 = $2dd4f45c8894762f$var$deflateRaw$1;
var $2dd4f45c8894762f$var$gzip_1$1 = $2dd4f45c8894762f$var$gzip$1;
var $2dd4f45c8894762f$var$constants$1 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$deflate_1$1 = {
    Deflate: $2dd4f45c8894762f$var$Deflate_1$1,
    deflate: $2dd4f45c8894762f$var$deflate_2,
    deflateRaw: $2dd4f45c8894762f$var$deflateRaw_1$1,
    gzip: $2dd4f45c8894762f$var$gzip_1$1,
    constants: $2dd4f45c8894762f$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $2dd4f45c8894762f$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $2dd4f45c8894762f$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $2dd4f45c8894762f$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $2dd4f45c8894762f$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $2dd4f45c8894762f$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $2dd4f45c8894762f$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $2dd4f45c8894762f$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$MAXBITS = 15;
const $2dd4f45c8894762f$var$ENOUGH_LENS$1 = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$CODES$1 = 0;
const $2dd4f45c8894762f$var$LENS$1 = 1;
const $2dd4f45c8894762f$var$DISTS$1 = 2;
const $2dd4f45c8894762f$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $2dd4f45c8894762f$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $2dd4f45c8894762f$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $2dd4f45c8894762f$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $2dd4f45c8894762f$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2dd4f45c8894762f$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2dd4f45c8894762f$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2dd4f45c8894762f$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2dd4f45c8894762f$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2dd4f45c8894762f$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2dd4f45c8894762f$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $2dd4f45c8894762f$var$LENS$1) {
        base = $2dd4f45c8894762f$var$lbase;
        extra = $2dd4f45c8894762f$var$lext;
        match = 257;
    } else {
        base = $2dd4f45c8894762f$var$dbase;
        extra = $2dd4f45c8894762f$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $2dd4f45c8894762f$var$inftrees = $2dd4f45c8894762f$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$CODES = 0;
const $2dd4f45c8894762f$var$LENS = 1;
const $2dd4f45c8894762f$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$1, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK, Z_TREES: $2dd4f45c8894762f$var$Z_TREES, Z_OK: $2dd4f45c8894762f$var$Z_OK$1, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$1, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED } = $2dd4f45c8894762f$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $2dd4f45c8894762f$var$HEAD = 16180; /* i: waiting for magic header */ 
const $2dd4f45c8894762f$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $2dd4f45c8894762f$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $2dd4f45c8894762f$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $2dd4f45c8894762f$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $2dd4f45c8894762f$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $2dd4f45c8894762f$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $2dd4f45c8894762f$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $2dd4f45c8894762f$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $2dd4f45c8894762f$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $2dd4f45c8894762f$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $2dd4f45c8894762f$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $2dd4f45c8894762f$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $2dd4f45c8894762f$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $2dd4f45c8894762f$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $2dd4f45c8894762f$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $2dd4f45c8894762f$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $2dd4f45c8894762f$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $2dd4f45c8894762f$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $2dd4f45c8894762f$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $2dd4f45c8894762f$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $2dd4f45c8894762f$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $2dd4f45c8894762f$var$DIST = 16202; /* i: waiting for distance code */ 
const $2dd4f45c8894762f$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $2dd4f45c8894762f$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $2dd4f45c8894762f$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $2dd4f45c8894762f$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $2dd4f45c8894762f$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $2dd4f45c8894762f$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $2dd4f45c8894762f$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $2dd4f45c8894762f$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $2dd4f45c8894762f$var$ENOUGH_LENS = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_WBITS = $2dd4f45c8894762f$var$MAX_WBITS;
const $2dd4f45c8894762f$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $2dd4f45c8894762f$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $2dd4f45c8894762f$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $2dd4f45c8894762f$var$HEAD || state.mode > $2dd4f45c8894762f$var$SYNC) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$inflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $2dd4f45c8894762f$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateReset = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $2dd4f45c8894762f$var$inflateResetKeep(strm);
};
const $2dd4f45c8894762f$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $2dd4f45c8894762f$var$inflateReset(strm);
};
const $2dd4f45c8894762f$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $2dd4f45c8894762f$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $2dd4f45c8894762f$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $2dd4f45c8894762f$var$inflateReset2(strm, windowBits);
    if (ret !== $2dd4f45c8894762f$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $2dd4f45c8894762f$var$inflateInit = (strm)=>{
    return $2dd4f45c8894762f$var$inflateInit2(strm, $2dd4f45c8894762f$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $2dd4f45c8894762f$var$virgin = true;
let $2dd4f45c8894762f$var$lenfix, $2dd4f45c8894762f$var$distfix; // We have no pointers in JS, so keep tables separate
const $2dd4f45c8894762f$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($2dd4f45c8894762f$var$virgin) {
        $2dd4f45c8894762f$var$lenfix = new Int32Array(512);
        $2dd4f45c8894762f$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, 288, $2dd4f45c8894762f$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, 0, 32, $2dd4f45c8894762f$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $2dd4f45c8894762f$var$virgin = false;
    }
    state.lencode = $2dd4f45c8894762f$var$lenfix;
    state.lenbits = 9;
    state.distcode = $2dd4f45c8894762f$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $2dd4f45c8894762f$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $2dd4f45c8894762f$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $2dd4f45c8894762f$var$TYPE) state.mode = $2dd4f45c8894762f$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $2dd4f45c8894762f$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $2dd4f45c8894762f$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $2dd4f45c8894762f$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $2dd4f45c8894762f$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $2dd4f45c8894762f$var$DICTID : $2dd4f45c8894762f$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $2dd4f45c8894762f$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$TIME;
        /* falls through */ case $2dd4f45c8894762f$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$OS;
        /* falls through */ case $2dd4f45c8894762f$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$EXLEN;
        /* falls through */ case $2dd4f45c8894762f$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $2dd4f45c8894762f$var$EXTRA;
        /* falls through */ case $2dd4f45c8894762f$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$NAME;
        /* falls through */ case $2dd4f45c8894762f$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$COMMENT;
        /* falls through */ case $2dd4f45c8894762f$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $2dd4f45c8894762f$var$HCRC;
        /* falls through */ case $2dd4f45c8894762f$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $2dd4f45c8894762f$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$DICT;
        /* falls through */ case $2dd4f45c8894762f$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $2dd4f45c8894762f$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $2dd4f45c8894762f$var$TYPE;
        /* falls through */ case $2dd4f45c8894762f$var$TYPE:
            if (flush === $2dd4f45c8894762f$var$Z_BLOCK || flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $2dd4f45c8894762f$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $2dd4f45c8894762f$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$LEN_; /* decode codes */ 
                    if (flush === $2dd4f45c8894762f$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $2dd4f45c8894762f$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $2dd4f45c8894762f$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$COPY_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$COPY_:
            state.mode = $2dd4f45c8894762f$var$COPY;
        /* falls through */ case $2dd4f45c8894762f$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$LENLENS;
        /* falls through */ case $2dd4f45c8894762f$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$CODELENS;
        /* falls through */ case $2dd4f45c8894762f$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $2dd4f45c8894762f$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $2dd4f45c8894762f$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $2dd4f45c8894762f$var$LEN_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$LEN_:
            state.mode = $2dd4f45c8894762f$var$LEN;
        /* falls through */ case $2dd4f45c8894762f$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $2dd4f45c8894762f$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $2dd4f45c8894762f$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $2dd4f45c8894762f$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $2dd4f45c8894762f$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$LENEXT;
        /* falls through */ case $2dd4f45c8894762f$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $2dd4f45c8894762f$var$DIST;
        /* falls through */ case $2dd4f45c8894762f$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$DISTEXT;
        /* falls through */ case $2dd4f45c8894762f$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $2dd4f45c8894762f$var$MATCH;
        /* falls through */ case $2dd4f45c8894762f$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, put - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $2dd4f45c8894762f$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$LENGTH;
        /* falls through */ case $2dd4f45c8894762f$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$DONE;
        /* falls through */ case $2dd4f45c8894762f$var$DONE:
            ret = $2dd4f45c8894762f$var$Z_STREAM_END$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$BAD:
            ret = $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$MEM:
            return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
        case $2dd4f45c8894762f$var$SYNC:
        /* falls through */ default:
            return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $2dd4f45c8894762f$var$BAD && (state.mode < $2dd4f45c8894762f$var$CHECK || flush !== $2dd4f45c8894762f$var$Z_FINISH$1)) $2dd4f45c8894762f$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $2dd4f45c8894762f$var$TYPE ? 128 : 0) + (state.mode === $2dd4f45c8894762f$var$LEN_ || state.mode === $2dd4f45c8894762f$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $2dd4f45c8894762f$var$Z_FINISH$1) && ret === $2dd4f45c8894762f$var$Z_OK$1) ret = $2dd4f45c8894762f$var$Z_BUF_ERROR;
    return ret;
};
const $2dd4f45c8894762f$var$inflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $2dd4f45c8894762f$var$DICT) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $2dd4f45c8894762f$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $2dd4f45c8894762f$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $2dd4f45c8894762f$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $2dd4f45c8894762f$var$MEM;
        return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
var $2dd4f45c8894762f$var$inflateReset_1 = $2dd4f45c8894762f$var$inflateReset;
var $2dd4f45c8894762f$var$inflateReset2_1 = $2dd4f45c8894762f$var$inflateReset2;
var $2dd4f45c8894762f$var$inflateResetKeep_1 = $2dd4f45c8894762f$var$inflateResetKeep;
var $2dd4f45c8894762f$var$inflateInit_1 = $2dd4f45c8894762f$var$inflateInit;
var $2dd4f45c8894762f$var$inflateInit2_1 = $2dd4f45c8894762f$var$inflateInit2;
var $2dd4f45c8894762f$var$inflate_2$1 = $2dd4f45c8894762f$var$inflate$2;
var $2dd4f45c8894762f$var$inflateEnd_1 = $2dd4f45c8894762f$var$inflateEnd;
var $2dd4f45c8894762f$var$inflateGetHeader_1 = $2dd4f45c8894762f$var$inflateGetHeader;
var $2dd4f45c8894762f$var$inflateSetDictionary_1 = $2dd4f45c8894762f$var$inflateSetDictionary;
var $2dd4f45c8894762f$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $2dd4f45c8894762f$var$inflate_1$2 = {
    inflateReset: $2dd4f45c8894762f$var$inflateReset_1,
    inflateReset2: $2dd4f45c8894762f$var$inflateReset2_1,
    inflateResetKeep: $2dd4f45c8894762f$var$inflateResetKeep_1,
    inflateInit: $2dd4f45c8894762f$var$inflateInit_1,
    inflateInit2: $2dd4f45c8894762f$var$inflateInit2_1,
    inflate: $2dd4f45c8894762f$var$inflate_2$1,
    inflateEnd: $2dd4f45c8894762f$var$inflateEnd_1,
    inflateGetHeader: $2dd4f45c8894762f$var$inflateGetHeader_1,
    inflateSetDictionary: $2dd4f45c8894762f$var$inflateSetDictionary_1,
    inflateInfo: $2dd4f45c8894762f$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $2dd4f45c8894762f$var$gzheader = $2dd4f45c8894762f$var$GZheader;
const $2dd4f45c8894762f$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH, Z_OK: $2dd4f45c8894762f$var$Z_OK, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Inflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
    this.header = new $2dd4f45c8894762f$var$gzheader();
    $2dd4f45c8894762f$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH : $2dd4f45c8894762f$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($2dd4f45c8894762f$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $2dd4f45c8894762f$var$Z_NEED_DICT && dictionary) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $2dd4f45c8894762f$var$Z_OK) status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $2dd4f45c8894762f$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $2dd4f45c8894762f$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2dd4f45c8894762f$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $2dd4f45c8894762f$var$inflate_1$2.inflateReset(strm);
            status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2dd4f45c8894762f$var$Z_STREAM_ERROR:
            case $2dd4f45c8894762f$var$Z_DATA_ERROR:
            case $2dd4f45c8894762f$var$Z_NEED_DICT:
            case $2dd4f45c8894762f$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2dd4f45c8894762f$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $2dd4f45c8894762f$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $2dd4f45c8894762f$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2dd4f45c8894762f$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2dd4f45c8894762f$var$inflate$1(input, options) {
    const inflator = new $2dd4f45c8894762f$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $2dd4f45c8894762f$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2dd4f45c8894762f$var$Inflate_1$1 = $2dd4f45c8894762f$var$Inflate$1;
var $2dd4f45c8894762f$var$inflate_2 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$inflateRaw_1$1 = $2dd4f45c8894762f$var$inflateRaw$1;
var $2dd4f45c8894762f$var$ungzip$1 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$constants = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$inflate_1$1 = {
    Inflate: $2dd4f45c8894762f$var$Inflate_1$1,
    inflate: $2dd4f45c8894762f$var$inflate_2,
    inflateRaw: $2dd4f45c8894762f$var$inflateRaw_1$1,
    ungzip: $2dd4f45c8894762f$var$ungzip$1,
    constants: $2dd4f45c8894762f$var$constants
};
const { Deflate: $2dd4f45c8894762f$var$Deflate, deflate: $2dd4f45c8894762f$var$deflate, deflateRaw: $2dd4f45c8894762f$var$deflateRaw, gzip: $2dd4f45c8894762f$var$gzip } = $2dd4f45c8894762f$var$deflate_1$1;
const { Inflate: $2dd4f45c8894762f$var$Inflate, inflate: $2dd4f45c8894762f$var$inflate, inflateRaw: $2dd4f45c8894762f$var$inflateRaw, ungzip: $2dd4f45c8894762f$var$ungzip } = $2dd4f45c8894762f$var$inflate_1$1;
var $2dd4f45c8894762f$export$ae157b6234afe138 = $2dd4f45c8894762f$var$Deflate;
var $2dd4f45c8894762f$export$2316623ecd1285ab = $2dd4f45c8894762f$var$deflate;
var $2dd4f45c8894762f$export$e95d6a8f69fb340a = $2dd4f45c8894762f$var$deflateRaw;
var $2dd4f45c8894762f$export$69f0ea7cf3a331a8 = $2dd4f45c8894762f$var$gzip;
var $2dd4f45c8894762f$export$d1de70a877d6e43c = $2dd4f45c8894762f$var$Inflate;
var $2dd4f45c8894762f$export$cae1ce83fe4a1782 = $2dd4f45c8894762f$var$inflate;
var $2dd4f45c8894762f$export$d0f0aa2d05c905c5 = $2dd4f45c8894762f$var$inflateRaw;
var $2dd4f45c8894762f$export$95adf9d270383091 = $2dd4f45c8894762f$var$ungzip;
var $2dd4f45c8894762f$export$1a988e7317c65621 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$export$2e2bcd8739ae039 = {
    Deflate: $2dd4f45c8894762f$export$ae157b6234afe138,
    deflate: $2dd4f45c8894762f$export$2316623ecd1285ab,
    deflateRaw: $2dd4f45c8894762f$export$e95d6a8f69fb340a,
    gzip: $2dd4f45c8894762f$export$69f0ea7cf3a331a8,
    Inflate: $2dd4f45c8894762f$export$d1de70a877d6e43c,
    inflate: $2dd4f45c8894762f$export$cae1ce83fe4a1782,
    inflateRaw: $2dd4f45c8894762f$export$d0f0aa2d05c905c5,
    ungzip: $2dd4f45c8894762f$export$95adf9d270383091,
    constants: $2dd4f45c8894762f$export$1a988e7317c65621
};

});

parcelRegister("e1Wzw", function(module, exports) {
/*!
 * jwe/defaults.js - Defaults for JWEs
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";
/**
 * @description
 * The default options for {@link JWE.createEncrypt}.
 *
 * @property {Boolean|String} zip Determines the compression algorithm to
 *           apply to the plaintext (if any) before it is encrypted. This can
 *           also be `true` (which is equivalent to `"DEF"`) or **`false`**
 *           (the default, which is equivalent to no compression).
 * @property {String} format Determines the serialization format of the
 *           output.  Expected to be `"general"` for general JSON
 *           Serialization, `"flattened"` for flattened JSON Serialization,
 *           or `"compact"` for Compact Serialization (default is
 *           **`"general"`**).
 * @property {Boolean} compact Determines if the output is the Compact
 *           serialization (`true`) or the JSON serialization (**`false`**,
 *           the default).
 * @property {String} contentAlg The algorithm used to encrypt the plaintext
 *           (default is **`"A128CBC-HS256"`**).
 * @property {String|String[]} protect The names of the headers to integrity
 *           protect.  The value `""` means that none of the header parameters
 *           are integrity protected, while `"*"` (the default) means that all
 *           header parameters are integrity protected.
 */ var $a36e97d9135cf0be$var$JWEDefaults = {
    zip: false,
    format: "general",
    contentAlg: "A128CBC-HS256",
    protect: "*"
};
module.exports = $a36e97d9135cf0be$var$JWEDefaults;

});


parcelRegister("pCSHk", function(module, exports) {
/*!
 * jwe/decrypt.js - Decrypt from a JWE
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $04d07eea56924e86$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $gS7wL = parcelRequire("gS7wL");

var $d1TAe = parcelRequire("d1TAe");

var $dXx0Z = parcelRequire("dXx0Z");

var $2rglK = parcelRequire("2rglK");

var $e4ypD = parcelRequire("e4ypD");
var $04d07eea56924e86$var$DEFAULT_OPTIONS = {
    algorithms: "*"
};
/**
 * @class JWE.Decrypter
 * @classdesc Processor of encrypted data.
 *
 * @description
 * **NOTE:** This class cannot be instantiated directly. Instead
 * call {@link JWE.createDecrypt}.
 */ function $04d07eea56924e86$var$JWEDecrypter(ks, globalOpts) {
    var assumedKey, keystore;
    if ($dXx0Z.isKey(ks)) {
        assumedKey = ks;
        keystore = assumedKey.keystore;
    } else if ($dXx0Z.isKeyStore(ks)) keystore = ks;
    else throw new TypeError("Keystore must be provided");
    globalOpts = $2rglK({}, $04d07eea56924e86$var$DEFAULT_OPTIONS, globalOpts);
    /**
   * Decrypts the given input.
   *
   * {opts}, if provided, is used to customize this specific decrypt operation.
   * This argument has the same semantics as {JWE.createDecrypt}, and takes
   * precedence over those options.
   *
   * The returned PRomise, when fulfilled, returns an object with the
   * following members:
   *
   * - `header` - The JOSE Header, combined from the relevant "header" and
   *            "protected" fields from the original JWE object.
   * - `protected` - An array containing the names of the protected fields
   * - `key` - The used to decrypt the content
   * - `payload` - The decrypted content (as a Buffer)
   * - `plaintext` - An alias for `payload`
   *
   * @param {Object|String} input The encrypted content
   * @param {Object} [opts] The options for this decryption operation.
   * @returns {Promise} A promise for the decyprted plaintext
   */ Object.defineProperty(this, "decrypt", {
        value: function(input, opts) {
            opts = $2rglK({}, globalOpts, opts || {});
            var extraHandlers = opts.handlers || {};
            var handlerKeys = Object.keys(extraHandlers);
            var algSpec = new $d1TAe(opts.algorithms);
            /* eslint camelcase: [0] */ if (typeof input === "string") {
                input = input.split(".");
                input = {
                    protected: input[0],
                    recipients: [
                        {
                            encrypted_key: input[1]
                        }
                    ],
                    iv: input[2],
                    ciphertext: input[3],
                    tag: input[4]
                };
            } else if (!input || typeof input !== "object") throw new Error("invalid input");
            if ("encrypted_key" in input) input.recipients = [
                {
                    encrypted_key: input.encrypted_key
                }
            ];
            var promise;
            // ensure recipients exists
            var rcptList = input.recipients || [
                {}
            ];
            promise = Promise.resolve(rcptList);
            //combine fields
            var fields, protect;
            promise = promise.then(function(rcptList) {
                if (input.protected) {
                    protect = $gS7wL.decode(input.protected).toString("utf8");
                    protect = JSON.parse(protect);
                    // verify "crit" field first
                    var crit = protect.crit;
                    if (crit) {
                        if (!Array.isArray(crit)) return Promise.reject(new Error("Invalid 'crit' header"));
                        for(var idx = 0; crit.length > idx; idx++){
                            if (-1 === handlerKeys.indexOf(crit[idx])) return Promise.reject(new Error("Critical extension is not supported: " + crit[idx]));
                        }
                    }
                    fields = protect;
                    protect = Object.keys(protect);
                } else {
                    fields = {};
                    protect = [];
                }
                fields = $2rglK(input.unprotected || {}, fields);
                rcptList = rcptList.map(function(r) {
                    var promise = Promise.resolve();
                    var header = r.header || {};
                    header = $2rglK(header, fields);
                    r.header = header;
                    r.protected = protect;
                    // check on allowed algorithms
                    if (!algSpec.match(header.alg)) promise = promise.then(function() {
                        return Promise.reject(new Error("Algorithm not allowed: " + header.alg));
                    });
                    if (!algSpec.match(header.enc)) promise = promise.then(function() {
                        return Promise.reject(new Error("Algorithm not allowed: " + header.enc));
                    });
                    if (header.epk) {
                        promise = promise.then(function() {
                            return $dXx0Z.asKey(header.epk);
                        });
                        promise = promise.then(function(epk) {
                            header.epk = epk.toObject(false);
                        });
                    }
                    return promise.then(function() {
                        return r;
                    });
                });
                return Promise.all(rcptList);
            });
            // decrypt with first key found
            var algKey, encKey, kdata;
            promise = promise.then(function(rcptList) {
                var jwe = {};
                return new Promise(function(resolve, reject) {
                    var processKey = function() {
                        var rcpt = rcptList.shift();
                        if (!rcpt) {
                            reject(new Error("no key found"));
                            return;
                        }
                        var algPromise = Promise.resolve(rcpt);
                        algPromise = algPromise.then(function(rcpt) {
                            // try to unwrap encrypted key
                            var prekey = kdata = rcpt.encrypted_key || "";
                            prekey = $gS7wL.decode(prekey);
                            algKey = assumedKey || keystore.get({
                                use: "enc",
                                alg: rcpt.header.alg,
                                kid: rcpt.header.kid
                            });
                            if (algKey) return algKey.unwrap(rcpt.header.alg, prekey, rcpt.header);
                            else return Promise.reject();
                        });
                        algPromise = algPromise.then(function(key) {
                            encKey = {
                                "kty": "oct",
                                "k": $gS7wL.encode(key)
                            };
                            encKey = $dXx0Z.asKey(encKey);
                            jwe.key = algKey;
                            jwe.header = rcpt.header;
                            jwe.protected = rcpt.protected;
                            resolve(jwe);
                        });
                        algPromise.catch(processKey);
                    };
                    processKey();
                });
            });
            // assign decipher inputs
            promise = promise.then(function(jwe) {
                jwe.iv = input.iv;
                jwe.tag = input.tag;
                jwe.ciphertext = input.ciphertext;
                return jwe;
            });
            // process any prepare-decrypt handlers
            promise = promise.then(function(jwe) {
                var processing = [];
                handlerKeys.forEach(function(h) {
                    h = extraHandlers[h];
                    var p;
                    if ("function" === typeof h) p = h(jwe);
                    else if ("object" === typeof h && "function" === typeof h.prepare) p = h.prepare(jwe);
                    if (p) processing.push(Promise.resolve(p));
                });
                return Promise.all(processing).then(function() {
                    // don't actually care about individual handler results
                    // assume {jwe} is updated
                    return jwe;
                });
            });
            // prepare decrypt inputs
            promise = promise.then(function(jwe) {
                if (!$04d07eea56924e86$require$Buffer.isBuffer(jwe.ciphertext)) jwe.ciphertext = $gS7wL.decode(jwe.ciphertext);
                return jwe;
            });
            // decrypt it!
            promise = promise.then(function(jwe) {
                var adata = input.protected;
                if ("aad" in input && null != input.aad) adata += "." + input.aad;
                var params = {
                    iv: jwe.iv,
                    adata: adata,
                    tag: jwe.tag,
                    kdata: kdata,
                    epu: jwe.epu,
                    epv: jwe.epv
                };
                var cdata = jwe.ciphertext;
                delete jwe.iv;
                delete jwe.tag;
                delete jwe.ciphertext;
                return encKey.then(function(enkKey) {
                    return enkKey.decrypt(jwe.header.enc, cdata, params).then(function(pdata) {
                        jwe.payload = jwe.plaintext = pdata;
                        return jwe;
                    });
                });
            });
            // (OPTIONAL) decompress plaintext
            promise = promise.then(function(jwe) {
                if ("DEF" === jwe.header.zip) return new Promise(function(resolve, reject) {
                    try {
                        var data = $e4ypD.inflateRaw($04d07eea56924e86$require$Buffer.from(jwe.plaintext));
                        jwe.payload = jwe.plaintext = $04d07eea56924e86$require$Buffer.from(data);
                        resolve(jwe);
                    } catch (err) {
                        reject(err);
                    }
                });
                return jwe;
            });
            // process any post-decrypt handlers
            promise = promise.then(function(jwe) {
                var processing = [];
                handlerKeys.forEach(function(h) {
                    h = extraHandlers[h];
                    var p;
                    if ("object" === typeof h && "function" === typeof h.complete) p = h.complete(jwe);
                    if (p) processing.push(Promise.resolve(p));
                });
                return Promise.all(processing).then(function() {
                    // don't actually care about individual handler results
                    // assume {jwe} is updated
                    return jwe;
                });
            });
            return promise;
        }
    });
}
/**
 * @description
 * Creates a new Decrypter for the given Key or KeyStore.
 *
 * {opts}, when provided, is used to customize decryption processes. The
 * following options are currently supported:
 *
 * - `handlers` - An object where each name is a JOSE header member name and
 *   the value can be a boolean, function, or an object.
 *
 * Handlers are intended to support 'crit' extensions. When a boolean value,
 * the member is expected to be processed once decryption is fully complete.
 * When a function, it is called just before the ciphertext is decrypted
 * (processed as if it were a `prepare` handler, as decribed below). When an
 * object, it can contain any of the following members:
 *
 * - `recipient` - A function called after a valid key is determined; it takes
 *   an object describing the recipient, and returns a Promise that is
 *   fulfilled once the handler's processing is complete.
 * - `prepare` - A function called just prior to decrypting the ciphertext;
 *   it takes an object describing the decryption result (but containing
 *   `ciphertext` and `tag' instead of `payload` and `plaintext`), and
 *   returns a Promise that is fulfilled once the handler's processing is
 *   complete.
 * - `complete` - A function called once decryption is complete, just prior
 *   to fulfilling the Promise returned by `decrypt()`; it takes the object
 *   that will be returned by `decrypt()`'s fulfilled Promise, and returns
 *   a Promise that is fulfilled once the handler's processing is complete.
 *
 * Note that normal processing of `decrypt()` does not continue until all
 * relevant handlers have completed. Any changes handlers make to the
 * provided objects affects `decrypt()`'s processing.
 *
 * @param {JWK.Key|JWK.KeyStore} ks The Key or KeyStore to use for decryption.
 * @param {Object} [opts] The options for this Decrypter.
 * @returns {JWE.Decrypter} The new Decrypter.
 */ function $04d07eea56924e86$var$createDecrypt(ks, opts) {
    var dec = new $04d07eea56924e86$var$JWEDecrypter(ks, opts);
    return dec;
}
module.exports = {
    decrypter: $04d07eea56924e86$var$JWEDecrypter,
    createDecrypt: $04d07eea56924e86$var$createDecrypt
};

});


parcelRegister("km0rz", function(module, exports) {
/*!
 * parse/index.js - JOSE Parser Entry Point
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ed1634d2417c5ae3$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $3s9pA = parcelRequire("3s9pA");

var $daZfV = parcelRequire("daZfV");
var $ed1634d2417c5ae3$var$parse = module.exports = function(input) {
    if ($ed1634d2417c5ae3$require$Buffer.isBuffer(input)) // assume buffer holds a Compact Serialization string
    return $3s9pA(input.toString("ascii"));
    else if ("string" === typeof input) return $3s9pA(input);
    else if (input) return $daZfV(input);
    else throw new TypeError("invalid input");
};
$ed1634d2417c5ae3$var$parse.compact = $3s9pA;
$ed1634d2417c5ae3$var$parse.json = $daZfV;

});
parcelRegister("3s9pA", function(module, exports) {
/*!
 * parse/compact.js - JOSE Compact Serialization Parser
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";



var $283b49902b7f8608$var$jose = {
    JWE: (parcelRequire("d4JNN")),
    JWS: (parcelRequire("3jdDF")),
    util: (parcelRequire("jIqqR"))
};
function $283b49902b7f8608$var$parseCompact(input) {
    var parts = input.split(".");
    var type, op;
    if (3 === parts.length) {
        // JWS
        type = "JWS";
        op = function(ks, opts) {
            return $283b49902b7f8608$var$jose.JWS.createVerify(ks).verify(input, opts);
        };
    } else if (5 === parts.length) {
        // JWE
        type = "JWE";
        op = function(ks, opts) {
            return $283b49902b7f8608$var$jose.JWE.createDecrypt(ks).decrypt(input, opts);
        };
    } else throw new TypeError("invalid jose serialization");
    // parse header
    var header;
    header = $283b49902b7f8608$var$jose.util.base64url.decode(parts[0], "utf8");
    header = JSON.parse(header);
    return {
        type: type,
        format: "compact",
        input: input,
        header: header,
        perform: op
    };
}
module.exports = $283b49902b7f8608$var$parseCompact;

});

parcelRegister("daZfV", function(module, exports) {
/*!
 * parse/compact.js - JOSE JSON Serialization Parser
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */ "use strict";

var $2rglK = parcelRequire("2rglK");



var $997bb9b003907e53$var$jose = {
    JWE: (parcelRequire("d4JNN")),
    JWS: (parcelRequire("3jdDF")),
    util: (parcelRequire("jIqqR"))
};
function $997bb9b003907e53$var$parseJSON(input) {
    var type, op, headers;
    if ("signatures" in input || "signature" in input) {
        // JWS
        type = "JWS";
        op = function(ks, opts) {
            return $997bb9b003907e53$var$jose.JWS.createVerify(ks).verify(input, opts);
        };
        // headers can be (signatures[].protected, signatures[].header, signature.protected, signature.header)
        headers = input.signatures || [
            {
                protected: input.protected,
                header: input.header,
                signature: input.signature
            }
        ];
        headers = headers.map(function(sig) {
            var all = {};
            if (sig.header) all = $2rglK(all, sig.header);
            var prot;
            if (sig.protected) {
                prot = sig.protected;
                prot = $997bb9b003907e53$var$jose.util.base64url.decode(prot, "utf8");
                prot = JSON.parse(prot);
                all = $2rglK(all, prot);
            }
            return all;
        });
    } else if ("ciphertext" in input) {
        // JWE
        type = "JWE";
        op = function(ks, opts) {
            return $997bb9b003907e53$var$jose.JWE.createDecrypt(ks).decrypt(input, opts);
        };
        // headers can be (protected, unprotected, recipients[].header)
        var root = {};
        if (input.protected) {
            root.protected = input.protected;
            root.protected = $997bb9b003907e53$var$jose.util.base64url.decode(root.protected, "utf8");
            root.protected = JSON.parse(root.protected);
        }
        if (input.unprotected) root.unprotected = input.unprotected;
        headers = input.recipients || [
            {}
        ];
        headers = headers.map(function(rcpt) {
            var all = {};
            if (rcpt.header) all = $2rglK(all, rcpt.header);
            if (root.unprotected) all = $2rglK(all, root.unprotected);
            if (root.protected) all = $2rglK(all, root.protected);
            return all;
        });
    }
    return {
        type: type,
        format: "json",
        input: input,
        all: headers,
        perform: op
    };
}
module.exports = $997bb9b003907e53$var$parseJSON;

});



parcelRegister("2VOQS", function(module, exports) {


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("3kJd2")), (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var VOID = kotlin_kotlin.$_$.f;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var toString = kotlin_kotlin.$_$.ob;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var equals = kotlin_kotlin.$_$.ba;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
    var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
    var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var serializerOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r2;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
    var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
    var hashCode = kotlin_kotlin.$_$.ha;
    var joinToString = kotlin_kotlin.$_$.g7;
    var KtMap = kotlin_kotlin.$_$.r5;
    var KtList = kotlin_kotlin.$_$.p5;
    var numberRangeToNumber = kotlin_kotlin.$_$.gb;
    var ClosedRange = kotlin_kotlin.$_$.qb;
    var contains = kotlin_kotlin.$_$.vb;
    var toDoubleOrNull = kotlin_kotlin.$_$.md;
    var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.j;
    var lazy = kotlin_kotlin.$_$.pf;
    var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
    var getBooleanHashCode = kotlin_kotlin.$_$.ea;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var NumberFormatException_init_$Create$ = kotlin_kotlin.$_$.f2;
    var toDouble = kotlin_kotlin.$_$.nd;
    var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
    var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
    var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
    var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
    var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
    var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
    var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
    var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
    var toLongOrNull = kotlin_kotlin.$_$.qd;
    var toULongOrNull = kotlin_kotlin.$_$.vd;
    var ULong = kotlin_kotlin.$_$.bf;
    var Companion_getInstance = kotlin_kotlin.$_$.f5;
    var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
    var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.w3;
    var toBooleanStrictOrNull = kotlin_kotlin.$_$.ld;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var lazy_0 = kotlin_kotlin.$_$.qf;
    var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
    var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
    var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
    var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
    var toLong = kotlin_kotlin.$_$.mb;
    var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.m3;
    var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.o3;
    var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.v3;
    var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.x3;
    var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.d3;
    var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.f3;
    var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.e4;
    var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.g4;
    var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
    var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
    var charSequenceSubSequence = kotlin_kotlin.$_$.y9;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var coerceAtMost = kotlin_kotlin.$_$.tb;
    var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
    var singleOrNull = kotlin_kotlin.$_$.d8;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var getValue = kotlin_kotlin.$_$.b7;
    var fillArrayVal = kotlin_kotlin.$_$.da;
    var copyOf = kotlin_kotlin.$_$.m6;
    var copyOf_0 = kotlin_kotlin.$_$.n6;
    var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
    var DeepRecursiveFunction = kotlin_kotlin.$_$.ge;
    var invoke = kotlin_kotlin.$_$.lf;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var DeepRecursiveScope = kotlin_kotlin.$_$.he;
    var Unit = kotlin_kotlin.$_$.ef;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
    var getKClass = kotlin_kotlin.$_$.e;
    var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
    var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
    var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
    var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
    var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
    var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
    var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
    var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
    var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
    var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
    var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var contains_0 = kotlin_kotlin.$_$.jc;
    var plus = kotlin_kotlin.$_$.sf;
    var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var isFinite = kotlin_kotlin.$_$.nf;
    var isFinite_0 = kotlin_kotlin.$_$.mf;
    var toUInt = kotlin_kotlin.$_$.ud;
    var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.n3;
    var toULong = kotlin_kotlin.$_$.wd;
    var toUByte = kotlin_kotlin.$_$.td;
    var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.e3;
    var toUShort = kotlin_kotlin.$_$.xd;
    var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.f4;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
    var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
    var toString_1 = kotlin_kotlin.$_$.y2;
    var Companion_getInstance_0 = kotlin_kotlin.$_$.e5;
    var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
    var Companion_getInstance_1 = kotlin_kotlin.$_$.d5;
    var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
    var Companion_getInstance_2 = kotlin_kotlin.$_$.g5;
    var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
    var setOf = kotlin_kotlin.$_$.c8;
    var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x2;
    var numberToChar = kotlin_kotlin.$_$.hb;
    var equals_0 = kotlin_kotlin.$_$.pc;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
    var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.r1;
    var toByte = kotlin_kotlin.$_$.lb;
    var toShort = kotlin_kotlin.$_$.nb;
    var single = kotlin_kotlin.$_$.ed;
    var Char = kotlin_kotlin.$_$.ee;
    var emptySet = kotlin_kotlin.$_$.t6;
    var plus_0 = kotlin_kotlin.$_$.t7;
    var toInt = kotlin_kotlin.$_$.pd;
    var toList = kotlin_kotlin.$_$.k8;
    var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.uf;
    var NamedValueEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
    var Enum = kotlin_kotlin.$_$.ie;
    var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
    var last = kotlin_kotlin.$_$.m7;
    var removeLast = kotlin_kotlin.$_$.z7;
    var lastIndexOf = kotlin_kotlin.$_$.bd;
    var Long = kotlin_kotlin.$_$.ne;
    var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t2;
    var numberToLong = kotlin_kotlin.$_$.ib;
    var charArray = kotlin_kotlin.$_$.v9;
    var indexOf = kotlin_kotlin.$_$.tc;
    var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.g1;
    var HashMap_init_$Create$ = kotlin_kotlin.$_$.p;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(Json, "Json", VOID, VOID, [
        StringFormat
    ]);
    initMetadataForObject(Default, "Default", VOID, Json);
    initMetadataForClass(JsonBuilder, "JsonBuilder");
    initMetadataForClass(JsonImpl, "JsonImpl", VOID, Json);
    initMetadataForClass(JsonClassDiscriminator, "JsonClassDiscriminator");
    initMetadataForClass(JsonNames, "JsonNames");
    initMetadataForClass(JsonConfiguration, "JsonConfiguration");
    initMetadataForClass(JsonContentPolymorphicSerializer, "JsonContentPolymorphicSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForInterface(JsonDecoder, "JsonDecoder", VOID, VOID, [
        Decoder,
        CompositeDecoder
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForClass(JsonElement, "JsonElement", VOID, VOID, VOID, VOID, VOID, {
        0: JsonElementSerializer_getInstance
    });
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(JsonObject, "JsonObject", VOID, JsonElement, [
        JsonElement,
        KtMap
    ], VOID, VOID, {
        0: JsonObjectSerializer_getInstance
    });
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(JsonPrimitive, "JsonPrimitive", VOID, JsonElement, VOID, VOID, VOID, {
        0: JsonPrimitiveSerializer_getInstance
    });
    initMetadataForCompanion(Companion_2);
    initMetadataForClass(JsonArray, "JsonArray", VOID, JsonElement, [
        JsonElement,
        KtList
    ], VOID, VOID, {
        0: JsonArraySerializer_getInstance
    });
    initMetadataForObject(JsonNull, "JsonNull", VOID, JsonPrimitive, [
        JsonPrimitive,
        SerializerFactory
    ], VOID, VOID, {
        0: JsonNull_getInstance
    });
    initMetadataForClass(JsonLiteral, "JsonLiteral", VOID, JsonPrimitive);
    initMetadataForObject(JsonPrimitiveSerializer, "JsonPrimitiveSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonElementSerializer, "JsonElementSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonObjectDescriptor, "JsonObjectDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForObject(JsonObjectSerializer, "JsonObjectSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonArrayDescriptor, "JsonArrayDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForObject(JsonArraySerializer, "JsonArraySerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonNullSerializer, "JsonNullSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonLiteralSerializer, "JsonLiteralSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(defer$1, VOID, VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForInterface(JsonEncoder, "JsonEncoder", VOID, VOID, [
        Encoder,
        CompositeEncoder
    ]);
    initMetadataForClass(Composer, "Composer");
    initMetadataForClass(ComposerForUnsignedNumbers, "ComposerForUnsignedNumbers", VOID, Composer);
    initMetadataForClass(ComposerForUnquotedLiterals, "ComposerForUnquotedLiterals", VOID, Composer);
    initMetadataForClass(ComposerWithPrettyPrint, "ComposerWithPrettyPrint", VOID, Composer);
    initMetadataForClass(JsonElementMarker, "JsonElementMarker");
    initMetadataForClass(JsonException, "JsonException", VOID, SerializationException);
    initMetadataForClass(JsonDecodingException, "JsonDecodingException", VOID, JsonException);
    initMetadataForClass(JsonEncodingException, "JsonEncodingException", VOID, JsonException);
    initMetadataForObject(Tombstone, "Tombstone");
    initMetadataForClass(JsonPath, "JsonPath", JsonPath);
    initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForCoroutine($readObjectCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(JsonTreeReader, "JsonTreeReader", VOID, VOID, VOID, [
        0
    ]);
    initMetadataForClass(PolymorphismValidator, "PolymorphismValidator", VOID, VOID, [
        SerializersModuleCollector
    ]);
    initMetadataForClass(Key, "Key", Key);
    initMetadataForClass(DescriptorSchemaCache, "DescriptorSchemaCache", DescriptorSchemaCache);
    initMetadataForClass(DiscriminatorHolder, "DiscriminatorHolder");
    initMetadataForClass(StreamingJsonDecoder, "StreamingJsonDecoder", VOID, AbstractDecoder, [
        JsonDecoder,
        AbstractDecoder
    ]);
    initMetadataForClass(JsonDecoderForUnsignedTypes, "JsonDecoderForUnsignedTypes", VOID, AbstractDecoder);
    initMetadataForClass(StreamingJsonEncoder, "StreamingJsonEncoder", VOID, AbstractEncoder, [
        JsonEncoder,
        AbstractEncoder
    ]);
    initMetadataForClass(AbstractJsonTreeDecoder, "AbstractJsonTreeDecoder", VOID, NamedValueDecoder, [
        NamedValueDecoder,
        JsonDecoder
    ]);
    initMetadataForClass(JsonTreeDecoder, "JsonTreeDecoder", VOID, AbstractJsonTreeDecoder);
    initMetadataForClass(JsonTreeListDecoder, "JsonTreeListDecoder", VOID, AbstractJsonTreeDecoder);
    initMetadataForClass(JsonPrimitiveDecoder, "JsonPrimitiveDecoder", VOID, AbstractJsonTreeDecoder);
    initMetadataForClass(JsonTreeMapDecoder, "JsonTreeMapDecoder", VOID, JsonTreeDecoder);
    initMetadataForClass(AbstractJsonTreeEncoder, "AbstractJsonTreeEncoder", VOID, NamedValueEncoder, [
        NamedValueEncoder,
        JsonEncoder
    ]);
    initMetadataForClass(JsonTreeEncoder, "JsonTreeEncoder", VOID, AbstractJsonTreeEncoder);
    initMetadataForClass(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1, VOID, VOID, AbstractEncoder);
    initMetadataForClass(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1, VOID, VOID, AbstractEncoder);
    initMetadataForClass(JsonPrimitiveEncoder, "JsonPrimitiveEncoder", VOID, AbstractJsonTreeEncoder);
    initMetadataForClass(JsonTreeListEncoder, "JsonTreeListEncoder", VOID, AbstractJsonTreeEncoder);
    initMetadataForClass(JsonTreeMapEncoder, "JsonTreeMapEncoder", VOID, JsonTreeEncoder);
    initMetadataForClass(WriteMode, "WriteMode", VOID, Enum);
    initMetadataForClass(AbstractJsonLexer, "AbstractJsonLexer");
    initMetadataForObject(CharMappings, "CharMappings");
    initMetadataForClass(StringJsonLexer, "StringJsonLexer", VOID, AbstractJsonLexer);
    initMetadataForClass(JsonToStringWriter, "JsonToStringWriter", JsonToStringWriter);
    //endregion
    function Default() {
        Default_instance = this;
        Json.call(this, new JsonConfiguration(), EmptySerializersModule());
    }
    var Default_instance;
    function Default_getInstance() {
        if (Default_instance == null) new Default();
        return Default_instance;
    }
    function Json(configuration, serializersModule) {
        Default_getInstance();
        this.x18_1 = configuration;
        this.y18_1 = serializersModule;
        this.z18_1 = new DescriptorSchemaCache();
    }
    protoOf(Json).dp = function() {
        return this.y18_1;
    };
    protoOf(Json).bp = function(serializer, value) {
        var result = new JsonToStringWriter();
        try {
            encodeByWriter(this, result, serializer, value);
            return result.toString();
        } finally{
            result.e19();
        }
    };
    protoOf(Json).cp = function(deserializer, string) {
        var lexer = new StringJsonLexer(string);
        var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.yn(), null);
        var result = input.kr(deserializer);
        lexer.r19();
        return result;
    };
    protoOf(Json).a19 = function(serializer, value) {
        return writeJson(this, value, serializer);
    };
    protoOf(Json).b19 = function(deserializer, element) {
        return readJson(this, element, deserializer);
    };
    protoOf(Json).c19 = function(string) {
        return this.cp(JsonElementSerializer_getInstance(), string);
    };
    function Json_0(from, builderAction) {
        from = from === VOID ? Default_getInstance() : from;
        var builder = new JsonBuilder(from);
        builderAction(builder);
        var conf = builder.h1a();
        return new JsonImpl(conf, builder.g1a_1);
    }
    function JsonBuilder(json) {
        this.s19_1 = json.x18_1.i1a_1;
        this.t19_1 = json.x18_1.n1a_1;
        this.u19_1 = json.x18_1.j1a_1;
        this.v19_1 = json.x18_1.k1a_1;
        this.w19_1 = json.x18_1.l1a_1;
        this.x19_1 = json.x18_1.m1a_1;
        this.y19_1 = json.x18_1.o1a_1;
        this.z19_1 = json.x18_1.p1a_1;
        this.a1a_1 = json.x18_1.q1a_1;
        this.b1a_1 = json.x18_1.r1a_1;
        this.c1a_1 = json.x18_1.s1a_1;
        this.d1a_1 = json.x18_1.t1a_1;
        this.e1a_1 = json.x18_1.u1a_1;
        this.f1a_1 = json.x18_1.v1a_1;
        this.g1a_1 = json.dp();
    }
    protoOf(JsonBuilder).h1a = function() {
        if (this.a1a_1) // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        {
            if (!(this.b1a_1 === "type")) {
                // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
                var message = "Class discriminator should not be specified when array polymorphism is specified";
                throw IllegalArgumentException_init_$Create$(toString(message));
            }
        }
        if (!this.x19_1) // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        {
            if (!(this.y19_1 === "    ")) {
                // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
                var message_0 = "Indent should not be specified when default printing mode is used";
                throw IllegalArgumentException_init_$Create$(toString(message_0));
            }
        } else if (!(this.y19_1 === "    ")) {
            var tmp$ret$3;
            $l$block: {
                // Inline function 'kotlin.text.all' call
                var indexedObject = this.y19_1;
                var inductionVariable = 0;
                while(inductionVariable < charSequenceLength(indexedObject)){
                    var element = charSequenceGet(indexedObject, inductionVariable);
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
                    if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
                        tmp$ret$3 = false;
                        break $l$block;
                    }
                }
                tmp$ret$3 = true;
            }
            var allWhitespaces = tmp$ret$3;
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!allWhitespaces) {
                // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
                var message_1 = "Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had " + this.y19_1;
                throw IllegalArgumentException_init_$Create$(toString(message_1));
            }
        }
        return new JsonConfiguration(this.s19_1, this.u19_1, this.v19_1, this.w19_1, this.x19_1, this.t19_1, this.y19_1, this.z19_1, this.a1a_1, this.b1a_1, this.c1a_1, this.d1a_1, this.e1a_1, this.f1a_1);
    };
    function validateConfiguration($this) {
        if (equals($this.dp(), EmptySerializersModule())) return Unit_instance;
        var collector = new PolymorphismValidator($this.x18_1.q1a_1, $this.x18_1.r1a_1);
        $this.dp().g18(collector);
    }
    function JsonImpl(configuration, module_0) {
        Json.call(this, configuration, module_0);
        validateConfiguration(this);
    }
    function JsonClassDiscriminator() {}
    function JsonNames() {}
    function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive) {
        encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
        ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
        isLenient = isLenient === VOID ? false : isLenient;
        allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
        prettyPrint = prettyPrint === VOID ? false : prettyPrint;
        explicitNulls = explicitNulls === VOID ? true : explicitNulls;
        prettyPrintIndent = prettyPrintIndent === VOID ? "    " : prettyPrintIndent;
        coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
        useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
        classDiscriminator = classDiscriminator === VOID ? "type" : classDiscriminator;
        allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
        useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
        namingStrategy = namingStrategy === VOID ? null : namingStrategy;
        decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
        this.i1a_1 = encodeDefaults;
        this.j1a_1 = ignoreUnknownKeys;
        this.k1a_1 = isLenient;
        this.l1a_1 = allowStructuredMapKeys;
        this.m1a_1 = prettyPrint;
        this.n1a_1 = explicitNulls;
        this.o1a_1 = prettyPrintIndent;
        this.p1a_1 = coerceInputValues;
        this.q1a_1 = useArrayPolymorphism;
        this.r1a_1 = classDiscriminator;
        this.s1a_1 = allowSpecialFloatingPointValues;
        this.t1a_1 = useAlternativeNames;
        this.u1a_1 = namingStrategy;
        this.v1a_1 = decodeEnumsCaseInsensitive;
    }
    protoOf(JsonConfiguration).toString = function() {
        return "JsonConfiguration(encodeDefaults=" + this.i1a_1 + ", ignoreUnknownKeys=" + this.j1a_1 + ", isLenient=" + this.k1a_1 + ", " + ("allowStructuredMapKeys=" + this.l1a_1 + ", prettyPrint=" + this.m1a_1 + ", explicitNulls=" + this.n1a_1 + ", ") + ("prettyPrintIndent='" + this.o1a_1 + "', coerceInputValues=" + this.p1a_1 + ", useArrayPolymorphism=" + this.q1a_1 + ", ") + ("classDiscriminator='" + this.r1a_1 + "', allowSpecialFloatingPointValues=" + this.s1a_1 + ", useAlternativeNames=" + this.t1a_1 + ", ") + ("namingStrategy=" + toString_0(this.u1a_1) + ", decodeEnumsCaseInsensitive=" + this.v1a_1 + ")");
    };
    function throwSubtypeNotRegistered($this, subClass, baseClass) {
        var tmp0_elvis_lhs = subClass.fa();
        var subClassName = tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs;
        var scope = "in the scope of '" + baseClass.fa() + "'";
        throw SerializationException_init_$Create$("Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + ".\n" + "Mark the base class as 'sealed' or register the serializer explicitly.");
    }
    function JsonContentPolymorphicSerializer(baseClass) {
        this.w1a_1 = baseClass;
        this.x1a_1 = buildSerialDescriptor("JsonContentPolymorphicSerializer<" + this.w1a_1.fa() + ">", SEALED_getInstance(), []);
    }
    protoOf(JsonContentPolymorphicSerializer).yn = function() {
        return this.x1a_1;
    };
    protoOf(JsonContentPolymorphicSerializer).oo = function(encoder, value) {
        var tmp0_elvis_lhs = encoder.dp().jt(this.w1a_1, value);
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? serializerOrNull(getKClassFromExpression(value)) : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_elvis_lhs == null) throwSubtypeNotRegistered(this, getKClassFromExpression(value), this.w1a_1);
        else tmp = tmp1_elvis_lhs;
        var actualSerializer = tmp;
        (isInterface(actualSerializer, KSerializer) ? actualSerializer : THROW_CCE()).zn(encoder, value);
    };
    protoOf(JsonContentPolymorphicSerializer).zn = function(encoder, value) {
        return this.oo(encoder, !(value == null) ? value : THROW_CCE());
    };
    protoOf(JsonContentPolymorphicSerializer).ao = function(decoder) {
        var input = asJsonDecoder(decoder);
        var tree = input.y1a();
        var tmp = this.z1a(tree);
        var actualSerializer = isInterface(tmp, KSerializer) ? tmp : THROW_CCE();
        return input.a1b().b19(actualSerializer, tree);
    };
    function JsonDecoder() {}
    function get_jsonUnquotedLiteralDescriptor() {
        _init_properties_JsonElement_kt__7cbdc2();
        return jsonUnquotedLiteralDescriptor;
    }
    var jsonUnquotedLiteralDescriptor;
    function Companion() {}
    protoOf(Companion).b1b = function() {
        return JsonElementSerializer_getInstance();
    };
    var Companion_instance;
    function Companion_getInstance_3() {
        return Companion_instance;
    }
    function JsonElement() {}
    function Companion_0() {}
    var Companion_instance_0;
    function Companion_getInstance_4() {
        return Companion_instance_0;
    }
    function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
        // Inline function 'kotlin.collections.component1' call
        var k = _name_for_destructuring_parameter_0__wldtmu.a1();
        // Inline function 'kotlin.collections.component2' call
        var v = _name_for_destructuring_parameter_0__wldtmu.b1();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
        printQuoted(this_0, k);
        this_0.f8(_Char___init__impl__6a9atx(58));
        this_0.d8(v);
        return this_0.toString();
    }
    function JsonObject(content) {
        JsonElement.call(this);
        this.c1b_1 = content;
    }
    protoOf(JsonObject).z = function() {
        return this.c1b_1.z();
    };
    protoOf(JsonObject).f2 = function() {
        return this.c1b_1.f2();
    };
    protoOf(JsonObject).m = function() {
        return this.c1b_1.m();
    };
    protoOf(JsonObject).g2 = function() {
        return this.c1b_1.g2();
    };
    protoOf(JsonObject).wl = function(key) {
        return this.c1b_1.c2(key);
    };
    protoOf(JsonObject).c2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return false;
        return this.wl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(JsonObject).vl = function(key) {
        return this.c1b_1.e2(key);
    };
    protoOf(JsonObject).e2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return null;
        return this.vl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(JsonObject).s = function() {
        return this.c1b_1.s();
    };
    protoOf(JsonObject).equals = function(other) {
        return equals(this.c1b_1, other);
    };
    protoOf(JsonObject).hashCode = function() {
        return hashCode(this.c1b_1);
    };
    protoOf(JsonObject).toString = function() {
        var tmp = this.c1b_1.z();
        return joinToString(tmp, ",", "{", "}", VOID, VOID, JsonObject$toString$lambda);
    };
    function Companion_1() {}
    var Companion_instance_1;
    function Companion_getInstance_5() {
        return Companion_instance_1;
    }
    function JsonPrimitive() {
        JsonElement.call(this);
    }
    protoOf(JsonPrimitive).toString = function() {
        return this.e1b();
    };
    function Companion_2() {}
    var Companion_instance_2;
    function Companion_getInstance_6() {
        return Companion_instance_2;
    }
    function JsonArray(content) {
        JsonElement.call(this);
        this.f1b_1 = content;
    }
    protoOf(JsonArray).m = function() {
        return this.f1b_1.m();
    };
    protoOf(JsonArray).g1b = function(element) {
        return this.f1b_1.a2(element);
    };
    protoOf(JsonArray).a2 = function(element) {
        if (!(element instanceof JsonElement)) return false;
        return this.g1b(element instanceof JsonElement ? element : THROW_CCE());
    };
    protoOf(JsonArray).h1b = function(elements) {
        return this.f1b_1.b2(elements);
    };
    protoOf(JsonArray).b2 = function(elements) {
        return this.h1b(elements);
    };
    protoOf(JsonArray).o = function(index) {
        return this.f1b_1.o(index);
    };
    protoOf(JsonArray).s = function() {
        return this.f1b_1.s();
    };
    protoOf(JsonArray).j = function() {
        return this.f1b_1.j();
    };
    protoOf(JsonArray).w = function(index) {
        return this.f1b_1.w(index);
    };
    protoOf(JsonArray).v = function(fromIndex, toIndex) {
        return this.f1b_1.v(fromIndex, toIndex);
    };
    protoOf(JsonArray).equals = function(other) {
        return equals(this.f1b_1, other);
    };
    protoOf(JsonArray).hashCode = function() {
        return hashCode(this.f1b_1);
    };
    protoOf(JsonArray).toString = function() {
        return joinToString(this.f1b_1, ",", "[", "]");
    };
    function get_intOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlinx.serialization.json.mapExceptionsToNull' call
        var tmp;
        try {
            // Inline function 'kotlinx.serialization.json.<get-intOrNull>.<anonymous>' call
            tmp = new StringJsonLexer(_this__u8e3s4.e1b()).i1b();
        } catch ($p) {
            var tmp_0;
            if ($p instanceof JsonDecodingException) {
                var e = $p;
                tmp_0 = null;
            } else throw $p;
            tmp = tmp_0;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_1;
        if (tmp0_elvis_lhs == null) return null;
        else tmp_1 = tmp0_elvis_lhs;
        var result = tmp_1;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-2147483648, 2147483647);
        if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) return null;
        return result.l1();
    }
    function get_booleanOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        return toBooleanStrictOrNull_0(_this__u8e3s4.e1b());
    }
    function get_doubleOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        return toDoubleOrNull(_this__u8e3s4.e1b());
    }
    function _get_$cachedSerializer__te6jhj($this) {
        return $this.k1b_1.b1();
    }
    function JsonNull$_anonymous__enib48() {
        return JsonNullSerializer_getInstance();
    }
    function JsonNull() {
        JsonNull_instance = this;
        JsonPrimitive.call(this);
        this.j1b_1 = "null";
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.k1b_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
    }
    protoOf(JsonNull).d1b = function() {
        return false;
    };
    protoOf(JsonNull).e1b = function() {
        return this.j1b_1;
    };
    protoOf(JsonNull).b1b = function() {
        return _get_$cachedSerializer__te6jhj(this);
    };
    protoOf(JsonNull).wz = function(typeParamsSerializers) {
        return this.b1b();
    };
    var JsonNull_instance;
    function JsonNull_getInstance() {
        if (JsonNull_instance == null) new JsonNull();
        return JsonNull_instance;
    }
    function get_floatOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlin.text.toFloatOrNull' call
        var this_0 = _this__u8e3s4.e1b();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDoubleOrNull(this_0);
    }
    function get_longOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlinx.serialization.json.mapExceptionsToNull' call
        var tmp;
        try {
            // Inline function 'kotlinx.serialization.json.<get-longOrNull>.<anonymous>' call
            tmp = new StringJsonLexer(_this__u8e3s4.e1b()).i1b();
        } catch ($p) {
            var tmp_0;
            if ($p instanceof JsonDecodingException) {
                var e = $p;
                tmp_0 = null;
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    }
    function JsonPrimitive_0(value) {
        _init_properties_JsonElement_kt__7cbdc2();
        if (value == null) return JsonNull_getInstance();
        return new JsonLiteral(value, true);
    }
    function get_jsonPrimitive(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) error(_this__u8e3s4, "JsonPrimitive");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function get_jsonObject(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) error(_this__u8e3s4, "JsonObject");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function JsonLiteral(body, isString, coerceToInlineType) {
        coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
        JsonPrimitive.call(this);
        this.l1b_1 = isString;
        this.m1b_1 = coerceToInlineType;
        this.n1b_1 = toString(body);
        if (!(this.m1b_1 == null)) // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        {
            if (!this.m1b_1.rp()) {
                // Inline function 'kotlin.require.<anonymous>' call
                var message = "Failed requirement.";
                throw IllegalArgumentException_init_$Create$(toString(message));
            }
        }
    }
    protoOf(JsonLiteral).d1b = function() {
        return this.l1b_1;
    };
    protoOf(JsonLiteral).e1b = function() {
        return this.n1b_1;
    };
    protoOf(JsonLiteral).toString = function() {
        var tmp;
        if (this.l1b_1) {
            // Inline function 'kotlin.text.buildString' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.apply' call
            var this_0 = StringBuilder_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
            printQuoted(this_0, this.n1b_1);
            tmp = this_0.toString();
        } else tmp = this.n1b_1;
        return tmp;
    };
    protoOf(JsonLiteral).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof JsonLiteral)) THROW_CCE();
        if (!(this.l1b_1 === other.l1b_1)) return false;
        if (!(this.n1b_1 === other.n1b_1)) return false;
        return true;
    };
    protoOf(JsonLiteral).hashCode = function() {
        var result = getBooleanHashCode(this.l1b_1);
        result = imul(31, result) + getStringHashCode(this.n1b_1) | 0;
        return result;
    };
    function error(_this__u8e3s4, element) {
        _init_properties_JsonElement_kt__7cbdc2();
        throw IllegalArgumentException_init_$Create$("Element " + toString(getKClassFromExpression(_this__u8e3s4)) + " is not a " + element);
    }
    function JsonPrimitive_1(value) {
        _init_properties_JsonElement_kt__7cbdc2();
        if (value == null) return JsonNull_getInstance();
        return new JsonLiteral(value, false);
    }
    function JsonPrimitive_2(value) {
        _init_properties_JsonElement_kt__7cbdc2();
        if (value == null) return JsonNull_getInstance();
        return new JsonLiteral(value, false);
    }
    function get_int(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlinx.serialization.json.mapExceptions' call
        var tmp;
        try {
            // Inline function 'kotlinx.serialization.json.<get-int>.<anonymous>' call
            tmp = new StringJsonLexer(_this__u8e3s4.e1b()).i1b();
        } catch ($p) {
            var tmp_0;
            if ($p instanceof JsonDecodingException) {
                var e = $p;
                throw NumberFormatException_init_$Create$(e.message);
            } else throw $p;
        }
        var result = tmp;
        // Inline function 'kotlin.ranges.contains' call
        var this_0 = numberRangeToNumber(-2147483648, 2147483647);
        if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) throw NumberFormatException_init_$Create$(_this__u8e3s4.e1b() + " is not an Int");
        return result.l1();
    }
    function get_long(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlinx.serialization.json.mapExceptions' call
        var tmp;
        try {
            // Inline function 'kotlinx.serialization.json.<get-long>.<anonymous>' call
            tmp = new StringJsonLexer(_this__u8e3s4.e1b()).i1b();
        } catch ($p) {
            var tmp_0;
            if ($p instanceof JsonDecodingException) {
                var e = $p;
                throw NumberFormatException_init_$Create$(e.message);
            } else throw $p;
        }
        return tmp;
    }
    function get_float(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        // Inline function 'kotlin.text.toFloat' call
        var this_0 = _this__u8e3s4.e1b();
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return toDouble(this_0);
    }
    function get_double(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        return toDouble(_this__u8e3s4.e1b());
    }
    function get_contentOrNull(_this__u8e3s4) {
        _init_properties_JsonElement_kt__7cbdc2();
        var tmp;
        if (_this__u8e3s4 instanceof JsonNull) tmp = null;
        else tmp = _this__u8e3s4.e1b();
        return tmp;
    }
    var properties_initialized_JsonElement_kt_abxy8s;
    function _init_properties_JsonElement_kt__7cbdc2() {
        if (!properties_initialized_JsonElement_kt_abxy8s) {
            properties_initialized_JsonElement_kt_abxy8s = true;
            jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor("kotlinx.serialization.json.JsonUnquotedLiteral", serializer(StringCompanionObject_instance));
        }
    }
    function JsonPrimitiveSerializer() {
        JsonPrimitiveSerializer_instance = this;
        this.o1b_1 = buildSerialDescriptor("kotlinx.serialization.json.JsonPrimitive", STRING_getInstance(), []);
    }
    protoOf(JsonPrimitiveSerializer).yn = function() {
        return this.o1b_1;
    };
    protoOf(JsonPrimitiveSerializer).p1b = function(encoder, value) {
        verify(encoder);
        var tmp;
        if (value instanceof JsonNull) {
            encoder.ct(JsonNullSerializer_getInstance(), JsonNull_getInstance());
            tmp = Unit_instance;
        } else {
            var tmp_0 = JsonLiteralSerializer_getInstance();
            encoder.ct(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
            tmp = Unit_instance;
        }
        return tmp;
    };
    protoOf(JsonPrimitiveSerializer).zn = function(encoder, value) {
        return this.p1b(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
    };
    protoOf(JsonPrimitiveSerializer).ao = function(decoder) {
        var result = asJsonDecoder(decoder).y1a();
        if (!(result instanceof JsonPrimitive)) throw JsonDecodingException_0(-1, "Unexpected JSON element, expected JsonPrimitive, had " + toString(getKClassFromExpression(result)), toString(result));
        return result;
    };
    var JsonPrimitiveSerializer_instance;
    function JsonPrimitiveSerializer_getInstance() {
        if (JsonPrimitiveSerializer_instance == null) new JsonPrimitiveSerializer();
        return JsonPrimitiveSerializer_instance;
    }
    function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
        $this$buildSerialDescriptor.mo("JsonPrimitive", defer(JsonElementSerializer$descriptor$lambda$lambda));
        $this$buildSerialDescriptor.mo("JsonNull", defer(JsonElementSerializer$descriptor$lambda$lambda_0));
        $this$buildSerialDescriptor.mo("JsonLiteral", defer(JsonElementSerializer$descriptor$lambda$lambda_1));
        $this$buildSerialDescriptor.mo("JsonObject", defer(JsonElementSerializer$descriptor$lambda$lambda_2));
        $this$buildSerialDescriptor.mo("JsonArray", defer(JsonElementSerializer$descriptor$lambda$lambda_3));
        return Unit_instance;
    }
    function JsonElementSerializer$descriptor$lambda$lambda() {
        return JsonPrimitiveSerializer_getInstance().o1b_1;
    }
    function JsonElementSerializer$descriptor$lambda$lambda_0() {
        return JsonNullSerializer_getInstance().q1b_1;
    }
    function JsonElementSerializer$descriptor$lambda$lambda_1() {
        return JsonLiteralSerializer_getInstance().r1b_1;
    }
    function JsonElementSerializer$descriptor$lambda$lambda_2() {
        return JsonObjectSerializer_getInstance().s1b_1;
    }
    function JsonElementSerializer$descriptor$lambda$lambda_3() {
        return JsonArraySerializer_getInstance().t1b_1;
    }
    function JsonElementSerializer() {
        JsonElementSerializer_instance = this;
        var tmp = this;
        var tmp_0 = SEALED_getInstance();
        tmp.u1b_1 = buildSerialDescriptor("kotlinx.serialization.json.JsonElement", tmp_0, [], JsonElementSerializer$descriptor$lambda);
    }
    protoOf(JsonElementSerializer).yn = function() {
        return this.u1b_1;
    };
    protoOf(JsonElementSerializer).v1b = function(encoder, value) {
        verify(encoder);
        if (value instanceof JsonPrimitive) encoder.ct(JsonPrimitiveSerializer_getInstance(), value);
        else {
            if (value instanceof JsonObject) encoder.ct(JsonObjectSerializer_getInstance(), value);
            else if (value instanceof JsonArray) encoder.ct(JsonArraySerializer_getInstance(), value);
        }
    };
    protoOf(JsonElementSerializer).zn = function(encoder, value) {
        return this.v1b(encoder, value instanceof JsonElement ? value : THROW_CCE());
    };
    protoOf(JsonElementSerializer).ao = function(decoder) {
        var input = asJsonDecoder(decoder);
        return input.y1a();
    };
    var JsonElementSerializer_instance;
    function JsonElementSerializer_getInstance() {
        if (JsonElementSerializer_instance == null) new JsonElementSerializer();
        return JsonElementSerializer_instance;
    }
    function JsonObjectDescriptor() {
        JsonObjectDescriptor_instance = this;
        this.w1b_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).yn();
        this.x1b_1 = "kotlinx.serialization.json.JsonObject";
    }
    protoOf(JsonObjectDescriptor).pp = function() {
        return this.w1b_1.pp();
    };
    protoOf(JsonObjectDescriptor).qp = function() {
        return this.w1b_1.qp();
    };
    protoOf(JsonObjectDescriptor).rp = function() {
        return this.w1b_1.rp();
    };
    protoOf(JsonObjectDescriptor).lp = function() {
        return this.w1b_1.lp();
    };
    protoOf(JsonObjectDescriptor).sp = function() {
        return this.w1b_1.sp();
    };
    protoOf(JsonObjectDescriptor).tp = function(index) {
        return this.w1b_1.tp(index);
    };
    protoOf(JsonObjectDescriptor).up = function(index) {
        return this.w1b_1.up(index);
    };
    protoOf(JsonObjectDescriptor).vp = function(name) {
        return this.w1b_1.vp(name);
    };
    protoOf(JsonObjectDescriptor).wp = function(index) {
        return this.w1b_1.wp(index);
    };
    protoOf(JsonObjectDescriptor).xp = function(index) {
        return this.w1b_1.xp(index);
    };
    protoOf(JsonObjectDescriptor).zo = function() {
        return this.x1b_1;
    };
    var JsonObjectDescriptor_instance;
    function JsonObjectDescriptor_getInstance() {
        if (JsonObjectDescriptor_instance == null) new JsonObjectDescriptor();
        return JsonObjectDescriptor_instance;
    }
    function JsonObjectSerializer() {
        JsonObjectSerializer_instance = this;
        this.s1b_1 = JsonObjectDescriptor_getInstance();
    }
    protoOf(JsonObjectSerializer).yn = function() {
        return this.s1b_1;
    };
    protoOf(JsonObjectSerializer).y1b = function(encoder, value) {
        verify(encoder);
        MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).zn(encoder, value);
    };
    protoOf(JsonObjectSerializer).zn = function(encoder, value) {
        return this.y1b(encoder, value instanceof JsonObject ? value : THROW_CCE());
    };
    protoOf(JsonObjectSerializer).ao = function(decoder) {
        verify_0(decoder);
        return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).ao(decoder));
    };
    var JsonObjectSerializer_instance;
    function JsonObjectSerializer_getInstance() {
        if (JsonObjectSerializer_instance == null) new JsonObjectSerializer();
        return JsonObjectSerializer_instance;
    }
    function JsonArrayDescriptor() {
        JsonArrayDescriptor_instance = this;
        this.z1b_1 = ListSerializer(JsonElementSerializer_getInstance()).yn();
        this.a1c_1 = "kotlinx.serialization.json.JsonArray";
    }
    protoOf(JsonArrayDescriptor).pp = function() {
        return this.z1b_1.pp();
    };
    protoOf(JsonArrayDescriptor).qp = function() {
        return this.z1b_1.qp();
    };
    protoOf(JsonArrayDescriptor).rp = function() {
        return this.z1b_1.rp();
    };
    protoOf(JsonArrayDescriptor).lp = function() {
        return this.z1b_1.lp();
    };
    protoOf(JsonArrayDescriptor).sp = function() {
        return this.z1b_1.sp();
    };
    protoOf(JsonArrayDescriptor).tp = function(index) {
        return this.z1b_1.tp(index);
    };
    protoOf(JsonArrayDescriptor).up = function(index) {
        return this.z1b_1.up(index);
    };
    protoOf(JsonArrayDescriptor).vp = function(name) {
        return this.z1b_1.vp(name);
    };
    protoOf(JsonArrayDescriptor).wp = function(index) {
        return this.z1b_1.wp(index);
    };
    protoOf(JsonArrayDescriptor).xp = function(index) {
        return this.z1b_1.xp(index);
    };
    protoOf(JsonArrayDescriptor).zo = function() {
        return this.a1c_1;
    };
    var JsonArrayDescriptor_instance;
    function JsonArrayDescriptor_getInstance() {
        if (JsonArrayDescriptor_instance == null) new JsonArrayDescriptor();
        return JsonArrayDescriptor_instance;
    }
    function JsonArraySerializer() {
        JsonArraySerializer_instance = this;
        this.t1b_1 = JsonArrayDescriptor_getInstance();
    }
    protoOf(JsonArraySerializer).yn = function() {
        return this.t1b_1;
    };
    protoOf(JsonArraySerializer).b1c = function(encoder, value) {
        verify(encoder);
        ListSerializer(JsonElementSerializer_getInstance()).zn(encoder, value);
    };
    protoOf(JsonArraySerializer).zn = function(encoder, value) {
        return this.b1c(encoder, value instanceof JsonArray ? value : THROW_CCE());
    };
    protoOf(JsonArraySerializer).ao = function(decoder) {
        verify_0(decoder);
        return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).ao(decoder));
    };
    var JsonArraySerializer_instance;
    function JsonArraySerializer_getInstance() {
        if (JsonArraySerializer_instance == null) new JsonArraySerializer();
        return JsonArraySerializer_instance;
    }
    function JsonNullSerializer() {
        JsonNullSerializer_instance = this;
        this.q1b_1 = buildSerialDescriptor("kotlinx.serialization.json.JsonNull", ENUM_getInstance(), []);
    }
    protoOf(JsonNullSerializer).yn = function() {
        return this.q1b_1;
    };
    protoOf(JsonNullSerializer).c1c = function(encoder, value) {
        verify(encoder);
        encoder.fs();
    };
    protoOf(JsonNullSerializer).zn = function(encoder, value) {
        return this.c1c(encoder, value instanceof JsonNull ? value : THROW_CCE());
    };
    protoOf(JsonNullSerializer).ao = function(decoder) {
        verify_0(decoder);
        if (decoder.wq()) throw new JsonDecodingException("Expected 'null' literal");
        decoder.xq();
        return JsonNull_getInstance();
    };
    var JsonNullSerializer_instance;
    function JsonNullSerializer_getInstance() {
        if (JsonNullSerializer_instance == null) new JsonNullSerializer();
        return JsonNullSerializer_instance;
    }
    function verify(encoder) {
        asJsonEncoder(encoder);
    }
    function JsonLiteralSerializer() {
        JsonLiteralSerializer_instance = this;
        this.r1b_1 = PrimitiveSerialDescriptor("kotlinx.serialization.json.JsonLiteral", STRING_getInstance());
    }
    protoOf(JsonLiteralSerializer).yn = function() {
        return this.r1b_1;
    };
    protoOf(JsonLiteralSerializer).d1c = function(encoder, value) {
        verify(encoder);
        if (value.l1b_1) return encoder.os(value.n1b_1);
        if (!(value.m1b_1 == null)) return encoder.qs(value.m1b_1).os(value.n1b_1);
        var tmp0_safe_receiver = toLongOrNull(value.n1b_1);
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return encoder.ks(tmp0_safe_receiver);
        var tmp1_safe_receiver = toULongOrNull(value.n1b_1);
        var tmp = tmp1_safe_receiver;
        if ((tmp == null ? null : new ULong(tmp)) == null) ;
        else {
            // Inline function 'kotlin.let' call
            var tmp_0 = tmp1_safe_receiver;
            // Inline function 'kotlin.contracts.contract' call
            var it = (tmp_0 == null ? null : new ULong(tmp_0)).tk_1;
            var tmp_1 = encoder.qs(serializer_0(Companion_getInstance()).yn());
            // Inline function 'kotlin.ULong.toLong' call
            var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
            tmp_1.ks(tmp$ret$1);
            return Unit_instance;
        }
        var tmp2_safe_receiver = toDoubleOrNull(value.n1b_1);
        if (tmp2_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return encoder.ms(tmp2_safe_receiver);
        var tmp3_safe_receiver = toBooleanStrictOrNull(value.n1b_1);
        if (tmp3_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return encoder.gs(tmp3_safe_receiver);
        encoder.os(value.n1b_1);
    };
    protoOf(JsonLiteralSerializer).zn = function(encoder, value) {
        return this.d1c(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
    };
    protoOf(JsonLiteralSerializer).ao = function(decoder) {
        var result = asJsonDecoder(decoder).y1a();
        if (!(result instanceof JsonLiteral)) throw JsonDecodingException_0(-1, "Unexpected JSON element, expected JsonLiteral, had " + toString(getKClassFromExpression(result)), toString(result));
        return result;
    };
    var JsonLiteralSerializer_instance;
    function JsonLiteralSerializer_getInstance() {
        if (JsonLiteralSerializer_instance == null) new JsonLiteralSerializer();
        return JsonLiteralSerializer_instance;
    }
    function asJsonDecoder(_this__u8e3s4) {
        var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalStateException_init_$Create$("This serializer can be used only with Json format." + ("Expected Decoder to be JsonDecoder, got " + toString(getKClassFromExpression(_this__u8e3s4))));
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function defer(deferred) {
        return new defer$1(deferred);
    }
    function verify_0(decoder) {
        asJsonDecoder(decoder);
    }
    function asJsonEncoder(_this__u8e3s4) {
        var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalStateException_init_$Create$("This serializer can be used only with Json format." + ("Expected Encoder to be JsonEncoder, got " + toString(getKClassFromExpression(_this__u8e3s4))));
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function _get_original__l7ku1m($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.e1c_1;
        original$factory();
        return this_0.b1();
    }
    function defer$1($deferred) {
        this.e1c_1 = lazy_0($deferred);
    }
    protoOf(defer$1).zo = function() {
        return _get_original__l7ku1m(this).zo();
    };
    protoOf(defer$1).sp = function() {
        return _get_original__l7ku1m(this).sp();
    };
    protoOf(defer$1).qp = function() {
        return _get_original__l7ku1m(this).qp();
    };
    protoOf(defer$1).wp = function(index) {
        return _get_original__l7ku1m(this).wp(index);
    };
    protoOf(defer$1).vp = function(name) {
        return _get_original__l7ku1m(this).vp(name);
    };
    protoOf(defer$1).tp = function(index) {
        return _get_original__l7ku1m(this).tp(index);
    };
    protoOf(defer$1).up = function(index) {
        return _get_original__l7ku1m(this).up(index);
    };
    protoOf(defer$1).xp = function(index) {
        return _get_original__l7ku1m(this).xp(index);
    };
    function original$factory() {
        return getPropertyCallableRef("original", 1, KProperty1, function(receiver) {
            return _get_original__l7ku1m(receiver);
        }, null);
    }
    function JsonEncoder() {}
    function Composer(writer) {
        this.f1c_1 = writer;
        this.g1c_1 = true;
    }
    protoOf(Composer).h1c = function() {
        this.g1c_1 = true;
    };
    protoOf(Composer).i1c = function() {
        return Unit_instance;
    };
    protoOf(Composer).j1c = function() {
        this.g1c_1 = false;
    };
    protoOf(Composer).k1c = function() {
        return Unit_instance;
    };
    protoOf(Composer).l1c = function(v) {
        return this.f1c_1.m1c(v);
    };
    protoOf(Composer).n1c = function(v) {
        return this.f1c_1.o1c(v);
    };
    protoOf(Composer).p1c = function(v) {
        return this.f1c_1.o1c(v.toString());
    };
    protoOf(Composer).q1c = function(v) {
        return this.f1c_1.o1c(v.toString());
    };
    protoOf(Composer).r1c = function(v) {
        return this.f1c_1.s1c(toLong(v));
    };
    protoOf(Composer).t1c = function(v) {
        return this.f1c_1.s1c(toLong(v));
    };
    protoOf(Composer).u1c = function(v) {
        return this.f1c_1.s1c(toLong(v));
    };
    protoOf(Composer).v1c = function(v) {
        return this.f1c_1.s1c(v);
    };
    protoOf(Composer).w1c = function(v) {
        return this.f1c_1.o1c(v.toString());
    };
    protoOf(Composer).x1c = function(value) {
        return this.f1c_1.y1c(value);
    };
    function Composer_0(sb, json) {
        return json.x18_1.m1a_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
    }
    function ComposerForUnsignedNumbers(writer, forceQuoting) {
        Composer.call(this, writer);
        this.b1d_1 = forceQuoting;
    }
    protoOf(ComposerForUnsignedNumbers).u1c = function(v) {
        if (this.b1d_1) {
            // Inline function 'kotlin.toUInt' call
            var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
            this.x1c(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
            // Inline function 'kotlin.toUInt' call
            var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
            this.n1c(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
    };
    protoOf(ComposerForUnsignedNumbers).v1c = function(v) {
        if (this.b1d_1) {
            // Inline function 'kotlin.toULong' call
            var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
            this.x1c(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
            // Inline function 'kotlin.toULong' call
            var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
            this.n1c(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
    };
    protoOf(ComposerForUnsignedNumbers).r1c = function(v) {
        if (this.b1d_1) {
            // Inline function 'kotlin.toUByte' call
            var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
            this.x1c(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
            // Inline function 'kotlin.toUByte' call
            var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
            this.n1c(UByte__toString_impl_v72jg(tmp$ret$1));
        }
    };
    protoOf(ComposerForUnsignedNumbers).t1c = function(v) {
        if (this.b1d_1) {
            // Inline function 'kotlin.toUShort' call
            var tmp$ret$0 = _UShort___init__impl__jigrne(v);
            this.x1c(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
            // Inline function 'kotlin.toUShort' call
            var tmp$ret$1 = _UShort___init__impl__jigrne(v);
            this.n1c(UShort__toString_impl_edaoee(tmp$ret$1));
        }
    };
    function ComposerForUnquotedLiterals(writer, forceQuoting) {
        Composer.call(this, writer);
        this.e1d_1 = forceQuoting;
    }
    protoOf(ComposerForUnquotedLiterals).x1c = function(value) {
        if (this.e1d_1) protoOf(Composer).x1c.call(this, value);
        else protoOf(Composer).n1c.call(this, value);
    };
    function ComposerWithPrettyPrint(writer, json) {
        Composer.call(this, writer);
        this.h1d_1 = json;
        this.i1d_1 = 0;
    }
    protoOf(ComposerWithPrettyPrint).h1c = function() {
        this.g1c_1 = true;
        this.i1d_1 = this.i1d_1 + 1 | 0;
    };
    protoOf(ComposerWithPrettyPrint).i1c = function() {
        this.i1d_1 = this.i1d_1 - 1 | 0;
    };
    protoOf(ComposerWithPrettyPrint).j1c = function() {
        this.g1c_1 = false;
        this.n1c("\n");
        // Inline function 'kotlin.repeat' call
        var times = this.i1d_1;
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < times) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
            this.n1c(this.h1d_1.x18_1.o1a_1);
        }while (inductionVariable < times);
    };
    protoOf(ComposerWithPrettyPrint).k1c = function() {
        this.l1c(_Char___init__impl__6a9atx(32));
    };
    function readIfAbsent($this, descriptor, index) {
        $this.k1d_1 = !descriptor.xp(index) && descriptor.up(index).lp();
        return $this.k1d_1;
    }
    function JsonElementMarker$readIfAbsent$ref($boundThis) {
        var l = function(p0, p1) {
            return readIfAbsent($boundThis, p0, p1);
        };
        l.callableName = "readIfAbsent";
        return l;
    }
    function JsonElementMarker(descriptor) {
        var tmp = this;
        tmp.j1d_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
        this.k1d_1 = false;
    }
    protoOf(JsonElementMarker).l1d = function(index) {
        this.j1d_1.ox(index);
    };
    protoOf(JsonElementMarker).m1d = function() {
        return this.j1d_1.px();
    };
    function JsonDecodingException(message) {
        JsonException.call(this, message);
        captureStack(this, JsonDecodingException);
    }
    function JsonDecodingException_0(offset, message, input) {
        return JsonDecodingException_1(offset, message + "\nJSON input: " + toString(minify(input, offset)));
    }
    function JsonException(message) {
        SerializationException_init_$Init$(message, this);
        captureStack(this, JsonException);
    }
    function JsonDecodingException_1(offset, message) {
        return new JsonDecodingException(offset >= 0 ? "Unexpected JSON token at offset " + offset + ": " + message : message);
    }
    function minify(_this__u8e3s4, offset) {
        offset = offset === VOID ? -1 : offset;
        if (charSequenceLength(_this__u8e3s4) < 200) return _this__u8e3s4;
        if (offset === -1) {
            var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
            if (start <= 0) return _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var endIndex = charSequenceLength(_this__u8e3s4);
            return "....." + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
        }
        var start_0 = offset - 30 | 0;
        var end = offset + 30 | 0;
        var prefix = start_0 <= 0 ? "" : ".....";
        var suffix = end >= charSequenceLength(_this__u8e3s4) ? "" : ".....";
        // Inline function 'kotlin.text.substring' call
        var startIndex = coerceAtLeast(start_0, 0);
        var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
        return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
    }
    function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
        _this__u8e3s4.n1d("Unexpected special floating-point value " + toString(result) + ". By default, " + "non-finite floating point values are prohibited because they do not conform JSON specification", VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
    }
    function JsonEncodingException(message) {
        JsonException.call(this, message);
        captureStack(this, JsonEncodingException);
    }
    function InvalidKeyKindException(keyDescriptor) {
        return new JsonEncodingException("Value of type '" + keyDescriptor.zo() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.sp().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
    }
    function InvalidFloatingPointEncoded(value, key, output) {
        return new JsonEncodingException(unexpectedFpErrorMessage(value, key, output));
    }
    function InvalidFloatingPointDecoded(value, key, output) {
        return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
    }
    function UnknownKeyException(key, input) {
        return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ("Current input: " + toString(minify(input))));
    }
    function InvalidFloatingPointEncoded_0(value, output) {
        return new JsonEncodingException("Unexpected special floating-point value " + toString(value) + ". By default, " + "non-finite floating point values are prohibited because they do not conform JSON specification. " + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ("Current output: " + toString(minify(output))));
    }
    function unexpectedFpErrorMessage(value, key, output) {
        return "Unexpected special floating-point value " + toString(value) + " with key " + key + ". By default, " + "non-finite floating point values are prohibited because they do not conform JSON specification. " + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ("Current output: " + toString(minify(output)));
    }
    function get_JsonDeserializationNamesKey() {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        return JsonDeserializationNamesKey;
    }
    var JsonDeserializationNamesKey;
    function get_JsonSerializationNamesKey() {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        return JsonSerializationNamesKey;
    }
    var JsonSerializationNamesKey;
    function getJsonNameIndex(_this__u8e3s4, json, name) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        if (decodeCaseInsensitive(json, _this__u8e3s4)) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$1 = name.toLowerCase();
            return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
        }
        var strategy = namingStrategy(_this__u8e3s4, json);
        if (!(strategy == null)) return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
        var index = _this__u8e3s4.vp(name);
        if (!(index === -3)) return index;
        if (!json.x18_1.t1a_1) return index;
        return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
    }
    function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
        suffix = suffix === VOID ? "" : suffix;
        _init_properties_JsonNamesMap_kt__cbbp0k();
        var index = getJsonNameIndex(_this__u8e3s4, json, name);
        if (index === -3) throw SerializationException_init_$Create$(_this__u8e3s4.zo() + " does not contain element with name '" + name + "'" + suffix);
        return index;
    }
    function getJsonElementName(_this__u8e3s4, json, index) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        var strategy = namingStrategy(_this__u8e3s4, json);
        return strategy == null ? _this__u8e3s4.wp(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
    }
    function namingStrategy(_this__u8e3s4, json) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        return equals(_this__u8e3s4.sp(), CLASS_getInstance()) ? json.x18_1.u1a_1 : null;
    }
    function deserializationNamesMap(_this__u8e3s4, descriptor) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        var tmp = get_schemaCache(_this__u8e3s4);
        var tmp_0 = get_JsonDeserializationNamesKey();
        return tmp.p1d(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
    }
    function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        return _this__u8e3s4.x18_1.v1a_1 && equals(descriptor.sp(), ENUM_getInstance());
    }
    function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).e2(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
    }
    function serializationNamesIndices(_this__u8e3s4, json, strategy) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        var tmp = get_schemaCache(json);
        var tmp_0 = get_JsonSerializationNamesKey();
        return tmp.p1d(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
    }
    function buildDeserializationNamesMap(_this__u8e3s4, json) {
        _init_properties_JsonNamesMap_kt__cbbp0k();
        // Inline function 'kotlin.collections.mutableMapOf' call
        var builder = LinkedHashMap_init_$Create$();
        var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
        var strategyForClasses = namingStrategy(_this__u8e3s4, json);
        var inductionVariable = 0;
        var last = _this__u8e3s4.qp();
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.filterIsInstance' call
            // Inline function 'kotlin.collections.filterIsInstanceTo' call
            var this_0 = _this__u8e3s4.tp(i);
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                if (element instanceof JsonNames) destination.e(element);
            }
            var tmp1_safe_receiver = singleOrNull(destination);
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.q1d_1;
            if (tmp2_safe_receiver == null) ;
            else {
                // Inline function 'kotlin.collections.forEach' call
                var inductionVariable_0 = 0;
                var last_0 = tmp2_safe_receiver.length;
                while(inductionVariable_0 < last_0){
                    var element_0 = tmp2_safe_receiver[inductionVariable_0];
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
                    var tmp;
                    if (useLowercaseEnums) // Inline function 'kotlin.text.lowercase' call
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp = element_0.toLowerCase();
                    else tmp = element_0;
                    buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
                }
            }
            var tmp_0;
            if (useLowercaseEnums) // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_0 = _this__u8e3s4.wp(i).toLowerCase();
            else if (!(strategyForClasses == null)) tmp_0 = strategyForClasses.r1d(_this__u8e3s4, i, _this__u8e3s4.wp(i));
            else tmp_0 = null;
            var nameToPut = tmp_0;
            if (nameToPut == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
        }while (inductionVariable < last);
        // Inline function 'kotlin.collections.ifEmpty' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (builder.s()) // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
        tmp_1 = emptyMap();
        else tmp_1 = builder;
        return tmp_1;
    }
    function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
        var entity = equals($this_buildDeserializationNamesMap.sp(), ENUM_getInstance()) ? "enum value" : "property";
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).c2(name)) throw new JsonException("The suggested name '" + name + "' for " + entity + " " + $this_buildDeserializationNamesMap.wp(index) + " is already one of the names for " + entity + " " + ($this_buildDeserializationNamesMap.wp(getValue(_this__u8e3s4, name)) + " in " + toString($this_buildDeserializationNamesMap)));
        // Inline function 'kotlin.collections.set' call
        _this__u8e3s4.m2(name, index);
    }
    function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
        return function() {
            return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
        };
    }
    function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
        return function() {
            var tmp = 0;
            var tmp_0 = $this_serializationNamesIndices.qp();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_1 = fillArrayVal(Array(tmp_0), null);
            while(tmp < tmp_0){
                var tmp_2 = tmp;
                var baseName = $this_serializationNamesIndices.wp(tmp_2);
                tmp_1[tmp_2] = $strategy.r1d($this_serializationNamesIndices, tmp_2, baseName);
                tmp = tmp + 1 | 0;
            }
            return tmp_1;
        };
    }
    var properties_initialized_JsonNamesMap_kt_ljpf42;
    function _init_properties_JsonNamesMap_kt__cbbp0k() {
        if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
            properties_initialized_JsonNamesMap_kt_ljpf42 = true;
            JsonDeserializationNamesKey = new Key();
            JsonSerializationNamesKey = new Key();
        }
    }
    function Tombstone() {}
    var Tombstone_instance;
    function Tombstone_getInstance() {
        return Tombstone_instance;
    }
    function resize($this) {
        var newSize = imul($this.u1d_1, 2);
        $this.s1d_1 = copyOf($this.s1d_1, newSize);
        $this.t1d_1 = copyOf_0($this.t1d_1, newSize);
    }
    function JsonPath() {
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp.s1d_1 = fillArrayVal(Array(8), null);
        var tmp_0 = this;
        var tmp_1 = 0;
        var tmp_2 = new Int32Array(8);
        while(tmp_1 < 8){
            tmp_2[tmp_1] = -1;
            tmp_1 = tmp_1 + 1 | 0;
        }
        tmp_0.t1d_1 = tmp_2;
        this.u1d_1 = -1;
    }
    protoOf(JsonPath).v1d = function(sd) {
        this.u1d_1 = this.u1d_1 + 1 | 0;
        var depth = this.u1d_1;
        if (depth === this.s1d_1.length) resize(this);
        this.s1d_1[depth] = sd;
    };
    protoOf(JsonPath).w1d = function(index) {
        this.t1d_1[this.u1d_1] = index;
    };
    protoOf(JsonPath).x1d = function(key) {
        var tmp;
        if (!(this.t1d_1[this.u1d_1] === -2)) {
            this.u1d_1 = this.u1d_1 + 1 | 0;
            tmp = this.u1d_1 === this.s1d_1.length;
        } else tmp = false;
        if (tmp) resize(this);
        this.s1d_1[this.u1d_1] = key;
        this.t1d_1[this.u1d_1] = -2;
    };
    protoOf(JsonPath).y1d = function() {
        if (this.t1d_1[this.u1d_1] === -2) this.s1d_1[this.u1d_1] = Tombstone_instance;
    };
    protoOf(JsonPath).z1d = function() {
        var depth = this.u1d_1;
        if (this.t1d_1[depth] === -2) {
            this.t1d_1[depth] = -1;
            this.u1d_1 = this.u1d_1 - 1 | 0;
        }
        if (!(this.u1d_1 === -1)) this.u1d_1 = this.u1d_1 - 1 | 0;
    };
    protoOf(JsonPath).a1e = function() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
        this_0.e8("$");
        // Inline function 'kotlin.repeat' call
        var times = this.u1d_1 + 1 | 0;
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < times) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
            var element = this.s1d_1[index];
            if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
                if (equals(element.sp(), LIST_getInstance())) {
                    if (!(this.t1d_1[index] === -1)) {
                        this_0.e8("[");
                        this_0.d8(this.t1d_1[index]);
                        this_0.e8("]");
                    }
                } else {
                    var idx = this.t1d_1[index];
                    if (idx >= 0) {
                        this_0.e8(".");
                        this_0.e8(element.wp(idx));
                    }
                }
            } else if (!(element === Tombstone_instance)) {
                this_0.e8("[");
                this_0.e8("'");
                this_0.d8(element);
                this_0.e8("'");
                this_0.e8("]");
            }
        }while (inductionVariable < times);
        return this_0.toString();
    };
    protoOf(JsonPath).toString = function() {
        return this.a1e();
    };
    function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
        var tmp = WriteMode_OBJ_getInstance();
        // Inline function 'kotlin.arrayOfNulls' call
        var size = values().length;
        var tmp$ret$0 = fillArrayVal(Array(size), null);
        var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
        encoder.ct(serializer, value);
    }
    function readObject($this) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
        var lastToken = $this.j1e_1.m1e(6);
        if ($this.j1e_1.n1e() === 4) $this.j1e_1.n1d("Unexpected leading comma");
        // Inline function 'kotlin.collections.linkedMapOf' call
        var result = LinkedHashMap_init_$Create$();
        $l$loop: while($this.j1e_1.o1e()){
            var key = $this.k1e_1 ? $this.j1e_1.q1e() : $this.j1e_1.p1e();
            $this.j1e_1.m1e(5);
            // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
            var element = $this.r1e();
            // Inline function 'kotlin.collections.set' call
            result.m2(key, element);
            lastToken = $this.j1e_1.s1e();
            var tmp0_subject = lastToken;
            if (tmp0_subject !== 4) {
                if (tmp0_subject === 7) break $l$loop;
                else $this.j1e_1.n1d("Expected end of the object or comma");
            }
        }
        if (lastToken === 6) $this.j1e_1.m1e(7);
        else if (lastToken === 4) $this.j1e_1.n1d("Unexpected trailing comma");
        return new JsonObject(result);
    }
    function readObject_0(_this__u8e3s4, $this, $completion) {
        var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function readArray($this) {
        var lastToken = $this.j1e_1.s1e();
        if ($this.j1e_1.n1e() === 4) $this.j1e_1.n1d("Unexpected leading comma");
        // Inline function 'kotlin.collections.arrayListOf' call
        var result = ArrayList_init_$Create$();
        while($this.j1e_1.o1e()){
            var element = $this.r1e();
            result.e(element);
            lastToken = $this.j1e_1.s1e();
            if (!(lastToken === 4)) {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
                var this_0 = $this.j1e_1;
                var condition = lastToken === 9;
                var position = this_0.n19_1;
                if (!condition) {
                    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
                    var tmp$ret$1 = "Expected end of the array or comma";
                    this_0.n1d(tmp$ret$1, position);
                }
            }
        }
        if (lastToken === 8) $this.j1e_1.m1e(9);
        else if (lastToken === 4) $this.j1e_1.n1d("Unexpected trailing comma");
        return new JsonArray(result);
    }
    function readValue($this, isString) {
        var tmp;
        if ($this.k1e_1 || !isString) tmp = $this.j1e_1.q1e();
        else tmp = $this.j1e_1.p1e();
        var string = tmp;
        if (!isString && string === "null") return JsonNull_getInstance();
        return new JsonLiteral(string, isString);
    }
    function readDeepRecursive($this) {
        return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
    }
    function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
        this.p1f_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsonTreeReader$readDeepRecursive$slambda).u1f = function($this$$receiver, it, $completion) {
        var tmp = this.v1f($this$$receiver, it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsonTreeReader$readDeepRecursive$slambda).hj = function(p1, p2, $completion) {
        var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
        return this.u1f(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
    };
    protoOf(JsonTreeReader$readDeepRecursive$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.s1f_1 = this.p1f_1.j1e_1.n1e();
                    if (this.s1f_1 === 1) {
                        this.t1f_1 = readValue(this.p1f_1, true);
                        this.v8_1 = 2;
                        continue $sm;
                    } else if (this.s1f_1 === 0) {
                        this.t1f_1 = readValue(this.p1f_1, false);
                        this.v8_1 = 2;
                        continue $sm;
                    } else {
                        if (this.s1f_1 === 6) {
                            this.v8_1 = 1;
                            suspendResult = readObject_0(this.q1f_1, this.p1f_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else if (this.s1f_1 === 8) {
                            this.t1f_1 = readArray(this.p1f_1);
                            this.v8_1 = 2;
                            continue $sm;
                        } else {
                            var tmp_0 = this;
                            this.p1f_1.j1e_1.n1d("Can't begin reading element, unexpected token");
                        }
                    }
                    break;
                case 1:
                    this.t1f_1 = suspendResult;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    return this.t1f_1;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsonTreeReader$readDeepRecursive$slambda).v1f = function($this$$receiver, it, completion) {
        var i = new JsonTreeReader$readDeepRecursive$slambda(this.p1f_1, completion);
        i.q1f_1 = $this$$receiver;
        i.r1f_1 = it;
        return i;
    };
    function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
        var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
        var l = function($this$$receiver, it, $completion) {
            return i.u1f($this$$receiver, it, $completion);
        };
        l.$arity = 2;
        return l;
    }
    function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.b1f_1 = _this__u8e3s4;
        this.c1f_1 = _this__u8e3s4_0;
    }
    protoOf($readObjectCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    var tmp_0 = this;
                    tmp_0.d1f_1 = this.b1f_1;
                    this.e1f_1 = this.d1f_1.j1e_1.m1e(6);
                    if (this.d1f_1.j1e_1.n1e() === 4) this.d1f_1.j1e_1.n1d("Unexpected leading comma");
                    var tmp_1 = this;
                    tmp_1.f1f_1 = LinkedHashMap_init_$Create$();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.d1f_1.j1e_1.o1e()) {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                    this.g1f_1 = this.d1f_1.k1e_1 ? this.d1f_1.j1e_1.q1e() : this.d1f_1.j1e_1.p1e();
                    this.d1f_1.j1e_1.m1e(5);
                    this.v8_1 = 2;
                    suspendResult = this.c1f_1.zi(Unit_instance, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var element = suspendResult;
                    var this_0 = this.f1f_1;
                    var key = this.g1f_1;
                    this_0.m2(key, element);
                    this.e1f_1 = this.d1f_1.j1e_1.s1e();
                    var tmp0_subject = this.e1f_1;
                    if (tmp0_subject === 4) {
                        this.v8_1 = 3;
                        continue $sm;
                    } else if (tmp0_subject === 7) {
                        this.v8_1 = 4;
                        continue $sm;
                    } else this.d1f_1.j1e_1.n1d("Expected end of the object or comma");
                    break;
                case 3:
                    this.v8_1 = 1;
                    continue $sm;
                case 4:
                    if (this.e1f_1 === 6) this.d1f_1.j1e_1.m1e(7);
                    else if (this.e1f_1 === 4) this.d1f_1.j1e_1.n1d("Unexpected trailing comma");
                    return new JsonObject(this.f1f_1);
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function JsonTreeReader(configuration, lexer) {
        this.j1e_1 = lexer;
        this.k1e_1 = configuration.k1a_1;
        this.l1e_1 = 0;
    }
    protoOf(JsonTreeReader).r1e = function() {
        var token = this.j1e_1.n1e();
        var tmp;
        if (token === 1) tmp = readValue(this, true);
        else if (token === 0) tmp = readValue(this, false);
        else if (token === 6) {
            var tmp_0;
            this.l1e_1 = this.l1e_1 + 1 | 0;
            if (this.l1e_1 === 200) tmp_0 = readDeepRecursive(this);
            else tmp_0 = readObject(this);
            var result = tmp_0;
            this.l1e_1 = this.l1e_1 - 1 | 0;
            tmp = result;
        } else if (token === 8) tmp = readArray(this);
        else this.j1e_1.n1d("Cannot read Json element because of unexpected " + tokenDescription(token));
        return tmp;
    };
    function classDiscriminator(_this__u8e3s4, json) {
        var tmp0_iterator = _this__u8e3s4.pp().j();
        while(tmp0_iterator.k()){
            var annotation = tmp0_iterator.l();
            if (annotation instanceof JsonClassDiscriminator) return annotation.w1f_1;
        }
        return json.x18_1.r1a_1;
    }
    function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
        var tmp;
        if (!(deserializer instanceof AbstractPolymorphicSerializer)) tmp = true;
        else tmp = _this__u8e3s4.a1b().x18_1.q1a_1;
        if (tmp) return deserializer.ao(_this__u8e3s4);
        var discriminator = classDiscriminator(deserializer.yn(), _this__u8e3s4.a1b());
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var value = _this__u8e3s4.y1a();
        var descriptor = deserializer.yn();
        if (!(value instanceof JsonObject)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonObject)) + " as the serialized body of " + descriptor.zo() + ", but had " + toString(getKClassFromExpression(value)));
        var jsonTree = value;
        var tmp0_safe_receiver = jsonTree.vl(discriminator);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
        var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1b();
        var tmp2_elvis_lhs = deserializer.po(_this__u8e3s4, type);
        var tmp_0;
        if (tmp2_elvis_lhs == null) throwSerializerNotFound(type, jsonTree);
        else tmp_0 = tmp2_elvis_lhs;
        var actualSerializer = tmp_0;
        var tmp_1 = _this__u8e3s4.a1b();
        return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
    }
    function throwSerializerNotFound(type, jsonTree) {
        var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
        throw JsonDecodingException_0(-1, "Polymorphic serializer was not found for " + suffix, jsonTree.toString());
    }
    function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
        if (!(serializer instanceof SealedClassSerializer)) return Unit_instance;
        if (jsonCachedSerialNames(actualSerializer.yn()).a2(classDiscriminator)) {
            var baseName = serializer.yn().zo();
            var actualName = actualSerializer.yn().zo();
            // Inline function 'kotlin.error' call
            var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + "You can either change class discriminator in JsonConfiguration, " + "rename property with @SerialName annotation or fall back to array polymorphism";
            throw IllegalStateException_init_$Create$(toString(message));
        }
    }
    function checkKind(kind) {
        if (kind instanceof ENUM) {
            // Inline function 'kotlin.error' call
            var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        if (kind instanceof PrimitiveKind) {
            // Inline function 'kotlin.error' call
            var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
        if (kind instanceof PolymorphicKind) {
            // Inline function 'kotlin.error' call
            var message_1 = "Actual serializer for polymorphic cannot be polymorphic itself";
            throw IllegalStateException_init_$Create$(toString(message_1));
        }
    }
    function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
        return validateIfSealed(serializer, actualSerializer, classDiscriminator);
    }
    function checkKind_0($this, descriptor, actualClass) {
        var kind = descriptor.sp();
        var tmp;
        if (kind instanceof PolymorphicKind) tmp = true;
        else tmp = equals(kind, CONTEXTUAL_getInstance());
        if (tmp) throw IllegalArgumentException_init_$Create$("Serializer for " + actualClass.fa() + " can't be registered as a subclass for polymorphic serialization " + ("because its kind " + kind.toString() + " is not concrete. To work with multiple hierarchies, register it as a base class."));
        if ($this.x1f_1) return Unit_instance;
        var tmp_0;
        var tmp_1;
        if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) tmp_1 = true;
        else tmp_1 = kind instanceof PrimitiveKind;
        if (tmp_1) tmp_0 = true;
        else tmp_0 = kind instanceof ENUM;
        if (tmp_0) throw IllegalArgumentException_init_$Create$("Serializer for " + actualClass.fa() + " of kind " + kind.toString() + " cannot be serialized polymorphically with class discriminator.");
    }
    function checkDiscriminatorCollisions($this, descriptor, actualClass) {
        var inductionVariable = 0;
        var last = descriptor.qp();
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var name = descriptor.wp(i);
            if (name === $this.y1f_1) throw IllegalArgumentException_init_$Create$("Polymorphic serializer for " + toString(actualClass) + " has property '" + name + "' that conflicts " + "with JSON class discriminator. You can either change class discriminator in JsonConfiguration, " + "rename property with @SerialName annotation " + "or fall back to array polymorphism");
        }while (inductionVariable < last);
    }
    function PolymorphismValidator(useArrayPolymorphism, discriminator) {
        this.x1f_1 = useArrayPolymorphism;
        this.y1f_1 = discriminator;
    }
    protoOf(PolymorphismValidator).o18 = function(kClass, provider) {};
    protoOf(PolymorphismValidator).r18 = function(baseClass, actualClass, actualSerializer) {
        var descriptor = actualSerializer.yn();
        checkKind_0(this, descriptor, actualClass);
        if (!this.x1f_1) checkDiscriminatorCollisions(this, descriptor, actualClass);
    };
    protoOf(PolymorphismValidator).s18 = function(baseClass, defaultSerializerProvider) {};
    protoOf(PolymorphismValidator).t18 = function(baseClass, defaultDeserializerProvider) {};
    function Key() {}
    function DescriptorSchemaCache() {
        this.o1d_1 = createMapForCache(16);
    }
    protoOf(DescriptorSchemaCache).z1f = function(descriptor, key, value) {
        // Inline function 'kotlin.collections.set' call
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.o1d_1;
        var value_0 = this_0.e2(descriptor);
        var tmp;
        if (value_0 == null) {
            // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
            var answer = createMapForCache(2);
            this_0.m2(descriptor, answer);
            tmp = answer;
        } else tmp = value_0;
        var this_1 = tmp;
        var key_0 = key instanceof Key ? key : THROW_CCE();
        var value_1 = !(value == null) ? value : THROW_CCE();
        this_1.m2(key_0, value_1);
    };
    protoOf(DescriptorSchemaCache).p1d = function(descriptor, key, defaultValue) {
        var tmp0_safe_receiver = this.a1g(descriptor, key);
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp0_safe_receiver;
        var value = defaultValue();
        this.z1f(descriptor, key, value);
        return value;
    };
    protoOf(DescriptorSchemaCache).a1g = function(descriptor, key) {
        var tmp0_safe_receiver = this.o1d_1.e2(descriptor);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else tmp = tmp0_safe_receiver.e2(key instanceof Key ? key : THROW_CCE());
        var tmp_0 = tmp;
        return !(tmp_0 == null) ? tmp_0 : null;
    };
    function DiscriminatorHolder(discriminatorToSkip) {
        this.b1g_1 = discriminatorToSkip;
    }
    function trySkip(_this__u8e3s4, $this, unknownKey) {
        if (_this__u8e3s4 == null) return false;
        if (_this__u8e3s4.b1g_1 === unknownKey) {
            _this__u8e3s4.b1g_1 = null;
            return true;
        }
        return false;
    }
    function skipLeftoverElements($this, descriptor) {
        while(!($this.bs(descriptor) === -1));
    }
    function checkLeadingComma($this) {
        if ($this.h19_1.n1e() === 4) $this.h19_1.n1d("Unexpected leading comma");
    }
    function decodeMapIndex($this) {
        var hasComma = false;
        var decodingKey = !(($this.j19_1 % 2 | 0) === 0);
        if (decodingKey) {
            if (!($this.j19_1 === -1)) hasComma = $this.h19_1.d1g();
        } else $this.h19_1.c1g(_Char___init__impl__6a9atx(58));
        var tmp;
        if ($this.h19_1.o1e()) {
            if (decodingKey) {
                if ($this.j19_1 === -1) {
                    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
                    var this_0 = $this.h19_1;
                    var condition = !hasComma;
                    var position = this_0.n19_1;
                    if (!condition) {
                        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
                        var tmp$ret$0 = "Unexpected trailing comma";
                        this_0.n1d(tmp$ret$0, position);
                    }
                } else {
                    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
                    var this_1 = $this.h19_1;
                    var condition_0 = hasComma;
                    var position_0 = this_1.n19_1;
                    if (!condition_0) {
                        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
                        var tmp$ret$1 = "Expected comma after the key-value pair";
                        this_1.n1d(tmp$ret$1, position_0);
                    }
                }
            }
            $this.j19_1 = $this.j19_1 + 1 | 0;
            tmp = $this.j19_1;
        } else {
            if (hasComma) $this.h19_1.n1d("Expected '}', but had ',' instead");
            tmp = -1;
        }
        return tmp;
    }
    function coerceInputValue($this, descriptor, index) {
        var tmp$ret$1;
        $l$block_2: {
            // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
            var this_0 = $this.f19_1;
            var elementDescriptor = descriptor.up(index);
            var tmp;
            if (!elementDescriptor.lp()) // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
            tmp = $this.h19_1.e1g(true);
            else tmp = false;
            if (tmp) {
                tmp$ret$1 = true;
                break $l$block_2;
            }
            if (equals(elementDescriptor.sp(), ENUM_getInstance())) {
                var tmp_0;
                if (elementDescriptor.lp()) // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
                tmp_0 = $this.h19_1.e1g(false);
                else tmp_0 = false;
                if (tmp_0) {
                    tmp$ret$1 = false;
                    break $l$block_2;
                }
                // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
                var tmp0_elvis_lhs = $this.h19_1.f1g($this.l19_1.k1a_1);
                var tmp_1;
                if (tmp0_elvis_lhs == null) {
                    tmp$ret$1 = false;
                    break $l$block_2;
                } else tmp_1 = tmp0_elvis_lhs;
                var enumValue = tmp_1;
                var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
                if (enumIndex === -3) {
                    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
                    $this.h19_1.p1e();
                    tmp$ret$1 = true;
                    break $l$block_2;
                }
            }
            tmp$ret$1 = false;
        }
        return tmp$ret$1;
    }
    function decodeObjectIndex($this, descriptor) {
        var hasComma = $this.h19_1.d1g();
        while($this.h19_1.o1e()){
            hasComma = false;
            var key = decodeStringKey($this);
            $this.h19_1.c1g(_Char___init__impl__6a9atx(58));
            var index = getJsonNameIndex(descriptor, $this.f19_1, key);
            var tmp;
            if (!(index === -3)) {
                var tmp_0;
                if ($this.l19_1.p1a_1 && coerceInputValue($this, descriptor, index)) {
                    hasComma = $this.h19_1.d1g();
                    tmp_0 = false;
                } else {
                    var tmp0_safe_receiver = $this.m19_1;
                    if (tmp0_safe_receiver == null) ;
                    else tmp0_safe_receiver.l1d(index);
                    return index;
                }
                tmp = tmp_0;
            } else tmp = true;
            var isUnknown = tmp;
            if (isUnknown) hasComma = handleUnknown($this, key);
        }
        if (hasComma) $this.h19_1.n1d("Unexpected trailing comma");
        var tmp1_safe_receiver = $this.m19_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m1d();
        return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
    }
    function handleUnknown($this, key) {
        if ($this.l19_1.j1a_1 || trySkip($this.k19_1, $this, key)) $this.h19_1.h1g($this.l19_1.k1a_1);
        else $this.h19_1.g1g(key);
        return $this.h19_1.d1g();
    }
    function decodeListIndex($this) {
        var hasComma = $this.h19_1.d1g();
        var tmp;
        if ($this.h19_1.o1e()) {
            if (!($this.j19_1 === -1) && !hasComma) $this.h19_1.n1d("Expected end of the array or comma");
            $this.j19_1 = $this.j19_1 + 1 | 0;
            tmp = $this.j19_1;
        } else {
            if (hasComma) $this.h19_1.n1d("Unexpected trailing comma");
            tmp = -1;
        }
        return tmp;
    }
    function decodeStringKey($this) {
        var tmp;
        if ($this.l19_1.k1a_1) tmp = $this.h19_1.j1g();
        else tmp = $this.h19_1.i1g();
        return tmp;
    }
    function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
        AbstractDecoder.call(this);
        this.f19_1 = json;
        this.g19_1 = mode;
        this.h19_1 = lexer;
        this.i19_1 = this.f19_1.dp();
        this.j19_1 = -1;
        this.k19_1 = discriminatorHolder;
        this.l19_1 = this.f19_1.x18_1;
        this.m19_1 = this.l19_1.n1a_1 ? null : new JsonElementMarker(descriptor);
    }
    protoOf(StreamingJsonDecoder).a1b = function() {
        return this.f19_1;
    };
    protoOf(StreamingJsonDecoder).dp = function() {
        return this.i19_1;
    };
    protoOf(StreamingJsonDecoder).y1a = function() {
        return new JsonTreeReader(this.f19_1.x18_1, this.h19_1).r1e();
    };
    protoOf(StreamingJsonDecoder).kr = function(deserializer) {
        try {
            var tmp;
            if (!(deserializer instanceof AbstractPolymorphicSerializer)) tmp = true;
            else tmp = this.f19_1.x18_1.q1a_1;
            if (tmp) return deserializer.ao(this);
            var discriminator = classDiscriminator(deserializer.yn(), this.f19_1);
            var type = this.h19_1.k1g(discriminator, this.l19_1.k1a_1);
            var actualSerializer = null;
            if (!(type == null)) actualSerializer = deserializer.po(this, type);
            if (actualSerializer == null) return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
            this.k19_1 = new DiscriminatorHolder(discriminator);
            var tmp_0 = actualSerializer.ao(this);
            var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
            return result;
        } catch ($p) {
            if ($p instanceof MissingFieldException) {
                var e = $p;
                if (contains_0(ensureNotNull(e.message), "at path")) throw e;
                throw new MissingFieldException(e.gp_1, plus(e.message, " at path: ") + this.h19_1.o19_1.a1e(), e);
            } else throw $p;
        }
    };
    protoOf(StreamingJsonDecoder).lr = function(descriptor) {
        var newMode = switchMode(this.f19_1, descriptor);
        this.h19_1.o19_1.v1d(descriptor);
        this.h19_1.c1g(newMode.n1g_1);
        checkLeadingComma(this);
        var tmp;
        switch(newMode.q2_1){
            case 1:
            case 2:
            case 3:
                tmp = new StreamingJsonDecoder(this.f19_1, newMode, this.h19_1, descriptor, this.k19_1);
                break;
            default:
                var tmp_0;
                if (this.g19_1.equals(newMode) && this.f19_1.x18_1.n1a_1) tmp_0 = this;
                else tmp_0 = new StreamingJsonDecoder(this.f19_1, newMode, this.h19_1, descriptor, this.k19_1);
                tmp = tmp_0;
                break;
        }
        return tmp;
    };
    protoOf(StreamingJsonDecoder).mr = function(descriptor) {
        if (this.f19_1.x18_1.j1a_1 && descriptor.qp() === 0) skipLeftoverElements(this, descriptor);
        this.h19_1.c1g(this.g19_1.o1g_1);
        this.h19_1.o19_1.z1d();
    };
    protoOf(StreamingJsonDecoder).wq = function() {
        var tmp;
        var tmp0_safe_receiver = this.m19_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k1d_1;
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) tmp = !this.h19_1.p1g();
        else tmp = false;
        return tmp;
    };
    protoOf(StreamingJsonDecoder).xq = function() {
        return null;
    };
    protoOf(StreamingJsonDecoder).xr = function(descriptor, index, deserializer, previousValue) {
        var isMapKey = this.g19_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
        if (isMapKey) this.h19_1.o19_1.y1d();
        var value = protoOf(AbstractDecoder).xr.call(this, descriptor, index, deserializer, previousValue);
        if (isMapKey) this.h19_1.o19_1.x1d(value);
        return value;
    };
    protoOf(StreamingJsonDecoder).bs = function(descriptor) {
        var index;
        switch(this.g19_1.q2_1){
            case 0:
                index = decodeObjectIndex(this, descriptor);
                break;
            case 2:
                index = decodeMapIndex(this);
                break;
            default:
                index = decodeListIndex(this);
                break;
        }
        if (!this.g19_1.equals(WriteMode_MAP_getInstance())) this.h19_1.o19_1.w1d(index);
        return index;
    };
    protoOf(StreamingJsonDecoder).yq = function() {
        var tmp;
        if (this.l19_1.k1a_1) tmp = this.h19_1.r1g();
        else tmp = this.h19_1.q1g();
        return tmp;
    };
    protoOf(StreamingJsonDecoder).zq = function() {
        var value = this.h19_1.i1b();
        if (!value.equals(toLong(value.n3()))) this.h19_1.n1d("Failed to parse byte for input '" + value.toString() + "'");
        return value.n3();
    };
    protoOf(StreamingJsonDecoder).ar = function() {
        var value = this.h19_1.i1b();
        if (!value.equals(toLong(value.o3()))) this.h19_1.n1d("Failed to parse short for input '" + value.toString() + "'");
        return value.o3();
    };
    protoOf(StreamingJsonDecoder).br = function() {
        var value = this.h19_1.i1b();
        if (!value.equals(toLong(value.l1()))) this.h19_1.n1d("Failed to parse int for input '" + value.toString() + "'");
        return value.l1();
    };
    protoOf(StreamingJsonDecoder).cr = function() {
        return this.h19_1.i1b();
    };
    protoOf(StreamingJsonDecoder).dr = function() {
        var tmp$ret$4;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.h19_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
                // Inline function 'kotlin.text.toFloat' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp$ret$4 = toDouble(input);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'float' for input '" + input + "'");
                } else throw $p;
            }
        }
        var result = tmp$ret$4;
        var specialFp = this.f19_1.x18_1.s1a_1;
        if (specialFp || isFinite(result)) return result;
        throwInvalidFloatingPointDecoded(this.h19_1, result);
    };
    protoOf(StreamingJsonDecoder).er = function() {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.h19_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
                tmp$ret$1 = toDouble(input);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'double' for input '" + input + "'");
                } else throw $p;
            }
        }
        var result = tmp$ret$1;
        var specialFp = this.f19_1.x18_1.s1a_1;
        if (specialFp || isFinite_0(result)) return result;
        throwInvalidFloatingPointDecoded(this.h19_1, result);
    };
    protoOf(StreamingJsonDecoder).fr = function() {
        var string = this.h19_1.q1e();
        if (!(string.length === 1)) this.h19_1.n1d("Expected single char, but got '" + string + "'");
        return charSequenceGet(string, 0);
    };
    protoOf(StreamingJsonDecoder).gr = function() {
        var tmp;
        if (this.l19_1.k1a_1) tmp = this.h19_1.j1g();
        else tmp = this.h19_1.p1e();
        return tmp;
    };
    protoOf(StreamingJsonDecoder).ir = function(descriptor) {
        return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.h19_1, this.f19_1) : protoOf(AbstractDecoder).ir.call(this, descriptor);
    };
    protoOf(StreamingJsonDecoder).hr = function(enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.f19_1, this.gr(), " at path " + this.h19_1.o19_1.a1e());
    };
    function JsonDecoderForUnsignedTypes(lexer, json) {
        AbstractDecoder.call(this);
        this.s1g_1 = lexer;
        this.t1g_1 = json.dp();
    }
    protoOf(JsonDecoderForUnsignedTypes).dp = function() {
        return this.t1g_1;
    };
    protoOf(JsonDecoderForUnsignedTypes).bs = function(descriptor) {
        var message = "unsupported";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(JsonDecoderForUnsignedTypes).br = function() {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.s1g_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
                // Inline function 'kotlin.UInt.toInt' call
                var this_1 = toUInt(input);
                tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'UInt' for input '" + input + "'");
                } else throw $p;
            }
        }
        return tmp$ret$2;
    };
    protoOf(JsonDecoderForUnsignedTypes).cr = function() {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.s1g_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
                // Inline function 'kotlin.ULong.toLong' call
                var this_1 = toULong(input);
                tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'ULong' for input '" + input + "'");
                } else throw $p;
            }
        }
        return tmp$ret$2;
    };
    protoOf(JsonDecoderForUnsignedTypes).zq = function() {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.s1g_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
                // Inline function 'kotlin.UByte.toByte' call
                var this_1 = toUByte(input);
                tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'UByte' for input '" + input + "'");
                } else throw $p;
            }
        }
        return tmp$ret$2;
    };
    protoOf(JsonDecoderForUnsignedTypes).ar = function() {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.parseString' call
            var this_0 = this.s1g_1;
            var input = this_0.q1e();
            try {
                // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
                // Inline function 'kotlin.UShort.toShort' call
                var this_1 = toUShort(input);
                tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    this_0.n1d("Failed to parse type 'UShort' for input '" + input + "'");
                } else throw $p;
            }
        }
        return tmp$ret$2;
    };
    function get_unsignedNumberDescriptors() {
        _init_properties_StreamingJsonEncoder_kt__pn1bsi();
        return unsignedNumberDescriptors;
    }
    var unsignedNumberDescriptors;
    function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
        StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
        return $this;
    }
    function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
        return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
    }
    function encodeTypeInfo($this, descriptor) {
        $this.b1e_1.j1c();
        $this.os(ensureNotNull($this.i1e_1));
        $this.b1e_1.l1c(_Char___init__impl__6a9atx(58));
        $this.b1e_1.k1c();
        $this.os(descriptor.zo());
    }
    function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
        AbstractEncoder.call(this);
        this.b1e_1 = composer;
        this.c1e_1 = json;
        this.d1e_1 = mode;
        this.e1e_1 = modeReuseCache;
        this.f1e_1 = this.c1e_1.dp();
        this.g1e_1 = this.c1e_1.x18_1;
        this.h1e_1 = false;
        this.i1e_1 = null;
        var i = this.d1e_1.q2_1;
        if (!(this.e1e_1 == null)) {
            if (!(this.e1e_1[i] === null) || !(this.e1e_1[i] === this)) this.e1e_1[i] = this;
        }
    }
    protoOf(StreamingJsonEncoder).a1b = function() {
        return this.c1e_1;
    };
    protoOf(StreamingJsonEncoder).dp = function() {
        return this.f1e_1;
    };
    protoOf(StreamingJsonEncoder).ht = function(descriptor, index) {
        return this.g1e_1.i1a_1;
    };
    protoOf(StreamingJsonEncoder).ct = function(serializer, value) {
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
            var tmp;
            if (!(serializer instanceof AbstractPolymorphicSerializer)) tmp = true;
            else tmp = this.a1b().x18_1.q1a_1;
            if (tmp) {
                serializer.zn(this, value);
                break $l$block;
            }
            var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
            var baseClassDiscriminator = classDiscriminator(serializer.yn(), this.a1b());
            var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
            validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.yn().sp());
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
            this.i1e_1 = baseClassDiscriminator;
            actualSerializer.zn(this, value);
        }
    };
    protoOf(StreamingJsonEncoder).lr = function(descriptor) {
        var newMode = switchMode(this.c1e_1, descriptor);
        if (!(newMode.n1g_1 === _Char___init__impl__6a9atx(0))) {
            this.b1e_1.l1c(newMode.n1g_1);
            this.b1e_1.h1c();
        }
        if (!(this.i1e_1 == null)) {
            encodeTypeInfo(this, descriptor);
            this.i1e_1 = null;
        }
        if (this.d1e_1.equals(newMode)) return this;
        var tmp0_safe_receiver = this.e1e_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.q2_1];
        return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.b1e_1, this.c1e_1, newMode, this.e1e_1) : tmp1_elvis_lhs;
    };
    protoOf(StreamingJsonEncoder).mr = function(descriptor) {
        if (!(this.d1e_1.o1g_1 === _Char___init__impl__6a9atx(0))) {
            this.b1e_1.i1c();
            this.b1e_1.j1c();
            this.b1e_1.l1c(this.d1e_1.o1g_1);
        }
    };
    protoOf(StreamingJsonEncoder).ds = function(descriptor, index) {
        switch(this.d1e_1.q2_1){
            case 1:
                if (!this.b1e_1.g1c_1) this.b1e_1.l1c(_Char___init__impl__6a9atx(44));
                this.b1e_1.j1c();
                break;
            case 2:
                if (!this.b1e_1.g1c_1) {
                    var tmp = this;
                    var tmp_0;
                    if ((index % 2 | 0) === 0) {
                        this.b1e_1.l1c(_Char___init__impl__6a9atx(44));
                        this.b1e_1.j1c();
                        tmp_0 = true;
                    } else {
                        this.b1e_1.l1c(_Char___init__impl__6a9atx(58));
                        this.b1e_1.k1c();
                        tmp_0 = false;
                    }
                    tmp.h1e_1 = tmp_0;
                } else {
                    this.h1e_1 = true;
                    this.b1e_1.j1c();
                }
                break;
            case 3:
                if (index === 0) this.h1e_1 = true;
                if (index === 1) {
                    this.b1e_1.l1c(_Char___init__impl__6a9atx(44));
                    this.b1e_1.k1c();
                    this.h1e_1 = false;
                }
                break;
            default:
                if (!this.b1e_1.g1c_1) this.b1e_1.l1c(_Char___init__impl__6a9atx(44));
                this.b1e_1.j1c();
                this.os(getJsonElementName(descriptor, this.c1e_1, index));
                this.b1e_1.l1c(_Char___init__impl__6a9atx(58));
                this.b1e_1.k1c();
                break;
        }
        return true;
    };
    protoOf(StreamingJsonEncoder).dt = function(descriptor, index, serializer, value) {
        if (!(value == null) || this.g1e_1.n1a_1) protoOf(AbstractEncoder).dt.call(this, descriptor, index, serializer, value);
    };
    protoOf(StreamingJsonEncoder).qs = function(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
            var tmp_0;
            var tmp_1 = this.b1e_1;
            if (tmp_1 instanceof ComposerForUnsignedNumbers) tmp_0 = this.b1e_1;
            else tmp_0 = new ComposerForUnsignedNumbers(this.b1e_1.f1c_1, this.h1e_1);
            var tmp$ret$1 = tmp_0;
            tmp = new StreamingJsonEncoder(tmp$ret$1, this.c1e_1, this.d1e_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
            var tmp_2;
            var tmp_3 = this.b1e_1;
            if (tmp_3 instanceof ComposerForUnquotedLiterals) tmp_2 = this.b1e_1;
            else tmp_2 = new ComposerForUnquotedLiterals(this.b1e_1.f1c_1, this.h1e_1);
            var tmp$ret$3 = tmp_2;
            tmp = new StreamingJsonEncoder(tmp$ret$3, this.c1e_1, this.d1e_1, null);
        } else tmp = protoOf(AbstractEncoder).qs.call(this, descriptor);
        return tmp;
    };
    protoOf(StreamingJsonEncoder).fs = function() {
        this.b1e_1.n1c("null");
    };
    protoOf(StreamingJsonEncoder).gs = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.w1c(value);
    };
    protoOf(StreamingJsonEncoder).hs = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.r1c(value);
    };
    protoOf(StreamingJsonEncoder).is = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.t1c(value);
    };
    protoOf(StreamingJsonEncoder).js = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.u1c(value);
    };
    protoOf(StreamingJsonEncoder).ks = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.v1c(value);
    };
    protoOf(StreamingJsonEncoder).ls = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.p1c(value);
        if (!this.g1e_1.s1a_1 && !isFinite(value)) throw InvalidFloatingPointEncoded_0(value, toString(this.b1e_1.f1c_1));
    };
    protoOf(StreamingJsonEncoder).ms = function(value) {
        if (this.h1e_1) this.os(value.toString());
        else this.b1e_1.q1c(value);
        if (!this.g1e_1.s1a_1 && !isFinite_0(value)) throw InvalidFloatingPointEncoded_0(value, toString(this.b1e_1.f1c_1));
    };
    protoOf(StreamingJsonEncoder).ns = function(value) {
        this.os(toString_1(value));
    };
    protoOf(StreamingJsonEncoder).os = function(value) {
        return this.b1e_1.x1c(value);
    };
    protoOf(StreamingJsonEncoder).ps = function(enumDescriptor, index) {
        this.os(enumDescriptor.wp(index));
    };
    function get_isUnsignedNumber(_this__u8e3s4) {
        _init_properties_StreamingJsonEncoder_kt__pn1bsi();
        return _this__u8e3s4.rp() && get_unsignedNumberDescriptors().a2(_this__u8e3s4);
    }
    function get_isUnquotedLiteral(_this__u8e3s4) {
        _init_properties_StreamingJsonEncoder_kt__pn1bsi();
        return _this__u8e3s4.rp() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
    }
    var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
    function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
        if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
            properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
            unsignedNumberDescriptors = setOf([
                serializer_1(Companion_getInstance_0()).yn(),
                serializer_0(Companion_getInstance()).yn(),
                serializer_2(Companion_getInstance_1()).yn(),
                serializer_3(Companion_getInstance_2()).yn()
            ]);
        }
    }
    function get_ESCAPE_STRINGS() {
        _init_properties_StringOps_kt__fcy1db();
        return ESCAPE_STRINGS;
    }
    var ESCAPE_STRINGS;
    var ESCAPE_MARKERS;
    function toHexChar(i) {
        _init_properties_StringOps_kt__fcy1db();
        var d = i & 15;
        var tmp;
        if (d < 10) {
            // Inline function 'kotlin.code' call
            var this_0 = _Char___init__impl__6a9atx(48);
            var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
            tmp = numberToChar(d + tmp$ret$0 | 0);
        } else {
            var tmp_0 = d - 10 | 0;
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(97);
            var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
            tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
        }
        return tmp;
    }
    function printQuoted(_this__u8e3s4, value) {
        _init_properties_StringOps_kt__fcy1db();
        _this__u8e3s4.f8(_Char___init__impl__6a9atx(34));
        var lastPos = 0;
        var inductionVariable = 0;
        var last = charSequenceLength(value) - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_0 = charSequenceGet(value, i);
            var c = Char__toInt_impl_vasixd(this_0);
            if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
                _this__u8e3s4.qb(value, lastPos, i);
                _this__u8e3s4.e8(get_ESCAPE_STRINGS()[c]);
                lastPos = i + 1 | 0;
            }
        }while (inductionVariable <= last);
        if (!(lastPos === 0)) _this__u8e3s4.qb(value, lastPos, value.length);
        else _this__u8e3s4.e8(value);
        _this__u8e3s4.f8(_Char___init__impl__6a9atx(34));
    }
    function toBooleanStrictOrNull_0(_this__u8e3s4) {
        _init_properties_StringOps_kt__fcy1db();
        return equals_0(_this__u8e3s4, "true", true) ? true : equals_0(_this__u8e3s4, "false", true) ? false : null;
    }
    var properties_initialized_StringOps_kt_wzaea7;
    function _init_properties_StringOps_kt__fcy1db() {
        if (!properties_initialized_StringOps_kt_wzaea7) {
            properties_initialized_StringOps_kt_wzaea7 = true;
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.arrayOfNulls' call
            var this_0 = fillArrayVal(Array(93), null);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
            var inductionVariable = 0;
            if (inductionVariable <= 31) do {
                var c = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var c1 = toHexChar(c >> 12);
                var c2 = toHexChar(c >> 8);
                var c3 = toHexChar(c >> 4);
                var c4 = toHexChar(c);
                this_0[c] = "\\u" + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
            }while (inductionVariable <= 31);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(34);
            this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(92);
            this_0[Char__toInt_impl_vasixd(this_2)] = "\\\\";
            // Inline function 'kotlin.code' call
            var this_3 = _Char___init__impl__6a9atx(9);
            this_0[Char__toInt_impl_vasixd(this_3)] = "\\t";
            // Inline function 'kotlin.code' call
            var this_4 = _Char___init__impl__6a9atx(8);
            this_0[Char__toInt_impl_vasixd(this_4)] = "\\b";
            // Inline function 'kotlin.code' call
            var this_5 = _Char___init__impl__6a9atx(10);
            this_0[Char__toInt_impl_vasixd(this_5)] = "\\n";
            // Inline function 'kotlin.code' call
            var this_6 = _Char___init__impl__6a9atx(13);
            this_0[Char__toInt_impl_vasixd(this_6)] = "\\r";
            this_0[12] = "\\f";
            ESCAPE_STRINGS = this_0;
            // Inline function 'kotlin.apply' call
            var this_7 = new Int8Array(93);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
            var inductionVariable_0 = 0;
            if (inductionVariable_0 <= 31) do {
                var c_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this_7[c_0] = 1;
            }while (inductionVariable_0 <= 31);
            // Inline function 'kotlin.code' call
            var this_8 = _Char___init__impl__6a9atx(34);
            this_7[Char__toInt_impl_vasixd(this_8)] = 34;
            // Inline function 'kotlin.code' call
            var this_9 = _Char___init__impl__6a9atx(92);
            this_7[Char__toInt_impl_vasixd(this_9)] = 92;
            // Inline function 'kotlin.code' call
            var this_10 = _Char___init__impl__6a9atx(9);
            this_7[Char__toInt_impl_vasixd(this_10)] = 116;
            // Inline function 'kotlin.code' call
            var this_11 = _Char___init__impl__6a9atx(8);
            this_7[Char__toInt_impl_vasixd(this_11)] = 98;
            // Inline function 'kotlin.code' call
            var this_12 = _Char___init__impl__6a9atx(10);
            this_7[Char__toInt_impl_vasixd(this_12)] = 110;
            // Inline function 'kotlin.code' call
            var this_13 = _Char___init__impl__6a9atx(13);
            this_7[Char__toInt_impl_vasixd(this_13)] = 114;
            this_7[12] = 102;
            ESCAPE_MARKERS = this_7;
        }
    }
    function readJson(_this__u8e3s4, element, deserializer) {
        var tmp;
        if (element instanceof JsonObject) tmp = new JsonTreeDecoder(_this__u8e3s4, element);
        else if (element instanceof JsonArray) tmp = new JsonTreeListDecoder(_this__u8e3s4, element);
        else {
            var tmp_0;
            if (element instanceof JsonLiteral) tmp_0 = true;
            else tmp_0 = equals(element, JsonNull_getInstance());
            if (tmp_0) tmp = new JsonPrimitiveDecoder(_this__u8e3s4, element instanceof JsonPrimitive ? element : THROW_CCE());
            else noWhenBranchMatchedException();
        }
        var input = tmp;
        return input.kr(deserializer);
    }
    function unparsedPrimitive($this, primitive) {
        throw JsonDecodingException_0(-1, "Failed to parse literal as '" + primitive + "' value", toString($this.z1g()));
    }
    function asLiteral(_this__u8e3s4, $this, type) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) throw JsonDecodingException_1(-1, "Unexpected 'null' literal when non-nullable " + type + " was expected");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function AbstractJsonTreeDecoder(json, value) {
        NamedValueDecoder.call(this);
        this.w1g_1 = json;
        this.x1g_1 = value;
        this.y1g_1 = this.a1b().x18_1;
    }
    protoOf(AbstractJsonTreeDecoder).a1b = function() {
        return this.w1g_1;
    };
    protoOf(AbstractJsonTreeDecoder).b1 = function() {
        return this.x1g_1;
    };
    protoOf(AbstractJsonTreeDecoder).dp = function() {
        return this.a1b().dp();
    };
    protoOf(AbstractJsonTreeDecoder).z1g = function() {
        var tmp0_safe_receiver = this.m15();
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
        tmp = this.a1h(tmp0_safe_receiver);
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.b1() : tmp1_elvis_lhs;
    };
    protoOf(AbstractJsonTreeDecoder).y1a = function() {
        return this.z1g();
    };
    protoOf(AbstractJsonTreeDecoder).kr = function(deserializer) {
        return decodeSerializableValuePolymorphic(this, deserializer);
    };
    protoOf(AbstractJsonTreeDecoder).n15 = function(parentName, childName) {
        return childName;
    };
    protoOf(AbstractJsonTreeDecoder).lr = function(descriptor) {
        var currentObject = this.z1g();
        var tmp0_subject = descriptor.sp();
        var tmp;
        var tmp_0;
        if (equals(tmp0_subject, LIST_getInstance())) tmp_0 = true;
        else tmp_0 = tmp0_subject instanceof PolymorphicKind;
        if (tmp_0) {
            var tmp_1 = this.a1b();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject instanceof JsonArray)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonArray)) + " as the serialized body of " + descriptor.zo() + ", but had " + toString(getKClassFromExpression(currentObject)));
            tmp = new JsonTreeListDecoder(tmp_1, currentObject);
        } else if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.a1b();
            var keyDescriptor = carrierDescriptor(descriptor.up(0), this_0.dp());
            var keyKind = keyDescriptor.sp();
            var tmp_2;
            var tmp_3;
            if (keyKind instanceof PrimitiveKind) tmp_3 = true;
            else tmp_3 = equals(keyKind, ENUM_getInstance());
            if (tmp_3) {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
                var tmp_4 = this.a1b();
                // Inline function 'kotlinx.serialization.json.internal.cast' call
                if (!(currentObject instanceof JsonObject)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonObject)) + " as the serialized body of " + descriptor.zo() + ", but had " + toString(getKClassFromExpression(currentObject)));
                tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject);
            } else {
                if (this_0.x18_1.l1a_1) {
                    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
                    var tmp_5 = this.a1b();
                    // Inline function 'kotlinx.serialization.json.internal.cast' call
                    if (!(currentObject instanceof JsonArray)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonArray)) + " as the serialized body of " + descriptor.zo() + ", but had " + toString(getKClassFromExpression(currentObject)));
                    tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject);
                } else throw InvalidKeyKindException(keyDescriptor);
            }
            tmp = tmp_2;
        } else {
            var tmp_6 = this.a1b();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject instanceof JsonObject)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonObject)) + " as the serialized body of " + descriptor.zo() + ", but had " + toString(getKClassFromExpression(currentObject)));
            tmp = new JsonTreeDecoder(tmp_6, currentObject);
        }
        return tmp;
    };
    protoOf(AbstractJsonTreeDecoder).mr = function(descriptor) {};
    protoOf(AbstractJsonTreeDecoder).wq = function() {
        var tmp = this.z1g();
        return !(tmp instanceof JsonNull);
    };
    protoOf(AbstractJsonTreeDecoder).b1h = function(tag) {
        var currentElement = this.a1h(tag);
        var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
        var tmp;
        if (tmp0_elvis_lhs == null) throw JsonDecodingException_0(-1, "Expected JsonPrimitive at " + tag + ", found " + toString(currentElement), toString(this.z1g()));
        else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(AbstractJsonTreeDecoder).c1h = function(tag, enumDescriptor) {
        return getJsonNameIndexOrThrow(enumDescriptor, this.a1b(), this.b1h(tag).e1b());
    };
    protoOf(AbstractJsonTreeDecoder).v16 = function(tag, enumDescriptor) {
        return this.c1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), enumDescriptor);
    };
    protoOf(AbstractJsonTreeDecoder).d1h = function(tag) {
        return !(this.a1h(tag) === JsonNull_getInstance());
    };
    protoOf(AbstractJsonTreeDecoder).l16 = function(tag) {
        return this.d1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).e1h = function(tag) {
        var value = this.b1h(tag);
        if (!this.a1b().x18_1.k1a_1) {
            var literal = asLiteral(value, this, "boolean");
            if (literal.l1b_1) throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.z1g()));
        }
        var tmp$ret$1;
        $l$block: // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
        try {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedBoolean.<anonymous>' call
            var tmp0_elvis_lhs = get_booleanOrNull(value);
            var tmp;
            if (tmp0_elvis_lhs == null) throw IllegalArgumentException_init_$Create$_0();
            else tmp = tmp0_elvis_lhs;
            var tmp0_elvis_lhs_0 = tmp;
            var tmp_0;
            if (tmp0_elvis_lhs_0 == null) unparsedPrimitive(this, "boolean");
            else tmp_0 = tmp0_elvis_lhs_0;
            tmp$ret$1 = tmp_0;
            break $l$block;
        } catch ($p) {
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                unparsedPrimitive(this, "boolean");
            } else throw $p;
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).m16 = function(tag) {
        return this.e1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).f1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
                var result = get_int(this_0);
                var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "byte");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "byte");
                } else throw $p;
            }
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).n16 = function(tag) {
        return this.f1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).g1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
                var result = get_int(this_0);
                var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "short");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "short");
                } else throw $p;
            }
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).o16 = function(tag) {
        return this.g1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).h1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
                var tmp0_elvis_lhs = get_int(this_0);
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "int");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "int");
                } else throw $p;
            }
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).p16 = function(tag) {
        return this.h1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).i1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
                var tmp0_elvis_lhs = get_long(this_0);
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "long");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "long");
                } else throw $p;
            }
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).q16 = function(tag) {
        return this.i1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).j1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
                var tmp0_elvis_lhs = get_float(this_0);
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "float");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "float");
                } else throw $p;
            }
        }
        var result = tmp$ret$1;
        var specialFp = this.a1b().x18_1.s1a_1;
        if (specialFp || isFinite(result)) return result;
        throw InvalidFloatingPointDecoded(result, tag, toString(this.z1g()));
    };
    protoOf(AbstractJsonTreeDecoder).r16 = function(tag) {
        return this.j1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).k1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
                var tmp0_elvis_lhs = get_double(this_0);
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "double");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "double");
                } else throw $p;
            }
        }
        var result = tmp$ret$1;
        var specialFp = this.a1b().x18_1.s1a_1;
        if (specialFp || isFinite_0(result)) return result;
        throw InvalidFloatingPointDecoded(result, tag, toString(this.z1g()));
    };
    protoOf(AbstractJsonTreeDecoder).s16 = function(tag) {
        return this.k1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).l1h = function(tag) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
            var this_0 = this.b1h(tag);
            try {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
                var tmp0_elvis_lhs = new Char(single(this_0.e1b()));
                var tmp;
                if (tmp0_elvis_lhs == null) unparsedPrimitive(this, "char");
                else tmp = tmp0_elvis_lhs;
                tmp$ret$1 = tmp.o1_1;
                break $l$block;
            } catch ($p) {
                if ($p instanceof IllegalArgumentException) {
                    var e = $p;
                    unparsedPrimitive(this, "char");
                } else throw $p;
            }
        }
        return tmp$ret$1;
    };
    protoOf(AbstractJsonTreeDecoder).t16 = function(tag) {
        return this.l1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).m1h = function(tag) {
        var value = this.b1h(tag);
        if (!this.a1b().x18_1.k1a_1) {
            var literal = asLiteral(value, this, "string");
            if (!literal.l1b_1) throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.z1g()));
        }
        if (value instanceof JsonNull) throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString(this.z1g()));
        return value.e1b();
    };
    protoOf(AbstractJsonTreeDecoder).u16 = function(tag) {
        return this.m1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeDecoder).n1h = function(tag, inlineDescriptor) {
        return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer(this.b1h(tag).e1b()), this.a1b()) : protoOf(NamedValueDecoder).w16.call(this, tag, inlineDescriptor);
    };
    protoOf(AbstractJsonTreeDecoder).w16 = function(tag, inlineDescriptor) {
        return this.n1h((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), inlineDescriptor);
    };
    protoOf(AbstractJsonTreeDecoder).ir = function(descriptor) {
        return !(this.m15() == null) ? protoOf(NamedValueDecoder).ir.call(this, descriptor) : new JsonPrimitiveDecoder(this.a1b(), this.b1()).ir(descriptor);
    };
    function coerceInputValue_0($this, descriptor, index, tag) {
        var tmp$ret$1;
        $l$block_2: {
            // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
            var this_0 = $this.a1b();
            var elementDescriptor = descriptor.up(index);
            var tmp;
            if (!elementDescriptor.lp()) {
                // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
                var tmp_0 = $this.a1h(tag);
                tmp = tmp_0 instanceof JsonNull;
            } else tmp = false;
            if (tmp) {
                tmp$ret$1 = true;
                break $l$block_2;
            }
            if (equals(elementDescriptor.sp(), ENUM_getInstance())) {
                var tmp_1;
                if (elementDescriptor.lp()) {
                    // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
                    var tmp_2 = $this.a1h(tag);
                    tmp_1 = tmp_2 instanceof JsonNull;
                } else tmp_1 = false;
                if (tmp_1) {
                    tmp$ret$1 = false;
                    break $l$block_2;
                }
                // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
                var tmp_3 = $this.a1h(tag);
                var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
                var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
                var tmp_4;
                if (tmp0_elvis_lhs == null) {
                    tmp$ret$1 = false;
                    break $l$block_2;
                } else tmp_4 = tmp0_elvis_lhs;
                var enumValue = tmp_4;
                var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
                if (enumIndex === -3) {
                    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
                    tmp$ret$1 = true;
                    break $l$block_2;
                }
            }
            tmp$ret$1 = false;
        }
        return tmp$ret$1;
    }
    function absenceIsNull($this, descriptor, index) {
        $this.x1h_1 = !$this.a1b().x18_1.n1a_1 && !descriptor.xp(index) && descriptor.up(index).lp();
        return $this.x1h_1;
    }
    function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
        polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
        polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
        AbstractJsonTreeDecoder.call(this, json, value);
        this.t1h_1 = value;
        this.u1h_1 = polyDiscriminator;
        this.v1h_1 = polyDescriptor;
        this.w1h_1 = 0;
        this.x1h_1 = false;
    }
    protoOf(JsonTreeDecoder).b1 = function() {
        return this.t1h_1;
    };
    protoOf(JsonTreeDecoder).bs = function(descriptor) {
        while(this.w1h_1 < descriptor.qp()){
            var tmp1 = this.w1h_1;
            this.w1h_1 = tmp1 + 1 | 0;
            var name = this.i15(descriptor, tmp1);
            var index = this.w1h_1 - 1 | 0;
            this.x1h_1 = false;
            var tmp;
            var tmp_0;
            // Inline function 'kotlin.collections.contains' call
            // Inline function 'kotlin.collections.containsKey' call
            var this_0 = this.b1();
            if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c2(name)) tmp_0 = true;
            else tmp_0 = absenceIsNull(this, descriptor, index);
            if (tmp_0) tmp = !this.y1g_1.p1a_1 || !coerceInputValue_0(this, descriptor, index, name);
            else tmp = false;
            if (tmp) return index;
        }
        return -1;
    };
    protoOf(JsonTreeDecoder).wq = function() {
        return !this.x1h_1 && protoOf(AbstractJsonTreeDecoder).wq.call(this);
    };
    protoOf(JsonTreeDecoder).j15 = function(descriptor, index) {
        var strategy = namingStrategy(descriptor, this.a1b());
        var baseName = descriptor.wp(index);
        if (strategy == null) {
            if (!this.y1g_1.t1a_1) return baseName;
            if (this.b1().f2().a2(baseName)) return baseName;
        }
        var deserializationNamesMap_0 = deserializationNamesMap(this.a1b(), descriptor);
        // Inline function 'kotlin.collections.find' call
        var this_0 = this.b1().f2();
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
                if (deserializationNamesMap_0.e2(element) === index) {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return tmp0_safe_receiver;
        var fallbackName = strategy == null ? null : strategy.r1d(descriptor, index, baseName);
        return fallbackName == null ? baseName : fallbackName;
    };
    protoOf(JsonTreeDecoder).a1h = function(tag) {
        return getValue(this.b1(), tag);
    };
    protoOf(JsonTreeDecoder).lr = function(descriptor) {
        if (descriptor === this.v1h_1) {
            var tmp = this.a1b();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var value = this.z1g();
            var descriptor_0 = this.v1h_1;
            if (!(value instanceof JsonObject)) throw JsonDecodingException_1(-1, "Expected " + toString(getKClass(JsonObject)) + " as the serialized body of " + descriptor_0.zo() + ", but had " + toString(getKClassFromExpression(value)));
            return new JsonTreeDecoder(tmp, value, this.u1h_1, this.v1h_1);
        }
        return protoOf(AbstractJsonTreeDecoder).lr.call(this, descriptor);
    };
    protoOf(JsonTreeDecoder).mr = function(descriptor) {
        var tmp;
        if (this.y1g_1.j1a_1) tmp = true;
        else {
            var tmp_0 = descriptor.sp();
            tmp = tmp_0 instanceof PolymorphicKind;
        }
        if (tmp) return Unit_instance;
        var strategy = namingStrategy(descriptor, this.a1b());
        var tmp_1;
        if (strategy == null && !this.y1g_1.t1a_1) tmp_1 = jsonCachedSerialNames(descriptor);
        else if (!(strategy == null)) tmp_1 = deserializationNamesMap(this.a1b(), descriptor).f2();
        else {
            var tmp_2 = jsonCachedSerialNames(descriptor);
            // Inline function 'kotlin.collections.orEmpty' call
            var tmp0_safe_receiver = get_schemaCache(this.a1b()).a1g(descriptor, get_JsonDeserializationNamesKey());
            var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f2();
            var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
            tmp_1 = plus_0(tmp_2, tmp$ret$0);
        }
        var names = tmp_1;
        var tmp1_iterator = this.b1().f2().j();
        while(tmp1_iterator.k()){
            var key = tmp1_iterator.l();
            if (!names.a2(key) && !(key === this.u1h_1)) throw UnknownKeyException(key, this.b1().toString());
        }
    };
    function JsonTreeListDecoder(json, value) {
        AbstractJsonTreeDecoder.call(this, json, value);
        this.d1i_1 = value;
        this.e1i_1 = this.d1i_1.m();
        this.f1i_1 = -1;
    }
    protoOf(JsonTreeListDecoder).b1 = function() {
        return this.d1i_1;
    };
    protoOf(JsonTreeListDecoder).j15 = function(descriptor, index) {
        return index.toString();
    };
    protoOf(JsonTreeListDecoder).a1h = function(tag) {
        return this.d1i_1.o(toInt(tag));
    };
    protoOf(JsonTreeListDecoder).bs = function(descriptor) {
        while(this.f1i_1 < (this.e1i_1 - 1 | 0)){
            this.f1i_1 = this.f1i_1 + 1 | 0;
            return this.f1i_1;
        }
        return -1;
    };
    function JsonPrimitiveDecoder(json, value) {
        AbstractJsonTreeDecoder.call(this, json, value);
        this.l1i_1 = value;
        this.e16("primitive");
    }
    protoOf(JsonPrimitiveDecoder).b1 = function() {
        return this.l1i_1;
    };
    protoOf(JsonPrimitiveDecoder).bs = function(descriptor) {
        return 0;
    };
    protoOf(JsonPrimitiveDecoder).a1h = function(tag) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(tag === "primitive")) {
            // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
            var message = "This input can only handle primitives with 'primitive' tag";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return this.l1i_1;
    };
    function JsonTreeMapDecoder(json, value) {
        JsonTreeDecoder.call(this, json, value);
        this.w1i_1 = value;
        this.x1i_1 = toList(this.w1i_1.f2());
        this.y1i_1 = imul(this.x1i_1.m(), 2);
        this.z1i_1 = -1;
    }
    protoOf(JsonTreeMapDecoder).b1 = function() {
        return this.w1i_1;
    };
    protoOf(JsonTreeMapDecoder).j15 = function(descriptor, index) {
        var i = index / 2 | 0;
        return this.x1i_1.o(i);
    };
    protoOf(JsonTreeMapDecoder).bs = function(descriptor) {
        while(this.z1i_1 < (this.y1i_1 - 1 | 0)){
            this.z1i_1 = this.z1i_1 + 1 | 0;
            return this.z1i_1;
        }
        return -1;
    };
    protoOf(JsonTreeMapDecoder).a1h = function(tag) {
        return (this.z1i_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.w1i_1, tag);
    };
    protoOf(JsonTreeMapDecoder).mr = function(descriptor) {};
    function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
        return new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.yn()).kr(deserializer);
    }
    function writeJson(_this__u8e3s4, value, serializer) {
        var result = {
            _v: null
        };
        var encoder = new JsonTreeEncoder(_this__u8e3s4, writeJson$lambda(result));
        encoder.ct(serializer, value);
        var tmp;
        if (result._v == null) throwUninitializedPropertyAccessException("result");
        else tmp = result._v;
        return tmp;
    }
    function JsonTreeEncoder(json, nodeConsumer) {
        AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
        var tmp = this;
        // Inline function 'kotlin.collections.linkedMapOf' call
        tmp.k1j_1 = LinkedHashMap_init_$Create$();
    }
    protoOf(JsonTreeEncoder).l1j = function(key, element) {
        // Inline function 'kotlin.collections.set' call
        this.k1j_1.m2(key, element);
    };
    protoOf(JsonTreeEncoder).dt = function(descriptor, index, serializer, value) {
        if (!(value == null) || this.d1j_1.n1a_1) protoOf(AbstractJsonTreeEncoder).dt.call(this, descriptor, index, serializer, value);
    };
    protoOf(JsonTreeEncoder).m1j = function() {
        return new JsonObject(this.k1j_1);
    };
    function inlineUnsignedNumberEncoder($this, tag) {
        return new AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1($this, tag);
    }
    function inlineUnquotedLiteralEncoder($this, tag, inlineDescriptor) {
        return new AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1($this, tag, inlineDescriptor);
    }
    function AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1(this$0, $tag) {
        this.b1k_1 = this$0;
        this.c1k_1 = $tag;
        AbstractEncoder.call(this);
        this.a1k_1 = this$0.b1j_1.dp();
    }
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).dp = function() {
        return this.a1k_1;
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).d1k = function(s) {
        return this.b1k_1.l1j(this.c1k_1, new JsonLiteral(s, false));
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).js = function(value) {
        // Inline function 'kotlin.toUInt' call
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
        return this.d1k(UInt__toString_impl_dbgl21(tmp$ret$0));
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).ks = function(value) {
        // Inline function 'kotlin.toULong' call
        var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
        return this.d1k(ULong__toString_impl_f9au7k(tmp$ret$0));
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).hs = function(value) {
        // Inline function 'kotlin.toUByte' call
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
        return this.d1k(UByte__toString_impl_v72jg(tmp$ret$0));
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).is = function(value) {
        // Inline function 'kotlin.toUShort' call
        var tmp$ret$0 = _UShort___init__impl__jigrne(value);
        return this.d1k(UShort__toString_impl_edaoee(tmp$ret$0));
    };
    function AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1(this$0, $tag, $inlineDescriptor) {
        this.e1k_1 = this$0;
        this.f1k_1 = $tag;
        this.g1k_1 = $inlineDescriptor;
        AbstractEncoder.call(this);
    }
    protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).dp = function() {
        return this.e1k_1.b1j_1.dp();
    };
    protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).os = function(value) {
        return this.e1k_1.l1j(this.f1k_1, new JsonLiteral(value, false, this.g1k_1));
    };
    function AbstractJsonTreeEncoder$beginStructure$lambda(this$0) {
        return function(node) {
            this$0.l1j(this$0.d16(), node);
            return Unit_instance;
        };
    }
    function AbstractJsonTreeEncoder(json, nodeConsumer) {
        NamedValueEncoder.call(this);
        this.b1j_1 = json;
        this.c1j_1 = nodeConsumer;
        this.d1j_1 = this.b1j_1.x18_1;
        this.e1j_1 = null;
    }
    protoOf(AbstractJsonTreeEncoder).a1b = function() {
        return this.b1j_1;
    };
    protoOf(AbstractJsonTreeEncoder).dp = function() {
        return this.b1j_1.dp();
    };
    protoOf(AbstractJsonTreeEncoder).j15 = function(descriptor, index) {
        return getJsonElementName(descriptor, this.b1j_1, index);
    };
    protoOf(AbstractJsonTreeEncoder).ht = function(descriptor, index) {
        return this.d1j_1.i1a_1;
    };
    protoOf(AbstractJsonTreeEncoder).n15 = function(parentName, childName) {
        return childName;
    };
    protoOf(AbstractJsonTreeEncoder).ft = function() {};
    protoOf(AbstractJsonTreeEncoder).fs = function() {
        var tmp0_elvis_lhs = this.m15();
        var tmp;
        if (tmp0_elvis_lhs == null) return this.c1j_1(JsonNull_getInstance());
        else tmp = tmp0_elvis_lhs;
        var tag = tmp;
        this.n1j(tag);
    };
    protoOf(AbstractJsonTreeEncoder).n1j = function(tag) {
        return this.l1j(tag, JsonNull_getInstance());
    };
    protoOf(AbstractJsonTreeEncoder).q15 = function(tag) {
        return this.n1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE());
    };
    protoOf(AbstractJsonTreeEncoder).o1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_1(value));
    };
    protoOf(AbstractJsonTreeEncoder).r15 = function(tag, value) {
        return this.o1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).p1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_1(value));
    };
    protoOf(AbstractJsonTreeEncoder).s15 = function(tag, value) {
        return this.p1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).q1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_1(value));
    };
    protoOf(AbstractJsonTreeEncoder).t15 = function(tag, value) {
        return this.q1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).r1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_1(value));
    };
    protoOf(AbstractJsonTreeEncoder).u15 = function(tag, value) {
        return this.r1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).s1j = function(tag, value) {
        this.l1j(tag, JsonPrimitive_1(value));
        if (!this.d1j_1.s1a_1 && !isFinite(value)) throw InvalidFloatingPointEncoded(value, tag, toString(this.m1j()));
    };
    protoOf(AbstractJsonTreeEncoder).v15 = function(tag, value) {
        return this.s1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).ct = function(serializer, value) {
        if (!(this.m15() == null) || !get_requiresTopLevelTag(carrierDescriptor(serializer.yn(), this.dp()))) $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
            var tmp;
            if (!(serializer instanceof AbstractPolymorphicSerializer)) tmp = true;
            else tmp = this.a1b().x18_1.q1a_1;
            if (tmp) {
                serializer.zn(this, value);
                break $l$block;
            }
            var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
            var baseClassDiscriminator = classDiscriminator(serializer.yn(), this.a1b());
            var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
            validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
            checkKind(actualSerializer.yn().sp());
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
            this.e1j_1 = baseClassDiscriminator;
            actualSerializer.zn(this, value);
        }
        else // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
        new JsonPrimitiveEncoder(this.b1j_1, this.c1j_1).ct(serializer, value);
    };
    protoOf(AbstractJsonTreeEncoder).t1j = function(tag, value) {
        this.l1j(tag, JsonPrimitive_1(value));
        if (!this.d1j_1.s1a_1 && !isFinite_0(value)) throw InvalidFloatingPointEncoded(value, tag, toString(this.m1j()));
    };
    protoOf(AbstractJsonTreeEncoder).w15 = function(tag, value) {
        return this.t1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).u1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_2(value));
    };
    protoOf(AbstractJsonTreeEncoder).x15 = function(tag, value) {
        return this.u1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).v1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_0(toString_1(value)));
    };
    protoOf(AbstractJsonTreeEncoder).y15 = function(tag, value) {
        return this.v1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).w1j = function(tag, value) {
        return this.l1j(tag, JsonPrimitive_0(value));
    };
    protoOf(AbstractJsonTreeEncoder).z15 = function(tag, value) {
        return this.w1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).x1j = function(tag, enumDescriptor, ordinal) {
        return this.l1j(tag, JsonPrimitive_0(enumDescriptor.wp(ordinal)));
    };
    protoOf(AbstractJsonTreeEncoder).a16 = function(tag, enumDescriptor, ordinal) {
        return this.x1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
    };
    protoOf(AbstractJsonTreeEncoder).y1j = function(tag, value) {
        this.l1j(tag, JsonPrimitive_0(toString(value)));
    };
    protoOf(AbstractJsonTreeEncoder).o15 = function(tag, value) {
        return this.y1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), value);
    };
    protoOf(AbstractJsonTreeEncoder).z1j = function(tag, inlineDescriptor) {
        return get_isUnsignedNumber(inlineDescriptor) ? inlineUnsignedNumberEncoder(this, tag) : get_isUnquotedLiteral(inlineDescriptor) ? inlineUnquotedLiteralEncoder(this, tag, inlineDescriptor) : protoOf(NamedValueEncoder).b16.call(this, tag, inlineDescriptor);
    };
    protoOf(AbstractJsonTreeEncoder).b16 = function(tag, inlineDescriptor) {
        return this.z1j((!(tag == null) ? typeof tag === "string" : false) ? tag : THROW_CCE(), inlineDescriptor);
    };
    protoOf(AbstractJsonTreeEncoder).qs = function(descriptor) {
        return !(this.m15() == null) ? protoOf(NamedValueEncoder).qs.call(this, descriptor) : new JsonPrimitiveEncoder(this.b1j_1, this.c1j_1).qs(descriptor);
    };
    protoOf(AbstractJsonTreeEncoder).lr = function(descriptor) {
        var tmp;
        if (this.m15() == null) tmp = this.c1j_1;
        else tmp = AbstractJsonTreeEncoder$beginStructure$lambda(this);
        var consumer = tmp;
        var tmp0_subject = descriptor.sp();
        var tmp_0;
        var tmp_1;
        if (equals(tmp0_subject, LIST_getInstance())) tmp_1 = true;
        else tmp_1 = tmp0_subject instanceof PolymorphicKind;
        if (tmp_1) tmp_0 = new JsonTreeListEncoder(this.b1j_1, consumer);
        else if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.b1j_1;
            var keyDescriptor = carrierDescriptor(descriptor.up(0), this_0.dp());
            var keyKind = keyDescriptor.sp();
            var tmp_2;
            var tmp_3;
            if (keyKind instanceof PrimitiveKind) tmp_3 = true;
            else tmp_3 = equals(keyKind, ENUM_getInstance());
            if (tmp_3) // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
            tmp_2 = new JsonTreeMapEncoder(this.b1j_1, consumer);
            else {
                if (this_0.x18_1.l1a_1) // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
                tmp_2 = new JsonTreeListEncoder(this.b1j_1, consumer);
                else throw InvalidKeyKindException(keyDescriptor);
            }
            tmp_0 = tmp_2;
        } else tmp_0 = new JsonTreeEncoder(this.b1j_1, consumer);
        var encoder = tmp_0;
        if (!(this.e1j_1 == null)) {
            encoder.l1j(ensureNotNull(this.e1j_1), JsonPrimitive_0(descriptor.zo()));
            this.e1j_1 = null;
        }
        return encoder;
    };
    protoOf(AbstractJsonTreeEncoder).c16 = function(descriptor) {
        this.c1j_1(this.m1j());
    };
    function get_requiresTopLevelTag(_this__u8e3s4) {
        var tmp;
        var tmp_0 = _this__u8e3s4.sp();
        if (tmp_0 instanceof PrimitiveKind) tmp = true;
        else tmp = _this__u8e3s4.sp() === ENUM_getInstance();
        return tmp;
    }
    function JsonPrimitiveEncoder(json, nodeConsumer) {
        AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
        this.m1k_1 = null;
        this.e16("primitive");
    }
    protoOf(JsonPrimitiveEncoder).l1j = function(key, element) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(key === "primitive")) {
            // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
            var message = "This output can only consume primitives with 'primitive' tag";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.m1k_1 == null)) {
            // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
            var message_0 = "Primitive element was already recorded. Does call to .encodeXxx happen more than once?";
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        this.m1k_1 = element;
        this.c1j_1(element);
    };
    protoOf(JsonPrimitiveEncoder).m1j = function() {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.requireNotNull' call
            var value = this.m1k_1;
            // Inline function 'kotlin.contracts.contract' call
            if (value == null) {
                // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.getCurrent.<anonymous>' call
                var message = "Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?";
                throw IllegalArgumentException_init_$Create$(toString(message));
            } else {
                tmp$ret$1 = value;
                break $l$block;
            }
        }
        return tmp$ret$1;
    };
    function JsonTreeListEncoder(json, nodeConsumer) {
        AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.s1k_1 = ArrayList_init_$Create$();
    }
    protoOf(JsonTreeListEncoder).j15 = function(descriptor, index) {
        return index.toString();
    };
    protoOf(JsonTreeListEncoder).l1j = function(key, element) {
        var idx = toInt(key);
        this.s1k_1.k2(idx, element);
    };
    protoOf(JsonTreeListEncoder).m1j = function() {
        return new JsonArray(this.s1k_1);
    };
    function _get_tag__e6h4qf($this) {
        var tmp = $this.z1k_1;
        if (!(tmp == null)) return tmp;
        else throwUninitializedPropertyAccessException("tag");
    }
    function JsonTreeMapEncoder(json, nodeConsumer) {
        JsonTreeEncoder.call(this, json, nodeConsumer);
        this.a1l_1 = true;
    }
    protoOf(JsonTreeMapEncoder).l1j = function(key, element) {
        if (this.a1l_1) {
            var tmp = this;
            var tmp_0;
            if (element instanceof JsonPrimitive) tmp_0 = element.e1b();
            else {
                if (element instanceof JsonObject) throw InvalidKeyKindException(JsonObjectSerializer_getInstance().s1b_1);
                else {
                    if (element instanceof JsonArray) throw InvalidKeyKindException(JsonArraySerializer_getInstance().t1b_1);
                    else noWhenBranchMatchedException();
                }
            }
            tmp.z1k_1 = tmp_0;
            this.a1l_1 = false;
        } else {
            // Inline function 'kotlin.collections.set' call
            var this_0 = this.k1j_1;
            var key_0 = _get_tag__e6h4qf(this);
            this_0.m2(key_0, element);
            this.a1l_1 = true;
        }
    };
    protoOf(JsonTreeMapEncoder).m1j = function() {
        return new JsonObject(this.k1j_1);
    };
    function writeJson$lambda($result) {
        return function(it) {
            $result._v = it;
            return Unit_instance;
        };
    }
    var WriteMode_OBJ_instance;
    var WriteMode_LIST_instance;
    var WriteMode_MAP_instance;
    var WriteMode_POLY_OBJ_instance;
    function values() {
        return [
            WriteMode_OBJ_getInstance(),
            WriteMode_LIST_getInstance(),
            WriteMode_MAP_getInstance(),
            WriteMode_POLY_OBJ_getInstance()
        ];
    }
    var WriteMode_entriesInitialized;
    function WriteMode_initEntries() {
        if (WriteMode_entriesInitialized) return Unit_instance;
        WriteMode_entriesInitialized = true;
        WriteMode_OBJ_instance = new WriteMode("OBJ", 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
        WriteMode_LIST_instance = new WriteMode("LIST", 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
        WriteMode_MAP_instance = new WriteMode("MAP", 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
        WriteMode_POLY_OBJ_instance = new WriteMode("POLY_OBJ", 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    }
    function WriteMode(name, ordinal, begin, end) {
        Enum.call(this, name, ordinal);
        this.n1g_1 = begin;
        this.o1g_1 = end;
    }
    function switchMode(_this__u8e3s4, desc) {
        var tmp0_subject = desc.sp();
        var tmp;
        if (tmp0_subject instanceof PolymorphicKind) tmp = WriteMode_POLY_OBJ_getInstance();
        else {
            if (equals(tmp0_subject, LIST_getInstance())) tmp = WriteMode_LIST_getInstance();
            else if (equals(tmp0_subject, MAP_getInstance())) {
                // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
                var keyDescriptor = carrierDescriptor(desc.up(0), _this__u8e3s4.dp());
                var keyKind = keyDescriptor.sp();
                var tmp_0;
                var tmp_1;
                if (keyKind instanceof PrimitiveKind) tmp_1 = true;
                else tmp_1 = equals(keyKind, ENUM_getInstance());
                if (tmp_1) // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
                tmp_0 = WriteMode_MAP_getInstance();
                else {
                    if (_this__u8e3s4.x18_1.l1a_1) // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
                    tmp_0 = WriteMode_LIST_getInstance();
                    else throw InvalidKeyKindException(keyDescriptor);
                }
                tmp = tmp_0;
            } else tmp = WriteMode_OBJ_getInstance();
        }
        return tmp;
    }
    function carrierDescriptor(_this__u8e3s4, module_0) {
        var tmp;
        if (equals(_this__u8e3s4.sp(), CONTEXTUAL_getInstance())) {
            var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
            tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
        } else if (_this__u8e3s4.rp()) tmp = carrierDescriptor(_this__u8e3s4.up(0), module_0);
        else tmp = _this__u8e3s4;
        return tmp;
    }
    function WriteMode_OBJ_getInstance() {
        WriteMode_initEntries();
        return WriteMode_OBJ_instance;
    }
    function WriteMode_LIST_getInstance() {
        WriteMode_initEntries();
        return WriteMode_LIST_instance;
    }
    function WriteMode_MAP_getInstance() {
        WriteMode_initEntries();
        return WriteMode_MAP_instance;
    }
    function WriteMode_POLY_OBJ_getInstance() {
        WriteMode_initEntries();
        return WriteMode_POLY_OBJ_instance;
    }
    function appendEscape($this, lastPosition, current) {
        $this.b1l(lastPosition, current);
        return appendEsc($this, current + 1 | 0);
    }
    function decodedString($this, lastPosition, currentPosition) {
        $this.b1l(lastPosition, currentPosition);
        var result = $this.q19_1.toString();
        $this.q19_1.vb(0);
        return result;
    }
    function takePeeked($this) {
        // Inline function 'kotlin.also' call
        var this_0 = ensureNotNull($this.p19_1);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
        $this.p19_1 = null;
        return this_0;
    }
    function wasUnquotedString($this) {
        return !(charSequenceGet($this.c1l(), $this.n19_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
    }
    function appendEsc($this, startPosition) {
        var currentPosition = startPosition;
        currentPosition = $this.d1l(currentPosition);
        if (currentPosition === -1) $this.n1d("Expected escape sequence to continue, got EOF");
        var tmp = $this.c1l();
        var tmp0 = currentPosition;
        currentPosition = tmp0 + 1 | 0;
        var currentChar = charSequenceGet(tmp, tmp0);
        if (currentChar === _Char___init__impl__6a9atx(117)) return appendHex($this, $this.c1l(), currentPosition);
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
        var c = escapeToChar(tmp$ret$0);
        if (c === _Char___init__impl__6a9atx(0)) $this.n1d("Invalid escaped char '" + toString_1(currentChar) + "'");
        $this.q19_1.f8(c);
        return currentPosition;
    }
    function appendHex($this, source, startPos) {
        if ((startPos + 4 | 0) >= charSequenceLength(source)) {
            $this.n19_1 = startPos;
            $this.e1l();
            if (($this.n19_1 + 4 | 0) >= charSequenceLength(source)) $this.n1d("Unexpected EOF during unicode escape");
            return appendHex($this, source, $this.n19_1);
        }
        $this.q19_1.f8(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
        return startPos + 4 | 0;
    }
    function fromHexChar($this, source, currentPosition) {
        var character = charSequenceGet(source, currentPosition);
        var tmp;
        if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
            // Inline function 'kotlin.code' call
            var tmp_0 = Char__toInt_impl_vasixd(character);
            // Inline function 'kotlin.code' call
            var this_0 = _Char___init__impl__6a9atx(48);
            tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
        } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
            // Inline function 'kotlin.code' call
            var tmp_1 = Char__toInt_impl_vasixd(character);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(97);
            tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
        } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
            // Inline function 'kotlin.code' call
            var tmp_2 = Char__toInt_impl_vasixd(character);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(65);
            tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
        } else $this.n1d("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
        return tmp;
    }
    function consumeBoolean2($this, start) {
        var current = $this.d1l(start);
        if (current >= charSequenceLength($this.c1l()) || current === -1) $this.n1d("EOF");
        // Inline function 'kotlin.code' call
        var tmp = $this.c1l();
        var tmp0 = current;
        current = tmp0 + 1 | 0;
        var this_0 = charSequenceGet(tmp, tmp0);
        var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
        var tmp_0;
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(116);
        if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
            consumeBooleanLiteral($this, "rue", current);
            tmp_0 = true;
        } else {
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(102);
            if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
                consumeBooleanLiteral($this, "alse", current);
                tmp_0 = false;
            } else $this.n1d("Expected valid boolean literal prefix, but had '" + $this.q1e() + "'");
        }
        return tmp_0;
    }
    function consumeBooleanLiteral($this, literalSuffix, current) {
        if ((charSequenceLength($this.c1l()) - current | 0) < literalSuffix.length) $this.n1d("Unexpected end of boolean literal");
        var inductionVariable = 0;
        var last = charSequenceLength(literalSuffix) - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var expected = charSequenceGet(literalSuffix, i);
            var actual = charSequenceGet($this.c1l(), current + i | 0);
            // Inline function 'kotlin.code' call
            var tmp = Char__toInt_impl_vasixd(expected);
            // Inline function 'kotlin.code' call
            if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) $this.n1d("Expected valid boolean literal prefix, but had '" + $this.q1e() + "'");
        }while (inductionVariable <= last);
        $this.n19_1 = current + literalSuffix.length | 0;
    }
    function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
        var tmp;
        switch(isExponentPositive){
            case false:
                // Inline function 'kotlin.math.pow' call
                var x = -exponentAccumulator.p3();
                tmp = Math.pow(10.0, x);
                break;
            case true:
                // Inline function 'kotlin.math.pow' call
                var x_0 = exponentAccumulator.p3();
                tmp = Math.pow(10.0, x_0);
                break;
            default:
                noWhenBranchMatchedException();
                break;
        }
        return tmp;
    }
    function AbstractJsonLexer() {
        this.n19_1 = 0;
        this.o19_1 = new JsonPath();
        this.p19_1 = null;
        this.q19_1 = StringBuilder_init_$Create$();
    }
    protoOf(AbstractJsonLexer).e1l = function() {};
    protoOf(AbstractJsonLexer).f1l = function(c) {
        return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
    };
    protoOf(AbstractJsonLexer).r19 = function() {
        var nextToken = this.s1e();
        if (!(nextToken === 10)) this.n1d("Expected EOF after parsing, but had " + toString_1(charSequenceGet(this.c1l(), this.n19_1 - 1 | 0)) + " instead");
    };
    protoOf(AbstractJsonLexer).m1e = function(expected) {
        var token = this.s1e();
        if (!(token === expected)) this.g1l(expected);
        return token;
    };
    protoOf(AbstractJsonLexer).c1g = function(expected) {
        this.e1l();
        var source = this.c1l();
        var cpos = this.n19_1;
        $l$loop_0: while(true){
            cpos = this.d1l(cpos);
            if (cpos === -1) break $l$loop_0;
            var tmp0 = cpos;
            cpos = tmp0 + 1 | 0;
            var c = charSequenceGet(source, tmp0);
            if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) continue $l$loop_0;
            this.n19_1 = cpos;
            if (c === expected) return Unit_instance;
            this.h1l(expected);
        }
        this.n19_1 = cpos;
        this.h1l(expected);
    };
    protoOf(AbstractJsonLexer).h1l = function(expected) {
        if (this.n19_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
            var tmp$ret$1;
            $l$block: {
                // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
                var snapshot = this.n19_1;
                try {
                    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.unexpectedToken.<anonymous>' call
                    this.n19_1 = this.n19_1 - 1 | 0;
                    tmp$ret$1 = this.q1e();
                    break $l$block;
                } finally{
                    this.n19_1 = snapshot;
                }
            }
            var inputLiteral = tmp$ret$1;
            if (inputLiteral === "null") this.i1l("Expected string literal but 'null' literal was found", this.n19_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls to default values.");
        }
        this.g1l(charToTokenClass(expected));
    };
    protoOf(AbstractJsonLexer).j1l = function(expectedToken, wasConsumed) {
        var expected = tokenDescription(expectedToken);
        var position = wasConsumed ? this.n19_1 - 1 | 0 : this.n19_1;
        var s = this.n19_1 === charSequenceLength(this.c1l()) || position < 0 ? "EOF" : toString_1(charSequenceGet(this.c1l(), position));
        this.n1d("Expected " + expected + ", but had '" + s + "' instead", position);
    };
    protoOf(AbstractJsonLexer).g1l = function(expectedToken, wasConsumed, $super) {
        wasConsumed = wasConsumed === VOID ? true : wasConsumed;
        return $super === VOID ? this.j1l(expectedToken, wasConsumed) : $super.j1l.call(this, expectedToken, wasConsumed);
    };
    protoOf(AbstractJsonLexer).n1e = function() {
        var source = this.c1l();
        var cpos = this.n19_1;
        $l$loop_0: while(true){
            cpos = this.d1l(cpos);
            if (cpos === -1) break $l$loop_0;
            var ch = charSequenceGet(source, cpos);
            if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
                cpos = cpos + 1 | 0;
                continue $l$loop_0;
            }
            this.n19_1 = cpos;
            return charToTokenClass(ch);
        }
        this.n19_1 = cpos;
        return 10;
    };
    protoOf(AbstractJsonLexer).e1g = function(doConsume) {
        var current = this.k1l();
        current = this.d1l(current);
        var len = charSequenceLength(this.c1l()) - current | 0;
        if (len < 4 || current === -1) return false;
        var inductionVariable = 0;
        if (inductionVariable <= 3) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(charSequenceGet("null", i) === charSequenceGet(this.c1l(), current + i | 0))) return false;
        }while (inductionVariable <= 3);
        if (len > 4 && charToTokenClass(charSequenceGet(this.c1l(), current + 4 | 0)) === 0) return false;
        if (doConsume) this.n19_1 = current + 4 | 0;
        return true;
    };
    protoOf(AbstractJsonLexer).p1g = function(doConsume, $super) {
        doConsume = doConsume === VOID ? true : doConsume;
        return $super === VOID ? this.e1g(doConsume) : $super.e1g.call(this, doConsume);
    };
    protoOf(AbstractJsonLexer).k1l = function() {
        var current = this.n19_1;
        $l$loop_0: while(true){
            current = this.d1l(current);
            if (current === -1) break $l$loop_0;
            var c = charSequenceGet(this.c1l(), current);
            if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) current = current + 1 | 0;
            else break $l$loop_0;
        }
        this.n19_1 = current;
        return current;
    };
    protoOf(AbstractJsonLexer).f1g = function(isLenient) {
        var token = this.n1e();
        var tmp;
        if (isLenient) {
            if (!(token === 1) && !(token === 0)) return null;
            tmp = this.q1e();
        } else {
            if (!(token === 1)) return null;
            tmp = this.p1e();
        }
        var string = tmp;
        this.p19_1 = string;
        return string;
    };
    protoOf(AbstractJsonLexer).l1l = function() {
        this.p19_1 = null;
    };
    protoOf(AbstractJsonLexer).m1l = function(startPos, endPos) {
        // Inline function 'kotlin.text.substring' call
        var this_0 = this.c1l();
        return toString(charSequenceSubSequence(this_0, startPos, endPos));
    };
    protoOf(AbstractJsonLexer).p1e = function() {
        if (!(this.p19_1 == null)) return takePeeked(this);
        return this.i1g();
    };
    protoOf(AbstractJsonLexer).consumeString2 = function(source, startPosition, current) {
        var currentPosition = current;
        var lastPosition = startPosition;
        var char = charSequenceGet(source, currentPosition);
        var usedAppend = false;
        while(!(char === _Char___init__impl__6a9atx(34))){
            if (char === _Char___init__impl__6a9atx(92)) {
                usedAppend = true;
                currentPosition = this.d1l(appendEscape(this, lastPosition, currentPosition));
                if (currentPosition === -1) this.n1d("Unexpected EOF", currentPosition);
                lastPosition = currentPosition;
            } else {
                currentPosition = currentPosition + 1 | 0;
                if (currentPosition >= charSequenceLength(source)) {
                    usedAppend = true;
                    this.b1l(lastPosition, currentPosition);
                    currentPosition = this.d1l(currentPosition);
                    if (currentPosition === -1) this.n1d("Unexpected EOF", currentPosition);
                    lastPosition = currentPosition;
                }
            }
            char = charSequenceGet(source, currentPosition);
        }
        var tmp;
        if (!usedAppend) tmp = this.m1l(lastPosition, currentPosition);
        else tmp = decodedString(this, lastPosition, currentPosition);
        var string = tmp;
        this.n19_1 = currentPosition + 1 | 0;
        return string;
    };
    protoOf(AbstractJsonLexer).j1g = function() {
        var result = this.q1e();
        if (result === "null" && wasUnquotedString(this)) this.n1d("Unexpected 'null' value instead of string literal");
        return result;
    };
    protoOf(AbstractJsonLexer).q1e = function() {
        if (!(this.p19_1 == null)) return takePeeked(this);
        var current = this.k1l();
        if (current >= charSequenceLength(this.c1l()) || current === -1) this.n1d("EOF", current);
        var token = charToTokenClass(charSequenceGet(this.c1l(), current));
        if (token === 1) return this.p1e();
        if (!(token === 0)) this.n1d("Expected beginning of the string, but got " + toString_1(charSequenceGet(this.c1l(), current)));
        var usedAppend = false;
        while(charToTokenClass(charSequenceGet(this.c1l(), current)) === 0){
            current = current + 1 | 0;
            if (current >= charSequenceLength(this.c1l())) {
                usedAppend = true;
                this.b1l(this.n19_1, current);
                var eof = this.d1l(current);
                if (eof === -1) {
                    this.n19_1 = current;
                    return decodedString(this, 0, 0);
                } else current = eof;
            }
        }
        var tmp;
        if (!usedAppend) tmp = this.m1l(this.n19_1, current);
        else tmp = decodedString(this, this.n19_1, current);
        var result = tmp;
        this.n19_1 = current;
        return result;
    };
    protoOf(AbstractJsonLexer).b1l = function(fromIndex, toIndex) {
        this.q19_1.qb(this.c1l(), fromIndex, toIndex);
    };
    protoOf(AbstractJsonLexer).h1g = function(allowLenientStrings) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var tokenStack = ArrayList_init_$Create$();
        var lastToken = this.n1e();
        if (!(lastToken === 8) && !(lastToken === 6)) {
            this.q1e();
            return Unit_instance;
        }
        $l$loop: while(true){
            lastToken = this.n1e();
            if (lastToken === 1) {
                if (allowLenientStrings) this.q1e();
                else this.i1g();
                continue $l$loop;
            }
            var tmp0_subject = lastToken;
            if (tmp0_subject === 8 ? true : tmp0_subject === 6) tokenStack.e(lastToken);
            else if (tmp0_subject === 9) {
                if (!(last(tokenStack) === 8)) throw JsonDecodingException_0(this.n19_1, "found ] instead of } at path: " + this.o19_1.toString(), this.c1l());
                removeLast(tokenStack);
            } else if (tmp0_subject === 7) {
                if (!(last(tokenStack) === 6)) throw JsonDecodingException_0(this.n19_1, "found } instead of ] at path: " + this.o19_1.toString(), this.c1l());
                removeLast(tokenStack);
            } else if (tmp0_subject === 10) this.n1d("Unexpected end of input due to malformed JSON during ignoring unknown keys");
            this.s1e();
            if (tokenStack.m() === 0) return Unit_instance;
        }
    };
    protoOf(AbstractJsonLexer).toString = function() {
        return "JsonReader(source='" + toString(this.c1l()) + "', currentPosition=" + this.n19_1 + ")";
    };
    protoOf(AbstractJsonLexer).g1g = function(key) {
        var processed = this.m1l(0, this.n19_1);
        var lastIndexOf_0 = lastIndexOf(processed, key);
        this.i1l("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
    };
    protoOf(AbstractJsonLexer).i1l = function(message, position, hint) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(hint) === 0) tmp = "";
        else tmp = "\n" + hint;
        var hintMessage = tmp;
        throw JsonDecodingException_0(position, message + " at path: " + this.o19_1.a1e() + hintMessage, this.c1l());
    };
    protoOf(AbstractJsonLexer).n1d = function(message, position, hint, $super) {
        position = position === VOID ? this.n19_1 : position;
        hint = hint === VOID ? "" : hint;
        return $super === VOID ? this.i1l(message, position, hint) : $super.i1l.call(this, message, position, hint);
    };
    protoOf(AbstractJsonLexer).i1b = function() {
        var current = this.k1l();
        current = this.d1l(current);
        if (current >= charSequenceLength(this.c1l()) || current === -1) this.n1d("EOF");
        var tmp;
        if (charSequenceGet(this.c1l(), current) === _Char___init__impl__6a9atx(34)) {
            current = current + 1 | 0;
            if (current === charSequenceLength(this.c1l())) this.n1d("EOF");
            tmp = true;
        } else tmp = false;
        var hasQuotation = tmp;
        var accumulator = new Long(0, 0);
        var exponentAccumulator = new Long(0, 0);
        var isNegative = false;
        var isExponentPositive = false;
        var hasExponent = false;
        var start = current;
        $l$loop_4: while(!(current === charSequenceLength(this.c1l()))){
            var ch = charSequenceGet(this.c1l(), current);
            if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
                if (current === start) this.n1d("Unexpected symbol " + toString_1(ch) + " in numeric literal");
                isExponentPositive = true;
                hasExponent = true;
                current = current + 1 | 0;
                continue $l$loop_4;
            }
            if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
                if (current === start) this.n1d("Unexpected symbol '-' in numeric literal");
                isExponentPositive = false;
                current = current + 1 | 0;
                continue $l$loop_4;
            }
            if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
                if (current === start) this.n1d("Unexpected symbol '+' in numeric literal");
                isExponentPositive = true;
                current = current + 1 | 0;
                continue $l$loop_4;
            }
            if (ch === _Char___init__impl__6a9atx(45)) {
                if (!(current === start)) this.n1d("Unexpected symbol '-' in numeric literal");
                isNegative = true;
                current = current + 1 | 0;
                continue $l$loop_4;
            }
            var token = charToTokenClass(ch);
            if (!(token === 0)) break $l$loop_4;
            current = current + 1 | 0;
            var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
            if (!(0 <= digit ? digit <= 9 : false)) this.n1d("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
            if (hasExponent) {
                // Inline function 'kotlin.Long.plus' call
                // Inline function 'kotlin.Long.times' call
                exponentAccumulator = exponentAccumulator.a3(toLong(10)).y2(toLong(digit));
                continue $l$loop_4;
            }
            // Inline function 'kotlin.Long.minus' call
            // Inline function 'kotlin.Long.times' call
            accumulator = accumulator.a3(toLong(10)).z2(toLong(digit));
            if (accumulator.j1(new Long(0, 0)) > 0) this.n1d("Numeric value overflow");
        }
        var hasChars = !(current === start);
        if (start === current || isNegative && start === (current - 1 | 0)) this.n1d("Expected numeric literal");
        if (hasQuotation) {
            if (!hasChars) this.n1d("EOF");
            if (!(charSequenceGet(this.c1l(), current) === _Char___init__impl__6a9atx(34))) this.n1d("Expected closing quotation mark");
            current = current + 1 | 0;
        }
        this.n19_1 = current;
        if (hasExponent) {
            var doubleAccumulator = accumulator.p3() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
            if (doubleAccumulator > new Long(-1, 2147483647).p3() || doubleAccumulator < new Long(0, -2147483648).p3()) this.n1d("Numeric value overflow");
            // Inline function 'kotlin.math.floor' call
            if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) this.n1d("Can't convert " + doubleAccumulator + " to Long");
            accumulator = numberToLong(doubleAccumulator);
        }
        var tmp_0;
        if (isNegative) tmp_0 = accumulator;
        else if (!accumulator.equals(new Long(0, -2147483648))) tmp_0 = accumulator.f3();
        else this.n1d("Numeric value overflow");
        return tmp_0;
    };
    protoOf(AbstractJsonLexer).q1g = function() {
        return consumeBoolean2(this, this.k1l());
    };
    protoOf(AbstractJsonLexer).r1g = function() {
        var current = this.k1l();
        if (current === charSequenceLength(this.c1l())) this.n1d("EOF");
        var tmp;
        if (charSequenceGet(this.c1l(), current) === _Char___init__impl__6a9atx(34)) {
            current = current + 1 | 0;
            tmp = true;
        } else tmp = false;
        var hasQuotation = tmp;
        var result = consumeBoolean2(this, current);
        if (hasQuotation) {
            if (this.n19_1 === charSequenceLength(this.c1l())) this.n1d("EOF");
            if (!(charSequenceGet(this.c1l(), this.n19_1) === _Char___init__impl__6a9atx(34))) this.n1d("Expected closing quotation mark");
            this.n19_1 = this.n19_1 + 1 | 0;
        }
        return result;
    };
    function charToTokenClass(c) {
        var tmp;
        // Inline function 'kotlin.code' call
        if (Char__toInt_impl_vasixd(c) < 126) {
            var tmp_0 = CharMappings_getInstance().o1l_1;
            // Inline function 'kotlin.code' call
            tmp = tmp_0[Char__toInt_impl_vasixd(c)];
        } else tmp = 0;
        return tmp;
    }
    function tokenDescription(token) {
        return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? "end of the input" : token === 127 ? "invalid token" : "valid token";
    }
    function escapeToChar(c) {
        return c < 117 ? CharMappings_getInstance().n1l_1[c] : _Char___init__impl__6a9atx(0);
    }
    function initEscape($this) {
        var inductionVariable = 0;
        if (inductionVariable <= 31) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            initC2ESC($this, i, _Char___init__impl__6a9atx(117));
        }while (inductionVariable <= 31);
        initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
        initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
        initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
        initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
        initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
        initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
        initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
        initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
    }
    function initCharToToken($this) {
        var inductionVariable = 0;
        if (inductionVariable <= 32) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            initC2TC($this, i, 127);
        }while (inductionVariable <= 32);
        initC2TC($this, 9, 3);
        initC2TC($this, 10, 3);
        initC2TC($this, 13, 3);
        initC2TC($this, 32, 3);
        initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
        initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
        initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
        initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
        initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
        initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
        initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
        initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
    }
    function initC2ESC($this, c, esc) {
        if (!(esc === _Char___init__impl__6a9atx(117))) {
            // Inline function 'kotlin.code' call
            var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
            $this.n1l_1[tmp$ret$0] = numberToChar(c);
        }
    }
    function initC2ESC_0($this, c, esc) {
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(c);
        return initC2ESC($this, tmp$ret$0, esc);
    }
    function initC2TC($this, c, cl) {
        $this.o1l_1[c] = cl;
    }
    function initC2TC_0($this, c, cl) {
        // Inline function 'kotlin.code' call
        var tmp$ret$0 = Char__toInt_impl_vasixd(c);
        return initC2TC($this, tmp$ret$0, cl);
    }
    function CharMappings() {
        CharMappings_instance = this;
        this.n1l_1 = charArray(117);
        this.o1l_1 = new Int8Array(126);
        initEscape(this);
        initCharToToken(this);
    }
    var CharMappings_instance;
    function CharMappings_getInstance() {
        if (CharMappings_instance == null) new CharMappings();
        return CharMappings_instance;
    }
    function StringJsonLexer(source) {
        AbstractJsonLexer.call(this);
        this.t1l_1 = source;
    }
    protoOf(StringJsonLexer).c1l = function() {
        return this.t1l_1;
    };
    protoOf(StringJsonLexer).d1l = function(position) {
        return position < this.t1l_1.length ? position : -1;
    };
    protoOf(StringJsonLexer).s1e = function() {
        var source = this.t1l_1;
        $l$loop: while(!(this.n19_1 === -1) && this.n19_1 < source.length){
            var tmp1 = this.n19_1;
            this.n19_1 = tmp1 + 1 | 0;
            var ch = charSequenceGet(source, tmp1);
            var tc = charToTokenClass(ch);
            var tmp;
            if (tc === 3) continue $l$loop;
            else tmp = tc;
            return tmp;
        }
        return 10;
    };
    protoOf(StringJsonLexer).d1g = function() {
        var current = this.k1l();
        if (current === this.t1l_1.length || current === -1) return false;
        if (charSequenceGet(this.t1l_1, current) === _Char___init__impl__6a9atx(44)) {
            this.n19_1 = this.n19_1 + 1 | 0;
            return true;
        }
        return false;
    };
    protoOf(StringJsonLexer).o1e = function() {
        var current = this.n19_1;
        if (current === -1) return false;
        $l$loop: while(current < this.t1l_1.length){
            var c = charSequenceGet(this.t1l_1, current);
            if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
                current = current + 1 | 0;
                continue $l$loop;
            }
            this.n19_1 = current;
            return this.f1l(c);
        }
        this.n19_1 = current;
        return false;
    };
    protoOf(StringJsonLexer).k1l = function() {
        var current = this.n19_1;
        if (current === -1) return current;
        $l$loop: while(current < this.t1l_1.length){
            var c = charSequenceGet(this.t1l_1, current);
            if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) current = current + 1 | 0;
            else break $l$loop;
        }
        this.n19_1 = current;
        return current;
    };
    protoOf(StringJsonLexer).c1g = function(expected) {
        if (this.n19_1 === -1) this.h1l(expected);
        var source = this.t1l_1;
        $l$loop: while(this.n19_1 < source.length){
            var tmp1 = this.n19_1;
            this.n19_1 = tmp1 + 1 | 0;
            var c = charSequenceGet(source, tmp1);
            if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) continue $l$loop;
            if (c === expected) return Unit_instance;
            this.h1l(expected);
        }
        this.n19_1 = -1;
        this.h1l(expected);
    };
    protoOf(StringJsonLexer).i1g = function() {
        this.c1g(_Char___init__impl__6a9atx(34));
        var current = this.n19_1;
        var closingQuote = indexOf(this.t1l_1, _Char___init__impl__6a9atx(34), current);
        if (closingQuote === -1) {
            this.q1e();
            this.j1l(1, false);
        }
        var inductionVariable = current;
        if (inductionVariable < closingQuote) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (charSequenceGet(this.t1l_1, i) === _Char___init__impl__6a9atx(92)) return this.consumeString2(this.t1l_1, this.n19_1, i);
        }while (inductionVariable < closingQuote);
        this.n19_1 = closingQuote + 1 | 0;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        return this.t1l_1.substring(current, closingQuote);
    };
    protoOf(StringJsonLexer).k1g = function(keyToMatch, isLenient) {
        var positionSnapshot = this.n19_1;
        try {
            if (!(this.s1e() === 6)) return null;
            var firstKey = this.f1g(isLenient);
            if (!(firstKey === keyToMatch)) return null;
            this.l1l();
            if (!(this.s1e() === 5)) return null;
            return this.f1g(isLenient);
        } finally{
            this.n19_1 = positionSnapshot;
            this.l1l();
        }
    };
    function get_schemaCache(_this__u8e3s4) {
        return _this__u8e3s4.z18_1;
    }
    function JsonToStringWriter() {
        this.d19_1 = StringBuilder_init_$Create$_0(128);
    }
    protoOf(JsonToStringWriter).s1c = function(value) {
        this.d19_1.d8(value);
    };
    protoOf(JsonToStringWriter).m1c = function(char) {
        this.d19_1.f8(char);
    };
    protoOf(JsonToStringWriter).o1c = function(text) {
        this.d19_1.e8(text);
    };
    protoOf(JsonToStringWriter).y1c = function(text) {
        printQuoted(this.d19_1, text);
    };
    protoOf(JsonToStringWriter).e19 = function() {
        this.d19_1.wb();
    };
    protoOf(JsonToStringWriter).toString = function() {
        return this.d19_1.toString();
    };
    function createMapForCache(initialCapacity) {
        return HashMap_init_$Create$(initialCapacity);
    }
    //region block: post-declaration
    protoOf(defer$1).lp = get_isNullable;
    protoOf(defer$1).rp = get_isInline;
    protoOf(defer$1).pp = get_annotations;
    protoOf(PolymorphismValidator).q18 = contextual;
    //endregion
    //region block: init
    Companion_instance = new Companion();
    Companion_instance_0 = new Companion_0();
    Companion_instance_1 = new Companion_1();
    Companion_instance_2 = new Companion_2();
    Tombstone_instance = new Tombstone();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Default_getInstance;
    _.$_$.b = Companion_instance;
    _.$_$.c = JsonElementSerializer_getInstance;
    _.$_$.d = JsonNull_getInstance;
    _.$_$.e = JsonPrimitiveSerializer_getInstance;
    _.$_$.f = JsonArray;
    _.$_$.g = JsonContentPolymorphicSerializer;
    _.$_$.h = JsonElement;
    _.$_$.i = JsonObject;
    _.$_$.j = JsonPrimitive_0;
    _.$_$.k = JsonPrimitive_1;
    _.$_$.l = JsonPrimitive_2;
    _.$_$.m = JsonPrimitive;
    _.$_$.n = Json_0;
    _.$_$.o = get_booleanOrNull;
    _.$_$.p = get_doubleOrNull;
    _.$_$.q = get_floatOrNull;
    _.$_$.r = get_intOrNull;
    _.$_$.s = get_jsonObject;
    _.$_$.t = get_jsonPrimitive;
    _.$_$.u = get_longOrNull;
    //endregion
    return _;
});

});
parcelRegister("3kJd2", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var VOID = kotlin_kotlin.$_$.f;
    var asList = kotlin_kotlin.$_$.x5;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var emptyList = kotlin_kotlin.$_$.r6;
    var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.j;
    var lazy = kotlin_kotlin.$_$.pf;
    var toString = kotlin_kotlin.$_$.ob;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var zip = kotlin_kotlin.$_$.w8;
    var toMap = kotlin_kotlin.$_$.n8;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
    var KtMap = kotlin_kotlin.$_$.r5;
    var isInterface = kotlin_kotlin.$_$.xa;
    var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.q1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.s1;
    var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.u1;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var KClass = kotlin_kotlin.$_$.zb;
    var Triple = kotlin_kotlin.$_$.ve;
    var getKClass = kotlin_kotlin.$_$.e;
    var Pair = kotlin_kotlin.$_$.qe;
    var Entry = kotlin_kotlin.$_$.q5;
    var LinkedHashMap = kotlin_kotlin.$_$.n5;
    var KtMutableMap = kotlin_kotlin.$_$.t5;
    var HashMap = kotlin_kotlin.$_$.k5;
    var LinkedHashSet = kotlin_kotlin.$_$.o5;
    var KtMutableSet = kotlin_kotlin.$_$.u5;
    var KtSet = kotlin_kotlin.$_$.v5;
    var HashSet = kotlin_kotlin.$_$.l5;
    var ArrayList = kotlin_kotlin.$_$.i5;
    var KtMutableList = kotlin_kotlin.$_$.s5;
    var KtList = kotlin_kotlin.$_$.p5;
    var Collection = kotlin_kotlin.$_$.j5;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.c3;
    var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b3;
    var Result = kotlin_kotlin.$_$.re;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var equals = kotlin_kotlin.$_$.ba;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var Iterable = kotlin_kotlin.$_$.m5;
    var isBlank = kotlin_kotlin.$_$.uc;
    var toList = kotlin_kotlin.$_$.l8;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var HashSet_init_$Create$ = kotlin_kotlin.$_$.t;
    var toHashSet = kotlin_kotlin.$_$.i8;
    var toBooleanArray = kotlin_kotlin.$_$.h8;
    var withIndex = kotlin_kotlin.$_$.v8;
    var to = kotlin_kotlin.$_$.wf;
    var lazy_0 = kotlin_kotlin.$_$.qf;
    var contentEquals = kotlin_kotlin.$_$.c6;
    var until = kotlin_kotlin.$_$.yb;
    var joinToString = kotlin_kotlin.$_$.g7;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var Long = kotlin_kotlin.$_$.ne;
    var Char = kotlin_kotlin.$_$.ee;
    var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.q2;
    var Duration = kotlin_kotlin.$_$.be;
    var Companion_getInstance = kotlin_kotlin.$_$.z4;
    var toIntOrNull = kotlin_kotlin.$_$.od;
    var hashCode = kotlin_kotlin.$_$.ha;
    var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.o;
    var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.u;
    var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.y;
    var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.z;
    var HashMap_init_$Create$ = kotlin_kotlin.$_$.q;
    var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.r;
    var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.x;
    var isArray = kotlin_kotlin.$_$.pa;
    var arrayIterator = kotlin_kotlin.$_$.r9;
    var step = kotlin_kotlin.$_$.xb;
    var getValue = kotlin_kotlin.$_$.b7;
    var longArray = kotlin_kotlin.$_$.fb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var get_lastIndex = kotlin_kotlin.$_$.i7;
    var countTrailingZeroBits = kotlin_kotlin.$_$.if;
    var indexOf = kotlin_kotlin.$_$.c7;
    var contentToString = kotlin_kotlin.$_$.e6;
    var Enum = kotlin_kotlin.$_$.ie;
    var fillArrayVal = kotlin_kotlin.$_$.da;
    var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.s;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var KTypeParameter = kotlin_kotlin.$_$.bc;
    var booleanArray = kotlin_kotlin.$_$.s9;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var contentHashCode = kotlin_kotlin.$_$.d6;
    var Companion_getInstance_0 = kotlin_kotlin.$_$.a5;
    var isCharArray = kotlin_kotlin.$_$.sa;
    var charArray = kotlin_kotlin.$_$.v9;
    var DoubleCompanionObject_instance = kotlin_kotlin.$_$.s4;
    var isDoubleArray = kotlin_kotlin.$_$.ua;
    var FloatCompanionObject_instance = kotlin_kotlin.$_$.t4;
    var isFloatArray = kotlin_kotlin.$_$.va;
    var Companion_getInstance_1 = kotlin_kotlin.$_$.b5;
    var isLongArray = kotlin_kotlin.$_$.ya;
    var Companion_getInstance_2 = kotlin_kotlin.$_$.f5;
    var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.c4;
    var ULongArray = kotlin_kotlin.$_$.af;
    var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.y3;
    var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.v3;
    var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.a4;
    var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.w3;
    var IntCompanionObject_instance = kotlin_kotlin.$_$.u4;
    var isIntArray = kotlin_kotlin.$_$.wa;
    var Companion_getInstance_3 = kotlin_kotlin.$_$.e5;
    var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.t3;
    var UIntArray = kotlin_kotlin.$_$.ye;
    var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.p3;
    var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.m3;
    var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.r3;
    var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.n3;
    var ShortCompanionObject_instance = kotlin_kotlin.$_$.v4;
    var isShortArray = kotlin_kotlin.$_$.ab;
    var Companion_getInstance_4 = kotlin_kotlin.$_$.g5;
    var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.l4;
    var UShortArray = kotlin_kotlin.$_$.cf;
    var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.h4;
    var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.e4;
    var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.j4;
    var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.f4;
    var ByteCompanionObject_instance = kotlin_kotlin.$_$.r4;
    var isByteArray = kotlin_kotlin.$_$.ra;
    var Companion_getInstance_5 = kotlin_kotlin.$_$.d5;
    var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.k3;
    var UByteArray = kotlin_kotlin.$_$.we;
    var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.h3;
    var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.d3;
    var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.i3;
    var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.e3;
    var BooleanCompanionObject_instance = kotlin_kotlin.$_$.q4;
    var isBooleanArray = kotlin_kotlin.$_$.qa;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var copyOf = kotlin_kotlin.$_$.i6;
    var copyOf_0 = kotlin_kotlin.$_$.k6;
    var copyOf_1 = kotlin_kotlin.$_$.l6;
    var copyOf_2 = kotlin_kotlin.$_$.g6;
    var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.d4;
    var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.z3;
    var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.b4;
    var copyOf_3 = kotlin_kotlin.$_$.n6;
    var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.u3;
    var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.q3;
    var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.s3;
    var copyOf_4 = kotlin_kotlin.$_$.f6;
    var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.m4;
    var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.i4;
    var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.k4;
    var copyOf_5 = kotlin_kotlin.$_$.j6;
    var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.l3;
    var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.g3;
    var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.j3;
    var copyOf_6 = kotlin_kotlin.$_$.h6;
    var Unit = kotlin_kotlin.$_$.ef;
    var trimIndent = kotlin_kotlin.$_$.yd;
    var equals_0 = kotlin_kotlin.$_$.pc;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var toString_1 = kotlin_kotlin.$_$.y2;
    var titlecase = kotlin_kotlin.$_$.kd;
    var isLowerCase = kotlin_kotlin.$_$.xc;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var ULong = kotlin_kotlin.$_$.bf;
    var UInt = kotlin_kotlin.$_$.ze;
    var UShort = kotlin_kotlin.$_$.df;
    var UByte = kotlin_kotlin.$_$.xe;
    var mapOf = kotlin_kotlin.$_$.r7;
    var last = kotlin_kotlin.$_$.m7;
    var lastOrNull = kotlin_kotlin.$_$.l7;
    var get_lastIndex_0 = kotlin_kotlin.$_$.j7;
    var get_js = kotlin_kotlin.$_$.db;
    var findAssociatedObject = kotlin_kotlin.$_$.c;
    var get_indices = kotlin_kotlin.$_$.e7;
    var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.c2;
    var get_indices_0 = kotlin_kotlin.$_$.d7;
    var Companion_instance = kotlin_kotlin.$_$.c5;
    var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
    var createFailure = kotlin_kotlin.$_$.jf;
    //endregion
    //region block: pre-declaration
    initMetadataForInterface(SerializationStrategy, "SerializationStrategy");
    initMetadataForInterface(DeserializationStrategy, "DeserializationStrategy");
    initMetadataForInterface(KSerializer, "KSerializer", VOID, VOID, [
        SerializationStrategy,
        DeserializationStrategy
    ]);
    initMetadataForClass(AbstractPolymorphicSerializer, "AbstractPolymorphicSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(PolymorphicSerializer, "PolymorphicSerializer", VOID, AbstractPolymorphicSerializer);
    initMetadataForClass(_no_name_provided__qut3iv);
    initMetadataForClass(SealedClassSerializer, "SealedClassSerializer", VOID, AbstractPolymorphicSerializer);
    initMetadataForInterface(StringFormat, "StringFormat");
    initMetadataForInterface(BinaryFormat, "BinaryFormat");
    initMetadataForClass(SerializationException, "SerializationException", SerializationException_init_$Create$, IllegalArgumentException);
    initMetadataForClass(UnknownFieldException, "UnknownFieldException", VOID, SerializationException);
    initMetadataForClass(MissingFieldException, "MissingFieldException", VOID, SerializationException);
    function get_isNullable() {
        return false;
    }
    function get_isInline() {
        return false;
    }
    function get_annotations() {
        return emptyList();
    }
    initMetadataForInterface(SerialDescriptor, "SerialDescriptor");
    initMetadataForClass(ContextDescriptor, "ContextDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForClass(elementDescriptors$1$1);
    initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [
        Iterable
    ]);
    initMetadataForClass(elementNames$1$1);
    initMetadataForClass(_no_name_provided__qut3iv_1, VOID, VOID, VOID, [
        Iterable
    ]);
    initMetadataForClass(ClassSerialDescriptorBuilder, "ClassSerialDescriptorBuilder");
    initMetadataForInterface(CachedNames, "CachedNames");
    initMetadataForClass(SerialDescriptorImpl, "SerialDescriptorImpl", VOID, VOID, [
        SerialDescriptor,
        CachedNames
    ]);
    initMetadataForClass(SerialKind, "SerialKind");
    initMetadataForObject(ENUM, "ENUM", VOID, SerialKind);
    initMetadataForObject(CONTEXTUAL, "CONTEXTUAL", VOID, SerialKind);
    initMetadataForClass(PrimitiveKind, "PrimitiveKind", VOID, SerialKind);
    initMetadataForObject(BOOLEAN, "BOOLEAN", VOID, PrimitiveKind);
    initMetadataForObject(BYTE, "BYTE", VOID, PrimitiveKind);
    initMetadataForObject(CHAR, "CHAR", VOID, PrimitiveKind);
    initMetadataForObject(SHORT, "SHORT", VOID, PrimitiveKind);
    initMetadataForObject(INT, "INT", VOID, PrimitiveKind);
    initMetadataForObject(LONG, "LONG", VOID, PrimitiveKind);
    initMetadataForObject(FLOAT, "FLOAT", VOID, PrimitiveKind);
    initMetadataForObject(DOUBLE, "DOUBLE", VOID, PrimitiveKind);
    initMetadataForObject(STRING, "STRING", VOID, PrimitiveKind);
    initMetadataForClass(StructureKind, "StructureKind", VOID, SerialKind);
    initMetadataForObject(CLASS, "CLASS", VOID, StructureKind);
    initMetadataForObject(LIST, "LIST", VOID, StructureKind);
    initMetadataForObject(MAP, "MAP", VOID, StructureKind);
    initMetadataForObject(OBJECT, "OBJECT", VOID, StructureKind);
    initMetadataForClass(PolymorphicKind, "PolymorphicKind", VOID, SerialKind);
    initMetadataForObject(SEALED, "SEALED", VOID, PolymorphicKind);
    initMetadataForObject(OPEN, "OPEN", VOID, PolymorphicKind);
    function decodeSerializableValue(deserializer) {
        return deserializer.ao(this);
    }
    initMetadataForInterface(Decoder, "Decoder");
    function decodeSequentially() {
        return false;
    }
    function decodeCollectionSize(descriptor) {
        return -1;
    }
    function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
        previousValue = previousValue === VOID ? null : previousValue;
        return $super === VOID ? this.xr(descriptor, index, deserializer, previousValue) : $super.xr.call(this, descriptor, index, deserializer, previousValue);
    }
    initMetadataForInterface(CompositeDecoder, "CompositeDecoder");
    initMetadataForClass(AbstractDecoder, "AbstractDecoder", VOID, VOID, [
        Decoder,
        CompositeDecoder
    ]);
    function encodeNotNullMark() {}
    function beginCollection(descriptor, collectionSize) {
        return this.lr(descriptor);
    }
    function encodeSerializableValue(serializer, value) {
        serializer.zn(this, value);
    }
    function encodeNullableSerializableValue(serializer, value) {
        var isNullabilitySupported = serializer.yn().lp();
        if (isNullabilitySupported) return this.ct(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
        if (value == null) this.fs();
        else {
            this.ft();
            this.ct(serializer, value);
        }
    }
    initMetadataForInterface(Encoder, "Encoder");
    function shouldEncodeElementDefault(descriptor, index) {
        return true;
    }
    initMetadataForInterface(CompositeEncoder, "CompositeEncoder");
    initMetadataForClass(AbstractEncoder, "AbstractEncoder", VOID, VOID, [
        Encoder,
        CompositeEncoder
    ]);
    initMetadataForObject(NothingSerializer_0, "NothingSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(DurationSerializer, "DurationSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(ListLikeDescriptor, "ListLikeDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForClass(ArrayListClassDesc, "ArrayListClassDesc", VOID, ListLikeDescriptor);
    initMetadataForClass(HashSetClassDesc, "HashSetClassDesc", VOID, ListLikeDescriptor);
    initMetadataForClass(LinkedHashSetClassDesc, "LinkedHashSetClassDesc", VOID, ListLikeDescriptor);
    initMetadataForClass(MapLikeDescriptor, "MapLikeDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForClass(HashMapClassDesc, "HashMapClassDesc", VOID, MapLikeDescriptor);
    initMetadataForClass(LinkedHashMapClassDesc, "LinkedHashMapClassDesc", VOID, MapLikeDescriptor);
    initMetadataForClass(ArrayClassDesc, "ArrayClassDesc", VOID, ListLikeDescriptor);
    initMetadataForClass(PrimitiveArrayDescriptor, "PrimitiveArrayDescriptor", VOID, ListLikeDescriptor);
    initMetadataForClass(AbstractCollectionSerializer, "AbstractCollectionSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(CollectionLikeSerializer, "CollectionLikeSerializer", VOID, AbstractCollectionSerializer);
    initMetadataForClass(CollectionSerializer, "CollectionSerializer", VOID, CollectionLikeSerializer);
    initMetadataForClass(ArrayListSerializer, "ArrayListSerializer", VOID, CollectionSerializer);
    initMetadataForClass(HashSetSerializer, "HashSetSerializer", VOID, CollectionSerializer);
    initMetadataForClass(LinkedHashSetSerializer, "LinkedHashSetSerializer", VOID, CollectionSerializer);
    initMetadataForClass(MapLikeSerializer, "MapLikeSerializer", VOID, AbstractCollectionSerializer);
    initMetadataForClass(HashMapSerializer, "HashMapSerializer", VOID, MapLikeSerializer);
    initMetadataForClass(LinkedHashMapSerializer, "LinkedHashMapSerializer", VOID, MapLikeSerializer);
    initMetadataForClass(ReferenceArraySerializer, "ReferenceArraySerializer", VOID, CollectionLikeSerializer);
    initMetadataForClass(PrimitiveArraySerializer, "PrimitiveArraySerializer", VOID, CollectionLikeSerializer);
    initMetadataForClass(PrimitiveArrayBuilder, "PrimitiveArrayBuilder");
    initMetadataForCompanion(Companion);
    initMetadataForClass(ElementMarker, "ElementMarker");
    initMetadataForClass(EnumSerializer, "EnumSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(PluginGeneratedSerialDescriptor, "PluginGeneratedSerialDescriptor", VOID, VOID, [
        SerialDescriptor,
        CachedNames
    ]);
    initMetadataForClass(EnumDescriptor, "EnumDescriptor", VOID, PluginGeneratedSerialDescriptor);
    initMetadataForClass(InlineClassDescriptor, "InlineClassDescriptor", VOID, PluginGeneratedSerialDescriptor);
    function typeParametersSerializers() {
        return get_EMPTY_SERIALIZER_ARRAY();
    }
    initMetadataForInterface(GeneratedSerializer, "GeneratedSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForObject(NoOpEncoder, "NoOpEncoder", VOID, AbstractEncoder);
    initMetadataForObject(NothingSerialDescriptor, "NothingSerialDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForClass(NullableSerializer, "NullableSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(SerialDescriptorForNullable, "SerialDescriptorForNullable", VOID, VOID, [
        SerialDescriptor,
        CachedNames
    ]);
    initMetadataForClass(ObjectSerializer, "ObjectSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForInterface(SerializerFactory, "SerializerFactory");
    initMetadataForObject(CharArraySerializer_0, "CharArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(DoubleArraySerializer_0, "DoubleArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(FloatArraySerializer_0, "FloatArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(LongArraySerializer_0, "LongArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(ULongArraySerializer_0, "ULongArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(IntArraySerializer_0, "IntArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(UIntArraySerializer_0, "UIntArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(ShortArraySerializer_0, "ShortArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(UShortArraySerializer_0, "UShortArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(ByteArraySerializer_0, "ByteArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(UByteArraySerializer_0, "UByteArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForObject(BooleanArraySerializer_0, "BooleanArraySerializer", VOID, PrimitiveArraySerializer, [
        KSerializer,
        PrimitiveArraySerializer
    ]);
    initMetadataForClass(CharArrayBuilder, "CharArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(DoubleArrayBuilder, "DoubleArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(FloatArrayBuilder, "FloatArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(LongArrayBuilder, "LongArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(ULongArrayBuilder, "ULongArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(IntArrayBuilder, "IntArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(UIntArrayBuilder, "UIntArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(ShortArrayBuilder, "ShortArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(UShortArrayBuilder, "UShortArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(ByteArrayBuilder, "ByteArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(UByteArrayBuilder, "UByteArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForClass(BooleanArrayBuilder, "BooleanArrayBuilder", VOID, PrimitiveArrayBuilder);
    initMetadataForObject(StringSerializer, "StringSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(CharSerializer, "CharSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(DoubleSerializer, "DoubleSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(FloatSerializer, "FloatSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(LongSerializer, "LongSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(IntSerializer, "IntSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(ShortSerializer, "ShortSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(ByteSerializer, "ByteSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(BooleanSerializer, "BooleanSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(UnitSerializer, "UnitSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(PrimitiveSerialDescriptor_0, "PrimitiveSerialDescriptor", VOID, VOID, [
        SerialDescriptor
    ]);
    initMetadataForClass(TaggedEncoder, "TaggedEncoder", VOID, VOID, [
        Encoder,
        CompositeEncoder
    ]);
    initMetadataForClass(NamedValueEncoder, "NamedValueEncoder", VOID, TaggedEncoder);
    initMetadataForClass(TaggedDecoder, "TaggedDecoder", VOID, VOID, [
        Decoder,
        CompositeDecoder
    ]);
    initMetadataForClass(NamedValueDecoder, "NamedValueDecoder", VOID, TaggedDecoder);
    initMetadataForClass(MapEntry, "MapEntry", VOID, VOID, [
        Entry
    ]);
    initMetadataForClass(KeyValueSerializer, "KeyValueSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(MapEntrySerializer_0, "MapEntrySerializer", VOID, KeyValueSerializer);
    initMetadataForClass(PairSerializer_0, "PairSerializer", VOID, KeyValueSerializer);
    initMetadataForClass(TripleSerializer_0, "TripleSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(ULongSerializer, "ULongSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(UIntSerializer, "UIntSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(UShortSerializer, "UShortSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(UByteSerializer, "UByteSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(SerializersModule, "SerializersModule");
    initMetadataForClass(SerialModuleImpl, "SerialModuleImpl", VOID, SerializersModule);
    initMetadataForClass(ContextualProvider, "ContextualProvider");
    initMetadataForClass(Argless, "Argless", VOID, ContextualProvider);
    initMetadataForClass(WithTypeArguments, "WithTypeArguments", VOID, ContextualProvider);
    function contextual(kClass, serializer) {
        return this.o18(kClass, SerializersModuleCollector$contextual$lambda(serializer));
    }
    initMetadataForInterface(SerializersModuleCollector, "SerializersModuleCollector");
    initMetadataForClass(SerializableWith, "SerializableWith", VOID, VOID, VOID, VOID, 0);
    initMetadataForClass(createCache$1);
    initMetadataForClass(createParametrizedCache$1);
    //endregion
    function KSerializer() {}
    function SerializationStrategy() {}
    function DeserializationStrategy() {}
    function PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, $this) {
        PolymorphicSerializer.call($this, baseClass);
        $this.co_1 = asList(classAnnotations);
        return $this;
    }
    function PolymorphicSerializer_init_$Create$(baseClass, classAnnotations) {
        return PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, objectCreate(protoOf(PolymorphicSerializer)));
    }
    function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
        return function($this$buildSerialDescriptor) {
            $this$buildSerialDescriptor.mo("type", serializer_1(StringCompanionObject_instance).yn());
            $this$buildSerialDescriptor.mo("value", buildSerialDescriptor("kotlinx.serialization.Polymorphic<" + this$0.bo_1.fa() + ">", CONTEXTUAL_getInstance(), []));
            $this$buildSerialDescriptor.go_1 = this$0.co_1;
            return Unit_instance;
        };
    }
    function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
        return function() {
            var tmp = OPEN_getInstance();
            return withContext(buildSerialDescriptor("kotlinx.serialization.Polymorphic", tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.bo_1);
        };
    }
    function PolymorphicSerializer(baseClass) {
        AbstractPolymorphicSerializer.call(this);
        this.bo_1 = baseClass;
        this.co_1 = emptyList();
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.do_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
    }
    protoOf(PolymorphicSerializer).no = function() {
        return this.bo_1;
    };
    protoOf(PolymorphicSerializer).yn = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.do_1;
        descriptor$factory();
        return this_0.b1();
    };
    protoOf(PolymorphicSerializer).toString = function() {
        return "kotlinx.serialization.PolymorphicSerializer(baseClass: " + toString(this.bo_1) + ")";
    };
    function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
        var tmp0_elvis_lhs = _this__u8e3s4.qo(encoder, value);
        var tmp;
        if (tmp0_elvis_lhs == null) throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.no());
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
        var tmp0_elvis_lhs = _this__u8e3s4.po(decoder, klassName);
        var tmp;
        if (tmp0_elvis_lhs == null) throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.no());
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function descriptor$factory() {
        return getPropertyCallableRef("descriptor", 1, KProperty1, function(receiver) {
            return receiver.yn();
        }, null);
    }
    function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
        SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
        $this.so_1 = asList(classAnnotations);
        return $this;
    }
    function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
        return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
    }
    function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
        return function($this$buildSerialDescriptor) {
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = this$0.vo_1.z().j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlinx.serialization.SealedClassSerializer.descriptor$delegate.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var name = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var serializer = element.b1();
                $this$buildSerialDescriptor.mo(name, serializer.yn());
            }
            return Unit_instance;
        };
    }
    function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
        return function($this$buildSerialDescriptor) {
            $this$buildSerialDescriptor.mo("type", serializer_1(StringCompanionObject_instance).yn());
            var tmp = "kotlinx.serialization.Sealed<" + this$0.ro_1.fa() + ">";
            var tmp_0 = CONTEXTUAL_getInstance();
            var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
            $this$buildSerialDescriptor.mo("value", elementDescriptor);
            $this$buildSerialDescriptor.go_1 = this$0.so_1;
            return Unit_instance;
        };
    }
    function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
        return function() {
            var tmp = SEALED_getInstance();
            return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
        };
    }
    function _no_name_provided__qut3iv($this) {
        this.wo_1 = $this;
    }
    protoOf(_no_name_provided__qut3iv).xo = function() {
        return this.wo_1.j();
    };
    protoOf(_no_name_provided__qut3iv).yo = function(element) {
        // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
        return element.b1().yn().zo();
    };
    protoOf(_no_name_provided__qut3iv).ap = function(element) {
        return this.yo((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
        AbstractPolymorphicSerializer.call(this);
        this.ro_1 = baseClass;
        this.so_1 = emptyList();
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.to_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
        if (!(subclasses.length === subclassSerializers.length)) throw IllegalArgumentException_init_$Create$("All subclasses of sealed class " + this.ro_1.fa() + " should be marked @Serializable");
        this.uo_1 = toMap(zip(subclasses, subclassSerializers));
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mapValues' call
        // Inline function 'kotlin.collections.aggregate' call
        // Inline function 'kotlin.collections.groupingBy' call
        var this_0 = this.uo_1.z();
        // Inline function 'kotlin.collections.aggregateTo' call
        var this_1 = new _no_name_provided__qut3iv(this_0);
        // Inline function 'kotlin.collections.mutableMapOf' call
        var destination = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = this_1.xo();
        while(tmp0_iterator.k()){
            var e = tmp0_iterator.l();
            var key = this_1.ap(e);
            var accumulator = destination.e2(key);
            // Inline function 'kotlin.collections.set' call
            // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
            accumulator == null && destination.c2(key);
            if (!(accumulator == null)) {
                // Inline function 'kotlin.error' call
                var message = "Multiple sealed subclasses of '" + toString(this.ro_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.a1()) + "', '" + toString(e.a1()) + "'");
                throw IllegalStateException_init_$Create$(toString(message));
            }
            destination.m2(key, e);
        }
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.m()));
        // Inline function 'kotlin.collections.associateByTo' call
        var tmp0_iterator_0 = destination.z().j();
        while(tmp0_iterator_0.k()){
            var element = tmp0_iterator_0.l();
            // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
            var tmp_2 = element.a1();
            // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
            var tmp$ret$7 = element.b1().b1();
            destination_0.m2(tmp_2, tmp$ret$7);
        }
        tmp_1.vo_1 = destination_0;
    }
    protoOf(SealedClassSerializer).no = function() {
        return this.ro_1;
    };
    protoOf(SealedClassSerializer).yn = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.to_1;
        descriptor$factory_0();
        return this_0.b1();
    };
    protoOf(SealedClassSerializer).po = function(decoder, klassName) {
        // Inline function 'kotlin.collections.get' call
        var this_0 = this.vo_1;
        var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).e2(klassName);
        return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).po.call(this, decoder, klassName) : tmp0_elvis_lhs;
    };
    protoOf(SealedClassSerializer).qo = function(encoder, value) {
        var tmp0_elvis_lhs = this.uo_1.e2(getKClassFromExpression(value));
        var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).qo.call(this, encoder, value) : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else // Inline function 'kotlinx.serialization.internal.cast' call
        tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
        return tmp;
    };
    function descriptor$factory_0() {
        return getPropertyCallableRef("descriptor", 1, KProperty1, function(receiver) {
            return receiver.yn();
        }, null);
    }
    function StringFormat() {}
    function BinaryFormat() {}
    function SerializationException_init_$Init$($this) {
        IllegalArgumentException_init_$Init$($this);
        SerializationException.call($this);
        return $this;
    }
    function SerializationException_init_$Create$() {
        var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
        captureStack(tmp, SerializationException_init_$Create$);
        return tmp;
    }
    function SerializationException_init_$Init$_0(message, $this) {
        IllegalArgumentException_init_$Init$_0(message, $this);
        SerializationException.call($this);
        return $this;
    }
    function SerializationException_init_$Create$_0(message) {
        var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
        captureStack(tmp, SerializationException_init_$Create$_0);
        return tmp;
    }
    function SerializationException_init_$Init$_1(message, cause, $this) {
        IllegalArgumentException_init_$Init$_1(message, cause, $this);
        SerializationException.call($this);
        return $this;
    }
    function SerializationException() {
        captureStack(this, SerializationException);
    }
    function UnknownFieldException_init_$Init$(index, $this) {
        UnknownFieldException.call($this, "An unknown field for index " + index);
        return $this;
    }
    function UnknownFieldException_init_$Create$(index) {
        var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
        captureStack(tmp, UnknownFieldException_init_$Create$);
        return tmp;
    }
    function UnknownFieldException(message) {
        SerializationException_init_$Init$_0(message, this);
        captureStack(this, UnknownFieldException);
    }
    function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
        MissingFieldException.call($this, missingFields, missingFields.m() === 1 ? "Field '" + missingFields.o(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : "Fields " + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
        return $this;
    }
    function MissingFieldException_init_$Create$(missingFields, serialName) {
        var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
        captureStack(tmp, MissingFieldException_init_$Create$);
        return tmp;
    }
    function MissingFieldException(missingFields, message, cause) {
        SerializationException_init_$Init$_1(message, cause, this);
        captureStack(this, MissingFieldException);
        this.gp_1 = missingFields;
    }
    function serializerOrNull(_this__u8e3s4) {
        var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
        return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
    }
    function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
        var tmp;
        if (failOnMissingTypeArgSerializer) {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
            var tmp0_iterator = typeArguments.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
                var tmp$ret$0 = serializer(_this__u8e3s4, item);
                destination.e(tmp$ret$0);
            }
            tmp = destination;
        } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
            var tmp0_iterator_0 = typeArguments.j();
            while(tmp0_iterator_0.k()){
                var item_0 = tmp0_iterator_0.l();
                // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
                var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
                var tmp_0;
                if (tmp0_elvis_lhs == null) return null;
                else tmp_0 = tmp0_elvis_lhs;
                var tmp$ret$3 = tmp_0;
                destination_0.e(tmp$ret$3);
            }
            tmp = destination_0;
        }
        var serializers = tmp;
        return serializers;
    }
    function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
        var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
        return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
    }
    function serializer(_this__u8e3s4, type) {
        var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
        var tmp;
        if (tmp0_elvis_lhs == null) platformSpecificSerializerNotRegistered(kclass(type));
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function serializerOrNull_0(_this__u8e3s4, type) {
        return serializerByKTypeImpl(_this__u8e3s4, type, false);
    }
    function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
        var tmp;
        if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(KtList))) ? true : _this__u8e3s4.equals(getKClass(KtMutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) tmp = new ArrayListSerializer(serializers.o(0));
        else if (_this__u8e3s4.equals(getKClass(HashSet))) tmp = new HashSetSerializer(serializers.o(0));
        else if ((_this__u8e3s4.equals(getKClass(KtSet)) ? true : _this__u8e3s4.equals(getKClass(KtMutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) tmp = new LinkedHashSetSerializer(serializers.o(0));
        else if (_this__u8e3s4.equals(getKClass(HashMap))) tmp = new HashMapSerializer(serializers.o(0), serializers.o(1));
        else if ((_this__u8e3s4.equals(getKClass(KtMap)) ? true : _this__u8e3s4.equals(getKClass(KtMutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) tmp = new LinkedHashMapSerializer(serializers.o(0), serializers.o(1));
        else if (_this__u8e3s4.equals(getKClass(Entry))) tmp = MapEntrySerializer(serializers.o(0), serializers.o(1));
        else if (_this__u8e3s4.equals(getKClass(Pair))) tmp = PairSerializer(serializers.o(0), serializers.o(1));
        else if (_this__u8e3s4.equals(getKClass(Triple))) tmp = TripleSerializer(serializers.o(0), serializers.o(1), serializers.o(2));
        else {
            var tmp_0;
            if (isReferenceArray(_this__u8e3s4)) {
                var tmp_1 = elementClassifierIfArray();
                tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.o(0));
            } else tmp_0 = null;
            tmp = tmp_0;
        }
        return tmp;
    }
    function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(serializers);
        return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
    }
    function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
        var rootClass = kclass(type);
        var isNullable = type.va();
        // Inline function 'kotlin.collections.map' call
        var this_0 = type.ua();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>' call
            var tmp$ret$1;
            $l$block: {
                // Inline function 'kotlin.requireNotNull' call
                var value = item.ii_1;
                // Inline function 'kotlin.contracts.contract' call
                if (value == null) {
                    // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>.<anonymous>' call
                    var message = "Star projections in type arguments are not allowed, but had " + toString(type);
                    throw IllegalArgumentException_init_$Create$(toString(message));
                } else {
                    tmp$ret$1 = value;
                    break $l$block;
                }
            }
            var tmp$ret$2 = tmp$ret$1;
            destination.e(tmp$ret$2);
        }
        var typeArguments = destination;
        var tmp;
        if (typeArguments.s()) tmp = findCachedSerializer(rootClass, isNullable);
        else {
            // Inline function 'kotlin.Result.getOrNull' call
            var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
            var tmp_0;
            if (_Result___get_isFailure__impl__jpiriv(this_1)) tmp_0 = null;
            else {
                var tmp_1 = _Result___get_value__impl__bjfvqg(this_1);
                tmp_0 = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            }
            tmp = tmp_0;
        }
        var cachedSerializer = tmp;
        if (cachedSerializer == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return cachedSerializer;
        var tmp_2;
        if (typeArguments.s()) tmp_2 = _this__u8e3s4.ip(rootClass);
        else {
            var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
            var tmp_3;
            if (tmp1_elvis_lhs == null) return null;
            else tmp_3 = tmp1_elvis_lhs;
            var serializers = tmp_3;
            var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
            tmp_2 = tmp2_elvis_lhs == null ? _this__u8e3s4.hp(rootClass, serializers) : tmp2_elvis_lhs;
        }
        var contextualSerializer = tmp_2;
        var tmp_4;
        if (contextualSerializer == null) tmp_4 = null;
        else // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_4 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
        var tmp4_safe_receiver = tmp_4;
        return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
    }
    function nullable(_this__u8e3s4, shouldBeNullable) {
        if (shouldBeNullable) return get_nullable(_this__u8e3s4);
        return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    }
    function serializer_0(_this__u8e3s4) {
        var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
        var tmp;
        if (tmp0_elvis_lhs == null) serializerNotRegistered(_this__u8e3s4);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function serializerByKTypeImpl$lambda($typeArguments) {
        return function() {
            return $typeArguments.o(0).ta();
        };
    }
    function get_SERIALIZERS_CACHE() {
        _init_properties_SerializersCache_kt__hgwi2p();
        return SERIALIZERS_CACHE;
    }
    var SERIALIZERS_CACHE;
    function get_SERIALIZERS_CACHE_NULLABLE() {
        _init_properties_SerializersCache_kt__hgwi2p();
        return SERIALIZERS_CACHE_NULLABLE;
    }
    var SERIALIZERS_CACHE_NULLABLE;
    function get_PARAMETRIZED_SERIALIZERS_CACHE() {
        _init_properties_SerializersCache_kt__hgwi2p();
        return PARAMETRIZED_SERIALIZERS_CACHE;
    }
    var PARAMETRIZED_SERIALIZERS_CACHE;
    function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
        _init_properties_SerializersCache_kt__hgwi2p();
        return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
    }
    var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
    function findCachedSerializer(clazz, isNullable) {
        _init_properties_SerializersCache_kt__hgwi2p();
        var tmp;
        if (!isNullable) {
            var tmp0_safe_receiver = get_SERIALIZERS_CACHE().jp(clazz);
            var tmp_0;
            if (tmp0_safe_receiver == null) tmp_0 = null;
            else // Inline function 'kotlinx.serialization.internal.cast' call
            tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
            tmp = tmp_0;
        } else tmp = get_SERIALIZERS_CACHE_NULLABLE().jp(clazz);
        return tmp;
    }
    function findParametrizedCachedSerializer(clazz, types, isNullable) {
        _init_properties_SerializersCache_kt__hgwi2p();
        var tmp;
        if (!isNullable) {
            var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().kp(clazz, types);
            tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
        } else tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().kp(clazz, types);
        return tmp;
    }
    function SERIALIZERS_CACHE$lambda(it) {
        _init_properties_SerializersCache_kt__hgwi2p();
        return serializerOrNull(it);
    }
    function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
        _init_properties_SerializersCache_kt__hgwi2p();
        var tmp0_safe_receiver = serializerOrNull(it);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else // Inline function 'kotlinx.serialization.internal.cast' call
        tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
        return tmp;
    }
    function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
        _init_properties_SerializersCache_kt__hgwi2p();
        var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
        return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
    }
    function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
        return function() {
            return $types.o(0).ta();
        };
    }
    function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
        _init_properties_SerializersCache_kt__hgwi2p();
        var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
        var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else // Inline function 'kotlinx.serialization.internal.cast' call
        tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
        return tmp;
    }
    function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
        return function() {
            return $types.o(0).ta();
        };
    }
    var properties_initialized_SerializersCache_kt_q8kf25;
    function _init_properties_SerializersCache_kt__hgwi2p() {
        if (!properties_initialized_SerializersCache_kt_q8kf25) {
            properties_initialized_SerializersCache_kt_q8kf25 = true;
            SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
            SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
            PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
            PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
        }
    }
    function get_nullable(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4.yn().lp()) tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
        else tmp = new NullableSerializer(_this__u8e3s4);
        return tmp;
    }
    function serializer_1(_this__u8e3s4) {
        return StringSerializer_getInstance();
    }
    function serializer_2(_this__u8e3s4) {
        return CharSerializer_getInstance();
    }
    function CharArraySerializer() {
        return CharArraySerializer_getInstance();
    }
    function serializer_3(_this__u8e3s4) {
        return DoubleSerializer_getInstance();
    }
    function DoubleArraySerializer() {
        return DoubleArraySerializer_getInstance();
    }
    function serializer_4(_this__u8e3s4) {
        return FloatSerializer_getInstance();
    }
    function FloatArraySerializer() {
        return FloatArraySerializer_getInstance();
    }
    function serializer_5(_this__u8e3s4) {
        return LongSerializer_getInstance();
    }
    function LongArraySerializer() {
        return LongArraySerializer_getInstance();
    }
    function serializer_6(_this__u8e3s4) {
        return ULongSerializer_getInstance();
    }
    function ULongArraySerializer() {
        return ULongArraySerializer_getInstance();
    }
    function serializer_7(_this__u8e3s4) {
        return IntSerializer_getInstance();
    }
    function IntArraySerializer() {
        return IntArraySerializer_getInstance();
    }
    function serializer_8(_this__u8e3s4) {
        return UIntSerializer_getInstance();
    }
    function UIntArraySerializer() {
        return UIntArraySerializer_getInstance();
    }
    function serializer_9(_this__u8e3s4) {
        return ShortSerializer_getInstance();
    }
    function ShortArraySerializer() {
        return ShortArraySerializer_getInstance();
    }
    function serializer_10(_this__u8e3s4) {
        return UShortSerializer_getInstance();
    }
    function UShortArraySerializer() {
        return UShortArraySerializer_getInstance();
    }
    function serializer_11(_this__u8e3s4) {
        return ByteSerializer_getInstance();
    }
    function ByteArraySerializer() {
        return ByteArraySerializer_getInstance();
    }
    function serializer_12(_this__u8e3s4) {
        return UByteSerializer_getInstance();
    }
    function UByteArraySerializer() {
        return UByteArraySerializer_getInstance();
    }
    function serializer_13(_this__u8e3s4) {
        return BooleanSerializer_getInstance();
    }
    function BooleanArraySerializer() {
        return BooleanArraySerializer_getInstance();
    }
    function serializer_14(_this__u8e3s4) {
        return UnitSerializer_getInstance();
    }
    function NothingSerializer() {
        return NothingSerializer_getInstance();
    }
    function serializer_15(_this__u8e3s4) {
        return DurationSerializer_getInstance();
    }
    function MapEntrySerializer(keySerializer, valueSerializer) {
        return new MapEntrySerializer_0(keySerializer, valueSerializer);
    }
    function PairSerializer(keySerializer, valueSerializer) {
        return new PairSerializer_0(keySerializer, valueSerializer);
    }
    function TripleSerializer(aSerializer, bSerializer, cSerializer) {
        return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
    }
    function ArraySerializer(kClass, elementSerializer) {
        return new ReferenceArraySerializer(kClass, elementSerializer);
    }
    function MapSerializer(keySerializer, valueSerializer) {
        return new LinkedHashMapSerializer(keySerializer, valueSerializer);
    }
    function ListSerializer(elementSerializer) {
        return new ArrayListSerializer(elementSerializer);
    }
    function SetSerializer(elementSerializer) {
        return new LinkedHashSetSerializer(elementSerializer);
    }
    function withContext(_this__u8e3s4, context) {
        return new ContextDescriptor(_this__u8e3s4, context);
    }
    function ContextDescriptor(original, kClass) {
        this.mp_1 = original;
        this.np_1 = kClass;
        this.op_1 = this.mp_1.zo() + "<" + this.np_1.fa() + ">";
    }
    protoOf(ContextDescriptor).pp = function() {
        return this.mp_1.pp();
    };
    protoOf(ContextDescriptor).qp = function() {
        return this.mp_1.qp();
    };
    protoOf(ContextDescriptor).rp = function() {
        return this.mp_1.rp();
    };
    protoOf(ContextDescriptor).lp = function() {
        return this.mp_1.lp();
    };
    protoOf(ContextDescriptor).sp = function() {
        return this.mp_1.sp();
    };
    protoOf(ContextDescriptor).tp = function(index) {
        return this.mp_1.tp(index);
    };
    protoOf(ContextDescriptor).up = function(index) {
        return this.mp_1.up(index);
    };
    protoOf(ContextDescriptor).vp = function(name) {
        return this.mp_1.vp(name);
    };
    protoOf(ContextDescriptor).wp = function(index) {
        return this.mp_1.wp(index);
    };
    protoOf(ContextDescriptor).xp = function(index) {
        return this.mp_1.xp(index);
    };
    protoOf(ContextDescriptor).zo = function() {
        return this.op_1;
    };
    protoOf(ContextDescriptor).equals = function(other) {
        var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var another = tmp;
        return equals(this.mp_1, another.mp_1) && another.np_1.equals(this.np_1);
    };
    protoOf(ContextDescriptor).hashCode = function() {
        var result = this.np_1.hashCode();
        result = imul(31, result) + getStringHashCode(this.op_1) | 0;
        return result;
    };
    protoOf(ContextDescriptor).toString = function() {
        return "ContextDescriptor(kClass: " + toString(this.np_1) + ", original: " + toString(this.mp_1) + ")";
    };
    function getContextualDescriptor(_this__u8e3s4, descriptor) {
        var tmp0_safe_receiver = get_capturedKClass(descriptor);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
            var tmp0_safe_receiver_0 = _this__u8e3s4.ip(tmp0_safe_receiver);
            tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.yn();
        }
        return tmp;
    }
    function get_capturedKClass(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4 instanceof ContextDescriptor) tmp = _this__u8e3s4.np_1;
        else if (_this__u8e3s4 instanceof SerialDescriptorForNullable) tmp = get_capturedKClass(_this__u8e3s4.yp_1);
        else tmp = null;
        return tmp;
    }
    function SerialDescriptor() {}
    function get_elementDescriptors(_this__u8e3s4) {
        // Inline function 'kotlin.collections.Iterable' call
        return new _no_name_provided__qut3iv_0(_this__u8e3s4);
    }
    function get_elementNames(_this__u8e3s4) {
        // Inline function 'kotlin.collections.Iterable' call
        return new _no_name_provided__qut3iv_1(_this__u8e3s4);
    }
    function elementDescriptors$1$1($this_elementDescriptors) {
        this.cq_1 = $this_elementDescriptors;
        this.bq_1 = $this_elementDescriptors.qp();
    }
    protoOf(elementDescriptors$1$1).k = function() {
        return this.bq_1 > 0;
    };
    protoOf(elementDescriptors$1$1).l = function() {
        var tmp = this.cq_1.qp();
        var tmp1 = this.bq_1;
        this.bq_1 = tmp1 - 1 | 0;
        return this.cq_1.up(tmp - tmp1 | 0);
    };
    function _no_name_provided__qut3iv_0($this_elementDescriptors) {
        this.dq_1 = $this_elementDescriptors;
    }
    protoOf(_no_name_provided__qut3iv_0).j = function() {
        // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
        return new elementDescriptors$1$1(this.dq_1);
    };
    function elementNames$1$1($this_elementNames) {
        this.fq_1 = $this_elementNames;
        this.eq_1 = $this_elementNames.qp();
    }
    protoOf(elementNames$1$1).k = function() {
        return this.eq_1 > 0;
    };
    protoOf(elementNames$1$1).l = function() {
        var tmp = this.fq_1.qp();
        var tmp1 = this.eq_1;
        this.eq_1 = tmp1 - 1 | 0;
        return this.fq_1.wp(tmp - tmp1 | 0);
    };
    function _no_name_provided__qut3iv_1($this_elementNames) {
        this.gq_1 = $this_elementNames;
    }
    protoOf(_no_name_provided__qut3iv_1).j = function() {
        // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
        return new elementNames$1$1(this.gq_1);
    };
    function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
        var tmp;
        if (builder === VOID) tmp = buildSerialDescriptor$lambda;
        else tmp = builder;
        builder = tmp;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!isBlank(serialName)) {
            // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
            var message = "Blank serial names are prohibited";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!equals(kind, CLASS_getInstance())) {
            // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
            var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
        builder(sdBuilder);
        return new SerialDescriptorImpl(serialName, kind, sdBuilder.ho_1.m(), toList(typeParameters), sdBuilder);
    }
    function ClassSerialDescriptorBuilder(serialName) {
        this.eo_1 = serialName;
        this.fo_1 = false;
        this.go_1 = emptyList();
        this.ho_1 = ArrayList_init_$Create$_0();
        this.io_1 = HashSet_init_$Create$();
        this.jo_1 = ArrayList_init_$Create$_0();
        this.ko_1 = ArrayList_init_$Create$_0();
        this.lo_1 = ArrayList_init_$Create$_0();
    }
    protoOf(ClassSerialDescriptorBuilder).hq = function(elementName, descriptor, annotations, isOptional) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!this.io_1.e(elementName)) {
            // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
            var message = "Element with name '" + elementName + "' is already registered in " + this.eo_1;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        this.ho_1.e(elementName);
        // Inline function 'kotlin.collections.plusAssign' call
        this.jo_1.e(descriptor);
        // Inline function 'kotlin.collections.plusAssign' call
        this.ko_1.e(annotations);
        // Inline function 'kotlin.collections.plusAssign' call
        this.lo_1.e(isOptional);
    };
    protoOf(ClassSerialDescriptorBuilder).mo = function(elementName, descriptor, annotations, isOptional, $super) {
        annotations = annotations === VOID ? emptyList() : annotations;
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
            this.hq(elementName, descriptor, annotations, isOptional);
            tmp = Unit_instance;
        } else tmp = $super.hq.call(this, elementName, descriptor, annotations, isOptional);
        return tmp;
    };
    function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
        var tmp;
        if (builderAction === VOID) tmp = buildClassSerialDescriptor$lambda;
        else tmp = builderAction;
        builderAction = tmp;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!isBlank(serialName)) {
            // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
            var message = "Blank serial names are prohibited";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
        builderAction(sdBuilder);
        return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.ho_1.m(), toList(typeParameters), sdBuilder);
    }
    function _get__hashCode__tgwhef($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.tq_1;
        _hashCode$factory();
        return this_0.b1();
    }
    function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
        return function() {
            return hashCodeImpl(this$0, this$0.sq_1);
        };
    }
    function SerialDescriptorImpl$toString$lambda(this$0) {
        return function(it) {
            return this$0.wp(it) + ": " + this$0.up(it).zo();
        };
    }
    function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
        this.iq_1 = serialName;
        this.jq_1 = kind;
        this.kq_1 = elementsCount;
        this.lq_1 = builder.go_1;
        this.mq_1 = toHashSet(builder.ho_1);
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = builder.ho_1;
        tmp.nq_1 = copyToArray(this_0);
        this.oq_1 = compactArray(builder.jo_1);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_1 = builder.ko_1;
        tmp_0.pq_1 = copyToArray(this_1);
        this.qq_1 = toBooleanArray(builder.lo_1);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        var this_2 = withIndex(this.nq_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
        var tmp0_iterator = this_2.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
            var tmp$ret$2 = to(item.re_1, item.qe_1);
            destination.e(tmp$ret$2);
        }
        tmp_1.rq_1 = toMap(destination);
        this.sq_1 = compactArray(typeParameters);
        var tmp_2 = this;
        tmp_2.tq_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
    }
    protoOf(SerialDescriptorImpl).zo = function() {
        return this.iq_1;
    };
    protoOf(SerialDescriptorImpl).sp = function() {
        return this.jq_1;
    };
    protoOf(SerialDescriptorImpl).qp = function() {
        return this.kq_1;
    };
    protoOf(SerialDescriptorImpl).pp = function() {
        return this.lq_1;
    };
    protoOf(SerialDescriptorImpl).uq = function() {
        return this.mq_1;
    };
    protoOf(SerialDescriptorImpl).wp = function(index) {
        return getChecked(this.nq_1, index);
    };
    protoOf(SerialDescriptorImpl).vp = function(name) {
        var tmp0_elvis_lhs = this.rq_1.e2(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
    };
    protoOf(SerialDescriptorImpl).tp = function(index) {
        return getChecked(this.pq_1, index);
    };
    protoOf(SerialDescriptorImpl).up = function(index) {
        return getChecked(this.oq_1, index);
    };
    protoOf(SerialDescriptorImpl).xp = function(index) {
        return getChecked_0(this.qq_1, index);
    };
    protoOf(SerialDescriptorImpl).equals = function(other) {
        var tmp$ret$0;
        $l$block_5: {
            // Inline function 'kotlinx.serialization.internal.equalsImpl' call
            if (this === other) {
                tmp$ret$0 = true;
                break $l$block_5;
            }
            if (!(other instanceof SerialDescriptorImpl)) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.zo() === other.zo())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
            if (!contentEquals(this.sq_1, other.sq_1)) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.qp() === other.qp())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            var inductionVariable = 0;
            var last = this.qp();
            if (inductionVariable < last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!(this.up(index).zo() === other.up(index).zo())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
                if (!equals(this.up(index).sp(), other.up(index).sp())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
            }while (inductionVariable < last);
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(SerialDescriptorImpl).hashCode = function() {
        return _get__hashCode__tgwhef(this);
    };
    protoOf(SerialDescriptorImpl).toString = function() {
        var tmp = until(0, this.kq_1);
        var tmp_0 = this.iq_1 + "(";
        return joinToString(tmp, ", ", tmp_0, ")", VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
    };
    function PrimitiveSerialDescriptor(serialName, kind) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!isBlank(serialName)) {
            // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
            var message = "Blank serial names are prohibited";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return PrimitiveDescriptorSafe(serialName, kind);
    }
    function buildSerialDescriptor$lambda($this$null) {
        return Unit_instance;
    }
    function buildClassSerialDescriptor$lambda($this$null) {
        return Unit_instance;
    }
    function _hashCode$factory() {
        return getPropertyCallableRef("_hashCode", 1, KProperty1, function(receiver) {
            return _get__hashCode__tgwhef(receiver);
        }, null);
    }
    function ENUM() {
        ENUM_instance = this;
        SerialKind.call(this);
    }
    var ENUM_instance;
    function ENUM_getInstance() {
        if (ENUM_instance == null) new ENUM();
        return ENUM_instance;
    }
    function CONTEXTUAL() {
        CONTEXTUAL_instance = this;
        SerialKind.call(this);
    }
    var CONTEXTUAL_instance;
    function CONTEXTUAL_getInstance() {
        if (CONTEXTUAL_instance == null) new CONTEXTUAL();
        return CONTEXTUAL_instance;
    }
    function SerialKind() {}
    protoOf(SerialKind).toString = function() {
        return ensureNotNull(getKClassFromExpression(this).fa());
    };
    protoOf(SerialKind).hashCode = function() {
        return getStringHashCode(this.toString());
    };
    function BOOLEAN() {
        BOOLEAN_instance = this;
        PrimitiveKind.call(this);
    }
    var BOOLEAN_instance;
    function BOOLEAN_getInstance() {
        if (BOOLEAN_instance == null) new BOOLEAN();
        return BOOLEAN_instance;
    }
    function BYTE() {
        BYTE_instance = this;
        PrimitiveKind.call(this);
    }
    var BYTE_instance;
    function BYTE_getInstance() {
        if (BYTE_instance == null) new BYTE();
        return BYTE_instance;
    }
    function CHAR() {
        CHAR_instance = this;
        PrimitiveKind.call(this);
    }
    var CHAR_instance;
    function CHAR_getInstance() {
        if (CHAR_instance == null) new CHAR();
        return CHAR_instance;
    }
    function SHORT() {
        SHORT_instance = this;
        PrimitiveKind.call(this);
    }
    var SHORT_instance;
    function SHORT_getInstance() {
        if (SHORT_instance == null) new SHORT();
        return SHORT_instance;
    }
    function INT() {
        INT_instance = this;
        PrimitiveKind.call(this);
    }
    var INT_instance;
    function INT_getInstance() {
        if (INT_instance == null) new INT();
        return INT_instance;
    }
    function LONG() {
        LONG_instance = this;
        PrimitiveKind.call(this);
    }
    var LONG_instance;
    function LONG_getInstance() {
        if (LONG_instance == null) new LONG();
        return LONG_instance;
    }
    function FLOAT() {
        FLOAT_instance = this;
        PrimitiveKind.call(this);
    }
    var FLOAT_instance;
    function FLOAT_getInstance() {
        if (FLOAT_instance == null) new FLOAT();
        return FLOAT_instance;
    }
    function DOUBLE() {
        DOUBLE_instance = this;
        PrimitiveKind.call(this);
    }
    var DOUBLE_instance;
    function DOUBLE_getInstance() {
        if (DOUBLE_instance == null) new DOUBLE();
        return DOUBLE_instance;
    }
    function STRING() {
        STRING_instance = this;
        PrimitiveKind.call(this);
    }
    var STRING_instance;
    function STRING_getInstance() {
        if (STRING_instance == null) new STRING();
        return STRING_instance;
    }
    function PrimitiveKind() {
        SerialKind.call(this);
    }
    function CLASS() {
        CLASS_instance = this;
        StructureKind.call(this);
    }
    var CLASS_instance;
    function CLASS_getInstance() {
        if (CLASS_instance == null) new CLASS();
        return CLASS_instance;
    }
    function LIST() {
        LIST_instance = this;
        StructureKind.call(this);
    }
    var LIST_instance;
    function LIST_getInstance() {
        if (LIST_instance == null) new LIST();
        return LIST_instance;
    }
    function MAP() {
        MAP_instance = this;
        StructureKind.call(this);
    }
    var MAP_instance;
    function MAP_getInstance() {
        if (MAP_instance == null) new MAP();
        return MAP_instance;
    }
    function OBJECT() {
        OBJECT_instance = this;
        StructureKind.call(this);
    }
    var OBJECT_instance;
    function OBJECT_getInstance() {
        if (OBJECT_instance == null) new OBJECT();
        return OBJECT_instance;
    }
    function StructureKind() {
        SerialKind.call(this);
    }
    function SEALED() {
        SEALED_instance = this;
        PolymorphicKind.call(this);
    }
    var SEALED_instance;
    function SEALED_getInstance() {
        if (SEALED_instance == null) new SEALED();
        return SEALED_instance;
    }
    function OPEN() {
        OPEN_instance = this;
        PolymorphicKind.call(this);
    }
    var OPEN_instance;
    function OPEN_getInstance() {
        if (OPEN_instance == null) new OPEN();
        return OPEN_instance;
    }
    function PolymorphicKind() {
        SerialKind.call(this);
    }
    function AbstractDecoder() {}
    protoOf(AbstractDecoder).vq = function() {
        throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
    };
    protoOf(AbstractDecoder).wq = function() {
        return true;
    };
    protoOf(AbstractDecoder).xq = function() {
        return null;
    };
    protoOf(AbstractDecoder).yq = function() {
        var tmp = this.vq();
        return typeof tmp === "boolean" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).zq = function() {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).ar = function() {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).br = function() {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).cr = function() {
        var tmp = this.vq();
        return tmp instanceof Long ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).dr = function() {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).er = function() {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).fr = function() {
        var tmp = this.vq();
        return tmp instanceof Char ? tmp.o1_1 : THROW_CCE();
    };
    protoOf(AbstractDecoder).gr = function() {
        var tmp = this.vq();
        return typeof tmp === "string" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).hr = function(enumDescriptor) {
        var tmp = this.vq();
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(AbstractDecoder).ir = function(descriptor) {
        return this;
    };
    protoOf(AbstractDecoder).jr = function(deserializer, previousValue) {
        return this.kr(deserializer);
    };
    protoOf(AbstractDecoder).lr = function(descriptor) {
        return this;
    };
    protoOf(AbstractDecoder).mr = function(descriptor) {};
    protoOf(AbstractDecoder).nr = function(descriptor, index) {
        return this.yq();
    };
    protoOf(AbstractDecoder).or = function(descriptor, index) {
        return this.zq();
    };
    protoOf(AbstractDecoder).pr = function(descriptor, index) {
        return this.ar();
    };
    protoOf(AbstractDecoder).qr = function(descriptor, index) {
        return this.br();
    };
    protoOf(AbstractDecoder).rr = function(descriptor, index) {
        return this.cr();
    };
    protoOf(AbstractDecoder).sr = function(descriptor, index) {
        return this.dr();
    };
    protoOf(AbstractDecoder).tr = function(descriptor, index) {
        return this.er();
    };
    protoOf(AbstractDecoder).ur = function(descriptor, index) {
        return this.fr();
    };
    protoOf(AbstractDecoder).vr = function(descriptor, index) {
        return this.gr();
    };
    protoOf(AbstractDecoder).wr = function(descriptor, index) {
        return this.ir(descriptor.up(index));
    };
    protoOf(AbstractDecoder).xr = function(descriptor, index, deserializer, previousValue) {
        return this.jr(deserializer, previousValue);
    };
    protoOf(AbstractDecoder).zr = function(descriptor, index, deserializer, previousValue) {
        var isNullabilitySupported = deserializer.yn().lp();
        return isNullabilitySupported || this.wq() ? this.jr(deserializer, previousValue) : this.xq();
    };
    function AbstractEncoder() {}
    protoOf(AbstractEncoder).lr = function(descriptor) {
        return this;
    };
    protoOf(AbstractEncoder).mr = function(descriptor) {};
    protoOf(AbstractEncoder).ds = function(descriptor, index) {
        return true;
    };
    protoOf(AbstractEncoder).es = function(value) {
        throw SerializationException_init_$Create$_0("Non-serializable " + toString(getKClassFromExpression(value)) + " is not supported by " + toString(getKClassFromExpression(this)) + " encoder");
    };
    protoOf(AbstractEncoder).fs = function() {
        throw SerializationException_init_$Create$_0("'null' is not supported by default");
    };
    protoOf(AbstractEncoder).gs = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).hs = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).is = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).js = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).ks = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).ls = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).ms = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).ns = function(value) {
        return this.es(new Char(value));
    };
    protoOf(AbstractEncoder).os = function(value) {
        return this.es(value);
    };
    protoOf(AbstractEncoder).ps = function(enumDescriptor, index) {
        return this.es(index);
    };
    protoOf(AbstractEncoder).qs = function(descriptor) {
        return this;
    };
    protoOf(AbstractEncoder).rs = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.gs(value);
    };
    protoOf(AbstractEncoder).ss = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.hs(value);
    };
    protoOf(AbstractEncoder).ts = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.is(value);
    };
    protoOf(AbstractEncoder).us = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.js(value);
    };
    protoOf(AbstractEncoder).vs = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.ks(value);
    };
    protoOf(AbstractEncoder).ws = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.ls(value);
    };
    protoOf(AbstractEncoder).xs = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.ms(value);
    };
    protoOf(AbstractEncoder).ys = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.ns(value);
    };
    protoOf(AbstractEncoder).zs = function(descriptor, index, value) {
        if (this.ds(descriptor, index)) this.os(value);
    };
    protoOf(AbstractEncoder).at = function(descriptor, index) {
        return this.ds(descriptor, index) ? this.qs(descriptor.up(index)) : NoOpEncoder_getInstance();
    };
    protoOf(AbstractEncoder).bt = function(descriptor, index, serializer, value) {
        if (this.ds(descriptor, index)) this.ct(serializer, value);
    };
    protoOf(AbstractEncoder).dt = function(descriptor, index, serializer, value) {
        if (this.ds(descriptor, index)) this.et(serializer, value);
    };
    function Decoder() {}
    function CompositeDecoder() {}
    function Encoder() {}
    function CompositeEncoder() {}
    function decodeSequentially_0($this, compositeDecoder) {
        var klassName = compositeDecoder.vr($this.yn(), 0);
        var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
        return compositeDecoder.yr($this.yn(), 1, serializer);
    }
    function AbstractPolymorphicSerializer() {}
    protoOf(AbstractPolymorphicSerializer).oo = function(encoder, value) {
        var actualSerializer = findPolymorphicSerializer(this, encoder, value);
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.yn();
        var composite = encoder.lr(descriptor);
        // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
        composite.zs(this.yn(), 0, actualSerializer.yn().zo());
        var tmp = this.yn();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
        composite.bt(tmp, 1, tmp$ret$0, value);
        composite.mr(descriptor);
    };
    protoOf(AbstractPolymorphicSerializer).zn = function(encoder, value) {
        return this.oo(encoder, !(value == null) ? value : THROW_CCE());
    };
    protoOf(AbstractPolymorphicSerializer).ao = function(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.yn();
        var composite = decoder.lr(descriptor);
        var tmp$ret$0;
        $l$block: {
            // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
            var klassName = null;
            var value = null;
            if (composite.as()) {
                tmp$ret$0 = decodeSequentially_0(this, composite);
                break $l$block;
            }
            mainLoop: while(true){
                var index = composite.bs(this.yn());
                switch(index){
                    case -1:
                        break mainLoop;
                    case 0:
                        klassName = composite.vr(this.yn(), index);
                        break;
                    case 1:
                        var tmp$ret$2;
                        $l$block_0: {
                            // Inline function 'kotlin.requireNotNull' call
                            var value_0 = klassName;
                            // Inline function 'kotlin.contracts.contract' call
                            if (value_0 == null) {
                                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                                var message = "Cannot read polymorphic value before its type token";
                                throw IllegalArgumentException_init_$Create$(toString(message));
                            } else {
                                tmp$ret$2 = value_0;
                                break $l$block_0;
                            }
                        }
                        klassName = tmp$ret$2;
                        var serializer = findPolymorphicSerializer_0(this, composite, klassName);
                        value = composite.yr(this.yn(), index, serializer);
                        break;
                    default:
                        var tmp0_elvis_lhs = klassName;
                        throw SerializationException_init_$Create$_0("Invalid index in polymorphic deserialization of " + (tmp0_elvis_lhs == null ? "unknown class" : tmp0_elvis_lhs) + ("\n Expected 0, 1 or DECODE_DONE(-1), but found " + index));
                }
            }
            var tmp$ret$4;
            $l$block_1: {
                // Inline function 'kotlin.requireNotNull' call
                var value_1 = value;
                // Inline function 'kotlin.contracts.contract' call
                if (value_1 == null) {
                    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                    var message_0 = "Polymorphic value has not been read for class " + klassName;
                    throw IllegalArgumentException_init_$Create$(toString(message_0));
                } else {
                    tmp$ret$4 = value_1;
                    break $l$block_1;
                }
            }
            var tmp = tmp$ret$4;
            tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
        }
        var result = tmp$ret$0;
        composite.mr(descriptor);
        return result;
    };
    protoOf(AbstractPolymorphicSerializer).po = function(decoder, klassName) {
        return decoder.dp().it(this.no(), klassName);
    };
    protoOf(AbstractPolymorphicSerializer).qo = function(encoder, value) {
        return encoder.dp().jt(this.no(), value);
    };
    function throwSubtypeNotRegistered(subClass, baseClass) {
        var tmp0_elvis_lhs = subClass.fa();
        throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
    }
    function throwSubtypeNotRegistered_0(subClassName, baseClass) {
        var scope = "in the scope of '" + baseClass.fa() + "'";
        throw SerializationException_init_$Create$_0(subClassName == null ? "Class discriminator was missing and no default polymorphic serializers were registered " + scope : "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + ".\n" + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.fa() + "' has to be sealed and '@Serializable'.\n") + ("Alternatively, register the serializer for '" + subClassName + "' explicitly in a corresponding SerializersModule."));
    }
    function NothingSerializer_0() {
        NothingSerializer_instance = this;
        this.kt_1 = NothingSerialDescriptor_getInstance();
    }
    protoOf(NothingSerializer_0).yn = function() {
        return this.kt_1;
    };
    protoOf(NothingSerializer_0).lt = function(encoder, value) {
        throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
    };
    protoOf(NothingSerializer_0).zn = function(encoder, value) {
        var tmp;
        tmp = THROW_CCE();
        return this.lt(encoder, tmp);
    };
    protoOf(NothingSerializer_0).ao = function(decoder) {
        throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
    };
    var NothingSerializer_instance;
    function NothingSerializer_getInstance() {
        if (NothingSerializer_instance == null) new NothingSerializer_0();
        return NothingSerializer_instance;
    }
    function DurationSerializer() {
        DurationSerializer_instance = this;
        this.mt_1 = new PrimitiveSerialDescriptor_0("kotlin.time.Duration", STRING_getInstance());
    }
    protoOf(DurationSerializer).yn = function() {
        return this.mt_1;
    };
    protoOf(DurationSerializer).nt = function(encoder, value) {
        encoder.os(Duration__toIsoString_impl_9h6wsm(value));
    };
    protoOf(DurationSerializer).zn = function(encoder, value) {
        return this.nt(encoder, value instanceof Duration ? value.xi_1 : THROW_CCE());
    };
    protoOf(DurationSerializer).ot = function(decoder) {
        return Companion_getInstance().wi(decoder.gr());
    };
    protoOf(DurationSerializer).ao = function(decoder) {
        return new Duration(this.ot(decoder));
    };
    var DurationSerializer_instance;
    function DurationSerializer_getInstance() {
        if (DurationSerializer_instance == null) new DurationSerializer();
        return DurationSerializer_instance;
    }
    function CachedNames() {}
    function ArrayListClassDesc(elementDesc) {
        ListLikeDescriptor.call(this, elementDesc);
    }
    protoOf(ArrayListClassDesc).zo = function() {
        return "kotlin.collections.ArrayList";
    };
    function HashSetClassDesc(elementDesc) {
        ListLikeDescriptor.call(this, elementDesc);
    }
    protoOf(HashSetClassDesc).zo = function() {
        return "kotlin.collections.HashSet";
    };
    function LinkedHashSetClassDesc(elementDesc) {
        ListLikeDescriptor.call(this, elementDesc);
    }
    protoOf(LinkedHashSetClassDesc).zo = function() {
        return "kotlin.collections.LinkedHashSet";
    };
    function HashMapClassDesc(keyDesc, valueDesc) {
        MapLikeDescriptor.call(this, "kotlin.collections.HashMap", keyDesc, valueDesc);
    }
    function LinkedHashMapClassDesc(keyDesc, valueDesc) {
        MapLikeDescriptor.call(this, "kotlin.collections.LinkedHashMap", keyDesc, valueDesc);
    }
    function ArrayClassDesc(elementDesc) {
        ListLikeDescriptor.call(this, elementDesc);
    }
    protoOf(ArrayClassDesc).zo = function() {
        return "kotlin.Array";
    };
    function ListLikeDescriptor(elementDescriptor) {
        this.rt_1 = elementDescriptor;
        this.st_1 = 1;
    }
    protoOf(ListLikeDescriptor).sp = function() {
        return LIST_getInstance();
    };
    protoOf(ListLikeDescriptor).qp = function() {
        return this.st_1;
    };
    protoOf(ListLikeDescriptor).wp = function(index) {
        return index.toString();
    };
    protoOf(ListLikeDescriptor).vp = function(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalArgumentException_init_$Create$(name + " is not a valid list index");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(ListLikeDescriptor).xp = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return false;
    };
    protoOf(ListLikeDescriptor).tp = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return emptyList();
    };
    protoOf(ListLikeDescriptor).up = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return this.rt_1;
    };
    protoOf(ListLikeDescriptor).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof ListLikeDescriptor)) return false;
        if (equals(this.rt_1, other.rt_1) && this.zo() === other.zo()) return true;
        return false;
    };
    protoOf(ListLikeDescriptor).hashCode = function() {
        return imul(hashCode(this.rt_1), 31) + getStringHashCode(this.zo()) | 0;
    };
    protoOf(ListLikeDescriptor).toString = function() {
        return this.zo() + "(" + toString(this.rt_1) + ")";
    };
    function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
        this.xt_1 = serialName;
        this.yt_1 = keyDescriptor;
        this.zt_1 = valueDescriptor;
        this.au_1 = 2;
    }
    protoOf(MapLikeDescriptor).zo = function() {
        return this.xt_1;
    };
    protoOf(MapLikeDescriptor).sp = function() {
        return MAP_getInstance();
    };
    protoOf(MapLikeDescriptor).qp = function() {
        return this.au_1;
    };
    protoOf(MapLikeDescriptor).wp = function(index) {
        return index.toString();
    };
    protoOf(MapLikeDescriptor).vp = function(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalArgumentException_init_$Create$(name + " is not a valid map index");
        else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(MapLikeDescriptor).xp = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return false;
    };
    protoOf(MapLikeDescriptor).tp = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return emptyList();
    };
    protoOf(MapLikeDescriptor).up = function(index) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(index >= 0)) {
            // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
            var message = "Illegal index " + index + ", " + this.zo() + " expects only non-negative indices";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var tmp;
        switch(index % 2 | 0){
            case 0:
                tmp = this.yt_1;
                break;
            case 1:
                tmp = this.zt_1;
                break;
            default:
                var message_0 = "Unreached";
                throw IllegalStateException_init_$Create$(toString(message_0));
        }
        return tmp;
    };
    protoOf(MapLikeDescriptor).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof MapLikeDescriptor)) return false;
        if (!(this.zo() === other.zo())) return false;
        if (!equals(this.yt_1, other.yt_1)) return false;
        if (!equals(this.zt_1, other.zt_1)) return false;
        return true;
    };
    protoOf(MapLikeDescriptor).hashCode = function() {
        var result = getStringHashCode(this.zo());
        result = imul(31, result) + hashCode(this.yt_1) | 0;
        result = imul(31, result) + hashCode(this.zt_1) | 0;
        return result;
    };
    protoOf(MapLikeDescriptor).toString = function() {
        return this.zo() + "(" + toString(this.yt_1) + ", " + toString(this.zt_1) + ")";
    };
    function PrimitiveArrayDescriptor(primitive) {
        ListLikeDescriptor.call(this, primitive);
        this.fu_1 = primitive.zo() + "Array";
    }
    protoOf(PrimitiveArrayDescriptor).zo = function() {
        return this.fu_1;
    };
    function ArrayListSerializer(element) {
        CollectionSerializer.call(this, element);
        this.hu_1 = new ArrayListClassDesc(element.yn());
    }
    protoOf(ArrayListSerializer).yn = function() {
        return this.hu_1;
    };
    protoOf(ArrayListSerializer).iu = function() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList_init_$Create$_0();
    };
    protoOf(ArrayListSerializer).ju = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(ArrayListSerializer).ku = function(_this__u8e3s4) {
        return this.ju(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ArrayListSerializer).lu = function(_this__u8e3s4) {
        return _this__u8e3s4;
    };
    protoOf(ArrayListSerializer).mu = function(_this__u8e3s4) {
        return this.lu(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ArrayListSerializer).nu = function(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
    };
    protoOf(ArrayListSerializer).ou = function(_this__u8e3s4) {
        return this.nu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ArrayListSerializer).pu = function(_this__u8e3s4, size) {
        return _this__u8e3s4.q5(size);
    };
    protoOf(ArrayListSerializer).qu = function(_this__u8e3s4, size) {
        return this.pu(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
    };
    protoOf(ArrayListSerializer).ru = function(_this__u8e3s4, index, element) {
        _this__u8e3s4.k2(index, element);
    };
    protoOf(ArrayListSerializer).su = function(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
        return this.ru(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    function HashSetSerializer(eSerializer) {
        CollectionSerializer.call(this, eSerializer);
        this.dv_1 = new HashSetClassDesc(eSerializer.yn());
    }
    protoOf(HashSetSerializer).yn = function() {
        return this.dv_1;
    };
    protoOf(HashSetSerializer).iu = function() {
        return HashSet_init_$Create$();
    };
    protoOf(HashSetSerializer).ev = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(HashSetSerializer).ku = function(_this__u8e3s4) {
        return this.ev(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashSetSerializer).fv = function(_this__u8e3s4) {
        return _this__u8e3s4;
    };
    protoOf(HashSetSerializer).mu = function(_this__u8e3s4) {
        return this.fv(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashSetSerializer).gv = function(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
    };
    protoOf(HashSetSerializer).ou = function(_this__u8e3s4) {
        return this.gv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashSetSerializer).hv = function(_this__u8e3s4, size) {};
    protoOf(HashSetSerializer).qu = function(_this__u8e3s4, size) {
        return this.hv(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
    };
    protoOf(HashSetSerializer).iv = function(_this__u8e3s4, index, element) {
        _this__u8e3s4.e(element);
    };
    protoOf(HashSetSerializer).su = function(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
        return this.iv(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    function LinkedHashSetSerializer(eSerializer) {
        CollectionSerializer.call(this, eSerializer);
        this.kv_1 = new LinkedHashSetClassDesc(eSerializer.yn());
    }
    protoOf(LinkedHashSetSerializer).yn = function() {
        return this.kv_1;
    };
    protoOf(LinkedHashSetSerializer).iu = function() {
        // Inline function 'kotlin.collections.linkedSetOf' call
        return LinkedHashSet_init_$Create$();
    };
    protoOf(LinkedHashSetSerializer).lv = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(LinkedHashSetSerializer).ku = function(_this__u8e3s4) {
        return this.lv(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashSetSerializer).mv = function(_this__u8e3s4) {
        return _this__u8e3s4;
    };
    protoOf(LinkedHashSetSerializer).mu = function(_this__u8e3s4) {
        return this.mv(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashSetSerializer).gv = function(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
    };
    protoOf(LinkedHashSetSerializer).ou = function(_this__u8e3s4) {
        return this.gv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashSetSerializer).nv = function(_this__u8e3s4, size) {};
    protoOf(LinkedHashSetSerializer).qu = function(_this__u8e3s4, size) {
        return this.nv(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
    };
    protoOf(LinkedHashSetSerializer).ov = function(_this__u8e3s4, index, element) {
        _this__u8e3s4.e(element);
    };
    protoOf(LinkedHashSetSerializer).su = function(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
        return this.ov(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    function HashMapSerializer(kSerializer, vSerializer) {
        MapLikeSerializer.call(this, kSerializer, vSerializer);
        this.rv_1 = new HashMapClassDesc(kSerializer.yn(), vSerializer.yn());
    }
    protoOf(HashMapSerializer).yn = function() {
        return this.rv_1;
    };
    protoOf(HashMapSerializer).sv = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(HashMapSerializer).tv = function(_this__u8e3s4) {
        return this.sv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashMapSerializer).uv = function(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.z().j();
    };
    protoOf(HashMapSerializer).vv = function(_this__u8e3s4) {
        return this.uv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashMapSerializer).iu = function() {
        return HashMap_init_$Create$();
    };
    protoOf(HashMapSerializer).wv = function(_this__u8e3s4) {
        return imul(_this__u8e3s4.m(), 2);
    };
    protoOf(HashMapSerializer).ku = function(_this__u8e3s4) {
        return this.wv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashMapSerializer).xv = function(_this__u8e3s4) {
        return _this__u8e3s4;
    };
    protoOf(HashMapSerializer).mu = function(_this__u8e3s4) {
        return this.xv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashMapSerializer).yv = function(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
    };
    protoOf(HashMapSerializer).ou = function(_this__u8e3s4) {
        return this.yv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(HashMapSerializer).zv = function(_this__u8e3s4, size) {};
    protoOf(HashMapSerializer).qu = function(_this__u8e3s4, size) {
        return this.zv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
    };
    function LinkedHashMapSerializer(kSerializer, vSerializer) {
        MapLikeSerializer.call(this, kSerializer, vSerializer);
        this.gw_1 = new LinkedHashMapClassDesc(kSerializer.yn(), vSerializer.yn());
    }
    protoOf(LinkedHashMapSerializer).yn = function() {
        return this.gw_1;
    };
    protoOf(LinkedHashMapSerializer).sv = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(LinkedHashMapSerializer).tv = function(_this__u8e3s4) {
        return this.sv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashMapSerializer).uv = function(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.z().j();
    };
    protoOf(LinkedHashMapSerializer).vv = function(_this__u8e3s4) {
        return this.uv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashMapSerializer).iu = function() {
        return LinkedHashMap_init_$Create$();
    };
    protoOf(LinkedHashMapSerializer).hw = function(_this__u8e3s4) {
        return imul(_this__u8e3s4.m(), 2);
    };
    protoOf(LinkedHashMapSerializer).ku = function(_this__u8e3s4) {
        return this.hw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashMapSerializer).iw = function(_this__u8e3s4) {
        return _this__u8e3s4;
    };
    protoOf(LinkedHashMapSerializer).mu = function(_this__u8e3s4) {
        return this.iw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashMapSerializer).yv = function(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
        return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
    };
    protoOf(LinkedHashMapSerializer).ou = function(_this__u8e3s4) {
        return this.yv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LinkedHashMapSerializer).jw = function(_this__u8e3s4, size) {};
    protoOf(LinkedHashMapSerializer).qu = function(_this__u8e3s4, size) {
        return this.jw(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
    };
    function ReferenceArraySerializer(kClass, eSerializer) {
        CollectionLikeSerializer.call(this, eSerializer);
        this.lw_1 = kClass;
        this.mw_1 = new ArrayClassDesc(eSerializer.yn());
    }
    protoOf(ReferenceArraySerializer).yn = function() {
        return this.mw_1;
    };
    protoOf(ReferenceArraySerializer).nw = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(ReferenceArraySerializer).tv = function(_this__u8e3s4) {
        return this.nw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ReferenceArraySerializer).ow = function(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
    };
    protoOf(ReferenceArraySerializer).vv = function(_this__u8e3s4) {
        return this.ow((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ReferenceArraySerializer).iu = function() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList_init_$Create$_0();
    };
    protoOf(ReferenceArraySerializer).pw = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(ReferenceArraySerializer).ku = function(_this__u8e3s4) {
        return this.pw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ReferenceArraySerializer).qw = function(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.lw_1);
    };
    protoOf(ReferenceArraySerializer).mu = function(_this__u8e3s4) {
        return this.qw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ReferenceArraySerializer).rw = function(_this__u8e3s4) {
        return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
    };
    protoOf(ReferenceArraySerializer).ou = function(_this__u8e3s4) {
        return this.rw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ReferenceArraySerializer).sw = function(_this__u8e3s4, size) {
        return _this__u8e3s4.q5(size);
    };
    protoOf(ReferenceArraySerializer).qu = function(_this__u8e3s4, size) {
        return this.sw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
    };
    protoOf(ReferenceArraySerializer).tw = function(_this__u8e3s4, index, element) {
        _this__u8e3s4.k2(index, element);
    };
    protoOf(ReferenceArraySerializer).su = function(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
        return this.tw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    function CollectionSerializer(element) {
        CollectionLikeSerializer.call(this, element);
    }
    protoOf(CollectionSerializer).uu = function(_this__u8e3s4) {
        return _this__u8e3s4.m();
    };
    protoOf(CollectionSerializer).tv = function(_this__u8e3s4) {
        return this.uu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(CollectionSerializer).vu = function(_this__u8e3s4) {
        return _this__u8e3s4.j();
    };
    protoOf(CollectionSerializer).vv = function(_this__u8e3s4) {
        return this.vu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    function MapLikeSerializer(keySerializer, valueSerializer) {
        AbstractCollectionSerializer.call(this);
        this.aw_1 = keySerializer;
        this.bw_1 = valueSerializer;
    }
    protoOf(MapLikeSerializer).cw = function(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(size >= 0)) {
            // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
            var message = "Size must be known in advance when using READ_ALL";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.d1_1;
        var last = progression.e1_1;
        var step_0 = progression.f1_1;
        if (step_0 > 0 && inductionVariable <= last || step_0 < 0 && last <= inductionVariable) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.dw(decoder, startIndex + index | 0, builder, false);
        }while (!(index === last));
    };
    protoOf(MapLikeSerializer).yu = function(decoder, builder, startIndex, size) {
        return this.cw(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
    };
    protoOf(MapLikeSerializer).dw = function(decoder, index, builder, checkIndex) {
        var key = decoder.yr(this.yn(), index, this.aw_1);
        var tmp;
        if (checkIndex) {
            // Inline function 'kotlin.also' call
            var this_0 = decoder.bs(this.yn());
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(this_0 === (index + 1 | 0))) {
                // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
                var message = "Value must follow key in a map, index for key: " + index + ", returned index for value: " + this_0;
                throw IllegalArgumentException_init_$Create$(toString(message));
            }
            tmp = this_0;
        } else tmp = index + 1 | 0;
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.c2(key)) {
            var tmp_2 = this.bw_1.yn().sp();
            tmp_1 = !(tmp_2 instanceof PrimitiveKind);
        } else tmp_1 = false;
        if (tmp_1) tmp_0 = decoder.xr(this.yn(), vIndex, this.bw_1, getValue(builder, key));
        else tmp_0 = decoder.yr(this.yn(), vIndex, this.bw_1);
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.m2(key, value);
    };
    protoOf(MapLikeSerializer).zu = function(decoder, index, builder, checkIndex) {
        return this.dw(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(MapLikeSerializer).xu = function(encoder, value) {
        var size = this.tv(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.yn();
        var composite = encoder.gt(descriptor, size);
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
        var iterator = this.vv(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = iterator;
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var k = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var v = element.b1();
            var tmp = this.yn();
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            composite.bt(tmp, tmp0, this.aw_1, k);
            var tmp_0 = this.yn();
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            composite.bt(tmp_0, tmp1, this.bw_1, v);
        }
        composite.mr(descriptor);
    };
    protoOf(MapLikeSerializer).zn = function(encoder, value) {
        return this.xu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    function CollectionLikeSerializer(elementSerializer) {
        AbstractCollectionSerializer.call(this);
        this.wu_1 = elementSerializer;
    }
    protoOf(CollectionLikeSerializer).xu = function(encoder, value) {
        var size = this.tv(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.yn();
        var composite = encoder.gt(descriptor, size);
        // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
        var iterator = this.vv(value);
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.bt(this.yn(), index, this.wu_1, iterator.l());
        }while (inductionVariable < size);
        composite.mr(descriptor);
    };
    protoOf(CollectionLikeSerializer).zn = function(encoder, value) {
        return this.xu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(CollectionLikeSerializer).yu = function(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(size >= 0)) {
            // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
            var message = "Size must be known in advance when using READ_ALL";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.zu(decoder, startIndex + index | 0, builder, false);
        }while (inductionVariable < size);
    };
    protoOf(CollectionLikeSerializer).zu = function(decoder, index, builder, checkIndex) {
        this.su(builder, index, decoder.yr(this.yn(), index, this.wu_1));
    };
    function readSize($this, decoder, builder) {
        var size = decoder.cs($this.yn());
        $this.qu(builder, size);
        return size;
    }
    function AbstractCollectionSerializer() {}
    protoOf(AbstractCollectionSerializer).bv = function(decoder, previous) {
        var tmp1_elvis_lhs = previous == null ? null : this.ou(previous);
        var builder = tmp1_elvis_lhs == null ? this.iu() : tmp1_elvis_lhs;
        var startIndex = this.ku(builder);
        var compositeDecoder = decoder.lr(this.yn());
        if (compositeDecoder.as()) this.yu(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
        else $l$loop: while(true){
            var index = compositeDecoder.bs(this.yn());
            if (index === -1) break $l$loop;
            this.av(compositeDecoder, startIndex + index | 0, builder);
        }
        compositeDecoder.mr(this.yn());
        return this.mu(builder);
    };
    protoOf(AbstractCollectionSerializer).ao = function(decoder) {
        return this.bv(decoder, null);
    };
    protoOf(AbstractCollectionSerializer).av = function(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
            this.zu(decoder, index, builder, checkIndex);
            tmp = Unit_instance;
        } else tmp = $super.zu.call(this, decoder, index, builder, checkIndex);
        return tmp;
    };
    function PrimitiveArraySerializer(primitiveSerializer) {
        CollectionLikeSerializer.call(this, primitiveSerializer);
        this.vw_1 = new PrimitiveArrayDescriptor(primitiveSerializer.yn());
    }
    protoOf(PrimitiveArraySerializer).yn = function() {
        return this.vw_1;
    };
    protoOf(PrimitiveArraySerializer).ww = function(_this__u8e3s4) {
        return _this__u8e3s4.xw();
    };
    protoOf(PrimitiveArraySerializer).ku = function(_this__u8e3s4) {
        return this.ww(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).yw = function(_this__u8e3s4) {
        return _this__u8e3s4.zw();
    };
    protoOf(PrimitiveArraySerializer).mu = function(_this__u8e3s4) {
        return this.yw(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).ax = function(_this__u8e3s4, size) {
        return _this__u8e3s4.bx(size);
    };
    protoOf(PrimitiveArraySerializer).qu = function(_this__u8e3s4, size) {
        return this.ax(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
    };
    protoOf(PrimitiveArraySerializer).cx = function(_this__u8e3s4) {
        var message = "This method lead to boxing and must not be used, use writeContents instead";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(PrimitiveArraySerializer).vv = function(_this__u8e3s4) {
        return this.cx((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).dx = function(_this__u8e3s4, index, element) {
        var message = "This method lead to boxing and must not be used, use Builder.append instead";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(PrimitiveArraySerializer).su = function(_this__u8e3s4, index, element) {
        var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
        return this.dx(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).iu = function() {
        return this.ou(this.ex());
    };
    protoOf(PrimitiveArraySerializer).hx = function(encoder, value) {
        var size = this.tv(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.vw_1;
        var composite = encoder.gt(descriptor, size);
        // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
        this.gx(composite, value, size);
        composite.mr(descriptor);
    };
    protoOf(PrimitiveArraySerializer).zn = function(encoder, value) {
        return this.hx(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).xu = function(encoder, value) {
        return this.hx(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(PrimitiveArraySerializer).ao = function(decoder) {
        return this.bv(decoder, null);
    };
    function PrimitiveArrayBuilder() {}
    protoOf(PrimitiveArrayBuilder).ix = function(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.xw() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
            this.bx(requiredCapacity);
            tmp = Unit_instance;
        } else tmp = $super.bx.call(this, requiredCapacity);
        return tmp;
    };
    function Companion() {
        Companion_instance_0 = this;
        this.jx_1 = longArray(0);
    }
    var Companion_instance_0;
    function Companion_getInstance_6() {
        if (Companion_instance_0 == null) new Companion();
        return Companion_instance_0;
    }
    function prepareHighMarksArray($this, elementsCount) {
        var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
        var elementsInLastSlot = elementsCount & 63;
        var highMarks = longArray(slotsCount);
        if (!(elementsInLastSlot === 0)) highMarks[get_lastIndex(highMarks)] = new Long(-1, -1).h3(elementsCount);
        return highMarks;
    }
    function markHigh($this, index) {
        var slot = (index >>> 6 | 0) - 1 | 0;
        var offsetInSlot = index & 63;
        $this.nx_1[slot] = $this.nx_1[slot].l3(new Long(1, 0).h3(offsetInSlot));
    }
    function nextUnmarkedHighIndex($this) {
        var inductionVariable = 0;
        var last = $this.nx_1.length - 1 | 0;
        if (inductionVariable <= last) do {
            var slot = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slotOffset = imul(slot + 1 | 0, 64);
            var slotMarks = $this.nx_1[slot];
            while(!slotMarks.equals(new Long(-1, -1))){
                var indexInSlot = countTrailingZeroBits(slotMarks.g3());
                slotMarks = slotMarks.l3(new Long(1, 0).h3(indexInSlot));
                var index = slotOffset + indexInSlot | 0;
                if ($this.lx_1($this.kx_1, index)) {
                    $this.nx_1[slot] = slotMarks;
                    return index;
                }
            }
            $this.nx_1[slot] = slotMarks;
        }while (inductionVariable <= last);
        return -1;
    }
    function ElementMarker(descriptor, readIfAbsent) {
        Companion_getInstance_6();
        this.kx_1 = descriptor;
        this.lx_1 = readIfAbsent;
        var elementsCount = this.kx_1.qp();
        if (elementsCount <= 64) {
            var tmp = this;
            var tmp_0;
            if (elementsCount === 64) tmp_0 = new Long(0, 0);
            else tmp_0 = new Long(-1, -1).h3(elementsCount);
            tmp.mx_1 = tmp_0;
            this.nx_1 = Companion_getInstance_6().jx_1;
        } else {
            this.mx_1 = new Long(0, 0);
            this.nx_1 = prepareHighMarksArray(this, elementsCount);
        }
    }
    protoOf(ElementMarker).ox = function(index) {
        if (index < 64) this.mx_1 = this.mx_1.l3(new Long(1, 0).h3(index));
        else markHigh(this, index);
    };
    protoOf(ElementMarker).px = function() {
        var elementsCount = this.kx_1.qp();
        while(!this.mx_1.equals(new Long(-1, -1))){
            var index = countTrailingZeroBits(this.mx_1.g3());
            this.mx_1 = this.mx_1.l3(new Long(1, 0).h3(index));
            if (this.lx_1(this.kx_1, index)) return index;
        }
        if (elementsCount > 64) return nextUnmarkedHighIndex(this);
        return -1;
    };
    function createSimpleEnumSerializer(serialName, values) {
        return new EnumSerializer(serialName, values);
    }
    function createUnmarkedDescriptor($this, serialName) {
        var d = new EnumDescriptor(serialName, $this.qx_1.length);
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = $this.qx_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while(inductionVariable < last){
            var element = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
            d.fy(element.p2_1);
        }
        return d;
    }
    function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
        return function() {
            var tmp0_elvis_lhs = this$0.rx_1;
            return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
        };
    }
    function EnumSerializer(serialName, values) {
        this.qx_1 = values;
        this.rx_1 = null;
        var tmp = this;
        tmp.sx_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
    }
    protoOf(EnumSerializer).yn = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.sx_1;
        descriptor$factory_1();
        return this_0.b1();
    };
    protoOf(EnumSerializer).gy = function(encoder, value) {
        var index = indexOf(this.qx_1, value);
        if (index === -1) throw SerializationException_init_$Create$_0(toString(value) + " is not a valid enum " + this.yn().zo() + ", " + ("must be one of " + contentToString(this.qx_1)));
        encoder.ps(this.yn(), index);
    };
    protoOf(EnumSerializer).zn = function(encoder, value) {
        return this.gy(encoder, value instanceof Enum ? value : THROW_CCE());
    };
    protoOf(EnumSerializer).ao = function(decoder) {
        var index = decoder.hr(this.yn());
        if (!(0 <= index ? index <= (this.qx_1.length - 1 | 0) : false)) throw SerializationException_init_$Create$_0("" + index + " is not among valid " + this.yn().zo() + " enum values, " + ("values size is " + this.qx_1.length));
        return this.qx_1[index];
    };
    protoOf(EnumSerializer).toString = function() {
        return "kotlinx.serialization.internal.EnumSerializer<" + this.yn().zo() + ">";
    };
    function _get_elementDescriptors__y23q9p($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.uy_1;
        elementDescriptors$factory();
        return this_0.b1();
    }
    function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
        return function() {
            var tmp = 0;
            var tmp_0 = $elementsCount;
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_1 = fillArrayVal(Array(tmp_0), null);
            while(tmp < tmp_0){
                var tmp_2 = tmp;
                tmp_1[tmp_2] = buildSerialDescriptor($name + "." + this$0.wp(tmp_2), OBJECT_getInstance(), []);
                tmp = tmp + 1 | 0;
            }
            return tmp_1;
        };
    }
    function EnumDescriptor(name, elementsCount) {
        PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
        this.ty_1 = ENUM_getInstance();
        var tmp = this;
        tmp.uy_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
    }
    protoOf(EnumDescriptor).sp = function() {
        return this.ty_1;
    };
    protoOf(EnumDescriptor).up = function(index) {
        return getChecked(_get_elementDescriptors__y23q9p(this), index);
    };
    protoOf(EnumDescriptor).equals = function(other) {
        if (this === other) return true;
        if (other == null) return false;
        if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false)) return false;
        if (!(other.sp() === ENUM_getInstance())) return false;
        if (!(this.zo() === other.zo())) return false;
        if (!equals(cachedSerialNames(this), cachedSerialNames(other))) return false;
        return true;
    };
    protoOf(EnumDescriptor).toString = function() {
        return joinToString(get_elementNames(this), ", ", this.zo() + "(", ")");
    };
    protoOf(EnumDescriptor).hashCode = function() {
        var result = getStringHashCode(this.zo());
        // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
        // Inline function 'kotlin.collections.fold' call
        var accumulator = 1;
        var tmp0_iterator = get_elementNames(this).j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
            var hash = accumulator;
            var tmp = imul(31, hash);
            // Inline function 'kotlin.hashCode' call
            // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
            var tmp1_elvis_lhs = element == null ? null : hashCode(element);
            accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        var elementsHashCode = accumulator;
        result = imul(31, result) + elementsHashCode | 0;
        return result;
    };
    function descriptor$factory_1() {
        return getPropertyCallableRef("descriptor", 1, KProperty1, function(receiver) {
            return receiver.yn();
        }, null);
    }
    function elementDescriptors$factory() {
        return getPropertyCallableRef("elementDescriptors", 1, KProperty1, function(receiver) {
            return _get_elementDescriptors__y23q9p(receiver);
        }, null);
    }
    function InlinePrimitiveDescriptor(name, primitiveSerializer) {
        return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
    }
    function InlineClassDescriptor(name, generatedSerializer) {
        PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
        this.jz_1 = true;
    }
    protoOf(InlineClassDescriptor).rp = function() {
        return this.jz_1;
    };
    protoOf(InlineClassDescriptor).hashCode = function() {
        return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
    };
    protoOf(InlineClassDescriptor).equals = function(other) {
        var tmp$ret$0;
        $l$block_5: {
            // Inline function 'kotlinx.serialization.internal.equalsImpl' call
            if (this === other) {
                tmp$ret$0 = true;
                break $l$block_5;
            }
            if (!(other instanceof InlineClassDescriptor)) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.zo() === other.zo())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
            if (!(other.jz_1 && contentEquals(this.vy(), other.vy()))) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.qp() === other.qp())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            var inductionVariable = 0;
            var last = this.qp();
            if (inductionVariable < last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!(this.up(index).zo() === other.up(index).zo())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
                if (!equals(this.up(index).sp(), other.up(index).sp())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
            }while (inductionVariable < last);
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    function InlinePrimitiveDescriptor$1($primitiveSerializer) {
        this.kz_1 = $primitiveSerializer;
    }
    protoOf(InlinePrimitiveDescriptor$1).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            this.kz_1
        ];
    };
    protoOf(InlinePrimitiveDescriptor$1).yn = function() {
        var message = "unsupported";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(InlinePrimitiveDescriptor$1).zn = function(encoder, value) {
        // Inline function 'kotlin.error' call
        var message = "unsupported";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(InlinePrimitiveDescriptor$1).ao = function(decoder) {
        // Inline function 'kotlin.error' call
        var message = "unsupported";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    function jsonCachedSerialNames(_this__u8e3s4) {
        return cachedSerialNames(_this__u8e3s4);
    }
    function NoOpEncoder() {
        NoOpEncoder_instance = this;
        AbstractEncoder.call(this);
        this.nz_1 = EmptySerializersModule_0();
    }
    protoOf(NoOpEncoder).dp = function() {
        return this.nz_1;
    };
    protoOf(NoOpEncoder).es = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).fs = function() {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).gs = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).hs = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).is = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).js = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).ks = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).ls = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).ms = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).ns = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).os = function(value) {
        return Unit_instance;
    };
    protoOf(NoOpEncoder).ps = function(enumDescriptor, index) {
        return Unit_instance;
    };
    var NoOpEncoder_instance;
    function NoOpEncoder_getInstance() {
        if (NoOpEncoder_instance == null) new NoOpEncoder();
        return NoOpEncoder_instance;
    }
    function error($this) {
        throw IllegalStateException_init_$Create$("Descriptor for type `kotlin.Nothing` does not have elements");
    }
    function NothingSerialDescriptor() {
        NothingSerialDescriptor_instance = this;
        this.oz_1 = OBJECT_getInstance();
        this.pz_1 = "kotlin.Nothing";
    }
    protoOf(NothingSerialDescriptor).sp = function() {
        return this.oz_1;
    };
    protoOf(NothingSerialDescriptor).zo = function() {
        return this.pz_1;
    };
    protoOf(NothingSerialDescriptor).qp = function() {
        return 0;
    };
    protoOf(NothingSerialDescriptor).wp = function(index) {
        error(this);
    };
    protoOf(NothingSerialDescriptor).vp = function(name) {
        error(this);
    };
    protoOf(NothingSerialDescriptor).xp = function(index) {
        error(this);
    };
    protoOf(NothingSerialDescriptor).up = function(index) {
        error(this);
    };
    protoOf(NothingSerialDescriptor).tp = function(index) {
        error(this);
    };
    protoOf(NothingSerialDescriptor).toString = function() {
        return "NothingSerialDescriptor";
    };
    protoOf(NothingSerialDescriptor).equals = function(other) {
        return this === other;
    };
    protoOf(NothingSerialDescriptor).hashCode = function() {
        return getStringHashCode(this.pz_1) + imul(31, this.oz_1.hashCode()) | 0;
    };
    var NothingSerialDescriptor_instance;
    function NothingSerialDescriptor_getInstance() {
        if (NothingSerialDescriptor_instance == null) new NothingSerialDescriptor();
        return NothingSerialDescriptor_instance;
    }
    function NullableSerializer(serializer) {
        this.qz_1 = serializer;
        this.rz_1 = new SerialDescriptorForNullable(this.qz_1.yn());
    }
    protoOf(NullableSerializer).yn = function() {
        return this.rz_1;
    };
    protoOf(NullableSerializer).sz = function(encoder, value) {
        if (!(value == null)) {
            encoder.ft();
            encoder.ct(this.qz_1, value);
        } else encoder.fs();
    };
    protoOf(NullableSerializer).zn = function(encoder, value) {
        return this.sz(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(NullableSerializer).ao = function(decoder) {
        return decoder.wq() ? decoder.kr(this.qz_1) : decoder.xq();
    };
    protoOf(NullableSerializer).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof NullableSerializer)) THROW_CCE();
        if (!equals(this.qz_1, other.qz_1)) return false;
        return true;
    };
    protoOf(NullableSerializer).hashCode = function() {
        return hashCode(this.qz_1);
    };
    function SerialDescriptorForNullable(original) {
        this.yp_1 = original;
        this.zp_1 = this.yp_1.zo() + "?";
        this.aq_1 = cachedSerialNames(this.yp_1);
    }
    protoOf(SerialDescriptorForNullable).pp = function() {
        return this.yp_1.pp();
    };
    protoOf(SerialDescriptorForNullable).qp = function() {
        return this.yp_1.qp();
    };
    protoOf(SerialDescriptorForNullable).rp = function() {
        return this.yp_1.rp();
    };
    protoOf(SerialDescriptorForNullable).sp = function() {
        return this.yp_1.sp();
    };
    protoOf(SerialDescriptorForNullable).tp = function(index) {
        return this.yp_1.tp(index);
    };
    protoOf(SerialDescriptorForNullable).up = function(index) {
        return this.yp_1.up(index);
    };
    protoOf(SerialDescriptorForNullable).vp = function(name) {
        return this.yp_1.vp(name);
    };
    protoOf(SerialDescriptorForNullable).wp = function(index) {
        return this.yp_1.wp(index);
    };
    protoOf(SerialDescriptorForNullable).xp = function(index) {
        return this.yp_1.xp(index);
    };
    protoOf(SerialDescriptorForNullable).zo = function() {
        return this.zp_1;
    };
    protoOf(SerialDescriptorForNullable).uq = function() {
        return this.aq_1;
    };
    protoOf(SerialDescriptorForNullable).lp = function() {
        return true;
    };
    protoOf(SerialDescriptorForNullable).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SerialDescriptorForNullable)) return false;
        if (!equals(this.yp_1, other.yp_1)) return false;
        return true;
    };
    protoOf(SerialDescriptorForNullable).toString = function() {
        return toString(this.yp_1) + "?";
    };
    protoOf(SerialDescriptorForNullable).hashCode = function() {
        return imul(hashCode(this.yp_1), 31);
    };
    function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
        return function($this$buildSerialDescriptor) {
            $this$buildSerialDescriptor.go_1 = this$0.uz_1;
            return Unit_instance;
        };
    }
    function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
        return function() {
            var tmp = OBJECT_getInstance();
            return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
        };
    }
    function ObjectSerializer(serialName, objectInstance) {
        this.tz_1 = objectInstance;
        this.uz_1 = emptyList();
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.vz_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
    }
    protoOf(ObjectSerializer).yn = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.vz_1;
        descriptor$factory_2();
        return this_0.b1();
    };
    protoOf(ObjectSerializer).oo = function(encoder, value) {
        encoder.lr(this.yn()).mr(this.yn());
    };
    protoOf(ObjectSerializer).zn = function(encoder, value) {
        return this.oo(encoder, !(value == null) ? value : THROW_CCE());
    };
    protoOf(ObjectSerializer).ao = function(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.yn();
        var composite = decoder.lr(descriptor);
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
            if (composite.as()) {
                tmp$ret$0 = Unit_instance;
                break $l$block_0;
            }
            var index = composite.bs(this.yn());
            if (index === -1) {
                tmp$ret$0 = Unit_instance;
                break $l$block_0;
            } else throw SerializationException_init_$Create$_0("Unexpected index " + index);
        }
        var result = tmp$ret$0;
        composite.mr(descriptor);
        return this.tz_1;
    };
    function descriptor$factory_2() {
        return getPropertyCallableRef("descriptor", 1, KProperty1, function(receiver) {
            return receiver.yn();
        }, null);
    }
    function get_EMPTY_DESCRIPTOR_ARRAY() {
        _init_properties_Platform_common_kt__3qzecs();
        return EMPTY_DESCRIPTOR_ARRAY;
    }
    var EMPTY_DESCRIPTOR_ARRAY;
    function cachedSerialNames(_this__u8e3s4) {
        _init_properties_Platform_common_kt__3qzecs();
        if (isInterface(_this__u8e3s4, CachedNames)) return _this__u8e3s4.uq();
        var result = HashSet_init_$Create$_1(_this__u8e3s4.qp());
        var inductionVariable = 0;
        var last = _this__u8e3s4.qp();
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.plusAssign' call
            var element = _this__u8e3s4.wp(i);
            result.e(element);
        }while (inductionVariable < last);
        return result;
    }
    function kclass(_this__u8e3s4) {
        _init_properties_Platform_common_kt__3qzecs();
        var t = _this__u8e3s4.ta();
        var tmp;
        if (!(t == null) ? isInterface(t, KClass) : false) tmp = t;
        else if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
            var message = "Captured type parameter " + toString_0(t) + " from generic non-reified function. " + ("Such functionality cannot be supported as " + toString_0(t) + " is erased, either specify serializer explicitly or make ") + ("calling function inline with reified " + toString_0(t));
            throw IllegalStateException_init_$Create$(toString(message));
        } else {
            var message_0 = "Only KClass supported as classifier, got " + toString_0(t);
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
        var tmp_0 = tmp;
        return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
    }
    function notRegisteredMessage(_this__u8e3s4) {
        _init_properties_Platform_common_kt__3qzecs();
        var tmp0_elvis_lhs = _this__u8e3s4.fa();
        return notRegisteredMessage_0(tmp0_elvis_lhs == null ? "<local class name not available>" : tmp0_elvis_lhs);
    }
    function notRegisteredMessage_0(className) {
        _init_properties_Platform_common_kt__3qzecs();
        return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
    }
    function compactArray(_this__u8e3s4) {
        _init_properties_Platform_common_kt__3qzecs();
        // Inline function 'kotlin.takeUnless' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(_this__u8e3s4 == null || _this__u8e3s4.s())) tmp = _this__u8e3s4;
        else tmp = null;
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp0_safe_receiver);
        var tmp1_elvis_lhs = tmp_0;
        return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
    }
    function serializerNotRegistered(_this__u8e3s4) {
        _init_properties_Platform_common_kt__3qzecs();
        throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
    }
    var properties_initialized_Platform_common_kt_i7q4ty;
    function _init_properties_Platform_common_kt__3qzecs() {
        if (!properties_initialized_Platform_common_kt_i7q4ty) {
            properties_initialized_Platform_common_kt_i7q4ty = true;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            EMPTY_DESCRIPTOR_ARRAY = [];
        }
    }
    function throwMissingFieldException(seen, goldenMask, descriptor) {
        // Inline function 'kotlin.collections.mutableListOf' call
        var missingFields = ArrayList_init_$Create$_0();
        var missingFieldsBits = goldenMask & ~seen;
        var inductionVariable = 0;
        if (inductionVariable < 32) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!((missingFieldsBits & 1) === 0)) {
                // Inline function 'kotlin.collections.plusAssign' call
                var element = descriptor.wp(i);
                missingFields.e(element);
            }
            missingFieldsBits = missingFieldsBits >>> 1 | 0;
        }while (inductionVariable < 32);
        throw MissingFieldException_init_$Create$(missingFields, descriptor.zo());
    }
    function _get_childSerializers__7vnyfa($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.cy_1;
        childSerializers$factory();
        return this_0.b1();
    }
    function _get__hashCode__tgwhef_0($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.ey_1;
        _hashCode$factory_0();
        return this_0.b1();
    }
    function buildIndices($this) {
        var indices = HashMap_init_$Create$();
        var inductionVariable = 0;
        var last = $this.xx_1.length - 1 | 0;
        if (inductionVariable <= last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.set' call
            var key = $this.xx_1[i];
            indices.m2(key, i);
        }while (inductionVariable <= last);
        return indices;
    }
    function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
        return function() {
            var tmp0_safe_receiver = this$0.ux_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lz();
            return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
        };
    }
    function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
        return function() {
            var tmp0_safe_receiver = this$0.ux_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mz();
            var tmp;
            if (tmp1_safe_receiver == null) tmp = null;
            else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
                var inductionVariable = 0;
                var last = tmp1_safe_receiver.length;
                while(inductionVariable < last){
                    var item = tmp1_safe_receiver[inductionVariable];
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = item.yn();
                    destination.e(tmp$ret$0);
                }
                tmp = destination;
            }
            return compactArray(tmp);
        };
    }
    function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
        return function() {
            return hashCodeImpl(this$0, this$0.vy());
        };
    }
    function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
        return function(i) {
            return this$0.wp(i) + ": " + this$0.up(i).zo();
        };
    }
    function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
        generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
        this.tx_1 = serialName;
        this.ux_1 = generatedSerializer;
        this.vx_1 = elementsCount;
        this.wx_1 = -1;
        var tmp = this;
        var tmp_0 = 0;
        var tmp_1 = this.vx_1;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_2 = fillArrayVal(Array(tmp_1), null);
        while(tmp_0 < tmp_1){
            tmp_2[tmp_0] = "[UNINITIALIZED]";
            tmp_0 = tmp_0 + 1 | 0;
        }
        tmp.xx_1 = tmp_2;
        var tmp_3 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.vx_1;
        tmp_3.yx_1 = fillArrayVal(Array(size), null);
        this.zx_1 = null;
        this.ay_1 = booleanArray(this.vx_1);
        this.by_1 = emptyMap();
        var tmp_4 = this;
        var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_4.cy_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
        var tmp_6 = this;
        var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_6.dy_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
        var tmp_8 = this;
        var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp_8.ey_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
    }
    protoOf(PluginGeneratedSerialDescriptor).zo = function() {
        return this.tx_1;
    };
    protoOf(PluginGeneratedSerialDescriptor).qp = function() {
        return this.vx_1;
    };
    protoOf(PluginGeneratedSerialDescriptor).sp = function() {
        return CLASS_getInstance();
    };
    protoOf(PluginGeneratedSerialDescriptor).pp = function() {
        var tmp0_elvis_lhs = this.zx_1;
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    };
    protoOf(PluginGeneratedSerialDescriptor).uq = function() {
        return this.by_1.f2();
    };
    protoOf(PluginGeneratedSerialDescriptor).vy = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.dy_1;
        typeParameterDescriptors$factory();
        return this_0.b1();
    };
    protoOf(PluginGeneratedSerialDescriptor).wy = function(name, isOptional) {
        this.wx_1 = this.wx_1 + 1 | 0;
        this.xx_1[this.wx_1] = name;
        this.ay_1[this.wx_1] = isOptional;
        this.yx_1[this.wx_1] = null;
        if (this.wx_1 === (this.vx_1 - 1 | 0)) this.by_1 = buildIndices(this);
    };
    protoOf(PluginGeneratedSerialDescriptor).fy = function(name, isOptional, $super) {
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
            this.wy(name, isOptional);
            tmp = Unit_instance;
        } else tmp = $super.wy.call(this, name, isOptional);
        return tmp;
    };
    protoOf(PluginGeneratedSerialDescriptor).up = function(index) {
        return getChecked(_get_childSerializers__7vnyfa(this), index).yn();
    };
    protoOf(PluginGeneratedSerialDescriptor).xp = function(index) {
        return getChecked_0(this.ay_1, index);
    };
    protoOf(PluginGeneratedSerialDescriptor).tp = function(index) {
        var tmp0_elvis_lhs = getChecked(this.yx_1, index);
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    };
    protoOf(PluginGeneratedSerialDescriptor).wp = function(index) {
        return getChecked(this.xx_1, index);
    };
    protoOf(PluginGeneratedSerialDescriptor).vp = function(name) {
        var tmp0_elvis_lhs = this.by_1.e2(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
    };
    protoOf(PluginGeneratedSerialDescriptor).equals = function(other) {
        var tmp$ret$0;
        $l$block_5: {
            // Inline function 'kotlinx.serialization.internal.equalsImpl' call
            if (this === other) {
                tmp$ret$0 = true;
                break $l$block_5;
            }
            if (!(other instanceof PluginGeneratedSerialDescriptor)) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.zo() === other.zo())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
            if (!contentEquals(this.vy(), other.vy())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            if (!(this.qp() === other.qp())) {
                tmp$ret$0 = false;
                break $l$block_5;
            }
            var inductionVariable = 0;
            var last = this.qp();
            if (inductionVariable < last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!(this.up(index).zo() === other.up(index).zo())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
                if (!equals(this.up(index).sp(), other.up(index).sp())) {
                    tmp$ret$0 = false;
                    break $l$block_5;
                }
            }while (inductionVariable < last);
            tmp$ret$0 = true;
        }
        return tmp$ret$0;
    };
    protoOf(PluginGeneratedSerialDescriptor).hashCode = function() {
        return _get__hashCode__tgwhef_0(this);
    };
    protoOf(PluginGeneratedSerialDescriptor).toString = function() {
        var tmp = until(0, this.vx_1);
        var tmp_0 = this.zo() + "(";
        return joinToString(tmp, ", ", tmp_0, ")", VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
    };
    function hashCodeImpl(_this__u8e3s4, typeParams) {
        var result = getStringHashCode(_this__u8e3s4.zo());
        result = imul(31, result) + contentHashCode(typeParams) | 0;
        var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
        // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
        // Inline function 'kotlin.collections.fold' call
        var accumulator = 1;
        var tmp0_iterator = elementDescriptors.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
            var hash = accumulator;
            var tmp = imul(31, hash);
            // Inline function 'kotlin.hashCode' call
            // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
            var tmp0_safe_receiver = element.zo();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
            accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        var namesHash = accumulator;
        // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
        // Inline function 'kotlin.collections.fold' call
        var accumulator_0 = 1;
        var tmp0_iterator_0 = elementDescriptors.j();
        while(tmp0_iterator_0.k()){
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
            var hash_0 = accumulator_0;
            var tmp_0 = imul(31, hash_0);
            // Inline function 'kotlin.hashCode' call
            // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
            var tmp0_safe_receiver_0 = element_0.sp();
            var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
            accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
        }
        var kindHash = accumulator_0;
        result = imul(31, result) + namesHash | 0;
        result = imul(31, result) + kindHash | 0;
        return result;
    }
    function childSerializers$factory() {
        return getPropertyCallableRef("childSerializers", 1, KProperty1, function(receiver) {
            return _get_childSerializers__7vnyfa(receiver);
        }, null);
    }
    function typeParameterDescriptors$factory() {
        return getPropertyCallableRef("typeParameterDescriptors", 1, KProperty1, function(receiver) {
            return receiver.vy();
        }, null);
    }
    function _hashCode$factory_0() {
        return getPropertyCallableRef("_hashCode", 1, KProperty1, function(receiver) {
            return _get__hashCode__tgwhef_0(receiver);
        }, null);
    }
    function get_EMPTY_SERIALIZER_ARRAY() {
        _init_properties_PluginHelperInterfaces_kt__xgvzfp();
        return EMPTY_SERIALIZER_ARRAY;
    }
    var EMPTY_SERIALIZER_ARRAY;
    function SerializerFactory() {}
    function GeneratedSerializer() {}
    var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
    function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
        if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
            properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            EMPTY_SERIALIZER_ARRAY = [];
        }
    }
    function CharArraySerializer_0() {
        CharArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_0()));
    }
    protoOf(CharArraySerializer_0).zz = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(CharArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.zz((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(CharArraySerializer_0).a10 = function(_this__u8e3s4) {
        return new CharArrayBuilder(_this__u8e3s4);
    };
    protoOf(CharArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.a10((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(CharArraySerializer_0).ex = function() {
        return charArray(0);
    };
    protoOf(CharArraySerializer_0).b10 = function(decoder, index, builder, checkIndex) {
        builder.e10(decoder.ur(this.vw_1, index));
    };
    protoOf(CharArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.b10(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(CharArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.b10(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(CharArraySerializer_0).f10 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.ys(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(CharArraySerializer_0).gx = function(encoder, content, size) {
        return this.f10(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
    };
    var CharArraySerializer_instance;
    function CharArraySerializer_getInstance() {
        if (CharArraySerializer_instance == null) new CharArraySerializer_0();
        return CharArraySerializer_instance;
    }
    function DoubleArraySerializer_0() {
        DoubleArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_3(DoubleCompanionObject_instance));
    }
    protoOf(DoubleArraySerializer_0).i10 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(DoubleArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.i10((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(DoubleArraySerializer_0).j10 = function(_this__u8e3s4) {
        return new DoubleArrayBuilder(_this__u8e3s4);
    };
    protoOf(DoubleArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.j10((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(DoubleArraySerializer_0).ex = function() {
        return new Float64Array(0);
    };
    protoOf(DoubleArraySerializer_0).k10 = function(decoder, index, builder, checkIndex) {
        builder.n10(decoder.tr(this.vw_1, index));
    };
    protoOf(DoubleArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.k10(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(DoubleArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.k10(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(DoubleArraySerializer_0).o10 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.xs(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(DoubleArraySerializer_0).gx = function(encoder, content, size) {
        return this.o10(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
    };
    var DoubleArraySerializer_instance;
    function DoubleArraySerializer_getInstance() {
        if (DoubleArraySerializer_instance == null) new DoubleArraySerializer_0();
        return DoubleArraySerializer_instance;
    }
    function FloatArraySerializer_0() {
        FloatArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_4(FloatCompanionObject_instance));
    }
    protoOf(FloatArraySerializer_0).r10 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(FloatArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.r10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(FloatArraySerializer_0).s10 = function(_this__u8e3s4) {
        return new FloatArrayBuilder(_this__u8e3s4);
    };
    protoOf(FloatArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.s10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(FloatArraySerializer_0).ex = function() {
        return new Float32Array(0);
    };
    protoOf(FloatArraySerializer_0).t10 = function(decoder, index, builder, checkIndex) {
        builder.w10(decoder.sr(this.vw_1, index));
    };
    protoOf(FloatArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.t10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(FloatArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.t10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(FloatArraySerializer_0).x10 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.ws(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(FloatArraySerializer_0).gx = function(encoder, content, size) {
        return this.x10(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
    };
    var FloatArraySerializer_instance;
    function FloatArraySerializer_getInstance() {
        if (FloatArraySerializer_instance == null) new FloatArraySerializer_0();
        return FloatArraySerializer_instance;
    }
    function LongArraySerializer_0() {
        LongArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_1()));
    }
    protoOf(LongArraySerializer_0).a11 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(LongArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.a11((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LongArraySerializer_0).b11 = function(_this__u8e3s4) {
        return new LongArrayBuilder(_this__u8e3s4);
    };
    protoOf(LongArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.b11((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(LongArraySerializer_0).ex = function() {
        return longArray(0);
    };
    protoOf(LongArraySerializer_0).c11 = function(decoder, index, builder, checkIndex) {
        builder.f11(decoder.rr(this.vw_1, index));
    };
    protoOf(LongArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.c11(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(LongArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.c11(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(LongArraySerializer_0).g11 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.vs(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(LongArraySerializer_0).gx = function(encoder, content, size) {
        return this.g11(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
    };
    var LongArraySerializer_instance;
    function LongArraySerializer_getInstance() {
        if (LongArraySerializer_instance == null) new LongArraySerializer_0();
        return LongArraySerializer_instance;
    }
    function ULongArraySerializer_0() {
        ULongArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_2()));
    }
    protoOf(ULongArraySerializer_0).j11 = function(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
    };
    protoOf(ULongArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.j11(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.yk_1 : THROW_CCE());
    };
    protoOf(ULongArraySerializer_0).k11 = function(_this__u8e3s4) {
        return new ULongArrayBuilder(_this__u8e3s4);
    };
    protoOf(ULongArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.k11(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.yk_1 : THROW_CCE());
    };
    protoOf(ULongArraySerializer_0).l11 = function() {
        return _ULongArray___init__impl__twm1l3(0);
    };
    protoOf(ULongArraySerializer_0).ex = function() {
        return new ULongArray(this.l11());
    };
    protoOf(ULongArraySerializer_0).m11 = function(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.wr(this.vw_1, index).cr();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.p11(tmp$ret$0);
    };
    protoOf(ULongArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.m11(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ULongArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.m11(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ULongArraySerializer_0).q11 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.at(this.vw_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.ks(tmp$ret$0);
        }while (inductionVariable < size);
    };
    protoOf(ULongArraySerializer_0).gx = function(encoder, content, size) {
        return this.q11(encoder, content instanceof ULongArray ? content.yk_1 : THROW_CCE(), size);
    };
    var ULongArraySerializer_instance;
    function ULongArraySerializer_getInstance() {
        if (ULongArraySerializer_instance == null) new ULongArraySerializer_0();
        return ULongArraySerializer_instance;
    }
    function IntArraySerializer_0() {
        IntArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_7(IntCompanionObject_instance));
    }
    protoOf(IntArraySerializer_0).t11 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(IntArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.t11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(IntArraySerializer_0).u11 = function(_this__u8e3s4) {
        return new IntArrayBuilder(_this__u8e3s4);
    };
    protoOf(IntArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.u11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(IntArraySerializer_0).ex = function() {
        return new Int32Array(0);
    };
    protoOf(IntArraySerializer_0).v11 = function(decoder, index, builder, checkIndex) {
        builder.y11(decoder.qr(this.vw_1, index));
    };
    protoOf(IntArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.v11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(IntArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.v11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(IntArraySerializer_0).z11 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.us(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(IntArraySerializer_0).gx = function(encoder, content, size) {
        return this.z11(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
    };
    var IntArraySerializer_instance;
    function IntArraySerializer_getInstance() {
        if (IntArraySerializer_instance == null) new IntArraySerializer_0();
        return IntArraySerializer_instance;
    }
    function UIntArraySerializer_0() {
        UIntArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_8(Companion_getInstance_3()));
    }
    protoOf(UIntArraySerializer_0).c12 = function(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
    };
    protoOf(UIntArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.c12(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.mk_1 : THROW_CCE());
    };
    protoOf(UIntArraySerializer_0).d12 = function(_this__u8e3s4) {
        return new UIntArrayBuilder(_this__u8e3s4);
    };
    protoOf(UIntArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.d12(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.mk_1 : THROW_CCE());
    };
    protoOf(UIntArraySerializer_0).e12 = function() {
        return _UIntArray___init__impl__ghjpc6(0);
    };
    protoOf(UIntArraySerializer_0).ex = function() {
        return new UIntArray(this.e12());
    };
    protoOf(UIntArraySerializer_0).f12 = function(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.wr(this.vw_1, index).br();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.i12(tmp$ret$0);
    };
    protoOf(UIntArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.f12(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UIntArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.f12(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UIntArraySerializer_0).j12 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.at(this.vw_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.js(tmp$ret$0);
        }while (inductionVariable < size);
    };
    protoOf(UIntArraySerializer_0).gx = function(encoder, content, size) {
        return this.j12(encoder, content instanceof UIntArray ? content.mk_1 : THROW_CCE(), size);
    };
    var UIntArraySerializer_instance;
    function UIntArraySerializer_getInstance() {
        if (UIntArraySerializer_instance == null) new UIntArraySerializer_0();
        return UIntArraySerializer_instance;
    }
    function ShortArraySerializer_0() {
        ShortArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_9(ShortCompanionObject_instance));
    }
    protoOf(ShortArraySerializer_0).m12 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(ShortArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.m12((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ShortArraySerializer_0).n12 = function(_this__u8e3s4) {
        return new ShortArrayBuilder(_this__u8e3s4);
    };
    protoOf(ShortArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.n12((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ShortArraySerializer_0).ex = function() {
        return new Int16Array(0);
    };
    protoOf(ShortArraySerializer_0).o12 = function(decoder, index, builder, checkIndex) {
        builder.r12(decoder.pr(this.vw_1, index));
    };
    protoOf(ShortArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.o12(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ShortArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.o12(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ShortArraySerializer_0).s12 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.ts(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(ShortArraySerializer_0).gx = function(encoder, content, size) {
        return this.s12(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
    };
    var ShortArraySerializer_instance;
    function ShortArraySerializer_getInstance() {
        if (ShortArraySerializer_instance == null) new ShortArraySerializer_0();
        return ShortArraySerializer_instance;
    }
    function UShortArraySerializer_0() {
        UShortArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_10(Companion_getInstance_4()));
    }
    protoOf(UShortArraySerializer_0).v12 = function(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
    };
    protoOf(UShortArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.v12(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.kl_1 : THROW_CCE());
    };
    protoOf(UShortArraySerializer_0).w12 = function(_this__u8e3s4) {
        return new UShortArrayBuilder(_this__u8e3s4);
    };
    protoOf(UShortArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.w12(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.kl_1 : THROW_CCE());
    };
    protoOf(UShortArraySerializer_0).x12 = function() {
        return _UShortArray___init__impl__9b26ef(0);
    };
    protoOf(UShortArraySerializer_0).ex = function() {
        return new UShortArray(this.x12());
    };
    protoOf(UShortArraySerializer_0).y12 = function(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.wr(this.vw_1, index).ar();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.b13(tmp$ret$0);
    };
    protoOf(UShortArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.y12(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UShortArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.y12(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UShortArraySerializer_0).c13 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.at(this.vw_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.is(tmp$ret$0);
        }while (inductionVariable < size);
    };
    protoOf(UShortArraySerializer_0).gx = function(encoder, content, size) {
        return this.c13(encoder, content instanceof UShortArray ? content.kl_1 : THROW_CCE(), size);
    };
    var UShortArraySerializer_instance;
    function UShortArraySerializer_getInstance() {
        if (UShortArraySerializer_instance == null) new UShortArraySerializer_0();
        return UShortArraySerializer_instance;
    }
    function ByteArraySerializer_0() {
        ByteArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_11(ByteCompanionObject_instance));
    }
    protoOf(ByteArraySerializer_0).f13 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(ByteArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.f13((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ByteArraySerializer_0).g13 = function(_this__u8e3s4) {
        return new ByteArrayBuilder(_this__u8e3s4);
    };
    protoOf(ByteArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.g13((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(ByteArraySerializer_0).ex = function() {
        return new Int8Array(0);
    };
    protoOf(ByteArraySerializer_0).h13 = function(decoder, index, builder, checkIndex) {
        builder.k13(decoder.or(this.vw_1, index));
    };
    protoOf(ByteArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.h13(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ByteArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.h13(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(ByteArraySerializer_0).l13 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.ss(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(ByteArraySerializer_0).gx = function(encoder, content, size) {
        return this.l13(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
    };
    var ByteArraySerializer_instance;
    function ByteArraySerializer_getInstance() {
        if (ByteArraySerializer_instance == null) new ByteArraySerializer_0();
        return ByteArraySerializer_instance;
    }
    function UByteArraySerializer_0() {
        UByteArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_12(Companion_getInstance_5()));
    }
    protoOf(UByteArraySerializer_0).o13 = function(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
    };
    protoOf(UByteArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.o13(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ak_1 : THROW_CCE());
    };
    protoOf(UByteArraySerializer_0).p13 = function(_this__u8e3s4) {
        return new UByteArrayBuilder(_this__u8e3s4);
    };
    protoOf(UByteArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.p13(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.ak_1 : THROW_CCE());
    };
    protoOf(UByteArraySerializer_0).q13 = function() {
        return _UByteArray___init__impl__ip4y9n(0);
    };
    protoOf(UByteArraySerializer_0).ex = function() {
        return new UByteArray(this.q13());
    };
    protoOf(UByteArraySerializer_0).r13 = function(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.wr(this.vw_1, index).zq();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.u13(tmp$ret$0);
    };
    protoOf(UByteArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.r13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UByteArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.r13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(UByteArraySerializer_0).v13 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.at(this.vw_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.hs(tmp$ret$0);
        }while (inductionVariable < size);
    };
    protoOf(UByteArraySerializer_0).gx = function(encoder, content, size) {
        return this.v13(encoder, content instanceof UByteArray ? content.ak_1 : THROW_CCE(), size);
    };
    var UByteArraySerializer_instance;
    function UByteArraySerializer_getInstance() {
        if (UByteArraySerializer_instance == null) new UByteArraySerializer_0();
        return UByteArraySerializer_instance;
    }
    function BooleanArraySerializer_0() {
        BooleanArraySerializer_instance = this;
        PrimitiveArraySerializer.call(this, serializer_13(BooleanCompanionObject_instance));
    }
    protoOf(BooleanArraySerializer_0).y13 = function(_this__u8e3s4) {
        return _this__u8e3s4.length;
    };
    protoOf(BooleanArraySerializer_0).tv = function(_this__u8e3s4) {
        return this.y13((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(BooleanArraySerializer_0).z13 = function(_this__u8e3s4) {
        return new BooleanArrayBuilder(_this__u8e3s4);
    };
    protoOf(BooleanArraySerializer_0).ou = function(_this__u8e3s4) {
        return this.z13((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(BooleanArraySerializer_0).ex = function() {
        return booleanArray(0);
    };
    protoOf(BooleanArraySerializer_0).a14 = function(decoder, index, builder, checkIndex) {
        builder.d14(decoder.nr(this.vw_1, index));
    };
    protoOf(BooleanArraySerializer_0).zu = function(decoder, index, builder, checkIndex) {
        return this.a14(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(BooleanArraySerializer_0).fx = function(decoder, index, builder, checkIndex) {
        return this.a14(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
    };
    protoOf(BooleanArraySerializer_0).e14 = function(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.rs(this.vw_1, i, content[i]);
        }while (inductionVariable < size);
    };
    protoOf(BooleanArraySerializer_0).gx = function(encoder, content, size) {
        return this.e14(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
    };
    var BooleanArraySerializer_instance;
    function BooleanArraySerializer_getInstance() {
        if (BooleanArraySerializer_instance == null) new BooleanArraySerializer_0();
        return BooleanArraySerializer_instance;
    }
    function CharArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.c10_1 = bufferWithData;
        this.d10_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(CharArrayBuilder).xw = function() {
        return this.d10_1;
    };
    protoOf(CharArrayBuilder).bx = function(requiredCapacity) {
        if (this.c10_1.length < requiredCapacity) this.c10_1 = copyOf(this.c10_1, coerceAtLeast(requiredCapacity, imul(this.c10_1.length, 2)));
    };
    protoOf(CharArrayBuilder).e10 = function(c) {
        this.ix();
        var tmp = this.c10_1;
        var tmp1 = this.d10_1;
        this.d10_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(CharArrayBuilder).zw = function() {
        return copyOf(this.c10_1, this.d10_1);
    };
    function DoubleArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.l10_1 = bufferWithData;
        this.m10_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(DoubleArrayBuilder).xw = function() {
        return this.m10_1;
    };
    protoOf(DoubleArrayBuilder).bx = function(requiredCapacity) {
        if (this.l10_1.length < requiredCapacity) this.l10_1 = copyOf_0(this.l10_1, coerceAtLeast(requiredCapacity, imul(this.l10_1.length, 2)));
    };
    protoOf(DoubleArrayBuilder).n10 = function(c) {
        this.ix();
        var tmp = this.l10_1;
        var tmp1 = this.m10_1;
        this.m10_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(DoubleArrayBuilder).zw = function() {
        return copyOf_0(this.l10_1, this.m10_1);
    };
    function FloatArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.u10_1 = bufferWithData;
        this.v10_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(FloatArrayBuilder).xw = function() {
        return this.v10_1;
    };
    protoOf(FloatArrayBuilder).bx = function(requiredCapacity) {
        if (this.u10_1.length < requiredCapacity) this.u10_1 = copyOf_1(this.u10_1, coerceAtLeast(requiredCapacity, imul(this.u10_1.length, 2)));
    };
    protoOf(FloatArrayBuilder).w10 = function(c) {
        this.ix();
        var tmp = this.u10_1;
        var tmp1 = this.v10_1;
        this.v10_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(FloatArrayBuilder).zw = function() {
        return copyOf_1(this.u10_1, this.v10_1);
    };
    function LongArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.d11_1 = bufferWithData;
        this.e11_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(LongArrayBuilder).xw = function() {
        return this.e11_1;
    };
    protoOf(LongArrayBuilder).bx = function(requiredCapacity) {
        if (this.d11_1.length < requiredCapacity) this.d11_1 = copyOf_2(this.d11_1, coerceAtLeast(requiredCapacity, imul(this.d11_1.length, 2)));
    };
    protoOf(LongArrayBuilder).f11 = function(c) {
        this.ix();
        var tmp = this.d11_1;
        var tmp1 = this.e11_1;
        this.e11_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(LongArrayBuilder).zw = function() {
        return copyOf_2(this.d11_1, this.e11_1);
    };
    function ULongArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.n11_1 = bufferWithData;
        this.o11_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.bx(10);
    }
    protoOf(ULongArrayBuilder).xw = function() {
        return this.o11_1;
    };
    protoOf(ULongArrayBuilder).bx = function(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.n11_1) < requiredCapacity) {
            var tmp = this;
            // Inline function 'kotlin.collections.copyOf' call
            var this_0 = this.n11_1;
            var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.n11_1), 2));
            tmp.n11_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
        }
    };
    protoOf(ULongArrayBuilder).p11 = function(c) {
        this.ix();
        var tmp = this.n11_1;
        var tmp1 = this.o11_1;
        this.o11_1 = tmp1 + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, tmp1, c);
    };
    protoOf(ULongArrayBuilder).f14 = function() {
        // Inline function 'kotlin.collections.copyOf' call
        var this_0 = this.n11_1;
        var newSize = this.o11_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    };
    protoOf(ULongArrayBuilder).zw = function() {
        return new ULongArray(this.f14());
    };
    function IntArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.w11_1 = bufferWithData;
        this.x11_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(IntArrayBuilder).xw = function() {
        return this.x11_1;
    };
    protoOf(IntArrayBuilder).bx = function(requiredCapacity) {
        if (this.w11_1.length < requiredCapacity) this.w11_1 = copyOf_3(this.w11_1, coerceAtLeast(requiredCapacity, imul(this.w11_1.length, 2)));
    };
    protoOf(IntArrayBuilder).y11 = function(c) {
        this.ix();
        var tmp = this.w11_1;
        var tmp1 = this.x11_1;
        this.x11_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(IntArrayBuilder).zw = function() {
        return copyOf_3(this.w11_1, this.x11_1);
    };
    function UIntArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.g12_1 = bufferWithData;
        this.h12_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.bx(10);
    }
    protoOf(UIntArrayBuilder).xw = function() {
        return this.h12_1;
    };
    protoOf(UIntArrayBuilder).bx = function(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.g12_1) < requiredCapacity) {
            var tmp = this;
            // Inline function 'kotlin.collections.copyOf' call
            var this_0 = this.g12_1;
            var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.g12_1), 2));
            tmp.g12_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
        }
    };
    protoOf(UIntArrayBuilder).i12 = function(c) {
        this.ix();
        var tmp = this.g12_1;
        var tmp1 = this.h12_1;
        this.h12_1 = tmp1 + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
    };
    protoOf(UIntArrayBuilder).g14 = function() {
        // Inline function 'kotlin.collections.copyOf' call
        var this_0 = this.g12_1;
        var newSize = this.h12_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    };
    protoOf(UIntArrayBuilder).zw = function() {
        return new UIntArray(this.g14());
    };
    function ShortArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.p12_1 = bufferWithData;
        this.q12_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(ShortArrayBuilder).xw = function() {
        return this.q12_1;
    };
    protoOf(ShortArrayBuilder).bx = function(requiredCapacity) {
        if (this.p12_1.length < requiredCapacity) this.p12_1 = copyOf_4(this.p12_1, coerceAtLeast(requiredCapacity, imul(this.p12_1.length, 2)));
    };
    protoOf(ShortArrayBuilder).r12 = function(c) {
        this.ix();
        var tmp = this.p12_1;
        var tmp1 = this.q12_1;
        this.q12_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(ShortArrayBuilder).zw = function() {
        return copyOf_4(this.p12_1, this.q12_1);
    };
    function UShortArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.z12_1 = bufferWithData;
        this.a13_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.bx(10);
    }
    protoOf(UShortArrayBuilder).xw = function() {
        return this.a13_1;
    };
    protoOf(UShortArrayBuilder).bx = function(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.z12_1) < requiredCapacity) {
            var tmp = this;
            // Inline function 'kotlin.collections.copyOf' call
            var this_0 = this.z12_1;
            var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.z12_1), 2));
            tmp.z12_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
        }
    };
    protoOf(UShortArrayBuilder).b13 = function(c) {
        this.ix();
        var tmp = this.z12_1;
        var tmp1 = this.a13_1;
        this.a13_1 = tmp1 + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, tmp1, c);
    };
    protoOf(UShortArrayBuilder).h14 = function() {
        // Inline function 'kotlin.collections.copyOf' call
        var this_0 = this.z12_1;
        var newSize = this.a13_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    };
    protoOf(UShortArrayBuilder).zw = function() {
        return new UShortArray(this.h14());
    };
    function ByteArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.i13_1 = bufferWithData;
        this.j13_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(ByteArrayBuilder).xw = function() {
        return this.j13_1;
    };
    protoOf(ByteArrayBuilder).bx = function(requiredCapacity) {
        if (this.i13_1.length < requiredCapacity) this.i13_1 = copyOf_5(this.i13_1, coerceAtLeast(requiredCapacity, imul(this.i13_1.length, 2)));
    };
    protoOf(ByteArrayBuilder).k13 = function(c) {
        this.ix();
        var tmp = this.i13_1;
        var tmp1 = this.j13_1;
        this.j13_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(ByteArrayBuilder).zw = function() {
        return copyOf_5(this.i13_1, this.j13_1);
    };
    function UByteArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.s13_1 = bufferWithData;
        this.t13_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.bx(10);
    }
    protoOf(UByteArrayBuilder).xw = function() {
        return this.t13_1;
    };
    protoOf(UByteArrayBuilder).bx = function(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.s13_1) < requiredCapacity) {
            var tmp = this;
            // Inline function 'kotlin.collections.copyOf' call
            var this_0 = this.s13_1;
            var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.s13_1), 2));
            tmp.s13_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
        }
    };
    protoOf(UByteArrayBuilder).u13 = function(c) {
        this.ix();
        var tmp = this.s13_1;
        var tmp1 = this.t13_1;
        this.t13_1 = tmp1 + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, tmp1, c);
    };
    protoOf(UByteArrayBuilder).i14 = function() {
        // Inline function 'kotlin.collections.copyOf' call
        var this_0 = this.s13_1;
        var newSize = this.t13_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    };
    protoOf(UByteArrayBuilder).zw = function() {
        return new UByteArray(this.i14());
    };
    function BooleanArrayBuilder(bufferWithData) {
        PrimitiveArrayBuilder.call(this);
        this.b14_1 = bufferWithData;
        this.c14_1 = bufferWithData.length;
        this.bx(10);
    }
    protoOf(BooleanArrayBuilder).xw = function() {
        return this.c14_1;
    };
    protoOf(BooleanArrayBuilder).bx = function(requiredCapacity) {
        if (this.b14_1.length < requiredCapacity) this.b14_1 = copyOf_6(this.b14_1, coerceAtLeast(requiredCapacity, imul(this.b14_1.length, 2)));
    };
    protoOf(BooleanArrayBuilder).d14 = function(c) {
        this.ix();
        var tmp = this.b14_1;
        var tmp1 = this.c14_1;
        this.c14_1 = tmp1 + 1 | 0;
        tmp[tmp1] = c;
    };
    protoOf(BooleanArrayBuilder).zw = function() {
        return copyOf_6(this.b14_1, this.c14_1);
    };
    function get_BUILTIN_SERIALIZERS() {
        _init_properties_Primitives_kt__k0eto4();
        return BUILTIN_SERIALIZERS;
    }
    var BUILTIN_SERIALIZERS;
    function builtinSerializerOrNull(_this__u8e3s4) {
        _init_properties_Primitives_kt__k0eto4();
        var tmp = get_BUILTIN_SERIALIZERS().e2(_this__u8e3s4);
        return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
    }
    function StringSerializer() {
        StringSerializer_instance = this;
        this.j14_1 = new PrimitiveSerialDescriptor_0("kotlin.String", STRING_getInstance());
    }
    protoOf(StringSerializer).yn = function() {
        return this.j14_1;
    };
    protoOf(StringSerializer).k14 = function(encoder, value) {
        return encoder.os(value);
    };
    protoOf(StringSerializer).zn = function(encoder, value) {
        return this.k14(encoder, (!(value == null) ? typeof value === "string" : false) ? value : THROW_CCE());
    };
    protoOf(StringSerializer).ao = function(decoder) {
        return decoder.gr();
    };
    var StringSerializer_instance;
    function StringSerializer_getInstance() {
        if (StringSerializer_instance == null) new StringSerializer();
        return StringSerializer_instance;
    }
    function CharSerializer() {
        CharSerializer_instance = this;
        this.l14_1 = new PrimitiveSerialDescriptor_0("kotlin.Char", CHAR_getInstance());
    }
    protoOf(CharSerializer).yn = function() {
        return this.l14_1;
    };
    protoOf(CharSerializer).m14 = function(encoder, value) {
        return encoder.ns(value);
    };
    protoOf(CharSerializer).zn = function(encoder, value) {
        return this.m14(encoder, value instanceof Char ? value.o1_1 : THROW_CCE());
    };
    protoOf(CharSerializer).n14 = function(decoder) {
        return decoder.fr();
    };
    protoOf(CharSerializer).ao = function(decoder) {
        return new Char(this.n14(decoder));
    };
    var CharSerializer_instance;
    function CharSerializer_getInstance() {
        if (CharSerializer_instance == null) new CharSerializer();
        return CharSerializer_instance;
    }
    function DoubleSerializer() {
        DoubleSerializer_instance = this;
        this.o14_1 = new PrimitiveSerialDescriptor_0("kotlin.Double", DOUBLE_getInstance());
    }
    protoOf(DoubleSerializer).yn = function() {
        return this.o14_1;
    };
    protoOf(DoubleSerializer).p14 = function(encoder, value) {
        return encoder.ms(value);
    };
    protoOf(DoubleSerializer).zn = function(encoder, value) {
        return this.p14(encoder, (!(value == null) ? typeof value === "number" : false) ? value : THROW_CCE());
    };
    protoOf(DoubleSerializer).ao = function(decoder) {
        return decoder.er();
    };
    var DoubleSerializer_instance;
    function DoubleSerializer_getInstance() {
        if (DoubleSerializer_instance == null) new DoubleSerializer();
        return DoubleSerializer_instance;
    }
    function FloatSerializer() {
        FloatSerializer_instance = this;
        this.q14_1 = new PrimitiveSerialDescriptor_0("kotlin.Float", FLOAT_getInstance());
    }
    protoOf(FloatSerializer).yn = function() {
        return this.q14_1;
    };
    protoOf(FloatSerializer).r14 = function(encoder, value) {
        return encoder.ls(value);
    };
    protoOf(FloatSerializer).zn = function(encoder, value) {
        return this.r14(encoder, (!(value == null) ? typeof value === "number" : false) ? value : THROW_CCE());
    };
    protoOf(FloatSerializer).ao = function(decoder) {
        return decoder.dr();
    };
    var FloatSerializer_instance;
    function FloatSerializer_getInstance() {
        if (FloatSerializer_instance == null) new FloatSerializer();
        return FloatSerializer_instance;
    }
    function LongSerializer() {
        LongSerializer_instance = this;
        this.s14_1 = new PrimitiveSerialDescriptor_0("kotlin.Long", LONG_getInstance());
    }
    protoOf(LongSerializer).yn = function() {
        return this.s14_1;
    };
    protoOf(LongSerializer).t14 = function(encoder, value) {
        return encoder.ks(value);
    };
    protoOf(LongSerializer).zn = function(encoder, value) {
        return this.t14(encoder, value instanceof Long ? value : THROW_CCE());
    };
    protoOf(LongSerializer).ao = function(decoder) {
        return decoder.cr();
    };
    var LongSerializer_instance;
    function LongSerializer_getInstance() {
        if (LongSerializer_instance == null) new LongSerializer();
        return LongSerializer_instance;
    }
    function IntSerializer() {
        IntSerializer_instance = this;
        this.u14_1 = new PrimitiveSerialDescriptor_0("kotlin.Int", INT_getInstance());
    }
    protoOf(IntSerializer).yn = function() {
        return this.u14_1;
    };
    protoOf(IntSerializer).v14 = function(encoder, value) {
        return encoder.js(value);
    };
    protoOf(IntSerializer).zn = function(encoder, value) {
        return this.v14(encoder, (!(value == null) ? typeof value === "number" : false) ? value : THROW_CCE());
    };
    protoOf(IntSerializer).ao = function(decoder) {
        return decoder.br();
    };
    var IntSerializer_instance;
    function IntSerializer_getInstance() {
        if (IntSerializer_instance == null) new IntSerializer();
        return IntSerializer_instance;
    }
    function ShortSerializer() {
        ShortSerializer_instance = this;
        this.w14_1 = new PrimitiveSerialDescriptor_0("kotlin.Short", SHORT_getInstance());
    }
    protoOf(ShortSerializer).yn = function() {
        return this.w14_1;
    };
    protoOf(ShortSerializer).x14 = function(encoder, value) {
        return encoder.is(value);
    };
    protoOf(ShortSerializer).zn = function(encoder, value) {
        return this.x14(encoder, (!(value == null) ? typeof value === "number" : false) ? value : THROW_CCE());
    };
    protoOf(ShortSerializer).ao = function(decoder) {
        return decoder.ar();
    };
    var ShortSerializer_instance;
    function ShortSerializer_getInstance() {
        if (ShortSerializer_instance == null) new ShortSerializer();
        return ShortSerializer_instance;
    }
    function ByteSerializer() {
        ByteSerializer_instance = this;
        this.y14_1 = new PrimitiveSerialDescriptor_0("kotlin.Byte", BYTE_getInstance());
    }
    protoOf(ByteSerializer).yn = function() {
        return this.y14_1;
    };
    protoOf(ByteSerializer).z14 = function(encoder, value) {
        return encoder.hs(value);
    };
    protoOf(ByteSerializer).zn = function(encoder, value) {
        return this.z14(encoder, (!(value == null) ? typeof value === "number" : false) ? value : THROW_CCE());
    };
    protoOf(ByteSerializer).ao = function(decoder) {
        return decoder.zq();
    };
    var ByteSerializer_instance;
    function ByteSerializer_getInstance() {
        if (ByteSerializer_instance == null) new ByteSerializer();
        return ByteSerializer_instance;
    }
    function BooleanSerializer() {
        BooleanSerializer_instance = this;
        this.a15_1 = new PrimitiveSerialDescriptor_0("kotlin.Boolean", BOOLEAN_getInstance());
    }
    protoOf(BooleanSerializer).yn = function() {
        return this.a15_1;
    };
    protoOf(BooleanSerializer).b15 = function(encoder, value) {
        return encoder.gs(value);
    };
    protoOf(BooleanSerializer).zn = function(encoder, value) {
        return this.b15(encoder, (!(value == null) ? typeof value === "boolean" : false) ? value : THROW_CCE());
    };
    protoOf(BooleanSerializer).ao = function(decoder) {
        return decoder.yq();
    };
    var BooleanSerializer_instance;
    function BooleanSerializer_getInstance() {
        if (BooleanSerializer_instance == null) new BooleanSerializer();
        return BooleanSerializer_instance;
    }
    function UnitSerializer() {
        UnitSerializer_instance = this;
        this.c15_1 = new ObjectSerializer("kotlin.Unit", Unit_instance);
    }
    protoOf(UnitSerializer).yn = function() {
        return this.c15_1.yn();
    };
    protoOf(UnitSerializer).d15 = function(decoder) {
        this.c15_1.ao(decoder);
    };
    protoOf(UnitSerializer).ao = function(decoder) {
        this.d15(decoder);
        return Unit_instance;
    };
    protoOf(UnitSerializer).e15 = function(encoder, value) {
        this.c15_1.oo(encoder, Unit_instance);
    };
    protoOf(UnitSerializer).zn = function(encoder, value) {
        return this.e15(encoder, value instanceof Unit ? value : THROW_CCE());
    };
    var UnitSerializer_instance;
    function UnitSerializer_getInstance() {
        if (UnitSerializer_instance == null) new UnitSerializer();
        return UnitSerializer_instance;
    }
    function error_0($this) {
        throw IllegalStateException_init_$Create$("Primitive descriptor does not have elements");
    }
    function PrimitiveSerialDescriptor_0(serialName, kind) {
        this.f15_1 = serialName;
        this.g15_1 = kind;
    }
    protoOf(PrimitiveSerialDescriptor_0).zo = function() {
        return this.f15_1;
    };
    protoOf(PrimitiveSerialDescriptor_0).sp = function() {
        return this.g15_1;
    };
    protoOf(PrimitiveSerialDescriptor_0).qp = function() {
        return 0;
    };
    protoOf(PrimitiveSerialDescriptor_0).wp = function(index) {
        error_0(this);
    };
    protoOf(PrimitiveSerialDescriptor_0).vp = function(name) {
        error_0(this);
    };
    protoOf(PrimitiveSerialDescriptor_0).xp = function(index) {
        error_0(this);
    };
    protoOf(PrimitiveSerialDescriptor_0).up = function(index) {
        error_0(this);
    };
    protoOf(PrimitiveSerialDescriptor_0).tp = function(index) {
        error_0(this);
    };
    protoOf(PrimitiveSerialDescriptor_0).toString = function() {
        return "PrimitiveDescriptor(" + this.f15_1 + ")";
    };
    protoOf(PrimitiveSerialDescriptor_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof PrimitiveSerialDescriptor_0)) return false;
        if (this.f15_1 === other.f15_1 && equals(this.g15_1, other.g15_1)) return true;
        return false;
    };
    protoOf(PrimitiveSerialDescriptor_0).hashCode = function() {
        return getStringHashCode(this.f15_1) + imul(31, this.g15_1.hashCode()) | 0;
    };
    function PrimitiveDescriptorSafe(serialName, kind) {
        _init_properties_Primitives_kt__k0eto4();
        checkName(serialName);
        return new PrimitiveSerialDescriptor_0(serialName, kind);
    }
    function checkName(serialName) {
        _init_properties_Primitives_kt__k0eto4();
        var keys = get_BUILTIN_SERIALIZERS().f2();
        var tmp0_iterator = keys.j();
        while(tmp0_iterator.k()){
            var primitive = tmp0_iterator.l();
            var simpleName = capitalize(ensureNotNull(primitive.fa()));
            var qualifiedName = "kotlin." + simpleName;
            if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) throw IllegalArgumentException_init_$Create$(trimIndent("\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name " + serialName + " there already exist " + capitalize(simpleName) + "Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            "));
        }
    }
    function capitalize(_this__u8e3s4) {
        _init_properties_Primitives_kt__k0eto4();
        // Inline function 'kotlin.text.replaceFirstChar' call
        var tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(_this__u8e3s4) > 0) {
            // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
            var it = charSequenceGet(_this__u8e3s4, 0);
            var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString_1(it);
            var tmp_0 = toString(tmp$ret$1);
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = tmp_0 + _this__u8e3s4.substring(1);
        } else tmp = _this__u8e3s4;
        return tmp;
    }
    var properties_initialized_Primitives_kt_6dpii6;
    function _init_properties_Primitives_kt__k0eto4() {
        if (!properties_initialized_Primitives_kt_6dpii6) {
            properties_initialized_Primitives_kt_6dpii6 = true;
            BUILTIN_SERIALIZERS = mapOf([
                to(PrimitiveClasses_getInstance().gb(), serializer_1(StringCompanionObject_instance)),
                to(getKClass(Char), serializer_2(Companion_getInstance_0())),
                to(PrimitiveClasses_getInstance().jb(), CharArraySerializer()),
                to(PrimitiveClasses_getInstance().eb(), serializer_3(DoubleCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().pb(), DoubleArraySerializer()),
                to(PrimitiveClasses_getInstance().db(), serializer_4(FloatCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().ob(), FloatArraySerializer()),
                to(getKClass(Long), serializer_5(Companion_getInstance_1())),
                to(PrimitiveClasses_getInstance().nb(), LongArraySerializer()),
                to(getKClass(ULong), serializer_6(Companion_getInstance_2())),
                to(getKClass(ULongArray), ULongArraySerializer()),
                to(PrimitiveClasses_getInstance().cb(), serializer_7(IntCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().mb(), IntArraySerializer()),
                to(getKClass(UInt), serializer_8(Companion_getInstance_3())),
                to(getKClass(UIntArray), UIntArraySerializer()),
                to(PrimitiveClasses_getInstance().bb(), serializer_9(ShortCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().lb(), ShortArraySerializer()),
                to(getKClass(UShort), serializer_10(Companion_getInstance_4())),
                to(getKClass(UShortArray), UShortArraySerializer()),
                to(PrimitiveClasses_getInstance().ab(), serializer_11(ByteCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().kb(), ByteArraySerializer()),
                to(getKClass(UByte), serializer_12(Companion_getInstance_5())),
                to(getKClass(UByteArray), UByteArraySerializer()),
                to(PrimitiveClasses_getInstance().za(), serializer_13(BooleanCompanionObject_instance)),
                to(PrimitiveClasses_getInstance().ib(), BooleanArraySerializer()),
                to(getKClass(Unit), serializer_14(Unit_instance)),
                to(PrimitiveClasses_getInstance().ya(), NothingSerializer()),
                to(getKClass(Duration), serializer_15(Companion_getInstance()))
            ]);
        }
    }
    function NamedValueEncoder() {
        TaggedEncoder.call(this);
    }
    protoOf(NamedValueEncoder).i15 = function(_this__u8e3s4, index) {
        return this.k15(this.j15(_this__u8e3s4, index));
    };
    protoOf(NamedValueEncoder).k15 = function(nestedName) {
        var tmp0_elvis_lhs = this.m15();
        return this.n15(tmp0_elvis_lhs == null ? "" : tmp0_elvis_lhs, nestedName);
    };
    protoOf(NamedValueEncoder).j15 = function(descriptor, index) {
        return descriptor.wp(index);
    };
    protoOf(NamedValueEncoder).n15 = function(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) tmp = childName;
        else tmp = parentName + "." + childName;
        return tmp;
    };
    function NamedValueDecoder() {
        TaggedDecoder.call(this);
    }
    protoOf(NamedValueDecoder).i15 = function(_this__u8e3s4, index) {
        return this.k15(this.j15(_this__u8e3s4, index));
    };
    protoOf(NamedValueDecoder).k15 = function(nestedName) {
        var tmp0_elvis_lhs = this.m15();
        return this.n15(tmp0_elvis_lhs == null ? "" : tmp0_elvis_lhs, nestedName);
    };
    protoOf(NamedValueDecoder).j15 = function(descriptor, index) {
        return descriptor.wp(index);
    };
    protoOf(NamedValueDecoder).n15 = function(parentName, childName) {
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(parentName) === 0) tmp = childName;
        else tmp = parentName + "." + childName;
        return tmp;
    };
    function encodeElement($this, desc, index) {
        var tag = $this.i15(desc, index);
        $this.e16(tag);
        return true;
    }
    function TaggedEncoder() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.l15_1 = ArrayList_init_$Create$_0();
    }
    protoOf(TaggedEncoder).dp = function() {
        return EmptySerializersModule_0();
    };
    protoOf(TaggedEncoder).o15 = function(tag, value) {
        throw SerializationException_init_$Create$_0("Non-serializable " + toString(getKClassFromExpression(value)) + " is not supported by " + toString(getKClassFromExpression(this)) + " encoder");
    };
    protoOf(TaggedEncoder).p15 = function(tag) {};
    protoOf(TaggedEncoder).q15 = function(tag) {
        throw SerializationException_init_$Create$_0("null is not supported");
    };
    protoOf(TaggedEncoder).r15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).s15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).t15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).u15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).v15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).w15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).x15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).y15 = function(tag, value) {
        return this.o15(tag, new Char(value));
    };
    protoOf(TaggedEncoder).z15 = function(tag, value) {
        return this.o15(tag, value);
    };
    protoOf(TaggedEncoder).a16 = function(tag, enumDescriptor, ordinal) {
        return this.o15(tag, ordinal);
    };
    protoOf(TaggedEncoder).b16 = function(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.internal.TaggedEncoder.encodeTaggedInline.<anonymous>' call
        this.e16(tag);
        return this;
    };
    protoOf(TaggedEncoder).qs = function(descriptor) {
        return this.b16(this.f16(), descriptor);
    };
    protoOf(TaggedEncoder).ft = function() {
        return this.p15(this.d16());
    };
    protoOf(TaggedEncoder).fs = function() {
        return this.q15(this.f16());
    };
    protoOf(TaggedEncoder).gs = function(value) {
        return this.x15(this.f16(), value);
    };
    protoOf(TaggedEncoder).hs = function(value) {
        return this.s15(this.f16(), value);
    };
    protoOf(TaggedEncoder).is = function(value) {
        return this.t15(this.f16(), value);
    };
    protoOf(TaggedEncoder).js = function(value) {
        return this.r15(this.f16(), value);
    };
    protoOf(TaggedEncoder).ks = function(value) {
        return this.u15(this.f16(), value);
    };
    protoOf(TaggedEncoder).ls = function(value) {
        return this.v15(this.f16(), value);
    };
    protoOf(TaggedEncoder).ms = function(value) {
        return this.w15(this.f16(), value);
    };
    protoOf(TaggedEncoder).ns = function(value) {
        return this.y15(this.f16(), value);
    };
    protoOf(TaggedEncoder).os = function(value) {
        return this.z15(this.f16(), value);
    };
    protoOf(TaggedEncoder).ps = function(enumDescriptor, index) {
        return this.a16(this.f16(), enumDescriptor, index);
    };
    protoOf(TaggedEncoder).lr = function(descriptor) {
        return this;
    };
    protoOf(TaggedEncoder).mr = function(descriptor) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.l15_1.s()) this.f16();
        this.c16(descriptor);
    };
    protoOf(TaggedEncoder).c16 = function(descriptor) {};
    protoOf(TaggedEncoder).rs = function(descriptor, index, value) {
        return this.x15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).ss = function(descriptor, index, value) {
        return this.s15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).ts = function(descriptor, index, value) {
        return this.t15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).us = function(descriptor, index, value) {
        return this.r15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).vs = function(descriptor, index, value) {
        return this.u15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).ws = function(descriptor, index, value) {
        return this.v15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).xs = function(descriptor, index, value) {
        return this.w15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).ys = function(descriptor, index, value) {
        return this.y15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).zs = function(descriptor, index, value) {
        return this.z15(this.i15(descriptor, index), value);
    };
    protoOf(TaggedEncoder).at = function(descriptor, index) {
        return this.b16(this.i15(descriptor, index), descriptor.up(index));
    };
    protoOf(TaggedEncoder).bt = function(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) this.ct(serializer, value);
    };
    protoOf(TaggedEncoder).dt = function(descriptor, index, serializer, value) {
        if (encodeElement(this, descriptor, index)) this.et(serializer, value);
    };
    protoOf(TaggedEncoder).d16 = function() {
        return last(this.l15_1);
    };
    protoOf(TaggedEncoder).m15 = function() {
        return lastOrNull(this.l15_1);
    };
    protoOf(TaggedEncoder).e16 = function(name) {
        this.l15_1.e(name);
    };
    protoOf(TaggedEncoder).f16 = function() {
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.l15_1.s()) tmp = this.l15_1.l2(get_lastIndex_0(this.l15_1));
        else throw SerializationException_init_$Create$_0("No tag in stack for requested element");
        return tmp;
    };
    function tagBlock($this, tag, block) {
        $this.e16(tag);
        var r = block();
        if (!$this.j16_1) $this.f16();
        $this.j16_1 = false;
        return r;
    }
    function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
        return function() {
            return this$0.jr($deserializer, $previousValue);
        };
    }
    function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
        return function() {
            return this$0.wq() ? this$0.jr($deserializer, $previousValue) : this$0.xq();
        };
    }
    function TaggedDecoder() {
        var tmp = this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.i16_1 = ArrayList_init_$Create$_0();
        this.j16_1 = false;
    }
    protoOf(TaggedDecoder).dp = function() {
        return EmptySerializersModule_0();
    };
    protoOf(TaggedDecoder).k16 = function(tag) {
        throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
    };
    protoOf(TaggedDecoder).l16 = function(tag) {
        return true;
    };
    protoOf(TaggedDecoder).m16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "boolean" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).n16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).o16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).p16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).q16 = function(tag) {
        var tmp = this.k16(tag);
        return tmp instanceof Long ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).r16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).s16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).t16 = function(tag) {
        var tmp = this.k16(tag);
        return tmp instanceof Char ? tmp.o1_1 : THROW_CCE();
    };
    protoOf(TaggedDecoder).u16 = function(tag) {
        var tmp = this.k16(tag);
        return typeof tmp === "string" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).v16 = function(tag, enumDescriptor) {
        var tmp = this.k16(tag);
        return typeof tmp === "number" ? tmp : THROW_CCE();
    };
    protoOf(TaggedDecoder).w16 = function(tag, inlineDescriptor) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
        this.e16(tag);
        return this;
    };
    protoOf(TaggedDecoder).jr = function(deserializer, previousValue) {
        return this.kr(deserializer);
    };
    protoOf(TaggedDecoder).ir = function(descriptor) {
        return this.w16(this.f16(), descriptor);
    };
    protoOf(TaggedDecoder).wq = function() {
        var tmp0_elvis_lhs = this.m15();
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var currentTag = tmp;
        return this.l16(currentTag);
    };
    protoOf(TaggedDecoder).xq = function() {
        return null;
    };
    protoOf(TaggedDecoder).yq = function() {
        return this.m16(this.f16());
    };
    protoOf(TaggedDecoder).zq = function() {
        return this.n16(this.f16());
    };
    protoOf(TaggedDecoder).ar = function() {
        return this.o16(this.f16());
    };
    protoOf(TaggedDecoder).br = function() {
        return this.p16(this.f16());
    };
    protoOf(TaggedDecoder).cr = function() {
        return this.q16(this.f16());
    };
    protoOf(TaggedDecoder).dr = function() {
        return this.r16(this.f16());
    };
    protoOf(TaggedDecoder).er = function() {
        return this.s16(this.f16());
    };
    protoOf(TaggedDecoder).fr = function() {
        return this.t16(this.f16());
    };
    protoOf(TaggedDecoder).gr = function() {
        return this.u16(this.f16());
    };
    protoOf(TaggedDecoder).hr = function(enumDescriptor) {
        return this.v16(this.f16(), enumDescriptor);
    };
    protoOf(TaggedDecoder).lr = function(descriptor) {
        return this;
    };
    protoOf(TaggedDecoder).mr = function(descriptor) {};
    protoOf(TaggedDecoder).nr = function(descriptor, index) {
        return this.m16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).or = function(descriptor, index) {
        return this.n16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).pr = function(descriptor, index) {
        return this.o16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).qr = function(descriptor, index) {
        return this.p16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).rr = function(descriptor, index) {
        return this.q16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).sr = function(descriptor, index) {
        return this.r16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).tr = function(descriptor, index) {
        return this.s16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).ur = function(descriptor, index) {
        return this.t16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).vr = function(descriptor, index) {
        return this.u16(this.i15(descriptor, index));
    };
    protoOf(TaggedDecoder).wr = function(descriptor, index) {
        return this.w16(this.i15(descriptor, index), descriptor.up(index));
    };
    protoOf(TaggedDecoder).xr = function(descriptor, index, deserializer, previousValue) {
        var tmp = this.i15(descriptor, index);
        return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
    };
    protoOf(TaggedDecoder).zr = function(descriptor, index, deserializer, previousValue) {
        var tmp = this.i15(descriptor, index);
        return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
    };
    protoOf(TaggedDecoder).m15 = function() {
        return lastOrNull(this.i16_1);
    };
    protoOf(TaggedDecoder).e16 = function(name) {
        this.i16_1.e(name);
    };
    protoOf(TaggedDecoder).f16 = function() {
        var r = this.i16_1.l2(get_lastIndex_0(this.i16_1));
        this.j16_1 = true;
        return r;
    };
    function get_NULL() {
        _init_properties_Tuples_kt__dz0qyd();
        return NULL;
    }
    var NULL;
    function MapEntry(key, value) {
        this.x16_1 = key;
        this.y16_1 = value;
    }
    protoOf(MapEntry).a1 = function() {
        return this.x16_1;
    };
    protoOf(MapEntry).b1 = function() {
        return this.y16_1;
    };
    protoOf(MapEntry).toString = function() {
        return "MapEntry(key=" + toString_0(this.x16_1) + ", value=" + toString_0(this.y16_1) + ")";
    };
    protoOf(MapEntry).hashCode = function() {
        var result = this.x16_1 == null ? 0 : hashCode(this.x16_1);
        result = imul(result, 31) + (this.y16_1 == null ? 0 : hashCode(this.y16_1)) | 0;
        return result;
    };
    protoOf(MapEntry).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof MapEntry)) return false;
        var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
        if (!equals(this.x16_1, tmp0_other_with_cast.x16_1)) return false;
        if (!equals(this.y16_1, tmp0_other_with_cast.y16_1)) return false;
        return true;
    };
    function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
        return function($this$buildSerialDescriptor) {
            $this$buildSerialDescriptor.mo("key", $keySerializer.yn());
            $this$buildSerialDescriptor.mo("value", $valueSerializer.yn());
            return Unit_instance;
        };
    }
    function MapEntrySerializer_0(keySerializer, valueSerializer) {
        KeyValueSerializer.call(this, keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.b17_1 = buildSerialDescriptor("kotlin.collections.Map.Entry", tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
    }
    protoOf(MapEntrySerializer_0).yn = function() {
        return this.b17_1;
    };
    protoOf(MapEntrySerializer_0).c17 = function(_this__u8e3s4) {
        return _this__u8e3s4.a1();
    };
    protoOf(MapEntrySerializer_0).d17 = function(_this__u8e3s4) {
        return this.c17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(MapEntrySerializer_0).e17 = function(_this__u8e3s4) {
        return _this__u8e3s4.b1();
    };
    protoOf(MapEntrySerializer_0).f17 = function(_this__u8e3s4) {
        return this.e17((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(MapEntrySerializer_0).g17 = function(key, value) {
        return new MapEntry(key, value);
    };
    function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
        return function($this$buildClassSerialDescriptor) {
            $this$buildClassSerialDescriptor.mo("first", $keySerializer.yn());
            $this$buildClassSerialDescriptor.mo("second", $valueSerializer.yn());
            return Unit_instance;
        };
    }
    function PairSerializer_0(keySerializer, valueSerializer) {
        KeyValueSerializer.call(this, keySerializer, valueSerializer);
        var tmp = this;
        tmp.m17_1 = buildClassSerialDescriptor("kotlin.Pair", [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
    }
    protoOf(PairSerializer_0).yn = function() {
        return this.m17_1;
    };
    protoOf(PairSerializer_0).n17 = function(_this__u8e3s4) {
        return _this__u8e3s4.z9_1;
    };
    protoOf(PairSerializer_0).d17 = function(_this__u8e3s4) {
        return this.n17(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(PairSerializer_0).o17 = function(_this__u8e3s4) {
        return _this__u8e3s4.aa_1;
    };
    protoOf(PairSerializer_0).f17 = function(_this__u8e3s4) {
        return this.o17(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
    };
    protoOf(PairSerializer_0).g17 = function(key, value) {
        return to(key, value);
    };
    function decodeSequentially_1($this, composite) {
        var a = composite.yr($this.s17_1, 0, $this.p17_1);
        var b = composite.yr($this.s17_1, 1, $this.q17_1);
        var c = composite.yr($this.s17_1, 2, $this.r17_1);
        composite.mr($this.s17_1);
        return new Triple(a, b, c);
    }
    function decodeStructure($this, composite) {
        var a = get_NULL();
        var b = get_NULL();
        var c = get_NULL();
        mainLoop: while(true){
            var index = composite.bs($this.s17_1);
            switch(index){
                case -1:
                    break mainLoop;
                case 0:
                    a = composite.yr($this.s17_1, 0, $this.p17_1);
                    break;
                case 1:
                    b = composite.yr($this.s17_1, 1, $this.q17_1);
                    break;
                case 2:
                    c = composite.yr($this.s17_1, 2, $this.r17_1);
                    break;
                default:
                    throw SerializationException_init_$Create$_0("Unexpected index " + index);
            }
        }
        composite.mr($this.s17_1);
        if (a === get_NULL()) throw SerializationException_init_$Create$_0("Element 'first' is missing");
        if (b === get_NULL()) throw SerializationException_init_$Create$_0("Element 'second' is missing");
        if (c === get_NULL()) throw SerializationException_init_$Create$_0("Element 'third' is missing");
        var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
        var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
        return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
    }
    function TripleSerializer$descriptor$lambda(this$0) {
        return function($this$buildClassSerialDescriptor) {
            $this$buildClassSerialDescriptor.mo("first", this$0.p17_1.yn());
            $this$buildClassSerialDescriptor.mo("second", this$0.q17_1.yn());
            $this$buildClassSerialDescriptor.mo("third", this$0.r17_1.yn());
            return Unit_instance;
        };
    }
    function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
        this.p17_1 = aSerializer;
        this.q17_1 = bSerializer;
        this.r17_1 = cSerializer;
        var tmp = this;
        tmp.s17_1 = buildClassSerialDescriptor("kotlin.Triple", [], TripleSerializer$descriptor$lambda(this));
    }
    protoOf(TripleSerializer_0).yn = function() {
        return this.s17_1;
    };
    protoOf(TripleSerializer_0).t17 = function(encoder, value) {
        var structuredEncoder = encoder.lr(this.s17_1);
        structuredEncoder.bt(this.s17_1, 0, this.p17_1, value.nj_1);
        structuredEncoder.bt(this.s17_1, 1, this.q17_1, value.oj_1);
        structuredEncoder.bt(this.s17_1, 2, this.r17_1, value.pj_1);
        structuredEncoder.mr(this.s17_1);
    };
    protoOf(TripleSerializer_0).zn = function(encoder, value) {
        return this.t17(encoder, value instanceof Triple ? value : THROW_CCE());
    };
    protoOf(TripleSerializer_0).ao = function(decoder) {
        var composite = decoder.lr(this.s17_1);
        if (composite.as()) return decodeSequentially_1(this, composite);
        return decodeStructure(this, composite);
    };
    function KeyValueSerializer(keySerializer, valueSerializer) {
        this.h17_1 = keySerializer;
        this.i17_1 = valueSerializer;
    }
    protoOf(KeyValueSerializer).j17 = function(encoder, value) {
        var structuredEncoder = encoder.lr(this.yn());
        structuredEncoder.bt(this.yn(), 0, this.h17_1, this.d17(value));
        structuredEncoder.bt(this.yn(), 1, this.i17_1, this.f17(value));
        structuredEncoder.mr(this.yn());
    };
    protoOf(KeyValueSerializer).zn = function(encoder, value) {
        return this.j17(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(KeyValueSerializer).ao = function(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.yn();
        var composite = decoder.lr(descriptor);
        var tmp$ret$0;
        $l$block: {
            // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
            if (composite.as()) {
                var key = composite.yr(this.yn(), 0, this.h17_1);
                var value = composite.yr(this.yn(), 1, this.i17_1);
                tmp$ret$0 = this.g17(key, value);
                break $l$block;
            }
            var key_0 = get_NULL();
            var value_0 = get_NULL();
            mainLoop: while(true){
                var idx = composite.bs(this.yn());
                switch(idx){
                    case -1:
                        break mainLoop;
                    case 0:
                        key_0 = composite.yr(this.yn(), 0, this.h17_1);
                        break;
                    case 1:
                        value_0 = composite.yr(this.yn(), 1, this.i17_1);
                        break;
                    default:
                        throw SerializationException_init_$Create$_0("Invalid index: " + idx);
                }
            }
            if (key_0 === get_NULL()) throw SerializationException_init_$Create$_0("Element 'key' is missing");
            if (value_0 === get_NULL()) throw SerializationException_init_$Create$_0("Element 'value' is missing");
            var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
            tmp$ret$0 = this.g17(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
        }
        var result = tmp$ret$0;
        composite.mr(descriptor);
        return result;
    };
    var properties_initialized_Tuples_kt_3vs7ar;
    function _init_properties_Tuples_kt__dz0qyd() {
        if (!properties_initialized_Tuples_kt_3vs7ar) {
            properties_initialized_Tuples_kt_3vs7ar = true;
            NULL = new Object();
        }
    }
    function ULongSerializer() {
        ULongSerializer_instance = this;
        this.u17_1 = InlinePrimitiveDescriptor("kotlin.ULong", serializer_5(Companion_getInstance_1()));
    }
    protoOf(ULongSerializer).yn = function() {
        return this.u17_1;
    };
    protoOf(ULongSerializer).v17 = function(encoder, value) {
        var tmp = encoder.qs(this.u17_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.ks(tmp$ret$0);
    };
    protoOf(ULongSerializer).zn = function(encoder, value) {
        return this.v17(encoder, value instanceof ULong ? value.tk_1 : THROW_CCE());
    };
    protoOf(ULongSerializer).w17 = function(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.ir(this.u17_1).cr();
        return _ULong___init__impl__c78o9k(this_0);
    };
    protoOf(ULongSerializer).ao = function(decoder) {
        return new ULong(this.w17(decoder));
    };
    var ULongSerializer_instance;
    function ULongSerializer_getInstance() {
        if (ULongSerializer_instance == null) new ULongSerializer();
        return ULongSerializer_instance;
    }
    function UIntSerializer() {
        UIntSerializer_instance = this;
        this.x17_1 = InlinePrimitiveDescriptor("kotlin.UInt", serializer_7(IntCompanionObject_instance));
    }
    protoOf(UIntSerializer).yn = function() {
        return this.x17_1;
    };
    protoOf(UIntSerializer).y17 = function(encoder, value) {
        var tmp = encoder.qs(this.x17_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.js(tmp$ret$0);
    };
    protoOf(UIntSerializer).zn = function(encoder, value) {
        return this.y17(encoder, value instanceof UInt ? value.hk_1 : THROW_CCE());
    };
    protoOf(UIntSerializer).z17 = function(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.ir(this.x17_1).br();
        return _UInt___init__impl__l7qpdl(this_0);
    };
    protoOf(UIntSerializer).ao = function(decoder) {
        return new UInt(this.z17(decoder));
    };
    var UIntSerializer_instance;
    function UIntSerializer_getInstance() {
        if (UIntSerializer_instance == null) new UIntSerializer();
        return UIntSerializer_instance;
    }
    function UShortSerializer() {
        UShortSerializer_instance = this;
        this.a18_1 = InlinePrimitiveDescriptor("kotlin.UShort", serializer_9(ShortCompanionObject_instance));
    }
    protoOf(UShortSerializer).yn = function() {
        return this.a18_1;
    };
    protoOf(UShortSerializer).b18 = function(encoder, value) {
        var tmp = encoder.qs(this.a18_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.is(tmp$ret$0);
    };
    protoOf(UShortSerializer).zn = function(encoder, value) {
        return this.b18(encoder, value instanceof UShort ? value.fl_1 : THROW_CCE());
    };
    protoOf(UShortSerializer).c18 = function(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.ir(this.a18_1).ar();
        return _UShort___init__impl__jigrne(this_0);
    };
    protoOf(UShortSerializer).ao = function(decoder) {
        return new UShort(this.c18(decoder));
    };
    var UShortSerializer_instance;
    function UShortSerializer_getInstance() {
        if (UShortSerializer_instance == null) new UShortSerializer();
        return UShortSerializer_instance;
    }
    function UByteSerializer() {
        UByteSerializer_instance = this;
        this.d18_1 = InlinePrimitiveDescriptor("kotlin.UByte", serializer_11(ByteCompanionObject_instance));
    }
    protoOf(UByteSerializer).yn = function() {
        return this.d18_1;
    };
    protoOf(UByteSerializer).e18 = function(encoder, value) {
        var tmp = encoder.qs(this.d18_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.hs(tmp$ret$0);
    };
    protoOf(UByteSerializer).zn = function(encoder, value) {
        return this.e18(encoder, value instanceof UByte ? value.vj_1 : THROW_CCE());
    };
    protoOf(UByteSerializer).f18 = function(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.ir(this.d18_1).zq();
        return _UByte___init__impl__g9hnc4(this_0);
    };
    protoOf(UByteSerializer).ao = function(decoder) {
        return new UByte(this.f18(decoder));
    };
    var UByteSerializer_instance;
    function UByteSerializer_getInstance() {
        if (UByteSerializer_instance == null) new UByteSerializer();
        return UByteSerializer_instance;
    }
    function get_EmptySerializersModuleLegacyJs() {
        _init_properties_SerializersModule_kt__u78ha3();
        return EmptySerializersModule;
    }
    var EmptySerializersModule;
    function SerializersModule() {}
    protoOf(SerializersModule).ip = function(kClass, typeArgumentsSerializers, $super) {
        typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
        return $super === VOID ? this.hp(kClass, typeArgumentsSerializers) : $super.hp.call(this, kClass, typeArgumentsSerializers);
    };
    function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
        SerializersModule.call(this);
        this.h18_1 = class2ContextualFactory;
        this.i18_1 = polyBase2Serializers;
        this.j18_1 = polyBase2DefaultSerializerProvider;
        this.k18_1 = polyBase2NamedSerializers;
        this.l18_1 = polyBase2DefaultDeserializerProvider;
    }
    protoOf(SerialModuleImpl).jt = function(baseClass, value) {
        if (!baseClass.ga(value)) return null;
        var tmp0_safe_receiver = this.i18_1.e2(baseClass);
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e2(getKClassFromExpression(value));
        var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
        if (!(registered == null)) return registered;
        var tmp_0 = this.j18_1.e2(baseClass);
        var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === "function" : false) ? tmp_0 : null;
        return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
    };
    protoOf(SerialModuleImpl).it = function(baseClass, serializedClassName) {
        var tmp0_safe_receiver = this.k18_1.e2(baseClass);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.collections.get' call
        tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).e2(serializedClassName);
        var tmp_0 = tmp;
        var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
        if (!(registered == null)) return registered;
        var tmp_1 = this.l18_1.e2(baseClass);
        var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === "function" : false) ? tmp_1 : null;
        return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
    };
    protoOf(SerialModuleImpl).hp = function(kClass, typeArgumentsSerializers) {
        var tmp0_safe_receiver = this.h18_1.e2(kClass);
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m18(typeArgumentsSerializers);
        return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
    };
    protoOf(SerialModuleImpl).g18 = function(collector) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = this.h18_1.z().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var kclass = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var serial = element.b1();
            if (serial instanceof Argless) {
                var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
                var tmp_0 = serial.p18_1;
                collector.q18(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
            } else if (serial instanceof WithTypeArguments) collector.o18(kclass, serial.n18_1);
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_0 = this.i18_1.z().j();
        while(tmp0_iterator_0.k()){
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var baseClass = element_0.a1();
            // Inline function 'kotlin.collections.component2' call
            var classMap = element_0.b1();
            // Inline function 'kotlin.collections.forEach' call
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator_1 = classMap.z().j();
            while(tmp0_iterator_1.k()){
                var element_1 = tmp0_iterator_1.l();
                // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var actualClass = element_1.a1();
                // Inline function 'kotlin.collections.component2' call
                var serializer = element_1.b1();
                var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
                var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
                // Inline function 'kotlinx.serialization.internal.cast' call
                var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
                collector.r18(tmp_1, tmp_2, tmp$ret$9);
            }
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_2 = this.j18_1.z().j();
        while(tmp0_iterator_2.k()){
            var element_2 = tmp0_iterator_2.l();
            // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var baseClass_0 = element_2.a1();
            // Inline function 'kotlin.collections.component2' call
            var provider = element_2.b1();
            var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
            collector.s18(tmp_3, typeof provider === "function" ? provider : THROW_CCE());
        }
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_3 = this.l18_1.z().j();
        while(tmp0_iterator_3.k()){
            var element_3 = tmp0_iterator_3.l();
            // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var baseClass_1 = element_3.a1();
            // Inline function 'kotlin.collections.component2' call
            var provider_0 = element_3.b1();
            var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
            collector.t18(tmp_4, typeof provider_0 === "function" ? provider_0 : THROW_CCE());
        }
    };
    function Argless() {}
    function WithTypeArguments() {}
    function ContextualProvider() {}
    var properties_initialized_SerializersModule_kt_fjigjn;
    function _init_properties_SerializersModule_kt__u78ha3() {
        if (!properties_initialized_SerializersModule_kt_fjigjn) {
            properties_initialized_SerializersModule_kt_fjigjn = true;
            EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
        }
    }
    function EmptySerializersModule_0() {
        return get_EmptySerializersModuleLegacyJs();
    }
    function SerializersModuleCollector$contextual$lambda($serializer) {
        return function(it) {
            return $serializer;
        };
    }
    function SerializersModuleCollector() {}
    function SerializableWith(serializer) {
        this.u18_1 = serializer;
    }
    protoOf(SerializableWith).equals = function(other) {
        if (!(other instanceof SerializableWith)) return false;
        var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
        if (!this.u18_1.equals(tmp0_other_with_cast.u18_1)) return false;
        return true;
    };
    protoOf(SerializableWith).hashCode = function() {
        return imul(getStringHashCode("serializer"), 127) ^ this.u18_1.hashCode();
    };
    protoOf(SerializableWith).toString = function() {
        return "@kotlinx.serialization.SerializableWith(serializer=" + toString(this.u18_1) + ")";
    };
    function createCache(factory) {
        return new createCache$1(factory);
    }
    function createParametrizedCache(factory) {
        return new createParametrizedCache$1(factory);
    }
    function compiledSerializerImpl(_this__u8e3s4) {
        var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
        var tmp;
        if (tmp1_elvis_lhs == null) {
            var tmp_0;
            if (_this__u8e3s4 === PrimitiveClasses_getInstance().ya()) tmp_0 = NothingSerializer_getInstance();
            else {
                // Inline function 'kotlin.js.asDynamic' call
                var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
                tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
            }
            var tmp_1 = tmp_0;
            tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
        } else tmp = tmp1_elvis_lhs;
        return tmp;
    }
    function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
        throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + "To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.");
    }
    function isReferenceArray(rootClass) {
        return rootClass.equals(PrimitiveClasses_getInstance().fb());
    }
    function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
        var tmp;
        try {
            // Inline function 'kotlin.reflect.findAssociatedObject' call
            var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
            var tmp_0;
            if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
            else {
                if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
                    var tmp_1 = assocObject.wz(args.slice());
                    tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
                } else if (get_isInterface(_this__u8e3s4)) tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
                else tmp_0 = null;
            }
            tmp = tmp_0;
        } catch ($p) {
            var tmp_2;
            var e = $p;
            tmp_2 = null;
            tmp = tmp_2;
        }
        return tmp;
    }
    function get_isInterface(_this__u8e3s4) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
        return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == "interface";
    }
    function toNativeArrayImpl(_this__u8e3s4, eClass) {
        // Inline function 'kotlin.collections.toTypedArray' call
        return copyToArray(_this__u8e3s4);
    }
    function getChecked(_this__u8e3s4, index) {
        if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false)) throw IndexOutOfBoundsException_init_$Create$("Index " + index + " out of bounds " + get_indices(_this__u8e3s4).toString());
        return _this__u8e3s4[index];
    }
    function getChecked_0(_this__u8e3s4, index) {
        if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false)) throw IndexOutOfBoundsException_init_$Create$("Index " + index + " out of bounds " + get_indices_0(_this__u8e3s4).toString());
        return _this__u8e3s4[index];
    }
    function createCache$1($factory) {
        this.v18_1 = $factory;
    }
    protoOf(createCache$1).jp = function(key) {
        return this.v18_1(key);
    };
    function createParametrizedCache$1($factory) {
        this.w18_1 = $factory;
    }
    protoOf(createParametrizedCache$1).kp = function(key, types) {
        // Inline function 'kotlin.runCatching' call
        var tmp;
        try {
            // Inline function 'kotlin.Companion.success' call
            // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
            var value = this.w18_1(key, types);
            tmp = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var e = $p;
                // Inline function 'kotlin.Companion.failure' call
                tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    };
    //region block: post-declaration
    protoOf(SerialDescriptorImpl).lp = get_isNullable;
    protoOf(SerialDescriptorImpl).rp = get_isInline;
    protoOf(AbstractDecoder).yr = decodeSerializableElement$default;
    protoOf(AbstractDecoder).kr = decodeSerializableValue;
    protoOf(AbstractDecoder).as = decodeSequentially;
    protoOf(AbstractDecoder).cs = decodeCollectionSize;
    protoOf(AbstractEncoder).ft = encodeNotNullMark;
    protoOf(AbstractEncoder).gt = beginCollection;
    protoOf(AbstractEncoder).ct = encodeSerializableValue;
    protoOf(AbstractEncoder).et = encodeNullableSerializableValue;
    protoOf(AbstractEncoder).ht = shouldEncodeElementDefault;
    protoOf(ListLikeDescriptor).lp = get_isNullable;
    protoOf(ListLikeDescriptor).rp = get_isInline;
    protoOf(ListLikeDescriptor).pp = get_annotations;
    protoOf(MapLikeDescriptor).lp = get_isNullable;
    protoOf(MapLikeDescriptor).rp = get_isInline;
    protoOf(MapLikeDescriptor).pp = get_annotations;
    protoOf(PluginGeneratedSerialDescriptor).lp = get_isNullable;
    protoOf(PluginGeneratedSerialDescriptor).rp = get_isInline;
    protoOf(InlinePrimitiveDescriptor$1).mz = typeParametersSerializers;
    protoOf(NothingSerialDescriptor).lp = get_isNullable;
    protoOf(NothingSerialDescriptor).rp = get_isInline;
    protoOf(NothingSerialDescriptor).pp = get_annotations;
    protoOf(PrimitiveSerialDescriptor_0).lp = get_isNullable;
    protoOf(PrimitiveSerialDescriptor_0).rp = get_isInline;
    protoOf(PrimitiveSerialDescriptor_0).pp = get_annotations;
    protoOf(TaggedEncoder).gt = beginCollection;
    protoOf(TaggedEncoder).ct = encodeSerializableValue;
    protoOf(TaggedEncoder).et = encodeNullableSerializableValue;
    protoOf(TaggedEncoder).ht = shouldEncodeElementDefault;
    protoOf(TaggedDecoder).yr = decodeSerializableElement$default;
    protoOf(TaggedDecoder).kr = decodeSerializableValue;
    protoOf(TaggedDecoder).as = decodeSequentially;
    protoOf(TaggedDecoder).cs = decodeCollectionSize;
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = PolymorphicSerializer_init_$Create$;
    _.$_$.b = SealedClassSerializer_init_$Create$;
    _.$_$.c = SerializationException_init_$Init$_0;
    _.$_$.d = SerializationException_init_$Create$_0;
    _.$_$.e = UnknownFieldException_init_$Create$;
    _.$_$.f = SEALED_getInstance;
    _.$_$.g = STRING_getInstance;
    _.$_$.h = CONTEXTUAL_getInstance;
    _.$_$.i = ENUM_getInstance;
    _.$_$.j = CLASS_getInstance;
    _.$_$.k = LIST_getInstance;
    _.$_$.l = MAP_getInstance;
    _.$_$.m = BooleanSerializer_getInstance;
    _.$_$.n = IntSerializer_getInstance;
    _.$_$.o = LongSerializer_getInstance;
    _.$_$.p = StringSerializer_getInstance;
    _.$_$.q = ListSerializer;
    _.$_$.r = MapSerializer;
    _.$_$.s = SetSerializer;
    _.$_$.t = get_nullable;
    _.$_$.u = serializer_1;
    _.$_$.v = serializer_10;
    _.$_$.w = serializer_8;
    _.$_$.x = serializer_12;
    _.$_$.y = serializer_6;
    _.$_$.z = PolymorphicKind;
    _.$_$.a1 = PrimitiveKind;
    _.$_$.b1 = PrimitiveSerialDescriptor;
    _.$_$.c1 = get_annotations;
    _.$_$.d1 = get_isInline;
    _.$_$.e1 = get_isNullable;
    _.$_$.f1 = SerialDescriptor;
    _.$_$.g1 = ENUM;
    _.$_$.h1 = buildSerialDescriptor;
    _.$_$.i1 = getContextualDescriptor;
    _.$_$.j1 = AbstractDecoder;
    _.$_$.k1 = AbstractEncoder;
    _.$_$.l1 = CompositeDecoder;
    _.$_$.m1 = CompositeEncoder;
    _.$_$.n1 = Decoder;
    _.$_$.o1 = Encoder;
    _.$_$.p1 = AbstractPolymorphicSerializer;
    _.$_$.q1 = ArrayListSerializer;
    _.$_$.r1 = ElementMarker;
    _.$_$.s1 = typeParametersSerializers;
    _.$_$.t1 = GeneratedSerializer;
    _.$_$.u1 = InlinePrimitiveDescriptor;
    _.$_$.v1 = LinkedHashMapSerializer;
    _.$_$.w1 = LinkedHashSetSerializer;
    _.$_$.x1 = NamedValueDecoder;
    _.$_$.y1 = NamedValueEncoder;
    _.$_$.z1 = PluginGeneratedSerialDescriptor;
    _.$_$.a2 = ReferenceArraySerializer;
    _.$_$.b2 = SerializerFactory;
    _.$_$.c2 = createSimpleEnumSerializer;
    _.$_$.d2 = jsonCachedSerialNames;
    _.$_$.e2 = throwMissingFieldException;
    _.$_$.f2 = EmptySerializersModule_0;
    _.$_$.g2 = contextual;
    _.$_$.h2 = SerializersModuleCollector;
    _.$_$.i2 = BinaryFormat;
    _.$_$.j2 = DeserializationStrategy;
    _.$_$.k2 = KSerializer;
    _.$_$.l2 = MissingFieldException;
    _.$_$.m2 = SealedClassSerializer;
    _.$_$.n2 = SerializationException;
    _.$_$.o2 = StringFormat;
    _.$_$.p2 = findPolymorphicSerializer;
    _.$_$.q2 = serializerOrNull_0;
    _.$_$.r2 = serializerOrNull;
    _.$_$.s2 = serializer_0;
    _.$_$.t2 = serializer;
    //endregion
    return _;
});

});


parcelRegister("fcWHW", function(module, exports) {





(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./curity-ssi-libs-core.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./Kotlin-DateTime-library-kotlinx-datetime.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("2VOQS")), (parcelRequire("iuiRe")), (parcelRequire("3kJd2")), (parcelRequire("3WyZ3")));
})(globalThis, function(_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_datetime) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var protoOf = kotlin_kotlin.$_$.kb;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var VOID = kotlin_kotlin.$_$.f;
    var toString = kotlin_kotlin.$_$.ob;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var toMap = kotlin_kotlin.$_$.m8;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var hashCode = kotlin_kotlin.$_$.ha;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var equals = kotlin_kotlin.$_$.ba;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
    var emptyList = kotlin_kotlin.$_$.r6;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var first = kotlin_kotlin.$_$.y6;
    var drop = kotlin_kotlin.$_$.q6;
    var toList = kotlin_kotlin.$_$.k8;
    var DefaultMultiValue = kotlin_io_curity_ssi_core.$_$.h;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var get_all = kotlin_io_curity_ssi_core.$_$.i;
    var isSingleItem = kotlin_io_curity_ssi_core.$_$.k;
    var forEach = kotlin_io_curity_ssi_core.$_$.j;
    var MultiValue = kotlin_io_curity_ssi_core.$_$.l;
    var JsonPrimitive_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.k;
    var toMutableMap = kotlin_kotlin.$_$.p8;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var lazy = kotlin_kotlin.$_$.qf;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
    var JsonPrimitive_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.l;
    var ToString = kotlin_io_curity_ssi_core.$_$.m;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
    var asSequence = kotlin_kotlin.$_$.y5;
    var map = kotlin_kotlin.$_$.ec;
    var toList_0 = kotlin_kotlin.$_$.fc;
    var checkIndexOverflow = kotlin_kotlin.$_$.z5;
    var get_longOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.u;
    var toSet = kotlin_kotlin.$_$.gc;
    var get_booleanOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var Companion_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
    var Exception = kotlin_kotlin.$_$.ke;
    var Companion_instance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
    var isInterface = kotlin_kotlin.$_$.xa;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
    var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var JsonElement = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var iterator = kotlin_kotlin.$_$.cb;
    var isNumber = kotlin_kotlin.$_$.za;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var get_intOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
    var get_floatOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.q;
    var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
    //endregion
    //region block: pre-declaration
    initMetadataForInterface(ToJson, "ToJson");
    function get_keys() {
        return this.y26().f2();
    }
    function get(key) {
        return this.y26().vl(key);
    }
    function toJson() {
        return new JsonObject(this.xl());
    }
    initMetadataForInterface(ToJsonDictionary, "ToJsonDictionary", VOID, VOID, [
        Dictionary,
        ToJson
    ], VOID, VOID, {
        0: ToJsonDictionarySerializer_getInstance
    });
    initMetadataForObject(FromJsonHelper, "FromJsonHelper");
    initMetadataForCompanion(Companion);
    initMetadataForClass(JsonDictionary, "JsonDictionary", VOID, VOID, [
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonDictionarySerializer_getInstance
    });
    initMetadataForCompanion(Companion_0, VOID, [
        SerializerFactory
    ]);
    initMetadataForClass(DefaultJsonMultiValue, "DefaultJsonMultiValue", VOID, VOID, [
        MultiValue
    ], VOID, VOID, {
        0: DefaultJsonMultiValueSerializer_getInstance
    });
    initMetadataForClass(CompositeFromJson, "CompositeFromJson");
    initMetadataForClass(TypedDictionaryFromJson, "TypedDictionaryFromJson");
    initMetadataForClass(TypedJsonDictionary, "TypedJsonDictionary", VOID, VOID, [
        ToJsonDictionary
    ]);
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(AnyString, "AnyString", VOID, VOID, [
        ToString,
        ToJson
    ], VOID, VOID, {
        0: AnyStringSerializer_getInstance
    });
    initMetadataForClass(JsonSerializer, "JsonSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(DerivedSerializer, "DerivedSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForClass(DelegateSerializer, "DelegateSerializer", VOID, DerivedSerializer);
    initMetadataForObject(ToJsonDictionarySerializer, "ToJsonDictionarySerializer", VOID, DelegateSerializer);
    initMetadataForObject(JsonDictionarySerializer, "JsonDictionarySerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(DefaultJsonMultiValueSerializer, "DefaultJsonMultiValueSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(AnyStringSerializer, "AnyStringSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsToJsonConverter, "JsToJsonConverter");
    initMetadataForObject(JsonToJsConverter, "JsonToJsConverter");
    //endregion
    function ToJsonDictionary() {}
    function FromJsonHelper() {}
    protoOf(FromJsonHelper).b27 = function(json, type) {
        if (json instanceof JsonObject) return json;
        // Inline function 'kotlin.error' call
        var message = "Cannot deserialize '" + type + "', not an object";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    protoOf(FromJsonHelper).c27 = function(json, type) {
        var tmp;
        if (json instanceof JsonPrimitive) tmp = json.d1b();
        else tmp = false;
        if (tmp) return json;
        // Inline function 'kotlin.error' call
        var message = "Cannot deserialize '" + type + "', not a String";
        throw IllegalStateException_init_$Create$(toString(message));
    };
    var FromJsonHelper_instance;
    function FromJsonHelper_getInstance() {
        return FromJsonHelper_instance;
    }
    function Companion() {}
    protoOf(Companion).d27 = function(json) {
        return new JsonDictionary(toMap(FromJsonHelper_instance.b27(json, "JsonDictionary")));
    };
    var Companion_instance_0;
    function Companion_getInstance_0() {
        return Companion_instance_0;
    }
    function JsonDictionary(_claims) {
        this.z26_1 = _claims;
    }
    protoOf(JsonDictionary).f2 = function() {
        return this.z26_1.f2();
    };
    protoOf(JsonDictionary).vl = function(key) {
        return this.z26_1.e2(key);
    };
    protoOf(JsonDictionary).xl = function() {
        return this.z26_1;
    };
    protoOf(JsonDictionary).y26 = function() {
        return this;
    };
    protoOf(JsonDictionary).toString = function() {
        return "JsonDictionary(_claims=" + toString(this.z26_1) + ")";
    };
    protoOf(JsonDictionary).hashCode = function() {
        return hashCode(this.z26_1);
    };
    protoOf(JsonDictionary).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonDictionary)) return false;
        var tmp0_other_with_cast = other instanceof JsonDictionary ? other : THROW_CCE();
        if (!equals(this.z26_1, tmp0_other_with_cast.z26_1)) return false;
        return true;
    };
    function toJson_0(_this__u8e3s4) {
        return JsonPrimitive_0(_this__u8e3s4);
    }
    function toJson_1(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.json.data.toJson.<anonymous>' call
            var tmp$ret$0 = toJson_0(item);
            destination.e(tmp$ret$0);
        }
        return new JsonArray(destination);
    }
    function Companion_0() {}
    protoOf(Companion_0).e27 = function(json, serializer) {
        var tmp;
        if (json instanceof JsonArray) {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(json, 10));
            var tmp0_iterator = json.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.json.data.Companion.fromJson.<anonymous>' call
                var tmp$ret$0 = Default_getInstance().b19(serializer, item);
                destination.e(tmp$ret$0);
            }
            tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
        } else tmp = DefaultJsonMultiValue_init_$Create$(Default_getInstance().b19(serializer, json));
        return tmp;
    };
    protoOf(Companion_0).f27 = function(typeSerial0) {
        return DefaultJsonMultiValueSerializer_getInstance();
    };
    protoOf(Companion_0).wz = function(typeParamsSerializers) {
        return this.f27(typeParamsSerializers[0]);
    };
    var Companion_instance_1;
    function Companion_getInstance_1() {
        return Companion_instance_1;
    }
    function DefaultJsonMultiValue_init_$Init$(singleItem, $this) {
        DefaultJsonMultiValue.call($this, singleItem, emptyList());
        return $this;
    }
    function DefaultJsonMultiValue_init_$Create$(singleItem) {
        return DefaultJsonMultiValue_init_$Init$(singleItem, objectCreate(protoOf(DefaultJsonMultiValue)));
    }
    function DefaultJsonMultiValue_init_$Init$_0(many, $this) {
        DefaultJsonMultiValue.call($this, first(many), toList(drop(many, 1)));
        return $this;
    }
    function DefaultJsonMultiValue_init_$Create$_0(many) {
        return DefaultJsonMultiValue_init_$Init$_0(many, objectCreate(protoOf(DefaultJsonMultiValue)));
    }
    function DefaultJsonMultiValue(_first, _rest) {
        this.g27_1 = _first;
        this.h27_1 = _rest;
        this.i27_1 = this.g27_1;
        this.j27_1 = this.h27_1;
    }
    protoOf(DefaultJsonMultiValue).mm = function() {
        return this.i27_1;
    };
    protoOf(DefaultJsonMultiValue).lm = function() {
        return this.j27_1;
    };
    protoOf(DefaultJsonMultiValue).k27 = function(mapper) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.qm();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            destination.e(mapper(item));
        }
        return new DefaultMultiValue(destination);
    };
    protoOf(DefaultJsonMultiValue).l27 = function(valueMapper) {
        var tmp;
        if (this.sm()) tmp = valueMapper(this.i27_1);
        else {
            // Inline function 'kotlin.collections.map' call
            var this_0 = this.qm();
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.json.data.DefaultJsonMultiValue.toJson.<anonymous>' call
                var tmp$ret$0 = valueMapper(item);
                destination.e(tmp$ret$0);
            }
            tmp = new JsonArray(destination);
        }
        return tmp;
    };
    protoOf(DefaultJsonMultiValue).toString = function() {
        return "DefaultJsonMultiValue(_first=" + toString_0(this.g27_1) + ", _rest=" + toString(this.h27_1) + ")";
    };
    protoOf(DefaultJsonMultiValue).hashCode = function() {
        var result = this.g27_1 == null ? 0 : hashCode(this.g27_1);
        result = imul(result, 31) + hashCode(this.h27_1) | 0;
        return result;
    };
    protoOf(DefaultJsonMultiValue).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DefaultJsonMultiValue)) return false;
        var tmp0_other_with_cast = other instanceof DefaultJsonMultiValue ? other : THROW_CCE();
        if (!equals(this.g27_1, tmp0_other_with_cast.g27_1)) return false;
        if (!equals(this.h27_1, tmp0_other_with_cast.h27_1)) return false;
        return true;
    };
    function toJson_2(_this__u8e3s4) {
        return JsonPrimitive_1(_this__u8e3s4);
    }
    function CompositeFromJson(_fromJson) {
        this.m27_1 = _fromJson;
    }
    protoOf(CompositeFromJson).d27 = function(json) {
        var serialized = this.m27_1.d27(json);
        return this.n27(serialized);
    };
    function TypedDictionaryFromJson(_typeKey) {
        this.o27_1 = _typeKey;
    }
    protoOf(TypedDictionaryFromJson).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "TypedJsonDictionary"));
        var type = unwrapString(map, this.o27_1);
        return new TypedJsonDictionary(this.o27_1, type, map.s() ? null : new JsonDictionary(map));
    };
    protoOf(TypedDictionaryFromJson).p27 = function(type, customClaims) {
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.json.data.TypedDictionaryFromJson.toJson.<anonymous>' call
        if (!(customClaims == null)) this_0.o2(customClaims.xl());
        this_0.m2(this.o27_1, JsonPrimitive_0(type));
        var tmp$ret$2 = this_0.r8();
        return new JsonDictionary(tmp$ret$2);
    };
    function _get__serializable__azf9o3($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.t27_1;
        _serializable$factory();
        return this_0.b1();
    }
    function TypedJsonDictionary$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.json.data.TypedJsonDictionary._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.s27_1 == null)) this_0.o2(this$0.s27_1.xl());
            this_0.m2(this$0.q27_1, JsonPrimitive_0(this$0.r27_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function TypedJsonDictionary(typeKey, type, customClaims) {
        customClaims = customClaims === VOID ? null : customClaims;
        this.q27_1 = typeKey;
        this.r27_1 = type;
        this.s27_1 = customClaims;
        var tmp = this;
        tmp.t27_1 = lazy(TypedJsonDictionary$_serializable$delegate$lambda(this));
    }
    protoOf(TypedJsonDictionary).y26 = function() {
        return _get__serializable__azf9o3(this);
    };
    protoOf(TypedJsonDictionary).toString = function() {
        return "TypedJsonDictionary(typeKey=" + this.q27_1 + ", type=" + this.r27_1 + ", customClaims=" + toString_0(this.s27_1) + ")";
    };
    protoOf(TypedJsonDictionary).hashCode = function() {
        var result = getStringHashCode(this.q27_1);
        result = imul(result, 31) + getStringHashCode(this.r27_1) | 0;
        result = imul(result, 31) + (this.s27_1 == null ? 0 : this.s27_1.hashCode()) | 0;
        return result;
    };
    protoOf(TypedJsonDictionary).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof TypedJsonDictionary)) return false;
        var tmp0_other_with_cast = other instanceof TypedJsonDictionary ? other : THROW_CCE();
        if (!(this.q27_1 === tmp0_other_with_cast.q27_1)) return false;
        if (!(this.r27_1 === tmp0_other_with_cast.r27_1)) return false;
        if (!equals(this.s27_1, tmp0_other_with_cast.s27_1)) return false;
        return true;
    };
    function ToJson() {}
    function toJson_3(_this__u8e3s4) {
        var tmp = DefaultJsonMultiValue_init_$Create$_0(_this__u8e3s4.qm());
        return tmp.l27(toJson$lambda);
    }
    function toJson_4(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.json.data.toJson.<anonymous>' call
            var tmp$ret$0 = toJson_0(item);
            destination.e(tmp$ret$0);
        }
        return new JsonArray(destination);
    }
    function toJsons(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.json.data.toJsons.<anonymous>' call
            var tmp$ret$0 = item.a27();
            destination.e(tmp$ret$0);
        }
        return new JsonArray(destination);
    }
    function toJson_5(_this__u8e3s4) {
        return JsonPrimitive_2(_this__u8e3s4);
    }
    function Companion_1() {}
    protoOf(Companion_1).d27 = function(json) {
        return new AnyString(FromJsonHelper_instance.c27(json, "AnyString").toString());
    };
    var Companion_instance_2;
    function Companion_getInstance_2() {
        return Companion_instance_2;
    }
    function AnyString(value) {
        this.u27_1 = value;
    }
    protoOf(AnyString).a27 = function() {
        return JsonPrimitive_0(this.u27_1);
    };
    protoOf(AnyString).toString = function() {
        return this.u27_1;
    };
    protoOf(AnyString).hashCode = function() {
        return getStringHashCode(this.u27_1);
    };
    protoOf(AnyString).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof AnyString)) return false;
        var tmp0_other_with_cast = other instanceof AnyString ? other : THROW_CCE();
        if (!(this.u27_1 === tmp0_other_with_cast.u27_1)) return false;
        return true;
    };
    function toJson$lambda(it) {
        return it.a27();
    }
    function _serializable$factory() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3(receiver);
        }, null);
    }
    function unwrapOptionalString(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonPrimitive) {
            var tmp_0;
            if (value.d1b()) tmp_0 = value.e1b();
            else throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + value.toString());
            tmp = tmp_0;
        } else throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
        return tmp;
    }
    function unwrapString(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value instanceof JsonPrimitive) tmp = value.d1b();
        else tmp = false;
        if (tmp) return value.e1b();
        throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
    }
    function unwrapOptionalJsonDictionary(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonObject) tmp = Companion_instance_0.d27(value);
        else throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
        return tmp;
    }
    function unwrapOptionalStringList(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonArray) {
            var tmp_0 = asSequence(value);
            tmp = toList_0(map(tmp_0, unwrapOptionalStringList$lambda));
        } else throwDeserializationError("Expected array but was " + toString_0(value));
        return tmp;
    }
    function unwrapOptionalMultiValueString(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else {
            if (value instanceof JsonPrimitive) {
                var tmp_0;
                if (value.d1b()) tmp_0 = DefaultJsonMultiValue_init_$Create$(value.e1b());
                else throwDeserializationError('Expected value of "' + key + '" to contain string or string[], but was ' + value.toString());
                tmp = tmp_0;
            } else if (value instanceof JsonArray) {
                // Inline function 'kotlin.collections.mapIndexed' call
                // Inline function 'kotlin.collections.mapIndexedTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
                var index = 0;
                var tmp0_iterator = value.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'io.curity.ssi.json.data.unwrapOptionalMultiValueString.<anonymous>' call
                    var tmp1 = index;
                    index = tmp1 + 1 | 0;
                    var index_0 = checkIndexOverflow(tmp1);
                    var tmp_1;
                    var tmp_2;
                    if (item instanceof JsonPrimitive) tmp_2 = item.d1b();
                    else tmp_2 = false;
                    if (tmp_2) tmp_1 = item.e1b();
                    else throwDeserializationError('Expected value of "' + key + '" to contain only objects but at [' + index_0 + "] was " + value.toString());
                    var tmp$ret$0 = tmp_1;
                    destination.e(tmp$ret$0);
                }
                tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
            } else throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
        }
        return tmp;
    }
    function unwrapOptionalLong(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonPrimitive) {
            var tmp0_elvis_lhs = get_longOrNull(value);
            var tmp_0;
            if (tmp0_elvis_lhs == null) throwDeserializationError('Expected value of "' + key + '" to be a Number but was ' + value.toString());
            else tmp_0 = tmp0_elvis_lhs;
            tmp = tmp_0;
        } else throwDeserializationError('Expected value of "' + key + '" to be a Number but was ' + toString_0(value));
        return tmp;
    }
    function unwrapJsonDictionary(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonObject) tmp = Companion_instance_0.d27(value);
        else throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
        return tmp;
    }
    function unwrapStringSet(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        if (value instanceof JsonArray) {
            var tmp = asSequence(value);
            return toSet(map(tmp, unwrapStringSet$lambda));
        }
        throwDeserializationError('Expected value of "' + key + '" to be an array but was ' + toString_0(value));
    }
    function unwrapStringList(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        if (value instanceof JsonArray) {
            var tmp = asSequence(value);
            return toList_0(map(tmp, unwrapStringList$lambda));
        }
        throwDeserializationError('Expected value of "' + key + '" to be an array but was ' + toString_0(value));
    }
    function unwrapMultiValueJsonDictionary(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value instanceof JsonObject) tmp = DefaultJsonMultiValue_init_$Create$(Companion_instance_0.d27(value));
        else if (value instanceof JsonArray) {
            // Inline function 'kotlin.collections.mapIndexed' call
            // Inline function 'kotlin.collections.mapIndexedTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
            var index = 0;
            var tmp0_iterator = value.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.json.data.unwrapMultiValueJsonDictionary.<anonymous>' call
                var tmp1 = index;
                index = tmp1 + 1 | 0;
                var index_0 = checkIndexOverflow(tmp1);
                var tmp_0;
                if (item instanceof JsonObject) tmp_0 = Companion_instance_0.d27(item);
                else throwDeserializationError('Expected value of "' + key + '" to contain only objects but at [' + index_0 + "] was " + value.toString());
                var tmp$ret$0 = tmp_0;
                destination.e(tmp$ret$0);
            }
            tmp = DefaultJsonMultiValue_init_$Create$_0(destination);
        } else throwDeserializationError('Expected value of "' + key + '" to be an object but was ' + toString_0(value));
        return tmp;
    }
    function unwrapOptionalBoolean(_this__u8e3s4, key) {
        var value = _this__u8e3s4.n2(key);
        var tmp;
        if (value == null || equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonPrimitive) {
            var tmp0_elvis_lhs = get_booleanOrNull(value);
            var tmp_0;
            if (tmp0_elvis_lhs == null) throwDeserializationError('Expected value of "' + key + '" to be a Boolean but was ' + value.toString());
            else tmp_0 = tmp0_elvis_lhs;
            tmp = tmp_0;
        } else throwDeserializationError('Expected value of "' + key + '" to be a String but was ' + toString_0(value));
        return tmp;
    }
    function throwDeserializationError(message) {
        throw IllegalArgumentException_init_$Create$(message);
    }
    function unwrapOptionalStringInstant(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = unwrapOptionalString(_this__u8e3s4, key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var string = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_getInstance().a1m(string);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof Exception) {
                var e = $p;
                throwDeserializationError('Expected value of "' + key + '" to be a String Instant but it could not be parsed: ' + e.toString());
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalStringList$lambda(it) {
        var tmp;
        var tmp_0;
        if (it instanceof JsonPrimitive) tmp_0 = it.d1b();
        else tmp_0 = false;
        if (tmp_0) tmp = it.e1b();
        else throwDeserializationError("Expected array item to be a String but was " + toString(it));
        return tmp;
    }
    function unwrapStringSet$lambda(it) {
        var tmp;
        var tmp_0;
        if (it instanceof JsonPrimitive) tmp_0 = it.d1b();
        else tmp_0 = false;
        if (tmp_0) tmp = it.e1b();
        else throwDeserializationError("Expected array item to be a String but was " + toString(it));
        return tmp;
    }
    function unwrapStringList$lambda(it) {
        var tmp;
        var tmp_0;
        if (it instanceof JsonPrimitive) tmp_0 = it.d1b();
        else tmp_0 = false;
        if (tmp_0) tmp = it.e1b();
        else throwDeserializationError("Expected array item to be a String but was " + toString(it));
        return tmp;
    }
    function JsonSerializer(_fromJson) {
        this.v27_1 = _fromJson;
        this.w27_1 = Companion_instance.b1b();
        this.x27_1 = this.w27_1.yn();
    }
    protoOf(JsonSerializer).yn = function() {
        return this.x27_1;
    };
    protoOf(JsonSerializer).y27 = function(encoder, value) {
        encoder.ct(this.w27_1, value.a27());
    };
    protoOf(JsonSerializer).zn = function(encoder, value) {
        return this.y27(encoder, (!(value == null) ? isInterface(value, ToJson) : false) ? value : THROW_CCE());
    };
    protoOf(JsonSerializer).ao = function(decoder) {
        return this.v27_1.d27(decoder.kr(this.w27_1));
    };
    function ToJsonDictionarySerializer$_init_$lambda_aby31c(toJson) {
        return toJson.y26();
    }
    function ToJsonDictionarySerializer() {
        ToJsonDictionarySerializer_instance = this;
        var tmp = JsonDictionarySerializer_getInstance();
        DelegateSerializer.call(this, tmp, ToJsonDictionarySerializer$_init_$lambda_aby31c);
    }
    var ToJsonDictionarySerializer_instance;
    function ToJsonDictionarySerializer_getInstance() {
        if (ToJsonDictionarySerializer_instance == null) new ToJsonDictionarySerializer();
        return ToJsonDictionarySerializer_instance;
    }
    function DerivedSerializer(_delegate, toSerializable, fromSerializable) {
        this.z27_1 = _delegate;
        this.a28_1 = toSerializable;
        this.b28_1 = fromSerializable;
        this.c28_1 = this.z27_1.yn();
    }
    protoOf(DerivedSerializer).yn = function() {
        return this.c28_1;
    };
    protoOf(DerivedSerializer).d28 = function(encoder, value) {
        return encoder.ct(this.z27_1, this.a28_1(value));
    };
    protoOf(DerivedSerializer).zn = function(encoder, value) {
        return this.d28(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
    };
    protoOf(DerivedSerializer).ao = function(decoder) {
        return this.b28_1(decoder.kr(this.z27_1));
    };
    function getStringOrDefault(_this__u8e3s4, key, defaultValue) {
        defaultValue = defaultValue === VOID ? "" : defaultValue;
        var value = _this__u8e3s4.vl(key);
        var tmp;
        var tmp_0;
        if (value instanceof JsonPrimitive) tmp_0 = value.d1b();
        else tmp_0 = false;
        if (tmp_0) tmp = value.e1b();
        else tmp = defaultValue;
        return tmp;
    }
    function identity$ref() {
        var l = function(p0) {
            return identity(p0);
        };
        l.callableName = "identity";
        return l;
    }
    function DelegateSerializer(delegate, converter) {
        DerivedSerializer.call(this, delegate, converter, identity$ref());
    }
    function JsonDictionarySerializer() {
        JsonDictionarySerializer_instance = this;
        this.e28_1 = MapSerializer(serializer(StringCompanionObject_instance), Companion_instance.b1b());
        this.f28_1 = this.e28_1.yn();
    }
    protoOf(JsonDictionarySerializer).yn = function() {
        return this.f28_1;
    };
    protoOf(JsonDictionarySerializer).g28 = function(encoder, value) {
        encoder.ct(this.e28_1, value.xl());
    };
    protoOf(JsonDictionarySerializer).zn = function(encoder, value) {
        return this.g28(encoder, value instanceof JsonDictionary ? value : THROW_CCE());
    };
    protoOf(JsonDictionarySerializer).ao = function(decoder) {
        var map = decoder.kr(this.e28_1);
        return new JsonDictionary(map);
    };
    var JsonDictionarySerializer_instance;
    function JsonDictionarySerializer_getInstance() {
        if (JsonDictionarySerializer_instance == null) new JsonDictionarySerializer();
        return JsonDictionarySerializer_instance;
    }
    function DefaultJsonMultiValueSerializer$serialize$lambda(it) {
        var tmp;
        if (it instanceof JsonElement) tmp = it;
        else if (!(it == null) ? isInterface(it, ToJson) : false) tmp = it.a27();
        else {
            // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
            var this_0 = Default_getInstance();
            // Inline function 'kotlinx.serialization.serializer' call
            var this_1 = this_0.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_2 = serializer_0(this_1, createKType(PrimitiveClasses_getInstance().wa(), arrayOf([]), true));
            var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
            tmp = this_0.a19(tmp$ret$1, it);
        }
        return tmp;
    }
    function DefaultJsonMultiValueSerializer() {
        DefaultJsonMultiValueSerializer_instance = this;
        this.h28_1 = Companion_instance.b1b();
        this.i28_1 = this.h28_1.yn();
    }
    protoOf(DefaultJsonMultiValueSerializer).yn = function() {
        return this.i28_1;
    };
    protoOf(DefaultJsonMultiValueSerializer).j28 = function(encoder, value) {
        encoder.ct(this.h28_1, value.l27(DefaultJsonMultiValueSerializer$serialize$lambda));
    };
    protoOf(DefaultJsonMultiValueSerializer).zn = function(encoder, value) {
        return this.j28(encoder, value instanceof DefaultJsonMultiValue ? value : THROW_CCE());
    };
    protoOf(DefaultJsonMultiValueSerializer).ao = function(decoder) {
        var result = this.h28_1.ao(decoder);
        if (result instanceof JsonArray) return DefaultJsonMultiValue_init_$Create$_0(toList(result));
        return DefaultJsonMultiValue_init_$Create$(result);
    };
    var DefaultJsonMultiValueSerializer_instance;
    function DefaultJsonMultiValueSerializer_getInstance() {
        if (DefaultJsonMultiValueSerializer_instance == null) new DefaultJsonMultiValueSerializer();
        return DefaultJsonMultiValueSerializer_instance;
    }
    function identity(t) {
        return t;
    }
    function AnyStringSerializer() {
        AnyStringSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_2);
    }
    var AnyStringSerializer_instance;
    function AnyStringSerializer_getInstance() {
        if (AnyStringSerializer_instance == null) new AnyStringSerializer();
        return AnyStringSerializer_instance;
    }
    function JsToJsonConverter() {}
    protoOf(JsToJsonConverter).k28 = function(value) {
        if (value == null) return JsonNull_getInstance();
        var tmp;
        if (!(value == null) ? typeof value === "string" : false) tmp = JsonPrimitive_0(value);
        else {
            if (!(value == null) ? typeof value === "boolean" : false) tmp = JsonPrimitive_2(value);
            else if (isNumber(value)) tmp = JsonPrimitive_1(value);
            else {
                var tmp_0;
                if (Array.isArray(value)) {
                    var jsArray = value;
                    var result = ArrayList_init_$Create$_0();
                    var _iterator__ex2g4s = iterator(jsArray);
                    while(_iterator__ex2g4s.k()){
                        var item = _iterator__ex2g4s.l();
                        result.e(this.k28(item));
                    }
                    return new JsonArray(result);
                } else if (typeof value === "object") // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0 = this.l28(value);
                else throw IllegalArgumentException_init_$Create$("Cannot convert JS Value to JsonElement: " + toString_0(value));
                tmp = tmp_0;
            }
        }
        return tmp;
    };
    protoOf(JsToJsonConverter).l28 = function(jsObject) {
        var keys = Object.keys(jsObject);
        // Inline function 'kotlin.collections.mutableMapOf' call
        var result = LinkedHashMap_init_$Create$();
        var _iterator__ex2g4s = iterator(keys);
        while(_iterator__ex2g4s.k()){
            var key = _iterator__ex2g4s.l();
            if (typeof key === "string") {
                // Inline function 'kotlin.collections.set' call
                var value = this.k28(jsObject[key]);
                result.m2(key, value);
            } else throw IllegalArgumentException_init_$Create$("Cannot convert JS object to JsonElement: non-string key: '" + toString(key) + "'");
        }
        return new JsonObject(result);
    };
    var JsToJsonConverter_instance;
    function JsToJsonConverter_getInstance() {
        return JsToJsonConverter_instance;
    }
    function JsonToJsConverter() {}
    protoOf(JsonToJsConverter).m28 = function(value) {
        var tmp;
        if (equals(value, JsonNull_getInstance())) tmp = null;
        else if (value instanceof JsonObject) {
            var result = {};
            var _iterator__ex2g4s = value.z().j();
            while(_iterator__ex2g4s.k()){
                var _destruct__k2r9zo = _iterator__ex2g4s.l();
                // Inline function 'kotlin.collections.component1' call
                var name = _destruct__k2r9zo.a1();
                // Inline function 'kotlin.collections.component2' call
                var item = _destruct__k2r9zo.b1();
                result[name] = this.m28(item);
            }
            return result;
        } else {
            if (value instanceof JsonArray) {
                var result_0 = [];
                var _iterator__ex2g4s_0 = value.j();
                while(_iterator__ex2g4s_0.k()){
                    var item_0 = _iterator__ex2g4s_0.l();
                    result_0.push(this.m28(item_0));
                }
                return result_0;
            } else if (value instanceof JsonPrimitive) {
                var tmp_0;
                if (value.d1b()) tmp_0 = value.e1b();
                else {
                    var tmp0_elvis_lhs = get_booleanOrNull(value);
                    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_intOrNull(value) : tmp0_elvis_lhs;
                    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_floatOrNull(value) : tmp1_elvis_lhs;
                    tmp_0 = tmp2_elvis_lhs == null ? get_doubleOrNull(value) : tmp2_elvis_lhs;
                }
                tmp = tmp_0;
            } else noWhenBranchMatchedException();
        }
        return tmp;
    };
    protoOf(JsonToJsConverter).n28 = function(map) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return this.m28(new JsonObject(map));
    };
    var JsonToJsConverter_instance;
    function JsonToJsConverter_getInstance() {
        return JsonToJsConverter_instance;
    }
    //region block: post-declaration
    protoOf(JsonDictionary).a27 = toJson;
    protoOf(DefaultJsonMultiValue).qm = get_all;
    protoOf(DefaultJsonMultiValue).sm = isSingleItem;
    protoOf(DefaultJsonMultiValue).rm = forEach;
    protoOf(TypedJsonDictionary).f2 = get_keys;
    protoOf(TypedJsonDictionary).vl = get;
    protoOf(TypedJsonDictionary).a27 = toJson;
    protoOf(TypedJsonDictionary).xl = toMap_0;
    //endregion
    //region block: init
    FromJsonHelper_instance = new FromJsonHelper();
    Companion_instance_0 = new Companion();
    Companion_instance_1 = new Companion_0();
    Companion_instance_2 = new Companion_1();
    JsToJsonConverter_instance = new JsToJsonConverter();
    JsonToJsConverter_instance = new JsonToJsConverter();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = DefaultJsonMultiValue_init_$Create$_0;
    _.$_$.b = DefaultJsonMultiValue_init_$Create$;
    _.$_$.c = JsToJsonConverter_instance;
    _.$_$.d = JsonToJsConverter_instance;
    _.$_$.e = Companion_instance_1;
    _.$_$.f = DefaultJsonMultiValueSerializer_getInstance;
    _.$_$.g = FromJsonHelper_instance;
    _.$_$.h = Companion_instance_0;
    _.$_$.i = ToJsonDictionarySerializer_getInstance;
    _.$_$.j = AnyString;
    _.$_$.k = CompositeFromJson;
    _.$_$.l = DefaultJsonMultiValue;
    _.$_$.m = DelegateSerializer;
    _.$_$.n = DerivedSerializer;
    _.$_$.o = JsonDictionary;
    _.$_$.p = JsonSerializer;
    _.$_$.q = get;
    _.$_$.r = get_keys;
    _.$_$.s = toJson;
    _.$_$.t = ToJsonDictionary;
    _.$_$.u = ToJson;
    _.$_$.v = TypedDictionaryFromJson;
    _.$_$.w = getStringOrDefault;
    _.$_$.x = toJsons;
    _.$_$.y = toJson_4;
    _.$_$.z = toJson_1;
    _.$_$.a1 = toJson_2;
    _.$_$.b1 = toJson_3;
    _.$_$.c1 = toJson_0;
    _.$_$.d1 = toJson_5;
    _.$_$.e1 = unwrapJsonDictionary;
    _.$_$.f1 = unwrapMultiValueJsonDictionary;
    _.$_$.g1 = unwrapOptionalBoolean;
    _.$_$.h1 = unwrapOptionalJsonDictionary;
    _.$_$.i1 = unwrapOptionalLong;
    _.$_$.j1 = unwrapOptionalMultiValueString;
    _.$_$.k1 = unwrapOptionalStringInstant;
    _.$_$.l1 = unwrapOptionalStringList;
    _.$_$.m1 = unwrapOptionalString;
    _.$_$.n1 = unwrapStringList;
    _.$_$.o1 = unwrapStringSet;
    _.$_$.p1 = unwrapString;
    //endregion
    return _;
});

});
parcelRegister("iuiRe", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var contains = kotlin_kotlin.$_$.jc;
    var charSequenceSubSequence = kotlin_kotlin.$_$.y9;
    var equals = kotlin_kotlin.$_$.ba;
    var protoOf = kotlin_kotlin.$_$.kb;
    var equals_0 = kotlin_kotlin.$_$.pc;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var toSet = kotlin_kotlin.$_$.r8;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var KtMap = kotlin_kotlin.$_$.r5;
    var VOID = kotlin_kotlin.$_$.f;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var SequenceScope = kotlin_kotlin.$_$.cc;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var iterator = kotlin_kotlin.$_$.dc;
    var Iterable = kotlin_kotlin.$_$.m5;
    var Entry = kotlin_kotlin.$_$.q5;
    var listOf = kotlin_kotlin.$_$.n7;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var captureStack = kotlin_kotlin.$_$.t9;
    var Exception = kotlin_kotlin.$_$.ke;
    var joinToString = kotlin_kotlin.$_$.g7;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.m1;
    var toList = kotlin_kotlin.$_$.k8;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(Locale, "Locale");
    initMetadataForClass(Dictionary$toMap$1, VOID, VOID, VOID, [
        KtMap
    ]);
    function toMap() {
        return new Dictionary$toMap$1(this);
    }
    initMetadataForInterface(Dictionary, "Dictionary");
    initMetadataForLambda(MultiValue$_get_all_$o$iterator$slambda_sxfdxj, CoroutineImpl, VOID, [
        1
    ]);
    function get_all() {
        return new MultiValue$all$1(this);
    }
    function isSingleItem() {
        return this.lm().s();
    }
    function forEach(action) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this.qm().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            action(element);
        }
    }
    initMetadataForInterface(MultiValue, "MultiValue");
    initMetadataForClass(DefaultMultiValue, "DefaultMultiValue", VOID, VOID, [
        MultiValue
    ]);
    initMetadataForClass(MultiValue$all$1, VOID, VOID, VOID, [
        Iterable
    ]);
    initMetadataForClass(MapDictionary, "MapDictionary", VOID, VOID, [
        Dictionary
    ]);
    initMetadataForInterface(ToString, "ToString");
    initMetadataForClass(Entry_0, "Entry", VOID, VOID, [
        Entry
    ]);
    initMetadataForClass(Valid, "Valid");
    initMetadataForClass(Invalid, "Invalid");
    initMetadataForCompanion(Companion);
    initMetadataForClass(ValidationException, "ValidationException", VOID, Exception);
    initMetadataForCoroutine($runCOROUTINE$0, CoroutineImpl);
    initMetadataForCompanion(Companion_0, VOID, VOID, [
        1
    ]);
    initMetadataForClass(ValidationScope, "ValidationScope", ValidationScope);
    //endregion
    function Locale(value) {
        this.pl_1 = value;
        this.ql_1 = this.pl_1.length === 2 && !contains(this.pl_1, "-");
        this.rl_1 = charSequenceSubSequence(this.pl_1, 0, 2);
    }
    protoOf(Locale).sl = function(other) {
        return equals(this.rl_1, other == null ? null : charSequenceSubSequence(other, 0, 2));
    };
    protoOf(Locale).equals = function(other) {
        var tmp;
        if (other instanceof Locale) tmp = equals_0(other.pl_1, this.pl_1, true);
        else tmp = false;
        return tmp;
    };
    protoOf(Locale).hashCode = function() {
        return getStringHashCode(this.pl_1);
    };
    protoOf(Locale).toString = function() {
        return this.pl_1;
    };
    function Dictionary$toMap$1(this$0) {
        this.ul_1 = this$0;
        this.tl_1 = this$0.f2();
    }
    protoOf(Dictionary$toMap$1).z = function() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.tl_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.data.<no name provided>.<get-entries>.<anonymous>' call
            var tmp$ret$0 = new Entry_0(item, ensureNotNull(this.vl(item)));
            destination.e(tmp$ret$0);
        }
        return toSet(destination);
    };
    protoOf(Dictionary$toMap$1).f2 = function() {
        return this.tl_1;
    };
    protoOf(Dictionary$toMap$1).m = function() {
        return this.tl_1.m();
    };
    protoOf(Dictionary$toMap$1).g2 = function() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.tl_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.data.<no name provided>.<get-values>.<anonymous>' call
            var tmp$ret$0 = ensureNotNull(this.vl(item));
            destination.e(tmp$ret$0);
        }
        return destination;
    };
    protoOf(Dictionary$toMap$1).s = function() {
        return this.tl_1.s();
    };
    protoOf(Dictionary$toMap$1).vl = function(key) {
        return this.ul_1.vl(key);
    };
    protoOf(Dictionary$toMap$1).e2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return null;
        return this.vl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(Dictionary$toMap$1).wl = function(key) {
        return this.tl_1.a2(key);
    };
    protoOf(Dictionary$toMap$1).c2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return false;
        return this.wl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    function Dictionary() {}
    function MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this$0, this$1, resultContinuation) {
        this.gm_1 = this$0;
        this.hm_1 = this$1;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).jm = function($this$iterator, $completion) {
        var tmp = this.km($this$iterator, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).y9 = function(p1, $completion) {
        return this.jm(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
    };
    protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (this.gm_1.nm_1) {
                        this.v8_1 = 3;
                        suspendResult = this.im_1.cf(this.hm_1.mm(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        suspendResult = this.im_1.ef(this.hm_1.lm(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 2:
                    this.v8_1 = 6;
                    continue $sm;
                case 3:
                    this.gm_1.nm_1 = false;
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.v8_1 = 1;
                    continue $sm;
                case 5:
                    throw this.y8_1;
                case 6:
                    return Unit_instance;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(MultiValue$_get_all_$o$iterator$slambda_sxfdxj).km = function($this$iterator, completion) {
        var i = new MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this.gm_1, this.hm_1, completion);
        i.im_1 = $this$iterator;
        return i;
    };
    function MultiValue$_get_all_$o$iterator$slambda_sxfdxj_0(this$0, this$1, resultContinuation) {
        var i = new MultiValue$_get_all_$o$iterator$slambda_sxfdxj(this$0, this$1, resultContinuation);
        var l = function($this$iterator, $completion) {
            return i.jm($this$iterator, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function DefaultMultiValue(elements) {
        this.pm_1 = elements;
    }
    protoOf(DefaultMultiValue).mm = function() {
        return this.pm_1.o(0);
    };
    protoOf(DefaultMultiValue).lm = function() {
        return this.pm_1.v(1, this.pm_1.m());
    };
    protoOf(DefaultMultiValue).qm = function() {
        return this.pm_1;
    };
    function MultiValue$all$1(this$0) {
        this.om_1 = this$0;
        this.nm_1 = true;
    }
    protoOf(MultiValue$all$1).j = function() {
        return iterator(MultiValue$_get_all_$o$iterator$slambda_sxfdxj_0(this, this.om_1, null));
    };
    function MultiValue() {}
    function MapDictionary(map) {
        this.tm_1 = map;
    }
    protoOf(MapDictionary).f2 = function() {
        return this.tm_1.f2();
    };
    protoOf(MapDictionary).vl = function(key) {
        return this.tm_1.e2(key);
    };
    protoOf(MapDictionary).xl = function() {
        return this.tm_1;
    };
    function ToString() {}
    function Entry_0(key, value) {
        this.um_1 = key;
        this.vm_1 = value;
    }
    protoOf(Entry_0).a1 = function() {
        return this.um_1;
    };
    protoOf(Entry_0).b1 = function() {
        return this.vm_1;
    };
    function Valid(value) {
        this.wm_1 = value;
    }
    protoOf(Valid).xm = function() {
        return this.wm_1;
    };
    function Invalid(errors) {
        this.ym_1 = errors;
    }
    protoOf(Invalid).xm = function() {
        throw new ValidationException(this.ym_1);
    };
    function Companion() {}
    protoOf(Companion).zm = function(error) {
        return new Invalid(listOf(error));
    };
    protoOf(Companion).an = function(value) {
        return new Valid(value);
    };
    var Companion_instance;
    function Companion_getInstance() {
        return Companion_instance;
    }
    function ValidationException_init_$Init$(error, $this) {
        ValidationException.call($this, listOf(error));
        return $this;
    }
    function ValidationException_init_$Create$(error) {
        var tmp = ValidationException_init_$Init$(error, objectCreate(protoOf(ValidationException)));
        captureStack(tmp, ValidationException_init_$Create$);
        return tmp;
    }
    function ValidationException(errors) {
        Exception_init_$Init$("validation error: " + joinToString(errors, "\n"), this);
        captureStack(this, ValidationException);
        this.bn_1 = errors;
    }
    function suspendableValidationScope(block, $completion) {
        return Companion_instance_0.cn(block, $completion);
    }
    function $runCOROUTINE$0(_this__u8e3s4, block, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.ln_1 = _this__u8e3s4;
        this.mn_1 = block;
    }
    protoOf($runCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.nn_1 = new ValidationScope();
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.mn_1(this.nn_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.on_1 = suspendResult;
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof Exception) {
                        var ex = this.y8_1;
                        var tmp_1 = this;
                        var tmp0_elvis_lhs = ex.message;
                        this.nn_1.pn_1.e(tmp0_elvis_lhs == null ? "Unknown error" : tmp0_elvis_lhs);
                        return new Invalid(toList(this.nn_1.pn_1));
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    var res = this.on_1;
                    var tmp_2;
                    if (!this.nn_1.pn_1.s()) tmp_2 = new Invalid(toList(this.nn_1.pn_1));
                    else {
                        var tmp_3;
                        if (res == null) tmp_3 = Companion_instance.zm("Unknown error");
                        else tmp_3 = new Valid(res);
                        tmp_2 = tmp_3;
                    }
                    return tmp_2;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_0() {}
    protoOf(Companion_0).cn = function(block, $completion) {
        var tmp = new $runCOROUTINE$0(this, block, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_0;
    function Companion_getInstance_0() {
        return Companion_instance_0;
    }
    function ValidationScope() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.pn_1 = ArrayList_init_$Create$_0();
        this.qn_1 = this.pn_1.s();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0.rn_1 = !this.pn_1.s();
    }
    protoOf(ValidationScope).sn = function(msg, predicate) {
        if (!predicate()) this.pn_1.e(msg);
    };
    protoOf(ValidationScope).tn = function(msg, value, applyOnExisting) {
        if (value == null) this.pn_1.e(msg);
        else applyOnExisting(value);
    };
    protoOf(ValidationScope).un = function(name, value, block) {
        var tmp;
        if (value == null) {
            this.vn("Missing claim '" + name + "'");
            tmp = null;
        } else if (!(block == null)) tmp = block(this, value);
        else tmp = null;
        return tmp;
    };
    protoOf(ValidationScope).wn = function(value, block) {
        if (!(value == null)) block(value);
    };
    protoOf(ValidationScope).xn = function(msg, value, converter) {
        var tmp;
        try {
            tmp = converter(value);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Exception) {
                var e = $p;
                this.vn(msg(e));
                tmp_0 = null;
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(ValidationScope).vn = function(msg) {
        this.pn_1.e(msg);
    };
    //region block: post-declaration
    protoOf(DefaultMultiValue).rm = forEach;
    //endregion
    //region block: init
    Companion_instance = new Companion();
    Companion_instance_0 = new Companion_0();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = suspendableValidationScope;
    _.$_$.b = ValidationException_init_$Create$;
    _.$_$.c = Companion_instance;
    _.$_$.d = toMap;
    _.$_$.e = Dictionary;
    _.$_$.f = Locale;
    _.$_$.g = MapDictionary;
    _.$_$.h = DefaultMultiValue;
    _.$_$.i = get_all;
    _.$_$.j = forEach;
    _.$_$.k = isSingleItem;
    _.$_$.l = MultiValue;
    _.$_$.m = ToString;
    _.$_$.n = ValidationScope;
    //endregion
    return _;
});

});

parcelRegister("3WyZ3", function(module, exports) {



(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "@js-joda/core",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js"
    ], factory);
    else factory(module.exports, (parcelRequire("3Zanr")), (parcelRequire("9vyMc")), (parcelRequire("3kJd2")));
})(globalThis, function(_, $module$_js_joda_core_gcv2k, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core) {
    "use strict";
    //region block: imports
    var Instant = $module$_js_joda_core_gcv2k.Instant;
    var Clock = $module$_js_joda_core_gcv2k.Clock;
    var OffsetDateTime = $module$_js_joda_core_gcv2k.OffsetDateTime;
    var Duration = $module$_js_joda_core_gcv2k.Duration;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.q1;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var captureStack = kotlin_kotlin.$_$.t9;
    var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.p1;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
    var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var VOID = kotlin_kotlin.$_$.f;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var indexOf = kotlin_kotlin.$_$.tc;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var Long = kotlin_kotlin.$_$.ne;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var ArithmeticException = kotlin_kotlin.$_$.de;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var numberToLong = kotlin_kotlin.$_$.ib;
    var Companion_getInstance = kotlin_kotlin.$_$.z4;
    var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.h;
    var toDuration = kotlin_kotlin.$_$.ce;
    var DurationUnit_NANOSECONDS_getInstance = kotlin_kotlin.$_$.g;
    var Duration__plus_impl_yu9v8f = kotlin_kotlin.$_$.p2;
    var Comparable = kotlin_kotlin.$_$.fe;
    var ArithmeticException_init_$Create$ = kotlin_kotlin.$_$.i1;
    //endregion
    //region block: pre-declaration
    initMetadataForObject(System, "System");
    initMetadataForClass(DateTimeFormatException, "DateTimeFormatException", DateTimeFormatException_init_$Create$, IllegalArgumentException);
    initMetadataForObject(InstantIso8601Serializer, "InstantIso8601Serializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForClass(Instant_0, "Instant", VOID, VOID, [
        Comparable
    ], VOID, VOID, {
        0: InstantIso8601Serializer_getInstance
    });
    //endregion
    function System() {}
    protoOf(System).u1l = function() {
        return Companion_getInstance_0().u1l();
    };
    var System_instance;
    function System_getInstance() {
        return System_instance;
    }
    function DateTimeFormatException_init_$Init$($this) {
        IllegalArgumentException_init_$Init$($this);
        DateTimeFormatException.call($this);
        return $this;
    }
    function DateTimeFormatException_init_$Create$() {
        var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
        captureStack(tmp, DateTimeFormatException_init_$Create$);
        return tmp;
    }
    function DateTimeFormatException_init_$Init$_0(cause, $this) {
        IllegalArgumentException_init_$Init$_0(cause, $this);
        DateTimeFormatException.call($this);
        return $this;
    }
    function DateTimeFormatException_init_$Create$_0(cause) {
        var tmp = DateTimeFormatException_init_$Init$_0(cause, objectCreate(protoOf(DateTimeFormatException)));
        captureStack(tmp, DateTimeFormatException_init_$Create$_0);
        return tmp;
    }
    function DateTimeFormatException() {
        captureStack(this, DateTimeFormatException);
    }
    function InstantIso8601Serializer() {
        InstantIso8601Serializer_instance = this;
        this.z1l_1 = PrimitiveSerialDescriptor("Instant", STRING_getInstance());
    }
    protoOf(InstantIso8601Serializer).yn = function() {
        return this.z1l_1;
    };
    protoOf(InstantIso8601Serializer).ao = function(decoder) {
        return Companion_getInstance_0().a1m(decoder.gr());
    };
    protoOf(InstantIso8601Serializer).b1m = function(encoder, value) {
        encoder.os(value.toString());
    };
    protoOf(InstantIso8601Serializer).zn = function(encoder, value) {
        return this.b1m(encoder, value instanceof Instant_0 ? value : THROW_CCE());
    };
    var InstantIso8601Serializer_instance;
    function InstantIso8601Serializer_getInstance() {
        if (InstantIso8601Serializer_instance == null) new InstantIso8601Serializer();
        return InstantIso8601Serializer_instance;
    }
    function fixOffsetRepresentation($this, isoString) {
        var time = indexOf(isoString, _Char___init__impl__6a9atx(84), VOID, true);
        if (time === -1) return isoString;
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.indexOfLast' call
            var inductionVariable = charSequenceLength(isoString) - 1 | 0;
            if (0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                // Inline function 'kotlinx.datetime.Companion.fixOffsetRepresentation.<anonymous>' call
                var c = charSequenceGet(isoString, index);
                if (c === _Char___init__impl__6a9atx(43) || c === _Char___init__impl__6a9atx(45)) {
                    tmp$ret$1 = index;
                    break $l$block;
                }
            }while (0 <= inductionVariable);
            tmp$ret$1 = -1;
        }
        var offset = tmp$ret$1;
        if (offset < time) return isoString;
        var separator = indexOf(isoString, _Char___init__impl__6a9atx(58), offset);
        return !(separator === -1) ? isoString : isoString + ":00";
    }
    function Companion() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.Companion.DISTANT_PAST.<anonymous>' call
        var tmp$ret$1 = Instant.ofEpochSecond(new Long(-931914497, -750).p3(), 999999999);
        tmp.v1l_1 = new Instant_0(tmp$ret$1);
        var tmp_0 = this;
        // Inline function 'kotlinx.datetime.jsTry' call
        // Inline function 'kotlinx.datetime.Companion.DISTANT_FUTURE.<anonymous>' call
        var tmp$ret$3 = Instant.ofEpochSecond(new Long(1151527680, 720).p3(), 0);
        tmp_0.w1l_1 = new Instant_0(tmp$ret$3);
        this.x1l_1 = new Instant_0(Instant.MIN);
        this.y1l_1 = new Instant_0(Instant.MAX);
    }
    protoOf(Companion).u1l = function() {
        return new Instant_0(Clock.systemUTC().instant());
    };
    protoOf(Companion).a1m = function(isoString) {
        var tmp;
        try {
            // Inline function 'kotlinx.datetime.jsTry' call
            // Inline function 'kotlinx.datetime.Companion.parse.<anonymous>' call
            var tmp$ret$1 = OffsetDateTime.parse(fixOffsetRepresentation(Companion_getInstance_0(), isoString));
            tmp = new Instant_0(tmp$ret$1.toInstant());
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var e = $p;
                if (isJodaDateTimeParseException(e)) throw DateTimeFormatException_init_$Create$_0(e);
                throw e;
            } else throw $p;
        }
        return tmp;
    };
    protoOf(Companion).c1m = function(epochSeconds, nanosecondAdjustment) {
        var tmp;
        try {
            // Inline function 'kotlin.floorDiv' call
            var other = new Long(1000000000, 0);
            var q = nanosecondAdjustment.b3(other);
            if (nanosecondAdjustment.m3(other).j1(new Long(0, 0)) < 0 && !q.a3(other).equals(nanosecondAdjustment)) q = q.e3();
            var tmp$ret$0 = q;
            var secs = safeAdd(epochSeconds, tmp$ret$0);
            // Inline function 'kotlin.mod' call
            var other_0 = new Long(1000000000, 0);
            var r = nanosecondAdjustment.c3(other_0);
            var nos = r.y2(other_0.k3(r.m3(other_0).k3(r.l3(r.f3())).i3(63))).l1();
            // Inline function 'kotlinx.datetime.jsTry' call
            // Inline function 'kotlinx.datetime.Companion.fromEpochSeconds.<anonymous>' call
            var tmp$ret$3 = Instant.ofEpochSecond(secs.p3(), nos);
            tmp = new Instant_0(tmp$ret$3);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var e = $p;
                var tmp_1;
                if (!isJodaDateTimeException(e)) tmp_1 = !(e instanceof ArithmeticException);
                else tmp_1 = false;
                if (tmp_1) throw e;
                tmp_0 = epochSeconds.j1(new Long(0, 0)) > 0 ? this.y1l_1 : this.x1l_1;
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(Companion).d1m = function(epochSeconds, nanosecondAdjustment, $super) {
        nanosecondAdjustment = nanosecondAdjustment === VOID ? new Long(0, 0) : nanosecondAdjustment;
        return $super === VOID ? this.c1m(epochSeconds, nanosecondAdjustment) : $super.c1m.call(this, epochSeconds, nanosecondAdjustment);
    };
    protoOf(Companion).b1b = function() {
        return InstantIso8601Serializer_getInstance();
    };
    var Companion_instance;
    function Companion_getInstance_0() {
        if (Companion_instance == null) new Companion();
        return Companion_instance;
    }
    function Instant_0(value) {
        Companion_getInstance_0();
        this.e1m_1 = value;
    }
    protoOf(Instant_0).f1m = function() {
        return numberToLong(this.e1m_1.epochSecond());
    };
    protoOf(Instant_0).g1m = function(other) {
        var diff = Duration.between(other.e1m_1, this.e1m_1);
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        var this_0 = diff.seconds();
        var tmp = toDuration(this_0, DurationUnit_SECONDS_getInstance());
        // Inline function 'kotlin.time.Companion.nanoseconds' call
        Companion_getInstance();
        var this_1 = diff.nano();
        var tmp$ret$1 = toDuration(this_1, DurationUnit_NANOSECONDS_getInstance());
        return Duration__plus_impl_yu9v8f(tmp, tmp$ret$1);
    };
    protoOf(Instant_0).h1m = function(other) {
        return this.e1m_1.compareTo(other.e1m_1);
    };
    protoOf(Instant_0).d = function(other) {
        return this.h1m(other instanceof Instant_0 ? other : THROW_CCE());
    };
    protoOf(Instant_0).equals = function(other) {
        var tmp;
        if (this === other) tmp = true;
        else {
            var tmp_0;
            if (other instanceof Instant_0) tmp_0 = this.e1m_1 === other.e1m_1 || this.e1m_1.equals(other.e1m_1);
            else tmp_0 = false;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(Instant_0).hashCode = function() {
        return this.e1m_1.hashCode();
    };
    protoOf(Instant_0).toString = function() {
        return this.e1m_1.toString();
    };
    function isJodaDateTimeException(_this__u8e3s4) {
        return hasJsExceptionName(_this__u8e3s4, "DateTimeException");
    }
    function isJodaDateTimeParseException(_this__u8e3s4) {
        return hasJsExceptionName(_this__u8e3s4, "DateTimeParseException");
    }
    function safeAdd(a, b) {
        var sum = a.y2(b);
        if (a.m3(sum).j1(new Long(0, 0)) < 0 && a.m3(b).j1(new Long(0, 0)) >= 0) throw ArithmeticException_init_$Create$("Addition overflows a long: " + a.toString() + " + " + b.toString());
        return sum;
    }
    function hasJsExceptionName(_this__u8e3s4, name) {
        // Inline function 'kotlin.js.asDynamic' call
        return _this__u8e3s4.name == name;
    }
    //region block: init
    System_instance = new System();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = InstantIso8601Serializer_getInstance;
    _.$_$.b = System_instance;
    _.$_$.c = Companion_getInstance_0;
    //endregion
    return _;
});

});
parcelRegister("3Zanr", function(module, exports) {

$parcel$export(module.exports, "DateTimeException", () => $2e6f1e48aadbcba7$export$6058f27c7f907fb);
$parcel$export(module.exports, "DateTimeParseException", () => $2e6f1e48aadbcba7$export$ce8a206818942248);
$parcel$export(module.exports, "UnsupportedTemporalTypeException", () => $2e6f1e48aadbcba7$export$8fe6dec993229f58);
$parcel$export(module.exports, "ArithmeticException", () => $2e6f1e48aadbcba7$export$5891bcae38b5fd67);
$parcel$export(module.exports, "IllegalArgumentException", () => $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
$parcel$export(module.exports, "IllegalStateException", () => $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e);
$parcel$export(module.exports, "NullPointerException", () => $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
$parcel$export(module.exports, "TemporalAmount", () => $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
$parcel$export(module.exports, "TemporalUnit", () => $2e6f1e48aadbcba7$export$5d412a4bb789788e);
$parcel$export(module.exports, "Duration", () => $2e6f1e48aadbcba7$export$3b11bc38611c5941);
$parcel$export(module.exports, "LocalTime", () => $2e6f1e48aadbcba7$export$bf1071e344bea1d);
$parcel$export(module.exports, "ChronoUnit", () => $2e6f1e48aadbcba7$export$e61e212a4109fb8a);
$parcel$export(module.exports, "ChronoField", () => $2e6f1e48aadbcba7$export$7f55a40756153c3e);
$parcel$export(module.exports, "YearConstants", () => $2e6f1e48aadbcba7$export$c04b60057299af61);
$parcel$export(module.exports, "TemporalField", () => $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9);
$parcel$export(module.exports, "ValueRange", () => $2e6f1e48aadbcba7$export$177e5e64bab4dec5);
$parcel$export(module.exports, "TemporalQueries", () => $2e6f1e48aadbcba7$export$d6cc568434dfd9dc);
$parcel$export(module.exports, "TemporalAccessor", () => $2e6f1e48aadbcba7$export$e5100310ee9cc158);
$parcel$export(module.exports, "TemporalQuery", () => $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff);
$parcel$export(module.exports, "DayOfWeek", () => $2e6f1e48aadbcba7$export$7ed5ca4f8b987938);
$parcel$export(module.exports, "Month", () => $2e6f1e48aadbcba7$export$951c8378cdfec6e6);
$parcel$export(module.exports, "IsoChronology", () => $2e6f1e48aadbcba7$export$f47ae290cf4e4958);
$parcel$export(module.exports, "Period", () => $2e6f1e48aadbcba7$export$67186dcd8fa4f92f);
$parcel$export(module.exports, "LocalDate", () => $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6);
$parcel$export(module.exports, "ResolverStyle", () => $2e6f1e48aadbcba7$export$2a833e4d13229d66);
$parcel$export(module.exports, "TemporalAdjuster", () => $2e6f1e48aadbcba7$export$841f8bd48996924f);
$parcel$export(module.exports, "Temporal", () => $2e6f1e48aadbcba7$export$336849d529cb05e5);
$parcel$export(module.exports, "ChronoLocalDate", () => $2e6f1e48aadbcba7$export$2a07e3472bc98879);
$parcel$export(module.exports, "DateTimeFormatter", () => $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c);
$parcel$export(module.exports, "ZoneId", () => $2e6f1e48aadbcba7$export$a514a0be1f00ef62);
$parcel$export(module.exports, "Instant", () => $2e6f1e48aadbcba7$export$fecec53969739358);
$parcel$export(module.exports, "ZoneRules", () => $2e6f1e48aadbcba7$export$cbd9bcf3fad97817);
$parcel$export(module.exports, "ZoneOffset", () => $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3);
$parcel$export(module.exports, "IsoFields", () => $2e6f1e48aadbcba7$export$2091a0730eb3b2d2);
$parcel$export(module.exports, "DecimalStyle", () => $2e6f1e48aadbcba7$export$c1929c59b9e7d355);
$parcel$export(module.exports, "SignStyle", () => $2e6f1e48aadbcba7$export$b2e3a42c433c0b35);
$parcel$export(module.exports, "TextStyle", () => $2e6f1e48aadbcba7$export$1df879243bf2e42d);
$parcel$export(module.exports, "ZoneRulesProvider", () => $2e6f1e48aadbcba7$export$79d73e02cd645302);
$parcel$export(module.exports, "ZoneRegion", () => $2e6f1e48aadbcba7$export$9caa52e4e516e67d);
$parcel$export(module.exports, "DateTimeFormatterBuilder", () => $2e6f1e48aadbcba7$export$81529fd372517959);
$parcel$export(module.exports, "LocalDateTime", () => $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff);
$parcel$export(module.exports, "MonthDay", () => $2e6f1e48aadbcba7$export$30964d9b15071608);
$parcel$export(module.exports, "Clock", () => $2e6f1e48aadbcba7$export$9735c82c4bae3302);
$parcel$export(module.exports, "Year", () => $2e6f1e48aadbcba7$export$6ce2f08d515512);
$parcel$export(module.exports, "YearMonth", () => $2e6f1e48aadbcba7$export$b707805e12671f51);
$parcel$export(module.exports, "TemporalAdjusters", () => $2e6f1e48aadbcba7$export$d922854d56f8a965);
$parcel$export(module.exports, "OffsetTime", () => $2e6f1e48aadbcba7$export$a362394fcc906a80);
$parcel$export(module.exports, "OffsetDateTime", () => $2e6f1e48aadbcba7$export$f351e12f7a164fb5);
$parcel$export(module.exports, "ChronoZonedDateTime", () => $2e6f1e48aadbcba7$export$e69f60c5a83f5572);
$parcel$export(module.exports, "ZonedDateTime", () => $2e6f1e48aadbcba7$export$d3b7288e7994edea);
$parcel$export(module.exports, "ChronoLocalDateTime", () => $2e6f1e48aadbcba7$export$94e985176fb19d17);
$parcel$export(module.exports, "ZoneOffsetTransition", () => $2e6f1e48aadbcba7$export$993d982a5ca9c76d);
$parcel$export(module.exports, "convert", () => $2e6f1e48aadbcba7$export$9c68d69a4c5bbcf9);
$parcel$export(module.exports, "nativeJs", () => $2e6f1e48aadbcba7$export$1f878d3ea5c30765);
$parcel$export(module.exports, "_", () => $2e6f1e48aadbcba7$export$71511d61b312f219);
$parcel$export(module.exports, "use", () => $2e6f1e48aadbcba7$export$1f96ae73734a86cc);
//! @version @js-joda/core - 3.2.0
//! @copyright (c) 2015-present, Philipp Thürwächter, Pattrick Hüper & js-joda contributors
//! @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
//! @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$createErrorType(name1, init, superErrorClass) {
    if (superErrorClass === void 0) superErrorClass = Error;
    function JsJodaException(message) {
        if (!Error.captureStackTrace) this.stack = new Error().stack;
        else Error.captureStackTrace(this, this.constructor);
        this.message = message;
        init && init.apply(this, arguments);
        this.toString = function() {
            return this.name + ": " + this.message;
        };
    }
    JsJodaException.prototype = Object.create(superErrorClass.prototype);
    JsJodaException.prototype.name = name1;
    JsJodaException.prototype.constructor = JsJodaException;
    return JsJodaException;
}
var $2e6f1e48aadbcba7$export$6058f27c7f907fb = $2e6f1e48aadbcba7$var$createErrorType("DateTimeException", $2e6f1e48aadbcba7$var$messageWithCause);
var $2e6f1e48aadbcba7$export$ce8a206818942248 = $2e6f1e48aadbcba7$var$createErrorType("DateTimeParseException", $2e6f1e48aadbcba7$var$messageForDateTimeParseException);
var $2e6f1e48aadbcba7$export$8fe6dec993229f58 = $2e6f1e48aadbcba7$var$createErrorType("UnsupportedTemporalTypeException", null, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
var $2e6f1e48aadbcba7$export$5891bcae38b5fd67 = $2e6f1e48aadbcba7$var$createErrorType("ArithmeticException");
var $2e6f1e48aadbcba7$export$86eb44ed3377dd8f = $2e6f1e48aadbcba7$var$createErrorType("IllegalArgumentException");
var $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e = $2e6f1e48aadbcba7$var$createErrorType("IllegalStateException");
var $2e6f1e48aadbcba7$export$b6ad7a1de4697efd = $2e6f1e48aadbcba7$var$createErrorType("NullPointerException");
function $2e6f1e48aadbcba7$var$messageWithCause(message, cause) {
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
}
function $2e6f1e48aadbcba7$var$messageForDateTimeParseException(message, text, index, cause) {
    if (text === void 0) text = "";
    if (index === void 0) index = 0;
    if (cause === void 0) cause = null;
    var msg = message || this.name;
    msg += ": " + text + ", at index: " + index;
    if (cause !== null && cause instanceof Error) msg += "\n-------\nCaused by: " + cause.stack + "\n-------\n";
    this.message = msg;
    this.parsedString = function() {
        return text;
    };
    this.errorIndex = function() {
        return index;
    };
}
function $2e6f1e48aadbcba7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $2e6f1e48aadbcba7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$assert(assertion, msg, error) {
    if (!assertion) {
        if (error) throw new error(msg);
        else throw new Error(msg);
    }
}
function $2e6f1e48aadbcba7$var$requireNonNull(value, parameterName) {
    if (value == null) throw new $2e6f1e48aadbcba7$export$b6ad7a1de4697efd(parameterName + " must not be null");
    return value;
}
function $2e6f1e48aadbcba7$var$requireInstance(value, _class, parameterName) {
    if (!(value instanceof _class)) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f(parameterName + " must be an instance of " + (_class.name ? _class.name : _class) + (value && value.constructor && value.constructor.name ? ", but is " + value.constructor.name : ""));
    return value;
}
function $2e6f1e48aadbcba7$var$abstractMethodFail(methodName) {
    throw new TypeError('abstract method "' + methodName + '" is not implemented');
}
var $2e6f1e48aadbcba7$var$assert$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    assert: $2e6f1e48aadbcba7$var$assert,
    requireNonNull: $2e6f1e48aadbcba7$var$requireNonNull,
    requireInstance: $2e6f1e48aadbcba7$var$requireInstance,
    abstractMethodFail: $2e6f1e48aadbcba7$var$abstractMethodFail
});
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER = 9007199254740991;
var $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER = -9007199254740991;
var $2e6f1e48aadbcba7$var$MathUtil = function() {
    function MathUtil() {}
    MathUtil.intDiv = function intDiv(x, y) {
        var r = x / y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.intMod = function intMod(x, y) {
        var r = x - MathUtil.intDiv(x, y) * y;
        r = MathUtil.roundDown(r);
        return MathUtil.safeZero(r);
    };
    MathUtil.roundDown = function roundDown(r) {
        if (r < 0) return Math.ceil(r);
        else return Math.floor(r);
    };
    MathUtil.floorDiv = function floorDiv(x, y) {
        var r = Math.floor(x / y);
        return MathUtil.safeZero(r);
    };
    MathUtil.floorMod = function floorMod(x, y) {
        var r = x - MathUtil.floorDiv(x, y) * y;
        return MathUtil.safeZero(r);
    };
    MathUtil.safeAdd = function safeAdd(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0) return MathUtil.safeZero(y);
        if (y === 0) return MathUtil.safeZero(x);
        var r = MathUtil.safeToInt(x + y);
        if (r === x || r === y) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid addition beyond MAX_SAFE_INTEGER!");
        return r;
    };
    MathUtil.safeSubtract = function safeSubtract(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 0 && y === 0) return 0;
        else if (x === 0) return MathUtil.safeZero(-1 * y);
        else if (y === 0) return MathUtil.safeZero(x);
        return MathUtil.safeToInt(x - y);
    };
    MathUtil.safeMultiply = function safeMultiply(x, y) {
        MathUtil.verifyInt(x);
        MathUtil.verifyInt(y);
        if (x === 1) return MathUtil.safeZero(y);
        if (y === 1) return MathUtil.safeZero(x);
        if (x === 0 || y === 0) return 0;
        var r = MathUtil.safeToInt(x * y);
        if (r / y !== x || x === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER && y === -1 || y === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER && x === -1) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Multiplication overflows: " + x + " * " + y);
        return r;
    };
    MathUtil.parseInt = function(_parseInt) {
        function parseInt1(_x) {
            return _parseInt.apply(this, arguments);
        }
        parseInt1.toString = function() {
            return _parseInt.toString();
        };
        return parseInt1;
    }(function(value) {
        var r = parseInt(value);
        return MathUtil.safeToInt(r);
    });
    MathUtil.safeToInt = function safeToInt(value) {
        MathUtil.verifyInt(value);
        return MathUtil.safeZero(value);
    };
    MathUtil.verifyInt = function verifyInt(value) {
        if (value == null) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid value: '" + value + "', using null or undefined as argument");
        if (isNaN(value)) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid int value, using NaN as argument");
        if (value % 1 !== 0) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Invalid value: '" + value + "' is a float");
        if (value > $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER || value < $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Calculation overflows an int: " + value);
    };
    MathUtil.safeZero = function safeZero(value) {
        return value === 0 ? 0 : +value;
    };
    MathUtil.compareNumbers = function compareNumbers(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    };
    MathUtil.smi = function smi(int) {
        return int >>> 1 & 0x40000000 | int & 0xBFFFFFFF;
    };
    MathUtil.hash = function hash(number) {
        if (number !== number || number === Infinity) return 0;
        var result = number;
        while(number > 0xFFFFFFFF){
            number /= 0xFFFFFFFF;
            result ^= number;
        }
        return MathUtil.smi(result);
    };
    MathUtil.hashCode = function hashCode() {
        var result = 17;
        for(var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++)numbers[_key] = arguments[_key];
        for(var _i = 0, _numbers = numbers; _i < _numbers.length; _i++){
            var n = _numbers[_i];
            result = (result << 5) - result + MathUtil.hash(n);
        }
        return MathUtil.hash(result);
    };
    return MathUtil;
}();
$2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER = $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER;
$2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER = $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$Enum = function() {
    function Enum(name1) {
        this._name = name1;
    }
    var _proto = Enum.prototype;
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Enum;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff = function() {
    function TemporalAmount() {}
    var _proto = TemporalAmount.prototype;
    _proto.get = function get(unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("get");
    };
    _proto.units = function units() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("units");
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("addTo");
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("subtractFrom");
    };
    return TemporalAmount;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$5d412a4bb789788e = function() {
    function TemporalUnit() {}
    var _proto = TemporalUnit.prototype;
    _proto.duration = function duration() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("duration");
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isDurationEstimated");
    };
    _proto.isDateBased = function isDateBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isDateBased");
    };
    _proto.isTimeBased = function isTimeBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isTimeBased");
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isSupportedBy");
    };
    _proto.addTo = function addTo(dateTime, periodToAdd) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("addTo");
    };
    _proto.between = function between(temporal1, temporal2) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("between");
    };
    return TemporalUnit;
}();
var $2e6f1e48aadbcba7$export$3b11bc38611c5941 = function(_TemporalAmount) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Duration, _TemporalAmount);
    function Duration(seconds, nanos) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        _this._seconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(seconds);
        _this._nanos = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanos);
        return _this;
    }
    Duration.ofDays = function ofDays(days) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(days, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    Duration.ofHours = function ofHours(hours) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    Duration.ofMinutes = function ofMinutes(minutes) {
        return Duration._create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    Duration.ofSeconds = function ofSeconds(seconds, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(seconds, $2e6f1e48aadbcba7$var$MathUtil.floorDiv(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
        var nos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration._create(secs, nos);
    };
    Duration.ofMillis = function ofMillis(millis) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(millis, 1000);
        var mos = $2e6f1e48aadbcba7$var$MathUtil.intMod(millis, 1000);
        if (mos < 0) {
            mos += 1000;
            secs--;
        }
        return Duration._create(secs, mos * 1000000);
    };
    Duration.ofNanos = function ofNanos(nanos) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        if (nos < 0) {
            nos += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            secs--;
        }
        return this._create(secs, nos);
    };
    Duration.of = function of(amount, unit) {
        return Duration.ZERO.plus(amount, unit);
    };
    Duration.from = function from(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
        var duration = Duration.ZERO;
        amount.units().forEach(function(unit) {
            duration = duration.plus(amount.get(unit), unit);
        });
        return duration;
    };
    Duration.between = function between(startInclusive, endExclusive) {
        $2e6f1e48aadbcba7$var$requireNonNull(startInclusive, "startInclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        var secs = startInclusive.until(endExclusive, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        var nanos = 0;
        if (startInclusive.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND) && endExclusive.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) try {
            var startNos = startInclusive.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            nanos = endExclusive.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND) - startNos;
            if (secs > 0 && nanos < 0) nanos += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs < 0 && nanos > 0) nanos -= $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
            else if (secs === 0 && nanos !== 0) {
                var adjustedEnd = endExclusive.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, startNos);
                secs = startInclusive.until(adjustedEnd, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
            }
        } catch (e) {}
        return this.ofSeconds(secs, nanos);
    };
    Duration.parse = function parse(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        var PATTERN = new RegExp("([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?", "i");
        var matches = PATTERN.exec(text);
        if (matches !== null) {
            if ("T" === matches[3] === false) {
                var negate = "-" === matches[1];
                var dayMatch = matches[2];
                var hourMatch = matches[4];
                var minuteMatch = matches[5];
                var secondMatch = matches[6];
                var fractionMatch = matches[7];
                if (dayMatch != null || hourMatch != null || minuteMatch != null || secondMatch != null) {
                    var daysAsSecs = Duration._parseNumber(text, dayMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY, "days");
                    var hoursAsSecs = Duration._parseNumber(text, hourMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR, "hours");
                    var minsAsSecs = Duration._parseNumber(text, minuteMatch, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE, "minutes");
                    var seconds = Duration._parseNumber(text, secondMatch, 1, "seconds");
                    var negativeSecs = secondMatch != null && secondMatch.charAt(0) === "-";
                    var nanos = Duration._parseFraction(text, fractionMatch, negativeSecs ? -1 : 1);
                    try {
                        return Duration._create(negate, daysAsSecs, hoursAsSecs, minsAsSecs, seconds, nanos);
                    } catch (ex) {
                        throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Duration: overflow", text, 0, ex);
                    }
                }
            }
        }
        throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Duration", text, 0);
    };
    Duration._parseNumber = function _parseNumber(text, parsed, multiplier, errorText) {
        if (parsed == null) return 0;
        try {
            if (parsed[0] === "+") parsed = parsed.substring(1);
            return $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(parseFloat(parsed), multiplier);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Duration: " + errorText, text, 0, ex);
        }
    };
    Duration._parseFraction = function _parseFraction(text, parsed, negate) {
        if (parsed == null || parsed.length === 0) return 0;
        parsed = (parsed + "000000000").substring(0, 9);
        return parseFloat(parsed) * negate;
    };
    Duration._create = function _create() {
        if (arguments.length <= 2) return Duration._createSecondsNanos(arguments[0], arguments[1]);
        else return Duration._createNegateDaysHoursMinutesSecondsNanos(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    };
    Duration._createNegateDaysHoursMinutesSecondsNanos = function _createNegateDaysHoursMinutesSecondsNanos(negate, daysAsSecs, hoursAsSecs, minsAsSecs, secs, nanos) {
        var seconds = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(daysAsSecs, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(hoursAsSecs, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(minsAsSecs, secs)));
        if (negate) return Duration.ofSeconds(seconds, nanos).negated();
        return Duration.ofSeconds(seconds, nanos);
    };
    Duration._createSecondsNanos = function _createSecondsNanos(seconds, nanoAdjustment) {
        if (seconds === void 0) seconds = 0;
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        if (seconds === 0 && nanoAdjustment === 0) return Duration.ZERO;
        return new Duration(seconds, nanoAdjustment);
    };
    var _proto = Duration.prototype;
    _proto.get = function get(unit) {
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS) return this._seconds;
        else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this._nanos;
        else throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.units = function units() {
        return [
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS
        ];
    };
    _proto.isZero = function isZero() {
        return this._seconds === 0 && this._nanos === 0;
    };
    _proto.isNegative = function isNegative() {
        return this._seconds < 0;
    };
    _proto.seconds = function seconds() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto.withSeconds = function withSeconds(seconds) {
        return Duration._create(seconds, this._nanos);
    };
    _proto.withNanos = function withNanos(nanoOfSecond) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nanoOfSecond);
        return Duration._create(this._seconds, nanoOfSecond);
    };
    _proto.plusDuration = function plusDuration(duration) {
        $2e6f1e48aadbcba7$var$requireNonNull(duration, "duration");
        return this.plus(duration.seconds(), duration.nano());
    };
    _proto.plus = function plus(durationOrNumber, unitOrNumber) {
        if (arguments.length === 1) return this.plusDuration(durationOrNumber);
        else if (arguments.length === 2 && unitOrNumber instanceof $2e6f1e48aadbcba7$export$5d412a4bb789788e) return this.plusAmountUnit(durationOrNumber, unitOrNumber);
        else return this.plusSecondsNanos(durationOrNumber, unitOrNumber);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, "amountToAdd");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
        if (unit.isDurationEstimated()) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unit must not have an estimated duration");
        if (amountToAdd === 0) return this;
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, 1000000000) * 1000, $2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 1000000000) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
            }
            return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(unit.duration().seconds(), amountToAdd), 0);
        }
        var duration = unit.duration().multipliedBy(amountToAdd);
        return this.plusSecondsNanos(duration.seconds(), duration.nano());
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(daysToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY), 0);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(hoursToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), 0);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(minutesToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), 0);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this.plusSecondsNanos(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this.plusSecondsNanos($2e6f1e48aadbcba7$var$MathUtil.intDiv(millisToAdd, 1000), $2e6f1e48aadbcba7$var$MathUtil.intMod(millisToAdd, 1000) * 1000000);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this.plusSecondsNanos(0, nanosToAdd);
    };
    _proto.plusSecondsNanos = function plusSecondsNanos(secondsToAdd, nanosToAdd) {
        $2e6f1e48aadbcba7$var$requireNonNull(secondsToAdd, "secondsToAdd");
        $2e6f1e48aadbcba7$var$requireNonNull(nanosToAdd, "nanosToAdd");
        if (secondsToAdd === 0 && nanosToAdd === 0) return this;
        var epochSec = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._seconds, secondsToAdd);
        epochSec = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(epochSec, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
        nanosToAdd = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._nanos, nanosToAdd);
        return Duration.ofSeconds(epochSec, nanoAdjustment);
    };
    _proto.minus = function minus(durationOrNumber, unit) {
        if (arguments.length === 1) return this.minusDuration(durationOrNumber);
        else return this.minusAmountUnit(durationOrNumber, unit);
    };
    _proto.minusDuration = function minusDuration(duration) {
        $2e6f1e48aadbcba7$var$requireNonNull(duration, "duration");
        var secsToSubtract = duration.seconds();
        var nanosToSubtract = duration.nano();
        if (secsToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER) return this.plus($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER, -nanosToSubtract);
        return this.plus(-secsToSubtract, -nanosToSubtract);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        return amountToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusAmountUnit($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER, unit) : this.plusAmountUnit(-amountToSubtract, unit);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return daysToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusDays($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusDays(-daysToSubtract);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return hoursToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusHours($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusHours(-hoursToSubtract);
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return minutesToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusMinutes($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusMinutes(-minutesToSubtract);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return secondsToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusSeconds($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusSeconds(-secondsToSubtract);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return millisToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusMillis($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusMillis(-millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return nanosToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusNanos($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER) : this.plusNanos(-nanosToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(multiplicand) {
        if (multiplicand === 0) return Duration.ZERO;
        if (multiplicand === 1) return this;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, multiplicand);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._nanos, multiplicand);
        secs = secs + $2e6f1e48aadbcba7$var$MathUtil.intDiv(nos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        nos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Duration.ofSeconds(secs, nos);
    };
    _proto.dividedBy = function dividedBy(divisor) {
        if (divisor === 0) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("Cannot divide by zero");
        if (divisor === 1) return this;
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, divisor);
        var secsMod = $2e6f1e48aadbcba7$var$MathUtil.roundDown((this._seconds / divisor - secs) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, divisor);
        nos = secsMod + nos;
        return Duration.ofSeconds(secs, nos);
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.abs = function abs() {
        return this.isNegative() ? this.negated() : this;
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (this._seconds !== 0) temporal = temporal.plus(this._seconds, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.plus(this._nanos, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (this._seconds !== 0) temporal = temporal.minus(this._seconds, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS);
        if (this._nanos !== 0) temporal = temporal.minus(this._nanos, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS);
        return temporal;
    };
    _proto.toDays = function toDays() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
    };
    _proto.toHours = function toHours() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
    };
    _proto.toMinutes = function toMinutes() {
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
    };
    _proto.toMillis = function toMillis() {
        var millis = Math.round($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, 1000));
        millis = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(millis, $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, 1000000));
        return millis;
    };
    _proto.toNanos = function toNanos() {
        var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, this._nanos);
        return totalNanos;
    };
    _proto.compareTo = function compareTo(otherDuration) {
        $2e6f1e48aadbcba7$var$requireNonNull(otherDuration, "otherDuration");
        $2e6f1e48aadbcba7$var$requireInstance(otherDuration, Duration, "otherDuration");
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._seconds, otherDuration.seconds());
        if (cmp !== 0) return cmp;
        return this._nanos - otherDuration.nano();
    };
    _proto.equals = function equals(otherDuration) {
        if (this === otherDuration) return true;
        if (otherDuration instanceof Duration) return this.seconds() === otherDuration.seconds() && this.nano() === otherDuration.nano();
        return false;
    };
    _proto.toString = function toString() {
        if (this === Duration.ZERO) return "PT0S";
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv($2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var secs = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
        var rval = "PT";
        if (hours !== 0) rval += hours + "H";
        if (minutes !== 0) rval += minutes + "M";
        if (secs === 0 && this._nanos === 0 && rval.length > 2) return rval;
        if (secs < 0 && this._nanos > 0) {
            if (secs === -1) rval += "-0";
            else rval += secs + 1;
        } else rval += secs;
        if (this._nanos > 0) {
            rval += ".";
            var nanoString;
            if (secs < 0) nanoString = "" + (2 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND - this._nanos);
            else nanoString = "" + ($2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos);
            nanoString = nanoString.slice(1, nanoString.length);
            rval += nanoString;
            while(rval.charAt(rval.length - 1) === "0")rval = rval.slice(0, rval.length - 1);
        }
        rval += "S";
        return rval;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Duration;
}($2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
function $2e6f1e48aadbcba7$var$_init() {
    $2e6f1e48aadbcba7$export$3b11bc38611c5941.ZERO = new $2e6f1e48aadbcba7$export$3b11bc38611c5941(0, 0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE.md in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$c04b60057299af61 = function YearConstants() {};
function $2e6f1e48aadbcba7$var$_init$1() {
    $2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE = -999999;
    $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE = 999999;
}
var $2e6f1e48aadbcba7$export$e61e212a4109fb8a = function(_TemporalUnit) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoUnit, _TemporalUnit);
    function ChronoUnit(name1, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name1;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto = ChronoUnit.prototype;
    _proto.duration = function duration() {
        return this._duration;
    };
    _proto.isDurationEstimated = function isDurationEstimated() {
        return this.isDateBased() || this === ChronoUnit.FOREVER;
    };
    _proto.isDateBased = function isDateBased() {
        return this.compareTo(ChronoUnit.DAYS) >= 0 && this !== ChronoUnit.FOREVER;
    };
    _proto.isTimeBased = function isTimeBased() {
        return this.compareTo(ChronoUnit.DAYS) < 0;
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        if (this === ChronoUnit.FOREVER) return false;
        try {
            temporal.plus(1, this);
            return true;
        } catch (e) {
            try {
                temporal.plus(-1, this);
                return true;
            } catch (e2) {
                return false;
            }
        }
    };
    _proto.addTo = function addTo(temporal, amount) {
        return temporal.plus(amount, this);
    };
    _proto.between = function between(temporal1, temporal2) {
        return temporal1.until(temporal2, this);
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        return this.duration().compareTo(other.duration());
    };
    return ChronoUnit;
}($2e6f1e48aadbcba7$export$5d412a4bb789788e);
function $2e6f1e48aadbcba7$var$_init$2() {
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Nanos", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Micros", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Millis", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofNanos(1000000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Seconds", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(1));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Minutes", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(60));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Hours", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(3600));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("HalfDays", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(43200));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Days", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(86400));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Weeks", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(604800));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Months", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(2629746));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Years", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Decades", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(315569520));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Centuries", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(3155695200));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Millennia", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952000));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Eras", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952 * ($2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE + 1)));
    $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER = new $2e6f1e48aadbcba7$export$e61e212a4109fb8a("Forever", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER, 999999999));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9 = function() {
    function TemporalField() {}
    var _proto = TemporalField.prototype;
    _proto.isDateBased = function isDateBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isDateBased");
    };
    _proto.isTimeBased = function isTimeBased() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isTimeBased");
    };
    _proto.baseUnit = function baseUnit() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("baseUnit");
    };
    _proto.rangeUnit = function rangeUnit() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("rangeUnit");
    };
    _proto.range = function range() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("range");
    };
    _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("rangeRefinedBy");
    };
    _proto.getFrom = function getFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("getFrom");
    };
    _proto.adjustInto = function adjustInto(temporal, newValue) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("adjustInto");
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isSupportedBy");
    };
    _proto.displayName = function displayName() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("displayName");
    };
    _proto.equals = function equals(other) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("equals");
    };
    _proto.name = function name1() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("name");
    };
    return TemporalField;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$177e5e64bab4dec5 = function() {
    function ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
        $2e6f1e48aadbcba7$var$assert(!(minSmallest > minLargest), "Smallest minimum value '" + minSmallest + "' must be less than largest minimum value '" + minLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        $2e6f1e48aadbcba7$var$assert(!(maxSmallest > maxLargest), "Smallest maximum value '" + maxSmallest + "' must be less than largest maximum value '" + maxLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        $2e6f1e48aadbcba7$var$assert(!(minLargest > maxLargest), "Minimum value '" + minLargest + "' must be less than maximum value '" + maxLargest + "'", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        this._minSmallest = minSmallest;
        this._minLargest = minLargest;
        this._maxLargest = maxLargest;
        this._maxSmallest = maxSmallest;
    }
    var _proto = ValueRange.prototype;
    _proto.isFixed = function isFixed() {
        return this._minSmallest === this._minLargest && this._maxSmallest === this._maxLargest;
    };
    _proto.minimum = function minimum() {
        return this._minSmallest;
    };
    _proto.largestMinimum = function largestMinimum() {
        return this._minLargest;
    };
    _proto.maximum = function maximum() {
        return this._maxLargest;
    };
    _proto.smallestMaximum = function smallestMaximum() {
        return this._maxSmallest;
    };
    _proto.isValidValue = function isValidValue(value) {
        return this.minimum() <= value && value <= this.maximum();
    };
    _proto.checkValidValue = function checkValidValue(value, field) {
        var msg;
        if (!this.isValidValue(value)) {
            if (field != null) msg = "Invalid value for " + field + " (valid values " + this.toString() + "): " + value;
            else msg = "Invalid value (valid values " + this.toString() + "): " + value;
            return $2e6f1e48aadbcba7$var$assert(false, msg, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        }
        return value;
    };
    _proto.checkValidIntValue = function checkValidIntValue(value, field) {
        if (this.isValidIntValue(value) === false) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid int value for " + field + ": " + value);
        return value;
    };
    _proto.isValidIntValue = function isValidIntValue(value) {
        return this.isIntValue() && this.isValidValue(value);
    };
    _proto.isIntValue = function isIntValue() {
        return this.minimum() >= $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER && this.maximum() <= $2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER;
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ValueRange) return this._minSmallest === other._minSmallest && this._minLargest === other._minLargest && this._maxSmallest === other._maxSmallest && this._maxLargest === other._maxLargest;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._minSmallest, this._minLargest, this._maxSmallest, this._maxLargest);
    };
    _proto.toString = function toString() {
        var str = this.minimum() + (this.minimum() !== this.largestMinimum() ? "/" + this.largestMinimum() : "");
        str += " - ";
        str += this.smallestMaximum() + (this.smallestMaximum() !== this.maximum() ? "/" + this.maximum() : "");
        return str;
    };
    ValueRange.of = function of() {
        if (arguments.length === 2) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[1]);
        else if (arguments.length === 3) return new ValueRange(arguments[0], arguments[0], arguments[1], arguments[2]);
        else if (arguments.length === 4) return new ValueRange(arguments[0], arguments[1], arguments[2], arguments[3]);
        else return $2e6f1e48aadbcba7$var$assert(false, "Invalid number of arguments " + arguments.length, $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
    };
    return ValueRange;
}();
var $2e6f1e48aadbcba7$export$7f55a40756153c3e = function(_TemporalField) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoField, _TemporalField);
    ChronoField.byName = function byName(fieldName) {
        for(var prop in ChronoField)if (ChronoField[prop]) {
            if (ChronoField[prop] instanceof ChronoField && ChronoField[prop].name() === fieldName) return ChronoField[prop];
        }
    };
    function ChronoField(name1, baseUnit, rangeUnit, range) {
        var _this;
        _this = _TemporalField.call(this) || this;
        _this._name = name1;
        _this._baseUnit = baseUnit;
        _this._rangeUnit = rangeUnit;
        _this._range = range;
        return _this;
    }
    var _proto = ChronoField.prototype;
    _proto.name = function name1() {
        return this._name;
    };
    _proto.baseUnit = function baseUnit() {
        return this._baseUnit;
    };
    _proto.rangeUnit = function rangeUnit() {
        return this._rangeUnit;
    };
    _proto.range = function range() {
        return this._range;
    };
    _proto.displayName = function displayName() {
        return this.toString();
    };
    _proto.checkValidValue = function checkValidValue(value) {
        return this.range().checkValidValue(value, this);
    };
    _proto.checkValidIntValue = function checkValidIntValue(value) {
        return this.range().checkValidIntValue(value, this);
    };
    _proto.isDateBased = function isDateBased() {
        var dateBased = this === ChronoField.DAY_OF_WEEK || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_MONTH || this === ChronoField.ALIGNED_DAY_OF_WEEK_IN_YEAR || this === ChronoField.DAY_OF_MONTH || this === ChronoField.DAY_OF_YEAR || this === ChronoField.EPOCH_DAY || this === ChronoField.ALIGNED_WEEK_OF_MONTH || this === ChronoField.ALIGNED_WEEK_OF_YEAR || this === ChronoField.MONTH_OF_YEAR || this === ChronoField.YEAR_OF_ERA || this === ChronoField.YEAR || this === ChronoField.ERA;
        return dateBased;
    };
    _proto.isTimeBased = function isTimeBased() {
        var timeBased = this === ChronoField.NANO_OF_SECOND || this === ChronoField.NANO_OF_DAY || this === ChronoField.MICRO_OF_SECOND || this === ChronoField.MICRO_OF_DAY || this === ChronoField.MILLI_OF_SECOND || this === ChronoField.MILLI_OF_DAY || this === ChronoField.SECOND_OF_MINUTE || this === ChronoField.SECOND_OF_DAY || this === ChronoField.MINUTE_OF_HOUR || this === ChronoField.MINUTE_OF_DAY || this === ChronoField.HOUR_OF_AMPM || this === ChronoField.CLOCK_HOUR_OF_AMPM || this === ChronoField.HOUR_OF_DAY || this === ChronoField.CLOCK_HOUR_OF_DAY || this === ChronoField.AMPM_OF_DAY;
        return timeBased;
    };
    _proto.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return temporal.range(this);
    };
    _proto.getFrom = function getFrom(temporal) {
        return temporal.getLong(this);
    };
    _proto.toString = function toString() {
        return this.name();
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.adjustInto = function adjustInto(temporal, newValue) {
        return temporal.with(this, newValue);
    };
    _proto.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported(this);
    };
    return ChronoField;
}($2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9);
function $2e6f1e48aadbcba7$var$_init$3() {
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("NanoOfSecond", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("NanoOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MicroOfSecond", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MicroOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MilliOfSecond", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MilliOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399999));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("SecondOfMinute", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 59));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("SecondOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 86399));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MinuteOfHour", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 59));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MinuteOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1439));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("HourOfAmPm", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 11));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("ClockHourOfAmPm", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 12));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("HourOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 23));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("ClockHourOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 24));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("AmPmOfDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("DayOfWeek", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("AlignedDayOfWeekInMonth", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("AlignedDayOfWeekInYear", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 7));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("DayOfMonth", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 28, 31), "day");
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("DayOfYear", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 365, 366));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("EpochDay", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(Math.floor($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE * 365.25), Math.floor($2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE * 365.25)));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("AlignedWeekOfMonth", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 4, 5));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("AlignedWeekOfYear", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 53));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("MonthOfYear", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 12), "month");
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("ProlepticMonth", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE * 12, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE * 12 + 11));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("YearOfEra", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE + 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("Year", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE, $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE), "year");
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("Era", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(0, 1));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("InstantSeconds", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of($2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER, $2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER));
    $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS = new $2e6f1e48aadbcba7$export$7f55a40756153c3e("OffsetSeconds", $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER, $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(-64800, 64800));
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$d6cc568434dfd9dc = function() {
    function TemporalQueries() {}
    TemporalQueries.zoneId = function zoneId() {
        return TemporalQueries.ZONE_ID;
    };
    TemporalQueries.chronology = function chronology() {
        return TemporalQueries.CHRONO;
    };
    TemporalQueries.precision = function precision() {
        return TemporalQueries.PRECISION;
    };
    TemporalQueries.zone = function zone() {
        return TemporalQueries.ZONE;
    };
    TemporalQueries.offset = function offset() {
        return TemporalQueries.OFFSET;
    };
    TemporalQueries.localDate = function localDate() {
        return TemporalQueries.LOCAL_DATE;
    };
    TemporalQueries.localTime = function localTime() {
        return TemporalQueries.LOCAL_TIME;
    };
    return TemporalQueries;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$e5100310ee9cc158 = function() {
    function TemporalAccessor() {}
    var _proto = TemporalAccessor.prototype;
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (this.isSupported(field)) return field.range();
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    return TemporalAccessor;
}();
var $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(TemporalQuery, _Enum);
    function TemporalQuery() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TemporalQuery.prototype;
    _proto.queryFrom = function queryFrom(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("queryFrom");
    };
    return TemporalQuery;
}($2e6f1e48aadbcba7$var$Enum);
function $2e6f1e48aadbcba7$var$createTemporalQuery(name1, queryFromFunction) {
    var ExtendedTemporalQuery = function(_TemporalQuery) {
        $2e6f1e48aadbcba7$var$_inheritsLoose(ExtendedTemporalQuery, _TemporalQuery);
        function ExtendedTemporalQuery() {
            return _TemporalQuery.apply(this, arguments) || this;
        }
        return ExtendedTemporalQuery;
    }($2e6f1e48aadbcba7$export$3164c6c8dc6c80ff);
    ExtendedTemporalQuery.prototype.queryFrom = queryFromFunction;
    return new ExtendedTemporalQuery(name1);
}
var $2e6f1e48aadbcba7$export$7ed5ca4f8b987938 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DayOfWeek, _TemporalAccessor);
    function DayOfWeek(ordinal, name1) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._ordinal = ordinal;
        _this._name = name1;
        return _this;
    }
    var _proto = DayOfWeek.prototype;
    _proto.ordinal = function ordinal() {
        return this._ordinal;
    };
    _proto.name = function name1() {
        return this._name;
    };
    DayOfWeek.values = function values() {
        return $2e6f1e48aadbcba7$var$ENUMS.slice();
    };
    DayOfWeek.valueOf = function valueOf(name1) {
        var ordinal = 0;
        for(ordinal; ordinal < $2e6f1e48aadbcba7$var$ENUMS.length; ordinal++){
            if ($2e6f1e48aadbcba7$var$ENUMS[ordinal].name() === name1) break;
        }
        return DayOfWeek.of(ordinal + 1);
    };
    DayOfWeek.of = function of(dayOfWeek) {
        if (dayOfWeek < 1 || dayOfWeek > 7) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid value for DayOfWeek: " + dayOfWeek);
        return $2e6f1e48aadbcba7$var$ENUMS[dayOfWeek - 1];
    };
    DayOfWeek.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$assert(temporal != null, "temporal", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (temporal instanceof DayOfWeek) return temporal;
        try {
            return DayOfWeek.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK));
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain DayOfWeek from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""), ex);
            else throw ex;
        }
    };
    _proto.value = function value() {
        return this._ordinal + 1;
    };
    _proto.displayName = function displayName(style, locale) {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented yet!");
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return field.range();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) return this.value();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(days) {
        var amount = $2e6f1e48aadbcba7$var$MathUtil.floorMod(days, 7);
        return $2e6f1e48aadbcba7$var$ENUMS[$2e6f1e48aadbcba7$var$MathUtil.floorMod(this._ordinal + (amount + 7), 7)];
    };
    _proto.minus = function minus(days) {
        return this.plus(-1 * $2e6f1e48aadbcba7$var$MathUtil.floorMod(days, 7));
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        $2e6f1e48aadbcba7$var$assert(_query != null, "query", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, this.value());
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    _proto.toString = function toString() {
        return this._name;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, DayOfWeek, "other");
        return this._ordinal - other._ordinal;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return DayOfWeek;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$ENUMS;
function $2e6f1e48aadbcba7$var$_init$4() {
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.MONDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(0, "MONDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.TUESDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(1, "TUESDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(2, "WEDNESDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(3, "THURSDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FRIDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(4, "FRIDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SATURDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(5, "SATURDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SUNDAY = new $2e6f1e48aadbcba7$export$7ed5ca4f8b987938(6, "SUNDAY");
    $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("DayOfWeek.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.from(temporal);
    });
    $2e6f1e48aadbcba7$var$ENUMS = [
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.MONDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.TUESDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.FRIDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SATURDAY,
        $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.SUNDAY
    ];
}
var $2e6f1e48aadbcba7$export$951c8378cdfec6e6 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Month, _TemporalAccessor);
    function Month(value, name1) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._value = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(value);
        _this._name = name1;
        return _this;
    }
    var _proto = Month.prototype;
    _proto.value = function value() {
        return this._value;
    };
    _proto.ordinal = function ordinal() {
        return this._value - 1;
    };
    _proto.name = function name1() {
        return this._name;
    };
    _proto.displayName = function displayName(style, locale) {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented yet!");
    };
    _proto.isSupported = function isSupported(field) {
        if (null === field) return false;
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR;
        return field != null && field.isSupportedBy(this);
    };
    _proto.get = function get(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return this.value();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.plus = function plus(months) {
        var amount = $2e6f1e48aadbcba7$var$MathUtil.intMod(months, 12) + 12;
        var newMonthVal = $2e6f1e48aadbcba7$var$MathUtil.intMod(this.value() + amount, 12);
        newMonthVal = newMonthVal === 0 ? 12 : newMonthVal;
        return Month.of(newMonthVal);
    };
    _proto.minus = function minus(months) {
        return this.plus(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(months, 12));
    };
    _proto.length = function length(leapYear) {
        switch(this){
            case Month.FEBRUARY:
                return leapYear ? 29 : 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.minLength = function minLength() {
        switch(this){
            case Month.FEBRUARY:
                return 28;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.maxLength = function maxLength() {
        switch(this){
            case Month.FEBRUARY:
                return 29;
            case Month.APRIL:
            case Month.JUNE:
            case Month.SEPTEMBER:
            case Month.NOVEMBER:
                return 30;
            default:
                return 31;
        }
    };
    _proto.firstDayOfYear = function firstDayOfYear(leapYear) {
        var leap = leapYear ? 1 : 0;
        switch(this){
            case Month.JANUARY:
                return 1;
            case Month.FEBRUARY:
                return 32;
            case Month.MARCH:
                return 60 + leap;
            case Month.APRIL:
                return 91 + leap;
            case Month.MAY:
                return 121 + leap;
            case Month.JUNE:
                return 152 + leap;
            case Month.JULY:
                return 182 + leap;
            case Month.AUGUST:
                return 213 + leap;
            case Month.SEPTEMBER:
                return 244 + leap;
            case Month.OCTOBER:
                return 274 + leap;
            case Month.NOVEMBER:
                return 305 + leap;
            case Month.DECEMBER:
            default:
                return 335 + leap;
        }
    };
    _proto.firstMonthOfQuarter = function firstMonthOfQuarter() {
        switch(this){
            case Month.JANUARY:
            case Month.FEBRUARY:
            case Month.MARCH:
                return Month.JANUARY;
            case Month.APRIL:
            case Month.MAY:
            case Month.JUNE:
                return Month.APRIL;
            case Month.JULY:
            case Month.AUGUST:
            case Month.SEPTEMBER:
                return Month.JULY;
            case Month.OCTOBER:
            case Month.NOVEMBER:
            case Month.DECEMBER:
            default:
                return Month.OCTOBER;
        }
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$assert(_query != null, "query() parameter must not be null", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.toString = function toString() {
        switch(this){
            case Month.JANUARY:
                return "JANUARY";
            case Month.FEBRUARY:
                return "FEBRUARY";
            case Month.MARCH:
                return "MARCH";
            case Month.APRIL:
                return "APRIL";
            case Month.MAY:
                return "MAY";
            case Month.JUNE:
                return "JUNE";
            case Month.JULY:
                return "JULY";
            case Month.AUGUST:
                return "AUGUST";
            case Month.SEPTEMBER:
                return "SEPTEMBER";
            case Month.OCTOBER:
                return "OCTOBER";
            case Month.NOVEMBER:
                return "NOVEMBER";
            case Month.DECEMBER:
                return "DECEMBER";
            default:
                return "unknown Month, value: " + this.value();
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, this.value());
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, Month, "other");
        return this._value - other._value;
    };
    _proto.equals = function equals(other) {
        return this === other;
    };
    Month.valueOf = function valueOf(name1) {
        var ordinal = 0;
        for(ordinal; ordinal < $2e6f1e48aadbcba7$var$MONTHS.length; ordinal++){
            if ($2e6f1e48aadbcba7$var$MONTHS[ordinal].name() === name1) break;
        }
        return Month.of(ordinal + 1);
    };
    Month.values = function values() {
        return $2e6f1e48aadbcba7$var$MONTHS.slice();
    };
    Month.of = function of(month) {
        if (month < 1 || month > 12) $2e6f1e48aadbcba7$var$assert(false, "Invalid value for MonthOfYear: " + month, $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        return $2e6f1e48aadbcba7$var$MONTHS[month - 1];
    };
    Month.from = function from(temporal) {
        if (temporal instanceof Month) return temporal;
        try {
            return Month.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Month from TemporalAccessor: " + temporal + " of type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""), ex);
        }
    };
    return Month;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$MONTHS;
function $2e6f1e48aadbcba7$var$_init$5() {
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JANUARY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(1, "JANUARY");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(2, "FEBRUARY");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MARCH = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(3, "MARCH");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.APRIL = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(4, "APRIL");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MAY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(5, "MAY");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JUNE = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(6, "JUNE");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JULY = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(7, "JULY");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.AUGUST = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(8, "AUGUST");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.SEPTEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(9, "SEPTEMBER");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.OCTOBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(10, "OCTOBER");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.NOVEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(11, "NOVEMBER");
    $2e6f1e48aadbcba7$export$951c8378cdfec6e6.DECEMBER = new $2e6f1e48aadbcba7$export$951c8378cdfec6e6(12, "DECEMBER");
    $2e6f1e48aadbcba7$var$MONTHS = [
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JANUARY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MARCH,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.APRIL,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.MAY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JUNE,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.JULY,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.AUGUST,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.SEPTEMBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.OCTOBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.NOVEMBER,
        $2e6f1e48aadbcba7$export$951c8378cdfec6e6.DECEMBER
    ];
}
var $2e6f1e48aadbcba7$var$PATTERN = /([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?/;
var $2e6f1e48aadbcba7$export$67186dcd8fa4f92f = function(_TemporalAmount) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Period, _TemporalAmount);
    function Period(years, months, days) {
        var _this;
        _this = _TemporalAmount.call(this) || this;
        var _years = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(years);
        var _months = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(months);
        var _days = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(days);
        if (_years === 0 && _months === 0 && _days === 0) {
            if (!Period.ZERO) {
                _this._years = _years;
                _this._months = _months;
                _this._days = _days;
                Period.ZERO = $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
            }
            return Period.ZERO || $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        }
        _this._years = _years;
        _this._months = _months;
        _this._days = _days;
        return _this;
    }
    Period.ofYears = function ofYears(years) {
        return Period.create(years, 0, 0);
    };
    Period.ofMonths = function ofMonths(months) {
        return Period.create(0, months, 0);
    };
    Period.ofWeeks = function ofWeeks(weeks) {
        return Period.create(0, 0, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeks, 7));
    };
    Period.ofDays = function ofDays(days) {
        return Period.create(0, 0, days);
    };
    Period.of = function of(years, months, days) {
        return Period.create(years, months, days);
    };
    Period.from = function from(amount) {
        if (amount instanceof Period) return amount;
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        var years = 0;
        var months = 0;
        var days = 0;
        var units = amount.units();
        for(var i = 0; i < units.length; i++){
            var unit = units[i];
            var unitAmount = amount.get(unit);
            if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS) years = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS) months = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) days = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(unitAmount);
            else throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit must be Years, Months or Days, but was " + unit);
        }
        return Period.create(years, months, days);
    };
    Period.between = function between(startDate, endDate) {
        $2e6f1e48aadbcba7$var$requireNonNull(startDate, "startDate");
        $2e6f1e48aadbcba7$var$requireNonNull(endDate, "endDate");
        $2e6f1e48aadbcba7$var$requireInstance(startDate, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, "startDate");
        $2e6f1e48aadbcba7$var$requireInstance(endDate, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, "endDate");
        return startDate.until(endDate);
    };
    Period.parse = function parse(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        try {
            return Period._parse(text);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$5891bcae38b5fd67) throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Period", text, 0, ex);
            else throw ex;
        }
    };
    Period._parse = function _parse(text) {
        var matches = $2e6f1e48aadbcba7$var$PATTERN.exec(text);
        if (matches != null) {
            var negate = "-" === matches[1] ? -1 : 1;
            var yearMatch = matches[2];
            var monthMatch = matches[3];
            var weekMatch = matches[4];
            var dayMatch = matches[5];
            if (yearMatch != null || monthMatch != null || weekMatch != null || dayMatch != null) {
                var years = Period._parseNumber(text, yearMatch, negate);
                var months = Period._parseNumber(text, monthMatch, negate);
                var weeks = Period._parseNumber(text, weekMatch, negate);
                var days = Period._parseNumber(text, dayMatch, negate);
                days = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(days, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeks, 7));
                return Period.create(years, months, days);
            }
        }
        throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text cannot be parsed to a Period", text, 0);
    };
    Period._parseNumber = function _parseNumber(text, str, negate) {
        if (str == null) return 0;
        var val = $2e6f1e48aadbcba7$var$MathUtil.parseInt(str);
        return $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(val, negate);
    };
    Period.create = function create(years, months, days) {
        return new Period(years, months, days);
    };
    var _proto = Period.prototype;
    _proto.units = function units() {
        return [
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS,
            $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS
        ];
    };
    _proto.chronology = function chronology() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.get = function get(unit) {
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS) return this._years;
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS) return this._months;
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS) return this._days;
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
    };
    _proto.isZero = function isZero() {
        return this === Period.ZERO;
    };
    _proto.isNegative = function isNegative() {
        return this._years < 0 || this._months < 0 || this._days < 0;
    };
    _proto.years = function years() {
        return this._years;
    };
    _proto.months = function months() {
        return this._months;
    };
    _proto.days = function days() {
        return this._days;
    };
    _proto.withYears = function withYears(years) {
        if (years === this._years) return this;
        return Period.create(years, this._months, this._days);
    };
    _proto.withMonths = function withMonths(months) {
        if (months === this._months) return this;
        return Period.create(this._years, months, this._days);
    };
    _proto.withDays = function withDays(days) {
        if (days === this._days) return this;
        return Period.create(this._years, this._months, days);
    };
    _proto.plus = function plus(amountToAdd) {
        var amount = Period.from(amountToAdd);
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._years, amount._years), $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._months, amount._months), $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._days, amount._days));
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._years, yearsToAdd)), this._months, this._days);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        return Period.create(this._years, $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._months, monthsToAdd)), this._days);
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        return Period.create(this._years, this._months, $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._days, daysToAdd)));
    };
    _proto.minus = function minus(amountToSubtract) {
        var amount = Period.from(amountToSubtract);
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._years, amount._years), $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._months, amount._months), $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(this._days, amount._days));
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(-1 * yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(-1 * monthsToSubtract);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(-1 * daysToSubtract);
    };
    _proto.multipliedBy = function multipliedBy(scalar) {
        if (this === Period.ZERO || scalar === 1) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._years, scalar), $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._months, scalar), $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._days, scalar));
    };
    _proto.negated = function negated() {
        return this.multipliedBy(-1);
    };
    _proto.normalized = function normalized() {
        var totalMonths = this.toTotalMonths();
        var splitYears = $2e6f1e48aadbcba7$var$MathUtil.intDiv(totalMonths, 12);
        var splitMonths = $2e6f1e48aadbcba7$var$MathUtil.intMod(totalMonths, 12);
        if (splitYears === this._years && splitMonths === this._months) return this;
        return Period.create($2e6f1e48aadbcba7$var$MathUtil.safeToInt(splitYears), splitMonths, this._days);
    };
    _proto.toTotalMonths = function toTotalMonths() {
        return this._years * 12 + this._months;
    };
    _proto.addTo = function addTo(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.plus(this.toTotalMonths(), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.plus(this._years, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.plus(this._months, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.plus(this._days, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.subtractFrom = function subtractFrom(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (this._years !== 0) {
            if (this._months !== 0) temporal = temporal.minus(this.toTotalMonths(), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            else temporal = temporal.minus(this._years, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        } else if (this._months !== 0) temporal = temporal.minus(this._months, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
        if (this._days !== 0) temporal = temporal.minus(this._days, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        return temporal;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof Period) {
            var other = obj;
            return this._years === other._years && this._months === other._months && this._days === other._days;
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._years, this._months, this._days);
    };
    _proto.toString = function toString() {
        if (this === Period.ZERO) return "P0D";
        else {
            var buf = "P";
            if (this._years !== 0) buf += "" + this._years + "Y";
            if (this._months !== 0) buf += "" + this._months + "M";
            if (this._days !== 0) buf += "" + this._days + "D";
            return buf;
        }
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Period;
}($2e6f1e48aadbcba7$export$f8b2fcf02a6656ff);
function $2e6f1e48aadbcba7$var$_init$6() {
    $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ParsePosition = function() {
    function ParsePosition(index) {
        this._index = index;
        this._errorIndex = -1;
    }
    var _proto = ParsePosition.prototype;
    _proto.getIndex = function getIndex() {
        return this._index;
    };
    _proto.setIndex = function setIndex(index) {
        this._index = index;
    };
    _proto.getErrorIndex = function getErrorIndex() {
        return this._errorIndex;
    };
    _proto.setErrorIndex = function setErrorIndex(errorIndex) {
        this._errorIndex = errorIndex;
    };
    return ParsePosition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$EnumMap = function() {
    function EnumMap() {
        this._map = {};
    }
    var _proto = EnumMap.prototype;
    _proto.putAll = function putAll(otherMap) {
        for(var key in otherMap._map)this._map[key] = otherMap._map[key];
        return this;
    };
    _proto.containsKey = function containsKey(key) {
        return this._map.hasOwnProperty(key.name()) && this.get(key) !== undefined;
    };
    _proto.get = function get(key) {
        return this._map[key.name()];
    };
    _proto.put = function put(key, val) {
        return this.set(key, val);
    };
    _proto.set = function set(key, val) {
        this._map[key.name()] = val;
        return this;
    };
    _proto.retainAll = function retainAll(keyList) {
        var map = {};
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i].name();
            map[key] = this._map[key];
        }
        this._map = map;
        return this;
    };
    _proto.remove = function remove(key) {
        var keyName = key.name();
        var val = this._map[keyName];
        this._map[keyName] = undefined;
        return val;
    };
    _proto.keySet = function keySet() {
        return this._map;
    };
    _proto.clear = function clear() {
        this._map = {};
    };
    return EnumMap;
}();
var $2e6f1e48aadbcba7$export$2a833e4d13229d66 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ResolverStyle, _Enum);
    function ResolverStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    return ResolverStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT = new $2e6f1e48aadbcba7$export$2a833e4d13229d66("STRICT");
$2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART = new $2e6f1e48aadbcba7$export$2a833e4d13229d66("SMART");
$2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT = new $2e6f1e48aadbcba7$export$2a833e4d13229d66("LENIENT");
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$841f8bd48996924f = function() {
    function TemporalAdjuster() {}
    var _proto = TemporalAdjuster.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("adjustInto");
    };
    return TemporalAdjuster;
}();
var $2e6f1e48aadbcba7$export$336849d529cb05e5 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Temporal, _TemporalAccessor);
    function Temporal() {
        return _TemporalAccessor.apply(this, arguments) || this;
    }
    var _proto = Temporal.prototype;
    _proto.isSupported = function isSupported(unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("isSupported");
    };
    _proto.minus = function minus(p1, p2) {
        if (arguments.length < 2) return this.minusAmount(p1);
        else return this.minusAmountUnit(p1, p2);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("minusAmount");
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("minusAmountUnit");
    };
    _proto.plus = function plus(p1, p2) {
        if (arguments.length < 2) return this.plusAmount(p1);
        else return this.plusAmountUnit(p1, p2);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("plusAmount");
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("plusAmountUnit");
    };
    _proto.until = function until(endTemporal, unit) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("until");
    };
    _proto.with = function _with(p1, p2) {
        if (arguments.length < 2) return this.withAdjuster(p1);
        else return this.withFieldValue(p1, p2);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("withAdjuster");
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("withFieldValue");
    };
    return Temporal;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$DefaultInterfaceTemporal = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DefaultInterfaceTemporal, _Temporal);
    function DefaultInterfaceTemporal() {
        return _Temporal.apply(this, arguments) || this;
    }
    var _proto = DefaultInterfaceTemporal.prototype;
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        $2e6f1e48aadbcba7$var$requireInstance(adjuster, $2e6f1e48aadbcba7$export$841f8bd48996924f, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, "amount");
        return amount.addTo(this);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, "unit");
        return amountToSubtract === $2e6f1e48aadbcba7$var$MIN_SAFE_INTEGER ? this.plusAmountUnit($2e6f1e48aadbcba7$var$MAX_SAFE_INTEGER, unit).plusAmountUnit(1, unit) : this.plusAmount(-amountToSubtract, unit);
    };
    return DefaultInterfaceTemporal;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$export$2a07e3472bc98879 = function(_DefaultInterfaceTemp) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoLocalDate, _DefaultInterfaceTemp);
    function ChronoLocalDate() {
        return _DefaultInterfaceTemp.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDate.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _DefaultInterfaceTemp.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toEpochDay());
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    return ChronoLocalDate;
}($2e6f1e48aadbcba7$var$DefaultInterfaceTemporal);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringUtil = function() {
    function StringUtil() {}
    StringUtil.startsWith = function startsWith(text, pattern) {
        return text.indexOf(pattern) === 0;
    };
    StringUtil.hashCode = function hashCode(text) {
        var len = text.length;
        if (len === 0) return 0;
        var hash = 0;
        for(var i = 0; i < len; i++){
            var chr = text.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0;
        }
        return $2e6f1e48aadbcba7$var$MathUtil.smi(hash);
    };
    return StringUtil;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$a514a0be1f00ef62 = function() {
    function ZoneId() {}
    ZoneId.systemDefault = function systemDefault() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation");
    };
    ZoneId.getAvailableZoneIds = function getAvailableZoneIds() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation");
    };
    ZoneId.of = function of(zoneId) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + zoneId);
    };
    ZoneId.ofOffset = function ofOffset(prefix, offset) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + prefix + offset);
    };
    ZoneId.from = function from(temporal) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation" + temporal);
    };
    var _proto = ZoneId.prototype;
    _proto.id = function id() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneId.id");
    };
    _proto.rules = function rules() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneId.rules");
    };
    _proto.normalized = function normalized() {
        var rules = this.rules();
        if (rules.isFixedOffset()) return rules.offset($2e6f1e48aadbcba7$export$fecec53969739358.EPOCH);
        return this;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZoneId) return this.id() === other.id();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$StringUtil.hashCode(this.id());
    };
    _proto.toString = function toString() {
        return this.id();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneId;
}();
var $2e6f1e48aadbcba7$export$cbd9bcf3fad97817 = function() {
    function ZoneRules() {}
    ZoneRules.of = function of(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        return new $2e6f1e48aadbcba7$var$Fixed(offset);
    };
    var _proto = ZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.isFixedOffset");
    };
    _proto.offset = function offset(instantOrLocalDateTime) {
        if (instantOrLocalDateTime instanceof $2e6f1e48aadbcba7$export$fecec53969739358) return this.offsetOfInstant(instantOrLocalDateTime);
        else return this.offsetOfLocalDateTime(instantOrLocalDateTime);
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.offsetInstant");
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.offsetOfEpochMilli");
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.offsetLocalDateTime");
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.validOffsets");
    };
    _proto.transition = function transition(localDateTime) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.transition");
    };
    _proto.standardOffset = function standardOffset(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.standardOffset");
    };
    _proto.daylightSavings = function daylightSavings(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.daylightSavings");
    };
    _proto.isDaylightSavings = function isDaylightSavings(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.isDaylightSavings");
    };
    _proto.isValidOffset = function isValidOffset(localDateTime, offset) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.isValidOffset");
    };
    _proto.nextTransition = function nextTransition(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.nextTransition");
    };
    _proto.previousTransition = function previousTransition(instant) {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.previousTransition");
    };
    _proto.transitions = function transitions() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.transitions");
    };
    _proto.transitionRules = function transitionRules() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.transitionRules");
    };
    _proto.toString = function toString() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("ZoneRules.toString");
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return ZoneRules;
}();
var $2e6f1e48aadbcba7$var$Fixed = function(_ZoneRules) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Fixed, _ZoneRules);
    function Fixed(offset) {
        var _this;
        _this = _ZoneRules.call(this) || this;
        _this._offset = offset;
        return _this;
    }
    var _proto2 = Fixed.prototype;
    _proto2.isFixedOffset = function isFixedOffset() {
        return true;
    };
    _proto2.offsetOfInstant = function offsetOfInstant() {
        return this._offset;
    };
    _proto2.offsetOfEpochMilli = function offsetOfEpochMilli() {
        return this._offset;
    };
    _proto2.offsetOfLocalDateTime = function offsetOfLocalDateTime() {
        return this._offset;
    };
    _proto2.validOffsets = function validOffsets() {
        return [
            this._offset
        ];
    };
    _proto2.transition = function transition() {
        return null;
    };
    _proto2.standardOffset = function standardOffset() {
        return this._offset;
    };
    _proto2.daylightSavings = function daylightSavings() {
        return $2e6f1e48aadbcba7$export$3b11bc38611c5941.ZERO;
    };
    _proto2.isDaylightSavings = function isDaylightSavings() {
        return false;
    };
    _proto2.isValidOffset = function isValidOffset(localDateTime, offset) {
        return this._offset.equals(offset);
    };
    _proto2.nextTransition = function nextTransition() {
        return null;
    };
    _proto2.previousTransition = function previousTransition() {
        return null;
    };
    _proto2.transitions = function transitions() {
        return [];
    };
    _proto2.transitionRules = function transitionRules() {
        return [];
    };
    _proto2.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Fixed) return this._offset.equals(other._offset);
        return false;
    };
    _proto2.toString = function toString() {
        return "FixedRules:" + this._offset.toString();
    };
    return Fixed;
}($2e6f1e48aadbcba7$export$cbd9bcf3fad97817);
var $2e6f1e48aadbcba7$var$SECONDS_CACHE = {};
var $2e6f1e48aadbcba7$var$ID_CACHE = {};
var $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZoneOffset, _ZoneId);
    function ZoneOffset(totalSeconds) {
        var _this;
        _this = _ZoneId.call(this) || this;
        ZoneOffset._validateTotalSeconds(totalSeconds);
        _this._totalSeconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(totalSeconds);
        _this._rules = $2e6f1e48aadbcba7$export$cbd9bcf3fad97817.of($2e6f1e48aadbcba7$var$_assertThisInitialized(_this));
        _this._id = ZoneOffset._buildId(totalSeconds);
        return _this;
    }
    var _proto = ZoneOffset.prototype;
    _proto.totalSeconds = function totalSeconds() {
        return this._totalSeconds;
    };
    _proto.id = function id() {
        return this._id;
    };
    ZoneOffset._buildId = function _buildId(totalSeconds) {
        if (totalSeconds === 0) return "Z";
        else {
            var absTotalSeconds = Math.abs(totalSeconds);
            var absHours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
            var absMinutes = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE), $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR);
            var buf = "" + (totalSeconds < 0 ? "-" : "+") + (absHours < 10 ? "0" : "") + absHours + (absMinutes < 10 ? ":0" : ":") + absMinutes;
            var absSeconds = $2e6f1e48aadbcba7$var$MathUtil.intMod(absTotalSeconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
            if (absSeconds !== 0) buf += (absSeconds < 10 ? ":0" : ":") + absSeconds;
            return buf;
        }
    };
    ZoneOffset._validateTotalSeconds = function _validateTotalSeconds(totalSeconds) {
        if (Math.abs(totalSeconds) > ZoneOffset.MAX_SECONDS) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset not in valid range: -18:00 to +18:00");
    };
    ZoneOffset._validate = function _validate(hours, minutes, seconds) {
        if (hours < -18 || hours > 18) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset hours not in valid range: value " + hours + " is not in the range -18 to 18");
        if (hours > 0) {
            if (minutes < 0 || seconds < 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset minutes and seconds must be positive because hours is positive");
        } else if (hours < 0) {
            if (minutes > 0 || seconds > 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset minutes and seconds must be negative because hours is negative");
        } else if (minutes > 0 && seconds < 0 || minutes < 0 && seconds > 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset minutes and seconds must have the same sign");
        if (Math.abs(minutes) > 59) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset minutes not in valid range: abs(value) " + Math.abs(minutes) + " is not in the range 0 to 59");
        if (Math.abs(seconds) > 59) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset seconds not in valid range: abs(value) " + Math.abs(seconds) + " is not in the range 0 to 59");
        if (Math.abs(hours) === 18 && (Math.abs(minutes) > 0 || Math.abs(seconds) > 0)) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Zone offset not in valid range: -18:00 to +18:00");
    };
    ZoneOffset.of = function of(offsetId) {
        $2e6f1e48aadbcba7$var$requireNonNull(offsetId, "offsetId");
        var offset = $2e6f1e48aadbcba7$var$ID_CACHE[offsetId];
        if (offset != null) return offset;
        var hours, minutes, seconds;
        switch(offsetId.length){
            case 2:
                offsetId = offsetId[0] + "0" + offsetId[1];
            case 3:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = 0;
                seconds = 0;
                break;
            case 5:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = 0;
                break;
            case 6:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = 0;
                break;
            case 7:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 3, false);
                seconds = ZoneOffset._parseNumber(offsetId, 5, false);
                break;
            case 9:
                hours = ZoneOffset._parseNumber(offsetId, 1, false);
                minutes = ZoneOffset._parseNumber(offsetId, 4, true);
                seconds = ZoneOffset._parseNumber(offsetId, 7, true);
                break;
            default:
                throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, invalid format: " + offsetId);
        }
        var first = offsetId[0];
        if (first !== "+" && first !== "-") throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, plus/minus not found when expected: " + offsetId);
        if (first === "-") return ZoneOffset.ofHoursMinutesSeconds(-hours, -minutes, -seconds);
        else return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, seconds);
    };
    ZoneOffset._parseNumber = function _parseNumber(offsetId, pos, precededByColon) {
        if (precededByColon && offsetId[pos - 1] !== ":") throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId);
        var ch1 = offsetId[pos];
        var ch2 = offsetId[pos + 1];
        if (ch1 < "0" || ch1 > "9" || ch2 < "0" || ch2 > "9") throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId);
        return (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
    };
    ZoneOffset.ofHours = function ofHours(hours) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, 0, 0);
    };
    ZoneOffset.ofHoursMinutes = function ofHoursMinutes(hours, minutes) {
        return ZoneOffset.ofHoursMinutesSeconds(hours, minutes, 0);
    };
    ZoneOffset.ofHoursMinutesSeconds = function ofHoursMinutesSeconds(hours, minutes, seconds) {
        ZoneOffset._validate(hours, minutes, seconds);
        var totalSeconds = hours * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR + minutes * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE + seconds;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalMinutes = function ofTotalMinutes(totalMinutes) {
        var totalSeconds = totalMinutes * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
        return ZoneOffset.ofTotalSeconds(totalSeconds);
    };
    ZoneOffset.ofTotalSeconds = function ofTotalSeconds(totalSeconds) {
        if (totalSeconds % (15 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE) === 0) {
            var totalSecs = totalSeconds;
            var result = $2e6f1e48aadbcba7$var$SECONDS_CACHE[totalSecs];
            if (result == null) {
                result = new ZoneOffset(totalSeconds);
                $2e6f1e48aadbcba7$var$SECONDS_CACHE[totalSecs] = result;
                $2e6f1e48aadbcba7$var$ID_CACHE[result.id()] = result;
            }
            return result;
        } else return new ZoneOffset(totalSeconds);
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._totalSeconds;
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unsupported field: " + field);
        return field.getFrom(this);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this._totalSeconds);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return other._totalSeconds - this._totalSeconds;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof ZoneOffset) return this._totalSeconds === obj._totalSeconds;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._totalSeconds;
    };
    _proto.toString = function toString() {
        return this._id;
    };
    return ZoneOffset;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
function $2e6f1e48aadbcba7$var$_init$7() {
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS = 18 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR;
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(-$2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS);
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX_SECONDS);
}
var $2e6f1e48aadbcba7$var$DateTimeBuilder = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DateTimeBuilder, _TemporalAccessor);
    DateTimeBuilder.create = function create(field, value) {
        var dtb = new DateTimeBuilder();
        dtb._addFieldValue(field, value);
        return dtb;
    };
    function DateTimeBuilder() {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this.fieldValues = new $2e6f1e48aadbcba7$var$EnumMap();
        _this.chrono = null;
        _this.zone = null;
        _this.date = null;
        _this.time = null;
        _this.leapSecond = false;
        _this.excessDays = null;
        return _this;
    }
    var _proto = DateTimeBuilder.prototype;
    _proto.getFieldValue0 = function getFieldValue0(field) {
        return this.fieldValues.get(field);
    };
    _proto._addFieldValue = function _addFieldValue(field, value) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        var old = this.getFieldValue0(field);
        if (old != null && old !== value) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Conflict found: " + field + " " + old + " differs from " + field + " " + value + ": " + this);
        return this._putFieldValue0(field, value);
    };
    _proto._putFieldValue0 = function _putFieldValue0(field, value) {
        this.fieldValues.put(field, value);
        return this;
    };
    _proto.resolve = function resolve(resolverStyle, resolverFields) {
        if (resolverFields != null) this.fieldValues.retainAll(resolverFields);
        this._mergeDate(resolverStyle);
        this._mergeTime(resolverStyle);
        this._resolveTimeInferZeroes(resolverStyle);
        if (this.excessDays != null && this.excessDays.isZero() === false && this.date != null && this.time != null) {
            this.date = this.date.plus(this.excessDays);
            this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ZERO;
        }
        this._resolveInstant();
        return this;
    };
    _proto._mergeDate = function _mergeDate(resolverStyle) {
        this._checkDate($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE.resolveDate(this.fieldValues, resolverStyle));
    };
    _proto._checkDate = function _checkDate(date) {
        if (date != null) {
            this._addObject(date);
            for(var fieldName in this.fieldValues.keySet()){
                var field = $2e6f1e48aadbcba7$export$7f55a40756153c3e.byName(fieldName);
                if (field) {
                    if (this.fieldValues.get(field) !== undefined) {
                        if (field.isDateBased()) {
                            var val1 = void 0;
                            try {
                                val1 = date.getLong(field);
                            } catch (ex) {
                                if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb) continue;
                                else throw ex;
                            }
                            var val2 = this.fieldValues.get(field);
                            if (val1 !== val2) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Conflict found: Field " + field + " " + val1 + " differs from " + field + " " + val2 + " derived from " + date);
                        }
                    }
                }
            }
        }
    };
    _proto._mergeTime = function _mergeTime(resolverStyle) {
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY)) {
            var ch = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && ch === 0) ;
                else $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY.checkValidValue(ch);
            }
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, ch === 24 ? 0 : ch);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM)) {
            var _ch = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && _ch === 0) ;
                else $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM.checkValidValue(_ch);
            }
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM, _ch === 12 ? 0 : _ch);
        }
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY));
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM)) {
            var ap = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY);
            var hap = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, ap * 12 + hap);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY)) {
            var nod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, 1000000000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(nod, 1000000000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY)) {
            var cod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY.checkValidValue(cod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(cod, 1000000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(cod, 1000000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY)) {
            var lod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY.checkValidValue(lod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(lod, 1000));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intMod(lod, 1000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY)) {
            var sod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(sod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(sod, 3600));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(sod, 60), 60));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, $2e6f1e48aadbcba7$var$MathUtil.intMod(sod, 60));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY)) {
            var mod = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY);
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY.checkValidValue(mod);
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, $2e6f1e48aadbcba7$var$MathUtil.intDiv(mod, 60));
            this._addFieldValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, $2e6f1e48aadbcba7$var$MathUtil.intMod(mod, 60));
        }
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND));
            if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND.checkValidValue(this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var los = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
            var cos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, los * 1000 + $2e6f1e48aadbcba7$var$MathUtil.intMod(cos, 1000));
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intDiv(nos, 1000));
            this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND) && this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) {
            var _nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND, $2e6f1e48aadbcba7$var$MathUtil.intDiv(_nos, 1000000));
            this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
        }
        if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND)) {
            var _cos = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, _cos * 1000);
        } else if (this.fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND)) {
            var _los = this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND);
            this._putFieldValue0($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, _los * 1000000);
        }
    };
    _proto._resolveTimeInferZeroes = function _resolveTimeInferZeroes(resolverStyle) {
        var hod = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        var moh = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var som = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nos = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (hod == null) return;
        if (moh == null && (som != null || nos != null)) return;
        if (moh != null && som == null && nos != null) return;
        if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            if (hod != null) {
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART && hod === 24 && (moh == null || moh === 0) && (som == null || som === 0) && (nos == null || nos === 0)) {
                    hod = 0;
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(1);
                }
                var hodVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidIntValue(hod);
                if (moh != null) {
                    var mohVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidIntValue(moh);
                    if (som != null) {
                        var somVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidIntValue(som);
                        if (nos != null) {
                            var nosVal = $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(nos);
                            this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal, somVal, nosVal));
                        } else this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal, somVal));
                    } else if (nos == null) this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, mohVal));
                } else if (som == null && nos == null) this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hodVal, 0));
            }
        } else if (hod != null) {
            var _hodVal = hod;
            if (moh != null) {
                if (som != null) {
                    if (nos == null) nos = 0;
                    var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(_hodVal, 3600000000000);
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(moh, 60000000000));
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(som, 1000000000));
                    totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, nos);
                    var excessDays = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totalNanos, 86400000000000);
                    var nod = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totalNanos, 86400000000000);
                    this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(nod));
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(excessDays);
                } else {
                    var totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(_hodVal, 3600);
                    totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalSecs, $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(moh, 60));
                    var _excessDays = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totalSecs, 86400);
                    var sod = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totalSecs, 86400);
                    this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(sod));
                    this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(_excessDays);
                }
            } else {
                var _excessDays2 = $2e6f1e48aadbcba7$var$MathUtil.safeToInt($2e6f1e48aadbcba7$var$MathUtil.floorDiv(_hodVal, 24));
                _hodVal = $2e6f1e48aadbcba7$var$MathUtil.floorMod(_hodVal, 24);
                this._addObject($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(_hodVal, 0));
                this.excessDays = $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ofDays(_excessDays2);
            }
        }
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        this.fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
    };
    _proto._addObject = function _addObject(dateOrTime) {
        if (dateOrTime instanceof $2e6f1e48aadbcba7$export$2a07e3472bc98879) this.date = dateOrTime;
        else if (dateOrTime instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) this.time = dateOrTime;
    };
    _proto._resolveInstant = function _resolveInstant() {
        if (this.date != null && this.time != null) {
            var offsetSecs = this.fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
            if (offsetSecs != null) {
                var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
                var instant = this.date.atTime(this.time).atZone(offset).getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, instant);
            } else if (this.zone != null) {
                var _instant = this.date.atTime(this.time).atZone(this.zone).getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
                this.fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, _instant);
            }
        }
    };
    _proto.build = function build(type) {
        return type.queryFrom(this);
    };
    _proto.isSupported = function isSupported(field) {
        if (field == null) return false;
        return this.fieldValues.containsKey(field) && this.fieldValues.get(field) !== undefined || this.date != null && this.date.isSupported(field) || this.time != null && this.time.isSupported(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        var value = this.getFieldValue0(field);
        if (value == null) {
            if (this.date != null && this.date.isSupported(field)) return this.date.getLong(field);
            if (this.time != null && this.time.isSupported(field)) return this.time.getLong(field);
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field not found: " + field);
        }
        return value;
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return this.zone;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.date != null ? $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(this.date) : null;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.time;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return _query.queryFrom(this);
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return null;
        return _query.queryFrom(this);
    };
    return DateTimeBuilder;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$DateTimeParseContext = function() {
    function DateTimeParseContext() {
        if (arguments.length === 1) {
            if (arguments[0] instanceof DateTimeParseContext) {
                this._constructorSelf.apply(this, arguments);
                return;
            } else this._constructorFormatter.apply(this, arguments);
        } else this._constructorParam.apply(this, arguments);
        this._caseSensitive = true;
        this._strict = true;
        this._parsed = [
            new $2e6f1e48aadbcba7$var$Parsed(this)
        ];
    }
    var _proto = DateTimeParseContext.prototype;
    _proto._constructorParam = function _constructorParam(locale, symbols, chronology) {
        this._locale = locale;
        this._symbols = symbols;
        this._overrideChronology = chronology;
    };
    _proto._constructorFormatter = function _constructorFormatter(formatter) {
        this._locale = formatter.locale();
        this._symbols = formatter.decimalStyle();
        this._overrideChronology = formatter.chronology();
    };
    _proto._constructorSelf = function _constructorSelf(other) {
        this._locale = other._locale;
        this._symbols = other._symbols;
        this._overrideChronology = other._overrideChronology;
        this._overrideZone = other._overrideZone;
        this._caseSensitive = other._caseSensitive;
        this._strict = other._strict;
        this._parsed = [
            new $2e6f1e48aadbcba7$var$Parsed(this)
        ];
    };
    _proto.copy = function copy() {
        return new DateTimeParseContext(this);
    };
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.isStrict = function isStrict() {
        return this._strict;
    };
    _proto.setStrict = function setStrict(strict) {
        this._strict = strict;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    _proto.startOptional = function startOptional() {
        this._parsed.push(this.currentParsed().copy());
    };
    _proto.endOptional = function endOptional(successful) {
        if (successful) this._parsed.splice(this._parsed.length - 2, 1);
        else this._parsed.splice(this._parsed.length - 1, 1);
    };
    _proto.isCaseSensitive = function isCaseSensitive() {
        return this._caseSensitive;
    };
    _proto.setCaseSensitive = function setCaseSensitive(caseSensitive) {
        this._caseSensitive = caseSensitive;
    };
    _proto.subSequenceEquals = function subSequenceEquals(cs1, offset1, cs2, offset2, length) {
        if (offset1 + length > cs1.length || offset2 + length > cs2.length) return false;
        if (!this.isCaseSensitive()) {
            cs1 = cs1.toLowerCase();
            cs2 = cs2.toLowerCase();
        }
        for(var i = 0; i < length; i++){
            var ch1 = cs1[offset1 + i];
            var ch2 = cs2[offset2 + i];
            if (ch1 !== ch2) return false;
        }
        return true;
    };
    _proto.charEquals = function charEquals(ch1, ch2) {
        if (this.isCaseSensitive()) return ch1 === ch2;
        return this.charEqualsIgnoreCase(ch1, ch2);
    };
    _proto.charEqualsIgnoreCase = function charEqualsIgnoreCase(c1, c2) {
        return c1 === c2 || c1.toLowerCase() === c2.toLowerCase();
    };
    _proto.setParsedField = function setParsedField(field, value, errorPos, successPos) {
        var currentParsedFieldValues = this.currentParsed().fieldValues;
        var old = currentParsedFieldValues.get(field);
        currentParsedFieldValues.set(field, value);
        return old != null && old !== value ? ~errorPos : successPos;
    };
    _proto.setParsedZone = function setParsedZone(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        this.currentParsed().zone = zone;
    };
    _proto.getParsed = function getParsed(field) {
        return this.currentParsed().fieldValues.get(field);
    };
    _proto.toParsed = function toParsed() {
        return this.currentParsed();
    };
    _proto.currentParsed = function currentParsed() {
        return this._parsed[this._parsed.length - 1];
    };
    _proto.setParsedLeapSecond = function setParsedLeapSecond() {
        this.currentParsed().leapSecond = true;
    };
    _proto.getEffectiveChronology = function getEffectiveChronology() {
        var chrono = this.currentParsed().chrono;
        if (chrono == null) {
            chrono = this._overrideChronology;
            if (chrono == null) chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        }
        return chrono;
    };
    return DateTimeParseContext;
}();
var $2e6f1e48aadbcba7$var$Parsed = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Parsed, _Temporal);
    function Parsed(dateTimeParseContext) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this.chrono = null;
        _this.zone = null;
        _this.fieldValues = new $2e6f1e48aadbcba7$var$EnumMap();
        _this.leapSecond = false;
        _this.dateTimeParseContext = dateTimeParseContext;
        return _this;
    }
    var _proto2 = Parsed.prototype;
    _proto2.copy = function copy() {
        var cloned = new Parsed();
        cloned.chrono = this.chrono;
        cloned.zone = this.zone;
        cloned.fieldValues.putAll(this.fieldValues);
        cloned.leapSecond = this.leapSecond;
        cloned.dateTimeParseContext = this.dateTimeParseContext;
        return cloned;
    };
    _proto2.toString = function toString() {
        return this.fieldValues + ", " + this.chrono + ", " + this.zone;
    };
    _proto2.isSupported = function isSupported(field) {
        return this.fieldValues.containsKey(field);
    };
    _proto2.get = function get(field) {
        var val = this.fieldValues.get(field);
        $2e6f1e48aadbcba7$var$assert(val != null);
        return val;
    };
    _proto2.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chrono;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.zone;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto2.toBuilder = function toBuilder() {
        var builder = new $2e6f1e48aadbcba7$var$DateTimeBuilder();
        builder.fieldValues.putAll(this.fieldValues);
        builder.chrono = this.dateTimeParseContext.getEffectiveChronology();
        if (this.zone != null) builder.zone = this.zone;
        else builder.zone = this.overrideZone;
        builder.leapSecond = this.leapSecond;
        builder.excessDays = this.excessDays;
        return builder;
    };
    return Parsed;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$DateTimePrintContext = function() {
    function DateTimePrintContext(temporal, localeOrFormatter, symbols) {
        if (arguments.length === 2 && arguments[1] instanceof $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c) {
            this._temporal = DateTimePrintContext.adjust(temporal, localeOrFormatter);
            this._locale = localeOrFormatter.locale();
            this._symbols = localeOrFormatter.decimalStyle();
        } else {
            this._temporal = temporal;
            this._locale = localeOrFormatter;
            this._symbols = symbols;
        }
        this._optional = 0;
    }
    DateTimePrintContext.adjust = function adjust(temporal, formatter) {
        return temporal;
    };
    var _proto = DateTimePrintContext.prototype;
    _proto.symbols = function symbols() {
        return this._symbols;
    };
    _proto.startOptional = function startOptional() {
        this._optional++;
    };
    _proto.endOptional = function endOptional() {
        this._optional--;
    };
    _proto.getValueQuery = function getValueQuery(query) {
        var result = this._temporal.query(query);
        if (result == null && this._optional === 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to extract value: " + this._temporal);
        return result;
    };
    _proto.getValue = function getValue(field) {
        try {
            return this._temporal.getLong(field);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb && this._optional > 0) return null;
            throw ex;
        }
    };
    _proto.temporal = function temporal() {
        return this._temporal;
    };
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.setDateTime = function setDateTime(temporal) {
        this._temporal = temporal;
    };
    _proto.setLocale = function setLocale(locale) {
        this._locale = locale;
    };
    return DateTimePrintContext;
}();
var $2e6f1e48aadbcba7$export$2091a0730eb3b2d2 = {};
var $2e6f1e48aadbcba7$var$QUARTER_DAYS = [
    0,
    90,
    181,
    273,
    0,
    91,
    182,
    274
];
var $2e6f1e48aadbcba7$var$Field = function(_TemporalField) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Field, _TemporalField);
    function Field() {
        return _TemporalField.apply(this, arguments) || this;
    }
    var _proto = Field.prototype;
    _proto.isDateBased = function isDateBased() {
        return true;
    };
    _proto.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto._isIso = function _isIso() {
        return true;
    };
    Field._getWeekRangeByLocalDate = function _getWeekRangeByLocalDate(date) {
        var wby = Field._getWeekBasedYear(date);
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, Field._getWeekRangeByYear(wby));
    };
    Field._getWeekRangeByYear = function _getWeekRangeByYear(wby) {
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 1);
        if (date.dayOfWeek() === $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.THURSDAY || date.dayOfWeek() === $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.WEDNESDAY && date.isLeapYear()) return 53;
        return 52;
    };
    Field._getWeek = function _getWeek(date) {
        var dow0 = date.dayOfWeek().ordinal();
        var doy0 = date.dayOfYear() - 1;
        var doyThu0 = doy0 + (3 - dow0);
        var alignedWeek = $2e6f1e48aadbcba7$var$MathUtil.intDiv(doyThu0, 7);
        var firstThuDoy0 = doyThu0 - alignedWeek * 7;
        var firstMonDoy0 = firstThuDoy0 - 3;
        if (firstMonDoy0 < -3) firstMonDoy0 += 7;
        if (doy0 < firstMonDoy0) return Field._getWeekRangeByLocalDate(date.withDayOfYear(180).minusYears(1)).maximum();
        var week = $2e6f1e48aadbcba7$var$MathUtil.intDiv(doy0 - firstMonDoy0, 7) + 1;
        if (week === 53) {
            if ((firstMonDoy0 === -3 || firstMonDoy0 === -2 && date.isLeapYear()) === false) week = 1;
        }
        return week;
    };
    Field._getWeekBasedYear = function _getWeekBasedYear(date) {
        var year = date.year();
        var doy = date.dayOfYear();
        if (doy <= 3) {
            var dow = date.dayOfWeek().ordinal();
            if (doy - dow < -2) year--;
        } else if (doy >= 363) {
            var _dow = date.dayOfWeek().ordinal();
            doy = doy - 363 - (date.isLeapYear() ? 1 : 0);
            if (doy - _dow >= 0) year++;
        }
        return year;
    };
    _proto.displayName = function displayName() {
        return this.toString();
    };
    _proto.resolve = function resolve() {
        return null;
    };
    _proto.name = function name1() {
        return this.toString();
    };
    return Field;
}($2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9);
var $2e6f1e48aadbcba7$var$DAY_OF_QUARTER_FIELD = function(_Field) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DAY_OF_QUARTER_FIELD, _Field);
    function DAY_OF_QUARTER_FIELD() {
        return _Field.apply(this, arguments) || this;
    }
    var _proto2 = DAY_OF_QUARTER_FIELD.prototype;
    _proto2.toString = function toString() {
        return "DayOfQuarter";
    };
    _proto2.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
    };
    _proto2.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    };
    _proto2.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 90, 92);
    };
    _proto2.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR) && temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) && temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) && this._isIso(temporal);
    };
    _proto2.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: DayOfQuarter");
        var qoy = temporal.getLong($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        if (qoy === 1) {
            var year = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
            return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 91) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 90);
        } else if (qoy === 2) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 91);
        else if (qoy === 3 || qoy === 4) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 92);
        return this.range();
    };
    _proto2.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: DayOfQuarter");
        var doy = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR);
        var moy = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var year = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        return doy - $2e6f1e48aadbcba7$var$QUARTER_DAYS[$2e6f1e48aadbcba7$var$MathUtil.intDiv(moy - 1, 3) + ($2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 4 : 0)];
    };
    _proto2.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR) + (newValue - curValue));
    };
    _proto2.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var yearLong = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        var qoyLong = fieldValues.get($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        if (yearLong == null || qoyLong == null) return null;
        var y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(yearLong);
        var doq = fieldValues.get($2e6f1e48aadbcba7$var$DAY_OF_QUARTER);
        var date;
        if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            var qoy = qoyLong;
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, 1, 1);
            date = date.plusMonths($2e6f1e48aadbcba7$var$MathUtil.safeMultiply($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(qoy, 1), 3));
            date = date.plusDays($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(doq, 1));
        } else {
            var _qoy = $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR.range().checkValidIntValue(qoyLong, $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
            if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                var max = 92;
                if (_qoy === 1) max = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(y) ? 91 : 90;
                else if (_qoy === 2) max = 91;
                $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, max).checkValidValue(doq, this);
            } else this.range().checkValidValue(doq, this);
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, (_qoy - 1) * 3 + 1, 1).plusDays(doq - 1);
        }
        fieldValues.remove(this);
        fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        fieldValues.remove($2e6f1e48aadbcba7$var$QUARTER_OF_YEAR);
        return date;
    };
    return DAY_OF_QUARTER_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR_FIELD = function(_Field2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(QUARTER_OF_YEAR_FIELD, _Field2);
    function QUARTER_OF_YEAR_FIELD() {
        return _Field2.apply(this, arguments) || this;
    }
    var _proto3 = QUARTER_OF_YEAR_FIELD.prototype;
    _proto3.toString = function toString() {
        return "QuarterOfYear";
    };
    _proto3.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    };
    _proto3.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS;
    };
    _proto3.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 4);
    };
    _proto3.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) && this._isIso(temporal);
    };
    _proto3.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return this.range();
    };
    _proto3.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: QuarterOfYear");
        var moy = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(moy + 2, 3);
    };
    _proto3.adjustInto = function adjustInto(temporal, newValue) {
        var curValue = this.getFrom(temporal);
        this.range().checkValidValue(newValue, this);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) + (newValue - curValue) * 3);
    };
    return QUARTER_OF_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR_FIELD = function(_Field3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(WEEK_OF_WEEK_BASED_YEAR_FIELD, _Field3);
    function WEEK_OF_WEEK_BASED_YEAR_FIELD() {
        return _Field3.apply(this, arguments) || this;
    }
    var _proto4 = WEEK_OF_WEEK_BASED_YEAR_FIELD.prototype;
    _proto4.toString = function toString() {
        return "WeekOfWeekBasedYear";
    };
    _proto4.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS;
    };
    _proto4.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    };
    _proto4.range = function range() {
        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, 52, 53);
    };
    _proto4.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto4.rangeRefinedBy = function rangeRefinedBy(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: WeekOfWeekBasedYear");
        return $2e6f1e48aadbcba7$var$Field._getWeekRangeByLocalDate($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: WeekOfWeekBasedYear");
        return $2e6f1e48aadbcba7$var$Field._getWeek($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto4.adjustInto = function adjustInto(temporal, newValue) {
        this.range().checkValidValue(newValue, this);
        return temporal.plus($2e6f1e48aadbcba7$var$MathUtil.safeSubtract(newValue, this.getFrom(temporal)), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS);
    };
    _proto4.resolve = function resolve(fieldValues, partialTemporal, resolverStyle) {
        var wbyLong = fieldValues.get($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var dowLong = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (wbyLong == null || dowLong == null) return null;
        var wby = $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR.range().checkValidIntValue(wbyLong, $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var wowby = fieldValues.get($2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR);
        var date;
        if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
            var dow = dowLong;
            var weeks = 0;
            if (dow > 7) {
                weeks = $2e6f1e48aadbcba7$var$MathUtil.intDiv(dow - 1, 7);
                dow = $2e6f1e48aadbcba7$var$MathUtil.intMod(dow - 1, 7) + 1;
            } else if (dow < 1) {
                weeks = $2e6f1e48aadbcba7$var$MathUtil.intDiv(dow, 7) - 1;
                dow = $2e6f1e48aadbcba7$var$MathUtil.intMod(dow, 7) + 7;
            }
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).plusWeeks(weeks).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, dow);
        } else {
            var _dow2 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(dowLong);
            if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                var temp = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4);
                var range = $2e6f1e48aadbcba7$var$Field._getWeekRangeByLocalDate(temp);
                range.checkValidValue(wowby, this);
            } else this.range().checkValidValue(wowby, this);
            date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(wby, 1, 4).plusWeeks(wowby - 1).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK, _dow2);
        }
        fieldValues.remove(this);
        fieldValues.remove($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        return date;
    };
    _proto4.displayName = function displayName() {
        return "Week";
    };
    return WEEK_OF_WEEK_BASED_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR_FIELD = function(_Field4) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(WEEK_BASED_YEAR_FIELD, _Field4);
    function WEEK_BASED_YEAR_FIELD() {
        return _Field4.apply(this, arguments) || this;
    }
    var _proto5 = WEEK_BASED_YEAR_FIELD.prototype;
    _proto5.toString = function toString() {
        return "WeekBasedYear";
    };
    _proto5.baseUnit = function baseUnit() {
        return $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    };
    _proto5.rangeUnit = function rangeUnit() {
        return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.FOREVER;
    };
    _proto5.range = function range() {
        return $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY) && this._isIso(temporal);
    };
    _proto5.rangeRefinedBy = function rangeRefinedBy(temporal) {
        return $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.range();
    };
    _proto5.getFrom = function getFrom(temporal) {
        if (temporal.isSupported(this) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: WeekBasedYear");
        return $2e6f1e48aadbcba7$var$Field._getWeekBasedYear($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal));
    };
    _proto5.adjustInto = function adjustInto(temporal, newValue) {
        if (this.isSupportedBy(temporal) === false) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: WeekBasedYear");
        var newWby = this.range().checkValidIntValue(newValue, $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR);
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
        var dow = date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        var week = $2e6f1e48aadbcba7$var$Field._getWeek(date);
        if (week === 53 && $2e6f1e48aadbcba7$var$Field._getWeekRangeByYear(newWby) === 52) week = 52;
        var resolved = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(newWby, 1, 4);
        var days = dow - resolved.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK) + (week - 1) * 7;
        resolved = resolved.plusDays(days);
        return temporal.with(resolved);
    };
    return WEEK_BASED_YEAR_FIELD;
}($2e6f1e48aadbcba7$var$Field);
var $2e6f1e48aadbcba7$var$Unit = function(_TemporalUnit) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Unit, _TemporalUnit);
    function Unit(name1, estimatedDuration) {
        var _this;
        _this = _TemporalUnit.call(this) || this;
        _this._name = name1;
        _this._duration = estimatedDuration;
        return _this;
    }
    var _proto6 = Unit.prototype;
    _proto6.duration = function duration() {
        return this._duration;
    };
    _proto6.isDurationEstimated = function isDurationEstimated() {
        return true;
    };
    _proto6.isDateBased = function isDateBased() {
        return true;
    };
    _proto6.isTimeBased = function isTimeBased() {
        return false;
    };
    _proto6.isSupportedBy = function isSupportedBy(temporal) {
        return temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY);
    };
    _proto6.addTo = function addTo(temporal, periodToAdd) {
        switch(this){
            case $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS:
                var added = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(temporal.get($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR), periodToAdd);
                return temporal.with($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR, added);
            case $2e6f1e48aadbcba7$var$QUARTER_YEARS:
                return temporal.plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(periodToAdd, 256), $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS).plus($2e6f1e48aadbcba7$var$MathUtil.intMod(periodToAdd, 256) * 3, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            default:
                throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e("Unreachable");
        }
    };
    _proto6.between = function between(temporal1, temporal2) {
        switch(this){
            case $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS:
                return $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(temporal2.getLong($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR), temporal1.getLong($2e6f1e48aadbcba7$var$WEEK_BASED_YEAR));
            case $2e6f1e48aadbcba7$var$QUARTER_YEARS:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(temporal1.until(temporal2, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS), 3);
            default:
                throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e("Unreachable");
        }
    };
    _proto6.toString = function toString() {
        return name;
    };
    return Unit;
}($2e6f1e48aadbcba7$export$5d412a4bb789788e);
var $2e6f1e48aadbcba7$var$DAY_OF_QUARTER = null;
var $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR = null;
var $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS = null;
var $2e6f1e48aadbcba7$var$QUARTER_YEARS = null;
function $2e6f1e48aadbcba7$var$_init$8() {
    $2e6f1e48aadbcba7$var$DAY_OF_QUARTER = new $2e6f1e48aadbcba7$var$DAY_OF_QUARTER_FIELD();
    $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR = new $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR = new $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR = new $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR_FIELD();
    $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS = new $2e6f1e48aadbcba7$var$Unit("WeekBasedYears", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(31556952));
    $2e6f1e48aadbcba7$var$QUARTER_YEARS = new $2e6f1e48aadbcba7$var$Unit("QuarterYears", $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(7889238));
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.DAY_OF_QUARTER = $2e6f1e48aadbcba7$var$DAY_OF_QUARTER;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR = $2e6f1e48aadbcba7$var$QUARTER_OF_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR = $2e6f1e48aadbcba7$var$WEEK_OF_WEEK_BASED_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEAR = $2e6f1e48aadbcba7$var$WEEK_BASED_YEAR;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEARS = $2e6f1e48aadbcba7$var$WEEK_BASED_YEARS;
    $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_YEARS = $2e6f1e48aadbcba7$var$QUARTER_YEARS;
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.prototype.isoWeekOfWeekyear = function() {
        return this.get($2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_OF_WEEK_BASED_YEAR);
    };
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.prototype.isoWeekyear = function() {
        return this.get($2e6f1e48aadbcba7$export$2091a0730eb3b2d2.WEEK_BASED_YEAR);
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$c1929c59b9e7d355 = function() {
    function DecimalStyle(zeroChar, positiveSignChar, negativeSignChar, decimalPointChar) {
        this._zeroDigit = zeroChar;
        this._zeroDigitCharCode = zeroChar.charCodeAt(0);
        this._positiveSign = positiveSignChar;
        this._negativeSign = negativeSignChar;
        this._decimalSeparator = decimalPointChar;
    }
    var _proto = DecimalStyle.prototype;
    _proto.positiveSign = function positiveSign() {
        return this._positiveSign;
    };
    _proto.withPositiveSign = function withPositiveSign(positiveSign) {
        if (positiveSign === this._positiveSign) return this;
        return new DecimalStyle(this._zeroDigit, positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.negativeSign = function negativeSign() {
        return this._negativeSign;
    };
    _proto.withNegativeSign = function withNegativeSign(negativeSign) {
        if (negativeSign === this._negativeSign) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, negativeSign, this._decimalSeparator);
    };
    _proto.zeroDigit = function zeroDigit() {
        return this._zeroDigit;
    };
    _proto.withZeroDigit = function withZeroDigit(zeroDigit) {
        if (zeroDigit === this._zeroDigit) return this;
        return new DecimalStyle(zeroDigit, this._positiveSign, this._negativeSign, this._decimalSeparator);
    };
    _proto.decimalSeparator = function decimalSeparator() {
        return this._decimalSeparator;
    };
    _proto.withDecimalSeparator = function withDecimalSeparator(decimalSeparator) {
        if (decimalSeparator === this._decimalSeparator) return this;
        return new DecimalStyle(this._zeroDigit, this._positiveSign, this._negativeSign, decimalSeparator);
    };
    _proto.convertToDigit = function convertToDigit(char) {
        var val = char.charCodeAt(0) - this._zeroDigitCharCode;
        return val >= 0 && val <= 9 ? val : -1;
    };
    _proto.convertNumberToI18N = function convertNumberToI18N(numericText) {
        if (this._zeroDigit === "0") return numericText;
        var diff = this._zeroDigitCharCode - "0".charCodeAt(0);
        var convertedText = "";
        for(var i = 0; i < numericText.length; i++)convertedText += String.fromCharCode(numericText.charCodeAt(i) + diff);
        return convertedText;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof DecimalStyle) return this._zeroDigit === other._zeroDigit && this._positiveSign === other._positiveSign && this._negativeSign === other._negativeSign && this._decimalSeparator === other._decimalSeparator;
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator;
    };
    _proto.toString = function toString() {
        return "DecimalStyle[" + this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator + "]";
    };
    DecimalStyle.of = function of() {
        throw new Error("not yet supported");
    };
    DecimalStyle.availableLocales = function availableLocales() {
        throw new Error("not yet supported");
    };
    return DecimalStyle;
}();
$2e6f1e48aadbcba7$export$c1929c59b9e7d355.STANDARD = new $2e6f1e48aadbcba7$export$c1929c59b9e7d355("0", "+", "-", ".");
var $2e6f1e48aadbcba7$export$b2e3a42c433c0b35 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SignStyle, _Enum);
    function SignStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SignStyle.prototype;
    _proto.parse = function parse(positive, strict, fixedWidth) {
        switch(this){
            case SignStyle.NORMAL:
                return !positive || !strict;
            case SignStyle.ALWAYS:
            case SignStyle.EXCEEDS_PAD:
                return true;
            default:
                return !strict && !fixedWidth;
        }
    };
    return SignStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35("NORMAL");
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NEVER = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35("NEVER");
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35("ALWAYS");
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35("EXCEEDS_PAD");
$2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE = new $2e6f1e48aadbcba7$export$b2e3a42c433c0b35("NOT_NEGATIVE");
var $2e6f1e48aadbcba7$export$1df879243bf2e42d = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(TextStyle, _Enum);
    function TextStyle() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = TextStyle.prototype;
    _proto.isStandalone = function isStandalone() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
            case TextStyle.SHORT_STANDALONE:
            case TextStyle.NARROW_STANDALONE:
                return true;
            default:
                return false;
        }
    };
    _proto.asStandalone = function asStandalone() {
        switch(this){
            case TextStyle.FULL:
                return TextStyle.FULL_STANDALONE;
            case TextStyle.SHORT:
                return TextStyle.SHORT_STANDALONE;
            case TextStyle.NARROW:
                return TextStyle.NARROW_STANDALONE;
            default:
                return this;
        }
    };
    _proto.asNormal = function asNormal() {
        switch(this){
            case TextStyle.FULL_STANDALONE:
                return TextStyle.FULL;
            case TextStyle.SHORT_STANDALONE:
                return TextStyle.SHORT;
            case TextStyle.NARROW_STANDALONE:
                return TextStyle.NARROW;
            default:
                return this;
        }
    };
    return TextStyle;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("FULL");
$2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("FULL_STANDALONE");
$2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("SHORT");
$2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("SHORT_STANDALONE");
$2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("NARROW");
$2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE = new $2e6f1e48aadbcba7$export$1df879243bf2e42d("NARROW_STANDALONE");
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$CharLiteralPrinterParser = function() {
    function CharLiteralPrinterParser(literal) {
        if (literal.length > 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f('invalid literal, too long: "' + literal + '"');
        this._literal = literal;
    }
    var _proto = CharLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        var ch = text.charAt(position);
        if (context.charEquals(this._literal, ch) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        if (this._literal === "'") return "''";
        return "'" + this._literal + "'";
    };
    return CharLiteralPrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$CompositePrinterParser = function() {
    function CompositePrinterParser(printerParsers, optional) {
        this._printerParsers = printerParsers;
        this._optional = optional;
    }
    var _proto = CompositePrinterParser.prototype;
    _proto.withOptional = function withOptional(optional) {
        if (optional === this._optional) return this;
        return new CompositePrinterParser(this._printerParsers, optional);
    };
    _proto.print = function print(context, buf) {
        var length = buf.length();
        if (this._optional) context.startOptional();
        try {
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                if (pp.print(context, buf) === false) {
                    buf.setLength(length);
                    return true;
                }
            }
        } finally{
            if (this._optional) context.endOptional();
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        if (this._optional) {
            context.startOptional();
            var pos = position;
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                pos = pp.parse(context, text, pos);
                if (pos < 0) {
                    context.endOptional(false);
                    return position;
                }
            }
            context.endOptional(true);
            return pos;
        } else {
            for(var _i = 0; _i < this._printerParsers.length; _i++){
                var _pp = this._printerParsers[_i];
                position = _pp.parse(context, text, position);
                if (position < 0) break;
            }
            return position;
        }
    };
    _proto.toString = function toString() {
        var buf = "";
        if (this._printerParsers != null) {
            buf += this._optional ? "[" : "(";
            for(var i = 0; i < this._printerParsers.length; i++){
                var pp = this._printerParsers[i];
                buf += pp.toString();
            }
            buf += this._optional ? "]" : ")";
        }
        return buf;
    };
    return CompositePrinterParser;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$FractionPrinterParser = function() {
    function FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field.range().isFixed() === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Field must have a fixed set of values: " + field);
        if (minWidth < 0 || minWidth > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Minimum width must be from 0 to 9 inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Maximum width must be from 1 to 9 inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        this.field = field;
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
        this.decimalPoint = decimalPoint;
    }
    var _proto = FractionPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var value = context.getValue(this.field);
        if (value === null) return false;
        var symbols = context.symbols();
        if (value === 0) {
            if (this.minWidth > 0) {
                if (this.decimalPoint) buf.append(symbols.decimalSeparator());
                for(var i = 0; i < this.minWidth; i++)buf.append(symbols.zeroDigit());
            }
        } else {
            var fraction = this.convertToFraction(value, symbols.zeroDigit());
            var outputScale = Math.min(Math.max(fraction.length, this.minWidth), this.maxWidth);
            fraction = fraction.substr(0, outputScale);
            if (fraction * 1 > 0) while(fraction.length > this.minWidth && fraction[fraction.length - 1] === "0")fraction = fraction.substr(0, fraction.length - 1);
            var str = fraction;
            str = symbols.convertNumberToI18N(str);
            if (this.decimalPoint) buf.append(symbols.decimalSeparator());
            buf.append(str);
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var effectiveMin = context.isStrict() ? this.minWidth : 0;
        var effectiveMax = context.isStrict() ? this.maxWidth : 9;
        var length = text.length;
        if (position === length) return effectiveMin > 0 ? ~position : position;
        if (this.decimalPoint) {
            if (text[position] !== context.symbols().decimalSeparator()) return effectiveMin > 0 ? ~position : position;
            position++;
        }
        var minEndPos = position + effectiveMin;
        if (minEndPos > length) return ~position;
        var maxEndPos = Math.min(position + effectiveMax, length);
        var total = 0;
        var pos = position;
        while(pos < maxEndPos){
            var ch = text.charAt(pos++);
            var digit = context.symbols().convertToDigit(ch);
            if (digit < 0) {
                if (pos < minEndPos) return ~position;
                pos--;
                break;
            }
            total = total * 10 + digit;
        }
        var moveLeft = pos - position;
        var scale = Math.pow(10, moveLeft);
        var value = this.convertFromFraction(total, scale);
        return context.setParsedField(this.field, value, position, pos);
    };
    _proto.convertToFraction = function convertToFraction(value, zeroDigit) {
        var range = this.field.range();
        range.checkValidValue(value, this.field);
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = value - _min;
        var _scaled = $2e6f1e48aadbcba7$var$MathUtil.intDiv(_value * 1000000000, _range);
        var fraction = "" + _scaled;
        while(fraction.length < 9)fraction = zeroDigit + fraction;
        return fraction;
    };
    _proto.convertFromFraction = function convertFromFraction(total, scale) {
        var range = this.field.range();
        var _min = range.minimum();
        var _range = range.maximum() - _min + 1;
        var _value = $2e6f1e48aadbcba7$var$MathUtil.intDiv(total * _range, scale);
        return _value;
    };
    _proto.toString = function toString() {
        var decimal = this.decimalPoint ? ",DecimalPoint" : "";
        return "Fraction(" + this.field + "," + this.minWidth + "," + this.maxWidth + decimal + ")";
    };
    return FractionPrinterParser;
}();
var $2e6f1e48aadbcba7$var$MAX_WIDTH = 15;
var $2e6f1e48aadbcba7$var$EXCEED_POINTS = [
    0,
    10,
    100,
    1000,
    10000,
    100000,
    1000000,
    10000000,
    100000000,
    1000000000
];
var $2e6f1e48aadbcba7$var$NumberPrinterParser = function() {
    function NumberPrinterParser(field, minWidth, maxWidth, signStyle, subsequentWidth) {
        if (subsequentWidth === void 0) subsequentWidth = 0;
        this._field = field;
        this._minWidth = minWidth;
        this._maxWidth = maxWidth;
        this._signStyle = signStyle;
        this._subsequentWidth = subsequentWidth;
    }
    var _proto = NumberPrinterParser.prototype;
    _proto.field = function field() {
        return this._field;
    };
    _proto.minWidth = function minWidth() {
        return this._minWidth;
    };
    _proto.maxWidth = function maxWidth() {
        return this._maxWidth;
    };
    _proto.signStyle = function signStyle() {
        return this._signStyle;
    };
    _proto.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, -1);
    };
    _proto.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new NumberPrinterParser(this._field, this._minWidth, this._maxWidth, this._signStyle, this._subsequentWidth + subsequentWidth);
    };
    _proto._isFixedWidth = function _isFixedWidth() {
        return this._subsequentWidth === -1 || this._subsequentWidth > 0 && this._minWidth === this._maxWidth && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE;
    };
    _proto.print = function print(context, buf) {
        var contextValue = context.getValue(this._field);
        if (contextValue == null) return false;
        var value = this._getValue(context, contextValue);
        var symbols = context.symbols();
        var str = "" + Math.abs(value);
        if (str.length > this._maxWidth) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " exceeds the maximum print width of " + this._maxWidth);
        str = symbols.convertNumberToI18N(str);
        if (value >= 0) switch(this._signStyle){
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD:
                if (this._minWidth < $2e6f1e48aadbcba7$var$MAX_WIDTH && value >= $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth]) buf.append(symbols.positiveSign());
                break;
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.positiveSign());
                break;
        }
        else switch(this._signStyle){
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL:
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD:
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS:
                buf.append(symbols.negativeSign());
                break;
            case $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE:
                throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field " + this._field + " cannot be printed as the value " + value + " cannot be negative according to the SignStyle");
        }
        for(var i = 0; i < this._minWidth - str.length; i++)buf.append(symbols.zeroDigit());
        buf.append(str);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position === length) return ~position;
        $2e6f1e48aadbcba7$var$assert(position >= 0 && position < length);
        var sign = text.charAt(position);
        var negative = false;
        var positive = false;
        if (sign === context.symbols().positiveSign()) {
            if (this._signStyle.parse(true, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            positive = true;
            position++;
        } else if (sign === context.symbols().negativeSign()) {
            if (this._signStyle.parse(false, context.isStrict(), this._minWidth === this._maxWidth) === false) return ~position;
            negative = true;
            position++;
        } else {
            if (this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.ALWAYS && context.isStrict()) return ~position;
        }
        var effMinWidth = context.isStrict() || this._isFixedWidth() ? this._minWidth : 1;
        var minEndPos = position + effMinWidth;
        if (minEndPos > length) return ~position;
        var effMaxWidth = (context.isStrict() || this._isFixedWidth() ? this._maxWidth : 9) + Math.max(this._subsequentWidth, 0);
        var total = 0;
        var pos = position;
        for(var pass = 0; pass < 2; pass++){
            var maxEndPos = Math.min(pos + effMaxWidth, length);
            while(pos < maxEndPos){
                var ch = text.charAt(pos++);
                var digit = context.symbols().convertToDigit(ch);
                if (digit < 0) {
                    pos--;
                    if (pos < minEndPos) return ~position;
                    break;
                }
                if (pos - position > $2e6f1e48aadbcba7$var$MAX_WIDTH) throw new $2e6f1e48aadbcba7$export$5891bcae38b5fd67("number text exceeds length");
                else total = total * 10 + digit;
            }
            if (this._subsequentWidth > 0 && pass === 0) {
                var parseLen = pos - position;
                effMaxWidth = Math.max(effMinWidth, parseLen - this._subsequentWidth);
                pos = position;
                total = 0;
            } else break;
        }
        if (negative) {
            if (total === 0 && context.isStrict()) return ~(position - 1);
            if (total !== 0) total = -total;
        } else if (this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD && context.isStrict()) {
            var _parseLen = pos - position;
            if (positive) {
                if (_parseLen <= this._minWidth) return ~(position - 1);
            } else {
                if (_parseLen > this._minWidth) return ~position;
            }
        }
        return this._setValue(context, total, position, pos);
    };
    _proto._getValue = function _getValue(context, value) {
        return value;
    };
    _proto._setValue = function _setValue(context, value, errorPos, successPos) {
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto.toString = function toString() {
        if (this._minWidth === 1 && this._maxWidth === $2e6f1e48aadbcba7$var$MAX_WIDTH && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL) return "Value(" + this._field + ")";
        if (this._minWidth === this._maxWidth && this._signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) return "Value(" + this._field + "," + this._minWidth + ")";
        return "Value(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + this._signStyle + ")";
    };
    return NumberPrinterParser;
}();
var $2e6f1e48aadbcba7$var$ReducedPrinterParser = function(_NumberPrinterParser) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ReducedPrinterParser, _NumberPrinterParser);
    function ReducedPrinterParser(field, width, maxWidth, baseValue, baseDate) {
        var _this;
        _this = _NumberPrinterParser.call(this, field, width, maxWidth, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) || this;
        if (width < 1 || width > 10) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The width must be from 1 to 10 inclusive but was " + width);
        if (maxWidth < 1 || maxWidth > 10) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The maxWidth must be from 1 to 10 inclusive but was " + maxWidth);
        if (maxWidth < width) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The maxWidth must be greater than the width");
        if (baseDate === null) {
            if (field.range().isValidValue(baseValue) === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The base value must be within the range of the field");
            if (baseValue + $2e6f1e48aadbcba7$var$EXCEED_POINTS[width] > $2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to add printer-parser as the range exceeds the capacity of an int");
        }
        _this._baseValue = baseValue;
        _this._baseDate = baseDate;
        return _this;
    }
    var _proto2 = ReducedPrinterParser.prototype;
    _proto2._getValue = function _getValue(context, value) {
        var absValue = Math.abs(value);
        var baseValue = this._baseValue;
        if (this._baseDate !== null) {
            context.temporal();
            var chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        if (value >= baseValue && value < baseValue + $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth]) return absValue % $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth];
        return absValue % $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._maxWidth];
    };
    _proto2._setValue = function _setValue(context, value, errorPos, successPos) {
        var baseValue = this._baseValue;
        if (this._baseDate != null) {
            var chrono = context.getEffectiveChronology();
            baseValue = chrono.date(this._baseDate).get(this._field);
        }
        var parseLen = successPos - errorPos;
        if (parseLen === this._minWidth && value >= 0) {
            var range = $2e6f1e48aadbcba7$var$EXCEED_POINTS[this._minWidth];
            var lastPart = baseValue % range;
            var basePart = baseValue - lastPart;
            if (baseValue > 0) value = basePart + value;
            else value = basePart - value;
            if (value < baseValue) value += range;
        }
        return context.setParsedField(this._field, value, errorPos, successPos);
    };
    _proto2.withFixedWidth = function withFixedWidth() {
        if (this._subsequentWidth === -1) return this;
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, -1);
    };
    _proto2.withSubsequentWidth = function withSubsequentWidth(subsequentWidth) {
        return new ReducedPrinterParser(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, this._subsequentWidth + subsequentWidth);
    };
    _proto2.isFixedWidth = function isFixedWidth(context) {
        if (context.isStrict() === false) return false;
        return _NumberPrinterParser.prototype.isFixedWidth.call(this, context);
    };
    _proto2.toString = function toString() {
        return "ReducedValue(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + (this._baseDate != null ? this._baseDate : this._baseValue) + ")";
    };
    return ReducedPrinterParser;
}($2e6f1e48aadbcba7$var$NumberPrinterParser);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$PATTERNS = [
    "+HH",
    "+HHmm",
    "+HH:mm",
    "+HHMM",
    "+HH:MM",
    "+HHMMss",
    "+HH:MM:ss",
    "+HHMMSS",
    "+HH:MM:SS"
];
var $2e6f1e48aadbcba7$var$OffsetIdPrinterParser = function() {
    function OffsetIdPrinterParser(noOffsetText, pattern) {
        $2e6f1e48aadbcba7$var$requireNonNull(noOffsetText, "noOffsetText");
        $2e6f1e48aadbcba7$var$requireNonNull(pattern, "pattern");
        this.noOffsetText = noOffsetText;
        this.type = this._checkPattern(pattern);
    }
    var _proto = OffsetIdPrinterParser.prototype;
    _proto._checkPattern = function _checkPattern(pattern) {
        for(var i = 0; i < $2e6f1e48aadbcba7$var$PATTERNS.length; i++){
            if ($2e6f1e48aadbcba7$var$PATTERNS[i] === pattern) return i;
        }
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid zone offset pattern: " + pattern);
    };
    _proto.print = function print(context, buf) {
        var offsetSecs = context.getValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
        if (offsetSecs == null) return false;
        var totalSecs = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(offsetSecs);
        if (totalSecs === 0) buf.append(this.noOffsetText);
        else {
            var absHours = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(totalSecs, 3600), 100));
            var absMinutes = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(totalSecs, 60), 60));
            var absSeconds = Math.abs($2e6f1e48aadbcba7$var$MathUtil.intMod(totalSecs, 60));
            var bufPos = buf.length();
            var output = absHours;
            buf.append(totalSecs < 0 ? "-" : "+").appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absHours, 10) + "0").appendChar($2e6f1e48aadbcba7$var$MathUtil.intMod(absHours, 10) + "0");
            if (this.type >= 3 || this.type >= 1 && absMinutes > 0) {
                buf.append(this.type % 2 === 0 ? ":" : "").appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absMinutes, 10) + "0").appendChar(absMinutes % 10 + "0");
                output += absMinutes;
                if (this.type >= 7 || this.type >= 5 && absSeconds > 0) {
                    buf.append(this.type % 2 === 0 ? ":" : "").appendChar($2e6f1e48aadbcba7$var$MathUtil.intDiv(absSeconds, 10) + "0").appendChar(absSeconds % 10 + "0");
                    output += absSeconds;
                }
            }
            if (output === 0) {
                buf.setLength(bufPos);
                buf.append(this.noOffsetText);
            }
        }
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        var noOffsetLen = this.noOffsetText.length;
        if (noOffsetLen === 0) {
            if (position === length) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position);
        } else {
            if (position === length) return ~position;
            if (context.subSequenceEquals(text, position, this.noOffsetText, 0, noOffsetLen)) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        }
        var sign = text[position];
        if (sign === "+" || sign === "-") {
            var negative = sign === "-" ? -1 : 1;
            var array = [
                0,
                0,
                0,
                0
            ];
            array[0] = position + 1;
            if ((this._parseNumber(array, 1, text, true) || this._parseNumber(array, 2, text, this.type >= 3) || this._parseNumber(array, 3, text, false)) === false) {
                var offsetSecs = $2e6f1e48aadbcba7$var$MathUtil.safeZero(negative * (array[1] * 3600 + array[2] * 60 + array[3]));
                return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, offsetSecs, position, array[0]);
            }
        }
        if (noOffsetLen === 0) return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, 0, position, position + noOffsetLen);
        return ~position;
    };
    _proto._parseNumber = function _parseNumber(array, arrayIndex, parseText, required) {
        if ((this.type + 3) / 2 < arrayIndex) return false;
        var pos = array[0];
        if (this.type % 2 === 0 && arrayIndex > 1) {
            if (pos + 1 > parseText.length || parseText[pos] !== ":") return required;
            pos++;
        }
        if (pos + 2 > parseText.length) return required;
        var ch1 = parseText[pos++];
        var ch2 = parseText[pos++];
        if (ch1 < "0" || ch1 > "9" || ch2 < "0" || ch2 > "9") return required;
        var value = (ch1.charCodeAt(0) - 48) * 10 + (ch2.charCodeAt(0) - 48);
        if (value < 0 || value > 59) return required;
        array[arrayIndex] = value;
        array[0] = pos;
        return false;
    };
    _proto.toString = function toString() {
        var converted = this.noOffsetText.replace("'", "''");
        return "Offset(" + $2e6f1e48aadbcba7$var$PATTERNS[this.type] + ",'" + converted + "')";
    };
    return OffsetIdPrinterParser;
}();
$2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID = new $2e6f1e48aadbcba7$var$OffsetIdPrinterParser("Z", "+HH:MM:ss");
$2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS = $2e6f1e48aadbcba7$var$PATTERNS;
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$PadPrinterParserDecorator = function() {
    function PadPrinterParserDecorator(printerParser, padWidth, padChar) {
        this._printerParser = printerParser;
        this._padWidth = padWidth;
        this._padChar = padChar;
    }
    var _proto = PadPrinterParserDecorator.prototype;
    _proto.print = function print(context, buf) {
        var preLen = buf.length();
        if (this._printerParser.print(context, buf) === false) return false;
        var len = buf.length() - preLen;
        if (len > this._padWidth) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Cannot print as output of " + len + " characters exceeds pad width of " + this._padWidth);
        for(var i = 0; i < this._padWidth - len; i++)buf.insert(preLen, this._padChar);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var strict = context.isStrict();
        var caseSensitive = context.isCaseSensitive();
        $2e6f1e48aadbcba7$var$assert(!(position > text.length));
        $2e6f1e48aadbcba7$var$assert(position >= 0);
        if (position === text.length) return ~position;
        var endPos = position + this._padWidth;
        if (endPos > text.length) {
            if (strict) return ~position;
            endPos = text.length;
        }
        var pos = position;
        while(pos < endPos && (caseSensitive ? text[pos] === this._padChar : context.charEquals(text[pos], this._padChar)))pos++;
        text = text.substring(0, endPos);
        var resultPos = this._printerParser.parse(context, text, pos);
        if (resultPos !== endPos && strict) return ~(position + pos);
        return resultPos;
    };
    _proto.toString = function toString() {
        return "Pad(" + this._printerParser + "," + this._padWidth + (this._padChar === " " ? ")" : ",'" + this._padChar + "')");
    };
    return PadPrinterParserDecorator;
}();
var $2e6f1e48aadbcba7$var$SettingsParser = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SettingsParser, _Enum);
    function SettingsParser() {
        return _Enum.apply(this, arguments) || this;
    }
    var _proto = SettingsParser.prototype;
    _proto.print = function print() {
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        switch(this){
            case SettingsParser.SENSITIVE:
                context.setCaseSensitive(true);
                break;
            case SettingsParser.INSENSITIVE:
                context.setCaseSensitive(false);
                break;
            case SettingsParser.STRICT:
                context.setStrict(true);
                break;
            case SettingsParser.LENIENT:
                context.setStrict(false);
                break;
        }
        return position;
    };
    _proto.toString = function toString() {
        switch(this){
            case SettingsParser.SENSITIVE:
                return "ParseCaseSensitive(true)";
            case SettingsParser.INSENSITIVE:
                return "ParseCaseSensitive(false)";
            case SettingsParser.STRICT:
                return "ParseStrict(true)";
            case SettingsParser.LENIENT:
                return "ParseStrict(false)";
        }
    };
    return SettingsParser;
}($2e6f1e48aadbcba7$var$Enum);
$2e6f1e48aadbcba7$var$SettingsParser.SENSITIVE = new $2e6f1e48aadbcba7$var$SettingsParser("SENSITIVE");
$2e6f1e48aadbcba7$var$SettingsParser.INSENSITIVE = new $2e6f1e48aadbcba7$var$SettingsParser("INSENSITIVE");
$2e6f1e48aadbcba7$var$SettingsParser.STRICT = new $2e6f1e48aadbcba7$var$SettingsParser("STRICT");
$2e6f1e48aadbcba7$var$SettingsParser.LENIENT = new $2e6f1e48aadbcba7$var$SettingsParser("LENIENT");
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringLiteralPrinterParser = function() {
    function StringLiteralPrinterParser(literal) {
        this._literal = literal;
    }
    var _proto = StringLiteralPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        buf.append(this._literal);
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        $2e6f1e48aadbcba7$var$assert(!(position > length || position < 0));
        if (context.subSequenceEquals(text, position, this._literal, 0, this._literal.length) === false) return ~position;
        return position + this._literal.length;
    };
    _proto.toString = function toString() {
        var converted = this._literal.replace("'", "''");
        return "'" + converted + "'";
    };
    return StringLiteralPrinterParser;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter, Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$79d73e02cd645302 = function() {
    function ZoneRulesProvider() {}
    ZoneRulesProvider.getRules = function getRules(zoneId) {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("unsupported ZoneId:" + zoneId);
    };
    ZoneRulesProvider.getAvailableZoneIds = function getAvailableZoneIds() {
        return [];
    };
    return ZoneRulesProvider;
}();
var $2e6f1e48aadbcba7$export$9caa52e4e516e67d = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZoneRegion, _ZoneId);
    ZoneRegion.ofId = function ofId(zoneId) {
        var rules = $2e6f1e48aadbcba7$export$79d73e02cd645302.getRules(zoneId);
        return new ZoneRegion(zoneId, rules);
    };
    function ZoneRegion(id, rules) {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._id = id;
        _this._rules = rules;
        return _this;
    }
    var _proto = ZoneRegion.prototype;
    _proto.id = function id() {
        return this._id;
    };
    _proto.rules = function rules() {
        return this._rules;
    };
    return ZoneRegion;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ZoneIdPrinterParser = function() {
    function ZoneIdPrinterParser(query, description) {
        this.query = query;
        this.description = description;
    }
    var _proto = ZoneIdPrinterParser.prototype;
    _proto.print = function print(context, buf) {
        var zone = context.getValueQuery(this.query);
        if (zone == null) return false;
        buf.append(zone.id());
        return true;
    };
    _proto.parse = function parse(context, text, position) {
        var length = text.length;
        if (position > length) return ~position;
        if (position === length) return ~position;
        var nextChar = text.charAt(position);
        if (nextChar === "+" || nextChar === "-") {
            var newContext = context.copy();
            var endPos = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
            if (endPos < 0) return endPos;
            var offset = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
            var zone = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offset);
            context.setParsedZone(zone);
            return endPos;
        } else if (length >= position + 2) {
            var nextNextChar = text.charAt(position + 1);
            if (context.charEquals(nextChar, "U") && context.charEquals(nextNextChar, "T")) {
                if (length >= position + 3 && context.charEquals(text.charAt(position + 2), "C")) return this._parsePrefixedOffset(context, text, position, position + 3);
                return this._parsePrefixedOffset(context, text, position, position + 2);
            } else if (context.charEquals(nextChar, "G") && length >= position + 3 && context.charEquals(nextNextChar, "M") && context.charEquals(text.charAt(position + 2), "T")) return this._parsePrefixedOffset(context, text, position, position + 3);
        }
        if (text.substr(position, 6) === "SYSTEM") {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault());
            return position + 6;
        }
        if (context.charEquals(nextChar, "Z")) {
            context.setParsedZone($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            return position + 1;
        }
        var availableZoneIds = $2e6f1e48aadbcba7$export$79d73e02cd645302.getAvailableZoneIds();
        if ($2e6f1e48aadbcba7$var$zoneIdTree.size !== availableZoneIds.length) $2e6f1e48aadbcba7$var$zoneIdTree = $2e6f1e48aadbcba7$var$ZoneIdTree.createTreeMap(availableZoneIds);
        var maxParseLength = length - position;
        var treeMap = $2e6f1e48aadbcba7$var$zoneIdTree.treeMap;
        var parsedZoneId = null;
        var parseLength = 0;
        while(treeMap != null){
            var parsedSubZoneId = text.substr(position, Math.min(treeMap.length, maxParseLength));
            treeMap = treeMap.get(parsedSubZoneId);
            if (treeMap != null && treeMap.isLeaf) {
                parsedZoneId = parsedSubZoneId;
                parseLength = treeMap.length;
            }
        }
        if (parsedZoneId != null) {
            context.setParsedZone($2e6f1e48aadbcba7$export$9caa52e4e516e67d.ofId(parsedZoneId));
            return position + parseLength;
        }
        return ~position;
    };
    _proto._parsePrefixedOffset = function _parsePrefixedOffset(context, text, prefixPos, position) {
        var prefix = text.substring(prefixPos, position).toUpperCase();
        var newContext = context.copy();
        if (position < text.length && context.charEquals(text.charAt(position), "Z")) {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var endPos = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID.parse(newContext, text, position);
        if (endPos < 0) {
            context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC));
            return position;
        }
        var offsetSecs = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS);
        var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(offsetSecs);
        context.setParsedZone($2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset(prefix, offset));
        return endPos;
    };
    _proto.toString = function toString() {
        return this.description;
    };
    return ZoneIdPrinterParser;
}();
var $2e6f1e48aadbcba7$var$ZoneIdTree = function() {
    ZoneIdTree.createTreeMap = function createTreeMap(availableZoneIds) {
        var sortedZoneIds = availableZoneIds.sort(function(a, b) {
            return a.length - b.length;
        });
        var treeMap = new $2e6f1e48aadbcba7$var$ZoneIdTreeMap(sortedZoneIds[0].length, false);
        for(var i = 0; i < sortedZoneIds.length; i++)treeMap.add(sortedZoneIds[i]);
        return new ZoneIdTree(sortedZoneIds.length, treeMap);
    };
    function ZoneIdTree(size, treeMap) {
        this.size = size;
        this.treeMap = treeMap;
    }
    return ZoneIdTree;
}();
var $2e6f1e48aadbcba7$var$ZoneIdTreeMap = function() {
    function ZoneIdTreeMap(length, isLeaf) {
        if (length === void 0) length = 0;
        if (isLeaf === void 0) isLeaf = false;
        this.length = length;
        this.isLeaf = isLeaf;
        this._treeMap = {};
    }
    var _proto2 = ZoneIdTreeMap.prototype;
    _proto2.add = function add(zoneId) {
        var idLength = zoneId.length;
        if (idLength === this.length) this._treeMap[zoneId] = new ZoneIdTreeMap(idLength, true);
        else if (idLength > this.length) {
            var subZoneId = zoneId.substr(0, this.length);
            var subTreeMap = this._treeMap[subZoneId];
            if (subTreeMap == null) {
                subTreeMap = new ZoneIdTreeMap(idLength, false);
                this._treeMap[subZoneId] = subTreeMap;
            }
            subTreeMap.add(zoneId);
        }
    };
    _proto2.get = function get(zoneId) {
        return this._treeMap[zoneId];
    };
    return ZoneIdTreeMap;
}();
var $2e6f1e48aadbcba7$var$zoneIdTree = new $2e6f1e48aadbcba7$var$ZoneIdTree([]);
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$MAX_WIDTH$1 = 15;
var $2e6f1e48aadbcba7$export$81529fd372517959 = function() {
    function DateTimeFormatterBuilder() {
        this._active = this;
        this._parent = null;
        this._printerParsers = [];
        this._optional = false;
        this._padNextWidth = 0;
        this._padNextChar = null;
        this._valueParserIndex = -1;
    }
    DateTimeFormatterBuilder._of = function _of(parent, optional) {
        $2e6f1e48aadbcba7$var$requireNonNull(parent, "parent");
        $2e6f1e48aadbcba7$var$requireNonNull(optional, "optional");
        var dtFormatterBuilder = new DateTimeFormatterBuilder();
        dtFormatterBuilder._parent = parent;
        dtFormatterBuilder._optional = optional;
        return dtFormatterBuilder;
    };
    var _proto = DateTimeFormatterBuilder.prototype;
    _proto.parseCaseSensitive = function parseCaseSensitive() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.SENSITIVE);
        return this;
    };
    _proto.parseCaseInsensitive = function parseCaseInsensitive() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.INSENSITIVE);
        return this;
    };
    _proto.parseStrict = function parseStrict() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.STRICT);
        return this;
    };
    _proto.parseLenient = function parseLenient() {
        this._appendInternalPrinterParser($2e6f1e48aadbcba7$var$SettingsParser.LENIENT);
        return this;
    };
    _proto.appendValue = function appendValue() {
        if (arguments.length === 1) return this._appendValue1.apply(this, arguments);
        else if (arguments.length === 2) return this._appendValue2.apply(this, arguments);
        else return this._appendValue4.apply(this, arguments);
    };
    _proto._appendValue1 = function _appendValue1(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        this._appendValuePrinterParser(new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, 1, $2e6f1e48aadbcba7$var$MAX_WIDTH$1, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL));
        return this;
    };
    _proto._appendValue2 = function _appendValue2(field, width) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        if (width < 1 || width > $2e6f1e48aadbcba7$var$MAX_WIDTH$1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH$1 + " inclusive but was " + width);
        var pp = new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, width, width, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValue4 = function _appendValue4(field, minWidth, maxWidth, signStyle) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        $2e6f1e48aadbcba7$var$requireNonNull(signStyle);
        if (minWidth === maxWidth && signStyle === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) return this._appendValue2(field, maxWidth);
        if (minWidth < 1 || minWidth > $2e6f1e48aadbcba7$var$MAX_WIDTH$1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH$1 + " inclusive but was " + minWidth);
        if (maxWidth < 1 || maxWidth > $2e6f1e48aadbcba7$var$MAX_WIDTH$1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The minimum width must be from 1 to " + $2e6f1e48aadbcba7$var$MAX_WIDTH$1 + " inclusive but was " + maxWidth);
        if (maxWidth < minWidth) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The maximum width must exceed or equal the minimum width but " + maxWidth + " < " + minWidth);
        var pp = new $2e6f1e48aadbcba7$var$NumberPrinterParser(field, minWidth, maxWidth, signStyle);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto.appendValueReduced = function appendValueReduced() {
        if (arguments.length === 4 && arguments[3] instanceof $2e6f1e48aadbcba7$export$2a07e3472bc98879) return this._appendValueReducedFieldWidthMaxWidthBaseDate.apply(this, arguments);
        else return this._appendValueReducedFieldWidthMaxWidthBaseValue.apply(this, arguments);
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseValue = function _appendValueReducedFieldWidthMaxWidthBaseValue(field, width, maxWidth, baseValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        var pp = new $2e6f1e48aadbcba7$var$ReducedPrinterParser(field, width, maxWidth, baseValue, null);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValueReducedFieldWidthMaxWidthBaseDate = function _appendValueReducedFieldWidthMaxWidthBaseDate(field, width, maxWidth, baseDate) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireNonNull(baseDate, "baseDate");
        $2e6f1e48aadbcba7$var$requireInstance(baseDate, $2e6f1e48aadbcba7$export$2a07e3472bc98879, "baseDate");
        var pp = new $2e6f1e48aadbcba7$var$ReducedPrinterParser(field, width, maxWidth, 0, baseDate);
        this._appendValuePrinterParser(pp);
        return this;
    };
    _proto._appendValuePrinterParser = function _appendValuePrinterParser(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._valueParserIndex >= 0 && this._active._printerParsers[this._active._valueParserIndex] instanceof $2e6f1e48aadbcba7$var$NumberPrinterParser) {
            var activeValueParser = this._active._valueParserIndex;
            var basePP = this._active._printerParsers[activeValueParser];
            if (pp.minWidth() === pp.maxWidth() && pp.signStyle() === $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NOT_NEGATIVE) {
                basePP = basePP.withSubsequentWidth(pp.maxWidth());
                this._appendInternal(pp.withFixedWidth());
                this._active._valueParserIndex = activeValueParser;
            } else {
                basePP = basePP.withFixedWidth();
                this._active._valueParserIndex = this._appendInternal(pp);
            }
            this._active._printerParsers[activeValueParser] = basePP;
        } else this._active._valueParserIndex = this._appendInternal(pp);
        return this;
    };
    _proto.appendFraction = function appendFraction(field, minWidth, maxWidth, decimalPoint) {
        this._appendInternal(new $2e6f1e48aadbcba7$var$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
        return this;
    };
    _proto.appendInstant = function appendInstant(fractionalDigits) {
        if (fractionalDigits === void 0) fractionalDigits = -2;
        if (fractionalDigits < -2 || fractionalDigits > 9) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid fractional digits: " + fractionalDigits);
        this._appendInternal(new $2e6f1e48aadbcba7$var$InstantPrinterParser(fractionalDigits));
        return this;
    };
    _proto.appendOffsetId = function appendOffsetId() {
        this._appendInternal($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.INSTANCE_ID);
        return this;
    };
    _proto.appendOffset = function appendOffset(pattern, noOffsetText) {
        this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$OffsetIdPrinterParser(noOffsetText, pattern));
        return this;
    };
    _proto.appendZoneId = function appendZoneId() {
        this._appendInternal(new $2e6f1e48aadbcba7$var$ZoneIdPrinterParser($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId(), "ZoneId()"));
        return this;
    };
    _proto.appendPattern = function appendPattern(pattern) {
        $2e6f1e48aadbcba7$var$requireNonNull(pattern, "pattern");
        this._parsePattern(pattern);
        return this;
    };
    _proto.appendZoneText = function appendZoneText() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendText = function appendText() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendLocalizedOffset = function appendLocalizedOffset() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto.appendWeekField = function appendWeekField() {
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
    };
    _proto._parsePattern = function _parsePattern(pattern) {
        var FIELD_MAP = {
            "G": $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA,
            "y": $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA,
            "u": $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR,
            "Q": $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            "q": $2e6f1e48aadbcba7$export$2091a0730eb3b2d2.QUARTER_OF_YEAR,
            "M": $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR,
            "L": $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR,
            "D": $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR,
            "d": $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH,
            "F": $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH,
            "E": $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            "c": $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            "e": $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK,
            "a": $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY,
            "H": $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY,
            "k": $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY,
            "K": $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM,
            "h": $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM,
            "m": $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR,
            "s": $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE,
            "S": $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND,
            "A": $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY,
            "n": $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND,
            "N": $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY
        };
        for(var pos = 0; pos < pattern.length; pos++){
            var cur = pattern.charAt(pos);
            if (cur >= "A" && cur <= "Z" || cur >= "a" && cur <= "z") {
                var start = pos++;
                for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                var count = pos - start;
                if (cur === "p") {
                    var pad = 0;
                    if (pos < pattern.length) {
                        cur = pattern.charAt(pos);
                        if (cur >= "A" && cur <= "Z" || cur >= "a" && cur <= "z") {
                            pad = count;
                            start = pos++;
                            for(; pos < pattern.length && pattern.charAt(pos) === cur; pos++);
                            count = pos - start;
                        }
                    }
                    if (pad === 0) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pad letter 'p' must be followed by valid pad pattern: " + pattern);
                    this.padNext(pad);
                }
                var field = FIELD_MAP[cur];
                if (field != null) this._parseField(cur, count, field);
                else if (cur === "z") {
                    if (count > 4) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    else if (count === 4) this.appendZoneText($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else this.appendZoneText($2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                } else if (cur === "V") {
                    if (count !== 2) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern letter count must be 2: " + cur);
                    this.appendZoneId();
                } else if (cur === "Z") {
                    if (count < 4) this.appendOffset("+HHMM", "+0000");
                    else if (count === 4) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else if (count === 5) this.appendOffset("+HH:MM:ss", "Z");
                    else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                } else if (cur === "O") {
                    if (count === 1) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                    else if (count === 4) this.appendLocalizedOffset($2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                    else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern letter count must be 1 or 4: " + cur);
                } else if (cur === "X") {
                    if (count > 5) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendOffset($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], "Z");
                } else if (cur === "x") {
                    if (count > 5) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    var zero = count === 1 ? "+00" : count % 2 === 0 ? "+0000" : "+00:00";
                    this.appendOffset($2e6f1e48aadbcba7$var$OffsetIdPrinterParser.PATTERNS[count + (count === 1 ? 0 : 1)], zero);
                } else if (cur === "W") {
                    if (count > 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField("W", count);
                } else if (cur === "w") {
                    if (count > 2) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                    this.appendWeekField("w", count);
                } else if (cur === "Y") this.appendWeekField("Y", count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Unknown pattern letter: " + cur);
                pos--;
            } else if (cur === "'") {
                var _start = pos++;
                for(; pos < pattern.length; pos++)if (pattern.charAt(pos) === "'") {
                    if (pos + 1 < pattern.length && pattern.charAt(pos + 1) === "'") pos++;
                    else break;
                }
                if (pos >= pattern.length) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern ends with an incomplete string literal: " + pattern);
                var str = pattern.substring(_start + 1, pos);
                if (str.length === 0) this.appendLiteral("'");
                else this.appendLiteral(str.replace("''", "'"));
            } else if (cur === "[") this.optionalStart();
            else if (cur === "]") {
                if (this._active._parent === null) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern invalid as it contains ] without previous [");
                this.optionalEnd();
            } else if (cur === "{" || cur === "}" || cur === "#") throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Pattern includes reserved character: '" + cur + "'");
            else this.appendLiteral(cur);
        }
    };
    _proto._parseField = function _parseField(cur, count, field) {
        switch(cur){
            case "u":
            case "y":
                if (count === 2) this.appendValueReduced(field, 2, 2, $2e6f1e48aadbcba7$var$ReducedPrinterParser.BASE_DATE);
                else if (count < 4) this.appendValue(field, count, $2e6f1e48aadbcba7$var$MAX_WIDTH$1, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.NORMAL);
                else this.appendValue(field, count, $2e6f1e48aadbcba7$var$MAX_WIDTH$1, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD);
                break;
            case "M":
            case "Q":
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "L":
            case "q":
                switch(count){
                    case 1:
                        this.appendValue(field);
                        break;
                    case 2:
                        this.appendValue(field, 2);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "e":
                switch(count){
                    case 1:
                    case 2:
                        this.appendWeekField("e", count);
                        break;
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "c":
                switch(count){
                    case 1:
                        this.appendWeekField("c", count);
                        break;
                    case 2:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid number of pattern letters: " + cur);
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT_STANDALONE);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL_STANDALONE);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW_STANDALONE);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "a":
                if (count === 1) this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "E":
            case "G":
                switch(count){
                    case 1:
                    case 2:
                    case 3:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.SHORT);
                        break;
                    case 4:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.FULL);
                        break;
                    case 5:
                        this.appendText(field, $2e6f1e48aadbcba7$export$1df879243bf2e42d.NARROW);
                        break;
                    default:
                        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                }
                break;
            case "S":
                this.appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, count, count, false);
                break;
            case "F":
                if (count === 1) this.appendValue(field);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "d":
            case "h":
            case "H":
            case "k":
            case "K":
            case "m":
            case "s":
                if (count === 1) this.appendValue(field);
                else if (count === 2) this.appendValue(field, count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            case "D":
                if (count === 1) this.appendValue(field);
                else if (count <= 3) this.appendValue(field, count);
                else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Too many pattern letters: " + cur);
                break;
            default:
                if (count === 1) this.appendValue(field);
                else this.appendValue(field, count);
                break;
        }
    };
    _proto.padNext = function padNext() {
        if (arguments.length === 1) return this._padNext1.apply(this, arguments);
        else return this._padNext2.apply(this, arguments);
    };
    _proto._padNext1 = function _padNext1(padWidth) {
        return this._padNext2(padWidth, " ");
    };
    _proto._padNext2 = function _padNext2(padWidth, padChar) {
        if (padWidth < 1) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("The pad width must be at least one but was " + padWidth);
        this._active._padNextWidth = padWidth;
        this._active._padNextChar = padChar;
        this._active._valueParserIndex = -1;
        return this;
    };
    _proto.optionalStart = function optionalStart() {
        this._active._valueParserIndex = -1;
        this._active = DateTimeFormatterBuilder._of(this._active, true);
        return this;
    };
    _proto.optionalEnd = function optionalEnd() {
        if (this._active._parent == null) throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e("Cannot call optionalEnd() as there was no previous call to optionalStart()");
        if (this._active._printerParsers.length > 0) {
            var cpp = new $2e6f1e48aadbcba7$var$CompositePrinterParser(this._active._printerParsers, this._active._optional);
            this._active = this._active._parent;
            this._appendInternal(cpp);
        } else this._active = this._active._parent;
        return this;
    };
    _proto._appendInternal = function _appendInternal(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $2e6f1e48aadbcba7$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.appendLiteral = function appendLiteral(literal) {
        $2e6f1e48aadbcba7$var$assert(literal != null);
        if (literal.length > 0) {
            if (literal.length === 1) this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$CharLiteralPrinterParser(literal.charAt(0)));
            else this._appendInternalPrinterParser(new $2e6f1e48aadbcba7$var$StringLiteralPrinterParser(literal));
        }
        return this;
    };
    _proto._appendInternalPrinterParser = function _appendInternalPrinterParser(pp) {
        $2e6f1e48aadbcba7$var$assert(pp != null);
        if (this._active._padNextWidth > 0) {
            if (pp != null) pp = new $2e6f1e48aadbcba7$var$PadPrinterParserDecorator(pp, this._active._padNextWidth, this._active._padNextChar);
            this._active._padNextWidth = 0;
            this._active._padNextChar = 0;
        }
        this._active._printerParsers.push(pp);
        this._active._valueParserIndex = -1;
        return this._active._printerParsers.length - 1;
    };
    _proto.append = function append(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        this._appendInternal(formatter._toPrinterParser(false));
        return this;
    };
    _proto.toFormatter = function toFormatter(resolverStyle) {
        if (resolverStyle === void 0) resolverStyle = $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART;
        while(this._active._parent != null)this.optionalEnd();
        var pp = new $2e6f1e48aadbcba7$var$CompositePrinterParser(this._printerParsers, false);
        return new $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c(pp, null, $2e6f1e48aadbcba7$export$c1929c59b9e7d355.STANDARD, resolverStyle, null, null, null);
    };
    return DateTimeFormatterBuilder;
}();
var $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS = 315569520000;
var $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970 = 62167219200;
var $2e6f1e48aadbcba7$var$InstantPrinterParser = function() {
    function InstantPrinterParser(fractionalDigits) {
        this.fractionalDigits = fractionalDigits;
    }
    var _proto2 = InstantPrinterParser.prototype;
    _proto2.print = function print(context, buf) {
        var inSecs = context.getValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
        var inNanos = 0;
        if (context.temporal().isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND)) inNanos = context.temporal().getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        if (inSecs == null) return false;
        var inSec = inSecs;
        var inNano = $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidIntValue(inNanos);
        if (inSec >= -$2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970) {
            var zeroSecs = inSec - $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS + $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970;
            var hi = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS) + 1;
            var lo = $2e6f1e48aadbcba7$var$MathUtil.floorMod(zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(lo - $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            if (hi > 0) buf.append("+").append(hi);
            buf.append(ldt);
            if (ldt.second() === 0) buf.append(":00");
        } else {
            var _zeroSecs = inSec + $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970;
            var _hi = $2e6f1e48aadbcba7$var$MathUtil.intDiv(_zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var _lo = $2e6f1e48aadbcba7$var$MathUtil.intMod(_zeroSecs, $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
            var _ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(_lo - $2e6f1e48aadbcba7$var$SECONDS_0000_TO_1970, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            var pos = buf.length();
            buf.append(_ldt);
            if (_ldt.second() === 0) buf.append(":00");
            if (_hi < 0) {
                if (_ldt.year() === -10000) buf.replace(pos, pos + 2, "" + (_hi - 1));
                else if (_lo === 0) buf.insert(pos, _hi);
                else buf.insert(pos + 1, Math.abs(_hi));
            }
        }
        if (this.fractionalDigits === -2) {
            if (inNano !== 0) {
                buf.append(".");
                if ($2e6f1e48aadbcba7$var$MathUtil.intMod(inNano, 1000000) === 0) buf.append(("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, 1000000) + 1000)).substring(1));
                else if ($2e6f1e48aadbcba7$var$MathUtil.intMod(inNano, 1000) === 0) buf.append(("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, 1000) + 1000000)).substring(1));
                else buf.append(("" + (inNano + 1000000000)).substring(1));
            }
        } else if (this.fractionalDigits > 0 || this.fractionalDigits === -1 && inNano > 0) {
            buf.append(".");
            var div = 100000000;
            for(var i = 0; this.fractionalDigits === -1 && inNano > 0 || i < this.fractionalDigits; i++){
                var digit = $2e6f1e48aadbcba7$var$MathUtil.intDiv(inNano, div);
                buf.append(digit);
                inNano = inNano - digit * div;
                div = $2e6f1e48aadbcba7$var$MathUtil.intDiv(div, 10);
            }
        }
        buf.append("Z");
        return true;
    };
    _proto2.parse = function parse(context, text, position) {
        var newContext = context.copy();
        var minDigits = this.fractionalDigits < 0 ? 0 : this.fractionalDigits;
        var maxDigits = this.fractionalDigits < 0 ? 9 : this.fractionalDigits;
        var parser = new $2e6f1e48aadbcba7$export$81529fd372517959().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral("T").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(":").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).appendLiteral(":").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, minDigits, maxDigits, true).appendLiteral("Z").toFormatter()._toPrinterParser(false);
        var pos = parser.parse(newContext, text, position);
        if (pos < 0) return pos;
        var yearParsed = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
        var month = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
        var day = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH);
        var hour = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY);
        var min = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR);
        var secVal = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE);
        var nanoVal = newContext.getParsed($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        var sec = secVal != null ? secVal : 0;
        var nano = nanoVal != null ? nanoVal : 0;
        var year = $2e6f1e48aadbcba7$var$MathUtil.intMod(yearParsed, 10000);
        var days = 0;
        if (hour === 24 && min === 0 && sec === 0 && nano === 0) {
            hour = 0;
            days = 1;
        } else if (hour === 23 && min === 59 && sec === 60) {
            context.setParsedLeapSecond();
            sec = 59;
        }
        var instantSecs;
        try {
            var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, day, hour, min, sec, 0).plusDays(days);
            instantSecs = ldt.toEpochSecond($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
            instantSecs += $2e6f1e48aadbcba7$var$MathUtil.safeMultiply($2e6f1e48aadbcba7$var$MathUtil.intDiv(yearParsed, 10000), $2e6f1e48aadbcba7$var$SECONDS_PER_10000_YEARS);
        } catch (ex) {
            return ~position;
        }
        var successPos = pos;
        successPos = context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, instantSecs, position, successPos);
        return context.setParsedField($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, nano, position, successPos);
    };
    _proto2.toString = function toString() {
        return "Instant()";
    };
    return InstantPrinterParser;
}();
function $2e6f1e48aadbcba7$var$_init$9() {
    $2e6f1e48aadbcba7$var$ReducedPrinterParser.BASE_DATE = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(2000, 1, 1);
    $2e6f1e48aadbcba7$export$81529fd372517959.CompositePrinterParser = $2e6f1e48aadbcba7$var$CompositePrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.PadPrinterParserDecorator = $2e6f1e48aadbcba7$var$PadPrinterParserDecorator;
    $2e6f1e48aadbcba7$export$81529fd372517959.SettingsParser = $2e6f1e48aadbcba7$var$SettingsParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.CharLiteralPrinterParser = $2e6f1e48aadbcba7$var$StringLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.StringLiteralPrinterParser = $2e6f1e48aadbcba7$var$StringLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.CharLiteralPrinterParser = $2e6f1e48aadbcba7$var$CharLiteralPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.NumberPrinterParser = $2e6f1e48aadbcba7$var$NumberPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.ReducedPrinterParser = $2e6f1e48aadbcba7$var$ReducedPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.FractionPrinterParser = $2e6f1e48aadbcba7$var$FractionPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.OffsetIdPrinterParser = $2e6f1e48aadbcba7$var$OffsetIdPrinterParser;
    $2e6f1e48aadbcba7$export$81529fd372517959.ZoneIdPrinterParser = $2e6f1e48aadbcba7$var$ZoneIdPrinterParser;
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$StringBuilder = function() {
    function StringBuilder() {
        this._str = "";
    }
    var _proto = StringBuilder.prototype;
    _proto.append = function append(str) {
        this._str += str;
        return this;
    };
    _proto.appendChar = function appendChar(str) {
        this._str += str[0];
        return this;
    };
    _proto.insert = function insert(offset, str) {
        this._str = this._str.slice(0, offset) + str + this._str.slice(offset);
        return this;
    };
    _proto.replace = function replace(start, end, str) {
        this._str = this._str.slice(0, start) + str + this._str.slice(end);
        return this;
    };
    _proto.length = function length() {
        return this._str.length;
    };
    _proto.setLength = function setLength(length) {
        this._str = this._str.slice(0, length);
        return this;
    };
    _proto.toString = function toString() {
        return this._str;
    };
    return StringBuilder;
}();
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c = function() {
    DateTimeFormatter.parsedExcessDays = function parsedExcessDays() {
        return DateTimeFormatter.PARSED_EXCESS_DAYS;
    };
    DateTimeFormatter.parsedLeapSecond = function parsedLeapSecond() {
        return DateTimeFormatter.PARSED_LEAP_SECOND;
    };
    DateTimeFormatter.ofPattern = function ofPattern(pattern) {
        return new $2e6f1e48aadbcba7$export$81529fd372517959().appendPattern(pattern).toFormatter();
    };
    function DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
        if (chrono === void 0) chrono = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        $2e6f1e48aadbcba7$var$assert(printerParser != null);
        $2e6f1e48aadbcba7$var$assert(decimalStyle != null);
        $2e6f1e48aadbcba7$var$assert(resolverStyle != null);
        this._printerParser = printerParser;
        this._locale = locale;
        this._decimalStyle = decimalStyle;
        this._resolverStyle = resolverStyle;
        this._resolverFields = resolverFields;
        this._chrono = chrono;
        this._zone = zone;
    }
    var _proto = DateTimeFormatter.prototype;
    _proto.locale = function locale() {
        return this._locale;
    };
    _proto.decimalStyle = function decimalStyle() {
        return this._decimalStyle;
    };
    _proto.chronology = function chronology() {
        return this._chrono;
    };
    _proto.withChronology = function withChronology(chrono) {
        if (this._chrono != null && this._chrono.equals(chrono)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, this._resolverStyle, this._resolverFields, chrono, this._zone);
    };
    _proto.withLocale = function withLocale() {
        return this;
    };
    _proto.withResolverStyle = function withResolverStyle(resolverStyle) {
        $2e6f1e48aadbcba7$var$requireNonNull(resolverStyle, "resolverStyle");
        if (resolverStyle.equals(this._resolverStyle)) return this;
        return new DateTimeFormatter(this._printerParser, this._locale, this._decimalStyle, resolverStyle, this._resolverFields, this._chrono, this._zone);
    };
    _proto.format = function format(temporal) {
        var buf = new $2e6f1e48aadbcba7$var$StringBuilder(32);
        this._formatTo(temporal, buf);
        return buf.toString();
    };
    _proto._formatTo = function _formatTo(temporal, appendable) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        $2e6f1e48aadbcba7$var$requireNonNull(appendable, "appendable");
        var context = new $2e6f1e48aadbcba7$var$DateTimePrintContext(temporal, this);
        this._printerParser.print(context, appendable);
    };
    _proto.parse = function parse(text, type) {
        if (arguments.length === 1) return this.parse1(text);
        else return this.parse2(text, type);
    };
    _proto.parse1 = function parse1(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        try {
            return this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto.parse2 = function parse2(text, type) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        $2e6f1e48aadbcba7$var$requireNonNull(type, "type");
        try {
            var builder = this._parseToBuilder(text, null).resolve(this._resolverStyle, this._resolverFields);
            return builder.build(type);
        } catch (ex) {
            if (ex instanceof $2e6f1e48aadbcba7$export$ce8a206818942248) throw ex;
            else throw this._createError(text, ex);
        }
    };
    _proto._createError = function _createError(text, ex) {
        var abbr = "";
        if (text.length > 64) abbr = text.substring(0, 64) + "...";
        else abbr = text;
        return new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed: " + ex.message, text, 0, ex);
    };
    _proto._parseToBuilder = function _parseToBuilder(text, position) {
        var pos = position != null ? position : new $2e6f1e48aadbcba7$var$ParsePosition(0);
        var result = this._parseUnresolved0(text, pos);
        if (result == null || pos.getErrorIndex() >= 0 || position == null && pos.getIndex() < text.length) {
            var abbr = "";
            if (text.length > 64) abbr = text.substr(0, 64).toString() + "...";
            else abbr = text;
            if (pos.getErrorIndex() >= 0) throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed at index " + pos.getErrorIndex(), text, pos.getErrorIndex());
            else throw new $2e6f1e48aadbcba7$export$ce8a206818942248("Text '" + abbr + "' could not be parsed, unparsed text found at index " + pos.getIndex(), text, pos.getIndex());
        }
        return result.toBuilder();
    };
    _proto.parseUnresolved = function parseUnresolved(text, position) {
        return this._parseUnresolved0(text, position);
    };
    _proto._parseUnresolved0 = function _parseUnresolved0(text, position) {
        $2e6f1e48aadbcba7$var$assert(text != null, "text", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        $2e6f1e48aadbcba7$var$assert(position != null, "position", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        var context = new $2e6f1e48aadbcba7$var$DateTimeParseContext(this);
        var pos = position.getIndex();
        pos = this._printerParser.parse(context, text, pos);
        if (pos < 0) {
            position.setErrorIndex(~pos);
            return null;
        }
        position.setIndex(pos);
        return context.toParsed();
    };
    _proto._toPrinterParser = function _toPrinterParser(optional) {
        return this._printerParser.withOptional(optional);
    };
    _proto.toString = function toString() {
        var pattern = this._printerParser.toString();
        return pattern.indexOf("[") === 0 ? pattern : pattern.substring(1, pattern.length - 1);
    };
    return DateTimeFormatter;
}();
function $2e6f1e48aadbcba7$var$_init$a() {
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY, 2).appendLiteral(":").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR, 2).optionalStart().appendLiteral(":").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE, 2).optionalStart().appendFraction($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, 0, 9, true).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendLiteral("T").append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().appendInstant().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME).optionalStart().appendLiteral("[").parseCaseSensitive().appendZoneId().appendLiteral("]").toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.BASIC_ISO_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_TIME = new $2e6f1e48aadbcba7$export$81529fd372517959().parseCaseInsensitive().append($2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME).appendOffsetId().toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT).withChronology($2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ORDINAL_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_WEEK_DATE = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-W").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK).toFormatter($2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT);
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.PARSED_EXCESS_DAYS = $2e6f1e48aadbcba7$var$createTemporalQuery("PARSED_EXCESS_DAYS", function(temporal) {
        if (temporal instanceof $2e6f1e48aadbcba7$var$DateTimeBuilder) return temporal.excessDays;
        else return $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.ZERO;
    });
    $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.PARSED_LEAP_SECOND = $2e6f1e48aadbcba7$var$createTemporalQuery("PARSED_LEAP_SECOND", function(temporal) {
        if (temporal instanceof $2e6f1e48aadbcba7$var$DateTimeBuilder) return temporal.leapSecond;
        else return false;
    });
}
var $2e6f1e48aadbcba7$export$30964d9b15071608 = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(MonthDay, _TemporalAccessor);
    MonthDay.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return MonthDay.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return MonthDay.nowZoneId(zoneIdOrClock);
        else return MonthDay.nowClock(zoneIdOrClock);
    };
    MonthDay.now0 = function now0() {
        return this.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    MonthDay.nowZoneId = function nowZoneId(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        return this.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    MonthDay.nowClock = function nowClock(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, "clock");
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return MonthDay.of(now.month(), now.dayOfMonth());
    };
    MonthDay.of = function of(monthOrNumber, number) {
        if (arguments.length === 2 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return MonthDay.ofMonthNumber(monthOrNumber, number);
        else return MonthDay.ofNumberNumber(monthOrNumber, number);
    };
    MonthDay.ofMonthNumber = function ofMonthNumber(month, dayOfMonth) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > month.maxLength()) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Illegal value for DayOfMonth field, value " + dayOfMonth + " is not valid for month " + month.toString());
        return new MonthDay(month.value(), dayOfMonth);
    };
    MonthDay.ofNumberNumber = function ofNumberNumber(month, dayOfMonth) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfMonth, "dayOfMonth");
        return MonthDay.of($2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(month), dayOfMonth);
    };
    MonthDay.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$e5100310ee9cc158, "temporal");
        if (temporal instanceof MonthDay) return temporal;
        try {
            return MonthDay.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR), temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain MonthDay from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    MonthDay.parse = function parse(text, formatter) {
        if (arguments.length === 1) return MonthDay.parseString(text);
        else return MonthDay.parseStringFormatter(text, formatter);
    };
    MonthDay.parseString = function parseString(text) {
        return MonthDay.parseStringFormatter(text, $2e6f1e48aadbcba7$var$PARSER);
    };
    MonthDay.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return formatter.parse(text, MonthDay.FROM);
    };
    function MonthDay(month, dayOfMonth) {
        var _this;
        _this = _TemporalAccessor.call(this) || this;
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        _this._day = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(dayOfMonth);
        return _this;
    }
    var _proto = MonthDay.prototype;
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.isSupported = function isSupported(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH;
        return field != null && field.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR) return field.range();
        else if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH) return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.month().minLength(), this.month().maxLength());
        return _TemporalAccessor.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this._day;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isValidYear = function isValidYear(year) {
        return (this._day === 29 && this._month === 2 && $2e6f1e48aadbcba7$export$6ce2f08d515512.isLeap(year) === false) === false;
    };
    _proto.withMonth = function withMonth(month) {
        return this.with($2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(month));
    };
    _proto.with = function _with(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        if (month.value() === this._month) return this;
        var day = Math.min(this._day, month.maxLength());
        return new MonthDay(month.value(), day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (dayOfMonth === this._day) return this;
        return MonthDay.of(this._month, dayOfMonth);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        temporal = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, this._month);
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, Math.min(temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum(), this._day));
    };
    _proto.atYear = function atYear(year) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(year, this._month, this.isValidYear(year) ? this._day : 28);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, "other");
        var cmp = this._month - other.monthValue();
        if (cmp === 0) cmp = this._day - other.dayOfMonth();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, "other");
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, MonthDay, "other");
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof MonthDay) {
            var other = obj;
            return this.monthValue() === other.monthValue() && this.dayOfMonth() === other.dayOfMonth();
        }
        return false;
    };
    _proto.toString = function toString() {
        return "--" + (this._month < 10 ? "0" : "") + this._month + (this._day < 10 ? "-0" : "-") + this._day;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    return MonthDay;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
var $2e6f1e48aadbcba7$var$PARSER;
function $2e6f1e48aadbcba7$var$_init$b() {
    $2e6f1e48aadbcba7$var$PARSER = new $2e6f1e48aadbcba7$export$81529fd372517959().appendLiteral("--").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 2).toFormatter();
    $2e6f1e48aadbcba7$export$30964d9b15071608.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("MonthDay.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$30964d9b15071608.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$b707805e12671f51 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(YearMonth, _Temporal);
    YearMonth.now = function now(zoneIdOrClock) {
        if (arguments.length === 0) return YearMonth.now0();
        else if (arguments.length === 1 && zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return YearMonth.nowZoneId(zoneIdOrClock);
        else return YearMonth.nowClock(zoneIdOrClock);
    };
    YearMonth.now0 = function now0() {
        return YearMonth.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    YearMonth.nowZoneId = function nowZoneId(zone) {
        return YearMonth.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    YearMonth.nowClock = function nowClock(clock) {
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return YearMonth.of(now.year(), now.month());
    };
    YearMonth.of = function of(year, monthOrNumber) {
        if (arguments.length === 2 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return YearMonth.ofNumberMonth(year, monthOrNumber);
        else return YearMonth.ofNumberNumber(year, monthOrNumber);
    };
    YearMonth.ofNumberMonth = function ofNumberMonth(year, month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$var$requireInstance(month, $2e6f1e48aadbcba7$export$951c8378cdfec6e6, "month");
        return YearMonth.ofNumberNumber(year, month.value());
    };
    YearMonth.ofNumberNumber = function ofNumberNumber(year, month) {
        $2e6f1e48aadbcba7$var$requireNonNull(year, "year");
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return new YearMonth(year, month);
    };
    YearMonth.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof YearMonth) return temporal;
        try {
            return YearMonth.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR), temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain YearMonth from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    YearMonth.parse = function parse(text, formatter) {
        if (arguments.length === 1) return YearMonth.parseString(text);
        else return YearMonth.parseStringFormatter(text, formatter);
    };
    YearMonth.parseString = function parseString(text) {
        return YearMonth.parseStringFormatter(text, $2e6f1e48aadbcba7$var$PARSER$1);
    };
    YearMonth.parseStringFormatter = function parseStringFormatter(text, formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, YearMonth.FROM);
    };
    function YearMonth(year, month) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(year);
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        return _this;
    }
    var _proto = YearMonth.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA) return this.year() <= 0 ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE + 1) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, "field");
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this._month;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this._getProlepticMonth();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto._getProlepticMonth = function _getProlepticMonth() {
        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._year, 12), this._month - 1);
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.isValidDay = function isValidDay(dayOfMonth) {
        return dayOfMonth >= 1 && dayOfMonth <= this.lengthOfMonth();
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        return this.month().length(this.isLeapYear());
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto.with = function _with(adjusterOrField, value) {
        if (arguments.length === 1) return this.withAdjuster(adjusterOrField);
        else return this.withFieldValue(adjusterOrField, value);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year < 1 ? 1 - newValue : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return new YearMonth(year, this._month);
    };
    _proto.withMonth = function withMonth(month) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        return new YearMonth(this._year, month);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, "unit");
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return this.withYear(newYear);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $2e6f1e48aadbcba7$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return new YearMonth(newYear, newMonth);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return amountToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusAmountUnit($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER, unit).plusAmountUnit(1, unit) : this.plusAmountUnit(-amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return monthsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusMonths(Math.MAX_SAFE_INTEGER).plusMonths(1) : this.plusMonths(-monthsToSubtract);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$336849d529cb05e5, "temporal");
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH, this._getProlepticMonth());
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(endExclusive, $2e6f1e48aadbcba7$export$336849d529cb05e5, "endExclusive");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, "unit");
        var end = YearMonth.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var monthsUntil = end._getProlepticMonth() - this._getProlepticMonth();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return monthsUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return monthsUntil / 12;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return monthsUntil / 120;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return monthsUntil / 1200;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return monthsUntil / 12000;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDay = function atDay(dayOfMonth) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(this._year, this._month, dayOfMonth);
    };
    _proto.atEndOfMonth = function atEndOfMonth() {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(this._year, this._month, this.lengthOfMonth());
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, YearMonth, "other");
        var cmp = this._year - other.year();
        if (cmp === 0) cmp = this._month - other.monthValue();
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(obj) {
        if (this === obj) return true;
        if (obj instanceof YearMonth) {
            var other = obj;
            return this.year() === other.year() && this.monthValue() === other.monthValue();
        }
        return false;
    };
    _proto.toString = function toString() {
        return $2e6f1e48aadbcba7$var$PARSER$1.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return YearMonth;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$var$PARSER$1;
function $2e6f1e48aadbcba7$var$_init$c() {
    $2e6f1e48aadbcba7$var$PARSER$1 = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).appendLiteral("-").appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, 2).toFormatter();
    $2e6f1e48aadbcba7$export$b707805e12671f51.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("YearMonth.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$b707805e12671f51.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$6ce2f08d515512 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Year, _Temporal);
    function Year(value) {
        var _this;
        _this = _Temporal.call(this) || this;
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(value);
        return _this;
    }
    var _proto = Year.prototype;
    _proto.value = function value() {
        return this._year;
    };
    Year.now = function now(zoneIdOrClock) {
        if (zoneIdOrClock === void 0) zoneIdOrClock = undefined;
        if (zoneIdOrClock === undefined) return Year.now0();
        else if (zoneIdOrClock instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return Year.nowZoneId(zoneIdOrClock);
        else return Year.nowClock(zoneIdOrClock);
    };
    Year.now0 = function now0() {
        return Year.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
    };
    Year.nowZoneId = function nowZoneId(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        $2e6f1e48aadbcba7$var$requireInstance(zone, $2e6f1e48aadbcba7$export$a514a0be1f00ef62, "zone");
        return Year.nowClock($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(zone));
    };
    Year.nowClock = function nowClock(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, "clock");
        $2e6f1e48aadbcba7$var$requireInstance(clock, $2e6f1e48aadbcba7$export$9735c82c4bae3302, "clock");
        var now = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.now(clock);
        return Year.of(now.year());
    };
    Year.of = function of(isoYear) {
        $2e6f1e48aadbcba7$var$requireNonNull(isoYear, "isoYear");
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(isoYear);
        return new Year(isoYear);
    };
    Year.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        $2e6f1e48aadbcba7$var$requireInstance(temporal, $2e6f1e48aadbcba7$export$e5100310ee9cc158, "temporal");
        if (temporal instanceof Year) return temporal;
        try {
            return Year.of(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Year from TemporalAccessor: " + temporal + ", type " + (temporal && temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    Year.parse = function parse(text, formatter) {
        if (arguments.length <= 1) return Year.parseText(text);
        else return Year.parseTextFormatter(text, formatter);
    };
    Year.parseText = function parseText(text) {
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        return Year.parse(text, $2e6f1e48aadbcba7$var$PARSER$2);
    };
    Year.parseTextFormatter = function parseTextFormatter(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$var$PARSER$2;
        $2e6f1e48aadbcba7$var$requireNonNull(text, "text");
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return formatter.parse(text, Year.FROM);
    };
    Year.isLeap = function isLeap(year) {
        return $2e6f1e48aadbcba7$var$MathUtil.intMod(year, 4) === 0 && ($2e6f1e48aadbcba7$var$MathUtil.intMod(year, 100) !== 0 || $2e6f1e48aadbcba7$var$MathUtil.intMod(year, 400) === 0);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (arguments.length === 1 && fieldOrUnit instanceof $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9) return this.isSupportedField(fieldOrUnit);
        else return this.isSupportedUnit(fieldOrUnit);
    };
    _proto.isSupportedField = function isSupportedField(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA;
        return field != null && field.isSupportedBy(this);
    };
    _proto.isSupportedUnit = function isSupportedUnit(unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA || unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS;
        return unit != null && unit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (this.isSupported(field)) return field.range();
        else if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.range(field).checkValidIntValue(this.getLong(field), field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this._year < 1 ? 1 - this._year : this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this._year;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this._year < 1 ? 0 : 1;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isLeap = function isLeap() {
        return Year.isLeap(this._year);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return Year.of(this._year < 1 ? 1 - newValue : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return Year.of(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : Year.of(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, "amountToAdd");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, "unit");
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        return Year.of($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.safeAdd(this._year, yearsToAdd)));
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        $2e6f1e48aadbcba7$var$requireInstance(amount, $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e, "unit");
        return amountToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plus($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER, unit).plus(1, unit) : this.plus(-amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return yearsToSubtract === $2e6f1e48aadbcba7$var$MathUtil.MIN_SAFE_INTEGER ? this.plusYears($2e6f1e48aadbcba7$var$MathUtil.MAX_SAFE_INTEGER).plusYears(1) : this.plusYears(-yearsToSubtract);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, this._year);
    };
    _proto.isValidMonthDay = function isValidMonthDay(monthDay) {
        return monthDay != null && monthDay.isValidYear(this._year);
    };
    _proto.length = function length() {
        return this.isLeap() ? 366 : 365;
    };
    _proto.atDay = function atDay(dayOfYear) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(this._year, dayOfYear);
    };
    _proto.atMonth = function atMonth(monthOrNumber) {
        if (arguments.length === 1 && monthOrNumber instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) return this.atMonthMonth(monthOrNumber);
        else return this.atMonthNumber(monthOrNumber);
    };
    _proto.atMonthMonth = function atMonthMonth(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$var$requireInstance(month, $2e6f1e48aadbcba7$export$951c8378cdfec6e6, "month");
        return $2e6f1e48aadbcba7$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthNumber = function atMonthNumber(month) {
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        return $2e6f1e48aadbcba7$export$b707805e12671f51.of(this._year, month);
    };
    _proto.atMonthDay = function atMonthDay(monthDay) {
        $2e6f1e48aadbcba7$var$requireNonNull(monthDay, "monthDay");
        $2e6f1e48aadbcba7$var$requireInstance(monthDay, $2e6f1e48aadbcba7$export$30964d9b15071608, "monthDay");
        return monthDay.atYear(this._year);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query()");
        $2e6f1e48aadbcba7$var$requireInstance(_query, $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff, "query()");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _Temporal.prototype.query.call(this, _query);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, "other");
        return this._year - other._year;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, "other");
        return this._year > other._year;
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, Year, "other");
        return this._year < other._year;
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return formatter.format(this);
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Year) return this.value() === other.value();
        return false;
    };
    _proto.toString = function toString() {
        return "" + this._year;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.until = function until(endExclusive, unit) {
        var end = Year.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var yearsUntil = end.value() - this.value();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return yearsUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 10);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 100);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearsUntil, 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    return Year;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
var $2e6f1e48aadbcba7$var$PARSER$2;
function $2e6f1e48aadbcba7$var$_init$d() {
    $2e6f1e48aadbcba7$export$6ce2f08d515512.MIN_VALUE = $2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE;
    $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE = $2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE;
    $2e6f1e48aadbcba7$var$PARSER$2 = new $2e6f1e48aadbcba7$export$81529fd372517959().appendValue($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, 4, 10, $2e6f1e48aadbcba7$export$b2e3a42c433c0b35.EXCEEDS_PAD).toFormatter();
    $2e6f1e48aadbcba7$export$6ce2f08d515512.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("Year.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$6ce2f08d515512.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$d922854d56f8a965 = function() {
    function TemporalAdjusters() {}
    TemporalAdjusters.firstDayOfMonth = function firstDayOfMonth() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_MONTH;
    };
    TemporalAdjusters.lastDayOfMonth = function lastDayOfMonth() {
        return $2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_MONTH;
    };
    TemporalAdjusters.firstDayOfNextMonth = function firstDayOfNextMonth() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_MONTH;
    };
    TemporalAdjusters.firstDayOfYear = function firstDayOfYear() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_YEAR;
    };
    TemporalAdjusters.lastDayOfYear = function lastDayOfYear() {
        return $2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_YEAR;
    };
    TemporalAdjusters.firstDayOfNextYear = function firstDayOfNextYear() {
        return $2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_YEAR;
    };
    TemporalAdjusters.firstInMonth = function firstInMonth(dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(1, dayOfWeek);
    };
    TemporalAdjusters.lastInMonth = function lastInMonth(dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(-1, dayOfWeek);
    };
    TemporalAdjusters.dayOfWeekInMonth = function dayOfWeekInMonth(ordinal, dayOfWeek) {
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, "dayOfWeek");
        return new $2e6f1e48aadbcba7$var$DayOfWeekInMonth(ordinal, dayOfWeek);
    };
    TemporalAdjusters.next = function next(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(2, dayOfWeek);
    };
    TemporalAdjusters.nextOrSame = function nextOrSame(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(0, dayOfWeek);
    };
    TemporalAdjusters.previous = function previous(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(3, dayOfWeek);
    };
    TemporalAdjusters.previousOrSame = function previousOrSame(dayOfWeek) {
        return new $2e6f1e48aadbcba7$var$RelativeDayOfWeek(1, dayOfWeek);
    };
    return TemporalAdjusters;
}();
var $2e6f1e48aadbcba7$var$Impl = function(_TemporalAdjuster) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Impl, _TemporalAdjuster);
    function Impl(ordinal) {
        var _this;
        _this = _TemporalAdjuster.call(this) || this;
        _this._ordinal = ordinal;
        return _this;
    }
    var _proto = Impl.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        switch(this._ordinal){
            case 0:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            case 1:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            case 2:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1).plus(1, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS);
            case 3:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, 1);
            case 4:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR).maximum());
            case 5:
                return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR, 1).plus(1, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS);
        }
        throw new $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e("Unreachable");
    };
    return Impl;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_MONTH = new $2e6f1e48aadbcba7$var$Impl(0);
$2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_MONTH = new $2e6f1e48aadbcba7$var$Impl(1);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_MONTH = new $2e6f1e48aadbcba7$var$Impl(2);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_YEAR = new $2e6f1e48aadbcba7$var$Impl(3);
$2e6f1e48aadbcba7$var$Impl.LAST_DAY_OF_YEAR = new $2e6f1e48aadbcba7$var$Impl(4);
$2e6f1e48aadbcba7$var$Impl.FIRST_DAY_OF_NEXT_YEAR = new $2e6f1e48aadbcba7$var$Impl(5);
var $2e6f1e48aadbcba7$var$DayOfWeekInMonth = function(_TemporalAdjuster2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(DayOfWeekInMonth, _TemporalAdjuster2);
    function DayOfWeekInMonth(ordinal, dow) {
        var _this2;
        _this2 = _TemporalAdjuster2.call(this) || this;
        _this2._ordinal = ordinal;
        _this2._dowValue = dow.value();
        return _this2;
    }
    var _proto2 = DayOfWeekInMonth.prototype;
    _proto2.adjustInto = function adjustInto(temporal) {
        if (this._ordinal >= 0) {
            var temp = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, 1);
            var curDow = temp.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
            var dowDiff = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._dowValue - curDow + 7, 7);
            dowDiff += (this._ordinal - 1) * 7;
            return temp.plus(dowDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        } else {
            var _temp = temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH, temporal.range($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH).maximum());
            var _curDow = _temp.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
            var daysDiff = this._dowValue - _curDow;
            daysDiff = daysDiff === 0 ? 0 : daysDiff > 0 ? daysDiff - 7 : daysDiff;
            daysDiff -= (-this._ordinal - 1) * 7;
            return _temp.plus(daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        }
    };
    return DayOfWeekInMonth;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
var $2e6f1e48aadbcba7$var$RelativeDayOfWeek = function(_TemporalAdjuster3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(RelativeDayOfWeek, _TemporalAdjuster3);
    function RelativeDayOfWeek(relative, dayOfWeek) {
        var _this3;
        _this3 = _TemporalAdjuster3.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfWeek, "dayOfWeek");
        _this3._relative = relative;
        _this3._dowValue = dayOfWeek.value();
        return _this3;
    }
    var _proto3 = RelativeDayOfWeek.prototype;
    _proto3.adjustInto = function adjustInto(temporal) {
        var calDow = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK);
        if (this._relative < 2 && calDow === this._dowValue) return temporal;
        if ((this._relative & 1) === 0) {
            var daysDiff = calDow - this._dowValue;
            return temporal.plus(daysDiff >= 0 ? 7 - daysDiff : -daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        } else {
            var _daysDiff = this._dowValue - calDow;
            return temporal.minus(_daysDiff >= 0 ? 7 - _daysDiff : -_daysDiff, $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS);
        }
    };
    return RelativeDayOfWeek;
}($2e6f1e48aadbcba7$export$841f8bd48996924f);
var $2e6f1e48aadbcba7$export$f47ae290cf4e4958 = function(_Enum) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(IsoChronology, _Enum);
    function IsoChronology() {
        return _Enum.apply(this, arguments) || this;
    }
    IsoChronology.isLeapYear = function isLeapYear(prolepticYear) {
        return (prolepticYear & 3) === 0 && (prolepticYear % 100 !== 0 || prolepticYear % 400 === 0);
    };
    var _proto = IsoChronology.prototype;
    _proto._updateResolveMap = function _updateResolveMap(fieldValues, field, value) {
        $2e6f1e48aadbcba7$var$requireNonNull(fieldValues, "fieldValues");
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        var current = fieldValues.get(field);
        if (current != null && current !== value) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid state, field: " + field + " " + current + " conflicts with " + field + " " + value);
        fieldValues.put(field, value);
    };
    _proto.resolveDate = function resolveDate(fieldValues, resolverStyle) {
        if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY)) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY));
        var prolepticMonth = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH);
        if (prolepticMonth != null) {
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH.checkValidValue(prolepticMonth);
            this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR, $2e6f1e48aadbcba7$var$MathUtil.floorMod(prolepticMonth, 12) + 1);
            this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, $2e6f1e48aadbcba7$var$MathUtil.floorDiv(prolepticMonth, 12));
        }
        var yoeLong = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA);
        if (yoeLong != null) {
            if (resolverStyle !== $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA.checkValidValue(yoeLong);
            var era = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            if (era == null) {
                var year = fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR);
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT) {
                    if (year != null) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, year > 0 ? yoeLong : $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
                    else fieldValues.put($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA, yoeLong);
                } else this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, year == null || year > 0 ? yoeLong : $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
            } else if (era === 1) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, yoeLong);
            else if (era === 0) this._updateResolveMap(fieldValues, $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR, $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(1, yoeLong));
            else throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid value for era: " + era);
        } else if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA)) $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA.checkValidValue(fieldValues.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA));
        if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR)) {
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR)) {
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH)) {
                    var y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    var moy = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR);
                    var dom = fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH);
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var months = moy - 1;
                        var days = dom - 1;
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, 1, 1).plusMonths(months).plusDays(days);
                    } else if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.SMART) {
                        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dom);
                        if (moy === 4 || moy === 6 || moy === 9 || moy === 11) dom = Math.min(dom, 30);
                        else if (moy === 2) dom = Math.min(dom, $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY.length($2e6f1e48aadbcba7$export$6ce2f08d515512.isLeap(y)));
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, moy, dom);
                    } else return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(y, moy, dom);
                }
            }
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR)) {
                var _y = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                    var _days = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR), 1);
                    return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(_y, 1).plusDays(_days);
                }
                var doy = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR));
                return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofYearDay(_y, doy);
            }
            if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR)) {
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR)) {
                    var _y2 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var weeks = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days2 = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR), 1);
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusWeeks(weeks).plusDays(_days2);
                    }
                    var aw = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var ad = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                    var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y2, 1, 1).plusDays((aw - 1) * 7 + (ad - 1));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT && date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) !== _y2) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Strict mode rejected date parsed to a different year");
                    return date;
                }
                if (fieldValues.containsKey($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK)) {
                    var _y3 = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.LENIENT) {
                        var _weeks = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR), 1);
                        var _days3 = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK), 1);
                        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_weeks).plusDays(_days3);
                    }
                    var _aw = $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                    var dow = $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK.checkValidIntValue(fieldValues.remove($2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK));
                    var _date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(_y3, 1, 1).plusWeeks(_aw - 1).with($2e6f1e48aadbcba7$export$d922854d56f8a965.nextOrSame($2e6f1e48aadbcba7$export$7ed5ca4f8b987938.of(dow)));
                    if (resolverStyle === $2e6f1e48aadbcba7$export$2a833e4d13229d66.STRICT && _date.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR) !== _y3) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Strict mode rejected date parsed to a different month");
                    return _date;
                }
            }
        }
        return null;
    };
    _proto.date = function date(temporal) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
    };
    return IsoChronology;
}($2e6f1e48aadbcba7$var$Enum);
function $2e6f1e48aadbcba7$var$_init$e() {
    $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE = new $2e6f1e48aadbcba7$export$f47ae290cf4e4958("IsoChronology");
}
var $2e6f1e48aadbcba7$export$a362394fcc906a80 = function(_DefaultInterfaceTemp) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetTime, _DefaultInterfaceTemp);
    OffsetTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof OffsetTime) return temporal;
        else if (temporal instanceof $2e6f1e48aadbcba7$export$f351e12f7a164fb5) return temporal.toOffsetTime();
        try {
            var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from(temporal);
            return new OffsetTime(time, offset);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain OffsetTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    OffsetTime.now = function now(clockOrZone) {
        if (arguments.length === 0) return OffsetTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return OffsetTime._now(clockOrZone);
        else return OffsetTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    OffsetTime._now = function _now(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, "clock");
        var now = clock.instant();
        return OffsetTime.ofInstant(now, clock.zone().rules().offset(now));
    };
    OffsetTime.of = function of() {
        if (arguments.length <= 2) return OffsetTime.ofTimeAndOffset.apply(this, arguments);
        else return OffsetTime.ofNumbers.apply(this, arguments);
    };
    OffsetTime.ofNumbers = function ofNumbers(hour, minute, second, nanoOfSecond, offset) {
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond);
        return new OffsetTime(time, offset);
    };
    OffsetTime.ofTimeAndOffset = function ofTimeAndOffset(time, offset) {
        return new OffsetTime(time, offset);
    };
    OffsetTime.ofInstant = function ofInstant(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, "instant");
        $2e6f1e48aadbcba7$var$requireInstance(instant, $2e6f1e48aadbcba7$export$fecec53969739358, "instant");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        $2e6f1e48aadbcba7$var$requireInstance(zone, $2e6f1e48aadbcba7$export$a514a0be1f00ef62, "zone");
        var rules = zone.rules();
        var offset = rules.offset(instant);
        var secsOfDay = instant.epochSecond() % $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        secsOfDay = (secsOfDay + offset.totalSeconds()) % $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        if (secsOfDay < 0) secsOfDay += $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY;
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, instant.nano());
        return new OffsetTime(time, offset);
    };
    OffsetTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, OffsetTime.FROM);
    };
    function OffsetTime(time, offset) {
        var _this;
        _this = _DefaultInterfaceTemp.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(time, "time");
        $2e6f1e48aadbcba7$var$requireInstance(time, $2e6f1e48aadbcba7$export$bf1071e344bea1d, "time");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, "offset");
        _this._time = time;
        _this._offset = offset;
        return _this;
    }
    var _proto = OffsetTime.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this._time.toNanoOfDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this.offset().totalSeconds());
    };
    _proto.atDate = function atDate(date) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(date, this._time, this._offset);
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this, OffsetTime.FROM);
    };
    _proto.get = function get(field) {
        return _DefaultInterfaceTemp.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._offset.totalSeconds();
            return this._time.getLong(field);
        }
        return field.getFrom(this);
    };
    _proto.hour = function hour() {
        return this._time.hour();
    };
    _proto.minute = function minute() {
        return this._time.minute();
    };
    _proto.second = function second() {
        return this._time.second();
    };
    _proto.nano = function nano() {
        return this._time.nano();
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return this._toEpochNano() > other._toEpochNano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return this._toEpochNano() < other._toEpochNano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return this._toEpochNano() === other._toEpochNano();
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isTimeBased() || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS;
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._withLocalTimeOffset(this._time.minusHours(hours), this._offset);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._withLocalTimeOffset(this._time.minusMinutes(minutes), this._offset);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._withLocalTimeOffset(this._time.minusSeconds(seconds), this._offset);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._withLocalTimeOffset(this._time.minusNanos(nanos), this._offset);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return this.plus(-1 * amountToSubtract, unit);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return this._withLocalTimeOffset(this._time.plus(amountToAdd, unit), this._offset);
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._withLocalTimeOffset(this._time.plusHours(hours), this._offset);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._withLocalTimeOffset(this._time.plusMinutes(minutes), this._offset);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._withLocalTimeOffset(this._time.plusSeconds(seconds), this._offset);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._withLocalTimeOffset(this._time.plusNanos(nanos), this._offset);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this._time;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _DefaultInterfaceTemp.prototype.query.call(this, _query);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._time.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._time;
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withLocalTimeOffset(this._time.truncatedTo(unit), this._offset);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        var end = OffsetTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var nanosUntil = end._toEpochNano() - this._toEpochNano();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return nanosUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return Math.floor(nanosUntil / 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return Math.floor(nanosUntil / 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return Math.floor(nanosUntil / $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return Math.floor(nanosUntil / $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return Math.floor(nanosUntil / $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return Math.floor(nanosUntil / (12 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.withHour = function withHour(hour) {
        return this._withLocalTimeOffset(this._time.withHour(hour), this._offset);
    };
    _proto.withMinute = function withMinute(minute) {
        return this._withLocalTimeOffset(this._time.withMinute(minute), this._offset);
    };
    _proto.withSecond = function withSecond(second) {
        return this._withLocalTimeOffset(this._time.withSecond(second), this._offset);
    };
    _proto.withNano = function withNano(nano) {
        return this._withLocalTimeOffset(this._time.withNano(nano), this._offset);
    };
    _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        if (offset.equals(this._offset)) return this;
        var difference = offset.totalSeconds() - this._offset.totalSeconds();
        var adjusted = this._time.plusSeconds(difference);
        return new OffsetTime(adjusted, offset);
    };
    _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
        return offset != null && offset.equals(this._offset) ? this : new OffsetTime(this._time, offset);
    };
    _proto._toEpochNano = function _toEpochNano() {
        var nod = this._time.toNanoOfDay();
        var offsetNanos = this._offset.totalSeconds() * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
        return nod - offsetNanos;
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._withLocalTimeOffset(adjuster, this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._withLocalTimeOffset(this._time, adjuster);
        else if (adjuster instanceof OffsetTime) return adjuster;
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return this._withLocalTimeOffset(this._time, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(field.checkValidIntValue(newValue)));
            return this._withLocalTimeOffset(this._time.with(field, newValue), this._offset);
        }
        return field.adjustInto(this, newValue);
    };
    _proto._withLocalTimeOffset = function _withLocalTimeOffset(time, offset) {
        if (this._time === time && this._offset.equals(offset)) return this;
        return new OffsetTime(time, offset);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, OffsetTime, "other");
        if (this._offset.equals(other._offset)) return this._time.compareTo(other._time);
        var compare = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._toEpochNano(), other._toEpochNano());
        if (compare === 0) return this._time.compareTo(other._time);
        return compare;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof OffsetTime) return this._time.equals(other._time) && this._offset.equals(other._offset);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._time.hashCode() ^ this._offset.hashCode();
    };
    _proto.toString = function toString() {
        return this._time.toString() + this._offset.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return OffsetTime;
}($2e6f1e48aadbcba7$var$DefaultInterfaceTemporal);
function $2e6f1e48aadbcba7$var$_init$f() {
    $2e6f1e48aadbcba7$export$a362394fcc906a80.MIN = $2e6f1e48aadbcba7$export$a362394fcc906a80.ofNumbers(0, 0, 0, 0, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX);
    $2e6f1e48aadbcba7$export$a362394fcc906a80.MAX = $2e6f1e48aadbcba7$export$a362394fcc906a80.ofNumbers(23, 59, 59, 999999999, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN);
    $2e6f1e48aadbcba7$export$a362394fcc906a80.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("OffsetTime.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$a362394fcc906a80.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$e69f60c5a83f5572 = function(_DefaultInterfaceTemp) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoZonedDateTime, _DefaultInterfaceTemp);
    function ChronoZonedDateTime() {
        return _DefaultInterfaceTemp.apply(this, arguments) || this;
    }
    var _proto = ChronoZonedDateTime.prototype;
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.zone();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.toLocalDate().chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        return _DefaultInterfaceTemp.prototype.query.call(this, _query);
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    _proto.toInstant = function toInstant() {
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond() {
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= this.offset().totalSeconds();
        return secs;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
        if (cmp === 0) {
            cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
            if (cmp === 0) {
                cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
                if (cmp === 0) cmp = $2e6f1e48aadbcba7$var$strcmp(this.zone().id(), other.zone().id());
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ChronoZonedDateTime) return this.compareTo(other) === 0;
        return false;
    };
    return ChronoZonedDateTime;
}($2e6f1e48aadbcba7$var$DefaultInterfaceTemporal);
function $2e6f1e48aadbcba7$var$strcmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
var $2e6f1e48aadbcba7$export$d3b7288e7994edea = function(_ChronoZonedDateTime) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ZonedDateTime, _ChronoZonedDateTime);
    ZonedDateTime.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone == null ? $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone() : clockOrZone;
        return ZonedDateTime.ofInstant(clock.instant(), clock.zone());
    };
    ZonedDateTime.of = function of() {
        if (arguments.length <= 2) return ZonedDateTime.of2.apply(this, arguments);
        else if (arguments.length === 3 && arguments[0] instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return ZonedDateTime.of3.apply(this, arguments);
        else return ZonedDateTime.of8.apply(this, arguments);
    };
    ZonedDateTime.of3 = function of3(date, time, zone) {
        return ZonedDateTime.of2($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, time), zone);
    };
    ZonedDateTime.of2 = function of2(localDateTime, zone) {
        return ZonedDateTime.ofLocal(localDateTime, zone, null);
    };
    ZonedDateTime.of8 = function of8(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, zone) {
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
        return ZonedDateTime.ofLocal(dt, zone, null);
    };
    ZonedDateTime.ofLocal = function ofLocal(localDateTime, zone, preferredOffset) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, "localDateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return new ZonedDateTime(localDateTime, zone, zone);
        var offset = null;
        var rules = zone.rules();
        var validOffsets = rules.validOffsets(localDateTime);
        if (validOffsets.length === 1) offset = validOffsets[0];
        else if (validOffsets.length === 0) {
            var trans = rules.transition(localDateTime);
            localDateTime = localDateTime.plusSeconds(trans.duration().seconds());
            offset = trans.offsetAfter();
        } else if (preferredOffset != null && validOffsets.some(function(validOffset) {
            return validOffset.equals(preferredOffset);
        })) offset = preferredOffset;
        else offset = $2e6f1e48aadbcba7$var$requireNonNull(validOffsets[0], "offset");
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofInstant = function ofInstant() {
        if (arguments.length === 2) return ZonedDateTime.ofInstant2.apply(this, arguments);
        else return ZonedDateTime.ofInstant3.apply(this, arguments);
    };
    ZonedDateTime.ofInstant2 = function ofInstant2(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, "instant");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        return ZonedDateTime._create(instant.epochSecond(), instant.nano(), zone);
    };
    ZonedDateTime.ofInstant3 = function ofInstant3(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, "localDateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        return ZonedDateTime._create(localDateTime.toEpochSecond(offset), localDateTime.nano(), zone);
    };
    ZonedDateTime._create = function _create(epochSecond, nanoOfSecond, zone) {
        var rules = zone.rules();
        var instant = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(epochSecond, nanoOfSecond);
        var offset = rules.offset(instant);
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(epochSecond, nanoOfSecond, offset);
        return new ZonedDateTime(ldt, offset, zone);
    };
    ZonedDateTime.ofStrict = function ofStrict(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, "localDateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        var rules = zone.rules();
        if (rules.isValidOffset(localDateTime, offset) === false) {
            var trans = rules.transition(localDateTime);
            if (trans != null && trans.isGap()) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("LocalDateTime " + localDateTime + " does not exist in zone " + zone + " due to a gap in the local time-line, typically caused by daylight savings");
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb('ZoneOffset "' + offset + '" is not valid for LocalDateTime "' + localDateTime + '" in zone "' + zone + '"');
        }
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.ofLenient = function ofLenient(localDateTime, offset, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(localDateTime, "localDateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 && offset.equals(zone) === false) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("ZoneId must match ZoneOffset");
        return new ZonedDateTime(localDateTime, offset, zone);
    };
    ZonedDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof ZonedDateTime) return temporal;
        var zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.from(temporal);
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS)) {
            var zdt = ZonedDateTime._from(temporal, zone);
            if (zdt != null) return zdt;
        }
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
        return ZonedDateTime.of2(ldt, zone);
    };
    ZonedDateTime._from = function _from(temporal, zone) {
        try {
            return ZonedDateTime.__from(temporal, zone);
        } catch (ex) {
            if (!(ex instanceof $2e6f1e48aadbcba7$export$6058f27c7f907fb)) throw ex;
        }
    };
    ZonedDateTime.__from = function __from(temporal, zone) {
        var epochSecond = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
        var nanoOfSecond = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
        return ZonedDateTime._create(epochSecond, nanoOfSecond, zone);
    };
    ZonedDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_ZONED_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, ZonedDateTime.FROM);
    };
    function ZonedDateTime(dateTime, offset, zone) {
        var _this;
        $2e6f1e48aadbcba7$var$requireNonNull(dateTime, "dateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        _this = _ChronoZonedDateTime.call(this) || this;
        _this._dateTime = dateTime;
        _this._offset = offset;
        _this._zone = zone;
        return _this;
    }
    var _proto = ZonedDateTime.prototype;
    _proto._resolveLocal = function _resolveLocal(newDateTime) {
        $2e6f1e48aadbcba7$var$requireNonNull(newDateTime, "newDateTime");
        return ZonedDateTime.ofLocal(newDateTime, this._zone, this._offset);
    };
    _proto._resolveInstant = function _resolveInstant(newDateTime) {
        return ZonedDateTime.ofInstant3(newDateTime, this._offset, this._zone);
    };
    _proto._resolveOffset = function _resolveOffset(offset) {
        if (offset.equals(this._offset) === false && this._zone.rules().isValidOffset(this._dateTime, offset)) return new ZonedDateTime(this._dateTime, offset, this._zone);
        return this;
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return true;
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._dateTime.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this.toEpochSecond();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this._offset.totalSeconds();
            }
            return this._dateTime.getLong(field);
        }
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        return field.getFrom(this);
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.withEarlierOffsetAtOverlap = function withEarlierOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this._dateTime);
        if (trans != null && trans.isOverlap()) {
            var earlierOffset = trans.offsetBefore();
            if (earlierOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, earlierOffset, this._zone);
        }
        return this;
    };
    _proto.withLaterOffsetAtOverlap = function withLaterOffsetAtOverlap() {
        var trans = this._zone.rules().transition(this.toLocalDateTime());
        if (trans != null) {
            var laterOffset = trans.offsetAfter();
            if (laterOffset.equals(this._offset) === false) return new ZonedDateTime(this._dateTime, laterOffset, this._zone);
        }
        return this;
    };
    _proto.zone = function zone() {
        return this._zone;
    };
    _proto.withZoneSameLocal = function withZoneSameLocal(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        return this._zone.equals(zone) ? this : ZonedDateTime.ofLocal(this._dateTime, zone, this._offset);
    };
    _proto.withZoneSameInstant = function withZoneSameInstant(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        return this._zone.equals(zone) ? this : ZonedDateTime._create(this._dateTime.toEpochSecond(this._offset), this._dateTime.nano(), zone);
    };
    _proto.withFixedOffsetZone = function withFixedOffsetZone() {
        return this._zone.equals(this._offset) ? this : new ZonedDateTime(this._dateTime, this._offset, this._offset);
    };
    _proto.year = function year() {
        return this._dateTime.year();
    };
    _proto.monthValue = function monthValue() {
        return this._dateTime.monthValue();
    };
    _proto.month = function month() {
        return this._dateTime.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._dateTime.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._dateTime.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._dateTime.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._dateTime.hour();
    };
    _proto.minute = function minute() {
        return this._dateTime.minute();
    };
    _proto.second = function second() {
        return this._dateTime.second();
    };
    _proto.nano = function nano() {
        return this._dateTime.nano();
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return this._resolveLocal($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(adjuster, this._dateTime.toLocalTime()));
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._resolveLocal($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this._dateTime.toLocalDate(), adjuster));
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) return this._resolveLocal(adjuster);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$fecec53969739358) {
            var instant = adjuster;
            return ZonedDateTime._create(instant.epochSecond(), instant.nano(), this._zone);
        } else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._resolveOffset(adjuster);
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return ZonedDateTime._create(newValue, this.nano(), this._zone);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(field.checkValidIntValue(newValue));
                    return this._resolveOffset(offset);
            }
            return this._resolveLocal(this._dateTime.with(field, newValue));
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._resolveLocal(this._dateTime.withYear(year));
    };
    _proto.withMonth = function withMonth(month) {
        return this._resolveLocal(this._dateTime.withMonth(month));
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._resolveLocal(this._dateTime.withDayOfMonth(dayOfMonth));
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._resolveLocal(this._dateTime.withDayOfYear(dayOfYear));
    };
    _proto.withHour = function withHour(hour) {
        return this._resolveLocal(this._dateTime.withHour(hour));
    };
    _proto.withMinute = function withMinute(minute) {
        return this._resolveLocal(this._dateTime.withMinute(minute));
    };
    _proto.withSecond = function withSecond(second) {
        return this._resolveLocal(this._dateTime.withSecond(second));
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        return this._resolveLocal(this._dateTime.withNano(nanoOfSecond));
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._resolveLocal(this._dateTime.truncatedTo(unit));
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            if (unit.isDateBased()) return this._resolveLocal(this._dateTime.plus(amountToAdd, unit));
            else return this._resolveInstant(this._dateTime.plus(amountToAdd, unit));
        }
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        return this._resolveLocal(this._dateTime.plusYears(years));
    };
    _proto.plusMonths = function plusMonths(months) {
        return this._resolveLocal(this._dateTime.plusMonths(months));
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        return this._resolveLocal(this._dateTime.plusWeeks(weeks));
    };
    _proto.plusDays = function plusDays(days) {
        return this._resolveLocal(this._dateTime.plusDays(days));
    };
    _proto.plusHours = function plusHours(hours) {
        return this._resolveInstant(this._dateTime.plusHours(hours));
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._resolveInstant(this._dateTime.plusMinutes(minutes));
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._resolveInstant(this._dateTime.plusSeconds(seconds));
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._resolveInstant(this._dateTime.plusNanos(nanos));
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return this.plusAmountUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this.plusHours(-1 * hours);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this.plusMinutes(-1 * minutes);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this.plusSeconds(-1 * seconds);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this.plusNanos(-1 * nanos);
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        return _ChronoZonedDateTime.prototype.query.call(this, _query);
    };
    _proto.until = function until(endExclusive, unit) {
        var end = ZonedDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            end = end.withZoneSameInstant(this._zone);
            if (unit.isDateBased()) return this._dateTime.until(end._dateTime, unit);
            else {
                var difference = this._offset.totalSeconds() - end._offset.totalSeconds();
                var adjustedEnd = end._dateTime.plusSeconds(difference);
                return this._dateTime.until(adjustedEnd, unit);
            }
        }
        return unit.between(this, end);
    };
    _proto.toLocalDateTime = function toLocalDateTime() {
        return this._dateTime;
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._dateTime.toLocalDate();
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._dateTime.toLocalTime();
    };
    _proto.toOffsetDateTime = function toOffsetDateTime() {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(this._dateTime, this._offset);
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof ZonedDateTime) return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset) && this._zone.equals(other._zone);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._dateTime.hashCode(), this._offset.hashCode(), this._zone.hashCode());
    };
    _proto.toString = function toString() {
        var str = this._dateTime.toString() + this._offset.toString();
        if (this._offset !== this._zone) str += "[" + this._zone.toString() + "]";
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        return _ChronoZonedDateTime.prototype.format.call(this, formatter);
    };
    return ZonedDateTime;
}($2e6f1e48aadbcba7$export$e69f60c5a83f5572);
function $2e6f1e48aadbcba7$var$_init$g() {
    $2e6f1e48aadbcba7$export$d3b7288e7994edea.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("ZonedDateTime.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$f351e12f7a164fb5 = function(_DefaultInterfaceTemp) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetDateTime, _DefaultInterfaceTemp);
    OffsetDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof OffsetDateTime) return temporal;
        try {
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from(temporal);
            try {
                var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
                return OffsetDateTime.of(ldt, offset);
            } catch (_) {
                var instant = $2e6f1e48aadbcba7$export$fecec53969739358.from(temporal);
                return OffsetDateTime.ofInstant(instant, offset);
            }
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain OffsetDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    OffsetDateTime.now = function now(clockOrZone) {
        if (arguments.length === 0) return OffsetDateTime.now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else {
            $2e6f1e48aadbcba7$var$requireNonNull(clockOrZone, "clockOrZone");
            if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) return OffsetDateTime.now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
            else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) {
                var now = clockOrZone.instant();
                return OffsetDateTime.ofInstant(now, clockOrZone.zone().rules().offset(now));
            } else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("clockOrZone must be an instance of ZoneId or Clock");
        }
    };
    OffsetDateTime.of = function of() {
        if (arguments.length <= 2) return OffsetDateTime.ofDateTime.apply(this, arguments);
        else if (arguments.length === 3) return OffsetDateTime.ofDateAndTime.apply(this, arguments);
        else return OffsetDateTime.ofNumbers.apply(this, arguments);
    };
    OffsetDateTime.ofDateTime = function ofDateTime(dateTime, offset) {
        return new OffsetDateTime(dateTime, offset);
    };
    OffsetDateTime.ofDateAndTime = function ofDateAndTime(date, time, offset) {
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, time);
        return new OffsetDateTime(dt, offset);
    };
    OffsetDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond, offset) {
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        var dt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(year, month, dayOfMonth, hour, minute, second, nanoOfSecond);
        return new OffsetDateTime(dt, offset);
    };
    OffsetDateTime.ofInstant = function ofInstant(instant, zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(instant, "instant");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        var rules = zone.rules();
        var offset = rules.offset(instant);
        var ldt = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
        return new OffsetDateTime(ldt, offset);
    };
    OffsetDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_OFFSET_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, OffsetDateTime.FROM);
    };
    function OffsetDateTime(dateTime, offset) {
        var _this;
        _this = _DefaultInterfaceTemp.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(dateTime, "dateTime");
        $2e6f1e48aadbcba7$var$requireInstance(dateTime, $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff, "dateTime");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, "offset");
        _this._dateTime = dateTime;
        _this._offset = offset;
        return _this;
    }
    var _proto = OffsetDateTime.prototype;
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toLocalDate().toEpochDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this.toLocalTime().toNanoOfDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS, this.offset().totalSeconds());
    };
    _proto.until = function until(endExclusive, unit) {
        var end = OffsetDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            end = end.withOffsetSameInstant(this._offset);
            return this._dateTime.until(end._dateTime, unit);
        }
        return unit.between(this, end);
    };
    _proto.atZoneSameInstant = function atZoneSameInstant(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofInstant(this._dateTime, this._offset, zone);
    };
    _proto.atZoneSimilarLocal = function atZoneSimilarLocal(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofLocal(this._dateTime, zone, this._offset);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this.offset();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId()) return null;
        return _DefaultInterfaceTemp.prototype.query.call(this, _query);
    };
    _proto.get = function get(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Field too large for an int: " + field);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this.offset().totalSeconds();
            }
            return this._dateTime.get(field);
        }
        return _DefaultInterfaceTemp.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this.toEpochSecond();
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this.offset().totalSeconds();
            }
            return this._dateTime.getLong(field);
        }
        return field.getFrom(this);
    };
    _proto.offset = function offset() {
        return this._offset;
    };
    _proto.year = function year() {
        return this._dateTime.year();
    };
    _proto.monthValue = function monthValue() {
        return this._dateTime.monthValue();
    };
    _proto.month = function month() {
        return this._dateTime.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._dateTime.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._dateTime.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._dateTime.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._dateTime.hour();
    };
    _proto.minute = function minute() {
        return this._dateTime.minute();
    };
    _proto.second = function second() {
        return this._dateTime.second();
    };
    _proto.nano = function nano() {
        return this._dateTime.nano();
    };
    _proto.toLocalDateTime = function toLocalDateTime() {
        return this._dateTime;
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._dateTime.toLocalDate();
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._dateTime.toLocalTime();
    };
    _proto.toOffsetTime = function toOffsetTime() {
        return $2e6f1e48aadbcba7$export$a362394fcc906a80.of(this._dateTime.toLocalTime(), this._offset);
    };
    _proto.toZonedDateTime = function toZonedDateTime() {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(this._dateTime, this._offset);
    };
    _proto.toInstant = function toInstant() {
        return this._dateTime.toInstant(this._offset);
    };
    _proto.toEpochSecond = function toEpochSecond() {
        return this._dateTime.toEpochSecond(this._offset);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS) return field.range();
            return this._dateTime.range(field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster);
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6 || adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d || adjuster instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) return this._withDateTimeOffset(this._dateTime.with(adjuster), this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$fecec53969739358) return OffsetDateTime.ofInstant(adjuster, this._offset);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) return this._withDateTimeOffset(this._dateTime, adjuster);
        else if (adjuster instanceof OffsetDateTime) return adjuster;
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return OffsetDateTime.ofInstant($2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(newValue, this.nano()), this._offset);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS:
                    return this._withDateTimeOffset(this._dateTime, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(f.checkValidIntValue(newValue)));
            }
            return this._withDateTimeOffset(this._dateTime.with(field, newValue), this._offset);
        }
        return field.adjustInto(this, newValue);
    };
    _proto._withDateTimeOffset = function _withDateTimeOffset(dateTime, offset) {
        if (this._dateTime === dateTime && this._offset.equals(offset)) return this;
        return new OffsetDateTime(dateTime, offset);
    };
    _proto.withYear = function withYear(year) {
        return this._withDateTimeOffset(this._dateTime.withYear(year), this._offset);
    };
    _proto.withMonth = function withMonth(month) {
        return this._withDateTimeOffset(this._dateTime.withMonth(month), this._offset);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._withDateTimeOffset(this._dateTime.withDayOfMonth(dayOfMonth), this._offset);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._withDateTimeOffset(this._dateTime.withDayOfYear(dayOfYear), this._offset);
    };
    _proto.withHour = function withHour(hour) {
        return this._withDateTimeOffset(this._dateTime.withHour(hour), this._offset);
    };
    _proto.withMinute = function withMinute(minute) {
        return this._withDateTimeOffset(this._dateTime.withMinute(minute), this._offset);
    };
    _proto.withSecond = function withSecond(second) {
        return this._withDateTimeOffset(this._dateTime.withSecond(second), this._offset);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        return this._withDateTimeOffset(this._dateTime.withNano(nanoOfSecond), this._offset);
    };
    _proto.withOffsetSameLocal = function withOffsetSameLocal(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        return this._withDateTimeOffset(this._dateTime, offset);
    };
    _proto.withOffsetSameInstant = function withOffsetSameInstant(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        if (offset.equals(this._offset)) return this;
        var difference = offset.totalSeconds() - this._offset.totalSeconds();
        var adjusted = this._dateTime.plusSeconds(difference);
        return new OffsetDateTime(adjusted, offset);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withDateTimeOffset(this._dateTime.truncatedTo(unit), this._offset);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return this._withDateTimeOffset(this._dateTime.plus(amountToAdd, unit), this._offset);
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        return this._withDateTimeOffset(this._dateTime.plusYears(years), this._offset);
    };
    _proto.plusMonths = function plusMonths(months) {
        return this._withDateTimeOffset(this._dateTime.plusMonths(months), this._offset);
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        return this._withDateTimeOffset(this._dateTime.plusWeeks(weeks), this._offset);
    };
    _proto.plusDays = function plusDays(days) {
        return this._withDateTimeOffset(this._dateTime.plusDays(days), this._offset);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._withDateTimeOffset(this._dateTime.plusHours(hours), this._offset);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._withDateTimeOffset(this._dateTime.plusMinutes(minutes), this._offset);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._withDateTimeOffset(this._dateTime.plusSeconds(seconds), this._offset);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._withDateTimeOffset(this._dateTime.plusNanos(nanos), this._offset);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount);
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return this.plus(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this._withDateTimeOffset(this._dateTime.minusYears(years), this._offset);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this._withDateTimeOffset(this._dateTime.minusMonths(months), this._offset);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this._withDateTimeOffset(this._dateTime.minusWeeks(weeks), this._offset);
    };
    _proto.minusDays = function minusDays(days) {
        return this._withDateTimeOffset(this._dateTime.minusDays(days), this._offset);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._withDateTimeOffset(this._dateTime.minusHours(hours), this._offset);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._withDateTimeOffset(this._dateTime.minusMinutes(minutes), this._offset);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._withDateTimeOffset(this._dateTime.minusSeconds(seconds), this._offset);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._withDateTimeOffset(this._dateTime.minusNanos(nanos), this._offset);
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, OffsetDateTime, "other");
        if (this.offset().equals(other.offset())) return this.toLocalDateTime().compareTo(other.toLocalDateTime());
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this.toEpochSecond(), other.toEpochSecond());
        if (cmp === 0) {
            cmp = this.toLocalTime().nano() - other.toLocalTime().nano();
            if (cmp === 0) cmp = this.toLocalDateTime().compareTo(other.toLocalDateTime());
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec > otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() > other.toLocalTime().nano();
    };
    _proto.isBefore = function isBefore(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        var thisEpochSec = this.toEpochSecond();
        var otherEpochSec = other.toEpochSecond();
        return thisEpochSec < otherEpochSec || thisEpochSec === otherEpochSec && this.toLocalTime().nano() < other.toLocalTime().nano();
    };
    _proto.isEqual = function isEqual(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        return this.toEpochSecond() === other.toEpochSecond() && this.toLocalTime().nano() === other.toLocalTime().nano();
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof OffsetDateTime) return this._dateTime.equals(other._dateTime) && this._offset.equals(other._offset);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._dateTime.hashCode() ^ this._offset.hashCode();
    };
    _proto.toString = function toString() {
        return this._dateTime.toString() + this._offset.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return OffsetDateTime;
}($2e6f1e48aadbcba7$var$DefaultInterfaceTemporal);
function $2e6f1e48aadbcba7$var$_init$h() {
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.MIN = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MIN.atOffset($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MAX);
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.MAX = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MAX.atOffset($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.MIN);
    $2e6f1e48aadbcba7$export$f351e12f7a164fb5.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("OffsetDateTime.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.from(temporal);
    });
}
var $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE = 146097;
var $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970 = $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE * 5 - 10957;
var $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6 = function(_ChronoLocalDate) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalDate, _ChronoLocalDate);
    LocalDate.now = function now(clockOrZone) {
        var clock;
        if (clockOrZone == null) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone();
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$a514a0be1f00ef62) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone);
        else clock = clockOrZone;
        return LocalDate.ofInstant(clock.instant(), clock.zone());
    };
    LocalDate.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        $2e6f1e48aadbcba7$var$requireNonNull(instant, "instant");
        var offset = zone.rules().offset(instant);
        var epochSec = instant.epochSecond() + offset.totalSeconds();
        var epochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochSec, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        return LocalDate.ofEpochDay(epochDay);
    };
    LocalDate.of = function of(year, month, dayOfMonth) {
        return new LocalDate(year, month, dayOfMonth);
    };
    LocalDate.ofYearDay = function ofYearDay(year, dayOfYear) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        var leap = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year);
        if (dayOfYear === 366 && leap === false) $2e6f1e48aadbcba7$var$assert(false, "Invalid date 'DayOfYear 366' as '" + year + "' is not a leap year", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
        var moy = $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(Math.floor((dayOfYear - 1) / 31 + 1));
        var monthEnd = moy.firstDayOfYear(leap) + moy.length(leap) - 1;
        if (dayOfYear > monthEnd) moy = moy.plus(1);
        var dom = dayOfYear - moy.firstDayOfYear(leap) + 1;
        return new LocalDate(year, moy.value(), dom);
    };
    LocalDate.ofEpochDay = function ofEpochDay(epochDay) {
        if (epochDay === void 0) epochDay = 0;
        var adjust, adjustCycles, doyEst, yearEst, zeroDay;
        zeroDay = epochDay + $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970;
        zeroDay -= 60;
        adjust = 0;
        if (zeroDay < 0) {
            adjustCycles = $2e6f1e48aadbcba7$var$MathUtil.intDiv(zeroDay + 1, $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE) - 1;
            adjust = adjustCycles * 400;
            zeroDay += -adjustCycles * $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE;
        }
        yearEst = $2e6f1e48aadbcba7$var$MathUtil.intDiv(400 * zeroDay + 591, $2e6f1e48aadbcba7$var$DAYS_PER_CYCLE);
        doyEst = zeroDay - (365 * yearEst + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 400));
        if (doyEst < 0) {
            yearEst--;
            doyEst = zeroDay - (365 * yearEst + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(yearEst, 400));
        }
        yearEst += adjust;
        var marchDoy0 = doyEst;
        var marchMonth0 = $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchDoy0 * 5 + 2, 153);
        var month = (marchMonth0 + 2) % 12 + 1;
        var dom = marchDoy0 - $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchMonth0 * 306 + 5, 10) + 1;
        yearEst += $2e6f1e48aadbcba7$var$MathUtil.intDiv(marchMonth0, 10);
        var year = yearEst;
        return new LocalDate(year, month, dom);
    };
    LocalDate.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        var date = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate());
        if (date == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalDate from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return date;
    };
    LocalDate.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE;
        $2e6f1e48aadbcba7$var$assert(formatter != null, "formatter", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        return formatter.parse(text, LocalDate.FROM);
    };
    LocalDate._resolvePreviousValid = function _resolvePreviousValid(year, month, day) {
        switch(month){
            case 2:
                day = Math.min(day, $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28);
                break;
            case 4:
            case 6:
            case 9:
            case 11:
                day = Math.min(day, 30);
                break;
        }
        return LocalDate.of(year, month, day);
    };
    function LocalDate(year, month, dayOfMonth) {
        var _this;
        _this = _ChronoLocalDate.call(this) || this;
        $2e6f1e48aadbcba7$var$requireNonNull(year, "year");
        $2e6f1e48aadbcba7$var$requireNonNull(month, "month");
        $2e6f1e48aadbcba7$var$requireNonNull(dayOfMonth, "dayOfMonth");
        if (month instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6) month = month.value();
        _this._year = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(year);
        _this._month = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(month);
        _this._day = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(dayOfMonth);
        LocalDate._validate(_this._year, _this._month, _this._day);
        return _this;
    }
    LocalDate._validate = function _validate(year, month, dayOfMonth) {
        var dom;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(month);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH.checkValidValue(dayOfMonth);
        if (dayOfMonth > 28) {
            dom = 31;
            switch(month){
                case 2:
                    dom = $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(year) ? 29 : 28;
                    break;
                case 4:
                case 6:
                case 9:
                case 11:
                    dom = 30;
            }
            if (dayOfMonth > dom) {
                if (dayOfMonth === 29) $2e6f1e48aadbcba7$var$assert(false, "Invalid date 'February 29' as '" + year + "' is not a leap year", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
                else $2e6f1e48aadbcba7$var$assert(false, "Invalid date '" + year + "' '" + month + "' '" + dayOfMonth + "'", $2e6f1e48aadbcba7$export$6058f27c7f907fb);
            }
        }
    };
    var _proto = LocalDate.prototype;
    _proto.isSupported = function isSupported(field) {
        return _ChronoLocalDate.prototype.isSupported.call(this, field);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field.isDateBased()) {
                switch(field){
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.lengthOfMonth());
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.lengthOfYear());
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                        return $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, this.month() === $2e6f1e48aadbcba7$export$951c8378cdfec6e6.FEBRUARY && this.isLeapYear() === false ? 4 : 5);
                    case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                        return this._year <= 0 ? $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE + 1) : $2e6f1e48aadbcba7$export$177e5e64bab4dec5.of(1, $2e6f1e48aadbcba7$export$6ce2f08d515512.MAX_VALUE);
                }
                return field.range();
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$assert(field != null, "", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK:
                return this.dayOfWeek().value();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this._day - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this.dayOfYear() - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                return this._day;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                return this.dayOfYear();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY:
                return this.toEpochDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._day - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.dayOfYear() - 1, 7) + 1;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                return this._month;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                return this._prolepticMonth();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                return this._year >= 1 ? this._year : 1 - this._year;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                return this._year;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                return this._year >= 1 ? 1 : 0;
        }
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto._prolepticMonth = function _prolepticMonth() {
        return this._year * 12 + (this._month - 1);
    };
    _proto.chronology = function chronology() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.INSTANCE;
    };
    _proto.year = function year() {
        return this._year;
    };
    _proto.monthValue = function monthValue() {
        return this._month;
    };
    _proto.month = function month() {
        return $2e6f1e48aadbcba7$export$951c8378cdfec6e6.of(this._month);
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._day;
    };
    _proto.dayOfYear = function dayOfYear() {
        return this.month().firstDayOfYear(this.isLeapYear()) + this._day - 1;
    };
    _proto.dayOfWeek = function dayOfWeek() {
        var dow0 = $2e6f1e48aadbcba7$var$MathUtil.floorMod(this.toEpochDay() + 3, 7);
        return $2e6f1e48aadbcba7$export$7ed5ca4f8b987938.of(dow0 + 1);
    };
    _proto.isLeapYear = function isLeapYear() {
        return $2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(this._year);
    };
    _proto.lengthOfMonth = function lengthOfMonth() {
        switch(this._month){
            case 2:
                return this.isLeapYear() ? 29 : 28;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            default:
                return 31;
        }
    };
    _proto.lengthOfYear = function lengthOfYear() {
        return this.isLeapYear() ? 366 : 365;
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof LocalDate) return adjuster;
        $2e6f1e48aadbcba7$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$assert(field != null, "field", $2e6f1e48aadbcba7$export$b6ad7a1de4697efd);
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            var f = field;
            f.checkValidValue(newValue);
            switch(f){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_WEEK:
                    return this.plusDays(newValue - this.dayOfWeek().value());
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH:
                    return this.plusDays(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR:
                    return this.plusDays(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_DAY_OF_WEEK_IN_YEAR));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_MONTH:
                    return this.withDayOfMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.DAY_OF_YEAR:
                    return this.withDayOfYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY:
                    return LocalDate.ofEpochDay(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH:
                    return this.plusWeeks(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR:
                    return this.plusWeeks(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ALIGNED_WEEK_OF_YEAR));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR:
                    return this.withMonth(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH:
                    return this.plusMonths(newValue - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.PROLEPTIC_MONTH));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR_OF_ERA:
                    return this.withYear(this._year >= 1 ? newValue : 1 - newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR:
                    return this.withYear(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA:
                    return this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) === newValue ? this : this.withYear(1 - this._year);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        if (this._year === year) return this;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidValue(year);
        return LocalDate._resolvePreviousValid(year, this._month, this._day);
    };
    _proto.withMonth = function withMonth(month) {
        var m = month instanceof $2e6f1e48aadbcba7$export$951c8378cdfec6e6 ? month.value() : month;
        if (this._month === m) return this;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MONTH_OF_YEAR.checkValidValue(m);
        return LocalDate._resolvePreviousValid(this._year, m, this._day);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        if (this._day === dayOfMonth) return this;
        return LocalDate.of(this._year, this._month, dayOfMonth);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        if (this.dayOfYear() === dayOfYear) return this;
        return LocalDate.ofYearDay(this._year, dayOfYear);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, "amountToAdd");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.plusDays(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS:
                    return this.plusWeeks(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this.plusMonths(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return this.plusYears(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 10));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 100));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return this.plusYears($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, 1000));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return this.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA, $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA), amountToAdd));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(yearsToAdd) {
        if (yearsToAdd === 0) return this;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue(this._year + yearsToAdd);
        return LocalDate._resolvePreviousValid(newYear, this._month, this._day);
    };
    _proto.plusMonths = function plusMonths(monthsToAdd) {
        if (monthsToAdd === 0) return this;
        var monthCount = this._year * 12 + (this._month - 1);
        var calcMonths = monthCount + monthsToAdd;
        var newYear = $2e6f1e48aadbcba7$export$7f55a40756153c3e.YEAR.checkValidIntValue($2e6f1e48aadbcba7$var$MathUtil.floorDiv(calcMonths, 12));
        var newMonth = $2e6f1e48aadbcba7$var$MathUtil.floorMod(calcMonths, 12) + 1;
        return LocalDate._resolvePreviousValid(newYear, newMonth, this._day);
    };
    _proto.plusWeeks = function plusWeeks(weeksToAdd) {
        return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(weeksToAdd, 7));
    };
    _proto.plusDays = function plusDays(daysToAdd) {
        if (daysToAdd === 0) return this;
        var mjDay = $2e6f1e48aadbcba7$var$MathUtil.safeAdd(this.toEpochDay(), daysToAdd);
        return LocalDate.ofEpochDay(mjDay);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToSubtract, "amountToSubtract");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        return this.plusAmountUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(yearsToSubtract) {
        return this.plusYears(yearsToSubtract * -1);
    };
    _proto.minusMonths = function minusMonths(monthsToSubtract) {
        return this.plusMonths(monthsToSubtract * -1);
    };
    _proto.minusWeeks = function minusWeeks(weeksToSubtract) {
        return this.plusWeeks(weeksToSubtract * -1);
    };
    _proto.minusDays = function minusDays(daysToSubtract) {
        return this.plusDays(daysToSubtract * -1);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this;
        return _ChronoLocalDate.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDate.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(p1, p2) {
        if (arguments.length < 2) return this.until1(p1);
        else return this.until2(p1, p2);
    };
    _proto.until2 = function until2(endExclusive, unit) {
        var end = LocalDate.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.daysUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.WEEKS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.daysUntil(end), 7);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MONTHS:
                    return this._monthsUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.YEARS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 12);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DECADES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 120);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.CENTURIES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 1200);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLENNIA:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._monthsUntil(end), 12000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.ERAS:
                    return end.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA) - this.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.ERA);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.daysUntil = function daysUntil(end) {
        return end.toEpochDay() - this.toEpochDay();
    };
    _proto._monthsUntil = function _monthsUntil(end) {
        var packed1 = this._prolepticMonth() * 32 + this.dayOfMonth();
        var packed2 = end._prolepticMonth() * 32 + end.dayOfMonth();
        return $2e6f1e48aadbcba7$var$MathUtil.intDiv(packed2 - packed1, 32);
    };
    _proto.until1 = function until1(endDate) {
        var end = LocalDate.from(endDate);
        var totalMonths = end._prolepticMonth() - this._prolepticMonth();
        var days = end._day - this._day;
        if (totalMonths > 0 && days < 0) {
            totalMonths--;
            var calcDate = this.plusMonths(totalMonths);
            days = end.toEpochDay() - calcDate.toEpochDay();
        } else if (totalMonths < 0 && days > 0) {
            totalMonths++;
            days -= end.lengthOfMonth();
        }
        var years = $2e6f1e48aadbcba7$var$MathUtil.intDiv(totalMonths, 12);
        var months = $2e6f1e48aadbcba7$var$MathUtil.intMod(totalMonths, 12);
        return $2e6f1e48aadbcba7$export$67186dcd8fa4f92f.of(years, months, days);
    };
    _proto.atTime = function atTime() {
        if (arguments.length === 1) return this.atTime1.apply(this, arguments);
        else return this.atTime4.apply(this, arguments);
    };
    _proto.atTime1 = function atTime1(time) {
        $2e6f1e48aadbcba7$var$requireNonNull(time, "time");
        if (time instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, time);
        else if (time instanceof $2e6f1e48aadbcba7$export$a362394fcc906a80) return this._atTimeOffsetTime(time);
        else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("time must be an instance of LocalTime or OffsetTime" + (time && time.constructor && time.constructor.name ? ", but is " + time.constructor.name : ""));
    };
    _proto.atTime4 = function atTime4(hour, minute, second, nanoOfSecond) {
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        return this.atTime1($2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond));
    };
    _proto._atTimeOffsetTime = function _atTimeOffsetTime(time) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of($2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, time.toLocalTime()), time.offset());
    };
    _proto.atStartOfDay = function atStartOfDay(zone) {
        if (zone != null) return this.atStartOfDayWithZone(zone);
        else return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(this, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT);
    };
    _proto.atStartOfDayWithZone = function atStartOfDayWithZone(zone) {
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        var ldt = this.atTime($2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT);
        if (zone instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3 === false) {
            var trans = zone.rules().transition(ldt);
            if (trans != null && trans.isGap()) ldt = trans.dateTimeAfter();
        }
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(ldt, zone);
    };
    _proto.toEpochDay = function toEpochDay() {
        var y = this._year;
        var m = this._month;
        var total = 0;
        total += 365 * y;
        if (y >= 0) total += $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 3, 4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 99, 100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(y + 399, 400);
        else total -= $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -4) - $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -100) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(y, -400);
        total += $2e6f1e48aadbcba7$var$MathUtil.intDiv(367 * m - 362, 12);
        total += this.dayOfMonth() - 1;
        if (m > 2) {
            total--;
            if (!$2e6f1e48aadbcba7$export$f47ae290cf4e4958.isLeapYear(y)) total--;
        }
        return total - $2e6f1e48aadbcba7$var$DAYS_0000_TO_1970;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalDate, "other");
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(otherDate) {
        var cmp = this._year - otherDate._year;
        if (cmp === 0) {
            cmp = this._month - otherDate._month;
            if (cmp === 0) cmp = this._day - otherDate._day;
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDate) return this._compareTo0(other) === 0;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        return $2e6f1e48aadbcba7$var$MathUtil.hash(yearValue & 0xFFFFF800 ^ (yearValue << 11) + (monthValue << 6) + dayValue);
    };
    _proto.toString = function toString() {
        var dayString, monthString, yearString;
        var yearValue = this._year;
        var monthValue = this._month;
        var dayValue = this._day;
        var absYear = Math.abs(yearValue);
        if (absYear < 1000) {
            if (yearValue < 0) yearString = "-" + ("" + (yearValue - 10000)).slice(-4);
            else yearString = ("" + (yearValue + 10000)).slice(-4);
        } else if (yearValue > 9999) yearString = "+" + yearValue;
        else yearString = "" + yearValue;
        if (monthValue < 10) monthString = "-0" + monthValue;
        else monthString = "-" + monthValue;
        if (dayValue < 10) dayString = "-0" + dayValue;
        else dayString = "-" + dayValue;
        return yearString + monthString + dayString;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        $2e6f1e48aadbcba7$var$requireInstance(formatter, $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c, "formatter");
        return _ChronoLocalDate.prototype.format.call(this, formatter);
    };
    return LocalDate;
}($2e6f1e48aadbcba7$export$2a07e3472bc98879);
function $2e6f1e48aadbcba7$var$_init$i() {
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MIN = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of($2e6f1e48aadbcba7$export$c04b60057299af61.MIN_VALUE, 1, 1);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MAX = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of($2e6f1e48aadbcba7$export$c04b60057299af61.MAX_VALUE, 12, 31);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.EPOCH_0 = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(0);
    $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("LocalDate.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$94e985176fb19d17 = function(_DefaultInterfaceTemp) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(ChronoLocalDateTime, _DefaultInterfaceTemp);
    function ChronoLocalDateTime() {
        return _DefaultInterfaceTemp.apply(this, arguments) || this;
    }
    var _proto = ChronoLocalDateTime.prototype;
    _proto.chronology = function chronology() {
        return this.toLocalDate().chronology();
    };
    _proto.query = function query(_query) {
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology()) return this.chronology();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(this.toLocalDate().toEpochDay());
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this.toLocalTime();
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _DefaultInterfaceTemp.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY, this.toLocalDate().toEpochDay()).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY, this.toLocalTime().toNanoOfDay());
    };
    _proto.toInstant = function toInstant(offset) {
        $2e6f1e48aadbcba7$var$requireInstance(offset, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3, "zoneId");
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond(this.toEpochSecond(offset), this.toLocalTime().nano());
    };
    _proto.toEpochSecond = function toEpochSecond(offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        var epochDay = this.toLocalDate().toEpochDay();
        var secs = epochDay * 86400 + this.toLocalTime().toSecondOfDay();
        secs -= offset.totalSeconds();
        return $2e6f1e48aadbcba7$var$MathUtil.safeToInt(secs);
    };
    return ChronoLocalDateTime;
}($2e6f1e48aadbcba7$var$DefaultInterfaceTemporal);
var $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff = function(_ChronoLocalDateTime) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalDateTime, _ChronoLocalDateTime);
    LocalDateTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalDateTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return LocalDateTime._now(clockOrZone);
        else return LocalDateTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalDateTime._now = function _now(clock) {
        $2e6f1e48aadbcba7$var$requireNonNull(clock, "clock");
        return LocalDateTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalDateTime._ofEpochMillis = function _ofEpochMillis(epochMilli, offset) {
        var localSecond = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochMilli, 1000) + offset.totalSeconds();
        var localEpochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.floorMod(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var nanoOfSecond = $2e6f1e48aadbcba7$var$MathUtil.floorMod(epochMilli, 1000) * 1000000;
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.of = function of() {
        if (arguments.length <= 2) return LocalDateTime.ofDateAndTime.apply(this, arguments);
        else return LocalDateTime.ofNumbers.apply(this, arguments);
    };
    LocalDateTime.ofNumbers = function ofNumbers(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.of(year, month, dayOfMonth);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, minute, second, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofDateAndTime = function ofDateAndTime(date, time) {
        $2e6f1e48aadbcba7$var$requireNonNull(date, "date");
        $2e6f1e48aadbcba7$var$requireNonNull(time, "time");
        return new LocalDateTime(date, time);
    };
    LocalDateTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        $2e6f1e48aadbcba7$var$requireNonNull(instant, "instant");
        $2e6f1e48aadbcba7$var$requireInstance(instant, $2e6f1e48aadbcba7$export$fecec53969739358, "instant");
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        var offset = zone.rules().offset(instant);
        return LocalDateTime.ofEpochSecond(instant.epochSecond(), instant.nano(), offset);
    };
    LocalDateTime.ofEpochSecond = function ofEpochSecond(epochSecond, nanoOfSecond, offset) {
        if (epochSecond === void 0) epochSecond = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (arguments.length === 2 && nanoOfSecond instanceof $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3) {
            offset = nanoOfSecond;
            nanoOfSecond = 0;
        }
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        var localSecond = epochSecond + offset.totalSeconds();
        var localEpochDay = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.floorMod(localSecond, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
        var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(localEpochDay);
        var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofSecondOfDay(secsOfDay, nanoOfSecond);
        return new LocalDateTime(date, time);
    };
    LocalDateTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        if (temporal instanceof LocalDateTime) return temporal;
        else if (temporal instanceof $2e6f1e48aadbcba7$export$d3b7288e7994edea) return temporal.toLocalDateTime();
        try {
            var date = $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.from(temporal);
            var time = $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
            return new LocalDateTime(date, time);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalDateTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        }
    };
    LocalDateTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_DATE_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, LocalDateTime.FROM);
    };
    function LocalDateTime(date, time) {
        var _this;
        _this = _ChronoLocalDateTime.call(this) || this;
        $2e6f1e48aadbcba7$var$requireInstance(date, $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6, "date");
        $2e6f1e48aadbcba7$var$requireInstance(time, $2e6f1e48aadbcba7$export$bf1071e344bea1d, "time");
        _this._date = date;
        _this._time = time;
        return _this;
    }
    var _proto = LocalDateTime.prototype;
    _proto._withDateTime = function _withDateTime(newDate, newTime) {
        if (this._date.equals(newDate) && this._time.equals(newTime)) return this;
        return new LocalDateTime(newDate, newTime);
    };
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isDateBased() || fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.range(field) : this._date.range(field);
        return field.rangeRefinedBy(this);
    };
    _proto.get = function get(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.get(field) : this._date.get(field);
        return _ChronoLocalDateTime.prototype.get.call(this, field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return field.isTimeBased() ? this._time.getLong(field) : this._date.getLong(field);
        return field.getFrom(this);
    };
    _proto.year = function year() {
        return this._date.year();
    };
    _proto.monthValue = function monthValue() {
        return this._date.monthValue();
    };
    _proto.month = function month() {
        return this._date.month();
    };
    _proto.dayOfMonth = function dayOfMonth() {
        return this._date.dayOfMonth();
    };
    _proto.dayOfYear = function dayOfYear() {
        return this._date.dayOfYear();
    };
    _proto.dayOfWeek = function dayOfWeek() {
        return this._date.dayOfWeek();
    };
    _proto.hour = function hour() {
        return this._time.hour();
    };
    _proto.minute = function minute() {
        return this._time.minute();
    };
    _proto.second = function second() {
        return this._time.second();
    };
    _proto.nano = function nano() {
        return this._time.nano();
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) return this._withDateTime(adjuster, this._time);
        else if (adjuster instanceof $2e6f1e48aadbcba7$export$bf1071e344bea1d) return this._withDateTime(this._date, adjuster);
        else if (adjuster instanceof LocalDateTime) return adjuster;
        $2e6f1e48aadbcba7$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            if (field.isTimeBased()) return this._withDateTime(this._date, this._time.with(field, newValue));
            else return this._withDateTime(this._date.with(field, newValue), this._time);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withYear = function withYear(year) {
        return this._withDateTime(this._date.withYear(year), this._time);
    };
    _proto.withMonth = function withMonth(month) {
        return this._withDateTime(this._date.withMonth(month), this._time);
    };
    _proto.withDayOfMonth = function withDayOfMonth(dayOfMonth) {
        return this._withDateTime(this._date.withDayOfMonth(dayOfMonth), this._time);
    };
    _proto.withDayOfYear = function withDayOfYear(dayOfYear) {
        return this._withDateTime(this._date.withDayOfYear(dayOfYear), this._time);
    };
    _proto.withHour = function withHour(hour) {
        var newTime = this._time.withHour(hour);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withMinute = function withMinute(minute) {
        var newTime = this._time.withMinute(minute);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withSecond = function withSecond(second) {
        var newTime = this._time.withSecond(second);
        return this._withDateTime(this._date, newTime);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        var newTime = this._time.withNano(nanoOfSecond);
        return this._withDateTime(this._date, newTime);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        return this._withDateTime(this._date, this._time.truncatedTo(unit));
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY)).plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY)).plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY) * 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusDays($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, 256)).plusHours($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 256) * 12);
            }
            return this._withDateTime(this._date.plus(amountToAdd, unit), this._time);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusYears = function plusYears(years) {
        var newDate = this._date.plusYears(years);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusMonths = function plusMonths(months) {
        var newDate = this._date.plusMonths(months);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusWeeks = function plusWeeks(weeks) {
        var newDate = this._date.plusWeeks(weeks);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusDays = function plusDays(days) {
        var newDate = this._date.plusDays(days);
        return this._withDateTime(newDate, this._time);
    };
    _proto.plusHours = function plusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, 1);
    };
    _proto.plusMinutes = function plusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, 1);
    };
    _proto.plusSeconds = function plusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, 1);
    };
    _proto.plusNanos = function plusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, 1);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        return this.plusAmountUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusYears = function minusYears(years) {
        return this.plusYears(-1 * years);
    };
    _proto.minusMonths = function minusMonths(months) {
        return this.plusMonths(-1 * months);
    };
    _proto.minusWeeks = function minusWeeks(weeks) {
        return this.plusWeeks(-1 * weeks);
    };
    _proto.minusDays = function minusDays(days) {
        return this.plusDays(-1 * days);
    };
    _proto.minusHours = function minusHours(hours) {
        return this._plusWithOverflow(this._date, hours, 0, 0, 0, -1);
    };
    _proto.minusMinutes = function minusMinutes(minutes) {
        return this._plusWithOverflow(this._date, 0, minutes, 0, 0, -1);
    };
    _proto.minusSeconds = function minusSeconds(seconds) {
        return this._plusWithOverflow(this._date, 0, 0, seconds, 0, -1);
    };
    _proto.minusNanos = function minusNanos(nanos) {
        return this._plusWithOverflow(this._date, 0, 0, 0, nanos, -1);
    };
    _proto._plusWithOverflow = function _plusWithOverflow(newDate, hours, minutes, seconds, nanos, sign) {
        if (hours === 0 && minutes === 0 && seconds === 0 && nanos === 0) return this._withDateTime(newDate, this._time);
        var totDays = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intDiv(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY);
        totDays *= sign;
        var totNanos = $2e6f1e48aadbcba7$var$MathUtil.intMod(nanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY) + $2e6f1e48aadbcba7$var$MathUtil.intMod(seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + $2e6f1e48aadbcba7$var$MathUtil.intMod(minutes, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE + $2e6f1e48aadbcba7$var$MathUtil.intMod(hours, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR;
        var curNoD = this._time.toNanoOfDay();
        totNanos = totNanos * sign + curNoD;
        totDays += $2e6f1e48aadbcba7$var$MathUtil.floorDiv(totNanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newNoD = $2e6f1e48aadbcba7$var$MathUtil.floorMod(totNanos, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
        var newTime = newNoD === curNoD ? this._time : $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(newNoD);
        return this._withDateTime(newDate.plusDays(totDays), newTime);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return this.toLocalDate();
        return _ChronoLocalDateTime.prototype.query.call(this, _query);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return _ChronoLocalDateTime.prototype.adjustInto.call(this, temporal);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        var end = LocalDateTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            if (unit.isTimeBased()) {
                var daysUntil = this._date.daysUntil(end._date);
                var timeUntil = end._time.toNanoOfDay() - this._time.toNanoOfDay();
                if (daysUntil > 0 && timeUntil < 0) {
                    daysUntil--;
                    timeUntil += $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY;
                } else if (daysUntil < 0 && timeUntil > 0) {
                    daysUntil++;
                    timeUntil -= $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY;
                }
                var amount = daysUntil;
                switch(unit){
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, timeUntil);
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, 1000));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, 1000000));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR));
                    case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                        amount = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amount, 2);
                        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(amount, $2e6f1e48aadbcba7$var$MathUtil.intDiv(timeUntil, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR * 12));
                }
                throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
            }
            var endDate = end._date;
            var endTime = end._time;
            if (endDate.isAfter(this._date) && endTime.isBefore(this._time)) endDate = endDate.minusDays(1);
            else if (endDate.isBefore(this._date) && endTime.isAfter(this._time)) endDate = endDate.plusDays(1);
            return this._date.until(endDate, unit);
        }
        return unit.between(this, end);
    };
    _proto.atOffset = function atOffset(offset) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.of(this, offset);
    };
    _proto.atZone = function atZone(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.of(this, zone);
    };
    _proto.toLocalDate = function toLocalDate() {
        return this._date;
    };
    _proto.toLocalTime = function toLocalTime() {
        return this._time;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalDateTime, "other");
        return this._compareTo0(other);
    };
    _proto._compareTo0 = function _compareTo0(other) {
        var cmp = this._date.compareTo(other.toLocalDate());
        if (cmp === 0) cmp = this._time.compareTo(other.toLocalTime());
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.isEqual = function isEqual(other) {
        return this.compareTo(other) === 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalDateTime) return this._date.equals(other._date) && this._time.equals(other._time);
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._date.hashCode() ^ this._time.hashCode();
    };
    _proto.toString = function toString() {
        return this._date.toString() + "T" + this._time.toString();
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return LocalDateTime;
}($2e6f1e48aadbcba7$export$94e985176fb19d17);
function $2e6f1e48aadbcba7$var$_init$j() {
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MIN = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MIN, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIN);
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.MAX = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of($2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.MAX, $2e6f1e48aadbcba7$export$bf1071e344bea1d.MAX);
    $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("LocalDateTime.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$bf1071e344bea1d = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(LocalTime, _Temporal);
    LocalTime.now = function now(clockOrZone) {
        if (clockOrZone == null) return LocalTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone());
        else if (clockOrZone instanceof $2e6f1e48aadbcba7$export$9735c82c4bae3302) return LocalTime._now(clockOrZone);
        else return LocalTime._now($2e6f1e48aadbcba7$export$9735c82c4bae3302.system(clockOrZone));
    };
    LocalTime._now = function _now(clock) {
        if (clock === void 0) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemDefaultZone();
        $2e6f1e48aadbcba7$var$requireNonNull(clock, "clock");
        return LocalTime.ofInstant(clock.instant(), clock.zone());
    };
    LocalTime.ofInstant = function ofInstant(instant, zone) {
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        var offset = zone.rules().offset(instant);
        var secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.intMod(instant.epochSecond(), LocalTime.SECONDS_PER_DAY);
        secsOfDay = $2e6f1e48aadbcba7$var$MathUtil.intMod(secsOfDay + offset.totalSeconds(), LocalTime.SECONDS_PER_DAY);
        if (secsOfDay < 0) secsOfDay += LocalTime.SECONDS_PER_DAY;
        return LocalTime.ofSecondOfDay(secsOfDay, instant.nano());
    };
    LocalTime.of = function of(hour, minute, second, nanoOfSecond) {
        return new LocalTime(hour, minute, second, nanoOfSecond);
    };
    LocalTime.ofSecondOfDay = function ofSecondOfDay(secondOfDay, nanoOfSecond) {
        if (secondOfDay === void 0) secondOfDay = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY.checkValidValue(secondOfDay);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_HOUR);
        secondOfDay -= hours * LocalTime.SECONDS_PER_HOUR;
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv(secondOfDay, LocalTime.SECONDS_PER_MINUTE);
        secondOfDay -= minutes * LocalTime.SECONDS_PER_MINUTE;
        return new LocalTime(hours, minutes, secondOfDay, nanoOfSecond);
    };
    LocalTime.ofNanoOfDay = function ofNanoOfDay(nanoOfDay) {
        if (nanoOfDay === void 0) nanoOfDay = 0;
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY.checkValidValue(nanoOfDay);
        var hours = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_HOUR);
        nanoOfDay -= hours * LocalTime.NANOS_PER_HOUR;
        var minutes = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_MINUTE);
        nanoOfDay -= minutes * LocalTime.NANOS_PER_MINUTE;
        var seconds = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoOfDay, LocalTime.NANOS_PER_SECOND);
        nanoOfDay -= seconds * LocalTime.NANOS_PER_SECOND;
        return new LocalTime(hours, minutes, seconds, nanoOfDay);
    };
    LocalTime.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        var time = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime());
        if (time == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain LocalTime TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return time;
    };
    LocalTime.parse = function parse(text, formatter) {
        if (formatter === void 0) formatter = $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_LOCAL_TIME;
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.parse(text, LocalTime.FROM);
    };
    function LocalTime(hour, minute, second, nanoOfSecond) {
        var _this;
        if (hour === void 0) hour = 0;
        if (minute === void 0) minute = 0;
        if (second === void 0) second = 0;
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        _this = _Temporal.call(this) || this;
        var _hour = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(hour);
        var _minute = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(minute);
        var _second = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(second);
        var _nanoOfSecond = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanoOfSecond);
        LocalTime._validate(_hour, _minute, _second, _nanoOfSecond);
        if (_minute === 0 && _second === 0 && _nanoOfSecond === 0) {
            if (!LocalTime.HOURS[_hour]) {
                _this._hour = _hour;
                _this._minute = _minute;
                _this._second = _second;
                _this._nano = _nanoOfSecond;
                LocalTime.HOURS[_hour] = $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
            }
            return LocalTime.HOURS[_hour] || $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        }
        _this._hour = _hour;
        _this._minute = _minute;
        _this._second = _second;
        _this._nano = _nanoOfSecond;
        return _this;
    }
    LocalTime._validate = function _validate(hour, minute, second, nanoOfSecond) {
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY.checkValidValue(hour);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR.checkValidValue(minute);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE.checkValidValue(second);
        $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND.checkValidValue(nanoOfSecond);
    };
    var _proto = LocalTime.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit.isTimeBased();
        else if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased();
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field);
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return this._get0(field);
        return field.getFrom(this);
    };
    _proto._get0 = function _get0(field) {
        switch(field){
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                return this._nano;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY:
                return this.toNanoOfDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nano, 1000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.toNanoOfDay(), 1000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nano, 1000000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this.toNanoOfDay(), 1000000);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                return this._second;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY:
                return this.toSecondOfDay();
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                return this._minute;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY:
                return this._hour * 60 + this._minute;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM:
                return $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12);
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                var ham = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12);
                return ham % 12 === 0 ? 12 : ham;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY:
                return this._hour;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                return this._hour === 0 ? 24 : this._hour;
            case $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY:
                return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._hour, 12);
        }
        throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
    };
    _proto.hour = function hour() {
        return this._hour;
    };
    _proto.minute = function minute() {
        return this._minute;
    };
    _proto.second = function second() {
        return this._second;
    };
    _proto.nano = function nano() {
        return this._nano;
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        if (adjuster instanceof LocalTime) return adjuster;
        $2e6f1e48aadbcba7$var$assert(typeof adjuster.adjustInto === "function", "adjuster", $2e6f1e48aadbcba7$export$86eb44ed3377dd8f);
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        $2e6f1e48aadbcba7$var$requireInstance(field, $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this.withNano(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return this.withNano(newValue * 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return this.withNano(newValue * 1000000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_DAY:
                    return LocalTime.ofNanoOfDay(newValue * 1000000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_MINUTE:
                    return this.withSecond(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.SECOND_OF_DAY:
                    return this.plusSeconds(newValue - this.toSecondOfDay());
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_HOUR:
                    return this.withMinute(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MINUTE_OF_DAY:
                    return this.plusMinutes(newValue - (this._hour * 60 + this._minute));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_AMPM:
                    return this.plusHours(newValue - $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_AMPM:
                    return this.plusHours((newValue === 12 ? 0 : newValue) - $2e6f1e48aadbcba7$var$MathUtil.intMod(this._hour, 12));
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.HOUR_OF_DAY:
                    return this.withHour(newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.CLOCK_HOUR_OF_DAY:
                    return this.withHour(newValue === 24 ? 0 : newValue);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.AMPM_OF_DAY:
                    return this.plusHours((newValue - $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._hour, 12)) * 12);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.withHour = function withHour(hour) {
        if (hour === void 0) hour = 0;
        if (this._hour === hour) return this;
        return new LocalTime(hour, this._minute, this._second, this._nano);
    };
    _proto.withMinute = function withMinute(minute) {
        if (minute === void 0) minute = 0;
        if (this._minute === minute) return this;
        return new LocalTime(this._hour, minute, this._second, this._nano);
    };
    _proto.withSecond = function withSecond(second) {
        if (second === void 0) second = 0;
        if (this._second === second) return this;
        return new LocalTime(this._hour, this._minute, second, this._nano);
    };
    _proto.withNano = function withNano(nanoOfSecond) {
        if (nanoOfSecond === void 0) nanoOfSecond = 0;
        if (this._nano === nanoOfSecond) return this;
        return new LocalTime(this._hour, this._minute, this._second, nanoOfSecond);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > LocalTime.SECONDS_PER_DAY) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit is too large to be used for truncation");
        var dur = unitDur.toNanos();
        if ($2e6f1e48aadbcba7$var$MathUtil.intMod(LocalTime.NANOS_PER_DAY, dur) !== 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit must divide into a standard day without remainder");
        var nod = this.toNanoOfDay();
        return LocalTime.ofNanoOfDay($2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, dur) * dur);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this.plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, LocalTime.MICROS_PER_DAY) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusNanos($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, LocalTime.MILLIS_PER_DAY) * 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusMinutes(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusHours(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusHours($2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 2) * 12);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusHours = function plusHours(hoursToAdd) {
        if (hoursToAdd === 0) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(hoursToAdd, LocalTime.HOURS_PER_DAY) + this._hour + LocalTime.HOURS_PER_DAY, LocalTime.HOURS_PER_DAY);
        return new LocalTime(newHour, this._minute, this._second, this._nano);
    };
    _proto.plusMinutes = function plusMinutes(minutesToAdd) {
        if (minutesToAdd === 0) return this;
        var mofd = this._hour * LocalTime.MINUTES_PER_HOUR + this._minute;
        var newMofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(minutesToAdd, LocalTime.MINUTES_PER_DAY) + mofd + LocalTime.MINUTES_PER_DAY, LocalTime.MINUTES_PER_DAY);
        if (mofd === newMofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newMofd, LocalTime.MINUTES_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod(newMofd, LocalTime.MINUTES_PER_HOUR);
        return new LocalTime(newHour, newMinute, this._second, this._nano);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        if (secondsToAdd === 0) return this;
        var sofd = this._hour * LocalTime.SECONDS_PER_HOUR + this._minute * LocalTime.SECONDS_PER_MINUTE + this._second;
        var newSofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(secondsToAdd, LocalTime.SECONDS_PER_DAY) + sofd + LocalTime.SECONDS_PER_DAY, LocalTime.SECONDS_PER_DAY);
        if (sofd === newSofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newSofd, LocalTime.SECONDS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $2e6f1e48aadbcba7$var$MathUtil.intMod(newSofd, LocalTime.SECONDS_PER_MINUTE);
        return new LocalTime(newHour, newMinute, newSecond, this._nano);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        if (nanosToAdd === 0) return this;
        var nofd = this.toNanoOfDay();
        var newNofd = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToAdd, LocalTime.NANOS_PER_DAY) + nofd + LocalTime.NANOS_PER_DAY, LocalTime.NANOS_PER_DAY);
        if (nofd === newNofd) return this;
        var newHour = $2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_HOUR);
        var newMinute = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_MINUTE), LocalTime.MINUTES_PER_HOUR);
        var newSecond = $2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$var$MathUtil.intDiv(newNofd, LocalTime.NANOS_PER_SECOND), LocalTime.SECONDS_PER_MINUTE);
        var newNano = $2e6f1e48aadbcba7$var$MathUtil.intMod(newNofd, LocalTime.NANOS_PER_SECOND);
        return new LocalTime(newHour, newMinute, newSecond, newNano);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        return this.plusAmountUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusHours = function minusHours(hoursToSubtract) {
        return this.plusHours(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(hoursToSubtract, LocalTime.HOURS_PER_DAY));
    };
    _proto.minusMinutes = function minusMinutes(minutesToSubtract) {
        return this.plusMinutes(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(minutesToSubtract, LocalTime.MINUTES_PER_DAY));
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(secondsToSubtract, LocalTime.SECONDS_PER_DAY));
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * $2e6f1e48aadbcba7$var$MathUtil.intMod(nanosToSubtract, LocalTime.NANOS_PER_DAY));
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return this;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        return temporal.with(LocalTime.NANO_OF_DAY, this.toNanoOfDay());
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        var end = LocalTime.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            var nanosUntil = end.toNanoOfDay() - this.toNanoOfDay();
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return nanosUntil;
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 1000000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_SECOND);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, LocalTime.NANOS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosUntil, 12 * LocalTime.NANOS_PER_HOUR);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto.atDate = function atDate(date) {
        return $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.of(date, this);
    };
    _proto.toSecondOfDay = function toSecondOfDay() {
        var total = this._hour * LocalTime.SECONDS_PER_HOUR;
        total += this._minute * LocalTime.SECONDS_PER_MINUTE;
        total += this._second;
        return total;
    };
    _proto.toNanoOfDay = function toNanoOfDay() {
        var total = this._hour * LocalTime.NANOS_PER_HOUR;
        total += this._minute * LocalTime.NANOS_PER_MINUTE;
        total += this._second * LocalTime.NANOS_PER_SECOND;
        total += this._nano;
        return total;
    };
    _proto.compareTo = function compareTo(other) {
        $2e6f1e48aadbcba7$var$requireNonNull(other, "other");
        $2e6f1e48aadbcba7$var$requireInstance(other, LocalTime, "other");
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._hour, other._hour);
        if (cmp === 0) {
            cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._minute, other._minute);
            if (cmp === 0) {
                cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._second, other._second);
                if (cmp === 0) cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._nano, other._nano);
            }
        }
        return cmp;
    };
    _proto.isAfter = function isAfter(other) {
        return this.compareTo(other) > 0;
    };
    _proto.isBefore = function isBefore(other) {
        return this.compareTo(other) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof LocalTime) return this._hour === other._hour && this._minute === other._minute && this._second === other._second && this._nano === other._nano;
        return false;
    };
    _proto.hashCode = function hashCode() {
        var nod = this.toNanoOfDay();
        return $2e6f1e48aadbcba7$var$MathUtil.hash(nod);
    };
    _proto.toString = function toString() {
        var buf = "";
        var hourValue = this._hour;
        var minuteValue = this._minute;
        var secondValue = this._second;
        var nanoValue = this._nano;
        buf += hourValue < 10 ? "0" : "";
        buf += hourValue;
        buf += minuteValue < 10 ? ":0" : ":";
        buf += minuteValue;
        if (secondValue > 0 || nanoValue > 0) {
            buf += secondValue < 10 ? ":0" : ":";
            buf += secondValue;
            if (nanoValue > 0) {
                buf += ".";
                if ($2e6f1e48aadbcba7$var$MathUtil.intMod(nanoValue, 1000000) === 0) buf += ("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoValue, 1000000) + 1000)).substring(1);
                else if ($2e6f1e48aadbcba7$var$MathUtil.intMod(nanoValue, 1000) === 0) buf += ("" + ($2e6f1e48aadbcba7$var$MathUtil.intDiv(nanoValue, 1000) + 1000000)).substring(1);
                else buf += ("" + (nanoValue + 1000000000)).substring(1);
            }
        }
        return buf;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    _proto.format = function format(formatter) {
        $2e6f1e48aadbcba7$var$requireNonNull(formatter, "formatter");
        return formatter.format(this);
    };
    return LocalTime;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$k() {
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS = [];
    for(var hour = 0; hour < 24; hour++)$2e6f1e48aadbcba7$export$bf1071e344bea1d.of(hour, 0, 0, 0);
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIN = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[0];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MAX = new $2e6f1e48aadbcba7$export$bf1071e344bea1d(23, 59, 59, 999999999);
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.MIDNIGHT = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[0];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.NOON = $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS[12];
    $2e6f1e48aadbcba7$export$bf1071e344bea1d.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("LocalTime.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$bf1071e344bea1d.from(temporal);
    });
}
$2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY = 24;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR = 60;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE = 60;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE * $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MILLIS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.MICROS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY * 1000000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND = 1000000000;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_MINUTE * $2e6f1e48aadbcba7$export$bf1071e344bea1d.MINUTES_PER_HOUR;
$2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY = $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_HOUR * $2e6f1e48aadbcba7$export$bf1071e344bea1d.HOURS_PER_DAY;
var $2e6f1e48aadbcba7$var$NANOS_PER_MILLI = 1000000;
var $2e6f1e48aadbcba7$export$fecec53969739358 = function(_Temporal) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(Instant, _Temporal);
    Instant.now = function now(clock) {
        if (clock === void 0) clock = $2e6f1e48aadbcba7$export$9735c82c4bae3302.systemUTC();
        return clock.instant();
    };
    Instant.ofEpochSecond = function ofEpochSecond(epochSecond, nanoAdjustment) {
        if (nanoAdjustment === void 0) nanoAdjustment = 0;
        var secs = epochSecond + $2e6f1e48aadbcba7$var$MathUtil.floorDiv(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(nanoAdjustment, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return Instant._create(secs, nos);
    };
    Instant.ofEpochMilli = function ofEpochMilli(epochMilli) {
        var secs = $2e6f1e48aadbcba7$var$MathUtil.floorDiv(epochMilli, 1000);
        var mos = $2e6f1e48aadbcba7$var$MathUtil.floorMod(epochMilli, 1000);
        return Instant._create(secs, mos * 1000000);
    };
    Instant.from = function from(temporal) {
        try {
            var instantSecs = temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS);
            var nanoOfSecond = temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND);
            return Instant.ofEpochSecond(instantSecs, nanoOfSecond);
        } catch (ex) {
            throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain Instant from TemporalAccessor: " + temporal + ", type " + typeof temporal, ex);
        }
    };
    Instant.parse = function parse(text) {
        return $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT.parse(text, Instant.FROM);
    };
    Instant._create = function _create(seconds, nanoOfSecond) {
        if (seconds === 0 && nanoOfSecond === 0) return Instant.EPOCH;
        return new Instant(seconds, nanoOfSecond);
    };
    Instant._validate = function _validate(seconds, nanoOfSecond) {
        if (seconds < Instant.MIN_SECONDS || seconds > Instant.MAX_SECONDS) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Instant exceeds minimum or maximum instant");
        if (nanoOfSecond < 0 || nanoOfSecond > $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Instant exceeds minimum or maximum instant");
    };
    function Instant(seconds, nanoOfSecond) {
        var _this;
        _this = _Temporal.call(this) || this;
        Instant._validate(seconds, nanoOfSecond);
        _this._seconds = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(seconds);
        _this._nanos = $2e6f1e48aadbcba7$var$MathUtil.safeToInt(nanoOfSecond);
        return _this;
    }
    var _proto = Instant.prototype;
    _proto.isSupported = function isSupported(fieldOrUnit) {
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) return fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND || fieldOrUnit === $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND;
        if (fieldOrUnit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) return fieldOrUnit.isTimeBased() || fieldOrUnit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS;
        return fieldOrUnit != null && fieldOrUnit.isSupportedBy(this);
    };
    _proto.range = function range(field) {
        return _Temporal.prototype.range.call(this, field);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return this._nanos;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, 1000);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return this._seconds;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.epochSecond = function epochSecond() {
        return this._seconds;
    };
    _proto.nano = function nano() {
        return this._nanos;
    };
    _proto.withAdjuster = function withAdjuster(adjuster) {
        $2e6f1e48aadbcba7$var$requireNonNull(adjuster, "adjuster");
        return adjuster.adjustInto(this);
    };
    _proto.withFieldValue = function withFieldValue(field, newValue) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            field.checkValidValue(newValue);
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MILLI_OF_SECOND:
                    var nval = newValue * $2e6f1e48aadbcba7$var$NANOS_PER_MILLI;
                    return nval !== this._nanos ? Instant._create(this._seconds, nval) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.MICRO_OF_SECOND:
                    var _nval = newValue * 1000;
                    return _nval !== this._nanos ? Instant._create(this._seconds, _nval) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return newValue !== this._nanos ? Instant._create(this._seconds, newValue) : this;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return newValue !== this._seconds ? Instant._create(newValue, this._nanos) : this;
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.adjustInto(this, newValue);
    };
    _proto.truncatedTo = function truncatedTo(unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        if (unit === $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS) return this;
        var unitDur = unit.duration();
        if (unitDur.seconds() > $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit is too large to be used for truncation");
        var dur = unitDur.toNanos();
        if ($2e6f1e48aadbcba7$var$MathUtil.intMod($2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_DAY, dur) !== 0) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unit must divide into a standard day without remainder");
        var nod = $2e6f1e48aadbcba7$var$MathUtil.intMod(this._seconds, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY) * $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND + this._nanos;
        var result = $2e6f1e48aadbcba7$var$MathUtil.intDiv(nod, dur) * dur;
        return this.plusNanos(result - nod);
    };
    _proto.plusAmount = function plusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.addTo(this);
    };
    _proto.plusAmountUnit = function plusAmountUnit(amountToAdd, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(amountToAdd, "amountToAdd");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        $2e6f1e48aadbcba7$var$requireInstance(unit, $2e6f1e48aadbcba7$export$5d412a4bb789788e);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this.plusNanos(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return this._plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(amountToAdd, 1000000), $2e6f1e48aadbcba7$var$MathUtil.intMod(amountToAdd, 1000000) * 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return this.plusMillis(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this.plusSeconds(amountToAdd);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY / 2));
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return this.plusSeconds($2e6f1e48aadbcba7$var$MathUtil.safeMultiply(amountToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY));
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.addTo(this, amountToAdd);
    };
    _proto.plusSeconds = function plusSeconds(secondsToAdd) {
        return this._plus(secondsToAdd, 0);
    };
    _proto.plusMillis = function plusMillis(millisToAdd) {
        return this._plus($2e6f1e48aadbcba7$var$MathUtil.intDiv(millisToAdd, 1000), $2e6f1e48aadbcba7$var$MathUtil.intMod(millisToAdd, 1000) * $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
    };
    _proto.plusNanos = function plusNanos(nanosToAdd) {
        return this._plus(0, nanosToAdd);
    };
    _proto._plus = function _plus(secondsToAdd, nanosToAdd) {
        if (secondsToAdd === 0 && nanosToAdd === 0) return this;
        var epochSec = this._seconds + secondsToAdd;
        epochSec = epochSec + $2e6f1e48aadbcba7$var$MathUtil.intDiv(nanosToAdd, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        var nanoAdjustment = this._nanos + nanosToAdd % $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND;
        return Instant.ofEpochSecond(epochSec, nanoAdjustment);
    };
    _proto.minusAmount = function minusAmount(amount) {
        $2e6f1e48aadbcba7$var$requireNonNull(amount, "amount");
        return amount.subtractFrom(this);
    };
    _proto.minusAmountUnit = function minusAmountUnit(amountToSubtract, unit) {
        return this.plusAmountUnit(-1 * amountToSubtract, unit);
    };
    _proto.minusSeconds = function minusSeconds(secondsToSubtract) {
        return this.plusSeconds(secondsToSubtract * -1);
    };
    _proto.minusMillis = function minusMillis(millisToSubtract) {
        return this.plusMillis(-1 * millisToSubtract);
    };
    _proto.minusNanos = function minusNanos(nanosToSubtract) {
        return this.plusNanos(-1 * nanosToSubtract);
    };
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.precision()) return $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS;
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.chronology() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zoneId() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone() || _query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.offset()) return null;
        return _query.queryFrom(this);
    };
    _proto.adjustInto = function adjustInto(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        return temporal.with($2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS, this._seconds).with($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND, this._nanos);
    };
    _proto.until = function until(endExclusive, unit) {
        $2e6f1e48aadbcba7$var$requireNonNull(endExclusive, "endExclusive");
        $2e6f1e48aadbcba7$var$requireNonNull(unit, "unit");
        var end = Instant.from(endExclusive);
        if (unit instanceof $2e6f1e48aadbcba7$export$e61e212a4109fb8a) {
            switch(unit){
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.NANOS:
                    return this._nanosUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MICROS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanosUntil(end), 1000);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MILLIS:
                    return $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.toEpochMilli(), this.toEpochMilli());
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.SECONDS:
                    return this._secondsUntil(end);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.MINUTES:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_MINUTE);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HOURS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.HALF_DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), 12 * $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_HOUR);
                case $2e6f1e48aadbcba7$export$e61e212a4109fb8a.DAYS:
                    return $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._secondsUntil(end), $2e6f1e48aadbcba7$export$bf1071e344bea1d.SECONDS_PER_DAY);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported unit: " + unit);
        }
        return unit.between(this, end);
    };
    _proto._nanosUntil = function _nanosUntil(end) {
        var secsDiff = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var totalNanos = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(secsDiff, $2e6f1e48aadbcba7$export$bf1071e344bea1d.NANOS_PER_SECOND);
        return $2e6f1e48aadbcba7$var$MathUtil.safeAdd(totalNanos, end.nano() - this.nano());
    };
    _proto._secondsUntil = function _secondsUntil(end) {
        var secsDiff = $2e6f1e48aadbcba7$var$MathUtil.safeSubtract(end.epochSecond(), this.epochSecond());
        var nanosDiff = end.nano() - this.nano();
        if (secsDiff > 0 && nanosDiff < 0) secsDiff--;
        else if (secsDiff < 0 && nanosDiff > 0) secsDiff++;
        return secsDiff;
    };
    _proto.atOffset = function atOffset(offset) {
        return $2e6f1e48aadbcba7$export$f351e12f7a164fb5.ofInstant(this, offset);
    };
    _proto.atZone = function atZone(zone) {
        return $2e6f1e48aadbcba7$export$d3b7288e7994edea.ofInstant(this, zone);
    };
    _proto.toEpochMilli = function toEpochMilli() {
        var millis = $2e6f1e48aadbcba7$var$MathUtil.safeMultiply(this._seconds, 1000);
        return millis + $2e6f1e48aadbcba7$var$MathUtil.intDiv(this._nanos, $2e6f1e48aadbcba7$var$NANOS_PER_MILLI);
    };
    _proto.compareTo = function compareTo(otherInstant) {
        $2e6f1e48aadbcba7$var$requireNonNull(otherInstant, "otherInstant");
        $2e6f1e48aadbcba7$var$requireInstance(otherInstant, Instant, "otherInstant");
        var cmp = $2e6f1e48aadbcba7$var$MathUtil.compareNumbers(this._seconds, otherInstant._seconds);
        if (cmp !== 0) return cmp;
        return this._nanos - otherInstant._nanos;
    };
    _proto.isAfter = function isAfter(otherInstant) {
        return this.compareTo(otherInstant) > 0;
    };
    _proto.isBefore = function isBefore(otherInstant) {
        return this.compareTo(otherInstant) < 0;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        if (other instanceof Instant) return this.epochSecond() === other.epochSecond() && this.nano() === other.nano();
        return false;
    };
    _proto.hashCode = function hashCode() {
        return $2e6f1e48aadbcba7$var$MathUtil.hashCode(this._seconds, this._nanos);
    };
    _proto.toString = function toString() {
        return $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c.ISO_INSTANT.format(this);
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    };
    return Instant;
}($2e6f1e48aadbcba7$export$336849d529cb05e5);
function $2e6f1e48aadbcba7$var$_init$l() {
    $2e6f1e48aadbcba7$export$fecec53969739358.MIN_SECONDS = -31619119219200;
    $2e6f1e48aadbcba7$export$fecec53969739358.MAX_SECONDS = 31494816403199;
    $2e6f1e48aadbcba7$export$fecec53969739358.EPOCH = new $2e6f1e48aadbcba7$export$fecec53969739358(0, 0);
    $2e6f1e48aadbcba7$export$fecec53969739358.MIN = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond($2e6f1e48aadbcba7$export$fecec53969739358.MIN_SECONDS, 0);
    $2e6f1e48aadbcba7$export$fecec53969739358.MAX = $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochSecond($2e6f1e48aadbcba7$export$fecec53969739358.MAX_SECONDS, 999999999);
    $2e6f1e48aadbcba7$export$fecec53969739358.FROM = $2e6f1e48aadbcba7$var$createTemporalQuery("Instant.FROM", function(temporal) {
        return $2e6f1e48aadbcba7$export$fecec53969739358.from(temporal);
    });
}
var $2e6f1e48aadbcba7$export$9735c82c4bae3302 = function() {
    function Clock() {}
    Clock.systemUTC = function systemUTC() {
        return new $2e6f1e48aadbcba7$var$SystemClock($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC);
    };
    Clock.systemDefaultZone = function systemDefaultZone() {
        return new $2e6f1e48aadbcba7$var$SystemClock($2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault());
    };
    Clock.system = function system(zone) {
        return new $2e6f1e48aadbcba7$var$SystemClock(zone);
    };
    Clock.fixed = function fixed(fixedInstant, zoneId) {
        return new $2e6f1e48aadbcba7$var$FixedClock(fixedInstant, zoneId);
    };
    Clock.offset = function offset(baseClock, duration) {
        return new $2e6f1e48aadbcba7$var$OffsetClock(baseClock, duration);
    };
    var _proto = Clock.prototype;
    _proto.millis = function millis() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("Clock.millis");
    };
    _proto.instant = function instant() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("Clock.instant");
    };
    _proto.zone = function zone() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("Clock.zone");
    };
    _proto.withZone = function withZone() {
        $2e6f1e48aadbcba7$var$abstractMethodFail("Clock.withZone");
    };
    return Clock;
}();
var $2e6f1e48aadbcba7$var$SystemClock = function(_Clock) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemClock, _Clock);
    function SystemClock(zone) {
        var _this;
        $2e6f1e48aadbcba7$var$requireNonNull(zone, "zone");
        _this = _Clock.call(this) || this;
        _this._zone = zone;
        return _this;
    }
    var _proto2 = SystemClock.prototype;
    _proto2.zone = function zone() {
        return this._zone;
    };
    _proto2.millis = function millis() {
        return new Date().getTime();
    };
    _proto2.instant = function instant() {
        return $2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(this.millis());
    };
    _proto2.equals = function equals(obj) {
        if (obj instanceof SystemClock) return this._zone.equals(obj._zone);
        return false;
    };
    _proto2.withZone = function withZone(zone) {
        if (zone.equals(this._zone)) return this;
        return new SystemClock(zone);
    };
    _proto2.toString = function toString() {
        return "SystemClock[" + this._zone.toString() + "]";
    };
    return SystemClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
var $2e6f1e48aadbcba7$var$FixedClock = function(_Clock2) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(FixedClock, _Clock2);
    function FixedClock(fixedInstant, zoneId) {
        var _this2;
        _this2 = _Clock2.call(this) || this;
        _this2._instant = fixedInstant;
        _this2._zoneId = zoneId;
        return _this2;
    }
    var _proto3 = FixedClock.prototype;
    _proto3.instant = function instant() {
        return this._instant;
    };
    _proto3.millis = function millis() {
        return this._instant.toEpochMilli();
    };
    _proto3.zone = function zone() {
        return this._zoneId;
    };
    _proto3.toString = function toString() {
        return "FixedClock[]";
    };
    _proto3.equals = function equals(obj) {
        if (obj instanceof FixedClock) return this._instant.equals(obj._instant) && this._zoneId.equals(obj._zoneId);
        return false;
    };
    _proto3.withZone = function withZone(zone) {
        if (zone.equals(this._zoneId)) return this;
        return new FixedClock(this._instant, zone);
    };
    return FixedClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
var $2e6f1e48aadbcba7$var$OffsetClock = function(_Clock3) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(OffsetClock, _Clock3);
    function OffsetClock(baseClock, offset) {
        var _this3;
        _this3 = _Clock3.call(this) || this;
        _this3._baseClock = baseClock;
        _this3._offset = offset;
        return _this3;
    }
    var _proto4 = OffsetClock.prototype;
    _proto4.zone = function zone() {
        return this._baseClock.zone();
    };
    _proto4.withZone = function withZone(zone) {
        if (zone.equals(this._baseClock.zone())) return this;
        return new OffsetClock(this._baseClock.withZone(zone), this._offset);
    };
    _proto4.millis = function millis() {
        return this._baseClock.millis() + this._offset.toMillis();
    };
    _proto4.instant = function instant() {
        return this._baseClock.instant().plus(this._offset);
    };
    _proto4.equals = function equals(obj) {
        if (obj instanceof OffsetClock) return this._baseClock.equals(obj._baseClock) && this._offset.equals(obj._offset);
        return false;
    };
    _proto4.toString = function toString() {
        return "OffsetClock[" + this._baseClock + "," + this._offset + "]";
    };
    return OffsetClock;
}($2e6f1e48aadbcba7$export$9735c82c4bae3302);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$993d982a5ca9c76d = function() {
    ZoneOffsetTransition.of = function of(transition, offsetBefore, offsetAfter) {
        return new ZoneOffsetTransition(transition, offsetBefore, offsetAfter);
    };
    function ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
        $2e6f1e48aadbcba7$var$requireNonNull(transition, "transition");
        $2e6f1e48aadbcba7$var$requireNonNull(offsetBefore, "offsetBefore");
        $2e6f1e48aadbcba7$var$requireNonNull(offsetAfter, "offsetAfter");
        if (offsetBefore.equals(offsetAfter)) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Offsets must not be equal");
        if (transition.nano() !== 0) throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Nano-of-second must be zero");
        if (transition instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) this._transition = transition;
        else this._transition = $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff.ofEpochSecond(transition, 0, offsetBefore);
        this._offsetBefore = offsetBefore;
        this._offsetAfter = offsetAfter;
    }
    var _proto = ZoneOffsetTransition.prototype;
    _proto.instant = function instant() {
        return this._transition.toInstant(this._offsetBefore);
    };
    _proto.toEpochSecond = function toEpochSecond() {
        return this._transition.toEpochSecond(this._offsetBefore);
    };
    _proto.dateTimeBefore = function dateTimeBefore() {
        return this._transition;
    };
    _proto.dateTimeAfter = function dateTimeAfter() {
        return this._transition.plusSeconds(this.durationSeconds());
    };
    _proto.offsetBefore = function offsetBefore() {
        return this._offsetBefore;
    };
    _proto.offsetAfter = function offsetAfter() {
        return this._offsetAfter;
    };
    _proto.duration = function duration() {
        return $2e6f1e48aadbcba7$export$3b11bc38611c5941.ofSeconds(this.durationSeconds());
    };
    _proto.durationSeconds = function durationSeconds() {
        return this._offsetAfter.totalSeconds() - this._offsetBefore.totalSeconds();
    };
    _proto.isGap = function isGap() {
        return this._offsetAfter.totalSeconds() > this._offsetBefore.totalSeconds();
    };
    _proto.isOverlap = function isOverlap() {
        return this._offsetAfter.totalSeconds() < this._offsetBefore.totalSeconds();
    };
    _proto.isValidOffset = function isValidOffset(offset) {
        return this.isGap() ? false : this._offsetBefore.equals(offset) || this._offsetAfter.equals(offset);
    };
    _proto.validOffsets = function validOffsets() {
        if (this.isGap()) return [];
        else return [
            this._offsetBefore,
            this._offsetAfter
        ];
    };
    _proto.compareTo = function compareTo(transition) {
        return this.instant().compareTo(transition.instant());
    };
    _proto.equals = function equals(other) {
        if (other === this) return true;
        if (other instanceof ZoneOffsetTransition) {
            var d = other;
            return this._transition.equals(d._transition) && this._offsetBefore.equals(d.offsetBefore()) && this._offsetAfter.equals(d.offsetAfter());
        }
        return false;
    };
    _proto.hashCode = function hashCode() {
        return this._transition.hashCode() ^ this._offsetBefore.hashCode() ^ this._offsetAfter.hashCode() >>> 16;
    };
    _proto.toString = function toString() {
        return "Transition[" + (this.isGap() ? "Gap" : "Overlap") + " at " + this._transition.toString() + this._offsetBefore.toString() + " to " + this._offsetAfter + "]";
    };
    return ZoneOffsetTransition;
}();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ function $2e6f1e48aadbcba7$var$_init$m() {
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID = $2e6f1e48aadbcba7$var$createTemporalQuery("ZONE_ID", function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.CHRONO = $2e6f1e48aadbcba7$var$createTemporalQuery("CHRONO", function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.CHRONO);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.PRECISION = $2e6f1e48aadbcba7$var$createTemporalQuery("PRECISION", function(temporal) {
        return temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.PRECISION);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.OFFSET = $2e6f1e48aadbcba7$var$createTemporalQuery("OFFSET", function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS)) return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(temporal.get($2e6f1e48aadbcba7$export$7f55a40756153c3e.OFFSET_SECONDS));
        return null;
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE = $2e6f1e48aadbcba7$var$createTemporalQuery("ZONE", function(temporal) {
        var zone = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.ZONE_ID);
        return zone != null ? zone : temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.OFFSET);
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.LOCAL_DATE = $2e6f1e48aadbcba7$var$createTemporalQuery("LOCAL_DATE", function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY)) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofEpochDay(temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.EPOCH_DAY));
        return null;
    });
    $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.LOCAL_TIME = $2e6f1e48aadbcba7$var$createTemporalQuery("LOCAL_TIME", function(temporal) {
        if (temporal.isSupported($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY)) return $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofNanoOfDay(temporal.getLong($2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_DAY));
        return null;
    });
}
var $2e6f1e48aadbcba7$var$SystemDefaultZoneRules = function(_ZoneRules) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemDefaultZoneRules, _ZoneRules);
    function SystemDefaultZoneRules() {
        return _ZoneRules.apply(this, arguments) || this;
    }
    var _proto = SystemDefaultZoneRules.prototype;
    _proto.isFixedOffset = function isFixedOffset() {
        return false;
    };
    _proto.offsetOfInstant = function offsetOfInstant(instant) {
        var offsetInMinutes = new Date(instant.toEpochMilli()).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfEpochMilli = function offsetOfEpochMilli(epochMilli) {
        var offsetInMinutes = new Date(epochMilli).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutes * -1);
    };
    _proto.offsetOfLocalDateTime = function offsetOfLocalDateTime(localDateTime) {
        var epochMilli = localDateTime.toEpochSecond($2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC) * 1000;
        var offsetInMinutesBeforePossibleTransition = new Date(epochMilli).getTimezoneOffset();
        var epochMilliSystemZone = epochMilli + offsetInMinutesBeforePossibleTransition * 60000;
        var offsetInMinutesAfterPossibleTransition = new Date(epochMilliSystemZone).getTimezoneOffset();
        return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalMinutes(offsetInMinutesAfterPossibleTransition * -1);
    };
    _proto.validOffsets = function validOffsets(localDateTime) {
        return [
            this.offsetOfLocalDateTime(localDateTime)
        ];
    };
    _proto.transition = function transition() {
        return null;
    };
    _proto.standardOffset = function standardOffset(instant) {
        return this.offsetOfInstant(instant);
    };
    _proto.daylightSavings = function daylightSavings() {
        this._throwNotSupported();
    };
    _proto.isDaylightSavings = function isDaylightSavings() {
        this._throwNotSupported();
    };
    _proto.isValidOffset = function isValidOffset(dateTime, offset) {
        return this.offsetOfLocalDateTime(dateTime).equals(offset);
    };
    _proto.nextTransition = function nextTransition() {
        this._throwNotSupported();
    };
    _proto.previousTransition = function previousTransition() {
        this._throwNotSupported();
    };
    _proto.transitions = function transitions() {
        this._throwNotSupported();
    };
    _proto.transitionRules = function transitionRules() {
        this._throwNotSupported();
    };
    _proto._throwNotSupported = function _throwNotSupported() {
        throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("not supported operation");
    };
    _proto.equals = function equals(other) {
        if (this === other || other instanceof SystemDefaultZoneRules) return true;
        else return false;
    };
    _proto.toString = function toString() {
        return "SYSTEM";
    };
    return SystemDefaultZoneRules;
}($2e6f1e48aadbcba7$export$cbd9bcf3fad97817);
var $2e6f1e48aadbcba7$var$SystemDefaultZoneId = function(_ZoneId) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(SystemDefaultZoneId, _ZoneId);
    function SystemDefaultZoneId() {
        var _this;
        _this = _ZoneId.call(this) || this;
        _this._rules = new $2e6f1e48aadbcba7$var$SystemDefaultZoneRules();
        return _this;
    }
    var _proto = SystemDefaultZoneId.prototype;
    _proto.rules = function rules() {
        return this._rules;
    };
    _proto.equals = function equals(other) {
        if (this === other) return true;
        return false;
    };
    _proto.id = function id() {
        return "SYSTEM";
    };
    return SystemDefaultZoneId;
}($2e6f1e48aadbcba7$export$a514a0be1f00ef62);
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @copyright (c) 2007-present, Stephen Colebourne & Michael Nascimento Santos
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ZoneIdFactory = function() {
    function ZoneIdFactory() {}
    ZoneIdFactory.systemDefault = function systemDefault() {
        return $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    };
    ZoneIdFactory.getAvailableZoneIds = function getAvailableZoneIds() {
        return $2e6f1e48aadbcba7$export$79d73e02cd645302.getAvailableZoneIds();
    };
    ZoneIdFactory.of = function of(zoneId) {
        $2e6f1e48aadbcba7$var$requireNonNull(zoneId, "zoneId");
        if (zoneId === "Z") return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC;
        if (zoneId.length === 1) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Invalid zone: " + zoneId);
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "+") || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "-")) return $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId);
        if (zoneId === "UTC" || zoneId === "GMT" || zoneId === "GMT0" || zoneId === "UT") return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId, $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.UTC.rules());
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "UTC+") || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "GMT+") || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "UTC-") || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "GMT-")) {
            var offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId.substring(3));
            if (offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId.substring(0, 3), offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(zoneId.substring(0, 3) + offset.id(), offset.rules());
        }
        if ($2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "UT+") || $2e6f1e48aadbcba7$var$StringUtil.startsWith(zoneId, "UT-")) {
            var _offset = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.of(zoneId.substring(2));
            if (_offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d("UT", _offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d("UT" + _offset.id(), _offset.rules());
        }
        if (zoneId === "SYSTEM") return $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        return $2e6f1e48aadbcba7$export$9caa52e4e516e67d.ofId(zoneId);
    };
    ZoneIdFactory.ofOffset = function ofOffset(prefix, offset) {
        $2e6f1e48aadbcba7$var$requireNonNull(prefix, "prefix");
        $2e6f1e48aadbcba7$var$requireNonNull(offset, "offset");
        if (prefix.length === 0) return offset;
        if (prefix === "GMT" || prefix === "UTC" || prefix === "UT") {
            if (offset.totalSeconds() === 0) return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(prefix, offset.rules());
            return new $2e6f1e48aadbcba7$export$9caa52e4e516e67d(prefix + offset.id(), offset.rules());
        }
        throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("Invalid prefix, must be GMT, UTC or UT: " + prefix);
    };
    ZoneIdFactory.from = function from(temporal) {
        $2e6f1e48aadbcba7$var$requireNonNull(temporal, "temporal");
        var obj = temporal.query($2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone());
        if (obj == null) throw new $2e6f1e48aadbcba7$export$6058f27c7f907fb("Unable to obtain ZoneId from TemporalAccessor: " + temporal + ", type " + (temporal.constructor != null ? temporal.constructor.name : ""));
        return obj;
    };
    return ZoneIdFactory;
}();
var $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = null;
function $2e6f1e48aadbcba7$var$_init$n() {
    $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE = new $2e6f1e48aadbcba7$var$SystemDefaultZoneId();
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault = $2e6f1e48aadbcba7$var$ZoneIdFactory.systemDefault;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.getAvailableZoneIds = $2e6f1e48aadbcba7$var$ZoneIdFactory.getAvailableZoneIds;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.of = $2e6f1e48aadbcba7$var$ZoneIdFactory.of;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.ofOffset = $2e6f1e48aadbcba7$var$ZoneIdFactory.ofOffset;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.from = $2e6f1e48aadbcba7$var$ZoneIdFactory.from;
    $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.from = $2e6f1e48aadbcba7$var$ZoneIdFactory.from;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.SYSTEM = $2e6f1e48aadbcba7$var$SYSTEM_DEFAULT_ZONE_ID_INSTANCE;
    $2e6f1e48aadbcba7$export$a514a0be1f00ef62.UTC = $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3.ofTotalSeconds(0);
}
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$isInit = false;
function $2e6f1e48aadbcba7$var$init() {
    if ($2e6f1e48aadbcba7$var$isInit) return;
    $2e6f1e48aadbcba7$var$isInit = true;
    $2e6f1e48aadbcba7$var$_init$1();
    $2e6f1e48aadbcba7$var$_init();
    $2e6f1e48aadbcba7$var$_init$2();
    $2e6f1e48aadbcba7$var$_init$3();
    $2e6f1e48aadbcba7$var$_init$k();
    $2e6f1e48aadbcba7$var$_init$8();
    $2e6f1e48aadbcba7$var$_init$m();
    $2e6f1e48aadbcba7$var$_init$4();
    $2e6f1e48aadbcba7$var$_init$l();
    $2e6f1e48aadbcba7$var$_init$i();
    $2e6f1e48aadbcba7$var$_init$j();
    $2e6f1e48aadbcba7$var$_init$d();
    $2e6f1e48aadbcba7$var$_init$5();
    $2e6f1e48aadbcba7$var$_init$c();
    $2e6f1e48aadbcba7$var$_init$b();
    $2e6f1e48aadbcba7$var$_init$6();
    $2e6f1e48aadbcba7$var$_init$7();
    $2e6f1e48aadbcba7$var$_init$g();
    $2e6f1e48aadbcba7$var$_init$n();
    $2e6f1e48aadbcba7$var$_init$e();
    $2e6f1e48aadbcba7$var$_init$a();
    $2e6f1e48aadbcba7$var$_init$9();
    $2e6f1e48aadbcba7$var$_init$h();
    $2e6f1e48aadbcba7$var$_init$f();
}
$2e6f1e48aadbcba7$var$init();
/*
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$var$ToNativeJsConverter = function() {
    function ToNativeJsConverter(temporal, zone) {
        var zonedDateTime;
        if (temporal instanceof $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6) {
            zone = zone == null ? $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atStartOfDay(zone);
        } else if (temporal instanceof $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff) {
            zone = zone == null ? $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault() : zone;
            zonedDateTime = temporal.atZone(zone);
        } else if (temporal instanceof $2e6f1e48aadbcba7$export$d3b7288e7994edea) {
            if (zone == null) zonedDateTime = temporal;
            else zonedDateTime = temporal.withZoneSameInstant(zone);
        } else throw new $2e6f1e48aadbcba7$export$86eb44ed3377dd8f("unsupported instance for convert operation:" + temporal);
        this.instant = zonedDateTime.toInstant();
    }
    var _proto = ToNativeJsConverter.prototype;
    _proto.toDate = function toDate() {
        return new Date(this.instant.toEpochMilli());
    };
    _proto.toEpochMilli = function toEpochMilli() {
        return this.instant.toEpochMilli();
    };
    return ToNativeJsConverter;
}();
function $2e6f1e48aadbcba7$export$9c68d69a4c5bbcf9(temporal, zone) {
    return new $2e6f1e48aadbcba7$var$ToNativeJsConverter(temporal, zone);
}
var $2e6f1e48aadbcba7$var$NativeJsTemporal = function(_TemporalAccessor) {
    $2e6f1e48aadbcba7$var$_inheritsLoose(NativeJsTemporal, _TemporalAccessor);
    function NativeJsTemporal(date, zone) {
        var _this;
        if (zone === void 0) zone = $2e6f1e48aadbcba7$export$a514a0be1f00ef62.systemDefault();
        _this = _TemporalAccessor.call(this) || this;
        _this._zone = zone;
        if (date instanceof Date) {
            _this._epochMilli = date.getTime();
            return $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        } else if (typeof date.toDate === "function" && date.toDate() instanceof Date) {
            _this._epochMilli = date.toDate().getTime();
            return $2e6f1e48aadbcba7$var$_assertThisInitialized(_this);
        }
        $2e6f1e48aadbcba7$var$assert(false, "date must be either a javascript date or a moment");
        return _this;
    }
    var _proto = NativeJsTemporal.prototype;
    _proto.query = function query(_query) {
        $2e6f1e48aadbcba7$var$requireNonNull(_query, "query");
        if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localDate()) return $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6.ofInstant($2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(this._epochMilli), this._zone);
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.localTime()) return $2e6f1e48aadbcba7$export$bf1071e344bea1d.ofInstant($2e6f1e48aadbcba7$export$fecec53969739358.ofEpochMilli(this._epochMilli), this._zone);
        else if (_query === $2e6f1e48aadbcba7$export$d6cc568434dfd9dc.zone()) return this._zone;
        return _TemporalAccessor.prototype.query.call(this, _query);
    };
    _proto.get = function get(field) {
        return this.getLong(field);
    };
    _proto.getLong = function getLong(field) {
        $2e6f1e48aadbcba7$var$requireNonNull(field, "field");
        if (field instanceof $2e6f1e48aadbcba7$export$7f55a40756153c3e) {
            switch(field){
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND:
                    return $2e6f1e48aadbcba7$var$MathUtil.floorMod(this._epochMilli, 1000) * 1000000;
                case $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS:
                    return $2e6f1e48aadbcba7$var$MathUtil.floorDiv(this._epochMilli, 1000);
            }
            throw new $2e6f1e48aadbcba7$export$8fe6dec993229f58("Unsupported field: " + field);
        }
        return field.getFrom(this);
    };
    _proto.isSupported = function isSupported(field) {
        return field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.INSTANT_SECONDS || field === $2e6f1e48aadbcba7$export$7f55a40756153c3e.NANO_OF_SECOND;
    };
    return NativeJsTemporal;
}($2e6f1e48aadbcba7$export$e5100310ee9cc158);
function $2e6f1e48aadbcba7$export$1f878d3ea5c30765(date, zone) {
    return new $2e6f1e48aadbcba7$var$NativeJsTemporal(date, zone);
}
function $2e6f1e48aadbcba7$var$bindUse(jsJoda) {
    var used = [];
    return function use(fn) {
        if (!~used.indexOf(fn)) {
            fn(jsJoda);
            used.push(fn);
        }
        return jsJoda;
    };
}
/**
 * @copyright (c) 2016, Philipp Thürwächter & Pattrick Hüper
 * @license BSD-3-Clause (see LICENSE in the root directory of this source tree)
 */ var $2e6f1e48aadbcba7$export$71511d61b312f219 = {
    assert: $2e6f1e48aadbcba7$var$assert$1,
    DateTimeBuilder: $2e6f1e48aadbcba7$var$DateTimeBuilder,
    DateTimeParseContext: $2e6f1e48aadbcba7$var$DateTimeParseContext,
    DateTimePrintContext: $2e6f1e48aadbcba7$var$DateTimePrintContext,
    MathUtil: $2e6f1e48aadbcba7$var$MathUtil,
    StringUtil: $2e6f1e48aadbcba7$var$StringUtil,
    StringBuilder: $2e6f1e48aadbcba7$var$StringBuilder
};
var $2e6f1e48aadbcba7$var$jsJodaExports = {
    _: $2e6f1e48aadbcba7$export$71511d61b312f219,
    convert: $2e6f1e48aadbcba7$export$9c68d69a4c5bbcf9,
    nativeJs: $2e6f1e48aadbcba7$export$1f878d3ea5c30765,
    ArithmeticException: $2e6f1e48aadbcba7$export$5891bcae38b5fd67,
    DateTimeException: $2e6f1e48aadbcba7$export$6058f27c7f907fb,
    DateTimeParseException: $2e6f1e48aadbcba7$export$ce8a206818942248,
    IllegalArgumentException: $2e6f1e48aadbcba7$export$86eb44ed3377dd8f,
    IllegalStateException: $2e6f1e48aadbcba7$export$f79c4ffdc088dc0e,
    UnsupportedTemporalTypeException: $2e6f1e48aadbcba7$export$8fe6dec993229f58,
    NullPointerException: $2e6f1e48aadbcba7$export$b6ad7a1de4697efd,
    Clock: $2e6f1e48aadbcba7$export$9735c82c4bae3302,
    DayOfWeek: $2e6f1e48aadbcba7$export$7ed5ca4f8b987938,
    Duration: $2e6f1e48aadbcba7$export$3b11bc38611c5941,
    Instant: $2e6f1e48aadbcba7$export$fecec53969739358,
    LocalDate: $2e6f1e48aadbcba7$export$6397c6cbb8fe96b6,
    LocalTime: $2e6f1e48aadbcba7$export$bf1071e344bea1d,
    LocalDateTime: $2e6f1e48aadbcba7$export$7dda5dc5c6c448ff,
    OffsetTime: $2e6f1e48aadbcba7$export$a362394fcc906a80,
    OffsetDateTime: $2e6f1e48aadbcba7$export$f351e12f7a164fb5,
    Month: $2e6f1e48aadbcba7$export$951c8378cdfec6e6,
    MonthDay: $2e6f1e48aadbcba7$export$30964d9b15071608,
    Period: $2e6f1e48aadbcba7$export$67186dcd8fa4f92f,
    Year: $2e6f1e48aadbcba7$export$6ce2f08d515512,
    YearConstants: $2e6f1e48aadbcba7$export$c04b60057299af61,
    YearMonth: $2e6f1e48aadbcba7$export$b707805e12671f51,
    ZonedDateTime: $2e6f1e48aadbcba7$export$d3b7288e7994edea,
    ZoneOffset: $2e6f1e48aadbcba7$export$47ce5d56ab10eaa3,
    ZoneId: $2e6f1e48aadbcba7$export$a514a0be1f00ef62,
    ZoneRegion: $2e6f1e48aadbcba7$export$9caa52e4e516e67d,
    ZoneOffsetTransition: $2e6f1e48aadbcba7$export$993d982a5ca9c76d,
    ZoneRules: $2e6f1e48aadbcba7$export$cbd9bcf3fad97817,
    ZoneRulesProvider: $2e6f1e48aadbcba7$export$79d73e02cd645302,
    ChronoLocalDate: $2e6f1e48aadbcba7$export$2a07e3472bc98879,
    ChronoLocalDateTime: $2e6f1e48aadbcba7$export$94e985176fb19d17,
    ChronoZonedDateTime: $2e6f1e48aadbcba7$export$e69f60c5a83f5572,
    IsoChronology: $2e6f1e48aadbcba7$export$f47ae290cf4e4958,
    ChronoField: $2e6f1e48aadbcba7$export$7f55a40756153c3e,
    ChronoUnit: $2e6f1e48aadbcba7$export$e61e212a4109fb8a,
    IsoFields: $2e6f1e48aadbcba7$export$2091a0730eb3b2d2,
    Temporal: $2e6f1e48aadbcba7$export$336849d529cb05e5,
    TemporalAccessor: $2e6f1e48aadbcba7$export$e5100310ee9cc158,
    TemporalAdjuster: $2e6f1e48aadbcba7$export$841f8bd48996924f,
    TemporalAdjusters: $2e6f1e48aadbcba7$export$d922854d56f8a965,
    TemporalAmount: $2e6f1e48aadbcba7$export$f8b2fcf02a6656ff,
    TemporalField: $2e6f1e48aadbcba7$export$d879d8cdc7b5c1c9,
    TemporalQueries: $2e6f1e48aadbcba7$export$d6cc568434dfd9dc,
    TemporalQuery: $2e6f1e48aadbcba7$export$3164c6c8dc6c80ff,
    TemporalUnit: $2e6f1e48aadbcba7$export$5d412a4bb789788e,
    ValueRange: $2e6f1e48aadbcba7$export$177e5e64bab4dec5,
    DateTimeFormatter: $2e6f1e48aadbcba7$export$3245e15bf4cbdd6c,
    DateTimeFormatterBuilder: $2e6f1e48aadbcba7$export$81529fd372517959,
    DecimalStyle: $2e6f1e48aadbcba7$export$c1929c59b9e7d355,
    ResolverStyle: $2e6f1e48aadbcba7$export$2a833e4d13229d66,
    SignStyle: $2e6f1e48aadbcba7$export$b2e3a42c433c0b35,
    TextStyle: $2e6f1e48aadbcba7$export$1df879243bf2e42d
};
var $2e6f1e48aadbcba7$export$1f96ae73734a86cc = $2e6f1e48aadbcba7$var$bindUse($2e6f1e48aadbcba7$var$jsJodaExports);
$2e6f1e48aadbcba7$var$jsJodaExports.use = $2e6f1e48aadbcba7$export$1f96ae73734a86cc;

});



parcelRegister("ctZcf", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./88b0986a7186d029-atomicfu-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("k4lEE")));
})(globalThis, function(_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var protoOf = kotlin_kotlin.$_$.kb;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var Continuation = kotlin_kotlin.$_$.h9;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var VOID = kotlin_kotlin.$_$.f;
    var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.o4;
    var createCoroutineUnintercepted = kotlin_kotlin.$_$.a9;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var toString = kotlin_kotlin.$_$.ob;
    var isInterface = kotlin_kotlin.$_$.xa;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
    var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var hashCode = kotlin_kotlin.$_$.ha;
    var equals = kotlin_kotlin.$_$.ba;
    var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
    var CancellationException_init_$Create$ = kotlin_kotlin.$_$.c1;
    var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a3;
    var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.c3;
    var Companion_instance = kotlin_kotlin.$_$.c5;
    var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
    var createFailure = kotlin_kotlin.$_$.jf;
    var AbstractCoroutineContextKey = kotlin_kotlin.$_$.d9;
    var Key_instance = kotlin_kotlin.$_$.n4;
    var AbstractCoroutineContextElement = kotlin_kotlin.$_$.c9;
    var get = kotlin_kotlin.$_$.e9;
    var minusKey = kotlin_kotlin.$_$.f9;
    var ContinuationInterceptor = kotlin_kotlin.$_$.g9;
    var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.j2;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.e1;
    var Enum = kotlin_kotlin.$_$.ie;
    var startCoroutine = kotlin_kotlin.$_$.o9;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var Long = kotlin_kotlin.$_$.ne;
    var intercepted = kotlin_kotlin.$_$.b9;
    var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.l;
    var RuntimeException = kotlin_kotlin.$_$.se;
    var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.i2;
    var captureStack = kotlin_kotlin.$_$.t9;
    var Error_0 = kotlin_kotlin.$_$.je;
    var Error_init_$Init$ = kotlin_kotlin.$_$.k1;
    var Element = kotlin_kotlin.$_$.l9;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
    var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.uf;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var CancellationException = kotlin_kotlin.$_$.y8;
    var ArrayList = kotlin_kotlin.$_$.i5;
    var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.a2;
    var plus = kotlin_kotlin.$_$.m9;
    var get_0 = kotlin_kotlin.$_$.j9;
    var fold = kotlin_kotlin.$_$.i9;
    var minusKey_0 = kotlin_kotlin.$_$.k9;
    var anyToString = kotlin_kotlin.$_$.q9;
    var UnsupportedOperationException = kotlin_kotlin.$_$.ff;
    var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
    var atomicfu$AtomicRefArray$ofNulls = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.a;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var toLong = kotlin_kotlin.$_$.mb;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var atomic$long$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.c;
    var listOf = kotlin_kotlin.$_$.o7;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.d2;
    var compareTo = kotlin_kotlin.$_$.z9;
    var last = kotlin_kotlin.$_$.cd;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var IllegalStateException = kotlin_kotlin.$_$.me;
    var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.x1;
    var NoSuchElementException = kotlin_kotlin.$_$.oe;
    var NoSuchElementException_init_$Init$ = kotlin_kotlin.$_$.e2;
    var getKClass = kotlin_kotlin.$_$.e;
    var addSuppressed = kotlin_kotlin.$_$.gf;
    var Exception = kotlin_kotlin.$_$.ke;
    var toLongOrNull = kotlin_kotlin.$_$.qd;
    var plus_0 = kotlin_kotlin.$_$.w7;
    var KtList = kotlin_kotlin.$_$.p5;
    var listOf_0 = kotlin_kotlin.$_$.n7;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var CancellationException_init_$Init$ = kotlin_kotlin.$_$.d1;
    var removeFirstOrNull = kotlin_kotlin.$_$.y7;
    var KtMutableList = kotlin_kotlin.$_$.s5;
    var coerceIn = kotlin_kotlin.$_$.ub;
    var CancellationException_init_$Init$_0 = kotlin_kotlin.$_$.b1;
    var HashSet_init_$Create$ = kotlin_kotlin.$_$.s;
    var RuntimeException_init_$Init$_0 = kotlin_kotlin.$_$.g2;
    var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.y;
    var UnsupportedOperationException_init_$Create$_0 = kotlin_kotlin.$_$.l2;
    //endregion
    //region block: pre-declaration
    function cancel$default(cause, $super) {
        cause = cause === VOID ? null : cause;
        var tmp;
        if ($super === VOID) {
            this.b1o(cause);
            tmp = Unit_instance;
        } else tmp = $super.b1o.call(this, cause);
        return tmp;
    }
    function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
        onCancelling = onCancelling === VOID ? false : onCancelling;
        invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
        return $super === VOID ? this.x1n(onCancelling, invokeImmediately, handler) : $super.x1n.call(this, onCancelling, invokeImmediately, handler);
    }
    initMetadataForInterface(Job, "Job", VOID, VOID, [
        Element
    ], [
        0
    ]);
    initMetadataForInterface(ParentJob, "ParentJob", VOID, VOID, [
        Job
    ], [
        0
    ]);
    initMetadataForClass(JobSupport, "JobSupport", VOID, VOID, [
        Job,
        ParentJob
    ], [
        0
    ]);
    initMetadataForInterface(CoroutineScope, "CoroutineScope");
    initMetadataForClass(AbstractCoroutine, "AbstractCoroutine", VOID, JobSupport, [
        JobSupport,
        Job,
        Continuation,
        CoroutineScope
    ], [
        0
    ]);
    initMetadataForClass(StandaloneCoroutine, "StandaloneCoroutine", VOID, AbstractCoroutine, VOID, [
        0
    ]);
    initMetadataForClass(LazyStandaloneCoroutine, "LazyStandaloneCoroutine", VOID, StandaloneCoroutine, VOID, [
        0
    ]);
    initMetadataForCoroutine($awaitCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(DeferredCoroutine, "DeferredCoroutine", VOID, AbstractCoroutine, [
        AbstractCoroutine,
        Job
    ], [
        0
    ]);
    initMetadataForClass(LazyDeferredCoroutine, "LazyDeferredCoroutine", VOID, DeferredCoroutine, VOID, [
        0
    ]);
    initMetadataForInterface(CancellableContinuation, "CancellableContinuation", VOID, VOID, [
        Continuation
    ]);
    initMetadataForClass(CancelHandlerBase, "CancelHandlerBase");
    initMetadataForInterface(NotCompleted, "NotCompleted");
    initMetadataForClass(CancelHandler, "CancelHandler", VOID, CancelHandlerBase, [
        CancelHandlerBase,
        NotCompleted
    ]);
    initMetadataForClass(DisposeOnCancel, "DisposeOnCancel", VOID, CancelHandler);
    initMetadataForInterface(Runnable, "Runnable");
    initMetadataForClass(SchedulerTask, "SchedulerTask", VOID, VOID, [
        Runnable
    ]);
    initMetadataForClass(DispatchedTask, "DispatchedTask", VOID, SchedulerTask);
    initMetadataForInterface(Waiter, "Waiter");
    initMetadataForClass(CancellableContinuationImpl, "CancellableContinuationImpl", VOID, DispatchedTask, [
        DispatchedTask,
        CancellableContinuation,
        Waiter
    ]);
    initMetadataForObject(Active, "Active", VOID, VOID, [
        NotCompleted
    ]);
    initMetadataForClass(CompletedContinuation, "CompletedContinuation");
    initMetadataForClass(InvokeOnCancel, "InvokeOnCancel", VOID, CancelHandler);
    initMetadataForCoroutine($awaitCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(CompletableDeferredImpl, "CompletableDeferredImpl", VOID, JobSupport, [
        JobSupport,
        Job
    ], [
        0
    ]);
    initMetadataForInterface(CompletableJob, "CompletableJob", VOID, VOID, [
        Job
    ], [
        0
    ]);
    initMetadataForClass(CompletedExceptionally, "CompletedExceptionally");
    initMetadataForClass(CancelledContinuation, "CancelledContinuation", VOID, CompletedExceptionally);
    initMetadataForClass(CompletedWithCancellation, "CompletedWithCancellation");
    initMetadataForObject(Key, "Key", VOID, AbstractCoroutineContextKey);
    initMetadataForClass(CoroutineDispatcher, "CoroutineDispatcher", VOID, AbstractCoroutineContextElement, [
        AbstractCoroutineContextElement,
        ContinuationInterceptor
    ]);
    initMetadataForObject(Key_0, "Key");
    initMetadataForObject(Key_1, "Key");
    initMetadataForClass(CoroutineName, "CoroutineName", VOID, AbstractCoroutineContextElement);
    initMetadataForObject(GlobalScope, "GlobalScope", VOID, VOID, [
        CoroutineScope
    ]);
    initMetadataForClass(CoroutineStart, "CoroutineStart", VOID, Enum);
    initMetadataForInterface(Delay, "Delay", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(EventLoop, "EventLoop", VOID, CoroutineDispatcher);
    initMetadataForObject(ThreadLocalEventLoop, "ThreadLocalEventLoop");
    initMetadataForClass(CompletionHandlerException, "CompletionHandlerException", VOID, RuntimeException);
    initMetadataForClass(CoroutinesInternalError, "CoroutinesInternalError", VOID, Error_0);
    initMetadataForObject(Key_2, "Key");
    initMetadataForInterface(ChildHandle, "ChildHandle");
    initMetadataForObject(NonDisposableHandle, "NonDisposableHandle", VOID, VOID, [
        ChildHandle
    ]);
    initMetadataForInterface(Incomplete, "Incomplete");
    initMetadataForClass(Empty, "Empty", VOID, VOID, [
        Incomplete
    ]);
    initMetadataForClass(LinkedListNode, "LinkedListNode", LinkedListNode);
    initMetadataForClass(LinkedListHead, "LinkedListHead", LinkedListHead, LinkedListNode);
    initMetadataForClass(NodeList, "NodeList", NodeList, LinkedListHead, [
        LinkedListHead,
        Incomplete
    ]);
    initMetadataForClass(CompletionHandlerBase, "CompletionHandlerBase", VOID, LinkedListNode);
    initMetadataForClass(JobNode, "JobNode", VOID, CompletionHandlerBase, [
        CompletionHandlerBase,
        Incomplete
    ]);
    initMetadataForClass(Finishing, "Finishing", VOID, VOID, [
        Incomplete
    ]);
    initMetadataForClass(ChildCompletion, "ChildCompletion", VOID, JobNode);
    initMetadataForClass(AwaitContinuation, "AwaitContinuation", VOID, CancellableContinuationImpl);
    initMetadataForClass(JobCancellingNode, "JobCancellingNode", VOID, JobNode);
    initMetadataForClass(InactiveNodeList, "InactiveNodeList", VOID, VOID, [
        Incomplete
    ]);
    initMetadataForClass(ChildHandleNode, "ChildHandleNode", VOID, JobCancellingNode, [
        JobCancellingNode,
        ChildHandle
    ]);
    initMetadataForClass(InvokeOnCancelling, "InvokeOnCancelling", VOID, JobCancellingNode);
    initMetadataForClass(InvokeOnCompletion, "InvokeOnCompletion", VOID, JobNode);
    initMetadataForClass(ResumeOnCompletion, "ResumeOnCompletion", VOID, JobNode);
    initMetadataForClass(ResumeAwaitOnCompletion, "ResumeAwaitOnCompletion", VOID, JobNode);
    initMetadataForClass(IncompleteStateBox, "IncompleteStateBox");
    initMetadataForClass(ChildContinuation, "ChildContinuation", VOID, JobCancellingNode);
    initMetadataForClass(JobImpl, "JobImpl", VOID, JobSupport, [
        JobSupport,
        CompletableJob
    ], [
        0
    ]);
    initMetadataForClass(MainCoroutineDispatcher, "MainCoroutineDispatcher", VOID, CoroutineDispatcher);
    initMetadataForClass(SupervisorJobImpl, "SupervisorJobImpl", VOID, JobImpl, VOID, [
        0
    ]);
    initMetadataForClass(TimeoutCancellationException, "TimeoutCancellationException", VOID, CancellationException);
    initMetadataForObject(Unconfined, "Unconfined", VOID, CoroutineDispatcher);
    initMetadataForObject(Key_3, "Key");
    initMetadataForClass(BufferOverflow, "BufferOverflow", VOID, Enum);
    initMetadataForClass(ConcurrentLinkedListNode, "ConcurrentLinkedListNode");
    initMetadataForClass(Segment, "Segment", VOID, ConcurrentLinkedListNode, [
        ConcurrentLinkedListNode,
        NotCompleted
    ]);
    initMetadataForClass(ChannelSegment, "ChannelSegment", VOID, Segment);
    initMetadataForCoroutine($hasNextCOROUTINE$5, CoroutineImpl);
    initMetadataForClass(SendBroadcast, "SendBroadcast", VOID, VOID, [
        Waiter
    ]);
    initMetadataForClass(BufferedChannelIterator, "BufferedChannelIterator", VOID, VOID, [
        Waiter
    ], [
        0,
        3
    ]);
    function close$default(cause, $super) {
        cause = cause === VOID ? null : cause;
        return $super === VOID ? this.j21(cause) : $super.j21.call(this, cause);
    }
    initMetadataForInterface(SendChannel, "SendChannel", VOID, VOID, VOID, [
        1
    ]);
    function cancel$default_0(cause, $super) {
        cause = cause === VOID ? null : cause;
        var tmp;
        if ($super === VOID) {
            this.b1o(cause);
            tmp = Unit_instance;
        } else tmp = $super.b1o.call(this, cause);
        return tmp;
    }
    initMetadataForInterface(ReceiveChannel, "ReceiveChannel", VOID, VOID, VOID, [
        0
    ]);
    initMetadataForClass(BufferedChannel, "BufferedChannel", VOID, VOID, [
        SendChannel,
        ReceiveChannel
    ], [
        1,
        4,
        0,
        3
    ]);
    initMetadataForClass(WaiterEB, "WaiterEB");
    initMetadataForClass(ReceiveCatching, "ReceiveCatching", VOID, VOID, [
        Waiter
    ]);
    initMetadataForObject(Factory, "Factory");
    initMetadataForClass(Failed, "Failed", Failed);
    initMetadataForClass(Closed, "Closed", VOID, Failed);
    initMetadataForCompanion(Companion);
    initMetadataForClass(ChannelResult, "ChannelResult");
    initMetadataForClass(ClosedSendChannelException, "ClosedSendChannelException", VOID, IllegalStateException);
    initMetadataForClass(ClosedReceiveChannelException, "ClosedReceiveChannelException", VOID, NoSuchElementException);
    initMetadataForClass(ConflatedBufferedChannel, "ConflatedBufferedChannel", VOID, BufferedChannel, VOID, [
        1,
        0
    ]);
    initMetadataForCoroutine($collectCOROUTINE$9, CoroutineImpl);
    initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($emitCOROUTINE$17, CoroutineImpl);
    initMetadataForClass(_no_name_provided__qut3iv_1, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($firstOrNullCOROUTINE$15, CoroutineImpl);
    initMetadataForCoroutine($firstOrNullCOROUTINE$16, CoroutineImpl);
    initMetadataForClass(OpDescriptor, "OpDescriptor");
    initMetadataForClass(SegmentOrClosed, "SegmentOrClosed");
    initMetadataForObject(ExceptionSuccessfullyProcessed, "ExceptionSuccessfullyProcessed", VOID, Exception);
    initMetadataForClass(DispatchedContinuation, "DispatchedContinuation", VOID, DispatchedTask, [
        DispatchedTask,
        Continuation
    ]);
    initMetadataForClass(UndeliveredElementException, "UndeliveredElementException", VOID, RuntimeException);
    initMetadataForClass(ScopeCoroutine, "ScopeCoroutine", VOID, AbstractCoroutine, VOID, [
        0
    ]);
    initMetadataForClass(ContextScope, "ContextScope", VOID, VOID, [
        CoroutineScope
    ]);
    initMetadataForClass(Symbol, "Symbol");
    initMetadataForInterface(SelectInstance, "SelectInstance");
    initMetadataForClass(ClauseData, "ClauseData", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(SelectImplementation, "SelectImplementation", VOID, CancelHandler, [
        CancelHandler,
        SelectInstance,
        Waiter
    ], [
        0,
        2
    ]);
    initMetadataForClass(TrySelectDetailedResult, "TrySelectDetailedResult", VOID, Enum);
    initMetadataForObject(Dispatchers, "Dispatchers");
    initMetadataForClass(JsMainDispatcher, "JsMainDispatcher", VOID, MainCoroutineDispatcher);
    initMetadataForClass(UnconfinedEventLoop, "UnconfinedEventLoop", UnconfinedEventLoop, EventLoop);
    initMetadataForClass(JobCancellationException, "JobCancellationException", VOID, CancellationException);
    initMetadataForClass(SetTimeoutBasedDispatcher, "SetTimeoutBasedDispatcher", VOID, CoroutineDispatcher, [
        CoroutineDispatcher,
        Delay
    ], [
        1
    ]);
    initMetadataForObject(NodeDispatcher, "NodeDispatcher", VOID, SetTimeoutBasedDispatcher, VOID, [
        1
    ]);
    initMetadataForObject(SetTimeoutDispatcher, "SetTimeoutDispatcher", VOID, SetTimeoutBasedDispatcher, VOID, [
        1
    ]);
    initMetadataForClass(MessageQueue, "MessageQueue", VOID, VOID, [
        KtMutableList
    ]);
    initMetadataForClass(ScheduledMessageQueue, "ScheduledMessageQueue", VOID, MessageQueue);
    initMetadataForClass(ClearTimeout, "ClearTimeout", VOID, CancelHandler);
    initMetadataForClass(WindowClearTimeout, "WindowClearTimeout", VOID, ClearTimeout);
    initMetadataForClass(WindowDispatcher, "WindowDispatcher", VOID, CoroutineDispatcher, [
        CoroutineDispatcher,
        Delay
    ], [
        1
    ]);
    initMetadataForClass(WindowMessageQueue, "WindowMessageQueue", VOID, MessageQueue);
    initMetadataForClass(AbortFlowException, "AbortFlowException", VOID, CancellationException);
    initMetadataForClass(DiagnosticCoroutineContextException, "DiagnosticCoroutineContextException", VOID, RuntimeException);
    initMetadataForClass(CommonThreadLocal, "CommonThreadLocal", CommonThreadLocal);
    //endregion
    function AbstractCoroutine(parentContext, initParentJob, active) {
        JobSupport.call(this, active);
        if (initParentJob) this.r1m(parentContext.i9(Key_instance_3));
        this.u1m_1 = parentContext.vf(this);
    }
    protoOf(AbstractCoroutine).b9 = function() {
        return this.u1m_1;
    };
    protoOf(AbstractCoroutine).v1m = function() {
        return this.u1m_1;
    };
    protoOf(AbstractCoroutine).w1m = function() {
        return protoOf(JobSupport).w1m.call(this);
    };
    protoOf(AbstractCoroutine).x1m = function(value) {};
    protoOf(AbstractCoroutine).y1m = function(cause, handled) {};
    protoOf(AbstractCoroutine).z1m = function() {
        return get_classSimpleName(this) + " was cancelled";
    };
    protoOf(AbstractCoroutine).a1n = function(state) {
        if (state instanceof CompletedExceptionally) this.y1m(state.b1n_1, state.d1n());
        else this.x1m((state == null ? true : !(state == null)) ? state : THROW_CCE());
    };
    protoOf(AbstractCoroutine).g9 = function(result) {
        var state = this.e1n(toState_0(result));
        if (state === get_COMPLETING_WAITING_CHILDREN()) return Unit_instance;
        this.f1n(state);
    };
    protoOf(AbstractCoroutine).f1n = function(state) {
        return this.g1n(state);
    };
    protoOf(AbstractCoroutine).h1n = function(exception) {
        handleCoroutineException(this.u1m_1, exception);
    };
    protoOf(AbstractCoroutine).i1n = function() {
        var tmp0_elvis_lhs = get_coroutineName(this.u1m_1);
        var tmp;
        if (tmp0_elvis_lhs == null) return protoOf(JobSupport).i1n.call(this);
        else tmp = tmp0_elvis_lhs;
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + protoOf(JobSupport).i1n.call(this);
    };
    protoOf(AbstractCoroutine).j1n = function(start, receiver, block) {
        start.m1n(block, receiver, this);
    };
    function launch(_this__u8e3s4, context, start, block) {
        context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
        start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
        var newContext = newCoroutineContext(_this__u8e3s4, context);
        var coroutine = start.r1o() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
        coroutine.j1n(start, coroutine, block);
        return coroutine;
    }
    function async(_this__u8e3s4, context, start, block) {
        context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
        start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
        var newContext = newCoroutineContext(_this__u8e3s4, context);
        var coroutine = start.r1o() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
        coroutine.j1n(start, coroutine, block);
        return coroutine;
    }
    function StandaloneCoroutine(parentContext, active) {
        AbstractCoroutine.call(this, parentContext, true, active);
    }
    protoOf(StandaloneCoroutine).m1o = function(exception) {
        handleCoroutineException(this.u1m_1, exception);
        return true;
    };
    function LazyStandaloneCoroutine(parentContext, block) {
        StandaloneCoroutine.call(this, parentContext, false);
        this.y1o_1 = createCoroutineUnintercepted(block, this, this);
    }
    protoOf(LazyStandaloneCoroutine).s1n = function() {
        startCoroutineCancellable(this.y1o_1, this);
    };
    function $awaitCOROUTINE$0(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h1p_1 = _this__u8e3s4;
    }
    protoOf($awaitCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.h1p_1.q1o(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function DeferredCoroutine(parentContext, active) {
        AbstractCoroutine.call(this, parentContext, true, active);
    }
    protoOf(DeferredCoroutine).l1p = function() {
        var tmp = this.p1o();
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(DeferredCoroutine).m1p = function($completion) {
        var tmp = new $awaitCOROUTINE$0(this, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function LazyDeferredCoroutine(parentContext, block) {
        DeferredCoroutine.call(this, parentContext, false);
        this.q1p_1 = createCoroutineUnintercepted(block, this, this);
    }
    protoOf(LazyDeferredCoroutine).s1n = function() {
        startCoroutineCancellable(this.q1p_1, this);
    };
    function CancellableContinuation() {}
    function disposeOnCancellation(_this__u8e3s4, handle) {
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new DisposeOnCancel(handle);
        return _this__u8e3s4.u1p(tmp$ret$1);
    }
    function DisposeOnCancel(handle) {
        CancelHandler.call(this);
        this.w1p_1 = handle;
    }
    protoOf(DisposeOnCancel).x1p = function(cause) {
        return this.w1p_1.y1p();
    };
    protoOf(DisposeOnCancel).invoke = function(cause) {
        return this.x1p(cause);
    };
    protoOf(DisposeOnCancel).toString = function() {
        return "DisposeOnCancel[" + toString(this.w1p_1) + "]";
    };
    function getOrCreateCancellableContinuation(delegate) {
        if (!(delegate instanceof DispatchedContinuation)) return new CancellableContinuationImpl(delegate, 1);
        var tmp0_safe_receiver = delegate.f1q();
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_0;
            // Inline function 'kotlinx.coroutines.getOrCreateCancellableContinuation.<anonymous>' call
            if (tmp0_safe_receiver.m1q()) tmp_0 = tmp0_safe_receiver;
            else tmp_0 = null;
            tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_1;
        if (tmp1_elvis_lhs == null) return new CancellableContinuationImpl(delegate, 2);
        else tmp_1 = tmp1_elvis_lhs;
        return tmp_1;
    }
    function get_RESUME_TOKEN() {
        _init_properties_CancellableContinuationImpl_kt__6rrtdd();
        return RESUME_TOKEN;
    }
    var RESUME_TOKEN;
    function _get_parentHandle__f8dcex($this) {
        return $this.l1q_1.kotlinx$atomicfu$value;
    }
    function _get_stateDebugRepresentation__bf18u4($this) {
        var tmp0_subject = $this.p1n();
        var tmp;
        if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) tmp = "Active";
        else if (tmp0_subject instanceof CancelledContinuation) tmp = "Cancelled";
        else tmp = "Completed";
        return tmp;
    }
    function isReusable($this) {
        var tmp;
        if (get_isReusableMode($this.o1q_1)) {
            var tmp_0 = $this.h1q_1;
            tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).n1q();
        } else tmp = false;
        return tmp;
    }
    function cancelLater($this, cause) {
        if (!isReusable($this)) return false;
        var tmp = $this.h1q_1;
        var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
        return dispatched.p1q(cause);
    }
    function callSegmentOnCancellation($this, segment, cause) {
        // Inline function 'kotlinx.coroutines.index' call
        var index = $this.j1q_1.kotlinx$atomicfu$value & 536870911;
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(index === 536870911)) {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
            var message = "The index for Segment.onCancellation(..) is broken";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
        try {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
            segment.u1q(index, cause, $this.b9());
        } catch ($p) {
            if ($p instanceof Error) {
                var ex = $p;
                handleCoroutineException($this.b9(), new CompletionHandlerException("Exception in invokeOnCancellation handler for " + $this.toString(), ex));
            } else throw $p;
        }
    }
    function trySuspend($this) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = $this.j1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.trySuspend.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.decision' call
            switch(cur >> _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()){
                case 0:
                    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
                    // Inline function 'kotlinx.coroutines.index' call
                    var index = cur & 536870911;
                    var tmp$ret$2 = (1 << _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()) + index | 0;
                    if ($this.j1q_1.atomicfu$compareAndSet(cur, tmp$ret$2)) return true;
                    break;
                case 2:
                    return false;
                default:
                    // Inline function 'kotlin.error' call
                    var message = "Already suspended";
                    throw IllegalStateException_init_$Create$(toString(message));
            }
        }
    }
    function tryResume($this) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = $this.j1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResume.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.decision' call
            switch(cur >> _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()){
                case 0:
                    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
                    // Inline function 'kotlinx.coroutines.index' call
                    var index = cur & 536870911;
                    var tmp$ret$2 = (2 << _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()) + index | 0;
                    if ($this.j1q_1.atomicfu$compareAndSet(cur, tmp$ret$2)) return true;
                    break;
                case 1:
                    return false;
                default:
                    // Inline function 'kotlin.error' call
                    var message = "Already resumed";
                    throw IllegalStateException_init_$Create$(toString(message));
            }
        }
    }
    function installParentHandle($this) {
        var tmp0_elvis_lhs = $this.b9().i9(Key_instance_3);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var parent = tmp;
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ChildContinuation($this);
        var handle = parent.y1n(true, VOID, tmp$ret$1);
        $this.l1q_1.atomicfu$compareAndSet(null, handle);
        return handle;
    }
    function invokeOnCancellationImpl($this, handler) {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = $this.k1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellationImpl.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (state instanceof Active) {
                if ($this.k1q_1.atomicfu$compareAndSet(state, handler)) return Unit_instance;
            } else {
                var tmp;
                if (state instanceof CancelHandler) tmp = true;
                else tmp = state instanceof Segment;
                if (tmp) multipleHandlersError($this, handler, state);
                else {
                    if (state instanceof CompletedExceptionally) {
                        if (!state.d1r()) multipleHandlersError($this, handler, state);
                        if (state instanceof CancelledContinuation) {
                            var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
                            var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b1n_1;
                            if (handler instanceof CancelHandler) $this.a1r(handler, cause);
                            else {
                                var segment = handler instanceof Segment ? handler : THROW_CCE();
                                callSegmentOnCancellation($this, segment, cause);
                            }
                        }
                        return Unit_instance;
                    } else if (state instanceof CompletedContinuation) {
                        if (!(state.w1q_1 == null)) multipleHandlersError($this, handler, state);
                        if (handler instanceof Segment) return Unit_instance;
                        if (!(handler instanceof CancelHandler)) THROW_CCE();
                        if (state.b1r()) {
                            $this.a1r(handler, state.z1q_1);
                            return Unit_instance;
                        }
                        var update = state.c1r(VOID, handler);
                        if ($this.k1q_1.atomicfu$compareAndSet(state, update)) return Unit_instance;
                    } else {
                        if (handler instanceof Segment) return Unit_instance;
                        if (!(handler instanceof CancelHandler)) THROW_CCE();
                        var update_0 = new CompletedContinuation(state, handler);
                        if ($this.k1q_1.atomicfu$compareAndSet(state, update_0)) return Unit_instance;
                    }
                }
            }
        }
    }
    function multipleHandlersError($this, handler, state) {
        // Inline function 'kotlin.error' call
        var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ", already has " + toString_0(state);
        throw IllegalStateException_init_$Create$(toString(message));
    }
    function makeCancelHandler($this, handler) {
        var tmp;
        if (handler instanceof CancelHandler) tmp = handler;
        else tmp = new InvokeOnCancel(handler);
        return tmp;
    }
    function dispatchResume($this, mode) {
        if (tryResume($this)) return Unit_instance;
        dispatch($this, mode);
    }
    function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
        var tmp;
        if (proposedUpdate instanceof CompletedExceptionally) // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        tmp = proposedUpdate;
        else if (!get_isCancellableMode(resumeMode) && idempotent == null) tmp = proposedUpdate;
        else {
            var tmp_0;
            var tmp_1;
            if (!(onCancellation == null)) tmp_1 = true;
            else tmp_1 = state instanceof CancelHandler;
            if (tmp_1) tmp_0 = true;
            else tmp_0 = !(idempotent == null);
            if (tmp_0) tmp = new CompletedContinuation(proposedUpdate, state instanceof CancelHandler ? state : null, onCancellation, idempotent);
            else tmp = proposedUpdate;
        }
        return tmp;
    }
    function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = $this.k1q_1;
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (!(state == null) ? isInterface(state, NotCompleted) : false) {
                var update = resumedState($this, state, proposedUpdate, resumeMode, onCancellation, null);
                if (!$this.k1q_1.atomicfu$compareAndSet(state, update)) break $l$block;
                detachChildIfNonResuable($this);
                dispatchResume($this, resumeMode);
                return Unit_instance;
            } else {
                if (state instanceof CancelledContinuation) {
                    if (state.i1r()) {
                        if (onCancellation == null) ;
                        else // Inline function 'kotlin.let' call
                        // Inline function 'kotlin.contracts.contract' call
                        $this.e1r(onCancellation, state.b1n_1);
                        return Unit_instance;
                    }
                }
            }
            alreadyResumedError($this, proposedUpdate);
        }
    }
    function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $super) {
        onCancellation = onCancellation === VOID ? null : onCancellation;
        return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
    }
    function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = $this.k1q_1;
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResumeImpl.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (!(state == null) ? isInterface(state, NotCompleted) : false) {
                var update = resumedState($this, state, proposedUpdate, $this.o1q_1, onCancellation, idempotent);
                if (!$this.k1q_1.atomicfu$compareAndSet(state, update)) break $l$block;
                detachChildIfNonResuable($this);
                return get_RESUME_TOKEN();
            } else {
                if (state instanceof CompletedContinuation) {
                    var tmp;
                    if (!(idempotent == null) && state.y1q_1 === idempotent) // Inline function 'kotlinx.coroutines.assert' call
                    tmp = get_RESUME_TOKEN();
                    else tmp = null;
                    return tmp;
                } else return null;
            }
        }
    }
    function alreadyResumedError($this, proposedUpdate) {
        // Inline function 'kotlin.error' call
        var message = "Already resumed, but proposed with update " + toString_0(proposedUpdate);
        throw IllegalStateException_init_$Create$(toString(message));
    }
    function detachChildIfNonResuable($this) {
        if (!isReusable($this)) $this.j1r();
    }
    function CancellableContinuationImpl(delegate, resumeMode) {
        DispatchedTask.call(this, resumeMode);
        this.h1q_1 = delegate;
        // Inline function 'kotlinx.coroutines.assert' call
        this.i1q_1 = this.h1q_1.b9();
        var tmp = this;
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        var tmp$ret$0 = (0 << _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()) + 536870911 | 0;
        tmp.j1q_1 = atomic$int$1(tmp$ret$0);
        this.k1q_1 = atomic$ref$1(Active_instance);
        this.l1q_1 = atomic$ref$1(null);
    }
    protoOf(CancellableContinuationImpl).k1r = function() {
        return this.h1q_1;
    };
    protoOf(CancellableContinuationImpl).b9 = function() {
        return this.i1q_1;
    };
    protoOf(CancellableContinuationImpl).p1n = function() {
        return this.k1q_1.kotlinx$atomicfu$value;
    };
    protoOf(CancellableContinuationImpl).q1n = function() {
        var tmp = this.p1n();
        return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
    };
    protoOf(CancellableContinuationImpl).r1p = function() {
        var tmp = this.p1n();
        return tmp instanceof CancelledContinuation;
    };
    protoOf(CancellableContinuationImpl).l1r = function() {
        var tmp0_elvis_lhs = installParentHandle(this);
        var tmp;
        if (tmp0_elvis_lhs == null) return Unit_instance;
        else tmp = tmp0_elvis_lhs;
        var handle = tmp;
        if (this.q1n()) {
            handle.y1p();
            this.l1q_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
        }
    };
    protoOf(CancellableContinuationImpl).m1q = function() {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var state = this.k1q_1.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.assert' call
        var tmp;
        if (state instanceof CompletedContinuation) tmp = !(state.y1q_1 == null);
        else tmp = false;
        if (tmp) {
            this.j1r();
            return false;
        }
        var tmp_0 = this.j1q_1;
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        tmp_0.kotlinx$atomicfu$value = (0 << _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()) + 536870911 | 0;
        this.k1q_1.kotlinx$atomicfu$value = Active_instance;
        return true;
    };
    protoOf(CancellableContinuationImpl).m1r = function() {
        return this.p1n();
    };
    protoOf(CancellableContinuationImpl).n1r = function(takenState, cause) {
        var this_0 = this.k1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (!(state == null) ? isInterface(state, NotCompleted) : false) {
                // Inline function 'kotlin.error' call
                var message = "Not completed";
                throw IllegalStateException_init_$Create$(toString(message));
            } else {
                if (state instanceof CompletedExceptionally) return Unit_instance;
                else if (state instanceof CompletedContinuation) {
                    // Inline function 'kotlin.check' call
                    // Inline function 'kotlin.contracts.contract' call
                    if (!!state.b1r()) {
                        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>.<anonymous>' call
                        var message_0 = "Must be called at most once";
                        throw IllegalStateException_init_$Create$(toString(message_0));
                    }
                    var update = state.c1r(VOID, VOID, VOID, VOID, cause);
                    if (this.k1q_1.atomicfu$compareAndSet(state, update)) {
                        state.o1r(this, cause);
                        return Unit_instance;
                    }
                } else {
                    if (this.k1q_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) return Unit_instance;
                }
            }
        }
        return Unit_instance;
    };
    protoOf(CancellableContinuationImpl).p1r = function(cause) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.k1q_1;
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancel.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (!(!(state == null) ? isInterface(state, NotCompleted) : false)) return false;
            var tmp;
            if (state instanceof CancelHandler) tmp = true;
            else tmp = state instanceof Segment;
            var update = new CancelledContinuation(this, cause, tmp);
            if (!this.k1q_1.atomicfu$compareAndSet(state, update)) break $l$block;
            if (state instanceof CancelHandler) this.a1r(state, cause);
            else if (state instanceof Segment) callSegmentOnCancellation(this, state, cause);
            detachChildIfNonResuable(this);
            dispatchResume(this, this.o1q_1);
            return true;
        }
    };
    protoOf(CancellableContinuationImpl).q1r = function(cause) {
        if (cancelLater(this, cause)) return Unit_instance;
        this.p1r(cause);
        detachChildIfNonResuable(this);
    };
    protoOf(CancellableContinuationImpl).a1r = function(handler, cause) {
        var tmp;
        try {
            handler.invoke(cause);
            tmp = Unit_instance;
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var ex = $p;
                handleCoroutineException(this.b9(), new CompletionHandlerException("Exception in invokeOnCancellation handler for " + this.toString(), ex));
                tmp_0 = Unit_instance;
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(CancellableContinuationImpl).e1r = function(onCancellation, cause) {
        try {
            onCancellation(cause);
        } catch ($p) {
            if ($p instanceof Error) {
                var ex = $p;
                handleCoroutineException(this.b9(), new CompletionHandlerException("Exception in resume onCancellation handler for " + this.toString(), ex));
            } else throw $p;
        }
    };
    protoOf(CancellableContinuationImpl).r1r = function(parent) {
        return parent.t1n();
    };
    protoOf(CancellableContinuationImpl).s1r = function() {
        var isReusable_0 = isReusable(this);
        if (trySuspend(this)) {
            if (_get_parentHandle__f8dcex(this) == null) installParentHandle(this);
            if (isReusable_0) this.t1r();
            return get_COROUTINE_SUSPENDED();
        }
        if (isReusable_0) this.t1r();
        var state = this.p1n();
        if (state instanceof CompletedExceptionally) throw recoverStackTrace(state.b1n_1, this);
        if (get_isCancellableMode(this.o1q_1)) {
            var job = this.b9().i9(Key_instance_3);
            if (!(job == null) && !job.w1m()) {
                var cause = job.t1n();
                this.n1r(state, cause);
                throw recoverStackTrace(cause, this);
            }
        }
        return this.u1r(state);
    };
    protoOf(CancellableContinuationImpl).t1r = function() {
        var tmp = this.h1q_1;
        var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v1r(this);
        var tmp_0;
        if (tmp1_elvis_lhs == null) return Unit_instance;
        else tmp_0 = tmp1_elvis_lhs;
        var cancellationCause = tmp_0;
        this.j1r();
        this.p1r(cancellationCause);
    };
    protoOf(CancellableContinuationImpl).g9 = function(result) {
        return resumeImpl$default(this, toState(result, this), this.o1q_1);
    };
    protoOf(CancellableContinuationImpl).w1r = function(value, onCancellation) {
        return resumeImpl(this, value, this.o1q_1, onCancellation);
    };
    protoOf(CancellableContinuationImpl).x1r = function(segment, index) {
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = this.j1q_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>' call
                // Inline function 'kotlin.check' call
                // Inline function 'kotlinx.coroutines.index' call
                // Inline function 'kotlin.contracts.contract' call
                if (!((cur & 536870911) === 536870911)) {
                    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>.<anonymous>' call
                    var message = "invokeOnCancellation should be called at most once";
                    throw IllegalStateException_init_$Create$(toString(message));
                }
                // Inline function 'kotlinx.coroutines.decisionAndIndex' call
                // Inline function 'kotlinx.coroutines.decision' call
                var upd = (cur >> _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i() << _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i()) + index | 0;
                if (this_0.atomicfu$compareAndSet(cur, upd)) break $l$block;
            }
        }
        invokeOnCancellationImpl(this, segment);
    };
    protoOf(CancellableContinuationImpl).u1p = function(handler) {
        var cancelHandler = makeCancelHandler(this, handler);
        invokeOnCancellationImpl(this, cancelHandler);
    };
    protoOf(CancellableContinuationImpl).j1r = function() {
        var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
        var tmp;
        if (tmp0_elvis_lhs == null) return Unit_instance;
        else tmp = tmp0_elvis_lhs;
        var handle = tmp;
        handle.y1p();
        this.l1q_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    };
    protoOf(CancellableContinuationImpl).s1p = function(value, idempotent, onCancellation) {
        return tryResumeImpl(this, value, idempotent, onCancellation);
    };
    protoOf(CancellableContinuationImpl).t1p = function(token) {
        // Inline function 'kotlinx.coroutines.assert' call
        dispatchResume(this, this.o1q_1);
    };
    protoOf(CancellableContinuationImpl).v1p = function(_this__u8e3s4, value) {
        var tmp = this.h1q_1;
        var dc = tmp instanceof DispatchedContinuation ? tmp : null;
        var tmp_0;
        if ((dc == null ? null : dc.a1q_1) === _this__u8e3s4) tmp_0 = 4;
        else tmp_0 = this.o1q_1;
        resumeImpl$default(this, value, tmp_0);
    };
    protoOf(CancellableContinuationImpl).u1r = function(state) {
        var tmp;
        if (state instanceof CompletedContinuation) {
            var tmp_0 = state.v1q_1;
            tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        } else tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
        return tmp;
    };
    protoOf(CancellableContinuationImpl).y1r = function(state) {
        var tmp0_safe_receiver = protoOf(DispatchedTask).y1r.call(this, state);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.getExceptionalResult.<anonymous>' call
        tmp = recoverStackTrace(tmp0_safe_receiver, this.h1q_1);
        return tmp;
    };
    protoOf(CancellableContinuationImpl).toString = function() {
        return this.z1r() + "(" + toDebugString(this.h1q_1) + "){" + _get_stateDebugRepresentation__bf18u4(this) + "}@" + get_hexAddress(this);
    };
    protoOf(CancellableContinuationImpl).z1r = function() {
        return "CancellableContinuation";
    };
    function NotCompleted() {}
    function CancelHandler() {
        CancelHandlerBase.call(this);
    }
    function Active() {}
    protoOf(Active).toString = function() {
        return "Active";
    };
    var Active_instance;
    function Active_getInstance() {
        return Active_instance;
    }
    function CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
        cancelHandler = cancelHandler === VOID ? null : cancelHandler;
        onCancellation = onCancellation === VOID ? null : onCancellation;
        idempotentResume = idempotentResume === VOID ? null : idempotentResume;
        cancelCause = cancelCause === VOID ? null : cancelCause;
        this.v1q_1 = result;
        this.w1q_1 = cancelHandler;
        this.x1q_1 = onCancellation;
        this.y1q_1 = idempotentResume;
        this.z1q_1 = cancelCause;
    }
    protoOf(CompletedContinuation).b1r = function() {
        return !(this.z1q_1 == null);
    };
    protoOf(CompletedContinuation).o1r = function(cont, cause) {
        var tmp0_safe_receiver = this.w1q_1;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        cont.a1r(tmp0_safe_receiver, cause);
        var tmp1_safe_receiver = this.x1q_1;
        if (tmp1_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        cont.e1r(tmp1_safe_receiver, cause);
    };
    protoOf(CompletedContinuation).c1s = function(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
        return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    };
    protoOf(CompletedContinuation).c1r = function(result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
        result = result === VOID ? this.v1q_1 : result;
        cancelHandler = cancelHandler === VOID ? this.w1q_1 : cancelHandler;
        onCancellation = onCancellation === VOID ? this.x1q_1 : onCancellation;
        idempotentResume = idempotentResume === VOID ? this.y1q_1 : idempotentResume;
        cancelCause = cancelCause === VOID ? this.z1q_1 : cancelCause;
        return $super === VOID ? this.c1s(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.c1s.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
    };
    protoOf(CompletedContinuation).toString = function() {
        return "CompletedContinuation(result=" + toString_0(this.v1q_1) + ", cancelHandler=" + toString_0(this.w1q_1) + ", onCancellation=" + toString_0(this.x1q_1) + ", idempotentResume=" + toString_0(this.y1q_1) + ", cancelCause=" + toString_0(this.z1q_1) + ")";
    };
    protoOf(CompletedContinuation).hashCode = function() {
        var result = this.v1q_1 == null ? 0 : hashCode(this.v1q_1);
        result = imul(result, 31) + (this.w1q_1 == null ? 0 : hashCode(this.w1q_1)) | 0;
        result = imul(result, 31) + (this.x1q_1 == null ? 0 : hashCode(this.x1q_1)) | 0;
        result = imul(result, 31) + (this.y1q_1 == null ? 0 : hashCode(this.y1q_1)) | 0;
        result = imul(result, 31) + (this.z1q_1 == null ? 0 : hashCode(this.z1q_1)) | 0;
        return result;
    };
    protoOf(CompletedContinuation).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CompletedContinuation)) return false;
        var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
        if (!equals(this.v1q_1, tmp0_other_with_cast.v1q_1)) return false;
        if (!equals(this.w1q_1, tmp0_other_with_cast.w1q_1)) return false;
        if (!equals(this.x1q_1, tmp0_other_with_cast.x1q_1)) return false;
        if (!equals(this.y1q_1, tmp0_other_with_cast.y1q_1)) return false;
        if (!equals(this.z1q_1, tmp0_other_with_cast.z1q_1)) return false;
        return true;
    };
    function InvokeOnCancel(handler) {
        CancelHandler.call(this);
        this.d1s_1 = handler;
    }
    protoOf(InvokeOnCancel).x1p = function(cause) {
        this.d1s_1(cause);
    };
    protoOf(InvokeOnCancel).invoke = function(cause) {
        return this.x1p(cause);
    };
    protoOf(InvokeOnCancel).toString = function() {
        return "InvokeOnCancel[" + get_classSimpleName(this.d1s_1) + "@" + get_hexAddress(this) + "]";
    };
    function _get_DECISION_SHIFT_$accessor$2jt7ek_1tkg2i() {
        _init_properties_CancellableContinuationImpl_kt__6rrtdd();
        return 29;
    }
    var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
    function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
        if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
            properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
            RESUME_TOKEN = new Symbol("RESUME_TOKEN");
        }
    }
    function CompletableDeferred(parent) {
        parent = parent === VOID ? null : parent;
        return new CompletableDeferredImpl(parent);
    }
    function $awaitCOROUTINE$1(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m1s_1 = _this__u8e3s4;
    }
    protoOf($awaitCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.m1s_1.q1o(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function CompletableDeferredImpl(parent) {
        JobSupport.call(this, true);
        this.r1m(parent);
    }
    protoOf(CompletableDeferredImpl).a1o = function() {
        return true;
    };
    protoOf(CompletableDeferredImpl).l1p = function() {
        var tmp = this.p1o();
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(CompletableDeferredImpl).m1p = function($completion) {
        var tmp = new $awaitCOROUTINE$1(this, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(CompletableDeferredImpl).p1s = function(value) {
        return this.q1s(value);
    };
    protoOf(CompletableDeferredImpl).r1s = function(exception) {
        return this.q1s(new CompletedExceptionally(exception));
    };
    function CompletableJob() {}
    function CompletedExceptionally(cause, handled) {
        handled = handled === VOID ? false : handled;
        this.b1n_1 = cause;
        this.c1n_1 = atomic$boolean$1(handled);
    }
    protoOf(CompletedExceptionally).d1n = function() {
        return this.c1n_1.kotlinx$atomicfu$value;
    };
    protoOf(CompletedExceptionally).d1r = function() {
        return this.c1n_1.atomicfu$compareAndSet(false, true);
    };
    protoOf(CompletedExceptionally).toString = function() {
        return get_classSimpleName(this) + "[" + this.b1n_1.toString() + "]";
    };
    function CancelledContinuation(continuation, cause, handled) {
        CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$("Continuation " + toString(continuation) + " was cancelled normally") : cause, handled);
        this.h1r_1 = atomic$boolean$1(false);
    }
    protoOf(CancelledContinuation).i1r = function() {
        return this.h1r_1.atomicfu$compareAndSet(false, true);
    };
    function toState(_this__u8e3s4, caller) {
        // Inline function 'kotlin.fold' call
        // Inline function 'kotlin.contracts.contract' call
        var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
        var tmp;
        if (exception == null) {
            // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
            var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
            tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        } else // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
        tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
        return tmp;
    }
    function toState_0(_this__u8e3s4, onCancellation) {
        onCancellation = onCancellation === VOID ? null : onCancellation;
        // Inline function 'kotlin.fold' call
        // Inline function 'kotlin.contracts.contract' call
        var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
        var tmp;
        if (exception == null) {
            // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
            var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
            var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            tmp = !(onCancellation == null) ? new CompletedWithCancellation(it, onCancellation) : it;
        } else // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
        tmp = new CompletedExceptionally(exception);
        return tmp;
    }
    function CompletedWithCancellation(result, onCancellation) {
        this.u1s_1 = result;
        this.v1s_1 = onCancellation;
    }
    protoOf(CompletedWithCancellation).toString = function() {
        return "CompletedWithCancellation(result=" + toString_0(this.u1s_1) + ", onCancellation=" + toString(this.v1s_1) + ")";
    };
    protoOf(CompletedWithCancellation).hashCode = function() {
        var result = this.u1s_1 == null ? 0 : hashCode(this.u1s_1);
        result = imul(result, 31) + hashCode(this.v1s_1) | 0;
        return result;
    };
    protoOf(CompletedWithCancellation).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CompletedWithCancellation)) return false;
        var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
        if (!equals(this.u1s_1, tmp0_other_with_cast.u1s_1)) return false;
        if (!equals(this.v1s_1, tmp0_other_with_cast.v1s_1)) return false;
        return true;
    };
    function recoverResult(state, uCont) {
        var tmp;
        if (state instanceof CompletedExceptionally) {
            // Inline function 'kotlin.Companion.failure' call
            var exception = recoverStackTrace(state.b1n_1, uCont);
            tmp = _Result___init__impl__xyqfz8(createFailure(exception));
        } else {
            // Inline function 'kotlin.Companion.success' call
            var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
            tmp = _Result___init__impl__xyqfz8(value);
        }
        return tmp;
    }
    function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
        return it instanceof CoroutineDispatcher ? it : null;
    }
    function Key() {
        Key_instance_0 = this;
        var tmp = Key_instance;
        AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
    }
    var Key_instance_0;
    function Key_getInstance() {
        if (Key_instance_0 == null) new Key();
        return Key_instance_0;
    }
    function CoroutineDispatcher() {
        Key_getInstance();
        AbstractCoroutineContextElement.call(this, Key_instance);
    }
    protoOf(CoroutineDispatcher).x1s = function(context) {
        return true;
    };
    protoOf(CoroutineDispatcher).j9 = function(continuation) {
        return new DispatchedContinuation(this, continuation);
    };
    protoOf(CoroutineDispatcher).k9 = function(continuation) {
        var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
        dispatched.z1s();
    };
    protoOf(CoroutineDispatcher).toString = function() {
        return get_classSimpleName(this) + "@" + get_hexAddress(this);
    };
    function handleCoroutineException(context, exception) {
        try {
            var tmp0_safe_receiver = context.i9(Key_instance_1);
            if (tmp0_safe_receiver == null) ;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                tmp0_safe_receiver.a1t(context, exception);
                return Unit_instance;
            }
        } catch ($p) {
            if ($p instanceof Error) {
                var t = $p;
                handleUncaughtCoroutineException(context, handlerException(exception, t));
                return Unit_instance;
            } else throw $p;
        }
        handleUncaughtCoroutineException(context, exception);
    }
    function Key_0() {}
    var Key_instance_1;
    function Key_getInstance_0() {
        return Key_instance_1;
    }
    function handlerException(originalException, thrownException) {
        if (originalException === thrownException) return originalException;
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.handlerException.<anonymous>' call
        // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
        return RuntimeException_init_$Create$("Exception while trying to handle coroutine exception", thrownException);
    }
    function Key_1() {}
    var Key_instance_2;
    function Key_getInstance_1() {
        return Key_instance_2;
    }
    function CoroutineName(name) {
        AbstractCoroutineContextElement.call(this, Key_instance_2);
        this.c1t_1 = name;
    }
    protoOf(CoroutineName).toString = function() {
        return "CoroutineName(" + this.c1t_1 + ")";
    };
    protoOf(CoroutineName).hashCode = function() {
        return getStringHashCode(this.c1t_1);
    };
    protoOf(CoroutineName).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CoroutineName)) return false;
        var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
        if (!(this.c1t_1 === tmp0_other_with_cast.c1t_1)) return false;
        return true;
    };
    function CoroutineScope() {}
    function GlobalScope() {}
    protoOf(GlobalScope).v1m = function() {
        return EmptyCoroutineContext_getInstance();
    };
    var GlobalScope_instance;
    function GlobalScope_getInstance() {
        return GlobalScope_instance;
    }
    function cancel(_this__u8e3s4, cause) {
        cause = cause === VOID ? null : cause;
        var tmp0_elvis_lhs = _this__u8e3s4.v1m().i9(Key_instance_3);
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "Scope cannot be cancelled because it does not have a job: " + toString(_this__u8e3s4);
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        var job = tmp;
        job.b1o(cause);
    }
    function cancel_0(_this__u8e3s4, message, cause) {
        cause = cause === VOID ? null : cause;
        return cancel(_this__u8e3s4, CancellationException_init_$Create$_0(message, cause));
    }
    function coroutineScope(block, $completion) {
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.coroutineScope.<anonymous>' call
        var coroutine = new ScopeCoroutine($completion.b9(), $completion);
        return startUndispatchedOrReturn(coroutine, coroutine, block);
    }
    function CoroutineScope_0(context) {
        return new ContextScope(!(context.i9(Key_instance_3) == null) ? context : context.vf(Job_0()));
    }
    var CoroutineStart_DEFAULT_instance;
    var CoroutineStart_LAZY_instance;
    var CoroutineStart_ATOMIC_instance;
    var CoroutineStart_UNDISPATCHED_instance;
    var CoroutineStart_entriesInitialized;
    function CoroutineStart_initEntries() {
        if (CoroutineStart_entriesInitialized) return Unit_instance;
        CoroutineStart_entriesInitialized = true;
        CoroutineStart_DEFAULT_instance = new CoroutineStart("DEFAULT", 0);
        CoroutineStart_LAZY_instance = new CoroutineStart("LAZY", 1);
        CoroutineStart_ATOMIC_instance = new CoroutineStart("ATOMIC", 2);
        CoroutineStart_UNDISPATCHED_instance = new CoroutineStart("UNDISPATCHED", 3);
    }
    function CoroutineStart(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    protoOf(CoroutineStart).m1n = function(block, receiver, completion) {
        var tmp;
        switch(this.q2_1){
            case 0:
                startCoroutineCancellable_0(block, receiver, completion);
                tmp = Unit_instance;
                break;
            case 2:
                startCoroutine(block, receiver, completion);
                tmp = Unit_instance;
                break;
            case 3:
                startCoroutineUndispatched(block, receiver, completion);
                tmp = Unit_instance;
                break;
            case 1:
                tmp = Unit_instance;
                break;
            default:
                noWhenBranchMatchedException();
                break;
        }
        return tmp;
    };
    protoOf(CoroutineStart).r1o = function() {
        return this === CoroutineStart_LAZY_getInstance();
    };
    function CoroutineStart_DEFAULT_getInstance() {
        CoroutineStart_initEntries();
        return CoroutineStart_DEFAULT_instance;
    }
    function CoroutineStart_LAZY_getInstance() {
        CoroutineStart_initEntries();
        return CoroutineStart_LAZY_instance;
    }
    function Delay() {}
    function get_delay(_this__u8e3s4) {
        var tmp = _this__u8e3s4.i9(Key_instance);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
        return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
    }
    function delay(timeMillis, $completion) {
        if (timeMillis.j1(new Long(0, 0)) <= 0) return Unit_instance;
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
        cancellable.l1r();
        // Inline function 'kotlinx.coroutines.delay.<anonymous>' call
        if (timeMillis.j1(new Long(-1, 2147483647)) < 0) get_delay(cancellable.b9()).d1t(timeMillis, cancellable);
        return cancellable.s1r();
    }
    function delta($this, unconfined) {
        return unconfined ? new Long(0, 1) : new Long(1, 0);
    }
    function EventLoop() {
        CoroutineDispatcher.call(this);
        this.f1t_1 = new Long(0, 0);
        this.g1t_1 = false;
        this.h1t_1 = null;
    }
    protoOf(EventLoop).i1t = function() {
        var tmp0_elvis_lhs = this.h1t_1;
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var queue = tmp;
        var tmp1_elvis_lhs = queue.ge();
        var tmp_0;
        if (tmp1_elvis_lhs == null) return false;
        else tmp_0 = tmp1_elvis_lhs;
        var task = tmp_0;
        task.a1s();
        return true;
    };
    protoOf(EventLoop).j1t = function(task) {
        var tmp0_elvis_lhs = this.h1t_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = ArrayDeque_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.EventLoop.dispatchUnconfined.<anonymous>' call
            this.h1t_1 = this_0;
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        var queue = tmp;
        queue.ee(task);
    };
    protoOf(EventLoop).k1t = function() {
        return this.f1t_1.j1(delta(this, true)) >= 0;
    };
    protoOf(EventLoop).l1t = function() {
        var tmp0_safe_receiver = this.h1t_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s();
        return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
    };
    protoOf(EventLoop).m1t = function(unconfined) {
        this.f1t_1 = this.f1t_1.y2(delta(this, unconfined));
        if (!unconfined) this.g1t_1 = true;
    };
    protoOf(EventLoop).n1t = function(unconfined) {
        this.f1t_1 = this.f1t_1.z2(delta(this, unconfined));
        if (this.f1t_1.j1(new Long(0, 0)) > 0) return Unit_instance;
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.g1t_1) this.o1t();
    };
    protoOf(EventLoop).o1t = function() {};
    function ThreadLocalEventLoop() {
        ThreadLocalEventLoop_instance = this;
        this.p1t_1 = commonThreadLocal(new Symbol("ThreadLocalEventLoop"));
    }
    protoOf(ThreadLocalEventLoop).q1t = function() {
        var tmp0_elvis_lhs = this.p1t_1.s1t();
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createEventLoop();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.ThreadLocalEventLoop.<get-eventLoop>.<anonymous>' call
            ThreadLocalEventLoop_getInstance().p1t_1.t1t(this_0);
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    var ThreadLocalEventLoop_instance;
    function ThreadLocalEventLoop_getInstance() {
        if (ThreadLocalEventLoop_instance == null) new ThreadLocalEventLoop();
        return ThreadLocalEventLoop_instance;
    }
    function CompletionHandlerException(message, cause) {
        RuntimeException_init_$Init$(message, cause, this);
        captureStack(this, CompletionHandlerException);
    }
    function CoroutinesInternalError(message, cause) {
        Error_init_$Init$(message, cause, this);
        captureStack(this, CoroutinesInternalError);
    }
    function Key_2() {}
    var Key_instance_3;
    function Key_getInstance_2() {
        return Key_instance_3;
    }
    function Job() {}
    function ParentJob() {}
    function ChildHandle() {}
    function NonDisposableHandle() {}
    protoOf(NonDisposableHandle).y1p = function() {};
    protoOf(NonDisposableHandle).f1o = function(cause) {
        return false;
    };
    protoOf(NonDisposableHandle).toString = function() {
        return "NonDisposableHandle";
    };
    var NonDisposableHandle_instance;
    function NonDisposableHandle_getInstance() {
        return NonDisposableHandle_instance;
    }
    function ensureActive(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4.i9(Key_instance_3);
        if (tmp0_safe_receiver == null) ;
        else ensureActive_0(tmp0_safe_receiver);
    }
    function ensureActive_0(_this__u8e3s4) {
        if (!_this__u8e3s4.w1m()) throw _this__u8e3s4.t1n();
    }
    function cancel_1(_this__u8e3s4, message, cause) {
        cause = cause === VOID ? null : cause;
        return _this__u8e3s4.b1o(CancellationException_init_$Create$_0(message, cause));
    }
    function Job_0(parent) {
        parent = parent === VOID ? null : parent;
        return new JobImpl(parent);
    }
    function get_job(_this__u8e3s4) {
        var tmp0_elvis_lhs = _this__u8e3s4.i9(Key_instance_3);
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function cancel_2(_this__u8e3s4, cause) {
        cause = cause === VOID ? null : cause;
        var tmp0_safe_receiver = _this__u8e3s4.i9(Key_instance_3);
        if (tmp0_safe_receiver == null) ;
        else tmp0_safe_receiver.b1o(cause);
    }
    function get_COMPLETING_ALREADY() {
        _init_properties_JobSupport_kt__68f172();
        return COMPLETING_ALREADY;
    }
    var COMPLETING_ALREADY;
    function get_COMPLETING_WAITING_CHILDREN() {
        _init_properties_JobSupport_kt__68f172();
        return COMPLETING_WAITING_CHILDREN;
    }
    var COMPLETING_WAITING_CHILDREN;
    function get_COMPLETING_RETRY() {
        _init_properties_JobSupport_kt__68f172();
        return COMPLETING_RETRY;
    }
    var COMPLETING_RETRY;
    function get_TOO_LATE_TO_CANCEL() {
        _init_properties_JobSupport_kt__68f172();
        return TOO_LATE_TO_CANCEL;
    }
    var TOO_LATE_TO_CANCEL;
    function get_SEALED() {
        _init_properties_JobSupport_kt__68f172();
        return SEALED;
    }
    var SEALED;
    function get_EMPTY_NEW() {
        _init_properties_JobSupport_kt__68f172();
        return EMPTY_NEW;
    }
    var EMPTY_NEW;
    function get_EMPTY_ACTIVE() {
        _init_properties_JobSupport_kt__68f172();
        return EMPTY_ACTIVE;
    }
    var EMPTY_ACTIVE;
    function Empty(isActive) {
        this.u1t_1 = isActive;
    }
    protoOf(Empty).w1m = function() {
        return this.u1t_1;
    };
    protoOf(Empty).v1t = function() {
        return null;
    };
    protoOf(Empty).toString = function() {
        return "Empty{" + (this.u1t_1 ? "Active" : "New") + "}";
    };
    function Incomplete() {}
    function NodeList() {
        LinkedListHead.call(this);
    }
    protoOf(NodeList).w1m = function() {
        return true;
    };
    protoOf(NodeList).v1t = function() {
        return this;
    };
    protoOf(NodeList).z1t = function(state) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>' call
        this_0.e8("List{");
        this_0.e8(state);
        this_0.e8("}[");
        var first = true;
        // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
        var cur = this.a1u_1;
        while(!equals(cur, this)){
            if (cur instanceof JobNode) {
                // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>.<anonymous>' call
                var node = cur;
                if (first) first = false;
                else this_0.e8(", ");
                this_0.d8(node);
            }
            cur = cur.a1u_1;
        }
        this_0.e8("]");
        return this_0.toString();
    };
    protoOf(NodeList).toString = function() {
        return get_DEBUG() ? this.z1t("Active") : protoOf(LinkedListHead).toString.call(this);
    };
    function JobNode() {
        CompletionHandlerBase.call(this);
    }
    protoOf(JobNode).n1u = function() {
        var tmp = this.m1u_1;
        if (!(tmp == null)) return tmp;
        else throwUninitializedPropertyAccessException("job");
    };
    protoOf(JobNode).w1m = function() {
        return true;
    };
    protoOf(JobNode).v1t = function() {
        return null;
    };
    protoOf(JobNode).y1p = function() {
        return this.n1u().z1n(this);
    };
    protoOf(JobNode).toString = function() {
        return get_classSimpleName(this) + "@" + get_hexAddress(this) + "[job@" + get_hexAddress(this.n1u()) + "]";
    };
    function _set_exceptionsHolder__tqm22h($this, value) {
        $this.s1u_1.kotlinx$atomicfu$value = value;
    }
    function _get_exceptionsHolder__nhszp($this) {
        return $this.s1u_1.kotlinx$atomicfu$value;
    }
    function allocateList($this) {
        return ArrayList_init_$Create$(4);
    }
    function finalizeFinishingState($this, state, proposedUpdate) {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
        var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1n_1;
        var wasCancelling;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        // Inline function 'kotlinx.coroutines.JobSupport.finalizeFinishingState.<anonymous>' call
        wasCancelling = state.t1u();
        var exceptions = state.u1u(proposedException);
        var finalCause = getFinalRootCause($this, state, exceptions);
        if (!(finalCause == null)) addSuppressedExceptions($this, finalCause, exceptions);
        var finalException = finalCause;
        var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
        if (!(finalException == null)) {
            var handled = cancelParent($this, finalException) || $this.m1o(finalException);
            if (handled) (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).d1r();
        }
        if (!wasCancelling) $this.j1o(finalException);
        $this.a1n(finalState);
        var casSuccess = $this.p1m_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
        // Inline function 'kotlinx.coroutines.assert' call
        completeStateFinalization($this, state, finalState);
        return finalState;
    }
    function getFinalRootCause($this, state, exceptions) {
        if (exceptions.s()) {
            if (state.t1u()) // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
            return new JobCancellationException($this.z1m(), null, $this);
            return null;
        }
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = exceptions.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
                if (!(element instanceof CancellationException)) {
                    tmp$ret$2 = element;
                    break $l$block;
                }
            }
            tmp$ret$2 = null;
        }
        var firstNonCancellation = tmp$ret$2;
        if (!(firstNonCancellation == null)) return firstNonCancellation;
        var first = exceptions.o(0);
        if (first instanceof TimeoutCancellationException) {
            var tmp$ret$4;
            $l$block_0: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var tmp0_iterator_0 = exceptions.j();
                while(tmp0_iterator_0.k()){
                    var element_0 = tmp0_iterator_0.l();
                    // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
                    var tmp;
                    if (!(element_0 === first)) tmp = element_0 instanceof TimeoutCancellationException;
                    else tmp = false;
                    if (tmp) {
                        tmp$ret$4 = element_0;
                        break $l$block_0;
                    }
                }
                tmp$ret$4 = null;
            }
            var detailedTimeoutException = tmp$ret$4;
            if (!(detailedTimeoutException == null)) return detailedTimeoutException;
        }
        return first;
    }
    function addSuppressedExceptions($this, rootCause, exceptions) {
        if (exceptions.m() <= 1) return Unit_instance;
        var seenExceptions = identitySet(exceptions.m());
        var unwrappedCause = unwrap(rootCause);
        var tmp0_iterator = exceptions.j();
        while(tmp0_iterator.k()){
            var exception = tmp0_iterator.l();
            var unwrapped = unwrap(exception);
            var tmp;
            var tmp_0;
            if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) tmp_0 = !(unwrapped instanceof CancellationException);
            else tmp_0 = false;
            if (tmp_0) tmp = seenExceptions.e(unwrapped);
            else tmp = false;
            tmp;
        }
    }
    function tryFinalizeSimpleState($this, state, update) {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        if (!$this.p1m_1.atomicfu$compareAndSet(state, boxIncomplete(update))) return false;
        $this.j1o(null);
        $this.a1n(update);
        completeStateFinalization($this, state, update);
        return true;
    }
    function completeStateFinalization($this, state, update) {
        var tmp0_safe_receiver = $this.o1n();
        if (tmp0_safe_receiver == null) ;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            tmp0_safe_receiver.y1p();
            $this.n1n(NonDisposableHandle_instance);
        }
        var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
        var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b1n_1;
        if (state instanceof JobNode) try {
            state.invoke(cause);
        } catch ($p) {
            if ($p instanceof Error) {
                var ex = $p;
                $this.h1n(new CompletionHandlerException("Exception in completion handler " + toString(state) + " for " + $this.toString(), ex));
            } else throw $p;
        }
        else {
            var tmp2_safe_receiver = state.v1t();
            if (tmp2_safe_receiver == null) ;
            else notifyCompletion(tmp2_safe_receiver, $this, cause);
        }
    }
    function notifyCancelling($this, list, cause) {
        $this.j1o(cause);
        // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
        var exception = null;
        // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
        var cur = list.a1u_1;
        while(!equals(cur, list)){
            if (cur instanceof JobCancellingNode) {
                // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
                var node = cur;
                try {
                    node.invoke(cause);
                } catch ($p) {
                    if ($p instanceof Error) {
                        var ex = $p;
                        var tmp0_safe_receiver = exception;
                        var tmp;
                        if (tmp0_safe_receiver == null) tmp = null;
                        else // Inline function 'kotlin.apply' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
                        // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
                        tmp = tmp0_safe_receiver;
                        if (tmp == null) // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        exception = new CompletionHandlerException("Exception in completion handler " + node.toString() + " for " + $this.toString(), ex);
                    } else throw $p;
                }
            }
            cur = cur.a1u_1;
        }
        var tmp0_safe_receiver_0 = exception;
        if (tmp0_safe_receiver_0 == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $this.h1n(tmp0_safe_receiver_0);
        cancelParent($this, cause);
    }
    function cancelParent($this, cause) {
        if ($this.k1o()) return true;
        var isCancellation = cause instanceof CancellationException;
        var parent = $this.o1n();
        if (parent === null || parent === NonDisposableHandle_instance) return isCancellation;
        return parent.f1o(cause) || isCancellation;
    }
    function notifyCompletion(_this__u8e3s4, $this, cause) {
        var exception = null;
        // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
        var cur = _this__u8e3s4.a1u_1;
        while(!equals(cur, _this__u8e3s4)){
            if (cur instanceof JobNode) {
                // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
                var node = cur;
                try {
                    node.invoke(cause);
                } catch ($p) {
                    if ($p instanceof Error) {
                        var ex = $p;
                        var tmp0_safe_receiver = exception;
                        var tmp;
                        if (tmp0_safe_receiver == null) tmp = null;
                        else // Inline function 'kotlin.apply' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
                        // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
                        tmp = tmp0_safe_receiver;
                        if (tmp == null) // Inline function 'kotlin.run' call
                        // Inline function 'kotlin.contracts.contract' call
                        exception = new CompletionHandlerException("Exception in completion handler " + node.toString() + " for " + $this.toString(), ex);
                    } else throw $p;
                }
            }
            cur = cur.a1u_1;
        }
        var tmp0_safe_receiver_0 = exception;
        if (tmp0_safe_receiver_0 == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        $this.h1n(tmp0_safe_receiver_0);
        return Unit_instance;
    }
    function startInternal($this, state) {
        if (state instanceof Empty) {
            if (state.u1t_1) return 0;
            if (!$this.p1m_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE())) return -1;
            $this.s1n();
            return 1;
        } else {
            if (state instanceof InactiveNodeList) {
                if (!$this.p1m_1.atomicfu$compareAndSet(state, state.v1u_1)) return -1;
                $this.s1n();
                return 1;
            } else return 0;
        }
    }
    function makeNode($this, handler, onCancelling) {
        var tmp;
        if (onCancelling) {
            var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
            tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
        } else {
            var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
            var tmp_0;
            if (tmp1_safe_receiver == null) tmp_0 = null;
            else // Inline function 'kotlin.also' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.JobSupport.makeNode.<anonymous>' call
            // Inline function 'kotlinx.coroutines.assert' call
            tmp_0 = tmp1_safe_receiver;
            var tmp2_elvis_lhs = tmp_0;
            tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
        }
        var node = tmp;
        node.m1u_1 = $this;
        return node;
    }
    function addLastAtomic($this, expect, list, node) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.coroutines.internal.LinkedListNode.addLastIf' call
            // Inline function 'kotlinx.coroutines.JobSupport.addLastAtomic.<anonymous>' call
            if (!($this.p1n() === expect)) {
                tmp$ret$1 = false;
                break $l$block;
            }
            list.h1u(node);
            tmp$ret$1 = true;
        }
        return tmp$ret$1;
    }
    function promoteEmptyToNodeList($this, state) {
        var list = new NodeList();
        var update = state.u1t_1 ? list : new InactiveNodeList(list);
        $this.p1m_1.atomicfu$compareAndSet(state, update);
    }
    function promoteSingleToNodeList($this, state) {
        state.o1u(new NodeList());
        // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
        var list = state.a1u_1;
        $this.p1m_1.atomicfu$compareAndSet(state, list);
    }
    function joinInternal($this) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true){
            // Inline function 'kotlinx.coroutines.JobSupport.joinInternal.<anonymous>' call
            var state = $this.p1n();
            if (!(!(state == null) ? isInterface(state, Incomplete) : false)) return false;
            if (startInternal($this, state) >= 0) return true;
        }
    }
    function joinSuspend($this, $completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
        cancellable.l1r();
        // Inline function 'kotlinx.coroutines.JobSupport.joinSuspend.<anonymous>' call
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ResumeOnCompletion(cancellable);
        disposeOnCancellation(cancellable, $this.w1n(tmp$ret$1));
        return cancellable.s1r();
    }
    function cancelMakeCompleting($this, cause) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true){
            // Inline function 'kotlinx.coroutines.JobSupport.cancelMakeCompleting.<anonymous>' call
            var state = $this.p1n();
            var tmp;
            if (!(!(state == null) ? isInterface(state, Incomplete) : false)) tmp = true;
            else {
                var tmp_0;
                if (state instanceof Finishing) tmp_0 = state.w1u();
                else tmp_0 = false;
                tmp = tmp_0;
            }
            if (tmp) return get_COMPLETING_ALREADY();
            var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
            var finalState = tryMakeCompleting($this, state, proposedUpdate);
            if (!(finalState === get_COMPLETING_RETRY())) return finalState;
        }
    }
    function createCauseException($this, cause) {
        var tmp;
        if (cause == null ? true : cause instanceof Error) {
            var tmp_0;
            if (cause == null) // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
            tmp_0 = new JobCancellationException($this.z1m(), null, $this);
            else tmp_0 = cause;
            tmp = tmp_0;
        } else tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).h1o();
        return tmp;
    }
    function makeCancelling($this, cause) {
        var causeExceptionCache = null;
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>' call
            var state = $this.p1n();
            if (state instanceof Finishing) {
                // Inline function 'kotlinx.coroutines.internal.synchronized' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
                // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
                if (state.x1u()) return get_TOO_LATE_TO_CANCEL();
                var wasCancelling = state.t1u();
                if (!(cause == null) || !wasCancelling) {
                    var tmp0_elvis_lhs = causeExceptionCache;
                    var tmp;
                    if (tmp0_elvis_lhs == null) {
                        // Inline function 'kotlin.also' call
                        var this_0 = createCauseException($this, cause);
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
                        causeExceptionCache = this_0;
                        tmp = this_0;
                    } else tmp = tmp0_elvis_lhs;
                    var causeException = tmp;
                    state.y1u(causeException);
                }
                // Inline function 'kotlin.takeIf' call
                var this_1 = state.z1u();
                // Inline function 'kotlin.contracts.contract' call
                var tmp_0;
                // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
                if (!wasCancelling) tmp_0 = this_1;
                else tmp_0 = null;
                var notifyRootCause = tmp_0;
                if (notifyRootCause == null) ;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                notifyCancelling($this, state.p1u_1, notifyRootCause);
                return get_COMPLETING_ALREADY();
            } else {
                if (!(state == null) ? isInterface(state, Incomplete) : false) {
                    var tmp2_elvis_lhs = causeExceptionCache;
                    var tmp_1;
                    if (tmp2_elvis_lhs == null) {
                        // Inline function 'kotlin.also' call
                        var this_2 = createCauseException($this, cause);
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
                        causeExceptionCache = this_2;
                        tmp_1 = this_2;
                    } else tmp_1 = tmp2_elvis_lhs;
                    var causeException_0 = tmp_1;
                    if (state.w1m()) {
                        if (tryMakeCancelling($this, state, causeException_0)) return get_COMPLETING_ALREADY();
                    } else {
                        var finalState = tryMakeCompleting($this, state, new CompletedExceptionally(causeException_0));
                        if (finalState === get_COMPLETING_ALREADY()) {
                            // Inline function 'kotlin.error' call
                            var message = "Cannot happen in " + toString_0(state);
                            throw IllegalStateException_init_$Create$(toString(message));
                        } else if (finalState === get_COMPLETING_RETRY()) break $l$block;
                        else return finalState;
                    }
                } else return get_TOO_LATE_TO_CANCEL();
            }
        }
    }
    function getOrPromoteCancellingList($this, state) {
        var tmp1_elvis_lhs = state.v1t();
        var tmp;
        if (tmp1_elvis_lhs == null) {
            var tmp_0;
            if (state instanceof Empty) tmp_0 = new NodeList();
            else if (state instanceof JobNode) {
                promoteSingleToNodeList($this, state);
                tmp_0 = null;
            } else {
                var message = "State should have list: " + toString(state);
                throw IllegalStateException_init_$Create$(toString(message));
            }
            tmp = tmp_0;
        } else tmp = tmp1_elvis_lhs;
        return tmp;
    }
    function tryMakeCancelling($this, state, rootCause) {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var list = tmp;
        var cancelling = new Finishing(list, false, rootCause);
        if (!$this.p1m_1.atomicfu$compareAndSet(state, cancelling)) return false;
        notifyCancelling($this, list, rootCause);
        return true;
    }
    function tryMakeCompleting($this, state, proposedUpdate) {
        if (!(!(state == null) ? isInterface(state, Incomplete) : false)) return get_COMPLETING_ALREADY();
        var tmp;
        var tmp_0;
        var tmp_1;
        if (state instanceof Empty) tmp_1 = true;
        else tmp_1 = state instanceof JobNode;
        if (tmp_1) tmp_0 = !(state instanceof ChildHandleNode);
        else tmp_0 = false;
        if (tmp_0) tmp = !(proposedUpdate instanceof CompletedExceptionally);
        else tmp = false;
        if (tmp) {
            if (tryFinalizeSimpleState($this, state, proposedUpdate)) return proposedUpdate;
            return get_COMPLETING_RETRY();
        }
        return tryMakeCompletingSlowPath($this, state, proposedUpdate);
    }
    function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
        var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
        var tmp;
        if (tmp0_elvis_lhs == null) return get_COMPLETING_RETRY();
        else tmp = tmp0_elvis_lhs;
        var list = tmp;
        var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
        var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
        var notifyRootCause = null;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (finishing.w1u()) return get_COMPLETING_ALREADY();
        finishing.a1v(true);
        if (!(finishing === state)) {
            if (!$this.p1m_1.atomicfu$compareAndSet(state, finishing)) return get_COMPLETING_RETRY();
        }
        // Inline function 'kotlinx.coroutines.assert' call
        var wasCancelling = finishing.t1u();
        var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        finishing.y1u(tmp0_safe_receiver.b1n_1);
        // Inline function 'kotlin.takeIf' call
        var this_0 = finishing.z1u();
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
        if (!wasCancelling) tmp_0 = this_0;
        else tmp_0 = null;
        notifyRootCause = tmp_0;
        var tmp2_safe_receiver = notifyRootCause;
        if (tmp2_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        notifyCancelling($this, list, tmp2_safe_receiver);
        var child = firstChild($this, state);
        if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate)) return get_COMPLETING_WAITING_CHILDREN();
        return finalizeFinishingState($this, finishing, proposedUpdate);
    }
    function _get_exceptionOrNull__b3j7js(_this__u8e3s4, $this) {
        var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1n_1;
    }
    function firstChild($this, state) {
        var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
        var tmp;
        if (tmp1_elvis_lhs == null) {
            var tmp0_safe_receiver = state.v1t();
            tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
        } else tmp = tmp1_elvis_lhs;
        return tmp;
    }
    function tryWaitForChild($this, state, child, proposedUpdate) {
        var $this_0 = $this;
        var state_0 = state;
        var child_0 = child;
        var proposedUpdate_0 = proposedUpdate;
        $l$1: do $l$0: do {
            var tmp = child_0.f1v_1;
            // Inline function 'kotlinx.coroutines.asHandler' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$1 = new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0);
            var handle = tmp.y1n(VOID, false, tmp$ret$1);
            if (!(handle === NonDisposableHandle_instance)) return true;
            var tmp0_elvis_lhs = nextChild(child_0, $this_0);
            var tmp_0;
            if (tmp0_elvis_lhs == null) return false;
            else tmp_0 = tmp0_elvis_lhs;
            var nextChild_0 = tmp_0;
            $this_0;
            state_0;
            child_0 = nextChild_0;
            proposedUpdate_0;
            continue $l$0;
        }while (false);
        while (true);
    }
    function continueCompleting($this, state, lastChild, proposedUpdate) {
        // Inline function 'kotlinx.coroutines.assert' call
        var waitChild = nextChild(lastChild, $this);
        if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate)) return Unit_instance;
        var finalState = finalizeFinishingState($this, state, proposedUpdate);
        $this.g1n(finalState);
    }
    function nextChild(_this__u8e3s4, $this) {
        var cur = _this__u8e3s4;
        $l$loop: while(true){
            // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
            if (!cur.c1u_1) break $l$loop;
            // Inline function 'kotlinx.coroutines.internal.LinkedListNode.prevNode' call
            cur = cur.b1u_1;
        }
        $l$loop_0: while(true){
            // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
            cur = cur.a1u_1;
            // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
            if (cur.c1u_1) continue $l$loop_0;
            if (cur instanceof ChildHandleNode) return cur;
            if (cur instanceof NodeList) return null;
        }
    }
    function stateString($this, state) {
        var tmp;
        if (state instanceof Finishing) tmp = state.t1u() ? "Cancelling" : state.w1u() ? "Completing" : "Active";
        else {
            if (!(state == null) ? isInterface(state, Incomplete) : false) tmp = state.w1m() ? "Active" : "New";
            else if (state instanceof CompletedExceptionally) tmp = "Cancelled";
            else tmp = "Completed";
        }
        return tmp;
    }
    function Finishing(list, isCompleting, rootCause) {
        this.p1u_1 = list;
        this.q1u_1 = atomic$boolean$1(isCompleting);
        this.r1u_1 = atomic$ref$1(rootCause);
        this.s1u_1 = atomic$ref$1(null);
    }
    protoOf(Finishing).v1t = function() {
        return this.p1u_1;
    };
    protoOf(Finishing).a1v = function(value) {
        this.q1u_1.kotlinx$atomicfu$value = value;
    };
    protoOf(Finishing).w1u = function() {
        return this.q1u_1.kotlinx$atomicfu$value;
    };
    protoOf(Finishing).g1v = function(value) {
        this.r1u_1.kotlinx$atomicfu$value = value;
    };
    protoOf(Finishing).z1u = function() {
        return this.r1u_1.kotlinx$atomicfu$value;
    };
    protoOf(Finishing).x1u = function() {
        return _get_exceptionsHolder__nhszp(this) === get_SEALED();
    };
    protoOf(Finishing).t1u = function() {
        return !(this.z1u() == null);
    };
    protoOf(Finishing).w1m = function() {
        return this.z1u() == null;
    };
    protoOf(Finishing).u1u = function(proposedException) {
        var eh = _get_exceptionsHolder__nhszp(this);
        var tmp;
        if (eh == null) tmp = allocateList(this);
        else {
            if (eh instanceof Error) {
                // Inline function 'kotlin.also' call
                var this_0 = allocateList(this);
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
                this_0.e(eh);
                tmp = this_0;
            } else if (eh instanceof ArrayList) tmp = eh instanceof ArrayList ? eh : THROW_CCE();
            else {
                var message = "State is " + toString_0(eh);
                throw IllegalStateException_init_$Create$(toString(message));
            }
        }
        var list = tmp;
        var rootCause = this.z1u();
        if (rootCause == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        list.k2(0, rootCause);
        if (!(proposedException == null) && !equals(proposedException, rootCause)) list.e(proposedException);
        _set_exceptionsHolder__tqm22h(this, get_SEALED());
        return list;
    };
    protoOf(Finishing).y1u = function(exception) {
        var rootCause = this.z1u();
        if (rootCause == null) {
            this.g1v(exception);
            return Unit_instance;
        }
        if (exception === rootCause) return Unit_instance;
        var eh = _get_exceptionsHolder__nhszp(this);
        if (eh == null) _set_exceptionsHolder__tqm22h(this, exception);
        else {
            if (eh instanceof Error) {
                if (exception === eh) return Unit_instance;
                // Inline function 'kotlin.apply' call
                var this_0 = allocateList(this);
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlinx.coroutines.Finishing.addExceptionLocked.<anonymous>' call
                this_0.e(eh);
                this_0.e(exception);
                _set_exceptionsHolder__tqm22h(this, this_0);
            } else if (eh instanceof ArrayList) (eh instanceof ArrayList ? eh : THROW_CCE()).e(exception);
            else {
                var message = "State is " + toString_0(eh);
                throw IllegalStateException_init_$Create$(toString(message));
            }
        }
    };
    protoOf(Finishing).toString = function() {
        return "Finishing[cancelling=" + this.t1u() + ", completing=" + this.w1u() + ", rootCause=" + toString_0(this.z1u()) + ", exceptions=" + toString_0(_get_exceptionsHolder__nhszp(this)) + ", list=" + this.p1u_1.toString() + "]";
    };
    function ChildCompletion(parent, state, child, proposedUpdate) {
        JobNode.call(this);
        this.l1v_1 = parent;
        this.m1v_1 = state;
        this.n1v_1 = child;
        this.o1v_1 = proposedUpdate;
    }
    protoOf(ChildCompletion).x1p = function(cause) {
        continueCompleting(this.l1v_1, this.m1v_1, this.n1v_1, this.o1v_1);
    };
    protoOf(ChildCompletion).invoke = function(cause) {
        return this.x1p(cause);
    };
    function AwaitContinuation(delegate, job) {
        CancellableContinuationImpl.call(this, delegate, 1);
        this.v1v_1 = job;
    }
    protoOf(AwaitContinuation).r1r = function(parent) {
        var state = this.v1v_1.p1n();
        if (state instanceof Finishing) {
            var tmp0_safe_receiver = state.z1u();
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            return tmp0_safe_receiver;
        }
        if (state instanceof CompletedExceptionally) return state.b1n_1;
        return parent.t1n();
    };
    protoOf(AwaitContinuation).z1r = function() {
        return "AwaitContinuation";
    };
    function awaitSuspend($this, $completion) {
        // Inline function 'kotlinx.coroutines.JobSupport.awaitSuspend.<anonymous>' call
        var cont = new AwaitContinuation(intercepted($completion), $this);
        cont.l1r();
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ResumeAwaitOnCompletion(cont);
        disposeOnCancellation(cont, $this.w1n(tmp$ret$1));
        return cont.s1r();
    }
    function JobSupport(active) {
        this.p1m_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
        this.q1m_1 = atomic$ref$1(null);
    }
    protoOf(JobSupport).a1 = function() {
        return Key_instance_3;
    };
    protoOf(JobSupport).n1n = function(value) {
        this.q1m_1.kotlinx$atomicfu$value = value;
    };
    protoOf(JobSupport).o1n = function() {
        return this.q1m_1.kotlinx$atomicfu$value;
    };
    protoOf(JobSupport).r1m = function(parent) {
        // Inline function 'kotlinx.coroutines.assert' call
        if (parent == null) {
            this.n1n(NonDisposableHandle_instance);
            return Unit_instance;
        }
        parent.r1n();
        var handle = parent.i1o(this);
        this.n1n(handle);
        if (this.q1n()) {
            handle.y1p();
            this.n1n(NonDisposableHandle_instance);
        }
    };
    protoOf(JobSupport).p1n = function() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.p1m_1;
        while(true){
            // Inline function 'kotlinx.coroutines.JobSupport.<get-state>.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (!(state instanceof OpDescriptor)) return state;
            state.w1v(this);
        }
    };
    protoOf(JobSupport).w1m = function() {
        var state = this.p1n();
        var tmp;
        if (!(state == null) ? isInterface(state, Incomplete) : false) tmp = state.w1m();
        else tmp = false;
        return tmp;
    };
    protoOf(JobSupport).q1n = function() {
        var tmp = this.p1n();
        return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
    };
    protoOf(JobSupport).r1n = function() {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true){
            // Inline function 'kotlinx.coroutines.JobSupport.start.<anonymous>' call
            var state = this.p1n();
            var tmp0_subject = startInternal(this, state);
            if (tmp0_subject === 0) return false;
            else if (tmp0_subject === 1) return true;
        }
    };
    protoOf(JobSupport).s1n = function() {};
    protoOf(JobSupport).t1n = function() {
        var state = this.p1n();
        var tmp;
        if (state instanceof Finishing) {
            var tmp0_safe_receiver = state.z1u();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.u1n(tmp0_safe_receiver, get_classSimpleName(this) + " is cancelling");
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
                var message = "Job is still new or active: " + this.toString();
                throw IllegalStateException_init_$Create$(toString(message));
            } else tmp_0 = tmp1_elvis_lhs;
            tmp = tmp_0;
        } else {
            if (!(state == null) ? isInterface(state, Incomplete) : false) {
                var message_0 = "Job is still new or active: " + this.toString();
                throw IllegalStateException_init_$Create$(toString(message_0));
            } else if (state instanceof CompletedExceptionally) tmp = this.v1n(state.b1n_1);
            else tmp = new JobCancellationException(get_classSimpleName(this) + " has completed normally", null, this);
        }
        return tmp;
    };
    protoOf(JobSupport).u1n = function(_this__u8e3s4, message) {
        var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
        var tmp;
        if (tmp0_elvis_lhs == null) // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        tmp = new JobCancellationException(message == null ? this.z1m() : message, _this__u8e3s4, this);
        else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    protoOf(JobSupport).v1n = function(_this__u8e3s4, message, $super) {
        message = message === VOID ? null : message;
        return $super === VOID ? this.u1n(_this__u8e3s4, message) : $super.u1n.call(this, _this__u8e3s4, message);
    };
    protoOf(JobSupport).w1n = function(handler) {
        return this.x1n(false, true, handler);
    };
    protoOf(JobSupport).x1n = function(onCancelling, invokeImmediately, handler) {
        var node = makeNode(this, handler, onCancelling);
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.JobSupport.invokeOnCompletion.<anonymous>' call
            var state = this.p1n();
            if (state instanceof Empty) {
                if (state.u1t_1) {
                    if (this.p1m_1.atomicfu$compareAndSet(state, node)) return node;
                } else promoteEmptyToNodeList(this, state);
            } else if (!(state == null) ? isInterface(state, Incomplete) : false) {
                var list = state.v1t();
                if (list == null) promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
                else {
                    var rootCause = null;
                    var handle = NonDisposableHandle_instance;
                    var tmp;
                    if (onCancelling) tmp = state instanceof Finishing;
                    else tmp = false;
                    if (tmp) {
                        // Inline function 'kotlinx.coroutines.internal.synchronized' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
                        rootCause = state.z1u();
                        var tmp_0;
                        if (rootCause == null) tmp_0 = true;
                        else {
                            var tmp_1;
                            // Inline function 'kotlinx.coroutines.isHandlerOf' call
                            if (handler instanceof ChildHandleNode) tmp_1 = !state.w1u();
                            else tmp_1 = false;
                            tmp_0 = tmp_1;
                        }
                        if (tmp_0) {
                            if (!addLastAtomic(this, state, list, node)) break $l$block;
                            if (rootCause == null) return node;
                            handle = node;
                        }
                    }
                    if (!(rootCause == null)) {
                        if (invokeImmediately) invokeIt(handler, rootCause);
                        return handle;
                    } else {
                        if (addLastAtomic(this, state, list, node)) return node;
                    }
                }
            } else {
                if (invokeImmediately) {
                    var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
                    invokeIt(handler, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b1n_1);
                }
                return NonDisposableHandle_instance;
            }
        }
    };
    protoOf(JobSupport).t1s = function($completion) {
        if (!joinInternal(this)) {
            // Inline function 'kotlin.js.getCoroutineContext' call
            var tmp$ret$0 = $completion.b9();
            ensureActive(tmp$ret$0);
            return Unit_instance;
        }
        return joinSuspend(this, $completion);
    };
    protoOf(JobSupport).z1n = function(node) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true){
            // Inline function 'kotlinx.coroutines.JobSupport.removeNode.<anonymous>' call
            var state = this.p1n();
            if (state instanceof JobNode) {
                if (!(state === node)) return Unit_instance;
                if (this.p1m_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE())) return Unit_instance;
            } else {
                if (!(state == null) ? isInterface(state, Incomplete) : false) {
                    if (!(state.v1t() == null)) node.g1u();
                    return Unit_instance;
                } else return Unit_instance;
            }
        }
    };
    protoOf(JobSupport).a1o = function() {
        return false;
    };
    protoOf(JobSupport).b1o = function(cause) {
        var tmp;
        if (cause == null) // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        tmp = new JobCancellationException(this.z1m(), null, this);
        else tmp = cause;
        this.d1o(tmp);
    };
    protoOf(JobSupport).z1m = function() {
        return "Job was cancelled";
    };
    protoOf(JobSupport).d1o = function(cause) {
        this.g1o(cause);
    };
    protoOf(JobSupport).e1o = function(parentJob) {
        this.g1o(parentJob);
    };
    protoOf(JobSupport).f1o = function(cause) {
        if (cause instanceof CancellationException) return true;
        return this.g1o(cause) && this.l1o();
    };
    protoOf(JobSupport).g1o = function(cause) {
        var finalState = get_COMPLETING_ALREADY();
        if (this.a1o()) {
            finalState = cancelMakeCompleting(this, cause);
            if (finalState === get_COMPLETING_WAITING_CHILDREN()) return true;
        }
        if (finalState === get_COMPLETING_ALREADY()) finalState = makeCancelling(this, cause);
        var tmp;
        if (finalState === get_COMPLETING_ALREADY()) tmp = true;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN()) tmp = true;
        else if (finalState === get_TOO_LATE_TO_CANCEL()) tmp = false;
        else {
            this.g1n(finalState);
            tmp = true;
        }
        return tmp;
    };
    protoOf(JobSupport).h1o = function() {
        var state = this.p1n();
        var tmp;
        if (state instanceof Finishing) tmp = state.z1u();
        else {
            if (state instanceof CompletedExceptionally) tmp = state.b1n_1;
            else if (!(state == null) ? isInterface(state, Incomplete) : false) {
                var message = "Cannot be cancelling child in this state: " + toString_0(state);
                throw IllegalStateException_init_$Create$(toString(message));
            } else tmp = null;
        }
        var rootCause = tmp;
        var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
        return tmp1_elvis_lhs == null ? new JobCancellationException("Parent job is " + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
    };
    protoOf(JobSupport).q1s = function(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.JobSupport.makeCompleting.<anonymous>' call
            var state = this.p1n();
            var finalState = tryMakeCompleting(this, state, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY()) return false;
            else if (finalState === get_COMPLETING_WAITING_CHILDREN()) return true;
            else if (finalState === get_COMPLETING_RETRY()) break $l$block;
            else {
                this.g1n(finalState);
                return true;
            }
        }
    };
    protoOf(JobSupport).e1n = function(proposedUpdate) {
        // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
        while(true)$l$block: {
            // Inline function 'kotlinx.coroutines.JobSupport.makeCompletingOnce.<anonymous>' call
            var state = this.p1n();
            var finalState = tryMakeCompleting(this, state, proposedUpdate);
            if (finalState === get_COMPLETING_ALREADY()) throw IllegalStateException_init_$Create$_0("Job " + this.toString() + " is already complete or completing, " + ("but is being completed with " + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(proposedUpdate, this));
            else if (finalState === get_COMPLETING_RETRY()) break $l$block;
            else return finalState;
        }
    };
    protoOf(JobSupport).i1o = function(child) {
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ChildHandleNode(child);
        var tmp = this.y1n(true, VOID, tmp$ret$1);
        return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
    };
    protoOf(JobSupport).h1n = function(exception) {
        throw exception;
    };
    protoOf(JobSupport).j1o = function(cause) {};
    protoOf(JobSupport).k1o = function() {
        return false;
    };
    protoOf(JobSupport).l1o = function() {
        return true;
    };
    protoOf(JobSupport).m1o = function(exception) {
        return false;
    };
    protoOf(JobSupport).a1n = function(state) {};
    protoOf(JobSupport).g1n = function(state) {};
    protoOf(JobSupport).toString = function() {
        return this.n1o() + "@" + get_hexAddress(this);
    };
    protoOf(JobSupport).n1o = function() {
        return this.i1n() + "{" + stateString(this, this.p1n()) + "}";
    };
    protoOf(JobSupport).i1n = function() {
        return get_classSimpleName(this);
    };
    protoOf(JobSupport).o1o = function() {
        var state = this.p1n();
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
            // Inline function 'kotlinx.coroutines.JobSupport.getCompletionExceptionOrNull.<anonymous>' call
            var message = "This job has not completed yet";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        return _get_exceptionOrNull__b3j7js(state, this);
    };
    protoOf(JobSupport).p1o = function() {
        var state = this.p1n();
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
            // Inline function 'kotlinx.coroutines.JobSupport.getCompletedInternal.<anonymous>' call
            var message = "This job has not completed yet";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        if (state instanceof CompletedExceptionally) throw state.b1n_1;
        return unboxState(state);
    };
    protoOf(JobSupport).q1o = function($completion) {
        $l$loop: while(true){
            var state = this.p1n();
            if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
                if (state instanceof CompletedExceptionally) // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
                throw state.b1n_1;
                return unboxState(state);
            }
            if (startInternal(this, state) >= 0) break $l$loop;
        }
        return awaitSuspend(this, $completion);
    };
    function boxIncomplete(_this__u8e3s4) {
        _init_properties_JobSupport_kt__68f172();
        var tmp;
        if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) tmp = new IncompleteStateBox(_this__u8e3s4);
        else tmp = _this__u8e3s4;
        return tmp;
    }
    function JobCancellingNode() {
        JobNode.call(this);
    }
    function InactiveNodeList(list) {
        this.v1u_1 = list;
    }
    protoOf(InactiveNodeList).v1t = function() {
        return this.v1u_1;
    };
    protoOf(InactiveNodeList).w1m = function() {
        return false;
    };
    protoOf(InactiveNodeList).toString = function() {
        return get_DEBUG() ? this.v1u_1.z1t("New") : anyToString(this);
    };
    function ChildHandleNode(childJob) {
        JobCancellingNode.call(this);
        this.f1v_1 = childJob;
    }
    protoOf(ChildHandleNode).x1p = function(cause) {
        return this.f1v_1.e1o(this.n1u());
    };
    protoOf(ChildHandleNode).invoke = function(cause) {
        return this.x1p(cause);
    };
    protoOf(ChildHandleNode).f1o = function(cause) {
        return this.n1u().f1o(cause);
    };
    function InvokeOnCancelling(handler) {
        JobCancellingNode.call(this);
        this.b1w_1 = handler;
        this.c1w_1 = atomic$int$1(0);
    }
    protoOf(InvokeOnCancelling).x1p = function(cause) {
        if (this.c1w_1.atomicfu$compareAndSet(0, 1)) this.b1w_1(cause);
    };
    protoOf(InvokeOnCancelling).invoke = function(cause) {
        return this.x1p(cause);
    };
    function InvokeOnCompletion(handler) {
        JobNode.call(this);
        this.h1w_1 = handler;
    }
    protoOf(InvokeOnCompletion).x1p = function(cause) {
        return this.h1w_1(cause);
    };
    protoOf(InvokeOnCompletion).invoke = function(cause) {
        return this.x1p(cause);
    };
    function ResumeOnCompletion(continuation) {
        JobNode.call(this);
        this.m1w_1 = continuation;
    }
    protoOf(ResumeOnCompletion).x1p = function(cause) {
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = this.m1w_1;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        this_0.g9(tmp$ret$0);
        return Unit_instance;
    };
    protoOf(ResumeOnCompletion).invoke = function(cause) {
        return this.x1p(cause);
    };
    function unboxState(_this__u8e3s4) {
        _init_properties_JobSupport_kt__68f172();
        var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1w_1;
        return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    }
    function ResumeAwaitOnCompletion(continuation) {
        JobNode.call(this);
        this.s1w_1 = continuation;
    }
    protoOf(ResumeAwaitOnCompletion).x1p = function(cause) {
        var state = this.n1u().p1n();
        // Inline function 'kotlinx.coroutines.assert' call
        if (state instanceof CompletedExceptionally) {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            var this_0 = this.s1w_1;
            // Inline function 'kotlin.Companion.failure' call
            var exception = state.b1n_1;
            var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
            this_0.g9(tmp$ret$0);
        } else {
            // Inline function 'kotlin.coroutines.resume' call
            var this_1 = this.s1w_1;
            var tmp = unboxState(state);
            // Inline function 'kotlin.Companion.success' call
            var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
            var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
            this_1.g9(tmp$ret$2);
        }
    };
    protoOf(ResumeAwaitOnCompletion).invoke = function(cause) {
        return this.x1p(cause);
    };
    function IncompleteStateBox(state) {
        this.n1w_1 = state;
    }
    function ChildContinuation(child) {
        JobCancellingNode.call(this);
        this.x1w_1 = child;
    }
    protoOf(ChildContinuation).x1p = function(cause) {
        this.x1w_1.q1r(this.x1w_1.r1r(this.n1u()));
    };
    protoOf(ChildContinuation).invoke = function(cause) {
        return this.x1p(cause);
    };
    function handlesExceptionF($this) {
        var tmp = $this.o1n();
        var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1u();
        var tmp_0;
        if (tmp1_elvis_lhs == null) return false;
        else tmp_0 = tmp1_elvis_lhs;
        var parentJob = tmp_0;
        while(true){
            if (parentJob.l1o()) return true;
            var tmp_1 = parentJob.o1n();
            var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.n1u();
            var tmp_2;
            if (tmp3_elvis_lhs == null) return false;
            else tmp_2 = tmp3_elvis_lhs;
            parentJob = tmp_2;
        }
    }
    function JobImpl(parent) {
        JobSupport.call(this, true);
        this.r1m(parent);
        this.a1x_1 = handlesExceptionF(this);
    }
    protoOf(JobImpl).a1o = function() {
        return true;
    };
    protoOf(JobImpl).l1o = function() {
        return this.a1x_1;
    };
    protoOf(JobImpl).s1s = function() {
        return this.q1s(Unit_instance);
    };
    protoOf(JobImpl).r1s = function(exception) {
        return this.q1s(new CompletedExceptionally(exception));
    };
    var properties_initialized_JobSupport_kt_5iq8a4;
    function _init_properties_JobSupport_kt__68f172() {
        if (!properties_initialized_JobSupport_kt_5iq8a4) {
            properties_initialized_JobSupport_kt_5iq8a4 = true;
            COMPLETING_ALREADY = new Symbol("COMPLETING_ALREADY");
            COMPLETING_WAITING_CHILDREN = new Symbol("COMPLETING_WAITING_CHILDREN");
            COMPLETING_RETRY = new Symbol("COMPLETING_RETRY");
            TOO_LATE_TO_CANCEL = new Symbol("TOO_LATE_TO_CANCEL");
            SEALED = new Symbol("SEALED");
            EMPTY_NEW = new Empty(false);
            EMPTY_ACTIVE = new Empty(true);
        }
    }
    function MainCoroutineDispatcher() {
        CoroutineDispatcher.call(this);
    }
    protoOf(MainCoroutineDispatcher).toString = function() {
        var tmp0_elvis_lhs = this.d1x();
        return tmp0_elvis_lhs == null ? get_classSimpleName(this) + "@" + get_hexAddress(this) : tmp0_elvis_lhs;
    };
    protoOf(MainCoroutineDispatcher).d1x = function() {
        var main = Dispatchers_getInstance().i1x();
        if (this === main) return "Dispatchers.Main";
        var tmp;
        try {
            tmp = main.c1x();
        } catch ($p) {
            var tmp_0;
            if ($p instanceof UnsupportedOperationException) {
                var e = $p;
                tmp_0 = null;
            } else throw $p;
            tmp = tmp_0;
        }
        var immediate = tmp;
        if (this === immediate) return "Dispatchers.Main.immediate";
        return null;
    };
    function SupervisorJob(parent) {
        parent = parent === VOID ? null : parent;
        return new SupervisorJobImpl(parent);
    }
    function SupervisorJobImpl(parent) {
        JobImpl.call(this, parent);
    }
    protoOf(SupervisorJobImpl).f1o = function(cause) {
        return false;
    };
    function TimeoutCancellationException() {}
    function Unconfined() {
        Unconfined_instance = this;
        CoroutineDispatcher.call(this);
    }
    protoOf(Unconfined).x1s = function(context) {
        return false;
    };
    protoOf(Unconfined).y1s = function(context, block) {
        var yieldContext = context.i9(Key_instance_4);
        if (!(yieldContext == null)) {
            yieldContext.o1x_1 = true;
            return Unit_instance;
        }
        throw UnsupportedOperationException_init_$Create$("Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.");
    };
    protoOf(Unconfined).toString = function() {
        return "Dispatchers.Unconfined";
    };
    var Unconfined_instance;
    function Unconfined_getInstance() {
        if (Unconfined_instance == null) new Unconfined();
        return Unconfined_instance;
    }
    function Key_3() {}
    var Key_instance_4;
    function Key_getInstance_3() {
        return Key_instance_4;
    }
    function Waiter() {}
    var BufferOverflow_SUSPEND_instance;
    var BufferOverflow_DROP_OLDEST_instance;
    var BufferOverflow_DROP_LATEST_instance;
    var BufferOverflow_entriesInitialized;
    function BufferOverflow_initEntries() {
        if (BufferOverflow_entriesInitialized) return Unit_instance;
        BufferOverflow_entriesInitialized = true;
        BufferOverflow_SUSPEND_instance = new BufferOverflow("SUSPEND", 0);
        BufferOverflow_DROP_OLDEST_instance = new BufferOverflow("DROP_OLDEST", 1);
        BufferOverflow_DROP_LATEST_instance = new BufferOverflow("DROP_LATEST", 2);
    }
    function BufferOverflow(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function BufferOverflow_SUSPEND_getInstance() {
        BufferOverflow_initEntries();
        return BufferOverflow_SUSPEND_instance;
    }
    function BufferOverflow_DROP_OLDEST_getInstance() {
        BufferOverflow_initEntries();
        return BufferOverflow_DROP_OLDEST_instance;
    }
    function BufferOverflow_DROP_LATEST_getInstance() {
        BufferOverflow_initEntries();
        return BufferOverflow_DROP_LATEST_instance;
    }
    function get_NULL_SEGMENT() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return NULL_SEGMENT;
    }
    var NULL_SEGMENT;
    function get_SEGMENT_SIZE() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return SEGMENT_SIZE;
    }
    var SEGMENT_SIZE;
    function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
    }
    var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
    function get_BUFFERED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return BUFFERED;
    }
    var BUFFERED;
    function get_IN_BUFFER() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return IN_BUFFER;
    }
    var IN_BUFFER;
    function get_RESUMING_BY_RCV() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return RESUMING_BY_RCV;
    }
    var RESUMING_BY_RCV;
    function get_RESUMING_BY_EB() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return RESUMING_BY_EB;
    }
    var RESUMING_BY_EB;
    function get_POISONED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return POISONED;
    }
    var POISONED;
    function get_DONE_RCV() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return DONE_RCV;
    }
    var DONE_RCV;
    function get_INTERRUPTED_SEND() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return INTERRUPTED_SEND;
    }
    var INTERRUPTED_SEND;
    function get_INTERRUPTED_RCV() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return INTERRUPTED_RCV;
    }
    var INTERRUPTED_RCV;
    function get_CHANNEL_CLOSED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return CHANNEL_CLOSED;
    }
    var CHANNEL_CLOSED;
    function get_SUSPEND() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return SUSPEND;
    }
    var SUSPEND;
    function get_SUSPEND_NO_WAITER() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return SUSPEND_NO_WAITER;
    }
    var SUSPEND_NO_WAITER;
    function get_FAILED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return FAILED;
    }
    var FAILED;
    function get_NO_RECEIVE_RESULT() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return NO_RECEIVE_RESULT;
    }
    var NO_RECEIVE_RESULT;
    function get_CLOSE_HANDLER_CLOSED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return CLOSE_HANDLER_CLOSED;
    }
    var CLOSE_HANDLER_CLOSED;
    function get_CLOSE_HANDLER_INVOKED() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return CLOSE_HANDLER_INVOKED;
    }
    var CLOSE_HANDLER_INVOKED;
    function get_NO_CLOSE_CAUSE() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return NO_CLOSE_CAUSE;
    }
    var NO_CLOSE_CAUSE;
    function setElementLazy($this, index, value) {
        // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
        $this.u1x_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
    }
    function ChannelSegment(id, prev, channel, pointers) {
        Segment.call(this, id, prev, pointers);
        this.t1x_1 = channel;
        this.u1x_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
    }
    protoOf(ChannelSegment).v1x = function() {
        return ensureNotNull(this.t1x_1);
    };
    protoOf(ChannelSegment).w1x = function() {
        return get_SEGMENT_SIZE();
    };
    protoOf(ChannelSegment).x1x = function(index, element) {
        setElementLazy(this, index, element);
    };
    protoOf(ChannelSegment).y1x = function(index) {
        var tmp = this.u1x_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(ChannelSegment).z1x = function(index) {
        // Inline function 'kotlin.also' call
        var this_0 = this.y1x(index);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.ChannelSegment.retrieveElement.<anonymous>' call
        this.a1y(index);
        return this_0;
    };
    protoOf(ChannelSegment).a1y = function(index) {
        setElementLazy(this, index, null);
    };
    protoOf(ChannelSegment).b1y = function(index) {
        return this.u1x_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
    };
    protoOf(ChannelSegment).c1y = function(index, value) {
        this.u1x_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
    };
    protoOf(ChannelSegment).d1y = function(index, from, to) {
        return this.u1x_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
    };
    protoOf(ChannelSegment).e1y = function(index, update) {
        return this.u1x_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
    };
    protoOf(ChannelSegment).u1q = function(index, cause, context) {
        var isSender = index >= get_SEGMENT_SIZE();
        var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
        var element = this.y1x(index_0);
        $l$loop: while(true){
            var cur = this.b1y(index_0);
            var tmp;
            if (!(cur == null) ? isInterface(cur, Waiter) : false) tmp = true;
            else tmp = cur instanceof WaiterEB;
            if (tmp) {
                var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
                if (this.d1y(index_0, cur, update)) {
                    this.a1y(index_0);
                    this.r1y(index_0, !isSender);
                    if (isSender) {
                        var tmp0_safe_receiver = this.v1x().g1y_1;
                        if (tmp0_safe_receiver == null) ;
                        else callUndeliveredElement(tmp0_safe_receiver, element, context);
                    }
                    return Unit_instance;
                }
            } else if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
                this.a1y(index_0);
                if (isSender) {
                    var tmp1_safe_receiver = this.v1x().g1y_1;
                    if (tmp1_safe_receiver == null) ;
                    else callUndeliveredElement(tmp1_safe_receiver, element, context);
                }
                return Unit_instance;
            } else {
                if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV()) continue $l$loop;
                else {
                    if (cur === get_DONE_RCV() || cur === get_BUFFERED()) return Unit_instance;
                    else {
                        if (cur === get_CHANNEL_CLOSED()) return Unit_instance;
                        else {
                            var message = "unexpected state: " + toString_0(cur);
                            throw IllegalStateException_init_$Create$(toString(message));
                        }
                    }
                }
            }
        }
    };
    protoOf(ChannelSegment).r1y = function(index, receiver) {
        if (receiver) {
            var tmp = this.v1x();
            // Inline function 'kotlin.Long.plus' call
            // Inline function 'kotlin.Long.times' call
            var this_0 = this.s1q_1;
            var other = get_SEGMENT_SIZE();
            var tmp$ret$1 = this_0.a3(toLong(other)).y2(toLong(index));
            tmp.s1y(tmp$ret$1);
        }
        this.t1y();
    };
    function onClosedHasNext($this) {
        $this.f1z_1 = get_CHANNEL_CLOSED();
        var tmp0_elvis_lhs = $this.h1z_1.i1z();
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var cause = tmp;
        throw recoverStackTrace_0(cause);
    }
    function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
        var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
        try {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>' call
            $this.g1z_1 = cancellable;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
            var this_0 = $this.h1z_1;
            var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
            if (updCellResult === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) prepareReceiverForSuspension($this, this_0, segment, index);
            else if (updCellResult === _get_FAILED_$accessor$yt74tm_h47uk8()) {
                if (r.j1(this_0.j1z()) < 0) segment.d1z();
                $l$block_0: {
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
                    var segment_0 = this_0.m1y_1.kotlinx$atomicfu$value;
                    $l$loop_0: while(true){
                        if (this_0.k1z()) {
                            onClosedHasNextNoWaiterSuspend($this);
                            break $l$block_0;
                        }
                        var r_0 = this_0.i1y_1.atomicfu$getAndIncrement$long();
                        // Inline function 'kotlin.Long.div' call
                        var other = get_SEGMENT_SIZE();
                        var id = r_0.b3(toLong(other));
                        // Inline function 'kotlin.Long.rem' call
                        var other_0 = get_SEGMENT_SIZE();
                        var i = r_0.c3(toLong(other_0)).l1();
                        if (!segment_0.s1q_1.equals(id)) {
                            var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
                            var tmp;
                            if (tmp0_elvis_lhs == null) continue $l$loop_0;
                            else tmp = tmp0_elvis_lhs;
                            segment_0 = tmp;
                        }
                        var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
                        var tmp_0;
                        if (updCellResult_0 === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) {
                            var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
                            if (tmp1_safe_receiver == null) ;
                            else prepareReceiverForSuspension(tmp1_safe_receiver, this_0, segment_0, i);
                            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter.<anonymous>' call
                            tmp_0 = Unit_instance;
                        } else if (updCellResult_0 === _get_FAILED_$accessor$yt74tm_h47uk8()) {
                            if (r_0.j1(this_0.j1z()) < 0) segment_0.d1z();
                            continue $l$loop_0;
                        } else if (updCellResult_0 === _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky()) {
                            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl.<anonymous>' call
                            var message = "unexpected";
                            throw IllegalStateException_init_$Create$(toString(message));
                        } else {
                            segment_0.d1z();
                            var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
                            $this.f1z_1 = element;
                            $this.g1z_1 = null;
                            var tmp0_safe_receiver = $this.h1z_1.g1y_1;
                            cancellable.w1r(true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cancellable.b9()));
                            tmp_0 = Unit_instance;
                        }
                        break $l$block_0;
                    }
                }
            } else {
                segment.d1z();
                // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
                $this.f1z_1 = element_0;
                $this.g1z_1 = null;
                var tmp0_safe_receiver_0 = $this.h1z_1.g1y_1;
                cancellable.w1r(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun(tmp0_safe_receiver_0, element_0, cancellable.b9()));
            }
        } catch ($p) {
            if ($p instanceof Error) {
                var e = $p;
                cancellable.t1r();
                throw e;
            } else throw $p;
        }
        return cancellable.s1r();
    }
    function onClosedHasNextNoWaiterSuspend($this) {
        var cont = ensureNotNull($this.g1z_1);
        $this.g1z_1 = null;
        $this.f1z_1 = get_CHANNEL_CLOSED();
        var cause = $this.h1z_1.i1z();
        if (cause == null) {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
            cont.g9(tmp$ret$0);
        } else {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var exception = recoverStackTrace(cause, cont);
            var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
            cont.g9(tmp$ret$2);
        }
    }
    function $hasNextCOROUTINE$5(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.t1z_1 = _this__u8e3s4;
    }
    protoOf($hasNextCOROUTINE$5).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 8;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    var tmp_0 = this;
                    tmp_0.v1z_1 = this.t1z_1.h1z_1;
                    var tmp_1 = this;
                    tmp_1.w1z_1 = null;
                    this.x1z_1 = this.v1z_1.m1y_1.kotlinx$atomicfu$value;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    if (this.v1z_1.k1z()) {
                        var tmp_2 = this;
                        tmp_2.u1z_1 = onClosedHasNext(this.t1z_1);
                        this.v8_1 = 10;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    this.y1z_1 = this.v1z_1.i1y_1.atomicfu$getAndIncrement$long();
                    var tmp_3 = this;
                    var this_0 = this.y1z_1;
                    var other = get_SEGMENT_SIZE();
                    tmp_3.z1z_1 = this_0.b3(toLong(other));
                    var tmp_4 = this;
                    var this_1 = this.y1z_1;
                    var other_0 = get_SEGMENT_SIZE();
                    tmp_4.a20_1 = this_1.c3(toLong(other_0)).l1();
                    if (!this.x1z_1.s1q_1.equals(this.z1z_1)) {
                        this.b20_1 = findSegmentReceive(this.v1z_1, this.z1z_1, this.x1z_1);
                        if (this.b20_1 == null) {
                            this.v8_1 = 2;
                            var tmp_5 = this;
                            continue $sm;
                        } else {
                            this.c20_1 = this.b20_1;
                            this.v8_1 = 4;
                            continue $sm;
                        }
                    } else {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 4:
                    this.x1z_1 = this.c20_1;
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    this.d20_1 = updateCellReceive(this.v1z_1, this.x1z_1, this.a20_1, this.y1z_1, this.w1z_1);
                    if (this.d20_1 === _get_SUSPEND_$accessor$yt74tm_ccb8g1()) {
                        var tmp_6 = this;
                        var tmp_7 = this.w1z_1;
                        var tmp1_safe_receiver = (!(tmp_7 == null) ? isInterface(tmp_7, Waiter) : false) ? tmp_7 : null;
                        if (tmp1_safe_receiver == null) ;
                        else prepareReceiverForSuspension(tmp1_safe_receiver, this.v1z_1, this.x1z_1, this.a20_1);
                        this.x1z_1;
                        this.a20_1;
                        this.y1z_1;
                        var message = "unreachable";
                        throw IllegalStateException_init_$Create$(toString(message));
                    } else {
                        if (this.d20_1 === _get_FAILED_$accessor$yt74tm_h47uk8()) {
                            if (this.y1z_1.j1(this.v1z_1.j1z()) < 0) this.x1z_1.d1z();
                            this.v8_1 = 2;
                            var tmp_8 = this;
                            continue $sm;
                        } else if (this.d20_1 === _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky()) {
                            var tmp_9 = this;
                            tmp_9.f20_1 = this.x1z_1;
                            var tmp_10 = this;
                            tmp_10.g20_1 = this.a20_1;
                            var tmp_11 = this;
                            tmp_11.h20_1 = this.y1z_1;
                            this.v8_1 = 6;
                            suspendResult = hasNextOnNoWaiterSuspend(this.t1z_1, this.f20_1, this.g20_1, this.h20_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_12 = this;
                            this.x1z_1.d1z();
                            var tmp_13 = this.d20_1;
                            var element = (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
                            this.t1z_1.f1z_1 = element;
                            tmp_12.e20_1 = true;
                            this.v8_1 = 7;
                            continue $sm;
                        }
                    }
                case 6:
                    var tmp_14 = this;
                    return suspendResult;
                case 7:
                    this.u1z_1 = this.e20_1;
                    this.v8_1 = 10;
                    continue $sm;
                case 8:
                    throw this.y8_1;
                case 9:
                    this.v8_1 = 10;
                    continue $sm;
                case 10:
                    return this.u1z_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 8) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function _get_bufferEndCounter__2d4hee($this) {
        return $this.j1y_1.kotlinx$atomicfu$value;
    }
    function _get_isRendezvousOrUnlimited__3mdufi($this) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<get-isRendezvousOrUnlimited>.<anonymous>' call
        var it = _get_bufferEndCounter__2d4hee($this);
        return it.equals(new Long(0, 0)) || it.equals(new Long(-1, 2147483647));
    }
    function prepareSenderForSuspension(_this__u8e3s4, $this, segment, index) {
        _this__u8e3s4.x1r(segment, index + get_SEGMENT_SIZE() | 0);
    }
    function SendBroadcast() {}
    function updateCellSend($this, segment, index, element, s, waiter, closed) {
        segment.x1x(index, element);
        if (closed) return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
        var state = segment.b1y(index);
        if (state === null) {
            if (bufferOrRendezvousSend($this, s)) {
                if (segment.d1y(index, null, get_BUFFERED())) return _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m();
            } else {
                if (waiter == null) return _get_RESULT_SUSPEND_NO_WAITER_$accessor$yt74tm_cvzv8m();
                else {
                    if (segment.d1y(index, null, waiter)) return _get_RESULT_SUSPEND_$accessor$yt74tm_cjypnf();
                }
            }
        } else if (!(state == null) ? isInterface(state, Waiter) : false) {
            segment.a1y(index);
            var tmp;
            if (tryResumeReceiver(state, $this, element)) {
                segment.c1y(index, get_DONE_RCV());
                $this.i20();
                tmp = _get_RESULT_RENDEZVOUS_$accessor$yt74tm_3irwt8();
            } else {
                if (!(segment.e1y(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) segment.r1y(index, true);
                tmp = _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0();
            }
            return tmp;
        }
        return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
    }
    function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
        while(true){
            var state = segment.b1y(index);
            if (state === null) {
                if (bufferOrRendezvousSend($this, s) && !closed) {
                    if (segment.d1y(index, null, get_BUFFERED())) return _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m();
                } else {
                    if (closed) {
                        if (segment.d1y(index, null, get_INTERRUPTED_SEND())) {
                            segment.r1y(index, false);
                            return _get_RESULT_CLOSED_$accessor$yt74tm_10v48j();
                        }
                    } else if (waiter == null) return _get_RESULT_SUSPEND_NO_WAITER_$accessor$yt74tm_cvzv8m();
                    else if (segment.d1y(index, null, waiter)) return _get_RESULT_SUSPEND_$accessor$yt74tm_cjypnf();
                }
            } else if (state === get_IN_BUFFER()) {
                if (segment.d1y(index, state, get_BUFFERED())) return _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m();
            } else if (state === get_INTERRUPTED_RCV()) {
                segment.a1y(index);
                return _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0();
            } else if (state === get_POISONED()) {
                segment.a1y(index);
                return _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0();
            } else if (state === get_CHANNEL_CLOSED()) {
                segment.a1y(index);
                completeCloseOrCancel($this);
                return _get_RESULT_CLOSED_$accessor$yt74tm_10v48j();
            } else {
                // Inline function 'kotlinx.coroutines.assert' call
                segment.a1y(index);
                var tmp;
                if (state instanceof WaiterEB) tmp = state.j20_1;
                else tmp = state;
                var receiver = tmp;
                var tmp_0;
                if (tryResumeReceiver(receiver, $this, element)) {
                    segment.c1y(index, get_DONE_RCV());
                    $this.i20();
                    tmp_0 = _get_RESULT_RENDEZVOUS_$accessor$yt74tm_3irwt8();
                } else {
                    if (!(segment.e1y(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) segment.r1y(index, true);
                    tmp_0 = _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0();
                }
                return tmp_0;
            }
        }
    }
    function shouldSendSuspend0($this, curSendersAndCloseStatus) {
        if (_get_isClosedForSend0__kxgf9m(curSendersAndCloseStatus, $this)) return false;
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$0 = curSendersAndCloseStatus.k3(new Long(-1, 268435455));
        return !bufferOrRendezvousSend($this, tmp$ret$0);
    }
    function bufferOrRendezvousSend($this, curSenders) {
        var tmp;
        if (curSenders.j1(_get_bufferEndCounter__2d4hee($this)) < 0) tmp = true;
        else {
            // Inline function 'kotlin.Long.plus' call
            var this_0 = $this.k20();
            var other = $this.f1y_1;
            var tmp$ret$0 = this_0.y2(toLong(other));
            tmp = curSenders.j1(tmp$ret$0) < 0;
        }
        return tmp;
    }
    function tryResumeReceiver(_this__u8e3s4, $this, element) {
        var tmp;
        if (isInterface(_this__u8e3s4, SelectInstance)) tmp = _this__u8e3s4.p20($this, element);
        else if (_this__u8e3s4 instanceof ReceiveCatching) {
            if (!(_this__u8e3s4 instanceof ReceiveCatching)) THROW_CCE();
            var tmp_0 = Companion_getInstance().n20(element);
            var tmp1_safe_receiver = $this.g1y_1;
            tmp = tryResume0(_this__u8e3s4.o20_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFun(tmp1_safe_receiver, element, _this__u8e3s4.o20_1.b9()));
        } else {
            if (_this__u8e3s4 instanceof BufferedChannelIterator) {
                if (!(_this__u8e3s4 instanceof BufferedChannelIterator)) THROW_CCE();
                tmp = _this__u8e3s4.l20(element);
            } else if (isInterface(_this__u8e3s4, CancellableContinuation)) {
                if (!isInterface(_this__u8e3s4, CancellableContinuation)) THROW_CCE();
                var tmp2_safe_receiver = $this.g1y_1;
                tmp = tryResume0(_this__u8e3s4, element, tmp2_safe_receiver == null ? null : bindCancellationFun(tmp2_safe_receiver, element, _this__u8e3s4.b9()));
            } else {
                var message = "Unexpected receiver type: " + toString(_this__u8e3s4);
                throw IllegalStateException_init_$Create$(toString(message));
            }
        }
        return tmp;
    }
    function prepareReceiverForSuspension(_this__u8e3s4, $this, segment, index) {
        $this.q20();
        _this__u8e3s4.x1r(segment, index);
    }
    function updateCellReceive($this, segment, index, r, waiter) {
        var state = segment.b1y(index);
        if (state === null) {
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var senders = $this.h1y_1.kotlinx$atomicfu$value.k3(new Long(-1, 268435455));
            if (r.j1(senders) >= 0) {
                if (waiter === null) return _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky();
                if (segment.d1y(index, state, waiter)) {
                    expandBuffer($this);
                    return _get_SUSPEND_$accessor$yt74tm_ccb8g1();
                }
            }
        } else if (state === get_BUFFERED()) {
            if (segment.d1y(index, state, get_DONE_RCV())) {
                expandBuffer($this);
                return segment.z1x(index);
            }
        }
        return updateCellReceiveSlow($this, segment, index, r, waiter);
    }
    function updateCellReceiveSlow($this, segment, index, r, waiter) {
        $l$loop: while(true){
            var state = segment.b1y(index);
            if (state === null || state === get_IN_BUFFER()) {
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var senders = $this.h1y_1.kotlinx$atomicfu$value.k3(new Long(-1, 268435455));
                if (r.j1(senders) < 0) {
                    if (segment.d1y(index, state, get_POISONED())) {
                        expandBuffer($this);
                        return _get_FAILED_$accessor$yt74tm_h47uk8();
                    }
                } else {
                    if (waiter === null) return _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky();
                    if (segment.d1y(index, state, waiter)) {
                        expandBuffer($this);
                        return _get_SUSPEND_$accessor$yt74tm_ccb8g1();
                    }
                }
            } else if (state === get_BUFFERED()) {
                if (segment.d1y(index, state, get_DONE_RCV())) {
                    expandBuffer($this);
                    return segment.z1x(index);
                }
            } else if (state === get_INTERRUPTED_SEND()) return _get_FAILED_$accessor$yt74tm_h47uk8();
            else if (state === get_POISONED()) return _get_FAILED_$accessor$yt74tm_h47uk8();
            else if (state === get_CHANNEL_CLOSED()) {
                expandBuffer($this);
                return _get_FAILED_$accessor$yt74tm_h47uk8();
            } else if (state === get_RESUMING_BY_EB()) continue $l$loop;
            else if (segment.d1y(index, state, get_RESUMING_BY_RCV())) {
                var helpExpandBuffer = state instanceof WaiterEB;
                var tmp;
                if (state instanceof WaiterEB) tmp = state.j20_1;
                else tmp = state;
                var sender = tmp;
                var tmp_0;
                if (tryResumeSender(sender, $this, segment, index)) {
                    segment.c1y(index, get_DONE_RCV());
                    expandBuffer($this);
                    tmp_0 = segment.z1x(index);
                } else {
                    segment.c1y(index, get_INTERRUPTED_SEND());
                    segment.r1y(index, false);
                    if (helpExpandBuffer) expandBuffer($this);
                    tmp_0 = _get_FAILED_$accessor$yt74tm_h47uk8();
                }
                return tmp_0;
            }
        }
    }
    function tryResumeSender(_this__u8e3s4, $this, segment, index) {
        var tmp;
        if (isInterface(_this__u8e3s4, CancellableContinuation)) {
            if (!isInterface(_this__u8e3s4, CancellableContinuation)) THROW_CCE();
            tmp = tryResume0(_this__u8e3s4, Unit_instance);
        } else {
            if (isInterface(_this__u8e3s4, SelectInstance)) {
                if (!(_this__u8e3s4 instanceof SelectImplementation)) THROW_CCE();
                var trySelectResult = _this__u8e3s4.v20($this, Unit_instance);
                if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) segment.a1y(index);
                tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
            } else if (_this__u8e3s4 instanceof SendBroadcast) tmp = tryResume0(_this__u8e3s4.r20_1, true);
            else {
                var message = "Unexpected waiter: " + toString(_this__u8e3s4);
                throw IllegalStateException_init_$Create$(toString(message));
            }
        }
        return tmp;
    }
    function expandBuffer($this) {
        if (_get_isRendezvousOrUnlimited__3mdufi($this)) return Unit_instance;
        var segment = $this.n1y_1.kotlinx$atomicfu$value;
        try_again: while(true){
            var b = $this.j1y_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = b.b3(toLong(other));
            var s = $this.j1z();
            if (s.j1(b) <= 0) {
                if (segment.s1q_1.j1(id) < 0 && !(segment.z1y() == null)) moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
                incCompletedExpandBufferAttempts$default($this);
                return Unit_instance;
            }
            if (!segment.s1q_1.equals(id)) {
                var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
                var tmp;
                if (tmp0_elvis_lhs == null) continue try_again;
                else tmp = tmp0_elvis_lhs;
                segment = tmp;
            }
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = b.c3(toLong(other_0)).l1();
            if (updateCellExpandBuffer($this, segment, i, b)) {
                incCompletedExpandBufferAttempts$default($this);
                return Unit_instance;
            } else {
                incCompletedExpandBufferAttempts$default($this);
                continue try_again;
            }
        }
    }
    function updateCellExpandBuffer($this, segment, index, b) {
        var state = segment.b1y(index);
        if (!(state == null) ? isInterface(state, Waiter) : false) {
            if (b.j1($this.i1y_1.kotlinx$atomicfu$value) >= 0) {
                if (segment.d1y(index, state, get_RESUMING_BY_EB())) {
                    var tmp;
                    if (tryResumeSender(state, $this, segment, index)) {
                        segment.c1y(index, get_BUFFERED());
                        tmp = true;
                    } else {
                        segment.c1y(index, get_INTERRUPTED_SEND());
                        segment.r1y(index, false);
                        tmp = false;
                    }
                    return tmp;
                }
            }
        }
        return updateCellExpandBufferSlow($this, segment, index, b);
    }
    function updateCellExpandBufferSlow($this, segment, index, b) {
        $l$loop: while(true){
            var state = segment.b1y(index);
            if (!(state == null) ? isInterface(state, Waiter) : false) {
                if (b.j1($this.i1y_1.kotlinx$atomicfu$value) < 0) {
                    if (segment.d1y(index, state, new WaiterEB(state))) return true;
                } else if (segment.d1y(index, state, get_RESUMING_BY_EB())) {
                    var tmp;
                    if (tryResumeSender(state, $this, segment, index)) {
                        segment.c1y(index, get_BUFFERED());
                        tmp = true;
                    } else {
                        segment.c1y(index, get_INTERRUPTED_SEND());
                        segment.r1y(index, false);
                        tmp = false;
                    }
                    return tmp;
                }
            } else {
                if (state === get_INTERRUPTED_SEND()) return false;
                else if (state === null) {
                    if (segment.d1y(index, state, get_IN_BUFFER())) return true;
                } else {
                    if (state === get_BUFFERED()) return true;
                    else {
                        if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV()) return true;
                        else {
                            if (state === get_CHANNEL_CLOSED()) return true;
                            else {
                                if (state === get_RESUMING_BY_RCV()) continue $l$loop;
                                else {
                                    var message = "Unexpected cell state: " + toString_0(state);
                                    throw IllegalStateException_init_$Create$(toString(message));
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    function incCompletedExpandBufferAttempts($this, nAttempts) {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.incCompletedExpandBufferAttempts.<anonymous>' call
        // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
        if (!$this.k1y_1.atomicfu$addAndGet$long(nAttempts).k3(new Long(0, 1073741824)).equals(new Long(0, 0))) $l$loop: while(true){
            // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
            if (!!$this.k1y_1.kotlinx$atomicfu$value.k3(new Long(0, 1073741824)).equals(new Long(0, 0))) break $l$loop;
        }
    }
    function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
        nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
        return incCompletedExpandBufferAttempts($this, nAttempts);
    }
    function BufferedChannelIterator($outer) {
        this.h1z_1 = $outer;
        this.f1z_1 = get_NO_RECEIVE_RESULT();
        this.g1z_1 = null;
    }
    protoOf(BufferedChannelIterator).w20 = function($completion) {
        var tmp = new $hasNextCOROUTINE$5(this, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(BufferedChannelIterator).x1r = function(segment, index) {
        var tmp0_safe_receiver = this.g1z_1;
        if (tmp0_safe_receiver == null) ;
        else tmp0_safe_receiver.x1r(segment, index);
    };
    protoOf(BufferedChannelIterator).l = function() {
        var result = this.f1z_1;
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(result === get_NO_RECEIVE_RESULT())) {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.next.<anonymous>' call
            var message = "`hasNext()` has not been invoked";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        this.f1z_1 = get_NO_RECEIVE_RESULT();
        if (result === get_CHANNEL_CLOSED()) throw recoverStackTrace_0(_get_receiveException__foorc1(this.h1z_1));
        return (result == null ? true : !(result == null)) ? result : THROW_CCE();
    };
    protoOf(BufferedChannelIterator).l20 = function(element) {
        var cont = ensureNotNull(this.g1z_1);
        this.g1z_1 = null;
        this.f1z_1 = element;
        var tmp0_safe_receiver = this.h1z_1.g1y_1;
        return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cont.b9()));
    };
    protoOf(BufferedChannelIterator).x20 = function() {
        var cont = ensureNotNull(this.g1z_1);
        this.g1z_1 = null;
        this.f1z_1 = get_CHANNEL_CLOSED();
        var cause = this.h1z_1.i1z();
        if (cause == null) {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
            cont.g9(tmp$ret$0);
        } else {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var exception = recoverStackTrace(cause, cont);
            var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
            cont.g9(tmp$ret$2);
        }
    };
    function _get_receiveException__foorc1($this) {
        var tmp0_elvis_lhs = $this.i1z();
        return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException("Channel was closed") : tmp0_elvis_lhs;
    }
    function invokeCloseHandler($this) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.atomicfu.getAndUpdate' call
            var this_0 = $this.q1y_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.invokeCloseHandler.<anonymous>' call
                var tmp;
                if (cur === null) tmp = get_CLOSE_HANDLER_CLOSED();
                else tmp = get_CLOSE_HANDLER_INVOKED();
                var upd = tmp;
                if (this_0.atomicfu$compareAndSet(cur, upd)) {
                    tmp$ret$1 = cur;
                    break $l$block;
                }
            }
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) return Unit_instance;
        else tmp_0 = tmp0_elvis_lhs;
        var closeHandler = tmp_0;
        if (typeof closeHandler !== "function") THROW_CCE();
        closeHandler($this.i1z());
    }
    function markClosed($this) {
        var tmp$ret$4;
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = $this.h1y_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markClosed.<anonymous>' call
                // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
                var tmp;
                switch(cur.i3(60).l1()){
                    case 0:
                        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                        var tmp$ret$1 = cur.k3(new Long(-1, 268435455));
                        tmp = constructSendersAndCloseStatus(tmp$ret$1, 2);
                        break;
                    case 1:
                        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                        var tmp$ret$2 = cur.k3(new Long(-1, 268435455));
                        tmp = constructSendersAndCloseStatus(tmp$ret$2, 3);
                        break;
                    default:
                        return Unit_instance;
                }
                var upd = tmp;
                if (this_0.atomicfu$compareAndSet(cur, upd)) {
                    tmp$ret$4 = Unit_instance;
                    break $l$block;
                }
            }
        }
        return tmp$ret$4;
    }
    function markCancelled($this) {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = $this.h1y_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markCancelled.<anonymous>' call
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var tmp$ret$0 = cur.k3(new Long(-1, 268435455));
                var upd = constructSendersAndCloseStatus(tmp$ret$0, 3);
                if (this_0.atomicfu$compareAndSet(cur, upd)) {
                    tmp$ret$2 = Unit_instance;
                    break $l$block;
                }
            }
        }
        return tmp$ret$2;
    }
    function markCancellationStarted($this) {
        var tmp$ret$3;
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = $this.h1y_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markCancellationStarted.<anonymous>' call
                var tmp;
                // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
                if (cur.i3(60).l1() === 0) {
                    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                    var tmp$ret$1 = cur.k3(new Long(-1, 268435455));
                    tmp = constructSendersAndCloseStatus(tmp$ret$1, 1);
                } else return Unit_instance;
                var upd = tmp;
                if (this_0.atomicfu$compareAndSet(cur, upd)) {
                    tmp$ret$3 = Unit_instance;
                    break $l$block;
                }
            }
        }
        return tmp$ret$3;
    }
    function completeCloseOrCancel($this) {
        $this.y20();
    }
    function completeClose($this, sendersCur) {
        var lastSegment = closeLinkedList($this);
        if ($this.a21()) {
            var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
            if (!lastBufferedCellGlobalIndex.equals(new Long(-1, -1))) $this.z20(lastBufferedCellGlobalIndex);
        }
        cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
        return lastSegment;
    }
    function completeCancel($this, sendersCur) {
        var lastSegment = completeClose($this, sendersCur);
        removeUnprocessedElements($this, lastSegment);
    }
    function closeLinkedList($this) {
        var lastSegment = $this.n1y_1.kotlinx$atomicfu$value;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var it = $this.l1y_1.kotlinx$atomicfu$value;
        if (it.s1q_1.j1(lastSegment.s1q_1) > 0) lastSegment = it;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var it_0 = $this.m1y_1.kotlinx$atomicfu$value;
        if (it_0.s1q_1.j1(lastSegment.s1q_1) > 0) lastSegment = it_0;
        return close(lastSegment);
    }
    function markAllEmptyCellsAsClosed($this, lastSegment) {
        var segment = lastSegment;
        while(true){
            var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
            if (0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                // Inline function 'kotlin.Long.plus' call
                // Inline function 'kotlin.Long.times' call
                var this_0 = segment.s1q_1;
                var other = get_SEGMENT_SIZE();
                var globalIndex = this_0.a3(toLong(other)).y2(toLong(index));
                if (globalIndex.j1($this.k20()) < 0) return new Long(-1, -1);
                cell_update: while(true){
                    var state = segment.b1y(index);
                    if (state === null || state === get_IN_BUFFER()) {
                        if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                            segment.t1y();
                            break cell_update;
                        }
                    } else if (state === get_BUFFERED()) return globalIndex;
                    else break cell_update;
                }
            }while (0 <= inductionVariable);
            var tmp1_elvis_lhs = segment.c1z();
            var tmp;
            if (tmp1_elvis_lhs == null) return new Long(-1, -1);
            else tmp = tmp1_elvis_lhs;
            segment = tmp;
        }
    }
    function removeUnprocessedElements($this, lastSegment) {
        var onUndeliveredElement = $this.g1y_1;
        var undeliveredElementException = null;
        var suspendedSenders = _InlineList___init__impl__z8n56();
        var segment = lastSegment;
        process_segments: while(true){
            var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
            if (0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                // Inline function 'kotlin.Long.plus' call
                // Inline function 'kotlin.Long.times' call
                var this_0 = segment.s1q_1;
                var other = get_SEGMENT_SIZE();
                var globalIndex = this_0.a3(toLong(other)).y2(toLong(index));
                update_cell: while(true){
                    var state = segment.b1y(index);
                    if (state === get_DONE_RCV()) break process_segments;
                    else if (state === get_BUFFERED()) {
                        if (globalIndex.j1($this.k20()) < 0) break process_segments;
                        if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                            if (!(onUndeliveredElement == null)) {
                                var element = segment.y1x(index);
                                undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                            }
                            segment.a1y(index);
                            segment.t1y();
                            break update_cell;
                        }
                    } else {
                        if (state === get_IN_BUFFER() || state === null) {
                            if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                                segment.t1y();
                                break update_cell;
                            }
                        } else {
                            var tmp;
                            if (!(state == null) ? isInterface(state, Waiter) : false) tmp = true;
                            else tmp = state instanceof WaiterEB;
                            if (tmp) {
                                if (globalIndex.j1($this.k20()) < 0) break process_segments;
                                var tmp_0;
                                if (state instanceof WaiterEB) tmp_0 = state.j20_1;
                                else tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                                var sender = tmp_0;
                                if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                                    if (!(onUndeliveredElement == null)) {
                                        var element_0 = segment.y1x(index);
                                        undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                                    }
                                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                                    segment.a1y(index);
                                    segment.t1y();
                                    break update_cell;
                                }
                            } else {
                                if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV()) break process_segments;
                                else {
                                    if (state === get_RESUMING_BY_EB()) continue update_cell;
                                    else break update_cell;
                                }
                            }
                        }
                    }
                }
            }while (0 <= inductionVariable);
            var tmp1_elvis_lhs = segment.c1z();
            var tmp_1;
            if (tmp1_elvis_lhs == null) break process_segments;
            else tmp_1 = tmp1_elvis_lhs;
            segment = tmp_1;
        }
        $l$block: {
            // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
            var this_1 = suspendedSenders;
            var tmp0_subject = _get_holder__f6h5pd(this_1);
            if (tmp0_subject == null) break $l$block;
            else if (!(tmp0_subject instanceof ArrayList)) {
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
                var tmp_2 = _get_holder__f6h5pd(this_1);
                var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
                resumeSenderOnCancelledChannel(it, $this);
            } else {
                var tmp_3 = _get_holder__f6h5pd(this_1);
                var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
                var inductionVariable_0 = list.m() - 1 | 0;
                if (0 <= inductionVariable_0) do {
                    var i = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + -1 | 0;
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
                    var it_0 = list.o(i);
                    resumeSenderOnCancelledChannel(it_0, $this);
                }while (0 <= inductionVariable_0);
            }
        }
        var tmp2_safe_receiver = undeliveredElementException;
        if (tmp2_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        throw tmp2_safe_receiver;
    }
    function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
        var suspendedReceivers = _InlineList___init__impl__z8n56();
        var segment = lastSegment;
        process_segments: while(!(segment == null)){
            var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
            if (0 <= inductionVariable) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + -1 | 0;
                // Inline function 'kotlin.Long.plus' call
                // Inline function 'kotlin.Long.times' call
                var this_0 = segment.s1q_1;
                var other = get_SEGMENT_SIZE();
                if (this_0.a3(toLong(other)).y2(toLong(index)).j1(sendersCounter) < 0) break process_segments;
                cell_update: while(true){
                    var state = segment.b1y(index);
                    if (state === null || state === get_IN_BUFFER()) {
                        if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                            segment.t1y();
                            break cell_update;
                        }
                    } else {
                        if (state instanceof WaiterEB) {
                            if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.j20_1);
                                segment.r1y(index, true);
                                break cell_update;
                            }
                        } else {
                            if (!(state == null) ? isInterface(state, Waiter) : false) {
                                if (segment.d1y(index, state, get_CHANNEL_CLOSED())) {
                                    suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                                    segment.r1y(index, true);
                                    break cell_update;
                                }
                            } else break cell_update;
                        }
                    }
                }
            }while (0 <= inductionVariable);
            segment = segment.c1z();
        }
        $l$block: {
            // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
            var this_1 = suspendedReceivers;
            var tmp0_subject = _get_holder__f6h5pd(this_1);
            if (tmp0_subject == null) break $l$block;
            else if (!(tmp0_subject instanceof ArrayList)) {
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
                var tmp = _get_holder__f6h5pd(this_1);
                var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
                resumeReceiverOnClosedChannel(it, $this);
            } else {
                var tmp_0 = _get_holder__f6h5pd(this_1);
                var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
                var inductionVariable_0 = list.m() - 1 | 0;
                if (0 <= inductionVariable_0) do {
                    var i = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + -1 | 0;
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
                    var it_0 = list.o(i);
                    resumeReceiverOnClosedChannel(it_0, $this);
                }while (0 <= inductionVariable_0);
            }
        }
    }
    function resumeReceiverOnClosedChannel(_this__u8e3s4, $this) {
        return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, true);
    }
    function resumeSenderOnCancelledChannel(_this__u8e3s4, $this) {
        return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, false);
    }
    function resumeWaiterOnClosedChannel(_this__u8e3s4, $this, receiver) {
        if (_this__u8e3s4 instanceof SendBroadcast) {
            // Inline function 'kotlin.coroutines.resume' call
            var this_0 = _this__u8e3s4.r20_1;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
            this_0.g9(tmp$ret$0);
        } else {
            if (isInterface(_this__u8e3s4, CancellableContinuation)) {
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var exception = receiver ? _get_receiveException__foorc1($this) : $this.c21();
                var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
                _this__u8e3s4.g9(tmp$ret$2);
            } else if (_this__u8e3s4 instanceof ReceiveCatching) {
                // Inline function 'kotlin.coroutines.resume' call
                var this_1 = _this__u8e3s4.o20_1;
                // Inline function 'kotlin.Companion.success' call
                var value = new ChannelResult(Companion_getInstance().b21($this.i1z()));
                var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
                this_1.g9(tmp$ret$4);
            } else {
                if (_this__u8e3s4 instanceof BufferedChannelIterator) _this__u8e3s4.x20();
                else if (isInterface(_this__u8e3s4, SelectInstance)) _this__u8e3s4.p20($this, get_CHANNEL_CLOSED());
                else {
                    var message = "Unexpected waiter: " + toString(_this__u8e3s4);
                    throw IllegalStateException_init_$Create$(toString(message));
                }
            }
        }
    }
    function _get_isClosedForSend0__kxgf9m(_this__u8e3s4, $this) {
        return isClosed($this, _this__u8e3s4, false);
    }
    function _get_isClosedForReceive0__f7qknl(_this__u8e3s4, $this) {
        return isClosed($this, _this__u8e3s4, true);
    }
    function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var tmp;
        switch(sendersAndCloseStatusCur.i3(60).l1()){
            case 0:
                tmp = false;
                break;
            case 1:
                tmp = false;
                break;
            case 2:
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var tmp$ret$1 = sendersAndCloseStatusCur.k3(new Long(-1, 268435455));
                completeClose($this, tmp$ret$1);
                tmp = isClosedForReceive ? !$this.d21() : true;
                break;
            case 3:
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var tmp$ret$2 = sendersAndCloseStatusCur.k3(new Long(-1, 268435455));
                completeCancel($this, tmp$ret$2);
                tmp = true;
                break;
            default:
                // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
                var message = "unexpected close status: " + sendersAndCloseStatusCur.i3(60).l1();
                throw IllegalStateException_init_$Create$(toString(message));
        }
        return tmp;
    }
    function isCellNonEmpty($this, segment, index, globalIndex) {
        while(true){
            var state = segment.b1y(index);
            if (state === null || state === get_IN_BUFFER()) {
                if (segment.d1y(index, state, get_POISONED())) {
                    expandBuffer($this);
                    return false;
                }
            } else if (state === get_BUFFERED()) return true;
            else if (state === get_INTERRUPTED_SEND()) return false;
            else if (state === get_CHANNEL_CLOSED()) return false;
            else if (state === get_DONE_RCV()) return false;
            else if (state === get_POISONED()) return false;
            else if (state === get_RESUMING_BY_EB()) return true;
            else if (state === get_RESUMING_BY_RCV()) return false;
            else return globalIndex.equals($this.k20());
        }
    }
    function findSegmentSend($this, id, startFrom) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1;
        $l$block_2: {
            // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
            var this_0 = $this.l1y_1;
            var createNewSegment = createSegmentFunction();
            while(true){
                var s = findSegmentInternal(startFrom, id, createNewSegment);
                var tmp;
                if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) tmp = true;
                else {
                    var tmp$ret$0;
                    $l$block_1: {
                        // Inline function 'kotlinx.coroutines.internal.moveForward' call
                        var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
                        while(true){
                            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
                            var cur = this_0.kotlinx$atomicfu$value;
                            if (cur.s1q_1.j1(to.s1q_1) >= 0) {
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (!to.v1y()) {
                                tmp$ret$0 = false;
                                break $l$block_1;
                            }
                            if (this_0.atomicfu$compareAndSet(cur, to)) {
                                if (cur.w1y()) cur.i4();
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (to.w1y()) to.i4();
                        }
                        tmp$ret$0 = Unit_instance;
                    }
                    tmp = tmp$ret$0;
                }
                if (tmp) {
                    tmp$ret$1 = s;
                    break $l$block_2;
                }
            }
        }
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentSend.<anonymous>' call
        var it = tmp$ret$1;
        var tmp_0;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
            completeCloseOrCancel($this);
            // Inline function 'kotlin.Long.times' call
            var this_1 = startFrom.s1q_1;
            var other = get_SEGMENT_SIZE();
            if (this_1.a3(toLong(other)).j1($this.k20()) < 0) startFrom.d1z();
            tmp_0 = null;
        } else {
            var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
            var tmp_1;
            if (segment.s1q_1.j1(id) > 0) {
                // Inline function 'kotlin.Long.times' call
                var this_2 = segment.s1q_1;
                var other_0 = get_SEGMENT_SIZE();
                var tmp$ret$3 = this_2.a3(toLong(other_0));
                updateSendersCounterIfLower($this, tmp$ret$3);
                // Inline function 'kotlin.Long.times' call
                var this_3 = segment.s1q_1;
                var other_1 = get_SEGMENT_SIZE();
                if (this_3.a3(toLong(other_1)).j1($this.k20()) < 0) segment.d1z();
                tmp_1 = null;
            } else // Inline function 'kotlinx.coroutines.assert' call
            tmp_1 = segment;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function findSegmentReceive($this, id, startFrom) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1;
        $l$block_2: {
            // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
            var this_0 = $this.m1y_1;
            var createNewSegment = createSegmentFunction();
            while(true){
                var s = findSegmentInternal(startFrom, id, createNewSegment);
                var tmp;
                if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) tmp = true;
                else {
                    var tmp$ret$0;
                    $l$block_1: {
                        // Inline function 'kotlinx.coroutines.internal.moveForward' call
                        var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
                        while(true){
                            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
                            var cur = this_0.kotlinx$atomicfu$value;
                            if (cur.s1q_1.j1(to.s1q_1) >= 0) {
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (!to.v1y()) {
                                tmp$ret$0 = false;
                                break $l$block_1;
                            }
                            if (this_0.atomicfu$compareAndSet(cur, to)) {
                                if (cur.w1y()) cur.i4();
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (to.w1y()) to.i4();
                        }
                        tmp$ret$0 = Unit_instance;
                    }
                    tmp = tmp$ret$0;
                }
                if (tmp) {
                    tmp$ret$1 = s;
                    break $l$block_2;
                }
            }
        }
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentReceive.<anonymous>' call
        var it = tmp$ret$1;
        var tmp_0;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
            completeCloseOrCancel($this);
            // Inline function 'kotlin.Long.times' call
            var this_1 = startFrom.s1q_1;
            var other = get_SEGMENT_SIZE();
            if (this_1.a3(toLong(other)).j1($this.j1z()) < 0) startFrom.d1z();
            tmp_0 = null;
        } else {
            var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
            var tmp_1;
            if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
                // Inline function 'kotlin.Long.div' call
                var this_2 = _get_bufferEndCounter__2d4hee($this);
                var other_0 = get_SEGMENT_SIZE();
                var tmp$ret$3 = this_2.b3(toLong(other_0));
                tmp_1 = id.j1(tmp$ret$3) <= 0;
            } else tmp_1 = false;
            if (tmp_1) $l$block_5: {
                // Inline function 'kotlinx.coroutines.internal.moveForward' call
                var this_3 = $this.n1y_1;
                while(true){
                    // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
                    var cur_0 = this_3.kotlinx$atomicfu$value;
                    if (cur_0.s1q_1.j1(segment.s1q_1) >= 0) break $l$block_5;
                    if (!segment.v1y()) break $l$block_5;
                    if (this_3.atomicfu$compareAndSet(cur_0, segment)) {
                        if (cur_0.w1y()) cur_0.i4();
                        break $l$block_5;
                    }
                    if (segment.w1y()) segment.i4();
                }
            }
            var tmp_2;
            if (segment.s1q_1.j1(id) > 0) {
                // Inline function 'kotlin.Long.times' call
                var this_4 = segment.s1q_1;
                var other_1 = get_SEGMENT_SIZE();
                var tmp$ret$5 = this_4.a3(toLong(other_1));
                updateReceiversCounterIfLower($this, tmp$ret$5);
                // Inline function 'kotlin.Long.times' call
                var this_5 = segment.s1q_1;
                var other_2 = get_SEGMENT_SIZE();
                if (this_5.a3(toLong(other_2)).j1($this.j1z()) < 0) segment.d1z();
                tmp_2 = null;
            } else // Inline function 'kotlinx.coroutines.assert' call
            tmp_2 = segment;
            tmp_0 = tmp_2;
        }
        return tmp_0;
    }
    function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
        // Inline function 'kotlin.let' call
        var tmp$ret$1;
        $l$block_2: {
            // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
            var this_0 = $this.n1y_1;
            var createNewSegment = createSegmentFunction();
            while(true){
                var s = findSegmentInternal(startFrom, id, createNewSegment);
                var tmp;
                if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) tmp = true;
                else {
                    var tmp$ret$0;
                    $l$block_1: {
                        // Inline function 'kotlinx.coroutines.internal.moveForward' call
                        var to = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
                        while(true){
                            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
                            var cur = this_0.kotlinx$atomicfu$value;
                            if (cur.s1q_1.j1(to.s1q_1) >= 0) {
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (!to.v1y()) {
                                tmp$ret$0 = false;
                                break $l$block_1;
                            }
                            if (this_0.atomicfu$compareAndSet(cur, to)) {
                                if (cur.w1y()) cur.i4();
                                tmp$ret$0 = true;
                                break $l$block_1;
                            }
                            if (to.w1y()) to.i4();
                        }
                        tmp$ret$0 = Unit_instance;
                    }
                    tmp = tmp$ret$0;
                }
                if (tmp) {
                    tmp$ret$1 = s;
                    break $l$block_2;
                }
            }
        }
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentBufferEnd.<anonymous>' call
        var it = tmp$ret$1;
        var tmp_0;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
            completeCloseOrCancel($this);
            moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
            incCompletedExpandBufferAttempts$default($this);
            tmp_0 = null;
        } else {
            var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
            var tmp_1;
            if (segment.s1q_1.j1(id) > 0) {
                // Inline function 'kotlin.Long.plus' call
                var tmp_2 = currentBufferEndCounter.y2(toLong(1));
                // Inline function 'kotlin.Long.times' call
                var this_1 = segment.s1q_1;
                var other = get_SEGMENT_SIZE();
                var tmp$ret$3 = this_1.a3(toLong(other));
                if ($this.j1y_1.atomicfu$compareAndSet(tmp_2, tmp$ret$3)) {
                    // Inline function 'kotlin.Long.times' call
                    var this_2 = segment.s1q_1;
                    var other_0 = get_SEGMENT_SIZE();
                    var tmp$ret$4 = this_2.a3(toLong(other_0));
                    incCompletedExpandBufferAttempts($this, tmp$ret$4.z2(currentBufferEndCounter));
                } else incCompletedExpandBufferAttempts$default($this);
                tmp_1 = null;
            } else // Inline function 'kotlinx.coroutines.assert' call
            tmp_1 = segment;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
        var segment = startFrom;
        $l$loop: while(segment.s1q_1.j1(id) < 0){
            var tmp0_elvis_lhs = segment.z1y();
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$loop;
            else tmp = tmp0_elvis_lhs;
            segment = tmp;
        }
        while(true){
            $l$loop_0: while(segment.u1y()){
                var tmp1_elvis_lhs = segment.z1y();
                var tmp_0;
                if (tmp1_elvis_lhs == null) break $l$loop_0;
                else tmp_0 = tmp1_elvis_lhs;
                segment = tmp_0;
            }
            var tmp$ret$0;
            $l$block_1: {
                // Inline function 'kotlinx.coroutines.internal.moveForward' call
                var this_0 = $this.n1y_1;
                var to = segment;
                while(true){
                    // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
                    var cur = this_0.kotlinx$atomicfu$value;
                    if (cur.s1q_1.j1(to.s1q_1) >= 0) {
                        tmp$ret$0 = true;
                        break $l$block_1;
                    }
                    if (!to.v1y()) {
                        tmp$ret$0 = false;
                        break $l$block_1;
                    }
                    if (this_0.atomicfu$compareAndSet(cur, to)) {
                        if (cur.w1y()) cur.i4();
                        tmp$ret$0 = true;
                        break $l$block_1;
                    }
                    if (to.w1y()) to.i4();
                }
                tmp$ret$0 = Unit_instance;
            }
            if (tmp$ret$0) return Unit_instance;
        }
    }
    function updateSendersCounterIfLower($this, value) {
        var this_0 = $this.h1y_1;
        while(true){
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateSendersCounterIfLower.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var curCounter = cur.k3(new Long(-1, 268435455));
            if (curCounter.j1(value) >= 0) return Unit_instance;
            // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
            var tmp$ret$1 = cur.i3(60).l1();
            var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
            if ($this.h1y_1.atomicfu$compareAndSet(cur, update)) return Unit_instance;
        }
        return Unit_instance;
    }
    function updateReceiversCounterIfLower($this, value) {
        var this_0 = $this.i1y_1;
        while(true){
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateReceiversCounterIfLower.<anonymous>' call
            var cur = this_0.kotlinx$atomicfu$value;
            if (cur.j1(value) >= 0) return Unit_instance;
            if ($this.i1y_1.atomicfu$compareAndSet(cur, value)) return Unit_instance;
        }
        return Unit_instance;
    }
    function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
        return function(it) {
            var tmp;
            if (!($element === get_CHANNEL_CLOSED())) {
                callUndeliveredElement(this$0.g1y_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.b9());
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
        return function(select, _anonymous_parameter_1__qggqgd, element) {
            return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
        };
    }
    function BufferedChannel(capacity, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        this.f1y_1 = capacity;
        this.g1y_1 = onUndeliveredElement;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.f1y_1 >= 0)) {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<anonymous>' call
            var message = "Invalid channel capacity: " + this.f1y_1 + ", should be >=0";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        this.h1y_1 = atomic$long$1(new Long(0, 0));
        this.i1y_1 = atomic$long$1(new Long(0, 0));
        this.j1y_1 = atomic$long$1(initialBufferEnd(this.f1y_1));
        this.k1y_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
        var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
        this.l1y_1 = atomic$ref$1(firstSegment);
        this.m1y_1 = atomic$ref$1(firstSegment);
        var tmp = this;
        var tmp_0;
        if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
            var tmp_1 = get_NULL_SEGMENT();
            tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
        } else tmp_0 = firstSegment;
        tmp.n1y_1 = atomic$ref$1(tmp_0);
        var tmp_2 = this;
        var tmp_3;
        if (this.g1y_1 == null) tmp_3 = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.onUndeliveredElementReceiveCancellationConstructor.<anonymous>' call
        tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
        tmp_2.o1y_1 = tmp_3;
        this.p1y_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
        this.q1y_1 = atomic$ref$1(null);
    }
    protoOf(BufferedChannel).j1z = function() {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        return this.h1y_1.kotlinx$atomicfu$value.k3(new Long(-1, 268435455));
    };
    protoOf(BufferedChannel).k20 = function() {
        return this.i1y_1.kotlinx$atomicfu$value;
    };
    protoOf(BufferedChannel).f21 = function(element) {
        if (shouldSendSuspend0(this, this.h1y_1.kotlinx$atomicfu$value)) return Companion_getInstance().g21();
        var tmp$ret$4;
        $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var waiter = get_INTERRUPTED_SEND();
            var segment = this.l1y_1.kotlinx$atomicfu$value;
            $l$loop_0: while(true){
                var sendersAndCloseStatusCur = this.h1y_1.atomicfu$getAndIncrement$long();
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var s = sendersAndCloseStatusCur.k3(new Long(-1, 268435455));
                var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, this);
                // Inline function 'kotlin.Long.div' call
                var other = get_SEGMENT_SIZE();
                var id = s.b3(toLong(other));
                // Inline function 'kotlin.Long.rem' call
                var other_0 = get_SEGMENT_SIZE();
                var i = s.c3(toLong(other_0)).l1();
                if (!segment.s1q_1.equals(id)) {
                    var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
                    var tmp;
                    if (tmp0_elvis_lhs == null) {
                        var tmp_0;
                        if (closed) {
                            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                            tmp$ret$4 = Companion_getInstance().b21(this.c21());
                            break $l$block_5;
                        } else continue $l$loop_0;
                    } else tmp = tmp0_elvis_lhs;
                    segment = tmp;
                }
                var tmp1_subject = updateCellSend(this, segment, i, element, s, waiter, closed);
                if (tmp1_subject === _get_RESULT_RENDEZVOUS_$accessor$yt74tm_3irwt8()) {
                    segment.d1z();
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                    tmp$ret$4 = Companion_getInstance().n20(Unit_instance);
                    break $l$block_5;
                } else if (tmp1_subject === _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m()) {
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                    tmp$ret$4 = Companion_getInstance().n20(Unit_instance);
                    break $l$block_5;
                } else if (tmp1_subject === _get_RESULT_SUSPEND_$accessor$yt74tm_cjypnf()) {
                    if (closed) {
                        segment.t1y();
                        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                        tmp$ret$4 = Companion_getInstance().b21(this.c21());
                        break $l$block_5;
                    }
                    var tmp2_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
                    if (tmp2_safe_receiver == null) ;
                    else prepareSenderForSuspension(tmp2_safe_receiver, this, segment, i);
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                    segment.t1y();
                    tmp$ret$4 = Companion_getInstance().g21();
                    break $l$block_5;
                } else if (tmp1_subject === _get_RESULT_CLOSED_$accessor$yt74tm_10v48j()) {
                    if (s.j1(this.k20()) < 0) segment.d1z();
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
                    tmp$ret$4 = Companion_getInstance().b21(this.c21());
                    break $l$block_5;
                } else if (tmp1_subject === _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0()) {
                    segment.d1z();
                    continue $l$loop_0;
                } else if (tmp1_subject === _get_RESULT_SUSPEND_NO_WAITER_$accessor$yt74tm_cvzv8m()) {
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl.<anonymous>' call
                    var message = "unexpected";
                    throw IllegalStateException_init_$Create$(toString(message));
                }
            }
        }
        return tmp$ret$4;
    };
    protoOf(BufferedChannel).q20 = function() {};
    protoOf(BufferedChannel).i20 = function() {};
    protoOf(BufferedChannel).z20 = function(globalCellIndex) {
        // Inline function 'kotlinx.coroutines.assert' call
        var segment = this.m1y_1.kotlinx$atomicfu$value;
        $l$loop_0: while(true){
            var r = this.i1y_1.kotlinx$atomicfu$value;
            // Inline function 'kotlin.math.max' call
            // Inline function 'kotlin.Long.plus' call
            var other = this.f1y_1;
            var a = r.y2(toLong(other));
            var b = _get_bufferEndCounter__2d4hee(this);
            var tmp$ret$1 = a.j1(b) >= 0 ? a : b;
            if (globalCellIndex.j1(tmp$ret$1) < 0) return Unit_instance;
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$2 = r.y2(toLong(1));
            if (!this.i1y_1.atomicfu$compareAndSet(r, tmp$ret$2)) continue $l$loop_0;
            // Inline function 'kotlin.Long.div' call
            var other_0 = get_SEGMENT_SIZE();
            var id = r.b3(toLong(other_0));
            // Inline function 'kotlin.Long.rem' call
            var other_1 = get_SEGMENT_SIZE();
            var i = r.c3(toLong(other_1)).l1();
            if (!segment.s1q_1.equals(id)) {
                var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
                var tmp;
                if (tmp0_elvis_lhs == null) continue $l$loop_0;
                else tmp = tmp0_elvis_lhs;
                segment = tmp;
            }
            var updCellResult = updateCellReceive(this, segment, i, r, null);
            if (updCellResult === _get_FAILED_$accessor$yt74tm_h47uk8()) {
                if (r.j1(this.j1z()) < 0) segment.d1z();
            } else {
                segment.d1z();
                var tmp1_safe_receiver = this.g1y_1;
                var tmp_0;
                if (tmp1_safe_receiver == null) tmp_0 = null;
                else tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
                var tmp2_safe_receiver = tmp_0;
                if (tmp2_safe_receiver == null) ;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                throw tmp2_safe_receiver;
            }
        }
    };
    protoOf(BufferedChannel).s1y = function(globalIndex) {
        if (_get_isRendezvousOrUnlimited__3mdufi(this)) return Unit_instance;
        while(_get_bufferEndCounter__2d4hee(this).j1(globalIndex) <= 0);
        // Inline function 'kotlin.repeat' call
        var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable = 0;
        if (inductionVariable < times) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
            var b = _get_bufferEndCounter__2d4hee(this);
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var ebCompleted = this.k1y_1.kotlinx$atomicfu$value.k3(new Long(-1, 1073741823));
            if (b.equals(ebCompleted) && b.equals(_get_bufferEndCounter__2d4hee(this))) return Unit_instance;
        }while (inductionVariable < times);
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = this.k1y_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
                // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
                var tmp$ret$1 = cur.k3(new Long(-1, 1073741823));
                var upd = constructEBCompletedAndPauseFlag(tmp$ret$1, true);
                if (this_0.atomicfu$compareAndSet(cur, upd)) break $l$block;
            }
        }
        while(true){
            var b_0 = _get_bufferEndCounter__2d4hee(this);
            var ebCompletedAndBit = this.k1y_1.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var ebCompleted_0 = ebCompletedAndBit.k3(new Long(-1, 1073741823));
            // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
            var pauseExpandBuffers = !ebCompletedAndBit.k3(new Long(0, 1073741824)).equals(new Long(0, 0));
            if (b_0.equals(ebCompleted_0) && b_0.equals(_get_bufferEndCounter__2d4hee(this))) {
                $l$block_0: {
                    // Inline function 'kotlinx.atomicfu.update' call
                    var this_1 = this.k1y_1;
                    while(true){
                        var cur_0 = this_1.kotlinx$atomicfu$value;
                        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
                        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
                        var tmp$ret$6 = cur_0.k3(new Long(-1, 1073741823));
                        var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$6, false);
                        if (this_1.atomicfu$compareAndSet(cur_0, upd_0)) break $l$block_0;
                    }
                }
                return Unit_instance;
            }
            if (!pauseExpandBuffers) this.k1y_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
        }
    };
    protoOf(BufferedChannel).j = function() {
        return new BufferedChannelIterator(this);
    };
    protoOf(BufferedChannel).i1z = function() {
        var tmp = this.p1y_1.kotlinx$atomicfu$value;
        return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
    };
    protoOf(BufferedChannel).c21 = function() {
        var tmp0_elvis_lhs = this.i1z();
        return tmp0_elvis_lhs == null ? new ClosedSendChannelException("Channel was closed") : tmp0_elvis_lhs;
    };
    protoOf(BufferedChannel).i21 = function() {};
    protoOf(BufferedChannel).j21 = function(cause) {
        return this.k21(cause, false);
    };
    protoOf(BufferedChannel).b1o = function(cause) {
        this.m21(cause);
    };
    protoOf(BufferedChannel).m21 = function(cause) {
        return this.k21(cause == null ? CancellationException_init_$Create$("Channel was cancelled") : cause, true);
    };
    protoOf(BufferedChannel).k21 = function(cause, cancel) {
        if (cancel) markCancellationStarted(this);
        var closedByThisOperation = this.p1y_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
        if (cancel) markCancelled(this);
        else markClosed(this);
        completeCloseOrCancel(this);
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.closeOrCancelImpl.<anonymous>' call
        this.i21();
        if (closedByThisOperation) invokeCloseHandler(this);
        return closedByThisOperation;
    };
    protoOf(BufferedChannel).a21 = function() {
        return false;
    };
    protoOf(BufferedChannel).y20 = function() {
        return _get_isClosedForSend0__kxgf9m(this.h1y_1.kotlinx$atomicfu$value, this);
    };
    protoOf(BufferedChannel).k1z = function() {
        return _get_isClosedForReceive0__f7qknl(this.h1y_1.kotlinx$atomicfu$value, this);
    };
    protoOf(BufferedChannel).d21 = function() {
        $l$loop: while(true){
            var segment = this.m1y_1.kotlinx$atomicfu$value;
            var r = this.k20();
            var s = this.j1z();
            if (s.j1(r) <= 0) return false;
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = r.b3(toLong(other));
            if (!segment.s1q_1.equals(id)) {
                var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                    var tmp_0;
                    if (this.m1y_1.kotlinx$atomicfu$value.s1q_1.j1(id) < 0) return false;
                    else continue $l$loop;
                } else tmp = tmp0_elvis_lhs;
                segment = tmp;
            }
            segment.d1z();
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = r.c3(toLong(other_0)).l1();
            if (isCellNonEmpty(this, segment, i, r)) return true;
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$2 = r.y2(toLong(1));
            this.i1y_1.atomicfu$compareAndSet(r, tmp$ret$2);
        }
    };
    protoOf(BufferedChannel).toString = function() {
        var sb = StringBuilder_init_$Create$();
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var tmp0_subject = this.h1y_1.kotlinx$atomicfu$value.i3(60).l1();
        if (tmp0_subject === 2) sb.e8("closed,");
        else if (tmp0_subject === 3) sb.e8("cancelled,");
        sb.e8("capacity=" + this.f1y_1 + ",");
        sb.e8("data=[");
        var tmp$ret$4;
        $l$block: {
            // Inline function 'kotlin.collections.minBy' call
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var this_0 = listOf([
                this.m1y_1.kotlinx$atomicfu$value,
                this.l1y_1.kotlinx$atomicfu$value,
                this.n1y_1.kotlinx$atomicfu$value
            ]);
            var destination = ArrayList_init_$Create$_0();
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
                if (!(element === get_NULL_SEGMENT())) destination.e(element);
            }
            var iterator = destination.j();
            if (!iterator.k()) throw NoSuchElementException_init_$Create$();
            var minElem = iterator.l();
            if (!iterator.k()) {
                tmp$ret$4 = minElem;
                break $l$block;
            }
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
            var minValue = minElem.s1q_1;
            do {
                var e = iterator.l();
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
                var v = e.s1q_1;
                if (compareTo(minValue, v) > 0) {
                    minElem = e;
                    minValue = v;
                }
            }while (iterator.k());
            tmp$ret$4 = minElem;
        }
        var firstSegment = tmp$ret$4;
        var r = this.k20();
        var s = this.j1z();
        var segment = firstSegment;
        append_elements: while(true){
            var inductionVariable = 0;
            var last_0 = get_SEGMENT_SIZE();
            if (inductionVariable < last_0) process_cell: do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.Long.plus' call
                // Inline function 'kotlin.Long.times' call
                var this_1 = segment.s1q_1;
                var other = get_SEGMENT_SIZE();
                var globalCellIndex = this_1.a3(toLong(other)).y2(toLong(i));
                if (globalCellIndex.j1(s) >= 0 && globalCellIndex.j1(r) >= 0) break append_elements;
                var cellState = segment.b1y(i);
                var element_0 = segment.y1x(i);
                var tmp;
                if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) tmp = globalCellIndex.j1(r) < 0 && globalCellIndex.j1(s) >= 0 ? "receive" : globalCellIndex.j1(s) < 0 && globalCellIndex.j1(r) >= 0 ? "send" : "cont";
                else if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) tmp = globalCellIndex.j1(r) < 0 && globalCellIndex.j1(s) >= 0 ? "onReceive" : globalCellIndex.j1(s) < 0 && globalCellIndex.j1(r) >= 0 ? "onSend" : "select";
                else {
                    if (cellState instanceof ReceiveCatching) tmp = "receiveCatching";
                    else if (cellState instanceof SendBroadcast) tmp = "sendBroadcast";
                    else {
                        if (cellState instanceof WaiterEB) tmp = "EB(" + toString_0(cellState) + ")";
                        else if (equals(cellState, get_RESUMING_BY_RCV()) ? true : equals(cellState, get_RESUMING_BY_EB())) tmp = "resuming_sender";
                        else {
                            if ((((((cellState == null ? true : equals(cellState, get_IN_BUFFER())) ? true : equals(cellState, get_DONE_RCV())) ? true : equals(cellState, get_POISONED())) ? true : equals(cellState, get_INTERRUPTED_RCV())) ? true : equals(cellState, get_INTERRUPTED_SEND())) ? true : equals(cellState, get_CHANNEL_CLOSED())) continue process_cell;
                            else tmp = toString(cellState);
                        }
                    }
                }
                var cellStateString = tmp;
                if (!(element_0 == null)) sb.e8("(" + cellStateString + "," + toString_0(element_0) + "),");
                else sb.e8(cellStateString + ",");
            }while (inductionVariable < last_0);
            var tmp3_elvis_lhs = segment.z1y();
            var tmp_0;
            if (tmp3_elvis_lhs == null) break append_elements;
            else tmp_0 = tmp3_elvis_lhs;
            segment = tmp_0;
        }
        if (last(sb) === _Char___init__impl__6a9atx(44)) sb.xb(sb.a() - 1 | 0);
        sb.e8("]");
        return sb.toString();
    };
    function WaiterEB(waiter) {
        this.j20_1 = waiter;
    }
    protoOf(WaiterEB).toString = function() {
        return "WaiterEB(" + toString(this.j20_1) + ")";
    };
    function initialBufferEnd(capacity) {
        _init_properties_BufferedChannel_kt__d6uc4y();
        switch(capacity){
            case 0:
                return new Long(0, 0);
            case 2147483647:
                return new Long(-1, 2147483647);
            default:
                return toLong(capacity);
        }
    }
    function ReceiveCatching() {}
    function tryResume0(_this__u8e3s4, value, onCancellation) {
        onCancellation = onCancellation === VOID ? null : onCancellation;
        _init_properties_BufferedChannel_kt__d6uc4y();
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.channels.tryResume0.<anonymous>' call
        var token = _this__u8e3s4.s1p(value, null, onCancellation);
        var tmp;
        if (!(token == null)) {
            _this__u8e3s4.t1p(token);
            tmp = true;
        } else tmp = false;
        return tmp;
    }
    function constructEBCompletedAndPauseFlag(counter, pauseEB) {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return (pauseEB ? new Long(0, 1073741824) : new Long(0, 0)).y2(counter);
    }
    function constructSendersAndCloseStatus(counter, closeStatus) {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return toLong(closeStatus).h3(60).y2(counter);
    }
    function createSegmentFunction() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return createSegment$ref();
    }
    function createSegment(id, prev) {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return new ChannelSegment(id, prev, prev.v1x(), 0);
    }
    function _get_RESULT_SUSPEND_NO_WAITER_$accessor$yt74tm_cvzv8m() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 3;
    }
    function _get_RESULT_RENDEZVOUS_$accessor$yt74tm_3irwt8() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 0;
    }
    function _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 1;
    }
    function _get_RESULT_SUSPEND_$accessor$yt74tm_cjypnf() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 2;
    }
    function _get_RESULT_CLOSED_$accessor$yt74tm_10v48j() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 4;
    }
    function _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return 5;
    }
    function _get_SUSPEND_NO_WAITER_$accessor$yt74tm_n6n1ky() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return get_SUSPEND_NO_WAITER();
    }
    function _get_SUSPEND_$accessor$yt74tm_ccb8g1() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return get_SUSPEND();
    }
    function _get_FAILED_$accessor$yt74tm_h47uk8() {
        _init_properties_BufferedChannel_kt__d6uc4y();
        return get_FAILED();
    }
    function createSegment$ref() {
        var l = function(p0, p1) {
            return createSegment(p0, p1);
        };
        l.callableName = "createSegment";
        return l;
    }
    var properties_initialized_BufferedChannel_kt_58tjvw;
    function _init_properties_BufferedChannel_kt__d6uc4y() {
        if (!properties_initialized_BufferedChannel_kt_58tjvw) {
            properties_initialized_BufferedChannel_kt_58tjvw = true;
            NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
            SEGMENT_SIZE = systemProp("kotlinx.coroutines.bufferedChannel.segmentSize", 32);
            EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp("kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations", 10000);
            BUFFERED = new Symbol("BUFFERED");
            IN_BUFFER = new Symbol("SHOULD_BUFFER");
            RESUMING_BY_RCV = new Symbol("S_RESUMING_BY_RCV");
            RESUMING_BY_EB = new Symbol("RESUMING_BY_EB");
            POISONED = new Symbol("POISONED");
            DONE_RCV = new Symbol("DONE_RCV");
            INTERRUPTED_SEND = new Symbol("INTERRUPTED_SEND");
            INTERRUPTED_RCV = new Symbol("INTERRUPTED_RCV");
            CHANNEL_CLOSED = new Symbol("CHANNEL_CLOSED");
            SUSPEND = new Symbol("SUSPEND");
            SUSPEND_NO_WAITER = new Symbol("SUSPEND_NO_WAITER");
            FAILED = new Symbol("FAILED");
            NO_RECEIVE_RESULT = new Symbol("NO_RECEIVE_RESULT");
            CLOSE_HANDLER_CLOSED = new Symbol("CLOSE_HANDLER_CLOSED");
            CLOSE_HANDLER_INVOKED = new Symbol("CLOSE_HANDLER_INVOKED");
            NO_CLOSE_CAUSE = new Symbol("NO_CLOSE_CAUSE");
        }
    }
    function Factory() {
        Factory_instance = this;
        this.o21_1 = 2147483647;
        this.p21_1 = 0;
        this.q21_1 = -1;
        this.r21_1 = -2;
        this.s21_1 = -3;
        this.t21_1 = "kotlinx.coroutines.channels.defaultBuffer";
        this.u21_1 = systemProp("kotlinx.coroutines.channels.defaultBuffer", 64, 1, 2147483646);
    }
    var Factory_instance;
    function Factory_getInstance() {
        if (Factory_instance == null) new Factory();
        return Factory_instance;
    }
    function _ChannelResult___init__impl__siwsuf(holder) {
        return holder;
    }
    function _ChannelResult___get_holder__impl__pm9gzw($this) {
        return $this;
    }
    function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
        var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
        return !(tmp instanceof Failed);
    }
    function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
        var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
        return tmp instanceof Closed;
    }
    function Failed() {}
    protoOf(Failed).toString = function() {
        return "Failed";
    };
    function Closed(cause) {
        Failed.call(this);
        this.v21_1 = cause;
    }
    protoOf(Closed).equals = function(other) {
        var tmp;
        if (other instanceof Closed) tmp = equals(this.v21_1, other.v21_1);
        else tmp = false;
        return tmp;
    };
    protoOf(Closed).hashCode = function() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.v21_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    };
    protoOf(Closed).toString = function() {
        return "Closed(" + toString_0(this.v21_1) + ")";
    };
    function Companion() {
        Companion_instance_0 = this;
        this.m20_1 = new Failed();
    }
    protoOf(Companion).n20 = function(value) {
        return _ChannelResult___init__impl__siwsuf(value);
    };
    protoOf(Companion).g21 = function() {
        return _ChannelResult___init__impl__siwsuf(this.m20_1);
    };
    protoOf(Companion).b21 = function(cause) {
        return _ChannelResult___init__impl__siwsuf(new Closed(cause));
    };
    var Companion_instance_0;
    function Companion_getInstance() {
        if (Companion_instance_0 == null) new Companion();
        return Companion_instance_0;
    }
    function ChannelResult__toString_impl_rrcqu7($this) {
        var tmp;
        if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) tmp = toString(_ChannelResult___get_holder__impl__pm9gzw($this));
        else tmp = "Value(" + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ")";
        return tmp;
    }
    function ChannelResult__hashCode_impl_lilec2($this) {
        return $this == null ? 0 : hashCode($this);
    }
    function ChannelResult__equals_impl_f471ri($this, other) {
        if (!(other instanceof ChannelResult)) return false;
        var tmp0_other_with_cast = other instanceof ChannelResult ? other.h21_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function ChannelResult(holder) {
        Companion_getInstance();
        this.h21_1 = holder;
    }
    protoOf(ChannelResult).toString = function() {
        return ChannelResult__toString_impl_rrcqu7(this.h21_1);
    };
    protoOf(ChannelResult).hashCode = function() {
        return ChannelResult__hashCode_impl_lilec2(this.h21_1);
    };
    protoOf(ChannelResult).equals = function(other) {
        return ChannelResult__equals_impl_f471ri(this.h21_1, other);
    };
    function ClosedSendChannelException(message) {
        IllegalStateException_init_$Init$(message, this);
        captureStack(this, ClosedSendChannelException);
    }
    function ClosedReceiveChannelException(message) {
        NoSuchElementException_init_$Init$(message, this);
        captureStack(this, ClosedReceiveChannelException);
    }
    function SendChannel() {}
    function ReceiveChannel() {}
    function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
        capacity = capacity === VOID ? 0 : capacity;
        onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        var tmp;
        switch(capacity){
            case 0:
                tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
                break;
            case -1:
                // Inline function 'kotlin.require' call
                // Inline function 'kotlin.contracts.contract' call
                if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
                    // Inline function 'kotlinx.coroutines.channels.Channel.<anonymous>' call
                    var message = "CONFLATED capacity cannot be used with non-default onBufferOverflow";
                    throw IllegalArgumentException_init_$Create$(toString(message));
                }
                tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
                break;
            case 2147483647:
                tmp = new BufferedChannel(2147483647, onUndeliveredElement);
                break;
            case -2:
                tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().u21_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
                break;
            default:
                tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
                break;
        }
        return tmp;
    }
    function cancelConsumed(_this__u8e3s4, cause) {
        var tmp;
        if (cause == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.channels.cancelConsumed.<anonymous>' call
            var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
            tmp = tmp0_elvis_lhs == null ? CancellationException_init_$Create$_0("Channel was consumed, consumer had failed", cause) : tmp0_elvis_lhs;
        }
        _this__u8e3s4.b1o(tmp);
    }
    function trySendImpl($this, element, isSendOp) {
        return $this.j22_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : trySendDropOldest($this, element);
    }
    function trySendDropLatest($this, element, isSendOp) {
        var result = protoOf(BufferedChannel).f21.call($this, element);
        if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result)) return result;
        if (isSendOp) {
            var tmp0_safe_receiver = $this.g1y_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
            if (tmp1_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            throw tmp1_safe_receiver;
        }
        return Companion_getInstance().n20(Unit_instance);
    }
    function trySendDropOldest($this, element) {
        var tmp$ret$3;
        $l$block: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var waiter = get_BUFFERED();
            var segment = $this.l1y_1.kotlinx$atomicfu$value;
            $l$loop_0: while(true){
                var sendersAndCloseStatusCur = $this.h1y_1.atomicfu$getAndIncrement$long();
                // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
                var s = sendersAndCloseStatusCur.k3(new Long(-1, 268435455));
                var closed = _get_isClosedForSend0__kxgf9m(sendersAndCloseStatusCur, $this);
                // Inline function 'kotlin.Long.div' call
                var other = get_SEGMENT_SIZE();
                var id = s.b3(toLong(other));
                // Inline function 'kotlin.Long.rem' call
                var other_0 = get_SEGMENT_SIZE();
                var i = s.c3(toLong(other_0)).l1();
                if (!segment.s1q_1.equals(id)) {
                    var tmp0_elvis_lhs = findSegmentSend($this, id, segment);
                    var tmp;
                    if (tmp0_elvis_lhs == null) {
                        var tmp_0;
                        if (closed) return Companion_getInstance().b21($this.c21());
                        else continue $l$loop_0;
                    } else tmp = tmp0_elvis_lhs;
                    segment = tmp;
                }
                var tmp1_subject = updateCellSend($this, segment, i, element, s, waiter, closed);
                if (tmp1_subject === _get_RESULT_RENDEZVOUS_$accessor$yt74tm_3irwt8()) {
                    segment.d1z();
                    return Companion_getInstance().n20(Unit_instance);
                } else if (tmp1_subject === _get_RESULT_BUFFERED_$accessor$yt74tm_quor5m()) return Companion_getInstance().n20(Unit_instance);
                else if (tmp1_subject === _get_RESULT_SUSPEND_$accessor$yt74tm_cjypnf()) {
                    if (closed) {
                        segment.t1y();
                        return Companion_getInstance().b21($this.c21());
                    }
                    var tmp2_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
                    if (tmp2_safe_receiver == null) ;
                    else prepareSenderForSuspension(tmp2_safe_receiver, $this, segment, i);
                    // Inline function 'kotlin.Long.plus' call
                    // Inline function 'kotlin.Long.times' call
                    var this_0 = segment.s1q_1;
                    var other_1 = get_SEGMENT_SIZE();
                    var tmp$ret$5 = this_0.a3(toLong(other_1)).y2(toLong(i));
                    $this.z20(tmp$ret$5);
                    return Companion_getInstance().n20(Unit_instance);
                } else if (tmp1_subject === _get_RESULT_CLOSED_$accessor$yt74tm_10v48j()) {
                    if (s.j1($this.k20()) < 0) segment.d1z();
                    return Companion_getInstance().b21($this.c21());
                } else if (tmp1_subject === _get_RESULT_FAILED_$accessor$yt74tm_vo1zj0()) {
                    segment.d1z();
                    continue $l$loop_0;
                } else if (tmp1_subject === _get_RESULT_SUSPEND_NO_WAITER_$accessor$yt74tm_cvzv8m()) {
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl.<anonymous>' call
                    var message = "unexpected";
                    throw IllegalStateException_init_$Create$(toString(message));
                }
            }
        }
        return tmp$ret$3;
    }
    function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        BufferedChannel.call(this, capacity, onUndeliveredElement);
        this.i22_1 = capacity;
        this.j22_1 = onBufferOverflow;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(this.j22_1 === BufferOverflow_SUSPEND_getInstance())) {
            // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
            var message = "This implementation does not support suspension for senders, use " + getKClass(BufferedChannel).fa() + " instead";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.i22_1 >= 1)) {
            // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
            var message_0 = "Buffered channel capacity must be at least 1, but " + this.i22_1 + " was specified";
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
    }
    protoOf(ConflatedBufferedChannel).a21 = function() {
        return this.j22_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
    };
    protoOf(ConflatedBufferedChannel).f21 = function(element) {
        return trySendImpl(this, element, false);
    };
    function asFlow(_this__u8e3s4) {
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        return new _no_name_provided__qut3iv(_this__u8e3s4);
    }
    function $collectCOROUTINE$9(_this__u8e3s4, collector, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.s22_1 = _this__u8e3s4;
        this.t22_1 = collector;
    }
    protoOf($collectCOROUTINE$9).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    tmp_0.u22_1 = this.t22_1;
                    var tmp_1 = this;
                    tmp_1.v22_1 = this.s22_1.z22_1;
                    this.w22_1 = this.v22_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.w22_1.k()) {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                    this.x22_1 = this.w22_1.l();
                    var tmp_2 = this;
                    tmp_2.y22_1 = this.x22_1;
                    this.v8_1 = 2;
                    suspendResult = this.u22_1.a23(this.y22_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    return Unit_instance;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function _no_name_provided__qut3iv($this_asFlow) {
        this.z22_1 = $this_asFlow;
    }
    protoOf(_no_name_provided__qut3iv).b23 = function(collector, $completion) {
        var tmp = new $collectCOROUTINE$9(this, collector, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv).c23 = function(collector, $completion) {
        return this.b23(collector, $completion);
    };
    function checkOwnership(_this__u8e3s4, owner) {
        if (!(_this__u8e3s4.d23_1 === owner)) throw _this__u8e3s4;
    }
    function firstOrNull(_this__u8e3s4, $completion) {
        var tmp = new $firstOrNullCOROUTINE$15(_this__u8e3s4, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function firstOrNull_0(_this__u8e3s4, predicate, $completion) {
        var tmp = new $firstOrNullCOROUTINE$16(_this__u8e3s4, predicate, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function _no_name_provided__qut3iv_0($result) {
        this.d24_1 = $result;
    }
    protoOf(_no_name_provided__qut3iv_0).e24 = function(value, $completion) {
        // Inline function 'kotlinx.coroutines.flow.firstOrNull.<anonymous>' call
        this.d24_1._v = value;
        throw new AbortFlowException(this);
    };
    protoOf(_no_name_provided__qut3iv_0).a23 = function(value, $completion) {
        return this.e24((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
    };
    function $emitCOROUTINE$17(_this__u8e3s4, value, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.n24_1 = _this__u8e3s4;
        this.o24_1 = value;
    }
    protoOf($emitCOROUTINE$17).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    tmp_0.p24_1 = this.o24_1;
                    this.v8_1 = 1;
                    suspendResult = this.n24_1.r24_1(this.p24_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    if (suspendResult) {
                        var tmp_1 = this;
                        this.n24_1.s24_1._v = this.p24_1;
                        tmp_1.q24_1 = false;
                        this.v8_1 = 2;
                        continue $sm;
                    } else {
                        var tmp_2 = this;
                        tmp_2.q24_1 = true;
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    var ARGUMENT = this.q24_1;
                    if (!ARGUMENT) throw new AbortFlowException(this.n24_1);
                    else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    return Unit_instance;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function _no_name_provided__qut3iv_1($predicate, $result) {
        this.r24_1 = $predicate;
        this.s24_1 = $result;
    }
    protoOf(_no_name_provided__qut3iv_1).e24 = function(value, $completion) {
        var tmp = new $emitCOROUTINE$17(this, value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv_1).a23 = function(value, $completion) {
        return this.e24((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
    };
    function $firstOrNullCOROUTINE$15(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m23_1 = _this__u8e3s4;
    }
    protoOf($firstOrNullCOROUTINE$15).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.n23_1 = {
                        _v: null
                    };
                    var tmp_0 = this;
                    tmp_0.o23_1 = this.m23_1;
                    var tmp_1 = this;
                    tmp_1.p23_1 = new _no_name_provided__qut3iv_0(this.n23_1);
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.o23_1.c23(this.p23_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 4;
                    var tmp_2 = this.y8_1;
                    if (tmp_2 instanceof AbortFlowException) {
                        var e = this.y8_1;
                        checkOwnership(e, this.p23_1);
                        this.v8_1 = 3;
                        continue $sm;
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 4;
                    return this.n23_1._v;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e_0 = $p;
            if (this.w8_1 === 4) throw e_0;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e_0;
            }
        }
        while (true);
    };
    function $firstOrNullCOROUTINE$16(_this__u8e3s4, predicate, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.y23_1 = _this__u8e3s4;
        this.z23_1 = predicate;
    }
    protoOf($firstOrNullCOROUTINE$16).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.a24_1 = {
                        _v: null
                    };
                    var tmp_0 = this;
                    tmp_0.b24_1 = this.y23_1;
                    var tmp_1 = this;
                    tmp_1.c24_1 = new _no_name_provided__qut3iv_1(this.z23_1, this.a24_1);
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.b24_1.c23(this.c24_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 4;
                    var tmp_2 = this.y8_1;
                    if (tmp_2 instanceof AbortFlowException) {
                        var e = this.y8_1;
                        checkOwnership(e, this.c24_1);
                        this.v8_1 = 3;
                        continue $sm;
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 4;
                    return this.a24_1._v;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e_0 = $p;
            if (this.w8_1 === 4) throw e_0;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e_0;
            }
        }
        while (true);
    };
    function OpDescriptor() {}
    function get_CLOSED() {
        _init_properties_ConcurrentLinkedList_kt__5gcgzy();
        return CLOSED;
    }
    var CLOSED;
    function Segment(id, prev, pointers) {
        ConcurrentLinkedListNode.call(this, prev);
        this.s1q_1 = id;
        this.t1q_1 = atomic$int$1(pointers << 16);
    }
    protoOf(Segment).u1y = function() {
        return this.t1q_1.kotlinx$atomicfu$value === this.w1x() && !this.b1z();
    };
    protoOf(Segment).v1y = function() {
        var tmp$ret$1;
        $l$block_0: {
            // Inline function 'kotlinx.coroutines.internal.addConditionally' call
            var this_0 = this.t1q_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'kotlinx.coroutines.internal.Segment.tryIncPointers.<anonymous>' call
                if (!(!(cur === this.w1x()) || this.b1z())) {
                    tmp$ret$1 = false;
                    break $l$block_0;
                }
                if (this_0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
                    tmp$ret$1 = true;
                    break $l$block_0;
                }
            }
        }
        return tmp$ret$1;
    };
    protoOf(Segment).w1y = function() {
        return this.t1q_1.atomicfu$addAndGet(-65536) === this.w1x() && !this.b1z();
    };
    protoOf(Segment).t1y = function() {
        if (this.t1q_1.atomicfu$incrementAndGet() === this.w1x()) this.i4();
    };
    function close(_this__u8e3s4) {
        _init_properties_ConcurrentLinkedList_kt__5gcgzy();
        var cur = _this__u8e3s4;
        while(true){
            // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
            var this_0 = cur;
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
            var it = _get_nextOrClosed__w0gmuv(this_0);
            var tmp;
            if (it === get_CLOSED()) return cur;
            else tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
            var next = tmp;
            if (next === null) {
                if (cur.e1z()) return cur;
            } else cur = next;
        }
    }
    function _SegmentOrClosed___init__impl__jnexvb(value) {
        return value;
    }
    function _get_value__a43j40($this) {
        return $this;
    }
    function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
        return _get_value__a43j40($this) === get_CLOSED();
    }
    function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
        var tmp;
        if (_get_value__a43j40($this) === get_CLOSED()) {
            var message = "Does not contain segment";
            throw IllegalStateException_init_$Create$(toString(message));
        } else {
            var tmp_0 = _get_value__a43j40($this);
            tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
        }
        return tmp;
    }
    function SegmentOrClosed__toString_impl_pzb2an($this) {
        return "SegmentOrClosed(value=" + toString_0($this) + ")";
    }
    function SegmentOrClosed__hashCode_impl_4855hs($this) {
        return $this == null ? 0 : hashCode($this);
    }
    function SegmentOrClosed__equals_impl_6erq1g($this, other) {
        if (!(other instanceof SegmentOrClosed)) return false;
        var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.e21_1 : THROW_CCE();
        if (!equals($this, tmp0_other_with_cast)) return false;
        return true;
    }
    function SegmentOrClosed(value) {
        this.e21_1 = value;
    }
    protoOf(SegmentOrClosed).toString = function() {
        return SegmentOrClosed__toString_impl_pzb2an(this.e21_1);
    };
    protoOf(SegmentOrClosed).hashCode = function() {
        return SegmentOrClosed__hashCode_impl_4855hs(this.e21_1);
    };
    protoOf(SegmentOrClosed).equals = function(other) {
        return SegmentOrClosed__equals_impl_6erq1g(this.e21_1, other);
    };
    function _get_nextOrClosed__w0gmuv($this) {
        return $this.x1y_1.kotlinx$atomicfu$value;
    }
    function _get_aliveSegmentLeft__mr4ndu($this) {
        var cur = $this.c1z();
        while(!(cur === null) && cur.u1y())cur = cur.y1y_1.kotlinx$atomicfu$value;
        return cur;
    }
    function _get_aliveSegmentRight__7ulr0b($this) {
        // Inline function 'kotlinx.coroutines.assert' call
        var cur = ensureNotNull($this.z1y());
        while(cur.u1y()){
            var tmp0_elvis_lhs = cur.z1y();
            var tmp;
            if (tmp0_elvis_lhs == null) return cur;
            else tmp = tmp0_elvis_lhs;
            cur = tmp;
        }
        return cur;
    }
    function ConcurrentLinkedListNode(prev) {
        this.x1y_1 = atomic$ref$1(null);
        this.y1y_1 = atomic$ref$1(prev);
    }
    protoOf(ConcurrentLinkedListNode).z1y = function() {
        // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
        var it = _get_nextOrClosed__w0gmuv(this);
        var tmp;
        if (it === get_CLOSED()) return null;
        else tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
        return tmp;
    };
    protoOf(ConcurrentLinkedListNode).a1z = function(value) {
        return this.x1y_1.atomicfu$compareAndSet(null, value);
    };
    protoOf(ConcurrentLinkedListNode).b1z = function() {
        return this.z1y() == null;
    };
    protoOf(ConcurrentLinkedListNode).c1z = function() {
        return this.y1y_1.kotlinx$atomicfu$value;
    };
    protoOf(ConcurrentLinkedListNode).d1z = function() {
        // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
        this.y1y_1.kotlinx$atomicfu$value = null;
    };
    protoOf(ConcurrentLinkedListNode).e1z = function() {
        return this.x1y_1.atomicfu$compareAndSet(null, get_CLOSED());
    };
    protoOf(ConcurrentLinkedListNode).i4 = function() {
        // Inline function 'kotlinx.coroutines.assert' call
        if (this.b1z()) return Unit_instance;
        $l$loop_0: while(true){
            var prev = _get_aliveSegmentLeft__mr4ndu(this);
            var next = _get_aliveSegmentRight__7ulr0b(this);
            $l$block: {
                // Inline function 'kotlinx.atomicfu.update' call
                var this_0 = next.y1y_1;
                while(true){
                    var cur = this_0.kotlinx$atomicfu$value;
                    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.remove.<anonymous>' call
                    var upd = cur === null ? null : prev;
                    if (this_0.atomicfu$compareAndSet(cur, upd)) break $l$block;
                }
            }
            if (!(prev === null)) prev.x1y_1.kotlinx$atomicfu$value = next;
            if (next.u1y() && !next.b1z()) continue $l$loop_0;
            if (!(prev === null) && prev.u1y()) continue $l$loop_0;
            return Unit_instance;
        }
    };
    function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
        _init_properties_ConcurrentLinkedList_kt__5gcgzy();
        var cur = _this__u8e3s4;
        $l$loop: while(cur.s1q_1.j1(id) < 0 || cur.u1y()){
            // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
            var this_0 = cur;
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
            var it = _get_nextOrClosed__w0gmuv(this_0);
            var tmp;
            if (it === get_CLOSED()) return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
            else tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
            var next = tmp;
            if (!(next == null)) {
                cur = next;
                continue $l$loop;
            }
            // Inline function 'kotlin.Long.plus' call
            var newTail = createNewSegment(cur.s1q_1.y2(toLong(1)), cur);
            if (cur.a1z(newTail)) {
                if (cur.u1y()) cur.i4();
                cur = newTail;
            }
        }
        return _SegmentOrClosed___init__impl__jnexvb(cur);
    }
    var properties_initialized_ConcurrentLinkedList_kt_kwt434;
    function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
        if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
            properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
            CLOSED = new Symbol("CLOSED");
        }
    }
    function handleUncaughtCoroutineException(context, exception) {
        var tmp0_iterator = get_platformExceptionHandlers().j();
        while(tmp0_iterator.k()){
            var handler = tmp0_iterator.l();
            try {
                handler.a1t(context, exception);
            } catch ($p) {
                if ($p instanceof ExceptionSuccessfullyProcessed) {
                    var _ = $p;
                    return Unit_instance;
                } else {
                    if ($p instanceof Error) {
                        var t = $p;
                        propagateExceptionFinalResort(handlerException(exception, t));
                    } else throw $p;
                }
            }
        }
        try {
            addSuppressed(exception, new DiagnosticCoroutineContextException(context));
        } catch ($p) {
            if ($p instanceof Error) var e = $p;
            else throw $p;
        }
        propagateExceptionFinalResort(exception);
    }
    function ExceptionSuccessfullyProcessed() {}
    function get_UNDEFINED() {
        _init_properties_DispatchedContinuation_kt__tnmqc0();
        return UNDEFINED;
    }
    var UNDEFINED;
    function get_REUSABLE_CLAIMED() {
        _init_properties_DispatchedContinuation_kt__tnmqc0();
        return REUSABLE_CLAIMED;
    }
    var REUSABLE_CLAIMED;
    function _get_reusableCancellableContinuation__9qex09($this) {
        var tmp = $this.e1q_1.kotlinx$atomicfu$value;
        return tmp instanceof CancellableContinuationImpl ? tmp : null;
    }
    function DispatchedContinuation(dispatcher, continuation) {
        DispatchedTask.call(this, -1);
        this.a1q_1 = dispatcher;
        this.b1q_1 = continuation;
        this.c1q_1 = get_UNDEFINED();
        this.d1q_1 = threadContextElements(this.b9());
        this.e1q_1 = atomic$ref$1(null);
    }
    protoOf(DispatchedContinuation).b9 = function() {
        return this.b1q_1.b9();
    };
    protoOf(DispatchedContinuation).n1q = function() {
        return !(this.e1q_1.kotlinx$atomicfu$value == null);
    };
    protoOf(DispatchedContinuation).t24 = function() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.e1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.awaitReusability.<anonymous>' call
            if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED())) return Unit_instance;
        }
    };
    protoOf(DispatchedContinuation).z1s = function() {
        this.t24();
        var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
        if (tmp0_safe_receiver == null) ;
        else tmp0_safe_receiver.j1r();
    };
    protoOf(DispatchedContinuation).f1q = function() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.e1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.claimReusableCancellableContinuation.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (state === null) {
                this.e1q_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
                return null;
            } else if (state instanceof CancellableContinuationImpl) {
                if (this.e1q_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
            } else {
                if (state !== get_REUSABLE_CLAIMED()) {
                    if (!(state instanceof Error)) {
                        var message = "Inconsistent state " + toString_0(state);
                        throw IllegalStateException_init_$Create$(toString(message));
                    }
                }
            }
        }
    };
    protoOf(DispatchedContinuation).v1r = function(continuation) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.e1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.tryReleaseClaimedContinuation.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (state === get_REUSABLE_CLAIMED()) {
                if (this.e1q_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation)) return null;
            } else if (state instanceof Error) {
                // Inline function 'kotlin.require' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlin.require' call
                // Inline function 'kotlin.contracts.contract' call
                if (!this.e1q_1.atomicfu$compareAndSet(state, null)) {
                    // Inline function 'kotlin.require.<anonymous>' call
                    var message = "Failed requirement.";
                    throw IllegalArgumentException_init_$Create$(toString(message));
                }
                return state;
            } else {
                var message_0 = "Inconsistent state " + toString_0(state);
                throw IllegalStateException_init_$Create$(toString(message_0));
            }
        }
    };
    protoOf(DispatchedContinuation).p1q = function(cause) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.e1q_1;
        while(true){
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.postponeCancellation.<anonymous>' call
            var state = this_0.kotlinx$atomicfu$value;
            if (equals(state, get_REUSABLE_CLAIMED())) {
                if (this.e1q_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause)) return true;
            } else {
                if (state instanceof Error) return true;
                else {
                    if (this.e1q_1.atomicfu$compareAndSet(state, null)) return false;
                }
            }
        }
    };
    protoOf(DispatchedContinuation).m1r = function() {
        var state = this.c1q_1;
        // Inline function 'kotlinx.coroutines.assert' call
        this.c1q_1 = get_UNDEFINED();
        return state;
    };
    protoOf(DispatchedContinuation).k1r = function() {
        return this;
    };
    protoOf(DispatchedContinuation).g9 = function(result) {
        var context = this.b1q_1.b9();
        var state = toState_0(result);
        if (this.a1q_1.x1s(context)) {
            this.c1q_1 = state;
            this.o1q_1 = 0;
            this.a1q_1.y1s(context, this);
        } else $l$block: {
            // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
            // Inline function 'kotlinx.coroutines.assert' call
            var eventLoop = ThreadLocalEventLoop_getInstance().q1t();
            var tmp;
            if (eventLoop.k1t()) {
                this.c1q_1 = state;
                this.o1q_1 = 0;
                eventLoop.j1t(this);
                tmp = true;
            } else {
                // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
                eventLoop.m1t(true);
                try {
                    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>' call
                    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
                    this.b9();
                    this.d1q_1;
                    this.b1q_1.g9(result);
                    $l$loop: while(eventLoop.i1t());
                } catch ($p) {
                    if ($p instanceof Error) {
                        var e = $p;
                        this.b1s(e, null);
                    } else throw $p;
                } finally{
                    eventLoop.n1t(true);
                }
                tmp = false;
            }
        }
    };
    protoOf(DispatchedContinuation).n1r = function(takenState, cause) {
        if (takenState instanceof CompletedWithCancellation) takenState.v1s_1(cause);
    };
    protoOf(DispatchedContinuation).toString = function() {
        return "DispatchedContinuation[" + this.a1q_1.toString() + ", " + toDebugString(this.b1q_1) + "]";
    };
    function resumeCancellableWith(_this__u8e3s4, result, onCancellation) {
        onCancellation = onCancellation === VOID ? null : onCancellation;
        _init_properties_DispatchedContinuation_kt__tnmqc0();
        var tmp;
        if (_this__u8e3s4 instanceof DispatchedContinuation) {
            var state = toState_0(result, onCancellation);
            var tmp_0;
            if (_this__u8e3s4.a1q_1.x1s(_this__u8e3s4.b9())) {
                _this__u8e3s4.c1q_1 = state;
                _this__u8e3s4.o1q_1 = 1;
                _this__u8e3s4.a1q_1.y1s(_this__u8e3s4.b9(), _this__u8e3s4);
                tmp_0 = Unit_instance;
            } else {
                $l$block: {
                    // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
                    // Inline function 'kotlinx.coroutines.assert' call
                    var eventLoop = ThreadLocalEventLoop_getInstance().q1t();
                    var tmp_1;
                    if (eventLoop.k1t()) {
                        _this__u8e3s4.c1q_1 = state;
                        _this__u8e3s4.o1q_1 = 1;
                        eventLoop.j1t(_this__u8e3s4);
                        tmp_1 = true;
                    } else {
                        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
                        eventLoop.m1t(true);
                        try {
                            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith.<anonymous>' call
                            var tmp$ret$3;
                            $l$block_0: {
                                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
                                var job = _this__u8e3s4.b9().i9(Key_instance_3);
                                if (!(job == null) && !job.w1m()) {
                                    var cause = job.t1n();
                                    _this__u8e3s4.n1r(state, cause);
                                    // Inline function 'kotlin.coroutines.resumeWithException' call
                                    // Inline function 'kotlin.Companion.failure' call
                                    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
                                    _this__u8e3s4.g9(tmp$ret$1);
                                    tmp$ret$3 = true;
                                    break $l$block_0;
                                }
                                tmp$ret$3 = false;
                            }
                            if (!tmp$ret$3) {
                                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
                                // Inline function 'kotlinx.coroutines.withContinuationContext' call
                                _this__u8e3s4.b1q_1;
                                _this__u8e3s4.d1q_1;
                                _this__u8e3s4.b1q_1.g9(result);
                            }
                            $l$loop: while(eventLoop.i1t());
                        } catch ($p) {
                            if ($p instanceof Error) {
                                var e = $p;
                                _this__u8e3s4.b1s(e, null);
                            } else throw $p;
                        } finally{
                            eventLoop.n1t(true);
                        }
                        tmp_1 = false;
                    }
                }
                tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
        } else {
            _this__u8e3s4.g9(result);
            tmp = Unit_instance;
        }
        return tmp;
    }
    var properties_initialized_DispatchedContinuation_kt_2siadq;
    function _init_properties_DispatchedContinuation_kt__tnmqc0() {
        if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
            properties_initialized_DispatchedContinuation_kt_2siadq = true;
            UNDEFINED = new Symbol("UNDEFINED");
            REUSABLE_CLAIMED = new Symbol("REUSABLE_CLAIMED");
        }
    }
    function DispatchedTask(resumeMode) {
        SchedulerTask.call(this);
        this.o1q_1 = resumeMode;
    }
    protoOf(DispatchedTask).n1r = function(takenState, cause) {};
    protoOf(DispatchedTask).u1r = function(state) {
        return (state == null ? true : !(state == null)) ? state : THROW_CCE();
    };
    protoOf(DispatchedTask).y1r = function(state) {
        var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1n_1;
    };
    protoOf(DispatchedTask).a1s = function() {
        // Inline function 'kotlinx.coroutines.assert' call
        get_taskContext(this);
        var taskContext = Unit_instance;
        var fatalException = null;
        try {
            var tmp = this.k1r();
            var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
            var continuation = delegate.b1q_1;
            // Inline function 'kotlinx.coroutines.withContinuationContext' call
            delegate.d1q_1;
            var context = continuation.b9();
            var state = this.m1r();
            var exception = this.y1r(state);
            var job = exception == null && get_isCancellableMode(this.o1q_1) ? context.i9(Key_instance_3) : null;
            if (!(job == null) && !job.w1m()) {
                var cause = job.t1n();
                this.n1r(state, cause);
                // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
                // Inline function 'kotlin.Companion.failure' call
                var exception_0 = recoverStackTrace(cause, continuation);
                var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception_0));
                continuation.g9(tmp$ret$0);
            } else if (!(exception == null)) {
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
                continuation.g9(tmp$ret$1);
            } else {
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var value = this.u1r(state);
                var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
                continuation.g9(tmp$ret$3);
            }
        } catch ($p) {
            if ($p instanceof Error) {
                var e = $p;
                fatalException = e;
            } else throw $p;
        } finally{
            // Inline function 'kotlin.runCatching' call
            var tmp_0;
            try {
                // Inline function 'kotlin.Companion.success' call
                // Inline function 'kotlinx.coroutines.afterTask' call
                tmp_0 = _Result___init__impl__xyqfz8(Unit_instance);
            } catch ($p) {
                var tmp_1;
                if ($p instanceof Error) {
                    var e_0 = $p;
                    // Inline function 'kotlin.Companion.failure' call
                    tmp_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
                } else throw $p;
                tmp_0 = tmp_1;
            }
            var result = tmp_0;
            this.b1s(fatalException, Result__exceptionOrNull_impl_p6xea9(result));
        }
    };
    protoOf(DispatchedTask).b1s = function(exception, finallyException) {
        if (exception === null && finallyException === null) return Unit_instance;
        !(exception === null) && finallyException;
        var cause = exception == null ? finallyException : exception;
        var reason = new CoroutinesInternalError("Fatal exception in coroutines machinery for " + toString(this) + ". " + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
        handleCoroutineException(this.k1r().b9(), reason);
    };
    function get_isReusableMode(_this__u8e3s4) {
        return _this__u8e3s4 === 2;
    }
    function get_isCancellableMode(_this__u8e3s4) {
        return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
    }
    function dispatch(_this__u8e3s4, mode) {
        // Inline function 'kotlinx.coroutines.assert' call
        var delegate = _this__u8e3s4.k1r();
        var undispatched = mode === 4;
        var tmp;
        var tmp_0;
        if (!undispatched) tmp_0 = delegate instanceof DispatchedContinuation;
        else tmp_0 = false;
        if (tmp_0) tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.o1q_1);
        else tmp = false;
        if (tmp) {
            var dispatcher = delegate.a1q_1;
            var context = delegate.b9();
            if (dispatcher.x1s(context)) dispatcher.y1s(context, _this__u8e3s4);
            else resumeUnconfined(_this__u8e3s4);
        } else resume(_this__u8e3s4, delegate, undispatched);
    }
    function resumeUnconfined(_this__u8e3s4) {
        var eventLoop = ThreadLocalEventLoop_getInstance().q1t();
        if (eventLoop.k1t()) eventLoop.j1t(_this__u8e3s4);
        else {
            // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
            eventLoop.m1t(true);
            try {
                // Inline function 'kotlinx.coroutines.resumeUnconfined.<anonymous>' call
                resume(_this__u8e3s4, _this__u8e3s4.k1r(), true);
                $l$loop: while(eventLoop.i1t());
            } catch ($p) {
                if ($p instanceof Error) {
                    var e = $p;
                    _this__u8e3s4.b1s(e, null);
                } else throw $p;
            } finally{
                eventLoop.n1t(true);
            }
        }
    }
    function resume(_this__u8e3s4, delegate, undispatched) {
        var state = _this__u8e3s4.m1r();
        var exception = _this__u8e3s4.y1r(state);
        var tmp;
        if (!(exception == null)) // Inline function 'kotlin.Companion.failure' call
        tmp = _Result___init__impl__xyqfz8(createFailure(exception));
        else {
            // Inline function 'kotlin.Companion.success' call
            var value = _this__u8e3s4.u1r(state);
            tmp = _Result___init__impl__xyqfz8(value);
        }
        var result = tmp;
        if (undispatched) {
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
            var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
            // Inline function 'kotlinx.coroutines.withContinuationContext' call
            this_0.b1q_1;
            this_0.d1q_1;
            this_0.b1q_1.g9(result);
        } else delegate.g9(result);
    }
    function _InlineList___init__impl__z8n56(holder) {
        holder = holder === VOID ? null : holder;
        return holder;
    }
    function _get_holder__f6h5pd($this) {
        return $this;
    }
    function InlineList__plus_impl_nuetvo($this, element) {
        // Inline function 'kotlinx.coroutines.assert' call
        var tmp0_subject = _get_holder__f6h5pd($this);
        var tmp;
        if (tmp0_subject == null) tmp = _InlineList___init__impl__z8n56(element);
        else if (tmp0_subject instanceof ArrayList) {
            var tmp_0 = _get_holder__f6h5pd($this);
            (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).e(element);
            tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
        } else {
            var list = ArrayList_init_$Create$(4);
            var tmp_1 = _get_holder__f6h5pd($this);
            list.e((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
            list.e(element);
            tmp = _InlineList___init__impl__z8n56(list);
        }
        return tmp;
    }
    function callUndeliveredElement(_this__u8e3s4, element, context) {
        var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        handleCoroutineException(context, tmp0_safe_receiver);
    }
    function UndeliveredElementException(message, cause) {
        RuntimeException_init_$Init$(message, cause, this);
        captureStack(this, UndeliveredElementException);
    }
    function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
        undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
        try {
            _this__u8e3s4(element);
        } catch ($p) {
            if ($p instanceof Error) {
                var ex = $p;
                if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) ;
                else return new UndeliveredElementException("Exception in undelivered element handler for " + toString_0(element), ex);
            } else throw $p;
        }
        return undeliveredElementException;
    }
    function bindCancellationFun(_this__u8e3s4, element, context) {
        return bindCancellationFun$lambda(_this__u8e3s4, element, context);
    }
    function bindCancellationFun$lambda($this_bindCancellationFun, $element, $context) {
        return function(_anonymous_parameter_0__qggqh8) {
            callUndeliveredElement($this_bindCancellationFun, $element, $context);
            return Unit_instance;
        };
    }
    function ScopeCoroutine(context, uCont) {
        AbstractCoroutine.call(this, context, true, true);
        this.x24_1 = uCont;
    }
    protoOf(ScopeCoroutine).k1o = function() {
        return true;
    };
    protoOf(ScopeCoroutine).g1n = function(state) {
        resumeCancellableWith(intercepted(this.x24_1), recoverResult(state, this.x24_1));
    };
    protoOf(ScopeCoroutine).f1n = function(state) {
        this.x24_1.g9(recoverResult(state, this.x24_1));
    };
    function ContextScope(context) {
        this.y24_1 = context;
    }
    protoOf(ContextScope).v1m = function() {
        return this.y24_1;
    };
    protoOf(ContextScope).toString = function() {
        return "CoroutineScope(coroutineContext=" + toString(this.y24_1) + ")";
    };
    function Symbol(symbol) {
        this.z24_1 = symbol;
    }
    protoOf(Symbol).toString = function() {
        return "<" + this.z24_1 + ">";
    };
    function systemProp(propertyName, defaultValue, minValue, maxValue) {
        minValue = minValue === VOID ? 1 : minValue;
        maxValue = maxValue === VOID ? 2147483647 : maxValue;
        return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).l1();
    }
    function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
        minValue = minValue === VOID ? new Long(1, 0) : minValue;
        maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
        var tmp0_elvis_lhs = systemProp_1(propertyName);
        var tmp;
        if (tmp0_elvis_lhs == null) return defaultValue;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp1_elvis_lhs = toLongOrNull(value);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
            var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp_0 = tmp1_elvis_lhs;
        var parsed = tmp_0;
        if (!(minValue.j1(parsed) <= 0 ? parsed.j1(maxValue) <= 0 : false)) {
            // Inline function 'kotlin.error' call
            var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + ".." + maxValue.toString() + ", but is '" + parsed.toString() + "'";
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
        return parsed;
    }
    function startCoroutineCancellable(_this__u8e3s4, fatalCompletion) {
        var tmp;
        try {
            var tmp_0 = intercepted(_this__u8e3s4);
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
            resumeCancellableWith(tmp_0, tmp$ret$0);
            tmp = Unit_instance;
        } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
                var e = $p;
                dispatcherFailure$accessor$glj1hg(fatalCompletion, e);
                tmp_1 = Unit_instance;
            } else throw $p;
            tmp = tmp_1;
        }
        return tmp;
    }
    function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion, onCancellation) {
        onCancellation = onCancellation === VOID ? null : onCancellation;
        var tmp;
        try {
            var tmp_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
            resumeCancellableWith(tmp_0, tmp$ret$0, onCancellation);
            tmp = Unit_instance;
        } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
                var e = $p;
                dispatcherFailure$accessor$glj1hg(completion, e);
                tmp_1 = Unit_instance;
            } else throw $p;
            tmp = tmp_1;
        }
        return tmp;
    }
    function dispatcherFailure(completion, e) {
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.g9(tmp$ret$0);
        throw e;
    }
    function dispatcherFailure$accessor$glj1hg(completion, e) {
        return dispatcherFailure(completion, e);
    }
    function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
        var tmp$ret$3;
        $l$block_0: {
            // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
            var tmp;
            try {
                // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
                // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
                // Inline function 'kotlin.js.asDynamic' call
                var a = block;
                tmp = typeof a === "function" ? a(receiver, _this__u8e3s4) : block.y9(receiver, _this__u8e3s4);
            } catch ($p) {
                var tmp_0;
                if ($p instanceof Error) {
                    var e = $p;
                    tmp_0 = new CompletedExceptionally(e);
                } else throw $p;
                tmp = tmp_0;
            }
            var result = tmp;
            if (result === get_COROUTINE_SUSPENDED()) {
                tmp$ret$3 = get_COROUTINE_SUSPENDED();
                break $l$block_0;
            }
            var state = _this__u8e3s4.e1n(result);
            if (state === get_COMPLETING_WAITING_CHILDREN()) {
                tmp$ret$3 = get_COROUTINE_SUSPENDED();
                break $l$block_0;
            }
            var tmp_1;
            if (state instanceof CompletedExceptionally) {
                var tmp_2;
                // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
                state.b1n_1;
                throw recoverStackTrace(state.b1n_1, _this__u8e3s4.x24_1);
            } else tmp_1 = unboxState(state);
            tmp$ret$3 = tmp_1;
        }
        return tmp$ret$3;
    }
    function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
        $l$block: {
            // Inline function 'kotlinx.coroutines.intrinsics.startDirect' call
            // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
            var actualCompletion = completion;
            var tmp;
            try {
                // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>' call
                // Inline function 'kotlinx.coroutines.withCoroutineContext' call
                completion.b9();
                // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
                // Inline function 'kotlin.js.asDynamic' call
                var a = _this__u8e3s4;
                tmp = typeof a === "function" ? a(receiver, actualCompletion) : _this__u8e3s4.y9(receiver, actualCompletion);
            } catch ($p) {
                var tmp_0;
                if ($p instanceof Error) {
                    var e = $p;
                    // Inline function 'kotlin.coroutines.resumeWithException' call
                    // Inline function 'kotlin.Companion.failure' call
                    var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(e));
                    actualCompletion.g9(tmp$ret$6);
                    break $l$block;
                } else throw $p;
            }
            var value = tmp;
            if (!(value === get_COROUTINE_SUSPENDED())) {
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
                var tmp$ret$9 = _Result___init__impl__xyqfz8(value_0);
                actualCompletion.g9(tmp$ret$9);
            }
        }
    }
    var DUMMY_PROCESS_RESULT_FUNCTION;
    function get_STATE_REG() {
        _init_properties_Select_kt__zhm2jg();
        return STATE_REG;
    }
    var STATE_REG;
    function get_STATE_COMPLETED() {
        _init_properties_Select_kt__zhm2jg();
        return STATE_COMPLETED;
    }
    var STATE_COMPLETED;
    function get_STATE_CANCELLED() {
        _init_properties_Select_kt__zhm2jg();
        return STATE_CANCELLED;
    }
    var STATE_CANCELLED;
    var NO_RESULT;
    var PARAM_CLAUSE_0;
    function SelectInstance() {}
    function trySelectInternal($this, clauseObject, internalResult) {
        $l$loop: while(true){
            var curState = $this.s20_1.kotlinx$atomicfu$value;
            if (isInterface(curState, CancellableContinuation)) {
                var tmp0_elvis_lhs = findClause($this, clauseObject);
                var tmp;
                if (tmp0_elvis_lhs == null) continue $l$loop;
                else tmp = tmp0_elvis_lhs;
                var clause = tmp;
                var onCancellation = clause.d25($this, internalResult);
                if ($this.s20_1.atomicfu$compareAndSet(curState, clause)) {
                    var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
                    $this.u20_1 = internalResult;
                    if (tryResume_0(cont, onCancellation)) return 0;
                    $this.u20_1 = null;
                    return 2;
                }
            } else {
                var tmp_0;
                if (equals(curState, get_STATE_COMPLETED())) tmp_0 = true;
                else tmp_0 = curState instanceof ClauseData;
                if (tmp_0) return 3;
                else {
                    if (equals(curState, get_STATE_CANCELLED())) return 2;
                    else {
                        if (equals(curState, get_STATE_REG())) {
                            if ($this.s20_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject))) return 1;
                        } else if (isInterface(curState, KtList)) {
                            if ($this.s20_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject))) return 1;
                        } else {
                            var message = "Unexpected state: " + toString(curState);
                            throw IllegalStateException_init_$Create$(toString(message));
                        }
                    }
                }
            }
        }
    }
    function findClause($this, clauseObject) {
        var tmp0_elvis_lhs = $this.t20_1;
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var clauses = tmp;
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = clauses.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlinx.coroutines.selects.SelectImplementation.findClause.<anonymous>' call
                if (element.a25_1 === clauseObject) {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        var tmp1_elvis_lhs = tmp$ret$1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
            var message = "Clause with object " + toString(clauseObject) + " is not found";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp_0 = tmp1_elvis_lhs;
        return tmp_0;
    }
    function ClauseData() {}
    protoOf(ClauseData).d25 = function(select, internalResult) {
        var tmp0_safe_receiver = this.c25_1;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.b25_1, internalResult);
    };
    function SelectImplementation() {}
    protoOf(SelectImplementation).v20 = function(clauseObject, result) {
        return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
    };
    var TrySelectDetailedResult_SUCCESSFUL_instance;
    var TrySelectDetailedResult_REREGISTER_instance;
    var TrySelectDetailedResult_CANCELLED_instance;
    var TrySelectDetailedResult_ALREADY_SELECTED_instance;
    var TrySelectDetailedResult_entriesInitialized;
    function TrySelectDetailedResult_initEntries() {
        if (TrySelectDetailedResult_entriesInitialized) return Unit_instance;
        TrySelectDetailedResult_entriesInitialized = true;
        TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult("SUCCESSFUL", 0);
        TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult("REREGISTER", 1);
        TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult("CANCELLED", 2);
        TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult("ALREADY_SELECTED", 3);
    }
    function TrySelectDetailedResult(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function TrySelectDetailedResult_0(trySelectInternalResult) {
        _init_properties_Select_kt__zhm2jg();
        var tmp;
        switch(trySelectInternalResult){
            case 0:
                tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
                break;
            case 1:
                tmp = TrySelectDetailedResult_REREGISTER_getInstance();
                break;
            case 2:
                tmp = TrySelectDetailedResult_CANCELLED_getInstance();
                break;
            case 3:
                tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
                break;
            default:
                var message = "Unexpected internal result: " + trySelectInternalResult;
                throw IllegalStateException_init_$Create$(toString(message));
        }
        return tmp;
    }
    function tryResume_0(_this__u8e3s4, onCancellation) {
        _init_properties_Select_kt__zhm2jg();
        var tmp0_elvis_lhs = _this__u8e3s4.s1p(Unit_instance, null, onCancellation);
        var tmp;
        if (tmp0_elvis_lhs == null) return false;
        else tmp = tmp0_elvis_lhs;
        var token = tmp;
        _this__u8e3s4.t1p(token);
        return true;
    }
    function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd, _anonymous_parameter_2__qggqfi) {
        _init_properties_Select_kt__zhm2jg();
        return null;
    }
    function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
        TrySelectDetailedResult_initEntries();
        return TrySelectDetailedResult_SUCCESSFUL_instance;
    }
    function TrySelectDetailedResult_REREGISTER_getInstance() {
        TrySelectDetailedResult_initEntries();
        return TrySelectDetailedResult_REREGISTER_instance;
    }
    function TrySelectDetailedResult_CANCELLED_getInstance() {
        TrySelectDetailedResult_initEntries();
        return TrySelectDetailedResult_CANCELLED_instance;
    }
    function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
        TrySelectDetailedResult_initEntries();
        return TrySelectDetailedResult_ALREADY_SELECTED_instance;
    }
    var properties_initialized_Select_kt_7rpl36;
    function _init_properties_Select_kt__zhm2jg() {
        if (!properties_initialized_Select_kt_7rpl36) {
            properties_initialized_Select_kt_7rpl36 = true;
            DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
            STATE_REG = new Symbol("STATE_REG");
            STATE_COMPLETED = new Symbol("STATE_COMPLETED");
            STATE_CANCELLED = new Symbol("STATE_CANCELLED");
            NO_RESULT = new Symbol("NO_RESULT");
            PARAM_CLAUSE_0 = new Symbol("PARAM_CLAUSE_0");
        }
    }
    function CompletionHandlerBase() {
        LinkedListNode.call(this);
    }
    function invokeIt(_this__u8e3s4, cause) {
        if (typeof _this__u8e3s4 === "function") _this__u8e3s4(cause);
        else // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4.invoke(cause);
    }
    function CancelHandlerBase() {}
    function toDebugString(_this__u8e3s4) {
        return toString(_this__u8e3s4);
    }
    function get_DefaultDelay() {
        var tmp = Dispatchers_getInstance().e1x_1;
        return isInterface(tmp, Delay) ? tmp : THROW_CCE();
    }
    function createDefaultDispatcher() {
        var tmp;
        if (isJsdom()) tmp = NodeDispatcher_getInstance();
        else {
            var tmp_0;
            var tmp_1;
            if (!(typeof window === "undefined")) // Inline function 'kotlin.js.asDynamic' call
            tmp_1 = window != null;
            else tmp_1 = false;
            if (tmp_1) // Inline function 'kotlin.js.asDynamic' call
            tmp_0 = !(typeof window.addEventListener === "undefined");
            else tmp_0 = false;
            if (tmp_0) tmp = asCoroutineDispatcher(window);
            else if (typeof $hPtJY === "undefined" || typeof $hPtJY.nextTick === "undefined") tmp = SetTimeoutDispatcher_getInstance();
            else tmp = NodeDispatcher_getInstance();
        }
        return tmp;
    }
    function isJsdom() {
        return !(typeof navigator === "undefined") && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === "undefined") && !(typeof navigator.userAgent.match === "undefined") && navigator.userAgent.match("\\bjsdom\\b");
    }
    function newCoroutineContext(_this__u8e3s4, context) {
        var combined = _this__u8e3s4.v1m().vf(context);
        return !(combined === Dispatchers_getInstance().e1x_1) && combined.i9(Key_instance) == null ? combined.vf(Dispatchers_getInstance().e1x_1) : combined;
    }
    function get_coroutineName(_this__u8e3s4) {
        return null;
    }
    var counter;
    function get_DEBUG() {
        return DEBUG;
    }
    var DEBUG;
    function get_classSimpleName(_this__u8e3s4) {
        var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).fa();
        return tmp0_elvis_lhs == null ? "Unknown" : tmp0_elvis_lhs;
    }
    function get_hexAddress(_this__u8e3s4) {
        // Inline function 'kotlin.js.asDynamic' call
        var result = _this__u8e3s4.__debug_counter;
        if (!(typeof result === "number")) {
            counter = counter + 1 | 0;
            result = counter;
            // Inline function 'kotlin.js.asDynamic' call
            _this__u8e3s4.__debug_counter = result;
        }
        return ((!(result == null) ? typeof result === "number" : false) ? result : THROW_CCE()).toString();
    }
    function Dispatchers() {
        Dispatchers_instance = this;
        this.e1x_1 = createDefaultDispatcher();
        this.f1x_1 = Unconfined_getInstance();
        this.g1x_1 = new JsMainDispatcher(this.e1x_1, false);
        this.h1x_1 = null;
    }
    protoOf(Dispatchers).i1x = function() {
        var tmp0_elvis_lhs = this.h1x_1;
        return tmp0_elvis_lhs == null ? this.g1x_1 : tmp0_elvis_lhs;
    };
    var Dispatchers_instance;
    function Dispatchers_getInstance() {
        if (Dispatchers_instance == null) new Dispatchers();
        return Dispatchers_instance;
    }
    function JsMainDispatcher(delegate, invokeImmediately) {
        MainCoroutineDispatcher.call(this);
        this.f25_1 = delegate;
        this.g25_1 = invokeImmediately;
        this.h25_1 = this.g25_1 ? this : new JsMainDispatcher(this.f25_1, true);
    }
    protoOf(JsMainDispatcher).c1x = function() {
        return this.h25_1;
    };
    protoOf(JsMainDispatcher).x1s = function(context) {
        return !this.g25_1;
    };
    protoOf(JsMainDispatcher).y1s = function(context, block) {
        return this.f25_1.y1s(context, block);
    };
    protoOf(JsMainDispatcher).toString = function() {
        var tmp0_elvis_lhs = this.d1x();
        return tmp0_elvis_lhs == null ? this.f25_1.toString() : tmp0_elvis_lhs;
    };
    function createEventLoop() {
        return new UnconfinedEventLoop();
    }
    function UnconfinedEventLoop() {
        EventLoop.call(this);
    }
    protoOf(UnconfinedEventLoop).y1s = function(context, block) {
        unsupported();
    };
    function unsupported() {
        throw UnsupportedOperationException_init_$Create$("runBlocking event loop is not supported");
    }
    function JobCancellationException(message, cause, job) {
        CancellationException_init_$Init$(message, cause, this);
        captureStack(this, JobCancellationException);
        this.m25_1 = job;
    }
    protoOf(JobCancellationException).toString = function() {
        return protoOf(CancellationException).toString.call(this) + "; job=" + toString(this.m25_1);
    };
    protoOf(JobCancellationException).equals = function(other) {
        var tmp;
        if (other === this) tmp = true;
        else {
            var tmp_0;
            var tmp_1;
            var tmp_2;
            if (other instanceof JobCancellationException) tmp_2 = other.message == this.message;
            else tmp_2 = false;
            if (tmp_2) tmp_1 = equals(other.m25_1, this.m25_1);
            else tmp_1 = false;
            if (tmp_1) tmp_0 = equals(other.cause, this.cause);
            else tmp_0 = false;
            tmp = tmp_0;
        }
        return tmp;
    };
    protoOf(JobCancellationException).hashCode = function() {
        var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.m25_1) | 0, 31);
        var tmp0_safe_receiver = this.cause;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    };
    function NodeDispatcher() {
        NodeDispatcher_instance = this;
        SetTimeoutBasedDispatcher.call(this);
    }
    protoOf(NodeDispatcher).p25 = function() {
        $hPtJY.nextTick(this.w25_1.t25_1);
    };
    var NodeDispatcher_instance;
    function NodeDispatcher_getInstance() {
        if (NodeDispatcher_instance == null) new NodeDispatcher();
        return NodeDispatcher_instance;
    }
    function SetTimeoutDispatcher() {
        SetTimeoutDispatcher_instance = this;
        SetTimeoutBasedDispatcher.call(this);
    }
    protoOf(SetTimeoutDispatcher).p25 = function() {
        setTimeout(this.w25_1.t25_1, 0);
    };
    var SetTimeoutDispatcher_instance;
    function SetTimeoutDispatcher_getInstance() {
        if (SetTimeoutDispatcher_instance == null) new SetTimeoutDispatcher();
        return SetTimeoutDispatcher_instance;
    }
    function SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this$0) {
        return function() {
            this$0.c26();
            return Unit_instance;
        };
    }
    function ScheduledMessageQueue($outer) {
        this.u25_1 = $outer;
        MessageQueue.call(this);
        var tmp = this;
        tmp.t25_1 = SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this);
    }
    protoOf(ScheduledMessageQueue).d26 = function() {
        this.u25_1.p25();
    };
    protoOf(ScheduledMessageQueue).e26 = function() {
        setTimeout(this.t25_1, 0);
    };
    function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
        return function() {
            // Inline function 'kotlin.with' call
            // Inline function 'kotlin.contracts.contract' call
            $continuation.v1p(this$0, Unit_instance);
            return Unit_instance;
        };
    }
    function SetTimeoutBasedDispatcher() {
        CoroutineDispatcher.call(this);
        this.w25_1 = new ScheduledMessageQueue(this);
    }
    protoOf(SetTimeoutBasedDispatcher).y1s = function(context, block) {
        this.w25_1.m26(block);
    };
    protoOf(SetTimeoutBasedDispatcher).d1t = function(timeMillis, continuation) {
        var handle = setTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ClearTimeout(handle);
        continuation.u1p(tmp$ret$1);
    };
    function MessageQueue() {
        this.z25_1 = ArrayDeque_init_$Create$();
        this.a26_1 = 16;
        this.b26_1 = false;
    }
    protoOf(MessageQueue).m = function() {
        return this.z25_1.ae_1;
    };
    protoOf(MessageQueue).f26 = function(index, element) {
        this.z25_1.k2(index, element);
    };
    protoOf(MessageQueue).k2 = function(index, element) {
        return this.f26(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
    };
    protoOf(MessageQueue).g26 = function(element) {
        return this.z25_1.e(element);
    };
    protoOf(MessageQueue).e = function(element) {
        return this.g26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
    };
    protoOf(MessageQueue).h26 = function(elements) {
        return this.z25_1.n(elements);
    };
    protoOf(MessageQueue).n = function(elements) {
        return this.h26(elements);
    };
    protoOf(MessageQueue).i2 = function() {
        this.z25_1.i2();
    };
    protoOf(MessageQueue).i26 = function(element) {
        return this.z25_1.a2(element);
    };
    protoOf(MessageQueue).a2 = function(element) {
        if (!(!(element == null) ? isInterface(element, Runnable) : false)) return false;
        return this.i26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
    };
    protoOf(MessageQueue).j26 = function(elements) {
        return this.z25_1.b2(elements);
    };
    protoOf(MessageQueue).b2 = function(elements) {
        return this.j26(elements);
    };
    protoOf(MessageQueue).o = function(index) {
        return this.z25_1.o(index);
    };
    protoOf(MessageQueue).s = function() {
        return this.z25_1.s();
    };
    protoOf(MessageQueue).j = function() {
        return this.z25_1.j();
    };
    protoOf(MessageQueue).w = function(index) {
        return this.z25_1.w(index);
    };
    protoOf(MessageQueue).l2 = function(index) {
        return this.z25_1.l2(index);
    };
    protoOf(MessageQueue).k26 = function(elements) {
        return this.z25_1.h2(elements);
    };
    protoOf(MessageQueue).h2 = function(elements) {
        return this.k26(elements);
    };
    protoOf(MessageQueue).l26 = function(index, element) {
        return this.z25_1.j2(index, element);
    };
    protoOf(MessageQueue).j2 = function(index, element) {
        return this.l26(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
    };
    protoOf(MessageQueue).v = function(fromIndex, toIndex) {
        return this.z25_1.v(fromIndex, toIndex);
    };
    protoOf(MessageQueue).m26 = function(element) {
        this.g26(element);
        if (!this.b26_1) {
            this.b26_1 = true;
            this.d26();
        }
    };
    protoOf(MessageQueue).c26 = function() {
        try {
            // Inline function 'kotlin.repeat' call
            var times = this.a26_1;
            // Inline function 'kotlin.contracts.contract' call
            var inductionVariable = 0;
            if (inductionVariable < times) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlinx.coroutines.MessageQueue.process.<anonymous>' call
                var tmp0_elvis_lhs = removeFirstOrNull(this);
                var tmp;
                if (tmp0_elvis_lhs == null) return Unit_instance;
                else tmp = tmp0_elvis_lhs;
                var element = tmp;
                element.a1s();
            }while (inductionVariable < times);
        } finally{
            if (this.s()) this.b26_1 = false;
            else this.e26();
        }
    };
    function delayToInt(timeMillis) {
        return coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)).l1();
    }
    function ClearTimeout(handle) {
        CancelHandler.call(this);
        this.n26_1 = handle;
    }
    protoOf(ClearTimeout).y1p = function() {
        clearTimeout(this.n26_1);
    };
    protoOf(ClearTimeout).x1p = function(cause) {
        this.y1p();
    };
    protoOf(ClearTimeout).invoke = function(cause) {
        return this.x1p(cause);
    };
    protoOf(ClearTimeout).toString = function() {
        return "ClearTimeout[" + this.n26_1 + "]";
    };
    function WindowClearTimeout($outer, handle) {
        this.p26_1 = $outer;
        ClearTimeout.call(this, handle);
    }
    protoOf(WindowClearTimeout).y1p = function() {
        this.p26_1.r26_1.clearTimeout(this.n26_1);
    };
    function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
        return function() {
            // Inline function 'kotlin.with' call
            // Inline function 'kotlin.contracts.contract' call
            $continuation.v1p(this$0, Unit_instance);
            return Unit_instance;
        };
    }
    function WindowDispatcher(window_0) {
        CoroutineDispatcher.call(this);
        this.r26_1 = window_0;
        this.s26_1 = new WindowMessageQueue(this.r26_1);
    }
    protoOf(WindowDispatcher).y1s = function(context, block) {
        return this.s26_1.m26(block);
    };
    protoOf(WindowDispatcher).d1t = function(timeMillis, continuation) {
        var handle = this.r26_1.setTimeout(WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new WindowClearTimeout(this, handle);
        continuation.u1p(tmp$ret$1);
    };
    function WindowMessageQueue$lambda(this$0) {
        return function(event) {
            var tmp;
            if (event.source == this$0.w26_1 && event.data == this$0.x26_1) {
                event.stopPropagation();
                this$0.c26();
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function WindowMessageQueue$schedule$lambda(this$0) {
        return function(it) {
            this$0.c26();
            return Unit_instance;
        };
    }
    function WindowMessageQueue(window_0) {
        MessageQueue.call(this);
        this.w26_1 = window_0;
        this.x26_1 = "dispatchCoroutine";
        this.w26_1.addEventListener("message", WindowMessageQueue$lambda(this), true);
    }
    protoOf(WindowMessageQueue).d26 = function() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then(WindowMessageQueue$schedule$lambda(this));
    };
    protoOf(WindowMessageQueue).e26 = function() {
        this.w26_1.postMessage(this.x26_1, "*");
    };
    function promise(_this__u8e3s4, context, start, block) {
        context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
        start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
        return asPromise(async(_this__u8e3s4, context, start, block));
    }
    function await_0(_this__u8e3s4, $completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
        cancellable.l1r();
        // Inline function 'kotlinx.coroutines.await.<anonymous>' call
        var tmp = await$lambda(cancellable);
        _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
        return cancellable.s1r();
    }
    function asPromise(_this__u8e3s4) {
        var promise = new Promise(asPromise$lambda(_this__u8e3s4));
        // Inline function 'kotlin.js.asDynamic' call
        promise.deferred = _this__u8e3s4;
        return promise;
    }
    function await$lambda($cont) {
        return function(it) {
            // Inline function 'kotlin.coroutines.resume' call
            var this_0 = $cont;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
            this_0.g9(tmp$ret$0);
            return Unit_instance;
        };
    }
    function await$lambda_0($cont) {
        return function(it) {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            var this_0 = $cont;
            // Inline function 'kotlin.Companion.failure' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(it));
            this_0.g9(tmp$ret$0);
            return Unit_instance;
        };
    }
    function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
        return function(it) {
            var e = $this_asPromise.o1o();
            var tmp;
            if (!(e == null)) tmp = $reject(e);
            else tmp = $resolve($this_asPromise.l1p());
            return Unit_instance;
        };
    }
    function asPromise$lambda($this_asPromise) {
        return function(resolve, reject) {
            $this_asPromise.w1n(asPromise$lambda$lambda($this_asPromise, reject, resolve));
            return Unit_instance;
        };
    }
    function Runnable() {}
    function SchedulerTask() {}
    function get_taskContext(_this__u8e3s4) {
        return Unit_instance;
    }
    function asCoroutineDispatcher(_this__u8e3s4) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = new WindowDispatcher(_this__u8e3s4);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlinx.coroutines.asCoroutineDispatcher.<anonymous>' call
            // Inline function 'kotlin.js.asDynamic' call
            _this__u8e3s4.coroutineDispatcher = this_0;
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function AbortFlowException(owner) {
        CancellationException_init_$Init$_0("Flow was aborted, no more elements needed", this);
        captureStack(this, AbortFlowException);
        this.d23_1 = owner;
    }
    function identitySet(expectedSize) {
        return HashSet_init_$Create$(expectedSize);
    }
    function get_platformExceptionHandlers_() {
        _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
        return platformExceptionHandlers_;
    }
    var platformExceptionHandlers_;
    function get_platformExceptionHandlers() {
        _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
        return get_platformExceptionHandlers_();
    }
    function propagateExceptionFinalResort(exception) {
        _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
        console.error(exception);
    }
    function DiagnosticCoroutineContextException(context) {
        RuntimeException_init_$Init$_0(toString(context), this);
        captureStack(this, DiagnosticCoroutineContextException);
    }
    var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
    function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
        if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
            properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
            // Inline function 'kotlin.collections.mutableSetOf' call
            platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
        }
    }
    function LinkedListHead() {
        LinkedListNode.call(this);
    }
    protoOf(LinkedListHead).g1u = function() {
        throw UnsupportedOperationException_init_$Create$_0();
    };
    function LinkedListNode() {
        this.a1u_1 = this;
        this.b1u_1 = this;
        this.c1u_1 = false;
    }
    protoOf(LinkedListNode).h1u = function(node) {
        var prev = this.b1u_1;
        node.a1u_1 = this;
        node.b1u_1 = prev;
        prev.a1u_1 = node;
        this.b1u_1 = node;
    };
    protoOf(LinkedListNode).g1u = function() {
        return this.i1u();
    };
    protoOf(LinkedListNode).y1p = function() {
        this.g1u();
    };
    protoOf(LinkedListNode).i1u = function() {
        if (this.c1u_1) return false;
        var prev = this.b1u_1;
        var next = this.a1u_1;
        prev.a1u_1 = next;
        next.b1u_1 = prev;
        this.c1u_1 = true;
        return true;
    };
    protoOf(LinkedListNode).o1u = function(node) {
        if (!(this.a1u_1 === this)) return false;
        this.h1u(node);
        return true;
    };
    function unwrap(exception) {
        return exception;
    }
    function recoverStackTrace(exception, continuation) {
        return exception;
    }
    function recoverStackTrace_0(exception) {
        return exception;
    }
    function systemProp_1(propertyName) {
        return null;
    }
    function threadContextElements(context) {
        return 0;
    }
    function CommonThreadLocal() {
        this.r1t_1 = null;
    }
    protoOf(CommonThreadLocal).s1t = function() {
        var tmp = this.r1t_1;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(CommonThreadLocal).t1t = function(value) {
        this.r1t_1 = value;
    };
    function commonThreadLocal(name) {
        return new CommonThreadLocal();
    }
    //region block: post-declaration
    protoOf(JobSupport).y1n = invokeOnCompletion$default;
    protoOf(JobSupport).c1o = cancel$default;
    protoOf(JobSupport).vf = plus;
    protoOf(JobSupport).i9 = get_0;
    protoOf(JobSupport).uf = fold;
    protoOf(JobSupport).tf = minusKey_0;
    protoOf(CoroutineDispatcher).i9 = get;
    protoOf(CoroutineDispatcher).tf = minusKey;
    protoOf(BufferedChannel).l21 = close$default;
    protoOf(BufferedChannel).n21 = cancel$default_0;
    //endregion
    //region block: init
    Active_instance = new Active();
    Key_instance_1 = new Key_0();
    Key_instance_2 = new Key_1();
    GlobalScope_instance = new GlobalScope();
    Key_instance_3 = new Key_2();
    NonDisposableHandle_instance = new NonDisposableHandle();
    Key_instance_4 = new Key_3();
    counter = 0;
    DEBUG = false;
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = firstOrNull_0;
    _.$_$.b = firstOrNull;
    _.$_$.c = await_0;
    _.$_$.d = coroutineScope;
    _.$_$.e = delay;
    _.$_$.f = cancel$default;
    _.$_$.g = invokeOnCompletion$default;
    _.$_$.h = _ChannelResult___get_isSuccess__impl__odq1z9;
    _.$_$.i = Key_getInstance;
    _.$_$.j = Key_instance_1;
    _.$_$.k = Dispatchers_getInstance;
    _.$_$.l = GlobalScope_instance;
    _.$_$.m = Key_instance_3;
    _.$_$.n = Channel;
    _.$_$.o = cancelConsumed;
    _.$_$.p = asFlow;
    _.$_$.q = recoverStackTrace;
    _.$_$.r = CancellableContinuationImpl;
    _.$_$.s = CompletableDeferred;
    _.$_$.t = CompletableJob;
    _.$_$.u = CoroutineName;
    _.$_$.v = CoroutineScope_0;
    _.$_$.w = CoroutineScope;
    _.$_$.x = Job_0;
    _.$_$.y = Job;
    _.$_$.z = SupervisorJob;
    _.$_$.a1 = async;
    _.$_$.b1 = cancel;
    _.$_$.c1 = cancel_2;
    _.$_$.d1 = cancel_0;
    _.$_$.e1 = cancel_1;
    _.$_$.f1 = get_job;
    _.$_$.g1 = launch;
    _.$_$.h1 = promise;
    //endregion
    return _;
});

});
parcelRegister("k4lEE", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var fillArrayVal = kotlin_kotlin.$_$.da;
    var protoOf = kotlin_kotlin.$_$.kb;
    var defineProp = kotlin_kotlin.$_$.aa;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var VOID = kotlin_kotlin.$_$.f;
    var toString = kotlin_kotlin.$_$.vf;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(atomicfu$AtomicRefArray$ref, "AtomicArray");
    initMetadataForClass(atomicfu$TraceBase, "TraceBase");
    initMetadataForObject(None, "None", VOID, atomicfu$TraceBase);
    initMetadataForClass(AtomicRef, "AtomicRef");
    initMetadataForClass(AtomicBoolean, "AtomicBoolean");
    initMetadataForClass(AtomicInt, "AtomicInt");
    initMetadataForClass(AtomicLong, "AtomicLong");
    //endregion
    function atomicfu$AtomicRefArray$ref(size) {
        var tmp = this;
        var tmp_0 = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_1 = fillArrayVal(Array(size), null);
        while(tmp_0 < size){
            tmp_1[tmp_0] = atomic$ref$1(null);
            tmp_0 = tmp_0 + 1 | 0;
        }
        tmp.i1m_1 = tmp_1;
    }
    protoOf(atomicfu$AtomicRefArray$ref).j1m = function() {
        return this.i1m_1.length;
    };
    protoOf(atomicfu$AtomicRefArray$ref).atomicfu$get = function(index) {
        return this.i1m_1[index];
    };
    function atomicfu$AtomicRefArray$ofNulls(size) {
        return new atomicfu$AtomicRefArray$ref(size);
    }
    function None() {
        None_instance = this;
        atomicfu$TraceBase.call(this);
    }
    var None_instance;
    function None_getInstance() {
        if (None_instance == null) new None();
        return None_instance;
    }
    function atomicfu$TraceBase() {}
    protoOf(atomicfu$TraceBase).atomicfu$Trace$append$1 = function(event) {};
    protoOf(atomicfu$TraceBase).atomicfu$Trace$append$2 = function(event1, event2) {};
    protoOf(atomicfu$TraceBase).atomicfu$Trace$append$3 = function(event1, event2, event3) {};
    protoOf(atomicfu$TraceBase).atomicfu$Trace$append$4 = function(event1, event2, event3, event4) {};
    function AtomicRef(value) {
        this.kotlinx$atomicfu$value = value;
    }
    protoOf(AtomicRef).k1m = function(_set____db54di) {
        this.kotlinx$atomicfu$value = _set____db54di;
    };
    protoOf(AtomicRef).l1m = function() {
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicRef).atomicfu$compareAndSet = function(expect, update) {
        if (!(this.kotlinx$atomicfu$value === expect)) return false;
        this.kotlinx$atomicfu$value = update;
        return true;
    };
    protoOf(AtomicRef).atomicfu$getAndSet = function(value) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = value;
        return oldValue;
    };
    protoOf(AtomicRef).toString = function() {
        return toString(this.kotlinx$atomicfu$value);
    };
    function atomic$ref$1(initial) {
        return atomic$ref$(initial, None_getInstance());
    }
    function AtomicBoolean(value) {
        this.kotlinx$atomicfu$value = value;
    }
    protoOf(AtomicBoolean).m1m = function(_set____db54di) {
        this.kotlinx$atomicfu$value = _set____db54di;
    };
    protoOf(AtomicBoolean).l1m = function() {
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicBoolean).atomicfu$compareAndSet = function(expect, update) {
        if (!(this.kotlinx$atomicfu$value === expect)) return false;
        this.kotlinx$atomicfu$value = update;
        return true;
    };
    protoOf(AtomicBoolean).atomicfu$getAndSet = function(value) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = value;
        return oldValue;
    };
    protoOf(AtomicBoolean).toString = function() {
        return this.kotlinx$atomicfu$value.toString();
    };
    function atomic$boolean$1(initial) {
        return atomic$boolean$(initial, None_getInstance());
    }
    function AtomicInt(value) {
        this.kotlinx$atomicfu$value = value;
    }
    protoOf(AtomicInt).n1m = function(_set____db54di) {
        this.kotlinx$atomicfu$value = _set____db54di;
    };
    protoOf(AtomicInt).l1m = function() {
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicInt).atomicfu$compareAndSet = function(expect, update) {
        if (!(this.kotlinx$atomicfu$value === expect)) return false;
        this.kotlinx$atomicfu$value = update;
        return true;
    };
    protoOf(AtomicInt).atomicfu$getAndSet = function(value) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = value;
        return oldValue;
    };
    protoOf(AtomicInt).atomicfu$getAndIncrement = function() {
        var tmp1 = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = tmp1 + 1 | 0;
        return tmp1;
    };
    protoOf(AtomicInt).atomicfu$getAndDecrement = function() {
        var tmp1 = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = tmp1 - 1 | 0;
        return tmp1;
    };
    protoOf(AtomicInt).atomicfu$getAndAdd = function(delta) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
        return oldValue;
    };
    protoOf(AtomicInt).atomicfu$addAndGet = function(delta) {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicInt).atomicfu$incrementAndGet = function() {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + 1 | 0;
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicInt).atomicfu$decrementAndGet = function() {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value - 1 | 0;
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicInt).toString = function() {
        return this.kotlinx$atomicfu$value.toString();
    };
    function atomic$int$1(initial) {
        return atomic$int$(initial, None_getInstance());
    }
    function AtomicLong(value) {
        this.kotlinx$atomicfu$value = value;
    }
    protoOf(AtomicLong).o1m = function(_set____db54di) {
        this.kotlinx$atomicfu$value = _set____db54di;
    };
    protoOf(AtomicLong).l1m = function() {
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicLong).atomicfu$compareAndSet = function(expect, update) {
        if (!this.kotlinx$atomicfu$value.equals(expect)) return false;
        this.kotlinx$atomicfu$value = update;
        return true;
    };
    protoOf(AtomicLong).atomicfu$getAndSet = function(value) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = value;
        return oldValue;
    };
    protoOf(AtomicLong).atomicfu$getAndIncrement$long = function() {
        var tmp1 = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = tmp1.d3();
        return tmp1;
    };
    protoOf(AtomicLong).atomicfu$getAndDecrement$long = function() {
        var tmp1 = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = tmp1.e3();
        return tmp1;
    };
    protoOf(AtomicLong).atomicfu$getAndAdd$long = function(delta) {
        var oldValue = this.kotlinx$atomicfu$value;
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.y2(delta);
        return oldValue;
    };
    protoOf(AtomicLong).atomicfu$addAndGet$long = function(delta) {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.y2(delta);
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicLong).atomicfu$incrementAndGet$long = function() {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.d3();
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicLong).atomicfu$decrementAndGet$long = function() {
        this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.e3();
        return this.kotlinx$atomicfu$value;
    };
    protoOf(AtomicLong).toString = function() {
        return this.kotlinx$atomicfu$value.toString();
    };
    function atomic$long$1(initial) {
        return atomic$long$(initial, None_getInstance());
    }
    function atomic$ref$(initial, trace) {
        trace = trace === VOID ? None_getInstance() : trace;
        return new AtomicRef(initial);
    }
    function atomic$boolean$(initial, trace) {
        trace = trace === VOID ? None_getInstance() : trace;
        return new AtomicBoolean(initial);
    }
    function atomic$int$(initial, trace) {
        trace = trace === VOID ? None_getInstance() : trace;
        return new AtomicInt(initial);
    }
    function atomic$long$(initial, trace) {
        trace = trace === VOID ? None_getInstance() : trace;
        return new AtomicLong(initial);
    }
    //region block: post-declaration
    defineProp(protoOf(atomicfu$AtomicRefArray$ref), "atomicfu$size", protoOf(atomicfu$AtomicRefArray$ref).j1m);
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = atomicfu$AtomicRefArray$ofNulls;
    _.$_$.b = atomic$boolean$1;
    _.$_$.c = atomic$long$1;
    _.$_$.d = atomic$ref$1;
    _.$_$.e = atomic$int$1;
    //endregion
    return _;
});

});



parcelRegister("1FnuK", function(module, exports) {









(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./kotlin-kotlin-stdlib.js",
        "./curity-ssi-libs-sd-jwt.js",
        "./curity-ssi-libs-core-json.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./Kotlin-DateTime-library-kotlinx-datetime.js",
        "./curity-ssi-libs-jose.js",
        "./curity-ssi-libs-core.js",
        "./curity-ssi-libs-verifiable-credentials.js"
    ], factory);
    else factory(module.exports, (parcelRequire("3kJd2")), (parcelRequire("9vyMc")), (parcelRequire("ljyPz")), (parcelRequire("fcWHW")), (parcelRequire("2VOQS")), (parcelRequire("3WyZ3")), (parcelRequire("lm0Zq")), (parcelRequire("iuiRe")), (parcelRequire("dfhqu")));
})(globalThis, function(_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_curity_ssi_sd_jwt, kotlin_io_curity_ssi_core_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_jose, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_verifiable_credentials) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
    var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var $serializer_getInstance = kotlin_io_curity_ssi_sd_jwt.$_$.d;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var VOID = kotlin_kotlin.$_$.f;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var toString = kotlin_kotlin.$_$.ob;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var hashCode = kotlin_kotlin.$_$.ha;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var equals = kotlin_kotlin.$_$.ba;
    var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
    var Long = kotlin_kotlin.$_$.ne;
    var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
    var getKClass = kotlin_kotlin.$_$.e;
    var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
    var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
    var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
    var ToJsonDictionarySerializer_getInstance = kotlin_io_curity_ssi_core_json.$_$.i;
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var ToJson = kotlin_io_curity_ssi_core_json.$_$.u;
    var InstantIso8601Serializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
    var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
    var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
    var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var Companion_instance = kotlin_io_curity_ssi_core_json.$_$.e;
    var asSequence = kotlin_kotlin.$_$.y5;
    var map = kotlin_kotlin.$_$.ec;
    var toList = kotlin_kotlin.$_$.fc;
    var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
    var KtMap = kotlin_kotlin.$_$.r5;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var createInvariantKTypeProjection = kotlin_kotlin.$_$.a;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
    var MapDictionary = kotlin_io_curity_ssi_core.$_$.g;
    var DictionaryCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.b;
    var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.t;
    var StringCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.c;
    var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
    var DefaultJsonMultiValue_init_$Create$_0 = kotlin_io_curity_ssi_core_json.$_$.a;
    var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
    var getBooleanHashCode = kotlin_kotlin.$_$.ea;
    var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
    var toMutableMap = kotlin_kotlin.$_$.p8;
    var unwrapString = kotlin_io_curity_ssi_core_json.$_$.p1;
    var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
    var toMap = kotlin_kotlin.$_$.m8;
    var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var toJson = kotlin_io_curity_ssi_core_json.$_$.c1;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var lazy = kotlin_kotlin.$_$.qf;
    var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
    var get = kotlin_io_curity_ssi_core_json.$_$.q;
    var toJson_0 = kotlin_io_curity_ssi_core_json.$_$.s;
    var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
    var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
    var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
    var unwrapOptionalStringList = kotlin_io_curity_ssi_core_json.$_$.l1;
    var toJson_1 = kotlin_io_curity_ssi_core_json.$_$.y;
    var toJsons = kotlin_io_curity_ssi_core_json.$_$.x;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var CompositeFromJson = kotlin_io_curity_ssi_core_json.$_$.k;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var first = kotlin_kotlin.$_$.y6;
    var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
    var to = kotlin_kotlin.$_$.wf;
    var mapOf = kotlin_kotlin.$_$.r7;
    var mapOf_0 = kotlin_kotlin.$_$.q7;
    var TypedDictionaryFromJson = kotlin_io_curity_ssi_core_json.$_$.v;
    var DelegateSerializer = kotlin_io_curity_ssi_core_json.$_$.m;
    var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
    var JsonContentPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
    var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
    var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
    var DerivedSerializer = kotlin_io_curity_ssi_core_json.$_$.n;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
    var unwrapOptionalBoolean = kotlin_io_curity_ssi_core_json.$_$.g1;
    var toJson_2 = kotlin_io_curity_ssi_core_json.$_$.d1;
    var unwrapStringSet = kotlin_io_curity_ssi_core_json.$_$.o1;
    var unwrapOptionalJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.h1;
    var toJson_3 = kotlin_io_curity_ssi_core_json.$_$.z;
    var Companion_instance_0 = kotlin_io_curity_ssi_core_json.$_$.h;
    var getStringOrDefault = kotlin_io_curity_ssi_core_json.$_$.w;
    var unwrapStringList = kotlin_io_curity_ssi_core_json.$_$.n1;
    var unwrapMultiValueJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.f1;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var toJson_4 = kotlin_io_curity_ssi_core_json.$_$.b1;
    var IssuerObject = kotlin_io_curity_ssi_verifiable_credentials.$_$.d;
    var IssuerURI = kotlin_io_curity_ssi_verifiable_credentials.$_$.e;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var defineProp = kotlin_kotlin.$_$.aa;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var isBlank = kotlin_kotlin.$_$.uc;
    var toSet = kotlin_kotlin.$_$.r8;
    var toList_0 = kotlin_kotlin.$_$.k8;
    var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
    var contains = kotlin_kotlin.$_$.b6;
    var firstOrNull = kotlin_kotlin.$_$.v6;
    var Primitive = kotlin_io_curity_ssi_sd_jwt.$_$.i;
    var Locale = kotlin_io_curity_ssi_core.$_$.f;
    var Array_0 = kotlin_io_curity_ssi_sd_jwt.$_$.g;
    var Object_0 = kotlin_io_curity_ssi_sd_jwt.$_$.h;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(ValidatedCredentialResponse, "ValidatedCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: Companion_getInstance_5
    });
    initMetadataForInterface(ValidatedVcSdJwtCredentialResponse, "ValidatedVcSdJwtCredentialResponse", VOID, VOID, [
        ValidatedCredentialResponse
    ]);
    initMetadataForClass(DefaultValidatedVcSdJwtCredentialResponse, "DefaultValidatedVcSdJwtCredentialResponse", VOID, VOID, [
        ValidatedVcSdJwtCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_0
    });
    initMetadataForCompanion(Companion_0);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(ValidatedJwtVcJsonCredentialResponse, "ValidatedJwtVcJsonCredentialResponse", VOID, VOID, [
        ValidatedCredentialResponse
    ], VOID, VOID, {
        0: Companion_getInstance_6
    });
    initMetadataForClass(DidValidatedJwtVcJsonCredentialResponse, "DidValidatedJwtVcJsonCredentialResponse", VOID, VOID, [
        ValidatedJwtVcJsonCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_1
    });
    initMetadataForCompanion(Companion_1);
    initMetadataForObject($serializer_1, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForCompanion(Companion_2);
    initMetadataForObject($serializer_2, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonTxCode, "JsonTxCode", JsonTxCode, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_3
    });
    initMetadataForObject($serializer_3, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonAuthorizationCode, "JsonAuthorizationCode", JsonAuthorizationCode, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_2
    });
    initMetadataForClass(JsonPreAuthorizedCode, "JsonPreAuthorizedCode", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_4
    });
    initMetadataForCompanion(Companion_3);
    initMetadataForObject($serializer_4, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonGrants, "JsonGrants", JsonGrants, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_5
    });
    initMetadataForCompanion(Companion_4);
    initMetadataForObject($serializer_5, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonOffer, "JsonOffer", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_6
    });
    initMetadataForCompanion(Companion_5, VOID, [
        SerializerFactory
    ]);
    initMetadataForInterface(ValidatedLdpVcCredentialResponse, "ValidatedLdpVcCredentialResponse", VOID, VOID, [
        ValidatedCredentialResponse
    ]);
    initMetadataForInterface(ValidatedJwtVcJsonLdCredentialResponse, "ValidatedJwtVcJsonLdCredentialResponse", VOID, VOID, [
        ValidatedCredentialResponse
    ]);
    initMetadataForCompanion(Companion_6, VOID, [
        SerializerFactory
    ]);
    initMetadataForCompanion(Companion_7);
    initMetadataForObject($serializer_6, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonCredentialDefinition, "JsonCredentialDefinition", VOID, VOID, [
        ToJson
    ], VOID, VOID, {
        0: $serializer_getInstance_7
    });
    initMetadataForCompanion(Companion_8);
    initMetadataForObject($serializer_7, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonCredentialIssuer, "JsonCredentialIssuer", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_8
    });
    initMetadataForCompanion(Companion_9);
    initMetadataForObject($serializer_8, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(UserVerifiableCredential, "UserVerifiableCredential", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_9
    });
    initMetadataForCompanion(Companion_10);
    initMetadataForObject($serializer_9, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonCredentialIssuerMetadata, "JsonCredentialIssuerMetadata", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_10
    });
    initMetadataForInterface(JsonCredentialConfigurationsSupported, "JsonCredentialConfigurationsSupported", VOID, VOID, VOID, VOID, VOID, {
        0: JsonSupportedCredentialSerializer_getInstance
    });
    initMetadataForCompanion(Companion_11);
    initMetadataForClass(JsonIssuerDisplay, "JsonIssuerDisplay", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonIssuerDisplaySerializer_getInstance
    });
    initMetadataForCompanion(Companion_12);
    initMetadataForClass(JsonDisplayable, "JsonDisplayable", JsonDisplayable, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonDisplayableSerializer_getInstance
    });
    initMetadataForCompanion(Companion_13);
    initMetadataForClass(JsonLogo, "JsonLogo", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonLogoSerializer_getInstance
    });
    initMetadataForCompanion(Companion_14);
    initMetadataForClass(JsonCredentialDisplay, "JsonCredentialDisplay", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonCredentialDisplaySerializer_getInstance
    });
    initMetadataForCompanion(Companion_15);
    initMetadataForClass(DefaultJsonCredentialConfigurationsSupported, "DefaultJsonCredentialConfigurationsSupported", VOID, VOID, [
        JsonCredentialConfigurationsSupported,
        ToJsonDictionary
    ], VOID, VOID, {
        0: DefaultJsonSupportedCredentialSerializer_getInstance
    });
    initMetadataForCompanion(Companion_16);
    initMetadataForObject($serializer_10, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(DefaultCredentialResponseEncryption, "DefaultCredentialResponseEncryption", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_11
    });
    initMetadataForCompanion(Companion_17);
    initMetadataForClass(JsonImage, "JsonImage", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonImageSerializer_getInstance
    });
    initMetadataForCompanion(Companion_18);
    initMetadataForObject($serializer_11, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonProofTypesSupported, "JsonProofTypesSupported", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_12
    });
    initMetadataForCompanion(Companion_19);
    initMetadataForObject($serializer_12, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonOAuthMetadata, "JsonOAuthMetadata", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_13
    });
    initMetadataForCompanion(Companion_20, CompositeFromJson);
    initMetadataForClass(JwtProofOfPossession, "JwtProofOfPossession", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JwtProofOfPossessionSerializer_getInstance
    });
    initMetadataForCompanion(Companion_21);
    initMetadataForClass(JsonProofOfPossession, "JsonProofOfPossession", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonProofOfPossessionSerializer_getInstance
    });
    initMetadataForCompanion(Companion_22);
    initMetadataForClass(JsonProof, "JsonProof", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonProofSerializer_getInstance
    });
    initMetadataForCompanion(Companion_23);
    initMetadataForObject($serializer_13, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonDeferredCredentialResponse, "JsonDeferredCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_14
    });
    initMetadataForObject(ToJsonProofOfPossessionSerializer, "ToJsonProofOfPossessionSerializer", VOID, DelegateSerializer);
    initMetadataForObject(BasicCredentialSubjectSerializer, "BasicCredentialSubjectSerializer", VOID, JsonSerializer);
    initMetadataForObject(JwtProofOfPossessionSerializer, "JwtProofOfPossessionSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonProofOfPossessionSerializer, "JsonProofOfPossessionSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonProofSerializer, "JsonProofSerializer", VOID, JsonSerializer);
    initMetadataForObject(SerializableW3CVerifiableCredentialSerializer, "SerializableW3CVerifiableCredentialSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonCredentialStatusSerializer, "JsonCredentialStatusSerializer", VOID, JsonSerializer);
    initMetadataForClass(JsonIssuerSerializer$_objectSerializer$1, VOID, VOID, JsonSerializer);
    initMetadataForObject(JsonIssuerSerializer, "JsonIssuerSerializer", VOID, JsonContentPolymorphicSerializer);
    initMetadataForObject(JsonIssuerDisplaySerializer, "JsonIssuerDisplaySerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonDisplayableSerializer, "JsonDisplayableSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonLogoSerializer, "JsonLogoSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonCredentialDisplaySerializer, "JsonCredentialDisplaySerializer", VOID, JsonSerializer);
    initMetadataForObject(DefaultJsonSupportedCredentialSerializer, "DefaultJsonSupportedCredentialSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonImageSerializer, "JsonImageSerializer", VOID, JsonSerializer);
    initMetadataForClass(VerifiableCredentialResponseSerializer, "VerifiableCredentialResponseSerializer", VOID, JsonContentPolymorphicSerializer);
    initMetadataForCompanion(Companion_24);
    initMetadataForCompanion(Companion_25);
    initMetadataForClass(JsonClaims, "JsonClaims", VOID, VOID, [
        ToJsonDictionary
    ], VOID, VOID, {
        0: VcSdJwtAuthorizationDetailClaimsSerializer_getInstance
    });
    initMetadataForClass(JsonClaimsItem, "JsonClaimsItem", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: VcSdJwtAuthorizationDetailClaimsItemSerializer_getInstance
    });
    initMetadataForCompanion(Companion_26);
    initMetadataForObject($serializer_14, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(VcSdJwtAuthorizationDetail, "VcSdJwtAuthorizationDetail", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_15
    });
    initMetadataForCompanion(Companion_27);
    initMetadataForObject($serializer_15, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(VcSdJwtCredentialConfigurationsSupported, "VcSdJwtCredentialConfigurationsSupported", VOID, VOID, [
        JsonCredentialConfigurationsSupported
    ], VOID, VOID, {
        0: $serializer_getInstance_16
    });
    initMetadataForCompanion(Companion_28);
    initMetadataForClass(VcSdJwtClaimsMetadata, "VcSdJwtClaimsMetadata", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: VcSdJwtClaimsMetadataSerializer_getInstance
    });
    initMetadataForCompanion(Companion_29);
    initMetadataForClass(VcSdJwtClaimsEntryMetadata, "VcSdJwtClaimsEntryMetadata", VcSdJwtClaimsEntryMetadata, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: VcSdJwtClaimsMetadataEntrySerializer_getInstance
    });
    initMetadataForCompanion(Companion_30);
    initMetadataForObject($serializer_16, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(VcSdJwtVerifiableCredentialRequest, "VcSdJwtVerifiableCredentialRequest", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_17
    });
    initMetadataForCompanion(Companion_31);
    initMetadataForObject($serializer_17, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(VcSdJwtCredentialResponse, "VcSdJwtCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: VcSdJwtCredentialResponseSerializer_getInstance
    });
    initMetadataForClass(VcSdJwtVerifiableCredentialResponse, "VcSdJwtVerifiableCredentialResponse", VOID, VOID, [
        VcSdJwtCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_18
    });
    initMetadataForObject(VcSdJwtClaimsMetadataSerializer, "VcSdJwtClaimsMetadataSerializer", VOID, JsonSerializer);
    initMetadataForObject(VcSdJwtClaimsMetadataEntrySerializer, "VcSdJwtClaimsMetadataEntrySerializer", VOID, JsonSerializer);
    initMetadataForObject(VcSdJwtAuthorizationDetailClaimsSerializer, "VcSdJwtAuthorizationDetailClaimsSerializer", VOID, JsonSerializer);
    initMetadataForObject(VcSdJwtAuthorizationDetailClaimsItemSerializer, "VcSdJwtAuthorizationDetailClaimsItemSerializer", VOID, JsonSerializer);
    initMetadataForCompanion(Companion_32);
    initMetadataForObject($serializer_18, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonAuthorizationDetail, "JwtVcJsonAuthorizationDetail", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_19
    });
    initMetadataForCompanion(Companion_33);
    initMetadataForCompanion(Companion_34);
    initMetadataForClass(JsonCredentialSubject, "JsonCredentialSubject", VOID, VOID, [
        ToJsonDictionary
    ], VOID, VOID, {
        0: JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance
    });
    initMetadataForClass(JsonCredentialSubjectItem, "JsonCredentialSubjectItem", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_getInstance
    });
    initMetadataForCompanion(Companion_35);
    initMetadataForObject($serializer_19, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonAuthorizationDetailsCredentialDefinition, "JwtVcJsonAuthorizationDetailsCredentialDefinition", JwtVcJsonAuthorizationDetailsCredentialDefinition, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_20
    });
    initMetadataForCompanion(Companion_36);
    initMetadataForObject($serializer_20, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonCredentialConfigurationsSupported, "JwtVcJsonCredentialConfigurationsSupported", VOID, VOID, [
        JsonCredentialConfigurationsSupported
    ], VOID, VOID, {
        0: $serializer_getInstance_21
    });
    initMetadataForCompanion(Companion_37);
    initMetadataForObject($serializer_21, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonMetadataCredentialDefinition, "JwtVcJsonMetadataCredentialDefinition", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_22
    });
    initMetadataForCompanion(Companion_38);
    initMetadataForClass(JwtVcJsonCredentialSubjectMetadata, "JwtVcJsonCredentialSubjectMetadata", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JwtVcJsonCredentialSubjectMetadataSerializer_getInstance
    });
    initMetadataForCompanion(Companion_39);
    initMetadataForClass(JwtVcJsonCredentialSubjectEntryMetadata, "JwtVcJsonCredentialSubjectEntryMetadata", JwtVcJsonCredentialSubjectEntryMetadata, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JwtVcJsonCredentialSubjectEntryMetadataSerializer_getInstance
    });
    initMetadataForCompanion(Companion_40);
    initMetadataForClass(CredentialDefinition, "CredentialDefinition", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance
    });
    initMetadataForCompanion(Companion_41);
    initMetadataForObject($serializer_22, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonVerifiableCredentialRequest, "JwtVcJsonVerifiableCredentialRequest", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_23
    });
    initMetadataForCompanion(Companion_42);
    initMetadataForObject($serializer_23, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JwtVcJsonLdVerifiableCredentialRequest, "JwtVcJsonLdVerifiableCredentialRequest", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_24
    });
    initMetadataForCompanion(Companion_43);
    initMetadataForObject($serializer_24, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(LdpVerifiableCredentialRequest, "LdpVerifiableCredentialRequest", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_25
    });
    initMetadataForCompanion(Companion_44, CompositeFromJson);
    initMetadataForClass(BasicCredentialSubject, "BasicCredentialSubject", VOID, VOID, [
        ToJsonDictionary
    ], VOID, VOID, {
        0: BasicCredentialSubjectSerializer_getInstance
    });
    initMetadataForCompanion(Companion_45);
    initMetadataForObject($serializer_25, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(JwtVcJsonCredentialResponse, "JwtVcJsonCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: JwtVcJsonCredentialResponseSerializer_getInstance
    });
    initMetadataForClass(JwtVcJsonVerifiableCredentialResponse, "JwtVcJsonVerifiableCredentialResponse", VOID, VOID, [
        JwtVcJsonCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_26
    });
    initMetadataForCompanion(Companion_46);
    initMetadataForObject($serializer_26, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(LdpVcCredentialResponse, "LdpVcCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: LdpVcCredentialResponseSerializer_getInstance
    });
    initMetadataForClass(LdpVcVerifiableCredentialResponse, "LdpVcVerifiableCredentialResponse", VOID, VOID, [
        LdpVcCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_27
    });
    initMetadataForCompanion(Companion_47);
    initMetadataForObject($serializer_27, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(JwtVcJsonLdCredentialResponse, "JwtVcJsonLdCredentialResponse", VOID, VOID, VOID, VOID, VOID, {
        0: JwtVcJsonLdCredentialResponseSerializer_getInstance
    });
    initMetadataForClass(JwtVcJsonLdVerifiableCredentialResponse, "JwtVcJsonLdVerifiableCredentialResponse", VOID, VOID, [
        JwtVcJsonLdCredentialResponse
    ], VOID, VOID, {
        0: $serializer_getInstance_28
    });
    initMetadataForCompanion(Companion_48);
    initMetadataForClass(Deferred, "Deferred", VOID, VOID, [
        JwtVcJsonCredentialResponse
    ], VOID, VOID, {
        0: DeferredJwtVcJsonCredentialResponseSerializer_getInstance
    });
    initMetadataForCompanion(Companion_49);
    initMetadataForClass(Deferred_0, "Deferred", VOID, VOID, [
        LdpVcCredentialResponse
    ], VOID, VOID, {
        0: DeferredLdpVcCredentialResponseSerializer_getInstance
    });
    initMetadataForCompanion(Companion_50);
    initMetadataForClass(Deferred_1, "Deferred", VOID, VOID, [
        JwtVcJsonLdCredentialResponse
    ], VOID, VOID, {
        0: DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance
    });
    initMetadataForCompanion(Companion_51);
    initMetadataForClass(Deferred_2, "Deferred", VOID, VOID, [
        VcSdJwtCredentialResponse
    ], VOID, VOID, {
        0: DeferredVcSdJwtCredentialResponseSerializer_getInstance
    });
    initMetadataForObject(JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer, "JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer", VOID, JsonSerializer);
    initMetadataForObject(DeferredJwtVcJsonCredentialResponseSerializer, "DeferredJwtVcJsonCredentialResponseSerializer", VOID, DerivedSerializer);
    initMetadataForObject(JwtVcJsonCredentialResponseSerializer, "JwtVcJsonCredentialResponseSerializer", VOID, VerifiableCredentialResponseSerializer);
    initMetadataForObject(DeferredLdpVcCredentialResponseSerializer, "DeferredLdpVcCredentialResponseSerializer", VOID, DerivedSerializer);
    initMetadataForObject(LdpVcCredentialResponseSerializer, "LdpVcCredentialResponseSerializer", VOID, VerifiableCredentialResponseSerializer);
    initMetadataForObject(DeferredJwtVcJsonLdCredentialResponseSerializer, "DeferredJwtVcJsonLdCredentialResponseSerializer", VOID, DerivedSerializer);
    initMetadataForObject(JwtVcJsonLdCredentialResponseSerializer, "JwtVcJsonLdCredentialResponseSerializer", VOID, VerifiableCredentialResponseSerializer);
    initMetadataForObject(JsonSupportedCredentialSerializer, "JsonSupportedCredentialSerializer", VOID, JsonContentPolymorphicSerializer);
    initMetadataForObject(JwtVcJsonCredentialSubjectMetadataSerializer, "JwtVcJsonCredentialSubjectMetadataSerializer", VOID, JsonSerializer);
    initMetadataForObject(JwtVcJsonCredentialSubjectEntryMetadataSerializer, "JwtVcJsonCredentialSubjectEntryMetadataSerializer", VOID, JsonSerializer);
    initMetadataForObject(VcSdJwtCredentialResponseSerializer, "VcSdJwtCredentialResponseSerializer", VOID, VerifiableCredentialResponseSerializer);
    initMetadataForObject(DeferredVcSdJwtCredentialResponseSerializer, "DeferredVcSdJwtCredentialResponseSerializer", VOID, DerivedSerializer);
    initMetadataForObject(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer, "JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer", VOID, JsonSerializer);
    initMetadataForObject(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer, "JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer", VOID, JsonSerializer);
    initMetadataForCompanion(Companion_52);
    initMetadataForClass(SerializableW3CVerifiableCredential, "SerializableW3CVerifiableCredential", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: SerializableW3CVerifiableCredentialSerializer_getInstance
    });
    initMetadataForCompanion(Companion_53);
    initMetadataForClass(JsonCredentialStatus, "JsonCredentialStatus", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: JsonCredentialStatusSerializer_getInstance
    });
    initMetadataForCompanion(Companion_54);
    initMetadataForClass(JsonIssuer$IssuerObject$toIssuer$1, VOID, VOID, MapDictionary, [
        MapDictionary,
        IssuerObject
    ]);
    function toIssuer() {
        return this.q3c().f3c();
    }
    initMetadataForInterface(ToJsonIssuer, "ToJsonIssuer", VOID, VOID, [
        ToJson
    ]);
    function toJsonIssuer() {
        return this;
    }
    initMetadataForInterface(JsonIssuer, "JsonIssuer", VOID, VOID, [
        ToJsonIssuer
    ], VOID, VOID, {
        0: JsonIssuerSerializer_getInstance
    });
    initMetadataForClass(IssuerURI_0, "IssuerURI", VOID, VOID, [
        JsonIssuer
    ]);
    initMetadataForClass(IssuerObject_0, "IssuerObject", VOID, VOID, [
        JsonIssuer
    ]);
    initMetadataForCompanion(Companion_55);
    initMetadataForObject($serializer_28, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonPresentationSubmission, "JsonPresentationSubmission", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_29
    });
    initMetadataForCompanion(Companion_56);
    initMetadataForObject($serializer_29, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonDescriptorMapObject, "JsonDescriptorMapObject", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_30
    });
    initMetadataForCompanion(Companion_57);
    initMetadataForObject($serializer_30, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonPresentationDefinition, "JsonPresentationDefinition", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_31
    });
    initMetadataForObject($serializer_31, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonInputDescriptor, "JsonInputDescriptor", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_32
    });
    initMetadataForCompanion(Companion_58);
    initMetadataForObject($serializer_32, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonConstraints, "JsonConstraints", JsonConstraints, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_33
    });
    initMetadataForCompanion(Companion_59);
    initMetadataForObject($serializer_33, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonField, "JsonField", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_34
    });
    initMetadataForCompanion(Companion_60);
    initMetadataForClass(AbstractJsonFilter, "AbstractJsonFilter", VOID, VOID, VOID, VOID, VOID, {
        0: JsonFilterSerializer_getInstance
    });
    initMetadataForCompanion(Companion_61);
    initMetadataForObject($serializer_34, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonArrayContainsFilter, "JsonArrayContainsFilter", VOID, AbstractJsonFilter, VOID, VOID, VOID, {
        0: $serializer_getInstance_35
    });
    initMetadataForObject($serializer_35, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonContains, "JsonContains", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_36
    });
    initMetadataForCompanion(Companion_62);
    initMetadataForObject($serializer_36, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonStringFilter, "JsonStringFilter", VOID, AbstractJsonFilter, VOID, VOID, VOID, {
        0: $serializer_getInstance_37
    });
    initMetadataForCompanion(Companion_63);
    initMetadataForObject($serializer_37, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonFormat, "JsonFormat", JsonFormat, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: $serializer_getInstance_38
    });
    initMetadataForCompanion(Companion_64);
    initMetadataForObject($serializer_38, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonAlgFormat, "JsonAlgFormat", VOID, VOID, [
        ToJson
    ], VOID, VOID, {
        0: $serializer_getInstance_39
    });
    initMetadataForCompanion(Companion_65);
    initMetadataForObject($serializer_39, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonPathNested, "JsonPathNested", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_40
    });
    initMetadataForCompanion(Companion_66);
    initMetadataForObject($serializer_40, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonProofTypeFormat, "JsonProofTypeFormat", VOID, VOID, [
        ToJson
    ], VOID, VOID, {
        0: $serializer_getInstance_41
    });
    initMetadataForCompanion(Companion_67);
    initMetadataForObject($serializer_41, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonVcSdJwtAlgsFormat, "JsonVcSdJwtAlgsFormat", VOID, VOID, [
        ToJson
    ], VOID, VOID, {
        0: $serializer_getInstance_42
    });
    initMetadataForCompanion(Companion_68, VOID, [
        SerializerFactory
    ]);
    initMetadataForInterface(JsonVerifiablePresentation, "JsonVerifiablePresentation", VOID, VOID, [
        ToJson
    ], VOID, VOID, {
        0: JsonVerifiablePresentationSerializer_getInstance
    });
    initMetadataForClass(JsonStringVerifiablePresentation, "JsonStringVerifiablePresentation", VOID, VOID, [
        JsonVerifiablePresentation
    ]);
    initMetadataForClass(JsonDictionaryVerifiablePresentation, "JsonDictionaryVerifiablePresentation", VOID, VOID, [
        JsonVerifiablePresentation,
        ToJsonDictionary
    ]);
    initMetadataForCompanion(Companion_69);
    initMetadataForObject($serializer_42, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonVerifierDirectPostAuthorizationResponse, "JsonVerifierDirectPostAuthorizationResponse", JsonVerifierDirectPostAuthorizationResponse, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_43
    });
    initMetadataForObject(JsonFilterSerializer, "JsonFilterSerializer", VOID, JsonContentPolymorphicSerializer);
    initMetadataForObject(SerializableW3CVerifiablePresentationSerializer, "SerializableW3CVerifiablePresentationSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonVerifiablePresentationSerializer, "JsonVerifiablePresentationSerializer", VOID, JsonSerializer);
    initMetadataForCompanion(Companion_70);
    initMetadataForClass(SerializableW3CVerifiablePresentation, "SerializableW3CVerifiablePresentation", VOID, VOID, [
        ToJsonDictionary,
        Dictionary
    ], VOID, VOID, {
        0: SerializableW3CVerifiablePresentationSerializer_getInstance
    });
    initMetadataForCompanion(Companion_71);
    initMetadataForClass(Either, "Either");
    initMetadataForInterface(ToJsonString, "ToJsonString");
    initMetadataForClass(JSObject, "JSObject");
    initMetadataForClass(JSIssuerObject, "JSIssuerObject", VOID, JSObject);
    initMetadataForClass(JSProofObject, "JSProofObject", VOID, JSObject);
    initMetadataForClass(JSCredentialStatusObject, "JSCredentialStatusObject", VOID, JSObject);
    initMetadataForClass(JsPair, "JsPair");
    initMetadataForClass(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition, "JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition");
    initMetadataForClass(JSJwtVcJsonVerifiableCredentialRequest, "JSJwtVcJsonVerifiableCredentialRequest", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSJwtVcJsonLdVerifiableCredentialRequest, "JSJwtVcJsonLdVerifiableCredentialRequest", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSLdpVerifiableCredentialRequest, "JSLdpVerifiableCredentialRequest", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSDeferredJsonCredentialResponse, "JSDeferredJsonCredentialResponse", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSJwtVcJsonVerifiableCredentialResponse, "JSJwtVcJsonVerifiableCredentialResponse", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSLdpVerifiableCredentialResponse, "JSLdpVerifiableCredentialResponse", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForClass(JSJwtVcJsonLdVerifiableCredentialResponse, "JSJwtVcJsonLdVerifiableCredentialResponse", VOID, VOID, [
        ToJsonString
    ]);
    initMetadataForInterface(JsDisplayable, "JsDisplayable");
    initMetadataForInterface(JsIssuerDisplay, "JsIssuerDisplay", VOID, VOID, [
        JsDisplayable
    ]);
    initMetadataForInterface(JsDisplayableSet, "JsDisplayableSet");
    initMetadataForClass(JsServerMetadata, "JsServerMetadata");
    initMetadataForClass(JsDisplayableAdapter, "JsDisplayableAdapter", VOID, VOID, [
        JsDisplayable
    ]);
    initMetadataForClass(JsIssuerDisplayAdapter, "JsIssuerDisplayAdapter", VOID, VOID, [
        JsIssuerDisplay
    ]);
    initMetadataForClass(JsCredentialDisplayAdapter, "JsCredentialDisplayAdapter");
    initMetadataForClass(JsLogo, "JsLogo");
    initMetadataForClass(JsCredentialDisplay, "JsCredentialDisplay", VOID, VOID, [
        JsDisplayable
    ]);
    initMetadataForClass(JsCredentialIssuerSupportedCredential, "JsCredentialIssuerSupportedCredential");
    initMetadataForClass(JsCredentialStatus, "JsCredentialStatus");
    function getNestedDisclosures() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = [];
        this.buildNestedDisclosure(array);
        return array;
    }
    initMetadataForInterface(JsSdValue, "JsSdValue");
    initMetadataForClass(JsSdObject, "JsSdObject", VOID, VOID, [
        JsSdValue
    ]);
    initMetadataForClass(JsSdArray, "JsSdArray", VOID, VOID, [
        JsSdValue
    ]);
    initMetadataForClass(JsSdPrimitive, "JsSdPrimitive", VOID, VOID, [
        JsSdValue
    ]);
    initMetadataForClass(JsSdProperty, "JsSdProperty");
    initMetadataForClass(JsSdArrayValue, "JsSdArrayValue");
    initMetadataForClass(JsCredentialIssuer, "JsCredentialIssuer");
    initMetadataForClass(JsUserVerifiableCredential, "JsUserVerifiableCredential");
    initMetadataForClass(JsLdpVcJsonLdCredential, "JsLdpVcJsonLdCredential");
    initMetadataForClass(JSCredentialResponse, "JSCredentialResponse");
    initMetadataForClass(JsJwtVcJsonLdCredential, "JsJwtVcJsonLdCredential");
    initMetadataForClass(JsJwtVcJsonCredential, "JsJwtVcJsonCredential");
    initMetadataForClass(JsDidJwtVcJsonCredential, "JsDidJwtVcJsonCredential");
    initMetadataForClass(JsSelectivelyDiscloseableClaim, "JsSelectivelyDiscloseableClaim");
    initMetadataForClass(JsVcSdJwtCredential, "JsVcSdJwtCredential");
    initMetadataForClass(JsDisplayableSetAdapter, "JsDisplayableSetAdapter", VOID, VOID, [
        JsDisplayableSet
    ]);
    initMetadataForCompanion(Companion_72);
    initMetadataForClass(JSW3CVerifiableCredential, "JSW3CVerifiableCredential", VOID, VOID, [
        ToJsonString
    ]);
    //endregion
    function Companion() {
        Companion_instance_1 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q30_1 = [
            null,
            new LinkedHashMapSerializer(StringSerializer_getInstance(), new ArrayListSerializer(JsonDisplayableSerializer_getInstance())),
            new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()),
            null,
            null,
            null,
            null,
            null
        ];
    }
    var Companion_instance_1;
    function Companion_getInstance() {
        if (Companion_instance_1 == null) new Companion();
        return Companion_instance_1;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.DefaultValidatedVcSdJwtCredentialResponse", this, 8);
        tmp0_serialDesc.wy("response", false);
        tmp0_serialDesc.wy("claimDisplayables", false);
        tmp0_serialDesc.wy("credentialDisplay", false);
        tmp0_serialDesc.wy("credential", false);
        tmp0_serialDesc.wy("issuer", false);
        tmp0_serialDesc.wy("vct", false);
        tmp0_serialDesc.wy("customClaims", false);
        tmp0_serialDesc.wy("kid", false);
        this.r30_1 = tmp0_serialDesc;
    }
    protoOf($serializer).s30 = function(encoder, value) {
        var tmp0_desc = this.r30_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance().q30_1;
        tmp1_output.bt(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), value.t30_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.u30_1);
        tmp1_output.dt(tmp0_desc, 2, tmp2_cached[2], value.v30_1);
        tmp1_output.zs(tmp0_desc, 3, value.w30_1);
        tmp1_output.zs(tmp0_desc, 4, value.x30_1);
        tmp1_output.zs(tmp0_desc, 5, value.y30_1);
        tmp1_output.bt(tmp0_desc, 6, $serializer_getInstance(), value.z30_1);
        tmp1_output.zs(tmp0_desc, 7, value.a31_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.s30(encoder, value instanceof DefaultValidatedVcSdJwtCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.r30_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.lr(tmp0_desc);
        var tmp13_cached = Companion_getInstance().q30_1;
        if (tmp12_input.as()) {
            tmp4_local0 = tmp12_input.xr(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp12_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp12_input.vr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp12_input.vr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp12_input.xr(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp12_input.vr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else while(tmp1_flag){
            tmp2_index = tmp12_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp12_input.xr(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp12_input.vr(tmp0_desc, 3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp12_input.vr(tmp0_desc, 4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp12_input.vr(tmp0_desc, 5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp12_input.xr(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp12_input.vr(tmp0_desc, 7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp12_input.mr(tmp0_desc);
        return DefaultValidatedVcSdJwtCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
    };
    protoOf($serializer).yn = function() {
        return this.r30_1;
    };
    protoOf($serializer).lz = function() {
        var tmp0_cached = Companion_getInstance().q30_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            VcSdJwtCredentialResponseSerializer_getInstance(),
            tmp0_cached[1],
            get_nullable(tmp0_cached[2]),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            $serializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance_0() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function DefaultValidatedVcSdJwtCredentialResponse_init_$Init$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker, $this) {
        if (!(255 === (255 & seen0))) throwMissingFieldException(seen0, 255, $serializer_getInstance_0().r30_1);
        $this.t30_1 = response;
        $this.u30_1 = claimDisplayables;
        $this.v30_1 = credentialDisplay;
        $this.w30_1 = credential;
        $this.x30_1 = issuer;
        $this.y30_1 = vct;
        $this.z30_1 = customClaims;
        $this.a31_1 = kid;
        return $this;
    }
    function DefaultValidatedVcSdJwtCredentialResponse_init_$Create$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker) {
        return DefaultValidatedVcSdJwtCredentialResponse_init_$Init$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker, objectCreate(protoOf(DefaultValidatedVcSdJwtCredentialResponse)));
    }
    function DefaultValidatedVcSdJwtCredentialResponse(response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid) {
        Companion_getInstance();
        this.t30_1 = response;
        this.u30_1 = claimDisplayables;
        this.v30_1 = credentialDisplay;
        this.w30_1 = credential;
        this.x30_1 = issuer;
        this.y30_1 = vct;
        this.z30_1 = customClaims;
        this.a31_1 = kid;
    }
    function Companion_0() {
        Companion_instance_2 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b31_1 = [
            null,
            null,
            null,
            new LinkedHashMapSerializer(StringSerializer_getInstance(), new ArrayListSerializer(JsonDisplayableSerializer_getInstance())),
            new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance())
        ];
    }
    var Companion_instance_2;
    function Companion_getInstance_0() {
        if (Companion_instance_2 == null) new Companion_0();
        return Companion_instance_2;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.DidValidatedJwtVcJsonCredentialResponse", this, 5);
        tmp0_serialDesc.wy("response", false);
        tmp0_serialDesc.wy("credentialJwt", false);
        tmp0_serialDesc.wy("w3cCredential", false);
        tmp0_serialDesc.wy("claimDisplayables", false);
        tmp0_serialDesc.wy("credentialDisplay", false);
        this.c31_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).d31 = function(encoder, value) {
        var tmp0_desc = this.c31_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().b31_1;
        tmp1_output.bt(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), value.e31_1);
        tmp1_output.zs(tmp0_desc, 1, value.f31_1);
        tmp1_output.bt(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), value.g31_1);
        tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.h31_1);
        tmp1_output.dt(tmp0_desc, 4, tmp2_cached[4], value.i31_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.d31(encoder, value instanceof DidValidatedJwtVcJsonCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.c31_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        var tmp10_cached = Companion_getInstance_0().b31_1;
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return DidValidatedJwtVcJsonCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.c31_1;
    };
    protoOf($serializer_0).lz = function() {
        var tmp0_cached = Companion_getInstance_0().b31_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            JwtVcJsonCredentialResponseSerializer_getInstance(),
            StringSerializer_getInstance(),
            SerializableW3CVerifiableCredentialSerializer_getInstance(),
            tmp0_cached[3],
            get_nullable(tmp0_cached[4])
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_1() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function DidValidatedJwtVcJsonCredentialResponse_init_$Init$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker, $this) {
        if (!(31 === (31 & seen0))) throwMissingFieldException(seen0, 31, $serializer_getInstance_1().c31_1);
        $this.e31_1 = response;
        $this.f31_1 = credentialJwt;
        $this.g31_1 = w3cCredential;
        $this.h31_1 = claimDisplayables;
        $this.i31_1 = credentialDisplay;
        return $this;
    }
    function DidValidatedJwtVcJsonCredentialResponse_init_$Create$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker) {
        return DidValidatedJwtVcJsonCredentialResponse_init_$Init$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker, objectCreate(protoOf(DidValidatedJwtVcJsonCredentialResponse)));
    }
    function DidValidatedJwtVcJsonCredentialResponse(response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay) {
        Companion_getInstance_0();
        this.e31_1 = response;
        this.f31_1 = credentialJwt;
        this.g31_1 = w3cCredential;
        this.h31_1 = claimDisplayables;
        this.i31_1 = credentialDisplay;
    }
    protoOf(DidValidatedJwtVcJsonCredentialResponse).j31 = function() {
        return this.e31_1;
    };
    protoOf(DidValidatedJwtVcJsonCredentialResponse).k31 = function() {
        return this.f31_1;
    };
    protoOf(DidValidatedJwtVcJsonCredentialResponse).toString = function() {
        return "DidValidatedJwtVcJsonCredentialResponse(response=" + toString(this.e31_1) + ", credentialJwt=" + this.f31_1 + ", w3cCredential=" + this.g31_1.toString() + ", claimDisplayables=" + toString(this.h31_1) + ", credentialDisplay=" + toString_0(this.i31_1) + ")";
    };
    protoOf(DidValidatedJwtVcJsonCredentialResponse).hashCode = function() {
        var result = hashCode(this.e31_1);
        result = imul(result, 31) + getStringHashCode(this.f31_1) | 0;
        result = imul(result, 31) + this.g31_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.h31_1) | 0;
        result = imul(result, 31) + (this.i31_1 == null ? 0 : hashCode(this.i31_1)) | 0;
        return result;
    };
    protoOf(DidValidatedJwtVcJsonCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DidValidatedJwtVcJsonCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof DidValidatedJwtVcJsonCredentialResponse ? other : THROW_CCE();
        if (!equals(this.e31_1, tmp0_other_with_cast.e31_1)) return false;
        if (!(this.f31_1 === tmp0_other_with_cast.f31_1)) return false;
        if (!this.g31_1.equals(tmp0_other_with_cast.g31_1)) return false;
        if (!equals(this.h31_1, tmp0_other_with_cast.h31_1)) return false;
        if (!equals(this.i31_1, tmp0_other_with_cast.i31_1)) return false;
        return true;
    };
    function Companion_1() {}
    var Companion_instance_3;
    function Companion_getInstance_1() {
        return Companion_instance_3;
    }
    function $serializer_1() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOffer.JsonGrants.JsonAuthorizationCode", this, 2);
        tmp0_serialDesc.wy("issuer_state", true);
        tmp0_serialDesc.wy("authorization_server", true);
        this.l31_1 = tmp0_serialDesc;
    }
    protoOf($serializer_1).m31 = function(encoder, value) {
        var tmp0_desc = this.l31_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.n31_1 == null)) tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.n31_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.o31_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.o31_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_1).zn = function(encoder, value) {
        return this.m31(encoder, value instanceof JsonAuthorizationCode ? value : THROW_CCE());
    };
    protoOf($serializer_1).ao = function(decoder) {
        var tmp0_desc = this.l31_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonAuthorizationCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_1).yn = function() {
        return this.l31_1;
    };
    protoOf($serializer_1).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_1;
    function $serializer_getInstance_2() {
        if ($serializer_instance_1 == null) new $serializer_1();
        return $serializer_instance_1;
    }
    function JsonAuthorizationCode_init_$Init$(seen0, issuerState, authorizationServer, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_2().l31_1);
        if (0 === (seen0 & 1)) $this.n31_1 = null;
        else $this.n31_1 = issuerState;
        if (0 === (seen0 & 2)) $this.o31_1 = null;
        else $this.o31_1 = authorizationServer;
        return $this;
    }
    function JsonAuthorizationCode_init_$Create$(seen0, issuerState, authorizationServer, serializationConstructorMarker) {
        return JsonAuthorizationCode_init_$Init$(seen0, issuerState, authorizationServer, serializationConstructorMarker, objectCreate(protoOf(JsonAuthorizationCode)));
    }
    function Companion_2() {}
    var Companion_instance_4;
    function Companion_getInstance_2() {
        return Companion_instance_4;
    }
    function $serializer_2() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOffer.JsonGrants.JsonPreAuthorizedCode.JsonTxCode", this, 3);
        tmp0_serialDesc.wy("input_mode", true);
        tmp0_serialDesc.wy("length", true);
        tmp0_serialDesc.wy("description", true);
        this.p31_1 = tmp0_serialDesc;
    }
    protoOf($serializer_2).q31 = function(encoder, value) {
        var tmp0_desc = this.p31_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.r31_1 == null)) tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.r31_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.s31_1 == null)) tmp1_output.dt(tmp0_desc, 1, IntSerializer_getInstance(), value.s31_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.t31_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.t31_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_2).zn = function(encoder, value) {
        return this.q31(encoder, value instanceof JsonTxCode ? value : THROW_CCE());
    };
    protoOf($serializer_2).ao = function(decoder) {
        var tmp0_desc = this.p31_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonTxCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_2).yn = function() {
        return this.p31_1;
    };
    protoOf($serializer_2).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(StringSerializer_getInstance()),
            get_nullable(IntSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_2;
    function $serializer_getInstance_3() {
        if ($serializer_instance_2 == null) new $serializer_2();
        return $serializer_instance_2;
    }
    function JsonTxCode_init_$Init$(seen0, inputMode, length, description, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_3().p31_1);
        if (0 === (seen0 & 1)) $this.r31_1 = null;
        else $this.r31_1 = inputMode;
        if (0 === (seen0 & 2)) $this.s31_1 = null;
        else $this.s31_1 = length;
        if (0 === (seen0 & 4)) $this.t31_1 = null;
        else $this.t31_1 = description;
        return $this;
    }
    function JsonTxCode_init_$Create$(seen0, inputMode, length, description, serializationConstructorMarker) {
        return JsonTxCode_init_$Init$(seen0, inputMode, length, description, serializationConstructorMarker, objectCreate(protoOf(JsonTxCode)));
    }
    function JsonTxCode(inputMode, length, description) {
        inputMode = inputMode === VOID ? null : inputMode;
        length = length === VOID ? null : length;
        description = description === VOID ? null : description;
        this.r31_1 = inputMode;
        this.s31_1 = length;
        this.t31_1 = description;
    }
    protoOf(JsonTxCode).toString = function() {
        return "JsonTxCode(inputMode=" + this.r31_1 + ", length=" + this.s31_1 + ", description=" + this.t31_1 + ")";
    };
    protoOf(JsonTxCode).hashCode = function() {
        var result = this.r31_1 == null ? 0 : getStringHashCode(this.r31_1);
        result = imul(result, 31) + (this.s31_1 == null ? 0 : this.s31_1) | 0;
        result = imul(result, 31) + (this.t31_1 == null ? 0 : getStringHashCode(this.t31_1)) | 0;
        return result;
    };
    protoOf(JsonTxCode).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonTxCode)) return false;
        var tmp0_other_with_cast = other instanceof JsonTxCode ? other : THROW_CCE();
        if (!(this.r31_1 == tmp0_other_with_cast.r31_1)) return false;
        if (!(this.s31_1 == tmp0_other_with_cast.s31_1)) return false;
        if (!(this.t31_1 == tmp0_other_with_cast.t31_1)) return false;
        return true;
    };
    function $serializer_3() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOffer.JsonGrants.JsonPreAuthorizedCode", this, 4);
        tmp0_serialDesc.wy("pre-authorized_code", false);
        tmp0_serialDesc.wy("tx_code", true);
        tmp0_serialDesc.wy("interval", true);
        tmp0_serialDesc.wy("authorization_server", true);
        this.u31_1 = tmp0_serialDesc;
    }
    protoOf($serializer_3).v31 = function(encoder, value) {
        var tmp0_desc = this.u31_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.w31_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.x31_1 == null)) tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_3(), value.x31_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !value.y31_1.equals(new Long(5, 0))) tmp1_output.vs(tmp0_desc, 2, value.y31_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.z31_1 == null)) tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.z31_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_3).zn = function(encoder, value) {
        return this.v31(encoder, value instanceof JsonPreAuthorizedCode ? value : THROW_CCE());
    };
    protoOf($serializer_3).ao = function(decoder) {
        var tmp0_desc = this.u31_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = new Long(0, 0);
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.rr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.rr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return JsonPreAuthorizedCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_3).yn = function() {
        return this.u31_1;
    };
    protoOf($serializer_3).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable($serializer_getInstance_3()),
            LongSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_3;
    function $serializer_getInstance_4() {
        if ($serializer_instance_3 == null) new $serializer_3();
        return $serializer_instance_3;
    }
    function JsonPreAuthorizedCode_init_$Init$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_4().u31_1);
        $this.w31_1 = preAuthorizedCode;
        if (0 === (seen0 & 2)) $this.x31_1 = null;
        else $this.x31_1 = txCode;
        if (0 === (seen0 & 4)) $this.y31_1 = new Long(5, 0);
        else $this.y31_1 = interval;
        if (0 === (seen0 & 8)) $this.z31_1 = null;
        else $this.z31_1 = authorizationServer;
        return $this;
    }
    function JsonPreAuthorizedCode_init_$Create$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker) {
        return JsonPreAuthorizedCode_init_$Init$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker, objectCreate(protoOf(JsonPreAuthorizedCode)));
    }
    function JsonAuthorizationCode(issuerState, authorizationServer) {
        issuerState = issuerState === VOID ? null : issuerState;
        authorizationServer = authorizationServer === VOID ? null : authorizationServer;
        this.n31_1 = issuerState;
        this.o31_1 = authorizationServer;
    }
    protoOf(JsonAuthorizationCode).toString = function() {
        return "JsonAuthorizationCode(issuerState=" + this.n31_1 + ", authorizationServer=" + this.o31_1 + ")";
    };
    protoOf(JsonAuthorizationCode).hashCode = function() {
        var result = this.n31_1 == null ? 0 : getStringHashCode(this.n31_1);
        result = imul(result, 31) + (this.o31_1 == null ? 0 : getStringHashCode(this.o31_1)) | 0;
        return result;
    };
    protoOf(JsonAuthorizationCode).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonAuthorizationCode)) return false;
        var tmp0_other_with_cast = other instanceof JsonAuthorizationCode ? other : THROW_CCE();
        if (!(this.n31_1 == tmp0_other_with_cast.n31_1)) return false;
        if (!(this.o31_1 == tmp0_other_with_cast.o31_1)) return false;
        return true;
    };
    function JsonPreAuthorizedCode() {}
    protoOf(JsonPreAuthorizedCode).toString = function() {
        return "JsonPreAuthorizedCode(preAuthorizedCode=" + this.w31_1 + ", txCode=" + toString_0(this.x31_1) + ", interval=" + this.y31_1.toString() + ", authorizationServer=" + this.z31_1 + ")";
    };
    protoOf(JsonPreAuthorizedCode).hashCode = function() {
        var result = getStringHashCode(this.w31_1);
        result = imul(result, 31) + (this.x31_1 == null ? 0 : this.x31_1.hashCode()) | 0;
        result = imul(result, 31) + this.y31_1.hashCode() | 0;
        result = imul(result, 31) + (this.z31_1 == null ? 0 : getStringHashCode(this.z31_1)) | 0;
        return result;
    };
    protoOf(JsonPreAuthorizedCode).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonPreAuthorizedCode)) return false;
        var tmp0_other_with_cast = other instanceof JsonPreAuthorizedCode ? other : THROW_CCE();
        if (!(this.w31_1 === tmp0_other_with_cast.w31_1)) return false;
        if (!equals(this.x31_1, tmp0_other_with_cast.x31_1)) return false;
        if (!this.y31_1.equals(tmp0_other_with_cast.y31_1)) return false;
        if (!(this.z31_1 == tmp0_other_with_cast.z31_1)) return false;
        return true;
    };
    function Companion_3() {}
    var Companion_instance_5;
    function Companion_getInstance_3() {
        return Companion_instance_5;
    }
    function $serializer_4() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOffer.JsonGrants", this, 2);
        tmp0_serialDesc.wy("authorization_code", true);
        tmp0_serialDesc.wy("urn:ietf:params:oauth:grant-type:pre-authorized_code", true);
        this.a32_1 = tmp0_serialDesc;
    }
    protoOf($serializer_4).b32 = function(encoder, value) {
        var tmp0_desc = this.a32_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.c32_1 == null)) tmp1_output.dt(tmp0_desc, 0, $serializer_getInstance_2(), value.c32_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d32_1 == null)) tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_4(), value.d32_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_4).zn = function(encoder, value) {
        return this.b32(encoder, value instanceof JsonGrants ? value : THROW_CCE());
    };
    protoOf($serializer_4).ao = function(decoder) {
        var tmp0_desc = this.a32_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonGrants_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_4).yn = function() {
        return this.a32_1;
    };
    protoOf($serializer_4).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable($serializer_getInstance_2()),
            get_nullable($serializer_getInstance_4())
        ];
    };
    var $serializer_instance_4;
    function $serializer_getInstance_5() {
        if ($serializer_instance_4 == null) new $serializer_4();
        return $serializer_instance_4;
    }
    function JsonGrants_init_$Init$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_5().a32_1);
        if (0 === (seen0 & 1)) $this.c32_1 = null;
        else $this.c32_1 = authorizationCode;
        if (0 === (seen0 & 2)) $this.d32_1 = null;
        else $this.d32_1 = preAuthorizedCode;
        return $this;
    }
    function JsonGrants_init_$Create$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker) {
        return JsonGrants_init_$Init$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker, objectCreate(protoOf(JsonGrants)));
    }
    function JsonGrants(authorizationCode, preAuthorizedCode) {
        authorizationCode = authorizationCode === VOID ? null : authorizationCode;
        preAuthorizedCode = preAuthorizedCode === VOID ? null : preAuthorizedCode;
        this.c32_1 = authorizationCode;
        this.d32_1 = preAuthorizedCode;
    }
    protoOf(JsonGrants).toString = function() {
        return "JsonGrants(authorizationCode=" + toString_0(this.c32_1) + ", preAuthorizedCode=" + toString_0(this.d32_1) + ")";
    };
    protoOf(JsonGrants).hashCode = function() {
        var result = this.c32_1 == null ? 0 : this.c32_1.hashCode();
        result = imul(result, 31) + (this.d32_1 == null ? 0 : this.d32_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonGrants).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonGrants)) return false;
        var tmp0_other_with_cast = other instanceof JsonGrants ? other : THROW_CCE();
        if (!equals(this.c32_1, tmp0_other_with_cast.c32_1)) return false;
        if (!equals(this.d32_1, tmp0_other_with_cast.d32_1)) return false;
        return true;
    };
    function Companion_4() {
        Companion_instance_6 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e32_1 = [
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            null
        ];
    }
    var Companion_instance_6;
    function Companion_getInstance_4() {
        if (Companion_instance_6 == null) new Companion_4();
        return Companion_instance_6;
    }
    function $serializer_5() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOffer", this, 3);
        tmp0_serialDesc.wy("credential_issuer", false);
        tmp0_serialDesc.wy("credential_configuration_ids", false);
        tmp0_serialDesc.wy("grants", true);
        this.f32_1 = tmp0_serialDesc;
    }
    protoOf($serializer_5).g32 = function(encoder, value) {
        var tmp0_desc = this.f32_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().e32_1;
        tmp1_output.zs(tmp0_desc, 0, value.h32_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.i32_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.j32_1 == null)) tmp1_output.dt(tmp0_desc, 2, $serializer_getInstance_5(), value.j32_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_5).zn = function(encoder, value) {
        return this.g32(encoder, value instanceof JsonOffer ? value : THROW_CCE());
    };
    protoOf($serializer_5).ao = function(decoder) {
        var tmp0_desc = this.f32_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        var tmp8_cached = Companion_getInstance_4().e32_1;
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_5).yn = function() {
        return this.f32_1;
    };
    protoOf($serializer_5).lz = function() {
        var tmp0_cached = Companion_getInstance_4().e32_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            tmp0_cached[1],
            get_nullable($serializer_getInstance_5())
        ];
    };
    var $serializer_instance_5;
    function $serializer_getInstance_6() {
        if ($serializer_instance_5 == null) new $serializer_5();
        return $serializer_instance_5;
    }
    function JsonOffer_init_$Init$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_6().f32_1);
        $this.h32_1 = credentialIssuer;
        $this.i32_1 = credentialConfigurationIds;
        if (0 === (seen0 & 4)) $this.j32_1 = null;
        else $this.j32_1 = grants;
        return $this;
    }
    function JsonOffer_init_$Create$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker) {
        return JsonOffer_init_$Init$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker, objectCreate(protoOf(JsonOffer)));
    }
    function JsonOffer(credentialIssuer, credentialConfigurationIds, grants) {
        Companion_getInstance_4();
        grants = grants === VOID ? null : grants;
        this.h32_1 = credentialIssuer;
        this.i32_1 = credentialConfigurationIds;
        this.j32_1 = grants;
    }
    protoOf(JsonOffer).toString = function() {
        return "JsonOffer(credentialIssuer=" + this.h32_1 + ", credentialConfigurationIds=" + toString(this.i32_1) + ", grants=" + toString_0(this.j32_1) + ")";
    };
    protoOf(JsonOffer).hashCode = function() {
        var result = getStringHashCode(this.h32_1);
        result = imul(result, 31) + hashCode(this.i32_1) | 0;
        result = imul(result, 31) + (this.j32_1 == null ? 0 : this.j32_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonOffer).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonOffer)) return false;
        var tmp0_other_with_cast = other instanceof JsonOffer ? other : THROW_CCE();
        if (!(this.h32_1 === tmp0_other_with_cast.h32_1)) return false;
        if (!equals(this.i32_1, tmp0_other_with_cast.i32_1)) return false;
        if (!equals(this.j32_1, tmp0_other_with_cast.j32_1)) return false;
        return true;
    };
    function Companion_5() {}
    protoOf(Companion_5).b1b = function() {
        var tmp = getKClass(ValidatedCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [
            getKClass(DidValidatedJwtVcJsonCredentialResponse),
            getKClass(ValidatedJwtVcJsonLdCredentialResponse),
            getKClass(ValidatedLdpVcCredentialResponse),
            getKClass(DefaultValidatedVcSdJwtCredentialResponse)
        ];
        // Inline function 'kotlin.arrayOf' call
        var tmp_1 = $serializer_getInstance_1();
        var tmp_2 = getKClass(ValidatedJwtVcJsonLdCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        var tmp_3 = PolymorphicSerializer_init_$Create$(tmp_2, tmp$ret$5);
        var tmp_4 = getKClass(ValidatedLdpVcCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_5 = [
            tmp_1,
            tmp_3,
            PolymorphicSerializer_init_$Create$(tmp_4, tmp$ret$8),
            $serializer_getInstance_0()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$14 = [];
        return SealedClassSerializer_init_$Create$("io.curity.vc.serialization.ValidatedCredentialResponse", tmp, tmp_0, tmp_5, tmp$ret$14);
    };
    protoOf(Companion_5).wz = function(typeParamsSerializers) {
        return this.b1b();
    };
    var Companion_instance_7;
    function Companion_getInstance_5() {
        return Companion_instance_7;
    }
    function ValidatedCredentialResponse() {}
    function ValidatedLdpVcCredentialResponse() {}
    function ValidatedJwtVcJsonLdCredentialResponse() {}
    function Companion_6() {}
    protoOf(Companion_6).b1b = function() {
        var tmp = getKClass(ValidatedJwtVcJsonCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [
            getKClass(DidValidatedJwtVcJsonCredentialResponse)
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [
            $serializer_getInstance_1()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        return SealedClassSerializer_init_$Create$("io.curity.vc.serialization.ValidatedJwtVcJsonCredentialResponse", tmp, tmp_0, tmp_1, tmp$ret$8);
    };
    protoOf(Companion_6).wz = function(typeParamsSerializers) {
        return this.b1b();
    };
    var Companion_instance_8;
    function Companion_getInstance_6() {
        return Companion_instance_8;
    }
    function ValidatedJwtVcJsonCredentialResponse() {}
    function ValidatedVcSdJwtCredentialResponse() {}
    function Companion_7() {
        Companion_instance_9 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l32_1 = [
            new ArrayListSerializer(StringSerializer_getInstance()),
            new LinkedHashSetSerializer(StringSerializer_getInstance()),
            null
        ];
    }
    protoOf(Companion_7).b1b = function() {
        return $serializer_getInstance_7();
    };
    var Companion_instance_9;
    function Companion_getInstance_7() {
        if (Companion_instance_9 == null) new Companion_7();
        return Companion_instance_9;
    }
    function $serializer_6() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonCredentialDefinition", this, 3);
        tmp0_serialDesc.wy("@context", false);
        tmp0_serialDesc.wy("types", false);
        tmp0_serialDesc.wy("credentialSubject", false);
        this.m32_1 = tmp0_serialDesc;
    }
    protoOf($serializer_6).n32 = function(encoder, value) {
        var tmp0_desc = this.m32_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().l32_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.o32_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.p32_1);
        tmp1_output.bt(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), value.q32_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_6).zn = function(encoder, value) {
        return this.n32(encoder, value instanceof JsonCredentialDefinition ? value : THROW_CCE());
    };
    protoOf($serializer_6).ao = function(decoder) {
        var tmp0_desc = this.m32_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        var tmp8_cached = Companion_getInstance_7().l32_1;
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_6).yn = function() {
        return this.m32_1;
    };
    protoOf($serializer_6).lz = function() {
        var tmp0_cached = Companion_getInstance_7().l32_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            tmp0_cached[0],
            tmp0_cached[1],
            ToJsonDictionarySerializer_getInstance()
        ];
    };
    var $serializer_instance_6;
    function $serializer_getInstance_7() {
        if ($serializer_instance_6 == null) new $serializer_6();
        return $serializer_instance_6;
    }
    function JsonCredentialDefinition_init_$Init$(seen0, context, types, credentialSubject, serializationConstructorMarker, $this) {
        if (!(7 === (7 & seen0))) throwMissingFieldException(seen0, 7, $serializer_getInstance_7().m32_1);
        $this.o32_1 = context;
        $this.p32_1 = types;
        $this.q32_1 = credentialSubject;
        return $this;
    }
    function JsonCredentialDefinition_init_$Create$(seen0, context, types, credentialSubject, serializationConstructorMarker) {
        return JsonCredentialDefinition_init_$Init$(seen0, context, types, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialDefinition)));
    }
    function JsonCredentialDefinition(context, types, credentialSubject) {
        Companion_getInstance_7();
        this.o32_1 = context;
        this.p32_1 = types;
        this.q32_1 = credentialSubject;
    }
    protoOf(JsonCredentialDefinition).a27 = function() {
        return Default_getInstance().a19(Companion_getInstance_7().b1b(), this);
    };
    protoOf(JsonCredentialDefinition).toString = function() {
        return "JsonCredentialDefinition(context=" + toString(this.o32_1) + ", types=" + toString(this.p32_1) + ", credentialSubject=" + toString(this.q32_1) + ")";
    };
    protoOf(JsonCredentialDefinition).hashCode = function() {
        var result = hashCode(this.o32_1);
        result = imul(result, 31) + hashCode(this.p32_1) | 0;
        result = imul(result, 31) + hashCode(this.q32_1) | 0;
        return result;
    };
    protoOf(JsonCredentialDefinition).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialDefinition)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialDefinition ? other : THROW_CCE();
        if (!equals(this.o32_1, tmp0_other_with_cast.o32_1)) return false;
        if (!equals(this.p32_1, tmp0_other_with_cast.p32_1)) return false;
        if (!equals(this.q32_1, tmp0_other_with_cast.q32_1)) return false;
        return true;
    };
    function Companion_8() {}
    var Companion_instance_10;
    function Companion_getInstance_8() {
        return Companion_instance_10;
    }
    function $serializer_7() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonCredentialIssuer", this, 3);
        tmp0_serialDesc.wy("issuerMetadata", false);
        tmp0_serialDesc.wy("authorizationServerMetadata", false);
        tmp0_serialDesc.wy("lastUpdate", false);
        this.r32_1 = tmp0_serialDesc;
    }
    protoOf($serializer_7).s32 = function(encoder, value) {
        var tmp0_desc = this.r32_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_10(), value.t32_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_13(), value.u32_1);
        tmp1_output.bt(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), value.v32_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_7).zn = function(encoder, value) {
        return this.s32(encoder, value instanceof JsonCredentialIssuer ? value : THROW_CCE());
    };
    protoOf($serializer_7).ao = function(decoder) {
        var tmp0_desc = this.r32_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonCredentialIssuer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_7).yn = function() {
        return this.r32_1;
    };
    protoOf($serializer_7).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            $serializer_getInstance_10(),
            $serializer_getInstance_13(),
            InstantIso8601Serializer_getInstance()
        ];
    };
    var $serializer_instance_7;
    function $serializer_getInstance_8() {
        if ($serializer_instance_7 == null) new $serializer_7();
        return $serializer_instance_7;
    }
    function JsonCredentialIssuer_init_$Init$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker, $this) {
        if (!(7 === (7 & seen0))) throwMissingFieldException(seen0, 7, $serializer_getInstance_8().r32_1);
        $this.t32_1 = issuerMetadata;
        $this.u32_1 = authorizationServerMetadata;
        $this.v32_1 = lastUpdate;
        return $this;
    }
    function JsonCredentialIssuer_init_$Create$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker) {
        return JsonCredentialIssuer_init_$Init$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialIssuer)));
    }
    function JsonCredentialIssuer(issuerMetadata, authorizationServerMetadata, lastUpdate) {
        this.t32_1 = issuerMetadata;
        this.u32_1 = authorizationServerMetadata;
        this.v32_1 = lastUpdate;
    }
    protoOf(JsonCredentialIssuer).toString = function() {
        return "JsonCredentialIssuer(issuerMetadata=" + this.t32_1.toString() + ", authorizationServerMetadata=" + this.u32_1.toString() + ", lastUpdate=" + this.v32_1.toString() + ")";
    };
    protoOf(JsonCredentialIssuer).hashCode = function() {
        var result = this.t32_1.hashCode();
        result = imul(result, 31) + this.u32_1.hashCode() | 0;
        result = imul(result, 31) + this.v32_1.hashCode() | 0;
        return result;
    };
    protoOf(JsonCredentialIssuer).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialIssuer)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialIssuer ? other : THROW_CCE();
        if (!this.t32_1.equals(tmp0_other_with_cast.t32_1)) return false;
        if (!this.u32_1.equals(tmp0_other_with_cast.u32_1)) return false;
        if (!this.v32_1.equals(tmp0_other_with_cast.v32_1)) return false;
        return true;
    };
    function Companion_9() {
        Companion_instance_11 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = getKClass(ValidatedCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [
            getKClass(DidValidatedJwtVcJsonCredentialResponse),
            getKClass(ValidatedJwtVcJsonLdCredentialResponse),
            getKClass(ValidatedLdpVcCredentialResponse),
            getKClass(DefaultValidatedVcSdJwtCredentialResponse)
        ];
        // Inline function 'kotlin.arrayOf' call
        var tmp_2 = $serializer_getInstance_1();
        var tmp_3 = getKClass(ValidatedJwtVcJsonLdCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        var tmp_4 = PolymorphicSerializer_init_$Create$(tmp_3, tmp$ret$5);
        var tmp_5 = getKClass(ValidatedLdpVcCredentialResponse);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_6 = [
            tmp_2,
            tmp_4,
            PolymorphicSerializer_init_$Create$(tmp_5, tmp$ret$8),
            $serializer_getInstance_0()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$14 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.w32_1 = [
            null,
            null,
            null,
            null,
            SealedClassSerializer_init_$Create$("io.curity.vc.serialization.ValidatedCredentialResponse", tmp_0, tmp_1, tmp_6, tmp$ret$14)
        ];
    }
    protoOf(Companion_9).x32 = function() {
        return encodeBase64url(Default_getInstance_0().fh(16));
    };
    var Companion_instance_11;
    function Companion_getInstance_9() {
        if (Companion_instance_11 == null) new Companion_9();
        return Companion_instance_11;
    }
    function $serializer_8() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.UserVerifiableCredential", this, 5);
        tmp0_serialDesc.wy("localId", false);
        tmp0_serialDesc.wy("issuerId", false);
        tmp0_serialDesc.wy("issuedAt", false);
        tmp0_serialDesc.wy("userDefinedName", false);
        tmp0_serialDesc.wy("credentialResponse", false);
        this.y32_1 = tmp0_serialDesc;
    }
    protoOf($serializer_8).z32 = function(encoder, value) {
        var tmp0_desc = this.y32_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_9().w32_1;
        tmp1_output.zs(tmp0_desc, 0, value.a33_1);
        tmp1_output.zs(tmp0_desc, 1, value.b33_1);
        tmp1_output.bt(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), value.c33_1);
        tmp1_output.zs(tmp0_desc, 3, value.d33_1);
        tmp1_output.bt(tmp0_desc, 4, tmp2_cached[4], value.e33_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_8).zn = function(encoder, value) {
        return this.z32(encoder, value instanceof UserVerifiableCredential ? value : THROW_CCE());
    };
    protoOf($serializer_8).ao = function(decoder) {
        var tmp0_desc = this.y32_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        var tmp10_cached = Companion_getInstance_9().w32_1;
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.vr(tmp0_desc, 3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return UserVerifiableCredential_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_8).yn = function() {
        return this.y32_1;
    };
    protoOf($serializer_8).lz = function() {
        var tmp0_cached = Companion_getInstance_9().w32_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            InstantIso8601Serializer_getInstance(),
            StringSerializer_getInstance(),
            tmp0_cached[4]
        ];
    };
    var $serializer_instance_8;
    function $serializer_getInstance_9() {
        if ($serializer_instance_8 == null) new $serializer_8();
        return $serializer_instance_8;
    }
    function UserVerifiableCredential_init_$Init$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker, $this) {
        if (!(31 === (31 & seen0))) throwMissingFieldException(seen0, 31, $serializer_getInstance_9().y32_1);
        $this.a33_1 = localId;
        $this.b33_1 = issuerId;
        $this.c33_1 = issuedAt;
        $this.d33_1 = userDefinedName;
        $this.e33_1 = credentialResponse;
        var tmp;
        var tmp_0 = $this.e33_1;
        if (!(tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse)) {
            var tmp_1 = $this.e33_1;
            tmp = !(tmp_1 instanceof DefaultValidatedVcSdJwtCredentialResponse);
        } else tmp = false;
        if (tmp) throw UnsupportedOperationException_init_$Create$("ValidatedCredentialResponse of this type " + ("is not supported yet: " + toString($this.e33_1)));
        return $this;
    }
    function UserVerifiableCredential_init_$Create$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker) {
        return UserVerifiableCredential_init_$Init$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker, objectCreate(protoOf(UserVerifiableCredential)));
    }
    function UserVerifiableCredential(localId, issuerId, issuedAt, userDefinedName, credentialResponse) {
        Companion_getInstance_9();
        this.a33_1 = localId;
        this.b33_1 = issuerId;
        this.c33_1 = issuedAt;
        this.d33_1 = userDefinedName;
        this.e33_1 = credentialResponse;
        var tmp;
        var tmp_0 = this.e33_1;
        if (!(tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse)) {
            var tmp_1 = this.e33_1;
            tmp = !(tmp_1 instanceof DefaultValidatedVcSdJwtCredentialResponse);
        } else tmp = false;
        if (tmp) throw UnsupportedOperationException_init_$Create$("ValidatedCredentialResponse of this type " + ("is not supported yet: " + toString(this.e33_1)));
    }
    protoOf(UserVerifiableCredential).f33 = function(localId, issuerId, issuedAt, userDefinedName, credentialResponse) {
        return new UserVerifiableCredential(localId, issuerId, issuedAt, userDefinedName, credentialResponse);
    };
    protoOf(UserVerifiableCredential).g33 = function(localId, issuerId, issuedAt, userDefinedName, credentialResponse, $super) {
        localId = localId === VOID ? this.a33_1 : localId;
        issuerId = issuerId === VOID ? this.b33_1 : issuerId;
        issuedAt = issuedAt === VOID ? this.c33_1 : issuedAt;
        userDefinedName = userDefinedName === VOID ? this.d33_1 : userDefinedName;
        credentialResponse = credentialResponse === VOID ? this.e33_1 : credentialResponse;
        return $super === VOID ? this.f33(localId, issuerId, issuedAt, userDefinedName, credentialResponse) : $super.f33.call(this, localId, issuerId, issuedAt, userDefinedName, credentialResponse);
    };
    protoOf(UserVerifiableCredential).toString = function() {
        return "UserVerifiableCredential(localId=" + this.a33_1 + ", issuerId=" + this.b33_1 + ", issuedAt=" + this.c33_1.toString() + ", userDefinedName=" + this.d33_1 + ", credentialResponse=" + toString(this.e33_1) + ")";
    };
    protoOf(UserVerifiableCredential).hashCode = function() {
        var result = getStringHashCode(this.a33_1);
        result = imul(result, 31) + getStringHashCode(this.b33_1) | 0;
        result = imul(result, 31) + this.c33_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d33_1) | 0;
        result = imul(result, 31) + hashCode(this.e33_1) | 0;
        return result;
    };
    protoOf(UserVerifiableCredential).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof UserVerifiableCredential)) return false;
        var tmp0_other_with_cast = other instanceof UserVerifiableCredential ? other : THROW_CCE();
        if (!(this.a33_1 === tmp0_other_with_cast.a33_1)) return false;
        if (!(this.b33_1 === tmp0_other_with_cast.b33_1)) return false;
        if (!this.c33_1.equals(tmp0_other_with_cast.c33_1)) return false;
        if (!(this.d33_1 === tmp0_other_with_cast.d33_1)) return false;
        if (!equals(this.e33_1, tmp0_other_with_cast.e33_1)) return false;
        return true;
    };
    function unwrapIssuer(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) throwDeserializationError('Missing mandatory key "' + key + '"');
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
            var this_0 = Default_getInstance();
            // Inline function 'kotlinx.serialization.serializer' call
            var this_1 = this_0.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_2 = serializer(this_1, createKType(getKClass(JsonIssuer), arrayOf([]), false));
            var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
            tmp_0 = this_0.b19(tmp$ret$1, value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalProofs(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var item = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_instance.e27(item, Companion_getInstance_22().b1b());
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalCredentialStatus(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_instance_55.d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalLogo(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_instance_15.d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalImage(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_instance_19.d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapCredentialDisplays(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) throwDeserializationError('Missing mandatory key "' + key + '"');
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        if (value instanceof JsonArray) {
            var tmp_1 = asSequence(value);
            tmp_0 = toList(map(tmp_1, unwrapCredentialDisplays$lambda));
        } else tmp_0 = null;
        return tmp_0;
    }
    function unwrapSupportedProofType(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
            var this_0 = Default_getInstance();
            // Inline function 'kotlinx.serialization.serializer' call
            var this_1 = this_0.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_2 = serializer(this_1, createKType(getKClass(KtMap), arrayOf([
                createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)),
                createInvariantKTypeProjection(createKType(getKClass(JsonProofTypesSupported), arrayOf([]), false))
            ]), true));
            var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
            tmp_0 = this_0.b19(tmp$ret$1, value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalDisplays(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        if (value instanceof JsonArray) {
            var tmp_1 = asSequence(value);
            tmp_0 = toList(map(tmp_1, unwrapOptionalDisplays$lambda));
        } else tmp_0 = null;
        return tmp_0;
    }
    function unwrapDisplays(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) throwDeserializationError('Missing mandatory key "' + key + '"');
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        if (value instanceof JsonArray) {
            var tmp_1 = asSequence(value);
            tmp_0 = toList(map(tmp_1, unwrapDisplays$lambda));
        } else tmp_0 = null;
        return tmp_0;
    }
    function throwDeserializationError(message) {
        throw IllegalArgumentException_init_$Create$(message);
    }
    function unwrapOptionalAlgFormat(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_getInstance_64().d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalVcSdJwtAlgsFormat(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_getInstance_67().d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalProofTypeFormat(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        try {
            tmp_0 = Companion_getInstance_66().d27(value);
        } catch ($p) {
            var tmp_1;
            if ($p instanceof IllegalArgumentException) {
                var e = $p;
                throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
            } else throw $p;
            tmp_0 = tmp_1;
        }
        return tmp_0;
    }
    function unwrapOptionalVerifiableCredentials(_this__u8e3s4, key) {
        var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        if (value instanceof JsonArray) {
            var tmp_1 = asSequence(value);
            tmp_0 = DefaultJsonMultiValue_init_$Create$_0(toList(map(tmp_1, unwrapOptionalVerifiableCredentials$lambda(key))));
        } else {
            if (value instanceof JsonPrimitive) tmp_0 = DefaultJsonMultiValue_init_$Create$(new StringCredential(get_jsonPrimitive(value).e1b()));
            else if (value instanceof JsonObject) tmp_0 = DefaultJsonMultiValue_init_$Create$(new DictionaryCredential(new MapDictionary(get_jsonObject(value))));
            else throwDeserializationError('Key "' + key + '" has an invalid value.');
        }
        return tmp_0;
    }
    function unwrapCredentialDisplays$lambda(it) {
        return Companion_instance_16.d27(it);
    }
    function unwrapOptionalDisplays$lambda(it) {
        return Companion_instance_14.d27(it);
    }
    function unwrapDisplays$lambda(it) {
        return Companion_instance_14.d27(it);
    }
    function unwrapOptionalVerifiableCredentials$lambda($key) {
        return function(it) {
            var tmp;
            if (it instanceof JsonPrimitive) tmp = new StringCredential(get_jsonPrimitive(it).e1b());
            else if (it instanceof JsonObject) tmp = new DictionaryCredential(new MapDictionary(get_jsonObject(it)));
            else throwDeserializationError('Key "' + $key + '" has an invalid value.');
            return tmp;
        };
    }
    function Companion_10() {
        Companion_instance_12 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l33_1 = [
            new ArrayListSerializer(StringSerializer_getInstance()),
            null,
            null,
            null,
            null,
            new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonSupportedCredentialSerializer_getInstance()),
            null,
            new ArrayListSerializer(JsonIssuerDisplaySerializer_getInstance()),
            null,
            null,
            null
        ];
    }
    var Companion_instance_12;
    function Companion_getInstance_10() {
        if (Companion_instance_12 == null) new Companion_10();
        return Companion_instance_12;
    }
    function $serializer_9() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonCredentialIssuerMetadata", this, 11);
        tmp0_serialDesc.wy("authorization_servers", true);
        tmp0_serialDesc.wy("credential_endpoint", false);
        tmp0_serialDesc.wy("batch_credential_endpoint", true);
        tmp0_serialDesc.wy("deferred_credential_endpoint", true);
        tmp0_serialDesc.wy("notification_endpoint", true);
        tmp0_serialDesc.wy("credential_configurations_supported", false);
        tmp0_serialDesc.wy("credential_issuer", false);
        tmp0_serialDesc.wy("display", true);
        tmp0_serialDesc.wy("credential_response_encryption", true);
        tmp0_serialDesc.wy("credential_identifiers_supported", true);
        tmp0_serialDesc.wy("signed_metadata", true);
        this.m33_1 = tmp0_serialDesc;
    }
    protoOf($serializer_9).n33 = function(encoder, value) {
        var tmp0_desc = this.m33_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_10().l33_1;
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.o33_1 == null)) tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.o33_1);
        tmp1_output.zs(tmp0_desc, 1, value.p33_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.q33_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.q33_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.r33_1 == null)) tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.r33_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.s33_1 == null)) tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.s33_1);
        tmp1_output.bt(tmp0_desc, 5, tmp2_cached[5], value.t33_1);
        tmp1_output.zs(tmp0_desc, 6, value.u33_1);
        if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.v33_1 == null)) tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.v33_1);
        if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.w33_1 == null)) tmp1_output.dt(tmp0_desc, 8, $serializer_getInstance_11(), value.w33_1);
        if (tmp1_output.ht(tmp0_desc, 9) ? true : !(value.x33_1 == null)) tmp1_output.dt(tmp0_desc, 9, BooleanSerializer_getInstance(), value.x33_1);
        if (tmp1_output.ht(tmp0_desc, 10) ? true : !(value.y33_1 == null)) tmp1_output.dt(tmp0_desc, 10, StringSerializer_getInstance(), value.y33_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_9).zn = function(encoder, value) {
        return this.n33(encoder, value instanceof JsonCredentialIssuerMetadata ? value : THROW_CCE());
    };
    protoOf($serializer_9).ao = function(decoder) {
        var tmp0_desc = this.m33_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_input = decoder.lr(tmp0_desc);
        var tmp16_cached = Companion_getInstance_10().l33_1;
        if (tmp15_input.as()) {
            tmp4_local0 = tmp15_input.zr(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp15_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp15_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp15_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp15_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp15_input.xr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp15_input.vr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp15_input.zr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            tmp12_local8 = tmp15_input.zr(tmp0_desc, 8, $serializer_getInstance_11(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            tmp13_local9 = tmp15_input.zr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            tmp14_local10 = tmp15_input.zr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
        } else while(tmp1_flag){
            tmp2_index = tmp15_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp15_input.zr(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp15_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp15_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp15_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp15_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp15_input.xr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp15_input.vr(tmp0_desc, 6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp15_input.zr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                case 8:
                    tmp12_local8 = tmp15_input.zr(tmp0_desc, 8, $serializer_getInstance_11(), tmp12_local8);
                    tmp3_bitMask0 = tmp3_bitMask0 | 256;
                    break;
                case 9:
                    tmp13_local9 = tmp15_input.zr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
                    tmp3_bitMask0 = tmp3_bitMask0 | 512;
                    break;
                case 10:
                    tmp14_local10 = tmp15_input.zr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp15_input.mr(tmp0_desc);
        return JsonCredentialIssuerMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
    };
    protoOf($serializer_9).yn = function() {
        return this.m33_1;
    };
    protoOf($serializer_9).lz = function() {
        var tmp0_cached = Companion_getInstance_10().l33_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(tmp0_cached[0]),
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            tmp0_cached[5],
            StringSerializer_getInstance(),
            get_nullable(tmp0_cached[7]),
            get_nullable($serializer_getInstance_11()),
            get_nullable(BooleanSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_9;
    function $serializer_getInstance_10() {
        if ($serializer_instance_9 == null) new $serializer_9();
        return $serializer_instance_9;
    }
    function JsonCredentialIssuerMetadata_init_$Init$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker, $this) {
        if (!(98 === (98 & seen0))) throwMissingFieldException(seen0, 98, $serializer_getInstance_10().m33_1);
        if (0 === (seen0 & 1)) $this.o33_1 = null;
        else $this.o33_1 = authorizationServers;
        $this.p33_1 = credentialEndpoint;
        if (0 === (seen0 & 4)) $this.q33_1 = null;
        else $this.q33_1 = batchCredentialEndpoint;
        if (0 === (seen0 & 8)) $this.r33_1 = null;
        else $this.r33_1 = deferredCredentialEndpoint;
        if (0 === (seen0 & 16)) $this.s33_1 = null;
        else $this.s33_1 = notificationEndpoint;
        $this.t33_1 = credentialConfigurationsSupported;
        $this.u33_1 = credentialIssuer;
        if (0 === (seen0 & 128)) $this.v33_1 = null;
        else $this.v33_1 = display;
        if (0 === (seen0 & 256)) $this.w33_1 = null;
        else $this.w33_1 = credentialResponseEncryption;
        if (0 === (seen0 & 512)) $this.x33_1 = null;
        else $this.x33_1 = credentialIdentifiersSupported;
        if (0 === (seen0 & 1024)) $this.y33_1 = null;
        else $this.y33_1 = signedMetadata;
        return $this;
    }
    function JsonCredentialIssuerMetadata_init_$Create$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker) {
        return JsonCredentialIssuerMetadata_init_$Init$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialIssuerMetadata)));
    }
    function JsonCredentialIssuerMetadata(authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata) {
        Companion_getInstance_10();
        authorizationServers = authorizationServers === VOID ? null : authorizationServers;
        batchCredentialEndpoint = batchCredentialEndpoint === VOID ? null : batchCredentialEndpoint;
        deferredCredentialEndpoint = deferredCredentialEndpoint === VOID ? null : deferredCredentialEndpoint;
        notificationEndpoint = notificationEndpoint === VOID ? null : notificationEndpoint;
        display = display === VOID ? null : display;
        credentialResponseEncryption = credentialResponseEncryption === VOID ? null : credentialResponseEncryption;
        credentialIdentifiersSupported = credentialIdentifiersSupported === VOID ? null : credentialIdentifiersSupported;
        signedMetadata = signedMetadata === VOID ? null : signedMetadata;
        this.o33_1 = authorizationServers;
        this.p33_1 = credentialEndpoint;
        this.q33_1 = batchCredentialEndpoint;
        this.r33_1 = deferredCredentialEndpoint;
        this.s33_1 = notificationEndpoint;
        this.t33_1 = credentialConfigurationsSupported;
        this.u33_1 = credentialIssuer;
        this.v33_1 = display;
        this.w33_1 = credentialResponseEncryption;
        this.x33_1 = credentialIdentifiersSupported;
        this.y33_1 = signedMetadata;
    }
    protoOf(JsonCredentialIssuerMetadata).toString = function() {
        return "JsonCredentialIssuerMetadata(authorizationServers=" + toString_0(this.o33_1) + ", credentialEndpoint=" + this.p33_1 + ", batchCredentialEndpoint=" + this.q33_1 + ", deferredCredentialEndpoint=" + this.r33_1 + ", notificationEndpoint=" + this.s33_1 + ", credentialConfigurationsSupported=" + toString(this.t33_1) + ", credentialIssuer=" + this.u33_1 + ", display=" + toString_0(this.v33_1) + ", credentialResponseEncryption=" + toString_0(this.w33_1) + ", credentialIdentifiersSupported=" + this.x33_1 + ", signedMetadata=" + this.y33_1 + ")";
    };
    protoOf(JsonCredentialIssuerMetadata).hashCode = function() {
        var result = this.o33_1 == null ? 0 : hashCode(this.o33_1);
        result = imul(result, 31) + getStringHashCode(this.p33_1) | 0;
        result = imul(result, 31) + (this.q33_1 == null ? 0 : getStringHashCode(this.q33_1)) | 0;
        result = imul(result, 31) + (this.r33_1 == null ? 0 : getStringHashCode(this.r33_1)) | 0;
        result = imul(result, 31) + (this.s33_1 == null ? 0 : getStringHashCode(this.s33_1)) | 0;
        result = imul(result, 31) + hashCode(this.t33_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u33_1) | 0;
        result = imul(result, 31) + (this.v33_1 == null ? 0 : hashCode(this.v33_1)) | 0;
        result = imul(result, 31) + (this.w33_1 == null ? 0 : this.w33_1.hashCode()) | 0;
        result = imul(result, 31) + (this.x33_1 == null ? 0 : getBooleanHashCode(this.x33_1)) | 0;
        result = imul(result, 31) + (this.y33_1 == null ? 0 : getStringHashCode(this.y33_1)) | 0;
        return result;
    };
    protoOf(JsonCredentialIssuerMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialIssuerMetadata)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialIssuerMetadata ? other : THROW_CCE();
        if (!equals(this.o33_1, tmp0_other_with_cast.o33_1)) return false;
        if (!(this.p33_1 === tmp0_other_with_cast.p33_1)) return false;
        if (!(this.q33_1 == tmp0_other_with_cast.q33_1)) return false;
        if (!(this.r33_1 == tmp0_other_with_cast.r33_1)) return false;
        if (!(this.s33_1 == tmp0_other_with_cast.s33_1)) return false;
        if (!equals(this.t33_1, tmp0_other_with_cast.t33_1)) return false;
        if (!(this.u33_1 === tmp0_other_with_cast.u33_1)) return false;
        if (!equals(this.v33_1, tmp0_other_with_cast.v33_1)) return false;
        if (!equals(this.w33_1, tmp0_other_with_cast.w33_1)) return false;
        if (!(this.x33_1 == tmp0_other_with_cast.x33_1)) return false;
        if (!(this.y33_1 == tmp0_other_with_cast.y33_1)) return false;
        return true;
    };
    function JsonCredentialConfigurationsSupported() {}
    function Companion_11() {}
    protoOf(Companion_11).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonIssuerDisplay"));
        return new JsonIssuerDisplay(unwrapString(map, "name"), unwrapOptionalString(map, "locale"), unwrapOptionalLogo(map, "logo"), new JsonDictionary(toMap(map)));
    };
    var Companion_instance_13;
    function Companion_getInstance_11() {
        return Companion_instance_13;
    }
    function _get__serializable__azf9o3($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.e34_1;
        _serializable$factory();
        return this_0.b1();
    }
    function JsonIssuerDisplay$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonIssuerDisplay._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.d34_1.a27());
            if (!(this$0.a34_1 == null)) this_0.m2("name", toJson(this$0.a34_1));
            if (!(this$0.b34_1 == null)) this_0.m2("locale", toJson(this$0.b34_1));
            if (!(this$0.c34_1 == null)) this_0.m2("logo", this$0.c34_1.a27());
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonIssuerDisplay(name, locale, logo, customClaims) {
        customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
        this.a34_1 = name;
        this.b34_1 = locale;
        this.c34_1 = logo;
        this.d34_1 = customClaims;
        var tmp = this;
        tmp.e34_1 = lazy(JsonIssuerDisplay$_serializable$delegate$lambda(this));
    }
    protoOf(JsonIssuerDisplay).y26 = function() {
        return _get__serializable__azf9o3(this);
    };
    protoOf(JsonIssuerDisplay).toString = function() {
        return "JsonIssuerDisplay(name=" + this.a34_1 + ", locale=" + this.b34_1 + ", logo=" + toString_0(this.c34_1) + ", customClaims=" + toString(this.d34_1) + ")";
    };
    protoOf(JsonIssuerDisplay).hashCode = function() {
        var result = this.a34_1 == null ? 0 : getStringHashCode(this.a34_1);
        result = imul(result, 31) + (this.b34_1 == null ? 0 : getStringHashCode(this.b34_1)) | 0;
        result = imul(result, 31) + (this.c34_1 == null ? 0 : this.c34_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.d34_1) | 0;
        return result;
    };
    protoOf(JsonIssuerDisplay).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonIssuerDisplay)) return false;
        var tmp0_other_with_cast = other instanceof JsonIssuerDisplay ? other : THROW_CCE();
        if (!(this.a34_1 == tmp0_other_with_cast.a34_1)) return false;
        if (!(this.b34_1 == tmp0_other_with_cast.b34_1)) return false;
        if (!equals(this.c34_1, tmp0_other_with_cast.c34_1)) return false;
        if (!equals(this.d34_1, tmp0_other_with_cast.d34_1)) return false;
        return true;
    };
    function Companion_12() {}
    protoOf(Companion_12).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonDisplayable"));
        return new JsonDisplayable(unwrapString(map, "name"), unwrapOptionalString(map, "locale"), new JsonDictionary(toMap(map)));
    };
    var Companion_instance_14;
    function Companion_getInstance_12() {
        return Companion_instance_14;
    }
    function _get__serializable__azf9o3_0($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.i34_1;
        _serializable$factory_0();
        return this_0.b1();
    }
    function JsonDisplayable$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonDisplayable._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.h34_1.a27());
            if (!(this$0.f34_1 == null)) this_0.m2("name", toJson(this$0.f34_1));
            if (!(this$0.g34_1 == null)) this_0.m2("locale", toJson(this$0.g34_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonDisplayable(name, locale, customClaims) {
        name = name === VOID ? null : name;
        locale = locale === VOID ? null : locale;
        customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
        this.f34_1 = name;
        this.g34_1 = locale;
        this.h34_1 = customClaims;
        var tmp = this;
        tmp.i34_1 = lazy(JsonDisplayable$_serializable$delegate$lambda(this));
    }
    protoOf(JsonDisplayable).y26 = function() {
        return _get__serializable__azf9o3_0(this);
    };
    protoOf(JsonDisplayable).toString = function() {
        return "JsonDisplayable(name=" + this.f34_1 + ", locale=" + this.g34_1 + ", customClaims=" + toString(this.h34_1) + ")";
    };
    protoOf(JsonDisplayable).hashCode = function() {
        var result = this.f34_1 == null ? 0 : getStringHashCode(this.f34_1);
        result = imul(result, 31) + (this.g34_1 == null ? 0 : getStringHashCode(this.g34_1)) | 0;
        result = imul(result, 31) + hashCode(this.h34_1) | 0;
        return result;
    };
    protoOf(JsonDisplayable).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonDisplayable)) return false;
        var tmp0_other_with_cast = other instanceof JsonDisplayable ? other : THROW_CCE();
        if (!(this.f34_1 == tmp0_other_with_cast.f34_1)) return false;
        if (!(this.g34_1 == tmp0_other_with_cast.g34_1)) return false;
        if (!equals(this.h34_1, tmp0_other_with_cast.h34_1)) return false;
        return true;
    };
    function Companion_13() {}
    protoOf(Companion_13).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonLogo"));
        return new JsonLogo(unwrapString(map, "uri"), unwrapOptionalString(map, "alt_text"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_15;
    function Companion_getInstance_13() {
        return Companion_instance_15;
    }
    function _get__serializable__azf9o3_1($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.m34_1;
        _serializable$factory_1();
        return this_0.b1();
    }
    function JsonLogo$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonLogo._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.l34_1 == null)) this_0.o2(this$0.l34_1.a27());
            this_0.m2("uri", toJson(this$0.j34_1));
            if (!(this$0.k34_1 == null)) this_0.m2("alt_text", toJson(this$0.k34_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonLogo(uri, altText, customClaims) {
        altText = altText === VOID ? null : altText;
        customClaims = customClaims === VOID ? null : customClaims;
        this.j34_1 = uri;
        this.k34_1 = altText;
        this.l34_1 = customClaims;
        var tmp = this;
        tmp.m34_1 = lazy(JsonLogo$_serializable$delegate$lambda(this));
    }
    protoOf(JsonLogo).y26 = function() {
        return _get__serializable__azf9o3_1(this);
    };
    protoOf(JsonLogo).toString = function() {
        return "JsonLogo(uri=" + this.j34_1 + ", altText=" + this.k34_1 + ", customClaims=" + toString_0(this.l34_1) + ")";
    };
    protoOf(JsonLogo).hashCode = function() {
        var result = getStringHashCode(this.j34_1);
        result = imul(result, 31) + (this.k34_1 == null ? 0 : getStringHashCode(this.k34_1)) | 0;
        result = imul(result, 31) + (this.l34_1 == null ? 0 : hashCode(this.l34_1)) | 0;
        return result;
    };
    protoOf(JsonLogo).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonLogo)) return false;
        var tmp0_other_with_cast = other instanceof JsonLogo ? other : THROW_CCE();
        if (!(this.j34_1 === tmp0_other_with_cast.j34_1)) return false;
        if (!(this.k34_1 == tmp0_other_with_cast.k34_1)) return false;
        if (!equals(this.l34_1, tmp0_other_with_cast.l34_1)) return false;
        return true;
    };
    function Companion_14() {}
    protoOf(Companion_14).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonLogo"));
        return new JsonCredentialDisplay(unwrapString(map, "name"), unwrapString(map, "locale"), unwrapOptionalLogo(map, "logo"), unwrapOptionalString(map, "description"), unwrapOptionalString(map, "background_color"), unwrapOptionalImage(map, "background_image"), unwrapOptionalString(map, "text_color"), new JsonDictionary(toMap(map)));
    };
    var Companion_instance_16;
    function Companion_getInstance_14() {
        return Companion_instance_16;
    }
    function _get__serializable__azf9o3_2($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.v34_1;
        _serializable$factory_2();
        return this_0.b1();
    }
    function JsonCredentialDisplay$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonCredentialDisplay._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.u34_1.a27());
            this_0.m2("name", toJson(this$0.n34_1));
            if (!(this$0.o34_1 == null)) this_0.m2("locale", toJson(this$0.o34_1));
            if (!(this$0.p34_1 == null)) this_0.m2("logo", this$0.p34_1.a27());
            if (!(this$0.q34_1 == null)) this_0.m2("description", toJson(this$0.q34_1));
            if (!(this$0.r34_1 == null)) this_0.m2("background_color", toJson(this$0.r34_1));
            if (!(this$0.t34_1 == null)) this_0.m2("text_color", toJson(this$0.t34_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonCredentialDisplay(name, locale, logo, description, backgroundColor, backgroundImage, textColor, customClaims) {
        locale = locale === VOID ? null : locale;
        logo = logo === VOID ? null : logo;
        description = description === VOID ? null : description;
        backgroundColor = backgroundColor === VOID ? null : backgroundColor;
        backgroundImage = backgroundImage === VOID ? null : backgroundImage;
        textColor = textColor === VOID ? null : textColor;
        customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
        this.n34_1 = name;
        this.o34_1 = locale;
        this.p34_1 = logo;
        this.q34_1 = description;
        this.r34_1 = backgroundColor;
        this.s34_1 = backgroundImage;
        this.t34_1 = textColor;
        this.u34_1 = customClaims;
        var tmp = this;
        tmp.v34_1 = lazy(JsonCredentialDisplay$_serializable$delegate$lambda(this));
    }
    protoOf(JsonCredentialDisplay).y26 = function() {
        return _get__serializable__azf9o3_2(this);
    };
    protoOf(JsonCredentialDisplay).toString = function() {
        return "JsonCredentialDisplay(name=" + this.n34_1 + ", locale=" + this.o34_1 + ", logo=" + toString_0(this.p34_1) + ", description=" + this.q34_1 + ", backgroundColor=" + this.r34_1 + ", backgroundImage=" + toString_0(this.s34_1) + ", textColor=" + this.t34_1 + ", customClaims=" + toString(this.u34_1) + ")";
    };
    protoOf(JsonCredentialDisplay).hashCode = function() {
        var result = getStringHashCode(this.n34_1);
        result = imul(result, 31) + (this.o34_1 == null ? 0 : getStringHashCode(this.o34_1)) | 0;
        result = imul(result, 31) + (this.p34_1 == null ? 0 : this.p34_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q34_1 == null ? 0 : getStringHashCode(this.q34_1)) | 0;
        result = imul(result, 31) + (this.r34_1 == null ? 0 : getStringHashCode(this.r34_1)) | 0;
        result = imul(result, 31) + (this.s34_1 == null ? 0 : hashCode(this.s34_1)) | 0;
        result = imul(result, 31) + (this.t34_1 == null ? 0 : getStringHashCode(this.t34_1)) | 0;
        result = imul(result, 31) + hashCode(this.u34_1) | 0;
        return result;
    };
    protoOf(JsonCredentialDisplay).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialDisplay)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialDisplay ? other : THROW_CCE();
        if (!(this.n34_1 === tmp0_other_with_cast.n34_1)) return false;
        if (!(this.o34_1 == tmp0_other_with_cast.o34_1)) return false;
        if (!equals(this.p34_1, tmp0_other_with_cast.p34_1)) return false;
        if (!(this.q34_1 == tmp0_other_with_cast.q34_1)) return false;
        if (!(this.r34_1 == tmp0_other_with_cast.r34_1)) return false;
        if (!equals(this.s34_1, tmp0_other_with_cast.s34_1)) return false;
        if (!(this.t34_1 == tmp0_other_with_cast.t34_1)) return false;
        if (!equals(this.u34_1, tmp0_other_with_cast.u34_1)) return false;
        return true;
    };
    function Companion_15() {}
    protoOf(Companion_15).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonSupportedCredential"));
        var tmp1_format = unwrapString(map, "format");
        var tmp2_cryptographicBindingMethodsSupported = unwrapOptionalStringList(map, "cryptographic_binding_methods_supported");
        var tmp3_display = unwrapCredentialDisplays(map, "display");
        var tmp4_customClaims = map.s() ? null : new JsonDictionary(toMap(map));
        var tmp5_scope = unwrapOptionalString(map, "scope");
        var tmp6_proofTypesSupported = unwrapSupportedProofType(map, "proof_types_supported");
        var tmp7_credentialSigningAlgValuesSupported = unwrapOptionalStringList(map, "credential_signing_alg_values_supported");
        return new DefaultJsonCredentialConfigurationsSupported(tmp1_format, tmp2_cryptographicBindingMethodsSupported, tmp3_display, tmp4_customClaims, tmp5_scope, tmp7_credentialSigningAlgValuesSupported, tmp6_proofTypesSupported);
    };
    protoOf(Companion_15).b1b = function() {
        return DefaultJsonSupportedCredentialSerializer_getInstance();
    };
    var Companion_instance_17;
    function Companion_getInstance_15() {
        return Companion_instance_17;
    }
    function _get__serializable__azf9o3_3($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.d35_1;
        _serializable$factory_3();
        return this_0.b1();
    }
    function DefaultJsonCredentialConfigurationsSupported$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.DefaultJsonCredentialConfigurationsSupported._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.z34_1 == null)) this_0.o2(this$0.z34_1.a27());
            this_0.m2("format", toJson(this$0.w34_1));
            if (!(this$0.x34_1 == null)) this_0.m2("cryptographic_binding_methods_supported", toJson_1(this$0.x34_1));
            if (!(this$0.y34_1 == null)) this_0.m2("display", toJsons(this$0.y34_1));
            if (!(this$0.a35_1 == null)) this_0.m2("scope", toJson(this$0.a35_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function DefaultJsonCredentialConfigurationsSupported(format, cryptographicBindingMethodsSupported, display, customClaims, scope, credentialSigningAlgValuesSupported, proofTypesSupported) {
        display = display === VOID ? null : display;
        customClaims = customClaims === VOID ? null : customClaims;
        this.w34_1 = format;
        this.x34_1 = cryptographicBindingMethodsSupported;
        this.y34_1 = display;
        this.z34_1 = customClaims;
        this.a35_1 = scope;
        this.b35_1 = credentialSigningAlgValuesSupported;
        this.c35_1 = proofTypesSupported;
        var tmp = this;
        tmp.d35_1 = lazy(DefaultJsonCredentialConfigurationsSupported$_serializable$delegate$lambda(this));
    }
    protoOf(DefaultJsonCredentialConfigurationsSupported).z33 = function() {
        return this.w34_1;
    };
    protoOf(DefaultJsonCredentialConfigurationsSupported).y26 = function() {
        return _get__serializable__azf9o3_3(this);
    };
    protoOf(DefaultJsonCredentialConfigurationsSupported).toString = function() {
        return "DefaultJsonCredentialConfigurationsSupported(format=" + this.w34_1 + ", cryptographicBindingMethodsSupported=" + toString_0(this.x34_1) + ", display=" + toString_0(this.y34_1) + ", customClaims=" + toString_0(this.z34_1) + ", scope=" + this.a35_1 + ", credentialSigningAlgValuesSupported=" + toString_0(this.b35_1) + ", proofTypesSupported=" + toString_0(this.c35_1) + ")";
    };
    protoOf(DefaultJsonCredentialConfigurationsSupported).hashCode = function() {
        var result = getStringHashCode(this.w34_1);
        result = imul(result, 31) + (this.x34_1 == null ? 0 : hashCode(this.x34_1)) | 0;
        result = imul(result, 31) + (this.y34_1 == null ? 0 : hashCode(this.y34_1)) | 0;
        result = imul(result, 31) + (this.z34_1 == null ? 0 : hashCode(this.z34_1)) | 0;
        result = imul(result, 31) + (this.a35_1 == null ? 0 : getStringHashCode(this.a35_1)) | 0;
        result = imul(result, 31) + (this.b35_1 == null ? 0 : hashCode(this.b35_1)) | 0;
        result = imul(result, 31) + (this.c35_1 == null ? 0 : hashCode(this.c35_1)) | 0;
        return result;
    };
    protoOf(DefaultJsonCredentialConfigurationsSupported).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DefaultJsonCredentialConfigurationsSupported)) return false;
        var tmp0_other_with_cast = other instanceof DefaultJsonCredentialConfigurationsSupported ? other : THROW_CCE();
        if (!(this.w34_1 === tmp0_other_with_cast.w34_1)) return false;
        if (!equals(this.x34_1, tmp0_other_with_cast.x34_1)) return false;
        if (!equals(this.y34_1, tmp0_other_with_cast.y34_1)) return false;
        if (!equals(this.z34_1, tmp0_other_with_cast.z34_1)) return false;
        if (!(this.a35_1 == tmp0_other_with_cast.a35_1)) return false;
        if (!equals(this.b35_1, tmp0_other_with_cast.b35_1)) return false;
        if (!equals(this.c35_1, tmp0_other_with_cast.c35_1)) return false;
        return true;
    };
    function Companion_16() {
        Companion_instance_18 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e35_1 = [
            new ArrayListSerializer(StringSerializer_getInstance()),
            new ArrayListSerializer(StringSerializer_getInstance()),
            null
        ];
    }
    var Companion_instance_18;
    function Companion_getInstance_16() {
        if (Companion_instance_18 == null) new Companion_16();
        return Companion_instance_18;
    }
    function $serializer_10() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.DefaultCredentialResponseEncryption", this, 3);
        tmp0_serialDesc.wy("alg_values_supported", false);
        tmp0_serialDesc.wy("enc_values_supported", false);
        tmp0_serialDesc.wy("encryption_required", false);
        this.f35_1 = tmp0_serialDesc;
    }
    protoOf($serializer_10).g35 = function(encoder, value) {
        var tmp0_desc = this.f35_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_16().e35_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.h35_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.i35_1);
        tmp1_output.rs(tmp0_desc, 2, value.j35_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_10).zn = function(encoder, value) {
        return this.g35(encoder, value instanceof DefaultCredentialResponseEncryption ? value : THROW_CCE());
    };
    protoOf($serializer_10).ao = function(decoder) {
        var tmp0_desc = this.f35_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.lr(tmp0_desc);
        var tmp8_cached = Companion_getInstance_16().e35_1;
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.nr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.nr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return DefaultCredentialResponseEncryption_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_10).yn = function() {
        return this.f35_1;
    };
    protoOf($serializer_10).lz = function() {
        var tmp0_cached = Companion_getInstance_16().e35_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            tmp0_cached[0],
            tmp0_cached[1],
            BooleanSerializer_getInstance()
        ];
    };
    var $serializer_instance_10;
    function $serializer_getInstance_11() {
        if ($serializer_instance_10 == null) new $serializer_10();
        return $serializer_instance_10;
    }
    function DefaultCredentialResponseEncryption_init_$Init$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker, $this) {
        if (!(7 === (7 & seen0))) throwMissingFieldException(seen0, 7, $serializer_getInstance_11().f35_1);
        $this.h35_1 = algValuesSupported;
        $this.i35_1 = encValuesSupported;
        $this.j35_1 = encryptionRequired;
        return $this;
    }
    function DefaultCredentialResponseEncryption_init_$Create$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker) {
        return DefaultCredentialResponseEncryption_init_$Init$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker, objectCreate(protoOf(DefaultCredentialResponseEncryption)));
    }
    function DefaultCredentialResponseEncryption() {}
    protoOf(DefaultCredentialResponseEncryption).toString = function() {
        return "DefaultCredentialResponseEncryption(algValuesSupported=" + toString(this.h35_1) + ", encValuesSupported=" + toString(this.i35_1) + ", encryptionRequired=" + this.j35_1 + ")";
    };
    protoOf(DefaultCredentialResponseEncryption).hashCode = function() {
        var result = hashCode(this.h35_1);
        result = imul(result, 31) + hashCode(this.i35_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.j35_1) | 0;
        return result;
    };
    protoOf(DefaultCredentialResponseEncryption).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DefaultCredentialResponseEncryption)) return false;
        var tmp0_other_with_cast = other instanceof DefaultCredentialResponseEncryption ? other : THROW_CCE();
        if (!equals(this.h35_1, tmp0_other_with_cast.h35_1)) return false;
        if (!equals(this.i35_1, tmp0_other_with_cast.i35_1)) return false;
        if (!(this.j35_1 === tmp0_other_with_cast.j35_1)) return false;
        return true;
    };
    function Companion_17() {}
    protoOf(Companion_17).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonImage"));
        return new JsonImage(unwrapString(map, "uri"));
    };
    var Companion_instance_19;
    function Companion_getInstance_17() {
        return Companion_instance_19;
    }
    function _get__serializable__azf9o3_4($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.l35_1;
        _serializable$factory_4();
        return this_0.b1();
    }
    function JsonImage$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonImage._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.m2("uri", toJson(this$0.k35_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonImage(uri) {
        this.k35_1 = uri;
        var tmp = this;
        tmp.l35_1 = lazy(JsonImage$_serializable$delegate$lambda(this));
    }
    protoOf(JsonImage).y26 = function() {
        return _get__serializable__azf9o3_4(this);
    };
    protoOf(JsonImage).toString = function() {
        return "JsonImage(uri=" + this.k35_1 + ")";
    };
    protoOf(JsonImage).hashCode = function() {
        return getStringHashCode(this.k35_1);
    };
    protoOf(JsonImage).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonImage)) return false;
        var tmp0_other_with_cast = other instanceof JsonImage ? other : THROW_CCE();
        if (!(this.k35_1 === tmp0_other_with_cast.k35_1)) return false;
        return true;
    };
    function Companion_18() {
        Companion_instance_20 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.m35_1 = [
            new ArrayListSerializer(StringSerializer_getInstance())
        ];
    }
    var Companion_instance_20;
    function Companion_getInstance_18() {
        if (Companion_instance_20 == null) new Companion_18();
        return Companion_instance_20;
    }
    function $serializer_11() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonProofTypesSupported", this, 1);
        tmp0_serialDesc.wy("proof_signing_alg_values_supported", false);
        this.n35_1 = tmp0_serialDesc;
    }
    protoOf($serializer_11).o35 = function(encoder, value) {
        var tmp0_desc = this.n35_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_18().m35_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.p35_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_11).zn = function(encoder, value) {
        return this.o35(encoder, value instanceof JsonProofTypesSupported ? value : THROW_CCE());
    };
    protoOf($serializer_11).ao = function(decoder) {
        var tmp0_desc = this.n35_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_18().m35_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return JsonProofTypesSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_11).yn = function() {
        return this.n35_1;
    };
    protoOf($serializer_11).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_18().m35_1[0]
        ];
    };
    var $serializer_instance_11;
    function $serializer_getInstance_12() {
        if ($serializer_instance_11 == null) new $serializer_11();
        return $serializer_instance_11;
    }
    function JsonProofTypesSupported_init_$Init$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_12().n35_1);
        $this.p35_1 = proofSigningAlgValuesSupported;
        return $this;
    }
    function JsonProofTypesSupported_init_$Create$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker) {
        return JsonProofTypesSupported_init_$Init$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker, objectCreate(protoOf(JsonProofTypesSupported)));
    }
    function JsonProofTypesSupported(proofSigningAlgValuesSupported) {
        Companion_getInstance_18();
        this.p35_1 = proofSigningAlgValuesSupported;
    }
    protoOf(JsonProofTypesSupported).toString = function() {
        return "JsonProofTypesSupported(proofSigningAlgValuesSupported=" + toString(this.p35_1) + ")";
    };
    protoOf(JsonProofTypesSupported).hashCode = function() {
        return hashCode(this.p35_1);
    };
    protoOf(JsonProofTypesSupported).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonProofTypesSupported)) return false;
        var tmp0_other_with_cast = other instanceof JsonProofTypesSupported ? other : THROW_CCE();
        if (!equals(this.p35_1, tmp0_other_with_cast.p35_1)) return false;
        return true;
    };
    function _serializable$factory() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3(receiver);
        }, null);
    }
    function _serializable$factory_0() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_0(receiver);
        }, null);
    }
    function _serializable$factory_1() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_1(receiver);
        }, null);
    }
    function _serializable$factory_2() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_2(receiver);
        }, null);
    }
    function _serializable$factory_3() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_3(receiver);
        }, null);
    }
    function _serializable$factory_4() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_4(receiver);
        }, null);
    }
    function Companion_19() {}
    var Companion_instance_21;
    function Companion_getInstance_19() {
        return Companion_instance_21;
    }
    function $serializer_12() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonOAuthMetadata", this, 2);
        tmp0_serialDesc.wy("authorization_endpoint", false);
        tmp0_serialDesc.wy("token_endpoint", false);
        this.q35_1 = tmp0_serialDesc;
    }
    protoOf($serializer_12).r35 = function(encoder, value) {
        var tmp0_desc = this.q35_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.s35_1);
        tmp1_output.zs(tmp0_desc, 1, value.t35_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_12).zn = function(encoder, value) {
        return this.r35(encoder, value instanceof JsonOAuthMetadata ? value : THROW_CCE());
    };
    protoOf($serializer_12).ao = function(decoder) {
        var tmp0_desc = this.q35_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonOAuthMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_12).yn = function() {
        return this.q35_1;
    };
    protoOf($serializer_12).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_12;
    function $serializer_getInstance_13() {
        if ($serializer_instance_12 == null) new $serializer_12();
        return $serializer_instance_12;
    }
    function JsonOAuthMetadata_init_$Init$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_13().q35_1);
        $this.s35_1 = authorizationEndpoint;
        $this.t35_1 = tokenEndpoint;
        return $this;
    }
    function JsonOAuthMetadata_init_$Create$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker) {
        return JsonOAuthMetadata_init_$Init$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthMetadata)));
    }
    function JsonOAuthMetadata(authorizationEndpoint, tokenEndpoint) {
        this.s35_1 = authorizationEndpoint;
        this.t35_1 = tokenEndpoint;
    }
    protoOf(JsonOAuthMetadata).toString = function() {
        return "JsonOAuthMetadata(authorizationEndpoint=" + this.s35_1 + ", tokenEndpoint=" + this.t35_1 + ")";
    };
    protoOf(JsonOAuthMetadata).hashCode = function() {
        var result = getStringHashCode(this.s35_1);
        result = imul(result, 31) + getStringHashCode(this.t35_1) | 0;
        return result;
    };
    protoOf(JsonOAuthMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonOAuthMetadata)) return false;
        var tmp0_other_with_cast = other instanceof JsonOAuthMetadata ? other : THROW_CCE();
        if (!(this.s35_1 === tmp0_other_with_cast.s35_1)) return false;
        if (!(this.t35_1 === tmp0_other_with_cast.t35_1)) return false;
        return true;
    };
    function Companion_20() {
        Companion_instance_22 = this;
        CompositeFromJson.call(this, Companion_getInstance_21());
        this.v35_1 = "jwt";
    }
    protoOf(Companion_20).w35 = function(toJson) {
        var serialized = toJson.z35();
        var type = toJson.x35_1;
        var tmp;
        if (serialized.x35_1 === "jwt") {
            var tmp0_elvis_lhs = serialized.y35_1;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
                var message = 'Missing the "jwt" claim';
                throw IllegalStateException_init_$Create$(toString(message));
            } else tmp_0 = tmp0_elvis_lhs;
            var customClaims = tmp_0;
            var tmp_1;
            if (customClaims.f2().m() === 1 && first(customClaims.f2()) === "jwt") {
                var jwt = customClaims.vl("jwt");
                var tmp_2;
                var tmp_3;
                if (jwt instanceof JsonPrimitive) tmp_3 = jwt.d1b();
                else tmp_3 = false;
                if (tmp_3) tmp_2 = new JwtProofOfPossession(jwt.e1b());
                else {
                    var message_0 = '"jwt" is not a String';
                    throw IllegalStateException_init_$Create$(toString(message_0));
                }
                tmp_1 = tmp_2;
            } else {
                var message_1 = 'Expected a single "jwt" custom claim but got \'' + toString(serialized.y35_1.f2()) + "'";
                throw IllegalStateException_init_$Create$(toString(message_1));
            }
            tmp = tmp_1;
        } else {
            var message_2 = 'Unexpected "proof_type": \'' + type + "'";
            throw IllegalStateException_init_$Create$(toString(message_2));
        }
        return tmp;
    };
    protoOf(Companion_20).n27 = function(toJson) {
        return this.w35(toJson instanceof JsonProofOfPossession ? toJson : THROW_CCE());
    };
    var Companion_instance_22;
    function Companion_getInstance_20() {
        if (Companion_instance_22 == null) new Companion_20();
        return Companion_instance_22;
    }
    function _get__serialized__5dtwz6($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.c36_1;
        _serialized$factory();
        return this_0.b1();
    }
    function JwtProofOfPossession$_serialized$delegate$lambda(this$0) {
        return function() {
            return mapOf([
                to("proof_type", JsonPrimitive_0("jwt")),
                to("jwt", JsonPrimitive_0(this$0.a36_1))
            ]);
        };
    }
    function JwtProofOfPossession(_jwt) {
        Companion_getInstance_20();
        this.a36_1 = _jwt;
        this.b36_1 = "jwt";
        var tmp = this;
        tmp.c36_1 = lazy(JwtProofOfPossession$_serialized$delegate$lambda(this));
    }
    protoOf(JwtProofOfPossession).xl = function() {
        return _get__serialized__5dtwz6(this);
    };
    protoOf(JwtProofOfPossession).y26 = function() {
        return new JsonDictionary(this.xl());
    };
    protoOf(JwtProofOfPossession).z35 = function() {
        return new JsonProofOfPossession("jwt", new JsonDictionary(mapOf_0(to("jwt", JsonPrimitive_0(this.a36_1)))));
    };
    protoOf(JwtProofOfPossession).toString = function() {
        return "JwtProofOfPossession(_jwt=" + this.a36_1 + ")";
    };
    protoOf(JwtProofOfPossession).hashCode = function() {
        return getStringHashCode(this.a36_1);
    };
    protoOf(JwtProofOfPossession).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtProofOfPossession)) return false;
        var tmp0_other_with_cast = other instanceof JwtProofOfPossession ? other : THROW_CCE();
        if (!(this.a36_1 === tmp0_other_with_cast.a36_1)) return false;
        return true;
    };
    function Companion_21() {
        Companion_instance_23 = this;
        this.d36_1 = new TypedDictionaryFromJson("proof_type");
    }
    protoOf(Companion_21).d27 = function(json) {
        var typedDictionary = this.d36_1.d27(json);
        return new JsonProofOfPossession(typedDictionary.r27_1, typedDictionary.s27_1);
    };
    var Companion_instance_23;
    function Companion_getInstance_21() {
        if (Companion_instance_23 == null) new Companion_21();
        return Companion_instance_23;
    }
    function JsonProofOfPossession(proofType, customClaims) {
        Companion_getInstance_21();
        customClaims = customClaims === VOID ? null : customClaims;
        this.x35_1 = proofType;
        this.y35_1 = customClaims;
    }
    protoOf(JsonProofOfPossession).y26 = function() {
        return Companion_getInstance_21().d36_1.p27(this.x35_1, this.y35_1);
    };
    protoOf(JsonProofOfPossession).z35 = function() {
        return this;
    };
    protoOf(JsonProofOfPossession).toString = function() {
        return "JsonProofOfPossession(proofType=" + this.x35_1 + ", customClaims=" + toString_0(this.y35_1) + ")";
    };
    protoOf(JsonProofOfPossession).hashCode = function() {
        var result = getStringHashCode(this.x35_1);
        result = imul(result, 31) + (this.y35_1 == null ? 0 : this.y35_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonProofOfPossession).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonProofOfPossession)) return false;
        var tmp0_other_with_cast = other instanceof JsonProofOfPossession ? other : THROW_CCE();
        if (!(this.x35_1 === tmp0_other_with_cast.x35_1)) return false;
        if (!equals(this.y35_1, tmp0_other_with_cast.y35_1)) return false;
        return true;
    };
    function Companion_22() {
        Companion_instance_24 = this;
        this.h33_1 = new TypedDictionaryFromJson("type");
    }
    protoOf(Companion_22).d27 = function(json) {
        var typedDictionary = this.h33_1.d27(json);
        return new JsonProof(typedDictionary.r27_1, typedDictionary.s27_1);
    };
    protoOf(Companion_22).b1b = function() {
        return JsonProofSerializer_getInstance();
    };
    var Companion_instance_24;
    function Companion_getInstance_22() {
        if (Companion_instance_24 == null) new Companion_22();
        return Companion_instance_24;
    }
    function JsonProof(type, customClaims) {
        Companion_getInstance_22();
        customClaims = customClaims === VOID ? null : customClaims;
        this.e36_1 = type;
        this.f36_1 = customClaims;
    }
    protoOf(JsonProof).g36 = function() {
        return this.e36_1;
    };
    protoOf(JsonProof).y26 = function() {
        return Companion_getInstance_22().h33_1.p27(this.e36_1, this.f36_1);
    };
    protoOf(JsonProof).toString = function() {
        return "JsonProof(type=" + this.e36_1 + ", customClaims=" + toString_0(this.f36_1) + ")";
    };
    protoOf(JsonProof).hashCode = function() {
        var result = getStringHashCode(this.e36_1);
        result = imul(result, 31) + (this.f36_1 == null ? 0 : this.f36_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonProof).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonProof)) return false;
        var tmp0_other_with_cast = other instanceof JsonProof ? other : THROW_CCE();
        if (!(this.e36_1 === tmp0_other_with_cast.e36_1)) return false;
        if (!equals(this.f36_1, tmp0_other_with_cast.f36_1)) return false;
        return true;
    };
    function _serialized$factory() {
        return getPropertyCallableRef("_serialized", 1, KProperty1, function(receiver) {
            return _get__serialized__5dtwz6(receiver);
        }, null);
    }
    function Companion_23() {}
    protoOf(Companion_23).b1b = function() {
        return $serializer_getInstance_14();
    };
    var Companion_instance_25;
    function Companion_getInstance_23() {
        return Companion_instance_25;
    }
    function $serializer_13() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JsonDeferredCredentialResponse", this, 3);
        tmp0_serialDesc.wy("transaction_id", false);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.h36_1 = tmp0_serialDesc;
    }
    protoOf($serializer_13).i36 = function(encoder, value) {
        var tmp0_desc = this.h36_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.j36_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.k36_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.k36_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.l36_1 == null)) tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.l36_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_13).zn = function(encoder, value) {
        return this.i36(encoder, value instanceof JsonDeferredCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_13).ao = function(decoder) {
        var tmp0_desc = this.h36_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonDeferredCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_13).yn = function() {
        return this.h36_1;
    };
    protoOf($serializer_13).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance_13;
    function $serializer_getInstance_14() {
        if ($serializer_instance_13 == null) new $serializer_13();
        return $serializer_instance_13;
    }
    function JsonDeferredCredentialResponse_init_$Init$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_14().h36_1);
        $this.j36_1 = transactionId;
        if (0 === (seen0 & 2)) $this.k36_1 = null;
        else $this.k36_1 = cNonce;
        if (0 === (seen0 & 4)) $this.l36_1 = null;
        else $this.l36_1 = cNonceExpiresIn;
        return $this;
    }
    function JsonDeferredCredentialResponse_init_$Create$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return JsonDeferredCredentialResponse_init_$Init$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JsonDeferredCredentialResponse)));
    }
    function JsonDeferredCredentialResponse() {}
    protoOf(JsonDeferredCredentialResponse).toString = function() {
        return "JsonDeferredCredentialResponse(transactionId=" + this.j36_1 + ", cNonce=" + this.k36_1 + ", cNonceExpiresIn=" + toString_0(this.l36_1) + ")";
    };
    protoOf(JsonDeferredCredentialResponse).hashCode = function() {
        var result = getStringHashCode(this.j36_1);
        result = imul(result, 31) + (this.k36_1 == null ? 0 : getStringHashCode(this.k36_1)) | 0;
        result = imul(result, 31) + (this.l36_1 == null ? 0 : this.l36_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonDeferredCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonDeferredCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof JsonDeferredCredentialResponse ? other : THROW_CCE();
        if (!(this.j36_1 === tmp0_other_with_cast.j36_1)) return false;
        if (!(this.k36_1 == tmp0_other_with_cast.k36_1)) return false;
        if (!equals(this.l36_1, tmp0_other_with_cast.l36_1)) return false;
        return true;
    };
    function ToJsonProofOfPossessionSerializer$_init_$lambda_79iudd(toJson) {
        return toJson.z35();
    }
    function ToJsonProofOfPossessionSerializer() {
        ToJsonProofOfPossessionSerializer_instance = this;
        var tmp = JsonProofOfPossessionSerializer_getInstance();
        DelegateSerializer.call(this, tmp, ToJsonProofOfPossessionSerializer$_init_$lambda_79iudd);
    }
    var ToJsonProofOfPossessionSerializer_instance;
    function ToJsonProofOfPossessionSerializer_getInstance() {
        if (ToJsonProofOfPossessionSerializer_instance == null) new ToJsonProofOfPossessionSerializer();
        return ToJsonProofOfPossessionSerializer_instance;
    }
    function BasicCredentialSubjectSerializer() {
        BasicCredentialSubjectSerializer_instance = this;
        JsonSerializer.call(this, Companion_getInstance_44());
    }
    var BasicCredentialSubjectSerializer_instance;
    function BasicCredentialSubjectSerializer_getInstance() {
        if (BasicCredentialSubjectSerializer_instance == null) new BasicCredentialSubjectSerializer();
        return BasicCredentialSubjectSerializer_instance;
    }
    function JwtProofOfPossessionSerializer() {
        JwtProofOfPossessionSerializer_instance = this;
        JsonSerializer.call(this, Companion_getInstance_20());
    }
    var JwtProofOfPossessionSerializer_instance;
    function JwtProofOfPossessionSerializer_getInstance() {
        if (JwtProofOfPossessionSerializer_instance == null) new JwtProofOfPossessionSerializer();
        return JwtProofOfPossessionSerializer_instance;
    }
    function JsonProofOfPossessionSerializer() {
        JsonProofOfPossessionSerializer_instance = this;
        JsonSerializer.call(this, Companion_getInstance_21());
    }
    var JsonProofOfPossessionSerializer_instance;
    function JsonProofOfPossessionSerializer_getInstance() {
        if (JsonProofOfPossessionSerializer_instance == null) new JsonProofOfPossessionSerializer();
        return JsonProofOfPossessionSerializer_instance;
    }
    function JsonProofSerializer() {
        JsonProofSerializer_instance = this;
        JsonSerializer.call(this, Companion_getInstance_22());
    }
    var JsonProofSerializer_instance;
    function JsonProofSerializer_getInstance() {
        if (JsonProofSerializer_instance == null) new JsonProofSerializer();
        return JsonProofSerializer_instance;
    }
    function SerializableW3CVerifiableCredentialSerializer() {
        SerializableW3CVerifiableCredentialSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_54);
    }
    var SerializableW3CVerifiableCredentialSerializer_instance;
    function SerializableW3CVerifiableCredentialSerializer_getInstance() {
        if (SerializableW3CVerifiableCredentialSerializer_instance == null) new SerializableW3CVerifiableCredentialSerializer();
        return SerializableW3CVerifiableCredentialSerializer_instance;
    }
    function JsonCredentialStatusSerializer() {
        JsonCredentialStatusSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_55);
    }
    var JsonCredentialStatusSerializer_instance;
    function JsonCredentialStatusSerializer_getInstance() {
        if (JsonCredentialStatusSerializer_instance == null) new JsonCredentialStatusSerializer();
        return JsonCredentialStatusSerializer_instance;
    }
    function JsonIssuerSerializer$_stringSerializer$lambda(it) {
        return it.m36_1;
    }
    function JsonIssuerSerializer$_stringSerializer$lambda_0(it) {
        return new IssuerURI_0(it);
    }
    function JsonIssuerSerializer$_objectSerializer$1() {
        JsonSerializer.call(this, Companion_instance_56);
    }
    function JsonIssuerSerializer() {
        JsonIssuerSerializer_instance = this;
        JsonContentPolymorphicSerializer.call(this, getKClass(JsonIssuer));
        var tmp = this;
        var tmp_0 = serializer_0(StringCompanionObject_instance);
        var tmp_1 = JsonIssuerSerializer$_stringSerializer$lambda;
        tmp.p36_1 = new DerivedSerializer(tmp_0, tmp_1, JsonIssuerSerializer$_stringSerializer$lambda_0);
        var tmp_2 = this;
        tmp_2.q36_1 = new JsonIssuerSerializer$_objectSerializer$1();
    }
    protoOf(JsonIssuerSerializer).z1a = function(element) {
        var tmp;
        if (element instanceof JsonPrimitive) tmp = this.p36_1;
        else tmp = this.q36_1;
        return tmp;
    };
    var JsonIssuerSerializer_instance;
    function JsonIssuerSerializer_getInstance() {
        if (JsonIssuerSerializer_instance == null) new JsonIssuerSerializer();
        return JsonIssuerSerializer_instance;
    }
    function JsonIssuerDisplaySerializer() {
        JsonIssuerDisplaySerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_13);
    }
    var JsonIssuerDisplaySerializer_instance;
    function JsonIssuerDisplaySerializer_getInstance() {
        if (JsonIssuerDisplaySerializer_instance == null) new JsonIssuerDisplaySerializer();
        return JsonIssuerDisplaySerializer_instance;
    }
    function JsonDisplayableSerializer() {
        JsonDisplayableSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_14);
    }
    var JsonDisplayableSerializer_instance;
    function JsonDisplayableSerializer_getInstance() {
        if (JsonDisplayableSerializer_instance == null) new JsonDisplayableSerializer();
        return JsonDisplayableSerializer_instance;
    }
    function JsonLogoSerializer() {
        JsonLogoSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_15);
    }
    var JsonLogoSerializer_instance;
    function JsonLogoSerializer_getInstance() {
        if (JsonLogoSerializer_instance == null) new JsonLogoSerializer();
        return JsonLogoSerializer_instance;
    }
    function JsonCredentialDisplaySerializer() {
        JsonCredentialDisplaySerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_16);
    }
    var JsonCredentialDisplaySerializer_instance;
    function JsonCredentialDisplaySerializer_getInstance() {
        if (JsonCredentialDisplaySerializer_instance == null) new JsonCredentialDisplaySerializer();
        return JsonCredentialDisplaySerializer_instance;
    }
    function DefaultJsonSupportedCredentialSerializer() {
        DefaultJsonSupportedCredentialSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_17);
    }
    var DefaultJsonSupportedCredentialSerializer_instance;
    function DefaultJsonSupportedCredentialSerializer_getInstance() {
        if (DefaultJsonSupportedCredentialSerializer_instance == null) new DefaultJsonSupportedCredentialSerializer();
        return DefaultJsonSupportedCredentialSerializer_instance;
    }
    function JsonImageSerializer() {
        JsonImageSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_19);
    }
    var JsonImageSerializer_instance;
    function JsonImageSerializer_getInstance() {
        if (JsonImageSerializer_instance == null) new JsonImageSerializer();
        return JsonImageSerializer_instance;
    }
    function VerifiableCredentialResponseSerializer(baseClass, _format, deferredSerializer, synchronousSerializer) {
        JsonContentPolymorphicSerializer.call(this, baseClass);
        this.t36_1 = _format;
        this.u36_1 = deferredSerializer;
        this.v36_1 = synchronousSerializer;
        var tmp = this;
        var tmp0_elvis_lhs = baseClass.fa();
        tmp.w36_1 = tmp0_elvis_lhs == null ? "VerifiableCredentialResponse" : tmp0_elvis_lhs;
    }
    protoOf(VerifiableCredentialResponseSerializer).z1a = function(element) {
        var response = FromJsonHelper_instance.b27(element, this.w36_1);
        var tmp;
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var key = "transaction_id";
        if ((isInterface(response, KtMap) ? response : THROW_CCE()).c2(key)) tmp = this.u36_1;
        else tmp = this.v36_1;
        return tmp;
    };
    function Companion_24() {}
    protoOf(Companion_24).d27 = function(json) {
        var map = FromJsonHelper_instance.b27(json, "Claims");
        // Inline function 'kotlin.collections.associate' call
        var this_0 = map.z();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.plusAssign' call
            // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            var pair = to(key, Companion_instance_27.d27(value));
            destination.m2(pair.z9_1, pair.aa_1);
        }
        return new JsonClaims(destination);
    };
    var Companion_instance_26;
    function Companion_getInstance_24() {
        return Companion_instance_26;
    }
    function VcSdJwtAuthorizationDetail$JsonClaims$_serialized$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.associate' call
            var this_0 = this$0.x36_1.z();
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateTo' call
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.plusAssign' call
                // Inline function 'io.curity.vc.serialization.JsonClaims._serialized.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = element.b1();
                var pair = to(key, value.y26().a27());
                destination.m2(pair.z9_1, pair.aa_1);
            }
            return new JsonDictionary(destination);
        };
    }
    function Companion_25() {}
    protoOf(Companion_25).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "ClaimsItem"));
        return new JsonClaimsItem(unwrapOptionalBoolean(map, "mandatory"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_27;
    function Companion_getInstance_25() {
        return Companion_instance_27;
    }
    function _get__serializable__azf9o3_5($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.b37_1;
        _serializable$factory_5();
        return this_0.b1();
    }
    function VcSdJwtAuthorizationDetail$JsonClaimsItem$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonClaimsItem._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.a37_1 == null)) this_0.o2(this$0.a37_1.a27());
            if (!(this$0.z36_1 == null)) this_0.m2("mandatory", toJson_2(this$0.z36_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function VcSdJwtAuthorizationDetail_init_$Init$(vct, claims, $this) {
        VcSdJwtAuthorizationDetail.call($this, "openid_credential", "vc+sd-jwt", null, vct, claims);
        return $this;
    }
    function VcSdJwtAuthorizationDetail_init_$Create$(vct, claims) {
        return VcSdJwtAuthorizationDetail_init_$Init$(vct, claims, objectCreate(protoOf(VcSdJwtAuthorizationDetail)));
    }
    function JsonClaims(claims) {
        this.x36_1 = claims;
        var tmp = this;
        tmp.y36_1 = lazy(VcSdJwtAuthorizationDetail$JsonClaims$_serialized$lambda(this));
    }
    protoOf(JsonClaims).y26 = function() {
        return this.y36_1.b1();
    };
    function JsonClaimsItem(mandatory, customClaims) {
        customClaims = customClaims === VOID ? null : customClaims;
        this.z36_1 = mandatory;
        this.a37_1 = customClaims;
        var tmp = this;
        tmp.b37_1 = lazy(VcSdJwtAuthorizationDetail$JsonClaimsItem$_serializable$delegate$lambda(this));
    }
    protoOf(JsonClaimsItem).y26 = function() {
        return _get__serializable__azf9o3_5(this);
    };
    function Companion_26() {}
    var Companion_instance_28;
    function Companion_getInstance_26() {
        return Companion_instance_28;
    }
    function $serializer_14() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.VcSdJwtAuthorizationDetail", this, 5);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("format", true);
        tmp0_serialDesc.wy("credential_configuration_id", true);
        tmp0_serialDesc.wy("vct", true);
        tmp0_serialDesc.wy("claims", true);
        this.c37_1 = tmp0_serialDesc;
    }
    protoOf($serializer_14).d37 = function(encoder, value) {
        var tmp0_desc = this.c37_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.e37_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.f37_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.f37_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g37_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.g37_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.h37_1 == null)) tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.h37_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.i37_1 == null)) tmp1_output.dt(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), value.i37_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_14).zn = function(encoder, value) {
        return this.d37(encoder, value instanceof VcSdJwtAuthorizationDetail ? value : THROW_CCE());
    };
    protoOf($serializer_14).ao = function(decoder) {
        var tmp0_desc = this.c37_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return VcSdJwtAuthorizationDetail_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_14).yn = function() {
        return this.c37_1;
    };
    protoOf($serializer_14).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(VcSdJwtAuthorizationDetailClaimsSerializer_getInstance())
        ];
    };
    var $serializer_instance_14;
    function $serializer_getInstance_15() {
        if ($serializer_instance_14 == null) new $serializer_14();
        return $serializer_instance_14;
    }
    function VcSdJwtAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_15().c37_1);
        $this.e37_1 = type;
        if (0 === (seen0 & 2)) $this.f37_1 = null;
        else $this.f37_1 = format;
        if (0 === (seen0 & 4)) $this.g37_1 = null;
        else $this.g37_1 = credentialConfigurationId;
        if (0 === (seen0 & 8)) $this.h37_1 = null;
        else $this.h37_1 = vct;
        if (0 === (seen0 & 16)) $this.i37_1 = null;
        else $this.i37_1 = claims;
        return $this;
    }
    function VcSdJwtAuthorizationDetail_init_$Create$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker) {
        return VcSdJwtAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtAuthorizationDetail)));
    }
    function VcSdJwtAuthorizationDetail(type, format, credentialConfigurationId, vct, claims) {
        format = format === VOID ? null : format;
        credentialConfigurationId = credentialConfigurationId === VOID ? null : credentialConfigurationId;
        vct = vct === VOID ? null : vct;
        claims = claims === VOID ? null : claims;
        this.e37_1 = type;
        this.f37_1 = format;
        this.g37_1 = credentialConfigurationId;
        this.h37_1 = vct;
        this.i37_1 = claims;
    }
    function _serializable$factory_5() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_5(receiver);
        }, null);
    }
    function Companion_27() {
        Companion_instance_29 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j37_1 = [
            null,
            null,
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            new ArrayListSerializer(StringSerializer_getInstance()),
            new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()),
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12())
        ];
    }
    protoOf(Companion_27).b1b = function() {
        return $serializer_getInstance_16();
    };
    var Companion_instance_29;
    function Companion_getInstance_27() {
        if (Companion_instance_29 == null) new Companion_27();
        return Companion_instance_29;
    }
    function $serializer_15() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.VcSdJwtCredentialConfigurationsSupported", this, 9);
        tmp0_serialDesc.wy("format", false);
        tmp0_serialDesc.wy("vct", false);
        tmp0_serialDesc.wy("claims", true);
        tmp0_serialDesc.wy("order", true);
        tmp0_serialDesc.wy("cryptographic_binding_methods_supported", true);
        tmp0_serialDesc.wy("display", true);
        tmp0_serialDesc.wy("scope", true);
        tmp0_serialDesc.wy("credential_signing_alg_values_supported", true);
        tmp0_serialDesc.wy("proof_types_supported", true);
        this.k37_1 = tmp0_serialDesc;
    }
    protoOf($serializer_15).l37 = function(encoder, value) {
        var tmp0_desc = this.k37_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_27().j37_1;
        tmp1_output.zs(tmp0_desc, 0, value.m37_1);
        tmp1_output.zs(tmp0_desc, 1, value.n37_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.o37_1 == null)) tmp1_output.dt(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), value.o37_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.p37_1 == null)) tmp1_output.dt(tmp0_desc, 3, tmp2_cached[3], value.p37_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.q37_1 == null)) tmp1_output.dt(tmp0_desc, 4, tmp2_cached[4], value.q37_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.r37_1 == null)) tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.r37_1);
        if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.s37_1 == null)) tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.s37_1);
        if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.t37_1 == null)) tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.t37_1);
        if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.u37_1 == null)) tmp1_output.dt(tmp0_desc, 8, tmp2_cached[8], value.u37_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_15).zn = function(encoder, value) {
        return this.l37(encoder, value instanceof VcSdJwtCredentialConfigurationsSupported ? value : THROW_CCE());
    };
    protoOf($serializer_15).ao = function(decoder) {
        var tmp0_desc = this.k37_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.lr(tmp0_desc);
        var tmp14_cached = Companion_getInstance_27().j37_1;
        if (tmp13_input.as()) {
            tmp4_local0 = tmp13_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp13_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp13_input.zr(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp13_input.zr(tmp0_desc, 3, tmp14_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp13_input.zr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp13_input.zr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp13_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp13_input.zr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            tmp12_local8 = tmp13_input.zr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else while(tmp1_flag){
            tmp2_index = tmp13_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp13_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp13_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp13_input.zr(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp13_input.zr(tmp0_desc, 3, tmp14_cached[3], tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp13_input.zr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp13_input.zr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp13_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp13_input.zr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                case 8:
                    tmp12_local8 = tmp13_input.zr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
                    tmp3_bitMask0 = tmp3_bitMask0 | 256;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp13_input.mr(tmp0_desc);
        return VcSdJwtCredentialConfigurationsSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
    };
    protoOf($serializer_15).yn = function() {
        return this.k37_1;
    };
    protoOf($serializer_15).lz = function() {
        var tmp0_cached = Companion_getInstance_27().j37_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            get_nullable(VcSdJwtClaimsMetadataSerializer_getInstance()),
            get_nullable(tmp0_cached[3]),
            get_nullable(tmp0_cached[4]),
            get_nullable(tmp0_cached[5]),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(tmp0_cached[7]),
            get_nullable(tmp0_cached[8])
        ];
    };
    var $serializer_instance_15;
    function $serializer_getInstance_16() {
        if ($serializer_instance_15 == null) new $serializer_15();
        return $serializer_instance_15;
    }
    function VcSdJwtCredentialConfigurationsSupported_init_$Init$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_16().k37_1);
        $this.m37_1 = format;
        $this.n37_1 = vct;
        if (0 === (seen0 & 4)) $this.o37_1 = null;
        else $this.o37_1 = claims;
        if (0 === (seen0 & 8)) $this.p37_1 = null;
        else $this.p37_1 = order;
        if (0 === (seen0 & 16)) $this.q37_1 = null;
        else $this.q37_1 = cryptographicBindingMethodsSupported;
        if (0 === (seen0 & 32)) $this.r37_1 = null;
        else $this.r37_1 = display;
        if (0 === (seen0 & 64)) $this.s37_1 = null;
        else $this.s37_1 = scope;
        if (0 === (seen0 & 128)) $this.t37_1 = null;
        else $this.t37_1 = credentialSigningAlgValuesSupported;
        if (0 === (seen0 & 256)) $this.u37_1 = null;
        else $this.u37_1 = proofTypesSupported;
        return $this;
    }
    function VcSdJwtCredentialConfigurationsSupported_init_$Create$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker) {
        return VcSdJwtCredentialConfigurationsSupported_init_$Init$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtCredentialConfigurationsSupported)));
    }
    function VcSdJwtCredentialConfigurationsSupported() {}
    protoOf(VcSdJwtCredentialConfigurationsSupported).z33 = function() {
        return this.m37_1;
    };
    protoOf(VcSdJwtCredentialConfigurationsSupported).toString = function() {
        return "VcSdJwtCredentialConfigurationsSupported(format=" + this.m37_1 + ", vct=" + this.n37_1 + ", claims=" + toString_0(this.o37_1) + ", order=" + toString_0(this.p37_1) + ", cryptographicBindingMethodsSupported=" + toString_0(this.q37_1) + ", display=" + toString_0(this.r37_1) + ", scope=" + this.s37_1 + ", credentialSigningAlgValuesSupported=" + toString_0(this.t37_1) + ", proofTypesSupported=" + toString_0(this.u37_1) + ")";
    };
    protoOf(VcSdJwtCredentialConfigurationsSupported).hashCode = function() {
        var result = getStringHashCode(this.m37_1);
        result = imul(result, 31) + getStringHashCode(this.n37_1) | 0;
        result = imul(result, 31) + (this.o37_1 == null ? 0 : this.o37_1.hashCode()) | 0;
        result = imul(result, 31) + (this.p37_1 == null ? 0 : hashCode(this.p37_1)) | 0;
        result = imul(result, 31) + (this.q37_1 == null ? 0 : hashCode(this.q37_1)) | 0;
        result = imul(result, 31) + (this.r37_1 == null ? 0 : hashCode(this.r37_1)) | 0;
        result = imul(result, 31) + (this.s37_1 == null ? 0 : getStringHashCode(this.s37_1)) | 0;
        result = imul(result, 31) + (this.t37_1 == null ? 0 : hashCode(this.t37_1)) | 0;
        result = imul(result, 31) + (this.u37_1 == null ? 0 : hashCode(this.u37_1)) | 0;
        return result;
    };
    protoOf(VcSdJwtCredentialConfigurationsSupported).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VcSdJwtCredentialConfigurationsSupported)) return false;
        var tmp0_other_with_cast = other instanceof VcSdJwtCredentialConfigurationsSupported ? other : THROW_CCE();
        if (!(this.m37_1 === tmp0_other_with_cast.m37_1)) return false;
        if (!(this.n37_1 === tmp0_other_with_cast.n37_1)) return false;
        if (!equals(this.o37_1, tmp0_other_with_cast.o37_1)) return false;
        if (!equals(this.p37_1, tmp0_other_with_cast.p37_1)) return false;
        if (!equals(this.q37_1, tmp0_other_with_cast.q37_1)) return false;
        if (!equals(this.r37_1, tmp0_other_with_cast.r37_1)) return false;
        if (!(this.s37_1 == tmp0_other_with_cast.s37_1)) return false;
        if (!equals(this.t37_1, tmp0_other_with_cast.t37_1)) return false;
        if (!equals(this.u37_1, tmp0_other_with_cast.u37_1)) return false;
        return true;
    };
    function Companion_28() {}
    protoOf(Companion_28).d27 = function(json) {
        var map = FromJsonHelper_instance.b27(json, "VcSdJwtClaimsMetadata");
        // Inline function 'kotlin.collections.associate' call
        var this_0 = map.z();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.plusAssign' call
            // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            var pair = to(key, Companion_instance_31.d27(value));
            destination.m2(pair.z9_1, pair.aa_1);
        }
        return new VcSdJwtClaimsMetadata(destination);
    };
    var Companion_instance_30;
    function Companion_getInstance_28() {
        return Companion_instance_30;
    }
    function _get__serialized__5dtwz6_0($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.w37_1;
        _serialized$factory_0();
        return this_0.b1();
    }
    function VcSdJwtClaimsMetadata$_serialized$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.associate' call
            var this_0 = this$0.v37_1.z();
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateTo' call
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.plusAssign' call
                // Inline function 'io.curity.vc.serialization.VcSdJwtClaimsMetadata._serialized$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = element.b1();
                var pair = to(key, value.y26().a27());
                destination.m2(pair.z9_1, pair.aa_1);
            }
            return new JsonDictionary(destination);
        };
    }
    function VcSdJwtClaimsMetadata(claims) {
        this.v37_1 = claims;
        var tmp = this;
        tmp.w37_1 = lazy(VcSdJwtClaimsMetadata$_serialized$delegate$lambda(this));
    }
    protoOf(VcSdJwtClaimsMetadata).y26 = function() {
        return _get__serialized__5dtwz6_0(this);
    };
    protoOf(VcSdJwtClaimsMetadata).toString = function() {
        return "VcSdJwtClaimsMetadata(claims=" + toString(this.v37_1) + ")";
    };
    protoOf(VcSdJwtClaimsMetadata).hashCode = function() {
        return hashCode(this.v37_1);
    };
    protoOf(VcSdJwtClaimsMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VcSdJwtClaimsMetadata)) return false;
        var tmp0_other_with_cast = other instanceof VcSdJwtClaimsMetadata ? other : THROW_CCE();
        if (!equals(this.v37_1, tmp0_other_with_cast.v37_1)) return false;
        return true;
    };
    function Companion_29() {}
    protoOf(Companion_29).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "VcSdJwtClaimsEntryMetadata"));
        return new VcSdJwtClaimsEntryMetadata(unwrapOptionalString(map, "value_type"), unwrapDisplays(map, "display"), unwrapOptionalBoolean(map, "mandatory"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_31;
    function Companion_getInstance_29() {
        return Companion_instance_31;
    }
    function _get__serializable__azf9o3_6($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.b38_1;
        _serializable$factory_6();
        return this_0.b1();
    }
    function VcSdJwtClaimsEntryMetadata$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.VcSdJwtClaimsEntryMetadata._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.a38_1 == null)) this_0.o2(this$0.a38_1.a27());
            if (!(this$0.x37_1 == null)) this_0.m2("value_type", toJson(this$0.x37_1));
            if (!(this$0.y37_1 == null)) this_0.m2("display", toJsons(this$0.y37_1));
            if (!(this$0.z37_1 == null)) this_0.m2("mandatory", toJson_2(this$0.z37_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function VcSdJwtClaimsEntryMetadata(valueType, display, _mandatory, customClaims) {
        valueType = valueType === VOID ? null : valueType;
        display = display === VOID ? null : display;
        _mandatory = _mandatory === VOID ? null : _mandatory;
        customClaims = customClaims === VOID ? null : customClaims;
        this.x37_1 = valueType;
        this.y37_1 = display;
        this.z37_1 = _mandatory;
        this.a38_1 = customClaims;
        var tmp = this;
        tmp.b38_1 = lazy(VcSdJwtClaimsEntryMetadata$_serializable$delegate$lambda(this));
    }
    protoOf(VcSdJwtClaimsEntryMetadata).y26 = function() {
        return _get__serializable__azf9o3_6(this);
    };
    protoOf(VcSdJwtClaimsEntryMetadata).toString = function() {
        return "VcSdJwtClaimsEntryMetadata(valueType=" + this.x37_1 + ", display=" + toString_0(this.y37_1) + ", _mandatory=" + this.z37_1 + ", customClaims=" + toString_0(this.a38_1) + ")";
    };
    protoOf(VcSdJwtClaimsEntryMetadata).hashCode = function() {
        var result = this.x37_1 == null ? 0 : getStringHashCode(this.x37_1);
        result = imul(result, 31) + (this.y37_1 == null ? 0 : hashCode(this.y37_1)) | 0;
        result = imul(result, 31) + (this.z37_1 == null ? 0 : getBooleanHashCode(this.z37_1)) | 0;
        result = imul(result, 31) + (this.a38_1 == null ? 0 : hashCode(this.a38_1)) | 0;
        return result;
    };
    protoOf(VcSdJwtClaimsEntryMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VcSdJwtClaimsEntryMetadata)) return false;
        var tmp0_other_with_cast = other instanceof VcSdJwtClaimsEntryMetadata ? other : THROW_CCE();
        if (!(this.x37_1 == tmp0_other_with_cast.x37_1)) return false;
        if (!equals(this.y37_1, tmp0_other_with_cast.y37_1)) return false;
        if (!(this.z37_1 == tmp0_other_with_cast.z37_1)) return false;
        if (!equals(this.a38_1, tmp0_other_with_cast.a38_1)) return false;
        return true;
    };
    function _serialized$factory_0() {
        return getPropertyCallableRef("_serialized", 1, KProperty1, function(receiver) {
            return _get__serialized__5dtwz6_0(receiver);
        }, null);
    }
    function _serializable$factory_6() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_6(receiver);
        }, null);
    }
    function Companion_30() {}
    var Companion_instance_32;
    function Companion_getInstance_30() {
        return Companion_instance_32;
    }
    function $serializer_16() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.VcSdJwtVerifiableCredentialRequest", this, 4);
        tmp0_serialDesc.wy("proof", true);
        tmp0_serialDesc.wy("vct", false);
        tmp0_serialDesc.wy("claims", true);
        tmp0_serialDesc.wy("format", true);
        this.c38_1 = tmp0_serialDesc;
    }
    protoOf($serializer_16).d38 = function(encoder, value) {
        var tmp0_desc = this.c38_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.e38_1 == null)) tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.e38_1);
        tmp1_output.zs(tmp0_desc, 1, value.f38_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g38_1 == null)) tmp1_output.dt(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), value.g38_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.h38_1 === "vc+sd-jwt")) tmp1_output.zs(tmp0_desc, 3, value.h38_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_16).zn = function(encoder, value) {
        return this.d38(encoder, value instanceof VcSdJwtVerifiableCredentialRequest ? value : THROW_CCE());
    };
    protoOf($serializer_16).ao = function(decoder) {
        var tmp0_desc = this.c38_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.vr(tmp0_desc, 3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return VcSdJwtVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_16).yn = function() {
        return this.c38_1;
    };
    protoOf($serializer_16).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(ToJsonProofOfPossessionSerializer_getInstance()),
            StringSerializer_getInstance(),
            get_nullable(ToJsonDictionarySerializer_getInstance()),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_16;
    function $serializer_getInstance_17() {
        if ($serializer_instance_16 == null) new $serializer_16();
        return $serializer_instance_16;
    }
    function VcSdJwtVerifiableCredentialRequest_init_$Init$(seen0, proof, vct, claims, format, serializationConstructorMarker, $this) {
        if (!(2 === (2 & seen0))) throwMissingFieldException(seen0, 2, $serializer_getInstance_17().c38_1);
        if (0 === (seen0 & 1)) $this.e38_1 = null;
        else $this.e38_1 = proof;
        $this.f38_1 = vct;
        if (0 === (seen0 & 4)) $this.g38_1 = null;
        else $this.g38_1 = claims;
        if (0 === (seen0 & 8)) $this.h38_1 = "vc+sd-jwt";
        else $this.h38_1 = format;
        return $this;
    }
    function VcSdJwtVerifiableCredentialRequest_init_$Create$(seen0, proof, vct, claims, format, serializationConstructorMarker) {
        return VcSdJwtVerifiableCredentialRequest_init_$Init$(seen0, proof, vct, claims, format, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtVerifiableCredentialRequest)));
    }
    function VcSdJwtVerifiableCredentialRequest(proof, vct, claims, format) {
        proof = proof === VOID ? null : proof;
        claims = claims === VOID ? null : claims;
        format = format === VOID ? "vc+sd-jwt" : format;
        this.e38_1 = proof;
        this.f38_1 = vct;
        this.g38_1 = claims;
        this.h38_1 = format;
    }
    protoOf(VcSdJwtVerifiableCredentialRequest).toString = function() {
        return "VcSdJwtVerifiableCredentialRequest(proof=" + toString_0(this.e38_1) + ", vct=" + this.f38_1 + ", claims=" + toString_0(this.g38_1) + ", format=" + this.h38_1 + ")";
    };
    protoOf(VcSdJwtVerifiableCredentialRequest).hashCode = function() {
        var result = this.e38_1 == null ? 0 : hashCode(this.e38_1);
        result = imul(result, 31) + getStringHashCode(this.f38_1) | 0;
        result = imul(result, 31) + (this.g38_1 == null ? 0 : hashCode(this.g38_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.h38_1) | 0;
        return result;
    };
    protoOf(VcSdJwtVerifiableCredentialRequest).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VcSdJwtVerifiableCredentialRequest)) return false;
        var tmp0_other_with_cast = other instanceof VcSdJwtVerifiableCredentialRequest ? other : THROW_CCE();
        if (!equals(this.e38_1, tmp0_other_with_cast.e38_1)) return false;
        if (!(this.f38_1 === tmp0_other_with_cast.f38_1)) return false;
        if (!equals(this.g38_1, tmp0_other_with_cast.g38_1)) return false;
        if (!(this.h38_1 === tmp0_other_with_cast.h38_1)) return false;
        return true;
    };
    function Companion_31() {}
    protoOf(Companion_31).b1b = function() {
        return $serializer_getInstance_18();
    };
    var Companion_instance_33;
    function Companion_getInstance_31() {
        return Companion_instance_33;
    }
    function $serializer_17() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.VcSdJwtVerifiableCredentialResponse", this, 3);
        tmp0_serialDesc.wy("credential", false);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.i38_1 = tmp0_serialDesc;
    }
    protoOf($serializer_17).j38 = function(encoder, value) {
        var tmp0_desc = this.i38_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.k38_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.l38_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.l38_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.m38_1 == null)) tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.m38_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_17).zn = function(encoder, value) {
        return this.j38(encoder, value instanceof VcSdJwtVerifiableCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_17).ao = function(decoder) {
        var tmp0_desc = this.i38_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return VcSdJwtVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_17).yn = function() {
        return this.i38_1;
    };
    protoOf($serializer_17).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance_17;
    function $serializer_getInstance_18() {
        if ($serializer_instance_17 == null) new $serializer_17();
        return $serializer_instance_17;
    }
    function VcSdJwtVerifiableCredentialResponse_init_$Init$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_18().i38_1);
        $this.k38_1 = stringCredential;
        if (0 === (seen0 & 2)) $this.l38_1 = null;
        else $this.l38_1 = cNonce;
        if (0 === (seen0 & 4)) $this.m38_1 = null;
        else $this.m38_1 = cNonceExpiresIn;
        return $this;
    }
    function VcSdJwtVerifiableCredentialResponse_init_$Create$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return VcSdJwtVerifiableCredentialResponse_init_$Init$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtVerifiableCredentialResponse)));
    }
    function VcSdJwtVerifiableCredentialResponse() {}
    protoOf(VcSdJwtVerifiableCredentialResponse).n38 = function() {
        return new StringCredential(this.k38_1);
    };
    protoOf(VcSdJwtVerifiableCredentialResponse).toString = function() {
        return "VcSdJwtVerifiableCredentialResponse(stringCredential=" + this.k38_1 + ", cNonce=" + this.l38_1 + ", cNonceExpiresIn=" + toString_0(this.m38_1) + ")";
    };
    protoOf(VcSdJwtVerifiableCredentialResponse).hashCode = function() {
        var result = getStringHashCode(this.k38_1);
        result = imul(result, 31) + (this.l38_1 == null ? 0 : getStringHashCode(this.l38_1)) | 0;
        result = imul(result, 31) + (this.m38_1 == null ? 0 : this.m38_1.hashCode()) | 0;
        return result;
    };
    protoOf(VcSdJwtVerifiableCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VcSdJwtVerifiableCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof VcSdJwtVerifiableCredentialResponse ? other : THROW_CCE();
        if (!(this.k38_1 === tmp0_other_with_cast.k38_1)) return false;
        if (!(this.l38_1 == tmp0_other_with_cast.l38_1)) return false;
        if (!equals(this.m38_1, tmp0_other_with_cast.m38_1)) return false;
        return true;
    };
    function VcSdJwtClaimsMetadataSerializer() {
        VcSdJwtClaimsMetadataSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_30);
    }
    var VcSdJwtClaimsMetadataSerializer_instance;
    function VcSdJwtClaimsMetadataSerializer_getInstance() {
        if (VcSdJwtClaimsMetadataSerializer_instance == null) new VcSdJwtClaimsMetadataSerializer();
        return VcSdJwtClaimsMetadataSerializer_instance;
    }
    function VcSdJwtClaimsMetadataEntrySerializer() {
        VcSdJwtClaimsMetadataEntrySerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_31);
    }
    var VcSdJwtClaimsMetadataEntrySerializer_instance;
    function VcSdJwtClaimsMetadataEntrySerializer_getInstance() {
        if (VcSdJwtClaimsMetadataEntrySerializer_instance == null) new VcSdJwtClaimsMetadataEntrySerializer();
        return VcSdJwtClaimsMetadataEntrySerializer_instance;
    }
    function VcSdJwtAuthorizationDetailClaimsSerializer() {
        VcSdJwtAuthorizationDetailClaimsSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_26);
    }
    var VcSdJwtAuthorizationDetailClaimsSerializer_instance;
    function VcSdJwtAuthorizationDetailClaimsSerializer_getInstance() {
        if (VcSdJwtAuthorizationDetailClaimsSerializer_instance == null) new VcSdJwtAuthorizationDetailClaimsSerializer();
        return VcSdJwtAuthorizationDetailClaimsSerializer_instance;
    }
    function VcSdJwtAuthorizationDetailClaimsItemSerializer() {
        VcSdJwtAuthorizationDetailClaimsItemSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_27);
    }
    var VcSdJwtAuthorizationDetailClaimsItemSerializer_instance;
    function VcSdJwtAuthorizationDetailClaimsItemSerializer_getInstance() {
        if (VcSdJwtAuthorizationDetailClaimsItemSerializer_instance == null) new VcSdJwtAuthorizationDetailClaimsItemSerializer();
        return VcSdJwtAuthorizationDetailClaimsItemSerializer_instance;
    }
    function JwtVcJsonAuthorizationDetail_init_$Init$(types, credentialSubject, $this) {
        JwtVcJsonAuthorizationDetail.call($this, "openid_credential", "jwt_vc_json", null, new JwtVcJsonAuthorizationDetailsCredentialDefinition(types, credentialSubject));
        return $this;
    }
    function JwtVcJsonAuthorizationDetail_init_$Create$(types, credentialSubject) {
        return JwtVcJsonAuthorizationDetail_init_$Init$(types, credentialSubject, objectCreate(protoOf(JwtVcJsonAuthorizationDetail)));
    }
    function Companion_32() {}
    var Companion_instance_34;
    function Companion_getInstance_32() {
        return Companion_instance_34;
    }
    function $serializer_18() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonAuthorizationDetail", this, 4);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("format", true);
        tmp0_serialDesc.wy("credential_configuration_id", true);
        tmp0_serialDesc.wy("credential_definition", true);
        this.o38_1 = tmp0_serialDesc;
    }
    protoOf($serializer_18).p38 = function(encoder, value) {
        var tmp0_desc = this.o38_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.q38_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.r38_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.r38_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.s38_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.s38_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.t38_1 == null)) tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_20(), value.t38_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_18).zn = function(encoder, value) {
        return this.p38(encoder, value instanceof JwtVcJsonAuthorizationDetail ? value : THROW_CCE());
    };
    protoOf($serializer_18).ao = function(decoder) {
        var tmp0_desc = this.o38_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return JwtVcJsonAuthorizationDetail_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_18).yn = function() {
        return this.o38_1;
    };
    protoOf($serializer_18).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable($serializer_getInstance_20())
        ];
    };
    var $serializer_instance_18;
    function $serializer_getInstance_19() {
        if ($serializer_instance_18 == null) new $serializer_18();
        return $serializer_instance_18;
    }
    function JwtVcJsonAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_19().o38_1);
        $this.q38_1 = type;
        if (0 === (seen0 & 2)) $this.r38_1 = null;
        else $this.r38_1 = format;
        if (0 === (seen0 & 4)) $this.s38_1 = null;
        else $this.s38_1 = credentialConfigurationId;
        if (0 === (seen0 & 8)) $this.t38_1 = null;
        else $this.t38_1 = credentialDefinition;
        return $this;
    }
    function JwtVcJsonAuthorizationDetail_init_$Create$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker) {
        return JwtVcJsonAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonAuthorizationDetail)));
    }
    function JwtVcJsonAuthorizationDetail(type, format, credentialConfigurationId, credentialDefinition) {
        format = format === VOID ? null : format;
        credentialConfigurationId = credentialConfigurationId === VOID ? null : credentialConfigurationId;
        credentialDefinition = credentialDefinition === VOID ? null : credentialDefinition;
        this.q38_1 = type;
        this.r38_1 = format;
        this.s38_1 = credentialConfigurationId;
        this.t38_1 = credentialDefinition;
    }
    function Companion_33() {}
    protoOf(Companion_33).d27 = function(json) {
        var map = FromJsonHelper_instance.b27(json, "JsonCredentialSubject");
        // Inline function 'kotlin.collections.associate' call
        var this_0 = map.z();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.plusAssign' call
            // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            var pair = to(key, Companion_instance_36.d27(value));
            destination.m2(pair.z9_1, pair.aa_1);
        }
        return new JsonCredentialSubject(destination);
    };
    var Companion_instance_35;
    function Companion_getInstance_33() {
        return Companion_instance_35;
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubject$_serialized$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.associate' call
            var this_0 = this$0.u38_1.z();
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateTo' call
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.plusAssign' call
                // Inline function 'io.curity.vc.serialization.JsonCredentialSubject._serialized.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = element.b1();
                var pair = to(key, value.y26().a27());
                destination.m2(pair.z9_1, pair.aa_1);
            }
            return new JsonDictionary(destination);
        };
    }
    function Companion_34() {}
    protoOf(Companion_34).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonCredentialSubjectItem"));
        return new JsonCredentialSubjectItem(unwrapOptionalBoolean(map, "mandatory"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_36;
    function Companion_getInstance_34() {
        return Companion_instance_36;
    }
    function _get__serializable__azf9o3_7($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.y38_1;
        _serializable$factory_7();
        return this_0.b1();
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubjectItem$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonCredentialSubjectItem._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.x38_1 == null)) this_0.o2(this$0.x38_1.a27());
            if (!(this$0.w38_1 == null)) this_0.m2("mandatory", toJson_2(this$0.w38_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonCredentialSubject(claims) {
        this.u38_1 = claims;
        var tmp = this;
        tmp.v38_1 = lazy(JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubject$_serialized$lambda(this));
    }
    protoOf(JsonCredentialSubject).y26 = function() {
        return this.v38_1.b1();
    };
    protoOf(JsonCredentialSubject).toString = function() {
        return "JsonCredentialSubject(claims=" + toString(this.u38_1) + ")";
    };
    protoOf(JsonCredentialSubject).hashCode = function() {
        return hashCode(this.u38_1);
    };
    protoOf(JsonCredentialSubject).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialSubject)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialSubject ? other : THROW_CCE();
        if (!equals(this.u38_1, tmp0_other_with_cast.u38_1)) return false;
        return true;
    };
    function JsonCredentialSubjectItem(mandatory, customClaims) {
        customClaims = customClaims === VOID ? null : customClaims;
        this.w38_1 = mandatory;
        this.x38_1 = customClaims;
        var tmp = this;
        tmp.y38_1 = lazy(JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubjectItem$_serializable$delegate$lambda(this));
    }
    protoOf(JsonCredentialSubjectItem).y26 = function() {
        return _get__serializable__azf9o3_7(this);
    };
    protoOf(JsonCredentialSubjectItem).toString = function() {
        return "JsonCredentialSubjectItem(mandatory=" + this.w38_1 + ", customClaims=" + toString_0(this.x38_1) + ")";
    };
    protoOf(JsonCredentialSubjectItem).hashCode = function() {
        var result = this.w38_1 == null ? 0 : getBooleanHashCode(this.w38_1);
        result = imul(result, 31) + (this.x38_1 == null ? 0 : hashCode(this.x38_1)) | 0;
        return result;
    };
    protoOf(JsonCredentialSubjectItem).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialSubjectItem)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialSubjectItem ? other : THROW_CCE();
        if (!(this.w38_1 == tmp0_other_with_cast.w38_1)) return false;
        if (!equals(this.x38_1, tmp0_other_with_cast.x38_1)) return false;
        return true;
    };
    function Companion_35() {
        Companion_instance_37 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.z38_1 = [
            new LinkedHashSetSerializer(StringSerializer_getInstance()),
            null
        ];
    }
    var Companion_instance_37;
    function Companion_getInstance_35() {
        if (Companion_instance_37 == null) new Companion_35();
        return Companion_instance_37;
    }
    function $serializer_19() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonAuthorizationDetailsCredentialDefinition", this, 2);
        tmp0_serialDesc.wy("type", true);
        tmp0_serialDesc.wy("credentialSubject", true);
        this.a39_1 = tmp0_serialDesc;
    }
    protoOf($serializer_19).b39 = function(encoder, value) {
        var tmp0_desc = this.a39_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_35().z38_1;
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.c39_1 == null)) tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.c39_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d39_1 == null)) tmp1_output.dt(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), value.d39_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_19).zn = function(encoder, value) {
        return this.b39(encoder, value instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition ? value : THROW_CCE());
    };
    protoOf($serializer_19).ao = function(decoder) {
        var tmp0_desc = this.a39_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_35().z38_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_19).yn = function() {
        return this.a39_1;
    };
    protoOf($serializer_19).lz = function() {
        var tmp0_cached = Companion_getInstance_35().z38_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(tmp0_cached[0]),
            get_nullable(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance())
        ];
    };
    var $serializer_instance_19;
    function $serializer_getInstance_20() {
        if ($serializer_instance_19 == null) new $serializer_19();
        return $serializer_instance_19;
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_20().a39_1);
        if (0 === (seen0 & 1)) $this.c39_1 = null;
        else $this.c39_1 = type;
        if (0 === (seen0 & 2)) $this.d39_1 = null;
        else $this.d39_1 = credentialSubject;
        return $this;
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Create$(seen0, type, credentialSubject, serializationConstructorMarker) {
        return JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition)));
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinition(type, credentialSubject) {
        Companion_getInstance_35();
        type = type === VOID ? null : type;
        credentialSubject = credentialSubject === VOID ? null : credentialSubject;
        this.c39_1 = type;
        this.d39_1 = credentialSubject;
    }
    protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).toString = function() {
        return "JwtVcJsonAuthorizationDetailsCredentialDefinition(type=" + toString_0(this.c39_1) + ", credentialSubject=" + toString_0(this.d39_1) + ")";
    };
    protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).hashCode = function() {
        var result = this.c39_1 == null ? 0 : hashCode(this.c39_1);
        result = imul(result, 31) + (this.d39_1 == null ? 0 : this.d39_1.hashCode()) | 0;
        return result;
    };
    protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition ? other : THROW_CCE();
        if (!equals(this.c39_1, tmp0_other_with_cast.c39_1)) return false;
        if (!equals(this.d39_1, tmp0_other_with_cast.d39_1)) return false;
        return true;
    };
    function _serializable$factory_7() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_7(receiver);
        }, null);
    }
    function Companion_36() {
        Companion_instance_38 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e39_1 = [
            null,
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()),
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12()),
            new ArrayListSerializer(StringSerializer_getInstance())
        ];
    }
    protoOf(Companion_36).b1b = function() {
        return $serializer_getInstance_21();
    };
    var Companion_instance_38;
    function Companion_getInstance_36() {
        if (Companion_instance_38 == null) new Companion_36();
        return Companion_instance_38;
    }
    function $serializer_20() {
        $serializer_instance_20 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonCredentialConfigurationsSupported", this, 8);
        tmp0_serialDesc.wy("format", false);
        tmp0_serialDesc.wy("credential_definition", false);
        tmp0_serialDesc.wy("cryptographic_binding_methods_supported", true);
        tmp0_serialDesc.wy("display", true);
        tmp0_serialDesc.wy("scope", true);
        tmp0_serialDesc.wy("credential_signing_alg_values_supported", true);
        tmp0_serialDesc.wy("proof_types_supported", true);
        tmp0_serialDesc.wy("order", true);
        this.f39_1 = tmp0_serialDesc;
    }
    protoOf($serializer_20).g39 = function(encoder, value) {
        var tmp0_desc = this.f39_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_36().e39_1;
        tmp1_output.zs(tmp0_desc, 0, value.h39_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_22(), value.i39_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.j39_1 == null)) tmp1_output.dt(tmp0_desc, 2, tmp2_cached[2], value.j39_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.k39_1 == null)) tmp1_output.dt(tmp0_desc, 3, tmp2_cached[3], value.k39_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.l39_1 == null)) tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.l39_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.m39_1 == null)) tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.m39_1);
        if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.n39_1 == null)) tmp1_output.dt(tmp0_desc, 6, tmp2_cached[6], value.n39_1);
        if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.o39_1 == null)) tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.o39_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_20).zn = function(encoder, value) {
        return this.g39(encoder, value instanceof JwtVcJsonCredentialConfigurationsSupported ? value : THROW_CCE());
    };
    protoOf($serializer_20).ao = function(decoder) {
        var tmp0_desc = this.f39_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.lr(tmp0_desc);
        var tmp13_cached = Companion_getInstance_36().e39_1;
        if (tmp12_input.as()) {
            tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, tmp13_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else while(tmp1_flag){
            tmp2_index = tmp12_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, tmp13_cached[6], tmp10_local6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp12_input.mr(tmp0_desc);
        return JwtVcJsonCredentialConfigurationsSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
    };
    protoOf($serializer_20).yn = function() {
        return this.f39_1;
    };
    protoOf($serializer_20).lz = function() {
        var tmp0_cached = Companion_getInstance_36().e39_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            $serializer_getInstance_22(),
            get_nullable(tmp0_cached[2]),
            get_nullable(tmp0_cached[3]),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(tmp0_cached[5]),
            get_nullable(tmp0_cached[6]),
            get_nullable(tmp0_cached[7])
        ];
    };
    var $serializer_instance_20;
    function $serializer_getInstance_21() {
        if ($serializer_instance_20 == null) new $serializer_20();
        return $serializer_instance_20;
    }
    function JwtVcJsonCredentialConfigurationsSupported_init_$Init$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_21().f39_1);
        $this.h39_1 = format;
        $this.i39_1 = credentialDefinition;
        if (0 === (seen0 & 4)) $this.j39_1 = null;
        else $this.j39_1 = cryptographicBindingMethodsSupported;
        if (0 === (seen0 & 8)) $this.k39_1 = null;
        else $this.k39_1 = display;
        if (0 === (seen0 & 16)) $this.l39_1 = null;
        else $this.l39_1 = scope;
        if (0 === (seen0 & 32)) $this.m39_1 = null;
        else $this.m39_1 = credentialSigningAlgValuesSupported;
        if (0 === (seen0 & 64)) $this.n39_1 = null;
        else $this.n39_1 = proofTypesSupported;
        if (0 === (seen0 & 128)) $this.o39_1 = null;
        else $this.o39_1 = order;
        return $this;
    }
    function JwtVcJsonCredentialConfigurationsSupported_init_$Create$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker) {
        return JwtVcJsonCredentialConfigurationsSupported_init_$Init$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonCredentialConfigurationsSupported)));
    }
    function JwtVcJsonCredentialConfigurationsSupported() {}
    protoOf(JwtVcJsonCredentialConfigurationsSupported).z33 = function() {
        return this.h39_1;
    };
    protoOf(JwtVcJsonCredentialConfigurationsSupported).toString = function() {
        return "JwtVcJsonCredentialConfigurationsSupported(format=" + this.h39_1 + ", credentialDefinition=" + this.i39_1.toString() + ", cryptographicBindingMethodsSupported=" + toString_0(this.j39_1) + ", display=" + toString_0(this.k39_1) + ", scope=" + this.l39_1 + ", credentialSigningAlgValuesSupported=" + toString_0(this.m39_1) + ", proofTypesSupported=" + toString_0(this.n39_1) + ", order=" + toString_0(this.o39_1) + ")";
    };
    protoOf(JwtVcJsonCredentialConfigurationsSupported).hashCode = function() {
        var result = getStringHashCode(this.h39_1);
        result = imul(result, 31) + this.i39_1.hashCode() | 0;
        result = imul(result, 31) + (this.j39_1 == null ? 0 : hashCode(this.j39_1)) | 0;
        result = imul(result, 31) + (this.k39_1 == null ? 0 : hashCode(this.k39_1)) | 0;
        result = imul(result, 31) + (this.l39_1 == null ? 0 : getStringHashCode(this.l39_1)) | 0;
        result = imul(result, 31) + (this.m39_1 == null ? 0 : hashCode(this.m39_1)) | 0;
        result = imul(result, 31) + (this.n39_1 == null ? 0 : hashCode(this.n39_1)) | 0;
        result = imul(result, 31) + (this.o39_1 == null ? 0 : hashCode(this.o39_1)) | 0;
        return result;
    };
    protoOf(JwtVcJsonCredentialConfigurationsSupported).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonCredentialConfigurationsSupported)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialConfigurationsSupported ? other : THROW_CCE();
        if (!(this.h39_1 === tmp0_other_with_cast.h39_1)) return false;
        if (!this.i39_1.equals(tmp0_other_with_cast.i39_1)) return false;
        if (!equals(this.j39_1, tmp0_other_with_cast.j39_1)) return false;
        if (!equals(this.k39_1, tmp0_other_with_cast.k39_1)) return false;
        if (!(this.l39_1 == tmp0_other_with_cast.l39_1)) return false;
        if (!equals(this.m39_1, tmp0_other_with_cast.m39_1)) return false;
        if (!equals(this.n39_1, tmp0_other_with_cast.n39_1)) return false;
        if (!equals(this.o39_1, tmp0_other_with_cast.o39_1)) return false;
        return true;
    };
    function Companion_37() {
        Companion_instance_39 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.p39_1 = [
            new LinkedHashSetSerializer(StringSerializer_getInstance()),
            null
        ];
    }
    var Companion_instance_39;
    function Companion_getInstance_37() {
        if (Companion_instance_39 == null) new Companion_37();
        return Companion_instance_39;
    }
    function $serializer_21() {
        $serializer_instance_21 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonMetadataCredentialDefinition", this, 2);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("credentialSubject", false);
        this.q39_1 = tmp0_serialDesc;
    }
    protoOf($serializer_21).r39 = function(encoder, value) {
        var tmp0_desc = this.q39_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_37().p39_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.s39_1);
        tmp1_output.dt(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), value.t39_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_21).zn = function(encoder, value) {
        return this.r39(encoder, value instanceof JwtVcJsonMetadataCredentialDefinition ? value : THROW_CCE());
    };
    protoOf($serializer_21).ao = function(decoder) {
        var tmp0_desc = this.q39_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_37().p39_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JwtVcJsonMetadataCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_21).yn = function() {
        return this.q39_1;
    };
    protoOf($serializer_21).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_37().p39_1[0],
            get_nullable(JwtVcJsonCredentialSubjectMetadataSerializer_getInstance())
        ];
    };
    var $serializer_instance_21;
    function $serializer_getInstance_22() {
        if ($serializer_instance_21 == null) new $serializer_21();
        return $serializer_instance_21;
    }
    function JwtVcJsonMetadataCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_22().q39_1);
        $this.s39_1 = type;
        $this.t39_1 = credentialSubject;
        return $this;
    }
    function JwtVcJsonMetadataCredentialDefinition_init_$Create$(seen0, type, credentialSubject, serializationConstructorMarker) {
        return JwtVcJsonMetadataCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonMetadataCredentialDefinition)));
    }
    function JwtVcJsonMetadataCredentialDefinition() {}
    protoOf(JwtVcJsonMetadataCredentialDefinition).toString = function() {
        return "JwtVcJsonMetadataCredentialDefinition(type=" + toString(this.s39_1) + ", credentialSubject=" + toString_0(this.t39_1) + ")";
    };
    protoOf(JwtVcJsonMetadataCredentialDefinition).hashCode = function() {
        var result = hashCode(this.s39_1);
        result = imul(result, 31) + (this.t39_1 == null ? 0 : this.t39_1.hashCode()) | 0;
        return result;
    };
    protoOf(JwtVcJsonMetadataCredentialDefinition).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonMetadataCredentialDefinition)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonMetadataCredentialDefinition ? other : THROW_CCE();
        if (!equals(this.s39_1, tmp0_other_with_cast.s39_1)) return false;
        if (!equals(this.t39_1, tmp0_other_with_cast.t39_1)) return false;
        return true;
    };
    function Companion_38() {}
    protoOf(Companion_38).d27 = function(json) {
        var map = FromJsonHelper_instance.b27(json, "JwtVcJsonCredentialSubjectMetadata");
        // Inline function 'kotlin.collections.associate' call
        var this_0 = map.z();
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.plusAssign' call
            // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            var pair = to(key, Companion_instance_41.d27(value));
            destination.m2(pair.z9_1, pair.aa_1);
        }
        return new JwtVcJsonCredentialSubjectMetadata(destination);
    };
    var Companion_instance_40;
    function Companion_getInstance_38() {
        return Companion_instance_40;
    }
    function JwtVcJsonCredentialSubjectMetadata$_serialized$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.associate' call
            var this_0 = this$0.u39_1.z();
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateTo' call
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.plusAssign' call
                // Inline function 'io.curity.vc.serialization.JwtVcJsonCredentialSubjectMetadata._serialized.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = element.b1();
                var pair = to(key, value.y26().a27());
                destination.m2(pair.z9_1, pair.aa_1);
            }
            return new JsonDictionary(destination);
        };
    }
    function JwtVcJsonCredentialSubjectMetadata(claims) {
        this.u39_1 = claims;
        var tmp = this;
        tmp.v39_1 = lazy(JwtVcJsonCredentialSubjectMetadata$_serialized$lambda(this));
    }
    protoOf(JwtVcJsonCredentialSubjectMetadata).y26 = function() {
        return this.v39_1.b1();
    };
    protoOf(JwtVcJsonCredentialSubjectMetadata).toString = function() {
        return "JwtVcJsonCredentialSubjectMetadata(claims=" + toString(this.u39_1) + ")";
    };
    protoOf(JwtVcJsonCredentialSubjectMetadata).hashCode = function() {
        return hashCode(this.u39_1);
    };
    protoOf(JwtVcJsonCredentialSubjectMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonCredentialSubjectMetadata)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialSubjectMetadata ? other : THROW_CCE();
        if (!equals(this.u39_1, tmp0_other_with_cast.u39_1)) return false;
        return true;
    };
    function Companion_39() {}
    protoOf(Companion_39).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonLogo"));
        return new JwtVcJsonCredentialSubjectEntryMetadata(unwrapOptionalString(map, "value_type"), unwrapOptionalDisplays(map, "display"), unwrapOptionalBoolean(map, "mandatory"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_41;
    function Companion_getInstance_39() {
        return Companion_instance_41;
    }
    function _get__serializable__azf9o3_8($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.a3a_1;
        _serializable$factory_8();
        return this_0.b1();
    }
    function JwtVcJsonCredentialSubjectEntryMetadata$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JwtVcJsonCredentialSubjectEntryMetadata._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.z39_1 == null)) this_0.o2(this$0.z39_1.a27());
            if (!(this$0.w39_1 == null)) this_0.m2("value_type", toJson(this$0.w39_1));
            if (!(this$0.x39_1 == null)) this_0.m2("display", toJsons(this$0.x39_1));
            if (!(this$0.y39_1 == null)) this_0.m2("mandatory", toJson_2(this$0.y39_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JwtVcJsonCredentialSubjectEntryMetadata(valueType, display, mandatory, customClaims) {
        valueType = valueType === VOID ? null : valueType;
        display = display === VOID ? null : display;
        mandatory = mandatory === VOID ? null : mandatory;
        customClaims = customClaims === VOID ? null : customClaims;
        this.w39_1 = valueType;
        this.x39_1 = display;
        this.y39_1 = mandatory;
        this.z39_1 = customClaims;
        var tmp = this;
        tmp.a3a_1 = lazy(JwtVcJsonCredentialSubjectEntryMetadata$_serializable$delegate$lambda(this));
    }
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).y26 = function() {
        return _get__serializable__azf9o3_8(this);
    };
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).toString = function() {
        return "JwtVcJsonCredentialSubjectEntryMetadata(valueType=" + this.w39_1 + ", display=" + toString_0(this.x39_1) + ", mandatory=" + this.y39_1 + ", customClaims=" + toString_0(this.z39_1) + ")";
    };
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).hashCode = function() {
        var result = this.w39_1 == null ? 0 : getStringHashCode(this.w39_1);
        result = imul(result, 31) + (this.x39_1 == null ? 0 : hashCode(this.x39_1)) | 0;
        result = imul(result, 31) + (this.y39_1 == null ? 0 : getBooleanHashCode(this.y39_1)) | 0;
        result = imul(result, 31) + (this.z39_1 == null ? 0 : hashCode(this.z39_1)) | 0;
        return result;
    };
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonCredentialSubjectEntryMetadata)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialSubjectEntryMetadata ? other : THROW_CCE();
        if (!(this.w39_1 == tmp0_other_with_cast.w39_1)) return false;
        if (!equals(this.x39_1, tmp0_other_with_cast.x39_1)) return false;
        if (!(this.y39_1 == tmp0_other_with_cast.y39_1)) return false;
        if (!equals(this.z39_1, tmp0_other_with_cast.z39_1)) return false;
        return true;
    };
    function _serializable$factory_8() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_8(receiver);
        }, null);
    }
    function Companion_40() {}
    protoOf(Companion_40).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "CredentialDefinition"));
        return new CredentialDefinition(unwrapStringSet(map, "type"), unwrapOptionalJsonDictionary(map, "credentialSubject"));
    };
    var Companion_instance_42;
    function Companion_getInstance_40() {
        return Companion_instance_42;
    }
    function _get__serializable__azf9o3_9($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.d3a_1;
        _serializable$factory_9();
        return this_0.b1();
    }
    function JwtVcJsonVerifiableCredentialRequest$CredentialDefinition$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.CredentialDefinition._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.m2("type", toJson_3(this$0.b3a_1));
            if (!(this$0.c3a_1 == null)) this_0.m2("credentialSubject", this$0.c3a_1.a27());
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function CredentialDefinition(type, credentialSubject) {
        credentialSubject = credentialSubject === VOID ? null : credentialSubject;
        this.b3a_1 = type;
        this.c3a_1 = credentialSubject;
        var tmp = this;
        tmp.d3a_1 = lazy(JwtVcJsonVerifiableCredentialRequest$CredentialDefinition$_serializable$delegate$lambda(this));
    }
    protoOf(CredentialDefinition).y26 = function() {
        return _get__serializable__azf9o3_9(this);
    };
    protoOf(CredentialDefinition).toString = function() {
        return "CredentialDefinition(type=" + toString(this.b3a_1) + ", credentialSubject=" + toString_0(this.c3a_1) + ")";
    };
    protoOf(CredentialDefinition).hashCode = function() {
        var result = hashCode(this.b3a_1);
        result = imul(result, 31) + (this.c3a_1 == null ? 0 : hashCode(this.c3a_1)) | 0;
        return result;
    };
    protoOf(CredentialDefinition).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CredentialDefinition)) return false;
        var tmp0_other_with_cast = other instanceof CredentialDefinition ? other : THROW_CCE();
        if (!equals(this.b3a_1, tmp0_other_with_cast.b3a_1)) return false;
        if (!equals(this.c3a_1, tmp0_other_with_cast.c3a_1)) return false;
        return true;
    };
    function Companion_41() {}
    var Companion_instance_43;
    function Companion_getInstance_41() {
        return Companion_instance_43;
    }
    function $serializer_22() {
        $serializer_instance_22 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonVerifiableCredentialRequest", this, 3);
        tmp0_serialDesc.wy("proof", true);
        tmp0_serialDesc.wy("credential_definition", false);
        tmp0_serialDesc.wy("format", false);
        this.e3a_1 = tmp0_serialDesc;
    }
    protoOf($serializer_22).f3a = function(encoder, value) {
        var tmp0_desc = this.e3a_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.g3a_1 == null)) tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.g3a_1);
        tmp1_output.bt(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), value.h3a_1);
        tmp1_output.zs(tmp0_desc, 2, value.i3a_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_22).zn = function(encoder, value) {
        return this.f3a(encoder, value instanceof JwtVcJsonVerifiableCredentialRequest ? value : THROW_CCE());
    };
    protoOf($serializer_22).ao = function(decoder) {
        var tmp0_desc = this.e3a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JwtVcJsonVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_22).yn = function() {
        return this.e3a_1;
    };
    protoOf($serializer_22).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(ToJsonProofOfPossessionSerializer_getInstance()),
            JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_22;
    function $serializer_getInstance_23() {
        if ($serializer_instance_22 == null) new $serializer_22();
        return $serializer_instance_22;
    }
    function JwtVcJsonVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
        if (!(6 === (6 & seen0))) throwMissingFieldException(seen0, 6, $serializer_getInstance_23().e3a_1);
        if (0 === (seen0 & 1)) $this.g3a_1 = null;
        else $this.g3a_1 = proof;
        $this.h3a_1 = credentialDefinition;
        $this.i3a_1 = format;
        return $this;
    }
    function JwtVcJsonVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
        return JwtVcJsonVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonVerifiableCredentialRequest)));
    }
    function JwtVcJsonVerifiableCredentialRequest(proof, credentialDefinition, format) {
        proof = proof === VOID ? null : proof;
        format = format === VOID ? "jwt_vc_json" : format;
        this.g3a_1 = proof;
        this.h3a_1 = credentialDefinition;
        this.i3a_1 = format;
    }
    protoOf(JwtVcJsonVerifiableCredentialRequest).toString = function() {
        return "JwtVcJsonVerifiableCredentialRequest(proof=" + toString_0(this.g3a_1) + ", credentialDefinition=" + this.h3a_1.toString() + ", format=" + this.i3a_1 + ")";
    };
    protoOf(JwtVcJsonVerifiableCredentialRequest).hashCode = function() {
        var result = this.g3a_1 == null ? 0 : hashCode(this.g3a_1);
        result = imul(result, 31) + this.h3a_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.i3a_1) | 0;
        return result;
    };
    protoOf(JwtVcJsonVerifiableCredentialRequest).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonVerifiableCredentialRequest)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonVerifiableCredentialRequest ? other : THROW_CCE();
        if (!equals(this.g3a_1, tmp0_other_with_cast.g3a_1)) return false;
        if (!this.h3a_1.equals(tmp0_other_with_cast.h3a_1)) return false;
        if (!(this.i3a_1 === tmp0_other_with_cast.i3a_1)) return false;
        return true;
    };
    function Companion_42() {}
    protoOf(Companion_42).b1b = function() {
        return $serializer_getInstance_24();
    };
    var Companion_instance_44;
    function Companion_getInstance_42() {
        return Companion_instance_44;
    }
    function $serializer_23() {
        $serializer_instance_23 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonLdVerifiableCredentialRequest", this, 3);
        tmp0_serialDesc.wy("proof", true);
        tmp0_serialDesc.wy("credential_definition", false);
        tmp0_serialDesc.wy("format", false);
        this.j3a_1 = tmp0_serialDesc;
    }
    protoOf($serializer_23).k3a = function(encoder, value) {
        var tmp0_desc = this.j3a_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.l3a_1 == null)) tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.l3a_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_7(), value.m3a_1);
        tmp1_output.zs(tmp0_desc, 2, value.n3a_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_23).zn = function(encoder, value) {
        return this.k3a(encoder, value instanceof JwtVcJsonLdVerifiableCredentialRequest ? value : THROW_CCE());
    };
    protoOf($serializer_23).ao = function(decoder) {
        var tmp0_desc = this.j3a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JwtVcJsonLdVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_23).yn = function() {
        return this.j3a_1;
    };
    protoOf($serializer_23).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(ToJsonProofOfPossessionSerializer_getInstance()),
            $serializer_getInstance_7(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_23;
    function $serializer_getInstance_24() {
        if ($serializer_instance_23 == null) new $serializer_23();
        return $serializer_instance_23;
    }
    function JwtVcJsonLdVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
        if (!(6 === (6 & seen0))) throwMissingFieldException(seen0, 6, $serializer_getInstance_24().j3a_1);
        if (0 === (seen0 & 1)) $this.l3a_1 = null;
        else $this.l3a_1 = proof;
        $this.m3a_1 = credentialDefinition;
        $this.n3a_1 = format;
        return $this;
    }
    function JwtVcJsonLdVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
        return JwtVcJsonLdVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonLdVerifiableCredentialRequest)));
    }
    function JwtVcJsonLdVerifiableCredentialRequest(proof, credentialDefinition, format) {
        proof = proof === VOID ? null : proof;
        format = format === VOID ? "jwt_vc_json-ld" : format;
        this.l3a_1 = proof;
        this.m3a_1 = credentialDefinition;
        this.n3a_1 = format;
    }
    protoOf(JwtVcJsonLdVerifiableCredentialRequest).toString = function() {
        return "JwtVcJsonLdVerifiableCredentialRequest(proof=" + toString_0(this.l3a_1) + ", credentialDefinition=" + this.m3a_1.toString() + ", format=" + this.n3a_1 + ")";
    };
    protoOf(JwtVcJsonLdVerifiableCredentialRequest).hashCode = function() {
        var result = this.l3a_1 == null ? 0 : hashCode(this.l3a_1);
        result = imul(result, 31) + this.m3a_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.n3a_1) | 0;
        return result;
    };
    protoOf(JwtVcJsonLdVerifiableCredentialRequest).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonLdVerifiableCredentialRequest)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonLdVerifiableCredentialRequest ? other : THROW_CCE();
        if (!equals(this.l3a_1, tmp0_other_with_cast.l3a_1)) return false;
        if (!this.m3a_1.equals(tmp0_other_with_cast.m3a_1)) return false;
        if (!(this.n3a_1 === tmp0_other_with_cast.n3a_1)) return false;
        return true;
    };
    function Companion_43() {}
    protoOf(Companion_43).b1b = function() {
        return $serializer_getInstance_25();
    };
    var Companion_instance_45;
    function Companion_getInstance_43() {
        return Companion_instance_45;
    }
    function $serializer_24() {
        $serializer_instance_24 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.LdpVerifiableCredentialRequest", this, 3);
        tmp0_serialDesc.wy("proof", true);
        tmp0_serialDesc.wy("credential_definition", false);
        tmp0_serialDesc.wy("format", false);
        this.o3a_1 = tmp0_serialDesc;
    }
    protoOf($serializer_24).p3a = function(encoder, value) {
        var tmp0_desc = this.o3a_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.q3a_1 == null)) tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.q3a_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_7(), value.r3a_1);
        tmp1_output.zs(tmp0_desc, 2, value.s3a_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_24).zn = function(encoder, value) {
        return this.p3a(encoder, value instanceof LdpVerifiableCredentialRequest ? value : THROW_CCE());
    };
    protoOf($serializer_24).ao = function(decoder) {
        var tmp0_desc = this.o3a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return LdpVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_24).yn = function() {
        return this.o3a_1;
    };
    protoOf($serializer_24).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(ToJsonProofOfPossessionSerializer_getInstance()),
            $serializer_getInstance_7(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_24;
    function $serializer_getInstance_25() {
        if ($serializer_instance_24 == null) new $serializer_24();
        return $serializer_instance_24;
    }
    function LdpVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
        if (!(6 === (6 & seen0))) throwMissingFieldException(seen0, 6, $serializer_getInstance_25().o3a_1);
        if (0 === (seen0 & 1)) $this.q3a_1 = null;
        else $this.q3a_1 = proof;
        $this.r3a_1 = credentialDefinition;
        $this.s3a_1 = format;
        return $this;
    }
    function LdpVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
        return LdpVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(LdpVerifiableCredentialRequest)));
    }
    function LdpVerifiableCredentialRequest(proof, credentialDefinition, format) {
        proof = proof === VOID ? null : proof;
        format = format === VOID ? "ldp_vc" : format;
        this.q3a_1 = proof;
        this.r3a_1 = credentialDefinition;
        this.s3a_1 = format;
    }
    protoOf(LdpVerifiableCredentialRequest).toString = function() {
        return "LdpVerifiableCredentialRequest(proof=" + toString_0(this.q3a_1) + ", credentialDefinition=" + this.r3a_1.toString() + ", format=" + this.s3a_1 + ")";
    };
    protoOf(LdpVerifiableCredentialRequest).hashCode = function() {
        var result = this.q3a_1 == null ? 0 : hashCode(this.q3a_1);
        result = imul(result, 31) + this.r3a_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.s3a_1) | 0;
        return result;
    };
    protoOf(LdpVerifiableCredentialRequest).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof LdpVerifiableCredentialRequest)) return false;
        var tmp0_other_with_cast = other instanceof LdpVerifiableCredentialRequest ? other : THROW_CCE();
        if (!equals(this.q3a_1, tmp0_other_with_cast.q3a_1)) return false;
        if (!this.r3a_1.equals(tmp0_other_with_cast.r3a_1)) return false;
        if (!(this.s3a_1 === tmp0_other_with_cast.s3a_1)) return false;
        return true;
    };
    function Companion_44() {
        Companion_instance_46 = this;
        CompositeFromJson.call(this, Companion_instance_0);
        this.u3a_1 = new JsonObject(emptyMap());
    }
    protoOf(Companion_44).v3a = function(toJson) {
        return new BasicCredentialSubject(toJson.f2());
    };
    protoOf(Companion_44).n27 = function(toJson) {
        return this.v3a(toJson instanceof JsonDictionary ? toJson : THROW_CCE());
    };
    var Companion_instance_46;
    function Companion_getInstance_44() {
        if (Companion_instance_46 == null) new Companion_44();
        return Companion_instance_46;
    }
    function _get__map__d2qn2m($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.x3a_1;
        _map$factory();
        return this_0.b1();
    }
    function BasicCredentialSubject$_map$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.associateWith' call
            var this_0 = this$0.w3a_1;
            var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
            // Inline function 'kotlin.collections.associateWithTo' call
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.curity.vc.serialization.BasicCredentialSubject._map$delegate.<anonymous>.<anonymous>' call
                var tmp$ret$0 = Companion_getInstance_44().u3a_1;
                result.m2(element, tmp$ret$0);
            }
            return result;
        };
    }
    function BasicCredentialSubject(_claims) {
        Companion_getInstance_44();
        this.w3a_1 = _claims;
        var tmp = this;
        tmp.x3a_1 = lazy(BasicCredentialSubject$_map$delegate$lambda(this));
    }
    protoOf(BasicCredentialSubject).y26 = function() {
        return new JsonDictionary(_get__map__d2qn2m(this));
    };
    protoOf(BasicCredentialSubject).xl = function() {
        return _get__map__d2qn2m(this);
    };
    protoOf(BasicCredentialSubject).toString = function() {
        return "BasicCredentialSubject(_claims=" + toString(this.w3a_1) + ")";
    };
    protoOf(BasicCredentialSubject).hashCode = function() {
        return hashCode(this.w3a_1);
    };
    protoOf(BasicCredentialSubject).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof BasicCredentialSubject)) return false;
        var tmp0_other_with_cast = other instanceof BasicCredentialSubject ? other : THROW_CCE();
        if (!equals(this.w3a_1, tmp0_other_with_cast.w3a_1)) return false;
        return true;
    };
    function _serializable$factory_9() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_9(receiver);
        }, null);
    }
    function _map$factory() {
        return getPropertyCallableRef("_map", 1, KProperty1, function(receiver) {
            return _get__map__d2qn2m(receiver);
        }, null);
    }
    function Companion_45() {}
    protoOf(Companion_45).b1b = function() {
        return $serializer_getInstance_26();
    };
    var Companion_instance_47;
    function Companion_getInstance_45() {
        return Companion_instance_47;
    }
    function $serializer_25() {
        $serializer_instance_25 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonVerifiableCredentialResponse", this, 3);
        tmp0_serialDesc.wy("credential", false);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.y3a_1 = tmp0_serialDesc;
    }
    protoOf($serializer_25).z3a = function(encoder, value) {
        var tmp0_desc = this.y3a_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.a3b_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.b3b_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.b3b_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.c3b_1 == null)) tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.c3b_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_25).zn = function(encoder, value) {
        return this.z3a(encoder, value instanceof JwtVcJsonVerifiableCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_25).ao = function(decoder) {
        var tmp0_desc = this.y3a_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JwtVcJsonVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_25).yn = function() {
        return this.y3a_1;
    };
    protoOf($serializer_25).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance_25;
    function $serializer_getInstance_26() {
        if ($serializer_instance_25 == null) new $serializer_25();
        return $serializer_instance_25;
    }
    function JwtVcJsonVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_26().y3a_1);
        $this.a3b_1 = _credential;
        if (0 === (seen0 & 2)) $this.b3b_1 = null;
        else $this.b3b_1 = cNonce;
        if (0 === (seen0 & 4)) $this.c3b_1 = null;
        else $this.c3b_1 = cNonceExpiresIn;
        return $this;
    }
    function JwtVcJsonVerifiableCredentialResponse_init_$Create$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return JwtVcJsonVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonVerifiableCredentialResponse)));
    }
    function JwtVcJsonVerifiableCredentialResponse() {}
    protoOf(JwtVcJsonVerifiableCredentialResponse).n38 = function() {
        return new StringCredential(this.a3b_1);
    };
    protoOf(JwtVcJsonVerifiableCredentialResponse).toString = function() {
        return "JwtVcJsonVerifiableCredentialResponse(_credential=" + this.a3b_1 + ", cNonce=" + this.b3b_1 + ", cNonceExpiresIn=" + toString_0(this.c3b_1) + ")";
    };
    protoOf(JwtVcJsonVerifiableCredentialResponse).hashCode = function() {
        var result = getStringHashCode(this.a3b_1);
        result = imul(result, 31) + (this.b3b_1 == null ? 0 : getStringHashCode(this.b3b_1)) | 0;
        result = imul(result, 31) + (this.c3b_1 == null ? 0 : this.c3b_1.hashCode()) | 0;
        return result;
    };
    protoOf(JwtVcJsonVerifiableCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonVerifiableCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonVerifiableCredentialResponse ? other : THROW_CCE();
        if (!(this.a3b_1 === tmp0_other_with_cast.a3b_1)) return false;
        if (!(this.b3b_1 == tmp0_other_with_cast.b3b_1)) return false;
        if (!equals(this.c3b_1, tmp0_other_with_cast.c3b_1)) return false;
        return true;
    };
    function Companion_46() {}
    protoOf(Companion_46).b1b = function() {
        return $serializer_getInstance_27();
    };
    var Companion_instance_48;
    function Companion_getInstance_46() {
        return Companion_instance_48;
    }
    function $serializer_26() {
        $serializer_instance_26 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.LdpVcVerifiableCredentialResponse", this, 3);
        tmp0_serialDesc.wy("credential", false);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.d3b_1 = tmp0_serialDesc;
    }
    protoOf($serializer_26).e3b = function(encoder, value) {
        var tmp0_desc = this.d3b_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.bt(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), value.f3b_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.g3b_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.g3b_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.h3b_1 == null)) tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.h3b_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_26).zn = function(encoder, value) {
        return this.e3b(encoder, value instanceof LdpVcVerifiableCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_26).ao = function(decoder) {
        var tmp0_desc = this.d3b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return LdpVcVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_26).yn = function() {
        return this.d3b_1;
    };
    protoOf($serializer_26).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            SerializableW3CVerifiableCredentialSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance_26;
    function $serializer_getInstance_27() {
        if ($serializer_instance_26 == null) new $serializer_26();
        return $serializer_instance_26;
    }
    function LdpVcVerifiableCredentialResponse_init_$Init$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_27().d3b_1);
        $this.f3b_1 = w3cCredential;
        if (0 === (seen0 & 2)) $this.g3b_1 = null;
        else $this.g3b_1 = cNonce;
        if (0 === (seen0 & 4)) $this.h3b_1 = null;
        else $this.h3b_1 = cNonceExpiresIn;
        return $this;
    }
    function LdpVcVerifiableCredentialResponse_init_$Create$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return LdpVcVerifiableCredentialResponse_init_$Init$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(LdpVcVerifiableCredentialResponse)));
    }
    function LdpVcVerifiableCredentialResponse() {}
    protoOf(LdpVcVerifiableCredentialResponse).n38 = function() {
        return new DictionaryCredential(this.f3b_1);
    };
    protoOf(LdpVcVerifiableCredentialResponse).toString = function() {
        return "LdpVcVerifiableCredentialResponse(w3cCredential=" + this.f3b_1.toString() + ", cNonce=" + this.g3b_1 + ", cNonceExpiresIn=" + toString_0(this.h3b_1) + ")";
    };
    protoOf(LdpVcVerifiableCredentialResponse).hashCode = function() {
        var result = this.f3b_1.hashCode();
        result = imul(result, 31) + (this.g3b_1 == null ? 0 : getStringHashCode(this.g3b_1)) | 0;
        result = imul(result, 31) + (this.h3b_1 == null ? 0 : this.h3b_1.hashCode()) | 0;
        return result;
    };
    protoOf(LdpVcVerifiableCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof LdpVcVerifiableCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof LdpVcVerifiableCredentialResponse ? other : THROW_CCE();
        if (!this.f3b_1.equals(tmp0_other_with_cast.f3b_1)) return false;
        if (!(this.g3b_1 == tmp0_other_with_cast.g3b_1)) return false;
        if (!equals(this.h3b_1, tmp0_other_with_cast.h3b_1)) return false;
        return true;
    };
    function Companion_47() {}
    protoOf(Companion_47).b1b = function() {
        return $serializer_getInstance_28();
    };
    var Companion_instance_49;
    function Companion_getInstance_47() {
        return Companion_instance_49;
    }
    function $serializer_27() {
        $serializer_instance_27 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.JwtVcJsonLdVerifiableCredentialResponse", this, 3);
        tmp0_serialDesc.wy("credential", false);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.i3b_1 = tmp0_serialDesc;
    }
    protoOf($serializer_27).j3b = function(encoder, value) {
        var tmp0_desc = this.i3b_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.k3b_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.l3b_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.l3b_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.m3b_1 == null)) tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.m3b_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_27).zn = function(encoder, value) {
        return this.j3b(encoder, value instanceof JwtVcJsonLdVerifiableCredentialResponse ? value : THROW_CCE());
    };
    protoOf($serializer_27).ao = function(decoder) {
        var tmp0_desc = this.i3b_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JwtVcJsonLdVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_27).yn = function() {
        return this.i3b_1;
    };
    protoOf($serializer_27).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance_27;
    function $serializer_getInstance_28() {
        if ($serializer_instance_27 == null) new $serializer_27();
        return $serializer_instance_27;
    }
    function JwtVcJsonLdVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_28().i3b_1);
        $this.k3b_1 = _credential;
        if (0 === (seen0 & 2)) $this.l3b_1 = null;
        else $this.l3b_1 = cNonce;
        if (0 === (seen0 & 4)) $this.m3b_1 = null;
        else $this.m3b_1 = cNonceExpiresIn;
        return $this;
    }
    function JwtVcJsonLdVerifiableCredentialResponse_init_$Create$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return JwtVcJsonLdVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonLdVerifiableCredentialResponse)));
    }
    function JwtVcJsonLdVerifiableCredentialResponse() {}
    protoOf(JwtVcJsonLdVerifiableCredentialResponse).n38 = function() {
        return new StringCredential(this.k3b_1);
    };
    protoOf(JwtVcJsonLdVerifiableCredentialResponse).toString = function() {
        return "JwtVcJsonLdVerifiableCredentialResponse(_credential=" + this.k3b_1 + ", cNonce=" + this.l3b_1 + ", cNonceExpiresIn=" + toString_0(this.m3b_1) + ")";
    };
    protoOf(JwtVcJsonLdVerifiableCredentialResponse).hashCode = function() {
        var result = getStringHashCode(this.k3b_1);
        result = imul(result, 31) + (this.l3b_1 == null ? 0 : getStringHashCode(this.l3b_1)) | 0;
        result = imul(result, 31) + (this.m3b_1 == null ? 0 : this.m3b_1.hashCode()) | 0;
        return result;
    };
    protoOf(JwtVcJsonLdVerifiableCredentialResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JwtVcJsonLdVerifiableCredentialResponse)) return false;
        var tmp0_other_with_cast = other instanceof JwtVcJsonLdVerifiableCredentialResponse ? other : THROW_CCE();
        if (!(this.k3b_1 === tmp0_other_with_cast.k3b_1)) return false;
        if (!(this.l3b_1 == tmp0_other_with_cast.l3b_1)) return false;
        if (!equals(this.m3b_1, tmp0_other_with_cast.m3b_1)) return false;
        return true;
    };
    function Companion_48() {}
    protoOf(Companion_48).b1b = function() {
        return DeferredJwtVcJsonCredentialResponseSerializer_getInstance();
    };
    var Companion_instance_50;
    function Companion_getInstance_48() {
        return Companion_instance_50;
    }
    function Deferred(value) {
        this.n3b_1 = value;
    }
    protoOf(Deferred).toString = function() {
        return "Deferred(value=" + this.n3b_1.toString() + ")";
    };
    protoOf(Deferred).hashCode = function() {
        return this.n3b_1.hashCode();
    };
    protoOf(Deferred).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Deferred)) return false;
        var tmp0_other_with_cast = other instanceof Deferred ? other : THROW_CCE();
        if (!this.n3b_1.equals(tmp0_other_with_cast.n3b_1)) return false;
        return true;
    };
    function JwtVcJsonCredentialResponse() {}
    function Companion_49() {}
    protoOf(Companion_49).b1b = function() {
        return DeferredLdpVcCredentialResponseSerializer_getInstance();
    };
    var Companion_instance_51;
    function Companion_getInstance_49() {
        return Companion_instance_51;
    }
    function Deferred_0(value) {
        this.o3b_1 = value;
    }
    protoOf(Deferred_0).toString = function() {
        return "Deferred(value=" + this.o3b_1.toString() + ")";
    };
    protoOf(Deferred_0).hashCode = function() {
        return this.o3b_1.hashCode();
    };
    protoOf(Deferred_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Deferred_0)) return false;
        var tmp0_other_with_cast = other instanceof Deferred_0 ? other : THROW_CCE();
        if (!this.o3b_1.equals(tmp0_other_with_cast.o3b_1)) return false;
        return true;
    };
    function LdpVcCredentialResponse() {}
    function Companion_50() {}
    protoOf(Companion_50).b1b = function() {
        return DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance();
    };
    var Companion_instance_52;
    function Companion_getInstance_50() {
        return Companion_instance_52;
    }
    function Deferred_1(value) {
        this.p3b_1 = value;
    }
    protoOf(Deferred_1).toString = function() {
        return "Deferred(value=" + this.p3b_1.toString() + ")";
    };
    protoOf(Deferred_1).hashCode = function() {
        return this.p3b_1.hashCode();
    };
    protoOf(Deferred_1).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Deferred_1)) return false;
        var tmp0_other_with_cast = other instanceof Deferred_1 ? other : THROW_CCE();
        if (!this.p3b_1.equals(tmp0_other_with_cast.p3b_1)) return false;
        return true;
    };
    function JwtVcJsonLdCredentialResponse() {}
    function Companion_51() {}
    protoOf(Companion_51).b1b = function() {
        return DeferredVcSdJwtCredentialResponseSerializer_getInstance();
    };
    var Companion_instance_53;
    function Companion_getInstance_51() {
        return Companion_instance_53;
    }
    function Deferred_2(value) {
        this.q3b_1 = value;
    }
    protoOf(Deferred_2).toString = function() {
        return "Deferred(value=" + this.q3b_1.toString() + ")";
    };
    protoOf(Deferred_2).hashCode = function() {
        return this.q3b_1.hashCode();
    };
    protoOf(Deferred_2).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Deferred_2)) return false;
        var tmp0_other_with_cast = other instanceof Deferred_2 ? other : THROW_CCE();
        if (!this.q3b_1.equals(tmp0_other_with_cast.q3b_1)) return false;
        return true;
    };
    function VcSdJwtCredentialResponse() {}
    function JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer() {
        JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_42);
    }
    var JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance;
    function JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance() {
        if (JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance == null) new JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer();
        return JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance;
    }
    function DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0(v) {
        return v.n3b_1;
    }
    function DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0_0(v) {
        return new Deferred(v);
    }
    function DeferredJwtVcJsonCredentialResponseSerializer() {
        DeferredJwtVcJsonCredentialResponseSerializer_instance = this;
        var tmp = Companion_instance_25.b1b();
        var tmp_0 = DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0;
        DerivedSerializer.call(this, tmp, tmp_0, DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0_0);
    }
    var DeferredJwtVcJsonCredentialResponseSerializer_instance;
    function DeferredJwtVcJsonCredentialResponseSerializer_getInstance() {
        if (DeferredJwtVcJsonCredentialResponseSerializer_instance == null) new DeferredJwtVcJsonCredentialResponseSerializer();
        return DeferredJwtVcJsonCredentialResponseSerializer_instance;
    }
    function JwtVcJsonCredentialResponseSerializer() {
        JwtVcJsonCredentialResponseSerializer_instance = this;
        VerifiableCredentialResponseSerializer.call(this, getKClass(JwtVcJsonCredentialResponse), "jwt_vc_json", Companion_instance_50.b1b(), Companion_instance_47.b1b());
    }
    var JwtVcJsonCredentialResponseSerializer_instance;
    function JwtVcJsonCredentialResponseSerializer_getInstance() {
        if (JwtVcJsonCredentialResponseSerializer_instance == null) new JwtVcJsonCredentialResponseSerializer();
        return JwtVcJsonCredentialResponseSerializer_instance;
    }
    function DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez(v) {
        return v.o3b_1;
    }
    function DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez_0(v) {
        return new Deferred_0(v);
    }
    function DeferredLdpVcCredentialResponseSerializer() {
        DeferredLdpVcCredentialResponseSerializer_instance = this;
        var tmp = Companion_instance_25.b1b();
        var tmp_0 = DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez;
        DerivedSerializer.call(this, tmp, tmp_0, DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez_0);
    }
    var DeferredLdpVcCredentialResponseSerializer_instance;
    function DeferredLdpVcCredentialResponseSerializer_getInstance() {
        if (DeferredLdpVcCredentialResponseSerializer_instance == null) new DeferredLdpVcCredentialResponseSerializer();
        return DeferredLdpVcCredentialResponseSerializer_instance;
    }
    function LdpVcCredentialResponseSerializer() {
        LdpVcCredentialResponseSerializer_instance = this;
        VerifiableCredentialResponseSerializer.call(this, getKClass(LdpVcCredentialResponse), "ldp_vc", Companion_instance_51.b1b(), Companion_instance_48.b1b());
    }
    var LdpVcCredentialResponseSerializer_instance;
    function LdpVcCredentialResponseSerializer_getInstance() {
        if (LdpVcCredentialResponseSerializer_instance == null) new LdpVcCredentialResponseSerializer();
        return LdpVcCredentialResponseSerializer_instance;
    }
    function DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k(v) {
        return v.p3b_1;
    }
    function DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k_0(v) {
        return new Deferred_1(v);
    }
    function DeferredJwtVcJsonLdCredentialResponseSerializer() {
        DeferredJwtVcJsonLdCredentialResponseSerializer_instance = this;
        var tmp = Companion_instance_25.b1b();
        var tmp_0 = DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k;
        DerivedSerializer.call(this, tmp, tmp_0, DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k_0);
    }
    var DeferredJwtVcJsonLdCredentialResponseSerializer_instance;
    function DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance() {
        if (DeferredJwtVcJsonLdCredentialResponseSerializer_instance == null) new DeferredJwtVcJsonLdCredentialResponseSerializer();
        return DeferredJwtVcJsonLdCredentialResponseSerializer_instance;
    }
    function JwtVcJsonLdCredentialResponseSerializer() {
        JwtVcJsonLdCredentialResponseSerializer_instance = this;
        VerifiableCredentialResponseSerializer.call(this, getKClass(JwtVcJsonLdCredentialResponse), "jwt_vc_json-ld", Companion_instance_52.b1b(), Companion_instance_49.b1b());
    }
    var JwtVcJsonLdCredentialResponseSerializer_instance;
    function JwtVcJsonLdCredentialResponseSerializer_getInstance() {
        if (JwtVcJsonLdCredentialResponseSerializer_instance == null) new JwtVcJsonLdCredentialResponseSerializer();
        return JwtVcJsonLdCredentialResponseSerializer_instance;
    }
    function JsonSupportedCredentialSerializer() {
        JsonSupportedCredentialSerializer_instance = this;
        JsonContentPolymorphicSerializer.call(this, getKClass(JsonCredentialConfigurationsSupported));
    }
    protoOf(JsonSupportedCredentialSerializer).z1a = function(element) {
        var response = FromJsonHelper_instance.b27(element, "JsonSupportedCredential");
        var format = getStringOrDefault(response, "format");
        switch(format){
            case "jwt_vc_json":
                return Companion_getInstance_36().b1b();
            case "vc+sd-jwt":
                return Companion_getInstance_27().b1b();
            default:
                return Companion_instance_17.b1b();
        }
    };
    var JsonSupportedCredentialSerializer_instance;
    function JsonSupportedCredentialSerializer_getInstance() {
        if (JsonSupportedCredentialSerializer_instance == null) new JsonSupportedCredentialSerializer();
        return JsonSupportedCredentialSerializer_instance;
    }
    function JwtVcJsonCredentialSubjectMetadataSerializer() {
        JwtVcJsonCredentialSubjectMetadataSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_40);
    }
    var JwtVcJsonCredentialSubjectMetadataSerializer_instance;
    function JwtVcJsonCredentialSubjectMetadataSerializer_getInstance() {
        if (JwtVcJsonCredentialSubjectMetadataSerializer_instance == null) new JwtVcJsonCredentialSubjectMetadataSerializer();
        return JwtVcJsonCredentialSubjectMetadataSerializer_instance;
    }
    function JwtVcJsonCredentialSubjectEntryMetadataSerializer() {
        JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_41);
    }
    var JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance;
    function JwtVcJsonCredentialSubjectEntryMetadataSerializer_getInstance() {
        if (JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance == null) new JwtVcJsonCredentialSubjectEntryMetadataSerializer();
        return JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance;
    }
    function VcSdJwtCredentialResponseSerializer() {
        VcSdJwtCredentialResponseSerializer_instance = this;
        VerifiableCredentialResponseSerializer.call(this, getKClass(VcSdJwtCredentialResponse), "vc+sd-jwt", Companion_instance_53.b1b(), Companion_instance_33.b1b());
    }
    var VcSdJwtCredentialResponseSerializer_instance;
    function VcSdJwtCredentialResponseSerializer_getInstance() {
        if (VcSdJwtCredentialResponseSerializer_instance == null) new VcSdJwtCredentialResponseSerializer();
        return VcSdJwtCredentialResponseSerializer_instance;
    }
    function DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd(v) {
        return v.q3b_1;
    }
    function DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd_0(v) {
        return new Deferred_2(v);
    }
    function DeferredVcSdJwtCredentialResponseSerializer() {
        DeferredVcSdJwtCredentialResponseSerializer_instance = this;
        var tmp = Companion_instance_25.b1b();
        var tmp_0 = DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd;
        DerivedSerializer.call(this, tmp, tmp_0, DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd_0);
    }
    var DeferredVcSdJwtCredentialResponseSerializer_instance;
    function DeferredVcSdJwtCredentialResponseSerializer_getInstance() {
        if (DeferredVcSdJwtCredentialResponseSerializer_instance == null) new DeferredVcSdJwtCredentialResponseSerializer();
        return DeferredVcSdJwtCredentialResponseSerializer_instance;
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer() {
        JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_35);
    }
    var JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance;
    function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance() {
        if (JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance == null) new JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer();
        return JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance;
    }
    function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer() {
        JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_36);
    }
    var JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance;
    function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_getInstance() {
        if (JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance == null) new JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer();
        return JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance;
    }
    function Companion_52() {}
    protoOf(Companion_52).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "SerializableW3CVerifiableCredential"));
        return new SerializableW3CVerifiableCredential(unwrapOptionalString(map, "id"), unwrapStringList(map, "@context"), unwrapStringSet(map, "type"), unwrapMultiValueJsonDictionary(map, "credentialSubject"), unwrapIssuer(map, "issuer"), unwrapString(map, "issued"), unwrapOptionalProofs(map, "proof"), unwrapOptionalString(map, "expirationDate"), unwrapOptionalCredentialStatus(map, "credentialStatus"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    protoOf(Companion_52).b1b = function() {
        return SerializableW3CVerifiableCredentialSerializer_getInstance();
    };
    var Companion_instance_54;
    function Companion_getInstance_52() {
        return Companion_instance_54;
    }
    function _get__serializable__azf9o3_10($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.d3c_1;
        _serializable$factory_10();
        return this_0.b1();
    }
    function SerializableW3CVerifiableCredential$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.c3c_1 == null)) this_0.o2(this$0.c3c_1.a27());
            if (!(this$0.t3b_1 == null)) this_0.m2("id", toJson(this$0.t3b_1));
            // Inline function 'kotlin.collections.map' call
            var this_1 = this$0.u3b_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator = this_1.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$0 = toJson(item);
                destination.e(tmp$ret$0);
            }
            this_0.m2("@context", new JsonArray(destination));
            // Inline function 'kotlin.collections.map' call
            var this_2 = this$0.v3b_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator_0 = this_2.j();
            while(tmp0_iterator_0.k()){
                var item_0 = tmp0_iterator_0.l();
                // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$3 = toJson(item_0);
                destination_0.e(tmp$ret$3);
            }
            this_0.m2("type", new JsonArray(destination_0));
            this_0.m2("credentialSubject", toJson_4(this$0.w3b_1));
            this_0.m2("issuer", this$0.x3b_1.a27());
            this_0.m2("issued", toJson(this$0.y3b_1));
            if (!(this$0.z3b_1 == null)) this_0.m2("proof", toJson_4(this$0.z3b_1));
            if (!(this$0.a3c_1 == null)) this_0.m2("expirationDate", toJson(this$0.a3c_1));
            if (!(this$0.b3c_1 == null)) this_0.m2("credentialStatus", this$0.b3c_1.a27());
            var tmp$ret$8 = this_0.r8();
            return new JsonDictionary(tmp$ret$8);
        };
    }
    function SerializableW3CVerifiableCredential(id, context, type, credentialSubject, jsonIssuer, issued, proof, expirationDate, credentialStatus, customClaims) {
        id = id === VOID ? null : id;
        proof = proof === VOID ? null : proof;
        expirationDate = expirationDate === VOID ? null : expirationDate;
        credentialStatus = credentialStatus === VOID ? null : credentialStatus;
        customClaims = customClaims === VOID ? null : customClaims;
        this.t3b_1 = id;
        this.u3b_1 = context;
        this.v3b_1 = type;
        this.w3b_1 = credentialSubject;
        this.x3b_1 = jsonIssuer;
        this.y3b_1 = issued;
        this.z3b_1 = proof;
        this.a3c_1 = expirationDate;
        this.b3c_1 = credentialStatus;
        this.c3c_1 = customClaims;
        var tmp = this;
        tmp.d3c_1 = lazy(SerializableW3CVerifiableCredential$_serializable$delegate$lambda(this));
    }
    protoOf(SerializableW3CVerifiableCredential).e3c = function() {
        return this.x3b_1.f3c();
    };
    protoOf(SerializableW3CVerifiableCredential).y26 = function() {
        return _get__serializable__azf9o3_10(this);
    };
    protoOf(SerializableW3CVerifiableCredential).toString = function() {
        return "SerializableW3CVerifiableCredential(id=" + this.t3b_1 + ", context=" + toString(this.u3b_1) + ", type=" + toString(this.v3b_1) + ", credentialSubject=" + toString(this.w3b_1) + ", jsonIssuer=" + toString(this.x3b_1) + ", issued=" + this.y3b_1 + ", proof=" + toString_0(this.z3b_1) + ", expirationDate=" + this.a3c_1 + ", credentialStatus=" + toString_0(this.b3c_1) + ", customClaims=" + toString_0(this.c3c_1) + ")";
    };
    protoOf(SerializableW3CVerifiableCredential).hashCode = function() {
        var result = this.t3b_1 == null ? 0 : getStringHashCode(this.t3b_1);
        result = imul(result, 31) + hashCode(this.u3b_1) | 0;
        result = imul(result, 31) + hashCode(this.v3b_1) | 0;
        result = imul(result, 31) + hashCode(this.w3b_1) | 0;
        result = imul(result, 31) + hashCode(this.x3b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y3b_1) | 0;
        result = imul(result, 31) + (this.z3b_1 == null ? 0 : hashCode(this.z3b_1)) | 0;
        result = imul(result, 31) + (this.a3c_1 == null ? 0 : getStringHashCode(this.a3c_1)) | 0;
        result = imul(result, 31) + (this.b3c_1 == null ? 0 : this.b3c_1.hashCode()) | 0;
        result = imul(result, 31) + (this.c3c_1 == null ? 0 : hashCode(this.c3c_1)) | 0;
        return result;
    };
    protoOf(SerializableW3CVerifiableCredential).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SerializableW3CVerifiableCredential)) return false;
        var tmp0_other_with_cast = other instanceof SerializableW3CVerifiableCredential ? other : THROW_CCE();
        if (!(this.t3b_1 == tmp0_other_with_cast.t3b_1)) return false;
        if (!equals(this.u3b_1, tmp0_other_with_cast.u3b_1)) return false;
        if (!equals(this.v3b_1, tmp0_other_with_cast.v3b_1)) return false;
        if (!equals(this.w3b_1, tmp0_other_with_cast.w3b_1)) return false;
        if (!equals(this.x3b_1, tmp0_other_with_cast.x3b_1)) return false;
        if (!(this.y3b_1 === tmp0_other_with_cast.y3b_1)) return false;
        if (!equals(this.z3b_1, tmp0_other_with_cast.z3b_1)) return false;
        if (!(this.a3c_1 == tmp0_other_with_cast.a3c_1)) return false;
        if (!equals(this.b3c_1, tmp0_other_with_cast.b3c_1)) return false;
        if (!equals(this.c3c_1, tmp0_other_with_cast.c3c_1)) return false;
        return true;
    };
    function Companion_53() {}
    protoOf(Companion_53).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonCredentialStatus"));
        var id = unwrapString(map, "id");
        var type = unwrapString(map, "type");
        return new JsonCredentialStatus(id, type, new JsonDictionary(toMap(map)));
    };
    var Companion_instance_55;
    function Companion_getInstance_53() {
        return Companion_instance_55;
    }
    function _get__serializable__azf9o3_11($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.j3c_1;
        _serializable$factory_11();
        return this_0.b1();
    }
    function JsonCredentialStatus$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.JsonCredentialStatus._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.i3c_1 == null)) this_0.o2(this$0.i3c_1.xl());
            this_0.m2("id", JsonPrimitive_0(this$0.g3c_1));
            this_0.m2("type", JsonPrimitive_0(this$0.h3c_1));
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonCredentialStatus(id, type, customClaims) {
        customClaims = customClaims === VOID ? null : customClaims;
        this.g3c_1 = id;
        this.h3c_1 = type;
        this.i3c_1 = customClaims;
        var tmp = this;
        tmp.j3c_1 = lazy(JsonCredentialStatus$_serializable$delegate$lambda(this));
    }
    protoOf(JsonCredentialStatus).k2a = function() {
        return this.g3c_1;
    };
    protoOf(JsonCredentialStatus).g36 = function() {
        return this.h3c_1;
    };
    protoOf(JsonCredentialStatus).y26 = function() {
        return _get__serializable__azf9o3_11(this);
    };
    protoOf(JsonCredentialStatus).toString = function() {
        return "JsonCredentialStatus(id=" + this.g3c_1 + ", type=" + this.h3c_1 + ", customClaims=" + toString_0(this.i3c_1) + ")";
    };
    protoOf(JsonCredentialStatus).hashCode = function() {
        var result = getStringHashCode(this.g3c_1);
        result = imul(result, 31) + getStringHashCode(this.h3c_1) | 0;
        result = imul(result, 31) + (this.i3c_1 == null ? 0 : this.i3c_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonCredentialStatus).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonCredentialStatus)) return false;
        var tmp0_other_with_cast = other instanceof JsonCredentialStatus ? other : THROW_CCE();
        if (!(this.g3c_1 === tmp0_other_with_cast.g3c_1)) return false;
        if (!(this.h3c_1 === tmp0_other_with_cast.h3c_1)) return false;
        if (!equals(this.i3c_1, tmp0_other_with_cast.i3c_1)) return false;
        return true;
    };
    function Companion_54() {}
    protoOf(Companion_54).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "IssuerObject"));
        var id = unwrapString(map, "id");
        return new IssuerObject_0(id, map.s() ? null : new JsonDictionary(map));
    };
    var Companion_instance_56;
    function Companion_getInstance_54() {
        return Companion_instance_56;
    }
    function _get__serializedMap__cqopou($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.m3c_1;
        _serializedMap$factory();
        return this_0.b1();
    }
    function JsonIssuer$IssuerObject$_serializedMap$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.serialization.IssuerObject._serializedMap$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.l3c_1 == null)) this_0.o2(this$0.l3c_1.xl());
            this_0.m2("id", toJson(this$0.k3c_1));
            return this_0.r8();
        };
    }
    function JsonIssuer$IssuerObject$toIssuer$1($thisId, this$0) {
        this.p3c_1 = $thisId;
        MapDictionary.call(this, _get__serializedMap__cqopou(this$0));
        this.o3c_1 = $thisId;
    }
    protoOf(JsonIssuer$IssuerObject$toIssuer$1).k2a = function() {
        return this.o3c_1;
    };
    protoOf(JsonIssuer$IssuerObject$toIssuer$1).toString = function() {
        return this.p3c_1;
    };
    function IssuerURI_0(value) {
        this.m36_1 = value;
    }
    protoOf(IssuerURI_0).f3c = function() {
        return new IssuerURI(this.m36_1);
    };
    protoOf(IssuerURI_0).a27 = function() {
        return toJson(this.m36_1);
    };
    protoOf(IssuerURI_0).toString = function() {
        return "IssuerURI(value=" + this.m36_1 + ")";
    };
    protoOf(IssuerURI_0).hashCode = function() {
        return getStringHashCode(this.m36_1);
    };
    protoOf(IssuerURI_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof IssuerURI_0)) return false;
        var tmp0_other_with_cast = other instanceof IssuerURI_0 ? other : THROW_CCE();
        if (!(this.m36_1 === tmp0_other_with_cast.m36_1)) return false;
        return true;
    };
    function IssuerObject_0(id, customClaims) {
        customClaims = customClaims === VOID ? null : customClaims;
        this.k3c_1 = id;
        this.l3c_1 = customClaims;
        var tmp = this;
        tmp.m3c_1 = lazy(JsonIssuer$IssuerObject$_serializedMap$delegate$lambda(this));
    }
    protoOf(IssuerObject_0).f3c = function() {
        var thisId = this.k3c_1;
        return new JsonIssuer$IssuerObject$toIssuer$1(thisId, this);
    };
    protoOf(IssuerObject_0).a27 = function() {
        return new JsonObject(_get__serializedMap__cqopou(this));
    };
    protoOf(IssuerObject_0).toString = function() {
        return "IssuerObject(id=" + this.k3c_1 + ", customClaims=" + toString_0(this.l3c_1) + ")";
    };
    protoOf(IssuerObject_0).hashCode = function() {
        var result = getStringHashCode(this.k3c_1);
        result = imul(result, 31) + (this.l3c_1 == null ? 0 : hashCode(this.l3c_1)) | 0;
        return result;
    };
    protoOf(IssuerObject_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof IssuerObject_0)) return false;
        var tmp0_other_with_cast = other instanceof IssuerObject_0 ? other : THROW_CCE();
        if (!(this.k3c_1 === tmp0_other_with_cast.k3c_1)) return false;
        if (!equals(this.l3c_1, tmp0_other_with_cast.l3c_1)) return false;
        return true;
    };
    function JsonIssuer() {}
    function ToJsonIssuer() {}
    function _serializable$factory_10() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_10(receiver);
        }, null);
    }
    function _serializable$factory_11() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_11(receiver);
        }, null);
    }
    function _serializedMap$factory() {
        return getPropertyCallableRef("_serializedMap", 1, KProperty1, function(receiver) {
            return _get__serializedMap__cqopou(receiver);
        }, null);
    }
    function Companion_55() {
        Companion_instance_57 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.r3c_1 = [
            null,
            null,
            new ArrayListSerializer($serializer_getInstance_30())
        ];
    }
    var Companion_instance_57;
    function Companion_getInstance_55() {
        if (Companion_instance_57 == null) new Companion_55();
        return Companion_instance_57;
    }
    function $serializer_28() {
        $serializer_instance_28 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonPresentationSubmission", this, 3);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("definition_id", false);
        tmp0_serialDesc.wy("descriptor_map", false);
        this.s3c_1 = tmp0_serialDesc;
    }
    protoOf($serializer_28).t3c = function(encoder, value) {
        var tmp0_desc = this.s3c_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_55().r3c_1;
        tmp1_output.zs(tmp0_desc, 0, value.u3c_1);
        tmp1_output.zs(tmp0_desc, 1, value.v3c_1);
        tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.w3c_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_28).zn = function(encoder, value) {
        return this.t3c(encoder, value instanceof JsonPresentationSubmission ? value : THROW_CCE());
    };
    protoOf($serializer_28).ao = function(decoder) {
        var tmp0_desc = this.s3c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        var tmp8_cached = Companion_getInstance_55().r3c_1;
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonPresentationSubmission_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_28).yn = function() {
        return this.s3c_1;
    };
    protoOf($serializer_28).lz = function() {
        var tmp0_cached = Companion_getInstance_55().r3c_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            tmp0_cached[2]
        ];
    };
    var $serializer_instance_28;
    function $serializer_getInstance_29() {
        if ($serializer_instance_28 == null) new $serializer_28();
        return $serializer_instance_28;
    }
    function JsonPresentationSubmission_init_$Init$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker, $this) {
        if (!(7 === (7 & seen0))) throwMissingFieldException(seen0, 7, $serializer_getInstance_29().s3c_1);
        $this.u3c_1 = id;
        $this.v3c_1 = definitionId;
        $this.w3c_1 = descriptorMap;
        return $this;
    }
    function JsonPresentationSubmission_init_$Create$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker) {
        return JsonPresentationSubmission_init_$Init$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker, objectCreate(protoOf(JsonPresentationSubmission)));
    }
    function JsonPresentationSubmission(id, definitionId, descriptorMap) {
        Companion_getInstance_55();
        this.u3c_1 = id;
        this.v3c_1 = definitionId;
        this.w3c_1 = descriptorMap;
    }
    protoOf(JsonPresentationSubmission).toString = function() {
        return "JsonPresentationSubmission(id=" + this.u3c_1 + ", definitionId=" + this.v3c_1 + ", descriptorMap=" + toString(this.w3c_1) + ")";
    };
    protoOf(JsonPresentationSubmission).hashCode = function() {
        var result = getStringHashCode(this.u3c_1);
        result = imul(result, 31) + getStringHashCode(this.v3c_1) | 0;
        result = imul(result, 31) + hashCode(this.w3c_1) | 0;
        return result;
    };
    protoOf(JsonPresentationSubmission).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonPresentationSubmission)) return false;
        var tmp0_other_with_cast = other instanceof JsonPresentationSubmission ? other : THROW_CCE();
        if (!(this.u3c_1 === tmp0_other_with_cast.u3c_1)) return false;
        if (!(this.v3c_1 === tmp0_other_with_cast.v3c_1)) return false;
        if (!equals(this.w3c_1, tmp0_other_with_cast.w3c_1)) return false;
        return true;
    };
    function Companion_56() {}
    var Companion_instance_58;
    function Companion_getInstance_56() {
        return Companion_instance_58;
    }
    function $serializer_29() {
        $serializer_instance_29 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonDescriptorMapObject", this, 4);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("format", false);
        tmp0_serialDesc.wy("path", false);
        tmp0_serialDesc.wy("path_nested", false);
        this.x3c_1 = tmp0_serialDesc;
    }
    protoOf($serializer_29).y3c = function(encoder, value) {
        var tmp0_desc = this.x3c_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.z3c_1);
        tmp1_output.zs(tmp0_desc, 1, value.a3d_1);
        tmp1_output.zs(tmp0_desc, 2, value.b3d_1);
        tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_40(), value.c3d_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_29).zn = function(encoder, value) {
        return this.y3c(encoder, value instanceof JsonDescriptorMapObject ? value : THROW_CCE());
    };
    protoOf($serializer_29).ao = function(decoder) {
        var tmp0_desc = this.x3c_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_40(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_40(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return JsonDescriptorMapObject_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_29).yn = function() {
        return this.x3c_1;
    };
    protoOf($serializer_29).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            get_nullable($serializer_getInstance_40())
        ];
    };
    var $serializer_instance_29;
    function $serializer_getInstance_30() {
        if ($serializer_instance_29 == null) new $serializer_29();
        return $serializer_instance_29;
    }
    function JsonDescriptorMapObject_init_$Init$(seen0, id, format, path, pathNested, serializationConstructorMarker, $this) {
        if (!(15 === (15 & seen0))) throwMissingFieldException(seen0, 15, $serializer_getInstance_30().x3c_1);
        $this.z3c_1 = id;
        $this.a3d_1 = format;
        $this.b3d_1 = path;
        $this.c3d_1 = pathNested;
        return $this;
    }
    function JsonDescriptorMapObject_init_$Create$(seen0, id, format, path, pathNested, serializationConstructorMarker) {
        return JsonDescriptorMapObject_init_$Init$(seen0, id, format, path, pathNested, serializationConstructorMarker, objectCreate(protoOf(JsonDescriptorMapObject)));
    }
    function JsonDescriptorMapObject(id, format, path, pathNested) {
        this.z3c_1 = id;
        this.a3d_1 = format;
        this.b3d_1 = path;
        this.c3d_1 = pathNested;
    }
    protoOf(JsonDescriptorMapObject).toString = function() {
        return "JsonDescriptorMapObject(id=" + this.z3c_1 + ", format=" + this.a3d_1 + ", path=" + this.b3d_1 + ", pathNested=" + toString_0(this.c3d_1) + ")";
    };
    protoOf(JsonDescriptorMapObject).hashCode = function() {
        var result = getStringHashCode(this.z3c_1);
        result = imul(result, 31) + getStringHashCode(this.a3d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b3d_1) | 0;
        result = imul(result, 31) + (this.c3d_1 == null ? 0 : this.c3d_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonDescriptorMapObject).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonDescriptorMapObject)) return false;
        var tmp0_other_with_cast = other instanceof JsonDescriptorMapObject ? other : THROW_CCE();
        if (!(this.z3c_1 === tmp0_other_with_cast.z3c_1)) return false;
        if (!(this.a3d_1 === tmp0_other_with_cast.a3d_1)) return false;
        if (!(this.b3d_1 === tmp0_other_with_cast.b3d_1)) return false;
        if (!equals(this.c3d_1, tmp0_other_with_cast.c3d_1)) return false;
        return true;
    };
    function Companion_57() {
        Companion_instance_59 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d3d_1 = [
            null,
            null,
            null,
            null,
            new ArrayListSerializer($serializer_getInstance_32())
        ];
    }
    var Companion_instance_59;
    function Companion_getInstance_57() {
        if (Companion_instance_59 == null) new Companion_57();
        return Companion_instance_59;
    }
    function $serializer_30() {
        $serializer_instance_30 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonPresentationDefinition", this, 5);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("name", true);
        tmp0_serialDesc.wy("purpose", true);
        tmp0_serialDesc.wy("format", true);
        tmp0_serialDesc.wy("input_descriptors", false);
        this.e3d_1 = tmp0_serialDesc;
    }
    protoOf($serializer_30).f3d = function(encoder, value) {
        var tmp0_desc = this.e3d_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_57().d3d_1;
        tmp1_output.zs(tmp0_desc, 0, value.g3d_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.h3d_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.h3d_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.i3d_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.i3d_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.j3d_1 == null)) tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_38(), value.j3d_1);
        tmp1_output.bt(tmp0_desc, 4, tmp2_cached[4], value.k3d_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_30).zn = function(encoder, value) {
        return this.f3d(encoder, value instanceof JsonPresentationDefinition ? value : THROW_CCE());
    };
    protoOf($serializer_30).ao = function(decoder) {
        var tmp0_desc = this.e3d_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        var tmp10_cached = Companion_getInstance_57().d3d_1;
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, $serializer_getInstance_38(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, $serializer_getInstance_38(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return JsonPresentationDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_30).yn = function() {
        return this.e3d_1;
    };
    protoOf($serializer_30).lz = function() {
        var tmp0_cached = Companion_getInstance_57().d3d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable($serializer_getInstance_38()),
            tmp0_cached[4]
        ];
    };
    var $serializer_instance_30;
    function $serializer_getInstance_31() {
        if ($serializer_instance_30 == null) new $serializer_30();
        return $serializer_instance_30;
    }
    function JsonPresentationDefinition_init_$Init$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker, $this) {
        if (!(17 === (17 & seen0))) throwMissingFieldException(seen0, 17, $serializer_getInstance_31().e3d_1);
        $this.g3d_1 = id;
        if (0 === (seen0 & 2)) $this.h3d_1 = null;
        else $this.h3d_1 = name;
        if (0 === (seen0 & 4)) $this.i3d_1 = null;
        else $this.i3d_1 = purpose;
        if (0 === (seen0 & 8)) $this.j3d_1 = null;
        else $this.j3d_1 = format;
        $this.k3d_1 = inputDescriptors;
        return $this;
    }
    function JsonPresentationDefinition_init_$Create$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker) {
        return JsonPresentationDefinition_init_$Init$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker, objectCreate(protoOf(JsonPresentationDefinition)));
    }
    function JsonPresentationDefinition(id, name, purpose, format, inputDescriptors) {
        Companion_getInstance_57();
        name = name === VOID ? null : name;
        purpose = purpose === VOID ? null : purpose;
        format = format === VOID ? null : format;
        this.g3d_1 = id;
        this.h3d_1 = name;
        this.i3d_1 = purpose;
        this.j3d_1 = format;
        this.k3d_1 = inputDescriptors;
    }
    protoOf(JsonPresentationDefinition).toString = function() {
        return "JsonPresentationDefinition(id=" + this.g3d_1 + ", name=" + this.h3d_1 + ", purpose=" + this.i3d_1 + ", format=" + toString_0(this.j3d_1) + ", inputDescriptors=" + toString(this.k3d_1) + ")";
    };
    protoOf(JsonPresentationDefinition).hashCode = function() {
        var result = getStringHashCode(this.g3d_1);
        result = imul(result, 31) + (this.h3d_1 == null ? 0 : getStringHashCode(this.h3d_1)) | 0;
        result = imul(result, 31) + (this.i3d_1 == null ? 0 : getStringHashCode(this.i3d_1)) | 0;
        result = imul(result, 31) + (this.j3d_1 == null ? 0 : this.j3d_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.k3d_1) | 0;
        return result;
    };
    protoOf(JsonPresentationDefinition).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonPresentationDefinition)) return false;
        var tmp0_other_with_cast = other instanceof JsonPresentationDefinition ? other : THROW_CCE();
        if (!(this.g3d_1 === tmp0_other_with_cast.g3d_1)) return false;
        if (!(this.h3d_1 == tmp0_other_with_cast.h3d_1)) return false;
        if (!(this.i3d_1 == tmp0_other_with_cast.i3d_1)) return false;
        if (!equals(this.j3d_1, tmp0_other_with_cast.j3d_1)) return false;
        if (!equals(this.k3d_1, tmp0_other_with_cast.k3d_1)) return false;
        return true;
    };
    function $serializer_31() {
        $serializer_instance_31 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonInputDescriptor", this, 5);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("name", true);
        tmp0_serialDesc.wy("purpose", true);
        tmp0_serialDesc.wy("constraints", false);
        tmp0_serialDesc.wy("format", true);
        this.l3d_1 = tmp0_serialDesc;
    }
    protoOf($serializer_31).m3d = function(encoder, value) {
        var tmp0_desc = this.l3d_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.n3d_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.o3d_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.o3d_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.p3d_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.p3d_1);
        tmp1_output.bt(tmp0_desc, 3, $serializer_getInstance_33(), value.q3d_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.r3d_1 == null)) tmp1_output.dt(tmp0_desc, 4, $serializer_getInstance_38(), value.r3d_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_31).zn = function(encoder, value) {
        return this.m3d(encoder, value instanceof JsonInputDescriptor ? value : THROW_CCE());
    };
    protoOf($serializer_31).ao = function(decoder) {
        var tmp0_desc = this.l3d_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, $serializer_getInstance_33(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, $serializer_getInstance_38(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, $serializer_getInstance_33(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, $serializer_getInstance_38(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return JsonInputDescriptor_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_31).yn = function() {
        return this.l3d_1;
    };
    protoOf($serializer_31).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            $serializer_getInstance_33(),
            get_nullable($serializer_getInstance_38())
        ];
    };
    var $serializer_instance_31;
    function $serializer_getInstance_32() {
        if ($serializer_instance_31 == null) new $serializer_31();
        return $serializer_instance_31;
    }
    function JsonInputDescriptor_init_$Init$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker, $this) {
        if (!(9 === (9 & seen0))) throwMissingFieldException(seen0, 9, $serializer_getInstance_32().l3d_1);
        $this.n3d_1 = id;
        if (0 === (seen0 & 2)) $this.o3d_1 = null;
        else $this.o3d_1 = name;
        if (0 === (seen0 & 4)) $this.p3d_1 = null;
        else $this.p3d_1 = purpose;
        $this.q3d_1 = constraints;
        if (0 === (seen0 & 16)) $this.r3d_1 = null;
        else $this.r3d_1 = format;
        return $this;
    }
    function JsonInputDescriptor_init_$Create$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker) {
        return JsonInputDescriptor_init_$Init$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker, objectCreate(protoOf(JsonInputDescriptor)));
    }
    function JsonInputDescriptor() {}
    protoOf(JsonInputDescriptor).toString = function() {
        return "JsonInputDescriptor(id=" + this.n3d_1 + ", name=" + this.o3d_1 + ", purpose=" + this.p3d_1 + ", constraints=" + this.q3d_1.toString() + ", format=" + toString_0(this.r3d_1) + ")";
    };
    protoOf(JsonInputDescriptor).hashCode = function() {
        var result = getStringHashCode(this.n3d_1);
        result = imul(result, 31) + (this.o3d_1 == null ? 0 : getStringHashCode(this.o3d_1)) | 0;
        result = imul(result, 31) + (this.p3d_1 == null ? 0 : getStringHashCode(this.p3d_1)) | 0;
        result = imul(result, 31) + this.q3d_1.hashCode() | 0;
        result = imul(result, 31) + (this.r3d_1 == null ? 0 : this.r3d_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonInputDescriptor).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonInputDescriptor)) return false;
        var tmp0_other_with_cast = other instanceof JsonInputDescriptor ? other : THROW_CCE();
        if (!(this.n3d_1 === tmp0_other_with_cast.n3d_1)) return false;
        if (!(this.o3d_1 == tmp0_other_with_cast.o3d_1)) return false;
        if (!(this.p3d_1 == tmp0_other_with_cast.p3d_1)) return false;
        if (!this.q3d_1.equals(tmp0_other_with_cast.q3d_1)) return false;
        if (!equals(this.r3d_1, tmp0_other_with_cast.r3d_1)) return false;
        return true;
    };
    function Companion_58() {
        Companion_instance_60 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s3d_1 = [
            new ArrayListSerializer($serializer_getInstance_34()),
            null
        ];
    }
    var Companion_instance_60;
    function Companion_getInstance_58() {
        if (Companion_instance_60 == null) new Companion_58();
        return Companion_instance_60;
    }
    function $serializer_32() {
        $serializer_instance_32 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonConstraints", this, 2);
        tmp0_serialDesc.wy("fields", true);
        tmp0_serialDesc.wy("limit_disclosure", true);
        this.t3d_1 = tmp0_serialDesc;
    }
    protoOf($serializer_32).u3d = function(encoder, value) {
        var tmp0_desc = this.t3d_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_58().s3d_1;
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.v3d_1 == null)) tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.v3d_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.w3d_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.w3d_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_32).zn = function(encoder, value) {
        return this.u3d(encoder, value instanceof JsonConstraints ? value : THROW_CCE());
    };
    protoOf($serializer_32).ao = function(decoder) {
        var tmp0_desc = this.t3d_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_58().s3d_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonConstraints_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_32).yn = function() {
        return this.t3d_1;
    };
    protoOf($serializer_32).lz = function() {
        var tmp0_cached = Companion_getInstance_58().s3d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(tmp0_cached[0]),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_32;
    function $serializer_getInstance_33() {
        if ($serializer_instance_32 == null) new $serializer_32();
        return $serializer_instance_32;
    }
    function JsonConstraints_init_$Init$(seen0, fields, limitDisclosure, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_33().t3d_1);
        if (0 === (seen0 & 1)) $this.v3d_1 = null;
        else $this.v3d_1 = fields;
        if (0 === (seen0 & 2)) $this.w3d_1 = null;
        else $this.w3d_1 = limitDisclosure;
        return $this;
    }
    function JsonConstraints_init_$Create$(seen0, fields, limitDisclosure, serializationConstructorMarker) {
        return JsonConstraints_init_$Init$(seen0, fields, limitDisclosure, serializationConstructorMarker, objectCreate(protoOf(JsonConstraints)));
    }
    function JsonConstraints(fields, limitDisclosure) {
        Companion_getInstance_58();
        fields = fields === VOID ? null : fields;
        limitDisclosure = limitDisclosure === VOID ? null : limitDisclosure;
        this.v3d_1 = fields;
        this.w3d_1 = limitDisclosure;
    }
    protoOf(JsonConstraints).toString = function() {
        return "JsonConstraints(fields=" + toString_0(this.v3d_1) + ", limitDisclosure=" + this.w3d_1 + ")";
    };
    protoOf(JsonConstraints).hashCode = function() {
        var result = this.v3d_1 == null ? 0 : hashCode(this.v3d_1);
        result = imul(result, 31) + (this.w3d_1 == null ? 0 : getStringHashCode(this.w3d_1)) | 0;
        return result;
    };
    protoOf(JsonConstraints).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonConstraints)) return false;
        var tmp0_other_with_cast = other instanceof JsonConstraints ? other : THROW_CCE();
        if (!equals(this.v3d_1, tmp0_other_with_cast.v3d_1)) return false;
        if (!(this.w3d_1 == tmp0_other_with_cast.w3d_1)) return false;
        return true;
    };
    function Companion_59() {
        Companion_instance_61 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.x3d_1 = [
            null,
            null,
            null,
            new ArrayListSerializer(StringSerializer_getInstance()),
            null,
            null
        ];
    }
    var Companion_instance_61;
    function Companion_getInstance_59() {
        if (Companion_instance_61 == null) new Companion_59();
        return Companion_instance_61;
    }
    function $serializer_33() {
        $serializer_instance_33 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonField", this, 6);
        tmp0_serialDesc.wy("id", true);
        tmp0_serialDesc.wy("name", true);
        tmp0_serialDesc.wy("purpose", true);
        tmp0_serialDesc.wy("path", false);
        tmp0_serialDesc.wy("filter", true);
        tmp0_serialDesc.wy("optional", true);
        this.y3d_1 = tmp0_serialDesc;
    }
    protoOf($serializer_33).z3d = function(encoder, value) {
        var tmp0_desc = this.y3d_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_59().x3d_1;
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.a3e_1 == null)) tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.a3e_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.b3e_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.b3e_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.c3e_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.c3e_1);
        tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.d3e_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.e3e_1 == null)) tmp1_output.dt(tmp0_desc, 4, JsonFilterSerializer_getInstance(), value.e3e_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.f3e_1 == null)) tmp1_output.dt(tmp0_desc, 5, BooleanSerializer_getInstance(), value.f3e_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_33).zn = function(encoder, value) {
        return this.z3d(encoder, value instanceof JsonField ? value : THROW_CCE());
    };
    protoOf($serializer_33).ao = function(decoder) {
        var tmp0_desc = this.y3d_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.lr(tmp0_desc);
        var tmp11_cached = Companion_getInstance_59().x3d_1;
        if (tmp10_input.as()) {
            tmp4_local0 = tmp10_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp10_input.xr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, JsonFilterSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp10_input.zr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else while(tmp1_flag){
            tmp2_index = tmp10_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp10_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp10_input.xr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, JsonFilterSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp10_input.zr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp10_input.mr(tmp0_desc);
        return JsonField_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
    };
    protoOf($serializer_33).yn = function() {
        return this.y3d_1;
    };
    protoOf($serializer_33).lz = function() {
        var tmp0_cached = Companion_getInstance_59().x3d_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            tmp0_cached[3],
            get_nullable(JsonFilterSerializer_getInstance()),
            get_nullable(BooleanSerializer_getInstance())
        ];
    };
    var $serializer_instance_33;
    function $serializer_getInstance_34() {
        if ($serializer_instance_33 == null) new $serializer_33();
        return $serializer_instance_33;
    }
    function JsonField_init_$Init$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker, $this) {
        if (!(8 === (8 & seen0))) throwMissingFieldException(seen0, 8, $serializer_getInstance_34().y3d_1);
        if (0 === (seen0 & 1)) $this.a3e_1 = null;
        else $this.a3e_1 = id;
        if (0 === (seen0 & 2)) $this.b3e_1 = null;
        else $this.b3e_1 = name;
        if (0 === (seen0 & 4)) $this.c3e_1 = null;
        else $this.c3e_1 = purpose;
        $this.d3e_1 = path;
        if (0 === (seen0 & 16)) $this.e3e_1 = null;
        else $this.e3e_1 = filter;
        if (0 === (seen0 & 32)) $this.f3e_1 = null;
        else $this.f3e_1 = optional;
        return $this;
    }
    function JsonField_init_$Create$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker) {
        return JsonField_init_$Init$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker, objectCreate(protoOf(JsonField)));
    }
    function JsonField() {}
    protoOf(JsonField).toString = function() {
        return "JsonField(id=" + this.a3e_1 + ", name=" + this.b3e_1 + ", purpose=" + this.c3e_1 + ", path=" + toString(this.d3e_1) + ", filter=" + toString_0(this.e3e_1) + ", optional=" + this.f3e_1 + ")";
    };
    protoOf(JsonField).hashCode = function() {
        var result = this.a3e_1 == null ? 0 : getStringHashCode(this.a3e_1);
        result = imul(result, 31) + (this.b3e_1 == null ? 0 : getStringHashCode(this.b3e_1)) | 0;
        result = imul(result, 31) + (this.c3e_1 == null ? 0 : getStringHashCode(this.c3e_1)) | 0;
        result = imul(result, 31) + hashCode(this.d3e_1) | 0;
        result = imul(result, 31) + (this.e3e_1 == null ? 0 : hashCode(this.e3e_1)) | 0;
        result = imul(result, 31) + (this.f3e_1 == null ? 0 : getBooleanHashCode(this.f3e_1)) | 0;
        return result;
    };
    protoOf(JsonField).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonField)) return false;
        var tmp0_other_with_cast = other instanceof JsonField ? other : THROW_CCE();
        if (!(this.a3e_1 == tmp0_other_with_cast.a3e_1)) return false;
        if (!(this.b3e_1 == tmp0_other_with_cast.b3e_1)) return false;
        if (!(this.c3e_1 == tmp0_other_with_cast.c3e_1)) return false;
        if (!equals(this.d3e_1, tmp0_other_with_cast.d3e_1)) return false;
        if (!equals(this.e3e_1, tmp0_other_with_cast.e3e_1)) return false;
        if (!(this.f3e_1 == tmp0_other_with_cast.f3e_1)) return false;
        return true;
    };
    function Companion_60() {}
    var Companion_instance_62;
    function Companion_getInstance_60() {
        return Companion_instance_62;
    }
    function AbstractJsonFilter() {}
    function Companion_61() {}
    protoOf(Companion_61).b1b = function() {
        return $serializer_getInstance_35();
    };
    var Companion_instance_63;
    function Companion_getInstance_61() {
        return Companion_instance_63;
    }
    function $serializer_34() {
        $serializer_instance_34 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonArrayContainsFilter", this, 2);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("contains", false);
        this.g3e_1 = tmp0_serialDesc;
    }
    protoOf($serializer_34).h3e = function(encoder, value) {
        var tmp0_desc = this.g3e_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.i3e_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_36(), value.j3e_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_34).zn = function(encoder, value) {
        return this.h3e(encoder, value instanceof JsonArrayContainsFilter ? value : THROW_CCE());
    };
    protoOf($serializer_34).ao = function(decoder) {
        var tmp0_desc = this.g3e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonArrayContainsFilter_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_34).yn = function() {
        return this.g3e_1;
    };
    protoOf($serializer_34).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            $serializer_getInstance_36()
        ];
    };
    var $serializer_instance_34;
    function $serializer_getInstance_35() {
        if ($serializer_instance_34 == null) new $serializer_34();
        return $serializer_instance_34;
    }
    function JsonArrayContainsFilter_init_$Init$(seen0, type, contains, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_35().g3e_1);
        AbstractJsonFilter.call($this);
        $this.i3e_1 = type;
        $this.j3e_1 = contains;
        return $this;
    }
    function JsonArrayContainsFilter_init_$Create$(seen0, type, contains, serializationConstructorMarker) {
        return JsonArrayContainsFilter_init_$Init$(seen0, type, contains, serializationConstructorMarker, objectCreate(protoOf(JsonArrayContainsFilter)));
    }
    function JsonArrayContainsFilter() {}
    protoOf(JsonArrayContainsFilter).toString = function() {
        return "JsonArrayContainsFilter(type=" + this.i3e_1 + ", contains=" + this.j3e_1.toString() + ")";
    };
    protoOf(JsonArrayContainsFilter).hashCode = function() {
        var result = getStringHashCode(this.i3e_1);
        result = imul(result, 31) + this.j3e_1.hashCode() | 0;
        return result;
    };
    protoOf(JsonArrayContainsFilter).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonArrayContainsFilter)) return false;
        var tmp0_other_with_cast = other instanceof JsonArrayContainsFilter ? other : THROW_CCE();
        if (!(this.i3e_1 === tmp0_other_with_cast.i3e_1)) return false;
        if (!this.j3e_1.equals(tmp0_other_with_cast.j3e_1)) return false;
        return true;
    };
    function $serializer_35() {
        $serializer_instance_35 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonContains", this, 2);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("pattern", false);
        this.k3e_1 = tmp0_serialDesc;
    }
    protoOf($serializer_35).l3e = function(encoder, value) {
        var tmp0_desc = this.k3e_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.m3e_1);
        tmp1_output.zs(tmp0_desc, 1, value.n3e_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_35).zn = function(encoder, value) {
        return this.l3e(encoder, value instanceof JsonContains ? value : THROW_CCE());
    };
    protoOf($serializer_35).ao = function(decoder) {
        var tmp0_desc = this.k3e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonContains_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_35).yn = function() {
        return this.k3e_1;
    };
    protoOf($serializer_35).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_35;
    function $serializer_getInstance_36() {
        if ($serializer_instance_35 == null) new $serializer_35();
        return $serializer_instance_35;
    }
    function JsonContains_init_$Init$(seen0, type, pattern, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_36().k3e_1);
        $this.m3e_1 = type;
        $this.n3e_1 = pattern;
        return $this;
    }
    function JsonContains_init_$Create$(seen0, type, pattern, serializationConstructorMarker) {
        return JsonContains_init_$Init$(seen0, type, pattern, serializationConstructorMarker, objectCreate(protoOf(JsonContains)));
    }
    function JsonContains() {}
    protoOf(JsonContains).toString = function() {
        return "JsonContains(type=" + this.m3e_1 + ", pattern=" + this.n3e_1 + ")";
    };
    protoOf(JsonContains).hashCode = function() {
        var result = getStringHashCode(this.m3e_1);
        result = imul(result, 31) + getStringHashCode(this.n3e_1) | 0;
        return result;
    };
    protoOf(JsonContains).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonContains)) return false;
        var tmp0_other_with_cast = other instanceof JsonContains ? other : THROW_CCE();
        if (!(this.m3e_1 === tmp0_other_with_cast.m3e_1)) return false;
        if (!(this.n3e_1 === tmp0_other_with_cast.n3e_1)) return false;
        return true;
    };
    function Companion_62() {}
    protoOf(Companion_62).b1b = function() {
        return $serializer_getInstance_37();
    };
    var Companion_instance_64;
    function Companion_getInstance_62() {
        return Companion_instance_64;
    }
    function $serializer_36() {
        $serializer_instance_36 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonStringFilter", this, 2);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("pattern", false);
        this.o3e_1 = tmp0_serialDesc;
    }
    protoOf($serializer_36).p3e = function(encoder, value) {
        var tmp0_desc = this.o3e_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.q3e_1);
        tmp1_output.zs(tmp0_desc, 1, value.r3e_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_36).zn = function(encoder, value) {
        return this.p3e(encoder, value instanceof JsonStringFilter ? value : THROW_CCE());
    };
    protoOf($serializer_36).ao = function(decoder) {
        var tmp0_desc = this.o3e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonStringFilter_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_36).yn = function() {
        return this.o3e_1;
    };
    protoOf($serializer_36).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_36;
    function $serializer_getInstance_37() {
        if ($serializer_instance_36 == null) new $serializer_36();
        return $serializer_instance_36;
    }
    function JsonStringFilter_init_$Init$(seen0, type, pattern, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_37().o3e_1);
        AbstractJsonFilter.call($this);
        $this.q3e_1 = type;
        $this.r3e_1 = pattern;
        return $this;
    }
    function JsonStringFilter_init_$Create$(seen0, type, pattern, serializationConstructorMarker) {
        return JsonStringFilter_init_$Init$(seen0, type, pattern, serializationConstructorMarker, objectCreate(protoOf(JsonStringFilter)));
    }
    function JsonStringFilter() {}
    protoOf(JsonStringFilter).toString = function() {
        return "JsonStringFilter(type=" + this.q3e_1 + ", pattern=" + this.r3e_1 + ")";
    };
    protoOf(JsonStringFilter).hashCode = function() {
        var result = getStringHashCode(this.q3e_1);
        result = imul(result, 31) + getStringHashCode(this.r3e_1) | 0;
        return result;
    };
    protoOf(JsonStringFilter).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonStringFilter)) return false;
        var tmp0_other_with_cast = other instanceof JsonStringFilter ? other : THROW_CCE();
        if (!(this.q3e_1 === tmp0_other_with_cast.q3e_1)) return false;
        if (!(this.r3e_1 === tmp0_other_with_cast.r3e_1)) return false;
        return true;
    };
    function Companion_63() {}
    protoOf(Companion_63).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonFormat"));
        return new JsonFormat(unwrapOptionalAlgFormat(map, "jwt_vc_json"), unwrapOptionalAlgFormat(map, "jwt_vp_json"), unwrapOptionalVcSdJwtAlgsFormat(map, "vc+sd-jwt"), unwrapOptionalProofTypeFormat(map, "ldp_vc"), unwrapOptionalProofTypeFormat(map, "ldp_vp"), new JsonDictionary(toMap(map)));
    };
    var Companion_instance_65;
    function Companion_getInstance_63() {
        return Companion_instance_65;
    }
    function _get__serializable__azf9o3_12($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.y3e_1;
        _serializable$factory_12();
        return this_0.b1();
    }
    function $serializer_37() {
        $serializer_instance_37 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonFormat", this, 6);
        tmp0_serialDesc.wy("jwt_vc_json", true);
        tmp0_serialDesc.wy("jwt_vp_json", true);
        tmp0_serialDesc.wy("vc+sd-jwt", true);
        tmp0_serialDesc.wy("ldp_vc", true);
        tmp0_serialDesc.wy("ldp_vp", true);
        tmp0_serialDesc.wy("customFormats", true);
        this.z3e_1 = tmp0_serialDesc;
    }
    protoOf($serializer_37).a3f = function(encoder, value) {
        var tmp0_desc = this.z3e_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.s3e_1 == null)) tmp1_output.dt(tmp0_desc, 0, $serializer_getInstance_39(), value.s3e_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.t3e_1 == null)) tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_39(), value.t3e_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.u3e_1 == null)) tmp1_output.dt(tmp0_desc, 2, $serializer_getInstance_42(), value.u3e_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.v3e_1 == null)) tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_41(), value.v3e_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.w3e_1 == null)) tmp1_output.dt(tmp0_desc, 4, $serializer_getInstance_41(), value.w3e_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !equals(value.x3e_1, new JsonDictionary(emptyMap()))) tmp1_output.bt(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), value.x3e_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_37).zn = function(encoder, value) {
        return this.a3f(encoder, value instanceof JsonFormat ? value : THROW_CCE());
    };
    protoOf($serializer_37).ao = function(decoder) {
        var tmp0_desc = this.z3e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp11_input = decoder.lr(tmp0_desc);
        if (tmp11_input.as()) {
            tmp4_local0 = tmp11_input.zr(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp11_input.zr(tmp0_desc, 1, $serializer_getInstance_39(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp11_input.zr(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp11_input.zr(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp11_input.zr(tmp0_desc, 4, $serializer_getInstance_41(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp11_input.xr(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else while(tmp1_flag){
            tmp2_index = tmp11_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp11_input.zr(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp11_input.zr(tmp0_desc, 1, $serializer_getInstance_39(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp11_input.zr(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp11_input.zr(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp11_input.zr(tmp0_desc, 4, $serializer_getInstance_41(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp11_input.xr(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp11_input.mr(tmp0_desc);
        return JsonFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
    };
    protoOf($serializer_37).yn = function() {
        return this.z3e_1;
    };
    protoOf($serializer_37).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable($serializer_getInstance_39()),
            get_nullable($serializer_getInstance_39()),
            get_nullable($serializer_getInstance_42()),
            get_nullable($serializer_getInstance_41()),
            get_nullable($serializer_getInstance_41()),
            ToJsonDictionarySerializer_getInstance()
        ];
    };
    var $serializer_instance_37;
    function $serializer_getInstance_38() {
        if ($serializer_instance_37 == null) new $serializer_37();
        return $serializer_instance_37;
    }
    function JsonFormat_init_$Init$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_38().z3e_1);
        if (0 === (seen0 & 1)) $this.s3e_1 = null;
        else $this.s3e_1 = jwtVcJson;
        if (0 === (seen0 & 2)) $this.t3e_1 = null;
        else $this.t3e_1 = jwtVpJson;
        if (0 === (seen0 & 4)) $this.u3e_1 = null;
        else $this.u3e_1 = vcSdJwt;
        if (0 === (seen0 & 8)) $this.v3e_1 = null;
        else $this.v3e_1 = ldpVc;
        if (0 === (seen0 & 16)) $this.w3e_1 = null;
        else $this.w3e_1 = ldpVp;
        if (0 === (seen0 & 32)) $this.x3e_1 = new JsonDictionary(emptyMap());
        else $this.x3e_1 = customFormats;
        var tmp = $this;
        tmp.y3e_1 = lazy(JsonFormat$_init_$lambda_oj59w($this));
        return $this;
    }
    function JsonFormat_init_$Create$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker) {
        return JsonFormat_init_$Init$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker, objectCreate(protoOf(JsonFormat)));
    }
    function JsonFormat$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vp.serialization.JsonFormat._serializable$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.x3e_1.a27());
            if (!(this$0.s3e_1 == null)) this_0.m2("jwt_vc_json", this$0.s3e_1.a27());
            if (!(this$0.t3e_1 == null)) this_0.m2("jwt_vp_json", this$0.t3e_1.a27());
            if (!(this$0.v3e_1 == null)) this_0.m2("ldp_vc", this$0.v3e_1.a27());
            if (!(this$0.w3e_1 == null)) this_0.m2("ldp_vp", this$0.w3e_1.a27());
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonFormat$_init_$lambda_oj59w(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vp.serialization.JsonFormat.<init>.<anonymous>.<anonymous>' call
            this_0.o2(this$0.x3e_1.a27());
            if (!(this$0.s3e_1 == null)) this_0.m2("jwt_vc_json", this$0.s3e_1.a27());
            if (!(this$0.t3e_1 == null)) this_0.m2("jwt_vp_json", this$0.t3e_1.a27());
            if (!(this$0.v3e_1 == null)) this_0.m2("ldp_vc", this$0.v3e_1.a27());
            if (!(this$0.w3e_1 == null)) this_0.m2("ldp_vp", this$0.w3e_1.a27());
            var tmp$ret$2 = this_0.r8();
            return new JsonDictionary(tmp$ret$2);
        };
    }
    function JsonFormat(jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats) {
        jwtVcJson = jwtVcJson === VOID ? null : jwtVcJson;
        jwtVpJson = jwtVpJson === VOID ? null : jwtVpJson;
        vcSdJwt = vcSdJwt === VOID ? null : vcSdJwt;
        ldpVc = ldpVc === VOID ? null : ldpVc;
        ldpVp = ldpVp === VOID ? null : ldpVp;
        customFormats = customFormats === VOID ? new JsonDictionary(emptyMap()) : customFormats;
        this.s3e_1 = jwtVcJson;
        this.t3e_1 = jwtVpJson;
        this.u3e_1 = vcSdJwt;
        this.v3e_1 = ldpVc;
        this.w3e_1 = ldpVp;
        this.x3e_1 = customFormats;
        var tmp = this;
        tmp.y3e_1 = lazy(JsonFormat$_serializable$delegate$lambda(this));
    }
    protoOf(JsonFormat).y26 = function() {
        return _get__serializable__azf9o3_12(this);
    };
    protoOf(JsonFormat).toString = function() {
        return "JsonFormat(jwtVcJson=" + toString_0(this.s3e_1) + ", jwtVpJson=" + toString_0(this.t3e_1) + ", vcSdJwt=" + toString_0(this.u3e_1) + ", ldpVc=" + toString_0(this.v3e_1) + ", ldpVp=" + toString_0(this.w3e_1) + ", customFormats=" + toString(this.x3e_1) + ")";
    };
    protoOf(JsonFormat).hashCode = function() {
        var result = this.s3e_1 == null ? 0 : this.s3e_1.hashCode();
        result = imul(result, 31) + (this.t3e_1 == null ? 0 : this.t3e_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u3e_1 == null ? 0 : this.u3e_1.hashCode()) | 0;
        result = imul(result, 31) + (this.v3e_1 == null ? 0 : this.v3e_1.hashCode()) | 0;
        result = imul(result, 31) + (this.w3e_1 == null ? 0 : this.w3e_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.x3e_1) | 0;
        return result;
    };
    protoOf(JsonFormat).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonFormat)) return false;
        var tmp0_other_with_cast = other instanceof JsonFormat ? other : THROW_CCE();
        if (!equals(this.s3e_1, tmp0_other_with_cast.s3e_1)) return false;
        if (!equals(this.t3e_1, tmp0_other_with_cast.t3e_1)) return false;
        if (!equals(this.u3e_1, tmp0_other_with_cast.u3e_1)) return false;
        if (!equals(this.v3e_1, tmp0_other_with_cast.v3e_1)) return false;
        if (!equals(this.w3e_1, tmp0_other_with_cast.w3e_1)) return false;
        if (!equals(this.x3e_1, tmp0_other_with_cast.x3e_1)) return false;
        return true;
    };
    function Companion_64() {
        Companion_instance_66 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i33_1 = [
            new LinkedHashSetSerializer(StringSerializer_getInstance())
        ];
    }
    protoOf(Companion_64).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonAlgFormat"));
        return new JsonAlgFormat(unwrapStringSet(map, "alg"));
    };
    protoOf(Companion_64).b1b = function() {
        return $serializer_getInstance_39();
    };
    var Companion_instance_66;
    function Companion_getInstance_64() {
        if (Companion_instance_66 == null) new Companion_64();
        return Companion_instance_66;
    }
    function $serializer_38() {
        $serializer_instance_38 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonAlgFormat", this, 1);
        tmp0_serialDesc.wy("alg", false);
        this.d3f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_38).e3f = function(encoder, value) {
        var tmp0_desc = this.d3f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_64().i33_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.b3f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_38).zn = function(encoder, value) {
        return this.e3f(encoder, value instanceof JsonAlgFormat ? value : THROW_CCE());
    };
    protoOf($serializer_38).ao = function(decoder) {
        var tmp0_desc = this.d3f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_64().i33_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return JsonAlgFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_38).yn = function() {
        return this.d3f_1;
    };
    protoOf($serializer_38).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_64().i33_1[0]
        ];
    };
    var $serializer_instance_38;
    function $serializer_getInstance_39() {
        if ($serializer_instance_38 == null) new $serializer_38();
        return $serializer_instance_38;
    }
    function JsonAlgFormat_init_$Init$(seen0, alg, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_39().d3f_1);
        $this.b3f_1 = alg;
        return $this;
    }
    function JsonAlgFormat_init_$Create$(seen0, alg, serializationConstructorMarker) {
        return JsonAlgFormat_init_$Init$(seen0, alg, serializationConstructorMarker, objectCreate(protoOf(JsonAlgFormat)));
    }
    function JsonAlgFormat(alg) {
        Companion_getInstance_64();
        this.b3f_1 = alg;
    }
    protoOf(JsonAlgFormat).a27 = function() {
        return Default_getInstance().a19(Companion_getInstance_64().b1b(), this);
    };
    protoOf(JsonAlgFormat).toString = function() {
        return "JsonAlgFormat(alg=" + toString(this.b3f_1) + ")";
    };
    protoOf(JsonAlgFormat).hashCode = function() {
        return hashCode(this.b3f_1);
    };
    protoOf(JsonAlgFormat).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonAlgFormat)) return false;
        var tmp0_other_with_cast = other instanceof JsonAlgFormat ? other : THROW_CCE();
        if (!equals(this.b3f_1, tmp0_other_with_cast.b3f_1)) return false;
        return true;
    };
    function Companion_65() {}
    var Companion_instance_67;
    function Companion_getInstance_65() {
        return Companion_instance_67;
    }
    function $serializer_39() {
        $serializer_instance_39 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonPathNested", this, 2);
        tmp0_serialDesc.wy("format", false);
        tmp0_serialDesc.wy("path", false);
        this.f3f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_39).g3f = function(encoder, value) {
        var tmp0_desc = this.f3f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.h3f_1);
        tmp1_output.zs(tmp0_desc, 1, value.i3f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_39).zn = function(encoder, value) {
        return this.g3f(encoder, value instanceof JsonPathNested ? value : THROW_CCE());
    };
    protoOf($serializer_39).ao = function(decoder) {
        var tmp0_desc = this.f3f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonPathNested_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_39).yn = function() {
        return this.f3f_1;
    };
    protoOf($serializer_39).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance()
        ];
    };
    var $serializer_instance_39;
    function $serializer_getInstance_40() {
        if ($serializer_instance_39 == null) new $serializer_39();
        return $serializer_instance_39;
    }
    function JsonPathNested_init_$Init$(seen0, format, path, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_40().f3f_1);
        $this.h3f_1 = format;
        $this.i3f_1 = path;
        return $this;
    }
    function JsonPathNested_init_$Create$(seen0, format, path, serializationConstructorMarker) {
        return JsonPathNested_init_$Init$(seen0, format, path, serializationConstructorMarker, objectCreate(protoOf(JsonPathNested)));
    }
    function JsonPathNested(format, path) {
        this.h3f_1 = format;
        this.i3f_1 = path;
    }
    protoOf(JsonPathNested).toString = function() {
        return "JsonPathNested(format=" + this.h3f_1 + ", path=" + this.i3f_1 + ")";
    };
    protoOf(JsonPathNested).hashCode = function() {
        var result = getStringHashCode(this.h3f_1);
        result = imul(result, 31) + getStringHashCode(this.i3f_1) | 0;
        return result;
    };
    protoOf(JsonPathNested).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonPathNested)) return false;
        var tmp0_other_with_cast = other instanceof JsonPathNested ? other : THROW_CCE();
        if (!(this.h3f_1 === tmp0_other_with_cast.h3f_1)) return false;
        if (!(this.i3f_1 === tmp0_other_with_cast.i3f_1)) return false;
        return true;
    };
    function Companion_66() {
        Companion_instance_68 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.k33_1 = [
            new LinkedHashSetSerializer(StringSerializer_getInstance())
        ];
    }
    protoOf(Companion_66).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonProofTypeFormat"));
        return new JsonProofTypeFormat(unwrapStringSet(map, "proof_type"));
    };
    protoOf(Companion_66).b1b = function() {
        return $serializer_getInstance_41();
    };
    var Companion_instance_68;
    function Companion_getInstance_66() {
        if (Companion_instance_68 == null) new Companion_66();
        return Companion_instance_68;
    }
    function $serializer_40() {
        $serializer_instance_40 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonProofTypeFormat", this, 1);
        tmp0_serialDesc.wy("proof_type", false);
        this.j3f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_40).k3f = function(encoder, value) {
        var tmp0_desc = this.j3f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_66().k33_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.c3f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_40).zn = function(encoder, value) {
        return this.k3f(encoder, value instanceof JsonProofTypeFormat ? value : THROW_CCE());
    };
    protoOf($serializer_40).ao = function(decoder) {
        var tmp0_desc = this.j3f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_66().k33_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return JsonProofTypeFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_40).yn = function() {
        return this.j3f_1;
    };
    protoOf($serializer_40).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_66().k33_1[0]
        ];
    };
    var $serializer_instance_40;
    function $serializer_getInstance_41() {
        if ($serializer_instance_40 == null) new $serializer_40();
        return $serializer_instance_40;
    }
    function JsonProofTypeFormat_init_$Init$(seen0, proofType, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_41().j3f_1);
        $this.c3f_1 = proofType;
        return $this;
    }
    function JsonProofTypeFormat_init_$Create$(seen0, proofType, serializationConstructorMarker) {
        return JsonProofTypeFormat_init_$Init$(seen0, proofType, serializationConstructorMarker, objectCreate(protoOf(JsonProofTypeFormat)));
    }
    function JsonProofTypeFormat(proofType) {
        Companion_getInstance_66();
        this.c3f_1 = proofType;
    }
    protoOf(JsonProofTypeFormat).a27 = function() {
        return Default_getInstance().a19(Companion_getInstance_66().b1b(), this);
    };
    protoOf(JsonProofTypeFormat).toString = function() {
        return "JsonProofTypeFormat(proofType=" + toString(this.c3f_1) + ")";
    };
    protoOf(JsonProofTypeFormat).hashCode = function() {
        return hashCode(this.c3f_1);
    };
    protoOf(JsonProofTypeFormat).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonProofTypeFormat)) return false;
        var tmp0_other_with_cast = other instanceof JsonProofTypeFormat ? other : THROW_CCE();
        if (!equals(this.c3f_1, tmp0_other_with_cast.c3f_1)) return false;
        return true;
    };
    function Companion_67() {
        Companion_instance_69 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j33_1 = [
            new LinkedHashSetSerializer(StringSerializer_getInstance()),
            new LinkedHashSetSerializer(StringSerializer_getInstance())
        ];
    }
    protoOf(Companion_67).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "JsonVcSdJwtAlgsFormat"));
        return new JsonVcSdJwtAlgsFormat(unwrapStringSet(map, "sd-jwt_alg_values"), unwrapStringSet(map, "kb-jwt_alg_values"));
    };
    protoOf(Companion_67).b1b = function() {
        return $serializer_getInstance_42();
    };
    var Companion_instance_69;
    function Companion_getInstance_67() {
        if (Companion_instance_69 == null) new Companion_67();
        return Companion_instance_69;
    }
    function $serializer_41() {
        $serializer_instance_41 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonVcSdJwtAlgsFormat", this, 2);
        tmp0_serialDesc.wy("sd-jwt_alg_values", false);
        tmp0_serialDesc.wy("kb-jwt_alg_values", false);
        this.l3f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_41).m3f = function(encoder, value) {
        var tmp0_desc = this.l3f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_67().j33_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.n3f_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.o3f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_41).zn = function(encoder, value) {
        return this.m3f(encoder, value instanceof JsonVcSdJwtAlgsFormat ? value : THROW_CCE());
    };
    protoOf($serializer_41).ao = function(decoder) {
        var tmp0_desc = this.l3f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_67().j33_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonVcSdJwtAlgsFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_41).yn = function() {
        return this.l3f_1;
    };
    protoOf($serializer_41).lz = function() {
        var tmp0_cached = Companion_getInstance_67().j33_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            tmp0_cached[0],
            tmp0_cached[1]
        ];
    };
    var $serializer_instance_41;
    function $serializer_getInstance_42() {
        if ($serializer_instance_41 == null) new $serializer_41();
        return $serializer_instance_41;
    }
    function JsonVcSdJwtAlgsFormat_init_$Init$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_42().l3f_1);
        $this.n3f_1 = sdJwtAlgValues;
        $this.o3f_1 = kbJwtAlgValues;
        return $this;
    }
    function JsonVcSdJwtAlgsFormat_init_$Create$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker) {
        return JsonVcSdJwtAlgsFormat_init_$Init$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker, objectCreate(protoOf(JsonVcSdJwtAlgsFormat)));
    }
    function JsonVcSdJwtAlgsFormat(sdJwtAlgValues, kbJwtAlgValues) {
        Companion_getInstance_67();
        this.n3f_1 = sdJwtAlgValues;
        this.o3f_1 = kbJwtAlgValues;
    }
    protoOf(JsonVcSdJwtAlgsFormat).a27 = function() {
        return Default_getInstance().a19(Companion_getInstance_67().b1b(), this);
    };
    protoOf(JsonVcSdJwtAlgsFormat).toString = function() {
        return "JsonVcSdJwtAlgsFormat(sdJwtAlgValues=" + toString(this.n3f_1) + ", kbJwtAlgValues=" + toString(this.o3f_1) + ")";
    };
    protoOf(JsonVcSdJwtAlgsFormat).hashCode = function() {
        var result = hashCode(this.n3f_1);
        result = imul(result, 31) + hashCode(this.o3f_1) | 0;
        return result;
    };
    protoOf(JsonVcSdJwtAlgsFormat).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonVcSdJwtAlgsFormat)) return false;
        var tmp0_other_with_cast = other instanceof JsonVcSdJwtAlgsFormat ? other : THROW_CCE();
        if (!equals(this.n3f_1, tmp0_other_with_cast.n3f_1)) return false;
        if (!equals(this.o3f_1, tmp0_other_with_cast.o3f_1)) return false;
        return true;
    };
    function _serializable$factory_12() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_12(receiver);
        }, null);
    }
    function Companion_68() {}
    protoOf(Companion_68).d27 = function(json) {
        var tmp;
        var tmp_0;
        if (json instanceof JsonPrimitive) tmp_0 = json.d1b();
        else tmp_0 = false;
        if (tmp_0) tmp = new JsonStringVerifiablePresentation(json.e1b());
        else tmp = new JsonDictionaryVerifiablePresentation(new JsonDictionary(FromJsonHelper_instance.b27(json, "JsonDictionaryVerifiablePresentation")));
        return tmp;
    };
    protoOf(Companion_68).b1b = function() {
        return JsonVerifiablePresentationSerializer_getInstance();
    };
    protoOf(Companion_68).wz = function(typeParamsSerializers) {
        return this.b1b();
    };
    var Companion_instance_70;
    function Companion_getInstance_68() {
        return Companion_instance_70;
    }
    function JsonStringVerifiablePresentation(value) {
        this.p3f_1 = value;
    }
    protoOf(JsonStringVerifiablePresentation).a27 = function() {
        return JsonPrimitive_0(this.p3f_1);
    };
    protoOf(JsonStringVerifiablePresentation).toString = function() {
        return "JsonStringVerifiablePresentation(value=" + this.p3f_1 + ")";
    };
    protoOf(JsonStringVerifiablePresentation).hashCode = function() {
        return getStringHashCode(this.p3f_1);
    };
    protoOf(JsonStringVerifiablePresentation).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonStringVerifiablePresentation)) return false;
        var tmp0_other_with_cast = other instanceof JsonStringVerifiablePresentation ? other : THROW_CCE();
        if (!(this.p3f_1 === tmp0_other_with_cast.p3f_1)) return false;
        return true;
    };
    function JsonDictionaryVerifiablePresentation(value) {
        this.q3f_1 = value;
    }
    protoOf(JsonDictionaryVerifiablePresentation).y26 = function() {
        return this.q3f_1;
    };
    protoOf(JsonDictionaryVerifiablePresentation).toString = function() {
        return "JsonDictionaryVerifiablePresentation(value=" + this.q3f_1.toString() + ")";
    };
    protoOf(JsonDictionaryVerifiablePresentation).hashCode = function() {
        return this.q3f_1.hashCode();
    };
    protoOf(JsonDictionaryVerifiablePresentation).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonDictionaryVerifiablePresentation)) return false;
        var tmp0_other_with_cast = other instanceof JsonDictionaryVerifiablePresentation ? other : THROW_CCE();
        if (!this.q3f_1.equals(tmp0_other_with_cast.q3f_1)) return false;
        return true;
    };
    function JsonVerifiablePresentation() {}
    function Companion_69() {}
    var Companion_instance_71;
    function Companion_getInstance_69() {
        return Companion_instance_71;
    }
    function $serializer_42() {
        $serializer_instance_42 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.serialization.JsonVerifierDirectPostAuthorizationResponse", this, 1);
        tmp0_serialDesc.wy("redirect_uri", true);
        this.r3f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_42).s3f = function(encoder, value) {
        var tmp0_desc = this.r3f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.t3f_1 == null)) tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.t3f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_42).zn = function(encoder, value) {
        return this.s3f(encoder, value instanceof JsonVerifierDirectPostAuthorizationResponse ? value : THROW_CCE());
    };
    protoOf($serializer_42).ao = function(decoder) {
        var tmp0_desc = this.r3f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return JsonVerifierDirectPostAuthorizationResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_42).yn = function() {
        return this.r3f_1;
    };
    protoOf($serializer_42).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_42;
    function $serializer_getInstance_43() {
        if ($serializer_instance_42 == null) new $serializer_42();
        return $serializer_instance_42;
    }
    function JsonVerifierDirectPostAuthorizationResponse_init_$Init$(seen0, redirectUri, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_43().r3f_1);
        if (0 === (seen0 & 1)) $this.t3f_1 = null;
        else $this.t3f_1 = redirectUri;
        return $this;
    }
    function JsonVerifierDirectPostAuthorizationResponse_init_$Create$(seen0, redirectUri, serializationConstructorMarker) {
        return JsonVerifierDirectPostAuthorizationResponse_init_$Init$(seen0, redirectUri, serializationConstructorMarker, objectCreate(protoOf(JsonVerifierDirectPostAuthorizationResponse)));
    }
    function JsonVerifierDirectPostAuthorizationResponse(redirectUri) {
        redirectUri = redirectUri === VOID ? null : redirectUri;
        this.t3f_1 = redirectUri;
    }
    protoOf(JsonVerifierDirectPostAuthorizationResponse).u3f = function() {
        return this.t3f_1;
    };
    protoOf(JsonVerifierDirectPostAuthorizationResponse).toString = function() {
        return "JsonVerifierDirectPostAuthorizationResponse(redirectUri=" + this.t3f_1 + ")";
    };
    protoOf(JsonVerifierDirectPostAuthorizationResponse).hashCode = function() {
        return this.t3f_1 == null ? 0 : getStringHashCode(this.t3f_1);
    };
    protoOf(JsonVerifierDirectPostAuthorizationResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonVerifierDirectPostAuthorizationResponse)) return false;
        var tmp0_other_with_cast = other instanceof JsonVerifierDirectPostAuthorizationResponse ? other : THROW_CCE();
        if (!(this.t3f_1 == tmp0_other_with_cast.t3f_1)) return false;
        return true;
    };
    function JsonFilterSerializer() {
        JsonFilterSerializer_instance = this;
        JsonContentPolymorphicSerializer.call(this, getKClass(AbstractJsonFilter));
    }
    protoOf(JsonFilterSerializer).z1a = function(element) {
        var tmp;
        // Inline function 'kotlin.collections.contains' call
        var this_0 = get_jsonObject(element);
        // Inline function 'kotlin.collections.containsKey' call
        var key = "contains";
        if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c2(key)) tmp = Companion_instance_63.b1b();
        else {
            // Inline function 'kotlin.collections.contains' call
            // Inline function 'kotlin.collections.containsKey' call
            var this_1 = get_jsonObject(element);
            if ((isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).c2("pattern")) tmp = Companion_instance_64.b1b();
            else {
                var message = "Unsupported filter: " + get_jsonObject(element).toString();
                throw IllegalStateException_init_$Create$(toString(message));
            }
        }
        return tmp;
    };
    var JsonFilterSerializer_instance;
    function JsonFilterSerializer_getInstance() {
        if (JsonFilterSerializer_instance == null) new JsonFilterSerializer();
        return JsonFilterSerializer_instance;
    }
    function SerializableW3CVerifiablePresentationSerializer() {
        SerializableW3CVerifiablePresentationSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_72);
    }
    var SerializableW3CVerifiablePresentationSerializer_instance;
    function SerializableW3CVerifiablePresentationSerializer_getInstance() {
        if (SerializableW3CVerifiablePresentationSerializer_instance == null) new SerializableW3CVerifiablePresentationSerializer();
        return SerializableW3CVerifiablePresentationSerializer_instance;
    }
    function JsonVerifiablePresentationSerializer() {
        JsonVerifiablePresentationSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_70);
    }
    var JsonVerifiablePresentationSerializer_instance;
    function JsonVerifiablePresentationSerializer_getInstance() {
        if (JsonVerifiablePresentationSerializer_instance == null) new JsonVerifiablePresentationSerializer();
        return JsonVerifiablePresentationSerializer_instance;
    }
    function Companion_70() {}
    protoOf(Companion_70).d27 = function(json) {
        var map = toMutableMap(FromJsonHelper_instance.b27(json, "SerializableW3CVerifiablePresentation"));
        return new SerializableW3CVerifiablePresentation(unwrapOptionalString(map, "id"), unwrapStringList(map, "@context"), unwrapStringList(map, "type"), unwrapOptionalString(map, "holder"), unwrapOptionalProofs(map, "proof"), unwrapOptionalVerifiableCredentials(map, "verifiableCredential"), map.s() ? null : new JsonDictionary(toMap(map)));
    };
    var Companion_instance_72;
    function Companion_getInstance_70() {
        return Companion_instance_72;
    }
    function _get__serializable__azf9o3_13($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.e3g_1;
        _serializable$factory_13();
        return this_0.b1();
    }
    function SerializableW3CVerifiablePresentation$_serializable$delegate$lambda$lambda(it) {
        var tmp;
        if (it instanceof StringCredential) tmp = JsonPrimitive_0(it.o2h_1);
        else if (it instanceof DictionaryCredential) {
            var tmp_0 = it.p2h_1;
            tmp = new JsonObject(isInterface(tmp_0, KtMap) ? tmp_0 : THROW_CCE());
        } else noWhenBranchMatchedException();
        return tmp;
    }
    function SerializableW3CVerifiablePresentation$_serializable$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>' call
            if (!(this$0.d3g_1 == null)) this_0.o2(this$0.d3g_1.a27());
            if (!(this$0.x3f_1 == null)) this_0.m2("id", toJson(this$0.x3f_1));
            // Inline function 'kotlin.collections.map' call
            var this_1 = this$0.y3f_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator = this_1.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$0 = toJson(item);
                destination.e(tmp$ret$0);
            }
            this_0.m2("@context", new JsonArray(destination));
            // Inline function 'kotlin.collections.map' call
            var this_2 = this$0.z3f_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator_0 = this_2.j();
            while(tmp0_iterator_0.k()){
                var item_0 = tmp0_iterator_0.l();
                // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$3 = toJson(item_0);
                destination_0.e(tmp$ret$3);
            }
            this_0.m2("type", new JsonArray(destination_0));
            if (!(this$0.a3g_1 == null)) this_0.m2("holder", toJson(this$0.a3g_1));
            if (!(this$0.b3g_1 == null)) this_0.m2("proof", toJson_4(this$0.b3g_1));
            if (!(this$0.c3g_1 == null)) this_0.m2("verifiableCredential", this$0.c3g_1.l27(SerializableW3CVerifiablePresentation$_serializable$delegate$lambda$lambda));
            var tmp$ret$8 = this_0.r8();
            return new JsonDictionary(tmp$ret$8);
        };
    }
    function SerializableW3CVerifiablePresentation(id, context, type, holder, proof, verifiableCredential, customClaims) {
        id = id === VOID ? null : id;
        holder = holder === VOID ? null : holder;
        proof = proof === VOID ? null : proof;
        verifiableCredential = verifiableCredential === VOID ? null : verifiableCredential;
        customClaims = customClaims === VOID ? null : customClaims;
        this.x3f_1 = id;
        this.y3f_1 = context;
        this.z3f_1 = type;
        this.a3g_1 = holder;
        this.b3g_1 = proof;
        this.c3g_1 = verifiableCredential;
        this.d3g_1 = customClaims;
        var tmp = this;
        tmp.e3g_1 = lazy(SerializableW3CVerifiablePresentation$_serializable$delegate$lambda(this));
    }
    protoOf(SerializableW3CVerifiablePresentation).y26 = function() {
        return _get__serializable__azf9o3_13(this);
    };
    protoOf(SerializableW3CVerifiablePresentation).toString = function() {
        return "SerializableW3CVerifiablePresentation(id=" + this.x3f_1 + ", context=" + toString(this.y3f_1) + ", type=" + toString(this.z3f_1) + ", holder=" + this.a3g_1 + ", proof=" + toString_0(this.b3g_1) + ", verifiableCredential=" + toString_0(this.c3g_1) + ", customClaims=" + toString_0(this.d3g_1) + ")";
    };
    protoOf(SerializableW3CVerifiablePresentation).hashCode = function() {
        var result = this.x3f_1 == null ? 0 : getStringHashCode(this.x3f_1);
        result = imul(result, 31) + hashCode(this.y3f_1) | 0;
        result = imul(result, 31) + hashCode(this.z3f_1) | 0;
        result = imul(result, 31) + (this.a3g_1 == null ? 0 : getStringHashCode(this.a3g_1)) | 0;
        result = imul(result, 31) + (this.b3g_1 == null ? 0 : hashCode(this.b3g_1)) | 0;
        result = imul(result, 31) + (this.c3g_1 == null ? 0 : this.c3g_1.hashCode()) | 0;
        result = imul(result, 31) + (this.d3g_1 == null ? 0 : hashCode(this.d3g_1)) | 0;
        return result;
    };
    protoOf(SerializableW3CVerifiablePresentation).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SerializableW3CVerifiablePresentation)) return false;
        var tmp0_other_with_cast = other instanceof SerializableW3CVerifiablePresentation ? other : THROW_CCE();
        if (!(this.x3f_1 == tmp0_other_with_cast.x3f_1)) return false;
        if (!equals(this.y3f_1, tmp0_other_with_cast.y3f_1)) return false;
        if (!equals(this.z3f_1, tmp0_other_with_cast.z3f_1)) return false;
        if (!(this.a3g_1 == tmp0_other_with_cast.a3g_1)) return false;
        if (!equals(this.b3g_1, tmp0_other_with_cast.b3g_1)) return false;
        if (!equals(this.c3g_1, tmp0_other_with_cast.c3g_1)) return false;
        if (!equals(this.d3g_1, tmp0_other_with_cast.d3g_1)) return false;
        return true;
    };
    function _serializable$factory_13() {
        return getPropertyCallableRef("_serializable", 1, KProperty1, function(receiver) {
            return _get__serializable__azf9o3_13(receiver);
        }, null);
    }
    function Companion_71() {}
    protoOf(Companion_71).left = function(left) {
        return new Either(left, null);
    };
    protoOf(Companion_71).right = function(right) {
        return new Either(null, right);
    };
    var Companion_instance_73;
    function Companion_getInstance_71() {
        return Companion_instance_73;
    }
    function Either(_left, _right) {
        this.f3g_1 = _left;
        this.g3g_1 = _right;
    }
    protoOf(Either).map = function(whenLeft, whenRight) {
        return !(this.f3g_1 == null) ? whenLeft(this.f3g_1) : whenRight(ensureNotNull(this.g3g_1));
    };
    function ToJsonString() {}
    function JSObject(_dictionary) {
        this.h3g_1 = _dictionary;
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = this.h3g_1.f2();
        tmp.keys = copyToArray(this_0);
    }
    protoOf(JSObject).f2 = function() {
        return this.keys;
    };
    protoOf(JSObject).get = function(key) {
        return this.h3g_1.vl(key);
    };
    function JSIssuerObject(issuer) {
        JSObject.call(this, issuer);
        this.id = issuer.k2a();
    }
    protoOf(JSIssuerObject).k2a = function() {
        return this.id;
    };
    function JSProofObject(proof) {
        JSObject.call(this, proof);
        this.type = proof.g36();
    }
    protoOf(JSProofObject).g36 = function() {
        return this.type;
    };
    function JSCredentialStatusObject(status) {
        JSObject.call(this, status);
        this.id = status.k2a();
        this.type = status.g36();
    }
    protoOf(JSCredentialStatusObject).k2a = function() {
        return this.id;
    };
    protoOf(JSCredentialStatusObject).g36 = function() {
        return this.type;
    };
    function JsPair(first, second) {
        this.first = first;
        this.second = second;
    }
    protoOf(JsPair).mm = function() {
        return this.first;
    };
    protoOf(JsPair).l3g = function() {
        return this.second;
    };
    function getRootCause(_this__u8e3s4) {
        var result = _this__u8e3s4;
        $l$loop: while(true){
            var tmp0_elvis_lhs = result.cause;
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$loop;
            else tmp = tmp0_elvis_lhs;
            result = tmp;
        }
        return result;
    }
    function createJSObject(dictionary) {
        return new JSObject(dictionary);
    }
    function JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(type, credentialSubjectClaims) {
        this.type = type;
        this.credentialSubjectClaims = credentialSubjectClaims;
    }
    protoOf(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition).g36 = function() {
        return this.type;
    };
    protoOf(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition).m3g = function() {
        return this.credentialSubjectClaims;
    };
    function JSJwtVcJsonVerifiableCredentialRequest(jwtProof, credentialDefinition) {
        this.jwtProof = jwtProof;
        this.credentialDefinition = credentialDefinition;
    }
    protoOf(JSJwtVcJsonVerifiableCredentialRequest).n3g = function() {
        return this.jwtProof;
    };
    protoOf(JSJwtVcJsonVerifiableCredentialRequest).o3g = function() {
        return this.credentialDefinition;
    };
    protoOf(JSJwtVcJsonVerifiableCredentialRequest).toJson = function() {
        var serializable = convertJwtVcJsonRequest(this);
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        return this_0.bp(tmp$ret$1, serializable);
    };
    function JSJwtVcJsonLdVerifiableCredentialRequest(jwtProof, types, context, credentialSubjectClaims) {
        this.jwtProof = jwtProof;
        this.types = types;
        this.context = context;
        this.credentialSubjectClaims = credentialSubjectClaims;
    }
    protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).n3g = function() {
        return this.jwtProof;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).p3g = function() {
        return this.types;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).b9 = function() {
        return this.context;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).m3g = function() {
        return this.credentialSubjectClaims;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).toJson = function() {
        var serializable = convertJwtVcJsonLdRequest(this);
        return Default_getInstance().bp(Companion_instance_44.b1b(), serializable);
    };
    function JSLdpVerifiableCredentialRequest(jwtProof, context, types, credentialSubjectClaims) {
        this.jwtProof = jwtProof;
        this.context = context;
        this.types = types;
        this.credentialSubjectClaims = credentialSubjectClaims;
    }
    protoOf(JSLdpVerifiableCredentialRequest).n3g = function() {
        return this.jwtProof;
    };
    protoOf(JSLdpVerifiableCredentialRequest).b9 = function() {
        return this.context;
    };
    protoOf(JSLdpVerifiableCredentialRequest).p3g = function() {
        return this.types;
    };
    protoOf(JSLdpVerifiableCredentialRequest).m3g = function() {
        return this.credentialSubjectClaims;
    };
    protoOf(JSLdpVerifiableCredentialRequest).toJson = function() {
        var serializable = convertLdpVcJsonRequest(this);
        return Default_getInstance().bp(Companion_instance_45.b1b(), serializable);
    };
    function convertJwtVcJsonRequest(request) {
        return new JwtVcJsonVerifiableCredentialRequest(new JwtProofOfPossession(request.jwtProof), convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(request.credentialDefinition));
    }
    function convertJwtVcJsonLdRequest(request) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = request.types;
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var element = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element)) destination.e(element);
        }
        var types = toSet(destination);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = request.context;
        var destination_0 = ArrayList_init_$Create$_0();
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        while(inductionVariable_0 < last_0){
            var element_0 = this_1[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_0)) destination_0.e(element_0);
        }
        var context = toList_0(destination_0);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_2 = request.credentialSubjectClaims;
        var destination_1 = ArrayList_init_$Create$_0();
        var inductionVariable_1 = 0;
        var last_1 = this_2.length;
        while(inductionVariable_1 < last_1){
            var element_1 = this_2[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_1)) destination_1.e(element_1);
        }
        var claims = toSet(destination_1);
        return new JwtVcJsonLdVerifiableCredentialRequest(new JwtProofOfPossession(request.jwtProof), new JsonCredentialDefinition(context, types, new BasicCredentialSubject(claims)));
    }
    function convertLdpVcJsonRequest(request) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = request.types;
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var element = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element)) destination.e(element);
        }
        var types = toSet(destination);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = request.credentialSubjectClaims;
        var destination_0 = ArrayList_init_$Create$_0();
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        while(inductionVariable_0 < last_0){
            var element_0 = this_1[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_0)) destination_0.e(element_0);
        }
        var claims = toSet(destination_0);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_2 = request.context;
        var destination_1 = ArrayList_init_$Create$_0();
        var inductionVariable_1 = 0;
        var last_1 = this_2.length;
        while(inductionVariable_1 < last_1){
            var element_1 = this_2[inductionVariable_1];
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_1)) destination_1.e(element_1);
        }
        var context = toList_0(destination_1);
        var tmp = new JwtProofOfPossession(request.jwtProof);
        var tmp0_credentialSubject = new BasicCredentialSubject(claims);
        return new LdpVerifiableCredentialRequest(tmp, new JsonCredentialDefinition(context, types, tmp0_credentialSubject));
    }
    function convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(credentialDefinition) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = credentialDefinition.credentialSubjectClaims;
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var element = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element)) destination.e(element);
        }
        var claims = toSet(destination);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_1 = credentialDefinition.type;
        var destination_0 = ArrayList_init_$Create$_0();
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        while(inductionVariable_0 < last_0){
            var element_0 = this_1[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition.<anonymous>' call
            // Inline function 'kotlin.text.isNotBlank' call
            if (!isBlank(element_0)) destination_0.e(element_0);
        }
        return new CredentialDefinition(toSet(destination_0), new BasicCredentialSubject(claims));
    }
    function JSDeferredJsonCredentialResponse(_response) {
        this.q3g_1 = _response;
        this.acceptanceToken = this.q3g_1.j36_1;
        this.cNonce = this.q3g_1.k36_1;
        var tmp = this;
        var tmp1_safe_receiver = this.q3g_1.l36_1;
        tmp.cNonceExpiresIn = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l1();
    }
    protoOf(JSDeferredJsonCredentialResponse).r3g = function() {
        return this.acceptanceToken;
    };
    protoOf(JSDeferredJsonCredentialResponse).s3g = function() {
        return this.cNonce;
    };
    protoOf(JSDeferredJsonCredentialResponse).t3g = function() {
        return this.cNonceExpiresIn;
    };
    protoOf(JSDeferredJsonCredentialResponse).toJson = function() {
        return Default_getInstance().bp(Companion_instance_25.b1b(), this.q3g_1);
    };
    function JSJwtVcJsonVerifiableCredentialResponse(_response) {
        this.u3g_1 = _response;
        this.credential = this.u3g_1.n38().o2h_1;
        this.cNonce = this.u3g_1.b3b_1;
        var tmp = this;
        var tmp2_safe_receiver = this.u3g_1.c3b_1;
        tmp.cNonceExpiresIn = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.l1();
    }
    protoOf(JSJwtVcJsonVerifiableCredentialResponse).n38 = function() {
        return this.credential;
    };
    protoOf(JSJwtVcJsonVerifiableCredentialResponse).s3g = function() {
        return this.cNonce;
    };
    protoOf(JSJwtVcJsonVerifiableCredentialResponse).t3g = function() {
        return this.cNonceExpiresIn;
    };
    protoOf(JSJwtVcJsonVerifiableCredentialResponse).toJson = function() {
        return Default_getInstance().bp(Companion_instance_47.b1b(), this.u3g_1);
    };
    function JSLdpVerifiableCredentialResponse(_response) {
        this.v3g_1 = _response;
        this.credential = Companion_instance_74.w3g(this.v3g_1.n38().p2h_1);
        this.cNonce = this.v3g_1.g3b_1;
        var tmp = this;
        var tmp3_safe_receiver = this.v3g_1.h3b_1;
        tmp.cNonceExpiresIn = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.l1();
    }
    protoOf(JSLdpVerifiableCredentialResponse).n38 = function() {
        return this.credential;
    };
    protoOf(JSLdpVerifiableCredentialResponse).s3g = function() {
        return this.cNonce;
    };
    protoOf(JSLdpVerifiableCredentialResponse).t3g = function() {
        return this.cNonceExpiresIn;
    };
    protoOf(JSLdpVerifiableCredentialResponse).toJson = function() {
        return Default_getInstance().bp(Companion_instance_48.b1b(), this.v3g_1);
    };
    function JSJwtVcJsonLdVerifiableCredentialResponse(_response) {
        this.x3g_1 = _response;
        this.credential = this.x3g_1.n38().o2h_1;
        this.cNonce = this.x3g_1.l3b_1;
        var tmp = this;
        var tmp4_safe_receiver = this.x3g_1.m3b_1;
        tmp.cNonceExpiresIn = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.l1();
    }
    protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).n38 = function() {
        return this.credential;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).s3g = function() {
        return this.cNonce;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).t3g = function() {
        return this.cNonceExpiresIn;
    };
    protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).toJson = function() {
        return Default_getInstance().bp(Companion_instance_49.b1b(), this.x3g_1);
    };
    function convertJwtVcJsonResponse(response) {
        var tmp;
        if (response instanceof Deferred) tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.n3b_1));
        else if (response instanceof JwtVcJsonVerifiableCredentialResponse) tmp = Companion_instance_73.left(new JSJwtVcJsonVerifiableCredentialResponse(response));
        else noWhenBranchMatchedException();
        return tmp;
    }
    function convertJwtVcJsonLdResponse(response) {
        var tmp;
        if (response instanceof Deferred_1) tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.p3b_1));
        else if (response instanceof JwtVcJsonLdVerifiableCredentialResponse) tmp = Companion_instance_73.left(new JSJwtVcJsonLdVerifiableCredentialResponse(response));
        else noWhenBranchMatchedException();
        return tmp;
    }
    function convertLdpVcJsonResponse(response) {
        var tmp;
        if (response instanceof Deferred_0) tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.o3b_1));
        else if (response instanceof LdpVcVerifiableCredentialResponse) tmp = Companion_instance_73.left(new JSLdpVerifiableCredentialResponse(response));
        else noWhenBranchMatchedException();
        return tmp;
    }
    function JsDisplayable() {}
    function JsIssuerDisplay() {}
    function JsDisplayableSet() {}
    function JsServerMetadata$credentialsSupported$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = this$0.b3h_1.t33_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(this_0.m());
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = this_0.z().j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsServerMetadata.credentialsSupported$delegate.<anonymous>.<anonymous>' call
                // Inline function 'js.core.tupleOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$7 = [
                    item.a1(),
                    new JsCredentialIssuerSupportedCredential(item.b1())
                ];
                destination.e(tmp$ret$7);
            }
            var tmp$ret$10 = copyToArray(destination);
            return new Map(tmp$ret$10);
        };
    }
    function JsServerMetadata$display$delegate$lambda(this$0) {
        return function() {
            var tmp9_safe_receiver = this$0.b3h_1.v33_1;
            var tmp;
            if (tmp9_safe_receiver == null) tmp = null;
            else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp9_safe_receiver, 10));
                var tmp0_iterator = tmp9_safe_receiver.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsServerMetadata.display$delegate.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = new JsIssuerDisplayAdapter(item);
                    destination.e(tmp$ret$0);
                }
                tmp = destination;
            }
            var tmp10_safe_receiver = tmp;
            var tmp_0;
            if (tmp10_safe_receiver == null) tmp_0 = null;
            else // Inline function 'kotlin.collections.toTypedArray' call
            tmp_0 = copyToArray(tmp10_safe_receiver);
            return tmp_0;
        };
    }
    function JsServerMetadata(inner) {
        this.b3h_1 = inner;
        var tmp = this;
        var tmp8_safe_receiver = this.b3h_1.o33_1;
        var tmp_0;
        if (tmp8_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp8_safe_receiver);
        tmp.authorizationServers = tmp_0;
        this.credentialEndpoint = this.b3h_1.p33_1;
        this.batchCredentialEndpoint = this.b3h_1.q33_1;
        var tmp_1 = this;
        tmp_1.c3h_1 = lazy(JsServerMetadata$credentialsSupported$delegate$lambda(this));
        this.credentialIssuer = this.b3h_1.u33_1;
        var tmp_2 = this;
        tmp_2.d3h_1 = lazy(JsServerMetadata$display$delegate$lambda(this));
    }
    protoOf(JsServerMetadata).e3h = function() {
        return this.b3h_1;
    };
    protoOf(JsServerMetadata).f3h = function() {
        return this.authorizationServers;
    };
    protoOf(JsServerMetadata).g3h = function() {
        return this.credentialEndpoint;
    };
    protoOf(JsServerMetadata).h3h = function() {
        return this.batchCredentialEndpoint;
    };
    protoOf(JsServerMetadata).i3h = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.c3h_1;
        credentialsSupported$factory();
        return this_0.b1();
    };
    protoOf(JsServerMetadata).j3h = function() {
        return this.credentialIssuer;
    };
    protoOf(JsServerMetadata).k3h = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.d3h_1;
        display$factory();
        return this_0.b1();
    };
    function JsDisplayableAdapter$customClaims$delegate$lambda(this$0) {
        return function() {
            return new JSObject(this$0.inner.h34_1);
        };
    }
    function JsDisplayableAdapter(inner) {
        this.inner = inner;
        this.l3h_1 = this.inner.g34_1;
        this.m3h_1 = this.inner.f34_1;
        var tmp = this;
        tmp.n3h_1 = lazy(JsDisplayableAdapter$customClaims$delegate$lambda(this));
    }
    protoOf(JsDisplayableAdapter).o3h = function() {
        return this.inner;
    };
    protoOf(JsDisplayableAdapter).y3g = function() {
        return this.l3h_1;
    };
    protoOf(JsDisplayableAdapter).r2 = function() {
        return this.m3h_1;
    };
    protoOf(JsDisplayableAdapter).z3g = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.n3h_1;
        customClaims$factory();
        return this_0.b1();
    };
    function JsIssuerDisplayAdapter$customClaims$delegate$lambda(this$0) {
        return function() {
            return new JSObject(this$0.inner.d34_1);
        };
    }
    function JsIssuerDisplayAdapter(inner) {
        this.inner = inner;
        this.p3h_1 = this.inner.b34_1;
        this.q3h_1 = this.inner.a34_1;
        var tmp = this;
        var tmp11_safe_receiver = this.inner.c34_1;
        var tmp_0;
        if (tmp11_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsIssuerDisplayAdapter.logo.<anonymous>' call
        tmp_0 = new JsLogo(tmp11_safe_receiver);
        tmp.r3h_1 = tmp_0;
        var tmp_1 = this;
        tmp_1.s3h_1 = lazy(JsIssuerDisplayAdapter$customClaims$delegate$lambda(this));
    }
    protoOf(JsIssuerDisplayAdapter).o3h = function() {
        return this.inner;
    };
    protoOf(JsIssuerDisplayAdapter).y3g = function() {
        return this.p3h_1;
    };
    protoOf(JsIssuerDisplayAdapter).r2 = function() {
        return this.q3h_1;
    };
    protoOf(JsIssuerDisplayAdapter).a3h = function() {
        return this.r3h_1;
    };
    protoOf(JsIssuerDisplayAdapter).z3g = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.s3h_1;
        customClaims$factory_0();
        return this_0.b1();
    };
    function JsCredentialDisplayAdapter(inner) {
        this.description = inner.q34_1;
        this.backgroundColor = inner.r34_1;
        this.textColor = inner.t34_1;
        var tmp = this;
        var tmp12_safe_receiver = inner.p34_1;
        var tmp_0;
        if (tmp12_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsCredentialDisplayAdapter.logo.<anonymous>' call
        tmp_0 = new JsLogo(tmp12_safe_receiver);
        tmp.logo = tmp_0;
        this.locale = inner.o34_1;
        this.name = inner.n34_1;
        this.customClaims = JsonToJsConverter_instance.n28(inner.xl());
    }
    protoOf(JsCredentialDisplayAdapter).t3h = function() {
        return this.description;
    };
    protoOf(JsCredentialDisplayAdapter).u3h = function() {
        return this.backgroundColor;
    };
    protoOf(JsCredentialDisplayAdapter).v3h = function() {
        return this.textColor;
    };
    protoOf(JsCredentialDisplayAdapter).a3h = function() {
        return this.logo;
    };
    protoOf(JsCredentialDisplayAdapter).y3g = function() {
        return this.locale;
    };
    protoOf(JsCredentialDisplayAdapter).r2 = function() {
        return this.name;
    };
    protoOf(JsCredentialDisplayAdapter).z3g = function() {
        return this.customClaims;
    };
    function JsLogo$asJson$delegate$lambda(this$0) {
        return function() {
            return JsonToJsConverter_instance.n28(this$0.w3h_1.xl());
        };
    }
    function JsLogo(inner) {
        this.w3h_1 = inner;
        this.url = this.w3h_1.j34_1;
        this.altText = this.w3h_1.k34_1;
        var tmp = this;
        tmp.x3h_1 = lazy(JsLogo$asJson$delegate$lambda(this));
    }
    protoOf(JsLogo).y3h = function() {
        return this.url;
    };
    protoOf(JsLogo).z3h = function() {
        return this.altText;
    };
    protoOf(JsLogo).a3i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.x3h_1;
        asJson$factory();
        return this_0.b1();
    };
    function JsCredentialDisplay$customClaims$delegate$lambda(this$0) {
        return function() {
            return new JSObject(this$0.inner.u34_1);
        };
    }
    function JsCredentialDisplay$logo$delegate$lambda(this$0) {
        return function() {
            var tmp13_safe_receiver = this$0.inner.p34_1;
            var tmp;
            if (tmp13_safe_receiver == null) tmp = null;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'JsCredentialDisplay.logo$delegate.<anonymous>.<anonymous>' call
            tmp = new JsLogo(tmp13_safe_receiver);
            return tmp;
        };
    }
    function JsCredentialDisplay(inner) {
        this.inner = inner;
        this.b3i_1 = this.inner.o34_1;
        this.c3i_1 = this.inner.n34_1;
        var tmp = this;
        tmp.d3i_1 = lazy(JsCredentialDisplay$customClaims$delegate$lambda(this));
        this.description = this.inner.q34_1;
        this.backgroundColor = this.inner.r34_1;
        this.textColor = this.inner.t34_1;
        var tmp_0 = this;
        tmp_0.e3i_1 = lazy(JsCredentialDisplay$logo$delegate$lambda(this));
    }
    protoOf(JsCredentialDisplay).o3h = function() {
        return this.inner;
    };
    protoOf(JsCredentialDisplay).y3g = function() {
        return this.b3i_1;
    };
    protoOf(JsCredentialDisplay).r2 = function() {
        return this.c3i_1;
    };
    protoOf(JsCredentialDisplay).z3g = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.d3i_1;
        customClaims$factory_1();
        return this_0.b1();
    };
    protoOf(JsCredentialDisplay).t3h = function() {
        return this.description;
    };
    protoOf(JsCredentialDisplay).u3h = function() {
        return this.backgroundColor;
    };
    protoOf(JsCredentialDisplay).v3h = function() {
        return this.textColor;
    };
    protoOf(JsCredentialDisplay).a3h = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.e3i_1;
        logo$factory();
        return this_0.b1();
    };
    function JsCredentialIssuerSupportedCredential$display$delegate$lambda(this$0) {
        return function() {
            var tmp14_subject = this$0.f3i_1;
            var tmp;
            if (tmp14_subject instanceof DefaultJsonCredentialConfigurationsSupported) tmp = this$0.f3i_1.y34_1;
            else {
                if (tmp14_subject instanceof JwtVcJsonCredentialConfigurationsSupported) tmp = this$0.f3i_1.k39_1;
                else if (tmp14_subject instanceof VcSdJwtCredentialConfigurationsSupported) tmp = this$0.f3i_1.r37_1;
                else noWhenBranchMatchedException();
            }
            var displays = tmp;
            var tmp_0;
            if (displays == null) tmp_0 = null;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'JsCredentialIssuerSupportedCredential.display$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(displays, 10));
                var tmp0_iterator = displays.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsCredentialIssuerSupportedCredential.display$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = new JsCredentialDisplay(item);
                    destination.e(tmp$ret$0);
                }
                tmp_0 = new JsDisplayableSetAdapter(destination);
            }
            return tmp_0;
        };
    }
    function JsCredentialIssuerSupportedCredential(inner) {
        this.f3i_1 = inner;
        this.format = this.f3i_1.z33();
        var tmp = this;
        tmp.g3i_1 = lazy(JsCredentialIssuerSupportedCredential$display$delegate$lambda(this));
    }
    protoOf(JsCredentialIssuerSupportedCredential).e3h = function() {
        return this.f3i_1;
    };
    protoOf(JsCredentialIssuerSupportedCredential).z33 = function() {
        return this.format;
    };
    protoOf(JsCredentialIssuerSupportedCredential).k3h = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.g3i_1;
        display$factory_0();
        return this_0.b1();
    };
    function JsCredentialStatus(inner) {
        this.inner = inner;
        this.id = this.inner.g3c_1;
        this.type = this.inner.h3c_1;
    }
    protoOf(JsCredentialStatus).o3h = function() {
        return this.inner;
    };
    protoOf(JsCredentialStatus).k2a = function() {
        return this.id;
    };
    protoOf(JsCredentialStatus).g36 = function() {
        return this.type;
    };
    function JsSdValue() {}
    function JsSdObject$buildNestedDisclosure$lambda($disclosures) {
        return function(property, _unused_var__etf5q3) {
            var tmp;
            if (!(property.disclosureString == null)) {
                var this_0 = $disclosures;
                var item = property.disclosureString;
                // Inline function 'kotlin.js.asDynamic' call
                tmp = this_0.push(item);
            }
            return Unit_instance;
        };
    }
    function JsSdObject(members) {
        this.members = members;
    }
    protoOf(JsSdObject).h3i = function() {
        return this.members;
    };
    protoOf(JsSdObject).buildNestedDisclosure = function(disclosures) {
        this.members.forEach(JsSdObject$buildNestedDisclosure$lambda(disclosures));
    };
    function JsSdArray(elements) {
        this.elements = elements;
    }
    protoOf(JsSdArray).i3i = function() {
        return this.elements;
    };
    protoOf(JsSdArray).buildNestedDisclosure = function(disclosures) {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this.elements;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while(inductionVariable < last){
            var element = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'JsSdArray.buildNestedDisclosure.<anonymous>' call
            if (!(element.disclosureString == null)) {
                // Inline function 'js.core.push' call
                var item = element.disclosureString;
                // Inline function 'kotlin.js.asDynamic' call
                disclosures.push(item);
            }
        }
    };
    function JsSdPrimitive(value) {
        this.value = value;
    }
    protoOf(JsSdPrimitive).b1 = function() {
        return this.value;
    };
    protoOf(JsSdPrimitive).buildNestedDisclosure = function(disclosures) {};
    function JsSdProperty(name, value, disclosureString) {
        disclosureString = disclosureString === VOID ? null : disclosureString;
        this.name = name;
        this.value = value;
        this.disclosureString = disclosureString;
        this.isSelectivelyDisclosable = !(this.disclosureString == null);
    }
    protoOf(JsSdProperty).r2 = function() {
        return this.name;
    };
    protoOf(JsSdProperty).b1 = function() {
        return this.value;
    };
    protoOf(JsSdProperty).j3i = function() {
        return this.disclosureString;
    };
    protoOf(JsSdProperty).k3i = function() {
        return this.isSelectivelyDisclosable;
    };
    protoOf(JsSdProperty).isDisclosedBy = function(disclosures) {
        return contains(disclosures, this.disclosureString);
    };
    function JsSdArrayValue(value, disclosureString) {
        disclosureString = disclosureString === VOID ? null : disclosureString;
        this.value = value;
        this.disclosureString = disclosureString;
        this.isSelectivelyDisclosable = !(this.disclosureString == null);
    }
    protoOf(JsSdArrayValue).b1 = function() {
        return this.value;
    };
    protoOf(JsSdArrayValue).j3i = function() {
        return this.disclosureString;
    };
    protoOf(JsSdArrayValue).k3i = function() {
        return this.isSelectivelyDisclosable;
    };
    protoOf(JsSdArrayValue).isDisclosedBy = function(disclosures) {
        return contains(disclosures, this.disclosureString);
    };
    function JsCredentialIssuer(credentialIssuer) {
        this.credentialIssuer = credentialIssuer;
        this.id = this.credentialIssuer.t32_1.u33_1;
        var tmp = this;
        var tmp18_safe_receiver = this.credentialIssuer.t32_1.v33_1;
        var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : firstOrNull(tmp18_safe_receiver);
        var tmp0_elvis_lhs = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.a34_1;
        tmp.name = tmp0_elvis_lhs == null ? "<no name>" : tmp0_elvis_lhs;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.credentialIssuer.t32_1.t33_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(this_0.m());
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = this_0.z().j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JsCredentialIssuer.credentialsSupported.<anonymous>' call
            // Inline function 'js.core.tupleOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$7 = [
                item.a1(),
                new JsCredentialIssuerSupportedCredential(item.b1())
            ];
            destination.e(tmp$ret$7);
        }
        var tmp$ret$10 = copyToArray(destination);
        tmp_0.credentialsSupported = new Map(tmp$ret$10);
        this.authorizationEndpoint = this.credentialIssuer.u32_1.s35_1;
        this.tokenEndpoint = this.credentialIssuer.u32_1.t35_1;
    }
    protoOf(JsCredentialIssuer).j3h = function() {
        return this.credentialIssuer;
    };
    protoOf(JsCredentialIssuer).k2a = function() {
        return this.id;
    };
    protoOf(JsCredentialIssuer).r2 = function() {
        return this.name;
    };
    protoOf(JsCredentialIssuer).i3h = function() {
        return this.credentialsSupported;
    };
    protoOf(JsCredentialIssuer).l3i = function() {
        return this.authorizationEndpoint;
    };
    protoOf(JsCredentialIssuer).m3i = function() {
        return this.tokenEndpoint;
    };
    function JsUserVerifiableCredential$credential$delegate$lambda(this$0) {
        return function() {
            return new JSCredentialResponse(this$0.n3i_1.e33_1);
        };
    }
    function JsUserVerifiableCredential(userVerifiableCredential) {
        this.n3i_1 = userVerifiableCredential;
        this.id = this.n3i_1.a33_1;
        this.issuerId = this.n3i_1.b33_1;
        this.issuedAt = this.n3i_1.c33_1.f1m().p3();
        var tmp = this;
        tmp.o3i_1 = lazy(JsUserVerifiableCredential$credential$delegate$lambda(this));
        this.userDefinedName = this.n3i_1.d33_1;
    }
    protoOf(JsUserVerifiableCredential).p3i = function() {
        return this.n3i_1;
    };
    protoOf(JsUserVerifiableCredential).k2a = function() {
        return this.id;
    };
    protoOf(JsUserVerifiableCredential).q3i = function() {
        return this.issuerId;
    };
    protoOf(JsUserVerifiableCredential).r3i = function() {
        return this.issuedAt;
    };
    protoOf(JsUserVerifiableCredential).n38 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.o3i_1;
        credential$factory();
        return this_0.b1();
    };
    protoOf(JsUserVerifiableCredential).s3i = function() {
        return this.userDefinedName;
    };
    protoOf(JsUserVerifiableCredential).withUserDefinedName = function(newName) {
        return new JsUserVerifiableCredential(this.n3i_1.g33(VOID, VOID, VOID, newName));
    };
    function JsLdpVcJsonLdCredential$value$delegate$lambda(this$0) {
        return function() {
            return new JSW3CVerifiableCredential(this$0.inner.k32());
        };
    }
    function JsLdpVcJsonLdCredential(inner) {
        this.inner = inner;
        var tmp = this;
        tmp.t3i_1 = lazy(JsLdpVcJsonLdCredential$value$delegate$lambda(this));
    }
    protoOf(JsLdpVcJsonLdCredential).o3h = function() {
        return this.inner;
    };
    protoOf(JsLdpVcJsonLdCredential).b1 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.t3i_1;
        value$factory();
        return this_0.b1();
    };
    function JSCredentialResponse$jwtVcJsonLd$delegate$lambda(this$0) {
        return function() {
            var tmp20_subject = this$0.inner;
            var tmp;
            if (isInterface(tmp20_subject, ValidatedJwtVcJsonLdCredentialResponse)) tmp = new JsJwtVcJsonLdCredential(this$0.inner);
            else tmp = null;
            return tmp;
        };
    }
    function JSCredentialResponse$jwtVcJson$delegate$lambda(this$0) {
        return function() {
            var tmp21_subject = this$0.inner;
            var tmp;
            if (isInterface(tmp21_subject, ValidatedJwtVcJsonCredentialResponse)) tmp = new JsJwtVcJsonCredential(this$0.inner);
            else tmp = null;
            return tmp;
        };
    }
    function JSCredentialResponse$didJwtVcJson$delegate$lambda(this$0) {
        return function() {
            var tmp;
            if (this$0.inner instanceof DidValidatedJwtVcJsonCredentialResponse) tmp = new JsDidJwtVcJsonCredential(this$0.inner);
            else tmp = null;
            return tmp;
        };
    }
    function JSCredentialResponse$ldp$delegate$lambda(this$0) {
        return function() {
            var tmp23_subject = this$0.inner;
            var tmp;
            if (isInterface(tmp23_subject, ValidatedLdpVcCredentialResponse)) tmp = new JsLdpVcJsonLdCredential(this$0.inner);
            else tmp = null;
            return tmp;
        };
    }
    function JSCredentialResponse$vcSdJwt$delegate$lambda(this$0) {
        return function() {
            var tmp;
            if (this$0.inner instanceof DefaultValidatedVcSdJwtCredentialResponse) tmp = new JsVcSdJwtCredential(this$0.inner);
            else tmp = null;
            return tmp;
        };
    }
    function JSCredentialResponse(inner) {
        this.inner = inner;
        var tmp = this;
        tmp.u3i_1 = lazy(JSCredentialResponse$jwtVcJsonLd$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.v3i_1 = lazy(JSCredentialResponse$jwtVcJson$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.w3i_1 = lazy(JSCredentialResponse$didJwtVcJson$delegate$lambda(this));
        var tmp_2 = this;
        tmp_2.x3i_1 = lazy(JSCredentialResponse$ldp$delegate$lambda(this));
        var tmp_3 = this;
        tmp_3.y3i_1 = lazy(JSCredentialResponse$vcSdJwt$delegate$lambda(this));
    }
    protoOf(JSCredentialResponse).o3h = function() {
        return this.inner;
    };
    protoOf(JSCredentialResponse).z3i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.u3i_1;
        jwtVcJsonLd$factory();
        return this_0.b1();
    };
    protoOf(JSCredentialResponse).a3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.v3i_1;
        jwtVcJson$factory();
        return this_0.b1();
    };
    protoOf(JSCredentialResponse).b3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.w3i_1;
        didJwtVcJson$factory();
        return this_0.b1();
    };
    protoOf(JSCredentialResponse).c3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.x3i_1;
        ldp$factory();
        return this_0.b1();
    };
    protoOf(JSCredentialResponse).d3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.y3i_1;
        vcSdJwt$factory();
        return this_0.b1();
    };
    protoOf(JSCredentialResponse).match = function(onJwtVcJsonLd, onJwtVcJson, onLdp, onVcSdJwt) {
        var tmp25_subject = this.inner;
        var tmp;
        if (isInterface(tmp25_subject, ValidatedJwtVcJsonCredentialResponse)) tmp = onJwtVcJson(ensureNotNull(this.jwtVcJson));
        else if (isInterface(tmp25_subject, ValidatedJwtVcJsonLdCredentialResponse)) tmp = onJwtVcJsonLd(ensureNotNull(this.jwtVcJsonLd));
        else {
            if (isInterface(tmp25_subject, ValidatedLdpVcCredentialResponse)) tmp = onLdp(ensureNotNull(this.ldp));
            else if (isInterface(tmp25_subject, ValidatedVcSdJwtCredentialResponse)) tmp = onVcSdJwt(ensureNotNull(this.vcSdJwt));
            else noWhenBranchMatchedException();
        }
        return tmp;
    };
    function JsJwtVcJsonLdCredential(inner) {
        this.inner = inner;
        this.value = this.inner.k31();
    }
    protoOf(JsJwtVcJsonLdCredential).o3h = function() {
        return this.inner;
    };
    protoOf(JsJwtVcJsonLdCredential).b1 = function() {
        return this.value;
    };
    function JsJwtVcJsonCredential(inner) {
        this.inner = inner;
        this.value = this.inner.k31();
    }
    protoOf(JsJwtVcJsonCredential).o3h = function() {
        return this.inner;
    };
    protoOf(JsJwtVcJsonCredential).b1 = function() {
        return this.value;
    };
    function JsDidJwtVcJsonCredential$claimDisplayables$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = this$0.e3j_1.h31_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(this_0.m());
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = this_0.z().j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsDidJwtVcJsonCredential.claimDisplayables$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = item.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = item.b1();
                // Inline function 'js.core.tupleOf' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
                var tmp0_iterator_0 = value.j();
                while(tmp0_iterator_0.k()){
                    var item_0 = tmp0_iterator_0.l();
                    // Inline function 'JsDidJwtVcJsonCredential.claimDisplayables$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$3 = new JsDisplayableAdapter(item_0);
                    destination_0.e(tmp$ret$3);
                }
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$12 = [
                    key,
                    new JsDisplayableSetAdapter(destination_0)
                ];
                destination.e(tmp$ret$12);
            }
            var tmp$ret$15 = copyToArray(destination);
            return new Map(tmp$ret$15);
        };
    }
    function JsDidJwtVcJsonCredential$credentialDisplay$delegate$lambda(this$0) {
        return function() {
            var tmp26_safe_receiver = this$0.e3j_1.i31_1;
            var tmp;
            if (tmp26_safe_receiver == null) tmp = null;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'JsDidJwtVcJsonCredential.credentialDisplay$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp26_safe_receiver, 10));
                var tmp0_iterator = tmp26_safe_receiver.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsDidJwtVcJsonCredential.credentialDisplay$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = new JsCredentialDisplay(item);
                    destination.e(tmp$ret$0);
                }
                tmp = new JsDisplayableSetAdapter(destination);
            }
            return tmp;
        };
    }
    function JsDidJwtVcJsonCredential$subjectStringProperties$delegate$lambda(this$0) {
        return function() {
            var item = this$0.e3j_1.g31_1.w3b_1.mm();
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.mapNotNull' call
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var this_0 = item.f2();
            var destination = ArrayList_init_$Create$_0();
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
                // Inline function 'JsDidJwtVcJsonCredential.subjectStringProperties$delegate.<anonymous>.<anonymous>' call
                var field = item.vl(element);
                var tmp;
                if (field instanceof JsonPrimitive) // Inline function 'js.core.tupleOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp = [
                    element,
                    field.e1b()
                ];
                else tmp = null;
                var tmp0_safe_receiver = tmp;
                if (tmp0_safe_receiver == null) ;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                destination.e(tmp0_safe_receiver);
            }
            var tmp$ret$10 = copyToArray(destination);
            return new Map(tmp$ret$10);
        };
    }
    function JsDidJwtVcJsonCredential(inner) {
        this.e3j_1 = inner;
        var tmp = this;
        tmp.f3j_1 = lazy(JsDidJwtVcJsonCredential$claimDisplayables$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.g3j_1 = lazy(JsDidJwtVcJsonCredential$credentialDisplay$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.h3j_1 = lazy(JsDidJwtVcJsonCredential$subjectStringProperties$delegate$lambda(this));
    }
    protoOf(JsDidJwtVcJsonCredential).i3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.f3j_1;
        claimDisplayables$factory();
        return this_0.b1();
    };
    protoOf(JsDidJwtVcJsonCredential).j3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.g3j_1;
        credentialDisplay$factory();
        return this_0.b1();
    };
    protoOf(JsDidJwtVcJsonCredential).k3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.h3j_1;
        subjectStringProperties$factory();
        return this_0.b1();
    };
    function JsSelectivelyDiscloseableClaim(name, value, isSelectivelyDiscloseable) {
        this.name = name;
        this.value = value;
        this.isSelectivelyDiscloseable = isSelectivelyDiscloseable;
    }
    protoOf(JsSelectivelyDiscloseableClaim).r2 = function() {
        return this.name;
    };
    protoOf(JsSelectivelyDiscloseableClaim).b1 = function() {
        return this.value;
    };
    protoOf(JsSelectivelyDiscloseableClaim).l3j = function() {
        return this.isSelectivelyDiscloseable;
    };
    protoOf(JsSelectivelyDiscloseableClaim).ba = function() {
        return this.name;
    };
    protoOf(JsSelectivelyDiscloseableClaim).ca = function() {
        return this.value;
    };
    protoOf(JsSelectivelyDiscloseableClaim).qj = function() {
        return this.isSelectivelyDiscloseable;
    };
    protoOf(JsSelectivelyDiscloseableClaim).m3j = function(name, value, isSelectivelyDiscloseable) {
        return new JsSelectivelyDiscloseableClaim(name, value, isSelectivelyDiscloseable);
    };
    protoOf(JsSelectivelyDiscloseableClaim).copy = function(name, value, isSelectivelyDiscloseable, $super) {
        name = name === VOID ? this.name : name;
        value = value === VOID ? this.value : value;
        isSelectivelyDiscloseable = isSelectivelyDiscloseable === VOID ? this.isSelectivelyDiscloseable : isSelectivelyDiscloseable;
        return this.m3j(name, value, isSelectivelyDiscloseable);
    };
    protoOf(JsSelectivelyDiscloseableClaim).toString = function() {
        return "JsSelectivelyDiscloseableClaim(name=" + this.name + ", value=" + toString_0(this.value) + ", isSelectivelyDiscloseable=" + this.isSelectivelyDiscloseable + ")";
    };
    protoOf(JsSelectivelyDiscloseableClaim).hashCode = function() {
        var result = getStringHashCode(this.name);
        result = imul(result, 31) + (this.value == null ? 0 : hashCode(this.value)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.isSelectivelyDiscloseable) | 0;
        return result;
    };
    protoOf(JsSelectivelyDiscloseableClaim).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsSelectivelyDiscloseableClaim)) return false;
        var tmp0_other_with_cast = other instanceof JsSelectivelyDiscloseableClaim ? other : THROW_CCE();
        if (!(this.name === tmp0_other_with_cast.name)) return false;
        if (!equals(this.value, tmp0_other_with_cast.value)) return false;
        if (!(this.isSelectivelyDiscloseable === tmp0_other_with_cast.isSelectivelyDiscloseable)) return false;
        return true;
    };
    function JsVcSdJwtCredential$claimDisplayables$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = this$0.n3j_1.u30_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(this_0.m());
            // Inline function 'kotlin.collections.iterator' call
            var tmp0_iterator = this_0.z().j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsVcSdJwtCredential.claimDisplayables$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = item.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = item.b1();
                // Inline function 'js.core.tupleOf' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
                var tmp0_iterator_0 = value.j();
                while(tmp0_iterator_0.k()){
                    var item_0 = tmp0_iterator_0.l();
                    // Inline function 'JsVcSdJwtCredential.claimDisplayables$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$3 = new JsDisplayableAdapter(item_0);
                    destination_0.e(tmp$ret$3);
                }
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$12 = [
                    key,
                    new JsDisplayableSetAdapter(destination_0)
                ];
                destination.e(tmp$ret$12);
            }
            var tmp$ret$15 = copyToArray(destination);
            return new Map(tmp$ret$15);
        };
    }
    function JsVcSdJwtCredential$credentialDisplay$delegate$lambda(this$0) {
        return function() {
            var tmp27_safe_receiver = this$0.n3j_1.v30_1;
            var tmp;
            if (tmp27_safe_receiver == null) tmp = null;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'JsVcSdJwtCredential.credentialDisplay$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp27_safe_receiver, 10));
                var tmp0_iterator = tmp27_safe_receiver.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsVcSdJwtCredential.credentialDisplay$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = new JsCredentialDisplay(item);
                    destination.e(tmp$ret$0);
                }
                tmp = new JsDisplayableSetAdapter(destination);
            }
            return tmp;
        };
    }
    function JsVcSdJwtCredential$customStringClaims$delegate$lambda(this$0) {
        return function() {
            var customClaims = this$0.n3j_1.z30_1.g2w_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.mapNotNull' call
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var this_0 = customClaims.f2();
            var destination = ArrayList_init_$Create$_0();
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
                // Inline function 'JsVcSdJwtCredential.customStringClaims$delegate.<anonymous>.<anonymous>' call
                var claim = ensureNotNull(customClaims.e2(element));
                var field = claim.s2w_1;
                var tmp;
                if (field instanceof Primitive) {
                    var tmp28_safe_receiver = field.n2w_1;
                    var tmp0_elvis_lhs = tmp28_safe_receiver == null ? null : tmp28_safe_receiver.e1b();
                    tmp = new JsSelectivelyDiscloseableClaim(element, tmp0_elvis_lhs == null ? "" : tmp0_elvis_lhs, !(claim.t2w_1 == null));
                } else tmp = null;
                var tmp0_safe_receiver = tmp;
                if (tmp0_safe_receiver == null) ;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                destination.e(tmp0_safe_receiver);
            }
            return copyToArray(destination);
        };
    }
    function JsVcSdJwtCredential(inner) {
        this.n3j_1 = inner;
        var tmp = this;
        tmp.o3j_1 = lazy(JsVcSdJwtCredential$claimDisplayables$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.p3j_1 = lazy(JsVcSdJwtCredential$credentialDisplay$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.q3j_1 = lazy(JsVcSdJwtCredential$customStringClaims$delegate$lambda(this));
        this.customSdClaims = JsSdValue_0(this.n3j_1.z30_1);
    }
    protoOf(JsVcSdJwtCredential).i3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.o3j_1;
        claimDisplayables$factory_0();
        return this_0.b1();
    };
    protoOf(JsVcSdJwtCredential).j3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.p3j_1;
        credentialDisplay$factory_0();
        return this_0.b1();
    };
    protoOf(JsVcSdJwtCredential).r3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.q3j_1;
        customStringClaims$factory();
        return this_0.b1();
    };
    protoOf(JsVcSdJwtCredential).s3j = function() {
        return this.customSdClaims;
    };
    function JsDisplayableSetAdapter(inner) {
        this.t3j_1 = inner;
    }
    protoOf(JsDisplayableSetAdapter).getBestMatchForLocales = function(preferredLocales) {
        var tmp$ret$10;
        $l$block_2: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(preferredLocales.length);
            var inductionVariable = 0;
            var last = preferredLocales.length;
            while(inductionVariable < last){
                var item = preferredLocales[inductionVariable];
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>' call
                var tmp$ret$0 = new Locale(item);
                destination.e(tmp$ret$0);
            }
            var tmp0_iterator = destination.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>' call
                var tmp;
                if (element.ql_1) {
                    var tmp$ret$4;
                    $l$block: {
                        // Inline function 'kotlin.collections.firstOrNull' call
                        var tmp0_iterator_0 = this.t3j_1.j();
                        while(tmp0_iterator_0.k()){
                            var element_0 = tmp0_iterator_0.l();
                            // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
                            if (element.sl(element_0.locale)) {
                                tmp$ret$4 = element_0;
                                break $l$block;
                            }
                        }
                        tmp$ret$4 = null;
                    }
                    tmp = tmp$ret$4;
                } else {
                    var tmp$ret$6;
                    $l$block_0: {
                        // Inline function 'kotlin.collections.firstOrNull' call
                        var tmp0_iterator_1 = this.t3j_1.j();
                        while(tmp0_iterator_1.k()){
                            var element_1 = tmp0_iterator_1.l();
                            // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
                            if (element.toString() === element_1.locale) {
                                tmp$ret$6 = element_1;
                                break $l$block_0;
                            }
                        }
                        tmp$ret$6 = null;
                    }
                    var tmp0_elvis_lhs = tmp$ret$6;
                    var tmp_0;
                    if (tmp0_elvis_lhs == null) {
                        var tmp$ret$8;
                        $l$block_1: {
                            // Inline function 'kotlin.collections.firstOrNull' call
                            var tmp0_iterator_2 = this.t3j_1.j();
                            while(tmp0_iterator_2.k()){
                                var element_2 = tmp0_iterator_2.l();
                                // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
                                if (element.sl(element_2.locale)) {
                                    tmp$ret$8 = element_2;
                                    break $l$block_1;
                                }
                            }
                            tmp$ret$8 = null;
                        }
                        tmp_0 = tmp$ret$8;
                    } else tmp_0 = tmp0_elvis_lhs;
                    tmp = tmp_0;
                }
                var result = tmp;
                if (!(result == null)) {
                    tmp$ret$10 = result;
                    break $l$block_2;
                }
            }
            tmp$ret$10 = null;
        }
        var tmp0_elvis_lhs_0 = tmp$ret$10;
        return tmp0_elvis_lhs_0 == null ? firstOrNull(this.t3j_1) : tmp0_elvis_lhs_0;
    };
    function JsSdValue_0(value) {
        var tmp;
        if (value instanceof Object_0) {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = value.g2w_1.g2();
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsSdValue.<anonymous>' call
                // Inline function 'js.core.tupleOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$6 = [
                    item.r2w_1,
                    new JsSdProperty(item.r2w_1, JsSdValue_0(item.s2w_1), item.t2w_1)
                ];
                destination.e(tmp$ret$6);
            }
            var tmp$ret$9 = copyToArray(destination);
            tmp = new JsSdObject(new Map(tmp$ret$9));
        } else {
            if (value instanceof Array_0) {
                // Inline function 'kotlin.collections.toTypedArray' call
                // Inline function 'kotlin.collections.map' call
                var this_1 = value.k2w_1;
                // Inline function 'kotlin.collections.mapTo' call
                var destination_0 = ArrayList_init_$Create$(this_1.length);
                var inductionVariable = 0;
                var last = this_1.length;
                while(inductionVariable < last){
                    var item_0 = this_1[inductionVariable];
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'JsSdValue.<anonymous>' call
                    var tmp$ret$10 = new JsSdArrayValue(JsSdValue_0(item_0.x2w_1), item_0.y2w_1);
                    destination_0.e(tmp$ret$10);
                }
                var tmp$ret$13 = copyToArray(destination_0);
                tmp = new JsSdArray(tmp$ret$13);
            } else if (value instanceof Primitive) {
                var tmp17_safe_receiver = value.n2w_1;
                tmp = new JsSdPrimitive(tmp17_safe_receiver == null ? null : tmp17_safe_receiver.e1b());
            } else noWhenBranchMatchedException();
        }
        return tmp;
    }
    function inner(_this__u8e3s4) {
        return _this__u8e3s4.b3h_1;
    }
    function inner_0(_this__u8e3s4) {
        return _this__u8e3s4.f3i_1;
    }
    function createJsCredentialIssuer(credentialIssuer) {
        return new JsCredentialIssuer(credentialIssuer);
    }
    function inner_1(_this__u8e3s4) {
        return _this__u8e3s4.n3i_1;
    }
    function createJsUserVerifiableCredential(inner) {
        return new JsUserVerifiableCredential(inner);
    }
    function createJsCredentialIssuerSupportedCredential(inner) {
        return new JsCredentialIssuerSupportedCredential(inner);
    }
    function credentialsSupported$factory() {
        return getPropertyCallableRef("credentialsSupported", 1, KProperty1, function(receiver) {
            return receiver.credentialsSupported;
        }, null);
    }
    function display$factory() {
        return getPropertyCallableRef("display", 1, KProperty1, function(receiver) {
            return receiver.display;
        }, null);
    }
    function customClaims$factory() {
        return getPropertyCallableRef("customClaims", 1, KProperty1, function(receiver) {
            return receiver.customClaims;
        }, null);
    }
    function customClaims$factory_0() {
        return getPropertyCallableRef("customClaims", 1, KProperty1, function(receiver) {
            return receiver.customClaims;
        }, null);
    }
    function asJson$factory() {
        return getPropertyCallableRef("asJson", 1, KProperty1, function(receiver) {
            return receiver.asJson;
        }, null);
    }
    function customClaims$factory_1() {
        return getPropertyCallableRef("customClaims", 1, KProperty1, function(receiver) {
            return receiver.customClaims;
        }, null);
    }
    function logo$factory() {
        return getPropertyCallableRef("logo", 1, KProperty1, function(receiver) {
            return receiver.logo;
        }, null);
    }
    function display$factory_0() {
        return getPropertyCallableRef("display", 1, KProperty1, function(receiver) {
            return receiver.display;
        }, null);
    }
    function credential$factory() {
        return getPropertyCallableRef("credential", 1, KProperty1, function(receiver) {
            return receiver.credential;
        }, null);
    }
    function value$factory() {
        return getPropertyCallableRef("value", 1, KProperty1, function(receiver) {
            return receiver.value;
        }, null);
    }
    function jwtVcJsonLd$factory() {
        return getPropertyCallableRef("jwtVcJsonLd", 1, KProperty1, function(receiver) {
            return receiver.jwtVcJsonLd;
        }, null);
    }
    function jwtVcJson$factory() {
        return getPropertyCallableRef("jwtVcJson", 1, KProperty1, function(receiver) {
            return receiver.jwtVcJson;
        }, null);
    }
    function didJwtVcJson$factory() {
        return getPropertyCallableRef("didJwtVcJson", 1, KProperty1, function(receiver) {
            return receiver.didJwtVcJson;
        }, null);
    }
    function ldp$factory() {
        return getPropertyCallableRef("ldp", 1, KProperty1, function(receiver) {
            return receiver.ldp;
        }, null);
    }
    function vcSdJwt$factory() {
        return getPropertyCallableRef("vcSdJwt", 1, KProperty1, function(receiver) {
            return receiver.vcSdJwt;
        }, null);
    }
    function claimDisplayables$factory() {
        return getPropertyCallableRef("claimDisplayables", 1, KProperty1, function(receiver) {
            return receiver.claimDisplayables;
        }, null);
    }
    function credentialDisplay$factory() {
        return getPropertyCallableRef("credentialDisplay", 1, KProperty1, function(receiver) {
            return receiver.credentialDisplay;
        }, null);
    }
    function subjectStringProperties$factory() {
        return getPropertyCallableRef("subjectStringProperties", 1, KProperty1, function(receiver) {
            return receiver.subjectStringProperties;
        }, null);
    }
    function claimDisplayables$factory_0() {
        return getPropertyCallableRef("claimDisplayables", 1, KProperty1, function(receiver) {
            return receiver.claimDisplayables;
        }, null);
    }
    function credentialDisplay$factory_0() {
        return getPropertyCallableRef("credentialDisplay", 1, KProperty1, function(receiver) {
            return receiver.credentialDisplay;
        }, null);
    }
    function customStringClaims$factory() {
        return getPropertyCallableRef("customStringClaims", 1, KProperty1, function(receiver) {
            return receiver.customStringClaims;
        }, null);
    }
    function Companion_72() {}
    protoOf(Companion_72).w3g = function(credential) {
        return new JSW3CVerifiableCredential(credential);
    };
    var Companion_instance_74;
    function Companion_getInstance_72() {
        return Companion_instance_74;
    }
    function JSW3CVerifiableCredential(_credential) {
        this.u3j_1 = _credential;
    }
    protoOf(JSW3CVerifiableCredential).k2a = function() {
        return this.u3j_1.t3b_1;
    };
    protoOf(JSW3CVerifiableCredential).b9 = function() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = this.u3j_1.u3b_1;
        return copyToArray(this_0);
    };
    protoOf(JSW3CVerifiableCredential).p3g = function() {
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = this.u3j_1.v3b_1;
        return copyToArray(this_0);
    };
    protoOf(JSW3CVerifiableCredential).v3j = function() {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.u3j_1.w3b_1.qm();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JSW3CVerifiableCredential.<get-credentialSubject>.<anonymous>' call
            var tmp$ret$0 = new JSObject(item);
            destination.e(tmp$ret$0);
        }
        return copyToArray(destination);
    };
    protoOf(JSW3CVerifiableCredential).e3c = function() {
        var iss = this.u3j_1.x3b_1.q3c();
        var tmp;
        if (iss instanceof IssuerObject_0) tmp = Companion_instance_73.right(new JSIssuerObject(iss.f3c()));
        else if (iss instanceof IssuerURI_0) tmp = Companion_instance_73.left(iss.m36_1);
        else noWhenBranchMatchedException();
        return tmp;
    };
    protoOf(JSW3CVerifiableCredential).w3j = function() {
        return this.u3j_1.y3b_1;
    };
    protoOf(JSW3CVerifiableCredential).x3j = function() {
        var tmp29_safe_receiver = this.u3j_1.z3b_1;
        var tmp30_safe_receiver = tmp29_safe_receiver == null ? null : tmp29_safe_receiver.qm();
        var tmp;
        if (tmp30_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp30_safe_receiver, 10));
            var tmp0_iterator = tmp30_safe_receiver.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JSW3CVerifiableCredential.<get-proof>.<anonymous>' call
                var tmp$ret$0 = new JSProofObject(item);
                destination.e(tmp$ret$0);
            }
            tmp = destination;
        }
        var tmp31_safe_receiver = tmp;
        var tmp_0;
        if (tmp31_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp31_safe_receiver);
        return tmp_0;
    };
    protoOf(JSW3CVerifiableCredential).y3j = function() {
        return this.u3j_1.a3c_1;
    };
    protoOf(JSW3CVerifiableCredential).z3j = function() {
        var tmp32_safe_receiver = this.u3j_1.b3c_1;
        var tmp;
        if (tmp32_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JSW3CVerifiableCredential.<get-credentialStatus>.<anonymous>' call
        tmp = new JSCredentialStatusObject(tmp32_safe_receiver);
        return tmp;
    };
    protoOf(JSW3CVerifiableCredential).z3g = function() {
        var tmp33_safe_receiver = this.u3j_1.c3c_1;
        var tmp;
        if (tmp33_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JSW3CVerifiableCredential.<get-customClaims>.<anonymous>' call
        tmp = new JSObject(tmp33_safe_receiver);
        return tmp;
    };
    protoOf(JSW3CVerifiableCredential).toJson = function() {
        return Default_getInstance().bp(Companion_instance_54.b1b(), this.u3j_1);
    };
    //region block: post-declaration
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    protoOf($serializer_1).mz = typeParametersSerializers;
    protoOf($serializer_2).mz = typeParametersSerializers;
    protoOf($serializer_3).mz = typeParametersSerializers;
    protoOf($serializer_4).mz = typeParametersSerializers;
    protoOf($serializer_5).mz = typeParametersSerializers;
    protoOf($serializer_6).mz = typeParametersSerializers;
    protoOf($serializer_7).mz = typeParametersSerializers;
    protoOf($serializer_8).mz = typeParametersSerializers;
    protoOf($serializer_9).mz = typeParametersSerializers;
    protoOf(JsonIssuerDisplay).f2 = get_keys;
    protoOf(JsonIssuerDisplay).vl = get;
    protoOf(JsonIssuerDisplay).a27 = toJson_0;
    protoOf(JsonIssuerDisplay).xl = toMap_0;
    protoOf(JsonDisplayable).f2 = get_keys;
    protoOf(JsonDisplayable).vl = get;
    protoOf(JsonDisplayable).a27 = toJson_0;
    protoOf(JsonDisplayable).xl = toMap_0;
    protoOf(JsonLogo).f2 = get_keys;
    protoOf(JsonLogo).vl = get;
    protoOf(JsonLogo).a27 = toJson_0;
    protoOf(JsonLogo).xl = toMap_0;
    protoOf(JsonCredentialDisplay).f2 = get_keys;
    protoOf(JsonCredentialDisplay).vl = get;
    protoOf(JsonCredentialDisplay).a27 = toJson_0;
    protoOf(JsonCredentialDisplay).xl = toMap_0;
    protoOf(DefaultJsonCredentialConfigurationsSupported).f2 = get_keys;
    protoOf(DefaultJsonCredentialConfigurationsSupported).vl = get;
    protoOf(DefaultJsonCredentialConfigurationsSupported).a27 = toJson_0;
    protoOf(DefaultJsonCredentialConfigurationsSupported).xl = toMap_0;
    protoOf($serializer_10).mz = typeParametersSerializers;
    protoOf(JsonImage).f2 = get_keys;
    protoOf(JsonImage).vl = get;
    protoOf(JsonImage).a27 = toJson_0;
    protoOf(JsonImage).xl = toMap_0;
    protoOf($serializer_11).mz = typeParametersSerializers;
    protoOf($serializer_12).mz = typeParametersSerializers;
    protoOf(JwtProofOfPossession).f2 = get_keys;
    protoOf(JwtProofOfPossession).vl = get;
    protoOf(JwtProofOfPossession).a27 = toJson_0;
    protoOf(JsonProofOfPossession).f2 = get_keys;
    protoOf(JsonProofOfPossession).vl = get;
    protoOf(JsonProofOfPossession).xl = toMap_0;
    protoOf(JsonProofOfPossession).a27 = toJson_0;
    protoOf(JsonProof).f2 = get_keys;
    protoOf(JsonProof).vl = get;
    protoOf(JsonProof).xl = toMap_0;
    protoOf(JsonProof).a27 = toJson_0;
    protoOf($serializer_13).mz = typeParametersSerializers;
    protoOf(JsonClaims).f2 = get_keys;
    protoOf(JsonClaims).vl = get;
    protoOf(JsonClaims).a27 = toJson_0;
    protoOf(JsonClaims).xl = toMap_0;
    protoOf(JsonClaimsItem).f2 = get_keys;
    protoOf(JsonClaimsItem).vl = get;
    protoOf(JsonClaimsItem).a27 = toJson_0;
    protoOf(JsonClaimsItem).xl = toMap_0;
    protoOf($serializer_14).mz = typeParametersSerializers;
    protoOf($serializer_15).mz = typeParametersSerializers;
    protoOf(VcSdJwtClaimsMetadata).f2 = get_keys;
    protoOf(VcSdJwtClaimsMetadata).vl = get;
    protoOf(VcSdJwtClaimsMetadata).a27 = toJson_0;
    protoOf(VcSdJwtClaimsMetadata).xl = toMap_0;
    protoOf(VcSdJwtClaimsEntryMetadata).f2 = get_keys;
    protoOf(VcSdJwtClaimsEntryMetadata).vl = get;
    protoOf(VcSdJwtClaimsEntryMetadata).a27 = toJson_0;
    protoOf(VcSdJwtClaimsEntryMetadata).xl = toMap_0;
    protoOf($serializer_16).mz = typeParametersSerializers;
    protoOf($serializer_17).mz = typeParametersSerializers;
    protoOf($serializer_18).mz = typeParametersSerializers;
    protoOf(JsonCredentialSubject).f2 = get_keys;
    protoOf(JsonCredentialSubject).vl = get;
    protoOf(JsonCredentialSubject).a27 = toJson_0;
    protoOf(JsonCredentialSubject).xl = toMap_0;
    protoOf(JsonCredentialSubjectItem).f2 = get_keys;
    protoOf(JsonCredentialSubjectItem).vl = get;
    protoOf(JsonCredentialSubjectItem).a27 = toJson_0;
    protoOf(JsonCredentialSubjectItem).xl = toMap_0;
    protoOf($serializer_19).mz = typeParametersSerializers;
    protoOf($serializer_20).mz = typeParametersSerializers;
    protoOf($serializer_21).mz = typeParametersSerializers;
    protoOf(JwtVcJsonCredentialSubjectMetadata).f2 = get_keys;
    protoOf(JwtVcJsonCredentialSubjectMetadata).vl = get;
    protoOf(JwtVcJsonCredentialSubjectMetadata).a27 = toJson_0;
    protoOf(JwtVcJsonCredentialSubjectMetadata).xl = toMap_0;
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).f2 = get_keys;
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).vl = get;
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).a27 = toJson_0;
    protoOf(JwtVcJsonCredentialSubjectEntryMetadata).xl = toMap_0;
    protoOf(CredentialDefinition).f2 = get_keys;
    protoOf(CredentialDefinition).vl = get;
    protoOf(CredentialDefinition).a27 = toJson_0;
    protoOf(CredentialDefinition).xl = toMap_0;
    protoOf($serializer_22).mz = typeParametersSerializers;
    protoOf($serializer_23).mz = typeParametersSerializers;
    protoOf($serializer_24).mz = typeParametersSerializers;
    protoOf(BasicCredentialSubject).f2 = get_keys;
    protoOf(BasicCredentialSubject).vl = get;
    protoOf(BasicCredentialSubject).a27 = toJson_0;
    protoOf($serializer_25).mz = typeParametersSerializers;
    protoOf($serializer_26).mz = typeParametersSerializers;
    protoOf($serializer_27).mz = typeParametersSerializers;
    protoOf(SerializableW3CVerifiableCredential).f2 = get_keys;
    protoOf(SerializableW3CVerifiableCredential).vl = get;
    protoOf(SerializableW3CVerifiableCredential).a27 = toJson_0;
    protoOf(SerializableW3CVerifiableCredential).xl = toMap_0;
    protoOf(JsonCredentialStatus).f2 = get_keys;
    protoOf(JsonCredentialStatus).vl = get;
    protoOf(JsonCredentialStatus).a27 = toJson_0;
    protoOf(JsonCredentialStatus).xl = toMap_0;
    protoOf(IssuerURI_0).q3c = toJsonIssuer;
    protoOf(IssuerObject_0).q3c = toJsonIssuer;
    protoOf($serializer_28).mz = typeParametersSerializers;
    protoOf($serializer_29).mz = typeParametersSerializers;
    protoOf($serializer_30).mz = typeParametersSerializers;
    protoOf($serializer_31).mz = typeParametersSerializers;
    protoOf($serializer_32).mz = typeParametersSerializers;
    protoOf($serializer_33).mz = typeParametersSerializers;
    protoOf($serializer_34).mz = typeParametersSerializers;
    protoOf($serializer_35).mz = typeParametersSerializers;
    protoOf($serializer_36).mz = typeParametersSerializers;
    protoOf($serializer_37).mz = typeParametersSerializers;
    protoOf(JsonFormat).f2 = get_keys;
    protoOf(JsonFormat).vl = get;
    protoOf(JsonFormat).xl = toMap_0;
    protoOf(JsonFormat).a27 = toJson_0;
    protoOf($serializer_38).mz = typeParametersSerializers;
    protoOf($serializer_39).mz = typeParametersSerializers;
    protoOf($serializer_40).mz = typeParametersSerializers;
    protoOf($serializer_41).mz = typeParametersSerializers;
    protoOf(JsonDictionaryVerifiablePresentation).a27 = toJson_0;
    protoOf(JsonDictionaryVerifiablePresentation).f2 = get_keys;
    protoOf(JsonDictionaryVerifiablePresentation).vl = get;
    protoOf(JsonDictionaryVerifiablePresentation).xl = toMap_0;
    protoOf($serializer_42).mz = typeParametersSerializers;
    protoOf(SerializableW3CVerifiablePresentation).f2 = get_keys;
    protoOf(SerializableW3CVerifiablePresentation).vl = get;
    protoOf(SerializableW3CVerifiablePresentation).a27 = toJson_0;
    protoOf(SerializableW3CVerifiablePresentation).xl = toMap_0;
    defineProp(protoOf(JsServerMetadata), "credentialsSupported", protoOf(JsServerMetadata).i3h);
    defineProp(protoOf(JsServerMetadata), "display", protoOf(JsServerMetadata).k3h);
    defineProp(protoOf(JsDisplayableAdapter), "locale", function() {
        return this.y3g();
    });
    defineProp(protoOf(JsDisplayableAdapter), "name", function() {
        return this.r2();
    });
    defineProp(protoOf(JsDisplayableAdapter), "customClaims", function() {
        return this.z3g();
    });
    defineProp(protoOf(JsIssuerDisplayAdapter), "locale", function() {
        return this.y3g();
    });
    defineProp(protoOf(JsIssuerDisplayAdapter), "name", function() {
        return this.r2();
    });
    defineProp(protoOf(JsIssuerDisplayAdapter), "logo", function() {
        return this.a3h();
    });
    defineProp(protoOf(JsIssuerDisplayAdapter), "customClaims", function() {
        return this.z3g();
    });
    defineProp(protoOf(JsLogo), "asJson", protoOf(JsLogo).a3i);
    defineProp(protoOf(JsCredentialDisplay), "locale", function() {
        return this.y3g();
    });
    defineProp(protoOf(JsCredentialDisplay), "name", function() {
        return this.r2();
    });
    defineProp(protoOf(JsCredentialDisplay), "customClaims", function() {
        return this.z3g();
    });
    defineProp(protoOf(JsCredentialDisplay), "logo", protoOf(JsCredentialDisplay).a3h);
    defineProp(protoOf(JsCredentialIssuerSupportedCredential), "display", protoOf(JsCredentialIssuerSupportedCredential).k3h);
    protoOf(JsSdObject).getNestedDisclosures = getNestedDisclosures;
    protoOf(JsSdArray).getNestedDisclosures = getNestedDisclosures;
    protoOf(JsSdPrimitive).getNestedDisclosures = getNestedDisclosures;
    defineProp(protoOf(JsUserVerifiableCredential), "credential", protoOf(JsUserVerifiableCredential).n38);
    defineProp(protoOf(JsLdpVcJsonLdCredential), "value", protoOf(JsLdpVcJsonLdCredential).b1);
    defineProp(protoOf(JSCredentialResponse), "jwtVcJsonLd", protoOf(JSCredentialResponse).z3i);
    defineProp(protoOf(JSCredentialResponse), "jwtVcJson", protoOf(JSCredentialResponse).a3j);
    defineProp(protoOf(JSCredentialResponse), "didJwtVcJson", protoOf(JSCredentialResponse).b3j);
    defineProp(protoOf(JSCredentialResponse), "ldp", protoOf(JSCredentialResponse).c3j);
    defineProp(protoOf(JSCredentialResponse), "vcSdJwt", protoOf(JSCredentialResponse).d3j);
    defineProp(protoOf(JsDidJwtVcJsonCredential), "claimDisplayables", protoOf(JsDidJwtVcJsonCredential).i3j);
    defineProp(protoOf(JsDidJwtVcJsonCredential), "credentialDisplay", protoOf(JsDidJwtVcJsonCredential).j3j);
    defineProp(protoOf(JsDidJwtVcJsonCredential), "subjectStringProperties", protoOf(JsDidJwtVcJsonCredential).k3j);
    defineProp(protoOf(JsVcSdJwtCredential), "claimDisplayables", protoOf(JsVcSdJwtCredential).i3j);
    defineProp(protoOf(JsVcSdJwtCredential), "credentialDisplay", protoOf(JsVcSdJwtCredential).j3j);
    defineProp(protoOf(JsVcSdJwtCredential), "customStringClaims", protoOf(JsVcSdJwtCredential).r3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "id", protoOf(JSW3CVerifiableCredential).k2a);
    defineProp(protoOf(JSW3CVerifiableCredential), "context", protoOf(JSW3CVerifiableCredential).b9);
    defineProp(protoOf(JSW3CVerifiableCredential), "types", protoOf(JSW3CVerifiableCredential).p3g);
    defineProp(protoOf(JSW3CVerifiableCredential), "credentialSubject", protoOf(JSW3CVerifiableCredential).v3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "issuer", protoOf(JSW3CVerifiableCredential).e3c);
    defineProp(protoOf(JSW3CVerifiableCredential), "issuanceDate", protoOf(JSW3CVerifiableCredential).w3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "proof", protoOf(JSW3CVerifiableCredential).x3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "expirationDate", protoOf(JSW3CVerifiableCredential).y3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "credentialStatus", protoOf(JSW3CVerifiableCredential).z3j);
    defineProp(protoOf(JSW3CVerifiableCredential), "customClaims", protoOf(JSW3CVerifiableCredential).z3g);
    //endregion
    //region block: init
    Companion_instance_3 = new Companion_1();
    Companion_instance_4 = new Companion_2();
    Companion_instance_5 = new Companion_3();
    Companion_instance_7 = new Companion_5();
    Companion_instance_8 = new Companion_6();
    Companion_instance_10 = new Companion_8();
    Companion_instance_13 = new Companion_11();
    Companion_instance_14 = new Companion_12();
    Companion_instance_15 = new Companion_13();
    Companion_instance_16 = new Companion_14();
    Companion_instance_17 = new Companion_15();
    Companion_instance_19 = new Companion_17();
    Companion_instance_21 = new Companion_19();
    Companion_instance_25 = new Companion_23();
    Companion_instance_26 = new Companion_24();
    Companion_instance_27 = new Companion_25();
    Companion_instance_28 = new Companion_26();
    Companion_instance_30 = new Companion_28();
    Companion_instance_31 = new Companion_29();
    Companion_instance_32 = new Companion_30();
    Companion_instance_33 = new Companion_31();
    Companion_instance_34 = new Companion_32();
    Companion_instance_35 = new Companion_33();
    Companion_instance_36 = new Companion_34();
    Companion_instance_40 = new Companion_38();
    Companion_instance_41 = new Companion_39();
    Companion_instance_42 = new Companion_40();
    Companion_instance_43 = new Companion_41();
    Companion_instance_44 = new Companion_42();
    Companion_instance_45 = new Companion_43();
    Companion_instance_47 = new Companion_45();
    Companion_instance_48 = new Companion_46();
    Companion_instance_49 = new Companion_47();
    Companion_instance_50 = new Companion_48();
    Companion_instance_51 = new Companion_49();
    Companion_instance_52 = new Companion_50();
    Companion_instance_53 = new Companion_51();
    Companion_instance_54 = new Companion_52();
    Companion_instance_55 = new Companion_53();
    Companion_instance_56 = new Companion_54();
    Companion_instance_58 = new Companion_56();
    Companion_instance_62 = new Companion_60();
    Companion_instance_63 = new Companion_61();
    Companion_instance_64 = new Companion_62();
    Companion_instance_65 = new Companion_63();
    Companion_instance_67 = new Companion_65();
    Companion_instance_70 = new Companion_68();
    Companion_instance_71 = new Companion_69();
    Companion_instance_72 = new Companion_70();
    Companion_instance_73 = new Companion_71();
    Companion_instance_74 = new Companion_72();
    //endregion
    //region block: exports
    function $jsExportAll$(_) {
        _.Either = Either;
        defineProp(_.Either, "Companion", Companion_getInstance_71);
        var $vc_js = _.vc_js || (_.vc_js = {});
        _.JSObject = JSObject;
        _.JSIssuerObject = JSIssuerObject;
        _.JSProofObject = JSProofObject;
        _.JSCredentialStatusObject = JSCredentialStatusObject;
        _.JsPair = JsPair;
        _.JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition = JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition;
        _.JSJwtVcJsonVerifiableCredentialRequest = JSJwtVcJsonVerifiableCredentialRequest;
        _.JSJwtVcJsonLdVerifiableCredentialRequest = JSJwtVcJsonLdVerifiableCredentialRequest;
        _.JSLdpVerifiableCredentialRequest = JSLdpVerifiableCredentialRequest;
        _.JSDeferredJsonCredentialResponse = JSDeferredJsonCredentialResponse;
        _.JSJwtVcJsonVerifiableCredentialResponse = JSJwtVcJsonVerifiableCredentialResponse;
        _.JSLdpVerifiableCredentialResponse = JSLdpVerifiableCredentialResponse;
        _.JSJwtVcJsonLdVerifiableCredentialResponse = JSJwtVcJsonLdVerifiableCredentialResponse;
        _.JsServerMetadata = JsServerMetadata;
        _.JsDisplayableAdapter = JsDisplayableAdapter;
        _.JsIssuerDisplayAdapter = JsIssuerDisplayAdapter;
        _.JsCredentialDisplayAdapter = JsCredentialDisplayAdapter;
        _.JsLogo = JsLogo;
        _.JsCredentialDisplay = JsCredentialDisplay;
        _.JsCredentialIssuerSupportedCredential = JsCredentialIssuerSupportedCredential;
        _.JsCredentialStatus = JsCredentialStatus;
        _.JsSdObject = JsSdObject;
        _.JsSdArray = JsSdArray;
        _.JsSdPrimitive = JsSdPrimitive;
        _.JsSdProperty = JsSdProperty;
        _.JsSdArrayValue = JsSdArrayValue;
        _.JsCredentialIssuer = JsCredentialIssuer;
        _.JsUserVerifiableCredential = JsUserVerifiableCredential;
        _.JsLdpVcJsonLdCredential = JsLdpVcJsonLdCredential;
        _.JSCredentialResponse = JSCredentialResponse;
        _.JsJwtVcJsonLdCredential = JsJwtVcJsonLdCredential;
        _.JsJwtVcJsonCredential = JsJwtVcJsonCredential;
        _.JsDidJwtVcJsonCredential = JsDidJwtVcJsonCredential;
        _.JsSelectivelyDiscloseableClaim = JsSelectivelyDiscloseableClaim;
        _.JsVcSdJwtCredential = JsVcSdJwtCredential;
        _.JSW3CVerifiableCredential = JSW3CVerifiableCredential;
        defineProp(_.JSW3CVerifiableCredential, "Companion", Companion_getInstance_72);
    }
    $jsExportAll$(_);
    _.$jsExportAll$ = $jsExportAll$;
    _.$_$ = _.$_$ || {};
    _.$_$.a = JsCredentialIssuer;
    _.$_$.b = JsPair;
    _.$_$.c = convertJwtVcJsonLdRequest;
    _.$_$.d = convertJwtVcJsonLdResponse;
    _.$_$.e = convertJwtVcJsonRequest;
    _.$_$.f = convertJwtVcJsonResponse;
    _.$_$.g = convertLdpVcJsonRequest;
    _.$_$.h = convertLdpVcJsonResponse;
    _.$_$.i = createJSObject;
    _.$_$.j = createJsCredentialIssuerSupportedCredential;
    _.$_$.k = createJsCredentialIssuer;
    _.$_$.l = createJsUserVerifiableCredential;
    _.$_$.m = getRootCause;
    _.$_$.n = inner;
    _.$_$.o = inner_0;
    _.$_$.p = inner_1;
    _.$_$.q = JwtVcJsonAuthorizationDetail_init_$Create$;
    _.$_$.r = VcSdJwtAuthorizationDetail_init_$Create$;
    _.$_$.s = $serializer_getInstance_8;
    _.$_$.t = $serializer_getInstance_6;
    _.$_$.u = $serializer_getInstance_3;
    _.$_$.v = JsonSupportedCredentialSerializer_getInstance;
    _.$_$.w = Companion_instance_54;
    _.$_$.x = Companion_getInstance_9;
    _.$_$.y = $serializer_getInstance_31;
    _.$_$.z = DefaultValidatedVcSdJwtCredentialResponse;
    _.$_$.a1 = DidValidatedJwtVcJsonCredentialResponse;
    _.$_$.b1 = JsonCredentialIssuerMetadata;
    _.$_$.c1 = JsonCredentialIssuer;
    _.$_$.d1 = IssuerObject_0;
    _.$_$.e1 = IssuerURI_0;
    _.$_$.f1 = JsonOAuthMetadata;
    _.$_$.g1 = JsonOffer;
    _.$_$.h1 = JsonProofOfPossession;
    _.$_$.i1 = JwtVcJsonAuthorizationDetail;
    _.$_$.j1 = JwtVcJsonCredentialConfigurationsSupported;
    _.$_$.k1 = Deferred;
    _.$_$.l1 = JwtVcJsonCredentialResponse;
    _.$_$.m1 = JwtVcJsonLdCredentialResponse;
    _.$_$.n1 = JwtVcJsonLdVerifiableCredentialRequest;
    _.$_$.o1 = CredentialDefinition;
    _.$_$.p1 = JwtVcJsonVerifiableCredentialRequest;
    _.$_$.q1 = JwtVcJsonVerifiableCredentialResponse;
    _.$_$.r1 = LdpVcCredentialResponse;
    _.$_$.s1 = LdpVerifiableCredentialRequest;
    _.$_$.t1 = UserVerifiableCredential;
    _.$_$.u1 = VcSdJwtAuthorizationDetail;
    _.$_$.v1 = VcSdJwtCredentialConfigurationsSupported;
    _.$_$.w1 = Deferred_2;
    _.$_$.x1 = VcSdJwtCredentialResponse;
    _.$_$.y1 = VcSdJwtVerifiableCredentialRequest;
    _.$_$.z1 = VcSdJwtVerifiableCredentialResponse;
    _.$_$.a2 = JsonArrayContainsFilter;
    _.$_$.b2 = JsonDescriptorMapObject;
    _.$_$.c2 = JsonPathNested;
    _.$_$.d2 = JsonPresentationDefinition;
    _.$_$.e2 = JsonPresentationSubmission;
    _.$_$.f2 = JsonStringFilter;
    _.$_$.g2 = JsonStringVerifiablePresentation;
    _.$_$.h2 = JsonVerifiablePresentation;
    _.$_$.i2 = JsonVerifierDirectPostAuthorizationResponse;
    _.$_$.j2 = SerializableW3CVerifiablePresentation;
    //endregion
    return _;
});

});
parcelRegister("ljyPz", function(module, exports) {







(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./curity-ssi-libs-jose.js",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./curity-ssi-libs-core.js",
        "./curity-ssi-libs-core-json.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("lm0Zq")), (parcelRequire("9vyMc")), (parcelRequire("2VOQS")), (parcelRequire("3kJd2")), (parcelRequire("iuiRe")), (parcelRequire("fcWHW")), (parcelRequire("ctZcf")));
})(globalThis, function(_, kotlin_io_curity_ssi_jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_core_json, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var secureRandom = kotlin_io_curity_ssi_jose.$_$.p;
    var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var encodeToByteArray = kotlin_kotlin.$_$.nc;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
    var listOf = kotlin_kotlin.$_$.o7;
    var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
    var getKClass = kotlin_kotlin.$_$.e;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var VOID = kotlin_kotlin.$_$.f;
    var decodeBase64Url = kotlin_io_curity_ssi_jose.$_$.n;
    var decodeToString = kotlin_kotlin.$_$.mc;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
    var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
    var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.t1;
    var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
    var Triple = kotlin_kotlin.$_$.ve;
    var Pair = kotlin_kotlin.$_$.qe;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var toString = kotlin_kotlin.$_$.vf;
    var toString_0 = kotlin_kotlin.$_$.ob;
    var hashCode = kotlin_kotlin.$_$.ha;
    var equals = kotlin_kotlin.$_$.ba;
    var StringBuilder = kotlin_kotlin.$_$.hc;
    var split = kotlin_kotlin.$_$.gd;
    var Companion_instance = kotlin_io_curity_ssi_core.$_$.c;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var get_lastIndex = kotlin_kotlin.$_$.j7;
    var until = kotlin_kotlin.$_$.yb;
    var slice = kotlin_kotlin.$_$.f8;
    var isBlank = kotlin_kotlin.$_$.uc;
    var createHashFunction = kotlin_io_curity_ssi_jose.$_$.m;
    var sha256 = kotlin_io_curity_ssi_jose.$_$.q;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var toMutableMap = kotlin_kotlin.$_$.p8;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var toList = kotlin_kotlin.$_$.k8;
    var to = kotlin_kotlin.$_$.wf;
    var toMap = kotlin_kotlin.$_$.n8;
    var checkIndexOverflow = kotlin_kotlin.$_$.z5;
    var mapOf = kotlin_kotlin.$_$.q7;
    var JsonJwsHeader = kotlin_io_curity_ssi_jose.$_$.s;
    var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
    var mapOf_0 = kotlin_kotlin.$_$.r7;
    var JsonJwtClaimsSet = kotlin_io_curity_ssi_jose.$_$.u;
    var JwsUtil_getInstance = kotlin_io_curity_ssi_jose.$_$.j;
    var Jws = kotlin_io_curity_ssi_jose.$_$.t;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var ValidationException_init_$Create$ = kotlin_io_curity_ssi_core.$_$.b;
    var contentEquals = kotlin_kotlin.$_$.lc;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var JsonNull_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.d;
    var singleOrNull = kotlin_kotlin.$_$.e8;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
    var JsonPrimitiveSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.e;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var contentEquals_0 = kotlin_kotlin.$_$.c6;
    var contentHashCode = kotlin_kotlin.$_$.d6;
    var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
    var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
    var setOf = kotlin_kotlin.$_$.b8;
    var Companion_getInstance = kotlin_io_curity_ssi_jose.$_$.g;
    var Companion_instance_0 = kotlin_io_curity_ssi_jose.$_$.e;
    var fromJwkDictionary = kotlin_io_curity_ssi_jose.$_$.c;
    var Exception = kotlin_kotlin.$_$.ke;
    var $serializer_getInstance = kotlin_io_curity_ssi_jose.$_$.h;
    var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
    var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
    var get_intOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.r;
    var get_booleanOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.o;
    var get_doubleOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.p;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var Collection = kotlin_kotlin.$_$.j5;
    var JsToJsonConverter_instance = kotlin_io_curity_ssi_core_json.$_$.c;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForCompanion(Companion_0);
    initMetadataForCoroutine($hashDisclosureCOROUTINE$0, CoroutineImpl);
    function toDisclosureHashString(hashFunction, $completion) {
        return Companion_instance_3.k2l(hashFunction, this.f2l(), $completion);
    }
    initMetadataForInterface(Disclosure, "Disclosure", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(Property, "Property", VOID, VOID, [
        Disclosure
    ], [
        1
    ]);
    initMetadataForClass(Value, "Value", VOID, VOID, [
        Disclosure
    ], [
        1
    ]);
    initMetadataForCompanion(Companion_1, VOID, VOID, [
        2
    ]);
    initMetadataForCoroutine($createCOROUTINE$1, CoroutineImpl);
    initMetadataForCompanion(Companion_2, VOID, VOID, [
        3
    ]);
    initMetadataForClass(DisclosuresByHash, "DisclosuresByHash");
    initMetadataForClass(Property_0, "Property");
    initMetadataForClass(ArrayIndex, "ArrayIndex");
    initMetadataForObject(AnyProperty, "AnyProperty");
    initMetadataForObject(AnyIndex, "AnyIndex");
    initMetadataForCompanion(Companion_3);
    initMetadataForClass(JsonPath, "JsonPath");
    initMetadataForCoroutine($computeKbJwtSdHashCOROUTINE$2, CoroutineImpl);
    initMetadataForCompanion(Companion_4, VOID, VOID, [
        3
    ]);
    initMetadataForClass(Decoded, "Decoded");
    initMetadataForClass(SdJwt, "SdJwt");
    initMetadataForClass(Result, "Result");
    initMetadataForCompanion(Companion_5);
    initMetadataForCoroutine($concealCOROUTINE$3, CoroutineImpl);
    initMetadataForCoroutine($concealElementCOROUTINE$5, CoroutineImpl);
    initMetadataForCoroutine($concealObjectCOROUTINE$6, CoroutineImpl);
    initMetadataForCoroutine($concealArrayCOROUTINE$7, CoroutineImpl);
    initMetadataForClass(SdJwtConcealer, "SdJwtConcealer", VOID, VOID, VOID, [
        1,
        2,
        3
    ]);
    initMetadataForCoroutine($buildCOROUTINE$8, CoroutineImpl);
    initMetadataForObject(SdJwtKeyBindingBuilder, "SdJwtKeyBindingBuilder", VOID, VOID, VOID, [
        8
    ]);
    initMetadataForLambda(SdJwtParser$Companion$decodeFromString$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForCoroutine($decodeFromStringCOROUTINE$13, CoroutineImpl);
    initMetadataForCompanion(Companion_6, VOID, VOID, [
        3,
        4
    ]);
    initMetadataForCoroutine($discloseCOROUTINE$10, CoroutineImpl);
    initMetadataForCoroutine($discloseCOROUTINE$11, CoroutineImpl);
    initMetadataForCoroutine($discloseCOROUTINE$12, CoroutineImpl);
    initMetadataForClass(SdJwtParser, "SdJwtParser", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_7);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForCompanion(Companion_8);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForCompanion(Companion_9);
    initMetadataForObject($serializer_1, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForInterface(SdValue, "SdValue", VOID, VOID, VOID, VOID, VOID, {
        0: Companion_getInstance_11
    });
    initMetadataForClass(Object_0, "Object", VOID, VOID, [
        SdValue
    ], VOID, VOID, {
        0: $serializer_getInstance_0
    });
    initMetadataForClass(Array_0, "Array", VOID, VOID, [
        SdValue
    ], VOID, VOID, {
        0: $serializer_getInstance_1
    });
    initMetadataForClass(Primitive, "Primitive", VOID, VOID, [
        SdValue
    ], VOID, VOID, {
        0: $serializer_getInstance_2
    });
    initMetadataForCompanion(Companion_10, VOID, [
        SerializerFactory
    ]);
    initMetadataForCompanion(Companion_11);
    initMetadataForObject($serializer_2, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(SdProperty, "SdProperty", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_3
    });
    initMetadataForCompanion(Companion_12);
    initMetadataForObject($serializer_3, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(SdArrayValue, "SdArrayValue", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_4
    });
    initMetadataForClass(Result_0, "Result");
    initMetadataForClass(ValidatedPayload, "ValidatedPayload");
    initMetadataForCoroutine($validateIssuerJwtCOROUTINE$15, CoroutineImpl);
    initMetadataForCoroutine($validateJwtSignatureCOROUTINE$16, CoroutineImpl);
    initMetadataForClass(VcSdJwtIssuerJwtValidator, "VcSdJwtIssuerJwtValidator", VOID, VOID, VOID, [
        3
    ]);
    initMetadataForCompanion(Companion_13);
    initMetadataForObject($serializer_4, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonVcSdJwtIssuerMetadata, "JsonVcSdJwtIssuerMetadata", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_5
    });
    initMetadataForClass(SdJwtParseResult, "SdJwtParseResult");
    initMetadataForInterface(SdValue_0, "SdValue");
    initMetadataForClass(SdObject, "SdObject", VOID, VOID, [
        SdValue_0
    ]);
    initMetadataForClass(SdArray, "SdArray", VOID, VOID, [
        SdValue_0
    ]);
    initMetadataForClass(SdPrimitive, "SdPrimitive", VOID, VOID, [
        SdValue_0
    ]);
    initMetadataForClass(SdArrayValue_0, "SdArrayValue");
    initMetadataForClass(SdProperty_0, "SdProperty");
    initMetadataForClass(ConcealResult, "ConcealResult");
    initMetadataForLambda(parseSdJwt$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(parseSdJwt$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(concealSdJwt$slambda, CoroutineImpl, VOID, [
        1
    ]);
    //endregion
    function Companion() {}
    protoOf(Companion).p2k = function(name, value) {
        return new Property(encodeBase64url(secureRandom(32)), name, value);
    };
    var Companion_instance_1;
    function Companion_getInstance_0() {
        return Companion_instance_1;
    }
    function Companion_0() {}
    protoOf(Companion_0).q2k = function(value) {
        return new Value(secureRandom(32), value);
    };
    var Companion_instance_2;
    function Companion_getInstance_1() {
        return Companion_instance_2;
    }
    function $hashDisclosureCOROUTINE$0(_this__u8e3s4, hashFunction, disclosure, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.z2k_1 = _this__u8e3s4;
        this.a2l_1 = hashFunction;
        this.b2l_1 = disclosure;
    }
    protoOf($hashDisclosureCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.a2l_1(encodeToByteArray(this.b2l_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return encodeBase64url(ARGUMENT);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Property(salt, name, value) {
        this.c2l_1 = salt;
        this.d2l_1 = name;
        this.e2l_1 = value;
    }
    protoOf(Property).f2l = function() {
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        var value = new JsonArray(listOf([
            JsonPrimitive(this.c2l_1),
            JsonPrimitive(this.d2l_1),
            this.e2l_1
        ]));
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonArray), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        return encodeBase64url(encodeToByteArray(tmp$ret$2));
    };
    function Value(salt, value) {
        this.h2l_1 = salt;
        this.i2l_1 = value;
    }
    protoOf(Value).f2l = function() {
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        var value = new JsonArray(listOf([
            JsonPrimitive(encodeBase64url(this.h2l_1)),
            this.i2l_1
        ]));
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonArray), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        return encodeBase64url(encodeToByteArray(tmp$ret$2));
    };
    function Companion_1() {}
    protoOf(Companion_1).j2l = function(disclosure, json) {
        var decodedDisclosure = decodeBase64Url(disclosure);
        var tmp;
        try {
            tmp = json.c19(decodeToString(decodedDisclosure));
        } catch ($p) {
            var tmp_0;
            if ($p instanceof SerializationException) {
                var ex = $p;
                throw IllegalArgumentException_init_$Create$("Disclosure has bad format", ex);
            } else throw $p;
        }
        var jsonElement = tmp;
        if (!(jsonElement instanceof JsonArray)) throw IllegalArgumentException_init_$Create$_0("Disclosure must be an array");
        var containsArg = jsonElement.m();
        if (!(2 <= containsArg ? containsArg <= 3 : false)) throw IllegalArgumentException_init_$Create$_0("Disclosure must contain two or three elements");
        var salt = jsonElement.o(0);
        var tmp_1;
        if (!(salt instanceof JsonPrimitive_0)) tmp_1 = true;
        else tmp_1 = !salt.d1b();
        if (tmp_1) throw IllegalArgumentException_init_$Create$_0("Disclosure has bad format: salt is not a string");
        var tmp_2;
        try {
            tmp_2 = decodeBase64Url(salt.e1b());
        } catch ($p) {
            var tmp_3;
            if ($p instanceof IllegalArgumentException) {
                var ex_0 = $p;
                throw IllegalArgumentException_init_$Create$_0("Disclosure has bad format: salt is not correctly encoded");
            } else throw $p;
        }
        var decodedSalt = tmp_2;
        if (decodedSalt.length < 8) throw IllegalArgumentException_init_$Create$_0("Disclosure has bad format: salt is too small");
        if (jsonElement.m() === 2) {
            var value = jsonElement.o(1);
            return new Value(decodedSalt, value);
        }
        if (jsonElement.m() === 3) {
            var name = jsonElement.o(1);
            var value_0 = jsonElement.o(2);
            var tmp_4;
            if (!(name instanceof JsonPrimitive_0)) tmp_4 = true;
            else tmp_4 = !name.d1b();
            if (tmp_4) throw IllegalArgumentException_init_$Create$_0("Disclosure has bad format: name must be a string");
            return new Property(salt.e1b(), name.e1b(), value_0);
        }
        throw IllegalArgumentException_init_$Create$_0("Disclosure must contain two or three elements");
    };
    protoOf(Companion_1).k2l = function(hashFunction, disclosure, $completion) {
        var tmp = new $hashDisclosureCOROUTINE$0(this, hashFunction, disclosure, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_3;
    function Companion_getInstance_2() {
        return Companion_instance_3;
    }
    function Disclosure() {}
    function $createCOROUTINE$1(_this__u8e3s4, disclosureStrings, hashFunction, json, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.t2l_1 = _this__u8e3s4;
        this.u2l_1 = disclosureStrings;
        this.v2l_1 = hashFunction;
        this.w2l_1 = json;
    }
    protoOf($createCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    tmp_0.x2l_1 = this.u2l_1;
                    this.y2l_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this.x2l_1, 10)), 16);
                    var tmp_1 = this;
                    tmp_1.z2l_1 = this.x2l_1;
                    var tmp_2 = this;
                    tmp_2.a2m_1 = LinkedHashMap_init_$Create$(this.y2l_1);
                    this.b2m_1 = this.z2l_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.b2m_1.k()) {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                    this.c2m_1 = this.b2m_1.l();
                    var tmp_3 = this;
                    tmp_3.d2m_1 = this.c2m_1;
                    this.v8_1 = 2;
                    suspendResult = Companion_instance_3.k2l(this.v2l_1, this.d2m_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var ARGUMENT = suspendResult;
                    this.a2m_1.m2(ARGUMENT, this.c2m_1);
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    var ARGUMENT_0 = this.a2m_1;
                    return new DisclosuresByHash(ARGUMENT_0, this.w2l_1);
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_2() {}
    protoOf(Companion_2).e2m = function(disclosureStrings, hashFunction, json, $completion) {
        var tmp = new $createCOROUTINE$1(this, disclosureStrings, hashFunction, json, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_4;
    function Companion_getInstance_3() {
        return Companion_instance_4;
    }
    function DisclosuresByHash(disclosureStringsByHash, json) {
        this.f2m_1 = disclosureStringsByHash;
        this.g2m_1 = json;
    }
    protoOf(DisclosuresByHash).h2m = function(hash) {
        var tmp0_safe_receiver = this.f2m_1.e2(hash);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.sdjwt.DisclosuresByHash.getProperty.<anonymous>' call
            var disclosure = Companion_instance_3.j2l(tmp0_safe_receiver, this.g2m_1);
            if (!(disclosure instanceof Property)) throw IllegalArgumentException_init_$Create$_0("Property is using a disclosure of the wrong type");
            tmp = new Triple(disclosure.d2l_1, disclosure.e2l_1, tmp0_safe_receiver);
        }
        return tmp;
    };
    protoOf(DisclosuresByHash).i2m = function(hash) {
        var tmp1_safe_receiver = this.f2m_1.e2(hash);
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.sdjwt.DisclosuresByHash.getArrayValue.<anonymous>' call
            var disclosure = Companion_instance_3.j2l(tmp1_safe_receiver, this.g2m_1);
            if (!(disclosure instanceof Value)) throw IllegalArgumentException_init_$Create$_0("Array value is using a disclosure of the wrong type");
            tmp = new Pair(disclosure.i2l_1, tmp1_safe_receiver);
        }
        return tmp;
    };
    function Property_0(name) {
        this.j2m_1 = name;
    }
    protoOf(Property_0).k2m = function(other) {
        var tmp;
        if (this.equals(other)) tmp = true;
        else tmp = other instanceof AnyProperty;
        return tmp;
    };
    protoOf(Property_0).toString = function() {
        return this.j2m_1;
    };
    protoOf(Property_0).hashCode = function() {
        return getStringHashCode(this.j2m_1);
    };
    protoOf(Property_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Property_0)) return false;
        var tmp0_other_with_cast = other instanceof Property_0 ? other : THROW_CCE();
        if (!(this.j2m_1 === tmp0_other_with_cast.j2m_1)) return false;
        return true;
    };
    function ArrayIndex(index) {
        this.l2m_1 = index;
    }
    protoOf(ArrayIndex).k2m = function(other) {
        var tmp;
        if (this.equals(other)) tmp = true;
        else tmp = other instanceof AnyIndex;
        return tmp;
    };
    protoOf(ArrayIndex).toString = function() {
        return "[" + this.l2m_1 + "]";
    };
    protoOf(ArrayIndex).hashCode = function() {
        return this.l2m_1;
    };
    protoOf(ArrayIndex).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof ArrayIndex)) return false;
        var tmp0_other_with_cast = other instanceof ArrayIndex ? other : THROW_CCE();
        if (!(this.l2m_1 === tmp0_other_with_cast.l2m_1)) return false;
        return true;
    };
    function AnyProperty() {}
    protoOf(AnyProperty).k2m = function(other) {
        var tmp;
        if (this.equals(other)) tmp = true;
        else tmp = other instanceof Property_0;
        return tmp;
    };
    protoOf(AnyProperty).toString = function() {
        return "*";
    };
    protoOf(AnyProperty).hashCode = function() {
        return -362470;
    };
    protoOf(AnyProperty).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof AnyProperty)) return false;
        other instanceof AnyProperty || THROW_CCE();
        return true;
    };
    var AnyProperty_instance;
    function AnyProperty_getInstance() {
        return AnyProperty_instance;
    }
    function AnyIndex() {}
    protoOf(AnyIndex).k2m = function(other) {
        var tmp;
        if (this.equals(other)) tmp = true;
        else tmp = other instanceof ArrayIndex;
        return tmp;
    };
    protoOf(AnyIndex).toString = function() {
        return "[*]";
    };
    protoOf(AnyIndex).hashCode = function() {
        return 1972714669;
    };
    protoOf(AnyIndex).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof AnyIndex)) return false;
        other instanceof AnyIndex || THROW_CCE();
        return true;
    };
    var AnyIndex_instance;
    function AnyIndex_getInstance() {
        return AnyIndex_instance;
    }
    function buildFromSegments($this, segments) {
        var iterator = segments.j();
        if (!iterator.k()) throw IllegalArgumentException_init_$Create$_0("segment list cannot be empty");
        var current = new JsonPath(iterator.l());
        while(iterator.k())current = new JsonPath(iterator.l(), current);
        return current;
    }
    function build($this, segment) {
        var tmp;
        if (typeof segment === "number") tmp = new ArrayIndex(segment);
        else {
            if (typeof segment === "string") switch(segment){
                case "[*]":
                    tmp = AnyIndex_instance;
                    break;
                case "*":
                    tmp = AnyProperty_instance;
                    break;
                default:
                    tmp = new Property_0(segment);
                    break;
            }
            else throw IllegalArgumentException_init_$Create$_0("segment must be Int or String, however it was " + getKClassFromExpression(segment).fa());
        }
        return tmp;
    }
    function Companion_3() {
        this.m2m_1 = "[*]";
        this.n2m_1 = "*";
    }
    protoOf(Companion_3).o2m = function(segments) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(segments.length);
        var inductionVariable = 0;
        var last = segments.length;
        while(inductionVariable < last){
            var item = segments[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'io.curity.ssi.sdjwt.Companion.build.<anonymous>' call
            var tmp$ret$0 = build(Companion_instance_5, item);
            destination.e(tmp$ret$0);
        }
        return buildFromSegments(this, destination);
    };
    var Companion_instance_5;
    function Companion_getInstance_4() {
        return Companion_instance_5;
    }
    function JsonPath(current, previous) {
        previous = previous === VOID ? null : previous;
        this.p2m_1 = current;
        this.q2m_1 = previous;
        var tmp = this;
        var tmp3_safe_receiver = this.q2m_1;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.r2m_1;
        var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver + 1 | 0;
        tmp.r2m_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    }
    protoOf(JsonPath).toString = function() {
        return this.q2m_1 == null ? "/" + toString_0(this.p2m_1) : toString(this.q2m_1) + "/" + toString_0(this.p2m_1);
    };
    protoOf(JsonPath).s2m = function(segment) {
        return new JsonPath(segment, this);
    };
    protoOf(JsonPath).t2m = function(name) {
        return this.s2m(new Property_0(name));
    };
    protoOf(JsonPath).u2m = function(index) {
        return this.s2m(new ArrayIndex(index));
    };
    protoOf(JsonPath).v2m = function(other) {
        if (!(this.r2m_1 === other.r2m_1)) return false;
        var path1 = this;
        var path2 = other;
        while(!(path1 == null) && !(path2 == null)){
            if (!path1.p2m_1.k2m(path2.p2m_1)) return false;
            path1 = path1.q2m_1;
            path2 = path2.q2m_1;
        }
        return true;
    };
    protoOf(JsonPath).hashCode = function() {
        var result = hashCode(this.p2m_1);
        result = imul(result, 31) + (this.q2m_1 == null ? 0 : this.q2m_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonPath).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonPath)) return false;
        var tmp0_other_with_cast = other instanceof JsonPath ? other : THROW_CCE();
        if (!equals(this.p2m_1, tmp0_other_with_cast.p2m_1)) return false;
        if (!equals(this.q2m_1, tmp0_other_with_cast.q2m_1)) return false;
        return true;
    };
    function withProperty(_this__u8e3s4, name) {
        var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.t2m(name);
        return tmp0_elvis_lhs == null ? new JsonPath(new Property_0(name)) : tmp0_elvis_lhs;
    }
    function $computeKbJwtSdHashCOROUTINE$2(_this__u8e3s4, jwt, jwtString, disclosures, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.e2n_1 = _this__u8e3s4;
        this.f2n_1 = jwt;
        this.g2n_1 = jwtString;
        this.h2n_1 = disclosures;
    }
    protoOf($computeKbJwtSdHashCOROUTINE$2).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.i2n_1 = this.e2n_1.k2n(this.f2n_1);
                    this.j2n_1 = this.e2n_1.l2n(this.g2n_1, this.h2n_1);
                    this.v8_1 = 1;
                    suspendResult = this.i2n_1(encodeToByteArray(this.j2n_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return encodeBase64url(ARGUMENT);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function Companion_4() {}
    protoOf(Companion_4).m2n = function(jwtString, disclosureStrings, keyBindingJwtString) {
        var builder = new StringBuilder(jwtString).e8("~");
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = disclosureStrings.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.sdjwt.Companion.encode.<anonymous>' call
            builder.e8(element).e8("~");
        }
        if (!(keyBindingJwtString == null)) builder.e8(keyBindingJwtString);
        return builder.toString();
    };
    protoOf(Companion_4).l2n = function(jwtString, disclosureStrings, keyBindingJwtString, $super) {
        keyBindingJwtString = keyBindingJwtString === VOID ? null : keyBindingJwtString;
        return $super === VOID ? this.m2n(jwtString, disclosureStrings, keyBindingJwtString) : $super.m2n.call(this, jwtString, disclosureStrings, keyBindingJwtString);
    };
    protoOf(Companion_4).n2n = function(encodedToken) {
        var parts = split(encodedToken, [
            "~"
        ]);
        if (parts.m() < 2) return Companion_instance.zm("Invalid SD-JWT: missing at least one '~'");
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = parts.o(0);
        if (charSequenceLength(this_0) === 0) return Companion_instance.zm("Invalid SD-JWT: needs to start with a JWT");
        var jwtString = parts.o(0);
        var disclosures = slice(parts, until(1, get_lastIndex(parts)));
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.sdjwt.Companion.decode.<anonymous>' call
        // Inline function 'kotlin.text.ifBlank' call
        var this_1 = parts.o(get_lastIndex(parts));
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (isBlank(this_1)) // Inline function 'io.curity.ssi.sdjwt.Companion.decode.<anonymous>.<anonymous>' call
        tmp = null;
        else tmp = this_1;
        var keyBindingJwtString = tmp;
        return Companion_instance.an(new Decoded(jwtString, disclosures, keyBindingJwtString));
    };
    protoOf(Companion_4).o2n = function(jwt, jwtString, disclosures, $completion) {
        var tmp = new $computeKbJwtSdHashCOROUTINE$2(this, jwt, jwtString, disclosures, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(Companion_4).k2n = function(jwt) {
        var tmp8_safe_receiver = jwt.k29_1.vl("_sd_alg");
        var tmp;
        if (tmp8_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.sdjwt.Companion.getHashFunctionToUse.<anonymous>' call
            var tmp_0;
            if (!(tmp8_safe_receiver instanceof JsonPrimitive_0)) tmp_0 = true;
            else tmp_0 = !tmp8_safe_receiver.d1b();
            if (tmp_0) throw IllegalArgumentException_init_$Create$_0("Invalid SD-JWT: _sd_alg is not a string");
            var hashAlg = tmp8_safe_receiver.e1b();
            var tmp0_elvis_lhs = createHashFunction(hashAlg);
            var tmp_1;
            if (tmp0_elvis_lhs == null) throw IllegalArgumentException_init_$Create$_0("Invalid SD-JWT: Unsupported hash algorithm " + hashAlg + " ");
            else tmp_1 = tmp0_elvis_lhs;
            tmp = tmp_1;
        }
        var tmp0_elvis_lhs_0 = tmp;
        return tmp0_elvis_lhs_0 == null ? sha256() : tmp0_elvis_lhs_0;
    };
    var Companion_instance_6;
    function Companion_getInstance_5() {
        return Companion_instance_6;
    }
    function Decoded(jwt, disclosures, keyBindingJwt) {
        keyBindingJwt = keyBindingJwt === VOID ? null : keyBindingJwt;
        this.p2n_1 = jwt;
        this.q2n_1 = disclosures;
        this.r2n_1 = keyBindingJwt;
    }
    protoOf(Decoded).ba = function() {
        return this.p2n_1;
    };
    protoOf(Decoded).ca = function() {
        return this.q2n_1;
    };
    protoOf(Decoded).qj = function() {
        return this.r2n_1;
    };
    protoOf(Decoded).toString = function() {
        return "Decoded(jwt=" + this.p2n_1 + ", disclosures=" + toString_0(this.q2n_1) + ", keyBindingJwt=" + this.r2n_1 + ")";
    };
    protoOf(Decoded).hashCode = function() {
        var result = getStringHashCode(this.p2n_1);
        result = imul(result, 31) + hashCode(this.q2n_1) | 0;
        result = imul(result, 31) + (this.r2n_1 == null ? 0 : getStringHashCode(this.r2n_1)) | 0;
        return result;
    };
    protoOf(Decoded).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Decoded)) return false;
        var tmp0_other_with_cast = other instanceof Decoded ? other : THROW_CCE();
        if (!(this.p2n_1 === tmp0_other_with_cast.p2n_1)) return false;
        if (!equals(this.q2n_1, tmp0_other_with_cast.q2n_1)) return false;
        if (!(this.r2n_1 == tmp0_other_with_cast.r2n_1)) return false;
        return true;
    };
    function SdJwt(jwtString, jwt, disclosedCustomClaims, disclosureStrings, keyBindingJwtString, keyBindingJwt) {
        this.s2n_1 = jwtString;
        this.t2n_1 = jwt;
        this.u2n_1 = disclosedCustomClaims;
        this.v2n_1 = disclosureStrings;
        this.w2n_1 = keyBindingJwtString;
        this.x2n_1 = keyBindingJwt;
    }
    function Result(obj, disclosures) {
        this.y2n_1 = obj;
        this.z2n_1 = disclosures;
    }
    protoOf(Result).toString = function() {
        return "Result(obj=" + toString(this.y2n_1) + ", disclosures=" + toString_0(this.z2n_1) + ")";
    };
    protoOf(Result).hashCode = function() {
        var result = this.y2n_1 == null ? 0 : hashCode(this.y2n_1);
        result = imul(result, 31) + hashCode(this.z2n_1) | 0;
        return result;
    };
    protoOf(Result).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Result)) return false;
        var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
        if (!equals(this.y2n_1, tmp0_other_with_cast.y2n_1)) return false;
        if (!equals(this.z2n_1, tmp0_other_with_cast.z2n_1)) return false;
        return true;
    };
    function concealElement($this, element, disclosures, path, $completion) {
        var tmp = new $concealElementCOROUTINE$5($this, element, disclosures, path, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function concealObject($this, obj, disclosures, path, $completion) {
        var tmp = new $concealObjectCOROUTINE$6($this, obj, disclosures, path, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function concealArray($this, array, disclosures, path, $completion) {
        var tmp = new $concealArrayCOROUTINE$7($this, array, disclosures, path, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function Companion_5() {}
    var Companion_instance_7;
    function Companion_getInstance_6() {
        return Companion_instance_7;
    }
    function $concealCOROUTINE$3(_this__u8e3s4, obj, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.s2q_1 = _this__u8e3s4;
        this.t2q_1 = obj;
    }
    protoOf($concealCOROUTINE$3).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.u2q_1 = ArrayList_init_$Create$_0();
                    var tmp_1 = this;
                    var this_0 = toMutableMap(this.t2q_1);
                    var value = JsonPrimitive(this.s2q_1.w2q_1);
                    this_0.m2("_sd_alg", value);
                    tmp_1.v2q_1 = this_0;
                    this.v8_1 = 1;
                    suspendResult = concealObject(this.s2q_1, new JsonObject(this.v2q_1), this.u2q_1, null, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var concealedObject = suspendResult;
                    return new Result(concealedObject, toList(this.u2q_1));
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $concealElementCOROUTINE$5(_this__u8e3s4, element, disclosures, path, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.i2o_1 = _this__u8e3s4;
        this.j2o_1 = element;
        this.k2o_1 = disclosures;
        this.l2o_1 = path;
    }
    protoOf($concealElementCOROUTINE$5).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.m2o_1 = this.j2o_1;
                    var tmp_0 = this.m2o_1;
                    if (tmp_0 instanceof JsonObject) {
                        this.v8_1 = 2;
                        suspendResult = concealObject(this.i2o_1, this.j2o_1, this.k2o_1, this.l2o_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_1 = this.m2o_1;
                        if (tmp_1 instanceof JsonArray) {
                            this.v8_1 = 1;
                            suspendResult = concealArray(this.i2o_1, this.j2o_1, this.k2o_1, this.l2o_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            this.n2o_1 = this.j2o_1;
                            this.v8_1 = 3;
                            continue $sm;
                        }
                    }
                case 1:
                    this.n2o_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.n2o_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.n2o_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $concealObjectCOROUTINE$6(_this__u8e3s4, obj, disclosures, path, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.w2o_1 = _this__u8e3s4;
        this.x2o_1 = obj;
        this.y2o_1 = disclosures;
        this.z2o_1 = path;
    }
    protoOf($concealObjectCOROUTINE$6).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.a2p_1 = ArrayList_init_$Create$_0();
                    var tmp_1 = this;
                    tmp_1.b2p_1 = ArrayList_init_$Create$_0();
                    var tmp_2 = this;
                    tmp_2.c2p_1 = this.x2o_1.z();
                    this.d2p_1 = this.c2p_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.d2p_1.k()) {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                    this.e2p_1 = this.d2p_1.l();
                    var tmp_3 = this;
                    tmp_3.f2p_1 = this.e2p_1;
                    var tmp_4 = this;
                    tmp_4.g2p_1 = this.f2p_1.a1();
                    var tmp_5 = this;
                    tmp_5.h2p_1 = this.f2p_1.b1();
                    this.i2p_1 = withProperty(this.z2o_1, this.g2p_1);
                    this.v8_1 = 2;
                    suspendResult = concealElement(this.w2o_1, this.h2p_1, this.y2o_1, this.i2p_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.j2p_1 = suspendResult;
                    if (this.w2o_1.y2q_1(this.i2p_1, this.h2p_1)) {
                        this.l2p_1 = Companion_instance_1.p2k(this.g2p_1, this.j2p_1);
                        this.y2o_1.e(this.l2p_1);
                        this.v8_1 = 3;
                        suspendResult = this.l2p_1.g2l(this.w2o_1.x2q_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_6 = this;
                        tmp_6.k2p_1 = this.a2p_1.e(to(this.g2p_1, this.j2p_1));
                        this.v8_1 = 4;
                        continue $sm;
                    }
                case 3:
                    var ARGUMENT = suspendResult;
                    this.k2p_1 = this.b2p_1.e(ARGUMENT);
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.v8_1 = 1;
                    continue $sm;
                case 5:
                    if (!this.b2p_1.s()) {
                        var this_0 = this.b2p_1;
                        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
                        var tmp0_iterator = this_0.j();
                        while(tmp0_iterator.k()){
                            var item = tmp0_iterator.l();
                            destination.e(JsonPrimitive(item));
                        }
                        this.a2p_1.e(to("_sd", new JsonArray(destination)));
                    }
                    return new JsonObject(toMap(this.a2p_1));
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $concealArrayCOROUTINE$7(_this__u8e3s4, array, disclosures, path, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.u2p_1 = _this__u8e3s4;
        this.v2p_1 = array;
        this.w2p_1 = disclosures;
        this.x2p_1 = path;
    }
    protoOf($concealArrayCOROUTINE$7).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.y2p_1 = this.v2p_1;
                    var tmp_1 = this;
                    tmp_1.z2p_1 = this.y2p_1;
                    var tmp_2 = this;
                    tmp_2.a2q_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this.y2p_1, 10));
                    this.b2q_1 = 0;
                    this.c2q_1 = this.z2p_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.c2q_1.k()) {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                    this.d2q_1 = this.c2q_1.l();
                    var tmp_3 = this;
                    var tmp1 = this.b2q_1;
                    this.b2q_1 = tmp1 + 1 | 0;
                    tmp_3.e2q_1 = checkIndexOverflow(tmp1);
                    var tmp_4 = this;
                    tmp_4.f2q_1 = this.d2q_1;
                    this.g2q_1 = this.x2p_1.u2m(this.e2q_1);
                    this.v8_1 = 2;
                    suspendResult = concealElement(this.u2p_1, this.f2q_1, this.w2p_1, this.g2q_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.h2q_1 = suspendResult;
                    if (this.u2p_1.y2q_1(this.g2q_1, this.f2q_1)) {
                        this.j2q_1 = Companion_instance_2.q2k(this.h2q_1);
                        this.w2p_1.e(this.j2q_1);
                        this.v8_1 = 3;
                        suspendResult = this.j2q_1.g2l(this.u2p_1.x2q_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_5 = this;
                        tmp_5.i2q_1 = this.h2q_1;
                        this.v8_1 = 4;
                        continue $sm;
                    }
                case 3:
                    var ARGUMENT = suspendResult;
                    var ARGUMENT_0 = JsonPrimitive(ARGUMENT);
                    var ARGUMENT_1 = to("...", ARGUMENT_0);
                    var ARGUMENT_2 = mapOf(ARGUMENT_1);
                    this.i2q_1 = new JsonObject(ARGUMENT_2);
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    var ARGUMENT_3 = this.i2q_1;
                    this.a2q_1.e(ARGUMENT_3);
                    this.v8_1 = 1;
                    continue $sm;
                case 5:
                    var ARGUMENT_4 = this.a2q_1;
                    return new JsonArray(ARGUMENT_4);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function SdJwtConcealer(hashAlgorithmName, hashFunction, concealPredicate) {
        this.w2q_1 = hashAlgorithmName;
        this.x2q_1 = hashFunction;
        this.y2q_1 = concealPredicate;
    }
    protoOf(SdJwtConcealer).z2q = function(obj, $completion) {
        var tmp = new $concealCOROUTINE$3(this, obj, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function $buildCOROUTINE$8(_this__u8e3s4, iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.i2r_1 = _this__u8e3s4;
        this.j2r_1 = iat;
        this.k2r_1 = aud;
        this.l2r_1 = nonce;
        this.m2r_1 = issuerJwt;
        this.n2r_1 = issuerJwtString;
        this.o2r_1 = disclosureStrings;
        this.p2r_1 = signingKey;
        this.q2r_1 = signingAlg;
    }
    protoOf($buildCOROUTINE$8).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = Companion_instance_6.o2n(this.m2r_1, this.n2r_1, this.o2r_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.r2r_1 = suspendResult;
                    this.s2r_1 = new JsonJwsHeader(this.q2r_1, "kb+jwt");
                    var tmp_0 = this;
                    var tmp10_iat = this.j2r_1.f1m();
                    var tmp11_aud = DefaultJsonMultiValue_init_$Create$(this.k2r_1);
                    var tmp12_customClaims = mapOf_0([
                        to("nonce", JsonPrimitive(this.l2r_1)),
                        to("sd_hash", JsonPrimitive(this.r2r_1))
                    ]);
                    tmp_0.t2r_1 = new JsonJwtClaimsSet(VOID, VOID, tmp11_aud, VOID, VOID, tmp10_iat, VOID, VOID, tmp12_customClaims);
                    this.v8_1 = 2;
                    suspendResult = JwsUtil_getInstance().j2d(this.p2r_1, this.s2r_1, this.t2r_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return suspendResult;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function SdJwtKeyBindingBuilder() {}
    protoOf(SdJwtKeyBindingBuilder).u2r = function(iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, $completion) {
        var tmp = new $buildCOROUTINE$8(this, iat, aud, nonce, issuerJwt, issuerJwtString, disclosureStrings, signingKey, signingAlg, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var SdJwtKeyBindingBuilder_instance;
    function SdJwtKeyBindingBuilder_getInstance() {
        return SdJwtKeyBindingBuilder_instance;
    }
    function SdJwtParser$Companion$decodeFromString$slambda($jwtDecoder, resultContinuation) {
        this.d2s_1 = $jwtDecoder;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(SdJwtParser$Companion$decodeFromString$slambda).g2s = function(encodedKbJwt, _unused_var__etf5q3, $completion) {
        var tmp = this.h2s(encodedKbJwt, _unused_var__etf5q3, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(SdJwtParser$Companion$decodeFromString$slambda).hj = function(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? typeof p1 === "string" : false) ? p1 : THROW_CCE();
        return this.g2s(tmp, p2 instanceof Jws ? p2 : THROW_CCE(), $completion);
    };
    protoOf(SdJwtParser$Companion$decodeFromString$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.d2s_1(this.e2s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(SdJwtParser$Companion$decodeFromString$slambda).h2s = function(encodedKbJwt, _unused_var__etf5q3, completion) {
        var i = new SdJwtParser$Companion$decodeFromString$slambda(this.d2s_1, completion);
        i.e2s_1 = encodedKbJwt;
        i.f2s_1 = _unused_var__etf5q3;
        return i;
    };
    function SdJwtParser$Companion$decodeFromString$slambda_0($jwtDecoder, resultContinuation) {
        var i = new SdJwtParser$Companion$decodeFromString$slambda($jwtDecoder, resultContinuation);
        var l = function(encodedKbJwt, _unused_var__etf5q3, $completion) {
            return i.g2s(encodedKbJwt, _unused_var__etf5q3, $completion);
        };
        l.$arity = 2;
        return l;
    }
    function $decodeFromStringCOROUTINE$13(_this__u8e3s4, encodedSdJwt, json, jwtDecoder, kbJwtDecoder, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.q2s_1 = _this__u8e3s4;
        this.r2s_1 = encodedSdJwt;
        this.s2s_1 = json;
        this.t2s_1 = jwtDecoder;
        this.u2s_1 = kbJwtDecoder;
    }
    protoOf($decodeFromStringCOROUTINE$13).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 9;
                    this.v2s_1 = Companion_instance_6.n2n(this.r2s_1).xm();
                    this.w2s_1 = this.v2s_1.ba();
                    this.x2s_1 = this.v2s_1.ca();
                    this.y2s_1 = this.v2s_1.qj();
                    this.v8_1 = 1;
                    suspendResult = this.t2s_1(this.w2s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.z2s_1 = suspendResult;
                    if (!(this.y2s_1 == null)) {
                        this.v8_1 = 2;
                        suspendResult = this.u2s_1(this.y2s_1, this.z2s_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_0 = this;
                        tmp_0.a2t_1 = null;
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 2:
                    this.a2t_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.b2t_1 = this.a2t_1;
                    this.c2t_1 = Companion_instance_6.k2n(this.z2s_1);
                    if (!(this.b2t_1 == null)) {
                        var tmp23_safe_receiver = this.b2t_1.j29_1;
                        if (!((tmp23_safe_receiver == null ? null : tmp23_safe_receiver.o29_1) === "kb+jwt")) throw ValidationException_init_$Create$("KB-JWT must have a 'typ' header with value'kb+jwt'");
                        var tmp24_safe_receiver = this.b2t_1.j29_1;
                        if ((tmp24_safe_receiver == null ? null : tmp24_safe_receiver.n29_1) == null) throw ValidationException_init_$Create$("KB-JWT must have a 'alg' header");
                        var tmp25_safe_receiver = this.b2t_1.j29_1;
                        var tmp26_safe_receiver = tmp25_safe_receiver == null ? null : tmp25_safe_receiver.n29_1;
                        if ((tmp26_safe_receiver == null ? null : contentEquals(tmp26_safe_receiver, "none", true)) === true) throw ValidationException_init_$Create$("KB-JWT must not use the 'none' algorithm");
                        var tmp_1 = this;
                        var sdHash = this.b2t_1.k29_1.vl("sd_hash");
                        var tmp_2;
                        if (sdHash instanceof JsonPrimitive_0) tmp_2 = sdHash.e1b();
                        else throw ValidationException_init_$Create$("KB-JWT must have a 'sd_hash' string claim");
                        tmp_1.d2t_1 = tmp_2;
                        this.v8_1 = 4;
                        suspendResult = Companion_instance_6.o2n(this.z2s_1, this.w2s_1, this.x2s_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 6;
                        continue $sm;
                    }
                case 4:
                    this.e2t_1 = suspendResult;
                    this.f2t_1 = this.d2t_1 === this.e2t_1;
                    if (!this.f2t_1) throw ValidationException_init_$Create$("KB-JWT has invalid 'sd_hash' value");
                    else {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 5:
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    this.v8_1 = 7;
                    suspendResult = Companion_instance_4.e2m(this.x2s_1, this.c2t_1, this.s2s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 7:
                    this.g2t_1 = suspendResult;
                    this.h2t_1 = new SdJwtParser(this.g2t_1);
                    this.v8_1 = 8;
                    suspendResult = disclose_1(this.h2t_1, new JsonObject(this.z2s_1.k29_1.h2a_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 8:
                    var ARGUMENT = suspendResult;
                    return new SdJwt(this.w2s_1, this.z2s_1, ARGUMENT, this.x2s_1, this.y2s_1, this.b2t_1);
                case 9:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 9) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function disclose($this, input, $completion) {
        var tmp = new $discloseCOROUTINE$10($this, input, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function disclose_0($this, input, $completion) {
        var tmp = new $discloseCOROUTINE$11($this, input, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function disclose_1($this, input, $completion) {
        var tmp = new $discloseCOROUTINE$12($this, input, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function Companion_6() {}
    protoOf(Companion_6).z2v = function(encodedSdJwt, json, jwtDecoder, $completion) {
        return this.a2w(encodedSdJwt, json, jwtDecoder, SdJwtParser$Companion$decodeFromString$slambda_0(jwtDecoder, null), $completion);
    };
    protoOf(Companion_6).b2w = function(encodedSdJwt, json, jwtDecoder, $completion, $super) {
        json = json === VOID ? Default_getInstance() : json;
        return $super === VOID ? this.z2v(encodedSdJwt, json, jwtDecoder, $completion) : $super.z2v.call(this, encodedSdJwt, json, jwtDecoder, $completion);
    };
    protoOf(Companion_6).a2w = function(encodedSdJwt, json, jwtDecoder, kbJwtDecoder, $completion) {
        var tmp = new $decodeFromStringCOROUTINE$13(this, encodedSdJwt, json, jwtDecoder, kbJwtDecoder, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    var Companion_instance_8;
    function Companion_getInstance_7() {
        return Companion_instance_8;
    }
    function $discloseCOROUTINE$10(_this__u8e3s4, input, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.q2t_1 = _this__u8e3s4;
        this.r2t_1 = input;
    }
    protoOf($discloseCOROUTINE$10).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.s2t_1 = this.r2t_1;
                    var tmp_0 = this.s2t_1;
                    if (tmp_0 instanceof JsonArray) {
                        this.v8_1 = 2;
                        suspendResult = disclose_0(this.q2t_1, this.r2t_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_1 = this.s2t_1;
                        if (tmp_1 instanceof JsonObject) {
                            this.v8_1 = 1;
                            suspendResult = disclose_1(this.q2t_1, this.r2t_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_2 = this.s2t_1;
                            if (tmp_2 instanceof JsonPrimitive_0) {
                                this.t2t_1 = new Primitive(this.r2t_1);
                                this.v8_1 = 3;
                                continue $sm;
                            } else if (equals(this.s2t_1, JsonNull_getInstance())) {
                                this.t2t_1 = new Primitive(null);
                                this.v8_1 = 3;
                                continue $sm;
                            } else {
                                var tmp_3 = this;
                                noWhenBranchMatchedException();
                            }
                        }
                    }
                    break;
                case 1:
                    this.t2t_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.t2t_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.t2t_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $discloseCOROUTINE$11(_this__u8e3s4, input, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.c2u_1 = _this__u8e3s4;
        this.d2u_1 = input;
    }
    protoOf($discloseCOROUTINE$11).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 9;
                    var tmp_0 = this;
                    tmp_0.e2u_1 = ArrayList_init_$Create$_0();
                    var tmp_1 = this;
                    tmp_1.f2u_1 = this.d2u_1;
                    this.g2u_1 = this.f2u_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.g2u_1.k()) {
                        this.v8_1 = 8;
                        continue $sm;
                    }
                    this.h2u_1 = this.g2u_1.l();
                    var tmp_2 = this;
                    tmp_2.i2u_1 = this.h2u_1;
                    this.j2u_1 = this.i2u_1;
                    var tmp_3 = this.j2u_1;
                    if (tmp_3 instanceof JsonPrimitive_0) {
                        this.k2u_1 = new SdArrayValue(new Primitive(this.i2u_1));
                        this.v8_1 = 7;
                        continue $sm;
                    } else if (equals(this.j2u_1, JsonNull_getInstance())) {
                        this.k2u_1 = new SdArrayValue(new Primitive(null));
                        this.v8_1 = 7;
                        continue $sm;
                    } else {
                        var tmp_4 = this.j2u_1;
                        if (tmp_4 instanceof JsonArray) {
                            this.v8_1 = 6;
                            suspendResult = disclose_0(this.c2u_1, this.i2u_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_5 = this.j2u_1;
                            if (tmp_5 instanceof JsonObject) {
                                this.l2u_1 = singleOrNull(this.i2u_1.z());
                                var tmp_6 = this;
                                var tmp19_safe_receiver = this.l2u_1;
                                tmp_6.m2u_1 = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.b1();
                                var tmp_7;
                                var tmp_8;
                                var tmp21_safe_receiver = this.l2u_1;
                                if ((tmp21_safe_receiver == null ? null : tmp21_safe_receiver.a1()) === "...") {
                                    var tmp_9 = this.m2u_1;
                                    tmp_8 = tmp_9 instanceof JsonPrimitive_0;
                                } else tmp_8 = false;
                                if (tmp_8) tmp_7 = this.m2u_1.d1b();
                                else tmp_7 = false;
                                if (tmp_7) {
                                    this.o2u_1 = this.c2u_1.c2w_1.i2m(this.m2u_1.e1b());
                                    if (this.o2u_1 == null) {
                                        this.p2u_1 = null;
                                        this.v8_1 = 4;
                                        continue $sm;
                                    } else {
                                        var tmp_10 = this;
                                        tmp_10.q2u_1 = this.o2u_1;
                                        var tmp_11 = this;
                                        tmp_11.r2u_1 = this.q2u_1;
                                        this.s2u_1 = this.r2u_1.ba();
                                        this.t2u_1 = this.r2u_1.ca();
                                        this.v8_1 = 3;
                                        suspendResult = disclose(this.c2u_1, this.s2u_1, this);
                                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                                        continue $sm;
                                    }
                                } else {
                                    this.v8_1 = 2;
                                    suspendResult = disclose_1(this.c2u_1, this.i2u_1, this);
                                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                                    continue $sm;
                                }
                            } else {
                                var tmp_12 = this;
                                noWhenBranchMatchedException();
                            }
                        }
                    }
                    break;
                case 2:
                    var ARGUMENT = suspendResult;
                    this.n2u_1 = new SdArrayValue(ARGUMENT);
                    this.v8_1 = 5;
                    continue $sm;
                case 3:
                    var ARGUMENT_0 = suspendResult;
                    this.p2u_1 = new SdArrayValue(ARGUMENT_0, this.t2u_1);
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.n2u_1 = this.p2u_1;
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    this.k2u_1 = this.n2u_1;
                    this.v8_1 = 7;
                    continue $sm;
                case 6:
                    var ARGUMENT_1 = suspendResult;
                    this.k2u_1 = new SdArrayValue(ARGUMENT_1);
                    this.v8_1 = 7;
                    continue $sm;
                case 7:
                    var sdValue = this.k2u_1;
                    if (!(sdValue == null)) this.e2u_1.e(sdValue);
                    this.v8_1 = 1;
                    continue $sm;
                case 8:
                    var this_0 = this.e2u_1;
                    return new Array_0(copyToArray(this_0));
                case 9:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 9) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $discloseCOROUTINE$12(_this__u8e3s4, input, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.c2v_1 = _this__u8e3s4;
        this.d2v_1 = input;
    }
    protoOf($discloseCOROUTINE$12).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 10;
                    var tmp_0 = this;
                    tmp_0.e2v_1 = LinkedHashMap_init_$Create$_0();
                    this.f2v_1 = this.d2v_1.vl("_sd");
                    if (!(this.f2v_1 == null)) {
                        var tmp_1 = this.f2v_1;
                        if (!(tmp_1 instanceof JsonArray)) throw IllegalArgumentException_init_$Create$_0("Invalid '$_sd_alg' claim: must be an array");
                        var tmp_2 = this;
                        tmp_2.g2v_1 = this.f2v_1;
                        this.h2v_1 = this.g2v_1.j();
                        this.v8_1 = 1;
                        continue $sm;
                    } else {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 1:
                    if (!this.h2v_1.k()) {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                    this.i2v_1 = this.h2v_1.l();
                    var tmp_3 = this;
                    tmp_3.j2v_1 = this.i2v_1;
                    var tmp_4;
                    var tmp_5 = this.j2v_1;
                    if (!(tmp_5 instanceof JsonPrimitive_0)) tmp_4 = true;
                    else tmp_4 = !this.j2v_1.d1b();
                    if (tmp_4) throw IllegalArgumentException_init_$Create$_0("Invalid '_sd_alg' claim: all its elements must be strings");
                    this.k2v_1 = this.j2v_1.e1b();
                    this.l2v_1 = this.c2v_1.c2w_1.h2m(this.k2v_1);
                    if (this.l2v_1 == null) {
                        this.m2v_1 = null;
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        var tmp_6 = this;
                        tmp_6.n2v_1 = this.l2v_1;
                        var tmp_7 = this;
                        tmp_7.o2v_1 = this.n2v_1;
                        this.p2v_1 = this.o2v_1.ba();
                        this.q2v_1 = this.o2v_1.ca();
                        this.r2v_1 = this.o2v_1.qj();
                        this.v8_1 = 2;
                        suspendResult = disclose(this.c2v_1, this.q2v_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 2:
                    this.s2v_1 = suspendResult;
                    var tmp_8 = this;
                    var this_0 = this.e2v_1;
                    var key = this.p2v_1;
                    var value = new SdProperty(this.p2v_1, this.s2v_1, this.r2v_1);
                    this_0.m2(key, value);
                    tmp_8.m2v_1 = Unit_instance;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.v8_1 = 1;
                    continue $sm;
                case 4:
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    var tmp_9 = this;
                    tmp_9.t2v_1 = this.d2v_1.z();
                    this.u2v_1 = this.t2v_1.j();
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    if (!this.u2v_1.k()) {
                        this.v8_1 = 9;
                        continue $sm;
                    }
                    this.v2v_1 = this.u2v_1.l();
                    var tmp_10 = this;
                    tmp_10.w2v_1 = this.v2v_1;
                    var tmp_11 = this;
                    tmp_11.x2v_1 = this.w2v_1.a1();
                    var tmp_12 = this;
                    tmp_12.y2v_1 = this.w2v_1.b1();
                    if (!(this.x2v_1 === "_sd") && !(this.x2v_1 === "_sd_alg")) {
                        this.v8_1 = 7;
                        suspendResult = disclose(this.c2v_1, this.y2v_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 8;
                        continue $sm;
                    }
                case 7:
                    var sdValue = suspendResult;
                    var this_1 = this.e2v_1;
                    var key_0 = this.x2v_1;
                    var value_0 = new SdProperty(this.x2v_1, sdValue);
                    this_1.m2(key_0, value_0);
                    this.v8_1 = 8;
                    continue $sm;
                case 8:
                    this.v8_1 = 6;
                    continue $sm;
                case 9:
                    return new Object_0(this.e2v_1);
                case 10:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 10) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function SdJwtParser(disclosuresByHash) {
        this.c2w_1 = disclosuresByHash;
    }
    function Companion_7() {
        Companion_instance_9 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d2w_1 = [
            new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_3())
        ];
    }
    var Companion_instance_9;
    function Companion_getInstance_8() {
        if (Companion_instance_9 == null) new Companion_7();
        return Companion_instance_9;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.SdValue.Object", this, 1);
        tmp0_serialDesc.wy("members", false);
        this.e2w_1 = tmp0_serialDesc;
    }
    protoOf($serializer).f2w = function(encoder, value) {
        var tmp0_desc = this.e2w_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_8().d2w_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.g2w_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.f2w(encoder, value instanceof Object_0 ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.e2w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_8().d2w_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return Object_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer).yn = function() {
        return this.e2w_1;
    };
    protoOf($serializer).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_8().d2w_1[0]
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance_0() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function Object_init_$Init$(seen0, members, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_0().e2w_1);
        $this.g2w_1 = members;
        return $this;
    }
    function Object_init_$Create$(seen0, members, serializationConstructorMarker) {
        return Object_init_$Init$(seen0, members, serializationConstructorMarker, objectCreate(protoOf(Object_0)));
    }
    function Companion_8() {
        Companion_instance_10 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h2w_1 = [
            new ReferenceArraySerializer(getKClass(SdArrayValue), $serializer_getInstance_4())
        ];
    }
    var Companion_instance_10;
    function Companion_getInstance_9() {
        if (Companion_instance_10 == null) new Companion_8();
        return Companion_instance_10;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.SdValue.Array", this, 1);
        tmp0_serialDesc.wy("elements", false);
        this.i2w_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).j2w = function(encoder, value) {
        var tmp0_desc = this.i2w_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_9().h2w_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.k2w_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.j2w(encoder, value instanceof Array_0 ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.i2w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_9().h2w_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return Array_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.i2w_1;
    };
    protoOf($serializer_0).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_9().h2w_1[0]
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_1() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function Array_init_$Init$(seen0, elements, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_1().i2w_1);
        $this.k2w_1 = elements;
        return $this;
    }
    function Array_init_$Create$(seen0, elements, serializationConstructorMarker) {
        return Array_init_$Init$(seen0, elements, serializationConstructorMarker, objectCreate(protoOf(Array_0)));
    }
    function Companion_9() {}
    var Companion_instance_11;
    function Companion_getInstance_10() {
        return Companion_instance_11;
    }
    function $serializer_1() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.SdValue.Primitive", this, 1);
        tmp0_serialDesc.wy("value", false);
        this.l2w_1 = tmp0_serialDesc;
    }
    protoOf($serializer_1).m2w = function(encoder, value) {
        var tmp0_desc = this.l2w_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.dt(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), value.n2w_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_1).zn = function(encoder, value) {
        return this.m2w(encoder, value instanceof Primitive ? value : THROW_CCE());
    };
    protoOf($serializer_1).ao = function(decoder) {
        var tmp0_desc = this.l2w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, JsonPrimitiveSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return Primitive_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_1).yn = function() {
        return this.l2w_1;
    };
    protoOf($serializer_1).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            get_nullable(JsonPrimitiveSerializer_getInstance())
        ];
    };
    var $serializer_instance_1;
    function $serializer_getInstance_2() {
        if ($serializer_instance_1 == null) new $serializer_1();
        return $serializer_instance_1;
    }
    function Primitive_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_2().l2w_1);
        $this.n2w_1 = value;
        return $this;
    }
    function Primitive_init_$Create$(seen0, value, serializationConstructorMarker) {
        return Primitive_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(Primitive)));
    }
    function Object_0(members) {
        Companion_getInstance_8();
        this.g2w_1 = members;
    }
    protoOf(Object_0).toString = function() {
        return "Object(members=" + toString_0(this.g2w_1) + ")";
    };
    protoOf(Object_0).hashCode = function() {
        return hashCode(this.g2w_1);
    };
    protoOf(Object_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Object_0)) return false;
        var tmp0_other_with_cast = other instanceof Object_0 ? other : THROW_CCE();
        if (!equals(this.g2w_1, tmp0_other_with_cast.g2w_1)) return false;
        return true;
    };
    function Array_0(elements) {
        Companion_getInstance_9();
        this.k2w_1 = elements;
    }
    protoOf(Array_0).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof Array_0)) THROW_CCE();
        return contentEquals_0(this.k2w_1, other.k2w_1);
    };
    protoOf(Array_0).hashCode = function() {
        return contentHashCode(this.k2w_1);
    };
    protoOf(Array_0).toString = function() {
        return "Array(elements=" + toString_0(this.k2w_1) + ")";
    };
    function Primitive(value) {
        this.n2w_1 = value;
    }
    protoOf(Primitive).toString = function() {
        return "Primitive(value=" + toString(this.n2w_1) + ")";
    };
    protoOf(Primitive).hashCode = function() {
        return this.n2w_1 == null ? 0 : hashCode(this.n2w_1);
    };
    protoOf(Primitive).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Primitive)) return false;
        var tmp0_other_with_cast = other instanceof Primitive ? other : THROW_CCE();
        if (!equals(this.n2w_1, tmp0_other_with_cast.n2w_1)) return false;
        return true;
    };
    function Companion_10() {}
    protoOf(Companion_10).b1b = function() {
        var tmp = getKClass(SdValue);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [
            getKClass(Array_0),
            getKClass(Object_0),
            getKClass(Primitive)
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [
            $serializer_getInstance_1(),
            $serializer_getInstance_0(),
            $serializer_getInstance_2()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        return SealedClassSerializer_init_$Create$("io.curity.ssi.sdjwt.SdValue", tmp, tmp_0, tmp_1, tmp$ret$8);
    };
    protoOf(Companion_10).wz = function(typeParamsSerializers) {
        return this.b1b();
    };
    var Companion_instance_12;
    function Companion_getInstance_11() {
        return Companion_instance_12;
    }
    function SdValue() {}
    function Companion_11() {
        Companion_instance_13 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = getKClass(SdValue);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [
            getKClass(Array_0),
            getKClass(Object_0),
            getKClass(Primitive)
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = [
            $serializer_getInstance_1(),
            $serializer_getInstance_0(),
            $serializer_getInstance_2()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o2w_1 = [
            null,
            SealedClassSerializer_init_$Create$("io.curity.ssi.sdjwt.SdValue", tmp_0, tmp_1, tmp_2, tmp$ret$8),
            null
        ];
    }
    var Companion_instance_13;
    function Companion_getInstance_12() {
        if (Companion_instance_13 == null) new Companion_11();
        return Companion_instance_13;
    }
    function $serializer_2() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.SdProperty", this, 3);
        tmp0_serialDesc.wy("name", false);
        tmp0_serialDesc.wy("value", false);
        tmp0_serialDesc.wy("disclosureString", true);
        this.p2w_1 = tmp0_serialDesc;
    }
    protoOf($serializer_2).q2w = function(encoder, value) {
        var tmp0_desc = this.p2w_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_12().o2w_1;
        tmp1_output.zs(tmp0_desc, 0, value.r2w_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.s2w_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.t2w_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.t2w_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_2).zn = function(encoder, value) {
        return this.q2w(encoder, value instanceof SdProperty ? value : THROW_CCE());
    };
    protoOf($serializer_2).ao = function(decoder) {
        var tmp0_desc = this.p2w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        var tmp8_cached = Companion_getInstance_12().o2w_1;
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return SdProperty_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_2).yn = function() {
        return this.p2w_1;
    };
    protoOf($serializer_2).lz = function() {
        var tmp0_cached = Companion_getInstance_12().o2w_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            tmp0_cached[1],
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_2;
    function $serializer_getInstance_3() {
        if ($serializer_instance_2 == null) new $serializer_2();
        return $serializer_instance_2;
    }
    function SdProperty_init_$Init$(seen0, name, value, disclosureString, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_3().p2w_1);
        $this.r2w_1 = name;
        $this.s2w_1 = value;
        if (0 === (seen0 & 4)) $this.t2w_1 = null;
        else $this.t2w_1 = disclosureString;
        return $this;
    }
    function SdProperty_init_$Create$(seen0, name, value, disclosureString, serializationConstructorMarker) {
        return SdProperty_init_$Init$(seen0, name, value, disclosureString, serializationConstructorMarker, objectCreate(protoOf(SdProperty)));
    }
    function SdProperty(name, value, disclosureString) {
        Companion_getInstance_12();
        disclosureString = disclosureString === VOID ? null : disclosureString;
        this.r2w_1 = name;
        this.s2w_1 = value;
        this.t2w_1 = disclosureString;
    }
    protoOf(SdProperty).toString = function() {
        return "SdProperty(name=" + this.r2w_1 + ", value=" + toString_0(this.s2w_1) + ", disclosureString=" + this.t2w_1 + ")";
    };
    protoOf(SdProperty).hashCode = function() {
        var result = getStringHashCode(this.r2w_1);
        result = imul(result, 31) + hashCode(this.s2w_1) | 0;
        result = imul(result, 31) + (this.t2w_1 == null ? 0 : getStringHashCode(this.t2w_1)) | 0;
        return result;
    };
    protoOf(SdProperty).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SdProperty)) return false;
        var tmp0_other_with_cast = other instanceof SdProperty ? other : THROW_CCE();
        if (!(this.r2w_1 === tmp0_other_with_cast.r2w_1)) return false;
        if (!equals(this.s2w_1, tmp0_other_with_cast.s2w_1)) return false;
        if (!(this.t2w_1 == tmp0_other_with_cast.t2w_1)) return false;
        return true;
    };
    function Companion_12() {
        Companion_instance_14 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = getKClass(SdValue);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = [
            getKClass(Array_0),
            getKClass(Object_0),
            getKClass(Primitive)
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = [
            $serializer_getInstance_1(),
            $serializer_getInstance_0(),
            $serializer_getInstance_2()
        ];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.u2w_1 = [
            SealedClassSerializer_init_$Create$("io.curity.ssi.sdjwt.SdValue", tmp_0, tmp_1, tmp_2, tmp$ret$8),
            null
        ];
    }
    var Companion_instance_14;
    function Companion_getInstance_13() {
        if (Companion_instance_14 == null) new Companion_12();
        return Companion_instance_14;
    }
    function $serializer_3() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.SdArrayValue", this, 2);
        tmp0_serialDesc.wy("value", false);
        tmp0_serialDesc.wy("disclosureString", true);
        this.v2w_1 = tmp0_serialDesc;
    }
    protoOf($serializer_3).w2w = function(encoder, value) {
        var tmp0_desc = this.v2w_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_13().u2w_1;
        tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.x2w_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.y2w_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.y2w_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_3).zn = function(encoder, value) {
        return this.w2w(encoder, value instanceof SdArrayValue ? value : THROW_CCE());
    };
    protoOf($serializer_3).ao = function(decoder) {
        var tmp0_desc = this.v2w_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_13().u2w_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return SdArrayValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_3).yn = function() {
        return this.v2w_1;
    };
    protoOf($serializer_3).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_13().u2w_1[0],
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_3;
    function $serializer_getInstance_4() {
        if ($serializer_instance_3 == null) new $serializer_3();
        return $serializer_instance_3;
    }
    function SdArrayValue_init_$Init$(seen0, value, disclosureString, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_4().v2w_1);
        $this.x2w_1 = value;
        if (0 === (seen0 & 2)) $this.y2w_1 = null;
        else $this.y2w_1 = disclosureString;
        return $this;
    }
    function SdArrayValue_init_$Create$(seen0, value, disclosureString, serializationConstructorMarker) {
        return SdArrayValue_init_$Init$(seen0, value, disclosureString, serializationConstructorMarker, objectCreate(protoOf(SdArrayValue)));
    }
    function SdArrayValue(value, disclosureString) {
        Companion_getInstance_13();
        disclosureString = disclosureString === VOID ? null : disclosureString;
        this.x2w_1 = value;
        this.y2w_1 = disclosureString;
    }
    protoOf(SdArrayValue).toString = function() {
        return "SdArrayValue(value=" + toString_0(this.x2w_1) + ", disclosureString=" + this.y2w_1 + ")";
    };
    protoOf(SdArrayValue).hashCode = function() {
        var result = hashCode(this.x2w_1);
        result = imul(result, 31) + (this.y2w_1 == null ? 0 : getStringHashCode(this.y2w_1)) | 0;
        return result;
    };
    protoOf(SdArrayValue).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof SdArrayValue)) return false;
        var tmp0_other_with_cast = other instanceof SdArrayValue ? other : THROW_CCE();
        if (!equals(this.x2w_1, tmp0_other_with_cast.x2w_1)) return false;
        if (!(this.y2w_1 == tmp0_other_with_cast.y2w_1)) return false;
        return true;
    };
    function Result_0(iss, vct, cnf) {
        this.z2w_1 = iss;
        this.a2x_1 = vct;
        this.b2x_1 = cnf;
    }
    protoOf(Result_0).toString = function() {
        return "Result(iss=" + this.z2w_1 + ", vct=" + this.a2x_1 + ", cnf=" + this.b2x_1.toString() + ")";
    };
    protoOf(Result_0).hashCode = function() {
        var result = getStringHashCode(this.z2w_1);
        result = imul(result, 31) + getStringHashCode(this.a2x_1) | 0;
        result = imul(result, 31) + this.b2x_1.hashCode() | 0;
        return result;
    };
    protoOf(Result_0).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof Result_0)) return false;
        var tmp0_other_with_cast = other instanceof Result_0 ? other : THROW_CCE();
        if (!(this.z2w_1 === tmp0_other_with_cast.z2w_1)) return false;
        if (!(this.a2x_1 === tmp0_other_with_cast.a2x_1)) return false;
        if (!this.b2x_1.equals(tmp0_other_with_cast.b2x_1)) return false;
        return true;
    };
    function validateIssuerJwtHeaderAndGetKid(_this__u8e3s4, $this, header) {
        _this__u8e3s4.tn("'typ' claim is not present in the header", header.o29_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtHeaderAndGetKid$lambda(_this__u8e3s4));
        return header.s29_1;
    }
    function validateIssuerJwtPayload(_this__u8e3s4, $this, payload) {
        var nowEpoch = $this.c2x_1.u1l().f1m();
        var tmp = payload.h2a_1.e2("vct");
        var vct = _this__u8e3s4.un("vct", tmp, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda);
        var iss = _this__u8e3s4.un("iss", payload.z29_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_0);
        _this__u8e3s4.wn(payload.d2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_1(nowEpoch, _this__u8e3s4));
        _this__u8e3s4.wn(payload.e2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_2(nowEpoch, _this__u8e3s4));
        _this__u8e3s4.wn(payload.c2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_3(nowEpoch, _this__u8e3s4));
        var cnfJwk = _this__u8e3s4.un("cnf", payload.g2a_1, VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_4);
        var tmp_0;
        if (!(iss == null) && !(vct == null) && !(cnfJwk == null)) tmp_0 = new ValidatedPayload(iss, vct, cnfJwk);
        else tmp_0 = null;
        return tmp_0;
    }
    function validateJwtSignature(_this__u8e3s4, $this, issuerId, jwtString, kid, $completion) {
        var tmp = new $validateJwtSignatureCOROUTINE$16($this, _this__u8e3s4, issuerId, jwtString, kid, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function ValidatedPayload(iss, vct, cnf) {
        this.z2x_1 = iss;
        this.a2y_1 = vct;
        this.b2y_1 = cnf;
    }
    protoOf(ValidatedPayload).toString = function() {
        return "ValidatedPayload(iss=" + this.z2x_1 + ", vct=" + this.a2y_1 + ", cnf=" + this.b2y_1.toString() + ")";
    };
    protoOf(ValidatedPayload).hashCode = function() {
        var result = getStringHashCode(this.z2x_1);
        result = imul(result, 31) + getStringHashCode(this.a2y_1) | 0;
        result = imul(result, 31) + this.b2y_1.hashCode() | 0;
        return result;
    };
    protoOf(ValidatedPayload).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof ValidatedPayload)) return false;
        var tmp0_other_with_cast = other instanceof ValidatedPayload ? other : THROW_CCE();
        if (!(this.z2x_1 === tmp0_other_with_cast.z2x_1)) return false;
        if (!(this.a2y_1 === tmp0_other_with_cast.a2y_1)) return false;
        if (!this.b2y_1.equals(tmp0_other_with_cast.b2y_1)) return false;
        return true;
    };
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtHeaderAndGetKid$lambda($this_validateIssuerJwtHeaderAndGetKid) {
        return function(it) {
            var tmp;
            if (!(it === "vc+sd-jwt")) {
                $this_validateIssuerJwtHeaderAndGetKid.vn("JWS header 'kid' is not 'vc+sd-jwt'");
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda($this$mandatory, it) {
        var tmp;
        if (it instanceof JsonPrimitive_0) {
            var tmp_0;
            if (it.d1b()) tmp_0 = it.e1b();
            else tmp_0 = null;
            tmp = tmp_0;
        } else tmp = null;
        var stringValue = tmp;
        if (stringValue == null) $this$mandatory.vn("'vct' is present but is not a string");
        return stringValue;
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_0($this$mandatory, it) {
        return it;
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_1($nowEpoch, $this_validateIssuerJwtPayload) {
        return function(it) {
            var tmp;
            if ($nowEpoch.j1(it) < 0) {
                $this_validateIssuerJwtPayload.vn("'nbf' is in the future");
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_2($nowEpoch, $this_validateIssuerJwtPayload) {
        return function(it) {
            var tmp;
            if ($nowEpoch.j1(it) < 0) {
                $this_validateIssuerJwtPayload.vn("'iat' is in the future");
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_3($nowEpoch, $this_validateIssuerJwtPayload) {
        return function(it) {
            var tmp;
            if ($nowEpoch.j1(it) > 0) {
                $this_validateIssuerJwtPayload.vn("'exp' is in the past");
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function VcSdJwtIssuerJwtValidator$validateIssuerJwtPayload$lambda_4($this$mandatory, it) {
        if (!equals(it.f2(), setOf("jwk"))) $this$mandatory.vn("'cnf' has unexpected members");
        var jwk = it.vl("jwk");
        if (jwk == null) {
            $this$mandatory.vn("'cnf.jwk' is missing in the 'cnf' claim");
            return null;
        }
        var jwkObject = jwk instanceof JsonObject ? jwk : null;
        if (jwkObject == null) {
            $this$mandatory.vn("'cnf.jwk' is not a JSON object");
            return null;
        }
        return Companion_getInstance().d27(jwkObject);
    }
    function $validateIssuerJwtCOROUTINE$15(_this__u8e3s4, validationScope, jwt, jwtString, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.k2y_1 = _this__u8e3s4;
        this.l2y_1 = validationScope;
        this.m2y_1 = jwt;
        this.n2y_1 = jwtString;
    }
    protoOf($validateIssuerJwtCOROUTINE$15).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.o2y_1 = this.l2y_1;
                    var tmp_1 = this;
                    tmp_1.p2y_1 = this.o2y_1;
                    var tmp_2 = this;
                    var header = this.m2y_1.j29_1;
                    var tmp_3;
                    if (header == null) {
                        this.p2y_1.vn("JWS Header is missing");
                        tmp_3 = null;
                    } else {
                        validateIssuerJwtHeaderAndGetKid(this.p2y_1, this.k2y_1, header);
                        tmp_3 = header.s29_1;
                    }
                    tmp_2.q2y_1 = tmp_3;
                    this.r2y_1 = validateIssuerJwtPayload(this.p2y_1, this.k2y_1, this.m2y_1.k29_1);
                    if (this.p2y_1.rn_1 || this.q2y_1 == null || this.r2y_1 == null) return null;
                    this.v8_1 = 1;
                    suspendResult = validateJwtSignature(this.p2y_1, this.k2y_1, this.r2y_1.z2x_1, this.n2y_1, this.q2y_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return new Result_0(this.r2y_1.z2x_1, this.r2y_1.a2y_1, this.r2y_1.b2y_1);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $validateJwtSignatureCOROUTINE$16(_this__u8e3s4, _this__u8e3s4_0, issuerId, jwtString, kid, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m2x_1 = _this__u8e3s4;
        this.n2x_1 = _this__u8e3s4_0;
        this.o2x_1 = issuerId;
        this.p2x_1 = jwtString;
        this.q2x_1 = kid;
    }
    protoOf($validateJwtSignatureCOROUTINE$16).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 9;
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    suspendResult = this.m2x_1.d2x_1.s2y(this.o2x_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.s2x_1 = suspendResult;
                    if (!(this.s2x_1.t2y_1 === this.o2x_1)) {
                        var tmp_0 = this;
                        this.n2x_1.vn("Issuer metadata ID mismatch, metadata has " + ("'" + this.s2x_1.t2y_1 + "', credential has '" + this.o2x_1 + "'"));
                        tmp_0.t2x_1 = null;
                        this.v8_1 = 4;
                        continue $sm;
                    } else {
                        this.u2x_1 = this.s2x_1.u2y_1.g29(this.q2x_1);
                        if (this.u2x_1 == null) {
                            var tmp_1 = this;
                            this.n2x_1.vn("Issuer metadata does not contain credential verification key");
                            tmp_1.v2x_1 = null;
                            this.v8_1 = 3;
                            continue $sm;
                        } else {
                            this.v8_1 = 2;
                            suspendResult = fromJwkDictionary(Companion_instance_0, this.u2x_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        }
                    }
                case 2:
                    this.v2x_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.t2x_1 = this.v2x_1;
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.r2x_1 = this.t2x_1;
                    this.w8_1 = 9;
                    this.v8_1 = 6;
                    continue $sm;
                case 5:
                    this.w8_1 = 9;
                    var tmp_2 = this.y8_1;
                    if (tmp_2 instanceof Exception) {
                        this.w2x_1 = this.y8_1;
                        var tmp_3 = this;
                        this.n2x_1.vn("Unexpected exception: " + this.w2x_1.message);
                        tmp_3.r2x_1 = null;
                        this.v8_1 = 6;
                        continue $sm;
                    } else throw this.y8_1;
                case 6:
                    this.w8_1 = 9;
                    this.x2x_1 = this.r2x_1;
                    if (this.x2x_1 == null) return false;
                    this.w8_1 = 8;
                    this.v8_1 = 7;
                    suspendResult = JwsUtil_getInstance().w2d(this.x2x_1, this.p2x_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 7:
                    this.y2x_1 = true;
                    this.w8_1 = 9;
                    this.v8_1 = 10;
                    continue $sm;
                case 8:
                    this.w8_1 = 9;
                    var tmp_4 = this.y8_1;
                    if (tmp_4 instanceof Exception) {
                        var ex = this.y8_1;
                        var tmp_5 = this;
                        this.n2x_1.vn("JWT is not valid: " + ex.message);
                        tmp_5.y2x_1 = false;
                        this.v8_1 = 10;
                        continue $sm;
                    } else throw this.y8_1;
                case 9:
                    throw this.y8_1;
                case 10:
                    this.w8_1 = 9;
                    return this.y2x_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 9) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function VcSdJwtIssuerJwtValidator(clock, issuerMetadataLoader) {
        this.c2x_1 = clock;
        this.d2x_1 = issuerMetadataLoader;
    }
    protoOf(VcSdJwtIssuerJwtValidator).v2y = function(validationScope, jwt, jwtString, $completion) {
        var tmp = new $validateIssuerJwtCOROUTINE$15(this, validationScope, jwt, jwtString, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function Companion_13() {}
    var Companion_instance_15;
    function Companion_getInstance_14() {
        return Companion_instance_15;
    }
    function $serializer_4() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.sdjwt.vc.JsonVcSdJwtIssuerMetadata", this, 2);
        tmp0_serialDesc.wy("issuer", false);
        tmp0_serialDesc.wy("jwks", false);
        this.w2y_1 = tmp0_serialDesc;
    }
    protoOf($serializer_4).x2y = function(encoder, value) {
        var tmp0_desc = this.w2y_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.t2y_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance(), value.u2y_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_4).zn = function(encoder, value) {
        return this.x2y(encoder, value instanceof JsonVcSdJwtIssuerMetadata ? value : THROW_CCE());
    };
    protoOf($serializer_4).ao = function(decoder) {
        var tmp0_desc = this.w2y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return JsonVcSdJwtIssuerMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_4).yn = function() {
        return this.w2y_1;
    };
    protoOf($serializer_4).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            $serializer_getInstance()
        ];
    };
    var $serializer_instance_4;
    function $serializer_getInstance_5() {
        if ($serializer_instance_4 == null) new $serializer_4();
        return $serializer_instance_4;
    }
    function JsonVcSdJwtIssuerMetadata_init_$Init$(seen0, issuer, jwks, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_5().w2y_1);
        $this.t2y_1 = issuer;
        $this.u2y_1 = jwks;
        return $this;
    }
    function JsonVcSdJwtIssuerMetadata_init_$Create$(seen0, issuer, jwks, serializationConstructorMarker) {
        return JsonVcSdJwtIssuerMetadata_init_$Init$(seen0, issuer, jwks, serializationConstructorMarker, objectCreate(protoOf(JsonVcSdJwtIssuerMetadata)));
    }
    function JsonVcSdJwtIssuerMetadata(issuer, jwks) {
        this.t2y_1 = issuer;
        this.u2y_1 = jwks;
    }
    protoOf(JsonVcSdJwtIssuerMetadata).toString = function() {
        return "JsonVcSdJwtIssuerMetadata(issuer=" + this.t2y_1 + ", jwks=" + toString_0(this.u2y_1) + ")";
    };
    protoOf(JsonVcSdJwtIssuerMetadata).hashCode = function() {
        var result = getStringHashCode(this.t2y_1);
        result = imul(result, 31) + hashCode(this.u2y_1) | 0;
        return result;
    };
    protoOf(JsonVcSdJwtIssuerMetadata).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonVcSdJwtIssuerMetadata)) return false;
        var tmp0_other_with_cast = other instanceof JsonVcSdJwtIssuerMetadata ? other : THROW_CCE();
        if (!(this.t2y_1 === tmp0_other_with_cast.t2y_1)) return false;
        if (!equals(this.u2y_1, tmp0_other_with_cast.u2y_1)) return false;
        return true;
    };
    function parseSdJwt(sdJwtString) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, parseSdJwt$slambda_0(sdJwtString, null));
    }
    function SdJwtParseResult(jwtString, kbJwtString, disclosures, disclosedClaims) {
        this.jwtString = jwtString;
        this.kbJwtString = kbJwtString;
        this.disclosures = disclosures;
        this.disclosedClaims = disclosedClaims;
    }
    protoOf(SdJwtParseResult).y2y = function() {
        return this.jwtString;
    };
    protoOf(SdJwtParseResult).z2y = function() {
        return this.kbJwtString;
    };
    protoOf(SdJwtParseResult).a2z = function() {
        return this.disclosures;
    };
    protoOf(SdJwtParseResult).b2z = function() {
        return this.disclosedClaims;
    };
    function SdValue_0() {}
    function SdObject(propertyMap) {
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = propertyMap.g2();
        tmp.properties = copyToArray(this_0);
    }
    protoOf(SdObject).c2z = function() {
        return this.properties;
    };
    function SdArray(values) {
        this.values = values;
    }
    protoOf(SdArray).g2 = function() {
        return this.values;
    };
    function SdPrimitive(value) {
        this.value = value;
    }
    protoOf(SdPrimitive).b1 = function() {
        return this.value;
    };
    function SdArrayValue_0(value, disclosure) {
        this.value = value;
        this.disclosure = disclosure;
    }
    protoOf(SdArrayValue_0).b1 = function() {
        return this.value;
    };
    protoOf(SdArrayValue_0).d2z = function() {
        return this.disclosure;
    };
    function SdProperty_0(name, value, disclosure) {
        this.name = name;
        this.value = value;
        this.disclosure = disclosure;
    }
    protoOf(SdProperty_0).r2 = function() {
        return this.name;
    };
    protoOf(SdProperty_0).b1 = function() {
        return this.value;
    };
    protoOf(SdProperty_0).d2z = function() {
        return this.disclosure;
    };
    function concealSdJwt(input, pathsToConceal) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, concealSdJwt$slambda_0(input, pathsToConceal, null));
    }
    function ConcealResult(output, disclosures) {
        this.output = output;
        this.disclosures = disclosures;
    }
    protoOf(ConcealResult).e2z = function() {
        return this.output;
    };
    protoOf(ConcealResult).a2z = function() {
        return this.disclosures;
    };
    function mapObject(input) {
        // Inline function 'kotlin.collections.mapValues' call
        var this_0 = input.g2w_1;
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.m()));
        // Inline function 'kotlin.collections.associateByTo' call
        var tmp0_iterator = this_0.z().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
            var tmp = element.a1();
            // Inline function 'mapObject.<anonymous>' call
            var tmp$ret$1 = new SdProperty_0(element.b1().r2w_1, map(element.b1().s2w_1), element.b1().t2w_1);
            destination.m2(tmp, tmp$ret$1);
        }
        return new SdObject(destination);
    }
    function map(input) {
        var tmp;
        if (input instanceof Array_0) tmp = mapArray(input);
        else {
            if (input instanceof Object_0) tmp = mapObject(input);
            else if (input instanceof Primitive) tmp = mapPrimitive(input);
            else noWhenBranchMatchedException();
        }
        return tmp;
    }
    function mapArray(input) {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = input.k2w_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(this_0.length);
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'mapArray.<anonymous>' call
            var tmp$ret$0 = new SdArrayValue_0(map(item.x2w_1), item.y2w_1);
            destination.e(tmp$ret$0);
        }
        var tmp$ret$3 = copyToArray(destination);
        return new SdArray(tmp$ret$3);
    }
    function mapPrimitive(input) {
        var tmp0_elvis_lhs = input.n2w_1;
        var tmp;
        if (tmp0_elvis_lhs == null) return new SdPrimitive(null);
        else tmp = tmp0_elvis_lhs;
        var value = tmp;
        var tmp_0;
        if (value.d1b()) tmp_0 = value.e1b();
        else {
            var tmp1_elvis_lhs = get_intOrNull(value);
            var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_booleanOrNull(value) : tmp1_elvis_lhs;
            tmp_0 = tmp2_elvis_lhs == null ? get_doubleOrNull(value) : tmp2_elvis_lhs;
        }
        return new SdPrimitive(tmp_0);
    }
    function parseSdJwt$slambda$slambda(resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(parseSdJwt$slambda$slambda).o2z = function(it, $completion) {
        var tmp = this.p2z(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(parseSdJwt$slambda$slambda).y9 = function(p1, $completion) {
        return this.o2z((!(p1 == null) ? typeof p1 === "string" : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(parseSdJwt$slambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return JwsUtil_getInstance().r2a(this.n2z_1);
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(parseSdJwt$slambda$slambda).p2z = function(it, completion) {
        var i = new parseSdJwt$slambda$slambda(completion);
        i.n2z_1 = it;
        return i;
    };
    function parseSdJwt$slambda$slambda_0(resultContinuation) {
        var i = new parseSdJwt$slambda$slambda(resultContinuation);
        var l = function(it, $completion) {
            return i.o2z(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function parseSdJwt$slambda($sdJwtString, resultContinuation) {
        this.y2z_1 = $sdJwtString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(parseSdJwt$slambda).a30 = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(parseSdJwt$slambda).y9 = function(p1, $completion) {
        return this.a30((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(parseSdJwt$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    var tmp_0 = Companion_instance_8;
                    suspendResult = tmp_0.b2w(this.y2z_1, VOID, parseSdJwt$slambda$slambda_0(null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var sdJwt = suspendResult;
                    var this_0 = sdJwt.v2n_1;
                    return new SdJwtParseResult(sdJwt.s2n_1, sdJwt.w2n_1, copyToArray(this_0), mapObject(sdJwt.u2n_1));
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(parseSdJwt$slambda).e2b = function($this$promise, completion) {
        var i = new parseSdJwt$slambda(this.y2z_1, completion);
        i.z2z_1 = $this$promise;
        return i;
    };
    function parseSdJwt$slambda_0($sdJwtString, resultContinuation) {
        var i = new parseSdJwt$slambda($sdJwtString, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.a30($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function concealSdJwt$slambda$lambda($paths) {
        return function(path, _unused_var__etf5q3) {
            var tmp$ret$0;
            $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var this_0 = $paths;
                var tmp;
                if (isInterface(this_0, Collection)) tmp = this_0.s();
                else tmp = false;
                if (tmp) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
                var tmp0_iterator = this_0.j();
                while(tmp0_iterator.k()){
                    var element = tmp0_iterator.l();
                    // Inline function 'concealSdJwt.<anonymous>.<anonymous>.<anonymous>' call
                    if (path.v2m(element)) {
                        tmp$ret$0 = true;
                        break $l$block_0;
                    }
                }
                tmp$ret$0 = false;
            }
            return tmp$ret$0;
        };
    }
    function concealSdJwt$slambda($input, $pathsToConceal, resultContinuation) {
        this.j30_1 = $input;
        this.k30_1 = $pathsToConceal;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(concealSdJwt$slambda).p30 = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(concealSdJwt$slambda).y9 = function(p1, $completion) {
        return this.p30((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(concealSdJwt$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.m30_1 = JsToJsonConverter_instance.l28(this.j30_1);
                    var tmp_0 = this;
                    var this_0 = this.k30_1;
                    var destination = ArrayList_init_$Create$(this_0.length);
                    var inductionVariable = 0;
                    var last = this_0.length;
                    while(inductionVariable < last){
                        var item = this_0[inductionVariable];
                        inductionVariable = inductionVariable + 1 | 0;
                        destination.e(Companion_instance_5.o2m(item.slice()));
                    }
                    tmp_0.n30_1 = destination;
                    var tmp_1 = this;
                    var tmp0_elvis_lhs = createHashFunction("sha-256");
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) throw IllegalStateException_init_$Create$("Unable to create SHA-256 function");
                    else tmp_2 = tmp0_elvis_lhs;
                    var tmp_3 = tmp_2;
                    tmp_1.o30_1 = new SdJwtConcealer("sha-256", tmp_3, concealSdJwt$slambda$lambda(this.n30_1));
                    this.v8_1 = 1;
                    suspendResult = this.o30_1.z2q(this.m30_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var result = suspendResult;
                    var this_1 = JsonToJsConverter_instance.m28(result.y2n_1);
                    var this_2 = result.z2n_1;
                    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
                    var tmp0_iterator = this_2.j();
                    while(tmp0_iterator.k()){
                        var item_0 = tmp0_iterator.l();
                        destination_0.e(item_0.f2l());
                    }
                    return new ConcealResult(this_1, copyToArray(destination_0));
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(concealSdJwt$slambda).e2b = function($this$promise, completion) {
        var i = new concealSdJwt$slambda(this.j30_1, this.k30_1, completion);
        i.l30_1 = $this$promise;
        return i;
    };
    function concealSdJwt$slambda_0($input, $pathsToConceal, resultContinuation) {
        var i = new concealSdJwt$slambda($input, $pathsToConceal, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.p30($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    //region block: post-declaration
    protoOf(Property).g2l = toDisclosureHashString;
    protoOf(Value).g2l = toDisclosureHashString;
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    protoOf($serializer_1).mz = typeParametersSerializers;
    protoOf($serializer_2).mz = typeParametersSerializers;
    protoOf($serializer_3).mz = typeParametersSerializers;
    protoOf($serializer_4).mz = typeParametersSerializers;
    //endregion
    //region block: init
    Companion_instance_1 = new Companion();
    Companion_instance_2 = new Companion_0();
    Companion_instance_3 = new Companion_1();
    Companion_instance_4 = new Companion_2();
    AnyProperty_instance = new AnyProperty();
    AnyIndex_instance = new AnyIndex();
    Companion_instance_5 = new Companion_3();
    Companion_instance_6 = new Companion_4();
    Companion_instance_7 = new Companion_5();
    SdJwtKeyBindingBuilder_instance = new SdJwtKeyBindingBuilder();
    Companion_instance_8 = new Companion_6();
    Companion_instance_11 = new Companion_9();
    Companion_instance_12 = new Companion_10();
    Companion_instance_15 = new Companion_13();
    //endregion
    //region block: exports
    function $jsExportAll$(_) {
        _.parseSdJwt = parseSdJwt;
        _.SdJwtParseResult = SdJwtParseResult;
        _.SdObject = SdObject;
        _.SdArray = SdArray;
        _.SdPrimitive = SdPrimitive;
        _.SdArrayValue = SdArrayValue_0;
        _.SdProperty = SdProperty_0;
        _.concealSdJwt = concealSdJwt;
        _.ConcealResult = ConcealResult;
    }
    $jsExportAll$(_);
    _.$jsExportAll$ = $jsExportAll$;
    _.$_$ = _.$_$ || {};
    _.$_$.a = Companion_instance_6;
    _.$_$.b = SdJwtKeyBindingBuilder_instance;
    _.$_$.c = Companion_instance_8;
    _.$_$.d = $serializer_getInstance_0;
    _.$_$.e = JsonVcSdJwtIssuerMetadata;
    _.$_$.f = VcSdJwtIssuerJwtValidator;
    _.$_$.g = Array_0;
    _.$_$.h = Object_0;
    _.$_$.i = Primitive;
    //endregion
    return _;
});

});

parcelRegister("dfhqu", function(module, exports) {


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./curity-ssi-libs-core.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("iuiRe")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_curity_ssi_core) {
    "use strict";
    //region block: imports
    var protoOf = kotlin_kotlin.$_$.kb;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var toString = kotlin_kotlin.$_$.ob;
    var hashCode = kotlin_kotlin.$_$.ha;
    var equals = kotlin_kotlin.$_$.ba;
    var ToString = kotlin_io_curity_ssi_core.$_$.m;
    var VOID = kotlin_kotlin.$_$.f;
    var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var enumEntries = kotlin_kotlin.$_$.p9;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var Enum = kotlin_kotlin.$_$.ie;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(StringCredential, "StringCredential");
    initMetadataForClass(DictionaryCredential, "DictionaryCredential");
    initMetadataForClass(IssuerURI, "IssuerURI", VOID, VOID, [
        ToString
    ]);
    initMetadataForInterface(IssuerObject, "IssuerObject", VOID, VOID, [
        ToString,
        Dictionary
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForClass(ClientIdScheme, "ClientIdScheme", VOID, Enum, [
        ToString,
        Enum
    ]);
    //endregion
    function StringCredential(value) {
        this.o2h_1 = value;
    }
    protoOf(StringCredential).toString = function() {
        return "StringCredential(value=" + this.o2h_1 + ")";
    };
    protoOf(StringCredential).hashCode = function() {
        return getStringHashCode(this.o2h_1);
    };
    protoOf(StringCredential).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof StringCredential)) return false;
        var tmp0_other_with_cast = other instanceof StringCredential ? other : THROW_CCE();
        if (!(this.o2h_1 === tmp0_other_with_cast.o2h_1)) return false;
        return true;
    };
    function DictionaryCredential(value) {
        this.p2h_1 = value;
    }
    protoOf(DictionaryCredential).toString = function() {
        return "DictionaryCredential(value=" + toString(this.p2h_1) + ")";
    };
    protoOf(DictionaryCredential).hashCode = function() {
        return hashCode(this.p2h_1);
    };
    protoOf(DictionaryCredential).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DictionaryCredential)) return false;
        var tmp0_other_with_cast = other instanceof DictionaryCredential ? other : THROW_CCE();
        if (!equals(this.p2h_1, tmp0_other_with_cast.p2h_1)) return false;
        return true;
    };
    function IssuerURI(value) {
        this.q2h_1 = value;
    }
    protoOf(IssuerURI).toString = function() {
        return this.q2h_1;
    };
    protoOf(IssuerURI).hashCode = function() {
        return getStringHashCode(this.q2h_1);
    };
    protoOf(IssuerURI).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof IssuerURI)) return false;
        var tmp0_other_with_cast = other instanceof IssuerURI ? other : THROW_CCE();
        if (!(this.q2h_1 === tmp0_other_with_cast.q2h_1)) return false;
        return true;
    };
    function IssuerObject() {}
    var ClientIdScheme_PRE_REGISTERED_instance;
    var ClientIdScheme_DID_instance;
    var ClientIdScheme_X509_SAN_DNS_instance;
    var ClientIdScheme_X509_SAN_URI_instance;
    var ClientIdScheme_VERIFIER_ATTESTATION_instance;
    var ClientIdScheme_REDIRECT_URI_instance;
    var ClientIdScheme_ENTITY_ID_instance;
    function Companion() {}
    protoOf(Companion).r2h = function(clientIdScheme) {
        var _iterator__ex2g4s = get_entries().j();
        while(_iterator__ex2g4s.k()){
            var cis = _iterator__ex2g4s.l();
            if (cis.u2h_1 === clientIdScheme) return cis;
        }
        throw IllegalArgumentException_init_$Create$("Unknown client id scheme: " + clientIdScheme);
    };
    var Companion_instance;
    function Companion_getInstance() {
        return Companion_instance;
    }
    function values() {
        return [
            ClientIdScheme_PRE_REGISTERED_getInstance(),
            ClientIdScheme_DID_getInstance(),
            ClientIdScheme_X509_SAN_DNS_getInstance(),
            ClientIdScheme_X509_SAN_URI_getInstance(),
            ClientIdScheme_VERIFIER_ATTESTATION_getInstance(),
            ClientIdScheme_REDIRECT_URI_getInstance(),
            ClientIdScheme_ENTITY_ID_getInstance()
        ];
    }
    function get_entries() {
        if ($ENTRIES == null) $ENTRIES = enumEntries(values());
        return $ENTRIES;
    }
    var ClientIdScheme_entriesInitialized;
    function ClientIdScheme_initEntries() {
        if (ClientIdScheme_entriesInitialized) return Unit_instance;
        ClientIdScheme_entriesInitialized = true;
        ClientIdScheme_PRE_REGISTERED_instance = new ClientIdScheme("PRE_REGISTERED", 0, "pre-registered");
        ClientIdScheme_DID_instance = new ClientIdScheme("DID", 1, "did");
        ClientIdScheme_X509_SAN_DNS_instance = new ClientIdScheme("X509_SAN_DNS", 2, "x509_san_dns");
        ClientIdScheme_X509_SAN_URI_instance = new ClientIdScheme("X509_SAN_URI", 3, "x509_san_uri");
        ClientIdScheme_VERIFIER_ATTESTATION_instance = new ClientIdScheme("VERIFIER_ATTESTATION", 4, "verifier_attestation");
        ClientIdScheme_REDIRECT_URI_instance = new ClientIdScheme("REDIRECT_URI", 5, "redirect_uri");
        ClientIdScheme_ENTITY_ID_instance = new ClientIdScheme("ENTITY_ID", 6, "entity_id");
    }
    var $ENTRIES;
    function ClientIdScheme(name, ordinal, clientIdScheme) {
        Enum.call(this, name, ordinal);
        this.u2h_1 = clientIdScheme;
    }
    protoOf(ClientIdScheme).toString = function() {
        return this.u2h_1;
    };
    function ClientIdScheme_PRE_REGISTERED_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_PRE_REGISTERED_instance;
    }
    function ClientIdScheme_DID_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_DID_instance;
    }
    function ClientIdScheme_X509_SAN_DNS_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_X509_SAN_DNS_instance;
    }
    function ClientIdScheme_X509_SAN_URI_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_X509_SAN_URI_instance;
    }
    function ClientIdScheme_VERIFIER_ATTESTATION_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_VERIFIER_ATTESTATION_instance;
    }
    function ClientIdScheme_REDIRECT_URI_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_REDIRECT_URI_instance;
    }
    function ClientIdScheme_ENTITY_ID_getInstance() {
        ClientIdScheme_initEntries();
        return ClientIdScheme_ENTITY_ID_instance;
    }
    //region block: init
    Companion_instance = new Companion();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Companion_instance;
    _.$_$.b = DictionaryCredential;
    _.$_$.c = StringCredential;
    _.$_$.d = IssuerObject;
    _.$_$.e = IssuerURI;
    //endregion
    return _;
});

});


parcelRegister("kmEuE", function(module, exports) {






(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-utils.js",
        "./ktor-ktor-client-core.js",
        "./ktor-ktor-http.js",
        "./ktor-ktor-serialization.js",
        "./ktor-ktor-io.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("cL6ZK")), (parcelRequire("dKHwv")), (parcelRequire("4fxpJ")), (parcelRequire("koNwy")), (parcelRequire("4cHl4")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization, kotlin_io_ktor_ktor_io) {
    "use strict";
    //region block: imports
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var VOID = kotlin_kotlin.$_$.f;
    var HttpResponseContainer = kotlin_io_ktor_ktor_client_core.$_$.t;
    var contentType = kotlin_io_ktor_ktor_http.$_$.h1;
    var suitableCharset = kotlin_io_ktor_ktor_serialization.$_$.f;
    var plus = kotlin_kotlin.$_$.t7;
    var toMutableSet = kotlin_kotlin.$_$.q8;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
    var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
    var register$default = kotlin_io_ktor_ktor_serialization.$_$.b;
    var Configuration = kotlin_io_ktor_ktor_serialization.$_$.c;
    var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
    var Phases_getInstance = kotlin_io_ktor_ktor_client_core.$_$.d;
    var Phases_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.e;
    var HttpClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.l;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var toString = kotlin_kotlin.$_$.ob;
    var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
    var accept = kotlin_io_ktor_ktor_client_core.$_$.p;
    var Collection = kotlin_kotlin.$_$.j5;
    var isInterface = kotlin_kotlin.$_$.xa;
    var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var contentType_0 = kotlin_io_ktor_ktor_http.$_$.f1;
    var EmptyContent_getInstance = kotlin_io_ktor_ktor_client_core.$_$.f;
    var Unit = kotlin_kotlin.$_$.ef;
    var charset = kotlin_io_ktor_ktor_http.$_$.d1;
    var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
    var equals = kotlin_kotlin.$_$.ba;
    var joinToString = kotlin_kotlin.$_$.g7;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.d1;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.m;
    var deserialize = kotlin_io_ktor_ktor_serialization.$_$.a;
    var Exception = kotlin_kotlin.$_$.ke;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.m1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.t;
    var getKClass = kotlin_kotlin.$_$.e;
    var setOf = kotlin_kotlin.$_$.c8;
    var startsWith = kotlin_kotlin.$_$.hd;
    var endsWith = kotlin_kotlin.$_$.oc;
    var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.y;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(ConverterRegistration, "ConverterRegistration");
    initMetadataForClass(ContentNegotiation$Config$defaultMatcher$1);
    initMetadataForLambda(ContentNegotiation$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(ContentNegotiation$Plugin$install$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForClass(Config, "Config", Config, VOID, [
        Configuration
    ]);
    initMetadataForObject(Plugin, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForCoroutine($convertRequestCOROUTINE$0, CoroutineImpl);
    initMetadataForCoroutine($convertResponseCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(ContentNegotiation, "ContentNegotiation", VOID, VOID, VOID, [
        2,
        5
    ]);
    initMetadataForClass(ContentConverterException, "ContentConverterException", VOID, Exception);
    initMetadataForObject(JsonContentTypeMatcher, "JsonContentTypeMatcher");
    //endregion
    function get_LOGGER() {
        _init_properties_ContentNegotiation_kt__o183go();
        return LOGGER;
    }
    var LOGGER;
    function get_DefaultCommonIgnoredTypes() {
        _init_properties_ContentNegotiation_kt__o183go();
        return DefaultCommonIgnoredTypes;
    }
    var DefaultCommonIgnoredTypes;
    function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
        this.m5r_1 = converter;
        this.n5r_1 = contentTypeToSend;
        this.o5r_1 = contentTypeMatcher;
    }
    function defaultMatcher($this, pattern) {
        return new ContentNegotiation$Config$defaultMatcher$1(pattern);
    }
    function ContentNegotiation$Config$defaultMatcher$1($pattern) {
        this.p5r_1 = $pattern;
    }
    protoOf(ContentNegotiation$Config$defaultMatcher$1).q5r = function(contentType) {
        return contentType.e49(this.p5r_1);
    };
    function ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation) {
        this.z5r_1 = $plugin;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(ContentNegotiation$Plugin$install$slambda).h4s = function($this$intercept, it, $completion) {
        var tmp = this.i4s($this$intercept, it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ContentNegotiation$Plugin$install$slambda).hj = function(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
        return this.h4s(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
    };
    protoOf(ContentNegotiation$Plugin$install$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = this.z5r_1.g5s(this.a5s_1.o46_1, this.a5s_1.r45(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.c5s_1 = suspendResult;
                    var tmp_0 = this;
                    var tmp_1;
                    if (this.c5s_1 == null) return Unit_instance;
                    else tmp_1 = this.c5s_1;
                    tmp_0.d5s_1 = tmp_1;
                    this.v8_1 = 2;
                    suspendResult = this.a5s_1.s45(this.d5s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(ContentNegotiation$Plugin$install$slambda).i4s = function($this$intercept, it, completion) {
        var i = new ContentNegotiation$Plugin$install$slambda(this.z5r_1, completion);
        i.a5s_1 = $this$intercept;
        i.b5s_1 = it;
        return i;
    };
    function ContentNegotiation$Plugin$install$slambda_0($plugin, resultContinuation) {
        var i = new ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation);
        var l = function($this$intercept, it, $completion) {
            return i.h4s($this$intercept, it, $completion);
        };
        l.$arity = 2;
        return l;
    }
    function ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation) {
        this.p5s_1 = $plugin;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(ContentNegotiation$Plugin$install$slambda_1).a4t = function($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
        var tmp = this.b4t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ContentNegotiation$Plugin$install$slambda_1).hj = function(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
        return this.a4t(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
    };
    protoOf(ContentNegotiation$Plugin$install$slambda_1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.s5s_1 = this.r5s_1.ba();
                    this.t5s_1 = this.r5s_1.ca();
                    var tmp_0 = this;
                    var tmp0_elvis_lhs = contentType(this.q5s_1.o46_1.j31());
                    var tmp_1;
                    if (tmp0_elvis_lhs == null) {
                        this.q5s_1;
                        get_LOGGER().k47('Response doesn\'t have "Content-Type" header, skipping ContentNegotiation plugin');
                        return Unit_instance;
                    } else tmp_1 = tmp0_elvis_lhs;
                    tmp_0.u5s_1 = tmp_1;
                    this.v5s_1 = suitableCharset(this.q5s_1.o46_1.w4v().m4d());
                    this.v8_1 = 1;
                    suspendResult = this.p5s_1.z5s(this.q5s_1.o46_1.w4v().y3h(), this.s5s_1, this.t5s_1, this.u5s_1, this.v5s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.w5s_1 = suspendResult;
                    var tmp_2 = this;
                    var tmp_3;
                    if (this.w5s_1 == null) return Unit_instance;
                    else tmp_3 = this.w5s_1;
                    tmp_2.x5s_1 = tmp_3;
                    this.y5s_1 = new HttpResponseContainer(this.s5s_1, this.x5s_1);
                    this.v8_1 = 2;
                    suspendResult = this.q5s_1.s45(this.y5s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(ContentNegotiation$Plugin$install$slambda_1).b4t = function($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
        var i = new ContentNegotiation$Plugin$install$slambda_1(this.p5s_1, completion);
        i.q5s_1 = $this$intercept;
        i.r5s_1 = _name_for_destructuring_parameter_0__wldtmu;
        return i;
    };
    function ContentNegotiation$Plugin$install$slambda_2($plugin, resultContinuation) {
        var i = new ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation);
        var l = function($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
            return i.a4t($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
        };
        l.$arity = 2;
        return l;
    }
    function Config() {
        this.a5t_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.b5t_1 = ArrayList_init_$Create$();
    }
    protoOf(Config).c4k = function(contentType, converter, configuration) {
        var matcher = contentType.equals(Application_getInstance().x47_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
        this.c5t(contentType, converter, matcher, configuration);
    };
    protoOf(Config).c5t = function(contentTypeToSend, converter, contentTypeMatcher, configuration) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        configuration(converter);
        var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
        this.b5t_1.e(registration);
    };
    function Plugin() {
        Plugin_instance = this;
        this.d5t_1 = new AttributeKey("ContentNegotiation");
    }
    protoOf(Plugin).a1 = function() {
        return this.d5t_1;
    };
    protoOf(Plugin).e5t = function(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new Config();
        // Inline function 'kotlin.contracts.contract' call
        block(this_0);
        var config = this_0;
        return new ContentNegotiation(config.b5t_1, config.a5t_1);
    };
    protoOf(Plugin).r4u = function(block) {
        return this.e5t(block);
    };
    protoOf(Plugin).f5t = function(plugin, scope) {
        var tmp = Phases_getInstance().l50_1;
        scope.n4r_1.s46(tmp, ContentNegotiation$Plugin$install$slambda_0(plugin, null));
        var tmp_0 = Phases_getInstance_0().m4u_1;
        scope.o4r_1.s46(tmp_0, ContentNegotiation$Plugin$install$slambda_2(plugin, null));
    };
    protoOf(Plugin).s4u = function(plugin, scope) {
        return this.f5t(plugin instanceof ContentNegotiation ? plugin : THROW_CCE(), scope);
    };
    var Plugin_instance;
    function Plugin_getInstance() {
        if (Plugin_instance == null) new Plugin();
        return Plugin_instance;
    }
    function ContentNegotiation$convertRequest$lambda(it) {
        return toString(it.m5r_1);
    }
    function $convertRequestCOROUTINE$0(_this__u8e3s4, request, body, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.o5t_1 = _this__u8e3s4;
        this.p5t_1 = request;
        this.q5t_1 = body;
    }
    protoOf($convertRequestCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 7;
                    var tmp0_iterator = this.o5t_1.e5s_1.j();
                    while(tmp0_iterator.k()){
                        var element = tmp0_iterator.l();
                        l$ret$1: {
                            get_LOGGER().k47("Adding Accept=" + element.n5r_1.a49_1 + " header for " + this.p5t_1.m4t_1.toString());
                            if (this.p5t_1.o4t_1.t43(HttpHeaders_getInstance().j49_1, element.n5r_1.toString())) break l$ret$1;
                            accept(this.p5t_1, element.n5r_1);
                        }
                    }
                    var tmp_0;
                    var tmp_1 = this.q5t_1;
                    if (tmp_1 instanceof OutgoingContent) tmp_0 = true;
                    else {
                        var tmp$ret$2;
                        l$ret$3: {
                            var this_0 = this.o5t_1.f5s_1;
                            var tmp_2;
                            if (isInterface(this_0, Collection)) tmp_2 = this_0.s();
                            else tmp_2 = false;
                            if (tmp_2) {
                                tmp$ret$2 = false;
                                break l$ret$3;
                            }
                            var tmp0_iterator_0 = this_0.j();
                            while(tmp0_iterator_0.k()){
                                var element_0 = tmp0_iterator_0.l();
                                if (element_0.ga(this.q5t_1)) {
                                    tmp$ret$2 = true;
                                    break l$ret$3;
                                }
                            }
                            tmp$ret$2 = false;
                        }
                        tmp_0 = tmp$ret$2;
                    }
                    if (tmp_0) {
                        get_LOGGER().k47("Body type " + toString(getKClassFromExpression(this.q5t_1)) + " is in ignored types. " + ("Skipping ContentNegotiation for " + this.p5t_1.m4t_1.toString() + "."));
                        return null;
                    }
                    var tmp_3 = this;
                    var tmp0_elvis_lhs = contentType_0(this.p5t_1);
                    var tmp_4;
                    if (tmp0_elvis_lhs == null) {
                        this.o5t_1;
                        get_LOGGER().k47("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.p5t_1.m4t_1.toString() + ".");
                        return null;
                    } else tmp_4 = tmp0_elvis_lhs;
                    tmp_3.r5t_1 = tmp_4;
                    var tmp_5 = this.q5t_1;
                    if (tmp_5 instanceof Unit) {
                        get_LOGGER().k47("Sending empty body for " + this.p5t_1.m4t_1.toString());
                        this.p5t_1.o4t_1.y43(HttpHeaders_getInstance().b4a_1);
                        return EmptyContent_getInstance();
                    }
                    var tmp_6 = this;
                    var this_1 = this.o5t_1.e5s_1;
                    var destination = ArrayList_init_$Create$();
                    var tmp0_iterator_1 = this_1.j();
                    while(tmp0_iterator_1.k()){
                        var element_1 = tmp0_iterator_1.l();
                        if (element_1.o5r_1.q5r(this.r5t_1)) destination.e(element_1);
                    }
                    var tmp_7;
                    if (!destination.s()) tmp_7 = destination;
                    else tmp_7 = null;
                    var tmp1_elvis_lhs = tmp_7;
                    var tmp_8;
                    if (tmp1_elvis_lhs == null) {
                        this.o5t_1;
                        get_LOGGER().k47("None of the registered converters match request Content-Type=" + this.r5t_1.toString() + ". " + ("Skipping ContentNegotiation for " + this.p5t_1.m4t_1.toString() + "."));
                        return null;
                    } else tmp_8 = tmp1_elvis_lhs;
                    tmp_6.s5t_1 = tmp_8;
                    if (this.p5t_1.y5g() == null) {
                        get_LOGGER().k47("Request has unknown body type. Skipping ContentNegotiation for " + this.p5t_1.m4t_1.toString() + ".");
                        return null;
                    }
                    this.p5t_1.o4t_1.y43(HttpHeaders_getInstance().b4a_1);
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    var tmp_9 = this;
                    tmp_9.u5t_1 = this.s5t_1;
                    this.v5t_1 = this.u5t_1.j();
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    if (!this.v5t_1.k()) {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                    this.w5t_1 = this.v5t_1.l();
                    var tmp_10 = this;
                    tmp_10.x5t_1 = this.w5t_1;
                    this.v8_1 = 3;
                    var tmp0_elvis_lhs_0 = charset(this.r5t_1);
                    var tmp_11 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().y3x_1 : tmp0_elvis_lhs_0;
                    var tmp_12 = ensureNotNull(this.p5t_1.y5g());
                    var this_2 = this.q5t_1;
                    var tmp_13;
                    if (!equals(this_2, NullBody_instance)) tmp_13 = this_2;
                    else tmp_13 = null;
                    suspendResult = this.x5t_1.m5r_1.f4k(this.r5t_1, tmp_11, tmp_12, tmp_13, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var result = suspendResult;
                    if (!(result == null)) get_LOGGER().k47("Converted request body using " + toString(this.x5t_1.m5r_1) + " for " + this.p5t_1.m4t_1.toString());
                    var result_0 = result;
                    if (!(result_0 == null)) {
                        this.t5t_1 = result_0;
                        this.v8_1 = 6;
                        continue $sm;
                    } else {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                case 4:
                    this.v8_1 = 2;
                    continue $sm;
                case 5:
                    this.t5t_1 = null;
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    var tmp2_elvis_lhs = this.t5t_1;
                    var tmp_14;
                    if (tmp2_elvis_lhs == null) {
                        var tmp_15 = "Can't convert " + toString(this.q5t_1) + " with contentType " + this.r5t_1.toString() + " using converters ";
                        throw new ContentConverterException(tmp_15 + joinToString(this.s5t_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$convertRequest$lambda));
                    } else tmp_14 = tmp2_elvis_lhs;
                    var serializedContent = tmp_14;
                    return serializedContent;
                case 7:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 7) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $convertResponseCOROUTINE$1(_this__u8e3s4, requestUrl, info, body, responseContentType, charset, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.g5u_1 = _this__u8e3s4;
        this.h5u_1 = requestUrl;
        this.i5u_1 = info;
        this.j5u_1 = body;
        this.k5u_1 = responseContentType;
        this.l5u_1 = charset;
    }
    protoOf($convertResponseCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this.j5u_1;
                    if (!isInterface(tmp_0, ByteReadChannel)) {
                        get_LOGGER().k47("Response body is already transformed. Skipping ContentNegotiation for " + this.h5u_1.toString() + ".");
                        return null;
                    }
                    if (this.g5u_1.f5s_1.a2(this.i5u_1.f47_1)) {
                        get_LOGGER().k47("Response body type " + toString(this.i5u_1.f47_1) + " is in ignored types. " + ("Skipping ContentNegotiation for " + this.h5u_1.toString() + "."));
                        return null;
                    }
                    var tmp_1 = this;
                    var this_0 = this.g5u_1.e5s_1;
                    var destination = ArrayList_init_$Create$();
                    var tmp0_iterator = this_0.j();
                    while(tmp0_iterator.k()){
                        var element = tmp0_iterator.l();
                        if (element.o5r_1.q5r(this.k5u_1)) destination.e(element);
                    }
                    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
                    var tmp0_iterator_0 = destination.j();
                    while(tmp0_iterator_0.k()){
                        var item = tmp0_iterator_0.l();
                        destination_0.e(item.m5r_1);
                    }
                    var tmp_2;
                    if (!destination_0.s()) tmp_2 = destination_0;
                    else tmp_2 = null;
                    var tmp0_elvis_lhs = tmp_2;
                    var tmp_3;
                    if (tmp0_elvis_lhs == null) {
                        this.g5u_1;
                        get_LOGGER().k47("None of the registered converters match response with Content-Type=" + this.k5u_1.toString() + ". " + ("Skipping ContentNegotiation for " + this.h5u_1.toString() + "."));
                        return null;
                    } else tmp_3 = tmp0_elvis_lhs;
                    tmp_1.m5u_1 = tmp_3;
                    this.v8_1 = 1;
                    suspendResult = deserialize(this.m5u_1, this.j5u_1, this.i5u_1, this.l5u_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var result = suspendResult;
                    if (!isInterface(result, ByteReadChannel)) get_LOGGER().k47("Response body was converted to " + toString(getKClassFromExpression(result)) + " for " + this.h5u_1.toString() + ".");
                    return result;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function ContentNegotiation(registrations, ignoredTypes) {
        Plugin_getInstance();
        this.e5s_1 = registrations;
        this.f5s_1 = ignoredTypes;
    }
    protoOf(ContentNegotiation).g5s = function(request, body, $completion) {
        var tmp = new $convertRequestCOROUTINE$0(this, request, body, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ContentNegotiation).z5s = function(requestUrl, info, body, responseContentType, charset, $completion) {
        var tmp = new $convertResponseCOROUTINE$1(this, requestUrl, info, body, responseContentType, charset, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function ContentConverterException(message) {
        Exception_init_$Init$(message, this);
        captureStack(this, ContentConverterException);
    }
    var properties_initialized_ContentNegotiation_kt_1ayduy;
    function _init_properties_ContentNegotiation_kt__o183go() {
        if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
            properties_initialized_ContentNegotiation_kt_1ayduy = true;
            LOGGER = KtorSimpleLogger("io.ktor.client.plugins.contentnegotiation.ContentNegotiation");
            DefaultCommonIgnoredTypes = setOf([
                PrimitiveClasses_getInstance().kb(),
                PrimitiveClasses_getInstance().gb(),
                getKClass(HttpStatusCode),
                getKClass(ByteReadChannel),
                getKClass(OutgoingContent)
            ]);
        }
    }
    function JsonContentTypeMatcher() {}
    protoOf(JsonContentTypeMatcher).q5r = function(contentType) {
        if (contentType.e49(Application_getInstance().x47_1)) return true;
        var value = contentType.d49().toString();
        return startsWith(value, "application/") && endsWith(value, "+json");
    };
    var JsonContentTypeMatcher_instance;
    function JsonContentTypeMatcher_getInstance() {
        return JsonContentTypeMatcher_instance;
    }
    function get_DefaultIgnoredTypes() {
        _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
        return DefaultIgnoredTypes;
    }
    var DefaultIgnoredTypes;
    var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
    function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
        if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
            properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
            // Inline function 'kotlin.collections.mutableSetOf' call
            DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
        }
    }
    //region block: post-declaration
    protoOf(Config).d4k = register$default;
    //endregion
    //region block: init
    JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Plugin_getInstance;
    //endregion
    return _;
});

});
parcelRegister("cL6ZK", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");




(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-io.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js",
        "./88b0986a7186d029-atomicfu-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("4cHl4")), (parcelRequire("ctZcf")), (parcelRequire("k4lEE")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_atomicfu) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var protoOf = kotlin_kotlin.$_$.kb;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var VOID = kotlin_kotlin.$_$.f;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var readBytes = kotlin_io_ktor_ktor_io.$_$.u;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var equals = kotlin_kotlin.$_$.ba;
    var hashCode = kotlin_kotlin.$_$.ha;
    var KtMutableMap = kotlin_kotlin.$_$.t5;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var Entry = kotlin_kotlin.$_$.q5;
    var isInterface = kotlin_kotlin.$_$.xa;
    var toString = kotlin_kotlin.$_$.vf;
    var charArray = kotlin_kotlin.$_$.v9;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var toString_0 = kotlin_kotlin.$_$.y2;
    var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
    var AbstractCoroutineContextElement = kotlin_kotlin.$_$.c9;
    var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
    var Element = kotlin_kotlin.$_$.l9;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var KtSet = kotlin_kotlin.$_$.v5;
    var toString_1 = kotlin_kotlin.$_$.ob;
    var KtMutableSet = kotlin_kotlin.$_$.u5;
    var Enum = kotlin_kotlin.$_$.ie;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var firstOrNull = kotlin_kotlin.$_$.v6;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var getBooleanHashCode = kotlin_kotlin.$_$.ea;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.g1;
    var get_lastIndex = kotlin_kotlin.$_$.ad;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v2;
    var equals_0 = kotlin_kotlin.$_$.pc;
    var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
    var Long = kotlin_kotlin.$_$.ne;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var Comparable = kotlin_kotlin.$_$.fe;
    var isSuspendFunction = kotlin_kotlin.$_$.bb;
    var KtMutableList = kotlin_kotlin.$_$.s5;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var ArrayList = kotlin_kotlin.$_$.i5;
    var emptyList = kotlin_kotlin.$_$.r6;
    var get_lastIndex_0 = kotlin_kotlin.$_$.j7;
    var last = kotlin_kotlin.$_$.m7;
    var mutableListOf = kotlin_kotlin.$_$.s7;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var extendThrowable = kotlin_kotlin.$_$.ca;
    var captureStack = kotlin_kotlin.$_$.t9;
    var recoverStackTrace = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
    var Companion_instance = kotlin_kotlin.$_$.c5;
    var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
    var createFailure = kotlin_kotlin.$_$.jf;
    var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a3;
    var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b3;
    var Continuation = kotlin_kotlin.$_$.h9;
    var fillArrayVal = kotlin_kotlin.$_$.da;
    var intercepted = kotlin_kotlin.$_$.b9;
    var toList = kotlin_kotlin.$_$.k8;
    var isNaN_0 = kotlin_kotlin.$_$.of;
    var numberToLong = kotlin_kotlin.$_$.ib;
    var IllegalStateException = kotlin_kotlin.$_$.me;
    var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.x1;
    var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.c3;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(AttributeKey, "AttributeKey");
    function get(key) {
        var tmp0_elvis_lhs = this.t41(key);
        var tmp;
        if (tmp0_elvis_lhs == null) throw IllegalStateException_init_$Create$("No instance for key " + key.toString());
        else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    initMetadataForInterface(Attributes, "Attributes");
    initMetadataForCoroutine($toByteArrayCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(CaseInsensitiveMap, "CaseInsensitiveMap", CaseInsensitiveMap, VOID, [
        KtMutableMap
    ]);
    initMetadataForClass(Entry_0, "Entry", VOID, VOID, [
        Entry
    ]);
    initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, AbstractCoroutineContextElement, [
        AbstractCoroutineContextElement,
        Element
    ]);
    initMetadataForClass(DelegatingMutableSet$iterator$1);
    initMetadataForClass(DelegatingMutableSet, "DelegatingMutableSet", VOID, VOID, [
        KtMutableSet
    ]);
    initMetadataForClass(Platform, "Platform", VOID, Enum);
    initMetadataForObject(PlatformUtils, "PlatformUtils");
    function get_0(name) {
        var tmp0_safe_receiver = this.l43(name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
    }
    function forEach(body) {
        var tmp0_iterator = this.n43().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.StringValues.forEach.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var k = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var v = element.b1();
            body(k, v);
        }
        return Unit_instance;
    }
    initMetadataForInterface(StringValues, "StringValues");
    initMetadataForClass(StringValuesBuilderImpl, "StringValuesBuilderImpl", StringValuesBuilderImpl);
    initMetadataForClass(StringValuesImpl, "StringValuesImpl", StringValuesImpl, VOID, [
        StringValues
    ]);
    initMetadataForClass(CaseInsensitiveString, "CaseInsensitiveString");
    initMetadataForClass(CopyOnWriteHashMap, "CopyOnWriteHashMap", CopyOnWriteHashMap);
    initMetadataForCompanion(Companion);
    initMetadataForClass(GMTDate, "GMTDate", VOID, VOID, [
        Comparable
    ]);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(WeekDay, "WeekDay", VOID, Enum);
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(Month, "Month", VOID, Enum);
    initMetadataForClass(Symbol, "Symbol");
    initMetadataForClass(LockFreeLinkedListNode, "LockFreeLinkedListNode");
    initMetadataForClass(Removed, "Removed");
    initMetadataForClass(OpDescriptor, "OpDescriptor");
    initMetadataForCoroutine($proceedLoopCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(PipelineContext, "PipelineContext", VOID, VOID, [
        CoroutineScope
    ], [
        1,
        0
    ]);
    initMetadataForClass(DebugPipelineContext, "DebugPipelineContext", VOID, PipelineContext, VOID, [
        1,
        0
    ]);
    initMetadataForCompanion(Companion_2);
    initMetadataForClass(PhaseContent, "PhaseContent");
    initMetadataForClass(Pipeline, "Pipeline", VOID, VOID, VOID, [
        2
    ]);
    initMetadataForClass(PipelinePhase, "PipelinePhase");
    initMetadataForClass(InvalidPhaseException, "InvalidPhaseException", VOID, Error);
    initMetadataForClass(PipelinePhaseRelation, "PipelinePhaseRelation");
    initMetadataForClass(After, "After", VOID, PipelinePhaseRelation);
    initMetadataForClass(Before, "Before", VOID, PipelinePhaseRelation);
    initMetadataForObject(Last, "Last", VOID, PipelinePhaseRelation);
    initMetadataForClass(SuspendFunctionGun$continuation$1, VOID, VOID, VOID, [
        Continuation
    ]);
    initMetadataForClass(SuspendFunctionGun, "SuspendFunctionGun", VOID, PipelineContext, VOID, [
        0,
        1
    ]);
    initMetadataForClass(TypeInfo, "TypeInfo");
    initMetadataForClass(AttributesJs, "AttributesJs", AttributesJs, VOID, [
        Attributes
    ]);
    initMetadataForClass(InvalidTimestampException, "InvalidTimestampException", VOID, IllegalStateException);
    initMetadataForClass(KtorSimpleLogger$1);
    initMetadataForClass(LogLevel, "LogLevel", VOID, Enum);
    initMetadataForObject(JsType, "JsType");
    //endregion
    function AttributeKey(name) {
        this.r41_1 = name;
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.r41_1;
        if (charSequenceLength(this_0) === 0) throw IllegalStateException_init_$Create$("Name can't be blank");
    }
    protoOf(AttributeKey).toString = function() {
        return "AttributeKey: " + this.r41_1;
    };
    protoOf(AttributeKey).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof AttributeKey)) THROW_CCE();
        if (!(this.r41_1 === other.r41_1)) return false;
        return true;
    };
    protoOf(AttributeKey).hashCode = function() {
        return getStringHashCode(this.r41_1);
    };
    function Attributes() {}
    function putAll(_this__u8e3s4, other) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = other.y41().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.putAll.<anonymous>' call
            _this__u8e3s4.v41(element instanceof AttributeKey ? element : THROW_CCE(), other.s41(element));
        }
    }
    function toByteArray(_this__u8e3s4, $completion) {
        var tmp = new $toByteArrayCOROUTINE$0(_this__u8e3s4, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function $toByteArrayCOROUTINE$0(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h42_1 = _this__u8e3s4;
    }
    protoOf($toByteArrayCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.h42_1.i3t(VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return readBytes(ARGUMENT);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$$receiver) {
        return $this$$receiver.i42_1;
    }
    function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$$receiver) {
        return caseInsensitive($this$$receiver);
    }
    function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$$receiver) {
        return new Entry_0($this$$receiver.a1().i42_1, $this$$receiver.b1());
    }
    function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$$receiver) {
        return new Entry_0(caseInsensitive($this$$receiver.a1()), $this$$receiver.b1());
    }
    function CaseInsensitiveMap() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.k42_1 = LinkedHashMap_init_$Create$();
    }
    protoOf(CaseInsensitiveMap).m = function() {
        return this.k42_1.m();
    };
    protoOf(CaseInsensitiveMap).wl = function(key) {
        return this.k42_1.c2(new CaseInsensitiveString(key));
    };
    protoOf(CaseInsensitiveMap).c2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return false;
        return this.wl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(CaseInsensitiveMap).vl = function(key) {
        return this.k42_1.e2(caseInsensitive(key));
    };
    protoOf(CaseInsensitiveMap).e2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return null;
        return this.vl((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(CaseInsensitiveMap).s = function() {
        return this.k42_1.s();
    };
    protoOf(CaseInsensitiveMap).i2 = function() {
        this.k42_1.i2();
    };
    protoOf(CaseInsensitiveMap).l42 = function(key, value) {
        return this.k42_1.m2(caseInsensitive(key), value);
    };
    protoOf(CaseInsensitiveMap).m2 = function(key, value) {
        var tmp = (!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE();
        return this.l42(tmp, !(value == null) ? value : THROW_CCE());
    };
    protoOf(CaseInsensitiveMap).m42 = function(from) {
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = from.z().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.CaseInsensitiveMap.putAll.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            this.l42(key, value);
        }
    };
    protoOf(CaseInsensitiveMap).o2 = function(from) {
        return this.m42(from);
    };
    protoOf(CaseInsensitiveMap).n42 = function(key) {
        return this.k42_1.n2(caseInsensitive(key));
    };
    protoOf(CaseInsensitiveMap).n2 = function(key) {
        if (!(!(key == null) ? typeof key === "string" : false)) return null;
        return this.n42((!(key == null) ? typeof key === "string" : false) ? key : THROW_CCE());
    };
    protoOf(CaseInsensitiveMap).f2 = function() {
        var tmp = this.k42_1.f2();
        var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
        return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
    };
    protoOf(CaseInsensitiveMap).z = function() {
        var tmp = this.k42_1.z();
        var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
        return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
    };
    protoOf(CaseInsensitiveMap).g2 = function() {
        return this.k42_1.g2();
    };
    protoOf(CaseInsensitiveMap).equals = function(other) {
        var tmp;
        if (other == null) tmp = true;
        else tmp = !(other instanceof CaseInsensitiveMap);
        if (tmp) return false;
        return equals(other.k42_1, this.k42_1);
    };
    protoOf(CaseInsensitiveMap).hashCode = function() {
        return hashCode(this.k42_1);
    };
    function Entry_0(key, value) {
        this.o42_1 = key;
        this.p42_1 = value;
    }
    protoOf(Entry_0).a1 = function() {
        return this.o42_1;
    };
    protoOf(Entry_0).b1 = function() {
        return this.p42_1;
    };
    protoOf(Entry_0).hashCode = function() {
        return (527 + hashCode(ensureNotNull(this.o42_1)) | 0) + hashCode(ensureNotNull(this.p42_1)) | 0;
    };
    protoOf(Entry_0).equals = function(other) {
        var tmp;
        if (other == null) tmp = true;
        else tmp = !(!(other == null) ? isInterface(other, Entry) : false);
        if (tmp) return false;
        return equals(other.a1(), this.o42_1) && equals(other.b1(), this.p42_1);
    };
    protoOf(Entry_0).toString = function() {
        return toString(this.o42_1) + "=" + toString(this.p42_1);
    };
    function toCharArray(_this__u8e3s4) {
        var tmp = 0;
        var tmp_0 = _this__u8e3s4.length;
        var tmp_1 = charArray(tmp_0);
        while(tmp < tmp_0){
            var tmp_2 = tmp;
            tmp_1[tmp_2] = charSequenceGet(_this__u8e3s4, tmp_2);
            tmp = tmp + 1 | 0;
        }
        return tmp_1;
    }
    function isLowerCase(_this__u8e3s4) {
        // Inline function 'kotlin.text.lowercaseChar' call
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = toString_0(_this__u8e3s4).toLowerCase();
        return charSequenceGet(tmp$ret$2, 0) === _this__u8e3s4;
    }
    function caseInsensitiveMap() {
        return new CaseInsensitiveMap();
    }
    function SilentSupervisor(parent) {
        parent = parent === VOID ? null : parent;
        var tmp = SupervisorJob(parent);
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        var tmp$ret$0 = new _no_name_provided__qut3iv();
        return tmp.vf(tmp$ret$0);
    }
    function _no_name_provided__qut3iv() {
        AbstractCoroutineContextElement.call(this, Key_instance);
    }
    protoOf(_no_name_provided__qut3iv).a1t = function(context, exception) {
        // Inline function 'io.ktor.util.SilentSupervisor.<anonymous>' call
        return Unit_instance;
    };
    function DelegatingMutableSet$iterator$1(this$0) {
        this.s42_1 = this$0;
        this.r42_1 = this$0.t42_1.j();
    }
    protoOf(DelegatingMutableSet$iterator$1).k = function() {
        return this.r42_1.k();
    };
    protoOf(DelegatingMutableSet$iterator$1).l = function() {
        return this.s42_1.u42_1(this.r42_1.l());
    };
    protoOf(DelegatingMutableSet$iterator$1).i4 = function() {
        return this.r42_1.i4();
    };
    function DelegatingMutableSet(delegate, convertTo, convert) {
        this.t42_1 = delegate;
        this.u42_1 = convertTo;
        this.v42_1 = convert;
        this.w42_1 = this.t42_1.m();
    }
    protoOf(DelegatingMutableSet).x42 = function(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.util.DelegatingMutableSet.convert.<anonymous>' call
            var tmp$ret$0 = this.v42_1(item);
            destination.e(tmp$ret$0);
        }
        return destination;
    };
    protoOf(DelegatingMutableSet).y42 = function(_this__u8e3s4) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
        var tmp0_iterator = _this__u8e3s4.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.util.DelegatingMutableSet.convertTo.<anonymous>' call
            var tmp$ret$0 = this.u42_1(item);
            destination.e(tmp$ret$0);
        }
        return destination;
    };
    protoOf(DelegatingMutableSet).m = function() {
        return this.w42_1;
    };
    protoOf(DelegatingMutableSet).z42 = function(element) {
        return this.t42_1.e(this.v42_1(element));
    };
    protoOf(DelegatingMutableSet).e = function(element) {
        return this.z42((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(DelegatingMutableSet).a43 = function(elements) {
        return this.t42_1.n(this.x42(elements));
    };
    protoOf(DelegatingMutableSet).n = function(elements) {
        return this.a43(elements);
    };
    protoOf(DelegatingMutableSet).i2 = function() {
        this.t42_1.i2();
    };
    protoOf(DelegatingMutableSet).b43 = function(elements) {
        return this.t42_1.h2(this.x42(elements));
    };
    protoOf(DelegatingMutableSet).h2 = function(elements) {
        return this.b43(elements);
    };
    protoOf(DelegatingMutableSet).c43 = function(element) {
        return this.t42_1.a2(this.v42_1(element));
    };
    protoOf(DelegatingMutableSet).a2 = function(element) {
        if (!(element == null ? true : !(element == null))) return false;
        return this.c43((element == null ? true : !(element == null)) ? element : THROW_CCE());
    };
    protoOf(DelegatingMutableSet).d43 = function(elements) {
        return this.t42_1.b2(this.x42(elements));
    };
    protoOf(DelegatingMutableSet).b2 = function(elements) {
        return this.d43(elements);
    };
    protoOf(DelegatingMutableSet).s = function() {
        return this.t42_1.s();
    };
    protoOf(DelegatingMutableSet).j = function() {
        return new DelegatingMutableSet$iterator$1(this);
    };
    protoOf(DelegatingMutableSet).hashCode = function() {
        return hashCode(this.t42_1);
    };
    protoOf(DelegatingMutableSet).equals = function(other) {
        var tmp;
        if (other == null) tmp = true;
        else tmp = !(!(other == null) ? isInterface(other, KtSet) : false);
        if (tmp) return false;
        var elements = this.y42(this.t42_1);
        var tmp_0;
        if (other.b2(elements)) // Inline function 'kotlin.collections.containsAll' call
        tmp_0 = elements.b2(other);
        else tmp_0 = false;
        return tmp_0;
    };
    protoOf(DelegatingMutableSet).toString = function() {
        return toString_1(this.y42(this.t42_1));
    };
    var Platform_Jvm_instance;
    var Platform_Native_instance;
    var Platform_Browser_instance;
    var Platform_Node_instance;
    var Platform_entriesInitialized;
    function Platform_initEntries() {
        if (Platform_entriesInitialized) return Unit_instance;
        Platform_entriesInitialized = true;
        Platform_Jvm_instance = new Platform("Jvm", 0);
        Platform_Native_instance = new Platform("Native", 1);
        Platform_Browser_instance = new Platform("Browser", 2);
        Platform_Node_instance = new Platform("Node", 3);
    }
    function Platform(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function PlatformUtils() {
        PlatformUtils_instance = this;
        this.e43_1 = get_platform(this).equals(Platform_Browser_getInstance());
        this.f43_1 = get_platform(this).equals(Platform_Node_getInstance());
        this.g43_1 = get_platform(this).equals(Platform_Jvm_getInstance());
        this.h43_1 = get_platform(this).equals(Platform_Native_getInstance());
        this.i43_1 = get_isDevelopmentMode(this);
        this.j43_1 = get_isNewMemoryModel(this);
    }
    var PlatformUtils_instance;
    function PlatformUtils_getInstance() {
        if (PlatformUtils_instance == null) new PlatformUtils();
        return PlatformUtils_instance;
    }
    function Platform_Jvm_getInstance() {
        Platform_initEntries();
        return Platform_Jvm_instance;
    }
    function Platform_Native_getInstance() {
        Platform_initEntries();
        return Platform_Native_instance;
    }
    function Platform_Browser_getInstance() {
        Platform_initEntries();
        return Platform_Browser_instance;
    }
    function Platform_Node_getInstance() {
        Platform_initEntries();
        return Platform_Node_instance;
    }
    function StringValues() {}
    function ensureListForKey($this, name) {
        var tmp0_elvis_lhs = $this.q43_1.e2(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            // Inline function 'kotlin.collections.mutableListOf' call
            var this_0 = ArrayList_init_$Create$_0();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.util.StringValuesBuilderImpl.ensureListForKey.<anonymous>' call
            $this.r43(name);
            // Inline function 'kotlin.collections.set' call
            $this.q43_1.m2(name, this_0);
            tmp = this_0;
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    }
    function StringValuesBuilderImpl$appendAll$lambda(this$0) {
        return function(name, values) {
            this$0.s43(name, values);
            return Unit_instance;
        };
    }
    function StringValuesBuilderImpl(caseInsensitiveName, size) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        size = size === VOID ? 8 : size;
        this.p43_1 = caseInsensitiveName;
        this.q43_1 = this.p43_1 ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_0(size);
    }
    protoOf(StringValuesBuilderImpl).k43 = function() {
        return this.p43_1;
    };
    protoOf(StringValuesBuilderImpl).l43 = function(name) {
        return this.q43_1.e2(name);
    };
    protoOf(StringValuesBuilderImpl).t43 = function(name, value) {
        var tmp0_safe_receiver = this.q43_1.e2(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a2(value);
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    };
    protoOf(StringValuesBuilderImpl).m43 = function() {
        return this.q43_1.f2();
    };
    protoOf(StringValuesBuilderImpl).s = function() {
        return this.q43_1.s();
    };
    protoOf(StringValuesBuilderImpl).n43 = function() {
        return unmodifiable(this.q43_1.z());
    };
    protoOf(StringValuesBuilderImpl).u43 = function(name, value) {
        this.v43(value);
        var list = ensureListForKey(this, name);
        list.i2();
        list.e(value);
    };
    protoOf(StringValuesBuilderImpl).vl = function(name) {
        var tmp0_safe_receiver = this.l43(name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
    };
    protoOf(StringValuesBuilderImpl).w43 = function(name, value) {
        this.v43(value);
        ensureListForKey(this, name).e(value);
    };
    protoOf(StringValuesBuilderImpl).x43 = function(stringValues) {
        stringValues.o43(StringValuesBuilderImpl$appendAll$lambda(this));
    };
    protoOf(StringValuesBuilderImpl).s43 = function(name, values) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var list = ensureListForKey(this, name);
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = values.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.StringValuesBuilderImpl.appendAll.<anonymous>.<anonymous>' call
            this.v43(element);
            list.e(element);
        }
    };
    protoOf(StringValuesBuilderImpl).y43 = function(name) {
        this.q43_1.n2(name);
    };
    protoOf(StringValuesBuilderImpl).i2 = function() {
        this.q43_1.i2();
    };
    protoOf(StringValuesBuilderImpl).r43 = function(name) {};
    protoOf(StringValuesBuilderImpl).v43 = function(value) {};
    function listForKey($this, name) {
        return $this.a44_1.e2(name);
    }
    function StringValuesImpl(caseInsensitiveName, values) {
        caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
        values = values === VOID ? emptyMap() : values;
        this.z43_1 = caseInsensitiveName;
        var tmp;
        if (this.z43_1) tmp = caseInsensitiveMap();
        else // Inline function 'kotlin.collections.mutableMapOf' call
        tmp = LinkedHashMap_init_$Create$();
        var newMap = tmp;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = values.z().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            // Inline function 'kotlin.collections.set' call
            // Inline function 'kotlin.collections.List' call
            // Inline function 'kotlin.collections.MutableList' call
            var size = value.m();
            var list = ArrayList_init_$Create$(size);
            // Inline function 'kotlin.repeat' call
            // Inline function 'kotlin.contracts.contract' call
            var inductionVariable = 0;
            if (inductionVariable < size) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'kotlin.collections.MutableList.<anonymous>' call
                // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>.<anonymous>' call
                var tmp$ret$4 = value.o(index);
                list.e(tmp$ret$4);
            }while (inductionVariable < size);
            newMap.m2(key, list);
        }
        this.a44_1 = newMap;
    }
    protoOf(StringValuesImpl).k43 = function() {
        return this.z43_1;
    };
    protoOf(StringValuesImpl).vl = function(name) {
        var tmp0_safe_receiver = listForKey(this, name);
        return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
    };
    protoOf(StringValuesImpl).l43 = function(name) {
        return listForKey(this, name);
    };
    protoOf(StringValuesImpl).m43 = function() {
        return unmodifiable(this.a44_1.f2());
    };
    protoOf(StringValuesImpl).s = function() {
        return this.a44_1.s();
    };
    protoOf(StringValuesImpl).n43 = function() {
        return unmodifiable(this.a44_1.z());
    };
    protoOf(StringValuesImpl).o43 = function(body) {
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator = this.a44_1.z().j();
        while(tmp0_iterator.k()){
            var tmp1_loop_parameter = tmp0_iterator.l();
            // Inline function 'kotlin.collections.component1' call
            var key = tmp1_loop_parameter.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = tmp1_loop_parameter.b1();
            body(key, value);
        }
    };
    protoOf(StringValuesImpl).toString = function() {
        return "StringValues(case=" + !this.z43_1 + ") " + toString_1(this.n43());
    };
    protoOf(StringValuesImpl).equals = function(other) {
        if (this === other) return true;
        if (!(!(other == null) ? isInterface(other, StringValues) : false)) return false;
        if (!(this.z43_1 === other.k43())) return false;
        return entriesEquals(this.n43(), other.n43());
    };
    protoOf(StringValuesImpl).hashCode = function() {
        return entriesHashCode(this.n43(), imul(31, getBooleanHashCode(this.z43_1)));
    };
    function appendAll(_this__u8e3s4, builder) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.util.appendAll.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = builder.n43().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.util.appendAll.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var name = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var values = element.b1();
            _this__u8e3s4.s43(name, values);
        }
        return _this__u8e3s4;
    }
    function entriesEquals(a, b) {
        return equals(a, b);
    }
    function entriesHashCode(entries, seed) {
        return imul(seed, 31) + hashCode(entries) | 0;
    }
    function toLowerCasePreservingASCIIRules(_this__u8e3s4) {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.indexOfFirst' call
            var inductionVariable = 0;
            var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
            if (inductionVariable <= last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
                var it = charSequenceGet(_this__u8e3s4, index);
                if (!(toLowerCasePreservingASCII(it) === it)) {
                    tmp$ret$1 = index;
                    break $l$block;
                }
            }while (inductionVariable <= last);
            tmp$ret$1 = -1;
        }
        var firstIndex = tmp$ret$1;
        if (firstIndex === -1) return _this__u8e3s4;
        var original = _this__u8e3s4;
        // Inline function 'kotlin.text.buildString' call
        var capacity = _this__u8e3s4.length;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$(capacity);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
        this_0.qb(original, 0, firstIndex);
        var inductionVariable_0 = firstIndex;
        var last_0 = get_lastIndex(original);
        if (inductionVariable_0 <= last_0) do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this_0.f8(toLowerCasePreservingASCII(charSequenceGet(original, index_0)));
        }while (!(index_0 === last_0));
        return this_0.toString();
    }
    function toLowerCasePreservingASCII(ch) {
        var tmp;
        if (_Char___init__impl__6a9atx(65) <= ch ? ch <= _Char___init__impl__6a9atx(90) : false) tmp = Char__plus_impl_qi7pgj(ch, 32);
        else if (_Char___init__impl__6a9atx(0) <= ch ? ch <= _Char___init__impl__6a9atx(127) : false) tmp = ch;
        else {
            // Inline function 'kotlin.text.lowercaseChar' call
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$2 = toString_0(ch).toLowerCase();
            tmp = charSequenceGet(tmp$ret$2, 0);
        }
        return tmp;
    }
    function CaseInsensitiveString(content) {
        this.i42_1 = content;
        var tmp = this;
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.i42_1.toLowerCase();
        tmp.j42_1 = getStringHashCode(tmp$ret$1);
    }
    protoOf(CaseInsensitiveString).equals = function(other) {
        var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i42_1;
        return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this.i42_1, true)) === true;
    };
    protoOf(CaseInsensitiveString).hashCode = function() {
        return this.j42_1;
    };
    protoOf(CaseInsensitiveString).toString = function() {
        return this.i42_1;
    };
    function caseInsensitive(_this__u8e3s4) {
        return new CaseInsensitiveString(_this__u8e3s4);
    }
    function CopyOnWriteHashMap() {
        this.b44_1 = atomic$ref$1(emptyMap());
    }
    protoOf(CopyOnWriteHashMap).c44 = function(key) {
        return this.b44_1.kotlinx$atomicfu$value.e2(key);
    };
    function Companion() {
        Companion_instance_0 = this;
        this.d44_1 = GMTDate_0(new Long(0, 0));
    }
    var Companion_instance_0;
    function Companion_getInstance() {
        if (Companion_instance_0 == null) new Companion();
        return Companion_instance_0;
    }
    function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
        Companion_getInstance();
        this.e44_1 = seconds;
        this.f44_1 = minutes;
        this.g44_1 = hours;
        this.h44_1 = dayOfWeek;
        this.i44_1 = dayOfMonth;
        this.j44_1 = dayOfYear;
        this.k44_1 = month;
        this.l44_1 = year;
        this.m44_1 = timestamp;
    }
    protoOf(GMTDate).n44 = function(other) {
        return this.m44_1.j1(other.m44_1);
    };
    protoOf(GMTDate).d = function(other) {
        return this.n44(other instanceof GMTDate ? other : THROW_CCE());
    };
    protoOf(GMTDate).toString = function() {
        return "GMTDate(seconds=" + this.e44_1 + ", minutes=" + this.f44_1 + ", hours=" + this.g44_1 + ", dayOfWeek=" + this.h44_1.toString() + ", dayOfMonth=" + this.i44_1 + ", dayOfYear=" + this.j44_1 + ", month=" + this.k44_1.toString() + ", year=" + this.l44_1 + ", timestamp=" + this.m44_1.toString() + ")";
    };
    protoOf(GMTDate).hashCode = function() {
        var result = this.e44_1;
        result = imul(result, 31) + this.f44_1 | 0;
        result = imul(result, 31) + this.g44_1 | 0;
        result = imul(result, 31) + this.h44_1.hashCode() | 0;
        result = imul(result, 31) + this.i44_1 | 0;
        result = imul(result, 31) + this.j44_1 | 0;
        result = imul(result, 31) + this.k44_1.hashCode() | 0;
        result = imul(result, 31) + this.l44_1 | 0;
        result = imul(result, 31) + this.m44_1.hashCode() | 0;
        return result;
    };
    protoOf(GMTDate).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof GMTDate)) return false;
        var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
        if (!(this.e44_1 === tmp0_other_with_cast.e44_1)) return false;
        if (!(this.f44_1 === tmp0_other_with_cast.f44_1)) return false;
        if (!(this.g44_1 === tmp0_other_with_cast.g44_1)) return false;
        if (!this.h44_1.equals(tmp0_other_with_cast.h44_1)) return false;
        if (!(this.i44_1 === tmp0_other_with_cast.i44_1)) return false;
        if (!(this.j44_1 === tmp0_other_with_cast.j44_1)) return false;
        if (!this.k44_1.equals(tmp0_other_with_cast.k44_1)) return false;
        if (!(this.l44_1 === tmp0_other_with_cast.l44_1)) return false;
        if (!this.m44_1.equals(tmp0_other_with_cast.m44_1)) return false;
        return true;
    };
    var WeekDay_MONDAY_instance;
    var WeekDay_TUESDAY_instance;
    var WeekDay_WEDNESDAY_instance;
    var WeekDay_THURSDAY_instance;
    var WeekDay_FRIDAY_instance;
    var WeekDay_SATURDAY_instance;
    var WeekDay_SUNDAY_instance;
    function Companion_0() {}
    protoOf(Companion_0).o44 = function(ordinal) {
        return values()[ordinal];
    };
    var Companion_instance_1;
    function Companion_getInstance_0() {
        return Companion_instance_1;
    }
    function values() {
        return [
            WeekDay_MONDAY_getInstance(),
            WeekDay_TUESDAY_getInstance(),
            WeekDay_WEDNESDAY_getInstance(),
            WeekDay_THURSDAY_getInstance(),
            WeekDay_FRIDAY_getInstance(),
            WeekDay_SATURDAY_getInstance(),
            WeekDay_SUNDAY_getInstance()
        ];
    }
    var WeekDay_entriesInitialized;
    function WeekDay_initEntries() {
        if (WeekDay_entriesInitialized) return Unit_instance;
        WeekDay_entriesInitialized = true;
        WeekDay_MONDAY_instance = new WeekDay("MONDAY", 0, "Mon");
        WeekDay_TUESDAY_instance = new WeekDay("TUESDAY", 1, "Tue");
        WeekDay_WEDNESDAY_instance = new WeekDay("WEDNESDAY", 2, "Wed");
        WeekDay_THURSDAY_instance = new WeekDay("THURSDAY", 3, "Thu");
        WeekDay_FRIDAY_instance = new WeekDay("FRIDAY", 4, "Fri");
        WeekDay_SATURDAY_instance = new WeekDay("SATURDAY", 5, "Sat");
        WeekDay_SUNDAY_instance = new WeekDay("SUNDAY", 6, "Sun");
    }
    function WeekDay(name, ordinal, value) {
        Enum.call(this, name, ordinal);
        this.r44_1 = value;
    }
    var Month_JANUARY_instance;
    var Month_FEBRUARY_instance;
    var Month_MARCH_instance;
    var Month_APRIL_instance;
    var Month_MAY_instance;
    var Month_JUNE_instance;
    var Month_JULY_instance;
    var Month_AUGUST_instance;
    var Month_SEPTEMBER_instance;
    var Month_OCTOBER_instance;
    var Month_NOVEMBER_instance;
    var Month_DECEMBER_instance;
    function Companion_1() {}
    protoOf(Companion_1).o44 = function(ordinal) {
        return values_0()[ordinal];
    };
    var Companion_instance_2;
    function Companion_getInstance_1() {
        return Companion_instance_2;
    }
    function values_0() {
        return [
            Month_JANUARY_getInstance(),
            Month_FEBRUARY_getInstance(),
            Month_MARCH_getInstance(),
            Month_APRIL_getInstance(),
            Month_MAY_getInstance(),
            Month_JUNE_getInstance(),
            Month_JULY_getInstance(),
            Month_AUGUST_getInstance(),
            Month_SEPTEMBER_getInstance(),
            Month_OCTOBER_getInstance(),
            Month_NOVEMBER_getInstance(),
            Month_DECEMBER_getInstance()
        ];
    }
    var Month_entriesInitialized;
    function Month_initEntries() {
        if (Month_entriesInitialized) return Unit_instance;
        Month_entriesInitialized = true;
        Month_JANUARY_instance = new Month("JANUARY", 0, "Jan");
        Month_FEBRUARY_instance = new Month("FEBRUARY", 1, "Feb");
        Month_MARCH_instance = new Month("MARCH", 2, "Mar");
        Month_APRIL_instance = new Month("APRIL", 3, "Apr");
        Month_MAY_instance = new Month("MAY", 4, "May");
        Month_JUNE_instance = new Month("JUNE", 5, "Jun");
        Month_JULY_instance = new Month("JULY", 6, "Jul");
        Month_AUGUST_instance = new Month("AUGUST", 7, "Aug");
        Month_SEPTEMBER_instance = new Month("SEPTEMBER", 8, "Sep");
        Month_OCTOBER_instance = new Month("OCTOBER", 9, "Oct");
        Month_NOVEMBER_instance = new Month("NOVEMBER", 10, "Nov");
        Month_DECEMBER_instance = new Month("DECEMBER", 11, "Dec");
    }
    function Month(name, ordinal, value) {
        Enum.call(this, name, ordinal);
        this.u44_1 = value;
    }
    function WeekDay_MONDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_MONDAY_instance;
    }
    function WeekDay_TUESDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_TUESDAY_instance;
    }
    function WeekDay_WEDNESDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_WEDNESDAY_instance;
    }
    function WeekDay_THURSDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_THURSDAY_instance;
    }
    function WeekDay_FRIDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_FRIDAY_instance;
    }
    function WeekDay_SATURDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_SATURDAY_instance;
    }
    function WeekDay_SUNDAY_getInstance() {
        WeekDay_initEntries();
        return WeekDay_SUNDAY_instance;
    }
    function Month_JANUARY_getInstance() {
        Month_initEntries();
        return Month_JANUARY_instance;
    }
    function Month_FEBRUARY_getInstance() {
        Month_initEntries();
        return Month_FEBRUARY_instance;
    }
    function Month_MARCH_getInstance() {
        Month_initEntries();
        return Month_MARCH_instance;
    }
    function Month_APRIL_getInstance() {
        Month_initEntries();
        return Month_APRIL_instance;
    }
    function Month_MAY_getInstance() {
        Month_initEntries();
        return Month_MAY_instance;
    }
    function Month_JUNE_getInstance() {
        Month_initEntries();
        return Month_JUNE_instance;
    }
    function Month_JULY_getInstance() {
        Month_initEntries();
        return Month_JULY_instance;
    }
    function Month_AUGUST_getInstance() {
        Month_initEntries();
        return Month_AUGUST_instance;
    }
    function Month_SEPTEMBER_getInstance() {
        Month_initEntries();
        return Month_SEPTEMBER_instance;
    }
    function Month_OCTOBER_getInstance() {
        Month_initEntries();
        return Month_OCTOBER_instance;
    }
    function Month_NOVEMBER_getInstance() {
        Month_initEntries();
        return Month_NOVEMBER_instance;
    }
    function Month_DECEMBER_getInstance() {
        Month_initEntries();
        return Month_DECEMBER_instance;
    }
    var CONDITION_FALSE;
    var ALREADY_REMOVED;
    var LIST_EMPTY;
    var REMOVE_PREPARED;
    var NO_DECISION;
    function Symbol(symbol) {
        this.v44_1 = symbol;
    }
    protoOf(Symbol).toString = function() {
        return this.v44_1;
    };
    function LockFreeLinkedListNode() {}
    protoOf(LockFreeLinkedListNode).z1y = function() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.w44_1;
        while(true){
            // Inline function 'io.ktor.util.internal.LockFreeLinkedListNode.<get-next>.<anonymous>' call
            var next = this_0.kotlinx$atomicfu$value;
            if (!(next instanceof OpDescriptor)) return next;
            next.w1v(this);
        }
    };
    protoOf(LockFreeLinkedListNode).x44 = function() {
        return unwrap(this.z1y());
    };
    function Removed() {}
    function OpDescriptor() {}
    function unwrap(_this__u8e3s4) {
        _init_properties_LockFreeLinkedList_kt__wekxce();
        var tmp0_safe_receiver = _this__u8e3s4 instanceof Removed ? _this__u8e3s4 : null;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y44_1;
        var tmp;
        if (tmp1_elvis_lhs == null) tmp = _this__u8e3s4 instanceof LockFreeLinkedListNode ? _this__u8e3s4 : THROW_CCE();
        else tmp = tmp1_elvis_lhs;
        return tmp;
    }
    var properties_initialized_LockFreeLinkedList_kt_lnmdgw;
    function _init_properties_LockFreeLinkedList_kt__wekxce() {
        if (!properties_initialized_LockFreeLinkedList_kt_lnmdgw) {
            properties_initialized_LockFreeLinkedList_kt_lnmdgw = true;
            CONDITION_FALSE = new Symbol("CONDITION_FALSE");
            ALREADY_REMOVED = new Symbol("ALREADY_REMOVED");
            LIST_EMPTY = new Symbol("LIST_EMPTY");
            REMOVE_PREPARED = new Symbol("REMOVE_PREPARED");
            NO_DECISION = new Symbol("NO_DECISION");
        }
    }
    function proceedLoop($this, $completion) {
        var tmp = new $proceedLoopCOROUTINE$1($this, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function $proceedLoopCOROUTINE$1(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h45_1 = _this__u8e3s4;
    }
    protoOf($proceedLoopCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.i45_1 = this.h45_1.p45_1;
                    if (this.i45_1 === -1) {
                        this.v8_1 = 5;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.j45_1 = this.h45_1.m45_1;
                    if (this.i45_1 >= this.j45_1.m()) {
                        this.h45_1.q45();
                        this.v8_1 = 5;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    this.k45_1 = this.j45_1.o(this.i45_1);
                    this.h45_1.p45_1 = this.i45_1 + 1 | 0;
                    this.v8_1 = 4;
                    var tmp_0 = this.k45_1;
                    suspendResult = (isSuspendFunction(tmp_0, 2) ? tmp_0 : THROW_CCE())(this.h45_1, this.h45_1.o45_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    this.v8_1 = 1;
                    continue $sm;
                case 5:
                    return this.h45_1.o45_1;
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
        PipelineContext.call(this, context);
        this.m45_1 = interceptors;
        this.n45_1 = coroutineContext;
        this.o45_1 = subject;
        this.p45_1 = 0;
    }
    protoOf(DebugPipelineContext).v1m = function() {
        return this.n45_1;
    };
    protoOf(DebugPipelineContext).r45 = function() {
        return this.o45_1;
    };
    protoOf(DebugPipelineContext).q45 = function() {
        this.p45_1 = -1;
    };
    protoOf(DebugPipelineContext).s45 = function(subject, $completion) {
        this.o45_1 = subject;
        return this.t45($completion);
    };
    protoOf(DebugPipelineContext).t45 = function($completion) {
        var index = this.p45_1;
        if (index < 0) return this.o45_1;
        if (index >= this.m45_1.m()) {
            this.q45();
            return this.o45_1;
        }
        return proceedLoop(this, $completion);
    };
    protoOf(DebugPipelineContext).u45 = function(initial, $completion) {
        this.p45_1 = 0;
        this.o45_1 = initial;
        return this.t45($completion);
    };
    function PhaseContent_init_$Init$(phase, relation, $this) {
        var tmp = Companion_getInstance_2().v45_1;
        PhaseContent.call($this, phase, relation, isInterface(tmp, KtMutableList) ? tmp : THROW_CCE());
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!Companion_getInstance_2().v45_1.s()) {
            // Inline function 'io.ktor.util.pipeline.PhaseContent.<init>.<anonymous>' call
            var message = "The shared empty array list has been modified";
            throw IllegalStateException_init_$Create$(toString_1(message));
        }
        return $this;
    }
    function PhaseContent_init_$Create$(phase, relation) {
        return PhaseContent_init_$Init$(phase, relation, objectCreate(protoOf(PhaseContent)));
    }
    function copyInterceptors($this) {
        $this.y45_1 = $this.a46();
        $this.z45_1 = false;
    }
    function Companion_2() {
        Companion_instance_3 = this;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.v45_1 = ArrayList_init_$Create$_0();
    }
    var Companion_instance_3;
    function Companion_getInstance_2() {
        if (Companion_instance_3 == null) new Companion_2();
        return Companion_instance_3;
    }
    function PhaseContent(phase, relation, interceptors) {
        Companion_getInstance_2();
        this.w45_1 = phase;
        this.x45_1 = relation;
        this.y45_1 = interceptors;
        this.z45_1 = true;
    }
    protoOf(PhaseContent).b3n = function() {
        return this.y45_1.s();
    };
    protoOf(PhaseContent).m = function() {
        return this.y45_1.m();
    };
    protoOf(PhaseContent).b46 = function(interceptor) {
        if (this.z45_1) copyInterceptors(this);
        this.y45_1.e(interceptor);
    };
    protoOf(PhaseContent).c46 = function(destination) {
        var interceptors = this.y45_1;
        if (destination instanceof ArrayList) destination.q5(destination.m() + interceptors.m() | 0);
        var inductionVariable = 0;
        var last = interceptors.m();
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination.e(interceptors.o(index));
        }while (inductionVariable < last);
    };
    protoOf(PhaseContent).d46 = function() {
        this.z45_1 = true;
        return this.y45_1;
    };
    protoOf(PhaseContent).a46 = function() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.collections.mutableListOf' call
        var this_0 = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.util.pipeline.PhaseContent.copiedInterceptors.<anonymous>' call
        this_0.n(this.y45_1);
        return this_0;
    };
    protoOf(PhaseContent).toString = function() {
        return "Phase `" + this.w45_1.e46_1 + "`, " + this.m() + " handlers";
    };
    function _set_interceptors__wod97b($this, value) {
        $this.j46_1.kotlinx$atomicfu$value = value;
    }
    function _get_interceptors__h4min7($this) {
        return $this.j46_1.kotlinx$atomicfu$value;
    }
    function createContext($this, context, subject, coroutineContext) {
        return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.m46());
    }
    function findPhase($this, phase) {
        var phasesList = $this.h46_1;
        var inductionVariable = 0;
        var last = phasesList.m();
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var current = phasesList.o(index);
            if (current === phase) {
                var content = PhaseContent_init_$Create$(phase, Last_getInstance());
                phasesList.j2(index, content);
                return content;
            }
            var tmp;
            if (current instanceof PhaseContent) tmp = current.w45_1 === phase;
            else tmp = false;
            if (tmp) return current instanceof PhaseContent ? current : THROW_CCE();
        }while (inductionVariable < last);
        return null;
    }
    function findPhaseIndex($this, phase) {
        var phasesList = $this.h46_1;
        var inductionVariable = 0;
        var last = phasesList.m();
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var current = phasesList.o(index);
            var tmp;
            if (current === phase) tmp = true;
            else {
                var tmp_0;
                if (current instanceof PhaseContent) tmp_0 = current.w45_1 === phase;
                else tmp_0 = false;
                tmp = tmp_0;
            }
            if (tmp) return index;
        }while (inductionVariable < last);
        return -1;
    }
    function hasPhase($this, phase) {
        var phasesList = $this.h46_1;
        var inductionVariable = 0;
        var last = phasesList.m();
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var current = phasesList.o(index);
            var tmp;
            if (current === phase) tmp = true;
            else {
                var tmp_0;
                if (current instanceof PhaseContent) tmp_0 = current.w45_1 === phase;
                else tmp_0 = false;
                tmp = tmp_0;
            }
            if (tmp) return true;
        }while (inductionVariable < last);
        return false;
    }
    function cacheInterceptors($this) {
        var interceptorsQuantity = $this.i46_1;
        if (interceptorsQuantity === 0) {
            notSharedInterceptorsList($this, emptyList());
            return emptyList();
        }
        var phases = $this.h46_1;
        if (interceptorsQuantity === 1) {
            var inductionVariable = 0;
            var last = get_lastIndex_0(phases);
            if (inductionVariable <= last) $l$loop_0: do {
                var phaseIndex = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var tmp = phases.o(phaseIndex);
                var tmp1_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
                var tmp_0;
                if (tmp1_elvis_lhs == null) continue $l$loop_0;
                else tmp_0 = tmp1_elvis_lhs;
                var phaseContent = tmp_0;
                if (phaseContent.b3n()) continue $l$loop_0;
                var interceptors = phaseContent.d46();
                setInterceptorsListFromPhase($this, phaseContent);
                return interceptors;
            }while (!(phaseIndex === last));
        }
        // Inline function 'kotlin.collections.mutableListOf' call
        var destination = ArrayList_init_$Create$_0();
        var inductionVariable_0 = 0;
        var last_0 = get_lastIndex_0(phases);
        if (inductionVariable_0 <= last_0) $l$loop_1: do {
            var phaseIndex_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp_1 = phases.o(phaseIndex_0);
            var tmp3_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
            var tmp_2;
            if (tmp3_elvis_lhs == null) continue $l$loop_1;
            else tmp_2 = tmp3_elvis_lhs;
            var phase = tmp_2;
            phase.c46(destination);
        }while (!(phaseIndex_0 === last_0));
        notSharedInterceptorsList($this, destination);
        return destination;
    }
    function sharedInterceptorsList($this) {
        if (_get_interceptors__h4min7($this) == null) cacheInterceptors($this);
        $this.k46_1 = true;
        return ensureNotNull(_get_interceptors__h4min7($this));
    }
    function resetInterceptorsList($this) {
        _set_interceptors__wod97b($this, null);
        $this.k46_1 = false;
        $this.l46_1 = null;
    }
    function notSharedInterceptorsList($this, list) {
        _set_interceptors__wod97b($this, list);
        $this.k46_1 = false;
        $this.l46_1 = null;
    }
    function setInterceptorsListFromPhase($this, phaseContent) {
        _set_interceptors__wod97b($this, phaseContent.d46());
        $this.k46_1 = false;
        $this.l46_1 = phaseContent.w45_1;
    }
    function tryAddToPhaseFastPath($this, phase, block) {
        var currentInterceptors = _get_interceptors__h4min7($this);
        if ($this.h46_1.s() || currentInterceptors == null) return false;
        var tmp;
        if ($this.k46_1) tmp = true;
        else tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, KtMutableList) : false);
        if (tmp) return false;
        if (equals($this.l46_1, phase)) {
            currentInterceptors.e(block);
            return true;
        }
        if (equals(phase, last($this.h46_1)) || findPhaseIndex($this, phase) === get_lastIndex_0($this.h46_1)) {
            ensureNotNull(findPhase($this, phase)).b46(block);
            currentInterceptors.e(block);
            return true;
        }
        return false;
    }
    function Pipeline(phases) {
        this.f46_1 = AttributesJsFn(true);
        this.g46_1 = false;
        this.h46_1 = mutableListOf(phases.slice());
        this.i46_1 = 0;
        this.j46_1 = atomic$ref$1(null);
        this.k46_1 = false;
        this.l46_1 = null;
    }
    protoOf(Pipeline).m46 = function() {
        return this.g46_1;
    };
    protoOf(Pipeline).n46 = function(context, subject, $completion) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.b9();
        return createContext(this, context, subject, tmp$ret$0).u45(subject, $completion);
    };
    protoOf(Pipeline).p46 = function(reference, phase) {
        if (hasPhase(this, phase)) return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) throw new InvalidPhaseException("Phase " + reference.toString() + " was not registered for this pipeline");
        var lastRelatedPhaseIndex = index;
        var inductionVariable = index + 1 | 0;
        var last = get_lastIndex_0(this.h46_1);
        if (inductionVariable <= last) $l$loop_0: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.h46_1.o(i);
            var tmp1_safe_receiver = tmp instanceof PhaseContent ? tmp : null;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x45_1;
            var tmp_0;
            if (tmp2_elvis_lhs == null) break $l$loop_0;
            else tmp_0 = tmp2_elvis_lhs;
            var relation = tmp_0;
            var tmp3_safe_receiver = relation instanceof After ? relation : null;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.q46_1;
            var tmp_1;
            if (tmp4_elvis_lhs == null) continue $l$loop_0;
            else tmp_1 = tmp4_elvis_lhs;
            var relatedTo = tmp_1;
            lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
        }while (!(i === last));
        this.h46_1.k2(lastRelatedPhaseIndex + 1 | 0, PhaseContent_init_$Create$(phase, new After(reference)));
    };
    protoOf(Pipeline).r46 = function(reference, phase) {
        if (hasPhase(this, phase)) return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) throw new InvalidPhaseException("Phase " + reference.toString() + " was not registered for this pipeline");
        this.h46_1.k2(index, PhaseContent_init_$Create$(phase, new Before(reference)));
    };
    protoOf(Pipeline).s46 = function(phase, block) {
        var tmp0_elvis_lhs = findPhase(this, phase);
        var tmp;
        if (tmp0_elvis_lhs == null) throw new InvalidPhaseException("Phase " + phase.toString() + " was not registered for this pipeline");
        else tmp = tmp0_elvis_lhs;
        var phaseContent = tmp;
        if (typeof block !== "function") THROW_CCE();
        if (tryAddToPhaseFastPath(this, phase, block)) {
            this.i46_1 = this.i46_1 + 1 | 0;
            return Unit_instance;
        }
        phaseContent.b46(block);
        this.i46_1 = this.i46_1 + 1 | 0;
        resetInterceptorsList(this);
        this.t46();
    };
    protoOf(Pipeline).t46 = function() {};
    function PipelineContext(context) {
        this.o46_1 = context;
    }
    function pipelineContextFor(context, interceptors, subject, coroutineContext, debugMode) {
        debugMode = debugMode === VOID ? false : debugMode;
        var tmp;
        if (get_DISABLE_SFG() || debugMode) tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
        else tmp = new SuspendFunctionGun(subject, context, interceptors);
        return tmp;
    }
    function PipelinePhase(name) {
        this.e46_1 = name;
    }
    protoOf(PipelinePhase).toString = function() {
        return "Phase('" + this.e46_1 + "')";
    };
    function InvalidPhaseException(message) {
        extendThrowable(this, message);
        captureStack(this, InvalidPhaseException);
    }
    function After(relativeTo) {
        PipelinePhaseRelation.call(this);
        this.q46_1 = relativeTo;
    }
    function Before(relativeTo) {
        PipelinePhaseRelation.call(this);
        this.u46_1 = relativeTo;
    }
    function Last() {
        Last_instance = this;
        PipelinePhaseRelation.call(this);
    }
    var Last_instance;
    function Last_getInstance() {
        if (Last_instance == null) new Last();
        return Last_instance;
    }
    function PipelinePhaseRelation() {}
    function recoverStackTraceBridge(exception, continuation) {
        var tmp;
        try {
            tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var _ = $p;
                tmp_0 = exception;
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    }
    function loop($this, direct) {
        do {
            var currentIndex = $this.b47_1;
            if (currentIndex === $this.w46_1.m()) {
                if (!direct) {
                    // Inline function 'kotlin.Companion.success' call
                    var value = $this.y46_1;
                    var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
                    resumeRootWith($this, tmp$ret$0);
                    return false;
                }
                return true;
            }
            $this.b47_1 = currentIndex + 1 | 0;
            var next = $this.w46_1.o(currentIndex);
            try {
                var result = next($this, $this.y46_1, $this.x46_1);
                if (result === get_COROUTINE_SUSPENDED()) return false;
            } catch ($p) {
                if ($p instanceof Error) {
                    var cause = $p;
                    // Inline function 'kotlin.Companion.failure' call
                    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
                    resumeRootWith($this, tmp$ret$1);
                    return false;
                } else throw $p;
            }
        }while (true);
    }
    function resumeRootWith($this, result) {
        if ($this.a47_1 < 0) {
            // Inline function 'kotlin.error' call
            var message = "No more continuations to resume";
            throw IllegalStateException_init_$Create$(toString_1(message));
        }
        var next = ensureNotNull($this.z46_1[$this.a47_1]);
        var tmp1 = $this.a47_1;
        $this.a47_1 = tmp1 - 1 | 0;
        $this.z46_1[tmp1] = null;
        if (!_Result___get_isFailure__impl__jpiriv(result)) next.g9(result);
        else {
            var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
            next.g9(tmp$ret$0);
        }
    }
    function discardLastRootContinuation($this) {
        if ($this.a47_1 < 0) throw IllegalStateException_init_$Create$("No more continuations to resume");
        var tmp1 = $this.a47_1;
        $this.a47_1 = tmp1 - 1 | 0;
        $this.z46_1[tmp1] = null;
    }
    function SuspendFunctionGun$continuation$1(this$0) {
        this.d47_1 = this$0;
        this.c47_1 = -2147483648;
    }
    protoOf(SuspendFunctionGun$continuation$1).b9 = function() {
        var continuation = this.d47_1.z46_1[this.d47_1.a47_1];
        if (!(continuation === this) && !(continuation == null)) return continuation.b9();
        var index = this.d47_1.a47_1 - 1 | 0;
        while(index >= 0){
            var tmp0 = index;
            index = tmp0 - 1 | 0;
            var cont = this.d47_1.z46_1[tmp0];
            if (!(cont === this) && !(cont == null)) return cont.b9();
        }
        // Inline function 'kotlin.error' call
        var message = "Not started";
        throw IllegalStateException_init_$Create$(toString_1(message));
    };
    protoOf(SuspendFunctionGun$continuation$1).jf = function(result) {
        if (_Result___get_isFailure__impl__jpiriv(result)) {
            // Inline function 'kotlin.Companion.failure' call
            var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
            var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
            resumeRootWith(this.d47_1, tmp$ret$0);
            return Unit_instance;
        }
        loop(this.d47_1, false);
    };
    protoOf(SuspendFunctionGun$continuation$1).g9 = function(result) {
        return this.jf(result);
    };
    function SuspendFunctionGun(initial, context, blocks) {
        PipelineContext.call(this, context);
        this.w46_1 = blocks;
        var tmp = this;
        tmp.x46_1 = new SuspendFunctionGun$continuation$1(this);
        this.y46_1 = initial;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.w46_1.m();
        tmp_0.z46_1 = fillArrayVal(Array(size), null);
        this.a47_1 = -1;
        this.b47_1 = 0;
    }
    protoOf(SuspendFunctionGun).v1m = function() {
        return this.x46_1.b9();
    };
    protoOf(SuspendFunctionGun).r45 = function() {
        return this.y46_1;
    };
    protoOf(SuspendFunctionGun).t45 = function($completion) {
        var tmp$ret$0;
        $l$block_0: {
            // Inline function 'io.ktor.util.pipeline.SuspendFunctionGun.proceed.<anonymous>' call
            if (this.b47_1 === this.w46_1.m()) {
                tmp$ret$0 = this.y46_1;
                break $l$block_0;
            }
            this.e47(intercepted($completion));
            if (loop(this, true)) {
                discardLastRootContinuation(this);
                tmp$ret$0 = this.y46_1;
                break $l$block_0;
            }
            tmp$ret$0 = get_COROUTINE_SUSPENDED();
        }
        return tmp$ret$0;
    };
    protoOf(SuspendFunctionGun).s45 = function(subject, $completion) {
        this.y46_1 = subject;
        return this.t45($completion);
    };
    protoOf(SuspendFunctionGun).u45 = function(initial, $completion) {
        this.b47_1 = 0;
        if (this.b47_1 === this.w46_1.m()) return initial;
        this.y46_1 = initial;
        if (this.a47_1 >= 0) throw IllegalStateException_init_$Create$("Already started");
        return this.t45($completion);
    };
    protoOf(SuspendFunctionGun).e47 = function(continuation) {
        this.a47_1 = this.a47_1 + 1 | 0;
        this.z46_1[this.a47_1] = continuation;
    };
    function TypeInfo(type, reifiedType, kotlinType) {
        kotlinType = kotlinType === VOID ? null : kotlinType;
        this.f47_1 = type;
        this.g47_1 = reifiedType;
        this.h47_1 = kotlinType;
    }
    protoOf(TypeInfo).toString = function() {
        return "TypeInfo(type=" + toString_1(this.f47_1) + ", reifiedType=" + toString_1(this.g47_1) + ", kotlinType=" + toString(this.h47_1) + ")";
    };
    protoOf(TypeInfo).hashCode = function() {
        var result = this.f47_1.hashCode();
        result = imul(result, 31) + hashCode(this.g47_1) | 0;
        result = imul(result, 31) + (this.h47_1 == null ? 0 : hashCode(this.h47_1)) | 0;
        return result;
    };
    protoOf(TypeInfo).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof TypeInfo)) return false;
        var tmp0_other_with_cast = other instanceof TypeInfo ? other : THROW_CCE();
        if (!this.f47_1.equals(tmp0_other_with_cast.f47_1)) return false;
        if (!equals(this.g47_1, tmp0_other_with_cast.g47_1)) return false;
        if (!equals(this.h47_1, tmp0_other_with_cast.h47_1)) return false;
        return true;
    };
    function AttributesJsFn(concurrent) {
        concurrent = concurrent === VOID ? false : concurrent;
        return new AttributesJs();
    }
    function AttributesJs() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.i47_1 = LinkedHashMap_init_$Create$();
    }
    protoOf(AttributesJs).t41 = function(key) {
        var tmp = this.i47_1.e2(key);
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    };
    protoOf(AttributesJs).u41 = function(key) {
        return this.i47_1.c2(key);
    };
    protoOf(AttributesJs).v41 = function(key, value) {
        // Inline function 'kotlin.collections.set' call
        this.i47_1.m2(key, value);
    };
    protoOf(AttributesJs).w41 = function(key) {
        this.i47_1.n2(key);
    };
    protoOf(AttributesJs).x41 = function(key, block) {
        var tmp0_safe_receiver = this.i47_1.e2(key);
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
        // Inline function 'kotlin.also' call
        var this_0 = block();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.util.AttributesJs.computeIfAbsent.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        this.i47_1.m2(key, this_0);
        return this_0;
    };
    protoOf(AttributesJs).y41 = function() {
        return toList(this.i47_1.f2());
    };
    function unmodifiable(_this__u8e3s4) {
        return _this__u8e3s4;
    }
    function get_platform(_this__u8e3s4) {
        var tmp = typeof $hPtJY !== "undefined" && $hPtJY.versions != null && $hPtJY.versions.node != null || typeof window !== "undefined" && typeof window.process !== "undefined" && window.process.versions != null && window.process.versions.node != null;
        var hasNodeApi = (!(tmp == null) ? typeof tmp === "boolean" : false) ? tmp : THROW_CCE();
        return hasNodeApi ? Platform_Node_getInstance() : Platform_Browser_getInstance();
    }
    function get_isDevelopmentMode(_this__u8e3s4) {
        return false;
    }
    function get_isNewMemoryModel(_this__u8e3s4) {
        return true;
    }
    function GMTDate_0(timestamp) {
        timestamp = timestamp === VOID ? null : timestamp;
        var tmp1_safe_receiver = timestamp == null ? null : timestamp.p3();
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.util.date.GMTDate.<anonymous>' call
        tmp = new Date(tmp1_safe_receiver);
        var tmp2_elvis_lhs = tmp;
        var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
        if (isNaN_0(date.getTime())) throw new InvalidTimestampException(ensureNotNull(timestamp));
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.contracts.contract' call
        var dayOfWeek = Companion_instance_1.o44((date.getUTCDay() + 6 | 0) % 7 | 0);
        var month = Companion_instance_2.o44(date.getUTCMonth());
        return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek, date.getUTCDate(), date.getUTCFullYear(), month, date.getUTCFullYear(), numberToLong(date.getTime()));
    }
    function InvalidTimestampException(timestamp) {
        IllegalStateException_init_$Init$("Invalid date timestamp exception: " + timestamp.toString(), this);
        captureStack(this, InvalidTimestampException);
    }
    function KtorSimpleLogger(name) {
        return new KtorSimpleLogger$1();
    }
    function KtorSimpleLogger$1() {
        var tmp = this;
        var tmp_0;
        switch(PlatformUtils_getInstance().f43_1 || PlatformUtils_getInstance().e43_1){
            case true:
                // Inline function 'kotlin.Result.getOrNull' call
                // Inline function 'kotlin.runCatching' call
                var tmp_1;
                try {
                    // Inline function 'kotlin.Companion.success' call
                    // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
                    var tmp_2 = undefined;
                    var value = (tmp_2 == null ? true : typeof tmp_2 === "string") ? tmp_2 : THROW_CCE();
                    tmp_1 = _Result___init__impl__xyqfz8(value);
                } catch ($p) {
                    var tmp_3;
                    if ($p instanceof Error) {
                        var e = $p;
                        // Inline function 'kotlin.Companion.failure' call
                        tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
                    } else throw $p;
                    tmp_1 = tmp_3;
                }
                var this_0 = tmp_1;
                var tmp_4;
                if (_Result___get_isFailure__impl__jpiriv(this_0)) tmp_4 = null;
                else {
                    var tmp_5 = _Result___get_value__impl__bjfvqg(this_0);
                    tmp_4 = (tmp_5 == null ? true : !(tmp_5 == null)) ? tmp_5 : THROW_CCE();
                }
                var tmp1_safe_receiver = tmp_4;
                var tmp_6;
                if (tmp1_safe_receiver == null) tmp_6 = null;
                else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
                    var tmp$ret$6;
                    $l$block: {
                        // Inline function 'kotlin.collections.firstOrNull' call
                        var indexedObject = values_1();
                        var inductionVariable = 0;
                        var last = indexedObject.length;
                        while(inductionVariable < last){
                            var element = indexedObject[inductionVariable];
                            inductionVariable = inductionVariable + 1 | 0;
                            // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>.<anonymous>' call
                            if (element.p2_1 === tmp1_safe_receiver) {
                                tmp$ret$6 = element;
                                break $l$block;
                            }
                        }
                        tmp$ret$6 = null;
                    }
                    tmp_6 = tmp$ret$6;
                }
                var tmp2_elvis_lhs = tmp_6;
                tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
                break;
            case false:
                tmp_0 = LogLevel_TRACE_getInstance();
                break;
            default:
                noWhenBranchMatchedException();
                break;
        }
        tmp.j47_1 = tmp_0;
    }
    protoOf(KtorSimpleLogger$1).k47 = function(message) {
        if (this.j47_1.t2(LogLevel_TRACE_getInstance()) > 0) return Unit_instance;
        console.debug("TRACE: " + message);
    };
    var LogLevel_TRACE_instance;
    var LogLevel_DEBUG_instance;
    var LogLevel_INFO_instance;
    var LogLevel_WARN_instance;
    var LogLevel_ERROR_instance;
    var LogLevel_NONE_instance;
    function values_1() {
        return [
            LogLevel_TRACE_getInstance(),
            LogLevel_DEBUG_getInstance(),
            LogLevel_INFO_getInstance(),
            LogLevel_WARN_getInstance(),
            LogLevel_ERROR_getInstance(),
            LogLevel_NONE_getInstance()
        ];
    }
    var LogLevel_entriesInitialized;
    function LogLevel_initEntries() {
        if (LogLevel_entriesInitialized) return Unit_instance;
        LogLevel_entriesInitialized = true;
        LogLevel_TRACE_instance = new LogLevel("TRACE", 0);
        LogLevel_DEBUG_instance = new LogLevel("DEBUG", 1);
        LogLevel_INFO_instance = new LogLevel("INFO", 2);
        LogLevel_WARN_instance = new LogLevel("WARN", 3);
        LogLevel_ERROR_instance = new LogLevel("ERROR", 4);
        LogLevel_NONE_instance = new LogLevel("NONE", 5);
    }
    function LogLevel(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function LogLevel_TRACE_getInstance() {
        LogLevel_initEntries();
        return LogLevel_TRACE_instance;
    }
    function LogLevel_DEBUG_getInstance() {
        LogLevel_initEntries();
        return LogLevel_DEBUG_instance;
    }
    function LogLevel_INFO_getInstance() {
        LogLevel_initEntries();
        return LogLevel_INFO_instance;
    }
    function LogLevel_WARN_getInstance() {
        LogLevel_initEntries();
        return LogLevel_WARN_instance;
    }
    function LogLevel_ERROR_getInstance() {
        LogLevel_initEntries();
        return LogLevel_ERROR_instance;
    }
    function LogLevel_NONE_getInstance() {
        LogLevel_initEntries();
        return LogLevel_NONE_instance;
    }
    function get_DISABLE_SFG() {
        return DISABLE_SFG;
    }
    var DISABLE_SFG;
    function withCause(_this__u8e3s4, cause) {
        return _this__u8e3s4;
    }
    function instanceOf(_this__u8e3s4, type) {
        return type.ga(_this__u8e3s4);
    }
    function typeInfoImpl(reifiedType, kClass, kType) {
        return new TypeInfo(kClass, reifiedType, kType);
    }
    function JsType() {}
    var JsType_instance;
    function JsType_getInstance() {
        return JsType_instance;
    }
    //region block: post-declaration
    protoOf(AttributesJs).s41 = get;
    //endregion
    //region block: init
    Companion_instance_1 = new Companion_0();
    Companion_instance_2 = new Companion_1();
    DISABLE_SFG = false;
    JsType_instance = new JsType();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = toByteArray;
    _.$_$.b = JsType_instance;
    _.$_$.c = PlatformUtils_getInstance;
    _.$_$.d = CopyOnWriteHashMap;
    _.$_$.e = GMTDate_0;
    _.$_$.f = LockFreeLinkedListNode;
    _.$_$.g = KtorSimpleLogger;
    _.$_$.h = PipelineContext;
    _.$_$.i = PipelinePhase;
    _.$_$.j = Pipeline;
    _.$_$.k = instanceOf;
    _.$_$.l = typeInfoImpl;
    _.$_$.m = AttributeKey;
    _.$_$.n = AttributesJsFn;
    _.$_$.o = SilentSupervisor;
    _.$_$.p = forEach;
    _.$_$.q = get_0;
    _.$_$.r = StringValuesBuilderImpl;
    _.$_$.s = StringValuesImpl;
    _.$_$.t = StringValues;
    _.$_$.u = appendAll;
    _.$_$.v = isLowerCase;
    _.$_$.w = get_platform;
    _.$_$.x = putAll;
    _.$_$.y = toCharArray;
    _.$_$.z = toLowerCasePreservingASCIIRules;
    //endregion
    return _;
});

});
parcelRegister("4cHl4", function(module, exports) {



(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./88b0986a7186d029-atomicfu-js-ir.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("k4lEE")), (parcelRequire("ctZcf")));
})(globalThis, function(_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var toString = kotlin_kotlin.$_$.ob;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var toLong = kotlin_kotlin.$_$.mb;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var Long = kotlin_kotlin.$_$.ne;
    var VOID = kotlin_kotlin.$_$.f;
    var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
    var atomic$long$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.c;
    var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var CancellationException_init_$Create$ = kotlin_kotlin.$_$.c1;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var CancellationException = kotlin_kotlin.$_$.y8;
    var CancellationException_init_$Init$ = kotlin_kotlin.$_$.b1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.o4;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var cancel$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f;
    var invokeOnCompletion$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g;
    var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
    var Key_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
    var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
    var isInterface = kotlin_kotlin.$_$.xa;
    var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
    var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
    var equals = kotlin_kotlin.$_$.ba;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.g1;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var hashCode = kotlin_kotlin.$_$.ha;
    var toString_0 = kotlin_kotlin.$_$.sd;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var Exception = kotlin_kotlin.$_$.ke;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.m1;
    var numberToChar = kotlin_kotlin.$_$.hb;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var coerceAtMost = kotlin_kotlin.$_$.tb;
    var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x2;
    var toByte = kotlin_kotlin.$_$.lb;
    var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.f4;
    var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
    var toShort = kotlin_kotlin.$_$.nb;
    var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.e4;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var isLowSurrogate = kotlin_kotlin.$_$.wc;
    var isHighSurrogate = kotlin_kotlin.$_$.vc;
    var Job_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
    var coerceAtMost_0 = kotlin_kotlin.$_$.sb;
    var toString_1 = kotlin_kotlin.$_$.vf;
    var lazy = kotlin_kotlin.$_$.qf;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.c2;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var replace = kotlin_kotlin.$_$.dd;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var extendThrowable = kotlin_kotlin.$_$.ca;
    var charSequenceSubSequence = kotlin_kotlin.$_$.y9;
    var IndexOutOfBoundsException_init_$Create$_0 = kotlin_kotlin.$_$.b2;
    var Exception_init_$Init$_0 = kotlin_kotlin.$_$.o1;
    var isCharSequence = kotlin_kotlin.$_$.ta;
    var trim = kotlin_kotlin.$_$.ae;
    var decodeToString = kotlin_kotlin.$_$.mc;
    var setOf = kotlin_kotlin.$_$.c8;
    var fillArrayVal = kotlin_kotlin.$_$.da;
    //endregion
    //region block: pre-declaration
    initMetadataForCoroutine($awaitAtLeastNBytesAvailableForWriteCOROUTINE$0, CoroutineImpl);
    initMetadataForCoroutine($awaitAtLeastNBytesAvailableForReadCOROUTINE$1, CoroutineImpl);
    initMetadataForCoroutine($writeFullyCOROUTINE$9, CoroutineImpl);
    initMetadataForCoroutine($writeFullyCOROUTINE$10, CoroutineImpl);
    initMetadataForCoroutine($readRemainingCOROUTINE$26, CoroutineImpl);
    initMetadataForCoroutine($readRemainingSuspendCOROUTINE$27, CoroutineImpl);
    initMetadataForCoroutine($readAvailableCOROUTINE$30, CoroutineImpl);
    initMetadataForCoroutine($readAvailableCOROUTINE$33, CoroutineImpl);
    initMetadataForCoroutine($awaitInternalAtLeast1COROUTINE$38, CoroutineImpl);
    initMetadataForCoroutine($awaitSuspendCOROUTINE$39, CoroutineImpl);
    function readRemaining$default(limit, $completion, $super) {
        limit = limit === VOID ? new Long(-1, 2147483647) : limit;
        return $super === VOID ? this.h3t(limit, $completion) : $super.h3t.call(this, limit, $completion);
    }
    initMetadataForInterface(ByteReadChannel_1, "ByteReadChannel", VOID, VOID, VOID, [
        3,
        1,
        2,
        0,
        5
    ]);
    initMetadataForClass(ByteChannelSequentialBase, "ByteChannelSequentialBase", VOID, VOID, [
        ByteReadChannel_1
    ], [
        1,
        3,
        0,
        2,
        5
    ]);
    initMetadataForClass(ClosedWriteChannelException, "ClosedWriteChannelException", VOID, CancellationException);
    initMetadataForClass(CloseElement, "CloseElement");
    initMetadataForInterface(WriterScope, "WriterScope", VOID, VOID, [
        CoroutineScope
    ]);
    initMetadataForClass(ChannelJob, "ChannelJob", VOID, VOID, [
        Job
    ], [
        0
    ]);
    initMetadataForClass(ChannelScope, "ChannelScope", VOID, VOID, [
        CoroutineScope,
        WriterScope
    ]);
    initMetadataForLambda(launchChannel$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForClass(Buffer, "Buffer");
    initMetadataForClass(InsufficientSpaceException, "InsufficientSpaceException", InsufficientSpaceException, Exception);
    initMetadataForClass(DefaultPool, "DefaultPool");
    initMetadataForClass(DefaultBufferPool, "DefaultBufferPool", DefaultBufferPool, DefaultPool);
    initMetadataForClass(Output, "Output");
    initMetadataForClass(BytePacketBuilder, "BytePacketBuilder", BytePacketBuilder, Output);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(Input, "Input");
    initMetadataForClass(ByteReadPacket, "ByteReadPacket", VOID, Input);
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(ChunkBuffer$Companion$EmptyPool$1);
    initMetadataForClass(NoPoolImpl, "NoPoolImpl");
    initMetadataForClass(ChunkBuffer$Companion$NoPool$1, VOID, VOID, NoPoolImpl);
    initMetadataForClass(ChunkBuffer$Companion$NoPoolManuallyManaged$1, VOID, VOID, NoPoolImpl);
    initMetadataForCompanion(Companion_2);
    initMetadataForClass(ChunkBuffer, "ChunkBuffer", VOID, Buffer);
    initMetadataForClass(MalformedUTF8InputException, "MalformedUTF8InputException", VOID, Exception);
    initMetadataForCoroutine($sleepCOROUTINE$52, CoroutineImpl);
    initMetadataForCoroutine($trySuspendCOROUTINE$53, CoroutineImpl);
    initMetadataForClass(AwaitingSlot, "AwaitingSlot", AwaitingSlot, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($copyToSequentialImplCOROUTINE$54, CoroutineImpl);
    initMetadataForCoroutine($copyToTailCOROUTINE$55, CoroutineImpl);
    initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
    initMetadataForClass(ByteChannelJS, "ByteChannelJS", VOID, ByteChannelSequentialBase, VOID, [
        3,
        1,
        0,
        2,
        5
    ]);
    initMetadataForCompanion(Companion_3);
    initMetadataForObject(DefaultAllocator, "DefaultAllocator");
    initMetadataForCompanion(Companion_4);
    initMetadataForClass(Memory, "Memory");
    initMetadataForCompanion(Companion_5);
    initMetadataForClass(Charset, "Charset");
    initMetadataForObject(Charsets, "Charsets");
    initMetadataForClass(MalformedInputException, "MalformedInputException", VOID, Error);
    initMetadataForClass(CharsetDecoder, "CharsetDecoder");
    initMetadataForClass(CharsetEncoder, "CharsetEncoder");
    initMetadataForClass(CharsetImpl, "CharsetImpl", VOID, Charset);
    initMetadataForClass(CharsetEncoderImpl, "CharsetEncoderImpl", VOID, CharsetEncoder);
    initMetadataForClass(CharsetDecoderImpl, "CharsetDecoderImpl", VOID, CharsetDecoder);
    initMetadataForClass(DecodeBufferResult, "DecodeBufferResult");
    initMetadataForClass(IOException, "IOException", VOID, Exception);
    initMetadataForClass(EOFException, "EOFException", VOID, IOException);
    initMetadataForClass(toKtor$1);
    initMetadataForClass(TextDecoderFallback, "TextDecoderFallback");
    //endregion
    function ByteReadChannel(content) {
        return ByteReadChannel_0(content, 0, content.length);
    }
    function _get_isCancelled__nhbn6y($this) {
        var tmp0_safe_receiver = $this.i3m_1.kotlinx$atomicfu$value;
        return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q3m_1) == null);
    }
    function flushImpl($this) {
        if ($this.j3m_1.b3n()) {
            $this.n3m_1.s3m();
            return false;
        }
        flushWrittenBytes($this);
        $this.n3m_1.s3m();
        return true;
    }
    function flushWrittenBytes($this) {
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        $this.o3m_1;
        // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.flushWrittenBytes.<anonymous>' call
        var size = $this.j3m_1.m();
        var buffer = ensureNotNull($this.j3m_1.k3n());
        $this.p3m_1.l3n(buffer);
        $this.g3m_1.atomicfu$addAndGet(size);
    }
    function ensureNotClosed($this) {
        if ($this.n3n()) {
            var tmp0_elvis_lhs = $this.m3n();
            throw tmp0_elvis_lhs == null ? new ClosedWriteChannelException("Channel " + toString($this) + " is already closed") : tmp0_elvis_lhs;
        }
    }
    function ensureNotFailed($this) {
        var tmp0_safe_receiver = $this.m3n();
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        throw tmp0_safe_receiver;
    }
    function ensureNotFailed_0($this, closeable) {
        var tmp0_safe_receiver = $this.m3n();
        if (tmp0_safe_receiver == null) ;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            closeable.e19();
            throw tmp0_safe_receiver;
        }
    }
    function readRemainingSuspend($this, builder, limit, $completion) {
        var tmp = new $readRemainingSuspendCOROUTINE$27($this, builder, limit, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function addBytesRead($this, count) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(count >= 0)) {
            // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
            var message = "Can't read negative amount of bytes: " + count;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
        $this.h3m_1.atomicfu$getAndAdd(-count | 0);
        $this.e3m_1.atomicfu$addAndGet$long(toLong(count));
        // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
        $this.g3m_1.atomicfu$getAndAdd(-count | 0);
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!($this.h3m_1.kotlinx$atomicfu$value >= 0)) {
            // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
            var message_0 = "Readable bytes count is negative: " + $this.a3o() + ", " + count + " in " + toString($this);
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!($this.a3o() >= 0)) {
            // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
            var message_1 = "Readable bytes count is negative: " + $this.a3o() + ", " + count + " in " + toString($this);
            throw IllegalStateException_init_$Create$(toString(message_1));
        }
    }
    function addBytesWritten($this, count) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(count >= 0)) {
            // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesWritten.<anonymous>' call
            var message = "Can't write negative amount of bytes: " + count;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlinx.atomicfu.AtomicInt.plusAssign' call
        $this.h3m_1.atomicfu$getAndAdd(count);
        $this.f3m_1.atomicfu$addAndGet$long(toLong(count));
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!($this.h3m_1.kotlinx$atomicfu$value >= 0)) {
            // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesWritten.<anonymous>' call
            var message_0 = "Readable bytes count is negative: " + $this.h3m_1.kotlinx$atomicfu$value + ", " + count + " in " + toString($this);
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
    }
    function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this$0, $count) {
        return function() {
            return this$0.b3o() < $count && !this$0.n3n();
        };
    }
    function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this$0, $count) {
        return function() {
            return this$0.a3o() < $count && !this$0.c3o();
        };
    }
    function $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(_this__u8e3s4, count, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.l3o_1 = _this__u8e3s4;
        this.m3o_1 = count;
    }
    protoOf($awaitAtLeastNBytesAvailableForWriteCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!(this.l3o_1.b3o() < this.m3o_1 && !this.l3o_1.n3n())) {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                    if (!flushImpl(this.l3o_1)) {
                        this.v8_1 = 2;
                        suspendResult = this.l3o_1.n3m_1.n3o(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this.l3o_1, this.m3o_1), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 2:
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.v8_1 = 1;
                    continue $sm;
                case 4:
                    throw this.y8_1;
                case 5:
                    return Unit_instance;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(_this__u8e3s4, count, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.w3o_1 = _this__u8e3s4;
        this.x3o_1 = count;
    }
    protoOf($awaitAtLeastNBytesAvailableForReadCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!(this.w3o_1.a3o() < this.x3o_1 && !this.w3o_1.c3o())) {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                    this.v8_1 = 2;
                    suspendResult = this.w3o_1.n3m_1.n3o(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this.w3o_1, this.x3o_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    throw this.y8_1;
                case 4:
                    return Unit_instance;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $writeFullyCOROUTINE$9(_this__u8e3s4, src, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.g3p_1 = _this__u8e3s4;
        this.h3p_1 = src;
    }
    protoOf($writeFullyCOROUTINE$9).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.g3p_1.i3p(1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var this_0 = this.h3p_1;
                    var count = this_0.l3p_1 - this_0.k3p_1 | 0;
                    writeFully_2(this.g3p_1.j3m_1, this.h3p_1);
                    this.g3p_1.p3p(count);
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $writeFullyCOROUTINE$10(_this__u8e3s4, src, offset, length, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.y3p_1 = _this__u8e3s4;
        this.z3p_1 = src;
        this.a3q_1 = offset;
        this.b3q_1 = length;
    }
    protoOf($writeFullyCOROUTINE$10).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.c3q_1 = this.a3q_1;
                    this.d3q_1 = this.a3q_1 + this.b3q_1 | 0;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!(this.c3q_1 < this.d3q_1)) {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                    this.v8_1 = 2;
                    suspendResult = this.y3p_1.i3p(1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var a = this.y3p_1.b3o();
                    var b = this.d3q_1 - this.c3q_1 | 0;
                    var bytesCount = Math.min(a, b);
                    writeFully_3(this.y3p_1.j3m_1, this.z3p_1, this.c3q_1, bytesCount);
                    this.c3q_1 = this.c3q_1 + bytesCount | 0;
                    this.y3p_1.p3p(bytesCount);
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    return Unit_instance;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $readRemainingCOROUTINE$26(_this__u8e3s4, limit, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m3q_1 = _this__u8e3s4;
        this.n3q_1 = limit;
    }
    protoOf($readRemainingCOROUTINE$26).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    ensureNotFailed(this.m3q_1);
                    this.o3q_1 = new BytePacketBuilder();
                    var tmp_0 = this;
                    var a = this.n3q_1;
                    var b = this.m3q_1.k3m_1.z3q();
                    tmp_0.p3q_1 = a.j1(b) <= 0 ? a : b;
                    this.o3q_1.a3r(this.m3q_1.k3m_1, this.p3q_1);
                    this.m3q_1.b3r(this.p3q_1.l1());
                    var tmp_1 = this;
                    var this_0 = this.n3q_1;
                    var other = this.o3q_1.m();
                    tmp_1.q3q_1 = this_0.z2(toLong(other));
                    if (this.q3q_1.equals(new Long(0, 0)) || this.m3q_1.c3o()) {
                        var tmp_2 = this;
                        ensureNotFailed_0(this.m3q_1, this.o3q_1);
                        tmp_2.r3q_1 = this.o3q_1.c3r();
                        this.v8_1 = 2;
                        continue $sm;
                    } else {
                        this.v8_1 = 1;
                        suspendResult = readRemainingSuspend(this.m3q_1, this.o3q_1, this.n3q_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 1:
                    this.r3q_1 = suspendResult;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    return this.r3q_1;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $readRemainingSuspendCOROUTINE$27(_this__u8e3s4, builder, limit, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.w3n_1 = _this__u8e3s4;
        this.x3n_1 = builder;
        this.y3n_1 = limit;
    }
    protoOf($readRemainingSuspendCOROUTINE$27).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!(toLong(this.x3n_1.m()).j1(this.y3n_1) < 0)) {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                    var tmp_0 = this;
                    var this_0 = this.y3n_1;
                    var other = this.x3n_1.m();
                    var a = this_0.z2(toLong(other));
                    var b = this.w3n_1.k3m_1.z3q();
                    tmp_0.z3n_1 = a.j1(b) <= 0 ? a : b;
                    this.x3n_1.a3r(this.w3n_1.k3m_1, this.z3n_1);
                    this.w3n_1.b3r(this.z3n_1.l1());
                    ensureNotFailed_0(this.w3n_1, this.x3n_1);
                    if (this.w3n_1.c3o() || this.x3n_1.m() === this.y3n_1.l1()) {
                        this.v8_1 = 4;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.v8_1 = 3;
                    suspendResult = this.w3n_1.d3r(1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    this.v8_1 = 1;
                    continue $sm;
                case 4:
                    ensureNotFailed_0(this.w3n_1, this.x3n_1);
                    return this.x3n_1.c3r();
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $readAvailableCOROUTINE$30(_this__u8e3s4, dst, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m3r_1 = _this__u8e3s4;
        this.n3r_1 = dst;
    }
    protoOf($readAvailableCOROUTINE$30).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp0_safe_receiver = this.m3r_1.m3n();
                    if (tmp0_safe_receiver == null) ;
                    else throw tmp0_safe_receiver;
                    if (this.m3r_1.n3n() && this.m3r_1.a3o() === 0) return -1;
                    var this_0 = this.n3r_1;
                    if ((this_0.n3p_1 - this_0.l3p_1 | 0) === 0) return 0;
                    if (this.m3r_1.a3o() === 0) {
                        this.v8_1 = 1;
                        suspendResult = this.m3r_1.d3r(1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    if (!this.m3r_1.k3m_1.p3r()) this.m3r_1.o3r();
                    var this_1 = this.n3r_1;
                    var a = toLong(this_1.n3p_1 - this_1.l3p_1 | 0);
                    var b = this.m3r_1.k3m_1.z3q();
                    var size = (a.j1(b) <= 0 ? a : b).l1();
                    readFully_2(this.m3r_1.k3m_1, this.n3r_1, size);
                    this.m3r_1.b3r(size);
                    return size;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $readAvailableCOROUTINE$33(_this__u8e3s4, dst, offset, length, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.y3r_1 = _this__u8e3s4;
        this.z3r_1 = dst;
        this.a3s_1 = offset;
        this.b3s_1 = length;
    }
    protoOf($readAvailableCOROUTINE$33).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp0_safe_receiver = this.y3r_1.m3n();
                    if (tmp0_safe_receiver == null) ;
                    else throw tmp0_safe_receiver;
                    if (this.y3r_1.n3n() && this.y3r_1.a3o() === 0) return -1;
                    if (this.b3s_1 === 0) return 0;
                    if (this.y3r_1.a3o() === 0) {
                        this.v8_1 = 1;
                        suspendResult = this.y3r_1.d3r(1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    if (!this.y3r_1.k3m_1.p3r()) this.y3r_1.o3r();
                    var a = toLong(this.b3s_1);
                    var b = this.y3r_1.k3m_1.z3q();
                    var size = (a.j1(b) <= 0 ? a : b).l1();
                    readFully_1(this.y3r_1.k3m_1, this.z3r_1, this.a3s_1, size);
                    this.y3r_1.b3r(size);
                    return size;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $awaitInternalAtLeast1COROUTINE$38(_this__u8e3s4, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.k3s_1 = _this__u8e3s4;
    }
    protoOf($awaitInternalAtLeast1COROUTINE$38).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    if (!this.k3s_1.k3m_1.m3s()) {
                        var tmp_0 = this;
                        tmp_0.l3s_1 = true;
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        this.v8_1 = 1;
                        suspendResult = this.k3s_1.d3r(1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 1:
                    this.l3s_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    throw this.y8_1;
                case 3:
                    return this.l3s_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $awaitSuspendCOROUTINE$39(_this__u8e3s4, atLeast, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v3s_1 = _this__u8e3s4;
        this.w3s_1 = atLeast;
    }
    protoOf($awaitSuspendCOROUTINE$39).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    if (!(this.w3s_1 >= 0)) {
                        var message = "Failed requirement.";
                        throw IllegalArgumentException_init_$Create$(toString(message));
                    }
                    this.v8_1 = 1;
                    suspendResult = this.v3s_1.x3s(this.w3s_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.v3s_1.o3r();
                    var tmp0_safe_receiver = this.v3s_1.m3n();
                    if (tmp0_safe_receiver == null) ;
                    else throw tmp0_safe_receiver;
                    return !this.v3s_1.c3o() && this.v3s_1.a3o() >= this.w3s_1;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function ByteChannelSequentialBase(initial, autoFlush, pool) {
        pool = pool === VOID ? Companion_getInstance_2().c3t() : pool;
        this.c3m_1 = autoFlush;
        this.d3m_1 = atomic$ref$1(Companion_getInstance_2().z3s_1);
        this.e3m_1 = atomic$long$1(new Long(0, 0));
        this.f3m_1 = atomic$long$1(new Long(0, 0));
        this.g3m_1 = atomic$int$1(0);
        this.h3m_1 = atomic$int$1(0);
        this.i3m_1 = atomic$ref$1(null);
        this.j3m_1 = new BytePacketBuilder(pool);
        this.k3m_1 = ByteReadPacket_init_$Create$(initial, pool);
        this.l3m_1 = atomic$int$1(0);
        this.m3m_1 = atomic$ref$1(Companion_getInstance_2().z3s_1);
        this.n3m_1 = new AwaitingSlot();
        this.o3m_1 = new Object();
        this.p3m_1 = new BytePacketBuilder();
        var count = remainingAll(initial).l1();
        this.p3p(count);
        this.g3m_1.atomicfu$addAndGet(count);
    }
    protoOf(ByteChannelSequentialBase).d3t = function() {
        return this.c3m_1;
    };
    protoOf(ByteChannelSequentialBase).n3n = function() {
        return !(this.i3m_1.kotlinx$atomicfu$value == null);
    };
    protoOf(ByteChannelSequentialBase).a3o = function() {
        return this.g3m_1.kotlinx$atomicfu$value;
    };
    protoOf(ByteChannelSequentialBase).b3o = function() {
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = 4088 - this.h3m_1.kotlinx$atomicfu$value | 0;
        return Math.max(0, b);
    };
    protoOf(ByteChannelSequentialBase).c3o = function() {
        return _get_isCancelled__nhbn6y(this) || this.n3n() && this.h3m_1.kotlinx$atomicfu$value === 0;
    };
    protoOf(ByteChannelSequentialBase).m3n = function() {
        var tmp0_safe_receiver = this.i3m_1.kotlinx$atomicfu$value;
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q3m_1;
    };
    protoOf(ByteChannelSequentialBase).i3p = function(count, $completion) {
        var tmp = new $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(this, count, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).x3s = function(count, $completion) {
        var tmp = new $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(this, count, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).e3t = function() {
        flushImpl(this);
    };
    protoOf(ByteChannelSequentialBase).o3r = function() {
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.o3m_1;
        // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.prepareFlushedBytes.<anonymous>' call
        unsafeAppend(this.k3m_1, this.p3m_1);
    };
    protoOf(ByteChannelSequentialBase).f3t = function(src, $completion) {
        var tmp = new $writeFullyCOROUTINE$9(this, src, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).g3t = function(src, offset, length, $completion) {
        var tmp = new $writeFullyCOROUTINE$10(this, src, offset, length, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).b3r = function(count) {
        addBytesRead(this, count);
        this.n3m_1.s3m();
    };
    protoOf(ByteChannelSequentialBase).h3t = function(limit, $completion) {
        var tmp = new $readRemainingCOROUTINE$26(this, limit, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).j3t = function(dst, $completion) {
        return this.k3t(dst instanceof Buffer ? dst : THROW_CCE(), $completion);
    };
    protoOf(ByteChannelSequentialBase).k3t = function(dst, $completion) {
        var tmp = new $readAvailableCOROUTINE$30(this, dst, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).l3t = function(dst, offset, length, $completion) {
        var tmp = new $readAvailableCOROUTINE$33(this, dst, offset, length, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).m3t = function($completion) {
        var tmp = new $awaitInternalAtLeast1COROUTINE$38(this, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).d3r = function(atLeast, $completion) {
        var tmp = new $awaitSuspendCOROUTINE$39(this, atLeast, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ByteChannelSequentialBase).p1r = function(cause) {
        if (!(this.m3n() == null) || this.n3n()) return false;
        return this.j21(cause == null ? CancellationException_init_$Create$("Channel cancelled") : cause);
    };
    protoOf(ByteChannelSequentialBase).j21 = function(cause) {
        var closeElement = cause == null ? get_CLOSED_SUCCESS() : new CloseElement(cause);
        if (!this.i3m_1.atomicfu$compareAndSet(null, closeElement)) return false;
        if (!(cause == null)) {
            this.k3m_1.e19();
            this.j3m_1.e19();
            this.p3m_1.e19();
        } else {
            this.e3t();
            this.j3m_1.e19();
        }
        this.n3m_1.n3t(cause);
        return true;
    };
    protoOf(ByteChannelSequentialBase).o3t = function(dst, limit) {
        var size = this.k3m_1.z3q();
        var tmp;
        if (size.j1(limit) <= 0) {
            dst.j3m_1.p3t(this.k3m_1);
            dst.p3p(size.l1());
            this.b3r(size.l1());
            tmp = size;
        } else tmp = new Long(0, 0);
        return tmp;
    };
    protoOf(ByteChannelSequentialBase).p3p = function(count) {
        addBytesWritten(this, count);
        if (this.n3n()) {
            this.j3m_1.e19();
            ensureNotClosed(this);
        }
        if (this.d3t() || this.b3o() === 0) this.e3t();
    };
    function cancel(_this__u8e3s4) {
        return _this__u8e3s4.p1r(null);
    }
    function readAvailable(_this__u8e3s4, dst, $completion) {
        return _this__u8e3s4.l3t(dst, 0, dst.length, $completion);
    }
    function close(_this__u8e3s4) {
        return _this__u8e3s4.j21(null);
    }
    function ClosedWriteChannelException(message) {
        CancellationException_init_$Init$(message, this);
        captureStack(this, ClosedWriteChannelException);
    }
    function writeFully(_this__u8e3s4, src, $completion) {
        return _this__u8e3s4.g3t(src, 0, src.length, $completion);
    }
    function get_CLOSED_SUCCESS() {
        _init_properties_CloseElement_kt__5e72ik();
        return CLOSED_SUCCESS;
    }
    var CLOSED_SUCCESS;
    function CloseElement(cause) {
        this.q3m_1 = cause;
    }
    var properties_initialized_CloseElement_kt_clkism;
    function _init_properties_CloseElement_kt__5e72ik() {
        if (!properties_initialized_CloseElement_kt_clkism) {
            properties_initialized_CloseElement_kt_clkism = true;
            CLOSED_SUCCESS = new CloseElement(null);
        }
    }
    function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
        coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
        autoFlush = autoFlush === VOID ? false : autoFlush;
        return launchChannel(_this__u8e3s4, coroutineContext, ByteChannel(autoFlush), true, block);
    }
    function WriterScope() {}
    function ChannelJob(delegate, channel) {
        this.r3t_1 = delegate;
        this.s3t_1 = channel;
    }
    protoOf(ChannelJob).v1x = function() {
        return this.s3t_1;
    };
    protoOf(ChannelJob).w1m = function() {
        return this.r3t_1.w1m();
    };
    protoOf(ChannelJob).a1 = function() {
        return this.r3t_1.a1();
    };
    protoOf(ChannelJob).i1o = function(child) {
        return this.r3t_1.i1o(child);
    };
    protoOf(ChannelJob).b1o = function(cause) {
        this.r3t_1.b1o(cause);
    };
    protoOf(ChannelJob).uf = function(initial, operation) {
        return this.r3t_1.uf(initial, operation);
    };
    protoOf(ChannelJob).i9 = function(key) {
        return this.r3t_1.i9(key);
    };
    protoOf(ChannelJob).t1n = function() {
        return this.r3t_1.t1n();
    };
    protoOf(ChannelJob).x1n = function(onCancelling, invokeImmediately, handler) {
        return this.r3t_1.x1n(onCancelling, invokeImmediately, handler);
    };
    protoOf(ChannelJob).w1n = function(handler) {
        return this.r3t_1.w1n(handler);
    };
    protoOf(ChannelJob).tf = function(key) {
        return this.r3t_1.tf(key);
    };
    protoOf(ChannelJob).vf = function(context) {
        return this.r3t_1.vf(context);
    };
    protoOf(ChannelJob).r1n = function() {
        return this.r3t_1.r1n();
    };
    protoOf(ChannelJob).toString = function() {
        return "ChannelJob[" + toString(this.r3t_1) + "]";
    };
    function launchChannel(_this__u8e3s4, context, channel, attachJob, block) {
        var dispatcher = _this__u8e3s4.v1m().i9(Key_getInstance());
        var job = launch(_this__u8e3s4, context, VOID, launchChannel$slambda_0(attachJob, channel, block, dispatcher, null));
        job.w1n(launchChannel$lambda(channel));
        return new ChannelJob(job, channel);
    }
    function ChannelScope(delegate, channel) {
        this.t3t_1 = channel;
        this.u3t_1 = delegate;
    }
    protoOf(ChannelScope).v1x = function() {
        return this.t3t_1;
    };
    protoOf(ChannelScope).v1m = function() {
        return this.u3t_1.v1m();
    };
    function launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation) {
        this.d3u_1 = $attachJob;
        this.e3u_1 = $channel;
        this.f3u_1 = $block;
        this.g3u_1 = $dispatcher;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(launchChannel$slambda).j3u = function($this$launch, $completion) {
        var tmp = this.e2b($this$launch, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(launchChannel$slambda).y9 = function(p1, $completion) {
        return this.j3u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(launchChannel$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    if (this.d3u_1) this.e3u_1.q3t(ensureNotNull(this.h3u_1.v1m().i9(Key_instance)));
                    var tmp_0 = this;
                    var tmp_1 = new ChannelScope(this.h3u_1, this.e3u_1);
                    tmp_0.i3u_1 = isInterface(tmp_1, CoroutineScope) ? tmp_1 : THROW_CCE();
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.f3u_1(this.i3u_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_2 = this.y8_1;
                    if (tmp_2 instanceof Error) {
                        var cause = this.y8_1;
                        if (!equals(this.g3u_1, Dispatchers_getInstance().f1x_1) && !(this.g3u_1 == null)) throw cause;
                        this.e3u_1.p1r(cause);
                        this.v8_1 = 4;
                        continue $sm;
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    return Unit_instance;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(launchChannel$slambda).e2b = function($this$launch, completion) {
        var i = new launchChannel$slambda(this.d3u_1, this.e3u_1, this.f3u_1, this.g3u_1, completion);
        i.h3u_1 = $this$launch;
        return i;
    };
    function launchChannel$slambda_0($attachJob, $channel, $block, $dispatcher, resultContinuation) {
        var i = new launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation);
        var l = function($this$launch, $completion) {
            return i.j3u($this$launch, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function launchChannel$lambda($channel) {
        return function(cause) {
            $channel.j21(cause);
            return Unit_instance;
        };
    }
    function unwrapCancellationException(_this__u8e3s4) {
        var exception = _this__u8e3s4;
        $l$loop: while(exception instanceof CancellationException){
            if (equals(exception, exception.cause)) return _this__u8e3s4;
            var tmp0_elvis_lhs = exception.cause;
            var tmp;
            if (tmp0_elvis_lhs == null) return exception;
            else tmp = tmp0_elvis_lhs;
            exception = tmp;
        }
        return exception;
    }
    function decode(_this__u8e3s4, input, max) {
        max = max === VOID ? 2147483647 : max;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.comparisons.minOf' call
        var a = toLong(max);
        var b = sizeEstimate(input);
        var capacity = (a.j1(b) <= 0 ? a : b).l1();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$(capacity);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
        decode_0(_this__u8e3s4, input, this_0, max);
        return this_0.toString();
    }
    function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
        var start = fromIndex;
        if (start >= toIndex) return 0;
        var bytesWritten = 0;
        // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
        var tail = prepareWriteHead(destination, 1, null);
        try {
            var size;
            $l$loop: while(true){
                // Inline function 'io.ktor.utils.io.charsets.encodeToImpl.<anonymous>' call
                var view = tail;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                var before = view.n3p_1 - view.l3p_1 | 0;
                var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, view);
                // Inline function 'kotlin.check' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlin.check' call
                // Inline function 'kotlin.contracts.contract' call
                if (!(rc >= 0)) {
                    // Inline function 'kotlin.check.<anonymous>' call
                    var message = "Check failed.";
                    throw IllegalStateException_init_$Create$(toString(message));
                }
                start = start + rc | 0;
                var tmp = bytesWritten;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                bytesWritten = tmp + (before - (view.n3p_1 - view.l3p_1 | 0) | 0) | 0;
                size = start >= toIndex ? 0 : rc === 0 ? 8 : 1;
                if (size <= 0) break $l$loop;
                tail = prepareWriteHead(destination, size, tail);
            }
        } finally{
            destination.k3u();
        }
        bytesWritten = bytesWritten + encodeCompleteImpl(_this__u8e3s4, destination) | 0;
        return bytesWritten;
    }
    function sizeEstimate(_this__u8e3s4) {
        var tmp;
        if (_this__u8e3s4 instanceof ByteReadPacket) tmp = _this__u8e3s4.z3q();
        else {
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = _this__u8e3s4.z3q();
            var b = new Long(16, 0);
            tmp = a.j1(b) >= 0 ? a : b;
        }
        return tmp;
    }
    function encodeCompleteImpl(_this__u8e3s4, dst) {
        var size = 1;
        var bytesWritten = 0;
        // Inline function 'io.ktor.utils.io.core.writeWhile' call
        var tail = prepareWriteHead(dst, 1, null);
        try {
            $l$loop: while(true){
                // Inline function 'io.ktor.utils.io.charsets.encodeCompleteImpl.<anonymous>' call
                var view = tail;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                var before = view.n3p_1 - view.l3p_1 | 0;
                if (encodeComplete(_this__u8e3s4, view)) size = 0;
                else size = size + 1 | 0;
                var tmp = bytesWritten;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                bytesWritten = tmp + (before - (view.n3p_1 - view.l3p_1 | 0) | 0) | 0;
                if (!(size > 0)) break $l$loop;
                tail = prepareWriteHead(dst, 1, tail);
            }
        } finally{
            dst.k3u();
        }
        return bytesWritten;
    }
    function encode(_this__u8e3s4, input, fromIndex, toIndex) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
        var tmp$ret$0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.buildPacket' call
            // Inline function 'kotlin.contracts.contract' call
            var builder = new BytePacketBuilder();
            try {
                // Inline function 'io.ktor.utils.io.charsets.encode.<anonymous>' call
                encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
                tmp$ret$0 = builder.c3r();
                break $l$block;
            } catch ($p) {
                if ($p instanceof Error) {
                    var t = $p;
                    builder.e19();
                    throw t;
                } else throw $p;
            }
        }
        return tmp$ret$0;
    }
    function Companion() {
        this.l3u_1 = 8;
    }
    protoOf(Companion).m3u = function() {
        return Companion_getInstance_2().z3s_1;
    };
    var Companion_instance;
    function Companion_getInstance() {
        return Companion_instance;
    }
    function Buffer(memory) {
        this.j3p_1 = memory;
        this.k3p_1 = 0;
        this.l3p_1 = 0;
        this.m3p_1 = 0;
        var tmp = this;
        // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
        tmp.n3p_1 = this.j3p_1.n3u_1.byteLength;
        var tmp_0 = this;
        // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
        tmp_0.o3p_1 = this.j3p_1.n3u_1.byteLength;
    }
    protoOf(Buffer).o3u = function(count) {
        if (count === 0) return Unit_instance;
        var newReadPosition = this.k3p_1 + count | 0;
        if (count < 0 || newReadPosition > this.l3p_1) {
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var tmp$ret$1 = this.l3p_1 - this.k3p_1 | 0;
            discardFailed(count, tmp$ret$1);
        }
        this.k3p_1 = newReadPosition;
    };
    protoOf(Buffer).p3u = function(count) {
        var newWritePosition = this.l3p_1 + count | 0;
        if (count < 0 || newWritePosition > this.n3p_1) {
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var tmp$ret$0 = this.n3p_1 - this.l3p_1 | 0;
            commitWrittenFailed(count, tmp$ret$0);
        }
        this.l3p_1 = newWritePosition;
    };
    protoOf(Buffer).q3u = function(position) {
        var limit = this.n3p_1;
        if (position < this.l3p_1) {
            var tmp = position - this.l3p_1 | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var tmp$ret$0 = this.n3p_1 - this.l3p_1 | 0;
            commitWrittenFailed(tmp, tmp$ret$0);
        }
        if (position >= limit) {
            if (position === limit) {
                this.l3p_1 = position;
                return false;
            }
            var tmp_0 = position - this.l3p_1 | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var tmp$ret$1 = this.n3p_1 - this.l3p_1 | 0;
            commitWrittenFailed(tmp_0, tmp$ret$1);
        }
        this.l3p_1 = position;
        return true;
    };
    protoOf(Buffer).r3u = function(position) {
        if (position < 0 || position > this.l3p_1) {
            var tmp = position - this.k3p_1 | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var tmp$ret$0 = this.l3p_1 - this.k3p_1 | 0;
            discardFailed(tmp, tmp$ret$0);
        }
        if (!(this.k3p_1 === position)) this.k3p_1 = position;
    };
    protoOf(Buffer).s3u = function(count) {
        var newReadPosition = this.k3p_1 - count | 0;
        if (newReadPosition < this.m3p_1) rewindFailed(count, this.k3p_1 - this.m3p_1 | 0);
        this.k3p_1 = newReadPosition;
    };
    protoOf(Buffer).t3u = function(startGap) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(startGap >= 0)) {
            // Inline function 'io.ktor.utils.io.core.Buffer.reserveStartGap.<anonymous>' call
            var message = "startGap shouldn't be negative: " + startGap;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        if (this.k3p_1 >= startGap) {
            this.m3p_1 = startGap;
            return Unit_instance;
        }
        if (this.k3p_1 === this.l3p_1) {
            if (startGap > this.n3p_1) startGapReservationFailedDueToLimit(this, startGap);
            this.l3p_1 = startGap;
            this.k3p_1 = startGap;
            this.m3p_1 = startGap;
            return Unit_instance;
        }
        startGapReservationFailed(this, startGap);
    };
    protoOf(Buffer).u3u = function(endGap) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(endGap >= 0)) {
            // Inline function 'io.ktor.utils.io.core.Buffer.reserveEndGap.<anonymous>' call
            var message = "endGap shouldn't be negative: " + endGap;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var newLimit = this.o3p_1 - endGap | 0;
        if (newLimit >= this.l3p_1) {
            this.n3p_1 = newLimit;
            return Unit_instance;
        }
        if (newLimit < 0) endGapReservationFailedDueToCapacity(this, endGap);
        if (newLimit < this.m3p_1) endGapReservationFailedDueToStartGap(this, endGap);
        if (this.k3p_1 === this.l3p_1) {
            this.n3p_1 = newLimit;
            this.k3p_1 = newLimit;
            this.l3p_1 = newLimit;
            return Unit_instance;
        }
        endGapReservationFailedDueToContent(this, endGap);
    };
    protoOf(Buffer).v3u = function() {
        this.m3p_1 = 0;
        this.k3p_1 = 0;
        var capacity = this.o3p_1;
        this.l3p_1 = capacity;
    };
    protoOf(Buffer).w3u = function() {
        this.x3u(this.o3p_1 - this.m3p_1 | 0);
    };
    protoOf(Buffer).x3u = function(limit) {
        var startGap = this.m3p_1;
        this.k3p_1 = startGap;
        this.l3p_1 = startGap;
        this.n3p_1 = limit;
    };
    protoOf(Buffer).y3u = function() {
        this.z3u(0);
        this.a3v();
    };
    protoOf(Buffer).a3v = function() {
        this.n3p_1 = this.o3p_1;
    };
    protoOf(Buffer).z3u = function(newReadPosition) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newReadPosition >= 0)) {
            // Inline function 'io.ktor.utils.io.core.Buffer.releaseStartGap.<anonymous>' call
            var message = "newReadPosition shouldn't be negative: " + newReadPosition;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newReadPosition <= this.k3p_1)) {
            // Inline function 'io.ktor.utils.io.core.Buffer.releaseStartGap.<anonymous>' call
            var message_0 = "newReadPosition shouldn't be ahead of the read position: " + newReadPosition + " > " + this.k3p_1;
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        this.k3p_1 = newReadPosition;
        if (this.m3p_1 > newReadPosition) this.m3p_1 = newReadPosition;
    };
    protoOf(Buffer).b3v = function(copy) {
        copy.n3p_1 = this.n3p_1;
        copy.m3p_1 = this.m3p_1;
        copy.k3p_1 = this.k3p_1;
        copy.l3p_1 = this.l3p_1;
    };
    protoOf(Buffer).c3v = function() {
        var readPosition = this.k3p_1;
        if (readPosition === this.l3p_1) throw new EOFException("No readable bytes available.");
        this.k3p_1 = readPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.get' call
        // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
        return this.j3p_1.n3u_1.getInt8(readPosition);
    };
    protoOf(Buffer).d3v = function(value) {
        var writePosition = this.l3p_1;
        if (writePosition === this.n3p_1) throw new InsufficientSpaceException("No free space in the buffer to write a byte");
        // Inline function 'io.ktor.utils.io.bits.set' call
        this.j3p_1.n3u_1.setInt8(writePosition, value);
        this.l3p_1 = writePosition + 1 | 0;
    };
    protoOf(Buffer).e3v = function() {
        this.y3u();
        this.w3u();
    };
    protoOf(Buffer).toString = function() {
        var tmp = "Buffer[0x" + toString_0(hashCode(this), 16) + "]";
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp_0 = this.l3p_1 - this.k3p_1 | 0;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var tmp_1 = this.n3p_1 - this.l3p_1 | 0;
        var tmp_2 = this.m3p_1;
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        return tmp + ("(" + tmp_0 + " used, " + tmp_1 + " free, " + (tmp_2 + (this.o3p_1 - this.n3p_1 | 0) | 0) + " reserved of " + this.o3p_1 + ")");
    };
    function discardFailed(count, readRemaining) {
        throw new EOFException("Unable to discard " + count + " bytes: only " + readRemaining + " available for reading");
    }
    function commitWrittenFailed(count, writeRemaining) {
        throw new EOFException("Unable to discard " + count + " bytes: only " + writeRemaining + " available for writing");
    }
    function rewindFailed(count, rewindRemaining) {
        throw IllegalArgumentException_init_$Create$("Unable to rewind " + count + " bytes: only " + rewindRemaining + " could be rewinded");
    }
    function startGapReservationFailedDueToLimit(_this__u8e3s4, startGap) {
        if (startGap > _this__u8e3s4.o3p_1) throw IllegalArgumentException_init_$Create$("Start gap " + startGap + " is bigger than the capacity " + _this__u8e3s4.o3p_1);
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        var tmp$ret$0 = _this__u8e3s4.o3p_1 - _this__u8e3s4.n3p_1 | 0;
        throw IllegalStateException_init_$Create$("Unable to reserve " + startGap + " start gap: there are already " + tmp$ret$0 + " bytes reserved in the end");
    }
    function startGapReservationFailed(_this__u8e3s4, startGap) {
        var tmp = "Unable to reserve " + startGap + " start gap: ";
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = _this__u8e3s4.l3p_1 - _this__u8e3s4.k3p_1 | 0;
        throw IllegalStateException_init_$Create$(tmp + ("there are already " + tmp$ret$0 + " content bytes starting at offset " + _this__u8e3s4.k3p_1));
    }
    function endGapReservationFailedDueToCapacity(_this__u8e3s4, endGap) {
        throw IllegalArgumentException_init_$Create$("End gap " + endGap + " is too big: capacity is " + _this__u8e3s4.o3p_1);
    }
    function endGapReservationFailedDueToStartGap(_this__u8e3s4, endGap) {
        throw IllegalArgumentException_init_$Create$("End gap " + endGap + " is too big: there are already " + _this__u8e3s4.m3p_1 + " bytes reserved in the beginning");
    }
    function endGapReservationFailedDueToContent(_this__u8e3s4, endGap) {
        var tmp = "Unable to reserve end gap " + endGap + ":";
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = _this__u8e3s4.l3p_1 - _this__u8e3s4.k3p_1 | 0;
        throw IllegalArgumentException_init_$Create$(tmp + (" there are already " + tmp$ret$0 + " content bytes at offset " + _this__u8e3s4.k3p_1));
    }
    function InsufficientSpaceException_init_$Init$(name, size, availableSpace, $this) {
        InsufficientSpaceException.call($this, "Not enough free space to write " + name + " of " + size + " bytes, available " + availableSpace + " bytes.");
        return $this;
    }
    function InsufficientSpaceException_init_$Create$(name, size, availableSpace) {
        var tmp = InsufficientSpaceException_init_$Init$(name, size, availableSpace, objectCreate(protoOf(InsufficientSpaceException)));
        captureStack(tmp, InsufficientSpaceException_init_$Create$);
        return tmp;
    }
    function InsufficientSpaceException(message) {
        message = message === VOID ? "Not enough free space" : message;
        Exception_init_$Init$(message, this);
        captureStack(this, InsufficientSpaceException);
    }
    function restoreStartGap(_this__u8e3s4, size) {
        _this__u8e3s4.z3u(_this__u8e3s4.k3p_1 - size | 0);
    }
    function writeBufferAppend(_this__u8e3s4, other, maxSize) {
        // Inline function 'kotlin.comparisons.minOf' call
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var a = other.l3p_1 - other.k3p_1 | 0;
        var size = Math.min(a, maxSize);
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        if ((_this__u8e3s4.n3p_1 - _this__u8e3s4.l3p_1 | 0) <= size) writeBufferAppendUnreserve(_this__u8e3s4, size);
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeBufferAppend.<anonymous>' call
        var dst = _this__u8e3s4.j3p_1;
        var dstOffset = _this__u8e3s4.l3p_1;
        _this__u8e3s4.n3p_1;
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeBufferAppend.<anonymous>.<anonymous>' call
        var src = other.j3p_1;
        var srcOffset = other.k3p_1;
        other.l3p_1;
        src.f3v(dst, srcOffset, size, dstOffset);
        var rc = size;
        other.o3u(rc);
        var rc_0 = rc;
        _this__u8e3s4.p3u(rc_0);
        return rc_0;
    }
    function writeBufferAppendUnreserve(_this__u8e3s4, writeSize) {
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var tmp = _this__u8e3s4.n3p_1 - _this__u8e3s4.l3p_1 | 0;
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        if ((tmp + (_this__u8e3s4.o3p_1 - _this__u8e3s4.n3p_1 | 0) | 0) < writeSize) throw IllegalArgumentException_init_$Create$("Can't append buffer: not enough free space at the end");
        var newWritePosition = _this__u8e3s4.l3p_1 + writeSize | 0;
        var overrunSize = newWritePosition - _this__u8e3s4.n3p_1 | 0;
        if (overrunSize > 0) _this__u8e3s4.a3v();
    }
    function writeBufferPrepend(_this__u8e3s4, other) {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var size = other.l3p_1 - other.k3p_1 | 0;
        var readPosition = _this__u8e3s4.k3p_1;
        if (readPosition < size) throw IllegalArgumentException_init_$Create$("Not enough space in the beginning to prepend bytes");
        var newReadPosition = readPosition - size | 0;
        other.j3p_1.f3v(_this__u8e3s4.j3p_1, other.k3p_1, size, newReadPosition);
        other.o3u(size);
        _this__u8e3s4.z3u(newReadPosition);
        return size;
    }
    function get_DefaultChunkedBufferPool() {
        _init_properties_BufferFactory_kt__uj6b48();
        return DefaultChunkedBufferPool;
    }
    var DefaultChunkedBufferPool;
    function DefaultBufferPool(bufferSize, capacity, allocator) {
        bufferSize = bufferSize === VOID ? 4096 : bufferSize;
        capacity = capacity === VOID ? 1000 : capacity;
        allocator = allocator === VOID ? DefaultAllocator_instance : allocator;
        DefaultPool.call(this, capacity);
        this.j3v_1 = bufferSize;
        this.k3v_1 = allocator;
    }
    protoOf(DefaultBufferPool).l3v = function() {
        return new ChunkBuffer(this.k3v_1.m3v(this.j3v_1), null, this);
    };
    protoOf(DefaultBufferPool).n3v = function(instance) {
        this.k3v_1.o3v(instance.j3p_1);
        protoOf(DefaultPool).s3v.call(this, instance);
        instance.d3w();
    };
    protoOf(DefaultBufferPool).s3v = function(instance) {
        return this.n3v(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    protoOf(DefaultBufferPool).e3w = function(instance) {
        protoOf(DefaultPool).f3w.call(this, instance);
        // Inline function 'kotlin.check' call
        // Inline function 'io.ktor.utils.io.bits.Memory.size' call
        var this_0 = instance.j3p_1;
        // Inline function 'kotlin.contracts.contract' call
        if (!toLong(this_0.n3u_1.byteLength).equals(toLong(this.j3v_1))) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            // Inline function 'io.ktor.utils.io.bits.Memory.size' call
            var this_1 = instance.j3p_1;
            var tmp$ret$1 = toLong(this_1.n3u_1.byteLength);
            var message = "Buffer size mismatch. Expected: " + this.j3v_1 + ", actual: " + tmp$ret$1.toString();
            throw IllegalStateException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(instance === Companion_getInstance_2().z3s_1)) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            var message_0 = "ChunkBuffer.Empty couldn't be recycled";
            throw IllegalStateException_init_$Create$(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(instance === Companion_instance.m3u())) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            var message_1 = "Empty instance couldn't be recycled";
            throw IllegalStateException_init_$Create$(toString(message_1));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(instance.g3w() === 0)) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            var message_2 = "Unable to clear buffer: it is still in use.";
            throw IllegalStateException_init_$Create$(toString(message_2));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(instance.z1y() == null)) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            var message_3 = "Recycled instance shouldn't be a part of a chain.";
            throw IllegalStateException_init_$Create$(toString(message_3));
        }
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(instance.c3w_1 == null)) {
            // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
            var message_4 = "Recycled instance shouldn't be a view or another buffer.";
            throw IllegalStateException_init_$Create$(toString(message_4));
        }
    };
    protoOf(DefaultBufferPool).f3w = function(instance) {
        return this.e3w(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    protoOf(DefaultBufferPool).h3w = function(instance) {
        // Inline function 'kotlin.apply' call
        var this_0 = protoOf(DefaultPool).i3w.call(this, instance);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.clearInstance.<anonymous>' call
        this_0.j3w();
        this_0.e3v();
        return this_0;
    };
    protoOf(DefaultBufferPool).i3w = function(instance) {
        return this.h3w(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    var properties_initialized_BufferFactory_kt_q9tgbq;
    function _init_properties_BufferFactory_kt__uj6b48() {
        if (!properties_initialized_BufferFactory_kt_q9tgbq) {
            properties_initialized_BufferFactory_kt_q9tgbq = true;
            DefaultChunkedBufferPool = new DefaultBufferPool();
        }
    }
    function writeFully_0(_this__u8e3s4, source, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? source.length - offset | 0 : length;
        // Inline function 'io.ktor.utils.io.core.writeExact' call
        var name = "byte array";
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.l3p_1;
        var writeRemaining = _this__u8e3s4.n3p_1 - start | 0;
        if (writeRemaining < length) throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
        // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
        // Inline function 'io.ktor.utils.io.bits.storeByteArray' call
        // Inline function 'io.ktor.utils.io.bits.useMemory' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        of(Companion_getInstance_4(), source, offset, length).f3v(memory, 0, length, start);
        var rc = length;
        _this__u8e3s4.p3u(rc);
    }
    function writeFully_1(_this__u8e3s4, src, length) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length >= 0)) {
            // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
            var message = "length shouldn't be negative: " + length;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length <= (src.l3p_1 - src.k3p_1 | 0))) {
            // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var message_0 = "length shouldn't be greater than the source read remaining: " + length + " > " + (src.l3p_1 - src.k3p_1 | 0);
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length <= (_this__u8e3s4.n3p_1 - _this__u8e3s4.l3p_1 | 0))) {
            // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var message_1 = "length shouldn't be greater than the destination write remaining space: " + length + " > " + (_this__u8e3s4.n3p_1 - _this__u8e3s4.l3p_1 | 0);
            throw IllegalArgumentException_init_$Create$(toString(message_1));
        }
        // Inline function 'io.ktor.utils.io.core.writeExact' call
        var name = "buffer readable content";
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.l3p_1;
        var writeRemaining = _this__u8e3s4.n3p_1 - start | 0;
        if (writeRemaining < length) throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
        // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
        src.j3p_1.f3v(memory, src.k3p_1, length, start);
        src.o3u(length);
        var rc = length;
        _this__u8e3s4.p3u(rc);
    }
    function readFully(_this__u8e3s4, destination, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? destination.length - offset | 0 : length;
        // Inline function 'io.ktor.utils.io.core.readExact' call
        var name = "byte array";
        // Inline function 'kotlin.contracts.contract' call
        var value;
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.k3p_1;
        if ((_this__u8e3s4.l3p_1 - start | 0) < length) throw new EOFException("Not enough bytes to read a " + name + " of size " + length + ".");
        copyTo_1(memory, destination, start, length, offset);
        value = Unit_instance;
        var rc = length;
        _this__u8e3s4.o3u(rc);
    }
    function readFully_0(_this__u8e3s4, dst, length) {
        var tmp;
        if (length === VOID) // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        tmp = dst.n3p_1 - dst.l3p_1 | 0;
        else tmp = length;
        length = tmp;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length >= 0)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length <= (dst.n3p_1 - dst.l3p_1 | 0))) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message_0 = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        // Inline function 'io.ktor.utils.io.core.readExact' call
        var name = "buffer content";
        // Inline function 'kotlin.contracts.contract' call
        var value;
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.k3p_1;
        if ((_this__u8e3s4.l3p_1 - start | 0) < length) throw new EOFException("Not enough bytes to read a " + name + " of size " + length + ".");
        memory.f3v(dst.j3p_1, start, length, dst.l3p_1);
        dst.p3u(length);
        value = Unit_instance;
        var rc = length;
        _this__u8e3s4.o3u(rc);
        return length;
    }
    function writeShort(_this__u8e3s4, value) {
        var name = "short integer";
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.l3p_1;
        var writeRemaining = _this__u8e3s4.n3p_1 - start | 0;
        if (writeRemaining < 2) throw InsufficientSpaceException_init_$Create$(name, 2, writeRemaining);
        // Inline function 'io.ktor.utils.io.core.writeShort.<anonymous>' call
        // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
        memory.n3u_1.setInt16(start, value, false);
        var rc = 2;
        _this__u8e3s4.p3u(rc);
        return Unit_instance;
    }
    function readShort(_this__u8e3s4) {
        // Inline function 'io.ktor.utils.io.core.readExact' call
        var name = "short integer";
        // Inline function 'kotlin.contracts.contract' call
        var value;
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var start = _this__u8e3s4.k3p_1;
        if ((_this__u8e3s4.l3p_1 - start | 0) < 2) throw new EOFException("Not enough bytes to read a " + name + " of size " + 2 + ".");
        // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
        // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
        value = memory.n3u_1.getInt16(start, false);
        var rc = 2;
        _this__u8e3s4.o3u(rc);
        return value;
    }
    function remainingAll(_this__u8e3s4) {
        return remainingAll_0(_this__u8e3s4, new Long(0, 0));
    }
    function findTail(_this__u8e3s4) {
        var $this = _this__u8e3s4;
        $l$1: do $l$0: do {
            var tmp0_elvis_lhs = $this.z1y();
            var tmp;
            if (tmp0_elvis_lhs == null) return $this;
            else tmp = tmp0_elvis_lhs;
            var next = tmp;
            $this = next;
            continue $l$0;
        }while (false);
        while (true);
    }
    function releaseAll(_this__u8e3s4, pool) {
        var current = _this__u8e3s4;
        while(!(current == null)){
            var next = current.m3w();
            current.n3w(pool);
            current = next;
        }
    }
    function remainingAll_0(_this__u8e3s4, n) {
        var $this = _this__u8e3s4;
        var n_0 = n;
        $l$1: do $l$0: do {
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var this_0 = $this;
            var tmp$ret$0 = this_0.l3p_1 - this_0.k3p_1 | 0;
            var rem = toLong(tmp$ret$0).y2(n_0);
            var tmp0_elvis_lhs = $this.z1y();
            var tmp;
            if (tmp0_elvis_lhs == null) return rem;
            else tmp = tmp0_elvis_lhs;
            var next = tmp;
            $this = next;
            n_0 = rem;
            continue $l$0;
        }while (false);
        while (true);
    }
    function BytePacketBuilder(pool) {
        pool = pool === VOID ? Companion_getInstance_2().c3t() : pool;
        Output.call(this, pool);
    }
    protoOf(BytePacketBuilder).m = function() {
        return this.o3w();
    };
    protoOf(BytePacketBuilder).b3n = function() {
        return this.o3w() === 0;
    };
    protoOf(BytePacketBuilder).p3w = function() {};
    protoOf(BytePacketBuilder).q3w = function(source, offset, length) {};
    protoOf(BytePacketBuilder).f8 = function(value) {
        var tmp = protoOf(Output).f8.call(this, value);
        return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
    };
    protoOf(BytePacketBuilder).f = function(value) {
        var tmp = protoOf(Output).f.call(this, value);
        return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
    };
    protoOf(BytePacketBuilder).qb = function(value, startIndex, endIndex) {
        var tmp = protoOf(Output).qb.call(this, value, startIndex, endIndex);
        return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
    };
    protoOf(BytePacketBuilder).c3r = function() {
        var size = this.m();
        var head = this.k3n();
        return head == null ? Companion_getInstance_0().r3w_1 : new ByteReadPacket(head, toLong(size), this.c3n_1);
    };
    protoOf(BytePacketBuilder).toString = function() {
        return "BytePacketBuilder[0x" + hashCode(this) + "]";
    };
    function ByteReadPacket_init_$Init$(head, pool, $this) {
        ByteReadPacket.call($this, head, remainingAll(head), pool);
        return $this;
    }
    function ByteReadPacket_init_$Create$(head, pool) {
        return ByteReadPacket_init_$Init$(head, pool, objectCreate(protoOf(ByteReadPacket)));
    }
    function Companion_0() {
        Companion_instance_0 = this;
        this.r3w_1 = new ByteReadPacket(Companion_getInstance_2().z3s_1, new Long(0, 0), Companion_getInstance_2().y3s_1);
    }
    var Companion_instance_0;
    function Companion_getInstance_0() {
        if (Companion_instance_0 == null) new Companion_0();
        return Companion_instance_0;
    }
    function ByteReadPacket(head, remaining, pool) {
        Companion_getInstance_0();
        Input.call(this, head, remaining, pool);
        this.y3w();
    }
    protoOf(ByteReadPacket).g3x = function() {
        return null;
    };
    protoOf(ByteReadPacket).h3x = function(destination, offset, length) {
        return 0;
    };
    protoOf(ByteReadPacket).toString = function() {
        return "ByteReadPacket[" + hashCode(this) + "]";
    };
    function _set__head__b4pap2($this, newHead) {
        $this.t3q_1 = newHead;
        $this.u3q_1 = newHead.j3p_1;
        $this.v3q_1 = newHead.k3p_1;
        $this.w3q_1 = newHead.l3p_1;
    }
    function readASCII($this, out, min, max) {
        if (max === 0 && min === 0) return 0;
        else if ($this.m3s()) {
            if (min === 0) return 0;
            else atLeastMinCharactersRequire($this, min);
        } else if (max < min) minShouldBeLess($this, min, max);
        var copied = 0;
        var utf8 = false;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            try {
                $l$loop_0: for(;;){
                    // Inline function 'io.ktor.utils.io.core.Input.readASCII.<anonymous>' call
                    var buffer = current;
                    var tmp$ret$4;
                    $l$block_0: {
                        // Inline function 'io.ktor.utils.io.core.internal.decodeASCII' call
                        // Inline function 'io.ktor.utils.io.core.read' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'io.ktor.utils.io.core.internal.decodeASCII.<anonymous>' call
                        var memory = buffer.j3p_1;
                        var start = buffer.k3p_1;
                        var endExclusive = buffer.l3p_1;
                        var inductionVariable = start;
                        if (inductionVariable < endExclusive) do {
                            var index = inductionVariable;
                            inductionVariable = inductionVariable + 1 | 0;
                            // Inline function 'io.ktor.utils.io.bits.get' call
                            // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                            var codepoint = memory.n3u_1.getInt8(index) & 255;
                            var tmp_0;
                            if ((codepoint & 128) === 128) tmp_0 = true;
                            else {
                                // Inline function 'io.ktor.utils.io.core.Input.readASCII.<anonymous>.<anonymous>' call
                                var it = numberToChar(codepoint);
                                var tmp_1;
                                if (copied === max) tmp_1 = false;
                                else {
                                    out.f8(it);
                                    copied = copied + 1 | 0;
                                    tmp_1 = true;
                                }
                                tmp_0 = !tmp_1;
                            }
                            if (tmp_0) {
                                buffer.o3u(index - start | 0);
                                tmp$ret$4 = false;
                                break $l$block_0;
                            }
                        }while (inductionVariable < endExclusive);
                        var rc = endExclusive - start | 0;
                        buffer.o3u(rc);
                        tmp$ret$4 = true;
                    }
                    var rc_0 = tmp$ret$4;
                    var tmp_2;
                    if (rc_0) tmp_2 = true;
                    else if (copied === max) tmp_2 = false;
                    else {
                        utf8 = true;
                        tmp_2 = false;
                    }
                    if (!tmp_2) break $l$loop_0;
                    release = false;
                    var tmp1_elvis_lhs = prepareReadNextHead($this, current);
                    var tmp_3;
                    if (tmp1_elvis_lhs == null) break $l$loop_0;
                    else tmp_3 = tmp1_elvis_lhs;
                    var next = tmp_3;
                    current = next;
                    release = true;
                }
            } finally{
                if (release) completeReadHead($this, current);
            }
        }
        if (utf8) return copied + readUtf8($this, out, min - copied | 0, max - copied | 0) | 0;
        if (copied < min) prematureEndOfStreamChars($this, min, copied);
        return copied;
    }
    function atLeastMinCharactersRequire($this, min) {
        throw new EOFException("at least " + min + " characters required but no bytes available");
    }
    function minShouldBeLess($this, min, max) {
        throw IllegalArgumentException_init_$Create$("min should be less or equal to max but min = " + min + ", max = " + max);
    }
    function prematureEndOfStreamChars($this, min, copied) {
        throw new MalformedUTF8InputException("Premature end of stream: expected at least " + min + " chars but had only " + copied);
    }
    function readUtf8($this, out, min, max) {
        var copied = 0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            var size = 1;
            try {
                $l$loop_0: do {
                    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                    var this_0 = current;
                    var before = this_0.l3p_1 - this_0.k3p_1 | 0;
                    var after;
                    if (before >= size) try {
                        // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>' call
                        var buffer = current;
                        var tmp$ret$5;
                        $l$block_3: {
                            // Inline function 'io.ktor.utils.io.core.internal.decodeUTF8' call
                            var byteCount = 0;
                            var value = 0;
                            var lastByteCount = 0;
                            // Inline function 'io.ktor.utils.io.core.read' call
                            // Inline function 'kotlin.contracts.contract' call
                            // Inline function 'io.ktor.utils.io.core.internal.decodeUTF8.<anonymous>' call
                            var memory = buffer.j3p_1;
                            var start = buffer.k3p_1;
                            var endExclusive = buffer.l3p_1;
                            var inductionVariable = start;
                            if (inductionVariable < endExclusive) do {
                                var index = inductionVariable;
                                inductionVariable = inductionVariable + 1 | 0;
                                // Inline function 'io.ktor.utils.io.bits.get' call
                                // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                                var v = memory.n3u_1.getInt8(index) & 255;
                                if ((v & 128) === 0) {
                                    if (!(byteCount === 0)) malformedByteCount(byteCount);
                                    // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                                    var it = numberToChar(v);
                                    var tmp_0;
                                    if (copied === max) tmp_0 = false;
                                    else {
                                        out.f8(it);
                                        copied = copied + 1 | 0;
                                        tmp_0 = true;
                                    }
                                    if (!tmp_0) {
                                        buffer.o3u(index - start | 0);
                                        tmp$ret$5 = -1;
                                        break $l$block_3;
                                    }
                                } else if (byteCount === 0) {
                                    var mask = 128;
                                    value = v;
                                    var inductionVariable_0 = 1;
                                    if (inductionVariable_0 <= 6) $l$loop: do {
                                        var i = inductionVariable_0;
                                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                                        if (!((value & mask) === 0)) {
                                            value = value & ~mask;
                                            mask = mask >> 1;
                                            byteCount = byteCount + 1 | 0;
                                        } else break $l$loop;
                                    }while (inductionVariable_0 <= 6);
                                    lastByteCount = byteCount;
                                    byteCount = byteCount - 1 | 0;
                                    if (lastByteCount > (endExclusive - index | 0)) {
                                        buffer.o3u(index - start | 0);
                                        tmp$ret$5 = lastByteCount;
                                        break $l$block_3;
                                    }
                                } else {
                                    value = value << 6 | v & 127;
                                    byteCount = byteCount - 1 | 0;
                                    if (byteCount === 0) {
                                        if (isBmpCodePoint(value)) {
                                            // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                                            var it_0 = numberToChar(value);
                                            var tmp_1;
                                            if (copied === max) tmp_1 = false;
                                            else {
                                                out.f8(it_0);
                                                copied = copied + 1 | 0;
                                                tmp_1 = true;
                                            }
                                            if (!tmp_1) {
                                                buffer.o3u(((index - start | 0) - lastByteCount | 0) + 1 | 0);
                                                tmp$ret$5 = -1;
                                                break $l$block_3;
                                            }
                                        } else if (!isValidCodePoint(value)) malformedCodePoint(value);
                                        else {
                                            var tmp_2;
                                            // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                                            var it_1 = numberToChar(highSurrogate(value));
                                            var tmp_3;
                                            if (copied === max) tmp_3 = false;
                                            else {
                                                out.f8(it_1);
                                                copied = copied + 1 | 0;
                                                tmp_3 = true;
                                            }
                                            if (!tmp_3) tmp_2 = true;
                                            else {
                                                // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                                                var it_2 = numberToChar(lowSurrogate(value));
                                                var tmp_4;
                                                if (copied === max) tmp_4 = false;
                                                else {
                                                    out.f8(it_2);
                                                    copied = copied + 1 | 0;
                                                    tmp_4 = true;
                                                }
                                                tmp_2 = !tmp_4;
                                            }
                                            if (tmp_2) {
                                                buffer.o3u(((index - start | 0) - lastByteCount | 0) + 1 | 0);
                                                tmp$ret$5 = -1;
                                                break $l$block_3;
                                            }
                                        }
                                        value = 0;
                                    }
                                }
                            }while (inductionVariable < endExclusive);
                            var rc = endExclusive - start | 0;
                            buffer.o3u(rc);
                            tmp$ret$5 = 0;
                        }
                        var size_0 = tmp$ret$5;
                        size = size_0 === 0 ? 1 : size_0 > 0 ? size_0 : 0;
                    } finally{
                        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                        var this_1 = current;
                        after = this_1.l3p_1 - this_1.k3p_1 | 0;
                    }
                    else after = before;
                    release = false;
                    var tmp_5;
                    if (after === 0) tmp_5 = prepareReadNextHead($this, current);
                    else {
                        var tmp_6;
                        if (after < size) tmp_6 = true;
                        else {
                            // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                            var this_2 = current;
                            tmp_6 = (this_2.o3p_1 - this_2.n3p_1 | 0) < 8;
                        }
                        if (tmp_6) {
                            completeReadHead($this, current);
                            tmp_5 = prepareReadFirstHead($this, size);
                        } else tmp_5 = current;
                    }
                    var tmp1_elvis_lhs = tmp_5;
                    var tmp_7;
                    if (tmp1_elvis_lhs == null) break $l$loop_0;
                    else tmp_7 = tmp1_elvis_lhs;
                    var next = tmp_7;
                    current = next;
                    release = true;
                }while (size > 0);
            } finally{
                if (release) completeReadHead($this, current);
            }
        }
        if (copied < min) prematureEndOfStreamChars($this, min, copied);
        return copied;
    }
    function discardAsMuchAsPossible($this, n, skipped) {
        var $this_0 = $this;
        var n_0 = n;
        var skipped_0 = skipped;
        $l$1: do $l$0: do {
            if (n_0.equals(new Long(0, 0))) return skipped_0;
            var tmp0_elvis_lhs = $this_0.u3x(1);
            var tmp;
            if (tmp0_elvis_lhs == null) return skipped_0;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            // Inline function 'kotlin.comparisons.minOf' call
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var tmp$ret$0 = current.l3p_1 - current.k3p_1 | 0;
            var a = toLong(tmp$ret$0);
            var b = n_0;
            var size = (a.j1(b) <= 0 ? a : b).l1();
            current.o3u(size);
            var tmp1_this = $this_0;
            tmp1_this.v3q_1 = tmp1_this.v3q_1 + size | 0;
            afterRead($this_0, current);
            // Inline function 'kotlin.Long.minus' call
            // Inline function 'kotlin.Long.plus' call
            $this_0;
            n_0 = n_0.z2(toLong(size));
            skipped_0 = skipped_0.y2(toLong(size));
            continue $l$0;
        }while (false);
        while (true);
    }
    function discardAsMuchAsPossible_0($this, n, skipped) {
        var currentCount = n;
        var currentSkipped = skipped;
        while(true){
            if (currentCount === 0) return currentSkipped;
            var tmp0_elvis_lhs = $this.u3x(1);
            var tmp;
            if (tmp0_elvis_lhs == null) return currentSkipped;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            // Inline function 'kotlin.comparisons.minOf' call
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var a = current.l3p_1 - current.k3p_1 | 0;
            var b = currentCount;
            var size = Math.min(a, b);
            current.o3u(size);
            $this.v3q_1 = $this.v3q_1 + size | 0;
            afterRead($this, current);
            currentCount = currentCount - size | 0;
            currentSkipped = currentSkipped + size | 0;
        }
    }
    function fixGapAfterReadFallback($this, current) {
        if ($this.y3q_1 && current.z1y() == null) {
            $this.v3q_1 = current.k3p_1;
            $this.w3q_1 = current.l3p_1;
            $this.i3x(new Long(0, 0));
            return Unit_instance;
        }
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var size = current.l3p_1 - current.k3p_1 | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        var b = 8 - (current.o3p_1 - current.n3p_1 | 0) | 0;
        var overrun = Math.min(size, b);
        if (size > overrun) fixGapAfterReadFallbackUnreserved($this, current, size, overrun);
        else {
            var new_0 = $this.s3q_1.k3w();
            new_0.u3u(8);
            new_0.w3x(current.m3w());
            writeBufferAppend(new_0, current, size);
            _set__head__b4pap2($this, new_0);
        }
        current.n3w($this.s3q_1);
    }
    function fixGapAfterReadFallbackUnreserved($this, current, size, overrun) {
        var chunk1 = $this.s3q_1.k3w();
        var chunk2 = $this.s3q_1.k3w();
        chunk1.u3u(8);
        chunk2.u3u(8);
        chunk1.w3x(chunk2);
        chunk2.w3x(current.m3w());
        writeBufferAppend(chunk1, current, size - overrun | 0);
        writeBufferAppend(chunk2, current, overrun);
        _set__head__b4pap2($this, chunk1);
        $this.i3x(remainingAll(chunk2));
    }
    function ensureNext($this, current, empty) {
        var $this_0 = $this;
        var current_0 = current;
        var empty_0 = empty;
        $l$1: do $l$0: do {
            if (current_0 === empty_0) return doFill($this_0);
            var next = current_0.m3w();
            current_0.n3w($this_0.s3q_1);
            var tmp;
            if (next == null) {
                _set__head__b4pap2($this_0, empty_0);
                $this_0.i3x(new Long(0, 0));
                $this_0;
                current_0 = empty_0;
                empty_0;
                continue $l$0;
            } else // Inline function 'io.ktor.utils.io.core.canRead' call
            if (next.l3p_1 > next.k3p_1) {
                _set__head__b4pap2($this_0, next);
                var tmp0_this = $this_0;
                // Inline function 'kotlin.Long.minus' call
                var this_0 = tmp0_this.x3q_1;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var other = next.l3p_1 - next.k3p_1 | 0;
                var tmp$ret$2 = this_0.z2(toLong(other));
                tmp0_this.i3x(tmp$ret$2);
                tmp = next;
            } else {
                $this_0;
                current_0 = next;
                empty_0;
                continue $l$0;
            }
            return tmp;
        }while (false);
        while (true);
    }
    function doFill($this) {
        if ($this.y3q_1) return null;
        var chunk = $this.g3x();
        if (chunk == null) {
            $this.y3q_1 = true;
            return null;
        }
        appendView($this, chunk);
        return chunk;
    }
    function appendView($this, chunk) {
        var tail = findTail($this.t3q_1);
        if (tail === Companion_getInstance_2().z3s_1) {
            _set__head__b4pap2($this, chunk);
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!$this.x3q_1.equals(new Long(0, 0))) throw IllegalStateException_init_$Create$("It should be no tail remaining bytes if current tail is EmptyBuffer");
            var tmp0_safe_receiver = chunk.z1y();
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : remainingAll(tmp0_safe_receiver);
            $this.i3x(tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
        } else {
            tail.w3x(chunk);
            $this.i3x($this.x3q_1.y2(remainingAll(chunk)));
        }
    }
    function prepareReadLoop($this, minSize, head) {
        var $this_0 = $this;
        var minSize_0 = minSize;
        var head_0 = head;
        $l$1: do $l$0: do {
            // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
            var this_0 = $this_0;
            var headSize = this_0.w3q_1 - this_0.v3q_1 | 0;
            if (headSize >= minSize_0) return head_0;
            var tmp0_elvis_lhs = head_0.z1y();
            var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? doFill($this_0) : tmp0_elvis_lhs;
            var tmp;
            if (tmp1_elvis_lhs == null) return null;
            else tmp = tmp1_elvis_lhs;
            var next = tmp;
            if (headSize === 0) {
                if (!(head_0 === Companion_getInstance_2().z3s_1)) $this_0.v3x(head_0);
                $this_0;
                minSize_0;
                head_0 = next;
                continue $l$0;
            } else {
                var desiredExtraBytes = minSize_0 - headSize | 0;
                var copied = writeBufferAppend(head_0, next, desiredExtraBytes);
                $this_0.w3q_1 = head_0.l3p_1;
                var tmp2_this = $this_0;
                // Inline function 'kotlin.Long.minus' call
                var tmp$ret$1 = tmp2_this.x3q_1.z2(toLong(copied));
                tmp2_this.i3x(tmp$ret$1);
                // Inline function 'io.ktor.utils.io.core.canRead' call
                if (!(next.l3p_1 > next.k3p_1)) {
                    head_0.w3x(null);
                    head_0.w3x(next.m3w());
                    next.n3w($this_0.s3q_1);
                } else next.t3u(copied);
            }
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var this_1 = head_0;
            if ((this_1.l3p_1 - this_1.k3p_1 | 0) >= minSize_0) return head_0;
            if (minSize_0 > 8) minSizeIsTooBig($this_0, minSize_0);
            $this_0;
            minSize_0;
            head_0;
            continue $l$0;
        }while (false);
        while (true);
    }
    function minSizeIsTooBig($this, minSize) {
        throw IllegalStateException_init_$Create$("minSize of " + minSize + " is too big (should be less than 8)");
    }
    function afterRead($this, head) {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        if ((head.l3p_1 - head.k3p_1 | 0) === 0) $this.v3x(head);
    }
    function Companion_1() {}
    var Companion_instance_1;
    function Companion_getInstance_1() {
        return Companion_instance_1;
    }
    function Input(head, remaining, pool) {
        head = head === VOID ? Companion_getInstance_2().z3s_1 : head;
        remaining = remaining === VOID ? remainingAll(head) : remaining;
        pool = pool === VOID ? Companion_getInstance_2().c3t() : pool;
        this.s3q_1 = pool;
        this.t3q_1 = head;
        this.u3q_1 = head.j3p_1;
        this.v3q_1 = head.k3p_1;
        this.w3q_1 = head.l3p_1;
        var tmp = this;
        // Inline function 'kotlin.Long.minus' call
        var other = this.w3q_1 - this.v3q_1 | 0;
        tmp.x3q_1 = remaining.z2(toLong(other));
        this.y3q_1 = false;
    }
    protoOf(Input).m3s = function() {
        var tmp;
        var tmp_0;
        // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
        if ((this.w3q_1 - this.v3q_1 | 0) === 0) tmp_0 = this.x3q_1.equals(new Long(0, 0));
        else tmp_0 = false;
        if (tmp_0) tmp = this.y3q_1 || doFill(this) == null;
        else tmp = false;
        return tmp;
    };
    protoOf(Input).s3w = function() {
        // Inline function 'kotlin.also' call
        var this_0 = this.t3q_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.Input.<get-head>.<anonymous>' call
        this_0.r3u(this.v3q_1);
        return this_0;
    };
    protoOf(Input).i3x = function(newValue) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(newValue.j1(new Long(0, 0)) >= 0)) {
            // Inline function 'io.ktor.utils.io.core.Input.<set-tailRemaining>.<anonymous>' call
            var message = "tailRemaining shouldn't be negative: " + newValue.toString();
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        this.x3q_1 = newValue;
    };
    protoOf(Input).z3q = function() {
        // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
        var tmp$ret$0 = this.w3q_1 - this.v3q_1 | 0;
        return toLong(tmp$ret$0).y2(this.x3q_1);
    };
    protoOf(Input).p3r = function() {
        return !(this.v3q_1 === this.w3q_1) || !this.x3q_1.equals(new Long(0, 0));
    };
    protoOf(Input).e19 = function() {
        var head = this.s3w();
        var empty = Companion_getInstance_2().z3s_1;
        if (!(head === empty)) {
            _set__head__b4pap2(this, empty);
            this.i3x(new Long(0, 0));
            releaseAll(head, this.s3q_1);
        }
    };
    protoOf(Input).k3n = function() {
        var head = this.s3w();
        var empty = Companion_getInstance_2().z3s_1;
        if (head === empty) return null;
        _set__head__b4pap2(this, empty);
        this.i3x(new Long(0, 0));
        return head;
    };
    protoOf(Input).j3x = function() {
        var head = this.s3w();
        var next = head.z1y();
        var empty = Companion_getInstance_2().z3s_1;
        if (head === empty) return null;
        if (next == null) {
            _set__head__b4pap2(this, empty);
            this.i3x(new Long(0, 0));
        } else {
            _set__head__b4pap2(this, next);
            // Inline function 'kotlin.Long.minus' call
            var this_0 = this.x3q_1;
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var other = next.l3p_1 - next.k3p_1 | 0;
            var tmp$ret$1 = this_0.z2(toLong(other));
            this.i3x(tmp$ret$1);
        }
        head.w3x(null);
        return head;
    };
    protoOf(Input).k3x = function(chain) {
        if (chain === Companion_getInstance_2().z3s_1) return Unit_instance;
        var size = remainingAll(chain);
        if (this.t3q_1 === Companion_getInstance_2().z3s_1) {
            _set__head__b4pap2(this, chain);
            // Inline function 'kotlin.Long.minus' call
            // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
            var other = this.w3q_1 - this.v3q_1 | 0;
            var tmp$ret$1 = size.z2(toLong(other));
            this.i3x(tmp$ret$1);
        } else {
            findTail(this.t3q_1).w3x(chain);
            this.i3x(this.x3q_1.y2(size));
        }
    };
    protoOf(Input).l3x = function(chain) {
        var tail = findTail(this.s3w());
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var size = chain.l3p_1 - chain.k3p_1 | 0;
        var tmp;
        if (size === 0) tmp = true;
        else // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        tmp = (tail.n3p_1 - tail.l3p_1 | 0) < size;
        if (tmp) return false;
        writeBufferAppend(tail, chain, size);
        if (this.s3w() === tail) this.w3q_1 = tail.l3p_1;
        else {
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$2 = this.x3q_1.y2(toLong(size));
            this.i3x(tmp$ret$2);
        }
        return true;
    };
    protoOf(Input).m3x = function(n) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(n >= 0)) {
            // Inline function 'io.ktor.utils.io.core.Input.discard.<anonymous>' call
            var message = "Negative discard is not allowed: " + n;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return discardAsMuchAsPossible_0(this, n, 0);
    };
    protoOf(Input).o3u = function(n) {
        if (!(this.m3x(n) === n)) throw new EOFException("Unable to discard " + n + " bytes due to end of packet");
    };
    protoOf(Input).n3x = function(n) {
        if (n.j1(new Long(0, 0)) <= 0) return new Long(0, 0);
        return discardAsMuchAsPossible(this, n, new Long(0, 0));
    };
    protoOf(Input).o3x = function(min, max) {
        if (min === 0 && (max === 0 || this.m3s())) return "";
        var remaining = this.z3q();
        if (remaining.j1(new Long(0, 0)) > 0 && toLong(max).j1(remaining) >= 0) return readTextExactBytes(this, remaining.l1());
        // Inline function 'kotlin.text.buildString' call
        var capacity = coerceAtMost(coerceAtLeast(min, 16), max);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$(capacity);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.Input.readText.<anonymous>' call
        readASCII(this, this_0, min, max);
        return this_0.toString();
    };
    protoOf(Input).p3x = function(min, max, $super) {
        min = min === VOID ? 0 : min;
        max = max === VOID ? 2147483647 : max;
        return $super === VOID ? this.o3x(min, max) : $super.o3x.call(this, min, max);
    };
    protoOf(Input).q3x = function(minSize) {
        return prepareReadLoop(this, minSize, this.s3w());
    };
    protoOf(Input).r3x = function(current) {
        return this.s3x(current);
    };
    protoOf(Input).s3x = function(current) {
        return ensureNext(this, current, Companion_getInstance_2().z3s_1);
    };
    protoOf(Input).t3x = function(current) {
        var tmp0_elvis_lhs = current.z1y();
        var tmp;
        if (tmp0_elvis_lhs == null) return fixGapAfterReadFallback(this, current);
        else tmp = tmp0_elvis_lhs;
        var next = tmp;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var remaining = current.l3p_1 - current.k3p_1 | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        var b = 8 - (current.o3p_1 - current.n3p_1 | 0) | 0;
        var overrunSize = Math.min(remaining, b);
        if (next.m3p_1 < overrunSize) return fixGapAfterReadFallback(this, current);
        restoreStartGap(next, overrunSize);
        if (remaining > overrunSize) {
            current.a3v();
            this.w3q_1 = current.l3p_1;
            // Inline function 'kotlin.Long.plus' call
            var tmp$ret$3 = this.x3q_1.y2(toLong(overrunSize));
            this.i3x(tmp$ret$3);
        } else {
            _set__head__b4pap2(this, next);
            // Inline function 'kotlin.Long.minus' call
            var this_0 = this.x3q_1;
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var other = (next.l3p_1 - next.k3p_1 | 0) - overrunSize | 0;
            var tmp$ret$5 = this_0.z2(toLong(other));
            this.i3x(tmp$ret$5);
            current.m3w();
            current.n3w(this.s3q_1);
        }
    };
    protoOf(Input).g3x = function() {
        var buffer = this.s3q_1.k3w();
        try {
            buffer.u3u(8);
            var tmp = buffer.l3p_1;
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var tmp$ret$0 = buffer.n3p_1 - buffer.l3p_1 | 0;
            var copied = this.h3x(buffer.j3p_1, tmp, tmp$ret$0);
            if (copied === 0) {
                this.y3q_1 = true;
                // Inline function 'io.ktor.utils.io.core.canRead' call
                if (!(buffer.l3p_1 > buffer.k3p_1)) {
                    buffer.n3w(this.s3q_1);
                    return null;
                }
            }
            buffer.p3u(copied);
            return buffer;
        } catch ($p) {
            if ($p instanceof Error) {
                var t = $p;
                buffer.n3w(this.s3q_1);
                throw t;
            } else throw $p;
        }
    };
    protoOf(Input).y3w = function() {
        if (!this.y3q_1) this.y3q_1 = true;
    };
    protoOf(Input).u3x = function(minSize) {
        var head = this.s3w();
        if ((this.w3q_1 - this.v3q_1 | 0) >= minSize) return head;
        return prepareReadLoop(this, minSize, head);
    };
    protoOf(Input).v3x = function(head) {
        var tmp0_elvis_lhs = head.m3w();
        var next = tmp0_elvis_lhs == null ? Companion_getInstance_2().z3s_1 : tmp0_elvis_lhs;
        _set__head__b4pap2(this, next);
        // Inline function 'kotlin.Long.minus' call
        var this_0 = this.x3q_1;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var other = next.l3p_1 - next.k3p_1 | 0;
        var tmp$ret$1 = this_0.z2(toLong(other));
        this.i3x(tmp$ret$1);
        head.n3w(this.s3q_1);
        return next;
    };
    function discard(_this__u8e3s4) {
        return _this__u8e3s4.n3x(new Long(-1, 2147483647));
    }
    function readFully_1(_this__u8e3s4, dst, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? dst.length - offset | 0 : length;
        // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
        // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
        var remaining = length;
        var dstOffset = offset;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            try {
                $l$loop_0: for(;;){
                    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate.<anonymous>' call
                    var buffer = current;
                    // Inline function 'kotlin.comparisons.minOf' call
                    var a = remaining;
                    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                    var b = buffer.l3p_1 - buffer.k3p_1 | 0;
                    var count = Math.min(a, b);
                    // Inline function 'io.ktor.utils.io.core.readFully.<anonymous>' call
                    var dstOffset_0 = dstOffset;
                    readFully(buffer, dst, dstOffset_0, count);
                    remaining = remaining - count | 0;
                    dstOffset = dstOffset + count | 0;
                    if (!(remaining > 0)) break $l$loop_0;
                    release = false;
                    var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
                    var tmp_0;
                    if (tmp1_elvis_lhs == null) break $l$loop_0;
                    else tmp_0 = tmp1_elvis_lhs;
                    var next = tmp_0;
                    current = next;
                    release = true;
                }
            } finally{
                if (release) completeReadHead(_this__u8e3s4, current);
            }
        }
        var this_0 = remaining;
        if (this_0 > 0) prematureEndOfStream(this_0);
    }
    function readFully_2(_this__u8e3s4, dst, length) {
        var tmp;
        if (length === VOID) // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        tmp = dst.n3p_1 - dst.l3p_1 | 0;
        else tmp = length;
        length = tmp;
        // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
        // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
        var remaining = length;
        var dstOffset = 0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
            var tmp_0;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp_0 = tmp0_elvis_lhs;
            var current = tmp_0;
            try {
                $l$loop_0: for(;;){
                    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate.<anonymous>' call
                    var buffer = current;
                    // Inline function 'kotlin.comparisons.minOf' call
                    var a = remaining;
                    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                    var b = buffer.l3p_1 - buffer.k3p_1 | 0;
                    var count = Math.min(a, b);
                    // Inline function 'io.ktor.utils.io.core.readFully.<anonymous>' call
                    readFully_0(buffer, dst, count);
                    remaining = remaining - count | 0;
                    dstOffset = dstOffset + count | 0;
                    if (!(remaining > 0)) break $l$loop_0;
                    release = false;
                    var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
                    var tmp_1;
                    if (tmp1_elvis_lhs == null) break $l$loop_0;
                    else tmp_1 = tmp1_elvis_lhs;
                    var next = tmp_1;
                    current = next;
                    release = true;
                }
            } finally{
                if (release) completeReadHead(_this__u8e3s4, current);
            }
        }
        var this_0 = remaining;
        if (this_0 > 0) prematureEndOfStream(this_0);
    }
    function readShort_0(_this__u8e3s4) {
        var tmp$ret$3;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.readPrimitive' call
            // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
            if ((_this__u8e3s4.w3q_1 - _this__u8e3s4.v3q_1 | 0) > 2) {
                var index = _this__u8e3s4.v3q_1;
                _this__u8e3s4.v3q_1 = index + 2 | 0;
                // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
                // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
                tmp$ret$3 = _this__u8e3s4.u3q_1.n3u_1.getInt16(index, false);
                break $l$block;
            }
            // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
            tmp$ret$3 = readShortFallback(_this__u8e3s4);
        }
        return tmp$ret$3;
    }
    function readShortFallback(_this__u8e3s4) {
        // Inline function 'io.ktor.utils.io.core.readPrimitiveFallback' call
        var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 2);
        var tmp;
        if (tmp0_elvis_lhs == null) prematureEndOfStream(2);
        else tmp = tmp0_elvis_lhs;
        var head = tmp;
        // Inline function 'io.ktor.utils.io.core.readShortFallback.<anonymous>' call
        var value = readShort(head);
        completeReadHead(_this__u8e3s4, head);
        return value;
    }
    function flushChain($this) {
        var tmp0_elvis_lhs = $this.k3n();
        var tmp;
        if (tmp0_elvis_lhs == null) return Unit_instance;
        else tmp = tmp0_elvis_lhs;
        var oldTail = tmp;
        try {
            // Inline function 'io.ktor.utils.io.core.forEachChunk' call
            // Inline function 'kotlin.contracts.contract' call
            var current = oldTail;
            $l$loop: for(;;){
                // Inline function 'io.ktor.utils.io.core.Output.flushChain.<anonymous>' call
                var chunk = current;
                var tmp_0 = chunk.k3p_1;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var tmp$ret$0 = chunk.l3p_1 - chunk.k3p_1 | 0;
                $this.q3w(chunk.j3p_1, tmp_0, tmp$ret$0);
                var tmp0_elvis_lhs_0 = current.z1y();
                var tmp_1;
                if (tmp0_elvis_lhs_0 == null) break $l$loop;
                else tmp_1 = tmp0_elvis_lhs_0;
                current = tmp_1;
            }
        } finally{
            releaseAll(oldTail, $this.c3n_1);
        }
    }
    function appendNewChunk($this) {
        var new_0 = $this.c3n_1.k3w();
        new_0.u3u(8);
        $this.t3w(new_0);
        return new_0;
    }
    function appendChainImpl($this, head, newTail, chainedSizeDelta) {
        var _tail = $this.e3n_1;
        if (_tail == null) {
            $this.d3n_1 = head;
            $this.j3n_1 = 0;
        } else {
            _tail.w3x(head);
            var tailPosition = $this.g3n_1;
            _tail.q3u(tailPosition);
            $this.j3n_1 = $this.j3n_1 + (tailPosition - $this.i3n_1 | 0) | 0;
        }
        $this.e3n_1 = newTail;
        $this.j3n_1 = $this.j3n_1 + chainedSizeDelta | 0;
        $this.f3n_1 = newTail.j3p_1;
        $this.g3n_1 = newTail.l3p_1;
        $this.i3n_1 = newTail.k3p_1;
        $this.h3n_1 = newTail.n3p_1;
    }
    function writeByteFallback($this, v) {
        appendNewChunk($this).d3v(v);
        $this.g3n_1 = $this.g3n_1 + 1 | 0;
    }
    function appendCharFallback($this, c) {
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.Output.write' call
            var buffer = $this.w3w(3);
            try {
                // Inline function 'io.ktor.utils.io.core.Output.appendCharFallback.<anonymous>' call
                // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
                var this_0 = buffer.j3p_1;
                var offset = buffer.l3p_1;
                // Inline function 'kotlin.code' call
                var v = Char__toInt_impl_vasixd(c);
                var tmp;
                if (0 <= v ? v <= 127 : false) {
                    // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
                    var value = toByte(v);
                    this_0.n3u_1.setInt8(offset, value);
                    tmp = 1;
                } else if (128 <= v ? v <= 2047 : false) {
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var value_0 = toByte(192 | v >> 6 & 31);
                    this_0.n3u_1.setInt8(offset, value_0);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index = offset + 1 | 0;
                    var value_1 = toByte(128 | v & 63);
                    this_0.n3u_1.setInt8(index, value_1);
                    tmp = 2;
                } else if (2048 <= v ? v <= 65535 : false) {
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var value_2 = toByte(224 | v >> 12 & 15);
                    this_0.n3u_1.setInt8(offset, value_2);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index_0 = offset + 1 | 0;
                    var value_3 = toByte(128 | v >> 6 & 63);
                    this_0.n3u_1.setInt8(index_0, value_3);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index_1 = offset + 2 | 0;
                    var value_4 = toByte(128 | v & 63);
                    this_0.n3u_1.setInt8(index_1, value_4);
                    tmp = 3;
                } else if (65536 <= v ? v <= 1114111 : false) {
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var value_5 = toByte(240 | v >> 18 & 7);
                    this_0.n3u_1.setInt8(offset, value_5);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index_2 = offset + 1 | 0;
                    var value_6 = toByte(128 | v >> 12 & 63);
                    this_0.n3u_1.setInt8(index_2, value_6);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index_3 = offset + 2 | 0;
                    var value_7 = toByte(128 | v >> 6 & 63);
                    this_0.n3u_1.setInt8(index_3, value_7);
                    // Inline function 'io.ktor.utils.io.bits.set' call
                    var index_4 = offset + 3 | 0;
                    var value_8 = toByte(128 | v & 63);
                    this_0.n3u_1.setInt8(index_4, value_8);
                    tmp = 4;
                } else malformedCodePoint(v);
                var size = tmp;
                buffer.p3u(size);
                var result = size;
                // Inline function 'kotlin.check' call
                // Inline function 'kotlin.contracts.contract' call
                if (!(result >= 0)) {
                    // Inline function 'io.ktor.utils.io.core.Output.write.<anonymous>' call
                    var message = "The returned value shouldn't be negative";
                    throw IllegalStateException_init_$Create$(toString(message));
                }
                break $l$block;
            } finally{
                $this.k3u();
            }
        }
    }
    function writePacketMerging($this, tail, foreignStolen, pool) {
        tail.q3u($this.g3n_1);
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var lastSize = tail.l3p_1 - tail.k3p_1 | 0;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var nextSize = foreignStolen.l3p_1 - foreignStolen.k3p_1 | 0;
        var maxCopySize = get_PACKET_MAX_COPY_SIZE();
        var tmp;
        var tmp_0;
        if (nextSize < maxCopySize) {
            // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
            var tmp_1 = tail.o3p_1 - tail.n3p_1 | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            tmp_0 = nextSize <= (tmp_1 + (tail.n3p_1 - tail.l3p_1 | 0) | 0);
        } else tmp_0 = false;
        if (tmp_0) tmp = nextSize;
        else tmp = -1;
        var appendSize = tmp;
        var tmp_2;
        if (lastSize < maxCopySize && lastSize <= foreignStolen.m3p_1 && isExclusivelyOwned(foreignStolen)) tmp_2 = lastSize;
        else tmp_2 = -1;
        var prependSize = tmp_2;
        if (appendSize === -1 && prependSize === -1) $this.u3w(foreignStolen);
        else if (prependSize === -1 || appendSize <= prependSize) {
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var tmp_3 = tail.n3p_1 - tail.l3p_1 | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
            var tmp$ret$5 = tail.o3p_1 - tail.n3p_1 | 0;
            writeBufferAppend(tail, foreignStolen, tmp_3 + tmp$ret$5 | 0);
            $this.k3u();
            var tmp0_safe_receiver = foreignStolen.m3w();
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            $this.u3w(tmp0_safe_receiver);
            foreignStolen.n3w(pool);
        } else if (appendSize === -1 || prependSize < appendSize) writePacketSlowPrepend($this, foreignStolen, tail);
        else throw IllegalStateException_init_$Create$("prep = " + prependSize + ", app = " + appendSize);
    }
    function writePacketSlowPrepend($this, foreignStolen, tail) {
        writeBufferPrepend(foreignStolen, tail);
        var tmp0_elvis_lhs = $this.d3n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "head should't be null since it is already handled in the fast-path";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        var _head = tmp;
        if (_head === tail) $this.d3n_1 = foreignStolen;
        else {
            var pre = _head;
            $l$loop: while(true){
                var next = ensureNotNull(pre.z1y());
                if (next === tail) break $l$loop;
                pre = next;
            }
            pre.w3x(foreignStolen);
        }
        tail.n3w($this.c3n_1);
        $this.e3n_1 = findTail(foreignStolen);
    }
    function Output(pool) {
        this.c3n_1 = pool;
        this.d3n_1 = null;
        this.e3n_1 = null;
        this.f3n_1 = Companion_getInstance_4().x3x_1;
        this.g3n_1 = 0;
        this.h3n_1 = 0;
        this.i3n_1 = 0;
        this.j3n_1 = 0;
    }
    protoOf(Output).o3w = function() {
        return this.j3n_1 + (this.g3n_1 - this.i3n_1 | 0) | 0;
    };
    protoOf(Output).s3w = function() {
        var tmp0_elvis_lhs = this.d3n_1;
        return tmp0_elvis_lhs == null ? Companion_getInstance_2().z3s_1 : tmp0_elvis_lhs;
    };
    protoOf(Output).e3t = function() {
        flushChain(this);
    };
    protoOf(Output).k3n = function() {
        var tmp0_elvis_lhs = this.d3n_1;
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var head = tmp;
        var tmp1_safe_receiver = this.e3n_1;
        if (tmp1_safe_receiver == null) ;
        else tmp1_safe_receiver.q3u(this.g3n_1);
        this.d3n_1 = null;
        this.e3n_1 = null;
        this.g3n_1 = 0;
        this.h3n_1 = 0;
        this.i3n_1 = 0;
        this.j3n_1 = 0;
        this.f3n_1 = Companion_getInstance_4().x3x_1;
        return head;
    };
    protoOf(Output).t3w = function(buffer) {
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(buffer.z1y() == null)) {
            // Inline function 'io.ktor.utils.io.core.Output.appendSingleChunk.<anonymous>' call
            var message = "It should be a single buffer chunk.";
            throw IllegalStateException_init_$Create$(toString(message));
        }
        appendChainImpl(this, buffer, buffer, 0);
    };
    protoOf(Output).u3w = function(head) {
        var tail = findTail(head);
        // Inline function 'io.ktor.utils.io.core.internal.toIntOrFail' call
        // Inline function 'kotlin.Long.minus' call
        var this_0 = remainingAll(head);
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var other = tail.l3p_1 - tail.k3p_1 | 0;
        var this_1 = this_0.z2(toLong(other));
        var name = "total size increase";
        if (this_1.j1(new Long(2147483647, 0)) >= 0) failLongToIntConversion(this_1, name);
        var chainedSizeDelta = this_1.l1();
        appendChainImpl(this, head, tail, chainedSizeDelta);
    };
    protoOf(Output).d3v = function(v) {
        var index = this.g3n_1;
        if (index < this.h3n_1) {
            this.g3n_1 = index + 1 | 0;
            // Inline function 'io.ktor.utils.io.bits.set' call
            this.f3n_1.n3u_1.setInt8(index, v);
            return Unit_instance;
        }
        return writeByteFallback(this, v);
    };
    protoOf(Output).v3w = function() {
        try {
            this.e3t();
        } finally{
            this.p3w();
        }
    };
    protoOf(Output).f8 = function(value) {
        var tailPosition = this.g3n_1;
        if ((this.h3n_1 - tailPosition | 0) >= 3) {
            // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
            var this_0 = this.f3n_1;
            // Inline function 'kotlin.code' call
            var v = Char__toInt_impl_vasixd(value);
            var tmp;
            if (0 <= v ? v <= 127 : false) {
                // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
                var value_0 = toByte(v);
                this_0.n3u_1.setInt8(tailPosition, value_0);
                tmp = 1;
            } else if (128 <= v ? v <= 2047 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_1 = toByte(192 | v >> 6 & 31);
                this_0.n3u_1.setInt8(tailPosition, value_1);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index = tailPosition + 1 | 0;
                var value_2 = toByte(128 | v & 63);
                this_0.n3u_1.setInt8(index, value_2);
                tmp = 2;
            } else if (2048 <= v ? v <= 65535 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_3 = toByte(224 | v >> 12 & 15);
                this_0.n3u_1.setInt8(tailPosition, value_3);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_0 = tailPosition + 1 | 0;
                var value_4 = toByte(128 | v >> 6 & 63);
                this_0.n3u_1.setInt8(index_0, value_4);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_1 = tailPosition + 2 | 0;
                var value_5 = toByte(128 | v & 63);
                this_0.n3u_1.setInt8(index_1, value_5);
                tmp = 3;
            } else if (65536 <= v ? v <= 1114111 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_6 = toByte(240 | v >> 18 & 7);
                this_0.n3u_1.setInt8(tailPosition, value_6);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_2 = tailPosition + 1 | 0;
                var value_7 = toByte(128 | v >> 12 & 63);
                this_0.n3u_1.setInt8(index_2, value_7);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_3 = tailPosition + 2 | 0;
                var value_8 = toByte(128 | v >> 6 & 63);
                this_0.n3u_1.setInt8(index_3, value_8);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_4 = tailPosition + 3 | 0;
                var value_9 = toByte(128 | v & 63);
                this_0.n3u_1.setInt8(index_4, value_9);
                tmp = 4;
            } else malformedCodePoint(v);
            var size = tmp;
            this.g3n_1 = tailPosition + size | 0;
            return this;
        }
        appendCharFallback(this, value);
        return this;
    };
    protoOf(Output).f = function(value) {
        if (value == null) this.qb("null", 0, 4);
        else this.qb(value, 0, charSequenceLength(value));
        return this;
    };
    protoOf(Output).qb = function(value, startIndex, endIndex) {
        if (value == null) return this.qb("null", startIndex, endIndex);
        writeText(this, value, startIndex, endIndex, Charsets_getInstance().y3x_1);
        return this;
    };
    protoOf(Output).p3t = function(packet) {
        var foreignStolen = packet.k3n();
        if (foreignStolen == null) {
            packet.e19();
            return Unit_instance;
        }
        var tail = this.e3n_1;
        if (tail == null) {
            this.u3w(foreignStolen);
            return Unit_instance;
        }
        writePacketMerging(this, tail, foreignStolen, packet.s3q_1);
    };
    protoOf(Output).l3n = function(chunkBuffer) {
        var _tail = this.e3n_1;
        if (_tail == null) {
            this.u3w(chunkBuffer);
            return Unit_instance;
        }
        writePacketMerging(this, _tail, chunkBuffer, this.c3n_1);
    };
    protoOf(Output).a3r = function(p, n) {
        var remaining = n;
        $l$loop: while(remaining.j1(new Long(0, 0)) > 0){
            // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
            var tmp$ret$0 = p.w3q_1 - p.v3q_1 | 0;
            var headRemaining = toLong(tmp$ret$0);
            if (headRemaining.j1(remaining) <= 0) {
                remaining = remaining.z2(headRemaining);
                var tmp0_elvis_lhs = p.j3x();
                var tmp;
                if (tmp0_elvis_lhs == null) throw new EOFException("Unexpected end of packet");
                else tmp = tmp0_elvis_lhs;
                this.t3w(tmp);
            } else {
                // Inline function 'io.ktor.utils.io.core.read' call
                // Inline function 'kotlin.contracts.contract' call
                var tmp0_elvis_lhs_0 = p.u3x(1);
                var tmp_0;
                if (tmp0_elvis_lhs_0 == null) prematureEndOfStream(1);
                else tmp_0 = tmp0_elvis_lhs_0;
                var buffer = tmp_0;
                var positionBefore = buffer.k3p_1;
                try {
                    // Inline function 'io.ktor.utils.io.core.Output.writePacket.<anonymous>' call
                    writeFully_2(this, buffer, remaining.l1());
                } finally{
                    var positionAfter = buffer.k3p_1;
                    if (positionAfter < positionBefore) throw IllegalStateException_init_$Create$("Buffer's position shouldn't be rewinded");
                    if (positionAfter === buffer.l3p_1) p.s3x(buffer);
                    else p.v3q_1 = positionAfter;
                }
                break $l$loop;
            }
        }
    };
    protoOf(Output).e19 = function() {
        this.v3w();
    };
    protoOf(Output).w3w = function(n) {
        // Inline function 'io.ktor.utils.io.core.Output.tailRemaining' call
        if ((this.h3n_1 - this.g3n_1 | 0) >= n) {
            var tmp0_safe_receiver = this.e3n_1;
            if (tmp0_safe_receiver == null) ;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                tmp0_safe_receiver.q3u(this.g3n_1);
                return tmp0_safe_receiver;
            }
        }
        return appendNewChunk(this);
    };
    protoOf(Output).k3u = function() {
        var tmp0_safe_receiver = this.e3n_1;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.g3n_1 = tmp0_safe_receiver.l3p_1;
    };
    protoOf(Output).x3w = function() {
        var head = this.s3w();
        if (!(head === Companion_getInstance_2().z3s_1)) {
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(head.z1y() == null)) {
                // Inline function 'kotlin.check.<anonymous>' call
                var message = "Check failed.";
                throw IllegalStateException_init_$Create$(toString(message));
            }
            head.w3u();
            head.u3u(8);
            this.g3n_1 = head.l3p_1;
            this.i3n_1 = this.g3n_1;
            this.h3n_1 = head.n3p_1;
        }
    };
    function writeFully_2(_this__u8e3s4, src, length) {
        var tmp;
        if (length === VOID) // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        tmp = src.l3p_1 - src.k3p_1 | 0;
        else tmp = length;
        length = tmp;
        // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
        var currentOffset = 0;
        var remaining = length;
        // Inline function 'io.ktor.utils.io.core.writeWhile' call
        var tail = prepareWriteHead(_this__u8e3s4, 1, null);
        try {
            $l$loop: while(true){
                // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate.<anonymous>' call
                var buffer = tail;
                // Inline function 'kotlin.comparisons.minOf' call
                var a = remaining;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                var b = buffer.n3p_1 - buffer.l3p_1 | 0;
                var size = Math.min(a, b);
                // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
                writeFully_1(buffer, src, size);
                currentOffset = currentOffset + size | 0;
                remaining = remaining - size | 0;
                if (!(remaining > 0)) break $l$loop;
                tail = prepareWriteHead(_this__u8e3s4, 1, tail);
            }
        } finally{
            _this__u8e3s4.k3u();
        }
    }
    function writeFully_3(_this__u8e3s4, src, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? src.length - offset | 0 : length;
        // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
        var currentOffset = offset;
        var remaining = length;
        // Inline function 'io.ktor.utils.io.core.writeWhile' call
        var tail = prepareWriteHead(_this__u8e3s4, 1, null);
        try {
            $l$loop: while(true){
                // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate.<anonymous>' call
                var buffer = tail;
                // Inline function 'kotlin.comparisons.minOf' call
                var a = remaining;
                // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
                var b = buffer.n3p_1 - buffer.l3p_1 | 0;
                var size = Math.min(a, b);
                // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
                var currentOffset_0 = currentOffset;
                writeFully_0(buffer, src, currentOffset_0, size);
                currentOffset = currentOffset + size | 0;
                remaining = remaining - size | 0;
                if (!(remaining > 0)) break $l$loop;
                tail = prepareWriteHead(_this__u8e3s4, 1, tail);
            }
        } finally{
            _this__u8e3s4.k3u();
        }
    }
    function writeShort_0(_this__u8e3s4, value) {
        var tmp$ret$0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.writePrimitiveTemplate' call
            var index = _this__u8e3s4.g3n_1;
            if ((_this__u8e3s4.h3n_1 - index | 0) > 2) {
                _this__u8e3s4.g3n_1 = index + 2 | 0;
                // Inline function 'io.ktor.utils.io.core.writeShort.<anonymous>' call
                // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
                _this__u8e3s4.f3n_1.n3u_1.setInt16(index, value, false);
                tmp$ret$0 = true;
                break $l$block;
            }
            tmp$ret$0 = false;
        }
        if (!tmp$ret$0) writeShortFallback(_this__u8e3s4, value);
    }
    function writeShortFallback(_this__u8e3s4, value) {
        // Inline function 'io.ktor.utils.io.core.writePrimitiveFallbackTemplate' call
        var tail = _this__u8e3s4.w3w(2);
        // Inline function 'io.ktor.utils.io.core.writeShortFallback.<anonymous>' call
        writeShort(tail, value);
        _this__u8e3s4.k3u();
        var tmp$ret$1, tmp$ret$2;
    }
    function readText(_this__u8e3s4, charset, max) {
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        max = max === VOID ? 2147483647 : max;
        return decode(charset.b3y(), _this__u8e3s4, max);
    }
    function readBytes(_this__u8e3s4, n) {
        var tmp;
        if (n === VOID) {
            // Inline function 'io.ktor.utils.io.core.coerceAtMostMaxIntOrFail' call
            var this_0 = _this__u8e3s4.z3q();
            var message = "Unable to convert to a ByteArray: packet is too big";
            if (this_0.j1(new Long(2147483647, 0)) > 0) throw IllegalArgumentException_init_$Create$(message);
            tmp = this_0.l1();
        } else tmp = n;
        n = tmp;
        var tmp_0;
        if (!(n === 0)) {
            // Inline function 'kotlin.also' call
            var this_1 = new Int8Array(n);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.utils.io.core.readBytes.<anonymous>' call
            readFully_1(_this__u8e3s4, this_1, 0, n);
            tmp_0 = this_1;
        } else tmp_0 = get_EmptyByteArray();
        return tmp_0;
    }
    function prematureEndOfStream(size) {
        throw new EOFException("Premature end of stream: expected " + size + " bytes");
    }
    function readTextExactBytes(_this__u8e3s4, bytesCount, charset) {
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        return decodeExactBytes(charset.b3y(), _this__u8e3s4, bytesCount);
    }
    function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        if (charset === Charsets_getInstance().y3x_1) return writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex);
        encodeToImpl(charset.c3y(), _this__u8e3s4, text, fromIndex, toIndex);
    }
    function writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex) {
        var index = fromIndex;
        // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
        var tail = prepareWriteHead(_this__u8e3s4, 1, null);
        try {
            var size;
            $l$loop: while(true){
                // Inline function 'io.ktor.utils.io.core.writeTextUtf8.<anonymous>' call
                var buffer = tail;
                var memory = buffer.j3p_1;
                var dstOffset = buffer.l3p_1;
                var dstLimit = buffer.n3p_1;
                var tmp0_container = encodeUTF8(memory, text, index, toIndex, dstOffset, dstLimit);
                var characters = EncodeResult__component1_impl_36tlhi(tmp0_container);
                var bytes = EncodeResult__component2_impl_3nv7vp(tmp0_container);
                var tmp = index;
                // Inline function 'kotlin.UShort.toInt' call
                index = tmp + (_UShort___get_data__impl__g0245(characters) & 65535) | 0;
                // Inline function 'kotlin.UShort.toInt' call
                var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
                buffer.p3u(tmp$ret$1);
                var tmp_0;
                var tmp_1;
                // Inline function 'kotlin.UShort.toInt' call
                if ((_UShort___get_data__impl__g0245(characters) & 65535) === 0) tmp_1 = index < toIndex;
                else tmp_1 = false;
                if (tmp_1) tmp_0 = 8;
                else if (index < toIndex) tmp_0 = 1;
                else tmp_0 = 0;
                size = tmp_0;
                if (size <= 0) break $l$loop;
                tail = prepareWriteHead(_this__u8e3s4, size, tail);
            }
        } finally{
            _this__u8e3s4.k3u();
        }
    }
    function ChunkBuffer$Companion$EmptyPool$1() {}
    protoOf(ChunkBuffer$Companion$EmptyPool$1).k3w = function() {
        return Companion_getInstance_2().z3s_1;
    };
    protoOf(ChunkBuffer$Companion$EmptyPool$1).d3y = function(instance) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(instance === Companion_getInstance_2().z3s_1)) {
            // Inline function 'io.ktor.utils.io.core.internal.<no name provided>.recycle.<anonymous>' call
            var message = "Only ChunkBuffer.Empty instance could be recycled.";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
    };
    protoOf(ChunkBuffer$Companion$EmptyPool$1).l3w = function(instance) {
        return this.d3y(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    function ChunkBuffer$Companion$NoPool$1() {
        NoPoolImpl.call(this);
    }
    protoOf(ChunkBuffer$Companion$NoPool$1).k3w = function() {
        return new ChunkBuffer(DefaultAllocator_instance.m3v(4096), null, this);
    };
    protoOf(ChunkBuffer$Companion$NoPool$1).d3y = function(instance) {
        DefaultAllocator_instance.o3v(instance.j3p_1);
    };
    protoOf(ChunkBuffer$Companion$NoPool$1).l3w = function(instance) {
        return this.d3y(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    function ChunkBuffer$Companion$NoPoolManuallyManaged$1() {
        NoPoolImpl.call(this);
    }
    protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).k3w = function() {
        throw UnsupportedOperationException_init_$Create$("This pool doesn't support borrow");
    };
    protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).d3y = function(instance) {};
    protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).l3w = function(instance) {
        return this.d3y(instance instanceof ChunkBuffer ? instance : THROW_CCE());
    };
    function appendNext($this, chunk) {
        if (!$this.a3w_1.atomicfu$compareAndSet(null, chunk)) throw IllegalStateException_init_$Create$("This chunk has already a next chunk.");
    }
    function Companion_2() {
        Companion_instance_2 = this;
        var tmp = this;
        tmp.y3s_1 = new ChunkBuffer$Companion$EmptyPool$1();
        this.z3s_1 = new ChunkBuffer(Companion_getInstance_4().x3x_1, null, this.y3s_1);
        var tmp_0 = this;
        tmp_0.a3t_1 = new ChunkBuffer$Companion$NoPool$1();
        var tmp_1 = this;
        tmp_1.b3t_1 = new ChunkBuffer$Companion$NoPoolManuallyManaged$1();
    }
    protoOf(Companion_2).c3t = function() {
        return get_DefaultChunkedBufferPool();
    };
    var Companion_instance_2;
    function Companion_getInstance_2() {
        if (Companion_instance_2 == null) new Companion_2();
        return Companion_instance_2;
    }
    function ChunkBuffer(memory, origin, parentPool) {
        Companion_getInstance_2();
        Buffer.call(this, memory);
        this.z3v_1 = parentPool;
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!!(origin === this)) {
            // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.<anonymous>' call
            var message = "A chunk couldn't be a view of itself.";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        this.a3w_1 = atomic$ref$1(null);
        this.b3w_1 = atomic$int$1(1);
        this.c3w_1 = origin;
    }
    protoOf(ChunkBuffer).w3x = function(newValue) {
        if (newValue == null) this.m3w();
        else appendNext(this, newValue);
    };
    protoOf(ChunkBuffer).z1y = function() {
        return this.a3w_1.kotlinx$atomicfu$value;
    };
    protoOf(ChunkBuffer).g3w = function() {
        return this.b3w_1.kotlinx$atomicfu$value;
    };
    protoOf(ChunkBuffer).m3w = function() {
        return this.a3w_1.atomicfu$getAndSet(null);
    };
    protoOf(ChunkBuffer).e3y = function() {
        // Inline function 'kotlin.let' call
        var tmp0_elvis_lhs = this.c3w_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.duplicate.<anonymous>' call
        var newOrigin = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
        newOrigin.f3y();
        // Inline function 'kotlin.also' call
        var this_0 = new ChunkBuffer(this.j3p_1, newOrigin, this.z3v_1);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.duplicate.<anonymous>.<anonymous>' call
        this.b3v(this_0);
        return this_0;
    };
    protoOf(ChunkBuffer).n3w = function(pool) {
        if (this.g3y()) {
            var origin = this.c3w_1;
            if (!(origin == null)) {
                this.d3w();
                origin.n3w(pool);
            } else {
                var tmp0_elvis_lhs = this.z3v_1;
                var poolToUse = tmp0_elvis_lhs == null ? pool : tmp0_elvis_lhs;
                poolToUse.l3w(this);
            }
        }
    };
    protoOf(ChunkBuffer).d3w = function() {
        if (!this.b3w_1.atomicfu$compareAndSet(0, -1)) throw IllegalStateException_init_$Create$("Unable to unlink: buffer is in use.");
        this.m3w();
        this.c3w_1 = null;
    };
    protoOf(ChunkBuffer).f3y = function() {
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = this.b3w_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.acquire.<anonymous>' call
                if (cur <= 0) throw IllegalStateException_init_$Create$("Unable to acquire chunk: it is already released.");
                var upd = cur + 1 | 0;
                if (this_0.atomicfu$compareAndSet(cur, upd)) break $l$block;
            }
        }
    };
    protoOf(ChunkBuffer).j3w = function() {
        $l$block: {
            // Inline function 'kotlinx.atomicfu.update' call
            var this_0 = this.b3w_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.unpark.<anonymous>' call
                if (cur < 0) throw IllegalStateException_init_$Create$("This instance is already disposed and couldn't be borrowed.");
                if (cur > 0) throw IllegalStateException_init_$Create$("This instance is already in use but somehow appeared in the pool.");
                var upd = 1;
                if (this_0.atomicfu$compareAndSet(cur, upd)) break $l$block;
            }
        }
    };
    protoOf(ChunkBuffer).g3y = function() {
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlinx.atomicfu.updateAndGet' call
            var this_0 = this.b3w_1;
            while(true){
                var cur = this_0.kotlinx$atomicfu$value;
                // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.release.<anonymous>' call
                if (cur <= 0) throw IllegalStateException_init_$Create$("Unable to release: it is already released.");
                var upd = cur - 1 | 0;
                if (this_0.atomicfu$compareAndSet(cur, upd)) {
                    tmp$ret$1 = upd;
                    break $l$block;
                }
            }
        }
        return tmp$ret$1 === 0;
    };
    protoOf(ChunkBuffer).e3v = function() {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.c3w_1 == null)) {
            // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.reset.<anonymous>' call
            var message = "Unable to reset buffer with origin";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        protoOf(Buffer).e3v.call(this);
        this.a3w_1.kotlinx$atomicfu$value = null;
    };
    function isExclusivelyOwned(_this__u8e3s4) {
        return _this__u8e3s4.g3w() === 1;
    }
    function _EncodeResult___init__impl__vkc0cy(value) {
        return value;
    }
    function _EncodeResult___get_value__impl__h0r466($this) {
        return $this;
    }
    function _EncodeResult___init__impl__vkc0cy_0(characters, bytes) {
        // Inline function 'kotlin.UShort.toInt' call
        var tmp = (_UShort___get_data__impl__g0245(characters) & 65535) << 16;
        // Inline function 'kotlin.UShort.toInt' call
        var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
        return _EncodeResult___init__impl__vkc0cy(tmp | tmp$ret$1);
    }
    function _EncodeResult___get_characters__impl__rrxzcv($this) {
        // Inline function 'kotlin.toUShort' call
        // Inline function 'io.ktor.utils.io.bits.highShort' call
        var this_0 = _EncodeResult___get_value__impl__h0r466($this);
        var this_1 = toShort(this_0 >>> 16 | 0);
        return _UShort___init__impl__jigrne(this_1);
    }
    function _EncodeResult___get_bytes__impl__bt0kq0($this) {
        // Inline function 'kotlin.toUShort' call
        // Inline function 'io.ktor.utils.io.bits.lowShort' call
        var this_0 = _EncodeResult___get_value__impl__h0r466($this);
        var this_1 = toShort(this_0 & 65535);
        return _UShort___init__impl__jigrne(this_1);
    }
    function EncodeResult__component1_impl_36tlhi($this) {
        return _EncodeResult___get_characters__impl__rrxzcv($this);
    }
    function EncodeResult__component2_impl_3nv7vp($this) {
        return _EncodeResult___get_bytes__impl__bt0kq0($this);
    }
    function failLongToIntConversion(value, name) {
        throw IllegalArgumentException_init_$Create$("Long value " + value.toString() + " of " + name + " doesn't fit into 32-bit integer");
    }
    function MalformedUTF8InputException(message) {
        Exception_init_$Init$(message, this);
        captureStack(this, MalformedUTF8InputException);
    }
    function malformedByteCount(byteCount) {
        throw new MalformedUTF8InputException("Expected " + byteCount + " more character bytes");
    }
    function isBmpCodePoint(cp) {
        return (cp >>> 16 | 0) === 0;
    }
    function isValidCodePoint(codePoint) {
        return codePoint <= 1114111;
    }
    function malformedCodePoint(value) {
        throw IllegalArgumentException_init_$Create$("Malformed code-point " + value + " found");
    }
    function highSurrogate(cp) {
        return (cp >>> 10 | 0) + 55232 | 0;
    }
    function lowSurrogate(cp) {
        return (cp & 1023) + 56320 | 0;
    }
    function encodeUTF8(_this__u8e3s4, text, from, to, dstOffset, dstLimit) {
        // Inline function 'kotlin.comparisons.minOf' call
        // Inline function 'kotlin.UShort.toInt' call
        var this_0 = _UShort___init__impl__jigrne(-1);
        var b = from + (_UShort___get_data__impl__g0245(this_0) & 65535) | 0;
        var lastCharIndex = Math.min(to, b);
        // Inline function 'kotlin.UShort.toInt' call
        var this_1 = _UShort___init__impl__jigrne(-1);
        var tmp$ret$2 = _UShort___get_data__impl__g0245(this_1) & 65535;
        var resultLimit = coerceAtMost(dstLimit, tmp$ret$2);
        var resultPosition = dstOffset;
        var index = from;
        $l$loop: do {
            if (resultPosition >= resultLimit || index >= lastCharIndex) {
                // Inline function 'kotlin.toUShort' call
                var this_2 = index - from | 0;
                var tmp = _UShort___init__impl__jigrne(toShort(this_2));
                // Inline function 'kotlin.toUShort' call
                var this_3 = resultPosition - dstOffset | 0;
                var tmp$ret$4 = _UShort___init__impl__jigrne(toShort(this_3));
                return _EncodeResult___init__impl__vkc0cy_0(tmp, tmp$ret$4);
            }
            // Inline function 'kotlin.code' call
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            var this_4 = charSequenceGet(text, tmp0);
            var character = Char__toInt_impl_vasixd(this_4) & 65535;
            if ((character & 65408) === 0) {
                // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
                var tmp1 = resultPosition;
                resultPosition = tmp1 + 1 | 0;
                var value = toByte(character);
                _this__u8e3s4.n3u_1.setInt8(tmp1, value);
            } else break $l$loop;
        }while (true);
        index = index - 1 | 0;
        return encodeUTF8Stage1(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
    }
    function encodeUTF8Stage1(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
        var index = index1;
        var resultPosition = resultPosition1;
        var stage1Limit = resultLimit - 3 | 0;
        $l$loop: for(;;){
            var freeSpace = stage1Limit - resultPosition | 0;
            if (freeSpace <= 0 || index >= lastCharIndex) break $l$loop;
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            var character = charSequenceGet(text, tmp0);
            var tmp;
            if (isHighSurrogate(character)) {
                var tmp_0;
                if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) tmp_0 = 63;
                else {
                    var tmp1 = index;
                    index = tmp1 + 1 | 0;
                    tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
                }
                tmp = tmp_0;
            } else // Inline function 'kotlin.code' call
            tmp = Char__toInt_impl_vasixd(character);
            var codepoint = tmp;
            // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
            var offset = resultPosition;
            var tmp_1;
            if (0 <= codepoint ? codepoint <= 127 : false) {
                // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
                var value = toByte(codepoint);
                _this__u8e3s4.n3u_1.setInt8(offset, value);
                tmp_1 = 1;
            } else if (128 <= codepoint ? codepoint <= 2047 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_0 = toByte(192 | codepoint >> 6 & 31);
                _this__u8e3s4.n3u_1.setInt8(offset, value_0);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_0 = offset + 1 | 0;
                var value_1 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_0, value_1);
                tmp_1 = 2;
            } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_2 = toByte(224 | codepoint >> 12 & 15);
                _this__u8e3s4.n3u_1.setInt8(offset, value_2);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_1 = offset + 1 | 0;
                var value_3 = toByte(128 | codepoint >> 6 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_1, value_3);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_2 = offset + 2 | 0;
                var value_4 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_2, value_4);
                tmp_1 = 3;
            } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_5 = toByte(240 | codepoint >> 18 & 7);
                _this__u8e3s4.n3u_1.setInt8(offset, value_5);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_3 = offset + 1 | 0;
                var value_6 = toByte(128 | codepoint >> 12 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_3, value_6);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_4 = offset + 2 | 0;
                var value_7 = toByte(128 | codepoint >> 6 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_4, value_7);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_5 = offset + 3 | 0;
                var value_8 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_5, value_8);
                tmp_1 = 4;
            } else malformedCodePoint(codepoint);
            var size = tmp_1;
            resultPosition = resultPosition + size | 0;
        }
        if (resultPosition === stage1Limit) return encodeUTF8Stage2(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
        // Inline function 'kotlin.toUShort' call
        var this_0 = index - from | 0;
        var tmp_2 = _UShort___init__impl__jigrne(toShort(this_0));
        // Inline function 'kotlin.toUShort' call
        var this_1 = resultPosition - dstOffset | 0;
        var tmp$ret$12 = _UShort___init__impl__jigrne(toShort(this_1));
        return _EncodeResult___init__impl__vkc0cy_0(tmp_2, tmp$ret$12);
    }
    function codePoint(high, low) {
        // Inline function 'kotlin.code' call
        var highValue = Char__toInt_impl_vasixd(high) - 55232 | 0;
        // Inline function 'kotlin.code' call
        var lowValue = Char__toInt_impl_vasixd(low) - 56320 | 0;
        return highValue << 10 | lowValue;
    }
    function encodeUTF8Stage2(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
        var index = index1;
        var resultPosition = resultPosition1;
        $l$loop_0: for(;;){
            var freeSpace = resultLimit - resultPosition | 0;
            if (freeSpace <= 0 || index >= lastCharIndex) break $l$loop_0;
            var tmp0 = index;
            index = tmp0 + 1 | 0;
            var character = charSequenceGet(text, tmp0);
            var tmp;
            if (!isHighSurrogate(character)) // Inline function 'kotlin.code' call
            tmp = Char__toInt_impl_vasixd(character);
            else {
                var tmp_0;
                if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) tmp_0 = 63;
                else {
                    var tmp1 = index;
                    index = tmp1 + 1 | 0;
                    tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
                }
                tmp = tmp_0;
            }
            var codepoint = tmp;
            // Inline function 'io.ktor.utils.io.core.internal.charactersSize' call
            var tmp_1;
            if (1 <= codepoint ? codepoint <= 127 : false) tmp_1 = 1;
            else if (128 <= codepoint ? codepoint <= 2047 : false) tmp_1 = 2;
            else if (2048 <= codepoint ? codepoint <= 65535 : false) tmp_1 = 3;
            else if (65536 <= codepoint ? codepoint <= 1114111 : false) tmp_1 = 4;
            else malformedCodePoint(codepoint);
            if (tmp_1 > freeSpace) {
                index = index - 1 | 0;
                break $l$loop_0;
            }
            // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
            var offset = resultPosition;
            var tmp_2;
            if (0 <= codepoint ? codepoint <= 127 : false) {
                // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
                var value = toByte(codepoint);
                _this__u8e3s4.n3u_1.setInt8(offset, value);
                tmp_2 = 1;
            } else if (128 <= codepoint ? codepoint <= 2047 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_0 = toByte(192 | codepoint >> 6 & 31);
                _this__u8e3s4.n3u_1.setInt8(offset, value_0);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_0 = offset + 1 | 0;
                var value_1 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_0, value_1);
                tmp_2 = 2;
            } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_2 = toByte(224 | codepoint >> 12 & 15);
                _this__u8e3s4.n3u_1.setInt8(offset, value_2);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_1 = offset + 1 | 0;
                var value_3 = toByte(128 | codepoint >> 6 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_1, value_3);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_2 = offset + 2 | 0;
                var value_4 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_2, value_4);
                tmp_2 = 3;
            } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
                // Inline function 'io.ktor.utils.io.bits.set' call
                var value_5 = toByte(240 | codepoint >> 18 & 7);
                _this__u8e3s4.n3u_1.setInt8(offset, value_5);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_3 = offset + 1 | 0;
                var value_6 = toByte(128 | codepoint >> 12 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_3, value_6);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_4 = offset + 2 | 0;
                var value_7 = toByte(128 | codepoint >> 6 & 63);
                _this__u8e3s4.n3u_1.setInt8(index_4, value_7);
                // Inline function 'io.ktor.utils.io.bits.set' call
                var index_5 = offset + 3 | 0;
                var value_8 = toByte(128 | codepoint & 63);
                _this__u8e3s4.n3u_1.setInt8(index_5, value_8);
                tmp_2 = 4;
            } else malformedCodePoint(codepoint);
            var size = tmp_2;
            resultPosition = resultPosition + size | 0;
        }
        // Inline function 'kotlin.toUShort' call
        var this_0 = index - from | 0;
        var tmp_3 = _UShort___init__impl__jigrne(toShort(this_0));
        // Inline function 'kotlin.toUShort' call
        var this_1 = resultPosition - dstOffset | 0;
        var tmp$ret$13 = _UShort___init__impl__jigrne(toShort(this_1));
        return _EncodeResult___init__impl__vkc0cy_0(tmp_3, tmp$ret$13);
    }
    function get_EmptyByteArray() {
        _init_properties_Unsafe_kt__orlvcq();
        return EmptyByteArray;
    }
    var EmptyByteArray;
    function completeReadHead(_this__u8e3s4, current) {
        _init_properties_Unsafe_kt__orlvcq();
        if (current === _this__u8e3s4) return Unit_instance;
        else {
            // Inline function 'io.ktor.utils.io.core.canRead' call
            if (!(current.l3p_1 > current.k3p_1)) _this__u8e3s4.s3x(current);
            else // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
            if ((current.o3p_1 - current.n3p_1 | 0) < 8) _this__u8e3s4.t3x(current);
            else _this__u8e3s4.v3q_1 = current.k3p_1;
        }
    }
    function prepareReadFirstHead(_this__u8e3s4, minSize) {
        _init_properties_Unsafe_kt__orlvcq();
        return _this__u8e3s4.q3x(minSize);
    }
    function prepareReadNextHead(_this__u8e3s4, current) {
        _init_properties_Unsafe_kt__orlvcq();
        if (current === _this__u8e3s4) return _this__u8e3s4.p3r() ? _this__u8e3s4 : null;
        return _this__u8e3s4.r3x(current);
    }
    function unsafeAppend(_this__u8e3s4, builder) {
        _init_properties_Unsafe_kt__orlvcq();
        var builderSize = builder.m();
        var tmp0_elvis_lhs = builder.k3n();
        var tmp;
        if (tmp0_elvis_lhs == null) return 0;
        else tmp = tmp0_elvis_lhs;
        var builderHead = tmp;
        if (builderSize <= get_PACKET_MAX_COPY_SIZE() && builderHead.z1y() == null && _this__u8e3s4.l3x(builderHead)) {
            builder.x3w();
            return builderSize;
        }
        _this__u8e3s4.k3x(builderHead);
        return builderSize;
    }
    function prepareWriteHead(_this__u8e3s4, capacity, current) {
        _init_properties_Unsafe_kt__orlvcq();
        if (!(current == null)) _this__u8e3s4.k3u();
        return _this__u8e3s4.w3w(capacity);
    }
    var properties_initialized_Unsafe_kt_o5mw48;
    function _init_properties_Unsafe_kt__orlvcq() {
        if (!properties_initialized_Unsafe_kt_o5mw48) {
            properties_initialized_Unsafe_kt_o5mw48 = true;
            EmptyByteArray = new Int8Array(0);
        }
    }
    function trySuspend($this, sleepCondition, $completion) {
        var tmp = new $trySuspendCOROUTINE$53($this, sleepCondition, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function $sleepCOROUTINE$52(_this__u8e3s4, sleepCondition, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.b3z_1 = _this__u8e3s4;
        this.c3z_1 = sleepCondition;
    }
    protoOf($sleepCOROUTINE$52).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = trySuspend(this.b3z_1, this.c3z_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    if (suspendResult) return Unit_instance;
                    else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.b3z_1.s3m();
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $trySuspendCOROUTINE$53(_this__u8e3s4, sleepCondition, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.p3y_1 = _this__u8e3s4;
        this.q3y_1 = sleepCondition;
    }
    protoOf($trySuspendCOROUTINE$53).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.r3y_1 = false;
                    this.s3y_1 = Job_0();
                    if (this.p3y_1.r3m_1.atomicfu$compareAndSet(null, this.s3y_1) && this.q3y_1()) {
                        this.r3y_1 = true;
                        this.v8_1 = 1;
                        suspendResult = this.s3y_1.t1s(this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    return this.r3y_1;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function AwaitingSlot() {
        this.r3m_1 = atomic$ref$1(null);
    }
    protoOf(AwaitingSlot).n3o = function(sleepCondition, $completion) {
        var tmp = new $sleepCOROUTINE$52(this, sleepCondition, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(AwaitingSlot).s3m = function() {
        var tmp0_safe_receiver = this.r3m_1.atomicfu$getAndSet(null);
        if (tmp0_safe_receiver == null) ;
        else tmp0_safe_receiver.s1s();
    };
    protoOf(AwaitingSlot).n3t = function(cause) {
        var tmp0_elvis_lhs = this.r3m_1.atomicfu$getAndSet(null);
        var tmp;
        if (tmp0_elvis_lhs == null) return Unit_instance;
        else tmp = tmp0_elvis_lhs;
        var continuation = tmp;
        if (!(cause == null)) continuation.r1s(cause);
        else continuation.s1s();
    };
    function copyToSequentialImpl(_this__u8e3s4, dst, limit, $completion) {
        var tmp = new $copyToSequentialImplCOROUTINE$54(_this__u8e3s4, dst, limit, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function copyToTail(_this__u8e3s4, dst, limit, $completion) {
        var tmp = new $copyToTailCOROUTINE$55(_this__u8e3s4, dst, limit, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function $copyToSequentialImplCOROUTINE$54(_this__u8e3s4, dst, limit, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.l3z_1 = _this__u8e3s4;
        this.m3z_1 = dst;
        this.n3z_1 = limit;
    }
    protoOf($copyToSequentialImplCOROUTINE$54).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 10;
                    if (!!(this.l3z_1 === this.m3z_1)) {
                        var message = "Failed requirement.";
                        throw IllegalArgumentException_init_$Create$(toString(message));
                    }
                    if (!(this.l3z_1.m3n() == null)) {
                        this.m3z_1.j21(this.l3z_1.m3n());
                        return new Long(0, 0);
                    }
                    this.o3z_1 = this.n3z_1;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!(this.o3z_1.j1(new Long(0, 0)) > 0)) {
                        this.v8_1 = 9;
                        continue $sm;
                    }
                    this.v8_1 = 2;
                    suspendResult = this.l3z_1.m3t(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.p3z_1 = suspendResult;
                    if (!this.p3z_1) {
                        this.v8_1 = 9;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    this.q3z_1 = this.l3z_1.o3t(this.m3z_1, this.o3z_1);
                    if (this.q3z_1.equals(new Long(0, 0))) {
                        this.v8_1 = 6;
                        suspendResult = copyToTail(this.l3z_1, this.m3z_1, this.o3z_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else if (this.m3z_1.b3o() === 0) {
                        this.v8_1 = 4;
                        suspendResult = this.m3z_1.i3p(1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 4:
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    this.r3z_1 = this.q3z_1;
                    this.v8_1 = 8;
                    continue $sm;
                case 6:
                    var tail = suspendResult;
                    if (tail.equals(new Long(0, 0))) {
                        this.v8_1 = 9;
                        continue $sm;
                    } else {
                        this.v8_1 = 7;
                        continue $sm;
                    }
                case 7:
                    this.r3z_1 = tail;
                    this.v8_1 = 8;
                    continue $sm;
                case 8:
                    var copied = this.r3z_1;
                    this.o3z_1 = this.o3z_1.z2(copied);
                    if (copied.j1(new Long(0, 0)) > 0) this.m3z_1.e3t();
                    this.v8_1 = 1;
                    continue $sm;
                case 9:
                    return this.n3z_1.z2(this.o3z_1);
                case 10:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 10) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $copyToTailCOROUTINE$55(_this__u8e3s4, dst, limit, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.a40_1 = _this__u8e3s4;
        this.b40_1 = dst;
        this.c40_1 = limit;
    }
    protoOf($copyToTailCOROUTINE$55).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 9;
                    this.d40_1 = Companion_getInstance_2().c3t().k3w();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.w8_1 = 8;
                    this.d40_1.x3u(coerceAtMost_0(this.c40_1, toLong(this.d40_1.o3p_1)).l1());
                    this.v8_1 = 3;
                    suspendResult = this.a40_1.j3t(this.d40_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    this.f40_1 = suspendResult;
                    if (this.f40_1 === -1) {
                        this.d40_1.n3w(Companion_getInstance_2().c3t());
                        this.e40_1 = new Long(0, 0);
                        this.w8_1 = 9;
                        this.v8_1 = 6;
                        continue $sm;
                    } else {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                case 4:
                    this.v8_1 = 5;
                    suspendResult = this.b40_1.f3t(this.d40_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 5:
                    this.e40_1 = toLong(this.f40_1);
                    this.w8_1 = 9;
                    this.v8_1 = 6;
                    var tmp_0 = this;
                    continue $sm;
                case 6:
                    var tmp_1 = this.e40_1;
                    this.w8_1 = 9;
                    this.d40_1.n3w(Companion_getInstance_2().c3t());
                    return tmp_1;
                case 7:
                    this.w8_1 = 9;
                    this.d40_1.n3w(Companion_getInstance_2().c3t());
                    return Unit_instance;
                case 8:
                    this.w8_1 = 9;
                    var t = this.y8_1;
                    this.d40_1.n3w(Companion_getInstance_2().c3t());
                    throw t;
                case 9:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 9) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function get_ByteArrayPool() {
        _init_properties_ByteArrayPool_kt__kfi3uj();
        return ByteArrayPool;
    }
    var ByteArrayPool;
    function ByteArrayPool$1() {
        DefaultPool.call(this, 128);
    }
    protoOf(ByteArrayPool$1).l3v = function() {
        return new Int8Array(4096);
    };
    var properties_initialized_ByteArrayPool_kt_td6pfh;
    function _init_properties_ByteArrayPool_kt__kfi3uj() {
        if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
            properties_initialized_ByteArrayPool_kt_td6pfh = true;
            ByteArrayPool = new ByteArrayPool$1();
        }
    }
    function NoPoolImpl() {}
    protoOf(NoPoolImpl).l3w = function(instance) {};
    function ByteChannel(autoFlush) {
        autoFlush = autoFlush === VOID ? false : autoFlush;
        return new ByteChannelJS(Companion_getInstance_2().z3s_1, autoFlush);
    }
    function copyTo(_this__u8e3s4, dst, limit, $completion) {
        var tmp = _this__u8e3s4 instanceof ByteChannelSequentialBase ? _this__u8e3s4 : THROW_CCE();
        return copyToSequentialImpl(tmp, dst instanceof ByteChannelSequentialBase ? dst : THROW_CCE(), limit, $completion);
    }
    function ByteReadChannel_0(content, offset, length) {
        // Inline function 'kotlin.collections.isEmpty' call
        if (content.length === 0) return Companion_getInstance_3().m3u();
        var head = Companion_getInstance_2().c3t().k3w();
        var tail = head;
        var start = offset;
        var end = start + length | 0;
        $l$loop: while(true){
            tail.u3u(8);
            // Inline function 'kotlin.comparisons.minOf' call
            var a = end - start | 0;
            // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
            var this_0 = tail;
            var b = this_0.n3p_1 - this_0.l3p_1 | 0;
            var size = Math.min(a, b);
            writeFully_0(tail instanceof Buffer ? tail : THROW_CCE(), content, start, size);
            start = start + size | 0;
            if (start === end) break $l$loop;
            var current = tail;
            tail = Companion_getInstance_2().c3t().k3w();
            current.w3x(tail);
        }
        // Inline function 'kotlin.apply' call
        var this_1 = new ByteChannelJS(head, false);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.ByteReadChannel.<anonymous>' call
        close(this_1);
        return this_1;
    }
    function ByteChannelJS$attachJob$lambda(this$0) {
        return function(cause) {
            this$0.y40_1 = null;
            var tmp;
            if (!(cause == null)) {
                this$0.p1r(unwrapCancellationException(cause));
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function ByteChannelJS(initial, autoFlush) {
        ByteChannelSequentialBase.call(this, initial, autoFlush);
        this.y40_1 = null;
    }
    protoOf(ByteChannelJS).q3t = function(job) {
        var tmp0_safe_receiver = this.y40_1;
        if (tmp0_safe_receiver == null) ;
        else tmp0_safe_receiver.c1o();
        this.y40_1 = job;
        job.y1n(true, VOID, ByteChannelJS$attachJob$lambda(this));
    };
    protoOf(ByteChannelJS).toString = function() {
        return "ByteChannel[" + toString_1(this.y40_1) + ", " + hashCode(this) + "]";
    };
    function ByteReadChannel$Companion$Empty$delegate$lambda() {
        // Inline function 'kotlin.apply' call
        var this_0 = new ByteChannelJS(Companion_getInstance_2().z3s_1, false);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.Companion.Empty$delegate.<anonymous>.<anonymous>' call
        this_0.j21(null);
        return this_0;
    }
    function Companion_3() {
        Companion_instance_3 = this;
        var tmp = this;
        tmp.j40_1 = lazy(ByteReadChannel$Companion$Empty$delegate$lambda);
    }
    protoOf(Companion_3).m3u = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.j40_1;
        Empty$factory();
        return this_0.b1();
    };
    var Companion_instance_3;
    function Companion_getInstance_3() {
        if (Companion_instance_3 == null) new Companion_3();
        return Companion_instance_3;
    }
    function ByteReadChannel_1() {}
    function Empty$factory() {
        return getPropertyCallableRef("Empty", 1, KProperty1, function(receiver) {
            return receiver.m3u();
        }, null);
    }
    function DefaultAllocator() {}
    protoOf(DefaultAllocator).m3v = function(size) {
        return new Memory(new DataView(new ArrayBuffer(size)));
    };
    protoOf(DefaultAllocator).o3v = function(instance) {};
    var DefaultAllocator_instance;
    function DefaultAllocator_getInstance() {
        return DefaultAllocator_instance;
    }
    function of(_this__u8e3s4, array, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? array.length - offset | 0 : length;
        // Inline function 'kotlin.js.asDynamic' call
        var typedArray = array;
        return of_0(Companion_getInstance_4(), typedArray, offset, length);
    }
    function of_0(_this__u8e3s4, view, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? view.byteLength : length;
        return of_1(Companion_getInstance_4(), view.buffer, view.byteOffset + offset | 0, length);
    }
    function of_1(_this__u8e3s4, buffer, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? buffer.byteLength - offset | 0 : length;
        return new Memory(new DataView(buffer, offset, length));
    }
    function Companion_4() {
        Companion_instance_4 = this;
        this.x3x_1 = new Memory(new DataView(new ArrayBuffer(0)));
    }
    var Companion_instance_4;
    function Companion_getInstance_4() {
        if (Companion_instance_4 == null) new Companion_4();
        return Companion_instance_4;
    }
    function Memory(view) {
        Companion_getInstance_4();
        this.n3u_1 = view;
    }
    protoOf(Memory).z40 = function(offset, length) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(offset >= 0)) {
            // Inline function 'io.ktor.utils.io.bits.Memory.slice.<anonymous>' call
            var message = "offset shouldn't be negative: " + offset;
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length >= 0)) {
            // Inline function 'io.ktor.utils.io.bits.Memory.slice.<anonymous>' call
            var message_0 = "length shouldn't be negative: " + length;
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        var tmp = toLong(offset + length | 0);
        // Inline function 'io.ktor.utils.io.bits.Memory.size' call
        var tmp$ret$2 = toLong(this.n3u_1.byteLength);
        if (tmp.j1(tmp$ret$2) > 0) {
            // Inline function 'io.ktor.utils.io.bits.Memory.size' call
            var tmp$ret$3 = toLong(this.n3u_1.byteLength);
            throw IndexOutOfBoundsException_init_$Create$("offset + length > size: " + offset + " + " + length + " > " + tmp$ret$3.toString());
        }
        return new Memory(new DataView(this.n3u_1.buffer, this.n3u_1.byteOffset + offset | 0, length));
    };
    protoOf(Memory).f3v = function(destination, offset, length, destinationOffset) {
        var src = new Int8Array(this.n3u_1.buffer, this.n3u_1.byteOffset + offset | 0, length);
        var dst = new Int8Array(destination.n3u_1.buffer, destination.n3u_1.byteOffset + destinationOffset | 0, length);
        dst.set(src);
    };
    function copyTo_0(_this__u8e3s4, destination, offset, length, destinationOffset) {
        copyTo_2(_this__u8e3s4.buffer, destination, offset + _this__u8e3s4.byteOffset | 0, length, destinationOffset);
    }
    function copyTo_1(_this__u8e3s4, destination, offset, length, destinationOffset) {
        // Inline function 'kotlin.js.asDynamic' call
        var to = destination;
        var from = new Int8Array(_this__u8e3s4.n3u_1.buffer, _this__u8e3s4.n3u_1.byteOffset + offset | 0, length);
        to.set(from, destinationOffset);
    }
    function copyTo_2(_this__u8e3s4, destination, offset, length, destinationOffset) {
        var from = new Int8Array(_this__u8e3s4, offset, length);
        var to = new Int8Array(destination.n3u_1.buffer, destination.n3u_1.byteOffset + destinationOffset | 0, length);
        to.set(from, 0);
    }
    function Companion_5() {}
    protoOf(Companion_5).a41 = function(name) {
        switch(name){
            case "UTF-8":
            case "utf-8":
            case "UTF8":
            case "utf8":
                return Charsets_getInstance().y3x_1;
        }
        var tmp;
        var tmp_0;
        var tmp_1;
        switch(name){
            case "ISO-8859-1":
            case "iso-8859-1":
                tmp_1 = true;
                break;
            default:
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.utils.io.charsets.Companion.forName.<anonymous>' call
                var it = replace(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
                var tmp_2;
                if (it === "iso-8859-1") tmp_2 = true;
                else // Inline function 'kotlin.text.lowercase' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_2 = it.toLowerCase() === "iso-8859-1";
                tmp_1 = tmp_2;
                break;
        }
        if (tmp_1) tmp_0 = true;
        else tmp_0 = name === "latin1";
        if (tmp_0) tmp = true;
        else tmp = name === "Latin1";
        if (tmp) return Charsets_getInstance().z3x_1;
        throw IllegalArgumentException_init_$Create$("Charset " + name + " is not supported");
    };
    protoOf(Companion_5).b41 = function(charset) {
        var tmp;
        switch(charset){
            case "UTF-8":
            case "utf-8":
            case "UTF8":
            case "utf8":
                tmp = true;
                break;
            default:
                var tmp_0;
                var tmp_1;
                switch(charset){
                    case "ISO-8859-1":
                    case "iso-8859-1":
                        tmp_1 = true;
                        break;
                    default:
                        // Inline function 'kotlin.let' call
                        // Inline function 'kotlin.contracts.contract' call
                        // Inline function 'io.ktor.utils.io.charsets.Companion.isSupported.<anonymous>' call
                        var it = replace(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
                        var tmp_2;
                        if (it === "iso-8859-1") tmp_2 = true;
                        else // Inline function 'kotlin.text.lowercase' call
                        // Inline function 'kotlin.js.asDynamic' call
                        tmp_2 = it.toLowerCase() === "iso-8859-1";
                        tmp_1 = tmp_2;
                        break;
                }
                if (tmp_1) tmp_0 = true;
                else tmp_0 = charset === "latin1";
                if (tmp_0) tmp = true;
                else tmp = false;
                break;
        }
        return tmp;
    };
    var Companion_instance_5;
    function Companion_getInstance_5() {
        return Companion_instance_5;
    }
    function Charset(_name) {
        this.a3y_1 = _name;
    }
    protoOf(Charset).equals = function(other) {
        if (this === other) return true;
        if (other == null || !(this.constructor == other.constructor)) return false;
        if (!(other instanceof Charset)) THROW_CCE();
        if (!(this.a3y_1 === other.a3y_1)) return false;
        return true;
    };
    protoOf(Charset).hashCode = function() {
        return getStringHashCode(this.a3y_1);
    };
    protoOf(Charset).toString = function() {
        return this.a3y_1;
    };
    function get_name(_this__u8e3s4) {
        return _this__u8e3s4.a3y_1;
    }
    function Charsets() {
        Charsets_instance = this;
        this.y3x_1 = new CharsetImpl("UTF-8");
        this.z3x_1 = new CharsetImpl("ISO-8859-1");
    }
    var Charsets_instance;
    function Charsets_getInstance() {
        if (Charsets_instance == null) new Charsets();
        return Charsets_instance;
    }
    function MalformedInputException(message) {
        extendThrowable(this, message);
        captureStack(this, MalformedInputException);
    }
    function CharsetDecoder(_charset) {
        this.c41_1 = _charset;
    }
    function encodeToByteArray(_this__u8e3s4, input, fromIndex, toIndex) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
        return encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex);
    }
    function CharsetEncoder(_charset) {
        this.d41_1 = _charset;
    }
    function CharsetImpl(name) {
        Charset.call(this, name);
        this.f41_1 = name;
    }
    protoOf(CharsetImpl).c3y = function() {
        return new CharsetEncoderImpl(this);
    };
    protoOf(CharsetImpl).b3y = function() {
        return new CharsetDecoderImpl(this);
    };
    protoOf(CharsetImpl).toString = function() {
        return "CharsetImpl(name=" + this.f41_1 + ")";
    };
    protoOf(CharsetImpl).hashCode = function() {
        return getStringHashCode(this.f41_1);
    };
    protoOf(CharsetImpl).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CharsetImpl)) return false;
        var tmp0_other_with_cast = other instanceof CharsetImpl ? other : THROW_CCE();
        if (!(this.f41_1 === tmp0_other_with_cast.f41_1)) return false;
        return true;
    };
    function encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex) {
        fromIndex = fromIndex === VOID ? 0 : fromIndex;
        toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
        var start = fromIndex;
        if (start >= toIndex) return get_EmptyByteArray();
        var single = Companion_getInstance_2().c3t().k3w();
        try {
            var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, single);
            start = start + rc | 0;
            if (start === toIndex) {
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var tmp$ret$0 = single.l3p_1 - single.k3p_1 | 0;
                var result = new Int8Array(tmp$ret$0);
                // Inline function 'io.ktor.utils.io.core.readFully' call
                var length = result.length - 0 | 0;
                readFully(single instanceof Buffer ? single : THROW_CCE(), result, 0, length);
                return result;
            }
            var tmp$ret$1;
            $l$block: {
                // Inline function 'io.ktor.utils.io.core.buildPacket' call
                // Inline function 'kotlin.contracts.contract' call
                var builder = new BytePacketBuilder();
                try {
                    // Inline function 'io.ktor.utils.io.charsets.encodeToByteArrayImpl1.<anonymous>' call
                    builder.t3w(single.e3y());
                    encodeToImpl(_this__u8e3s4, builder, input, start, toIndex);
                    tmp$ret$1 = builder.c3r();
                    break $l$block;
                } catch ($p) {
                    if ($p instanceof Error) {
                        var t = $p;
                        builder.e19();
                        throw t;
                    } else throw $p;
                }
            }
            return readBytes(tmp$ret$1);
        } finally{
            single.n3w(Companion_getInstance_2().c3t());
        }
    }
    function CharsetEncoderImpl(charset) {
        CharsetEncoder.call(this, charset);
        this.h41_1 = charset;
    }
    protoOf(CharsetEncoderImpl).toString = function() {
        return "CharsetEncoderImpl(charset=" + this.h41_1.toString() + ")";
    };
    protoOf(CharsetEncoderImpl).hashCode = function() {
        return this.h41_1.hashCode();
    };
    protoOf(CharsetEncoderImpl).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CharsetEncoderImpl)) return false;
        var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
        if (!this.h41_1.equals(tmp0_other_with_cast.h41_1)) return false;
        return true;
    };
    function CharsetDecoderImpl(charset) {
        CharsetDecoder.call(this, charset);
        this.j41_1 = charset;
    }
    protoOf(CharsetDecoderImpl).toString = function() {
        return "CharsetDecoderImpl(charset=" + this.j41_1.toString() + ")";
    };
    protoOf(CharsetDecoderImpl).hashCode = function() {
        return this.j41_1.hashCode();
    };
    protoOf(CharsetDecoderImpl).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CharsetDecoderImpl)) return false;
        var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
        if (!this.j41_1.equals(tmp0_other_with_cast.j41_1)) return false;
        return true;
    };
    function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(fromIndex <= toIndex)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = "Failed requirement.";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        if (get_charset(_this__u8e3s4).equals(Charsets_getInstance().z3x_1)) return encodeISO88591(input, fromIndex, toIndex, dst);
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(get_charset(_this__u8e3s4) === Charsets_getInstance().y3x_1)) {
            // Inline function 'io.ktor.utils.io.charsets.encodeImpl.<anonymous>' call
            var message_0 = "Only UTF-8 encoding is supported in JS";
            throw IllegalArgumentException_init_$Create$(toString(message_0));
        }
        var encoder = new TextEncoder();
        var start = fromIndex;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var dstRemaining = dst.n3p_1 - dst.l3p_1 | 0;
        $l$loop: while(start < toIndex && dstRemaining > 0){
            // Inline function 'kotlin.comparisons.minOf' call
            var a = toIndex - start | 0;
            var b = dstRemaining / 6 | 0;
            var tmp$ret$3 = Math.min(a, b);
            var numChars = coerceAtLeast(tmp$ret$3, 1);
            var dropLastChar = isHighSurrogate(charSequenceGet(input, (start + numChars | 0) - 1 | 0));
            var endIndexExclusive = dropLastChar && numChars === 1 ? start + 2 | 0 : dropLastChar ? (start + numChars | 0) - 1 | 0 : start + numChars | 0;
            // Inline function 'kotlin.text.substring' call
            var startIndex = start;
            var tmp$ret$4 = toString(charSequenceSubSequence(input, startIndex, endIndexExclusive));
            var array1 = encoder.encode(tmp$ret$4);
            if (array1.length > dstRemaining) break $l$loop;
            writeFully_4(dst, array1);
            start = endIndexExclusive;
            dstRemaining = dstRemaining - array1.length | 0;
        }
        return start - fromIndex | 0;
    }
    function get_charset(_this__u8e3s4) {
        return _this__u8e3s4.d41_1;
    }
    function decode_0(_this__u8e3s4, input, dst, max) {
        var decoder = Decoder(get_name(get_charset_0(_this__u8e3s4)), true);
        var charactersCopied = 0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead(input, 1);
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            var size = 1;
            try {
                $l$loop: do {
                    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                    var this_0 = current;
                    var before = this_0.l3p_1 - this_0.k3p_1 | 0;
                    var after;
                    if (before >= size) try {
                        var tmp$ret$3;
                        $l$block_0: {
                            // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
                            var buffer = current;
                            var rem = max - charactersCopied | 0;
                            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                            var bufferSize = buffer.l3p_1 - buffer.k3p_1 | 0;
                            if (rem < bufferSize) {
                                tmp$ret$3 = 0;
                                break $l$block_0;
                            }
                            // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                            // Inline function 'kotlin.contracts.contract' call
                            // Inline function 'io.ktor.utils.io.core.read' call
                            // Inline function 'kotlin.contracts.contract' call
                            // Inline function 'io.ktor.utils.io.core.readDirectInt8Array.<anonymous>' call
                            var memory = buffer.j3p_1;
                            var start = buffer.k3p_1;
                            var endExclusive = buffer.l3p_1;
                            // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>' call
                            var view = new Int8Array(memory.n3u_1.buffer, memory.n3u_1.byteOffset + start | 0, endExclusive - start | 0);
                            $l$block_2: // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                            try {
                                // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>.<anonymous>' call
                                var tmp$ret$4;
                                $l$block_1: // Inline function 'io.ktor.utils.io.js.decodeStream' call
                                // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                                try {
                                    tmp$ret$4 = decoder.k41(view, decodeOptions(true));
                                    break $l$block_1;
                                } catch ($p) {
                                    if ($p instanceof Error) {
                                        var t = $p;
                                        var tmp0_elvis_lhs_0 = t.message;
                                        throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_0 == null ? "no cause provided" : tmp0_elvis_lhs_0));
                                    } else throw $p;
                                }
                                break $l$block_2;
                            } catch ($p) {
                                if ($p instanceof Error) {
                                    var t_0 = $p;
                                    var tmp0_elvis_lhs_1 = t_0.message;
                                    throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_1 == null ? "no cause provided" : tmp0_elvis_lhs_1));
                                } else throw $p;
                            }
                            var decodedText = tmp$ret$4;
                            dst.f(decodedText);
                            charactersCopied = charactersCopied + decodedText.length | 0;
                            var rc = view.byteLength;
                            buffer.o3u(rc);
                            var tmp_0;
                            if (charactersCopied === max) {
                                var tmp_1;
                                try {
                                    tmp_1 = decoder.l41();
                                } catch ($p) {
                                    var tmp_2;
                                    var _ = $p;
                                    tmp_2 = "";
                                    tmp_1 = tmp_2;
                                }
                                var tail = tmp_1;
                                // Inline function 'kotlin.text.isNotEmpty' call
                                if (charSequenceLength(tail) > 0) buffer.s3u(bufferSize);
                                tmp_0 = 0;
                            } else if (charactersCopied < max) tmp_0 = 8;
                            else tmp_0 = 0;
                            tmp$ret$3 = tmp_0;
                        }
                        size = tmp$ret$3;
                    } finally{
                        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                        var this_1 = current;
                        after = this_1.l3p_1 - this_1.k3p_1 | 0;
                    }
                    else after = before;
                    release = false;
                    var tmp_3;
                    if (after === 0) tmp_3 = prepareReadNextHead(input, current);
                    else {
                        var tmp_4;
                        if (after < size) tmp_4 = true;
                        else {
                            // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                            var this_2 = current;
                            tmp_4 = (this_2.o3p_1 - this_2.n3p_1 | 0) < 8;
                        }
                        if (tmp_4) {
                            completeReadHead(input, current);
                            tmp_3 = prepareReadFirstHead(input, size);
                        } else tmp_3 = current;
                    }
                    var tmp1_elvis_lhs = tmp_3;
                    var tmp_5;
                    if (tmp1_elvis_lhs == null) break $l$loop;
                    else tmp_5 = tmp1_elvis_lhs;
                    var next = tmp_5;
                    current = next;
                    release = true;
                }while (size > 0);
            } finally{
                if (release) completeReadHead(input, current);
            }
        }
        if (charactersCopied < max) {
            var size_0 = 1;
            $l$block_3: {
                // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
                var release_0 = true;
                var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
                var tmp_6;
                if (tmp0_elvis_lhs_2 == null) break $l$block_3;
                else tmp_6 = tmp0_elvis_lhs_2;
                var current_0 = tmp_6;
                var size_1 = 1;
                try {
                    $l$loop_0: do {
                        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                        var this_3 = current_0;
                        var before_0 = this_3.l3p_1 - this_3.k3p_1 | 0;
                        var after_0;
                        if (before_0 >= size_1) try {
                            // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
                            // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                            // Inline function 'kotlin.contracts.contract' call
                            // Inline function 'io.ktor.utils.io.core.read' call
                            var this_4 = current_0;
                            // Inline function 'kotlin.contracts.contract' call
                            // Inline function 'io.ktor.utils.io.core.readDirectInt8Array.<anonymous>' call
                            var memory_0 = this_4.j3p_1;
                            var start_0 = this_4.k3p_1;
                            var endExclusive_0 = this_4.l3p_1;
                            // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>' call
                            var view_0 = new Int8Array(memory_0.n3u_1.buffer, memory_0.n3u_1.byteOffset + start_0 | 0, endExclusive_0 - start_0 | 0);
                            var result = decodeBufferImpl(view_0, decoder, max - charactersCopied | 0);
                            dst.f(result.m41_1);
                            charactersCopied = charactersCopied + result.m41_1.length | 0;
                            var rc_0 = result.n41_1;
                            this_4.o3u(rc_0);
                            var rc_1 = rc_0;
                            if (rc_1 > 0) size_0 = 1;
                            else if (size_0 === 8) size_0 = 0;
                            else size_0 = size_0 + 1 | 0;
                            size_1 = size_0;
                        } finally{
                            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                            var this_5 = current_0;
                            after_0 = this_5.l3p_1 - this_5.k3p_1 | 0;
                        }
                        else after_0 = before_0;
                        release_0 = false;
                        var tmp_7;
                        if (after_0 === 0) tmp_7 = prepareReadNextHead(input, current_0);
                        else {
                            var tmp_8;
                            if (after_0 < size_1) tmp_8 = true;
                            else {
                                // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                                var this_6 = current_0;
                                tmp_8 = (this_6.o3p_1 - this_6.n3p_1 | 0) < 8;
                            }
                            if (tmp_8) {
                                completeReadHead(input, current_0);
                                tmp_7 = prepareReadFirstHead(input, size_1);
                            } else tmp_7 = current_0;
                        }
                        var tmp1_elvis_lhs_0 = tmp_7;
                        var tmp_9;
                        if (tmp1_elvis_lhs_0 == null) break $l$loop_0;
                        else tmp_9 = tmp1_elvis_lhs_0;
                        var next_0 = tmp_9;
                        current_0 = next_0;
                        release_0 = true;
                    }while (size_1 > 0);
                } finally{
                    if (release_0) completeReadHead(input, current_0);
                }
            }
        }
        return charactersCopied;
    }
    function encodeComplete(_this__u8e3s4, dst) {
        return true;
    }
    function decodeExactBytes(_this__u8e3s4, input, inputLength) {
        if (inputLength === 0) return "";
        // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
        if ((input.w3q_1 - input.v3q_1 | 0) >= inputLength) {
            var decoder = Decoder(get_charset_0(_this__u8e3s4).a3y_1, true);
            var head = input.s3w();
            var view = input.u3q_1.n3u_1;
            var tmp$ret$2;
            $l$block: // Inline function 'io.ktor.utils.io.js.decodeWrap' call
            try {
                // Inline function 'io.ktor.utils.io.charsets.decodeExactBytes.<anonymous>' call
                var subView = head.k3p_1 === 0 && inputLength === view.byteLength ? view : new DataView(view.buffer, view.byteOffset + head.k3p_1 | 0, inputLength);
                tmp$ret$2 = decoder.o41(subView);
                break $l$block;
            } catch ($p) {
                if ($p instanceof Error) {
                    var t = $p;
                    var tmp0_elvis_lhs = t.message;
                    throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs == null ? "no cause provided" : tmp0_elvis_lhs));
                } else throw $p;
            }
            var text = tmp$ret$2;
            input.o3u(inputLength);
            return text;
        }
        return decodeExactBytesSlow(_this__u8e3s4, input, inputLength);
    }
    function get_charset_0(_this__u8e3s4) {
        return _this__u8e3s4.c41_1;
    }
    function decodeExactBytesSlow(_this__u8e3s4, input, inputLength) {
        var decoder = Decoder(get_name(get_charset_0(_this__u8e3s4)), true);
        var inputRemaining = inputLength;
        var sb = StringBuilder_init_$Create$(inputLength);
        $l$block_4: // Inline function 'io.ktor.utils.io.js.decodeWrap' call
        try {
            // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>' call
            $l$block: {
                // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
                var release = true;
                var tmp0_elvis_lhs = prepareReadFirstHead(input, 6);
                var tmp;
                if (tmp0_elvis_lhs == null) break $l$block;
                else tmp = tmp0_elvis_lhs;
                var current = tmp;
                var size = 6;
                try {
                    $l$loop: do {
                        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                        var this_0 = current;
                        var before = this_0.l3p_1 - this_0.k3p_1 | 0;
                        var after;
                        if (before >= size) try {
                            // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>.<anonymous>' call
                            var buffer = current;
                            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                            var chunkSize = buffer.l3p_1 - buffer.k3p_1 | 0;
                            // Inline function 'kotlin.comparisons.minOf' call
                            var b = inputRemaining;
                            var size_0 = Math.min(chunkSize, b);
                            var tmp_0;
                            if (buffer.k3p_1 === 0 && buffer.j3p_1.n3u_1.byteLength === size_0) {
                                var tmp$ret$4;
                                $l$block_0: {
                                    // Inline function 'io.ktor.utils.io.js.decodeStream' call
                                    var buffer_0 = buffer.j3p_1.n3u_1;
                                    // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                                    try {
                                        tmp$ret$4 = decoder.k41(buffer_0, decodeOptions(true));
                                        break $l$block_0;
                                    } catch ($p) {
                                        if ($p instanceof Error) {
                                            var t = $p;
                                            var tmp0_elvis_lhs_0 = t.message;
                                            throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_0 == null ? "no cause provided" : tmp0_elvis_lhs_0));
                                        } else throw $p;
                                    }
                                }
                                tmp_0 = tmp$ret$4;
                            } else {
                                var tmp$ret$6;
                                $l$block_1: {
                                    // Inline function 'io.ktor.utils.io.js.decodeStream' call
                                    var buffer_1 = new Int8Array(buffer.j3p_1.n3u_1.buffer, buffer.j3p_1.n3u_1.byteOffset + buffer.k3p_1 | 0, size_0);
                                    // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                                    try {
                                        tmp$ret$6 = decoder.k41(buffer_1, decodeOptions(true));
                                        break $l$block_1;
                                    } catch ($p) {
                                        if ($p instanceof Error) {
                                            var t_0 = $p;
                                            var tmp0_elvis_lhs_1 = t_0.message;
                                            throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_1 == null ? "no cause provided" : tmp0_elvis_lhs_1));
                                        } else throw $p;
                                    }
                                }
                                tmp_0 = tmp$ret$6;
                            }
                            var text = tmp_0;
                            sb.e8(text);
                            buffer.o3u(size_0);
                            inputRemaining = inputRemaining - size_0 | 0;
                            size = inputRemaining > 0 ? 6 : 0;
                        } finally{
                            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                            var this_1 = current;
                            after = this_1.l3p_1 - this_1.k3p_1 | 0;
                        }
                        else after = before;
                        release = false;
                        var tmp_1;
                        if (after === 0) tmp_1 = prepareReadNextHead(input, current);
                        else {
                            var tmp_2;
                            if (after < size) tmp_2 = true;
                            else {
                                // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                                var this_2 = current;
                                tmp_2 = (this_2.o3p_1 - this_2.n3p_1 | 0) < 8;
                            }
                            if (tmp_2) {
                                completeReadHead(input, current);
                                tmp_1 = prepareReadFirstHead(input, size);
                            } else tmp_1 = current;
                        }
                        var tmp1_elvis_lhs = tmp_1;
                        var tmp_3;
                        if (tmp1_elvis_lhs == null) break $l$loop;
                        else tmp_3 = tmp1_elvis_lhs;
                        var next = tmp_3;
                        current = next;
                        release = true;
                    }while (size > 0);
                } finally{
                    if (release) completeReadHead(input, current);
                }
            }
            if (inputRemaining > 0) $l$block_2: {
                // Inline function 'io.ktor.utils.io.core.takeWhile' call
                var release_0 = true;
                var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
                var tmp_4;
                if (tmp0_elvis_lhs_2 == null) break $l$block_2;
                else tmp_4 = tmp0_elvis_lhs_2;
                var current_0 = tmp_4;
                try {
                    $l$loop_1: do {
                        // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>.<anonymous>' call
                        var buffer_2 = current_0;
                        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                        var chunkSize_0 = buffer_2.l3p_1 - buffer_2.k3p_1 | 0;
                        // Inline function 'kotlin.comparisons.minOf' call
                        var b_0 = inputRemaining;
                        var size_1 = Math.min(chunkSize_0, b_0);
                        var tmp_5;
                        if (buffer_2.k3p_1 === 0 && buffer_2.j3p_1.n3u_1.byteLength === size_1) tmp_5 = decoder.o41(buffer_2.j3p_1.n3u_1);
                        else {
                            var tmp$ret$14;
                            $l$block_3: {
                                // Inline function 'io.ktor.utils.io.js.decodeStream' call
                                var buffer_3 = new Int8Array(buffer_2.j3p_1.n3u_1.buffer, buffer_2.j3p_1.n3u_1.byteOffset + buffer_2.k3p_1 | 0, size_1);
                                // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                                try {
                                    tmp$ret$14 = decoder.k41(buffer_3, decodeOptions(true));
                                    break $l$block_3;
                                } catch ($p) {
                                    if ($p instanceof Error) {
                                        var t_1 = $p;
                                        var tmp0_elvis_lhs_3 = t_1.message;
                                        throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_3 == null ? "no cause provided" : tmp0_elvis_lhs_3));
                                    } else throw $p;
                                }
                            }
                            tmp_5 = tmp$ret$14;
                        }
                        var text_0 = tmp_5;
                        sb.e8(text_0);
                        buffer_2.o3u(size_1);
                        inputRemaining = inputRemaining - size_1 | 0;
                        release_0 = false;
                        var tmp1_elvis_lhs_0 = prepareReadNextHead(input, current_0);
                        var tmp_6;
                        if (tmp1_elvis_lhs_0 == null) break $l$loop_1;
                        else tmp_6 = tmp1_elvis_lhs_0;
                        var next_0 = tmp_6;
                        current_0 = next_0;
                        release_0 = true;
                    }while (true);
                } finally{
                    if (release_0) completeReadHead(input, current_0);
                }
            }
            sb.e8(decoder.l41());
            break $l$block_4;
        } catch ($p) {
            if ($p instanceof Error) {
                var t_2 = $p;
                var tmp0_elvis_lhs_4 = t_2.message;
                throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs_4 == null ? "no cause provided" : tmp0_elvis_lhs_4));
            } else throw $p;
        }
        if (inputRemaining > 0) throw new EOFException("Not enough bytes available: had only " + (inputLength - inputRemaining | 0) + " instead of " + inputLength);
        return sb.toString();
    }
    function DecodeBufferResult(charactersDecoded, bytesConsumed) {
        this.m41_1 = charactersDecoded;
        this.n41_1 = bytesConsumed;
    }
    protoOf(DecodeBufferResult).toString = function() {
        return "DecodeBufferResult(charactersDecoded=" + this.m41_1 + ", bytesConsumed=" + this.n41_1 + ")";
    };
    protoOf(DecodeBufferResult).hashCode = function() {
        var result = getStringHashCode(this.m41_1);
        result = imul(result, 31) + this.n41_1 | 0;
        return result;
    };
    protoOf(DecodeBufferResult).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DecodeBufferResult)) return false;
        var tmp0_other_with_cast = other instanceof DecodeBufferResult ? other : THROW_CCE();
        if (!(this.m41_1 === tmp0_other_with_cast.m41_1)) return false;
        if (!(this.n41_1 === tmp0_other_with_cast.n41_1)) return false;
        return true;
    };
    function decodeBufferImpl(_this__u8e3s4, nativeDecoder, maxCharacters) {
        if (maxCharacters === 0) return new DecodeBufferResult("", 0);
        try {
            var sizeInBytes = coerceAtMost(maxCharacters, _this__u8e3s4.byteLength);
            var text = nativeDecoder.o41(_this__u8e3s4.subarray(0, sizeInBytes));
            if (text.length <= maxCharacters) return new DecodeBufferResult(text, sizeInBytes);
        } catch ($p) {
            var _ = $p;
        }
        return decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters);
    }
    function decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters) {
        var maxBytes = coerceAtMost(maxCharacters >= 268435455 ? 2147483647 : imul(maxCharacters, 8), _this__u8e3s4.byteLength);
        var sizeInBytes = maxBytes;
        while(sizeInBytes > 8){
            try {
                var text = nativeDecoder.o41(_this__u8e3s4.subarray(0, sizeInBytes));
                if (text.length <= maxCharacters) return new DecodeBufferResult(text, sizeInBytes);
            } catch ($p) {
                var _ = $p;
            }
            sizeInBytes = sizeInBytes / 2 | 0;
        }
        sizeInBytes = 8;
        while(sizeInBytes > 0){
            try {
                var text_0 = nativeDecoder.o41(_this__u8e3s4.subarray(0, sizeInBytes));
                if (text_0.length <= maxCharacters) return new DecodeBufferResult(text_0, sizeInBytes);
            } catch ($p) {
                var __0 = $p;
            }
            sizeInBytes = sizeInBytes - 1 | 0;
        }
        $l$block: // Inline function 'io.ktor.utils.io.js.decodeWrap' call
        try {
            // Inline function 'io.ktor.utils.io.charsets.decodeBufferImplSlow.<anonymous>' call
            nativeDecoder.o41(_this__u8e3s4);
            break $l$block;
        } catch ($p) {
            if ($p instanceof Error) {
                var t = $p;
                var tmp0_elvis_lhs = t.message;
                throw new MalformedInputException("Failed to decode bytes: " + (tmp0_elvis_lhs == null ? "no cause provided" : tmp0_elvis_lhs));
            } else throw $p;
        }
        throw new MalformedInputException("Unable to decode buffer");
    }
    function encodeISO88591(input, fromIndex, toIndex, dst) {
        if (fromIndex >= toIndex) return 0;
        // Inline function 'io.ktor.utils.io.core.writeDirect' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeDirect.<anonymous>' call
        var memory = dst.j3p_1;
        var start = dst.l3p_1;
        var endExclusive = dst.n3p_1;
        // Inline function 'io.ktor.utils.io.charsets.encodeISO88591.<anonymous>' call
        var view = memory.z40(start, endExclusive - start | 0).n3u_1;
        var i8 = new Int8Array(view.buffer, view.byteOffset, view.byteLength);
        var writeIndex = 0;
        var inductionVariable = fromIndex;
        if (inductionVariable < toIndex) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.code' call
            var this_0 = charSequenceGet(input, index);
            var character = Char__toInt_impl_vasixd(this_0);
            if (character > 255) failedToMapError(character);
            // Inline function 'org.khronos.webgl.set' call
            var tmp1 = writeIndex;
            writeIndex = tmp1 + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            i8[tmp1] = toByte(character);
        }while (inductionVariable < toIndex);
        var rc = writeIndex;
        dst.p3u(rc);
        return toIndex - fromIndex | 0;
    }
    function failedToMapError(ch) {
        throw new MalformedInputException("The character with unicode point " + ch + " couldn't be mapped to ISO-8859-1 character");
    }
    function writeFully_4(_this__u8e3s4, src, offset, length) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? src.byteLength - offset | 0 : length;
        // Inline function 'io.ktor.utils.io.core.write' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
        var memory = _this__u8e3s4.j3p_1;
        var dstOffset = _this__u8e3s4.l3p_1;
        if ((_this__u8e3s4.n3p_1 - dstOffset | 0) < length) throw new InsufficientSpaceException("Not enough free space to write " + length + " bytes");
        copyTo_0(src, memory, offset, length, dstOffset);
        var rc = length;
        _this__u8e3s4.p3u(rc);
    }
    function get_PACKET_MAX_COPY_SIZE() {
        return PACKET_MAX_COPY_SIZE;
    }
    var PACKET_MAX_COPY_SIZE;
    function String_0(bytes, offset, length, charset) {
        offset = offset === VOID ? 0 : offset;
        length = length === VOID ? bytes.length : length;
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        if (offset < 0 || length < 0 || (offset + length | 0) > bytes.length) checkIndices(offset, length, bytes);
        // Inline function 'kotlin.js.asDynamic' call
        var i8 = bytes;
        var bufferOffset = i8.byteOffset + offset | 0;
        var buffer = i8.buffer.slice(bufferOffset, bufferOffset + length | 0);
        var view = new ChunkBuffer(of_1(Companion_getInstance_4(), buffer), null, Companion_getInstance_2().a3t_1);
        view.v3u();
        var packet = ByteReadPacket_init_$Create$(view, Companion_getInstance_2().b3t_1);
        return decode(charset.b3y(), packet, 2147483647);
    }
    function checkIndices(offset, length, bytes) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(offset >= 0)) throw IndexOutOfBoundsException_init_$Create$("offset (" + offset + ") shouldn't be negative");
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(length >= 0)) throw IndexOutOfBoundsException_init_$Create$("length (" + length + ") shouldn't be negative");
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!((offset + length | 0) <= bytes.length)) throw IndexOutOfBoundsException_init_$Create$("offset (" + offset + ") + length (" + length + ") > bytes.size (" + bytes.length + ")");
        throw IndexOutOfBoundsException_init_$Create$_0();
    }
    function EOFException(message) {
        IOException_init_$Init$(message, this);
        captureStack(this, EOFException);
    }
    function IOException_init_$Init$(message, $this) {
        IOException.call($this, message, null);
        return $this;
    }
    function IOException(message, cause) {
        Exception_init_$Init$_0(message, cause, this);
        captureStack(this, IOException);
    }
    function Decoder(encoding, fatal) {
        fatal = fatal === VOID ? true : fatal;
        var tmp;
        try {
            tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var cause = $p;
                tmp_0 = new TextDecoderFallback(encoding, fatal);
            } else throw $p;
            tmp = tmp_0;
        }
        return tmp;
    }
    function decodeOptions(stream) {
        // Inline function 'kotlin.apply' call
        var this_0 = new Object();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.js.decodeOptions.<anonymous>' call
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.stream = stream;
        return this_0;
    }
    function toKtor(_this__u8e3s4) {
        return new toKtor$1(_this__u8e3s4);
    }
    function textDecoderOptions(fatal) {
        fatal = fatal === VOID ? false : fatal;
        // Inline function 'kotlin.apply' call
        var this_0 = new Object();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.utils.io.js.textDecoderOptions.<anonymous>' call
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.contracts.contract' call
        this_0.fatal = fatal;
        return this_0;
    }
    function toKtor$1($this_toKtor) {
        this.p41_1 = $this_toKtor;
    }
    protoOf(toKtor$1).l41 = function() {
        return this.p41_1.decode();
    };
    protoOf(toKtor$1).o41 = function(buffer) {
        return this.p41_1.decode(buffer);
    };
    protoOf(toKtor$1).k41 = function(buffer, options) {
        return this.p41_1.decode(buffer, options);
    };
    function get_ENCODING_ALIASES() {
        _init_properties_TextDecoderFallback_kt__nrrftl();
        return ENCODING_ALIASES;
    }
    var ENCODING_ALIASES;
    function get_REPLACEMENT() {
        _init_properties_TextDecoderFallback_kt__nrrftl();
        return REPLACEMENT;
    }
    var REPLACEMENT;
    function TextDecoderFallback(encoding, fatal) {
        this.q41_1 = fatal;
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.text.trim' call
        // Inline function 'kotlin.js.asDynamic' call
        var requestedEncoding = toString(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!get_ENCODING_ALIASES().a2(requestedEncoding)) {
            // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.<anonymous>' call
            var message = encoding + " is not supported.";
            throw IllegalStateException_init_$Create$(toString(message));
        }
    }
    protoOf(TextDecoderFallback).l41 = function() {
        return "";
    };
    protoOf(TextDecoderFallback).o41 = function(buffer) {
        var tmp$ret$3;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.buildPacket' call
            // Inline function 'kotlin.contracts.contract' call
            var builder = new BytePacketBuilder();
            try {
                // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.decode.<anonymous>' call
                var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
                var inductionVariable = 0;
                var last = bytes.length;
                if (inductionVariable < last) $l$loop: do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'org.khronos.webgl.get' call
                    // Inline function 'kotlin.js.asDynamic' call
                    var byte = bytes[index];
                    var point = toCodePoint(byte);
                    if (point < 0) {
                        // Inline function 'kotlin.check' call
                        // Inline function 'kotlin.contracts.contract' call
                        if (!!this.q41_1) {
                            // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.decode.<anonymous>.<anonymous>' call
                            var message = "Invalid character: " + point;
                            throw IllegalStateException_init_$Create$(toString(message));
                        }
                        writeFully_3(builder, get_REPLACEMENT());
                        continue $l$loop;
                    }
                    if (point > 255) builder.d3v(toByte(point >> 8));
                    builder.d3v(toByte(point & 255));
                }while (inductionVariable < last);
                tmp$ret$3 = builder.c3r();
                break $l$block;
            } catch ($p) {
                if ($p instanceof Error) {
                    var t = $p;
                    builder.e19();
                    throw t;
                } else throw $p;
            }
        }
        return decodeToString(readBytes(tmp$ret$3));
    };
    protoOf(TextDecoderFallback).k41 = function(buffer, options) {
        return this.o41(buffer);
    };
    function toCodePoint(_this__u8e3s4) {
        _init_properties_TextDecoderFallback_kt__nrrftl();
        var value = _this__u8e3s4 & 255;
        if (isASCII(value)) return value;
        return get_WIN1252_TABLE()[value - 128 | 0];
    }
    function isASCII(_this__u8e3s4) {
        _init_properties_TextDecoderFallback_kt__nrrftl();
        return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
    }
    var properties_initialized_TextDecoderFallback_kt_7y92ax;
    function _init_properties_TextDecoderFallback_kt__nrrftl() {
        if (!properties_initialized_TextDecoderFallback_kt_7y92ax) {
            properties_initialized_TextDecoderFallback_kt_7y92ax = true;
            ENCODING_ALIASES = setOf([
                "ansi_x3.4-1968",
                "ascii",
                "cp1252",
                "cp819",
                "csisolatin1",
                "ibm819",
                "iso-8859-1",
                "iso-ir-100",
                "iso8859-1",
                "iso88591",
                "iso_8859-1",
                "iso_8859-1:1987",
                "l1",
                "latin1",
                "us-ascii",
                "windows-1252",
                "x-cp1252"
            ]);
            // Inline function 'kotlin.byteArrayOf' call
            REPLACEMENT = new Int8Array([
                -17,
                -65,
                -67
            ]);
        }
    }
    function get_WIN1252_TABLE() {
        _init_properties_Win1252Table_kt__tl0v64();
        return WIN1252_TABLE;
    }
    var WIN1252_TABLE;
    var properties_initialized_Win1252Table_kt_pkmjoq;
    function _init_properties_Win1252Table_kt__tl0v64() {
        if (!properties_initialized_Win1252Table_kt_pkmjoq) {
            properties_initialized_Win1252Table_kt_pkmjoq = true;
            // Inline function 'kotlin.intArrayOf' call
            WIN1252_TABLE = new Int32Array([
                8364,
                -1,
                8218,
                402,
                8222,
                8230,
                8224,
                8225,
                710,
                8240,
                352,
                8249,
                338,
                -1,
                381,
                -1,
                -1,
                8216,
                8217,
                8220,
                8221,
                8226,
                8211,
                8212,
                732,
                8482,
                353,
                8250,
                339,
                -1,
                382,
                376,
                160,
                161,
                162,
                163,
                164,
                165,
                166,
                167,
                168,
                169,
                170,
                171,
                172,
                173,
                174,
                175,
                176,
                177,
                178,
                179,
                180,
                181,
                182,
                183,
                184,
                185,
                186,
                187,
                188,
                189,
                190,
                191,
                192,
                193,
                194,
                195,
                196,
                197,
                198,
                199,
                200,
                201,
                202,
                203,
                204,
                205,
                206,
                207,
                208,
                209,
                210,
                211,
                212,
                213,
                214,
                215,
                216,
                217,
                218,
                219,
                220,
                221,
                222,
                223,
                224,
                225,
                226,
                227,
                228,
                229,
                230,
                231,
                232,
                233,
                234,
                235,
                236,
                237,
                238,
                239,
                240,
                241,
                242,
                243,
                244,
                245,
                246,
                247,
                248,
                249,
                250,
                251,
                252,
                253,
                254,
                255
            ]);
        }
    }
    function DefaultPool(capacity) {
        this.p3v_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.p3v_1;
        tmp.q3v_1 = fillArrayVal(Array(size), null);
        this.r3v_1 = 0;
    }
    protoOf(DefaultPool).s3v = function(instance) {};
    protoOf(DefaultPool).i3w = function(instance) {
        return instance;
    };
    protoOf(DefaultPool).f3w = function(instance) {};
    protoOf(DefaultPool).k3w = function() {
        if (this.r3v_1 === 0) return this.l3v();
        this.r3v_1 = this.r3v_1 - 1 | 0;
        var idx = this.r3v_1;
        var tmp = this.q3v_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.q3v_1[idx] = null;
        return this.i3w(instance);
    };
    protoOf(DefaultPool).l3w = function(instance) {
        this.f3w(instance);
        if (this.r3v_1 === this.p3v_1) this.s3v(instance);
        else {
            var tmp1 = this.r3v_1;
            this.r3v_1 = tmp1 + 1 | 0;
            this.q3v_1[tmp1] = instance;
        }
    };
    //region block: post-declaration
    protoOf(ByteChannelSequentialBase).i3t = readRemaining$default;
    protoOf(ChannelJob).c1o = cancel$default;
    protoOf(ChannelJob).y1n = invokeOnCompletion$default;
    //endregion
    //region block: init
    Companion_instance = new Companion();
    Companion_instance_1 = new Companion_1();
    DefaultAllocator_instance = new DefaultAllocator();
    Companion_instance_5 = new Companion_5();
    PACKET_MAX_COPY_SIZE = 200;
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = copyTo;
    _.$_$.b = readAvailable;
    _.$_$.c = writeFully;
    _.$_$.d = IOException_init_$Init$;
    _.$_$.e = Companion_instance_5;
    _.$_$.f = Charsets_getInstance;
    _.$_$.g = Companion_getInstance_3;
    _.$_$.h = MalformedInputException;
    _.$_$.i = decode;
    _.$_$.j = encodeToByteArray;
    _.$_$.k = encode;
    _.$_$.l = get_name;
    _.$_$.m = completeReadHead;
    _.$_$.n = prepareReadFirstHead;
    _.$_$.o = prepareReadNextHead;
    _.$_$.p = BytePacketBuilder;
    _.$_$.q = ByteReadPacket;
    _.$_$.r = Input;
    _.$_$.s = String_0;
    _.$_$.t = discard;
    _.$_$.u = readBytes;
    _.$_$.v = readShort_0;
    _.$_$.w = readText;
    _.$_$.x = writeFully_3;
    _.$_$.y = writeShort_0;
    _.$_$.z = writeText;
    _.$_$.a1 = IOException;
    _.$_$.b1 = get_ByteArrayPool;
    _.$_$.c1 = ByteReadChannel;
    _.$_$.d1 = ByteReadChannel_1;
    _.$_$.e1 = WriterScope;
    _.$_$.f1 = cancel;
    _.$_$.g1 = writer;
    //endregion
    return _;
});

});


parcelRegister("dKHwv", function(module, exports) {








(function(root11, factory11) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js",
        "./ktor-ktor-utils.js",
        "./88b0986a7186d029-atomicfu-js-ir.js",
        "./ktor-ktor-events.js",
        "./ktor-ktor-io.js",
        "./ktor-ktor-http.js",
        "./ktor-ktor-websockets.js"
    ], factory11);
    else factory11(module.exports, (parcelRequire("9vyMc")), (parcelRequire("ctZcf")), (parcelRequire("cL6ZK")), (parcelRequire("k4lEE")), (parcelRequire("adZDH")), (parcelRequire("4cHl4")), (parcelRequire("4fxpJ")), (parcelRequire("kSmcm")));
})(globalThis, function(_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_io_ktor_ktor_events, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_websockets) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var protoOf = kotlin_kotlin.$_$.kb;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.h;
    var toString = kotlin_kotlin.$_$.ob;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var VOID = kotlin_kotlin.$_$.f;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
    var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
    var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
    var AttributesJsFn = kotlin_io_ktor_ktor_utils.$_$.n;
    var Events = kotlin_io_ktor_ktor_events.$_$.b;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.c;
    var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.d1;
    var isInterface = kotlin_kotlin.$_$.xa;
    var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.m;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var instanceOf = kotlin_io_ktor_ktor_utils.$_$.k;
    var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
    var equals = kotlin_kotlin.$_$.ba;
    var cancel_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d1;
    var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.uf;
    var IllegalStateException = kotlin_kotlin.$_$.me;
    var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.w1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var defineProp = kotlin_kotlin.$_$.aa;
    var UnsupportedOperationException = kotlin_kotlin.$_$.ff;
    var UnsupportedOperationException_init_$Init$ = kotlin_kotlin.$_$.k2;
    var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
    var trimIndent = kotlin_kotlin.$_$.yd;
    var ByteReadChannel_0 = kotlin_io_ktor_ktor_io.$_$.c1;
    var readBytes = kotlin_io_ktor_ktor_io.$_$.u;
    var IllegalStateException_init_$Init$_0 = kotlin_kotlin.$_$.x1;
    var WriterScope = kotlin_io_ktor_ktor_io.$_$.e1;
    var ReadChannelContent = kotlin_io_ktor_ktor_http.$_$.o;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
    var writer = kotlin_io_ktor_ktor_io.$_$.g1;
    var WriteChannelContent = kotlin_io_ktor_ktor_http.$_$.p;
    var Companion_getInstance = kotlin_io_ktor_ktor_io.$_$.g;
    var NoContent = kotlin_io_ktor_ktor_http.$_$.m;
    var ProtocolUpgrade = kotlin_io_ktor_ktor_http.$_$.n;
    var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.l;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
    var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
    var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f1;
    var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
    var emptySet = kotlin_kotlin.$_$.t6;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
    var UnsafeHeaderException = kotlin_io_ktor_ktor_http.$_$.y;
    var CancellationException_init_$Create$ = kotlin_kotlin.$_$.c1;
    var CoroutineName = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
    var SilentSupervisor = kotlin_io_ktor_ktor_utils.$_$.o;
    var lazy = kotlin_kotlin.$_$.qf;
    var CompletableJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var setOf = kotlin_kotlin.$_$.b8;
    var get = kotlin_kotlin.$_$.j9;
    var fold = kotlin_kotlin.$_$.i9;
    var minusKey = kotlin_kotlin.$_$.k9;
    var plus = kotlin_kotlin.$_$.m9;
    var Element = kotlin_kotlin.$_$.l9;
    var joinToString = kotlin_kotlin.$_$.g7;
    var setOf_0 = kotlin_kotlin.$_$.c8;
    var PipelinePhase = kotlin_io_ktor_ktor_utils.$_$.i;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var contentLength = kotlin_io_ktor_ktor_http.$_$.e1;
    var MalformedInputException = kotlin_io_ktor_ktor_io.$_$.h;
    var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
    var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
    var toLong = kotlin_kotlin.$_$.mb;
    var toLong_0 = kotlin_kotlin.$_$.rd;
    var contentType = kotlin_io_ktor_ktor_http.$_$.f1;
    var isByteArray = kotlin_kotlin.$_$.ra;
    var Text_getInstance = kotlin_io_ktor_ktor_http.$_$.c;
    var TextContent = kotlin_io_ktor_ktor_http.$_$.r;
    var Long = kotlin_kotlin.$_$.ne;
    var copyTo = kotlin_io_ktor_ktor_io.$_$.a;
    var CancellationException = kotlin_kotlin.$_$.y8;
    var cancel_1 = kotlin_io_ktor_ktor_io.$_$.f1;
    var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.t;
    var getKClass = kotlin_kotlin.$_$.e;
    var toByteArray = kotlin_io_ktor_ktor_utils.$_$.a;
    var Input = kotlin_io_ktor_ktor_io.$_$.r;
    var ByteReadPacket = kotlin_io_ktor_ktor_io.$_$.q;
    var Unit = kotlin_kotlin.$_$.ef;
    var Companion_getInstance_0 = kotlin_io_ktor_ktor_http.$_$.f;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var toInt = kotlin_kotlin.$_$.pd;
    var reversed = kotlin_kotlin.$_$.a8;
    var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.y;
    var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
    var charset = kotlin_io_ktor_ktor_http.$_$.d1;
    var withCharset = kotlin_io_ktor_ktor_http.$_$.t1;
    var compareValues = kotlin_kotlin.$_$.x8;
    var get_name = kotlin_io_ktor_ktor_io.$_$.l;
    var toList = kotlin_kotlin.$_$.j8;
    var sortedWith = kotlin_kotlin.$_$.g8;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var roundToInt = kotlin_kotlin.$_$.pb;
    var firstOrNull = kotlin_kotlin.$_$.v6;
    var charset_0 = kotlin_io_ktor_ktor_http.$_$.c1;
    var readText = kotlin_io_ktor_ktor_io.$_$.w;
    var get_authority = kotlin_io_ktor_ktor_http.$_$.b1;
    var takeFrom = kotlin_io_ktor_ktor_http.$_$.r1;
    var isSecure = kotlin_io_ktor_ktor_http.$_$.j1;
    var get_authority_0 = kotlin_io_ktor_ktor_http.$_$.a1;
    var EventDefinition = kotlin_io_ktor_ktor_events.$_$.a;
    var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.h;
    var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
    var cancel_2 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e1;
    var trimMargin = kotlin_kotlin.$_$.zd;
    var get_lastIndex = kotlin_kotlin.$_$.j7;
    var downTo = kotlin_kotlin.$_$.wb;
    var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e;
    var isWebsocket = kotlin_io_ktor_ktor_http.$_$.l1;
    var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
    var IOException = kotlin_io_ktor_ktor_io.$_$.a1;
    var IOException_init_$Init$ = kotlin_io_ktor_ktor_io.$_$.d;
    var isSuspendFunction = kotlin_kotlin.$_$.bb;
    var IllegalStateException_init_$Init$_1 = kotlin_kotlin.$_$.z1;
    var URLBuilder = kotlin_io_ktor_ktor_http.$_$.x;
    var HeadersBuilder = kotlin_io_ktor_ktor_http.$_$.s;
    var takeFrom_0 = kotlin_io_ktor_ktor_http.$_$.q1;
    var appendAll = kotlin_io_ktor_ktor_utils.$_$.u;
    var putAll = kotlin_io_ktor_ktor_utils.$_$.x;
    var GMTDate = kotlin_io_ktor_ktor_utils.$_$.e;
    var Pipeline = kotlin_io_ktor_ktor_utils.$_$.j;
    var formUrlEncode = kotlin_io_ktor_ktor_http.$_$.i1;
    var encodeToByteArray = kotlin_kotlin.$_$.nc;
    var encodeToByteArray_0 = kotlin_io_ktor_ktor_io.$_$.j;
    var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.i;
    var decode = kotlin_io_ktor_ktor_io.$_$.i;
    var hashCode = kotlin_kotlin.$_$.ha;
    var get_ByteArrayPool = kotlin_io_ktor_ktor_io.$_$.b1;
    var readAvailable = kotlin_io_ktor_ktor_io.$_$.b;
    var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
    var equals_0 = kotlin_kotlin.$_$.pc;
    var flatten = kotlin_kotlin.$_$.z6;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var get_platform = kotlin_io_ktor_ktor_utils.$_$.w;
    var Companion_getInstance_3 = kotlin_io_ktor_ktor_http.$_$.g;
    var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
    var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.e1;
    var cancel_3 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c1;
    var Companion_getInstance_4 = kotlin_io_ktor_ktor_http.$_$.d;
    var intercepted = kotlin_kotlin.$_$.b9;
    var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
    var extendThrowable = kotlin_kotlin.$_$.ca;
    var Companion_instance = kotlin_kotlin.$_$.c5;
    var createFailure = kotlin_kotlin.$_$.jf;
    var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
    var toTypedArray = kotlin_kotlin.$_$.t8;
    var writeFully = kotlin_io_ktor_ktor_io.$_$.c;
    var Error_init_$Create$ = kotlin_kotlin.$_$.j1;
    var Error_init_$Create$_0 = kotlin_kotlin.$_$.l1;
    var _ChannelResult___get_isSuccess__impl__odq1z9 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
    var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n;
    var Companion_getInstance_5 = kotlin_io_ktor_ktor_websockets.$_$.f;
    var Codes_CLOSED_ABNORMALLY_getInstance = kotlin_io_ktor_ktor_websockets.$_$.a;
    var Text_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.e;
    var Binary_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.c;
    var CloseReason = kotlin_io_ktor_ktor_websockets.$_$.g;
    var Close_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.d;
    var String_0 = kotlin_io_ktor_ktor_io.$_$.s;
    var BytePacketBuilder = kotlin_io_ktor_ktor_io.$_$.p;
    var writeFully_0 = kotlin_io_ktor_ktor_io.$_$.x;
    var readShort = kotlin_io_ktor_ktor_io.$_$.v;
    var cancelConsumed = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
    var Codes_NORMAL_getInstance = kotlin_io_ktor_ktor_websockets.$_$.b;
    var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s;
    //endregion
    //region block: pre-declaration
    initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForCoroutine($executeCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(HttpClient, "HttpClient", VOID, VOID, [
        CoroutineScope
    ], [
        1
    ]);
    initMetadataForClass(HttpClientConfig, "HttpClientConfig", HttpClientConfig);
    initMetadataForCompanion(Companion);
    initMetadataForCoroutine($bodyNullableCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(HttpClientCall, "HttpClientCall", VOID, VOID, [
        CoroutineScope
    ], [
        0,
        1
    ]);
    initMetadataForClass(DoubleReceiveException, "DoubleReceiveException", VOID, IllegalStateException);
    initMetadataForClass(NoTransformationFoundException, "NoTransformationFoundException", VOID, UnsupportedOperationException);
    initMetadataForClass(SavedHttpCall, "SavedHttpCall", VOID, HttpClientCall, VOID, [
        0,
        1
    ]);
    function get_coroutineContext() {
        return this.t4w().v1m();
    }
    initMetadataForInterface(HttpRequest_0, "HttpRequest", VOID, VOID, [
        CoroutineScope
    ]);
    initMetadataForClass(SavedHttpRequest, "SavedHttpRequest", VOID, VOID, [
        HttpRequest_0
    ]);
    initMetadataForClass(HttpResponse, "HttpResponse", VOID, VOID, [
        CoroutineScope
    ]);
    initMetadataForClass(SavedHttpResponse, "SavedHttpResponse", VOID, HttpResponse);
    initMetadataForCoroutine($saveCOROUTINE$3, CoroutineImpl);
    initMetadataForClass(UnsupportedContentTypeException, "UnsupportedContentTypeException", VOID, IllegalStateException);
    initMetadataForLambda(ObservableContent$content$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(ObservableContent, "ObservableContent", VOID, ReadChannelContent);
    initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($executeWithinCallContextCOROUTINE$4, CoroutineImpl);
    function get_supportedCapabilities() {
        return emptySet();
    }
    function install(client11) {
        var tmp11 = Phases_getInstance_0().f4u_1;
        client11.p4r_1.s46(tmp11, HttpClientEngine$install$slambda_0(client11, this, null));
    }
    initMetadataForInterface(HttpClientEngine, "HttpClientEngine", VOID, VOID, [
        CoroutineScope
    ], [
        1
    ]);
    function create$default(block11, $super11) {
        var tmp11;
        if (block11 === VOID) tmp11 = HttpClientEngineFactory$create$lambda;
        else tmp11 = block11;
        block11 = tmp11;
        return $super11 === VOID ? this.q4u(block11) : $super11.q4u.call(this, block11);
    }
    initMetadataForInterface(HttpClientEngineFactory, "HttpClientEngineFactory");
    initMetadataForClass(ClientEngineClosedException, "ClientEngineClosedException", ClientEngineClosedException, IllegalStateException);
    initMetadataForClass(HttpClientEngineBase, "HttpClientEngineBase", VOID, VOID, [
        HttpClientEngine
    ], [
        1
    ]);
    initMetadataForClass(HttpClientEngineConfig, "HttpClientEngineConfig", HttpClientEngineConfig);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(KtorCallContextElement, "KtorCallContextElement", VOID, VOID, [
        Element
    ]);
    initMetadataForInterface(HttpClientPlugin, "HttpClientPlugin");
    initMetadataForObject(Plugin, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForLambda(BodyProgress$handle$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(BodyProgress$handle$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForClass(BodyProgress, "BodyProgress");
    initMetadataForClass(ResponseException, "ResponseException", VOID, IllegalStateException);
    initMetadataForClass(RedirectResponseException, "RedirectResponseException", VOID, ResponseException);
    initMetadataForClass(ClientRequestException, "ClientRequestException", VOID, ResponseException);
    initMetadataForClass(ServerResponseException, "ServerResponseException", VOID, ResponseException);
    initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(defaultTransformers$1$content$1, VOID, VOID, ByteArrayContent);
    initMetadataForClass(defaultTransformers$1$content$2, VOID, VOID, ReadChannelContent);
    initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpCallValidator$Companion$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpCallValidator$Companion$install$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpCallValidator$Companion$install$slambda_3, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForClass(Config, "Config", Config);
    initMetadataForCompanion(Companion_1, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForCoroutine($validateResponseCOROUTINE$5, CoroutineImpl);
    initMetadataForCoroutine($processExceptionCOROUTINE$6, CoroutineImpl);
    initMetadataForClass(HttpCallValidator, "HttpCallValidator", VOID, VOID, VOID, [
        1,
        2
    ]);
    initMetadataForClass(ExceptionHandlerWrapper, "ExceptionHandlerWrapper");
    initMetadataForClass(RequestExceptionHandlerWrapper, "RequestExceptionHandlerWrapper");
    initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [
        HttpRequest_0
    ]);
    initMetadataForLambda(HttpPlainText$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForLambda(HttpPlainText$Plugin$install$slambda_1, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForClass(Config_0, "Config", Config_0);
    initMetadataForObject(Plugin_0, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForClass(sam$kotlin_Comparator$0, "sam$kotlin_Comparator$0");
    initMetadataForClass(HttpPlainText, "HttpPlainText");
    initMetadataForLambda(HttpRedirect$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForCoroutine($handleCallCOROUTINE$7, CoroutineImpl);
    initMetadataForClass(Config_1, "Config", Config_1);
    initMetadataForObject(Plugin_1, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ], [
        4
    ]);
    initMetadataForClass(HttpRedirect, "HttpRedirect");
    initMetadataForLambda(HttpRequestLifecycle$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForObject(Plugin_2, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForClass(HttpRequestLifecycle, "HttpRequestLifecycle");
    initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForCoroutine($executeCOROUTINE$8, CoroutineImpl);
    initMetadataForClass(Config_2, "Config", Config_2);
    initMetadataForObject(Plugin_3, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForInterface(Sender, "Sender", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(InterceptedSender, "InterceptedSender", VOID, VOID, [
        Sender
    ], [
        1
    ]);
    initMetadataForClass(DefaultSender, "DefaultSender", VOID, VOID, [
        Sender
    ], [
        1
    ]);
    initMetadataForClass(HttpSend, "HttpSend");
    initMetadataForClass(SendCountExceedException, "SendCountExceedException", VOID, IllegalStateException);
    initMetadataForCompanion(Companion_2);
    initMetadataForLambda(HttpTimeout$Plugin$install$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(HttpTimeout$Plugin$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForClass(HttpTimeoutCapabilityConfiguration, "HttpTimeoutCapabilityConfiguration", HttpTimeoutCapabilityConfiguration_init_$Create$);
    initMetadataForObject(Plugin_4, "Plugin", VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForClass(HttpTimeout, "HttpTimeout");
    initMetadataForClass(HttpRequestTimeoutException, "HttpRequestTimeoutException", VOID, IOException);
    initMetadataForClass(HookHandler, "HookHandler");
    initMetadataForClass(ClientPluginBuilder, "ClientPluginBuilder");
    initMetadataForClass(ClientPluginInstance, "ClientPluginInstance");
    initMetadataForClass(createClientPlugin$1, VOID, VOID, VOID, [
        HttpClientPlugin
    ]);
    initMetadataForClass(OnRequestContext, "OnRequestContext");
    initMetadataForLambda(RequestHook$install$slambda, CoroutineImpl, VOID, [
        2
    ]);
    initMetadataForObject(RequestHook, "RequestHook");
    initMetadataForClass(DelegatedCall, "DelegatedCall", VOID, HttpClientCall, VOID, [
        0,
        1
    ]);
    initMetadataForClass(DelegatedRequest, "DelegatedRequest", VOID, VOID, [
        HttpRequest_0
    ]);
    initMetadataForClass(DelegatedResponse, "DelegatedResponse", VOID, HttpResponse);
    initMetadataForObject(WebSocketCapability, "WebSocketCapability");
    initMetadataForClass(WebSocketException, "WebSocketException", VOID, IllegalStateException);
    initMetadataForClass(ClientUpgradeContent, "ClientUpgradeContent", VOID, NoContent, VOID, [
        1
    ]);
    initMetadataForClass(DefaultHttpRequest, "DefaultHttpRequest", VOID, VOID, [
        HttpRequest_0
    ]);
    initMetadataForCompanion(Companion_3);
    initMetadataForClass(HttpRequestBuilder, "HttpRequestBuilder", HttpRequestBuilder);
    initMetadataForClass(HttpRequestData, "HttpRequestData");
    initMetadataForClass(HttpResponseData, "HttpResponseData");
    initMetadataForObject(Phases, "Phases");
    initMetadataForClass(HttpRequestPipeline, "HttpRequestPipeline", HttpRequestPipeline, Pipeline, VOID, [
        2
    ]);
    initMetadataForObject(Phases_0, "Phases");
    initMetadataForClass(HttpSendPipeline, "HttpSendPipeline", HttpSendPipeline, Pipeline, VOID, [
        2
    ]);
    initMetadataForClass(FormDataContent, "FormDataContent", VOID, ByteArrayContent);
    initMetadataForCoroutine($submitFormCOROUTINE$18, CoroutineImpl);
    initMetadataForClass(DefaultHttpResponse, "DefaultHttpResponse", VOID, HttpResponse);
    initMetadataForCoroutine($bodyAsTextCOROUTINE$20, CoroutineImpl);
    initMetadataForObject(Phases_1, "Phases");
    initMetadataForClass(HttpResponsePipeline, "HttpResponsePipeline", HttpResponsePipeline, Pipeline, VOID, [
        2
    ]);
    initMetadataForObject(Phases_2, "Phases");
    initMetadataForClass(HttpReceivePipeline, "HttpReceivePipeline", HttpReceivePipeline, Pipeline, VOID, [
        2
    ]);
    initMetadataForClass(HttpResponseContainer, "HttpResponseContainer");
    initMetadataForLambda(HttpStatement$execute$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($executeCOROUTINE$21, CoroutineImpl);
    initMetadataForCoroutine($executeUnsafeCOROUTINE$22, CoroutineImpl);
    initMetadataForCoroutine($cleanupCOROUTINE$23, CoroutineImpl);
    initMetadataForClass(HttpStatement, "HttpStatement", VOID, VOID, VOID, [
        1,
        0
    ]);
    initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(HttpResponseReceiveFail, "HttpResponseReceiveFail");
    initMetadataForObject(EmptyContent, "EmptyContent", VOID, NoContent);
    initMetadataForObject(Js, "Js", VOID, VOID, [
        HttpClientEngineFactory
    ]);
    initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
    initMetadataForCoroutine($executeCOROUTINE$24, CoroutineImpl);
    initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$25, CoroutineImpl);
    initMetadataForClass(JsClientEngine, "JsClientEngine", VOID, HttpClientEngineBase, VOID, [
        1,
        2
    ]);
    initMetadataForClass(JsError, "JsError", VOID, Error);
    initMetadataForLambda(toRaw$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($toRawCOROUTINE$26, CoroutineImpl);
    initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(readBodyNode$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsWebSocketSession, "JsWebSocketSession", VOID, VOID, [
        CoroutineScope
    ], [
        0,
        1
    ]);
    //endregion
    function HttpClient_init_$Init$(engine11, userConfig11, manageEngine11, $this11) {
        HttpClient.call($this11, engine11, userConfig11);
        $this11.j4r_1 = manageEngine11;
        return $this11;
    }
    function HttpClient_init_$Create$(engine11, userConfig11, manageEngine11) {
        return HttpClient_init_$Init$(engine11, userConfig11, manageEngine11, objectCreate(protoOf(HttpClient)));
    }
    function HttpClient$lambda(this$011) {
        return function(it11) {
            var tmp11;
            if (!(it11 == null)) {
                cancel(this$011.h4r_1);
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function HttpClient$slambda(this$011, resultContinuation11) {
        this.d4s_1 = this$011;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpClient$slambda).h4s = function($this$intercept11, call11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, call11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClient$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpClient$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    var tmp_011 = this.f4s_1;
                    if (!(tmp_011 instanceof HttpClientCall)) {
                        var message11 = "Error: HttpClientCall expected, but found " + toString(this.f4s_1) + "(" + toString(getKClassFromExpression(this.f4s_1)) + ").";
                        throw IllegalStateException_init_$Create$(toString(message11));
                    }
                    this.v8_1 = 1;
                    suspendResult11 = this.d4s_1.q4r_1.n46(Unit_instance, this.f4s_1.j31(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.g4s_1 = suspendResult11;
                    this.f4s_1.o4s(this.g4s_1);
                    this.v8_1 = 2;
                    suspendResult11 = this.e4s_1.s45(this.f4s_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpClient$slambda).i4s = function($this$intercept11, call11, completion11) {
        var i11 = new HttpClient$slambda(this.d4s_1, completion11);
        i11.e4s_1 = $this$intercept11;
        i11.f4s_1 = call11;
        return i11;
    };
    function HttpClient$slambda_0(this$011, resultContinuation11) {
        var i11 = new HttpClient$slambda(this$011, resultContinuation11);
        var l11 = function($this$intercept11, call11, $completion11) {
            return i11.h4s($this$intercept11, call11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function HttpClient$lambda_0($this$install11) {
        defaultTransformers($this$install11);
        return Unit_instance;
    }
    function HttpClient$slambda_1(this$011, resultContinuation11) {
        this.x4s_1 = this$011;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpClient$slambda_1).a4t = function($this$intercept11, it11, $completion11) {
        var tmp11 = this.b4t($this$intercept11, it11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClient$slambda_1).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.a4t(tmp11, p211 instanceof HttpResponseContainer ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpClient$slambda_1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = this.y4s_1.t45(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_011 = this.y8_1;
                    if (tmp_011 instanceof Error) {
                        var cause11 = this.y8_1;
                        this.x4s_1.t4r_1.e4r(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.y4s_1.o46_1.j31(), cause11));
                        throw cause11;
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpClient$slambda_1).b4t = function($this$intercept11, it11, completion11) {
        var i11 = new HttpClient$slambda_1(this.x4s_1, completion11);
        i11.y4s_1 = $this$intercept11;
        i11.z4s_1 = it11;
        return i11;
    };
    function HttpClient$slambda_2(this$011, resultContinuation11) {
        var i11 = new HttpClient$slambda_1(this$011, resultContinuation11);
        var l11 = function($this$intercept11, it11, $completion11) {
            return i11.a4t($this$intercept11, it11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function $executeCOROUTINE$0(_this__u8e3s411, builder11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.k4t_1 = _this__u8e3s411;
        this.l4t_1 = builder11;
    }
    protoOf($executeCOROUTINE$0).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.k4t_1.t4r_1.e4r(get_HttpRequestCreated(), this.l4t_1);
                    this.v8_1 = 1;
                    suspendResult11 = this.k4t_1.n4r_1.n46(this.l4t_1, this.l4t_1.p4t_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return suspendResult11 instanceof HttpClientCall ? suspendResult11 : THROW_CCE();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function HttpClient(engine11, userConfig11) {
        userConfig11 = userConfig11 === VOID ? new HttpClientConfig() : userConfig11;
        this.h4r_1 = engine11;
        this.i4r_1 = userConfig11;
        this.j4r_1 = false;
        this.k4r_1 = atomic$boolean$1(false);
        this.l4r_1 = Job(this.h4r_1.v1m().i9(Key_instance));
        this.m4r_1 = this.h4r_1.v1m().vf(this.l4r_1);
        this.n4r_1 = new HttpRequestPipeline(this.i4r_1.z4t_1);
        this.o4r_1 = new HttpResponsePipeline(this.i4r_1.z4t_1);
        this.p4r_1 = new HttpSendPipeline(this.i4r_1.z4t_1);
        this.q4r_1 = new HttpReceivePipeline(this.i4r_1.z4t_1);
        this.r4r_1 = AttributesJsFn(true);
        this.s4r_1 = this.h4r_1.a4u();
        this.t4r_1 = new Events();
        this.u4r_1 = new HttpClientConfig();
        if (this.j4r_1) this.l4r_1.w1n(HttpClient$lambda(this));
        this.h4r_1.b4u(this);
        var tmp11 = Phases_getInstance_0().g4u_1;
        this.p4r_1.s46(tmp11, HttpClient$slambda_0(this, null));
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$with11 = this.i4r_1;
        this.u4r_1.h4u(Plugin_getInstance_2());
        this.u4r_1.h4u(Plugin_getInstance());
        if ($this$with11.x4t_1) this.u4r_1.i4u("DefaultTransformers", HttpClient$lambda_0);
        this.u4r_1.h4u(Plugin_getInstance_3());
        this.u4r_1.h4u(Companion_getInstance_8());
        if ($this$with11.w4t_1) this.u4r_1.h4u(Plugin_getInstance_1());
        this.u4r_1.j4u($this$with11);
        if ($this$with11.x4t_1) this.u4r_1.h4u(Plugin_getInstance_0());
        addDefaultResponseValidation(this.u4r_1);
        this.u4r_1.b4u(this);
        var tmp_011 = Phases_getInstance_1().k4u_1;
        this.o4r_1.s46(tmp_011, HttpClient$slambda_2(this, null));
    }
    protoOf(HttpClient).v1m = function() {
        return this.m4r_1;
    };
    protoOf(HttpClient).p4u = function(builder11, $completion11) {
        var tmp11 = new $executeCOROUTINE$0(this, builder11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClient).toString = function() {
        return "HttpClient[" + toString(this.h4r_1) + "]";
    };
    function HttpClient_0(engine11, block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new HttpClientConfig();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        return HttpClient_init_$Create$(engine11, this_011, false);
    }
    function HttpClient_1(engineFactory11, block11) {
        var tmp11;
        if (block11 === VOID) tmp11 = HttpClient$lambda_1;
        else tmp11 = block11;
        block11 = tmp11;
        // Inline function 'kotlin.apply' call
        var this_011 = new HttpClientConfig();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        var engine11 = engineFactory11.q4u(config11.v4t_1);
        var client11 = HttpClient_init_$Create$(engine11, config11, true);
        var tmp_011 = ensureNotNull(client11.m4r_1.i9(Key_instance));
        tmp_011.w1n(HttpClient$lambda_2(engine11));
        return client11;
    }
    function HttpClient$lambda_1($this$null11) {
        return Unit_instance;
    }
    function HttpClient$lambda_2($engine11) {
        return function(it11) {
            $engine11.v3w();
            return Unit_instance;
        };
    }
    function HttpClientConfig$engineConfig$lambda($this$null11) {
        return Unit_instance;
    }
    function HttpClientConfig$install$lambda($this$null11) {
        return Unit_instance;
    }
    function HttpClientConfig$install$lambda_0($previousConfigBlock11, $configure11) {
        return function($this$null11) {
            var tmp0_safe_receiver11 = $previousConfigBlock11;
            if (tmp0_safe_receiver11 == null) ;
            else tmp0_safe_receiver11($this$null11);
            $configure11(!($this$null11 == null) ? $this$null11 : THROW_CCE());
            return Unit_instance;
        };
    }
    function HttpClientConfig$install$lambda$lambda() {
        return AttributesJsFn(true);
    }
    function HttpClientConfig$install$lambda_1($plugin11) {
        return function(scope11) {
            var tmp11 = get_PLUGIN_INSTALLED_LIST();
            var attributes11 = scope11.r4r_1.x41(tmp11, HttpClientConfig$install$lambda$lambda);
            var config11 = ensureNotNull(scope11.u4r_1.t4t_1.e2($plugin11.a1()));
            var pluginData11 = $plugin11.r4u(config11);
            $plugin11.s4u(pluginData11, scope11);
            attributes11.v41($plugin11.a1(), pluginData11);
            return Unit_instance;
        };
    }
    function HttpClientConfig() {
        var tmp11 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp11.s4t_1 = LinkedHashMap_init_$Create$();
        var tmp_011 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_011.t4t_1 = LinkedHashMap_init_$Create$();
        var tmp_141 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_141.u4t_1 = LinkedHashMap_init_$Create$();
        var tmp_211 = this;
        tmp_211.v4t_1 = HttpClientConfig$engineConfig$lambda;
        this.w4t_1 = true;
        this.x4t_1 = true;
        this.y4t_1 = false;
        this.z4t_1 = PlatformUtils_getInstance().i43_1;
    }
    protoOf(HttpClientConfig).t4u = function(plugin11, configure11) {
        var previousConfigBlock11 = this.t4t_1.e2(plugin11.a1());
        // Inline function 'kotlin.collections.set' call
        var this_011 = this.t4t_1;
        var key11 = plugin11.a1();
        var value11 = HttpClientConfig$install$lambda_0(previousConfigBlock11, configure11);
        this_011.m2(key11, value11);
        if (this.s4t_1.c2(plugin11.a1())) return Unit_instance;
        // Inline function 'kotlin.collections.set' call
        var this_111 = this.s4t_1;
        var key_011 = plugin11.a1();
        var value_011 = HttpClientConfig$install$lambda_1(plugin11);
        this_111.m2(key_011, value_011);
    };
    protoOf(HttpClientConfig).h4u = function(plugin11, configure11, $super11) {
        var tmp11;
        if (configure11 === VOID) tmp11 = HttpClientConfig$install$lambda;
        else tmp11 = configure11;
        configure11 = tmp11;
        var tmp_011;
        if ($super11 === VOID) {
            this.t4u(plugin11, configure11);
            tmp_011 = Unit_instance;
        } else tmp_011 = $super11.t4u.call(this, plugin11, configure11);
        return tmp_011;
    };
    protoOf(HttpClientConfig).i4u = function(key11, block11) {
        // Inline function 'kotlin.collections.set' call
        this.u4t_1.m2(key11, block11);
    };
    protoOf(HttpClientConfig).b4u = function(client11) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator11 = this.s4t_1.g2().j();
        while(tmp0_iterator11.k()){
            var element11 = tmp0_iterator11.l();
            // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            element11(client11);
        }
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_011 = this.u4t_1.g2().j();
        while(tmp0_iterator_011.k()){
            var element_011 = tmp0_iterator_011.l();
            // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlin.contracts.contract' call
            element_011(client11);
        }
    };
    protoOf(HttpClientConfig).j4u = function(other11) {
        this.w4t_1 = other11.w4t_1;
        this.x4t_1 = other11.x4t_1;
        this.y4t_1 = other11.y4t_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var this_011 = this.s4t_1;
        var map11 = other11.s4t_1;
        this_011.o2(map11);
        // Inline function 'kotlin.collections.plusAssign' call
        var this_111 = this.t4t_1;
        var map_011 = other11.t4t_1;
        this_111.o2(map_011);
        // Inline function 'kotlin.collections.plusAssign' call
        var this_211 = this.u4t_1;
        var map_111 = other11.u4t_1;
        this_211.o2(map_111);
    };
    function HttpClientCall_init_$Init$(client11, requestData11, responseData11, $this11) {
        HttpClientCall.call($this11, client11);
        $this11.l4s_1 = new DefaultHttpRequest($this11, requestData11);
        $this11.m4s_1 = new DefaultHttpResponse($this11, responseData11);
        var tmp11 = responseData11.y4u_1;
        if (!isInterface(tmp11, ByteReadChannel)) $this11.b4v().v41(Companion_getInstance_6().c4v_1, responseData11.y4u_1);
        return $this11;
    }
    function HttpClientCall_init_$Create$(client11, requestData11, responseData11) {
        return HttpClientCall_init_$Init$(client11, requestData11, responseData11, objectCreate(protoOf(HttpClientCall)));
    }
    function Companion() {
        Companion_instance_0 = this;
        this.c4v_1 = new AttributeKey("CustomResponse");
    }
    var Companion_instance_0;
    function Companion_getInstance_6() {
        if (Companion_instance_0 == null) new Companion();
        return Companion_instance_0;
    }
    function $bodyNullableCOROUTINE$1(_this__u8e3s411, info11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.l4v_1 = _this__u8e3s411;
        this.m4v_1 = info11;
    }
    protoOf($bodyNullableCOROUTINE$1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 10;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.n4v_1 = Unit_instance;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.w8_1 = 9;
                    this.w8_1 = 8;
                    if (instanceOf(this.l4v_1.j31(), this.m4v_1.f47_1)) {
                        this.n4v_1 = this.l4v_1.j31();
                        this.w8_1 = 10;
                        this.v8_1 = 7;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    if (!this.l4v_1.s4v() && !this.l4v_1.k4s_1.atomicfu$compareAndSet(false, true)) throw new DoubleReceiveException(this.l4v_1);
                    this.o4v_1 = this.l4v_1.b4v().t41(Companion_getInstance_6().c4v_1);
                    if (this.o4v_1 == null) {
                        this.v8_1 = 4;
                        suspendResult11 = this.l4v_1.t4v(this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        this.p4v_1 = this.o4v_1;
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 4:
                    this.p4v_1 = suspendResult11;
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    this.q4v_1 = this.p4v_1;
                    this.r4v_1 = new HttpResponseContainer(this.m4v_1, this.q4v_1);
                    this.v8_1 = 6;
                    suspendResult11 = this.l4v_1.j4s_1.o4r_1.n46(this.l4v_1, this.r4v_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 6:
                    var ARGUMENT11 = suspendResult11;
                    var this_011 = ARGUMENT11.v4v_1;
                    var tmp_011;
                    if (!equals(this_011, NullBody_instance)) tmp_011 = this_011;
                    else tmp_011 = null;
                    var result11 = tmp_011;
                    if (!(result11 == null) && !instanceOf(result11, this.m4v_1.f47_1)) {
                        var from11 = getKClassFromExpression(result11);
                        var to11 = this.m4v_1.f47_1;
                        throw new NoTransformationFoundException(this.l4v_1.j31(), from11, to11);
                    }
                    this.n4v_1 = result11;
                    this.w8_1 = 10;
                    this.v8_1 = 7;
                    var tmp_141 = this;
                    continue $sm;
                case 7:
                    var tmp_211 = this.n4v_1;
                    this.w8_1 = 10;
                    complete(this.l4v_1.j31());
                    return tmp_211;
                case 8:
                    this.w8_1 = 9;
                    var tmp_311 = this.y8_1;
                    if (tmp_311 instanceof Error) {
                        var cause11 = this.y8_1;
                        var tmp_411 = this;
                        cancel_0(this.l4v_1.j31(), "Receive failed", cause11);
                        throw cause11;
                    } else throw this.y8_1;
                case 9:
                    this.w8_1 = 10;
                    var t11 = this.y8_1;
                    complete(this.l4v_1.j31());
                    throw t11;
                case 10:
                    throw this.y8_1;
                case 11:
                    this.w8_1 = 10;
                    complete(this.l4v_1.j31());
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 10) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function HttpClientCall(client11) {
        Companion_getInstance_6();
        this.j4s_1 = client11;
        this.k4s_1 = atomic$boolean$1(false);
        this.n4s_1 = false;
    }
    protoOf(HttpClientCall).v1m = function() {
        return this.j31().v1m();
    };
    protoOf(HttpClientCall).b4v = function() {
        return this.w4v().b4v();
    };
    protoOf(HttpClientCall).w4v = function() {
        var tmp11 = this.l4s_1;
        if (!(tmp11 == null)) return tmp11;
        else throwUninitializedPropertyAccessException("request");
    };
    protoOf(HttpClientCall).j31 = function() {
        var tmp11 = this.m4s_1;
        if (!(tmp11 == null)) return tmp11;
        else throwUninitializedPropertyAccessException("response");
    };
    protoOf(HttpClientCall).s4v = function() {
        return this.n4s_1;
    };
    protoOf(HttpClientCall).t4v = function($completion11) {
        return this.j31().e1b();
    };
    protoOf(HttpClientCall).x4v = function(info11, $completion11) {
        var tmp11 = new $bodyNullableCOROUTINE$1(this, info11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClientCall).toString = function() {
        return "HttpClientCall[" + this.w4v().y3h().toString() + ", " + this.j31().y4v().toString() + "]";
    };
    protoOf(HttpClientCall).o4s = function(response11) {
        this.m4s_1 = response11;
    };
    function DoubleReceiveException(call11) {
        IllegalStateException_init_$Init$(this);
        captureStack(this, DoubleReceiveException);
        this.z4v_1 = "Response already received: " + call11.toString();
    }
    protoOf(DoubleReceiveException).l9 = function() {
        return this.z4v_1;
    };
    function NoTransformationFoundException(response11, from11, to11) {
        UnsupportedOperationException_init_$Init$(this);
        captureStack(this, NoTransformationFoundException);
        this.a4w_1 = trimIndent("\n        Expected response body of the type '" + toString(to11) + "' but was '" + toString(from11) + "'\n        In response from `" + get_request(response11).y3h().toString() + "`\n        Response status `" + response11.y4v().toString() + "`\n        Response header `ContentType: " + response11.m4d().vl(HttpHeaders_getInstance().b4a_1) + "` \n        Request header `Accept: " + get_request(response11).m4d().vl(HttpHeaders_getInstance().j49_1) + "`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ");
    }
    protoOf(NoTransformationFoundException).l9 = function() {
        return this.a4w_1;
    };
    function save(_this__u8e3s411, $completion11) {
        var tmp11 = new $saveCOROUTINE$3(_this__u8e3s411, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function SavedHttpCall(client11, request11, response11, responseBody11) {
        HttpClientCall.call(this, client11);
        this.p4w_1 = responseBody11;
        this.l4s_1 = new SavedHttpRequest(this, request11);
        this.m4s_1 = new SavedHttpResponse(this, this.p4w_1, response11);
        this.q4w_1 = true;
    }
    protoOf(SavedHttpCall).t4v = function($completion11) {
        return ByteReadChannel_0(this.p4w_1);
    };
    protoOf(SavedHttpCall).s4v = function() {
        return this.q4w_1;
    };
    function SavedHttpRequest(call11, origin11) {
        this.r4w_1 = call11;
        this.s4w_1 = origin11;
    }
    protoOf(SavedHttpRequest).t4w = function() {
        return this.r4w_1;
    };
    protoOf(SavedHttpRequest).b4v = function() {
        return this.s4w_1.b4v();
    };
    protoOf(SavedHttpRequest).v1m = function() {
        return this.s4w_1.v1m();
    };
    protoOf(SavedHttpRequest).m4d = function() {
        return this.s4w_1.m4d();
    };
    protoOf(SavedHttpRequest).u4w = function() {
        return this.s4w_1.u4w();
    };
    protoOf(SavedHttpRequest).y3h = function() {
        return this.s4w_1.y3h();
    };
    function SavedHttpResponse(call11, body11, origin11) {
        HttpResponse.call(this);
        this.v4w_1 = call11;
        this.w4w_1 = Job();
        this.x4w_1 = origin11.y4v();
        this.y4w_1 = origin11.e4x();
        this.z4w_1 = origin11.f4x();
        this.a4x_1 = origin11.g4x();
        this.b4x_1 = origin11.m4d();
        this.c4x_1 = origin11.v1m().vf(this.w4w_1);
        this.d4x_1 = ByteReadChannel_0(body11);
    }
    protoOf(SavedHttpResponse).t4w = function() {
        return this.v4w_1;
    };
    protoOf(SavedHttpResponse).y4v = function() {
        return this.x4w_1;
    };
    protoOf(SavedHttpResponse).e4x = function() {
        return this.y4w_1;
    };
    protoOf(SavedHttpResponse).f4x = function() {
        return this.z4w_1;
    };
    protoOf(SavedHttpResponse).g4x = function() {
        return this.a4x_1;
    };
    protoOf(SavedHttpResponse).m4d = function() {
        return this.b4x_1;
    };
    protoOf(SavedHttpResponse).v1m = function() {
        return this.c4x_1;
    };
    protoOf(SavedHttpResponse).e1b = function() {
        return this.d4x_1;
    };
    function $saveCOROUTINE$3(_this__u8e3s411, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.j4w_1 = _this__u8e3s411;
    }
    protoOf($saveCOROUTINE$3).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = this.j4w_1.j31().e1b().i3t(VOID, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    var ARGUMENT11 = suspendResult11;
                    var responseBody11 = readBytes(ARGUMENT11);
                    return new SavedHttpCall(this.j4w_1.j4s_1, this.j4w_1.w4v(), this.j4w_1.j31(), responseBody11);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function UnsupportedContentTypeException(content11) {
        IllegalStateException_init_$Init$_0("Failed to write body: " + toString(getKClassFromExpression(content11)), this);
        captureStack(this, UnsupportedContentTypeException);
    }
    function ObservableContent$content$slambda(this$011, resultContinuation11) {
        this.p4x_1 = this$011;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(ObservableContent$content$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(ObservableContent$content$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(ObservableContent$content$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = this.p4x_1.u4x_1.y4i(this.q4x_1.v1x(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(ObservableContent$content$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new ObservableContent$content$slambda(this.p4x_1, completion11);
        i11.q4x_1 = $this$writer11;
        return i11;
    };
    function ObservableContent$content$slambda_0(this$011, resultContinuation11) {
        var i11 = new ObservableContent$content$slambda(this$011, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function ObservableContent(delegate11, callContext11, listener11) {
        ReadChannelContent.call(this);
        this.u4x_1 = delegate11;
        this.v4x_1 = callContext11;
        this.w4x_1 = listener11;
        var tmp11 = this;
        var tmp0_subject11 = this.u4x_1;
        var tmp_011;
        if (tmp0_subject11 instanceof ByteArrayContent) tmp_011 = ByteReadChannel_0(this.u4x_1.t4i());
        else {
            if (tmp0_subject11 instanceof ProtocolUpgrade) throw new UnsupportedContentTypeException(this.u4x_1);
            else if (tmp0_subject11 instanceof NoContent) tmp_011 = Companion_getInstance().m3u();
            else {
                if (tmp0_subject11 instanceof ReadChannelContent) tmp_011 = this.u4x_1.w4i();
                else if (tmp0_subject11 instanceof WriteChannelContent) {
                    var tmp_141 = GlobalScope_instance;
                    tmp_011 = writer(tmp_141, this.v4x_1, true, ObservableContent$content$slambda_0(this, null)).v1x();
                } else noWhenBranchMatchedException();
            }
        }
        tmp11.x4x_1 = tmp_011;
    }
    protoOf(ObservableContent).r4i = function() {
        return this.u4x_1.r4i();
    };
    protoOf(ObservableContent).s4i = function() {
        return this.u4x_1.s4i();
    };
    protoOf(ObservableContent).m4d = function() {
        return this.u4x_1.m4d();
    };
    protoOf(ObservableContent).w4i = function() {
        return observable(this.x4x_1, this.v4x_1, this.s4i(), this.w4x_1);
    };
    function get_CALL_COROUTINE() {
        _init_properties_HttpClientEngine_kt__h91z5h();
        return CALL_COROUTINE;
    }
    var CALL_COROUTINE;
    function get_CLIENT_CONFIG() {
        _init_properties_HttpClientEngine_kt__h91z5h();
        return CLIENT_CONFIG;
    }
    var CLIENT_CONFIG;
    function HttpClientEngine$install$slambda$lambda($client11, $response11) {
        return function(it11) {
            var tmp11;
            if (!(it11 == null)) {
                $client11.t4r_1.e4r(get_HttpResponseCancelled(), $response11);
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function _get_closed__iwkfs1($this11) {
        var tmp0_safe_receiver11 = $this11.v1m().i9(Key_instance);
        var tmp1_elvis_lhs11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.w1m();
        return !(tmp1_elvis_lhs11 == null ? false : tmp1_elvis_lhs11);
    }
    function executeWithinCallContext($this11, requestData11, $completion11) {
        var tmp11 = new $executeWithinCallContextCOROUTINE$4($this11, requestData11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function checkExtensions($this11, requestData11) {
        var tmp0_iterator11 = requestData11.q4y_1.j();
        while(tmp0_iterator11.k()){
            var requestedExtension11 = tmp0_iterator11.l();
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!$this11.r4y().a2(requestedExtension11)) {
                // Inline function 'io.ktor.client.engine.HttpClientEngine.checkExtensions.<anonymous>' call
                var message11 = "Engine doesn't support " + toString(requestedExtension11);
                throw IllegalArgumentException_init_$Create$(toString(message11));
            }
        }
    }
    function HttpClientEngine$install$slambda($client11, this$011, resultContinuation11) {
        this.a4z_1 = $client11;
        this.b4z_1 = this$011;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpClientEngine$install$slambda).h4s = function($this$intercept11, content11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, content11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClientEngine$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpClientEngine$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    var tmp_011 = this;
                    var this_011 = new HttpRequestBuilder();
                    this_011.j4z(this.c4z_1.o46_1);
                    var body11 = this.d4z_1;
                    if (body11 == null) {
                        this_011.p4t_1 = NullBody_instance;
                        var tmp_141 = JsType_instance;
                        var tmp_211 = PrimitiveClasses_getInstance().wa();
                        var tmp_311;
                        try {
                            tmp_311 = createKType(PrimitiveClasses_getInstance().wa(), arrayOf([]), false);
                        } catch ($p11) {
                            var tmp_411;
                            if ($p11 instanceof Error) {
                                var cause11 = $p11;
                                tmp_411 = null;
                            } else throw $p11;
                            tmp_311 = tmp_411;
                        }
                        this_011.k4z(typeInfoImpl(tmp_141, tmp_211, tmp_311));
                    } else if (body11 instanceof OutgoingContent) {
                        this_011.p4t_1 = body11;
                        this_011.k4z(null);
                    } else {
                        this_011.p4t_1 = body11;
                        var tmp_511 = JsType_instance;
                        var tmp_611 = PrimitiveClasses_getInstance().wa();
                        var tmp_711;
                        try {
                            tmp_711 = createKType(PrimitiveClasses_getInstance().wa(), arrayOf([]), false);
                        } catch ($p11) {
                            var tmp_811;
                            if ($p11 instanceof Error) {
                                var cause_011 = $p11;
                                tmp_811 = null;
                            } else throw $p11;
                            tmp_711 = tmp_811;
                        }
                        this_011.k4z(typeInfoImpl(tmp_511, tmp_611, tmp_711));
                    }
                    tmp_011.e4z_1 = this_011;
                    this.a4z_1.t4r_1.e4r(get_HttpRequestIsReadyForSending(), this.e4z_1);
                    var tmp_911 = this;
                    var this_111 = this.e4z_1.c3r();
                    this_111.p4y_1.v41(get_CLIENT_CONFIG(), this.a4z_1.u4r_1);
                    tmp_911.f4z_1 = this_111;
                    validateHeaders(this.f4z_1);
                    checkExtensions(this.b4z_1, this.f4z_1);
                    this.v8_1 = 1;
                    suspendResult11 = executeWithinCallContext(this.b4z_1, this.f4z_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.g4z_1 = suspendResult11;
                    this.h4z_1 = HttpClientCall_init_$Create$(this.a4z_1, this.f4z_1, this.g4z_1);
                    this.i4z_1 = this.h4z_1.j31();
                    this.a4z_1.t4r_1.e4r(get_HttpResponseReceived(), this.i4z_1);
                    var tmp_1011 = get_job(this.i4z_1.v1m());
                    tmp_1011.w1n(HttpClientEngine$install$slambda$lambda(this.a4z_1, this.i4z_1));
                    this.v8_1 = 2;
                    suspendResult11 = this.c4z_1.s45(this.h4z_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpClientEngine$install$slambda).i4s = function($this$intercept11, content11, completion11) {
        var i11 = new HttpClientEngine$install$slambda(this.a4z_1, this.b4z_1, completion11);
        i11.c4z_1 = $this$intercept11;
        i11.d4z_1 = content11;
        return i11;
    };
    function HttpClientEngine$install$slambda_0($client11, this$011, resultContinuation11) {
        var i11 = new HttpClientEngine$install$slambda($client11, this$011, resultContinuation11);
        var l11 = function($this$intercept11, content11, $completion11) {
            return i11.h4s($this$intercept11, content11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function HttpClientEngine$executeWithinCallContext$slambda(this$011, $requestData11, resultContinuation11) {
        this.t4z_1 = this$011;
        this.u4z_1 = $requestData11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpClientEngine$executeWithinCallContext$slambda).w4z = function($this$async11, $completion11) {
        var tmp11 = this.e2b($this$async11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpClientEngine$executeWithinCallContext$slambda).y9 = function(p111, $completion11) {
        return this.w4z((!(p111 == null) ? isInterface(p111, CoroutineScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(HttpClientEngine$executeWithinCallContext$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    if (_get_closed__iwkfs1(this.t4z_1)) throw new ClientEngineClosedException();
                    this.v8_1 = 1;
                    suspendResult11 = this.t4z_1.x4z(this.u4z_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return suspendResult11;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpClientEngine$executeWithinCallContext$slambda).e2b = function($this$async11, completion11) {
        var i11 = new HttpClientEngine$executeWithinCallContext$slambda(this.t4z_1, this.u4z_1, completion11);
        i11.v4z_1 = $this$async11;
        return i11;
    };
    function HttpClientEngine$executeWithinCallContext$slambda_0(this$011, $requestData11, resultContinuation11) {
        var i11 = new HttpClientEngine$executeWithinCallContext$slambda(this$011, $requestData11, resultContinuation11);
        var l11 = function($this$async11, $completion11) {
            return i11.w4z($this$async11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function $executeWithinCallContextCOROUTINE$4(_this__u8e3s411, requestData11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.g4y_1 = _this__u8e3s411;
        this.h4y_1 = requestData11;
    }
    protoOf($executeWithinCallContextCOROUTINE$4).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult11 = createCallContext(this.g4y_1, this.h4y_1.o4y_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.i4y_1 = suspendResult11;
                    this.j4y_1 = this.i4y_1.vf(new KtorCallContextElement(this.i4y_1));
                    this.v8_1 = 2;
                    suspendResult11 = async(this.g4y_1, this.j4y_1, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.g4y_1, this.h4y_1, null)).m1p(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return suspendResult11;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function HttpClientEngine() {}
    function validateHeaders(request11) {
        _init_properties_HttpClientEngine_kt__h91z5h();
        var requestHeaders11 = request11.m4y_1;
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_011 = requestHeaders11.m43();
        var destination11 = ArrayList_init_$Create$();
        var tmp0_iterator11 = this_011.j();
        while(tmp0_iterator11.k()){
            var element11 = tmp0_iterator11.l();
            // Inline function 'io.ktor.client.engine.validateHeaders.<anonymous>' call
            if (HttpHeaders_getInstance().e4d_1.a2(element11)) destination11.e(element11);
        }
        var unsafeRequestHeaders11 = destination11;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!unsafeRequestHeaders11.s()) throw new UnsafeHeaderException(toString(unsafeRequestHeaders11));
    }
    function createCallContext(_this__u8e3s411, parentJob11, $completion11) {
        var callJob11 = Job(parentJob11);
        var callContext11 = _this__u8e3s411.v1m().vf(callJob11).vf(get_CALL_COROUTINE());
        $l$block: {
            // Inline function 'io.ktor.client.engine.attachToUserJob' call
            // Inline function 'kotlin.js.getCoroutineContext' call
            var tmp0_elvis_lhs11 = $completion11.b9().i9(Key_instance);
            var tmp11;
            if (tmp0_elvis_lhs11 == null) break $l$block;
            else tmp11 = tmp0_elvis_lhs11;
            var userJob11 = tmp11;
            var cleanupHandler11 = userJob11.y1n(true, VOID, createCallContext$lambda(callJob11));
            callJob11.w1n(createCallContext$lambda_0(cleanupHandler11));
        }
        return callContext11;
    }
    function HttpClientEngineFactory$create$lambda($this$null11) {
        return Unit_instance;
    }
    function HttpClientEngineFactory() {}
    function createCallContext$lambda($callJob11) {
        return function(cause11) {
            if (cause11 == null) return Unit_instance;
            $callJob11.b1o(CancellationException_init_$Create$(cause11.message));
            return Unit_instance;
        };
    }
    function createCallContext$lambda_0($cleanupHandler11) {
        return function(it11) {
            $cleanupHandler11.y1p();
            return Unit_instance;
        };
    }
    var properties_initialized_HttpClientEngine_kt_5uiebb;
    function _init_properties_HttpClientEngine_kt__h91z5h() {
        if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
            properties_initialized_HttpClientEngine_kt_5uiebb = true;
            CALL_COROUTINE = new CoroutineName("call-context");
            CLIENT_CONFIG = new AttributeKey("client-config");
        }
    }
    function ClientEngineClosedException(cause11) {
        cause11 = cause11 === VOID ? null : cause11;
        IllegalStateException_init_$Init$_0("Client already closed", this);
        captureStack(this, ClientEngineClosedException);
        this.z4z_1 = cause11;
    }
    protoOf(ClientEngineClosedException).m9 = function() {
        return this.z4z_1;
    };
    function HttpClientEngineBase$coroutineContext$delegate$lambda(this$011) {
        return function() {
            return SilentSupervisor().vf(this$011.e50()).vf(new CoroutineName(this$011.a50_1 + "-context"));
        };
    }
    function HttpClientEngineBase(engineName11) {
        this.a50_1 = engineName11;
        this.b50_1 = atomic$boolean$1(false);
        this.c50_1 = ioDispatcher();
        var tmp11 = this;
        tmp11.d50_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
    }
    protoOf(HttpClientEngineBase).e50 = function() {
        return this.c50_1;
    };
    protoOf(HttpClientEngineBase).v1m = function() {
        // Inline function 'kotlin.getValue' call
        var this_011 = this.d50_1;
        coroutineContext$factory();
        return this_011.b1();
    };
    protoOf(HttpClientEngineBase).v3w = function() {
        if (!this.b50_1.atomicfu$compareAndSet(false, true)) return Unit_instance;
        var tmp11 = this.v1m().i9(Key_instance);
        var tmp0_elvis_lhs11 = (!(tmp11 == null) ? isInterface(tmp11, CompletableJob) : false) ? tmp11 : null;
        var tmp_011;
        if (tmp0_elvis_lhs11 == null) return Unit_instance;
        else tmp_011 = tmp0_elvis_lhs11;
        var requestJob11 = tmp_011;
        requestJob11.s1s();
    };
    function coroutineContext$factory() {
        return getPropertyCallableRef("coroutineContext", 1, KProperty1, function(receiver11) {
            return receiver11.v1m();
        }, null);
    }
    function get_ENGINE_CAPABILITIES_KEY() {
        _init_properties_HttpClientEngineCapability_kt__ifvyst();
        return ENGINE_CAPABILITIES_KEY;
    }
    var ENGINE_CAPABILITIES_KEY;
    var DEFAULT_CAPABILITIES;
    var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
    function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
        if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
            properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
            ENGINE_CAPABILITIES_KEY = new AttributeKey("EngineCapabilities");
            DEFAULT_CAPABILITIES = setOf(Plugin_getInstance_4());
        }
    }
    function HttpClientEngineConfig() {
        this.f50_1 = 4;
        this.g50_1 = false;
        this.h50_1 = null;
    }
    function get_KTOR_DEFAULT_USER_AGENT() {
        _init_properties_Utils_kt__jo07cx();
        return KTOR_DEFAULT_USER_AGENT;
    }
    var KTOR_DEFAULT_USER_AGENT;
    function get_DATE_HEADERS() {
        _init_properties_Utils_kt__jo07cx();
        return DATE_HEADERS;
    }
    var DATE_HEADERS;
    function Companion_0() {}
    var Companion_instance_1;
    function Companion_getInstance_7() {
        return Companion_instance_1;
    }
    function KtorCallContextElement(callContext11) {
        this.i50_1 = callContext11;
    }
    protoOf(KtorCallContextElement).a1 = function() {
        return Companion_instance_1;
    };
    function callContext($completion11) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$011 = $completion11.b9();
        return ensureNotNull(tmp$ret$011.i9(Companion_instance_1)).i50_1;
    }
    function mergeHeaders(requestHeaders11, content11, block11) {
        _init_properties_Utils_kt__jo07cx();
        var tmp11 = buildHeaders(mergeHeaders$lambda(requestHeaders11, content11));
        tmp11.o43(mergeHeaders$lambda_0(block11));
        var missingAgent11 = requestHeaders11.vl(HttpHeaders_getInstance().h4c_1) == null && content11.m4d().vl(HttpHeaders_getInstance().h4c_1) == null;
        if (missingAgent11 && needUserAgent()) block11(HttpHeaders_getInstance().h4c_1, get_KTOR_DEFAULT_USER_AGENT());
        var tmp0_safe_receiver11 = content11.r4i();
        var tmp1_elvis_lhs11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.toString();
        var tmp2_elvis_lhs11 = tmp1_elvis_lhs11 == null ? content11.m4d().vl(HttpHeaders_getInstance().b4a_1) : tmp1_elvis_lhs11;
        var type11 = tmp2_elvis_lhs11 == null ? requestHeaders11.vl(HttpHeaders_getInstance().b4a_1) : tmp2_elvis_lhs11;
        var tmp3_safe_receiver11 = content11.s4i();
        var tmp4_elvis_lhs11 = tmp3_safe_receiver11 == null ? null : tmp3_safe_receiver11.toString();
        var tmp5_elvis_lhs11 = tmp4_elvis_lhs11 == null ? content11.m4d().vl(HttpHeaders_getInstance().y49_1) : tmp4_elvis_lhs11;
        var length11 = tmp5_elvis_lhs11 == null ? requestHeaders11.vl(HttpHeaders_getInstance().y49_1) : tmp5_elvis_lhs11;
        if (type11 == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        block11(HttpHeaders_getInstance().b4a_1, type11);
        if (length11 == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        block11(HttpHeaders_getInstance().y49_1, length11);
    }
    function needUserAgent() {
        _init_properties_Utils_kt__jo07cx();
        return !PlatformUtils_getInstance().e43_1;
    }
    function mergeHeaders$lambda($requestHeaders11, $content11) {
        return function($this$buildHeaders11) {
            $this$buildHeaders11.x43($requestHeaders11);
            $this$buildHeaders11.x43($content11.m4d());
            return Unit_instance;
        };
    }
    function mergeHeaders$lambda_0($block11) {
        return function(key11, values11) {
            var tmp11;
            if (HttpHeaders_getInstance().y49_1 === key11) return Unit_instance;
            var tmp_011;
            if (HttpHeaders_getInstance().b4a_1 === key11) return Unit_instance;
            var tmp_141;
            if (get_DATE_HEADERS().a2(key11)) {
                var tmp0_iterator11 = values11.j();
                while(tmp0_iterator11.k()){
                    var element11 = tmp0_iterator11.l();
                    // Inline function 'io.ktor.client.engine.mergeHeaders.<anonymous>.<anonymous>' call
                    $block11(key11, element11);
                }
                tmp_141 = Unit_instance;
            } else {
                var separator11 = HttpHeaders_getInstance().c4a_1 === key11 ? "; " : ",";
                tmp_141 = $block11(key11, joinToString(values11, separator11));
            }
            return Unit_instance;
        };
    }
    var properties_initialized_Utils_kt_xvi83j;
    function _init_properties_Utils_kt__jo07cx() {
        if (!properties_initialized_Utils_kt_xvi83j) {
            properties_initialized_Utils_kt_xvi83j = true;
            KTOR_DEFAULT_USER_AGENT = "Ktor client";
            DATE_HEADERS = setOf_0([
                HttpHeaders_getInstance().e4a_1,
                HttpHeaders_getInstance().k4a_1,
                HttpHeaders_getInstance().w4a_1,
                HttpHeaders_getInstance().r4a_1,
                HttpHeaders_getInstance().v4a_1
            ]);
        }
    }
    function get_UploadProgressListenerAttributeKey() {
        _init_properties_BodyProgress_kt__s0v569();
        return UploadProgressListenerAttributeKey;
    }
    var UploadProgressListenerAttributeKey;
    function get_DownloadProgressListenerAttributeKey() {
        _init_properties_BodyProgress_kt__s0v569();
        return DownloadProgressListenerAttributeKey;
    }
    var DownloadProgressListenerAttributeKey;
    function handle($this11, scope11) {
        var observableContentPhase11 = new PipelinePhase("ObservableContent");
        scope11.n4r_1.p46(Phases_getInstance().m50_1, observableContentPhase11);
        scope11.n4r_1.s46(observableContentPhase11, BodyProgress$handle$slambda_0(null));
        var tmp11 = Phases_getInstance_2().q50_1;
        scope11.q4r_1.s46(tmp11, BodyProgress$handle$slambda_2(null));
    }
    function Plugin() {
        Plugin_instance = this;
        this.r50_1 = new AttributeKey("BodyProgress");
    }
    protoOf(Plugin).a1 = function() {
        return this.r50_1;
    };
    protoOf(Plugin).s50 = function(block11) {
        return new BodyProgress();
    };
    protoOf(Plugin).r4u = function(block11) {
        return this.s50(block11);
    };
    protoOf(Plugin).t50 = function(plugin11, scope11) {
        handle(plugin11, scope11);
    };
    protoOf(Plugin).s4u = function(plugin11, scope11) {
        return this.t50(plugin11 instanceof BodyProgress ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance;
    function Plugin_getInstance() {
        if (Plugin_instance == null) new Plugin();
        return Plugin_instance;
    }
    function BodyProgress$handle$slambda(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(BodyProgress$handle$slambda).h4s = function($this$intercept11, content11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, content11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(BodyProgress$handle$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(BodyProgress$handle$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    var tmp_011 = this;
                    var tmp0_elvis_lhs11 = this.c51_1.o46_1.r4t_1.t41(get_UploadProgressListenerAttributeKey());
                    var tmp_141;
                    if (tmp0_elvis_lhs11 == null) return Unit_instance;
                    else tmp_141 = tmp0_elvis_lhs11;
                    tmp_011.e51_1 = tmp_141;
                    var tmp_211 = this;
                    var tmp_311 = this.d51_1;
                    tmp_211.f51_1 = new ObservableContent(tmp_311 instanceof OutgoingContent ? tmp_311 : THROW_CCE(), this.c51_1.o46_1.q4t_1, this.e51_1);
                    this.v8_1 = 1;
                    suspendResult11 = this.c51_1.s45(this.f51_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(BodyProgress$handle$slambda).i4s = function($this$intercept11, content11, completion11) {
        var i11 = new BodyProgress$handle$slambda(completion11);
        i11.c51_1 = $this$intercept11;
        i11.d51_1 = content11;
        return i11;
    };
    function BodyProgress$handle$slambda_0(resultContinuation11) {
        var i11 = new BodyProgress$handle$slambda(resultContinuation11);
        var l11 = function($this$intercept11, content11, $completion11) {
            return i11.h4s($this$intercept11, content11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function BodyProgress$handle$slambda_1(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(BodyProgress$handle$slambda_1).s51 = function($this$intercept11, response11, $completion11) {
        var tmp11 = this.t51($this$intercept11, response11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(BodyProgress$handle$slambda_1).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.s51(tmp11, p211 instanceof HttpResponse ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(BodyProgress$handle$slambda_1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    var tmp_011 = this;
                    var tmp0_elvis_lhs11 = this.p51_1.t4w().w4v().b4v().t41(get_DownloadProgressListenerAttributeKey());
                    var tmp_141;
                    if (tmp0_elvis_lhs11 == null) return Unit_instance;
                    else tmp_141 = tmp0_elvis_lhs11;
                    tmp_011.q51_1 = tmp_141;
                    this.r51_1 = withObservableDownload(this.p51_1, this.q51_1);
                    this.v8_1 = 1;
                    suspendResult11 = this.o51_1.s45(this.r51_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(BodyProgress$handle$slambda_1).t51 = function($this$intercept11, response11, completion11) {
        var i11 = new BodyProgress$handle$slambda_1(completion11);
        i11.o51_1 = $this$intercept11;
        i11.p51_1 = response11;
        return i11;
    };
    function BodyProgress$handle$slambda_2(resultContinuation11) {
        var i11 = new BodyProgress$handle$slambda_1(resultContinuation11);
        var l11 = function($this$intercept11, response11, $completion11) {
            return i11.s51($this$intercept11, response11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function BodyProgress() {
        Plugin_getInstance();
    }
    function withObservableDownload(_this__u8e3s411, listener11) {
        _init_properties_BodyProgress_kt__s0v569();
        var observableByteChannel11 = observable(_this__u8e3s411.e1b(), _this__u8e3s411.v1m(), contentLength(_this__u8e3s411), listener11);
        return wrapWithContent(_this__u8e3s411.t4w(), observableByteChannel11).j31();
    }
    var properties_initialized_BodyProgress_kt_pmfrhr;
    function _init_properties_BodyProgress_kt__s0v569() {
        if (!properties_initialized_BodyProgress_kt_pmfrhr) {
            properties_initialized_BodyProgress_kt_pmfrhr = true;
            UploadProgressListenerAttributeKey = new AttributeKey("UploadProgressListenerAttributeKey");
            DownloadProgressListenerAttributeKey = new AttributeKey("DownloadProgressListenerAttributeKey");
        }
    }
    function get_ValidateMark() {
        _init_properties_DefaultResponseValidation_kt__wcn8vr();
        return ValidateMark;
    }
    var ValidateMark;
    function get_LOGGER() {
        _init_properties_DefaultResponseValidation_kt__wcn8vr();
        return LOGGER;
    }
    var LOGGER;
    function addDefaultResponseValidation(_this__u8e3s411) {
        _init_properties_DefaultResponseValidation_kt__wcn8vr();
        HttpResponseValidator(_this__u8e3s411, addDefaultResponseValidation$lambda(_this__u8e3s411));
    }
    function ResponseException(response11, cachedResponseText11) {
        IllegalStateException_init_$Init$_0("Bad response: " + response11.toString() + '. Text: "' + cachedResponseText11 + '"', this);
        captureStack(this, ResponseException);
        this.u51_1 = response11;
    }
    function RedirectResponseException(response11, cachedResponseText11) {
        ResponseException.call(this, response11, cachedResponseText11);
        captureStack(this, RedirectResponseException);
        this.w51_1 = "Unhandled redirect: " + response11.t4w().w4v().u4w().v4d_1 + " " + response11.t4w().w4v().y3h().toString() + ". " + ("Status: " + response11.y4v().toString() + '. Text: "' + cachedResponseText11 + '"');
    }
    protoOf(RedirectResponseException).l9 = function() {
        return this.w51_1;
    };
    function ClientRequestException(response11, cachedResponseText11) {
        ResponseException.call(this, response11, cachedResponseText11);
        captureStack(this, ClientRequestException);
        this.y51_1 = "Client request(" + response11.t4w().w4v().u4w().v4d_1 + " " + response11.t4w().w4v().y3h().toString() + ") " + ("invalid: " + response11.y4v().toString() + '. Text: "' + cachedResponseText11 + '"');
    }
    protoOf(ClientRequestException).l9 = function() {
        return this.y51_1;
    };
    function ServerResponseException(response11, cachedResponseText11) {
        ResponseException.call(this, response11, cachedResponseText11);
        captureStack(this, ServerResponseException);
        this.a52_1 = "Server error(" + response11.t4w().w4v().u4w().v4d_1 + " " + response11.t4w().w4v().y3h().toString() + ": " + (response11.y4v().toString() + '. Text: "' + cachedResponseText11 + '"');
    }
    protoOf(ServerResponseException).l9 = function() {
        return this.a52_1;
    };
    function addDefaultResponseValidation$lambda$slambda(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(addDefaultResponseValidation$lambda$slambda).r52 = function(response11, $completion11) {
        var tmp11 = this.s52(response11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(addDefaultResponseValidation$lambda$slambda).y9 = function(p111, $completion11) {
        return this.r52(p111 instanceof HttpResponse ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(addDefaultResponseValidation$lambda$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 5;
                    this.k52_1 = this.j52_1.t4w().b4v().s41(get_ExpectSuccessAttributeKey());
                    if (!this.k52_1) {
                        get_LOGGER().k47("Skipping default response validation for " + this.j52_1.t4w().w4v().y3h().toString());
                        return Unit_instance;
                    }
                    this.l52_1 = this.j52_1.y4v().h4g_1;
                    this.m52_1 = this.j52_1.t4w();
                    if (this.l52_1 < 300 || this.m52_1.b4v().u41(get_ValidateMark())) return Unit_instance;
                    this.v8_1 = 1;
                    suspendResult11 = save(this.m52_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.n52_1 = suspendResult11;
                    this.n52_1.b4v().v41(get_ValidateMark(), Unit_instance);
                    this.o52_1 = this.n52_1;
                    this.p52_1 = this.o52_1.j31();
                    this.w8_1 = 3;
                    this.v8_1 = 2;
                    suspendResult11 = bodyAsText(this.p52_1, VOID, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    this.q52_1 = suspendResult11;
                    this.w8_1 = 5;
                    this.v8_1 = 4;
                    continue $sm;
                case 3:
                    this.w8_1 = 5;
                    var tmp_011 = this.y8_1;
                    if (tmp_011 instanceof MalformedInputException) {
                        var _11 = this.y8_1;
                        var tmp_141 = this;
                        tmp_141.q52_1 = "<body failed decoding>";
                        this.v8_1 = 4;
                        continue $sm;
                    } else throw this.y8_1;
                case 4:
                    this.w8_1 = 5;
                    var exceptionResponseText11 = this.q52_1;
                    var tmp0_subject11 = this.l52_1;
                    var exception11 = (300 <= tmp0_subject11 ? tmp0_subject11 <= 399 : false) ? new RedirectResponseException(this.p52_1, exceptionResponseText11) : (400 <= tmp0_subject11 ? tmp0_subject11 <= 499 : false) ? new ClientRequestException(this.p52_1, exceptionResponseText11) : (500 <= tmp0_subject11 ? tmp0_subject11 <= 599 : false) ? new ServerResponseException(this.p52_1, exceptionResponseText11) : new ResponseException(this.p52_1, exceptionResponseText11);
                    get_LOGGER().k47("Default response validation for " + this.j52_1.t4w().w4v().y3h().toString() + " failed with " + exception11.toString());
                    throw exception11;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 5) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(addDefaultResponseValidation$lambda$slambda).s52 = function(response11, completion11) {
        var i11 = new addDefaultResponseValidation$lambda$slambda(completion11);
        i11.j52_1 = response11;
        return i11;
    };
    function addDefaultResponseValidation$lambda$slambda_0(resultContinuation11) {
        var i11 = new addDefaultResponseValidation$lambda$slambda(resultContinuation11);
        var l11 = function(response11, $completion11) {
            return i11.r52(response11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation11) {
        return function($this$HttpResponseValidator11) {
            $this$HttpResponseValidator11.v52_1 = $this_addDefaultResponseValidation11.y4t_1;
            $this$HttpResponseValidator11.w52(addDefaultResponseValidation$lambda$slambda_0(null));
            return Unit_instance;
        };
    }
    var properties_initialized_DefaultResponseValidation_kt_akvzqt;
    function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
        if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
            properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
            ValidateMark = new AttributeKey("ValidateMark");
            LOGGER = KtorSimpleLogger("io.ktor.client.plugins.DefaultResponseValidation");
        }
    }
    function get_LOGGER_0() {
        _init_properties_DefaultTransform_kt__20knxx();
        return LOGGER_0;
    }
    var LOGGER_0;
    function defaultTransformers(_this__u8e3s411) {
        _init_properties_DefaultTransform_kt__20knxx();
        var tmp11 = Phases_getInstance().m50_1;
        _this__u8e3s411.n4r_1.s46(tmp11, defaultTransformers$slambda_0(null));
        var tmp_011 = Phases_getInstance_1().l4u_1;
        _this__u8e3s411.o4r_1.s46(tmp_011, defaultTransformers$slambda_2(null));
        platformResponseDefaultTransformers(_this__u8e3s411);
    }
    function defaultTransformers$1$content$1($contentType11, $body11) {
        this.a53_1 = $body11;
        ByteArrayContent.call(this);
        var tmp11 = this;
        tmp11.y52_1 = $contentType11 == null ? Application_getInstance().a48_1 : $contentType11;
        this.z52_1 = toLong($body11.length);
    }
    protoOf(defaultTransformers$1$content$1).r4i = function() {
        return this.y52_1;
    };
    protoOf(defaultTransformers$1$content$1).s4i = function() {
        return this.z52_1;
    };
    protoOf(defaultTransformers$1$content$1).t4i = function() {
        return this.a53_1;
    };
    function defaultTransformers$1$content$2($this_intercept11, $contentType11, $body11) {
        this.e53_1 = $body11;
        ReadChannelContent.call(this);
        var tmp11 = this;
        var tmp0_safe_receiver11 = $this_intercept11.o46_1.o4t_1.vl(HttpHeaders_getInstance().y49_1);
        tmp11.c53_1 = tmp0_safe_receiver11 == null ? null : toLong_0(tmp0_safe_receiver11);
        var tmp_011 = this;
        tmp_011.d53_1 = $contentType11 == null ? Application_getInstance().a48_1 : $contentType11;
    }
    protoOf(defaultTransformers$1$content$2).s4i = function() {
        return this.c53_1;
    };
    protoOf(defaultTransformers$1$content$2).r4i = function() {
        return this.d53_1;
    };
    protoOf(defaultTransformers$1$content$2).w4i = function() {
        return this.e53_1;
    };
    function defaultTransformers$slambda(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(defaultTransformers$slambda).h4s = function($this$intercept11, body11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, body11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(defaultTransformers$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(defaultTransformers$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    if (this.n53_1.o46_1.o4t_1.vl(HttpHeaders_getInstance().j49_1) == null) this.n53_1.o46_1.o4t_1.w43(HttpHeaders_getInstance().j49_1, "*/*");
                    this.p53_1 = contentType(this.n53_1.o46_1);
                    var tmp_011 = this;
                    var tmp0_subject11 = this.o53_1;
                    var tmp_141;
                    if (typeof tmp0_subject11 === "string") {
                        var tmp1_elvis_lhs11 = this.p53_1;
                        tmp_141 = new TextContent(this.o53_1, tmp1_elvis_lhs11 == null ? Text_getInstance().q48_1 : tmp1_elvis_lhs11);
                    } else if (isByteArray(tmp0_subject11)) tmp_141 = new defaultTransformers$1$content$1(this.p53_1, this.o53_1);
                    else {
                        if (isInterface(tmp0_subject11, ByteReadChannel)) tmp_141 = new defaultTransformers$1$content$2(this.n53_1, this.p53_1, this.o53_1);
                        else if (tmp0_subject11 instanceof OutgoingContent) tmp_141 = this.o53_1;
                        else tmp_141 = platformRequestDefaultTransform(this.p53_1, this.n53_1.o46_1, this.o53_1);
                    }
                    tmp_011.q53_1 = tmp_141;
                    var tmp2_safe_receiver11 = this.q53_1;
                    if (!((tmp2_safe_receiver11 == null ? null : tmp2_safe_receiver11.r4i()) == null)) {
                        this.n53_1.o46_1.o4t_1.y43(HttpHeaders_getInstance().b4a_1);
                        get_LOGGER_0().k47("Transformed with default transformers request body for " + this.n53_1.o46_1.m4t_1.toString() + " from " + toString(getKClassFromExpression(this.o53_1)));
                        this.v8_1 = 1;
                        suspendResult11 = this.n53_1.s45(this.q53_1, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(defaultTransformers$slambda).i4s = function($this$intercept11, body11, completion11) {
        var i11 = new defaultTransformers$slambda(completion11);
        i11.n53_1 = $this$intercept11;
        i11.o53_1 = body11;
        return i11;
    };
    function defaultTransformers$slambda_0(resultContinuation11) {
        var i11 = new defaultTransformers$slambda(resultContinuation11);
        var l11 = function($this$intercept11, body11, $completion11) {
            return i11.h4s($this$intercept11, body11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function defaultTransformers$slambda$slambda($body11, $response11, resultContinuation11) {
        this.z53_1 = $body11;
        this.a54_1 = $response11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(defaultTransformers$slambda$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(defaultTransformers$slambda$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(defaultTransformers$slambda$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    this.w8_1 = 3;
                    this.v8_1 = 2;
                    suspendResult11 = copyTo(this.z53_1, this.b54_1.v1x(), new Long(-1, 2147483647), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    var tmp_011 = this;
                    tmp_011.c54_1 = Unit_instance;
                    this.w8_1 = 5;
                    this.v8_1 = 6;
                    continue $sm;
                case 3:
                    this.w8_1 = 4;
                    var tmp_141 = this.y8_1;
                    if (tmp_141 instanceof CancellationException) {
                        var cause11 = this.y8_1;
                        var tmp_211 = this;
                        cancel(this.a54_1, cause11);
                        throw cause11;
                    } else {
                        var tmp_311 = this.y8_1;
                        if (tmp_311 instanceof Error) {
                            var cause_011 = this.y8_1;
                            var tmp_411 = this;
                            cancel_0(this.a54_1, "Receive failed", cause_011);
                            throw cause_011;
                        } else throw this.y8_1;
                    }
                case 4:
                    this.w8_1 = 5;
                    var t11 = this.y8_1;
                    complete(this.a54_1);
                    throw t11;
                case 5:
                    throw this.y8_1;
                case 6:
                    this.w8_1 = 5;
                    complete(this.a54_1);
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 5) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(defaultTransformers$slambda$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new defaultTransformers$slambda$slambda(this.z53_1, this.a54_1, completion11);
        i11.b54_1 = $this$writer11;
        return i11;
    };
    function defaultTransformers$slambda$slambda_0($body11, $response11, resultContinuation11) {
        var i11 = new defaultTransformers$slambda$slambda($body11, $response11, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function defaultTransformers$slambda$lambda($responseJobHolder11) {
        return function(it11) {
            $responseJobHolder11.s1s();
            return Unit_instance;
        };
    }
    function defaultTransformers$slambda_1(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(defaultTransformers$slambda_1).a4t = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11) {
        var tmp11 = this.b4t($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(defaultTransformers$slambda_1).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.a4t(tmp11, p211 instanceof HttpResponseContainer ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(defaultTransformers$slambda_1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 11;
                    this.n54_1 = this.m54_1.ba();
                    this.o54_1 = this.m54_1.ca();
                    var tmp_011 = this.o54_1;
                    if (!isInterface(tmp_011, ByteReadChannel)) return Unit_instance;
                    this.p54_1 = this.l54_1.o46_1.j31();
                    this.q54_1 = this.n54_1.f47_1;
                    if (this.q54_1.equals(getKClass(Unit))) {
                        cancel_1(this.o54_1);
                        this.v8_1 = 9;
                        suspendResult11 = this.l54_1.s45(new HttpResponseContainer(this.n54_1, Unit_instance), this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else if (this.q54_1.equals(PrimitiveClasses_getInstance().cb())) {
                        this.v8_1 = 7;
                        suspendResult11 = this.o54_1.i3t(VOID, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        if (this.q54_1.equals(getKClass(ByteReadPacket)) ? true : this.q54_1.equals(getKClass(Input))) {
                            this.v8_1 = 5;
                            suspendResult11 = this.o54_1.i3t(VOID, this);
                            if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                            continue $sm;
                        } else if (this.q54_1.equals(PrimitiveClasses_getInstance().kb())) {
                            this.v8_1 = 3;
                            suspendResult11 = toByteArray(this.o54_1, this);
                            if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                            continue $sm;
                        } else {
                            if (this.q54_1.equals(getKClass(ByteReadChannel))) {
                                this.s54_1 = Job(this.p54_1.v1m().i9(Key_instance));
                                var tmp_141 = this;
                                var tmp_211 = this.p54_1.v1m();
                                var this_011 = writer(this.l54_1, tmp_211, VOID, defaultTransformers$slambda$slambda_0(this.o54_1, this.p54_1, null));
                                this_011.w1n(defaultTransformers$slambda$lambda(this.s54_1));
                                tmp_141.t54_1 = this_011.v1x();
                                this.v8_1 = 2;
                                suspendResult11 = this.l54_1.s45(new HttpResponseContainer(this.n54_1, this.t54_1), this);
                                if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                                continue $sm;
                            } else if (this.q54_1.equals(getKClass(HttpStatusCode))) {
                                cancel_1(this.o54_1);
                                this.v8_1 = 1;
                                suspendResult11 = this.l54_1.s45(new HttpResponseContainer(this.n54_1, this.p54_1.y4v()), this);
                                if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                                continue $sm;
                            } else {
                                this.r54_1 = null;
                                this.v8_1 = 10;
                                continue $sm;
                            }
                        }
                    }
                case 1:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 2:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 3:
                    this.u54_1 = suspendResult11;
                    this.v54_1 = contentLength(this.p54_1);
                    this.w54_1 = !PlatformUtils_getInstance().e43_1 && this.p54_1.m4d().vl(HttpHeaders_getInstance().w49_1) == null;
                    this.x54_1 = !this.l54_1.o46_1.w4v().u4w().equals(Companion_getInstance_0().s4d_1);
                    if (this.w54_1 && this.x54_1 && !(this.v54_1 == null) && this.v54_1.j1(new Long(0, 0)) > 0) {
                        if (!(this.u54_1.length === this.v54_1.l1())) {
                            var message11 = "Expected " + toString_0(this.v54_1) + ", actual " + this.u54_1.length;
                            throw IllegalStateException_init_$Create$(toString(message11));
                        }
                    }
                    this.v8_1 = 4;
                    suspendResult11 = this.l54_1.s45(new HttpResponseContainer(this.n54_1, this.u54_1), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 4:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 5:
                    this.y54_1 = suspendResult11;
                    this.z54_1 = new HttpResponseContainer(this.n54_1, this.y54_1);
                    this.v8_1 = 6;
                    suspendResult11 = this.l54_1.s45(this.z54_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 6:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 7:
                    this.a55_1 = suspendResult11;
                    this.b55_1 = this.a55_1.p3x();
                    this.c55_1 = toInt(this.b55_1);
                    this.d55_1 = new HttpResponseContainer(this.n54_1, this.c55_1);
                    this.v8_1 = 8;
                    suspendResult11 = this.l54_1.s45(this.d55_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 8:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 9:
                    this.r54_1 = suspendResult11;
                    this.v8_1 = 10;
                    continue $sm;
                case 10:
                    var result11 = this.r54_1;
                    if (!(result11 == null)) get_LOGGER_0().k47("Transformed with default transformers response body " + ("for " + this.l54_1.o46_1.w4v().y3h().toString() + " to " + toString(this.n54_1.f47_1)));
                    return Unit_instance;
                case 11:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 11) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(defaultTransformers$slambda_1).b4t = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, completion11) {
        var i11 = new defaultTransformers$slambda_1(completion11);
        i11.l54_1 = $this$intercept11;
        i11.m54_1 = _name_for_destructuring_parameter_0__wldtmu11;
        return i11;
    };
    function defaultTransformers$slambda_2(resultContinuation11) {
        var i11 = new defaultTransformers$slambda_1(resultContinuation11);
        var l11 = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11) {
            return i11.a4t($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    var properties_initialized_DefaultTransform_kt_ossax9;
    function _init_properties_DefaultTransform_kt__20knxx() {
        if (!properties_initialized_DefaultTransform_kt_ossax9) {
            properties_initialized_DefaultTransform_kt_ossax9 = true;
            LOGGER_0 = KtorSimpleLogger("io.ktor.client.plugins.defaultTransformers");
        }
    }
    function get_LOGGER_1() {
        _init_properties_HttpCallValidator_kt__r6yh2y();
        return LOGGER_1;
    }
    var LOGGER_1;
    function get_ExpectSuccessAttributeKey() {
        _init_properties_HttpCallValidator_kt__r6yh2y();
        return ExpectSuccessAttributeKey;
    }
    var ExpectSuccessAttributeKey;
    function HttpCallValidator$Companion$install$slambda$lambda($plugin11) {
        return function() {
            return $plugin11.g55_1;
        };
    }
    function HttpCallValidator$Companion$install$slambda($plugin11, resultContinuation11) {
        this.p55_1 = $plugin11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpCallValidator$Companion$install$slambda).h4s = function($this$intercept11, it11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, it11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpCallValidator$Companion$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpCallValidator$Companion$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 5;
                    this.w8_1 = 3;
                    var tmp_011 = get_ExpectSuccessAttributeKey();
                    this.q55_1.o46_1.r4t_1.x41(tmp_011, HttpCallValidator$Companion$install$slambda$lambda(this.p55_1));
                    this.v8_1 = 1;
                    suspendResult11 = this.q55_1.s45(this.r55_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.w8_1 = 5;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.w8_1 = 5;
                    return Unit_instance;
                case 3:
                    this.w8_1 = 5;
                    var tmp_141 = this.y8_1;
                    if (tmp_141 instanceof Error) {
                        this.s55_1 = this.y8_1;
                        this.t55_1 = unwrapCancellationException(this.s55_1);
                        this.v8_1 = 4;
                        suspendResult11 = processException(this.p55_1, this.t55_1, HttpRequest(this.q55_1.o46_1), this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else throw this.y8_1;
                case 4:
                    throw this.t55_1;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 5) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpCallValidator$Companion$install$slambda).i4s = function($this$intercept11, it11, completion11) {
        var i11 = new HttpCallValidator$Companion$install$slambda(this.p55_1, completion11);
        i11.q55_1 = $this$intercept11;
        i11.r55_1 = it11;
        return i11;
    };
    function HttpCallValidator$Companion$install$slambda_0($plugin11, resultContinuation11) {
        var i11 = new HttpCallValidator$Companion$install$slambda($plugin11, resultContinuation11);
        var l11 = function($this$intercept11, it11, $completion11) {
            return i11.h4s($this$intercept11, it11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function HttpCallValidator$Companion$install$slambda_1($plugin11, resultContinuation11) {
        this.c56_1 = $plugin11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpCallValidator$Companion$install$slambda_1).a4t = function($this$intercept11, container11, $completion11) {
        var tmp11 = this.b4t($this$intercept11, container11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpCallValidator$Companion$install$slambda_1).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.a4t(tmp11, p211 instanceof HttpResponseContainer ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpCallValidator$Companion$install$slambda_1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 5;
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult11 = this.d56_1.s45(this.e56_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.w8_1 = 5;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.w8_1 = 5;
                    return Unit_instance;
                case 3:
                    this.w8_1 = 5;
                    var tmp_011 = this.y8_1;
                    if (tmp_011 instanceof Error) {
                        this.f56_1 = this.y8_1;
                        this.g56_1 = unwrapCancellationException(this.f56_1);
                        this.v8_1 = 4;
                        suspendResult11 = processException(this.c56_1, this.g56_1, this.d56_1.o46_1.w4v(), this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else throw this.y8_1;
                case 4:
                    throw this.g56_1;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 5) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpCallValidator$Companion$install$slambda_1).b4t = function($this$intercept11, container11, completion11) {
        var i11 = new HttpCallValidator$Companion$install$slambda_1(this.c56_1, completion11);
        i11.d56_1 = $this$intercept11;
        i11.e56_1 = container11;
        return i11;
    };
    function HttpCallValidator$Companion$install$slambda_2($plugin11, resultContinuation11) {
        var i11 = new HttpCallValidator$Companion$install$slambda_1($plugin11, resultContinuation11);
        var l11 = function($this$intercept11, container11, $completion11) {
            return i11.a4t($this$intercept11, container11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function HttpCallValidator$Companion$install$slambda_3($plugin11, resultContinuation11) {
        this.p56_1 = $plugin11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpCallValidator$Companion$install$slambda_3).t56 = function($this$intercept11, request11, $completion11) {
        var tmp11 = this.u56($this$intercept11, request11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpCallValidator$Companion$install$slambda_3).hj = function(p111, p211, $completion11) {
        var tmp11 = (!(p111 == null) ? isInterface(p111, Sender) : false) ? p111 : THROW_CCE();
        return this.t56(tmp11, p211 instanceof HttpRequestBuilder ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpCallValidator$Companion$install$slambda_3).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult11 = this.q56_1.v56(this.r56_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.s56_1 = suspendResult11;
                    this.v8_1 = 2;
                    suspendResult11 = validateResponse(this.p56_1, this.s56_1.j31(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return this.s56_1;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpCallValidator$Companion$install$slambda_3).u56 = function($this$intercept11, request11, completion11) {
        var i11 = new HttpCallValidator$Companion$install$slambda_3(this.p56_1, completion11);
        i11.q56_1 = $this$intercept11;
        i11.r56_1 = request11;
        return i11;
    };
    function HttpCallValidator$Companion$install$slambda_4($plugin11, resultContinuation11) {
        var i11 = new HttpCallValidator$Companion$install$slambda_3($plugin11, resultContinuation11);
        var l11 = function($this$intercept11, request11, $completion11) {
            return i11.t56($this$intercept11, request11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function validateResponse($this11, response11, $completion11) {
        var tmp11 = new $validateResponseCOROUTINE$5($this11, response11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function processException($this11, cause11, request11, $completion11) {
        var tmp11 = new $processExceptionCOROUTINE$6($this11, cause11, request11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function Config() {
        var tmp11 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp11.t52_1 = ArrayList_init_$Create$();
        var tmp_011 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_011.u52_1 = ArrayList_init_$Create$();
        this.v52_1 = true;
    }
    protoOf(Config).w52 = function(block11) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.t52_1.e(block11);
    };
    function Companion_1() {
        Companion_instance_2 = this;
        this.z57_1 = new AttributeKey("HttpResponseValidator");
    }
    protoOf(Companion_1).a1 = function() {
        return this.z57_1;
    };
    protoOf(Companion_1).a58 = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new Config();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        return new HttpCallValidator(reversed(config11.t52_1), reversed(config11.u52_1), config11.v52_1);
    };
    protoOf(Companion_1).r4u = function(block11) {
        return this.a58(block11);
    };
    protoOf(Companion_1).b58 = function(plugin_011, scope11) {
        var tmp11 = Phases_getInstance().j50_1;
        scope11.n4r_1.s46(tmp11, HttpCallValidator$Companion$install$slambda_0(plugin_011, null));
        var BeforeReceive11 = new PipelinePhase("BeforeReceive");
        scope11.o4r_1.r46(Phases_getInstance_1().k4u_1, BeforeReceive11);
        scope11.o4r_1.s46(BeforeReceive11, HttpCallValidator$Companion$install$slambda_2(plugin_011, null));
        var tmp_011 = plugin(scope11, Plugin_getInstance_3());
        tmp_011.e58(HttpCallValidator$Companion$install$slambda_4(plugin_011, null));
    };
    protoOf(Companion_1).s4u = function(plugin11, scope11) {
        return this.b58(plugin11 instanceof HttpCallValidator ? plugin11 : THROW_CCE(), scope11);
    };
    var Companion_instance_2;
    function Companion_getInstance_8() {
        if (Companion_instance_2 == null) new Companion_1();
        return Companion_instance_2;
    }
    function $validateResponseCOROUTINE$5(_this__u8e3s411, response11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.e57_1 = _this__u8e3s411;
        this.f57_1 = response11;
    }
    protoOf($validateResponseCOROUTINE$5).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    get_LOGGER_1().k47("Validating response for request " + this.f57_1.t4w().w4v().y3h().toString());
                    var tmp_011 = this;
                    tmp_011.g57_1 = this.e57_1.e55_1;
                    this.h57_1 = this.g57_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.h57_1.k()) {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                    this.i57_1 = this.h57_1.l();
                    this.v8_1 = 2;
                    suspendResult11 = this.i57_1(this.f57_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    return Unit_instance;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function $processExceptionCOROUTINE$6(_this__u8e3s411, cause11, request11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.r57_1 = _this__u8e3s411;
        this.s57_1 = cause11;
        this.t57_1 = request11;
    }
    protoOf($processExceptionCOROUTINE$6).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 6;
                    get_LOGGER_1().k47("Processing exception " + this.s57_1.toString() + " for request " + this.t57_1.y3h().toString());
                    var tmp_011 = this;
                    tmp_011.u57_1 = this.r57_1.f55_1;
                    this.v57_1 = this.u57_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    if (!this.v57_1.k()) {
                        this.v8_1 = 5;
                        continue $sm;
                    }
                    this.w57_1 = this.v57_1.l();
                    var tmp_141 = this;
                    tmp_141.x57_1 = this.w57_1;
                    this.y57_1 = this.x57_1;
                    var tmp_211 = this.y57_1;
                    if (tmp_211 instanceof ExceptionHandlerWrapper) {
                        this.v8_1 = 3;
                        suspendResult11 = this.x57_1.g58_1(this.s57_1, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        var tmp_311 = this.y57_1;
                        if (tmp_311 instanceof RequestExceptionHandlerWrapper) {
                            this.v8_1 = 2;
                            suspendResult11 = this.x57_1.f58_1(this.s57_1, this.t57_1, this);
                            if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                            continue $sm;
                        } else {
                            this.v8_1 = 4;
                            continue $sm;
                        }
                    }
                case 2:
                    this.v8_1 = 4;
                    continue $sm;
                case 3:
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.v8_1 = 1;
                    continue $sm;
                case 5:
                    return Unit_instance;
                case 6:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 6) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function HttpCallValidator(responseValidators11, callExceptionHandlers11, expectSuccess11) {
        Companion_getInstance_8();
        this.e55_1 = responseValidators11;
        this.f55_1 = callExceptionHandlers11;
        this.g55_1 = expectSuccess11;
    }
    function ExceptionHandlerWrapper() {}
    function RequestExceptionHandlerWrapper() {}
    function HttpRequest(builder11) {
        _init_properties_HttpCallValidator_kt__r6yh2y();
        return new HttpRequest$1(builder11);
    }
    function HttpResponseValidator(_this__u8e3s411, block11) {
        _init_properties_HttpCallValidator_kt__r6yh2y();
        _this__u8e3s411.t4u(Companion_getInstance_8(), block11);
    }
    function HttpRequest$1($builder11) {
        this.l58_1 = $builder11;
        this.h58_1 = $builder11.n4t_1;
        this.i58_1 = $builder11.m4t_1.c3r();
        this.j58_1 = $builder11.r4t_1;
        this.k58_1 = $builder11.o4t_1.c3r();
    }
    protoOf(HttpRequest$1).t4w = function() {
        var message11 = "Call is not initialized";
        throw IllegalStateException_init_$Create$(toString(message11));
    };
    protoOf(HttpRequest$1).u4w = function() {
        return this.h58_1;
    };
    protoOf(HttpRequest$1).y3h = function() {
        return this.i58_1;
    };
    protoOf(HttpRequest$1).b4v = function() {
        return this.j58_1;
    };
    protoOf(HttpRequest$1).m4d = function() {
        return this.k58_1;
    };
    var properties_initialized_HttpCallValidator_kt_xrx49w;
    function _init_properties_HttpCallValidator_kt__r6yh2y() {
        if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
            properties_initialized_HttpCallValidator_kt_xrx49w = true;
            LOGGER_1 = KtorSimpleLogger("io.ktor.client.plugins.HttpCallValidator");
            ExpectSuccessAttributeKey = new AttributeKey("ExpectSuccessAttributeKey");
        }
    }
    function get_PLUGIN_INSTALLED_LIST() {
        _init_properties_HttpClientPlugin_kt__cypu1m();
        return PLUGIN_INSTALLED_LIST;
    }
    var PLUGIN_INSTALLED_LIST;
    function plugin(_this__u8e3s411, plugin11) {
        _init_properties_HttpClientPlugin_kt__cypu1m();
        var tmp0_elvis_lhs11 = pluginOrNull(_this__u8e3s411, plugin11);
        var tmp11;
        if (tmp0_elvis_lhs11 == null) throw IllegalStateException_init_$Create$("Plugin " + toString(plugin11) + " is not installed. Consider using `install(" + plugin11.a1().toString() + ")` in client config first.");
        else tmp11 = tmp0_elvis_lhs11;
        return tmp11;
    }
    function HttpClientPlugin() {}
    function pluginOrNull(_this__u8e3s411, plugin11) {
        _init_properties_HttpClientPlugin_kt__cypu1m();
        var tmp0_safe_receiver11 = _this__u8e3s411.r4r_1.t41(get_PLUGIN_INSTALLED_LIST());
        return tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.t41(plugin11.a1());
    }
    var properties_initialized_HttpClientPlugin_kt_p98320;
    function _init_properties_HttpClientPlugin_kt__cypu1m() {
        if (!properties_initialized_HttpClientPlugin_kt_p98320) {
            properties_initialized_HttpClientPlugin_kt_p98320 = true;
            PLUGIN_INSTALLED_LIST = new AttributeKey("ApplicationPluginRegistry");
        }
    }
    function get_LOGGER_2() {
        _init_properties_HttpPlainText_kt__iy89z1();
        return LOGGER_2;
    }
    var LOGGER_2;
    function HttpPlainText$Plugin$install$slambda($plugin11, resultContinuation11) {
        this.u58_1 = $plugin11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpPlainText$Plugin$install$slambda).h4s = function($this$intercept11, content11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, content11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpPlainText$Plugin$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpPlainText$Plugin$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.u58_1.b59(this.v58_1.o46_1);
                    var tmp_011 = this.w58_1;
                    if (!(typeof tmp_011 === "string")) return Unit_instance;
                    this.x58_1 = contentType(this.v58_1.o46_1);
                    if (!(this.x58_1 == null) && !(this.x58_1.a49_1 === Text_getInstance().q48_1.a49_1)) return Unit_instance;
                    this.v8_1 = 1;
                    suspendResult11 = this.v58_1.s45(wrapContent(this.u58_1, this.v58_1.o46_1, this.w58_1, this.x58_1), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpPlainText$Plugin$install$slambda).i4s = function($this$intercept11, content11, completion11) {
        var i11 = new HttpPlainText$Plugin$install$slambda(this.u58_1, completion11);
        i11.v58_1 = $this$intercept11;
        i11.w58_1 = content11;
        return i11;
    };
    function HttpPlainText$Plugin$install$slambda_0($plugin11, resultContinuation11) {
        var i11 = new HttpPlainText$Plugin$install$slambda($plugin11, resultContinuation11);
        var l11 = function($this$intercept11, content11, $completion11) {
            return i11.h4s($this$intercept11, content11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function HttpPlainText$Plugin$install$slambda_1($plugin11, resultContinuation11) {
        this.k59_1 = $plugin11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpPlainText$Plugin$install$slambda_1).a4t = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11) {
        var tmp11 = this.b4t($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpPlainText$Plugin$install$slambda_1).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.a4t(tmp11, p211 instanceof HttpResponseContainer ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpPlainText$Plugin$install$slambda_1).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    this.n59_1 = this.m59_1.ba();
                    this.o59_1 = this.m59_1.ca();
                    var tmp_011;
                    if (!this.n59_1.f47_1.equals(PrimitiveClasses_getInstance().gb())) tmp_011 = true;
                    else {
                        var tmp_141 = this.o59_1;
                        tmp_011 = !isInterface(tmp_141, ByteReadChannel);
                    }
                    if (tmp_011) return Unit_instance;
                    this.v8_1 = 1;
                    suspendResult11 = this.o59_1.i3t(VOID, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.p59_1 = suspendResult11;
                    this.q59_1 = this.k59_1.r59(this.l59_1.o46_1, this.p59_1);
                    this.v8_1 = 2;
                    suspendResult11 = this.l59_1.s45(new HttpResponseContainer(this.n59_1, this.q59_1), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpPlainText$Plugin$install$slambda_1).b4t = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, completion11) {
        var i11 = new HttpPlainText$Plugin$install$slambda_1(this.k59_1, completion11);
        i11.l59_1 = $this$intercept11;
        i11.m59_1 = _name_for_destructuring_parameter_0__wldtmu11;
        return i11;
    };
    function HttpPlainText$Plugin$install$slambda_2($plugin11, resultContinuation11) {
        var i11 = new HttpPlainText$Plugin$install$slambda_1($plugin11, resultContinuation11);
        var l11 = function($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11) {
            return i11.a4t($this$intercept11, _name_for_destructuring_parameter_0__wldtmu11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function Config_0() {
        var tmp11 = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp11.s59_1 = LinkedHashSet_init_$Create$();
        var tmp_011 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_011.t59_1 = LinkedHashMap_init_$Create$();
        this.u59_1 = null;
        this.v59_1 = Charsets_getInstance().y3x_1;
    }
    function Plugin_0() {
        Plugin_instance_0 = this;
        this.w59_1 = new AttributeKey("HttpPlainText");
    }
    protoOf(Plugin_0).a1 = function() {
        return this.w59_1;
    };
    protoOf(Plugin_0).x59 = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new Config_0();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.contracts.contract' call
        return new HttpPlainText(config11.s59_1, config11.t59_1, config11.u59_1, config11.v59_1);
    };
    protoOf(Plugin_0).r4u = function(block11) {
        return this.x59(block11);
    };
    protoOf(Plugin_0).y59 = function(plugin11, scope11) {
        var tmp11 = Phases_getInstance().m50_1;
        scope11.n4r_1.s46(tmp11, HttpPlainText$Plugin$install$slambda_0(plugin11, null));
        var tmp_011 = Phases_getInstance_1().m4u_1;
        scope11.o4r_1.s46(tmp_011, HttpPlainText$Plugin$install$slambda_2(plugin11, null));
    };
    protoOf(Plugin_0).s4u = function(plugin11, scope11) {
        return this.y59(plugin11 instanceof HttpPlainText ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance_0;
    function Plugin_getInstance_0() {
        if (Plugin_instance_0 == null) new Plugin_0();
        return Plugin_instance_0;
    }
    function wrapContent($this11, request11, content11, requestContentType11) {
        var contentType11 = requestContentType11 == null ? Text_getInstance().q48_1 : requestContentType11;
        var tmp2_elvis_lhs11 = requestContentType11 == null ? null : charset(requestContentType11);
        var charset_011 = tmp2_elvis_lhs11 == null ? $this11.z58_1 : tmp2_elvis_lhs11;
        get_LOGGER_2().k47("Sending request body to " + request11.m4t_1.toString() + " as text/plain with charset " + charset_011.toString());
        return new TextContent(content11, withCharset(contentType11, charset_011));
    }
    function sam$kotlin_Comparator$0(function_011) {
        this.z59_1 = function_011;
    }
    protoOf(sam$kotlin_Comparator$0).bd = function(a11, b11) {
        return this.z59_1(a11, b11);
    };
    protoOf(sam$kotlin_Comparator$0).compare = function(a11, b11) {
        return this.bd(a11, b11);
    };
    function HttpPlainText$lambda(a11, b11) {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
        var tmp11 = b11.aa_1;
        // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
        var tmp$ret$111 = a11.aa_1;
        return compareValues(tmp11, tmp$ret$111);
    }
    function HttpPlainText$lambda_0(a11, b11) {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
        var tmp11 = get_name(a11);
        // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
        var tmp$ret$111 = get_name(b11);
        return compareValues(tmp11, tmp$ret$111);
    }
    function HttpPlainText(charsets11, charsetQuality11, sendCharset11, responseCharsetFallback11) {
        Plugin_getInstance_0();
        this.y58_1 = responseCharsetFallback11;
        // Inline function 'kotlin.collections.sortedByDescending' call
        var this_011 = toList(charsetQuality11);
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp11 = HttpPlainText$lambda;
        var tmp$ret$011 = new sam$kotlin_Comparator$0(tmp11);
        var withQuality11 = sortedWith(this_011, tmp$ret$011);
        // Inline function 'kotlin.collections.sortedBy' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination11 = ArrayList_init_$Create$();
        var tmp0_iterator11 = charsets11.j();
        while(tmp0_iterator11.k()){
            var element11 = tmp0_iterator11.l();
            // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
            if (!charsetQuality11.c2(element11)) destination11.e(element11);
        }
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_011 = HttpPlainText$lambda_0;
        var tmp$ret$511 = new sam$kotlin_Comparator$0(tmp_011);
        var withoutQuality11 = sortedWith(destination11, tmp$ret$511);
        var tmp_141 = this;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_111 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_011 = withoutQuality11.j();
        while(tmp0_iterator_011.k()){
            var element_011 = tmp0_iterator_011.l();
            // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(this_111) > 0) this_111.e8(",");
            this_111.e8(get_name(element_011));
        }
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_111 = withQuality11.j();
        while(tmp0_iterator_111.k()){
            var element_111 = tmp0_iterator_111.l();
            // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
            var charset11 = element_111.ba();
            var quality11 = element_111.ca();
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(this_111) > 0) this_111.e8(",");
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(0.0 <= quality11 ? quality11 <= 1.0 : false)) {
                // Inline function 'kotlin.check.<anonymous>' call
                var message11 = "Check failed.";
                throw IllegalStateException_init_$Create$(toString(message11));
            }
            // Inline function 'kotlin.math.roundToInt' call
            var this_211 = 100 * quality11;
            var truncatedQuality11 = roundToInt(this_211) / 100.0;
            this_111.e8(get_name(charset11) + ";q=" + truncatedQuality11);
        }
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(this_111) === 0) this_111.e8(get_name(this.y58_1));
        tmp_141.a59_1 = this_111.toString();
        var tmp_211 = this;
        var tmp2_elvis_lhs11 = sendCharset11 == null ? firstOrNull(withoutQuality11) : sendCharset11;
        var tmp_311;
        if (tmp2_elvis_lhs11 == null) {
            var tmp1_safe_receiver11 = firstOrNull(withQuality11);
            tmp_311 = tmp1_safe_receiver11 == null ? null : tmp1_safe_receiver11.z9_1;
        } else tmp_311 = tmp2_elvis_lhs11;
        var tmp3_elvis_lhs11 = tmp_311;
        tmp_211.z58_1 = tmp3_elvis_lhs11 == null ? Charsets_getInstance().y3x_1 : tmp3_elvis_lhs11;
    }
    protoOf(HttpPlainText).r59 = function(call11, body11) {
        var tmp0_elvis_lhs11 = charset_0(call11.j31());
        var actualCharset11 = tmp0_elvis_lhs11 == null ? this.y58_1 : tmp0_elvis_lhs11;
        get_LOGGER_2().k47("Reading response body for " + call11.w4v().y3h().toString() + " as String with charset " + actualCharset11.toString());
        return readText(body11, actualCharset11);
    };
    protoOf(HttpPlainText).b59 = function(context11) {
        if (!(context11.o4t_1.vl(HttpHeaders_getInstance().k49_1) == null)) return Unit_instance;
        get_LOGGER_2().k47("Adding Accept-Charset=" + this.a59_1 + " to " + context11.m4t_1.toString());
        context11.o4t_1.u43(HttpHeaders_getInstance().k49_1, this.a59_1);
    };
    var properties_initialized_HttpPlainText_kt_2nx4ox;
    function _init_properties_HttpPlainText_kt__iy89z1() {
        if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
            properties_initialized_HttpPlainText_kt_2nx4ox = true;
            LOGGER_2 = KtorSimpleLogger("io.ktor.client.plugins.HttpPlainText");
        }
    }
    function get_ALLOWED_FOR_REDIRECT() {
        _init_properties_HttpRedirect_kt__ure7fo();
        return ALLOWED_FOR_REDIRECT;
    }
    var ALLOWED_FOR_REDIRECT;
    function get_LOGGER_3() {
        _init_properties_HttpRedirect_kt__ure7fo();
        return LOGGER_3;
    }
    var LOGGER_3;
    function handleCall(_this__u8e3s411, $this11, context11, origin11, allowHttpsDowngrade11, client11, $completion11) {
        var tmp11 = new $handleCallCOROUTINE$7($this11, _this__u8e3s411, context11, origin11, allowHttpsDowngrade11, client11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function HttpRedirect$Plugin$install$slambda($plugin11, $scope11, resultContinuation11) {
        this.b5b_1 = $plugin11;
        this.c5b_1 = $scope11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpRedirect$Plugin$install$slambda).t56 = function($this$intercept11, context11, $completion11) {
        var tmp11 = this.u56($this$intercept11, context11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpRedirect$Plugin$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = (!(p111 == null) ? isInterface(p111, Sender) : false) ? p111 : THROW_CCE();
        return this.t56(tmp11, p211 instanceof HttpRequestBuilder ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpRedirect$Plugin$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult11 = this.d5b_1.v56(this.e5b_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.f5b_1 = suspendResult11;
                    if (this.b5b_1.g5b_1 && !get_ALLOWED_FOR_REDIRECT().a2(this.f5b_1.w4v().u4w())) return this.f5b_1;
                    this.v8_1 = 2;
                    suspendResult11 = handleCall(this.d5b_1, Plugin_getInstance_1(), this.e5b_1, this.f5b_1, this.b5b_1.h5b_1, this.c5b_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return suspendResult11;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpRedirect$Plugin$install$slambda).u56 = function($this$intercept11, context11, completion11) {
        var i11 = new HttpRedirect$Plugin$install$slambda(this.b5b_1, this.c5b_1, completion11);
        i11.d5b_1 = $this$intercept11;
        i11.e5b_1 = context11;
        return i11;
    };
    function HttpRedirect$Plugin$install$slambda_0($plugin11, $scope11, resultContinuation11) {
        var i11 = new HttpRedirect$Plugin$install$slambda($plugin11, $scope11, resultContinuation11);
        var l11 = function($this$intercept11, context11, $completion11) {
            return i11.t56($this$intercept11, context11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function $handleCallCOROUTINE$7(_this__u8e3s411, _this__u8e3s4_011, context11, origin11, allowHttpsDowngrade11, client11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.i5a_1 = _this__u8e3s411;
        this.j5a_1 = _this__u8e3s4_011;
        this.k5a_1 = context11;
        this.l5a_1 = origin11;
        this.m5a_1 = allowHttpsDowngrade11;
        this.n5a_1 = client11;
    }
    protoOf($handleCallCOROUTINE$7).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    if (!isRedirect(this.l5a_1.j31().y4v())) return this.l5a_1;
                    this.o5a_1 = this.l5a_1;
                    this.p5a_1 = this.k5a_1;
                    this.q5a_1 = this.l5a_1.w4v().y3h().z4g_1;
                    this.r5a_1 = get_authority(this.l5a_1.w4v().y3h());
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.n5a_1.t4r_1.e4r(this.i5a_1.j5b_1, this.o5a_1.j31());
                    this.s5a_1 = this.o5a_1.j31().m4d().vl(HttpHeaders_getInstance().x4a_1);
                    get_LOGGER_3().k47("Received redirect response to " + this.s5a_1 + " for request " + this.k5a_1.m4t_1.toString());
                    var tmp_011 = this;
                    var this_011 = new HttpRequestBuilder();
                    this_011.j4z(this.p5a_1);
                    this_011.m4t_1.w4g_1.i2();
                    var tmp0_safe_receiver11 = this.s5a_1;
                    if (tmp0_safe_receiver11 == null) ;
                    else takeFrom(this_011.m4t_1, tmp0_safe_receiver11);
                    if (!this.m5a_1 && isSecure(this.q5a_1) && !isSecure(this_011.m4t_1.n4g_1)) {
                        get_LOGGER_3().k47("Can not redirect " + this.k5a_1.m4t_1.toString() + " because of security downgrade");
                        return this.o5a_1;
                    }
                    if (!(this.r5a_1 === get_authority_0(this_011.m4t_1))) {
                        this_011.o4t_1.y43(HttpHeaders_getInstance().s49_1);
                        get_LOGGER_3().k47("Removing Authorization header from redirect for " + this.k5a_1.m4t_1.toString());
                    }
                    tmp_011.p5a_1 = this_011;
                    this.v8_1 = 2;
                    suspendResult11 = this.j5a_1.v56(this.p5a_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    this.o5a_1 = suspendResult11;
                    if (!isRedirect(this.o5a_1.j31().y4v())) return this.o5a_1;
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    throw this.y8_1;
                case 4:
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function Config_1() {
        this.k5b_1 = true;
        this.l5b_1 = false;
    }
    function Plugin_1() {
        Plugin_instance_1 = this;
        this.i5b_1 = new AttributeKey("HttpRedirect");
        this.j5b_1 = new EventDefinition();
    }
    protoOf(Plugin_1).a1 = function() {
        return this.i5b_1;
    };
    protoOf(Plugin_1).m5b = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new Config_1();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        return new HttpRedirect(config11.k5b_1, config11.l5b_1);
    };
    protoOf(Plugin_1).r4u = function(block11) {
        return this.m5b(block11);
    };
    protoOf(Plugin_1).n5b = function(plugin_011, scope11) {
        var tmp11 = plugin(scope11, Plugin_getInstance_3());
        tmp11.e58(HttpRedirect$Plugin$install$slambda_0(plugin_011, scope11, null));
    };
    protoOf(Plugin_1).s4u = function(plugin11, scope11) {
        return this.n5b(plugin11 instanceof HttpRedirect ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance_1;
    function Plugin_getInstance_1() {
        if (Plugin_instance_1 == null) new Plugin_1();
        return Plugin_instance_1;
    }
    function HttpRedirect(checkHttpMethod11, allowHttpsDowngrade11) {
        Plugin_getInstance_1();
        this.g5b_1 = checkHttpMethod11;
        this.h5b_1 = allowHttpsDowngrade11;
    }
    function isRedirect(_this__u8e3s411) {
        _init_properties_HttpRedirect_kt__ure7fo();
        var tmp0_subject11 = _this__u8e3s411.h4g_1;
        return ((((tmp0_subject11 === Companion_getInstance_1().q4e_1.h4g_1 ? true : tmp0_subject11 === Companion_getInstance_1().r4e_1.h4g_1) ? true : tmp0_subject11 === Companion_getInstance_1().w4e_1.h4g_1) ? true : tmp0_subject11 === Companion_getInstance_1().x4e_1.h4g_1) ? true : tmp0_subject11 === Companion_getInstance_1().s4e_1.h4g_1) ? true : false;
    }
    var properties_initialized_HttpRedirect_kt_klj746;
    function _init_properties_HttpRedirect_kt__ure7fo() {
        if (!properties_initialized_HttpRedirect_kt_klj746) {
            properties_initialized_HttpRedirect_kt_klj746 = true;
            ALLOWED_FOR_REDIRECT = setOf_0([
                Companion_getInstance_0().n4d_1,
                Companion_getInstance_0().s4d_1
            ]);
            LOGGER_3 = KtorSimpleLogger("io.ktor.client.plugins.HttpRedirect");
        }
    }
    function get_LOGGER_4() {
        _init_properties_HttpRequestLifecycle_kt__jgkmfx();
        return LOGGER_4;
    }
    var LOGGER_4;
    function HttpRequestLifecycle$Plugin$install$slambda($scope11, resultContinuation11) {
        this.w5b_1 = $scope11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpRequestLifecycle$Plugin$install$slambda).h4s = function($this$intercept11, it11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, it11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpRequestLifecycle$Plugin$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpRequestLifecycle$Plugin$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 6;
                    this.z5b_1 = SupervisorJob(this.x5b_1.o46_1.q4t_1);
                    attachToClientEngineJob(this.z5b_1, ensureNotNull(this.w5b_1.m4r_1.i9(Key_instance)));
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    this.w8_1 = 3;
                    this.x5b_1.o46_1.q4t_1 = this.z5b_1;
                    this.v8_1 = 2;
                    suspendResult11 = this.x5b_1.t45(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    var tmp_011 = this;
                    tmp_011.a5c_1 = Unit_instance;
                    this.w8_1 = 6;
                    this.v8_1 = 5;
                    continue $sm;
                case 3:
                    this.w8_1 = 4;
                    var tmp_141 = this.y8_1;
                    if (tmp_141 instanceof Error) {
                        var cause11 = this.y8_1;
                        var tmp_211 = this;
                        this.z5b_1.r1s(cause11);
                        throw cause11;
                    } else throw this.y8_1;
                case 4:
                    this.w8_1 = 6;
                    var t11 = this.y8_1;
                    this.z5b_1.s1s();
                    throw t11;
                case 5:
                    this.w8_1 = 6;
                    this.z5b_1.s1s();
                    return Unit_instance;
                case 6:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 6) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpRequestLifecycle$Plugin$install$slambda).i4s = function($this$intercept11, it11, completion11) {
        var i11 = new HttpRequestLifecycle$Plugin$install$slambda(this.w5b_1, completion11);
        i11.x5b_1 = $this$intercept11;
        i11.y5b_1 = it11;
        return i11;
    };
    function HttpRequestLifecycle$Plugin$install$slambda_0($scope11, resultContinuation11) {
        var i11 = new HttpRequestLifecycle$Plugin$install$slambda($scope11, resultContinuation11);
        var l11 = function($this$intercept11, it11, $completion11) {
            return i11.h4s($this$intercept11, it11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function Plugin_2() {
        Plugin_instance_2 = this;
        this.b5c_1 = new AttributeKey("RequestLifecycle");
    }
    protoOf(Plugin_2).a1 = function() {
        return this.b5c_1;
    };
    protoOf(Plugin_2).s50 = function(block11) {
        return new HttpRequestLifecycle();
    };
    protoOf(Plugin_2).r4u = function(block11) {
        return this.s50(block11);
    };
    protoOf(Plugin_2).c5c = function(plugin11, scope11) {
        var tmp11 = Phases_getInstance().j50_1;
        scope11.n4r_1.s46(tmp11, HttpRequestLifecycle$Plugin$install$slambda_0(scope11, null));
    };
    protoOf(Plugin_2).s4u = function(plugin11, scope11) {
        return this.c5c(plugin11 instanceof HttpRequestLifecycle ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance_2;
    function Plugin_getInstance_2() {
        if (Plugin_instance_2 == null) new Plugin_2();
        return Plugin_instance_2;
    }
    function HttpRequestLifecycle() {
        Plugin_getInstance_2();
    }
    function attachToClientEngineJob(requestJob11, clientEngineJob11) {
        _init_properties_HttpRequestLifecycle_kt__jgkmfx();
        var handler11 = clientEngineJob11.w1n(attachToClientEngineJob$lambda(requestJob11));
        requestJob11.w1n(attachToClientEngineJob$lambda_0(handler11));
    }
    function attachToClientEngineJob$lambda($requestJob11) {
        return function(cause11) {
            var tmp11;
            if (!(cause11 == null)) {
                get_LOGGER_4().k47("Cancelling request because engine Job failed with error: " + toString_0(cause11));
                cancel_2($requestJob11, "Engine failed", cause11);
                tmp11 = Unit_instance;
            } else {
                get_LOGGER_4().k47("Cancelling request because engine Job completed");
                $requestJob11.s1s();
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function attachToClientEngineJob$lambda_0($handler11) {
        return function(it11) {
            $handler11.y1p();
            return Unit_instance;
        };
    }
    var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
    function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
        if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
            properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
            LOGGER_4 = KtorSimpleLogger("io.ktor.client.plugins.HttpRequestLifecycle");
        }
    }
    function HttpSend$Plugin$install$slambda($plugin11, $scope11, resultContinuation11) {
        this.l5c_1 = $plugin11;
        this.m5c_1 = $scope11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpSend$Plugin$install$slambda).h4s = function($this$intercept11, content11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, content11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpSend$Plugin$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpSend$Plugin$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 3;
                    var tmp_011 = this.o5c_1;
                    if (!(tmp_011 instanceof OutgoingContent)) {
                        var message11 = trimMargin("\n|Fail to prepare request body for sending. \n|The body type is: " + toString(getKClassFromExpression(this.o5c_1)) + ", with Content-Type: " + toString_0(contentType(this.n5c_1.o46_1)) + ".\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.");
                        throw IllegalStateException_init_$Create$(toString(message11));
                    }
                    var this_011 = this.n5c_1.o46_1;
                    var body11 = this.o5c_1;
                    if (body11 == null) {
                        this_011.p4t_1 = NullBody_instance;
                        var tmp_141 = JsType_instance;
                        var tmp_211 = getKClass(OutgoingContent);
                        var tmp_311;
                        try {
                            tmp_311 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                        } catch ($p11) {
                            var tmp_411;
                            if ($p11 instanceof Error) {
                                var cause11 = $p11;
                                tmp_411 = null;
                            } else throw $p11;
                            tmp_311 = tmp_411;
                        }
                        this_011.k4z(typeInfoImpl(tmp_141, tmp_211, tmp_311));
                    } else if (body11 instanceof OutgoingContent) {
                        this_011.p4t_1 = body11;
                        this_011.k4z(null);
                    } else {
                        this_011.p4t_1 = body11;
                        var tmp_511 = JsType_instance;
                        var tmp_611 = getKClass(OutgoingContent);
                        var tmp_711;
                        try {
                            tmp_711 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                        } catch ($p11) {
                            var tmp_811;
                            if ($p11 instanceof Error) {
                                var cause_011 = $p11;
                                tmp_811 = null;
                            } else throw $p11;
                            tmp_711 = tmp_811;
                        }
                        this_011.k4z(typeInfoImpl(tmp_511, tmp_611, tmp_711));
                    }
                    this.p5c_1 = new DefaultSender(this.l5c_1.c58_1, this.m5c_1);
                    this.q5c_1 = this.p5c_1;
                    var tmp0_iterator11 = downTo(get_lastIndex(this.l5c_1.d58_1), 0).j();
                    while(tmp0_iterator11.k()){
                        var element11 = tmp0_iterator11.l();
                        var interceptor11 = this.l5c_1.d58_1.o(element11);
                        this.q5c_1 = new InterceptedSender(interceptor11, this.q5c_1);
                    }
                    this.v8_1 = 1;
                    suspendResult11 = this.q5c_1.v56(this.n5c_1.o46_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.r5c_1 = suspendResult11;
                    this.v8_1 = 2;
                    suspendResult11 = this.n5c_1.s45(this.r5c_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 3) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpSend$Plugin$install$slambda).i4s = function($this$intercept11, content11, completion11) {
        var i11 = new HttpSend$Plugin$install$slambda(this.l5c_1, this.m5c_1, completion11);
        i11.n5c_1 = $this$intercept11;
        i11.o5c_1 = content11;
        return i11;
    };
    function HttpSend$Plugin$install$slambda_0($plugin11, $scope11, resultContinuation11) {
        var i11 = new HttpSend$Plugin$install$slambda($plugin11, $scope11, resultContinuation11);
        var l11 = function($this$intercept11, content11, $completion11) {
            return i11.h4s($this$intercept11, content11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function $executeCOROUTINE$8(_this__u8e3s411, requestBuilder11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.a5d_1 = _this__u8e3s411;
        this.b5d_1 = requestBuilder11;
    }
    protoOf($executeCOROUTINE$8).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    var tmp0_safe_receiver11 = this.a5d_1.f5d_1;
                    if (tmp0_safe_receiver11 == null) ;
                    else cancel(tmp0_safe_receiver11);
                    if (this.a5d_1.e5d_1 >= this.a5d_1.c5d_1) throw new SendCountExceedException("Max send count " + this.a5d_1.c5d_1 + " exceeded. Consider increasing the property " + "maxSendCount if more is required.");
                    var tmp1_this11 = this.a5d_1;
                    tmp1_this11.e5d_1 = tmp1_this11.e5d_1 + 1 | 0;
                    this.v8_1 = 1;
                    suspendResult11 = this.a5d_1.d5d_1.p4r_1.n46(this.b5d_1, this.b5d_1.p4t_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    var sendResult11 = suspendResult11;
                    var tmp3_elvis_lhs11 = sendResult11 instanceof HttpClientCall ? sendResult11 : null;
                    var tmp_011;
                    if (tmp3_elvis_lhs11 == null) {
                        var message11 = "Failed to execute send pipeline. Expected [HttpClientCall], but received " + toString(sendResult11);
                        throw IllegalStateException_init_$Create$(toString(message11));
                    } else tmp_011 = tmp3_elvis_lhs11;
                    var call11 = tmp_011;
                    this.a5d_1.f5d_1 = call11;
                    return call11;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function Config_2() {
        this.g5d_1 = 20;
    }
    function Plugin_3() {
        Plugin_instance_3 = this;
        this.h5d_1 = new AttributeKey("HttpSend");
    }
    protoOf(Plugin_3).a1 = function() {
        return this.h5d_1;
    };
    protoOf(Plugin_3).i5d = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new Config_2();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        return new HttpSend(config11.g5d_1);
    };
    protoOf(Plugin_3).r4u = function(block11) {
        return this.i5d(block11);
    };
    protoOf(Plugin_3).j5d = function(plugin11, scope11) {
        var tmp11 = Phases_getInstance().n50_1;
        scope11.n4r_1.s46(tmp11, HttpSend$Plugin$install$slambda_0(plugin11, scope11, null));
    };
    protoOf(Plugin_3).s4u = function(plugin11, scope11) {
        return this.j5d(plugin11 instanceof HttpSend ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance_3;
    function Plugin_getInstance_3() {
        if (Plugin_instance_3 == null) new Plugin_3();
        return Plugin_instance_3;
    }
    function InterceptedSender(interceptor11, nextSender11) {
        this.k5d_1 = interceptor11;
        this.l5d_1 = nextSender11;
    }
    protoOf(InterceptedSender).v56 = function(requestBuilder11, $completion11) {
        return this.k5d_1(this.l5d_1, requestBuilder11, $completion11);
    };
    function DefaultSender(maxSendCount11, client11) {
        this.c5d_1 = maxSendCount11;
        this.d5d_1 = client11;
        this.e5d_1 = 0;
        this.f5d_1 = null;
    }
    protoOf(DefaultSender).v56 = function(requestBuilder11, $completion11) {
        var tmp11 = new $executeCOROUTINE$8(this, requestBuilder11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    function HttpSend(maxSendCount11) {
        Plugin_getInstance_3();
        maxSendCount11 = maxSendCount11 === VOID ? 20 : maxSendCount11;
        this.c58_1 = maxSendCount11;
        var tmp11 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp11.d58_1 = ArrayList_init_$Create$();
    }
    protoOf(HttpSend).e58 = function(block11) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.d58_1.e(block11);
    };
    function Sender() {}
    function SendCountExceedException(message11) {
        IllegalStateException_init_$Init$_0(message11, this);
        captureStack(this, SendCountExceedException);
    }
    function get_LOGGER_5() {
        _init_properties_HttpTimeout_kt__pucqrr();
        return LOGGER_5;
    }
    var LOGGER_5;
    function HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis11, connectTimeoutMillis11, socketTimeoutMillis11, $this11) {
        requestTimeoutMillis11 = requestTimeoutMillis11 === VOID ? null : requestTimeoutMillis11;
        connectTimeoutMillis11 = connectTimeoutMillis11 === VOID ? null : connectTimeoutMillis11;
        socketTimeoutMillis11 = socketTimeoutMillis11 === VOID ? null : socketTimeoutMillis11;
        HttpTimeoutCapabilityConfiguration.call($this11);
        $this11.p5d(requestTimeoutMillis11);
        $this11.q5d(connectTimeoutMillis11);
        $this11.r5d(socketTimeoutMillis11);
        return $this11;
    }
    function HttpTimeoutCapabilityConfiguration_init_$Create$(requestTimeoutMillis11, connectTimeoutMillis11, socketTimeoutMillis11) {
        return HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis11, connectTimeoutMillis11, socketTimeoutMillis11, objectCreate(protoOf(HttpTimeoutCapabilityConfiguration)));
    }
    function checkTimeoutValue($this11, value11) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(value11 == null || value11.j1(new Long(0, 0)) > 0)) {
            // Inline function 'io.ktor.client.plugins.HttpTimeoutCapabilityConfiguration.checkTimeoutValue.<anonymous>' call
            var message11 = "Only positive timeout values are allowed, for infinite timeout use HttpTimeout.INFINITE_TIMEOUT_MS";
            throw IllegalArgumentException_init_$Create$(toString(message11));
        }
        return value11;
    }
    function Companion_2() {
        Companion_instance_3 = this;
        this.s5d_1 = new AttributeKey("TimeoutConfiguration");
    }
    var Companion_instance_3;
    function Companion_getInstance_9() {
        if (Companion_instance_3 == null) new Companion_2();
        return Companion_instance_3;
    }
    function HttpTimeout$Plugin$install$slambda$slambda($requestTimeout11, $request11, $executionContext11, resultContinuation11) {
        this.b5e_1 = $requestTimeout11;
        this.c5e_1 = $request11;
        this.d5e_1 = $executionContext11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpTimeout$Plugin$install$slambda$slambda).j3u = function($this$launch11, $completion11) {
        var tmp11 = this.e2b($this$launch11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpTimeout$Plugin$install$slambda$slambda).y9 = function(p111, $completion11) {
        return this.j3u((!(p111 == null) ? isInterface(p111, CoroutineScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(HttpTimeout$Plugin$install$slambda$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = delay(this.b5e_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    var cause11 = HttpRequestTimeoutException_init_$Create$(this.c5e_1);
                    get_LOGGER_5().k47("Request timeout: " + this.c5e_1.m4t_1.toString());
                    cancel_2(this.d5e_1, ensureNotNull(cause11.message), cause11);
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpTimeout$Plugin$install$slambda$slambda).e2b = function($this$launch11, completion11) {
        var i11 = new HttpTimeout$Plugin$install$slambda$slambda(this.b5e_1, this.c5e_1, this.d5e_1, completion11);
        i11.e5e_1 = $this$launch11;
        return i11;
    };
    function HttpTimeout$Plugin$install$slambda$slambda_0($requestTimeout11, $request11, $executionContext11, resultContinuation11) {
        var i11 = new HttpTimeout$Plugin$install$slambda$slambda($requestTimeout11, $request11, $executionContext11, resultContinuation11);
        var l11 = function($this$launch11, $completion11) {
            return i11.j3u($this$launch11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function HttpTimeout$Plugin$install$slambda$lambda($killer11) {
        return function(it11) {
            $killer11.c1o();
            return Unit_instance;
        };
    }
    function HttpTimeout$Plugin$install$slambda($plugin11, $scope11, resultContinuation11) {
        this.n5e_1 = $plugin11;
        this.o5e_1 = $scope11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpTimeout$Plugin$install$slambda).t56 = function($this$intercept11, request11, $completion11) {
        var tmp11 = this.u56($this$intercept11, request11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpTimeout$Plugin$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = (!(p111 == null) ? isInterface(p111, Sender) : false) ? p111 : THROW_CCE();
        return this.t56(tmp11, p211 instanceof HttpRequestBuilder ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(HttpTimeout$Plugin$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    this.r5e_1 = isWebsocket(this.q5e_1.m4t_1.n4g_1);
                    var tmp_011;
                    if (this.r5e_1) tmp_011 = true;
                    else {
                        var tmp_141 = this.q5e_1.p4t_1;
                        tmp_011 = tmp_141 instanceof ClientUpgradeContent;
                    }
                    if (tmp_011) {
                        this.v8_1 = 3;
                        suspendResult11 = this.p5e_1.v56(this.q5e_1, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        this.v8_1 = 1;
                        continue $sm;
                    }
                case 1:
                    this.s5e_1 = this.q5e_1.t5e(Plugin_getInstance_4());
                    if (this.s5e_1 == null && hasNotNullTimeouts(this.n5e_1)) {
                        this.s5e_1 = HttpTimeoutCapabilityConfiguration_init_$Create$();
                        this.q5e_1.u5e(Plugin_getInstance_4(), this.s5e_1);
                    }
                    var tmp0_safe_receiver11 = this.s5e_1;
                    if (tmp0_safe_receiver11 == null) ;
                    else l$ret$1: {
                        var tmp0_elvis_lhs11 = tmp0_safe_receiver11.v5e();
                        tmp0_safe_receiver11.q5d(tmp0_elvis_lhs11 == null ? this.n5e_1.x5e_1 : tmp0_elvis_lhs11);
                        var tmp1_elvis_lhs11 = tmp0_safe_receiver11.z5e();
                        tmp0_safe_receiver11.r5d(tmp1_elvis_lhs11 == null ? this.n5e_1.y5e_1 : tmp1_elvis_lhs11);
                        var tmp2_elvis_lhs11 = tmp0_safe_receiver11.a5f();
                        tmp0_safe_receiver11.p5d(tmp2_elvis_lhs11 == null ? this.n5e_1.w5e_1 : tmp2_elvis_lhs11);
                        var tmp3_elvis_lhs11 = tmp0_safe_receiver11.a5f();
                        var requestTimeout11 = tmp3_elvis_lhs11 == null ? this.n5e_1.w5e_1 : tmp3_elvis_lhs11;
                        if (requestTimeout11 == null || equals(requestTimeout11, new Long(-1, 2147483647))) break l$ret$1;
                        var executionContext11 = this.q5e_1.q4t_1;
                        var killer11 = launch(this.o5e_1, VOID, VOID, HttpTimeout$Plugin$install$slambda$slambda_0(requestTimeout11, this.q5e_1, executionContext11, null));
                        var tmp_211 = this.q5e_1.q4t_1;
                        tmp_211.w1n(HttpTimeout$Plugin$install$slambda$lambda(killer11));
                    }
                    this.v8_1 = 2;
                    suspendResult11 = this.p5e_1.v56(this.q5e_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    return suspendResult11;
                case 3:
                    return suspendResult11;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpTimeout$Plugin$install$slambda).u56 = function($this$intercept11, request11, completion11) {
        var i11 = new HttpTimeout$Plugin$install$slambda(this.n5e_1, this.o5e_1, completion11);
        i11.p5e_1 = $this$intercept11;
        i11.q5e_1 = request11;
        return i11;
    };
    function HttpTimeout$Plugin$install$slambda_0($plugin11, $scope11, resultContinuation11) {
        var i11 = new HttpTimeout$Plugin$install$slambda($plugin11, $scope11, resultContinuation11);
        var l11 = function($this$intercept11, request11, $completion11) {
            return i11.t56($this$intercept11, request11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    protoOf(HttpTimeoutCapabilityConfiguration).p5d = function(value11) {
        this.m5d_1 = checkTimeoutValue(this, value11);
    };
    protoOf(HttpTimeoutCapabilityConfiguration).a5f = function() {
        return this.m5d_1;
    };
    protoOf(HttpTimeoutCapabilityConfiguration).q5d = function(value11) {
        this.n5d_1 = checkTimeoutValue(this, value11);
    };
    protoOf(HttpTimeoutCapabilityConfiguration).v5e = function() {
        return this.n5d_1;
    };
    protoOf(HttpTimeoutCapabilityConfiguration).r5d = function(value11) {
        this.o5d_1 = checkTimeoutValue(this, value11);
    };
    protoOf(HttpTimeoutCapabilityConfiguration).z5e = function() {
        return this.o5d_1;
    };
    protoOf(HttpTimeoutCapabilityConfiguration).b5f = function() {
        return new HttpTimeout(this.a5f(), this.v5e(), this.z5e());
    };
    protoOf(HttpTimeoutCapabilityConfiguration).equals = function(other11) {
        if (this === other11) return true;
        if (other11 == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other11))) return false;
        if (!(other11 instanceof HttpTimeoutCapabilityConfiguration)) THROW_CCE();
        if (!equals(this.m5d_1, other11.m5d_1)) return false;
        if (!equals(this.n5d_1, other11.n5d_1)) return false;
        if (!equals(this.o5d_1, other11.o5d_1)) return false;
        return true;
    };
    protoOf(HttpTimeoutCapabilityConfiguration).hashCode = function() {
        var tmp0_safe_receiver11 = this.m5d_1;
        var tmp1_elvis_lhs11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.hashCode();
        var result11 = tmp1_elvis_lhs11 == null ? 0 : tmp1_elvis_lhs11;
        var tmp11 = imul(31, result11);
        var tmp2_safe_receiver11 = this.n5d_1;
        var tmp3_elvis_lhs11 = tmp2_safe_receiver11 == null ? null : tmp2_safe_receiver11.hashCode();
        result11 = tmp11 + (tmp3_elvis_lhs11 == null ? 0 : tmp3_elvis_lhs11) | 0;
        var tmp_011 = imul(31, result11);
        var tmp4_safe_receiver11 = this.o5d_1;
        var tmp5_elvis_lhs11 = tmp4_safe_receiver11 == null ? null : tmp4_safe_receiver11.hashCode();
        result11 = tmp_011 + (tmp5_elvis_lhs11 == null ? 0 : tmp5_elvis_lhs11) | 0;
        return result11;
    };
    function HttpTimeoutCapabilityConfiguration() {
        Companion_getInstance_9();
        this.m5d_1 = new Long(0, 0);
        this.n5d_1 = new Long(0, 0);
        this.o5d_1 = new Long(0, 0);
    }
    function hasNotNullTimeouts($this11) {
        return !($this11.w5e_1 == null) || !($this11.x5e_1 == null) || !($this11.y5e_1 == null);
    }
    function Plugin_4() {
        Plugin_instance_4 = this;
        this.c5f_1 = new AttributeKey("TimeoutPlugin");
        this.d5f_1 = new Long(-1, 2147483647);
    }
    protoOf(Plugin_4).a1 = function() {
        return this.c5f_1;
    };
    protoOf(Plugin_4).e5f = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = HttpTimeoutCapabilityConfiguration_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        return this_011.b5f();
    };
    protoOf(Plugin_4).r4u = function(block11) {
        return this.e5f(block11);
    };
    protoOf(Plugin_4).f5f = function(plugin_011, scope11) {
        var tmp11 = plugin(scope11, Plugin_getInstance_3());
        tmp11.e58(HttpTimeout$Plugin$install$slambda_0(plugin_011, scope11, null));
    };
    protoOf(Plugin_4).s4u = function(plugin11, scope11) {
        return this.f5f(plugin11 instanceof HttpTimeout ? plugin11 : THROW_CCE(), scope11);
    };
    var Plugin_instance_4;
    function Plugin_getInstance_4() {
        if (Plugin_instance_4 == null) new Plugin_4();
        return Plugin_instance_4;
    }
    function HttpTimeout(requestTimeoutMillis11, connectTimeoutMillis11, socketTimeoutMillis11) {
        Plugin_getInstance_4();
        this.w5e_1 = requestTimeoutMillis11;
        this.x5e_1 = connectTimeoutMillis11;
        this.y5e_1 = socketTimeoutMillis11;
    }
    function HttpRequestTimeoutException_init_$Init$(request11, $this11) {
        var tmp11 = request11.m4t_1.d4i();
        var tmp0_safe_receiver11 = request11.t5e(Plugin_getInstance_4());
        HttpRequestTimeoutException.call($this11, tmp11, tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.a5f());
        return $this11;
    }
    function HttpRequestTimeoutException_init_$Create$(request11) {
        var tmp11 = HttpRequestTimeoutException_init_$Init$(request11, objectCreate(protoOf(HttpRequestTimeoutException)));
        captureStack(tmp11, HttpRequestTimeoutException_init_$Create$);
        return tmp11;
    }
    function HttpRequestTimeoutException(url11, timeoutMillis11) {
        IOException_init_$Init$("Request timeout has expired [url=" + url11 + ", request_timeout=" + toString(timeoutMillis11 == null ? "unknown" : timeoutMillis11) + " ms]", this);
        captureStack(this, HttpRequestTimeoutException);
    }
    var properties_initialized_HttpTimeout_kt_9oyjbd;
    function _init_properties_HttpTimeout_kt__pucqrr() {
        if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
            properties_initialized_HttpTimeout_kt_9oyjbd = true;
            LOGGER_5 = KtorSimpleLogger("io.ktor.client.plugins.HttpTimeout");
        }
    }
    function HookHandler(hook11, handler11) {
        this.g5f_1 = hook11;
        this.h5f_1 = handler11;
    }
    protoOf(HookHandler).b4u = function(client11) {
        this.g5f_1.i5f(client11, this.h5f_1);
    };
    function ClientPluginBuilder$onClose$lambda() {
        return Unit_instance;
    }
    function ClientPluginBuilder(key11, client11, pluginConfig11) {
        this.j5f_1 = key11;
        this.k5f_1 = client11;
        this.l5f_1 = pluginConfig11;
        var tmp11 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp11.m5f_1 = ArrayList_init_$Create$();
        var tmp_011 = this;
        tmp_011.n5f_1 = ClientPluginBuilder$onClose$lambda;
    }
    protoOf(ClientPluginBuilder).o5f = function(block11) {
        this.p5f(RequestHook_instance, block11);
    };
    protoOf(ClientPluginBuilder).p5f = function(hook11, handler11) {
        this.m5f_1.e(new HookHandler(hook11, handler11));
    };
    function ClientPluginInstance$onClose$lambda() {
        return Unit_instance;
    }
    function ClientPluginInstance(config11, name11, body11) {
        this.q5f_1 = config11;
        this.r5f_1 = name11;
        this.s5f_1 = body11;
        var tmp11 = this;
        tmp11.t5f_1 = ClientPluginInstance$onClose$lambda;
    }
    protoOf(ClientPluginInstance).b4u = function(scope11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new ClientPluginBuilder(new AttributeKey(this.r5f_1), scope11, this.q5f_1);
        // Inline function 'kotlin.contracts.contract' call
        this.s5f_1(this_011);
        var pluginBuilder11 = this_011;
        this.t5f_1 = pluginBuilder11.n5f_1;
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator11 = pluginBuilder11.m5f_1.j();
        while(tmp0_iterator11.k()){
            var element11 = tmp0_iterator11.l();
            // Inline function 'io.ktor.client.plugins.api.ClientPluginInstance.install.<anonymous>' call
            element11.b4u(scope11);
        }
    };
    function createClientPlugin(name11, createConfiguration11, body11) {
        return new createClientPlugin$1(name11, createConfiguration11, body11);
    }
    function createClientPlugin$1($name11, $createConfiguration11, $body11) {
        this.v5f_1 = $name11;
        this.w5f_1 = $createConfiguration11;
        this.x5f_1 = $body11;
        this.u5f_1 = new AttributeKey($name11);
    }
    protoOf(createClientPlugin$1).a1 = function() {
        return this.u5f_1;
    };
    protoOf(createClientPlugin$1).y5f = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = this.w5f_1();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        var config11 = this_011;
        return new ClientPluginInstance(config11, this.v5f_1, this.x5f_1);
    };
    protoOf(createClientPlugin$1).r4u = function(block11) {
        return this.y5f(block11);
    };
    protoOf(createClientPlugin$1).z5f = function(plugin11, scope11) {
        plugin11.b4u(scope11);
    };
    protoOf(createClientPlugin$1).s4u = function(plugin11, scope11) {
        return this.z5f(plugin11 instanceof ClientPluginInstance ? plugin11 : THROW_CCE(), scope11);
    };
    function OnRequestContext() {}
    function RequestHook$install$slambda($handler11, resultContinuation11) {
        this.i5g_1 = $handler11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(RequestHook$install$slambda).h4s = function($this$intercept11, it11, $completion11) {
        var tmp11 = this.i4s($this$intercept11, it11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(RequestHook$install$slambda).hj = function(p111, p211, $completion11) {
        var tmp11 = p111 instanceof PipelineContext ? p111 : THROW_CCE();
        return this.h4s(tmp11, !(p211 == null) ? p211 : THROW_CCE(), $completion11);
    };
    protoOf(RequestHook$install$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = this.i5g_1(new OnRequestContext(), this.j5g_1.o46_1, this.j5g_1.r45(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(RequestHook$install$slambda).i4s = function($this$intercept11, it11, completion11) {
        var i11 = new RequestHook$install$slambda(this.i5g_1, completion11);
        i11.j5g_1 = $this$intercept11;
        i11.k5g_1 = it11;
        return i11;
    };
    function RequestHook$install$slambda_0($handler11, resultContinuation11) {
        var i11 = new RequestHook$install$slambda($handler11, resultContinuation11);
        var l11 = function($this$intercept11, it11, $completion11) {
            return i11.h4s($this$intercept11, it11, $completion11);
        };
        l11.$arity = 2;
        return l11;
    }
    function RequestHook() {}
    protoOf(RequestHook).l5g = function(client11, handler11) {
        var tmp11 = Phases_getInstance().k50_1;
        client11.n4r_1.s46(tmp11, RequestHook$install$slambda_0(handler11, null));
    };
    protoOf(RequestHook).i5f = function(client11, handler11) {
        return this.l5g(client11, (!(handler11 == null) ? isSuspendFunction(handler11, 3) : false) ? handler11 : THROW_CCE());
    };
    var RequestHook_instance;
    function RequestHook_getInstance() {
        return RequestHook_instance;
    }
    function wrapWithContent(_this__u8e3s411, content11) {
        return new DelegatedCall(_this__u8e3s411.j4s_1, content11, _this__u8e3s411);
    }
    function DelegatedCall(client11, content11, originCall11) {
        HttpClientCall.call(this, client11);
        this.l4s_1 = new DelegatedRequest(this, originCall11.w4v());
        this.m4s_1 = new DelegatedResponse(this, content11, originCall11.j31());
    }
    function DelegatedRequest(call11, origin11) {
        this.m5g_1 = call11;
        this.n5g_1 = origin11;
    }
    protoOf(DelegatedRequest).t4w = function() {
        return this.m5g_1;
    };
    protoOf(DelegatedRequest).b4v = function() {
        return this.n5g_1.b4v();
    };
    protoOf(DelegatedRequest).v1m = function() {
        return this.n5g_1.v1m();
    };
    protoOf(DelegatedRequest).m4d = function() {
        return this.n5g_1.m4d();
    };
    protoOf(DelegatedRequest).u4w = function() {
        return this.n5g_1.u4w();
    };
    protoOf(DelegatedRequest).y3h = function() {
        return this.n5g_1.y3h();
    };
    function DelegatedResponse(call11, content11, origin11) {
        HttpResponse.call(this);
        this.o5g_1 = call11;
        this.p5g_1 = content11;
        this.q5g_1 = origin11;
        this.r5g_1 = this.q5g_1.v1m();
    }
    protoOf(DelegatedResponse).t4w = function() {
        return this.o5g_1;
    };
    protoOf(DelegatedResponse).e1b = function() {
        return this.p5g_1;
    };
    protoOf(DelegatedResponse).v1m = function() {
        return this.r5g_1;
    };
    protoOf(DelegatedResponse).y4v = function() {
        return this.q5g_1.y4v();
    };
    protoOf(DelegatedResponse).e4x = function() {
        return this.q5g_1.e4x();
    };
    protoOf(DelegatedResponse).f4x = function() {
        return this.q5g_1.f4x();
    };
    protoOf(DelegatedResponse).g4x = function() {
        return this.q5g_1.g4x();
    };
    protoOf(DelegatedResponse).m4d = function() {
        return this.q5g_1.m4d();
    };
    function WebSocketCapability() {}
    protoOf(WebSocketCapability).toString = function() {
        return "WebSocketCapability";
    };
    var WebSocketCapability_instance;
    function WebSocketCapability_getInstance() {
        return WebSocketCapability_instance;
    }
    function WebSocketException_init_$Init$(message11, $this11) {
        WebSocketException.call($this11, message11, null);
        return $this11;
    }
    function WebSocketException_init_$Create$(message11) {
        var tmp11 = WebSocketException_init_$Init$(message11, objectCreate(protoOf(WebSocketException)));
        captureStack(tmp11, WebSocketException_init_$Create$);
        return tmp11;
    }
    function WebSocketException(message11, cause11) {
        IllegalStateException_init_$Init$_1(message11, cause11, this);
        captureStack(this, WebSocketException);
    }
    function ClientUpgradeContent() {}
    function DefaultHttpRequest(call11, data11) {
        this.s5g_1 = call11;
        this.t5g_1 = data11.l4y_1;
        this.u5g_1 = data11.k4y_1;
        this.v5g_1 = data11.n4y_1;
        this.w5g_1 = data11.m4y_1;
        this.x5g_1 = data11.p4y_1;
    }
    protoOf(DefaultHttpRequest).t4w = function() {
        return this.s5g_1;
    };
    protoOf(DefaultHttpRequest).v1m = function() {
        return this.t4w().v1m();
    };
    protoOf(DefaultHttpRequest).u4w = function() {
        return this.t5g_1;
    };
    protoOf(DefaultHttpRequest).y3h = function() {
        return this.u5g_1;
    };
    protoOf(DefaultHttpRequest).m4d = function() {
        return this.w5g_1;
    };
    protoOf(DefaultHttpRequest).b4v = function() {
        return this.x5g_1;
    };
    function HttpRequest_0() {}
    function Companion_3() {}
    var Companion_instance_4;
    function Companion_getInstance_10() {
        return Companion_instance_4;
    }
    function HttpRequestBuilder$setCapability$lambda() {
        // Inline function 'kotlin.collections.mutableMapOf' call
        return LinkedHashMap_init_$Create$();
    }
    function HttpRequestBuilder() {
        this.m4t_1 = new URLBuilder();
        this.n4t_1 = Companion_getInstance_0().n4d_1;
        this.o4t_1 = new HeadersBuilder();
        this.p4t_1 = EmptyContent_getInstance();
        this.q4t_1 = SupervisorJob();
        this.r4t_1 = AttributesJsFn(true);
    }
    protoOf(HttpRequestBuilder).m4d = function() {
        return this.o4t_1;
    };
    protoOf(HttpRequestBuilder).k4z = function(value11) {
        if (!(value11 == null)) this.r4t_1.v41(get_BodyTypeAttributeKey(), value11);
        else this.r4t_1.w41(get_BodyTypeAttributeKey());
    };
    protoOf(HttpRequestBuilder).y5g = function() {
        return this.r4t_1.t41(get_BodyTypeAttributeKey());
    };
    protoOf(HttpRequestBuilder).c3r = function() {
        var tmp11 = this.m4t_1.c3r();
        var tmp_011 = this.n4t_1;
        var tmp_141 = this.o4t_1.c3r();
        var tmp_211 = this.p4t_1;
        var tmp0_elvis_lhs11 = tmp_211 instanceof OutgoingContent ? tmp_211 : null;
        var tmp_311;
        if (tmp0_elvis_lhs11 == null) {
            var message11 = "No request transformation found: " + toString(this.p4t_1);
            throw IllegalStateException_init_$Create$(toString(message11));
        } else tmp_311 = tmp0_elvis_lhs11;
        return new HttpRequestData(tmp11, tmp_011, tmp_141, tmp_311, this.q4t_1, this.r4t_1);
    };
    protoOf(HttpRequestBuilder).j4z = function(builder11) {
        this.q4t_1 = builder11.q4t_1;
        return this.z5g(builder11);
    };
    protoOf(HttpRequestBuilder).z5g = function(builder11) {
        this.n4t_1 = builder11.n4t_1;
        this.p4t_1 = builder11.p4t_1;
        this.k4z(builder11.y5g());
        takeFrom_0(this.m4t_1, builder11.m4t_1);
        this.m4t_1.u4g_1 = this.m4t_1.u4g_1;
        appendAll(this.o4t_1, builder11.o4t_1);
        putAll(this.r4t_1, builder11.r4t_1);
        return this;
    };
    protoOf(HttpRequestBuilder).u5e = function(key11, capability11) {
        var tmp11 = get_ENGINE_CAPABILITIES_KEY();
        var capabilities11 = this.r4t_1.x41(tmp11, HttpRequestBuilder$setCapability$lambda);
        // Inline function 'kotlin.collections.set' call
        capabilities11.m2(key11, capability11);
    };
    protoOf(HttpRequestBuilder).t5e = function(key11) {
        var tmp0_safe_receiver11 = this.r4t_1.t41(get_ENGINE_CAPABILITIES_KEY());
        var tmp11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.e2(key11);
        return (tmp11 == null ? true : !(tmp11 == null)) ? tmp11 : THROW_CCE();
    };
    function HttpRequestData(url11, method11, headers11, body11, executionContext11, attributes11) {
        this.k4y_1 = url11;
        this.l4y_1 = method11;
        this.m4y_1 = headers11;
        this.n4y_1 = body11;
        this.o4y_1 = executionContext11;
        this.p4y_1 = attributes11;
        var tmp11 = this;
        var tmp0_safe_receiver11 = this.p4y_1.t41(get_ENGINE_CAPABILITIES_KEY());
        var tmp1_elvis_lhs11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.f2();
        tmp11.q4y_1 = tmp1_elvis_lhs11 == null ? emptySet() : tmp1_elvis_lhs11;
    }
    protoOf(HttpRequestData).toString = function() {
        return "HttpRequestData(url=" + this.k4y_1.toString() + ", method=" + this.l4y_1.toString() + ")";
    };
    function HttpResponseData(statusCode11, requestTime11, headers11, version11, body11, callContext11) {
        this.u4u_1 = statusCode11;
        this.v4u_1 = requestTime11;
        this.w4u_1 = headers11;
        this.x4u_1 = version11;
        this.y4u_1 = body11;
        this.z4u_1 = callContext11;
        this.a4v_1 = GMTDate();
    }
    protoOf(HttpResponseData).toString = function() {
        return "HttpResponseData=(statusCode=" + this.u4u_1.toString() + ")";
    };
    function url(_this__u8e3s411, urlString11) {
        takeFrom(_this__u8e3s411.m4t_1, urlString11);
    }
    function isUpgradeRequest(_this__u8e3s411) {
        var tmp11 = _this__u8e3s411.n4y_1;
        return tmp11 instanceof ClientUpgradeContent;
    }
    function Phases() {
        Phases_instance = this;
        this.j50_1 = new PipelinePhase("Before");
        this.k50_1 = new PipelinePhase("State");
        this.l50_1 = new PipelinePhase("Transform");
        this.m50_1 = new PipelinePhase("Render");
        this.n50_1 = new PipelinePhase("Send");
    }
    var Phases_instance;
    function Phases_getInstance() {
        if (Phases_instance == null) new Phases();
        return Phases_instance;
    }
    function HttpRequestPipeline(developmentMode11) {
        Phases_getInstance();
        developmentMode11 = developmentMode11 === VOID ? false : developmentMode11;
        Pipeline.call(this, [
            Phases_getInstance().j50_1,
            Phases_getInstance().k50_1,
            Phases_getInstance().l50_1,
            Phases_getInstance().m50_1,
            Phases_getInstance().n50_1
        ]);
        this.h5h_1 = developmentMode11;
    }
    protoOf(HttpRequestPipeline).m46 = function() {
        return this.h5h_1;
    };
    function Phases_0() {
        Phases_instance_0 = this;
        this.c4u_1 = new PipelinePhase("Before");
        this.d4u_1 = new PipelinePhase("State");
        this.e4u_1 = new PipelinePhase("Monitoring");
        this.f4u_1 = new PipelinePhase("Engine");
        this.g4u_1 = new PipelinePhase("Receive");
    }
    var Phases_instance_0;
    function Phases_getInstance_0() {
        if (Phases_instance_0 == null) new Phases_0();
        return Phases_instance_0;
    }
    function HttpSendPipeline(developmentMode11) {
        Phases_getInstance_0();
        developmentMode11 = developmentMode11 === VOID ? false : developmentMode11;
        Pipeline.call(this, [
            Phases_getInstance_0().c4u_1,
            Phases_getInstance_0().d4u_1,
            Phases_getInstance_0().e4u_1,
            Phases_getInstance_0().f4u_1,
            Phases_getInstance_0().g4u_1
        ]);
        this.p5h_1 = developmentMode11;
    }
    protoOf(HttpSendPipeline).m46 = function() {
        return this.p5h_1;
    };
    function get_BodyTypeAttributeKey() {
        _init_properties_RequestBody_kt__bo3lwf();
        return BodyTypeAttributeKey;
    }
    var BodyTypeAttributeKey;
    var properties_initialized_RequestBody_kt_agyv1b;
    function _init_properties_RequestBody_kt__bo3lwf() {
        if (!properties_initialized_RequestBody_kt_agyv1b) {
            properties_initialized_RequestBody_kt_agyv1b = true;
            BodyTypeAttributeKey = new AttributeKey("BodyTypeAttributeKey");
        }
    }
    function FormDataContent(formData11) {
        ByteArrayContent.call(this);
        this.r5h_1 = formData11;
        var tmp11 = this;
        var tmp$ret$011;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.toByteArray' call
            var this_011 = formUrlEncode(this.r5h_1);
            var charset11 = Charsets_getInstance().y3x_1;
            if (charset11.equals(Charsets_getInstance().y3x_1)) {
                tmp$ret$011 = encodeToByteArray(this_011);
                break $l$block;
            }
            tmp$ret$011 = encodeToByteArray_0(charset11.c3y(), this_011, 0, this_011.length);
        }
        tmp11.s5h_1 = tmp$ret$011;
        this.t5h_1 = toLong(this.s5h_1.length);
        this.u5h_1 = withCharset(Application_getInstance().g48_1, Charsets_getInstance().y3x_1);
    }
    protoOf(FormDataContent).s4i = function() {
        return this.t5h_1;
    };
    protoOf(FormDataContent).r4i = function() {
        return this.u5h_1;
    };
    protoOf(FormDataContent).t4i = function() {
        return this.s5h_1;
    };
    function submitForm(_this__u8e3s411, url11, formParameters11, encodeInQuery11, block11, $completion11) {
        formParameters11 = formParameters11 === VOID ? Companion_getInstance_2().k4g_1 : formParameters11;
        encodeInQuery11 = encodeInQuery11 === VOID ? false : encodeInQuery11;
        var tmp11;
        if (block11 === VOID) tmp11 = submitForm$lambda;
        else tmp11 = block11;
        block11 = tmp11;
        var tmp_011 = new $submitFormCOROUTINE$18(_this__u8e3s411, url11, formParameters11, encodeInQuery11, block11, $completion11);
        tmp_011.x8_1 = Unit_instance;
        tmp_011.y8_1 = null;
        return tmp_011.d9();
    }
    function submitForm$lambda($this$null11) {
        return Unit_instance;
    }
    function $submitFormCOROUTINE$18(_this__u8e3s411, url11, formParameters11, encodeInQuery11, block11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.d5i_1 = _this__u8e3s411;
        this.e5i_1 = url11;
        this.f5i_1 = formParameters11;
        this.g5i_1 = encodeInQuery11;
        this.h5i_1 = block11;
    }
    protoOf($submitFormCOROUTINE$18).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    var tmp_011 = this;
                    tmp_011.i5i_1 = this.d5i_1;
                    var tmp_141 = this;
                    tmp_141.j5i_1 = this.f5i_1;
                    var tmp_211 = this;
                    tmp_211.k5i_1 = this.g5i_1;
                    var tmp_311 = this;
                    tmp_311.l5i_1 = this.i5i_1;
                    var tmp_411 = this;
                    tmp_411.m5i_1 = this.l5i_1;
                    var tmp_511 = this;
                    var this_011 = new HttpRequestBuilder();
                    if (this.k5i_1) {
                        this_011.n4t_1 = Companion_getInstance_0().n4d_1;
                        this_011.m4t_1.w4g_1.x43(this.j5i_1);
                    } else {
                        this_011.n4t_1 = Companion_getInstance_0().o4d_1;
                        var body11 = new FormDataContent(this.j5i_1);
                        if (body11 == null) {
                            this_011.p4t_1 = NullBody_instance;
                            var tmp_611 = JsType_instance;
                            var tmp_711 = getKClass(FormDataContent);
                            var tmp_811;
                            try {
                                tmp_811 = createKType(getKClass(FormDataContent), arrayOf([]), false);
                            } catch ($p11) {
                                var tmp_911;
                                if ($p11 instanceof Error) {
                                    var cause11 = $p11;
                                    tmp_911 = null;
                                } else throw $p11;
                                tmp_811 = tmp_911;
                            }
                            this_011.k4z(typeInfoImpl(tmp_611, tmp_711, tmp_811));
                        } else if (body11 instanceof OutgoingContent) {
                            this_011.p4t_1 = body11;
                            this_011.k4z(null);
                        } else {
                            this_011.p4t_1 = body11;
                            var tmp_1011 = JsType_instance;
                            var tmp_1111 = getKClass(FormDataContent);
                            var tmp_1211;
                            try {
                                tmp_1211 = createKType(getKClass(FormDataContent), arrayOf([]), false);
                            } catch ($p11) {
                                var tmp_1311;
                                if ($p11 instanceof Error) {
                                    var cause_011 = $p11;
                                    tmp_1311 = null;
                                } else throw $p11;
                                tmp_1211 = tmp_1311;
                            }
                            this_011.k4z(typeInfoImpl(tmp_1011, tmp_1111, tmp_1211));
                        }
                    }
                    url(this_011, this.e5i_1);
                    this.h5i_1(this_011);
                    tmp_511.n5i_1 = this_011;
                    this.v8_1 = 1;
                    suspendResult11 = new HttpStatement(this.n5i_1, this.m5i_1).q5i(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return suspendResult11;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function header(_this__u8e3s411, key11, value11) {
        var tmp11;
        if (value11 == null) tmp11 = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            _this__u8e3s411.m4d().w43(key11, toString(value11));
            tmp11 = Unit_instance;
        }
        var tmp_011;
        if (tmp11 == null) tmp_011 = Unit_instance;
        else tmp_011 = Unit_instance;
        return tmp_011;
    }
    function set_port(_this__u8e3s411, value11) {
        _this__u8e3s411.m4t_1.p4g_1 = value11;
    }
    function accept(_this__u8e3s411, contentType11) {
        return _this__u8e3s411.m4d().w43(HttpHeaders_getInstance().j49_1, contentType11.toString());
    }
    function DefaultHttpResponse(call11, responseData11) {
        HttpResponse.call(this);
        this.r5i_1 = call11;
        this.s5i_1 = responseData11.z4u_1;
        this.t5i_1 = responseData11.u4u_1;
        this.u5i_1 = responseData11.x4u_1;
        this.v5i_1 = responseData11.v4u_1;
        this.w5i_1 = responseData11.a4v_1;
        var tmp11 = this;
        var tmp_011 = responseData11.y4u_1;
        var tmp0_elvis_lhs11 = isInterface(tmp_011, ByteReadChannel) ? tmp_011 : null;
        tmp11.x5i_1 = tmp0_elvis_lhs11 == null ? Companion_getInstance().m3u() : tmp0_elvis_lhs11;
        this.y5i_1 = responseData11.w4u_1;
    }
    protoOf(DefaultHttpResponse).t4w = function() {
        return this.r5i_1;
    };
    protoOf(DefaultHttpResponse).v1m = function() {
        return this.s5i_1;
    };
    protoOf(DefaultHttpResponse).y4v = function() {
        return this.t5i_1;
    };
    protoOf(DefaultHttpResponse).e4x = function() {
        return this.u5i_1;
    };
    protoOf(DefaultHttpResponse).f4x = function() {
        return this.v5i_1;
    };
    protoOf(DefaultHttpResponse).g4x = function() {
        return this.w5i_1;
    };
    protoOf(DefaultHttpResponse).e1b = function() {
        return this.x5i_1;
    };
    protoOf(DefaultHttpResponse).m4d = function() {
        return this.y5i_1;
    };
    function HttpResponse() {}
    protoOf(HttpResponse).toString = function() {
        return "HttpResponse[" + get_request(this).y3h().toString() + ", " + this.y4v().toString() + "]";
    };
    function get_request(_this__u8e3s411) {
        return _this__u8e3s411.t4w().w4v();
    }
    function complete(_this__u8e3s411) {
        var tmp11 = ensureNotNull(_this__u8e3s411.v1m().i9(Key_instance));
        var job11 = isInterface(tmp11, CompletableJob) ? tmp11 : THROW_CCE();
        job11.s1s();
    }
    function bodyAsText(_this__u8e3s411, fallbackCharset11, $completion11) {
        fallbackCharset11 = fallbackCharset11 === VOID ? Charsets_getInstance().y3x_1 : fallbackCharset11;
        var tmp11 = new $bodyAsTextCOROUTINE$20(_this__u8e3s411, fallbackCharset11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function $bodyAsTextCOROUTINE$20(_this__u8e3s411, fallbackCharset11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.h5j_1 = _this__u8e3s411;
        this.i5j_1 = fallbackCharset11;
    }
    protoOf($bodyAsTextCOROUTINE$20).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    var tmp_011 = this;
                    var tmp0_elvis_lhs11 = charset_0(this.h5j_1);
                    tmp_011.j5j_1 = tmp0_elvis_lhs11 == null ? this.i5j_1 : tmp0_elvis_lhs11;
                    this.k5j_1 = this.j5j_1.b3y();
                    var tmp_141 = this;
                    tmp_141.l5j_1 = this.h5j_1;
                    this.v8_1 = 1;
                    var tmp_211 = this.l5j_1.t4w();
                    var tmp_311 = JsType_instance;
                    var tmp_411 = getKClass(ByteReadPacket);
                    var tmp_511;
                    try {
                        tmp_511 = createKType(getKClass(ByteReadPacket), arrayOf([]), false);
                    } catch ($p11) {
                        var tmp_611;
                        if ($p11 instanceof Error) {
                            var cause11 = $p11;
                            tmp_611 = null;
                        } else throw $p11;
                        tmp_511 = tmp_611;
                    }
                    suspendResult11 = tmp_211.x4v(typeInfoImpl(tmp_311, tmp_411, tmp_511), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    var input11 = suspendResult11 instanceof ByteReadPacket ? suspendResult11 : THROW_CCE();
                    return decode(this.k5j_1, input11);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function Phases_1() {
        Phases_instance_1 = this;
        this.k4u_1 = new PipelinePhase("Receive");
        this.l4u_1 = new PipelinePhase("Parse");
        this.m4u_1 = new PipelinePhase("Transform");
        this.n4u_1 = new PipelinePhase("State");
        this.o4u_1 = new PipelinePhase("After");
    }
    var Phases_instance_1;
    function Phases_getInstance_1() {
        if (Phases_instance_1 == null) new Phases_1();
        return Phases_instance_1;
    }
    function HttpResponsePipeline(developmentMode11) {
        Phases_getInstance_1();
        developmentMode11 = developmentMode11 === VOID ? false : developmentMode11;
        Pipeline.call(this, [
            Phases_getInstance_1().k4u_1,
            Phases_getInstance_1().l4u_1,
            Phases_getInstance_1().m4u_1,
            Phases_getInstance_1().n4u_1,
            Phases_getInstance_1().o4u_1
        ]);
        this.t5j_1 = developmentMode11;
    }
    protoOf(HttpResponsePipeline).m46 = function() {
        return this.t5j_1;
    };
    function Phases_2() {
        Phases_instance_2 = this;
        this.o50_1 = new PipelinePhase("Before");
        this.p50_1 = new PipelinePhase("State");
        this.q50_1 = new PipelinePhase("After");
    }
    var Phases_instance_2;
    function Phases_getInstance_2() {
        if (Phases_instance_2 == null) new Phases_2();
        return Phases_instance_2;
    }
    function HttpReceivePipeline(developmentMode11) {
        Phases_getInstance_2();
        developmentMode11 = developmentMode11 === VOID ? false : developmentMode11;
        Pipeline.call(this, [
            Phases_getInstance_2().o50_1,
            Phases_getInstance_2().p50_1,
            Phases_getInstance_2().q50_1
        ]);
        this.b5k_1 = developmentMode11;
    }
    protoOf(HttpReceivePipeline).m46 = function() {
        return this.b5k_1;
    };
    function HttpResponseContainer(expectedType11, response11) {
        this.u4v_1 = expectedType11;
        this.v4v_1 = response11;
    }
    protoOf(HttpResponseContainer).ba = function() {
        return this.u4v_1;
    };
    protoOf(HttpResponseContainer).ca = function() {
        return this.v4v_1;
    };
    protoOf(HttpResponseContainer).toString = function() {
        return "HttpResponseContainer(expectedType=" + this.u4v_1.toString() + ", response=" + toString(this.v4v_1) + ")";
    };
    protoOf(HttpResponseContainer).hashCode = function() {
        var result11 = this.u4v_1.hashCode();
        result11 = imul(result11, 31) + hashCode(this.v4v_1) | 0;
        return result11;
    };
    protoOf(HttpResponseContainer).equals = function(other11) {
        if (this === other11) return true;
        if (!(other11 instanceof HttpResponseContainer)) return false;
        var tmp0_other_with_cast11 = other11 instanceof HttpResponseContainer ? other11 : THROW_CCE();
        if (!this.u4v_1.equals(tmp0_other_with_cast11.u4v_1)) return false;
        if (!equals(this.v4v_1, tmp0_other_with_cast11.v4v_1)) return false;
        return true;
    };
    function checkCapabilities($this11) {
        var tmp0_safe_receiver11 = $this11.o5i_1.r4t_1.t41(get_ENGINE_CAPABILITIES_KEY());
        var tmp1_safe_receiver11 = tmp0_safe_receiver11 == null ? null : tmp0_safe_receiver11.f2();
        var tmp11;
        if (tmp1_safe_receiver11 == null) tmp11 = null;
        else {
            // Inline function 'kotlin.collections.filterIsInstance' call
            // Inline function 'kotlin.collections.filterIsInstanceTo' call
            var destination11 = ArrayList_init_$Create$();
            var tmp0_iterator11 = tmp1_safe_receiver11.j();
            while(tmp0_iterator11.k()){
                var element11 = tmp0_iterator11.l();
                if (!(element11 == null) ? isInterface(element11, HttpClientPlugin) : false) destination11.e(element11);
            }
            tmp11 = destination11;
        }
        var tmp2_safe_receiver11 = tmp11;
        if (tmp2_safe_receiver11 == null) ;
        else {
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_011 = tmp2_safe_receiver11.j();
            while(tmp0_iterator_011.k()){
                var element_011 = tmp0_iterator_011.l();
                // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>' call
                $l$block: {
                    // Inline function 'kotlin.requireNotNull' call
                    // Inline function 'kotlin.contracts.contract' call
                    if (pluginOrNull($this11.p5i_1, element_011) == null) {
                        // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>.<anonymous>' call
                        var message11 = "Consider installing " + toString(element_011) + " plugin because the request requires it to be installed";
                        throw IllegalArgumentException_init_$Create$(toString(message11));
                    } else break $l$block;
                }
            }
        }
    }
    function HttpStatement$execute$slambda(resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(HttpStatement$execute$slambda).l5k = function(it11, $completion11) {
        var tmp11 = this.s52(it11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpStatement$execute$slambda).y9 = function(p111, $completion11) {
        return this.l5k(p111 instanceof HttpResponse ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(HttpStatement$execute$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = save(this.k5k_1.t4w(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    var savedCall11 = suspendResult11;
                    return savedCall11.j31();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(HttpStatement$execute$slambda).s52 = function(it11, completion11) {
        var i11 = new HttpStatement$execute$slambda(completion11);
        i11.k5k_1 = it11;
        return i11;
    };
    function HttpStatement$execute$slambda_0(resultContinuation11) {
        var i11 = new HttpStatement$execute$slambda(resultContinuation11);
        var l11 = function(it11, $completion11) {
            return i11.l5k(it11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function $executeCOROUTINE$21(_this__u8e3s411, block11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.u5k_1 = _this__u8e3s411;
        this.v5k_1 = block11;
    }
    protoOf($executeCOROUTINE$21).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 13;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.w8_1 = 12;
                    this.v8_1 = 2;
                    suspendResult11 = this.u5k_1.b5l(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    this.x5k_1 = suspendResult11;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.w8_1 = 10;
                    this.v8_1 = 5;
                    suspendResult11 = this.v5k_1(this.x5k_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 5:
                    this.y5k_1 = suspendResult11;
                    this.v8_1 = 6;
                    var tmp_011 = this;
                    continue $sm;
                case 6:
                    this.z5k_1 = this.y5k_1;
                    this.w8_1 = 12;
                    this.v8_1 = 7;
                    suspendResult11 = this.u5k_1.c5l(this.x5k_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 7:
                    return this.z5k_1;
                case 8:
                    this.w8_1 = 12;
                    this.v8_1 = 9;
                    suspendResult11 = this.u5k_1.c5l(this.x5k_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 9:
                    var tmp_141 = this;
                    tmp_141.w5k_1 = Unit_instance;
                    this.w8_1 = 13;
                    this.v8_1 = 15;
                    continue $sm;
                case 10:
                    this.w8_1 = 12;
                    this.a5l_1 = this.y8_1;
                    this.v8_1 = 11;
                    suspendResult11 = this.u5k_1.c5l(this.x5k_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 11:
                    throw this.a5l_1;
                case 12:
                    this.w8_1 = 13;
                    var tmp_211 = this.y8_1;
                    if (tmp_211 instanceof CancellationException) {
                        var cause11 = this.y8_1;
                        throw unwrapCancellationException(cause11);
                    } else throw this.y8_1;
                case 13:
                    throw this.y8_1;
                case 14:
                    this.w8_1 = 13;
                    this.v8_1 = 15;
                    continue $sm;
                case 15:
                    return this.w5k_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 13) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function $executeUnsafeCOROUTINE$22(_this__u8e3s411, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.l5l_1 = _this__u8e3s411;
    }
    protoOf($executeUnsafeCOROUTINE$22).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.w8_1 = 3;
                    this.n5l_1 = new HttpRequestBuilder().j4z(this.l5l_1.o5i_1);
                    this.v8_1 = 2;
                    suspendResult11 = this.l5l_1.p5i_1.p4u(this.n5l_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    var call11 = suspendResult11;
                    var tmp_011 = this;
                    return call11.j31();
                case 3:
                    this.w8_1 = 4;
                    var tmp_141 = this.y8_1;
                    if (tmp_141 instanceof CancellationException) {
                        var cause11 = this.y8_1;
                        throw unwrapCancellationException(cause11);
                    } else throw this.y8_1;
                case 4:
                    throw this.y8_1;
                case 5:
                    this.w8_1 = 4;
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    return this.m5l_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function $cleanupCOROUTINE$23(_this__u8e3s411, _this__u8e3s4_011, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.w5l_1 = _this__u8e3s411;
        this.x5l_1 = _this__u8e3s4_011;
    }
    protoOf($cleanupCOROUTINE$23).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    var tmp_011 = this;
                    var tmp_141 = ensureNotNull(this.x5l_1.v1m().i9(Key_instance));
                    tmp_011.y5l_1 = isInterface(tmp_141, CompletableJob) ? tmp_141 : THROW_CCE();
                    var tmp_211 = this;
                    tmp_211.z5l_1 = this.y5l_1;
                    var tmp_311 = this;
                    tmp_311.a5m_1 = this.z5l_1;
                    this.a5m_1.s1s();
                    this.w8_1 = 1;
                    cancel_1(this.x5l_1.e1b());
                    this.w8_1 = 4;
                    this.v8_1 = 2;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    var tmp_411 = this.y8_1;
                    if (tmp_411 instanceof Error) {
                        this.b5m_1 = this.y8_1;
                        this.v8_1 = 2;
                        continue $sm;
                    } else throw this.y8_1;
                case 2:
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    suspendResult11 = this.a5m_1.t1s(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 3:
                    return Unit_instance;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function HttpStatement(builder11, client11) {
        this.o5i_1 = builder11;
        this.p5i_1 = client11;
        checkCapabilities(this);
    }
    protoOf(HttpStatement).c5m = function(block11, $completion11) {
        var tmp11 = new $executeCOROUTINE$21(this, block11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpStatement).q5i = function($completion11) {
        return this.c5m(HttpStatement$execute$slambda_0(null), $completion11);
    };
    protoOf(HttpStatement).b5l = function($completion11) {
        var tmp11 = new $executeUnsafeCOROUTINE$22(this, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpStatement).c5l = function(_this__u8e3s411, $completion11) {
        var tmp11 = new $cleanupCOROUTINE$23(this, _this__u8e3s411, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(HttpStatement).toString = function() {
        return "HttpStatement[" + this.o5i_1.m4t_1.toString() + "]";
    };
    function observable(_this__u8e3s411, context11, contentLength11, listener11) {
        var tmp11 = GlobalScope_instance;
        return writer(tmp11, context11, true, observable$slambda_0(contentLength11, _this__u8e3s411, listener11, null)).v1x();
    }
    function observable$slambda($contentLength11, $this_observable11, $listener11, resultContinuation11) {
        this.l5m_1 = $contentLength11;
        this.m5m_1 = $this_observable11;
        this.n5m_1 = $listener11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(observable$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(observable$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(observable$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 15;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    var tmp_011 = this;
                    tmp_011.q5m_1 = get_ByteArrayPool();
                    this.r5m_1 = this.q5m_1.k3w();
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.w8_1 = 14;
                    var tmp_141 = this;
                    tmp_141.t5m_1 = this.r5m_1;
                    var tmp_211 = this;
                    var tmp0_elvis_lhs11 = this.l5m_1;
                    tmp_211.u5m_1 = tmp0_elvis_lhs11 == null ? new Long(-1, -1) : tmp0_elvis_lhs11;
                    this.v5m_1 = new Long(0, 0);
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    if (!!this.m5m_1.c3o()) {
                        this.v8_1 = 8;
                        continue $sm;
                    }
                    this.v8_1 = 5;
                    suspendResult11 = readAvailable(this.m5m_1, this.t5m_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 5:
                    this.w5m_1 = suspendResult11;
                    this.v8_1 = 6;
                    suspendResult11 = this.o5m_1.v1x().g3t(this.t5m_1, 0, this.w5m_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 6:
                    var tmp_311 = this;
                    var this_011 = this.v5m_1;
                    var other11 = this.w5m_1;
                    tmp_311.v5m_1 = this_011.y2(toLong(other11));
                    this.v8_1 = 7;
                    suspendResult11 = this.n5m_1(this.v5m_1, this.u5m_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 7:
                    this.v8_1 = 4;
                    continue $sm;
                case 8:
                    this.x5m_1 = this.m5m_1.m3n();
                    this.o5m_1.v1x().j21(this.x5m_1);
                    if (this.x5m_1 == null && this.v5m_1.equals(new Long(0, 0))) {
                        this.v8_1 = 9;
                        suspendResult11 = this.n5m_1(this.v5m_1, this.u5m_1, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        this.v8_1 = 10;
                        continue $sm;
                    }
                case 9:
                    this.v8_1 = 10;
                    continue $sm;
                case 10:
                    this.s5m_1 = Unit_instance;
                    this.w8_1 = 15;
                    this.v8_1 = 11;
                    var tmp_411 = this;
                    continue $sm;
                case 11:
                    this.w8_1 = 15;
                    var tmp_511 = this;
                    this.q5m_1.l3w(this.r5m_1);
                    tmp_511.p5m_1 = Unit_instance;
                    this.v8_1 = 13;
                    continue $sm;
                case 12:
                    this.w8_1 = 15;
                    this.q5m_1.l3w(this.r5m_1);
                    this.v8_1 = 13;
                    continue $sm;
                case 13:
                    return Unit_instance;
                case 14:
                    this.w8_1 = 15;
                    var t11 = this.y8_1;
                    this.q5m_1.l3w(this.r5m_1);
                    throw t11;
                case 15:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 15) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(observable$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new observable$slambda(this.l5m_1, this.m5m_1, this.n5m_1, completion11);
        i11.o5m_1 = $this$writer11;
        return i11;
    };
    function observable$slambda_0($contentLength11, $this_observable11, $listener11, resultContinuation11) {
        var i11 = new observable$slambda($contentLength11, $this_observable11, $listener11, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function get_HttpRequestCreated() {
        _init_properties_ClientEvents_kt__xuvbz8();
        return HttpRequestCreated;
    }
    var HttpRequestCreated;
    function get_HttpRequestIsReadyForSending() {
        _init_properties_ClientEvents_kt__xuvbz8();
        return HttpRequestIsReadyForSending;
    }
    var HttpRequestIsReadyForSending;
    function get_HttpResponseReceived() {
        _init_properties_ClientEvents_kt__xuvbz8();
        return HttpResponseReceived;
    }
    var HttpResponseReceived;
    function get_HttpResponseReceiveFailed() {
        _init_properties_ClientEvents_kt__xuvbz8();
        return HttpResponseReceiveFailed;
    }
    var HttpResponseReceiveFailed;
    function get_HttpResponseCancelled() {
        _init_properties_ClientEvents_kt__xuvbz8();
        return HttpResponseCancelled;
    }
    var HttpResponseCancelled;
    function HttpResponseReceiveFail(response11, cause11) {
        this.y5m_1 = response11;
        this.z5m_1 = cause11;
    }
    var properties_initialized_ClientEvents_kt_rdee4m;
    function _init_properties_ClientEvents_kt__xuvbz8() {
        if (!properties_initialized_ClientEvents_kt_rdee4m) {
            properties_initialized_ClientEvents_kt_rdee4m = true;
            HttpRequestCreated = new EventDefinition();
            HttpRequestIsReadyForSending = new EventDefinition();
            HttpResponseReceived = new EventDefinition();
            HttpResponseReceiveFailed = new EventDefinition();
            HttpResponseCancelled = new EventDefinition();
        }
    }
    function EmptyContent() {
        EmptyContent_instance = this;
        NoContent.call(this);
        this.b5n_1 = new Long(0, 0);
    }
    protoOf(EmptyContent).s4i = function() {
        return this.b5n_1;
    };
    protoOf(EmptyContent).toString = function() {
        return "EmptyContent";
    };
    var EmptyContent_instance;
    function EmptyContent_getInstance() {
        if (EmptyContent_instance == null) new EmptyContent();
        return EmptyContent_instance;
    }
    function buildHeaders(block11) {
        var tmp11;
        if (block11 === VOID) tmp11 = buildHeaders$lambda;
        else tmp11 = block11;
        block11 = tmp11;
        // Inline function 'kotlin.apply' call
        var this_011 = new HeadersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        return this_011.c3r();
    }
    function buildHeaders$lambda($this$null11) {
        return Unit_instance;
    }
    function HttpClient_2(block11) {
        var tmp11;
        if (block11 === VOID) tmp11 = HttpClient$lambda_3;
        else tmp11 = block11;
        block11 = tmp11;
        return HttpClient_1(JsClient(), block11);
    }
    function HttpClient$lambda_3($this$null11) {
        return Unit_instance;
    }
    function ioDispatcher() {
        return Dispatchers_getInstance().e1x_1;
    }
    function Js() {}
    protoOf(Js).c5n = function(block11) {
        // Inline function 'kotlin.apply' call
        var this_011 = new HttpClientEngineConfig();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        return new JsClientEngine(this_011);
    };
    protoOf(Js).q4u = function(block11) {
        return this.c5n(block11);
    };
    var Js_instance;
    function Js_getInstance() {
        return Js_instance;
    }
    function JsClient() {
        return Js_instance;
    }
    function createWebSocket($this, urlString_capturingHack, headers) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = headers.m43();
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
            if (equals_0(element, "sec-websocket-protocol", true)) destination.e(element);
        }
        var protocolHeaderNames = destination;
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_0 = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = protocolHeaderNames.j();
        while(tmp0_iterator_0.k()){
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
            var tmp0_safe_receiver = headers.l43(element_0);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination_0.e(tmp0_safe_receiver);
        }
        var this_1 = flatten(destination_0);
        var protocols = copyToArray(this_1);
        var tmp;
        if (get_platform(PlatformUtils_getInstance()).q2_1 === 2) tmp = new WebSocket(urlString_capturingHack, protocols);
        else {
            var ws_capturingHack = eval("require")("ws");
            var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
            headers.o43(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
            tmp = new ws_capturingHack(urlString_capturingHack, protocols, {
                headers: headers_capturingHack
            });
        }
        return tmp;
    }
    function executeWebSocketRequest($this11, request11, callContext11, $completion11) {
        var tmp11 = new $executeWebSocketRequestCOROUTINE$25($this11, request11, callContext11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function JsClientEngine$createWebSocket$headers_capturingHack$1() {}
    function JsClientEngine$createWebSocket$lambda($headers_capturingHack11) {
        return function(name11, values11) {
            $headers_capturingHack11[name11] = joinToString(values11, ",");
            return Unit_instance;
        };
    }
    function $executeCOROUTINE$24(_this__u8e3s411, data11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.a5o_1 = _this__u8e3s411;
        this.b5o_1 = data11;
    }
    protoOf($executeCOROUTINE$24).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 6;
                    this.v8_1 = 1;
                    suspendResult11 = callContext(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.c5o_1 = suspendResult11;
                    this.d5o_1 = this.b5o_1.p4y_1.s41(get_CLIENT_CONFIG());
                    if (isUpgradeRequest(this.b5o_1)) {
                        this.v8_1 = 5;
                        suspendResult11 = executeWebSocketRequest(this.a5o_1, this.b5o_1, this.c5o_1, this);
                        if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.e5o_1 = GMTDate();
                    this.v8_1 = 3;
                    suspendResult11 = toRaw(this.b5o_1, this.d5o_1, this.c5o_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 3:
                    this.f5o_1 = suspendResult11;
                    this.v8_1 = 4;
                    suspendResult11 = commonFetch(this.b5o_1.k4y_1.toString(), this.f5o_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 4:
                    var rawResponse11 = suspendResult11;
                    var status11 = new HttpStatusCode(rawResponse11.status, rawResponse11.statusText);
                    var headers11 = mapToKtor(rawResponse11.headers);
                    var version11 = Companion_getInstance_3().x4d_1;
                    var body11 = readBody(CoroutineScope_0(this.c5o_1), rawResponse11);
                    return new HttpResponseData(status11, this.e5o_1, headers11, version11, body11, this.c5o_1);
                case 5:
                    return suspendResult11;
                case 6:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 6) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function $executeWebSocketRequestCOROUTINE$25(_this__u8e3s411, request11, callContext11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.l5n_1 = _this__u8e3s411;
        this.m5n_1 = request11;
        this.n5n_1 = callContext11;
    }
    protoOf($executeWebSocketRequestCOROUTINE$25).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    this.o5n_1 = GMTDate();
                    this.p5n_1 = this.m5n_1.k4y_1.toString();
                    this.q5n_1 = createWebSocket(this.l5n_1, this.p5n_1, this.m5n_1.m4y_1);
                    this.r5n_1 = new JsWebSocketSession(this.n5n_1, this.q5n_1);
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = awaitConnection(this.q5n_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    this.w8_1 = 4;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 4;
                    var tmp_011 = this.y8_1;
                    if (tmp_011 instanceof Error) {
                        var cause11 = this.y8_1;
                        cancel_3(this.n5n_1, CancellationException_init_$Create$_0("Failed to connect to " + this.p5n_1, cause11));
                        throw cause11;
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 4;
                    return new HttpResponseData(Companion_getInstance_1().f4e_1, this.o5n_1, Companion_getInstance_4().g49_1, Companion_getInstance_3().x4d_1, this.r5n_1, this.n5n_1);
                case 4:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function JsClientEngine(config11) {
        HttpClientEngineBase.call(this, "ktor-js");
        this.k5o_1 = config11;
        this.l5o_1 = setOf_0([
            Plugin_getInstance_4(),
            WebSocketCapability_instance
        ]);
        // Inline function 'kotlin.check' call
        // Inline function 'kotlin.contracts.contract' call
        if (!(this.k5o_1.h50_1 == null)) {
            // Inline function 'io.ktor.client.engine.js.JsClientEngine.<anonymous>' call
            var message11 = "Proxy unsupported in Js engine.";
            throw IllegalStateException_init_$Create$(toString(message11));
        }
    }
    protoOf(JsClientEngine).a4u = function() {
        return this.k5o_1;
    };
    protoOf(JsClientEngine).r4y = function() {
        return this.l5o_1;
    };
    protoOf(JsClientEngine).x4z = function(data11, $completion11) {
        var tmp11 = new $executeCOROUTINE$24(this, data11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    function mapToKtor(_this__u8e3s411) {
        return buildHeaders(mapToKtor$lambda(_this__u8e3s411));
    }
    function awaitConnection(_this__u8e3s411, $completion11) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable11 = new CancellableContinuationImpl(intercepted($completion11), 1);
        cancellable11.l1r();
        $l$block: {
            // Inline function 'io.ktor.client.engine.js.awaitConnection.<anonymous>' call
            if (cancellable11.r1p()) break $l$block;
            var eventListener11 = awaitConnection$lambda(cancellable11, _this__u8e3s411);
            _this__u8e3s411.addEventListener("open", eventListener11);
            _this__u8e3s411.addEventListener("error", eventListener11);
            cancellable11.u1p(awaitConnection$lambda_0(_this__u8e3s411, eventListener11));
        }
        return cancellable11.s1r();
    }
    function asString(_this__u8e3s411) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_011 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.client.engine.js.asString.<anonymous>' call
        var tmp11 = JSON;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$211 = [
            "message",
            "target",
            "type",
            "isTrusted"
        ];
        this_011.e8(tmp11.stringify(_this__u8e3s411, tmp$ret$211));
        return this_011.toString();
    }
    function JsError(origin11) {
        extendThrowable(this, "Error from javascript[" + origin11 + "].");
        captureStack(this, JsError);
        this.m5o_1 = origin11;
    }
    function mapToKtor$lambda$lambda($this_buildHeaders11) {
        return function(value11, key11) {
            $this_buildHeaders11.w43(key11, value11);
            return Unit_instance;
        };
    }
    function mapToKtor$lambda($this_mapToKtor11) {
        return function($this$buildHeaders11) {
            // Inline function 'kotlin.js.asDynamic' call
            $this_mapToKtor11.forEach(mapToKtor$lambda$lambda($this$buildHeaders11));
            return Unit_instance;
        };
    }
    function awaitConnection$lambda($continuation11, $this_awaitConnection11) {
        return function(event11) {
            var tmp0_subject11 = event11.type;
            var tmp11;
            if (tmp0_subject11 === "open") {
                // Inline function 'kotlin.coroutines.resume' call
                var this_011 = $continuation11;
                // Inline function 'kotlin.Companion.success' call
                var value11 = $this_awaitConnection11;
                var tmp$ret$011 = _Result___init__impl__xyqfz8(value11);
                this_011.g9(tmp$ret$011);
                tmp11 = Unit_instance;
            } else if (tmp0_subject11 === "error") {
                // Inline function 'kotlin.coroutines.resumeWithException' call
                var this_111 = $continuation11;
                // Inline function 'kotlin.Companion.failure' call
                var exception11 = WebSocketException_init_$Create$(asString(event11));
                var tmp$ret$211 = _Result___init__impl__xyqfz8(createFailure(exception11));
                this_111.g9(tmp$ret$211);
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function awaitConnection$lambda_0($this_awaitConnection11, $eventListener11) {
        return function(it11) {
            $this_awaitConnection11.removeEventListener("open", $eventListener11);
            $this_awaitConnection11.removeEventListener("error", $eventListener11);
            var tmp11;
            if (!(it11 == null)) {
                $this_awaitConnection11.close();
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function toRaw(_this__u8e3s411, clientConfig11, callContext11, $completion11) {
        var tmp11 = new $toRawCOROUTINE$26(_this__u8e3s411, clientConfig11, callContext11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    }
    function buildObject(block11) {
        // Inline function 'kotlin.apply' call
        var tmp11 = {};
        var this_011 = (tmp11 == null ? true : !(tmp11 == null)) ? tmp11 : THROW_CCE();
        // Inline function 'kotlin.contracts.contract' call
        block11(this_011);
        return this_011;
    }
    function toRaw$lambda($jsHeaders11) {
        return function(key11, value11) {
            $jsHeaders11[key11] = value11;
            return Unit_instance;
        };
    }
    function toRaw$slambda($content11, resultContinuation11) {
        this.j5p_1 = $content11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(toRaw$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(toRaw$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(toRaw$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult11 = this.j5p_1.y4i(this.k5p_1.v1x(), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 2) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(toRaw$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new toRaw$slambda(this.j5p_1, completion11);
        i11.k5p_1 = $this$writer11;
        return i11;
    };
    function toRaw$slambda_0($content11, resultContinuation11) {
        var i11 = new toRaw$slambda($content11, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function toRaw$lambda_0($this_toRaw11, $jsHeaders11, $clientConfig11, $bodyBytes11) {
        return function($this$buildObject11) {
            $this$buildObject11.method = $this_toRaw11.l4y_1.v4d_1;
            $this$buildObject11.headers = $jsHeaders11;
            var tmp11;
            if ($clientConfig11.w4t_1) // Inline function 'org.w3c.fetch.FOLLOW' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp11 = "follow";
            else // Inline function 'org.w3c.fetch.MANUAL' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp11 = "manual";
            $this$buildObject11.redirect = tmp11;
            var tmp0_safe_receiver11 = $bodyBytes11;
            if (tmp0_safe_receiver11 == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            $this$buildObject11.body = new Uint8Array(toTypedArray(tmp0_safe_receiver11));
            return Unit_instance;
        };
    }
    function $toRawCOROUTINE$26(_this__u8e3s411, clientConfig11, callContext11, resultContinuation11) {
        CoroutineImpl.call(this, resultContinuation11);
        this.v5o_1 = _this__u8e3s411;
        this.w5o_1 = clientConfig11;
        this.x5o_1 = callContext11;
    }
    protoOf($toRawCOROUTINE$26).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 4;
                    this.y5o_1 = {};
                    mergeHeaders(this.v5o_1.m4y_1, this.v5o_1.n4y_1, toRaw$lambda(this.y5o_1));
                    this.z5o_1 = this.v5o_1.n4y_1;
                    var tmp_011 = this.z5o_1;
                    if (tmp_011 instanceof ByteArrayContent) {
                        this.a5p_1 = this.z5o_1.t4i();
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        var tmp_141 = this.z5o_1;
                        if (tmp_141 instanceof ReadChannelContent) {
                            this.v8_1 = 2;
                            suspendResult11 = this.z5o_1.w4i().i3t(VOID, this);
                            if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                            continue $sm;
                        } else {
                            var tmp_211 = this.z5o_1;
                            if (tmp_211 instanceof WriteChannelContent) {
                                this.v8_1 = 1;
                                var tmp_311 = GlobalScope_instance;
                                suspendResult11 = writer(tmp_311, this.x5o_1, VOID, toRaw$slambda_0(this.z5o_1, null)).v1x().i3t(VOID, this);
                                if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                                continue $sm;
                            } else {
                                this.a5p_1 = null;
                                this.v8_1 = 3;
                                continue $sm;
                            }
                        }
                    }
                case 1:
                    var ARGUMENT11 = suspendResult11;
                    this.a5p_1 = readBytes(ARGUMENT11);
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    var ARGUMENT_011 = suspendResult11;
                    this.a5p_1 = readBytes(ARGUMENT_011);
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    var bodyBytes11 = this.a5p_1;
                    return buildObject(toRaw$lambda_0(this.v5o_1, this.y5o_1, this.w5o_1, bodyBytes11));
                case 4:
                    throw this.y8_1;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 4) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    function asByteArray(_this__u8e3s411) {
        // Inline function 'kotlin.js.asDynamic' call
        return new Int8Array(_this__u8e3s411.buffer, _this__u8e3s411.byteOffset, _this__u8e3s411.length);
    }
    function readBodyBrowser(_this__u8e3s411, response11) {
        var tmp0_elvis_lhs11 = response11.body;
        var tmp11;
        if (tmp0_elvis_lhs11 == null) return Companion_getInstance().m3u();
        else tmp11 = tmp0_elvis_lhs11;
        var stream11 = tmp11;
        return channelFromStream(_this__u8e3s411, stream11);
    }
    function channelFromStream(_this__u8e3s411, stream11) {
        return writer(_this__u8e3s411, VOID, VOID, channelFromStream$slambda_0(stream11, null)).v1x();
    }
    function readChunk(_this__u8e3s411, $completion11) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable11 = new CancellableContinuationImpl(intercepted($completion11), 1);
        cancellable11.l1r();
        // Inline function 'io.ktor.client.engine.js.browser.readChunk.<anonymous>' call
        var tmp11 = _this__u8e3s411.read();
        var tmp_011 = tmp11.then(readChunk$lambda(cancellable11));
        tmp_011.catch(readChunk$lambda_0(cancellable11));
        return cancellable11.s1r();
    }
    function channelFromStream$slambda($stream11, resultContinuation11) {
        this.t5p_1 = $stream11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(channelFromStream$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(channelFromStream$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(channelFromStream$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 6;
                    this.v5p_1 = this.t5p_1.getReader();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.w8_1 = 5;
                    this.v8_1 = 2;
                    suspendResult11 = readChunk(this.v5p_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    this.w5p_1 = suspendResult11;
                    if (this.w5p_1 == null) {
                        this.w8_1 = 6;
                        this.v8_1 = 8;
                        var tmp_011 = this;
                        continue $sm;
                    } else {
                        this.x5p_1 = this.w5p_1;
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    this.y5p_1 = this.x5p_1;
                    this.v8_1 = 4;
                    suspendResult11 = writeFully(this.u5p_1.v1x(), asByteArray(this.y5p_1), this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 4:
                    this.u5p_1.v1x().e3t();
                    this.w8_1 = 6;
                    this.v8_1 = 7;
                    continue $sm;
                case 5:
                    this.w8_1 = 6;
                    var tmp_141 = this.y8_1;
                    if (tmp_141 instanceof Error) {
                        var cause11 = this.y8_1;
                        this.v5p_1.cancel(cause11);
                        throw cause11;
                    } else throw this.y8_1;
                case 6:
                    throw this.y8_1;
                case 7:
                    this.w8_1 = 6;
                    this.v8_1 = 1;
                    continue $sm;
                case 8:
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 6) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(channelFromStream$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new channelFromStream$slambda(this.t5p_1, completion11);
        i11.u5p_1 = $this$writer11;
        return i11;
    };
    function channelFromStream$slambda_0($stream11, resultContinuation11) {
        var i11 = new channelFromStream$slambda($stream11, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function readChunk$lambda($continuation11) {
        return function(it11) {
            var chunk11 = it11.value;
            var result11 = it11.done || chunk11 == null ? null : chunk11;
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$011 = _Result___init__impl__xyqfz8(result11);
            $continuation11.g9(tmp$ret$011);
            return Unit_instance;
        };
    }
    function readChunk$lambda_0($continuation11) {
        return function(cause11) {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            var this_011 = $continuation11;
            // Inline function 'kotlin.Companion.failure' call
            var tmp$ret$011 = _Result___init__impl__xyqfz8(createFailure(cause11));
            this_011.g9(tmp$ret$011);
            return Unit_instance;
        };
    }
    function commonFetch(input11, init11, $completion11) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
        var cancellable11 = new CancellableContinuationImpl(intercepted($completion11), 1);
        cancellable11.l1r();
        // Inline function 'io.ktor.client.engine.js.compatibility.commonFetch.<anonymous>' call
        var controller11 = AbortController_0();
        init11.signal = controller11.signal;
        cancellable11.u1p(commonFetch$lambda(controller11));
        var promise11 = get_platform(PlatformUtils_getInstance()).q2_1 === 2 ? fetch(input11, init11) : jsRequireNodeFetch()(input11, init11);
        var tmp11 = commonFetch$lambda_0(cancellable11);
        promise11.then(tmp11, commonFetch$lambda_1(cancellable11));
        return cancellable11.s1r();
    }
    function readBody(_this__u8e3s411, response11) {
        return get_platform(PlatformUtils_getInstance()).q2_1 === 3 ? readBodyNode(_this__u8e3s411, response11) : readBodyBrowser(_this__u8e3s411, response11);
    }
    function AbortController_0() {
        var tmp;
        if (get_platform(PlatformUtils_getInstance()).q2_1 === 2) tmp = new AbortController();
        else {
            var controller = eval("require")("abort-controller");
            tmp = new controller();
        }
        return tmp;
    }
    function jsRequireNodeFetch() {
        var tmp;
        try {
            tmp = eval("require")("node-fetch");
        } catch ($p) {
            var tmp_0;
            var cause = $p;
            throw Error_init_$Create$("Error loading module 'node-fetch': " + cause);
        }
        return tmp;
    }
    function commonFetch$lambda($controller11) {
        return function(it11) {
            $controller11.abort();
            return Unit_instance;
        };
    }
    function commonFetch$lambda_0($continuation11) {
        return function(it11) {
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$011 = _Result___init__impl__xyqfz8(it11);
            $continuation11.g9(tmp$ret$011);
            return Unit_instance;
        };
    }
    function commonFetch$lambda_1($continuation11) {
        return function(it11) {
            // Inline function 'kotlin.Companion.failure' call
            var exception11 = Error_init_$Create$_0("Fail to fetch", it11);
            var tmp$ret$011 = _Result___init__impl__xyqfz8(createFailure(exception11));
            $continuation11.g9(tmp$ret$011);
            return Unit_instance;
        };
    }
    function readBodyNode(_this__u8e3s411, response11) {
        return writer(_this__u8e3s411, VOID, VOID, readBodyNode$slambda_0(response11, null)).v1x();
    }
    function readBodyNode$slambda$lambda($responseData11, $body11) {
        return function(chunk11) {
            _ChannelResult___get_isSuccess__impl__odq1z9($responseData11.f21(asByteArray(new Uint8Array(chunk11))));
            return $body11.pause();
        };
    }
    function readBodyNode$slambda$lambda_0($responseData11, $this_writer11) {
        return function(error11) {
            var cause11 = new JsError(error11);
            $responseData11.j21(cause11);
            return $this_writer11.v1x().j21(cause11);
        };
    }
    function readBodyNode$slambda$lambda_1($responseData11) {
        return function() {
            return $responseData11.l21();
        };
    }
    function readBodyNode$slambda($response11, resultContinuation11) {
        this.h5q_1 = $response11;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(readBodyNode$slambda).r4x = function($this$writer11, $completion11) {
        var tmp11 = this.s4x($this$writer11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(readBodyNode$slambda).y9 = function(p111, $completion11) {
        return this.r4x((!(p111 == null) ? isInterface(p111, WriterScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(readBodyNode$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 6;
                    var tmp_011 = this;
                    var tmp0_elvis_lhs11 = this.h5q_1.body;
                    var tmp_141;
                    if (tmp0_elvis_lhs11 == null) {
                        var message11 = "Fail to get body";
                        throw IllegalStateException_init_$Create$(toString(message11));
                    } else tmp_141 = tmp0_elvis_lhs11;
                    tmp_011.j5q_1 = tmp_141;
                    this.k5q_1 = Channel(1);
                    this.j5q_1.on("data", readBodyNode$slambda$lambda(this.k5q_1, this.j5q_1));
                    this.j5q_1.on("error", readBodyNode$slambda$lambda_0(this.k5q_1, this.i5q_1));
                    this.j5q_1.on("end", readBodyNode$slambda$lambda_1(this.k5q_1));
                    this.w8_1 = 5;
                    this.l5q_1 = this.k5q_1.j();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.v8_1 = 2;
                    suspendResult11 = this.l5q_1.w20(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 2:
                    if (!suspendResult11) {
                        this.v8_1 = 4;
                        continue $sm;
                    }
                    this.m5q_1 = this.l5q_1.l();
                    this.v8_1 = 3;
                    suspendResult11 = writeFully(this.i5q_1.v1x(), this.m5q_1, this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 3:
                    this.i5q_1.v1x().e3t();
                    this.j5q_1.resume();
                    this.v8_1 = 1;
                    continue $sm;
                case 4:
                    this.w8_1 = 6;
                    this.v8_1 = 7;
                    continue $sm;
                case 5:
                    this.w8_1 = 6;
                    var tmp_211 = this.y8_1;
                    if (tmp_211 instanceof Error) {
                        var cause11 = this.y8_1;
                        this.j5q_1.destroy(cause11);
                        throw cause11;
                    } else throw this.y8_1;
                case 6:
                    throw this.y8_1;
                case 7:
                    this.w8_1 = 6;
                    return Unit_instance;
            }
        } catch ($p11) {
            var e11 = $p11;
            if (this.w8_1 === 6) throw e11;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e11;
            }
        }
        while (true);
    };
    protoOf(readBodyNode$slambda).s4x = function($this$writer11, completion11) {
        var i11 = new readBodyNode$slambda(this.h5q_1, completion11);
        i11.i5q_1 = $this$writer11;
        return i11;
    };
    function readBodyNode$slambda_0($response11, resultContinuation11) {
        var i11 = new readBodyNode$slambda($response11, resultContinuation11);
        var l11 = function($this$writer11, $completion11) {
            return i11.r4x($this$writer11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function platformRequestDefaultTransform(contentType11, context11, body11) {
        return null;
    }
    function platformResponseDefaultTransformers(_this__u8e3s411) {}
    function isReservedStatusCode(_this__u8e3s411, $this11) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.isReservedStatusCode.<anonymous>' call
        var resolved11 = Companion_getInstance_5().k4j(_this__u8e3s411);
        return resolved11 == null || equals(resolved11, Codes_CLOSED_ABNORMALLY_getInstance());
    }
    function JsWebSocketSession$lambda(this$011) {
        return function(it11) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var event11 = it11;
            var data11 = event11.data;
            var tmp11;
            if (data11 instanceof ArrayBuffer) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$311 = new Int8Array(data11);
                tmp11 = Binary_init_$Create$(false, tmp$ret$311);
            } else if (!(data11 == null) ? typeof data11 === "string" : false) tmp11 = Text_init_$Create$(data11);
            else {
                var error11 = IllegalStateException_init_$Create$("Unknown frame type: " + event11.type);
                this$011.p5q_1.r1s(error11);
                throw error11;
            }
            var frame11 = tmp11;
            this$011.q5q_1.f21(frame11);
            return Unit_instance;
        };
    }
    function JsWebSocketSession$lambda_0(this$011) {
        return function(it11) {
            var cause11 = WebSocketException_init_$Create$(toString(it11));
            this$011.p5q_1.r1s(cause11);
            this$011.q5q_1.j21(cause11);
            this$011.r5q_1.n21();
            return Unit_instance;
        };
    }
    function JsWebSocketSession$lambda_1(this$011) {
        return function(event11) {
            var tmp11 = event11.code;
            var tmp_011 = (!(tmp11 == null) ? typeof tmp11 === "number" : false) ? tmp11 : THROW_CCE();
            var tmp_141 = event11.reason;
            var reason11 = new CloseReason(tmp_011, (!(tmp_141 == null) ? typeof tmp_141 === "string" : false) ? tmp_141 : THROW_CCE());
            this$011.p5q_1.p1s(reason11);
            this$011.q5q_1.f21(Close_init_$Create$(reason11));
            this$011.q5q_1.l21();
            this$011.r5q_1.n21();
            return Unit_instance;
        };
    }
    function JsWebSocketSession$slambda(this$011, resultContinuation11) {
        this.d5r_1 = this$011;
        CoroutineImpl.call(this, resultContinuation11);
    }
    protoOf(JsWebSocketSession$slambda).j3u = function($this$launch11, $completion11) {
        var tmp11 = this.e2b($this$launch11, $completion11);
        tmp11.x8_1 = Unit_instance;
        tmp11.y8_1 = null;
        return tmp11.d9();
    };
    protoOf(JsWebSocketSession$slambda).y9 = function(p111, $completion11) {
        return this.j3u((!(p111 == null) ? isInterface(p111, CoroutineScope) : false) ? p111 : THROW_CCE(), $completion11);
    };
    protoOf(JsWebSocketSession$slambda).d9 = function() {
        var suspendResult11 = this.x8_1;
        $sm: do try {
            var tmp11 = this.v8_1;
            switch(tmp11){
                case 0:
                    this.w8_1 = 10;
                    var tmp_011 = this;
                    tmp_011.f5r_1 = this.d5r_1.r5q_1;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    var tmp_141 = this;
                    tmp_141.h5r_1 = this.f5r_1;
                    this.i5r_1 = null;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.w8_1 = 9;
                    this.w8_1 = 8;
                    var tmp_211 = this;
                    tmp_211.k5r_1 = this.h5r_1;
                    this.l5r_1 = this.k5r_1.j();
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.v8_1 = 5;
                    suspendResult11 = this.l5r_1.w20(this);
                    if (suspendResult11 === get_COROUTINE_SUSPENDED()) return suspendResult11;
                    continue $sm;
                case 5:
                    if (!suspendResult11) {
                        this.v8_1 = 6;
                        continue $sm;
                    }
                    var e11 = this.l5r_1.l();
                    switch(e11.w4j_1.q2_1){
                        case 0:
                            var text11 = e11.x4j_1;
                            this.d5r_1.o5q_1.send(String_0(text11));
                            break;
                        case 1:
                            var tmp_311 = e11.x4j_1;
                            var source11 = tmp_311 instanceof Int8Array ? tmp_311 : THROW_CCE();
                            var frameData11 = source11.buffer.slice(source11.byteOffset, source11.byteOffset + source11.byteLength | 0);
                            this.d5r_1.o5q_1.send(frameData11);
                            break;
                        case 2:
                            var tmp$ret$011;
                            l$ret$1: do {
                                var builder11 = new BytePacketBuilder();
                                try {
                                    writeFully_0(builder11, e11.x4j_1);
                                    tmp$ret$011 = builder11.c3r();
                                    break l$ret$1;
                                } catch ($p11) {
                                    if ($p11 instanceof Error) {
                                        var t11 = $p11;
                                        builder11.e19();
                                        throw t11;
                                    } else throw $p11;
                                }
                            }while (false);
                            var data11 = tmp$ret$011;
                            var code11 = readShort(data11);
                            var reason11 = data11.p3x();
                            this.d5r_1.p5q_1.p1s(new CloseReason(code11, reason11));
                            if (isReservedStatusCode(code11, this.d5r_1)) this.d5r_1.o5q_1.close();
                            else this.d5r_1.o5q_1.close(code11, reason11);
                            break;
                        case 3:
                        case 4:
                            break;
                    }
                    this.v8_1 = 4;
                    continue $sm;
                case 6:
                    this.j5r_1 = Unit_instance;
                    this.w8_1 = 10;
                    this.v8_1 = 7;
                    var tmp_411 = this;
                    continue $sm;
                case 7:
                    this.w8_1 = 10;
                    var tmp_511 = this;
                    cancelConsumed(this.h5r_1, this.i5r_1);
                    tmp_511.g5r_1 = Unit_instance;
                    this.v8_1 = 12;
                    continue $sm;
                case 8:
                    this.w8_1 = 9;
                    var tmp_611 = this.y8_1;
                    if (tmp_611 instanceof Error) {
                        var e_011 = this.y8_1;
                        var tmp_711 = this;
                        this.i5r_1 = e_011;
                        throw e_011;
                    } else throw this.y8_1;
                case 9:
                    this.w8_1 = 10;
                    var t_011 = this.y8_1;
                    cancelConsumed(this.h5r_1, this.i5r_1);
                    throw t_011;
                case 10:
                    throw this.y8_1;
                case 11:
                    this.w8_1 = 10;
                    cancelConsumed(this.h5r_1, this.i5r_1);
                    this.v8_1 = 12;
                    continue $sm;
                case 12:
                    return Unit_instance;
            }
        } catch ($p11) {
            var e_111 = $p11;
            if (this.w8_1 === 10) throw e_111;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e_111;
            }
        }
        while (true);
    };
    protoOf(JsWebSocketSession$slambda).e2b = function($this$launch11, completion11) {
        var i11 = new JsWebSocketSession$slambda(this.d5r_1, completion11);
        i11.e5r_1 = $this$launch11;
        return i11;
    };
    function JsWebSocketSession$slambda_0(this$011, resultContinuation11) {
        var i11 = new JsWebSocketSession$slambda(this$011, resultContinuation11);
        var l11 = function($this$launch11, $completion11) {
            return i11.j3u($this$launch11, $completion11);
        };
        l11.$arity = 1;
        return l11;
    }
    function JsWebSocketSession$lambda_2(this$011) {
        return function(cause11) {
            var tmp11;
            if (cause11 == null) {
                this$011.o5q_1.close();
                tmp11 = Unit_instance;
            } else {
                this$011.o5q_1.close(Codes_NORMAL_getInstance().h4j_1, "Client failed");
                tmp11 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function JsWebSocketSession(coroutineContext11, websocket11) {
        this.n5q_1 = coroutineContext11;
        this.o5q_1 = websocket11;
        this.p5q_1 = CompletableDeferred();
        this.q5q_1 = Channel(2147483647);
        this.r5q_1 = Channel(2147483647);
        this.s5q_1 = this.q5q_1;
        this.t5q_1 = this.r5q_1;
        this.u5q_1 = this.p5q_1;
        // Inline function 'org.w3c.dom.ARRAYBUFFER' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$211 = "arraybuffer";
        this.o5q_1.binaryType = tmp$ret$211;
        this.o5q_1.addEventListener("message", JsWebSocketSession$lambda(this));
        this.o5q_1.addEventListener("error", JsWebSocketSession$lambda_0(this));
        this.o5q_1.addEventListener("close", JsWebSocketSession$lambda_1(this));
        launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
        var tmp0_safe_receiver11 = this.n5q_1.i9(Key_instance);
        if (tmp0_safe_receiver11 == null) ;
        else tmp0_safe_receiver11.w1n(JsWebSocketSession$lambda_2(this));
    }
    protoOf(JsWebSocketSession).v1m = function() {
        return this.n5q_1;
    };
    function unwrapCancellationException(_this__u8e3s411) {
        var exception11 = _this__u8e3s411;
        $l$loop: while(exception11 instanceof CancellationException){
            if (equals(exception11, exception11.cause)) return _this__u8e3s411;
            exception11 = exception11.cause;
        }
        var tmp0_elvis_lhs11 = exception11;
        return tmp0_elvis_lhs11 == null ? _this__u8e3s411 : tmp0_elvis_lhs11;
    }
    //region block: post-declaration
    defineProp(protoOf(DoubleReceiveException), "message", function() {
        return this.l9();
    });
    defineProp(protoOf(NoTransformationFoundException), "message", function() {
        return this.l9();
    });
    defineProp(protoOf(ClientEngineClosedException), "cause", function() {
        return this.m9();
    });
    protoOf(HttpClientEngineBase).r4y = get_supportedCapabilities;
    protoOf(HttpClientEngineBase).b4u = install;
    protoOf(KtorCallContextElement).i9 = get;
    protoOf(KtorCallContextElement).uf = fold;
    protoOf(KtorCallContextElement).tf = minusKey;
    protoOf(KtorCallContextElement).vf = plus;
    defineProp(protoOf(RedirectResponseException), "message", function() {
        return this.l9();
    });
    defineProp(protoOf(ClientRequestException), "message", function() {
        return this.l9();
    });
    defineProp(protoOf(ServerResponseException), "message", function() {
        return this.l9();
    });
    protoOf(HttpRequest$1).v1m = get_coroutineContext;
    protoOf(Js).y4z = create$default;
    //endregion
    //region block: init
    Companion_instance_1 = new Companion_0();
    RequestHook_instance = new RequestHook();
    WebSocketCapability_instance = new WebSocketCapability();
    Companion_instance_4 = new Companion_3();
    Js_instance = new Js();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = submitForm;
    _.$_$.b = Js_instance;
    _.$_$.c = Plugin_getInstance_3;
    _.$_$.d = Phases_getInstance;
    _.$_$.e = Phases_getInstance_1;
    _.$_$.f = EmptyContent_getInstance;
    _.$_$.g = install;
    _.$_$.h = get_supportedCapabilities;
    _.$_$.i = HttpClientEngine;
    _.$_$.j = OnRequestContext;
    _.$_$.k = createClientPlugin;
    _.$_$.l = HttpClientPlugin;
    _.$_$.m = Sender;
    _.$_$.n = plugin;
    _.$_$.o = HttpRequestBuilder;
    _.$_$.p = accept;
    _.$_$.q = header;
    _.$_$.r = set_port;
    _.$_$.s = url;
    _.$_$.t = HttpResponseContainer;
    _.$_$.u = HttpStatement;
    _.$_$.v = HttpClient_0;
    _.$_$.w = HttpClient_2;
    //endregion
    return _;
});

});
parcelRegister("adZDH", function(module, exports) {


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./ktor-ktor-utils.js",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("cL6ZK")), (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_io_ktor_ktor_utils, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var LockFreeLinkedListNode = kotlin_io_ktor_ktor_utils.$_$.f;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var VOID = kotlin_kotlin.$_$.f;
    var CopyOnWriteHashMap = kotlin_io_ktor_ktor_utils.$_$.d;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var equals = kotlin_kotlin.$_$.ba;
    var addSuppressed = kotlin_kotlin.$_$.gf;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var protoOf = kotlin_kotlin.$_$.kb;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(HandlerRegistration, "HandlerRegistration", VOID, LockFreeLinkedListNode);
    initMetadataForClass(Events, "Events", Events);
    initMetadataForClass(EventDefinition, "EventDefinition", EventDefinition);
    //endregion
    function HandlerRegistration() {}
    function Events() {
        this.d4r_1 = new CopyOnWriteHashMap();
    }
    protoOf(Events).e4r = function(definition, value) {
        var exception = null;
        var tmp0_safe_receiver = this.d4r_1.c44(definition);
        if (tmp0_safe_receiver == null) ;
        else {
            // Inline function 'io.ktor.util.internal.LockFreeLinkedListHead.forEach' call
            var tmp = tmp0_safe_receiver.z1y();
            var cur = tmp instanceof LockFreeLinkedListNode ? tmp : THROW_CCE();
            while(!equals(cur, tmp0_safe_receiver)){
                if (cur instanceof HandlerRegistration) {
                    // Inline function 'io.ktor.events.Events.raise.<anonymous>' call
                    var registration = cur;
                    try {
                        var tmp_0 = registration.g4r_1;
                        (typeof tmp_0 === "function" ? tmp_0 : THROW_CCE())(value);
                    } catch ($p) {
                        if ($p instanceof Error) {
                            var e = $p;
                            var tmp0_safe_receiver_0 = exception;
                            var tmp_1;
                            if (tmp0_safe_receiver_0 == null) tmp_1 = null;
                            else {
                                addSuppressed(tmp0_safe_receiver_0, e);
                                tmp_1 = Unit_instance;
                            }
                            if (tmp_1 == null) // Inline function 'kotlin.run' call
                            // Inline function 'kotlin.contracts.contract' call
                            exception = e;
                        } else throw $p;
                    }
                }
                cur = cur.x44();
            }
        }
        var tmp1_safe_receiver = exception;
        if (tmp1_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        throw tmp1_safe_receiver;
    };
    function EventDefinition() {}
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = EventDefinition;
    _.$_$.b = Events;
    //endregion
    return _;
});

});

parcelRegister("4fxpJ", function(module, exports) {



(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-io.js",
        "./ktor-ktor-utils.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("4cHl4")), (parcelRequire("cL6ZK")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_utils) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var VOID = kotlin_kotlin.$_$.f;
    var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.h1;
    var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
    var encode = kotlin_io_ktor_ktor_io.$_$.k;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var prepareReadFirstHead = kotlin_io_ktor_ktor_io.$_$.n;
    var prepareReadNextHead = kotlin_io_ktor_ktor_io.$_$.o;
    var completeReadHead = kotlin_io_ktor_ktor_io.$_$.m;
    var charArray = kotlin_kotlin.$_$.v9;
    var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
    var concatToString = kotlin_kotlin.$_$.ic;
    var charSequenceGet = kotlin_kotlin.$_$.w9;
    var toString = kotlin_kotlin.$_$.ob;
    var Char = kotlin_kotlin.$_$.ee;
    var isSurrogate = kotlin_kotlin.$_$.yc;
    var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v2;
    var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.u2;
    var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.g1;
    var charSequenceLength = kotlin_kotlin.$_$.x9;
    var charSequenceSubSequence = kotlin_kotlin.$_$.y9;
    var toString_0 = kotlin_kotlin.$_$.y2;
    var toByte = kotlin_kotlin.$_$.lb;
    var String_0 = kotlin_io_ktor_ktor_io.$_$.s;
    var Exception = kotlin_kotlin.$_$.ke;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.m1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var Char__minus_impl_a2frrh_0 = kotlin_kotlin.$_$.t2;
    var numberToChar = kotlin_kotlin.$_$.hb;
    var Char__rangeTo_impl_tkncvp = kotlin_kotlin.$_$.w2;
    var plus = kotlin_kotlin.$_$.u7;
    var plus_0 = kotlin_kotlin.$_$.v7;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x2;
    var toSet = kotlin_kotlin.$_$.r8;
    var setOf = kotlin_kotlin.$_$.c8;
    var plus_1 = kotlin_kotlin.$_$.t7;
    var listOf = kotlin_kotlin.$_$.o7;
    var emptyList = kotlin_kotlin.$_$.r6;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var equals = kotlin_kotlin.$_$.pc;
    var Collection = kotlin_kotlin.$_$.j5;
    var isInterface = kotlin_kotlin.$_$.xa;
    var isBlank = kotlin_kotlin.$_$.uc;
    var last = kotlin_kotlin.$_$.m7;
    var indexOf = kotlin_kotlin.$_$.tc;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var isCharSequence = kotlin_kotlin.$_$.ta;
    var trim = kotlin_kotlin.$_$.ae;
    var contains = kotlin_kotlin.$_$.kc;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var plus_2 = kotlin_kotlin.$_$.w7;
    var equals_0 = kotlin_kotlin.$_$.ba;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var hashCode = kotlin_kotlin.$_$.ha;
    var Companion_instance = kotlin_io_ktor_ktor_io.$_$.e;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var get_name = kotlin_io_ktor_ktor_io.$_$.l;
    var get_lastIndex = kotlin_kotlin.$_$.j7;
    var first = kotlin_kotlin.$_$.qc;
    var last_0 = kotlin_kotlin.$_$.cd;
    var get_lastIndex_0 = kotlin_kotlin.$_$.ad;
    var StringValuesBuilderImpl = kotlin_io_ktor_ktor_utils.$_$.r;
    var emptySet = kotlin_kotlin.$_$.t6;
    var get = kotlin_io_ktor_ktor_utils.$_$.q;
    var forEach = kotlin_io_ktor_ktor_utils.$_$.p;
    var StringValues = kotlin_io_ktor_ktor_utils.$_$.t;
    var StringValuesImpl = kotlin_io_ktor_ktor_utils.$_$.s;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var toDoubleOrNull = kotlin_kotlin.$_$.md;
    var LazyThreadSafetyMode_NONE_getInstance = kotlin_kotlin.$_$.i;
    var lazy = kotlin_kotlin.$_$.pf;
    var to = kotlin_kotlin.$_$.wf;
    var sortedWith = kotlin_kotlin.$_$.g8;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var compareValues = kotlin_kotlin.$_$.x8;
    var asList = kotlin_kotlin.$_$.x5;
    var Char__compareTo_impl_ypi4mb = kotlin_kotlin.$_$.s2;
    var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.s1;
    var toLong = kotlin_kotlin.$_$.rd;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
    var Comparable = kotlin_kotlin.$_$.fe;
    var addAll = kotlin_kotlin.$_$.w5;
    var joinTo = kotlin_kotlin.$_$.h7;
    var toString_1 = kotlin_kotlin.$_$.vf;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var isWhitespace = kotlin_kotlin.$_$.zc;
    var startsWith = kotlin_kotlin.$_$.id;
    var charArrayOf = kotlin_kotlin.$_$.u9;
    var split = kotlin_kotlin.$_$.fd;
    var toMutableList = kotlin_kotlin.$_$.o8;
    var first_0 = kotlin_kotlin.$_$.x6;
    var joinToString = kotlin_kotlin.$_$.g7;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var toCharArray = kotlin_io_ktor_ktor_utils.$_$.y;
    var indexOfAny = kotlin_kotlin.$_$.rc;
    var dropLast = kotlin_kotlin.$_$.p6;
    var IllegalStateException = kotlin_kotlin.$_$.me;
    var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.z1;
    var indexOf_0 = kotlin_kotlin.$_$.sc;
    var toInt = kotlin_kotlin.$_$.pd;
    var listOf_0 = kotlin_kotlin.$_$.n7;
    var toLowerCasePreservingASCIIRules = kotlin_io_ktor_ktor_utils.$_$.z;
    var isLowerCase = kotlin_io_ktor_ktor_utils.$_$.v;
    var appendAll = kotlin_io_ktor_ktor_utils.$_$.u;
    var startsWith_0 = kotlin_kotlin.$_$.hd;
    var lazy_0 = kotlin_kotlin.$_$.qf;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var toLong_0 = kotlin_kotlin.$_$.mb;
    var encodeToByteArray = kotlin_kotlin.$_$.nc;
    var encodeToByteArray_0 = kotlin_io_ktor_ktor_io.$_$.j;
    var take = kotlin_kotlin.$_$.jd;
    var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.c;
    var get_platform = kotlin_io_ktor_ktor_utils.$_$.w;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(URLDecodeException, "URLDecodeException", VOID, Exception);
    initMetadataForCompanion(Companion);
    initMetadataForObject(Application, "Application");
    initMetadataForObject(Text, "Text");
    initMetadataForClass(HeaderValueWithParameters, "HeaderValueWithParameters");
    initMetadataForClass(ContentType, "ContentType", VOID, HeaderValueWithParameters);
    initMetadataForClass(BadContentTypeFormatException, "BadContentTypeFormatException", VOID, Exception);
    initMetadataForCompanion(Companion_0);
    initMetadataForCompanion(Companion_1);
    initMetadataForClass(HeadersBuilder, "HeadersBuilder", HeadersBuilder, StringValuesBuilderImpl);
    initMetadataForObject(EmptyHeaders, "EmptyHeaders", VOID, VOID, [
        StringValues
    ]);
    initMetadataForClass(HeadersImpl, "HeadersImpl", HeadersImpl, StringValuesImpl, [
        StringValues,
        StringValuesImpl
    ]);
    initMetadataForClass(HeaderValueParam, "HeaderValueParam");
    initMetadataForClass(HeaderValue, "HeaderValue");
    initMetadataForClass(sam$kotlin_Comparator$0, "sam$kotlin_Comparator$0");
    initMetadataForObject(HttpHeaders, "HttpHeaders");
    initMetadataForClass(IllegalHeaderNameException, "IllegalHeaderNameException", VOID, IllegalArgumentException);
    initMetadataForClass(IllegalHeaderValueException, "IllegalHeaderValueException", VOID, IllegalArgumentException);
    initMetadataForClass(UnsafeHeaderException, "UnsafeHeaderException", VOID, IllegalArgumentException);
    initMetadataForCompanion(Companion_2);
    initMetadataForClass(HttpMethod, "HttpMethod");
    initMetadataForCompanion(Companion_3);
    initMetadataForClass(HttpProtocolVersion, "HttpProtocolVersion");
    initMetadataForCompanion(Companion_4);
    initMetadataForClass(HttpStatusCode, "HttpStatusCode", VOID, VOID, [
        Comparable
    ]);
    initMetadataForCompanion(Companion_5);
    initMetadataForInterface(Parameters, "Parameters", VOID, VOID, [
        StringValues
    ]);
    initMetadataForObject(EmptyParameters, "EmptyParameters", VOID, VOID, [
        Parameters
    ]);
    initMetadataForClass(ParametersBuilderImpl, "ParametersBuilderImpl", ParametersBuilderImpl, StringValuesBuilderImpl);
    initMetadataForClass(ParametersImpl, "ParametersImpl", ParametersImpl, StringValuesImpl, [
        Parameters,
        StringValuesImpl
    ]);
    initMetadataForCompanion(Companion_6);
    initMetadataForClass(URLBuilder, "URLBuilder", URLBuilder);
    initMetadataForClass(URLParserException, "URLParserException", VOID, IllegalStateException);
    initMetadataForCompanion(Companion_7);
    initMetadataForClass(URLProtocol, "URLProtocol");
    initMetadataForCompanion(Companion_8);
    initMetadataForClass(Url_0, "Url");
    initMetadataForClass(UrlDecodedParametersBuilder, "UrlDecodedParametersBuilder");
    initMetadataForClass(OutgoingContent, "OutgoingContent");
    initMetadataForClass(ByteArrayContent_0, "ByteArrayContent", VOID, OutgoingContent);
    initMetadataForClass(ByteArrayContent, "ByteArrayContent", VOID, ByteArrayContent_0);
    initMetadataForClass(NoContent, "NoContent", VOID, OutgoingContent);
    initMetadataForClass(ReadChannelContent, "ReadChannelContent", VOID, OutgoingContent);
    initMetadataForClass(WriteChannelContent, "WriteChannelContent", VOID, OutgoingContent, VOID, [
        1
    ]);
    initMetadataForClass(ProtocolUpgrade, "ProtocolUpgrade", VOID, OutgoingContent, VOID, [
        4
    ]);
    initMetadataForObject(NullBody, "NullBody");
    initMetadataForClass(TextContent, "TextContent", VOID, ByteArrayContent_0);
    //endregion
    function get_URL_ALPHABET() {
        _init_properties_Codecs_kt__fudxxf();
        return URL_ALPHABET;
    }
    var URL_ALPHABET;
    function get_URL_ALPHABET_CHARS() {
        _init_properties_Codecs_kt__fudxxf();
        return URL_ALPHABET_CHARS;
    }
    var URL_ALPHABET_CHARS;
    function get_HEX_ALPHABET() {
        _init_properties_Codecs_kt__fudxxf();
        return HEX_ALPHABET;
    }
    var HEX_ALPHABET;
    function get_URL_PROTOCOL_PART() {
        _init_properties_Codecs_kt__fudxxf();
        return URL_PROTOCOL_PART;
    }
    var URL_PROTOCOL_PART;
    function get_VALID_PATH_PART() {
        _init_properties_Codecs_kt__fudxxf();
        return VALID_PATH_PART;
    }
    var VALID_PATH_PART;
    var ATTRIBUTE_CHARACTERS;
    function get_SPECIAL_SYMBOLS() {
        _init_properties_Codecs_kt__fudxxf();
        return SPECIAL_SYMBOLS;
    }
    var SPECIAL_SYMBOLS;
    function encodeURLParameter(_this__u8e3s4, spaceToPlus) {
        spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
        _init_properties_Codecs_kt__fudxxf();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.encodeURLParameter.<anonymous>' call
        var content = encode(Charsets_getInstance().y3x_1.c3y(), _this__u8e3s4);
        forEach_0(content, encodeURLParameter$lambda(this_0, spaceToPlus));
        return this_0.toString();
    }
    function decodeURLPart(_this__u8e3s4, start, end, charset) {
        start = start === VOID ? 0 : start;
        end = end === VOID ? _this__u8e3s4.length : end;
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        _init_properties_Codecs_kt__fudxxf();
        return decodeScan(_this__u8e3s4, start, end, false, charset);
    }
    function encodeURLQueryComponent(_this__u8e3s4, encodeFull, spaceToPlus, charset) {
        encodeFull = encodeFull === VOID ? false : encodeFull;
        spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        _init_properties_Codecs_kt__fudxxf();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.encodeURLQueryComponent.<anonymous>' call
        var content = encode(charset.c3y(), _this__u8e3s4);
        forEach_0(content, encodeURLQueryComponent$lambda(spaceToPlus, this_0, encodeFull));
        return this_0.toString();
    }
    function decodeURLQueryComponent(_this__u8e3s4, start, end, plusIsSpace, charset) {
        start = start === VOID ? 0 : start;
        end = end === VOID ? _this__u8e3s4.length : end;
        plusIsSpace = plusIsSpace === VOID ? false : plusIsSpace;
        charset = charset === VOID ? Charsets_getInstance().y3x_1 : charset;
        _init_properties_Codecs_kt__fudxxf();
        return decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset);
    }
    function encodeURLPathPart(_this__u8e3s4) {
        _init_properties_Codecs_kt__fudxxf();
        return encodeURLPath_0(_this__u8e3s4, true);
    }
    function encodeURLPath(_this__u8e3s4) {
        _init_properties_Codecs_kt__fudxxf();
        return encodeURLPath_0(_this__u8e3s4, false);
    }
    function encodeURLParameterValue(_this__u8e3s4) {
        _init_properties_Codecs_kt__fudxxf();
        return encodeURLParameter(_this__u8e3s4, true);
    }
    function forEach_0(_this__u8e3s4, block) {
        _init_properties_Codecs_kt__fudxxf();
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release = true;
            var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
            var tmp;
            if (tmp0_elvis_lhs == null) break $l$block;
            else tmp = tmp0_elvis_lhs;
            var current = tmp;
            try {
                $l$loop_1: for(;;){
                    // Inline function 'io.ktor.http.forEach.<anonymous>' call
                    var buffer = current;
                    $l$loop: while(true){
                        // Inline function 'io.ktor.utils.io.core.canRead' call
                        if (!(buffer.l3p_1 > buffer.k3p_1)) break $l$loop;
                        block(buffer.c3v());
                    }
                    release = false;
                    var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
                    var tmp_0;
                    if (tmp1_elvis_lhs == null) break $l$loop_1;
                    else tmp_0 = tmp1_elvis_lhs;
                    var next = tmp_0;
                    current = next;
                    release = true;
                }
            } finally{
                if (release) completeReadHead(_this__u8e3s4, current);
            }
        }
    }
    function percentEncode(_this__u8e3s4) {
        _init_properties_Codecs_kt__fudxxf();
        var code = _this__u8e3s4 & 255;
        var array = charArray(3);
        array[0] = _Char___init__impl__6a9atx(37);
        array[1] = hexDigitToChar(code >> 4);
        array[2] = hexDigitToChar(code & 15);
        return concatToString(array);
    }
    function decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset) {
        _init_properties_Codecs_kt__fudxxf();
        var inductionVariable = start;
        if (inductionVariable < end) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ch = charSequenceGet(_this__u8e3s4, index);
            if (ch === _Char___init__impl__6a9atx(37) || plusIsSpace && ch === _Char___init__impl__6a9atx(43)) return decodeImpl(_this__u8e3s4, start, end, index, plusIsSpace, charset);
        }while (inductionVariable < end);
        var tmp;
        if (start === 0 && end === _this__u8e3s4.length) tmp = toString(_this__u8e3s4);
        else // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = _this__u8e3s4.substring(start, end);
        return tmp;
    }
    function encodeURLPath_0(_this__u8e3s4, encodeSlash) {
        _init_properties_Codecs_kt__fudxxf();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.encodeURLPath.<anonymous>' call
        var charset = Charsets_getInstance().y3x_1;
        var index = 0;
        $l$loop_0: while(index < _this__u8e3s4.length){
            var current = charSequenceGet(_this__u8e3s4, index);
            if (!encodeSlash && current === _Char___init__impl__6a9atx(47) || get_URL_ALPHABET_CHARS().a2(new Char(current)) || get_VALID_PATH_PART().a2(new Char(current))) {
                this_0.f8(current);
                index = index + 1 | 0;
                continue $l$loop_0;
            }
            if (current === _Char___init__impl__6a9atx(37) && (index + 2 | 0) < _this__u8e3s4.length && get_HEX_ALPHABET().a2(new Char(charSequenceGet(_this__u8e3s4, index + 1 | 0))) && get_HEX_ALPHABET().a2(new Char(charSequenceGet(_this__u8e3s4, index + 2 | 0)))) {
                this_0.f8(current);
                this_0.f8(charSequenceGet(_this__u8e3s4, index + 1 | 0));
                this_0.f8(charSequenceGet(_this__u8e3s4, index + 2 | 0));
                index = index + 3 | 0;
                continue $l$loop_0;
            }
            var symbolSize = isSurrogate(current) ? 2 : 1;
            var tmp = encode(charset.c3y(), _this__u8e3s4, index, index + symbolSize | 0);
            forEach_0(tmp, encodeURLPath$lambda(this_0));
            index = index + symbolSize | 0;
        }
        return this_0.toString();
    }
    function hexDigitToChar(digit) {
        _init_properties_Codecs_kt__fudxxf();
        return (0 <= digit ? digit <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), digit) : Char__minus_impl_a2frrh(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), digit), 10);
    }
    function decodeImpl(_this__u8e3s4, start, end, prefixEnd, plusIsSpace, charset) {
        _init_properties_Codecs_kt__fudxxf();
        var length = end - start | 0;
        var sbSize = length > 255 ? length / 3 | 0 : length;
        var sb = StringBuilder_init_$Create$_0(sbSize);
        if (prefixEnd > start) sb.qb(_this__u8e3s4, start, prefixEnd);
        var index = prefixEnd;
        var bytes = null;
        while(index < end){
            var c = charSequenceGet(_this__u8e3s4, index);
            if (plusIsSpace && c === _Char___init__impl__6a9atx(43)) {
                sb.f8(_Char___init__impl__6a9atx(32));
                index = index + 1 | 0;
            } else if (c === _Char___init__impl__6a9atx(37)) {
                if (bytes == null) bytes = new Int8Array((end - index | 0) / 3 | 0);
                var count = 0;
                while(index < end && charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(37)){
                    if ((index + 2 | 0) >= end) {
                        // Inline function 'kotlin.text.substring' call
                        var startIndex = index;
                        var endIndex = charSequenceLength(_this__u8e3s4);
                        var tmp$ret$0 = toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
                        throw new URLDecodeException("Incomplete trailing HEX escape: " + tmp$ret$0 + ", in " + toString(_this__u8e3s4) + " at " + index);
                    }
                    var digit1 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 1 | 0));
                    var digit2 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 2 | 0));
                    if (digit1 === -1 || digit2 === -1) throw new URLDecodeException("Wrong HEX escape: %" + toString_0(charSequenceGet(_this__u8e3s4, index + 1 | 0)) + toString_0(charSequenceGet(_this__u8e3s4, index + 2 | 0)) + ", in " + toString(_this__u8e3s4) + ", at " + index);
                    var tmp = bytes;
                    var tmp1 = count;
                    count = tmp1 + 1 | 0;
                    tmp[tmp1] = toByte(imul(digit1, 16) + digit2 | 0);
                    index = index + 3 | 0;
                }
                sb.e8(String_0(bytes, 0, count, charset));
            } else {
                sb.f8(c);
                index = index + 1 | 0;
            }
        }
        return sb.toString();
    }
    function URLDecodeException(message) {
        Exception_init_$Init$(message, this);
        captureStack(this, URLDecodeException);
    }
    function charToHexDigit(c2) {
        _init_properties_Codecs_kt__fudxxf();
        return (_Char___init__impl__6a9atx(48) <= c2 ? c2 <= _Char___init__impl__6a9atx(57) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(48)) : (_Char___init__impl__6a9atx(65) <= c2 ? c2 <= _Char___init__impl__6a9atx(70) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(65)) + 10 | 0 : (_Char___init__impl__6a9atx(97) <= c2 ? c2 <= _Char___init__impl__6a9atx(102) : false) ? Char__minus_impl_a2frrh_0(c2, _Char___init__impl__6a9atx(97)) + 10 | 0 : -1;
    }
    function encodeURLParameter$lambda($$this$buildString, $spaceToPlus) {
        return function(it) {
            var tmp;
            if (get_URL_ALPHABET().a2(it) || get_SPECIAL_SYMBOLS().a2(it)) {
                $$this$buildString.f8(numberToChar(it));
                tmp = Unit_instance;
            } else if ($spaceToPlus && it === 32) {
                $$this$buildString.f8(_Char___init__impl__6a9atx(43));
                tmp = Unit_instance;
            } else {
                $$this$buildString.e8(percentEncode(it));
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function encodeURLQueryComponent$lambda($spaceToPlus, $$this$buildString, $encodeFull) {
        return function(it) {
            var tmp;
            if (it === 32) {
                var tmp_0;
                if ($spaceToPlus) {
                    $$this$buildString.f8(_Char___init__impl__6a9atx(43));
                    tmp_0 = Unit_instance;
                } else {
                    $$this$buildString.e8("%20");
                    tmp_0 = Unit_instance;
                }
                tmp = tmp_0;
            } else if (get_URL_ALPHABET().a2(it) || !$encodeFull && get_URL_PROTOCOL_PART().a2(it)) {
                $$this$buildString.f8(numberToChar(it));
                tmp = Unit_instance;
            } else {
                $$this$buildString.e8(percentEncode(it));
                tmp = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function encodeURLPath$lambda($$this$buildString) {
        return function(it) {
            $$this$buildString.e8(percentEncode(it));
            return Unit_instance;
        };
    }
    var properties_initialized_Codecs_kt_hkj9s1;
    function _init_properties_Codecs_kt__fudxxf() {
        if (!properties_initialized_Codecs_kt_hkj9s1) {
            properties_initialized_Codecs_kt_hkj9s1 = true;
            // Inline function 'kotlin.collections.map' call
            var this_0 = plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.ktor.http.URL_ALPHABET.<anonymous>' call
                // Inline function 'kotlin.code' call
                var this_1 = item.o1_1;
                var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
                var tmp$ret$1 = toByte(tmp$ret$0);
                destination.e(tmp$ret$1);
            }
            URL_ALPHABET = toSet(destination);
            URL_ALPHABET_CHARS = toSet(plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
            HEX_ALPHABET = toSet(plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
            // Inline function 'kotlin.collections.map' call
            var this_2 = setOf([
                new Char(_Char___init__impl__6a9atx(58)),
                new Char(_Char___init__impl__6a9atx(47)),
                new Char(_Char___init__impl__6a9atx(63)),
                new Char(_Char___init__impl__6a9atx(35)),
                new Char(_Char___init__impl__6a9atx(91)),
                new Char(_Char___init__impl__6a9atx(93)),
                new Char(_Char___init__impl__6a9atx(64)),
                new Char(_Char___init__impl__6a9atx(33)),
                new Char(_Char___init__impl__6a9atx(36)),
                new Char(_Char___init__impl__6a9atx(38)),
                new Char(_Char___init__impl__6a9atx(39)),
                new Char(_Char___init__impl__6a9atx(40)),
                new Char(_Char___init__impl__6a9atx(41)),
                new Char(_Char___init__impl__6a9atx(42)),
                new Char(_Char___init__impl__6a9atx(44)),
                new Char(_Char___init__impl__6a9atx(59)),
                new Char(_Char___init__impl__6a9atx(61)),
                new Char(_Char___init__impl__6a9atx(45)),
                new Char(_Char___init__impl__6a9atx(46)),
                new Char(_Char___init__impl__6a9atx(95)),
                new Char(_Char___init__impl__6a9atx(126)),
                new Char(_Char___init__impl__6a9atx(43))
            ]);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
            var tmp0_iterator_0 = this_2.j();
            while(tmp0_iterator_0.k()){
                var item_0 = tmp0_iterator_0.l();
                // Inline function 'io.ktor.http.URL_PROTOCOL_PART.<anonymous>' call
                // Inline function 'kotlin.code' call
                var this_3 = item_0.o1_1;
                var tmp$ret$0_0 = Char__toInt_impl_vasixd(this_3);
                var tmp$ret$1_0 = toByte(tmp$ret$0_0);
                destination_0.e(tmp$ret$1_0);
            }
            URL_PROTOCOL_PART = destination_0;
            VALID_PATH_PART = setOf([
                new Char(_Char___init__impl__6a9atx(58)),
                new Char(_Char___init__impl__6a9atx(64)),
                new Char(_Char___init__impl__6a9atx(33)),
                new Char(_Char___init__impl__6a9atx(36)),
                new Char(_Char___init__impl__6a9atx(38)),
                new Char(_Char___init__impl__6a9atx(39)),
                new Char(_Char___init__impl__6a9atx(40)),
                new Char(_Char___init__impl__6a9atx(41)),
                new Char(_Char___init__impl__6a9atx(42)),
                new Char(_Char___init__impl__6a9atx(43)),
                new Char(_Char___init__impl__6a9atx(44)),
                new Char(_Char___init__impl__6a9atx(59)),
                new Char(_Char___init__impl__6a9atx(61)),
                new Char(_Char___init__impl__6a9atx(45)),
                new Char(_Char___init__impl__6a9atx(46)),
                new Char(_Char___init__impl__6a9atx(95)),
                new Char(_Char___init__impl__6a9atx(126))
            ]);
            ATTRIBUTE_CHARACTERS = plus_1(get_URL_ALPHABET_CHARS(), setOf([
                new Char(_Char___init__impl__6a9atx(33)),
                new Char(_Char___init__impl__6a9atx(35)),
                new Char(_Char___init__impl__6a9atx(36)),
                new Char(_Char___init__impl__6a9atx(38)),
                new Char(_Char___init__impl__6a9atx(43)),
                new Char(_Char___init__impl__6a9atx(45)),
                new Char(_Char___init__impl__6a9atx(46)),
                new Char(_Char___init__impl__6a9atx(94)),
                new Char(_Char___init__impl__6a9atx(95)),
                new Char(_Char___init__impl__6a9atx(96)),
                new Char(_Char___init__impl__6a9atx(124)),
                new Char(_Char___init__impl__6a9atx(126))
            ]));
            // Inline function 'kotlin.collections.map' call
            var this_4 = listOf([
                new Char(_Char___init__impl__6a9atx(45)),
                new Char(_Char___init__impl__6a9atx(46)),
                new Char(_Char___init__impl__6a9atx(95)),
                new Char(_Char___init__impl__6a9atx(126))
            ]);
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
            var tmp0_iterator_1 = this_4.j();
            while(tmp0_iterator_1.k()){
                var item_1 = tmp0_iterator_1.l();
                // Inline function 'io.ktor.http.SPECIAL_SYMBOLS.<anonymous>' call
                // Inline function 'kotlin.code' call
                var this_5 = item_1.o1_1;
                var tmp$ret$0_1 = Char__toInt_impl_vasixd(this_5);
                var tmp$ret$1_1 = toByte(tmp$ret$0_1);
                destination_1.e(tmp$ret$1_1);
            }
            SPECIAL_SYMBOLS = destination_1;
        }
    }
    function ContentType_init_$Init$(contentType, contentSubtype, parameters, $this) {
        parameters = parameters === VOID ? emptyList() : parameters;
        ContentType.call($this, contentType, contentSubtype, contentType + "/" + contentSubtype, parameters);
        return $this;
    }
    function ContentType_init_$Create$(contentType, contentSubtype, parameters) {
        return ContentType_init_$Init$(contentType, contentSubtype, parameters, objectCreate(protoOf(ContentType)));
    }
    function hasParameter($this, name, value) {
        var tmp;
        switch($this.m47_1.m()){
            case 0:
                tmp = false;
                break;
            case 1:
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.http.ContentType.hasParameter.<anonymous>' call
                var it = $this.m47_1.o(0);
                tmp = equals(it.n47_1, name, true) && equals(it.o47_1, value, true);
                break;
            default:
                var tmp$ret$2;
                $l$block_0: {
                    // Inline function 'kotlin.collections.any' call
                    var this_0 = $this.m47_1;
                    var tmp_0;
                    if (isInterface(this_0, Collection)) tmp_0 = this_0.s();
                    else tmp_0 = false;
                    if (tmp_0) {
                        tmp$ret$2 = false;
                        break $l$block_0;
                    }
                    var tmp0_iterator = this_0.j();
                    while(tmp0_iterator.k()){
                        var element = tmp0_iterator.l();
                        // Inline function 'io.ktor.http.ContentType.hasParameter.<anonymous>' call
                        if (equals(element.n47_1, name, true) && equals(element.o47_1, value, true)) {
                            tmp$ret$2 = true;
                            break $l$block_0;
                        }
                    }
                    tmp$ret$2 = false;
                }
                tmp = tmp$ret$2;
                break;
        }
        return tmp;
    }
    function Companion() {
        Companion_instance_0 = this;
        this.q47_1 = ContentType_init_$Create$("*", "*");
    }
    protoOf(Companion).a1m = function(value) {
        if (isBlank(value)) return this.q47_1;
        // Inline function 'io.ktor.http.Companion.parse' call
        var headerValue = last(parseHeaderValue(value));
        // Inline function 'io.ktor.http.Companion.parse.<anonymous>' call
        var parts = headerValue.r47_1;
        var parameters = headerValue.s47_1;
        var slash = indexOf(parts, _Char___init__impl__6a9atx(47));
        if (slash === -1) {
            // Inline function 'kotlin.text.trim' call
            if (toString(trim(isCharSequence(parts) ? parts : THROW_CCE())) === "*") return Companion_getInstance().q47_1;
            throw new BadContentTypeFormatException(value);
        }
        // Inline function 'kotlin.text.trim' call
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var this_0 = parts.substring(0, slash);
        var type = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(type) === 0) throw new BadContentTypeFormatException(value);
        // Inline function 'kotlin.text.trim' call
        // Inline function 'kotlin.text.substring' call
        var startIndex = slash + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var this_1 = parts.substring(startIndex);
        var subtype = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (contains(type, _Char___init__impl__6a9atx(32)) || contains(subtype, _Char___init__impl__6a9atx(32))) throw new BadContentTypeFormatException(value);
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(subtype) === 0) tmp = true;
        else tmp = contains(subtype, _Char___init__impl__6a9atx(47));
        if (tmp) throw new BadContentTypeFormatException(value);
        return ContentType_init_$Create$(type, subtype, parameters);
    };
    var Companion_instance_0;
    function Companion_getInstance() {
        if (Companion_instance_0 == null) new Companion();
        return Companion_instance_0;
    }
    function Application() {
        Application_instance = this;
        this.u47_1 = ContentType_init_$Create$("application", "*");
        this.v47_1 = ContentType_init_$Create$("application", "atom+xml");
        this.w47_1 = ContentType_init_$Create$("application", "cbor");
        this.x47_1 = ContentType_init_$Create$("application", "json");
        this.y47_1 = ContentType_init_$Create$("application", "hal+json");
        this.z47_1 = ContentType_init_$Create$("application", "javascript");
        this.a48_1 = ContentType_init_$Create$("application", "octet-stream");
        this.b48_1 = ContentType_init_$Create$("application", "rss+xml");
        this.c48_1 = ContentType_init_$Create$("application", "xml");
        this.d48_1 = ContentType_init_$Create$("application", "xml-dtd");
        this.e48_1 = ContentType_init_$Create$("application", "zip");
        this.f48_1 = ContentType_init_$Create$("application", "gzip");
        this.g48_1 = ContentType_init_$Create$("application", "x-www-form-urlencoded");
        this.h48_1 = ContentType_init_$Create$("application", "pdf");
        this.i48_1 = ContentType_init_$Create$("application", "vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        this.j48_1 = ContentType_init_$Create$("application", "vnd.openxmlformats-officedocument.wordprocessingml.document");
        this.k48_1 = ContentType_init_$Create$("application", "vnd.openxmlformats-officedocument.presentationml.presentation");
        this.l48_1 = ContentType_init_$Create$("application", "protobuf");
        this.m48_1 = ContentType_init_$Create$("application", "wasm");
        this.n48_1 = ContentType_init_$Create$("application", "problem+json");
        this.o48_1 = ContentType_init_$Create$("application", "problem+xml");
    }
    var Application_instance;
    function Application_getInstance() {
        if (Application_instance == null) new Application();
        return Application_instance;
    }
    function Text() {
        Text_instance = this;
        this.p48_1 = ContentType_init_$Create$("text", "*");
        this.q48_1 = ContentType_init_$Create$("text", "plain");
        this.r48_1 = ContentType_init_$Create$("text", "css");
        this.s48_1 = ContentType_init_$Create$("text", "csv");
        this.t48_1 = ContentType_init_$Create$("text", "html");
        this.u48_1 = ContentType_init_$Create$("text", "javascript");
        this.v48_1 = ContentType_init_$Create$("text", "vcard");
        this.w48_1 = ContentType_init_$Create$("text", "xml");
        this.x48_1 = ContentType_init_$Create$("text", "event-stream");
    }
    var Text_instance;
    function Text_getInstance() {
        if (Text_instance == null) new Text();
        return Text_instance;
    }
    function ContentType(contentType, contentSubtype, existingContent, parameters) {
        Companion_getInstance();
        parameters = parameters === VOID ? emptyList() : parameters;
        HeaderValueWithParameters.call(this, existingContent, parameters);
        this.a49_1 = contentType;
        this.b49_1 = contentSubtype;
    }
    protoOf(ContentType).c49 = function(name, value) {
        if (hasParameter(this, name, value)) return this;
        return new ContentType(this.a49_1, this.b49_1, this.l47_1, plus_2(this.m47_1, HeaderValueParam_init_$Create$(name, value)));
    };
    protoOf(ContentType).d49 = function() {
        return this.m47_1.s() ? this : ContentType_init_$Create$(this.a49_1, this.b49_1);
    };
    protoOf(ContentType).e49 = function(pattern) {
        if (!(pattern.a49_1 === "*") && !equals(pattern.a49_1, this.a49_1, true)) return false;
        if (!(pattern.b49_1 === "*") && !equals(pattern.b49_1, this.b49_1, true)) return false;
        var tmp0_iterator = pattern.m47_1.j();
        while(tmp0_iterator.k()){
            var tmp1_loop_parameter = tmp0_iterator.l();
            var patternName = tmp1_loop_parameter.ba();
            var patternValue = tmp1_loop_parameter.ca();
            var tmp;
            if (patternName === "*") {
                var tmp_0;
                if (patternValue === "*") tmp_0 = true;
                else {
                    var tmp$ret$0;
                    $l$block_0: {
                        // Inline function 'kotlin.collections.any' call
                        var this_0 = this.m47_1;
                        var tmp_1;
                        if (isInterface(this_0, Collection)) tmp_1 = this_0.s();
                        else tmp_1 = false;
                        if (tmp_1) {
                            tmp$ret$0 = false;
                            break $l$block_0;
                        }
                        var tmp0_iterator_0 = this_0.j();
                        while(tmp0_iterator_0.k()){
                            var element = tmp0_iterator_0.l();
                            // Inline function 'io.ktor.http.ContentType.match.<anonymous>' call
                            if (equals(element.o47_1, patternValue, true)) {
                                tmp$ret$0 = true;
                                break $l$block_0;
                            }
                        }
                        tmp$ret$0 = false;
                    }
                    tmp_0 = tmp$ret$0;
                }
                tmp = tmp_0;
            } else {
                var value = this.f49(patternName);
                tmp = patternValue === "*" ? !(value == null) : equals(value, patternValue, true);
            }
            var matches = tmp;
            if (!matches) return false;
        }
        return true;
    };
    protoOf(ContentType).equals = function(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ContentType) tmp_1 = equals(this.a49_1, other.a49_1, true);
        else tmp_1 = false;
        if (tmp_1) tmp_0 = equals(this.b49_1, other.b49_1, true);
        else tmp_0 = false;
        if (tmp_0) tmp = equals_0(this.m47_1, other.m47_1);
        else tmp = false;
        return tmp;
    };
    protoOf(ContentType).hashCode = function() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.a49_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$1);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = this.b49_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
        result = result + imul(31, hashCode(this.m47_1)) | 0;
        return result;
    };
    function BadContentTypeFormatException(value) {
        Exception_init_$Init$("Bad Content-Type format: " + value, this);
        captureStack(this, BadContentTypeFormatException);
    }
    function charset(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4.f49("charset");
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.http.charset.<anonymous>' call
            var tmp_0;
            try {
                tmp_0 = Companion_instance.a41(tmp0_safe_receiver);
            } catch ($p) {
                var tmp_1;
                if ($p instanceof IllegalArgumentException) {
                    var exception = $p;
                    tmp_1 = null;
                } else throw $p;
                tmp_0 = tmp_1;
            }
            tmp = tmp_0;
        }
        return tmp;
    }
    function withCharset(_this__u8e3s4, charset) {
        return _this__u8e3s4.c49("charset", get_name(charset));
    }
    function withCharsetIfNeeded(_this__u8e3s4, charset) {
        var tmp;
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        if (!(_this__u8e3s4.a49_1.toLowerCase() === "text")) tmp = _this__u8e3s4;
        else tmp = _this__u8e3s4.c49("charset", get_name(charset));
        return tmp;
    }
    function get_HeaderFieldValueSeparators() {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        return HeaderFieldValueSeparators;
    }
    var HeaderFieldValueSeparators;
    function Companion_0() {}
    var Companion_instance_1;
    function Companion_getInstance_0() {
        return Companion_instance_1;
    }
    function HeaderValueWithParameters(content, parameters) {
        parameters = parameters === VOID ? emptyList() : parameters;
        this.l47_1 = content;
        this.m47_1 = parameters;
    }
    protoOf(HeaderValueWithParameters).f49 = function(name) {
        var inductionVariable = 0;
        var last = get_lastIndex(this.m47_1);
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var parameter = this.m47_1.o(index);
            if (equals(parameter.n47_1, name, true)) return parameter.o47_1;
        }while (!(index === last));
        return null;
    };
    protoOf(HeaderValueWithParameters).toString = function() {
        var tmp;
        if (this.m47_1.s()) tmp = this.l47_1;
        else {
            var tmp_0 = this.l47_1.length;
            // Inline function 'kotlin.collections.sumOf' call
            var sum = 0;
            var tmp0_iterator = this.m47_1.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                var tmp_1 = sum;
                // Inline function 'io.ktor.http.HeaderValueWithParameters.toString.<anonymous>' call
                sum = tmp_1 + ((element.n47_1.length + element.o47_1.length | 0) + 3 | 0) | 0;
            }
            var size = tmp_0 + sum | 0;
            // Inline function 'kotlin.apply' call
            var this_0 = StringBuilder_init_$Create$_0(size);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.http.HeaderValueWithParameters.toString.<anonymous>' call
            this_0.e8(this.l47_1);
            var inductionVariable = 0;
            var last = get_lastIndex(this.m47_1);
            if (inductionVariable <= last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element_0 = this.m47_1.o(index);
                this_0.e8("; ");
                this_0.e8(element_0.n47_1);
                this_0.e8("=");
                // Inline function 'io.ktor.http.escapeIfNeededTo' call
                var this_1 = element_0.o47_1;
                if (needQuotes$accessor$vynnj(this_1)) this_0.e8(quote(this_1));
                else this_0.e8(this_1);
            }while (!(index === last));
            tmp = this_0.toString();
        }
        return tmp;
    };
    function needQuotes(_this__u8e3s4) {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(_this__u8e3s4) === 0) return true;
        if (isQuoted(_this__u8e3s4)) return false;
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        if (inductionVariable < last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (get_HeaderFieldValueSeparators().a2(new Char(charSequenceGet(_this__u8e3s4, index)))) return true;
        }while (inductionVariable < last);
        return false;
    }
    function quote(_this__u8e3s4) {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.quote.<anonymous>' call
        quoteTo(_this__u8e3s4, this_0);
        return this_0.toString();
    }
    function isQuoted(_this__u8e3s4) {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        if (_this__u8e3s4.length < 2) return false;
        if (!(first(_this__u8e3s4) === _Char___init__impl__6a9atx(34)) || !(last_0(_this__u8e3s4) === _Char___init__impl__6a9atx(34))) return false;
        var startIndex = 1;
        $l$loop: do {
            var index = indexOf(_this__u8e3s4, _Char___init__impl__6a9atx(34), startIndex);
            if (index === get_lastIndex_0(_this__u8e3s4)) break $l$loop;
            var slashesCount = 0;
            var slashIndex = index - 1 | 0;
            while(charSequenceGet(_this__u8e3s4, slashIndex) === _Char___init__impl__6a9atx(92)){
                slashesCount = slashesCount + 1 | 0;
                slashIndex = slashIndex - 1 | 0;
            }
            if ((slashesCount % 2 | 0) === 0) return false;
            startIndex = index + 1 | 0;
        }while (startIndex < _this__u8e3s4.length);
        return true;
    }
    function quoteTo(_this__u8e3s4, out) {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        out.e8('"');
        var inductionVariable = 0;
        var last = _this__u8e3s4.length;
        if (inductionVariable < last) do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ch = charSequenceGet(_this__u8e3s4, i);
            if (ch === _Char___init__impl__6a9atx(92)) out.e8("\\\\");
            else if (ch === _Char___init__impl__6a9atx(10)) out.e8("\\n");
            else if (ch === _Char___init__impl__6a9atx(13)) out.e8("\\r");
            else if (ch === _Char___init__impl__6a9atx(9)) out.e8("\\t");
            else if (ch === _Char___init__impl__6a9atx(34)) out.e8('\\"');
            else out.f8(ch);
        }while (inductionVariable < last);
        out.e8('"');
    }
    function needQuotes$accessor$vynnj(_this__u8e3s4) {
        _init_properties_HeaderValueWithParameters_kt__z6luvy();
        return needQuotes(_this__u8e3s4);
    }
    var properties_initialized_HeaderValueWithParameters_kt_yu5xg;
    function _init_properties_HeaderValueWithParameters_kt__z6luvy() {
        if (!properties_initialized_HeaderValueWithParameters_kt_yu5xg) {
            properties_initialized_HeaderValueWithParameters_kt_yu5xg = true;
            HeaderFieldValueSeparators = setOf([
                new Char(_Char___init__impl__6a9atx(40)),
                new Char(_Char___init__impl__6a9atx(41)),
                new Char(_Char___init__impl__6a9atx(60)),
                new Char(_Char___init__impl__6a9atx(62)),
                new Char(_Char___init__impl__6a9atx(64)),
                new Char(_Char___init__impl__6a9atx(44)),
                new Char(_Char___init__impl__6a9atx(59)),
                new Char(_Char___init__impl__6a9atx(58)),
                new Char(_Char___init__impl__6a9atx(92)),
                new Char(_Char___init__impl__6a9atx(34)),
                new Char(_Char___init__impl__6a9atx(47)),
                new Char(_Char___init__impl__6a9atx(91)),
                new Char(_Char___init__impl__6a9atx(93)),
                new Char(_Char___init__impl__6a9atx(63)),
                new Char(_Char___init__impl__6a9atx(61)),
                new Char(_Char___init__impl__6a9atx(123)),
                new Char(_Char___init__impl__6a9atx(125)),
                new Char(_Char___init__impl__6a9atx(32)),
                new Char(_Char___init__impl__6a9atx(9)),
                new Char(_Char___init__impl__6a9atx(10)),
                new Char(_Char___init__impl__6a9atx(13))
            ]);
        }
    }
    function Companion_1() {
        Companion_instance_2 = this;
        this.g49_1 = EmptyHeaders_instance;
    }
    var Companion_instance_2;
    function Companion_getInstance_1() {
        if (Companion_instance_2 == null) new Companion_1();
        return Companion_instance_2;
    }
    function HeadersBuilder(size) {
        size = size === VOID ? 8 : size;
        StringValuesBuilderImpl.call(this, true, size);
    }
    protoOf(HeadersBuilder).c3r = function() {
        return new HeadersImpl(this.q43_1);
    };
    protoOf(HeadersBuilder).r43 = function(name) {
        protoOf(StringValuesBuilderImpl).r43.call(this, name);
        HttpHeaders_getInstance().f4d(name);
    };
    protoOf(HeadersBuilder).v43 = function(value) {
        protoOf(StringValuesBuilderImpl).v43.call(this, value);
        HttpHeaders_getInstance().g4d(value);
    };
    function EmptyHeaders() {}
    protoOf(EmptyHeaders).k43 = function() {
        return true;
    };
    protoOf(EmptyHeaders).l43 = function(name) {
        return null;
    };
    protoOf(EmptyHeaders).m43 = function() {
        return emptySet();
    };
    protoOf(EmptyHeaders).n43 = function() {
        return emptySet();
    };
    protoOf(EmptyHeaders).toString = function() {
        return "Headers " + toString(this.n43());
    };
    var EmptyHeaders_instance;
    function EmptyHeaders_getInstance() {
        return EmptyHeaders_instance;
    }
    function HeadersImpl(values) {
        values = values === VOID ? emptyMap() : values;
        StringValuesImpl.call(this, true, values);
    }
    protoOf(HeadersImpl).toString = function() {
        return "Headers " + toString(this.n43());
    };
    function HeaderValueParam_init_$Init$(name, value, $this) {
        HeaderValueParam.call($this, name, value, false);
        return $this;
    }
    function HeaderValueParam_init_$Create$(name, value) {
        return HeaderValueParam_init_$Init$(name, value, objectCreate(protoOf(HeaderValueParam)));
    }
    function HeaderValueParam(name, value, escapeValue) {
        this.n47_1 = name;
        this.o47_1 = value;
        this.p47_1 = escapeValue;
    }
    protoOf(HeaderValueParam).equals = function(other) {
        var tmp;
        var tmp_0;
        if (other instanceof HeaderValueParam) tmp_0 = equals(other.n47_1, this.n47_1, true);
        else tmp_0 = false;
        if (tmp_0) tmp = equals(other.o47_1, this.o47_1, true);
        else tmp = false;
        return tmp;
    };
    protoOf(HeaderValueParam).hashCode = function() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.n47_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$1);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = this.o47_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
        return result;
    };
    protoOf(HeaderValueParam).ba = function() {
        return this.n47_1;
    };
    protoOf(HeaderValueParam).ca = function() {
        return this.o47_1;
    };
    protoOf(HeaderValueParam).toString = function() {
        return "HeaderValueParam(name=" + this.n47_1 + ", value=" + this.o47_1 + ", escapeValue=" + this.p47_1 + ")";
    };
    function HeaderValue(value, params) {
        params = params === VOID ? emptyList() : params;
        this.r47_1 = value;
        this.s47_1 = params;
        var tmp = this;
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = this.s47_1.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.ktor.http.HeaderValue.quality.<anonymous>' call
                if (element.n47_1 === "q") {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o47_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
        var tmp_0;
        if (tmp2_safe_receiver == null) tmp_0 = null;
        else {
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_1;
            // Inline function 'io.ktor.http.HeaderValue.quality.<anonymous>' call
            if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) tmp_1 = tmp2_safe_receiver;
            else tmp_1 = null;
            tmp_0 = tmp_1;
        }
        var tmp3_elvis_lhs = tmp_0;
        tmp.t47_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
    }
    protoOf(HeaderValue).ba = function() {
        return this.r47_1;
    };
    protoOf(HeaderValue).toString = function() {
        return "HeaderValue(value=" + this.r47_1 + ", params=" + toString(this.s47_1) + ")";
    };
    protoOf(HeaderValue).hashCode = function() {
        var result = getStringHashCode(this.r47_1);
        result = imul(result, 31) + hashCode(this.s47_1) | 0;
        return result;
    };
    protoOf(HeaderValue).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof HeaderValue)) return false;
        var tmp0_other_with_cast = other instanceof HeaderValue ? other : THROW_CCE();
        if (!(this.r47_1 === tmp0_other_with_cast.r47_1)) return false;
        if (!equals_0(this.s47_1, tmp0_other_with_cast.s47_1)) return false;
        return true;
    };
    function parseHeaderValue(text) {
        return parseHeaderValue_0(text, false);
    }
    function parseHeaderValue_0(text, parametersOnly) {
        if (text == null) return emptyList();
        var position = 0;
        var tmp = LazyThreadSafetyMode_NONE_getInstance();
        var items = lazy(tmp, parseHeaderValue$lambda);
        while(position <= get_lastIndex_0(text))position = parseHeaderValueItem(text, position, items, parametersOnly);
        return valueOrEmpty(items);
    }
    function parseHeaderValueItem(text, start, items, parametersOnly) {
        var position = start;
        var tmp = LazyThreadSafetyMode_NONE_getInstance();
        var parameters = lazy(tmp, parseHeaderValueItem$lambda);
        var valueEnd = parametersOnly ? position : null;
        while(position <= get_lastIndex_0(text)){
            var tmp0_subject = charSequenceGet(text, position);
            if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
                var tmp_0 = items.b1();
                var tmp1_elvis_lhs = valueEnd;
                tmp_0.e(new HeaderValue(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
                return position + 1 | 0;
            } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
                if (valueEnd == null) valueEnd = position;
                position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
            } else {
                var tmp_1;
                if (parametersOnly) tmp_1 = parseHeaderValueParameter(text, position, parameters);
                else tmp_1 = position + 1 | 0;
                position = tmp_1;
            }
        }
        var tmp_2 = items.b1();
        var tmp2_elvis_lhs = valueEnd;
        tmp_2.e(new HeaderValue(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
        return position;
    }
    function valueOrEmpty(_this__u8e3s4) {
        return _this__u8e3s4.kj() ? _this__u8e3s4.b1() : emptyList();
    }
    function subtrim(_this__u8e3s4, start, end) {
        // Inline function 'kotlin.text.trim' call
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var this_0 = _this__u8e3s4.substring(start, end);
        return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    }
    function parseHeaderValueParameter(text, start, parameters) {
        var position = start;
        while(position <= get_lastIndex_0(text)){
            var tmp0_subject = charSequenceGet(text, position);
            if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
                var tmp1_container = parseHeaderValueParameterValue(text, position + 1 | 0);
                var paramEnd = tmp1_container.ba();
                var paramValue = tmp1_container.ca();
                parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
                return paramEnd;
            } else if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44)) {
                parseHeaderValueParameter$addParam(parameters, text, start, position, "");
                return position;
            } else position = position + 1 | 0;
        }
        parseHeaderValueParameter$addParam(parameters, text, start, position, "");
        return position;
    }
    function parseHeaderValueParameterValue(value, start) {
        if (value.length === start) return to(start, "");
        var position = start;
        if (charSequenceGet(value, start) === _Char___init__impl__6a9atx(34)) return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
        while(position <= get_lastIndex_0(value)){
            var tmp0_subject = charSequenceGet(value, position);
            if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44)) return to(position, subtrim(value, start, position));
            else position = position + 1 | 0;
        }
        return to(position, subtrim(value, start, position));
    }
    function parseHeaderValueParameterValueQuoted(value, start) {
        var position = start;
        var builder = StringBuilder_init_$Create$();
        loop: while(position <= get_lastIndex_0(value)){
            var currentChar = charSequenceGet(value, position);
            if (currentChar === _Char___init__impl__6a9atx(34) && nextIsSemicolonOrEnd(value, position)) return to(position + 1 | 0, builder.toString());
            else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex_0(value) - 2 | 0)) {
                builder.f8(charSequenceGet(value, position + 1 | 0));
                position = position + 2 | 0;
                continue loop;
            }
            builder.f8(currentChar);
            position = position + 1 | 0;
        }
        var tmp = position;
        // Inline function 'kotlin.text.plus' call
        var this_0 = _Char___init__impl__6a9atx(34);
        var other = builder.toString();
        var tmp$ret$0 = toString_0(this_0) + other;
        return to(tmp, tmp$ret$0);
    }
    function nextIsSemicolonOrEnd(_this__u8e3s4, start) {
        var position = start + 1 | 0;
        loop: while(position < _this__u8e3s4.length && charSequenceGet(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32))position = position + 1 | 0;
        return position === _this__u8e3s4.length || charSequenceGet(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59);
    }
    function parseAndSortHeader(header) {
        // Inline function 'kotlin.collections.sortedByDescending' call
        var this_0 = parseHeaderValue(header);
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp = parseAndSortHeader$lambda;
        var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
        return sortedWith(this_0, tmp$ret$0);
    }
    function sam$kotlin_Comparator$0(function_0) {
        this.h4d_1 = function_0;
    }
    protoOf(sam$kotlin_Comparator$0).bd = function(a, b) {
        return this.h4d_1(a, b);
    };
    protoOf(sam$kotlin_Comparator$0).compare = function(a, b) {
        return this.bd(a, b);
    };
    function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
        var name = subtrim(text, start, end);
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(name) === 0) return Unit_instance;
        $parameters.b1().e(HeaderValueParam_init_$Create$(name, value));
    }
    function parseHeaderValue$lambda() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList_init_$Create$_0();
    }
    function parseHeaderValueItem$lambda() {
        // Inline function 'kotlin.collections.arrayListOf' call
        return ArrayList_init_$Create$_0();
    }
    function parseAndSortHeader$lambda(a, b) {
        // Inline function 'kotlin.comparisons.compareValuesBy' call
        // Inline function 'io.ktor.http.parseAndSortHeader.<anonymous>' call
        var tmp = b.t47_1;
        // Inline function 'io.ktor.http.parseAndSortHeader.<anonymous>' call
        var tmp$ret$1 = a.t47_1;
        return compareValues(tmp, tmp$ret$1);
    }
    function HttpHeaders() {
        HttpHeaders_instance = this;
        this.j49_1 = "Accept";
        this.k49_1 = "Accept-Charset";
        this.l49_1 = "Accept-Encoding";
        this.m49_1 = "Accept-Language";
        this.n49_1 = "Accept-Ranges";
        this.o49_1 = "Age";
        this.p49_1 = "Allow";
        this.q49_1 = "ALPN";
        this.r49_1 = "Authentication-Info";
        this.s49_1 = "Authorization";
        this.t49_1 = "Cache-Control";
        this.u49_1 = "Connection";
        this.v49_1 = "Content-Disposition";
        this.w49_1 = "Content-Encoding";
        this.x49_1 = "Content-Language";
        this.y49_1 = "Content-Length";
        this.z49_1 = "Content-Location";
        this.a4a_1 = "Content-Range";
        this.b4a_1 = "Content-Type";
        this.c4a_1 = "Cookie";
        this.d4a_1 = "DASL";
        this.e4a_1 = "Date";
        this.f4a_1 = "DAV";
        this.g4a_1 = "Depth";
        this.h4a_1 = "Destination";
        this.i4a_1 = "ETag";
        this.j4a_1 = "Expect";
        this.k4a_1 = "Expires";
        this.l4a_1 = "From";
        this.m4a_1 = "Forwarded";
        this.n4a_1 = "Host";
        this.o4a_1 = "HTTP2-Settings";
        this.p4a_1 = "If";
        this.q4a_1 = "If-Match";
        this.r4a_1 = "If-Modified-Since";
        this.s4a_1 = "If-None-Match";
        this.t4a_1 = "If-Range";
        this.u4a_1 = "If-Schedule-Tag-Match";
        this.v4a_1 = "If-Unmodified-Since";
        this.w4a_1 = "Last-Modified";
        this.x4a_1 = "Location";
        this.y4a_1 = "Lock-Token";
        this.z4a_1 = "Link";
        this.a4b_1 = "Max-Forwards";
        this.b4b_1 = "MIME-Version";
        this.c4b_1 = "Ordering-Type";
        this.d4b_1 = "Origin";
        this.e4b_1 = "Overwrite";
        this.f4b_1 = "Position";
        this.g4b_1 = "Pragma";
        this.h4b_1 = "Prefer";
        this.i4b_1 = "Preference-Applied";
        this.j4b_1 = "Proxy-Authenticate";
        this.k4b_1 = "Proxy-Authentication-Info";
        this.l4b_1 = "Proxy-Authorization";
        this.m4b_1 = "Public-Key-Pins";
        this.n4b_1 = "Public-Key-Pins-Report-Only";
        this.o4b_1 = "Range";
        this.p4b_1 = "Referer";
        this.q4b_1 = "Retry-After";
        this.r4b_1 = "Schedule-Reply";
        this.s4b_1 = "Schedule-Tag";
        this.t4b_1 = "Sec-WebSocket-Accept";
        this.u4b_1 = "Sec-WebSocket-Extensions";
        this.v4b_1 = "Sec-WebSocket-Key";
        this.w4b_1 = "Sec-WebSocket-Protocol";
        this.x4b_1 = "Sec-WebSocket-Version";
        this.y4b_1 = "Server";
        this.z4b_1 = "Set-Cookie";
        this.a4c_1 = "SLUG";
        this.b4c_1 = "Strict-Transport-Security";
        this.c4c_1 = "TE";
        this.d4c_1 = "Timeout";
        this.e4c_1 = "Trailer";
        this.f4c_1 = "Transfer-Encoding";
        this.g4c_1 = "Upgrade";
        this.h4c_1 = "User-Agent";
        this.i4c_1 = "Vary";
        this.j4c_1 = "Via";
        this.k4c_1 = "Warning";
        this.l4c_1 = "WWW-Authenticate";
        this.m4c_1 = "Access-Control-Allow-Origin";
        this.n4c_1 = "Access-Control-Allow-Methods";
        this.o4c_1 = "Access-Control-Allow-Credentials";
        this.p4c_1 = "Access-Control-Allow-Headers";
        this.q4c_1 = "Access-Control-Request-Method";
        this.r4c_1 = "Access-Control-Request-Headers";
        this.s4c_1 = "Access-Control-Expose-Headers";
        this.t4c_1 = "Access-Control-Max-Age";
        this.u4c_1 = "X-Http-Method-Override";
        this.v4c_1 = "X-Forwarded-Host";
        this.w4c_1 = "X-Forwarded-Server";
        this.x4c_1 = "X-Forwarded-Proto";
        this.y4c_1 = "X-Forwarded-For";
        this.z4c_1 = "X-Forwarded-Port";
        this.a4d_1 = "X-Request-ID";
        this.b4d_1 = "X-Correlation-ID";
        this.c4d_1 = "X-Total-Count";
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d4d_1 = [
            this.f4c_1,
            this.g4c_1
        ];
        this.e4d_1 = asList(this.d4d_1);
    }
    protoOf(HttpHeaders).f4d = function(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while(inductionVariable < charSequenceLength(name)){
            var item = charSequenceGet(name, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'io.ktor.http.HttpHeaders.checkHeaderName.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) throw new IllegalHeaderNameException(name, tmp1);
        }
    };
    protoOf(HttpHeaders).g4d = function(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while(inductionVariable < charSequenceLength(value)){
            var item = charSequenceGet(value, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'io.ktor.http.HttpHeaders.checkHeaderValue.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) throw new IllegalHeaderValueException(value, tmp1);
        }
    };
    var HttpHeaders_instance;
    function HttpHeaders_getInstance() {
        if (HttpHeaders_instance == null) new HttpHeaders();
        return HttpHeaders_instance;
    }
    function isDelimiter(ch) {
        return contains('"(),/:;<=>?@[\\]{}', ch);
    }
    function IllegalHeaderNameException(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString_0(charSequenceGet(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        IllegalArgumentException_init_$Init$(tmp + (" (code " + (tmp$ret$0 & 255) + ")"), this);
        captureStack(this, IllegalHeaderNameException);
        this.i4d_1 = headerName;
        this.j4d_1 = position;
    }
    function IllegalHeaderValueException(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString_0(charSequenceGet(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        IllegalArgumentException_init_$Init$(tmp + (" (code " + (tmp$ret$0 & 255) + ")"), this);
        captureStack(this, IllegalHeaderValueException);
        this.k4d_1 = headerValue;
        this.l4d_1 = position;
    }
    function UnsafeHeaderException(header) {
        IllegalArgumentException_init_$Init$("Header(s) " + header + " are controlled by the engine and " + "cannot be set explicitly", this);
        captureStack(this, UnsafeHeaderException);
    }
    function contentType(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4.m4d().vl(HttpHeaders_getInstance().b4a_1);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.contentType.<anonymous>' call
        tmp = Companion_getInstance().a1m(tmp0_safe_receiver);
        return tmp;
    }
    function contentLength(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4.m4d().vl(HttpHeaders_getInstance().y49_1);
        return tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
    }
    function charset_0(_this__u8e3s4) {
        var tmp0_safe_receiver = contentType_1(_this__u8e3s4);
        return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
    }
    function contentType_0(_this__u8e3s4, type) {
        return _this__u8e3s4.m4d().u43(HttpHeaders_getInstance().b4a_1, type.toString());
    }
    function contentType_1(_this__u8e3s4) {
        var tmp0_safe_receiver = _this__u8e3s4.m4d().vl(HttpHeaders_getInstance().b4a_1);
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.contentType.<anonymous>' call
        tmp = Companion_getInstance().a1m(tmp0_safe_receiver);
        return tmp;
    }
    function Companion_2() {
        Companion_instance_3 = this;
        this.n4d_1 = new HttpMethod("GET");
        this.o4d_1 = new HttpMethod("POST");
        this.p4d_1 = new HttpMethod("PUT");
        this.q4d_1 = new HttpMethod("PATCH");
        this.r4d_1 = new HttpMethod("DELETE");
        this.s4d_1 = new HttpMethod("HEAD");
        this.t4d_1 = new HttpMethod("OPTIONS");
        this.u4d_1 = listOf([
            this.n4d_1,
            this.o4d_1,
            this.p4d_1,
            this.q4d_1,
            this.r4d_1,
            this.s4d_1,
            this.t4d_1
        ]);
    }
    var Companion_instance_3;
    function Companion_getInstance_2() {
        if (Companion_instance_3 == null) new Companion_2();
        return Companion_instance_3;
    }
    function HttpMethod(value) {
        Companion_getInstance_2();
        this.v4d_1 = value;
    }
    protoOf(HttpMethod).toString = function() {
        return "HttpMethod(value=" + this.v4d_1 + ")";
    };
    protoOf(HttpMethod).hashCode = function() {
        return getStringHashCode(this.v4d_1);
    };
    protoOf(HttpMethod).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof HttpMethod)) return false;
        var tmp0_other_with_cast = other instanceof HttpMethod ? other : THROW_CCE();
        if (!(this.v4d_1 === tmp0_other_with_cast.v4d_1)) return false;
        return true;
    };
    function Companion_3() {
        Companion_instance_4 = this;
        this.w4d_1 = new HttpProtocolVersion("HTTP", 2, 0);
        this.x4d_1 = new HttpProtocolVersion("HTTP", 1, 1);
        this.y4d_1 = new HttpProtocolVersion("HTTP", 1, 0);
        this.z4d_1 = new HttpProtocolVersion("SPDY", 3, 0);
        this.a4e_1 = new HttpProtocolVersion("QUIC", 1, 0);
    }
    var Companion_instance_4;
    function Companion_getInstance_3() {
        if (Companion_instance_4 == null) new Companion_3();
        return Companion_instance_4;
    }
    function HttpProtocolVersion(name, major, minor) {
        Companion_getInstance_3();
        this.b4e_1 = name;
        this.c4e_1 = major;
        this.d4e_1 = minor;
    }
    protoOf(HttpProtocolVersion).toString = function() {
        return this.b4e_1 + "/" + this.c4e_1 + "." + this.d4e_1;
    };
    protoOf(HttpProtocolVersion).hashCode = function() {
        var result = getStringHashCode(this.b4e_1);
        result = imul(result, 31) + this.c4e_1 | 0;
        result = imul(result, 31) + this.d4e_1 | 0;
        return result;
    };
    protoOf(HttpProtocolVersion).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof HttpProtocolVersion)) return false;
        var tmp0_other_with_cast = other instanceof HttpProtocolVersion ? other : THROW_CCE();
        if (!(this.b4e_1 === tmp0_other_with_cast.b4e_1)) return false;
        if (!(this.c4e_1 === tmp0_other_with_cast.c4e_1)) return false;
        if (!(this.d4e_1 === tmp0_other_with_cast.d4e_1)) return false;
        return true;
    };
    function Companion_4() {
        Companion_instance_5 = this;
        this.e4e_1 = new HttpStatusCode(100, "Continue");
        this.f4e_1 = new HttpStatusCode(101, "Switching Protocols");
        this.g4e_1 = new HttpStatusCode(102, "Processing");
        this.h4e_1 = new HttpStatusCode(200, "OK");
        this.i4e_1 = new HttpStatusCode(201, "Created");
        this.j4e_1 = new HttpStatusCode(202, "Accepted");
        this.k4e_1 = new HttpStatusCode(203, "Non-Authoritative Information");
        this.l4e_1 = new HttpStatusCode(204, "No Content");
        this.m4e_1 = new HttpStatusCode(205, "Reset Content");
        this.n4e_1 = new HttpStatusCode(206, "Partial Content");
        this.o4e_1 = new HttpStatusCode(207, "Multi-Status");
        this.p4e_1 = new HttpStatusCode(300, "Multiple Choices");
        this.q4e_1 = new HttpStatusCode(301, "Moved Permanently");
        this.r4e_1 = new HttpStatusCode(302, "Found");
        this.s4e_1 = new HttpStatusCode(303, "See Other");
        this.t4e_1 = new HttpStatusCode(304, "Not Modified");
        this.u4e_1 = new HttpStatusCode(305, "Use Proxy");
        this.v4e_1 = new HttpStatusCode(306, "Switch Proxy");
        this.w4e_1 = new HttpStatusCode(307, "Temporary Redirect");
        this.x4e_1 = new HttpStatusCode(308, "Permanent Redirect");
        this.y4e_1 = new HttpStatusCode(400, "Bad Request");
        this.z4e_1 = new HttpStatusCode(401, "Unauthorized");
        this.a4f_1 = new HttpStatusCode(402, "Payment Required");
        this.b4f_1 = new HttpStatusCode(403, "Forbidden");
        this.c4f_1 = new HttpStatusCode(404, "Not Found");
        this.d4f_1 = new HttpStatusCode(405, "Method Not Allowed");
        this.e4f_1 = new HttpStatusCode(406, "Not Acceptable");
        this.f4f_1 = new HttpStatusCode(407, "Proxy Authentication Required");
        this.g4f_1 = new HttpStatusCode(408, "Request Timeout");
        this.h4f_1 = new HttpStatusCode(409, "Conflict");
        this.i4f_1 = new HttpStatusCode(410, "Gone");
        this.j4f_1 = new HttpStatusCode(411, "Length Required");
        this.k4f_1 = new HttpStatusCode(412, "Precondition Failed");
        this.l4f_1 = new HttpStatusCode(413, "Payload Too Large");
        this.m4f_1 = new HttpStatusCode(414, "Request-URI Too Long");
        this.n4f_1 = new HttpStatusCode(415, "Unsupported Media Type");
        this.o4f_1 = new HttpStatusCode(416, "Requested Range Not Satisfiable");
        this.p4f_1 = new HttpStatusCode(417, "Expectation Failed");
        this.q4f_1 = new HttpStatusCode(422, "Unprocessable Entity");
        this.r4f_1 = new HttpStatusCode(423, "Locked");
        this.s4f_1 = new HttpStatusCode(424, "Failed Dependency");
        this.t4f_1 = new HttpStatusCode(425, "Too Early");
        this.u4f_1 = new HttpStatusCode(426, "Upgrade Required");
        this.v4f_1 = new HttpStatusCode(429, "Too Many Requests");
        this.w4f_1 = new HttpStatusCode(431, "Request Header Fields Too Large");
        this.x4f_1 = new HttpStatusCode(500, "Internal Server Error");
        this.y4f_1 = new HttpStatusCode(501, "Not Implemented");
        this.z4f_1 = new HttpStatusCode(502, "Bad Gateway");
        this.a4g_1 = new HttpStatusCode(503, "Service Unavailable");
        this.b4g_1 = new HttpStatusCode(504, "Gateway Timeout");
        this.c4g_1 = new HttpStatusCode(505, "HTTP Version Not Supported");
        this.d4g_1 = new HttpStatusCode(506, "Variant Also Negotiates");
        this.e4g_1 = new HttpStatusCode(507, "Insufficient Storage");
        this.f4g_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.f4g_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap_init_$Create$(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.Companion.statusCodesMap.<anonymous>' call
            var tmp$ret$0 = element.h4g_1;
            destination.m2(tmp$ret$0, element);
        }
        tmp.g4g_1 = destination;
    }
    var Companion_instance_5;
    function Companion_getInstance_4() {
        if (Companion_instance_5 == null) new Companion_4();
        return Companion_instance_5;
    }
    function HttpStatusCode(value, description) {
        Companion_getInstance_4();
        this.h4g_1 = value;
        this.i4g_1 = description;
    }
    protoOf(HttpStatusCode).toString = function() {
        return "" + this.h4g_1 + " " + this.i4g_1;
    };
    protoOf(HttpStatusCode).equals = function(other) {
        var tmp;
        if (other instanceof HttpStatusCode) tmp = other.h4g_1 === this.h4g_1;
        else tmp = false;
        return tmp;
    };
    protoOf(HttpStatusCode).hashCode = function() {
        return this.h4g_1;
    };
    protoOf(HttpStatusCode).j4g = function(other) {
        return this.h4g_1 - other.h4g_1 | 0;
    };
    protoOf(HttpStatusCode).d = function(other) {
        return this.j4g(other instanceof HttpStatusCode ? other : THROW_CCE());
    };
    function allStatusCodes() {
        return listOf([
            Companion_getInstance_4().e4e_1,
            Companion_getInstance_4().f4e_1,
            Companion_getInstance_4().g4e_1,
            Companion_getInstance_4().h4e_1,
            Companion_getInstance_4().i4e_1,
            Companion_getInstance_4().j4e_1,
            Companion_getInstance_4().k4e_1,
            Companion_getInstance_4().l4e_1,
            Companion_getInstance_4().m4e_1,
            Companion_getInstance_4().n4e_1,
            Companion_getInstance_4().o4e_1,
            Companion_getInstance_4().p4e_1,
            Companion_getInstance_4().q4e_1,
            Companion_getInstance_4().r4e_1,
            Companion_getInstance_4().s4e_1,
            Companion_getInstance_4().t4e_1,
            Companion_getInstance_4().u4e_1,
            Companion_getInstance_4().v4e_1,
            Companion_getInstance_4().w4e_1,
            Companion_getInstance_4().x4e_1,
            Companion_getInstance_4().y4e_1,
            Companion_getInstance_4().z4e_1,
            Companion_getInstance_4().a4f_1,
            Companion_getInstance_4().b4f_1,
            Companion_getInstance_4().c4f_1,
            Companion_getInstance_4().d4f_1,
            Companion_getInstance_4().e4f_1,
            Companion_getInstance_4().f4f_1,
            Companion_getInstance_4().g4f_1,
            Companion_getInstance_4().h4f_1,
            Companion_getInstance_4().i4f_1,
            Companion_getInstance_4().j4f_1,
            Companion_getInstance_4().k4f_1,
            Companion_getInstance_4().l4f_1,
            Companion_getInstance_4().m4f_1,
            Companion_getInstance_4().n4f_1,
            Companion_getInstance_4().o4f_1,
            Companion_getInstance_4().p4f_1,
            Companion_getInstance_4().q4f_1,
            Companion_getInstance_4().r4f_1,
            Companion_getInstance_4().s4f_1,
            Companion_getInstance_4().t4f_1,
            Companion_getInstance_4().u4f_1,
            Companion_getInstance_4().v4f_1,
            Companion_getInstance_4().w4f_1,
            Companion_getInstance_4().x4f_1,
            Companion_getInstance_4().y4f_1,
            Companion_getInstance_4().z4f_1,
            Companion_getInstance_4().a4g_1,
            Companion_getInstance_4().b4g_1,
            Companion_getInstance_4().c4g_1,
            Companion_getInstance_4().d4g_1,
            Companion_getInstance_4().e4g_1
        ]);
    }
    function isSuccess(_this__u8e3s4) {
        var containsArg = _this__u8e3s4.h4g_1;
        return 200 <= containsArg ? containsArg < 300 : false;
    }
    function formUrlEncode(_this__u8e3s4) {
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var this_0 = _this__u8e3s4.n43();
        var destination = ArrayList_init_$Create$_0();
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.formUrlEncode.<anonymous>' call
            // Inline function 'kotlin.collections.map' call
            var this_1 = element.b1();
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
            var tmp0_iterator_0 = this_1.j();
            while(tmp0_iterator_0.k()){
                var item = tmp0_iterator_0.l();
                // Inline function 'io.ktor.http.formUrlEncode.<anonymous>.<anonymous>' call
                var tmp$ret$0 = to(element.a1(), item);
                destination_0.e(tmp$ret$0);
            }
            var list = destination_0;
            addAll(destination, list);
        }
        return formUrlEncode_0(destination);
    }
    function formUrlEncode_0(_this__u8e3s4) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.formUrlEncode.<anonymous>' call
        formUrlEncodeTo(_this__u8e3s4, this_0);
        return this_0.toString();
    }
    function formUrlEncodeTo(_this__u8e3s4, out) {
        joinTo(_this__u8e3s4, out, "&", VOID, VOID, VOID, VOID, formUrlEncodeTo$lambda);
    }
    function formUrlEncodeTo$lambda(it) {
        var key = encodeURLParameter(it.z9_1, true);
        var tmp;
        if (it.aa_1 == null) tmp = key;
        else {
            var value = encodeURLParameterValue(toString_1(it.aa_1));
            tmp = key + "=" + value;
        }
        return tmp;
    }
    function Companion_5() {
        Companion_instance_6 = this;
        this.k4g_1 = EmptyParameters_instance;
    }
    var Companion_instance_6;
    function Companion_getInstance_5() {
        if (Companion_instance_6 == null) new Companion_5();
        return Companion_instance_6;
    }
    function Parameters() {}
    function parameters(builder) {
        // Inline function 'io.ktor.http.Companion.build' call
        Companion_getInstance_5();
        // Inline function 'kotlin.apply' call
        var this_0 = ParametersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        builder(this_0);
        return this_0.c3r();
    }
    function ParametersBuilder(size) {
        size = size === VOID ? 8 : size;
        return new ParametersBuilderImpl(size);
    }
    function EmptyParameters() {}
    protoOf(EmptyParameters).k43 = function() {
        return true;
    };
    protoOf(EmptyParameters).l43 = function(name) {
        return null;
    };
    protoOf(EmptyParameters).m43 = function() {
        return emptySet();
    };
    protoOf(EmptyParameters).n43 = function() {
        return emptySet();
    };
    protoOf(EmptyParameters).s = function() {
        return true;
    };
    protoOf(EmptyParameters).toString = function() {
        return "Parameters " + toString(this.n43());
    };
    protoOf(EmptyParameters).equals = function(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Parameters) : false) tmp = other.s();
        else tmp = false;
        return tmp;
    };
    var EmptyParameters_instance;
    function EmptyParameters_getInstance() {
        return EmptyParameters_instance;
    }
    function ParametersBuilderImpl(size) {
        size = size === VOID ? 8 : size;
        StringValuesBuilderImpl.call(this, true, size);
    }
    protoOf(ParametersBuilderImpl).c3r = function() {
        return new ParametersImpl(this.q43_1);
    };
    function ParametersImpl(values) {
        values = values === VOID ? emptyMap() : values;
        StringValuesImpl.call(this, true, values);
    }
    protoOf(ParametersImpl).toString = function() {
        return "Parameters " + toString(this.n43());
    };
    function parseQueryString(query, startIndex, limit, decode) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        limit = limit === VOID ? 1000 : limit;
        decode = decode === VOID ? true : decode;
        var tmp;
        if (startIndex > get_lastIndex_0(query)) tmp = Companion_getInstance_5().k4g_1;
        else {
            // Inline function 'io.ktor.http.Companion.build' call
            Companion_getInstance_5();
            // Inline function 'kotlin.apply' call
            var this_0 = ParametersBuilder();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.http.parseQueryString.<anonymous>' call
            parse(this_0, query, startIndex, limit, decode);
            tmp = this_0.c3r();
        }
        return tmp;
    }
    function parse(_this__u8e3s4, query, startIndex, limit, decode) {
        var count = 0;
        var nameIndex = startIndex;
        var equalIndex = -1;
        var inductionVariable = startIndex;
        var last = get_lastIndex_0(query);
        if (inductionVariable <= last) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (count === limit) return Unit_instance;
            var tmp1_subject = charSequenceGet(query, index);
            if (tmp1_subject === _Char___init__impl__6a9atx(38)) {
                appendParam(_this__u8e3s4, query, nameIndex, equalIndex, index, decode);
                nameIndex = index + 1 | 0;
                equalIndex = -1;
                count = count + 1 | 0;
            } else if (tmp1_subject === _Char___init__impl__6a9atx(61)) {
                if (equalIndex === -1) equalIndex = index;
            }
        }while (!(index === last));
        if (count === limit) return Unit_instance;
        appendParam(_this__u8e3s4, query, nameIndex, equalIndex, query.length, decode);
    }
    function appendParam(_this__u8e3s4, query, nameIndex, equalIndex, endIndex, decode) {
        if (equalIndex === -1) {
            var spaceNameIndex = trimStart(nameIndex, endIndex, query);
            var spaceEndIndex = trimEnd(spaceNameIndex, endIndex, query);
            if (spaceEndIndex > spaceNameIndex) {
                var tmp;
                if (decode) tmp = decodeURLQueryComponent(query, spaceNameIndex, spaceEndIndex);
                else // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp = query.substring(spaceNameIndex, spaceEndIndex);
                var name = tmp;
                _this__u8e3s4.s43(name, emptyList());
            }
            return Unit_instance;
        }
        var spaceNameIndex_0 = trimStart(nameIndex, equalIndex, query);
        var spaceEqualIndex = trimEnd(spaceNameIndex_0, equalIndex, query);
        if (spaceEqualIndex > spaceNameIndex_0) {
            var tmp_0;
            if (decode) tmp_0 = decodeURLQueryComponent(query, spaceNameIndex_0, spaceEqualIndex);
            else // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_0 = query.substring(spaceNameIndex_0, spaceEqualIndex);
            var name_0 = tmp_0;
            var spaceValueIndex = trimStart(equalIndex + 1 | 0, endIndex, query);
            var spaceEndIndex_0 = trimEnd(spaceValueIndex, endIndex, query);
            var tmp_1;
            if (decode) tmp_1 = decodeURLQueryComponent(query, spaceValueIndex, spaceEndIndex_0, true);
            else // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_1 = query.substring(spaceValueIndex, spaceEndIndex_0);
            var value = tmp_1;
            _this__u8e3s4.w43(name_0, value);
        }
    }
    function trimStart(start, end, query) {
        var spaceIndex = start;
        while(spaceIndex < end && isWhitespace(charSequenceGet(query, spaceIndex)))spaceIndex = spaceIndex + 1 | 0;
        return spaceIndex;
    }
    function trimEnd(start, end, text) {
        var spaceIndex = end;
        while(spaceIndex > start && isWhitespace(charSequenceGet(text, spaceIndex - 1 | 0)))spaceIndex = spaceIndex - 1 | 0;
        return spaceIndex;
    }
    function applyOrigin($this) {
        var tmp;
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_0 = $this.o4g_1;
        if (charSequenceLength(this_0) > 0) tmp = true;
        else tmp = $this.n4g_1.x4g_1 === "file";
        if (tmp) return Unit_instance;
        $this.o4g_1 = Companion_getInstance_6().p4h_1.a4h_1;
        if ($this.n4g_1.equals(Companion_getInstance_7().q4h_1)) $this.n4g_1 = Companion_getInstance_6().p4h_1.z4g_1;
        if ($this.p4g_1 === 0) $this.p4g_1 = Companion_getInstance_6().p4h_1.b4h_1;
    }
    function Companion_6() {
        Companion_instance_7 = this;
        this.p4h_1 = Url(get_origin(this));
    }
    var Companion_instance_7;
    function Companion_getInstance_6() {
        if (Companion_instance_7 == null) new Companion_6();
        return Companion_instance_7;
    }
    function URLBuilder(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
        Companion_getInstance_6();
        protocol = protocol === VOID ? Companion_getInstance_7().q4h_1 : protocol;
        host = host === VOID ? "" : host;
        port = port === VOID ? 0 : port;
        user = user === VOID ? null : user;
        password = password === VOID ? null : password;
        pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
        parameters = parameters === VOID ? Companion_getInstance_5().k4g_1 : parameters;
        fragment = fragment === VOID ? "" : fragment;
        trailingQuery = trailingQuery === VOID ? false : trailingQuery;
        this.n4g_1 = protocol;
        this.o4g_1 = host;
        this.p4g_1 = port;
        this.q4g_1 = trailingQuery;
        var tmp = this;
        tmp.r4g_1 = user == null ? null : encodeURLParameter(user);
        var tmp_0 = this;
        tmp_0.s4g_1 = password == null ? null : encodeURLParameter(password);
        this.t4g_1 = encodeURLQueryComponent(fragment);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(pathSegments, 10));
        var tmp0_iterator = pathSegments.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.http.URLBuilder.encodedPathSegments.<anonymous>' call
            var tmp$ret$0 = encodeURLPathPart(item);
            destination.e(tmp$ret$0);
        }
        tmp_1.u4g_1 = destination;
        this.v4g_1 = encodeParameters(parameters);
        this.w4g_1 = new UrlDecodedParametersBuilder(this.v4g_1);
    }
    protoOf(URLBuilder).w4h = function(value) {
        var tmp = this;
        tmp.r4g_1 = value == null ? null : encodeURLParameter(value);
    };
    protoOf(URLBuilder).x4h = function() {
        var tmp0_safe_receiver = this.r4g_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
    };
    protoOf(URLBuilder).y4h = function() {
        var tmp0_safe_receiver = this.s4g_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
    };
    protoOf(URLBuilder).z4h = function() {
        return decodeURLQueryComponent(this.t4g_1);
    };
    protoOf(URLBuilder).a4i = function(value) {
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
        var tmp0_iterator = value.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.http.URLBuilder.<set-pathSegments>.<anonymous>' call
            var tmp$ret$0 = encodeURLPathPart(item);
            destination.e(tmp$ret$0);
        }
        tmp.u4g_1 = destination;
    };
    protoOf(URLBuilder).b4i = function() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.u4g_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.http.URLBuilder.<get-pathSegments>.<anonymous>' call
            var tmp$ret$0 = decodeURLPart(item);
            destination.e(tmp$ret$0);
        }
        return destination;
    };
    protoOf(URLBuilder).c4i = function(value) {
        this.v4g_1 = value;
        this.w4g_1 = new UrlDecodedParametersBuilder(value);
    };
    protoOf(URLBuilder).d4i = function() {
        applyOrigin(this);
        return appendTo(this, StringBuilder_init_$Create$_0(256)).toString();
    };
    protoOf(URLBuilder).toString = function() {
        return appendTo(this, StringBuilder_init_$Create$_0(256)).toString();
    };
    protoOf(URLBuilder).c3r = function() {
        applyOrigin(this);
        return new Url_0(this.n4g_1, this.o4g_1, this.p4g_1, this.b4i(), this.w4g_1.c3r(), this.z4h(), this.x4h(), this.y4h(), this.q4g_1, this.d4i());
    };
    function get_authority(_this__u8e3s4) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.<get-authority>.<anonymous>' call
        this_0.e8(get_encodedUserAndPassword(_this__u8e3s4));
        this_0.e8(_this__u8e3s4.o4g_1);
        if (!(_this__u8e3s4.p4g_1 === 0) && !(_this__u8e3s4.p4g_1 === _this__u8e3s4.n4g_1.y4g_1)) {
            this_0.e8(":");
            this_0.e8(_this__u8e3s4.p4g_1.toString());
        }
        return this_0.toString();
    }
    function path(_this__u8e3s4, path) {
        var tmp = _this__u8e3s4;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(path.length);
        var inductionVariable = 0;
        var last = path.length;
        while(inductionVariable < last){
            var item = path[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'io.ktor.http.path.<anonymous>' call
            var tmp$ret$0 = encodeURLPath(item);
            destination.e(tmp$ret$0);
        }
        tmp.u4g_1 = destination;
    }
    function appendTo(_this__u8e3s4, out) {
        out.f(_this__u8e3s4.n4g_1.x4g_1);
        var tmp0_subject = _this__u8e3s4.n4g_1.x4g_1;
        if (tmp0_subject === "file") {
            appendFile(out, _this__u8e3s4.o4g_1, get_encodedPath(_this__u8e3s4));
            return out;
        } else if (tmp0_subject === "mailto") {
            appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.o4g_1);
            return out;
        }
        out.f("://");
        out.f(get_authority(_this__u8e3s4));
        appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.v4g_1, _this__u8e3s4.q4g_1);
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_0 = _this__u8e3s4.t4g_1;
        if (charSequenceLength(this_0) > 0) {
            out.f8(_Char___init__impl__6a9atx(35));
            out.f(_this__u8e3s4.t4g_1);
        }
        return out;
    }
    function get_encodedUserAndPassword(_this__u8e3s4) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.<get-encodedUserAndPassword>.<anonymous>' call
        appendUserAndPassword(this_0, _this__u8e3s4.r4g_1, _this__u8e3s4.s4g_1);
        return this_0.toString();
    }
    function appendFile(_this__u8e3s4, host, encodedPath) {
        _this__u8e3s4.f("://");
        _this__u8e3s4.f(host);
        if (!startsWith(encodedPath, _Char___init__impl__6a9atx(47))) _this__u8e3s4.f8(_Char___init__impl__6a9atx(47));
        _this__u8e3s4.f(encodedPath);
    }
    function set_encodedPath(_this__u8e3s4, value) {
        _this__u8e3s4.u4g_1 = isBlank(value) ? emptyList() : value === "/" ? get_ROOT_PATH() : toMutableList(split(value, charArrayOf([
            _Char___init__impl__6a9atx(47)
        ])));
    }
    function get_encodedPath(_this__u8e3s4) {
        return joinPath(_this__u8e3s4.u4g_1);
    }
    function appendMailto(_this__u8e3s4, encodedUser, host) {
        _this__u8e3s4.f(":");
        _this__u8e3s4.f(encodedUser);
        _this__u8e3s4.f(host);
    }
    function joinPath(_this__u8e3s4) {
        if (_this__u8e3s4.s()) return "";
        if (_this__u8e3s4.m() === 1) {
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = first_0(_this__u8e3s4);
            if (charSequenceLength(this_0) === 0) return "/";
            return first_0(_this__u8e3s4);
        }
        return joinToString(_this__u8e3s4, "/");
    }
    function get_ROOT_PATH() {
        _init_properties_URLParser_kt__sf11to();
        return ROOT_PATH;
    }
    var ROOT_PATH;
    function takeFrom(_this__u8e3s4, urlString) {
        _init_properties_URLParser_kt__sf11to();
        if (isBlank(urlString)) return _this__u8e3s4;
        var tmp;
        try {
            tmp = takeFromUnsafe(_this__u8e3s4, urlString);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Error) {
                var cause = $p;
                throw new URLParserException(urlString, cause);
            } else throw $p;
        }
        return tmp;
    }
    function takeFromUnsafe(_this__u8e3s4, urlString) {
        _init_properties_URLParser_kt__sf11to();
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.indexOfFirst' call
            var inductionVariable = 0;
            var last = charSequenceLength(urlString) - 1 | 0;
            if (inductionVariable <= last) do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
                var it = charSequenceGet(urlString, index);
                if (!isWhitespace(it)) {
                    tmp$ret$1 = index;
                    break $l$block;
                }
            }while (inductionVariable <= last);
            tmp$ret$1 = -1;
        }
        var startIndex = tmp$ret$1;
        var tmp$ret$3;
        $l$block_0: {
            // Inline function 'kotlin.text.indexOfLast' call
            var inductionVariable_0 = charSequenceLength(urlString) - 1 | 0;
            if (0 <= inductionVariable_0) do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + -1 | 0;
                // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
                var it_0 = charSequenceGet(urlString, index_0);
                if (!isWhitespace(it_0)) {
                    tmp$ret$3 = index_0;
                    break $l$block_0;
                }
            }while (0 <= inductionVariable_0);
            tmp$ret$3 = -1;
        }
        var endIndex = tmp$ret$3 + 1 | 0;
        var schemeLength = findScheme(urlString, startIndex, endIndex);
        if (schemeLength > 0) {
            // Inline function 'kotlin.text.substring' call
            var startIndex_0 = startIndex;
            var endIndex_0 = startIndex + schemeLength | 0;
            // Inline function 'kotlin.js.asDynamic' call
            var scheme = urlString.substring(startIndex_0, endIndex_0);
            _this__u8e3s4.n4g_1 = Companion_getInstance_7().e4i(scheme);
            startIndex = startIndex + (schemeLength + 1 | 0) | 0;
        }
        var slashCount = count(urlString, startIndex, endIndex, _Char___init__impl__6a9atx(47));
        startIndex = startIndex + slashCount | 0;
        if (_this__u8e3s4.n4g_1.x4g_1 === "file") {
            parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount);
            return _this__u8e3s4;
        }
        if (_this__u8e3s4.n4g_1.x4g_1 === "mailto") {
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(slashCount === 0)) {
                // Inline function 'kotlin.require.<anonymous>' call
                var message = "Failed requirement.";
                throw IllegalArgumentException_init_$Create$(toString(message));
            }
            parseMailto(_this__u8e3s4, urlString, startIndex, endIndex);
            return _this__u8e3s4;
        }
        if (slashCount >= 2) loop: while(true){
            // Inline function 'kotlin.takeIf' call
            var this_0 = indexOfAny(urlString, toCharArray("@/\\?#"), startIndex);
            // Inline function 'kotlin.contracts.contract' call
            var tmp;
            // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
            if (this_0 > 0) tmp = this_0;
            else tmp = null;
            var tmp0_elvis_lhs = tmp;
            var delimiter = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
            if (delimiter < endIndex && charSequenceGet(urlString, delimiter) === _Char___init__impl__6a9atx(64)) {
                var passwordIndex = indexOfColonInHostPort(urlString, startIndex, delimiter);
                if (!(passwordIndex === -1)) {
                    var tmp_0 = _this__u8e3s4;
                    // Inline function 'kotlin.text.substring' call
                    var startIndex_1 = startIndex;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp_0.r4g_1 = urlString.substring(startIndex_1, passwordIndex);
                    var tmp_1 = _this__u8e3s4;
                    // Inline function 'kotlin.text.substring' call
                    var startIndex_2 = passwordIndex + 1 | 0;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp_1.s4g_1 = urlString.substring(startIndex_2, delimiter);
                } else {
                    var tmp_2 = _this__u8e3s4;
                    // Inline function 'kotlin.text.substring' call
                    var startIndex_3 = startIndex;
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp_2.r4g_1 = urlString.substring(startIndex_3, delimiter);
                }
                startIndex = delimiter + 1 | 0;
            } else {
                fillHost(_this__u8e3s4, urlString, startIndex, delimiter);
                startIndex = delimiter;
                break loop;
            }
        }
        if (startIndex >= endIndex) {
            _this__u8e3s4.u4g_1 = charSequenceGet(urlString, endIndex - 1 | 0) === _Char___init__impl__6a9atx(47) ? get_ROOT_PATH() : emptyList();
            return _this__u8e3s4;
        }
        var tmp_3 = _this__u8e3s4;
        var tmp_4;
        if (slashCount === 0) tmp_4 = dropLast(_this__u8e3s4.u4g_1, 1);
        else tmp_4 = emptyList();
        tmp_3.u4g_1 = tmp_4;
        // Inline function 'kotlin.takeIf' call
        var this_1 = indexOfAny(urlString, toCharArray("?#"), startIndex);
        // Inline function 'kotlin.contracts.contract' call
        var tmp_5;
        // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
        if (this_1 > 0) tmp_5 = this_1;
        else tmp_5 = null;
        var tmp1_elvis_lhs = tmp_5;
        var pathEnd = tmp1_elvis_lhs == null ? endIndex : tmp1_elvis_lhs;
        if (pathEnd > startIndex) {
            // Inline function 'kotlin.text.substring' call
            var startIndex_4 = startIndex;
            // Inline function 'kotlin.js.asDynamic' call
            var rawPath = urlString.substring(startIndex_4, pathEnd);
            var tmp_6;
            var tmp_7;
            if (_this__u8e3s4.u4g_1.m() === 1) {
                // Inline function 'kotlin.text.isEmpty' call
                var this_2 = first_0(_this__u8e3s4.u4g_1);
                tmp_7 = charSequenceLength(this_2) === 0;
            } else tmp_7 = false;
            if (tmp_7) tmp_6 = emptyList();
            else tmp_6 = _this__u8e3s4.u4g_1;
            var basePath = tmp_6;
            var rawChunks = rawPath === "/" ? get_ROOT_PATH() : split(rawPath, charArrayOf([
                _Char___init__impl__6a9atx(47)
            ]));
            var relativePath = plus_0(slashCount === 1 ? get_ROOT_PATH() : emptyList(), rawChunks);
            _this__u8e3s4.u4g_1 = plus_0(basePath, relativePath);
            startIndex = pathEnd;
        }
        if (startIndex < endIndex && charSequenceGet(urlString, startIndex) === _Char___init__impl__6a9atx(63)) startIndex = parseQuery(_this__u8e3s4, urlString, startIndex, endIndex);
        parseFragment(_this__u8e3s4, urlString, startIndex, endIndex);
        return _this__u8e3s4;
    }
    function URLParserException(urlString, cause) {
        IllegalStateException_init_$Init$("Fail to parse url: " + urlString, cause, this);
        captureStack(this, URLParserException);
    }
    function findScheme(urlString, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        var current = startIndex;
        var incorrectSchemePosition = -1;
        var firstChar = charSequenceGet(urlString, current);
        if (!(_Char___init__impl__6a9atx(97) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(90) : false)) incorrectSchemePosition = current;
        while(current < endIndex){
            var char = charSequenceGet(urlString, current);
            if (char === _Char___init__impl__6a9atx(58)) {
                if (!(incorrectSchemePosition === -1)) throw IllegalArgumentException_init_$Create$("Illegal character in scheme at position " + incorrectSchemePosition);
                return current - startIndex | 0;
            }
            if (char === _Char___init__impl__6a9atx(47) || char === _Char___init__impl__6a9atx(63) || char === _Char___init__impl__6a9atx(35)) return -1;
            if (incorrectSchemePosition === -1 && !(_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(90) : false) && !(_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) && !(char === _Char___init__impl__6a9atx(46)) && !(char === _Char___init__impl__6a9atx(43)) && !(char === _Char___init__impl__6a9atx(45))) incorrectSchemePosition = current;
            current = current + 1 | 0;
        }
        return -1;
    }
    function count(urlString, startIndex, endIndex, char) {
        _init_properties_URLParser_kt__sf11to();
        var result = 0;
        $l$loop: while((startIndex + result | 0) < endIndex && charSequenceGet(urlString, startIndex + result | 0) === char)result = result + 1 | 0;
        return result;
    }
    function parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount) {
        _init_properties_URLParser_kt__sf11to();
        switch(slashCount){
            case 2:
                var nextSlash = indexOf(urlString, _Char___init__impl__6a9atx(47), startIndex);
                if (nextSlash === -1 || nextSlash === endIndex) {
                    var tmp = _this__u8e3s4;
                    // Inline function 'kotlin.text.substring' call
                    // Inline function 'kotlin.js.asDynamic' call
                    tmp.o4g_1 = urlString.substring(startIndex, endIndex);
                    return Unit_instance;
                }
                var tmp_0 = _this__u8e3s4;
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0.o4g_1 = urlString.substring(startIndex, nextSlash);
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$5 = urlString.substring(nextSlash, endIndex);
                set_encodedPath(_this__u8e3s4, tmp$ret$5);
                break;
            case 3:
                _this__u8e3s4.o4g_1 = "";
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$7 = urlString.substring(startIndex, endIndex);
                set_encodedPath(_this__u8e3s4, "/" + tmp$ret$7);
                break;
            default:
                throw IllegalArgumentException_init_$Create$("Invalid file url: " + urlString);
        }
    }
    function parseMailto(_this__u8e3s4, urlString, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        var delimiter = indexOf_0(urlString, "@", startIndex);
        if (delimiter === -1) throw IllegalArgumentException_init_$Create$("Invalid mailto url: " + urlString + ", it should contain '@'.");
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = urlString.substring(startIndex, delimiter);
        _this__u8e3s4.w4h(decodeURLPart(tmp$ret$1));
        var tmp = _this__u8e3s4;
        // Inline function 'kotlin.text.substring' call
        var startIndex_0 = delimiter + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp.o4g_1 = urlString.substring(startIndex_0, endIndex);
    }
    function indexOfColonInHostPort(_this__u8e3s4, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        var skip = false;
        var inductionVariable = startIndex;
        if (inductionVariable < endIndex) do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp1_subject = charSequenceGet(_this__u8e3s4, index);
            if (tmp1_subject === _Char___init__impl__6a9atx(91)) skip = true;
            else if (tmp1_subject === _Char___init__impl__6a9atx(93)) skip = false;
            else if (tmp1_subject === _Char___init__impl__6a9atx(58)) {
                if (!skip) return index;
            }
        }while (inductionVariable < endIndex);
        return -1;
    }
    function fillHost(_this__u8e3s4, urlString, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        // Inline function 'kotlin.takeIf' call
        var this_0 = indexOfColonInHostPort(urlString, startIndex, endIndex);
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'io.ktor.http.fillHost.<anonymous>' call
        if (this_0 > 0) tmp = this_0;
        else tmp = null;
        var tmp0_elvis_lhs = tmp;
        var colonIndex = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
        var tmp_0 = _this__u8e3s4;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0.o4g_1 = urlString.substring(startIndex, colonIndex);
        if ((colonIndex + 1 | 0) < endIndex) {
            var tmp_1 = _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var startIndex_0 = colonIndex + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$5 = urlString.substring(startIndex_0, endIndex);
            tmp_1.p4g_1 = toInt(tmp$ret$5);
        } else _this__u8e3s4.p4g_1 = 0;
    }
    function parseQuery(_this__u8e3s4, urlString, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        if ((startIndex + 1 | 0) === endIndex) {
            _this__u8e3s4.q4g_1 = true;
            return endIndex;
        }
        // Inline function 'kotlin.takeIf' call
        var this_0 = indexOf(urlString, _Char___init__impl__6a9atx(35), startIndex + 1 | 0);
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'io.ktor.http.parseQuery.<anonymous>' call
        if (this_0 > 0) tmp = this_0;
        else tmp = null;
        var tmp0_elvis_lhs = tmp;
        var fragmentStart = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
        // Inline function 'kotlin.text.substring' call
        var startIndex_0 = startIndex + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = urlString.substring(startIndex_0, fragmentStart);
        var rawParameters = parseQueryString(tmp$ret$3, VOID, VOID, false);
        rawParameters.o43(parseQuery$lambda(_this__u8e3s4));
        return fragmentStart;
    }
    function parseFragment(_this__u8e3s4, urlString, startIndex, endIndex) {
        _init_properties_URLParser_kt__sf11to();
        if (startIndex < endIndex && charSequenceGet(urlString, startIndex) === _Char___init__impl__6a9atx(35)) {
            var tmp = _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var startIndex_0 = startIndex + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp.t4g_1 = urlString.substring(startIndex_0, endIndex);
        }
    }
    function parseQuery$lambda($this_parseQuery) {
        return function(key, values) {
            $this_parseQuery.v4g_1.s43(key, values);
            return Unit_instance;
        };
    }
    var properties_initialized_URLParser_kt_hd1g6a;
    function _init_properties_URLParser_kt__sf11to() {
        if (!properties_initialized_URLParser_kt_hd1g6a) {
            properties_initialized_URLParser_kt_hd1g6a = true;
            ROOT_PATH = listOf_0("");
        }
    }
    function isWebsocket(_this__u8e3s4) {
        return _this__u8e3s4.x4g_1 === "ws" || _this__u8e3s4.x4g_1 === "wss";
    }
    function Companion_7() {
        Companion_instance_8 = this;
        this.q4h_1 = new URLProtocol("http", 80);
        this.r4h_1 = new URLProtocol("https", 443);
        this.s4h_1 = new URLProtocol("ws", 80);
        this.t4h_1 = new URLProtocol("wss", 443);
        this.u4h_1 = new URLProtocol("socks", 1080);
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = listOf([
            this.q4h_1,
            this.r4h_1,
            this.s4h_1,
            this.t4h_1,
            this.u4h_1
        ]);
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap_init_$Create$(capacity);
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.Companion.byName.<anonymous>' call
            var tmp$ret$0 = element.x4g_1;
            destination.m2(tmp$ret$0, element);
        }
        tmp.v4h_1 = destination;
    }
    protoOf(Companion_7).e4i = function(name) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.Companion.createOrDefault.<anonymous>' call
        var it = toLowerCasePreservingASCIIRules(name);
        var tmp0_elvis_lhs = Companion_getInstance_7().v4h_1.e2(it);
        return tmp0_elvis_lhs == null ? new URLProtocol(it, 0) : tmp0_elvis_lhs;
    };
    var Companion_instance_8;
    function Companion_getInstance_7() {
        if (Companion_instance_8 == null) new Companion_7();
        return Companion_instance_8;
    }
    function URLProtocol(name, defaultPort) {
        Companion_getInstance_7();
        this.x4g_1 = name;
        this.y4g_1 = defaultPort;
        // Inline function 'kotlin.require' call
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.text.all' call
            var indexedObject = this.x4g_1;
            var inductionVariable = 0;
            while(inductionVariable < charSequenceLength(indexedObject)){
                var element = charSequenceGet(indexedObject, inductionVariable);
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'io.ktor.http.URLProtocol.<anonymous>' call
                if (!isLowerCase(element)) {
                    tmp$ret$1 = false;
                    break $l$block;
                }
            }
            tmp$ret$1 = true;
        }
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp$ret$1) {
            // Inline function 'io.ktor.http.URLProtocol.<anonymous>' call
            var message = "All characters should be lower case";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
    }
    protoOf(URLProtocol).toString = function() {
        return "URLProtocol(name=" + this.x4g_1 + ", defaultPort=" + this.y4g_1 + ")";
    };
    protoOf(URLProtocol).hashCode = function() {
        var result = getStringHashCode(this.x4g_1);
        result = imul(result, 31) + this.y4g_1 | 0;
        return result;
    };
    protoOf(URLProtocol).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof URLProtocol)) return false;
        var tmp0_other_with_cast = other instanceof URLProtocol ? other : THROW_CCE();
        if (!(this.x4g_1 === tmp0_other_with_cast.x4g_1)) return false;
        if (!(this.y4g_1 === tmp0_other_with_cast.y4g_1)) return false;
        return true;
    };
    function isSecure(_this__u8e3s4) {
        return _this__u8e3s4.x4g_1 === "https" || _this__u8e3s4.x4g_1 === "wss";
    }
    function takeFrom_0(_this__u8e3s4, url) {
        _this__u8e3s4.n4g_1 = url.n4g_1;
        _this__u8e3s4.o4g_1 = url.o4g_1;
        _this__u8e3s4.p4g_1 = url.p4g_1;
        _this__u8e3s4.u4g_1 = url.u4g_1;
        _this__u8e3s4.r4g_1 = url.r4g_1;
        _this__u8e3s4.s4g_1 = url.s4g_1;
        // Inline function 'kotlin.apply' call
        var this_0 = ParametersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.takeFrom.<anonymous>' call
        appendAll(this_0, url.v4g_1);
        _this__u8e3s4.c4i(this_0);
        _this__u8e3s4.t4g_1 = url.t4g_1;
        _this__u8e3s4.q4g_1 = url.q4g_1;
        return _this__u8e3s4;
    }
    function URLBuilder_0(urlString) {
        return takeFrom(new URLBuilder(), urlString);
    }
    function URLBuilder_1(url) {
        return takeFrom_1(new URLBuilder(), url);
    }
    function Url(urlString) {
        return URLBuilder_0(urlString).c3r();
    }
    function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
        var tmp;
        // Inline function 'kotlin.text.isNotBlank' call
        if (!isBlank(encodedPath)) tmp = !startsWith_0(encodedPath, "/");
        else tmp = false;
        if (tmp) _this__u8e3s4.f8(_Char___init__impl__6a9atx(47));
        _this__u8e3s4.f(encodedPath);
        if (!encodedQueryParameters.s() || trailingQuery) _this__u8e3s4.f("?");
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var this_0 = encodedQueryParameters.n43();
        var destination = ArrayList_init_$Create$_0();
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.appendUrlFullPath.<anonymous>' call
            // Inline function 'kotlin.collections.component1' call
            var key = element.a1();
            // Inline function 'kotlin.collections.component2' call
            var value = element.b1();
            var tmp_0;
            if (value.s()) tmp_0 = listOf_0(to(key, null));
            else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
                var tmp0_iterator_0 = value.j();
                while(tmp0_iterator_0.k()){
                    var item = tmp0_iterator_0.l();
                    // Inline function 'io.ktor.http.appendUrlFullPath.<anonymous>.<anonymous>' call
                    var tmp$ret$3 = to(key, item);
                    destination_0.e(tmp$ret$3);
                }
                tmp_0 = destination_0;
            }
            var list = tmp_0;
            addAll(destination, list);
        }
        var tmp_1 = destination;
        joinTo(tmp_1, _this__u8e3s4, "&", VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
    }
    function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
        if (encodedUser == null) return Unit_instance;
        _this__u8e3s4.e8(encodedUser);
        if (!(encodedPassword == null)) {
            _this__u8e3s4.f8(_Char___init__impl__6a9atx(58));
            _this__u8e3s4.e8(encodedPassword);
        }
        _this__u8e3s4.e8("@");
    }
    function get_hostWithPort(_this__u8e3s4) {
        return _this__u8e3s4.a4h_1 + ":" + _this__u8e3s4.f4i();
    }
    function takeFrom_1(_this__u8e3s4, url) {
        _this__u8e3s4.n4g_1 = url.z4g_1;
        _this__u8e3s4.o4g_1 = url.a4h_1;
        _this__u8e3s4.p4g_1 = url.f4i();
        set_encodedPath(_this__u8e3s4, url.g4i());
        _this__u8e3s4.r4g_1 = url.h4i();
        _this__u8e3s4.s4g_1 = url.i4i();
        // Inline function 'kotlin.apply' call
        var this_0 = ParametersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.takeFrom.<anonymous>' call
        this_0.x43(parseQueryString(url.j4i(), VOID, VOID, false));
        _this__u8e3s4.c4i(this_0);
        _this__u8e3s4.t4g_1 = url.k4i();
        _this__u8e3s4.q4g_1 = url.h4h_1;
        return _this__u8e3s4;
    }
    function appendUrlFullPath$lambda(it) {
        var key = it.z9_1;
        var tmp;
        if (it.aa_1 == null) tmp = key;
        else {
            var value = toString_1(it.aa_1);
            tmp = key + "=" + value;
        }
        return tmp;
    }
    function Companion_8() {}
    var Companion_instance_9;
    function Companion_getInstance_8() {
        return Companion_instance_9;
    }
    function Url$encodedPath$delegate$lambda(this$0) {
        return function() {
            var tmp;
            if (this$0.c4h_1.s()) return "";
            var pathStartIndex = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(47), this$0.z4g_1.x4g_1.length + 3 | 0);
            var tmp_0;
            if (pathStartIndex === -1) return "";
            // Inline function 'kotlin.charArrayOf' call
            var tmp$ret$0 = charArrayOf([
                _Char___init__impl__6a9atx(63),
                _Char___init__impl__6a9atx(35)
            ]);
            var pathEndIndex = indexOfAny(this$0.i4h_1, tmp$ret$0, pathStartIndex);
            var tmp_1;
            if (pathEndIndex === -1) // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(pathStartIndex);
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(pathStartIndex, pathEndIndex);
        };
    }
    function Url$encodedQuery$delegate$lambda(this$0) {
        return function() {
            var queryStart = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
            var tmp;
            if (queryStart === 0) return "";
            var queryEnd = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(35), queryStart);
            var tmp_0;
            if (queryEnd === -1) // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(queryStart);
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(queryStart, queryEnd);
        };
    }
    function Url$encodedPathAndQuery$delegate$lambda(this$0) {
        return function() {
            var pathStart = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(47), this$0.z4g_1.x4g_1.length + 3 | 0);
            var tmp;
            if (pathStart === -1) return "";
            var queryEnd = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(35), pathStart);
            var tmp_0;
            if (queryEnd === -1) // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(pathStart);
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(pathStart, queryEnd);
        };
    }
    function Url$encodedUser$delegate$lambda(this$0) {
        return function() {
            var tmp;
            if (this$0.f4h_1 == null) return null;
            var tmp_0;
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = this$0.f4h_1;
            if (charSequenceLength(this_0) === 0) return "";
            var usernameStart = this$0.z4g_1.x4g_1.length + 3 | 0;
            // Inline function 'kotlin.charArrayOf' call
            var tmp$ret$1 = charArrayOf([
                _Char___init__impl__6a9atx(58),
                _Char___init__impl__6a9atx(64)
            ]);
            var usernameEnd = indexOfAny(this$0.i4h_1, tmp$ret$1, usernameStart);
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(usernameStart, usernameEnd);
        };
    }
    function Url$encodedPassword$delegate$lambda(this$0) {
        return function() {
            var tmp;
            if (this$0.g4h_1 == null) return null;
            var tmp_0;
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = this$0.g4h_1;
            if (charSequenceLength(this_0) === 0) return "";
            var passwordStart = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(58), this$0.z4g_1.x4g_1.length + 3 | 0) + 1 | 0;
            var passwordEnd = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(64));
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(passwordStart, passwordEnd);
        };
    }
    function Url$encodedFragment$delegate$lambda(this$0) {
        return function() {
            var fragmentStart = indexOf(this$0.i4h_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
            var tmp;
            if (fragmentStart === 0) return "";
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            return this$0.i4h_1.substring(fragmentStart);
        };
    }
    function Url_0(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
        this.z4g_1 = protocol;
        this.a4h_1 = host;
        this.b4h_1 = specifiedPort;
        this.c4h_1 = pathSegments;
        this.d4h_1 = parameters;
        this.e4h_1 = fragment;
        this.f4h_1 = user;
        this.g4h_1 = password;
        this.h4h_1 = trailingQuery;
        this.i4h_1 = urlString;
        // Inline function 'kotlin.require' call
        var tmp;
        var containsArg = this.b4h_1;
        if (0 <= containsArg ? containsArg <= 65535 : false) tmp = true;
        else tmp = this.b4h_1 === 0;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp) {
            // Inline function 'io.ktor.http.Url.<anonymous>' call
            var message = "port must be between 0 and 65535, or 0 if not set";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
        var tmp_0 = this;
        tmp_0.j4h_1 = lazy_0(Url$encodedPath$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.k4h_1 = lazy_0(Url$encodedQuery$delegate$lambda(this));
        var tmp_2 = this;
        tmp_2.l4h_1 = lazy_0(Url$encodedPathAndQuery$delegate$lambda(this));
        var tmp_3 = this;
        tmp_3.m4h_1 = lazy_0(Url$encodedUser$delegate$lambda(this));
        var tmp_4 = this;
        tmp_4.n4h_1 = lazy_0(Url$encodedPassword$delegate$lambda(this));
        var tmp_5 = this;
        tmp_5.o4h_1 = lazy_0(Url$encodedFragment$delegate$lambda(this));
    }
    protoOf(Url_0).f4i = function() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.b4h_1;
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'io.ktor.http.Url.<get-port>.<anonymous>' call
        if (!(this_0 === 0)) tmp = this_0;
        else tmp = null;
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? this.z4g_1.y4g_1 : tmp0_elvis_lhs;
    };
    protoOf(Url_0).g4i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.j4h_1;
        encodedPath$factory();
        return this_0.b1();
    };
    protoOf(Url_0).j4i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.k4h_1;
        encodedQuery$factory();
        return this_0.b1();
    };
    protoOf(Url_0).h4i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.m4h_1;
        encodedUser$factory();
        return this_0.b1();
    };
    protoOf(Url_0).i4i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.n4h_1;
        encodedPassword$factory();
        return this_0.b1();
    };
    protoOf(Url_0).k4i = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.o4h_1;
        encodedFragment$factory();
        return this_0.b1();
    };
    protoOf(Url_0).toString = function() {
        return this.i4h_1;
    };
    protoOf(Url_0).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof Url_0)) THROW_CCE();
        if (!(this.i4h_1 === other.i4h_1)) return false;
        return true;
    };
    protoOf(Url_0).hashCode = function() {
        return getStringHashCode(this.i4h_1);
    };
    function get_authority_0(_this__u8e3s4) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.<get-authority>.<anonymous>' call
        this_0.e8(get_encodedUserAndPassword_0(_this__u8e3s4));
        if (_this__u8e3s4.b4h_1 === 0 || _this__u8e3s4.b4h_1 === _this__u8e3s4.z4g_1.y4g_1) this_0.e8(_this__u8e3s4.a4h_1);
        else this_0.e8(get_hostWithPort(_this__u8e3s4));
        return this_0.toString();
    }
    function get_encodedUserAndPassword_0(_this__u8e3s4) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.<get-encodedUserAndPassword>.<anonymous>' call
        appendUserAndPassword(this_0, _this__u8e3s4.h4i(), _this__u8e3s4.i4i());
        return this_0.toString();
    }
    function encodedPath$factory() {
        return getPropertyCallableRef("encodedPath", 1, KProperty1, function(receiver) {
            return receiver.g4i();
        }, null);
    }
    function encodedQuery$factory() {
        return getPropertyCallableRef("encodedQuery", 1, KProperty1, function(receiver) {
            return receiver.j4i();
        }, null);
    }
    function encodedUser$factory() {
        return getPropertyCallableRef("encodedUser", 1, KProperty1, function(receiver) {
            return receiver.h4i();
        }, null);
    }
    function encodedPassword$factory() {
        return getPropertyCallableRef("encodedPassword", 1, KProperty1, function(receiver) {
            return receiver.i4i();
        }, null);
    }
    function encodedFragment$factory() {
        return getPropertyCallableRef("encodedFragment", 1, KProperty1, function(receiver) {
            return receiver.k4i();
        }, null);
    }
    function UrlDecodedParametersBuilder(encodedParametersBuilder) {
        this.l4i_1 = encodedParametersBuilder;
        this.m4i_1 = this.l4i_1.k43();
    }
    protoOf(UrlDecodedParametersBuilder).c3r = function() {
        return decodeParameters(this.l4i_1);
    };
    protoOf(UrlDecodedParametersBuilder).k43 = function() {
        return this.m4i_1;
    };
    protoOf(UrlDecodedParametersBuilder).l43 = function(name) {
        var tmp0_safe_receiver = this.l4i_1.l43(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
            var tmp0_iterator = tmp0_safe_receiver.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.getAll.<anonymous>' call
                var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
                destination.e(tmp$ret$0);
            }
            tmp = destination;
        }
        return tmp;
    };
    protoOf(UrlDecodedParametersBuilder).m43 = function() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.l4i_1.m43();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.names.<anonymous>' call
            var tmp$ret$0 = decodeURLQueryComponent(item);
            destination.e(tmp$ret$0);
        }
        return toSet(destination);
    };
    protoOf(UrlDecodedParametersBuilder).s = function() {
        return this.l4i_1.s();
    };
    protoOf(UrlDecodedParametersBuilder).n43 = function() {
        return decodeParameters(this.l4i_1).n43();
    };
    protoOf(UrlDecodedParametersBuilder).w43 = function(name, value) {
        return this.l4i_1.w43(encodeURLParameter(name), encodeURLParameterValue(value));
    };
    protoOf(UrlDecodedParametersBuilder).x43 = function(stringValues) {
        return appendAllEncoded(this.l4i_1, stringValues);
    };
    protoOf(UrlDecodedParametersBuilder).s43 = function(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
        var tmp0_iterator = values.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.appendAll.<anonymous>' call
            var tmp$ret$0 = encodeURLParameterValue(item);
            destination.e(tmp$ret$0);
        }
        return this.l4i_1.s43(tmp, destination);
    };
    protoOf(UrlDecodedParametersBuilder).i2 = function() {
        return this.l4i_1.i2();
    };
    function encodeParameters(parameters) {
        // Inline function 'kotlin.apply' call
        var this_0 = ParametersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.encodeParameters.<anonymous>' call
        appendAllEncoded(this_0, parameters);
        return this_0;
    }
    function decodeParameters(parameters) {
        // Inline function 'kotlin.apply' call
        var this_0 = ParametersBuilder();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.ktor.http.decodeParameters.<anonymous>' call
        appendAllDecoded(this_0, parameters);
        return this_0.c3r();
    }
    function appendAllEncoded(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = parameters.m43().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.appendAllEncoded.<anonymous>' call
            var tmp0_elvis_lhs = parameters.l43(element);
            var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var tmp = encodeURLParameter(element);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
            var tmp0_iterator_0 = values.j();
            while(tmp0_iterator_0.k()){
                var item = tmp0_iterator_0.l();
                // Inline function 'io.ktor.http.appendAllEncoded.<anonymous>.<anonymous>' call
                var tmp$ret$0 = encodeURLParameterValue(item);
                destination.e(tmp$ret$0);
            }
            _this__u8e3s4.s43(tmp, destination);
        }
    }
    function appendAllDecoded(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = parameters.m43().j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.ktor.http.appendAllDecoded.<anonymous>' call
            var tmp0_elvis_lhs = parameters.l43(element);
            var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
            var tmp = decodeURLQueryComponent(element);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(values, 10));
            var tmp0_iterator_0 = values.j();
            while(tmp0_iterator_0.k()){
                var item = tmp0_iterator_0.l();
                // Inline function 'io.ktor.http.appendAllDecoded.<anonymous>.<anonymous>' call
                var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
                destination.e(tmp$ret$0);
            }
            _this__u8e3s4.s43(tmp, destination);
        }
    }
    function ByteArrayContent(bytes, contentType, status) {
        contentType = contentType === VOID ? null : contentType;
        status = status === VOID ? null : status;
        ByteArrayContent_0.call(this);
        this.o4i_1 = bytes;
        this.p4i_1 = contentType;
        this.q4i_1 = status;
    }
    protoOf(ByteArrayContent).r4i = function() {
        return this.p4i_1;
    };
    protoOf(ByteArrayContent).s4i = function() {
        return toLong_0(this.o4i_1.length);
    };
    protoOf(ByteArrayContent).t4i = function() {
        return this.o4i_1;
    };
    function NoContent() {
        OutgoingContent.call(this);
    }
    function ReadChannelContent() {
        OutgoingContent.call(this);
    }
    function WriteChannelContent() {}
    function ByteArrayContent_0() {
        OutgoingContent.call(this);
    }
    function ProtocolUpgrade() {}
    function OutgoingContent() {
        this.u4i_1 = null;
    }
    protoOf(OutgoingContent).r4i = function() {
        return null;
    };
    protoOf(OutgoingContent).s4i = function() {
        return null;
    };
    protoOf(OutgoingContent).m4d = function() {
        return Companion_getInstance_1().g49_1;
    };
    function NullBody() {}
    var NullBody_instance;
    function NullBody_getInstance() {
        return NullBody_instance;
    }
    function TextContent(text, contentType, status) {
        status = status === VOID ? null : status;
        ByteArrayContent_0.call(this);
        this.b4j_1 = text;
        this.c4j_1 = contentType;
        this.d4j_1 = status;
        var tmp = this;
        var tmp$ret$0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.toByteArray' call
            var this_0 = this.b4j_1;
            var tmp0_elvis_lhs = charset(this.c4j_1);
            var charset_0 = tmp0_elvis_lhs == null ? Charsets_getInstance().y3x_1 : tmp0_elvis_lhs;
            if (charset_0.equals(Charsets_getInstance().y3x_1)) {
                tmp$ret$0 = encodeToByteArray(this_0);
                break $l$block;
            }
            tmp$ret$0 = encodeToByteArray_0(charset_0.c3y(), this_0, 0, this_0.length);
        }
        tmp.e4j_1 = tmp$ret$0;
    }
    protoOf(TextContent).r4i = function() {
        return this.c4j_1;
    };
    protoOf(TextContent).s4i = function() {
        return toLong_0(this.e4j_1.length);
    };
    protoOf(TextContent).t4i = function() {
        return this.e4j_1;
    };
    protoOf(TextContent).toString = function() {
        return "TextContent[" + this.c4j_1.toString() + '] "' + take(this.b4j_1, 30) + '"';
    };
    function get_origin(_this__u8e3s4) {
        var tmp;
        if (get_platform(PlatformUtils_getInstance()).q2_1 === 2) {
            var tmp_0 = function() {
                var tmpLocation = null;
                if (typeof window !== "undefined") tmpLocation = window.location;
                else if (typeof self !== "undefined") tmpLocation = self.location;
                var origin = "";
                if (tmpLocation) origin = tmpLocation.origin;
                return origin && origin != "null" ? origin : "http://localhost";
            }();
            tmp = (!(tmp_0 == null) ? typeof tmp_0 === "string" : false) ? tmp_0 : THROW_CCE();
        } else tmp = "http://localhost";
        return tmp;
    }
    //region block: post-declaration
    protoOf(EmptyHeaders).vl = get;
    protoOf(EmptyHeaders).o43 = forEach;
    protoOf(EmptyParameters).o43 = forEach;
    //endregion
    //region block: init
    Companion_instance_1 = new Companion_0();
    EmptyHeaders_instance = new EmptyHeaders();
    EmptyParameters_instance = new EmptyParameters();
    Companion_instance_9 = new Companion_8();
    NullBody_instance = new NullBody();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = NullBody_instance;
    _.$_$.b = Application_getInstance;
    _.$_$.c = Text_getInstance;
    _.$_$.d = Companion_getInstance_1;
    _.$_$.e = HttpHeaders_getInstance;
    _.$_$.f = Companion_getInstance_2;
    _.$_$.g = Companion_getInstance_3;
    _.$_$.h = Companion_getInstance_4;
    _.$_$.i = Companion_getInstance_5;
    _.$_$.j = Companion_getInstance_7;
    _.$_$.k = ByteArrayContent;
    _.$_$.l = ByteArrayContent_0;
    _.$_$.m = NoContent;
    _.$_$.n = ProtocolUpgrade;
    _.$_$.o = ReadChannelContent;
    _.$_$.p = WriteChannelContent;
    _.$_$.q = OutgoingContent;
    _.$_$.r = TextContent;
    _.$_$.s = HeadersBuilder;
    _.$_$.t = HttpStatusCode;
    _.$_$.u = ParametersBuilder;
    _.$_$.v = URLBuilder_0;
    _.$_$.w = URLBuilder_1;
    _.$_$.x = URLBuilder;
    _.$_$.y = UnsafeHeaderException;
    _.$_$.z = Url;
    _.$_$.a1 = get_authority;
    _.$_$.b1 = get_authority_0;
    _.$_$.c1 = charset_0;
    _.$_$.d1 = charset;
    _.$_$.e1 = contentLength;
    _.$_$.f1 = contentType;
    _.$_$.g1 = contentType_0;
    _.$_$.h1 = contentType_1;
    _.$_$.i1 = formUrlEncode;
    _.$_$.j1 = isSecure;
    _.$_$.k1 = isSuccess;
    _.$_$.l1 = isWebsocket;
    _.$_$.m1 = parameters;
    _.$_$.n1 = parseAndSortHeader;
    _.$_$.o1 = path;
    _.$_$.p1 = takeFrom_1;
    _.$_$.q1 = takeFrom_0;
    _.$_$.r1 = takeFrom;
    _.$_$.s1 = withCharsetIfNeeded;
    _.$_$.t1 = withCharset;
    //endregion
    return _;
});

});

parcelRegister("kSmcm", function(module, exports) {


(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-io.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("4cHl4")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_io) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var Enum = kotlin_kotlin.$_$.ie;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var VOID = kotlin_kotlin.$_$.f;
    var toString = kotlin_kotlin.$_$.ob;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var get_lastIndex = kotlin_kotlin.$_$.k7;
    var compareTo = kotlin_kotlin.$_$.z9;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var fillArrayVal = kotlin_kotlin.$_$.da;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
    var encodeToByteArray = kotlin_kotlin.$_$.nc;
    var encodeToByteArray_0 = kotlin_io_ktor_ktor_io.$_$.j;
    var BytePacketBuilder = kotlin_io_ktor_ktor_io.$_$.p;
    var writeShort = kotlin_io_ktor_ktor_io.$_$.y;
    var writeText = kotlin_io_ktor_ktor_io.$_$.z;
    var readBytes = kotlin_io_ktor_ktor_io.$_$.u;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForClass(Codes, "Codes", VOID, Enum);
    initMetadataForClass(CloseReason, "CloseReason");
    initMetadataForObject(NonDisposableHandle, "NonDisposableHandle");
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(FrameType, "FrameType", VOID, Enum);
    initMetadataForClass(Frame, "Frame");
    initMetadataForClass(Binary, "Binary", VOID, Frame);
    initMetadataForClass(Text, "Text", VOID, Frame);
    initMetadataForClass(Close, "Close", Close_init_$Create$_0, Frame);
    initMetadataForCompanion(Companion_1);
    //endregion
    var Codes_NORMAL_instance;
    var Codes_GOING_AWAY_instance;
    var Codes_PROTOCOL_ERROR_instance;
    var Codes_CANNOT_ACCEPT_instance;
    var Codes_CLOSED_ABNORMALLY_instance;
    var Codes_NOT_CONSISTENT_instance;
    var Codes_VIOLATED_POLICY_instance;
    var Codes_TOO_BIG_instance;
    var Codes_NO_EXTENSION_instance;
    var Codes_INTERNAL_ERROR_instance;
    var Codes_SERVICE_RESTART_instance;
    var Codes_TRY_AGAIN_LATER_instance;
    function Companion() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = values();
        var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap_init_$Create$(capacity);
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var element = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'io.ktor.websocket.Companion.byCodeMap.<anonymous>' call
            var tmp$ret$0 = element.h4j_1;
            destination.m2(tmp$ret$0, element);
        }
        tmp.i4j_1 = destination;
        this.j4j_1 = Codes_INTERNAL_ERROR_getInstance();
    }
    protoOf(Companion).k4j = function(code) {
        return this.i4j_1.e2(code);
    };
    var Companion_instance;
    function Companion_getInstance() {
        Codes_initEntries();
        if (Companion_instance == null) new Companion();
        return Companion_instance;
    }
    function values() {
        return [
            Codes_NORMAL_getInstance(),
            Codes_GOING_AWAY_getInstance(),
            Codes_PROTOCOL_ERROR_getInstance(),
            Codes_CANNOT_ACCEPT_getInstance(),
            Codes_CLOSED_ABNORMALLY_getInstance(),
            Codes_NOT_CONSISTENT_getInstance(),
            Codes_VIOLATED_POLICY_getInstance(),
            Codes_TOO_BIG_getInstance(),
            Codes_NO_EXTENSION_getInstance(),
            Codes_INTERNAL_ERROR_getInstance(),
            Codes_SERVICE_RESTART_getInstance(),
            Codes_TRY_AGAIN_LATER_getInstance()
        ];
    }
    var Codes_entriesInitialized;
    function Codes_initEntries() {
        if (Codes_entriesInitialized) return Unit_instance;
        Codes_entriesInitialized = true;
        Codes_NORMAL_instance = new Codes("NORMAL", 0, 1000);
        Codes_GOING_AWAY_instance = new Codes("GOING_AWAY", 1, 1001);
        Codes_PROTOCOL_ERROR_instance = new Codes("PROTOCOL_ERROR", 2, 1002);
        Codes_CANNOT_ACCEPT_instance = new Codes("CANNOT_ACCEPT", 3, 1003);
        Codes_CLOSED_ABNORMALLY_instance = new Codes("CLOSED_ABNORMALLY", 4, 1006);
        Codes_NOT_CONSISTENT_instance = new Codes("NOT_CONSISTENT", 5, 1007);
        Codes_VIOLATED_POLICY_instance = new Codes("VIOLATED_POLICY", 6, 1008);
        Codes_TOO_BIG_instance = new Codes("TOO_BIG", 7, 1009);
        Codes_NO_EXTENSION_instance = new Codes("NO_EXTENSION", 8, 1010);
        Codes_INTERNAL_ERROR_instance = new Codes("INTERNAL_ERROR", 9, 1011);
        Codes_SERVICE_RESTART_instance = new Codes("SERVICE_RESTART", 10, 1012);
        Codes_TRY_AGAIN_LATER_instance = new Codes("TRY_AGAIN_LATER", 11, 1013);
        Companion_getInstance();
    }
    function Codes(name, ordinal, code) {
        Enum.call(this, name, ordinal);
        this.h4j_1 = code;
    }
    function Codes_NORMAL_getInstance() {
        Codes_initEntries();
        return Codes_NORMAL_instance;
    }
    function Codes_GOING_AWAY_getInstance() {
        Codes_initEntries();
        return Codes_GOING_AWAY_instance;
    }
    function Codes_PROTOCOL_ERROR_getInstance() {
        Codes_initEntries();
        return Codes_PROTOCOL_ERROR_instance;
    }
    function Codes_CANNOT_ACCEPT_getInstance() {
        Codes_initEntries();
        return Codes_CANNOT_ACCEPT_instance;
    }
    function Codes_CLOSED_ABNORMALLY_getInstance() {
        Codes_initEntries();
        return Codes_CLOSED_ABNORMALLY_instance;
    }
    function Codes_NOT_CONSISTENT_getInstance() {
        Codes_initEntries();
        return Codes_NOT_CONSISTENT_instance;
    }
    function Codes_VIOLATED_POLICY_getInstance() {
        Codes_initEntries();
        return Codes_VIOLATED_POLICY_instance;
    }
    function Codes_TOO_BIG_getInstance() {
        Codes_initEntries();
        return Codes_TOO_BIG_instance;
    }
    function Codes_NO_EXTENSION_getInstance() {
        Codes_initEntries();
        return Codes_NO_EXTENSION_instance;
    }
    function Codes_INTERNAL_ERROR_getInstance() {
        Codes_initEntries();
        return Codes_INTERNAL_ERROR_instance;
    }
    function Codes_SERVICE_RESTART_getInstance() {
        Codes_initEntries();
        return Codes_SERVICE_RESTART_instance;
    }
    function Codes_TRY_AGAIN_LATER_getInstance() {
        Codes_initEntries();
        return Codes_TRY_AGAIN_LATER_instance;
    }
    function CloseReason(code, message) {
        this.l4j_1 = code;
        this.m4j_1 = message;
    }
    protoOf(CloseReason).n4j = function() {
        return Companion_getInstance().k4j(this.l4j_1);
    };
    protoOf(CloseReason).toString = function() {
        var tmp0_elvis_lhs = this.n4j();
        return "CloseReason(reason=" + toString(tmp0_elvis_lhs == null ? this.l4j_1 : tmp0_elvis_lhs) + ", message=" + this.m4j_1 + ")";
    };
    protoOf(CloseReason).hashCode = function() {
        var result = this.l4j_1;
        result = imul(result, 31) + getStringHashCode(this.m4j_1) | 0;
        return result;
    };
    protoOf(CloseReason).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CloseReason)) return false;
        var tmp0_other_with_cast = other instanceof CloseReason ? other : THROW_CCE();
        if (!(this.l4j_1 === tmp0_other_with_cast.l4j_1)) return false;
        if (!(this.m4j_1 === tmp0_other_with_cast.m4j_1)) return false;
        return true;
    };
    function NonDisposableHandle() {}
    protoOf(NonDisposableHandle).y1p = function() {};
    protoOf(NonDisposableHandle).toString = function() {
        return "NonDisposableHandle";
    };
    var NonDisposableHandle_instance;
    function NonDisposableHandle_getInstance() {
        return NonDisposableHandle_instance;
    }
    var FrameType_TEXT_instance;
    var FrameType_BINARY_instance;
    var FrameType_CLOSE_instance;
    var FrameType_PING_instance;
    var FrameType_PONG_instance;
    function Companion_0() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp$ret$1;
        $l$block_0: {
            // Inline function 'kotlin.collections.maxByOrNull' call
            var this_0 = values_0();
            // Inline function 'kotlin.collections.isEmpty' call
            if (this_0.length === 0) {
                tmp$ret$1 = null;
                break $l$block_0;
            }
            var maxElem = this_0[0];
            var lastIndex = get_lastIndex(this_0);
            if (lastIndex === 0) {
                tmp$ret$1 = maxElem;
                break $l$block_0;
            }
            // Inline function 'io.ktor.websocket.Companion.maxOpcode.<anonymous>' call
            var maxValue = maxElem.r4j_1;
            var inductionVariable = 1;
            if (inductionVariable <= lastIndex) do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var e = this_0[i];
                // Inline function 'io.ktor.websocket.Companion.maxOpcode.<anonymous>' call
                var v = e.r4j_1;
                if (compareTo(maxValue, v) < 0) {
                    maxElem = e;
                    maxValue = v;
                }
            }while (!(i === lastIndex));
            tmp$ret$1 = maxElem;
        }
        tmp.s4j_1 = ensureNotNull(tmp$ret$1).r4j_1;
        var tmp_0 = this;
        var tmp_1 = 0;
        var tmp_2 = this.s4j_1 + 1 | 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_3 = fillArrayVal(Array(tmp_2), null);
        while(tmp_1 < tmp_2){
            var tmp_4 = tmp_1;
            var tmp$ret$6;
            $l$block_2: {
                // Inline function 'kotlin.collections.singleOrNull' call
                var single = null;
                var found = false;
                var indexedObject = values_0();
                var inductionVariable_0 = 0;
                var last = indexedObject.length;
                while(inductionVariable_0 < last){
                    var element = indexedObject[inductionVariable_0];
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'io.ktor.websocket.Companion.byOpcodeArray.<anonymous>' call
                    if (element.r4j_1 === tmp_4) {
                        if (found) {
                            tmp$ret$6 = null;
                            break $l$block_2;
                        }
                        single = element;
                        found = true;
                    }
                }
                if (!found) {
                    tmp$ret$6 = null;
                    break $l$block_2;
                }
                tmp$ret$6 = single;
            }
            tmp_3[tmp_4] = tmp$ret$6;
            tmp_1 = tmp_1 + 1 | 0;
        }
        tmp_0.t4j_1 = tmp_3;
    }
    var Companion_instance_0;
    function Companion_getInstance_0() {
        FrameType_initEntries();
        if (Companion_instance_0 == null) new Companion_0();
        return Companion_instance_0;
    }
    function values_0() {
        return [
            FrameType_TEXT_getInstance(),
            FrameType_BINARY_getInstance(),
            FrameType_CLOSE_getInstance(),
            FrameType_PING_getInstance(),
            FrameType_PONG_getInstance()
        ];
    }
    var FrameType_entriesInitialized;
    function FrameType_initEntries() {
        if (FrameType_entriesInitialized) return Unit_instance;
        FrameType_entriesInitialized = true;
        FrameType_TEXT_instance = new FrameType("TEXT", 0, false, 1);
        FrameType_BINARY_instance = new FrameType("BINARY", 1, false, 2);
        FrameType_CLOSE_instance = new FrameType("CLOSE", 2, true, 8);
        FrameType_PING_instance = new FrameType("PING", 3, true, 9);
        FrameType_PONG_instance = new FrameType("PONG", 4, true, 10);
        Companion_getInstance_0();
    }
    function FrameType(name, ordinal, controlFrame, opcode) {
        Enum.call(this, name, ordinal);
        this.q4j_1 = controlFrame;
        this.r4j_1 = opcode;
    }
    function FrameType_TEXT_getInstance() {
        FrameType_initEntries();
        return FrameType_TEXT_instance;
    }
    function FrameType_BINARY_getInstance() {
        FrameType_initEntries();
        return FrameType_BINARY_instance;
    }
    function FrameType_CLOSE_getInstance() {
        FrameType_initEntries();
        return FrameType_CLOSE_instance;
    }
    function FrameType_PING_getInstance() {
        FrameType_initEntries();
        return FrameType_PING_instance;
    }
    function FrameType_PONG_getInstance() {
        FrameType_initEntries();
        return FrameType_PONG_instance;
    }
    function Binary_init_$Init$(fin, data, $this) {
        Binary.call($this, fin, data, false, false, false);
        return $this;
    }
    function Binary_init_$Create$(fin, data) {
        return Binary_init_$Init$(fin, data, objectCreate(protoOf(Binary)));
    }
    function Text_init_$Init$(fin, data, $this) {
        Text.call($this, fin, data, false, false, false);
        return $this;
    }
    function Text_init_$Init$_0(text, $this) {
        var tmp$ret$0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.toByteArray' call
            var charset = Charsets_getInstance().y3x_1;
            if (charset.equals(Charsets_getInstance().y3x_1)) {
                tmp$ret$0 = encodeToByteArray(text);
                break $l$block;
            }
            tmp$ret$0 = encodeToByteArray_0(charset.c3y(), text, 0, text.length);
        }
        Text_init_$Init$(true, tmp$ret$0, $this);
        return $this;
    }
    function Text_init_$Create$(text) {
        return Text_init_$Init$_0(text, objectCreate(protoOf(Text)));
    }
    function Close_init_$Init$(reason, $this) {
        var tmp$ret$0;
        $l$block: {
            // Inline function 'io.ktor.utils.io.core.buildPacket' call
            // Inline function 'kotlin.contracts.contract' call
            var builder = new BytePacketBuilder();
            try {
                // Inline function 'io.ktor.websocket.Close.<init>.<anonymous>' call
                writeShort(builder, reason.l4j_1);
                writeText(builder, reason.m4j_1);
                tmp$ret$0 = builder.c3r();
                break $l$block;
            } catch ($p) {
                if ($p instanceof Error) {
                    var t = $p;
                    builder.e19();
                    throw t;
                } else throw $p;
            }
        }
        Close_init_$Init$_0(tmp$ret$0, $this);
        return $this;
    }
    function Close_init_$Create$(reason) {
        return Close_init_$Init$(reason, objectCreate(protoOf(Close)));
    }
    function Close_init_$Init$_0(packet, $this) {
        Close.call($this, readBytes(packet));
        return $this;
    }
    function Close_init_$Init$_1($this) {
        Close.call($this, Companion_getInstance_1().u4j_1);
        return $this;
    }
    function Close_init_$Create$_0() {
        return Close_init_$Init$_1(objectCreate(protoOf(Close)));
    }
    function Binary(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
    }
    function Text(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
    }
    function Close(data) {
        Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
    }
    function Companion_1() {
        Companion_instance_1 = this;
        this.u4j_1 = new Int8Array(0);
    }
    var Companion_instance_1;
    function Companion_getInstance_1() {
        if (Companion_instance_1 == null) new Companion_1();
        return Companion_instance_1;
    }
    function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance_1();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        this.v4j_1 = fin;
        this.w4j_1 = frameType;
        this.x4j_1 = data;
        this.y4j_1 = disposableHandle;
        this.z4j_1 = rsv1;
        this.a4k_1 = rsv2;
        this.b4k_1 = rsv3;
    }
    protoOf(Frame).toString = function() {
        return "Frame " + this.w4j_1.toString() + " (fin=" + this.v4j_1 + ", buffer len = " + this.x4j_1.length + ")";
    };
    //region block: init
    NonDisposableHandle_instance = new NonDisposableHandle();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Codes_CLOSED_ABNORMALLY_getInstance;
    _.$_$.b = Codes_NORMAL_getInstance;
    _.$_$.c = Binary_init_$Create$;
    _.$_$.d = Close_init_$Create$;
    _.$_$.e = Text_init_$Create$;
    _.$_$.f = Companion_getInstance;
    _.$_$.g = CloseReason;
    //endregion
    return _;
});

});


parcelRegister("koNwy", function(module, exports) {




(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-io.js",
        "./ktor-ktor-http.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("4cHl4")), (parcelRequire("4fxpJ")), (parcelRequire("ctZcf")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
    "use strict";
    //region block: imports
    var Exception = kotlin_kotlin.$_$.ke;
    var VOID = kotlin_kotlin.$_$.f;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.o1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var initMetadataForInterface = kotlin_kotlin.$_$.ma;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
    var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
    var parseAndSortHeader = kotlin_io_ktor_ktor_http.$_$.n1;
    var Companion_instance = kotlin_io_ktor_ktor_io.$_$.e;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
    var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
    var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(ContentConvertException, "ContentConvertException", VOID, Exception);
    initMetadataForClass(JsonConvertException, "JsonConvertException", VOID, ContentConvertException);
    function register$default(contentType, converter, configuration, $super) {
        var tmp;
        if (configuration === VOID) tmp = Configuration$register$lambda;
        else tmp = configuration;
        configuration = tmp;
        var tmp_0;
        if ($super === VOID) {
            this.c4k(contentType, converter, configuration);
            tmp_0 = Unit_instance;
        } else tmp_0 = $super.c4k.call(this, contentType, converter, configuration);
        return tmp_0;
    }
    initMetadataForInterface(Configuration, "Configuration");
    function serialize(contentType, charset, typeInfo, value, $completion) {
        return this.f4k(contentType, charset, typeInfo, value, $completion);
    }
    function serializeNullable(contentType, charset, typeInfo, value, $completion) {
        return this.e4k(contentType, charset, typeInfo, ensureNotNull(value), $completion);
    }
    initMetadataForInterface(ContentConverter, "ContentConverter", VOID, VOID, VOID, [
        4,
        3
    ]);
    initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, "sam$kotlinx_coroutines_flow_FlowCollector$0", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($deserializeCOROUTINE$0, CoroutineImpl);
    //endregion
    function ContentConvertException(message, cause) {
        cause = cause === VOID ? null : cause;
        Exception_init_$Init$(message, cause, this);
        captureStack(this, ContentConvertException);
    }
    function JsonConvertException(message, cause) {
        cause = cause === VOID ? null : cause;
        ContentConvertException.call(this, message, cause);
        captureStack(this, JsonConvertException);
    }
    function Configuration$register$lambda($this$null) {
        return Unit_instance;
    }
    function Configuration() {}
    function ContentConverter() {}
    function deserialize(_this__u8e3s4, body, typeInfo, charset, $completion) {
        var tmp = new $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function suitableCharset(_this__u8e3s4, defaultCharset) {
        defaultCharset = defaultCharset === VOID ? Charsets_getInstance().y3x_1 : defaultCharset;
        var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
        return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
    }
    function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
        defaultCharset = defaultCharset === VOID ? Charsets_getInstance().y3x_1 : defaultCharset;
        var tmp0_iterator = parseAndSortHeader(_this__u8e3s4.vl(HttpHeaders_getInstance().k49_1)).j();
        while(tmp0_iterator.k()){
            var charset = tmp0_iterator.l().ba();
            if (charset === "*") return defaultCharset;
            else if (Companion_instance.b41(charset)) return Companion_instance.a41(charset);
        }
        return null;
    }
    function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
        this.t4k_1 = function_0;
    }
    protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a23 = function(value, $completion) {
        return this.t4k_1(value, $completion);
    };
    function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
        this.c4l_1 = $$this$unsafeFlow;
        this.d4l_1 = $charset;
        this.e4l_1 = $typeInfo;
        this.f4l_1 = $body;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(deserialize$o$collect$slambda).i2j = function(value, $completion) {
        var tmp = this.j2j(value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(deserialize$o$collect$slambda).y9 = function(p1, $completion) {
        return this.i2j((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(deserialize$o$collect$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp_0 = this;
                    tmp_0.h4l_1 = this.c4l_1;
                    var tmp_1 = this;
                    tmp_1.i4l_1 = this.g4l_1;
                    var tmp_2 = this;
                    tmp_2.j4l_1 = this.i4l_1;
                    this.v8_1 = 1;
                    suspendResult = this.j4l_1.g4k(this.d4l_1, this.e4l_1, this.f4l_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.k4l_1 = suspendResult;
                    this.v8_1 = 2;
                    suspendResult = this.h4l_1.a23(this.k4l_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(deserialize$o$collect$slambda).j2j = function(value, completion) {
        var i = new deserialize$o$collect$slambda(this.c4l_1, this.d4l_1, this.e4l_1, this.f4l_1, completion);
        i.g4l_1 = value;
        return i;
    };
    function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
        var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
        var l = function(value, $completion) {
            return i.i2j(value, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.t4l_1 = _this__u8e3s4;
        this.u4l_1 = collector;
    }
    protoOf($collectCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.v4l_1 = this.u4l_1;
                    this.v8_1 = 1;
                    var tmp_1 = deserialize$o$collect$slambda_0(this.v4l_1, this.t4l_1.x4l_1, this.t4l_1.y4l_1, this.t4l_1.z4l_1, null);
                    suspendResult = this.t4l_1.w4l_1.c23(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function _no_name_provided__qut3iv($this, $charset, $typeInfo, $body) {
        this.w4l_1 = $this;
        this.x4l_1 = $charset;
        this.y4l_1 = $typeInfo;
        this.z4l_1 = $body;
    }
    protoOf(_no_name_provided__qut3iv).b23 = function(collector, $completion) {
        var tmp = new $collectCOROUTINE$1(this, collector, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv).c23 = function(collector, $completion) {
        return this.b23(collector, $completion);
    };
    function deserialize$slambda($body, resultContinuation) {
        this.i4m_1 = $body;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(deserialize$slambda).k4m = function(it, $completion) {
        var tmp = this.j2j(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(deserialize$slambda).y9 = function(p1, $completion) {
        return this.k4m((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(deserialize$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return !(this.j4m_1 == null) || this.i4m_1.c3o();
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(deserialize$slambda).j2j = function(it, completion) {
        var i = new deserialize$slambda(this.i4m_1, completion);
        i.j4m_1 = it;
        return i;
    };
    function deserialize$slambda_0($body, resultContinuation) {
        var i = new deserialize$slambda($body, resultContinuation);
        var l = function(it, $completion) {
            return i.k4m(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.p4k_1 = _this__u8e3s4;
        this.q4k_1 = body;
        this.r4k_1 = typeInfo;
        this.s4k_1 = charset;
    }
    protoOf($deserializeCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    var this_0 = asFlow(this.p4k_1);
                    var tmp_0 = new _no_name_provided__qut3iv(this_0, this.s4k_1, this.r4k_1, this.q4k_1);
                    suspendResult = firstOrNull(tmp_0, deserialize$slambda_0(this.q4k_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var result = suspendResult;
                    var tmp_1;
                    if (!(result == null)) tmp_1 = result;
                    else if (!this.q4k_1.c3o()) tmp_1 = this.q4k_1;
                    else {
                        var tmp0_safe_receiver = this.r4k_1.h47_1;
                        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.va()) === true) tmp_1 = NullBody_instance;
                        else throw new ContentConvertException("No suitable converter found for " + this.r4k_1.toString());
                    }
                    return tmp_1;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = deserialize;
    _.$_$.b = register$default;
    _.$_$.c = Configuration;
    _.$_$.d = ContentConverter;
    _.$_$.e = JsonConvertException;
    _.$_$.f = suitableCharset;
    //endregion
    return _;
});

});


parcelRegister("3WU9A", function(module, exports) {




(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-http.js",
        "./ktor-ktor-serialization-kotlinx.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("4fxpJ")), (parcelRequire("20sjI")), (parcelRequire("2VOQS")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization_kotlinx, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
    "use strict";
    //region block: imports
    var VOID = kotlin_kotlin.$_$.f;
    var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
    var serialization = kotlin_io_ktor_ktor_serialization_kotlinx.$_$.a;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
    //endregion
    //region block: pre-declaration
    //endregion
    function get_DefaultJson() {
        _init_properties_JsonSupport_kt__yf438r();
        return DefaultJson;
    }
    var DefaultJson;
    function json(_this__u8e3s4, json, contentType) {
        json = json === VOID ? get_DefaultJson() : json;
        contentType = contentType === VOID ? Application_getInstance().x47_1 : contentType;
        _init_properties_JsonSupport_kt__yf438r();
        serialization(_this__u8e3s4, contentType, json);
    }
    function DefaultJson$lambda($this$Json) {
        _init_properties_JsonSupport_kt__yf438r();
        $this$Json.s19_1 = true;
        $this$Json.v19_1 = true;
        $this$Json.c1a_1 = true;
        $this$Json.w19_1 = true;
        $this$Json.x19_1 = false;
        $this$Json.a1a_1 = false;
        return Unit_instance;
    }
    var properties_initialized_JsonSupport_kt_9cgd93;
    function _init_properties_JsonSupport_kt__yf438r() {
        if (!properties_initialized_JsonSupport_kt_9cgd93) {
            properties_initialized_JsonSupport_kt_9cgd93 = true;
            DefaultJson = Json(VOID, DefaultJson$lambda);
        }
    }
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = json;
    //endregion
    return _;
});

});
parcelRegister("20sjI", function(module, exports) {






(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./ktor-ktor-http.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js",
        "./ktor-ktor-io.js",
        "./ktor-ktor-serialization.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("3kJd2")), (parcelRequire("4fxpJ")), (parcelRequire("ctZcf")), (parcelRequire("4cHl4")), (parcelRequire("koNwy")));
})(globalThis, function(_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_serialization) {
    "use strict";
    //region block: imports
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var protoOf = kotlin_kotlin.$_$.kb;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var VOID = kotlin_kotlin.$_$.f;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var toString = kotlin_kotlin.$_$.ob;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.k;
    var BinaryFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
    var withCharsetIfNeeded = kotlin_io_ktor_ktor_http.$_$.s1;
    var TextContent = kotlin_io_ktor_ktor_http.$_$.r;
    var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
    var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
    var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a;
    var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
    var discard = kotlin_io_ktor_ktor_io.$_$.t;
    var readBytes = kotlin_io_ktor_ktor_io.$_$.u;
    var readText = kotlin_io_ktor_ktor_io.$_$.w;
    var JsonConvertException = kotlin_io_ktor_ktor_serialization.$_$.e;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var ContentConverter = kotlin_io_ktor_ktor_serialization.$_$.d;
    var serializerOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q2;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s2;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
    var KtMap = kotlin_kotlin.$_$.r5;
    var SetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
    var KtSet = kotlin_kotlin.$_$.v5;
    var firstOrNull_0 = kotlin_kotlin.$_$.w6;
    var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
    var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
    var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
    var isArray = kotlin_kotlin.$_$.pa;
    var KtList = kotlin_kotlin.$_$.p5;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var filterNotNull = kotlin_kotlin.$_$.u6;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.m;
    var HashSet_init_$Create$ = kotlin_kotlin.$_$.t;
    var singleOrNull = kotlin_kotlin.$_$.d8;
    var Collection = kotlin_kotlin.$_$.j5;
    var emptyList = kotlin_kotlin.$_$.r6;
    //endregion
    //region block: pre-declaration
    initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$o$collect$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($collectCOROUTINE$2, CoroutineImpl);
    initMetadataForLambda(KotlinxSerializationConverter$deserialize$o$collect$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($collectCOROUTINE$3, CoroutineImpl);
    initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, "sam$kotlinx_coroutines_flow_FlowCollector$0", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, "sam$kotlinx_coroutines_flow_FlowCollector$0", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(KotlinxSerializationConverter$deserialize$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($serializeNullableCOROUTINE$0, CoroutineImpl);
    initMetadataForCoroutine($deserializeCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(KotlinxSerializationConverter, "KotlinxSerializationConverter", VOID, VOID, [
        ContentConverter
    ], [
        4,
        3
    ]);
    //endregion
    function extensions(format) {
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = get_providers();
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'io.ktor.serialization.kotlinx.extensions.<anonymous>' call
            var tmp0_safe_receiver = element.l4m(format);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.e(tmp0_safe_receiver);
        }
        return destination;
    }
    function serialization(_this__u8e3s4, contentType, format) {
        _this__u8e3s4.d4k(contentType, new KotlinxSerializationConverter(format));
    }
    function KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
        this.u4m_1 = $$this$unsafeFlow;
        this.v4m_1 = $contentType;
        this.w4m_1 = $charset;
        this.x4m_1 = $typeInfo;
        this.y4m_1 = $value;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).i2j = function(value, $completion) {
        var tmp = this.j2j(value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).y9 = function(p1, $completion) {
        return this.i2j((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp_0 = this;
                    tmp_0.a4n_1 = this.u4m_1;
                    var tmp_1 = this;
                    tmp_1.b4n_1 = this.z4m_1;
                    var tmp_2 = this;
                    tmp_2.c4n_1 = this.b4n_1;
                    this.v8_1 = 1;
                    suspendResult = this.c4n_1.e4n(this.v4m_1, this.w4m_1, this.x4m_1, this.y4m_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.d4n_1 = suspendResult;
                    this.v8_1 = 2;
                    suspendResult = this.a4n_1.a23(this.d4n_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).j2j = function(value, completion) {
        var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda(this.u4m_1, this.v4m_1, this.w4m_1, this.x4m_1, this.y4m_1, completion);
        i.z4m_1 = value;
        return i;
    };
    function KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
        var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation);
        var l = function(value, $completion) {
            return i.i2j(value, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $collectCOROUTINE$2(_this__u8e3s4, collector, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.n4n_1 = _this__u8e3s4;
        this.o4n_1 = collector;
    }
    protoOf($collectCOROUTINE$2).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.p4n_1 = this.o4n_1;
                    this.v8_1 = 1;
                    var tmp_1 = KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0(this.p4n_1, this.n4n_1.r4n_1, this.n4n_1.s4n_1, this.n4n_1.t4n_1, this.n4n_1.u4n_1, null);
                    suspendResult = this.n4n_1.q4n_1.c23(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
        this.d4o_1 = $$this$unsafeFlow;
        this.e4o_1 = $charset;
        this.f4o_1 = $typeInfo;
        this.g4o_1 = $content;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).i2j = function(value, $completion) {
        var tmp = this.j2j(value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).y9 = function(p1, $completion) {
        return this.i2j((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp_0 = this;
                    tmp_0.i4o_1 = this.d4o_1;
                    var tmp_1 = this;
                    tmp_1.j4o_1 = this.h4o_1;
                    var tmp_2 = this;
                    tmp_2.k4o_1 = this.j4o_1;
                    this.v8_1 = 1;
                    suspendResult = this.k4o_1.g4k(this.e4o_1, this.f4o_1, this.g4o_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.l4o_1 = suspendResult;
                    this.v8_1 = 2;
                    suspendResult = this.i4o_1.a23(this.l4o_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return Unit_instance;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).j2j = function(value, completion) {
        var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda(this.d4o_1, this.e4o_1, this.f4o_1, this.g4o_1, completion);
        i.h4o_1 = value;
        return i;
    };
    function KotlinxSerializationConverter$deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
        var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation);
        var l = function(value, $completion) {
            return i.i2j(value, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $collectCOROUTINE$3(_this__u8e3s4, collector, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.u4o_1 = _this__u8e3s4;
        this.v4o_1 = collector;
    }
    protoOf($collectCOROUTINE$3).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.w4o_1 = this.v4o_1;
                    this.v8_1 = 1;
                    var tmp_1 = KotlinxSerializationConverter$deserialize$o$collect$slambda_0(this.w4o_1, this.u4o_1.y4o_1, this.u4o_1.z4o_1, this.u4o_1.a4p_1, null);
                    suspendResult = this.u4o_1.x4o_1.c23(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function serializeContent($this, serializer, format, value, contentType, charset) {
        var tmp;
        if (isInterface(format, StringFormat)) {
            var content = format.bp(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
            tmp = new TextContent(content, withCharsetIfNeeded(contentType, charset));
        } else if (isInterface(format, BinaryFormat)) {
            var content_0 = format.ep(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
            tmp = new ByteArrayContent(content_0, contentType);
        } else {
            var message = "Unsupported format " + toString(format);
            throw IllegalStateException_init_$Create$(toString(message));
        }
        return tmp;
    }
    function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
        this.b4p_1 = function_0;
    }
    protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a23 = function(value, $completion) {
        return this.b4p_1(value, $completion);
    };
    function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
        this.c4p_1 = function_0;
    }
    protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).a23 = function(value, $completion) {
        return this.c4p_1(value, $completion);
    };
    function _no_name_provided__qut3iv($this, $contentType, $charset, $typeInfo, $value) {
        this.q4n_1 = $this;
        this.r4n_1 = $contentType;
        this.s4n_1 = $charset;
        this.t4n_1 = $typeInfo;
        this.u4n_1 = $value;
    }
    protoOf(_no_name_provided__qut3iv).b23 = function(collector, $completion) {
        var tmp = new $collectCOROUTINE$2(this, collector, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv).c23 = function(collector, $completion) {
        return this.b23(collector, $completion);
    };
    function KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(KotlinxSerializationConverter$serializeNullable$slambda).m4p = function(it, $completion) {
        var tmp = this.n4p(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$slambda).y9 = function(p1, $completion) {
        return this.m4p((p1 == null ? true : p1 instanceof OutgoingContent) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return !(this.l4p_1 == null);
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(KotlinxSerializationConverter$serializeNullable$slambda).n4p = function(it, completion) {
        var i = new KotlinxSerializationConverter$serializeNullable$slambda(completion);
        i.l4p_1 = it;
        return i;
    };
    function KotlinxSerializationConverter$serializeNullable$slambda_0(resultContinuation) {
        var i = new KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation);
        var l = function(it, $completion) {
            return i.m4p(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function _no_name_provided__qut3iv_0($this, $charset, $typeInfo, $content) {
        this.x4o_1 = $this;
        this.y4o_1 = $charset;
        this.z4o_1 = $typeInfo;
        this.a4p_1 = $content;
    }
    protoOf(_no_name_provided__qut3iv_0).b23 = function(collector, $completion) {
        var tmp = new $collectCOROUTINE$3(this, collector, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv_0).c23 = function(collector, $completion) {
        return this.b23(collector, $completion);
    };
    function KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation) {
        this.w4p_1 = $content;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(KotlinxSerializationConverter$deserialize$slambda).k4m = function(it, $completion) {
        var tmp = this.j2j(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(KotlinxSerializationConverter$deserialize$slambda).y9 = function(p1, $completion) {
        return this.k4m((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(KotlinxSerializationConverter$deserialize$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return !(this.x4p_1 == null) || this.w4p_1.c3o();
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(KotlinxSerializationConverter$deserialize$slambda).j2j = function(it, completion) {
        var i = new KotlinxSerializationConverter$deserialize$slambda(this.w4p_1, completion);
        i.x4p_1 = it;
        return i;
    };
    function KotlinxSerializationConverter$deserialize$slambda_0($content, resultContinuation) {
        var i = new KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation);
        var l = function(it, $completion) {
            return i.k4m(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $serializeNullableCOROUTINE$0(_this__u8e3s4, contentType, charset, typeInfo, value, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.g4q_1 = _this__u8e3s4;
        this.h4q_1 = contentType;
        this.i4q_1 = charset;
        this.j4q_1 = typeInfo;
        this.k4q_1 = value;
    }
    protoOf($serializeNullableCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    var this_0 = asFlow(this.g4q_1.m4q_1);
                    var tmp_0 = new _no_name_provided__qut3iv(this_0, this.h4q_1, this.i4q_1, this.j4q_1, this.k4q_1);
                    suspendResult = firstOrNull(tmp_0, KotlinxSerializationConverter$serializeNullable$slambda_0(null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var fromExtension = suspendResult;
                    if (!(fromExtension == null)) return fromExtension;
                    var tmp_1;
                    try {
                        tmp_1 = serializerForTypeInfo(this.g4q_1.l4q_1.dp(), this.j4q_1);
                    } catch ($p) {
                        var tmp_2;
                        if ($p instanceof SerializationException) {
                            var cause = $p;
                            tmp_2 = guessSerializer(this.k4q_1, this.g4q_1.l4q_1.dp());
                        } else throw $p;
                        tmp_1 = tmp_2;
                    }
                    var serializer = tmp_1;
                    return serializeContent(this.g4q_1, serializer, this.g4q_1.l4q_1, this.k4q_1, this.h4q_1, this.i4q_1);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $deserializeCOROUTINE$1(_this__u8e3s4, charset, typeInfo, content, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v4q_1 = _this__u8e3s4;
        this.w4q_1 = charset;
        this.x4q_1 = typeInfo;
        this.y4q_1 = content;
    }
    protoOf($deserializeCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    var this_0 = asFlow(this.v4q_1.m4q_1);
                    var tmp_0 = new _no_name_provided__qut3iv_0(this_0, this.w4q_1, this.x4q_1, this.y4q_1);
                    suspendResult = firstOrNull(tmp_0, KotlinxSerializationConverter$deserialize$slambda_0(this.y4q_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.z4q_1 = suspendResult;
                    var tmp_1;
                    if (!this.v4q_1.m4q_1.s()) tmp_1 = !(this.z4q_1 == null) || this.y4q_1.c3o();
                    else tmp_1 = false;
                    if (tmp_1) return this.z4q_1;
                    this.a4r_1 = serializerForTypeInfo(this.v4q_1.l4q_1.dp(), this.x4q_1);
                    this.v8_1 = 2;
                    suspendResult = this.y4q_1.i3t(VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var contentPacket = suspendResult;
                    this.w8_1 = 3;
                    var tmp0_subject = this.v4q_1.l4q_1;
                    var tmp_2;
                    if (isInterface(tmp0_subject, StringFormat)) tmp_2 = this.v4q_1.l4q_1.cp(this.a4r_1, readText(contentPacket, this.w4q_1));
                    else if (isInterface(tmp0_subject, BinaryFormat)) tmp_2 = this.v4q_1.l4q_1.fp(this.a4r_1, readBytes(contentPacket));
                    else {
                        discard(contentPacket);
                        var message = "Unsupported format " + toString(this.v4q_1.l4q_1);
                        throw IllegalStateException_init_$Create$(toString(message));
                    }
                    return tmp_2;
                case 3:
                    this.w8_1 = 5;
                    var tmp_3 = this.y8_1;
                    if (tmp_3 instanceof Error) {
                        var cause = this.y8_1;
                        throw new JsonConvertException("Illegal input: " + cause.message, cause);
                    } else throw this.y8_1;
                case 4:
                    this.w8_1 = 5;
                    return Unit_instance;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function KotlinxSerializationConverter(format) {
        this.l4q_1 = format;
        this.m4q_1 = extensions(this.l4q_1);
        // Inline function 'kotlin.require' call
        var tmp;
        var tmp_0 = this.l4q_1;
        if (isInterface(tmp_0, BinaryFormat)) tmp = true;
        else {
            var tmp_1 = this.l4q_1;
            tmp = isInterface(tmp_1, StringFormat);
        }
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp) {
            // Inline function 'io.ktor.serialization.kotlinx.KotlinxSerializationConverter.<anonymous>' call
            var message = "Only binary and string formats are supported, " + toString(this.l4q_1) + " is not supported.";
            throw IllegalArgumentException_init_$Create$(toString(message));
        }
    }
    protoOf(KotlinxSerializationConverter).b4r = function(contentType, charset, typeInfo, value, $completion) {
        return this.c4r(contentType, charset, typeInfo, value, $completion);
    };
    protoOf(KotlinxSerializationConverter).e4k = function(contentType, charset, typeInfo, value, $completion) {
        return this.b4r(contentType, charset, typeInfo, value, $completion);
    };
    protoOf(KotlinxSerializationConverter).c4r = function(contentType, charset, typeInfo, value, $completion) {
        var tmp = new $serializeNullableCOROUTINE$0(this, contentType, charset, typeInfo, value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(KotlinxSerializationConverter).f4k = function(contentType, charset, typeInfo, value, $completion) {
        return this.c4r(contentType, charset, typeInfo, value, $completion);
    };
    protoOf(KotlinxSerializationConverter).g4k = function(charset, typeInfo, content, $completion) {
        var tmp = new $deserializeCOROUTINE$1(this, charset, typeInfo, content, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function serializerForTypeInfo(_this__u8e3s4, typeInfo) {
        var module_0 = _this__u8e3s4;
        var tmp0_safe_receiver = typeInfo.h47_1;
        var tmp;
        if (tmp0_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.ktor.serialization.kotlinx.serializerForTypeInfo.<anonymous>' call
            var tmp_0;
            if (tmp0_safe_receiver.ua().s()) tmp_0 = null;
            else tmp_0 = serializerOrNull(module_0, tmp0_safe_receiver);
            tmp = tmp_0;
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
            var tmp1_safe_receiver = module_0.ip(typeInfo.f47_1);
            tmp_1 = tmp1_safe_receiver == null ? null : maybeNullable(tmp1_safe_receiver, typeInfo);
        } else tmp_1 = tmp2_elvis_lhs;
        var tmp3_elvis_lhs = tmp_1;
        return tmp3_elvis_lhs == null ? maybeNullable(serializer(typeInfo.f47_1), typeInfo) : tmp3_elvis_lhs;
    }
    function guessSerializer(value, module_0) {
        var tmp;
        if (value == null) tmp = get_nullable(serializer_0(StringCompanionObject_instance));
        else {
            if (!(value == null) ? isInterface(value, KtList) : false) tmp = ListSerializer(elementSerializer(value, module_0));
            else if (!(value == null) ? isArray(value) : false) {
                var tmp1_safe_receiver = firstOrNull_0(value);
                var tmp_0;
                if (tmp1_safe_receiver == null) tmp_0 = null;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.serialization.kotlinx.guessSerializer.<anonymous>' call
                tmp_0 = guessSerializer(tmp1_safe_receiver, module_0);
                var tmp2_elvis_lhs = tmp_0;
                tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_0(StringCompanionObject_instance)) : tmp2_elvis_lhs;
            } else {
                if (!(value == null) ? isInterface(value, KtSet) : false) tmp = SetSerializer(elementSerializer(value, module_0));
                else if (!(value == null) ? isInterface(value, KtMap) : false) {
                    var keySerializer = elementSerializer(value.f2(), module_0);
                    var valueSerializer = elementSerializer(value.g2(), module_0);
                    tmp = MapSerializer(keySerializer, valueSerializer);
                } else {
                    var tmp3_elvis_lhs = module_0.ip(getKClassFromExpression(value));
                    tmp = tmp3_elvis_lhs == null ? serializer(getKClassFromExpression(value)) : tmp3_elvis_lhs;
                }
            }
        }
        var tmp_1 = tmp;
        return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
    }
    function maybeNullable(_this__u8e3s4, typeInfo) {
        var tmp;
        var tmp0_safe_receiver = typeInfo.h47_1;
        if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.va()) === true) tmp = get_nullable(_this__u8e3s4);
        else tmp = _this__u8e3s4;
        return tmp;
    }
    function elementSerializer(_this__u8e3s4, module_0) {
        // Inline function 'kotlin.collections.distinctBy' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = filterNotNull(_this__u8e3s4);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
            var tmp$ret$0 = guessSerializer(item, module_0);
            destination.e(tmp$ret$0);
        }
        var set = HashSet_init_$Create$();
        var list = ArrayList_init_$Create$();
        var tmp0_iterator_0 = destination.j();
        while(tmp0_iterator_0.k()){
            var e = tmp0_iterator_0.l();
            // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
            var key = e.yn().zo();
            if (set.e(key)) list.e(e);
        }
        var serializers = list;
        if (serializers.m() > 1) {
            // Inline function 'kotlin.error' call
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
            var tmp0_iterator_1 = serializers.j();
            while(tmp0_iterator_1.k()){
                var item_0 = tmp0_iterator_1.l();
                // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
                var tmp$ret$5 = item_0.yn().zo();
                destination_0.e(tmp$ret$5);
            }
            var message = "Serializing collections of different element types is not yet supported. " + ("Selected serializers: " + toString(destination_0));
            throw IllegalStateException_init_$Create$(toString(message));
        }
        var tmp0_elvis_lhs = singleOrNull(serializers);
        var selected = tmp0_elvis_lhs == null ? serializer_0(StringCompanionObject_instance) : tmp0_elvis_lhs;
        if (selected.yn().lp()) return selected;
        if (!isInterface(selected, KSerializer)) THROW_CCE();
        var tmp$ret$8;
        $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(_this__u8e3s4, Collection)) tmp = _this__u8e3s4.s();
            else tmp = false;
            if (tmp) {
                tmp$ret$8 = false;
                break $l$block_0;
            }
            var tmp0_iterator_2 = _this__u8e3s4.j();
            while(tmp0_iterator_2.k()){
                var element = tmp0_iterator_2.l();
                // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
                if (element == null) {
                    tmp$ret$8 = true;
                    break $l$block_0;
                }
            }
            tmp$ret$8 = false;
        }
        if (tmp$ret$8) return get_nullable(selected);
        return selected;
    }
    function get_providers() {
        return emptyList();
    }
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = serialization;
    //endregion
    return _;
});

});


parcelRegister("6KJhA", function(module, exports) {








(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./kotlin-kotlin-stdlib.js",
        "./ktor-ktor-http.js",
        "./ktor-ktor-client-content-negotiation.js",
        "./ktor-ktor-serialization-kotlinx-json.js",
        "./ktor-ktor-client-core.js",
        "./ktor-ktor-utils.js"
    ], factory);
    else factory(module.exports, (parcelRequire("2VOQS")), (parcelRequire("3kJd2")), (parcelRequire("9vyMc")), (parcelRequire("4fxpJ")), (parcelRequire("kmEuE")), (parcelRequire("3WU9A")), (parcelRequire("dKHwv")), (parcelRequire("cL6ZK")));
})(globalThis, function(_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.c;
    var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var VOID = kotlin_kotlin.$_$.f;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var toString = kotlin_kotlin.$_$.vf;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var hashCode = kotlin_kotlin.$_$.ha;
    var equals = kotlin_kotlin.$_$.ba;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var THROW_IAE = kotlin_kotlin.$_$.ue;
    var Enum = kotlin_kotlin.$_$.ie;
    var defineProp = kotlin_kotlin.$_$.aa;
    var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
    var parameters = kotlin_io_ktor_ktor_http.$_$.m1;
    var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
    var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var submitForm = kotlin_io_ktor_ktor_client_core.$_$.a;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
    var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
    var getKClass = kotlin_kotlin.$_$.e;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.v;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonOAuthSuccessTokenResponse, "JsonOAuthSuccessTokenResponse", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance
    });
    initMetadataForCompanion(Companion_0);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonOAuthErrorTokenResponse, "JsonOAuthErrorTokenResponse", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_0
    });
    initMetadataForClass(OAuthResponseType, "OAuthResponseType", VOID, Enum);
    initMetadataForCompanion(Companion_1);
    initMetadataForObject($serializer_1, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(OAuthAuthorizationRequest, "OAuthAuthorizationRequest", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_1
    });
    initMetadataForCompanion(Companion_2);
    initMetadataForObject($serializer_2, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(OAuthAuthorizationResponse, "OAuthAuthorizationResponse", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_2
    });
    initMetadataForClass(OAuthClient, "OAuthClient");
    initMetadataForCoroutine($requestTokenCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(OAuthCodeFlowClient, "OAuthCodeFlowClient", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($requestTokenCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(OAuthPreAuthorizedCodeFlowClient, "OAuthPreAuthorizedCodeFlowClient", VOID, VOID, VOID, [
        2
    ]);
    initMetadataForCoroutine($requestTokenCOROUTINE$2, CoroutineImpl);
    initMetadataForClass(OAuthRefreshFlowClient, "OAuthRefreshFlowClient", VOID, VOID, VOID, [
        1
    ]);
    //endregion
    function Companion() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.n5u_1 = [
            null,
            null,
            null,
            null,
            null,
            new ArrayListSerializer(JsonElementSerializer_getInstance()),
            null,
            null
        ];
    }
    var Companion_instance;
    function Companion_getInstance() {
        if (Companion_instance == null) new Companion();
        return Companion_instance;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.oauth.JsonOAuthSuccessTokenResponse", this, 8);
        tmp0_serialDesc.wy("token_type", false);
        tmp0_serialDesc.wy("access_token", false);
        tmp0_serialDesc.wy("refresh_token", true);
        tmp0_serialDesc.wy("expires_in", true);
        tmp0_serialDesc.wy("scope", true);
        tmp0_serialDesc.wy("authorization_details", true);
        tmp0_serialDesc.wy("c_nonce", true);
        tmp0_serialDesc.wy("c_nonce_expires_in", true);
        this.o5u_1 = tmp0_serialDesc;
    }
    protoOf($serializer).p5u = function(encoder, value) {
        var tmp0_desc = this.o5u_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance().n5u_1;
        tmp1_output.zs(tmp0_desc, 0, value.q5u_1);
        tmp1_output.zs(tmp0_desc, 1, value.r5u_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.s5u_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.s5u_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.t5u_1 == null)) tmp1_output.dt(tmp0_desc, 3, LongSerializer_getInstance(), value.t5u_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.u5u_1 == null)) tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.u5u_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.v5u_1 == null)) tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.v5u_1);
        if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.w5u_1 == null)) tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.w5u_1);
        if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.x5u_1 == null)) tmp1_output.dt(tmp0_desc, 7, LongSerializer_getInstance(), value.x5u_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.p5u(encoder, value instanceof JsonOAuthSuccessTokenResponse ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.o5u_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.lr(tmp0_desc);
        var tmp13_cached = Companion_getInstance().n5u_1;
        if (tmp12_input.as()) {
            tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp12_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else while(tmp1_flag){
            tmp2_index = tmp12_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp12_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp12_input.mr(tmp0_desc);
        return JsonOAuthSuccessTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
    };
    protoOf($serializer).yn = function() {
        return this.o5u_1;
    };
    protoOf($serializer).lz = function() {
        var tmp0_cached = Companion_getInstance().n5u_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(tmp0_cached[5]),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(LongSerializer_getInstance())
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function JsonOAuthSuccessTokenResponse_init_$Init$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance().o5u_1);
        $this.q5u_1 = tokenType;
        $this.r5u_1 = accessToken;
        if (0 === (seen0 & 4)) $this.s5u_1 = null;
        else $this.s5u_1 = refreshToken;
        if (0 === (seen0 & 8)) $this.t5u_1 = null;
        else $this.t5u_1 = expiresIn;
        if (0 === (seen0 & 16)) $this.u5u_1 = null;
        else $this.u5u_1 = scope;
        if (0 === (seen0 & 32)) $this.v5u_1 = null;
        else $this.v5u_1 = authorizationDetails;
        if (0 === (seen0 & 64)) $this.w5u_1 = null;
        else $this.w5u_1 = cNonce;
        if (0 === (seen0 & 128)) $this.x5u_1 = null;
        else $this.x5u_1 = cNonceExpiresIn;
        return $this;
    }
    function JsonOAuthSuccessTokenResponse_init_$Create$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
        return JsonOAuthSuccessTokenResponse_init_$Init$(seen0, tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthSuccessTokenResponse)));
    }
    function JsonOAuthSuccessTokenResponse(tokenType, accessToken, refreshToken, expiresIn, scope, authorizationDetails, cNonce, cNonceExpiresIn) {
        Companion_getInstance();
        refreshToken = refreshToken === VOID ? null : refreshToken;
        expiresIn = expiresIn === VOID ? null : expiresIn;
        scope = scope === VOID ? null : scope;
        authorizationDetails = authorizationDetails === VOID ? null : authorizationDetails;
        cNonce = cNonce === VOID ? null : cNonce;
        cNonceExpiresIn = cNonceExpiresIn === VOID ? null : cNonceExpiresIn;
        this.q5u_1 = tokenType;
        this.r5u_1 = accessToken;
        this.s5u_1 = refreshToken;
        this.t5u_1 = expiresIn;
        this.u5u_1 = scope;
        this.v5u_1 = authorizationDetails;
        this.w5u_1 = cNonce;
        this.x5u_1 = cNonceExpiresIn;
    }
    protoOf(JsonOAuthSuccessTokenResponse).y5u = function() {
        return this.r5u_1;
    };
    protoOf(JsonOAuthSuccessTokenResponse).z5u = function() {
        return this.s5u_1;
    };
    protoOf(JsonOAuthSuccessTokenResponse).toString = function() {
        return "JsonOAuthSuccessTokenResponse(tokenType=" + this.q5u_1 + ", accessToken=" + this.r5u_1 + ", refreshToken=" + this.s5u_1 + ", expiresIn=" + toString(this.t5u_1) + ", scope=" + this.u5u_1 + ", authorizationDetails=" + toString(this.v5u_1) + ", cNonce=" + this.w5u_1 + ", cNonceExpiresIn=" + toString(this.x5u_1) + ")";
    };
    protoOf(JsonOAuthSuccessTokenResponse).hashCode = function() {
        var result = getStringHashCode(this.q5u_1);
        result = imul(result, 31) + getStringHashCode(this.r5u_1) | 0;
        result = imul(result, 31) + (this.s5u_1 == null ? 0 : getStringHashCode(this.s5u_1)) | 0;
        result = imul(result, 31) + (this.t5u_1 == null ? 0 : this.t5u_1.hashCode()) | 0;
        result = imul(result, 31) + (this.u5u_1 == null ? 0 : getStringHashCode(this.u5u_1)) | 0;
        result = imul(result, 31) + (this.v5u_1 == null ? 0 : hashCode(this.v5u_1)) | 0;
        result = imul(result, 31) + (this.w5u_1 == null ? 0 : getStringHashCode(this.w5u_1)) | 0;
        result = imul(result, 31) + (this.x5u_1 == null ? 0 : this.x5u_1.hashCode()) | 0;
        return result;
    };
    protoOf(JsonOAuthSuccessTokenResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonOAuthSuccessTokenResponse)) return false;
        var tmp0_other_with_cast = other instanceof JsonOAuthSuccessTokenResponse ? other : THROW_CCE();
        if (!(this.q5u_1 === tmp0_other_with_cast.q5u_1)) return false;
        if (!(this.r5u_1 === tmp0_other_with_cast.r5u_1)) return false;
        if (!(this.s5u_1 == tmp0_other_with_cast.s5u_1)) return false;
        if (!equals(this.t5u_1, tmp0_other_with_cast.t5u_1)) return false;
        if (!(this.u5u_1 == tmp0_other_with_cast.u5u_1)) return false;
        if (!equals(this.v5u_1, tmp0_other_with_cast.v5u_1)) return false;
        if (!(this.w5u_1 == tmp0_other_with_cast.w5u_1)) return false;
        if (!equals(this.x5u_1, tmp0_other_with_cast.x5u_1)) return false;
        return true;
    };
    function Companion_0() {}
    var Companion_instance_0;
    function Companion_getInstance_0() {
        return Companion_instance_0;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.oauth.JsonOAuthErrorTokenResponse", this, 3);
        tmp0_serialDesc.wy("error", false);
        tmp0_serialDesc.wy("error_description", true);
        tmp0_serialDesc.wy("error_uri", true);
        this.a5v_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).b5v = function(encoder, value) {
        var tmp0_desc = this.a5v_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.c5v_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d5v_1 == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.d5v_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.e5v_1 == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.e5v_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.b5v(encoder, value instanceof JsonOAuthErrorTokenResponse ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.a5v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonOAuthErrorTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.a5v_1;
    };
    protoOf($serializer_0).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_0() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function JsonOAuthErrorTokenResponse_init_$Init$(seen0, error, errorDescription, errorUri, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance_0().a5v_1);
        $this.c5v_1 = error;
        if (0 === (seen0 & 2)) $this.d5v_1 = null;
        else $this.d5v_1 = errorDescription;
        if (0 === (seen0 & 4)) $this.e5v_1 = null;
        else $this.e5v_1 = errorUri;
        return $this;
    }
    function JsonOAuthErrorTokenResponse_init_$Create$(seen0, error, errorDescription, errorUri, serializationConstructorMarker) {
        return JsonOAuthErrorTokenResponse_init_$Init$(seen0, error, errorDescription, errorUri, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthErrorTokenResponse)));
    }
    function JsonOAuthErrorTokenResponse(error, errorDescription, errorUri) {
        errorDescription = errorDescription === VOID ? null : errorDescription;
        errorUri = errorUri === VOID ? null : errorUri;
        this.c5v_1 = error;
        this.d5v_1 = errorDescription;
        this.e5v_1 = errorUri;
    }
    protoOf(JsonOAuthErrorTokenResponse).toString = function() {
        return "JsonOAuthErrorTokenResponse(error=" + this.c5v_1 + ", errorDescription=" + this.d5v_1 + ", errorUri=" + this.e5v_1 + ")";
    };
    protoOf(JsonOAuthErrorTokenResponse).hashCode = function() {
        var result = getStringHashCode(this.c5v_1);
        result = imul(result, 31) + (this.d5v_1 == null ? 0 : getStringHashCode(this.d5v_1)) | 0;
        result = imul(result, 31) + (this.e5v_1 == null ? 0 : getStringHashCode(this.e5v_1)) | 0;
        return result;
    };
    protoOf(JsonOAuthErrorTokenResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsonOAuthErrorTokenResponse)) return false;
        var tmp0_other_with_cast = other instanceof JsonOAuthErrorTokenResponse ? other : THROW_CCE();
        if (!(this.c5v_1 === tmp0_other_with_cast.c5v_1)) return false;
        if (!(this.d5v_1 == tmp0_other_with_cast.d5v_1)) return false;
        if (!(this.e5v_1 == tmp0_other_with_cast.e5v_1)) return false;
        return true;
    };
    var OAuthResponseType_code_instance;
    function values() {
        return [
            OAuthResponseType_code_getInstance()
        ];
    }
    function valueOf(value) {
        if (value === "code") return OAuthResponseType_code_getInstance();
        else {
            OAuthResponseType_initEntries();
            THROW_IAE("No enum constant value.");
        }
    }
    var OAuthResponseType_entriesInitialized;
    function OAuthResponseType_initEntries() {
        if (OAuthResponseType_entriesInitialized) return Unit_instance;
        OAuthResponseType_entriesInitialized = true;
        OAuthResponseType_code_instance = new OAuthResponseType("code", 0);
    }
    function OAuthResponseType(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    function Companion_1() {
        Companion_instance_1 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h5v_1 = [
            null,
            null,
            null,
            null,
            null,
            createSimpleEnumSerializer("io.curity.oauth.OAuthResponseType", values())
        ];
    }
    protoOf(Companion_1).b1b = function() {
        return $serializer_getInstance_1();
    };
    var Companion_instance_1;
    function Companion_getInstance_1() {
        if (Companion_instance_1 == null) new Companion_1();
        return Companion_instance_1;
    }
    function $serializer_1() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.oauth.OAuthAuthorizationRequest", this, 6);
        tmp0_serialDesc.wy("clientId", false);
        tmp0_serialDesc.wy("authorizationDetails", true);
        tmp0_serialDesc.wy("scope", true);
        tmp0_serialDesc.wy("state", true);
        tmp0_serialDesc.wy("redirectUri", true);
        tmp0_serialDesc.wy("responseType", false);
        this.i5v_1 = tmp0_serialDesc;
    }
    protoOf($serializer_1).j5v = function(encoder, value) {
        var tmp0_desc = this.i5v_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().h5v_1;
        tmp1_output.zs(tmp0_desc, 0, value.client_id);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.authorization_details == null)) tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.authorization_details);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.scope == null)) tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.scope);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.state == null)) tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.state);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.redirect_uri == null)) tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.redirect_uri);
        tmp1_output.bt(tmp0_desc, 5, tmp2_cached[5], value.response_type);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_1).zn = function(encoder, value) {
        return this.j5v(encoder, value instanceof OAuthAuthorizationRequest ? value : THROW_CCE());
    };
    protoOf($serializer_1).ao = function(decoder) {
        var tmp0_desc = this.i5v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_input = decoder.lr(tmp0_desc);
        var tmp11_cached = Companion_getInstance_1().h5v_1;
        if (tmp10_input.as()) {
            tmp4_local0 = tmp10_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp10_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp10_input.xr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else while(tmp1_flag){
            tmp2_index = tmp10_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp10_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp10_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp10_input.xr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp10_input.mr(tmp0_desc);
        return OAuthAuthorizationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
    };
    protoOf($serializer_1).yn = function() {
        return this.i5v_1;
    };
    protoOf($serializer_1).lz = function() {
        var tmp0_cached = Companion_getInstance_1().h5v_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance()),
            tmp0_cached[5]
        ];
    };
    var $serializer_instance_1;
    function $serializer_getInstance_1() {
        if ($serializer_instance_1 == null) new $serializer_1();
        return $serializer_instance_1;
    }
    function OAuthAuthorizationRequest_init_$Init$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker, $this) {
        if (!(33 === (33 & seen0))) throwMissingFieldException(seen0, 33, $serializer_getInstance_1().i5v_1);
        $this.client_id = clientId;
        if (0 === (seen0 & 2)) $this.authorization_details = null;
        else $this.authorization_details = authorizationDetails;
        if (0 === (seen0 & 4)) $this.scope = null;
        else $this.scope = scope;
        if (0 === (seen0 & 8)) $this.state = null;
        else $this.state = state;
        if (0 === (seen0 & 16)) $this.redirect_uri = null;
        else $this.redirect_uri = redirectUri;
        $this.response_type = responseType;
        return $this;
    }
    function OAuthAuthorizationRequest_init_$Create$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker) {
        return OAuthAuthorizationRequest_init_$Init$(seen0, clientId, authorizationDetails, scope, state, redirectUri, responseType, serializationConstructorMarker, objectCreate(protoOf(OAuthAuthorizationRequest)));
    }
    function OAuthAuthorizationRequest(clientId, authorizationDetails, scope, state, redirectUri, responseType) {
        Companion_getInstance_1();
        authorizationDetails = authorizationDetails === VOID ? null : authorizationDetails;
        scope = scope === VOID ? null : scope;
        state = state === VOID ? null : state;
        redirectUri = redirectUri === VOID ? null : redirectUri;
        responseType = responseType === VOID ? OAuthResponseType_code_getInstance() : responseType;
        this.client_id = clientId;
        this.authorization_details = authorizationDetails;
        this.scope = scope;
        this.state = state;
        this.redirect_uri = redirectUri;
        this.response_type = responseType;
    }
    protoOf(OAuthAuthorizationRequest).k5v = function() {
        return this.client_id;
    };
    protoOf(OAuthAuthorizationRequest).l5v = function() {
        return this.authorization_details;
    };
    protoOf(OAuthAuthorizationRequest).m5v = function() {
        return this.scope;
    };
    protoOf(OAuthAuthorizationRequest).n5v = function() {
        return this.state;
    };
    protoOf(OAuthAuthorizationRequest).o5v = function() {
        return this.redirect_uri;
    };
    protoOf(OAuthAuthorizationRequest).p5v = function() {
        return this.response_type;
    };
    protoOf(OAuthAuthorizationRequest).ba = function() {
        return this.client_id;
    };
    protoOf(OAuthAuthorizationRequest).ca = function() {
        return this.authorization_details;
    };
    protoOf(OAuthAuthorizationRequest).qj = function() {
        return this.scope;
    };
    protoOf(OAuthAuthorizationRequest).q5v = function() {
        return this.state;
    };
    protoOf(OAuthAuthorizationRequest).r5v = function() {
        return this.redirect_uri;
    };
    protoOf(OAuthAuthorizationRequest).s5v = function() {
        return this.response_type;
    };
    protoOf(OAuthAuthorizationRequest).t5v = function(clientId, authorizationDetails, scope, state, redirectUri, responseType) {
        return new OAuthAuthorizationRequest(clientId, authorizationDetails, scope, state, redirectUri, responseType);
    };
    protoOf(OAuthAuthorizationRequest).copy = function(clientId, authorizationDetails, scope, state, redirectUri, responseType, $super) {
        clientId = clientId === VOID ? this.client_id : clientId;
        authorizationDetails = authorizationDetails === VOID ? this.authorization_details : authorizationDetails;
        scope = scope === VOID ? this.scope : scope;
        state = state === VOID ? this.state : state;
        redirectUri = redirectUri === VOID ? this.redirect_uri : redirectUri;
        responseType = responseType === VOID ? this.response_type : responseType;
        return this.t5v(clientId, authorizationDetails, scope, state, redirectUri, responseType);
    };
    protoOf(OAuthAuthorizationRequest).toString = function() {
        return "OAuthAuthorizationRequest(clientId=" + this.client_id + ", authorizationDetails=" + this.authorization_details + ", scope=" + this.scope + ", state=" + this.state + ", redirectUri=" + this.redirect_uri + ", responseType=" + this.response_type.toString() + ")";
    };
    protoOf(OAuthAuthorizationRequest).hashCode = function() {
        var result = getStringHashCode(this.client_id);
        result = imul(result, 31) + (this.authorization_details == null ? 0 : getStringHashCode(this.authorization_details)) | 0;
        result = imul(result, 31) + (this.scope == null ? 0 : getStringHashCode(this.scope)) | 0;
        result = imul(result, 31) + (this.state == null ? 0 : getStringHashCode(this.state)) | 0;
        result = imul(result, 31) + (this.redirect_uri == null ? 0 : getStringHashCode(this.redirect_uri)) | 0;
        result = imul(result, 31) + this.response_type.hashCode() | 0;
        return result;
    };
    protoOf(OAuthAuthorizationRequest).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof OAuthAuthorizationRequest)) return false;
        var tmp0_other_with_cast = other instanceof OAuthAuthorizationRequest ? other : THROW_CCE();
        if (!(this.client_id === tmp0_other_with_cast.client_id)) return false;
        if (!(this.authorization_details == tmp0_other_with_cast.authorization_details)) return false;
        if (!(this.scope == tmp0_other_with_cast.scope)) return false;
        if (!(this.state == tmp0_other_with_cast.state)) return false;
        if (!(this.redirect_uri == tmp0_other_with_cast.redirect_uri)) return false;
        if (!this.response_type.equals(tmp0_other_with_cast.response_type)) return false;
        return true;
    };
    function appendParameters(_this__u8e3s4, request) {
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.oauth.appendParameters.<anonymous>' call
        _this__u8e3s4.w43("response_type", request.response_type.p2_1);
        _this__u8e3s4.w43("client_id", request.client_id);
        if (!(request.authorization_details == null)) _this__u8e3s4.w43("authorization_details", request.authorization_details);
        if (!(request.scope == null)) _this__u8e3s4.w43("scope", request.scope);
        var tmp0_safe_receiver = request.state;
        if (tmp0_safe_receiver == null) ;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        _this__u8e3s4.w43("state", tmp0_safe_receiver);
        var tmp1_safe_receiver = request.redirect_uri;
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            _this__u8e3s4.w43("redirect_uri", tmp1_safe_receiver);
            tmp = Unit_instance;
        }
    }
    function OAuthResponseType_code_getInstance() {
        OAuthResponseType_initEntries();
        return OAuthResponseType_code_instance;
    }
    function Companion_2() {}
    protoOf(Companion_2).b1b = function() {
        return $serializer_getInstance_2();
    };
    var Companion_instance_2;
    function Companion_getInstance_2() {
        return Companion_instance_2;
    }
    function $serializer_2() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.oauth.OAuthAuthorizationResponse", this, 2);
        tmp0_serialDesc.wy("state", false);
        tmp0_serialDesc.wy("code", false);
        this.u5v_1 = tmp0_serialDesc;
    }
    protoOf($serializer_2).v5v = function(encoder, value) {
        var tmp0_desc = this.u5v_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.zs(tmp0_desc, 0, value.state);
        tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.code);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_2).zn = function(encoder, value) {
        return this.v5v(encoder, value instanceof OAuthAuthorizationResponse ? value : THROW_CCE());
    };
    protoOf($serializer_2).ao = function(decoder) {
        var tmp0_desc = this.u5v_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return OAuthAuthorizationResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_2).yn = function() {
        return this.u5v_1;
    };
    protoOf($serializer_2).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_2;
    function $serializer_getInstance_2() {
        if ($serializer_instance_2 == null) new $serializer_2();
        return $serializer_instance_2;
    }
    function OAuthAuthorizationResponse_init_$Init$(seen0, state, code, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_2().u5v_1);
        $this.state = state;
        $this.code = code;
        return $this;
    }
    function OAuthAuthorizationResponse_init_$Create$(seen0, state, code, serializationConstructorMarker) {
        return OAuthAuthorizationResponse_init_$Init$(seen0, state, code, serializationConstructorMarker, objectCreate(protoOf(OAuthAuthorizationResponse)));
    }
    function OAuthAuthorizationResponse(state, code) {
        this.state = state;
        this.code = code;
    }
    protoOf(OAuthAuthorizationResponse).n5v = function() {
        return this.state;
    };
    protoOf(OAuthAuthorizationResponse).w5v = function() {
        return this.code;
    };
    protoOf(OAuthAuthorizationResponse).ba = function() {
        return this.state;
    };
    protoOf(OAuthAuthorizationResponse).ca = function() {
        return this.code;
    };
    protoOf(OAuthAuthorizationResponse).x5v = function(state, code) {
        return new OAuthAuthorizationResponse(state, code);
    };
    protoOf(OAuthAuthorizationResponse).copy = function(state, code, $super) {
        state = state === VOID ? this.state : state;
        code = code === VOID ? this.code : code;
        return this.x5v(state, code);
    };
    protoOf(OAuthAuthorizationResponse).toString = function() {
        return "OAuthAuthorizationResponse(state=" + this.state + ", code=" + this.code + ")";
    };
    protoOf(OAuthAuthorizationResponse).hashCode = function() {
        var result = getStringHashCode(this.state);
        result = imul(result, 31) + (this.code == null ? 0 : getStringHashCode(this.code)) | 0;
        return result;
    };
    protoOf(OAuthAuthorizationResponse).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof OAuthAuthorizationResponse)) return false;
        var tmp0_other_with_cast = other instanceof OAuthAuthorizationResponse ? other : THROW_CCE();
        if (!(this.state === tmp0_other_with_cast.state)) return false;
        if (!(this.code == tmp0_other_with_cast.code)) return false;
        return true;
    };
    function OAuthClient(id, redirectUri, secret) {
        this.id = id;
        this.redirectUri = redirectUri;
        this.secret = secret;
    }
    protoOf(OAuthClient).k2a = function() {
        return this.id;
    };
    protoOf(OAuthClient).u3f = function() {
        return this.redirectUri;
    };
    protoOf(OAuthClient).y5v = function() {
        return this.secret;
    };
    protoOf(OAuthClient).ba = function() {
        return this.id;
    };
    protoOf(OAuthClient).ca = function() {
        return this.redirectUri;
    };
    protoOf(OAuthClient).qj = function() {
        return this.secret;
    };
    protoOf(OAuthClient).z5v = function(id, redirectUri, secret) {
        return new OAuthClient(id, redirectUri, secret);
    };
    protoOf(OAuthClient).copy = function(id, redirectUri, secret, $super) {
        id = id === VOID ? this.id : id;
        redirectUri = redirectUri === VOID ? this.redirectUri : redirectUri;
        secret = secret === VOID ? this.secret : secret;
        return this.z5v(id, redirectUri, secret);
    };
    protoOf(OAuthClient).toString = function() {
        return "OAuthClient(id=" + this.id + ", redirectUri=" + this.redirectUri + ", secret=" + this.secret + ")";
    };
    protoOf(OAuthClient).hashCode = function() {
        var result = getStringHashCode(this.id);
        result = imul(result, 31) + getStringHashCode(this.redirectUri) | 0;
        result = imul(result, 31) + getStringHashCode(this.secret) | 0;
        return result;
    };
    protoOf(OAuthClient).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof OAuthClient)) return false;
        var tmp0_other_with_cast = other instanceof OAuthClient ? other : THROW_CCE();
        if (!(this.id === tmp0_other_with_cast.id)) return false;
        if (!(this.redirectUri === tmp0_other_with_cast.redirectUri)) return false;
        if (!(this.secret === tmp0_other_with_cast.secret)) return false;
        return true;
    };
    function createParameters($this, code, redirectUri) {
        return parameters(OAuthCodeFlowClient$createParameters$lambda(code, redirectUri, $this));
    }
    function OAuthCodeFlowClient$_httpClient$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, OAuthCodeFlowClient$_httpClient$lambda$lambda);
        return Unit_instance;
    }
    function OAuthCodeFlowClient$_httpClient$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function OAuthCodeFlowClient$createParameters$lambda($code, $redirectUri, this$0) {
        return function($this$parameters) {
            $this$parameters.w43("grant_type", "authorization_code");
            $this$parameters.w43("code", $code);
            $this$parameters.w43("redirect_uri", $redirectUri);
            $this$parameters.w43("client_id", this$0.a5w_1.id);
            $this$parameters.w43("client_secret", this$0.a5w_1.secret);
            return Unit_instance;
        };
    }
    function $requestTokenCOROUTINE$0(_this__u8e3s4, code, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.l5w_1 = _this__u8e3s4;
        this.m5w_1 = code;
    }
    protoOf($requestTokenCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = submitForm(this.l5w_1.c5w_1, this.l5w_1.b5w_1, createParameters(this.l5w_1, this.m5w_1, this.l5w_1.a5w_1.redirectUri), VOID, VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.n5w_1 = suspendResult;
                    if (!(this.n5w_1.y4v().h4g_1 === 200)) throw Exception_init_$Create$("Unexpected status code for token request");
                    var tmp_0 = this;
                    tmp_0.o5w_1 = this.n5w_1;
                    this.v8_1 = 2;
                    var tmp_1 = this.o5w_1.t4w();
                    var tmp_2 = JsType_instance;
                    var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
                    var tmp_4;
                    try {
                        tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_5;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_5 = null;
                        } else throw $p;
                        tmp_4 = tmp_5;
                    }
                    suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function OAuthCodeFlowClient(engine, oAuthClient, tokenEndpoint) {
        this.a5w_1 = oAuthClient;
        this.b5w_1 = tokenEndpoint;
        var tmp = this;
        tmp.c5w_1 = HttpClient(engine, OAuthCodeFlowClient$_httpClient$lambda);
    }
    protoOf(OAuthCodeFlowClient).p5w = function(code, $completion) {
        var tmp = new $requestTokenCOROUTINE$0(this, code, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda$lambda);
        return Unit_instance;
    }
    function OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function OAuthPreAuthorizedCodeFlowClient$requestToken$lambda($preAuthorizedCode, $txCode, this$0) {
        return function($this$parameters) {
            $this$parameters.w43("grant_type", "urn:ietf:params:oauth:grant-type:pre-authorized_code");
            $this$parameters.w43("pre-authorized_code", $preAuthorizedCode);
            var tmp;
            if (!($txCode == null)) {
                $this$parameters.w43("tx_code", $txCode);
                tmp = Unit_instance;
            }
            $this$parameters.w43("client_id", this$0.q5w_1.id);
            $this$parameters.w43("client_secret", this$0.q5w_1.secret);
            return Unit_instance;
        };
    }
    function $requestTokenCOROUTINE$1(_this__u8e3s4, preAuthorizedCode, txCode, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.b5x_1 = _this__u8e3s4;
        this.c5x_1 = preAuthorizedCode;
        this.d5x_1 = txCode;
    }
    protoOf($requestTokenCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.v8_1 = 1;
                    suspendResult = submitForm(this.b5x_1.s5w_1, this.b5x_1.r5w_1, parameters(OAuthPreAuthorizedCodeFlowClient$requestToken$lambda(this.c5x_1, this.d5x_1, this.b5x_1)), VOID, VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.e5x_1 = suspendResult;
                    this.f5x_1 = this.e5x_1.y4v().h4g_1;
                    if (this.f5x_1 === 200) {
                        var tmp_0 = this;
                        tmp_0.h5x_1 = this.e5x_1;
                        this.v8_1 = 3;
                        var tmp_1 = this.h5x_1.t4w();
                        var tmp_2 = JsType_instance;
                        var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
                        var tmp_4;
                        try {
                            tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_5;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_5 = null;
                            } else throw $p;
                            tmp_4 = tmp_5;
                        }
                        suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else if (this.f5x_1 === 400) {
                        var tmp_6 = this;
                        tmp_6.i5x_1 = this.e5x_1;
                        this.v8_1 = 2;
                        var tmp_7 = this.i5x_1.t4w();
                        var tmp_8 = JsType_instance;
                        var tmp_9 = getKClass(JsonOAuthErrorTokenResponse);
                        var tmp_10;
                        try {
                            tmp_10 = createKType(getKClass(JsonOAuthErrorTokenResponse), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_11;
                            if ($p instanceof Error) {
                                var cause_0 = $p;
                                tmp_11 = null;
                            } else throw $p;
                            tmp_10 = tmp_11;
                        }
                        suspendResult = tmp_7.x4v(typeInfoImpl(tmp_8, tmp_9, tmp_10), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_12 = this;
                        throw Exception_init_$Create$("Unexpected status code for token response: " + this.e5x_1.y4v().h4g_1);
                    }
                case 2:
                    var tmp_13 = this;
                    tmp_13.g5x_1 = suspendResult instanceof JsonOAuthErrorTokenResponse ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    continue $sm;
                case 3:
                    var tmp_14 = this;
                    tmp_14.g5x_1 = suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    return this.g5x_1;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function OAuthPreAuthorizedCodeFlowClient(engine, oAuthClient, tokenEndpoint) {
        this.q5w_1 = oAuthClient;
        this.r5w_1 = tokenEndpoint;
        var tmp = this;
        tmp.s5w_1 = HttpClient(engine, OAuthPreAuthorizedCodeFlowClient$_httpClient$lambda);
    }
    protoOf(OAuthPreAuthorizedCodeFlowClient).j5x = function(preAuthorizedCode, txCode, $completion) {
        var tmp = new $requestTokenCOROUTINE$1(this, preAuthorizedCode, txCode, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function createParameters_0($this, refreshToken) {
        return parameters(OAuthRefreshFlowClient$createParameters$lambda(refreshToken, $this));
    }
    function OAuthRefreshFlowClient$_httpClient$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, OAuthRefreshFlowClient$_httpClient$lambda$lambda);
        return Unit_instance;
    }
    function OAuthRefreshFlowClient$_httpClient$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function OAuthRefreshFlowClient$createParameters$lambda($refreshToken, this$0) {
        return function($this$parameters) {
            $this$parameters.w43("grant_type", "refresh_token");
            $this$parameters.w43("refresh_token", $refreshToken);
            $this$parameters.w43("client_id", this$0.k5x_1.id);
            $this$parameters.w43("client_secret", this$0.k5x_1.secret);
            return Unit_instance;
        };
    }
    function $requestTokenCOROUTINE$2(_this__u8e3s4, refreshToken, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v5x_1 = _this__u8e3s4;
        this.w5x_1 = refreshToken;
    }
    protoOf($requestTokenCOROUTINE$2).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = submitForm(this.v5x_1.m5x_1, this.v5x_1.l5x_1, createParameters_0(this.v5x_1, this.w5x_1), VOID, VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.x5x_1 = suspendResult;
                    if (!(this.x5x_1.y4v().h4g_1 === 200)) throw Exception_init_$Create$("Unexpected status code for token request");
                    var tmp_0 = this;
                    tmp_0.y5x_1 = this.x5x_1;
                    this.v8_1 = 2;
                    var tmp_1 = this.y5x_1.t4w();
                    var tmp_2 = JsType_instance;
                    var tmp_3 = getKClass(JsonOAuthSuccessTokenResponse);
                    var tmp_4;
                    try {
                        tmp_4 = createKType(getKClass(JsonOAuthSuccessTokenResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_5;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_5 = null;
                        } else throw $p;
                        tmp_4 = tmp_5;
                    }
                    suspendResult = tmp_1.x4v(typeInfoImpl(tmp_2, tmp_3, tmp_4), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    return suspendResult instanceof JsonOAuthSuccessTokenResponse ? suspendResult : THROW_CCE();
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function OAuthRefreshFlowClient(engine, oAuthClient, tokenEndpoint) {
        this.k5x_1 = oAuthClient;
        this.l5x_1 = tokenEndpoint;
        var tmp = this;
        tmp.m5x_1 = HttpClient(engine, OAuthRefreshFlowClient$_httpClient$lambda);
    }
    protoOf(OAuthRefreshFlowClient).p5w = function(refreshToken, $completion) {
        var tmp = new $requestTokenCOROUTINE$2(this, refreshToken, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    //region block: post-declaration
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    defineProp(protoOf(OAuthResponseType), "name", protoOf(OAuthResponseType).r2);
    defineProp(protoOf(OAuthResponseType), "ordinal", protoOf(OAuthResponseType).s2);
    protoOf($serializer_1).mz = typeParametersSerializers;
    protoOf($serializer_2).mz = typeParametersSerializers;
    //endregion
    //region block: init
    Companion_instance_0 = new Companion_0();
    Companion_instance_2 = new Companion_2();
    //endregion
    //region block: exports
    function $jsExportAll$(_) {
        var $io = _.io || (_.io = {});
        var $io$curity = $io.curity || ($io.curity = {});
        var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
        $io$curity$oauth.OAuthResponseType = OAuthResponseType;
        $io$curity$oauth.OAuthResponseType.values = values;
        $io$curity$oauth.OAuthResponseType.valueOf = valueOf;
        defineProp($io$curity$oauth.OAuthResponseType, "code", OAuthResponseType_code_getInstance);
        $io$curity$oauth.OAuthAuthorizationRequest = OAuthAuthorizationRequest;
        defineProp($io$curity$oauth.OAuthAuthorizationRequest, "Companion", Companion_getInstance_1);
        var $io = _.io || (_.io = {});
        var $io$curity = $io.curity || ($io.curity = {});
        var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
        $io$curity$oauth.OAuthAuthorizationResponse = OAuthAuthorizationResponse;
        defineProp($io$curity$oauth.OAuthAuthorizationResponse, "Companion", Companion_getInstance_2);
        var $io = _.io || (_.io = {});
        var $io$curity = $io.curity || ($io.curity = {});
        var $io$curity$oauth = $io$curity.oauth || ($io$curity.oauth = {});
        $io$curity$oauth.OAuthClient = OAuthClient;
    }
    $jsExportAll$(_);
    _.$jsExportAll$ = $jsExportAll$;
    _.$_$ = _.$_$ || {};
    _.$_$.a = JsonOAuthErrorTokenResponse;
    _.$_$.b = JsonOAuthSuccessTokenResponse;
    _.$_$.c = OAuthAuthorizationRequest;
    _.$_$.d = OAuthAuthorizationResponse;
    _.$_$.e = OAuthClient;
    _.$_$.f = OAuthCodeFlowClient;
    _.$_$.g = OAuthPreAuthorizedCodeFlowClient;
    _.$_$.h = OAuthRefreshFlowClient;
    _.$_$.i = appendParameters;
    //endregion
    return _;
});

});

parcelRegister("jrYSV", function(module, exports) {








(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./curity-ssi-libs-jose.js",
        "./kotlin-kotlin-stdlib.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./curity-ssi-libs-did.js",
        "./curity-ssi-libs-core-json.js",
        "./curity-ssi-libs-did-json.js",
        "./curity-ssi-libs-core.js"
    ], factory);
    else factory(module.exports, (parcelRequire("2VOQS")), (parcelRequire("lm0Zq")), (parcelRequire("9vyMc")), (parcelRequire("3kJd2")), (parcelRequire("lsn9o")), (parcelRequire("fcWHW")), (parcelRequire("692Pz")), (parcelRequire("iuiRe")));
})(globalThis, function(_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_curity_ssi_jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_did, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_did_json, kotlin_io_curity_ssi_core) {
    "use strict";
    //region block: imports
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var JsonJwk = kotlin_io_curity_ssi_jose.$_$.r;
    var getKClass = kotlin_kotlin.$_$.e;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var encodeToByteArray = kotlin_kotlin.$_$.nc;
    var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
    var Did = kotlin_io_curity_ssi_did.$_$.f;
    var VOID = kotlin_kotlin.$_$.f;
    var DidUrl = kotlin_io_curity_ssi_did.$_$.e;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var toSet = kotlin_kotlin.$_$.r8;
    var decodeBase64Url = kotlin_io_curity_ssi_jose.$_$.n;
    var decodeToString = kotlin_kotlin.$_$.mc;
    var DidResolutionException = kotlin_io_curity_ssi_did.$_$.d;
    var Exception = kotlin_kotlin.$_$.ke;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
    var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
    var JsonPublicKeyJwk = kotlin_io_curity_ssi_did_json.$_$.d;
    var JsonVerificationMethod = kotlin_io_curity_ssi_did_json.$_$.e;
    var JsonDidDocument = kotlin_io_curity_ssi_did_json.$_$.b;
    var JsonDidResolutionSuccessResult = kotlin_io_curity_ssi_did_json.$_$.c;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var enumEntries = kotlin_kotlin.$_$.p9;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var Enum = kotlin_kotlin.$_$.ie;
    var ToString = kotlin_io_curity_ssi_core.$_$.m;
    //endregion
    //region block: pre-declaration
    initMetadataForObject(JwkDid, "JwkDid");
    initMetadataForClass(JwkDidResolver, "JwkDidResolver", JwkDidResolver, VOID, VOID, [
        1
    ]);
    initMetadataForClass(JwkDidType, "JwkDidType", VOID, Enum, [
        ToString,
        Enum
    ]);
    initMetadataForClass(VerificationMethodType, "VerificationMethodType", VOID, Enum, [
        ToString,
        Enum
    ]);
    //endregion
    function JwkDid() {}
    protoOf(JwkDid).w3l = function(verificationKey) {
        var tmp = JwkDidType_JWK_getInstance().toString();
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        var value = verificationKey.u2f();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonJwk), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        return new DidUrl(new Did(tmp, encodeBase64url(encodeToByteArray(tmp$ret$2))), VOID, VOID, "0");
    };
    var JwkDid_instance;
    function JwkDid_getInstance() {
        return JwkDid_instance;
    }
    function JwkDidResolver() {
        this.x3l_1 = toSet(get_entries());
    }
    protoOf(JwkDidResolver).y3l = function(did, $completion) {
        var id = did.k2i_1;
        var tmp;
        try {
            tmp = decodeToString(decodeBase64Url(id));
        } catch ($p) {
            var tmp_0;
            if ($p instanceof Exception) {
                var ex = $p;
                throw new DidResolutionException("DID identifier is not base64 url");
            } else throw $p;
        }
        var jwkString = tmp;
        var jwk;
        try {
            var element = Default_getInstance().c19(jwkString);
            if (!(element instanceof JsonObject)) throw new DidResolutionException("DID Identifier is not valid for DID method");
            jwk = element;
        } catch ($p) {
            if ($p instanceof SerializationException) {
                var ex_0 = $p;
                throw new DidResolutionException("DID Identifier is not valid for DID method", ex_0);
            } else throw $p;
        }
        var tmp0_id = did.m2i("0");
        var tmp1_type = VerificationMethodType_JsonWebKey2020_getInstance();
        var tmp2_controller = DefaultJsonMultiValue_init_$Create$(did);
        var tmp3_publicKeyJwk = new JsonPublicKeyJwk(jwk);
        var didDocument = new JsonDidDocument(did, DefaultJsonMultiValue_init_$Create$(new JsonVerificationMethod(tmp0_id, tmp2_controller, tmp1_type, tmp3_publicKeyJwk)));
        return new JsonDidResolutionSuccessResult(didDocument);
    };
    protoOf(JwkDidResolver).k2j = function(did, $completion) {
        return this.y3l(did, $completion);
    };
    protoOf(JwkDidResolver).o2k = function() {
        return this.x3l_1;
    };
    var JwkDidType_JWK_instance;
    function values() {
        return [
            JwkDidType_JWK_getInstance()
        ];
    }
    function get_entries() {
        if ($ENTRIES == null) $ENTRIES = enumEntries(values());
        return $ENTRIES;
    }
    var JwkDidType_entriesInitialized;
    function JwkDidType_initEntries() {
        if (JwkDidType_entriesInitialized) return Unit_instance;
        JwkDidType_entriesInitialized = true;
        JwkDidType_JWK_instance = new JwkDidType("JWK", 0);
    }
    var $ENTRIES;
    function JwkDidType(name, ordinal) {
        Enum.call(this, name, ordinal);
    }
    protoOf(JwkDidType).toString = function() {
        return "jwk";
    };
    var VerificationMethodType_JsonWebKey2020_instance;
    var VerificationMethodType_EcdsaSecp256k1VerificationKey2019_instance;
    var VerificationMethodType_entriesInitialized;
    function VerificationMethodType_initEntries() {
        if (VerificationMethodType_entriesInitialized) return Unit_instance;
        VerificationMethodType_entriesInitialized = true;
        VerificationMethodType_JsonWebKey2020_instance = new VerificationMethodType("JsonWebKey2020", 0, "JsonWebKey2020");
        VerificationMethodType_EcdsaSecp256k1VerificationKey2019_instance = new VerificationMethodType("EcdsaSecp256k1VerificationKey2019", 1, "EcdsaSecp256k1VerificationKey2019");
    }
    function VerificationMethodType(name, ordinal, value) {
        Enum.call(this, name, ordinal);
        this.b3m_1 = value;
    }
    protoOf(VerificationMethodType).toString = function() {
        return this.p2_1;
    };
    function JwkDidType_JWK_getInstance() {
        JwkDidType_initEntries();
        return JwkDidType_JWK_instance;
    }
    function VerificationMethodType_JsonWebKey2020_getInstance() {
        VerificationMethodType_initEntries();
        return VerificationMethodType_JsonWebKey2020_instance;
    }
    //region block: init
    JwkDid_instance = new JwkDid();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = JwkDid_instance;
    _.$_$.b = JwkDidResolver;
    //endregion
    return _;
});

});
parcelRegister("lsn9o", function(module, exports) {



(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./curity-ssi-libs-core.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")), (parcelRequire("iuiRe")), (parcelRequire("ctZcf")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var VOID = kotlin_kotlin.$_$.f;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var ToString = kotlin_io_curity_ssi_core.$_$.m;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var isBlank = kotlin_kotlin.$_$.uc;
    var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var StringBuilder = kotlin_kotlin.$_$.hc;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
    var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
    var addAll = kotlin_kotlin.$_$.w5;
    var toSet = kotlin_kotlin.$_$.r8;
    var Exception = kotlin_kotlin.$_$.ke;
    var Exception_init_$Init$ = kotlin_kotlin.$_$.o1;
    var captureStack = kotlin_kotlin.$_$.t9;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForClass(Did, "Did", VOID, VOID, [
        ToString
    ]);
    initMetadataForCompanion(Companion_0);
    initMetadataForClass(DidUrl, "DidUrl", VOID, VOID, [
        ToString
    ]);
    initMetadataForLambda(CompositeDidResolver$resolve$o$collect$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
    initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, "sam$kotlinx_coroutines_flow_FlowCollector$0", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($resolveCOROUTINE$0, CoroutineImpl);
    initMetadataForClass(CompositeDidResolver, "CompositeDidResolver", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(DidResolutionException, "DidResolutionException", VOID, Exception);
    //endregion
    function Companion() {}
    protoOf(Companion).a1m = function(value) {
        var tmp1_safe_receiver = Companion_getInstance_0().d2i(value);
        var tmp;
        if (tmp1_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.Companion.parse.<anonymous>' call
            var tmp_0;
            if (tmp1_safe_receiver.i2i_1) tmp_0 = tmp1_safe_receiver.e2i_1;
            else tmp_0 = null;
            tmp = tmp_0;
        }
        return tmp;
    };
    var Companion_instance;
    function Companion_getInstance() {
        return Companion_instance;
    }
    function Did(method, identifier) {
        this.j2i_1 = method;
        this.k2i_1 = identifier;
        this.l2i_1 = "did:" + this.j2i_1 + ":" + this.k2i_1;
    }
    protoOf(Did).toString = function() {
        return this.l2i_1;
    };
    protoOf(Did).m2i = function(fragment) {
        return new DidUrl(this, VOID, VOID, fragment);
    };
    protoOf(Did).equals = function(other) {
        if (this === other) return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) return false;
        if (!(other instanceof Did)) THROW_CCE();
        return this.l2i_1 === other.l2i_1;
    };
    protoOf(Did).hashCode = function() {
        return getStringHashCode(this.l2i_1);
    };
    function require_0($this, value) {
        var tmp;
        // Inline function 'kotlin.text.isNullOrBlank' call
        // Inline function 'kotlin.contracts.contract' call
        if (value == null || isBlank(value)) tmp = null;
        else tmp = value;
        return tmp;
    }
    function Companion_0() {
        Companion_instance_0 = this;
        this.v2h_1 = "(?:%[0-9a-fA-F]{2})";
        this.w2h_1 = "(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))";
        this.x2h_1 = "([a-z0-9]+)";
        this.y2h_1 = "((?:(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))*:)*((?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))+))";
        this.z2h_1 = "(/[^#?]*)?";
        this.a2i_1 = "([?][^#]*)?";
        this.b2i_1 = "(#.*)?";
        this.c2i_1 = Regex_init_$Create$("^did:([a-z0-9]+):((?:(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))*:)*((?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))+))(/[^#?]*)?([?][^#]*)?(#.*)?$");
    }
    protoOf(Companion_0).d2i = function(didString) {
        var tmp0_elvis_lhs = this.c2i_1.kc(didString);
        var tmp;
        if (tmp0_elvis_lhs == null) return null;
        else tmp = tmp0_elvis_lhs;
        var matchResult = tmp;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = matchResult.zc();
        var groupValues = copyToArray(this_0);
        if (!(groupValues.length === 7)) return null;
        var tmp1_elvis_lhs = require_0(this, groupValues[1]);
        var tmp_0;
        if (tmp1_elvis_lhs == null) return null;
        else tmp_0 = tmp1_elvis_lhs;
        var method = tmp_0;
        var tmp2_elvis_lhs = require_0(this, groupValues[2]);
        var tmp_1;
        if (tmp2_elvis_lhs == null) return null;
        else tmp_1 = tmp2_elvis_lhs;
        var id = tmp_1;
        var tmp2_safe_receiver = groupValues[4];
        var tmp_2;
        if (tmp2_safe_receiver == null) tmp_2 = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
            var tmp_3;
            if (isBlank(tmp2_safe_receiver)) tmp_3 = null;
            else // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_3 = tmp2_safe_receiver.substring(1);
            tmp_2 = tmp_3;
        }
        var path = tmp_2;
        var tmp3_safe_receiver = groupValues[5];
        var tmp_4;
        if (tmp3_safe_receiver == null) tmp_4 = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
            var tmp_5;
            if (isBlank(tmp3_safe_receiver)) tmp_5 = null;
            else // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_5 = tmp3_safe_receiver.substring(1);
            tmp_4 = tmp_5;
        }
        var queryString = tmp_4;
        var tmp4_safe_receiver = groupValues[6];
        var tmp_6;
        if (tmp4_safe_receiver == null) tmp_6 = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
            var tmp_7;
            if (isBlank(tmp4_safe_receiver)) tmp_7 = null;
            else // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_7 = tmp4_safe_receiver.substring(1);
            tmp_6 = tmp_7;
        }
        var fragment = tmp_6;
        return new DidUrl(new Did(method, id), path, queryString, fragment);
    };
    var Companion_instance_0;
    function Companion_getInstance_0() {
        if (Companion_instance_0 == null) new Companion_0();
        return Companion_instance_0;
    }
    function DidUrl(did, path, query, fragment) {
        Companion_getInstance_0();
        path = path === VOID ? null : path;
        query = query === VOID ? null : query;
        fragment = fragment === VOID ? null : fragment;
        this.e2i_1 = did;
        this.f2i_1 = path;
        this.g2i_1 = query;
        this.h2i_1 = fragment;
        this.i2i_1 = this.f2i_1 == null && this.g2i_1 == null && this.h2i_1 == null;
    }
    protoOf(DidUrl).toString = function() {
        var builder = new StringBuilder(this.e2i_1.toString());
        if (!(this.f2i_1 == null)) builder.e8("/" + this.f2i_1);
        if (!(this.g2i_1 == null)) builder.e8("?" + this.g2i_1);
        if (!(this.h2i_1 == null)) builder.e8("#" + this.h2i_1);
        return builder.toString();
    };
    protoOf(DidUrl).hashCode = function() {
        var result = this.e2i_1.hashCode();
        result = imul(result, 31) + (this.f2i_1 == null ? 0 : getStringHashCode(this.f2i_1)) | 0;
        result = imul(result, 31) + (this.g2i_1 == null ? 0 : getStringHashCode(this.g2i_1)) | 0;
        result = imul(result, 31) + (this.h2i_1 == null ? 0 : getStringHashCode(this.h2i_1)) | 0;
        return result;
    };
    protoOf(DidUrl).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof DidUrl)) return false;
        var tmp0_other_with_cast = other instanceof DidUrl ? other : THROW_CCE();
        if (!this.e2i_1.equals(tmp0_other_with_cast.e2i_1)) return false;
        if (!(this.f2i_1 == tmp0_other_with_cast.f2i_1)) return false;
        if (!(this.g2i_1 == tmp0_other_with_cast.g2i_1)) return false;
        if (!(this.h2i_1 == tmp0_other_with_cast.h2i_1)) return false;
        return true;
    };
    function CompositeDidResolver$resolve$o$collect$slambda($$this$unsafeFlow, $did, resultContinuation) {
        this.v2i_1 = $$this$unsafeFlow;
        this.w2i_1 = $did;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(CompositeDidResolver$resolve$o$collect$slambda).i2j = function(value, $completion) {
        var tmp = this.j2j(value, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(CompositeDidResolver$resolve$o$collect$slambda).y9 = function(p1, $completion) {
        return this.i2j((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(CompositeDidResolver$resolve$o$collect$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 8;
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    var tmp_0 = this;
                    tmp_0.z2i_1 = this.v2i_1;
                    var tmp_1 = this;
                    tmp_1.a2j_1 = this.x2i_1;
                    var tmp_2 = this;
                    tmp_2.b2j_1 = this.a2j_1;
                    this.w8_1 = 3;
                    this.v8_1 = 2;
                    suspendResult = this.b2j_1.k2j(this.w2i_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.c2j_1 = suspendResult;
                    this.w8_1 = 8;
                    this.v8_1 = 4;
                    continue $sm;
                case 3:
                    this.w8_1 = 8;
                    var tmp_3 = this.y8_1;
                    if (tmp_3 instanceof DidResolutionException) {
                        this.d2j_1 = this.y8_1;
                        var tmp_4 = this;
                        tmp_4.c2j_1 = null;
                        this.v8_1 = 4;
                        continue $sm;
                    } else throw this.y8_1;
                case 4:
                    this.w8_1 = 8;
                    this.e2j_1 = this.c2j_1;
                    this.f2j_1 = this.e2j_1;
                    if (this.f2j_1 == null) {
                        this.y2i_1 = Unit_instance;
                        this.v8_1 = 7;
                        var tmp_5 = this;
                        continue $sm;
                    } else {
                        this.g2j_1 = this.f2j_1;
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 5:
                    this.h2j_1 = this.g2j_1;
                    this.v8_1 = 6;
                    suspendResult = this.z2i_1.a23(this.h2j_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 6:
                    this.y2i_1 = suspendResult;
                    this.v8_1 = 7;
                    continue $sm;
                case 7:
                    return Unit_instance;
                case 8:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 8) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(CompositeDidResolver$resolve$o$collect$slambda).j2j = function(value, completion) {
        var i = new CompositeDidResolver$resolve$o$collect$slambda(this.v2i_1, this.w2i_1, completion);
        i.x2i_1 = value;
        return i;
    };
    function CompositeDidResolver$resolve$o$collect$slambda_0($$this$unsafeFlow, $did, resultContinuation) {
        var i = new CompositeDidResolver$resolve$o$collect$slambda($$this$unsafeFlow, $did, resultContinuation);
        var l = function(value, $completion) {
            return i.i2j(value, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.t2j_1 = _this__u8e3s4;
        this.u2j_1 = collector;
    }
    protoOf($collectCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    tmp_0.v2j_1 = this.u2j_1;
                    this.v8_1 = 1;
                    var tmp_1 = CompositeDidResolver$resolve$o$collect$slambda_0(this.v2j_1, this.t2j_1.x2j_1, null);
                    suspendResult = this.t2j_1.w2j_1.c23(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
        this.y2j_1 = function_0;
    }
    protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a23 = function(value, $completion) {
        return this.y2j_1(value, $completion);
    };
    function _no_name_provided__qut3iv($this, $did) {
        this.w2j_1 = $this;
        this.x2j_1 = $did;
    }
    protoOf(_no_name_provided__qut3iv).b23 = function(collector, $completion) {
        var tmp = new $collectCOROUTINE$1(this, collector, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(_no_name_provided__qut3iv).c23 = function(collector, $completion) {
        return this.b23(collector, $completion);
    };
    function $resolveCOROUTINE$0(_this__u8e3s4, did, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h2k_1 = _this__u8e3s4;
        this.i2k_1 = did;
    }
    protoOf($resolveCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    var tmp0_elvis_lhs = this.h2k_1.l2k_1.e2(this.i2k_1.j2i_1);
                    var tmp_1;
                    if (tmp0_elvis_lhs == null) throw new DidResolutionException("DID method is not supported");
                    else tmp_1 = tmp0_elvis_lhs;
                    tmp_0.j2k_1 = tmp_1;
                    this.v8_1 = 1;
                    var this_0 = asFlow(this.j2k_1);
                    suspendResult = firstOrNull(new _no_name_provided__qut3iv(this_0, this.i2k_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var tmp1_elvis_lhs = suspendResult;
                    var tmp_2;
                    if (tmp1_elvis_lhs == null) throw new DidResolutionException("Could not resolve DID");
                    else tmp_2 = tmp1_elvis_lhs;
                    var resolutionResult = tmp_2;
                    return resolutionResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function CompositeDidResolver(didResolvers) {
        this.k2k_1 = didResolvers;
        var tmp = this;
        // Inline function 'kotlin.collections.buildMap' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.collections.buildMapInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = LinkedHashMap_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this.k2k_1.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_0 = element.o2k().j();
            while(tmp0_iterator_0.k()){
                var element_0 = tmp0_iterator_0.l();
                // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.getOrPut' call
                var key = element_0.toString();
                var value = this_0.e2(key);
                var tmp_0;
                if (value == null) {
                    // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    // Inline function 'kotlin.collections.mutableListOf' call
                    var answer = ArrayList_init_$Create$();
                    this_0.m2(key, answer);
                    tmp_0 = answer;
                } else tmp_0 = value;
                tmp_0.e(element);
            }
        }
        tmp.l2k_1 = this_0.r8();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var this_1 = this.k2k_1;
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator_1 = this_1.j();
        while(tmp0_iterator_1.k()){
            var element_1 = tmp0_iterator_1.l();
            // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.supportedMethods.<anonymous>' call
            var list = element_1.o2k();
            addAll(destination, list);
        }
        tmp_1.m2k_1 = toSet(destination);
        this.n2k_1 = this.m2k_1;
    }
    protoOf(CompositeDidResolver).k2j = function(did, $completion) {
        var tmp = new $resolveCOROUTINE$0(this, did, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(CompositeDidResolver).o2k = function() {
        return this.n2k_1;
    };
    function DidResolutionException(message, cause) {
        cause = cause === VOID ? null : cause;
        Exception_init_$Init$(message, cause, this);
        captureStack(this, DidResolutionException);
    }
    //region block: init
    Companion_instance = new Companion();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Companion_instance;
    _.$_$.b = Companion_getInstance_0;
    _.$_$.c = CompositeDidResolver;
    _.$_$.d = DidResolutionException;
    _.$_$.e = DidUrl;
    _.$_$.f = Did;
    //endregion
    return _;
});

});

parcelRegister("692Pz", function(module, exports) {







(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./curity-ssi-libs-core-json.js",
        "./kotlin-kotlin-stdlib.js",
        "./curity-ssi-libs-core.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./Kotlin-DateTime-library-kotlinx-datetime.js",
        "./curity-ssi-libs-did.js"
    ], factory);
    else factory(module.exports, (parcelRequire("fcWHW")), (parcelRequire("9vyMc")), (parcelRequire("iuiRe")), (parcelRequire("3kJd2")), (parcelRequire("2VOQS")), (parcelRequire("3WyZ3")), (parcelRequire("lsn9o")));
})(globalThis, function(_, kotlin_io_curity_ssi_core_json, kotlin_kotlin, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_did) {
    "use strict";
    //region block: imports
    var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
    var toMap = kotlin_kotlin.$_$.m8;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
    var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
    var get = kotlin_io_curity_ssi_core_json.$_$.q;
    var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
    var toJson = kotlin_io_curity_ssi_core_json.$_$.s;
    var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
    var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var VOID = kotlin_kotlin.$_$.f;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var MultiValue = kotlin_io_curity_ssi_core.$_$.l;
    var getKClass = kotlin_kotlin.$_$.e;
    var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
    var DefaultJsonMultiValueSerializer_getInstance = kotlin_io_curity_ssi_core_json.$_$.f;
    var lazy = kotlin_kotlin.$_$.qf;
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
    var ToString = kotlin_io_curity_ssi_core.$_$.m;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var toMutableMap = kotlin_kotlin.$_$.p8;
    var unwrapOptionalStringInstant = kotlin_io_curity_ssi_core_json.$_$.k1;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
    var Companion_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
    var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
    var AnyString = kotlin_io_curity_ssi_core_json.$_$.j;
    var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
    var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
    var DidUrl = kotlin_io_curity_ssi_did.$_$.e;
    var Companion_getInstance_0 = kotlin_io_curity_ssi_did.$_$.b;
    var toString = kotlin_kotlin.$_$.ob;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
    var Did = kotlin_io_curity_ssi_did.$_$.f;
    var Companion_instance = kotlin_io_curity_ssi_did.$_$.a;
    //endregion
    //region block: pre-declaration
    initMetadataForCompanion(Companion);
    initMetadataForClass(JsonPublicKeyJwk, "JsonPublicKeyJwk", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonPublicKeyJwkSerializer_getInstance
    });
    initMetadataForCompanion(Companion_0);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonDidResolutionSuccessResult, "JsonDidResolutionSuccessResult", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance
    });
    initMetadataForCompanion(Companion_1);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonDidDocument, "JsonDidDocument", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: $serializer_getInstance_0
    });
    initMetadataForCompanion(Companion_2);
    initMetadataForObject($serializer_1, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(JsonVerificationMethod, "JsonVerificationMethod", VOID, VOID, [
        ToJsonDictionary
    ], VOID, VOID, {
        0: $serializer_getInstance_1
    });
    initMetadataForCompanion(Companion_3);
    initMetadataForClass(JsonDidDocumentMetadata, "JsonDidDocumentMetadata", VOID, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonDidDocumentMetadataSerializer_getInstance
    });
    initMetadataForCompanion(Companion_4);
    initMetadataForClass(JsonDidResolutionMetadata, "JsonDidResolutionMetadata", JsonDidResolutionMetadata, VOID, [
        Dictionary,
        ToJsonDictionary
    ], VOID, VOID, {
        0: JsonDidResolutionMetadataSerializer_getInstance
    });
    initMetadataForObject(DidUrlAsStringSerializer, "DidUrlAsStringSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonPublicKeyJwkSerializer, "JsonPublicKeyJwkSerializer", VOID, JsonSerializer);
    initMetadataForObject(DidAsStringSerializer, "DidAsStringSerializer", VOID, VOID, [
        KSerializer
    ]);
    initMetadataForObject(JsonDidDocumentMetadataSerializer, "JsonDidDocumentMetadataSerializer", VOID, JsonSerializer);
    initMetadataForObject(JsonDidResolutionMetadataSerializer, "JsonDidResolutionMetadataSerializer", VOID, JsonSerializer);
    //endregion
    function Companion() {}
    protoOf(Companion).d27 = function(json) {
        return new JsonPublicKeyJwk(toMap(FromJsonHelper_instance.b27(json, "PublicKeyJwk")));
    };
    protoOf(Companion).a3k = function(other) {
        var tmp;
        if (other instanceof JsonPublicKeyJwk) tmp = other;
        else tmp = new JsonPublicKeyJwk(other.xl());
        return tmp;
    };
    var Companion_instance_0;
    function Companion_getInstance_1() {
        return Companion_instance_0;
    }
    function JsonPublicKeyJwk(map) {
        this.b3k_1 = map;
    }
    protoOf(JsonPublicKeyJwk).y26 = function() {
        return new JsonDictionary(this.b3k_1);
    };
    function Companion_0() {}
    var Companion_instance_1;
    function Companion_getInstance_2() {
        return Companion_instance_1;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.did.json.JsonDidResolutionSuccessResult", this, 3);
        tmp0_serialDesc.wy("document", false);
        tmp0_serialDesc.wy("documentMetadata", true);
        tmp0_serialDesc.wy("resolutionMetadata", true);
        this.c3k_1 = tmp0_serialDesc;
    }
    protoOf($serializer).d3k = function(encoder, value) {
        var tmp0_desc = this.c3k_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_0(), value.e3k_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.f3k_1 == null)) tmp1_output.dt(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), value.f3k_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g3k_1 == null)) tmp1_output.dt(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), value.g3k_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.d3k(encoder, value instanceof JsonDidResolutionSuccessResult ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.c3k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.lr(tmp0_desc);
        if (tmp7_input.as()) {
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else while(tmp1_flag){
            tmp2_index = tmp7_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, JsonDidDocumentMetadataSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, JsonDidResolutionMetadataSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp7_input.mr(tmp0_desc);
        return JsonDidResolutionSuccessResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
    };
    protoOf($serializer).yn = function() {
        return this.c3k_1;
    };
    protoOf($serializer).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            $serializer_getInstance_0(),
            get_nullable(JsonDidDocumentMetadataSerializer_getInstance()),
            get_nullable(JsonDidResolutionMetadataSerializer_getInstance())
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function JsonDidResolutionSuccessResult_init_$Init$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker, $this) {
        if (!(1 === (1 & seen0))) throwMissingFieldException(seen0, 1, $serializer_getInstance().c3k_1);
        $this.e3k_1 = document;
        if (0 === (seen0 & 2)) $this.f3k_1 = null;
        else $this.f3k_1 = documentMetadata;
        if (0 === (seen0 & 4)) $this.g3k_1 = null;
        else $this.g3k_1 = resolutionMetadata;
        return $this;
    }
    function JsonDidResolutionSuccessResult_init_$Create$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker) {
        return JsonDidResolutionSuccessResult_init_$Init$(seen0, document, documentMetadata, resolutionMetadata, serializationConstructorMarker, objectCreate(protoOf(JsonDidResolutionSuccessResult)));
    }
    function JsonDidResolutionSuccessResult(document, documentMetadata, resolutionMetadata) {
        documentMetadata = documentMetadata === VOID ? null : documentMetadata;
        resolutionMetadata = resolutionMetadata === VOID ? null : resolutionMetadata;
        this.e3k_1 = document;
        this.f3k_1 = documentMetadata;
        this.g3k_1 = resolutionMetadata;
    }
    protoOf(JsonDidResolutionSuccessResult).h3k = function() {
        return this.e3k_1;
    };
    function Companion_1() {
        Companion_instance_2 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = getKClass(MultiValue);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i3k_1 = [
            null,
            PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2),
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ];
    }
    protoOf(Companion_1).b1b = function() {
        return $serializer_getInstance_0();
    };
    var Companion_instance_2;
    function Companion_getInstance_3() {
        if (Companion_instance_2 == null) new Companion_1();
        return Companion_instance_2;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.did.json.JsonDidDocument", this, 10);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("verificationMethod", false);
        tmp0_serialDesc.wy("alsoKnownAs", true);
        tmp0_serialDesc.wy("controller", true);
        tmp0_serialDesc.wy("authentication", true);
        tmp0_serialDesc.wy("assertionMethod", true);
        tmp0_serialDesc.wy("keyAgreement", true);
        tmp0_serialDesc.wy("capabilityInvocation", true);
        tmp0_serialDesc.wy("capabilityDelegation", true);
        tmp0_serialDesc.wy("service", true);
        this.j3k_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).k3k = function(encoder, value) {
        var tmp0_desc = this.j3k_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().i3k_1;
        tmp1_output.bt(tmp0_desc, 0, DidAsStringSerializer_getInstance(), value.l3k_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.m3k_1);
        if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.n3k_1 == null)) tmp1_output.dt(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), value.n3k_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.o3k_1 == null)) tmp1_output.dt(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), value.o3k_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.p3k_1 == null)) tmp1_output.dt(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), value.p3k_1);
        if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.q3k_1 == null)) tmp1_output.dt(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), value.q3k_1);
        if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.r3k_1 == null)) tmp1_output.dt(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), value.r3k_1);
        if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.s3k_1 == null)) tmp1_output.dt(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), value.s3k_1);
        if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.t3k_1 == null)) tmp1_output.dt(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), value.t3k_1);
        if (tmp1_output.ht(tmp0_desc, 9) ? true : !(value.u3k_1 == null)) tmp1_output.dt(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), value.u3k_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.k3k(encoder, value instanceof JsonDidDocument ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.j3k_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp19_input = decoder.lr(tmp0_desc);
        var tmp20_cached = Companion_getInstance_3().i3k_1;
        if (tmp19_input.as()) {
            tmp4_local0 = tmp19_input.xr(tmp0_desc, 0, DidAsStringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp19_input.xr(tmp0_desc, 1, tmp20_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp19_input.zr(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp19_input.zr(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp19_input.zr(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp19_input.zr(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp19_input.zr(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            tmp11_local7 = tmp19_input.zr(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            tmp12_local8 = tmp19_input.zr(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            tmp13_local9 = tmp19_input.zr(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else while(tmp1_flag){
            tmp2_index = tmp19_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp19_input.xr(tmp0_desc, 0, DidAsStringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp19_input.xr(tmp0_desc, 1, tmp20_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp19_input.zr(tmp0_desc, 2, DefaultJsonMultiValueSerializer_getInstance(), tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp19_input.zr(tmp0_desc, 3, DefaultJsonMultiValueSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp19_input.zr(tmp0_desc, 4, DefaultJsonMultiValueSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp19_input.zr(tmp0_desc, 5, DefaultJsonMultiValueSerializer_getInstance(), tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp19_input.zr(tmp0_desc, 6, DefaultJsonMultiValueSerializer_getInstance(), tmp10_local6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                case 7:
                    tmp11_local7 = tmp19_input.zr(tmp0_desc, 7, DefaultJsonMultiValueSerializer_getInstance(), tmp11_local7);
                    tmp3_bitMask0 = tmp3_bitMask0 | 128;
                    break;
                case 8:
                    tmp12_local8 = tmp19_input.zr(tmp0_desc, 8, DefaultJsonMultiValueSerializer_getInstance(), tmp12_local8);
                    tmp3_bitMask0 = tmp3_bitMask0 | 256;
                    break;
                case 9:
                    tmp13_local9 = tmp19_input.zr(tmp0_desc, 9, DefaultJsonMultiValueSerializer_getInstance(), tmp13_local9);
                    tmp3_bitMask0 = tmp3_bitMask0 | 512;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp19_input.mr(tmp0_desc);
        return JsonDidDocument_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.j3k_1;
    };
    protoOf($serializer_0).lz = function() {
        var tmp0_cached = Companion_getInstance_3().i3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            DidAsStringSerializer_getInstance(),
            tmp0_cached[1],
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance())
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_0() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function JsonDidDocument_init_$Init$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_0().j3k_1);
        $this.l3k_1 = id;
        $this.m3k_1 = verificationMethod;
        if (0 === (seen0 & 4)) $this.n3k_1 = null;
        else $this.n3k_1 = alsoKnownAs;
        if (0 === (seen0 & 8)) $this.o3k_1 = null;
        else $this.o3k_1 = controller;
        if (0 === (seen0 & 16)) $this.p3k_1 = null;
        else $this.p3k_1 = _authentication;
        if (0 === (seen0 & 32)) $this.q3k_1 = null;
        else $this.q3k_1 = _assertionMethod;
        if (0 === (seen0 & 64)) $this.r3k_1 = null;
        else $this.r3k_1 = _keyAgreement;
        if (0 === (seen0 & 128)) $this.s3k_1 = null;
        else $this.s3k_1 = _capabilityInvocation;
        if (0 === (seen0 & 256)) $this.t3k_1 = null;
        else $this.t3k_1 = _capabilityDelegation;
        if (0 === (seen0 & 512)) $this.u3k_1 = null;
        else $this.u3k_1 = service;
        var tmp = $this;
        tmp.v3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd($this));
        var tmp_0 = $this;
        tmp_0.w3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_0($this));
        var tmp_1 = $this;
        tmp_1.x3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_1($this));
        var tmp_2 = $this;
        tmp_2.y3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_2($this));
        var tmp_3 = $this;
        tmp_3.z3k_1 = lazy(JsonDidDocument$_init_$lambda_nmzsrd_3($this));
        return $this;
    }
    function JsonDidDocument_init_$Create$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker) {
        return JsonDidDocument_init_$Init$(seen0, id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service, serializationConstructorMarker, objectCreate(protoOf(JsonDidDocument)));
    }
    function JsonDidDocument$authentication$delegate$lambda$lambda(it) {
        return it.a3l();
    }
    function JsonDidDocument$authentication$delegate$lambda(this$0) {
        return function() {
            var tmp4_safe_receiver = this$0.p3k_1;
            var tmp;
            if (tmp4_safe_receiver == null) tmp = null;
            else tmp = tmp4_safe_receiver.k27(JsonDidDocument$authentication$delegate$lambda$lambda);
            return tmp;
        };
    }
    function JsonDidDocument$assertionMethod$delegate$lambda$lambda(it) {
        return it.a3l();
    }
    function JsonDidDocument$assertionMethod$delegate$lambda(this$0) {
        return function() {
            var tmp5_safe_receiver = this$0.q3k_1;
            var tmp;
            if (tmp5_safe_receiver == null) tmp = null;
            else tmp = tmp5_safe_receiver.k27(JsonDidDocument$assertionMethod$delegate$lambda$lambda);
            return tmp;
        };
    }
    function JsonDidDocument$keyAgreement$delegate$lambda$lambda(it) {
        return it.a3l();
    }
    function JsonDidDocument$keyAgreement$delegate$lambda(this$0) {
        return function() {
            var tmp6_safe_receiver = this$0.r3k_1;
            var tmp;
            if (tmp6_safe_receiver == null) tmp = null;
            else tmp = tmp6_safe_receiver.k27(JsonDidDocument$keyAgreement$delegate$lambda$lambda);
            return tmp;
        };
    }
    function JsonDidDocument$capabilityInvocation$delegate$lambda$lambda(it) {
        return it.a3l();
    }
    function JsonDidDocument$capabilityInvocation$delegate$lambda(this$0) {
        return function() {
            var tmp7_safe_receiver = this$0.s3k_1;
            var tmp;
            if (tmp7_safe_receiver == null) tmp = null;
            else tmp = tmp7_safe_receiver.k27(JsonDidDocument$capabilityInvocation$delegate$lambda$lambda);
            return tmp;
        };
    }
    function JsonDidDocument$capabilityDelegation$delegate$lambda$lambda(it) {
        return it.a3l();
    }
    function JsonDidDocument$capabilityDelegation$delegate$lambda(this$0) {
        return function() {
            var tmp8_safe_receiver = this$0.t3k_1;
            var tmp;
            if (tmp8_safe_receiver == null) tmp = null;
            else tmp = tmp8_safe_receiver.k27(JsonDidDocument$capabilityDelegation$delegate$lambda$lambda);
            return tmp;
        };
    }
    function JsonDidDocument$_init_$lambda$lambda_3wo04c(it) {
        return it.a3l();
    }
    function JsonDidDocument$_init_$lambda_nmzsrd(this$0) {
        return function() {
            var tmp4_safe_receiver = this$0.p3k_1;
            var tmp;
            if (tmp4_safe_receiver == null) tmp = null;
            else tmp = tmp4_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c);
            return tmp;
        };
    }
    function JsonDidDocument$_init_$lambda$lambda_3wo04c_0(it) {
        return it.a3l();
    }
    function JsonDidDocument$_init_$lambda_nmzsrd_0(this$0) {
        return function() {
            var tmp5_safe_receiver = this$0.q3k_1;
            var tmp;
            if (tmp5_safe_receiver == null) tmp = null;
            else tmp = tmp5_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_0);
            return tmp;
        };
    }
    function JsonDidDocument$_init_$lambda$lambda_3wo04c_1(it) {
        return it.a3l();
    }
    function JsonDidDocument$_init_$lambda_nmzsrd_1(this$0) {
        return function() {
            var tmp6_safe_receiver = this$0.r3k_1;
            var tmp;
            if (tmp6_safe_receiver == null) tmp = null;
            else tmp = tmp6_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_1);
            return tmp;
        };
    }
    function JsonDidDocument$_init_$lambda$lambda_3wo04c_2(it) {
        return it.a3l();
    }
    function JsonDidDocument$_init_$lambda_nmzsrd_2(this$0) {
        return function() {
            var tmp7_safe_receiver = this$0.s3k_1;
            var tmp;
            if (tmp7_safe_receiver == null) tmp = null;
            else tmp = tmp7_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_2);
            return tmp;
        };
    }
    function JsonDidDocument$_init_$lambda$lambda_3wo04c_3(it) {
        return it.a3l();
    }
    function JsonDidDocument$_init_$lambda_nmzsrd_3(this$0) {
        return function() {
            var tmp8_safe_receiver = this$0.t3k_1;
            var tmp;
            if (tmp8_safe_receiver == null) tmp = null;
            else tmp = tmp8_safe_receiver.k27(JsonDidDocument$_init_$lambda$lambda_3wo04c_3);
            return tmp;
        };
    }
    function JsonDidDocument(id, verificationMethod, alsoKnownAs, controller, _authentication, _assertionMethod, _keyAgreement, _capabilityInvocation, _capabilityDelegation, service) {
        Companion_getInstance_3();
        alsoKnownAs = alsoKnownAs === VOID ? null : alsoKnownAs;
        controller = controller === VOID ? null : controller;
        _authentication = _authentication === VOID ? null : _authentication;
        _assertionMethod = _assertionMethod === VOID ? null : _assertionMethod;
        _keyAgreement = _keyAgreement === VOID ? null : _keyAgreement;
        _capabilityInvocation = _capabilityInvocation === VOID ? null : _capabilityInvocation;
        _capabilityDelegation = _capabilityDelegation === VOID ? null : _capabilityDelegation;
        service = service === VOID ? null : service;
        this.l3k_1 = id;
        this.m3k_1 = verificationMethod;
        this.n3k_1 = alsoKnownAs;
        this.o3k_1 = controller;
        this.p3k_1 = _authentication;
        this.q3k_1 = _assertionMethod;
        this.r3k_1 = _keyAgreement;
        this.s3k_1 = _capabilityInvocation;
        this.t3k_1 = _capabilityDelegation;
        this.u3k_1 = service;
        var tmp = this;
        tmp.v3k_1 = lazy(JsonDidDocument$authentication$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.w3k_1 = lazy(JsonDidDocument$assertionMethod$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.x3k_1 = lazy(JsonDidDocument$keyAgreement$delegate$lambda(this));
        var tmp_2 = this;
        tmp_2.y3k_1 = lazy(JsonDidDocument$capabilityInvocation$delegate$lambda(this));
        var tmp_3 = this;
        tmp_3.z3k_1 = lazy(JsonDidDocument$capabilityDelegation$delegate$lambda(this));
    }
    protoOf(JsonDidDocument).y26 = function() {
        return new JsonDictionary(get_jsonObject(Default_getInstance().a19(Companion_getInstance_3().b1b(), this)));
    };
    protoOf(JsonDidDocument).b3l = function(didUrl) {
        var didString = didUrl.toString();
        var tmp$ret$1;
        $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = this.m3k_1.qm().j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.curity.ssi.did.json.JsonDidDocument.getVerificationMethodFor.<anonymous>' call
                if (element.c3l_1.toString() === didString) {
                    tmp$ret$1 = element;
                    break $l$block;
                }
            }
            tmp$ret$1 = null;
        }
        return tmp$ret$1;
    };
    function Companion_2() {
        Companion_instance_3 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = getKClass(ToString);
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.h3l_1 = [
            null,
            null,
            PolymorphicSerializer_init_$Create$(tmp_0, tmp$ret$2),
            null,
            null
        ];
    }
    protoOf(Companion_2).d27 = function(json) {
        return Default_getInstance().b19(this.b1b(), json);
    };
    protoOf(Companion_2).b1b = function() {
        return $serializer_getInstance_1();
    };
    var Companion_instance_3;
    function Companion_getInstance_4() {
        if (Companion_instance_3 == null) new Companion_2();
        return Companion_instance_3;
    }
    function $serializer_1() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.ssi.did.json.JsonVerificationMethod", this, 5);
        tmp0_serialDesc.wy("id", false);
        tmp0_serialDesc.wy("controller", true);
        tmp0_serialDesc.wy("type", false);
        tmp0_serialDesc.wy("publicKeyJwk", true);
        tmp0_serialDesc.wy("publicKeyMultibase", true);
        this.i3l_1 = tmp0_serialDesc;
    }
    protoOf($serializer_1).j3l = function(encoder, value) {
        var tmp0_desc = this.i3l_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_4().h3l_1;
        tmp1_output.bt(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), value.c3l_1);
        if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d3l_1 == null)) tmp1_output.dt(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), value.d3l_1);
        tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.e3l_1);
        if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.f3l_1 == null)) tmp1_output.dt(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), value.f3l_1);
        if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.g3l_1 == null)) tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.g3l_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_1).zn = function(encoder, value) {
        return this.j3l(encoder, value instanceof JsonVerificationMethod ? value : THROW_CCE());
    };
    protoOf($serializer_1).ao = function(decoder) {
        var tmp0_desc = this.i3l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.lr(tmp0_desc);
        var tmp10_cached = Companion_getInstance_4().h3l_1;
        if (tmp9_input.as()) {
            tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else while(tmp1_flag){
            tmp2_index = tmp9_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, DidUrlAsStringSerializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, DefaultJsonMultiValueSerializer_getInstance(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, JsonPublicKeyJwkSerializer_getInstance(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp9_input.mr(tmp0_desc);
        return JsonVerificationMethod_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
    };
    protoOf($serializer_1).yn = function() {
        return this.i3l_1;
    };
    protoOf($serializer_1).lz = function() {
        var tmp0_cached = Companion_getInstance_4().h3l_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            DidUrlAsStringSerializer_getInstance(),
            get_nullable(DefaultJsonMultiValueSerializer_getInstance()),
            tmp0_cached[2],
            get_nullable(JsonPublicKeyJwkSerializer_getInstance()),
            get_nullable(StringSerializer_getInstance())
        ];
    };
    var $serializer_instance_1;
    function $serializer_getInstance_1() {
        if ($serializer_instance_1 == null) new $serializer_1();
        return $serializer_instance_1;
    }
    function JsonVerificationMethod_init_$Init$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker, $this) {
        if (!(5 === (5 & seen0))) throwMissingFieldException(seen0, 5, $serializer_getInstance_1().i3l_1);
        $this.c3l_1 = id;
        if (0 === (seen0 & 2)) $this.d3l_1 = null;
        else $this.d3l_1 = controller;
        $this.e3l_1 = type;
        if (0 === (seen0 & 8)) $this.f3l_1 = null;
        else $this.f3l_1 = publicKeyJwk;
        if (0 === (seen0 & 16)) $this.g3l_1 = null;
        else $this.g3l_1 = publicKeyMultibase;
        return $this;
    }
    function JsonVerificationMethod_init_$Create$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker) {
        return JsonVerificationMethod_init_$Init$(seen0, id, controller, type, publicKeyJwk, publicKeyMultibase, serializationConstructorMarker, objectCreate(protoOf(JsonVerificationMethod)));
    }
    function JsonVerificationMethod(id, controller, type, publicKeyJwk, publicKeyMultibase) {
        Companion_getInstance_4();
        controller = controller === VOID ? null : controller;
        publicKeyJwk = publicKeyJwk === VOID ? null : publicKeyJwk;
        publicKeyMultibase = publicKeyMultibase === VOID ? null : publicKeyMultibase;
        this.c3l_1 = id;
        this.d3l_1 = controller;
        this.e3l_1 = type;
        this.f3l_1 = publicKeyJwk;
        this.g3l_1 = publicKeyMultibase;
    }
    protoOf(JsonVerificationMethod).k3l = function() {
        return this.f3l_1;
    };
    protoOf(JsonVerificationMethod).y26 = function() {
        return new JsonDictionary(get_jsonObject(Default_getInstance().a19(Companion_getInstance_4().b1b(), this)));
    };
    function Companion_3() {}
    protoOf(Companion_3).d27 = function(json) {
        var obj = toMutableMap(FromJsonHelper_instance.b27(json, "JsonDidDocumentMetadata"));
        return new JsonDidDocumentMetadata(unwrapOptionalStringInstant(obj, "updated"), unwrapOptionalStringInstant(obj, "updated"), toMap(obj));
    };
    var Companion_instance_4;
    function Companion_getInstance_5() {
        return Companion_instance_4;
    }
    function _get__serialized__5dtwz6($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.o3l_1;
        _serialized$factory();
        return this_0.b1();
    }
    function JsonDidDocumentMetadata$_serialized$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.json.JsonDidDocumentMetadata._serialized$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.n3l_1);
            var tmp0_safe_receiver = this$0.l3l_1;
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.json.JsonDidDocumentMetadata._serialized$delegate.<anonymous>.<anonymous>.<anonymous>' call
            this_0.m2("created", Default_getInstance().a19(Companion_getInstance().b1b(), tmp0_safe_receiver));
            var tmp1_safe_receiver = this$0.m3l_1;
            if (tmp1_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this_0.m2("updated", Default_getInstance().a19(Companion_getInstance().b1b(), tmp1_safe_receiver));
            var tmp$ret$5 = this_0.r8();
            return new JsonDictionary(tmp$ret$5);
        };
    }
    function JsonDidDocumentMetadata(created, updated, customClaims) {
        created = created === VOID ? null : created;
        updated = updated === VOID ? null : updated;
        this.l3l_1 = created;
        this.m3l_1 = updated;
        this.n3l_1 = customClaims;
        var tmp = this;
        tmp.o3l_1 = lazy(JsonDidDocumentMetadata$_serialized$delegate$lambda(this));
    }
    protoOf(JsonDidDocumentMetadata).y26 = function() {
        return _get__serialized__5dtwz6(this);
    };
    function Companion_4() {}
    protoOf(Companion_4).d27 = function(json) {
        var obj = toMutableMap(FromJsonHelper_instance.b27(json, "JsonDidDocumentMetadata"));
        var tmp2_safe_receiver = unwrapOptionalString(obj, "contentType");
        var tmp;
        if (tmp2_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.ssi.did.json.Companion.fromJson.<anonymous>' call
        tmp = new AnyString(tmp2_safe_receiver);
        return new JsonDidResolutionMetadata(tmp, toMap(obj));
    };
    var Companion_instance_5;
    function Companion_getInstance_6() {
        return Companion_instance_5;
    }
    function _get__serialized__5dtwz6_0($this) {
        // Inline function 'kotlin.getValue' call
        var this_0 = $this.r3l_1;
        _serialized$factory_0();
        return this_0.b1();
    }
    function JsonDidResolutionMetadata$_serialized$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.buildMap' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.buildMapInternal' call
            // Inline function 'kotlin.apply' call
            var this_0 = LinkedHashMap_init_$Create$();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.ssi.did.json.JsonDidResolutionMetadata._serialized$delegate.<anonymous>.<anonymous>' call
            this_0.o2(this$0.q3l_1);
            var tmp3_safe_receiver = this$0.p3l_1;
            if (tmp3_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this_0.m2("contentType", JsonPrimitive(tmp3_safe_receiver.toString()));
            var tmp$ret$3 = this_0.r8();
            return new JsonDictionary(tmp$ret$3);
        };
    }
    function JsonDidResolutionMetadata(contentType, customClaims) {
        contentType = contentType === VOID ? null : contentType;
        customClaims = customClaims === VOID ? emptyMap() : customClaims;
        this.p3l_1 = contentType;
        this.q3l_1 = customClaims;
        var tmp = this;
        tmp.r3l_1 = lazy(JsonDidResolutionMetadata$_serialized$delegate$lambda(this));
    }
    protoOf(JsonDidResolutionMetadata).y26 = function() {
        return _get__serialized__5dtwz6_0(this);
    };
    function _serialized$factory() {
        return getPropertyCallableRef("_serialized", 1, KProperty1, function(receiver) {
            return _get__serialized__5dtwz6(receiver);
        }, null);
    }
    function _serialized$factory_0() {
        return getPropertyCallableRef("_serialized", 1, KProperty1, function(receiver) {
            return _get__serialized__5dtwz6_0(receiver);
        }, null);
    }
    function DidUrlAsStringSerializer() {
        DidUrlAsStringSerializer_instance = this;
        this.s3l_1 = PrimitiveSerialDescriptor("io.curity.ssi.did.json.DidUrlAsStringSerializer", STRING_getInstance());
    }
    protoOf(DidUrlAsStringSerializer).yn = function() {
        return this.s3l_1;
    };
    protoOf(DidUrlAsStringSerializer).t3l = function(encoder, value) {
        return encoder.os(value.toString());
    };
    protoOf(DidUrlAsStringSerializer).zn = function(encoder, value) {
        return this.t3l(encoder, value instanceof DidUrl ? value : THROW_CCE());
    };
    protoOf(DidUrlAsStringSerializer).ao = function(decoder) {
        var tmp0_elvis_lhs = Companion_getInstance_0().d2i(decoder.gr());
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "String does not conform to DID URL syntax";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    var DidUrlAsStringSerializer_instance;
    function DidUrlAsStringSerializer_getInstance() {
        if (DidUrlAsStringSerializer_instance == null) new DidUrlAsStringSerializer();
        return DidUrlAsStringSerializer_instance;
    }
    function JsonPublicKeyJwkSerializer() {
        JsonPublicKeyJwkSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_0);
    }
    var JsonPublicKeyJwkSerializer_instance;
    function JsonPublicKeyJwkSerializer_getInstance() {
        if (JsonPublicKeyJwkSerializer_instance == null) new JsonPublicKeyJwkSerializer();
        return JsonPublicKeyJwkSerializer_instance;
    }
    function DidAsStringSerializer() {
        DidAsStringSerializer_instance = this;
        this.u3l_1 = PrimitiveSerialDescriptor("io.curity.ssi.did.json.DidAsStringSerializer", STRING_getInstance());
    }
    protoOf(DidAsStringSerializer).yn = function() {
        return this.u3l_1;
    };
    protoOf(DidAsStringSerializer).v3l = function(encoder, value) {
        return encoder.os(value.toString());
    };
    protoOf(DidAsStringSerializer).zn = function(encoder, value) {
        return this.v3l(encoder, value instanceof Did ? value : THROW_CCE());
    };
    protoOf(DidAsStringSerializer).ao = function(decoder) {
        var tmp0_elvis_lhs = Companion_instance.a1m(decoder.gr());
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "String does not conform to DID syntax";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        return tmp;
    };
    var DidAsStringSerializer_instance;
    function DidAsStringSerializer_getInstance() {
        if (DidAsStringSerializer_instance == null) new DidAsStringSerializer();
        return DidAsStringSerializer_instance;
    }
    function JsonDidDocumentMetadataSerializer() {
        JsonDidDocumentMetadataSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_4);
    }
    var JsonDidDocumentMetadataSerializer_instance;
    function JsonDidDocumentMetadataSerializer_getInstance() {
        if (JsonDidDocumentMetadataSerializer_instance == null) new JsonDidDocumentMetadataSerializer();
        return JsonDidDocumentMetadataSerializer_instance;
    }
    function JsonDidResolutionMetadataSerializer() {
        JsonDidResolutionMetadataSerializer_instance = this;
        JsonSerializer.call(this, Companion_instance_5);
    }
    var JsonDidResolutionMetadataSerializer_instance;
    function JsonDidResolutionMetadataSerializer_getInstance() {
        if (JsonDidResolutionMetadataSerializer_instance == null) new JsonDidResolutionMetadataSerializer();
        return JsonDidResolutionMetadataSerializer_instance;
    }
    //region block: post-declaration
    protoOf(JsonPublicKeyJwk).f2 = get_keys;
    protoOf(JsonPublicKeyJwk).vl = get;
    protoOf(JsonPublicKeyJwk).xl = toMap_0;
    protoOf(JsonPublicKeyJwk).a27 = toJson;
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    protoOf(JsonDidDocument).f2 = get_keys;
    protoOf(JsonDidDocument).vl = get;
    protoOf(JsonDidDocument).xl = toMap_0;
    protoOf(JsonDidDocument).a27 = toJson;
    protoOf($serializer_1).mz = typeParametersSerializers;
    protoOf(JsonVerificationMethod).f2 = get_keys;
    protoOf(JsonVerificationMethod).vl = get;
    protoOf(JsonVerificationMethod).a27 = toJson;
    protoOf(JsonVerificationMethod).xl = toMap_0;
    protoOf(JsonDidDocumentMetadata).f2 = get_keys;
    protoOf(JsonDidDocumentMetadata).vl = get;
    protoOf(JsonDidDocumentMetadata).xl = toMap_0;
    protoOf(JsonDidDocumentMetadata).a27 = toJson;
    protoOf(JsonDidResolutionMetadata).f2 = get_keys;
    protoOf(JsonDidResolutionMetadata).vl = get;
    protoOf(JsonDidResolutionMetadata).xl = toMap_0;
    protoOf(JsonDidResolutionMetadata).a27 = toJson;
    //endregion
    //region block: init
    Companion_instance_0 = new Companion();
    Companion_instance_1 = new Companion_0();
    Companion_instance_4 = new Companion_3();
    Companion_instance_5 = new Companion_4();
    //endregion
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = Companion_instance_0;
    _.$_$.b = JsonDidDocument;
    _.$_$.c = JsonDidResolutionSuccessResult;
    _.$_$.d = JsonPublicKeyJwk;
    _.$_$.e = JsonVerificationMethod;
    //endregion
    return _;
});

});


parcelRegister("3pY5s", function(module, exports) {

(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js"
    ], factory);
    else factory(module.exports, (parcelRequire("9vyMc")));
})(globalThis, function(_, kotlin_kotlin) {
    "use strict";
    //region block: imports
    var protoOf = kotlin_kotlin.$_$.kb;
    var toString = kotlin_kotlin.$_$.ob;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    //endregion
    //region block: pre-declaration
    initMetadataForClass(EventListenerHandler, "EventListenerHandler");
    //endregion
    function EventListener(handler) {
        return new EventListenerHandler(handler);
    }
    function EventListenerHandler(handler) {
        this.nl_1 = handler;
    }
    protoOf(EventListenerHandler).ol = function(event) {
        this.nl_1(event);
    };
    protoOf(EventListenerHandler).handleEvent = function(event) {
        return this.ol(event);
    };
    protoOf(EventListenerHandler).toString = function() {
        return "EventListenerHandler(" + toString(this.nl_1) + ")";
    };
    //region block: exports
    _.$_$ = _.$_$ || {};
    _.$_$.a = EventListener;
    //endregion
    return _;
});

});

parcelRegister("hdGlG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.GA4 = void 0;

var $c8948021b554a410$var$_gtag = $c8948021b554a410$var$_interopRequireDefault((parcelRequire("brtX6")));

var $c8948021b554a410$var$_format = $c8948021b554a410$var$_interopRequireDefault((parcelRequire("k0qU7")));
var $c8948021b554a410$var$_excluded = [
    "eventCategory",
    "eventAction",
    "eventLabel",
    "eventValue",
    "hitType"
], $c8948021b554a410$var$_excluded2 = [
    "title",
    "location"
], $c8948021b554a410$var$_excluded3 = [
    "page",
    "hitType"
];
function $c8948021b554a410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c8948021b554a410$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c8948021b554a410$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c8948021b554a410$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c8948021b554a410$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c8948021b554a410$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c8948021b554a410$var$_typeof(obj);
}
function $c8948021b554a410$var$_toConsumableArray(arr) {
    return $c8948021b554a410$var$_arrayWithoutHoles(arr) || $c8948021b554a410$var$_iterableToArray(arr) || $c8948021b554a410$var$_unsupportedIterableToArray(arr) || $c8948021b554a410$var$_nonIterableSpread();
}
function $c8948021b554a410$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8948021b554a410$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c8948021b554a410$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c8948021b554a410$var$_arrayLikeToArray(arr);
}
function $c8948021b554a410$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c8948021b554a410$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c8948021b554a410$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c8948021b554a410$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c8948021b554a410$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c8948021b554a410$var$_slicedToArray(arr, i) {
    return $c8948021b554a410$var$_arrayWithHoles(arr) || $c8948021b554a410$var$_iterableToArrayLimit(arr, i) || $c8948021b554a410$var$_unsupportedIterableToArray(arr, i) || $c8948021b554a410$var$_nonIterableRest();
}
function $c8948021b554a410$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8948021b554a410$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8948021b554a410$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8948021b554a410$var$_arrayLikeToArray(o, minLen);
}
function $c8948021b554a410$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8948021b554a410$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $c8948021b554a410$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c8948021b554a410$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c8948021b554a410$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c8948021b554a410$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c8948021b554a410$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c8948021b554a410$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c8948021b554a410$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c8948021b554a410$var$_defineProperty(obj, key, value) {
    key = $c8948021b554a410$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c8948021b554a410$var$_toPropertyKey(arg) {
    var key = $c8948021b554a410$var$_toPrimitive(arg, "string");
    return $c8948021b554a410$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c8948021b554a410$var$_toPrimitive(input, hint) {
    if ($c8948021b554a410$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c8948021b554a410$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/ /**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */ /**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */ /**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */ var $c8948021b554a410$var$GA4 = /*#__PURE__*/ function() {
    function GA4() {
        var _this = this;
        $c8948021b554a410$var$_classCallCheck(this, GA4);
        $c8948021b554a410$var$_defineProperty(this, "reset", function() {
            _this.isInitialized = false;
            _this._testMode = false;
            _this._currentMeasurementId;
            _this._hasLoadedGA = false;
            _this._isQueuing = false;
            _this._queueGtag = [];
        });
        $c8948021b554a410$var$_defineProperty(this, "_gtag", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!_this._testMode) {
                if (_this._isQueuing) _this._queueGtag.push(args);
                else $c8948021b554a410$var$_gtag["default"].apply(void 0, args);
            } else _this._queueGtag.push(args);
        });
        $c8948021b554a410$var$_defineProperty(this, "_loadGA", function(GA_MEASUREMENT_ID, nonce) {
            var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
            if (typeof window === "undefined" || typeof document === "undefined") return;
            if (!_this._hasLoadedGA) {
                // Global Site Tag (gtag.js) - Google Analytics
                var script = document.createElement("script");
                script.async = true;
                script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
                if (nonce) script.setAttribute("nonce", nonce);
                document.body.appendChild(script);
                window.dataLayer = window.dataLayer || [];
                window.gtag = function gtag() {
                    window.dataLayer.push(arguments);
                };
                _this._hasLoadedGA = true;
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_toGtagOptions", function(gaOptions) {
            if (!gaOptions) return;
            var mapFields = {
                // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
                // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
                cookieUpdate: "cookie_update",
                cookieExpires: "cookie_expires",
                cookieDomain: "cookie_domain",
                cookieFlags: "cookie_flags",
                // must be in set method?
                userId: "user_id",
                clientId: "client_id",
                anonymizeIp: "anonymize_ip",
                // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
                contentGroup1: "content_group1",
                contentGroup2: "content_group2",
                contentGroup3: "content_group3",
                contentGroup4: "content_group4",
                contentGroup5: "content_group5",
                // https://support.google.com/analytics/answer/9050852?hl=en
                allowAdFeatures: "allow_google_signals",
                allowAdPersonalizationSignals: "allow_ad_personalization_signals",
                nonInteraction: "non_interaction",
                page: "page_path",
                hitCallback: "event_callback"
            };
            var gtagOptions = Object.entries(gaOptions).reduce(function(prev, _ref) {
                var _ref2 = $c8948021b554a410$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                if (mapFields[key]) prev[mapFields[key]] = value;
                else prev[key] = value;
                return prev;
            }, {});
            return gtagOptions;
        });
        $c8948021b554a410$var$_defineProperty(this, "initialize", function(GA_MEASUREMENT_ID) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            if (!GA_MEASUREMENT_ID) throw new Error("Require GA_MEASUREMENT_ID");
            var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [
                {
                    trackingId: GA_MEASUREMENT_ID
                }
            ] : GA_MEASUREMENT_ID;
            _this._currentMeasurementId = initConfigs[0].trackingId;
            var gaOptions = options.gaOptions, gtagOptions = options.gtagOptions, nonce = options.nonce, _options$testMode = options.testMode, testMode = _options$testMode === void 0 ? false : _options$testMode, gtagUrl = options.gtagUrl;
            _this._testMode = testMode;
            if (!testMode) _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
            if (!_this.isInitialized) {
                _this._gtag("js", new Date());
                initConfigs.forEach(function(config) {
                    var mergedGtagOptions = $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, _this._toGtagOptions($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
                    if (Object.keys(mergedGtagOptions).length) _this._gtag("config", config.trackingId, mergedGtagOptions);
                    else _this._gtag("config", config.trackingId);
                });
            }
            _this.isInitialized = true;
            if (!testMode) {
                var queues = $c8948021b554a410$var$_toConsumableArray(_this._queueGtag);
                _this._queueGtag = [];
                _this._isQueuing = false;
                while(queues.length){
                    var queue = queues.shift();
                    _this._gtag.apply(_this, $c8948021b554a410$var$_toConsumableArray(queue));
                    if (queue[0] === "get") _this._isQueuing = true;
                }
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "set", function(fieldsObject) {
            if (!fieldsObject) {
                console.warn("`fieldsObject` is required in .set()");
                return;
            }
            if ($c8948021b554a410$var$_typeof(fieldsObject) !== "object") {
                console.warn("Expected `fieldsObject` arg to be an Object");
                return;
            }
            if (Object.keys(fieldsObject).length === 0) console.warn("empty `fieldsObject` given to .set()");
            _this._gaCommand("set", fieldsObject);
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendEvent", function(eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
            _this._gtag("event", eventAction, $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            }, fieldsObject && {
                non_interaction: fieldsObject.nonInteraction
            }), _this._toGtagOptions(fieldsObject)));
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendEventParameters", function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            if (typeof args[0] === "string") _this._gaCommandSendEvent.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$ = args[0], eventCategory = _args$.eventCategory, eventAction = _args$.eventAction, eventLabel = _args$.eventLabel, eventValue = _args$.eventValue, hitType = _args$.hitType, rest = $c8948021b554a410$var$_objectWithoutProperties(_args$, $c8948021b554a410$var$_excluded);
                _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendTiming", function(timingCategory, timingVar, timingValue, timingLabel) {
            _this._gtag("event", "timing_complete", {
                name: timingVar,
                value: timingValue,
                event_category: timingCategory,
                event_label: timingLabel
            });
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendPageview", function(page, fieldsObject) {
            if (fieldsObject && Object.keys(fieldsObject).length) {
                var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject), title = _this$_toGtagOptions.title, location = _this$_toGtagOptions.location, rest = $c8948021b554a410$var$_objectWithoutProperties(_this$_toGtagOptions, $c8948021b554a410$var$_excluded2);
                _this._gtag("event", "page_view", $c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread($c8948021b554a410$var$_objectSpread({}, page && {
                    page_path: page
                }), title && {
                    page_title: title
                }), location && {
                    page_location: location
                }), rest));
            } else if (page) _this._gtag("event", "page_view", {
                page_path: page
            });
            else _this._gtag("event", "page_view");
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSendPageviewParameters", function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            if (typeof args[0] === "string") _this._gaCommandSendPageview.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
            else {
                var _args$2 = args[0], page = _args$2.page, hitType = _args$2.hitType, rest = $c8948021b554a410$var$_objectWithoutProperties(_args$2, $c8948021b554a410$var$_excluded3);
                _this._gaCommandSendPageview(page, rest);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSend", function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
            switch(hitType){
                case "event":
                    _this._gaCommandSendEventParameters.apply(_this, args);
                    break;
                case "pageview":
                    _this._gaCommandSendPageviewParameters.apply(_this, args);
                    break;
                case "timing":
                    _this._gaCommandSendTiming.apply(_this, $c8948021b554a410$var$_toConsumableArray(args.slice(1)));
                    break;
                case "screenview":
                case "transaction":
                case "item":
                case "social":
                case "exception":
                    console.warn("Unsupported send command: ".concat(hitType));
                    break;
                default:
                    console.warn("Send command doesn't exist: ".concat(hitType));
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommandSet", function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            if (typeof args[0] === "string") args[0] = $c8948021b554a410$var$_defineProperty({}, args[0], args[1]);
            _this._gtag("set", _this._toGtagOptions(args[0]));
        });
        $c8948021b554a410$var$_defineProperty(this, "_gaCommand", function(command) {
            for(var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++)args[_key6 - 1] = arguments[_key6];
            switch(command){
                case "send":
                    _this._gaCommandSend.apply(_this, args);
                    break;
                case "set":
                    _this._gaCommandSet.apply(_this, args);
                    break;
                default:
                    console.warn("Command doesn't exist: ".concat(command));
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "ga", function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            if (typeof args[0] === "string") _this._gaCommand.apply(_this, args);
            else {
                var readyCallback = args[0];
                _this._gtag("get", _this._currentMeasurementId, "client_id", function(clientId) {
                    _this._isQueuing = false;
                    var queues = _this._queueGtag;
                    readyCallback({
                        get: function get(property) {
                            return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
                        }
                    });
                    while(queues.length){
                        var queue = queues.shift();
                        _this._gtag.apply(_this, $c8948021b554a410$var$_toConsumableArray(queue));
                    }
                });
                _this._isQueuing = true;
            }
            return _this.ga;
        });
        $c8948021b554a410$var$_defineProperty(this, "event", function(optionsOrName, params) {
            if (typeof optionsOrName === "string") _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
            else {
                var action = optionsOrName.action, category = optionsOrName.category, label = optionsOrName.label, value = optionsOrName.value, nonInteraction = optionsOrName.nonInteraction, transport = optionsOrName.transport;
                if (!category || !action) {
                    console.warn("args.category AND args.action are required in event()");
                    return;
                }
                // Required Fields
                var fieldObject = {
                    hitType: "event",
                    eventCategory: (0, $c8948021b554a410$var$_format["default"])(category),
                    eventAction: (0, $c8948021b554a410$var$_format["default"])(action)
                };
                // Optional Fields
                if (label) fieldObject.eventLabel = (0, $c8948021b554a410$var$_format["default"])(label);
                if (typeof value !== "undefined") {
                    if (typeof value !== "number") console.warn("Expected `args.value` arg to be a Number.");
                    else fieldObject.eventValue = value;
                }
                if (typeof nonInteraction !== "undefined") {
                    if (typeof nonInteraction !== "boolean") console.warn("`args.nonInteraction` must be a boolean.");
                    else fieldObject.nonInteraction = nonInteraction;
                }
                if (typeof transport !== "undefined") {
                    if (typeof transport !== "string") console.warn("`args.transport` must be a string.");
                    else {
                        if ([
                            "beacon",
                            "xhr",
                            "image"
                        ].indexOf(transport) === -1) console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
                        fieldObject.transport = transport;
                    }
                }
                _this._gaCommand("send", fieldObject);
            }
        });
        $c8948021b554a410$var$_defineProperty(this, "send", function(fieldObject) {
            _this._gaCommand("send", fieldObject);
        });
        this.reset();
    }
    $c8948021b554a410$var$_createClass(GA4, [
        {
            key: "gtag",
            value: function gtag() {
                this._gtag.apply(this, arguments);
            }
        }
    ]);
    return GA4;
}();
module.exports.GA4 = $c8948021b554a410$var$GA4;
var $c8948021b554a410$var$_default = new $c8948021b554a410$var$GA4();
module.exports["default"] = $c8948021b554a410$var$_default;

});
parcelRegister("brtX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $85497333f8cbed81$var$gtag = function gtag() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (typeof window !== "undefined") {
        var _window;
        if (typeof window.gtag === "undefined") {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
        }
        (_window = window).gtag.apply(_window, args);
    }
};
var $85497333f8cbed81$var$_default = $85497333f8cbed81$var$gtag;
module.exports["default"] = $85497333f8cbed81$var$_default;

});

parcelRegister("k0qU7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e908ad5c0df5df0a$var$format;
var $e908ad5c0df5df0a$var$smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function $e908ad5c0df5df0a$var$toTitleCase(string) {
    return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
        if (index > 0 && index + match.length !== title.length && match.search($e908ad5c0df5df0a$var$smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) return match.toLowerCase();
        if (match.substr(1).search(/[A-Z]|\../) > -1) return match;
        return match.charAt(0).toUpperCase() + match.substr(1);
    });
}
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function $e908ad5c0df5df0a$var$mightBeEmail(s) {
    // There's no point trying to validate rfc822 fully, just look for ...@...
    return typeof s === "string" && s.indexOf("@") !== -1;
}
var $e908ad5c0df5df0a$var$redacted = "REDACTED (Potential Email Address)";
function $e908ad5c0df5df0a$var$redactEmail(string) {
    if ($e908ad5c0df5df0a$var$mightBeEmail(string)) {
        console.warn("This arg looks like an email address, redacting.");
        return $e908ad5c0df5df0a$var$redacted;
    }
    return string;
}
function $e908ad5c0df5df0a$var$format() {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _str = s || "";
    if (titleCase) _str = $e908ad5c0df5df0a$var$toTitleCase(s);
    if (redactingEmail) _str = $e908ad5c0df5df0a$var$redactEmail(_str);
    return _str;
}

});


parcelRegister("8zRdb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kIqKa").then(()=>parcelRequire("hqpyP"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("8m5tQ", function(module, exports) {
/*
Language: 1C:Enterprise
Author: Stanislav Belov <stbelov@gmail.com>
Description: built-in language 1C:Enterprise (v7, v8)
Category: enterprise
*/ function $6154a112137c8d52$var$_1c(hljs) {
    // общий паттерн для определения идентификаторов
    var UNDERSCORE_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]+";
    // v7 уникальные ключевые слова, отсутствующие в v8 ==> keyword
    var v7_keywords = "\u0434\u0430\u043B\u0435\u0435 ";
    // v8 ключевые слова ==> keyword
    var v8_keywords = "\u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u0432\u044B\u0437\u0432\u0430\u0442\u044C\u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0434\u043B\u044F \u0435\u0441\u043B\u0438 \u0438 \u0438\u0437 \u0438\u043B\u0438 \u0438\u043D\u0430\u0447\u0435 \u0438\u043D\u0430\u0447\u0435\u0435\u0441\u043B\u0438 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043F\u044B\u0442\u043A\u0438 \u043A\u043E\u043D\u0435\u0446\u0446\u0438\u043A\u043B\u0430 \u043D\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u0435\u0440\u0435\u043C \u043F\u043E \u043F\u043E\u043A\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u043F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0442\u043E\u0433\u0434\u0430 \u0446\u0438\u043A\u043B \u044D\u043A\u0441\u043F\u043E\u0440\u0442 ";
    // keyword : ключевые слова
    var KEYWORD = v7_keywords + v8_keywords;
    // v7 уникальные директивы, отсутствующие в v8 ==> meta-keyword
    var v7_meta_keywords = "\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0438\u0437\u0444\u0430\u0439\u043B\u0430 ";
    // v8 ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях ==> meta-keyword
    var v8_meta_keywords = "\u0432\u0435\u0431\u043A\u043B\u0438\u0435\u043D\u0442 \u0432\u043C\u0435\u0441\u0442\u043E \u0432\u043D\u0435\u0448\u043D\u0435\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442 \u043A\u043E\u043D\u0435\u0446\u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043B\u0438\u0435\u043D\u0442 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0432\u0435\u0440 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u0441\u043B\u0435 \u0441\u0435\u0440\u0432\u0435\u0440 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0431\u044B\u0447\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043D\u043A\u0438\u0439\u043A\u043B\u0438\u0435\u043D\u0442 ";
    // meta-keyword : ключевые слова в инструкциях препроцессора, директивах компиляции, аннотациях
    var METAKEYWORD = v7_meta_keywords + v8_meta_keywords;
    // v7 системные константы ==> built_in
    var v7_system_constants = "\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u043E\u043A \u0441\u0438\u043C\u0432\u043E\u043B\u0442\u0430\u0431\u0443\u043B\u044F\u0446\u0438\u0438 ";
    // v7 уникальные методы глобального контекста, отсутствующие в v8 ==> built_in
    var v7_global_context_methods = "ansitooem oemtoansi \u0432\u0432\u0435\u0441\u0442\u0438\u0432\u0438\u0434\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0438\u043E\u0434 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0434\u0430\u0442\u0430\u0433\u043E\u0434 \u0434\u0430\u0442\u0430\u043C\u0435\u0441\u044F\u0446 \u0434\u0430\u0442\u0430\u0447\u0438\u0441\u043B\u043E \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0438\u0431 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u0434\u0441\u0438\u043C\u0432 \u043A\u043E\u043D\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043A\u043E\u043D\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u043D\u0435\u0434\u0435\u043B\u0438 \u043B\u043E\u0433 \u043B\u043E\u043310 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043D\u0430\u0431\u043E\u0440\u0430\u043F\u0440\u0430\u0432 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0432\u0438\u0434 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0441\u0447\u0435\u0442 \u043D\u0430\u0439\u0442\u0438\u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043D\u0430\u0447\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u0433\u043E\u0434\u0430 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u043D\u0435\u0434\u0435\u043B\u0438\u0433\u043E\u0434\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u044F\u0437\u044B\u043A \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043E\u043A\u043D\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0441\u0442\u0440 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u0442\u0443\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0430 \u043F\u0440\u0435\u0444\u0438\u043A\u0441\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u043F\u0438\u0441\u044C \u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u043C \u0440\u0430\u0437\u043E\u0431\u0440\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043F\u043E \u0441\u0438\u043C\u0432 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0441\u0442\u0440\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u0447\u0435\u0442\u043F\u043E\u043A\u043E\u0434\u0443 \u0442\u0435\u043A\u0443\u0449\u0435\u0435\u0432\u0440\u0435\u043C\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0442\u0440 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043D\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043F\u043E \u0444\u0438\u043A\u0441\u0448\u0430\u0431\u043B\u043E\u043D \u0448\u0430\u0431\u043B\u043E\u043D ";
    // v8 методы глобального контекста ==> built_in
    var v8_global_context_methods = "acos asin atan base64\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 base64\u0441\u0442\u0440\u043E\u043A\u0430 cos exp log log10 pow sin sqrt tan xml\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 xml\u0441\u0442\u0440\u043E\u043A\u0430 xml\u0442\u0438\u043F xml\u0442\u0438\u043F\u0437\u043D\u0447 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435\u043E\u043A\u043D\u043E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u043B\u0435\u0432\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u0434\u0430\u0442\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u0441\u0442\u0440\u043E\u043A\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0447\u0438\u0441\u043B\u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u0447\u0442\u0435\u043D\u0438\u044Fxml \u0432\u043E\u043F\u0440\u043E\u0441 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0433 \u0432\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u043F\u0440\u0430\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u0433\u043E\u0434 \u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B\u0432\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u0442\u0430 \u0434\u0435\u043D\u044C \u0434\u0435\u043D\u044C\u0433\u043E\u0434\u0430 \u0434\u0435\u043D\u044C\u043D\u0435\u0434\u0435\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C\u043C\u0435\u0441\u044F\u0446 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0437\u0430\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cjson \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cxml \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u0437\u0430\u043F\u0438\u0441\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0432\u043E\u0439\u0441\u0442\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0437\u0430\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0444\u0430\u0439\u043B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u0438\u0437xml\u0442\u0438\u043F\u0430 \u0438\u043C\u043F\u043E\u0440\u0442\u043C\u043E\u0434\u0435\u043B\u0438xdto \u0438\u043C\u044F\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430 \u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0438\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043A\u043E\u0434\u0441\u0438\u043C\u0432\u043E\u043B\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043A\u043E\u043D\u0435\u0446\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u0434\u043D\u044F \u043A\u043E\u043D\u0435\u0446\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0438\u043D\u0443\u0442\u044B \u043A\u043E\u043D\u0435\u0446\u043D\u0435\u0434\u0435\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u0447\u0430\u0441\u0430 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0444\u0430\u0439\u043B \u043A\u0440\u0430\u0442\u043A\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043B\u0435\u0432 \u043C\u0430\u043A\u0441 \u043C\u0435\u0441\u0442\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u043C\u0435\u0441\u044F\u0446 \u043C\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430 \u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043D\u0430\u0439\u0442\u0438 \u043D\u0430\u0439\u0442\u0438\u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u043D\u0430\u0439\u0442\u0438\u043E\u043A\u043D\u043E\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435\u043D\u0430\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u0441\u0441\u044B\u043B\u043A\u0430\u043C \u043D\u0430\u0439\u0442\u0438\u0444\u0430\u0439\u043B\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u0434\u043D\u044F \u043D\u0430\u0447\u0430\u043B\u043E\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0447\u0430\u0441\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0443\u0441\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0438\u0441\u043A\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0435\u0434\u0435\u043B\u044F\u0433\u043E\u0434\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043D\u043E\u043C\u0435\u0440\u0441\u0435\u0430\u043D\u0441\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u043E\u043C\u0435\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u0440\u0435\u0433 \u043D\u0441\u0442\u0440 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044E\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u0435\u0440\u044B\u0432\u0430\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043E\u043A\u0440 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C\u043E\u0431\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0438\u043D\u0434\u0435\u043A\u0441\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0435\u0440\u0435\u0439\u0442\u0438\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0434\u0430\u0442\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0441\u0442\u0440\u043E\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0447\u0438\u0441\u043B\u0430 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u043E\u043F\u0440\u043E\u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043D\u0430\u043A\u0430\u0440\u0442\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Ccom\u043E\u0431\u044A\u0435\u043A\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Cxml\u0442\u0438\u043F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0430\u0434\u0440\u0435\u0441\u043F\u043E\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043A\u043E\u0434\u044B\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0447\u0430\u0441\u043E\u0432\u044B\u0435\u043F\u043E\u044F\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u044D\u043A\u0440\u0430\u043D\u043E\u0432\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0430\u0434\u0440\u0435\u0441\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0438\u0439\u043C\u0430\u043A\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0443\u044E\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043A\u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0443\u044E\u043E\u0442\u043C\u0435\u0442\u043A\u0443\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445\u0441\u0441\u044B\u043B\u043E\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0435\u0430\u043D\u0441\u044B\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0441\u0435\u0430\u043D\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u043E\u0441 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0432\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u0440\u0430\u0432 \u043F\u0440\u0430\u0432\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u0434\u0430\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0430\u0432\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0447\u0430\u0441\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u044F\u0441\u0430 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C\u0432\u044B\u0437\u043E\u0432 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cjson \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cxml \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u043F\u0443\u0441\u0442\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0440\u0430\u0431\u043E\u0447\u0438\u0439\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u0440\u0430\u0437\u043E\u0440\u0432\u0430\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0440\u043E\u043B\u044C\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0430 \u0441\u0438\u0433\u043D\u0430\u043B \u0441\u0438\u043C\u0432\u043E\u043B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u043B\u0435\u0442\u043D\u0435\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0431\u0443\u0444\u0435\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u0444\u0430\u0431\u0440\u0438\u043A\u0443xdto \u0441\u043E\u043A\u0440\u043B \u0441\u043E\u043A\u0440\u043B\u043F \u0441\u043E\u043A\u0440\u043F \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434 \u0441\u0442\u0440\u0434\u043B\u0438\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u043D\u0430\u0439\u0442\u0438 \u0441\u0442\u0440\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F\u0441 \u0441\u0442\u0440\u043E\u043A\u0430 \u0441\u0442\u0440\u043E\u043A\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0441\u0442\u0440\u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0441\u0442\u0440\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0432\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0442\u0440\u0448\u0430\u0431\u043B\u043E\u043D \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430\u0441\u0435\u0430\u043D\u0441\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u0432\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0445 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0442\u0438\u043F \u0442\u0438\u043F\u0437\u043D\u0447 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F\u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u0442\u0440\u0435\u0433 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0444\u043E\u0440\u043C\u0430\u0442 \u0446\u0435\u043B \u0447\u0430\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0447\u0438\u0441\u043B\u043E \u0447\u0438\u0441\u043B\u043E\u043F\u0440\u043E\u043F\u0438\u0441\u044C\u044E \u044D\u0442\u043E\u0430\u0434\u0440\u0435\u0441\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 ";
    // v8 свойства глобального контекста ==> built_in
    var v8_global_context_property = "ws\u0441\u0441\u044B\u043B\u043A\u0438 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043C\u0430\u043A\u0435\u0442\u043E\u0432\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u0441\u0442\u0438\u043B\u0435\u0439 \u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0442\u0447\u0435\u0442\u044B \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0441\u0442\u0438\u043B\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0436\u0443\u0440\u043D\u0430\u043B\u044B\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0437\u0430\u0434\u0430\u0447\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0439\u0434\u0430\u0442\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u044B \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0438\u043E\u0442\u0431\u043E\u0440\u0430 \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E\u0442\u0447\u0435\u0442\u044B \u043F\u0430\u043D\u0435\u043B\u044C\u0437\u0430\u0434\u0430\u0447\u043E\u0441 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u043F\u043B\u0430\u043D\u044B\u043E\u0431\u043C\u0435\u043D\u0430 \u043F\u043B\u0430\u043D\u044B\u0441\u0447\u0435\u0442\u043E\u0432 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0440\u0430\u0431\u043E\u0447\u0430\u044F\u0434\u0430\u0442\u0430 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0433\u0435\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C\u0443\u043B\u044C\u0442\u0438\u043C\u0435\u0434\u0438\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043F\u043E\u0447\u0442\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0435\u043F\u043E\u0442\u043E\u043A\u0438 \u0444\u043E\u043D\u043E\u0432\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043E\u0431\u0449\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0445\u0441\u043F\u0438\u0441\u043A\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A ";
    // built_in : встроенные или библиотечные объекты (константы, классы, функции)
    var BUILTIN = v7_system_constants + v7_global_context_methods + v8_global_context_methods + v8_global_context_property;
    // v8 системные наборы значений ==> class
    var v8_system_sets_of_values = "web\u0446\u0432\u0435\u0442\u0430 windows\u0446\u0432\u0435\u0442\u0430 windows\u0448\u0440\u0438\u0444\u0442\u044B \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0440\u0430\u043C\u043A\u0438\u0441\u0442\u0438\u043B\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u044B \u0446\u0432\u0435\u0442\u0430\u0441\u0442\u0438\u043B\u044F \u0448\u0440\u0438\u0444\u0442\u044B\u0441\u0442\u0438\u043B\u044F ";
    // v8 системные перечисления - интерфейсные ==> class
    var v8_system_enums_interface = "\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044F\u0432\u0444\u043E\u0440\u043C\u0435 \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0438\u0439 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0438\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u043E\u0432 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0432\u044B\u0441\u043E\u0442\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u0435\u043A\u043E\u0440\u0430\u0446\u0438\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0438\u0434\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044F \u0432\u0438\u0434\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u0432\u0438\u0434\u043F\u043E\u043B\u044F\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0444\u043B\u0430\u0436\u043A\u0430 \u0432\u043B\u0438\u044F\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043D\u0430\u043F\u0443\u0437\u044B\u0440\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043A\u043E\u043B\u043E\u043D\u043E\u043A \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B \u0433\u0440\u0443\u043F\u043F\u044B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043C\u0435\u0436\u0434\u0443\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043C\u0438\u0444\u043E\u0440\u043C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043E\u0441\u044B\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E\u0447\u043A\u0438\u0431\u0438\u0440\u0436\u0435\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043E\u0441\u0438\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043E\u043C\u0430\u043D\u0434 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C\u0441\u0435\u0440\u0438\u0439 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0434\u0435\u0440\u0435\u0432\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u043F\u0438\u0441\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043D\u043E\u043F\u043E\u043A \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438\u0432\u044B\u0431\u043E\u0440\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u0439\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u043E\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F\u043F\u0440\u0438\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0438\u043F\u043E\u043B\u043E\u0441\u044B\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0444\u0438\u0433\u0443\u0440\u044B\u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u043B\u0438\u0442\u0440\u0430\u0446\u0432\u0435\u0442\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0438\u0441\u043A\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043E\u043F\u043E\u0440\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u0448\u043A\u0430\u043B\u044B\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u043E\u0438\u0441\u043A\u043E\u043C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0439\u0433\u0438\u0441\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0441\u0435\u0440\u0438\u0439\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0437\u043C\u0435\u0440\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0441\u0442\u044F\u0433\u0438\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0432\u0432\u043E\u0434\u0430\u0441\u0442\u0440\u043E\u043A\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0431\u043E\u0440\u0430\u043D\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u0442\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u043F\u0435\u0447\u0430\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0440\u0435\u0436\u0438\u043C\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u043A\u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u043E\u043A\u043D\u0430\u0444\u043E\u0440\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0435\u0440\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438\u0441\u0435\u0442\u043A\u0438\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E\u0441\u0442\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0431\u0435\u043B\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0440\u0435\u0436\u0438\u043C\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0441\u043F\u0438\u0441\u043A\u0430\u0437\u0430\u0434\u0430\u0447 \u0441\u043A\u0432\u043E\u0437\u043D\u043E\u0435\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0433\u0440\u0443\u043F\u043F\u0430\u043A\u043E\u043C\u0430\u043D\u0434 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0442\u0438\u043B\u044C\u0441\u0442\u0440\u0435\u043B\u043A\u0438 \u0442\u0438\u043F\u0430\u043F\u043F\u0440\u043E\u043A\u0441\u0438\u043C\u0430\u0446\u0438\u0438\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0442\u0438\u043F\u0438\u043C\u043F\u043E\u0440\u0442\u0430\u0441\u0435\u0440\u0438\u0439\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0438\u0438\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u0447\u043D\u043E\u0433\u043E\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0448\u043A\u0430\u043B\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0438\u0441\u043A\u0430\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u0440\u043E\u0435\u043A\u0446\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u043C\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u043E\u0441\u0435\u0440\u0438\u044F\u043C\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u0442\u0438\u043F\u0441\u0442\u043E\u0440\u043E\u043D\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0448\u043A\u0430\u043B\u044B\u0440\u0430\u0434\u0430\u0440\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0430\u043A\u0442\u043E\u0440\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0438\u0433\u0443\u0440\u0430\u043A\u043D\u043E\u043F\u043A\u0438 \u0444\u0438\u0433\u0443\u0440\u044B\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u043D\u044F\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0448\u0438\u0440\u0438\u043D\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B ";
    // v8 системные перечисления - свойства прикладных объектов ==> class
    var v8_system_enums_objects_properties = "\u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0442\u043E\u0447\u043A\u0438\u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u0436\u0438\u043C\u0430\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0440\u0435\u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u0432\u0440\u0435\u043C\u044F \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 ";
    // v8 системные перечисления - планы обмена ==> class
    var v8_system_enums_exchange_plans = "\u0430\u0432\u0442\u043E\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u043D\u043E\u043C\u0435\u0440\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 системные перечисления - табличный документ ==> class
    var v8_system_enums_tabular_document = "\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043B\u043E\u043D\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u0441\u0442\u0440\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u0447\u0442\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0439\u043F\u0435\u0447\u0430\u0442\u0438 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043A\u0443\u0440\u0441\u043E\u0440\u043E\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u044F\u0447\u0435\u0439\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043B\u0438\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0443\u0437\u043E\u0440\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u044C\u043F\u0435\u0447\u0430\u0442\u0438 \u0447\u0435\u0440\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446 ";
    // v8 системные перечисления - планировщик ==> class
    var v8_system_enums_sheduler = "\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430 ";
    // v8 системные перечисления - форматированный документ ==> class
    var v8_system_enums_formatted_document = "\u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 ";
    // v8 системные перечисления - запрос ==> class
    var v8_system_enums_query = "\u043E\u0431\u0445\u043E\u0434\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0437\u0430\u043F\u0438\u0441\u0438\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - построитель отчета ==> class
    var v8_system_enums_report_builder = "\u0432\u0438\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0442\u043E\u0433\u043E\u0432 ";
    // v8 системные перечисления - работа с файлами ==> class
    var v8_system_enums_files = "\u0434\u043E\u0441\u0442\u0443\u043F\u043A\u0444\u0430\u0439\u043B\u0443 \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u0430\u0439\u043B\u0430 ";
    // v8 системные перечисления - построитель запроса ==> class
    var v8_system_enums_query_builder = "\u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - анализ данных ==> class
    var v8_system_enums_data_analysis = "\u0432\u0438\u0434\u0434\u0430\u043D\u043D\u044B\u0445\u0430\u043D\u0430\u043B\u0438\u0437\u0430 \u043C\u0435\u0442\u043E\u0434\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0447\u0438\u0441\u043B\u043E\u0432\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0434\u0435\u0440\u0435\u0432\u043E\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0430\u044F\u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u043C\u043E\u0434\u0435\u043B\u0438\u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430 \u0442\u0438\u043F\u043C\u0435\u0440\u044B\u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0442\u0441\u0435\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u043F\u043E\u043B\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u0440\u043E\u0449\u0435\u043D\u0438\u044F\u0434\u0435\u0440\u0435\u0432\u0430\u0440\u0435\u0448\u0435\u043D\u0438\u0439 ";
    // v8 системные перечисления - xml, json, xs, dom, xdto, web-сервисы ==> class
    var v8_system_enums_xml_json_xs_dom_xdto_ws = "ws\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442xpathxs \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u0430\u0442\u044Bjson \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u0432\u0438\u0434\u0444\u0430\u0441\u0435\u0442\u0430xdto \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Fdom \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u0445\u0435\u043C\u044Bxs \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Dxs \u043C\u0435\u0442\u043E\u0434\u043D\u0430\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044Fxs \u043C\u043E\u0434\u0435\u043B\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430xml \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u043E\u0442\u0431\u043E\u0440\u0430\u0443\u0437\u043B\u043E\u0432dom \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0441\u0442\u0440\u043E\u043Ajson \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435dom \u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u0442\u0438\u043F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xml \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fjson \u0442\u0438\u043F\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043Exml \u0442\u0438\u043F\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044Bxs \u0442\u0438\u043F\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438xml \u0442\u0438\u043F\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430domxpath \u0442\u0438\u043F\u0443\u0437\u043B\u0430dom \u0442\u0438\u043F\u0443\u0437\u043B\u0430xml \u0444\u043E\u0440\u043C\u0430xml \u0444\u043E\u0440\u043C\u0430\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044Fxs \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u0430\u0442\u044Bjson \u044D\u043A\u0440\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432json ";
    // v8 системные перечисления - система компоновки данных ==> class
    var v8_system_enums_data_composition_system = "\u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u0435\u0439\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u043E\u0433\u043E\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0432\u044B\u0432\u043E\u0434\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u043F\u043E\u043B\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u043D\u0430\u0431\u043E\u0440\u043E\u0432\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u0432\u0442\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0443\u0441\u043B\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 системные перечисления - почта ==> class
    var v8_system_enums_email = "\u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0432\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043D\u0435ascii\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0442\u0435\u043A\u0441\u0442\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u044B \u0441\u0442\u0430\u0442\u0443\u0441\u0440\u0430\u0437\u0431\u043E\u0440\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F ";
    // v8 системные перечисления - журнал регистрации ==> class
    var v8_system_enums_logbook = "\u0440\u0435\u0436\u0438\u043C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 ";
    // v8 системные перечисления - криптография ==> class
    var v8_system_enums_cryptography = "\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0442\u0438\u043F\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 ";
    // v8 системные перечисления - ZIP ==> class
    var v8_system_enums_zip = "\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0438\u043C\u0435\u043D\u0444\u0430\u0439\u043B\u043E\u0432\u0432zip\u0444\u0430\u0439\u043B\u0435 \u043C\u0435\u0442\u043E\u0434\u0441\u0436\u0430\u0442\u0438\u044Fzip \u043C\u0435\u0442\u043E\u0434\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u044Fzip \u0440\u0435\u0436\u0438\u043C\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439\u0444\u0430\u0439\u043B\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u043F\u043E\u0434\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439zip \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0441\u0436\u0430\u0442\u0438\u044Fzip ";
    // v8 системные перечисления -
    // Блокировка данных, Фоновые задания, Автоматизированное тестирование,
    // Доставляемые уведомления, Встроенные покупки, Интернет, Работа с двоичными данными ==> class
    var v8_system_enums_other = "\u0437\u0432\u0443\u043A\u043E\u0432\u043E\u0435\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u043A\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u043F\u043E\u0442\u043E\u043A\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0431\u0430\u0439\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0432\u0438\u0441\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0444\u043E\u043D\u043E\u0432\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044Fftp ";
    // v8 системные перечисления - схема запроса ==> class
    var v8_system_enums_request_schema = "\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0440\u044F\u0434\u043A\u0430\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043C\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 ";
    // v8 системные перечисления - свойства объектов метаданных ==> class
    var v8_system_enums_properties_of_metadata_objects = "http\u043C\u0435\u0442\u043E\u0434 \u0430\u0432\u0442\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0430\u0432\u0442\u043E\u043F\u0440\u0435\u0444\u0438\u043A\u0441\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0433\u043E\u044F\u0437\u044B\u043A\u0430 \u0432\u0438\u0434\u0438\u0435\u0440\u0430\u0440\u0445\u0438\u0438 \u0432\u0438\u0434\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0438\u043D\u0434\u0435\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u0430\u0437\u044B\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E\u0432\u044B\u0431\u043E\u0440\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0437\u0434\u0435\u043B\u044F\u0435\u043C\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0437\u0430\u0434\u0430\u0447\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043B\u0430\u043D\u0430\u043E\u0431\u043C\u0435\u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0433\u0440\u0430\u043D\u0438\u0446\u044B\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043C\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u044B\u0445\u0432\u044B\u0437\u043E\u0432\u043E\u0432\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B\u0438\u0432\u043D\u0435\u0448\u043D\u0438\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0433\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439 ";
    // v8 системные перечисления - разные ==> class
    var v8_system_enums_differents = "\u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0444\u043E\u0440\u043C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439\u0434\u0430\u0442\u044B\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u0438\u0434\u0433\u0440\u0430\u043D\u0438\u0446\u044B \u0432\u0438\u0434\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0432\u0438\u0434\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0432\u0438\u0434\u0440\u0430\u043C\u043A\u0438 \u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0446\u0432\u0435\u0442\u0430 \u0432\u0438\u0434\u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0430\u044F\u0434\u043B\u0438\u043D\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u0437\u043D\u0430\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435byteordermark \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u0430 \u043A\u043E\u0434\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430\u0434\u0438\u0430\u043B\u043E\u0433\u0430 \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430xbase \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0438\u0441\u043A\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u043E\u043F\u0440\u043E\u0441 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u043E\u0440\u043C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430windows \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u0442\u0438\u043F\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u043A\u043B\u0430\u0432\u0438\u0448\u0438enter \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438\u043E\u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0445\u0435\u0448\u0444\u0443\u043D\u043A\u0446\u0438\u044F \u0447\u0430\u0441\u0442\u0438\u0434\u0430\u0442\u044B";
    // class: встроенные наборы значений, системные перечисления (содержат дочерние значения, обращения к которым через разыменование)
    var CLASS = v8_system_sets_of_values + v8_system_enums_interface + v8_system_enums_objects_properties + v8_system_enums_exchange_plans + v8_system_enums_tabular_document + v8_system_enums_sheduler + v8_system_enums_formatted_document + v8_system_enums_query + v8_system_enums_report_builder + v8_system_enums_files + v8_system_enums_query_builder + v8_system_enums_data_analysis + v8_system_enums_xml_json_xs_dom_xdto_ws + v8_system_enums_data_composition_system + v8_system_enums_email + v8_system_enums_logbook + v8_system_enums_cryptography + v8_system_enums_zip + v8_system_enums_other + v8_system_enums_request_schema + v8_system_enums_properties_of_metadata_objects + v8_system_enums_differents;
    // v8 общие объекты (у объектов есть конструктор, экземпляры создаются методом НОВЫЙ) ==> type
    var v8_shared_object = "com\u043E\u0431\u044A\u0435\u043A\u0442 ftp\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 http\u0437\u0430\u043F\u0440\u043E\u0441 http\u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0442\u0432\u0435\u0442 http\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 ws\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F ws\u043F\u0440\u043E\u043A\u0441\u0438 xbase \u0430\u043D\u0430\u043B\u0438\u0437\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u043D\u043D\u043E\u0442\u0430\u0446\u0438\u044Fxs \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u0444\u0435\u0440\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435xs \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u0441\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445\u0447\u0438\u0441\u0435\u043B \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0435\u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0440\u0443\u043F\u043F\u0430\u043C\u043E\u0434\u0435\u043B\u0438xs \u0434\u0430\u043D\u043D\u044B\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430\u0433\u0430\u043D\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0446\u0432\u0435\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442dom \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442html \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044Fxs \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u044Cdom \u0437\u0430\u043F\u0438\u0441\u044Cfastinfoset \u0437\u0430\u043F\u0438\u0441\u044Chtml \u0437\u0430\u043F\u0438\u0441\u044Cjson \u0437\u0430\u043F\u0438\u0441\u044Cxml \u0437\u0430\u043F\u0438\u0441\u044Czip\u0444\u0430\u0439\u043B\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0442\u0435\u043A\u0441\u0442\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0443\u0437\u043B\u043E\u0432dom \u0437\u0430\u043F\u0440\u043E\u0441 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435openssl \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u0435\u0439\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u043C\u043F\u043E\u0440\u0442xs \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439\u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u0440\u043E\u043A\u0441\u0438 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0434\u043B\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044Fxs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0442\u0435\u0440\u0430\u0442\u043E\u0440\u0443\u0437\u043B\u043E\u0432dom \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0430\u0442\u044B \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0447\u0438\u0441\u043B\u0430 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043C\u0430\u043A\u0435\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0444\u043E\u0440\u043C\u0430\u0442\u043D\u043E\u0439\u0441\u0442\u0440\u043E\u043A\u0438 \u043B\u0438\u043D\u0438\u044F \u043C\u0430\u043A\u0435\u0442\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u0441\u043A\u0430xs \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043D\u0430\u0431\u043E\u0440\u0441\u0445\u0435\u043Cxml \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438json \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u0445\u043E\u0434\u0434\u0435\u0440\u0435\u0432\u0430dom \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u043D\u043E\u0442\u0430\u0446\u0438\u0438xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430xs \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0434\u043E\u0441\u0442\u0443\u043F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043E\u0442\u043A\u0430\u0437\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0442\u0438\u043F\u043E\u0432 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u043E\u0432xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430dom \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044Fxpathxs \u043E\u0442\u0431\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u044B\u0445\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438json \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438xml \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0447\u0442\u0435\u043D\u0438\u044Fxml \u043F\u0435\u0440\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435xs \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043F\u043E\u043B\u0435\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Cdom \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0445\u0435\u043Cxml \u043F\u043E\u0442\u043E\u043A \u043F\u043E\u0442\u043E\u043A\u0432\u043F\u0430\u043C\u044F\u0442\u0438 \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435xsl \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043A\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443xml \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0437\u044B\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Ddom \u0440\u0430\u043C\u043A\u0430 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u043E\u0435\u0438\u043C\u044Fxml \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0447\u0442\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0432\u043E\u0434\u043D\u0430\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u0444\u0430\u0439\u043B \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432\u0444\u0430\u0439\u043B \u0441\u0436\u0430\u0442\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0441\u043E\u0447\u0435\u0442\u0430\u043D\u0438\u0435\u043A\u043B\u0430\u0432\u0438\u0448 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439\u043F\u0435\u0440\u0438\u043E\u0434 \u0441\u0445\u0435\u043C\u0430xml \u0441\u0445\u0435\u043C\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u0441\u0442\u0438\u0440\u0443\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445xml \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0439\u043F\u043E\u0442\u043E\u043A \u0444\u0430\u0441\u0435\u0442\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432\u0434\u0440\u043E\u0431\u043D\u043E\u0439\u0447\u0430\u0441\u0442\u0438xs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0440\u0430\u0437\u0446\u0430xs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0449\u0435\u0433\u043E\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432xs \u0444\u0430\u0441\u0435\u0442\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u0444\u0438\u043B\u044C\u0442\u0440\u0443\u0437\u043B\u043E\u0432dom \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442xs \u0445\u0435\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0446\u0432\u0435\u0442 \u0447\u0442\u0435\u043D\u0438\u0435fastinfoset \u0447\u0442\u0435\u043D\u0438\u0435html \u0447\u0442\u0435\u043D\u0438\u0435json \u0447\u0442\u0435\u043D\u0438\u0435xml \u0447\u0442\u0435\u043D\u0438\u0435zip\u0444\u0430\u0439\u043B\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0447\u0442\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0443\u0437\u043B\u043E\u0432dom \u0448\u0440\u0438\u0444\u0442 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 ";
    // v8 универсальные коллекции значений ==> type
    var v8_universal_collection = "comsafearray \u0434\u0435\u0440\u0435\u0432\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0441\u043F\u0438\u0441\u043E\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0442\u0430\u0431\u043B\u0438\u0446\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u043C\u0430\u0441\u0441\u0438\u0432 ";
    // type : встроенные типы
    var TYPE = v8_shared_object + v8_universal_collection;
    // literal : примитивные типы
    var LITERAL = "null \u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u043E\u0436\u044C \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E";
    // number : числа
    var NUMBERS = hljs.inherit(hljs.NUMBER_MODE);
    // string : строки
    var STRINGS = {
        className: "string",
        begin: '"|\\|',
        end: '"|$',
        contains: [
            {
                begin: '""'
            }
        ]
    };
    // number : даты
    var DATE = {
        begin: "'",
        end: "'",
        excludeBegin: true,
        excludeEnd: true,
        contains: [
            {
                className: "number",
                begin: "\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}"
            }
        ]
    };
    // comment : комментарии
    var COMMENTS = hljs.inherit(hljs.C_LINE_COMMENT_MODE);
    // meta : инструкции препроцессора, директивы компиляции
    var META = {
        className: "meta",
        begin: "#|&",
        end: "$",
        keywords: {
            $pattern: UNDERSCORE_IDENT_RE,
            "meta-keyword": KEYWORD + METAKEYWORD
        },
        contains: [
            COMMENTS
        ]
    };
    // symbol : метка goto
    var SYMBOL = {
        className: "symbol",
        begin: "~",
        end: ";|:",
        excludeEnd: true
    };
    // function : объявление процедур и функций
    var FUNCTION = {
        className: "function",
        variants: [
            {
                begin: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430|\u0444\u0443\u043D\u043A\u0446\u0438\u044F",
                end: "\\)",
                keywords: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u044F"
            },
            {
                begin: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B|\u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438",
                keywords: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438"
            }
        ],
        contains: [
            {
                begin: "\\(",
                end: "\\)",
                endsParent: true,
                contains: [
                    {
                        className: "params",
                        begin: UNDERSCORE_IDENT_RE,
                        end: ",",
                        excludeEnd: true,
                        endsWithParent: true,
                        keywords: {
                            $pattern: UNDERSCORE_IDENT_RE,
                            keyword: "\u0437\u043D\u0430\u0447",
                            literal: LITERAL
                        },
                        contains: [
                            NUMBERS,
                            STRINGS,
                            DATE
                        ]
                    },
                    COMMENTS
                ]
            },
            hljs.inherit(hljs.TITLE_MODE, {
                begin: UNDERSCORE_IDENT_RE
            })
        ]
    };
    return {
        name: "1C:Enterprise",
        case_insensitive: true,
        keywords: {
            $pattern: UNDERSCORE_IDENT_RE,
            keyword: KEYWORD,
            built_in: BUILTIN,
            class: CLASS,
            type: TYPE,
            literal: LITERAL
        },
        contains: [
            META,
            FUNCTION,
            COMMENTS,
            SYMBOL,
            NUMBERS,
            STRINGS,
            DATE
        ]
    };
}
module.exports = $6154a112137c8d52$var$_1c;

});

parcelRegister("jzZa4", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e410ba98feaba270$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $e410ba98feaba270$var$concat(...args) {
    const joined = args.map((x)=>$e410ba98feaba270$var$source(x)).join("");
    return joined;
}
/*
Language: Augmented Backus-Naur Form
Author: Alex McKibben <alex@nullscope.net>
Website: https://tools.ietf.org/html/rfc5234
Audit: 2020
*/ /** @type LanguageFn */ function $e410ba98feaba270$var$abnf(hljs) {
    const regexes = {
        ruleDeclaration: /^[a-zA-Z][a-zA-Z0-9-]*/,
        unexpectedChars: /[!@#$^&',?+~`|:]/
    };
    const keywords = [
        "ALPHA",
        "BIT",
        "CHAR",
        "CR",
        "CRLF",
        "CTL",
        "DIGIT",
        "DQUOTE",
        "HEXDIG",
        "HTAB",
        "LF",
        "LWSP",
        "OCTET",
        "SP",
        "VCHAR",
        "WSP"
    ];
    const commentMode = hljs.COMMENT(/;/, /$/);
    const terminalBinaryMode = {
        className: "symbol",
        begin: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+){0,1}/
    };
    const terminalDecimalMode = {
        className: "symbol",
        begin: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+){0,1}/
    };
    const terminalHexadecimalMode = {
        className: "symbol",
        begin: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+){0,1}/
    };
    const caseSensitivityIndicatorMode = {
        className: "symbol",
        begin: /%[si]/
    };
    const ruleDeclarationMode = {
        className: "attribute",
        begin: $e410ba98feaba270$var$concat(regexes.ruleDeclaration, /(?=\s*=)/)
    };
    return {
        name: "Augmented Backus-Naur Form",
        illegal: regexes.unexpectedChars,
        keywords: keywords,
        contains: [
            ruleDeclarationMode,
            commentMode,
            terminalBinaryMode,
            terminalDecimalMode,
            terminalHexadecimalMode,
            caseSensitivityIndicatorMode,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE
        ]
    };
}
module.exports = $e410ba98feaba270$var$abnf;

});

parcelRegister("ePTdO", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $acd0aa06596f430f$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $acd0aa06596f430f$var$concat(...args) {
    const joined = args.map((x)=>$acd0aa06596f430f$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $acd0aa06596f430f$var$either(...args) {
    const joined = "(" + args.map((x)=>$acd0aa06596f430f$var$source(x)).join("|") + ")";
    return joined;
}
/*
 Language: Apache Access Log
 Author: Oleg Efimov <efimovov@gmail.com>
 Description: Apache/Nginx Access Logs
 Website: https://httpd.apache.org/docs/2.4/logs.html#accesslog
 Audit: 2020
 */ /** @type LanguageFn */ function $acd0aa06596f430f$var$accesslog(_hljs) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
    const HTTP_VERBS = [
        "GET",
        "POST",
        "HEAD",
        "PUT",
        "DELETE",
        "CONNECT",
        "OPTIONS",
        "PATCH",
        "TRACE"
    ];
    return {
        name: "Apache Access Log",
        contains: [
            // IP
            {
                className: "number",
                begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
                relevance: 5
            },
            // Other numbers
            {
                className: "number",
                begin: /\b\d+\b/,
                relevance: 0
            },
            // Requests
            {
                className: "string",
                begin: $acd0aa06596f430f$var$concat(/"/, $acd0aa06596f430f$var$either(...HTTP_VERBS)),
                end: /"/,
                keywords: HTTP_VERBS,
                illegal: /\n/,
                relevance: 5,
                contains: [
                    {
                        begin: /HTTP\/[12]\.\d'/,
                        relevance: 5
                    }
                ]
            },
            // Dates
            {
                className: "string",
                // dates must have a certain length, this prevents matching
                // simple array accesses a[123] and [] and other common patterns
                // found in other languages
                begin: /\[\d[^\]\n]{8,}\]/,
                illegal: /\n/,
                relevance: 1
            },
            {
                className: "string",
                begin: /\[/,
                end: /\]/,
                illegal: /\n/,
                relevance: 0
            },
            // User agent / relevance boost
            {
                className: "string",
                begin: /"Mozilla\/\d\.\d \(/,
                end: /"/,
                illegal: /\n/,
                relevance: 3
            },
            // Strings
            {
                className: "string",
                begin: /"/,
                end: /"/,
                illegal: /\n/,
                relevance: 0
            }
        ]
    };
}
module.exports = $acd0aa06596f430f$var$accesslog;

});

parcelRegister("jYOgV", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e8ba9de1f5c74544$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $e8ba9de1f5c74544$var$concat(...args) {
    const joined = args.map((x)=>$e8ba9de1f5c74544$var$source(x)).join("");
    return joined;
}
/*
Language: ActionScript
Author: Alexander Myadzel <myadzel@gmail.com>
Category: scripting
Audit: 2020
*/ /** @type LanguageFn */ function $e8ba9de1f5c74544$var$actionscript(hljs) {
    const IDENT_RE = /[a-zA-Z_$][a-zA-Z0-9_$]*/;
    const IDENT_FUNC_RETURN_TYPE_RE = /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/;
    const AS3_REST_ARG_MODE = {
        className: "rest_arg",
        begin: /[.]{3}/,
        end: IDENT_RE,
        relevance: 10
    };
    return {
        name: "ActionScript",
        aliases: [
            "as"
        ],
        keywords: {
            keyword: "as break case catch class const continue default delete do dynamic each else extends final finally for function get if implements import in include instanceof interface internal is namespace native new override package private protected public return set static super switch this throw try typeof use var void while with",
            literal: "true false null undefined"
        },
        contains: [
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "class",
                beginKeywords: "package",
                end: /\{/,
                contains: [
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "meta",
                beginKeywords: "import include",
                end: /;/,
                keywords: {
                    "meta-keyword": "import include"
                }
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[{;]/,
                excludeEnd: true,
                illegal: /\S/,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            AS3_REST_ARG_MODE
                        ]
                    },
                    {
                        begin: $e8ba9de1f5c74544$var$concat(/:\s*/, IDENT_FUNC_RETURN_TYPE_RE)
                    }
                ]
            },
            hljs.METHOD_GUARD
        ],
        illegal: /#/
    };
}
module.exports = $e8ba9de1f5c74544$var$actionscript;

});

parcelRegister("7wzO7", function(module, exports) {
/*
Language: Ada
Author: Lars Schulna <kartoffelbrei.mit.muskatnuss@gmail.org>
Description: Ada is a general-purpose programming language that has great support for saftey critical and real-time applications.
             It has been developed by the DoD and thus has been used in military and safety-critical applications (like civil aviation).
             The first version appeared in the 80s, but it's still actively developed today with
             the newest standard being Ada2012.
*/ // We try to support full Ada2012
//
// We highlight all appearances of types, keywords, literals (string, char, number, bool)
// and titles (user defined function/procedure/package)
// CSS classes are set accordingly
//
// Languages causing problems for language detection:
// xml (broken by Foo : Bar type), elm (broken by Foo : Bar type), vbscript-html (broken by body keyword)
// sql (ada default.txt has a lot of sql keywords)
/** @type LanguageFn */ function $57a74c27509933f8$var$ada(hljs) {
    // Regular expression for Ada numeric literals.
    // stolen form the VHDL highlighter
    // Decimal literal:
    const INTEGER_RE = "\\d(_|\\d)*";
    const EXPONENT_RE = "[eE][-+]?" + INTEGER_RE;
    const DECIMAL_LITERAL_RE = INTEGER_RE + "(\\." + INTEGER_RE + ")?" + "(" + EXPONENT_RE + ")?";
    // Based literal:
    const BASED_INTEGER_RE = "\\w+";
    const BASED_LITERAL_RE = INTEGER_RE + "#" + BASED_INTEGER_RE + "(\\." + BASED_INTEGER_RE + ")?" + "#" + "(" + EXPONENT_RE + ")?";
    const NUMBER_RE = "\\b(" + BASED_LITERAL_RE + "|" + DECIMAL_LITERAL_RE + ")";
    // Identifier regex
    const ID_REGEX = "[A-Za-z](_?[A-Za-z0-9.])*";
    // bad chars, only allowed in literals
    const BAD_CHARS = `[]\\{\\}%#'"`;
    // Ada doesn't have block comments, only line comments
    const COMMENTS = hljs.COMMENT("--", "$");
    // variable declarations of the form
    // Foo : Bar := Baz;
    // where only Bar will be highlighted
    const VAR_DECLS = {
        // TODO: These spaces are not required by the Ada syntax
        // however, I have yet to see handwritten Ada code where
        // someone does not put spaces around :
        begin: "\\s+:\\s+",
        end: "\\s*(:=|;|\\)|=>|$)",
        // endsWithParent: true,
        // returnBegin: true,
        illegal: BAD_CHARS,
        contains: [
            {
                // workaround to avoid highlighting
                // named loops and declare blocks
                beginKeywords: "loop for declare others",
                endsParent: true
            },
            {
                // properly highlight all modifiers
                className: "keyword",
                beginKeywords: "not null constant access function procedure in out aliased exception"
            },
            {
                className: "type",
                begin: ID_REGEX,
                endsParent: true,
                relevance: 0
            }
        ]
    };
    return {
        name: "Ada",
        case_insensitive: true,
        keywords: {
            keyword: "abort else new return abs elsif not reverse abstract end accept entry select access exception of separate aliased exit or some all others subtype and for out synchronized array function overriding at tagged generic package task begin goto pragma terminate body private then if procedure type case in protected constant interface is raise use declare range delay limited record when delta loop rem while digits renames with do mod requeue xor",
            literal: "True False"
        },
        contains: [
            COMMENTS,
            // strings "foobar"
            {
                className: "string",
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            // characters ''
            {
                // character literals always contain one char
                className: "string",
                begin: /'.'/
            },
            {
                // number literals
                className: "number",
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                // Attributes
                className: "symbol",
                begin: "'" + ID_REGEX
            },
            {
                // package definition, maybe inside generic
                className: "title",
                begin: "(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?",
                end: "(is|$)",
                keywords: "package body",
                excludeBegin: true,
                excludeEnd: true,
                illegal: BAD_CHARS
            },
            {
                // function/procedure declaration/definition
                // maybe inside generic
                begin: "(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+",
                end: "(\\bis|\\bwith|\\brenames|\\)\\s*;)",
                keywords: "overriding function procedure with is renames return",
                // we need to re-match the 'function' keyword, so that
                // the title mode below matches only exactly once
                returnBegin: true,
                contains: [
                    COMMENTS,
                    {
                        // name of the function/procedure
                        className: "title",
                        begin: "(\\bwith\\s+)?\\b(function|procedure)\\s+",
                        end: "(\\(|\\s+|$)",
                        excludeBegin: true,
                        excludeEnd: true,
                        illegal: BAD_CHARS
                    },
                    // 'self'
                    // // parameter types
                    VAR_DECLS,
                    {
                        // return type
                        className: "type",
                        begin: "\\breturn\\s+",
                        end: "(\\s+|;|$)",
                        keywords: "return",
                        excludeBegin: true,
                        excludeEnd: true,
                        // we are done with functions
                        endsParent: true,
                        illegal: BAD_CHARS
                    }
                ]
            },
            {
                // new type declarations
                // maybe inside generic
                className: "type",
                begin: "\\b(sub)?type\\s+",
                end: "\\s+",
                keywords: "type",
                excludeBegin: true,
                illegal: BAD_CHARS
            },
            // see comment above the definition
            VAR_DECLS
        ]
    };
}
module.exports = $57a74c27509933f8$var$ada;

});

parcelRegister("2PUwx", function(module, exports) {
/*
Language: AngelScript
Author: Melissa Geels <melissa@nimble.tools>
Category: scripting
Website: https://www.angelcode.com/angelscript/
*/ /** @type LanguageFn */ function $210c30a25451bf2f$var$angelscript(hljs) {
    var builtInTypeMode = {
        className: "built_in",
        begin: "\\b(void|bool|int|int8|int16|int32|int64|uint|uint8|uint16|uint32|uint64|string|ref|array|double|float|auto|dictionary)"
    };
    var objectHandleMode = {
        className: "symbol",
        begin: "[a-zA-Z0-9_]+@"
    };
    var genericMode = {
        className: "keyword",
        begin: "<",
        end: ">",
        contains: [
            builtInTypeMode,
            objectHandleMode
        ]
    };
    builtInTypeMode.contains = [
        genericMode
    ];
    objectHandleMode.contains = [
        genericMode
    ];
    return {
        name: "AngelScript",
        aliases: [
            "asc"
        ],
        keywords: "for in|0 break continue while do|0 return if else case switch namespace is cast or and xor not get|0 in inout|10 out override set|0 private public const default|0 final shared external mixin|10 enum typedef funcdef this super import from interface abstract|0 try catch protected explicit property",
        // avoid close detection with C# and JS
        illegal: "(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])",
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'",
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                relevance: 0
            },
            // """heredoc strings"""
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                relevance: 0
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                begin: "^\\s*\\[",
                end: "\\]"
            },
            {
                beginKeywords: "interface namespace",
                end: /\{/,
                illegal: "[;.\\-]",
                contains: [
                    {
                        className: "symbol",
                        begin: "[a-zA-Z0-9_]+"
                    }
                ]
            },
            {
                beginKeywords: "class",
                end: /\{/,
                illegal: "[;.\\-]",
                contains: [
                    {
                        className: "symbol",
                        begin: "[a-zA-Z0-9_]+",
                        contains: [
                            {
                                begin: "[:,]\\s*",
                                contains: [
                                    {
                                        className: "symbol",
                                        begin: "[a-zA-Z0-9_]+"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            builtInTypeMode,
            objectHandleMode,
            {
                className: "literal",
                begin: "\\b(null|true|false)"
            },
            {
                className: "number",
                relevance: 0,
                begin: "(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)"
            }
        ]
    };
}
module.exports = $210c30a25451bf2f$var$angelscript;

});

parcelRegister("9hmTb", function(module, exports) {
/*
Language: Apache config
Author: Ruslan Keba <rukeba@gmail.com>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: https://httpd.apache.org
Description: language definition for Apache configuration files (httpd.conf & .htaccess)
Category: common, config
Audit: 2020
*/ /** @type LanguageFn */ function $6c1774e6aa6d8ffe$var$apache(hljs) {
    const NUMBER_REF = {
        className: "number",
        begin: /[$%]\d+/
    };
    const NUMBER = {
        className: "number",
        begin: /\d+/
    };
    const IP_ADDRESS = {
        className: "number",
        begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
    };
    const PORT_NUMBER = {
        className: "number",
        begin: /:\d{1,5}/
    };
    return {
        name: "Apache config",
        aliases: [
            "apacheconf"
        ],
        case_insensitive: true,
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                className: "section",
                begin: /<\/?/,
                end: />/,
                contains: [
                    IP_ADDRESS,
                    PORT_NUMBER,
                    // low relevance prevents us from claming XML/HTML where this rule would
                    // match strings inside of XML tags
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        relevance: 0
                    })
                ]
            },
            {
                className: "attribute",
                begin: /\w+/,
                relevance: 0,
                // keywords aren’t needed for highlighting per se, they only boost relevance
                // for a very generally defined mode (starts with a word, ends with line-end
                keywords: {
                    nomarkup: "order deny allow setenv rewriterule rewriteengine rewritecond documentroot sethandler errordocument loadmodule options header listen serverroot servername"
                },
                starts: {
                    end: /$/,
                    relevance: 0,
                    keywords: {
                        literal: "on off all deny allow"
                    },
                    contains: [
                        {
                            className: "meta",
                            begin: /\s\[/,
                            end: /\]$/
                        },
                        {
                            className: "variable",
                            begin: /[\$%]\{/,
                            end: /\}/,
                            contains: [
                                "self",
                                NUMBER_REF
                            ]
                        },
                        IP_ADDRESS,
                        NUMBER,
                        hljs.QUOTE_STRING_MODE
                    ]
                }
            }
        ],
        illegal: /\S/
    };
}
module.exports = $6c1774e6aa6d8ffe$var$apache;

});

parcelRegister("8Vvqc", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $67fc0548164d119d$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $67fc0548164d119d$var$concat(...args) {
    const joined = args.map((x)=>$67fc0548164d119d$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $67fc0548164d119d$var$either(...args) {
    const joined = "(" + args.map((x)=>$67fc0548164d119d$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: AppleScript
Authors: Nathan Grigg <nathan@nathanamy.org>, Dr. Drang <drdrang@gmail.com>
Category: scripting
Website: https://developer.apple.com/library/archive/documentation/AppleScript/Conceptual/AppleScriptLangGuide/introduction/ASLR_intro.html
Audit: 2020
*/ /** @type LanguageFn */ function $67fc0548164d119d$var$applescript(hljs) {
    const STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        contains: [
            "self",
            hljs.C_NUMBER_MODE,
            STRING
        ]
    };
    const COMMENT_MODE_1 = hljs.COMMENT(/--/, /$/);
    const COMMENT_MODE_2 = hljs.COMMENT(/\(\*/, /\*\)/, {
        contains: [
            "self",
            COMMENT_MODE_1
        ]
    });
    const COMMENTS = [
        COMMENT_MODE_1,
        COMMENT_MODE_2,
        hljs.HASH_COMMENT_MODE
    ];
    const KEYWORD_PATTERNS = [
        /apart from/,
        /aside from/,
        /instead of/,
        /out of/,
        /greater than/,
        /isn't|(doesn't|does not) (equal|come before|come after|contain)/,
        /(greater|less) than( or equal)?/,
        /(starts?|ends|begins?) with/,
        /contained by/,
        /comes (before|after)/,
        /a (ref|reference)/,
        /POSIX (file|path)/,
        /(date|time) string/,
        /quoted form/
    ];
    const BUILT_IN_PATTERNS = [
        /clipboard info/,
        /the clipboard/,
        /info for/,
        /list (disks|folder)/,
        /mount volume/,
        /path to/,
        /(close|open for) access/,
        /(get|set) eof/,
        /current date/,
        /do shell script/,
        /get volume settings/,
        /random number/,
        /set volume/,
        /system attribute/,
        /system info/,
        /time to GMT/,
        /(load|run|store) script/,
        /scripting components/,
        /ASCII (character|number)/,
        /localized string/,
        /choose (application|color|file|file name|folder|from list|remote application|URL)/,
        /display (alert|dialog)/
    ];
    return {
        name: "AppleScript",
        aliases: [
            "osascript"
        ],
        keywords: {
            keyword: "about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",
            literal: "AppleScript false linefeed return pi quote result space tab true",
            built_in: "alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name paragraph paragraphs rest reverse running time version weekday word words year"
        },
        contains: [
            STRING,
            hljs.C_NUMBER_MODE,
            {
                className: "built_in",
                begin: $67fc0548164d119d$var$concat(/\b/, $67fc0548164d119d$var$either(...BUILT_IN_PATTERNS), /\b/)
            },
            {
                className: "built_in",
                begin: /^\s*return\b/
            },
            {
                className: "literal",
                begin: /\b(text item delimiters|current application|missing value)\b/
            },
            {
                className: "keyword",
                begin: $67fc0548164d119d$var$concat(/\b/, $67fc0548164d119d$var$either(...KEYWORD_PATTERNS), /\b/)
            },
            {
                beginKeywords: "on",
                illegal: /[${=;\n]/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS
                ]
            },
            ...COMMENTS
        ],
        illegal: /\/\/|->|=>|\[\[/
    };
}
module.exports = $67fc0548164d119d$var$applescript;

});

parcelRegister("j1C1h", function(module, exports) {
/*
 Language: ArcGIS Arcade
 Category: scripting
 Author: John Foster <jfoster@esri.com>
 Website: https://developers.arcgis.com/arcade/
 Description: ArcGIS Arcade is an expression language used in many Esri ArcGIS products such as Pro, Online, Server, Runtime, JavaScript, and Python
*/ /** @type LanguageFn */ function $dd9b9a35d61bac35$var$arcade(hljs) {
    const IDENT_RE = "[A-Za-z_][0-9A-Za-z_]*";
    const KEYWORDS = {
        keyword: "if for while var new function do return void else break",
        literal: "BackSlash DoubleQuote false ForwardSlash Infinity NaN NewLine null PI SingleQuote Tab TextFormatting true undefined",
        built_in: "Abs Acos Angle Attachments Area AreaGeodetic Asin Atan Atan2 Average Bearing Boolean Buffer BufferGeodetic Ceil Centroid Clip Console Constrain Contains Cos Count Crosses Cut Date DateAdd DateDiff Day Decode DefaultValue Dictionary Difference Disjoint Distance DistanceGeodetic Distinct DomainCode DomainName Equals Exp Extent Feature FeatureSet FeatureSetByAssociation FeatureSetById FeatureSetByPortalItem FeatureSetByRelationshipName FeatureSetByTitle FeatureSetByUrl Filter First Floor Geometry GroupBy Guid HasKey Hour IIf IndexOf Intersection Intersects IsEmpty IsNan IsSelfIntersecting Length LengthGeodetic Log Max Mean Millisecond Min Minute Month MultiPartToSinglePart Multipoint NextSequenceValue Now Number OrderBy Overlaps Point Polygon Polyline Portal Pow Random Relate Reverse RingIsClockWise Round Second SetGeometry Sin Sort Sqrt Stdev Sum SymmetricDifference Tan Text Timestamp Today ToLocal Top Touches ToUTC TrackCurrentTime TrackGeometryWindow TrackIndex TrackStartTime TrackWindow TypeOf Union UrlEncode Variance Weekday When Within Year "
    };
    const SYMBOL = {
        className: "symbol",
        begin: "\\$[datastore|feature|layer|map|measure|sourcefeature|sourcelayer|targetfeature|targetlayer|value|view]+"
    };
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: "\\b(0[bB][01]+)"
            },
            {
                begin: "\\b(0[oO][0-7]+)"
            },
            {
                begin: hljs.C_NUMBER_RE
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS,
        contains: [] // defined later
    };
    const TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    SUBST.contains = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    const PARAMS_CONTAINS = SUBST.contains.concat([
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.C_LINE_COMMENT_MODE
    ]);
    return {
        name: "ArcGIS Arcade",
        keywords: KEYWORDS,
        contains: [
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            TEMPLATE_STRING,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            SYMBOL,
            NUMBER,
            {
                begin: /[{,]\s*/,
                relevance: 0,
                contains: [
                    {
                        begin: IDENT_RE + "\\s*:",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            {
                                className: "attr",
                                begin: IDENT_RE,
                                relevance: 0
                            }
                        ]
                    }
                ]
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(return)\\b)\\s*",
                keywords: "return",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        begin: "(\\(.*?\\)|" + IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: IDENT_RE
                                    },
                                    {
                                        begin: /\(\s*\)/
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE
                    }),
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        contains: PARAMS_CONTAINS
                    }
                ],
                illegal: /\[|%/
            },
            {
                begin: /\$[(.]/
            }
        ],
        illegal: /#(?!!)/
    };
}
module.exports = $dd9b9a35d61bac35$var$arcade;

});

parcelRegister("hlBw7", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $ca117ff3a5d8daa6$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $ca117ff3a5d8daa6$var$lookahead(re) {
    return $ca117ff3a5d8daa6$var$concat("(?=", re, ")");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $ca117ff3a5d8daa6$var$optional(re) {
    return $ca117ff3a5d8daa6$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $ca117ff3a5d8daa6$var$concat(...args) {
    const joined = args.map((x)=>$ca117ff3a5d8daa6$var$source(x)).join("");
    return joined;
}
/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/ /** @type LanguageFn */ function $ca117ff3a5d8daa6$var$cPlusPlus(hljs) {
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT("//", "$", {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = "decltype\\(auto\\)";
    const NAMESPACE_RE = "[a-zA-Z_]\\w*::";
    const TEMPLATE_ARGUMENT_RE = "<[^<>]+>";
    const FUNCTION_TYPE_RE = "(" + DECLTYPE_AUTO_RE + "|" + $ca117ff3a5d8daa6$var$optional(NAMESPACE_RE) + "[a-zA-Z_]\\w*" + $ca117ff3a5d8daa6$var$optional(TEMPLATE_ARGUMENT_RE) + ")";
    const CPP_PRIMITIVE_TYPES = {
        className: "keyword",
        begin: "\\b[a-z\\d_]*_t\\b"
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)";
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "(u8?|U|L)?'(" + CHARACTER_ESCAPES + "|.)",
                end: "'",
                illegal: "."
            },
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                end: /\)([^()\\ ]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const TITLE_MODE = {
        className: "title",
        begin: $ca117ff3a5d8daa6$var$optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = $ca117ff3a5d8daa6$var$optional(NAMESPACE_RE) + hljs.IDENT_RE + "\\s*\\(";
    const COMMON_CPP_HINTS = [
        "asin",
        "atan2",
        "atan",
        "calloc",
        "ceil",
        "cosh",
        "cos",
        "exit",
        "exp",
        "fabs",
        "floor",
        "fmod",
        "fprintf",
        "fputs",
        "free",
        "frexp",
        "auto_ptr",
        "deque",
        "list",
        "queue",
        "stack",
        "vector",
        "map",
        "set",
        "pair",
        "bitset",
        "multiset",
        "multimap",
        "unordered_set",
        "fscanf",
        "future",
        "isalnum",
        "isalpha",
        "iscntrl",
        "isdigit",
        "isgraph",
        "islower",
        "isprint",
        "ispunct",
        "isspace",
        "isupper",
        "isxdigit",
        "tolower",
        "toupper",
        "labs",
        "ldexp",
        "log10",
        "log",
        "malloc",
        "realloc",
        "memchr",
        "memcmp",
        "memcpy",
        "memset",
        "modf",
        "pow",
        "printf",
        "putchar",
        "puts",
        "scanf",
        "sinh",
        "sin",
        "snprintf",
        "sprintf",
        "sqrt",
        "sscanf",
        "strcat",
        "strchr",
        "strcmp",
        "strcpy",
        "strcspn",
        "strlen",
        "strncat",
        "strncmp",
        "strncpy",
        "strpbrk",
        "strrchr",
        "strspn",
        "strstr",
        "tanh",
        "tan",
        "unordered_map",
        "unordered_multiset",
        "unordered_multimap",
        "priority_queue",
        "make_pair",
        "array",
        "shared_ptr",
        "abort",
        "terminate",
        "abs",
        "acos",
        "vfprintf",
        "vprintf",
        "vsprintf",
        "endl",
        "initializer_list",
        "unique_ptr",
        "complex",
        "imaginary",
        "std",
        "string",
        "wstring",
        "cin",
        "cout",
        "cerr",
        "clog",
        "stdin",
        "stdout",
        "stderr",
        "stringstream",
        "istringstream",
        "ostringstream"
    ];
    const CPP_KEYWORDS = {
        keyword: "int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid wchar_t short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignas alignof constexpr consteval constinit decltype concept co_await co_return co_yield requires noexcept static_assert thread_local restrict final override atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq",
        built_in: "_Bool _Complex _Imaginary",
        _relevance_hints: COMMON_CPP_HINTS,
        literal: "true false nullptr NULL"
    };
    const FUNCTION_DISPATCH = {
        className: "function.dispatch",
        relevance: 0,
        keywords: CPP_KEYWORDS,
        begin: $ca117ff3a5d8daa6$var$concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, $ca117ff3a5d8daa6$var$lookahead(/\s*\(/))
    };
    const EXPRESSION_CONTAINS = [
        FUNCTION_DISPATCH,
        PREPROCESSOR,
        CPP_PRIMITIVE_TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: "new throw return else",
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    "self"
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        className: "function",
        begin: "(" + FUNCTION_TYPE_RE + "[\\*&\\s]+)+" + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            // needed because we do not have look-behind on the below rule
            // to prevent it from grabbing the final : in a :: pair
            {
                begin: /::/,
                relevance: 0
            },
            // initializers
            {
                begin: /:/,
                endsWithParent: true,
                contains: [
                    STRINGS,
                    NUMBERS
                ]
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            "self",
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        name: "C++",
        aliases: [
            "cc",
            "c++",
            "h++",
            "hpp",
            "hh",
            "hxx",
            "cxx"
        ],
        keywords: CPP_KEYWORDS,
        illegal: "</",
        classNameAliases: {
            "function.dispatch": "built_in"
        },
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",
                end: ">",
                keywords: CPP_KEYWORDS,
                contains: [
                    "self",
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: CPP_KEYWORDS
            },
            {
                className: "class",
                beginKeywords: "enum class struct union",
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: CPP_KEYWORDS
        }
    };
}
/*
Language: Arduino
Author: Stefania Mellai <s.mellai@arduino.cc>
Description: The Arduino® Language is a superset of C++. This rules are designed to highlight the Arduino® source code. For info about language see http://www.arduino.cc.
Website: https://www.arduino.cc
*/ /** @type LanguageFn */ function $ca117ff3a5d8daa6$var$arduino(hljs) {
    const ARDUINO_KW = {
        keyword: "boolean byte word String",
        built_in: "KeyboardController MouseController SoftwareSerial EthernetServer EthernetClient LiquidCrystal RobotControl GSMVoiceCall EthernetUDP EsploraTFT HttpClient RobotMotor WiFiClient GSMScanner FileSystem Scheduler GSMServer YunClient YunServer IPAddress GSMClient GSMModem Keyboard Ethernet Console GSMBand Esplora Stepper Process WiFiUDP GSM_SMS Mailbox USBHost Firmata PImage Client Server GSMPIN FileIO Bridge Serial EEPROM Stream Mouse Audio Servo File Task GPRS WiFi Wire TFT GSM SPI SD ",
        _: "setup loop runShellCommandAsynchronously analogWriteResolution retrieveCallingNumber printFirmwareVersion analogReadResolution sendDigitalPortPair noListenOnLocalhost readJoystickButton setFirmwareVersion readJoystickSwitch scrollDisplayRight getVoiceCallStatus scrollDisplayLeft writeMicroseconds delayMicroseconds beginTransmission getSignalStrength runAsynchronously getAsynchronously listenOnLocalhost getCurrentCarrier readAccelerometer messageAvailable sendDigitalPorts lineFollowConfig countryNameWrite runShellCommand readStringUntil rewindDirectory readTemperature setClockDivider readLightSensor endTransmission analogReference detachInterrupt countryNameRead attachInterrupt encryptionType readBytesUntil robotNameWrite readMicrophone robotNameRead cityNameWrite userNameWrite readJoystickY readJoystickX mouseReleased openNextFile scanNetworks noInterrupts digitalWrite beginSpeaker mousePressed isActionDone mouseDragged displayLogos noAutoscroll addParameter remoteNumber getModifiers keyboardRead userNameRead waitContinue processInput parseCommand printVersion readNetworks writeMessage blinkVersion cityNameRead readMessage setDataMode parsePacket isListening setBitOrder beginPacket isDirectory motorsWrite drawCompass digitalRead clearScreen serialEvent rightToLeft setTextSize leftToRight requestFrom keyReleased compassRead analogWrite interrupts WiFiServer disconnect playMelody parseFloat autoscroll getPINUsed setPINUsed setTimeout sendAnalog readSlider analogRead beginWrite createChar motorsStop keyPressed tempoWrite readButton subnetMask debugPrint macAddress writeGreen randomSeed attachGPRS readString sendString remotePort releaseAll mouseMoved background getXChange getYChange answerCall getResult voiceCall endPacket constrain getSocket writeJSON getButton available connected findUntil readBytes exitValue readGreen writeBlue startLoop IPAddress isPressed sendSysex pauseMode gatewayIP setCursor getOemKey tuneWrite noDisplay loadImage switchPIN onRequest onReceive changePIN playFile noBuffer parseInt overflow checkPIN knobRead beginTFT bitClear updateIR bitWrite position writeRGB highByte writeRed setSpeed readBlue noStroke remoteIP transfer shutdown hangCall beginSMS endWrite attached maintain noCursor checkReg checkPUK shiftOut isValid shiftIn pulseIn connect println localIP pinMode getIMEI display noBlink process getBand running beginSD drawBMP lowByte setBand release bitRead prepare pointTo readRed setMode noFill remove listen stroke detach attach noTone exists buffer height bitSet circle config cursor random IRread setDNS endSMS getKey micros millis begin print write ready flush width isPIN blink clear press mkdir rmdir close point yield image BSSID click delay read text move peek beep rect line open seek fill size turn stop home find step tone sqrt RSSI SSID end bit tan cos sin pow map abs max min get run put",
        literal: "DIGITAL_MESSAGE FIRMATA_STRING ANALOG_MESSAGE REPORT_DIGITAL REPORT_ANALOG INPUT_PULLUP SET_PIN_MODE INTERNAL2V56 SYSTEM_RESET LED_BUILTIN INTERNAL1V1 SYSEX_START INTERNAL EXTERNAL DEFAULT OUTPUT INPUT HIGH LOW"
    };
    const ARDUINO = $ca117ff3a5d8daa6$var$cPlusPlus(hljs);
    const kws = /** @type {Record<string,any>} */ ARDUINO.keywords;
    kws.keyword += " " + ARDUINO_KW.keyword;
    kws.literal += " " + ARDUINO_KW.literal;
    kws.built_in += " " + ARDUINO_KW.built_in;
    kws._ += " " + ARDUINO_KW._;
    ARDUINO.name = "Arduino";
    ARDUINO.aliases = [
        "ino"
    ];
    ARDUINO.supersetOf = "cpp";
    return ARDUINO;
}
module.exports = $ca117ff3a5d8daa6$var$arduino;

});

parcelRegister("dlNkY", function(module, exports) {
/*
Language: ARM Assembly
Author: Dan Panzarella <alsoelp@gmail.com>
Description: ARM Assembly including Thumb and Thumb2 instructions
Category: assembler
*/ /** @type LanguageFn */ function $9b8381e274644328$var$armasm(hljs) {
    // local labels: %?[FB]?[AT]?\d{1,2}\w+
    const COMMENT = {
        variants: [
            hljs.COMMENT("^[ \\t]*(?=#)", "$", {
                relevance: 0,
                excludeBegin: true
            }),
            hljs.COMMENT("[;@]", "$", {
                relevance: 0
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    return {
        name: "ARM Assembly",
        case_insensitive: true,
        aliases: [
            "arm"
        ],
        keywords: {
            $pattern: "\\.?" + hljs.IDENT_RE,
            meta: // GNU preprocs
            ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ",
            built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"
        },
        contains: [
            {
                className: "keyword",
                begin: "\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\s)" // followed by space
            },
            COMMENT,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                relevance: 0
            },
            {
                className: "title",
                begin: "\\|",
                end: "\\|",
                illegal: "\\n",
                relevance: 0
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "[#$=]?0x[0-9a-f]+"
                    },
                    {
                        begin: "[#$=]?0b[01]+"
                    },
                    {
                        begin: "[#$=]\\d+"
                    },
                    {
                        begin: "\\b\\d+"
                    }
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                    },
                    {
                        begin: "^[a-z_\\.\\$][a-z0-9_\\.\\$]+"
                    },
                    {
                        begin: "[=#]\\w+"
                    }
                ],
                relevance: 0
            }
        ]
    };
}
module.exports = $9b8381e274644328$var$armasm;

});

parcelRegister("kB1SH", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $efe8b8ecebeac899$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $efe8b8ecebeac899$var$lookahead(re) {
    return $efe8b8ecebeac899$var$concat("(?=", re, ")");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $efe8b8ecebeac899$var$optional(re) {
    return $efe8b8ecebeac899$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $efe8b8ecebeac899$var$concat(...args) {
    const joined = args.map((x)=>$efe8b8ecebeac899$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $efe8b8ecebeac899$var$either(...args) {
    const joined = "(" + args.map((x)=>$efe8b8ecebeac899$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: HTML, XML
Website: https://www.w3.org/XML/
Category: common
Audit: 2020
*/ /** @type LanguageFn */ function $efe8b8ecebeac899$var$xml(hljs) {
    // Element names can contain letters, digits, hyphens, underscores, and periods
    const TAG_NAME_RE = $efe8b8ecebeac899$var$concat(/[A-Z_]/, $efe8b8ecebeac899$var$optional(/[A-Z0-9_.-]*:/), /[A-Z0-9_.-]*/);
    const XML_IDENT_RE = /[A-Za-z0-9._:-]+/;
    const XML_ENTITIES = {
        className: "symbol",
        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
    };
    const XML_META_KEYWORDS = {
        begin: /\s/,
        contains: [
            {
                className: "meta-keyword",
                begin: /#?[a-z_][a-z1-9_-]+/,
                illegal: /\n/
            }
        ]
    };
    const XML_META_PAR_KEYWORDS = hljs.inherit(XML_META_KEYWORDS, {
        begin: /\(/,
        end: /\)/
    });
    const APOS_META_STRING_MODE = hljs.inherit(hljs.APOS_STRING_MODE, {
        className: "meta-string"
    });
    const QUOTE_META_STRING_MODE = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        className: "meta-string"
    });
    const TAG_INTERNALS = {
        endsWithParent: true,
        illegal: /</,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: XML_IDENT_RE,
                relevance: 0
            },
            {
                begin: /=\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "string",
                        endsParent: true,
                        variants: [
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    XML_ENTITIES
                                ]
                            },
                            {
                                begin: /[^\s"'=<>`]+/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        name: "HTML, XML",
        aliases: [
            "html",
            "xhtml",
            "rss",
            "atom",
            "xjb",
            "xsd",
            "xsl",
            "plist",
            "wsf",
            "svg"
        ],
        case_insensitive: true,
        contains: [
            {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                relevance: 10,
                contains: [
                    XML_META_KEYWORDS,
                    QUOTE_META_STRING_MODE,
                    APOS_META_STRING_MODE,
                    XML_META_PAR_KEYWORDS,
                    {
                        begin: /\[/,
                        end: /\]/,
                        contains: [
                            {
                                className: "meta",
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [
                                    XML_META_KEYWORDS,
                                    XML_META_PAR_KEYWORDS,
                                    QUOTE_META_STRING_MODE,
                                    APOS_META_STRING_MODE
                                ]
                            }
                        ]
                    }
                ]
            },
            hljs.COMMENT(/<!--/, /-->/, {
                relevance: 10
            }),
            {
                begin: /<!\[CDATA\[/,
                end: /\]\]>/,
                relevance: 10
            },
            XML_ENTITIES,
            {
                className: "meta",
                begin: /<\?xml/,
                end: /\?>/,
                relevance: 10
            },
            {
                className: "tag",
                /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending braket. The '$' is needed for the lexeme to be recognized
        by hljs.subMode() that tests lexemes outside the stream.
        */ begin: /<style(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "style"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/style>/,
                    returnEnd: true,
                    subLanguage: [
                        "css",
                        "xml"
                    ]
                }
            },
            {
                className: "tag",
                // See the comment in the <style tag about the lookahead pattern
                begin: /<script(?=\s|>)/,
                end: />/,
                keywords: {
                    name: "script"
                },
                contains: [
                    TAG_INTERNALS
                ],
                starts: {
                    end: /<\/script>/,
                    returnEnd: true,
                    subLanguage: [
                        "javascript",
                        "handlebars",
                        "xml"
                    ]
                }
            },
            // we need this for now for jSX
            {
                className: "tag",
                begin: /<>|<\/>/
            },
            // open tag
            {
                className: "tag",
                begin: $efe8b8ecebeac899$var$concat(/</, $efe8b8ecebeac899$var$lookahead($efe8b8ecebeac899$var$concat(TAG_NAME_RE, // <tag/>
                // <tag>
                // <tag ...
                $efe8b8ecebeac899$var$either(/\/>/, />/, /\s/)))),
                end: /\/?>/,
                contains: [
                    {
                        className: "name",
                        begin: TAG_NAME_RE,
                        relevance: 0,
                        starts: TAG_INTERNALS
                    }
                ]
            },
            // close tag
            {
                className: "tag",
                begin: $efe8b8ecebeac899$var$concat(/<\//, $efe8b8ecebeac899$var$lookahead($efe8b8ecebeac899$var$concat(TAG_NAME_RE, />/))),
                contains: [
                    {
                        className: "name",
                        begin: TAG_NAME_RE,
                        relevance: 0
                    },
                    {
                        begin: />/,
                        relevance: 0,
                        endsParent: true
                    }
                ]
            }
        ]
    };
}
module.exports = $efe8b8ecebeac899$var$xml;

});

parcelRegister("gkbm1", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $be27524e275551d4$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $be27524e275551d4$var$concat(...args) {
    const joined = args.map((x)=>$be27524e275551d4$var$source(x)).join("");
    return joined;
}
/*
Language: AsciiDoc
Requires: xml.js
Author: Dan Allen <dan.j.allen@gmail.com>
Website: http://asciidoc.org
Description: A semantic, text-based document format that can be exported to HTML, DocBook and other backends.
Category: markup
*/ /** @type LanguageFn */ function $be27524e275551d4$var$asciidoc(hljs) {
    const HORIZONTAL_RULE = {
        begin: "^'{3,}[ \\t]*$",
        relevance: 10
    };
    const ESCAPED_FORMATTING = [
        // escaped constrained formatting marks (i.e., \* \_ or \`)
        {
            begin: /\\[*_`]/
        },
        // escaped unconstrained formatting marks (i.e., \\** \\__ or \\``)
        // must ignore until the next formatting marks
        // this rule might not be 100% compliant with Asciidoctor 2.0 but we are entering undefined behavior territory...
        {
            begin: /\\\\\*{2}[^\n]*?\*{2}/
        },
        {
            begin: /\\\\_{2}[^\n]*_{2}/
        },
        {
            begin: /\\\\`{2}[^\n]*`{2}/
        },
        // guard: constrained formatting mark may not be preceded by ":", ";" or
        // "}". match these so the constrained rule doesn't see them
        {
            begin: /[:;}][*_`](?![*_`])/
        }
    ];
    const STRONG = [
        // inline unconstrained strong (single line)
        {
            className: "strong",
            begin: /\*{2}([^\n]+?)\*{2}/
        },
        // inline unconstrained strong (multi-line)
        {
            className: "strong",
            begin: $be27524e275551d4$var$concat(/\*\*/, /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/, /(\*(?!\*)|\\[^\n]|[^*\n\\])*/, /\*\*/),
            relevance: 0
        },
        // inline constrained strong (single line)
        {
            className: "strong",
            // must not precede or follow a word character
            begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
        },
        // inline constrained strong (multi-line)
        {
            className: "strong",
            // must not precede or follow a word character
            begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
        }
    ];
    const EMPHASIS = [
        // inline unconstrained emphasis (single line)
        {
            className: "emphasis",
            begin: /_{2}([^\n]+?)_{2}/
        },
        // inline unconstrained emphasis (multi-line)
        {
            className: "emphasis",
            begin: $be27524e275551d4$var$concat(/__/, /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/, /(_(?!_)|\\[^\n]|[^_\n\\])*/, /__/),
            relevance: 0
        },
        // inline constrained emphasis (single line)
        {
            className: "emphasis",
            // must not precede or follow a word character
            begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
        },
        // inline constrained emphasis (multi-line)
        {
            className: "emphasis",
            // must not precede or follow a word character
            begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
        },
        // inline constrained emphasis using single quote (legacy)
        {
            className: "emphasis",
            // must not follow a word character or be followed by a single quote or space
            begin: "\\B'(?!['\\s])",
            end: "(\\n{2}|')",
            // allow escaped single quote followed by word char
            contains: [
                {
                    begin: "\\\\'\\w",
                    relevance: 0
                }
            ],
            relevance: 0
        }
    ];
    const ADMONITION = {
        className: "symbol",
        begin: "^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",
        relevance: 10
    };
    const BULLET_LIST = {
        className: "bullet",
        begin: "^(\\*+|-+|\\.+|[^\\n]+?::)\\s+"
    };
    return {
        name: "AsciiDoc",
        aliases: [
            "adoc"
        ],
        contains: [
            // block comment
            hljs.COMMENT("^/{4,}\\n", "\\n/{4,}$", // can also be done as...
            // '^/{4,}$',
            // '^/{4,}$',
            {
                relevance: 10
            }),
            // line comment
            hljs.COMMENT("^//", "$", {
                relevance: 0
            }),
            // title
            {
                className: "title",
                begin: "^\\.\\w.*$"
            },
            // example, admonition & sidebar blocks
            {
                begin: "^[=\\*]{4,}\\n",
                end: "\\n^[=\\*]{4,}$",
                relevance: 10
            },
            // headings
            {
                className: "section",
                relevance: 10,
                variants: [
                    {
                        begin: "^(={1,6})[ 	].+?([ 	]\\1)?$"
                    },
                    {
                        begin: "^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$"
                    }
                ]
            },
            // document attributes
            {
                className: "meta",
                begin: "^:.+?:",
                end: "\\s",
                excludeEnd: true,
                relevance: 10
            },
            // block attributes
            {
                className: "meta",
                begin: "^\\[.+?\\]$",
                relevance: 0
            },
            // quoteblocks
            {
                className: "quote",
                begin: "^_{4,}\\n",
                end: "\\n_{4,}$",
                relevance: 10
            },
            // listing and literal blocks
            {
                className: "code",
                begin: "^[\\-\\.]{4,}\\n",
                end: "\\n[\\-\\.]{4,}$",
                relevance: 10
            },
            // passthrough blocks
            {
                begin: "^\\+{4,}\\n",
                end: "\\n\\+{4,}$",
                contains: [
                    {
                        begin: "<",
                        end: ">",
                        subLanguage: "xml",
                        relevance: 0
                    }
                ],
                relevance: 10
            },
            BULLET_LIST,
            ADMONITION,
            ...ESCAPED_FORMATTING,
            ...STRONG,
            ...EMPHASIS,
            // inline smart quotes
            {
                className: "string",
                variants: [
                    {
                        begin: "``.+?''"
                    },
                    {
                        begin: "`.+?'"
                    }
                ]
            },
            // inline unconstrained emphasis
            {
                className: "code",
                begin: /`{2}/,
                end: /(\n{2}|`{2})/
            },
            // inline code snippets (TODO should get same treatment as strong and emphasis)
            {
                className: "code",
                begin: "(`.+?`|\\+.+?\\+)",
                relevance: 0
            },
            // indented literal block
            {
                className: "code",
                begin: "^[ \\t]",
                end: "$",
                relevance: 0
            },
            HORIZONTAL_RULE,
            // images and links
            {
                begin: "(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]",
                returnBegin: true,
                contains: [
                    {
                        begin: "(link|image:?):",
                        relevance: 0
                    },
                    {
                        className: "link",
                        begin: "\\w",
                        end: "[^\\[]+",
                        relevance: 0
                    },
                    {
                        className: "string",
                        begin: "\\[",
                        end: "\\]",
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    }
                ],
                relevance: 10
            }
        ]
    };
}
module.exports = $be27524e275551d4$var$asciidoc;

});

parcelRegister("63yFf", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $468de97ad0938a4b$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $468de97ad0938a4b$var$concat(...args) {
    const joined = args.map((x)=>$468de97ad0938a4b$var$source(x)).join("");
    return joined;
}
/*
Language: AspectJ
Author: Hakan Ozler <ozler.hakan@gmail.com>
Website: https://www.eclipse.org/aspectj/
Description: Syntax Highlighting for the AspectJ Language which is a general-purpose aspect-oriented extension to the Java programming language.
Audit: 2020
*/ /** @type LanguageFn */ function $468de97ad0938a4b$var$aspectj(hljs) {
    const KEYWORDS = "false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else extends implements break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws privileged aspectOf adviceexecution proceed cflowbelow cflow initialization preinitialization staticinitialization withincode target within execution getWithinTypeName handler thisJoinPoint thisJoinPointStaticPart thisEnclosingJoinPointStaticPart declare parents warning error soft precedence thisAspectInstance";
    const SHORTKEYS = "get set args call";
    return {
        name: "AspectJ",
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT(/\/\*\*/, /\*\//, {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: "doctag",
                        begin: /@[A-Za-z]+/
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "class",
                beginKeywords: "aspect",
                end: /[{;=]/,
                excludeEnd: true,
                illegal: /[:;"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton"
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        begin: /\([^\)]*/,
                        end: /[)]+/,
                        keywords: KEYWORDS + " " + SHORTKEYS,
                        excludeEnd: false
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: /[{;=]/,
                excludeEnd: true,
                relevance: 0,
                keywords: "class interface",
                illegal: /[:"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                // AspectJ Constructs
                beginKeywords: "pointcut after before around throwing returning",
                end: /[)]/,
                excludeEnd: false,
                illegal: /["\[\]]/,
                contains: [
                    {
                        begin: $468de97ad0938a4b$var$concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
                        returnBegin: true,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    }
                ]
            },
            {
                begin: /[:]/,
                returnBegin: true,
                end: /[{;]/,
                relevance: 0,
                excludeEnd: false,
                keywords: KEYWORDS,
                illegal: /["\[\]]/,
                contains: [
                    {
                        begin: $468de97ad0938a4b$var$concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
                        keywords: KEYWORDS + " " + SHORTKEYS,
                        relevance: 0
                    },
                    hljs.QUOTE_STRING_MODE
                ]
            },
            {
                // this prevents 'new Name(...), or throw ...' from being recognized as a function definition
                beginKeywords: "new throw",
                relevance: 0
            },
            {
                // the function class is a bit different for AspectJ compared to the Java language
                className: "function",
                begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
                returnBegin: true,
                end: /[{;=]/,
                keywords: KEYWORDS,
                excludeEnd: true,
                contains: [
                    {
                        begin: $468de97ad0938a4b$var$concat(hljs.UNDERSCORE_IDENT_RE, /\s*\(/),
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: KEYWORDS,
                        contains: [
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            hljs.C_NUMBER_MODE,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                // annotation is also used in this language
                className: "meta",
                begin: /@[A-Za-z]+/
            }
        ]
    };
}
module.exports = $468de97ad0938a4b$var$aspectj;

});

parcelRegister("8BAsx", function(module, exports) {
/*
Language: AutoHotkey
Author: Seongwon Lee <dlimpid@gmail.com>
Description: AutoHotkey language definition
Category: scripting
*/ /** @type LanguageFn */ function $643e0f80d6c43bd9$var$autohotkey(hljs) {
    const BACKTICK_ESCAPE = {
        begin: "`[\\s\\S]"
    };
    return {
        name: "AutoHotkey",
        case_insensitive: true,
        aliases: [
            "ahk"
        ],
        keywords: {
            keyword: "Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",
            literal: "true false NOT AND OR",
            built_in: "ComSpec Clipboard ClipboardAll ErrorLevel"
        },
        contains: [
            BACKTICK_ESCAPE,
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                contains: [
                    BACKTICK_ESCAPE
                ]
            }),
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "number",
                begin: hljs.NUMBER_RE,
                relevance: 0
            },
            {
                // subst would be the most accurate however fails the point of
                // highlighting. variable is comparably the most accurate that actually
                // has some effect
                className: "variable",
                begin: "%[a-zA-Z0-9#_$@]+%"
            },
            {
                className: "built_in",
                begin: "^\\s*\\w+\\s*(,|%)"
            },
            {
                // symbol would be most accurate however is highlighted just like
                // built_in and that makes up a lot of AutoHotkey code meaning that it
                // would fail to highlight anything
                className: "title",
                variants: [
                    {
                        begin: '^[^\\n";]+::(?!=)'
                    },
                    {
                        begin: '^[^\\n";]+:(?!=)',
                        // zero relevance as it catches a lot of things
                        // followed by a single ':' in many languages
                        relevance: 0
                    }
                ]
            },
            {
                className: "meta",
                begin: "^\\s*#\\w+",
                end: "$",
                relevance: 0
            },
            {
                className: "built_in",
                begin: "A_[a-zA-Z0-9]+"
            },
            {
                // consecutive commas, not for highlighting but just for relevance
                begin: ",\\s*,"
            }
        ]
    };
}
module.exports = $643e0f80d6c43bd9$var$autohotkey;

});

parcelRegister("hfevr", function(module, exports) {
/*
Language: AutoIt
Author: Manh Tuan <junookyo@gmail.com>
Description: AutoIt language definition
Category: scripting
*/ /** @type LanguageFn */ function $c8df170448a9bb61$var$autoit(hljs) {
    const KEYWORDS = "ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With";
    const DIRECTIVES = [
        "EndRegion",
        "forcedef",
        "forceref",
        "ignorefunc",
        "include",
        "include-once",
        "NoTrayIcon",
        "OnAutoItStartRegister",
        "pragma",
        "Region",
        "RequireAdmin",
        "Tidy_Off",
        "Tidy_On",
        "Tidy_Parameters"
    ];
    const LITERAL = "True False And Null Not Or Default";
    const BUILT_IN = "Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive";
    const COMMENT = {
        variants: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.COMMENT("#cs", "#ce"),
            hljs.COMMENT("#comments-start", "#comments-end")
        ]
    };
    const VARIABLE = {
        begin: "\\$[A-z0-9_]+"
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/,
                        relevance: 0
                    }
                ]
            }
        ]
    };
    const NUMBER = {
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": DIRECTIVES
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                keywords: {
                    "meta-keyword": "include"
                },
                end: "$",
                contains: [
                    STRING,
                    {
                        className: "meta-string",
                        variants: [
                            {
                                begin: "<",
                                end: ">"
                            },
                            {
                                begin: /"/,
                                end: /"/,
                                contains: [
                                    {
                                        begin: /""/,
                                        relevance: 0
                                    }
                                ]
                            },
                            {
                                begin: /'/,
                                end: /'/,
                                contains: [
                                    {
                                        begin: /''/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            STRING,
            COMMENT
        ]
    };
    const CONSTANT = {
        className: "symbol",
        // begin: '@',
        // end: '$',
        // keywords: 'AppDataCommonDir AppDataDir AutoItExe AutoItPID AutoItVersion AutoItX64 COM_EventObj CommonFilesDir Compiled ComputerName ComSpec CPUArch CR CRLF DesktopCommonDir DesktopDepth DesktopDir DesktopHeight DesktopRefresh DesktopWidth DocumentsCommonDir error exitCode exitMethod extended FavoritesCommonDir FavoritesDir GUI_CtrlHandle GUI_CtrlId GUI_DragFile GUI_DragId GUI_DropId GUI_WinHandle HomeDrive HomePath HomeShare HotKeyPressed HOUR IPAddress1 IPAddress2 IPAddress3 IPAddress4 KBLayout LF LocalAppDataDir LogonDNSDomain LogonDomain LogonServer MDAY MIN MON MSEC MUILang MyDocumentsDir NumParams OSArch OSBuild OSLang OSServicePack OSType OSVersion ProgramFilesDir ProgramsCommonDir ProgramsDir ScriptDir ScriptFullPath ScriptLineNumber ScriptName SEC StartMenuCommonDir StartMenuDir StartupCommonDir StartupDir SW_DISABLE SW_ENABLE SW_HIDE SW_LOCK SW_MAXIMIZE SW_MINIMIZE SW_RESTORE SW_SHOW SW_SHOWDEFAULT SW_SHOWMAXIMIZED SW_SHOWMINIMIZED SW_SHOWMINNOACTIVE SW_SHOWNA SW_SHOWNOACTIVATE SW_SHOWNORMAL SW_UNLOCK SystemDir TAB TempDir TRAY_ID TrayIconFlashing TrayIconVisible UserName UserProfileDir WDAY WindowsDir WorkingDir YDAY YEAR',
        // relevance: 5
        begin: "@[A-z0-9_]+"
    };
    const FUNCTION = {
        className: "function",
        beginKeywords: "Func",
        end: "$",
        illegal: "\\$|\\[|%",
        contains: [
            hljs.UNDERSCORE_TITLE_MODE,
            {
                className: "params",
                begin: "\\(",
                end: "\\)",
                contains: [
                    VARIABLE,
                    STRING,
                    NUMBER
                ]
            }
        ]
    };
    return {
        name: "AutoIt",
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: KEYWORDS,
            built_in: BUILT_IN,
            literal: LITERAL
        },
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            NUMBER,
            PREPROCESSOR,
            CONSTANT,
            FUNCTION
        ]
    };
}
module.exports = $c8df170448a9bb61$var$autoit;

});

parcelRegister("6w0Vy", function(module, exports) {
/*
Language: AVR Assembly
Author: Vladimir Ermakov <vooon341@gmail.com>
Category: assembler
Website: https://www.microchip.com/webdoc/avrassembler/avrassembler.wb_instruction_list.html
*/ /** @type LanguageFn */ function $4be67364efd9099d$var$avrasm(hljs) {
    return {
        name: "AVR Assembly",
        case_insensitive: true,
        keywords: {
            $pattern: "\\.?" + hljs.IDENT_RE,
            keyword: /* mnemonic */ "adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr",
            built_in: /* general purpose registers */ "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf",
            meta: ".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"
        },
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            hljs.C_NUMBER_MODE,
            hljs.BINARY_NUMBER_MODE,
            {
                className: "number",
                begin: "\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)" // $..., 0o...
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                illegal: "[^\\\\][^']"
            },
            {
                className: "symbol",
                begin: "^[A-Za-z0-9_.$]+:"
            },
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "subst",
                begin: "@[0-9]+"
            }
        ]
    };
}
module.exports = $4be67364efd9099d$var$avrasm;

});

parcelRegister("4FtHV", function(module, exports) {
/*
Language: Awk
Author: Matthew Daly <matthewbdaly@gmail.com>
Website: https://www.gnu.org/software/gawk/manual/gawk.html
Description: language definition for Awk scripts
*/ /** @type LanguageFn */ function $366209089835c0a5$var$awk(hljs) {
    const VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d#@][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)\}/
            }
        ]
    };
    const KEYWORDS = "BEGIN END if else while do for in break continue delete next nextfile function func exit|10";
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /(u|b)?r?'''/,
                end: /'''/,
                relevance: 10
            },
            {
                begin: /(u|b)?r?"""/,
                end: /"""/,
                relevance: 10
            },
            {
                begin: /(u|r|ur)'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /(u|r|ur)"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /(b|br)'/,
                end: /'/
            },
            {
                begin: /(b|br)"/,
                end: /"/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    return {
        name: "Awk",
        keywords: {
            keyword: KEYWORDS
        },
        contains: [
            VARIABLE,
            STRING,
            hljs.REGEXP_MODE,
            hljs.HASH_COMMENT_MODE,
            hljs.NUMBER_MODE
        ]
    };
}
module.exports = $366209089835c0a5$var$awk;

});

parcelRegister("HfSOx", function(module, exports) {
/*
Language: Microsoft X++
Description: X++ is a language used in Microsoft Dynamics 365, Dynamics AX, and Axapta.
Author: Dmitri Roudakov <dmitri@roudakov.ru>
Website: https://dynamics.microsoft.com/en-us/ax-overview/
Category: enterprise
*/ /** @type LanguageFn */ function $08205651e3353365$var$axapta(hljs) {
    const BUILT_IN_KEYWORDS = [
        "anytype",
        "boolean",
        "byte",
        "char",
        "container",
        "date",
        "double",
        "enum",
        "guid",
        "int",
        "int64",
        "long",
        "real",
        "short",
        "str",
        "utcdatetime",
        "var"
    ];
    const LITERAL_KEYWORDS = [
        "default",
        "false",
        "null",
        "true"
    ];
    const NORMAL_KEYWORDS = [
        "abstract",
        "as",
        "asc",
        "avg",
        "break",
        "breakpoint",
        "by",
        "byref",
        "case",
        "catch",
        "changecompany",
        "class",
        "client",
        "client",
        "common",
        "const",
        "continue",
        "count",
        "crosscompany",
        "delegate",
        "delete_from",
        "desc",
        "display",
        "div",
        "do",
        "edit",
        "else",
        "eventhandler",
        "exists",
        "extends",
        "final",
        "finally",
        "firstfast",
        "firstonly",
        "firstonly1",
        "firstonly10",
        "firstonly100",
        "firstonly1000",
        "flush",
        "for",
        "forceliterals",
        "forcenestedloop",
        "forceplaceholders",
        "forceselectorder",
        "forupdate",
        "from",
        "generateonly",
        "group",
        "hint",
        "if",
        "implements",
        "in",
        "index",
        "insert_recordset",
        "interface",
        "internal",
        "is",
        "join",
        "like",
        "maxof",
        "minof",
        "mod",
        "namespace",
        "new",
        "next",
        "nofetch",
        "notexists",
        "optimisticlock",
        "order",
        "outer",
        "pessimisticlock",
        "print",
        "private",
        "protected",
        "public",
        "readonly",
        "repeatableread",
        "retry",
        "return",
        "reverse",
        "select",
        "server",
        "setting",
        "static",
        "sum",
        "super",
        "switch",
        "this",
        "throw",
        "try",
        "ttsabort",
        "ttsbegin",
        "ttscommit",
        "unchecked",
        "update_recordset",
        "using",
        "validtimestate",
        "void",
        "where",
        "while"
    ];
    const KEYWORDS = {
        keyword: NORMAL_KEYWORDS,
        built_in: BUILT_IN_KEYWORDS,
        literal: LITERAL_KEYWORDS
    };
    return {
        name: "X++",
        aliases: [
            "x++"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: /\{/,
                excludeEnd: true,
                illegal: ":",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            }
        ]
    };
}
module.exports = $08205651e3353365$var$axapta;

});

parcelRegister("cheUk", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $8f02a2e67c509667$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $8f02a2e67c509667$var$concat(...args) {
    const joined = args.map((x)=>$8f02a2e67c509667$var$source(x)).join("");
    return joined;
}
/*
Language: Bash
Author: vah <vahtenberg@gmail.com>
Contributrors: Benjamin Pannell <contact@sierrasoftworks.com>
Website: https://www.gnu.org/software/bash/
Category: common
*/ /** @type LanguageFn */ function $8f02a2e67c509667$var$bash(hljs) {
    const VAR = {};
    const BRACED_VAR = {
        begin: /\$\{/,
        end: /\}/,
        contains: [
            "self",
            {
                begin: /:-/,
                contains: [
                    VAR
                ]
            } // default values
        ]
    };
    Object.assign(VAR, {
        className: "variable",
        variants: [
            {
                begin: $8f02a2e67c509667$var$concat(/\$[\w\d#@][\w\d_]*/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![\\w\\d])(?![$])`)
            },
            BRACED_VAR
        ]
    });
    const SUBST = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const HERE_DOC = {
        begin: /<<-?\s*(?=\w+)/,
        starts: {
            contains: [
                hljs.END_SAME_AS_BEGIN({
                    begin: /(\w+)/,
                    end: /(\w+)/,
                    className: "string"
                })
            ]
        }
    };
    const QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            SUBST
        ]
    };
    SUBST.contains.push(QUOTE_STRING);
    const ESCAPED_QUOTE = {
        className: "",
        begin: /\\"/
    };
    const APOS_STRING = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    const ARITHMETIC = {
        begin: /\$\(\(/,
        end: /\)\)/,
        contains: [
            {
                begin: /\d+#[0-9a-f]+/,
                className: "number"
            },
            hljs.NUMBER_MODE,
            VAR
        ]
    };
    const SH_LIKE_SHELLS = [
        "fish",
        "bash",
        "zsh",
        "sh",
        "csh",
        "ksh",
        "tcsh",
        "dash",
        "scsh"
    ];
    const KNOWN_SHEBANG = hljs.SHEBANG({
        binary: `(${SH_LIKE_SHELLS.join("|")})`,
        relevance: 10
    });
    const FUNCTION = {
        className: "function",
        begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        returnBegin: true,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /\w[\w\d_]*/
            })
        ],
        relevance: 0
    };
    return {
        name: "Bash",
        aliases: [
            "sh",
            "zsh"
        ],
        keywords: {
            $pattern: /\b[a-z._-]+\b/,
            keyword: "if then else elif fi for while in do done case esac function",
            literal: "true false",
            built_in: // Shell built-ins
            // http://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            "break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp"
        },
        contains: [
            KNOWN_SHEBANG,
            hljs.SHEBANG(),
            FUNCTION,
            ARITHMETIC,
            hljs.HASH_COMMENT_MODE,
            HERE_DOC,
            QUOTE_STRING,
            ESCAPED_QUOTE,
            APOS_STRING,
            VAR
        ]
    };
}
module.exports = $8f02a2e67c509667$var$bash;

});

parcelRegister("ahe0r", function(module, exports) {
/*
Language: BASIC
Author: Raphaël Assénat <raph@raphnet.net>
Description: Based on the BASIC reference from the Tandy 1000 guide
Website: https://en.wikipedia.org/wiki/Tandy_1000
*/ /** @type LanguageFn */ function $77b65b382a102240$var$basic(hljs) {
    return {
        name: "BASIC",
        case_insensitive: true,
        illegal: "^.",
        // Support explicitly typed variables that end with $%! or #.
        keywords: {
            $pattern: "[a-zA-Z][a-zA-Z0-9_$%!#]*",
            keyword: "ABS ASC AND ATN AUTO|0 BEEP BLOAD|10 BSAVE|10 CALL CALLS CDBL CHAIN CHDIR CHR$|10 CINT CIRCLE CLEAR CLOSE CLS COLOR COM COMMON CONT COS CSNG CSRLIN CVD CVI CVS DATA DATE$ DEFDBL DEFINT DEFSNG DEFSTR DEF|0 SEG USR DELETE DIM DRAW EDIT END ENVIRON ENVIRON$ EOF EQV ERASE ERDEV ERDEV$ ERL ERR ERROR EXP FIELD FILES FIX FOR|0 FRE GET GOSUB|10 GOTO HEX$ IF THEN ELSE|0 INKEY$ INP INPUT INPUT# INPUT$ INSTR IMP INT IOCTL IOCTL$ KEY ON OFF LIST KILL LEFT$ LEN LET LINE LLIST LOAD LOC LOCATE LOF LOG LPRINT USING LSET MERGE MID$ MKDIR MKD$ MKI$ MKS$ MOD NAME NEW NEXT NOISE NOT OCT$ ON OR PEN PLAY STRIG OPEN OPTION BASE OUT PAINT PALETTE PCOPY PEEK PMAP POINT POKE POS PRINT PRINT] PSET PRESET PUT RANDOMIZE READ REM RENUM RESET|0 RESTORE RESUME RETURN|0 RIGHT$ RMDIR RND RSET RUN SAVE SCREEN SGN SHELL SIN SOUND SPACE$ SPC SQR STEP STICK STOP STR$ STRING$ SWAP SYSTEM TAB TAN TIME$ TIMER TROFF TRON TO USR VAL VARPTR VARPTR$ VIEW WAIT WHILE WEND WIDTH WINDOW WRITE XOR"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.COMMENT("REM", "$", {
                relevance: 10
            }),
            hljs.COMMENT("'", "$", {
                relevance: 0
            }),
            {
                // Match line numbers
                className: "symbol",
                begin: "^[0-9]+ ",
                relevance: 10
            },
            {
                // Match typed numeric constants (1000, 12.34!, 1.2e5, 1.5#, 1.2D2)
                className: "number",
                begin: "\\b\\d+(\\.\\d+)?([edED]\\d+)?[#!]?",
                relevance: 0
            },
            {
                // Match hexadecimal numbers (&Hxxxx)
                className: "number",
                begin: "(&[hH][0-9a-fA-F]{1,4})"
            },
            {
                // Match octal numbers (&Oxxxxxx)
                className: "number",
                begin: "(&[oO][0-7]{1,6})"
            }
        ]
    };
}
module.exports = $77b65b382a102240$var$basic;

});

parcelRegister("MnP3I", function(module, exports) {
/*
Language: Backus–Naur Form
Website: https://en.wikipedia.org/wiki/Backus–Naur_form
Author: Oleg Efimov <efimovov@gmail.com>
*/ /** @type LanguageFn */ function $0916f677bd06a7ae$var$bnf(hljs) {
    return {
        name: "Backus\u2013Naur Form",
        contains: [
            // Attribute
            {
                className: "attribute",
                begin: /</,
                end: />/
            },
            // Specific
            {
                begin: /::=/,
                end: /$/,
                contains: [
                    {
                        begin: /</,
                        end: />/
                    },
                    // Common
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                ]
            }
        ]
    };
}
module.exports = $0916f677bd06a7ae$var$bnf;

});

parcelRegister("5IOyj", function(module, exports) {
/*
Language: Brainfuck
Author: Evgeny Stepanischev <imbolk@gmail.com>
Website: https://esolangs.org/wiki/Brainfuck
*/ /** @type LanguageFn */ function $42a8467520e9c3e0$var$brainfuck(hljs) {
    const LITERAL = {
        className: "literal",
        begin: /[+-]/,
        relevance: 0
    };
    return {
        name: "Brainfuck",
        aliases: [
            "bf"
        ],
        contains: [
            hljs.COMMENT("[^\\[\\]\\.,\\+\\-<> \r\n]", "[\\[\\]\\.,\\+\\-<> \r\n]", {
                returnEnd: true,
                relevance: 0
            }),
            {
                className: "title",
                begin: "[\\[\\]]",
                relevance: 0
            },
            {
                className: "string",
                begin: "[\\.,]",
                relevance: 0
            },
            {
                // this mode works as the only relevance counter
                begin: /(?:\+\+|--)/,
                contains: [
                    LITERAL
                ]
            },
            LITERAL
        ]
    };
}
module.exports = $42a8467520e9c3e0$var$brainfuck;

});

parcelRegister("fCRY0", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $b6044453c4b97eab$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $b6044453c4b97eab$var$lookahead(re) {
    return $b6044453c4b97eab$var$concat("(?=", re, ")");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $b6044453c4b97eab$var$optional(re) {
    return $b6044453c4b97eab$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $b6044453c4b97eab$var$concat(...args) {
    const joined = args.map((x)=>$b6044453c4b97eab$var$source(x)).join("");
    return joined;
}
/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/ /** @type LanguageFn */ function $b6044453c4b97eab$var$cPlusPlus(hljs) {
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT("//", "$", {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = "decltype\\(auto\\)";
    const NAMESPACE_RE = "[a-zA-Z_]\\w*::";
    const TEMPLATE_ARGUMENT_RE = "<[^<>]+>";
    const FUNCTION_TYPE_RE = "(" + DECLTYPE_AUTO_RE + "|" + $b6044453c4b97eab$var$optional(NAMESPACE_RE) + "[a-zA-Z_]\\w*" + $b6044453c4b97eab$var$optional(TEMPLATE_ARGUMENT_RE) + ")";
    const CPP_PRIMITIVE_TYPES = {
        className: "keyword",
        begin: "\\b[a-z\\d_]*_t\\b"
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)";
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "(u8?|U|L)?'(" + CHARACTER_ESCAPES + "|.)",
                end: "'",
                illegal: "."
            },
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                end: /\)([^()\\ ]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const TITLE_MODE = {
        className: "title",
        begin: $b6044453c4b97eab$var$optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = $b6044453c4b97eab$var$optional(NAMESPACE_RE) + hljs.IDENT_RE + "\\s*\\(";
    const COMMON_CPP_HINTS = [
        "asin",
        "atan2",
        "atan",
        "calloc",
        "ceil",
        "cosh",
        "cos",
        "exit",
        "exp",
        "fabs",
        "floor",
        "fmod",
        "fprintf",
        "fputs",
        "free",
        "frexp",
        "auto_ptr",
        "deque",
        "list",
        "queue",
        "stack",
        "vector",
        "map",
        "set",
        "pair",
        "bitset",
        "multiset",
        "multimap",
        "unordered_set",
        "fscanf",
        "future",
        "isalnum",
        "isalpha",
        "iscntrl",
        "isdigit",
        "isgraph",
        "islower",
        "isprint",
        "ispunct",
        "isspace",
        "isupper",
        "isxdigit",
        "tolower",
        "toupper",
        "labs",
        "ldexp",
        "log10",
        "log",
        "malloc",
        "realloc",
        "memchr",
        "memcmp",
        "memcpy",
        "memset",
        "modf",
        "pow",
        "printf",
        "putchar",
        "puts",
        "scanf",
        "sinh",
        "sin",
        "snprintf",
        "sprintf",
        "sqrt",
        "sscanf",
        "strcat",
        "strchr",
        "strcmp",
        "strcpy",
        "strcspn",
        "strlen",
        "strncat",
        "strncmp",
        "strncpy",
        "strpbrk",
        "strrchr",
        "strspn",
        "strstr",
        "tanh",
        "tan",
        "unordered_map",
        "unordered_multiset",
        "unordered_multimap",
        "priority_queue",
        "make_pair",
        "array",
        "shared_ptr",
        "abort",
        "terminate",
        "abs",
        "acos",
        "vfprintf",
        "vprintf",
        "vsprintf",
        "endl",
        "initializer_list",
        "unique_ptr",
        "complex",
        "imaginary",
        "std",
        "string",
        "wstring",
        "cin",
        "cout",
        "cerr",
        "clog",
        "stdin",
        "stdout",
        "stderr",
        "stringstream",
        "istringstream",
        "ostringstream"
    ];
    const CPP_KEYWORDS = {
        keyword: "int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid wchar_t short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignas alignof constexpr consteval constinit decltype concept co_await co_return co_yield requires noexcept static_assert thread_local restrict final override atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq",
        built_in: "_Bool _Complex _Imaginary",
        _relevance_hints: COMMON_CPP_HINTS,
        literal: "true false nullptr NULL"
    };
    const FUNCTION_DISPATCH = {
        className: "function.dispatch",
        relevance: 0,
        keywords: CPP_KEYWORDS,
        begin: $b6044453c4b97eab$var$concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, $b6044453c4b97eab$var$lookahead(/\s*\(/))
    };
    const EXPRESSION_CONTAINS = [
        FUNCTION_DISPATCH,
        PREPROCESSOR,
        CPP_PRIMITIVE_TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: "new throw return else",
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    "self"
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        className: "function",
        begin: "(" + FUNCTION_TYPE_RE + "[\\*&\\s]+)+" + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            // needed because we do not have look-behind on the below rule
            // to prevent it from grabbing the final : in a :: pair
            {
                begin: /::/,
                relevance: 0
            },
            // initializers
            {
                begin: /:/,
                endsWithParent: true,
                contains: [
                    STRINGS,
                    NUMBERS
                ]
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            "self",
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        name: "C++",
        aliases: [
            "cc",
            "c++",
            "h++",
            "hpp",
            "hh",
            "hxx",
            "cxx"
        ],
        keywords: CPP_KEYWORDS,
        illegal: "</",
        classNameAliases: {
            "function.dispatch": "built_in"
        },
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",
                end: ">",
                keywords: CPP_KEYWORDS,
                contains: [
                    "self",
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: CPP_KEYWORDS
            },
            {
                className: "class",
                beginKeywords: "enum class struct union",
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: CPP_KEYWORDS
        }
    };
}
/*
Language: C-like (deprecated, use C and C++ instead)
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>, Zaven Muradyan <megalivoithos@gmail.com>, Roel Deckers <admin@codingcat.nl>, Sam Wu <samsam2310@gmail.com>, Jordi Petit <jordi.petit@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, Google Inc. (David Benjamin) <davidben@google.com>
*/ /** @type LanguageFn */ function $b6044453c4b97eab$var$cLike(hljs) {
    const lang = $b6044453c4b97eab$var$cPlusPlus(hljs);
    const C_ALIASES = [
        "c",
        "h"
    ];
    const CPP_ALIASES = [
        "cc",
        "c++",
        "h++",
        "hpp",
        "hh",
        "hxx",
        "cxx"
    ];
    lang.disableAutodetect = true;
    lang.aliases = [];
    // support users only loading c-like (legacy)
    if (!hljs.getLanguage("c")) lang.aliases.push(...C_ALIASES);
    if (!hljs.getLanguage("cpp")) lang.aliases.push(...CPP_ALIASES);
    // if c and cpp are loaded after then they will reclaim these
    // aliases for themselves
    return lang;
}
module.exports = $b6044453c4b97eab$var$cLike;

});

parcelRegister("cpOKh", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $909f2ed6e31daf49$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $909f2ed6e31daf49$var$optional(re) {
    return $909f2ed6e31daf49$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $909f2ed6e31daf49$var$concat(...args) {
    const joined = args.map((x)=>$909f2ed6e31daf49$var$source(x)).join("");
    return joined;
}
/*
Language: C
Category: common, system
Website: https://en.wikipedia.org/wiki/C_(programming_language)
*/ /** @type LanguageFn */ function $909f2ed6e31daf49$var$c(hljs) {
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT("//", "$", {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = "decltype\\(auto\\)";
    const NAMESPACE_RE = "[a-zA-Z_]\\w*::";
    const TEMPLATE_ARGUMENT_RE = "<[^<>]+>";
    const FUNCTION_TYPE_RE = "(" + DECLTYPE_AUTO_RE + "|" + $909f2ed6e31daf49$var$optional(NAMESPACE_RE) + "[a-zA-Z_]\\w*" + $909f2ed6e31daf49$var$optional(TEMPLATE_ARGUMENT_RE) + ")";
    const CPP_PRIMITIVE_TYPES = {
        className: "keyword",
        begin: "\\b[a-z\\d_]*_t\\b"
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)";
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "(u8?|U|L)?'(" + CHARACTER_ESCAPES + "|.)",
                end: "'",
                illegal: "."
            },
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                end: /\)([^()\\ ]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const TITLE_MODE = {
        className: "title",
        begin: $909f2ed6e31daf49$var$optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = $909f2ed6e31daf49$var$optional(NAMESPACE_RE) + hljs.IDENT_RE + "\\s*\\(";
    const CPP_KEYWORDS = {
        keyword: "int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid wchar_t short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignas alignof constexpr consteval constinit decltype concept co_await co_return co_yield requires noexcept static_assert thread_local restrict final override atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq",
        built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr _Bool complex _Complex imaginary _Imaginary",
        literal: "true false nullptr NULL"
    };
    const EXPRESSION_CONTAINS = [
        PREPROCESSOR,
        CPP_PRIMITIVE_TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: "new throw return else",
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    "self"
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        className: "function",
        begin: "(" + FUNCTION_TYPE_RE + "[\\*&\\s]+)+" + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            "self",
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        name: "C",
        aliases: [
            "h"
        ],
        keywords: CPP_KEYWORDS,
        // Until differentiations are added between `c` and `cpp`, `c` will
        // not be auto-detected to avoid auto-detect conflicts between C and C++
        disableAutodetect: true,
        illegal: "</",
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",
                end: ">",
                keywords: CPP_KEYWORDS,
                contains: [
                    "self",
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: CPP_KEYWORDS
            },
            {
                className: "class",
                beginKeywords: "enum class struct union",
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: CPP_KEYWORDS
        }
    };
}
module.exports = $909f2ed6e31daf49$var$c;

});

parcelRegister("ixHQI", function(module, exports) {
/*
Language: C/AL
Author: Kenneth Fuglsang Christensen <kfuglsang@gmail.com>
Description: Provides highlighting of Microsoft Dynamics NAV C/AL code files
Website: https://docs.microsoft.com/en-us/dynamics-nav/programming-in-c-al
*/ /** @type LanguageFn */ function $d7fd52a291a696c8$var$cal(hljs) {
    const KEYWORDS = "div mod in and or not xor asserterror begin case do downto else end exit for if of repeat then to until while with var";
    const LITERALS = "false true";
    const COMMENT_MODES = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.COMMENT(/\{/, /\}/, {
            relevance: 0
        }),
        hljs.COMMENT(/\(\*/, /\*\)/, {
            relevance: 10
        })
    ];
    const STRING = {
        className: "string",
        begin: /'/,
        end: /'/,
        contains: [
            {
                begin: /''/
            }
        ]
    };
    const CHAR_STRING = {
        className: "string",
        begin: /(#\d+)+/
    };
    const DATE = {
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
        relevance: 0
    };
    const DBL_QUOTED_VARIABLE = {
        className: "string",
        begin: '"',
        end: '"'
    };
    const PROCEDURE = {
        className: "function",
        beginKeywords: "procedure",
        end: /[:;]/,
        keywords: "procedure|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING
                ]
            }
        ].concat(COMMENT_MODES)
    };
    const OBJECT = {
        className: "class",
        begin: "OBJECT (Table|Form|Report|Dataport|Codeunit|XMLport|MenuSuite|Page|Query) (\\d+) ([^\\r\\n]+)",
        returnBegin: true,
        contains: [
            hljs.TITLE_MODE,
            PROCEDURE
        ]
    };
    return {
        name: "C/AL",
        case_insensitive: true,
        keywords: {
            keyword: KEYWORDS,
            literal: LITERALS
        },
        illegal: /\/\*/,
        contains: [
            STRING,
            CHAR_STRING,
            DATE,
            DBL_QUOTED_VARIABLE,
            hljs.NUMBER_MODE,
            OBJECT,
            PROCEDURE
        ]
    };
}
module.exports = $d7fd52a291a696c8$var$cal;

});

parcelRegister("74F4K", function(module, exports) {
/*
Language: Cap’n Proto
Author: Oleg Efimov <efimovov@gmail.com>
Description: Cap’n Proto message definition format
Website: https://capnproto.org/capnp-tool.html
Category: protocols
*/ /** @type LanguageFn */ function $5268c4dbb97a1137$var$capnproto(hljs) {
    return {
        name: "Cap\u2019n Proto",
        aliases: [
            "capnp"
        ],
        keywords: {
            keyword: "struct enum interface union group import using const annotation extends in of on as with from fixed",
            built_in: "Void Bool Int8 Int16 Int32 Int64 UInt8 UInt16 UInt32 UInt64 Float32 Float64 Text Data AnyPointer AnyStruct Capability List",
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.HASH_COMMENT_MODE,
            {
                className: "meta",
                begin: /@0x[\w\d]{16};/,
                illegal: /\n/
            },
            {
                className: "symbol",
                begin: /@\d+\b/
            },
            {
                className: "class",
                beginKeywords: "struct enum",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            },
            {
                className: "class",
                beginKeywords: "interface",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            }
        ]
    };
}
module.exports = $5268c4dbb97a1137$var$capnproto;

});

parcelRegister("jfjbY", function(module, exports) {
/*
Language: Ceylon
Author: Lucas Werkmeister <mail@lucaswerkmeister.de>
Website: https://ceylon-lang.org
*/ /** @type LanguageFn */ function $e02e4e2d30f165b0$var$ceylon(hljs) {
    // 2.3. Identifiers and keywords
    const KEYWORDS = "assembly module package import alias class interface object given value assign void function new of extends satisfies abstracts in out return break continue throw assert dynamic if else switch case for while try catch finally then let this outer super is exists nonempty";
    // 7.4.1 Declaration Modifiers
    const DECLARATION_MODIFIERS = "shared abstract formal default actual variable late native deprecated final sealed annotation suppressWarnings small";
    // 7.4.2 Documentation
    const DOCUMENTATION = "doc by license see throws tagged";
    const SUBST = {
        className: "subst",
        excludeBegin: true,
        excludeEnd: true,
        begin: /``/,
        end: /``/,
        keywords: KEYWORDS,
        relevance: 10
    };
    const EXPRESSIONS = [
        {
            // verbatim string
            className: "string",
            begin: '"""',
            end: '"""',
            relevance: 10
        },
        {
            // string literal or template
            className: "string",
            begin: '"',
            end: '"',
            contains: [
                SUBST
            ]
        },
        {
            // character literal
            className: "string",
            begin: "'",
            end: "'"
        },
        {
            // numeric literal
            className: "number",
            begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
            relevance: 0
        }
    ];
    SUBST.contains = EXPRESSIONS;
    return {
        name: "Ceylon",
        keywords: {
            keyword: KEYWORDS + " " + DECLARATION_MODIFIERS,
            meta: DOCUMENTATION
        },
        illegal: "\\$[^01]|#[^0-9a-fA-F]",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    "self"
                ]
            }),
            {
                // compiler annotation
                className: "meta",
                begin: '@[a-z]\\w*(?::"[^"]*")?'
            }
        ].concat(EXPRESSIONS)
    };
}
module.exports = $e02e4e2d30f165b0$var$ceylon;

});

parcelRegister("bNu1a", function(module, exports) {
/*
Language: Clean
Author: Camil Staps <info@camilstaps.nl>
Category: functional
Website: http://clean.cs.ru.nl
*/ /** @type LanguageFn */ function $896b8e3d285f485d$var$clean(hljs) {
    return {
        name: "Clean",
        aliases: [
            "icl",
            "dcl"
        ],
        keywords: {
            keyword: "if let in with where case of class instance otherwise implementation definition system module from import qualified as special code inline foreign export ccall stdcall generic derive infix infixl infixr",
            built_in: "Int Real Char Bool",
            literal: "True False"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                begin: "->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>"
            }
        ]
    };
}
module.exports = $896b8e3d285f485d$var$clean;

});

parcelRegister("8Pjhc", function(module, exports) {
/*
Language: Clojure
Description: Clojure syntax (based on lisp.js)
Author: mfornos
Website: https://clojure.org
Category: lisp
*/ /** @type LanguageFn */ function $66d20a0e6007fe81$var$clojure(hljs) {
    const SYMBOLSTART = "a-zA-Z_\\-!.?+*=<>&#'";
    const SYMBOL_RE = "[" + SYMBOLSTART + "][" + SYMBOLSTART + "0-9/;:]*";
    const globals = "def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord";
    const keywords = {
        $pattern: SYMBOL_RE,
        "builtin-name": // Clojure keywords
        globals + " " + "cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem " + "quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? " + "set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? " + "class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? " + "string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . " + "inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last " + "drop-while while intern condp case reduced cycle split-at split-with repeat replicate " + "iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext " + "nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends " + "add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler " + "set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter " + "monitor-exit macroexpand macroexpand-1 for dosync and or " + "when when-not when-let comp juxt partial sequence memoize constantly complement identity assert " + "peek pop doto proxy first rest cons cast coll last butlast " + "sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import " + "refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! " + "assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger " + "bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline " + "flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking " + "assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! " + "reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! " + "new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty " + "hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list " + "disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer " + "chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate " + "unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta " + "lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"
    };
    const SIMPLE_NUMBER_RE = "[-+]?\\d+(\\.\\d+)?";
    const SYMBOL = {
        begin: SYMBOL_RE,
        relevance: 0
    };
    const NUMBER = {
        className: "number",
        begin: SIMPLE_NUMBER_RE,
        relevance: 0
    };
    const STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    const COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    const LITERAL = {
        className: "literal",
        begin: /\b(true|false|nil)\b/
    };
    const COLLECTION = {
        begin: "[\\[\\{]",
        end: "[\\]\\}]"
    };
    const HINT = {
        className: "comment",
        begin: "\\^" + SYMBOL_RE
    };
    const HINT_COL = hljs.COMMENT("\\^\\{", "\\}");
    const KEY = {
        className: "symbol",
        begin: "[:]{1,2}" + SYMBOL_RE
    };
    const LIST = {
        begin: "\\(",
        end: "\\)"
    };
    const BODY = {
        endsWithParent: true,
        relevance: 0
    };
    const NAME = {
        keywords: keywords,
        className: "name",
        begin: SYMBOL_RE,
        relevance: 0,
        starts: BODY
    };
    const DEFAULT_CONTAINS = [
        LIST,
        STRING,
        HINT,
        HINT_COL,
        COMMENT,
        KEY,
        COLLECTION,
        NUMBER,
        LITERAL,
        SYMBOL
    ];
    const GLOBAL = {
        beginKeywords: globals,
        lexemes: SYMBOL_RE,
        end: '(\\[|#|\\d|"|:|\\{|\\)|\\(|$)',
        contains: [
            {
                className: "title",
                begin: SYMBOL_RE,
                relevance: 0,
                excludeEnd: true,
                // we can only have a single title
                endsParent: true
            }
        ].concat(DEFAULT_CONTAINS)
    };
    LIST.contains = [
        hljs.COMMENT("comment", ""),
        GLOBAL,
        NAME,
        BODY
    ];
    BODY.contains = DEFAULT_CONTAINS;
    COLLECTION.contains = DEFAULT_CONTAINS;
    HINT_COL.contains = [
        COLLECTION
    ];
    return {
        name: "Clojure",
        aliases: [
            "clj"
        ],
        illegal: /\S/,
        contains: [
            LIST,
            STRING,
            HINT,
            HINT_COL,
            COMMENT,
            KEY,
            COLLECTION,
            NUMBER,
            LITERAL
        ]
    };
}
module.exports = $66d20a0e6007fe81$var$clojure;

});

parcelRegister("4GKer", function(module, exports) {
/*
Language: Clojure REPL
Description: Clojure REPL sessions
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Requires: clojure.js
Website: https://clojure.org
Category: lisp
*/ /** @type LanguageFn */ function $369ef26351aaa3e6$var$clojureRepl(hljs) {
    return {
        name: "Clojure REPL",
        contains: [
            {
                className: "meta",
                begin: /^([\w.-]+|\s*#_)?=>/,
                starts: {
                    end: /$/,
                    subLanguage: "clojure"
                }
            }
        ]
    };
}
module.exports = $369ef26351aaa3e6$var$clojureRepl;

});

parcelRegister("e8EoF", function(module, exports) {
/*
Language: CMake
Description: CMake is an open-source cross-platform system for build automation.
Author: Igor Kalnitsky <igor@kalnitsky.org>
Website: https://cmake.org
*/ /** @type LanguageFn */ function $a4b125fe2a9fab70$var$cmake(hljs) {
    return {
        name: "CMake",
        aliases: [
            "cmake.in"
        ],
        case_insensitive: true,
        keywords: {
            keyword: // scripting commands
            "break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"
        },
        contains: [
            {
                className: "variable",
                begin: /\$\{/,
                end: /\}/
            },
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE
        ]
    };
}
module.exports = $a4b125fe2a9fab70$var$cmake;

});

parcelRegister("aK6iY", function(module, exports) {
const $7d2317517b14d3e0$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $7d2317517b14d3e0$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
const $7d2317517b14d3e0$var$TYPES = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
];
const $7d2317517b14d3e0$var$ERROR_TYPES = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $7d2317517b14d3e0$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $7d2317517b14d3e0$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global" // Node.js
];
const $7d2317517b14d3e0$var$BUILT_INS = [].concat($7d2317517b14d3e0$var$BUILT_IN_GLOBALS, $7d2317517b14d3e0$var$BUILT_IN_VARIABLES, $7d2317517b14d3e0$var$TYPES, $7d2317517b14d3e0$var$ERROR_TYPES);
/*
Language: CoffeeScript
Author: Dmytrii Nagirniak <dnagir@gmail.com>
Contributors: Oleg Efimov <efimovov@gmail.com>, Cédric Néhémie <cedric.nehemie@gmail.com>
Description: CoffeeScript is a programming language that transcompiles to JavaScript. For info about language see http://coffeescript.org/
Category: common, scripting
Website: https://coffeescript.org
*/ /** @type LanguageFn */ function $7d2317517b14d3e0$var$coffeescript(hljs) {
    const COFFEE_BUILT_INS = [
        "npm",
        "print"
    ];
    const COFFEE_LITERALS = [
        "yes",
        "no",
        "on",
        "off"
    ];
    const COFFEE_KEYWORDS = [
        "then",
        "unless",
        "until",
        "loop",
        "by",
        "when",
        "and",
        "or",
        "is",
        "isnt",
        "not"
    ];
    const NOT_VALID_KEYWORDS = [
        "var",
        "const",
        "let",
        "function",
        "static"
    ];
    const excluding = (list)=>(kw)=>!list.includes(kw);
    const KEYWORDS$1 = {
        keyword: $7d2317517b14d3e0$var$KEYWORDS.concat(COFFEE_KEYWORDS).filter(excluding(NOT_VALID_KEYWORDS)),
        literal: $7d2317517b14d3e0$var$LITERALS.concat(COFFEE_LITERALS),
        built_in: $7d2317517b14d3e0$var$BUILT_INS.concat(COFFEE_BUILT_INS)
    };
    const JS_IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: KEYWORDS$1
    };
    const EXPRESSIONS = [
        hljs.BINARY_NUMBER_MODE,
        hljs.inherit(hljs.C_NUMBER_MODE, {
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            }
        }),
        {
            className: "string",
            variants: [
                {
                    begin: /'''/,
                    end: /'''/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"""/,
                    end: /"""/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                }
            ]
        },
        {
            className: "regexp",
            variants: [
                {
                    begin: "///",
                    end: "///",
                    contains: [
                        SUBST,
                        hljs.HASH_COMMENT_MODE
                    ]
                },
                {
                    begin: "//[gim]{0,3}(?=\\W)",
                    relevance: 0
                },
                {
                    // regex can't start with space to parse x / 2 / 3 as two divisions
                    // regex can't start with *, and it supports an "illegal" in the main mode
                    begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
                }
            ]
        },
        {
            begin: "@" + JS_IDENT_RE // relevance booster
        },
        {
            subLanguage: "javascript",
            excludeBegin: true,
            excludeEnd: true,
            variants: [
                {
                    begin: "```",
                    end: "```"
                },
                {
                    begin: "`",
                    end: "`"
                }
            ]
        }
    ];
    SUBST.contains = EXPRESSIONS;
    const TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    const POSSIBLE_PARAMS_RE = "(\\(.*\\)\\s*)?\\B[-=]>";
    const PARAMS = {
        className: "params",
        begin: "\\([^\\(]",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS$1,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    return {
        name: "CoffeeScript",
        aliases: [
            "coffee",
            "cson",
            "iced"
        ],
        keywords: KEYWORDS$1,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("###", "###"),
            hljs.HASH_COMMENT_MODE,
            {
                className: "function",
                begin: "^\\s*" + JS_IDENT_RE + "\\s*=\\s*" + POSSIBLE_PARAMS_RE,
                end: "[-=]>",
                returnBegin: true,
                contains: [
                    TITLE,
                    PARAMS
                ]
            },
            {
                // anonymous function start
                begin: /[:\(,=]\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "function",
                        begin: POSSIBLE_PARAMS_RE,
                        end: "[-=]>",
                        returnBegin: true,
                        contains: [
                            PARAMS
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
}
module.exports = $7d2317517b14d3e0$var$coffeescript;

});

parcelRegister("jlnGk", function(module, exports) {
/*
Language: Coq
Author: Stephan Boyer <stephan@stephanboyer.com>
Category: functional
Website: https://coq.inria.fr
*/ /** @type LanguageFn */ function $e152592c28639733$var$coq(hljs) {
    return {
        name: "Coq",
        keywords: {
            keyword: "_|0 as at cofix else end exists exists2 fix for forall fun if IF in let match mod Prop return Set then Type using where with Abort About Add Admit Admitted All Arguments Assumptions Axiom Back BackTo Backtrack Bind Blacklist Canonical Cd Check Class Classes Close Coercion Coercions CoFixpoint CoInductive Collection Combined Compute Conjecture Conjectures Constant constr Constraint Constructors Context Corollary CreateHintDb Cut Declare Defined Definition Delimit Dependencies Dependent Derive Drop eauto End Equality Eval Example Existential Existentials Existing Export exporting Extern Extract Extraction Fact Field Fields File Fixpoint Focus for From Function Functional Generalizable Global Goal Grab Grammar Graph Guarded Heap Hint HintDb Hints Hypotheses Hypothesis ident Identity If Immediate Implicit Import Include Inductive Infix Info Initial Inline Inspect Instance Instances Intro Intros Inversion Inversion_clear Language Left Lemma Let Libraries Library Load LoadPath Local Locate Ltac ML Mode Module Modules Monomorphic Morphism Next NoInline Notation Obligation Obligations Opaque Open Optimize Options Parameter Parameters Parametric Path Paths pattern Polymorphic Preterm Print Printing Program Projections Proof Proposition Pwd Qed Quit Rec Record Recursive Redirect Relation Remark Remove Require Reserved Reset Resolve Restart Rewrite Right Ring Rings Save Scheme Scope Scopes Script Search SearchAbout SearchHead SearchPattern SearchRewrite Section Separate Set Setoid Show Solve Sorted Step Strategies Strategy Structure SubClass Table Tables Tactic Term Test Theorem Time Timeout Transparent Type Typeclasses Types Undelimit Undo Unfocus Unfocused Unfold Universe Universes Unset Unshelve using Variable Variables Variant Verbose Visibility where with",
            built_in: "abstract absurd admit after apply as assert assumption at auto autorewrite autounfold before bottom btauto by case case_eq cbn cbv change classical_left classical_right clear clearbody cofix compare compute congruence constr_eq constructor contradict contradiction cut cutrewrite cycle decide decompose dependent destruct destruction dintuition discriminate discrR do double dtauto eapply eassumption eauto ecase econstructor edestruct ediscriminate eelim eexact eexists einduction einjection eleft elim elimtype enough equality erewrite eright esimplify_eq esplit evar exact exactly_once exfalso exists f_equal fail field field_simplify field_simplify_eq first firstorder fix fold fourier functional generalize generalizing gfail give_up has_evar hnf idtac in induction injection instantiate intro intro_pattern intros intuition inversion inversion_clear is_evar is_var lapply lazy left lia lra move native_compute nia nsatz omega once pattern pose progress proof psatz quote record red refine reflexivity remember rename repeat replace revert revgoals rewrite rewrite_strat right ring ring_simplify rtauto set setoid_reflexivity setoid_replace setoid_rewrite setoid_symmetry setoid_transitivity shelve shelve_unifiable simpl simple simplify_eq solve specialize split split_Rabs split_Rmult stepl stepr subst sum swap symmetry tactic tauto time timeout top transitivity trivial try tryif unfold unify until using vm_compute with"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.COMMENT("\\(\\*", "\\*\\)"),
            hljs.C_NUMBER_MODE,
            {
                className: "type",
                excludeBegin: true,
                begin: "\\|\\s*",
                end: "\\w+"
            },
            {
                begin: /[-=]>/
            }
        ]
    };
}
module.exports = $e152592c28639733$var$coq;

});

parcelRegister("dUE2d", function(module, exports) {
/*
Language: Caché Object Script
Author: Nikita Savchenko <zitros.lab@gmail.com>
Category: enterprise, scripting
Website: https://cedocs.intersystems.com/latest/csp/docbook/DocBook.UI.Page.cls
*/ /** @type LanguageFn */ function $a20f8f5d26a96e3a$var$cos(hljs) {
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""',
                        relevance: 0
                    }
                ]
            }
        ]
    };
    const NUMBERS = {
        className: "number",
        begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
        relevance: 0
    };
    const COS_KEYWORDS = "property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii";
    // registered function - no need in them due to all functions are highlighted,
    // but I'll just leave this here.
    // "$bit", "$bitcount",
    // "$bitfind", "$bitlogic", "$case", "$char", "$classmethod", "$classname",
    // "$compile", "$data", "$decimal", "$double", "$extract", "$factor",
    // "$find", "$fnumber", "$get", "$increment", "$inumber", "$isobject",
    // "$isvaliddouble", "$isvalidnum", "$justify", "$length", "$list",
    // "$listbuild", "$listdata", "$listfind", "$listfromstring", "$listget",
    // "$listlength", "$listnext", "$listsame", "$listtostring", "$listvalid",
    // "$locate", "$match", "$method", "$name", "$nconvert", "$next",
    // "$normalize", "$now", "$number", "$order", "$parameter", "$piece",
    // "$prefetchoff", "$prefetchon", "$property", "$qlength", "$qsubscript",
    // "$query", "$random", "$replace", "$reverse", "$sconvert", "$select",
    // "$sortbegin", "$sortend", "$stack", "$text", "$translate", "$view",
    // "$wascii", "$wchar", "$wextract", "$wfind", "$wiswide", "$wlength",
    // "$wreverse", "$xecute", "$zabs", "$zarccos", "$zarcsin", "$zarctan",
    // "$zcos", "$zcot", "$zcsc", "$zdate", "$zdateh", "$zdatetime",
    // "$zdatetimeh", "$zexp", "$zhex", "$zln", "$zlog", "$zpower", "$zsec",
    // "$zsin", "$zsqr", "$ztan", "$ztime", "$ztimeh", "$zboolean",
    // "$zconvert", "$zcrc", "$zcyc", "$zdascii", "$zdchar", "$zf",
    // "$ziswide", "$zlascii", "$zlchar", "$zname", "$zposition", "$zqascii",
    // "$zqchar", "$zsearch", "$zseek", "$zstrip", "$zwascii", "$zwchar",
    // "$zwidth", "$zwpack", "$zwbpack", "$zwunpack", "$zwbunpack", "$zzenkaku",
    // "$change", "$mv", "$mvat", "$mvfmt", "$mvfmts", "$mviconv",
    // "$mviconvs", "$mvinmat", "$mvlover", "$mvoconv", "$mvoconvs", "$mvraise",
    // "$mvtrans", "$mvv", "$mvname", "$zbitand", "$zbitcount", "$zbitfind",
    // "$zbitget", "$zbitlen", "$zbitnot", "$zbitor", "$zbitset", "$zbitstr",
    // "$zbitxor", "$zincrement", "$znext", "$zorder", "$zprevious", "$zsort",
    // "device", "$ecode", "$estack", "$etrap", "$halt", "$horolog",
    // "$io", "$job", "$key", "$namespace", "$principal", "$quit", "$roles",
    // "$storage", "$system", "$test", "$this", "$tlevel", "$username",
    // "$x", "$y", "$za", "$zb", "$zchild", "$zeof", "$zeos", "$zerror",
    // "$zhorolog", "$zio", "$zjob", "$zmode", "$znspace", "$zparent", "$zpi",
    // "$zpos", "$zreference", "$zstorage", "$ztimestamp", "$ztimezone",
    // "$ztrap", "$zversion"
    return {
        name: "Cach\xe9 Object Script",
        case_insensitive: true,
        aliases: [
            "cls"
        ],
        keywords: COS_KEYWORDS,
        contains: [
            NUMBERS,
            STRINGS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "comment",
                begin: /;/,
                end: "$",
                relevance: 0
            },
            {
                className: "built_in",
                begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
            },
            {
                className: "built_in",
                begin: /\$\$\$[a-zA-Z]+/
            },
            {
                className: "built_in",
                begin: /%[a-z]+(?:\.[a-z]+)*/
            },
            {
                className: "symbol",
                begin: /\^%?[a-zA-Z][\w]*/
            },
            {
                className: "keyword",
                begin: /##class|##super|#define|#dim/
            },
            // sub-languages: are not fully supported by hljs by 11/15/2015
            // left for the future implementation.
            {
                begin: /&sql\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                subLanguage: "sql"
            },
            {
                begin: /&(js|jscript|javascript)</,
                end: />/,
                excludeBegin: true,
                excludeEnd: true,
                subLanguage: "javascript"
            },
            {
                // this brakes first and last tag, but this is the only way to embed a valid html
                begin: /&html<\s*</,
                end: />\s*>/,
                subLanguage: "xml"
            }
        ]
    };
}
module.exports = $a20f8f5d26a96e3a$var$cos;

});

parcelRegister("lmzvz", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f8d7323943559e4d$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f8d7323943559e4d$var$lookahead(re) {
    return $f8d7323943559e4d$var$concat("(?=", re, ")");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f8d7323943559e4d$var$optional(re) {
    return $f8d7323943559e4d$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $f8d7323943559e4d$var$concat(...args) {
    const joined = args.map((x)=>$f8d7323943559e4d$var$source(x)).join("");
    return joined;
}
/*
Language: C++
Category: common, system
Website: https://isocpp.org
*/ /** @type LanguageFn */ function $f8d7323943559e4d$var$cpp(hljs) {
    // added for historic reasons because `hljs.C_LINE_COMMENT_MODE` does
    // not include such support nor can we be sure all the grammars depending
    // on it would desire this behavior
    const C_LINE_COMMENT_MODE = hljs.COMMENT("//", "$", {
        contains: [
            {
                begin: /\\\n/
            }
        ]
    });
    const DECLTYPE_AUTO_RE = "decltype\\(auto\\)";
    const NAMESPACE_RE = "[a-zA-Z_]\\w*::";
    const TEMPLATE_ARGUMENT_RE = "<[^<>]+>";
    const FUNCTION_TYPE_RE = "(" + DECLTYPE_AUTO_RE + "|" + $f8d7323943559e4d$var$optional(NAMESPACE_RE) + "[a-zA-Z_]\\w*" + $f8d7323943559e4d$var$optional(TEMPLATE_ARGUMENT_RE) + ")";
    const CPP_PRIMITIVE_TYPES = {
        className: "keyword",
        begin: "\\b[a-z\\d_]*_t\\b"
    };
    // https://en.cppreference.com/w/cpp/language/escape
    // \\ \x \xFF \u2837 \u00323747 \374
    const CHARACTER_ESCAPES = "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)";
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '(u8?|U|L)?"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "(u8?|U|L)?'(" + CHARACTER_ESCAPES + "|.)",
                end: "'",
                illegal: "."
            },
            hljs.END_SAME_AS_BEGIN({
                begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                end: /\)([^()\\ ]{0,16})"/
            })
        ]
    };
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<.*?>/
            },
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const TITLE_MODE = {
        className: "title",
        begin: $f8d7323943559e4d$var$optional(NAMESPACE_RE) + hljs.IDENT_RE,
        relevance: 0
    };
    const FUNCTION_TITLE = $f8d7323943559e4d$var$optional(NAMESPACE_RE) + hljs.IDENT_RE + "\\s*\\(";
    const COMMON_CPP_HINTS = [
        "asin",
        "atan2",
        "atan",
        "calloc",
        "ceil",
        "cosh",
        "cos",
        "exit",
        "exp",
        "fabs",
        "floor",
        "fmod",
        "fprintf",
        "fputs",
        "free",
        "frexp",
        "auto_ptr",
        "deque",
        "list",
        "queue",
        "stack",
        "vector",
        "map",
        "set",
        "pair",
        "bitset",
        "multiset",
        "multimap",
        "unordered_set",
        "fscanf",
        "future",
        "isalnum",
        "isalpha",
        "iscntrl",
        "isdigit",
        "isgraph",
        "islower",
        "isprint",
        "ispunct",
        "isspace",
        "isupper",
        "isxdigit",
        "tolower",
        "toupper",
        "labs",
        "ldexp",
        "log10",
        "log",
        "malloc",
        "realloc",
        "memchr",
        "memcmp",
        "memcpy",
        "memset",
        "modf",
        "pow",
        "printf",
        "putchar",
        "puts",
        "scanf",
        "sinh",
        "sin",
        "snprintf",
        "sprintf",
        "sqrt",
        "sscanf",
        "strcat",
        "strchr",
        "strcmp",
        "strcpy",
        "strcspn",
        "strlen",
        "strncat",
        "strncmp",
        "strncpy",
        "strpbrk",
        "strrchr",
        "strspn",
        "strstr",
        "tanh",
        "tan",
        "unordered_map",
        "unordered_multiset",
        "unordered_multimap",
        "priority_queue",
        "make_pair",
        "array",
        "shared_ptr",
        "abort",
        "terminate",
        "abs",
        "acos",
        "vfprintf",
        "vprintf",
        "vsprintf",
        "endl",
        "initializer_list",
        "unique_ptr",
        "complex",
        "imaginary",
        "std",
        "string",
        "wstring",
        "cin",
        "cout",
        "cerr",
        "clog",
        "stdin",
        "stdout",
        "stderr",
        "stringstream",
        "istringstream",
        "ostringstream"
    ];
    const CPP_KEYWORDS = {
        keyword: "int float while private char char8_t char16_t char32_t catch import module export virtual operator sizeof dynamic_cast|10 typedef const_cast|10 const for static_cast|10 union namespace unsigned long volatile static protected bool template mutable if public friend do goto auto void enum else break extern using asm case typeid wchar_t short reinterpret_cast|10 default double register explicit signed typename try this switch continue inline delete alignas alignof constexpr consteval constinit decltype concept co_await co_return co_yield requires noexcept static_assert thread_local restrict final override atomic_bool atomic_char atomic_schar atomic_uchar atomic_short atomic_ushort atomic_int atomic_uint atomic_long atomic_ulong atomic_llong atomic_ullong new throw return and and_eq bitand bitor compl not not_eq or or_eq xor xor_eq",
        built_in: "_Bool _Complex _Imaginary",
        _relevance_hints: COMMON_CPP_HINTS,
        literal: "true false nullptr NULL"
    };
    const FUNCTION_DISPATCH = {
        className: "function.dispatch",
        relevance: 0,
        keywords: CPP_KEYWORDS,
        begin: $f8d7323943559e4d$var$concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!while)/, hljs.IDENT_RE, $f8d7323943559e4d$var$lookahead(/\s*\(/))
    };
    const EXPRESSION_CONTAINS = [
        FUNCTION_DISPATCH,
        PREPROCESSOR,
        CPP_PRIMITIVE_TYPES,
        C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        NUMBERS,
        STRINGS
    ];
    const EXPRESSION_CONTEXT = {
        // This mode covers expression context where we can't expect a function
        // definition and shouldn't highlight anything that looks like one:
        // `return some()`, `else if()`, `(x*sum(1, 2))`
        variants: [
            {
                begin: /=/,
                end: /;/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                beginKeywords: "new throw return else",
                end: /;/
            }
        ],
        keywords: CPP_KEYWORDS,
        contains: EXPRESSION_CONTAINS.concat([
            {
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                contains: EXPRESSION_CONTAINS.concat([
                    "self"
                ]),
                relevance: 0
            }
        ]),
        relevance: 0
    };
    const FUNCTION_DECLARATION = {
        className: "function",
        begin: "(" + FUNCTION_TYPE_RE + "[\\*&\\s]+)+" + FUNCTION_TITLE,
        returnBegin: true,
        end: /[{;=]/,
        excludeEnd: true,
        keywords: CPP_KEYWORDS,
        illegal: /[^\w\s\*&:<>.]/,
        contains: [
            {
                begin: DECLTYPE_AUTO_RE,
                keywords: CPP_KEYWORDS,
                relevance: 0
            },
            {
                begin: FUNCTION_TITLE,
                returnBegin: true,
                contains: [
                    TITLE_MODE
                ],
                relevance: 0
            },
            // needed because we do not have look-behind on the below rule
            // to prevent it from grabbing the final : in a :: pair
            {
                begin: /::/,
                relevance: 0
            },
            // initializers
            {
                begin: /:/,
                endsWithParent: true,
                contains: [
                    STRINGS,
                    NUMBERS
                ]
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: CPP_KEYWORDS,
                relevance: 0,
                contains: [
                    C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    STRINGS,
                    NUMBERS,
                    CPP_PRIMITIVE_TYPES,
                    // Count matching parentheses.
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: CPP_KEYWORDS,
                        relevance: 0,
                        contains: [
                            "self",
                            C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRINGS,
                            NUMBERS,
                            CPP_PRIMITIVE_TYPES
                        ]
                    }
                ]
            },
            CPP_PRIMITIVE_TYPES,
            C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            PREPROCESSOR
        ]
    };
    return {
        name: "C++",
        aliases: [
            "cc",
            "c++",
            "h++",
            "hpp",
            "hh",
            "hxx",
            "cxx"
        ],
        keywords: CPP_KEYWORDS,
        illegal: "</",
        classNameAliases: {
            "function.dispatch": "built_in"
        },
        contains: [].concat(EXPRESSION_CONTEXT, FUNCTION_DECLARATION, FUNCTION_DISPATCH, EXPRESSION_CONTAINS, [
            PREPROCESSOR,
            {
                begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array)\\s*<",
                end: ">",
                keywords: CPP_KEYWORDS,
                contains: [
                    "self",
                    CPP_PRIMITIVE_TYPES
                ]
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: CPP_KEYWORDS
            },
            {
                className: "class",
                beginKeywords: "enum class struct union",
                end: /[{;:<>=]/,
                contains: [
                    {
                        beginKeywords: "final class struct"
                    },
                    hljs.TITLE_MODE
                ]
            }
        ]),
        exports: {
            preprocessor: PREPROCESSOR,
            strings: STRINGS,
            keywords: CPP_KEYWORDS
        }
    };
}
module.exports = $f8d7323943559e4d$var$cpp;

});

parcelRegister("6QJGt", function(module, exports) {
/*
Language: crmsh
Author: Kristoffer Gronlund <kgronlund@suse.com>
Website: http://crmsh.github.io
Description: Syntax Highlighting for the crmsh DSL
Category: config
*/ /** @type LanguageFn */ function $4fcb094f41399fbd$var$crmsh(hljs) {
    const RESOURCES = "primitive rsc_template";
    const COMMANDS = "group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";
    const PROPERTY_SETS = "property rsc_defaults op_defaults";
    const KEYWORDS = "params meta operations op rule attributes utilization";
    const OPERATORS = "read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\";
    const TYPES = "number string";
    const LITERALS = "Master Started Slave Stopped start promote demote stop monitor true false";
    return {
        name: "crmsh",
        aliases: [
            "crm",
            "pcmk"
        ],
        case_insensitive: true,
        keywords: {
            keyword: KEYWORDS + " " + OPERATORS + " " + TYPES,
            literal: LITERALS
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                beginKeywords: "node",
                starts: {
                    end: "\\s*([\\w_-]+:)?",
                    starts: {
                        className: "title",
                        end: "\\s*[\\$\\w_][\\w_-]*"
                    }
                }
            },
            {
                beginKeywords: RESOURCES,
                starts: {
                    className: "title",
                    end: "\\s*[\\$\\w_][\\w_-]*",
                    starts: {
                        end: "\\s*@?[\\w_][\\w_\\.:-]*"
                    }
                }
            },
            {
                begin: "\\b(" + COMMANDS.split(" ").join("|") + ")\\s+",
                keywords: COMMANDS,
                starts: {
                    className: "title",
                    end: "[\\$\\w_][\\w_-]*"
                }
            },
            {
                beginKeywords: PROPERTY_SETS,
                starts: {
                    className: "title",
                    end: "\\s*([\\w_-]+:)?"
                }
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "meta",
                begin: "(ocf|systemd|service|lsb):[\\w_:-]+",
                relevance: 0
            },
            {
                className: "number",
                begin: "\\b\\d+(\\.\\d+)?(ms|s|h|m)?",
                relevance: 0
            },
            {
                className: "literal",
                begin: "[-]?(infinity|inf)",
                relevance: 0
            },
            {
                className: "attr",
                begin: /([A-Za-z$_#][\w_-]+)=/,
                relevance: 0
            },
            {
                className: "tag",
                begin: "</?",
                end: "/?>",
                relevance: 0
            }
        ]
    };
}
module.exports = $4fcb094f41399fbd$var$crmsh;

});

parcelRegister("2jJYq", function(module, exports) {
/*
Language: Crystal
Author: TSUYUSATO Kitsune <make.just.on@gmail.com>
Website: https://crystal-lang.org
*/ /** @type LanguageFn */ function $1b0104838efd5124$var$crystal(hljs) {
    const INT_SUFFIX = "(_?[ui](8|16|32|64|128))?";
    const FLOAT_SUFFIX = "(_?f(32|64))?";
    const CRYSTAL_IDENT_RE = "[a-zA-Z_]\\w*[!?=]?";
    const CRYSTAL_METHOD_RE = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?";
    const CRYSTAL_PATH_RE = "[A-Za-z_]\\w*(::\\w+)*(\\?|!)?";
    const CRYSTAL_KEYWORDS = {
        $pattern: CRYSTAL_IDENT_RE,
        keyword: "abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",
        literal: "false nil true"
    };
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: CRYSTAL_KEYWORDS
    };
    const EXPANSION = {
        className: "template-variable",
        variants: [
            {
                begin: "\\{\\{",
                end: "\\}\\}"
            },
            {
                begin: "\\{%",
                end: "%\\}"
            }
        ],
        keywords: CRYSTAL_KEYWORDS
    };
    function recursiveParen(begin, end) {
        const contains = [
            {
                begin: begin,
                end: end
            }
        ];
        contains[0].contains = contains;
        return contains;
    }
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /`/,
                end: /`/
            },
            {
                begin: "%[Qwi]?\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%[Qwi]?\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%[Qwi]?\\{",
                end: /\}/,
                contains: recursiveParen(/\{/, /\}/)
            },
            {
                begin: "%[Qwi]?<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%[Qwi]?\\|",
                end: "\\|"
            },
            {
                begin: /<<-\w+$/,
                end: /^\s*\w+$/
            }
        ],
        relevance: 0
    };
    const Q_STRING = {
        className: "string",
        variants: [
            {
                begin: "%q\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%q\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%q\\{",
                end: /\}/,
                contains: recursiveParen(/\{/, /\}/)
            },
            {
                begin: "%q<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%q\\|",
                end: "\\|"
            },
            {
                begin: /<<-'\w+'$/,
                end: /^\s*\w+$/
            }
        ],
        relevance: 0
    };
    const REGEXP = {
        begin: "(?!%\\})(" + hljs.RE_STARTERS_RE + "|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*",
        keywords: "case if select unless until when while",
        contains: [
            {
                className: "regexp",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST
                ],
                variants: [
                    {
                        begin: "//[a-z]*",
                        relevance: 0
                    },
                    {
                        begin: "/(?!\\/)",
                        end: "/[a-z]*"
                    }
                ]
            }
        ],
        relevance: 0
    };
    const REGEXP2 = {
        className: "regexp",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: "%r\\(",
                end: "\\)",
                contains: recursiveParen("\\(", "\\)")
            },
            {
                begin: "%r\\[",
                end: "\\]",
                contains: recursiveParen("\\[", "\\]")
            },
            {
                begin: "%r\\{",
                end: /\}/,
                contains: recursiveParen(/\{/, /\}/)
            },
            {
                begin: "%r<",
                end: ">",
                contains: recursiveParen("<", ">")
            },
            {
                begin: "%r\\|",
                end: "\\|"
            }
        ],
        relevance: 0
    };
    const ATTRIBUTE = {
        className: "meta",
        begin: "@\\[",
        end: "\\]",
        contains: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                className: "meta-string"
            })
        ]
    };
    const CRYSTAL_DEFAULT_CONTAINS = [
        EXPANSION,
        STRING,
        Q_STRING,
        REGEXP2,
        REGEXP,
        ATTRIBUTE,
        hljs.HASH_COMMENT_MODE,
        {
            className: "class",
            beginKeywords: "class module struct",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                }),
                {
                    begin: "<"
                }
            ]
        },
        {
            className: "class",
            beginKeywords: "lib enum union",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                })
            ]
        },
        {
            beginKeywords: "annotation",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.HASH_COMMENT_MODE,
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_PATH_RE
                })
            ],
            relevance: 2
        },
        {
            className: "function",
            beginKeywords: "def",
            end: /\B\b/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_METHOD_RE,
                    endsParent: true
                })
            ]
        },
        {
            className: "function",
            beginKeywords: "fun macro",
            end: /\B\b/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: CRYSTAL_METHOD_RE,
                    endsParent: true
                })
            ],
            relevance: 2
        },
        {
            className: "symbol",
            begin: hljs.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
            relevance: 0
        },
        {
            className: "symbol",
            begin: ":",
            contains: [
                STRING,
                {
                    begin: CRYSTAL_METHOD_RE
                }
            ],
            relevance: 0
        },
        {
            className: "number",
            variants: [
                {
                    begin: "\\b0b([01_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b0o([0-7_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b0x([A-Fa-f0-9_]+)" + INT_SUFFIX
                },
                {
                    begin: "\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?" + FLOAT_SUFFIX + "(?!_)"
                },
                {
                    begin: "\\b([1-9][0-9_]*|0)" + INT_SUFFIX
                }
            ],
            relevance: 0
        }
    ];
    SUBST.contains = CRYSTAL_DEFAULT_CONTAINS;
    EXPANSION.contains = CRYSTAL_DEFAULT_CONTAINS.slice(1); // without EXPANSION
    return {
        name: "Crystal",
        aliases: [
            "cr"
        ],
        keywords: CRYSTAL_KEYWORDS,
        contains: CRYSTAL_DEFAULT_CONTAINS
    };
}
module.exports = $1b0104838efd5124$var$crystal;

});

parcelRegister("gazCZ", function(module, exports) {
/*
Language: C#
Author: Jason Diamond <jason@diamond.name>
Contributor: Nicolas LLOBERA <nllobera@gmail.com>, Pieter Vantorre <pietervantorre@gmail.com>, David Pine <david.pine@microsoft.com>
Website: https://docs.microsoft.com/en-us/dotnet/csharp/
Category: common
*/ /** @type LanguageFn */ function $bc593778e8de70a1$var$csharp(hljs) {
    const BUILT_IN_KEYWORDS = [
        "bool",
        "byte",
        "char",
        "decimal",
        "delegate",
        "double",
        "dynamic",
        "enum",
        "float",
        "int",
        "long",
        "nint",
        "nuint",
        "object",
        "sbyte",
        "short",
        "string",
        "ulong",
        "uint",
        "ushort"
    ];
    const FUNCTION_MODIFIERS = [
        "public",
        "private",
        "protected",
        "static",
        "internal",
        "protected",
        "abstract",
        "async",
        "extern",
        "override",
        "unsafe",
        "virtual",
        "new",
        "sealed",
        "partial"
    ];
    const LITERAL_KEYWORDS = [
        "default",
        "false",
        "null",
        "true"
    ];
    const NORMAL_KEYWORDS = [
        "abstract",
        "as",
        "base",
        "break",
        "case",
        "class",
        "const",
        "continue",
        "do",
        "else",
        "event",
        "explicit",
        "extern",
        "finally",
        "fixed",
        "for",
        "foreach",
        "goto",
        "if",
        "implicit",
        "in",
        "interface",
        "internal",
        "is",
        "lock",
        "namespace",
        "new",
        "operator",
        "out",
        "override",
        "params",
        "private",
        "protected",
        "public",
        "readonly",
        "record",
        "ref",
        "return",
        "sealed",
        "sizeof",
        "stackalloc",
        "static",
        "struct",
        "switch",
        "this",
        "throw",
        "try",
        "typeof",
        "unchecked",
        "unsafe",
        "using",
        "virtual",
        "void",
        "volatile",
        "while"
    ];
    const CONTEXTUAL_KEYWORDS = [
        "add",
        "alias",
        "and",
        "ascending",
        "async",
        "await",
        "by",
        "descending",
        "equals",
        "from",
        "get",
        "global",
        "group",
        "init",
        "into",
        "join",
        "let",
        "nameof",
        "not",
        "notnull",
        "on",
        "or",
        "orderby",
        "partial",
        "remove",
        "select",
        "set",
        "unmanaged",
        "value|0",
        "var",
        "when",
        "where",
        "with",
        "yield"
    ];
    const KEYWORDS = {
        keyword: NORMAL_KEYWORDS.concat(CONTEXTUAL_KEYWORDS),
        built_in: BUILT_IN_KEYWORDS,
        literal: LITERAL_KEYWORDS
    };
    const TITLE_MODE = hljs.inherit(hljs.TITLE_MODE, {
        begin: "[a-zA-Z](\\.?\\w)*"
    });
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(0b[01']+)"
            },
            {
                begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"
            },
            {
                begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
            }
        ],
        relevance: 0
    };
    const VERBATIM_STRING = {
        className: "string",
        begin: '@"',
        end: '"',
        contains: [
            {
                begin: '""'
            }
        ]
    };
    const VERBATIM_STRING_NO_LF = hljs.inherit(VERBATIM_STRING, {
        illegal: /\n/
    });
    const SUBST = {
        className: "subst",
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS
    };
    const SUBST_NO_LF = hljs.inherit(SUBST, {
        illegal: /\n/
    });
    const INTERPOLATED_STRING = {
        className: "string",
        begin: /\$"/,
        end: '"',
        illegal: /\n/,
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            hljs.BACKSLASH_ESCAPE,
            SUBST_NO_LF
        ]
    };
    const INTERPOLATED_VERBATIM_STRING = {
        className: "string",
        begin: /\$@"/,
        end: '"',
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            {
                begin: '""'
            },
            SUBST
        ]
    };
    const INTERPOLATED_VERBATIM_STRING_NO_LF = hljs.inherit(INTERPOLATED_VERBATIM_STRING, {
        illegal: /\n/,
        contains: [
            {
                begin: /\{\{/
            },
            {
                begin: /\}\}/
            },
            {
                begin: '""'
            },
            SUBST_NO_LF
        ]
    });
    SUBST.contains = [
        INTERPOLATED_VERBATIM_STRING,
        INTERPOLATED_STRING,
        VERBATIM_STRING,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.C_BLOCK_COMMENT_MODE
    ];
    SUBST_NO_LF.contains = [
        INTERPOLATED_VERBATIM_STRING_NO_LF,
        INTERPOLATED_STRING,
        VERBATIM_STRING_NO_LF,
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        NUMBERS,
        hljs.inherit(hljs.C_BLOCK_COMMENT_MODE, {
            illegal: /\n/
        })
    ];
    const STRING = {
        variants: [
            INTERPOLATED_VERBATIM_STRING,
            INTERPOLATED_STRING,
            VERBATIM_STRING,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    const GENERIC_MODIFIER = {
        begin: "<",
        end: ">",
        contains: [
            {
                beginKeywords: "in out"
            },
            TITLE_MODE
        ]
    };
    const TYPE_IDENT_RE = hljs.IDENT_RE + "(<" + hljs.IDENT_RE + "(\\s*,\\s*" + hljs.IDENT_RE + ")*>)?(\\[\\])?";
    const AT_IDENTIFIER = {
        // prevents expressions like `@class` from incorrect flagging
        // `class` as a keyword
        begin: "@" + hljs.IDENT_RE,
        relevance: 0
    };
    return {
        name: "C#",
        aliases: [
            "cs",
            "c#"
        ],
        keywords: KEYWORDS,
        illegal: /::/,
        contains: [
            hljs.COMMENT("///", "$", {
                returnBegin: true,
                contains: [
                    {
                        className: "doctag",
                        variants: [
                            {
                                begin: "///",
                                relevance: 0
                            },
                            {
                                begin: "<!--|-->"
                            },
                            {
                                begin: "</?",
                                end: ">"
                            }
                        ]
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elif endif define undef warning error line region endregion pragma checksum"
                }
            },
            STRING,
            NUMBERS,
            {
                beginKeywords: "class interface",
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:,]/,
                contains: [
                    {
                        beginKeywords: "where class"
                    },
                    TITLE_MODE,
                    GENERIC_MODIFIER,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:]/,
                contains: [
                    TITLE_MODE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                beginKeywords: "record",
                relevance: 0,
                end: /[{;=]/,
                illegal: /[^\s:]/,
                contains: [
                    TITLE_MODE,
                    GENERIC_MODIFIER,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // [Attributes("")]
                className: "meta",
                begin: "^\\s*\\[",
                excludeBegin: true,
                end: "\\]",
                excludeEnd: true,
                contains: [
                    {
                        className: "meta-string",
                        begin: /"/,
                        end: /"/
                    }
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: "new return throw await else",
                relevance: 0
            },
            {
                className: "function",
                begin: "(" + TYPE_IDENT_RE + "\\s+)+" + hljs.IDENT_RE + "\\s*(<.+>\\s*)?\\(",
                returnBegin: true,
                end: /\s*[{;=]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    // prevents these from being highlighted `title`
                    {
                        beginKeywords: FUNCTION_MODIFIERS.join(" "),
                        relevance: 0
                    },
                    {
                        begin: hljs.IDENT_RE + "\\s*(<.+>\\s*)?\\(",
                        returnBegin: true,
                        contains: [
                            hljs.TITLE_MODE,
                            GENERIC_MODIFIER
                        ],
                        relevance: 0
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            STRING,
                            NUMBERS,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            AT_IDENTIFIER
        ]
    };
}
module.exports = $bc593778e8de70a1$var$csharp;

});

parcelRegister("jrFBM", function(module, exports) {
/*
Language: CSP
Description: Content Security Policy definition highlighting
Author: Taras <oxdef@oxdef.info>
Website: https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP

vim: ts=2 sw=2 st=2
*/ /** @type LanguageFn */ function $e280d081f5b86f67$var$csp(hljs) {
    return {
        name: "CSP",
        case_insensitive: false,
        keywords: {
            $pattern: "[a-zA-Z][a-zA-Z0-9_-]*",
            keyword: "base-uri child-src connect-src default-src font-src form-action frame-ancestors frame-src img-src media-src object-src plugin-types report-uri sandbox script-src style-src"
        },
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            {
                className: "attribute",
                begin: "^Content",
                end: ":",
                excludeEnd: true
            }
        ]
    };
}
module.exports = $e280d081f5b86f67$var$csp;

});

parcelRegister("jRcsb", function(module, exports) {
const $e74ca0957779e4dc$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            className: "meta",
            begin: "!important"
        },
        HEXCOLOR: {
            className: "number",
            begin: "#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})"
        },
        ATTRIBUTE_SELECTOR_MODE: {
            className: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        }
    };
};
const $e74ca0957779e4dc$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $e74ca0957779e4dc$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $e74ca0957779e4dc$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $e74ca0957779e4dc$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $e74ca0957779e4dc$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "auto",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "border",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "clear",
    "clip",
    "clip-path",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "content",
    "counter-increment",
    "counter-reset",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-variant-ligatures",
    "font-variation-settings",
    "font-weight",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inherit",
    "initial",
    "justify-content",
    "left",
    "letter-spacing",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-bottom",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "max-height",
    "max-width",
    "min-height",
    "min-width",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-bottom",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "right",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-last",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-indent",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "white-space",
    "widows",
    "width",
    "word-break",
    "word-spacing",
    "word-wrap",
    "z-index"
].reverse();
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e74ca0957779e4dc$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $e74ca0957779e4dc$var$lookahead(re) {
    return $e74ca0957779e4dc$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $e74ca0957779e4dc$var$concat(...args) {
    const joined = args.map((x)=>$e74ca0957779e4dc$var$source(x)).join("");
    return joined;
}
/*
Language: CSS
Category: common, css
Website: https://developer.mozilla.org/en-US/docs/Web/CSS
*/ /** @type LanguageFn */ function $e74ca0957779e4dc$var$css(hljs) {
    const modes = $e74ca0957779e4dc$var$MODES(hljs);
    const FUNCTION_DISPATCH = {
        className: "built_in",
        begin: /[\w-]+(?=\()/
    };
    const VENDOR_PREFIX = {
        begin: /-(webkit|moz|ms|o)-(?=[a-z])/
    };
    const AT_MODIFIERS = "and or not only";
    const AT_PROPERTY_RE = /@-?\w[\w]*(-\w+)*/; // @-webkit-keyframes
    const IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    const STRINGS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ];
    return {
        name: "CSS",
        case_insensitive: true,
        illegal: /[=|'\$]/,
        keywords: {
            keyframePosition: "from to"
        },
        classNameAliases: {
            // for visual continuity with `tag {}` and because we
            // don't have a great class for this?
            keyframePosition: "selector-tag"
        },
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            VENDOR_PREFIX,
            // to recognize keyframe 40% etc which are outside the scope of our
            // attribute value mode
            hljs.CSS_NUMBER_MODE,
            {
                className: "selector-id",
                begin: /#[A-Za-z0-9_-]+/,
                relevance: 0
            },
            {
                className: "selector-class",
                begin: "\\." + IDENT_RE,
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "selector-pseudo",
                variants: [
                    {
                        begin: ":(" + $e74ca0957779e4dc$var$PSEUDO_CLASSES.join("|") + ")"
                    },
                    {
                        begin: "::(" + $e74ca0957779e4dc$var$PSEUDO_ELEMENTS.join("|") + ")"
                    }
                ]
            },
            // we may actually need this (12/2020)
            // { // pseudo-selector params
            //   begin: /\(/,
            //   end: /\)/,
            //   contains: [ hljs.CSS_NUMBER_MODE ]
            // },
            {
                className: "attribute",
                begin: "\\b(" + $e74ca0957779e4dc$var$ATTRIBUTES.join("|") + ")\\b"
            },
            // attribute values
            {
                begin: ":",
                end: "[;}]",
                contains: [
                    modes.HEXCOLOR,
                    modes.IMPORTANT,
                    hljs.CSS_NUMBER_MODE,
                    ...STRINGS,
                    // needed to highlight these as strings and to avoid issues with
                    // illegal characters that might be inside urls that would tigger the
                    // languages illegal stack
                    {
                        begin: /(url|data-uri)\(/,
                        end: /\)/,
                        relevance: 0,
                        keywords: {
                            built_in: "url data-uri"
                        },
                        contains: [
                            {
                                className: "string",
                                // any character other than `)` as in `url()` will be the start
                                // of a string, which ends with `)` (from the parent mode)
                                begin: /[^)]/,
                                endsWithParent: true,
                                excludeEnd: true
                            }
                        ]
                    },
                    FUNCTION_DISPATCH
                ]
            },
            {
                begin: $e74ca0957779e4dc$var$lookahead(/@/),
                end: "[{;]",
                relevance: 0,
                illegal: /:/,
                contains: [
                    {
                        className: "keyword",
                        begin: AT_PROPERTY_RE
                    },
                    {
                        begin: /\s/,
                        endsWithParent: true,
                        excludeEnd: true,
                        relevance: 0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: AT_MODIFIERS,
                            attribute: $e74ca0957779e4dc$var$MEDIA_FEATURES.join(" ")
                        },
                        contains: [
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: "attribute"
                            },
                            ...STRINGS,
                            hljs.CSS_NUMBER_MODE
                        ]
                    }
                ]
            },
            {
                className: "selector-tag",
                begin: "\\b(" + $e74ca0957779e4dc$var$TAGS.join("|") + ")\\b"
            }
        ]
    };
}
module.exports = $e74ca0957779e4dc$var$css;

});

parcelRegister("4N24D", function(module, exports) {
/*
Language: D
Author: Aleksandar Ruzicic <aleksandar@ruzicic.info>
Description: D is a language with C-like syntax and static typing. It pragmatically combines efficiency, control, and modeling power, with safety and programmer productivity.
Version: 1.0a
Website: https://dlang.org
Date: 2012-04-08
*/ /**
 * Known issues:
 *
 * - invalid hex string literals will be recognized as a double quoted strings
 *   but 'x' at the beginning of string will not be matched
 *
 * - delimited string literals are not checked for matching end delimiter
 *   (not possible to do with js regexp)
 *
 * - content of token string is colored as a string (i.e. no keyword coloring inside a token string)
 *   also, content of token string is not validated to contain only valid D tokens
 *
 * - special token sequence rule is not strictly following D grammar (anything following #line
 *   up to the end of line is matched as special token sequence)
 */ /** @type LanguageFn */ function $37cd58d1305304f1$var$d(hljs) {
    /**
   * Language keywords
   *
   * @type {Object}
   */ const D_KEYWORDS = {
        $pattern: hljs.UNDERSCORE_IDENT_RE,
        keyword: "abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",
        built_in: "bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",
        literal: "false null true"
    };
    /**
   * Number literal regexps
   *
   * @type {String}
   */ const decimal_integer_re = "(0|[1-9][\\d_]*)";
    const decimal_integer_nosus_re = "(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)";
    const binary_integer_re = "0[bB][01_]+";
    const hexadecimal_digits_re = "([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)";
    const hexadecimal_integer_re = "0[xX]" + hexadecimal_digits_re;
    const decimal_exponent_re = "([eE][+-]?" + decimal_integer_nosus_re + ")";
    const decimal_float_re = "(" + decimal_integer_nosus_re + "(\\.\\d*|" + decimal_exponent_re + ")|" + "\\d+\\." + decimal_integer_nosus_re + "|" + "\\." + decimal_integer_re + decimal_exponent_re + "?" + ")";
    const hexadecimal_float_re = "(0[xX](" + hexadecimal_digits_re + "\\." + hexadecimal_digits_re + "|" + "\\.?" + hexadecimal_digits_re + ")[pP][+-]?" + decimal_integer_nosus_re + ")";
    const integer_re = "(" + decimal_integer_re + "|" + binary_integer_re + "|" + hexadecimal_integer_re + ")";
    const float_re = "(" + hexadecimal_float_re + "|" + decimal_float_re + ")";
    /**
   * Escape sequence supported in D string and character literals
   *
   * @type {String}
   */ const escape_sequence_re = "\\\\(['\"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};"; // named character entity
    /**
   * D integer number literals
   *
   * @type {Object}
   */ const D_INTEGER_MODE = {
        className: "number",
        begin: "\\b" + integer_re + "(L|u|U|Lu|LU|uL|UL)?",
        relevance: 0
    };
    /**
   * [D_FLOAT_MODE description]
   * @type {Object}
   */ const D_FLOAT_MODE = {
        className: "number",
        begin: "\\b(" + float_re + "([fF]|L|i|[fF]i|Li)?|" + integer_re + "(i|[fF]i|Li)" + ")",
        relevance: 0
    };
    /**
   * D character literal
   *
   * @type {Object}
   */ const D_CHARACTER_MODE = {
        className: "string",
        begin: "'(" + escape_sequence_re + "|.)",
        end: "'",
        illegal: "."
    };
    /**
   * D string escape sequence
   *
   * @type {Object}
   */ const D_ESCAPE_SEQUENCE = {
        begin: escape_sequence_re,
        relevance: 0
    };
    /**
   * D double quoted string literal
   *
   * @type {Object}
   */ const D_STRING_MODE = {
        className: "string",
        begin: '"',
        contains: [
            D_ESCAPE_SEQUENCE
        ],
        end: '"[cwd]?'
    };
    /**
   * D wysiwyg and delimited string literals
   *
   * @type {Object}
   */ const D_WYSIWYG_DELIMITED_STRING_MODE = {
        className: "string",
        begin: '[rq]"',
        end: '"[cwd]?',
        relevance: 5
    };
    /**
   * D alternate wysiwyg string literal
   *
   * @type {Object}
   */ const D_ALTERNATE_WYSIWYG_STRING_MODE = {
        className: "string",
        begin: "`",
        end: "`[cwd]?"
    };
    /**
   * D hexadecimal string literal
   *
   * @type {Object}
   */ const D_HEX_STRING_MODE = {
        className: "string",
        begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
        relevance: 10
    };
    /**
   * D delimited string literal
   *
   * @type {Object}
   */ const D_TOKEN_STRING_MODE = {
        className: "string",
        begin: 'q"\\{',
        end: '\\}"'
    };
    /**
   * Hashbang support
   *
   * @type {Object}
   */ const D_HASHBANG_MODE = {
        className: "meta",
        begin: "^#!",
        end: "$",
        relevance: 5
    };
    /**
   * D special token sequence
   *
   * @type {Object}
   */ const D_SPECIAL_TOKEN_SEQUENCE_MODE = {
        className: "meta",
        begin: "#(line)",
        end: "$",
        relevance: 5
    };
    /**
   * D attributes
   *
   * @type {Object}
   */ const D_ATTRIBUTE_MODE = {
        className: "keyword",
        begin: "@[a-zA-Z_][a-zA-Z_\\d]*"
    };
    /**
   * D nesting comment
   *
   * @type {Object}
   */ const D_NESTING_COMMENT_MODE = hljs.COMMENT("\\/\\+", "\\+\\/", {
        contains: [
            "self"
        ],
        relevance: 10
    });
    return {
        name: "D",
        keywords: D_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            D_NESTING_COMMENT_MODE,
            D_HEX_STRING_MODE,
            D_STRING_MODE,
            D_WYSIWYG_DELIMITED_STRING_MODE,
            D_ALTERNATE_WYSIWYG_STRING_MODE,
            D_TOKEN_STRING_MODE,
            D_FLOAT_MODE,
            D_INTEGER_MODE,
            D_CHARACTER_MODE,
            D_HASHBANG_MODE,
            D_SPECIAL_TOKEN_SEQUENCE_MODE,
            D_ATTRIBUTE_MODE
        ]
    };
}
module.exports = $37cd58d1305304f1$var$d;

});

parcelRegister("c1rMz", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $8c0b210b1ded5289$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $8c0b210b1ded5289$var$concat(...args) {
    const joined = args.map((x)=>$8c0b210b1ded5289$var$source(x)).join("");
    return joined;
}
/*
Language: Markdown
Requires: xml.js
Author: John Crepezzi <john.crepezzi@gmail.com>
Website: https://daringfireball.net/projects/markdown/
Category: common, markup
*/ function $8c0b210b1ded5289$var$markdown(hljs) {
    const INLINE_HTML = {
        begin: /<\/?[A-Za-z_]/,
        end: ">",
        subLanguage: "xml",
        relevance: 0
    };
    const HORIZONTAL_RULE = {
        begin: "^[-\\*]{3,}",
        end: "$"
    };
    const CODE = {
        className: "code",
        variants: [
            // TODO: fix to allow these to work with sublanguage also
            {
                begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*"
            },
            {
                begin: "(~{3,})[^~](.|\\n)*?\\1~*[ ]*"
            },
            // needed to allow markdown as a sublanguage to work
            {
                begin: "```",
                end: "```+[ ]*$"
            },
            {
                begin: "~~~",
                end: "~~~+[ ]*$"
            },
            {
                begin: "`.+?`"
            },
            {
                begin: "(?=^( {4}|\\t))",
                // use contains to gobble up multiple lines to allow the block to be whatever size
                // but only have a single open/close tag vs one per line
                contains: [
                    {
                        begin: "^( {4}|\\t)",
                        end: "(\\n)$"
                    }
                ],
                relevance: 0
            }
        ]
    };
    const LIST = {
        className: "bullet",
        begin: "^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)",
        end: "\\s+",
        excludeEnd: true
    };
    const LINK_REFERENCE = {
        begin: /^\[[^\n]+\]:/,
        returnBegin: true,
        contains: [
            {
                className: "symbol",
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "link",
                begin: /:\s*/,
                end: /$/,
                excludeBegin: true
            }
        ]
    };
    const URL_SCHEME = /[A-Za-z][A-Za-z0-9+.-]*/;
    const LINK = {
        variants: [
            // too much like nested array access in so many languages
            // to have any real relevance
            {
                begin: /\[.+?\]\[.*?\]/,
                relevance: 0
            },
            // popular internet URLs
            {
                begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
                relevance: 2
            },
            {
                begin: $8c0b210b1ded5289$var$concat(/\[.+?\]\(/, URL_SCHEME, /:\/\/.*?\)/),
                relevance: 2
            },
            // relative urls
            {
                begin: /\[.+?\]\([./?&#].*?\)/,
                relevance: 1
            },
            // whatever else, lower relevance (might not be a link at all)
            {
                begin: /\[.+?\]\(.*?\)/,
                relevance: 0
            }
        ],
        returnBegin: true,
        contains: [
            {
                className: "string",
                relevance: 0,
                begin: "\\[",
                end: "\\]",
                excludeBegin: true,
                returnEnd: true
            },
            {
                className: "link",
                relevance: 0,
                begin: "\\]\\(",
                end: "\\)",
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "symbol",
                relevance: 0,
                begin: "\\]\\[",
                end: "\\]",
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
    const BOLD = {
        className: "strong",
        contains: [],
        variants: [
            {
                begin: /_{2}/,
                end: /_{2}/
            },
            {
                begin: /\*{2}/,
                end: /\*{2}/
            }
        ]
    };
    const ITALIC = {
        className: "emphasis",
        contains: [],
        variants: [
            {
                begin: /\*(?!\*)/,
                end: /\*/
            },
            {
                begin: /_(?!_)/,
                end: /_/,
                relevance: 0
            }
        ]
    };
    BOLD.contains.push(ITALIC);
    ITALIC.contains.push(BOLD);
    let CONTAINABLE = [
        INLINE_HTML,
        LINK
    ];
    BOLD.contains = BOLD.contains.concat(CONTAINABLE);
    ITALIC.contains = ITALIC.contains.concat(CONTAINABLE);
    CONTAINABLE = CONTAINABLE.concat(BOLD, ITALIC);
    const HEADER = {
        className: "section",
        variants: [
            {
                begin: "^#{1,6}",
                end: "$",
                contains: CONTAINABLE
            },
            {
                begin: "(?=^.+?\\n[=-]{2,}$)",
                contains: [
                    {
                        begin: "^[=-]*$"
                    },
                    {
                        begin: "^",
                        end: "\\n",
                        contains: CONTAINABLE
                    }
                ]
            }
        ]
    };
    const BLOCKQUOTE = {
        className: "quote",
        begin: "^>\\s+",
        contains: CONTAINABLE,
        end: "$"
    };
    return {
        name: "Markdown",
        aliases: [
            "md",
            "mkdown",
            "mkd"
        ],
        contains: [
            HEADER,
            INLINE_HTML,
            LIST,
            BOLD,
            ITALIC,
            BLOCKQUOTE,
            CODE,
            HORIZONTAL_RULE,
            LINK,
            LINK_REFERENCE
        ]
    };
}
module.exports = $8c0b210b1ded5289$var$markdown;

});

parcelRegister("iUUCy", function(module, exports) {
/*
Language: Dart
Requires: markdown.js
Author: Maxim Dikun <dikmax@gmail.com>
Description: Dart a modern, object-oriented language developed by Google. For more information see https://www.dartlang.org/
Website: https://dart.dev
Category: scripting
*/ /** @type LanguageFn */ function $dc5960abe022eb15$var$dart(hljs) {
    const SUBST = {
        className: "subst",
        variants: [
            {
                begin: "\\$[A-Za-z0-9_]+"
            }
        ]
    };
    const BRACED_SUBST = {
        className: "subst",
        variants: [
            {
                begin: /\$\{/,
                end: /\}/
            }
        ],
        keywords: "true false null this is new super"
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: "r'''",
                end: "'''"
            },
            {
                begin: 'r"""',
                end: '"""'
            },
            {
                begin: "r'",
                end: "'",
                illegal: "\\n"
            },
            {
                begin: 'r"',
                end: '"',
                illegal: "\\n"
            },
            {
                begin: "'''",
                end: "'''",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: '"""',
                end: '"""',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: "'",
                end: "'",
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            },
            {
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST,
                    BRACED_SUBST
                ]
            }
        ]
    };
    BRACED_SUBST.contains = [
        hljs.C_NUMBER_MODE,
        STRING
    ];
    const BUILT_IN_TYPES = [
        // dart:core
        "Comparable",
        "DateTime",
        "Duration",
        "Function",
        "Iterable",
        "Iterator",
        "List",
        "Map",
        "Match",
        "Object",
        "Pattern",
        "RegExp",
        "Set",
        "Stopwatch",
        "String",
        "StringBuffer",
        "StringSink",
        "Symbol",
        "Type",
        "Uri",
        "bool",
        "double",
        "int",
        "num",
        // dart:html
        "Element",
        "ElementList"
    ];
    const NULLABLE_BUILT_IN_TYPES = BUILT_IN_TYPES.map((e)=>`${e}?`);
    const KEYWORDS = {
        keyword: "abstract as assert async await break case catch class const continue covariant default deferred do dynamic else enum export extends extension external factory false final finally for Function get hide if implements import in inferface is late library mixin new null on operator part required rethrow return set show static super switch sync this throw true try typedef var void while with yield",
        built_in: BUILT_IN_TYPES.concat(NULLABLE_BUILT_IN_TYPES).concat([
            // dart:core
            "Never",
            "Null",
            "dynamic",
            "print",
            // dart:html
            "document",
            "querySelector",
            "querySelectorAll",
            "window"
        ]),
        $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
    };
    return {
        name: "Dart",
        keywords: KEYWORDS,
        contains: [
            STRING,
            hljs.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
                subLanguage: "markdown",
                relevance: 0
            }),
            hljs.COMMENT(/\/{3,} ?/, /$/, {
                contains: [
                    {
                        subLanguage: "markdown",
                        begin: ".",
                        end: "$",
                        relevance: 0
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "class interface",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            },
            {
                begin: "=>" // No markup, just a relevance booster
            }
        ]
    };
}
module.exports = $dc5960abe022eb15$var$dart;

});

parcelRegister("7Nt9h", function(module, exports) {
/*
Language: Delphi
Website: https://www.embarcadero.com/products/delphi
*/ /** @type LanguageFn */ function $5ad3b857df9d3992$var$delphi(hljs) {
    const KEYWORDS = "exports register file shl array record property for mod while set ally label uses raise not stored class safecall var interface or private static exit index inherited to else stdcall override shr asm far resourcestring finalization packed virtual out and protected library do xorwrite goto near function end div overload object unit begin string on inline repeat until destructor write message program with read initialization except default nil if case cdecl in downto threadvar of try pascal const external constructor type public then implementation finally published procedure absolute reintroduce operator as is abstract alias assembler bitpacked break continue cppdecl cvar enumerator experimental platform deprecated unimplemented dynamic export far16 forward generic helper implements interrupt iochecks local name nodefault noreturn nostackframe oldfpccall otherwise saveregisters softfloat specialize strict unaligned varargs ";
    const COMMENT_MODES = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.COMMENT(/\{/, /\}/, {
            relevance: 0
        }),
        hljs.COMMENT(/\(\*/, /\*\)/, {
            relevance: 10
        })
    ];
    const DIRECTIVE = {
        className: "meta",
        variants: [
            {
                begin: /\{\$/,
                end: /\}/
            },
            {
                begin: /\(\*\$/,
                end: /\*\)/
            }
        ]
    };
    const STRING = {
        className: "string",
        begin: /'/,
        end: /'/,
        contains: [
            {
                begin: /''/
            }
        ]
    };
    const NUMBER = {
        className: "number",
        relevance: 0,
        // Source: https://www.freepascal.org/docs-html/ref/refse6.html
        variants: [
            {
                // Hexadecimal notation, e.g., $7F.
                begin: "\\$[0-9A-Fa-f]+"
            },
            {
                // Octal notation, e.g., &42.
                begin: "&[0-7]+"
            },
            {
                // Binary notation, e.g., %1010.
                begin: "%[01]+"
            }
        ]
    };
    const CHAR_STRING = {
        className: "string",
        begin: /(#\d+)+/
    };
    const CLASS = {
        begin: hljs.IDENT_RE + "\\s*=\\s*class\\s*\\(",
        returnBegin: true,
        contains: [
            hljs.TITLE_MODE
        ]
    };
    const FUNCTION = {
        className: "function",
        beginKeywords: "function constructor destructor procedure",
        end: /[:;]/,
        keywords: "function constructor|10 destructor|10 procedure|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING,
                    DIRECTIVE
                ].concat(COMMENT_MODES)
            },
            DIRECTIVE
        ].concat(COMMENT_MODES)
    };
    return {
        name: "Delphi",
        aliases: [
            "dpr",
            "dfm",
            "pas",
            "pascal",
            "freepascal",
            "lazarus",
            "lpr",
            "lfm"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
        contains: [
            STRING,
            CHAR_STRING,
            hljs.NUMBER_MODE,
            NUMBER,
            CLASS,
            FUNCTION,
            DIRECTIVE
        ].concat(COMMENT_MODES)
    };
}
module.exports = $5ad3b857df9d3992$var$delphi;

});

parcelRegister("7CY40", function(module, exports) {
/*
Language: Diff
Description: Unified and context diff
Author: Vasily Polovnyov <vast@whiteants.net>
Website: https://www.gnu.org/software/diffutils/
Category: common
*/ /** @type LanguageFn */ function $58daac66f623a7dd$var$diff(hljs) {
    return {
        name: "Diff",
        aliases: [
            "patch"
        ],
        contains: [
            {
                className: "meta",
                relevance: 10,
                variants: [
                    {
                        begin: /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/
                    },
                    {
                        begin: /^\*\*\* +\d+,\d+ +\*\*\*\*$/
                    },
                    {
                        begin: /^--- +\d+,\d+ +----$/
                    }
                ]
            },
            {
                className: "comment",
                variants: [
                    {
                        begin: /Index: /,
                        end: /$/
                    },
                    {
                        begin: /^index/,
                        end: /$/
                    },
                    {
                        begin: /={3,}/,
                        end: /$/
                    },
                    {
                        begin: /^-{3}/,
                        end: /$/
                    },
                    {
                        begin: /^\*{3} /,
                        end: /$/
                    },
                    {
                        begin: /^\+{3}/,
                        end: /$/
                    },
                    {
                        begin: /^\*{15}$/
                    },
                    {
                        begin: /^diff --git/,
                        end: /$/
                    }
                ]
            },
            {
                className: "addition",
                begin: /^\+/,
                end: /$/
            },
            {
                className: "deletion",
                begin: /^-/,
                end: /$/
            },
            {
                className: "addition",
                begin: /^!/,
                end: /$/
            }
        ]
    };
}
module.exports = $58daac66f623a7dd$var$diff;

});

parcelRegister("hSwnX", function(module, exports) {
/*
Language: Django
Description: Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design.
Requires: xml.js
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Ilya Baryshev <baryshev@gmail.com>
Website: https://www.djangoproject.com
Category: template
*/ /** @type LanguageFn */ function $d04099e25c4cdfda$var$django(hljs) {
    const FILTER = {
        begin: /\|[A-Za-z]+:?/,
        keywords: {
            name: "truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE
        ]
    };
    return {
        name: "Django",
        aliases: [
            "jinja"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            hljs.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/),
            hljs.COMMENT(/\{#/, /#\}/),
            {
                className: "template-tag",
                begin: /\{%/,
                end: /%\}/,
                contains: [
                    {
                        className: "name",
                        begin: /\w+/,
                        keywords: {
                            name: "comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim"
                        },
                        starts: {
                            endsWithParent: true,
                            keywords: "in by as",
                            contains: [
                                FILTER
                            ],
                            relevance: 0
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{\{/,
                end: /\}\}/,
                contains: [
                    FILTER
                ]
            }
        ]
    };
}
module.exports = $d04099e25c4cdfda$var$django;

});

parcelRegister("eb8CG", function(module, exports) {
/*
Language: DNS Zone
Author: Tim Schumacher <tim@datenknoten.me>
Category: config
Website: https://en.wikipedia.org/wiki/Zone_file
*/ /** @type LanguageFn */ function $a528c818abc740e8$var$dns(hljs) {
    return {
        name: "DNS Zone",
        aliases: [
            "bind",
            "zone"
        ],
        keywords: {
            keyword: "IN A AAAA AFSDB APL CAA CDNSKEY CDS CERT CNAME DHCID DLV DNAME DNSKEY DS HIP IPSECKEY KEY KX LOC MX NAPTR NS NSEC NSEC3 NSEC3PARAM PTR RRSIG RP SIG SOA SRV SSHFP TA TKEY TLSA TSIG TXT"
        },
        contains: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "meta",
                begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
            },
            // IPv6
            {
                className: "number",
                begin: "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b"
            },
            // IPv4
            {
                className: "number",
                begin: "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b"
            },
            hljs.inherit(hljs.NUMBER_MODE, {
                begin: /\b\d+[dhwm]?/
            })
        ]
    };
}
module.exports = $a528c818abc740e8$var$dns;

});

parcelRegister("5nRkt", function(module, exports) {
/*
Language: Dockerfile
Requires: bash.js
Author: Alexis Hénaut <alexis@henaut.net>
Description: language definition for Dockerfile files
Website: https://docs.docker.com/engine/reference/builder/
Category: config
*/ /** @type LanguageFn */ function $3eb877cbeba7f6a3$var$dockerfile(hljs) {
    return {
        name: "Dockerfile",
        aliases: [
            "docker"
        ],
        case_insensitive: true,
        keywords: "from maintainer expose env arg user onbuild stopsignal",
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            {
                beginKeywords: "run cmd entrypoint volume add copy workdir label healthcheck shell",
                starts: {
                    end: /[^\\]$/,
                    subLanguage: "bash"
                }
            }
        ],
        illegal: "</"
    };
}
module.exports = $3eb877cbeba7f6a3$var$dockerfile;

});

parcelRegister("9jpnQ", function(module, exports) {
/*
Language: Batch file (DOS)
Author: Alexander Makarov <sam@rmcreative.ru>
Contributors: Anton Kochkov <anton.kochkov@gmail.com>
Website: https://en.wikipedia.org/wiki/Batch_file
*/ /** @type LanguageFn */ function $6c79941026d64500$var$dos(hljs) {
    const COMMENT = hljs.COMMENT(/^\s*@?rem\b/, /$/, {
        relevance: 10
    });
    const LABEL = {
        className: "symbol",
        begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",
        relevance: 0
    };
    return {
        name: "Batch file (DOS)",
        aliases: [
            "bat",
            "cmd"
        ],
        case_insensitive: true,
        illegal: /\/\*/,
        keywords: {
            keyword: "if else goto for in do call exit not exist errorlevel defined equ neq lss leq gtr geq",
            built_in: "prn nul lpt3 lpt2 lpt1 con com4 com3 com2 com1 aux shift cd dir echo setlocal endlocal set pause copy append assoc at attrib break cacls cd chcp chdir chkdsk chkntfs cls cmd color comp compact convert date dir diskcomp diskcopy doskey erase fs find findstr format ftype graftabl help keyb label md mkdir mode more move path pause print popd pushd promt rd recover rem rename replace restore rmdir shift sort start subst time title tree type ver verify vol ping net ipconfig taskkill xcopy ren del"
        },
        contains: [
            {
                className: "variable",
                begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
            },
            {
                className: "function",
                begin: LABEL.begin,
                end: "goto:eof",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                    }),
                    COMMENT
                ]
            },
            {
                className: "number",
                begin: "\\b\\d+",
                relevance: 0
            },
            COMMENT
        ]
    };
}
module.exports = $6c79941026d64500$var$dos;

});

parcelRegister("3ipgz", function(module, exports) {
/*
 Language: dsconfig
 Description: dsconfig batch configuration language for LDAP directory servers
 Contributors: Jacob Childress <jacobc@gmail.com>
 Category: enterprise, config
 */ /** @type LanguageFn */ function $2666a6e3d5fcab60$var$dsconfig(hljs) {
    const QUOTED_PROPERTY = {
        className: "string",
        begin: /"/,
        end: /"/
    };
    const APOS_PROPERTY = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    const UNQUOTED_PROPERTY = {
        className: "string",
        begin: /[\w\-?]+:\w+/,
        end: /\W/,
        relevance: 0
    };
    const VALUELESS_PROPERTY = {
        className: "string",
        begin: /\w+(\-\w+)*/,
        end: /(?=\W)/,
        relevance: 0
    };
    return {
        keywords: "dsconfig",
        contains: [
            {
                className: "keyword",
                begin: "^dsconfig",
                end: /\s/,
                excludeEnd: true,
                relevance: 10
            },
            {
                className: "built_in",
                begin: /(list|create|get|set|delete)-(\w+)/,
                end: /\s/,
                excludeEnd: true,
                illegal: "!@#$%^&*()",
                relevance: 10
            },
            {
                className: "built_in",
                begin: /--(\w+)/,
                end: /\s/,
                excludeEnd: true
            },
            QUOTED_PROPERTY,
            APOS_PROPERTY,
            UNQUOTED_PROPERTY,
            VALUELESS_PROPERTY,
            hljs.HASH_COMMENT_MODE
        ]
    };
}
module.exports = $2666a6e3d5fcab60$var$dsconfig;

});

parcelRegister("gntgi", function(module, exports) {
/*
Language: Device Tree
Description: *.dts files used in the Linux kernel
Author: Martin Braun <martin.braun@ettus.com>, Moritz Fischer <moritz.fischer@ettus.com>
Website: https://elinux.org/Device_Tree_Reference
Category: config
*/ /** @type LanguageFn */ function $bec57e1ce907ba5f$var$dts(hljs) {
    const STRINGS = {
        className: "string",
        variants: [
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                begin: '((u8?|U)|L)?"'
            }),
            {
                begin: '(u8?|U)?R"',
                end: '"',
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: "'\\\\?.",
                end: "'",
                illegal: "."
            }
        ]
    };
    const NUMBERS = {
        className: "number",
        variants: [
            {
                begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)"
            },
            {
                begin: hljs.C_NUMBER_RE
            }
        ],
        relevance: 0
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": "if else elif endif define undef ifdef ifndef"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                end: "$",
                keywords: {
                    "meta-keyword": "include"
                },
                contains: [
                    hljs.inherit(STRINGS, {
                        className: "meta-string"
                    }),
                    {
                        className: "meta-string",
                        begin: "<",
                        end: ">",
                        illegal: "\\n"
                    }
                ]
            },
            STRINGS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    const DTS_REFERENCE = {
        className: "variable",
        begin: /&[a-z\d_]*\b/
    };
    const DTS_KEYWORD = {
        className: "meta-keyword",
        begin: "/[a-z][a-z\\d-]*/"
    };
    const DTS_LABEL = {
        className: "symbol",
        begin: "^\\s*[a-zA-Z_][a-zA-Z\\d_]*:"
    };
    const DTS_CELL_PROPERTY = {
        className: "params",
        begin: "<",
        end: ">",
        contains: [
            NUMBERS,
            DTS_REFERENCE
        ]
    };
    const DTS_NODE = {
        className: "class",
        begin: /[a-zA-Z_][a-zA-Z\d_@]*\s\{/,
        end: /[{;=]/,
        returnBegin: true,
        excludeEnd: true
    };
    const DTS_ROOT_NODE = {
        className: "class",
        begin: "/\\s*\\{",
        end: /\};/,
        relevance: 10,
        contains: [
            DTS_REFERENCE,
            DTS_KEYWORD,
            DTS_LABEL,
            DTS_NODE,
            DTS_CELL_PROPERTY,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            STRINGS
        ]
    };
    return {
        name: "Device Tree",
        keywords: "",
        contains: [
            DTS_ROOT_NODE,
            DTS_REFERENCE,
            DTS_KEYWORD,
            DTS_LABEL,
            DTS_NODE,
            DTS_CELL_PROPERTY,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            STRINGS,
            PREPROCESSOR,
            {
                begin: hljs.IDENT_RE + "::",
                keywords: ""
            }
        ]
    };
}
module.exports = $bec57e1ce907ba5f$var$dts;

});

parcelRegister("4CIEe", function(module, exports) {
/*
Language: Dust
Requires: xml.js
Author: Michael Allen <michael.allen@benefitfocus.com>
Description: Matcher for dust.js templates.
Website: https://www.dustjs.com
Category: template
*/ /** @type LanguageFn */ function $35dd583077425f5f$var$dust(hljs) {
    const EXPRESSION_KEYWORDS = "if eq ne lt lte gt gte select default math sep";
    return {
        name: "Dust",
        aliases: [
            "dst"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            {
                className: "template-tag",
                begin: /\{[#\/]/,
                end: /\}/,
                illegal: /;/,
                contains: [
                    {
                        className: "name",
                        begin: /[a-zA-Z\.-]+/,
                        starts: {
                            endsWithParent: true,
                            relevance: 0,
                            contains: [
                                hljs.QUOTE_STRING_MODE
                            ]
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{/,
                end: /\}/,
                illegal: /;/,
                keywords: EXPRESSION_KEYWORDS
            }
        ]
    };
}
module.exports = $35dd583077425f5f$var$dust;

});

parcelRegister("ahRAo", function(module, exports) {
/*
Language: Extended Backus-Naur Form
Author: Alex McKibben <alex@nullscope.net>
Website: https://en.wikipedia.org/wiki/Extended_Backus–Naur_form
*/ /** @type LanguageFn */ function $77d50ef6af757558$var$ebnf(hljs) {
    const commentMode = hljs.COMMENT(/\(\*/, /\*\)/);
    const nonTerminalMode = {
        className: "attribute",
        begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
    };
    const specialSequenceMode = {
        className: "meta",
        begin: /\?.*\?/
    };
    const ruleBodyMode = {
        begin: /=/,
        end: /[.;]/,
        contains: [
            commentMode,
            specialSequenceMode,
            {
                // terminals
                className: "string",
                variants: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    {
                        begin: "`",
                        end: "`"
                    }
                ]
            }
        ]
    };
    return {
        name: "Extended Backus-Naur Form",
        illegal: /\S/,
        contains: [
            commentMode,
            nonTerminalMode,
            ruleBodyMode
        ]
    };
}
module.exports = $77d50ef6af757558$var$ebnf;

});

parcelRegister("b2fxC", function(module, exports) {
/*
Language: Elixir
Author: Josh Adams <josh@isotope11.com>
Description: language definition for Elixir source code files (.ex and .exs).  Based on ruby language support.
Category: functional
Website: https://elixir-lang.org
*/ /** @type LanguageFn */ function $808befc3ed45988d$var$elixir(hljs) {
    const ELIXIR_IDENT_RE = "[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?";
    const ELIXIR_METHOD_RE = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?";
    const ELIXIR_KEYWORDS = {
        $pattern: ELIXIR_IDENT_RE,
        keyword: "and false then defined module in return redo retry end for true self when next until do begin unless nil break not case cond alias while ensure or include use alias fn quote require import with|0"
    };
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: ELIXIR_KEYWORDS
    };
    const NUMBER = {
        className: "number",
        begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[1-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",
        relevance: 0
    };
    const SIGIL_DELIMITERS = "[/|([{<\"']";
    const LOWERCASE_SIGIL = {
        className: "string",
        begin: "~[a-z](?=" + SIGIL_DELIMITERS + ")",
        contains: [
            {
                endsParent: true,
                contains: [
                    {
                        contains: [
                            hljs.BACKSLASH_ESCAPE,
                            SUBST
                        ],
                        variants: [
                            {
                                begin: /"/,
                                end: /"/
                            },
                            {
                                begin: /'/,
                                end: /'/
                            },
                            {
                                begin: /\//,
                                end: /\//
                            },
                            {
                                begin: /\|/,
                                end: /\|/
                            },
                            {
                                begin: /\(/,
                                end: /\)/
                            },
                            {
                                begin: /\[/,
                                end: /\]/
                            },
                            {
                                begin: /\{/,
                                end: /\}/
                            },
                            {
                                begin: /</,
                                end: />/
                            }
                        ]
                    }
                ]
            }
        ]
    };
    const UPCASE_SIGIL = {
        className: "string",
        begin: "~[A-Z](?=" + SIGIL_DELIMITERS + ")",
        contains: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /\//,
                end: /\//
            },
            {
                begin: /\|/,
                end: /\|/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                begin: /\[/,
                end: /\]/
            },
            {
                begin: /\{/,
                end: /\}/
            },
            {
                begin: /</,
                end: />/
            }
        ]
    };
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /"""/,
                end: /"""/
            },
            {
                begin: /'''/,
                end: /'''/
            },
            {
                begin: /~S"""/,
                end: /"""/,
                contains: [] // override default
            },
            {
                begin: /~S"/,
                end: /"/,
                contains: [] // override default
            },
            {
                begin: /~S'''/,
                end: /'''/,
                contains: [] // override default
            },
            {
                begin: /~S'/,
                end: /'/,
                contains: [] // override default
            },
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            }
        ]
    };
    const FUNCTION = {
        className: "function",
        beginKeywords: "def defp defmacro",
        end: /\B\b/,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: ELIXIR_IDENT_RE,
                endsParent: true
            })
        ]
    };
    const CLASS = hljs.inherit(FUNCTION, {
        className: "class",
        beginKeywords: "defimpl defmodule defprotocol defrecord",
        end: /\bdo\b|$|;/
    });
    const ELIXIR_DEFAULT_CONTAINS = [
        STRING,
        UPCASE_SIGIL,
        LOWERCASE_SIGIL,
        hljs.HASH_COMMENT_MODE,
        CLASS,
        FUNCTION,
        {
            begin: "::"
        },
        {
            className: "symbol",
            begin: ":(?![\\s:])",
            contains: [
                STRING,
                {
                    begin: ELIXIR_METHOD_RE
                }
            ],
            relevance: 0
        },
        {
            className: "symbol",
            begin: ELIXIR_IDENT_RE + ":(?!:)",
            relevance: 0
        },
        NUMBER,
        {
            className: "variable",
            begin: "(\\$\\W)|((\\$|@@?)(\\w+))"
        },
        {
            begin: "->"
        },
        {
            begin: "(" + hljs.RE_STARTERS_RE + ")\\s*",
            contains: [
                hljs.HASH_COMMENT_MODE,
                {
                    // to prevent false regex triggers for the division function:
                    // /:
                    begin: /\/: (?=\d+\s*[,\]])/,
                    relevance: 0,
                    contains: [
                        NUMBER
                    ]
                },
                {
                    className: "regexp",
                    illegal: "\\n",
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ],
                    variants: [
                        {
                            begin: "/",
                            end: "/[a-z]*"
                        },
                        {
                            begin: "%r\\[",
                            end: "\\][a-z]*"
                        }
                    ]
                }
            ],
            relevance: 0
        }
    ];
    SUBST.contains = ELIXIR_DEFAULT_CONTAINS;
    return {
        name: "Elixir",
        keywords: ELIXIR_KEYWORDS,
        contains: ELIXIR_DEFAULT_CONTAINS
    };
}
module.exports = $808befc3ed45988d$var$elixir;

});

parcelRegister("j8dfG", function(module, exports) {
/*
Language: Elm
Author: Janis Voigtlaender <janis.voigtlaender@gmail.com>
Website: https://elm-lang.org
Category: functional
*/ /** @type LanguageFn */ function $ded90b371b6c0535$var$elm(hljs) {
    const COMMENT = {
        variants: [
            hljs.COMMENT("--", "$"),
            hljs.COMMENT(/\{-/, /-\}/, {
                contains: [
                    "self"
                ]
            })
        ]
    };
    const CONSTRUCTOR = {
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
    };
    const LIST = {
        begin: "\\(",
        end: "\\)",
        illegal: '"',
        contains: [
            {
                className: "type",
                begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
            },
            COMMENT
        ]
    };
    const RECORD = {
        begin: /\{/,
        end: /\}/,
        contains: LIST.contains
    };
    const CHARACTER = {
        className: "string",
        begin: "'\\\\?.",
        end: "'",
        illegal: "."
    };
    return {
        name: "Elm",
        keywords: "let in if then else case of where module import exposing type alias as infix infixl infixr port effect command subscription",
        contains: [
            // Top-level constructions.
            {
                beginKeywords: "port effect module",
                end: "exposing",
                keywords: "port effect module where command subscription exposing",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "import",
                end: "$",
                keywords: "import as exposing",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "type",
                end: "$",
                keywords: "type alias",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    RECORD,
                    COMMENT
                ]
            },
            {
                beginKeywords: "infix infixl infixr",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE,
                    COMMENT
                ]
            },
            {
                begin: "port",
                end: "$",
                keywords: "port",
                contains: [
                    COMMENT
                ]
            },
            // Literals and names.
            CHARACTER,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            CONSTRUCTOR,
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "^[_a-z][\\w']*"
            }),
            COMMENT,
            {
                begin: "->|<-"
            } // No markup, relevance booster
        ],
        illegal: /;/
    };
}
module.exports = $ded90b371b6c0535$var$elm;

});

parcelRegister("6ykfy", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4c55a0441f08d366$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $4c55a0441f08d366$var$lookahead(re) {
    return $4c55a0441f08d366$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $4c55a0441f08d366$var$concat(...args) {
    const joined = args.map((x)=>$4c55a0441f08d366$var$source(x)).join("");
    return joined;
}
/*
Language: Ruby
Description: Ruby is a dynamic, open source programming language with a focus on simplicity and productivity.
Website: https://www.ruby-lang.org/
Author: Anton Kovalyov <anton@kovalyov.net>
Contributors: Peter Leonov <gojpeg@yandex.ru>, Vasily Polovnyov <vast@whiteants.net>, Loren Segal <lsegal@soen.ca>, Pascal Hurni <phi@ruby-reactive.org>, Cedric Sohrauer <sohrauer@googlemail.com>
Category: common
*/ function $4c55a0441f08d366$var$ruby(hljs) {
    const RUBY_METHOD_RE = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)";
    const RUBY_KEYWORDS = {
        keyword: "and then defined module in return redo if BEGIN retry end for self when next until do begin unless END rescue else break undef not super class case require yield alias while ensure elsif or include attr_reader attr_writer attr_accessor __FILE__",
        built_in: "proc lambda",
        literal: "true false nil"
    };
    const YARDOCTAG = {
        className: "doctag",
        begin: "@[A-Za-z]+"
    };
    const IRB_OBJECT = {
        begin: "#<",
        end: ">"
    };
    const COMMENT_MODES = [
        hljs.COMMENT("#", "$", {
            contains: [
                YARDOCTAG
            ]
        }),
        hljs.COMMENT("^=begin", "^=end", {
            contains: [
                YARDOCTAG
            ],
            relevance: 10
        }),
        hljs.COMMENT("^__END__", "\\n$")
    ];
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: RUBY_KEYWORDS
    };
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /`/,
                end: /`/
            },
            {
                begin: /%[qQwWx]?\(/,
                end: /\)/
            },
            {
                begin: /%[qQwWx]?\[/,
                end: /\]/
            },
            {
                begin: /%[qQwWx]?\{/,
                end: /\}/
            },
            {
                begin: /%[qQwWx]?</,
                end: />/
            },
            {
                begin: /%[qQwWx]?\//,
                end: /\//
            },
            {
                begin: /%[qQwWx]?%/,
                end: /%/
            },
            {
                begin: /%[qQwWx]?-/,
                end: /-/
            },
            {
                begin: /%[qQwWx]?\|/,
                end: /\|/
            },
            // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
            // where ? is the last character of a preceding identifier, as in: `func?4`
            {
                begin: /\B\?(\\\d{1,3})/
            },
            {
                begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/
            },
            {
                begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/
            },
            {
                begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/
            },
            {
                begin: /\B\?\\(c|C-)[\x20-\x7e]/
            },
            {
                begin: /\B\?\\?\S/
            },
            {
                begin: /<<[-~]?'?(\w+)\n(?:[^\n]*\n)*?\s*\1\b/,
                returnBegin: true,
                contains: [
                    {
                        begin: /<<[-~]?'?/
                    },
                    hljs.END_SAME_AS_BEGIN({
                        begin: /(\w+)/,
                        end: /(\w+)/,
                        contains: [
                            hljs.BACKSLASH_ESCAPE,
                            SUBST
                        ]
                    })
                ]
            }
        ]
    };
    // Ruby syntax is underdocumented, but this grammar seems to be accurate
    // as of version 2.7.2 (confirmed with (irb and `Ripper.sexp(...)`)
    // https://docs.ruby-lang.org/en/2.7.0/doc/syntax/literals_rdoc.html#label-Numbers
    const decimal = "[1-9](_?[0-9])*|0";
    const digits = "[0-9](_?[0-9])*";
    const NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            // decimal integer/float, optionally exponential or rational, optionally imaginary
            {
                begin: `\\b(${decimal})(\\.(${digits}))?([eE][+-]?(${digits})|r)?i?\\b`
            },
            // explicit decimal/binary/octal/hexadecimal integer,
            // optionally rational and/or imaginary
            {
                begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b"
            },
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b"
            },
            // 0-prefixed implicit octal integer, optionally rational and/or imaginary
            {
                begin: "\\b0(_?[0-7])+r?i?\\b"
            }
        ]
    };
    const PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        endsParent: true,
        keywords: RUBY_KEYWORDS
    };
    const RUBY_DEFAULT_CONTAINS = [
        STRING,
        {
            className: "class",
            beginKeywords: "class module",
            end: "$|;",
            illegal: /=/,
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: "[A-Za-z_]\\w*(::\\w+)*(\\?|!)?"
                }),
                {
                    begin: "<\\s*",
                    contains: [
                        {
                            begin: "(" + hljs.IDENT_RE + "::)?" + hljs.IDENT_RE,
                            // we already get points for <, we don't need poitns
                            // for the name also
                            relevance: 0
                        }
                    ]
                }
            ].concat(COMMENT_MODES)
        },
        {
            className: "function",
            // def method_name(
            // def method_name;
            // def method_name (end of line)
            begin: $4c55a0441f08d366$var$concat(/def\s+/, $4c55a0441f08d366$var$lookahead(RUBY_METHOD_RE + "\\s*(\\(|;|$)")),
            relevance: 0,
            keywords: "def",
            end: "$|;",
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: RUBY_METHOD_RE
                }),
                PARAMS
            ].concat(COMMENT_MODES)
        },
        {
            // swallow namespace qualifiers before symbols
            begin: hljs.IDENT_RE + "::"
        },
        {
            className: "symbol",
            begin: hljs.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
            relevance: 0
        },
        {
            className: "symbol",
            begin: ":(?!\\s)",
            contains: [
                STRING,
                {
                    begin: RUBY_METHOD_RE
                }
            ],
            relevance: 0
        },
        NUMBER,
        {
            // negative-look forward attemps to prevent false matches like:
            // @ident@ or $ident$ that might indicate this is not ruby at all
            className: "variable",
            begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])" + `(?![A-Za-z])(?![@$?'])`
        },
        {
            className: "params",
            begin: /\|/,
            end: /\|/,
            relevance: 0,
            keywords: RUBY_KEYWORDS
        },
        {
            begin: "(" + hljs.RE_STARTERS_RE + "|unless)\\s*",
            keywords: "unless",
            contains: [
                {
                    className: "regexp",
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ],
                    illegal: /\n/,
                    variants: [
                        {
                            begin: "/",
                            end: "/[a-z]*"
                        },
                        {
                            begin: /%r\{/,
                            end: /\}[a-z]*/
                        },
                        {
                            begin: "%r\\(",
                            end: "\\)[a-z]*"
                        },
                        {
                            begin: "%r!",
                            end: "![a-z]*"
                        },
                        {
                            begin: "%r\\[",
                            end: "\\][a-z]*"
                        }
                    ]
                }
            ].concat(IRB_OBJECT, COMMENT_MODES),
            relevance: 0
        }
    ].concat(IRB_OBJECT, COMMENT_MODES);
    SUBST.contains = RUBY_DEFAULT_CONTAINS;
    PARAMS.contains = RUBY_DEFAULT_CONTAINS;
    // >>
    // ?>
    const SIMPLE_PROMPT = "[>?]>";
    // irb(main):001:0>
    const DEFAULT_PROMPT = "[\\w#]+\\(\\w+\\):\\d+:\\d+>";
    const RVM_PROMPT = "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>";
    const IRB_DEFAULT = [
        {
            begin: /^\s*=>/,
            starts: {
                end: "$",
                contains: RUBY_DEFAULT_CONTAINS
            }
        },
        {
            className: "meta",
            begin: "^(" + SIMPLE_PROMPT + "|" + DEFAULT_PROMPT + "|" + RVM_PROMPT + ")(?=[ ])",
            starts: {
                end: "$",
                contains: RUBY_DEFAULT_CONTAINS
            }
        }
    ];
    COMMENT_MODES.unshift(IRB_OBJECT);
    return {
        name: "Ruby",
        aliases: [
            "rb",
            "gemspec",
            "podspec",
            "thor",
            "irb"
        ],
        keywords: RUBY_KEYWORDS,
        illegal: /\/\*/,
        contains: [
            hljs.SHEBANG({
                binary: "ruby"
            })
        ].concat(IRB_DEFAULT).concat(COMMENT_MODES).concat(RUBY_DEFAULT_CONTAINS)
    };
}
module.exports = $4c55a0441f08d366$var$ruby;

});

parcelRegister("dliKk", function(module, exports) {
/*
Language: ERB (Embedded Ruby)
Requires: xml.js, ruby.js
Author: Lucas Mazza <lucastmazza@gmail.com>
Contributors: Kassio Borges <kassioborgesm@gmail.com>
Description: "Bridge" language defining fragments of Ruby in HTML within <% .. %>
Website: https://ruby-doc.org/stdlib-2.6.5/libdoc/erb/rdoc/ERB.html
Category: template
*/ /** @type LanguageFn */ function $9b6bc7294966f76b$var$erb(hljs) {
    return {
        name: "ERB",
        subLanguage: "xml",
        contains: [
            hljs.COMMENT("<%#", "%>"),
            {
                begin: "<%[%=-]?",
                end: "[%-]?%>",
                subLanguage: "ruby",
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
}
module.exports = $9b6bc7294966f76b$var$erb;

});

parcelRegister("ldUmx", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f736884cb53162cd$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $f736884cb53162cd$var$concat(...args) {
    const joined = args.map((x)=>$f736884cb53162cd$var$source(x)).join("");
    return joined;
}
/*
Language: Erlang REPL
Author: Sergey Ignatov <sergey@ignatov.spb.su>
Website: https://www.erlang.org
Category: functional
*/ /** @type LanguageFn */ function $f736884cb53162cd$var$erlangRepl(hljs) {
    return {
        name: "Erlang REPL",
        keywords: {
            built_in: "spawn spawn_link self",
            keyword: "after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"
        },
        contains: [
            {
                className: "meta",
                begin: "^[0-9]+> ",
                relevance: 10
            },
            hljs.COMMENT("%", "$"),
            {
                className: "number",
                begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
                relevance: 0
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                begin: $f736884cb53162cd$var$concat(/\?(::)?/, /([A-Z]\w*)/, /((::)[A-Z]\w*)*/ // perhaps more
                )
            },
            {
                begin: "->"
            },
            {
                begin: "ok"
            },
            {
                begin: "!"
            },
            {
                begin: "(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",
                relevance: 0
            },
            {
                begin: "[A-Z][a-zA-Z0-9_']*",
                relevance: 0
            }
        ]
    };
}
module.exports = $f736884cb53162cd$var$erlangRepl;

});

parcelRegister("lpGxw", function(module, exports) {
/*
Language: Erlang
Description: Erlang is a general-purpose functional language, with strict evaluation, single assignment, and dynamic typing.
Author: Nikolay Zakharov <nikolay.desh@gmail.com>, Dmitry Kovega <arhibot@gmail.com>
Website: https://www.erlang.org
Category: functional
*/ /** @type LanguageFn */ function $f96cee4832436c1a$var$erlang(hljs) {
    const BASIC_ATOM_RE = "[a-z'][a-zA-Z0-9_']*";
    const FUNCTION_NAME_RE = "(" + BASIC_ATOM_RE + ":" + BASIC_ATOM_RE + "|" + BASIC_ATOM_RE + ")";
    const ERLANG_RESERVED = {
        keyword: "after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor",
        literal: "false true"
    };
    const COMMENT = hljs.COMMENT("%", "$");
    const NUMBER = {
        className: "number",
        begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
        relevance: 0
    };
    const NAMED_FUN = {
        begin: "fun\\s+" + BASIC_ATOM_RE + "/\\d+"
    };
    const FUNCTION_CALL = {
        begin: FUNCTION_NAME_RE + "\\(",
        end: "\\)",
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                begin: FUNCTION_NAME_RE,
                relevance: 0
            },
            {
                begin: "\\(",
                end: "\\)",
                endsWithParent: true,
                returnEnd: true,
                relevance: 0
            }
        ]
    };
    const TUPLE = {
        begin: /\{/,
        end: /\}/,
        relevance: 0
    };
    const VAR1 = {
        begin: "\\b_([A-Z][A-Za-z0-9_]*)?",
        relevance: 0
    };
    const VAR2 = {
        begin: "[A-Z][a-zA-Z0-9_]*",
        relevance: 0
    };
    const RECORD_ACCESS = {
        begin: "#" + hljs.UNDERSCORE_IDENT_RE,
        relevance: 0,
        returnBegin: true,
        contains: [
            {
                begin: "#" + hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            },
            {
                begin: /\{/,
                end: /\}/,
                relevance: 0
            }
        ]
    };
    const BLOCK_STATEMENTS = {
        beginKeywords: "fun receive if try case",
        end: "end",
        keywords: ERLANG_RESERVED
    };
    BLOCK_STATEMENTS.contains = [
        COMMENT,
        NAMED_FUN,
        hljs.inherit(hljs.APOS_STRING_MODE, {
            className: ""
        }),
        BLOCK_STATEMENTS,
        FUNCTION_CALL,
        hljs.QUOTE_STRING_MODE,
        NUMBER,
        TUPLE,
        VAR1,
        VAR2,
        RECORD_ACCESS
    ];
    const BASIC_MODES = [
        COMMENT,
        NAMED_FUN,
        BLOCK_STATEMENTS,
        FUNCTION_CALL,
        hljs.QUOTE_STRING_MODE,
        NUMBER,
        TUPLE,
        VAR1,
        VAR2,
        RECORD_ACCESS
    ];
    FUNCTION_CALL.contains[1].contains = BASIC_MODES;
    TUPLE.contains = BASIC_MODES;
    RECORD_ACCESS.contains[1].contains = BASIC_MODES;
    const DIRECTIVES = [
        "-module",
        "-record",
        "-undef",
        "-export",
        "-ifdef",
        "-ifndef",
        "-author",
        "-copyright",
        "-doc",
        "-vsn",
        "-import",
        "-include",
        "-include_lib",
        "-compile",
        "-define",
        "-else",
        "-endif",
        "-file",
        "-behaviour",
        "-behavior",
        "-spec"
    ];
    const PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: BASIC_MODES
    };
    return {
        name: "Erlang",
        aliases: [
            "erl"
        ],
        keywords: ERLANG_RESERVED,
        illegal: "(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",
        contains: [
            {
                className: "function",
                begin: "^" + BASIC_ATOM_RE + "\\s*\\(",
                end: "->",
                returnBegin: true,
                illegal: "\\(|#|//|/\\*|\\\\|:|;",
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: BASIC_ATOM_RE
                    })
                ],
                starts: {
                    end: ";|\\.",
                    keywords: ERLANG_RESERVED,
                    contains: BASIC_MODES
                }
            },
            COMMENT,
            {
                begin: "^-",
                end: "\\.",
                relevance: 0,
                excludeEnd: true,
                returnBegin: true,
                keywords: {
                    $pattern: "-" + hljs.IDENT_RE,
                    keyword: DIRECTIVES.map((x)=>`${x}|1.5`).join(" ")
                },
                contains: [
                    PARAMS
                ]
            },
            NUMBER,
            hljs.QUOTE_STRING_MODE,
            RECORD_ACCESS,
            VAR1,
            VAR2,
            TUPLE,
            {
                begin: /\.$/
            } // relevance booster
        ]
    };
}
module.exports = $f96cee4832436c1a$var$erlang;

});

parcelRegister("jetw7", function(module, exports) {
/*
Language: Excel formulae
Author: Victor Zhou <OiCMudkips@users.noreply.github.com>
Description: Excel formulae
Website: https://products.office.com/en-us/excel/
*/ /** @type LanguageFn */ function $e0063893c827fd76$var$excel(hljs) {
    return {
        name: "Excel formulae",
        aliases: [
            "xlsx",
            "xls"
        ],
        case_insensitive: true,
        // built-in functions imported from https://web.archive.org/web/20160513042710/https://support.office.com/en-us/article/Excel-functions-alphabetical-b3944572-255d-4efb-bb96-c6d90033e188
        keywords: {
            $pattern: /[a-zA-Z][\w\.]*/,
            built_in: "ABS ACCRINT ACCRINTM ACOS ACOSH ACOT ACOTH AGGREGATE ADDRESS AMORDEGRC AMORLINC AND ARABIC AREAS ASC ASIN ASINH ATAN ATAN2 ATANH AVEDEV AVERAGE AVERAGEA AVERAGEIF AVERAGEIFS BAHTTEXT BASE BESSELI BESSELJ BESSELK BESSELY BETADIST BETA.DIST BETAINV BETA.INV BIN2DEC BIN2HEX BIN2OCT BINOMDIST BINOM.DIST BINOM.DIST.RANGE BINOM.INV BITAND BITLSHIFT BITOR BITRSHIFT BITXOR CALL CEILING CEILING.MATH CEILING.PRECISE CELL CHAR CHIDIST CHIINV CHITEST CHISQ.DIST CHISQ.DIST.RT CHISQ.INV CHISQ.INV.RT CHISQ.TEST CHOOSE CLEAN CODE COLUMN COLUMNS COMBIN COMBINA COMPLEX CONCAT CONCATENATE CONFIDENCE CONFIDENCE.NORM CONFIDENCE.T CONVERT CORREL COS COSH COT COTH COUNT COUNTA COUNTBLANK COUNTIF COUNTIFS COUPDAYBS COUPDAYS COUPDAYSNC COUPNCD COUPNUM COUPPCD COVAR COVARIANCE.P COVARIANCE.S CRITBINOM CSC CSCH CUBEKPIMEMBER CUBEMEMBER CUBEMEMBERPROPERTY CUBERANKEDMEMBER CUBESET CUBESETCOUNT CUBEVALUE CUMIPMT CUMPRINC DATE DATEDIF DATEVALUE DAVERAGE DAY DAYS DAYS360 DB DBCS DCOUNT DCOUNTA DDB DEC2BIN DEC2HEX DEC2OCT DECIMAL DEGREES DELTA DEVSQ DGET DISC DMAX DMIN DOLLAR DOLLARDE DOLLARFR DPRODUCT DSTDEV DSTDEVP DSUM DURATION DVAR DVARP EDATE EFFECT ENCODEURL EOMONTH ERF ERF.PRECISE ERFC ERFC.PRECISE ERROR.TYPE EUROCONVERT EVEN EXACT EXP EXPON.DIST EXPONDIST FACT FACTDOUBLE FALSE|0 F.DIST FDIST F.DIST.RT FILTERXML FIND FINDB F.INV F.INV.RT FINV FISHER FISHERINV FIXED FLOOR FLOOR.MATH FLOOR.PRECISE FORECAST FORECAST.ETS FORECAST.ETS.CONFINT FORECAST.ETS.SEASONALITY FORECAST.ETS.STAT FORECAST.LINEAR FORMULATEXT FREQUENCY F.TEST FTEST FV FVSCHEDULE GAMMA GAMMA.DIST GAMMADIST GAMMA.INV GAMMAINV GAMMALN GAMMALN.PRECISE GAUSS GCD GEOMEAN GESTEP GETPIVOTDATA GROWTH HARMEAN HEX2BIN HEX2DEC HEX2OCT HLOOKUP HOUR HYPERLINK HYPGEOM.DIST HYPGEOMDIST IF IFERROR IFNA IFS IMABS IMAGINARY IMARGUMENT IMCONJUGATE IMCOS IMCOSH IMCOT IMCSC IMCSCH IMDIV IMEXP IMLN IMLOG10 IMLOG2 IMPOWER IMPRODUCT IMREAL IMSEC IMSECH IMSIN IMSINH IMSQRT IMSUB IMSUM IMTAN INDEX INDIRECT INFO INT INTERCEPT INTRATE IPMT IRR ISBLANK ISERR ISERROR ISEVEN ISFORMULA ISLOGICAL ISNA ISNONTEXT ISNUMBER ISODD ISREF ISTEXT ISO.CEILING ISOWEEKNUM ISPMT JIS KURT LARGE LCM LEFT LEFTB LEN LENB LINEST LN LOG LOG10 LOGEST LOGINV LOGNORM.DIST LOGNORMDIST LOGNORM.INV LOOKUP LOWER MATCH MAX MAXA MAXIFS MDETERM MDURATION MEDIAN MID MIDBs MIN MINIFS MINA MINUTE MINVERSE MIRR MMULT MOD MODE MODE.MULT MODE.SNGL MONTH MROUND MULTINOMIAL MUNIT N NA NEGBINOM.DIST NEGBINOMDIST NETWORKDAYS NETWORKDAYS.INTL NOMINAL NORM.DIST NORMDIST NORMINV NORM.INV NORM.S.DIST NORMSDIST NORM.S.INV NORMSINV NOT NOW NPER NPV NUMBERVALUE OCT2BIN OCT2DEC OCT2HEX ODD ODDFPRICE ODDFYIELD ODDLPRICE ODDLYIELD OFFSET OR PDURATION PEARSON PERCENTILE.EXC PERCENTILE.INC PERCENTILE PERCENTRANK.EXC PERCENTRANK.INC PERCENTRANK PERMUT PERMUTATIONA PHI PHONETIC PI PMT POISSON.DIST POISSON POWER PPMT PRICE PRICEDISC PRICEMAT PROB PRODUCT PROPER PV QUARTILE QUARTILE.EXC QUARTILE.INC QUOTIENT RADIANS RAND RANDBETWEEN RANK.AVG RANK.EQ RANK RATE RECEIVED REGISTER.ID REPLACE REPLACEB REPT RIGHT RIGHTB ROMAN ROUND ROUNDDOWN ROUNDUP ROW ROWS RRI RSQ RTD SEARCH SEARCHB SEC SECH SECOND SERIESSUM SHEET SHEETS SIGN SIN SINH SKEW SKEW.P SLN SLOPE SMALL SQL.REQUEST SQRT SQRTPI STANDARDIZE STDEV STDEV.P STDEV.S STDEVA STDEVP STDEVPA STEYX SUBSTITUTE SUBTOTAL SUM SUMIF SUMIFS SUMPRODUCT SUMSQ SUMX2MY2 SUMX2PY2 SUMXMY2 SWITCH SYD T TAN TANH TBILLEQ TBILLPRICE TBILLYIELD T.DIST T.DIST.2T T.DIST.RT TDIST TEXT TEXTJOIN TIME TIMEVALUE T.INV T.INV.2T TINV TODAY TRANSPOSE TREND TRIM TRIMMEAN TRUE|0 TRUNC T.TEST TTEST TYPE UNICHAR UNICODE UPPER VALUE VAR VAR.P VAR.S VARA VARP VARPA VDB VLOOKUP WEBSERVICE WEEKDAY WEEKNUM WEIBULL WEIBULL.DIST WORKDAY WORKDAY.INTL XIRR XNPV XOR YEAR YEARFRAC YIELD YIELDDISC YIELDMAT Z.TEST ZTEST"
        },
        contains: [
            {
                /* matches a beginning equal sign found in Excel formula examples */ begin: /^=/,
                end: /[^=]/,
                returnEnd: true,
                illegal: /=/,
                /* only allow single equal sign at front of line */ relevance: 10
            },
            /* technically, there can be more than 2 letters in column names, but this prevents conflict with some keywords */ {
                /* matches a reference to a single cell */ className: "symbol",
                begin: /\b[A-Z]{1,2}\d+\b/,
                end: /[^\d]/,
                excludeEnd: true,
                relevance: 0
            },
            {
                /* matches a reference to a range of cells */ className: "symbol",
                begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
                relevance: 0
            },
            hljs.BACKSLASH_ESCAPE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                begin: hljs.NUMBER_RE + "(%)?",
                relevance: 0
            },
            /* Excel formula comments are done by putting the comment in a function call to N() */ hljs.COMMENT(/\bN\(/, /\)/, {
                excludeBegin: true,
                excludeEnd: true,
                illegal: /\n/
            })
        ]
    };
}
module.exports = $e0063893c827fd76$var$excel;

});

parcelRegister("2gdJp", function(module, exports) {
/*
Language: FIX
Author: Brent Bradbury <brent@brentium.com>
*/ /** @type LanguageFn */ function $1a57ba2a81f8eada$var$fix(hljs) {
    return {
        name: "FIX",
        contains: [
            {
                begin: /[^\u2401\u0001]+/,
                end: /[\u2401\u0001]/,
                excludeEnd: true,
                returnBegin: true,
                returnEnd: false,
                contains: [
                    {
                        begin: /([^\u2401\u0001=]+)/,
                        end: /=([^\u2401\u0001=]+)/,
                        returnEnd: true,
                        returnBegin: false,
                        className: "attr"
                    },
                    {
                        begin: /=/,
                        end: /([\u2401\u0001])/,
                        excludeEnd: true,
                        excludeBegin: true,
                        className: "string"
                    }
                ]
            }
        ],
        case_insensitive: true
    };
}
module.exports = $1a57ba2a81f8eada$var$fix;

});

parcelRegister("gh4Hb", function(module, exports) {
/*
 Language: Flix
 Category: functional
 Author: Magnus Madsen <mmadsen@uwaterloo.ca>
 Website: https://flix.dev/
 */ /** @type LanguageFn */ function $bd91e051aeb4a5b9$var$flix(hljs) {
    const CHAR = {
        className: "string",
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            }
        ]
    };
    const NAME = {
        className: "title",
        relevance: 0,
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
    };
    const METHOD = {
        className: "function",
        beginKeywords: "def",
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [
            NAME
        ]
    };
    return {
        name: "Flix",
        keywords: {
            literal: "true false",
            keyword: "case class def else enum if impl import in lat rel index let match namespace switch type yield with"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            CHAR,
            STRING,
            METHOD,
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $bd91e051aeb4a5b9$var$flix;

});

parcelRegister("b6Sro", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $816a7c10489d124c$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $816a7c10489d124c$var$concat(...args) {
    const joined = args.map((x)=>$816a7c10489d124c$var$source(x)).join("");
    return joined;
}
/*
Language: Fortran
Author: Anthony Scemama <scemama@irsamc.ups-tlse.fr>
Website: https://en.wikipedia.org/wiki/Fortran
Category: scientific
*/ /** @type LanguageFn */ function $816a7c10489d124c$var$fortran(hljs) {
    const PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    const COMMENT = {
        variants: [
            hljs.COMMENT("!", "$", {
                relevance: 0
            }),
            // allow FORTRAN 77 style comments
            hljs.COMMENT("^C[ ]", "$", {
                relevance: 0
            }),
            hljs.COMMENT("^C$", "$", {
                relevance: 0
            })
        ]
    };
    // regex in both fortran and irpf90 should match
    const OPTIONAL_NUMBER_SUFFIX = /(_[a-z_\d]+)?/;
    const OPTIONAL_NUMBER_EXP = /([de][+-]?\d+)?/;
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: $816a7c10489d124c$var$concat(/\b\d+/, /\.(\d*)/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            },
            {
                begin: $816a7c10489d124c$var$concat(/\b\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            },
            {
                begin: $816a7c10489d124c$var$concat(/\.\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            }
        ],
        relevance: 0
    };
    const FUNCTION_DEF = {
        className: "function",
        beginKeywords: "subroutine function program",
        illegal: "[${=\\n]",
        contains: [
            hljs.UNDERSCORE_TITLE_MODE,
            PARAMS
        ]
    };
    const STRING = {
        className: "string",
        relevance: 0,
        variants: [
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    const KEYWORDS = {
        literal: ".False. .True.",
        keyword: "kind do concurrent local shared while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then block endblock endassociate public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure impure integer real character complex logical codimension dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data",
        built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image sync change team co_broadcast co_max co_min co_sum co_reduce"
    };
    return {
        name: "Fortran",
        case_insensitive: true,
        aliases: [
            "f90",
            "f95"
        ],
        keywords: KEYWORDS,
        illegal: /\/\*/,
        contains: [
            STRING,
            FUNCTION_DEF,
            // allow `C = value` for assignments so they aren't misdetected
            // as Fortran 77 style comments
            {
                begin: /^C\s*=(?!=)/,
                relevance: 0
            },
            COMMENT,
            NUMBER
        ]
    };
}
module.exports = $816a7c10489d124c$var$fortran;

});

parcelRegister("l9gyx", function(module, exports) {
/*
Language: F#
Author: Jonas Follesø <jonas@follesoe.no>
Contributors: Troy Kershaw <hello@troykershaw.com>, Henrik Feldt <henrik@haf.se>
Website: https://docs.microsoft.com/en-us/dotnet/fsharp/
Category: functional
*/ /** @type LanguageFn */ function $f65747f358184eb1$var$fsharp(hljs) {
    const TYPEPARAM = {
        begin: "<",
        end: ">",
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: /'[a-zA-Z0-9_]+/
            })
        ]
    };
    return {
        name: "F#",
        aliases: [
            "fs"
        ],
        keywords: "abstract and as assert base begin class default delegate do done downcast downto elif else end exception extern false finally for fun function global if in inherit inline interface internal lazy let match member module mutable namespace new null of open or override private public rec return sig static struct then to true try type upcast use val void when while with yield",
        illegal: /\/\*/,
        contains: [
            {
                // monad builder keywords (matches before non-bang kws)
                className: "keyword",
                begin: /\b(yield|return|let|do)!/
            },
            {
                className: "string",
                begin: '@"',
                end: '"',
                contains: [
                    {
                        begin: '""'
                    }
                ]
            },
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            hljs.COMMENT("\\(\\*(\\s)", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            {
                className: "class",
                beginKeywords: "type",
                end: "\\(|=|$",
                excludeEnd: true,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    TYPEPARAM
                ]
            },
            {
                className: "meta",
                begin: "\\[<",
                end: ">\\]",
                relevance: 10
            },
            {
                className: "symbol",
                begin: "\\B('[A-Za-z])\\b",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $f65747f358184eb1$var$fsharp;

});

parcelRegister("dsDLC", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $9cccbccee44cb2ae$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $9cccbccee44cb2ae$var$anyNumberOfTimes(re) {
    return $9cccbccee44cb2ae$var$concat("(", re, ")*");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $9cccbccee44cb2ae$var$concat(...args) {
    const joined = args.map((x)=>$9cccbccee44cb2ae$var$source(x)).join("");
    return joined;
}
/** @type LanguageFn */ function $9cccbccee44cb2ae$var$gams(hljs) {
    const KEYWORDS = {
        keyword: "abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",
        literal: "eps inf na",
        built_in: "abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"
    };
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true
    };
    const SYMBOLS = {
        className: "symbol",
        variants: [
            {
                begin: /=[lgenxc]=/
            },
            {
                begin: /\$/
            }
        ]
    };
    const QSTR = {
        className: "comment",
        variants: [
            {
                begin: "'",
                end: "'"
            },
            {
                begin: '"',
                end: '"'
            }
        ],
        illegal: "\\n",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const ASSIGNMENT = {
        begin: "/",
        end: "/",
        keywords: KEYWORDS,
        contains: [
            QSTR,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    const COMMENT_WORD = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/;
    const DESCTEXT = {
        begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
        excludeBegin: true,
        end: "$",
        endsWithParent: true,
        contains: [
            QSTR,
            ASSIGNMENT,
            {
                className: "comment",
                // one comment word, then possibly more
                begin: $9cccbccee44cb2ae$var$concat(COMMENT_WORD, // [ ] because \s would be too broad (matching newlines)
                $9cccbccee44cb2ae$var$anyNumberOfTimes($9cccbccee44cb2ae$var$concat(/[ ]+/, COMMENT_WORD))),
                relevance: 0
            }
        ]
    };
    return {
        name: "GAMS",
        aliases: [
            "gms"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: [
            hljs.COMMENT(/^\$ontext/, /^\$offtext/),
            {
                className: "meta",
                begin: "^\\$[a-z0-9]+",
                end: "$",
                returnBegin: true,
                contains: [
                    {
                        className: "meta-keyword",
                        begin: "^\\$[a-z0-9]+"
                    }
                ]
            },
            hljs.COMMENT("^\\*", "$"),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            // Declarations
            {
                beginKeywords: "set sets parameter parameters variable variables scalar scalars equation equations",
                end: ";",
                contains: [
                    hljs.COMMENT("^\\*", "$"),
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    ASSIGNMENT,
                    DESCTEXT
                ]
            },
            {
                beginKeywords: "table",
                end: ";",
                returnBegin: true,
                contains: [
                    {
                        beginKeywords: "table",
                        end: "$",
                        contains: [
                            DESCTEXT
                        ]
                    },
                    hljs.COMMENT("^\\*", "$"),
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    hljs.C_NUMBER_MODE
                ]
            },
            // Function definitions
            {
                className: "function",
                begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
                returnBegin: true,
                contains: [
                    {
                        className: "title",
                        begin: /^[a-z0-9_]+/
                    },
                    PARAMS,
                    SYMBOLS
                ]
            },
            hljs.C_NUMBER_MODE,
            SYMBOLS
        ]
    };
}
module.exports = $9cccbccee44cb2ae$var$gams;

});

parcelRegister("7BbCT", function(module, exports) {
/*
Language: GAUSS
Author: Matt Evans <matt@aptech.com>
Description: GAUSS Mathematical and Statistical language
Website: https://www.aptech.com
Category: scientific
*/ function $588501d29d9e3676$var$gauss(hljs) {
    const KEYWORDS = {
        keyword: "bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",
        built_in: "abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",
        literal: "DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"
    };
    const AT_COMMENT_MODE = hljs.COMMENT("@", "@");
    const PREPROCESSOR = {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: {
            "meta-keyword": "define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            {
                beginKeywords: "include",
                end: "$",
                keywords: {
                    "meta-keyword": "include"
                },
                contains: [
                    {
                        className: "meta-string",
                        begin: '"',
                        end: '"',
                        illegal: "\\n"
                    }
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE
        ]
    };
    const STRUCT_TYPE = {
        begin: /\bstruct\s+/,
        end: /\s/,
        keywords: "struct",
        contains: [
            {
                className: "type",
                begin: hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
    // only for definitions
    const PARSE_PARAMS = [
        {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: true,
            excludeEnd: true,
            endsWithParent: true,
            relevance: 0,
            contains: [
                {
                    className: "literal",
                    begin: /\.\.\./
                },
                hljs.C_NUMBER_MODE,
                hljs.C_BLOCK_COMMENT_MODE,
                AT_COMMENT_MODE,
                STRUCT_TYPE
            ]
        }
    ];
    const FUNCTION_DEF = {
        className: "title",
        begin: hljs.UNDERSCORE_IDENT_RE,
        relevance: 0
    };
    const DEFINITION = function(beginKeywords, end, inherits) {
        const mode = hljs.inherit({
            className: "function",
            beginKeywords: beginKeywords,
            end: end,
            excludeEnd: true,
            contains: [].concat(PARSE_PARAMS)
        }, inherits || {});
        mode.contains.push(FUNCTION_DEF);
        mode.contains.push(hljs.C_NUMBER_MODE);
        mode.contains.push(hljs.C_BLOCK_COMMENT_MODE);
        mode.contains.push(AT_COMMENT_MODE);
        return mode;
    };
    const BUILT_IN_REF = {
        className: "built_in",
        begin: "\\b(" + KEYWORDS.built_in.split(" ").join("|") + ")\\b"
    };
    const STRING_REF = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        relevance: 0
    };
    const FUNCTION_REF = {
        // className: "fn_ref",
        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
        returnBegin: true,
        keywords: KEYWORDS,
        relevance: 0,
        contains: [
            {
                beginKeywords: KEYWORDS.keyword
            },
            BUILT_IN_REF,
            {
                className: "built_in",
                begin: hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
    const FUNCTION_REF_PARAMS = {
        // className: "fn_ref_params",
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        keywords: {
            built_in: KEYWORDS.built_in,
            literal: KEYWORDS.literal
        },
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE,
            BUILT_IN_REF,
            FUNCTION_REF,
            STRING_REF,
            "self"
        ]
    };
    FUNCTION_REF.contains.push(FUNCTION_REF_PARAMS);
    return {
        name: "GAUSS",
        aliases: [
            "gss"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        illegal: /(\{[%#]|[%#]\}| <- )/,
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            AT_COMMENT_MODE,
            STRING_REF,
            PREPROCESSOR,
            {
                className: "keyword",
                begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
            },
            DEFINITION("proc keyword", ";"),
            DEFINITION("fn", "="),
            {
                beginKeywords: "for threadfor",
                end: /;/,
                // end: /\(/,
                relevance: 0,
                contains: [
                    hljs.C_BLOCK_COMMENT_MODE,
                    AT_COMMENT_MODE,
                    FUNCTION_REF_PARAMS
                ]
            },
            {
                // excludes method names from keyword processing
                variants: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\." + hljs.UNDERSCORE_IDENT_RE
                    },
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*="
                    }
                ],
                relevance: 0
            },
            FUNCTION_REF,
            STRUCT_TYPE
        ]
    };
}
module.exports = $588501d29d9e3676$var$gauss;

});

parcelRegister("iB6Fn", function(module, exports) {
/*
 Language: G-code (ISO 6983)
 Contributors: Adam Joseph Cook <adam.joseph.cook@gmail.com>
 Description: G-code syntax highlighter for Fanuc and other common CNC machine tool controls.
 Website: https://www.sis.se/api/document/preview/911952/
 */ function $d8a0da83e8d0a61d$var$gcode(hljs) {
    const GCODE_IDENT_RE = "[A-Z_][A-Z0-9_.]*";
    const GCODE_CLOSE_RE = "%";
    const GCODE_KEYWORDS = {
        $pattern: GCODE_IDENT_RE,
        keyword: "IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT EQ LT GT NE GE LE OR XOR"
    };
    const GCODE_START = {
        className: "meta",
        begin: "([O])([0-9]+)"
    };
    const NUMBER = hljs.inherit(hljs.C_NUMBER_MODE, {
        begin: "([-+]?((\\.\\d+)|(\\d+)(\\.\\d*)?))|" + hljs.C_NUMBER_RE
    });
    const GCODE_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT(/\(/, /\)/),
        NUMBER,
        hljs.inherit(hljs.APOS_STRING_MODE, {
            illegal: null
        }),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {
            illegal: null
        }),
        {
            className: "name",
            begin: "([G])([0-9]+\\.?[0-9]?)"
        },
        {
            className: "name",
            begin: "([M])([0-9]+\\.?[0-9]?)"
        },
        {
            className: "attr",
            begin: "(VC|VS|#)",
            end: "(\\d+)"
        },
        {
            className: "attr",
            begin: "(VZOFX|VZOFY|VZOFZ)"
        },
        {
            className: "built_in",
            begin: "(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)",
            contains: [
                NUMBER
            ],
            end: "\\]"
        },
        {
            className: "symbol",
            variants: [
                {
                    begin: "N",
                    end: "\\d+",
                    illegal: "\\W"
                }
            ]
        }
    ];
    return {
        name: "G-code (ISO 6983)",
        aliases: [
            "nc"
        ],
        // Some implementations (CNC controls) of G-code are interoperable with uppercase and lowercase letters seamlessly.
        // However, most prefer all uppercase and uppercase is customary.
        case_insensitive: true,
        keywords: GCODE_KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: GCODE_CLOSE_RE
            },
            GCODE_START
        ].concat(GCODE_CODE)
    };
}
module.exports = $d8a0da83e8d0a61d$var$gcode;

});

parcelRegister("3BTtX", function(module, exports) {
/*
 Language: Gherkin
 Author: Sam Pikesley (@pikesley) <sam.pikesley@theodi.org>
 Description: Gherkin is the format for cucumber specifications. It is a domain specific language which helps you to describe business behavior without the need to go into detail of implementation.
 Website: https://cucumber.io/docs/gherkin/
 */ function $2a0fdd6c72d5c5d6$var$gherkin(hljs) {
    return {
        name: "Gherkin",
        aliases: [
            "feature"
        ],
        keywords: "Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",
        contains: [
            {
                className: "symbol",
                begin: "\\*",
                relevance: 0
            },
            {
                className: "meta",
                begin: "@[^@\\s]+"
            },
            {
                begin: "\\|",
                end: "\\|\\w*$",
                contains: [
                    {
                        className: "string",
                        begin: "[^|]+"
                    }
                ]
            },
            {
                className: "variable",
                begin: "<",
                end: ">"
            },
            hljs.HASH_COMMENT_MODE,
            {
                className: "string",
                begin: '"""',
                end: '"""'
            },
            hljs.QUOTE_STRING_MODE
        ]
    };
}
module.exports = $2a0fdd6c72d5c5d6$var$gherkin;

});

parcelRegister("gp7HK", function(module, exports) {
/*
Language: GLSL
Description: OpenGL Shading Language
Author: Sergey Tikhomirov <sergey@tikhomirov.io>
Website: https://en.wikipedia.org/wiki/OpenGL_Shading_Language
Category: graphics
*/ function $bf14f51e2333e10c$var$glsl(hljs) {
    return {
        name: "GLSL",
        keywords: {
            keyword: // Statements
            "break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly",
            type: "atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",
            built_in: // Constants
            "gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow",
            literal: "true false"
        },
        illegal: '"',
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            }
        ]
    };
}
module.exports = $bf14f51e2333e10c$var$glsl;

});

parcelRegister("3jkHQ", function(module, exports) {
/*
Language: GML
Author: Meseta <meseta@gmail.com>
Description: Game Maker Language for GameMaker Studio 2
Website: https://docs2.yoyogames.com
Category: scripting
*/ function $26933547757404e7$var$gml(hljs) {
    const GML_KEYWORDS = {
        keyword: "begin end if then else while do for break continue with until repeat exit and or xor not return mod div switch case default var globalvar enum function constructor delete #macro #region #endregion",
        built_in: "is_real is_string is_array is_undefined is_int32 is_int64 is_ptr is_vec3 is_vec4 is_matrix is_bool is_method is_struct is_infinity is_nan is_numeric typeof variable_global_exists variable_global_get variable_global_set variable_instance_exists variable_instance_get variable_instance_set variable_instance_get_names variable_struct_exists variable_struct_get variable_struct_get_names variable_struct_names_count variable_struct_remove variable_struct_set array_delete array_insert array_length array_length_1d array_length_2d array_height_2d array_equals array_create array_copy array_pop array_push array_resize array_sort random random_range irandom irandom_range random_set_seed random_get_seed randomize randomise choose abs round floor ceil sign frac sqrt sqr exp ln log2 log10 sin cos tan arcsin arccos arctan arctan2 dsin dcos dtan darcsin darccos darctan darctan2 degtorad radtodeg power logn min max mean median clamp lerp dot_product dot_product_3d dot_product_normalised dot_product_3d_normalised dot_product_normalized dot_product_3d_normalized math_set_epsilon math_get_epsilon angle_difference point_distance_3d point_distance point_direction lengthdir_x lengthdir_y real string int64 ptr string_format chr ansi_char ord string_length string_byte_length string_pos string_copy string_char_at string_ord_at string_byte_at string_set_byte_at string_delete string_insert string_lower string_upper string_repeat string_letters string_digits string_lettersdigits string_replace string_replace_all string_count string_hash_to_newline clipboard_has_text clipboard_set_text clipboard_get_text date_current_datetime date_create_datetime date_valid_datetime date_inc_year date_inc_month date_inc_week date_inc_day date_inc_hour date_inc_minute date_inc_second date_get_year date_get_month date_get_week date_get_day date_get_hour date_get_minute date_get_second date_get_weekday date_get_day_of_year date_get_hour_of_year date_get_minute_of_year date_get_second_of_year date_year_span date_month_span date_week_span date_day_span date_hour_span date_minute_span date_second_span date_compare_datetime date_compare_date date_compare_time date_date_of date_time_of date_datetime_string date_date_string date_time_string date_days_in_month date_days_in_year date_leap_year date_is_today date_set_timezone date_get_timezone game_set_speed game_get_speed motion_set motion_add place_free place_empty place_meeting place_snapped move_random move_snap move_towards_point move_contact_solid move_contact_all move_outside_solid move_outside_all move_bounce_solid move_bounce_all move_wrap distance_to_point distance_to_object position_empty position_meeting path_start path_end mp_linear_step mp_potential_step mp_linear_step_object mp_potential_step_object mp_potential_settings mp_linear_path mp_potential_path mp_linear_path_object mp_potential_path_object mp_grid_create mp_grid_destroy mp_grid_clear_all mp_grid_clear_cell mp_grid_clear_rectangle mp_grid_add_cell mp_grid_get_cell mp_grid_add_rectangle mp_grid_add_instances mp_grid_path mp_grid_draw mp_grid_to_ds_grid collision_point collision_rectangle collision_circle collision_ellipse collision_line collision_point_list collision_rectangle_list collision_circle_list collision_ellipse_list collision_line_list instance_position_list instance_place_list point_in_rectangle point_in_triangle point_in_circle rectangle_in_rectangle rectangle_in_triangle rectangle_in_circle instance_find instance_exists instance_number instance_position instance_nearest instance_furthest instance_place instance_create_depth instance_create_layer instance_copy instance_change instance_destroy position_destroy position_change instance_id_get instance_deactivate_all instance_deactivate_object instance_deactivate_region instance_activate_all instance_activate_object instance_activate_region room_goto room_goto_previous room_goto_next room_previous room_next room_restart game_end game_restart game_load game_save game_save_buffer game_load_buffer event_perform event_user event_perform_object event_inherited show_debug_message show_debug_overlay debug_event debug_get_callstack alarm_get alarm_set font_texture_page_size keyboard_set_map keyboard_get_map keyboard_unset_map keyboard_check keyboard_check_pressed keyboard_check_released keyboard_check_direct keyboard_get_numlock keyboard_set_numlock keyboard_key_press keyboard_key_release keyboard_clear io_clear mouse_check_button mouse_check_button_pressed mouse_check_button_released mouse_wheel_up mouse_wheel_down mouse_clear draw_self draw_sprite draw_sprite_pos draw_sprite_ext draw_sprite_stretched draw_sprite_stretched_ext draw_sprite_tiled draw_sprite_tiled_ext draw_sprite_part draw_sprite_part_ext draw_sprite_general draw_clear draw_clear_alpha draw_point draw_line draw_line_width draw_rectangle draw_roundrect draw_roundrect_ext draw_triangle draw_circle draw_ellipse draw_set_circle_precision draw_arrow draw_button draw_path draw_healthbar draw_getpixel draw_getpixel_ext draw_set_colour draw_set_color draw_set_alpha draw_get_colour draw_get_color draw_get_alpha merge_colour make_colour_rgb make_colour_hsv colour_get_red colour_get_green colour_get_blue colour_get_hue colour_get_saturation colour_get_value merge_color make_color_rgb make_color_hsv color_get_red color_get_green color_get_blue color_get_hue color_get_saturation color_get_value merge_color screen_save screen_save_part draw_set_font draw_set_halign draw_set_valign draw_text draw_text_ext string_width string_height string_width_ext string_height_ext draw_text_transformed draw_text_ext_transformed draw_text_colour draw_text_ext_colour draw_text_transformed_colour draw_text_ext_transformed_colour draw_text_color draw_text_ext_color draw_text_transformed_color draw_text_ext_transformed_color draw_point_colour draw_line_colour draw_line_width_colour draw_rectangle_colour draw_roundrect_colour draw_roundrect_colour_ext draw_triangle_colour draw_circle_colour draw_ellipse_colour draw_point_color draw_line_color draw_line_width_color draw_rectangle_color draw_roundrect_color draw_roundrect_color_ext draw_triangle_color draw_circle_color draw_ellipse_color draw_primitive_begin draw_vertex draw_vertex_colour draw_vertex_color draw_primitive_end sprite_get_uvs font_get_uvs sprite_get_texture font_get_texture texture_get_width texture_get_height texture_get_uvs draw_primitive_begin_texture draw_vertex_texture draw_vertex_texture_colour draw_vertex_texture_color texture_global_scale surface_create surface_create_ext surface_resize surface_free surface_exists surface_get_width surface_get_height surface_get_texture surface_set_target surface_set_target_ext surface_reset_target surface_depth_disable surface_get_depth_disable draw_surface draw_surface_stretched draw_surface_tiled draw_surface_part draw_surface_ext draw_surface_stretched_ext draw_surface_tiled_ext draw_surface_part_ext draw_surface_general surface_getpixel surface_getpixel_ext surface_save surface_save_part surface_copy surface_copy_part application_surface_draw_enable application_get_position application_surface_enable application_surface_is_enabled display_get_width display_get_height display_get_orientation display_get_gui_width display_get_gui_height display_reset display_mouse_get_x display_mouse_get_y display_mouse_set display_set_ui_visibility window_set_fullscreen window_get_fullscreen window_set_caption window_set_min_width window_set_max_width window_set_min_height window_set_max_height window_get_visible_rects window_get_caption window_set_cursor window_get_cursor window_set_colour window_get_colour window_set_color window_get_color window_set_position window_set_size window_set_rectangle window_center window_get_x window_get_y window_get_width window_get_height window_mouse_get_x window_mouse_get_y window_mouse_set window_view_mouse_get_x window_view_mouse_get_y window_views_mouse_get_x window_views_mouse_get_y audio_listener_position audio_listener_velocity audio_listener_orientation audio_emitter_position audio_emitter_create audio_emitter_free audio_emitter_exists audio_emitter_pitch audio_emitter_velocity audio_emitter_falloff audio_emitter_gain audio_play_sound audio_play_sound_on audio_play_sound_at audio_stop_sound audio_resume_music audio_music_is_playing audio_resume_sound audio_pause_sound audio_pause_music audio_channel_num audio_sound_length audio_get_type audio_falloff_set_model audio_play_music audio_stop_music audio_master_gain audio_music_gain audio_sound_gain audio_sound_pitch audio_stop_all audio_resume_all audio_pause_all audio_is_playing audio_is_paused audio_exists audio_sound_set_track_position audio_sound_get_track_position audio_emitter_get_gain audio_emitter_get_pitch audio_emitter_get_x audio_emitter_get_y audio_emitter_get_z audio_emitter_get_vx audio_emitter_get_vy audio_emitter_get_vz audio_listener_set_position audio_listener_set_velocity audio_listener_set_orientation audio_listener_get_data audio_set_master_gain audio_get_master_gain audio_sound_get_gain audio_sound_get_pitch audio_get_name audio_sound_set_track_position audio_sound_get_track_position audio_create_stream audio_destroy_stream audio_create_sync_group audio_destroy_sync_group audio_play_in_sync_group audio_start_sync_group audio_stop_sync_group audio_pause_sync_group audio_resume_sync_group audio_sync_group_get_track_pos audio_sync_group_debug audio_sync_group_is_playing audio_debug audio_group_load audio_group_unload audio_group_is_loaded audio_group_load_progress audio_group_name audio_group_stop_all audio_group_set_gain audio_create_buffer_sound audio_free_buffer_sound audio_create_play_queue audio_free_play_queue audio_queue_sound audio_get_recorder_count audio_get_recorder_info audio_start_recording audio_stop_recording audio_sound_get_listener_mask audio_emitter_get_listener_mask audio_get_listener_mask audio_sound_set_listener_mask audio_emitter_set_listener_mask audio_set_listener_mask audio_get_listener_count audio_get_listener_info audio_system show_message show_message_async clickable_add clickable_add_ext clickable_change clickable_change_ext clickable_delete clickable_exists clickable_set_style show_question show_question_async get_integer get_string get_integer_async get_string_async get_login_async get_open_filename get_save_filename get_open_filename_ext get_save_filename_ext show_error highscore_clear highscore_add highscore_value highscore_name draw_highscore sprite_exists sprite_get_name sprite_get_number sprite_get_width sprite_get_height sprite_get_xoffset sprite_get_yoffset sprite_get_bbox_left sprite_get_bbox_right sprite_get_bbox_top sprite_get_bbox_bottom sprite_save sprite_save_strip sprite_set_cache_size sprite_set_cache_size_ext sprite_get_tpe sprite_prefetch sprite_prefetch_multi sprite_flush sprite_flush_multi sprite_set_speed sprite_get_speed_type sprite_get_speed font_exists font_get_name font_get_fontname font_get_bold font_get_italic font_get_first font_get_last font_get_size font_set_cache_size path_exists path_get_name path_get_length path_get_time path_get_kind path_get_closed path_get_precision path_get_number path_get_point_x path_get_point_y path_get_point_speed path_get_x path_get_y path_get_speed script_exists script_get_name timeline_add timeline_delete timeline_clear timeline_exists timeline_get_name timeline_moment_clear timeline_moment_add_script timeline_size timeline_max_moment object_exists object_get_name object_get_sprite object_get_solid object_get_visible object_get_persistent object_get_mask object_get_parent object_get_physics object_is_ancestor room_exists room_get_name sprite_set_offset sprite_duplicate sprite_assign sprite_merge sprite_add sprite_replace sprite_create_from_surface sprite_add_from_surface sprite_delete sprite_set_alpha_from_sprite sprite_collision_mask font_add_enable_aa font_add_get_enable_aa font_add font_add_sprite font_add_sprite_ext font_replace font_replace_sprite font_replace_sprite_ext font_delete path_set_kind path_set_closed path_set_precision path_add path_assign path_duplicate path_append path_delete path_add_point path_insert_point path_change_point path_delete_point path_clear_points path_reverse path_mirror path_flip path_rotate path_rescale path_shift script_execute object_set_sprite object_set_solid object_set_visible object_set_persistent object_set_mask room_set_width room_set_height room_set_persistent room_set_background_colour room_set_background_color room_set_view room_set_viewport room_get_viewport room_set_view_enabled room_add room_duplicate room_assign room_instance_add room_instance_clear room_get_camera room_set_camera asset_get_index asset_get_type file_text_open_from_string file_text_open_read file_text_open_write file_text_open_append file_text_close file_text_write_string file_text_write_real file_text_writeln file_text_read_string file_text_read_real file_text_readln file_text_eof file_text_eoln file_exists file_delete file_rename file_copy directory_exists directory_create directory_destroy file_find_first file_find_next file_find_close file_attributes filename_name filename_path filename_dir filename_drive filename_ext filename_change_ext file_bin_open file_bin_rewrite file_bin_close file_bin_position file_bin_size file_bin_seek file_bin_write_byte file_bin_read_byte parameter_count parameter_string environment_get_variable ini_open_from_string ini_open ini_close ini_read_string ini_read_real ini_write_string ini_write_real ini_key_exists ini_section_exists ini_key_delete ini_section_delete ds_set_precision ds_exists ds_stack_create ds_stack_destroy ds_stack_clear ds_stack_copy ds_stack_size ds_stack_empty ds_stack_push ds_stack_pop ds_stack_top ds_stack_write ds_stack_read ds_queue_create ds_queue_destroy ds_queue_clear ds_queue_copy ds_queue_size ds_queue_empty ds_queue_enqueue ds_queue_dequeue ds_queue_head ds_queue_tail ds_queue_write ds_queue_read ds_list_create ds_list_destroy ds_list_clear ds_list_copy ds_list_size ds_list_empty ds_list_add ds_list_insert ds_list_replace ds_list_delete ds_list_find_index ds_list_find_value ds_list_mark_as_list ds_list_mark_as_map ds_list_sort ds_list_shuffle ds_list_write ds_list_read ds_list_set ds_map_create ds_map_destroy ds_map_clear ds_map_copy ds_map_size ds_map_empty ds_map_add ds_map_add_list ds_map_add_map ds_map_replace ds_map_replace_map ds_map_replace_list ds_map_delete ds_map_exists ds_map_find_value ds_map_find_previous ds_map_find_next ds_map_find_first ds_map_find_last ds_map_write ds_map_read ds_map_secure_save ds_map_secure_load ds_map_secure_load_buffer ds_map_secure_save_buffer ds_map_set ds_priority_create ds_priority_destroy ds_priority_clear ds_priority_copy ds_priority_size ds_priority_empty ds_priority_add ds_priority_change_priority ds_priority_find_priority ds_priority_delete_value ds_priority_delete_min ds_priority_find_min ds_priority_delete_max ds_priority_find_max ds_priority_write ds_priority_read ds_grid_create ds_grid_destroy ds_grid_copy ds_grid_resize ds_grid_width ds_grid_height ds_grid_clear ds_grid_set ds_grid_add ds_grid_multiply ds_grid_set_region ds_grid_add_region ds_grid_multiply_region ds_grid_set_disk ds_grid_add_disk ds_grid_multiply_disk ds_grid_set_grid_region ds_grid_add_grid_region ds_grid_multiply_grid_region ds_grid_get ds_grid_get_sum ds_grid_get_max ds_grid_get_min ds_grid_get_mean ds_grid_get_disk_sum ds_grid_get_disk_min ds_grid_get_disk_max ds_grid_get_disk_mean ds_grid_value_exists ds_grid_value_x ds_grid_value_y ds_grid_value_disk_exists ds_grid_value_disk_x ds_grid_value_disk_y ds_grid_shuffle ds_grid_write ds_grid_read ds_grid_sort ds_grid_set ds_grid_get effect_create_below effect_create_above effect_clear part_type_create part_type_destroy part_type_exists part_type_clear part_type_shape part_type_sprite part_type_size part_type_scale part_type_orientation part_type_life part_type_step part_type_death part_type_speed part_type_direction part_type_gravity part_type_colour1 part_type_colour2 part_type_colour3 part_type_colour_mix part_type_colour_rgb part_type_colour_hsv part_type_color1 part_type_color2 part_type_color3 part_type_color_mix part_type_color_rgb part_type_color_hsv part_type_alpha1 part_type_alpha2 part_type_alpha3 part_type_blend part_system_create part_system_create_layer part_system_destroy part_system_exists part_system_clear part_system_draw_order part_system_depth part_system_position part_system_automatic_update part_system_automatic_draw part_system_update part_system_drawit part_system_get_layer part_system_layer part_particles_create part_particles_create_colour part_particles_create_color part_particles_clear part_particles_count part_emitter_create part_emitter_destroy part_emitter_destroy_all part_emitter_exists part_emitter_clear part_emitter_region part_emitter_burst part_emitter_stream external_call external_define external_free window_handle window_device matrix_get matrix_set matrix_build_identity matrix_build matrix_build_lookat matrix_build_projection_ortho matrix_build_projection_perspective matrix_build_projection_perspective_fov matrix_multiply matrix_transform_vertex matrix_stack_push matrix_stack_pop matrix_stack_multiply matrix_stack_set matrix_stack_clear matrix_stack_top matrix_stack_is_empty browser_input_capture os_get_config os_get_info os_get_language os_get_region os_lock_orientation display_get_dpi_x display_get_dpi_y display_set_gui_size display_set_gui_maximise display_set_gui_maximize device_mouse_dbclick_enable display_set_timing_method display_get_timing_method display_set_sleep_margin display_get_sleep_margin virtual_key_add virtual_key_hide virtual_key_delete virtual_key_show draw_enable_drawevent draw_enable_swf_aa draw_set_swf_aa_level draw_get_swf_aa_level draw_texture_flush draw_flush gpu_set_blendenable gpu_set_ztestenable gpu_set_zfunc gpu_set_zwriteenable gpu_set_lightingenable gpu_set_fog gpu_set_cullmode gpu_set_blendmode gpu_set_blendmode_ext gpu_set_blendmode_ext_sepalpha gpu_set_colorwriteenable gpu_set_colourwriteenable gpu_set_alphatestenable gpu_set_alphatestref gpu_set_alphatestfunc gpu_set_texfilter gpu_set_texfilter_ext gpu_set_texrepeat gpu_set_texrepeat_ext gpu_set_tex_filter gpu_set_tex_filter_ext gpu_set_tex_repeat gpu_set_tex_repeat_ext gpu_set_tex_mip_filter gpu_set_tex_mip_filter_ext gpu_set_tex_mip_bias gpu_set_tex_mip_bias_ext gpu_set_tex_min_mip gpu_set_tex_min_mip_ext gpu_set_tex_max_mip gpu_set_tex_max_mip_ext gpu_set_tex_max_aniso gpu_set_tex_max_aniso_ext gpu_set_tex_mip_enable gpu_set_tex_mip_enable_ext gpu_get_blendenable gpu_get_ztestenable gpu_get_zfunc gpu_get_zwriteenable gpu_get_lightingenable gpu_get_fog gpu_get_cullmode gpu_get_blendmode gpu_get_blendmode_ext gpu_get_blendmode_ext_sepalpha gpu_get_blendmode_src gpu_get_blendmode_dest gpu_get_blendmode_srcalpha gpu_get_blendmode_destalpha gpu_get_colorwriteenable gpu_get_colourwriteenable gpu_get_alphatestenable gpu_get_alphatestref gpu_get_alphatestfunc gpu_get_texfilter gpu_get_texfilter_ext gpu_get_texrepeat gpu_get_texrepeat_ext gpu_get_tex_filter gpu_get_tex_filter_ext gpu_get_tex_repeat gpu_get_tex_repeat_ext gpu_get_tex_mip_filter gpu_get_tex_mip_filter_ext gpu_get_tex_mip_bias gpu_get_tex_mip_bias_ext gpu_get_tex_min_mip gpu_get_tex_min_mip_ext gpu_get_tex_max_mip gpu_get_tex_max_mip_ext gpu_get_tex_max_aniso gpu_get_tex_max_aniso_ext gpu_get_tex_mip_enable gpu_get_tex_mip_enable_ext gpu_push_state gpu_pop_state gpu_get_state gpu_set_state draw_light_define_ambient draw_light_define_direction draw_light_define_point draw_light_enable draw_set_lighting draw_light_get_ambient draw_light_get draw_get_lighting shop_leave_rating url_get_domain url_open url_open_ext url_open_full get_timer achievement_login achievement_logout achievement_post achievement_increment achievement_post_score achievement_available achievement_show_achievements achievement_show_leaderboards achievement_load_friends achievement_load_leaderboard achievement_send_challenge achievement_load_progress achievement_reset achievement_login_status achievement_get_pic achievement_show_challenge_notifications achievement_get_challenges achievement_event achievement_show achievement_get_info cloud_file_save cloud_string_save cloud_synchronise ads_enable ads_disable ads_setup ads_engagement_launch ads_engagement_available ads_engagement_active ads_event ads_event_preload ads_set_reward_callback ads_get_display_height ads_get_display_width ads_move ads_interstitial_available ads_interstitial_display device_get_tilt_x device_get_tilt_y device_get_tilt_z device_is_keypad_open device_mouse_check_button device_mouse_check_button_pressed device_mouse_check_button_released device_mouse_x device_mouse_y device_mouse_raw_x device_mouse_raw_y device_mouse_x_to_gui device_mouse_y_to_gui iap_activate iap_status iap_enumerate_products iap_restore_all iap_acquire iap_consume iap_product_details iap_purchase_details facebook_init facebook_login facebook_status facebook_graph_request facebook_dialog facebook_logout facebook_launch_offerwall facebook_post_message facebook_send_invite facebook_user_id facebook_accesstoken facebook_check_permission facebook_request_read_permissions facebook_request_publish_permissions gamepad_is_supported gamepad_get_device_count gamepad_is_connected gamepad_get_description gamepad_get_button_threshold gamepad_set_button_threshold gamepad_get_axis_deadzone gamepad_set_axis_deadzone gamepad_button_count gamepad_button_check gamepad_button_check_pressed gamepad_button_check_released gamepad_button_value gamepad_axis_count gamepad_axis_value gamepad_set_vibration gamepad_set_colour gamepad_set_color os_is_paused window_has_focus code_is_compiled http_get http_get_file http_post_string http_request json_encode json_decode zip_unzip load_csv base64_encode base64_decode md5_string_unicode md5_string_utf8 md5_file os_is_network_connected sha1_string_unicode sha1_string_utf8 sha1_file os_powersave_enable analytics_event analytics_event_ext win8_livetile_tile_notification win8_livetile_tile_clear win8_livetile_badge_notification win8_livetile_badge_clear win8_livetile_queue_enable win8_secondarytile_pin win8_secondarytile_badge_notification win8_secondarytile_delete win8_livetile_notification_begin win8_livetile_notification_secondary_begin win8_livetile_notification_expiry win8_livetile_notification_tag win8_livetile_notification_text_add win8_livetile_notification_image_add win8_livetile_notification_end win8_appbar_enable win8_appbar_add_element win8_appbar_remove_element win8_settingscharm_add_entry win8_settingscharm_add_html_entry win8_settingscharm_add_xaml_entry win8_settingscharm_set_xaml_property win8_settingscharm_get_xaml_property win8_settingscharm_remove_entry win8_share_image win8_share_screenshot win8_share_file win8_share_url win8_share_text win8_search_enable win8_search_disable win8_search_add_suggestions win8_device_touchscreen_available win8_license_initialize_sandbox win8_license_trial_version winphone_license_trial_version winphone_tile_title winphone_tile_count winphone_tile_back_title winphone_tile_back_content winphone_tile_back_content_wide winphone_tile_front_image winphone_tile_front_image_small winphone_tile_front_image_wide winphone_tile_back_image winphone_tile_back_image_wide winphone_tile_background_colour winphone_tile_background_color winphone_tile_icon_image winphone_tile_small_icon_image winphone_tile_wide_content winphone_tile_cycle_images winphone_tile_small_background_image physics_world_create physics_world_gravity physics_world_update_speed physics_world_update_iterations physics_world_draw_debug physics_pause_enable physics_fixture_create physics_fixture_set_kinematic physics_fixture_set_density physics_fixture_set_awake physics_fixture_set_restitution physics_fixture_set_friction physics_fixture_set_collision_group physics_fixture_set_sensor physics_fixture_set_linear_damping physics_fixture_set_angular_damping physics_fixture_set_circle_shape physics_fixture_set_box_shape physics_fixture_set_edge_shape physics_fixture_set_polygon_shape physics_fixture_set_chain_shape physics_fixture_add_point physics_fixture_bind physics_fixture_bind_ext physics_fixture_delete physics_apply_force physics_apply_impulse physics_apply_angular_impulse physics_apply_local_force physics_apply_local_impulse physics_apply_torque physics_mass_properties physics_draw_debug physics_test_overlap physics_remove_fixture physics_set_friction physics_set_density physics_set_restitution physics_get_friction physics_get_density physics_get_restitution physics_joint_distance_create physics_joint_rope_create physics_joint_revolute_create physics_joint_prismatic_create physics_joint_pulley_create physics_joint_wheel_create physics_joint_weld_create physics_joint_friction_create physics_joint_gear_create physics_joint_enable_motor physics_joint_get_value physics_joint_set_value physics_joint_delete physics_particle_create physics_particle_delete physics_particle_delete_region_circle physics_particle_delete_region_box physics_particle_delete_region_poly physics_particle_set_flags physics_particle_set_category_flags physics_particle_draw physics_particle_draw_ext physics_particle_count physics_particle_get_data physics_particle_get_data_particle physics_particle_group_begin physics_particle_group_circle physics_particle_group_box physics_particle_group_polygon physics_particle_group_add_point physics_particle_group_end physics_particle_group_join physics_particle_group_delete physics_particle_group_count physics_particle_group_get_data physics_particle_group_get_mass physics_particle_group_get_inertia physics_particle_group_get_centre_x physics_particle_group_get_centre_y physics_particle_group_get_vel_x physics_particle_group_get_vel_y physics_particle_group_get_ang_vel physics_particle_group_get_x physics_particle_group_get_y physics_particle_group_get_angle physics_particle_set_group_flags physics_particle_get_group_flags physics_particle_get_max_count physics_particle_get_radius physics_particle_get_density physics_particle_get_damping physics_particle_get_gravity_scale physics_particle_set_max_count physics_particle_set_radius physics_particle_set_density physics_particle_set_damping physics_particle_set_gravity_scale network_create_socket network_create_socket_ext network_create_server network_create_server_raw network_connect network_connect_raw network_send_packet network_send_raw network_send_broadcast network_send_udp network_send_udp_raw network_set_timeout network_set_config network_resolve network_destroy buffer_create buffer_write buffer_read buffer_seek buffer_get_surface buffer_set_surface buffer_delete buffer_exists buffer_get_type buffer_get_alignment buffer_poke buffer_peek buffer_save buffer_save_ext buffer_load buffer_load_ext buffer_load_partial buffer_copy buffer_fill buffer_get_size buffer_tell buffer_resize buffer_md5 buffer_sha1 buffer_base64_encode buffer_base64_decode buffer_base64_decode_ext buffer_sizeof buffer_get_address buffer_create_from_vertex_buffer buffer_create_from_vertex_buffer_ext buffer_copy_from_vertex_buffer buffer_async_group_begin buffer_async_group_option buffer_async_group_end buffer_load_async buffer_save_async gml_release_mode gml_pragma steam_activate_overlay steam_is_overlay_enabled steam_is_overlay_activated steam_get_persona_name steam_initialised steam_is_cloud_enabled_for_app steam_is_cloud_enabled_for_account steam_file_persisted steam_get_quota_total steam_get_quota_free steam_file_write steam_file_write_file steam_file_read steam_file_delete steam_file_exists steam_file_size steam_file_share steam_is_screenshot_requested steam_send_screenshot steam_is_user_logged_on steam_get_user_steam_id steam_user_owns_dlc steam_user_installed_dlc steam_set_achievement steam_get_achievement steam_clear_achievement steam_set_stat_int steam_set_stat_float steam_set_stat_avg_rate steam_get_stat_int steam_get_stat_float steam_get_stat_avg_rate steam_reset_all_stats steam_reset_all_stats_achievements steam_stats_ready steam_create_leaderboard steam_upload_score steam_upload_score_ext steam_download_scores_around_user steam_download_scores steam_download_friends_scores steam_upload_score_buffer steam_upload_score_buffer_ext steam_current_game_language steam_available_languages steam_activate_overlay_browser steam_activate_overlay_user steam_activate_overlay_store steam_get_user_persona_name steam_get_app_id steam_get_user_account_id steam_ugc_download steam_ugc_create_item steam_ugc_start_item_update steam_ugc_set_item_title steam_ugc_set_item_description steam_ugc_set_item_visibility steam_ugc_set_item_tags steam_ugc_set_item_content steam_ugc_set_item_preview steam_ugc_submit_item_update steam_ugc_get_item_update_progress steam_ugc_subscribe_item steam_ugc_unsubscribe_item steam_ugc_num_subscribed_items steam_ugc_get_subscribed_items steam_ugc_get_item_install_info steam_ugc_get_item_update_info steam_ugc_request_item_details steam_ugc_create_query_user steam_ugc_create_query_user_ex steam_ugc_create_query_all steam_ugc_create_query_all_ex steam_ugc_query_set_cloud_filename_filter steam_ugc_query_set_match_any_tag steam_ugc_query_set_search_text steam_ugc_query_set_ranked_by_trend_days steam_ugc_query_add_required_tag steam_ugc_query_add_excluded_tag steam_ugc_query_set_return_long_description steam_ugc_query_set_return_total_only steam_ugc_query_set_allow_cached_response steam_ugc_send_query shader_set shader_get_name shader_reset shader_current shader_is_compiled shader_get_sampler_index shader_get_uniform shader_set_uniform_i shader_set_uniform_i_array shader_set_uniform_f shader_set_uniform_f_array shader_set_uniform_matrix shader_set_uniform_matrix_array shader_enable_corner_id texture_set_stage texture_get_texel_width texture_get_texel_height shaders_are_supported vertex_format_begin vertex_format_end vertex_format_delete vertex_format_add_position vertex_format_add_position_3d vertex_format_add_colour vertex_format_add_color vertex_format_add_normal vertex_format_add_texcoord vertex_format_add_textcoord vertex_format_add_custom vertex_create_buffer vertex_create_buffer_ext vertex_delete_buffer vertex_begin vertex_end vertex_position vertex_position_3d vertex_colour vertex_color vertex_argb vertex_texcoord vertex_normal vertex_float1 vertex_float2 vertex_float3 vertex_float4 vertex_ubyte4 vertex_submit vertex_freeze vertex_get_number vertex_get_buffer_size vertex_create_buffer_from_buffer vertex_create_buffer_from_buffer_ext push_local_notification push_get_first_local_notification push_get_next_local_notification push_cancel_local_notification skeleton_animation_set skeleton_animation_get skeleton_animation_mix skeleton_animation_set_ext skeleton_animation_get_ext skeleton_animation_get_duration skeleton_animation_get_frames skeleton_animation_clear skeleton_skin_set skeleton_skin_get skeleton_attachment_set skeleton_attachment_get skeleton_attachment_create skeleton_collision_draw_set skeleton_bone_data_get skeleton_bone_data_set skeleton_bone_state_get skeleton_bone_state_set skeleton_get_minmax skeleton_get_num_bounds skeleton_get_bounds skeleton_animation_get_frame skeleton_animation_set_frame draw_skeleton draw_skeleton_time draw_skeleton_instance draw_skeleton_collision skeleton_animation_list skeleton_skin_list skeleton_slot_data layer_get_id layer_get_id_at_depth layer_get_depth layer_create layer_destroy layer_destroy_instances layer_add_instance layer_has_instance layer_set_visible layer_get_visible layer_exists layer_x layer_y layer_get_x layer_get_y layer_hspeed layer_vspeed layer_get_hspeed layer_get_vspeed layer_script_begin layer_script_end layer_shader layer_get_script_begin layer_get_script_end layer_get_shader layer_set_target_room layer_get_target_room layer_reset_target_room layer_get_all layer_get_all_elements layer_get_name layer_depth layer_get_element_layer layer_get_element_type layer_element_move layer_force_draw_depth layer_is_draw_depth_forced layer_get_forced_depth layer_background_get_id layer_background_exists layer_background_create layer_background_destroy layer_background_visible layer_background_change layer_background_sprite layer_background_htiled layer_background_vtiled layer_background_stretch layer_background_yscale layer_background_xscale layer_background_blend layer_background_alpha layer_background_index layer_background_speed layer_background_get_visible layer_background_get_sprite layer_background_get_htiled layer_background_get_vtiled layer_background_get_stretch layer_background_get_yscale layer_background_get_xscale layer_background_get_blend layer_background_get_alpha layer_background_get_index layer_background_get_speed layer_sprite_get_id layer_sprite_exists layer_sprite_create layer_sprite_destroy layer_sprite_change layer_sprite_index layer_sprite_speed layer_sprite_xscale layer_sprite_yscale layer_sprite_angle layer_sprite_blend layer_sprite_alpha layer_sprite_x layer_sprite_y layer_sprite_get_sprite layer_sprite_get_index layer_sprite_get_speed layer_sprite_get_xscale layer_sprite_get_yscale layer_sprite_get_angle layer_sprite_get_blend layer_sprite_get_alpha layer_sprite_get_x layer_sprite_get_y layer_tilemap_get_id layer_tilemap_exists layer_tilemap_create layer_tilemap_destroy tilemap_tileset tilemap_x tilemap_y tilemap_set tilemap_set_at_pixel tilemap_get_tileset tilemap_get_tile_width tilemap_get_tile_height tilemap_get_width tilemap_get_height tilemap_get_x tilemap_get_y tilemap_get tilemap_get_at_pixel tilemap_get_cell_x_at_pixel tilemap_get_cell_y_at_pixel tilemap_clear draw_tilemap draw_tile tilemap_set_global_mask tilemap_get_global_mask tilemap_set_mask tilemap_get_mask tilemap_get_frame tile_set_empty tile_set_index tile_set_flip tile_set_mirror tile_set_rotate tile_get_empty tile_get_index tile_get_flip tile_get_mirror tile_get_rotate layer_tile_exists layer_tile_create layer_tile_destroy layer_tile_change layer_tile_xscale layer_tile_yscale layer_tile_blend layer_tile_alpha layer_tile_x layer_tile_y layer_tile_region layer_tile_visible layer_tile_get_sprite layer_tile_get_xscale layer_tile_get_yscale layer_tile_get_blend layer_tile_get_alpha layer_tile_get_x layer_tile_get_y layer_tile_get_region layer_tile_get_visible layer_instance_get_instance instance_activate_layer instance_deactivate_layer camera_create camera_create_view camera_destroy camera_apply camera_get_active camera_get_default camera_set_default camera_set_view_mat camera_set_proj_mat camera_set_update_script camera_set_begin_script camera_set_end_script camera_set_view_pos camera_set_view_size camera_set_view_speed camera_set_view_border camera_set_view_angle camera_set_view_target camera_get_view_mat camera_get_proj_mat camera_get_update_script camera_get_begin_script camera_get_end_script camera_get_view_x camera_get_view_y camera_get_view_width camera_get_view_height camera_get_view_speed_x camera_get_view_speed_y camera_get_view_border_x camera_get_view_border_y camera_get_view_angle camera_get_view_target view_get_camera view_get_visible view_get_xport view_get_yport view_get_wport view_get_hport view_get_surface_id view_set_camera view_set_visible view_set_xport view_set_yport view_set_wport view_set_hport view_set_surface_id gesture_drag_time gesture_drag_distance gesture_flick_speed gesture_double_tap_time gesture_double_tap_distance gesture_pinch_distance gesture_pinch_angle_towards gesture_pinch_angle_away gesture_rotate_time gesture_rotate_angle gesture_tap_count gesture_get_drag_time gesture_get_drag_distance gesture_get_flick_speed gesture_get_double_tap_time gesture_get_double_tap_distance gesture_get_pinch_distance gesture_get_pinch_angle_towards gesture_get_pinch_angle_away gesture_get_rotate_time gesture_get_rotate_angle gesture_get_tap_count keyboard_virtual_show keyboard_virtual_hide keyboard_virtual_status keyboard_virtual_height",
        literal: "self other all noone global local undefined pointer_invalid pointer_null path_action_stop path_action_restart path_action_continue path_action_reverse true false pi GM_build_date GM_version GM_runtime_version  timezone_local timezone_utc gamespeed_fps gamespeed_microseconds  ev_create ev_destroy ev_step ev_alarm ev_keyboard ev_mouse ev_collision ev_other ev_draw ev_draw_begin ev_draw_end ev_draw_pre ev_draw_post ev_keypress ev_keyrelease ev_trigger ev_left_button ev_right_button ev_middle_button ev_no_button ev_left_press ev_right_press ev_middle_press ev_left_release ev_right_release ev_middle_release ev_mouse_enter ev_mouse_leave ev_mouse_wheel_up ev_mouse_wheel_down ev_global_left_button ev_global_right_button ev_global_middle_button ev_global_left_press ev_global_right_press ev_global_middle_press ev_global_left_release ev_global_right_release ev_global_middle_release ev_joystick1_left ev_joystick1_right ev_joystick1_up ev_joystick1_down ev_joystick1_button1 ev_joystick1_button2 ev_joystick1_button3 ev_joystick1_button4 ev_joystick1_button5 ev_joystick1_button6 ev_joystick1_button7 ev_joystick1_button8 ev_joystick2_left ev_joystick2_right ev_joystick2_up ev_joystick2_down ev_joystick2_button1 ev_joystick2_button2 ev_joystick2_button3 ev_joystick2_button4 ev_joystick2_button5 ev_joystick2_button6 ev_joystick2_button7 ev_joystick2_button8 ev_outside ev_boundary ev_game_start ev_game_end ev_room_start ev_room_end ev_no_more_lives ev_animation_end ev_end_of_path ev_no_more_health ev_close_button ev_user0 ev_user1 ev_user2 ev_user3 ev_user4 ev_user5 ev_user6 ev_user7 ev_user8 ev_user9 ev_user10 ev_user11 ev_user12 ev_user13 ev_user14 ev_user15 ev_step_normal ev_step_begin ev_step_end ev_gui ev_gui_begin ev_gui_end ev_cleanup ev_gesture ev_gesture_tap ev_gesture_double_tap ev_gesture_drag_start ev_gesture_dragging ev_gesture_drag_end ev_gesture_flick ev_gesture_pinch_start ev_gesture_pinch_in ev_gesture_pinch_out ev_gesture_pinch_end ev_gesture_rotate_start ev_gesture_rotating ev_gesture_rotate_end ev_global_gesture_tap ev_global_gesture_double_tap ev_global_gesture_drag_start ev_global_gesture_dragging ev_global_gesture_drag_end ev_global_gesture_flick ev_global_gesture_pinch_start ev_global_gesture_pinch_in ev_global_gesture_pinch_out ev_global_gesture_pinch_end ev_global_gesture_rotate_start ev_global_gesture_rotating ev_global_gesture_rotate_end vk_nokey vk_anykey vk_enter vk_return vk_shift vk_control vk_alt vk_escape vk_space vk_backspace vk_tab vk_pause vk_printscreen vk_left vk_right vk_up vk_down vk_home vk_end vk_delete vk_insert vk_pageup vk_pagedown vk_f1 vk_f2 vk_f3 vk_f4 vk_f5 vk_f6 vk_f7 vk_f8 vk_f9 vk_f10 vk_f11 vk_f12 vk_numpad0 vk_numpad1 vk_numpad2 vk_numpad3 vk_numpad4 vk_numpad5 vk_numpad6 vk_numpad7 vk_numpad8 vk_numpad9 vk_divide vk_multiply vk_subtract vk_add vk_decimal vk_lshift vk_lcontrol vk_lalt vk_rshift vk_rcontrol vk_ralt  mb_any mb_none mb_left mb_right mb_middle c_aqua c_black c_blue c_dkgray c_fuchsia c_gray c_green c_lime c_ltgray c_maroon c_navy c_olive c_purple c_red c_silver c_teal c_white c_yellow c_orange fa_left fa_center fa_right fa_top fa_middle fa_bottom pr_pointlist pr_linelist pr_linestrip pr_trianglelist pr_trianglestrip pr_trianglefan bm_complex bm_normal bm_add bm_max bm_subtract bm_zero bm_one bm_src_colour bm_inv_src_colour bm_src_color bm_inv_src_color bm_src_alpha bm_inv_src_alpha bm_dest_alpha bm_inv_dest_alpha bm_dest_colour bm_inv_dest_colour bm_dest_color bm_inv_dest_color bm_src_alpha_sat tf_point tf_linear tf_anisotropic mip_off mip_on mip_markedonly audio_falloff_none audio_falloff_inverse_distance audio_falloff_inverse_distance_clamped audio_falloff_linear_distance audio_falloff_linear_distance_clamped audio_falloff_exponent_distance audio_falloff_exponent_distance_clamped audio_old_system audio_new_system audio_mono audio_stereo audio_3d cr_default cr_none cr_arrow cr_cross cr_beam cr_size_nesw cr_size_ns cr_size_nwse cr_size_we cr_uparrow cr_hourglass cr_drag cr_appstart cr_handpoint cr_size_all spritespeed_framespersecond spritespeed_framespergameframe asset_object asset_unknown asset_sprite asset_sound asset_room asset_path asset_script asset_font asset_timeline asset_tiles asset_shader fa_readonly fa_hidden fa_sysfile fa_volumeid fa_directory fa_archive  ds_type_map ds_type_list ds_type_stack ds_type_queue ds_type_grid ds_type_priority ef_explosion ef_ring ef_ellipse ef_firework ef_smoke ef_smokeup ef_star ef_spark ef_flare ef_cloud ef_rain ef_snow pt_shape_pixel pt_shape_disk pt_shape_square pt_shape_line pt_shape_star pt_shape_circle pt_shape_ring pt_shape_sphere pt_shape_flare pt_shape_spark pt_shape_explosion pt_shape_cloud pt_shape_smoke pt_shape_snow ps_distr_linear ps_distr_gaussian ps_distr_invgaussian ps_shape_rectangle ps_shape_ellipse ps_shape_diamond ps_shape_line ty_real ty_string dll_cdecl dll_stdcall matrix_view matrix_projection matrix_world os_win32 os_windows os_macosx os_ios os_android os_symbian os_linux os_unknown os_winphone os_tizen os_win8native os_wiiu os_3ds  os_psvita os_bb10 os_ps4 os_xboxone os_ps3 os_xbox360 os_uwp os_tvos os_switch browser_not_a_browser browser_unknown browser_ie browser_firefox browser_chrome browser_safari browser_safari_mobile browser_opera browser_tizen browser_edge browser_windows_store browser_ie_mobile  device_ios_unknown device_ios_iphone device_ios_iphone_retina device_ios_ipad device_ios_ipad_retina device_ios_iphone5 device_ios_iphone6 device_ios_iphone6plus device_emulator device_tablet display_landscape display_landscape_flipped display_portrait display_portrait_flipped tm_sleep tm_countvsyncs of_challenge_win of_challen ge_lose of_challenge_tie leaderboard_type_number leaderboard_type_time_mins_secs cmpfunc_never cmpfunc_less cmpfunc_equal cmpfunc_lessequal cmpfunc_greater cmpfunc_notequal cmpfunc_greaterequal cmpfunc_always cull_noculling cull_clockwise cull_counterclockwise lighttype_dir lighttype_point iap_ev_storeload iap_ev_product iap_ev_purchase iap_ev_consume iap_ev_restore iap_storeload_ok iap_storeload_failed iap_status_uninitialised iap_status_unavailable iap_status_loading iap_status_available iap_status_processing iap_status_restoring iap_failed iap_unavailable iap_available iap_purchased iap_canceled iap_refunded fb_login_default fb_login_fallback_to_webview fb_login_no_fallback_to_webview fb_login_forcing_webview fb_login_use_system_account fb_login_forcing_safari  phy_joint_anchor_1_x phy_joint_anchor_1_y phy_joint_anchor_2_x phy_joint_anchor_2_y phy_joint_reaction_force_x phy_joint_reaction_force_y phy_joint_reaction_torque phy_joint_motor_speed phy_joint_angle phy_joint_motor_torque phy_joint_max_motor_torque phy_joint_translation phy_joint_speed phy_joint_motor_force phy_joint_max_motor_force phy_joint_length_1 phy_joint_length_2 phy_joint_damping_ratio phy_joint_frequency phy_joint_lower_angle_limit phy_joint_upper_angle_limit phy_joint_angle_limits phy_joint_max_length phy_joint_max_torque phy_joint_max_force phy_debug_render_aabb phy_debug_render_collision_pairs phy_debug_render_coms phy_debug_render_core_shapes phy_debug_render_joints phy_debug_render_obb phy_debug_render_shapes  phy_particle_flag_water phy_particle_flag_zombie phy_particle_flag_wall phy_particle_flag_spring phy_particle_flag_elastic phy_particle_flag_viscous phy_particle_flag_powder phy_particle_flag_tensile phy_particle_flag_colourmixing phy_particle_flag_colormixing phy_particle_group_flag_solid phy_particle_group_flag_rigid phy_particle_data_flag_typeflags phy_particle_data_flag_position phy_particle_data_flag_velocity phy_particle_data_flag_colour phy_particle_data_flag_color phy_particle_data_flag_category  achievement_our_info achievement_friends_info achievement_leaderboard_info achievement_achievement_info achievement_filter_all_players achievement_filter_friends_only achievement_filter_favorites_only achievement_type_achievement_challenge achievement_type_score_challenge achievement_pic_loaded  achievement_show_ui achievement_show_profile achievement_show_leaderboard achievement_show_achievement achievement_show_bank achievement_show_friend_picker achievement_show_purchase_prompt network_socket_tcp network_socket_udp network_socket_bluetooth network_type_connect network_type_disconnect network_type_data network_type_non_blocking_connect network_config_connect_timeout network_config_use_non_blocking_socket network_config_enable_reliable_udp network_config_disable_reliable_udp buffer_fixed buffer_grow buffer_wrap buffer_fast buffer_vbuffer buffer_network buffer_u8 buffer_s8 buffer_u16 buffer_s16 buffer_u32 buffer_s32 buffer_u64 buffer_f16 buffer_f32 buffer_f64 buffer_bool buffer_text buffer_string buffer_surface_copy buffer_seek_start buffer_seek_relative buffer_seek_end buffer_generalerror buffer_outofspace buffer_outofbounds buffer_invalidtype  text_type button_type input_type ANSI_CHARSET DEFAULT_CHARSET EASTEUROPE_CHARSET RUSSIAN_CHARSET SYMBOL_CHARSET SHIFTJIS_CHARSET HANGEUL_CHARSET GB2312_CHARSET CHINESEBIG5_CHARSET JOHAB_CHARSET HEBREW_CHARSET ARABIC_CHARSET GREEK_CHARSET TURKISH_CHARSET VIETNAMESE_CHARSET THAI_CHARSET MAC_CHARSET BALTIC_CHARSET OEM_CHARSET  gp_face1 gp_face2 gp_face3 gp_face4 gp_shoulderl gp_shoulderr gp_shoulderlb gp_shoulderrb gp_select gp_start gp_stickl gp_stickr gp_padu gp_padd gp_padl gp_padr gp_axislh gp_axislv gp_axisrh gp_axisrv ov_friends ov_community ov_players ov_settings ov_gamegroup ov_achievements lb_sort_none lb_sort_ascending lb_sort_descending lb_disp_none lb_disp_numeric lb_disp_time_sec lb_disp_time_ms ugc_result_success ugc_filetype_community ugc_filetype_microtrans ugc_visibility_public ugc_visibility_friends_only ugc_visibility_private ugc_query_RankedByVote ugc_query_RankedByPublicationDate ugc_query_AcceptedForGameRankedByAcceptanceDate ugc_query_RankedByTrend ugc_query_FavoritedByFriendsRankedByPublicationDate ugc_query_CreatedByFriendsRankedByPublicationDate ugc_query_RankedByNumTimesReported ugc_query_CreatedByFollowedUsersRankedByPublicationDate ugc_query_NotYetRated ugc_query_RankedByTotalVotesAsc ugc_query_RankedByVotesUp ugc_query_RankedByTextSearch ugc_sortorder_CreationOrderDesc ugc_sortorder_CreationOrderAsc ugc_sortorder_TitleAsc ugc_sortorder_LastUpdatedDesc ugc_sortorder_SubscriptionDateDesc ugc_sortorder_VoteScoreDesc ugc_sortorder_ForModeration ugc_list_Published ugc_list_VotedOn ugc_list_VotedUp ugc_list_VotedDown ugc_list_WillVoteLater ugc_list_Favorited ugc_list_Subscribed ugc_list_UsedOrPlayed ugc_list_Followed ugc_match_Items ugc_match_Items_Mtx ugc_match_Items_ReadyToUse ugc_match_Collections ugc_match_Artwork ugc_match_Videos ugc_match_Screenshots ugc_match_AllGuides ugc_match_WebGuides ugc_match_IntegratedGuides ugc_match_UsableInGame ugc_match_ControllerBindings  vertex_usage_position vertex_usage_colour vertex_usage_color vertex_usage_normal vertex_usage_texcoord vertex_usage_textcoord vertex_usage_blendweight vertex_usage_blendindices vertex_usage_psize vertex_usage_tangent vertex_usage_binormal vertex_usage_fog vertex_usage_depth vertex_usage_sample vertex_type_float1 vertex_type_float2 vertex_type_float3 vertex_type_float4 vertex_type_colour vertex_type_color vertex_type_ubyte4 layerelementtype_undefined layerelementtype_background layerelementtype_instance layerelementtype_oldtilemap layerelementtype_sprite layerelementtype_tilemap layerelementtype_particlesystem layerelementtype_tile tile_rotate tile_flip tile_mirror tile_index_mask kbv_type_default kbv_type_ascii kbv_type_url kbv_type_email kbv_type_numbers kbv_type_phone kbv_type_phone_name kbv_returnkey_default kbv_returnkey_go kbv_returnkey_google kbv_returnkey_join kbv_returnkey_next kbv_returnkey_route kbv_returnkey_search kbv_returnkey_send kbv_returnkey_yahoo kbv_returnkey_done kbv_returnkey_continue kbv_returnkey_emergency kbv_autocapitalize_none kbv_autocapitalize_words kbv_autocapitalize_sentences kbv_autocapitalize_characters",
        symbol: "argument_relative argument argument0 argument1 argument2 argument3 argument4 argument5 argument6 argument7 argument8 argument9 argument10 argument11 argument12 argument13 argument14 argument15 argument_count x|0 y|0 xprevious yprevious xstart ystart hspeed vspeed direction speed friction gravity gravity_direction path_index path_position path_positionprevious path_speed path_scale path_orientation path_endaction object_index id solid persistent mask_index instance_count instance_id room_speed fps fps_real current_time current_year current_month current_day current_weekday current_hour current_minute current_second alarm timeline_index timeline_position timeline_speed timeline_running timeline_loop room room_first room_last room_width room_height room_caption room_persistent score lives health show_score show_lives show_health caption_score caption_lives caption_health event_type event_number event_object event_action application_surface gamemaker_pro gamemaker_registered gamemaker_version error_occurred error_last debug_mode keyboard_key keyboard_lastkey keyboard_lastchar keyboard_string mouse_x mouse_y mouse_button mouse_lastbutton cursor_sprite visible sprite_index sprite_width sprite_height sprite_xoffset sprite_yoffset image_number image_index image_speed depth image_xscale image_yscale image_angle image_alpha image_blend bbox_left bbox_right bbox_top bbox_bottom layer background_colour  background_showcolour background_color background_showcolor view_enabled view_current view_visible view_xview view_yview view_wview view_hview view_xport view_yport view_wport view_hport view_angle view_hborder view_vborder view_hspeed view_vspeed view_object view_surface_id view_camera game_id game_display_name game_project_name game_save_id working_directory temp_directory program_directory browser_width browser_height os_type os_device os_browser os_version display_aa async_load delta_time webgl_enabled event_data iap_data phy_rotation phy_position_x phy_position_y phy_angular_velocity phy_linear_velocity_x phy_linear_velocity_y phy_speed_x phy_speed_y phy_speed phy_angular_damping phy_linear_damping phy_bullet phy_fixed_rotation phy_active phy_mass phy_inertia phy_com_x phy_com_y phy_dynamic phy_kinematic phy_sleeping phy_collision_points phy_collision_x phy_collision_y phy_col_normal_x phy_col_normal_y phy_position_xprevious phy_position_yprevious"
    };
    return {
        name: "GML",
        case_insensitive: false,
        keywords: GML_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $26933547757404e7$var$gml;

});

parcelRegister("eCnIO", function(module, exports) {
/*
Language: Go
Author: Stephan Kountso aka StepLg <steplg@gmail.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>
Description: Google go language (golang). For info about language
Website: http://golang.org/
Category: common, system
*/ function $aa4703f07f3cb2df$var$go(hljs) {
    const GO_KEYWORDS = {
        keyword: "break default func interface select case map struct chan else goto package switch const fallthrough if range type continue for import return var go defer bool byte complex64 complex128 float32 float64 int8 int16 int32 int64 string uint8 uint16 uint32 uint64 int uint uintptr rune",
        literal: "true false iota nil",
        built_in: "append cap close complex copy imag len make new panic print println real recover delete"
    };
    return {
        name: "Go",
        aliases: [
            "golang"
        ],
        keywords: GO_KEYWORDS,
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                variants: [
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    {
                        begin: "`",
                        end: "`"
                    }
                ]
            },
            {
                className: "number",
                variants: [
                    {
                        begin: hljs.C_NUMBER_RE + "[i]",
                        relevance: 1
                    },
                    hljs.C_NUMBER_MODE
                ]
            },
            {
                begin: /:=/ // relevance booster
            },
            {
                className: "function",
                beginKeywords: "func",
                end: "\\s*(\\{|$)",
                excludeEnd: true,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: GO_KEYWORDS,
                        illegal: /["']/
                    }
                ]
            }
        ]
    };
}
module.exports = $aa4703f07f3cb2df$var$go;

});

parcelRegister("fItrr", function(module, exports) {
/*
Language: Golo
Author: Philippe Charriere <ph.charriere@gmail.com>
Description: a lightweight dynamic language for the JVM
Website: http://golo-lang.org/
*/ function $b711cd904b47c99e$var$golo(hljs) {
    return {
        name: "Golo",
        keywords: {
            keyword: "println readln print import module function local return let var while for foreach times in case when match with break continue augment augmentation each find filter reduce if then else otherwise try catch finally raise throw orIfNull DynamicObject|10 DynamicVariable struct Observable map set vector list array",
            literal: "true false null"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@[A-Za-z]+"
            }
        ]
    };
}
module.exports = $b711cd904b47c99e$var$golo;

});

parcelRegister("l8Fwd", function(module, exports) {
/*
Language: Gradle
Description: Gradle is an open-source build automation tool focused on flexibility and performance.
Website: https://gradle.org
Author: Damian Mee <mee.damian@gmail.com>
*/ function $f63a8d0df62e3891$var$gradle(hljs) {
    return {
        name: "Gradle",
        case_insensitive: true,
        keywords: {
            keyword: "task project allprojects subprojects artifacts buildscript configurations dependencies repositories sourceSets description delete from into include exclude source classpath destinationDir includes options sourceCompatibility targetCompatibility group flatDir doLast doFirst flatten todir fromdir ant def abstract break case catch continue default do else extends final finally for if implements instanceof native new private protected public return static switch synchronized throw throws transient try volatile while strictfp package import false null super this true antlrtask checkstyle codenarc copy boolean byte char class double float int interface long short void compile runTime file fileTree abs any append asList asWritable call collect compareTo count div dump each eachByte eachFile eachLine every find findAll flatten getAt getErr getIn getOut getText grep immutable inject inspect intersect invokeMethods isCase join leftShift minus multiply newInputStream newOutputStream newPrintWriter newReader newWriter next plus pop power previous print println push putAt read readBytes readLines reverse reverseEach round size sort splitEachLine step subMap times toInteger toList tokenize upto waitForOrKill withPrintWriter withReader withStream withWriter withWriterAppend write writeLine"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.REGEXP_MODE
        ]
    };
}
module.exports = $f63a8d0df62e3891$var$gradle;

});

parcelRegister("8cUJC", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $5f9b7414ab719b1c$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $5f9b7414ab719b1c$var$lookahead(re) {
    return $5f9b7414ab719b1c$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $5f9b7414ab719b1c$var$concat(...args) {
    const joined = args.map((x)=>$5f9b7414ab719b1c$var$source(x)).join("");
    return joined;
}
/*
 Language: Groovy
 Author: Guillaume Laforge <glaforge@gmail.com>
 Description: Groovy programming language implementation inspired from Vsevolod's Java mode
 Website: https://groovy-lang.org
 */ function $5f9b7414ab719b1c$var$variants(variants, obj = {}) {
    obj.variants = variants;
    return obj;
}
function $5f9b7414ab719b1c$var$groovy(hljs) {
    const IDENT_RE = "[A-Za-z0-9_$]+";
    const COMMENT = $5f9b7414ab719b1c$var$variants([
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.COMMENT("/\\*\\*", "\\*/", {
            relevance: 0,
            contains: [
                {
                    // eat up @'s in emails to prevent them to be recognized as doctags
                    begin: /\w+@/,
                    relevance: 0
                },
                {
                    className: "doctag",
                    begin: "@[A-Za-z]+"
                }
            ]
        })
    ]);
    const REGEXP = {
        className: "regexp",
        begin: /~?\/[^\/\n]+\//,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const NUMBER = $5f9b7414ab719b1c$var$variants([
        hljs.BINARY_NUMBER_MODE,
        hljs.C_NUMBER_MODE
    ]);
    const STRING = $5f9b7414ab719b1c$var$variants([
        {
            begin: /"""/,
            end: /"""/
        },
        {
            begin: /'''/,
            end: /'''/
        },
        {
            begin: "\\$/",
            end: "/\\$",
            relevance: 10
        },
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE
    ], {
        className: "string"
    });
    return {
        name: "Groovy",
        keywords: {
            built_in: "this super",
            literal: "true false null",
            keyword: "byte short char int long boolean float double void def as in assert trait abstract static volatile transient public private protected synchronized final class interface enum if else for while switch case break default continue throw throws try catch finally implements extends new import package return instanceof"
        },
        contains: [
            hljs.SHEBANG({
                binary: "groovy",
                relevance: 10
            }),
            COMMENT,
            STRING,
            REGEXP,
            NUMBER,
            {
                className: "class",
                beginKeywords: "class interface trait enum",
                end: /\{/,
                illegal: ":",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "meta",
                begin: "@[A-Za-z]+",
                relevance: 0
            },
            {
                // highlight map keys and named parameters as attrs
                className: "attr",
                begin: IDENT_RE + "[ 	]*:",
                relevance: 0
            },
            {
                // catch middle element of the ternary operator
                // to avoid highlight it as a label, named parameter, or map key
                begin: /\?/,
                end: /:/,
                relevance: 0,
                contains: [
                    COMMENT,
                    STRING,
                    REGEXP,
                    NUMBER,
                    "self"
                ]
            },
            {
                // highlight labeled statements
                className: "symbol",
                begin: "^[ 	]*" + $5f9b7414ab719b1c$var$lookahead(IDENT_RE + ":"),
                excludeBegin: true,
                end: IDENT_RE + ":",
                relevance: 0
            }
        ],
        illegal: /#|<\//
    };
}
module.exports = $5f9b7414ab719b1c$var$groovy;

});

parcelRegister("higtC", function(module, exports) {
/*
Language: HAML
Requires: ruby.js
Author: Dan Allen <dan.j.allen@gmail.com>
Website: http://haml.info
Category: template
*/ // TODO support filter tags like :javascript, support inline HTML
function $c970e60e5a68dd0f$var$haml(hljs) {
    return {
        name: "HAML",
        case_insensitive: true,
        contains: [
            {
                className: "meta",
                begin: "^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",
                relevance: 10
            },
            // FIXME these comments should be allowed to span indented lines
            hljs.COMMENT("^\\s*(!=#|=#|-#|/).*$", false, {
                relevance: 0
            }),
            {
                begin: "^\\s*(-|=|!=)(?!#)",
                starts: {
                    end: "\\n",
                    subLanguage: "ruby"
                }
            },
            {
                className: "tag",
                begin: "^\\s*%",
                contains: [
                    {
                        className: "selector-tag",
                        begin: "\\w+"
                    },
                    {
                        className: "selector-id",
                        begin: "#[\\w-]+"
                    },
                    {
                        className: "selector-class",
                        begin: "\\.[\\w-]+"
                    },
                    {
                        begin: /\{\s*/,
                        end: /\s*\}/,
                        contains: [
                            {
                                begin: ":\\w+\\s*=>",
                                end: ",\\s+",
                                returnBegin: true,
                                endsWithParent: true,
                                contains: [
                                    {
                                        className: "attr",
                                        begin: ":\\w+"
                                    },
                                    hljs.APOS_STRING_MODE,
                                    hljs.QUOTE_STRING_MODE,
                                    {
                                        begin: "\\w+",
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: "\\(\\s*",
                        end: "\\s*\\)",
                        excludeEnd: true,
                        contains: [
                            {
                                begin: "\\w+\\s*=",
                                end: "\\s+",
                                returnBegin: true,
                                endsWithParent: true,
                                contains: [
                                    {
                                        className: "attr",
                                        begin: "\\w+",
                                        relevance: 0
                                    },
                                    hljs.APOS_STRING_MODE,
                                    hljs.QUOTE_STRING_MODE,
                                    {
                                        begin: "\\w+",
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                begin: "^\\s*[=~]\\s*"
            },
            {
                begin: /#\{/,
                starts: {
                    end: /\}/,
                    subLanguage: "ruby"
                }
            }
        ]
    };
}
module.exports = $c970e60e5a68dd0f$var$haml;

});

parcelRegister("hkha6", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $c9d19defc55bd378$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $c9d19defc55bd378$var$anyNumberOfTimes(re) {
    return $c9d19defc55bd378$var$concat("(", re, ")*");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $c9d19defc55bd378$var$optional(re) {
    return $c9d19defc55bd378$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $c9d19defc55bd378$var$concat(...args) {
    const joined = args.map((x)=>$c9d19defc55bd378$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $c9d19defc55bd378$var$either(...args) {
    const joined = "(" + args.map((x)=>$c9d19defc55bd378$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: Handlebars
Requires: xml.js
Author: Robin Ward <robin.ward@gmail.com>
Description: Matcher for Handlebars as well as EmberJS additions.
Website: https://handlebarsjs.com
Category: template
*/ function $c9d19defc55bd378$var$handlebars(hljs) {
    const BUILT_INS = {
        "builtin-name": [
            "action",
            "bindattr",
            "collection",
            "component",
            "concat",
            "debugger",
            "each",
            "each-in",
            "get",
            "hash",
            "if",
            "in",
            "input",
            "link-to",
            "loc",
            "log",
            "lookup",
            "mut",
            "outlet",
            "partial",
            "query-params",
            "render",
            "template",
            "textarea",
            "unbound",
            "unless",
            "view",
            "with",
            "yield"
        ]
    };
    const LITERALS = {
        literal: [
            "true",
            "false",
            "undefined",
            "null"
        ]
    };
    // as defined in https://handlebarsjs.com/guide/expressions.html#literal-segments
    // this regex matches literal segments like ' abc ' or [ abc ] as well as helpers and paths
    // like a/b, ./abc/cde, and abc.bcd
    const DOUBLE_QUOTED_ID_REGEX = /""|"[^"]+"/;
    const SINGLE_QUOTED_ID_REGEX = /''|'[^']+'/;
    const BRACKET_QUOTED_ID_REGEX = /\[\]|\[[^\]]+\]/;
    const PLAIN_ID_REGEX = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/;
    const PATH_DELIMITER_REGEX = /(\.|\/)/;
    const ANY_ID = $c9d19defc55bd378$var$either(DOUBLE_QUOTED_ID_REGEX, SINGLE_QUOTED_ID_REGEX, BRACKET_QUOTED_ID_REGEX, PLAIN_ID_REGEX);
    const IDENTIFIER_REGEX = $c9d19defc55bd378$var$concat($c9d19defc55bd378$var$optional(/\.|\.\/|\//), ANY_ID, $c9d19defc55bd378$var$anyNumberOfTimes($c9d19defc55bd378$var$concat(PATH_DELIMITER_REGEX, ANY_ID)));
    // identifier followed by a equal-sign (without the equal sign)
    const HASH_PARAM_REGEX = $c9d19defc55bd378$var$concat("(", BRACKET_QUOTED_ID_REGEX, "|", PLAIN_ID_REGEX, ")(?==)");
    const HELPER_NAME_OR_PATH_EXPRESSION = {
        begin: IDENTIFIER_REGEX,
        lexemes: /[\w.\/]+/
    };
    const HELPER_PARAMETER = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: LITERALS
    });
    const SUB_EXPRESSION = {
        begin: /\(/,
        end: /\)/
    };
    const HASH = {
        // fka "attribute-assignment", parameters of the form 'key=value'
        className: "attr",
        begin: HASH_PARAM_REGEX,
        relevance: 0,
        starts: {
            begin: /=/,
            end: /=/,
            starts: {
                contains: [
                    hljs.NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    HELPER_PARAMETER,
                    SUB_EXPRESSION
                ]
            }
        }
    };
    const BLOCK_PARAMS = {
        // parameters of the form '{{#with x as | y |}}...{{/with}}'
        begin: /as\s+\|/,
        keywords: {
            keyword: "as"
        },
        end: /\|/,
        contains: [
            {
                // define sub-mode in order to prevent highlighting of block-parameter named "as"
                begin: /\w+/
            }
        ]
    };
    const HELPER_PARAMETERS = {
        contains: [
            hljs.NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            BLOCK_PARAMS,
            HASH,
            HELPER_PARAMETER,
            SUB_EXPRESSION
        ],
        returnEnd: true
    };
    const SUB_EXPRESSION_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: "name",
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\)/
        })
    });
    SUB_EXPRESSION.contains = [
        SUB_EXPRESSION_CONTENTS
    ];
    const OPENING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: "name",
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const CLOSING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: "name"
    });
    const BASIC_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: "name",
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
        begin: /\\\{\{/,
        skip: true
    };
    const PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
        begin: /\\\\(?=\{\{)/,
        skip: true
    };
    return {
        name: "Handlebars",
        aliases: [
            "hbs",
            "html.hbs",
            "html.handlebars",
            "htmlbars"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH,
            PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH,
            hljs.COMMENT(/\{\{!--/, /--\}\}/),
            hljs.COMMENT(/\{\{!/, /\}\}/),
            {
                // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
                className: "template-tag",
                begin: /\{\{\{\{(?!\/)/,
                end: /\}\}\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ],
                starts: {
                    end: /\{\{\{\{\//,
                    returnEnd: true,
                    subLanguage: "xml"
                }
            },
            {
                // close raw block
                className: "template-tag",
                begin: /\{\{\{\{\//,
                end: /\}\}\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // open block statement
                className: "template-tag",
                begin: /\{\{#/,
                end: /\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                className: "template-tag",
                begin: /\{\{(?=else\}\})/,
                end: /\}\}/,
                keywords: "else"
            },
            {
                className: "template-tag",
                begin: /\{\{(?=else if)/,
                end: /\}\}/,
                keywords: "else if"
            },
            {
                // closing block statement
                className: "template-tag",
                begin: /\{\{\//,
                end: /\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is NOT html-escaped
                className: "template-variable",
                begin: /\{\{\{/,
                end: /\}\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is html-escaped
                className: "template-variable",
                begin: /\{\{/,
                end: /\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            }
        ]
    };
}
module.exports = $c9d19defc55bd378$var$handlebars;

});

parcelRegister("ciB8y", function(module, exports) {
/*
Language: Haskell
Author: Jeremy Hull <sourdrums@gmail.com>
Contributors: Zena Treep <zena.treep@gmail.com>
Website: https://www.haskell.org
Category: functional
*/ function $8f43f9207869593b$var$haskell(hljs) {
    const COMMENT = {
        variants: [
            hljs.COMMENT("--", "$"),
            hljs.COMMENT(/\{-/, /-\}/, {
                contains: [
                    "self"
                ]
            })
        ]
    };
    const PRAGMA = {
        className: "meta",
        begin: /\{-#/,
        end: /#-\}/
    };
    const PREPROCESSOR = {
        className: "meta",
        begin: "^#",
        end: "$"
    };
    const CONSTRUCTOR = {
        className: "type",
        begin: "\\b[A-Z][\\w']*",
        relevance: 0
    };
    const LIST = {
        begin: "\\(",
        end: "\\)",
        illegal: '"',
        contains: [
            PRAGMA,
            PREPROCESSOR,
            {
                className: "type",
                begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
            },
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "[_a-z][\\w']*"
            }),
            COMMENT
        ]
    };
    const RECORD = {
        begin: /\{/,
        end: /\}/,
        contains: LIST.contains
    };
    return {
        name: "Haskell",
        aliases: [
            "hs"
        ],
        keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
        contains: [
            // Top-level constructions.
            {
                beginKeywords: "module",
                end: "where",
                keywords: "module where",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                begin: "\\bimport\\b",
                end: "$",
                keywords: "import qualified as hiding",
                contains: [
                    LIST,
                    COMMENT
                ],
                illegal: "\\W\\.|;"
            },
            {
                className: "class",
                begin: "^(\\s*)?(class|instance)\\b",
                end: "where",
                keywords: "class family instance where",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    COMMENT
                ]
            },
            {
                className: "class",
                begin: "\\b(data|(new)?type)\\b",
                end: "$",
                keywords: "data family type newtype deriving",
                contains: [
                    PRAGMA,
                    CONSTRUCTOR,
                    LIST,
                    RECORD,
                    COMMENT
                ]
            },
            {
                beginKeywords: "default",
                end: "$",
                contains: [
                    CONSTRUCTOR,
                    LIST,
                    COMMENT
                ]
            },
            {
                beginKeywords: "infix infixl infixr",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE,
                    COMMENT
                ]
            },
            {
                begin: "\\bforeign\\b",
                end: "$",
                keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
                contains: [
                    CONSTRUCTOR,
                    hljs.QUOTE_STRING_MODE,
                    COMMENT
                ]
            },
            {
                className: "meta",
                begin: "#!\\/usr\\/bin\\/env runhaskell",
                end: "$"
            },
            // "Whitespaces".
            PRAGMA,
            PREPROCESSOR,
            // Literals and names.
            // TODO: characters.
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            CONSTRUCTOR,
            hljs.inherit(hljs.TITLE_MODE, {
                begin: "^[_a-z][\\w']*"
            }),
            COMMENT,
            {
                begin: "->|<-"
            }
        ]
    };
}
module.exports = $8f43f9207869593b$var$haskell;

});

parcelRegister("freT9", function(module, exports) {
/*
Language: Haxe
Description: Haxe is an open source toolkit based on a modern, high level, strictly typed programming language.
Author: Christopher Kaster <ikasoki@gmail.com> (Based on the actionscript.js language file by Alexander Myadzel)
Contributors: Kenton Hamaluik <kentonh@gmail.com>
Website: https://haxe.org
*/ function $b3d4ed30ef9dd16a$var$haxe(hljs) {
    const HAXE_BASIC_TYPES = "Int Float String Bool Dynamic Void Array ";
    return {
        name: "Haxe",
        aliases: [
            "hx"
        ],
        keywords: {
            keyword: "break case cast catch continue default do dynamic else enum extern for function here if import in inline never new override package private get set public return static super switch this throw trace try typedef untyped using var while " + HAXE_BASIC_TYPES,
            built_in: "trace this",
            literal: "true false null _"
        },
        contains: [
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        className: "subst",
                        begin: "\\$\\{",
                        end: "\\}"
                    },
                    {
                        className: "subst",
                        begin: "\\$",
                        end: /\W\}/
                    }
                ]
            },
            hljs.QUOTE_STRING_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "@:",
                end: "$"
            },
            {
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elseif end error"
                }
            },
            {
                className: "type",
                begin: ":[ 	]*",
                end: "[^A-Za-z0-9_ 	\\->]",
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0
            },
            {
                className: "type",
                begin: ":[ 	]*",
                end: "\\W",
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "type",
                begin: "new *",
                end: "\\W",
                excludeBegin: true,
                excludeEnd: true
            },
            {
                className: "class",
                beginKeywords: "enum",
                end: "\\{",
                contains: [
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "abstract",
                end: "[\\{$]",
                contains: [
                    {
                        className: "type",
                        begin: "\\(",
                        end: "\\)",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "from +",
                        end: "\\W",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "to +",
                        end: "\\W",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    hljs.TITLE_MODE
                ],
                keywords: {
                    keyword: "abstract from to"
                }
            },
            {
                className: "class",
                begin: "\\b(class|interface) +",
                end: "[\\{$]",
                excludeEnd: true,
                keywords: "class interface",
                contains: [
                    {
                        className: "keyword",
                        begin: "\\b(extends|implements) +",
                        keywords: "extends implements",
                        contains: [
                            {
                                className: "type",
                                begin: hljs.IDENT_RE,
                                relevance: 0
                            }
                        ]
                    },
                    hljs.TITLE_MODE
                ]
            },
            {
                className: "function",
                beginKeywords: "function",
                end: "\\(",
                excludeEnd: true,
                illegal: "\\S",
                contains: [
                    hljs.TITLE_MODE
                ]
            }
        ],
        illegal: /<\//
    };
}
module.exports = $b3d4ed30ef9dd16a$var$haxe;

});

parcelRegister("fWLHt", function(module, exports) {
/*
Language: HSP
Author: prince <MC.prince.0203@gmail.com>
Website: https://en.wikipedia.org/wiki/Hot_Soup_Processor
Category: scripting
*/ function $b9c1461181eab41a$var$hsp(hljs) {
    return {
        name: "HSP",
        case_insensitive: true,
        keywords: {
            $pattern: /[\w._]+/,
            keyword: "goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            {
                // multi-line string
                className: "string",
                begin: /\{"/,
                end: /"\}/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                // pre-processor
                className: "meta",
                begin: "#",
                end: "$",
                keywords: {
                    "meta-keyword": "addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib"
                },
                contains: [
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        className: "meta-string"
                    }),
                    hljs.NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                // label
                className: "symbol",
                begin: "^\\*(\\w+|@)"
            },
            hljs.NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $b9c1461181eab41a$var$hsp;

});

parcelRegister("3lp2P", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $26f6c29aa5226463$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $26f6c29aa5226463$var$anyNumberOfTimes(re) {
    return $26f6c29aa5226463$var$concat("(", re, ")*");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $26f6c29aa5226463$var$optional(re) {
    return $26f6c29aa5226463$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $26f6c29aa5226463$var$concat(...args) {
    const joined = args.map((x)=>$26f6c29aa5226463$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $26f6c29aa5226463$var$either(...args) {
    const joined = "(" + args.map((x)=>$26f6c29aa5226463$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: Handlebars
Requires: xml.js
Author: Robin Ward <robin.ward@gmail.com>
Description: Matcher for Handlebars as well as EmberJS additions.
Website: https://handlebarsjs.com
Category: template
*/ function $26f6c29aa5226463$var$handlebars(hljs) {
    const BUILT_INS = {
        "builtin-name": [
            "action",
            "bindattr",
            "collection",
            "component",
            "concat",
            "debugger",
            "each",
            "each-in",
            "get",
            "hash",
            "if",
            "in",
            "input",
            "link-to",
            "loc",
            "log",
            "lookup",
            "mut",
            "outlet",
            "partial",
            "query-params",
            "render",
            "template",
            "textarea",
            "unbound",
            "unless",
            "view",
            "with",
            "yield"
        ]
    };
    const LITERALS = {
        literal: [
            "true",
            "false",
            "undefined",
            "null"
        ]
    };
    // as defined in https://handlebarsjs.com/guide/expressions.html#literal-segments
    // this regex matches literal segments like ' abc ' or [ abc ] as well as helpers and paths
    // like a/b, ./abc/cde, and abc.bcd
    const DOUBLE_QUOTED_ID_REGEX = /""|"[^"]+"/;
    const SINGLE_QUOTED_ID_REGEX = /''|'[^']+'/;
    const BRACKET_QUOTED_ID_REGEX = /\[\]|\[[^\]]+\]/;
    const PLAIN_ID_REGEX = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/;
    const PATH_DELIMITER_REGEX = /(\.|\/)/;
    const ANY_ID = $26f6c29aa5226463$var$either(DOUBLE_QUOTED_ID_REGEX, SINGLE_QUOTED_ID_REGEX, BRACKET_QUOTED_ID_REGEX, PLAIN_ID_REGEX);
    const IDENTIFIER_REGEX = $26f6c29aa5226463$var$concat($26f6c29aa5226463$var$optional(/\.|\.\/|\//), ANY_ID, $26f6c29aa5226463$var$anyNumberOfTimes($26f6c29aa5226463$var$concat(PATH_DELIMITER_REGEX, ANY_ID)));
    // identifier followed by a equal-sign (without the equal sign)
    const HASH_PARAM_REGEX = $26f6c29aa5226463$var$concat("(", BRACKET_QUOTED_ID_REGEX, "|", PLAIN_ID_REGEX, ")(?==)");
    const HELPER_NAME_OR_PATH_EXPRESSION = {
        begin: IDENTIFIER_REGEX,
        lexemes: /[\w.\/]+/
    };
    const HELPER_PARAMETER = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: LITERALS
    });
    const SUB_EXPRESSION = {
        begin: /\(/,
        end: /\)/
    };
    const HASH = {
        // fka "attribute-assignment", parameters of the form 'key=value'
        className: "attr",
        begin: HASH_PARAM_REGEX,
        relevance: 0,
        starts: {
            begin: /=/,
            end: /=/,
            starts: {
                contains: [
                    hljs.NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    HELPER_PARAMETER,
                    SUB_EXPRESSION
                ]
            }
        }
    };
    const BLOCK_PARAMS = {
        // parameters of the form '{{#with x as | y |}}...{{/with}}'
        begin: /as\s+\|/,
        keywords: {
            keyword: "as"
        },
        end: /\|/,
        contains: [
            {
                // define sub-mode in order to prevent highlighting of block-parameter named "as"
                begin: /\w+/
            }
        ]
    };
    const HELPER_PARAMETERS = {
        contains: [
            hljs.NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            BLOCK_PARAMS,
            HASH,
            HELPER_PARAMETER,
            SUB_EXPRESSION
        ],
        returnEnd: true
    };
    const SUB_EXPRESSION_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: "name",
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\)/
        })
    });
    SUB_EXPRESSION.contains = [
        SUB_EXPRESSION_CONTENTS
    ];
    const OPENING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: "name",
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const CLOSING_BLOCK_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        keywords: BUILT_INS,
        className: "name"
    });
    const BASIC_MUSTACHE_CONTENTS = hljs.inherit(HELPER_NAME_OR_PATH_EXPRESSION, {
        className: "name",
        keywords: BUILT_INS,
        starts: hljs.inherit(HELPER_PARAMETERS, {
            end: /\}\}/
        })
    });
    const ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH = {
        begin: /\\\{\{/,
        skip: true
    };
    const PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH = {
        begin: /\\\\(?=\{\{)/,
        skip: true
    };
    return {
        name: "Handlebars",
        aliases: [
            "hbs",
            "html.hbs",
            "html.handlebars",
            "htmlbars"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            ESCAPE_MUSTACHE_WITH_PRECEEDING_BACKSLASH,
            PREVENT_ESCAPE_WITH_ANOTHER_PRECEEDING_BACKSLASH,
            hljs.COMMENT(/\{\{!--/, /--\}\}/),
            hljs.COMMENT(/\{\{!/, /\}\}/),
            {
                // open raw block "{{{{raw}}}} content not evaluated {{{{/raw}}}}"
                className: "template-tag",
                begin: /\{\{\{\{(?!\/)/,
                end: /\}\}\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ],
                starts: {
                    end: /\{\{\{\{\//,
                    returnEnd: true,
                    subLanguage: "xml"
                }
            },
            {
                // close raw block
                className: "template-tag",
                begin: /\{\{\{\{\//,
                end: /\}\}\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // open block statement
                className: "template-tag",
                begin: /\{\{#/,
                end: /\}\}/,
                contains: [
                    OPENING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                className: "template-tag",
                begin: /\{\{(?=else\}\})/,
                end: /\}\}/,
                keywords: "else"
            },
            {
                className: "template-tag",
                begin: /\{\{(?=else if)/,
                end: /\}\}/,
                keywords: "else if"
            },
            {
                // closing block statement
                className: "template-tag",
                begin: /\{\{\//,
                end: /\}\}/,
                contains: [
                    CLOSING_BLOCK_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is NOT html-escaped
                className: "template-variable",
                begin: /\{\{\{/,
                end: /\}\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            },
            {
                // template variable or helper-call that is html-escaped
                className: "template-variable",
                begin: /\{\{/,
                end: /\}\}/,
                contains: [
                    BASIC_MUSTACHE_CONTENTS
                ]
            }
        ]
    };
}
/*
 Language: HTMLBars (legacy)
 Requires: xml.js
 Description: Matcher for Handlebars as well as EmberJS additions.
 Website: https://github.com/tildeio/htmlbars
 Category: template
 */ function $26f6c29aa5226463$var$htmlbars(hljs) {
    const definition = $26f6c29aa5226463$var$handlebars(hljs);
    definition.name = "HTMLbars";
    // HACK: This lets handlebars do the auto-detection if it's been loaded (by
    // default the build script will load in alphabetical order) and if not (perhaps
    // an install is only using `htmlbars`, not `handlebars`) then this will still
    // allow HTMLBars to participate in the auto-detection
    // worse case someone will have HTMLbars and handlebars competing for the same
    // content and will need to change their setup to only require handlebars, but
    // I don't consider this a breaking change
    if (hljs.getLanguage("handlebars")) definition.disableAutodetect = true;
    return definition;
}
module.exports = $26f6c29aa5226463$var$htmlbars;

});

parcelRegister("dFhmZ", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $9f2c93feb9a29482$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $9f2c93feb9a29482$var$concat(...args) {
    const joined = args.map((x)=>$9f2c93feb9a29482$var$source(x)).join("");
    return joined;
}
/*
Language: HTTP
Description: HTTP request and response headers with automatic body highlighting
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: common, protocols
Website: https://developer.mozilla.org/en-US/docs/Web/HTTP/Overview
*/ function $9f2c93feb9a29482$var$http(hljs) {
    const VERSION = "HTTP/(2|1\\.[01])";
    const HEADER_NAME = /[A-Za-z][A-Za-z0-9-]*/;
    const HEADER = {
        className: "attribute",
        begin: $9f2c93feb9a29482$var$concat("^", HEADER_NAME, "(?=\\:\\s)"),
        starts: {
            contains: [
                {
                    className: "punctuation",
                    begin: /: /,
                    relevance: 0,
                    starts: {
                        end: "$",
                        relevance: 0
                    }
                }
            ]
        }
    };
    const HEADERS_AND_BODY = [
        HEADER,
        {
            begin: "\\n\\n",
            starts: {
                subLanguage: [],
                endsWithParent: true
            }
        }
    ];
    return {
        name: "HTTP",
        aliases: [
            "https"
        ],
        illegal: /\S/,
        contains: [
            // response
            {
                begin: "^(?=" + VERSION + " \\d{3})",
                end: /$/,
                contains: [
                    {
                        className: "meta",
                        begin: VERSION
                    },
                    {
                        className: "number",
                        begin: "\\b\\d{3}\\b"
                    }
                ],
                starts: {
                    end: /\b\B/,
                    illegal: /\S/,
                    contains: HEADERS_AND_BODY
                }
            },
            // request
            {
                begin: "(?=^[A-Z]+ (.*?) " + VERSION + "$)",
                end: /$/,
                contains: [
                    {
                        className: "string",
                        begin: " ",
                        end: " ",
                        excludeBegin: true,
                        excludeEnd: true
                    },
                    {
                        className: "meta",
                        begin: VERSION
                    },
                    {
                        className: "keyword",
                        begin: "[A-Z]+"
                    }
                ],
                starts: {
                    end: /\b\B/,
                    illegal: /\S/,
                    contains: HEADERS_AND_BODY
                }
            },
            // to allow headers to work even without a preamble
            hljs.inherit(HEADER, {
                relevance: 0
            })
        ]
    };
}
module.exports = $9f2c93feb9a29482$var$http;

});

parcelRegister("43oHJ", function(module, exports) {
/*
Language: Hy
Description: Hy is a wonderful dialect of Lisp that’s embedded in Python.
Author: Sergey Sobko <s.sobko@profitware.ru>
Website: http://docs.hylang.org/en/stable/
Category: lisp
*/ function $2f3a9b04d75c057a$var$hy(hljs) {
    var SYMBOLSTART = "a-zA-Z_\\-!.?+*=<>&#'";
    var SYMBOL_RE = "[" + SYMBOLSTART + "][" + SYMBOLSTART + "0-9/;:]*";
    var keywords = {
        $pattern: SYMBOL_RE,
        "builtin-name": // keywords
        "!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"
    };
    var SIMPLE_NUMBER_RE = "[-+]?\\d+(\\.\\d+)?";
    var SYMBOL = {
        begin: SYMBOL_RE,
        relevance: 0
    };
    var NUMBER = {
        className: "number",
        begin: SIMPLE_NUMBER_RE,
        relevance: 0
    };
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    var COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    var LITERAL = {
        className: "literal",
        begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
    };
    var COLLECTION = {
        begin: "[\\[\\{]",
        end: "[\\]\\}]"
    };
    var HINT = {
        className: "comment",
        begin: "\\^" + SYMBOL_RE
    };
    var HINT_COL = hljs.COMMENT("\\^\\{", "\\}");
    var KEY = {
        className: "symbol",
        begin: "[:]{1,2}" + SYMBOL_RE
    };
    var LIST = {
        begin: "\\(",
        end: "\\)"
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    var NAME = {
        className: "name",
        relevance: 0,
        keywords: keywords,
        begin: SYMBOL_RE,
        starts: BODY
    };
    var DEFAULT_CONTAINS = [
        LIST,
        STRING,
        HINT,
        HINT_COL,
        COMMENT,
        KEY,
        COLLECTION,
        NUMBER,
        LITERAL,
        SYMBOL
    ];
    LIST.contains = [
        hljs.COMMENT("comment", ""),
        NAME,
        BODY
    ];
    BODY.contains = DEFAULT_CONTAINS;
    COLLECTION.contains = DEFAULT_CONTAINS;
    return {
        name: "Hy",
        aliases: [
            "hylang"
        ],
        illegal: /\S/,
        contains: [
            hljs.SHEBANG(),
            LIST,
            STRING,
            HINT,
            HINT_COL,
            COMMENT,
            KEY,
            COLLECTION,
            NUMBER,
            LITERAL
        ]
    };
}
module.exports = $2f3a9b04d75c057a$var$hy;

});

parcelRegister("c9gLT", function(module, exports) {
/*
Language: Inform 7
Author: Bruno Dias <bruno.r.dias@gmail.com>
Description: Language definition for Inform 7, a DSL for writing parser interactive fiction.
Website: http://inform7.com
*/ function $8d8355c71a7140fa$var$inform7(hljs) {
    const START_BRACKET = "\\[";
    const END_BRACKET = "\\]";
    return {
        name: "Inform 7",
        aliases: [
            "i7"
        ],
        case_insensitive: true,
        keywords: {
            // Some keywords more or less unique to I7, for relevance.
            keyword: // kind:
            "thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"
        },
        contains: [
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0,
                contains: [
                    {
                        className: "subst",
                        begin: START_BRACKET,
                        end: END_BRACKET
                    }
                ]
            },
            {
                className: "section",
                begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
                end: "$"
            },
            {
                // Rule definition
                // This is here for relevance.
                begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
                end: ":",
                contains: [
                    {
                        // Rule name
                        begin: "\\(This",
                        end: "\\)"
                    }
                ]
            },
            {
                className: "comment",
                begin: START_BRACKET,
                end: END_BRACKET,
                contains: [
                    "self"
                ]
            }
        ]
    };
}
module.exports = $8d8355c71a7140fa$var$inform7;

});

parcelRegister("3oDqc", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $2792314cbce94b15$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $2792314cbce94b15$var$lookahead(re) {
    return $2792314cbce94b15$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $2792314cbce94b15$var$concat(...args) {
    const joined = args.map((x)=>$2792314cbce94b15$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $2792314cbce94b15$var$either(...args) {
    const joined = "(" + args.map((x)=>$2792314cbce94b15$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: TOML, also INI
Description: TOML aims to be a minimal configuration file format that's easy to read due to obvious semantics.
Contributors: Guillaume Gomez <guillaume1.gomez@gmail.com>
Category: common, config
Website: https://github.com/toml-lang/toml
*/ function $2792314cbce94b15$var$ini(hljs) {
    const NUMBERS = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: /([+-]+)?[\d]+_[\d_]+/
            },
            {
                begin: hljs.NUMBER_RE
            }
        ]
    };
    const COMMENTS = hljs.COMMENT();
    COMMENTS.variants = [
        {
            begin: /;/,
            end: /$/
        },
        {
            begin: /#/,
            end: /$/
        }
    ];
    const VARIABLES = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d"][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)\}/
            }
        ]
    };
    const LITERALS = {
        className: "literal",
        begin: /\bon|off|true|false|yes|no\b/
    };
    const STRINGS = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: "'''",
                end: "'''",
                relevance: 10
            },
            {
                begin: '"""',
                end: '"""',
                relevance: 10
            },
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            }
        ]
    };
    const ARRAY = {
        begin: /\[/,
        end: /\]/,
        contains: [
            COMMENTS,
            LITERALS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            "self"
        ],
        relevance: 0
    };
    const BARE_KEY = /[A-Za-z0-9_-]+/;
    const QUOTED_KEY_DOUBLE_QUOTE = /"(\\"|[^"])*"/;
    const QUOTED_KEY_SINGLE_QUOTE = /'[^']*'/;
    const ANY_KEY = $2792314cbce94b15$var$either(BARE_KEY, QUOTED_KEY_DOUBLE_QUOTE, QUOTED_KEY_SINGLE_QUOTE);
    const DOTTED_KEY = $2792314cbce94b15$var$concat(ANY_KEY, "(\\s*\\.\\s*", ANY_KEY, ")*", $2792314cbce94b15$var$lookahead(/\s*=\s*[^#\s]/));
    return {
        name: "TOML, also INI",
        aliases: [
            "toml"
        ],
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            COMMENTS,
            {
                className: "section",
                begin: /\[+/,
                end: /\]+/
            },
            {
                begin: DOTTED_KEY,
                className: "attr",
                starts: {
                    end: /$/,
                    contains: [
                        COMMENTS,
                        ARRAY,
                        LITERALS,
                        VARIABLES,
                        STRINGS,
                        NUMBERS
                    ]
                }
            }
        ]
    };
}
module.exports = $2792314cbce94b15$var$ini;

});

parcelRegister("gM8oT", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $c367a536531c65d3$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $c367a536531c65d3$var$concat(...args) {
    const joined = args.map((x)=>$c367a536531c65d3$var$source(x)).join("");
    return joined;
}
/*
Language: IRPF90
Author: Anthony Scemama <scemama@irsamc.ups-tlse.fr>
Description: IRPF90 is an open-source Fortran code generator
Website: http://irpf90.ups-tlse.fr
Category: scientific
*/ /** @type LanguageFn */ function $c367a536531c65d3$var$irpf90(hljs) {
    const PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    // regex in both fortran and irpf90 should match
    const OPTIONAL_NUMBER_SUFFIX = /(_[a-z_\d]+)?/;
    const OPTIONAL_NUMBER_EXP = /([de][+-]?\d+)?/;
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: $c367a536531c65d3$var$concat(/\b\d+/, /\.(\d*)/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            },
            {
                begin: $c367a536531c65d3$var$concat(/\b\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            },
            {
                begin: $c367a536531c65d3$var$concat(/\.\d+/, OPTIONAL_NUMBER_EXP, OPTIONAL_NUMBER_SUFFIX)
            }
        ],
        relevance: 0
    };
    const F_KEYWORDS = {
        literal: ".False. .True.",
        keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",
        built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"
    };
    return {
        name: "IRPF90",
        case_insensitive: true,
        keywords: F_KEYWORDS,
        illegal: /\/\*/,
        contains: [
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "subroutine function program",
                illegal: "[${=\\n]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS
                ]
            },
            hljs.COMMENT("!", "$", {
                relevance: 0
            }),
            hljs.COMMENT("begin_doc", "end_doc", {
                relevance: 10
            }),
            NUMBER
        ]
    };
}
module.exports = $c367a536531c65d3$var$irpf90;

});

parcelRegister("ewc1c", function(module, exports) {
/*
Language: ISBL
Author: Dmitriy Tarasov <dimatar@gmail.com>
Description: built-in language DIRECTUM
Category: enterprise
*/ function $a91d606cfe9b3e8e$var$isbl(hljs) {
    // Определение идентификаторов
    const UNDERSCORE_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_!][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*";
    // Определение имен функций
    const FUNCTION_NAME_IDENT_RE = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*";
    // keyword : ключевые слова
    const KEYWORD = "and \u0438 else \u0438\u043D\u0430\u0447\u0435 endexcept endfinally endforeach \u043A\u043E\u043D\u0435\u0446\u0432\u0441\u0435 endif \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 endwhile \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043A\u0430 except exitfor finally foreach \u0432\u0441\u0435 if \u0435\u0441\u043B\u0438 in \u0432 not \u043D\u0435 or \u0438\u043B\u0438 try while \u043F\u043E\u043A\u0430 ";
    // SYSRES Constants
    const sysres_constants = "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE ";
    // Base constant
    const base_constants = "CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE ";
    // Base group name
    const base_group_name_constants = "ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME ";
    // Decision block properties
    const decision_block_properties_constants = "DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY ";
    // File extension
    const file_extension_constants = "ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION ";
    // Job block properties
    const job_block_properties_constants = "JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY ";
    // Language code
    const language_code_constants = "ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE ";
    // Launching external applications
    const launching_external_applications_constants = "smHidden smMaximized smMinimized smNormal wmNo wmYes ";
    // Link kind
    const link_kind_constants = "COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND ";
    // Lock type
    const lock_type_constants = "COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE ";
    // Monitor block properties
    const monitor_block_properties_constants = "MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY ";
    // Notice block properties
    const notice_block_properties_constants = "NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY ";
    // Object events
    const object_events_constants = "dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT ";
    // Object params
    const object_params_constants = "CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM ";
    // Other
    const other_constants = "ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME ";
    // Privileges
    const privileges_constants = "PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE ";
    // Pseudoreference code
    const pseudoreference_code_constants = "ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE ";
    // Requisite ISBCertificateType values
    const requisite_ISBCertificateType_values_constants = "CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT ";
    // Requisite ISBEDocStorageType values
    const requisite_ISBEDocStorageType_values_constants = "STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER ";
    // Requisite CompType2 values
    const requisite_compType2_values_constants = "COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE ";
    // Requisite name
    const requisite_name_constants = "SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STAT\u0415 SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID ";
    // Result
    const result_constants = "RESULT_VAR_NAME RESULT_VAR_NAME_ENG ";
    // Rule identification
    const rule_identification_constants = "AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID ";
    // Script block properties
    const script_block_properties_constants = "SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY ";
    // Subtask block properties
    const subtask_block_properties_constants = "SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY ";
    // System component
    const system_component_constants = "SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS ";
    // System dialogs
    const system_dialogs_constants = "SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS ";
    // System reference names
    const system_reference_names_constants = "SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS ";
    // Table name
    const table_name_constants = "ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME ";
    // Test
    const test_constants = "TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME ";
    // Using the dialog windows
    const using_the_dialog_windows_constants = "ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk ";
    // Using the document
    const using_the_document_constants = "EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE ";
    // Using the EA and encryption
    const using_the_EA_and_encryption_constants = "cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate ";
    // Using the ISBL-editor
    const using_the_ISBL_editor_constants = "ISBL_SYNTAX NO_SYNTAX XML_SYNTAX ";
    // Wait block properties
    const wait_block_properties_constants = "WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY ";
    // SYSRES Common
    const sysres_common_constants = "SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP ";
    // Константы ==> built_in
    const CONSTANTS = sysres_constants + base_constants + base_group_name_constants + decision_block_properties_constants + file_extension_constants + job_block_properties_constants + language_code_constants + launching_external_applications_constants + link_kind_constants + lock_type_constants + monitor_block_properties_constants + notice_block_properties_constants + object_events_constants + object_params_constants + other_constants + privileges_constants + pseudoreference_code_constants + requisite_ISBCertificateType_values_constants + requisite_ISBEDocStorageType_values_constants + requisite_compType2_values_constants + requisite_name_constants + result_constants + rule_identification_constants + script_block_properties_constants + subtask_block_properties_constants + system_component_constants + system_dialogs_constants + system_reference_names_constants + table_name_constants + test_constants + using_the_dialog_windows_constants + using_the_document_constants + using_the_EA_and_encryption_constants + using_the_ISBL_editor_constants + wait_block_properties_constants + sysres_common_constants;
    // enum TAccountType
    const TAccountType = "atUser atGroup atRole ";
    // enum TActionEnabledMode
    const TActionEnabledMode = "aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty ";
    // enum TAddPosition
    const TAddPosition = "apBegin apEnd ";
    // enum TAlignment
    const TAlignment = "alLeft alRight ";
    // enum TAreaShowMode
    const TAreaShowMode = "asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways ";
    // enum TCertificateInvalidationReason
    const TCertificateInvalidationReason = "cirCommon cirRevoked ";
    // enum TCertificateType
    const TCertificateType = "ctSignature ctEncode ctSignatureEncode ";
    // enum TCheckListBoxItemState
    const TCheckListBoxItemState = "clbUnchecked clbChecked clbGrayed ";
    // enum TCloseOnEsc
    const TCloseOnEsc = "ceISB ceAlways ceNever ";
    // enum TCompType
    const TCompType = "ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob ";
    // enum TConditionFormat
    const TConditionFormat = "cfInternal cfDisplay ";
    // enum TConnectionIntent
    const TConnectionIntent = "ciUnspecified ciWrite ciRead ";
    // enum TContentKind
    const TContentKind = "ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog ";
    // enum TControlType
    const TControlType = "ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton ";
    // enum TCriterionContentType
    const TCriterionContentType = "cctDate cctInteger cctNumeric cctPick cctReference cctString cctText ";
    // enum TCultureType
    const TCultureType = "cltInternal cltPrimary cltGUI ";
    // enum TDataSetEventType
    const TDataSetEventType = "dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange ";
    // enum TDataSetState
    const TDataSetState = "dssEdit dssInsert dssBrowse dssInActive ";
    // enum TDateFormatType
    const TDateFormatType = "dftDate dftShortDate dftDateTime dftTimeStamp ";
    // enum TDateOffsetType
    const TDateOffsetType = "dotDays dotHours dotMinutes dotSeconds ";
    // enum TDateTimeKind
    const TDateTimeKind = "dtkndLocal dtkndUTC ";
    // enum TDeaAccessRights
    const TDeaAccessRights = "arNone arView arEdit arFull ";
    // enum TDocumentDefaultAction
    const TDocumentDefaultAction = "ddaView ddaEdit ";
    // enum TEditMode
    const TEditMode = "emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode ";
    // enum TEditorCloseObservType
    const TEditorCloseObservType = "ecotFile ecotProcess ";
    // enum TEdmsApplicationAction
    const TEdmsApplicationAction = "eaGet eaCopy eaCreate eaCreateStandardRoute ";
    // enum TEDocumentLockType
    const TEDocumentLockType = "edltAll edltNothing edltQuery ";
    // enum TEDocumentStepShowMode
    const TEDocumentStepShowMode = "essmText essmCard ";
    // enum TEDocumentStepVersionType
    const TEDocumentStepVersionType = "esvtLast esvtLastActive esvtSpecified ";
    // enum TEDocumentStorageFunction
    const TEDocumentStorageFunction = "edsfExecutive edsfArchive ";
    // enum TEDocumentStorageType
    const TEDocumentStorageType = "edstSQLServer edstFile ";
    // enum TEDocumentVersionSourceType
    const TEDocumentVersionSourceType = "edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile ";
    // enum TEDocumentVersionState
    const TEDocumentVersionState = "vsDefault vsDesign vsActive vsObsolete ";
    // enum TEncodeType
    const TEncodeType = "etNone etCertificate etPassword etCertificatePassword ";
    // enum TExceptionCategory
    const TExceptionCategory = "ecException ecWarning ecInformation ";
    // enum TExportedSignaturesType
    const TExportedSignaturesType = "estAll estApprovingOnly ";
    // enum TExportedVersionType
    const TExportedVersionType = "evtLast evtLastActive evtQuery ";
    // enum TFieldDataType
    const TFieldDataType = "fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger ";
    // enum TFolderType
    const TFolderType = "ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch ";
    // enum TGridRowHeight
    const TGridRowHeight = "grhAuto grhX1 grhX2 grhX3 ";
    // enum THyperlinkType
    const THyperlinkType = "hltText hltRTF hltHTML ";
    // enum TImageFileFormat
    const TImageFileFormat = "iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG ";
    // enum TImageMode
    const TImageMode = "im8bGrayscale im24bRGB im1bMonochrome ";
    // enum TImageType
    const TImageType = "itBMP itJPEG itWMF itPNG ";
    // enum TInplaceHintKind
    const TInplaceHintKind = "ikhInformation ikhWarning ikhError ikhNoIcon ";
    // enum TISBLContext
    const TISBLContext = "icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler ";
    // enum TItemShow
    const TItemShow = "isShow isHide isByUserSettings ";
    // enum TJobKind
    const TJobKind = "jkJob jkNotice jkControlJob ";
    // enum TJoinType
    const TJoinType = "jtInner jtLeft jtRight jtFull jtCross ";
    // enum TLabelPos
    const TLabelPos = "lbpAbove lbpBelow lbpLeft lbpRight ";
    // enum TLicensingType
    const TLicensingType = "eltPerConnection eltPerUser ";
    // enum TLifeCycleStageFontColor
    const TLifeCycleStageFontColor = "sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac ";
    // enum TLifeCycleStageFontStyle
    const TLifeCycleStageFontStyle = "sfsItalic sfsStrikeout sfsNormal ";
    // enum TLockableDevelopmentComponentType
    const TLockableDevelopmentComponentType = "ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents ";
    // enum TMaxRecordCountRestrictionType
    const TMaxRecordCountRestrictionType = "mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom ";
    // enum TRangeValueType
    const TRangeValueType = "vtEqual vtGreaterOrEqual vtLessOrEqual vtRange ";
    // enum TRelativeDate
    const TRelativeDate = "rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth ";
    // enum TReportDestination
    const TReportDestination = "rdWindow rdFile rdPrinter ";
    // enum TReqDataType
    const TReqDataType = "rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument ";
    // enum TRequisiteEventType
    const TRequisiteEventType = "reOnChange reOnChangeValues ";
    // enum TSBTimeType
    const TSBTimeType = "ttGlobal ttLocal ttUser ttSystem ";
    // enum TSearchShowMode
    const TSearchShowMode = "ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal ";
    // enum TSelectMode
    const TSelectMode = "smSelect smLike smCard ";
    // enum TSignatureType
    const TSignatureType = "stNone stAuthenticating stApproving ";
    // enum TSignerContentType
    const TSignerContentType = "sctString sctStream ";
    // enum TStringsSortType
    const TStringsSortType = "sstAnsiSort sstNaturalSort ";
    // enum TStringValueType
    const TStringValueType = "svtEqual svtContain ";
    // enum TStructuredObjectAttributeType
    const TStructuredObjectAttributeType = "soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown ";
    // enum TTaskAbortReason
    const TTaskAbortReason = "tarAbortByUser tarAbortByWorkflowException ";
    // enum TTextValueType
    const TTextValueType = "tvtAllWords tvtExactPhrase tvtAnyWord ";
    // enum TUserObjectStatus
    const TUserObjectStatus = "usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp ";
    // enum TUserType
    const TUserType = "utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected ";
    // enum TValuesBuildType
    const TValuesBuildType = "btAnd btDetailAnd btOr btNotOr btOnly ";
    // enum TViewMode
    const TViewMode = "vmView vmSelect vmNavigation ";
    // enum TViewSelectionMode
    const TViewSelectionMode = "vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection ";
    // enum TWizardActionType
    const TWizardActionType = "wfatPrevious wfatNext wfatCancel wfatFinish ";
    // enum TWizardFormElementProperty
    const TWizardFormElementProperty = "wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 ";
    // enum TWizardFormElementType
    const TWizardFormElementType = "wfetQueryParameter wfetText wfetDelimiter wfetLabel ";
    // enum TWizardParamType
    const TWizardParamType = "wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate ";
    // enum TWizardStepResult
    const TWizardStepResult = "wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal ";
    // enum TWizardStepType
    const TWizardStepType = "wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal ";
    // enum TWorkAccessType
    const TWorkAccessType = "waAll waPerformers waManual ";
    // enum TWorkflowBlockType
    const TWorkflowBlockType = "wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause ";
    // enum TWorkflowDataType
    const TWorkflowDataType = "wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection ";
    // enum TWorkImportance
    const TWorkImportance = "wiLow wiNormal wiHigh ";
    // enum TWorkRouteType
    const TWorkRouteType = "wrtSoft wrtHard ";
    // enum TWorkState
    const TWorkState = "wsInit wsRunning wsDone wsControlled wsAborted wsContinued ";
    // enum TWorkTextBuildingMode
    const TWorkTextBuildingMode = "wtmFull wtmFromCurrent wtmOnlyCurrent ";
    // Перечисления
    const ENUMS = TAccountType + TActionEnabledMode + TAddPosition + TAlignment + TAreaShowMode + TCertificateInvalidationReason + TCertificateType + TCheckListBoxItemState + TCloseOnEsc + TCompType + TConditionFormat + TConnectionIntent + TContentKind + TControlType + TCriterionContentType + TCultureType + TDataSetEventType + TDataSetState + TDateFormatType + TDateOffsetType + TDateTimeKind + TDeaAccessRights + TDocumentDefaultAction + TEditMode + TEditorCloseObservType + TEdmsApplicationAction + TEDocumentLockType + TEDocumentStepShowMode + TEDocumentStepVersionType + TEDocumentStorageFunction + TEDocumentStorageType + TEDocumentVersionSourceType + TEDocumentVersionState + TEncodeType + TExceptionCategory + TExportedSignaturesType + TExportedVersionType + TFieldDataType + TFolderType + TGridRowHeight + THyperlinkType + TImageFileFormat + TImageMode + TImageType + TInplaceHintKind + TISBLContext + TItemShow + TJobKind + TJoinType + TLabelPos + TLicensingType + TLifeCycleStageFontColor + TLifeCycleStageFontStyle + TLockableDevelopmentComponentType + TMaxRecordCountRestrictionType + TRangeValueType + TRelativeDate + TReportDestination + TReqDataType + TRequisiteEventType + TSBTimeType + TSearchShowMode + TSelectMode + TSignatureType + TSignerContentType + TStringsSortType + TStringValueType + TStructuredObjectAttributeType + TTaskAbortReason + TTextValueType + TUserObjectStatus + TUserType + TValuesBuildType + TViewMode + TViewSelectionMode + TWizardActionType + TWizardFormElementProperty + TWizardFormElementType + TWizardParamType + TWizardStepResult + TWizardStepType + TWorkAccessType + TWorkflowBlockType + TWorkflowDataType + TWorkImportance + TWorkRouteType + TWorkState + TWorkTextBuildingMode;
    // Системные функции ==> SYSFUNCTIONS
    const system_functions = "AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory \u0410\u043D\u0430\u043B\u0438\u0437 \u0411\u0430\u0437\u0430\u0414\u0430\u043D\u043D\u044B\u0445 \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0418\u043D\u0444\u043E \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0412\u0432\u043E\u0434 \u0412\u0432\u043E\u0434\u041C\u0435\u043D\u044E \u0412\u0435\u0434\u0421 \u0412\u0435\u0434\u0421\u043F\u0440 \u0412\u0435\u0440\u0445\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0412\u043D\u0435\u0448\u041F\u0440\u043E\u0433\u0440 \u0412\u043E\u0441\u0441\u0442 \u0412\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F\u041F\u0430\u043F\u043A\u0430 \u0412\u0440\u0435\u043C\u044F \u0412\u044B\u0431\u043E\u0440SQL \u0412\u044B\u0431\u0440\u0430\u0442\u044C\u0417\u0430\u043F\u0438\u0441\u044C \u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C\u0421\u0442\u0440 \u0412\u044B\u0437\u0432\u0430\u0442\u044C \u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0412\u044B\u043F\u041F\u0440\u043E\u0433\u0440 \u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439\u0424\u0430\u0439\u043B \u0413\u0440\u0443\u043F\u043F\u0430\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F\u0421\u0435\u0440\u0432 \u0414\u0435\u043D\u044C\u041D\u0435\u0434\u0435\u043B\u0438 \u0414\u0438\u0430\u043B\u043E\u0433\u0414\u0430\u041D\u0435\u0442 \u0414\u043B\u0438\u043D\u0430\u0421\u0442\u0440 \u0414\u043E\u0431\u041F\u043E\u0434\u0441\u0442\u0440 \u0415\u041F\u0443\u0441\u0442\u043E \u0415\u0441\u043B\u0438\u0422\u043E \u0415\u0427\u0438\u0441\u043B\u043E \u0417\u0430\u043C\u041F\u043E\u0434\u0441\u0442\u0440 \u0417\u0430\u043F\u0438\u0441\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0417\u043D\u0430\u0447\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u0414\u0422\u0438\u043F\u0421\u043F\u0440 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0414\u0438\u0441\u043A \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0418\u043C\u044F\u0424\u0430\u0439\u043B\u0430 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u041F\u0443\u0442\u044C \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0418\u0437\u043C\u0414\u0430\u0442 \u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0420\u0430\u0437\u043C\u0435\u0440\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u043C\u044F\u041E\u0440\u0433 \u0418\u043C\u044F\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u043D\u0434\u0435\u043A\u0441 \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0428\u0430\u0433 \u0418\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439\u0420\u0435\u0436\u0438\u043C \u0418\u0442\u043E\u0433\u0422\u0431\u043B\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0412\u0435\u0434\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0421\u043F\u0440\u041F\u043E\u0418\u0414 \u041A\u043E\u0434\u041F\u043EAnalit \u041A\u043E\u0434\u0421\u0438\u043C\u0432\u043E\u043B\u0430 \u041A\u043E\u0434\u0421\u043F\u0440 \u041A\u043E\u043B\u041F\u043E\u0434\u0441\u0442\u0440 \u041A\u043E\u043B\u041F\u0440\u043E\u043F \u041A\u043E\u043D\u041C\u0435\u0441 \u041A\u043E\u043D\u0441\u0442 \u041A\u043E\u043D\u0441\u0442\u0415\u0441\u0442\u044C \u041A\u043E\u043D\u0441\u0442\u0417\u043D\u0430\u0447 \u041A\u043E\u043D\u0422\u0440\u0430\u043D \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041A\u043E\u043F\u0438\u044F\u0421\u0442\u0440 \u041A\u041F\u0435\u0440\u0438\u043E\u0434 \u041A\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u043A\u0441 \u041C\u0430\u043A\u0441\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u0441\u0441\u0438\u0432 \u041C\u0435\u043D\u044E \u041C\u0435\u043D\u044E\u0420\u0430\u0441\u0448 \u041C\u0438\u043D \u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u041D\u0430\u0439\u0442\u0438\u0420\u0430\u0441\u0448 \u041D\u0430\u0438\u043C\u0412\u0438\u0434\u0421\u043F\u0440 \u041D\u0430\u0438\u043C\u041F\u043EAnalit \u041D\u0430\u0438\u043C\u0421\u043F\u0440 \u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C\u041F\u0435\u0440\u0435\u0432\u043E\u0434\u044B\u0421\u0442\u0440\u043E\u043A \u041D\u0430\u0447\u041C\u0435\u0441 \u041D\u0430\u0447\u0422\u0440\u0430\u043D \u041D\u0438\u0436\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u041D\u043E\u043C\u0435\u0440\u0421\u043F\u0440 \u041D\u041F\u0435\u0440\u0438\u043E\u0434 \u041E\u043A\u043D\u043E \u041E\u043A\u0440 \u041E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u041E\u0442\u043B\u0418\u043D\u0444\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u041E\u0442\u043B\u0418\u043D\u0444\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u041E\u0442\u0447\u0435\u0442 \u041E\u0442\u0447\u0435\u0442\u0410\u043D\u0430\u043B \u041E\u0442\u0447\u0435\u0442\u0418\u043D\u0442 \u041F\u0430\u043F\u043A\u0430\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u041F\u0430\u0443\u0437\u0430 \u041F\u0412\u044B\u0431\u043E\u0440SQL \u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u0421\u0442\u0440 \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0418\u0414\u0422\u0430\u0431\u043B\u0438\u0446\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u0414 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u043C\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0421\u0442\u0430\u0442\u0443\u0441 \u041F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0417\u043D\u0430\u0447 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u0423\u0441\u043B\u043E\u0432\u0438\u0435 \u0420\u0430\u0437\u0431\u0421\u0442\u0440 \u0420\u0430\u0437\u043D\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0414\u0430\u0442 \u0420\u0430\u0437\u043D\u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0420\u0430\u0431\u0412\u0440\u0435\u043C\u044F \u0420\u0435\u0433\u0423\u0441\u0442\u0412\u0440\u0435\u043C \u0420\u0435\u0433\u0423\u0441\u0442\u0414\u0430\u0442 \u0420\u0435\u0433\u0423\u0441\u0442\u0427\u0441\u043B \u0420\u0435\u0434\u0422\u0435\u043A\u0441\u0442 \u0420\u0435\u0435\u0441\u0442\u0440\u0417\u0430\u043F\u0438\u0441\u044C \u0420\u0435\u0435\u0441\u0442\u0440\u0421\u043F\u0438\u0441\u043E\u043A\u0418\u043C\u0435\u043D\u041F\u0430\u0440\u0430\u043C \u0420\u0435\u0435\u0441\u0442\u0440\u0427\u0442\u0435\u043D\u0438\u0435 \u0420\u0435\u043A\u0432\u0421\u043F\u0440 \u0420\u0435\u043A\u0432\u0421\u043F\u0440\u041F\u0440 \u0421\u0435\u0433\u043E\u0434\u043D\u044F \u0421\u0435\u0439\u0447\u0430\u0441 \u0421\u0435\u0440\u0432\u0435\u0440 \u0421\u0435\u0440\u0432\u0435\u0440\u041F\u0440\u043E\u0446\u0435\u0441\u0441\u0418\u0414 \u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0421\u0436\u041F\u0440\u043E\u0431 \u0421\u0438\u043C\u0432\u043E\u043B \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0414\u0438\u0440\u0435\u043A\u0442\u0443\u043C\u041A\u043E\u0434 \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u041A\u043E\u0434 \u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u0418\u0437\u0414\u0432\u0443\u0445\u0421\u043F\u0438\u0441\u043A\u043E\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u041F\u0430\u043F\u043A\u0438 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0417\u0430\u043F\u0440\u043E\u0441 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041A\u044D\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041C\u0430\u0441\u0441\u0438\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0431\u044A\u0435\u043A\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0442\u0447\u0435\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041F\u0430\u043F\u043A\u0443 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0442\u0440\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u043E\u0437\u0434\u0421\u043F\u0440 \u0421\u043E\u0441\u0442\u0421\u043F\u0440 \u0421\u043E\u0445\u0440 \u0421\u043E\u0445\u0440\u0421\u043F\u0440 \u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0438\u0441\u0442\u0435\u043C \u0421\u043F\u0440 \u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u0418\u0437\u043C\u041D\u0430\u0431\u0414\u0430\u043D \u0421\u043F\u0440\u041A\u043E\u0434 \u0421\u043F\u0440\u041D\u043E\u043C\u0435\u0440 \u0421\u043F\u0440\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u041F\u0430\u0440\u0430\u043C \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0417\u043D\u0430\u0447 \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0418\u043C\u044F \u0421\u043F\u0440\u0420\u0435\u043A\u0432 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0412\u0432\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041D\u043E\u0432\u044B\u0435 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0420\u0435\u0436\u0438\u043C \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0422\u0438\u043F\u0422\u0435\u043A\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0421\u043F\u0440\u0421\u043E\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u0422\u0431\u043B\u0418\u0442\u043E\u0433 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041A\u043E\u043B \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0430\u043A\u0441 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0438\u043D \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041F\u0440\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043B\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043E\u0437\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0423\u0434 \u0421\u043F\u0440\u0422\u0435\u043A\u041F\u0440\u0435\u0434\u0441\u0442 \u0421\u043F\u0440\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C\u0421\u0442\u0440 \u0421\u0442\u0440\u0412\u0435\u0440\u0445\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u041D\u0438\u0436\u043D\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0421\u0443\u043C\u041F\u0440\u043E\u043F \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439\u041F\u0430\u0440\u0430\u043C \u0422\u0435\u043A\u0412\u0435\u0440\u0441\u0438\u044F \u0422\u0435\u043A\u041E\u0440\u0433 \u0422\u043E\u0447\u043D \u0422\u0440\u0430\u043D \u0422\u0440\u0430\u043D\u0441\u043B\u0438\u0442\u0435\u0440\u0430\u0446\u0438\u044F \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0422\u0430\u0431\u043B\u0438\u0446\u0443 \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u0423\u0434\u0421\u043F\u0440 \u0423\u0434\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0423\u0441\u0442 \u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438\u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442 \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0417\u0430\u043D\u044F\u0442 \u0424\u0430\u0439\u043B\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0418\u0441\u043A\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041C\u043E\u0436\u043D\u043E\u0427\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0424\u0430\u0439\u043B\u0420\u0430\u0437\u043C\u0435\u0440 \u0424\u0430\u0439\u043B\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0441\u044B\u043B\u043A\u0430\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0424\u043C\u0442SQL\u0414\u0430\u0442 \u0424\u043C\u0442\u0414\u0430\u0442 \u0424\u043C\u0442\u0421\u0442\u0440 \u0424\u043C\u0442\u0427\u0441\u043B \u0424\u043E\u0440\u043C\u0430\u0442 \u0426\u041C\u0430\u0441\u0441\u0438\u0432\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0426\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442 \u0426\u041F\u043E\u0434\u0441\u0442\u0440 ";
    // Предопределенные переменные ==> built_in
    const predefined_variables = "AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work \u0412\u044B\u0437\u043E\u0432\u0421\u043F\u043E\u0441\u043E\u0431 \u0418\u043C\u044F\u041E\u0442\u0447\u0435\u0442\u0430 \u0420\u0435\u043A\u0432\u0417\u043D\u0430\u0447 ";
    // Интерфейсы ==> type
    const interfaces = "IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ";
    // built_in : встроенные или библиотечные объекты (константы, перечисления)
    const BUILTIN = CONSTANTS + ENUMS;
    // class: встроенные наборы значений, системные объекты, фабрики
    const CLASS = predefined_variables;
    // literal : примитивные типы
    const LITERAL = "null true false nil ";
    // number : числа
    const NUMBERS = {
        className: "number",
        begin: hljs.NUMBER_RE,
        relevance: 0
    };
    // string : строки
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            }
        ]
    };
    // Токены
    const DOCTAGS = {
        className: "doctag",
        begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
        relevance: 0
    };
    // Однострочный комментарий
    const ISBL_LINE_COMMENT_MODE = {
        className: "comment",
        begin: "//",
        end: "$",
        relevance: 0,
        contains: [
            hljs.PHRASAL_WORDS_MODE,
            DOCTAGS
        ]
    };
    // Многострочный комментарий
    const ISBL_BLOCK_COMMENT_MODE = {
        className: "comment",
        begin: "/\\*",
        end: "\\*/",
        relevance: 0,
        contains: [
            hljs.PHRASAL_WORDS_MODE,
            DOCTAGS
        ]
    };
    // comment : комментарии
    const COMMENTS = {
        variants: [
            ISBL_LINE_COMMENT_MODE,
            ISBL_BLOCK_COMMENT_MODE
        ]
    };
    // keywords : ключевые слова
    const KEYWORDS = {
        $pattern: UNDERSCORE_IDENT_RE,
        keyword: KEYWORD,
        built_in: BUILTIN,
        class: CLASS,
        literal: LITERAL
    };
    // methods : методы
    const METHODS = {
        begin: "\\.\\s*" + hljs.UNDERSCORE_IDENT_RE,
        keywords: KEYWORDS,
        relevance: 0
    };
    // type : встроенные типы
    const TYPES = {
        className: "type",
        begin: ":[ \\t]*(" + interfaces.trim().replace(/\s/g, "|") + ")",
        end: "[ \\t]*=",
        excludeEnd: true
    };
    // variables : переменные
    const VARIABLES = {
        className: "variable",
        keywords: KEYWORDS,
        begin: UNDERSCORE_IDENT_RE,
        relevance: 0,
        contains: [
            TYPES,
            METHODS
        ]
    };
    // Имена функций
    const FUNCTION_TITLE = FUNCTION_NAME_IDENT_RE + "\\(";
    const TITLE_MODE = {
        className: "title",
        keywords: {
            $pattern: UNDERSCORE_IDENT_RE,
            built_in: system_functions
        },
        begin: FUNCTION_TITLE,
        end: "\\(",
        returnBegin: true,
        excludeEnd: true
    };
    // function : функции
    const FUNCTIONS = {
        className: "function",
        begin: FUNCTION_TITLE,
        end: "\\)$",
        returnBegin: true,
        keywords: KEYWORDS,
        illegal: "[\\[\\]\\|\\$\\?%,~#@]",
        contains: [
            TITLE_MODE,
            METHODS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            COMMENTS
        ]
    };
    return {
        name: "ISBL",
        case_insensitive: true,
        keywords: KEYWORDS,
        illegal: "\\$|\\?|%|,|;$|~|#|@|</",
        contains: [
            FUNCTIONS,
            TYPES,
            METHODS,
            VARIABLES,
            STRINGS,
            NUMBERS,
            COMMENTS
        ]
    };
}
module.exports = $a91d606cfe9b3e8e$var$isbl;

});

parcelRegister("lhbPW", function(module, exports) {
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var $f7d45e107b161df7$var$decimalDigits = "[0-9](_*[0-9])*";
var $f7d45e107b161df7$var$frac = `\\.(${$f7d45e107b161df7$var$decimalDigits})`;
var $f7d45e107b161df7$var$hexDigits = "[0-9a-fA-F](_*[0-9a-fA-F])*";
var $f7d45e107b161df7$var$NUMERIC = {
    className: "number",
    variants: [
        // DecimalFloatingPointLiteral
        // including ExponentPart
        {
            begin: `(\\b(${$f7d45e107b161df7$var$decimalDigits})((${$f7d45e107b161df7$var$frac})|\\.)?|(${$f7d45e107b161df7$var$frac}))` + `[eE][+-]?(${$f7d45e107b161df7$var$decimalDigits})[fFdD]?\\b`
        },
        // excluding ExponentPart
        {
            begin: `\\b(${$f7d45e107b161df7$var$decimalDigits})((${$f7d45e107b161df7$var$frac})[fFdD]?\\b|\\.([fFdD]\\b)?)`
        },
        {
            begin: `(${$f7d45e107b161df7$var$frac})[fFdD]?\\b`
        },
        {
            begin: `\\b(${$f7d45e107b161df7$var$decimalDigits})[fFdD]\\b`
        },
        // HexadecimalFloatingPointLiteral
        {
            begin: `\\b0[xX]((${$f7d45e107b161df7$var$hexDigits})\\.?|(${$f7d45e107b161df7$var$hexDigits})?\\.(${$f7d45e107b161df7$var$hexDigits}))` + `[pP][+-]?(${$f7d45e107b161df7$var$decimalDigits})[fFdD]?\\b`
        },
        // DecimalIntegerLiteral
        {
            begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b"
        },
        // HexIntegerLiteral
        {
            begin: `\\b0[xX](${$f7d45e107b161df7$var$hexDigits})[lL]?\\b`
        },
        // OctalIntegerLiteral
        {
            begin: "\\b0(_*[0-7])*[lL]?\\b"
        },
        // BinaryIntegerLiteral
        {
            begin: "\\b0[bB][01](_*[01])*[lL]?\\b"
        }
    ],
    relevance: 0
};
/*
Language: Java
Author: Vsevolod Solovyov <vsevolod.solovyov@gmail.com>
Category: common, enterprise
Website: https://www.java.com/
*/ function $f7d45e107b161df7$var$java(hljs) {
    var JAVA_IDENT_RE = "[\xc0-\u02B8a-zA-Z_$][\xc0-\u02B8a-zA-Z_$0-9]*";
    var GENERIC_IDENT_RE = JAVA_IDENT_RE + "(<" + JAVA_IDENT_RE + "(\\s*,\\s*" + JAVA_IDENT_RE + ")*>)?";
    var KEYWORDS = "false synchronized int abstract float private char boolean var static null if const for true while long strictfp finally protected import native final void enum else break transient catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private module requires exports do";
    var ANNOTATION = {
        className: "meta",
        begin: "@" + JAVA_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self"
                ] // allow nested () inside our annotation
            }
        ]
    };
    const NUMBER = $f7d45e107b161df7$var$NUMERIC;
    return {
        name: "Java",
        aliases: [
            "jsp"
        ],
        keywords: KEYWORDS,
        illegal: /<\/|#/,
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        // eat up @'s in emails to prevent them to be recognized as doctags
                        begin: /\w+@/,
                        relevance: 0
                    },
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            // relevance boost
            {
                begin: /import java\.[a-z]+\./,
                keywords: "import",
                relevance: 2
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "class",
                beginKeywords: "class interface enum",
                end: /[{;=]/,
                excludeEnd: true,
                // TODO: can this be removed somehow?
                // an extra boost because Java is more popular than other languages with
                // this same syntax feature (this is just to preserve our tests passing
                // for now)
                relevance: 1,
                keywords: "class interface enum",
                illegal: /[:"\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                // Expression keywords prevent 'keyword Name(...)' from being
                // recognized as a function definition
                beginKeywords: "new throw return else",
                relevance: 0
            },
            {
                className: "class",
                begin: "record\\s+" + hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                returnBegin: true,
                excludeEnd: true,
                end: /[{;=]/,
                keywords: KEYWORDS,
                contains: [
                    {
                        beginKeywords: "record"
                    },
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                className: "function",
                begin: "(" + GENERIC_IDENT_RE + "\\s+)+" + hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                returnBegin: true,
                end: /[{;=]/,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            ANNOTATION,
                            hljs.APOS_STRING_MODE,
                            hljs.QUOTE_STRING_MODE,
                            NUMBER,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            NUMBER,
            ANNOTATION
        ]
    };
}
module.exports = $f7d45e107b161df7$var$java;

});

parcelRegister("hXeXQ", function(module, exports) {
const $d1238deabc8645bb$var$IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
const $d1238deabc8645bb$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $d1238deabc8645bb$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
const $d1238deabc8645bb$var$TYPES = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
];
const $d1238deabc8645bb$var$ERROR_TYPES = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $d1238deabc8645bb$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $d1238deabc8645bb$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global" // Node.js
];
const $d1238deabc8645bb$var$BUILT_INS = [].concat($d1238deabc8645bb$var$BUILT_IN_GLOBALS, $d1238deabc8645bb$var$BUILT_IN_VARIABLES, $d1238deabc8645bb$var$TYPES, $d1238deabc8645bb$var$ERROR_TYPES);
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $d1238deabc8645bb$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $d1238deabc8645bb$var$lookahead(re) {
    return $d1238deabc8645bb$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $d1238deabc8645bb$var$concat(...args) {
    const joined = args.map((x)=>$d1238deabc8645bb$var$source(x)).join("");
    return joined;
}
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $d1238deabc8645bb$var$javascript(hljs) {
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $d1238deabc8645bb$var$IDENT_RE;
    const FRAGMENT = {
        begin: "<>",
        end: "</>"
    };
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            // nested type?
            // HTML should not include another raw `<` inside a tag
            // But a type might: `<Array<Array<number>>`, etc.
            if (nextChar === "<") {
                response.ignoreMatch();
                return;
            }
            // <something>
            // This is now either a tag or a type.
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $d1238deabc8645bb$var$IDENT_RE,
        keyword: $d1238deabc8645bb$var$KEYWORDS,
        literal: $d1238deabc8645bb$var$LITERALS,
        built_in: $d1238deabc8645bb$var$BUILT_INS
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = "[0-9](_?[0-9])*";
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    const CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    const TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [
            {
                className: "doctag",
                begin: "@[A-Za-z]+",
                contains: [
                    {
                        className: "type",
                        begin: "\\{",
                        end: "\\}",
                        relevance: 0
                    },
                    {
                        className: "variable",
                        begin: IDENT_RE$1 + "(?=\\s*(-)|$)",
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    return {
        name: "Javascript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            {
                label: "use_strict",
                className: "meta",
                relevance: 10,
                begin: /^\s*['"]use (strict|asm)['"]/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            NUMBER,
            {
                begin: $d1238deabc8645bb$var$concat(/[{,\n]\s*/, // we need to look ahead to make sure that we actually have an
                // attribute coming up so we don't steal a comma from a potential
                // "value" container
                //
                // NOTE: this might not work how you think.  We don't actually always
                // enter this mode and stay.  Instead it might merely match `,
                // <comments up next>` and then immediately end after the , because it
                // fails to find any actual attrs. But this still does the job because
                // it prevents the value contain rule from grabbing this instead and
                // prevening this rule from firing when we actually DO have keys.
                $d1238deabc8645bb$var$lookahead($d1238deabc8645bb$var$concat(// we also need to allow for multiple possible comments inbetween
                // the first key:value pairing
                /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/, IDENT_RE$1 + "\\s*:"))),
                relevance: 0,
                contains: [
                    {
                        className: "attr",
                        begin: IDENT_RE$1 + $d1238deabc8645bb$var$lookahead("\\s*:"),
                        relevance: 0
                    }
                ]
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        className: "",
                        begin: /\s/,
                        end: /\s*/,
                        skip: true
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[{;]/,
                excludeEnd: true,
                keywords: KEYWORDS$1,
                contains: [
                    "self",
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    PARAMS
                ],
                illegal: /%/
            },
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                className: "function",
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: hljs.UNDERSCORE_IDENT_RE + "\\(" + // first parens
                "[^()]*(\\(" + "[^()]*(\\(" + "[^()]*" + "\\)[^()]*)*" + "\\)[^()]*)*" + "\\)\\s*\\{",
                returnBegin: true,
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    })
                ]
            },
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                variants: [
                    {
                        begin: "\\." + IDENT_RE$1
                    },
                    {
                        begin: "\\$" + IDENT_RE$1
                    }
                ],
                relevance: 0
            },
            {
                className: "class",
                beginKeywords: "class",
                end: /[{;=]/,
                excludeEnd: true,
                illegal: /[:"[\]]/,
                contains: [
                    {
                        beginKeywords: "extends"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: /\b(?=constructor)/,
                end: /[{;]/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    "self",
                    PARAMS
                ]
            },
            {
                begin: "(get|set)\\s+(?=" + IDENT_RE$1 + "\\()",
                end: /\{/,
                keywords: "get set",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    {
                        begin: /\(\)/
                    },
                    PARAMS
                ]
            },
            {
                begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
module.exports = $d1238deabc8645bb$var$javascript;

});

parcelRegister("14ZtH", function(module, exports) {
/*
 Language: JBoss CLI
 Author: Raphaël Parrëe <rparree@edc4it.com>
 Description: language definition jboss cli
 Website: https://docs.jboss.org/author/display/WFLY/Command+Line+Interface
 Category: config
 */ function $0c95da6a901831be$var$jbossCli(hljs) {
    const PARAM = {
        begin: /[\w-]+ *=/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: /[\w-]+/
            }
        ]
    };
    const PARAMSBLOCK = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        contains: [
            PARAM
        ],
        relevance: 0
    };
    const OPERATION = {
        className: "function",
        begin: /:[\w\-.]+/,
        relevance: 0
    };
    const PATH = {
        className: "string",
        begin: /\B([\/.])[\w\-.\/=]+/
    };
    const COMMAND_PARAMS = {
        className: "params",
        begin: /--[\w\-=\/]+/
    };
    return {
        name: "JBoss CLI",
        aliases: [
            "wildfly-cli"
        ],
        keywords: {
            $pattern: "[a-z-]+",
            keyword: "alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",
            literal: "true false"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            COMMAND_PARAMS,
            OPERATION,
            PATH,
            PARAMSBLOCK
        ]
    };
}
module.exports = $0c95da6a901831be$var$jbossCli;

});

parcelRegister("hIDeD", function(module, exports) {
/*
Language: JSON
Description: JSON (JavaScript Object Notation) is a lightweight data-interchange format.
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: http://www.json.org
Category: common, protocols
*/ function $ce64fafc59094643$var$json(hljs) {
    const LITERALS = {
        literal: "true false null"
    };
    const ALLOWED_COMMENTS = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE
    ];
    const TYPES = [
        hljs.QUOTE_STRING_MODE,
        hljs.C_NUMBER_MODE
    ];
    const VALUE_CONTAINER = {
        end: ",",
        endsWithParent: true,
        excludeEnd: true,
        contains: TYPES,
        keywords: LITERALS
    };
    const OBJECT = {
        begin: /\{/,
        end: /\}/,
        contains: [
            {
                className: "attr",
                begin: /"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                illegal: "\\n"
            },
            hljs.inherit(VALUE_CONTAINER, {
                begin: /:/
            })
        ].concat(ALLOWED_COMMENTS),
        illegal: "\\S"
    };
    const ARRAY = {
        begin: "\\[",
        end: "\\]",
        contains: [
            hljs.inherit(VALUE_CONTAINER)
        ],
        illegal: "\\S"
    };
    TYPES.push(OBJECT, ARRAY);
    ALLOWED_COMMENTS.forEach(function(rule) {
        TYPES.push(rule);
    });
    return {
        name: "JSON",
        contains: TYPES,
        keywords: LITERALS,
        illegal: "\\S"
    };
}
module.exports = $ce64fafc59094643$var$json;

});

parcelRegister("lMPba", function(module, exports) {
/*
Language: Julia
Description: Julia is a high-level, high-performance, dynamic programming language.
Author: Kenta Sato <bicycle1885@gmail.com>
Contributors: Alex Arslan <ararslan@comcast.net>, Fredrik Ekre <ekrefredrik@gmail.com>
Website: https://julialang.org
*/ function $fdc5c7c640b4aca9$var$julia(hljs) {
    // Since there are numerous special names in Julia, it is too much trouble
    // to maintain them by hand. Hence these names (i.e. keywords, literals and
    // built-ins) are automatically generated from Julia 1.5.2 itself through
    // the following scripts for each.
    // ref: https://docs.julialang.org/en/v1/manual/variables/#Allowed-Variable-Names
    var VARIABLE_NAME_RE = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*";
    // # keyword generator, multi-word keywords handled manually below (Julia 1.5.2)
    // import REPL.REPLCompletions
    // res = String["in", "isa", "where"]
    // for kw in collect(x.keyword for x in REPLCompletions.complete_keyword(""))
    //     if !(contains(kw, " ") || kw == "struct")
    //         push!(res, kw)
    //     end
    // end
    // sort!(unique!(res))
    // foreach(x -> println("\'", x, "\',"), res)
    var KEYWORD_LIST = [
        "baremodule",
        "begin",
        "break",
        "catch",
        "ccall",
        "const",
        "continue",
        "do",
        "else",
        "elseif",
        "end",
        "export",
        "false",
        "finally",
        "for",
        "function",
        "global",
        "if",
        "import",
        "in",
        "isa",
        "let",
        "local",
        "macro",
        "module",
        "quote",
        "return",
        "true",
        "try",
        "using",
        "where",
        "while"
    ];
    // # literal generator (Julia 1.5.2)
    // import REPL.REPLCompletions
    // res = String["true", "false"]
    // for compl in filter!(x -> isa(x, REPLCompletions.ModuleCompletion) && (x.parent === Base || x.parent === Core),
    //                     REPLCompletions.completions("", 0)[1])
    //     try
    //         v = eval(Symbol(compl.mod))
    //         if !(v isa Function || v isa Type || v isa TypeVar || v isa Module || v isa Colon)
    //             push!(res, compl.mod)
    //         end
    //     catch e
    //     end
    // end
    // sort!(unique!(res))
    // foreach(x -> println("\'", x, "\',"), res)
    var LITERAL_LIST = [
        "ARGS",
        "C_NULL",
        "DEPOT_PATH",
        "ENDIAN_BOM",
        "ENV",
        "Inf",
        "Inf16",
        "Inf32",
        "Inf64",
        "InsertionSort",
        "LOAD_PATH",
        "MergeSort",
        "NaN",
        "NaN16",
        "NaN32",
        "NaN64",
        "PROGRAM_FILE",
        "QuickSort",
        "RoundDown",
        "RoundFromZero",
        "RoundNearest",
        "RoundNearestTiesAway",
        "RoundNearestTiesUp",
        "RoundToZero",
        "RoundUp",
        "VERSION|0",
        "devnull",
        "false",
        "im",
        "missing",
        "nothing",
        "pi",
        "stderr",
        "stdin",
        "stdout",
        "true",
        "undef",
        "\u03C0",
        "\u212F"
    ];
    // # built_in generator (Julia 1.5.2)
    // import REPL.REPLCompletions
    // res = String[]
    // for compl in filter!(x -> isa(x, REPLCompletions.ModuleCompletion) && (x.parent === Base || x.parent === Core),
    //                     REPLCompletions.completions("", 0)[1])
    //     try
    //         v = eval(Symbol(compl.mod))
    //         if (v isa Type || v isa TypeVar) && (compl.mod != "=>")
    //             push!(res, compl.mod)
    //         end
    //     catch e
    //     end
    // end
    // sort!(unique!(res))
    // foreach(x -> println("\'", x, "\',"), res)
    var BUILT_IN_LIST = [
        "AbstractArray",
        "AbstractChannel",
        "AbstractChar",
        "AbstractDict",
        "AbstractDisplay",
        "AbstractFloat",
        "AbstractIrrational",
        "AbstractMatrix",
        "AbstractRange",
        "AbstractSet",
        "AbstractString",
        "AbstractUnitRange",
        "AbstractVecOrMat",
        "AbstractVector",
        "Any",
        "ArgumentError",
        "Array",
        "AssertionError",
        "BigFloat",
        "BigInt",
        "BitArray",
        "BitMatrix",
        "BitSet",
        "BitVector",
        "Bool",
        "BoundsError",
        "CapturedException",
        "CartesianIndex",
        "CartesianIndices",
        "Cchar",
        "Cdouble",
        "Cfloat",
        "Channel",
        "Char",
        "Cint",
        "Cintmax_t",
        "Clong",
        "Clonglong",
        "Cmd",
        "Colon",
        "Complex",
        "ComplexF16",
        "ComplexF32",
        "ComplexF64",
        "CompositeException",
        "Condition",
        "Cptrdiff_t",
        "Cshort",
        "Csize_t",
        "Cssize_t",
        "Cstring",
        "Cuchar",
        "Cuint",
        "Cuintmax_t",
        "Culong",
        "Culonglong",
        "Cushort",
        "Cvoid",
        "Cwchar_t",
        "Cwstring",
        "DataType",
        "DenseArray",
        "DenseMatrix",
        "DenseVecOrMat",
        "DenseVector",
        "Dict",
        "DimensionMismatch",
        "Dims",
        "DivideError",
        "DomainError",
        "EOFError",
        "Enum",
        "ErrorException",
        "Exception",
        "ExponentialBackOff",
        "Expr",
        "Float16",
        "Float32",
        "Float64",
        "Function",
        "GlobalRef",
        "HTML",
        "IO",
        "IOBuffer",
        "IOContext",
        "IOStream",
        "IdDict",
        "IndexCartesian",
        "IndexLinear",
        "IndexStyle",
        "InexactError",
        "InitError",
        "Int",
        "Int128",
        "Int16",
        "Int32",
        "Int64",
        "Int8",
        "Integer",
        "InterruptException",
        "InvalidStateException",
        "Irrational",
        "KeyError",
        "LinRange",
        "LineNumberNode",
        "LinearIndices",
        "LoadError",
        "MIME",
        "Matrix",
        "Method",
        "MethodError",
        "Missing",
        "MissingException",
        "Module",
        "NTuple",
        "NamedTuple",
        "Nothing",
        "Number",
        "OrdinalRange",
        "OutOfMemoryError",
        "OverflowError",
        "Pair",
        "PartialQuickSort",
        "PermutedDimsArray",
        "Pipe",
        "ProcessFailedException",
        "Ptr",
        "QuoteNode",
        "Rational",
        "RawFD",
        "ReadOnlyMemoryError",
        "Real",
        "ReentrantLock",
        "Ref",
        "Regex",
        "RegexMatch",
        "RoundingMode",
        "SegmentationFault",
        "Set",
        "Signed",
        "Some",
        "StackOverflowError",
        "StepRange",
        "StepRangeLen",
        "StridedArray",
        "StridedMatrix",
        "StridedVecOrMat",
        "StridedVector",
        "String",
        "StringIndexError",
        "SubArray",
        "SubString",
        "SubstitutionString",
        "Symbol",
        "SystemError",
        "Task",
        "TaskFailedException",
        "Text",
        "TextDisplay",
        "Timer",
        "Tuple",
        "Type",
        "TypeError",
        "TypeVar",
        "UInt",
        "UInt128",
        "UInt16",
        "UInt32",
        "UInt64",
        "UInt8",
        "UndefInitializer",
        "UndefKeywordError",
        "UndefRefError",
        "UndefVarError",
        "Union",
        "UnionAll",
        "UnitRange",
        "Unsigned",
        "Val",
        "Vararg",
        "VecElement",
        "VecOrMat",
        "Vector",
        "VersionNumber",
        "WeakKeyDict",
        "WeakRef"
    ];
    var KEYWORDS = {
        $pattern: VARIABLE_NAME_RE,
        keyword: KEYWORD_LIST,
        literal: LITERAL_LIST,
        built_in: BUILT_IN_LIST
    };
    // placeholder for recursive self-reference
    var DEFAULT = {
        keywords: KEYWORDS,
        illegal: /<\//
    };
    // ref: https://docs.julialang.org/en/v1/manual/integers-and-floating-point-numbers/
    var NUMBER = {
        className: "number",
        // supported numeric literals:
        //  * binary literal (e.g. 0x10)
        //  * octal literal (e.g. 0o76543210)
        //  * hexadecimal literal (e.g. 0xfedcba876543210)
        //  * hexadecimal floating point literal (e.g. 0x1p0, 0x1.2p2)
        //  * decimal literal (e.g. 9876543210, 100_000_000)
        //  * floating pointe literal (e.g. 1.2, 1.2f, .2, 1., 1.2e10, 1.2e-10)
        begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
        relevance: 0
    };
    var CHAR = {
        className: "string",
        begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
    };
    var INTERPOLATION = {
        className: "subst",
        begin: /\$\(/,
        end: /\)/,
        keywords: KEYWORDS
    };
    var INTERPOLATED_VARIABLE = {
        className: "variable",
        begin: "\\$" + VARIABLE_NAME_RE
    };
    // TODO: neatly escape normal code in string literal
    var STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            INTERPOLATION,
            INTERPOLATED_VARIABLE
        ],
        variants: [
            {
                begin: /\w*"""/,
                end: /"""\w*/,
                relevance: 10
            },
            {
                begin: /\w*"/,
                end: /"\w*/
            }
        ]
    };
    var COMMAND = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            INTERPOLATION,
            INTERPOLATED_VARIABLE
        ],
        begin: "`",
        end: "`"
    };
    var MACROCALL = {
        className: "meta",
        begin: "@" + VARIABLE_NAME_RE
    };
    var COMMENT = {
        className: "comment",
        variants: [
            {
                begin: "#=",
                end: "=#",
                relevance: 10
            },
            {
                begin: "#",
                end: "$"
            }
        ]
    };
    DEFAULT.name = "Julia";
    DEFAULT.contains = [
        NUMBER,
        CHAR,
        STRING,
        COMMAND,
        MACROCALL,
        COMMENT,
        hljs.HASH_COMMENT_MODE,
        {
            className: "keyword",
            begin: "\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b"
        },
        {
            begin: /<:/
        } // relevance booster
    ];
    INTERPOLATION.contains = DEFAULT.contains;
    return DEFAULT;
}
module.exports = $fdc5c7c640b4aca9$var$julia;

});

parcelRegister("b58C8", function(module, exports) {
/*
Language: Julia REPL
Description: Julia REPL sessions
Author: Morten Piibeleht <morten.piibeleht@gmail.com>
Website: https://julialang.org
Requires: julia.js

The Julia REPL code blocks look something like the following:

  julia> function foo(x)
             x + 1
         end
  foo (generic function with 1 method)

They start on a new line with "julia>". Usually there should also be a space after this, but
we also allow the code to start right after the > character. The code may run over multiple
lines, but the additional lines must start with six spaces (i.e. be indented to match
"julia>"). The rest of the code is assumed to be output from the executed code and will be
left un-highlighted.

Using simply spaces to identify line continuations may get a false-positive if the output
also prints out six spaces, but such cases should be rare.
*/ function $8116d7ec3ea4f1f9$var$juliaRepl(hljs) {
    return {
        name: "Julia REPL",
        contains: [
            {
                className: "meta",
                begin: /^julia>/,
                relevance: 10,
                starts: {
                    // end the highlighting if we are on a new line and the line does not have at
                    // least six spaces in the beginning
                    end: /^(?![ ]{6})/,
                    subLanguage: "julia"
                },
                // jldoctest Markdown blocks are used in the Julia manual and package docs indicate
                // code snippets that should be verified when the documentation is built. They can be
                // either REPL-like or script-like, but are usually REPL-like and therefore we apply
                // julia-repl highlighting to them. More information can be found in Documenter's
                // manual: https://juliadocs.github.io/Documenter.jl/latest/man/doctests.html
                aliases: [
                    "jldoctest"
                ]
            }
        ]
    };
}
module.exports = $8116d7ec3ea4f1f9$var$juliaRepl;

});

parcelRegister("kJmbc", function(module, exports) {
// https://docs.oracle.com/javase/specs/jls/se15/html/jls-3.html#jls-3.10
var $f1793708650e05c9$var$decimalDigits = "[0-9](_*[0-9])*";
var $f1793708650e05c9$var$frac = `\\.(${$f1793708650e05c9$var$decimalDigits})`;
var $f1793708650e05c9$var$hexDigits = "[0-9a-fA-F](_*[0-9a-fA-F])*";
var $f1793708650e05c9$var$NUMERIC = {
    className: "number",
    variants: [
        // DecimalFloatingPointLiteral
        // including ExponentPart
        {
            begin: `(\\b(${$f1793708650e05c9$var$decimalDigits})((${$f1793708650e05c9$var$frac})|\\.)?|(${$f1793708650e05c9$var$frac}))` + `[eE][+-]?(${$f1793708650e05c9$var$decimalDigits})[fFdD]?\\b`
        },
        // excluding ExponentPart
        {
            begin: `\\b(${$f1793708650e05c9$var$decimalDigits})((${$f1793708650e05c9$var$frac})[fFdD]?\\b|\\.([fFdD]\\b)?)`
        },
        {
            begin: `(${$f1793708650e05c9$var$frac})[fFdD]?\\b`
        },
        {
            begin: `\\b(${$f1793708650e05c9$var$decimalDigits})[fFdD]\\b`
        },
        // HexadecimalFloatingPointLiteral
        {
            begin: `\\b0[xX]((${$f1793708650e05c9$var$hexDigits})\\.?|(${$f1793708650e05c9$var$hexDigits})?\\.(${$f1793708650e05c9$var$hexDigits}))` + `[pP][+-]?(${$f1793708650e05c9$var$decimalDigits})[fFdD]?\\b`
        },
        // DecimalIntegerLiteral
        {
            begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b"
        },
        // HexIntegerLiteral
        {
            begin: `\\b0[xX](${$f1793708650e05c9$var$hexDigits})[lL]?\\b`
        },
        // OctalIntegerLiteral
        {
            begin: "\\b0(_*[0-7])*[lL]?\\b"
        },
        // BinaryIntegerLiteral
        {
            begin: "\\b0[bB][01](_*[01])*[lL]?\\b"
        }
    ],
    relevance: 0
};
/*
 Language: Kotlin
 Description: Kotlin is an OSS statically typed programming language that targets the JVM, Android, JavaScript and Native.
 Author: Sergey Mashkov <cy6erGn0m@gmail.com>
 Website: https://kotlinlang.org
 Category: common
 */ function $f1793708650e05c9$var$kotlin(hljs) {
    const KEYWORDS = {
        keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
        built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
        literal: "true false null"
    };
    const KEYWORDS_WITH_LABEL = {
        className: "keyword",
        begin: /\b(break|continue|return|this)\b/,
        starts: {
            contains: [
                {
                    className: "symbol",
                    begin: /@\w+/
                }
            ]
        }
    };
    const LABEL = {
        className: "symbol",
        begin: hljs.UNDERSCORE_IDENT_RE + "@"
    };
    // for string templates
    const SUBST = {
        className: "subst",
        begin: /\$\{/,
        end: /\}/,
        contains: [
            hljs.C_NUMBER_MODE
        ]
    };
    const VARIABLE = {
        className: "variable",
        begin: "\\$" + hljs.UNDERSCORE_IDENT_RE
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: '"""',
                end: '"""(?=[^"])',
                contains: [
                    VARIABLE,
                    SUBST
                ]
            },
            // Can't use built-in modes easily, as we want to use STRING in the meta
            // context as 'meta-string' and there's no syntax to remove explicitly set
            // classNames in built-in modes.
            {
                begin: "'",
                end: "'",
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '"',
                end: '"',
                illegal: /\n/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VARIABLE,
                    SUBST
                ]
            }
        ]
    };
    SUBST.contains.push(STRING);
    const ANNOTATION_USE_SITE = {
        className: "meta",
        begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + hljs.UNDERSCORE_IDENT_RE + ")?"
    };
    const ANNOTATION = {
        className: "meta",
        begin: "@" + hljs.UNDERSCORE_IDENT_RE,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    hljs.inherit(STRING, {
                        className: "meta-string"
                    })
                ]
            }
        ]
    };
    // https://kotlinlang.org/docs/reference/whatsnew11.html#underscores-in-numeric-literals
    // According to the doc above, the number mode of kotlin is the same as java 8,
    // so the code below is copied from java.js
    const KOTLIN_NUMBER_MODE = $f1793708650e05c9$var$NUMERIC;
    const KOTLIN_NESTED_COMMENT = hljs.COMMENT("/\\*", "\\*/", {
        contains: [
            hljs.C_BLOCK_COMMENT_MODE
        ]
    });
    const KOTLIN_PAREN_TYPE = {
        variants: [
            {
                className: "type",
                begin: hljs.UNDERSCORE_IDENT_RE
            },
            {
                begin: /\(/,
                end: /\)/,
                contains: [] // defined later
            }
        ]
    };
    const KOTLIN_PAREN_TYPE2 = KOTLIN_PAREN_TYPE;
    KOTLIN_PAREN_TYPE2.variants[1].contains = [
        KOTLIN_PAREN_TYPE
    ];
    KOTLIN_PAREN_TYPE.variants[1].contains = [
        KOTLIN_PAREN_TYPE2
    ];
    return {
        name: "Kotlin",
        aliases: [
            "kt",
            "kts"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.COMMENT("/\\*\\*", "\\*/", {
                relevance: 0,
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.C_LINE_COMMENT_MODE,
            KOTLIN_NESTED_COMMENT,
            KEYWORDS_WITH_LABEL,
            LABEL,
            ANNOTATION_USE_SITE,
            ANNOTATION,
            {
                className: "function",
                beginKeywords: "fun",
                end: "[(]|$",
                returnBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                relevance: 5,
                contains: [
                    {
                        begin: hljs.UNDERSCORE_IDENT_RE + "\\s*\\(",
                        returnBegin: true,
                        relevance: 0,
                        contains: [
                            hljs.UNDERSCORE_TITLE_MODE
                        ]
                    },
                    {
                        className: "type",
                        begin: /</,
                        end: />/,
                        keywords: "reified",
                        relevance: 0
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        endsParent: true,
                        keywords: KEYWORDS,
                        relevance: 0,
                        contains: [
                            {
                                begin: /:/,
                                end: /[=,\/]/,
                                endsWithParent: true,
                                contains: [
                                    KOTLIN_PAREN_TYPE,
                                    hljs.C_LINE_COMMENT_MODE,
                                    KOTLIN_NESTED_COMMENT
                                ],
                                relevance: 0
                            },
                            hljs.C_LINE_COMMENT_MODE,
                            KOTLIN_NESTED_COMMENT,
                            ANNOTATION_USE_SITE,
                            ANNOTATION,
                            STRING,
                            hljs.C_NUMBER_MODE
                        ]
                    },
                    KOTLIN_NESTED_COMMENT
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface trait",
                end: /[:\{(]|$/,
                excludeEnd: true,
                illegal: "extends implements",
                contains: [
                    {
                        beginKeywords: "public protected internal private constructor"
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "type",
                        begin: /</,
                        end: />/,
                        excludeBegin: true,
                        excludeEnd: true,
                        relevance: 0
                    },
                    {
                        className: "type",
                        begin: /[,:]\s*/,
                        end: /[<\(,]|$/,
                        excludeBegin: true,
                        returnEnd: true
                    },
                    ANNOTATION_USE_SITE,
                    ANNOTATION
                ]
            },
            STRING,
            {
                className: "meta",
                begin: "^#!/usr/bin/env",
                end: "$",
                illegal: "\n"
            },
            KOTLIN_NUMBER_MODE
        ]
    };
}
module.exports = $f1793708650e05c9$var$kotlin;

});

parcelRegister("fcj0z", function(module, exports) {
/*
Language: Lasso
Author: Eric Knibbe <eric@lassosoft.com>
Description: Lasso is a language and server platform for database-driven web applications. This definition handles Lasso 9 syntax and LassoScript for Lasso 8.6 and earlier.
Website: http://www.lassosoft.com/What-Is-Lasso
*/ function $b106b8a3bad26df7$var$lasso(hljs) {
    const LASSO_IDENT_RE = "[a-zA-Z_][\\w.]*";
    const LASSO_ANGLE_RE = "<\\?(lasso(script)?|=)";
    const LASSO_CLOSE_RE = "\\]|\\?>";
    const LASSO_KEYWORDS = {
        $pattern: LASSO_IDENT_RE + "|&[lg]t;",
        literal: "true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",
        built_in: "array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",
        keyword: "cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"
    };
    const HTML_COMMENT = hljs.COMMENT("<!--", "-->", {
        relevance: 0
    });
    const LASSO_NOPROCESS = {
        className: "meta",
        begin: "\\[noprocess\\]",
        starts: {
            end: "\\[/noprocess\\]",
            returnEnd: true,
            contains: [
                HTML_COMMENT
            ]
        }
    };
    const LASSO_START = {
        className: "meta",
        begin: "\\[/noprocess|" + LASSO_ANGLE_RE
    };
    const LASSO_DATAMEMBER = {
        className: "symbol",
        begin: "'" + LASSO_IDENT_RE + "'"
    };
    const LASSO_CODE = [
        hljs.C_LINE_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.inherit(hljs.C_NUMBER_MODE, {
            begin: hljs.C_NUMBER_RE + "|(-?infinity|NaN)\\b"
        }),
        hljs.inherit(hljs.APOS_STRING_MODE, {
            illegal: null
        }),
        hljs.inherit(hljs.QUOTE_STRING_MODE, {
            illegal: null
        }),
        {
            className: "string",
            begin: "`",
            end: "`"
        },
        {
            variants: [
                {
                    begin: "[#$]" + LASSO_IDENT_RE
                },
                {
                    begin: "#",
                    end: "\\d+",
                    illegal: "\\W"
                }
            ]
        },
        {
            className: "type",
            begin: "::\\s*",
            end: LASSO_IDENT_RE,
            illegal: "\\W"
        },
        {
            className: "params",
            variants: [
                {
                    begin: "-(?!infinity)" + LASSO_IDENT_RE,
                    relevance: 0
                },
                {
                    begin: "(\\.\\.\\.)"
                }
            ]
        },
        {
            begin: /(->|\.)\s*/,
            relevance: 0,
            contains: [
                LASSO_DATAMEMBER
            ]
        },
        {
            className: "class",
            beginKeywords: "define",
            returnEnd: true,
            end: "\\(|=>",
            contains: [
                hljs.inherit(hljs.TITLE_MODE, {
                    begin: LASSO_IDENT_RE + "(=(?!>))?|[-+*/%](?!>)"
                })
            ]
        }
    ];
    return {
        name: "Lasso",
        aliases: [
            "ls",
            "lassoscript"
        ],
        case_insensitive: true,
        keywords: LASSO_KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: LASSO_CLOSE_RE,
                relevance: 0,
                starts: {
                    end: "\\[|" + LASSO_ANGLE_RE,
                    returnEnd: true,
                    relevance: 0,
                    contains: [
                        HTML_COMMENT
                    ]
                }
            },
            LASSO_NOPROCESS,
            LASSO_START,
            {
                className: "meta",
                begin: "\\[no_square_brackets",
                starts: {
                    end: "\\[/no_square_brackets\\]",
                    keywords: LASSO_KEYWORDS,
                    contains: [
                        {
                            className: "meta",
                            begin: LASSO_CLOSE_RE,
                            relevance: 0,
                            starts: {
                                end: "\\[noprocess\\]|" + LASSO_ANGLE_RE,
                                returnEnd: true,
                                contains: [
                                    HTML_COMMENT
                                ]
                            }
                        },
                        LASSO_NOPROCESS,
                        LASSO_START
                    ].concat(LASSO_CODE)
                }
            },
            {
                className: "meta",
                begin: "\\[",
                relevance: 0
            },
            {
                className: "meta",
                begin: "^#!",
                end: "lasso9$",
                relevance: 10
            }
        ].concat(LASSO_CODE)
    };
}
module.exports = $b106b8a3bad26df7$var$lasso;

});

parcelRegister("aZs14", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $8005555593f5dfc7$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $8005555593f5dfc7$var$either(...args) {
    const joined = "(" + args.map((x)=>$8005555593f5dfc7$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: LaTeX
Author: Benedikt Wilde <bwilde@posteo.de>
Website: https://www.latex-project.org
Category: markup
*/ /** @type LanguageFn */ function $8005555593f5dfc7$var$latex(hljs) {
    const KNOWN_CONTROL_WORDS = $8005555593f5dfc7$var$either(...[
        "(?:NeedsTeXFormat|RequirePackage|GetIdInfo)",
        "Provides(?:Expl)?(?:Package|Class|File)",
        "(?:DeclareOption|ProcessOptions)",
        "(?:documentclass|usepackage|input|include)",
        "makeat(?:letter|other)",
        "ExplSyntax(?:On|Off)",
        "(?:new|renew|provide)?command",
        "(?:re)newenvironment",
        "(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand",
        "(?:New|Renew|Provide|Declare)DocumentEnvironment",
        "(?:(?:e|g|x)?def|let)",
        "(?:begin|end)",
        "(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)",
        "caption",
        "(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)",
        "(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)",
        "(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)",
        "(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)",
        "(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)",
        "(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)"
    ].map((word)=>word + "(?![a-zA-Z@:_])"));
    const L3_REGEX = new RegExp([
        // A function \module_function_name:signature or \__module_function_name:signature,
        // where both module and function_name need at least two characters and
        // function_name may contain single underscores.
        "(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*",
        // A variable \scope_module_and_name_type or \scope__module_ane_name_type,
        // where scope is one of l, g or c, type needs at least two characters
        // and module_and_name may contain single underscores.
        "[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}",
        // A quark \q_the_name or \q__the_name or
        // scan mark \s_the_name or \s__vthe_name,
        // where variable_name needs at least two characters and
        // may contain single underscores.
        "[qs]__?[a-zA-Z](?:_?[a-zA-Z])+",
        // Other LaTeX3 macro names that are not covered by the three rules above.
        "use(?:_i)?:[a-zA-Z]*",
        "(?:else|fi|or):",
        "(?:if|cs|exp):w",
        "(?:hbox|vbox):n",
        "::[a-zA-Z]_unbraced",
        "::[a-zA-Z:]"
    ].map((pattern)=>pattern + "(?![a-zA-Z:_])").join("|"));
    const L2_VARIANTS = [
        {
            begin: /[a-zA-Z@]+/
        },
        {
            begin: /[^a-zA-Z@]?/
        } // control symbol
    ];
    const DOUBLE_CARET_VARIANTS = [
        {
            begin: /\^{6}[0-9a-f]{6}/
        },
        {
            begin: /\^{5}[0-9a-f]{5}/
        },
        {
            begin: /\^{4}[0-9a-f]{4}/
        },
        {
            begin: /\^{3}[0-9a-f]{3}/
        },
        {
            begin: /\^{2}[0-9a-f]{2}/
        },
        {
            begin: /\^{2}[\u0000-\u007f]/
        }
    ];
    const CONTROL_SEQUENCE = {
        className: "keyword",
        begin: /\\/,
        relevance: 0,
        contains: [
            {
                endsParent: true,
                begin: KNOWN_CONTROL_WORDS
            },
            {
                endsParent: true,
                begin: L3_REGEX
            },
            {
                endsParent: true,
                variants: DOUBLE_CARET_VARIANTS
            },
            {
                endsParent: true,
                relevance: 0,
                variants: L2_VARIANTS
            }
        ]
    };
    const MACRO_PARAM = {
        className: "params",
        relevance: 0,
        begin: /#+\d?/
    };
    const DOUBLE_CARET_CHAR = {
        // relevance: 1
        variants: DOUBLE_CARET_VARIANTS
    };
    const SPECIAL_CATCODE = {
        className: "built_in",
        relevance: 0,
        begin: /[$&^_]/
    };
    const MAGIC_COMMENT = {
        className: "meta",
        begin: "% !TeX",
        end: "$",
        relevance: 10
    };
    const COMMENT = hljs.COMMENT("%", "$", {
        relevance: 0
    });
    const EVERYTHING_BUT_VERBATIM = [
        CONTROL_SEQUENCE,
        MACRO_PARAM,
        DOUBLE_CARET_CHAR,
        SPECIAL_CATCODE,
        MAGIC_COMMENT,
        COMMENT
    ];
    const BRACE_GROUP_NO_VERBATIM = {
        begin: /\{/,
        end: /\}/,
        relevance: 0,
        contains: [
            "self",
            ...EVERYTHING_BUT_VERBATIM
        ]
    };
    const ARGUMENT_BRACES = hljs.inherit(BRACE_GROUP_NO_VERBATIM, {
        relevance: 0,
        endsParent: true,
        contains: [
            BRACE_GROUP_NO_VERBATIM,
            ...EVERYTHING_BUT_VERBATIM
        ]
    });
    const ARGUMENT_BRACKETS = {
        begin: /\[/,
        end: /\]/,
        endsParent: true,
        relevance: 0,
        contains: [
            BRACE_GROUP_NO_VERBATIM,
            ...EVERYTHING_BUT_VERBATIM
        ]
    };
    const SPACE_GOBBLER = {
        begin: /\s+/,
        relevance: 0
    };
    const ARGUMENT_M = [
        ARGUMENT_BRACES
    ];
    const ARGUMENT_O = [
        ARGUMENT_BRACKETS
    ];
    const ARGUMENT_AND_THEN = function(arg, starts_mode) {
        return {
            contains: [
                SPACE_GOBBLER
            ],
            starts: {
                relevance: 0,
                contains: arg,
                starts: starts_mode
            }
        };
    };
    const CSNAME = function(csname, starts_mode) {
        return {
            begin: "\\\\" + csname + "(?![a-zA-Z@:_])",
            keywords: {
                $pattern: /\\[a-zA-Z]+/,
                keyword: "\\" + csname
            },
            relevance: 0,
            contains: [
                SPACE_GOBBLER
            ],
            starts: starts_mode
        };
    };
    const BEGIN_ENV = function(envname, starts_mode) {
        return hljs.inherit({
            begin: "\\\\begin(?=[ 	]*(\\r?\\n[ 	]*)?\\{" + envname + "\\})",
            keywords: {
                $pattern: /\\[a-zA-Z]+/,
                keyword: "\\begin"
            },
            relevance: 0
        }, ARGUMENT_AND_THEN(ARGUMENT_M, starts_mode));
    };
    const VERBATIM_DELIMITED_EQUAL = (innerName = "string")=>{
        return hljs.END_SAME_AS_BEGIN({
            className: innerName,
            begin: /(.|\r?\n)/,
            end: /(.|\r?\n)/,
            excludeBegin: true,
            excludeEnd: true,
            endsParent: true
        });
    };
    const VERBATIM_DELIMITED_ENV = function(envname) {
        return {
            className: "string",
            end: "(?=\\\\end\\{" + envname + "\\})"
        };
    };
    const VERBATIM_DELIMITED_BRACES = (innerName = "string")=>{
        return {
            relevance: 0,
            begin: /\{/,
            starts: {
                endsParent: true,
                contains: [
                    {
                        className: innerName,
                        end: /(?=\})/,
                        endsParent: true,
                        contains: [
                            {
                                begin: /\{/,
                                end: /\}/,
                                relevance: 0,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ]
            }
        };
    };
    const VERBATIM = [
        ...[
            "verb",
            "lstinline"
        ].map((csname)=>CSNAME(csname, {
                contains: [
                    VERBATIM_DELIMITED_EQUAL()
                ]
            })),
        CSNAME("mint", ARGUMENT_AND_THEN(ARGUMENT_M, {
            contains: [
                VERBATIM_DELIMITED_EQUAL()
            ]
        })),
        CSNAME("mintinline", ARGUMENT_AND_THEN(ARGUMENT_M, {
            contains: [
                VERBATIM_DELIMITED_BRACES(),
                VERBATIM_DELIMITED_EQUAL()
            ]
        })),
        CSNAME("url", {
            contains: [
                VERBATIM_DELIMITED_BRACES("link"),
                VERBATIM_DELIMITED_BRACES("link")
            ]
        }),
        CSNAME("hyperref", {
            contains: [
                VERBATIM_DELIMITED_BRACES("link")
            ]
        }),
        CSNAME("href", ARGUMENT_AND_THEN(ARGUMENT_O, {
            contains: [
                VERBATIM_DELIMITED_BRACES("link")
            ]
        })),
        ...[].concat(...[
            "",
            "\\*"
        ].map((suffix)=>[
                BEGIN_ENV("verbatim" + suffix, VERBATIM_DELIMITED_ENV("verbatim" + suffix)),
                BEGIN_ENV("filecontents" + suffix, ARGUMENT_AND_THEN(ARGUMENT_M, VERBATIM_DELIMITED_ENV("filecontents" + suffix))),
                ...[
                    "",
                    "B",
                    "L"
                ].map((prefix)=>BEGIN_ENV(prefix + "Verbatim" + suffix, ARGUMENT_AND_THEN(ARGUMENT_O, VERBATIM_DELIMITED_ENV(prefix + "Verbatim" + suffix))))
            ])),
        BEGIN_ENV("minted", ARGUMENT_AND_THEN(ARGUMENT_O, ARGUMENT_AND_THEN(ARGUMENT_M, VERBATIM_DELIMITED_ENV("minted"))))
    ];
    return {
        name: "LaTeX",
        aliases: [
            "tex"
        ],
        contains: [
            ...VERBATIM,
            ...EVERYTHING_BUT_VERBATIM
        ]
    };
}
module.exports = $8005555593f5dfc7$var$latex;

});

parcelRegister("e6tv5", function(module, exports) {
/*
Language: LDIF
Contributors: Jacob Childress <jacobc@gmail.com>
Category: enterprise, config
Website: https://en.wikipedia.org/wiki/LDAP_Data_Interchange_Format
*/ function $a44882640583d88e$var$ldif(hljs) {
    return {
        name: "LDIF",
        contains: [
            {
                className: "attribute",
                begin: "^dn",
                end: ": ",
                excludeEnd: true,
                starts: {
                    end: "$",
                    relevance: 0
                },
                relevance: 10
            },
            {
                className: "attribute",
                begin: "^\\w",
                end: ": ",
                excludeEnd: true,
                starts: {
                    end: "$",
                    relevance: 0
                }
            },
            {
                className: "literal",
                begin: "^-",
                end: "$"
            },
            hljs.HASH_COMMENT_MODE
        ]
    };
}
module.exports = $a44882640583d88e$var$ldif;

});

parcelRegister("1zfr3", function(module, exports) {
/*
Language: Leaf
Author: Hale Chan <halechan@qq.com>
Description: Based on the Leaf reference from https://vapor.github.io/documentation/guide/leaf.html.
*/ function $124508752961205c$var$leaf(hljs) {
    return {
        name: "Leaf",
        contains: [
            {
                className: "function",
                begin: "#+[A-Za-z_0-9]*\\(",
                end: / \{/,
                returnBegin: true,
                excludeEnd: true,
                contains: [
                    {
                        className: "keyword",
                        begin: "#+"
                    },
                    {
                        className: "title",
                        begin: "[A-Za-z_][A-Za-z_0-9]*"
                    },
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        endsParent: true,
                        contains: [
                            {
                                className: "string",
                                begin: '"',
                                end: '"'
                            },
                            {
                                className: "variable",
                                begin: "[A-Za-z_][A-Za-z_0-9]*"
                            }
                        ]
                    }
                ]
            }
        ]
    };
}
module.exports = $124508752961205c$var$leaf;

});

parcelRegister("hL458", function(module, exports) {
const $ced9fe003ff8628f$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            className: "meta",
            begin: "!important"
        },
        HEXCOLOR: {
            className: "number",
            begin: "#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})"
        },
        ATTRIBUTE_SELECTOR_MODE: {
            className: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        }
    };
};
const $ced9fe003ff8628f$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $ced9fe003ff8628f$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $ced9fe003ff8628f$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $ced9fe003ff8628f$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $ced9fe003ff8628f$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "auto",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "border",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "clear",
    "clip",
    "clip-path",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "content",
    "counter-increment",
    "counter-reset",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-variant-ligatures",
    "font-variation-settings",
    "font-weight",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inherit",
    "initial",
    "justify-content",
    "left",
    "letter-spacing",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-bottom",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "max-height",
    "max-width",
    "min-height",
    "min-width",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-bottom",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "right",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-last",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-indent",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "white-space",
    "widows",
    "width",
    "word-break",
    "word-spacing",
    "word-wrap",
    "z-index"
].reverse();
// some grammars use them all as a single group
const $ced9fe003ff8628f$var$PSEUDO_SELECTORS = $ced9fe003ff8628f$var$PSEUDO_CLASSES.concat($ced9fe003ff8628f$var$PSEUDO_ELEMENTS);
/*
Language: Less
Description: It's CSS, with just a little more.
Author:   Max Mikhailov <seven.phases.max@gmail.com>
Website: http://lesscss.org
Category: common, css
*/ /** @type LanguageFn */ function $ced9fe003ff8628f$var$less(hljs) {
    const modes = $ced9fe003ff8628f$var$MODES(hljs);
    const PSEUDO_SELECTORS$1 = $ced9fe003ff8628f$var$PSEUDO_SELECTORS;
    const AT_MODIFIERS = "and or not only";
    const IDENT_RE = "[\\w-]+"; // yes, Less identifiers may begin with a digit
    const INTERP_IDENT_RE = "(" + IDENT_RE + "|@\\{" + IDENT_RE + "\\})";
    /* Generic Modes */ const RULES = [];
    const VALUE_MODES = []; // forward def. for recursive modes
    const STRING_MODE = function(c) {
        return {
            // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
            className: "string",
            begin: "~?" + c + ".*?" + c
        };
    };
    const IDENT_MODE = function(name, begin, relevance) {
        return {
            className: name,
            begin: begin,
            relevance: relevance
        };
    };
    const AT_KEYWORDS = {
        $pattern: /[a-z-]+/,
        keyword: AT_MODIFIERS,
        attribute: $ced9fe003ff8628f$var$MEDIA_FEATURES.join(" ")
    };
    const PARENS_MODE = {
        // used only to properly balance nested parens inside mixin call, def. arg list
        begin: "\\(",
        end: "\\)",
        contains: VALUE_MODES,
        keywords: AT_KEYWORDS,
        relevance: 0
    };
    // generic Less highlighter (used almost everywhere except selectors):
    VALUE_MODES.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, STRING_MODE("'"), STRING_MODE('"'), hljs.CSS_NUMBER_MODE, {
        begin: "(url|data-uri)\\(",
        starts: {
            className: "string",
            end: "[\\)\\n]",
            excludeEnd: true
        }
    }, modes.HEXCOLOR, PARENS_MODE, IDENT_MODE("variable", "@@?" + IDENT_RE, 10), IDENT_MODE("variable", "@\\{" + IDENT_RE + "\\}"), IDENT_MODE("built_in", "~?`[^`]*?`"), {
        className: "attribute",
        begin: IDENT_RE + "\\s*:",
        end: ":",
        returnBegin: true,
        excludeEnd: true
    }, modes.IMPORTANT);
    const VALUE_WITH_RULESETS = VALUE_MODES.concat({
        begin: /\{/,
        end: /\}/,
        contains: RULES
    });
    const MIXIN_GUARD_MODE = {
        beginKeywords: "when",
        endsWithParent: true,
        contains: [
            {
                beginKeywords: "and not"
            }
        ].concat(VALUE_MODES) // using this form to override VALUE’s 'function' match
    };
    /* Rule-Level Modes */ const RULE_MODE = {
        begin: INTERP_IDENT_RE + "\\s*:",
        returnBegin: true,
        end: /[;}]/,
        relevance: 0,
        contains: [
            {
                begin: /-(webkit|moz|ms|o)-/
            },
            {
                className: "attribute",
                begin: "\\b(" + $ced9fe003ff8628f$var$ATTRIBUTES.join("|") + ")\\b",
                end: /(?=:)/,
                starts: {
                    endsWithParent: true,
                    illegal: "[<=$]",
                    relevance: 0,
                    contains: VALUE_MODES
                }
            }
        ]
    };
    const AT_RULE_MODE = {
        className: "keyword",
        begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
        starts: {
            end: "[;{}]",
            keywords: AT_KEYWORDS,
            returnEnd: true,
            contains: VALUE_MODES,
            relevance: 0
        }
    };
    // variable definitions and calls
    const VAR_RULE_MODE = {
        className: "variable",
        variants: [
            // using more strict pattern for higher relevance to increase chances of Less detection.
            // this is *the only* Less specific statement used in most of the sources, so...
            // (we’ll still often loose to the css-parser unless there's '//' comment,
            // simply because 1 variable just can't beat 99 properties :)
            {
                begin: "@" + IDENT_RE + "\\s*:",
                relevance: 15
            },
            {
                begin: "@" + IDENT_RE
            }
        ],
        starts: {
            end: "[;}]",
            returnEnd: true,
            contains: VALUE_WITH_RULESETS
        }
    };
    const SELECTOR_MODE = {
        // first parse unambiguous selectors (i.e. those not starting with tag)
        // then fall into the scary lookahead-discriminator variant.
        // this mode also handles mixin definitions and calls
        variants: [
            {
                begin: "[\\.#:&\\[>]",
                end: "[;{}]" // mixin calls end with ';'
            },
            {
                begin: INTERP_IDENT_RE,
                end: /\{/
            }
        ],
        returnBegin: true,
        returnEnd: true,
        illegal: "[<='$\"]",
        relevance: 0,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            MIXIN_GUARD_MODE,
            IDENT_MODE("keyword", "all\\b"),
            IDENT_MODE("variable", "@\\{" + IDENT_RE + "\\}"),
            {
                begin: "\\b(" + $ced9fe003ff8628f$var$TAGS.join("|") + ")\\b",
                className: "selector-tag"
            },
            IDENT_MODE("selector-tag", INTERP_IDENT_RE + "%?", 0),
            IDENT_MODE("selector-id", "#" + INTERP_IDENT_RE),
            IDENT_MODE("selector-class", "\\." + INTERP_IDENT_RE, 0),
            IDENT_MODE("selector-tag", "&", 0),
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "selector-pseudo",
                begin: ":(" + $ced9fe003ff8628f$var$PSEUDO_CLASSES.join("|") + ")"
            },
            {
                className: "selector-pseudo",
                begin: "::(" + $ced9fe003ff8628f$var$PSEUDO_ELEMENTS.join("|") + ")"
            },
            {
                begin: "\\(",
                end: "\\)",
                contains: VALUE_WITH_RULESETS
            },
            {
                begin: "!important"
            } // eat !important after mixin call or it will be colored as tag
        ]
    };
    const PSEUDO_SELECTOR_MODE = {
        begin: IDENT_RE + ":(:)?" + `(${PSEUDO_SELECTORS$1.join("|")})`,
        returnBegin: true,
        contains: [
            SELECTOR_MODE
        ]
    };
    RULES.push(hljs.C_LINE_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, AT_RULE_MODE, VAR_RULE_MODE, PSEUDO_SELECTOR_MODE, RULE_MODE, SELECTOR_MODE);
    return {
        name: "Less",
        case_insensitive: true,
        illegal: "[=>'/<($\"]",
        contains: RULES
    };
}
module.exports = $ced9fe003ff8628f$var$less;

});

parcelRegister("atsIb", function(module, exports) {
/*
Language: Lisp
Description: Generic lisp syntax
Author: Vasily Polovnyov <vast@whiteants.net>
Category: lisp
*/ function $7a02e25a3f8dbb31$var$lisp(hljs) {
    var LISP_IDENT_RE = "[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*";
    var MEC_RE = "\\|[^]*?\\|";
    var LISP_SIMPLE_NUMBER_RE = "(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?";
    var LITERAL = {
        className: "literal",
        begin: "\\b(t{1}|nil)\\b"
    };
    var NUMBER = {
        className: "number",
        variants: [
            {
                begin: LISP_SIMPLE_NUMBER_RE,
                relevance: 0
            },
            {
                begin: "#(b|B)[0-1]+(/[0-1]+)?"
            },
            {
                begin: "#(o|O)[0-7]+(/[0-7]+)?"
            },
            {
                begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?"
            },
            {
                begin: "#(c|C)\\(" + LISP_SIMPLE_NUMBER_RE + " +" + LISP_SIMPLE_NUMBER_RE,
                end: "\\)"
            }
        ]
    };
    var STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    var COMMENT = hljs.COMMENT(";", "$", {
        relevance: 0
    });
    var VARIABLE = {
        begin: "\\*",
        end: "\\*"
    };
    var KEYWORD = {
        className: "symbol",
        begin: "[:&]" + LISP_IDENT_RE
    };
    var IDENT = {
        begin: LISP_IDENT_RE,
        relevance: 0
    };
    var MEC = {
        begin: MEC_RE
    };
    var QUOTED_LIST = {
        begin: "\\(",
        end: "\\)",
        contains: [
            "self",
            LITERAL,
            STRING,
            NUMBER,
            IDENT
        ]
    };
    var QUOTED = {
        contains: [
            NUMBER,
            STRING,
            VARIABLE,
            KEYWORD,
            QUOTED_LIST,
            IDENT
        ],
        variants: [
            {
                begin: "['`]\\(",
                end: "\\)"
            },
            {
                begin: "\\(quote ",
                end: "\\)",
                keywords: {
                    name: "quote"
                }
            },
            {
                begin: "'" + MEC_RE
            }
        ]
    };
    var QUOTED_ATOM = {
        variants: [
            {
                begin: "'" + LISP_IDENT_RE
            },
            {
                begin: "#'" + LISP_IDENT_RE + "(::" + LISP_IDENT_RE + ")*"
            }
        ]
    };
    var LIST = {
        begin: "\\(\\s*",
        end: "\\)"
    };
    var BODY = {
        endsWithParent: true,
        relevance: 0
    };
    LIST.contains = [
        {
            className: "name",
            variants: [
                {
                    begin: LISP_IDENT_RE,
                    relevance: 0
                },
                {
                    begin: MEC_RE
                }
            ]
        },
        BODY
    ];
    BODY.contains = [
        QUOTED,
        QUOTED_ATOM,
        LIST,
        LITERAL,
        NUMBER,
        STRING,
        COMMENT,
        VARIABLE,
        KEYWORD,
        MEC,
        IDENT
    ];
    return {
        name: "Lisp",
        illegal: /\S/,
        contains: [
            NUMBER,
            hljs.SHEBANG(),
            LITERAL,
            STRING,
            COMMENT,
            QUOTED,
            QUOTED_ATOM,
            LIST,
            IDENT
        ]
    };
}
module.exports = $7a02e25a3f8dbb31$var$lisp;

});

parcelRegister("16j1K", function(module, exports) {
/*
Language: LiveCode
Author: Ralf Bitter <rabit@revigniter.com>
Description: Language definition for LiveCode server accounting for revIgniter (a web application framework) characteristics.
Version: 1.1
Date: 2019-04-17
Category: enterprise
*/ function $0cd51c5e838d2c45$var$livecodeserver(hljs) {
    const VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: "\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)"
            },
            {
                begin: "\\$_[A-Z]+"
            }
        ],
        relevance: 0
    };
    const COMMENT_MODES = [
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.HASH_COMMENT_MODE,
        hljs.COMMENT("--", "$"),
        hljs.COMMENT("[^:]//", "$")
    ];
    const TITLE1 = hljs.inherit(hljs.TITLE_MODE, {
        variants: [
            {
                begin: "\\b_*rig[A-Z][A-Za-z0-9_\\-]*"
            },
            {
                begin: "\\b_[a-z0-9\\-]+"
            }
        ]
    });
    const TITLE2 = hljs.inherit(hljs.TITLE_MODE, {
        begin: "\\b([A-Za-z0-9_\\-]+)\\b"
    });
    return {
        name: "LiveCode",
        case_insensitive: false,
        keywords: {
            keyword: "$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",
            literal: "SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",
            built_in: "put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"
        },
        contains: [
            VARIABLE,
            {
                className: "keyword",
                begin: "\\bend\\sif\\b"
            },
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    VARIABLE,
                    TITLE2,
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.BINARY_NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    TITLE1
                ]
            },
            {
                className: "function",
                begin: "\\bend\\s+",
                end: "$",
                keywords: "end",
                contains: [
                    TITLE2,
                    TITLE1
                ],
                relevance: 0
            },
            {
                beginKeywords: "command on",
                end: "$",
                contains: [
                    VARIABLE,
                    TITLE2,
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.BINARY_NUMBER_MODE,
                    hljs.C_NUMBER_MODE,
                    TITLE1
                ]
            },
            {
                className: "meta",
                variants: [
                    {
                        begin: "<\\?(rev|lc|livecode)",
                        relevance: 10
                    },
                    {
                        begin: "<\\?"
                    },
                    {
                        begin: "\\?>"
                    }
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE,
            TITLE1
        ].concat(COMMENT_MODES),
        illegal: ";$|^\\[|^=|&|\\{"
    };
}
module.exports = $0cd51c5e838d2c45$var$livecodeserver;

});

parcelRegister("5bJQY", function(module, exports) {
const $3c718c5b60111588$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $3c718c5b60111588$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
const $3c718c5b60111588$var$TYPES = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
];
const $3c718c5b60111588$var$ERROR_TYPES = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $3c718c5b60111588$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $3c718c5b60111588$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global" // Node.js
];
const $3c718c5b60111588$var$BUILT_INS = [].concat($3c718c5b60111588$var$BUILT_IN_GLOBALS, $3c718c5b60111588$var$BUILT_IN_VARIABLES, $3c718c5b60111588$var$TYPES, $3c718c5b60111588$var$ERROR_TYPES);
/*
Language: LiveScript
Author: Taneli Vatanen <taneli.vatanen@gmail.com>
Contributors: Jen Evers-Corvina <jen@sevvie.net>
Origin: coffeescript.js
Description: LiveScript is a programming language that transcompiles to JavaScript. For info about language see http://livescript.net/
Website: https://livescript.net
Category: scripting
*/ function $3c718c5b60111588$var$livescript(hljs) {
    const LIVESCRIPT_BUILT_INS = [
        "npm",
        "print"
    ];
    const LIVESCRIPT_LITERALS = [
        "yes",
        "no",
        "on",
        "off",
        "it",
        "that",
        "void"
    ];
    const LIVESCRIPT_KEYWORDS = [
        "then",
        "unless",
        "until",
        "loop",
        "of",
        "by",
        "when",
        "and",
        "or",
        "is",
        "isnt",
        "not",
        "it",
        "that",
        "otherwise",
        "from",
        "to",
        "til",
        "fallthrough",
        "case",
        "enum",
        "native",
        "list",
        "map",
        "__hasProp",
        "__extends",
        "__slice",
        "__bind",
        "__indexOf"
    ];
    const KEYWORDS$1 = {
        keyword: $3c718c5b60111588$var$KEYWORDS.concat(LIVESCRIPT_KEYWORDS),
        literal: $3c718c5b60111588$var$LITERALS.concat(LIVESCRIPT_LITERALS),
        built_in: $3c718c5b60111588$var$BUILT_INS.concat(LIVESCRIPT_BUILT_INS)
    };
    const JS_IDENT_RE = "[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*";
    const TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: KEYWORDS$1
    };
    const SUBST_SIMPLE = {
        className: "subst",
        begin: /#[A-Za-z$_]/,
        end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
        keywords: KEYWORDS$1
    };
    const EXPRESSIONS = [
        hljs.BINARY_NUMBER_MODE,
        {
            className: "number",
            begin: "(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",
            relevance: 0,
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            } // a number tries to eat the following slash to prevent treating it as a regexp
        },
        {
            className: "string",
            variants: [
                {
                    begin: /'''/,
                    end: /'''/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"""/,
                    end: /"""/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST,
                        SUBST_SIMPLE
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST,
                        SUBST_SIMPLE
                    ]
                },
                {
                    begin: /\\/,
                    end: /(\s|$)/,
                    excludeEnd: true
                }
            ]
        },
        {
            className: "regexp",
            variants: [
                {
                    begin: "//",
                    end: "//[gim]*",
                    contains: [
                        SUBST,
                        hljs.HASH_COMMENT_MODE
                    ]
                },
                {
                    // regex can't start with space to parse x / 2 / 3 as two divisions
                    // regex can't start with *, and it supports an "illegal" in the main mode
                    begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
                }
            ]
        },
        {
            begin: "@" + JS_IDENT_RE
        },
        {
            begin: "``",
            end: "``",
            excludeBegin: true,
            excludeEnd: true,
            subLanguage: "javascript"
        }
    ];
    SUBST.contains = EXPRESSIONS;
    const PARAMS = {
        className: "params",
        begin: "\\(",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS$1,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    const SYMBOLS = {
        begin: "(#=>|=>|\\|>>|-?->|!->)"
    };
    return {
        name: "LiveScript",
        aliases: [
            "ls"
        ],
        keywords: KEYWORDS$1,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("\\/\\*", "\\*\\/"),
            hljs.HASH_COMMENT_MODE,
            SYMBOLS,
            {
                className: "function",
                contains: [
                    TITLE,
                    PARAMS
                ],
                returnBegin: true,
                variants: [
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?",
                        end: "->\\*?"
                    },
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?",
                        end: "[-~]{1,2}>\\*?"
                    },
                    {
                        begin: "(" + JS_IDENT_RE + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?",
                        end: "!?[-~]{1,2}>\\*?"
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
}
module.exports = $3c718c5b60111588$var$livescript;

});

parcelRegister("lCRAk", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $fbe6b67466fc0fd2$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $fbe6b67466fc0fd2$var$concat(...args) {
    const joined = args.map((x)=>$fbe6b67466fc0fd2$var$source(x)).join("");
    return joined;
}
/*
Language: LLVM IR
Author: Michael Rodler <contact@f0rki.at>
Description: language used as intermediate representation in the LLVM compiler framework
Website: https://llvm.org/docs/LangRef.html
Category: assembler
Audit: 2020
*/ /** @type LanguageFn */ function $fbe6b67466fc0fd2$var$llvm(hljs) {
    const IDENT_RE = /([-a-zA-Z$._][\w$.-]*)/;
    const TYPE = {
        className: "type",
        begin: /\bi\d+(?=\s|\b)/
    };
    const OPERATOR = {
        className: "operator",
        relevance: 0,
        begin: /=/
    };
    const PUNCTUATION = {
        className: "punctuation",
        relevance: 0,
        begin: /,/
    };
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: /0[xX][a-fA-F0-9]+/
            },
            {
                begin: /-?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/
            }
        ],
        relevance: 0
    };
    const LABEL = {
        className: "symbol",
        variants: [
            {
                begin: /^\s*[a-z]+:/
            }
        ],
        relevance: 0
    };
    const VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: $fbe6b67466fc0fd2$var$concat(/%/, IDENT_RE)
            },
            {
                begin: /%\d+/
            },
            {
                begin: /#\d+/
            }
        ]
    };
    const FUNCTION = {
        className: "title",
        variants: [
            {
                begin: $fbe6b67466fc0fd2$var$concat(/@/, IDENT_RE)
            },
            {
                begin: /@\d+/
            },
            {
                begin: $fbe6b67466fc0fd2$var$concat(/!/, IDENT_RE)
            },
            {
                begin: $fbe6b67466fc0fd2$var$concat(/!\d+/, IDENT_RE)
            },
            // https://llvm.org/docs/LangRef.html#namedmetadatastructure
            // obviously a single digit can also be used in this fashion
            {
                begin: /!\d+/
            }
        ]
    };
    return {
        name: "LLVM IR",
        // TODO: split into different categories of keywords
        keywords: "begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly double",
        contains: [
            TYPE,
            // this matches "empty comments"...
            // ...because it's far more likely this is a statement terminator in
            // another language than an actual comment
            hljs.COMMENT(/;\s*$/, null, {
                relevance: 0
            }),
            hljs.COMMENT(/;/, /$/),
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                variants: [
                    // Double-quoted string
                    {
                        begin: /"/,
                        end: /[^\\]"/
                    }
                ]
            },
            FUNCTION,
            PUNCTUATION,
            OPERATOR,
            VARIABLE,
            LABEL,
            NUMBER
        ]
    };
}
module.exports = $fbe6b67466fc0fd2$var$llvm;

});

parcelRegister("9Re3w", function(module, exports) {
/*
Language: LSL (Linden Scripting Language)
Description: The Linden Scripting Language is used in Second Life by Linden Labs.
Author: Builder's Brewery <buildersbrewery@gmail.com>
Website: http://wiki.secondlife.com/wiki/LSL_Portal
Category: scripting
*/ function $72d3f776749ea404$var$lsl(hljs) {
    var LSL_STRING_ESCAPE_CHARS = {
        className: "subst",
        begin: /\\[tn"\\]/
    };
    var LSL_STRINGS = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            LSL_STRING_ESCAPE_CHARS
        ]
    };
    var LSL_NUMBERS = {
        className: "number",
        relevance: 0,
        begin: hljs.C_NUMBER_RE
    };
    var LSL_CONSTANTS = {
        className: "literal",
        variants: [
            {
                begin: "\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b"
            },
            {
                begin: "\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b"
            },
            {
                begin: "\\b(FALSE|TRUE)\\b"
            },
            {
                begin: "\\b(ZERO_ROTATION)\\b"
            },
            {
                begin: "\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b"
            },
            {
                begin: "\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b"
            }
        ]
    };
    var LSL_FUNCTIONS = {
        className: "built_in",
        begin: "\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b"
    };
    return {
        name: "LSL (Linden Scripting Language)",
        illegal: ":",
        contains: [
            LSL_STRINGS,
            {
                className: "comment",
                variants: [
                    hljs.COMMENT("//", "$"),
                    hljs.COMMENT("/\\*", "\\*/")
                ],
                relevance: 0
            },
            LSL_NUMBERS,
            {
                className: "section",
                variants: [
                    {
                        begin: "\\b(state|default)\\b"
                    },
                    {
                        begin: "\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b"
                    }
                ]
            },
            LSL_FUNCTIONS,
            LSL_CONSTANTS,
            {
                className: "type",
                begin: "\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b"
            }
        ]
    };
}
module.exports = $72d3f776749ea404$var$lsl;

});

parcelRegister("7rY7i", function(module, exports) {
/*
Language: Lua
Description: Lua is a powerful, efficient, lightweight, embeddable scripting language.
Author: Andrew Fedorov <dmmdrs@mail.ru>
Category: common, scripting
Website: https://www.lua.org
*/ function $56c9aff36d87e8d9$var$lua(hljs) {
    const OPENING_LONG_BRACKET = "\\[=*\\[";
    const CLOSING_LONG_BRACKET = "\\]=*\\]";
    const LONG_BRACKETS = {
        begin: OPENING_LONG_BRACKET,
        end: CLOSING_LONG_BRACKET,
        contains: [
            "self"
        ]
    };
    const COMMENTS = [
        hljs.COMMENT("--(?!" + OPENING_LONG_BRACKET + ")", "$"),
        hljs.COMMENT("--" + OPENING_LONG_BRACKET, CLOSING_LONG_BRACKET, {
            contains: [
                LONG_BRACKETS
            ],
            relevance: 10
        })
    ];
    return {
        name: "Lua",
        keywords: {
            $pattern: hljs.UNDERSCORE_IDENT_RE,
            literal: "true false nil",
            keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
            built_in: // Metatags and globals:
            "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
        },
        contains: COMMENTS.concat([
            {
                className: "function",
                beginKeywords: "function",
                end: "\\)",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                    }),
                    {
                        className: "params",
                        begin: "\\(",
                        endsWithParent: true,
                        contains: COMMENTS
                    }
                ].concat(COMMENTS)
            },
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: OPENING_LONG_BRACKET,
                end: CLOSING_LONG_BRACKET,
                contains: [
                    LONG_BRACKETS
                ],
                relevance: 5
            }
        ])
    };
}
module.exports = $56c9aff36d87e8d9$var$lua;

});

parcelRegister("6YHAI", function(module, exports) {
/*
Language: Makefile
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Contributors: Joël Porquet <joel@porquet.org>
Website: https://www.gnu.org/software/make/manual/html_node/Introduction.html
Category: common
*/ function $514a28ffcf90e278$var$makefile(hljs) {
    /* Variables: simple (eg $(var)) and special (eg $@) */ const VARIABLE = {
        className: "variable",
        variants: [
            {
                begin: "\\$\\(" + hljs.UNDERSCORE_IDENT_RE + "\\)",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: /\$[@%<?\^\+\*]/
            }
        ]
    };
    /* Quoted string with variables inside */ const QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VARIABLE
        ]
    };
    /* Function: $(func arg,...) */ const FUNC = {
        className: "variable",
        begin: /\$\([\w-]+\s/,
        end: /\)/,
        keywords: {
            built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value"
        },
        contains: [
            VARIABLE
        ]
    };
    /* Variable assignment */ const ASSIGNMENT = {
        begin: "^" + hljs.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)"
    };
    /* Meta targets (.PHONY) */ const META = {
        className: "meta",
        begin: /^\.PHONY:/,
        end: /$/,
        keywords: {
            $pattern: /[\.\w]+/,
            "meta-keyword": ".PHONY"
        }
    };
    /* Targets */ const TARGET = {
        className: "section",
        begin: /^[^\s]+:/,
        end: /$/,
        contains: [
            VARIABLE
        ]
    };
    return {
        name: "Makefile",
        aliases: [
            "mk",
            "mak",
            "make"
        ],
        keywords: {
            $pattern: /[\w-]+/,
            keyword: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            VARIABLE,
            QUOTE_STRING,
            FUNC,
            ASSIGNMENT,
            META,
            TARGET
        ]
    };
}
module.exports = $514a28ffcf90e278$var$makefile;

});

parcelRegister("9e07y", function(module, exports) {
const $6b7583d952c27b16$var$SYSTEM_SYMBOLS = [
    "AASTriangle",
    "AbelianGroup",
    "Abort",
    "AbortKernels",
    "AbortProtect",
    "AbortScheduledTask",
    "Above",
    "Abs",
    "AbsArg",
    "AbsArgPlot",
    "Absolute",
    "AbsoluteCorrelation",
    "AbsoluteCorrelationFunction",
    "AbsoluteCurrentValue",
    "AbsoluteDashing",
    "AbsoluteFileName",
    "AbsoluteOptions",
    "AbsolutePointSize",
    "AbsoluteThickness",
    "AbsoluteTime",
    "AbsoluteTiming",
    "AcceptanceThreshold",
    "AccountingForm",
    "Accumulate",
    "Accuracy",
    "AccuracyGoal",
    "ActionDelay",
    "ActionMenu",
    "ActionMenuBox",
    "ActionMenuBoxOptions",
    "Activate",
    "Active",
    "ActiveClassification",
    "ActiveClassificationObject",
    "ActiveItem",
    "ActivePrediction",
    "ActivePredictionObject",
    "ActiveStyle",
    "AcyclicGraphQ",
    "AddOnHelpPath",
    "AddSides",
    "AddTo",
    "AddToSearchIndex",
    "AddUsers",
    "AdjacencyGraph",
    "AdjacencyList",
    "AdjacencyMatrix",
    "AdjacentMeshCells",
    "AdjustmentBox",
    "AdjustmentBoxOptions",
    "AdjustTimeSeriesForecast",
    "AdministrativeDivisionData",
    "AffineHalfSpace",
    "AffineSpace",
    "AffineStateSpaceModel",
    "AffineTransform",
    "After",
    "AggregatedEntityClass",
    "AggregationLayer",
    "AircraftData",
    "AirportData",
    "AirPressureData",
    "AirTemperatureData",
    "AiryAi",
    "AiryAiPrime",
    "AiryAiZero",
    "AiryBi",
    "AiryBiPrime",
    "AiryBiZero",
    "AlgebraicIntegerQ",
    "AlgebraicNumber",
    "AlgebraicNumberDenominator",
    "AlgebraicNumberNorm",
    "AlgebraicNumberPolynomial",
    "AlgebraicNumberTrace",
    "AlgebraicRules",
    "AlgebraicRulesData",
    "Algebraics",
    "AlgebraicUnitQ",
    "Alignment",
    "AlignmentMarker",
    "AlignmentPoint",
    "All",
    "AllowAdultContent",
    "AllowedCloudExtraParameters",
    "AllowedCloudParameterExtensions",
    "AllowedDimensions",
    "AllowedFrequencyRange",
    "AllowedHeads",
    "AllowGroupClose",
    "AllowIncomplete",
    "AllowInlineCells",
    "AllowKernelInitialization",
    "AllowLooseGrammar",
    "AllowReverseGroupClose",
    "AllowScriptLevelChange",
    "AllowVersionUpdate",
    "AllTrue",
    "Alphabet",
    "AlphabeticOrder",
    "AlphabeticSort",
    "AlphaChannel",
    "AlternateImage",
    "AlternatingFactorial",
    "AlternatingGroup",
    "AlternativeHypothesis",
    "Alternatives",
    "AltitudeMethod",
    "AmbientLight",
    "AmbiguityFunction",
    "AmbiguityList",
    "Analytic",
    "AnatomyData",
    "AnatomyForm",
    "AnatomyPlot3D",
    "AnatomySkinStyle",
    "AnatomyStyling",
    "AnchoredSearch",
    "And",
    "AndersonDarlingTest",
    "AngerJ",
    "AngleBisector",
    "AngleBracket",
    "AnglePath",
    "AnglePath3D",
    "AngleVector",
    "AngularGauge",
    "Animate",
    "AnimationCycleOffset",
    "AnimationCycleRepetitions",
    "AnimationDirection",
    "AnimationDisplayTime",
    "AnimationRate",
    "AnimationRepetitions",
    "AnimationRunning",
    "AnimationRunTime",
    "AnimationTimeIndex",
    "Animator",
    "AnimatorBox",
    "AnimatorBoxOptions",
    "AnimatorElements",
    "Annotate",
    "Annotation",
    "AnnotationDelete",
    "AnnotationKeys",
    "AnnotationRules",
    "AnnotationValue",
    "Annuity",
    "AnnuityDue",
    "Annulus",
    "AnomalyDetection",
    "AnomalyDetector",
    "AnomalyDetectorFunction",
    "Anonymous",
    "Antialiasing",
    "AntihermitianMatrixQ",
    "Antisymmetric",
    "AntisymmetricMatrixQ",
    "Antonyms",
    "AnyOrder",
    "AnySubset",
    "AnyTrue",
    "Apart",
    "ApartSquareFree",
    "APIFunction",
    "Appearance",
    "AppearanceElements",
    "AppearanceRules",
    "AppellF1",
    "Append",
    "AppendCheck",
    "AppendLayer",
    "AppendTo",
    "Apply",
    "ApplySides",
    "ArcCos",
    "ArcCosh",
    "ArcCot",
    "ArcCoth",
    "ArcCsc",
    "ArcCsch",
    "ArcCurvature",
    "ARCHProcess",
    "ArcLength",
    "ArcSec",
    "ArcSech",
    "ArcSin",
    "ArcSinDistribution",
    "ArcSinh",
    "ArcTan",
    "ArcTanh",
    "Area",
    "Arg",
    "ArgMax",
    "ArgMin",
    "ArgumentCountQ",
    "ARIMAProcess",
    "ArithmeticGeometricMean",
    "ARMAProcess",
    "Around",
    "AroundReplace",
    "ARProcess",
    "Array",
    "ArrayComponents",
    "ArrayDepth",
    "ArrayFilter",
    "ArrayFlatten",
    "ArrayMesh",
    "ArrayPad",
    "ArrayPlot",
    "ArrayQ",
    "ArrayResample",
    "ArrayReshape",
    "ArrayRules",
    "Arrays",
    "Arrow",
    "Arrow3DBox",
    "ArrowBox",
    "Arrowheads",
    "ASATriangle",
    "Ask",
    "AskAppend",
    "AskConfirm",
    "AskDisplay",
    "AskedQ",
    "AskedValue",
    "AskFunction",
    "AskState",
    "AskTemplateDisplay",
    "AspectRatio",
    "AspectRatioFixed",
    "Assert",
    "AssociateTo",
    "Association",
    "AssociationFormat",
    "AssociationMap",
    "AssociationQ",
    "AssociationThread",
    "AssumeDeterministic",
    "Assuming",
    "Assumptions",
    "AstronomicalData",
    "Asymptotic",
    "AsymptoticDSolveValue",
    "AsymptoticEqual",
    "AsymptoticEquivalent",
    "AsymptoticGreater",
    "AsymptoticGreaterEqual",
    "AsymptoticIntegrate",
    "AsymptoticLess",
    "AsymptoticLessEqual",
    "AsymptoticOutputTracker",
    "AsymptoticProduct",
    "AsymptoticRSolveValue",
    "AsymptoticSolve",
    "AsymptoticSum",
    "Asynchronous",
    "AsynchronousTaskObject",
    "AsynchronousTasks",
    "Atom",
    "AtomCoordinates",
    "AtomCount",
    "AtomDiagramCoordinates",
    "AtomList",
    "AtomQ",
    "AttentionLayer",
    "Attributes",
    "Audio",
    "AudioAmplify",
    "AudioAnnotate",
    "AudioAnnotationLookup",
    "AudioBlockMap",
    "AudioCapture",
    "AudioChannelAssignment",
    "AudioChannelCombine",
    "AudioChannelMix",
    "AudioChannels",
    "AudioChannelSeparate",
    "AudioData",
    "AudioDelay",
    "AudioDelete",
    "AudioDevice",
    "AudioDistance",
    "AudioEncoding",
    "AudioFade",
    "AudioFrequencyShift",
    "AudioGenerator",
    "AudioIdentify",
    "AudioInputDevice",
    "AudioInsert",
    "AudioInstanceQ",
    "AudioIntervals",
    "AudioJoin",
    "AudioLabel",
    "AudioLength",
    "AudioLocalMeasurements",
    "AudioLooping",
    "AudioLoudness",
    "AudioMeasurements",
    "AudioNormalize",
    "AudioOutputDevice",
    "AudioOverlay",
    "AudioPad",
    "AudioPan",
    "AudioPartition",
    "AudioPause",
    "AudioPitchShift",
    "AudioPlay",
    "AudioPlot",
    "AudioQ",
    "AudioRecord",
    "AudioReplace",
    "AudioResample",
    "AudioReverb",
    "AudioReverse",
    "AudioSampleRate",
    "AudioSpectralMap",
    "AudioSpectralTransformation",
    "AudioSplit",
    "AudioStop",
    "AudioStream",
    "AudioStreams",
    "AudioTimeStretch",
    "AudioTracks",
    "AudioTrim",
    "AudioType",
    "AugmentedPolyhedron",
    "AugmentedSymmetricPolynomial",
    "Authenticate",
    "Authentication",
    "AuthenticationDialog",
    "AutoAction",
    "Autocomplete",
    "AutocompletionFunction",
    "AutoCopy",
    "AutocorrelationTest",
    "AutoDelete",
    "AutoEvaluateEvents",
    "AutoGeneratedPackage",
    "AutoIndent",
    "AutoIndentSpacings",
    "AutoItalicWords",
    "AutoloadPath",
    "AutoMatch",
    "Automatic",
    "AutomaticImageSize",
    "AutoMultiplicationSymbol",
    "AutoNumberFormatting",
    "AutoOpenNotebooks",
    "AutoOpenPalettes",
    "AutoQuoteCharacters",
    "AutoRefreshed",
    "AutoRemove",
    "AutorunSequencing",
    "AutoScaling",
    "AutoScroll",
    "AutoSpacing",
    "AutoStyleOptions",
    "AutoStyleWords",
    "AutoSubmitting",
    "Axes",
    "AxesEdge",
    "AxesLabel",
    "AxesOrigin",
    "AxesStyle",
    "AxiomaticTheory",
    "Axis",
    "BabyMonsterGroupB",
    "Back",
    "Background",
    "BackgroundAppearance",
    "BackgroundTasksSettings",
    "Backslash",
    "Backsubstitution",
    "Backward",
    "Ball",
    "Band",
    "BandpassFilter",
    "BandstopFilter",
    "BarabasiAlbertGraphDistribution",
    "BarChart",
    "BarChart3D",
    "BarcodeImage",
    "BarcodeRecognize",
    "BaringhausHenzeTest",
    "BarLegend",
    "BarlowProschanImportance",
    "BarnesG",
    "BarOrigin",
    "BarSpacing",
    "BartlettHannWindow",
    "BartlettWindow",
    "BaseDecode",
    "BaseEncode",
    "BaseForm",
    "Baseline",
    "BaselinePosition",
    "BaseStyle",
    "BasicRecurrentLayer",
    "BatchNormalizationLayer",
    "BatchSize",
    "BatesDistribution",
    "BattleLemarieWavelet",
    "BayesianMaximization",
    "BayesianMaximizationObject",
    "BayesianMinimization",
    "BayesianMinimizationObject",
    "Because",
    "BeckmannDistribution",
    "Beep",
    "Before",
    "Begin",
    "BeginDialogPacket",
    "BeginFrontEndInteractionPacket",
    "BeginPackage",
    "BellB",
    "BellY",
    "Below",
    "BenfordDistribution",
    "BeniniDistribution",
    "BenktanderGibratDistribution",
    "BenktanderWeibullDistribution",
    "BernoulliB",
    "BernoulliDistribution",
    "BernoulliGraphDistribution",
    "BernoulliProcess",
    "BernsteinBasis",
    "BesselFilterModel",
    "BesselI",
    "BesselJ",
    "BesselJZero",
    "BesselK",
    "BesselY",
    "BesselYZero",
    "Beta",
    "BetaBinomialDistribution",
    "BetaDistribution",
    "BetaNegativeBinomialDistribution",
    "BetaPrimeDistribution",
    "BetaRegularized",
    "Between",
    "BetweennessCentrality",
    "BeveledPolyhedron",
    "BezierCurve",
    "BezierCurve3DBox",
    "BezierCurve3DBoxOptions",
    "BezierCurveBox",
    "BezierCurveBoxOptions",
    "BezierFunction",
    "BilateralFilter",
    "Binarize",
    "BinaryDeserialize",
    "BinaryDistance",
    "BinaryFormat",
    "BinaryImageQ",
    "BinaryRead",
    "BinaryReadList",
    "BinarySerialize",
    "BinaryWrite",
    "BinCounts",
    "BinLists",
    "Binomial",
    "BinomialDistribution",
    "BinomialProcess",
    "BinormalDistribution",
    "BiorthogonalSplineWavelet",
    "BipartiteGraphQ",
    "BiquadraticFilterModel",
    "BirnbaumImportance",
    "BirnbaumSaundersDistribution",
    "BitAnd",
    "BitClear",
    "BitGet",
    "BitLength",
    "BitNot",
    "BitOr",
    "BitSet",
    "BitShiftLeft",
    "BitShiftRight",
    "BitXor",
    "BiweightLocation",
    "BiweightMidvariance",
    "Black",
    "BlackmanHarrisWindow",
    "BlackmanNuttallWindow",
    "BlackmanWindow",
    "Blank",
    "BlankForm",
    "BlankNullSequence",
    "BlankSequence",
    "Blend",
    "Block",
    "BlockchainAddressData",
    "BlockchainBase",
    "BlockchainBlockData",
    "BlockchainContractValue",
    "BlockchainData",
    "BlockchainGet",
    "BlockchainKeyEncode",
    "BlockchainPut",
    "BlockchainTokenData",
    "BlockchainTransaction",
    "BlockchainTransactionData",
    "BlockchainTransactionSign",
    "BlockchainTransactionSubmit",
    "BlockMap",
    "BlockRandom",
    "BlomqvistBeta",
    "BlomqvistBetaTest",
    "Blue",
    "Blur",
    "BodePlot",
    "BohmanWindow",
    "Bold",
    "Bond",
    "BondCount",
    "BondList",
    "BondQ",
    "Bookmarks",
    "Boole",
    "BooleanConsecutiveFunction",
    "BooleanConvert",
    "BooleanCountingFunction",
    "BooleanFunction",
    "BooleanGraph",
    "BooleanMaxterms",
    "BooleanMinimize",
    "BooleanMinterms",
    "BooleanQ",
    "BooleanRegion",
    "Booleans",
    "BooleanStrings",
    "BooleanTable",
    "BooleanVariables",
    "BorderDimensions",
    "BorelTannerDistribution",
    "Bottom",
    "BottomHatTransform",
    "BoundaryDiscretizeGraphics",
    "BoundaryDiscretizeRegion",
    "BoundaryMesh",
    "BoundaryMeshRegion",
    "BoundaryMeshRegionQ",
    "BoundaryStyle",
    "BoundedRegionQ",
    "BoundingRegion",
    "Bounds",
    "Box",
    "BoxBaselineShift",
    "BoxData",
    "BoxDimensions",
    "Boxed",
    "Boxes",
    "BoxForm",
    "BoxFormFormatTypes",
    "BoxFrame",
    "BoxID",
    "BoxMargins",
    "BoxMatrix",
    "BoxObject",
    "BoxRatios",
    "BoxRotation",
    "BoxRotationPoint",
    "BoxStyle",
    "BoxWhiskerChart",
    "Bra",
    "BracketingBar",
    "BraKet",
    "BrayCurtisDistance",
    "BreadthFirstScan",
    "Break",
    "BridgeData",
    "BrightnessEqualize",
    "BroadcastStationData",
    "Brown",
    "BrownForsytheTest",
    "BrownianBridgeProcess",
    "BrowserCategory",
    "BSplineBasis",
    "BSplineCurve",
    "BSplineCurve3DBox",
    "BSplineCurve3DBoxOptions",
    "BSplineCurveBox",
    "BSplineCurveBoxOptions",
    "BSplineFunction",
    "BSplineSurface",
    "BSplineSurface3DBox",
    "BSplineSurface3DBoxOptions",
    "BubbleChart",
    "BubbleChart3D",
    "BubbleScale",
    "BubbleSizes",
    "BuildingData",
    "BulletGauge",
    "BusinessDayQ",
    "ButterflyGraph",
    "ButterworthFilterModel",
    "Button",
    "ButtonBar",
    "ButtonBox",
    "ButtonBoxOptions",
    "ButtonCell",
    "ButtonContents",
    "ButtonData",
    "ButtonEvaluator",
    "ButtonExpandable",
    "ButtonFrame",
    "ButtonFunction",
    "ButtonMargins",
    "ButtonMinHeight",
    "ButtonNote",
    "ButtonNotebook",
    "ButtonSource",
    "ButtonStyle",
    "ButtonStyleMenuListing",
    "Byte",
    "ByteArray",
    "ByteArrayFormat",
    "ByteArrayQ",
    "ByteArrayToString",
    "ByteCount",
    "ByteOrdering",
    "C",
    "CachedValue",
    "CacheGraphics",
    "CachePersistence",
    "CalendarConvert",
    "CalendarData",
    "CalendarType",
    "Callout",
    "CalloutMarker",
    "CalloutStyle",
    "CallPacket",
    "CanberraDistance",
    "Cancel",
    "CancelButton",
    "CandlestickChart",
    "CanonicalGraph",
    "CanonicalizePolygon",
    "CanonicalizePolyhedron",
    "CanonicalName",
    "CanonicalWarpingCorrespondence",
    "CanonicalWarpingDistance",
    "CantorMesh",
    "CantorStaircase",
    "Cap",
    "CapForm",
    "CapitalDifferentialD",
    "Capitalize",
    "CapsuleShape",
    "CaptureRunning",
    "CardinalBSplineBasis",
    "CarlemanLinearize",
    "CarmichaelLambda",
    "CaseOrdering",
    "Cases",
    "CaseSensitive",
    "Cashflow",
    "Casoratian",
    "Catalan",
    "CatalanNumber",
    "Catch",
    "CategoricalDistribution",
    "Catenate",
    "CatenateLayer",
    "CauchyDistribution",
    "CauchyWindow",
    "CayleyGraph",
    "CDF",
    "CDFDeploy",
    "CDFInformation",
    "CDFWavelet",
    "Ceiling",
    "CelestialSystem",
    "Cell",
    "CellAutoOverwrite",
    "CellBaseline",
    "CellBoundingBox",
    "CellBracketOptions",
    "CellChangeTimes",
    "CellContents",
    "CellContext",
    "CellDingbat",
    "CellDynamicExpression",
    "CellEditDuplicate",
    "CellElementsBoundingBox",
    "CellElementSpacings",
    "CellEpilog",
    "CellEvaluationDuplicate",
    "CellEvaluationFunction",
    "CellEvaluationLanguage",
    "CellEventActions",
    "CellFrame",
    "CellFrameColor",
    "CellFrameLabelMargins",
    "CellFrameLabels",
    "CellFrameMargins",
    "CellGroup",
    "CellGroupData",
    "CellGrouping",
    "CellGroupingRules",
    "CellHorizontalScrolling",
    "CellID",
    "CellLabel",
    "CellLabelAutoDelete",
    "CellLabelMargins",
    "CellLabelPositioning",
    "CellLabelStyle",
    "CellLabelTemplate",
    "CellMargins",
    "CellObject",
    "CellOpen",
    "CellPrint",
    "CellProlog",
    "Cells",
    "CellSize",
    "CellStyle",
    "CellTags",
    "CellularAutomaton",
    "CensoredDistribution",
    "Censoring",
    "Center",
    "CenterArray",
    "CenterDot",
    "CentralFeature",
    "CentralMoment",
    "CentralMomentGeneratingFunction",
    "Cepstrogram",
    "CepstrogramArray",
    "CepstrumArray",
    "CForm",
    "ChampernowneNumber",
    "ChangeOptions",
    "ChannelBase",
    "ChannelBrokerAction",
    "ChannelDatabin",
    "ChannelHistoryLength",
    "ChannelListen",
    "ChannelListener",
    "ChannelListeners",
    "ChannelListenerWait",
    "ChannelObject",
    "ChannelPreSendFunction",
    "ChannelReceiverFunction",
    "ChannelSend",
    "ChannelSubscribers",
    "ChanVeseBinarize",
    "Character",
    "CharacterCounts",
    "CharacterEncoding",
    "CharacterEncodingsPath",
    "CharacteristicFunction",
    "CharacteristicPolynomial",
    "CharacterName",
    "CharacterNormalize",
    "CharacterRange",
    "Characters",
    "ChartBaseStyle",
    "ChartElementData",
    "ChartElementDataFunction",
    "ChartElementFunction",
    "ChartElements",
    "ChartLabels",
    "ChartLayout",
    "ChartLegends",
    "ChartStyle",
    "Chebyshev1FilterModel",
    "Chebyshev2FilterModel",
    "ChebyshevDistance",
    "ChebyshevT",
    "ChebyshevU",
    "Check",
    "CheckAbort",
    "CheckAll",
    "Checkbox",
    "CheckboxBar",
    "CheckboxBox",
    "CheckboxBoxOptions",
    "ChemicalData",
    "ChessboardDistance",
    "ChiDistribution",
    "ChineseRemainder",
    "ChiSquareDistribution",
    "ChoiceButtons",
    "ChoiceDialog",
    "CholeskyDecomposition",
    "Chop",
    "ChromaticityPlot",
    "ChromaticityPlot3D",
    "ChromaticPolynomial",
    "Circle",
    "CircleBox",
    "CircleDot",
    "CircleMinus",
    "CirclePlus",
    "CirclePoints",
    "CircleThrough",
    "CircleTimes",
    "CirculantGraph",
    "CircularOrthogonalMatrixDistribution",
    "CircularQuaternionMatrixDistribution",
    "CircularRealMatrixDistribution",
    "CircularSymplecticMatrixDistribution",
    "CircularUnitaryMatrixDistribution",
    "Circumsphere",
    "CityData",
    "ClassifierFunction",
    "ClassifierInformation",
    "ClassifierMeasurements",
    "ClassifierMeasurementsObject",
    "Classify",
    "ClassPriors",
    "Clear",
    "ClearAll",
    "ClearAttributes",
    "ClearCookies",
    "ClearPermissions",
    "ClearSystemCache",
    "ClebschGordan",
    "ClickPane",
    "Clip",
    "ClipboardNotebook",
    "ClipFill",
    "ClippingStyle",
    "ClipPlanes",
    "ClipPlanesStyle",
    "ClipRange",
    "Clock",
    "ClockGauge",
    "ClockwiseContourIntegral",
    "Close",
    "Closed",
    "CloseKernels",
    "ClosenessCentrality",
    "Closing",
    "ClosingAutoSave",
    "ClosingEvent",
    "ClosingSaveDialog",
    "CloudAccountData",
    "CloudBase",
    "CloudConnect",
    "CloudConnections",
    "CloudDeploy",
    "CloudDirectory",
    "CloudDisconnect",
    "CloudEvaluate",
    "CloudExport",
    "CloudExpression",
    "CloudExpressions",
    "CloudFunction",
    "CloudGet",
    "CloudImport",
    "CloudLoggingData",
    "CloudObject",
    "CloudObjectInformation",
    "CloudObjectInformationData",
    "CloudObjectNameFormat",
    "CloudObjects",
    "CloudObjectURLType",
    "CloudPublish",
    "CloudPut",
    "CloudRenderingMethod",
    "CloudSave",
    "CloudShare",
    "CloudSubmit",
    "CloudSymbol",
    "CloudUnshare",
    "CloudUserID",
    "ClusterClassify",
    "ClusterDissimilarityFunction",
    "ClusteringComponents",
    "ClusteringTree",
    "CMYKColor",
    "Coarse",
    "CodeAssistOptions",
    "Coefficient",
    "CoefficientArrays",
    "CoefficientDomain",
    "CoefficientList",
    "CoefficientRules",
    "CoifletWavelet",
    "Collect",
    "Colon",
    "ColonForm",
    "ColorBalance",
    "ColorCombine",
    "ColorConvert",
    "ColorCoverage",
    "ColorData",
    "ColorDataFunction",
    "ColorDetect",
    "ColorDistance",
    "ColorFunction",
    "ColorFunctionScaling",
    "Colorize",
    "ColorNegate",
    "ColorOutput",
    "ColorProfileData",
    "ColorQ",
    "ColorQuantize",
    "ColorReplace",
    "ColorRules",
    "ColorSelectorSettings",
    "ColorSeparate",
    "ColorSetter",
    "ColorSetterBox",
    "ColorSetterBoxOptions",
    "ColorSlider",
    "ColorsNear",
    "ColorSpace",
    "ColorToneMapping",
    "Column",
    "ColumnAlignments",
    "ColumnBackgrounds",
    "ColumnForm",
    "ColumnLines",
    "ColumnsEqual",
    "ColumnSpacings",
    "ColumnWidths",
    "CombinedEntityClass",
    "CombinerFunction",
    "CometData",
    "CommonDefaultFormatTypes",
    "Commonest",
    "CommonestFilter",
    "CommonName",
    "CommonUnits",
    "CommunityBoundaryStyle",
    "CommunityGraphPlot",
    "CommunityLabels",
    "CommunityRegionStyle",
    "CompanyData",
    "CompatibleUnitQ",
    "CompilationOptions",
    "CompilationTarget",
    "Compile",
    "Compiled",
    "CompiledCodeFunction",
    "CompiledFunction",
    "CompilerOptions",
    "Complement",
    "ComplementedEntityClass",
    "CompleteGraph",
    "CompleteGraphQ",
    "CompleteKaryTree",
    "CompletionsListPacket",
    "Complex",
    "ComplexContourPlot",
    "Complexes",
    "ComplexExpand",
    "ComplexInfinity",
    "ComplexityFunction",
    "ComplexListPlot",
    "ComplexPlot",
    "ComplexPlot3D",
    "ComplexRegionPlot",
    "ComplexStreamPlot",
    "ComplexVectorPlot",
    "ComponentMeasurements",
    "ComponentwiseContextMenu",
    "Compose",
    "ComposeList",
    "ComposeSeries",
    "CompositeQ",
    "Composition",
    "CompoundElement",
    "CompoundExpression",
    "CompoundPoissonDistribution",
    "CompoundPoissonProcess",
    "CompoundRenewalProcess",
    "Compress",
    "CompressedData",
    "CompressionLevel",
    "ComputeUncertainty",
    "Condition",
    "ConditionalExpression",
    "Conditioned",
    "Cone",
    "ConeBox",
    "ConfidenceLevel",
    "ConfidenceRange",
    "ConfidenceTransform",
    "ConfigurationPath",
    "ConformAudio",
    "ConformImages",
    "Congruent",
    "ConicHullRegion",
    "ConicHullRegion3DBox",
    "ConicHullRegionBox",
    "ConicOptimization",
    "Conjugate",
    "ConjugateTranspose",
    "Conjunction",
    "Connect",
    "ConnectedComponents",
    "ConnectedGraphComponents",
    "ConnectedGraphQ",
    "ConnectedMeshComponents",
    "ConnectedMoleculeComponents",
    "ConnectedMoleculeQ",
    "ConnectionSettings",
    "ConnectLibraryCallbackFunction",
    "ConnectSystemModelComponents",
    "ConnesWindow",
    "ConoverTest",
    "ConsoleMessage",
    "ConsoleMessagePacket",
    "Constant",
    "ConstantArray",
    "ConstantArrayLayer",
    "ConstantImage",
    "ConstantPlusLayer",
    "ConstantRegionQ",
    "Constants",
    "ConstantTimesLayer",
    "ConstellationData",
    "ConstrainedMax",
    "ConstrainedMin",
    "Construct",
    "Containing",
    "ContainsAll",
    "ContainsAny",
    "ContainsExactly",
    "ContainsNone",
    "ContainsOnly",
    "ContentFieldOptions",
    "ContentLocationFunction",
    "ContentObject",
    "ContentPadding",
    "ContentsBoundingBox",
    "ContentSelectable",
    "ContentSize",
    "Context",
    "ContextMenu",
    "Contexts",
    "ContextToFileName",
    "Continuation",
    "Continue",
    "ContinuedFraction",
    "ContinuedFractionK",
    "ContinuousAction",
    "ContinuousMarkovProcess",
    "ContinuousTask",
    "ContinuousTimeModelQ",
    "ContinuousWaveletData",
    "ContinuousWaveletTransform",
    "ContourDetect",
    "ContourGraphics",
    "ContourIntegral",
    "ContourLabels",
    "ContourLines",
    "ContourPlot",
    "ContourPlot3D",
    "Contours",
    "ContourShading",
    "ContourSmoothing",
    "ContourStyle",
    "ContraharmonicMean",
    "ContrastiveLossLayer",
    "Control",
    "ControlActive",
    "ControlAlignment",
    "ControlGroupContentsBox",
    "ControllabilityGramian",
    "ControllabilityMatrix",
    "ControllableDecomposition",
    "ControllableModelQ",
    "ControllerDuration",
    "ControllerInformation",
    "ControllerInformationData",
    "ControllerLinking",
    "ControllerManipulate",
    "ControllerMethod",
    "ControllerPath",
    "ControllerState",
    "ControlPlacement",
    "ControlsRendering",
    "ControlType",
    "Convergents",
    "ConversionOptions",
    "ConversionRules",
    "ConvertToBitmapPacket",
    "ConvertToPostScript",
    "ConvertToPostScriptPacket",
    "ConvexHullMesh",
    "ConvexPolygonQ",
    "ConvexPolyhedronQ",
    "ConvolutionLayer",
    "Convolve",
    "ConwayGroupCo1",
    "ConwayGroupCo2",
    "ConwayGroupCo3",
    "CookieFunction",
    "Cookies",
    "CoordinateBoundingBox",
    "CoordinateBoundingBoxArray",
    "CoordinateBounds",
    "CoordinateBoundsArray",
    "CoordinateChartData",
    "CoordinatesToolOptions",
    "CoordinateTransform",
    "CoordinateTransformData",
    "CoprimeQ",
    "Coproduct",
    "CopulaDistribution",
    "Copyable",
    "CopyDatabin",
    "CopyDirectory",
    "CopyFile",
    "CopyTag",
    "CopyToClipboard",
    "CornerFilter",
    "CornerNeighbors",
    "Correlation",
    "CorrelationDistance",
    "CorrelationFunction",
    "CorrelationTest",
    "Cos",
    "Cosh",
    "CoshIntegral",
    "CosineDistance",
    "CosineWindow",
    "CosIntegral",
    "Cot",
    "Coth",
    "Count",
    "CountDistinct",
    "CountDistinctBy",
    "CounterAssignments",
    "CounterBox",
    "CounterBoxOptions",
    "CounterClockwiseContourIntegral",
    "CounterEvaluator",
    "CounterFunction",
    "CounterIncrements",
    "CounterStyle",
    "CounterStyleMenuListing",
    "CountRoots",
    "CountryData",
    "Counts",
    "CountsBy",
    "Covariance",
    "CovarianceEstimatorFunction",
    "CovarianceFunction",
    "CoxianDistribution",
    "CoxIngersollRossProcess",
    "CoxModel",
    "CoxModelFit",
    "CramerVonMisesTest",
    "CreateArchive",
    "CreateCellID",
    "CreateChannel",
    "CreateCloudExpression",
    "CreateDatabin",
    "CreateDataStructure",
    "CreateDataSystemModel",
    "CreateDialog",
    "CreateDirectory",
    "CreateDocument",
    "CreateFile",
    "CreateIntermediateDirectories",
    "CreateManagedLibraryExpression",
    "CreateNotebook",
    "CreatePacletArchive",
    "CreatePalette",
    "CreatePalettePacket",
    "CreatePermissionsGroup",
    "CreateScheduledTask",
    "CreateSearchIndex",
    "CreateSystemModel",
    "CreateTemporary",
    "CreateUUID",
    "CreateWindow",
    "CriterionFunction",
    "CriticalityFailureImportance",
    "CriticalitySuccessImportance",
    "CriticalSection",
    "Cross",
    "CrossEntropyLossLayer",
    "CrossingCount",
    "CrossingDetect",
    "CrossingPolygon",
    "CrossMatrix",
    "Csc",
    "Csch",
    "CTCLossLayer",
    "Cube",
    "CubeRoot",
    "Cubics",
    "Cuboid",
    "CuboidBox",
    "Cumulant",
    "CumulantGeneratingFunction",
    "Cup",
    "CupCap",
    "Curl",
    "CurlyDoubleQuote",
    "CurlyQuote",
    "CurrencyConvert",
    "CurrentDate",
    "CurrentImage",
    "CurrentlySpeakingPacket",
    "CurrentNotebookImage",
    "CurrentScreenImage",
    "CurrentValue",
    "Curry",
    "CurryApplied",
    "CurvatureFlowFilter",
    "CurveClosed",
    "Cyan",
    "CycleGraph",
    "CycleIndexPolynomial",
    "Cycles",
    "CyclicGroup",
    "Cyclotomic",
    "Cylinder",
    "CylinderBox",
    "CylindricalDecomposition",
    "D",
    "DagumDistribution",
    "DamData",
    "DamerauLevenshteinDistance",
    "DampingFactor",
    "Darker",
    "Dashed",
    "Dashing",
    "DatabaseConnect",
    "DatabaseDisconnect",
    "DatabaseReference",
    "Databin",
    "DatabinAdd",
    "DatabinRemove",
    "Databins",
    "DatabinUpload",
    "DataCompression",
    "DataDistribution",
    "DataRange",
    "DataReversed",
    "Dataset",
    "DatasetDisplayPanel",
    "DataStructure",
    "DataStructureQ",
    "Date",
    "DateBounds",
    "Dated",
    "DateDelimiters",
    "DateDifference",
    "DatedUnit",
    "DateFormat",
    "DateFunction",
    "DateHistogram",
    "DateInterval",
    "DateList",
    "DateListLogPlot",
    "DateListPlot",
    "DateListStepPlot",
    "DateObject",
    "DateObjectQ",
    "DateOverlapsQ",
    "DatePattern",
    "DatePlus",
    "DateRange",
    "DateReduction",
    "DateString",
    "DateTicksFormat",
    "DateValue",
    "DateWithinQ",
    "DaubechiesWavelet",
    "DavisDistribution",
    "DawsonF",
    "DayCount",
    "DayCountConvention",
    "DayHemisphere",
    "DaylightQ",
    "DayMatchQ",
    "DayName",
    "DayNightTerminator",
    "DayPlus",
    "DayRange",
    "DayRound",
    "DeBruijnGraph",
    "DeBruijnSequence",
    "Debug",
    "DebugTag",
    "Decapitalize",
    "Decimal",
    "DecimalForm",
    "DeclareKnownSymbols",
    "DeclarePackage",
    "Decompose",
    "DeconvolutionLayer",
    "Decrement",
    "Decrypt",
    "DecryptFile",
    "DedekindEta",
    "DeepSpaceProbeData",
    "Default",
    "DefaultAxesStyle",
    "DefaultBaseStyle",
    "DefaultBoxStyle",
    "DefaultButton",
    "DefaultColor",
    "DefaultControlPlacement",
    "DefaultDuplicateCellStyle",
    "DefaultDuration",
    "DefaultElement",
    "DefaultFaceGridsStyle",
    "DefaultFieldHintStyle",
    "DefaultFont",
    "DefaultFontProperties",
    "DefaultFormatType",
    "DefaultFormatTypeForStyle",
    "DefaultFrameStyle",
    "DefaultFrameTicksStyle",
    "DefaultGridLinesStyle",
    "DefaultInlineFormatType",
    "DefaultInputFormatType",
    "DefaultLabelStyle",
    "DefaultMenuStyle",
    "DefaultNaturalLanguage",
    "DefaultNewCellStyle",
    "DefaultNewInlineCellStyle",
    "DefaultNotebook",
    "DefaultOptions",
    "DefaultOutputFormatType",
    "DefaultPrintPrecision",
    "DefaultStyle",
    "DefaultStyleDefinitions",
    "DefaultTextFormatType",
    "DefaultTextInlineFormatType",
    "DefaultTicksStyle",
    "DefaultTooltipStyle",
    "DefaultValue",
    "DefaultValues",
    "Defer",
    "DefineExternal",
    "DefineInputStreamMethod",
    "DefineOutputStreamMethod",
    "DefineResourceFunction",
    "Definition",
    "Degree",
    "DegreeCentrality",
    "DegreeGraphDistribution",
    "DegreeLexicographic",
    "DegreeReverseLexicographic",
    "DEigensystem",
    "DEigenvalues",
    "Deinitialization",
    "Del",
    "DelaunayMesh",
    "Delayed",
    "Deletable",
    "Delete",
    "DeleteAnomalies",
    "DeleteBorderComponents",
    "DeleteCases",
    "DeleteChannel",
    "DeleteCloudExpression",
    "DeleteContents",
    "DeleteDirectory",
    "DeleteDuplicates",
    "DeleteDuplicatesBy",
    "DeleteFile",
    "DeleteMissing",
    "DeleteObject",
    "DeletePermissionsKey",
    "DeleteSearchIndex",
    "DeleteSmallComponents",
    "DeleteStopwords",
    "DeleteWithContents",
    "DeletionWarning",
    "DelimitedArray",
    "DelimitedSequence",
    "Delimiter",
    "DelimiterFlashTime",
    "DelimiterMatching",
    "Delimiters",
    "DeliveryFunction",
    "Dendrogram",
    "Denominator",
    "DensityGraphics",
    "DensityHistogram",
    "DensityPlot",
    "DensityPlot3D",
    "DependentVariables",
    "Deploy",
    "Deployed",
    "Depth",
    "DepthFirstScan",
    "Derivative",
    "DerivativeFilter",
    "DerivedKey",
    "DescriptorStateSpace",
    "DesignMatrix",
    "DestroyAfterEvaluation",
    "Det",
    "DeviceClose",
    "DeviceConfigure",
    "DeviceExecute",
    "DeviceExecuteAsynchronous",
    "DeviceObject",
    "DeviceOpen",
    "DeviceOpenQ",
    "DeviceRead",
    "DeviceReadBuffer",
    "DeviceReadLatest",
    "DeviceReadList",
    "DeviceReadTimeSeries",
    "Devices",
    "DeviceStreams",
    "DeviceWrite",
    "DeviceWriteBuffer",
    "DGaussianWavelet",
    "DiacriticalPositioning",
    "Diagonal",
    "DiagonalizableMatrixQ",
    "DiagonalMatrix",
    "DiagonalMatrixQ",
    "Dialog",
    "DialogIndent",
    "DialogInput",
    "DialogLevel",
    "DialogNotebook",
    "DialogProlog",
    "DialogReturn",
    "DialogSymbols",
    "Diamond",
    "DiamondMatrix",
    "DiceDissimilarity",
    "DictionaryLookup",
    "DictionaryWordQ",
    "DifferenceDelta",
    "DifferenceOrder",
    "DifferenceQuotient",
    "DifferenceRoot",
    "DifferenceRootReduce",
    "Differences",
    "DifferentialD",
    "DifferentialRoot",
    "DifferentialRootReduce",
    "DifferentiatorFilter",
    "DigitalSignature",
    "DigitBlock",
    "DigitBlockMinimum",
    "DigitCharacter",
    "DigitCount",
    "DigitQ",
    "DihedralAngle",
    "DihedralGroup",
    "Dilation",
    "DimensionalCombinations",
    "DimensionalMeshComponents",
    "DimensionReduce",
    "DimensionReducerFunction",
    "DimensionReduction",
    "Dimensions",
    "DiracComb",
    "DiracDelta",
    "DirectedEdge",
    "DirectedEdges",
    "DirectedGraph",
    "DirectedGraphQ",
    "DirectedInfinity",
    "Direction",
    "Directive",
    "Directory",
    "DirectoryName",
    "DirectoryQ",
    "DirectoryStack",
    "DirichletBeta",
    "DirichletCharacter",
    "DirichletCondition",
    "DirichletConvolve",
    "DirichletDistribution",
    "DirichletEta",
    "DirichletL",
    "DirichletLambda",
    "DirichletTransform",
    "DirichletWindow",
    "DisableConsolePrintPacket",
    "DisableFormatting",
    "DiscreteAsymptotic",
    "DiscreteChirpZTransform",
    "DiscreteConvolve",
    "DiscreteDelta",
    "DiscreteHadamardTransform",
    "DiscreteIndicator",
    "DiscreteLimit",
    "DiscreteLQEstimatorGains",
    "DiscreteLQRegulatorGains",
    "DiscreteLyapunovSolve",
    "DiscreteMarkovProcess",
    "DiscreteMaxLimit",
    "DiscreteMinLimit",
    "DiscretePlot",
    "DiscretePlot3D",
    "DiscreteRatio",
    "DiscreteRiccatiSolve",
    "DiscreteShift",
    "DiscreteTimeModelQ",
    "DiscreteUniformDistribution",
    "DiscreteVariables",
    "DiscreteWaveletData",
    "DiscreteWaveletPacketTransform",
    "DiscreteWaveletTransform",
    "DiscretizeGraphics",
    "DiscretizeRegion",
    "Discriminant",
    "DisjointQ",
    "Disjunction",
    "Disk",
    "DiskBox",
    "DiskMatrix",
    "DiskSegment",
    "Dispatch",
    "DispatchQ",
    "DispersionEstimatorFunction",
    "Display",
    "DisplayAllSteps",
    "DisplayEndPacket",
    "DisplayFlushImagePacket",
    "DisplayForm",
    "DisplayFunction",
    "DisplayPacket",
    "DisplayRules",
    "DisplaySetSizePacket",
    "DisplayString",
    "DisplayTemporary",
    "DisplayWith",
    "DisplayWithRef",
    "DisplayWithVariable",
    "DistanceFunction",
    "DistanceMatrix",
    "DistanceTransform",
    "Distribute",
    "Distributed",
    "DistributedContexts",
    "DistributeDefinitions",
    "DistributionChart",
    "DistributionDomain",
    "DistributionFitTest",
    "DistributionParameterAssumptions",
    "DistributionParameterQ",
    "Dithering",
    "Div",
    "Divergence",
    "Divide",
    "DivideBy",
    "Dividers",
    "DivideSides",
    "Divisible",
    "Divisors",
    "DivisorSigma",
    "DivisorSum",
    "DMSList",
    "DMSString",
    "Do",
    "DockedCells",
    "DocumentGenerator",
    "DocumentGeneratorInformation",
    "DocumentGeneratorInformationData",
    "DocumentGenerators",
    "DocumentNotebook",
    "DocumentWeightingRules",
    "Dodecahedron",
    "DomainRegistrationInformation",
    "DominantColors",
    "DOSTextFormat",
    "Dot",
    "DotDashed",
    "DotEqual",
    "DotLayer",
    "DotPlusLayer",
    "Dotted",
    "DoubleBracketingBar",
    "DoubleContourIntegral",
    "DoubleDownArrow",
    "DoubleLeftArrow",
    "DoubleLeftRightArrow",
    "DoubleLeftTee",
    "DoubleLongLeftArrow",
    "DoubleLongLeftRightArrow",
    "DoubleLongRightArrow",
    "DoubleRightArrow",
    "DoubleRightTee",
    "DoubleUpArrow",
    "DoubleUpDownArrow",
    "DoubleVerticalBar",
    "DoublyInfinite",
    "Down",
    "DownArrow",
    "DownArrowBar",
    "DownArrowUpArrow",
    "DownLeftRightVector",
    "DownLeftTeeVector",
    "DownLeftVector",
    "DownLeftVectorBar",
    "DownRightTeeVector",
    "DownRightVector",
    "DownRightVectorBar",
    "Downsample",
    "DownTee",
    "DownTeeArrow",
    "DownValues",
    "DragAndDrop",
    "DrawEdges",
    "DrawFrontFaces",
    "DrawHighlighted",
    "Drop",
    "DropoutLayer",
    "DSolve",
    "DSolveValue",
    "Dt",
    "DualLinearProgramming",
    "DualPolyhedron",
    "DualSystemsModel",
    "DumpGet",
    "DumpSave",
    "DuplicateFreeQ",
    "Duration",
    "Dynamic",
    "DynamicBox",
    "DynamicBoxOptions",
    "DynamicEvaluationTimeout",
    "DynamicGeoGraphics",
    "DynamicImage",
    "DynamicLocation",
    "DynamicModule",
    "DynamicModuleBox",
    "DynamicModuleBoxOptions",
    "DynamicModuleParent",
    "DynamicModuleValues",
    "DynamicName",
    "DynamicNamespace",
    "DynamicReference",
    "DynamicSetting",
    "DynamicUpdating",
    "DynamicWrapper",
    "DynamicWrapperBox",
    "DynamicWrapperBoxOptions",
    "E",
    "EarthImpactData",
    "EarthquakeData",
    "EccentricityCentrality",
    "Echo",
    "EchoFunction",
    "EclipseType",
    "EdgeAdd",
    "EdgeBetweennessCentrality",
    "EdgeCapacity",
    "EdgeCapForm",
    "EdgeColor",
    "EdgeConnectivity",
    "EdgeContract",
    "EdgeCost",
    "EdgeCount",
    "EdgeCoverQ",
    "EdgeCycleMatrix",
    "EdgeDashing",
    "EdgeDelete",
    "EdgeDetect",
    "EdgeForm",
    "EdgeIndex",
    "EdgeJoinForm",
    "EdgeLabeling",
    "EdgeLabels",
    "EdgeLabelStyle",
    "EdgeList",
    "EdgeOpacity",
    "EdgeQ",
    "EdgeRenderingFunction",
    "EdgeRules",
    "EdgeShapeFunction",
    "EdgeStyle",
    "EdgeTaggedGraph",
    "EdgeTaggedGraphQ",
    "EdgeTags",
    "EdgeThickness",
    "EdgeWeight",
    "EdgeWeightedGraphQ",
    "Editable",
    "EditButtonSettings",
    "EditCellTagsSettings",
    "EditDistance",
    "EffectiveInterest",
    "Eigensystem",
    "Eigenvalues",
    "EigenvectorCentrality",
    "Eigenvectors",
    "Element",
    "ElementData",
    "ElementwiseLayer",
    "ElidedForms",
    "Eliminate",
    "EliminationOrder",
    "Ellipsoid",
    "EllipticE",
    "EllipticExp",
    "EllipticExpPrime",
    "EllipticF",
    "EllipticFilterModel",
    "EllipticK",
    "EllipticLog",
    "EllipticNomeQ",
    "EllipticPi",
    "EllipticReducedHalfPeriods",
    "EllipticTheta",
    "EllipticThetaPrime",
    "EmbedCode",
    "EmbeddedHTML",
    "EmbeddedService",
    "EmbeddingLayer",
    "EmbeddingObject",
    "EmitSound",
    "EmphasizeSyntaxErrors",
    "EmpiricalDistribution",
    "Empty",
    "EmptyGraphQ",
    "EmptyRegion",
    "EnableConsolePrintPacket",
    "Enabled",
    "Encode",
    "Encrypt",
    "EncryptedObject",
    "EncryptFile",
    "End",
    "EndAdd",
    "EndDialogPacket",
    "EndFrontEndInteractionPacket",
    "EndOfBuffer",
    "EndOfFile",
    "EndOfLine",
    "EndOfString",
    "EndPackage",
    "EngineEnvironment",
    "EngineeringForm",
    "Enter",
    "EnterExpressionPacket",
    "EnterTextPacket",
    "Entity",
    "EntityClass",
    "EntityClassList",
    "EntityCopies",
    "EntityFunction",
    "EntityGroup",
    "EntityInstance",
    "EntityList",
    "EntityPrefetch",
    "EntityProperties",
    "EntityProperty",
    "EntityPropertyClass",
    "EntityRegister",
    "EntityStore",
    "EntityStores",
    "EntityTypeName",
    "EntityUnregister",
    "EntityValue",
    "Entropy",
    "EntropyFilter",
    "Environment",
    "Epilog",
    "EpilogFunction",
    "Equal",
    "EqualColumns",
    "EqualRows",
    "EqualTilde",
    "EqualTo",
    "EquatedTo",
    "Equilibrium",
    "EquirippleFilterKernel",
    "Equivalent",
    "Erf",
    "Erfc",
    "Erfi",
    "ErlangB",
    "ErlangC",
    "ErlangDistribution",
    "Erosion",
    "ErrorBox",
    "ErrorBoxOptions",
    "ErrorNorm",
    "ErrorPacket",
    "ErrorsDialogSettings",
    "EscapeRadius",
    "EstimatedBackground",
    "EstimatedDistribution",
    "EstimatedProcess",
    "EstimatorGains",
    "EstimatorRegulator",
    "EuclideanDistance",
    "EulerAngles",
    "EulerCharacteristic",
    "EulerE",
    "EulerGamma",
    "EulerianGraphQ",
    "EulerMatrix",
    "EulerPhi",
    "Evaluatable",
    "Evaluate",
    "Evaluated",
    "EvaluatePacket",
    "EvaluateScheduledTask",
    "EvaluationBox",
    "EvaluationCell",
    "EvaluationCompletionAction",
    "EvaluationData",
    "EvaluationElements",
    "EvaluationEnvironment",
    "EvaluationMode",
    "EvaluationMonitor",
    "EvaluationNotebook",
    "EvaluationObject",
    "EvaluationOrder",
    "Evaluator",
    "EvaluatorNames",
    "EvenQ",
    "EventData",
    "EventEvaluator",
    "EventHandler",
    "EventHandlerTag",
    "EventLabels",
    "EventSeries",
    "ExactBlackmanWindow",
    "ExactNumberQ",
    "ExactRootIsolation",
    "ExampleData",
    "Except",
    "ExcludedForms",
    "ExcludedLines",
    "ExcludedPhysicalQuantities",
    "ExcludePods",
    "Exclusions",
    "ExclusionsStyle",
    "Exists",
    "Exit",
    "ExitDialog",
    "ExoplanetData",
    "Exp",
    "Expand",
    "ExpandAll",
    "ExpandDenominator",
    "ExpandFileName",
    "ExpandNumerator",
    "Expectation",
    "ExpectationE",
    "ExpectedValue",
    "ExpGammaDistribution",
    "ExpIntegralE",
    "ExpIntegralEi",
    "ExpirationDate",
    "Exponent",
    "ExponentFunction",
    "ExponentialDistribution",
    "ExponentialFamily",
    "ExponentialGeneratingFunction",
    "ExponentialMovingAverage",
    "ExponentialPowerDistribution",
    "ExponentPosition",
    "ExponentStep",
    "Export",
    "ExportAutoReplacements",
    "ExportByteArray",
    "ExportForm",
    "ExportPacket",
    "ExportString",
    "Expression",
    "ExpressionCell",
    "ExpressionGraph",
    "ExpressionPacket",
    "ExpressionUUID",
    "ExpToTrig",
    "ExtendedEntityClass",
    "ExtendedGCD",
    "Extension",
    "ExtentElementFunction",
    "ExtentMarkers",
    "ExtentSize",
    "ExternalBundle",
    "ExternalCall",
    "ExternalDataCharacterEncoding",
    "ExternalEvaluate",
    "ExternalFunction",
    "ExternalFunctionName",
    "ExternalIdentifier",
    "ExternalObject",
    "ExternalOptions",
    "ExternalSessionObject",
    "ExternalSessions",
    "ExternalStorageBase",
    "ExternalStorageDownload",
    "ExternalStorageGet",
    "ExternalStorageObject",
    "ExternalStoragePut",
    "ExternalStorageUpload",
    "ExternalTypeSignature",
    "ExternalValue",
    "Extract",
    "ExtractArchive",
    "ExtractLayer",
    "ExtractPacletArchive",
    "ExtremeValueDistribution",
    "FaceAlign",
    "FaceForm",
    "FaceGrids",
    "FaceGridsStyle",
    "FacialFeatures",
    "Factor",
    "FactorComplete",
    "Factorial",
    "Factorial2",
    "FactorialMoment",
    "FactorialMomentGeneratingFunction",
    "FactorialPower",
    "FactorInteger",
    "FactorList",
    "FactorSquareFree",
    "FactorSquareFreeList",
    "FactorTerms",
    "FactorTermsList",
    "Fail",
    "Failure",
    "FailureAction",
    "FailureDistribution",
    "FailureQ",
    "False",
    "FareySequence",
    "FARIMAProcess",
    "FeatureDistance",
    "FeatureExtract",
    "FeatureExtraction",
    "FeatureExtractor",
    "FeatureExtractorFunction",
    "FeatureNames",
    "FeatureNearest",
    "FeatureSpacePlot",
    "FeatureSpacePlot3D",
    "FeatureTypes",
    "FEDisableConsolePrintPacket",
    "FeedbackLinearize",
    "FeedbackSector",
    "FeedbackSectorStyle",
    "FeedbackType",
    "FEEnableConsolePrintPacket",
    "FetalGrowthData",
    "Fibonacci",
    "Fibonorial",
    "FieldCompletionFunction",
    "FieldHint",
    "FieldHintStyle",
    "FieldMasked",
    "FieldSize",
    "File",
    "FileBaseName",
    "FileByteCount",
    "FileConvert",
    "FileDate",
    "FileExistsQ",
    "FileExtension",
    "FileFormat",
    "FileHandler",
    "FileHash",
    "FileInformation",
    "FileName",
    "FileNameDepth",
    "FileNameDialogSettings",
    "FileNameDrop",
    "FileNameForms",
    "FileNameJoin",
    "FileNames",
    "FileNameSetter",
    "FileNameSplit",
    "FileNameTake",
    "FilePrint",
    "FileSize",
    "FileSystemMap",
    "FileSystemScan",
    "FileTemplate",
    "FileTemplateApply",
    "FileType",
    "FilledCurve",
    "FilledCurveBox",
    "FilledCurveBoxOptions",
    "Filling",
    "FillingStyle",
    "FillingTransform",
    "FilteredEntityClass",
    "FilterRules",
    "FinancialBond",
    "FinancialData",
    "FinancialDerivative",
    "FinancialIndicator",
    "Find",
    "FindAnomalies",
    "FindArgMax",
    "FindArgMin",
    "FindChannels",
    "FindClique",
    "FindClusters",
    "FindCookies",
    "FindCurvePath",
    "FindCycle",
    "FindDevices",
    "FindDistribution",
    "FindDistributionParameters",
    "FindDivisions",
    "FindEdgeCover",
    "FindEdgeCut",
    "FindEdgeIndependentPaths",
    "FindEquationalProof",
    "FindEulerianCycle",
    "FindExternalEvaluators",
    "FindFaces",
    "FindFile",
    "FindFit",
    "FindFormula",
    "FindFundamentalCycles",
    "FindGeneratingFunction",
    "FindGeoLocation",
    "FindGeometricConjectures",
    "FindGeometricTransform",
    "FindGraphCommunities",
    "FindGraphIsomorphism",
    "FindGraphPartition",
    "FindHamiltonianCycle",
    "FindHamiltonianPath",
    "FindHiddenMarkovStates",
    "FindImageText",
    "FindIndependentEdgeSet",
    "FindIndependentVertexSet",
    "FindInstance",
    "FindIntegerNullVector",
    "FindKClan",
    "FindKClique",
    "FindKClub",
    "FindKPlex",
    "FindLibrary",
    "FindLinearRecurrence",
    "FindList",
    "FindMatchingColor",
    "FindMaximum",
    "FindMaximumCut",
    "FindMaximumFlow",
    "FindMaxValue",
    "FindMeshDefects",
    "FindMinimum",
    "FindMinimumCostFlow",
    "FindMinimumCut",
    "FindMinValue",
    "FindMoleculeSubstructure",
    "FindPath",
    "FindPeaks",
    "FindPermutation",
    "FindPostmanTour",
    "FindProcessParameters",
    "FindRepeat",
    "FindRoot",
    "FindSequenceFunction",
    "FindSettings",
    "FindShortestPath",
    "FindShortestTour",
    "FindSpanningTree",
    "FindSystemModelEquilibrium",
    "FindTextualAnswer",
    "FindThreshold",
    "FindTransientRepeat",
    "FindVertexCover",
    "FindVertexCut",
    "FindVertexIndependentPaths",
    "Fine",
    "FinishDynamic",
    "FiniteAbelianGroupCount",
    "FiniteGroupCount",
    "FiniteGroupData",
    "First",
    "FirstCase",
    "FirstPassageTimeDistribution",
    "FirstPosition",
    "FischerGroupFi22",
    "FischerGroupFi23",
    "FischerGroupFi24Prime",
    "FisherHypergeometricDistribution",
    "FisherRatioTest",
    "FisherZDistribution",
    "Fit",
    "FitAll",
    "FitRegularization",
    "FittedModel",
    "FixedOrder",
    "FixedPoint",
    "FixedPointList",
    "FlashSelection",
    "Flat",
    "Flatten",
    "FlattenAt",
    "FlattenLayer",
    "FlatTopWindow",
    "FlipView",
    "Floor",
    "FlowPolynomial",
    "FlushPrintOutputPacket",
    "Fold",
    "FoldList",
    "FoldPair",
    "FoldPairList",
    "FollowRedirects",
    "Font",
    "FontColor",
    "FontFamily",
    "FontForm",
    "FontName",
    "FontOpacity",
    "FontPostScriptName",
    "FontProperties",
    "FontReencoding",
    "FontSize",
    "FontSlant",
    "FontSubstitutions",
    "FontTracking",
    "FontVariations",
    "FontWeight",
    "For",
    "ForAll",
    "ForceVersionInstall",
    "Format",
    "FormatRules",
    "FormatType",
    "FormatTypeAutoConvert",
    "FormatValues",
    "FormBox",
    "FormBoxOptions",
    "FormControl",
    "FormFunction",
    "FormLayoutFunction",
    "FormObject",
    "FormPage",
    "FormTheme",
    "FormulaData",
    "FormulaLookup",
    "FortranForm",
    "Forward",
    "ForwardBackward",
    "Fourier",
    "FourierCoefficient",
    "FourierCosCoefficient",
    "FourierCosSeries",
    "FourierCosTransform",
    "FourierDCT",
    "FourierDCTFilter",
    "FourierDCTMatrix",
    "FourierDST",
    "FourierDSTMatrix",
    "FourierMatrix",
    "FourierParameters",
    "FourierSequenceTransform",
    "FourierSeries",
    "FourierSinCoefficient",
    "FourierSinSeries",
    "FourierSinTransform",
    "FourierTransform",
    "FourierTrigSeries",
    "FractionalBrownianMotionProcess",
    "FractionalGaussianNoiseProcess",
    "FractionalPart",
    "FractionBox",
    "FractionBoxOptions",
    "FractionLine",
    "Frame",
    "FrameBox",
    "FrameBoxOptions",
    "Framed",
    "FrameInset",
    "FrameLabel",
    "Frameless",
    "FrameMargins",
    "FrameRate",
    "FrameStyle",
    "FrameTicks",
    "FrameTicksStyle",
    "FRatioDistribution",
    "FrechetDistribution",
    "FreeQ",
    "FrenetSerretSystem",
    "FrequencySamplingFilterKernel",
    "FresnelC",
    "FresnelF",
    "FresnelG",
    "FresnelS",
    "Friday",
    "FrobeniusNumber",
    "FrobeniusSolve",
    "FromAbsoluteTime",
    "FromCharacterCode",
    "FromCoefficientRules",
    "FromContinuedFraction",
    "FromDate",
    "FromDigits",
    "FromDMS",
    "FromEntity",
    "FromJulianDate",
    "FromLetterNumber",
    "FromPolarCoordinates",
    "FromRomanNumeral",
    "FromSphericalCoordinates",
    "FromUnixTime",
    "Front",
    "FrontEndDynamicExpression",
    "FrontEndEventActions",
    "FrontEndExecute",
    "FrontEndObject",
    "FrontEndResource",
    "FrontEndResourceString",
    "FrontEndStackSize",
    "FrontEndToken",
    "FrontEndTokenExecute",
    "FrontEndValueCache",
    "FrontEndVersion",
    "FrontFaceColor",
    "FrontFaceOpacity",
    "Full",
    "FullAxes",
    "FullDefinition",
    "FullForm",
    "FullGraphics",
    "FullInformationOutputRegulator",
    "FullOptions",
    "FullRegion",
    "FullSimplify",
    "Function",
    "FunctionCompile",
    "FunctionCompileExport",
    "FunctionCompileExportByteArray",
    "FunctionCompileExportLibrary",
    "FunctionCompileExportString",
    "FunctionDomain",
    "FunctionExpand",
    "FunctionInterpolation",
    "FunctionPeriod",
    "FunctionRange",
    "FunctionSpace",
    "FussellVeselyImportance",
    "GaborFilter",
    "GaborMatrix",
    "GaborWavelet",
    "GainMargins",
    "GainPhaseMargins",
    "GalaxyData",
    "GalleryView",
    "Gamma",
    "GammaDistribution",
    "GammaRegularized",
    "GapPenalty",
    "GARCHProcess",
    "GatedRecurrentLayer",
    "Gather",
    "GatherBy",
    "GaugeFaceElementFunction",
    "GaugeFaceStyle",
    "GaugeFrameElementFunction",
    "GaugeFrameSize",
    "GaugeFrameStyle",
    "GaugeLabels",
    "GaugeMarkers",
    "GaugeStyle",
    "GaussianFilter",
    "GaussianIntegers",
    "GaussianMatrix",
    "GaussianOrthogonalMatrixDistribution",
    "GaussianSymplecticMatrixDistribution",
    "GaussianUnitaryMatrixDistribution",
    "GaussianWindow",
    "GCD",
    "GegenbauerC",
    "General",
    "GeneralizedLinearModelFit",
    "GenerateAsymmetricKeyPair",
    "GenerateConditions",
    "GeneratedCell",
    "GeneratedDocumentBinding",
    "GenerateDerivedKey",
    "GenerateDigitalSignature",
    "GenerateDocument",
    "GeneratedParameters",
    "GeneratedQuantityMagnitudes",
    "GenerateFileSignature",
    "GenerateHTTPResponse",
    "GenerateSecuredAuthenticationKey",
    "GenerateSymmetricKey",
    "GeneratingFunction",
    "GeneratorDescription",
    "GeneratorHistoryLength",
    "GeneratorOutputType",
    "Generic",
    "GenericCylindricalDecomposition",
    "GenomeData",
    "GenomeLookup",
    "GeoAntipode",
    "GeoArea",
    "GeoArraySize",
    "GeoBackground",
    "GeoBoundingBox",
    "GeoBounds",
    "GeoBoundsRegion",
    "GeoBubbleChart",
    "GeoCenter",
    "GeoCircle",
    "GeoContourPlot",
    "GeoDensityPlot",
    "GeodesicClosing",
    "GeodesicDilation",
    "GeodesicErosion",
    "GeodesicOpening",
    "GeoDestination",
    "GeodesyData",
    "GeoDirection",
    "GeoDisk",
    "GeoDisplacement",
    "GeoDistance",
    "GeoDistanceList",
    "GeoElevationData",
    "GeoEntities",
    "GeoGraphics",
    "GeogravityModelData",
    "GeoGridDirectionDifference",
    "GeoGridLines",
    "GeoGridLinesStyle",
    "GeoGridPosition",
    "GeoGridRange",
    "GeoGridRangePadding",
    "GeoGridUnitArea",
    "GeoGridUnitDistance",
    "GeoGridVector",
    "GeoGroup",
    "GeoHemisphere",
    "GeoHemisphereBoundary",
    "GeoHistogram",
    "GeoIdentify",
    "GeoImage",
    "GeoLabels",
    "GeoLength",
    "GeoListPlot",
    "GeoLocation",
    "GeologicalPeriodData",
    "GeomagneticModelData",
    "GeoMarker",
    "GeometricAssertion",
    "GeometricBrownianMotionProcess",
    "GeometricDistribution",
    "GeometricMean",
    "GeometricMeanFilter",
    "GeometricOptimization",
    "GeometricScene",
    "GeometricTransformation",
    "GeometricTransformation3DBox",
    "GeometricTransformation3DBoxOptions",
    "GeometricTransformationBox",
    "GeometricTransformationBoxOptions",
    "GeoModel",
    "GeoNearest",
    "GeoPath",
    "GeoPosition",
    "GeoPositionENU",
    "GeoPositionXYZ",
    "GeoProjection",
    "GeoProjectionData",
    "GeoRange",
    "GeoRangePadding",
    "GeoRegionValuePlot",
    "GeoResolution",
    "GeoScaleBar",
    "GeoServer",
    "GeoSmoothHistogram",
    "GeoStreamPlot",
    "GeoStyling",
    "GeoStylingImageFunction",
    "GeoVariant",
    "GeoVector",
    "GeoVectorENU",
    "GeoVectorPlot",
    "GeoVectorXYZ",
    "GeoVisibleRegion",
    "GeoVisibleRegionBoundary",
    "GeoWithinQ",
    "GeoZoomLevel",
    "GestureHandler",
    "GestureHandlerTag",
    "Get",
    "GetBoundingBoxSizePacket",
    "GetContext",
    "GetEnvironment",
    "GetFileName",
    "GetFrontEndOptionsDataPacket",
    "GetLinebreakInformationPacket",
    "GetMenusPacket",
    "GetPageBreakInformationPacket",
    "Glaisher",
    "GlobalClusteringCoefficient",
    "GlobalPreferences",
    "GlobalSession",
    "Glow",
    "GoldenAngle",
    "GoldenRatio",
    "GompertzMakehamDistribution",
    "GoochShading",
    "GoodmanKruskalGamma",
    "GoodmanKruskalGammaTest",
    "Goto",
    "Grad",
    "Gradient",
    "GradientFilter",
    "GradientOrientationFilter",
    "GrammarApply",
    "GrammarRules",
    "GrammarToken",
    "Graph",
    "Graph3D",
    "GraphAssortativity",
    "GraphAutomorphismGroup",
    "GraphCenter",
    "GraphComplement",
    "GraphData",
    "GraphDensity",
    "GraphDiameter",
    "GraphDifference",
    "GraphDisjointUnion",
    "GraphDistance",
    "GraphDistanceMatrix",
    "GraphElementData",
    "GraphEmbedding",
    "GraphHighlight",
    "GraphHighlightStyle",
    "GraphHub",
    "Graphics",
    "Graphics3D",
    "Graphics3DBox",
    "Graphics3DBoxOptions",
    "GraphicsArray",
    "GraphicsBaseline",
    "GraphicsBox",
    "GraphicsBoxOptions",
    "GraphicsColor",
    "GraphicsColumn",
    "GraphicsComplex",
    "GraphicsComplex3DBox",
    "GraphicsComplex3DBoxOptions",
    "GraphicsComplexBox",
    "GraphicsComplexBoxOptions",
    "GraphicsContents",
    "GraphicsData",
    "GraphicsGrid",
    "GraphicsGridBox",
    "GraphicsGroup",
    "GraphicsGroup3DBox",
    "GraphicsGroup3DBoxOptions",
    "GraphicsGroupBox",
    "GraphicsGroupBoxOptions",
    "GraphicsGrouping",
    "GraphicsHighlightColor",
    "GraphicsRow",
    "GraphicsSpacing",
    "GraphicsStyle",
    "GraphIntersection",
    "GraphLayout",
    "GraphLinkEfficiency",
    "GraphPeriphery",
    "GraphPlot",
    "GraphPlot3D",
    "GraphPower",
    "GraphPropertyDistribution",
    "GraphQ",
    "GraphRadius",
    "GraphReciprocity",
    "GraphRoot",
    "GraphStyle",
    "GraphUnion",
    "Gray",
    "GrayLevel",
    "Greater",
    "GreaterEqual",
    "GreaterEqualLess",
    "GreaterEqualThan",
    "GreaterFullEqual",
    "GreaterGreater",
    "GreaterLess",
    "GreaterSlantEqual",
    "GreaterThan",
    "GreaterTilde",
    "Green",
    "GreenFunction",
    "Grid",
    "GridBaseline",
    "GridBox",
    "GridBoxAlignment",
    "GridBoxBackground",
    "GridBoxDividers",
    "GridBoxFrame",
    "GridBoxItemSize",
    "GridBoxItemStyle",
    "GridBoxOptions",
    "GridBoxSpacings",
    "GridCreationSettings",
    "GridDefaultElement",
    "GridElementStyleOptions",
    "GridFrame",
    "GridFrameMargins",
    "GridGraph",
    "GridLines",
    "GridLinesStyle",
    "GroebnerBasis",
    "GroupActionBase",
    "GroupBy",
    "GroupCentralizer",
    "GroupElementFromWord",
    "GroupElementPosition",
    "GroupElementQ",
    "GroupElements",
    "GroupElementToWord",
    "GroupGenerators",
    "Groupings",
    "GroupMultiplicationTable",
    "GroupOrbits",
    "GroupOrder",
    "GroupPageBreakWithin",
    "GroupSetwiseStabilizer",
    "GroupStabilizer",
    "GroupStabilizerChain",
    "GroupTogetherGrouping",
    "GroupTogetherNestedGrouping",
    "GrowCutComponents",
    "Gudermannian",
    "GuidedFilter",
    "GumbelDistribution",
    "HaarWavelet",
    "HadamardMatrix",
    "HalfLine",
    "HalfNormalDistribution",
    "HalfPlane",
    "HalfSpace",
    "HalftoneShading",
    "HamiltonianGraphQ",
    "HammingDistance",
    "HammingWindow",
    "HandlerFunctions",
    "HandlerFunctionsKeys",
    "HankelH1",
    "HankelH2",
    "HankelMatrix",
    "HankelTransform",
    "HannPoissonWindow",
    "HannWindow",
    "HaradaNortonGroupHN",
    "HararyGraph",
    "HarmonicMean",
    "HarmonicMeanFilter",
    "HarmonicNumber",
    "Hash",
    "HatchFilling",
    "HatchShading",
    "Haversine",
    "HazardFunction",
    "Head",
    "HeadCompose",
    "HeaderAlignment",
    "HeaderBackground",
    "HeaderDisplayFunction",
    "HeaderLines",
    "HeaderSize",
    "HeaderStyle",
    "Heads",
    "HeavisideLambda",
    "HeavisidePi",
    "HeavisideTheta",
    "HeldGroupHe",
    "HeldPart",
    "HelpBrowserLookup",
    "HelpBrowserNotebook",
    "HelpBrowserSettings",
    "Here",
    "HermiteDecomposition",
    "HermiteH",
    "HermitianMatrixQ",
    "HessenbergDecomposition",
    "Hessian",
    "HeunB",
    "HeunBPrime",
    "HeunC",
    "HeunCPrime",
    "HeunD",
    "HeunDPrime",
    "HeunG",
    "HeunGPrime",
    "HeunT",
    "HeunTPrime",
    "HexadecimalCharacter",
    "Hexahedron",
    "HexahedronBox",
    "HexahedronBoxOptions",
    "HiddenItems",
    "HiddenMarkovProcess",
    "HiddenSurface",
    "Highlighted",
    "HighlightGraph",
    "HighlightImage",
    "HighlightMesh",
    "HighpassFilter",
    "HigmanSimsGroupHS",
    "HilbertCurve",
    "HilbertFilter",
    "HilbertMatrix",
    "Histogram",
    "Histogram3D",
    "HistogramDistribution",
    "HistogramList",
    "HistogramTransform",
    "HistogramTransformInterpolation",
    "HistoricalPeriodData",
    "HitMissTransform",
    "HITSCentrality",
    "HjorthDistribution",
    "HodgeDual",
    "HoeffdingD",
    "HoeffdingDTest",
    "Hold",
    "HoldAll",
    "HoldAllComplete",
    "HoldComplete",
    "HoldFirst",
    "HoldForm",
    "HoldPattern",
    "HoldRest",
    "HolidayCalendar",
    "HomeDirectory",
    "HomePage",
    "Horizontal",
    "HorizontalForm",
    "HorizontalGauge",
    "HorizontalScrollPosition",
    "HornerForm",
    "HostLookup",
    "HotellingTSquareDistribution",
    "HoytDistribution",
    "HTMLSave",
    "HTTPErrorResponse",
    "HTTPRedirect",
    "HTTPRequest",
    "HTTPRequestData",
    "HTTPResponse",
    "Hue",
    "HumanGrowthData",
    "HumpDownHump",
    "HumpEqual",
    "HurwitzLerchPhi",
    "HurwitzZeta",
    "HyperbolicDistribution",
    "HypercubeGraph",
    "HyperexponentialDistribution",
    "Hyperfactorial",
    "Hypergeometric0F1",
    "Hypergeometric0F1Regularized",
    "Hypergeometric1F1",
    "Hypergeometric1F1Regularized",
    "Hypergeometric2F1",
    "Hypergeometric2F1Regularized",
    "HypergeometricDistribution",
    "HypergeometricPFQ",
    "HypergeometricPFQRegularized",
    "HypergeometricU",
    "Hyperlink",
    "HyperlinkAction",
    "HyperlinkCreationSettings",
    "Hyperplane",
    "Hyphenation",
    "HyphenationOptions",
    "HypoexponentialDistribution",
    "HypothesisTestData",
    "I",
    "IconData",
    "Iconize",
    "IconizedObject",
    "IconRules",
    "Icosahedron",
    "Identity",
    "IdentityMatrix",
    "If",
    "IgnoreCase",
    "IgnoreDiacritics",
    "IgnorePunctuation",
    "IgnoreSpellCheck",
    "IgnoringInactive",
    "Im",
    "Image",
    "Image3D",
    "Image3DProjection",
    "Image3DSlices",
    "ImageAccumulate",
    "ImageAdd",
    "ImageAdjust",
    "ImageAlign",
    "ImageApply",
    "ImageApplyIndexed",
    "ImageAspectRatio",
    "ImageAssemble",
    "ImageAugmentationLayer",
    "ImageBoundingBoxes",
    "ImageCache",
    "ImageCacheValid",
    "ImageCapture",
    "ImageCaptureFunction",
    "ImageCases",
    "ImageChannels",
    "ImageClip",
    "ImageCollage",
    "ImageColorSpace",
    "ImageCompose",
    "ImageContainsQ",
    "ImageContents",
    "ImageConvolve",
    "ImageCooccurrence",
    "ImageCorners",
    "ImageCorrelate",
    "ImageCorrespondingPoints",
    "ImageCrop",
    "ImageData",
    "ImageDeconvolve",
    "ImageDemosaic",
    "ImageDifference",
    "ImageDimensions",
    "ImageDisplacements",
    "ImageDistance",
    "ImageEffect",
    "ImageExposureCombine",
    "ImageFeatureTrack",
    "ImageFileApply",
    "ImageFileFilter",
    "ImageFileScan",
    "ImageFilter",
    "ImageFocusCombine",
    "ImageForestingComponents",
    "ImageFormattingWidth",
    "ImageForwardTransformation",
    "ImageGraphics",
    "ImageHistogram",
    "ImageIdentify",
    "ImageInstanceQ",
    "ImageKeypoints",
    "ImageLabels",
    "ImageLegends",
    "ImageLevels",
    "ImageLines",
    "ImageMargins",
    "ImageMarker",
    "ImageMarkers",
    "ImageMeasurements",
    "ImageMesh",
    "ImageMultiply",
    "ImageOffset",
    "ImagePad",
    "ImagePadding",
    "ImagePartition",
    "ImagePeriodogram",
    "ImagePerspectiveTransformation",
    "ImagePosition",
    "ImagePreviewFunction",
    "ImagePyramid",
    "ImagePyramidApply",
    "ImageQ",
    "ImageRangeCache",
    "ImageRecolor",
    "ImageReflect",
    "ImageRegion",
    "ImageResize",
    "ImageResolution",
    "ImageRestyle",
    "ImageRotate",
    "ImageRotated",
    "ImageSaliencyFilter",
    "ImageScaled",
    "ImageScan",
    "ImageSize",
    "ImageSizeAction",
    "ImageSizeCache",
    "ImageSizeMultipliers",
    "ImageSizeRaw",
    "ImageSubtract",
    "ImageTake",
    "ImageTransformation",
    "ImageTrim",
    "ImageType",
    "ImageValue",
    "ImageValuePositions",
    "ImagingDevice",
    "ImplicitRegion",
    "Implies",
    "Import",
    "ImportAutoReplacements",
    "ImportByteArray",
    "ImportOptions",
    "ImportString",
    "ImprovementImportance",
    "In",
    "Inactivate",
    "Inactive",
    "IncidenceGraph",
    "IncidenceList",
    "IncidenceMatrix",
    "IncludeAromaticBonds",
    "IncludeConstantBasis",
    "IncludeDefinitions",
    "IncludeDirectories",
    "IncludeFileExtension",
    "IncludeGeneratorTasks",
    "IncludeHydrogens",
    "IncludeInflections",
    "IncludeMetaInformation",
    "IncludePods",
    "IncludeQuantities",
    "IncludeRelatedTables",
    "IncludeSingularTerm",
    "IncludeWindowTimes",
    "Increment",
    "IndefiniteMatrixQ",
    "Indent",
    "IndentingNewlineSpacings",
    "IndentMaxFraction",
    "IndependenceTest",
    "IndependentEdgeSetQ",
    "IndependentPhysicalQuantity",
    "IndependentUnit",
    "IndependentUnitDimension",
    "IndependentVertexSetQ",
    "Indeterminate",
    "IndeterminateThreshold",
    "IndexCreationOptions",
    "Indexed",
    "IndexEdgeTaggedGraph",
    "IndexGraph",
    "IndexTag",
    "Inequality",
    "InexactNumberQ",
    "InexactNumbers",
    "InfiniteFuture",
    "InfiniteLine",
    "InfinitePast",
    "InfinitePlane",
    "Infinity",
    "Infix",
    "InflationAdjust",
    "InflationMethod",
    "Information",
    "InformationData",
    "InformationDataGrid",
    "Inherited",
    "InheritScope",
    "InhomogeneousPoissonProcess",
    "InitialEvaluationHistory",
    "Initialization",
    "InitializationCell",
    "InitializationCellEvaluation",
    "InitializationCellWarning",
    "InitializationObjects",
    "InitializationValue",
    "Initialize",
    "InitialSeeding",
    "InlineCounterAssignments",
    "InlineCounterIncrements",
    "InlineRules",
    "Inner",
    "InnerPolygon",
    "InnerPolyhedron",
    "Inpaint",
    "Input",
    "InputAliases",
    "InputAssumptions",
    "InputAutoReplacements",
    "InputField",
    "InputFieldBox",
    "InputFieldBoxOptions",
    "InputForm",
    "InputGrouping",
    "InputNamePacket",
    "InputNotebook",
    "InputPacket",
    "InputSettings",
    "InputStream",
    "InputString",
    "InputStringPacket",
    "InputToBoxFormPacket",
    "Insert",
    "InsertionFunction",
    "InsertionPointObject",
    "InsertLinebreaks",
    "InsertResults",
    "Inset",
    "Inset3DBox",
    "Inset3DBoxOptions",
    "InsetBox",
    "InsetBoxOptions",
    "Insphere",
    "Install",
    "InstallService",
    "InstanceNormalizationLayer",
    "InString",
    "Integer",
    "IntegerDigits",
    "IntegerExponent",
    "IntegerLength",
    "IntegerName",
    "IntegerPart",
    "IntegerPartitions",
    "IntegerQ",
    "IntegerReverse",
    "Integers",
    "IntegerString",
    "Integral",
    "Integrate",
    "Interactive",
    "InteractiveTradingChart",
    "Interlaced",
    "Interleaving",
    "InternallyBalancedDecomposition",
    "InterpolatingFunction",
    "InterpolatingPolynomial",
    "Interpolation",
    "InterpolationOrder",
    "InterpolationPoints",
    "InterpolationPrecision",
    "Interpretation",
    "InterpretationBox",
    "InterpretationBoxOptions",
    "InterpretationFunction",
    "Interpreter",
    "InterpretTemplate",
    "InterquartileRange",
    "Interrupt",
    "InterruptSettings",
    "IntersectedEntityClass",
    "IntersectingQ",
    "Intersection",
    "Interval",
    "IntervalIntersection",
    "IntervalMarkers",
    "IntervalMarkersStyle",
    "IntervalMemberQ",
    "IntervalSlider",
    "IntervalUnion",
    "Into",
    "Inverse",
    "InverseBetaRegularized",
    "InverseCDF",
    "InverseChiSquareDistribution",
    "InverseContinuousWaveletTransform",
    "InverseDistanceTransform",
    "InverseEllipticNomeQ",
    "InverseErf",
    "InverseErfc",
    "InverseFourier",
    "InverseFourierCosTransform",
    "InverseFourierSequenceTransform",
    "InverseFourierSinTransform",
    "InverseFourierTransform",
    "InverseFunction",
    "InverseFunctions",
    "InverseGammaDistribution",
    "InverseGammaRegularized",
    "InverseGaussianDistribution",
    "InverseGudermannian",
    "InverseHankelTransform",
    "InverseHaversine",
    "InverseImagePyramid",
    "InverseJacobiCD",
    "InverseJacobiCN",
    "InverseJacobiCS",
    "InverseJacobiDC",
    "InverseJacobiDN",
    "InverseJacobiDS",
    "InverseJacobiNC",
    "InverseJacobiND",
    "InverseJacobiNS",
    "InverseJacobiSC",
    "InverseJacobiSD",
    "InverseJacobiSN",
    "InverseLaplaceTransform",
    "InverseMellinTransform",
    "InversePermutation",
    "InverseRadon",
    "InverseRadonTransform",
    "InverseSeries",
    "InverseShortTimeFourier",
    "InverseSpectrogram",
    "InverseSurvivalFunction",
    "InverseTransformedRegion",
    "InverseWaveletTransform",
    "InverseWeierstrassP",
    "InverseWishartMatrixDistribution",
    "InverseZTransform",
    "Invisible",
    "InvisibleApplication",
    "InvisibleTimes",
    "IPAddress",
    "IrreduciblePolynomialQ",
    "IslandData",
    "IsolatingInterval",
    "IsomorphicGraphQ",
    "IsotopeData",
    "Italic",
    "Item",
    "ItemAspectRatio",
    "ItemBox",
    "ItemBoxOptions",
    "ItemDisplayFunction",
    "ItemSize",
    "ItemStyle",
    "ItoProcess",
    "JaccardDissimilarity",
    "JacobiAmplitude",
    "Jacobian",
    "JacobiCD",
    "JacobiCN",
    "JacobiCS",
    "JacobiDC",
    "JacobiDN",
    "JacobiDS",
    "JacobiNC",
    "JacobiND",
    "JacobiNS",
    "JacobiP",
    "JacobiSC",
    "JacobiSD",
    "JacobiSN",
    "JacobiSymbol",
    "JacobiZeta",
    "JankoGroupJ1",
    "JankoGroupJ2",
    "JankoGroupJ3",
    "JankoGroupJ4",
    "JarqueBeraALMTest",
    "JohnsonDistribution",
    "Join",
    "JoinAcross",
    "Joined",
    "JoinedCurve",
    "JoinedCurveBox",
    "JoinedCurveBoxOptions",
    "JoinForm",
    "JordanDecomposition",
    "JordanModelDecomposition",
    "JulianDate",
    "JuliaSetBoettcher",
    "JuliaSetIterationCount",
    "JuliaSetPlot",
    "JuliaSetPoints",
    "K",
    "KagiChart",
    "KaiserBesselWindow",
    "KaiserWindow",
    "KalmanEstimator",
    "KalmanFilter",
    "KarhunenLoeveDecomposition",
    "KaryTree",
    "KatzCentrality",
    "KCoreComponents",
    "KDistribution",
    "KEdgeConnectedComponents",
    "KEdgeConnectedGraphQ",
    "KeepExistingVersion",
    "KelvinBei",
    "KelvinBer",
    "KelvinKei",
    "KelvinKer",
    "KendallTau",
    "KendallTauTest",
    "KernelExecute",
    "KernelFunction",
    "KernelMixtureDistribution",
    "KernelObject",
    "Kernels",
    "Ket",
    "Key",
    "KeyCollisionFunction",
    "KeyComplement",
    "KeyDrop",
    "KeyDropFrom",
    "KeyExistsQ",
    "KeyFreeQ",
    "KeyIntersection",
    "KeyMap",
    "KeyMemberQ",
    "KeypointStrength",
    "Keys",
    "KeySelect",
    "KeySort",
    "KeySortBy",
    "KeyTake",
    "KeyUnion",
    "KeyValueMap",
    "KeyValuePattern",
    "Khinchin",
    "KillProcess",
    "KirchhoffGraph",
    "KirchhoffMatrix",
    "KleinInvariantJ",
    "KnapsackSolve",
    "KnightTourGraph",
    "KnotData",
    "KnownUnitQ",
    "KochCurve",
    "KolmogorovSmirnovTest",
    "KroneckerDelta",
    "KroneckerModelDecomposition",
    "KroneckerProduct",
    "KroneckerSymbol",
    "KuiperTest",
    "KumaraswamyDistribution",
    "Kurtosis",
    "KuwaharaFilter",
    "KVertexConnectedComponents",
    "KVertexConnectedGraphQ",
    "LABColor",
    "Label",
    "Labeled",
    "LabeledSlider",
    "LabelingFunction",
    "LabelingSize",
    "LabelStyle",
    "LabelVisibility",
    "LaguerreL",
    "LakeData",
    "LambdaComponents",
    "LambertW",
    "LaminaData",
    "LanczosWindow",
    "LandauDistribution",
    "Language",
    "LanguageCategory",
    "LanguageData",
    "LanguageIdentify",
    "LanguageOptions",
    "LaplaceDistribution",
    "LaplaceTransform",
    "Laplacian",
    "LaplacianFilter",
    "LaplacianGaussianFilter",
    "Large",
    "Larger",
    "Last",
    "Latitude",
    "LatitudeLongitude",
    "LatticeData",
    "LatticeReduce",
    "Launch",
    "LaunchKernels",
    "LayeredGraphPlot",
    "LayerSizeFunction",
    "LayoutInformation",
    "LCHColor",
    "LCM",
    "LeaderSize",
    "LeafCount",
    "LeapYearQ",
    "LearnDistribution",
    "LearnedDistribution",
    "LearningRate",
    "LearningRateMultipliers",
    "LeastSquares",
    "LeastSquaresFilterKernel",
    "Left",
    "LeftArrow",
    "LeftArrowBar",
    "LeftArrowRightArrow",
    "LeftDownTeeVector",
    "LeftDownVector",
    "LeftDownVectorBar",
    "LeftRightArrow",
    "LeftRightVector",
    "LeftTee",
    "LeftTeeArrow",
    "LeftTeeVector",
    "LeftTriangle",
    "LeftTriangleBar",
    "LeftTriangleEqual",
    "LeftUpDownVector",
    "LeftUpTeeVector",
    "LeftUpVector",
    "LeftUpVectorBar",
    "LeftVector",
    "LeftVectorBar",
    "LegendAppearance",
    "Legended",
    "LegendFunction",
    "LegendLabel",
    "LegendLayout",
    "LegendMargins",
    "LegendMarkers",
    "LegendMarkerSize",
    "LegendreP",
    "LegendreQ",
    "LegendreType",
    "Length",
    "LengthWhile",
    "LerchPhi",
    "Less",
    "LessEqual",
    "LessEqualGreater",
    "LessEqualThan",
    "LessFullEqual",
    "LessGreater",
    "LessLess",
    "LessSlantEqual",
    "LessThan",
    "LessTilde",
    "LetterCharacter",
    "LetterCounts",
    "LetterNumber",
    "LetterQ",
    "Level",
    "LeveneTest",
    "LeviCivitaTensor",
    "LevyDistribution",
    "Lexicographic",
    "LibraryDataType",
    "LibraryFunction",
    "LibraryFunctionError",
    "LibraryFunctionInformation",
    "LibraryFunctionLoad",
    "LibraryFunctionUnload",
    "LibraryLoad",
    "LibraryUnload",
    "LicenseID",
    "LiftingFilterData",
    "LiftingWaveletTransform",
    "LightBlue",
    "LightBrown",
    "LightCyan",
    "Lighter",
    "LightGray",
    "LightGreen",
    "Lighting",
    "LightingAngle",
    "LightMagenta",
    "LightOrange",
    "LightPink",
    "LightPurple",
    "LightRed",
    "LightSources",
    "LightYellow",
    "Likelihood",
    "Limit",
    "LimitsPositioning",
    "LimitsPositioningTokens",
    "LindleyDistribution",
    "Line",
    "Line3DBox",
    "Line3DBoxOptions",
    "LinearFilter",
    "LinearFractionalOptimization",
    "LinearFractionalTransform",
    "LinearGradientImage",
    "LinearizingTransformationData",
    "LinearLayer",
    "LinearModelFit",
    "LinearOffsetFunction",
    "LinearOptimization",
    "LinearProgramming",
    "LinearRecurrence",
    "LinearSolve",
    "LinearSolveFunction",
    "LineBox",
    "LineBoxOptions",
    "LineBreak",
    "LinebreakAdjustments",
    "LineBreakChart",
    "LinebreakSemicolonWeighting",
    "LineBreakWithin",
    "LineColor",
    "LineGraph",
    "LineIndent",
    "LineIndentMaxFraction",
    "LineIntegralConvolutionPlot",
    "LineIntegralConvolutionScale",
    "LineLegend",
    "LineOpacity",
    "LineSpacing",
    "LineWrapParts",
    "LinkActivate",
    "LinkClose",
    "LinkConnect",
    "LinkConnectedQ",
    "LinkCreate",
    "LinkError",
    "LinkFlush",
    "LinkFunction",
    "LinkHost",
    "LinkInterrupt",
    "LinkLaunch",
    "LinkMode",
    "LinkObject",
    "LinkOpen",
    "LinkOptions",
    "LinkPatterns",
    "LinkProtocol",
    "LinkRankCentrality",
    "LinkRead",
    "LinkReadHeld",
    "LinkReadyQ",
    "Links",
    "LinkService",
    "LinkWrite",
    "LinkWriteHeld",
    "LiouvilleLambda",
    "List",
    "Listable",
    "ListAnimate",
    "ListContourPlot",
    "ListContourPlot3D",
    "ListConvolve",
    "ListCorrelate",
    "ListCurvePathPlot",
    "ListDeconvolve",
    "ListDensityPlot",
    "ListDensityPlot3D",
    "Listen",
    "ListFormat",
    "ListFourierSequenceTransform",
    "ListInterpolation",
    "ListLineIntegralConvolutionPlot",
    "ListLinePlot",
    "ListLogLinearPlot",
    "ListLogLogPlot",
    "ListLogPlot",
    "ListPicker",
    "ListPickerBox",
    "ListPickerBoxBackground",
    "ListPickerBoxOptions",
    "ListPlay",
    "ListPlot",
    "ListPlot3D",
    "ListPointPlot3D",
    "ListPolarPlot",
    "ListQ",
    "ListSliceContourPlot3D",
    "ListSliceDensityPlot3D",
    "ListSliceVectorPlot3D",
    "ListStepPlot",
    "ListStreamDensityPlot",
    "ListStreamPlot",
    "ListSurfacePlot3D",
    "ListVectorDensityPlot",
    "ListVectorPlot",
    "ListVectorPlot3D",
    "ListZTransform",
    "Literal",
    "LiteralSearch",
    "LocalAdaptiveBinarize",
    "LocalCache",
    "LocalClusteringCoefficient",
    "LocalizeDefinitions",
    "LocalizeVariables",
    "LocalObject",
    "LocalObjects",
    "LocalResponseNormalizationLayer",
    "LocalSubmit",
    "LocalSymbol",
    "LocalTime",
    "LocalTimeZone",
    "LocationEquivalenceTest",
    "LocationTest",
    "Locator",
    "LocatorAutoCreate",
    "LocatorBox",
    "LocatorBoxOptions",
    "LocatorCentering",
    "LocatorPane",
    "LocatorPaneBox",
    "LocatorPaneBoxOptions",
    "LocatorRegion",
    "Locked",
    "Log",
    "Log10",
    "Log2",
    "LogBarnesG",
    "LogGamma",
    "LogGammaDistribution",
    "LogicalExpand",
    "LogIntegral",
    "LogisticDistribution",
    "LogisticSigmoid",
    "LogitModelFit",
    "LogLikelihood",
    "LogLinearPlot",
    "LogLogisticDistribution",
    "LogLogPlot",
    "LogMultinormalDistribution",
    "LogNormalDistribution",
    "LogPlot",
    "LogRankTest",
    "LogSeriesDistribution",
    "LongEqual",
    "Longest",
    "LongestCommonSequence",
    "LongestCommonSequencePositions",
    "LongestCommonSubsequence",
    "LongestCommonSubsequencePositions",
    "LongestMatch",
    "LongestOrderedSequence",
    "LongForm",
    "Longitude",
    "LongLeftArrow",
    "LongLeftRightArrow",
    "LongRightArrow",
    "LongShortTermMemoryLayer",
    "Lookup",
    "Loopback",
    "LoopFreeGraphQ",
    "Looping",
    "LossFunction",
    "LowerCaseQ",
    "LowerLeftArrow",
    "LowerRightArrow",
    "LowerTriangularize",
    "LowerTriangularMatrixQ",
    "LowpassFilter",
    "LQEstimatorGains",
    "LQGRegulator",
    "LQOutputRegulatorGains",
    "LQRegulatorGains",
    "LUBackSubstitution",
    "LucasL",
    "LuccioSamiComponents",
    "LUDecomposition",
    "LunarEclipse",
    "LUVColor",
    "LyapunovSolve",
    "LyonsGroupLy",
    "MachineID",
    "MachineName",
    "MachineNumberQ",
    "MachinePrecision",
    "MacintoshSystemPageSetup",
    "Magenta",
    "Magnification",
    "Magnify",
    "MailAddressValidation",
    "MailExecute",
    "MailFolder",
    "MailItem",
    "MailReceiverFunction",
    "MailResponseFunction",
    "MailSearch",
    "MailServerConnect",
    "MailServerConnection",
    "MailSettings",
    "MainSolve",
    "MaintainDynamicCaches",
    "Majority",
    "MakeBoxes",
    "MakeExpression",
    "MakeRules",
    "ManagedLibraryExpressionID",
    "ManagedLibraryExpressionQ",
    "MandelbrotSetBoettcher",
    "MandelbrotSetDistance",
    "MandelbrotSetIterationCount",
    "MandelbrotSetMemberQ",
    "MandelbrotSetPlot",
    "MangoldtLambda",
    "ManhattanDistance",
    "Manipulate",
    "Manipulator",
    "MannedSpaceMissionData",
    "MannWhitneyTest",
    "MantissaExponent",
    "Manual",
    "Map",
    "MapAll",
    "MapAt",
    "MapIndexed",
    "MAProcess",
    "MapThread",
    "MarchenkoPasturDistribution",
    "MarcumQ",
    "MardiaCombinedTest",
    "MardiaKurtosisTest",
    "MardiaSkewnessTest",
    "MarginalDistribution",
    "MarkovProcessProperties",
    "Masking",
    "MatchingDissimilarity",
    "MatchLocalNameQ",
    "MatchLocalNames",
    "MatchQ",
    "Material",
    "MathematicalFunctionData",
    "MathematicaNotation",
    "MathieuC",
    "MathieuCharacteristicA",
    "MathieuCharacteristicB",
    "MathieuCharacteristicExponent",
    "MathieuCPrime",
    "MathieuGroupM11",
    "MathieuGroupM12",
    "MathieuGroupM22",
    "MathieuGroupM23",
    "MathieuGroupM24",
    "MathieuS",
    "MathieuSPrime",
    "MathMLForm",
    "MathMLText",
    "Matrices",
    "MatrixExp",
    "MatrixForm",
    "MatrixFunction",
    "MatrixLog",
    "MatrixNormalDistribution",
    "MatrixPlot",
    "MatrixPower",
    "MatrixPropertyDistribution",
    "MatrixQ",
    "MatrixRank",
    "MatrixTDistribution",
    "Max",
    "MaxBend",
    "MaxCellMeasure",
    "MaxColorDistance",
    "MaxDate",
    "MaxDetect",
    "MaxDuration",
    "MaxExtraBandwidths",
    "MaxExtraConditions",
    "MaxFeatureDisplacement",
    "MaxFeatures",
    "MaxFilter",
    "MaximalBy",
    "Maximize",
    "MaxItems",
    "MaxIterations",
    "MaxLimit",
    "MaxMemoryUsed",
    "MaxMixtureKernels",
    "MaxOverlapFraction",
    "MaxPlotPoints",
    "MaxPoints",
    "MaxRecursion",
    "MaxStableDistribution",
    "MaxStepFraction",
    "MaxSteps",
    "MaxStepSize",
    "MaxTrainingRounds",
    "MaxValue",
    "MaxwellDistribution",
    "MaxWordGap",
    "McLaughlinGroupMcL",
    "Mean",
    "MeanAbsoluteLossLayer",
    "MeanAround",
    "MeanClusteringCoefficient",
    "MeanDegreeConnectivity",
    "MeanDeviation",
    "MeanFilter",
    "MeanGraphDistance",
    "MeanNeighborDegree",
    "MeanShift",
    "MeanShiftFilter",
    "MeanSquaredLossLayer",
    "Median",
    "MedianDeviation",
    "MedianFilter",
    "MedicalTestData",
    "Medium",
    "MeijerG",
    "MeijerGReduce",
    "MeixnerDistribution",
    "MellinConvolve",
    "MellinTransform",
    "MemberQ",
    "MemoryAvailable",
    "MemoryConstrained",
    "MemoryConstraint",
    "MemoryInUse",
    "MengerMesh",
    "Menu",
    "MenuAppearance",
    "MenuCommandKey",
    "MenuEvaluator",
    "MenuItem",
    "MenuList",
    "MenuPacket",
    "MenuSortingValue",
    "MenuStyle",
    "MenuView",
    "Merge",
    "MergeDifferences",
    "MergingFunction",
    "MersennePrimeExponent",
    "MersennePrimeExponentQ",
    "Mesh",
    "MeshCellCentroid",
    "MeshCellCount",
    "MeshCellHighlight",
    "MeshCellIndex",
    "MeshCellLabel",
    "MeshCellMarker",
    "MeshCellMeasure",
    "MeshCellQuality",
    "MeshCells",
    "MeshCellShapeFunction",
    "MeshCellStyle",
    "MeshConnectivityGraph",
    "MeshCoordinates",
    "MeshFunctions",
    "MeshPrimitives",
    "MeshQualityGoal",
    "MeshRange",
    "MeshRefinementFunction",
    "MeshRegion",
    "MeshRegionQ",
    "MeshShading",
    "MeshStyle",
    "Message",
    "MessageDialog",
    "MessageList",
    "MessageName",
    "MessageObject",
    "MessageOptions",
    "MessagePacket",
    "Messages",
    "MessagesNotebook",
    "MetaCharacters",
    "MetaInformation",
    "MeteorShowerData",
    "Method",
    "MethodOptions",
    "MexicanHatWavelet",
    "MeyerWavelet",
    "Midpoint",
    "Min",
    "MinColorDistance",
    "MinDate",
    "MinDetect",
    "MineralData",
    "MinFilter",
    "MinimalBy",
    "MinimalPolynomial",
    "MinimalStateSpaceModel",
    "Minimize",
    "MinimumTimeIncrement",
    "MinIntervalSize",
    "MinkowskiQuestionMark",
    "MinLimit",
    "MinMax",
    "MinorPlanetData",
    "Minors",
    "MinRecursion",
    "MinSize",
    "MinStableDistribution",
    "Minus",
    "MinusPlus",
    "MinValue",
    "Missing",
    "MissingBehavior",
    "MissingDataMethod",
    "MissingDataRules",
    "MissingQ",
    "MissingString",
    "MissingStyle",
    "MissingValuePattern",
    "MittagLefflerE",
    "MixedFractionParts",
    "MixedGraphQ",
    "MixedMagnitude",
    "MixedRadix",
    "MixedRadixQuantity",
    "MixedUnit",
    "MixtureDistribution",
    "Mod",
    "Modal",
    "Mode",
    "Modular",
    "ModularInverse",
    "ModularLambda",
    "Module",
    "Modulus",
    "MoebiusMu",
    "Molecule",
    "MoleculeContainsQ",
    "MoleculeEquivalentQ",
    "MoleculeGraph",
    "MoleculeModify",
    "MoleculePattern",
    "MoleculePlot",
    "MoleculePlot3D",
    "MoleculeProperty",
    "MoleculeQ",
    "MoleculeRecognize",
    "MoleculeValue",
    "Moment",
    "Momentary",
    "MomentConvert",
    "MomentEvaluate",
    "MomentGeneratingFunction",
    "MomentOfInertia",
    "Monday",
    "Monitor",
    "MonomialList",
    "MonomialOrder",
    "MonsterGroupM",
    "MoonPhase",
    "MoonPosition",
    "MorletWavelet",
    "MorphologicalBinarize",
    "MorphologicalBranchPoints",
    "MorphologicalComponents",
    "MorphologicalEulerNumber",
    "MorphologicalGraph",
    "MorphologicalPerimeter",
    "MorphologicalTransform",
    "MortalityData",
    "Most",
    "MountainData",
    "MouseAnnotation",
    "MouseAppearance",
    "MouseAppearanceTag",
    "MouseButtons",
    "Mouseover",
    "MousePointerNote",
    "MousePosition",
    "MovieData",
    "MovingAverage",
    "MovingMap",
    "MovingMedian",
    "MoyalDistribution",
    "Multicolumn",
    "MultiedgeStyle",
    "MultigraphQ",
    "MultilaunchWarning",
    "MultiLetterItalics",
    "MultiLetterStyle",
    "MultilineFunction",
    "Multinomial",
    "MultinomialDistribution",
    "MultinormalDistribution",
    "MultiplicativeOrder",
    "Multiplicity",
    "MultiplySides",
    "Multiselection",
    "MultivariateHypergeometricDistribution",
    "MultivariatePoissonDistribution",
    "MultivariateTDistribution",
    "N",
    "NakagamiDistribution",
    "NameQ",
    "Names",
    "NamespaceBox",
    "NamespaceBoxOptions",
    "Nand",
    "NArgMax",
    "NArgMin",
    "NBernoulliB",
    "NBodySimulation",
    "NBodySimulationData",
    "NCache",
    "NDEigensystem",
    "NDEigenvalues",
    "NDSolve",
    "NDSolveValue",
    "Nearest",
    "NearestFunction",
    "NearestMeshCells",
    "NearestNeighborGraph",
    "NearestTo",
    "NebulaData",
    "NeedCurrentFrontEndPackagePacket",
    "NeedCurrentFrontEndSymbolsPacket",
    "NeedlemanWunschSimilarity",
    "Needs",
    "Negative",
    "NegativeBinomialDistribution",
    "NegativeDefiniteMatrixQ",
    "NegativeIntegers",
    "NegativeMultinomialDistribution",
    "NegativeRationals",
    "NegativeReals",
    "NegativeSemidefiniteMatrixQ",
    "NeighborhoodData",
    "NeighborhoodGraph",
    "Nest",
    "NestedGreaterGreater",
    "NestedLessLess",
    "NestedScriptRules",
    "NestGraph",
    "NestList",
    "NestWhile",
    "NestWhileList",
    "NetAppend",
    "NetBidirectionalOperator",
    "NetChain",
    "NetDecoder",
    "NetDelete",
    "NetDrop",
    "NetEncoder",
    "NetEvaluationMode",
    "NetExtract",
    "NetFlatten",
    "NetFoldOperator",
    "NetGANOperator",
    "NetGraph",
    "NetInformation",
    "NetInitialize",
    "NetInsert",
    "NetInsertSharedArrays",
    "NetJoin",
    "NetMapOperator",
    "NetMapThreadOperator",
    "NetMeasurements",
    "NetModel",
    "NetNestOperator",
    "NetPairEmbeddingOperator",
    "NetPort",
    "NetPortGradient",
    "NetPrepend",
    "NetRename",
    "NetReplace",
    "NetReplacePart",
    "NetSharedArray",
    "NetStateObject",
    "NetTake",
    "NetTrain",
    "NetTrainResultsObject",
    "NetworkPacketCapture",
    "NetworkPacketRecording",
    "NetworkPacketRecordingDuring",
    "NetworkPacketTrace",
    "NeumannValue",
    "NevilleThetaC",
    "NevilleThetaD",
    "NevilleThetaN",
    "NevilleThetaS",
    "NewPrimitiveStyle",
    "NExpectation",
    "Next",
    "NextCell",
    "NextDate",
    "NextPrime",
    "NextScheduledTaskTime",
    "NHoldAll",
    "NHoldFirst",
    "NHoldRest",
    "NicholsGridLines",
    "NicholsPlot",
    "NightHemisphere",
    "NIntegrate",
    "NMaximize",
    "NMaxValue",
    "NMinimize",
    "NMinValue",
    "NominalVariables",
    "NonAssociative",
    "NoncentralBetaDistribution",
    "NoncentralChiSquareDistribution",
    "NoncentralFRatioDistribution",
    "NoncentralStudentTDistribution",
    "NonCommutativeMultiply",
    "NonConstants",
    "NondimensionalizationTransform",
    "None",
    "NoneTrue",
    "NonlinearModelFit",
    "NonlinearStateSpaceModel",
    "NonlocalMeansFilter",
    "NonNegative",
    "NonNegativeIntegers",
    "NonNegativeRationals",
    "NonNegativeReals",
    "NonPositive",
    "NonPositiveIntegers",
    "NonPositiveRationals",
    "NonPositiveReals",
    "Nor",
    "NorlundB",
    "Norm",
    "Normal",
    "NormalDistribution",
    "NormalGrouping",
    "NormalizationLayer",
    "Normalize",
    "Normalized",
    "NormalizedSquaredEuclideanDistance",
    "NormalMatrixQ",
    "NormalsFunction",
    "NormFunction",
    "Not",
    "NotCongruent",
    "NotCupCap",
    "NotDoubleVerticalBar",
    "Notebook",
    "NotebookApply",
    "NotebookAutoSave",
    "NotebookClose",
    "NotebookConvertSettings",
    "NotebookCreate",
    "NotebookCreateReturnObject",
    "NotebookDefault",
    "NotebookDelete",
    "NotebookDirectory",
    "NotebookDynamicExpression",
    "NotebookEvaluate",
    "NotebookEventActions",
    "NotebookFileName",
    "NotebookFind",
    "NotebookFindReturnObject",
    "NotebookGet",
    "NotebookGetLayoutInformationPacket",
    "NotebookGetMisspellingsPacket",
    "NotebookImport",
    "NotebookInformation",
    "NotebookInterfaceObject",
    "NotebookLocate",
    "NotebookObject",
    "NotebookOpen",
    "NotebookOpenReturnObject",
    "NotebookPath",
    "NotebookPrint",
    "NotebookPut",
    "NotebookPutReturnObject",
    "NotebookRead",
    "NotebookResetGeneratedCells",
    "Notebooks",
    "NotebookSave",
    "NotebookSaveAs",
    "NotebookSelection",
    "NotebookSetupLayoutInformationPacket",
    "NotebooksMenu",
    "NotebookTemplate",
    "NotebookWrite",
    "NotElement",
    "NotEqualTilde",
    "NotExists",
    "NotGreater",
    "NotGreaterEqual",
    "NotGreaterFullEqual",
    "NotGreaterGreater",
    "NotGreaterLess",
    "NotGreaterSlantEqual",
    "NotGreaterTilde",
    "Nothing",
    "NotHumpDownHump",
    "NotHumpEqual",
    "NotificationFunction",
    "NotLeftTriangle",
    "NotLeftTriangleBar",
    "NotLeftTriangleEqual",
    "NotLess",
    "NotLessEqual",
    "NotLessFullEqual",
    "NotLessGreater",
    "NotLessLess",
    "NotLessSlantEqual",
    "NotLessTilde",
    "NotNestedGreaterGreater",
    "NotNestedLessLess",
    "NotPrecedes",
    "NotPrecedesEqual",
    "NotPrecedesSlantEqual",
    "NotPrecedesTilde",
    "NotReverseElement",
    "NotRightTriangle",
    "NotRightTriangleBar",
    "NotRightTriangleEqual",
    "NotSquareSubset",
    "NotSquareSubsetEqual",
    "NotSquareSuperset",
    "NotSquareSupersetEqual",
    "NotSubset",
    "NotSubsetEqual",
    "NotSucceeds",
    "NotSucceedsEqual",
    "NotSucceedsSlantEqual",
    "NotSucceedsTilde",
    "NotSuperset",
    "NotSupersetEqual",
    "NotTilde",
    "NotTildeEqual",
    "NotTildeFullEqual",
    "NotTildeTilde",
    "NotVerticalBar",
    "Now",
    "NoWhitespace",
    "NProbability",
    "NProduct",
    "NProductFactors",
    "NRoots",
    "NSolve",
    "NSum",
    "NSumTerms",
    "NuclearExplosionData",
    "NuclearReactorData",
    "Null",
    "NullRecords",
    "NullSpace",
    "NullWords",
    "Number",
    "NumberCompose",
    "NumberDecompose",
    "NumberExpand",
    "NumberFieldClassNumber",
    "NumberFieldDiscriminant",
    "NumberFieldFundamentalUnits",
    "NumberFieldIntegralBasis",
    "NumberFieldNormRepresentatives",
    "NumberFieldRegulator",
    "NumberFieldRootsOfUnity",
    "NumberFieldSignature",
    "NumberForm",
    "NumberFormat",
    "NumberLinePlot",
    "NumberMarks",
    "NumberMultiplier",
    "NumberPadding",
    "NumberPoint",
    "NumberQ",
    "NumberSeparator",
    "NumberSigns",
    "NumberString",
    "Numerator",
    "NumeratorDenominator",
    "NumericalOrder",
    "NumericalSort",
    "NumericArray",
    "NumericArrayQ",
    "NumericArrayType",
    "NumericFunction",
    "NumericQ",
    "NuttallWindow",
    "NValues",
    "NyquistGridLines",
    "NyquistPlot",
    "O",
    "ObservabilityGramian",
    "ObservabilityMatrix",
    "ObservableDecomposition",
    "ObservableModelQ",
    "OceanData",
    "Octahedron",
    "OddQ",
    "Off",
    "Offset",
    "OLEData",
    "On",
    "ONanGroupON",
    "Once",
    "OneIdentity",
    "Opacity",
    "OpacityFunction",
    "OpacityFunctionScaling",
    "Open",
    "OpenAppend",
    "Opener",
    "OpenerBox",
    "OpenerBoxOptions",
    "OpenerView",
    "OpenFunctionInspectorPacket",
    "Opening",
    "OpenRead",
    "OpenSpecialOptions",
    "OpenTemporary",
    "OpenWrite",
    "Operate",
    "OperatingSystem",
    "OperatorApplied",
    "OptimumFlowData",
    "Optional",
    "OptionalElement",
    "OptionInspectorSettings",
    "OptionQ",
    "Options",
    "OptionsPacket",
    "OptionsPattern",
    "OptionValue",
    "OptionValueBox",
    "OptionValueBoxOptions",
    "Or",
    "Orange",
    "Order",
    "OrderDistribution",
    "OrderedQ",
    "Ordering",
    "OrderingBy",
    "OrderingLayer",
    "Orderless",
    "OrderlessPatternSequence",
    "OrnsteinUhlenbeckProcess",
    "Orthogonalize",
    "OrthogonalMatrixQ",
    "Out",
    "Outer",
    "OuterPolygon",
    "OuterPolyhedron",
    "OutputAutoOverwrite",
    "OutputControllabilityMatrix",
    "OutputControllableModelQ",
    "OutputForm",
    "OutputFormData",
    "OutputGrouping",
    "OutputMathEditExpression",
    "OutputNamePacket",
    "OutputResponse",
    "OutputSizeLimit",
    "OutputStream",
    "Over",
    "OverBar",
    "OverDot",
    "Overflow",
    "OverHat",
    "Overlaps",
    "Overlay",
    "OverlayBox",
    "OverlayBoxOptions",
    "Overscript",
    "OverscriptBox",
    "OverscriptBoxOptions",
    "OverTilde",
    "OverVector",
    "OverwriteTarget",
    "OwenT",
    "OwnValues",
    "Package",
    "PackingMethod",
    "PackPaclet",
    "PacletDataRebuild",
    "PacletDirectoryAdd",
    "PacletDirectoryLoad",
    "PacletDirectoryRemove",
    "PacletDirectoryUnload",
    "PacletDisable",
    "PacletEnable",
    "PacletFind",
    "PacletFindRemote",
    "PacletInformation",
    "PacletInstall",
    "PacletInstallSubmit",
    "PacletNewerQ",
    "PacletObject",
    "PacletObjectQ",
    "PacletSite",
    "PacletSiteObject",
    "PacletSiteRegister",
    "PacletSites",
    "PacletSiteUnregister",
    "PacletSiteUpdate",
    "PacletUninstall",
    "PacletUpdate",
    "PaddedForm",
    "Padding",
    "PaddingLayer",
    "PaddingSize",
    "PadeApproximant",
    "PadLeft",
    "PadRight",
    "PageBreakAbove",
    "PageBreakBelow",
    "PageBreakWithin",
    "PageFooterLines",
    "PageFooters",
    "PageHeaderLines",
    "PageHeaders",
    "PageHeight",
    "PageRankCentrality",
    "PageTheme",
    "PageWidth",
    "Pagination",
    "PairedBarChart",
    "PairedHistogram",
    "PairedSmoothHistogram",
    "PairedTTest",
    "PairedZTest",
    "PaletteNotebook",
    "PalettePath",
    "PalindromeQ",
    "Pane",
    "PaneBox",
    "PaneBoxOptions",
    "Panel",
    "PanelBox",
    "PanelBoxOptions",
    "Paneled",
    "PaneSelector",
    "PaneSelectorBox",
    "PaneSelectorBoxOptions",
    "PaperWidth",
    "ParabolicCylinderD",
    "ParagraphIndent",
    "ParagraphSpacing",
    "ParallelArray",
    "ParallelCombine",
    "ParallelDo",
    "Parallelepiped",
    "ParallelEvaluate",
    "Parallelization",
    "Parallelize",
    "ParallelMap",
    "ParallelNeeds",
    "Parallelogram",
    "ParallelProduct",
    "ParallelSubmit",
    "ParallelSum",
    "ParallelTable",
    "ParallelTry",
    "Parameter",
    "ParameterEstimator",
    "ParameterMixtureDistribution",
    "ParameterVariables",
    "ParametricFunction",
    "ParametricNDSolve",
    "ParametricNDSolveValue",
    "ParametricPlot",
    "ParametricPlot3D",
    "ParametricRampLayer",
    "ParametricRegion",
    "ParentBox",
    "ParentCell",
    "ParentConnect",
    "ParentDirectory",
    "ParentForm",
    "Parenthesize",
    "ParentList",
    "ParentNotebook",
    "ParetoDistribution",
    "ParetoPickandsDistribution",
    "ParkData",
    "Part",
    "PartBehavior",
    "PartialCorrelationFunction",
    "PartialD",
    "ParticleAcceleratorData",
    "ParticleData",
    "Partition",
    "PartitionGranularity",
    "PartitionsP",
    "PartitionsQ",
    "PartLayer",
    "PartOfSpeech",
    "PartProtection",
    "ParzenWindow",
    "PascalDistribution",
    "PassEventsDown",
    "PassEventsUp",
    "Paste",
    "PasteAutoQuoteCharacters",
    "PasteBoxFormInlineCells",
    "PasteButton",
    "Path",
    "PathGraph",
    "PathGraphQ",
    "Pattern",
    "PatternFilling",
    "PatternSequence",
    "PatternTest",
    "PauliMatrix",
    "PaulWavelet",
    "Pause",
    "PausedTime",
    "PDF",
    "PeakDetect",
    "PeanoCurve",
    "PearsonChiSquareTest",
    "PearsonCorrelationTest",
    "PearsonDistribution",
    "PercentForm",
    "PerfectNumber",
    "PerfectNumberQ",
    "PerformanceGoal",
    "Perimeter",
    "PeriodicBoundaryCondition",
    "PeriodicInterpolation",
    "Periodogram",
    "PeriodogramArray",
    "Permanent",
    "Permissions",
    "PermissionsGroup",
    "PermissionsGroupMemberQ",
    "PermissionsGroups",
    "PermissionsKey",
    "PermissionsKeys",
    "PermutationCycles",
    "PermutationCyclesQ",
    "PermutationGroup",
    "PermutationLength",
    "PermutationList",
    "PermutationListQ",
    "PermutationMax",
    "PermutationMin",
    "PermutationOrder",
    "PermutationPower",
    "PermutationProduct",
    "PermutationReplace",
    "Permutations",
    "PermutationSupport",
    "Permute",
    "PeronaMalikFilter",
    "Perpendicular",
    "PerpendicularBisector",
    "PersistenceLocation",
    "PersistenceTime",
    "PersistentObject",
    "PersistentObjects",
    "PersistentValue",
    "PersonData",
    "PERTDistribution",
    "PetersenGraph",
    "PhaseMargins",
    "PhaseRange",
    "PhysicalSystemData",
    "Pi",
    "Pick",
    "PIDData",
    "PIDDerivativeFilter",
    "PIDFeedforward",
    "PIDTune",
    "Piecewise",
    "PiecewiseExpand",
    "PieChart",
    "PieChart3D",
    "PillaiTrace",
    "PillaiTraceTest",
    "PingTime",
    "Pink",
    "PitchRecognize",
    "Pivoting",
    "PixelConstrained",
    "PixelValue",
    "PixelValuePositions",
    "Placed",
    "Placeholder",
    "PlaceholderReplace",
    "Plain",
    "PlanarAngle",
    "PlanarGraph",
    "PlanarGraphQ",
    "PlanckRadiationLaw",
    "PlaneCurveData",
    "PlanetaryMoonData",
    "PlanetData",
    "PlantData",
    "Play",
    "PlayRange",
    "Plot",
    "Plot3D",
    "Plot3Matrix",
    "PlotDivision",
    "PlotJoined",
    "PlotLabel",
    "PlotLabels",
    "PlotLayout",
    "PlotLegends",
    "PlotMarkers",
    "PlotPoints",
    "PlotRange",
    "PlotRangeClipping",
    "PlotRangeClipPlanesStyle",
    "PlotRangePadding",
    "PlotRegion",
    "PlotStyle",
    "PlotTheme",
    "Pluralize",
    "Plus",
    "PlusMinus",
    "Pochhammer",
    "PodStates",
    "PodWidth",
    "Point",
    "Point3DBox",
    "Point3DBoxOptions",
    "PointBox",
    "PointBoxOptions",
    "PointFigureChart",
    "PointLegend",
    "PointSize",
    "PoissonConsulDistribution",
    "PoissonDistribution",
    "PoissonProcess",
    "PoissonWindow",
    "PolarAxes",
    "PolarAxesOrigin",
    "PolarGridLines",
    "PolarPlot",
    "PolarTicks",
    "PoleZeroMarkers",
    "PolyaAeppliDistribution",
    "PolyGamma",
    "Polygon",
    "Polygon3DBox",
    "Polygon3DBoxOptions",
    "PolygonalNumber",
    "PolygonAngle",
    "PolygonBox",
    "PolygonBoxOptions",
    "PolygonCoordinates",
    "PolygonDecomposition",
    "PolygonHoleScale",
    "PolygonIntersections",
    "PolygonScale",
    "Polyhedron",
    "PolyhedronAngle",
    "PolyhedronCoordinates",
    "PolyhedronData",
    "PolyhedronDecomposition",
    "PolyhedronGenus",
    "PolyLog",
    "PolynomialExtendedGCD",
    "PolynomialForm",
    "PolynomialGCD",
    "PolynomialLCM",
    "PolynomialMod",
    "PolynomialQ",
    "PolynomialQuotient",
    "PolynomialQuotientRemainder",
    "PolynomialReduce",
    "PolynomialRemainder",
    "Polynomials",
    "PoolingLayer",
    "PopupMenu",
    "PopupMenuBox",
    "PopupMenuBoxOptions",
    "PopupView",
    "PopupWindow",
    "Position",
    "PositionIndex",
    "Positive",
    "PositiveDefiniteMatrixQ",
    "PositiveIntegers",
    "PositiveRationals",
    "PositiveReals",
    "PositiveSemidefiniteMatrixQ",
    "PossibleZeroQ",
    "Postfix",
    "PostScript",
    "Power",
    "PowerDistribution",
    "PowerExpand",
    "PowerMod",
    "PowerModList",
    "PowerRange",
    "PowerSpectralDensity",
    "PowersRepresentations",
    "PowerSymmetricPolynomial",
    "Precedence",
    "PrecedenceForm",
    "Precedes",
    "PrecedesEqual",
    "PrecedesSlantEqual",
    "PrecedesTilde",
    "Precision",
    "PrecisionGoal",
    "PreDecrement",
    "Predict",
    "PredictionRoot",
    "PredictorFunction",
    "PredictorInformation",
    "PredictorMeasurements",
    "PredictorMeasurementsObject",
    "PreemptProtect",
    "PreferencesPath",
    "Prefix",
    "PreIncrement",
    "Prepend",
    "PrependLayer",
    "PrependTo",
    "PreprocessingRules",
    "PreserveColor",
    "PreserveImageOptions",
    "Previous",
    "PreviousCell",
    "PreviousDate",
    "PriceGraphDistribution",
    "PrimaryPlaceholder",
    "Prime",
    "PrimeNu",
    "PrimeOmega",
    "PrimePi",
    "PrimePowerQ",
    "PrimeQ",
    "Primes",
    "PrimeZetaP",
    "PrimitivePolynomialQ",
    "PrimitiveRoot",
    "PrimitiveRootList",
    "PrincipalComponents",
    "PrincipalValue",
    "Print",
    "PrintableASCIIQ",
    "PrintAction",
    "PrintForm",
    "PrintingCopies",
    "PrintingOptions",
    "PrintingPageRange",
    "PrintingStartingPageNumber",
    "PrintingStyleEnvironment",
    "Printout3D",
    "Printout3DPreviewer",
    "PrintPrecision",
    "PrintTemporary",
    "Prism",
    "PrismBox",
    "PrismBoxOptions",
    "PrivateCellOptions",
    "PrivateEvaluationOptions",
    "PrivateFontOptions",
    "PrivateFrontEndOptions",
    "PrivateKey",
    "PrivateNotebookOptions",
    "PrivatePaths",
    "Probability",
    "ProbabilityDistribution",
    "ProbabilityPlot",
    "ProbabilityPr",
    "ProbabilityScalePlot",
    "ProbitModelFit",
    "ProcessConnection",
    "ProcessDirectory",
    "ProcessEnvironment",
    "Processes",
    "ProcessEstimator",
    "ProcessInformation",
    "ProcessObject",
    "ProcessParameterAssumptions",
    "ProcessParameterQ",
    "ProcessStateDomain",
    "ProcessStatus",
    "ProcessTimeDomain",
    "Product",
    "ProductDistribution",
    "ProductLog",
    "ProgressIndicator",
    "ProgressIndicatorBox",
    "ProgressIndicatorBoxOptions",
    "Projection",
    "Prolog",
    "PromptForm",
    "ProofObject",
    "Properties",
    "Property",
    "PropertyList",
    "PropertyValue",
    "Proportion",
    "Proportional",
    "Protect",
    "Protected",
    "ProteinData",
    "Pruning",
    "PseudoInverse",
    "PsychrometricPropertyData",
    "PublicKey",
    "PublisherID",
    "PulsarData",
    "PunctuationCharacter",
    "Purple",
    "Put",
    "PutAppend",
    "Pyramid",
    "PyramidBox",
    "PyramidBoxOptions",
    "QBinomial",
    "QFactorial",
    "QGamma",
    "QHypergeometricPFQ",
    "QnDispersion",
    "QPochhammer",
    "QPolyGamma",
    "QRDecomposition",
    "QuadraticIrrationalQ",
    "QuadraticOptimization",
    "Quantile",
    "QuantilePlot",
    "Quantity",
    "QuantityArray",
    "QuantityDistribution",
    "QuantityForm",
    "QuantityMagnitude",
    "QuantityQ",
    "QuantityUnit",
    "QuantityVariable",
    "QuantityVariableCanonicalUnit",
    "QuantityVariableDimensions",
    "QuantityVariableIdentifier",
    "QuantityVariablePhysicalQuantity",
    "Quartics",
    "QuartileDeviation",
    "Quartiles",
    "QuartileSkewness",
    "Query",
    "QueueingNetworkProcess",
    "QueueingProcess",
    "QueueProperties",
    "Quiet",
    "Quit",
    "Quotient",
    "QuotientRemainder",
    "RadialGradientImage",
    "RadialityCentrality",
    "RadicalBox",
    "RadicalBoxOptions",
    "RadioButton",
    "RadioButtonBar",
    "RadioButtonBox",
    "RadioButtonBoxOptions",
    "Radon",
    "RadonTransform",
    "RamanujanTau",
    "RamanujanTauL",
    "RamanujanTauTheta",
    "RamanujanTauZ",
    "Ramp",
    "Random",
    "RandomChoice",
    "RandomColor",
    "RandomComplex",
    "RandomEntity",
    "RandomFunction",
    "RandomGeoPosition",
    "RandomGraph",
    "RandomImage",
    "RandomInstance",
    "RandomInteger",
    "RandomPermutation",
    "RandomPoint",
    "RandomPolygon",
    "RandomPolyhedron",
    "RandomPrime",
    "RandomReal",
    "RandomSample",
    "RandomSeed",
    "RandomSeeding",
    "RandomVariate",
    "RandomWalkProcess",
    "RandomWord",
    "Range",
    "RangeFilter",
    "RangeSpecification",
    "RankedMax",
    "RankedMin",
    "RarerProbability",
    "Raster",
    "Raster3D",
    "Raster3DBox",
    "Raster3DBoxOptions",
    "RasterArray",
    "RasterBox",
    "RasterBoxOptions",
    "Rasterize",
    "RasterSize",
    "Rational",
    "RationalFunctions",
    "Rationalize",
    "Rationals",
    "Ratios",
    "RawArray",
    "RawBoxes",
    "RawData",
    "RawMedium",
    "RayleighDistribution",
    "Re",
    "Read",
    "ReadByteArray",
    "ReadLine",
    "ReadList",
    "ReadProtected",
    "ReadString",
    "Real",
    "RealAbs",
    "RealBlockDiagonalForm",
    "RealDigits",
    "RealExponent",
    "Reals",
    "RealSign",
    "Reap",
    "RebuildPacletData",
    "RecognitionPrior",
    "RecognitionThreshold",
    "Record",
    "RecordLists",
    "RecordSeparators",
    "Rectangle",
    "RectangleBox",
    "RectangleBoxOptions",
    "RectangleChart",
    "RectangleChart3D",
    "RectangularRepeatingElement",
    "RecurrenceFilter",
    "RecurrenceTable",
    "RecurringDigitsForm",
    "Red",
    "Reduce",
    "RefBox",
    "ReferenceLineStyle",
    "ReferenceMarkers",
    "ReferenceMarkerStyle",
    "Refine",
    "ReflectionMatrix",
    "ReflectionTransform",
    "Refresh",
    "RefreshRate",
    "Region",
    "RegionBinarize",
    "RegionBoundary",
    "RegionBoundaryStyle",
    "RegionBounds",
    "RegionCentroid",
    "RegionDifference",
    "RegionDimension",
    "RegionDisjoint",
    "RegionDistance",
    "RegionDistanceFunction",
    "RegionEmbeddingDimension",
    "RegionEqual",
    "RegionFillingStyle",
    "RegionFunction",
    "RegionImage",
    "RegionIntersection",
    "RegionMeasure",
    "RegionMember",
    "RegionMemberFunction",
    "RegionMoment",
    "RegionNearest",
    "RegionNearestFunction",
    "RegionPlot",
    "RegionPlot3D",
    "RegionProduct",
    "RegionQ",
    "RegionResize",
    "RegionSize",
    "RegionSymmetricDifference",
    "RegionUnion",
    "RegionWithin",
    "RegisterExternalEvaluator",
    "RegularExpression",
    "Regularization",
    "RegularlySampledQ",
    "RegularPolygon",
    "ReIm",
    "ReImLabels",
    "ReImPlot",
    "ReImStyle",
    "Reinstall",
    "RelationalDatabase",
    "RelationGraph",
    "Release",
    "ReleaseHold",
    "ReliabilityDistribution",
    "ReliefImage",
    "ReliefPlot",
    "RemoteAuthorizationCaching",
    "RemoteConnect",
    "RemoteConnectionObject",
    "RemoteFile",
    "RemoteRun",
    "RemoteRunProcess",
    "Remove",
    "RemoveAlphaChannel",
    "RemoveAsynchronousTask",
    "RemoveAudioStream",
    "RemoveBackground",
    "RemoveChannelListener",
    "RemoveChannelSubscribers",
    "Removed",
    "RemoveDiacritics",
    "RemoveInputStreamMethod",
    "RemoveOutputStreamMethod",
    "RemoveProperty",
    "RemoveScheduledTask",
    "RemoveUsers",
    "RemoveVideoStream",
    "RenameDirectory",
    "RenameFile",
    "RenderAll",
    "RenderingOptions",
    "RenewalProcess",
    "RenkoChart",
    "RepairMesh",
    "Repeated",
    "RepeatedNull",
    "RepeatedString",
    "RepeatedTiming",
    "RepeatingElement",
    "Replace",
    "ReplaceAll",
    "ReplaceHeldPart",
    "ReplaceImageValue",
    "ReplaceList",
    "ReplacePart",
    "ReplacePixelValue",
    "ReplaceRepeated",
    "ReplicateLayer",
    "RequiredPhysicalQuantities",
    "Resampling",
    "ResamplingAlgorithmData",
    "ResamplingMethod",
    "Rescale",
    "RescalingTransform",
    "ResetDirectory",
    "ResetMenusPacket",
    "ResetScheduledTask",
    "ReshapeLayer",
    "Residue",
    "ResizeLayer",
    "Resolve",
    "ResourceAcquire",
    "ResourceData",
    "ResourceFunction",
    "ResourceObject",
    "ResourceRegister",
    "ResourceRemove",
    "ResourceSearch",
    "ResourceSubmissionObject",
    "ResourceSubmit",
    "ResourceSystemBase",
    "ResourceSystemPath",
    "ResourceUpdate",
    "ResourceVersion",
    "ResponseForm",
    "Rest",
    "RestartInterval",
    "Restricted",
    "Resultant",
    "ResumePacket",
    "Return",
    "ReturnEntersInput",
    "ReturnExpressionPacket",
    "ReturnInputFormPacket",
    "ReturnPacket",
    "ReturnReceiptFunction",
    "ReturnTextPacket",
    "Reverse",
    "ReverseApplied",
    "ReverseBiorthogonalSplineWavelet",
    "ReverseElement",
    "ReverseEquilibrium",
    "ReverseGraph",
    "ReverseSort",
    "ReverseSortBy",
    "ReverseUpEquilibrium",
    "RevolutionAxis",
    "RevolutionPlot3D",
    "RGBColor",
    "RiccatiSolve",
    "RiceDistribution",
    "RidgeFilter",
    "RiemannR",
    "RiemannSiegelTheta",
    "RiemannSiegelZ",
    "RiemannXi",
    "Riffle",
    "Right",
    "RightArrow",
    "RightArrowBar",
    "RightArrowLeftArrow",
    "RightComposition",
    "RightCosetRepresentative",
    "RightDownTeeVector",
    "RightDownVector",
    "RightDownVectorBar",
    "RightTee",
    "RightTeeArrow",
    "RightTeeVector",
    "RightTriangle",
    "RightTriangleBar",
    "RightTriangleEqual",
    "RightUpDownVector",
    "RightUpTeeVector",
    "RightUpVector",
    "RightUpVectorBar",
    "RightVector",
    "RightVectorBar",
    "RiskAchievementImportance",
    "RiskReductionImportance",
    "RogersTanimotoDissimilarity",
    "RollPitchYawAngles",
    "RollPitchYawMatrix",
    "RomanNumeral",
    "Root",
    "RootApproximant",
    "RootIntervals",
    "RootLocusPlot",
    "RootMeanSquare",
    "RootOfUnityQ",
    "RootReduce",
    "Roots",
    "RootSum",
    "Rotate",
    "RotateLabel",
    "RotateLeft",
    "RotateRight",
    "RotationAction",
    "RotationBox",
    "RotationBoxOptions",
    "RotationMatrix",
    "RotationTransform",
    "Round",
    "RoundImplies",
    "RoundingRadius",
    "Row",
    "RowAlignments",
    "RowBackgrounds",
    "RowBox",
    "RowHeights",
    "RowLines",
    "RowMinHeight",
    "RowReduce",
    "RowsEqual",
    "RowSpacings",
    "RSolve",
    "RSolveValue",
    "RudinShapiro",
    "RudvalisGroupRu",
    "Rule",
    "RuleCondition",
    "RuleDelayed",
    "RuleForm",
    "RulePlot",
    "RulerUnits",
    "Run",
    "RunProcess",
    "RunScheduledTask",
    "RunThrough",
    "RuntimeAttributes",
    "RuntimeOptions",
    "RussellRaoDissimilarity",
    "SameQ",
    "SameTest",
    "SameTestProperties",
    "SampledEntityClass",
    "SampleDepth",
    "SampledSoundFunction",
    "SampledSoundList",
    "SampleRate",
    "SamplingPeriod",
    "SARIMAProcess",
    "SARMAProcess",
    "SASTriangle",
    "SatelliteData",
    "SatisfiabilityCount",
    "SatisfiabilityInstances",
    "SatisfiableQ",
    "Saturday",
    "Save",
    "Saveable",
    "SaveAutoDelete",
    "SaveConnection",
    "SaveDefinitions",
    "SavitzkyGolayMatrix",
    "SawtoothWave",
    "Scale",
    "Scaled",
    "ScaleDivisions",
    "ScaledMousePosition",
    "ScaleOrigin",
    "ScalePadding",
    "ScaleRanges",
    "ScaleRangeStyle",
    "ScalingFunctions",
    "ScalingMatrix",
    "ScalingTransform",
    "Scan",
    "ScheduledTask",
    "ScheduledTaskActiveQ",
    "ScheduledTaskInformation",
    "ScheduledTaskInformationData",
    "ScheduledTaskObject",
    "ScheduledTasks",
    "SchurDecomposition",
    "ScientificForm",
    "ScientificNotationThreshold",
    "ScorerGi",
    "ScorerGiPrime",
    "ScorerHi",
    "ScorerHiPrime",
    "ScreenRectangle",
    "ScreenStyleEnvironment",
    "ScriptBaselineShifts",
    "ScriptForm",
    "ScriptLevel",
    "ScriptMinSize",
    "ScriptRules",
    "ScriptSizeMultipliers",
    "Scrollbars",
    "ScrollingOptions",
    "ScrollPosition",
    "SearchAdjustment",
    "SearchIndexObject",
    "SearchIndices",
    "SearchQueryString",
    "SearchResultObject",
    "Sec",
    "Sech",
    "SechDistribution",
    "SecondOrderConeOptimization",
    "SectionGrouping",
    "SectorChart",
    "SectorChart3D",
    "SectorOrigin",
    "SectorSpacing",
    "SecuredAuthenticationKey",
    "SecuredAuthenticationKeys",
    "SeedRandom",
    "Select",
    "Selectable",
    "SelectComponents",
    "SelectedCells",
    "SelectedNotebook",
    "SelectFirst",
    "Selection",
    "SelectionAnimate",
    "SelectionCell",
    "SelectionCellCreateCell",
    "SelectionCellDefaultStyle",
    "SelectionCellParentStyle",
    "SelectionCreateCell",
    "SelectionDebuggerTag",
    "SelectionDuplicateCell",
    "SelectionEvaluate",
    "SelectionEvaluateCreateCell",
    "SelectionMove",
    "SelectionPlaceholder",
    "SelectionSetStyle",
    "SelectWithContents",
    "SelfLoops",
    "SelfLoopStyle",
    "SemanticImport",
    "SemanticImportString",
    "SemanticInterpretation",
    "SemialgebraicComponentInstances",
    "SemidefiniteOptimization",
    "SendMail",
    "SendMessage",
    "Sequence",
    "SequenceAlignment",
    "SequenceAttentionLayer",
    "SequenceCases",
    "SequenceCount",
    "SequenceFold",
    "SequenceFoldList",
    "SequenceForm",
    "SequenceHold",
    "SequenceLastLayer",
    "SequenceMostLayer",
    "SequencePosition",
    "SequencePredict",
    "SequencePredictorFunction",
    "SequenceReplace",
    "SequenceRestLayer",
    "SequenceReverseLayer",
    "SequenceSplit",
    "Series",
    "SeriesCoefficient",
    "SeriesData",
    "SeriesTermGoal",
    "ServiceConnect",
    "ServiceDisconnect",
    "ServiceExecute",
    "ServiceObject",
    "ServiceRequest",
    "ServiceResponse",
    "ServiceSubmit",
    "SessionSubmit",
    "SessionTime",
    "Set",
    "SetAccuracy",
    "SetAlphaChannel",
    "SetAttributes",
    "Setbacks",
    "SetBoxFormNamesPacket",
    "SetCloudDirectory",
    "SetCookies",
    "SetDelayed",
    "SetDirectory",
    "SetEnvironment",
    "SetEvaluationNotebook",
    "SetFileDate",
    "SetFileLoadingContext",
    "SetNotebookStatusLine",
    "SetOptions",
    "SetOptionsPacket",
    "SetPermissions",
    "SetPrecision",
    "SetProperty",
    "SetSecuredAuthenticationKey",
    "SetSelectedNotebook",
    "SetSharedFunction",
    "SetSharedVariable",
    "SetSpeechParametersPacket",
    "SetStreamPosition",
    "SetSystemModel",
    "SetSystemOptions",
    "Setter",
    "SetterBar",
    "SetterBox",
    "SetterBoxOptions",
    "Setting",
    "SetUsers",
    "SetValue",
    "Shading",
    "Shallow",
    "ShannonWavelet",
    "ShapiroWilkTest",
    "Share",
    "SharingList",
    "Sharpen",
    "ShearingMatrix",
    "ShearingTransform",
    "ShellRegion",
    "ShenCastanMatrix",
    "ShiftedGompertzDistribution",
    "ShiftRegisterSequence",
    "Short",
    "ShortDownArrow",
    "Shortest",
    "ShortestMatch",
    "ShortestPathFunction",
    "ShortLeftArrow",
    "ShortRightArrow",
    "ShortTimeFourier",
    "ShortTimeFourierData",
    "ShortUpArrow",
    "Show",
    "ShowAutoConvert",
    "ShowAutoSpellCheck",
    "ShowAutoStyles",
    "ShowCellBracket",
    "ShowCellLabel",
    "ShowCellTags",
    "ShowClosedCellArea",
    "ShowCodeAssist",
    "ShowContents",
    "ShowControls",
    "ShowCursorTracker",
    "ShowGroupOpenCloseIcon",
    "ShowGroupOpener",
    "ShowInvisibleCharacters",
    "ShowPageBreaks",
    "ShowPredictiveInterface",
    "ShowSelection",
    "ShowShortBoxForm",
    "ShowSpecialCharacters",
    "ShowStringCharacters",
    "ShowSyntaxStyles",
    "ShrinkingDelay",
    "ShrinkWrapBoundingBox",
    "SiderealTime",
    "SiegelTheta",
    "SiegelTukeyTest",
    "SierpinskiCurve",
    "SierpinskiMesh",
    "Sign",
    "Signature",
    "SignedRankTest",
    "SignedRegionDistance",
    "SignificanceLevel",
    "SignPadding",
    "SignTest",
    "SimilarityRules",
    "SimpleGraph",
    "SimpleGraphQ",
    "SimplePolygonQ",
    "SimplePolyhedronQ",
    "Simplex",
    "Simplify",
    "Sin",
    "Sinc",
    "SinghMaddalaDistribution",
    "SingleEvaluation",
    "SingleLetterItalics",
    "SingleLetterStyle",
    "SingularValueDecomposition",
    "SingularValueList",
    "SingularValuePlot",
    "SingularValues",
    "Sinh",
    "SinhIntegral",
    "SinIntegral",
    "SixJSymbol",
    "Skeleton",
    "SkeletonTransform",
    "SkellamDistribution",
    "Skewness",
    "SkewNormalDistribution",
    "SkinStyle",
    "Skip",
    "SliceContourPlot3D",
    "SliceDensityPlot3D",
    "SliceDistribution",
    "SliceVectorPlot3D",
    "Slider",
    "Slider2D",
    "Slider2DBox",
    "Slider2DBoxOptions",
    "SliderBox",
    "SliderBoxOptions",
    "SlideView",
    "Slot",
    "SlotSequence",
    "Small",
    "SmallCircle",
    "Smaller",
    "SmithDecomposition",
    "SmithDelayCompensator",
    "SmithWatermanSimilarity",
    "SmoothDensityHistogram",
    "SmoothHistogram",
    "SmoothHistogram3D",
    "SmoothKernelDistribution",
    "SnDispersion",
    "Snippet",
    "SnubPolyhedron",
    "SocialMediaData",
    "Socket",
    "SocketConnect",
    "SocketListen",
    "SocketListener",
    "SocketObject",
    "SocketOpen",
    "SocketReadMessage",
    "SocketReadyQ",
    "Sockets",
    "SocketWaitAll",
    "SocketWaitNext",
    "SoftmaxLayer",
    "SokalSneathDissimilarity",
    "SolarEclipse",
    "SolarSystemFeatureData",
    "SolidAngle",
    "SolidData",
    "SolidRegionQ",
    "Solve",
    "SolveAlways",
    "SolveDelayed",
    "Sort",
    "SortBy",
    "SortedBy",
    "SortedEntityClass",
    "Sound",
    "SoundAndGraphics",
    "SoundNote",
    "SoundVolume",
    "SourceLink",
    "Sow",
    "Space",
    "SpaceCurveData",
    "SpaceForm",
    "Spacer",
    "Spacings",
    "Span",
    "SpanAdjustments",
    "SpanCharacterRounding",
    "SpanFromAbove",
    "SpanFromBoth",
    "SpanFromLeft",
    "SpanLineThickness",
    "SpanMaxSize",
    "SpanMinSize",
    "SpanningCharacters",
    "SpanSymmetric",
    "SparseArray",
    "SpatialGraphDistribution",
    "SpatialMedian",
    "SpatialTransformationLayer",
    "Speak",
    "SpeakerMatchQ",
    "SpeakTextPacket",
    "SpearmanRankTest",
    "SpearmanRho",
    "SpeciesData",
    "SpecificityGoal",
    "SpectralLineData",
    "Spectrogram",
    "SpectrogramArray",
    "Specularity",
    "SpeechCases",
    "SpeechInterpreter",
    "SpeechRecognize",
    "SpeechSynthesize",
    "SpellingCorrection",
    "SpellingCorrectionList",
    "SpellingDictionaries",
    "SpellingDictionariesPath",
    "SpellingOptions",
    "SpellingSuggestionsPacket",
    "Sphere",
    "SphereBox",
    "SpherePoints",
    "SphericalBesselJ",
    "SphericalBesselY",
    "SphericalHankelH1",
    "SphericalHankelH2",
    "SphericalHarmonicY",
    "SphericalPlot3D",
    "SphericalRegion",
    "SphericalShell",
    "SpheroidalEigenvalue",
    "SpheroidalJoiningFactor",
    "SpheroidalPS",
    "SpheroidalPSPrime",
    "SpheroidalQS",
    "SpheroidalQSPrime",
    "SpheroidalRadialFactor",
    "SpheroidalS1",
    "SpheroidalS1Prime",
    "SpheroidalS2",
    "SpheroidalS2Prime",
    "Splice",
    "SplicedDistribution",
    "SplineClosed",
    "SplineDegree",
    "SplineKnots",
    "SplineWeights",
    "Split",
    "SplitBy",
    "SpokenString",
    "Sqrt",
    "SqrtBox",
    "SqrtBoxOptions",
    "Square",
    "SquaredEuclideanDistance",
    "SquareFreeQ",
    "SquareIntersection",
    "SquareMatrixQ",
    "SquareRepeatingElement",
    "SquaresR",
    "SquareSubset",
    "SquareSubsetEqual",
    "SquareSuperset",
    "SquareSupersetEqual",
    "SquareUnion",
    "SquareWave",
    "SSSTriangle",
    "StabilityMargins",
    "StabilityMarginsStyle",
    "StableDistribution",
    "Stack",
    "StackBegin",
    "StackComplete",
    "StackedDateListPlot",
    "StackedListPlot",
    "StackInhibit",
    "StadiumShape",
    "StandardAtmosphereData",
    "StandardDeviation",
    "StandardDeviationFilter",
    "StandardForm",
    "Standardize",
    "Standardized",
    "StandardOceanData",
    "StandbyDistribution",
    "Star",
    "StarClusterData",
    "StarData",
    "StarGraph",
    "StartAsynchronousTask",
    "StartExternalSession",
    "StartingStepSize",
    "StartOfLine",
    "StartOfString",
    "StartProcess",
    "StartScheduledTask",
    "StartupSound",
    "StartWebSession",
    "StateDimensions",
    "StateFeedbackGains",
    "StateOutputEstimator",
    "StateResponse",
    "StateSpaceModel",
    "StateSpaceRealization",
    "StateSpaceTransform",
    "StateTransformationLinearize",
    "StationaryDistribution",
    "StationaryWaveletPacketTransform",
    "StationaryWaveletTransform",
    "StatusArea",
    "StatusCentrality",
    "StepMonitor",
    "StereochemistryElements",
    "StieltjesGamma",
    "StippleShading",
    "StirlingS1",
    "StirlingS2",
    "StopAsynchronousTask",
    "StoppingPowerData",
    "StopScheduledTask",
    "StrataVariables",
    "StratonovichProcess",
    "StreamColorFunction",
    "StreamColorFunctionScaling",
    "StreamDensityPlot",
    "StreamMarkers",
    "StreamPlot",
    "StreamPoints",
    "StreamPosition",
    "Streams",
    "StreamScale",
    "StreamStyle",
    "String",
    "StringBreak",
    "StringByteCount",
    "StringCases",
    "StringContainsQ",
    "StringCount",
    "StringDelete",
    "StringDrop",
    "StringEndsQ",
    "StringExpression",
    "StringExtract",
    "StringForm",
    "StringFormat",
    "StringFreeQ",
    "StringInsert",
    "StringJoin",
    "StringLength",
    "StringMatchQ",
    "StringPadLeft",
    "StringPadRight",
    "StringPart",
    "StringPartition",
    "StringPosition",
    "StringQ",
    "StringRepeat",
    "StringReplace",
    "StringReplaceList",
    "StringReplacePart",
    "StringReverse",
    "StringRiffle",
    "StringRotateLeft",
    "StringRotateRight",
    "StringSkeleton",
    "StringSplit",
    "StringStartsQ",
    "StringTake",
    "StringTemplate",
    "StringToByteArray",
    "StringToStream",
    "StringTrim",
    "StripBoxes",
    "StripOnInput",
    "StripWrapperBoxes",
    "StrokeForm",
    "StructuralImportance",
    "StructuredArray",
    "StructuredArrayHeadQ",
    "StructuredSelection",
    "StruveH",
    "StruveL",
    "Stub",
    "StudentTDistribution",
    "Style",
    "StyleBox",
    "StyleBoxAutoDelete",
    "StyleData",
    "StyleDefinitions",
    "StyleForm",
    "StyleHints",
    "StyleKeyMapping",
    "StyleMenuListing",
    "StyleNameDialogSettings",
    "StyleNames",
    "StylePrint",
    "StyleSheetPath",
    "Subdivide",
    "Subfactorial",
    "Subgraph",
    "SubMinus",
    "SubPlus",
    "SubresultantPolynomialRemainders",
    "SubresultantPolynomials",
    "Subresultants",
    "Subscript",
    "SubscriptBox",
    "SubscriptBoxOptions",
    "Subscripted",
    "Subsequences",
    "Subset",
    "SubsetCases",
    "SubsetCount",
    "SubsetEqual",
    "SubsetMap",
    "SubsetPosition",
    "SubsetQ",
    "SubsetReplace",
    "Subsets",
    "SubStar",
    "SubstitutionSystem",
    "Subsuperscript",
    "SubsuperscriptBox",
    "SubsuperscriptBoxOptions",
    "SubtitleEncoding",
    "SubtitleTracks",
    "Subtract",
    "SubtractFrom",
    "SubtractSides",
    "SubValues",
    "Succeeds",
    "SucceedsEqual",
    "SucceedsSlantEqual",
    "SucceedsTilde",
    "Success",
    "SuchThat",
    "Sum",
    "SumConvergence",
    "SummationLayer",
    "Sunday",
    "SunPosition",
    "Sunrise",
    "Sunset",
    "SuperDagger",
    "SuperMinus",
    "SupernovaData",
    "SuperPlus",
    "Superscript",
    "SuperscriptBox",
    "SuperscriptBoxOptions",
    "Superset",
    "SupersetEqual",
    "SuperStar",
    "Surd",
    "SurdForm",
    "SurfaceAppearance",
    "SurfaceArea",
    "SurfaceColor",
    "SurfaceData",
    "SurfaceGraphics",
    "SurvivalDistribution",
    "SurvivalFunction",
    "SurvivalModel",
    "SurvivalModelFit",
    "SuspendPacket",
    "SuzukiDistribution",
    "SuzukiGroupSuz",
    "SwatchLegend",
    "Switch",
    "Symbol",
    "SymbolName",
    "SymletWavelet",
    "Symmetric",
    "SymmetricGroup",
    "SymmetricKey",
    "SymmetricMatrixQ",
    "SymmetricPolynomial",
    "SymmetricReduction",
    "Symmetrize",
    "SymmetrizedArray",
    "SymmetrizedArrayRules",
    "SymmetrizedDependentComponents",
    "SymmetrizedIndependentComponents",
    "SymmetrizedReplacePart",
    "SynchronousInitialization",
    "SynchronousUpdating",
    "Synonyms",
    "Syntax",
    "SyntaxForm",
    "SyntaxInformation",
    "SyntaxLength",
    "SyntaxPacket",
    "SyntaxQ",
    "SynthesizeMissingValues",
    "SystemCredential",
    "SystemCredentialData",
    "SystemCredentialKey",
    "SystemCredentialKeys",
    "SystemCredentialStoreObject",
    "SystemDialogInput",
    "SystemException",
    "SystemGet",
    "SystemHelpPath",
    "SystemInformation",
    "SystemInformationData",
    "SystemInstall",
    "SystemModel",
    "SystemModeler",
    "SystemModelExamples",
    "SystemModelLinearize",
    "SystemModelParametricSimulate",
    "SystemModelPlot",
    "SystemModelProgressReporting",
    "SystemModelReliability",
    "SystemModels",
    "SystemModelSimulate",
    "SystemModelSimulateSensitivity",
    "SystemModelSimulationData",
    "SystemOpen",
    "SystemOptions",
    "SystemProcessData",
    "SystemProcesses",
    "SystemsConnectionsModel",
    "SystemsModelDelay",
    "SystemsModelDelayApproximate",
    "SystemsModelDelete",
    "SystemsModelDimensions",
    "SystemsModelExtract",
    "SystemsModelFeedbackConnect",
    "SystemsModelLabels",
    "SystemsModelLinearity",
    "SystemsModelMerge",
    "SystemsModelOrder",
    "SystemsModelParallelConnect",
    "SystemsModelSeriesConnect",
    "SystemsModelStateFeedbackConnect",
    "SystemsModelVectorRelativeOrders",
    "SystemStub",
    "SystemTest",
    "Tab",
    "TabFilling",
    "Table",
    "TableAlignments",
    "TableDepth",
    "TableDirections",
    "TableForm",
    "TableHeadings",
    "TableSpacing",
    "TableView",
    "TableViewBox",
    "TableViewBoxBackground",
    "TableViewBoxItemSize",
    "TableViewBoxOptions",
    "TabSpacings",
    "TabView",
    "TabViewBox",
    "TabViewBoxOptions",
    "TagBox",
    "TagBoxNote",
    "TagBoxOptions",
    "TaggingRules",
    "TagSet",
    "TagSetDelayed",
    "TagStyle",
    "TagUnset",
    "Take",
    "TakeDrop",
    "TakeLargest",
    "TakeLargestBy",
    "TakeList",
    "TakeSmallest",
    "TakeSmallestBy",
    "TakeWhile",
    "Tally",
    "Tan",
    "Tanh",
    "TargetDevice",
    "TargetFunctions",
    "TargetSystem",
    "TargetUnits",
    "TaskAbort",
    "TaskExecute",
    "TaskObject",
    "TaskRemove",
    "TaskResume",
    "Tasks",
    "TaskSuspend",
    "TaskWait",
    "TautologyQ",
    "TelegraphProcess",
    "TemplateApply",
    "TemplateArgBox",
    "TemplateBox",
    "TemplateBoxOptions",
    "TemplateEvaluate",
    "TemplateExpression",
    "TemplateIf",
    "TemplateObject",
    "TemplateSequence",
    "TemplateSlot",
    "TemplateSlotSequence",
    "TemplateUnevaluated",
    "TemplateVerbatim",
    "TemplateWith",
    "TemporalData",
    "TemporalRegularity",
    "Temporary",
    "TemporaryVariable",
    "TensorContract",
    "TensorDimensions",
    "TensorExpand",
    "TensorProduct",
    "TensorQ",
    "TensorRank",
    "TensorReduce",
    "TensorSymmetry",
    "TensorTranspose",
    "TensorWedge",
    "TestID",
    "TestReport",
    "TestReportObject",
    "TestResultObject",
    "Tetrahedron",
    "TetrahedronBox",
    "TetrahedronBoxOptions",
    "TeXForm",
    "TeXSave",
    "Text",
    "Text3DBox",
    "Text3DBoxOptions",
    "TextAlignment",
    "TextBand",
    "TextBoundingBox",
    "TextBox",
    "TextCases",
    "TextCell",
    "TextClipboardType",
    "TextContents",
    "TextData",
    "TextElement",
    "TextForm",
    "TextGrid",
    "TextJustification",
    "TextLine",
    "TextPacket",
    "TextParagraph",
    "TextPosition",
    "TextRecognize",
    "TextSearch",
    "TextSearchReport",
    "TextSentences",
    "TextString",
    "TextStructure",
    "TextStyle",
    "TextTranslation",
    "Texture",
    "TextureCoordinateFunction",
    "TextureCoordinateScaling",
    "TextWords",
    "Therefore",
    "ThermodynamicData",
    "ThermometerGauge",
    "Thick",
    "Thickness",
    "Thin",
    "Thinning",
    "ThisLink",
    "ThompsonGroupTh",
    "Thread",
    "ThreadingLayer",
    "ThreeJSymbol",
    "Threshold",
    "Through",
    "Throw",
    "ThueMorse",
    "Thumbnail",
    "Thursday",
    "Ticks",
    "TicksStyle",
    "TideData",
    "Tilde",
    "TildeEqual",
    "TildeFullEqual",
    "TildeTilde",
    "TimeConstrained",
    "TimeConstraint",
    "TimeDirection",
    "TimeFormat",
    "TimeGoal",
    "TimelinePlot",
    "TimeObject",
    "TimeObjectQ",
    "TimeRemaining",
    "Times",
    "TimesBy",
    "TimeSeries",
    "TimeSeriesAggregate",
    "TimeSeriesForecast",
    "TimeSeriesInsert",
    "TimeSeriesInvertibility",
    "TimeSeriesMap",
    "TimeSeriesMapThread",
    "TimeSeriesModel",
    "TimeSeriesModelFit",
    "TimeSeriesResample",
    "TimeSeriesRescale",
    "TimeSeriesShift",
    "TimeSeriesThread",
    "TimeSeriesWindow",
    "TimeUsed",
    "TimeValue",
    "TimeWarpingCorrespondence",
    "TimeWarpingDistance",
    "TimeZone",
    "TimeZoneConvert",
    "TimeZoneOffset",
    "Timing",
    "Tiny",
    "TitleGrouping",
    "TitsGroupT",
    "ToBoxes",
    "ToCharacterCode",
    "ToColor",
    "ToContinuousTimeModel",
    "ToDate",
    "Today",
    "ToDiscreteTimeModel",
    "ToEntity",
    "ToeplitzMatrix",
    "ToExpression",
    "ToFileName",
    "Together",
    "Toggle",
    "ToggleFalse",
    "Toggler",
    "TogglerBar",
    "TogglerBox",
    "TogglerBoxOptions",
    "ToHeldExpression",
    "ToInvertibleTimeSeries",
    "TokenWords",
    "Tolerance",
    "ToLowerCase",
    "Tomorrow",
    "ToNumberField",
    "TooBig",
    "Tooltip",
    "TooltipBox",
    "TooltipBoxOptions",
    "TooltipDelay",
    "TooltipStyle",
    "ToonShading",
    "Top",
    "TopHatTransform",
    "ToPolarCoordinates",
    "TopologicalSort",
    "ToRadicals",
    "ToRules",
    "ToSphericalCoordinates",
    "ToString",
    "Total",
    "TotalHeight",
    "TotalLayer",
    "TotalVariationFilter",
    "TotalWidth",
    "TouchPosition",
    "TouchscreenAutoZoom",
    "TouchscreenControlPlacement",
    "ToUpperCase",
    "Tr",
    "Trace",
    "TraceAbove",
    "TraceAction",
    "TraceBackward",
    "TraceDepth",
    "TraceDialog",
    "TraceForward",
    "TraceInternal",
    "TraceLevel",
    "TraceOff",
    "TraceOn",
    "TraceOriginal",
    "TracePrint",
    "TraceScan",
    "TrackedSymbols",
    "TrackingFunction",
    "TracyWidomDistribution",
    "TradingChart",
    "TraditionalForm",
    "TraditionalFunctionNotation",
    "TraditionalNotation",
    "TraditionalOrder",
    "TrainingProgressCheckpointing",
    "TrainingProgressFunction",
    "TrainingProgressMeasurements",
    "TrainingProgressReporting",
    "TrainingStoppingCriterion",
    "TrainingUpdateSchedule",
    "TransferFunctionCancel",
    "TransferFunctionExpand",
    "TransferFunctionFactor",
    "TransferFunctionModel",
    "TransferFunctionPoles",
    "TransferFunctionTransform",
    "TransferFunctionZeros",
    "TransformationClass",
    "TransformationFunction",
    "TransformationFunctions",
    "TransformationMatrix",
    "TransformedDistribution",
    "TransformedField",
    "TransformedProcess",
    "TransformedRegion",
    "TransitionDirection",
    "TransitionDuration",
    "TransitionEffect",
    "TransitiveClosureGraph",
    "TransitiveReductionGraph",
    "Translate",
    "TranslationOptions",
    "TranslationTransform",
    "Transliterate",
    "Transparent",
    "TransparentColor",
    "Transpose",
    "TransposeLayer",
    "TrapSelection",
    "TravelDirections",
    "TravelDirectionsData",
    "TravelDistance",
    "TravelDistanceList",
    "TravelMethod",
    "TravelTime",
    "TreeForm",
    "TreeGraph",
    "TreeGraphQ",
    "TreePlot",
    "TrendStyle",
    "Triangle",
    "TriangleCenter",
    "TriangleConstruct",
    "TriangleMeasurement",
    "TriangleWave",
    "TriangularDistribution",
    "TriangulateMesh",
    "Trig",
    "TrigExpand",
    "TrigFactor",
    "TrigFactorList",
    "Trigger",
    "TrigReduce",
    "TrigToExp",
    "TrimmedMean",
    "TrimmedVariance",
    "TropicalStormData",
    "True",
    "TrueQ",
    "TruncatedDistribution",
    "TruncatedPolyhedron",
    "TsallisQExponentialDistribution",
    "TsallisQGaussianDistribution",
    "TTest",
    "Tube",
    "TubeBezierCurveBox",
    "TubeBezierCurveBoxOptions",
    "TubeBox",
    "TubeBoxOptions",
    "TubeBSplineCurveBox",
    "TubeBSplineCurveBoxOptions",
    "Tuesday",
    "TukeyLambdaDistribution",
    "TukeyWindow",
    "TunnelData",
    "Tuples",
    "TuranGraph",
    "TuringMachine",
    "TuttePolynomial",
    "TwoWayRule",
    "Typed",
    "TypeSpecifier",
    "UnateQ",
    "Uncompress",
    "UnconstrainedParameters",
    "Undefined",
    "UnderBar",
    "Underflow",
    "Underlined",
    "Underoverscript",
    "UnderoverscriptBox",
    "UnderoverscriptBoxOptions",
    "Underscript",
    "UnderscriptBox",
    "UnderscriptBoxOptions",
    "UnderseaFeatureData",
    "UndirectedEdge",
    "UndirectedGraph",
    "UndirectedGraphQ",
    "UndoOptions",
    "UndoTrackedVariables",
    "Unequal",
    "UnequalTo",
    "Unevaluated",
    "UniformDistribution",
    "UniformGraphDistribution",
    "UniformPolyhedron",
    "UniformSumDistribution",
    "Uninstall",
    "Union",
    "UnionedEntityClass",
    "UnionPlus",
    "Unique",
    "UnitaryMatrixQ",
    "UnitBox",
    "UnitConvert",
    "UnitDimensions",
    "Unitize",
    "UnitRootTest",
    "UnitSimplify",
    "UnitStep",
    "UnitSystem",
    "UnitTriangle",
    "UnitVector",
    "UnitVectorLayer",
    "UnityDimensions",
    "UniverseModelData",
    "UniversityData",
    "UnixTime",
    "Unprotect",
    "UnregisterExternalEvaluator",
    "UnsameQ",
    "UnsavedVariables",
    "Unset",
    "UnsetShared",
    "UntrackedVariables",
    "Up",
    "UpArrow",
    "UpArrowBar",
    "UpArrowDownArrow",
    "Update",
    "UpdateDynamicObjects",
    "UpdateDynamicObjectsSynchronous",
    "UpdateInterval",
    "UpdatePacletSites",
    "UpdateSearchIndex",
    "UpDownArrow",
    "UpEquilibrium",
    "UpperCaseQ",
    "UpperLeftArrow",
    "UpperRightArrow",
    "UpperTriangularize",
    "UpperTriangularMatrixQ",
    "Upsample",
    "UpSet",
    "UpSetDelayed",
    "UpTee",
    "UpTeeArrow",
    "UpTo",
    "UpValues",
    "URL",
    "URLBuild",
    "URLDecode",
    "URLDispatcher",
    "URLDownload",
    "URLDownloadSubmit",
    "URLEncode",
    "URLExecute",
    "URLExpand",
    "URLFetch",
    "URLFetchAsynchronous",
    "URLParse",
    "URLQueryDecode",
    "URLQueryEncode",
    "URLRead",
    "URLResponseTime",
    "URLSave",
    "URLSaveAsynchronous",
    "URLShorten",
    "URLSubmit",
    "UseGraphicsRange",
    "UserDefinedWavelet",
    "Using",
    "UsingFrontEnd",
    "UtilityFunction",
    "V2Get",
    "ValenceErrorHandling",
    "ValidationLength",
    "ValidationSet",
    "Value",
    "ValueBox",
    "ValueBoxOptions",
    "ValueDimensions",
    "ValueForm",
    "ValuePreprocessingFunction",
    "ValueQ",
    "Values",
    "ValuesData",
    "Variables",
    "Variance",
    "VarianceEquivalenceTest",
    "VarianceEstimatorFunction",
    "VarianceGammaDistribution",
    "VarianceTest",
    "VectorAngle",
    "VectorAround",
    "VectorAspectRatio",
    "VectorColorFunction",
    "VectorColorFunctionScaling",
    "VectorDensityPlot",
    "VectorGlyphData",
    "VectorGreater",
    "VectorGreaterEqual",
    "VectorLess",
    "VectorLessEqual",
    "VectorMarkers",
    "VectorPlot",
    "VectorPlot3D",
    "VectorPoints",
    "VectorQ",
    "VectorRange",
    "Vectors",
    "VectorScale",
    "VectorScaling",
    "VectorSizes",
    "VectorStyle",
    "Vee",
    "Verbatim",
    "Verbose",
    "VerboseConvertToPostScriptPacket",
    "VerificationTest",
    "VerifyConvergence",
    "VerifyDerivedKey",
    "VerifyDigitalSignature",
    "VerifyFileSignature",
    "VerifyInterpretation",
    "VerifySecurityCertificates",
    "VerifySolutions",
    "VerifyTestAssumptions",
    "Version",
    "VersionedPreferences",
    "VersionNumber",
    "VertexAdd",
    "VertexCapacity",
    "VertexColors",
    "VertexComponent",
    "VertexConnectivity",
    "VertexContract",
    "VertexCoordinateRules",
    "VertexCoordinates",
    "VertexCorrelationSimilarity",
    "VertexCosineSimilarity",
    "VertexCount",
    "VertexCoverQ",
    "VertexDataCoordinates",
    "VertexDegree",
    "VertexDelete",
    "VertexDiceSimilarity",
    "VertexEccentricity",
    "VertexInComponent",
    "VertexInDegree",
    "VertexIndex",
    "VertexJaccardSimilarity",
    "VertexLabeling",
    "VertexLabels",
    "VertexLabelStyle",
    "VertexList",
    "VertexNormals",
    "VertexOutComponent",
    "VertexOutDegree",
    "VertexQ",
    "VertexRenderingFunction",
    "VertexReplace",
    "VertexShape",
    "VertexShapeFunction",
    "VertexSize",
    "VertexStyle",
    "VertexTextureCoordinates",
    "VertexWeight",
    "VertexWeightedGraphQ",
    "Vertical",
    "VerticalBar",
    "VerticalForm",
    "VerticalGauge",
    "VerticalSeparator",
    "VerticalSlider",
    "VerticalTilde",
    "Video",
    "VideoEncoding",
    "VideoExtractFrames",
    "VideoFrameList",
    "VideoFrameMap",
    "VideoPause",
    "VideoPlay",
    "VideoQ",
    "VideoStop",
    "VideoStream",
    "VideoStreams",
    "VideoTimeSeries",
    "VideoTracks",
    "VideoTrim",
    "ViewAngle",
    "ViewCenter",
    "ViewMatrix",
    "ViewPoint",
    "ViewPointSelectorSettings",
    "ViewPort",
    "ViewProjection",
    "ViewRange",
    "ViewVector",
    "ViewVertical",
    "VirtualGroupData",
    "Visible",
    "VisibleCell",
    "VoiceStyleData",
    "VoigtDistribution",
    "VolcanoData",
    "Volume",
    "VonMisesDistribution",
    "VoronoiMesh",
    "WaitAll",
    "WaitAsynchronousTask",
    "WaitNext",
    "WaitUntil",
    "WakebyDistribution",
    "WalleniusHypergeometricDistribution",
    "WaringYuleDistribution",
    "WarpingCorrespondence",
    "WarpingDistance",
    "WatershedComponents",
    "WatsonUSquareTest",
    "WattsStrogatzGraphDistribution",
    "WaveletBestBasis",
    "WaveletFilterCoefficients",
    "WaveletImagePlot",
    "WaveletListPlot",
    "WaveletMapIndexed",
    "WaveletMatrixPlot",
    "WaveletPhi",
    "WaveletPsi",
    "WaveletScale",
    "WaveletScalogram",
    "WaveletThreshold",
    "WeaklyConnectedComponents",
    "WeaklyConnectedGraphComponents",
    "WeaklyConnectedGraphQ",
    "WeakStationarity",
    "WeatherData",
    "WeatherForecastData",
    "WebAudioSearch",
    "WebElementObject",
    "WeberE",
    "WebExecute",
    "WebImage",
    "WebImageSearch",
    "WebSearch",
    "WebSessionObject",
    "WebSessions",
    "WebWindowObject",
    "Wedge",
    "Wednesday",
    "WeibullDistribution",
    "WeierstrassE1",
    "WeierstrassE2",
    "WeierstrassE3",
    "WeierstrassEta1",
    "WeierstrassEta2",
    "WeierstrassEta3",
    "WeierstrassHalfPeriods",
    "WeierstrassHalfPeriodW1",
    "WeierstrassHalfPeriodW2",
    "WeierstrassHalfPeriodW3",
    "WeierstrassInvariantG2",
    "WeierstrassInvariantG3",
    "WeierstrassInvariants",
    "WeierstrassP",
    "WeierstrassPPrime",
    "WeierstrassSigma",
    "WeierstrassZeta",
    "WeightedAdjacencyGraph",
    "WeightedAdjacencyMatrix",
    "WeightedData",
    "WeightedGraphQ",
    "Weights",
    "WelchWindow",
    "WheelGraph",
    "WhenEvent",
    "Which",
    "While",
    "White",
    "WhiteNoiseProcess",
    "WhitePoint",
    "Whitespace",
    "WhitespaceCharacter",
    "WhittakerM",
    "WhittakerW",
    "WienerFilter",
    "WienerProcess",
    "WignerD",
    "WignerSemicircleDistribution",
    "WikidataData",
    "WikidataSearch",
    "WikipediaData",
    "WikipediaSearch",
    "WilksW",
    "WilksWTest",
    "WindDirectionData",
    "WindingCount",
    "WindingPolygon",
    "WindowClickSelect",
    "WindowElements",
    "WindowFloating",
    "WindowFrame",
    "WindowFrameElements",
    "WindowMargins",
    "WindowMovable",
    "WindowOpacity",
    "WindowPersistentStyles",
    "WindowSelected",
    "WindowSize",
    "WindowStatusArea",
    "WindowTitle",
    "WindowToolbars",
    "WindowWidth",
    "WindSpeedData",
    "WindVectorData",
    "WinsorizedMean",
    "WinsorizedVariance",
    "WishartMatrixDistribution",
    "With",
    "WolframAlpha",
    "WolframAlphaDate",
    "WolframAlphaQuantity",
    "WolframAlphaResult",
    "WolframLanguageData",
    "Word",
    "WordBoundary",
    "WordCharacter",
    "WordCloud",
    "WordCount",
    "WordCounts",
    "WordData",
    "WordDefinition",
    "WordFrequency",
    "WordFrequencyData",
    "WordList",
    "WordOrientation",
    "WordSearch",
    "WordSelectionFunction",
    "WordSeparators",
    "WordSpacings",
    "WordStem",
    "WordTranslation",
    "WorkingPrecision",
    "WrapAround",
    "Write",
    "WriteLine",
    "WriteString",
    "Wronskian",
    "XMLElement",
    "XMLObject",
    "XMLTemplate",
    "Xnor",
    "Xor",
    "XYZColor",
    "Yellow",
    "Yesterday",
    "YuleDissimilarity",
    "ZernikeR",
    "ZeroSymmetric",
    "ZeroTest",
    "ZeroWidthTimes",
    "Zeta",
    "ZetaZero",
    "ZIPCodeData",
    "ZipfDistribution",
    "ZoomCenter",
    "ZoomFactor",
    "ZTest",
    "ZTransform",
    "$Aborted",
    "$ActivationGroupID",
    "$ActivationKey",
    "$ActivationUserRegistered",
    "$AddOnsDirectory",
    "$AllowDataUpdates",
    "$AllowExternalChannelFunctions",
    "$AllowInternet",
    "$AssertFunction",
    "$Assumptions",
    "$AsynchronousTask",
    "$AudioDecoders",
    "$AudioEncoders",
    "$AudioInputDevices",
    "$AudioOutputDevices",
    "$BaseDirectory",
    "$BasePacletsDirectory",
    "$BatchInput",
    "$BatchOutput",
    "$BlockchainBase",
    "$BoxForms",
    "$ByteOrdering",
    "$CacheBaseDirectory",
    "$Canceled",
    "$ChannelBase",
    "$CharacterEncoding",
    "$CharacterEncodings",
    "$CloudAccountName",
    "$CloudBase",
    "$CloudConnected",
    "$CloudConnection",
    "$CloudCreditsAvailable",
    "$CloudEvaluation",
    "$CloudExpressionBase",
    "$CloudObjectNameFormat",
    "$CloudObjectURLType",
    "$CloudRootDirectory",
    "$CloudSymbolBase",
    "$CloudUserID",
    "$CloudUserUUID",
    "$CloudVersion",
    "$CloudVersionNumber",
    "$CloudWolframEngineVersionNumber",
    "$CommandLine",
    "$CompilationTarget",
    "$ConditionHold",
    "$ConfiguredKernels",
    "$Context",
    "$ContextPath",
    "$ControlActiveSetting",
    "$Cookies",
    "$CookieStore",
    "$CreationDate",
    "$CurrentLink",
    "$CurrentTask",
    "$CurrentWebSession",
    "$DataStructures",
    "$DateStringFormat",
    "$DefaultAudioInputDevice",
    "$DefaultAudioOutputDevice",
    "$DefaultFont",
    "$DefaultFrontEnd",
    "$DefaultImagingDevice",
    "$DefaultLocalBase",
    "$DefaultMailbox",
    "$DefaultNetworkInterface",
    "$DefaultPath",
    "$DefaultProxyRules",
    "$DefaultSystemCredentialStore",
    "$Display",
    "$DisplayFunction",
    "$DistributedContexts",
    "$DynamicEvaluation",
    "$Echo",
    "$EmbedCodeEnvironments",
    "$EmbeddableServices",
    "$EntityStores",
    "$Epilog",
    "$EvaluationCloudBase",
    "$EvaluationCloudObject",
    "$EvaluationEnvironment",
    "$ExportFormats",
    "$ExternalIdentifierTypes",
    "$ExternalStorageBase",
    "$Failed",
    "$FinancialDataSource",
    "$FontFamilies",
    "$FormatType",
    "$FrontEnd",
    "$FrontEndSession",
    "$GeoEntityTypes",
    "$GeoLocation",
    "$GeoLocationCity",
    "$GeoLocationCountry",
    "$GeoLocationPrecision",
    "$GeoLocationSource",
    "$HistoryLength",
    "$HomeDirectory",
    "$HTMLExportRules",
    "$HTTPCookies",
    "$HTTPRequest",
    "$IgnoreEOF",
    "$ImageFormattingWidth",
    "$ImageResolution",
    "$ImagingDevice",
    "$ImagingDevices",
    "$ImportFormats",
    "$IncomingMailSettings",
    "$InitialDirectory",
    "$Initialization",
    "$InitializationContexts",
    "$Input",
    "$InputFileName",
    "$InputStreamMethods",
    "$Inspector",
    "$InstallationDate",
    "$InstallationDirectory",
    "$InterfaceEnvironment",
    "$InterpreterTypes",
    "$IterationLimit",
    "$KernelCount",
    "$KernelID",
    "$Language",
    "$LaunchDirectory",
    "$LibraryPath",
    "$LicenseExpirationDate",
    "$LicenseID",
    "$LicenseProcesses",
    "$LicenseServer",
    "$LicenseSubprocesses",
    "$LicenseType",
    "$Line",
    "$Linked",
    "$LinkSupported",
    "$LoadedFiles",
    "$LocalBase",
    "$LocalSymbolBase",
    "$MachineAddresses",
    "$MachineDomain",
    "$MachineDomains",
    "$MachineEpsilon",
    "$MachineID",
    "$MachineName",
    "$MachinePrecision",
    "$MachineType",
    "$MaxExtraPrecision",
    "$MaxLicenseProcesses",
    "$MaxLicenseSubprocesses",
    "$MaxMachineNumber",
    "$MaxNumber",
    "$MaxPiecewiseCases",
    "$MaxPrecision",
    "$MaxRootDegree",
    "$MessageGroups",
    "$MessageList",
    "$MessagePrePrint",
    "$Messages",
    "$MinMachineNumber",
    "$MinNumber",
    "$MinorReleaseNumber",
    "$MinPrecision",
    "$MobilePhone",
    "$ModuleNumber",
    "$NetworkConnected",
    "$NetworkInterfaces",
    "$NetworkLicense",
    "$NewMessage",
    "$NewSymbol",
    "$NotebookInlineStorageLimit",
    "$Notebooks",
    "$NoValue",
    "$NumberMarks",
    "$Off",
    "$OperatingSystem",
    "$Output",
    "$OutputForms",
    "$OutputSizeLimit",
    "$OutputStreamMethods",
    "$Packages",
    "$ParentLink",
    "$ParentProcessID",
    "$PasswordFile",
    "$PatchLevelID",
    "$Path",
    "$PathnameSeparator",
    "$PerformanceGoal",
    "$Permissions",
    "$PermissionsGroupBase",
    "$PersistenceBase",
    "$PersistencePath",
    "$PipeSupported",
    "$PlotTheme",
    "$Post",
    "$Pre",
    "$PreferencesDirectory",
    "$PreInitialization",
    "$PrePrint",
    "$PreRead",
    "$PrintForms",
    "$PrintLiteral",
    "$Printout3DPreviewer",
    "$ProcessID",
    "$ProcessorCount",
    "$ProcessorType",
    "$ProductInformation",
    "$ProgramName",
    "$PublisherID",
    "$RandomState",
    "$RecursionLimit",
    "$RegisteredDeviceClasses",
    "$RegisteredUserName",
    "$ReleaseNumber",
    "$RequesterAddress",
    "$RequesterWolframID",
    "$RequesterWolframUUID",
    "$RootDirectory",
    "$ScheduledTask",
    "$ScriptCommandLine",
    "$ScriptInputString",
    "$SecuredAuthenticationKeyTokens",
    "$ServiceCreditsAvailable",
    "$Services",
    "$SessionID",
    "$SetParentLink",
    "$SharedFunctions",
    "$SharedVariables",
    "$SoundDisplay",
    "$SoundDisplayFunction",
    "$SourceLink",
    "$SSHAuthentication",
    "$SubtitleDecoders",
    "$SubtitleEncoders",
    "$SummaryBoxDataSizeLimit",
    "$SuppressInputFormHeads",
    "$SynchronousEvaluation",
    "$SyntaxHandler",
    "$System",
    "$SystemCharacterEncoding",
    "$SystemCredentialStore",
    "$SystemID",
    "$SystemMemory",
    "$SystemShell",
    "$SystemTimeZone",
    "$SystemWordLength",
    "$TemplatePath",
    "$TemporaryDirectory",
    "$TemporaryPrefix",
    "$TestFileName",
    "$TextStyle",
    "$TimedOut",
    "$TimeUnit",
    "$TimeZone",
    "$TimeZoneEntity",
    "$TopDirectory",
    "$TraceOff",
    "$TraceOn",
    "$TracePattern",
    "$TracePostAction",
    "$TracePreAction",
    "$UnitSystem",
    "$Urgent",
    "$UserAddOnsDirectory",
    "$UserAgentLanguages",
    "$UserAgentMachine",
    "$UserAgentName",
    "$UserAgentOperatingSystem",
    "$UserAgentString",
    "$UserAgentVersion",
    "$UserBaseDirectory",
    "$UserBasePacletsDirectory",
    "$UserDocumentsDirectory",
    "$Username",
    "$UserName",
    "$UserURLBase",
    "$Version",
    "$VersionNumber",
    "$VideoDecoders",
    "$VideoEncoders",
    "$VoiceStyles",
    "$WolframDocumentsDirectory",
    "$WolframID",
    "$WolframUUID"
];
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $6b7583d952c27b16$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $6b7583d952c27b16$var$optional(re) {
    return $6b7583d952c27b16$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $6b7583d952c27b16$var$concat(...args) {
    const joined = args.map((x)=>$6b7583d952c27b16$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $6b7583d952c27b16$var$either(...args) {
    const joined = "(" + args.map((x)=>$6b7583d952c27b16$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: Wolfram Language
Description: The Wolfram Language is the programming language used in Wolfram Mathematica, a modern technical computing system spanning most areas of technical computing.
Authors: Patrick Scheibe <patrick@halirutan.de>, Robert Jacobson <robertjacobson@acm.org>
Website: https://www.wolfram.com/mathematica/
Category: scientific
*/ /** @type LanguageFn */ function $6b7583d952c27b16$var$mathematica(hljs) {
    /*
  This rather scary looking matching of Mathematica numbers is carefully explained by Robert Jacobson here:
  https://wltools.github.io/LanguageSpec/Specification/Syntax/Number-representations/
   */ const BASE_RE = /([2-9]|[1-2]\d|[3][0-5])\^\^/;
    const BASE_DIGITS_RE = /(\w*\.\w+|\w+\.\w*|\w+)/;
    const NUMBER_RE = /(\d*\.\d+|\d+\.\d*|\d+)/;
    const BASE_NUMBER_RE = $6b7583d952c27b16$var$either($6b7583d952c27b16$var$concat(BASE_RE, BASE_DIGITS_RE), NUMBER_RE);
    const ACCURACY_RE = /``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/;
    const PRECISION_RE = /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/;
    const APPROXIMATE_NUMBER_RE = $6b7583d952c27b16$var$either(ACCURACY_RE, PRECISION_RE);
    const SCIENTIFIC_NOTATION_RE = /\*\^[+-]?\d+/;
    const MATHEMATICA_NUMBER_RE = $6b7583d952c27b16$var$concat(BASE_NUMBER_RE, $6b7583d952c27b16$var$optional(APPROXIMATE_NUMBER_RE), $6b7583d952c27b16$var$optional(SCIENTIFIC_NOTATION_RE));
    const NUMBERS = {
        className: "number",
        relevance: 0,
        begin: MATHEMATICA_NUMBER_RE
    };
    const SYMBOL_RE = /[a-zA-Z$][a-zA-Z0-9$]*/;
    const SYSTEM_SYMBOLS_SET = new Set($6b7583d952c27b16$var$SYSTEM_SYMBOLS);
    /** @type {Mode} */ const SYMBOLS = {
        variants: [
            {
                className: "builtin-symbol",
                begin: SYMBOL_RE,
                // for performance out of fear of regex.either(...Mathematica.SYSTEM_SYMBOLS)
                "on:begin": (match, response)=>{
                    if (!SYSTEM_SYMBOLS_SET.has(match[0])) response.ignoreMatch();
                }
            },
            {
                className: "symbol",
                relevance: 0,
                begin: SYMBOL_RE
            }
        ]
    };
    const NAMED_CHARACTER = {
        className: "named-character",
        begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
    };
    const OPERATORS = {
        className: "operator",
        relevance: 0,
        begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
    };
    const PATTERNS = {
        className: "pattern",
        relevance: 0,
        begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
    };
    const SLOTS = {
        className: "slot",
        relevance: 0,
        begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
    };
    const BRACES = {
        className: "brace",
        relevance: 0,
        begin: /[[\](){}]/
    };
    const MESSAGES = {
        className: "message-name",
        relevance: 0,
        begin: $6b7583d952c27b16$var$concat("::", SYMBOL_RE)
    };
    return {
        name: "Mathematica",
        aliases: [
            "mma",
            "wl"
        ],
        classNameAliases: {
            brace: "punctuation",
            pattern: "type",
            slot: "type",
            symbol: "variable",
            "named-character": "variable",
            "builtin-symbol": "built_in",
            "message-name": "string"
        },
        contains: [
            hljs.COMMENT(/\(\*/, /\*\)/, {
                contains: [
                    "self"
                ]
            }),
            PATTERNS,
            SLOTS,
            MESSAGES,
            SYMBOLS,
            NAMED_CHARACTER,
            hljs.QUOTE_STRING_MODE,
            NUMBERS,
            OPERATORS,
            BRACES
        ]
    };
}
module.exports = $6b7583d952c27b16$var$mathematica;

});

parcelRegister("2DX6A", function(module, exports) {
/*
Language: Matlab
Author: Denis Bardadym <bardadymchik@gmail.com>
Contributors: Eugene Nizhibitsky <nizhibitsky@ya.ru>, Egor Rogov <e.rogov@postgrespro.ru>
Website: https://www.mathworks.com/products/matlab.html
Category: scientific
*/ /*
  Formal syntax is not published, helpful link:
  https://github.com/kornilova-l/matlab-IntelliJ-plugin/blob/master/src/main/grammar/Matlab.bnf
*/ function $1ecd125dc9bf2ae0$var$matlab(hljs) {
    var TRANSPOSE_RE = "('|\\.')+";
    var TRANSPOSE = {
        relevance: 0,
        contains: [
            {
                begin: TRANSPOSE_RE
            }
        ]
    };
    return {
        name: "Matlab",
        keywords: {
            keyword: "arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while",
            built_in: "sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "
        },
        illegal: '(//|"|#|/\\*|\\s+/\\w+)',
        contains: [
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        variants: [
                            {
                                begin: "\\(",
                                end: "\\)"
                            },
                            {
                                begin: "\\[",
                                end: "\\]"
                            }
                        ]
                    }
                ]
            },
            {
                className: "built_in",
                begin: /true|false/,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                begin: "[a-zA-Z][a-zA-Z_0-9]*" + TRANSPOSE_RE,
                relevance: 0
            },
            {
                className: "number",
                begin: hljs.C_NUMBER_RE,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        begin: "''"
                    }
                ]
            },
            {
                begin: /\]|\}|\)/,
                relevance: 0,
                starts: TRANSPOSE
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        begin: '""'
                    }
                ],
                starts: TRANSPOSE
            },
            hljs.COMMENT("^\\s*%\\{\\s*$", "^\\s*%\\}\\s*$"),
            hljs.COMMENT("%", "$")
        ]
    };
}
module.exports = $1ecd125dc9bf2ae0$var$matlab;

});

parcelRegister("aUT8O", function(module, exports) {
/*
Language: Maxima
Author: Robert Dodier <robert.dodier@gmail.com>
Website: http://maxima.sourceforge.net
Category: scientific
*/ function $7f29e8361c8e8a04$var$maxima(hljs) {
    const KEYWORDS = "if then else elseif for thru do while unless step in and or not";
    const LITERALS = "true false unknown inf minf ind und %e %i %pi %phi %gamma";
    const BUILTIN_FUNCTIONS = " abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest";
    const SYMBOLS = "_ __ %|0 %%|0";
    return {
        name: "Maxima",
        keywords: {
            $pattern: "[A-Za-z_%][0-9A-Za-z_%]*",
            keyword: KEYWORDS,
            literal: LITERALS,
            built_in: BUILTIN_FUNCTIONS,
            symbol: SYMBOLS
        },
        contains: [
            {
                className: "comment",
                begin: "/\\*",
                end: "\\*/",
                contains: [
                    "self"
                ]
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                relevance: 0,
                variants: [
                    {
                        // float number w/ exponent
                        // hmm, I wonder if we ought to include other exponent markers?
                        begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b"
                    },
                    {
                        // bigfloat number
                        begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b",
                        relevance: 10
                    },
                    {
                        // float number w/out exponent
                        // Doesn't seem to recognize floats which start with '.'
                        begin: "\\b(\\.\\d+|\\d+\\.\\d+)\\b"
                    },
                    {
                        // integer in base up to 36
                        // Doesn't seem to recognize integers which end with '.'
                        begin: "\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b"
                    }
                ]
            }
        ],
        illegal: /@/
    };
}
module.exports = $7f29e8361c8e8a04$var$maxima;

});

parcelRegister("z4A3a", function(module, exports) {
/*
Language: MEL
Description: Maya Embedded Language
Author: Shuen-Huei Guan <drake.guan@gmail.com>
Website: http://www.autodesk.com/products/autodesk-maya/overview
Category: graphics
*/ function $0696d294ee35067c$var$mel(hljs) {
    return {
        name: "MEL",
        keywords: "int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",
        illegal: "</",
        contains: [
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
}
module.exports = $0696d294ee35067c$var$mel;

});

parcelRegister("jU8Uv", function(module, exports) {
/*
Language: Mercury
Author: mucaho <mkucko@gmail.com>
Description: Mercury is a logic/functional programming language which combines the clarity and expressiveness of declarative programming with advanced static analysis and error detection features.
Website: https://www.mercurylang.org
*/ function $e7da28ad9d36e063$var$mercury(hljs) {
    const KEYWORDS = {
        keyword: "module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",
        meta: // pragma
        "inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing",
        built_in: "some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"
    };
    const COMMENT = hljs.COMMENT("%", "$");
    const NUMCODE = {
        className: "number",
        begin: "0'.\\|0[box][0-9a-fA-F]*"
    };
    const ATOM = hljs.inherit(hljs.APOS_STRING_MODE, {
        relevance: 0
    });
    const STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        relevance: 0
    });
    const STRING_FMT = {
        className: "subst",
        begin: "\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",
        relevance: 0
    };
    STRING.contains = STRING.contains.slice(); // we need our own copy of contains
    STRING.contains.push(STRING_FMT);
    const IMPLICATION = {
        className: "built_in",
        variants: [
            {
                begin: "<=>"
            },
            {
                begin: "<=",
                relevance: 0
            },
            {
                begin: "=>",
                relevance: 0
            },
            {
                begin: "/\\\\"
            },
            {
                begin: "\\\\/"
            }
        ]
    };
    const HEAD_BODY_CONJUNCTION = {
        className: "built_in",
        variants: [
            {
                begin: ":-\\|-->"
            },
            {
                begin: "=",
                relevance: 0
            }
        ]
    };
    return {
        name: "Mercury",
        aliases: [
            "m",
            "moo"
        ],
        keywords: KEYWORDS,
        contains: [
            IMPLICATION,
            HEAD_BODY_CONJUNCTION,
            COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMCODE,
            hljs.NUMBER_MODE,
            ATOM,
            STRING,
            {
                begin: /:-/
            },
            {
                begin: /\.$/
            }
        ]
    };
}
module.exports = $e7da28ad9d36e063$var$mercury;

});

parcelRegister("bwGfp", function(module, exports) {
/*
Language: MIPS Assembly
Author: Nebuleon Fumika <nebuleon.fumika@gmail.com>
Description: MIPS Assembly (up to MIPS32R2)
Website: https://en.wikipedia.org/wiki/MIPS_architecture
Category: assembler
*/ function $86437457dd961fcf$var$mipsasm(hljs) {
    // local labels: %?[FB]?[AT]?\d{1,2}\w+
    return {
        name: "MIPS Assembly",
        case_insensitive: true,
        aliases: [
            "mips"
        ],
        keywords: {
            $pattern: "\\.?" + hljs.IDENT_RE,
            meta: // GNU preprocs
            ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ",
            built_in: "$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt " // Coprocessor 0 registers
        },
        contains: [
            {
                className: "keyword",
                begin: "\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",
                end: "\\s"
            },
            // lines ending with ; or # aren't really comments, probably auto-detect fail
            hljs.COMMENT("[;#](?!\\s*$)", "$"),
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "[^\\\\]'",
                relevance: 0
            },
            {
                className: "title",
                begin: "\\|",
                end: "\\|",
                illegal: "\\n",
                relevance: 0
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "0x[0-9a-f]+"
                    },
                    {
                        begin: "\\b-?\\d+"
                    }
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                    },
                    {
                        begin: "^\\s*[0-9]+:"
                    },
                    {
                        begin: "[0-9]+[bf]"
                    }
                ],
                relevance: 0
            }
        ],
        // forward slashes are not allowed
        illegal: /\//
    };
}
module.exports = $86437457dd961fcf$var$mipsasm;

});

parcelRegister("fQkZ1", function(module, exports) {
/*
Language: Mizar
Description: The Mizar Language is a formal language derived from the mathematical vernacular.
Author: Kelley van Evert <kelleyvanevert@gmail.com>
Website: http://mizar.org/language/
Category: scientific
*/ function $b88bfd2d62c842d4$var$mizar(hljs) {
    return {
        name: "Mizar",
        keywords: "environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",
        contains: [
            hljs.COMMENT("::", "$")
        ]
    };
}
module.exports = $b88bfd2d62c842d4$var$mizar;

});

parcelRegister("8MPLA", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $665af62a3756aaa3$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $665af62a3756aaa3$var$concat(...args) {
    const joined = args.map((x)=>$665af62a3756aaa3$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $665af62a3756aaa3$var$either(...args) {
    const joined = "(" + args.map((x)=>$665af62a3756aaa3$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: Perl
Author: Peter Leonov <gojpeg@yandex.ru>
Website: https://www.perl.org
Category: common
*/ /** @type LanguageFn */ function $665af62a3756aaa3$var$perl(hljs) {
    const KEYWORDS = [
        "abs",
        "accept",
        "alarm",
        "and",
        "atan2",
        "bind",
        "binmode",
        "bless",
        "break",
        "caller",
        "chdir",
        "chmod",
        "chomp",
        "chop",
        "chown",
        "chr",
        "chroot",
        "close",
        "closedir",
        "connect",
        "continue",
        "cos",
        "crypt",
        "dbmclose",
        "dbmopen",
        "defined",
        "delete",
        "die",
        "do",
        "dump",
        "each",
        "else",
        "elsif",
        "endgrent",
        "endhostent",
        "endnetent",
        "endprotoent",
        "endpwent",
        "endservent",
        "eof",
        "eval",
        "exec",
        "exists",
        "exit",
        "exp",
        "fcntl",
        "fileno",
        "flock",
        "for",
        "foreach",
        "fork",
        "format",
        "formline",
        "getc",
        "getgrent",
        "getgrgid",
        "getgrnam",
        "gethostbyaddr",
        "gethostbyname",
        "gethostent",
        "getlogin",
        "getnetbyaddr",
        "getnetbyname",
        "getnetent",
        "getpeername",
        "getpgrp",
        "getpriority",
        "getprotobyname",
        "getprotobynumber",
        "getprotoent",
        "getpwent",
        "getpwnam",
        "getpwuid",
        "getservbyname",
        "getservbyport",
        "getservent",
        "getsockname",
        "getsockopt",
        "given",
        "glob",
        "gmtime",
        "goto",
        "grep",
        "gt",
        "hex",
        "if",
        "index",
        "int",
        "ioctl",
        "join",
        "keys",
        "kill",
        "last",
        "lc",
        "lcfirst",
        "length",
        "link",
        "listen",
        "local",
        "localtime",
        "log",
        "lstat",
        "lt",
        "ma",
        "map",
        "mkdir",
        "msgctl",
        "msgget",
        "msgrcv",
        "msgsnd",
        "my",
        "ne",
        "next",
        "no",
        "not",
        "oct",
        "open",
        "opendir",
        "or",
        "ord",
        "our",
        "pack",
        "package",
        "pipe",
        "pop",
        "pos",
        "print",
        "printf",
        "prototype",
        "push",
        "q|0",
        "qq",
        "quotemeta",
        "qw",
        "qx",
        "rand",
        "read",
        "readdir",
        "readline",
        "readlink",
        "readpipe",
        "recv",
        "redo",
        "ref",
        "rename",
        "require",
        "reset",
        "return",
        "reverse",
        "rewinddir",
        "rindex",
        "rmdir",
        "say",
        "scalar",
        "seek",
        "seekdir",
        "select",
        "semctl",
        "semget",
        "semop",
        "send",
        "setgrent",
        "sethostent",
        "setnetent",
        "setpgrp",
        "setpriority",
        "setprotoent",
        "setpwent",
        "setservent",
        "setsockopt",
        "shift",
        "shmctl",
        "shmget",
        "shmread",
        "shmwrite",
        "shutdown",
        "sin",
        "sleep",
        "socket",
        "socketpair",
        "sort",
        "splice",
        "split",
        "sprintf",
        "sqrt",
        "srand",
        "stat",
        "state",
        "study",
        "sub",
        "substr",
        "symlink",
        "syscall",
        "sysopen",
        "sysread",
        "sysseek",
        "system",
        "syswrite",
        "tell",
        "telldir",
        "tie",
        "tied",
        "time",
        "times",
        "tr",
        "truncate",
        "uc",
        "ucfirst",
        "umask",
        "undef",
        "unless",
        "unlink",
        "unpack",
        "unshift",
        "untie",
        "until",
        "use",
        "utime",
        "values",
        "vec",
        "wait",
        "waitpid",
        "wantarray",
        "warn",
        "when",
        "while",
        "write",
        "x|0",
        "xor",
        "y|0"
    ];
    // https://perldoc.perl.org/perlre#Modifiers
    const REGEX_MODIFIERS = /[dualxmsipngr]{0,12}/; // aa and xx are valid, making max length 12
    const PERL_KEYWORDS = {
        $pattern: /[\w.]+/,
        keyword: KEYWORDS.join(" ")
    };
    const SUBST = {
        className: "subst",
        begin: "[$@]\\{",
        end: "\\}",
        keywords: PERL_KEYWORDS
    };
    const METHOD = {
        begin: /->\{/,
        end: /\}/
    };
    const VAR = {
        variants: [
            {
                begin: /\$\d/
            },
            {
                begin: $665af62a3756aaa3$var$concat(/[$%@](\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/, // negative look-ahead tries to avoid matching patterns that are not
                // Perl at all like $ident$, @ident@, etc.
                `(?![A-Za-z])(?![@$%])`)
            },
            {
                begin: /[$%@][^\s\w{]/,
                relevance: 0
            }
        ]
    };
    const STRING_CONTAINS = [
        hljs.BACKSLASH_ESCAPE,
        SUBST,
        VAR
    ];
    const REGEX_DELIMS = [
        /!/,
        /\//,
        /\|/,
        /\?/,
        /'/,
        /"/,
        /#/ // valid but infrequent and weird
    ];
    /**
   * @param {string|RegExp} prefix
   * @param {string|RegExp} open
   * @param {string|RegExp} close
   */ const PAIRED_DOUBLE_RE = (prefix, open, close = "\\1")=>{
        const middle = close === "\\1" ? close : $665af62a3756aaa3$var$concat(close, open);
        return $665af62a3756aaa3$var$concat($665af62a3756aaa3$var$concat("(?:", prefix, ")"), open, /(?:\\.|[^\\\/])*?/, middle, /(?:\\.|[^\\\/])*?/, close, REGEX_MODIFIERS);
    };
    /**
   * @param {string|RegExp} prefix
   * @param {string|RegExp} open
   * @param {string|RegExp} close
   */ const PAIRED_RE = (prefix, open, close)=>{
        return $665af62a3756aaa3$var$concat($665af62a3756aaa3$var$concat("(?:", prefix, ")"), open, /(?:\\.|[^\\\/])*?/, close, REGEX_MODIFIERS);
    };
    const PERL_DEFAULT_CONTAINS = [
        VAR,
        hljs.HASH_COMMENT_MODE,
        hljs.COMMENT(/^=\w/, /=cut/, {
            endsWithParent: true
        }),
        METHOD,
        {
            className: "string",
            contains: STRING_CONTAINS,
            variants: [
                {
                    begin: "q[qwxr]?\\s*\\(",
                    end: "\\)",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\[",
                    end: "\\]",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\{",
                    end: "\\}",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*\\|",
                    end: "\\|",
                    relevance: 5
                },
                {
                    begin: "q[qwxr]?\\s*<",
                    end: ">",
                    relevance: 5
                },
                {
                    begin: "qw\\s+q",
                    end: "q",
                    relevance: 5
                },
                {
                    begin: "'",
                    end: "'",
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: '"',
                    end: '"'
                },
                {
                    begin: "`",
                    end: "`",
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /\{\w+\}/,
                    relevance: 0
                },
                {
                    begin: "-?\\w+\\s*=>",
                    relevance: 0
                }
            ]
        },
        {
            className: "number",
            begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
            relevance: 0
        },
        {
            begin: "(\\/\\/|" + hljs.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
            keywords: "split return print reverse grep",
            relevance: 0,
            contains: [
                hljs.HASH_COMMENT_MODE,
                {
                    className: "regexp",
                    variants: [
                        // allow matching common delimiters
                        {
                            begin: PAIRED_DOUBLE_RE("s|tr|y", $665af62a3756aaa3$var$either(...REGEX_DELIMS))
                        },
                        // and then paired delmis
                        {
                            begin: PAIRED_DOUBLE_RE("s|tr|y", "\\(", "\\)")
                        },
                        {
                            begin: PAIRED_DOUBLE_RE("s|tr|y", "\\[", "\\]")
                        },
                        {
                            begin: PAIRED_DOUBLE_RE("s|tr|y", "\\{", "\\}")
                        }
                    ],
                    relevance: 2
                },
                {
                    className: "regexp",
                    variants: [
                        {
                            // could be a comment in many languages so do not count
                            // as relevant
                            begin: /(m|qr)\/\//,
                            relevance: 0
                        },
                        // prefix is optional with /regex/
                        {
                            begin: PAIRED_RE("(?:m|qr)?", /\//, /\//)
                        },
                        // allow matching common delimiters
                        {
                            begin: PAIRED_RE("m|qr", $665af62a3756aaa3$var$either(...REGEX_DELIMS), /\1/)
                        },
                        // allow common paired delmins
                        {
                            begin: PAIRED_RE("m|qr", /\(/, /\)/)
                        },
                        {
                            begin: PAIRED_RE("m|qr", /\[/, /\]/)
                        },
                        {
                            begin: PAIRED_RE("m|qr", /\{/, /\}/)
                        }
                    ]
                }
            ]
        },
        {
            className: "function",
            beginKeywords: "sub",
            end: "(\\s*\\(.*?\\))?[;{]",
            excludeEnd: true,
            relevance: 5,
            contains: [
                hljs.TITLE_MODE
            ]
        },
        {
            begin: "-\\w\\b",
            relevance: 0
        },
        {
            begin: "^__DATA__$",
            end: "^__END__$",
            subLanguage: "mojolicious",
            contains: [
                {
                    begin: "^@@.*",
                    end: "$",
                    className: "comment"
                }
            ]
        }
    ];
    SUBST.contains = PERL_DEFAULT_CONTAINS;
    METHOD.contains = PERL_DEFAULT_CONTAINS;
    return {
        name: "Perl",
        aliases: [
            "pl",
            "pm"
        ],
        keywords: PERL_KEYWORDS,
        contains: PERL_DEFAULT_CONTAINS
    };
}
module.exports = $665af62a3756aaa3$var$perl;

});

parcelRegister("fkIyq", function(module, exports) {
/*
Language: Mojolicious
Requires: xml.js, perl.js
Author: Dotan Dimet <dotan@corky.net>
Description: Mojolicious .ep (Embedded Perl) templates
Website: https://mojolicious.org
Category: template
*/ function $b29b48d3291e36c6$var$mojolicious(hljs) {
    return {
        name: "Mojolicious",
        subLanguage: "xml",
        contains: [
            {
                className: "meta",
                begin: "^__(END|DATA)__$"
            },
            // mojolicious line
            {
                begin: "^\\s*%{1,2}={0,2}",
                end: "$",
                subLanguage: "perl"
            },
            // mojolicious block
            {
                begin: "<%{1,2}={0,2}",
                end: "={0,1}%>",
                subLanguage: "perl",
                excludeBegin: true,
                excludeEnd: true
            }
        ]
    };
}
module.exports = $b29b48d3291e36c6$var$mojolicious;

});

parcelRegister("adFFh", function(module, exports) {
/*
Language: Monkey
Description: Monkey2 is an easy to use, cross platform, games oriented programming language from Blitz Research.
Author: Arthur Bikmullin <devolonter@gmail.com>
Website: https://blitzresearch.itch.io/monkey2
*/ function $770b700726b79f66$var$monkey(hljs) {
    const NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: "[$][a-fA-F0-9]+"
            },
            hljs.NUMBER_MODE
        ]
    };
    return {
        name: "Monkey",
        case_insensitive: true,
        keywords: {
            keyword: "public private property continue exit extern new try catch eachin not abstract final select case default const local global field end if then else elseif endif while wend repeat until forever for to step next return module inline throw import",
            built_in: "DebugLog DebugStop Error Print ACos ACosr ASin ASinr ATan ATan2 ATan2r ATanr Abs Abs Ceil Clamp Clamp Cos Cosr Exp Floor Log Max Max Min Min Pow Sgn Sgn Sin Sinr Sqrt Tan Tanr Seed PI HALFPI TWOPI",
            literal: "true false null and or shl shr mod"
        },
        illegal: /\/\*/,
        contains: [
            hljs.COMMENT("#rem", "#end"),
            hljs.COMMENT("'", "$", {
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "function method",
                end: "[(=:]|$",
                illegal: /\n/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: "$",
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "built_in",
                begin: "\\b(self|super)\\b"
            },
            {
                className: "meta",
                begin: "\\s*#",
                end: "$",
                keywords: {
                    "meta-keyword": "if else elseif endif end then"
                }
            },
            {
                className: "meta",
                begin: "^\\s*strict\\b"
            },
            {
                beginKeywords: "alias",
                end: "=",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.QUOTE_STRING_MODE,
            NUMBER
        ]
    };
}
module.exports = $770b700726b79f66$var$monkey;

});

parcelRegister("6QlzV", function(module, exports) {
/*
Language: MoonScript
Author: Billy Quith <chinbillybilbo@gmail.com>
Description: MoonScript is a programming language that transcompiles to Lua.
Origin: coffeescript.js
Website: http://moonscript.org/
Category: scripting
*/ function $4fb8566b23d1a6f4$var$moonscript(hljs) {
    const KEYWORDS = {
        keyword: // Moonscript keywords
        "if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using",
        literal: "true false nil",
        built_in: "_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"
    };
    const JS_IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
    const SUBST = {
        className: "subst",
        begin: /#\{/,
        end: /\}/,
        keywords: KEYWORDS
    };
    const EXPRESSIONS = [
        hljs.inherit(hljs.C_NUMBER_MODE, {
            starts: {
                end: "(\\s*/)?",
                relevance: 0
            }
        }),
        {
            className: "string",
            variants: [
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        hljs.BACKSLASH_ESCAPE,
                        SUBST
                    ]
                }
            ]
        },
        {
            className: "built_in",
            begin: "@__" + hljs.IDENT_RE
        },
        {
            begin: "@" + hljs.IDENT_RE // relevance booster on par with CoffeeScript
        },
        {
            begin: hljs.IDENT_RE + "\\\\" + hljs.IDENT_RE // inst\method
        }
    ];
    SUBST.contains = EXPRESSIONS;
    const TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: JS_IDENT_RE
    });
    const POSSIBLE_PARAMS_RE = "(\\(.*\\)\\s*)?\\B[-=]>";
    const PARAMS = {
        className: "params",
        begin: "\\([^\\(]",
        returnBegin: true,
        /* We need another contained nameless mode to not have every nested
    pair of parens to be called "params" */ contains: [
            {
                begin: /\(/,
                end: /\)/,
                keywords: KEYWORDS,
                contains: [
                    "self"
                ].concat(EXPRESSIONS)
            }
        ]
    };
    return {
        name: "MoonScript",
        aliases: [
            "moon"
        ],
        keywords: KEYWORDS,
        illegal: /\/\*/,
        contains: EXPRESSIONS.concat([
            hljs.COMMENT("--", "$"),
            {
                className: "function",
                begin: "^\\s*" + JS_IDENT_RE + "\\s*=\\s*" + POSSIBLE_PARAMS_RE,
                end: "[-=]>",
                returnBegin: true,
                contains: [
                    TITLE,
                    PARAMS
                ]
            },
            {
                begin: /[\(,:=]\s*/,
                relevance: 0,
                contains: [
                    {
                        className: "function",
                        begin: POSSIBLE_PARAMS_RE,
                        end: "[-=]>",
                        returnBegin: true,
                        contains: [
                            PARAMS
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class",
                end: "$",
                illegal: /[:="\[\]]/,
                contains: [
                    {
                        beginKeywords: "extends",
                        endsWithParent: true,
                        illegal: /[:="\[\]]/,
                        contains: [
                            TITLE
                        ]
                    },
                    TITLE
                ]
            },
            {
                className: "name",
                begin: JS_IDENT_RE + ":",
                end: ":",
                returnBegin: true,
                returnEnd: true,
                relevance: 0
            }
        ])
    };
}
module.exports = $4fb8566b23d1a6f4$var$moonscript;

});

parcelRegister("39pDl", function(module, exports) {
/*
 Language: N1QL
 Author: Andres Täht <andres.taht@gmail.com>
 Contributors: Rene Saarsoo <nene@triin.net>
 Description: Couchbase query language
 Website: https://www.couchbase.com/products/n1ql
 */ function $24b618a9d48f87c9$var$n1ql(hljs) {
    return {
        name: "N1QL",
        case_insensitive: true,
        contains: [
            {
                beginKeywords: "build create index delete drop explain infer|10 insert merge prepare select update upsert|10",
                end: /;/,
                endsWithParent: true,
                keywords: {
                    // Taken from http://developer.couchbase.com/documentation/server/current/n1ql/n1ql-language-reference/reservedwords.html
                    keyword: "all alter analyze and any array as asc begin between binary boolean break bucket build by call case cast cluster collate collection commit connect continue correlate cover create database dataset datastore declare decrement delete derived desc describe distinct do drop each element else end every except exclude execute exists explain fetch first flatten for force from function grant group gsi having if ignore ilike in include increment index infer inline inner insert intersect into is join key keys keyspace known last left let letting like limit lsm map mapping matched materialized merge minus namespace nest not number object offset on option or order outer over parse partition password path pool prepare primary private privilege procedure public raw realm reduce rename return returning revoke right role rollback satisfies schema select self semi set show some start statistics string system then to transaction trigger truncate under union unique unknown unnest unset update upsert use user using validate value valued values via view when where while with within work xor",
                    // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/literals.html
                    literal: "true false null missing|5",
                    // Taken from http://developer.couchbase.com/documentation/server/4.5/n1ql/n1ql-language-reference/functions.html
                    built_in: "array_agg array_append array_concat array_contains array_count array_distinct array_ifnull array_length array_max array_min array_position array_prepend array_put array_range array_remove array_repeat array_replace array_reverse array_sort array_sum avg count max min sum greatest least ifmissing ifmissingornull ifnull missingif nullif ifinf ifnan ifnanorinf naninf neginfif posinfif clock_millis clock_str date_add_millis date_add_str date_diff_millis date_diff_str date_part_millis date_part_str date_trunc_millis date_trunc_str duration_to_str millis str_to_millis millis_to_str millis_to_utc millis_to_zone_name now_millis now_str str_to_duration str_to_utc str_to_zone_name decode_json encode_json encoded_size poly_length base64 base64_encode base64_decode meta uuid abs acos asin atan atan2 ceil cos degrees e exp ln log floor pi power radians random round sign sin sqrt tan trunc object_length object_names object_pairs object_inner_pairs object_values object_inner_values object_add object_put object_remove object_unwrap regexp_contains regexp_like regexp_position regexp_replace contains initcap length lower ltrim position repeat replace rtrim split substr title trim upper isarray isatom isboolean isnumber isobject isstring type toarray toatom toboolean tonumber toobject tostring"
                },
                contains: [
                    {
                        className: "string",
                        begin: "'",
                        end: "'",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        className: "string",
                        begin: '"',
                        end: '"',
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        className: "symbol",
                        begin: "`",
                        end: "`",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ],
                        relevance: 2
                    },
                    hljs.C_NUMBER_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
}
module.exports = $24b618a9d48f87c9$var$n1ql;

});

parcelRegister("gPoTD", function(module, exports) {
/*
Language: Nginx config
Author: Peter Leonov <gojpeg@yandex.ru>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Category: common, config
Website: https://www.nginx.com
*/ function $c404b8a84c4de559$var$nginx(hljs) {
    const VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$\d+/
            },
            {
                begin: /\$\{/,
                end: /\}/
            },
            {
                begin: /[$@]/ + hljs.UNDERSCORE_IDENT_RE
            }
        ]
    };
    const DEFAULT = {
        endsWithParent: true,
        keywords: {
            $pattern: "[a-z/_]+",
            literal: "on off yes no true false none blocked debug info notice warn error crit select break last permanent redirect kqueue rtsig epoll poll /dev/poll"
        },
        relevance: 0,
        illegal: "=>",
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: /"/,
                        end: /"/
                    },
                    {
                        begin: /'/,
                        end: /'/
                    }
                ]
            },
            // this swallows entire URLs to avoid detecting numbers within
            {
                begin: "([a-z]+):/",
                end: "\\s",
                endsWithParent: true,
                excludeEnd: true,
                contains: [
                    VAR
                ]
            },
            {
                className: "regexp",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    VAR
                ],
                variants: [
                    {
                        begin: "\\s\\^",
                        end: "\\s|\\{|;",
                        returnEnd: true
                    },
                    // regexp locations (~, ~*)
                    {
                        begin: "~\\*?\\s+",
                        end: "\\s|\\{|;",
                        returnEnd: true
                    },
                    // *.example.com
                    {
                        begin: "\\*(\\.[a-z\\-]+)+"
                    },
                    // sub.example.*
                    {
                        begin: "([a-z\\-]+\\.)+\\*"
                    }
                ]
            },
            // IP
            {
                className: "number",
                begin: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"
            },
            // units
            {
                className: "number",
                begin: "\\b\\d+[kKmMgGdshdwy]*\\b",
                relevance: 0
            },
            VAR
        ]
    };
    return {
        name: "Nginx config",
        aliases: [
            "nginxconf"
        ],
        contains: [
            hljs.HASH_COMMENT_MODE,
            {
                begin: hljs.UNDERSCORE_IDENT_RE + "\\s+\\{",
                returnBegin: true,
                end: /\{/,
                contains: [
                    {
                        className: "section",
                        begin: hljs.UNDERSCORE_IDENT_RE
                    }
                ],
                relevance: 0
            },
            {
                begin: hljs.UNDERSCORE_IDENT_RE + "\\s",
                end: ";|\\{",
                returnBegin: true,
                contains: [
                    {
                        className: "attribute",
                        begin: hljs.UNDERSCORE_IDENT_RE,
                        starts: DEFAULT
                    }
                ],
                relevance: 0
            }
        ],
        illegal: "[^\\s\\}]"
    };
}
module.exports = $c404b8a84c4de559$var$nginx;

});

parcelRegister("gRhge", function(module, exports) {
/*
Language: Nim
Description: Nim is a statically typed compiled systems programming language.
Website: https://nim-lang.org
Category: system
*/ function $c45efc32ef95ed83$var$nim(hljs) {
    return {
        name: "Nim",
        keywords: {
            keyword: "addr and as asm bind block break case cast const continue converter discard distinct div do elif else end enum except export finally for from func generic if import in include interface is isnot iterator let macro method mixin mod nil not notin object of or out proc ptr raise ref return shl shr static template try tuple type using var when while with without xor yield",
            literal: "shared guarded stdin stdout stderr result true false",
            built_in: "int int8 int16 int32 int64 uint uint8 uint16 uint32 uint64 float float32 float64 bool char string cstring pointer expr stmt void auto any range array openarray varargs seq set clong culong cchar cschar cshort cint csize clonglong cfloat cdouble clongdouble cuchar cushort cuint culonglong cstringarray semistatic"
        },
        contains: [
            {
                className: "meta",
                begin: /\{\./,
                end: /\.\}/,
                relevance: 10
            },
            {
                className: "string",
                begin: /[a-zA-Z]\w*"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/
                    }
                ]
            },
            {
                className: "string",
                begin: /([a-zA-Z]\w*)?"""/,
                end: /"""/
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "type",
                begin: /\b[A-Z]\w+\b/,
                relevance: 0
            },
            {
                className: "number",
                relevance: 0,
                variants: [
                    {
                        begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/
                    },
                    {
                        begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/
                    },
                    {
                        begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/
                    },
                    {
                        begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/
                    }
                ]
            },
            hljs.HASH_COMMENT_MODE
        ]
    };
}
module.exports = $c45efc32ef95ed83$var$nim;

});

parcelRegister("1m60g", function(module, exports) {
/*
Language: Nix
Author: Domen Kožar <domen@dev.si>
Description: Nix functional language
Website: http://nixos.org/nix
*/ function $0fcc80a8bfdc0b24$var$nix(hljs) {
    const NIX_KEYWORDS = {
        keyword: "rec with let in inherit assert if else then",
        literal: "true false or and null",
        built_in: "import abort baseNameOf dirOf isNull builtins map removeAttrs throw toString derivation"
    };
    const ANTIQUOTE = {
        className: "subst",
        begin: /\$\{/,
        end: /\}/,
        keywords: NIX_KEYWORDS
    };
    const ATTRS = {
        begin: /[a-zA-Z0-9-_]+(\s*=)/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "attr",
                begin: /\S+/
            }
        ]
    };
    const STRING = {
        className: "string",
        contains: [
            ANTIQUOTE
        ],
        variants: [
            {
                begin: "''",
                end: "''"
            },
            {
                begin: '"',
                end: '"'
            }
        ]
    };
    const EXPRESSIONS = [
        hljs.NUMBER_MODE,
        hljs.HASH_COMMENT_MODE,
        hljs.C_BLOCK_COMMENT_MODE,
        STRING,
        ATTRS
    ];
    ANTIQUOTE.contains = EXPRESSIONS;
    return {
        name: "Nix",
        aliases: [
            "nixos"
        ],
        keywords: NIX_KEYWORDS,
        contains: EXPRESSIONS
    };
}
module.exports = $0fcc80a8bfdc0b24$var$nix;

});

parcelRegister("i57b6", function(module, exports) {
/*
Language: Node REPL
Requires: javascript.js
Author: Marat Nagayev <nagaevmt@yandex.ru>
Category: scripting
*/ /** @type LanguageFn */ function $d29e430a1c1236e8$var$nodeRepl(hljs) {
    return {
        name: "Node REPL",
        contains: [
            {
                className: "meta",
                starts: {
                    // a space separates the REPL prefix from the actual code
                    // this is purely for cleaner HTML output
                    end: / |$/,
                    starts: {
                        end: "$",
                        subLanguage: "javascript"
                    }
                },
                variants: [
                    {
                        begin: /^>(?=[ ]|$)/
                    },
                    {
                        begin: /^\.\.\.(?=[ ]|$)/
                    }
                ]
            }
        ]
    };
}
module.exports = $d29e430a1c1236e8$var$nodeRepl;

});

parcelRegister("dHmDc", function(module, exports) {
/*
Language: NSIS
Description: Nullsoft Scriptable Install System
Author: Jan T. Sott <jan.sott@gmail.com>
Website: https://nsis.sourceforge.io/Main_Page
*/ function $9f90d89c8f0fb09a$var$nsis(hljs) {
    const CONSTANTS = {
        className: "variable",
        begin: /\$(ADMINTOOLS|APPDATA|CDBURN_AREA|CMDLINE|COMMONFILES32|COMMONFILES64|COMMONFILES|COOKIES|DESKTOP|DOCUMENTS|EXEDIR|EXEFILE|EXEPATH|FAVORITES|FONTS|HISTORY|HWNDPARENT|INSTDIR|INTERNET_CACHE|LANGUAGE|LOCALAPPDATA|MUSIC|NETHOOD|OUTDIR|PICTURES|PLUGINSDIR|PRINTHOOD|PROFILE|PROGRAMFILES32|PROGRAMFILES64|PROGRAMFILES|QUICKLAUNCH|RECENT|RESOURCES_LOCALIZED|RESOURCES|SENDTO|SMPROGRAMS|SMSTARTUP|STARTMENU|SYSDIR|TEMP|TEMPLATES|VIDEOS|WINDIR)/
    };
    const DEFINES = {
        // ${defines}
        className: "variable",
        begin: /\$+\{[\w.:-]+\}/
    };
    const VARIABLES = {
        // $variables
        className: "variable",
        begin: /\$+\w+/,
        illegal: /\(\)\{\}/
    };
    const LANGUAGES = {
        // $(language_strings)
        className: "variable",
        begin: /\$+\([\w^.:-]+\)/
    };
    const PARAMETERS = {
        // command parameters
        className: "params",
        begin: "(ARCHIVE|FILE_ATTRIBUTE_ARCHIVE|FILE_ATTRIBUTE_NORMAL|FILE_ATTRIBUTE_OFFLINE|FILE_ATTRIBUTE_READONLY|FILE_ATTRIBUTE_SYSTEM|FILE_ATTRIBUTE_TEMPORARY|HKCR|HKCU|HKDD|HKEY_CLASSES_ROOT|HKEY_CURRENT_CONFIG|HKEY_CURRENT_USER|HKEY_DYN_DATA|HKEY_LOCAL_MACHINE|HKEY_PERFORMANCE_DATA|HKEY_USERS|HKLM|HKPD|HKU|IDABORT|IDCANCEL|IDIGNORE|IDNO|IDOK|IDRETRY|IDYES|MB_ABORTRETRYIGNORE|MB_DEFBUTTON1|MB_DEFBUTTON2|MB_DEFBUTTON3|MB_DEFBUTTON4|MB_ICONEXCLAMATION|MB_ICONINFORMATION|MB_ICONQUESTION|MB_ICONSTOP|MB_OK|MB_OKCANCEL|MB_RETRYCANCEL|MB_RIGHT|MB_RTLREADING|MB_SETFOREGROUND|MB_TOPMOST|MB_USERICON|MB_YESNO|NORMAL|OFFLINE|READONLY|SHCTX|SHELL_CONTEXT|SYSTEM|TEMPORARY)"
    };
    const COMPILER = {
        // !compiler_flags
        className: "keyword",
        begin: /!(addincludedir|addplugindir|appendfile|cd|define|delfile|echo|else|endif|error|execute|finalize|getdllversion|gettlbversion|if|ifdef|ifmacrodef|ifmacrondef|ifndef|include|insertmacro|macro|macroend|makensis|packhdr|searchparse|searchreplace|system|tempfile|undef|verbose|warning)/
    };
    const METACHARS = {
        // $\n, $\r, $\t, $$
        className: "meta",
        begin: /\$(\\[nrt]|\$)/
    };
    const PLUGINS = {
        // plug::ins
        className: "class",
        begin: /\w+::\w+/
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"'
            },
            {
                begin: "'",
                end: "'"
            },
            {
                begin: "`",
                end: "`"
            }
        ],
        illegal: /\n/,
        contains: [
            METACHARS,
            CONSTANTS,
            DEFINES,
            VARIABLES,
            LANGUAGES
        ]
    };
    return {
        name: "NSIS",
        case_insensitive: false,
        keywords: {
            keyword: "Abort AddBrandingImage AddSize AllowRootDirInstall AllowSkipFiles AutoCloseWindow BGFont BGGradient BrandingText BringToFront Call CallInstDLL Caption ChangeUI CheckBitmap ClearErrors CompletedText ComponentText CopyFiles CRCCheck CreateDirectory CreateFont CreateShortCut Delete DeleteINISec DeleteINIStr DeleteRegKey DeleteRegValue DetailPrint DetailsButtonText DirText DirVar DirVerify EnableWindow EnumRegKey EnumRegValue Exch Exec ExecShell ExecShellWait ExecWait ExpandEnvStrings File FileBufSize FileClose FileErrorText FileOpen FileRead FileReadByte FileReadUTF16LE FileReadWord FileWriteUTF16LE FileSeek FileWrite FileWriteByte FileWriteWord FindClose FindFirst FindNext FindWindow FlushINI GetCurInstType GetCurrentAddress GetDlgItem GetDLLVersion GetDLLVersionLocal GetErrorLevel GetFileTime GetFileTimeLocal GetFullPathName GetFunctionAddress GetInstDirError GetKnownFolderPath GetLabelAddress GetTempFileName Goto HideWindow Icon IfAbort IfErrors IfFileExists IfRebootFlag IfRtlLanguage IfShellVarContextAll IfSilent InitPluginsDir InstallButtonText InstallColors InstallDir InstallDirRegKey InstProgressFlags InstType InstTypeGetText InstTypeSetText Int64Cmp Int64CmpU Int64Fmt IntCmp IntCmpU IntFmt IntOp IntPtrCmp IntPtrCmpU IntPtrOp IsWindow LangString LicenseBkColor LicenseData LicenseForceSelection LicenseLangString LicenseText LoadAndSetImage LoadLanguageFile LockWindow LogSet LogText ManifestDPIAware ManifestLongPathAware ManifestMaxVersionTested ManifestSupportedOS MessageBox MiscButtonText Name Nop OutFile Page PageCallbacks PEAddResource PEDllCharacteristics PERemoveResource PESubsysVer Pop Push Quit ReadEnvStr ReadINIStr ReadRegDWORD ReadRegStr Reboot RegDLL Rename RequestExecutionLevel ReserveFile Return RMDir SearchPath SectionGetFlags SectionGetInstTypes SectionGetSize SectionGetText SectionIn SectionSetFlags SectionSetInstTypes SectionSetSize SectionSetText SendMessage SetAutoClose SetBrandingImage SetCompress SetCompressor SetCompressorDictSize SetCtlColors SetCurInstType SetDatablockOptimize SetDateSave SetDetailsPrint SetDetailsView SetErrorLevel SetErrors SetFileAttributes SetFont SetOutPath SetOverwrite SetRebootFlag SetRegView SetShellVarContext SetSilent ShowInstDetails ShowUninstDetails ShowWindow SilentInstall SilentUnInstall Sleep SpaceTexts StrCmp StrCmpS StrCpy StrLen SubCaption Unicode UninstallButtonText UninstallCaption UninstallIcon UninstallSubCaption UninstallText UninstPage UnRegDLL Var VIAddVersionKey VIFileVersion VIProductVersion WindowIcon WriteINIStr WriteRegBin WriteRegDWORD WriteRegExpandStr WriteRegMultiStr WriteRegNone WriteRegStr WriteUninstaller XPStyle",
            literal: "admin all auto both bottom bzip2 colored components current custom directory false force hide highest ifdiff ifnewer instfiles lastused leave left license listonly lzma nevershow none normal notset off on open print right show silent silentlog smooth textonly top true try un.components un.custom un.directory un.instfiles un.license uninstConfirm user Win10 Win7 Win8 WinVista zlib"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "function",
                beginKeywords: "Function PageEx Section SectionGroup",
                end: "$"
            },
            STRING,
            COMPILER,
            DEFINES,
            VARIABLES,
            LANGUAGES,
            PARAMETERS,
            PLUGINS,
            hljs.NUMBER_MODE
        ]
    };
}
module.exports = $9f90d89c8f0fb09a$var$nsis;

});

parcelRegister("dCB9T", function(module, exports) {
/*
Language: Objective-C
Author: Valerii Hiora <valerii.hiora@gmail.com>
Contributors: Angel G. Olloqui <angelgarcia.mail@gmail.com>, Matt Diephouse <matt@diephouse.com>, Andrew Farmer <ahfarmer@gmail.com>, Minh Nguyễn <mxn@1ec5.org>
Website: https://developer.apple.com/documentation/objectivec
Category: common
*/ function $9eaba5e0f975fac1$var$objectivec(hljs) {
    const API_CLASS = {
        className: "built_in",
        begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
    };
    const IDENTIFIER_RE = /[a-zA-Z@][a-zA-Z0-9_]*/;
    const OBJC_KEYWORDS = {
        $pattern: IDENTIFIER_RE,
        keyword: "int float while char export sizeof typedef const struct for union unsigned long volatile static bool mutable if do return goto void enum else break extern asm case short default double register explicit signed typename this switch continue wchar_t inline readonly assign readwrite self @synchronized id typeof nonatomic super unichar IBOutlet IBAction strong weak copy in out inout bycopy byref oneway __strong __weak __block __autoreleasing @private @protected @public @try @property @end @throw @catch @finally @autoreleasepool @synthesize @dynamic @selector @optional @required @encode @package @import @defs @compatibility_alias __bridge __bridge_transfer __bridge_retained __bridge_retain __covariant __contravariant __kindof _Nonnull _Nullable _Null_unspecified __FUNCTION__ __PRETTY_FUNCTION__ __attribute__ getter setter retain unsafe_unretained nonnull nullable null_unspecified null_resettable class instancetype NS_DESIGNATED_INITIALIZER NS_UNAVAILABLE NS_REQUIRES_SUPER NS_RETURNS_INNER_POINTER NS_INLINE NS_AVAILABLE NS_DEPRECATED NS_ENUM NS_OPTIONS NS_SWIFT_UNAVAILABLE NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_REFINED_FOR_SWIFT NS_SWIFT_NAME NS_SWIFT_NOTHROW NS_DURING NS_HANDLER NS_ENDHANDLER NS_VALUERETURN NS_VOIDRETURN",
        literal: "false true FALSE TRUE nil YES NO NULL",
        built_in: "BOOL dispatch_once_t dispatch_queue_t dispatch_sync dispatch_async dispatch_once"
    };
    const CLASS_KEYWORDS = {
        $pattern: IDENTIFIER_RE,
        keyword: "@interface @class @protocol @implementation"
    };
    return {
        name: "Objective-C",
        aliases: [
            "mm",
            "objc",
            "obj-c",
            "obj-c++",
            "objective-c++"
        ],
        keywords: OBJC_KEYWORDS,
        illegal: "</",
        contains: [
            API_CLASS,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            {
                className: "string",
                variants: [
                    {
                        begin: '@"',
                        end: '"',
                        illegal: "\\n",
                        contains: [
                            hljs.BACKSLASH_ESCAPE
                        ]
                    }
                ]
            },
            {
                className: "meta",
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    "meta-keyword": "if else elif endif define undef warning error line pragma ifdef ifndef include"
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        className: "meta-string"
                    }),
                    {
                        className: "meta-string",
                        begin: /<.*?>/,
                        end: /$/,
                        illegal: "\\n"
                    },
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE
                ]
            },
            {
                className: "class",
                begin: "(" + CLASS_KEYWORDS.keyword.split(" ").join("|") + ")\\b",
                end: /(\{|$)/,
                excludeEnd: true,
                keywords: CLASS_KEYWORDS,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: "\\." + hljs.UNDERSCORE_IDENT_RE,
                relevance: 0
            }
        ]
    };
}
module.exports = $9eaba5e0f975fac1$var$objectivec;

});

parcelRegister("f6CSv", function(module, exports) {
/*
Language: OCaml
Author: Mehdi Dogguy <mehdi@dogguy.org>
Contributors: Nicolas Braud-Santoni <nicolas.braud-santoni@ens-cachan.fr>, Mickael Delahaye <mickael.delahaye@gmail.com>
Description: OCaml language definition.
Website: https://ocaml.org
Category: functional
*/ function $aff592ed91b2832a$var$ocaml(hljs) {
    /* missing support for heredoc-like string (OCaml 4.0.2+) */ return {
        name: "OCaml",
        aliases: [
            "ml"
        ],
        keywords: {
            $pattern: "[a-z_]\\w*!?",
            keyword: "and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",
            built_in: /* built-in types */ "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref",
            literal: "true false"
        },
        illegal: /\/\/|>>/,
        contains: [
            {
                className: "literal",
                begin: "\\[(\\|\\|)?\\]|\\(\\)",
                relevance: 0
            },
            hljs.COMMENT("\\(\\*", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            {
                className: "symbol",
                begin: "'[A-Za-z_](?!')[\\w']*"
            },
            {
                className: "type",
                begin: "`[A-Z][\\w']*"
            },
            {
                className: "type",
                begin: "\\b[A-Z][\\w']*",
                relevance: 0
            },
            {
                begin: "[a-z_]\\w*'[\\w']*",
                relevance: 0
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "number",
                begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                relevance: 0
            },
            {
                begin: /->/ // relevance booster
            }
        ]
    };
}
module.exports = $aff592ed91b2832a$var$ocaml;

});

parcelRegister("1vj8j", function(module, exports) {
/*
Language: OpenSCAD
Author: Dan Panzarella <alsoelp@gmail.com>
Description: OpenSCAD is a language for the 3D CAD modeling software of the same name.
Website: https://www.openscad.org
Category: scientific
*/ function $1187871cb2874c29$var$openscad(hljs) {
    const SPECIAL_VARS = {
        className: "keyword",
        begin: "\\$(f[asn]|t|vp[rtd]|children)"
    };
    const LITERALS = {
        className: "literal",
        begin: "false|true|PI|undef"
    };
    const NUMBERS = {
        className: "number",
        begin: "\\b\\d+(\\.\\d+)?(e-?\\d+)?",
        relevance: 0
    };
    const STRING = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null
    });
    const PREPRO = {
        className: "meta",
        keywords: {
            "meta-keyword": "include use"
        },
        begin: "include|use <",
        end: ">"
    };
    const PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)",
        contains: [
            "self",
            NUMBERS,
            STRING,
            SPECIAL_VARS,
            LITERALS
        ]
    };
    const MODIFIERS = {
        begin: "[*!#%]",
        relevance: 0
    };
    const FUNCTIONS = {
        className: "function",
        beginKeywords: "module function",
        end: /=|\{/,
        contains: [
            PARAMS,
            hljs.UNDERSCORE_TITLE_MODE
        ]
    };
    return {
        name: "OpenSCAD",
        aliases: [
            "scad"
        ],
        keywords: {
            keyword: "function module include use for intersection_for if else \\%",
            literal: "false true PI undef",
            built_in: "circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            NUMBERS,
            PREPRO,
            STRING,
            SPECIAL_VARS,
            MODIFIERS,
            FUNCTIONS
        ]
    };
}
module.exports = $1187871cb2874c29$var$openscad;

});

parcelRegister("amStw", function(module, exports) {
/*
Language: Oxygene
Author: Carlo Kok <ck@remobjects.com>
Description: Oxygene is built on the foundation of Object Pascal, revamped and extended to be a modern language for the twenty-first century.
Website: https://www.elementscompiler.com/elements/default.aspx
*/ function $78c6371216ab4d6c$var$oxygene(hljs) {
    const OXYGENE_KEYWORDS = {
        $pattern: /\.?\w+/,
        keyword: "abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained"
    };
    const CURLY_COMMENT = hljs.COMMENT(/\{/, /\}/, {
        relevance: 0
    });
    const PAREN_COMMENT = hljs.COMMENT("\\(\\*", "\\*\\)", {
        relevance: 10
    });
    const STRING = {
        className: "string",
        begin: "'",
        end: "'",
        contains: [
            {
                begin: "''"
            }
        ]
    };
    const CHAR_STRING = {
        className: "string",
        begin: "(#\\d+)+"
    };
    const FUNCTION = {
        className: "function",
        beginKeywords: "function constructor destructor procedure method",
        end: "[:;]",
        keywords: "function constructor|10 destructor|10 procedure|10 method|10",
        contains: [
            hljs.TITLE_MODE,
            {
                className: "params",
                begin: "\\(",
                end: "\\)",
                keywords: OXYGENE_KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING
                ]
            },
            CURLY_COMMENT,
            PAREN_COMMENT
        ]
    };
    return {
        name: "Oxygene",
        case_insensitive: true,
        keywords: OXYGENE_KEYWORDS,
        illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
        contains: [
            CURLY_COMMENT,
            PAREN_COMMENT,
            hljs.C_LINE_COMMENT_MODE,
            STRING,
            CHAR_STRING,
            hljs.NUMBER_MODE,
            FUNCTION,
            {
                className: "class",
                begin: "=\\bclass\\b",
                end: "end;",
                keywords: OXYGENE_KEYWORDS,
                contains: [
                    STRING,
                    CHAR_STRING,
                    CURLY_COMMENT,
                    PAREN_COMMENT,
                    hljs.C_LINE_COMMENT_MODE,
                    FUNCTION
                ]
            }
        ]
    };
}
module.exports = $78c6371216ab4d6c$var$oxygene;

});

parcelRegister("caY3R", function(module, exports) {
/*
Language: Parser3
Requires: xml.js
Author: Oleg Volchkov <oleg@volchkov.net>
Website: https://www.parser.ru/en/
Category: template
*/ function $8dd50225002aafed$var$parser3(hljs) {
    const CURLY_SUBCOMMENT = hljs.COMMENT(/\{/, /\}/, {
        contains: [
            "self"
        ]
    });
    return {
        name: "Parser3",
        subLanguage: "xml",
        relevance: 0,
        contains: [
            hljs.COMMENT("^#", "$"),
            hljs.COMMENT(/\^rem\{/, /\}/, {
                relevance: 10,
                contains: [
                    CURLY_SUBCOMMENT
                ]
            }),
            {
                className: "meta",
                begin: "^@(?:BASE|USE|CLASS|OPTIONS)$",
                relevance: 10
            },
            {
                className: "title",
                begin: "@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"
            },
            {
                className: "variable",
                begin: /\$\{?[\w\-.:]+\}?/
            },
            {
                className: "keyword",
                begin: /\^[\w\-.:]+/
            },
            {
                className: "number",
                begin: "\\^#[0-9a-fA-F]+"
            },
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $8dd50225002aafed$var$parser3;

});

parcelRegister("2YmYa", function(module, exports) {
/*
Language: Packet Filter config
Description: pf.conf — packet filter configuration file (OpenBSD)
Author: Peter Piwowarski <oldlaptop654@aol.com>
Website: http://man.openbsd.org/pf.conf
Category: config
*/ function $22a3009e5b4ea9e5$var$pf(hljs) {
    const MACRO = {
        className: "variable",
        begin: /\$[\w\d#@][\w\d_]*/
    };
    const TABLE = {
        className: "variable",
        begin: /<(?!\/)/,
        end: />/
    };
    return {
        name: "Packet Filter config",
        aliases: [
            "pf.conf"
        ],
        keywords: {
            $pattern: /[a-z0-9_<>-]+/,
            built_in: /* block match pass are "actions" in pf.conf(5), the rest are
                 * lexically similar top-level commands.
                 */ "block match pass load anchor|5 antispoof|10 set table",
            keyword: "in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id",
            literal: "all any no-route self urpf-failed egress|5 unknown"
        },
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.NUMBER_MODE,
            hljs.QUOTE_STRING_MODE,
            MACRO,
            TABLE
        ]
    };
}
module.exports = $22a3009e5b4ea9e5$var$pf;

});

parcelRegister("5h1Dk", function(module, exports) {
/*
Language: PostgreSQL and PL/pgSQL
Author: Egor Rogov (e.rogov@postgrespro.ru)
Website: https://www.postgresql.org/docs/11/sql.html
Description:
    This language incorporates both PostgreSQL SQL dialect and PL/pgSQL language.
    It is based on PostgreSQL version 11. Some notes:
    - Text in double-dollar-strings is _always_ interpreted as some programming code. Text
      in ordinary quotes is _never_ interpreted that way and highlighted just as a string.
    - There are quite a bit "special cases". That's because many keywords are not strictly
      they are keywords in some contexts and ordinary identifiers in others. Only some
      of such cases are handled; you still can get some of your identifiers highlighted
      wrong way.
    - Function names deliberately are not highlighted. There is no way to tell function
      call from other constructs, hence we can't highlight _all_ function names. And
      some names highlighted while others not looks ugly.
*/ function $3d6fce9b90ce33ec$var$pgsql(hljs) {
    const COMMENT_MODE = hljs.COMMENT("--", "$");
    const UNQUOTED_IDENT = "[a-zA-Z_][a-zA-Z_0-9$]*";
    const DOLLAR_STRING = "\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$";
    const LABEL = "<<\\s*" + UNQUOTED_IDENT + "\\s*>>";
    const SQL_KW = // https://www.postgresql.org/docs/11/static/sql-keywords-appendix.html
    // https://www.postgresql.org/docs/11/static/sql-commands.html
    // SQL commands (starting words)
    "ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY ";
    const ROLE_ATTRS = "SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS ";
    const PLPGSQL_KW = "ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN ";
    const TYPES = // https://www.postgresql.org/docs/11/static/datatype.html
    "BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 "; // +
    const TYPES_RE = TYPES.trim().split(" ").map(function(val) {
        return val.split("|")[0];
    }).join("|");
    const SQL_BI = "CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC ";
    const PLPGSQL_BI = "FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 ";
    const PLPGSQL_EXCEPTIONS = // exceptions https://www.postgresql.org/docs/current/static/errcodes-appendix.html
    "SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED ";
    const FUNCTIONS = // https://www.postgresql.org/docs/11/static/functions-aggregate.html
    "ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ";
    const FUNCTIONS_RE = FUNCTIONS.trim().split(" ").map(function(val) {
        return val.split("|")[0];
    }).join("|");
    return {
        name: "PostgreSQL",
        aliases: [
            "postgres",
            "postgresql"
        ],
        case_insensitive: true,
        keywords: {
            keyword: SQL_KW + PLPGSQL_KW + ROLE_ATTRS,
            built_in: SQL_BI + PLPGSQL_BI + PLPGSQL_EXCEPTIONS
        },
        // Forbid some cunstructs from other languages to improve autodetect. In fact
        // "[a-z]:" is legal (as part of array slice), but improbabal.
        illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
        contains: [
            // special handling of some words, which are reserved only in some contexts
            {
                className: "keyword",
                variants: [
                    {
                        begin: /\bTEXT\s*SEARCH\b/
                    },
                    {
                        begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/
                    },
                    {
                        begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/
                    },
                    {
                        begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/
                    },
                    {
                        begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/
                    },
                    {
                        begin: /\bNULLS\s+(FIRST|LAST)\b/
                    },
                    {
                        begin: /\bEVENT\s+TRIGGER\b/
                    },
                    {
                        begin: /\b(MAPPING|OR)\s+REPLACE\b/
                    },
                    {
                        begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/
                    },
                    {
                        begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/
                    },
                    {
                        begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/
                    },
                    {
                        begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/
                    },
                    {
                        begin: /\bPRESERVE\s+ROWS\b/
                    },
                    {
                        begin: /\bDISCARD\s+PLANS\b/
                    },
                    {
                        begin: /\bREFERENCING\s+(OLD|NEW)\b/
                    },
                    {
                        begin: /\bSKIP\s+LOCKED\b/
                    },
                    {
                        begin: /\bGROUPING\s+SETS\b/
                    },
                    {
                        begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/
                    },
                    {
                        begin: /\b(WITH|WITHOUT)\s+HOLD\b/
                    },
                    {
                        begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/
                    },
                    {
                        begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/
                    },
                    {
                        begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/
                    },
                    {
                        begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/
                    },
                    {
                        begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/
                    },
                    {
                        begin: /\bSECURITY\s+LABEL\b/
                    },
                    {
                        begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/
                    },
                    {
                        begin: /\bWITH\s+(NO\s+)?DATA\b/
                    },
                    {
                        begin: /\b(FOREIGN|SET)\s+DATA\b/
                    },
                    {
                        begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/
                    },
                    {
                        begin: /\b(WITH|FOR)\s+ORDINALITY\b/
                    },
                    {
                        begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/
                    },
                    {
                        begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/
                    },
                    {
                        begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/
                    },
                    {
                        begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/
                    },
                    {
                        begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/
                    },
                    {
                        begin: /\bAT\s+TIME\s+ZONE\b/
                    },
                    {
                        begin: /\bGRANTED\s+BY\b/
                    },
                    {
                        begin: /\bRETURN\s+(QUERY|NEXT)\b/
                    },
                    {
                        begin: /\b(ATTACH|DETACH)\s+PARTITION\b/
                    },
                    {
                        begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/
                    },
                    {
                        begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/
                    },
                    {
                        begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/
                    }
                ]
            },
            // functions named as keywords, followed by '('
            {
                begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
            },
            // INCLUDE ( ... ) in index_parameters in CREATE TABLE
            {
                begin: /\bINCLUDE\s*\(/,
                keywords: "INCLUDE"
            },
            // not highlight RANGE if not in frame_clause (not 100% correct, but seems satisfactory)
            {
                begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/
            },
            // disable highlighting in commands CREATE AGGREGATE/COLLATION/DATABASE/OPERTOR/TEXT SEARCH .../TYPE
            // and in PL/pgSQL RAISE ... USING
            {
                begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/
            },
            // PG_smth; HAS_some_PRIVILEGE
            {
                // className: 'built_in',
                begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
                relevance: 10
            },
            // extract
            {
                begin: /\bEXTRACT\s*\(/,
                end: /\bFROM\b/,
                returnEnd: true,
                keywords: {
                    // built_in: 'EXTRACT',
                    type: "CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"
                }
            },
            // xmlelement, xmlpi - special NAME
            {
                begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
                keywords: {
                    // built_in: 'XMLELEMENT XMLPI',
                    keyword: "NAME"
                }
            },
            // xmlparse, xmlserialize
            {
                begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
                keywords: {
                    // built_in: 'XMLPARSE XMLSERIALIZE',
                    keyword: "DOCUMENT CONTENT"
                }
            },
            // Sequences. We actually skip everything between CACHE|INCREMENT|MAXVALUE|MINVALUE and
            // nearest following numeric constant. Without with trick we find a lot of "keywords"
            // in 'avrasm' autodetection test...
            {
                beginKeywords: "CACHE INCREMENT MAXVALUE MINVALUE",
                end: hljs.C_NUMBER_RE,
                returnEnd: true,
                keywords: "BY CACHE INCREMENT MAXVALUE MINVALUE"
            },
            // WITH|WITHOUT TIME ZONE as part of datatype
            {
                className: "type",
                begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
            },
            // INTERVAL optional fields
            {
                className: "type",
                begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
            },
            // Pseudo-types which allowed only as return type
            {
                begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
                keywords: {
                    keyword: "RETURNS",
                    type: "LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"
                }
            },
            // Known functions - only when followed by '('
            {
                begin: "\\b(" + FUNCTIONS_RE + ")\\s*\\("
            },
            // Types
            {
                begin: "\\.(" + TYPES_RE + ")\\b" // prevent highlight as type, say, 'oid' in 'pgclass.oid'
            },
            {
                begin: "\\b(" + TYPES_RE + ")\\s+PATH\\b",
                keywords: {
                    keyword: "PATH",
                    type: TYPES.replace("PATH ", "")
                }
            },
            {
                className: "type",
                begin: "\\b(" + TYPES_RE + ")\\b"
            },
            // Strings, see https://www.postgresql.org/docs/11/static/sql-syntax-lexical.html#SQL-SYNTAX-CONSTANTS
            {
                className: "string",
                begin: "'",
                end: "'",
                contains: [
                    {
                        begin: "''"
                    }
                ]
            },
            {
                className: "string",
                begin: "(e|E|u&|U&)'",
                end: "'",
                contains: [
                    {
                        begin: "\\\\."
                    }
                ],
                relevance: 10
            },
            hljs.END_SAME_AS_BEGIN({
                begin: DOLLAR_STRING,
                end: DOLLAR_STRING,
                contains: [
                    {
                        // actually we want them all except SQL; listed are those with known implementations
                        // and XML + JSON just in case
                        subLanguage: [
                            "pgsql",
                            "perl",
                            "python",
                            "tcl",
                            "r",
                            "lua",
                            "java",
                            "php",
                            "ruby",
                            "bash",
                            "scheme",
                            "xml",
                            "json"
                        ],
                        endsWithParent: true
                    }
                ]
            }),
            // identifiers in quotes
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""'
                    }
                ]
            },
            // numbers
            hljs.C_NUMBER_MODE,
            // comments
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            // PL/pgSQL staff
            // %ROWTYPE, %TYPE, $n
            {
                className: "meta",
                variants: [
                    {
                        begin: "%(ROW)?TYPE",
                        relevance: 10
                    },
                    {
                        begin: "\\$\\d+"
                    },
                    {
                        begin: "^#\\w",
                        end: "$"
                    }
                ]
            },
            // <<labeles>>
            {
                className: "symbol",
                begin: LABEL,
                relevance: 10
            }
        ]
    };
}
module.exports = $3d6fce9b90ce33ec$var$pgsql;

});

parcelRegister("5CEHT", function(module, exports) {
/*
Language: PHP
Author: Victor Karamzin <Victor.Karamzin@enterra-inc.com>
Contributors: Evgeny Stepanischev <imbolk@gmail.com>, Ivan Sagalaev <maniac@softwaremaniacs.org>
Website: https://www.php.net
Category: common
*/ /**
 * @param {HLJSApi} hljs
 * @returns {LanguageDetail}
 * */ function $418013e5ee6d2d39$var$php(hljs) {
    const VARIABLE = {
        className: "variable",
        begin: "\\$+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*" + // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        `(?![A-Za-z0-9])(?![$])`
    };
    const PREPROCESSOR = {
        className: "meta",
        variants: [
            {
                begin: /<\?php/,
                relevance: 10
            },
            {
                begin: /<\?[=]?/
            },
            {
                begin: /\?>/
            } // end php tag
        ]
    };
    const SUBST = {
        className: "subst",
        variants: [
            {
                begin: /\$\w+/
            },
            {
                begin: /\{\$/,
                end: /\}/
            }
        ]
    };
    const SINGLE_QUOTED = hljs.inherit(hljs.APOS_STRING_MODE, {
        illegal: null
    });
    const DOUBLE_QUOTED = hljs.inherit(hljs.QUOTE_STRING_MODE, {
        illegal: null,
        contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST)
    });
    const HEREDOC = hljs.END_SAME_AS_BEGIN({
        begin: /<<<[ \t]*(\w+)\n/,
        end: /[ \t]*(\w+)\b/,
        contains: hljs.QUOTE_STRING_MODE.contains.concat(SUBST)
    });
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            PREPROCESSOR
        ],
        variants: [
            hljs.inherit(SINGLE_QUOTED, {
                begin: "b'",
                end: "'"
            }),
            hljs.inherit(DOUBLE_QUOTED, {
                begin: 'b"',
                end: '"'
            }),
            DOUBLE_QUOTED,
            SINGLE_QUOTED,
            HEREDOC
        ]
    };
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: `\\b0b[01]+(?:_[01]+)*\\b`
            },
            {
                begin: `\\b0o[0-7]+(?:_[0-7]+)*\\b`
            },
            {
                begin: `\\b0x[\\da-f]+(?:_[\\da-f]+)*\\b`
            },
            // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
            {
                begin: `(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:e[+-]?\\d+)?`
            }
        ],
        relevance: 0
    };
    const KEYWORDS = {
        keyword: // Magic constants:
        // <https://www.php.net/manual/en/language.constants.predefined.php>
        "__CLASS__ __DIR__ __FILE__ __FUNCTION__ __LINE__ __METHOD__ __NAMESPACE__ __TRAIT__ die echo exit include include_once print require require_once array abstract and as binary bool boolean break callable case catch class clone const continue declare default do double else elseif empty enddeclare endfor endforeach endif endswitch endwhile enum eval extends final finally float for foreach from global goto if implements instanceof insteadof int integer interface isset iterable list match|0 mixed new object or private protected public real return string switch throw trait try unset use var void while xor yield",
        literal: "false null true",
        built_in: // Standard PHP library:
        // <https://www.php.net/manual/en/book.spl.php>
        "Error|0 AppendIterator ArgumentCountError ArithmeticError ArrayIterator ArrayObject AssertionError BadFunctionCallException BadMethodCallException CachingIterator CallbackFilterIterator CompileError Countable DirectoryIterator DivisionByZeroError DomainException EmptyIterator ErrorException Exception FilesystemIterator FilterIterator GlobIterator InfiniteIterator InvalidArgumentException IteratorIterator LengthException LimitIterator LogicException MultipleIterator NoRewindIterator OutOfBoundsException OutOfRangeException OuterIterator OverflowException ParentIterator ParseError RangeException RecursiveArrayIterator RecursiveCachingIterator RecursiveCallbackFilterIterator RecursiveDirectoryIterator RecursiveFilterIterator RecursiveIterator RecursiveIteratorIterator RecursiveRegexIterator RecursiveTreeIterator RegexIterator RuntimeException SeekableIterator SplDoublyLinkedList SplFileInfo SplFileObject SplFixedArray SplHeap SplMaxHeap SplMinHeap SplObjectStorage SplObserver SplObserver SplPriorityQueue SplQueue SplStack SplSubject SplSubject SplTempFileObject TypeError UnderflowException UnexpectedValueException UnhandledMatchError ArrayAccess Closure Generator Iterator IteratorAggregate Serializable Stringable Throwable Traversable WeakReference WeakMap Directory __PHP_Incomplete_Class parent php_user_filter self static stdClass"
    };
    return {
        aliases: [
            "php3",
            "php4",
            "php5",
            "php6",
            "php7",
            "php8"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.COMMENT("//", "$", {
                contains: [
                    PREPROCESSOR
                ]
            }),
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    {
                        className: "doctag",
                        begin: "@[A-Za-z]+"
                    }
                ]
            }),
            hljs.COMMENT("__halt_compiler.+?;", false, {
                endsWithParent: true,
                keywords: "__halt_compiler"
            }),
            PREPROCESSOR,
            {
                className: "keyword",
                begin: /\$this\b/
            },
            VARIABLE,
            {
                // swallow composed identifiers to avoid parsing them as keywords
                begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
            },
            {
                className: "function",
                relevance: 0,
                beginKeywords: "fn function",
                end: /[;{]/,
                excludeEnd: true,
                illegal: "[$%\\[]",
                contains: [
                    {
                        beginKeywords: "use"
                    },
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        begin: "=>",
                        endsParent: true
                    },
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)",
                        excludeBegin: true,
                        excludeEnd: true,
                        keywords: KEYWORDS,
                        contains: [
                            "self",
                            VARIABLE,
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRING,
                            NUMBER
                        ]
                    }
                ]
            },
            {
                className: "class",
                variants: [
                    {
                        beginKeywords: "enum",
                        illegal: /[($"]/
                    },
                    {
                        beginKeywords: "class interface trait",
                        illegal: /[:($"]/
                    }
                ],
                relevance: 0,
                end: /\{/,
                excludeEnd: true,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                relevance: 0,
                end: ";",
                illegal: /[.']/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                beginKeywords: "use",
                relevance: 0,
                end: ";",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            STRING,
            NUMBER
        ]
    };
}
module.exports = $418013e5ee6d2d39$var$php;

});

parcelRegister("aGPf1", function(module, exports) {
/*
Language: PHP Template
Requires: xml.js, php.js
Author: Josh Goebel <hello@joshgoebel.com>
Website: https://www.php.net
Category: common
*/ function $7c859318170f5ca5$var$phpTemplate(hljs) {
    return {
        name: "PHP template",
        subLanguage: "xml",
        contains: [
            {
                begin: /<\?(php|=)?/,
                end: /\?>/,
                subLanguage: "php",
                contains: [
                    // We don't want the php closing tag ?> to close the PHP block when
                    // inside any of the following blocks:
                    {
                        begin: "/\\*",
                        end: "\\*/",
                        skip: true
                    },
                    {
                        begin: 'b"',
                        end: '"',
                        skip: true
                    },
                    {
                        begin: "b'",
                        end: "'",
                        skip: true
                    },
                    hljs.inherit(hljs.APOS_STRING_MODE, {
                        illegal: null,
                        className: null,
                        contains: null,
                        skip: true
                    }),
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        illegal: null,
                        className: null,
                        contains: null,
                        skip: true
                    })
                ]
            }
        ]
    };
}
module.exports = $7c859318170f5ca5$var$phpTemplate;

});

parcelRegister("1FKm9", function(module, exports) {
/*
Language: Plain text
Author: Egor Rogov (e.rogov@postgrespro.ru)
Description: Plain text without any highlighting.
Category: common
*/ function $137d9431d38c5522$var$plaintext(hljs) {
    return {
        name: "Plain text",
        aliases: [
            "text",
            "txt"
        ],
        disableAutodetect: true
    };
}
module.exports = $137d9431d38c5522$var$plaintext;

});

parcelRegister("7jCd3", function(module, exports) {
/*
Language: Pony
Author: Joe Eli McIlvain <joe.eli.mac@gmail.com>
Description: Pony is an open-source, object-oriented, actor-model,
             capabilities-secure, high performance programming language.
Website: https://www.ponylang.io
*/ function $5537f25d49a2cef9$var$pony(hljs) {
    const KEYWORDS = {
        keyword: "actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",
        meta: "iso val tag trn box ref",
        literal: "this false true"
    };
    const TRIPLE_QUOTE_STRING_MODE = {
        className: "string",
        begin: '"""',
        end: '"""',
        relevance: 10
    };
    const QUOTE_STRING_MODE = {
        className: "string",
        begin: '"',
        end: '"',
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const SINGLE_QUOTE_CHAR_MODE = {
        className: "string",
        begin: "'",
        end: "'",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        relevance: 0
    };
    const TYPE_NAME = {
        className: "type",
        begin: "\\b_?[A-Z][\\w]*",
        relevance: 0
    };
    const PRIMED_NAME = {
        begin: hljs.IDENT_RE + "'",
        relevance: 0
    };
    const NUMBER_MODE = {
        className: "number",
        begin: "(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
        relevance: 0
    };
    /**
   * The `FUNCTION` and `CLASS` modes were intentionally removed to simplify
   * highlighting and fix cases like
   * ```
   * interface Iterator[A: A]
   *   fun has_next(): Bool
   *   fun next(): A?
   * ```
   * where it is valid to have a function head without a body
   */ return {
        name: "Pony",
        keywords: KEYWORDS,
        contains: [
            TYPE_NAME,
            TRIPLE_QUOTE_STRING_MODE,
            QUOTE_STRING_MODE,
            SINGLE_QUOTE_CHAR_MODE,
            PRIMED_NAME,
            NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
}
module.exports = $5537f25d49a2cef9$var$pony;

});

parcelRegister("5SMky", function(module, exports) {
/*
Language: PowerShell
Description: PowerShell is a task-based command-line shell and scripting language built on .NET.
Author: David Mohundro <david@mohundro.com>
Contributors: Nicholas Blumhardt <nblumhardt@nblumhardt.com>, Victor Zhou <OiCMudkips@users.noreply.github.com>, Nicolas Le Gall <contact@nlegall.fr>
Website: https://docs.microsoft.com/en-us/powershell/
*/ function $44877c53073845a6$var$powershell(hljs) {
    const TYPES = [
        "string",
        "char",
        "byte",
        "int",
        "long",
        "bool",
        "decimal",
        "single",
        "double",
        "DateTime",
        "xml",
        "array",
        "hashtable",
        "void"
    ];
    // https://docs.microsoft.com/en-us/powershell/scripting/developer/cmdlet/approved-verbs-for-windows-powershell-commands
    const VALID_VERBS = "Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where";
    const COMPARISON_OPERATORS = "-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor";
    const KEYWORDS = {
        $pattern: /-?[A-z\.\-]+\b/,
        keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",
        // "echo" relevance has been set to 0 to avoid auto-detect conflicts with shell transcripts
        built_in: "ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"
    };
    const TITLE_NAME_RE = /\w[\w\d]*((-)[\w\d]+)*/;
    const BACKTICK_ESCAPE = {
        begin: "`[\\s\\S]",
        relevance: 0
    };
    const VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$\B/
            },
            {
                className: "keyword",
                begin: /\$this/
            },
            {
                begin: /\$[\w\d][\w\d_:]*/
            }
        ]
    };
    const LITERAL = {
        className: "literal",
        begin: /\$(null|true|false)\b/
    };
    const QUOTE_STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /@"/,
                end: /^"@/
            }
        ],
        contains: [
            BACKTICK_ESCAPE,
            VAR,
            {
                className: "variable",
                begin: /\$[A-z]/,
                end: /[^A-z]/
            }
        ]
    };
    const APOS_STRING = {
        className: "string",
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /@'/,
                end: /^'@/
            }
        ]
    };
    const PS_HELPTAGS = {
        className: "doctag",
        variants: [
            /* no paramater help tags */ {
                begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
            },
            /* one parameter help tags */ {
                begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
            }
        ]
    };
    const PS_COMMENT = hljs.inherit(hljs.COMMENT(null, null), {
        variants: [
            /* single-line comment */ {
                begin: /#/,
                end: /$/
            },
            /* multi-line comment */ {
                begin: /<#/,
                end: /#>/
            }
        ],
        contains: [
            PS_HELPTAGS
        ]
    });
    const CMDLETS = {
        className: "built_in",
        variants: [
            {
                begin: "(".concat(VALID_VERBS, ")+(-)[\\w\\d]+")
            }
        ]
    };
    const PS_CLASS = {
        className: "class",
        beginKeywords: "class enum",
        end: /\s*[{]/,
        excludeEnd: true,
        relevance: 0,
        contains: [
            hljs.TITLE_MODE
        ]
    };
    const PS_FUNCTION = {
        className: "function",
        begin: /function\s+/,
        end: /\s*\{|$/,
        excludeEnd: true,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                begin: "function",
                relevance: 0,
                className: "keyword"
            },
            {
                className: "title",
                begin: TITLE_NAME_RE,
                relevance: 0
            },
            {
                begin: /\(/,
                end: /\)/,
                className: "params",
                relevance: 0,
                contains: [
                    VAR
                ]
            }
        ]
    };
    // Using statment, plus type, plus assembly name.
    const PS_USING = {
        begin: /using\s/,
        end: /$/,
        returnBegin: true,
        contains: [
            QUOTE_STRING,
            APOS_STRING,
            {
                className: "keyword",
                begin: /(using|assembly|command|module|namespace|type)/
            }
        ]
    };
    // Comperison operators & function named parameters.
    const PS_ARGUMENTS = {
        variants: [
            // PS literals are pretty verbose so it's a good idea to accent them a bit.
            {
                className: "operator",
                begin: "(".concat(COMPARISON_OPERATORS, ")\\b")
            },
            {
                className: "literal",
                begin: /(-)[\w\d]+/,
                relevance: 0
            }
        ]
    };
    const HASH_SIGNS = {
        className: "selector-tag",
        begin: /@\B/,
        relevance: 0
    };
    // It's a very general rule so I'll narrow it a bit with some strict boundaries
    // to avoid any possible false-positive collisions!
    const PS_METHODS = {
        className: "function",
        begin: /\[.*\]\s*[\w]+[ ]??\(/,
        end: /$/,
        returnBegin: true,
        relevance: 0,
        contains: [
            {
                className: "keyword",
                begin: "(".concat(KEYWORDS.keyword.toString().replace(/\s/g, "|"), ")\\b"),
                endsParent: true,
                relevance: 0
            },
            hljs.inherit(hljs.TITLE_MODE, {
                endsParent: true
            })
        ]
    };
    const GENTLEMANS_SET = [
        // STATIC_MEMBER,
        PS_METHODS,
        PS_COMMENT,
        BACKTICK_ESCAPE,
        hljs.NUMBER_MODE,
        QUOTE_STRING,
        APOS_STRING,
        // PS_NEW_OBJECT_TYPE,
        CMDLETS,
        VAR,
        LITERAL,
        HASH_SIGNS
    ];
    const PS_TYPE = {
        begin: /\[/,
        end: /\]/,
        excludeBegin: true,
        excludeEnd: true,
        relevance: 0,
        contains: [].concat("self", GENTLEMANS_SET, {
            begin: "(" + TYPES.join("|") + ")",
            className: "built_in",
            relevance: 0
        }, {
            className: "type",
            begin: /[\.\w\d]+/,
            relevance: 0
        })
    };
    PS_METHODS.contains.unshift(PS_TYPE);
    return {
        name: "PowerShell",
        aliases: [
            "ps",
            "ps1"
        ],
        case_insensitive: true,
        keywords: KEYWORDS,
        contains: GENTLEMANS_SET.concat(PS_CLASS, PS_FUNCTION, PS_USING, PS_ARGUMENTS, PS_TYPE)
    };
}
module.exports = $44877c53073845a6$var$powershell;

});

parcelRegister("8wTNK", function(module, exports) {
/*
Language: Processing
Description: Processing is a flexible software sketchbook and a language for learning how to code within the context of the visual arts.
Author: Erik Paluka <erik.paluka@gmail.com>
Website: https://processing.org
Category: graphics
*/ function $635c98de9880f401$var$processing(hljs) {
    return {
        name: "Processing",
        keywords: {
            keyword: "BufferedReader PVector PFont PImage PGraphics HashMap boolean byte char color double float int long String Array FloatDict FloatList IntDict IntList JSONArray JSONObject Object StringDict StringList Table TableRow XML false synchronized int abstract float private char boolean static null if const for true while long throw strictfp finally protected import native final return void enum else break transient new catch instanceof byte super volatile case assert short package default double public try this switch continue throws protected public private",
            literal: "P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI",
            title: "setup draw",
            built_in: "displayHeight displayWidth mouseY mouseX mousePressed pmouseX pmouseY key keyCode pixels focused frameCount frameRate height width size createGraphics beginDraw createShape loadShape PShape arc ellipse line point quad rect triangle bezier bezierDetail bezierPoint bezierTangent curve curveDetail curvePoint curveTangent curveTightness shape shapeMode beginContour beginShape bezierVertex curveVertex endContour endShape quadraticVertex vertex ellipseMode noSmooth rectMode smooth strokeCap strokeJoin strokeWeight mouseClicked mouseDragged mouseMoved mousePressed mouseReleased mouseWheel keyPressed keyPressedkeyReleased keyTyped print println save saveFrame day hour millis minute month second year background clear colorMode fill noFill noStroke stroke alpha blue brightness color green hue lerpColor red saturation modelX modelY modelZ screenX screenY screenZ ambient emissive shininess specular add createImage beginCamera camera endCamera frustum ortho perspective printCamera printProjection cursor frameRate noCursor exit loop noLoop popStyle pushStyle redraw binary boolean byte char float hex int str unbinary unhex join match matchAll nf nfc nfp nfs split splitTokens trim append arrayCopy concat expand reverse shorten sort splice subset box sphere sphereDetail createInput createReader loadBytes loadJSONArray loadJSONObject loadStrings loadTable loadXML open parseXML saveTable selectFolder selectInput beginRaw beginRecord createOutput createWriter endRaw endRecord PrintWritersaveBytes saveJSONArray saveJSONObject saveStream saveStrings saveXML selectOutput popMatrix printMatrix pushMatrix resetMatrix rotate rotateX rotateY rotateZ scale shearX shearY translate ambientLight directionalLight lightFalloff lights lightSpecular noLights normal pointLight spotLight image imageMode loadImage noTint requestImage tint texture textureMode textureWrap blend copy filter get loadPixels set updatePixels blendMode loadShader PShaderresetShader shader createFont loadFont text textFont textAlign textLeading textMode textSize textWidth textAscent textDescent abs ceil constrain dist exp floor lerp log mag map max min norm pow round sq sqrt acos asin atan atan2 cos degrees radians sin tan noise noiseDetail noiseSeed random randomGaussian randomSeed"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $635c98de9880f401$var$processing;

});

parcelRegister("9W4AC", function(module, exports) {
/*
Language: Python profiler
Description: Python profiler results
Author: Brian Beck <exogen@gmail.com>
*/ function $73bd1743412fbed6$var$profile(hljs) {
    return {
        name: "Python profiler",
        contains: [
            hljs.C_NUMBER_MODE,
            {
                begin: "[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",
                end: ":",
                excludeEnd: true
            },
            {
                begin: "(ncalls|tottime|cumtime)",
                end: "$",
                keywords: "ncalls tottime|10 cumtime|10 filename",
                relevance: 10
            },
            {
                begin: "function calls",
                end: "$",
                contains: [
                    hljs.C_NUMBER_MODE
                ],
                relevance: 10
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "\\(",
                end: "\\)$",
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0
            }
        ]
    };
}
module.exports = $73bd1743412fbed6$var$profile;

});

parcelRegister("cRudC", function(module, exports) {
/*
Language: Prolog
Description: Prolog is a general purpose logic programming language associated with artificial intelligence and computational linguistics.
Author: Raivo Laanemets <raivo@infdot.com>
Website: https://en.wikipedia.org/wiki/Prolog
*/ function $95d1e010fa4cf422$var$prolog(hljs) {
    const ATOM = {
        begin: /[a-z][A-Za-z0-9_]*/,
        relevance: 0
    };
    const VAR = {
        className: "symbol",
        variants: [
            {
                begin: /[A-Z][a-zA-Z0-9_]*/
            },
            {
                begin: /_[A-Za-z0-9_]*/
            }
        ],
        relevance: 0
    };
    const PARENTED = {
        begin: /\(/,
        end: /\)/,
        relevance: 0
    };
    const LIST = {
        begin: /\[/,
        end: /\]/
    };
    const LINE_COMMENT = {
        className: "comment",
        begin: /%/,
        end: /$/,
        contains: [
            hljs.PHRASAL_WORDS_MODE
        ]
    };
    const BACKTICK_STRING = {
        className: "string",
        begin: /`/,
        end: /`/,
        contains: [
            hljs.BACKSLASH_ESCAPE
        ]
    };
    const CHAR_CODE = {
        className: "string",
        begin: /0'(\\'|.)/
    };
    const SPACE_CODE = {
        className: "string",
        begin: /0'\\s/ // 0'\s
    };
    const PRED_OP = {
        begin: /:-/
    };
    const inner = [
        ATOM,
        VAR,
        PARENTED,
        PRED_OP,
        LIST,
        LINE_COMMENT,
        hljs.C_BLOCK_COMMENT_MODE,
        hljs.QUOTE_STRING_MODE,
        hljs.APOS_STRING_MODE,
        BACKTICK_STRING,
        CHAR_CODE,
        SPACE_CODE,
        hljs.C_NUMBER_MODE
    ];
    PARENTED.contains = inner;
    LIST.contains = inner;
    return {
        name: "Prolog",
        contains: inner.concat([
            {
                begin: /\.$/
            }
        ])
    };
}
module.exports = $95d1e010fa4cf422$var$prolog;

});

parcelRegister("iF6qb", function(module, exports) {
/*
Language: .properties
Contributors: Valentin Aitken <valentin@nalisbg.com>, Egor Rogov <e.rogov@postgrespro.ru>
Website: https://en.wikipedia.org/wiki/.properties
Category: common, config
*/ function $d96109730631741f$var$properties(hljs) {
    // whitespaces: space, tab, formfeed
    var WS0 = "[ \\t\\f]*";
    var WS1 = "[ \\t\\f]+";
    // delimiter
    var EQUAL_DELIM = WS0 + "[:=]" + WS0;
    var WS_DELIM = WS1;
    var DELIM = "(" + EQUAL_DELIM + "|" + WS_DELIM + ")";
    var KEY_ALPHANUM = "([^\\\\\\W:= \\t\\f\\n]|\\\\.)+";
    var KEY_OTHER = "([^\\\\:= \\t\\f\\n]|\\\\.)+";
    var DELIM_AND_VALUE = {
        // skip DELIM
        end: DELIM,
        relevance: 0,
        starts: {
            // value: everything until end of line (again, taking into account backslashes)
            className: "string",
            end: /$/,
            relevance: 0,
            contains: [
                {
                    begin: "\\\\\\\\"
                },
                {
                    begin: "\\\\\\n"
                }
            ]
        }
    };
    return {
        name: ".properties",
        case_insensitive: true,
        illegal: /\S/,
        contains: [
            hljs.COMMENT("^\\s*[!#]", "$"),
            // key: everything until whitespace or = or : (taking into account backslashes)
            // case of a "normal" key
            {
                returnBegin: true,
                variants: [
                    {
                        begin: KEY_ALPHANUM + EQUAL_DELIM,
                        relevance: 1
                    },
                    {
                        begin: KEY_ALPHANUM + WS_DELIM,
                        relevance: 0
                    }
                ],
                contains: [
                    {
                        className: "attr",
                        begin: KEY_ALPHANUM,
                        endsParent: true,
                        relevance: 0
                    }
                ],
                starts: DELIM_AND_VALUE
            },
            // case of key containing non-alphanumeric chars => relevance = 0
            {
                begin: KEY_OTHER + DELIM,
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "meta",
                        begin: KEY_OTHER,
                        endsParent: true,
                        relevance: 0
                    }
                ],
                starts: DELIM_AND_VALUE
            },
            // case of an empty key
            {
                className: "attr",
                relevance: 0,
                begin: KEY_OTHER + WS0 + "$"
            }
        ]
    };
}
module.exports = $d96109730631741f$var$properties;

});

parcelRegister("6vldq", function(module, exports) {
/*
Language: Protocol Buffers
Author: Dan Tao <daniel.tao@gmail.com>
Description: Protocol buffer message definition format
Website: https://developers.google.com/protocol-buffers/docs/proto3
Category: protocols
*/ function $4bc6184ea2c66ec5$var$protobuf(hljs) {
    return {
        name: "Protocol Buffers",
        keywords: {
            keyword: "package import option optional required repeated group oneof",
            built_in: "double float int32 int64 uint32 uint64 sint32 sint64 fixed32 fixed64 sfixed32 sfixed64 bool string bytes",
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "message enum service",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        } // hack: eating everything after the first title
                    })
                ]
            },
            {
                className: "function",
                beginKeywords: "rpc",
                end: /[{;]/,
                excludeEnd: true,
                keywords: "rpc returns"
            },
            {
                // BLAH = ...;
                begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
            }
        ]
    };
}
module.exports = $4bc6184ea2c66ec5$var$protobuf;

});

parcelRegister("3Lh4K", function(module, exports) {
/*
Language: Puppet
Author: Jose Molina Colmenero <gaudy41@gmail.com>
Website: https://puppet.com/docs
Category: config
*/ function $2bd301c1bf0bb56f$var$puppet(hljs) {
    const PUPPET_KEYWORDS = {
        keyword: /* language keywords */ "and case default else elsif false if in import enherits node or true undef unless main settings $string ",
        literal: /* metaparameters */ "alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted",
        built_in: /* core facts */ "architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"
    };
    const COMMENT = hljs.COMMENT("#", "$");
    const IDENT_RE = "([A-Za-z_]|::)(\\w|::)*";
    const TITLE = hljs.inherit(hljs.TITLE_MODE, {
        begin: IDENT_RE
    });
    const VARIABLE = {
        className: "variable",
        begin: "\\$" + IDENT_RE
    };
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VARIABLE
        ],
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            }
        ]
    };
    return {
        name: "Puppet",
        aliases: [
            "pp"
        ],
        contains: [
            COMMENT,
            VARIABLE,
            STRING,
            {
                beginKeywords: "class",
                end: "\\{|;",
                illegal: /=/,
                contains: [
                    TITLE,
                    COMMENT
                ]
            },
            {
                beginKeywords: "define",
                end: /\{/,
                contains: [
                    {
                        className: "section",
                        begin: hljs.IDENT_RE,
                        endsParent: true
                    }
                ]
            },
            {
                begin: hljs.IDENT_RE + "\\s+\\{",
                returnBegin: true,
                end: /\S/,
                contains: [
                    {
                        className: "keyword",
                        begin: hljs.IDENT_RE
                    },
                    {
                        begin: /\{/,
                        end: /\}/,
                        keywords: PUPPET_KEYWORDS,
                        relevance: 0,
                        contains: [
                            STRING,
                            COMMENT,
                            {
                                begin: "[a-zA-Z_]+\\s*=>",
                                returnBegin: true,
                                end: "=>",
                                contains: [
                                    {
                                        className: "attr",
                                        begin: hljs.IDENT_RE
                                    }
                                ]
                            },
                            {
                                className: "number",
                                begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                                relevance: 0
                            },
                            VARIABLE
                        ]
                    }
                ],
                relevance: 0
            }
        ]
    };
}
module.exports = $2bd301c1bf0bb56f$var$puppet;

});

parcelRegister("5JTQt", function(module, exports) {
/*
Language: PureBASIC
Author: Tristano Ajmone <tajmone@gmail.com>
Description: Syntax highlighting for PureBASIC (v.5.00-5.60). No inline ASM highlighting. (v.1.2, May 2017)
Credits: I've taken inspiration from the PureBasic language file for GeSHi, created by Gustavo Julio Fiorenza (GuShH).
Website: https://www.purebasic.com
*/ // Base deafult colors in PB IDE: background: #FFFFDF; foreground: #000000;
function $42dc7977dc43fa1f$var$purebasic(hljs) {
    const STRINGS = {
        className: "string",
        begin: '(~)?"',
        end: '"',
        illegal: "\\n"
    };
    const CONSTANTS = {
        //  "#" + a letter or underscore + letters, digits or underscores + (optional) "$"
        className: "symbol",
        begin: "#[a-zA-Z_]\\w*\\$?"
    };
    return {
        name: "PureBASIC",
        aliases: [
            "pb",
            "pbi"
        ],
        keywords: // Keywords from all version of PureBASIC 5.00 upward ...
        "Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr",
        contains: [
            // COMMENTS | PB IDE color: #00AAAA (Persian Green)
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "function",
                begin: "\\b(Procedure|Declare)(C|CDLL|DLL)?\\b",
                end: "\\(",
                excludeEnd: true,
                returnBegin: true,
                contains: [
                    {
                        className: "keyword",
                        begin: "(Procedure|Declare)(C|CDLL|DLL)?",
                        excludeEnd: true
                    },
                    {
                        className: "type",
                        begin: "\\.\\w*"
                    },
                    hljs.UNDERSCORE_TITLE_MODE // PROCEDURE NAME | PB IDE color: #006666 (Blue Stone)
                ]
            },
            STRINGS,
            CONSTANTS
        ]
    };
}
/*  ==============================================================================
                                      CHANGELOG
    ==============================================================================
    - v.1.2 (2017-05-12)
        -- BUG-FIX: Some keywords were accidentally joyned together. Now fixed.
    - v.1.1 (2017-04-30)
        -- Updated to PureBASIC 5.60.
        -- Keywords list now built by extracting them from the PureBASIC SDK's
           "SyntaxHilighting.dll" (from each PureBASIC version). Tokens from each
           version are added to the list, and renamed or removed tokens are kept
           for the sake of covering all versions of the language from PureBASIC
           v5.00 upward. (NOTE: currently, there are no renamed or deprecated
           tokens in the keywords list). For more info, see:
           -- http://www.purebasic.fr/english/viewtopic.php?&p=506269
           -- https://github.com/tajmone/purebasic-archives/tree/master/syntax-highlighting/guidelines
    - v.1.0 (April 2016)
        -- First release
        -- Keywords list taken and adapted from GuShH's (Gustavo Julio Fiorenza)
           PureBasic language file for GeSHi:
           -- https://github.com/easybook/geshi/blob/master/geshi/purebasic.php
*/ module.exports = $42dc7977dc43fa1f$var$purebasic;

});

parcelRegister("ly5Ff", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $fb012ac57b5ce79e$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $fb012ac57b5ce79e$var$lookahead(re) {
    return $fb012ac57b5ce79e$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $fb012ac57b5ce79e$var$concat(...args) {
    const joined = args.map((x)=>$fb012ac57b5ce79e$var$source(x)).join("");
    return joined;
}
/*
Language: Python
Description: Python is an interpreted, object-oriented, high-level programming language with dynamic semantics.
Website: https://www.python.org
Category: common
*/ function $fb012ac57b5ce79e$var$python(hljs) {
    const RESERVED_WORDS = [
        "and",
        "as",
        "assert",
        "async",
        "await",
        "break",
        "class",
        "continue",
        "def",
        "del",
        "elif",
        "else",
        "except",
        "finally",
        "for",
        "from",
        "global",
        "if",
        "import",
        "in",
        "is",
        "lambda",
        "nonlocal|10",
        "not",
        "or",
        "pass",
        "raise",
        "return",
        "try",
        "while",
        "with",
        "yield"
    ];
    const BUILT_INS = [
        "__import__",
        "abs",
        "all",
        "any",
        "ascii",
        "bin",
        "bool",
        "breakpoint",
        "bytearray",
        "bytes",
        "callable",
        "chr",
        "classmethod",
        "compile",
        "complex",
        "delattr",
        "dict",
        "dir",
        "divmod",
        "enumerate",
        "eval",
        "exec",
        "filter",
        "float",
        "format",
        "frozenset",
        "getattr",
        "globals",
        "hasattr",
        "hash",
        "help",
        "hex",
        "id",
        "input",
        "int",
        "isinstance",
        "issubclass",
        "iter",
        "len",
        "list",
        "locals",
        "map",
        "max",
        "memoryview",
        "min",
        "next",
        "object",
        "oct",
        "open",
        "ord",
        "pow",
        "print",
        "property",
        "range",
        "repr",
        "reversed",
        "round",
        "set",
        "setattr",
        "slice",
        "sorted",
        "staticmethod",
        "str",
        "sum",
        "super",
        "tuple",
        "type",
        "vars",
        "zip"
    ];
    const LITERALS = [
        "__debug__",
        "Ellipsis",
        "False",
        "None",
        "NotImplemented",
        "True"
    ];
    // https://docs.python.org/3/library/typing.html
    // TODO: Could these be supplemented by a CamelCase matcher in certain
    // contexts, leaving these remaining only for relevance hinting?
    const TYPES = [
        "Any",
        "Callable",
        "Coroutine",
        "Dict",
        "List",
        "Literal",
        "Generic",
        "Optional",
        "Sequence",
        "Set",
        "Tuple",
        "Type",
        "Union"
    ];
    const KEYWORDS = {
        $pattern: /[A-Za-z]\w+|__\w+__/,
        keyword: RESERVED_WORDS,
        built_in: BUILT_INS,
        literal: LITERALS,
        type: TYPES
    };
    const PROMPT = {
        className: "meta",
        begin: /^(>>>|\.\.\.) /
    };
    const SUBST = {
        className: "subst",
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS,
        illegal: /#/
    };
    const LITERAL_BRACKET = {
        begin: /\{\{/,
        relevance: 0
    };
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT
                ],
                relevance: 10
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                end: /'''/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                end: /"""/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    PROMPT,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([uU]|[rR])'/,
                end: /'/,
                relevance: 10
            },
            {
                begin: /([uU]|[rR])"/,
                end: /"/,
                relevance: 10
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])'/,
                end: /'/
            },
            {
                begin: /([bB]|[bB][rR]|[rR][bB])"/,
                end: /"/
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])'/,
                end: /'/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            {
                begin: /([fF][rR]|[rR][fF]|[fF])"/,
                end: /"/,
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    LITERAL_BRACKET,
                    SUBST
                ]
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
    // https://docs.python.org/3.9/reference/lexical_analysis.html#numeric-literals
    const digitpart = "[0-9](_?[0-9])*";
    const pointfloat = `(\\b(${digitpart}))?\\.(${digitpart})|\\b(${digitpart})\\.`;
    const NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            // exponentfloat, pointfloat
            // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
            // optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            // Note: no leading \b because floats can start with a decimal point
            // and we don't want to mishandle e.g. `fn(.5)`,
            // no trailing \b for pointfloat because it can end with a decimal point
            // and we don't want to mishandle e.g. `0..hex()`; this should be safe
            // because both MUST contain a decimal point and so cannot be confused with
            // the interior part of an identifier
            {
                begin: `(\\b(${digitpart})|(${pointfloat}))[eE][+-]?(${digitpart})[jJ]?\\b`
            },
            {
                begin: `(${pointfloat})[jJ]?`
            },
            // decinteger, bininteger, octinteger, hexinteger
            // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
            // optionally "long" in Python 2
            // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
            // decinteger is optionally imaginary
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: "\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?\\b"
            },
            {
                begin: "\\b0[bB](_?[01])+[lL]?\\b"
            },
            {
                begin: "\\b0[oO](_?[0-7])+[lL]?\\b"
            },
            {
                begin: "\\b0[xX](_?[0-9a-fA-F])+[lL]?\\b"
            },
            // imagnumber (digitpart-based)
            // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
            {
                begin: `\\b(${digitpart})[jJ]\\b`
            }
        ]
    };
    const COMMENT_TYPE = {
        className: "comment",
        begin: $fb012ac57b5ce79e$var$lookahead(/# type:/),
        end: /$/,
        keywords: KEYWORDS,
        contains: [
            {
                begin: /# type:/
            },
            // comment within a datatype comment includes no keywords
            {
                begin: /#/,
                end: /\b\B/,
                endsWithParent: true
            }
        ]
    };
    const PARAMS = {
        className: "params",
        variants: [
            // Exclude params in functions without params
            {
                className: "",
                begin: /\(\s*\)/,
                skip: true
            },
            {
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    "self",
                    PROMPT,
                    NUMBER,
                    STRING,
                    hljs.HASH_COMMENT_MODE
                ]
            }
        ]
    };
    SUBST.contains = [
        STRING,
        NUMBER,
        PROMPT
    ];
    return {
        name: "Python",
        aliases: [
            "py",
            "gyp",
            "ipython"
        ],
        keywords: KEYWORDS,
        illegal: /(<\/|->|\?)|=>/,
        contains: [
            PROMPT,
            NUMBER,
            {
                // very common convention
                begin: /\bself\b/
            },
            {
                // eat "if" prior to string so that it won't accidentally be
                // labeled as an f-string
                beginKeywords: "if",
                relevance: 0
            },
            STRING,
            COMMENT_TYPE,
            hljs.HASH_COMMENT_MODE,
            {
                variants: [
                    {
                        className: "function",
                        beginKeywords: "def"
                    },
                    {
                        className: "class",
                        beginKeywords: "class"
                    }
                ],
                end: /:/,
                illegal: /[${=;\n,]/,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    PARAMS,
                    {
                        begin: /->/,
                        endsWithParent: true,
                        keywords: KEYWORDS
                    }
                ]
            },
            {
                className: "meta",
                begin: /^[\t ]*@/,
                end: /(?=#)|$/,
                contains: [
                    NUMBER,
                    PARAMS,
                    STRING
                ]
            }
        ]
    };
}
module.exports = $fb012ac57b5ce79e$var$python;

});

parcelRegister("34yz7", function(module, exports) {
/*
Language: Python REPL
Requires: python.js
Author: Josh Goebel <hello@joshgoebel.com>
Category: common
*/ function $23cc8ec733086e01$var$pythonRepl(hljs) {
    return {
        aliases: [
            "pycon"
        ],
        contains: [
            {
                className: "meta",
                starts: {
                    // a space separates the REPL prefix from the actual code
                    // this is purely for cleaner HTML output
                    end: / |$/,
                    starts: {
                        end: "$",
                        subLanguage: "python"
                    }
                },
                variants: [
                    {
                        begin: /^>>>(?=[ ]|$)/
                    },
                    {
                        begin: /^\.\.\.(?=[ ]|$)/
                    }
                ]
            }
        ]
    };
}
module.exports = $23cc8ec733086e01$var$pythonRepl;

});

parcelRegister("bzIMw", function(module, exports) {
/*
Language: Q
Description: Q is a vector-based functional paradigm programming language built into the kdb+ database.
             (K/Q/Kdb+ from Kx Systems)
Author: Sergey Vidyuk <svidyuk@gmail.com>
Website: https://kx.com/connect-with-us/developers/
*/ function $86d5b346fa45059a$var$q(hljs) {
    const KEYWORDS = {
        $pattern: /(`?)[A-Za-z0-9_]+\b/,
        keyword: "do while select delete by update from",
        literal: "0b 1b",
        built_in: "neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",
        type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
    };
    return {
        name: "Q",
        aliases: [
            "k",
            "kdb"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $86d5b346fa45059a$var$q;

});

parcelRegister("6fYUw", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $48e3645b5024920a$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $48e3645b5024920a$var$concat(...args) {
    const joined = args.map((x)=>$48e3645b5024920a$var$source(x)).join("");
    return joined;
}
/*
Language: QML
Requires: javascript.js, xml.js
Author: John Foster <jfoster@esri.com>
Description: Syntax highlighting for the Qt Quick QML scripting language, based mostly off
             the JavaScript parser.
Website: https://doc.qt.io/qt-5/qmlapplications.html
Category: scripting
*/ function $48e3645b5024920a$var$qml(hljs) {
    const KEYWORDS = {
        keyword: "in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",
        literal: "true false null undefined NaN Infinity",
        built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise"
    };
    const QML_IDENT_RE = "[a-zA-Z_][a-zA-Z0-9\\._]*";
    // Isolate property statements. Ends at a :, =, ;, ,, a comment or end of line.
    // Use property class.
    const PROPERTY = {
        className: "keyword",
        begin: "\\bproperty\\b",
        starts: {
            className: "string",
            end: "(:|=|;|,|//|/\\*|$)",
            returnEnd: true
        }
    };
    // Isolate signal statements. Ends at a ) a comment or end of line.
    // Use property class.
    const SIGNAL = {
        className: "keyword",
        begin: "\\bsignal\\b",
        starts: {
            className: "string",
            end: "(\\(|:|=|;|,|//|/\\*|$)",
            returnEnd: true
        }
    };
    // id: is special in QML. When we see id: we want to mark the id: as attribute and
    // emphasize the token following.
    const ID_ID = {
        className: "attribute",
        begin: "\\bid\\s*:",
        starts: {
            className: "string",
            end: QML_IDENT_RE,
            returnEnd: false
        }
    };
    // Find QML object attribute. An attribute is a QML identifier followed by :.
    // Unfortunately it's hard to know where it ends, as it may contain scalars,
    // objects, object definitions, or javascript. The true end is either when the parent
    // ends or the next attribute is detected.
    const QML_ATTRIBUTE = {
        begin: QML_IDENT_RE + "\\s*:",
        returnBegin: true,
        contains: [
            {
                className: "attribute",
                begin: QML_IDENT_RE,
                end: "\\s*:",
                excludeEnd: true,
                relevance: 0
            }
        ],
        relevance: 0
    };
    // Find QML object. A QML object is a QML identifier followed by { and ends at the matching }.
    // All we really care about is finding IDENT followed by { and just mark up the IDENT and ignore the {.
    const QML_OBJECT = {
        begin: $48e3645b5024920a$var$concat(QML_IDENT_RE, /\s*\{/),
        end: /\{/,
        returnBegin: true,
        relevance: 0,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                begin: QML_IDENT_RE
            })
        ]
    };
    return {
        name: "QML",
        aliases: [
            "qt"
        ],
        case_insensitive: false,
        keywords: KEYWORDS,
        contains: [
            {
                className: "meta",
                begin: /^\s*['"]use (strict|asm)['"]/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    {
                        className: "subst",
                        begin: "\\$\\{",
                        end: "\\}"
                    }
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "number",
                variants: [
                    {
                        begin: "\\b(0[bB][01]+)"
                    },
                    {
                        begin: "\\b(0[oO][0-7]+)"
                    },
                    {
                        begin: hljs.C_NUMBER_RE
                    }
                ],
                relevance: 0
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    hljs.C_LINE_COMMENT_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    hljs.REGEXP_MODE,
                    {
                        begin: /</,
                        end: />\s*[);\]]/,
                        relevance: 0,
                        subLanguage: "xml"
                    }
                ],
                relevance: 0
            },
            SIGNAL,
            PROPERTY,
            {
                className: "function",
                beginKeywords: "function",
                end: /\{/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /[A-Za-z$_][0-9A-Za-z$_]*/
                    }),
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: true,
                        excludeEnd: true,
                        contains: [
                            hljs.C_LINE_COMMENT_MODE,
                            hljs.C_BLOCK_COMMENT_MODE
                        ]
                    }
                ],
                illegal: /\[|%/
            },
            {
                // hack: prevents detection of keywords after dots
                begin: "\\." + hljs.IDENT_RE,
                relevance: 0
            },
            ID_ID,
            QML_ATTRIBUTE,
            QML_OBJECT
        ],
        illegal: /#/
    };
}
module.exports = $48e3645b5024920a$var$qml;

});

parcelRegister("bqL6M", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $8526aa283fa4b9ec$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $8526aa283fa4b9ec$var$lookahead(re) {
    return $8526aa283fa4b9ec$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $8526aa283fa4b9ec$var$concat(...args) {
    const joined = args.map((x)=>$8526aa283fa4b9ec$var$source(x)).join("");
    return joined;
}
/*
Language: R
Description: R is a free software environment for statistical computing and graphics.
Author: Joe Cheng <joe@rstudio.org>
Contributors: Konrad Rudolph <konrad.rudolph@gmail.com>
Website: https://www.r-project.org
Category: common,scientific
*/ /** @type LanguageFn */ function $8526aa283fa4b9ec$var$r(hljs) {
    // Identifiers in R cannot start with `_`, but they can start with `.` if it
    // is not immediately followed by a digit.
    // R also supports quoted identifiers, which are near-arbitrary sequences
    // delimited by backticks (`…`), which may contain escape sequences. These are
    // handled in a separate mode. See `test/markup/r/names.txt` for examples.
    // FIXME: Support Unicode identifiers.
    const IDENT_RE = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/;
    const SIMPLE_IDENT = /[a-zA-Z][a-zA-Z_0-9]*/;
    return {
        name: "R",
        // only in Haskell, not R
        illegal: /->/,
        keywords: {
            $pattern: IDENT_RE,
            keyword: "function if in break next repeat else for while",
            literal: "NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",
            built_in: // Builtin constants
            "LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"
        },
        compilerExtensions: [
            // allow beforeMatch to act as a "qualifier" for the match
            // the full match begin must be [beforeMatch][begin]
            (mode, parent)=>{
                if (!mode.beforeMatch) return;
                // starts conflicts with endsParent which we need to make sure the child
                // rule is not matched multiple times
                if (mode.starts) throw new Error("beforeMatch cannot be used with starts");
                const originalMode = Object.assign({}, mode);
                Object.keys(mode).forEach((key)=>{
                    delete mode[key];
                });
                mode.begin = $8526aa283fa4b9ec$var$concat(originalMode.beforeMatch, $8526aa283fa4b9ec$var$lookahead(originalMode.begin));
                mode.starts = {
                    relevance: 0,
                    contains: [
                        Object.assign(originalMode, {
                            endsParent: true
                        })
                    ]
                };
                mode.relevance = 0;
                delete originalMode.beforeMatch;
            }
        ],
        contains: [
            // Roxygen comments
            hljs.COMMENT(/#'/, /$/, {
                contains: [
                    {
                        // Handle `@examples` separately to cause all subsequent code
                        // until the next `@`-tag on its own line to be kept as-is,
                        // preventing highlighting. This code is example R code, so nested
                        // doctags shouldn’t be treated as such. See
                        // `test/markup/r/roxygen.txt` for an example.
                        className: "doctag",
                        begin: "@examples",
                        starts: {
                            contains: [
                                {
                                    begin: /\n/
                                },
                                {
                                    begin: /#'\s*(?=@[a-zA-Z]+)/,
                                    endsParent: true
                                },
                                {
                                    begin: /#'/,
                                    end: /$/,
                                    excludeBegin: true
                                }
                            ]
                        }
                    },
                    {
                        // Handle `@param` to highlight the parameter name following
                        // after.
                        className: "doctag",
                        begin: "@param",
                        end: /$/,
                        contains: [
                            {
                                className: "variable",
                                variants: [
                                    {
                                        begin: IDENT_RE
                                    },
                                    {
                                        begin: /`(?:\\.|[^`\\])+`/
                                    }
                                ],
                                endsParent: true
                            }
                        ]
                    },
                    {
                        className: "doctag",
                        begin: /@[a-zA-Z]+/
                    },
                    {
                        className: "meta-keyword",
                        begin: /\\[a-zA-Z]+/
                    }
                ]
            }),
            hljs.HASH_COMMENT_MODE,
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]"(-*)\(/,
                        end: /\)(-*)"/
                    }),
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]"(-*)\{/,
                        end: /\}(-*)"/
                    }),
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]"(-*)\[/,
                        end: /\](-*)"/
                    }),
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]'(-*)\(/,
                        end: /\)(-*)'/
                    }),
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]'(-*)\{/,
                        end: /\}(-*)'/
                    }),
                    hljs.END_SAME_AS_BEGIN({
                        begin: /[rR]'(-*)\[/,
                        end: /\](-*)'/
                    }),
                    {
                        begin: '"',
                        end: '"',
                        relevance: 0
                    },
                    {
                        begin: "'",
                        end: "'",
                        relevance: 0
                    }
                ]
            },
            {
                className: "number",
                relevance: 0,
                beforeMatch: /([^a-zA-Z0-9._])/,
                variants: [
                    // TODO: replace with negative look-behind when available
                    // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/ },
                    // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/ },
                    // { begin: /(?<![a-zA-Z0-9._])(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/ }
                    {
                        // Special case: only hexadecimal binary powers can contain fractions.
                        match: /0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/
                    },
                    {
                        match: /0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/
                    },
                    {
                        match: /(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/
                    }
                ]
            },
            {
                // infix operator
                begin: "%",
                end: "%"
            },
            // relevance boost for assignment
            {
                begin: $8526aa283fa4b9ec$var$concat(SIMPLE_IDENT, "\\s+<-\\s+")
            },
            {
                // escaped identifier
                begin: "`",
                end: "`",
                contains: [
                    {
                        begin: /\\./
                    }
                ]
            }
        ]
    };
}
module.exports = $8526aa283fa4b9ec$var$r;

});

parcelRegister("fKypu", function(module, exports) {
/*
Language: ReasonML
Description: Reason lets you write simple, fast and quality type safe code while leveraging both the JavaScript & OCaml ecosystems.
Website: https://reasonml.github.io
Author: Gidi Meir Morris <oss@gidi.io>
Category: functional
*/ function $b775d80ae1a4a21a$var$reasonml(hljs) {
    function orReValues(ops) {
        return ops.map(function(op) {
            return op.split("").map(function(char) {
                return "\\" + char;
            }).join("");
        }).join("|");
    }
    const RE_IDENT = "~?[a-z$_][0-9a-zA-Z$_]*";
    const RE_MODULE_IDENT = "`?[A-Z$_][0-9a-zA-Z$_]*";
    const RE_PARAM_TYPEPARAM = "'?[a-z$_][0-9a-z$_]*";
    const RE_PARAM_TYPE = "\\s*:\\s*[a-z$_][0-9a-z$_]*(\\(\\s*(" + RE_PARAM_TYPEPARAM + "\\s*(," + RE_PARAM_TYPEPARAM + "\\s*)*)?\\))?";
    const RE_PARAM = RE_IDENT + "(" + RE_PARAM_TYPE + "){0,2}";
    const RE_OPERATOR = "(" + orReValues([
        "||",
        "++",
        "**",
        "+.",
        "*",
        "/",
        "*.",
        "/.",
        "..."
    ]) + "|\\|>|&&|==|===)";
    const RE_OPERATOR_SPACED = "\\s+" + RE_OPERATOR + "\\s+";
    const KEYWORDS = {
        keyword: "and as asr assert begin class constraint do done downto else end exception external for fun function functor if in include inherit initializer land lazy let lor lsl lsr lxor match method mod module mutable new nonrec object of open or private rec sig struct then to try type val virtual when while with",
        built_in: "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 ref string unit ",
        literal: "true false"
    };
    const RE_NUMBER = "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)";
    const NUMBER_MODE = {
        className: "number",
        relevance: 0,
        variants: [
            {
                begin: RE_NUMBER
            },
            {
                begin: "\\(-" + RE_NUMBER + "\\)"
            }
        ]
    };
    const OPERATOR_MODE = {
        className: "operator",
        relevance: 0,
        begin: RE_OPERATOR
    };
    const LIST_CONTENTS_MODES = [
        {
            className: "identifier",
            relevance: 0,
            begin: RE_IDENT
        },
        OPERATOR_MODE,
        NUMBER_MODE
    ];
    const MODULE_ACCESS_CONTENTS = [
        hljs.QUOTE_STRING_MODE,
        OPERATOR_MODE,
        {
            className: "module",
            begin: "\\b" + RE_MODULE_IDENT,
            returnBegin: true,
            end: ".",
            contains: [
                {
                    className: "identifier",
                    begin: RE_MODULE_IDENT,
                    relevance: 0
                }
            ]
        }
    ];
    const PARAMS_CONTENTS = [
        {
            className: "module",
            begin: "\\b" + RE_MODULE_IDENT,
            returnBegin: true,
            end: ".",
            relevance: 0,
            contains: [
                {
                    className: "identifier",
                    begin: RE_MODULE_IDENT,
                    relevance: 0
                }
            ]
        }
    ];
    const PARAMS_MODE = {
        begin: RE_IDENT,
        end: "(,|\\n|\\))",
        relevance: 0,
        contains: [
            OPERATOR_MODE,
            {
                className: "typing",
                begin: ":",
                end: "(,|\\n)",
                returnBegin: true,
                relevance: 0,
                contains: PARAMS_CONTENTS
            }
        ]
    };
    const FUNCTION_BLOCK_MODE = {
        className: "function",
        relevance: 0,
        keywords: KEYWORDS,
        variants: [
            {
                begin: "\\s(\\(\\.?.*?\\)|" + RE_IDENT + ")\\s*=>",
                end: "\\s*=>",
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "params",
                        variants: [
                            {
                                begin: RE_IDENT
                            },
                            {
                                begin: RE_PARAM
                            },
                            {
                                begin: /\(\s*\)/
                            }
                        ]
                    }
                ]
            },
            {
                begin: "\\s\\(\\.?[^;\\|]*\\)\\s*=>",
                end: "\\s=>",
                returnBegin: true,
                relevance: 0,
                contains: [
                    {
                        className: "params",
                        relevance: 0,
                        variants: [
                            PARAMS_MODE
                        ]
                    }
                ]
            },
            {
                begin: "\\(\\.\\s" + RE_IDENT + "\\)\\s*=>"
            }
        ]
    };
    MODULE_ACCESS_CONTENTS.push(FUNCTION_BLOCK_MODE);
    const CONSTRUCTOR_MODE = {
        className: "constructor",
        begin: RE_MODULE_IDENT + "\\(",
        end: "\\)",
        illegal: "\\n",
        keywords: KEYWORDS,
        contains: [
            hljs.QUOTE_STRING_MODE,
            OPERATOR_MODE,
            {
                className: "params",
                begin: "\\b" + RE_IDENT
            }
        ]
    };
    const PATTERN_MATCH_BLOCK_MODE = {
        className: "pattern-match",
        begin: "\\|",
        returnBegin: true,
        keywords: KEYWORDS,
        end: "=>",
        relevance: 0,
        contains: [
            CONSTRUCTOR_MODE,
            OPERATOR_MODE,
            {
                relevance: 0,
                className: "constructor",
                begin: RE_MODULE_IDENT
            }
        ]
    };
    const MODULE_ACCESS_MODE = {
        className: "module-access",
        keywords: KEYWORDS,
        returnBegin: true,
        variants: [
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+" + RE_IDENT
            },
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+\\(",
                end: "\\)",
                returnBegin: true,
                contains: [
                    FUNCTION_BLOCK_MODE,
                    {
                        begin: "\\(",
                        end: "\\)",
                        skip: true
                    }
                ].concat(MODULE_ACCESS_CONTENTS)
            },
            {
                begin: "\\b(" + RE_MODULE_IDENT + "\\.)+\\{",
                end: /\}/
            }
        ],
        contains: MODULE_ACCESS_CONTENTS
    };
    PARAMS_CONTENTS.push(MODULE_ACCESS_MODE);
    return {
        name: "ReasonML",
        aliases: [
            "re"
        ],
        keywords: KEYWORDS,
        illegal: "(:-|:=|\\$\\{|\\+=)",
        contains: [
            hljs.COMMENT("/\\*", "\\*/", {
                illegal: "^(#,\\/\\/)"
            }),
            {
                className: "character",
                begin: "'(\\\\[^']+|[^'])'",
                illegal: "\\n",
                relevance: 0
            },
            hljs.QUOTE_STRING_MODE,
            {
                className: "literal",
                begin: "\\(\\)",
                relevance: 0
            },
            {
                className: "literal",
                begin: "\\[\\|",
                end: "\\|\\]",
                relevance: 0,
                contains: LIST_CONTENTS_MODES
            },
            {
                className: "literal",
                begin: "\\[",
                end: "\\]",
                relevance: 0,
                contains: LIST_CONTENTS_MODES
            },
            CONSTRUCTOR_MODE,
            {
                className: "operator",
                begin: RE_OPERATOR_SPACED,
                illegal: "-->",
                relevance: 0
            },
            NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            PATTERN_MATCH_BLOCK_MODE,
            FUNCTION_BLOCK_MODE,
            {
                className: "module-def",
                begin: "\\bmodule\\s+" + RE_IDENT + "\\s+" + RE_MODULE_IDENT + "\\s+=\\s+\\{",
                end: /\}/,
                returnBegin: true,
                keywords: KEYWORDS,
                relevance: 0,
                contains: [
                    {
                        className: "module",
                        relevance: 0,
                        begin: RE_MODULE_IDENT
                    },
                    {
                        begin: /\{/,
                        end: /\}/,
                        skip: true
                    }
                ].concat(MODULE_ACCESS_CONTENTS)
            },
            MODULE_ACCESS_MODE
        ]
    };
}
module.exports = $b775d80ae1a4a21a$var$reasonml;

});

parcelRegister("f88HE", function(module, exports) {
/*
Language: RenderMan RIB
Author: Konstantin Evdokimenko <qewerty@gmail.com>
Contributors: Shuen-Huei Guan <drake.guan@gmail.com>
Website: https://renderman.pixar.com/resources/RenderMan_20/ribBinding.html
Category: graphics
*/ function $b03e5a9d94906f28$var$rib(hljs) {
    return {
        name: "RenderMan RIB",
        keywords: "ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",
        illegal: "</",
        contains: [
            hljs.HASH_COMMENT_MODE,
            hljs.C_NUMBER_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE
        ]
    };
}
module.exports = $b03e5a9d94906f28$var$rib;

});

parcelRegister("gbKHl", function(module, exports) {
/*
Language: Roboconf
Author: Vincent Zurczak <vzurczak@linagora.com>
Description: Syntax highlighting for Roboconf's DSL
Website: http://roboconf.net
Category: config
*/ function $bc91e5af6c25d38b$var$roboconf(hljs) {
    const IDENTIFIER = "[a-zA-Z-_][^\\n{]+\\{";
    const PROPERTY = {
        className: "attribute",
        begin: /[a-zA-Z-_]+/,
        end: /\s*:/,
        excludeEnd: true,
        starts: {
            end: ";",
            relevance: 0,
            contains: [
                {
                    className: "variable",
                    begin: /\.[a-zA-Z-_]+/
                },
                {
                    className: "keyword",
                    begin: /\(optional\)/
                }
            ]
        }
    };
    return {
        name: "Roboconf",
        aliases: [
            "graph",
            "instances"
        ],
        case_insensitive: true,
        keywords: "import",
        contains: [
            // Facet sections
            {
                begin: "^facet " + IDENTIFIER,
                end: /\}/,
                keywords: "facet",
                contains: [
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Instance sections
            {
                begin: "^\\s*instance of " + IDENTIFIER,
                end: /\}/,
                keywords: "name count channels instance-data instance-state instance of",
                illegal: /\S/,
                contains: [
                    "self",
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Component sections
            {
                begin: "^" + IDENTIFIER,
                end: /\}/,
                contains: [
                    PROPERTY,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            // Comments
            hljs.HASH_COMMENT_MODE
        ]
    };
}
module.exports = $bc91e5af6c25d38b$var$roboconf;

});

parcelRegister("iQUn5", function(module, exports) {
/*
Language: Microtik RouterOS script
Author: Ivan Dementev <ivan_div@mail.ru>
Description: Scripting host provides a way to automate some router maintenance tasks by means of executing user-defined scripts bounded to some event occurrence
Website: https://wiki.mikrotik.com/wiki/Manual:Scripting
*/ // Colors from RouterOS terminal:
//   green        - #0E9A00
//   teal         - #0C9A9A
//   purple       - #99069A
//   light-brown  - #9A9900
function $db98cf8453bfa2a2$var$routeros(hljs) {
    const STATEMENTS = "foreach do while for if from to step else on-error and or not in";
    // Global commands: Every global command should start with ":" token, otherwise it will be treated as variable.
    const GLOBAL_COMMANDS = "global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime";
    // Common commands: Following commands available from most sub-menus:
    const COMMON_COMMANDS = "add remove enable disable set get print export edit find run debug error info warning";
    const LITERALS = "true false yes no nothing nil null";
    const OBJECTS = "traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw";
    const VAR = {
        className: "variable",
        variants: [
            {
                begin: /\$[\w\d#@][\w\d_]*/
            },
            {
                begin: /\$\{(.*?)\}/
            }
        ]
    };
    const QUOTE_STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        contains: [
            hljs.BACKSLASH_ESCAPE,
            VAR,
            {
                className: "variable",
                begin: /\$\(/,
                end: /\)/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
    const APOS_STRING = {
        className: "string",
        begin: /'/,
        end: /'/
    };
    return {
        name: "Microtik RouterOS script",
        aliases: [
            "mikrotik"
        ],
        case_insensitive: true,
        keywords: {
            $pattern: /:?[\w-]+/,
            literal: LITERALS,
            keyword: STATEMENTS + " :" + STATEMENTS.split(" ").join(" :") + " :" + GLOBAL_COMMANDS.split(" ").join(" :")
        },
        contains: [
            {
                variants: [
                    {
                        begin: /\/\*/,
                        end: /\*\//
                    },
                    {
                        begin: /\/\//,
                        end: /$/
                    },
                    {
                        begin: /<\//,
                        end: />/
                    }
                ],
                illegal: /./
            },
            hljs.COMMENT("^#", "$"),
            QUOTE_STRING,
            APOS_STRING,
            VAR,
            // attribute=value
            {
                // > is to avoid matches with => in other grammars
                begin: /[\w-]+=([^\s{}[\]()>]+)/,
                relevance: 0,
                returnBegin: true,
                contains: [
                    {
                        className: "attribute",
                        begin: /[^=]+/
                    },
                    {
                        begin: /=/,
                        endsWithParent: true,
                        relevance: 0,
                        contains: [
                            QUOTE_STRING,
                            APOS_STRING,
                            VAR,
                            {
                                className: "literal",
                                begin: "\\b(" + LITERALS.split(" ").join("|") + ")\\b"
                            },
                            {
                                // Do not format unclassified values. Needed to exclude highlighting of values as built_in.
                                begin: /("[^"]*"|[^\s{}[\]]+)/
                            }
                        ]
                    }
                ]
            },
            {
                // HEX values
                className: "number",
                begin: /\*[0-9a-fA-F]+/
            },
            {
                begin: "\\b(" + COMMON_COMMANDS.split(" ").join("|") + ")([\\s[(\\]|])",
                returnBegin: true,
                contains: [
                    {
                        className: "builtin-name",
                        begin: /\w+/
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "(\\.\\./|/|\\s)((" + OBJECTS.split(" ").join("|") + ");?\\s)+"
                    },
                    {
                        begin: /\.\./,
                        relevance: 0
                    }
                ]
            }
        ]
    };
}
module.exports = $db98cf8453bfa2a2$var$routeros;

});

parcelRegister("2mZxq", function(module, exports) {
/*
Language: RenderMan RSL
Author: Konstantin Evdokimenko <qewerty@gmail.com>
Contributors: Shuen-Huei Guan <drake.guan@gmail.com>
Website: https://renderman.pixar.com/resources/RenderMan_20/shadingLanguage.html
Category: graphics
*/ function $1b9d5f0a1928a617$var$rsl(hljs) {
    return {
        name: "RenderMan RSL",
        keywords: {
            keyword: "float color point normal vector matrix while for if do return else break extern continue",
            built_in: "abs acos ambient area asin atan atmosphere attribute calculatenormal ceil cellnoise clamp comp concat cos degrees depth Deriv diffuse distance Du Dv environment exp faceforward filterstep floor format fresnel incident length lightsource log match max min mod noise normalize ntransform opposite option phong pnoise pow printf ptlined radians random reflect refract renderinfo round setcomp setxcomp setycomp setzcomp shadow sign sin smoothstep specular specularbrdf spline sqrt step tan texture textureinfo trace transform vtransform xcomp ycomp zcomp"
        },
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "#",
                end: "$"
            },
            {
                className: "class",
                beginKeywords: "surface displacement light volume imager",
                end: "\\("
            },
            {
                beginKeywords: "illuminate illuminance gather",
                end: "\\("
            }
        ]
    };
}
module.exports = $1b9d5f0a1928a617$var$rsl;

});

parcelRegister("gfBOr", function(module, exports) {
/*
Language: Oracle Rules Language
Author: Jason Jacobson <jason.a.jacobson@gmail.com>
Description: The Oracle Utilities Rules Language is used to program the Oracle Utilities Applications acquired from LODESTAR Corporation.  The products include Billing Component, LPSS, Pricing Component etc. through version 1.6.1.
Website: https://docs.oracle.com/cd/E17904_01/dev.1111/e10227/rlref.htm
Category: enterprise
*/ function $bd4b60d4797c8bd0$var$ruleslanguage(hljs) {
    return {
        name: "Oracle Rules Language",
        keywords: {
            keyword: "BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",
            built_in: "IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "literal",
                variants: [
                    {
                        begin: "#\\s+",
                        relevance: 0
                    },
                    {
                        begin: "#[a-zA-Z .]+"
                    }
                ]
            }
        ]
    };
}
module.exports = $bd4b60d4797c8bd0$var$ruleslanguage;

});

parcelRegister("bfORy", function(module, exports) {
/*
Language: Rust
Author: Andrey Vlasovskikh <andrey.vlasovskikh@gmail.com>
Contributors: Roman Shmatov <romanshmatov@gmail.com>, Kasper Andersen <kma_untrusted@protonmail.com>
Website: https://www.rust-lang.org
Category: common, system
*/ function $83188cbb2ce5d0ca$var$rust(hljs) {
    const NUM_SUFFIX = "([ui](8|16|32|64|128|size)|f(32|64))?";
    const KEYWORDS = "abstract as async await become box break const continue crate do dyn else enum extern false final fn for if impl in let loop macro match mod move mut override priv pub ref return self Self static struct super trait true try type typeof unsafe unsized use virtual where while yield";
    const BUILTINS = // functions
    "drop i8 i16 i32 i64 i128 isize u8 u16 u32 u64 u128 usize f32 f64 str char bool Box Option Result String Vec Copy Send Sized Sync Drop Fn FnMut FnOnce ToOwned Clone Debug PartialEq PartialOrd Eq Ord AsRef AsMut Into From Default Iterator Extend IntoIterator DoubleEndedIterator ExactSizeIterator SliceConcatExt ToString assert! assert_eq! bitflags! bytes! cfg! col! concat! concat_idents! debug_assert! debug_assert_eq! env! panic! file! format! format_args! include_bin! include_str! line! local_data_key! module_path! option_env! print! println! select! stringify! try! unimplemented! unreachable! vec! write! writeln! macro_rules! assert_ne! debug_assert_ne!";
    return {
        name: "Rust",
        aliases: [
            "rs"
        ],
        keywords: {
            $pattern: hljs.IDENT_RE + "!?",
            keyword: KEYWORDS,
            literal: "true false Some None Ok Err",
            built_in: BUILTINS
        },
        illegal: "</",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT("/\\*", "\\*/", {
                contains: [
                    "self"
                ]
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                begin: /b?"/,
                illegal: null
            }),
            {
                className: "string",
                variants: [
                    {
                        begin: /r(#*)"(.|\n)*?"\1(?!#)/
                    },
                    {
                        begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/
                    }
                ]
            },
            {
                className: "symbol",
                begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "\\b0b([01_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b0o([0-7_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b0x([A-Fa-f0-9_]+)" + NUM_SUFFIX
                    },
                    {
                        begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + NUM_SUFFIX
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "fn",
                end: "(\\(|<)",
                excludeEnd: true,
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                className: "meta",
                begin: "#!?\\[",
                end: "\\]",
                contains: [
                    {
                        className: "meta-string",
                        begin: /"/,
                        end: /"/
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "type",
                end: ";",
                contains: [
                    hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
                        endsParent: true
                    })
                ],
                illegal: "\\S"
            },
            {
                className: "class",
                beginKeywords: "trait enum struct union",
                end: /\{/,
                contains: [
                    hljs.inherit(hljs.UNDERSCORE_TITLE_MODE, {
                        endsParent: true
                    })
                ],
                illegal: "[\\w\\d]"
            },
            {
                begin: hljs.IDENT_RE + "::",
                keywords: {
                    built_in: BUILTINS
                }
            },
            {
                begin: "->"
            }
        ]
    };
}
module.exports = $83188cbb2ce5d0ca$var$rust;

});

parcelRegister("2bWJg", function(module, exports) {
/*
Language: SAS
Author: Mauricio Caceres <mauricio.caceres.bravo@gmail.com>
Description: Syntax Highlighting for SAS
*/ function $198a2a35e44ff38d$var$sas(hljs) {
    // Data step and PROC SQL statements
    const SAS_KEYWORDS = "do if then else end until while abort array attrib by call cards cards4 catname continue datalines datalines4 delete delim delimiter display dm drop endsas error file filename footnote format goto in infile informat input keep label leave length libname link list lostcard merge missing modify options output out page put redirect remove rename replace retain return select set skip startsas stop title update waitsas where window x systask add and alter as cascade check create delete describe distinct drop foreign from group having index insert into in key like message modify msgtype not null on or order primary references reset restrict select set table unique update validate view where";
    // Built-in SAS functions
    const SAS_FUN = "abs|addr|airy|arcos|arsin|atan|attrc|attrn|band|betainv|blshift|bnot|bor|brshift|bxor|byte|cdf|ceil|cexist|cinv|close|cnonct|collate|compbl|compound|compress|cos|cosh|css|curobs|cv|daccdb|daccdbsl|daccsl|daccsyd|dacctab|dairy|date|datejul|datepart|datetime|day|dclose|depdb|depdbsl|depdbsl|depsl|depsl|depsyd|depsyd|deptab|deptab|dequote|dhms|dif|digamma|dim|dinfo|dnum|dopen|doptname|doptnum|dread|dropnote|dsname|erf|erfc|exist|exp|fappend|fclose|fcol|fdelete|fetch|fetchobs|fexist|fget|fileexist|filename|fileref|finfo|finv|fipname|fipnamel|fipstate|floor|fnonct|fnote|fopen|foptname|foptnum|fpoint|fpos|fput|fread|frewind|frlen|fsep|fuzz|fwrite|gaminv|gamma|getoption|getvarc|getvarn|hbound|hms|hosthelp|hour|ibessel|index|indexc|indexw|input|inputc|inputn|int|intck|intnx|intrr|irr|jbessel|juldate|kurtosis|lag|lbound|left|length|lgamma|libname|libref|log|log10|log2|logpdf|logpmf|logsdf|lowcase|max|mdy|mean|min|minute|mod|month|mopen|mort|n|netpv|nmiss|normal|note|npv|open|ordinal|pathname|pdf|peek|peekc|pmf|point|poisson|poke|probbeta|probbnml|probchi|probf|probgam|probhypr|probit|probnegb|probnorm|probt|put|putc|putn|qtr|quote|ranbin|rancau|ranexp|rangam|range|rank|rannor|ranpoi|rantbl|rantri|ranuni|repeat|resolve|reverse|rewind|right|round|saving|scan|sdf|second|sign|sin|sinh|skewness|soundex|spedis|sqrt|std|stderr|stfips|stname|stnamel|substr|sum|symget|sysget|sysmsg|sysprod|sysrc|system|tan|tanh|time|timepart|tinv|tnonct|today|translate|tranwrd|trigamma|trim|trimn|trunc|uniform|upcase|uss|var|varfmt|varinfmt|varlabel|varlen|varname|varnum|varray|varrayx|vartype|verify|vformat|vformatd|vformatdx|vformatn|vformatnx|vformatw|vformatwx|vformatx|vinarray|vinarrayx|vinformat|vinformatd|vinformatdx|vinformatn|vinformatnx|vinformatw|vinformatwx|vinformatx|vlabel|vlabelx|vlength|vlengthx|vname|vnamex|vtype|vtypex|weekday|year|yyq|zipfips|zipname|zipnamel|zipstate";
    // Built-in macro functions
    const SAS_MACRO_FUN = "bquote|nrbquote|cmpres|qcmpres|compstor|datatyp|display|do|else|end|eval|global|goto|if|index|input|keydef|label|left|length|let|local|lowcase|macro|mend|nrbquote|nrquote|nrstr|put|qcmpres|qleft|qlowcase|qscan|qsubstr|qsysfunc|qtrim|quote|qupcase|scan|str|substr|superq|syscall|sysevalf|sysexec|sysfunc|sysget|syslput|sysprod|sysrc|sysrput|then|to|trim|unquote|until|upcase|verify|while|window";
    return {
        name: "SAS",
        case_insensitive: true,
        keywords: {
            literal: "null missing _all_ _automatic_ _character_ _infile_ _n_ _name_ _null_ _numeric_ _user_ _webout_",
            meta: SAS_KEYWORDS
        },
        contains: [
            {
                // Distinct highlight for proc <proc>, data, run, quit
                className: "keyword",
                begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
            },
            {
                // Macro variables
                className: "variable",
                begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
            },
            {
                // Special emphasis for datalines|cards
                className: "emphasis",
                begin: /^\s*datalines|cards.*;/,
                end: /^\s*;\s*$/
            },
            {
                className: "built_in",
                begin: "%(" + SAS_MACRO_FUN + ")"
            },
            {
                // User-defined macro functions highlighted after
                className: "name",
                begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
            },
            {
                className: "meta",
                begin: "[^%](" + SAS_FUN + ")[(]"
            },
            {
                className: "string",
                variants: [
                    hljs.APOS_STRING_MODE,
                    hljs.QUOTE_STRING_MODE
                ]
            },
            hljs.COMMENT("\\*", ";"),
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
}
module.exports = $198a2a35e44ff38d$var$sas;

});

parcelRegister("gJPco", function(module, exports) {
/*
Language: Scala
Category: functional
Author: Jan Berkel <jan.berkel@gmail.com>
Contributors: Erik Osheim <d_m@plastic-idolatry.com>
Website: https://www.scala-lang.org
*/ function $c2f89054fa8eb0b1$var$scala(hljs) {
    const ANNOTATION = {
        className: "meta",
        begin: "@[A-Za-z]+"
    };
    // used in strings for escaping/interpolation/substitution
    const SUBST = {
        className: "subst",
        variants: [
            {
                begin: "\\$[A-Za-z0-9_]+"
            },
            {
                begin: /\$\{/,
                end: /\}/
            }
        ]
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: '"""',
                end: '"""'
            },
            {
                begin: '"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                begin: '[a-z]+"',
                end: '"',
                illegal: "\\n",
                contains: [
                    hljs.BACKSLASH_ESCAPE,
                    SUBST
                ]
            },
            {
                className: "string",
                begin: '[a-z]+"""',
                end: '"""',
                contains: [
                    SUBST
                ],
                relevance: 10
            }
        ]
    };
    const SYMBOL = {
        className: "symbol",
        begin: "'\\w[\\w\\d_]*(?!')"
    };
    const TYPE = {
        className: "type",
        begin: "\\b[A-Z][A-Za-z0-9_]*",
        relevance: 0
    };
    const NAME = {
        className: "title",
        begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
        relevance: 0
    };
    const CLASS = {
        className: "class",
        beginKeywords: "class object trait type",
        end: /[:={\[\n;]/,
        excludeEnd: true,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                beginKeywords: "extends with",
                relevance: 10
            },
            {
                begin: /\[/,
                end: /\]/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE
                ]
            },
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                excludeBegin: true,
                excludeEnd: true,
                relevance: 0,
                contains: [
                    TYPE
                ]
            },
            NAME
        ]
    };
    const METHOD = {
        className: "function",
        beginKeywords: "def",
        end: /[:={\[(\n;]/,
        excludeEnd: true,
        contains: [
            NAME
        ]
    };
    return {
        name: "Scala",
        keywords: {
            literal: "true false null",
            keyword: "type yield lazy override def with val var sealed abstract private trait object if forSome for while throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            STRING,
            SYMBOL,
            TYPE,
            METHOD,
            CLASS,
            hljs.C_NUMBER_MODE,
            ANNOTATION
        ]
    };
}
module.exports = $c2f89054fa8eb0b1$var$scala;

});

parcelRegister("2kAZn", function(module, exports) {
/*
Language: Scheme
Description: Scheme is a programming language in the Lisp family.
             (keywords based on http://community.schemewiki.org/?scheme-keywords)
Author: JP Verkamp <me@jverkamp.com>
Contributors: Ivan Sagalaev <maniac@softwaremaniacs.org>
Origin: clojure.js
Website: http://community.schemewiki.org/?what-is-scheme
Category: lisp
*/ function $1b2a2445b37f7d46$var$scheme(hljs) {
    const SCHEME_IDENT_RE = "[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+";
    const SCHEME_SIMPLE_NUMBER_RE = "(-|\\+)?\\d+([./]\\d+)?";
    const SCHEME_COMPLEX_NUMBER_RE = SCHEME_SIMPLE_NUMBER_RE + "[+\\-]" + SCHEME_SIMPLE_NUMBER_RE + "i";
    const KEYWORDS = {
        $pattern: SCHEME_IDENT_RE,
        "builtin-name": "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
    };
    const LITERAL = {
        className: "literal",
        begin: "(#t|#f|#\\\\" + SCHEME_IDENT_RE + "|#\\\\.)"
    };
    const NUMBER = {
        className: "number",
        variants: [
            {
                begin: SCHEME_SIMPLE_NUMBER_RE,
                relevance: 0
            },
            {
                begin: SCHEME_COMPLEX_NUMBER_RE,
                relevance: 0
            },
            {
                begin: "#b[0-1]+(/[0-1]+)?"
            },
            {
                begin: "#o[0-7]+(/[0-7]+)?"
            },
            {
                begin: "#x[0-9a-f]+(/[0-9a-f]+)?"
            }
        ]
    };
    const STRING = hljs.QUOTE_STRING_MODE;
    const COMMENT_MODES = [
        hljs.COMMENT(";", "$", {
            relevance: 0
        }),
        hljs.COMMENT("#\\|", "\\|#")
    ];
    const IDENT = {
        begin: SCHEME_IDENT_RE,
        relevance: 0
    };
    const QUOTED_IDENT = {
        className: "symbol",
        begin: "'" + SCHEME_IDENT_RE
    };
    const BODY = {
        endsWithParent: true,
        relevance: 0
    };
    const QUOTED_LIST = {
        variants: [
            {
                begin: /'/
            },
            {
                begin: "`"
            }
        ],
        contains: [
            {
                begin: "\\(",
                end: "\\)",
                contains: [
                    "self",
                    LITERAL,
                    STRING,
                    NUMBER,
                    IDENT,
                    QUOTED_IDENT
                ]
            }
        ]
    };
    const NAME = {
        className: "name",
        relevance: 0,
        begin: SCHEME_IDENT_RE,
        keywords: KEYWORDS
    };
    const LAMBDA = {
        begin: /lambda/,
        endsWithParent: true,
        returnBegin: true,
        contains: [
            NAME,
            {
                endsParent: true,
                variants: [
                    {
                        begin: /\(/,
                        end: /\)/
                    },
                    {
                        begin: /\[/,
                        end: /\]/
                    }
                ],
                contains: [
                    IDENT
                ]
            }
        ]
    };
    const LIST = {
        variants: [
            {
                begin: "\\(",
                end: "\\)"
            },
            {
                begin: "\\[",
                end: "\\]"
            }
        ],
        contains: [
            LAMBDA,
            NAME,
            BODY
        ]
    };
    BODY.contains = [
        LITERAL,
        NUMBER,
        STRING,
        IDENT,
        QUOTED_IDENT,
        QUOTED_LIST,
        LIST
    ].concat(COMMENT_MODES);
    return {
        name: "Scheme",
        illegal: /\S/,
        contains: [
            hljs.SHEBANG(),
            NUMBER,
            STRING,
            QUOTED_IDENT,
            QUOTED_LIST,
            LIST
        ].concat(COMMENT_MODES)
    };
}
module.exports = $1b2a2445b37f7d46$var$scheme;

});

parcelRegister("k3MqZ", function(module, exports) {
/*
Language: Scilab
Author: Sylvestre Ledru <sylvestre.ledru@scilab-enterprises.com>
Origin: matlab.js
Description: Scilab is a port from Matlab
Website: https://www.scilab.org
Category: scientific
*/ function $e9a9a882b7f39f26$var$scilab(hljs) {
    const COMMON_CONTAINS = [
        hljs.C_NUMBER_MODE,
        {
            className: "string",
            begin: "'|\"",
            end: "'|\"",
            contains: [
                hljs.BACKSLASH_ESCAPE,
                {
                    begin: "''"
                }
            ]
        }
    ];
    return {
        name: "Scilab",
        aliases: [
            "sci"
        ],
        keywords: {
            $pattern: /%?\w+/,
            keyword: "abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",
            literal: "%f %F %t %T %pi %eps %inf %nan %e %i %z %s",
            built_in: "abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"
        },
        illegal: '("|#|/\\*|\\s+/\\w+)',
        contains: [
            {
                className: "function",
                beginKeywords: "function",
                end: "$",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)"
                    }
                ]
            },
            // seems to be a guard against [ident]' or [ident].
            // perhaps to prevent attributes from flagging as keywords?
            {
                begin: "[a-zA-Z_][a-zA-Z_0-9]*[\\.']+",
                relevance: 0
            },
            {
                begin: "\\[",
                end: "\\][\\.']*",
                relevance: 0,
                contains: COMMON_CONTAINS
            },
            hljs.COMMENT("//", "$")
        ].concat(COMMON_CONTAINS)
    };
}
module.exports = $e9a9a882b7f39f26$var$scilab;

});

parcelRegister("3qcwH", function(module, exports) {
const $27dd844c3edda6a0$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            className: "meta",
            begin: "!important"
        },
        HEXCOLOR: {
            className: "number",
            begin: "#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})"
        },
        ATTRIBUTE_SELECTOR_MODE: {
            className: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        }
    };
};
const $27dd844c3edda6a0$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $27dd844c3edda6a0$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $27dd844c3edda6a0$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $27dd844c3edda6a0$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $27dd844c3edda6a0$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "auto",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "border",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "clear",
    "clip",
    "clip-path",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "content",
    "counter-increment",
    "counter-reset",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-variant-ligatures",
    "font-variation-settings",
    "font-weight",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inherit",
    "initial",
    "justify-content",
    "left",
    "letter-spacing",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-bottom",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "max-height",
    "max-width",
    "min-height",
    "min-width",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-bottom",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "right",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-last",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-indent",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "white-space",
    "widows",
    "width",
    "word-break",
    "word-spacing",
    "word-wrap",
    "z-index"
].reverse();
/*
Language: SCSS
Description: Scss is an extension of the syntax of CSS.
Author: Kurt Emch <kurt@kurtemch.com>
Website: https://sass-lang.com
Category: common, css
*/ /** @type LanguageFn */ function $27dd844c3edda6a0$var$scss(hljs) {
    const modes = $27dd844c3edda6a0$var$MODES(hljs);
    const PSEUDO_ELEMENTS$1 = $27dd844c3edda6a0$var$PSEUDO_ELEMENTS;
    const PSEUDO_CLASSES$1 = $27dd844c3edda6a0$var$PSEUDO_CLASSES;
    const AT_IDENTIFIER = "@[a-z-]+"; // @font-face
    const AT_MODIFIERS = "and or not only";
    const IDENT_RE = "[a-zA-Z-][a-zA-Z0-9_-]*";
    const VARIABLE = {
        className: "variable",
        begin: "(\\$" + IDENT_RE + ")\\b"
    };
    return {
        name: "SCSS",
        case_insensitive: true,
        illegal: "[=/|']",
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "selector-id",
                begin: "#[A-Za-z0-9_-]+",
                relevance: 0
            },
            {
                className: "selector-class",
                begin: "\\.[A-Za-z0-9_-]+",
                relevance: 0
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "selector-tag",
                begin: "\\b(" + $27dd844c3edda6a0$var$TAGS.join("|") + ")\\b",
                // was there, before, but why?
                relevance: 0
            },
            {
                className: "selector-pseudo",
                begin: ":(" + PSEUDO_CLASSES$1.join("|") + ")"
            },
            {
                className: "selector-pseudo",
                begin: "::(" + PSEUDO_ELEMENTS$1.join("|") + ")"
            },
            VARIABLE,
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    hljs.CSS_NUMBER_MODE
                ]
            },
            {
                className: "attribute",
                begin: "\\b(" + $27dd844c3edda6a0$var$ATTRIBUTES.join("|") + ")\\b"
            },
            {
                begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"
            },
            {
                begin: ":",
                end: ";",
                contains: [
                    VARIABLE,
                    modes.HEXCOLOR,
                    hljs.CSS_NUMBER_MODE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    modes.IMPORTANT
                ]
            },
            // matching these here allows us to treat them more like regular CSS
            // rules so everything between the {} gets regular rule highlighting,
            // which is what we want for page and font-face
            {
                begin: "@(page|font-face)",
                lexemes: AT_IDENTIFIER,
                keywords: "@page @font-face"
            },
            {
                begin: "@",
                end: "[{;]",
                returnBegin: true,
                keywords: {
                    $pattern: /[a-z-]+/,
                    keyword: AT_MODIFIERS,
                    attribute: $27dd844c3edda6a0$var$MEDIA_FEATURES.join(" ")
                },
                contains: [
                    {
                        begin: AT_IDENTIFIER,
                        className: "keyword"
                    },
                    {
                        begin: /[a-z-]+(?=:)/,
                        className: "attribute"
                    },
                    VARIABLE,
                    hljs.QUOTE_STRING_MODE,
                    hljs.APOS_STRING_MODE,
                    modes.HEXCOLOR,
                    hljs.CSS_NUMBER_MODE
                ]
            }
        ]
    };
}
module.exports = $27dd844c3edda6a0$var$scss;

});

parcelRegister("68ktp", function(module, exports) {
/*
Language: Shell Session
Requires: bash.js
Author: TSUYUSATO Kitsune <make.just.on@gmail.com>
Category: common
Audit: 2020
*/ /** @type LanguageFn */ function $47735efdeec0231c$var$shell(hljs) {
    return {
        name: "Shell Session",
        aliases: [
            "console"
        ],
        contains: [
            {
                className: "meta",
                // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
                // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
                // echo /path/to/home > t.exe
                begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#]/,
                starts: {
                    end: /[^\\](?=\s*$)/,
                    subLanguage: "bash"
                }
            }
        ]
    };
}
module.exports = $47735efdeec0231c$var$shell;

});

parcelRegister("2htv8", function(module, exports) {
/*
Language: Smali
Author: Dennis Titze <dennis.titze@gmail.com>
Description: Basic Smali highlighting
Website: https://github.com/JesusFreke/smali
*/ function $1a940d9a9a6dd677$var$smali(hljs) {
    const smali_instr_low_prio = [
        "add",
        "and",
        "cmp",
        "cmpg",
        "cmpl",
        "const",
        "div",
        "double",
        "float",
        "goto",
        "if",
        "int",
        "long",
        "move",
        "mul",
        "neg",
        "new",
        "nop",
        "not",
        "or",
        "rem",
        "return",
        "shl",
        "shr",
        "sput",
        "sub",
        "throw",
        "ushr",
        "xor"
    ];
    const smali_instr_high_prio = [
        "aget",
        "aput",
        "array",
        "check",
        "execute",
        "fill",
        "filled",
        "goto/16",
        "goto/32",
        "iget",
        "instance",
        "invoke",
        "iput",
        "monitor",
        "packed",
        "sget",
        "sparse"
    ];
    const smali_keywords = [
        "transient",
        "constructor",
        "abstract",
        "final",
        "synthetic",
        "public",
        "private",
        "protected",
        "static",
        "bridge",
        "system"
    ];
    return {
        name: "Smali",
        contains: [
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0
            },
            hljs.COMMENT("#", "$", {
                relevance: 0
            }),
            {
                className: "keyword",
                variants: [
                    {
                        begin: "\\s*\\.end\\s[a-zA-Z0-9]*"
                    },
                    {
                        begin: "^[ ]*\\.[a-zA-Z]*",
                        relevance: 0
                    },
                    {
                        begin: "\\s:[a-zA-Z_0-9]*",
                        relevance: 0
                    },
                    {
                        begin: "\\s(" + smali_keywords.join("|") + ")"
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "\\s(" + smali_instr_low_prio.join("|") + ")\\s"
                    },
                    {
                        begin: "\\s(" + smali_instr_low_prio.join("|") + ")((-|/)[a-zA-Z0-9]+)+\\s",
                        relevance: 10
                    },
                    {
                        begin: "\\s(" + smali_instr_high_prio.join("|") + ")((-|/)[a-zA-Z0-9]+)*\\s",
                        relevance: 10
                    }
                ]
            },
            {
                className: "class",
                begin: "L[^(;:\n]*;",
                relevance: 0
            },
            {
                begin: "[vp][0-9]+"
            }
        ]
    };
}
module.exports = $1a940d9a9a6dd677$var$smali;

});

parcelRegister("le1df", function(module, exports) {
/*
Language: Smalltalk
Description: Smalltalk is an object-oriented, dynamically typed reflective programming language.
Author: Vladimir Gubarkov <xonixx@gmail.com>
Website: https://en.wikipedia.org/wiki/Smalltalk
*/ function $f73bd898cf02cd19$var$smalltalk(hljs) {
    const VAR_IDENT_RE = "[a-z][a-zA-Z0-9_]*";
    const CHAR = {
        className: "string",
        begin: "\\$.{1}"
    };
    const SYMBOL = {
        className: "symbol",
        begin: "#" + hljs.UNDERSCORE_IDENT_RE
    };
    return {
        name: "Smalltalk",
        aliases: [
            "st"
        ],
        keywords: "self super nil true false thisContext",
        contains: [
            hljs.COMMENT('"', '"'),
            hljs.APOS_STRING_MODE,
            {
                className: "type",
                begin: "\\b[A-Z][A-Za-z0-9_]*",
                relevance: 0
            },
            {
                begin: VAR_IDENT_RE + ":",
                relevance: 0
            },
            hljs.C_NUMBER_MODE,
            SYMBOL,
            CHAR,
            {
                // This looks more complicated than needed to avoid combinatorial
                // explosion under V8. It effectively means `| var1 var2 ... |` with
                // whitespace adjacent to `|` being optional.
                begin: "\\|[ ]*" + VAR_IDENT_RE + "([ ]+" + VAR_IDENT_RE + ")*[ ]*\\|",
                returnBegin: true,
                end: /\|/,
                illegal: /\S/,
                contains: [
                    {
                        begin: "(\\|[ ]*)?" + VAR_IDENT_RE
                    }
                ]
            },
            {
                begin: "#\\(",
                end: "\\)",
                contains: [
                    hljs.APOS_STRING_MODE,
                    CHAR,
                    hljs.C_NUMBER_MODE,
                    SYMBOL
                ]
            }
        ]
    };
}
module.exports = $f73bd898cf02cd19$var$smalltalk;

});

parcelRegister("eKuVF", function(module, exports) {
/*
Language: SML (Standard ML)
Author: Edwin Dalorzo <edwin@dalorzo.org>
Description: SML language definition.
Website: https://www.smlnj.org
Origin: ocaml.js
Category: functional
*/ function $abcd5a6bc5e0cc55$var$sml(hljs) {
    return {
        name: "SML (Standard ML)",
        aliases: [
            "ml"
        ],
        keywords: {
            $pattern: "[a-z_]\\w*!?",
            keyword: /* according to Definition of Standard ML 97  */ "abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while",
            built_in: /* built-in types according to basis library */ "array bool char exn int list option order real ref string substring vector unit word",
            literal: "true false NONE SOME LESS EQUAL GREATER nil"
        },
        illegal: /\/\/|>>/,
        contains: [
            {
                className: "literal",
                begin: /\[(\|\|)?\]|\(\)/,
                relevance: 0
            },
            hljs.COMMENT("\\(\\*", "\\*\\)", {
                contains: [
                    "self"
                ]
            }),
            {
                className: "symbol",
                begin: "'[A-Za-z_](?!')[\\w']*"
            },
            {
                className: "type",
                begin: "`[A-Z][\\w']*"
            },
            {
                className: "type",
                begin: "\\b[A-Z][\\w']*",
                relevance: 0
            },
            {
                begin: "[a-z_]\\w*'[\\w']*"
            },
            hljs.inherit(hljs.APOS_STRING_MODE, {
                className: "string",
                relevance: 0
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "number",
                begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                relevance: 0
            },
            {
                begin: /[-=]>/ // relevance booster
            }
        ]
    };
}
module.exports = $abcd5a6bc5e0cc55$var$sml;

});

parcelRegister("16hNA", function(module, exports) {
/*
Language: SQF
Author: Søren Enevoldsen <senevoldsen90@gmail.com>
Contributors: Marvin Saignat <contact@zgmrvn.com>, Dedmen Miller <dedmen@dedmen.de>
Description: Scripting language for the Arma game series
Website: https://community.bistudio.com/wiki/SQF_syntax
Category: scripting
*/ function $0cd4286fb7c92b5e$var$sqf(hljs) {
    // In SQF, a variable start with _
    const VARIABLE = {
        className: "variable",
        begin: /\b_+[a-zA-Z]\w*/
    };
    // In SQF, a function should fit myTag_fnc_myFunction pattern
    // https://community.bistudio.com/wiki/Functions_Library_(Arma_3)#Adding_a_Function
    const FUNCTION = {
        className: "title",
        begin: /[a-zA-Z][a-zA-Z0-9]+_fnc_\w*/
    };
    // In SQF strings, quotes matching the start are escaped by adding a consecutive.
    // Example of single escaped quotes: " "" " and  ' '' '.
    const STRINGS = {
        className: "string",
        variants: [
            {
                begin: '"',
                end: '"',
                contains: [
                    {
                        begin: '""',
                        relevance: 0
                    }
                ]
            },
            {
                begin: "'",
                end: "'",
                contains: [
                    {
                        begin: "''",
                        relevance: 0
                    }
                ]
            }
        ]
    };
    // list of keywords from:
    // https://community.bistudio.com/wiki/PreProcessor_Commands
    const PREPROCESSOR = {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "define undef ifdef ifndef else endif include"
        },
        contains: [
            {
                begin: /\\\n/,
                relevance: 0
            },
            hljs.inherit(STRINGS, {
                className: "meta-string"
            }),
            {
                className: "meta-string",
                begin: /<[^\n>]*>/,
                end: /$/,
                illegal: "\\n"
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
    return {
        name: "SQF",
        case_insensitive: true,
        keywords: {
            keyword: "case catch default do else exit exitWith for forEach from if private switch then throw to try waitUntil while with",
            built_in: "abs accTime acos action actionIDs actionKeys actionKeysImages actionKeysNames actionKeysNamesArray actionName actionParams activateAddons activatedAddons activateKey add3DENConnection add3DENEventHandler add3DENLayer addAction addBackpack addBackpackCargo addBackpackCargoGlobal addBackpackGlobal addCamShake addCuratorAddons addCuratorCameraArea addCuratorEditableObjects addCuratorEditingArea addCuratorPoints addEditorObject addEventHandler addForce addGoggles addGroupIcon addHandgunItem addHeadgear addItem addItemCargo addItemCargoGlobal addItemPool addItemToBackpack addItemToUniform addItemToVest addLiveStats addMagazine addMagazineAmmoCargo addMagazineCargo addMagazineCargoGlobal addMagazineGlobal addMagazinePool addMagazines addMagazineTurret addMenu addMenuItem addMissionEventHandler addMPEventHandler addMusicEventHandler addOwnedMine addPlayerScores addPrimaryWeaponItem addPublicVariableEventHandler addRating addResources addScore addScoreSide addSecondaryWeaponItem addSwitchableUnit addTeamMember addToRemainsCollector addTorque addUniform addVehicle addVest addWaypoint addWeapon addWeaponCargo addWeaponCargoGlobal addWeaponGlobal addWeaponItem addWeaponPool addWeaponTurret admin agent agents AGLToASL aimedAtTarget aimPos airDensityRTD airplaneThrottle airportSide AISFinishHeal alive all3DENEntities allAirports allControls allCurators allCutLayers allDead allDeadMen allDisplays allGroups allMapMarkers allMines allMissionObjects allow3DMode allowCrewInImmobile allowCuratorLogicIgnoreAreas allowDamage allowDammage allowFileOperations allowFleeing allowGetIn allowSprint allPlayers allSimpleObjects allSites allTurrets allUnits allUnitsUAV allVariables ammo ammoOnPylon and animate animateBay animateDoor animatePylon animateSource animationNames animationPhase animationSourcePhase animationState append apply armoryPoints arrayIntersect asin ASLToAGL ASLToATL assert assignAsCargo assignAsCargoIndex assignAsCommander assignAsDriver assignAsGunner assignAsTurret assignCurator assignedCargo assignedCommander assignedDriver assignedGunner assignedItems assignedTarget assignedTeam assignedVehicle assignedVehicleRole assignItem assignTeam assignToAirport atan atan2 atg ATLToASL attachedObject attachedObjects attachedTo attachObject attachTo attackEnabled backpack backpackCargo backpackContainer backpackItems backpackMagazines backpackSpaceFor behaviour benchmark binocular boundingBox boundingBoxReal boundingCenter breakOut breakTo briefingName buildingExit buildingPos buttonAction buttonSetAction cadetMode call callExtension camCommand camCommit camCommitPrepared camCommitted camConstuctionSetParams camCreate camDestroy cameraEffect cameraEffectEnableHUD cameraInterest cameraOn cameraView campaignConfigFile camPreload camPreloaded camPrepareBank camPrepareDir camPrepareDive camPrepareFocus camPrepareFov camPrepareFovRange camPreparePos camPrepareRelPos camPrepareTarget camSetBank camSetDir camSetDive camSetFocus camSetFov camSetFovRange camSetPos camSetRelPos camSetTarget camTarget camUseNVG canAdd canAddItemToBackpack canAddItemToUniform canAddItemToVest cancelSimpleTaskDestination canFire canMove canSlingLoad canStand canSuspend canTriggerDynamicSimulation canUnloadInCombat canVehicleCargo captive captiveNum cbChecked cbSetChecked ceil channelEnabled cheatsEnabled checkAIFeature checkVisibility className clearAllItemsFromBackpack clearBackpackCargo clearBackpackCargoGlobal clearGroupIcons clearItemCargo clearItemCargoGlobal clearItemPool clearMagazineCargo clearMagazineCargoGlobal clearMagazinePool clearOverlay clearRadio clearWeaponCargo clearWeaponCargoGlobal clearWeaponPool clientOwner closeDialog closeDisplay closeOverlay collapseObjectTree collect3DENHistory collectiveRTD combatMode commandArtilleryFire commandChat commander commandFire commandFollow commandFSM commandGetOut commandingMenu commandMove commandRadio commandStop commandSuppressiveFire commandTarget commandWatch comment commitOverlay compile compileFinal completedFSM composeText configClasses configFile configHierarchy configName configProperties configSourceAddonList configSourceMod configSourceModList confirmSensorTarget connectTerminalToUAV controlsGroupCtrl copyFromClipboard copyToClipboard copyWaypoints cos count countEnemy countFriendly countSide countType countUnknown create3DENComposition create3DENEntity createAgent createCenter createDialog createDiaryLink createDiaryRecord createDiarySubject createDisplay createGearDialog createGroup createGuardedPoint createLocation createMarker createMarkerLocal createMenu createMine createMissionDisplay createMPCampaignDisplay createSimpleObject createSimpleTask createSite createSoundSource createTask createTeam createTrigger createUnit createVehicle createVehicleCrew createVehicleLocal crew ctAddHeader ctAddRow ctClear ctCurSel ctData ctFindHeaderRows ctFindRowHeader ctHeaderControls ctHeaderCount ctRemoveHeaders ctRemoveRows ctrlActivate ctrlAddEventHandler ctrlAngle ctrlAutoScrollDelay ctrlAutoScrollRewind ctrlAutoScrollSpeed ctrlChecked ctrlClassName ctrlCommit ctrlCommitted ctrlCreate ctrlDelete ctrlEnable ctrlEnabled ctrlFade ctrlHTMLLoaded ctrlIDC ctrlIDD ctrlMapAnimAdd ctrlMapAnimClear ctrlMapAnimCommit ctrlMapAnimDone ctrlMapCursor ctrlMapMouseOver ctrlMapScale ctrlMapScreenToWorld ctrlMapWorldToScreen ctrlModel ctrlModelDirAndUp ctrlModelScale ctrlParent ctrlParentControlsGroup ctrlPosition ctrlRemoveAllEventHandlers ctrlRemoveEventHandler ctrlScale ctrlSetActiveColor ctrlSetAngle ctrlSetAutoScrollDelay ctrlSetAutoScrollRewind ctrlSetAutoScrollSpeed ctrlSetBackgroundColor ctrlSetChecked ctrlSetEventHandler ctrlSetFade ctrlSetFocus ctrlSetFont ctrlSetFontH1 ctrlSetFontH1B ctrlSetFontH2 ctrlSetFontH2B ctrlSetFontH3 ctrlSetFontH3B ctrlSetFontH4 ctrlSetFontH4B ctrlSetFontH5 ctrlSetFontH5B ctrlSetFontH6 ctrlSetFontH6B ctrlSetFontHeight ctrlSetFontHeightH1 ctrlSetFontHeightH2 ctrlSetFontHeightH3 ctrlSetFontHeightH4 ctrlSetFontHeightH5 ctrlSetFontHeightH6 ctrlSetFontHeightSecondary ctrlSetFontP ctrlSetFontPB ctrlSetFontSecondary ctrlSetForegroundColor ctrlSetModel ctrlSetModelDirAndUp ctrlSetModelScale ctrlSetPixelPrecision ctrlSetPosition ctrlSetScale ctrlSetStructuredText ctrlSetText ctrlSetTextColor ctrlSetTooltip ctrlSetTooltipColorBox ctrlSetTooltipColorShade ctrlSetTooltipColorText ctrlShow ctrlShown ctrlText ctrlTextHeight ctrlTextWidth ctrlType ctrlVisible ctRowControls ctRowCount ctSetCurSel ctSetData ctSetHeaderTemplate ctSetRowTemplate ctSetValue ctValue curatorAddons curatorCamera curatorCameraArea curatorCameraAreaCeiling curatorCoef curatorEditableObjects curatorEditingArea curatorEditingAreaType curatorMouseOver curatorPoints curatorRegisteredObjects curatorSelected curatorWaypointCost current3DENOperation currentChannel currentCommand currentMagazine currentMagazineDetail currentMagazineDetailTurret currentMagazineTurret currentMuzzle currentNamespace currentTask currentTasks currentThrowable currentVisionMode currentWaypoint currentWeapon currentWeaponMode currentWeaponTurret currentZeroing cursorObject cursorTarget customChat customRadio cutFadeOut cutObj cutRsc cutText damage date dateToNumber daytime deActivateKey debriefingText debugFSM debugLog deg delete3DENEntities deleteAt deleteCenter deleteCollection deleteEditorObject deleteGroup deleteGroupWhenEmpty deleteIdentity deleteLocation deleteMarker deleteMarkerLocal deleteRange deleteResources deleteSite deleteStatus deleteTeam deleteVehicle deleteVehicleCrew deleteWaypoint detach detectedMines diag_activeMissionFSMs diag_activeScripts diag_activeSQFScripts diag_activeSQSScripts diag_captureFrame diag_captureFrameToFile diag_captureSlowFrame diag_codePerformance diag_drawMode diag_enable diag_enabled diag_fps diag_fpsMin diag_frameNo diag_lightNewLoad diag_list diag_log diag_logSlowFrame diag_mergeConfigFile diag_recordTurretLimits diag_setLightNew diag_tickTime diag_toggle dialog diarySubjectExists didJIP didJIPOwner difficulty difficultyEnabled difficultyEnabledRTD difficultyOption direction directSay disableAI disableCollisionWith disableConversation disableDebriefingStats disableMapIndicators disableNVGEquipment disableRemoteSensors disableSerialization disableTIEquipment disableUAVConnectability disableUserInput displayAddEventHandler displayCtrl displayParent displayRemoveAllEventHandlers displayRemoveEventHandler displaySetEventHandler dissolveTeam distance distance2D distanceSqr distributionRegion do3DENAction doArtilleryFire doFire doFollow doFSM doGetOut doMove doorPhase doStop doSuppressiveFire doTarget doWatch drawArrow drawEllipse drawIcon drawIcon3D drawLine drawLine3D drawLink drawLocation drawPolygon drawRectangle drawTriangle driver drop dynamicSimulationDistance dynamicSimulationDistanceCoef dynamicSimulationEnabled dynamicSimulationSystemEnabled echo edit3DENMissionAttributes editObject editorSetEventHandler effectiveCommander emptyPositions enableAI enableAIFeature enableAimPrecision enableAttack enableAudioFeature enableAutoStartUpRTD enableAutoTrimRTD enableCamShake enableCaustics enableChannel enableCollisionWith enableCopilot enableDebriefingStats enableDiagLegend enableDynamicSimulation enableDynamicSimulationSystem enableEndDialog enableEngineArtillery enableEnvironment enableFatigue enableGunLights enableInfoPanelComponent enableIRLasers enableMimics enablePersonTurret enableRadio enableReload enableRopeAttach enableSatNormalOnDetail enableSaving enableSentences enableSimulation enableSimulationGlobal enableStamina enableTeamSwitch enableTraffic enableUAVConnectability enableUAVWaypoints enableVehicleCargo enableVehicleSensor enableWeaponDisassembly endLoadingScreen endMission engineOn enginesIsOnRTD enginesRpmRTD enginesTorqueRTD entities environmentEnabled estimatedEndServerTime estimatedTimeLeft evalObjectArgument everyBackpack everyContainer exec execEditorScript execFSM execVM exp expectedDestination exportJIPMessages eyeDirection eyePos face faction fadeMusic fadeRadio fadeSound fadeSpeech failMission fillWeaponsFromPool find findCover findDisplay findEditorObject findEmptyPosition findEmptyPositionReady findIf findNearestEnemy finishMissionInit finite fire fireAtTarget firstBackpack flag flagAnimationPhase flagOwner flagSide flagTexture fleeing floor flyInHeight flyInHeightASL fog fogForecast fogParams forceAddUniform forcedMap forceEnd forceFlagTexture forceFollowRoad forceMap forceRespawn forceSpeed forceWalk forceWeaponFire forceWeatherChange forEachMember forEachMemberAgent forEachMemberTeam forgetTarget format formation formationDirection formationLeader formationMembers formationPosition formationTask formatText formLeader freeLook fromEditor fuel fullCrew gearIDCAmmoCount gearSlotAmmoCount gearSlotData get3DENActionState get3DENAttribute get3DENCamera get3DENConnections get3DENEntity get3DENEntityID get3DENGrid get3DENIconsVisible get3DENLayerEntities get3DENLinesVisible get3DENMissionAttribute get3DENMouseOver get3DENSelected getAimingCoef getAllEnvSoundControllers getAllHitPointsDamage getAllOwnedMines getAllSoundControllers getAmmoCargo getAnimAimPrecision getAnimSpeedCoef getArray getArtilleryAmmo getArtilleryComputerSettings getArtilleryETA getAssignedCuratorLogic getAssignedCuratorUnit getBackpackCargo getBleedingRemaining getBurningValue getCameraViewDirection getCargoIndex getCenterOfMass getClientState getClientStateNumber getCompatiblePylonMagazines getConnectedUAV getContainerMaxLoad getCursorObjectParams getCustomAimCoef getDammage getDescription getDir getDirVisual getDLCAssetsUsage getDLCAssetsUsageByName getDLCs getEditorCamera getEditorMode getEditorObjectScope getElevationOffset getEnvSoundController getFatigue getForcedFlagTexture getFriend getFSMVariable getFuelCargo getGroupIcon getGroupIconParams getGroupIcons getHideFrom getHit getHitIndex getHitPointDamage getItemCargo getMagazineCargo getMarkerColor getMarkerPos getMarkerSize getMarkerType getMass getMissionConfig getMissionConfigValue getMissionDLCs getMissionLayerEntities getModelInfo getMousePosition getMusicPlayedTime getNumber getObjectArgument getObjectChildren getObjectDLC getObjectMaterials getObjectProxy getObjectTextures getObjectType getObjectViewDistance getOxygenRemaining getPersonUsedDLCs getPilotCameraDirection getPilotCameraPosition getPilotCameraRotation getPilotCameraTarget getPlateNumber getPlayerChannel getPlayerScores getPlayerUID getPos getPosASL getPosASLVisual getPosASLW getPosATL getPosATLVisual getPosVisual getPosWorld getPylonMagazines getRelDir getRelPos getRemoteSensorsDisabled getRepairCargo getResolution getShadowDistance getShotParents getSlingLoad getSoundController getSoundControllerResult getSpeed getStamina getStatValue getSuppression getTerrainGrid getTerrainHeightASL getText getTotalDLCUsageTime getUnitLoadout getUnitTrait getUserMFDText getUserMFDvalue getVariable getVehicleCargo getWeaponCargo getWeaponSway getWingsOrientationRTD getWingsPositionRTD getWPPos glanceAt globalChat globalRadio goggles goto group groupChat groupFromNetId groupIconSelectable groupIconsVisible groupId groupOwner groupRadio groupSelectedUnits groupSelectUnit gunner gusts halt handgunItems handgunMagazine handgunWeapon handsHit hasInterface hasPilotCamera hasWeapon hcAllGroups hcGroupParams hcLeader hcRemoveAllGroups hcRemoveGroup hcSelected hcSelectGroup hcSetGroup hcShowBar hcShownBar headgear hideBody hideObject hideObjectGlobal hideSelection hint hintC hintCadet hintSilent hmd hostMission htmlLoad HUDMovementLevels humidity image importAllGroups importance in inArea inAreaArray incapacitatedState inflame inflamed infoPanel infoPanelComponentEnabled infoPanelComponents infoPanels inGameUISetEventHandler inheritsFrom initAmbientLife inPolygon inputAction inRangeOfArtillery insertEditorObject intersect is3DEN is3DENMultiplayer isAbleToBreathe isAgent isArray isAutoHoverOn isAutonomous isAutotest isBleeding isBurning isClass isCollisionLightOn isCopilotEnabled isDamageAllowed isDedicated isDLCAvailable isEngineOn isEqualTo isEqualType isEqualTypeAll isEqualTypeAny isEqualTypeArray isEqualTypeParams isFilePatchingEnabled isFlashlightOn isFlatEmpty isForcedWalk isFormationLeader isGroupDeletedWhenEmpty isHidden isInRemainsCollector isInstructorFigureEnabled isIRLaserOn isKeyActive isKindOf isLaserOn isLightOn isLocalized isManualFire isMarkedForCollection isMultiplayer isMultiplayerSolo isNil isNull isNumber isObjectHidden isObjectRTD isOnRoad isPipEnabled isPlayer isRealTime isRemoteExecuted isRemoteExecutedJIP isServer isShowing3DIcons isSimpleObject isSprintAllowed isStaminaEnabled isSteamMission isStreamFriendlyUIEnabled isText isTouchingGround isTurnedOut isTutHintsEnabled isUAVConnectable isUAVConnected isUIContext isUniformAllowed isVehicleCargo isVehicleRadarOn isVehicleSensorEnabled isWalking isWeaponDeployed isWeaponRested itemCargo items itemsWithMagazines join joinAs joinAsSilent joinSilent joinString kbAddDatabase kbAddDatabaseTargets kbAddTopic kbHasTopic kbReact kbRemoveTopic kbTell kbWasSaid keyImage keyName knowsAbout land landAt landResult language laserTarget lbAdd lbClear lbColor lbColorRight lbCurSel lbData lbDelete lbIsSelected lbPicture lbPictureRight lbSelection lbSetColor lbSetColorRight lbSetCurSel lbSetData lbSetPicture lbSetPictureColor lbSetPictureColorDisabled lbSetPictureColorSelected lbSetPictureRight lbSetPictureRightColor lbSetPictureRightColorDisabled lbSetPictureRightColorSelected lbSetSelectColor lbSetSelectColorRight lbSetSelected lbSetText lbSetTextRight lbSetTooltip lbSetValue lbSize lbSort lbSortByValue lbText lbTextRight lbValue leader leaderboardDeInit leaderboardGetRows leaderboardInit leaderboardRequestRowsFriends leaderboardsRequestUploadScore leaderboardsRequestUploadScoreKeepBest leaderboardState leaveVehicle libraryCredits libraryDisclaimers lifeState lightAttachObject lightDetachObject lightIsOn lightnings limitSpeed linearConversion lineIntersects lineIntersectsObjs lineIntersectsSurfaces lineIntersectsWith linkItem list listObjects listRemoteTargets listVehicleSensors ln lnbAddArray lnbAddColumn lnbAddRow lnbClear lnbColor lnbCurSelRow lnbData lnbDeleteColumn lnbDeleteRow lnbGetColumnsPosition lnbPicture lnbSetColor lnbSetColumnsPos lnbSetCurSelRow lnbSetData lnbSetPicture lnbSetText lnbSetValue lnbSize lnbSort lnbSortByValue lnbText lnbValue load loadAbs loadBackpack loadFile loadGame loadIdentity loadMagazine loadOverlay loadStatus loadUniform loadVest local localize locationPosition lock lockCameraTo lockCargo lockDriver locked lockedCargo lockedDriver lockedTurret lockIdentity lockTurret lockWP log logEntities logNetwork logNetworkTerminate lookAt lookAtPos magazineCargo magazines magazinesAllTurrets magazinesAmmo magazinesAmmoCargo magazinesAmmoFull magazinesDetail magazinesDetailBackpack magazinesDetailUniform magazinesDetailVest magazinesTurret magazineTurretAmmo mapAnimAdd mapAnimClear mapAnimCommit mapAnimDone mapCenterOnCamera mapGridPosition markAsFinishedOnSteam markerAlpha markerBrush markerColor markerDir markerPos markerShape markerSize markerText markerType max members menuAction menuAdd menuChecked menuClear menuCollapse menuData menuDelete menuEnable menuEnabled menuExpand menuHover menuPicture menuSetAction menuSetCheck menuSetData menuSetPicture menuSetValue menuShortcut menuShortcutText menuSize menuSort menuText menuURL menuValue min mineActive mineDetectedBy missionConfigFile missionDifficulty missionName missionNamespace missionStart missionVersion mod modelToWorld modelToWorldVisual modelToWorldVisualWorld modelToWorldWorld modParams moonIntensity moonPhase morale move move3DENCamera moveInAny moveInCargo moveInCommander moveInDriver moveInGunner moveInTurret moveObjectToEnd moveOut moveTime moveTo moveToCompleted moveToFailed musicVolume name nameSound nearEntities nearestBuilding nearestLocation nearestLocations nearestLocationWithDubbing nearestObject nearestObjects nearestTerrainObjects nearObjects nearObjectsReady nearRoads nearSupplies nearTargets needReload netId netObjNull newOverlay nextMenuItemIndex nextWeatherChange nMenuItems not numberOfEnginesRTD numberToDate objectCurators objectFromNetId objectParent objStatus onBriefingGroup onBriefingNotes onBriefingPlan onBriefingTeamSwitch onCommandModeChanged onDoubleClick onEachFrame onGroupIconClick onGroupIconOverEnter onGroupIconOverLeave onHCGroupSelectionChanged onMapSingleClick onPlayerConnected onPlayerDisconnected onPreloadFinished onPreloadStarted onShowNewObject onTeamSwitch openCuratorInterface openDLCPage openMap openSteamApp openYoutubeVideo or orderGetIn overcast overcastForecast owner param params parseNumber parseSimpleArray parseText parsingNamespace particlesQuality pickWeaponPool pitch pixelGrid pixelGridBase pixelGridNoUIScale pixelH pixelW playableSlotsNumber playableUnits playAction playActionNow player playerRespawnTime playerSide playersNumber playGesture playMission playMove playMoveNow playMusic playScriptedMission playSound playSound3D position positionCameraToWorld posScreenToWorld posWorldToScreen ppEffectAdjust ppEffectCommit ppEffectCommitted ppEffectCreate ppEffectDestroy ppEffectEnable ppEffectEnabled ppEffectForceInNVG precision preloadCamera preloadObject preloadSound preloadTitleObj preloadTitleRsc preprocessFile preprocessFileLineNumbers primaryWeapon primaryWeaponItems primaryWeaponMagazine priority processDiaryLink productVersion profileName profileNamespace profileNameSteam progressLoadingScreen progressPosition progressSetPosition publicVariable publicVariableClient publicVariableServer pushBack pushBackUnique putWeaponPool queryItemsPool queryMagazinePool queryWeaponPool rad radioChannelAdd radioChannelCreate radioChannelRemove radioChannelSetCallSign radioChannelSetLabel radioVolume rain rainbow random rank rankId rating rectangular registeredTasks registerTask reload reloadEnabled remoteControl remoteExec remoteExecCall remoteExecutedOwner remove3DENConnection remove3DENEventHandler remove3DENLayer removeAction removeAll3DENEventHandlers removeAllActions removeAllAssignedItems removeAllContainers removeAllCuratorAddons removeAllCuratorCameraAreas removeAllCuratorEditingAreas removeAllEventHandlers removeAllHandgunItems removeAllItems removeAllItemsWithMagazines removeAllMissionEventHandlers removeAllMPEventHandlers removeAllMusicEventHandlers removeAllOwnedMines removeAllPrimaryWeaponItems removeAllWeapons removeBackpack removeBackpackGlobal removeCuratorAddons removeCuratorCameraArea removeCuratorEditableObjects removeCuratorEditingArea removeDrawIcon removeDrawLinks removeEventHandler removeFromRemainsCollector removeGoggles removeGroupIcon removeHandgunItem removeHeadgear removeItem removeItemFromBackpack removeItemFromUniform removeItemFromVest removeItems removeMagazine removeMagazineGlobal removeMagazines removeMagazinesTurret removeMagazineTurret removeMenuItem removeMissionEventHandler removeMPEventHandler removeMusicEventHandler removeOwnedMine removePrimaryWeaponItem removeSecondaryWeaponItem removeSimpleTask removeSwitchableUnit removeTeamMember removeUniform removeVest removeWeapon removeWeaponAttachmentCargo removeWeaponCargo removeWeaponGlobal removeWeaponTurret reportRemoteTarget requiredVersion resetCamShake resetSubgroupDirection resize resources respawnVehicle restartEditorCamera reveal revealMine reverse reversedMouseY roadAt roadsConnectedTo roleDescription ropeAttachedObjects ropeAttachedTo ropeAttachEnabled ropeAttachTo ropeCreate ropeCut ropeDestroy ropeDetach ropeEndPosition ropeLength ropes ropeUnwind ropeUnwound rotorsForcesRTD rotorsRpmRTD round runInitScript safeZoneH safeZoneW safeZoneWAbs safeZoneX safeZoneXAbs safeZoneY save3DENInventory saveGame saveIdentity saveJoysticks saveOverlay saveProfileNamespace saveStatus saveVar savingEnabled say say2D say3D scopeName score scoreSide screenshot screenToWorld scriptDone scriptName scudState secondaryWeapon secondaryWeaponItems secondaryWeaponMagazine select selectBestPlaces selectDiarySubject selectedEditorObjects selectEditorObject selectionNames selectionPosition selectLeader selectMax selectMin selectNoPlayer selectPlayer selectRandom selectRandomWeighted selectWeapon selectWeaponTurret sendAUMessage sendSimpleCommand sendTask sendTaskResult sendUDPMessage serverCommand serverCommandAvailable serverCommandExecutable serverName serverTime set set3DENAttribute set3DENAttributes set3DENGrid set3DENIconsVisible set3DENLayer set3DENLinesVisible set3DENLogicType set3DENMissionAttribute set3DENMissionAttributes set3DENModelsVisible set3DENObjectType set3DENSelected setAccTime setActualCollectiveRTD setAirplaneThrottle setAirportSide setAmmo setAmmoCargo setAmmoOnPylon setAnimSpeedCoef setAperture setApertureNew setArmoryPoints setAttributes setAutonomous setBehaviour setBleedingRemaining setBrakesRTD setCameraInterest setCamShakeDefParams setCamShakeParams setCamUseTI setCaptive setCenterOfMass setCollisionLight setCombatMode setCompassOscillation setConvoySeparation setCuratorCameraAreaCeiling setCuratorCoef setCuratorEditingAreaType setCuratorWaypointCost setCurrentChannel setCurrentTask setCurrentWaypoint setCustomAimCoef setCustomWeightRTD setDamage setDammage setDate setDebriefingText setDefaultCamera setDestination setDetailMapBlendPars setDir setDirection setDrawIcon setDriveOnPath setDropInterval setDynamicSimulationDistance setDynamicSimulationDistanceCoef setEditorMode setEditorObjectScope setEffectCondition setEngineRPMRTD setFace setFaceAnimation setFatigue setFeatureType setFlagAnimationPhase setFlagOwner setFlagSide setFlagTexture setFog setFormation setFormationTask setFormDir setFriend setFromEditor setFSMVariable setFuel setFuelCargo setGroupIcon setGroupIconParams setGroupIconsSelectable setGroupIconsVisible setGroupId setGroupIdGlobal setGroupOwner setGusts setHideBehind setHit setHitIndex setHitPointDamage setHorizonParallaxCoef setHUDMovementLevels setIdentity setImportance setInfoPanel setLeader setLightAmbient setLightAttenuation setLightBrightness setLightColor setLightDayLight setLightFlareMaxDistance setLightFlareSize setLightIntensity setLightnings setLightUseFlare setLocalWindParams setMagazineTurretAmmo setMarkerAlpha setMarkerAlphaLocal setMarkerBrush setMarkerBrushLocal setMarkerColor setMarkerColorLocal setMarkerDir setMarkerDirLocal setMarkerPos setMarkerPosLocal setMarkerShape setMarkerShapeLocal setMarkerSize setMarkerSizeLocal setMarkerText setMarkerTextLocal setMarkerType setMarkerTypeLocal setMass setMimic setMousePosition setMusicEffect setMusicEventHandler setName setNameSound setObjectArguments setObjectMaterial setObjectMaterialGlobal setObjectProxy setObjectTexture setObjectTextureGlobal setObjectViewDistance setOvercast setOwner setOxygenRemaining setParticleCircle setParticleClass setParticleFire setParticleParams setParticleRandom setPilotCameraDirection setPilotCameraRotation setPilotCameraTarget setPilotLight setPiPEffect setPitch setPlateNumber setPlayable setPlayerRespawnTime setPos setPosASL setPosASL2 setPosASLW setPosATL setPosition setPosWorld setPylonLoadOut setPylonsPriority setRadioMsg setRain setRainbow setRandomLip setRank setRectangular setRepairCargo setRotorBrakeRTD setShadowDistance setShotParents setSide setSimpleTaskAlwaysVisible setSimpleTaskCustomData setSimpleTaskDescription setSimpleTaskDestination setSimpleTaskTarget setSimpleTaskType setSimulWeatherLayers setSize setSkill setSlingLoad setSoundEffect setSpeaker setSpeech setSpeedMode setStamina setStaminaScheme setStatValue setSuppression setSystemOfUnits setTargetAge setTaskMarkerOffset setTaskResult setTaskState setTerrainGrid setText setTimeMultiplier setTitleEffect setTrafficDensity setTrafficDistance setTrafficGap setTrafficSpeed setTriggerActivation setTriggerArea setTriggerStatements setTriggerText setTriggerTimeout setTriggerType setType setUnconscious setUnitAbility setUnitLoadout setUnitPos setUnitPosWeak setUnitRank setUnitRecoilCoefficient setUnitTrait setUnloadInCombat setUserActionText setUserMFDText setUserMFDvalue setVariable setVectorDir setVectorDirAndUp setVectorUp setVehicleAmmo setVehicleAmmoDef setVehicleArmor setVehicleCargo setVehicleId setVehicleLock setVehiclePosition setVehicleRadar setVehicleReceiveRemoteTargets setVehicleReportOwnPosition setVehicleReportRemoteTargets setVehicleTIPars setVehicleVarName setVelocity setVelocityModelSpace setVelocityTransformation setViewDistance setVisibleIfTreeCollapsed setWantedRPMRTD setWaves setWaypointBehaviour setWaypointCombatMode setWaypointCompletionRadius setWaypointDescription setWaypointForceBehaviour setWaypointFormation setWaypointHousePosition setWaypointLoiterRadius setWaypointLoiterType setWaypointName setWaypointPosition setWaypointScript setWaypointSpeed setWaypointStatements setWaypointTimeout setWaypointType setWaypointVisible setWeaponReloadingTime setWind setWindDir setWindForce setWindStr setWingForceScaleRTD setWPPos show3DIcons showChat showCinemaBorder showCommandingMenu showCompass showCuratorCompass showGPS showHUD showLegend showMap shownArtilleryComputer shownChat shownCompass shownCuratorCompass showNewEditorObject shownGPS shownHUD shownMap shownPad shownRadio shownScoretable shownUAVFeed shownWarrant shownWatch showPad showRadio showScoretable showSubtitles showUAVFeed showWarrant showWatch showWaypoint showWaypoints side sideChat sideEnemy sideFriendly sideRadio simpleTasks simulationEnabled simulCloudDensity simulCloudOcclusion simulInClouds simulWeatherSync sin size sizeOf skill skillFinal skipTime sleep sliderPosition sliderRange sliderSetPosition sliderSetRange sliderSetSpeed sliderSpeed slingLoadAssistantShown soldierMagazines someAmmo sort soundVolume spawn speaker speed speedMode splitString sqrt squadParams stance startLoadingScreen step stop stopEngineRTD stopped str sunOrMoon supportInfo suppressFor surfaceIsWater surfaceNormal surfaceType swimInDepth switchableUnits switchAction switchCamera switchGesture switchLight switchMove synchronizedObjects synchronizedTriggers synchronizedWaypoints synchronizeObjectsAdd synchronizeObjectsRemove synchronizeTrigger synchronizeWaypoint systemChat systemOfUnits tan targetKnowledge targets targetsAggregate targetsQuery taskAlwaysVisible taskChildren taskCompleted taskCustomData taskDescription taskDestination taskHint taskMarkerOffset taskParent taskResult taskState taskType teamMember teamName teams teamSwitch teamSwitchEnabled teamType terminate terrainIntersect terrainIntersectASL terrainIntersectAtASL text textLog textLogFormat tg time timeMultiplier titleCut titleFadeOut titleObj titleRsc titleText toArray toFixed toLower toString toUpper triggerActivated triggerActivation triggerArea triggerAttachedVehicle triggerAttachObject triggerAttachVehicle triggerDynamicSimulation triggerStatements triggerText triggerTimeout triggerTimeoutCurrent triggerType turretLocal turretOwner turretUnit tvAdd tvClear tvCollapse tvCollapseAll tvCount tvCurSel tvData tvDelete tvExpand tvExpandAll tvPicture tvSetColor tvSetCurSel tvSetData tvSetPicture tvSetPictureColor tvSetPictureColorDisabled tvSetPictureColorSelected tvSetPictureRight tvSetPictureRightColor tvSetPictureRightColorDisabled tvSetPictureRightColorSelected tvSetText tvSetTooltip tvSetValue tvSort tvSortByValue tvText tvTooltip tvValue type typeName typeOf UAVControl uiNamespace uiSleep unassignCurator unassignItem unassignTeam unassignVehicle underwater uniform uniformContainer uniformItems uniformMagazines unitAddons unitAimPosition unitAimPositionVisual unitBackpack unitIsUAV unitPos unitReady unitRecoilCoefficient units unitsBelowHeight unlinkItem unlockAchievement unregisterTask updateDrawIcon updateMenuItem updateObjectTree useAISteeringComponent useAudioTimeForMoves userInputDisabled vectorAdd vectorCos vectorCrossProduct vectorDiff vectorDir vectorDirVisual vectorDistance vectorDistanceSqr vectorDotProduct vectorFromTo vectorMagnitude vectorMagnitudeSqr vectorModelToWorld vectorModelToWorldVisual vectorMultiply vectorNormalized vectorUp vectorUpVisual vectorWorldToModel vectorWorldToModelVisual vehicle vehicleCargoEnabled vehicleChat vehicleRadio vehicleReceiveRemoteTargets vehicleReportOwnPosition vehicleReportRemoteTargets vehicles vehicleVarName velocity velocityModelSpace verifySignature vest vestContainer vestItems vestMagazines viewDistance visibleCompass visibleGPS visibleMap visiblePosition visiblePositionASL visibleScoretable visibleWatch waves waypointAttachedObject waypointAttachedVehicle waypointAttachObject waypointAttachVehicle waypointBehaviour waypointCombatMode waypointCompletionRadius waypointDescription waypointForceBehaviour waypointFormation waypointHousePosition waypointLoiterRadius waypointLoiterType waypointName waypointPosition waypoints waypointScript waypointsEnabledUAV waypointShow waypointSpeed waypointStatements waypointTimeout waypointTimeoutCurrent waypointType waypointVisible weaponAccessories weaponAccessoriesCargo weaponCargo weaponDirection weaponInertia weaponLowered weapons weaponsItems weaponsItemsCargo weaponState weaponsTurret weightRTD WFSideText wind ",
            literal: "blufor civilian configNull controlNull displayNull east endl false grpNull independent lineBreak locationNull nil objNull opfor pi resistance scriptNull sideAmbientLife sideEmpty sideLogic sideUnknown taskNull teamMemberNull true west"
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.NUMBER_MODE,
            VARIABLE,
            FUNCTION,
            STRINGS,
            PREPROCESSOR
        ],
        illegal: /#|^\$ /
    };
}
module.exports = $0cd4286fb7c92b5e$var$sqf;

});

parcelRegister("dpe6f", function(module, exports) {
/*
 Language: SQL More (mix of MySQL, Oracle, etc)
 Contributors: Nikolay Lisienko <info@neor.ru>, Heiko August <post@auge8472.de>, Travis Odom <travis.a.odom@gmail.com>, Vadimtro <vadimtro@yahoo.com>, Benjamin Auder <benjamin.auder@gmail.com>
 Website: https://en.wikipedia.org/wiki/SQL
 Category: database
 */ /*

This is a preservation of the old bloated SQL grammar which includes pretty much
the kitchen sink because no one was keeping track of which keywords belong to
which databases.  This is likely to be removed in the future.

- Oracle SQL should be factored into it's own 3rd party grammar.
- MySQL should be factored out into it's own 3rd party grammar.

*/ function $9c288c1b7d2e0054$var$sql_more(hljs) {
    var COMMENT_MODE = hljs.COMMENT("--", "$");
    return {
        name: "SQL (more)",
        aliases: [
            "mysql",
            "oracle"
        ],
        disableAutodetect: true,
        case_insensitive: true,
        illegal: /[<>{}*]/,
        contains: [
            {
                beginKeywords: "begin end start commit rollback savepoint lock alter create drop rename call delete do handler insert load replace select truncate update set show pragma grant merge describe use explain help declare prepare execute deallocate release unlock purge reset change stop analyze cache flush optimize repair kill install uninstall checksum restore check backup revoke comment values with",
                end: /;/,
                endsWithParent: true,
                keywords: {
                    $pattern: /[\w\.]+/,
                    keyword: "as abort abs absolute acc acce accep accept access accessed accessible account acos action activate add addtime admin administer advanced advise aes_decrypt aes_encrypt after agent aggregate ali alia alias all allocate allow alter always analyze ancillary and anti any anydata anydataset anyschema anytype apply archive archived archivelog are as asc ascii asin assembly assertion associate asynchronous at atan atn2 attr attri attrib attribu attribut attribute attributes audit authenticated authentication authid authors auto autoallocate autodblink autoextend automatic availability avg backup badfile basicfile before begin beginning benchmark between bfile bfile_base big bigfile bin binary_double binary_float binlog bit_and bit_count bit_length bit_or bit_xor bitmap blob_base block blocksize body both bound bucket buffer_cache buffer_pool build bulk by byte byteordermark bytes cache caching call calling cancel capacity cascade cascaded case cast catalog category ceil ceiling chain change changed char_base char_length character_length characters characterset charindex charset charsetform charsetid check checksum checksum_agg child choose chr chunk class cleanup clear client clob clob_base clone close cluster_id cluster_probability cluster_set clustering coalesce coercibility col collate collation collect colu colum column column_value columns columns_updated comment commit compact compatibility compiled complete composite_limit compound compress compute concat concat_ws concurrent confirm conn connec connect connect_by_iscycle connect_by_isleaf connect_by_root connect_time connection consider consistent constant constraint constraints constructor container content contents context contributors controlfile conv convert convert_tz corr corr_k corr_s corresponding corruption cos cost count count_big counted covar_pop covar_samp cpu_per_call cpu_per_session crc32 create creation critical cross cube cume_dist curdate current current_date current_time current_timestamp current_user cursor curtime customdatum cycle data database databases datafile datafiles datalength date_add date_cache date_format date_sub dateadd datediff datefromparts datename datepart datetime2fromparts day day_to_second dayname dayofmonth dayofweek dayofyear days db_role_change dbtimezone ddl deallocate declare decode decompose decrement decrypt deduplicate def defa defau defaul default defaults deferred defi defin define degrees delayed delegate delete delete_all delimited demand dense_rank depth dequeue des_decrypt des_encrypt des_key_file desc descr descri describ describe descriptor deterministic diagnostics difference dimension direct_load directory disable disable_all disallow disassociate discardfile disconnect diskgroup distinct distinctrow distribute distributed div do document domain dotnet double downgrade drop dumpfile duplicate duration each edition editionable editions element ellipsis else elsif elt empty enable enable_all enclosed encode encoding encrypt end end-exec endian enforced engine engines enqueue enterprise entityescaping eomonth error errors escaped evalname evaluate event eventdata events except exception exceptions exchange exclude excluding execu execut execute exempt exists exit exp expire explain explode export export_set extended extent external external_1 external_2 externally extract failed failed_login_attempts failover failure far fast feature_set feature_value fetch field fields file file_name_convert filesystem_like_logging final finish first first_value fixed flash_cache flashback floor flush following follows for forall force foreign form forma format found found_rows freelist freelists freepools fresh from from_base64 from_days ftp full function general generated get get_format get_lock getdate getutcdate global global_name globally go goto grant grants greatest group group_concat group_id grouping grouping_id groups gtid_subtract guarantee guard handler hash hashkeys having hea head headi headin heading heap help hex hierarchy high high_priority hosts hour hours http id ident_current ident_incr ident_seed identified identity idle_time if ifnull ignore iif ilike ilm immediate import in include including increment index indexes indexing indextype indicator indices inet6_aton inet6_ntoa inet_aton inet_ntoa infile initial initialized initially initrans inmemory inner innodb input insert install instance instantiable instr interface interleaved intersect into invalidate invisible is is_free_lock is_ipv4 is_ipv4_compat is_not is_not_null is_used_lock isdate isnull isolation iterate java join json json_exists keep keep_duplicates key keys kill language large last last_day last_insert_id last_value lateral lax lcase lead leading least leaves left len lenght length less level levels library like like2 like4 likec limit lines link list listagg little ln load load_file lob lobs local localtime localtimestamp locate locator lock locked log log10 log2 logfile logfiles logging logical logical_reads_per_call logoff logon logs long loop low low_priority lower lpad lrtrim ltrim main make_set makedate maketime managed management manual map mapping mask master master_pos_wait match matched materialized max maxextents maximize maxinstances maxlen maxlogfiles maxloghistory maxlogmembers maxsize maxtrans md5 measures median medium member memcompress memory merge microsecond mid migration min minextents minimum mining minus minute minutes minvalue missing mod mode model modification modify module monitoring month months mount move movement multiset mutex name name_const names nan national native natural nav nchar nclob nested never new newline next nextval no no_write_to_binlog noarchivelog noaudit nobadfile nocheck nocompress nocopy nocycle nodelay nodiscardfile noentityescaping noguarantee nokeep nologfile nomapping nomaxvalue nominimize nominvalue nomonitoring none noneditionable nonschema noorder nopr nopro noprom nopromp noprompt norely noresetlogs noreverse normal norowdependencies noschemacheck noswitch not nothing notice notnull notrim novalidate now nowait nth_value nullif nulls num numb numbe nvarchar nvarchar2 object ocicoll ocidate ocidatetime ociduration ociinterval ociloblocator ocinumber ociref ocirefcursor ocirowid ocistring ocitype oct octet_length of off offline offset oid oidindex old on online only opaque open operations operator optimal optimize option optionally or oracle oracle_date oradata ord ordaudio orddicom orddoc order ordimage ordinality ordvideo organization orlany orlvary out outer outfile outline output over overflow overriding package pad parallel parallel_enable parameters parent parse partial partition partitions pascal passing password password_grace_time password_lock_time password_reuse_max password_reuse_time password_verify_function patch path patindex pctincrease pctthreshold pctused pctversion percent percent_rank percentile_cont percentile_disc performance period period_add period_diff permanent physical pi pipe pipelined pivot pluggable plugin policy position post_transaction pow power pragma prebuilt precedes preceding precision prediction prediction_cost prediction_details prediction_probability prediction_set prepare present preserve prior priority private private_sga privileges procedural procedure procedure_analyze processlist profiles project prompt protection public publishingservername purge quarter query quick quiesce quota quotename radians raise rand range rank raw read reads readsize rebuild record records recover recovery recursive recycle redo reduced ref reference referenced references referencing refresh regexp_like register regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy reject rekey relational relative relaylog release release_lock relies_on relocate rely rem remainder rename repair repeat replace replicate replication required reset resetlogs resize resource respect restore restricted result result_cache resumable resume retention return returning returns reuse reverse revoke right rlike role roles rollback rolling rollup round row row_count rowdependencies rowid rownum rows rtrim rules safe salt sample save savepoint sb1 sb2 sb4 scan schema schemacheck scn scope scroll sdo_georaster sdo_topo_geometry search sec_to_time second seconds section securefile security seed segment select self semi sequence sequential serializable server servererror session session_user sessions_per_user set sets settings sha sha1 sha2 share shared shared_pool short show shrink shutdown si_averagecolor si_colorhistogram si_featurelist si_positionalcolor si_stillimage si_texture siblings sid sign sin size size_t sizes skip slave sleep smalldatetimefromparts smallfile snapshot some soname sort soundex source space sparse spfile split sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_small_result sql_variant_property sqlcode sqldata sqlerror sqlname sqlstate sqrt square standalone standby start starting startup statement static statistics stats_binomial_test stats_crosstab stats_ks_test stats_mode stats_mw_test stats_one_way_anova stats_t_test_ stats_t_test_indep stats_t_test_one stats_t_test_paired stats_wsr_test status std stddev stddev_pop stddev_samp stdev stop storage store stored str str_to_date straight_join strcmp strict string struct stuff style subdate subpartition subpartitions substitutable substr substring subtime subtring_index subtype success sum suspend switch switchoffset switchover sync synchronous synonym sys sys_xmlagg sysasm sysaux sysdate sysdatetimeoffset sysdba sysoper system system_user sysutcdatetime table tables tablespace tablesample tan tdo template temporary terminated tertiary_weights test than then thread through tier ties time time_format time_zone timediff timefromparts timeout timestamp timestampadd timestampdiff timezone_abbr timezone_minute timezone_region to to_base64 to_date to_days to_seconds todatetimeoffset trace tracking transaction transactional translate translation treat trigger trigger_nestlevel triggers trim truncate try_cast try_convert try_parse type ub1 ub2 ub4 ucase unarchived unbounded uncompress under undo unhex unicode uniform uninstall union unique unix_timestamp unknown unlimited unlock unnest unpivot unrecoverable unsafe unsigned until untrusted unusable unused update updated upgrade upped upper upsert url urowid usable usage use use_stored_outlines user user_data user_resources users using utc_date utc_timestamp uuid uuid_short validate validate_password_strength validation valist value values var var_samp varcharc vari varia variab variabl variable variables variance varp varraw varrawc varray verify version versions view virtual visible void wait wallet warning warnings week weekday weekofyear wellformed when whene whenev wheneve whenever where while whitespace window with within without work wrapped xdb xml xmlagg xmlattributes xmlcast xmlcolattval xmlelement xmlexists xmlforest xmlindex xmlnamespaces xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltype xor year year_to_month years yearweek",
                    literal: "true false null unknown",
                    built_in: "array bigint binary bit blob bool boolean char character date dec decimal float int int8 integer interval number numeric real record serial serial8 smallint text time timestamp tinyint varchar varchar2 varying void"
                },
                contains: [
                    {
                        className: "string",
                        begin: "'",
                        end: "'",
                        contains: [
                            {
                                begin: "''"
                            }
                        ]
                    },
                    {
                        className: "string",
                        begin: '"',
                        end: '"',
                        contains: [
                            {
                                begin: '""'
                            }
                        ]
                    },
                    {
                        className: "string",
                        begin: "`",
                        end: "`"
                    },
                    hljs.C_NUMBER_MODE,
                    hljs.C_BLOCK_COMMENT_MODE,
                    COMMENT_MODE,
                    hljs.HASH_COMMENT_MODE
                ]
            },
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            hljs.HASH_COMMENT_MODE
        ]
    };
}
module.exports = $9c288c1b7d2e0054$var$sql_more;

});

parcelRegister("5VO9I", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $45192e859cd1dce2$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $45192e859cd1dce2$var$concat(...args) {
    const joined = args.map((x)=>$45192e859cd1dce2$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $45192e859cd1dce2$var$either(...args) {
    const joined = "(" + args.map((x)=>$45192e859cd1dce2$var$source(x)).join("|") + ")";
    return joined;
}
/*
 Language: SQL
 Website: https://en.wikipedia.org/wiki/SQL
 Category: common, database
 */ function $45192e859cd1dce2$var$sql(hljs) {
    const COMMENT_MODE = hljs.COMMENT("--", "$");
    const STRING = {
        className: "string",
        variants: [
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/
                    }
                ]
            }
        ]
    };
    const QUOTED_IDENTIFIER = {
        begin: /"/,
        end: /"/,
        contains: [
            {
                begin: /""/
            }
        ]
    };
    const LITERALS = [
        "true",
        "false",
        // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
        // "null",
        "unknown"
    ];
    const MULTI_WORD_TYPES = [
        "double precision",
        "large object",
        "with timezone",
        "without timezone"
    ];
    const TYPES = [
        "bigint",
        "binary",
        "blob",
        "boolean",
        "char",
        "character",
        "clob",
        "date",
        "dec",
        "decfloat",
        "decimal",
        "float",
        "int",
        "integer",
        "interval",
        "nchar",
        "nclob",
        "national",
        "numeric",
        "real",
        "row",
        "smallint",
        "time",
        "timestamp",
        "varchar",
        "varying",
        "varbinary"
    ];
    const NON_RESERVED_WORDS = [
        "add",
        "asc",
        "collation",
        "desc",
        "final",
        "first",
        "last",
        "view"
    ];
    // https://jakewheat.github.io/sql-overview/sql-2016-foundation-grammar.html#reserved-word
    const RESERVED_WORDS = [
        "abs",
        "acos",
        "all",
        "allocate",
        "alter",
        "and",
        "any",
        "are",
        "array",
        "array_agg",
        "array_max_cardinality",
        "as",
        "asensitive",
        "asin",
        "asymmetric",
        "at",
        "atan",
        "atomic",
        "authorization",
        "avg",
        "begin",
        "begin_frame",
        "begin_partition",
        "between",
        "bigint",
        "binary",
        "blob",
        "boolean",
        "both",
        "by",
        "call",
        "called",
        "cardinality",
        "cascaded",
        "case",
        "cast",
        "ceil",
        "ceiling",
        "char",
        "char_length",
        "character",
        "character_length",
        "check",
        "classifier",
        "clob",
        "close",
        "coalesce",
        "collate",
        "collect",
        "column",
        "commit",
        "condition",
        "connect",
        "constraint",
        "contains",
        "convert",
        "copy",
        "corr",
        "corresponding",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "create",
        "cross",
        "cube",
        "cume_dist",
        "current",
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_row",
        "current_schema",
        "current_time",
        "current_timestamp",
        "current_path",
        "current_role",
        "current_transform_group_for_type",
        "current_user",
        "cursor",
        "cycle",
        "date",
        "day",
        "deallocate",
        "dec",
        "decimal",
        "decfloat",
        "declare",
        "default",
        "define",
        "delete",
        "dense_rank",
        "deref",
        "describe",
        "deterministic",
        "disconnect",
        "distinct",
        "double",
        "drop",
        "dynamic",
        "each",
        "element",
        "else",
        "empty",
        "end",
        "end_frame",
        "end_partition",
        "end-exec",
        "equals",
        "escape",
        "every",
        "except",
        "exec",
        "execute",
        "exists",
        "exp",
        "external",
        "extract",
        "false",
        "fetch",
        "filter",
        "first_value",
        "float",
        "floor",
        "for",
        "foreign",
        "frame_row",
        "free",
        "from",
        "full",
        "function",
        "fusion",
        "get",
        "global",
        "grant",
        "group",
        "grouping",
        "groups",
        "having",
        "hold",
        "hour",
        "identity",
        "in",
        "indicator",
        "initial",
        "inner",
        "inout",
        "insensitive",
        "insert",
        "int",
        "integer",
        "intersect",
        "intersection",
        "interval",
        "into",
        "is",
        "join",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "language",
        "large",
        "last_value",
        "lateral",
        "lead",
        "leading",
        "left",
        "like",
        "like_regex",
        "listagg",
        "ln",
        "local",
        "localtime",
        "localtimestamp",
        "log",
        "log10",
        "lower",
        "match",
        "match_number",
        "match_recognize",
        "matches",
        "max",
        "member",
        "merge",
        "method",
        "min",
        "minute",
        "mod",
        "modifies",
        "module",
        "month",
        "multiset",
        "national",
        "natural",
        "nchar",
        "nclob",
        "new",
        "no",
        "none",
        "normalize",
        "not",
        "nth_value",
        "ntile",
        "null",
        "nullif",
        "numeric",
        "octet_length",
        "occurrences_regex",
        "of",
        "offset",
        "old",
        "omit",
        "on",
        "one",
        "only",
        "open",
        "or",
        "order",
        "out",
        "outer",
        "over",
        "overlaps",
        "overlay",
        "parameter",
        "partition",
        "pattern",
        "per",
        "percent",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "period",
        "portion",
        "position",
        "position_regex",
        "power",
        "precedes",
        "precision",
        "prepare",
        "primary",
        "procedure",
        "ptf",
        "range",
        "rank",
        "reads",
        "real",
        "recursive",
        "ref",
        "references",
        "referencing",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "release",
        "result",
        "return",
        "returns",
        "revoke",
        "right",
        "rollback",
        "rollup",
        "row",
        "row_number",
        "rows",
        "running",
        "savepoint",
        "scope",
        "scroll",
        "search",
        "second",
        "seek",
        "select",
        "sensitive",
        "session_user",
        "set",
        "show",
        "similar",
        "sin",
        "sinh",
        "skip",
        "smallint",
        "some",
        "specific",
        "specifictype",
        "sql",
        "sqlexception",
        "sqlstate",
        "sqlwarning",
        "sqrt",
        "start",
        "static",
        "stddev_pop",
        "stddev_samp",
        "submultiset",
        "subset",
        "substring",
        "substring_regex",
        "succeeds",
        "sum",
        "symmetric",
        "system",
        "system_time",
        "system_user",
        "table",
        "tablesample",
        "tan",
        "tanh",
        "then",
        "time",
        "timestamp",
        "timezone_hour",
        "timezone_minute",
        "to",
        "trailing",
        "translate",
        "translate_regex",
        "translation",
        "treat",
        "trigger",
        "trim",
        "trim_array",
        "true",
        "truncate",
        "uescape",
        "union",
        "unique",
        "unknown",
        "unnest",
        "update   ",
        "upper",
        "user",
        "using",
        "value",
        "values",
        "value_of",
        "var_pop",
        "var_samp",
        "varbinary",
        "varchar",
        "varying",
        "versioning",
        "when",
        "whenever",
        "where",
        "width_bucket",
        "window",
        "with",
        "within",
        "without",
        "year"
    ];
    // these are reserved words we have identified to be functions
    // and should only be highlighted in a dispatch-like context
    // ie, array_agg(...), etc.
    const RESERVED_FUNCTIONS = [
        "abs",
        "acos",
        "array_agg",
        "asin",
        "atan",
        "avg",
        "cast",
        "ceil",
        "ceiling",
        "coalesce",
        "corr",
        "cos",
        "cosh",
        "count",
        "covar_pop",
        "covar_samp",
        "cume_dist",
        "dense_rank",
        "deref",
        "element",
        "exp",
        "extract",
        "first_value",
        "floor",
        "json_array",
        "json_arrayagg",
        "json_exists",
        "json_object",
        "json_objectagg",
        "json_query",
        "json_table",
        "json_table_primitive",
        "json_value",
        "lag",
        "last_value",
        "lead",
        "listagg",
        "ln",
        "log",
        "log10",
        "lower",
        "max",
        "min",
        "mod",
        "nth_value",
        "ntile",
        "nullif",
        "percent_rank",
        "percentile_cont",
        "percentile_disc",
        "position",
        "position_regex",
        "power",
        "rank",
        "regr_avgx",
        "regr_avgy",
        "regr_count",
        "regr_intercept",
        "regr_r2",
        "regr_slope",
        "regr_sxx",
        "regr_sxy",
        "regr_syy",
        "row_number",
        "sin",
        "sinh",
        "sqrt",
        "stddev_pop",
        "stddev_samp",
        "substring",
        "substring_regex",
        "sum",
        "tan",
        "tanh",
        "translate",
        "translate_regex",
        "treat",
        "trim",
        "trim_array",
        "unnest",
        "upper",
        "value_of",
        "var_pop",
        "var_samp",
        "width_bucket"
    ];
    // these functions can
    const POSSIBLE_WITHOUT_PARENS = [
        "current_catalog",
        "current_date",
        "current_default_transform_group",
        "current_path",
        "current_role",
        "current_schema",
        "current_transform_group_for_type",
        "current_user",
        "session_user",
        "system_time",
        "system_user",
        "current_time",
        "localtime",
        "current_timestamp",
        "localtimestamp"
    ];
    // those exist to boost relevance making these very
    // "SQL like" keyword combos worth +1 extra relevance
    const COMBOS = [
        "create table",
        "insert into",
        "primary key",
        "foreign key",
        "not null",
        "alter table",
        "add constraint",
        "grouping sets",
        "on overflow",
        "character set",
        "respect nulls",
        "ignore nulls",
        "nulls first",
        "nulls last",
        "depth first",
        "breadth first"
    ];
    const FUNCTIONS = RESERVED_FUNCTIONS;
    const KEYWORDS = [
        ...RESERVED_WORDS,
        ...NON_RESERVED_WORDS
    ].filter((keyword)=>{
        return !RESERVED_FUNCTIONS.includes(keyword);
    });
    const VARIABLE = {
        className: "variable",
        begin: /@[a-z0-9]+/
    };
    const OPERATOR = {
        className: "operator",
        begin: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
        relevance: 0
    };
    const FUNCTION_CALL = {
        begin: $45192e859cd1dce2$var$concat(/\b/, $45192e859cd1dce2$var$either(...FUNCTIONS), /\s*\(/),
        keywords: {
            built_in: FUNCTIONS
        }
    };
    // keywords with less than 3 letters are reduced in relevancy
    function reduceRelevancy(list, { exceptions: exceptions, when: when } = {}) {
        const qualifyFn = when;
        exceptions = exceptions || [];
        return list.map((item)=>{
            if (item.match(/\|\d+$/) || exceptions.includes(item)) return item;
            else if (qualifyFn(item)) return `${item}|0`;
            else return item;
        });
    }
    return {
        name: "SQL",
        case_insensitive: true,
        // does not include {} or HTML tags `</`
        illegal: /[{}]|<\//,
        keywords: {
            $pattern: /\b[\w\.]+/,
            keyword: reduceRelevancy(KEYWORDS, {
                when: (x)=>x.length < 3
            }),
            literal: LITERALS,
            type: TYPES,
            built_in: POSSIBLE_WITHOUT_PARENS
        },
        contains: [
            {
                begin: $45192e859cd1dce2$var$either(...COMBOS),
                keywords: {
                    $pattern: /[\w\.]+/,
                    keyword: KEYWORDS.concat(COMBOS),
                    literal: LITERALS,
                    type: TYPES
                }
            },
            {
                className: "type",
                begin: $45192e859cd1dce2$var$either(...MULTI_WORD_TYPES)
            },
            FUNCTION_CALL,
            VARIABLE,
            STRING,
            QUOTED_IDENTIFIER,
            hljs.C_NUMBER_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            COMMENT_MODE,
            OPERATOR
        ]
    };
}
module.exports = $45192e859cd1dce2$var$sql;

});

parcelRegister("djWDs", function(module, exports) {
/*
Language: Stan
Description: The Stan probabilistic programming language
Author: Jeffrey B. Arnold <jeffrey.arnold@gmail.com>
Website: http://mc-stan.org/
Category: scientific
*/ function $0280af9ecd8fe259$var$stan(hljs) {
    // variable names cannot conflict with block identifiers
    const BLOCKS = [
        "functions",
        "model",
        "data",
        "parameters",
        "quantities",
        "transformed",
        "generated"
    ];
    const STATEMENTS = [
        "for",
        "in",
        "if",
        "else",
        "while",
        "break",
        "continue",
        "return"
    ];
    const SPECIAL_FUNCTIONS = [
        "print",
        "reject",
        "increment_log_prob|10",
        "integrate_ode|10",
        "integrate_ode_rk45|10",
        "integrate_ode_bdf|10",
        "algebra_solver"
    ];
    const VAR_TYPES = [
        "int",
        "real",
        "vector",
        "ordered",
        "positive_ordered",
        "simplex",
        "unit_vector",
        "row_vector",
        "matrix",
        "cholesky_factor_corr|10",
        "cholesky_factor_cov|10",
        "corr_matrix|10",
        "cov_matrix|10",
        "void"
    ];
    const FUNCTIONS = [
        "Phi",
        "Phi_approx",
        "abs",
        "acos",
        "acosh",
        "algebra_solver",
        "append_array",
        "append_col",
        "append_row",
        "asin",
        "asinh",
        "atan",
        "atan2",
        "atanh",
        "bernoulli_cdf",
        "bernoulli_lccdf",
        "bernoulli_lcdf",
        "bernoulli_logit_lpmf",
        "bernoulli_logit_rng",
        "bernoulli_lpmf",
        "bernoulli_rng",
        "bessel_first_kind",
        "bessel_second_kind",
        "beta_binomial_cdf",
        "beta_binomial_lccdf",
        "beta_binomial_lcdf",
        "beta_binomial_lpmf",
        "beta_binomial_rng",
        "beta_cdf",
        "beta_lccdf",
        "beta_lcdf",
        "beta_lpdf",
        "beta_rng",
        "binary_log_loss",
        "binomial_cdf",
        "binomial_coefficient_log",
        "binomial_lccdf",
        "binomial_lcdf",
        "binomial_logit_lpmf",
        "binomial_lpmf",
        "binomial_rng",
        "block",
        "categorical_logit_lpmf",
        "categorical_logit_rng",
        "categorical_lpmf",
        "categorical_rng",
        "cauchy_cdf",
        "cauchy_lccdf",
        "cauchy_lcdf",
        "cauchy_lpdf",
        "cauchy_rng",
        "cbrt",
        "ceil",
        "chi_square_cdf",
        "chi_square_lccdf",
        "chi_square_lcdf",
        "chi_square_lpdf",
        "chi_square_rng",
        "cholesky_decompose",
        "choose",
        "col",
        "cols",
        "columns_dot_product",
        "columns_dot_self",
        "cos",
        "cosh",
        "cov_exp_quad",
        "crossprod",
        "csr_extract_u",
        "csr_extract_v",
        "csr_extract_w",
        "csr_matrix_times_vector",
        "csr_to_dense_matrix",
        "cumulative_sum",
        "determinant",
        "diag_matrix",
        "diag_post_multiply",
        "diag_pre_multiply",
        "diagonal",
        "digamma",
        "dims",
        "dirichlet_lpdf",
        "dirichlet_rng",
        "distance",
        "dot_product",
        "dot_self",
        "double_exponential_cdf",
        "double_exponential_lccdf",
        "double_exponential_lcdf",
        "double_exponential_lpdf",
        "double_exponential_rng",
        "e",
        "eigenvalues_sym",
        "eigenvectors_sym",
        "erf",
        "erfc",
        "exp",
        "exp2",
        "exp_mod_normal_cdf",
        "exp_mod_normal_lccdf",
        "exp_mod_normal_lcdf",
        "exp_mod_normal_lpdf",
        "exp_mod_normal_rng",
        "expm1",
        "exponential_cdf",
        "exponential_lccdf",
        "exponential_lcdf",
        "exponential_lpdf",
        "exponential_rng",
        "fabs",
        "falling_factorial",
        "fdim",
        "floor",
        "fma",
        "fmax",
        "fmin",
        "fmod",
        "frechet_cdf",
        "frechet_lccdf",
        "frechet_lcdf",
        "frechet_lpdf",
        "frechet_rng",
        "gamma_cdf",
        "gamma_lccdf",
        "gamma_lcdf",
        "gamma_lpdf",
        "gamma_p",
        "gamma_q",
        "gamma_rng",
        "gaussian_dlm_obs_lpdf",
        "get_lp",
        "gumbel_cdf",
        "gumbel_lccdf",
        "gumbel_lcdf",
        "gumbel_lpdf",
        "gumbel_rng",
        "head",
        "hypergeometric_lpmf",
        "hypergeometric_rng",
        "hypot",
        "inc_beta",
        "int_step",
        "integrate_ode",
        "integrate_ode_bdf",
        "integrate_ode_rk45",
        "inv",
        "inv_Phi",
        "inv_chi_square_cdf",
        "inv_chi_square_lccdf",
        "inv_chi_square_lcdf",
        "inv_chi_square_lpdf",
        "inv_chi_square_rng",
        "inv_cloglog",
        "inv_gamma_cdf",
        "inv_gamma_lccdf",
        "inv_gamma_lcdf",
        "inv_gamma_lpdf",
        "inv_gamma_rng",
        "inv_logit",
        "inv_sqrt",
        "inv_square",
        "inv_wishart_lpdf",
        "inv_wishart_rng",
        "inverse",
        "inverse_spd",
        "is_inf",
        "is_nan",
        "lbeta",
        "lchoose",
        "lgamma",
        "lkj_corr_cholesky_lpdf",
        "lkj_corr_cholesky_rng",
        "lkj_corr_lpdf",
        "lkj_corr_rng",
        "lmgamma",
        "lmultiply",
        "log",
        "log10",
        "log1m",
        "log1m_exp",
        "log1m_inv_logit",
        "log1p",
        "log1p_exp",
        "log2",
        "log_determinant",
        "log_diff_exp",
        "log_falling_factorial",
        "log_inv_logit",
        "log_mix",
        "log_rising_factorial",
        "log_softmax",
        "log_sum_exp",
        "logistic_cdf",
        "logistic_lccdf",
        "logistic_lcdf",
        "logistic_lpdf",
        "logistic_rng",
        "logit",
        "lognormal_cdf",
        "lognormal_lccdf",
        "lognormal_lcdf",
        "lognormal_lpdf",
        "lognormal_rng",
        "machine_precision",
        "matrix_exp",
        "max",
        "mdivide_left_spd",
        "mdivide_left_tri_low",
        "mdivide_right_spd",
        "mdivide_right_tri_low",
        "mean",
        "min",
        "modified_bessel_first_kind",
        "modified_bessel_second_kind",
        "multi_gp_cholesky_lpdf",
        "multi_gp_lpdf",
        "multi_normal_cholesky_lpdf",
        "multi_normal_cholesky_rng",
        "multi_normal_lpdf",
        "multi_normal_prec_lpdf",
        "multi_normal_rng",
        "multi_student_t_lpdf",
        "multi_student_t_rng",
        "multinomial_lpmf",
        "multinomial_rng",
        "multiply_log",
        "multiply_lower_tri_self_transpose",
        "neg_binomial_2_cdf",
        "neg_binomial_2_lccdf",
        "neg_binomial_2_lcdf",
        "neg_binomial_2_log_lpmf",
        "neg_binomial_2_log_rng",
        "neg_binomial_2_lpmf",
        "neg_binomial_2_rng",
        "neg_binomial_cdf",
        "neg_binomial_lccdf",
        "neg_binomial_lcdf",
        "neg_binomial_lpmf",
        "neg_binomial_rng",
        "negative_infinity",
        "normal_cdf",
        "normal_lccdf",
        "normal_lcdf",
        "normal_lpdf",
        "normal_rng",
        "not_a_number",
        "num_elements",
        "ordered_logistic_lpmf",
        "ordered_logistic_rng",
        "owens_t",
        "pareto_cdf",
        "pareto_lccdf",
        "pareto_lcdf",
        "pareto_lpdf",
        "pareto_rng",
        "pareto_type_2_cdf",
        "pareto_type_2_lccdf",
        "pareto_type_2_lcdf",
        "pareto_type_2_lpdf",
        "pareto_type_2_rng",
        "pi",
        "poisson_cdf",
        "poisson_lccdf",
        "poisson_lcdf",
        "poisson_log_lpmf",
        "poisson_log_rng",
        "poisson_lpmf",
        "poisson_rng",
        "positive_infinity",
        "pow",
        "print",
        "prod",
        "qr_Q",
        "qr_R",
        "quad_form",
        "quad_form_diag",
        "quad_form_sym",
        "rank",
        "rayleigh_cdf",
        "rayleigh_lccdf",
        "rayleigh_lcdf",
        "rayleigh_lpdf",
        "rayleigh_rng",
        "reject",
        "rep_array",
        "rep_matrix",
        "rep_row_vector",
        "rep_vector",
        "rising_factorial",
        "round",
        "row",
        "rows",
        "rows_dot_product",
        "rows_dot_self",
        "scaled_inv_chi_square_cdf",
        "scaled_inv_chi_square_lccdf",
        "scaled_inv_chi_square_lcdf",
        "scaled_inv_chi_square_lpdf",
        "scaled_inv_chi_square_rng",
        "sd",
        "segment",
        "sin",
        "singular_values",
        "sinh",
        "size",
        "skew_normal_cdf",
        "skew_normal_lccdf",
        "skew_normal_lcdf",
        "skew_normal_lpdf",
        "skew_normal_rng",
        "softmax",
        "sort_asc",
        "sort_desc",
        "sort_indices_asc",
        "sort_indices_desc",
        "sqrt",
        "sqrt2",
        "square",
        "squared_distance",
        "step",
        "student_t_cdf",
        "student_t_lccdf",
        "student_t_lcdf",
        "student_t_lpdf",
        "student_t_rng",
        "sub_col",
        "sub_row",
        "sum",
        "tail",
        "tan",
        "tanh",
        "target",
        "tcrossprod",
        "tgamma",
        "to_array_1d",
        "to_array_2d",
        "to_matrix",
        "to_row_vector",
        "to_vector",
        "trace",
        "trace_gen_quad_form",
        "trace_quad_form",
        "trigamma",
        "trunc",
        "uniform_cdf",
        "uniform_lccdf",
        "uniform_lcdf",
        "uniform_lpdf",
        "uniform_rng",
        "variance",
        "von_mises_lpdf",
        "von_mises_rng",
        "weibull_cdf",
        "weibull_lccdf",
        "weibull_lcdf",
        "weibull_lpdf",
        "weibull_rng",
        "wiener_lpdf",
        "wishart_lpdf",
        "wishart_rng"
    ];
    const DISTRIBUTIONS = [
        "bernoulli",
        "bernoulli_logit",
        "beta",
        "beta_binomial",
        "binomial",
        "binomial_logit",
        "categorical",
        "categorical_logit",
        "cauchy",
        "chi_square",
        "dirichlet",
        "double_exponential",
        "exp_mod_normal",
        "exponential",
        "frechet",
        "gamma",
        "gaussian_dlm_obs",
        "gumbel",
        "hypergeometric",
        "inv_chi_square",
        "inv_gamma",
        "inv_wishart",
        "lkj_corr",
        "lkj_corr_cholesky",
        "logistic",
        "lognormal",
        "multi_gp",
        "multi_gp_cholesky",
        "multi_normal",
        "multi_normal_cholesky",
        "multi_normal_prec",
        "multi_student_t",
        "multinomial",
        "neg_binomial",
        "neg_binomial_2",
        "neg_binomial_2_log",
        "normal",
        "ordered_logistic",
        "pareto",
        "pareto_type_2",
        "poisson",
        "poisson_log",
        "rayleigh",
        "scaled_inv_chi_square",
        "skew_normal",
        "student_t",
        "uniform",
        "von_mises",
        "weibull",
        "wiener",
        "wishart"
    ];
    return {
        name: "Stan",
        aliases: [
            "stanfuncs"
        ],
        keywords: {
            $pattern: hljs.IDENT_RE,
            title: BLOCKS,
            keyword: STATEMENTS.concat(VAR_TYPES).concat(SPECIAL_FUNCTIONS),
            built_in: FUNCTIONS
        },
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT(/#/, /$/, {
                relevance: 0,
                keywords: {
                    "meta-keyword": "include"
                }
            }),
            hljs.COMMENT(/\/\*/, /\*\//, {
                relevance: 0,
                // highlight doc strings mentioned in Stan reference
                contains: [
                    {
                        className: "doctag",
                        begin: /@(return|param)/
                    }
                ]
            }),
            {
                // hack: in range constraints, lower must follow "<"
                begin: /<\s*lower\s*=/,
                keywords: "lower"
            },
            {
                // hack: in range constraints, upper must follow either , or <
                // <lower = ..., upper = ...> or <upper = ...>
                begin: /[<,]\s*upper\s*=/,
                keywords: "upper"
            },
            {
                className: "keyword",
                begin: /\btarget\s*\+=/,
                relevance: 10
            },
            {
                begin: "~\\s*(" + hljs.IDENT_RE + ")\\s*\\(",
                keywords: DISTRIBUTIONS
            },
            {
                className: "number",
                variants: [
                    {
                        begin: /\b\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/
                    },
                    {
                        begin: /\.\d+(?:[eE][+-]?\d+)?\b/
                    }
                ],
                relevance: 0
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                relevance: 0
            }
        ]
    };
}
module.exports = $0280af9ecd8fe259$var$stan;

});

parcelRegister("czGB8", function(module, exports) {
/*
Language: Stata
Author: Brian Quistorff <bquistorff@gmail.com>
Contributors: Drew McDonald <drewmcdo@gmail.com>
Description: Stata is a general-purpose statistical software package created in 1985 by StataCorp.
Website: https://en.wikipedia.org/wiki/Stata
Category: scientific
*/ /*
  This is a fork and modification of Drew McDonald's file (https://github.com/drewmcdonald/stata-highlighting). I have also included a list of builtin commands from https://bugs.kde.org/show_bug.cgi?id=135646.
*/ function $9279cbf60d8fbe2d$var$stata(hljs) {
    return {
        name: "Stata",
        aliases: [
            "do",
            "ado"
        ],
        case_insensitive: true,
        keywords: "if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",
        contains: [
            {
                className: "symbol",
                begin: /`[a-zA-Z0-9_]+'/
            },
            {
                className: "variable",
                begin: /\$\{?[a-zA-Z0-9_]+\}?/
            },
            {
                className: "string",
                variants: [
                    {
                        begin: '`"[^\r\n]*?"\''
                    },
                    {
                        begin: '"[^\r\n"]*"'
                    }
                ]
            },
            {
                className: "built_in",
                variants: [
                    {
                        begin: "\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()"
                    }
                ]
            },
            hljs.COMMENT("^[ 	]*\\*.*$", false),
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE
        ]
    };
}
module.exports = $9279cbf60d8fbe2d$var$stata;

});

parcelRegister("lsJDk", function(module, exports) {
/*
Language: STEP Part 21
Contributors: Adam Joseph Cook <adam.joseph.cook@gmail.com>
Description: Syntax highlighter for STEP Part 21 files (ISO 10303-21).
Website: https://en.wikipedia.org/wiki/ISO_10303-21
*/ function $f9ff9c58a0338201$var$step21(hljs) {
    const STEP21_IDENT_RE = "[A-Z_][A-Z0-9_.]*";
    const STEP21_KEYWORDS = {
        $pattern: STEP21_IDENT_RE,
        keyword: "HEADER ENDSEC DATA"
    };
    const STEP21_START = {
        className: "meta",
        begin: "ISO-10303-21;",
        relevance: 10
    };
    const STEP21_CLOSE = {
        className: "meta",
        begin: "END-ISO-10303-21;",
        relevance: 10
    };
    return {
        name: "STEP Part 21",
        aliases: [
            "p21",
            "step",
            "stp"
        ],
        case_insensitive: true,
        keywords: STEP21_KEYWORDS,
        contains: [
            STEP21_START,
            STEP21_CLOSE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT("/\\*\\*!", "\\*/"),
            hljs.C_NUMBER_MODE,
            hljs.inherit(hljs.APOS_STRING_MODE, {
                illegal: null
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "#",
                        end: "\\d+",
                        illegal: "\\W"
                    }
                ]
            }
        ]
    };
}
module.exports = $f9ff9c58a0338201$var$step21;

});

parcelRegister("6hHNE", function(module, exports) {
const $49364e5b0a5ced59$var$MODES = (hljs)=>{
    return {
        IMPORTANT: {
            className: "meta",
            begin: "!important"
        },
        HEXCOLOR: {
            className: "number",
            begin: "#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})"
        },
        ATTRIBUTE_SELECTOR_MODE: {
            className: "selector-attr",
            begin: /\[/,
            end: /\]/,
            illegal: "$",
            contains: [
                hljs.APOS_STRING_MODE,
                hljs.QUOTE_STRING_MODE
            ]
        }
    };
};
const $49364e5b0a5ced59$var$TAGS = [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "audio",
    "b",
    "blockquote",
    "body",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "dd",
    "del",
    "details",
    "dfn",
    "div",
    "dl",
    "dt",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "mark",
    "menu",
    "nav",
    "object",
    "ol",
    "p",
    "q",
    "quote",
    "samp",
    "section",
    "span",
    "strong",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "ul",
    "var",
    "video"
];
const $49364e5b0a5ced59$var$MEDIA_FEATURES = [
    "any-hover",
    "any-pointer",
    "aspect-ratio",
    "color",
    "color-gamut",
    "color-index",
    "device-aspect-ratio",
    "device-height",
    "device-width",
    "display-mode",
    "forced-colors",
    "grid",
    "height",
    "hover",
    "inverted-colors",
    "monochrome",
    "orientation",
    "overflow-block",
    "overflow-inline",
    "pointer",
    "prefers-color-scheme",
    "prefers-contrast",
    "prefers-reduced-motion",
    "prefers-reduced-transparency",
    "resolution",
    "scan",
    "scripting",
    "update",
    "width",
    // TODO: find a better solution?
    "min-width",
    "max-width",
    "min-height",
    "max-height"
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-classes
const $49364e5b0a5ced59$var$PSEUDO_CLASSES = [
    "active",
    "any-link",
    "blank",
    "checked",
    "current",
    "default",
    "defined",
    "dir",
    "disabled",
    "drop",
    "empty",
    "enabled",
    "first",
    "first-child",
    "first-of-type",
    "fullscreen",
    "future",
    "focus",
    "focus-visible",
    "focus-within",
    "has",
    "host",
    "host-context",
    "hover",
    "indeterminate",
    "in-range",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "local-link",
    "not",
    "nth-child",
    "nth-col",
    "nth-last-child",
    "nth-last-col",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "past",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "target",
    "target-within",
    "user-invalid",
    "valid",
    "visited",
    "where" // where()
];
// https://developer.mozilla.org/en-US/docs/Web/CSS/Pseudo-elements
const $49364e5b0a5ced59$var$PSEUDO_ELEMENTS = [
    "after",
    "backdrop",
    "before",
    "cue",
    "cue-region",
    "first-letter",
    "first-line",
    "grammar-error",
    "marker",
    "part",
    "placeholder",
    "selection",
    "slotted",
    "spelling-error"
];
const $49364e5b0a5ced59$var$ATTRIBUTES = [
    "align-content",
    "align-items",
    "align-self",
    "animation",
    "animation-delay",
    "animation-direction",
    "animation-duration",
    "animation-fill-mode",
    "animation-iteration-count",
    "animation-name",
    "animation-play-state",
    "animation-timing-function",
    "auto",
    "backface-visibility",
    "background",
    "background-attachment",
    "background-clip",
    "background-color",
    "background-image",
    "background-origin",
    "background-position",
    "background-repeat",
    "background-size",
    "border",
    "border-bottom",
    "border-bottom-color",
    "border-bottom-left-radius",
    "border-bottom-right-radius",
    "border-bottom-style",
    "border-bottom-width",
    "border-collapse",
    "border-color",
    "border-image",
    "border-image-outset",
    "border-image-repeat",
    "border-image-slice",
    "border-image-source",
    "border-image-width",
    "border-left",
    "border-left-color",
    "border-left-style",
    "border-left-width",
    "border-radius",
    "border-right",
    "border-right-color",
    "border-right-style",
    "border-right-width",
    "border-spacing",
    "border-style",
    "border-top",
    "border-top-color",
    "border-top-left-radius",
    "border-top-right-radius",
    "border-top-style",
    "border-top-width",
    "border-width",
    "bottom",
    "box-decoration-break",
    "box-shadow",
    "box-sizing",
    "break-after",
    "break-before",
    "break-inside",
    "caption-side",
    "clear",
    "clip",
    "clip-path",
    "color",
    "column-count",
    "column-fill",
    "column-gap",
    "column-rule",
    "column-rule-color",
    "column-rule-style",
    "column-rule-width",
    "column-span",
    "column-width",
    "columns",
    "content",
    "counter-increment",
    "counter-reset",
    "cursor",
    "direction",
    "display",
    "empty-cells",
    "filter",
    "flex",
    "flex-basis",
    "flex-direction",
    "flex-flow",
    "flex-grow",
    "flex-shrink",
    "flex-wrap",
    "float",
    "font",
    "font-display",
    "font-family",
    "font-feature-settings",
    "font-kerning",
    "font-language-override",
    "font-size",
    "font-size-adjust",
    "font-smoothing",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-variant-ligatures",
    "font-variation-settings",
    "font-weight",
    "height",
    "hyphens",
    "icon",
    "image-orientation",
    "image-rendering",
    "image-resolution",
    "ime-mode",
    "inherit",
    "initial",
    "justify-content",
    "left",
    "letter-spacing",
    "line-height",
    "list-style",
    "list-style-image",
    "list-style-position",
    "list-style-type",
    "margin",
    "margin-bottom",
    "margin-left",
    "margin-right",
    "margin-top",
    "marks",
    "mask",
    "max-height",
    "max-width",
    "min-height",
    "min-width",
    "nav-down",
    "nav-index",
    "nav-left",
    "nav-right",
    "nav-up",
    "none",
    "normal",
    "object-fit",
    "object-position",
    "opacity",
    "order",
    "orphans",
    "outline",
    "outline-color",
    "outline-offset",
    "outline-style",
    "outline-width",
    "overflow",
    "overflow-wrap",
    "overflow-x",
    "overflow-y",
    "padding",
    "padding-bottom",
    "padding-left",
    "padding-right",
    "padding-top",
    "page-break-after",
    "page-break-before",
    "page-break-inside",
    "perspective",
    "perspective-origin",
    "pointer-events",
    "position",
    "quotes",
    "resize",
    "right",
    "src",
    "tab-size",
    "table-layout",
    "text-align",
    "text-align-last",
    "text-decoration",
    "text-decoration-color",
    "text-decoration-line",
    "text-decoration-style",
    "text-indent",
    "text-overflow",
    "text-rendering",
    "text-shadow",
    "text-transform",
    "text-underline-position",
    "top",
    "transform",
    "transform-origin",
    "transform-style",
    "transition",
    "transition-delay",
    "transition-duration",
    "transition-property",
    "transition-timing-function",
    "unicode-bidi",
    "vertical-align",
    "visibility",
    "white-space",
    "widows",
    "width",
    "word-break",
    "word-spacing",
    "word-wrap",
    "z-index"
].reverse();
/*
Language: Stylus
Author: Bryant Williams <b.n.williams@gmail.com>
Description: Stylus is an expressive, robust, feature-rich CSS language built for nodejs.
Website: https://github.com/stylus/stylus
Category: css
*/ /** @type LanguageFn */ function $49364e5b0a5ced59$var$stylus(hljs) {
    const modes = $49364e5b0a5ced59$var$MODES(hljs);
    const AT_MODIFIERS = "and or not only";
    const VARIABLE = {
        className: "variable",
        begin: "\\$" + hljs.IDENT_RE
    };
    const AT_KEYWORDS = [
        "charset",
        "css",
        "debug",
        "extend",
        "font-face",
        "for",
        "import",
        "include",
        "keyframes",
        "media",
        "mixin",
        "page",
        "warn",
        "while"
    ];
    const LOOKAHEAD_TAG_END = "(?=[.\\s\\n[:,(])";
    // illegals
    const ILLEGAL = [
        "\\?",
        "(\\bReturn\\b)",
        "(\\bEnd\\b)",
        "(\\bend\\b)",
        "(\\bdef\\b)",
        ";",
        "#\\s",
        "\\*\\s",
        "===\\s",
        "\\|",
        "%" // prolog
    ];
    return {
        name: "Stylus",
        aliases: [
            "styl"
        ],
        case_insensitive: false,
        keywords: "if else for in",
        illegal: "(" + ILLEGAL.join("|") + ")",
        contains: [
            // strings
            hljs.QUOTE_STRING_MODE,
            hljs.APOS_STRING_MODE,
            // comments
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            // hex colors
            modes.HEXCOLOR,
            // class tag
            {
                begin: "\\.[a-zA-Z][a-zA-Z0-9_-]*" + LOOKAHEAD_TAG_END,
                className: "selector-class"
            },
            // id tag
            {
                begin: "#[a-zA-Z][a-zA-Z0-9_-]*" + LOOKAHEAD_TAG_END,
                className: "selector-id"
            },
            // tags
            {
                begin: "\\b(" + $49364e5b0a5ced59$var$TAGS.join("|") + ")" + LOOKAHEAD_TAG_END,
                className: "selector-tag"
            },
            // psuedo selectors
            {
                className: "selector-pseudo",
                begin: "&?:(" + $49364e5b0a5ced59$var$PSEUDO_CLASSES.join("|") + ")" + LOOKAHEAD_TAG_END
            },
            {
                className: "selector-pseudo",
                begin: "&?::(" + $49364e5b0a5ced59$var$PSEUDO_ELEMENTS.join("|") + ")" + LOOKAHEAD_TAG_END
            },
            modes.ATTRIBUTE_SELECTOR_MODE,
            {
                className: "keyword",
                begin: /@media/,
                starts: {
                    end: /[{;}]/,
                    keywords: {
                        $pattern: /[a-z-]+/,
                        keyword: AT_MODIFIERS,
                        attribute: $49364e5b0a5ced59$var$MEDIA_FEATURES.join(" ")
                    },
                    contains: [
                        hljs.CSS_NUMBER_MODE
                    ]
                }
            },
            // @ keywords
            {
                className: "keyword",
                begin: "@((-(o|moz|ms|webkit)-)?(" + AT_KEYWORDS.join("|") + "))\\b"
            },
            // variables
            VARIABLE,
            // dimension
            hljs.CSS_NUMBER_MODE,
            // functions
            //  - only from beginning of line + whitespace
            {
                className: "function",
                begin: "^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",
                illegal: "[\\n]",
                returnBegin: true,
                contains: [
                    {
                        className: "title",
                        begin: "\\b[a-zA-Z][a-zA-Z0-9_-]*"
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            modes.HEXCOLOR,
                            VARIABLE,
                            hljs.APOS_STRING_MODE,
                            hljs.CSS_NUMBER_MODE,
                            hljs.QUOTE_STRING_MODE
                        ]
                    }
                ]
            },
            // attributes
            //  - only from beginning of line + whitespace
            //  - must have whitespace after it
            {
                className: "attribute",
                begin: "\\b(" + $49364e5b0a5ced59$var$ATTRIBUTES.join("|") + ")\\b",
                starts: {
                    // value container
                    end: /;|$/,
                    contains: [
                        modes.HEXCOLOR,
                        VARIABLE,
                        hljs.APOS_STRING_MODE,
                        hljs.QUOTE_STRING_MODE,
                        hljs.CSS_NUMBER_MODE,
                        hljs.C_BLOCK_COMMENT_MODE,
                        modes.IMPORTANT
                    ],
                    illegal: /\./,
                    relevance: 0
                }
            }
        ]
    };
}
module.exports = $49364e5b0a5ced59$var$stylus;

});

parcelRegister("7JIKd", function(module, exports) {
/*
Language: SubUnit
Author: Sergey Bronnikov <sergeyb@bronevichok.ru>
Website: https://pypi.org/project/python-subunit/
*/ function $5a1f71b09da17c6a$var$subunit(hljs) {
    const DETAILS = {
        className: "string",
        begin: "\\[\n(multipart)?",
        end: "\\]\n"
    };
    const TIME = {
        className: "string",
        begin: "\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z"
    };
    const PROGRESSVALUE = {
        className: "string",
        begin: "(\\+|-)\\d+"
    };
    const KEYWORDS = {
        className: "keyword",
        relevance: 10,
        variants: [
            {
                begin: "^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?"
            },
            {
                begin: "^progress(:?)(\\s+)?(pop|push)?"
            },
            {
                begin: "^tags:"
            },
            {
                begin: "^time:"
            }
        ]
    };
    return {
        name: "SubUnit",
        case_insensitive: true,
        contains: [
            DETAILS,
            TIME,
            PROGRESSVALUE,
            KEYWORDS
        ]
    };
}
module.exports = $5a1f71b09da17c6a$var$subunit;

});

parcelRegister("3Vwbc", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $2dbfa82f8a3b3302$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $2dbfa82f8a3b3302$var$lookahead(re) {
    return $2dbfa82f8a3b3302$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $2dbfa82f8a3b3302$var$concat(...args) {
    const joined = args.map((x)=>$2dbfa82f8a3b3302$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $2dbfa82f8a3b3302$var$either(...args) {
    const joined = "(" + args.map((x)=>$2dbfa82f8a3b3302$var$source(x)).join("|") + ")";
    return joined;
}
const $2dbfa82f8a3b3302$var$keywordWrapper = (keyword)=>$2dbfa82f8a3b3302$var$concat(/\b/, keyword, /\w$/.test(keyword) ? /\b/ : /\B/);
// Keywords that require a leading dot.
const $2dbfa82f8a3b3302$var$dotKeywords = [
    "Protocol",
    "Type" // contextual
].map($2dbfa82f8a3b3302$var$keywordWrapper);
// Keywords that may have a leading dot.
const $2dbfa82f8a3b3302$var$optionalDotKeywords = [
    "init",
    "self"
].map($2dbfa82f8a3b3302$var$keywordWrapper);
// should register as keyword, not type
const $2dbfa82f8a3b3302$var$keywordTypes = [
    "Any",
    "Self"
];
// Regular keywords and literals.
const $2dbfa82f8a3b3302$var$keywords = [
    // strings below will be fed into the regular `keywords` engine while regex
    // will result in additional modes being created to scan for those keywords to
    // avoid conflicts with other rules
    "associatedtype",
    "async",
    "await",
    /as\?/,
    /as!/,
    "as",
    "break",
    "case",
    "catch",
    "class",
    "continue",
    "convenience",
    "default",
    "defer",
    "deinit",
    "didSet",
    "do",
    "dynamic",
    "else",
    "enum",
    "extension",
    "fallthrough",
    /fileprivate\(set\)/,
    "fileprivate",
    "final",
    "for",
    "func",
    "get",
    "guard",
    "if",
    "import",
    "indirect",
    "infix",
    /init\?/,
    /init!/,
    "inout",
    /internal\(set\)/,
    "internal",
    "in",
    "is",
    "lazy",
    "let",
    "mutating",
    "nonmutating",
    /open\(set\)/,
    "open",
    "operator",
    "optional",
    "override",
    "postfix",
    "precedencegroup",
    "prefix",
    /private\(set\)/,
    "private",
    "protocol",
    /public\(set\)/,
    "public",
    "repeat",
    "required",
    "rethrows",
    "return",
    "set",
    "some",
    "static",
    "struct",
    "subscript",
    "super",
    "switch",
    "throws",
    "throw",
    /try\?/,
    /try!/,
    "try",
    "typealias",
    /unowned\(safe\)/,
    /unowned\(unsafe\)/,
    "unowned",
    "var",
    "weak",
    "where",
    "while",
    "willSet" // contextual
];
// NOTE: Contextual keywords are reserved only in specific contexts.
// Ideally, these should be matched using modes to avoid false positives.
// Literals.
const $2dbfa82f8a3b3302$var$literals = [
    "false",
    "nil",
    "true"
];
// Keywords used in precedence groups.
const $2dbfa82f8a3b3302$var$precedencegroupKeywords = [
    "assignment",
    "associativity",
    "higherThan",
    "left",
    "lowerThan",
    "none",
    "right"
];
// Keywords that start with a number sign (#).
// #available is handled separately.
const $2dbfa82f8a3b3302$var$numberSignKeywords = [
    "#colorLiteral",
    "#column",
    "#dsohandle",
    "#else",
    "#elseif",
    "#endif",
    "#error",
    "#file",
    "#fileID",
    "#fileLiteral",
    "#filePath",
    "#function",
    "#if",
    "#imageLiteral",
    "#keyPath",
    "#line",
    "#selector",
    "#sourceLocation",
    "#warn_unqualified_access",
    "#warning"
];
// Global functions in the Standard Library.
const $2dbfa82f8a3b3302$var$builtIns = [
    "abs",
    "all",
    "any",
    "assert",
    "assertionFailure",
    "debugPrint",
    "dump",
    "fatalError",
    "getVaList",
    "isKnownUniquelyReferenced",
    "max",
    "min",
    "numericCast",
    "pointwiseMax",
    "pointwiseMin",
    "precondition",
    "preconditionFailure",
    "print",
    "readLine",
    "repeatElement",
    "sequence",
    "stride",
    "swap",
    "swift_unboxFromSwiftValueWithType",
    "transcode",
    "type",
    "unsafeBitCast",
    "unsafeDowncast",
    "withExtendedLifetime",
    "withUnsafeMutablePointer",
    "withUnsafePointer",
    "withVaList",
    "withoutActuallyEscaping",
    "zip"
];
// Valid first characters for operators.
const $2dbfa82f8a3b3302$var$operatorHead = $2dbfa82f8a3b3302$var$either(/[/=\-+!*%<>&|^~?]/, /[\u00A1-\u00A7]/, /[\u00A9\u00AB]/, /[\u00AC\u00AE]/, /[\u00B0\u00B1]/, /[\u00B6\u00BB\u00BF\u00D7\u00F7]/, /[\u2016-\u2017]/, /[\u2020-\u2027]/, /[\u2030-\u203E]/, /[\u2041-\u2053]/, /[\u2055-\u205E]/, /[\u2190-\u23FF]/, /[\u2500-\u2775]/, /[\u2794-\u2BFF]/, /[\u2E00-\u2E7F]/, /[\u3001-\u3003]/, /[\u3008-\u3020]/, /[\u3030]/);
// Valid characters for operators.
const $2dbfa82f8a3b3302$var$operatorCharacter = $2dbfa82f8a3b3302$var$either($2dbfa82f8a3b3302$var$operatorHead, /[\u0300-\u036F]/, /[\u1DC0-\u1DFF]/, /[\u20D0-\u20FF]/, /[\uFE00-\uFE0F]/, /[\uFE20-\uFE2F]/);
// Valid operator.
const $2dbfa82f8a3b3302$var$operator = $2dbfa82f8a3b3302$var$concat($2dbfa82f8a3b3302$var$operatorHead, $2dbfa82f8a3b3302$var$operatorCharacter, "*");
// Valid first characters for identifiers.
const $2dbfa82f8a3b3302$var$identifierHead = $2dbfa82f8a3b3302$var$either(/[a-zA-Z_]/, /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/, /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/, /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/, /[\u1E00-\u1FFF]/, /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/, /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/, /[\u2C00-\u2DFF\u2E80-\u2FFF]/, /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/, /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/, /[\uFE47-\uFEFE\uFF00-\uFFFD]/ // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
);
// Valid characters for identifiers.
const $2dbfa82f8a3b3302$var$identifierCharacter = $2dbfa82f8a3b3302$var$either($2dbfa82f8a3b3302$var$identifierHead, /\d/, /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/);
// Valid identifier.
const $2dbfa82f8a3b3302$var$identifier = $2dbfa82f8a3b3302$var$concat($2dbfa82f8a3b3302$var$identifierHead, $2dbfa82f8a3b3302$var$identifierCharacter, "*");
// Valid type identifier.
const $2dbfa82f8a3b3302$var$typeIdentifier = $2dbfa82f8a3b3302$var$concat(/[A-Z]/, $2dbfa82f8a3b3302$var$identifierCharacter, "*");
// Built-in attributes, which are highlighted as keywords.
// @available is handled separately.
const $2dbfa82f8a3b3302$var$keywordAttributes = [
    "autoclosure",
    $2dbfa82f8a3b3302$var$concat(/convention\(/, $2dbfa82f8a3b3302$var$either("swift", "block", "c"), /\)/),
    "discardableResult",
    "dynamicCallable",
    "dynamicMemberLookup",
    "escaping",
    "frozen",
    "GKInspectable",
    "IBAction",
    "IBDesignable",
    "IBInspectable",
    "IBOutlet",
    "IBSegueAction",
    "inlinable",
    "main",
    "nonobjc",
    "NSApplicationMain",
    "NSCopying",
    "NSManaged",
    $2dbfa82f8a3b3302$var$concat(/objc\(/, $2dbfa82f8a3b3302$var$identifier, /\)/),
    "objc",
    "objcMembers",
    "propertyWrapper",
    "requires_stored_property_inits",
    "testable",
    "UIApplicationMain",
    "unknown",
    "usableFromInline"
];
// Contextual keywords used in @available and #available.
const $2dbfa82f8a3b3302$var$availabilityKeywords = [
    "iOS",
    "iOSApplicationExtension",
    "macOS",
    "macOSApplicationExtension",
    "macCatalyst",
    "macCatalystApplicationExtension",
    "watchOS",
    "watchOSApplicationExtension",
    "tvOS",
    "tvOSApplicationExtension",
    "swift"
];
/*
Language: Swift
Description: Swift is a general-purpose programming language built using a modern approach to safety, performance, and software design patterns.
Author: Steven Van Impe <steven.vanimpe@icloud.com>
Contributors: Chris Eidhof <chris@eidhof.nl>, Nate Cook <natecook@gmail.com>, Alexander Lichter <manniL@gmx.net>, Richard Gibson <gibson042@github>
Website: https://swift.org
Category: common, system
*/ /** @type LanguageFn */ function $2dbfa82f8a3b3302$var$swift(hljs) {
    const WHITESPACE = {
        match: /\s+/,
        relevance: 0
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID411
    const BLOCK_COMMENT = hljs.COMMENT("/\\*", "\\*/", {
        contains: [
            "self"
        ]
    });
    const COMMENTS = [
        hljs.C_LINE_COMMENT_MODE,
        BLOCK_COMMENT
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID413
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html
    const DOT_KEYWORD = {
        className: "keyword",
        begin: $2dbfa82f8a3b3302$var$concat(/\./, $2dbfa82f8a3b3302$var$lookahead($2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$dotKeywords, ...$2dbfa82f8a3b3302$var$optionalDotKeywords))),
        end: $2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$dotKeywords, ...$2dbfa82f8a3b3302$var$optionalDotKeywords),
        excludeBegin: true
    };
    const KEYWORD_GUARD = {
        // Consume .keyword to prevent highlighting properties and methods as keywords.
        match: $2dbfa82f8a3b3302$var$concat(/\./, $2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$keywords)),
        relevance: 0
    };
    const PLAIN_KEYWORDS = $2dbfa82f8a3b3302$var$keywords.filter((kw)=>typeof kw === "string").concat([
        "_|0"
    ]); // seems common, so 0 relevance
    const REGEX_KEYWORDS = $2dbfa82f8a3b3302$var$keywords.filter((kw)=>typeof kw !== "string") // find regex
    .concat($2dbfa82f8a3b3302$var$keywordTypes).map($2dbfa82f8a3b3302$var$keywordWrapper);
    const KEYWORD = {
        variants: [
            {
                className: "keyword",
                match: $2dbfa82f8a3b3302$var$either(...REGEX_KEYWORDS, ...$2dbfa82f8a3b3302$var$optionalDotKeywords)
            }
        ]
    };
    // find all the regular keywords
    const KEYWORDS = {
        $pattern: $2dbfa82f8a3b3302$var$either(/\b\w+/, /#\w+/ // number keywords
        ),
        keyword: PLAIN_KEYWORDS.concat($2dbfa82f8a3b3302$var$numberSignKeywords),
        literal: $2dbfa82f8a3b3302$var$literals
    };
    const KEYWORD_MODES = [
        DOT_KEYWORD,
        KEYWORD_GUARD,
        KEYWORD
    ];
    // https://github.com/apple/swift/tree/main/stdlib/public/core
    const BUILT_IN_GUARD = {
        // Consume .built_in to prevent highlighting properties and methods.
        match: $2dbfa82f8a3b3302$var$concat(/\./, $2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$builtIns)),
        relevance: 0
    };
    const BUILT_IN = {
        className: "built_in",
        match: $2dbfa82f8a3b3302$var$concat(/\b/, $2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$builtIns), /(?=\()/)
    };
    const BUILT_INS = [
        BUILT_IN_GUARD,
        BUILT_IN
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID418
    const OPERATOR_GUARD = {
        // Prevent -> from being highlighting as an operator.
        match: /->/,
        relevance: 0
    };
    const OPERATOR = {
        className: "operator",
        relevance: 0,
        variants: [
            {
                match: $2dbfa82f8a3b3302$var$operator
            },
            {
                // dot-operator: only operators that start with a dot are allowed to use dots as
                // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
                // characters that may also include dots.
                match: `\\.(\\.|${$2dbfa82f8a3b3302$var$operatorCharacter})+`
            }
        ]
    };
    const OPERATORS = [
        OPERATOR_GUARD,
        OPERATOR
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_numeric-literal
    // TODO: Update for leading `-` after lookbehind is supported everywhere
    const decimalDigits = "([0-9]_*)+";
    const hexDigits = "([0-9a-fA-F]_*)+";
    const NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            // decimal floating-point-literal (subsumes decimal-literal)
            {
                match: `\\b(${decimalDigits})(\\.(${decimalDigits}))?` + `([eE][+-]?(${decimalDigits}))?\\b`
            },
            // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
            {
                match: `\\b0x(${hexDigits})(\\.(${hexDigits}))?` + `([pP][+-]?(${decimalDigits}))?\\b`
            },
            // octal-literal
            {
                match: /\b0o([0-7]_*)+\b/
            },
            // binary-literal
            {
                match: /\b0b([01]_*)+\b/
            }
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#grammar_string-literal
    const ESCAPED_CHARACTER = (rawDelimiter = "")=>({
            className: "subst",
            variants: [
                {
                    match: $2dbfa82f8a3b3302$var$concat(/\\/, rawDelimiter, /[0\\tnr"']/)
                },
                {
                    match: $2dbfa82f8a3b3302$var$concat(/\\/, rawDelimiter, /u\{[0-9a-fA-F]{1,8}\}/)
                }
            ]
        });
    const ESCAPED_NEWLINE = (rawDelimiter = "")=>({
            className: "subst",
            match: $2dbfa82f8a3b3302$var$concat(/\\/, rawDelimiter, /[\t ]*(?:[\r\n]|\r\n)/)
        });
    const INTERPOLATION = (rawDelimiter = "")=>({
            className: "subst",
            label: "interpol",
            begin: $2dbfa82f8a3b3302$var$concat(/\\/, rawDelimiter, /\(/),
            end: /\)/
        });
    const MULTILINE_STRING = (rawDelimiter = "")=>({
            begin: $2dbfa82f8a3b3302$var$concat(rawDelimiter, /"""/),
            end: $2dbfa82f8a3b3302$var$concat(/"""/, rawDelimiter),
            contains: [
                ESCAPED_CHARACTER(rawDelimiter),
                ESCAPED_NEWLINE(rawDelimiter),
                INTERPOLATION(rawDelimiter)
            ]
        });
    const SINGLE_LINE_STRING = (rawDelimiter = "")=>({
            begin: $2dbfa82f8a3b3302$var$concat(rawDelimiter, /"/),
            end: $2dbfa82f8a3b3302$var$concat(/"/, rawDelimiter),
            contains: [
                ESCAPED_CHARACTER(rawDelimiter),
                INTERPOLATION(rawDelimiter)
            ]
        });
    const STRING = {
        className: "string",
        variants: [
            MULTILINE_STRING(),
            MULTILINE_STRING("#"),
            MULTILINE_STRING("##"),
            MULTILINE_STRING("###"),
            SINGLE_LINE_STRING(),
            SINGLE_LINE_STRING("#"),
            SINGLE_LINE_STRING("##"),
            SINGLE_LINE_STRING("###")
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/LexicalStructure.html#ID412
    const QUOTED_IDENTIFIER = {
        match: $2dbfa82f8a3b3302$var$concat(/`/, $2dbfa82f8a3b3302$var$identifier, /`/)
    };
    const IMPLICIT_PARAMETER = {
        className: "variable",
        match: /\$\d+/
    };
    const PROPERTY_WRAPPER_PROJECTION = {
        className: "variable",
        match: `\\$${$2dbfa82f8a3b3302$var$identifierCharacter}+`
    };
    const IDENTIFIERS = [
        QUOTED_IDENTIFIER,
        IMPLICIT_PARAMETER,
        PROPERTY_WRAPPER_PROJECTION
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/Attributes.html
    const AVAILABLE_ATTRIBUTE = {
        match: /(@|#)available/,
        className: "keyword",
        starts: {
            contains: [
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: $2dbfa82f8a3b3302$var$availabilityKeywords,
                    contains: [
                        ...OPERATORS,
                        NUMBER,
                        STRING
                    ]
                }
            ]
        }
    };
    const KEYWORD_ATTRIBUTE = {
        className: "keyword",
        match: $2dbfa82f8a3b3302$var$concat(/@/, $2dbfa82f8a3b3302$var$either(...$2dbfa82f8a3b3302$var$keywordAttributes))
    };
    const USER_DEFINED_ATTRIBUTE = {
        className: "meta",
        match: $2dbfa82f8a3b3302$var$concat(/@/, $2dbfa82f8a3b3302$var$identifier)
    };
    const ATTRIBUTES = [
        AVAILABLE_ATTRIBUTE,
        KEYWORD_ATTRIBUTE,
        USER_DEFINED_ATTRIBUTE
    ];
    // https://docs.swift.org/swift-book/ReferenceManual/Types.html
    const TYPE = {
        match: $2dbfa82f8a3b3302$var$lookahead(/\b[A-Z]/),
        relevance: 0,
        contains: [
            {
                className: "type",
                match: $2dbfa82f8a3b3302$var$concat(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, $2dbfa82f8a3b3302$var$identifierCharacter, "+")
            },
            {
                className: "type",
                match: $2dbfa82f8a3b3302$var$typeIdentifier,
                relevance: 0
            },
            {
                match: /[?!]+/,
                relevance: 0
            },
            {
                match: /\.\.\./,
                relevance: 0
            },
            {
                match: $2dbfa82f8a3b3302$var$concat(/\s+&\s+/, $2dbfa82f8a3b3302$var$lookahead($2dbfa82f8a3b3302$var$typeIdentifier)),
                relevance: 0
            }
        ]
    };
    const GENERIC_ARGUMENTS = {
        begin: /</,
        end: />/,
        keywords: KEYWORDS,
        contains: [
            ...COMMENTS,
            ...KEYWORD_MODES,
            ...ATTRIBUTES,
            OPERATOR_GUARD,
            TYPE
        ]
    };
    TYPE.contains.push(GENERIC_ARGUMENTS);
    // https://docs.swift.org/swift-book/ReferenceManual/Expressions.html#ID552
    // Prevents element names from being highlighted as keywords.
    const TUPLE_ELEMENT_NAME = {
        match: $2dbfa82f8a3b3302$var$concat($2dbfa82f8a3b3302$var$identifier, /\s*:/),
        keywords: "_|0",
        relevance: 0
    };
    // Matches tuples as well as the parameter list of a function type.
    const TUPLE = {
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        keywords: KEYWORDS,
        contains: [
            "self",
            TUPLE_ELEMENT_NAME,
            ...COMMENTS,
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS,
            ...ATTRIBUTES,
            TYPE
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID362
    // Matches both the keyword func and the function title.
    // Grouping these lets us differentiate between the operator function <
    // and the start of the generic parameter clause (also <).
    const FUNC_PLUS_TITLE = {
        beginKeywords: "func",
        contains: [
            {
                className: "title",
                match: $2dbfa82f8a3b3302$var$either(QUOTED_IDENTIFIER.match, $2dbfa82f8a3b3302$var$identifier, $2dbfa82f8a3b3302$var$operator),
                // Required to make sure the opening < of the generic parameter clause
                // isn't parsed as a second title.
                endsParent: true,
                relevance: 0
            },
            WHITESPACE
        ]
    };
    const GENERIC_PARAMETERS = {
        begin: /</,
        end: />/,
        contains: [
            ...COMMENTS,
            TYPE
        ]
    };
    const FUNCTION_PARAMETER_NAME = {
        begin: $2dbfa82f8a3b3302$var$either($2dbfa82f8a3b3302$var$lookahead($2dbfa82f8a3b3302$var$concat($2dbfa82f8a3b3302$var$identifier, /\s*:/)), $2dbfa82f8a3b3302$var$lookahead($2dbfa82f8a3b3302$var$concat($2dbfa82f8a3b3302$var$identifier, /\s+/, $2dbfa82f8a3b3302$var$identifier, /\s*:/))),
        end: /:/,
        relevance: 0,
        contains: [
            {
                className: "keyword",
                match: /\b_\b/
            },
            {
                className: "params",
                match: $2dbfa82f8a3b3302$var$identifier
            }
        ]
    };
    const FUNCTION_PARAMETERS = {
        begin: /\(/,
        end: /\)/,
        keywords: KEYWORDS,
        contains: [
            FUNCTION_PARAMETER_NAME,
            ...COMMENTS,
            ...KEYWORD_MODES,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...ATTRIBUTES,
            TYPE,
            TUPLE
        ],
        endsParent: true,
        illegal: /["']/
    };
    const FUNCTION = {
        className: "function",
        match: $2dbfa82f8a3b3302$var$lookahead(/\bfunc\b/),
        contains: [
            FUNC_PLUS_TITLE,
            GENERIC_PARAMETERS,
            FUNCTION_PARAMETERS,
            WHITESPACE
        ],
        illegal: [
            /\[/,
            /%/
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID375
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID379
    const INIT_SUBSCRIPT = {
        className: "function",
        match: /\b(subscript|init[?!]?)\s*(?=[<(])/,
        keywords: {
            keyword: "subscript init init? init!",
            $pattern: /\w+[?!]?/
        },
        contains: [
            GENERIC_PARAMETERS,
            FUNCTION_PARAMETERS,
            WHITESPACE
        ],
        illegal: /\[|%/
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID380
    const OPERATOR_DECLARATION = {
        beginKeywords: "operator",
        end: hljs.MATCH_NOTHING_RE,
        contains: [
            {
                className: "title",
                match: $2dbfa82f8a3b3302$var$operator,
                endsParent: true,
                relevance: 0
            }
        ]
    };
    // https://docs.swift.org/swift-book/ReferenceManual/Declarations.html#ID550
    const PRECEDENCEGROUP = {
        beginKeywords: "precedencegroup",
        end: hljs.MATCH_NOTHING_RE,
        contains: [
            {
                className: "title",
                match: $2dbfa82f8a3b3302$var$typeIdentifier,
                relevance: 0
            },
            {
                begin: /{/,
                end: /}/,
                relevance: 0,
                endsParent: true,
                keywords: [
                    ...$2dbfa82f8a3b3302$var$precedencegroupKeywords,
                    ...$2dbfa82f8a3b3302$var$literals
                ],
                contains: [
                    TYPE
                ]
            }
        ]
    };
    // Add supported submodes to string interpolation.
    for (const variant of STRING.variants){
        const interpolation = variant.contains.find((mode)=>mode.label === "interpol");
        // TODO: Interpolation can contain any expression, so there's room for improvement here.
        interpolation.keywords = KEYWORDS;
        const submodes = [
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS
        ];
        interpolation.contains = [
            ...submodes,
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self",
                    ...submodes
                ]
            }
        ];
    }
    return {
        name: "Swift",
        keywords: KEYWORDS,
        contains: [
            ...COMMENTS,
            FUNCTION,
            INIT_SUBSCRIPT,
            {
                className: "class",
                beginKeywords: "struct protocol class extension enum",
                end: "\\{",
                excludeEnd: true,
                keywords: KEYWORDS,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
                    }),
                    ...KEYWORD_MODES
                ]
            },
            OPERATOR_DECLARATION,
            PRECEDENCEGROUP,
            {
                beginKeywords: "import",
                end: /$/,
                contains: [
                    ...COMMENTS
                ],
                relevance: 0
            },
            ...KEYWORD_MODES,
            ...BUILT_INS,
            ...OPERATORS,
            NUMBER,
            STRING,
            ...IDENTIFIERS,
            ...ATTRIBUTES,
            TYPE,
            TUPLE
        ]
    };
}
module.exports = $2dbfa82f8a3b3302$var$swift;

});

parcelRegister("95S8w", function(module, exports) {
/*
Language: Tagger Script
Author: Philipp Wolfer <ph.wolfer@gmail.com>
Description: Syntax Highlighting for the Tagger Script as used by MusicBrainz Picard.
Website: https://picard.musicbrainz.org
 */ function $69ee930e8c1631fb$var$taggerscript(hljs) {
    const COMMENT = {
        className: "comment",
        begin: /\$noop\(/,
        end: /\)/,
        contains: [
            {
                begin: /\(/,
                end: /\)/,
                contains: [
                    "self",
                    {
                        begin: /\\./
                    }
                ]
            }
        ],
        relevance: 10
    };
    const FUNCTION = {
        className: "keyword",
        begin: /\$(?!noop)[a-zA-Z][_a-zA-Z0-9]*/,
        end: /\(/,
        excludeEnd: true
    };
    const VARIABLE = {
        className: "variable",
        begin: /%[_a-zA-Z0-9:]*/,
        end: "%"
    };
    const ESCAPE_SEQUENCE = {
        className: "symbol",
        begin: /\\./
    };
    return {
        name: "Tagger Script",
        contains: [
            COMMENT,
            FUNCTION,
            VARIABLE,
            ESCAPE_SEQUENCE
        ]
    };
}
module.exports = $69ee930e8c1631fb$var$taggerscript;

});

parcelRegister("9Q3uF", function(module, exports) {
/*
Language: YAML
Description: Yet Another Markdown Language
Author: Stefan Wienert <stwienert@gmail.com>
Contributors: Carl Baxter <carl@cbax.tech>
Requires: ruby.js
Website: https://yaml.org
Category: common, config
*/ function $729bae247f5477e5$var$yaml(hljs) {
    var LITERALS = "true false yes no null";
    // YAML spec allows non-reserved URI characters in tags.
    var URI_CHARACTERS = "[\\w#;/?:@&=+$,.~*'()[\\]]+";
    // Define keys as starting with a word character
    // ...containing word chars, spaces, colons, forward-slashes, hyphens and periods
    // ...and ending with a colon followed immediately by a space, tab or newline.
    // The YAML spec allows for much more than this, but this covers most use-cases.
    var KEY = {
        className: "attr",
        variants: [
            {
                begin: "\\w[\\w :\\/.-]*:(?=[ 	]|$)"
            },
            {
                begin: '"\\w[\\w :\\/.-]*":(?=[ 	]|$)'
            },
            {
                begin: "'\\w[\\w :\\/.-]*':(?=[ 	]|$)"
            } // single quoted keys
        ]
    };
    var TEMPLATE_VARIABLES = {
        className: "template-variable",
        variants: [
            {
                begin: /\{\{/,
                end: /\}\}/
            },
            {
                begin: /%\{/,
                end: /\}/
            } // Ruby i18n
        ]
    };
    var STRING = {
        className: "string",
        relevance: 0,
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /\S+/
            }
        ],
        contains: [
            hljs.BACKSLASH_ESCAPE,
            TEMPLATE_VARIABLES
        ]
    };
    // Strings inside of value containers (objects) can't contain braces,
    // brackets, or commas
    var CONTAINER_STRING = hljs.inherit(STRING, {
        variants: [
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /[^\s,{}[\]]+/
            }
        ]
    });
    var DATE_RE = "[0-9]{4}(-[0-9][0-9]){0,2}";
    var TIME_RE = "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?";
    var FRACTION_RE = "(\\.[0-9]*)?";
    var ZONE_RE = "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?";
    var TIMESTAMP = {
        className: "number",
        begin: "\\b" + DATE_RE + TIME_RE + FRACTION_RE + ZONE_RE + "\\b"
    };
    var VALUE_CONTAINER = {
        end: ",",
        endsWithParent: true,
        excludeEnd: true,
        keywords: LITERALS,
        relevance: 0
    };
    var OBJECT = {
        begin: /\{/,
        end: /\}/,
        contains: [
            VALUE_CONTAINER
        ],
        illegal: "\\n",
        relevance: 0
    };
    var ARRAY = {
        begin: "\\[",
        end: "\\]",
        contains: [
            VALUE_CONTAINER
        ],
        illegal: "\\n",
        relevance: 0
    };
    var MODES = [
        KEY,
        {
            className: "meta",
            begin: "^---\\s*$",
            relevance: 10
        },
        {
            // Blocks start with a | or > followed by a newline
            //
            // Indentation of subsequent lines must be the same to
            // be considered part of the block
            className: "string",
            begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
        },
        {
            begin: "<%[%=-]?",
            end: "[%-]?%>",
            subLanguage: "ruby",
            excludeBegin: true,
            excludeEnd: true,
            relevance: 0
        },
        {
            className: "type",
            begin: "!\\w+!" + URI_CHARACTERS
        },
        // https://yaml.org/spec/1.2/spec.html#id2784064
        {
            className: "type",
            begin: "!<" + URI_CHARACTERS + ">"
        },
        {
            className: "type",
            begin: "!" + URI_CHARACTERS
        },
        {
            className: "type",
            begin: "!!" + URI_CHARACTERS
        },
        {
            className: "meta",
            begin: "&" + hljs.UNDERSCORE_IDENT_RE + "$"
        },
        {
            className: "meta",
            begin: "\\*" + hljs.UNDERSCORE_IDENT_RE + "$"
        },
        {
            className: "bullet",
            // TODO: remove |$ hack when we have proper look-ahead support
            begin: "-(?=[ ]|$)",
            relevance: 0
        },
        hljs.HASH_COMMENT_MODE,
        {
            beginKeywords: LITERALS,
            keywords: {
                literal: LITERALS
            }
        },
        TIMESTAMP,
        // numbers are any valid C-style number that
        // sit isolated from other words
        {
            className: "number",
            begin: hljs.C_NUMBER_RE + "\\b",
            relevance: 0
        },
        OBJECT,
        ARRAY,
        STRING
    ];
    var VALUE_MODES = [
        ...MODES
    ];
    VALUE_MODES.pop();
    VALUE_MODES.push(CONTAINER_STRING);
    VALUE_CONTAINER.contains = VALUE_MODES;
    return {
        name: "YAML",
        case_insensitive: true,
        aliases: [
            "yml"
        ],
        contains: MODES
    };
}
module.exports = $729bae247f5477e5$var$yaml;

});

parcelRegister("e9h52", function(module, exports) {
/*
Language: Test Anything Protocol
Description: TAP, the Test Anything Protocol, is a simple text-based interface between testing modules in a test harness.
Requires: yaml.js
Author: Sergey Bronnikov <sergeyb@bronevichok.ru>
Website: https://testanything.org
*/ function $a4cf27bfac535b1c$var$tap(hljs) {
    return {
        name: "Test Anything Protocol",
        case_insensitive: true,
        contains: [
            hljs.HASH_COMMENT_MODE,
            // version of format and total amount of testcases
            {
                className: "meta",
                variants: [
                    {
                        begin: "^TAP version (\\d+)$"
                    },
                    {
                        begin: "^1\\.\\.(\\d+)$"
                    }
                ]
            },
            // YAML block
            {
                begin: /---$/,
                end: "\\.\\.\\.$",
                subLanguage: "yaml",
                relevance: 0
            },
            // testcase number
            {
                className: "number",
                begin: " (\\d+) "
            },
            // testcase status and description
            {
                className: "symbol",
                variants: [
                    {
                        begin: "^ok"
                    },
                    {
                        begin: "^not ok"
                    }
                ]
            }
        ]
    };
}
module.exports = $a4cf27bfac535b1c$var$tap;

});

parcelRegister("5a08n", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $3c1dfd8c98929e7c$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $3c1dfd8c98929e7c$var$optional(re) {
    return $3c1dfd8c98929e7c$var$concat("(", re, ")?");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $3c1dfd8c98929e7c$var$concat(...args) {
    const joined = args.map((x)=>$3c1dfd8c98929e7c$var$source(x)).join("");
    return joined;
}
/*
Language: Tcl
Description: Tcl is a very simple programming language.
Author: Radek Liska <radekliska@gmail.com>
Website: https://www.tcl.tk/about/language.html
*/ function $3c1dfd8c98929e7c$var$tcl(hljs) {
    const TCL_IDENT = /[a-zA-Z_][a-zA-Z0-9_]*/;
    const NUMBER = {
        className: "number",
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    return {
        name: "Tcl",
        aliases: [
            "tk"
        ],
        keywords: "after append apply array auto_execok auto_import auto_load auto_mkindex auto_mkindex_old auto_qualify auto_reset bgerror binary break catch cd chan clock close concat continue dde dict encoding eof error eval exec exit expr fblocked fconfigure fcopy file fileevent filename flush for foreach format gets glob global history http if incr info interp join lappend|10 lassign|10 lindex|10 linsert|10 list llength|10 load lrange|10 lrepeat|10 lreplace|10 lreverse|10 lsearch|10 lset|10 lsort|10 mathfunc mathop memory msgcat namespace open package parray pid pkg::create pkg_mkIndex platform platform::shell proc puts pwd read refchan regexp registry regsub|10 rename return safe scan seek set socket source split string subst switch tcl_endOfWord tcl_findLibrary tcl_startOfNextWord tcl_startOfPreviousWord tcl_wordBreakAfter tcl_wordBreakBefore tcltest tclvars tell time tm trace unknown unload unset update uplevel upvar variable vwait while",
        contains: [
            hljs.COMMENT(";[ \\t]*#", "$"),
            hljs.COMMENT("^[ \\t]*#", "$"),
            {
                beginKeywords: "proc",
                end: "[\\{]",
                excludeEnd: true,
                contains: [
                    {
                        className: "title",
                        begin: "[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                        end: "[ \\t\\n\\r]",
                        endsWithParent: true,
                        excludeEnd: true
                    }
                ]
            },
            {
                className: "variable",
                variants: [
                    {
                        begin: $3c1dfd8c98929e7c$var$concat(/\$/, $3c1dfd8c98929e7c$var$optional(/::/), TCL_IDENT, "(::", TCL_IDENT, ")*")
                    },
                    {
                        begin: "\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                        end: "\\}",
                        contains: [
                            NUMBER
                        ]
                    }
                ]
            },
            {
                className: "string",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    hljs.inherit(hljs.QUOTE_STRING_MODE, {
                        illegal: null
                    })
                ]
            },
            NUMBER
        ]
    };
}
module.exports = $3c1dfd8c98929e7c$var$tcl;

});

parcelRegister("7FuCM", function(module, exports) {
/*
Language: Thrift
Author: Oleg Efimov <efimovov@gmail.com>
Description: Thrift message definition format
Website: https://thrift.apache.org
Category: protocols
*/ function $59541e1f4895a4ef$var$thrift(hljs) {
    const BUILT_IN_TYPES = "bool byte i16 i32 i64 double string binary";
    return {
        name: "Thrift",
        keywords: {
            keyword: "namespace const typedef struct enum service exception void oneway set list map required optional",
            built_in: BUILT_IN_TYPES,
            literal: "true false"
        },
        contains: [
            hljs.QUOTE_STRING_MODE,
            hljs.NUMBER_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "struct enum service exception",
                end: /\{/,
                illegal: /\n/,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        // hack: eating everything after the first title
                        starts: {
                            endsWithParent: true,
                            excludeEnd: true
                        }
                    })
                ]
            },
            {
                begin: "\\b(set|list|map)\\s*<",
                end: ">",
                keywords: BUILT_IN_TYPES,
                contains: [
                    "self"
                ]
            }
        ]
    };
}
module.exports = $59541e1f4895a4ef$var$thrift;

});

parcelRegister("fZGmp", function(module, exports) {
/*
Language: TP
Author: Jay Strybis <jay.strybis@gmail.com>
Description: FANUC TP programming language (TPP).
*/ function $ba4d6971dc5eb98a$var$tp(hljs) {
    const TPID = {
        className: "number",
        begin: "[1-9][0-9]*",
        /* no leading zeros */ relevance: 0
    };
    const TPLABEL = {
        className: "symbol",
        begin: ":[^\\]]+"
    };
    const TPDATA = {
        className: "built_in",
        begin: "(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[",
        end: "\\]",
        contains: [
            "self",
            TPID,
            TPLABEL
        ]
    };
    const TPIO = {
        className: "built_in",
        begin: "(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[",
        end: "\\]",
        contains: [
            "self",
            TPID,
            hljs.QUOTE_STRING_MODE,
            /* for pos section at bottom */ TPLABEL
        ]
    };
    return {
        name: "TP",
        keywords: {
            keyword: "ABORT ACC ADJUST AND AP_LD BREAK CALL CNT COL CONDITION CONFIG DA DB DIV DETECT ELSE END ENDFOR ERR_NUM ERROR_PROG FINE FOR GP GUARD INC IF JMP LINEAR_MAX_SPEED LOCK MOD MONITOR OFFSET Offset OR OVERRIDE PAUSE PREG PTH RT_LD RUN SELECT SKIP Skip TA TB TO TOOL_OFFSET Tool_Offset UF UT UFRAME_NUM UTOOL_NUM UNLOCK WAIT X Y Z W P R STRLEN SUBSTR FINDSTR VOFFSET PROG ATTR MN POS",
            literal: "ON OFF max_speed LPOS JPOS ENABLE DISABLE START STOP RESET"
        },
        contains: [
            TPDATA,
            TPIO,
            {
                className: "keyword",
                begin: "/(PROG|ATTR|MN|POS|END)\\b"
            },
            {
                /* this is for cases like ,CALL */ className: "keyword",
                begin: "(CALL|RUN|POINT_LOGIC|LBL)\\b"
            },
            {
                /* this is for cases like CNT100 where the default lexemes do not
         * separate the keyword and the number */ className: "keyword",
                begin: "\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"
            },
            {
                /* to catch numbers that do not have a word boundary on the left */ className: "number",
                begin: "\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b",
                relevance: 0
            },
            hljs.COMMENT("//", "[;$]"),
            hljs.COMMENT("!", "[;$]"),
            hljs.COMMENT("--eg:", "$"),
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            hljs.C_NUMBER_MODE,
            {
                className: "variable",
                begin: "\\$[A-Za-z0-9_]+"
            }
        ]
    };
}
module.exports = $ba4d6971dc5eb98a$var$tp;

});

parcelRegister("2NhyA", function(module, exports) {
/*
Language: Twig
Requires: xml.js
Author: Luke Holder <lukemh@gmail.com>
Description: Twig is a templating language for PHP
Website: https://twig.symfony.com
Category: template
*/ function $208dc6d1a876726b$var$twig(hljs) {
    var PARAMS = {
        className: "params",
        begin: "\\(",
        end: "\\)"
    };
    var FUNCTION_NAMES = "attribute block constant cycle date dump include max min parent random range source template_from_string";
    var FUNCTIONS = {
        beginKeywords: FUNCTION_NAMES,
        keywords: {
            name: FUNCTION_NAMES
        },
        relevance: 0,
        contains: [
            PARAMS
        ]
    };
    var FILTER = {
        begin: /\|[A-Za-z_]+:?/,
        keywords: "abs batch capitalize column convert_encoding date date_modify default escape filter first format inky_to_html inline_css join json_encode keys last length lower map markdown merge nl2br number_format raw reduce replace reverse round slice sort spaceless split striptags title trim upper url_encode",
        contains: [
            FUNCTIONS
        ]
    };
    var TAGS = "apply autoescape block deprecated do embed extends filter flush for from if import include macro sandbox set use verbatim with";
    TAGS = TAGS + " " + TAGS.split(" ").map(function(t) {
        return "end" + t;
    }).join(" ");
    return {
        name: "Twig",
        aliases: [
            "craftcms"
        ],
        case_insensitive: true,
        subLanguage: "xml",
        contains: [
            hljs.COMMENT(/\{#/, /#\}/),
            {
                className: "template-tag",
                begin: /\{%/,
                end: /%\}/,
                contains: [
                    {
                        className: "name",
                        begin: /\w+/,
                        keywords: TAGS,
                        starts: {
                            endsWithParent: true,
                            contains: [
                                FILTER,
                                FUNCTIONS
                            ],
                            relevance: 0
                        }
                    }
                ]
            },
            {
                className: "template-variable",
                begin: /\{\{/,
                end: /\}\}/,
                contains: [
                    "self",
                    FILTER,
                    FUNCTIONS
                ]
            }
        ]
    };
}
module.exports = $208dc6d1a876726b$var$twig;

});

parcelRegister("1loeR", function(module, exports) {
const $0faa8de2a2a77fe4$var$IDENT_RE = "[A-Za-z$_][0-9A-Za-z$_]*";
const $0faa8de2a2a77fe4$var$KEYWORDS = [
    "as",
    "in",
    "of",
    "if",
    "for",
    "while",
    "finally",
    "var",
    "new",
    "function",
    "do",
    "return",
    "void",
    "else",
    "break",
    "catch",
    "instanceof",
    "with",
    "throw",
    "case",
    "default",
    "try",
    "switch",
    "continue",
    "typeof",
    "delete",
    "let",
    "yield",
    "const",
    "class",
    // JS handles these with a special rule
    // "get",
    // "set",
    "debugger",
    "async",
    "await",
    "static",
    "import",
    "from",
    "export",
    "extends"
];
const $0faa8de2a2a77fe4$var$LITERALS = [
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity"
];
const $0faa8de2a2a77fe4$var$TYPES = [
    "Intl",
    "DataView",
    "Number",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Object",
    "Function",
    "Boolean",
    "Error",
    "Symbol",
    "Set",
    "Map",
    "WeakSet",
    "WeakMap",
    "Proxy",
    "Reflect",
    "JSON",
    "Promise",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Float32Array",
    "Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "ArrayBuffer",
    "BigInt64Array",
    "BigUint64Array",
    "BigInt"
];
const $0faa8de2a2a77fe4$var$ERROR_TYPES = [
    "EvalError",
    "InternalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
const $0faa8de2a2a77fe4$var$BUILT_IN_GLOBALS = [
    "setInterval",
    "setTimeout",
    "clearInterval",
    "clearTimeout",
    "require",
    "exports",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "unescape"
];
const $0faa8de2a2a77fe4$var$BUILT_IN_VARIABLES = [
    "arguments",
    "this",
    "super",
    "console",
    "window",
    "document",
    "localStorage",
    "module",
    "global" // Node.js
];
const $0faa8de2a2a77fe4$var$BUILT_INS = [].concat($0faa8de2a2a77fe4$var$BUILT_IN_GLOBALS, $0faa8de2a2a77fe4$var$BUILT_IN_VARIABLES, $0faa8de2a2a77fe4$var$TYPES, $0faa8de2a2a77fe4$var$ERROR_TYPES);
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $0faa8de2a2a77fe4$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $0faa8de2a2a77fe4$var$lookahead(re) {
    return $0faa8de2a2a77fe4$var$concat("(?=", re, ")");
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $0faa8de2a2a77fe4$var$concat(...args) {
    const joined = args.map((x)=>$0faa8de2a2a77fe4$var$source(x)).join("");
    return joined;
}
/*
Language: JavaScript
Description: JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language with first-class functions.
Category: common, scripting
Website: https://developer.mozilla.org/en-US/docs/Web/JavaScript
*/ /** @type LanguageFn */ function $0faa8de2a2a77fe4$var$javascript(hljs) {
    /**
   * Takes a string like "<Booger" and checks to see
   * if we can find a matching "</Booger" later in the
   * content.
   * @param {RegExpMatchArray} match
   * @param {{after:number}} param1
   */ const hasClosingTag = (match, { after: after })=>{
        const tag = "</" + match[0].slice(1);
        const pos = match.input.indexOf(tag, after);
        return pos !== -1;
    };
    const IDENT_RE$1 = $0faa8de2a2a77fe4$var$IDENT_RE;
    const FRAGMENT = {
        begin: "<>",
        end: "</>"
    };
    const XML_TAG = {
        begin: /<[A-Za-z0-9\\._:-]+/,
        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
        /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */ isTrulyOpeningTag: (match, response)=>{
            const afterMatchIndex = match[0].length + match.index;
            const nextChar = match.input[afterMatchIndex];
            // nested type?
            // HTML should not include another raw `<` inside a tag
            // But a type might: `<Array<Array<number>>`, etc.
            if (nextChar === "<") {
                response.ignoreMatch();
                return;
            }
            // <something>
            // This is now either a tag or a type.
            if (nextChar === ">") // if we cannot find a matching closing tag, then we
            // will ignore it
            {
                if (!hasClosingTag(match, {
                    after: afterMatchIndex
                })) response.ignoreMatch();
            }
        }
    };
    const KEYWORDS$1 = {
        $pattern: $0faa8de2a2a77fe4$var$IDENT_RE,
        keyword: $0faa8de2a2a77fe4$var$KEYWORDS,
        literal: $0faa8de2a2a77fe4$var$LITERALS,
        built_in: $0faa8de2a2a77fe4$var$BUILT_INS
    };
    // https://tc39.es/ecma262/#sec-literals-numeric-literals
    const decimalDigits = "[0-9](_?[0-9])*";
    const frac = `\\.(${decimalDigits})`;
    // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
    // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
    const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
    const NUMBER = {
        className: "number",
        variants: [
            // DecimalLiteral
            {
                begin: `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` + `[eE][+-]?(${decimalDigits})\\b`
            },
            {
                begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b`
            },
            // DecimalBigIntegerLiteral
            {
                begin: `\\b(0|[1-9](_?[0-9])*)n\\b`
            },
            // NonDecimalIntegerLiteral
            {
                begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
            },
            {
                begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
            },
            {
                begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
            },
            // LegacyOctalIntegerLiteral (does not include underscore separators)
            // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
            {
                begin: "\\b0[0-7]+n?\\b"
            }
        ],
        relevance: 0
    };
    const SUBST = {
        className: "subst",
        begin: "\\$\\{",
        end: "\\}",
        keywords: KEYWORDS$1,
        contains: [] // defined later
    };
    const HTML_TEMPLATE = {
        begin: "html`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "xml"
        }
    };
    const CSS_TEMPLATE = {
        begin: "css`",
        end: "",
        starts: {
            end: "`",
            returnEnd: false,
            contains: [
                hljs.BACKSLASH_ESCAPE,
                SUBST
            ],
            subLanguage: "css"
        }
    };
    const TEMPLATE_STRING = {
        className: "string",
        begin: "`",
        end: "`",
        contains: [
            hljs.BACKSLASH_ESCAPE,
            SUBST
        ]
    };
    const JSDOC_COMMENT = hljs.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
        relevance: 0,
        contains: [
            {
                className: "doctag",
                begin: "@[A-Za-z]+",
                contains: [
                    {
                        className: "type",
                        begin: "\\{",
                        end: "\\}",
                        relevance: 0
                    },
                    {
                        className: "variable",
                        begin: IDENT_RE$1 + "(?=\\s*(-)|$)",
                        endsParent: true,
                        relevance: 0
                    },
                    // eat spaces (not newlines) so we can find
                    // types or variables
                    {
                        begin: /(?=[^\n])\s/,
                        relevance: 0
                    }
                ]
            }
        ]
    });
    const COMMENT = {
        className: "comment",
        variants: [
            JSDOC_COMMENT,
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE
        ]
    };
    const SUBST_INTERNALS = [
        hljs.APOS_STRING_MODE,
        hljs.QUOTE_STRING_MODE,
        HTML_TEMPLATE,
        CSS_TEMPLATE,
        TEMPLATE_STRING,
        NUMBER,
        hljs.REGEXP_MODE
    ];
    SUBST.contains = SUBST_INTERNALS.concat({
        // we need to pair up {} inside our subst to prevent
        // it from ending too early by matching another }
        begin: /\{/,
        end: /\}/,
        keywords: KEYWORDS$1,
        contains: [
            "self"
        ].concat(SUBST_INTERNALS)
    });
    const SUBST_AND_COMMENTS = [].concat(COMMENT, SUBST.contains);
    const PARAMS_CONTAINS = SUBST_AND_COMMENTS.concat([
        // eat recursive parens in sub expressions
        {
            begin: /\(/,
            end: /\)/,
            keywords: KEYWORDS$1,
            contains: [
                "self"
            ].concat(SUBST_AND_COMMENTS)
        }
    ]);
    const PARAMS = {
        className: "params",
        begin: /\(/,
        end: /\)/,
        excludeBegin: true,
        excludeEnd: true,
        keywords: KEYWORDS$1,
        contains: PARAMS_CONTAINS
    };
    return {
        name: "Javascript",
        aliases: [
            "js",
            "jsx",
            "mjs",
            "cjs"
        ],
        keywords: KEYWORDS$1,
        // this will be extended by TypeScript
        exports: {
            PARAMS_CONTAINS: PARAMS_CONTAINS
        },
        illegal: /#(?![$_A-z])/,
        contains: [
            hljs.SHEBANG({
                label: "shebang",
                binary: "node",
                relevance: 5
            }),
            {
                label: "use_strict",
                className: "meta",
                relevance: 10,
                begin: /^\s*['"]use (strict|asm)['"]/
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            HTML_TEMPLATE,
            CSS_TEMPLATE,
            TEMPLATE_STRING,
            COMMENT,
            NUMBER,
            {
                begin: $0faa8de2a2a77fe4$var$concat(/[{,\n]\s*/, // we need to look ahead to make sure that we actually have an
                // attribute coming up so we don't steal a comma from a potential
                // "value" container
                //
                // NOTE: this might not work how you think.  We don't actually always
                // enter this mode and stay.  Instead it might merely match `,
                // <comments up next>` and then immediately end after the , because it
                // fails to find any actual attrs. But this still does the job because
                // it prevents the value contain rule from grabbing this instead and
                // prevening this rule from firing when we actually DO have keys.
                $0faa8de2a2a77fe4$var$lookahead($0faa8de2a2a77fe4$var$concat(// we also need to allow for multiple possible comments inbetween
                // the first key:value pairing
                /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/, IDENT_RE$1 + "\\s*:"))),
                relevance: 0,
                contains: [
                    {
                        className: "attr",
                        begin: IDENT_RE$1 + $0faa8de2a2a77fe4$var$lookahead("\\s*:"),
                        relevance: 0
                    }
                ]
            },
            {
                begin: "(" + hljs.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                keywords: "return throw case",
                contains: [
                    COMMENT,
                    hljs.REGEXP_MODE,
                    {
                        className: "function",
                        // we have to count the parens to make sure we actually have the
                        // correct bounding ( ) before the =>.  There could be any number of
                        // sub-expressions inside also surrounded by parens.
                        begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + hljs.UNDERSCORE_IDENT_RE + ")\\s*=>",
                        returnBegin: true,
                        end: "\\s*=>",
                        contains: [
                            {
                                className: "params",
                                variants: [
                                    {
                                        begin: hljs.UNDERSCORE_IDENT_RE,
                                        relevance: 0
                                    },
                                    {
                                        className: null,
                                        begin: /\(\s*\)/,
                                        skip: true
                                    },
                                    {
                                        begin: /\(/,
                                        end: /\)/,
                                        excludeBegin: true,
                                        excludeEnd: true,
                                        keywords: KEYWORDS$1,
                                        contains: PARAMS_CONTAINS
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        begin: /,/,
                        relevance: 0
                    },
                    {
                        className: "",
                        begin: /\s/,
                        end: /\s*/,
                        skip: true
                    },
                    {
                        variants: [
                            {
                                begin: FRAGMENT.begin,
                                end: FRAGMENT.end
                            },
                            {
                                begin: XML_TAG.begin,
                                // we carefully check the opening tag to see if it truly
                                // is a tag and not a false positive
                                "on:begin": XML_TAG.isTrulyOpeningTag,
                                end: XML_TAG.end
                            }
                        ],
                        subLanguage: "xml",
                        contains: [
                            {
                                begin: XML_TAG.begin,
                                end: XML_TAG.end,
                                skip: true,
                                contains: [
                                    "self"
                                ]
                            }
                        ]
                    }
                ],
                relevance: 0
            },
            {
                className: "function",
                beginKeywords: "function",
                end: /[{;]/,
                excludeEnd: true,
                keywords: KEYWORDS$1,
                contains: [
                    "self",
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    PARAMS
                ],
                illegal: /%/
            },
            {
                // prevent this from getting swallowed up by function
                // since they appear "function like"
                beginKeywords: "while if switch catch for"
            },
            {
                className: "function",
                // we have to count the parens to make sure we actually have the correct
                // bounding ( ).  There could be any number of sub-expressions inside
                // also surrounded by parens.
                begin: hljs.UNDERSCORE_IDENT_RE + "\\(" + // first parens
                "[^()]*(\\(" + "[^()]*(\\(" + "[^()]*" + "\\)[^()]*)*" + "\\)[^()]*)*" + "\\)\\s*\\{",
                returnBegin: true,
                contains: [
                    PARAMS,
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    })
                ]
            },
            // hack: prevents detection of keywords in some circumstances
            // .keyword()
            // $keyword = x
            {
                variants: [
                    {
                        begin: "\\." + IDENT_RE$1
                    },
                    {
                        begin: "\\$" + IDENT_RE$1
                    }
                ],
                relevance: 0
            },
            {
                className: "class",
                beginKeywords: "class",
                end: /[{;=]/,
                excludeEnd: true,
                illegal: /[:"[\]]/,
                contains: [
                    {
                        beginKeywords: "extends"
                    },
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            {
                begin: /\b(?=constructor)/,
                end: /[{;]/,
                excludeEnd: true,
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    "self",
                    PARAMS
                ]
            },
            {
                begin: "(get|set)\\s+(?=" + IDENT_RE$1 + "\\()",
                end: /\{/,
                keywords: "get set",
                contains: [
                    hljs.inherit(hljs.TITLE_MODE, {
                        begin: IDENT_RE$1
                    }),
                    {
                        begin: /\(\)/
                    },
                    PARAMS
                ]
            },
            {
                begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
            }
        ]
    };
}
/*
Language: TypeScript
Author: Panu Horsmalahti <panu.horsmalahti@iki.fi>
Contributors: Ike Ku <dempfi@yahoo.com>
Description: TypeScript is a strict superset of JavaScript
Website: https://www.typescriptlang.org
Category: common, scripting
*/ /** @type LanguageFn */ function $0faa8de2a2a77fe4$var$typescript(hljs) {
    const IDENT_RE$1 = $0faa8de2a2a77fe4$var$IDENT_RE;
    const NAMESPACE = {
        beginKeywords: "namespace",
        end: /\{/,
        excludeEnd: true
    };
    const INTERFACE = {
        beginKeywords: "interface",
        end: /\{/,
        excludeEnd: true,
        keywords: "interface extends"
    };
    const USE_STRICT = {
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use strict['"]/
    };
    const TYPES = [
        "any",
        "void",
        "number",
        "boolean",
        "string",
        "object",
        "never",
        "enum"
    ];
    const TS_SPECIFIC_KEYWORDS = [
        "type",
        "namespace",
        "typedef",
        "interface",
        "public",
        "private",
        "protected",
        "implements",
        "declare",
        "abstract",
        "readonly"
    ];
    const KEYWORDS$1 = {
        $pattern: $0faa8de2a2a77fe4$var$IDENT_RE,
        keyword: $0faa8de2a2a77fe4$var$KEYWORDS.concat(TS_SPECIFIC_KEYWORDS),
        literal: $0faa8de2a2a77fe4$var$LITERALS,
        built_in: $0faa8de2a2a77fe4$var$BUILT_INS.concat(TYPES)
    };
    const DECORATOR = {
        className: "meta",
        begin: "@" + IDENT_RE$1
    };
    const swapMode = (mode, label, replacement)=>{
        const indx = mode.contains.findIndex((m)=>m.label === label);
        if (indx === -1) throw new Error("can not find mode to replace");
        mode.contains.splice(indx, 1, replacement);
    };
    const tsLanguage = $0faa8de2a2a77fe4$var$javascript(hljs);
    // this should update anywhere keywords is used since
    // it will be the same actual JS object
    Object.assign(tsLanguage.keywords, KEYWORDS$1);
    tsLanguage.exports.PARAMS_CONTAINS.push(DECORATOR);
    tsLanguage.contains = tsLanguage.contains.concat([
        DECORATOR,
        NAMESPACE,
        INTERFACE
    ]);
    // TS gets a simpler shebang rule than JS
    swapMode(tsLanguage, "shebang", hljs.SHEBANG());
    // JS use strict rule purposely excludes `asm` which makes no sense
    swapMode(tsLanguage, "use_strict", USE_STRICT);
    const functionDeclaration = tsLanguage.contains.find((m)=>m.className === "function");
    functionDeclaration.relevance = 0; // () => {} is more typical in TypeScript
    Object.assign(tsLanguage, {
        name: "TypeScript",
        aliases: [
            "ts",
            "tsx"
        ]
    });
    return tsLanguage;
}
module.exports = $0faa8de2a2a77fe4$var$typescript;

});

parcelRegister("c7YeD", function(module, exports) {
/*
Language: Vala
Author: Antono Vasiljev <antono.vasiljev@gmail.com>
Description: Vala is a new programming language that aims to bring modern programming language features to GNOME developers without imposing any additional runtime requirements and without using a different ABI compared to applications and libraries written in C.
Website: https://wiki.gnome.org/Projects/Vala
*/ function $8d44dce2cebc6990$var$vala(hljs) {
    return {
        name: "Vala",
        keywords: {
            keyword: // Value types
            "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var",
            built_in: "DBus GLib CCode Gee Object Gtk Posix",
            literal: "false true null"
        },
        contains: [
            {
                className: "class",
                beginKeywords: "class interface namespace",
                end: /\{/,
                excludeEnd: true,
                illegal: "[^,:\\n\\s\\.]",
                contains: [
                    hljs.UNDERSCORE_TITLE_MODE
                ]
            },
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            {
                className: "string",
                begin: '"""',
                end: '"""',
                relevance: 5
            },
            hljs.APOS_STRING_MODE,
            hljs.QUOTE_STRING_MODE,
            hljs.C_NUMBER_MODE,
            {
                className: "meta",
                begin: "^#",
                end: "$",
                relevance: 2
            }
        ]
    };
}
module.exports = $8d44dce2cebc6990$var$vala;

});

parcelRegister("ctiKc", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $9146bbab032b40fe$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $9146bbab032b40fe$var$concat(...args) {
    const joined = args.map((x)=>$9146bbab032b40fe$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $9146bbab032b40fe$var$either(...args) {
    const joined = "(" + args.map((x)=>$9146bbab032b40fe$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: Visual Basic .NET
Description: Visual Basic .NET (VB.NET) is a multi-paradigm, object-oriented programming language, implemented on the .NET Framework.
Authors: Poren Chiang <ren.chiang@gmail.com>, Jan Pilzer
Website: https://docs.microsoft.com/dotnet/visual-basic/getting-started
Category: common
*/ /** @type LanguageFn */ function $9146bbab032b40fe$var$vbnet(hljs) {
    /**
   * Character Literal
   * Either a single character ("a"C) or an escaped double quote (""""C).
   */ const CHARACTER = {
        className: "string",
        begin: /"(""|[^/n])"C\b/
    };
    const STRING = {
        className: "string",
        begin: /"/,
        end: /"/,
        illegal: /\n/,
        contains: [
            {
                // double quote escape
                begin: /""/
            }
        ]
    };
    /** Date Literals consist of a date, a time, or both separated by whitespace, surrounded by # */ const MM_DD_YYYY = /\d{1,2}\/\d{1,2}\/\d{4}/;
    const YYYY_MM_DD = /\d{4}-\d{1,2}-\d{1,2}/;
    const TIME_12H = /(\d|1[012])(:\d+){0,2} *(AM|PM)/;
    const TIME_24H = /\d{1,2}(:\d{1,2}){1,2}/;
    const DATE = {
        className: "literal",
        variants: [
            {
                // #YYYY-MM-DD# (ISO-Date) or #M/D/YYYY# (US-Date)
                begin: $9146bbab032b40fe$var$concat(/# */, $9146bbab032b40fe$var$either(YYYY_MM_DD, MM_DD_YYYY), / *#/)
            },
            {
                // #H:mm[:ss]# (24h Time)
                begin: $9146bbab032b40fe$var$concat(/# */, TIME_24H, / *#/)
            },
            {
                // #h[:mm[:ss]] A# (12h Time)
                begin: $9146bbab032b40fe$var$concat(/# */, TIME_12H, / *#/)
            },
            {
                // date plus time
                begin: $9146bbab032b40fe$var$concat(/# */, $9146bbab032b40fe$var$either(YYYY_MM_DD, MM_DD_YYYY), / +/, $9146bbab032b40fe$var$either(TIME_12H, TIME_24H), / *#/)
            }
        ]
    };
    const NUMBER = {
        className: "number",
        relevance: 0,
        variants: [
            {
                // Float
                begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
            },
            {
                // Integer (base 10)
                begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
            },
            {
                // Integer (base 16)
                begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
            },
            {
                // Integer (base 8)
                begin: /&O[0-7_]+((U?[SIL])|[%&])?/
            },
            {
                // Integer (base 2)
                begin: /&B[01_]+((U?[SIL])|[%&])?/
            }
        ]
    };
    const LABEL = {
        className: "label",
        begin: /^\w+:/
    };
    const DOC_COMMENT = hljs.COMMENT(/'''/, /$/, {
        contains: [
            {
                className: "doctag",
                begin: /<\/?/,
                end: />/
            }
        ]
    });
    const COMMENT = hljs.COMMENT(null, /$/, {
        variants: [
            {
                begin: /'/
            },
            {
                // TODO: Use `beforeMatch:` for leading spaces
                begin: /([\t ]|^)REM(?=\s)/
            }
        ]
    });
    const DIRECTIVES = {
        className: "meta",
        // TODO: Use `beforeMatch:` for indentation once available
        begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
        end: /$/,
        keywords: {
            "meta-keyword": "const disable else elseif enable end externalsource if region then"
        },
        contains: [
            COMMENT
        ]
    };
    return {
        name: "Visual Basic .NET",
        aliases: [
            "vb"
        ],
        case_insensitive: true,
        classNameAliases: {
            label: "symbol"
        },
        keywords: {
            keyword: "addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield" /* t-y */ ,
            built_in: // Operators https://docs.microsoft.com/dotnet/visual-basic/language-reference/operators
            "addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort",
            type: // Data types https://docs.microsoft.com/dotnet/visual-basic/language-reference/data-types
            "boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort",
            literal: "true false nothing"
        },
        illegal: "//|\\{|\\}|endif|gosub|variant|wend|^\\$ " /* reserved deprecated keywords */ ,
        contains: [
            CHARACTER,
            STRING,
            DATE,
            NUMBER,
            LABEL,
            DOC_COMMENT,
            COMMENT,
            DIRECTIVES
        ]
    };
}
module.exports = $9146bbab032b40fe$var$vbnet;

});

parcelRegister("aCEs1", function(module, exports) {
/**
 * @param {string} value
 * @returns {RegExp}
 * */ /**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $7bbcd4b0e2b38675$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $7bbcd4b0e2b38675$var$concat(...args) {
    const joined = args.map((x)=>$7bbcd4b0e2b38675$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $7bbcd4b0e2b38675$var$either(...args) {
    const joined = "(" + args.map((x)=>$7bbcd4b0e2b38675$var$source(x)).join("|") + ")";
    return joined;
}
/*
Language: VBScript
Description: VBScript ("Microsoft Visual Basic Scripting Edition") is an Active Scripting language developed by Microsoft that is modeled on Visual Basic.
Author: Nikita Ledyaev <lenikita@yandex.ru>
Contributors: Michal Gabrukiewicz <mgabru@gmail.com>
Website: https://en.wikipedia.org/wiki/VBScript
Category: scripting
*/ /** @type LanguageFn */ function $7bbcd4b0e2b38675$var$vbscript(hljs) {
    const BUILT_IN_FUNCTIONS = "lcase month vartype instrrev ubound setlocale getobject rgb getref string weekdayname rnd dateadd monthname now day minute isarray cbool round formatcurrency conversions csng timevalue second year space abs clng timeserial fixs len asc isempty maths dateserial atn timer isobject filter weekday datevalue ccur isdate instr datediff formatdatetime replace isnull right sgn array snumeric log cdbl hex chr lbound msgbox ucase getlocale cos cdate cbyte rtrim join hour oct typename trim strcomp int createobject loadpicture tan formatnumber mid split  cint sin datepart ltrim sqr time derived eval date formatpercent exp inputbox left ascw chrw regexp cstr err".split(" ");
    const BUILT_IN_OBJECTS = [
        "server",
        "response",
        "request",
        // take no arguments so can be called without ()
        "scriptengine",
        "scriptenginebuildversion",
        "scriptengineminorversion",
        "scriptenginemajorversion"
    ];
    const BUILT_IN_CALL = {
        begin: $7bbcd4b0e2b38675$var$concat($7bbcd4b0e2b38675$var$either(...BUILT_IN_FUNCTIONS), "\\s*\\("),
        // relevance 0 because this is acting as a beginKeywords really
        relevance: 0,
        keywords: {
            built_in: BUILT_IN_FUNCTIONS
        }
    };
    return {
        name: "VBScript",
        aliases: [
            "vbs"
        ],
        case_insensitive: true,
        keywords: {
            keyword: "call class const dim do loop erase execute executeglobal exit for each next function if then else on error option explicit new private property let get public randomize redim rem select case set stop sub while wend with end to elseif is or xor and not class_initialize class_terminate default preserve in me byval byref step resume goto",
            built_in: BUILT_IN_OBJECTS,
            literal: "true false null nothing empty"
        },
        illegal: "//",
        contains: [
            BUILT_IN_CALL,
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                contains: [
                    {
                        begin: '""'
                    }
                ]
            }),
            hljs.COMMENT(/'/, /$/, {
                relevance: 0
            }),
            hljs.C_NUMBER_MODE
        ]
    };
}
module.exports = $7bbcd4b0e2b38675$var$vbscript;

});

parcelRegister("i3NKp", function(module, exports) {
/*
Language: VBScript in HTML
Requires: xml.js, vbscript.js
Author: Ivan Sagalaev <maniac@softwaremaniacs.org>
Description: "Bridge" language defining fragments of VBScript in HTML within <% .. %>
Website: https://en.wikipedia.org/wiki/VBScript
Category: scripting
*/ function $d25f18a6e799f0c2$var$vbscriptHtml(hljs) {
    return {
        name: "VBScript in HTML",
        subLanguage: "xml",
        contains: [
            {
                begin: "<%",
                end: "%>",
                subLanguage: "vbscript"
            }
        ]
    };
}
module.exports = $d25f18a6e799f0c2$var$vbscriptHtml;

});

parcelRegister("e1Vbh", function(module, exports) {
/*
Language: Verilog
Author: Jon Evans <jon@craftyjon.com>
Contributors: Boone Severson <boone.severson@gmail.com>
Description: Verilog is a hardware description language used in electronic design automation to describe digital and mixed-signal systems. This highlighter supports Verilog and SystemVerilog through IEEE 1800-2012.
Website: http://www.verilog.com
*/ function $a36d83a4a7130077$var$verilog(hljs) {
    const SV_KEYWORDS = {
        $pattern: /[\w\$]+/,
        keyword: "accept_on alias always always_comb always_ff always_latch and assert assign assume automatic before begin bind bins binsof bit break buf|0 bufif0 bufif1 byte case casex casez cell chandle checker class clocking cmos config const constraint context continue cover covergroup coverpoint cross deassign default defparam design disable dist do edge else end endcase endchecker endclass endclocking endconfig endfunction endgenerate endgroup endinterface endmodule endpackage endprimitive endprogram endproperty endspecify endsequence endtable endtask enum event eventually expect export extends extern final first_match for force foreach forever fork forkjoin function generate|5 genvar global highz0 highz1 if iff ifnone ignore_bins illegal_bins implements implies import incdir include initial inout input inside instance int integer interconnect interface intersect join join_any join_none large let liblist library local localparam logic longint macromodule matches medium modport module nand negedge nettype new nexttime nmos nor noshowcancelled not notif0 notif1 or output package packed parameter pmos posedge primitive priority program property protected pull0 pull1 pulldown pullup pulsestyle_ondetect pulsestyle_onevent pure rand randc randcase randsequence rcmos real realtime ref reg reject_on release repeat restrict return rnmos rpmos rtran rtranif0 rtranif1 s_always s_eventually s_nexttime s_until s_until_with scalared sequence shortint shortreal showcancelled signed small soft solve specify specparam static string strong strong0 strong1 struct super supply0 supply1 sync_accept_on sync_reject_on table tagged task this throughout time timeprecision timeunit tran tranif0 tranif1 tri tri0 tri1 triand trior trireg type typedef union unique unique0 unsigned until until_with untyped use uwire var vectored virtual void wait wait_order wand weak weak0 weak1 while wildcard wire with within wor xnor xor",
        literal: "null",
        built_in: "$finish $stop $exit $fatal $error $warning $info $realtime $time $printtimescale $bitstoreal $bitstoshortreal $itor $signed $cast $bits $stime $timeformat $realtobits $shortrealtobits $rtoi $unsigned $asserton $assertkill $assertpasson $assertfailon $assertnonvacuouson $assertoff $assertcontrol $assertpassoff $assertfailoff $assertvacuousoff $isunbounded $sampled $fell $changed $past_gclk $fell_gclk $changed_gclk $rising_gclk $steady_gclk $coverage_control $coverage_get $coverage_save $set_coverage_db_name $rose $stable $past $rose_gclk $stable_gclk $future_gclk $falling_gclk $changing_gclk $display $coverage_get_max $coverage_merge $get_coverage $load_coverage_db $typename $unpacked_dimensions $left $low $increment $clog2 $ln $log10 $exp $sqrt $pow $floor $ceil $sin $cos $tan $countbits $onehot $isunknown $fatal $warning $dimensions $right $high $size $asin $acos $atan $atan2 $hypot $sinh $cosh $tanh $asinh $acosh $atanh $countones $onehot0 $error $info $random $dist_chi_square $dist_erlang $dist_exponential $dist_normal $dist_poisson $dist_t $dist_uniform $q_initialize $q_remove $q_exam $async$and$array $async$nand$array $async$or$array $async$nor$array $sync$and$array $sync$nand$array $sync$or$array $sync$nor$array $q_add $q_full $psprintf $async$and$plane $async$nand$plane $async$or$plane $async$nor$plane $sync$and$plane $sync$nand$plane $sync$or$plane $sync$nor$plane $system $display $displayb $displayh $displayo $strobe $strobeb $strobeh $strobeo $write $readmemb $readmemh $writememh $value$plusargs $dumpvars $dumpon $dumplimit $dumpports $dumpportson $dumpportslimit $writeb $writeh $writeo $monitor $monitorb $monitorh $monitoro $writememb $dumpfile $dumpoff $dumpall $dumpflush $dumpportsoff $dumpportsall $dumpportsflush $fclose $fdisplay $fdisplayb $fdisplayh $fdisplayo $fstrobe $fstrobeb $fstrobeh $fstrobeo $swrite $swriteb $swriteh $swriteo $fscanf $fread $fseek $fflush $feof $fopen $fwrite $fwriteb $fwriteh $fwriteo $fmonitor $fmonitorb $fmonitorh $fmonitoro $sformat $sformatf $fgetc $ungetc $fgets $sscanf $rewind $ftell $ferror"
    };
    return {
        name: "Verilog",
        aliases: [
            "v",
            "sv",
            "svh"
        ],
        case_insensitive: false,
        keywords: SV_KEYWORDS,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.C_LINE_COMMENT_MODE,
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ],
                variants: [
                    {
                        begin: "\\b((\\d+'(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)"
                    },
                    {
                        begin: "\\B(('(b|h|o|d|B|H|O|D))[0-9xzXZa-fA-F_]+)"
                    },
                    {
                        begin: "\\b([0-9_])+",
                        relevance: 0
                    }
                ]
            },
            /* parameters to instances */ {
                className: "variable",
                variants: [
                    {
                        begin: "#\\((?!parameter).+\\)"
                    },
                    {
                        begin: "\\.\\w+",
                        relevance: 0
                    }
                ]
            },
            {
                className: "meta",
                begin: "`",
                end: "$",
                keywords: {
                    "meta-keyword": "define __FILE__ __LINE__ begin_keywords celldefine default_nettype define else elsif end_keywords endcelldefine endif ifdef ifndef include line nounconnected_drive pragma resetall timescale unconnected_drive undef undefineall"
                },
                relevance: 0
            }
        ]
    };
}
module.exports = $a36d83a4a7130077$var$verilog;

});

parcelRegister("fqQ9v", function(module, exports) {
/*
Language: VHDL
Author: Igor Kalnitsky <igor@kalnitsky.org>
Contributors: Daniel C.K. Kho <daniel.kho@tauhop.com>, Guillaume Savaton <guillaume.savaton@eseo.fr>
Description: VHDL is a hardware description language used in electronic design automation to describe digital and mixed-signal systems.
Website: https://en.wikipedia.org/wiki/VHDL
*/ function $b3c1bd17a689a480$var$vhdl(hljs) {
    // Regular expression for VHDL numeric literals.
    // Decimal literal:
    const INTEGER_RE = "\\d(_|\\d)*";
    const EXPONENT_RE = "[eE][-+]?" + INTEGER_RE;
    const DECIMAL_LITERAL_RE = INTEGER_RE + "(\\." + INTEGER_RE + ")?" + "(" + EXPONENT_RE + ")?";
    // Based literal:
    const BASED_INTEGER_RE = "\\w+";
    const BASED_LITERAL_RE = INTEGER_RE + "#" + BASED_INTEGER_RE + "(\\." + BASED_INTEGER_RE + ")?" + "#" + "(" + EXPONENT_RE + ")?";
    const NUMBER_RE = "\\b(" + BASED_LITERAL_RE + "|" + DECIMAL_LITERAL_RE + ")";
    return {
        name: "VHDL",
        case_insensitive: true,
        keywords: {
            keyword: "abs access after alias all and architecture array assert assume assume_guarantee attribute begin block body buffer bus case component configuration constant context cover disconnect downto default else elsif end entity exit fairness file for force function generate generic group guarded if impure in inertial inout is label library linkage literal loop map mod nand new next nor not null of on open or others out package parameter port postponed procedure process property protected pure range record register reject release rem report restrict restrict_guarantee return rol ror select sequence severity shared signal sla sll sra srl strong subtype then to transport type unaffected units until use variable view vmode vprop vunit wait when while with xnor xor",
            built_in: "boolean bit character integer time delay_length natural positive string bit_vector file_open_kind file_open_status std_logic std_logic_vector unsigned signed boolean_vector integer_vector std_ulogic std_ulogic_vector unresolved_unsigned u_unsigned unresolved_signed u_signed real_vector time_vector",
            literal: "false true note warning error failure line text side width" // textio
        },
        illegal: /\{/,
        contains: [
            hljs.C_BLOCK_COMMENT_MODE,
            hljs.COMMENT("--", "$"),
            hljs.QUOTE_STRING_MODE,
            {
                className: "number",
                begin: NUMBER_RE,
                relevance: 0
            },
            {
                className: "string",
                begin: "'(U|X|0|1|Z|W|L|H|-)'",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                className: "symbol",
                begin: "'[A-Za-z](_?[A-Za-z0-9])*",
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            }
        ]
    };
}
module.exports = $b3c1bd17a689a480$var$vhdl;

});

parcelRegister("gs6c3", function(module, exports) {
/*
Language: Vim Script
Author: Jun Yang <yangjvn@126.com>
Description: full keyword and built-in from http://vimdoc.sourceforge.net/htmldoc/
Website: https://www.vim.org
Category: scripting
*/ function $bfa410c049bc6a30$var$vim(hljs) {
    return {
        name: "Vim Script",
        keywords: {
            $pattern: /[!#@\w]+/,
            keyword: // express version except: ! & * < = > !! # @ @@
            "N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank",
            built_in: "synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"
        },
        illegal: /;/,
        contains: [
            hljs.NUMBER_MODE,
            {
                className: "string",
                begin: "'",
                end: "'",
                illegal: "\\n"
            },
            /*
      A double quote can start either a string or a line comment. Strings are
      ended before the end of a line by another double quote and can contain
      escaped double-quotes and post-escaped line breaks.

      Also, any double quote at the beginning of a line is a comment but we
      don't handle that properly at the moment: any double quote inside will
      turn them into a string. Handling it properly will require a smarter
      parser.
      */ {
                className: "string",
                begin: /"(\\"|\n\\|[^"\n])*"/
            },
            hljs.COMMENT('"', "$"),
            {
                className: "variable",
                begin: /[bwtglsav]:[\w\d_]*/
            },
            {
                className: "function",
                beginKeywords: "function function!",
                end: "$",
                relevance: 0,
                contains: [
                    hljs.TITLE_MODE,
                    {
                        className: "params",
                        begin: "\\(",
                        end: "\\)"
                    }
                ]
            },
            {
                className: "symbol",
                begin: /<[\w-]+>/
            }
        ]
    };
}
module.exports = $bfa410c049bc6a30$var$vim;

});

parcelRegister("1shLC", function(module, exports) {
/*
Language: Intel x86 Assembly
Author: innocenat <innocenat@gmail.com>
Description: x86 assembly language using Intel's mnemonic and NASM syntax
Website: https://en.wikipedia.org/wiki/X86_assembly_language
Category: assembler
*/ function $10f6302904266e52$var$x86asm(hljs) {
    return {
        name: "Intel x86 Assembly",
        case_insensitive: true,
        keywords: {
            $pattern: "[.%]?" + hljs.IDENT_RE,
            keyword: "lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
            built_in: // Instruction pointer
            "ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr",
            meta: "%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"
        },
        contains: [
            hljs.COMMENT(";", "$", {
                relevance: 0
            }),
            {
                className: "number",
                variants: [
                    // Float number and x87 BCD
                    {
                        begin: "\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",
                        relevance: 0
                    },
                    // Hex number in $
                    {
                        begin: "\\$[0-9][0-9A-Fa-f]*",
                        relevance: 0
                    },
                    // Number in H,D,T,Q,O,B,Y suffix
                    {
                        begin: "\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b"
                    },
                    // Number in X,D,T,Q,O,B,Y prefix
                    {
                        begin: "\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b"
                    }
                ]
            },
            // Double quote string
            hljs.QUOTE_STRING_MODE,
            {
                className: "string",
                variants: [
                    // Single-quoted string
                    {
                        begin: "'",
                        end: "[^\\\\]'"
                    },
                    // Backquoted string
                    {
                        begin: "`",
                        end: "[^\\\\]`"
                    }
                ],
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    // Global label and local label
                    {
                        begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)"
                    },
                    // Macro-local label
                    {
                        begin: "^\\s*%%[A-Za-z0-9_$#@~.?]*:"
                    }
                ],
                relevance: 0
            },
            // Macro parameter
            {
                className: "subst",
                begin: "%[0-9]+",
                relevance: 0
            },
            // Macro parameter
            {
                className: "subst",
                begin: "%!S+",
                relevance: 0
            },
            {
                className: "meta",
                begin: /^\s*\.[\w_-]+/
            }
        ]
    };
}
module.exports = $10f6302904266e52$var$x86asm;

});

parcelRegister("2Q6SU", function(module, exports) {
/*
Language: XL
Author: Christophe de Dinechin <christophe@taodyne.com>
Description: An extensible programming language, based on parse tree rewriting
Website: http://xlr.sf.net
*/ function $2115c740c84b41fc$var$xl(hljs) {
    const BUILTIN_MODULES = "ObjectLoader Animate MovieCredits Slides Filters Shading Materials LensFlare Mapping VLCAudioVideo StereoDecoder PointCloud NetworkAccess RemoteControl RegExp ChromaKey Snowfall NodeJS Speech Charts";
    const XL_KEYWORDS = {
        $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
        keyword: "if then else do while until for loop import with is as where when by data constant integer real text name boolean symbol infix prefix postfix block tree",
        literal: "true false nil",
        built_in: "in mod rem and or xor not abs sign floor ceil sqrt sin cos tan asin acos atan exp expm1 log log2 log10 log1p pi at text_length text_range text_find text_replace contains page slide basic_slide title_slide title subtitle fade_in fade_out fade_at clear_color color line_color line_width texture_wrap texture_transform texture scale_?x scale_?y scale_?z? translate_?x translate_?y translate_?z? rotate_?x rotate_?y rotate_?z? rectangle circle ellipse sphere path line_to move_to quad_to curve_to theme background contents locally time mouse_?x mouse_?y mouse_buttons " + BUILTIN_MODULES
    };
    const DOUBLE_QUOTE_TEXT = {
        className: "string",
        begin: '"',
        end: '"',
        illegal: "\\n"
    };
    const SINGLE_QUOTE_TEXT = {
        className: "string",
        begin: "'",
        end: "'",
        illegal: "\\n"
    };
    const LONG_TEXT = {
        className: "string",
        begin: "<<",
        end: ">>"
    };
    const BASED_NUMBER = {
        className: "number",
        begin: "[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"
    };
    const IMPORT = {
        beginKeywords: "import",
        end: "$",
        keywords: XL_KEYWORDS,
        contains: [
            DOUBLE_QUOTE_TEXT
        ]
    };
    const FUNCTION_DEFINITION = {
        className: "function",
        begin: /[a-z][^\n]*->/,
        returnBegin: true,
        end: /->/,
        contains: [
            hljs.inherit(hljs.TITLE_MODE, {
                starts: {
                    endsWithParent: true,
                    keywords: XL_KEYWORDS
                }
            })
        ]
    };
    return {
        name: "XL",
        aliases: [
            "tao"
        ],
        keywords: XL_KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.C_BLOCK_COMMENT_MODE,
            DOUBLE_QUOTE_TEXT,
            SINGLE_QUOTE_TEXT,
            LONG_TEXT,
            FUNCTION_DEFINITION,
            IMPORT,
            BASED_NUMBER,
            hljs.NUMBER_MODE
        ]
    };
}
module.exports = $2115c740c84b41fc$var$xl;

});

parcelRegister("in7A8", function(module, exports) {
/*
Language: XQuery
Author: Dirk Kirsten <dk@basex.org>
Contributor: Duncan Paterson
Description: Supports XQuery 3.1 including XQuery Update 3, so also XPath (as it is a superset)
Refactored to process xml constructor syntax and function-bodies. Added missing data-types, xpath operands, inbuilt functions, and query prologs
Website: https://www.w3.org/XML/Query/
Category: functional
Audit: 2020
*/ /** @type LanguageFn */ function $d60041978ebac4c3$var$xquery(_hljs) {
    // see https://www.w3.org/TR/xquery/#id-terminal-delimitation
    const KEYWORDS = "module schema namespace boundary-space preserve no-preserve strip default collation base-uri ordering context decimal-format decimal-separator copy-namespaces empty-sequence except exponent-separator external grouping-separator inherit no-inherit lax minus-sign per-mille percent schema-attribute schema-element strict unordered zero-digit declare import option function validate variable for at in let where order group by return if then else tumbling sliding window start when only end previous next stable ascending descending allowing empty greatest least some every satisfies switch case typeswitch try catch and or to union intersect instance of treat as castable cast map array delete insert into replace value rename copy modify update";
    // Node Types (sorted by inheritance)
    // atomic types (sorted by inheritance)
    const TYPE = "item document-node node attribute document element comment namespace namespace-node processing-instruction text construction xs:anyAtomicType xs:untypedAtomic xs:duration xs:time xs:decimal xs:float xs:double xs:gYearMonth xs:gYear xs:gMonthDay xs:gMonth xs:gDay xs:boolean xs:base64Binary xs:hexBinary xs:anyURI xs:QName xs:NOTATION xs:dateTime xs:dateTimeStamp xs:date xs:string xs:normalizedString xs:token xs:language xs:NMTOKEN xs:Name xs:NCName xs:ID xs:IDREF xs:ENTITY xs:integer xs:nonPositiveInteger xs:negativeInteger xs:long xs:int xs:short xs:byte xs:nonNegativeInteger xs:unisignedLong xs:unsignedInt xs:unsignedShort xs:unsignedByte xs:positiveInteger xs:yearMonthDuration xs:dayTimeDuration";
    const LITERAL = "eq ne lt le gt ge is self:: child:: descendant:: descendant-or-self:: attribute:: following:: following-sibling:: parent:: ancestor:: ancestor-or-self:: preceding:: preceding-sibling:: NaN";
    // functions (TODO: find regex for op: without breaking build)
    const BUILT_IN = {
        className: "built_in",
        variants: [
            {
                begin: /\barray:/,
                end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
            },
            {
                begin: /\bmap:/,
                end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
            },
            {
                begin: /\bmath:/,
                end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
            },
            {
                begin: /\bop:/,
                end: /\(/,
                excludeEnd: true
            },
            {
                begin: /\bfn:/,
                end: /\(/,
                excludeEnd: true
            },
            // do not highlight inbuilt strings as variable or xml element names
            {
                begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/
            },
            {
                begin: /\blocal:/,
                end: /\(/,
                excludeEnd: true
            },
            {
                begin: /\bzip:/,
                end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
            },
            {
                begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
                end: /\(/,
                excludeEnd: true
            }
        ]
    };
    const TITLE = {
        className: "title",
        begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
        end: /;/
    };
    const VAR = {
        className: "variable",
        begin: /[$][\w\-:]+/
    };
    const NUMBER = {
        className: "number",
        begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
        relevance: 0
    };
    const STRING = {
        className: "string",
        variants: [
            {
                begin: /"/,
                end: /"/,
                contains: [
                    {
                        begin: /""/,
                        relevance: 0
                    }
                ]
            },
            {
                begin: /'/,
                end: /'/,
                contains: [
                    {
                        begin: /''/,
                        relevance: 0
                    }
                ]
            }
        ]
    };
    const ANNOTATION = {
        className: "meta",
        begin: /%[\w\-:]+/
    };
    const COMMENT = {
        className: "comment",
        begin: /\(:/,
        end: /:\)/,
        relevance: 10,
        contains: [
            {
                className: "doctag",
                begin: /@\w+/
            }
        ]
    };
    // see https://www.w3.org/TR/xquery/#id-computedConstructors
    // mocha: computed_inbuilt
    // see https://www.regexpal.com/?fam=99749
    const COMPUTED = {
        beginKeywords: "element attribute comment document processing-instruction",
        end: /\{/,
        excludeEnd: true
    };
    // mocha: direct_method
    const DIRECT = {
        begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
        end: /(\/[\w._:-]+>)/,
        subLanguage: "xml",
        contains: [
            {
                begin: /\{/,
                end: /\}/,
                subLanguage: "xquery"
            },
            "self"
        ]
    };
    const CONTAINS = [
        VAR,
        BUILT_IN,
        STRING,
        NUMBER,
        COMMENT,
        ANNOTATION,
        TITLE,
        COMPUTED,
        DIRECT
    ];
    return {
        name: "XQuery",
        aliases: [
            "xpath",
            "xq"
        ],
        case_insensitive: false,
        illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
        keywords: {
            $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
            keyword: KEYWORDS,
            type: TYPE,
            literal: LITERAL
        },
        contains: CONTAINS
    };
}
module.exports = $d60041978ebac4c3$var$xquery;

});

parcelRegister("2c2Kl", function(module, exports) {
/*
 Language: Zephir
 Description: Zephir, an open source, high-level language designed to ease the creation and maintainability of extensions for PHP with a focus on type and memory safety.
 Author: Oleg Efimov <efimovov@gmail.com>
 Website: https://zephir-lang.com/en
 Audit: 2020
 */ /** @type LanguageFn */ function $198ed521fc90492b$var$zephir(hljs) {
    const STRING = {
        className: "string",
        contains: [
            hljs.BACKSLASH_ESCAPE
        ],
        variants: [
            hljs.inherit(hljs.APOS_STRING_MODE, {
                illegal: null
            }),
            hljs.inherit(hljs.QUOTE_STRING_MODE, {
                illegal: null
            })
        ]
    };
    const TITLE_MODE = hljs.UNDERSCORE_TITLE_MODE;
    const NUMBER = {
        variants: [
            hljs.BINARY_NUMBER_MODE,
            hljs.C_NUMBER_MODE
        ]
    };
    const KEYWORDS = // classes and objects
    "namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined";
    return {
        name: "Zephir",
        aliases: [
            "zep"
        ],
        keywords: KEYWORDS,
        contains: [
            hljs.C_LINE_COMMENT_MODE,
            hljs.COMMENT(/\/\*/, /\*\//, {
                contains: [
                    {
                        className: "doctag",
                        begin: /@[A-Za-z]+/
                    }
                ]
            }),
            {
                className: "string",
                begin: /<<<['"]?\w+['"]?$/,
                end: /^\w+;/,
                contains: [
                    hljs.BACKSLASH_ESCAPE
                ]
            },
            {
                // swallow composed identifiers to avoid parsing them as keywords
                begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
            },
            {
                className: "function",
                beginKeywords: "function fn",
                end: /[;{]/,
                excludeEnd: true,
                illegal: /\$|\[|%/,
                contains: [
                    TITLE_MODE,
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: KEYWORDS,
                        contains: [
                            "self",
                            hljs.C_BLOCK_COMMENT_MODE,
                            STRING,
                            NUMBER
                        ]
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "class interface",
                end: /\{/,
                excludeEnd: true,
                illegal: /[:($"]/,
                contains: [
                    {
                        beginKeywords: "extends implements"
                    },
                    TITLE_MODE
                ]
            },
            {
                beginKeywords: "namespace",
                end: /;/,
                illegal: /[.']/,
                contains: [
                    TITLE_MODE
                ]
            },
            {
                beginKeywords: "use",
                end: /;/,
                contains: [
                    TITLE_MODE
                ]
            },
            {
                begin: /=>/ // No markup, just a relevance booster
            },
            STRING,
            NUMBER
        ]
    };
}
module.exports = $198ed521fc90492b$var$zephir;

});

/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/**
 * React Router DOM v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * @remix-run/router v1.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else if (isPathRelative) {
        let fromSegments = routePathnames[routePathnames.length - 1].replace(/^\//, "").split("/");
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="path", each leading .. segment means "go up one URL segment"
            while(toSegments[0] === ".."){
                toSegments.shift();
                fromSegments.pop();
            }
            to.pathname = toSegments.join("/");
        }
        from = "/" + fromSegments.join("/");
    } else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // With relative="route" (the default), each leading .. segment means
            // "go up one route" instead of "go up one URL segment".  This is a key
            // difference from how <a href> works and a major reason we call this a
            // "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.20.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || "");
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ const $f8409e0880c5cb17$export$66b32f6f30eb4b4 = {
    HOME: "/",
    ABOUT: "/about",
    OFFER: "/offer",
    SCAN: "/start/scan",
    ISSUER_LIST: "/issuers",
    SETTINGS: "/settings",
    ISSUER_DETAIL: "/issuers/id/:id",
    ISSUER_ADD: "/issuers/add",
    CREDENTIAL_ISSUANCE: "/issuers/id/:id/cs/:credentialId/issue",
    OAUTH_CALLBACK: "/oauth/callback",
    CREDENTIAL_LIST: "/credentials",
    CREDENTIAL_DETAIL: "/credentials/:id",
    START: "/start",
    OFFER_RESOLVE: "/offer/resolve",
    PRESENTATION_RESOLVE: "/presentation/resolve/:id?",
    TO_ISSUER_DETAIL: function(id) {
        return this.ISSUER_DETAIL.replace(":id", id);
    },
    TO_CREDENTIAL_ISSUANCE: function(issuerId, credentialId) {
        return this.CREDENTIAL_ISSUANCE.replace(":id", encodeURIComponent(issuerId)).replace(":credentialId", encodeURIComponent(credentialId));
    },
    TO_CREDENTIAL_DETAIL: function(id) {
        return this.CREDENTIAL_DETAIL.replace(":id", id);
    },
    TO_OFFER_RESOLVE: function(offerRequest) {
        return this.OFFER_RESOLVE + "?" + offerRequest;
    },
    TO_PRESENTATION_RESOLVE: function(presentationRequest) {
        return this.PRESENTATION_RESOLVE.replace(":id?", "") + "?" + presentationRequest;
    },
    TO_PRESENTATION_RESOLVE_WITH_ID: function(id) {
        return this.PRESENTATION_RESOLVE.replace(":id?", id);
    }
};


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



var $acw62 = parcelRequire("acw62");
/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ var $8b4eb369eb8605c9$exports = {};





















(function(root, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./kotlin-kotlin-stdlib.js",
        "./curity-ssi-libs-jose.js",
        "./curity-ssi-libs-verifiable-credentials-vc-ks-data.js",
        "./kotlinx-serialization-kotlinx-serialization-core.js",
        "./ktor-ktor-client-content-negotiation.js",
        "./ktor-ktor-serialization-kotlinx-json.js",
        "./ktor-ktor-http.js",
        "./kotlinx-serialization-kotlinx-serialization-json.js",
        "./ktor-ktor-client-core.js",
        "./ktor-ktor-utils.js",
        "./curity-ssi-libs-oauth.js",
        "./curity-ssi-libs-core-json.js",
        "./curity-ssi-libs-did-resolvers-jwk.js",
        "./Kotlin-DateTime-library-kotlinx-datetime.js",
        "./curity-ssi-libs-sd-jwt.js",
        "./curity-ssi-libs-did.js",
        "./curity-ssi-libs-core.js",
        "./curity-ssi-libs-verifiable-credentials.js",
        "./curity-ssi-libs-did-json.js",
        "./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js",
        "./kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.js"
    ], factory);
    else factory($8b4eb369eb8605c9$exports, (parcelRequire("9vyMc")), (parcelRequire("lm0Zq")), (parcelRequire("1FnuK")), (parcelRequire("3kJd2")), (parcelRequire("kmEuE")), (parcelRequire("3WU9A")), (parcelRequire("4fxpJ")), (parcelRequire("2VOQS")), (parcelRequire("dKHwv")), (parcelRequire("cL6ZK")), (parcelRequire("6KJhA")), (parcelRequire("fcWHW")), (parcelRequire("jrYSV")), (parcelRequire("3WyZ3")), (parcelRequire("ljyPz")), (parcelRequire("lsn9o")), (parcelRequire("iuiRe")), (parcelRequire("dfhqu")), (parcelRequire("692Pz")), (parcelRequire("ctZcf")), (parcelRequire("3pY5s")));
})(globalThis, function(_, kotlin_kotlin, kotlin_io_curity_ssi_jose, kotlin_io_curity_ssi_vc_ks_data, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils, kotlin_io_curity_ssi_oauth, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_jwk, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_sd_jwt, kotlin_io_curity_ssi_did, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_verifiable_credentials, kotlin_io_curity_ssi_did_json, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat) {
    "use strict";
    //region block: imports
    var imul = Math.imul;
    var VOID = kotlin_kotlin.$_$.f;
    var JsonJwsHeader = kotlin_io_curity_ssi_jose.$_$.s;
    var JsonJwtClaimsSet = kotlin_io_curity_ssi_jose.$_$.u;
    var JwsUtil_getInstance = kotlin_io_curity_ssi_jose.$_$.j;
    var protoOf = kotlin_kotlin.$_$.kb;
    var initMetadataForObject = kotlin_kotlin.$_$.oa;
    var JsonSupportedCredentialSerializer_getInstance = kotlin_io_curity_ssi_vc_ks_data.$_$.v;
    var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
    var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
    var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
    var $serializer_getInstance = kotlin_io_curity_ssi_vc_ks_data.$_$.t;
    var $serializer_getInstance_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.s;
    var equals = kotlin_kotlin.$_$.ba;
    var $serializer_getInstance_1 = kotlin_io_curity_ssi_vc_ks_data.$_$.u;
    var Unit_instance = kotlin_kotlin.$_$.h5;
    var THROW_CCE = kotlin_kotlin.$_$.te;
    var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
    var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
    var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
    var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
    var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
    var objectCreate = kotlin_kotlin.$_$.jb;
    var toString = kotlin_kotlin.$_$.ob;
    var hashCode = kotlin_kotlin.$_$.ha;
    var initMetadataForClass = kotlin_kotlin.$_$.ia;
    var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
    var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
    var CoroutineImpl = kotlin_kotlin.$_$.n9;
    var URLBuilder = kotlin_io_ktor_ktor_http.$_$.v;
    var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
    var singleOrNull = kotlin_kotlin.$_$.d8;
    var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
    var JsonOffer = kotlin_io_curity_ssi_vc_ks_data.$_$.g1;
    var getKClass = kotlin_kotlin.$_$.e;
    var arrayOf = kotlin_kotlin.$_$.hf;
    var createKType = kotlin_kotlin.$_$.b;
    var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
    var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
    var isInterface = kotlin_kotlin.$_$.xa;
    var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.v;
    var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.o;
    var takeFrom = kotlin_io_ktor_ktor_http.$_$.p1;
    var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.f;
    var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.u;
    var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
    var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
    var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
    var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
    var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
    var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
    var first = kotlin_kotlin.$_$.x6;
    var OAuthPreAuthorizedCodeFlowClient = kotlin_io_curity_ssi_oauth.$_$.g;
    var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
    var JsonOAuthErrorTokenResponse = kotlin_io_curity_ssi_oauth.$_$.a;
    var OAuthRefreshFlowClient = kotlin_io_curity_ssi_oauth.$_$.h;
    var JsonOAuthSuccessTokenResponse = kotlin_io_curity_ssi_oauth.$_$.b;
    var VcSdJwtAuthorizationDetail_init_$Create$ = kotlin_io_curity_ssi_vc_ks_data.$_$.r;
    var listOf = kotlin_kotlin.$_$.n7;
    var KtList = kotlin_kotlin.$_$.p5;
    var VcSdJwtAuthorizationDetail = kotlin_io_curity_ssi_vc_ks_data.$_$.u1;
    var createInvariantKTypeProjection = kotlin_kotlin.$_$.a;
    var VcSdJwtCredentialConfigurationsSupported = kotlin_io_curity_ssi_vc_ks_data.$_$.v1;
    var toSet = kotlin_kotlin.$_$.r8;
    var JwtVcJsonAuthorizationDetail_init_$Create$ = kotlin_io_curity_ssi_vc_ks_data.$_$.q;
    var JwtVcJsonAuthorizationDetail = kotlin_io_curity_ssi_vc_ks_data.$_$.i1;
    var JwtVcJsonCredentialConfigurationsSupported = kotlin_io_curity_ssi_vc_ks_data.$_$.j1;
    var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
    var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
    var OAuthAuthorizationRequest = kotlin_io_curity_ssi_oauth.$_$.c;
    var OAuthCodeFlowClient = kotlin_io_curity_ssi_oauth.$_$.f;
    var getKClassFromExpression = kotlin_kotlin.$_$.d;
    var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
    var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
    var to = kotlin_kotlin.$_$.wf;
    var mapOf = kotlin_kotlin.$_$.q7;
    var JwkDid_instance = kotlin_io_curity_ssi_jwk.$_$.a;
    var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
    var JsonProofOfPossession = kotlin_io_curity_ssi_vc_ks_data.$_$.h1;
    var VcSdJwtVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.y1;
    var CredentialDefinition = kotlin_io_curity_ssi_vc_ks_data.$_$.o1;
    var JwtVcJsonVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.p1;
    var Companion_getInstance_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.x;
    var System_instance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.b;
    var UserVerifiableCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.t1;
    var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.j;
    var URLBuilder_0 = kotlin_io_ktor_ktor_http.$_$.w;
    var plus = kotlin_kotlin.$_$.v7;
    var emptyList = kotlin_kotlin.$_$.r6;
    var isBlank = kotlin_kotlin.$_$.uc;
    var toList = kotlin_kotlin.$_$.k8;
    var listOf_0 = kotlin_kotlin.$_$.o7;
    var isSuccess = kotlin_io_ktor_ktor_http.$_$.k1;
    var JsonCredentialIssuerMetadata = kotlin_io_curity_ssi_vc_ks_data.$_$.b1;
    var getOrNull = kotlin_kotlin.$_$.a7;
    var JsonOAuthMetadata = kotlin_io_curity_ssi_vc_ks_data.$_$.f1;
    var JsonCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.c1;
    var Url = kotlin_io_ktor_ktor_http.$_$.z;
    var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
    var JsonVcSdJwtIssuerMetadata = kotlin_io_curity_ssi_sd_jwt.$_$.e;
    var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
    var Companion_getInstance_2 = kotlin_io_curity_ssi_did.$_$.b;
    var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
    var mapCapacity = kotlin_kotlin.$_$.p7;
    var coerceAtLeast = kotlin_kotlin.$_$.rb;
    var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
    var emptyMap = kotlin_kotlin.$_$.s6;
    var ValidationScope = kotlin_io_curity_ssi_core.$_$.n;
    var JwtVcJsonVerifiableCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.q1;
    var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
    var Deferred = kotlin_io_curity_ssi_vc_ks_data.$_$.k1;
    var DidValidatedJwtVcJsonCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.a1;
    var initMetadataForLambda = kotlin_kotlin.$_$.na;
    var suspendableValidationScope = kotlin_io_curity_ssi_core.$_$.a;
    var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
    var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
    var _Duration___get_absoluteValue__impl__vr7i6w = kotlin_kotlin.$_$.n2;
    var _Duration___get_inWholeSeconds__impl__hpy7b3 = kotlin_kotlin.$_$.o2;
    var Long = kotlin_kotlin.$_$.ne;
    var Companion_getInstance_3 = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
    var Companion_instance = kotlin_io_curity_ssi_vc_ks_data.$_$.w;
    var IssuerURI = kotlin_io_curity_ssi_verifiable_credentials.$_$.e;
    var IssuerObject = kotlin_io_curity_ssi_verifiable_credentials.$_$.d;
    var DidResolutionException = kotlin_io_curity_ssi_did.$_$.d;
    var Companion_instance_0 = kotlin_io_curity_ssi_jose.$_$.e;
    var Companion_instance_1 = kotlin_io_curity_ssi_did_json.$_$.a;
    var JsonPublicKeyJwk = kotlin_io_curity_ssi_did_json.$_$.d;
    var CryptoException = kotlin_io_curity_ssi_jose.$_$.k;
    var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
    var IllegalArgumentException = kotlin_kotlin.$_$.le;
    var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
    var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
    var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
    var startsWith = kotlin_kotlin.$_$.hd;
    var header = kotlin_io_ktor_ktor_client_core.$_$.q;
    var Plugin_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.c;
    var plugin = kotlin_io_ktor_ktor_client_core.$_$.n;
    var Sender = kotlin_io_ktor_ktor_client_core.$_$.m;
    var initMetadataForFunctionReference = kotlin_kotlin.$_$.la;
    var url = kotlin_io_ktor_ktor_client_core.$_$.s;
    var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
    var contentType = kotlin_io_ktor_ktor_http.$_$.g1;
    var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
    var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
    var JwtVcJsonCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.l1;
    var VcSdJwtCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.x1;
    var path = kotlin_io_ktor_ktor_http.$_$.o1;
    var JwtVcJsonLdVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.n1;
    var JwtVcJsonLdCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.m1;
    var LdpVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.s1;
    var LdpVcCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.r1;
    var Deferred_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.w1;
    var VcSdJwtVerifiableCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.z1;
    var Companion_instance_2 = kotlin_io_curity_ssi_sd_jwt.$_$.c;
    var VcSdJwtIssuerJwtValidator = kotlin_io_curity_ssi_sd_jwt.$_$.f;
    var DefaultValidatedVcSdJwtCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.z;
    var Pair = kotlin_kotlin.$_$.qe;
    var Collection = kotlin_kotlin.$_$.j5;
    var JsonStringFilter = kotlin_io_curity_ssi_vc_ks_data.$_$.f2;
    var JsonArrayContainsFilter = kotlin_io_curity_ssi_vc_ks_data.$_$.a2;
    var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
    var IssuerObject_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.d1;
    var IssuerURI_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.e1;
    var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
    var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.t;
    var Companion_instance_3 = kotlin_io_curity_ssi_jose.$_$.d;
    var JsonPresentationSubmission = kotlin_io_curity_ssi_vc_ks_data.$_$.e2;
    var checkIndexOverflow = kotlin_kotlin.$_$.z5;
    var DefaultJsonMultiValue_init_$Create$_0 = kotlin_io_curity_ssi_core_json.$_$.a;
    var JsonDescriptorMapObject = kotlin_io_curity_ssi_vc_ks_data.$_$.b2;
    var StringCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.c;
    var SerializableW3CVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.j2;
    var toString_0 = kotlin_kotlin.$_$.vf;
    var JsonPathNested = kotlin_io_curity_ssi_vc_ks_data.$_$.c2;
    var JsonStringVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.g2;
    var toLong = kotlin_kotlin.$_$.mb;
    var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
    var SdJwtKeyBindingBuilder_instance = kotlin_io_curity_ssi_sd_jwt.$_$.b;
    var Companion_instance_4 = kotlin_io_curity_ssi_sd_jwt.$_$.a;
    var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.h2;
    var Companion_getInstance_4 = kotlin_io_ktor_ktor_http.$_$.h;
    var DefaultJsonMultiValue = kotlin_io_curity_ssi_core_json.$_$.l;
    var JsonVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.h2;
    var Companion_getInstance_5 = kotlin_io_ktor_ktor_http.$_$.i;
    var ParametersBuilder = kotlin_io_ktor_ktor_http.$_$.u;
    var submitForm = kotlin_io_ktor_ktor_client_core.$_$.a;
    var JsonVerifierDirectPostAuthorizationResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.i2;
    var getStringHashCode = kotlin_kotlin.$_$.ga;
    var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
    var setOf = kotlin_kotlin.$_$.c8;
    var JsonPresentationDefinition = kotlin_io_curity_ssi_vc_ks_data.$_$.d2;
    var intersect = kotlin_kotlin.$_$.f7;
    var Companion_instance_5 = kotlin_io_curity_ssi_verifiable_credentials.$_$.a;
    var ensureNotNull = kotlin_kotlin.$_$.kf;
    var Companion_instance_6 = kotlin_io_curity_ssi_jose.$_$.f;
    var $serializer_getInstance_2 = kotlin_io_curity_ssi_jose.$_$.i;
    var $serializer_getInstance_3 = kotlin_io_curity_ssi_vc_ks_data.$_$.y;
    var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
    var Js_instance = kotlin_io_ktor_ktor_client_core.$_$.b;
    var OAuthClient = kotlin_io_curity_ssi_oauth.$_$.e;
    var JwkDidResolver = kotlin_io_curity_ssi_jwk.$_$.b;
    var CompositeDidResolver = kotlin_io_curity_ssi_did.$_$.c;
    var HttpClient_0 = kotlin_io_ktor_ktor_client_core.$_$.w;
    var JsDefaultKeyStore = kotlin_io_curity_ssi_jose.$_$.a;
    var NotImplementedError = kotlin_kotlin.$_$.pe;
    var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
    var joinToString = kotlin_kotlin.$_$.g7;
    var get_authority = kotlin_io_ktor_ktor_http.$_$.b1;
    var putAll = kotlin_io_ktor_ktor_utils.$_$.x;
    var get_supportedCapabilities = kotlin_io_ktor_ktor_client_core.$_$.h;
    var install = kotlin_io_ktor_ktor_client_core.$_$.g;
    var HttpClientEngine = kotlin_io_ktor_ktor_client_core.$_$.i;
    var OnRequestContext = kotlin_io_ktor_ktor_client_core.$_$.j;
    var get_authority_0 = kotlin_io_ktor_ktor_http.$_$.a1;
    var set_port = kotlin_io_ktor_ktor_client_core.$_$.r;
    var createClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.k;
    var convertJwtVcJsonRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.e;
    var convertJwtVcJsonResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.f;
    var convertJwtVcJsonLdRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.c;
    var convertJwtVcJsonLdResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.d;
    var convertLdpVcJsonRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.g;
    var convertLdpVcJsonResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.h;
    var inner = kotlin_io_curity_ssi_vc_ks_data.$_$.n;
    var CancellationException = kotlin_kotlin.$_$.y8;
    var CancellationException_init_$Init$ = kotlin_kotlin.$_$.a1;
    var captureStack = kotlin_kotlin.$_$.t9;
    var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
    var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
    var printStackTrace = kotlin_kotlin.$_$.tf;
    var getRootCause = kotlin_io_curity_ssi_vc_ks_data.$_$.m;
    var EventListener = kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.$_$.a;
    var appendParameters = kotlin_io_curity_ssi_oauth.$_$.i;
    var Exception = kotlin_kotlin.$_$.ke;
    var Companion_instance_7 = kotlin_kotlin.$_$.c5;
    var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
    var parameters = kotlin_io_ktor_ktor_http.$_$.m1;
    var formUrlEncode = kotlin_io_ktor_ktor_http.$_$.i1;
    var intercepted = kotlin_kotlin.$_$.b9;
    var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
    var returnIfSuspended = kotlin_kotlin.$_$.k;
    var OAuthAuthorizationResponse = kotlin_io_curity_ssi_oauth.$_$.d;
    var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
    var createJsCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.k;
    var JsCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.a;
    var copyToArray = kotlin_kotlin.$_$.o6;
    var inner_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.p;
    var createJsUserVerifiableCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.l;
    var createJsCredentialIssuerSupportedCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.j;
    var lazy = kotlin_kotlin.$_$.qf;
    var defineProp = kotlin_kotlin.$_$.aa;
    var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
    var inner_1 = kotlin_io_curity_ssi_vc_ks_data.$_$.o;
    var NativeSigningKey = kotlin_io_curity_ssi_jose.$_$.v;
    var NativeVerificationKey = kotlin_io_curity_ssi_jose.$_$.w;
    var SigningKeyPair = kotlin_io_curity_ssi_jose.$_$.l;
    var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
    var KProperty1 = kotlin_kotlin.$_$.ac;
    var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
    var KtMutableMap = kotlin_kotlin.$_$.t5;
    var JsJwsHeaderAndPayload = kotlin_io_curity_ssi_jose.$_$.b;
    var createJSObject = kotlin_io_curity_ssi_vc_ks_data.$_$.i;
    var toList_0 = kotlin_kotlin.$_$.l8;
    var JsPair = kotlin_io_curity_ssi_vc_ks_data.$_$.b;
    var toLong_0 = kotlin_kotlin.$_$.rd;
    var toSet_0 = kotlin_kotlin.$_$.s8;
    //endregion
    //region block: pre-declaration
    initMetadataForObject(ProofOfPossessionBuilder, "ProofOfPossessionBuilder", VOID, VOID, VOID, [
        7,
        6
    ]);
    initMetadataForCompanion(Companion);
    initMetadataForObject($serializer, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(ResolvedOffer, "ResolvedOffer", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_4
    });
    initMetadataForCoroutine($startHandleOfferCOROUTINE$0, CoroutineImpl);
    initMetadataForCoroutine($continueHandleOfferCOROUTINE$1, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialsCOROUTINE$3, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialCOROUTINE$4, CoroutineImpl);
    initMetadataForClass(CredentialIssuanceCoordinator, "CredentialIssuanceCoordinator", VOID, VOID, VOID, [
        1,
        4,
        5,
        3
    ]);
    initMetadataForClass(OfferResult, "OfferResult");
    initMetadataForClass(IssuedCredentials, "IssuedCredentials", VOID, OfferResult);
    initMetadataForObject(InvalidOfferOrUserCode, "InvalidOfferOrUserCode", VOID, OfferResult);
    initMetadataForCompanion(Companion_0);
    initMetadataForCoroutine($loadCOROUTINE$5, CoroutineImpl);
    initMetadataForClass(DefaultCredentialIssuerLoader, "DefaultCredentialIssuerLoader", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_1);
    initMetadataForCoroutine($getCOROUTINE$6, CoroutineImpl);
    initMetadataForClass(DefaultVcSdJwtIssuerMetadataLoader, "DefaultVcSdJwtIssuerMetadataLoader", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(DidSubjectVerifiableCredentialResponseValidator, "DidSubjectVerifiableCredentialResponseValidator", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_2);
    initMetadataForLambda(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($validateCOROUTINE$7, CoroutineImpl);
    initMetadataForClass(JwtVcJsonCredentialWithDidSubjectValidator, "JwtVcJsonCredentialWithDidSubjectValidator", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCoroutine($validateJwtSignatureCOROUTINE$8, CoroutineImpl);
    initMetadataForObject(JwtCredentialValidationHelper, "JwtCredentialValidationHelper", VOID, VOID, VOID, [
        3
    ]);
    initMetadataForClass(InMemoryKeyAliasStore, "InMemoryKeyAliasStore", InMemoryKeyAliasStore, VOID, VOID, [
        2,
        1
    ]);
    initMetadataForCompanion(Companion_3);
    initMetadataForObject($serializer_0, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(InMemoryVerifiableCredentialStore, "InMemoryVerifiableCredentialStore", InMemoryVerifiableCredentialStore, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_5
    });
    initMetadataForCoroutine($interceptCOROUTINE$9, CoroutineImpl);
    initMetadataForCoroutine($withTokenCOROUTINE$10, CoroutineImpl);
    initMetadataForClass(OAuthTokenInterceptor, "OAuthTokenInterceptor", VOID, VOID, VOID, [
        2
    ]);
    initMetadataForFunctionReference(OAuthTokenInterceptor$intercept$ref, VOID, VOID, [
        2
    ]);
    initMetadataForCoroutine($requestCredentialCOROUTINE$11, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialCOROUTINE$12, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialCOROUTINE$13, CoroutineImpl);
    initMetadataForCoroutine($requestCredentialCOROUTINE$14, CoroutineImpl);
    initMetadataForClass(VcClient, "VcClient", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($validateVcSdJwtCOROUTINE$15, CoroutineImpl);
    initMetadataForClass(VcSdJwtVerifiableCredentialResponseValidator, "VcSdJwtVerifiableCredentialResponseValidator", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForClass(CredentialFinderResult, "CredentialFinderResult");
    initMetadataForClass(InMemoryPreRegisteredClientStore, "InMemoryPreRegisteredClientStore", InMemoryPreRegisteredClientStore, VOID, VOID, [
        1,
        0
    ]);
    initMetadataForCompanion(Companion_4);
    initMetadataForObject($serializer_1, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(InMemoryRequestJwtStore, "InMemoryRequestJwtStore", InMemoryRequestJwtStore, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_6
    });
    initMetadataForCompanion(Companion_5);
    initMetadataForClass(JwtVcJsonIssuer, "JwtVcJsonIssuer");
    initMetadataForClass(JwtVcJsonType, "JwtVcJsonType");
    initMetadataForClass(VcSdJwtIssuer, "VcSdJwtIssuer");
    initMetadataForClass(VcSdJwtType, "VcSdJwtType");
    initMetadataForClass(OpenIdWalletAuthenticatorCredentialFinder, "OpenIdWalletAuthenticatorCredentialFinder", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_6);
    initMetadataForLambda(PresentationResponseCreator$createVpSdJwt$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($createVerifiablePresentationResponseCOROUTINE$19, CoroutineImpl);
    initMetadataForCoroutine($createVerifiablePresentationCOROUTINE$20, CoroutineImpl);
    initMetadataForCoroutine($createVpJwtCOROUTINE$21, CoroutineImpl);
    initMetadataForCoroutine($createVpSdJwtCOROUTINE$22, CoroutineImpl);
    initMetadataForClass(PresentationResponseCreator, "PresentationResponseCreator", VOID, VOID, VOID, [
        2,
        5,
        3,
        4
    ]);
    initMetadataForClass(UserSelectedCredentials, "UserSelectedCredentials");
    initMetadataForClass(UserSelectedCredential, "UserSelectedCredential");
    initMetadataForClass(PresentationDisclosure, "PresentationDisclosure");
    initMetadataForCoroutine($fetchRequestObjectJwtCOROUTINE$23, CoroutineImpl);
    initMetadataForCoroutine($postDirectPostAuthorizationResponseCOROUTINE$24, CoroutineImpl);
    initMetadataForClass(VerifierClient, "VerifierClient", VOID, VOID, VOID, [
        1,
        2
    ]);
    initMetadataForCompanion(Companion_7);
    initMetadataForObject($serializer_2, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(PreRegisteredClient, "PreRegisteredClient", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_7
    });
    initMetadataForCompanion(Companion_8);
    initMetadataForObject($serializer_3, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(VpFormat, "VpFormat", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_8
    });
    initMetadataForObject(WalletMetadata, "WalletMetadata");
    initMetadataForCompanion(Companion_9);
    initMetadataForClass(VerifiablePresentationResponseParameters, "VerifiablePresentationResponseParameters");
    initMetadataForLambda(DefaultRequestObjectJwtValidator$validate$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($validateCOROUTINE$25, CoroutineImpl);
    initMetadataForCoroutine($validateSignatureForPreRegisteredClientCOROUTINE$26, CoroutineImpl);
    initMetadataForCoroutine($fetchJwksCOROUTINE$27, CoroutineImpl);
    initMetadataForClass(DefaultRequestObjectJwtValidator, "DefaultRequestObjectJwtValidator", VOID, VOID, VOID, [
        1,
        2
    ]);
    initMetadataForLambda(HaipRequestObjectJwtValidator$validate$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForCoroutine($validateCOROUTINE$28, CoroutineImpl);
    initMetadataForClass(HaipRequestObjectJwtValidator, "HaipRequestObjectJwtValidator", VOID, DefaultRequestObjectJwtValidator, VOID, [
        1
    ]);
    initMetadataForCompanion(Companion_10);
    initMetadataForObject($serializer_4, "$serializer", VOID, VOID, [
        GeneratedSerializer
    ]);
    initMetadataForClass(ValidatedRequestJwt, "ValidatedRequestJwt", VOID, VOID, VOID, VOID, VOID, {
        0: $serializer_getInstance_9
    });
    initMetadataForClass(JsHttpProxy, "JsHttpProxy");
    initMetadataForClass(ProxyPluginConfig, "ProxyPluginConfig", ProxyPluginConfig);
    initMetadataForClass(ProxyEngine, "ProxyEngine", VOID, VOID, [
        HttpClientEngine
    ], [
        1
    ]);
    initMetadataForLambda(ProxyPlugin$lambda$slambda, CoroutineImpl, VOID, [
        3
    ]);
    initMetadataForLambda(JsVcClient$requestJwtVcJsonCredential$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsVcClient$requestJwtVcJsonLdCredential$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsVcClient$requestLdpVcJsonCredential$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsVcClient, "JsVcClient");
    initMetadataForClass(UserCancellationException, "UserCancellationException", UserCancellationException, CancellationException);
    initMetadataForLambda(safePromise$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsProxy, "JsProxy");
    initMetadataForCoroutine($authorizeCOROUTINE$29, CoroutineImpl);
    initMetadataForClass(BrowserWindowOAuthAuthorizer, "BrowserWindowOAuthAuthorizer", BrowserWindowOAuthAuthorizer, VOID, VOID, [
        2
    ]);
    initMetadataForClass(JsOAuthSupport, "JsOAuthSupport");
    initMetadataForClass(BrowserWindowOAuthSupport, "BrowserWindowOAuthSupport", VOID, VOID, VOID, [
        1
    ]);
    initMetadataForLambda(JsKeyAliasStore$add$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsKeyAliasStore$get$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsKeyAliasStore, "JsKeyAliasStore");
    initMetadataForLambda(JsCredentialIssuerLoader$load$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsCredentialIssuerLoader, "JsCredentialIssuerLoader");
    initMetadataForLambda(JsCredentialIssuerStore$upsert$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuerStore$getAll$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuerStore$getById$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuerStore$removeById$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForClass(JsCredentialIssuerStore, "JsCredentialIssuerStore");
    initMetadataForClass(JsVerifiableCredentialStore, "JsVerifiableCredentialStore");
    initMetadataForClass(JsResolvedOffer, "JsResolvedOffer");
    initMetadataForClass(JsTxCode, "JsTxCode");
    initMetadataForClass(JsOfferResult, "JsOfferResult");
    initMetadataForLambda(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda, CoroutineImpl, VOID, [
        1
    ]);
    initMetadataForLambda(JsCredentialIssuanceCoordinator$startHandleOffer$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsCredentialIssuanceCoordinator$requestCredentials$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsCredentialIssuanceCoordinator, "JsCredentialIssuanceCoordinator");
    initMetadataForCompanion(Companion_11);
    initMetadataForClass(LocalStorageCredentialIssuerStore, "LocalStorageCredentialIssuerStore", LocalStorageCredentialIssuerStore, VOID, VOID, [
        1,
        0
    ]);
    initMetadataForCompanion(Companion_12);
    initMetadataForClass(LocalStorageVerifiableCredentialStore, "LocalStorageVerifiableCredentialStore");
    initMetadataForClass(JsValidatedRequestJwt, "JsValidatedRequestJwt");
    initMetadataForClass(JsPresentationDefinition, "JsPresentationDefinition");
    initMetadataForClass(JsFormat, "JsFormat");
    initMetadataForClass(JsAlgFormat, "JsAlgFormat");
    initMetadataForClass(JsProofTypeFormat, "JsProofTypeFormat");
    initMetadataForClass(JsInputDescriptor, "JsInputDescriptor");
    initMetadataForClass(JsConstraint, "JsConstraint");
    initMetadataForClass(JsField, "JsField");
    initMetadataForCompanion(Companion_13);
    initMetadataForClass(AbstractJsfilter, "AbstractJsfilter");
    initMetadataForClass(JsStringFilter, "JsStringFilter", VOID, AbstractJsfilter);
    initMetadataForClass(JsArrayContainsFilter, "JsArrayContainsFilter", VOID, AbstractJsfilter);
    initMetadataForClass(JsContains, "JsContains");
    initMetadataForClass(JsVerifiablePresentationResponseParameters, "JsVerifiablePresentationResponseParameters");
    initMetadataForClass(JsPresentationSubmission, "JsPresentationSubmission");
    initMetadataForClass(JsDescriptorMapObject, "JsDescriptorMapObject");
    initMetadataForClass(JsPathNested, "JsPathNested");
    initMetadataForClass(JsVerifierDirectPostAuthorizationResponse, "JsVerifierDirectPostAuthorizationResponse");
    initMetadataForClass(JsUserSelectedCredentials, "JsUserSelectedCredentials");
    initMetadataForClass(JsUserSelectedCredential, "JsUserSelectedCredential");
    initMetadataForClass(JsPresentationDisclosure, "JsPresentationDisclosure");
    initMetadataForCompanion(Companion_14);
    initMetadataForLambda(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsPresentationResponseCreator, "JsPresentationResponseCreator");
    initMetadataForClass(JsRequestJwtStore, "JsRequestJwtStore");
    initMetadataForLambda(JsVerifierClient$fetchRequestObjectJwt$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsVerifierClient$postDirectPostAuthorizationResponse$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsVerifierClient, "JsVerifierClient");
    initMetadataForCompanion(Companion_15);
    initMetadataForClass(LocalStorageRequestJwtStore, "LocalStorageRequestJwtStore");
    initMetadataForLambda(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsOpenIdWalletAuthenticatorCredentialFinder, "JsOpenIdWalletAuthenticatorCredentialFinder");
    initMetadataForClass(JsCredentialFinderResult, "JsCredentialFinderResult");
    initMetadataForLambda(JsPreRegisteredClientStore$getByClientId$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsPreRegisteredClientStore$upsert$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForLambda(JsPreRegisteredClientStore$getAll$slambda, CoroutineImpl, VOID, [
        0
    ]);
    initMetadataForClass(JsPreRegisteredClientStore, "JsPreRegisteredClientStore");
    initMetadataForClass(JsPreRegisteredClient, "JsPreRegisteredClient");
    initMetadataForClass(JsVpFormat, "JsVpFormat");
    //endregion
    function ProofOfPossessionBuilder() {}
    protoOf(ProofOfPossessionBuilder).z5x = function(signingKeyPair, kid, alg, iss, aud, iat, additionalClaims, $completion) {
        var tmp0_kid = kid.toString();
        var jwsHeader = new JsonJwsHeader(alg, "openid4vci-proof+jwt", VOID, VOID, VOID, tmp0_kid);
        var jwsPayload = new JsonJwtClaimsSet(iss, VOID, aud, VOID, VOID, iat.f1m(), VOID, VOID, additionalClaims);
        return JwsUtil_getInstance().j2d(signingKeyPair.u28_1, jwsHeader, jwsPayload, $completion);
    };
    protoOf(ProofOfPossessionBuilder).a5y = function(signingKeyPair, alg, iss, aud, iat, additionalClaims, $completion) {
        var tmp1_jwk = signingKeyPair.v28_1.u2f();
        var jwsHeader = new JsonJwsHeader(alg, "openid4vci-proof+jwt", VOID, VOID, tmp1_jwk);
        var jwsPayload = new JsonJwtClaimsSet(iss, VOID, aud, VOID, VOID, iat.f1m(), VOID, VOID, additionalClaims);
        return JwsUtil_getInstance().j2d(signingKeyPair.u28_1, jwsHeader, jwsPayload, $completion);
    };
    var ProofOfPossessionBuilder_instance;
    function ProofOfPossessionBuilder_getInstance() {
        return ProofOfPossessionBuilder_instance;
    }
    function Companion() {
        Companion_instance_8 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.b5y_1 = [
            null,
            null,
            new ArrayListSerializer(JsonSupportedCredentialSerializer_getInstance()),
            null
        ];
    }
    var Companion_instance_8;
    function Companion_getInstance_6() {
        if (Companion_instance_8 == null) new Companion();
        return Companion_instance_8;
    }
    function $serializer() {
        $serializer_instance = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.serialization.ResolvedOffer", this, 4);
        tmp0_serialDesc.wy("offer", false);
        tmp0_serialDesc.wy("issuer", false);
        tmp0_serialDesc.wy("credentialsSupported", false);
        tmp0_serialDesc.wy("txCode", true);
        this.c5y_1 = tmp0_serialDesc;
    }
    protoOf($serializer).d5y = function(encoder, value) {
        var tmp0_desc = this.c5y_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().b5y_1;
        tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance(), value.e5y_1);
        tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_0(), value.f5y_1);
        tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.g5y_1);
        var tmp;
        if (tmp1_output.ht(tmp0_desc, 3)) tmp = true;
        else {
            var tmp2_safe_receiver = value.e5y_1.j32_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
            tmp = !equals(value.h5y_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1);
        }
        if (tmp) tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_1(), value.h5y_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer).zn = function(encoder, value) {
        return this.d5y(encoder, value instanceof ResolvedOffer ? value : THROW_CCE());
    };
    protoOf($serializer).ao = function(decoder) {
        var tmp0_desc = this.c5y_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        var tmp9_cached = Companion_getInstance_6().b5y_1;
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.xr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.xr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.xr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.xr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return ResolvedOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer).yn = function() {
        return this.c5y_1;
    };
    protoOf($serializer).lz = function() {
        var tmp0_cached = Companion_getInstance_6().b5y_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            $serializer_getInstance(),
            $serializer_getInstance_0(),
            tmp0_cached[2],
            get_nullable($serializer_getInstance_1())
        ];
    };
    var $serializer_instance;
    function $serializer_getInstance_4() {
        if ($serializer_instance == null) new $serializer();
        return $serializer_instance;
    }
    function ResolvedOffer_init_$Init$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker, $this) {
        if (!(7 === (7 & seen0))) throwMissingFieldException(seen0, 7, $serializer_getInstance_4().c5y_1);
        $this.e5y_1 = offer;
        $this.f5y_1 = issuer;
        $this.g5y_1 = credentialsSupported;
        if (0 === (seen0 & 8)) {
            var tmp = $this;
            var tmp2_safe_receiver = $this.e5y_1.j32_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
            tmp.h5y_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1;
        } else $this.h5y_1 = txCode;
        return $this;
    }
    function ResolvedOffer_init_$Create$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker) {
        return ResolvedOffer_init_$Init$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker, objectCreate(protoOf(ResolvedOffer)));
    }
    function ResolvedOffer(offer, issuer, credentialsSupported) {
        Companion_getInstance_6();
        this.e5y_1 = offer;
        this.f5y_1 = issuer;
        this.g5y_1 = credentialsSupported;
        var tmp = this;
        var tmp2_safe_receiver = this.e5y_1.j32_1;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
        tmp.h5y_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1;
    }
    protoOf(ResolvedOffer).toString = function() {
        return "ResolvedOffer(offer=" + this.e5y_1.toString() + ", issuer=" + this.f5y_1.toString() + ", credentialsSupported=" + toString(this.g5y_1) + ")";
    };
    protoOf(ResolvedOffer).hashCode = function() {
        var result = this.e5y_1.hashCode();
        result = imul(result, 31) + this.f5y_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.g5y_1) | 0;
        return result;
    };
    protoOf(ResolvedOffer).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof ResolvedOffer)) return false;
        var tmp0_other_with_cast = other instanceof ResolvedOffer ? other : THROW_CCE();
        if (!this.e5y_1.equals(tmp0_other_with_cast.e5y_1)) return false;
        if (!this.f5y_1.equals(tmp0_other_with_cast.f5y_1)) return false;
        if (!equals(this.g5y_1, tmp0_other_with_cast.g5y_1)) return false;
        return true;
    };
    function requestCredentialsUsingPreAuthorizedCode($this, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, $completion) {
        var tmp = new $requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2($this, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function requestCredential($this, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, $completion) {
        var tmp = new $requestCredentialCOROUTINE$4($this, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function CredentialIssuanceCoordinator$startHandleOffer$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, CredentialIssuanceCoordinator$startHandleOffer$lambda$lambda);
        return Unit_instance;
    }
    function CredentialIssuanceCoordinator$startHandleOffer$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function CredentialIssuanceCoordinator$requestCredential$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, CredentialIssuanceCoordinator$requestCredential$lambda$lambda);
        return Unit_instance;
    }
    function CredentialIssuanceCoordinator$requestCredential$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function $startHandleOfferCOROUTINE$0(_this__u8e3s4, offerString, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.f60_1 = _this__u8e3s4;
        this.g60_1 = offerString;
    }
    protoOf($startHandleOfferCOROUTINE$0).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.h60_1 = URLBuilder(this.g60_1).c3r().d4h_1;
                    this.i60_1 = this.h60_1.l43("credential_offer");
                    this.j60_1 = this.h60_1.l43("credential_offer_uri");
                    if (!(this.i60_1 == null) && !(this.j60_1 == null)) throw Exception_init_$Create$("both 'credential_offer' and 'credential_offer_uri' are present");
                    if (!(this.j60_1 == null)) {
                        var tmp_0 = this;
                        var tmp4_safe_receiver = singleOrNull(this.j60_1);
                        var tmp_1;
                        if (tmp4_safe_receiver == null) tmp_1 = null;
                        else tmp_1 = URLBuilder(tmp4_safe_receiver).c3r();
                        var tmp0_elvis_lhs = tmp_1;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) throw Exception_init_$Create$("'credential_offer_uri' is empty or has more than one value");
                        else tmp_2 = tmp0_elvis_lhs;
                        tmp_0.l60_1 = tmp_2;
                        var tmp_3 = this;
                        tmp_3.m60_1 = HttpClient(this.f60_1.c61_1, CredentialIssuanceCoordinator$startHandleOffer$lambda);
                        var tmp_4 = this;
                        tmp_4.n60_1 = this.m60_1;
                        var tmp_5 = this;
                        tmp_5.o60_1 = this.l60_1;
                        var tmp_6 = this;
                        tmp_6.p60_1 = this.n60_1;
                        var tmp_7 = this;
                        tmp_7.q60_1 = this.p60_1;
                        var tmp_8 = this;
                        var this_0 = new HttpRequestBuilder();
                        takeFrom(this_0.m4t_1, this.o60_1);
                        tmp_8.r60_1 = this_0;
                        this.r60_1.n4t_1 = Companion_getInstance().n4d_1;
                        var tmp_9 = this;
                        tmp_9.s60_1 = this.q60_1;
                        var tmp_10 = this;
                        tmp_10.t60_1 = this.r60_1;
                        this.v8_1 = 1;
                        suspendResult = new HttpStatement(this.t60_1, this.s60_1).q5i(this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else if (!(this.i60_1 == null)) {
                        var tmp_11 = this;
                        var tmp5_safe_receiver = singleOrNull(this.i60_1);
                        var tmp_12;
                        if (tmp5_safe_receiver == null) tmp_12 = null;
                        else {
                            var this_1 = Default_getInstance();
                            var this_2 = this_1.dp();
                            var this_3 = serializer(this_2, createKType(getKClass(JsonOffer), arrayOf([]), false));
                            tmp_12 = this_1.cp(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), tmp5_safe_receiver);
                        }
                        var tmp1_elvis_lhs = tmp_12;
                        var tmp_13;
                        if (tmp1_elvis_lhs == null) throw Exception_init_$Create$("'credential_offer' is empty or has more than one value");
                        else tmp_13 = tmp1_elvis_lhs;
                        tmp_11.k60_1 = tmp_13;
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        var tmp_14 = this;
                        throw Exception_init_$Create$("both 'credential_offer' and 'credential_offer_uri' are missing");
                    }
                case 1:
                    this.u60_1 = suspendResult;
                    if (!(this.u60_1.y4v().h4g_1 === 200)) throw Exception_init_$Create$("Communication error while fetching the offer");
                    var tmp_15 = this;
                    tmp_15.v60_1 = this.u60_1;
                    this.v8_1 = 2;
                    var tmp_16 = this.v60_1.t4w();
                    var tmp_17 = JsType_instance;
                    var tmp_18 = getKClass(JsonOffer);
                    var tmp_19;
                    try {
                        tmp_19 = createKType(getKClass(JsonOffer), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_20;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_20 = null;
                        } else throw $p;
                        tmp_19 = tmp_20;
                    }
                    suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var tmp_21 = this;
                    tmp_21.k60_1 = suspendResult instanceof JsonOffer ? suspendResult : THROW_CCE();
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.w60_1 = this.k60_1;
                    this.x60_1 = this.w60_1.j32_1;
                    if (this.x60_1 == null || this.x60_1.c32_1 == null && this.x60_1.d32_1 == null) throw Exception_init_$Create$("Not enough grant information");
                    this.v8_1 = 4;
                    suspendResult = this.f60_1.d61_1.g61(this.w60_1.h32_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    var issuer = suspendResult;
                    var this_4 = this.w60_1.i32_1;
                    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
                    var tmp0_iterator = this_4.j();
                    while(tmp0_iterator.k()){
                        var item = tmp0_iterator.l();
                        var tmp0_elvis_lhs_0 = issuer.t32_1.t33_1.e2(item);
                        var tmp_22;
                        if (tmp0_elvis_lhs_0 == null) throw Exception_init_$Create$("Issue does not have supported Credential with ID '" + item + "'");
                        else tmp_22 = tmp0_elvis_lhs_0;
                        destination.e(tmp_22);
                    }
                    var credentialsSupported = destination;
                    var resolvedOffer = new ResolvedOffer(this.w60_1, issuer, credentialsSupported);
                    return resolvedOffer;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $continueHandleOfferCOROUTINE$1(_this__u8e3s4, resolvedOffer, credentialsSupported, code, signingKeyPair, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.p61_1 = _this__u8e3s4;
        this.q61_1 = resolvedOffer;
        this.r61_1 = credentialsSupported;
        this.s61_1 = code;
        this.t61_1 = signingKeyPair;
    }
    protoOf($continueHandleOfferCOROUTINE$1).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.u61_1 = this.q61_1.e5y_1;
                    this.v61_1 = this.u61_1.j32_1;
                    if (this.v61_1 == null || this.v61_1.c32_1 == null && this.v61_1.d32_1 == null) throw Exception_init_$Create$("Not enough grant information");
                    if (!(this.q61_1.h5y_1 == null) && this.s61_1 == null) throw Exception_init_$Create$("User code is required");
                    this.w61_1 = this.v61_1.d32_1;
                    if (!(this.w61_1 == null) && (this.w61_1.x31_1 == null || !(this.s61_1 == null))) {
                        this.v8_1 = 2;
                        suspendResult = requestCredentialsUsingPreAuthorizedCode(this.p61_1, this.q61_1.f5y_1, first(this.r61_1), this.w61_1.w31_1, this.s61_1, this.t61_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else if (!(this.v61_1.c32_1 == null)) {
                        this.v8_1 = 1;
                        suspendResult = this.p61_1.y61(this.q61_1.f5y_1, first(this.r61_1), this.t61_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_0 = this;
                        throw Exception_init_$Create$("No grant available");
                    }
                case 1:
                    var ARGUMENT = suspendResult;
                    this.x61_1 = new IssuedCredentials(ARGUMENT);
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.x61_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.x61_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2(_this__u8e3s4, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.q5y_1 = _this__u8e3s4;
        this.r5y_1 = issuer;
        this.s5y_1 = credentialSupported;
        this.t5y_1 = preAuthorizedCode;
        this.u5y_1 = code;
        this.v5y_1 = signingKeyPair;
    }
    protoOf($requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.w5y_1 = new OAuthPreAuthorizedCodeFlowClient(this.q5y_1.c61_1, this.q5y_1.z60_1, this.r5y_1.u32_1.t35_1);
                    this.v8_1 = 1;
                    suspendResult = this.w5y_1.j5x(this.t5y_1, this.u5y_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.x5y_1 = suspendResult;
                    var tmp_0 = this.x5y_1;
                    if (tmp_0 instanceof JsonOAuthSuccessTokenResponse) {
                        this.z5y_1 = new OAuthRefreshFlowClient(this.q5y_1.c61_1, this.q5y_1.z60_1, this.r5y_1.u32_1.t35_1);
                        this.v8_1 = 2;
                        suspendResult = requestCredential(this.q5y_1, this.x5y_1, this.z5y_1, this.r5y_1, this.v5y_1, this.s5y_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_1 = this.x5y_1;
                        if (tmp_1 instanceof JsonOAuthErrorTokenResponse) {
                            var tmp_2 = this;
                            var tmp_3;
                            if (this.x5y_1.c5v_1 === "invalid_grant") tmp_3 = InvalidOfferOrUserCode_getInstance();
                            else throw Exception_init_$Create$("Unexpected error when using the pre-authorized code flow: " + this.x5y_1.c5v_1);
                            tmp_2.y5y_1 = tmp_3;
                            this.v8_1 = 3;
                            continue $sm;
                        } else {
                            var tmp_4 = this;
                            noWhenBranchMatchedException();
                        }
                    }
                    break;
                case 2:
                    var ARGUMENT = suspendResult;
                    this.y5y_1 = new IssuedCredentials(ARGUMENT);
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.y5y_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialsCOROUTINE$3(_this__u8e3s4, issuer, credentialSupported, signingKeyPair, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h62_1 = _this__u8e3s4;
        this.i62_1 = issuer;
        this.j62_1 = credentialSupported;
        this.k62_1 = signingKeyPair;
    }
    protoOf($requestCredentialsCOROUTINE$3).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    var tmp6_subject = this.j62_1;
                    var tmp_1;
                    if (tmp6_subject instanceof JwtVcJsonCredentialConfigurationsSupported) {
                        var this_0 = this.h62_1.f61_1;
                        var value = listOf(JwtVcJsonAuthorizationDetail_init_$Create$(toSet(this.j62_1.i39_1.s39_1), null));
                        var this_1 = this_0.dp();
                        var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([
                            createInvariantKTypeProjection(createKType(getKClass(JwtVcJsonAuthorizationDetail), arrayOf([]), false))
                        ]), false));
                        tmp_1 = this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
                    } else {
                        if (tmp6_subject instanceof VcSdJwtCredentialConfigurationsSupported) {
                            var this_3 = this.h62_1.f61_1;
                            var value_0 = listOf(VcSdJwtAuthorizationDetail_init_$Create$(this.j62_1.n37_1, null));
                            var this_4 = this_3.dp();
                            var this_5 = serializer(this_4, createKType(getKClass(KtList), arrayOf([
                                createInvariantKTypeProjection(createKType(getKClass(VcSdJwtAuthorizationDetail), arrayOf([]), false))
                            ]), false));
                            tmp_1 = this_3.bp(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), value_0);
                        } else throw Exception_init_$Create$("Format '" + this.j62_1.z33() + "' is not supported");
                    }
                    tmp_0.l62_1 = tmp_1;
                    var tmp_2 = this;
                    var tmp7_clientId = this.h62_1.z60_1.id;
                    var tmp8_redirectUri = this.h62_1.z60_1.redirectUri;
                    var tmp9_state = encodeBase64url(Default_getInstance_0().fh(16));
                    tmp_2.m62_1 = new OAuthAuthorizationRequest(tmp7_clientId, this.l62_1, VOID, tmp9_state, tmp8_redirectUri);
                    this.v8_1 = 1;
                    suspendResult = this.h62_1.b61_1.s62(this.i62_1.u32_1.s35_1, this.m62_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.n62_1 = suspendResult;
                    if (!(this.n62_1.state === this.m62_1.state)) throw Exception_init_$Create$("Authorization response state is not valid.");
                    var tmp_3 = this;
                    var tmp0_elvis_lhs = this.n62_1.code;
                    var tmp_4;
                    if (tmp0_elvis_lhs == null) throw Exception_init_$Create$("authorization response is missing a code");
                    else tmp_4 = tmp0_elvis_lhs;
                    tmp_3.o62_1 = tmp_4;
                    this.p62_1 = new OAuthCodeFlowClient(this.h62_1.c61_1, this.h62_1.z60_1, this.i62_1.u32_1.t35_1);
                    this.q62_1 = new OAuthRefreshFlowClient(this.h62_1.c61_1, this.h62_1.z60_1, this.i62_1.u32_1.t35_1);
                    this.v8_1 = 2;
                    suspendResult = this.p62_1.p5w(this.o62_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.r62_1 = suspendResult;
                    this.v8_1 = 3;
                    suspendResult = requestCredential(this.h62_1, this.r62_1, this.q62_1, this.i62_1, this.k62_1, this.j62_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    return suspendResult;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialCOROUTINE$4(_this__u8e3s4, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.i5z_1 = _this__u8e3s4;
        this.j5z_1 = tokenResponse;
        this.k5z_1 = refreshFlowClient;
        this.l5z_1 = issuer;
        this.m5z_1 = signingKeyPair;
        this.n5z_1 = credentialSupported;
    }
    protoOf($requestCredentialCOROUTINE$4).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 7;
                    var tmp_0 = this;
                    var tmp0_elvis_lhs = this.j5z_1.w5u_1;
                    var tmp_1;
                    if (tmp0_elvis_lhs == null) throw Exception_init_$Create$("token response is missing the c_nonce");
                    else tmp_1 = tmp0_elvis_lhs;
                    tmp_0.o5z_1 = tmp_1;
                    var tmp_2 = this;
                    tmp_2.p5z_1 = HttpClient(this.i5z_1.c61_1, CredentialIssuanceCoordinator$requestCredential$lambda);
                    installOAuthSupport(this.p5z_1, this.j5z_1, this.k5z_1);
                    this.q5z_1 = this.n5z_1;
                    var tmp_3 = this.q5z_1;
                    if (tmp_3 instanceof JwtVcJsonCredentialConfigurationsSupported) {
                        this.v8_1 = 2;
                        suspendResult = ProofOfPossessionBuilder_instance.z5x(this.m5z_1, JwkDid_instance.w3l(this.m5z_1.v28_1), "ES256", this.i5z_1.z60_1.id, DefaultJsonMultiValue_init_$Create$(this.l5z_1.t32_1.u33_1), this.i5z_1.y60_1.u1l(), mapOf(to("nonce", JsonPrimitive(this.o5z_1))), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_4 = this.q5z_1;
                        if (tmp_4 instanceof VcSdJwtCredentialConfigurationsSupported) {
                            this.v8_1 = 1;
                            suspendResult = ProofOfPossessionBuilder_instance.a5y(this.m5z_1, "ES256", this.i5z_1.z60_1.id, DefaultJsonMultiValue_init_$Create$(this.l5z_1.t32_1.u33_1), this.i5z_1.y60_1.u1l(), mapOf(to("nonce", JsonPrimitive(this.o5z_1))), this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_5 = this;
                            throw Exception_init_$Create$("Unsupported supported credential " + getKClassFromExpression(this.n5z_1).fa());
                        }
                    }
                case 1:
                    this.r5z_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.r5z_1 = suspendResult;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.s5z_1 = this.r5z_1;
                    this.t5z_1 = this.n5z_1;
                    var tmp_6 = this.t5z_1;
                    if (tmp_6 instanceof JwtVcJsonCredentialConfigurationsSupported) {
                        this.v5z_1 = new VcClient(this.p5z_1, this.l5z_1.t32_1, new DidSubjectVerifiableCredentialResponseValidator(this.l5z_1, JwkDid_instance.w3l(this.m5z_1.v28_1), VOID, this.n5z_1, this.i5z_1.a61_1));
                        this.v8_1 = 5;
                        var tmp12_credentialDefinition = new CredentialDefinition(this.n5z_1.i39_1.s39_1);
                        var tmp13_proof = new JsonProofOfPossession("jwt", new JsonDictionary(mapOf(to("jwt", JsonPrimitive(this.s5z_1)))));
                        suspendResult = this.v5z_1.y62(new JwtVcJsonVerifiableCredentialRequest(tmp13_proof, tmp12_credentialDefinition), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_7 = this.t5z_1;
                        if (tmp_7 instanceof VcSdJwtCredentialConfigurationsSupported) {
                            this.w5z_1 = new VcClient(this.p5z_1, this.l5z_1.t32_1, new VcSdJwtVerifiableCredentialResponseValidator(this.i5z_1.y60_1, this.i5z_1.e61_1, this.l5z_1, this.n5z_1, this.m5z_1));
                            this.v8_1 = 4;
                            var tmp14_vct = this.n5z_1.n37_1;
                            var tmp15_proof = new JsonProofOfPossession("jwt", new JsonDictionary(mapOf(to("jwt", JsonPrimitive(this.s5z_1)))));
                            suspendResult = this.w5z_1.x62(new VcSdJwtVerifiableCredentialRequest(tmp15_proof, tmp14_vct), this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_8 = this;
                            throw Exception_init_$Create$("Unsupported credential " + getKClassFromExpression(this.n5z_1).fa());
                        }
                    }
                case 4:
                    this.u5z_1 = suspendResult;
                    this.v8_1 = 6;
                    continue $sm;
                case 5:
                    this.u5z_1 = suspendResult;
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    var validatedResponse = this.u5z_1;
                    var tmp16_localId = Companion_getInstance_0().x32();
                    var tmp17_issuerId = this.l5z_1.t32_1.u33_1;
                    var tmp18_issuedAt = System_instance.u1l();
                    return listOf(new UserVerifiableCredential(tmp16_localId, tmp17_issuerId, tmp18_issuedAt, "", validatedResponse));
                case 7:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 7) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function CredentialIssuanceCoordinator(clock, oAuthClient, didResolver, oAuthAuthorizer, httpClientEngine, issuerLoader, vcSdJwtIssuerMetadataLoader) {
        this.y60_1 = clock;
        this.z60_1 = oAuthClient;
        this.a61_1 = didResolver;
        this.b61_1 = oAuthAuthorizer;
        this.c61_1 = httpClientEngine;
        this.d61_1 = issuerLoader;
        this.e61_1 = vcSdJwtIssuerMetadataLoader;
        this.f61_1 = Default_getInstance();
    }
    protoOf(CredentialIssuanceCoordinator).z62 = function(offerString, $completion) {
        var tmp = new $startHandleOfferCOROUTINE$0(this, offerString, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(CredentialIssuanceCoordinator).a63 = function(resolvedOffer, credentialsSupported, code, signingKeyPair, $completion) {
        var tmp = new $continueHandleOfferCOROUTINE$1(this, resolvedOffer, credentialsSupported, code, signingKeyPair, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(CredentialIssuanceCoordinator).y61 = function(issuer, credentialSupported, signingKeyPair, $completion) {
        var tmp = new $requestCredentialsCOROUTINE$3(this, issuer, credentialSupported, signingKeyPair, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function IssuedCredentials(credentials) {
        OfferResult.call(this);
        this.b63_1 = credentials;
    }
    protoOf(IssuedCredentials).toString = function() {
        return "IssuedCredentials(credentials=" + toString(this.b63_1) + ")";
    };
    protoOf(IssuedCredentials).hashCode = function() {
        return hashCode(this.b63_1);
    };
    protoOf(IssuedCredentials).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof IssuedCredentials)) return false;
        var tmp0_other_with_cast = other instanceof IssuedCredentials ? other : THROW_CCE();
        if (!equals(this.b63_1, tmp0_other_with_cast.b63_1)) return false;
        return true;
    };
    function InvalidOfferOrUserCode() {
        InvalidOfferOrUserCode_instance = this;
        OfferResult.call(this);
    }
    protoOf(InvalidOfferOrUserCode).toString = function() {
        return "InvalidOfferOrUserCode";
    };
    protoOf(InvalidOfferOrUserCode).hashCode = function() {
        return -1674259812;
    };
    protoOf(InvalidOfferOrUserCode).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof InvalidOfferOrUserCode)) return false;
        other instanceof InvalidOfferOrUserCode || THROW_CCE();
        return true;
    };
    var InvalidOfferOrUserCode_instance;
    function InvalidOfferOrUserCode_getInstance() {
        if (InvalidOfferOrUserCode_instance == null) new InvalidOfferOrUserCode();
        return InvalidOfferOrUserCode_instance;
    }
    function OfferResult() {}
    function metadataUrlForIssuerId($this, id) {
        var idUrl = URLBuilder(id).c3r();
        if (!idUrl.z4g_1.equals(Companion_getInstance_1().r4h_1)) throw Exception_init_$Create$("Invalid Issuer identifier - must use HTTPS");
        // Inline function 'kotlin.apply' call
        var this_0 = URLBuilder_0(idUrl);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.Companion.metadataUrlForIssuerId.<anonymous>' call
        this_0.a4i(plus(this_0.b4i(), Companion_getInstance_7().c63_1));
        return this_0.c3r();
    }
    function metadataUrlForAuthorizationServerId($this, id) {
        var idUrl = URLBuilder(id).c3r();
        if (!idUrl.z4g_1.equals(Companion_getInstance_1().r4h_1)) throw Exception_init_$Create$("Invalid Authorization Server identifier - must use HTTPS");
        // Inline function 'kotlin.apply' call
        var this_0 = URLBuilder_0(idUrl);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.Companion.metadataUrlForAuthorizationServerId.<anonymous>' call
        this_0.a4i(plus(Companion_getInstance_7().d63_1, removeTrailingEmptySegments(Companion_getInstance_7(), this_0.b4i())));
        return this_0.c3r();
    }
    function removeTrailingEmptySegments($this, segments) {
        var tmp$ret$0;
        $l$block_1: {
            // Inline function 'kotlin.collections.takeLastWhile' call
            if (segments.s()) {
                tmp$ret$0 = emptyList();
                break $l$block_1;
            }
            var iterator = segments.w(segments.m());
            while(iterator.s4()){
                // Inline function 'io.curity.vc.services.Companion.removeTrailingEmptySegments.<anonymous>' call
                // Inline function 'kotlin.text.isNotBlank' call
                var this_0 = iterator.u4();
                if (!!isBlank(this_0)) {
                    iterator.l();
                    var expectedSize = segments.m() - iterator.t4() | 0;
                    if (expectedSize === 0) {
                        tmp$ret$0 = emptyList();
                        break $l$block_1;
                    }
                    // Inline function 'kotlin.apply' call
                    var this_1 = ArrayList_init_$Create$(expectedSize);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'kotlin.collections.takeLastWhile.<anonymous>' call
                    while(iterator.k())this_1.e(iterator.l());
                    tmp$ret$0 = this_1;
                    break $l$block_1;
                }
            }
            tmp$ret$0 = toList(segments);
        }
        return tmp$ret$0;
    }
    function Companion_0() {
        Companion_instance_9 = this;
        this.c63_1 = listOf_0([
            ".well-known",
            "openid-credential-issuer"
        ]);
        this.d63_1 = listOf_0([
            ".well-known",
            "oauth-authorization-server"
        ]);
    }
    var Companion_instance_9;
    function Companion_getInstance_7() {
        if (Companion_instance_9 == null) new Companion_0();
        return Companion_instance_9;
    }
    function $loadCOROUTINE$5(_this__u8e3s4, issuerId, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.m63_1 = _this__u8e3s4;
        this.n63_1 = issuerId;
    }
    protoOf($loadCOROUTINE$5).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.o63_1 = metadataUrlForIssuerId(Companion_getInstance_7(), this.n63_1);
                    var tmp_0 = this;
                    tmp_0.p63_1 = this.m63_1.m64_1;
                    var tmp_1 = this;
                    tmp_1.q63_1 = this.o63_1;
                    var tmp_2 = this;
                    tmp_2.r63_1 = this.p63_1;
                    var tmp_3 = this;
                    tmp_3.s63_1 = this.r63_1;
                    var tmp_4 = this;
                    var this_0 = new HttpRequestBuilder();
                    takeFrom(this_0.m4t_1, this.q63_1);
                    tmp_4.t63_1 = this_0;
                    this.t63_1.n4t_1 = Companion_getInstance().n4d_1;
                    var tmp_5 = this;
                    tmp_5.u63_1 = this.s63_1;
                    var tmp_6 = this;
                    tmp_6.v63_1 = this.t63_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.v63_1, this.u63_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.w63_1 = suspendResult;
                    var tmp_7 = this;
                    tmp_7.x63_1 = this.w63_1;
                    if (!isSuccess(this.x63_1.y4v())) throw Exception_init_$Create$("Error " + this.x63_1.y4v().h4g_1 + " while accessing " + this.o63_1.toString());
                    var tmp_8 = this;
                    tmp_8.y63_1 = this.x63_1;
                    this.v8_1 = 2;
                    var tmp_9 = this.y63_1.t4w();
                    var tmp_10 = JsType_instance;
                    var tmp_11 = getKClass(JsonCredentialIssuerMetadata);
                    var tmp_12;
                    try {
                        tmp_12 = createKType(getKClass(JsonCredentialIssuerMetadata), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_13;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_13 = null;
                        } else throw $p;
                        tmp_12 = tmp_13;
                    }
                    suspendResult = tmp_9.x4v(typeInfoImpl(tmp_10, tmp_11, tmp_12), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var tmp_14 = this;
                    tmp_14.z63_1 = suspendResult instanceof JsonCredentialIssuerMetadata ? suspendResult : THROW_CCE();
                    var tmp_15 = this;
                    var tmp_16 = Companion_getInstance_7();
                    var tmp19_safe_receiver = this.z63_1.o33_1;
                    var tmp0_elvis_lhs = tmp19_safe_receiver == null ? null : getOrNull(tmp19_safe_receiver, 0);
                    tmp_15.a64_1 = metadataUrlForAuthorizationServerId(tmp_16, tmp0_elvis_lhs == null ? this.z63_1.u33_1 : tmp0_elvis_lhs);
                    var tmp_17 = this;
                    tmp_17.b64_1 = this.m63_1.m64_1;
                    var tmp_18 = this;
                    tmp_18.c64_1 = this.a64_1;
                    var tmp_19 = this;
                    tmp_19.d64_1 = this.b64_1;
                    var tmp_20 = this;
                    tmp_20.e64_1 = this.d64_1;
                    var tmp_21 = this;
                    var this_1 = new HttpRequestBuilder();
                    takeFrom(this_1.m4t_1, this.c64_1);
                    tmp_21.f64_1 = this_1;
                    this.f64_1.n4t_1 = Companion_getInstance().n4d_1;
                    var tmp_22 = this;
                    tmp_22.g64_1 = this.e64_1;
                    var tmp_23 = this;
                    tmp_23.h64_1 = this.f64_1;
                    this.v8_1 = 3;
                    suspendResult = new HttpStatement(this.h64_1, this.g64_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    this.i64_1 = suspendResult;
                    var tmp_24 = this;
                    tmp_24.j64_1 = this.i64_1;
                    if (!isSuccess(this.j64_1.y4v())) throw Exception_init_$Create$("Error " + this.j64_1.y4v().h4g_1 + " while accessing " + this.a64_1.toString());
                    var tmp_25 = this;
                    tmp_25.k64_1 = this.j64_1;
                    this.v8_1 = 4;
                    var tmp_26 = this.k64_1.t4w();
                    var tmp_27 = JsType_instance;
                    var tmp_28 = getKClass(JsonOAuthMetadata);
                    var tmp_29;
                    try {
                        tmp_29 = createKType(getKClass(JsonOAuthMetadata), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_30;
                        if ($p instanceof Error) {
                            var cause_0 = $p;
                            tmp_30 = null;
                        } else throw $p;
                        tmp_29 = tmp_30;
                    }
                    suspendResult = tmp_26.x4v(typeInfoImpl(tmp_27, tmp_28, tmp_29), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    var authorizationServerMetadata = suspendResult instanceof JsonOAuthMetadata ? suspendResult : THROW_CCE();
                    var now = this.m63_1.l64_1.u1l();
                    return new JsonCredentialIssuer(this.z63_1, authorizationServerMetadata, now);
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function DefaultCredentialIssuerLoader(clock, client) {
        Companion_getInstance_7();
        clock = clock === VOID ? System_instance : clock;
        this.l64_1 = clock;
        this.m64_1 = client;
    }
    protoOf(DefaultCredentialIssuerLoader).g61 = function(issuerId, $completion) {
        var tmp = new $loadCOROUTINE$5(this, issuerId, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function removeTrailingEmptySegments_0($this, segments) {
        var tmp$ret$0;
        $l$block_1: {
            // Inline function 'kotlin.collections.takeLastWhile' call
            if (segments.s()) {
                tmp$ret$0 = emptyList();
                break $l$block_1;
            }
            var iterator = segments.w(segments.m());
            while(iterator.s4()){
                // Inline function 'io.curity.vc.services.Companion.removeTrailingEmptySegments.<anonymous>' call
                // Inline function 'kotlin.text.isNotBlank' call
                var this_0 = iterator.u4();
                if (!!isBlank(this_0)) {
                    iterator.l();
                    var expectedSize = segments.m() - iterator.t4() | 0;
                    if (expectedSize === 0) {
                        tmp$ret$0 = emptyList();
                        break $l$block_1;
                    }
                    // Inline function 'kotlin.apply' call
                    var this_1 = ArrayList_init_$Create$(expectedSize);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'kotlin.collections.takeLastWhile.<anonymous>' call
                    while(iterator.k())this_1.e(iterator.l());
                    tmp$ret$0 = this_1;
                    break $l$block_1;
                }
            }
            tmp$ret$0 = toList(segments);
        }
        return tmp$ret$0;
    }
    function Companion_1() {}
    var Companion_instance_10;
    function Companion_getInstance_8() {
        return Companion_instance_10;
    }
    function $getCOROUTINE$6(_this__u8e3s4, issuerId, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v64_1 = _this__u8e3s4;
        this.w64_1 = issuerId;
    }
    protoOf($getCOROUTINE$6).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.x64_1 = Url(this.w64_1);
                    var tmp_0 = this;
                    var this_0 = URLBuilder_0(this.x64_1);
                    this_0.a4i(plus(listOf_0([
                        ".well-known",
                        "jwt-vc-issuer"
                    ]), removeTrailingEmptySegments_0(Companion_instance_10, this_0.b4i())));
                    tmp_0.y64_1 = this_0.c3r();
                    var tmp_1 = this;
                    tmp_1.z64_1 = this.v64_1.j65_1;
                    var tmp_2 = this;
                    tmp_2.a65_1 = this.y64_1;
                    var tmp_3 = this;
                    tmp_3.b65_1 = this.z64_1;
                    var tmp_4 = this;
                    tmp_4.c65_1 = this.b65_1;
                    var tmp_5 = this;
                    var this_1 = new HttpRequestBuilder();
                    takeFrom(this_1.m4t_1, this.a65_1);
                    tmp_5.d65_1 = this_1;
                    this.d65_1.n4t_1 = Companion_getInstance().n4d_1;
                    var tmp_6 = this;
                    tmp_6.e65_1 = this.c65_1;
                    var tmp_7 = this;
                    tmp_7.f65_1 = this.d65_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.f65_1, this.e65_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.g65_1 = suspendResult;
                    if (this.g65_1.y4v().h4g_1 >= 400) {
                        var tmp_8 = this;
                        tmp_8.h65_1 = this.g65_1;
                        this.v8_1 = 4;
                        var tmp_9 = this.h65_1.t4w();
                        var tmp_10 = JsType_instance;
                        var tmp_11 = PrimitiveClasses_getInstance().gb();
                        var tmp_12;
                        try {
                            tmp_12 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_13;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_13 = null;
                            } else throw $p;
                            tmp_12 = tmp_13;
                        }
                        suspendResult = tmp_9.x4v(typeInfoImpl(tmp_10, tmp_11, tmp_12), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    var tmp_14 = this;
                    tmp_14.i65_1 = this.g65_1;
                    this.v8_1 = 3;
                    var tmp_15 = this.i65_1.t4w();
                    var tmp_16 = JsType_instance;
                    var tmp_17 = getKClass(JsonVcSdJwtIssuerMetadata);
                    var tmp_18;
                    try {
                        tmp_18 = createKType(getKClass(JsonVcSdJwtIssuerMetadata), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_19;
                        if ($p instanceof Error) {
                            var cause_0 = $p;
                            tmp_19 = null;
                        } else throw $p;
                        tmp_18 = tmp_19;
                    }
                    suspendResult = tmp_15.x4v(typeInfoImpl(tmp_16, tmp_17, tmp_18), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    return suspendResult instanceof JsonVcSdJwtIssuerMetadata ? suspendResult : THROW_CCE();
                case 4:
                    var body = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    throw Exception_init_$Create$("Issuer metadata request for " + this.w64_1 + " with non-success status response: " + this.g65_1.y4v().h4g_1 + ", " + body);
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function DefaultVcSdJwtIssuerMetadataLoader(httpClient) {
        this.j65_1 = httpClient;
    }
    protoOf(DefaultVcSdJwtIssuerMetadataLoader).s2y = function(issuerId, $completion) {
        var tmp = new $getCOROUTINE$6(this, issuerId, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function DidSubjectVerifiableCredentialResponseValidator(issuer, didSubjectIdentifier, clock, supportedCredential, didResolver) {
        clock = clock === VOID ? System_instance : clock;
        this.k65_1 = issuer;
        this.l65_1 = didSubjectIdentifier;
        this.m65_1 = clock;
        this.n65_1 = supportedCredential;
        this.o65_1 = didResolver;
    }
    protoOf(DidSubjectVerifiableCredentialResponseValidator).p65 = function(response, $completion) {
        var validator = new JwtVcJsonCredentialWithDidSubjectValidator(this.k65_1, this.l65_1, this.m65_1, this.n65_1, this.o65_1);
        return validator.v65(response, $completion);
    };
    protoOf(DidSubjectVerifiableCredentialResponseValidator).w65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
    };
    protoOf(DidSubjectVerifiableCredentialResponseValidator).x65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
    };
    protoOf(DidSubjectVerifiableCredentialResponseValidator).y65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
    };
    function ifNull(_this__u8e3s4, $this, action) {
        if (_this__u8e3s4 == null) action();
        return _this__u8e3s4;
    }
    function validateHeader(_this__u8e3s4, $this, header) {
        var tmp22_safe_receiver = header.s29_1;
        var tmp;
        if (tmp22_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validateHeader.<anonymous>' call
            var tmp_0 = Companion_getInstance_2().d2i(tmp22_safe_receiver);
            var tmp_1 = Companion_instance_11;
            tmp = ifNull(tmp_0, tmp_1, JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda(_this__u8e3s4));
        }
        var tmp_2 = tmp;
        var tmp_3 = Companion_instance_11;
        return ifNull(tmp_2, tmp_3, JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda_0(_this__u8e3s4));
    }
    function validatePayload(_this__u8e3s4, $this, payload) {
        var w3cCredential = JwtCredentialValidationHelper_instance.z65(_this__u8e3s4, payload, $this.r65_1, $this.s65_1);
        var tmp23_safe_receiver = $this.t65_1.i39_1.t39_1;
        var tmp24_safe_receiver = tmp23_safe_receiver == null ? null : tmp23_safe_receiver.u39_1;
        var tmp25_safe_receiver = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.z();
        var tmp;
        if (tmp25_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.collections.mapNotNull' call
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var destination = ArrayList_init_$Create$_0();
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator = tmp25_safe_receiver.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
                // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validatePayload.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key = element.a1();
                // Inline function 'kotlin.collections.component2' call
                var value = element.b1();
                var valueDisplay = value.x39_1;
                var tmp_0;
                if (!(valueDisplay == null)) tmp_0 = to(key, valueDisplay);
                else tmp_0 = null;
                var tmp0_safe_receiver = tmp_0;
                if (tmp0_safe_receiver == null) ;
                else // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                destination.e(tmp0_safe_receiver);
            }
            tmp = destination;
        }
        var tmp26_safe_receiver = tmp;
        var tmp_1;
        if (tmp26_safe_receiver == null) tmp_1 = null;
        else {
            // Inline function 'kotlin.collections.associate' call
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp26_safe_receiver, 10)), 16);
            // Inline function 'kotlin.collections.associateTo' call
            var destination_0 = LinkedHashMap_init_$Create$(capacity);
            var tmp0_iterator_0 = tmp26_safe_receiver.j();
            while(tmp0_iterator_0.k()){
                var element_0 = tmp0_iterator_0.l();
                // Inline function 'kotlin.collections.plusAssign' call
                // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validatePayload.<anonymous>' call
                var key_0 = element_0.ba();
                var value_0 = element_0.ca();
                var pair = to(key_0, value_0);
                destination_0.m2(pair.z9_1, pair.aa_1);
            }
            tmp_1 = destination_0;
        }
        var tmp0_elvis_lhs = tmp_1;
        var subjectDisplayInformation = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp_2;
        if (_this__u8e3s4.qn_1 && !(w3cCredential == null)) tmp_2 = to(w3cCredential, subjectDisplayInformation);
        else tmp_2 = null;
        return tmp_2;
    }
    function Companion_2() {}
    var Companion_instance_11;
    function Companion_getInstance_9() {
        return Companion_instance_11;
    }
    function JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda($response, this$0, resultContinuation) {
        this.i66_1 = $response;
        this.j66_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).w66 = function($this$suspendableValidationScope, $completion) {
        var tmp = this.x66($this$suspendableValidationScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).y9 = function(p1, $completion) {
        return this.w66(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    var tmp_0 = this;
                    var tmp20_subject = this.i66_1;
                    var tmp_1;
                    if (tmp20_subject instanceof Deferred) {
                        var message = "Cannot handle deferred response";
                        throw IllegalStateException_init_$Create$(toString(message));
                    } else if (tmp20_subject instanceof JwtVcJsonVerifiableCredentialResponse) tmp_1 = this.i66_1.n38();
                    else noWhenBranchMatchedException();
                    tmp_0.l66_1 = tmp_1;
                    this.m66_1 = JwsUtil_getInstance().r2a(this.l66_1.o2h_1);
                    var tmp_2 = this;
                    var header = this.m66_1.j29_1;
                    var tmp_3;
                    if (header == null) {
                        this.k66_1.vn("JWS Header is missing");
                        tmp_3 = null;
                    } else tmp_3 = validateHeader(this.k66_1, this.j66_1, header);
                    tmp_2.n66_1 = tmp_3;
                    this.o66_1 = validatePayload(this.k66_1, this.j66_1, this.m66_1.k29_1);
                    if (this.o66_1 == null) {
                        this.p66_1 = null;
                        this.v8_1 = 4;
                        continue $sm;
                    } else {
                        var tmp_4 = this;
                        tmp_4.q66_1 = this.o66_1;
                        var tmp_5 = this;
                        tmp_5.r66_1 = this.q66_1;
                        this.s66_1 = this.r66_1.ba();
                        this.t66_1 = this.r66_1.ca();
                        if (this.k66_1.qn_1 && !(this.n66_1 == null)) {
                            this.v8_1 = 1;
                            suspendResult = JwtCredentialValidationHelper_instance.y66(this.k66_1, this.l66_1.o2h_1, this.n66_1, this.j66_1.u65_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_6 = this;
                            tmp_6.u66_1 = null;
                            this.v8_1 = 3;
                            continue $sm;
                        }
                    }
                case 1:
                    var ARGUMENT = suspendResult;
                    if (!ARGUMENT) {
                        var tmp_7 = this;
                        this.k66_1.vn("Unable to validate signature");
                        tmp_7.v66_1 = null;
                        this.v8_1 = 2;
                        continue $sm;
                    } else {
                        var tmp_8 = this;
                        tmp_8.v66_1 = new DidValidatedJwtVcJsonCredentialResponse(this.i66_1, this.l66_1.o2h_1, this.s66_1, this.t66_1, this.j66_1.t65_1.k39_1);
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.u66_1 = this.v66_1;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.p66_1 = this.u66_1;
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    return this.p66_1;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).x66 = function($this$suspendableValidationScope, completion) {
        var i = new JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda(this.i66_1, this.j66_1, completion);
        i.k66_1 = $this$suspendableValidationScope;
        return i;
    };
    function JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda_0($response, this$0, resultContinuation) {
        var i = new JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda($response, this$0, resultContinuation);
        var l = function($this$suspendableValidationScope, $completion) {
            return i.w66($this$suspendableValidationScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda($this_validateHeader) {
        return function() {
            $this_validateHeader.vn("JWE 'kid' is not a valid DID URL");
            return Unit_instance;
        };
    }
    function JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda_0($this_validateHeader) {
        return function() {
            $this_validateHeader.vn("JWE 'kid' claim is missing");
            return Unit_instance;
        };
    }
    function $validateCOROUTINE$7(_this__u8e3s4, response, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.h67_1 = _this__u8e3s4;
        this.i67_1 = response;
    }
    protoOf($validateCOROUTINE$7).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = suspendableValidationScope(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda_0(this.i67_1, this.h67_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return ARGUMENT.xm();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function JwtVcJsonCredentialWithDidSubjectValidator(issuer, didSubjectIdentifier, clock, supportedCredential, didResolver) {
        this.q65_1 = issuer;
        this.r65_1 = didSubjectIdentifier;
        this.s65_1 = clock;
        this.t65_1 = supportedCredential;
        this.u65_1 = didResolver;
    }
    protoOf(JwtVcJsonCredentialWithDidSubjectValidator).v65 = function(response, $completion) {
        var tmp = new $validateCOROUTINE$7(this, response, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function validateVcClaim(_this__u8e3s4, $this, vc, iss, sub, jti, iat, exp, didSubjectIdentifier) {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var typeList = vc.v3b_1;
        _this__u8e3s4.sn("type contains 'VerifiableCredential'", JwtCredentialValidationHelper$validateVcClaim$lambda(typeList));
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var vcIssuer = vc.e3c();
        _this__u8e3s4.sn("vc.issuer matches jwt.issuer", JwtCredentialValidationHelper$validateVcClaim$lambda_0(vcIssuer, iss));
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var id = vc.t3b_1;
        _this__u8e3s4.sn("vc.id must match jwt.jti", JwtCredentialValidationHelper$validateVcClaim$lambda_1(id, jti));
        if (!(iat == null)) {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcClaim.<anonymous>' call
            var issuedString = vc.y3b_1;
            var tmp = JwtCredentialValidationHelper$validateVcClaim$lambda_2;
            var tmp31_safe_receiver = _this__u8e3s4.xn(tmp, issuedString, JwtCredentialValidationHelper$validateVcClaim$lambda_3(issuedString));
            var tmp_0;
            if (tmp31_safe_receiver == null) tmp_0 = null;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                _this__u8e3s4.sn("vc.issued matches jwt.iat", JwtCredentialValidationHelper$validateVcClaim$lambda_4(tmp31_safe_receiver, iat));
                tmp_0 = Unit_instance;
            }
        }
        var tmp32_safe_receiver = vc.a3c_1;
        if (tmp32_safe_receiver == null) ;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcClaim.<anonymous>' call
            var tmp_1 = JwtCredentialValidationHelper$validateVcClaim$lambda_5;
            var tmp33_safe_receiver = _this__u8e3s4.xn(tmp_1, tmp32_safe_receiver, JwtCredentialValidationHelper$validateVcClaim$lambda_6(tmp32_safe_receiver));
            var tmp_2;
            if (tmp33_safe_receiver == null) tmp_2 = null;
            else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                _this__u8e3s4.sn("vc.expirationDate matches jwt.exp", JwtCredentialValidationHelper$validateVcClaim$lambda_7(tmp33_safe_receiver, exp));
                tmp_2 = Unit_instance;
            }
        }
        vc.w3b_1.rm(JwtCredentialValidationHelper$validateVcClaim$lambda_8(_this__u8e3s4, sub, didSubjectIdentifier));
    }
    function validateVcCredentialSubject(_this__u8e3s4, $this, credentialSubject, sub, didSubjectIdentifier) {
        // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.claim' call
        var value = credentialSubject.vl("id");
        if (value == null) _this__u8e3s4.vn("Missing claim 'id'");
        else {
            // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcCredentialSubject.<anonymous>' call
            var tmp;
            if (value instanceof JsonPrimitive_0) tmp = value.e1b();
            else if (value instanceof JsonObject) {
                var tmp_0 = value.vl("id");
                var tmp35_safe_receiver = tmp_0 instanceof JsonPrimitive_0 ? tmp_0 : null;
                tmp = tmp35_safe_receiver == null ? null : tmp35_safe_receiver.e1b();
            } else tmp = null;
            var credentialSubjectId = tmp;
            _this__u8e3s4.sn("credentialSubject.id must match the used subject identifier", JwtCredentialValidationHelper$validateVcCredentialSubject$lambda(credentialSubjectId, didSubjectIdentifier));
            _this__u8e3s4.sn("credentialSubject.id must match jwt.sub", JwtCredentialValidationHelper$validateVcCredentialSubject$lambda_0(credentialSubjectId, sub));
        }
    }
    function sameish($this, i1, i2) {
        return !(i1 == null) && !(i2 == null) && _Duration___get_inWholeSeconds__impl__hpy7b3(_Duration___get_absoluteValue__impl__vr7i6w(i1.g1m(i2))).j1(new Long(2, 0)) <= 0;
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda($sub, $didSubjectIdentifier) {
        return function() {
            return $sub === $didSubjectIdentifier.e2i_1.toString();
        };
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda($clock, $expInstant) {
        return function() {
            return $clock.u1l().h1m($expInstant) < 0;
        };
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda_0($clock) {
        return function($this$mandatory, exp) {
            var expInstant = Companion_getInstance_3().d1m(exp);
            $this$mandatory.sn("'exp' claim is in the future", JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda($clock, expInstant));
            return expInstant;
        };
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda_0($iatInstant, $clock) {
        return function() {
            return $iatInstant.h1m($clock.u1l()) <= 0;
        };
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda_1($clock) {
        return function($this$mandatory, iat) {
            var iatInstant = Companion_getInstance_3().d1m(iat);
            $this$mandatory.sn("'iat' is not in the future", JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda_0(iatInstant, $clock));
            return iatInstant;
        };
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda_2(err) {
        return "Credential does not conform to w3c data model: " + err.toString();
    }
    function JwtCredentialValidationHelper$validateCredentialClaims$lambda_3(credential) {
        return Companion_instance.d27(credential);
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda($typeList) {
        return function() {
            return $typeList.a2("VerifiableCredential");
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_0($vcIssuer, $iss) {
        return function() {
            var tmp30_subject = $vcIssuer;
            var tmp;
            if (isInterface(tmp30_subject, IssuerObject)) tmp = $vcIssuer.k2a();
            else if (tmp30_subject instanceof IssuerURI) tmp = $vcIssuer.q2h_1;
            else noWhenBranchMatchedException();
            var issuerId = tmp;
            return issuerId === $iss;
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_1($id, $jti) {
        return function() {
            return $id == $jti;
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_2(err) {
        return "vc.issued is invalid: " + err.toString();
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_3($issuedString) {
        return function(it) {
            return Companion_getInstance_3().a1m($issuedString);
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_4($issued, $iat) {
        return function() {
            return sameish(JwtCredentialValidationHelper_instance, $issued, $iat);
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_5(err) {
        return "vc.expirationDate is invalid: " + err.toString();
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_6($expirationDate) {
        return function(it) {
            return Companion_getInstance_3().a1m($expirationDate);
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_7($expiration, $exp) {
        return function() {
            return sameish(JwtCredentialValidationHelper_instance, $expiration, $exp);
        };
    }
    function JwtCredentialValidationHelper$validateVcClaim$lambda_8($this_validateVcClaim, $sub, $didSubjectIdentifier) {
        return function(subject) {
            validateVcCredentialSubject($this_validateVcClaim, JwtCredentialValidationHelper_instance, subject, $sub, $didSubjectIdentifier);
            return Unit_instance;
        };
    }
    function JwtCredentialValidationHelper$validateVcCredentialSubject$lambda($credentialSubjectId, $didSubjectIdentifier) {
        return function() {
            return $credentialSubjectId === $didSubjectIdentifier.e2i_1.toString();
        };
    }
    function JwtCredentialValidationHelper$validateVcCredentialSubject$lambda_0($credentialSubjectId, $sub) {
        return function() {
            return $credentialSubjectId == $sub;
        };
    }
    function $validateJwtSignatureCOROUTINE$8(_this__u8e3s4, _this__u8e3s4_0, jwt, didUrl, didResolver, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.r67_1 = _this__u8e3s4;
        this.s67_1 = _this__u8e3s4_0;
        this.t67_1 = jwt;
        this.u67_1 = didUrl;
        this.v67_1 = didResolver;
    }
    protoOf($validateJwtSignatureCOROUTINE$8).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 9;
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.v67_1.k2j(this.u67_1.e2i_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.x67_1 = suspendResult;
                    this.y67_1 = this.x67_1.h3k();
                    this.z67_1 = this.y67_1.b3l(this.u67_1);
                    this.a68_1 = this.z67_1 == null ? null : this.z67_1.k3l();
                    if (this.a68_1 == null) this.s67_1.vn("Unable to find usable key in DID document");
                    this.w67_1 = this.a68_1;
                    this.w8_1 = 9;
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    this.w8_1 = 9;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof DidResolutionException) {
                        this.b68_1 = this.y8_1;
                        var tmp_1 = this;
                        this.s67_1.vn("Unable to find DID document");
                        return false;
                    } else throw this.y8_1;
                case 3:
                    this.w8_1 = 9;
                    this.c68_1 = this.w67_1;
                    var tmp_2 = this;
                    var tmp_3;
                    if (this.c68_1 == null) return false;
                    else tmp_3 = this.c68_1;
                    tmp_2.d68_1 = tmp_3;
                    this.w8_1 = 5;
                    this.v8_1 = 4;
                    var tmp_4 = Companion_instance_0;
                    var this_0 = Default_getInstance();
                    var value = Companion_instance_1.a3k(this.d68_1);
                    var this_1 = this_0.dp();
                    var this_2 = serializer(this_1, createKType(getKClass(JsonPublicKeyJwk), arrayOf([]), false));
                    suspendResult = tmp_4.x28(this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    this.e68_1 = suspendResult;
                    this.w8_1 = 9;
                    this.v8_1 = 6;
                    continue $sm;
                case 5:
                    this.w8_1 = 9;
                    var tmp_5 = this.y8_1;
                    if (tmp_5 instanceof CryptoException) {
                        this.f68_1 = this.y8_1;
                        var tmp_6 = this;
                        this.s67_1.vn("Unable to use key resolved from DID URL");
                        return false;
                    } else throw this.y8_1;
                case 6:
                    this.w8_1 = 9;
                    this.g68_1 = this.e68_1;
                    this.w8_1 = 8;
                    this.v8_1 = 7;
                    suspendResult = JwsUtil_getInstance().w2d(this.g68_1, this.t67_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 7:
                    this.h68_1 = true;
                    this.w8_1 = 9;
                    this.v8_1 = 10;
                    continue $sm;
                case 8:
                    this.w8_1 = 9;
                    var tmp_7 = this.y8_1;
                    if (tmp_7 instanceof CryptoException) {
                        var ex = this.y8_1;
                        var tmp_8 = this;
                        this.s67_1.vn("Signature is not valid");
                        tmp_8.h68_1 = false;
                        this.v8_1 = 10;
                        continue $sm;
                    } else throw this.y8_1;
                case 9:
                    throw this.y8_1;
                case 10:
                    this.w8_1 = 9;
                    return this.h68_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 9) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function JwtCredentialValidationHelper() {}
    protoOf(JwtCredentialValidationHelper).y66 = function(_this__u8e3s4, jwt, didUrl, didResolver, $completion) {
        var tmp = new $validateJwtSignatureCOROUTINE$8(this, _this__u8e3s4, jwt, didUrl, didResolver, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JwtCredentialValidationHelper).z65 = function(_this__u8e3s4, payload, didSubjectIdentifier, clock) {
        var iss = payload.z29_1;
        // Inline function 'kotlin.also' call
        var this_0 = payload.a2a_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
        _this__u8e3s4.sn("'sub' claim matches subject identifier", JwtCredentialValidationHelper$validateCredentialClaims$lambda(this_0, didSubjectIdentifier));
        var sub = this_0;
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
        var jti = payload.f2a_1;
        var exp = _this__u8e3s4.un("exp", payload.c2a_1, JwtCredentialValidationHelper$validateCredentialClaims$lambda_0(clock));
        var iat = _this__u8e3s4.un("iat", payload.e2a_1, JwtCredentialValidationHelper$validateCredentialClaims$lambda_1(clock));
        var tmp28_safe_receiver = payload.vl("vc");
        var tmp;
        if (tmp28_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
            var tmp_0 = JwtCredentialValidationHelper$validateCredentialClaims$lambda_2;
            var tmp29_safe_receiver = _this__u8e3s4.xn(tmp_0, tmp28_safe_receiver, JwtCredentialValidationHelper$validateCredentialClaims$lambda_3);
            var tmp_1;
            if (tmp29_safe_receiver == null) tmp_1 = null;
            else {
                // Inline function 'kotlin.also' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>.<anonymous>' call
                validateVcClaim(_this__u8e3s4, JwtCredentialValidationHelper_instance, tmp29_safe_receiver, iss, sub, jti, iat, exp, didSubjectIdentifier);
                tmp_1 = tmp29_safe_receiver;
            }
            tmp = tmp_1;
        }
        return tmp;
    };
    var JwtCredentialValidationHelper_instance;
    function JwtCredentialValidationHelper_getInstance() {
        return JwtCredentialValidationHelper_instance;
    }
    function InMemoryKeyAliasStore() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.i68_1 = LinkedHashMap_init_$Create$_0();
    }
    protoOf(InMemoryKeyAliasStore).j68 = function(alias, kid, $completion) {
        // Inline function 'kotlin.collections.set' call
        this.i68_1.m2(alias, kid);
        return Unit_instance;
    };
    protoOf(InMemoryKeyAliasStore).k68 = function(alias, $completion) {
        return this.i68_1.e2(alias);
    };
    function deserializeUserVerifiableCredentialOrNull($this, serializedCredential) {
        var tmp;
        try {
            // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
            var this_0 = Default_getInstance();
            // Inline function 'kotlinx.serialization.serializer' call
            var this_1 = this_0.dp();
            // Inline function 'kotlinx.serialization.internal.cast' call
            var this_2 = serializer(this_1, createKType(getKClass(UserVerifiableCredential), arrayOf([]), false));
            var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
            tmp = this_0.cp(tmp$ret$1, serializedCredential);
        } catch ($p) {
            var tmp_0;
            if ($p instanceof SerializationException) {
                var ex = $p;
                tmp_0 = null;
            } else {
                if ($p instanceof IllegalArgumentException) {
                    var ex_0 = $p;
                    tmp_0 = null;
                } else throw $p;
            }
            tmp = tmp_0;
        }
        return tmp;
    }
    function Companion_3() {
        Companion_instance_12 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l68_1 = [
            new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())
        ];
    }
    var Companion_instance_12;
    function Companion_getInstance_10() {
        if (Companion_instance_12 == null) new Companion_3();
        return Companion_instance_12;
    }
    function $serializer_0() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vc.services.InMemoryVerifiableCredentialStore", this, 1);
        tmp0_serialDesc.wy("map", true);
        this.m68_1 = tmp0_serialDesc;
    }
    protoOf($serializer_0).n68 = function(encoder, value) {
        var tmp0_desc = this.m68_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_10().l68_1;
        var tmp;
        if (tmp1_output.ht(tmp0_desc, 0)) tmp = true;
        else {
            // Inline function 'kotlin.collections.mutableMapOf' call
            var tmp$ret$0 = LinkedHashMap_init_$Create$_0();
            tmp = !equals(value.o68_1, tmp$ret$0);
        }
        if (tmp) tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.o68_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_0).zn = function(encoder, value) {
        return this.n68(encoder, value instanceof InMemoryVerifiableCredentialStore ? value : THROW_CCE());
    };
    protoOf($serializer_0).ao = function(decoder) {
        var tmp0_desc = this.m68_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_10().l68_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return InMemoryVerifiableCredentialStore_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_0).yn = function() {
        return this.m68_1;
    };
    protoOf($serializer_0).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_10().l68_1[0]
        ];
    };
    var $serializer_instance_0;
    function $serializer_getInstance_5() {
        if ($serializer_instance_0 == null) new $serializer_0();
        return $serializer_instance_0;
    }
    function InMemoryVerifiableCredentialStore_init_$Init$(seen0, map, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_5().m68_1);
        if (0 === (seen0 & 1)) {
            var tmp = $this;
            // Inline function 'kotlin.collections.mutableMapOf' call
            tmp.o68_1 = LinkedHashMap_init_$Create$_0();
        } else $this.o68_1 = map;
        return $this;
    }
    function InMemoryVerifiableCredentialStore_init_$Create$(seen0, map, serializationConstructorMarker) {
        return InMemoryVerifiableCredentialStore_init_$Init$(seen0, map, serializationConstructorMarker, objectCreate(protoOf(InMemoryVerifiableCredentialStore)));
    }
    function InMemoryVerifiableCredentialStore(map) {
        Companion_getInstance_10();
        var tmp;
        if (map === VOID) // Inline function 'kotlin.collections.mutableMapOf' call
        tmp = LinkedHashMap_init_$Create$_0();
        else tmp = map;
        map = tmp;
        this.o68_1 = map;
    }
    protoOf(InMemoryVerifiableCredentialStore).p68 = function(credential) {
        if (this.o68_1.c2(credential.a33_1)) throw Exception_init_$Create$("A Credential with this name already exists");
        // Inline function 'kotlin.collections.set' call
        var this_0 = this.o68_1;
        var key = credential.a33_1;
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_1 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_2 = this_1.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_3 = serializer(this_2, createKType(getKClass(UserVerifiableCredential), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
        var value = this_1.bp(tmp$ret$1, credential);
        this_0.m2(key, value);
    };
    protoOf(InMemoryVerifiableCredentialStore).q68 = function(localId) {
        this.o68_1.n2(localId);
    };
    protoOf(InMemoryVerifiableCredentialStore).r68 = function(localId) {
        var tmp37_safe_receiver = this.o68_1.e2(localId);
        var tmp;
        if (tmp37_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getById.<anonymous>' call
        tmp = deserializeUserVerifiableCredentialOrNull(this, tmp37_safe_receiver);
        return tmp;
    };
    protoOf(InMemoryVerifiableCredentialStore).s68 = function(namePrefix) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = this.o68_1.g2();
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByName.<anonymous>' call
            var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.e(tmp0_safe_receiver);
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var tmp0_iterator_0 = destination.j();
        while(tmp0_iterator_0.k()){
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByName.<anonymous>' call
            if (startsWith(element_0.a33_1, namePrefix)) destination_0.e(element_0);
        }
        return destination_0;
    };
    protoOf(InMemoryVerifiableCredentialStore).t68 = function(issuerId) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = this.o68_1.g2();
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByIssuer.<anonymous>' call
            var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.e(tmp0_safe_receiver);
        }
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var tmp0_iterator_0 = destination.j();
        while(tmp0_iterator_0.k()){
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByIssuer.<anonymous>' call
            if (element_0.b33_1 === issuerId) destination_0.e(element_0);
        }
        return destination_0;
    };
    protoOf(InMemoryVerifiableCredentialStore).u68 = function() {
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = this.o68_1.g2();
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var element = tmp0_iterator.l();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getAll.<anonymous>' call
            var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
            if (tmp0_safe_receiver == null) ;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.e(tmp0_safe_receiver);
        }
        return destination;
    };
    function withToken($this, request, force, $completion) {
        var tmp = new $withTokenCOROUTINE$10($this, request, force, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function withToken$default($this, request, force, $completion, $super) {
        force = force === VOID ? false : force;
        return withToken($this, request, force, $completion);
    }
    function $interceptCOROUTINE$9(_this__u8e3s4, sender, request, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.r69_1 = _this__u8e3s4;
        this.s69_1 = sender;
        this.t69_1 = request;
    }
    protoOf($interceptCOROUTINE$9).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 7;
                    this.v8_1 = 1;
                    suspendResult = withToken$default(this.r69_1, this.t69_1, VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.u69_1 = suspendResult;
                    this.v8_1 = 2;
                    suspendResult = this.s69_1.v56(this.t69_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.v69_1 = suspendResult;
                    var tmp_0;
                    var containsArg = this.v69_1.j31().y4v().h4g_1;
                    if (401 <= containsArg ? containsArg <= 403 : false) tmp_0 = !this.u69_1;
                    else tmp_0 = false;
                    if (tmp_0) {
                        this.v8_1 = 4;
                        suspendResult = withToken(this.r69_1, this.t69_1, true, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                case 3:
                    return this.v69_1;
                case 4:
                    if (suspendResult) {
                        this.v8_1 = 5;
                        suspendResult = this.s69_1.v56(this.t69_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_1 = this;
                        tmp_1.w69_1 = this.v69_1;
                        this.v8_1 = 6;
                        continue $sm;
                    }
                case 5:
                    this.w69_1 = suspendResult;
                    this.v8_1 = 6;
                    continue $sm;
                case 6:
                    return this.w69_1;
                case 7:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 7) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $withTokenCOROUTINE$10(_this__u8e3s4, request, force, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.d69_1 = _this__u8e3s4;
        this.e69_1 = request;
        this.f69_1 = force;
    }
    protoOf($withTokenCOROUTINE$10).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.g69_1 = false;
                    this.h69_1 = this.d69_1.y69_1.z5u();
                    if (this.f69_1 && this.h69_1 == null) return false;
                    if (this.f69_1 && !(this.h69_1 == null)) {
                        this.g69_1 = true;
                        this.v8_1 = 1;
                        suspendResult = this.d69_1.x69_1.p5w(this.h69_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_0 = this;
                        tmp_0.i69_1 = this.d69_1.y69_1;
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 1:
                    this.i69_1 = suspendResult;
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    var tokenResponse = this.i69_1;
                    header(this.e69_1, "Authorization", "Bearer " + tokenResponse.y5u());
                    if (this.g69_1) this.d69_1.y69_1 = tokenResponse;
                    return this.g69_1;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function OAuthTokenInterceptor(initialTokenResponse, refreshFlowClient) {
        this.x69_1 = refreshFlowClient;
        this.y69_1 = initialTokenResponse;
    }
    protoOf(OAuthTokenInterceptor).z69 = function(sender, request, $completion) {
        var tmp = new $interceptCOROUTINE$9(this, sender, request, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function installOAuthSupport(_this__u8e3s4, initialTokenResponse, refreshFlowClient) {
        var oauthInterceptor = new OAuthTokenInterceptor(initialTokenResponse, refreshFlowClient);
        var tmp = plugin(_this__u8e3s4, Plugin_getInstance_0());
        tmp.e58(OAuthTokenInterceptor$intercept$ref_0(oauthInterceptor));
    }
    function OAuthTokenInterceptor$intercept$ref($boundThis) {
        this.a6a_1 = $boundThis;
    }
    protoOf(OAuthTokenInterceptor$intercept$ref).t56 = function(p0, p1, $completion) {
        return this.a6a_1.z69(p0, p1, $completion);
    };
    protoOf(OAuthTokenInterceptor$intercept$ref).hj = function(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
        return this.t56(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
    };
    function OAuthTokenInterceptor$intercept$ref_0($boundThis) {
        var i = new OAuthTokenInterceptor$intercept$ref($boundThis);
        var l = function(p0, p1, $completion) {
            return i.t56(p0, p1, $completion);
        };
        l.callableName = "intercept";
        l.$arity = 2;
        return l;
    }
    function $requestCredentialCOROUTINE$11(_this__u8e3s4, request, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.j6a_1 = _this__u8e3s4;
        this.k6a_1 = request;
    }
    protoOf($requestCredentialCOROUTINE$11).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.l6a_1 = this.j6a_1.t62_1;
                    var tmp_1 = this;
                    tmp_1.m6a_1 = this.j6a_1.u62_1.p33_1;
                    var tmp_2 = this;
                    tmp_2.n6a_1 = this.l6a_1;
                    var tmp_3 = this;
                    tmp_3.o6a_1 = this.n6a_1;
                    var tmp_4 = this;
                    var this_0 = new HttpRequestBuilder();
                    url(this_0, this.m6a_1);
                    contentType(this_0, Application_getInstance().x47_1);
                    var body = this.k6a_1;
                    if (body == null) {
                        this_0.p4t_1 = NullBody_instance;
                        var tmp_5 = JsType_instance;
                        var tmp_6 = getKClass(JwtVcJsonVerifiableCredentialRequest);
                        var tmp_7;
                        try {
                            tmp_7 = createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_8;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_8 = null;
                            } else throw $p;
                            tmp_7 = tmp_8;
                        }
                        this_0.k4z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
                    } else if (body instanceof OutgoingContent) {
                        this_0.p4t_1 = body;
                        this_0.k4z(null);
                    } else {
                        this_0.p4t_1 = body;
                        var tmp_9 = JsType_instance;
                        var tmp_10 = getKClass(JwtVcJsonVerifiableCredentialRequest);
                        var tmp_11;
                        try {
                            tmp_11 = createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_12;
                            if ($p instanceof Error) {
                                var cause_0 = $p;
                                tmp_12 = null;
                            } else throw $p;
                            tmp_11 = tmp_12;
                        }
                        this_0.k4z(typeInfoImpl(tmp_9, tmp_10, tmp_11));
                    }
                    tmp_4.p6a_1 = this_0;
                    this.p6a_1.n4t_1 = Companion_getInstance().o4d_1;
                    var tmp_13 = this;
                    tmp_13.q6a_1 = this.o6a_1;
                    var tmp_14 = this;
                    tmp_14.r6a_1 = this.p6a_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.r6a_1, this.q6a_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.s6a_1 = suspendResult;
                    if (this.s6a_1.y4v().h4g_1 >= 300) {
                        var tmp_15 = this;
                        tmp_15.t6a_1 = this.s6a_1;
                        this.v8_1 = 5;
                        var tmp_16 = this.t6a_1.t4w();
                        var tmp_17 = JsType_instance;
                        var tmp_18 = PrimitiveClasses_getInstance().gb();
                        var tmp_19;
                        try {
                            tmp_19 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_20;
                            if ($p instanceof Error) {
                                var cause_1 = $p;
                                tmp_20 = null;
                            } else throw $p;
                            tmp_19 = tmp_20;
                        }
                        suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.u6a_1 = this.j6a_1.v62_1;
                    var tmp_21 = this;
                    tmp_21.v6a_1 = this.s6a_1;
                    this.v8_1 = 3;
                    var tmp_22 = this.v6a_1.t4w();
                    var tmp_23 = JsType_instance;
                    var tmp_24 = getKClass(JwtVcJsonCredentialResponse);
                    var tmp_25;
                    try {
                        tmp_25 = createKType(getKClass(JwtVcJsonCredentialResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_26;
                        if ($p instanceof Error) {
                            var cause_2 = $p;
                            tmp_26 = null;
                        } else throw $p;
                        tmp_25 = tmp_26;
                    }
                    suspendResult = tmp_22.x4v(typeInfoImpl(tmp_23, tmp_24, tmp_25), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var tmp_27 = this;
                    tmp_27.w6a_1 = (!(suspendResult == null) ? isInterface(suspendResult, JwtVcJsonCredentialResponse) : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    suspendResult = this.u6a_1.p65(this.w6a_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    return suspendResult;
                case 5:
                    var body_0 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    throw Exception_init_$Create$("Credential request with non-success response: " + this.s6a_1.y4v().h4g_1 + ", " + body_0);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialCOROUTINE$12(_this__u8e3s4, request, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.f6b_1 = _this__u8e3s4;
        this.g6b_1 = request;
    }
    protoOf($requestCredentialCOROUTINE$12).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.h6b_1 = this.f6b_1.t62_1;
                    var tmp_1 = this;
                    tmp_1.i6b_1 = this.f6b_1.u62_1.p33_1;
                    var tmp_2 = this;
                    tmp_2.j6b_1 = this.h6b_1;
                    var tmp_3 = this;
                    tmp_3.k6b_1 = this.j6b_1;
                    var tmp_4 = this;
                    var this_0 = new HttpRequestBuilder();
                    url(this_0, this.i6b_1);
                    contentType(this_0, Application_getInstance().x47_1);
                    var body = this.g6b_1;
                    if (body == null) {
                        this_0.p4t_1 = NullBody_instance;
                        var tmp_5 = JsType_instance;
                        var tmp_6 = getKClass(VcSdJwtVerifiableCredentialRequest);
                        var tmp_7;
                        try {
                            tmp_7 = createKType(getKClass(VcSdJwtVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_8;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_8 = null;
                            } else throw $p;
                            tmp_7 = tmp_8;
                        }
                        this_0.k4z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
                    } else if (body instanceof OutgoingContent) {
                        this_0.p4t_1 = body;
                        this_0.k4z(null);
                    } else {
                        this_0.p4t_1 = body;
                        var tmp_9 = JsType_instance;
                        var tmp_10 = getKClass(VcSdJwtVerifiableCredentialRequest);
                        var tmp_11;
                        try {
                            tmp_11 = createKType(getKClass(VcSdJwtVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_12;
                            if ($p instanceof Error) {
                                var cause_0 = $p;
                                tmp_12 = null;
                            } else throw $p;
                            tmp_11 = tmp_12;
                        }
                        this_0.k4z(typeInfoImpl(tmp_9, tmp_10, tmp_11));
                    }
                    tmp_4.l6b_1 = this_0;
                    this.l6b_1.n4t_1 = Companion_getInstance().o4d_1;
                    var tmp_13 = this;
                    tmp_13.m6b_1 = this.k6b_1;
                    var tmp_14 = this;
                    tmp_14.n6b_1 = this.l6b_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.n6b_1, this.m6b_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.o6b_1 = suspendResult;
                    if (this.o6b_1.y4v().h4g_1 >= 400) {
                        var tmp_15 = this;
                        tmp_15.p6b_1 = this.o6b_1;
                        this.v8_1 = 5;
                        var tmp_16 = this.p6b_1.t4w();
                        var tmp_17 = JsType_instance;
                        var tmp_18 = PrimitiveClasses_getInstance().gb();
                        var tmp_19;
                        try {
                            tmp_19 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_20;
                            if ($p instanceof Error) {
                                var cause_1 = $p;
                                tmp_20 = null;
                            } else throw $p;
                            tmp_19 = tmp_20;
                        }
                        suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.q6b_1 = this.f6b_1.v62_1;
                    var tmp_21 = this;
                    tmp_21.r6b_1 = this.o6b_1;
                    this.v8_1 = 3;
                    var tmp_22 = this.r6b_1.t4w();
                    var tmp_23 = JsType_instance;
                    var tmp_24 = getKClass(VcSdJwtCredentialResponse);
                    var tmp_25;
                    try {
                        tmp_25 = createKType(getKClass(VcSdJwtCredentialResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_26;
                        if ($p instanceof Error) {
                            var cause_2 = $p;
                            tmp_26 = null;
                        } else throw $p;
                        tmp_25 = tmp_26;
                    }
                    suspendResult = tmp_22.x4v(typeInfoImpl(tmp_23, tmp_24, tmp_25), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var tmp_27 = this;
                    tmp_27.s6b_1 = (!(suspendResult == null) ? isInterface(suspendResult, VcSdJwtCredentialResponse) : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    suspendResult = this.q6b_1.y65(this.s6b_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    return suspendResult;
                case 5:
                    var body_0 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    throw Exception_init_$Create$("Credential request with non-success response: " + this.o6b_1.y4v().h4g_1 + ", " + body_0);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialCOROUTINE$13(_this__u8e3s4, request, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.b6c_1 = _this__u8e3s4;
        this.c6c_1 = request;
    }
    protoOf($requestCredentialCOROUTINE$13).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.d6c_1 = this.b6c_1.t62_1;
                    var tmp_1 = this;
                    tmp_1.e6c_1 = this.d6c_1;
                    var tmp_2 = this;
                    var this_0 = new HttpRequestBuilder();
                    path(this_0.m4t_1, [
                        this.b6c_1.u62_1.p33_1
                    ]);
                    contentType(this_0, Application_getInstance().x47_1);
                    var body = this.c6c_1;
                    if (body == null) {
                        this_0.p4t_1 = NullBody_instance;
                        var tmp_3 = JsType_instance;
                        var tmp_4 = getKClass(JwtVcJsonLdVerifiableCredentialRequest);
                        var tmp_5;
                        try {
                            tmp_5 = createKType(getKClass(JwtVcJsonLdVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_6;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_6 = null;
                            } else throw $p;
                            tmp_5 = tmp_6;
                        }
                        this_0.k4z(typeInfoImpl(tmp_3, tmp_4, tmp_5));
                    } else if (body instanceof OutgoingContent) {
                        this_0.p4t_1 = body;
                        this_0.k4z(null);
                    } else {
                        this_0.p4t_1 = body;
                        var tmp_7 = JsType_instance;
                        var tmp_8 = getKClass(JwtVcJsonLdVerifiableCredentialRequest);
                        var tmp_9;
                        try {
                            tmp_9 = createKType(getKClass(JwtVcJsonLdVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_10;
                            if ($p instanceof Error) {
                                var cause_0 = $p;
                                tmp_10 = null;
                            } else throw $p;
                            tmp_9 = tmp_10;
                        }
                        this_0.k4z(typeInfoImpl(tmp_7, tmp_8, tmp_9));
                    }
                    tmp_2.f6c_1 = this_0;
                    this.f6c_1.n4t_1 = Companion_getInstance().o4d_1;
                    var tmp_11 = this;
                    tmp_11.g6c_1 = this.e6c_1;
                    var tmp_12 = this;
                    tmp_12.h6c_1 = this.f6c_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.h6c_1, this.g6c_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.i6c_1 = suspendResult;
                    if (this.i6c_1.y4v().h4g_1 >= 400) {
                        var tmp_13 = this;
                        tmp_13.j6c_1 = this.i6c_1;
                        this.v8_1 = 5;
                        var tmp_14 = this.j6c_1.t4w();
                        var tmp_15 = JsType_instance;
                        var tmp_16 = PrimitiveClasses_getInstance().gb();
                        var tmp_17;
                        try {
                            tmp_17 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_18;
                            if ($p instanceof Error) {
                                var cause_1 = $p;
                                tmp_18 = null;
                            } else throw $p;
                            tmp_17 = tmp_18;
                        }
                        suspendResult = tmp_14.x4v(typeInfoImpl(tmp_15, tmp_16, tmp_17), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.k6c_1 = this.b6c_1.v62_1;
                    var tmp_19 = this;
                    tmp_19.l6c_1 = this.i6c_1;
                    this.v8_1 = 3;
                    var tmp_20 = this.l6c_1.t4w();
                    var tmp_21 = JsType_instance;
                    var tmp_22 = getKClass(JwtVcJsonLdCredentialResponse);
                    var tmp_23;
                    try {
                        tmp_23 = createKType(getKClass(JwtVcJsonLdCredentialResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_24;
                        if ($p instanceof Error) {
                            var cause_2 = $p;
                            tmp_24 = null;
                        } else throw $p;
                        tmp_23 = tmp_24;
                    }
                    suspendResult = tmp_20.x4v(typeInfoImpl(tmp_21, tmp_22, tmp_23), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var tmp_25 = this;
                    tmp_25.m6c_1 = (!(suspendResult == null) ? isInterface(suspendResult, JwtVcJsonLdCredentialResponse) : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    suspendResult = this.k6c_1.w65(this.m6c_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    return suspendResult;
                case 5:
                    var body_0 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    throw Exception_init_$Create$("Credential request with non-success response: " + this.i6c_1.y4v().h4g_1 + ", " + body_0);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $requestCredentialCOROUTINE$14(_this__u8e3s4, request, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v6c_1 = _this__u8e3s4;
        this.w6c_1 = request;
    }
    protoOf($requestCredentialCOROUTINE$14).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    var tmp_0 = this;
                    tmp_0.x6c_1 = this.v6c_1.t62_1;
                    var tmp_1 = this;
                    tmp_1.y6c_1 = this.x6c_1;
                    var tmp_2 = this;
                    var this_0 = new HttpRequestBuilder();
                    path(this_0.m4t_1, [
                        this.v6c_1.u62_1.p33_1
                    ]);
                    contentType(this_0, Application_getInstance().x47_1);
                    var body = this.w6c_1;
                    if (body == null) {
                        this_0.p4t_1 = NullBody_instance;
                        var tmp_3 = JsType_instance;
                        var tmp_4 = getKClass(LdpVerifiableCredentialRequest);
                        var tmp_5;
                        try {
                            tmp_5 = createKType(getKClass(LdpVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_6;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_6 = null;
                            } else throw $p;
                            tmp_5 = tmp_6;
                        }
                        this_0.k4z(typeInfoImpl(tmp_3, tmp_4, tmp_5));
                    } else if (body instanceof OutgoingContent) {
                        this_0.p4t_1 = body;
                        this_0.k4z(null);
                    } else {
                        this_0.p4t_1 = body;
                        var tmp_7 = JsType_instance;
                        var tmp_8 = getKClass(LdpVerifiableCredentialRequest);
                        var tmp_9;
                        try {
                            tmp_9 = createKType(getKClass(LdpVerifiableCredentialRequest), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_10;
                            if ($p instanceof Error) {
                                var cause_0 = $p;
                                tmp_10 = null;
                            } else throw $p;
                            tmp_9 = tmp_10;
                        }
                        this_0.k4z(typeInfoImpl(tmp_7, tmp_8, tmp_9));
                    }
                    tmp_2.z6c_1 = this_0;
                    this.z6c_1.n4t_1 = Companion_getInstance().o4d_1;
                    var tmp_11 = this;
                    tmp_11.a6d_1 = this.y6c_1;
                    var tmp_12 = this;
                    tmp_12.b6d_1 = this.z6c_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.b6d_1, this.a6d_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.c6d_1 = suspendResult;
                    if (this.c6d_1.y4v().h4g_1 >= 400) {
                        var tmp_13 = this;
                        tmp_13.d6d_1 = this.c6d_1;
                        this.v8_1 = 5;
                        var tmp_14 = this.d6d_1.t4w();
                        var tmp_15 = JsType_instance;
                        var tmp_16 = PrimitiveClasses_getInstance().gb();
                        var tmp_17;
                        try {
                            tmp_17 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_18;
                            if ($p instanceof Error) {
                                var cause_1 = $p;
                                tmp_18 = null;
                            } else throw $p;
                            tmp_17 = tmp_18;
                        }
                        suspendResult = tmp_14.x4v(typeInfoImpl(tmp_15, tmp_16, tmp_17), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        this.v8_1 = 2;
                        continue $sm;
                    }
                case 2:
                    this.e6d_1 = this.v6c_1.v62_1;
                    var tmp_19 = this;
                    tmp_19.f6d_1 = this.c6d_1;
                    this.v8_1 = 3;
                    var tmp_20 = this.f6d_1.t4w();
                    var tmp_21 = JsType_instance;
                    var tmp_22 = getKClass(LdpVcCredentialResponse);
                    var tmp_23;
                    try {
                        tmp_23 = createKType(getKClass(LdpVcCredentialResponse), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_24;
                        if ($p instanceof Error) {
                            var cause_2 = $p;
                            tmp_24 = null;
                        } else throw $p;
                        tmp_23 = tmp_24;
                    }
                    suspendResult = tmp_20.x4v(typeInfoImpl(tmp_21, tmp_22, tmp_23), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var tmp_25 = this;
                    tmp_25.g6d_1 = (!(suspendResult == null) ? isInterface(suspendResult, LdpVcCredentialResponse) : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 4;
                    suspendResult = this.e6d_1.x65(this.g6d_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    return suspendResult;
                case 5:
                    var body_0 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    throw Exception_init_$Create$("Credential request with non-success response: " + this.c6d_1.y4v().h4g_1 + ", " + body_0);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function VcClient(httpClient, vcServerMetadata, responseValidator) {
        this.t62_1 = httpClient;
        this.u62_1 = vcServerMetadata;
        this.v62_1 = responseValidator;
        this.w62_1 = this.t62_1;
    }
    protoOf(VcClient).y62 = function(request, $completion) {
        var tmp = new $requestCredentialCOROUTINE$11(this, request, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcClient).x62 = function(request, $completion) {
        var tmp = new $requestCredentialCOROUTINE$12(this, request, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcClient).h6d = function(request, $completion) {
        var tmp = new $requestCredentialCOROUTINE$13(this, request, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcClient).i6d = function(request, $completion) {
        var tmp = new $requestCredentialCOROUTINE$14(this, request, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).o2z = function(it, $completion) {
        var tmp = this.p2z(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).y9 = function(p1, $completion) {
        return this.o2z((!(p1 == null) ? typeof p1 === "string" : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return JwsUtil_getInstance().r2a(this.r6d_1);
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).p2z = function(it, completion) {
        var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(completion);
        i.r6d_1 = it;
        return i;
    };
    function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda_0(resultContinuation) {
        var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(resultContinuation);
        var l = function(it, $completion) {
            return i.o2z(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda($response, this$0, resultContinuation) {
        this.a6e_1 = $response;
        this.b6e_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).f6e = function($this$suspendableValidationScope, $completion) {
        var tmp = this.x66($this$suspendableValidationScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).y9 = function(p1, $completion) {
        return this.f6e(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    var tmp_0 = this;
                    var tmp38_subject = this.a6e_1;
                    var tmp_1;
                    if (tmp38_subject instanceof VcSdJwtVerifiableCredentialResponse) tmp_1 = this.a6e_1.n38();
                    else if (tmp38_subject instanceof Deferred_0) {
                        var message = "Cannot handle deferred response";
                        throw IllegalStateException_init_$Create$(toString(message));
                    } else noWhenBranchMatchedException();
                    tmp_0.d6e_1 = tmp_1;
                    this.v8_1 = 1;
                    var tmp_2 = Companion_instance_2;
                    suspendResult = tmp_2.b2w(this.d6e_1.o2h_1, VOID, VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda_0(null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.e6e_1 = suspendResult;
                    if (!(this.e6e_1.x2n_1 == null) || !(this.e6e_1.w2n_1 == null)) this.c6e_1.vn("Issued credential must not have key-binding JWT");
                    this.v8_1 = 2;
                    suspendResult = new VcSdJwtIssuerJwtValidator(this.b6e_1.g6e_1, this.b6e_1.h6e_1).v2y(this.c6e_1, this.e6e_1.t2n_1, this.e6e_1.s2n_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var validatedIssuerJwtResult = suspendResult;
                    if (!(this.b6e_1.i6e_1.t32_1.u33_1 === (validatedIssuerJwtResult == null ? null : validatedIssuerJwtResult.z2w_1))) this.c6e_1.vn("Issued credential issuer does not match metadata issuer");
                    if (!(this.b6e_1.j6e_1.n37_1 === (validatedIssuerJwtResult == null ? null : validatedIssuerJwtResult.a2x_1))) this.c6e_1.vn("Issued credential 'vct' does not match metadata 'vct'");
                    if (!(validatedIssuerJwtResult == null)) {
                        if (!validatedIssuerJwtResult.b2x_1.b29(this.b6e_1.k6e_1.v28_1.u2f())) this.c6e_1.vn("Issued credential 'cnf' claims does not match signing key");
                    }
                    if (this.c6e_1.rn_1) return null;
                    var tmp41_safe_receiver = this.b6e_1.j6e_1.o37_1;
                    var tmp42_safe_receiver = tmp41_safe_receiver == null ? null : tmp41_safe_receiver.v37_1;
                    var tmp43_safe_receiver = tmp42_safe_receiver == null ? null : tmp42_safe_receiver.z();
                    var tmp_3;
                    if (tmp43_safe_receiver == null) tmp_3 = null;
                    else {
                        var destination = ArrayList_init_$Create$_0();
                        var tmp0_iterator = tmp43_safe_receiver.j();
                        while(tmp0_iterator.k()){
                            var element = tmp0_iterator.l();
                            var key = element.a1();
                            var value = element.b1();
                            var valueDisplay = value.y37_1;
                            var tmp_4;
                            if (!(valueDisplay == null)) tmp_4 = to(key, valueDisplay);
                            else tmp_4 = null;
                            var tmp0_safe_receiver = tmp_4;
                            if (tmp0_safe_receiver == null) ;
                            else destination.e(tmp0_safe_receiver);
                        }
                        tmp_3 = destination;
                    }
                    var tmp44_safe_receiver = tmp_3;
                    var tmp_5;
                    if (tmp44_safe_receiver == null) tmp_5 = null;
                    else {
                        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp44_safe_receiver, 10)), 16);
                        var destination_0 = LinkedHashMap_init_$Create$(capacity);
                        var tmp0_iterator_0 = tmp44_safe_receiver.j();
                        while(tmp0_iterator_0.k()){
                            var element_0 = tmp0_iterator_0.l();
                            var key_0 = element_0.ba();
                            var value_0 = element_0.ca();
                            var pair = to(key_0, value_0);
                            destination_0.m2(pair.z9_1, pair.aa_1);
                        }
                        tmp_5 = destination_0;
                    }
                    var tmp0_elvis_lhs = tmp_5;
                    var subjectDisplayInformation = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
                    var tmp_6;
                    if (!(validatedIssuerJwtResult == null)) tmp_6 = new DefaultValidatedVcSdJwtCredentialResponse(this.a6e_1, subjectDisplayInformation, this.b6e_1.j6e_1.r37_1, this.d6e_1.o2h_1, validatedIssuerJwtResult.z2w_1, validatedIssuerJwtResult.a2x_1, this.e6e_1.u2n_1, this.b6e_1.k6e_1.w28_1);
                    else tmp_6 = null;
                    return tmp_6;
                case 3:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 3) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).x66 = function($this$suspendableValidationScope, completion) {
        var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda(this.a6e_1, this.b6e_1, completion);
        i.c6e_1 = $this$suspendableValidationScope;
        return i;
    };
    function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda_0($response, this$0, resultContinuation) {
        var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda($response, this$0, resultContinuation);
        var l = function($this$suspendableValidationScope, $completion) {
            return i.f6e($this$suspendableValidationScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $validateVcSdJwtCOROUTINE$15(_this__u8e3s4, response, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.t6e_1 = _this__u8e3s4;
        this.u6e_1 = response;
    }
    protoOf($validateVcSdJwtCOROUTINE$15).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = suspendableValidationScope(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda_0(this.u6e_1, this.t6e_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return ARGUMENT.xm();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function VcSdJwtVerifiableCredentialResponseValidator(clock, issuerMetadataLoader, issuer, supportedCredential, signingKeyPair) {
        this.g6e_1 = clock;
        this.h6e_1 = issuerMetadataLoader;
        this.i6e_1 = issuer;
        this.j6e_1 = supportedCredential;
        this.k6e_1 = signingKeyPair;
    }
    protoOf(VcSdJwtVerifiableCredentialResponseValidator).y65 = function(response, $completion) {
        var tmp = new $validateVcSdJwtCOROUTINE$15(this, response, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator).p65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator).w65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
    };
    protoOf(VcSdJwtVerifiableCredentialResponseValidator).x65 = function(response, $completion) {
        throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
    };
    function CredentialFinderResult(data) {
        this.v6e_1 = data;
    }
    protoOf(CredentialFinderResult).toString = function() {
        return "CredentialFinderResult(data=" + toString(this.v6e_1) + ")";
    };
    protoOf(CredentialFinderResult).hashCode = function() {
        return hashCode(this.v6e_1);
    };
    protoOf(CredentialFinderResult).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof CredentialFinderResult)) return false;
        var tmp0_other_with_cast = other instanceof CredentialFinderResult ? other : THROW_CCE();
        if (!equals(this.v6e_1, tmp0_other_with_cast.v6e_1)) return false;
        return true;
    };
    function InMemoryPreRegisteredClientStore() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.w6e_1 = LinkedHashMap_init_$Create$_0();
    }
    protoOf(InMemoryPreRegisteredClientStore).x6e = function(clientId, $completion) {
        return this.w6e_1.e2(clientId);
    };
    protoOf(InMemoryPreRegisteredClientStore).y6e = function(preRegistredClient, $completion) {
        // Inline function 'kotlin.collections.set' call
        var this_0 = this.w6e_1;
        var key = preRegistredClient.z6e_1;
        this_0.m2(key, preRegistredClient);
        return Unit_instance;
    };
    protoOf(InMemoryPreRegisteredClientStore).d6f = function($completion) {
        return toList(this.w6e_1.g2());
    };
    function Companion_4() {
        Companion_instance_13 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.e6f_1 = [
            new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_9())
        ];
    }
    var Companion_instance_13;
    function Companion_getInstance_11() {
        if (Companion_instance_13 == null) new Companion_4();
        return Companion_instance_13;
    }
    function $serializer_1() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.services.InMemoryRequestJwtStore", this, 1);
        tmp0_serialDesc.wy("memory", true);
        this.f6f_1 = tmp0_serialDesc;
    }
    protoOf($serializer_1).g6f = function(encoder, value) {
        var tmp0_desc = this.f6f_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_11().e6f_1;
        var tmp;
        if (tmp1_output.ht(tmp0_desc, 0)) tmp = true;
        else {
            // Inline function 'kotlin.collections.mutableMapOf' call
            var tmp$ret$0 = LinkedHashMap_init_$Create$_0();
            tmp = !equals(value.h6f_1, tmp$ret$0);
        }
        if (tmp) tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.h6f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_1).zn = function(encoder, value) {
        return this.g6f(encoder, value instanceof InMemoryRequestJwtStore ? value : THROW_CCE());
    };
    protoOf($serializer_1).ao = function(decoder) {
        var tmp0_desc = this.f6f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.lr(tmp0_desc);
        var tmp6_cached = Companion_getInstance_11().e6f_1;
        if (tmp5_input.as()) {
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else while(tmp1_flag){
            tmp2_index = tmp5_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp5_input.mr(tmp0_desc);
        return InMemoryRequestJwtStore_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
    };
    protoOf($serializer_1).yn = function() {
        return this.f6f_1;
    };
    protoOf($serializer_1).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            Companion_getInstance_11().e6f_1[0]
        ];
    };
    var $serializer_instance_1;
    function $serializer_getInstance_6() {
        if ($serializer_instance_1 == null) new $serializer_1();
        return $serializer_instance_1;
    }
    function InMemoryRequestJwtStore_init_$Init$(seen0, memory, serializationConstructorMarker, $this) {
        if (!(0 === (0 & seen0))) throwMissingFieldException(seen0, 0, $serializer_getInstance_6().f6f_1);
        if (0 === (seen0 & 1)) {
            var tmp = $this;
            // Inline function 'kotlin.collections.mutableMapOf' call
            tmp.h6f_1 = LinkedHashMap_init_$Create$_0();
        } else $this.h6f_1 = memory;
        return $this;
    }
    function InMemoryRequestJwtStore_init_$Create$(seen0, memory, serializationConstructorMarker) {
        return InMemoryRequestJwtStore_init_$Init$(seen0, memory, serializationConstructorMarker, objectCreate(protoOf(InMemoryRequestJwtStore)));
    }
    function InMemoryRequestJwtStore() {
        Companion_getInstance_11();
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.h6f_1 = LinkedHashMap_init_$Create$_0();
    }
    protoOf(InMemoryRequestJwtStore).i6f = function(id, requestJwt) {
        // Inline function 'kotlin.collections.set' call
        this.h6f_1.m2(id, requestJwt);
    };
    protoOf(InMemoryRequestJwtStore).q68 = function(id) {
        this.h6f_1.n2(id);
    };
    protoOf(InMemoryRequestJwtStore).r68 = function(id) {
        return this.h6f_1.e2(id);
    };
    protoOf(InMemoryRequestJwtStore).u68 = function() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.h6f_1.z();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.vp.services.InMemoryRequestJwtStore.getAll.<anonymous>' call
            var tmp$ret$0 = new Pair(item.a1(), item.b1());
            destination.e(tmp$ret$0);
        }
        return destination;
    };
    function Companion_5() {}
    protoOf(Companion_5).j6f = function(field) {
        var fieldFilter = field.e3e_1;
        var tmp;
        if (fieldFilter instanceof JsonArrayContainsFilter) {
            var tmp_0;
            var tmp$ret$0;
            $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var this_0 = field.d3e_1;
                var tmp_1;
                if (isInterface(this_0, Collection)) tmp_1 = this_0.s();
                else tmp_1 = false;
                if (tmp_1) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
                var tmp0_iterator = this_0.j();
                while(tmp0_iterator.k()){
                    var element = tmp0_iterator.l();
                    // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
                    if (element === "$.vc.type") {
                        tmp$ret$0 = true;
                        break $l$block_0;
                    }
                }
                tmp$ret$0 = false;
            }
            if (tmp$ret$0) tmp_0 = new JwtVcJsonType(fieldFilter.j3e_1.n3e_1);
            else tmp_0 = null;
            tmp = tmp_0;
        } else {
            if (fieldFilter instanceof JsonStringFilter) {
                var tmp_2;
                var tmp$ret$2;
                $l$block_2: {
                    // Inline function 'kotlin.collections.any' call
                    var this_1 = field.d3e_1;
                    var tmp_3;
                    if (isInterface(this_1, Collection)) tmp_3 = this_1.s();
                    else tmp_3 = false;
                    if (tmp_3) {
                        tmp$ret$2 = false;
                        break $l$block_2;
                    }
                    var tmp0_iterator_0 = this_1.j();
                    while(tmp0_iterator_0.k()){
                        var element_0 = tmp0_iterator_0.l();
                        // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
                        if (element_0 === "$.vc.issuer") {
                            tmp$ret$2 = true;
                            break $l$block_2;
                        }
                    }
                    tmp$ret$2 = false;
                }
                if (tmp$ret$2) tmp_2 = new JwtVcJsonIssuer(fieldFilter.r3e_1);
                else {
                    var tmp$ret$4;
                    $l$block_4: {
                        // Inline function 'kotlin.collections.any' call
                        var this_2 = field.d3e_1;
                        var tmp_4;
                        if (isInterface(this_2, Collection)) tmp_4 = this_2.s();
                        else tmp_4 = false;
                        if (tmp_4) {
                            tmp$ret$4 = false;
                            break $l$block_4;
                        }
                        var tmp0_iterator_1 = this_2.j();
                        while(tmp0_iterator_1.k()){
                            var element_1 = tmp0_iterator_1.l();
                            // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
                            if (element_1 === "$.iss") {
                                tmp$ret$4 = true;
                                break $l$block_4;
                            }
                        }
                        tmp$ret$4 = false;
                    }
                    if (tmp$ret$4) tmp_2 = new VcSdJwtIssuer(fieldFilter.r3e_1);
                    else {
                        var tmp$ret$6;
                        $l$block_6: {
                            // Inline function 'kotlin.collections.any' call
                            var this_3 = field.d3e_1;
                            var tmp_5;
                            if (isInterface(this_3, Collection)) tmp_5 = this_3.s();
                            else tmp_5 = false;
                            if (tmp_5) {
                                tmp$ret$6 = false;
                                break $l$block_6;
                            }
                            var tmp0_iterator_2 = this_3.j();
                            while(tmp0_iterator_2.k()){
                                var element_2 = tmp0_iterator_2.l();
                                // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
                                if (element_2 === "$.vct") {
                                    tmp$ret$6 = true;
                                    break $l$block_6;
                                }
                            }
                            tmp$ret$6 = false;
                        }
                        if (tmp$ret$6) tmp_2 = new VcSdJwtType(fieldFilter.r3e_1);
                        else tmp_2 = null;
                    }
                }
                tmp = tmp_2;
            } else if (fieldFilter == null) tmp = null;
            else noWhenBranchMatchedException();
        }
        return tmp;
    };
    var Companion_instance_14;
    function Companion_getInstance_12() {
        return Companion_instance_14;
    }
    function JwtVcJsonIssuer(issuerPattern) {
        this.k6f_1 = issuerPattern;
    }
    protoOf(JwtVcJsonIssuer).l6f = function(credential) {
        var credentialResponse = credential.e33_1;
        var tmp;
        if (credentialResponse instanceof DidValidatedJwtVcJsonCredentialResponse) {
            var issuer = credentialResponse.g31_1.x3b_1;
            var tmp_0;
            if (issuer instanceof IssuerURI_0) tmp_0 = Regex_init_$Create$(this.k6f_1).ic(issuer.m36_1);
            else if (issuer instanceof IssuerObject_0) tmp_0 = Regex_init_$Create$(this.k6f_1).ic(issuer.k3c_1);
            else tmp_0 = false;
            tmp = tmp_0;
        } else tmp = false;
        return tmp;
    };
    function JwtVcJsonType(typePattern) {
        this.m6f_1 = Regex_init_$Create$(typePattern);
    }
    protoOf(JwtVcJsonType).l6f = function(credential) {
        var credentialResponse = credential.e33_1;
        var tmp;
        if (credentialResponse instanceof DidValidatedJwtVcJsonCredentialResponse) {
            var tmp$ret$0;
            $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var this_0 = credentialResponse.g31_1.v3b_1;
                var tmp_0;
                if (isInterface(this_0, Collection)) tmp_0 = this_0.s();
                else tmp_0 = false;
                if (tmp_0) {
                    tmp$ret$0 = false;
                    break $l$block_0;
                }
                var tmp0_iterator = this_0.j();
                while(tmp0_iterator.k()){
                    var element = tmp0_iterator.l();
                    // Inline function 'io.curity.vp.services.JwtVcJsonType.matches.<anonymous>' call
                    if (this.m6f_1.ic(element)) {
                        tmp$ret$0 = true;
                        break $l$block_0;
                    }
                }
                tmp$ret$0 = false;
            }
            tmp = tmp$ret$0;
        } else tmp = false;
        return tmp;
    };
    function VcSdJwtIssuer(issuerPattern) {
        this.n6f_1 = issuerPattern;
        this.o6f_1 = Regex_init_$Create$(this.n6f_1);
    }
    protoOf(VcSdJwtIssuer).l6f = function(credential) {
        var credentialResponse = credential.e33_1;
        var tmp;
        if (credentialResponse instanceof DefaultValidatedVcSdJwtCredentialResponse) tmp = this.o6f_1.ic(credentialResponse.x30_1);
        else tmp = false;
        return tmp;
    };
    function VcSdJwtType(typePattern) {
        this.p6f_1 = typePattern;
        this.q6f_1 = Regex_init_$Create$(this.p6f_1);
    }
    protoOf(VcSdJwtType).l6f = function(credential) {
        var credentialResponse = credential.e33_1;
        var tmp;
        if (credentialResponse instanceof DefaultValidatedVcSdJwtCredentialResponse) tmp = this.q6f_1.ic(credentialResponse.y30_1);
        else tmp = false;
        return tmp;
    };
    function getRequestedConstraintsAsMatchers($this, constraintFields) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(constraintFields, 10));
        var tmp0_iterator = constraintFields.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.getRequestedConstraintsAsMatchers.<anonymous>' call
            var tmp0_elvis_lhs = Companion_instance_14.j6f(item);
            var tmp;
            if (tmp0_elvis_lhs == null) {
                var message = "Unsupported field filter " + item.toString();
                throw IllegalStateException_init_$Create$(toString(message));
            } else tmp = tmp0_elvis_lhs;
            var tmp$ret$0 = tmp;
            destination.e(tmp$ret$0);
        }
        return destination;
    }
    function OpenIdWalletAuthenticatorCredentialFinder(credentialStore) {
        this.r6f_1 = credentialStore;
    }
    protoOf(OpenIdWalletAuthenticatorCredentialFinder).s6f = function(presentationDefinition, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = presentationDefinition.k3d_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>' call
            var tmp0_elvis_lhs = item.q3d_1.v3d_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
                var message = "Unsupported presentation_definition format (missing 'fields').";
                throw IllegalStateException_init_$Create$(toString(message));
            } else tmp = tmp0_elvis_lhs;
            var constraintFields = tmp;
            var matchers = getRequestedConstraintsAsMatchers(this, constraintFields);
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var this_1 = this.r6f_1.u68();
            var destination_0 = ArrayList_init_$Create$_0();
            var tmp0_iterator_0 = this_1.j();
            while(tmp0_iterator_0.k()){
                var element = tmp0_iterator_0.l();
                // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>.<anonymous>' call
                var tmp$ret$0;
                $l$block_0: {
                    // Inline function 'kotlin.collections.all' call
                    var tmp_0;
                    if (isInterface(matchers, Collection)) tmp_0 = matchers.s();
                    else tmp_0 = false;
                    if (tmp_0) {
                        tmp$ret$0 = true;
                        break $l$block_0;
                    }
                    var tmp0_iterator_1 = matchers.j();
                    while(tmp0_iterator_1.k()){
                        var element_0 = tmp0_iterator_1.l();
                        // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>.<anonymous>.<anonymous>' call
                        if (!element_0.l6f(element)) {
                            tmp$ret$0 = false;
                            break $l$block_0;
                        }
                    }
                    tmp$ret$0 = true;
                }
                if (tmp$ret$0) destination_0.e(element);
            }
            var credentials = destination_0;
            var tmp$ret$5 = to(item, credentials);
            destination.e(tmp$ret$5);
        }
        var data = destination;
        return new CredentialFinderResult(data);
    };
    function Companion_6() {
        Companion_instance_15 = this;
        this.t6f_1 = listOf("https://www.w3.org/2018/credentials/v1");
        this.u6f_1 = listOf("VerifiablePresentation");
    }
    var Companion_instance_15;
    function Companion_getInstance_13() {
        if (Companion_instance_15 == null) new Companion_6();
        return Companion_instance_15;
    }
    function createVerifiablePresentation($this, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, $completion) {
        var tmp = new $createVerifiablePresentationCOROUTINE$20($this, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function createVpJwt($this, validatedRequestJwt, w3cPresentation, vc, $completion) {
        var tmp = new $createVpJwtCOROUTINE$21($this, validatedRequestJwt, w3cPresentation, vc, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function createVpSdJwt($this, validatedRequestJwt, vc, presentationDisclosures, kid, $completion) {
        var tmp = new $createVpSdJwtCOROUTINE$22($this, validatedRequestJwt, vc, presentationDisclosures, kid, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function getVerifiablePresentationIssuer($this, credential) {
        var parsedVc = JwsUtil_getInstance().r2a(credential);
        var tmp64_safe_receiver = parsedVc.k29_1.vl("vc");
        var tmp0_elvis_lhs = tmp64_safe_receiver == null ? null : get_jsonObject(tmp64_safe_receiver);
        var tmp;
        if (tmp0_elvis_lhs == null) {
            var message = "missing vc claim";
            throw IllegalStateException_init_$Create$(toString(message));
        } else tmp = tmp0_elvis_lhs;
        var vcClaim = tmp;
        var tmp65_safe_receiver = vcClaim.vl("credentialSubject");
        var tmp1_elvis_lhs = tmp65_safe_receiver == null ? null : get_jsonObject(tmp65_safe_receiver);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
            var message_0 = "missing credentialSubject claim";
            throw IllegalStateException_init_$Create$(toString(message_0));
        } else tmp_0 = tmp1_elvis_lhs;
        var credentialSubject = tmp_0;
        var tmp66_safe_receiver = credentialSubject.vl("id");
        var tmp67_safe_receiver = tmp66_safe_receiver == null ? null : get_jsonPrimitive(tmp66_safe_receiver);
        var tmp2_elvis_lhs = tmp67_safe_receiver == null ? null : tmp67_safe_receiver.e1b();
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
            var message_1 = "Cannot create a presentation from credential which doesn't have credential subject.";
            throw IllegalStateException_init_$Create$(toString(message_1));
        } else tmp_1 = tmp2_elvis_lhs;
        var credSubjectString = tmp_1;
        var tmp3_elvis_lhs = Companion_getInstance_2().d2i(credSubjectString + "#0");
        var tmp_2;
        if (tmp3_elvis_lhs == null) {
            var message_2 = "Cannot create a presentation because credential subject is not a DID.";
            throw IllegalStateException_init_$Create$(toString(message_2));
        } else tmp_2 = tmp3_elvis_lhs;
        var didUrl = tmp_2;
        return didUrl;
    }
    function createPresentationSubmission($this, validatedRequestJwt, descriptorMapObjects) {
        return new JsonPresentationSubmission(Companion_instance_3.t28(16), validatedRequestJwt.j6i_1.g3d_1, descriptorMapObjects);
    }
    function PresentationResponseCreator$createVpSdJwt$slambda(resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(PresentationResponseCreator$createVpSdJwt$slambda).o2z = function(it, $completion) {
        var tmp = this.p2z(it, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(PresentationResponseCreator$createVpSdJwt$slambda).y9 = function(p1, $completion) {
        return this.o2z((!(p1 == null) ? typeof p1 === "string" : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(PresentationResponseCreator$createVpSdJwt$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                return JwsUtil_getInstance().r2a(this.u6i_1);
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(PresentationResponseCreator$createVpSdJwt$slambda).p2z = function(it, completion) {
        var i = new PresentationResponseCreator$createVpSdJwt$slambda(completion);
        i.u6i_1 = it;
        return i;
    };
    function PresentationResponseCreator$createVpSdJwt$slambda_0(resultContinuation) {
        var i = new PresentationResponseCreator$createVpSdJwt$slambda(resultContinuation);
        var l = function(it, $completion) {
            return i.o2z(it, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $createVerifiablePresentationResponseCOROUTINE$19(_this__u8e3s4, validatedRequestJwt, userSelectedCredentials, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.d6j_1 = _this__u8e3s4;
        this.e6j_1 = validatedRequestJwt;
        this.f6j_1 = userSelectedCredentials;
    }
    protoOf($createVerifiablePresentationResponseCOROUTINE$19).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    if (this.f6j_1.y6j_1.m() === 1) {
                        this.h6j_1 = first(this.f6j_1.y6j_1);
                        this.i6j_1 = this.h6j_1.z6j_1;
                        this.j6j_1 = this.h6j_1.a6k_1;
                        this.k6j_1 = this.h6j_1.b6k_1;
                        this.l6j_1 = "$";
                        this.v8_1 = 4;
                        suspendResult = createVerifiablePresentation(this.d6j_1, this.e6j_1, this.i6j_1, this.j6j_1, this.l6j_1, this.k6j_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_0 = this;
                        tmp_0.m6j_1 = this.f6j_1.y6j_1;
                        var tmp_1 = this;
                        tmp_1.n6j_1 = this.m6j_1;
                        var tmp_2 = this;
                        tmp_2.o6j_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this.m6j_1, 10));
                        this.p6j_1 = 0;
                        this.q6j_1 = this.n6j_1.j();
                        this.v8_1 = 1;
                        continue $sm;
                    }
                case 1:
                    if (!this.q6j_1.k()) {
                        this.v8_1 = 3;
                        continue $sm;
                    }
                    this.r6j_1 = this.q6j_1.l();
                    var tmp_3 = this;
                    var tmp1 = this.p6j_1;
                    this.p6j_1 = tmp1 + 1 | 0;
                    tmp_3.s6j_1 = checkIndexOverflow(tmp1);
                    var tmp_4 = this;
                    tmp_4.t6j_1 = this.r6j_1;
                    this.u6j_1 = this.t6j_1.z6j_1;
                    this.v6j_1 = this.t6j_1.a6k_1;
                    this.w6j_1 = this.t6j_1.b6k_1;
                    this.x6j_1 = "$[" + this.s6j_1 + "]";
                    this.v8_1 = 2;
                    suspendResult = createVerifiablePresentation(this.d6j_1, this.e6j_1, this.u6j_1, this.v6j_1, this.x6j_1, this.w6j_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var ARGUMENT = suspendResult;
                    this.o6j_1.e(ARGUMENT);
                    this.v8_1 = 1;
                    continue $sm;
                case 3:
                    this.g6j_1 = this.o6j_1;
                    this.v8_1 = 5;
                    continue $sm;
                case 4:
                    var ARGUMENT_0 = suspendResult;
                    this.g6j_1 = listOf(ARGUMENT_0);
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    var descriptorsAndPresentations = this.g6j_1;
                    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(descriptorsAndPresentations, 10));
                    var tmp0_iterator = descriptorsAndPresentations.j();
                    while(tmp0_iterator.k()){
                        var item = tmp0_iterator.l();
                        destination.e(item.z9_1);
                    }
                    var descriptors = destination;
                    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(descriptorsAndPresentations, 10));
                    var tmp0_iterator_0 = descriptorsAndPresentations.j();
                    while(tmp0_iterator_0.k()){
                        var item_0 = tmp0_iterator_0.l();
                        destination_0.e(item_0.aa_1);
                    }
                    var presentations = destination_0;
                    return new VerifiablePresentationResponseParameters(DefaultJsonMultiValue_init_$Create$_0(presentations), createPresentationSubmission(this.d6j_1, this.e6j_1, descriptors), this.e6j_1.k6i_1);
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $createVerifiablePresentationCOROUTINE$20(_this__u8e3s4, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.d6g_1 = _this__u8e3s4;
        this.e6g_1 = validatedRequestJwt;
        this.f6g_1 = inputDescriptor;
        this.g6g_1 = credential;
        this.h6g_1 = topLevelJsonPath;
        this.i6g_1 = presentationDisclosures;
    }
    protoOf($createVerifiablePresentationCOROUTINE$20).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.j6g_1 = this.g6g_1.e33_1;
                    var tmp_0 = this.j6g_1;
                    if (tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse) {
                        var tmp_1;
                        if (!(this.i6g_1 == null)) tmp_1 = !this.i6g_1.c6k_1.s();
                        else tmp_1 = false;
                        if (tmp_1) {
                            var message = "presentation disclosures cannot be used with the 'jwt_vc_json' format";
                            throw IllegalStateException_init_$Create$(toString(message));
                        }
                        this.l6g_1 = new SerializableW3CVerifiablePresentation(VOID, Companion_getInstance_13().t6f_1, Companion_getInstance_13().u6f_1, VOID, VOID, DefaultJsonMultiValue_init_$Create$(new StringCredential(this.j6g_1.f31_1)));
                        this.m6g_1 = this.f6g_1.r3d_1;
                        if (!(this.m6g_1 == null) && (this.m6g_1.s3e_1 == null || this.m6g_1.t3e_1 == null)) {
                            var message_0 = "Unsupported presentation format requested: " + toString_0(this.f6g_1.r3d_1);
                            throw IllegalStateException_init_$Create$(toString(message_0));
                        }
                        this.n6g_1 = new JsonDescriptorMapObject(this.f6g_1.n3d_1, "jwt_vp_json", this.h6g_1, new JsonPathNested("jwt_vc_json", "$.vp.verifiableCredential"));
                        this.v8_1 = 2;
                        suspendResult = createVpJwt(this.d6g_1, this.e6g_1, this.l6g_1, this.j6g_1.f31_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_2 = this.j6g_1;
                        if (tmp_2 instanceof DefaultValidatedVcSdJwtCredentialResponse) {
                            this.o6g_1 = new JsonDescriptorMapObject(this.f6g_1.n3d_1, "vc+sd-jwt", this.h6g_1, null);
                            this.v8_1 = 1;
                            var tmp55_safe_receiver = this.i6g_1;
                            var tmp0_elvis_lhs = tmp55_safe_receiver == null ? null : tmp55_safe_receiver.c6k_1;
                            suspendResult = createVpSdJwt(this.d6g_1, this.e6g_1, this.j6g_1.w30_1, tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, this.j6g_1.a31_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            var tmp_3 = this;
                            var message_1 = "Unsupported credential type: " + getKClassFromExpression(this.g6g_1.e33_1).fa();
                            throw IllegalStateException_init_$Create$(toString(message_1));
                        }
                    }
                case 1:
                    var ARGUMENT = suspendResult;
                    var presentation = new JsonStringVerifiablePresentation(ARGUMENT);
                    this.k6g_1 = to(this.o6g_1, presentation);
                    this.v8_1 = 3;
                    continue $sm;
                case 2:
                    var ARGUMENT_0 = suspendResult;
                    var presentation_0 = new JsonStringVerifiablePresentation(ARGUMENT_0);
                    this.k6g_1 = to(this.n6g_1, presentation_0);
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.k6g_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $createVpJwtCOROUTINE$21(_this__u8e3s4, validatedRequestJwt, w3cPresentation, vc, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.x6g_1 = _this__u8e3s4;
        this.y6g_1 = validatedRequestJwt;
        this.z6g_1 = w3cPresentation;
        this.a6h_1 = vc;
    }
    protoOf($createVpJwtCOROUTINE$21).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 5;
                    this.b6h_1 = getVerifiablePresentationIssuer(this.x6g_1, this.a6h_1);
                    this.c6h_1 = new JsonJwsHeader("ES256", "JWT", VOID, VOID, VOID, this.b6h_1.toString());
                    this.d6h_1 = this.x6g_1.d6k_1.u1l();
                    this.e6h_1 = this.b6h_1.e2i_1.l2i_1;
                    var tmp_0 = this;
                    var tmp56_jti = Companion_instance_3.t28(32);
                    var tmp57_aud = DefaultJsonMultiValue_init_$Create$(this.y6g_1.h6i_1);
                    var tmp58_nbf = this.d6h_1.f1m();
                    var tmp59_exp = this.d6h_1.f1m().y2(toLong(3600));
                    var tmp60_customClaims = mapOf(to("vp", this.z6g_1.a27()));
                    tmp_0.f6h_1 = new JsonJwtClaimsSet(this.e6h_1, VOID, tmp57_aud, tmp59_exp, tmp58_nbf, VOID, tmp56_jti, VOID, tmp60_customClaims);
                    this.v8_1 = 1;
                    suspendResult = this.x6g_1.e6k_1.k68(this.b6h_1.toString(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.g6h_1 = suspendResult;
                    if (this.g6h_1 == null) {
                        this.h6h_1 = null;
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        var tmp_1 = this;
                        tmp_1.i6h_1 = this.g6h_1;
                        var tmp_2 = this;
                        tmp_2.j6h_1 = this.i6h_1;
                        this.v8_1 = 2;
                        suspendResult = this.x6g_1.f6k_1.g2b(this.j6h_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 2:
                    this.k6h_1 = suspendResult;
                    this.h6h_1 = this.k6h_1 == null ? null : this.k6h_1.u28_1;
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.l6h_1 = this.h6h_1;
                    var tmp_3 = this;
                    var tmp_4;
                    if (this.l6h_1 == null) {
                        var message = "Cannot create a presentation. Missing private key for DID URL: " + this.b6h_1.toString();
                        throw IllegalStateException_init_$Create$(toString(message));
                    } else tmp_4 = this.l6h_1;
                    tmp_3.m6h_1 = tmp_4;
                    this.v8_1 = 4;
                    suspendResult = JwsUtil_getInstance().j2d(this.m6h_1, this.c6h_1, this.f6h_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 4:
                    return suspendResult;
                case 5:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 5) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $createVpSdJwtCOROUTINE$22(_this__u8e3s4, validatedRequestJwt, vc, presentationDisclosures, kid, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.v6h_1 = _this__u8e3s4;
        this.w6h_1 = validatedRequestJwt;
        this.x6h_1 = vc;
        this.y6h_1 = presentationDisclosures;
        this.z6h_1 = kid;
    }
    protoOf($createVpSdJwtCOROUTINE$22).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.v8_1 = 1;
                    var tmp_0 = Companion_instance_2;
                    suspendResult = tmp_0.b2w(this.x6h_1, VOID, PresentationResponseCreator$createVpSdJwt$slambda_0(null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.a6i_1 = suspendResult;
                    if (!(this.a6i_1.x2n_1 == null) || !(this.a6i_1.w2n_1 == null)) throw IllegalArgumentException_init_$Create$("Credential SD-JWT cannot have a KB-JWT");
                    this.v8_1 = 2;
                    suspendResult = this.v6h_1.f6k_1.g2b(this.z6h_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.b6i_1 = suspendResult;
                    this.c6i_1 = this.b6i_1 == null ? null : this.b6i_1.u28_1;
                    var tmp_1 = this;
                    var tmp_2;
                    if (this.c6i_1 == null) {
                        var message = "Cannot create a presentation. Missing private key with id: " + this.z6h_1;
                        throw IllegalStateException_init_$Create$(toString(message));
                    } else tmp_2 = this.c6i_1;
                    tmp_1.d6i_1 = tmp_2;
                    var tmp$ret$0;
                    l$ret$1: {
                        var this_0 = this.y6h_1;
                        var tmp_3;
                        if (isInterface(this_0, Collection)) tmp_3 = this_0.s();
                        else tmp_3 = false;
                        if (tmp_3) {
                            tmp$ret$0 = false;
                            break l$ret$1;
                        }
                        var tmp0_iterator = this_0.j();
                        while(tmp0_iterator.k()){
                            var element = tmp0_iterator.l();
                            if (!this.a6i_1.v2n_1.a2(element)) {
                                tmp$ret$0 = true;
                                break l$ret$1;
                            }
                        }
                        tmp$ret$0 = false;
                    }
                    if (tmp$ret$0) {
                        var message_0 = "A presentation disclosure is not in the originally issued SD-JWT";
                        throw IllegalStateException_init_$Create$(toString(message_0));
                    }
                    this.e6i_1 = "ES256";
                    this.v8_1 = 3;
                    suspendResult = SdJwtKeyBindingBuilder_instance.u2r(this.v6h_1.d6k_1.u1l(), this.w6h_1.h6i_1, this.w6h_1.i6i_1, this.a6i_1.t2n_1, this.a6i_1.s2n_1, this.y6h_1, this.d6i_1, this.e6i_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var kbJwtString = suspendResult;
                    return Companion_instance_4.m2n(this.a6i_1.s2n_1, this.y6h_1, kbJwtString);
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function PresentationResponseCreator(clock, keyAliasStore, keyStore) {
        Companion_getInstance_13();
        this.d6k_1 = clock;
        this.e6k_1 = keyAliasStore;
        this.f6k_1 = keyStore;
    }
    protoOf(PresentationResponseCreator).g6k = function(validatedRequestJwt, userSelectedCredentials, $completion) {
        var tmp = new $createVerifiablePresentationResponseCOROUTINE$19(this, validatedRequestJwt, userSelectedCredentials, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function UserSelectedCredentials(data) {
        this.y6j_1 = data;
    }
    protoOf(UserSelectedCredentials).toString = function() {
        return "UserSelectedCredentials(data=" + toString(this.y6j_1) + ")";
    };
    protoOf(UserSelectedCredentials).hashCode = function() {
        return hashCode(this.y6j_1);
    };
    protoOf(UserSelectedCredentials).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof UserSelectedCredentials)) return false;
        var tmp0_other_with_cast = other instanceof UserSelectedCredentials ? other : THROW_CCE();
        if (!equals(this.y6j_1, tmp0_other_with_cast.y6j_1)) return false;
        return true;
    };
    function UserSelectedCredential(descriptor, credential, presentationDisclosure) {
        this.z6j_1 = descriptor;
        this.a6k_1 = credential;
        this.b6k_1 = presentationDisclosure;
    }
    protoOf(UserSelectedCredential).toString = function() {
        return "UserSelectedCredential(descriptor=" + this.z6j_1.toString() + ", credential=" + this.a6k_1.toString() + ", presentationDisclosure=" + this.b6k_1.toString() + ")";
    };
    protoOf(UserSelectedCredential).hashCode = function() {
        var result = this.z6j_1.hashCode();
        result = imul(result, 31) + this.a6k_1.hashCode() | 0;
        result = imul(result, 31) + this.b6k_1.hashCode() | 0;
        return result;
    };
    protoOf(UserSelectedCredential).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof UserSelectedCredential)) return false;
        var tmp0_other_with_cast = other instanceof UserSelectedCredential ? other : THROW_CCE();
        if (!this.z6j_1.equals(tmp0_other_with_cast.z6j_1)) return false;
        if (!this.a6k_1.equals(tmp0_other_with_cast.a6k_1)) return false;
        if (!this.b6k_1.equals(tmp0_other_with_cast.b6k_1)) return false;
        return true;
    };
    function PresentationDisclosure(disclosures) {
        this.c6k_1 = disclosures;
    }
    protoOf(PresentationDisclosure).toString = function() {
        return "PresentationDisclosure(disclosures=" + toString(this.c6k_1) + ")";
    };
    protoOf(PresentationDisclosure).hashCode = function() {
        return hashCode(this.c6k_1);
    };
    protoOf(PresentationDisclosure).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof PresentationDisclosure)) return false;
        var tmp0_other_with_cast = other instanceof PresentationDisclosure ? other : THROW_CCE();
        if (!equals(this.c6k_1, tmp0_other_with_cast.c6k_1)) return false;
        return true;
    };
    function $fetchRequestObjectJwtCOROUTINE$23(_this__u8e3s4, uri, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.p6k_1 = _this__u8e3s4;
        this.q6k_1 = uri;
    }
    protoOf($fetchRequestObjectJwtCOROUTINE$23).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    tmp_0.r6k_1 = this.p6k_1.c6l_1;
                    var tmp_1 = this;
                    tmp_1.s6k_1 = this.q6k_1;
                    var tmp_2 = this;
                    tmp_2.t6k_1 = this.r6k_1;
                    var tmp_3 = this;
                    tmp_3.u6k_1 = this.t6k_1;
                    var tmp_4 = this;
                    var this_0 = new HttpRequestBuilder();
                    url(this_0, this.s6k_1);
                    header(this_0, "Accept", "application/jwt");
                    tmp_4.v6k_1 = this_0;
                    this.v6k_1.n4t_1 = Companion_getInstance().n4d_1;
                    var tmp_5 = this;
                    tmp_5.w6k_1 = this.u6k_1;
                    var tmp_6 = this;
                    tmp_6.x6k_1 = this.v6k_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.x6k_1, this.w6k_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.y6k_1 = suspendResult;
                    if (!this.y6k_1.y4v().equals(Companion_getInstance_4().h4e_1)) throw RuntimeException_init_$Create$("Unexpected response while fetching request object. Got status: " + this.y6k_1.y4v().h4g_1);
                    this.z6k_1 = this.p6k_1.d6l_1;
                    var tmp_7 = this;
                    tmp_7.a6l_1 = this.y6k_1;
                    this.v8_1 = 2;
                    var tmp_8 = this.a6l_1.t4w();
                    var tmp_9 = JsType_instance;
                    var tmp_10 = PrimitiveClasses_getInstance().gb();
                    var tmp_11;
                    try {
                        tmp_11 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_12;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_12 = null;
                        } else throw $p;
                        tmp_11 = tmp_12;
                    }
                    suspendResult = tmp_8.x4v(typeInfoImpl(tmp_9, tmp_10, tmp_11), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var tmp_13 = this;
                    tmp_13.b6l_1 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 3;
                    suspendResult = this.z6k_1.h6l(this.b6l_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    return suspendResult;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $postDirectPostAuthorizationResponseCOROUTINE$24(_this__u8e3s4, uri, params, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.q6l_1 = _this__u8e3s4;
        this.r6l_1 = uri;
        this.s6l_1 = params;
    }
    protoOf($postDirectPostAuthorizationResponseCOROUTINE$24).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    var this_0 = Default_getInstance();
                    var value = this.s6l_1.z6l_1;
                    var this_1 = this_0.dp();
                    var this_2 = serializer(this_1, createKType(getKClass(JsonPresentationSubmission), arrayOf([]), false));
                    tmp_0.t6l_1 = this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
                    var tmp_1 = this;
                    var this_3 = Default_getInstance();
                    var value_0 = this.s6l_1.y6l_1;
                    var this_4 = this_3.dp();
                    var this_5 = serializer(this_4, createKType(getKClass(DefaultJsonMultiValue), arrayOf([
                        createInvariantKTypeProjection(createKType(getKClass(JsonVerifiablePresentation), arrayOf([]), false))
                    ]), false));
                    tmp_1.u6l_1 = this_3.bp(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), value_0);
                    this.v8_1 = 1;
                    Companion_getInstance_5();
                    var this_6 = ParametersBuilder();
                    this_6.w43("vp_token", this.u6l_1);
                    this_6.w43("presentation_submission", this.t6l_1);
                    if (!(this.s6l_1.a6m_1 == null)) this_6.w43("state", this.s6l_1.a6m_1);
                    suspendResult = submitForm(this.q6l_1.c6l_1, this.r6l_1, this_6.c3r(), VOID, VOID, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.v6l_1 = suspendResult;
                    if (this.v6l_1.y4v().equals(Companion_getInstance_4().h4e_1)) {
                        var tmp_2 = this;
                        tmp_2.x6l_1 = this.v6l_1;
                        this.v8_1 = 2;
                        var tmp_3 = this.x6l_1.t4w();
                        var tmp_4 = JsType_instance;
                        var tmp_5 = getKClass(JsonVerifierDirectPostAuthorizationResponse);
                        var tmp_6;
                        try {
                            tmp_6 = createKType(getKClass(JsonVerifierDirectPostAuthorizationResponse), arrayOf([]), false);
                        } catch ($p) {
                            var tmp_7;
                            if ($p instanceof Error) {
                                var cause = $p;
                                tmp_7 = null;
                            } else throw $p;
                            tmp_6 = tmp_7;
                        }
                        suspendResult = tmp_3.x4v(typeInfoImpl(tmp_4, tmp_5, tmp_6), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    } else {
                        var tmp_8 = this;
                        throw Exception_init_$Create$("Validating verifiable presentations failed: " + this.v6l_1.y4v().toString());
                    }
                case 2:
                    var tmp_9 = this;
                    tmp_9.w6l_1 = suspendResult instanceof JsonVerifierDirectPostAuthorizationResponse ? suspendResult : THROW_CCE();
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    return this.w6l_1;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function VerifierClient(httpClient, validator) {
        this.c6l_1 = httpClient;
        this.d6l_1 = validator;
    }
    protoOf(VerifierClient).b6m = function(uri, $completion) {
        var tmp = new $fetchRequestObjectJwtCOROUTINE$23(this, uri, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(VerifierClient).c6m = function(uri, params, $completion) {
        var tmp = new $postDirectPostAuthorizationResponseCOROUTINE$24(this, uri, params, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function Companion_7() {
        Companion_instance_16 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.d6m_1 = [
            null,
            null,
            null,
            new ArrayListSerializer($serializer_getInstance_8())
        ];
    }
    var Companion_instance_16;
    function Companion_getInstance_14() {
        if (Companion_instance_16 == null) new Companion_7();
        return Companion_instance_16;
    }
    function $serializer_2() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.services.PreRegisteredClient", this, 4);
        tmp0_serialDesc.wy("clientId", false);
        tmp0_serialDesc.wy("jwksUri", false);
        tmp0_serialDesc.wy("redirectUri", false);
        tmp0_serialDesc.wy("vpFormatsSupported", false);
        this.e6m_1 = tmp0_serialDesc;
    }
    protoOf($serializer_2).f6m = function(encoder, value) {
        var tmp0_desc = this.e6m_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().d6m_1;
        tmp1_output.zs(tmp0_desc, 0, value.z6e_1);
        tmp1_output.zs(tmp0_desc, 1, value.a6f_1);
        tmp1_output.zs(tmp0_desc, 2, value.b6f_1);
        tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.c6f_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_2).zn = function(encoder, value) {
        return this.f6m(encoder, value instanceof PreRegisteredClient ? value : THROW_CCE());
    };
    protoOf($serializer_2).ao = function(decoder) {
        var tmp0_desc = this.e6m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.lr(tmp0_desc);
        var tmp9_cached = Companion_getInstance_14().d6m_1;
        if (tmp8_input.as()) {
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp8_input.xr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else while(tmp1_flag){
            tmp2_index = tmp8_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp8_input.xr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp8_input.mr(tmp0_desc);
        return PreRegisteredClient_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
    };
    protoOf($serializer_2).yn = function() {
        return this.e6m_1;
    };
    protoOf($serializer_2).lz = function() {
        var tmp0_cached = Companion_getInstance_14().d6m_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            tmp0_cached[3]
        ];
    };
    var $serializer_instance_2;
    function $serializer_getInstance_7() {
        if ($serializer_instance_2 == null) new $serializer_2();
        return $serializer_instance_2;
    }
    function PreRegisteredClient_init_$Init$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker, $this) {
        if (!(15 === (15 & seen0))) throwMissingFieldException(seen0, 15, $serializer_getInstance_7().e6m_1);
        $this.z6e_1 = clientId;
        $this.a6f_1 = jwksUri;
        $this.b6f_1 = redirectUri;
        $this.c6f_1 = vpFormatsSupported;
        return $this;
    }
    function PreRegisteredClient_init_$Create$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker) {
        return PreRegisteredClient_init_$Init$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker, objectCreate(protoOf(PreRegisteredClient)));
    }
    function PreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported) {
        Companion_getInstance_14();
        this.z6e_1 = clientId;
        this.a6f_1 = jwksUri;
        this.b6f_1 = redirectUri;
        this.c6f_1 = vpFormatsSupported;
    }
    protoOf(PreRegisteredClient).toString = function() {
        return "PreRegisteredClient(clientId=" + this.z6e_1 + ", jwksUri=" + this.a6f_1 + ", redirectUri=" + this.b6f_1 + ", vpFormatsSupported=" + toString(this.c6f_1) + ")";
    };
    protoOf(PreRegisteredClient).hashCode = function() {
        var result = getStringHashCode(this.z6e_1);
        result = imul(result, 31) + getStringHashCode(this.a6f_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b6f_1) | 0;
        result = imul(result, 31) + hashCode(this.c6f_1) | 0;
        return result;
    };
    protoOf(PreRegisteredClient).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof PreRegisteredClient)) return false;
        var tmp0_other_with_cast = other instanceof PreRegisteredClient ? other : THROW_CCE();
        if (!(this.z6e_1 === tmp0_other_with_cast.z6e_1)) return false;
        if (!(this.a6f_1 === tmp0_other_with_cast.a6f_1)) return false;
        if (!(this.b6f_1 === tmp0_other_with_cast.b6f_1)) return false;
        if (!equals(this.c6f_1, tmp0_other_with_cast.c6f_1)) return false;
        return true;
    };
    function Companion_8() {
        Companion_instance_17 = this;
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.g6m_1 = [
            null,
            new LinkedHashSetSerializer(StringSerializer_getInstance())
        ];
    }
    var Companion_instance_17;
    function Companion_getInstance_15() {
        if (Companion_instance_17 == null) new Companion_8();
        return Companion_instance_17;
    }
    function $serializer_3() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.services.VpFormat", this, 2);
        tmp0_serialDesc.wy("format", false);
        tmp0_serialDesc.wy("algs", false);
        this.h6m_1 = tmp0_serialDesc;
    }
    protoOf($serializer_3).i6m = function(encoder, value) {
        var tmp0_desc = this.h6m_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        var tmp2_cached = Companion_getInstance_15().g6m_1;
        tmp1_output.zs(tmp0_desc, 0, value.j6m_1);
        tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.k6m_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_3).zn = function(encoder, value) {
        return this.i6m(encoder, value instanceof VpFormat ? value : THROW_CCE());
    };
    protoOf($serializer_3).ao = function(decoder) {
        var tmp0_desc = this.h6m_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.lr(tmp0_desc);
        var tmp7_cached = Companion_getInstance_15().g6m_1;
        if (tmp6_input.as()) {
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else while(tmp1_flag){
            tmp2_index = tmp6_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp6_input.mr(tmp0_desc);
        return VpFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
    };
    protoOf($serializer_3).yn = function() {
        return this.h6m_1;
    };
    protoOf($serializer_3).lz = function() {
        var tmp0_cached = Companion_getInstance_15().g6m_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            StringSerializer_getInstance(),
            tmp0_cached[1]
        ];
    };
    var $serializer_instance_3;
    function $serializer_getInstance_8() {
        if ($serializer_instance_3 == null) new $serializer_3();
        return $serializer_instance_3;
    }
    function VpFormat_init_$Init$(seen0, format, algs, serializationConstructorMarker, $this) {
        if (!(3 === (3 & seen0))) throwMissingFieldException(seen0, 3, $serializer_getInstance_8().h6m_1);
        $this.j6m_1 = format;
        $this.k6m_1 = algs;
        return $this;
    }
    function VpFormat_init_$Create$(seen0, format, algs, serializationConstructorMarker) {
        return VpFormat_init_$Init$(seen0, format, algs, serializationConstructorMarker, objectCreate(protoOf(VpFormat)));
    }
    function VpFormat(format, algs) {
        Companion_getInstance_15();
        this.j6m_1 = format;
        this.k6m_1 = algs;
    }
    protoOf(VpFormat).toString = function() {
        return "VpFormat(format=" + this.j6m_1 + ", algs=" + toString(this.k6m_1) + ")";
    };
    protoOf(VpFormat).hashCode = function() {
        var result = getStringHashCode(this.j6m_1);
        result = imul(result, 31) + hashCode(this.k6m_1) | 0;
        return result;
    };
    protoOf(VpFormat).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VpFormat)) return false;
        var tmp0_other_with_cast = other instanceof VpFormat ? other : THROW_CCE();
        if (!(this.j6m_1 === tmp0_other_with_cast.j6m_1)) return false;
        if (!equals(this.k6m_1, tmp0_other_with_cast.k6m_1)) return false;
        return true;
    };
    function WalletMetadata() {
        WalletMetadata_instance = this;
        this.l6m_1 = listOf(new VpFormat("jwt_vp_json", setOf([
            "EdDSA",
            "ES256",
            "ES384",
            "ES512",
            "RS256",
            "RS384",
            "RS512",
            "PS256",
            "PS384",
            "PS512"
        ])));
    }
    var WalletMetadata_instance;
    function WalletMetadata_getInstance() {
        if (WalletMetadata_instance == null) new WalletMetadata();
        return WalletMetadata_instance;
    }
    function Companion_9() {
        this.m6m_1 = "vp_token";
        this.n6m_1 = "presentation_submission";
        this.o6m_1 = "state";
    }
    var Companion_instance_18;
    function Companion_getInstance_16() {
        return Companion_instance_18;
    }
    function VerifiablePresentationResponseParameters(vpToken, presentationSubmission, state) {
        this.y6l_1 = vpToken;
        this.z6l_1 = presentationSubmission;
        this.a6m_1 = state;
    }
    protoOf(VerifiablePresentationResponseParameters).toString = function() {
        return "VerifiablePresentationResponseParameters(vpToken=" + this.y6l_1.toString() + ", presentationSubmission=" + this.z6l_1.toString() + ", state=" + this.a6m_1 + ")";
    };
    protoOf(VerifiablePresentationResponseParameters).hashCode = function() {
        var result = this.y6l_1.hashCode();
        result = imul(result, 31) + this.z6l_1.hashCode() | 0;
        result = imul(result, 31) + (this.a6m_1 == null ? 0 : getStringHashCode(this.a6m_1)) | 0;
        return result;
    };
    protoOf(VerifiablePresentationResponseParameters).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof VerifiablePresentationResponseParameters)) return false;
        var tmp0_other_with_cast = other instanceof VerifiablePresentationResponseParameters ? other : THROW_CCE();
        if (!this.y6l_1.equals(tmp0_other_with_cast.y6l_1)) return false;
        if (!this.z6l_1.equals(tmp0_other_with_cast.z6l_1)) return false;
        if (!(this.a6m_1 == tmp0_other_with_cast.a6m_1)) return false;
        return true;
    };
    function validatePresentationDefinition(_this__u8e3s4, $this, payload) {
        var tmp78_safe_receiver = payload.vl("presentation_definition");
        var tmp79_safe_receiver = tmp78_safe_receiver == null ? null : get_jsonPrimitive(tmp78_safe_receiver);
        var presentationDefinition = tmp79_safe_receiver == null ? null : tmp79_safe_receiver.e1b();
        if (presentationDefinition == null) {
            _this__u8e3s4.vn("Missing presentation_definition claim");
            return null;
        }
        // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(JsonPresentationDefinition), arrayOf([]), true));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        return this_0.cp(tmp$ret$1, presentationDefinition);
    }
    function validateBasicClaims(_this__u8e3s4, $this, claims) {
        var nowInEpochSeconds = $this.q6m_1.u1l().f1m();
        var exp = claims.c2a_1;
        if (exp == null) _this__u8e3s4.vn("exp claim is missing");
        else if (nowInEpochSeconds.j1(exp) > 0) _this__u8e3s4.vn("Request Object expired");
        var nbf = claims.d2a_1;
        if (nbf == null) _this__u8e3s4.vn("nbf claim is missing");
        else if (nowInEpochSeconds.j1(nbf) < 0) _this__u8e3s4.vn("Request Object used before the 'nbf' claim");
        var tmp80_safe_receiver = claims.vl("nonce");
        var tmp81_safe_receiver = tmp80_safe_receiver == null ? null : get_jsonPrimitive(tmp80_safe_receiver);
        if ((tmp81_safe_receiver == null ? null : tmp81_safe_receiver.e1b()) == null) _this__u8e3s4.vn("Missing nonce claim");
        var tmp82_safe_receiver = claims.vl("response_type");
        var tmp83_safe_receiver = tmp82_safe_receiver == null ? null : get_jsonPrimitive(tmp82_safe_receiver);
        var responseType = tmp83_safe_receiver == null ? null : tmp83_safe_receiver.e1b();
        if (!(responseType === "vp_token") && !(responseType === "vp_token id_token") && !(responseType === "code")) _this__u8e3s4.vn("Invalid value for the response_type claim: " + responseType + ".");
        var aud = claims.b2a_1;
        var iss = claims.z29_1;
        var tmp85_safe_receiver = aud == null ? null : aud.qm();
        var tmp;
        if (tmp85_safe_receiver == null) tmp = null;
        else {
            var tmp$ret$1;
            $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var tmp0_iterator = tmp85_safe_receiver.j();
                while(tmp0_iterator.k()){
                    var element = tmp0_iterator.l();
                    // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateBasicClaims.<anonymous>' call
                    if (element === "https://self-issued.me/v2" || element === iss) {
                        tmp$ret$1 = element;
                        break $l$block;
                    }
                }
                tmp$ret$1 = null;
            }
            tmp = tmp$ret$1;
        }
        var isAudInvalid = tmp == null;
        if (isAudInvalid) _this__u8e3s4.vn("Invalid value for the aud claim: " + toString_0(claims.b2a_1) + ".");
        var tmp86_safe_receiver = claims.vl("client_id");
        var tmp87_safe_receiver = tmp86_safe_receiver == null ? null : get_jsonPrimitive(tmp86_safe_receiver);
        var clientId = tmp87_safe_receiver == null ? null : tmp87_safe_receiver.e1b();
        if (!(iss == clientId)) _this__u8e3s4.vn("iss claim value doesn't match client_id claim value.");
    }
    function validateVpFormatForPreRegisteredClient(_this__u8e3s4, $this, preRegisteredClient) {
        var tmp$ret$4;
        $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator = WalletMetadata_getInstance().l6m_1.j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateVpFormatForPreRegisteredClient.<anonymous>' call
                var tmp$ret$2;
                $l$block: {
                    // Inline function 'kotlin.collections.firstOrNull' call
                    var tmp0_iterator_0 = preRegisteredClient.c6f_1.j();
                    while(tmp0_iterator_0.k()){
                        var element_0 = tmp0_iterator_0.l();
                        // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateVpFormatForPreRegisteredClient.<anonymous>.<anonymous>' call
                        var tmp;
                        if (element_0.j6m_1 === element.j6m_1) // Inline function 'kotlin.collections.isNotEmpty' call
                        tmp = !intersect(element_0.k6m_1, element.k6m_1).s();
                        else tmp = false;
                        if (tmp) {
                            tmp$ret$2 = element_0;
                            break $l$block;
                        }
                    }
                    tmp$ret$2 = null;
                }
                if (!(tmp$ret$2 == null)) {
                    tmp$ret$4 = element;
                    break $l$block_0;
                }
            }
            tmp$ret$4 = null;
        }
        var isFormatSupported = !(tmp$ret$4 == null);
        if (!isFormatSupported) _this__u8e3s4.vn("Format not supported");
    }
    function validateSignatureForPreRegisteredClient(_this__u8e3s4, $this, jws, preRegisteredClient, $completion) {
        var tmp = new $validateSignatureForPreRegisteredClientCOROUTINE$26($this, _this__u8e3s4, jws, preRegisteredClient, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function fetchJwks(_this__u8e3s4, $this, jwksUri, $completion) {
        var tmp = new $fetchJwksCOROUTINE$27($this, _this__u8e3s4, jwksUri, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    }
    function DefaultRequestObjectJwtValidator$validate$slambda($requestObjectJwt, this$0, resultContinuation) {
        this.k6o_1 = $requestObjectJwt;
        this.l6o_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(DefaultRequestObjectJwtValidator$validate$slambda).u6o = function($this$suspendableValidationScope, $completion) {
        var tmp = this.x66($this$suspendableValidationScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(DefaultRequestObjectJwtValidator$validate$slambda).y9 = function(p1, $completion) {
        return this.u6o(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
    };
    protoOf(DefaultRequestObjectJwtValidator$validate$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 6;
                    this.n6o_1 = JwsUtil_getInstance().r2a(this.k6o_1);
                    var tmp_0 = this;
                    var tmp68_safe_receiver = this.n6o_1.k29_1.vl("client_id_scheme");
                    var tmp69_safe_receiver = tmp68_safe_receiver == null ? null : get_jsonPrimitive(tmp68_safe_receiver);
                    tmp_0.o6o_1 = tmp69_safe_receiver == null ? null : tmp69_safe_receiver.e1b();
                    if (this.o6o_1 == null) {
                        this.m6o_1.vn("Missing client_id_scheme claim");
                        return null;
                    }
                    validateBasicClaims(this.m6o_1, this.l6o_1, this.n6o_1.k29_1);
                    var tmp_1 = this;
                    var tmp0_elvis_lhs = validatePresentationDefinition(this.m6o_1, this.l6o_1, this.n6o_1.k29_1);
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) return null;
                    else tmp_2 = tmp0_elvis_lhs;
                    tmp_1.p6o_1 = tmp_2;
                    this.q6o_1 = Companion_instance_5.r2h(this.o6o_1);
                    this.r6o_1 = this.q6o_1.q2_1;
                    if (this.r6o_1 === 0) {
                        var tmp_3 = this;
                        var tmp70_safe_receiver = this.n6o_1.k29_1.vl("client_id");
                        var tmp71_safe_receiver = tmp70_safe_receiver == null ? null : get_jsonPrimitive(tmp70_safe_receiver);
                        tmp_3.s6o_1 = tmp71_safe_receiver == null ? null : tmp71_safe_receiver.e1b();
                        if (!(this.s6o_1 == null)) {
                            this.v8_1 = 1;
                            suspendResult = this.l6o_1.p6m_1.x6e(this.s6o_1, this);
                            if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                            continue $sm;
                        } else {
                            this.m6o_1.vn("Missing client_id claim");
                            this.v8_1 = 4;
                            continue $sm;
                        }
                    } else {
                        this.m6o_1.vn("Unsupported client_id_scheme value: " + this.q6o_1.toString());
                        this.v8_1 = 5;
                        continue $sm;
                    }
                case 1:
                    this.t6o_1 = suspendResult;
                    if (this.t6o_1 == null) {
                        this.m6o_1.vn("Unknown client " + this.s6o_1);
                        this.v8_1 = 3;
                        continue $sm;
                    } else {
                        validateVpFormatForPreRegisteredClient(this.m6o_1, this.l6o_1, this.t6o_1);
                        this.v8_1 = 2;
                        suspendResult = validateSignatureForPreRegisteredClient(this.m6o_1, this.l6o_1, this.k6o_1, this.t6o_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                        continue $sm;
                    }
                case 2:
                    this.v8_1 = 3;
                    continue $sm;
                case 3:
                    this.v8_1 = 4;
                    continue $sm;
                case 4:
                    this.v8_1 = 5;
                    continue $sm;
                case 5:
                    var tmp_4;
                    if (this.m6o_1.qn_1) {
                        var tmp72_safe_receiver = this.n6o_1.k29_1.h2a_1.e2("state");
                        var tmp73_safe_receiver = tmp72_safe_receiver == null ? null : get_jsonPrimitive(tmp72_safe_receiver);
                        var state = tmp73_safe_receiver == null ? null : tmp73_safe_receiver.e1b();
                        var tmp74_safe_receiver = this.n6o_1.k29_1.vl("response_uri");
                        var tmp75_safe_receiver = tmp74_safe_receiver == null ? null : get_jsonPrimitive(tmp74_safe_receiver);
                        var responseUri = ensureNotNull(tmp75_safe_receiver == null ? null : tmp75_safe_receiver.e1b());
                        var tmp76_safe_receiver = this.n6o_1.k29_1.vl("nonce");
                        var tmp77_safe_receiver = tmp76_safe_receiver == null ? null : get_jsonPrimitive(tmp76_safe_receiver);
                        var nonce = ensureNotNull(tmp77_safe_receiver == null ? null : tmp77_safe_receiver.e1b());
                        var iss = ensureNotNull(this.n6o_1.k29_1.z29_1);
                        var exp = ensureNotNull(this.n6o_1.k29_1.c2a_1);
                        tmp_4 = new ValidatedRequestJwt(this.n6o_1, responseUri, iss, nonce, this.p6o_1, state, exp);
                    } else tmp_4 = null;
                    return tmp_4;
                case 6:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 6) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(DefaultRequestObjectJwtValidator$validate$slambda).x66 = function($this$suspendableValidationScope, completion) {
        var i = new DefaultRequestObjectJwtValidator$validate$slambda(this.k6o_1, this.l6o_1, completion);
        i.m6o_1 = $this$suspendableValidationScope;
        return i;
    };
    function DefaultRequestObjectJwtValidator$validate$slambda_0($requestObjectJwt, this$0, resultContinuation) {
        var i = new DefaultRequestObjectJwtValidator$validate$slambda($requestObjectJwt, this$0, resultContinuation);
        var l = function($this$suspendableValidationScope, $completion) {
            return i.u6o($this$suspendableValidationScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $validateCOROUTINE$25(_this__u8e3s4, requestObjectJwt, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.d6p_1 = _this__u8e3s4;
        this.e6p_1 = requestObjectJwt;
    }
    protoOf($validateCOROUTINE$25).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = suspendableValidationScope(DefaultRequestObjectJwtValidator$validate$slambda_0(this.e6p_1, this.d6p_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return ARGUMENT.xm();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $validateSignatureForPreRegisteredClientCOROUTINE$26(_this__u8e3s4, _this__u8e3s4_0, jws, preRegisteredClient, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.a6n_1 = _this__u8e3s4;
        this.b6n_1 = _this__u8e3s4_0;
        this.c6n_1 = jws;
        this.d6n_1 = preRegisteredClient;
    }
    protoOf($validateSignatureForPreRegisteredClientCOROUTINE$26).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    this.w8_1 = 3;
                    this.v8_1 = 1;
                    suspendResult = fetchJwks(this.b6n_1, this.a6n_1, this.d6n_1.a6f_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.f6n_1 = suspendResult;
                    this.v8_1 = 2;
                    suspendResult = JwsUtil_getInstance().l2h(this.f6n_1, this.c6n_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    this.e6n_1 = suspendResult;
                    this.w8_1 = 4;
                    this.v8_1 = 5;
                    continue $sm;
                case 3:
                    this.w8_1 = 4;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof CryptoException) {
                        var ex = this.y8_1;
                        var tmp_1 = this;
                        this.b6n_1.vn("Invalid signature.");
                        tmp_1.e6n_1 = Unit_instance;
                        this.v8_1 = 5;
                        continue $sm;
                    } else throw this.y8_1;
                case 4:
                    throw this.y8_1;
                case 5:
                    this.w8_1 = 4;
                    return Unit_instance;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function $fetchJwksCOROUTINE$27(_this__u8e3s4, _this__u8e3s4_0, jwksUri, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.o6n_1 = _this__u8e3s4;
        this.p6n_1 = _this__u8e3s4_0;
        this.q6n_1 = jwksUri;
    }
    protoOf($fetchJwksCOROUTINE$27).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 4;
                    var tmp_0 = this;
                    tmp_0.r6n_1 = this.o6n_1.r6m_1;
                    var tmp_1 = this;
                    tmp_1.s6n_1 = this.q6n_1;
                    var tmp_2 = this;
                    tmp_2.t6n_1 = this.r6n_1;
                    var tmp_3 = this;
                    tmp_3.u6n_1 = this.t6n_1;
                    var tmp_4 = this;
                    var this_0 = new HttpRequestBuilder();
                    url(this_0, this.s6n_1);
                    tmp_4.v6n_1 = this_0;
                    this.v6n_1.n4t_1 = Companion_getInstance().n4d_1;
                    var tmp_5 = this;
                    tmp_5.w6n_1 = this.u6n_1;
                    var tmp_6 = this;
                    tmp_6.x6n_1 = this.v6n_1;
                    this.v8_1 = 1;
                    suspendResult = new HttpStatement(this.x6n_1, this.w6n_1).q5i(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.y6n_1 = suspendResult;
                    if (!(this.y6n_1.y4v().h4g_1 === 200)) this.p6n_1.vn("Cannot fetch JWKS from: " + this.q6n_1 + ". Status: " + this.y6n_1.y4v().h4g_1);
                    this.z6n_1 = Companion_instance_6;
                    var tmp_7 = this;
                    tmp_7.a6o_1 = this.y6n_1;
                    this.v8_1 = 2;
                    var tmp_8 = this.a6o_1.t4w();
                    var tmp_9 = JsType_instance;
                    var tmp_10 = PrimitiveClasses_getInstance().gb();
                    var tmp_11;
                    try {
                        tmp_11 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
                    } catch ($p) {
                        var tmp_12;
                        if ($p instanceof Error) {
                            var cause = $p;
                            tmp_12 = null;
                        } else throw $p;
                        tmp_11 = tmp_12;
                    }
                    suspendResult = tmp_8.x4v(typeInfoImpl(tmp_9, tmp_10, tmp_11), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 2:
                    var tmp_13 = this;
                    tmp_13.b6o_1 = (!(suspendResult == null) ? typeof suspendResult === "string" : false) ? suspendResult : THROW_CCE();
                    this.v8_1 = 3;
                    suspendResult = this.z6n_1.f2g(this.b6o_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    return suspendResult;
                case 4:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 4) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function DefaultRequestObjectJwtValidator(preRegisteredClientStore, clock, httpClient) {
        this.p6m_1 = preRegisteredClientStore;
        this.q6m_1 = clock;
        this.r6m_1 = httpClient;
    }
    protoOf(DefaultRequestObjectJwtValidator).h6l = function(requestObjectJwt, $completion) {
        var tmp = new $validateCOROUTINE$25(this, requestObjectJwt, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function HaipRequestObjectJwtValidator$validate$slambda(this$0, $requestObjectJwt, resultContinuation) {
        this.n6p_1 = this$0;
        this.o6p_1 = $requestObjectJwt;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(HaipRequestObjectJwtValidator$validate$slambda).u6o = function($this$suspendableValidationScope, $completion) {
        var tmp = this.x66($this$suspendableValidationScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(HaipRequestObjectJwtValidator$validate$slambda).y9 = function(p1, $completion) {
        return this.u6o(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
    };
    protoOf(HaipRequestObjectJwtValidator$validate$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = protoOf(DefaultRequestObjectJwtValidator).h6l.call(this.n6p_1, this.o6p_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var validatedRequestJwt = suspendResult;
                    var tmp88_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl("response_mode");
                    var tmp89_safe_receiver = tmp88_safe_receiver == null ? null : get_jsonPrimitive(tmp88_safe_receiver);
                    var responseMode = tmp89_safe_receiver == null ? null : tmp89_safe_receiver.e1b();
                    if (!(responseMode === "direct_post")) this.p6p_1.vn("Invalid response_mode. Only 'direct_post' is accepted.");
                    var tmp90_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl("response_type");
                    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : get_jsonPrimitive(tmp90_safe_receiver);
                    var responseType = tmp91_safe_receiver == null ? null : tmp91_safe_receiver.e1b();
                    if (!(responseType === "vp_token")) this.p6p_1.vn("Invalid response_type. Only 'vp_token' is accepted.");
                    var tmp92_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl("response_uri");
                    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : get_jsonPrimitive(tmp92_safe_receiver);
                    var responseUri = tmp93_safe_receiver == null ? null : tmp93_safe_receiver.e1b();
                    if (responseUri == null || !startsWith(responseUri, "https://")) this.p6p_1.vn("Invalid value for the response_uri claim: " + responseUri + ". 'https' is required.");
                    var tmp_0;
                    if (this.p6p_1.qn_1) tmp_0 = validatedRequestJwt;
                    else tmp_0 = null;
                    return tmp_0;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(HaipRequestObjectJwtValidator$validate$slambda).x66 = function($this$suspendableValidationScope, completion) {
        var i = new HaipRequestObjectJwtValidator$validate$slambda(this.n6p_1, this.o6p_1, completion);
        i.p6p_1 = $this$suspendableValidationScope;
        return i;
    };
    function HaipRequestObjectJwtValidator$validate$slambda_0(this$0, $requestObjectJwt, resultContinuation) {
        var i = new HaipRequestObjectJwtValidator$validate$slambda(this$0, $requestObjectJwt, resultContinuation);
        var l = function($this$suspendableValidationScope, $completion) {
            return i.u6o($this$suspendableValidationScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function $validateCOROUTINE$28(_this__u8e3s4, requestObjectJwt, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.y6p_1 = _this__u8e3s4;
        this.z6p_1 = requestObjectJwt;
    }
    protoOf($validateCOROUTINE$28).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = suspendableValidationScope(HaipRequestObjectJwtValidator$validate$slambda_0(this.y6p_1, this.z6p_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return ARGUMENT.xm();
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function HaipRequestObjectJwtValidator(preRegisteredClientStore, clock, httpClient) {
        DefaultRequestObjectJwtValidator.call(this, preRegisteredClientStore, clock, httpClient);
    }
    protoOf(HaipRequestObjectJwtValidator).h6l = function(requestObjectJwt, $completion) {
        var tmp = new $validateCOROUTINE$28(this, requestObjectJwt, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function Companion_10() {}
    var Companion_instance_19;
    function Companion_getInstance_17() {
        return Companion_instance_19;
    }
    function $serializer_4() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new PluginGeneratedSerialDescriptor("io.curity.vp.services.ValidatedRequestJwt", this, 7);
        tmp0_serialDesc.wy("jws", false);
        tmp0_serialDesc.wy("responseUri", false);
        tmp0_serialDesc.wy("iss", false);
        tmp0_serialDesc.wy("nonce", false);
        tmp0_serialDesc.wy("presentationDefinition", false);
        tmp0_serialDesc.wy("state", false);
        tmp0_serialDesc.wy("expAt", false);
        this.a6q_1 = tmp0_serialDesc;
    }
    protoOf($serializer_4).b6q = function(encoder, value) {
        var tmp0_desc = this.a6q_1;
        var tmp1_output = encoder.lr(tmp0_desc);
        tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_2(), value.f6i_1);
        tmp1_output.zs(tmp0_desc, 1, value.g6i_1);
        tmp1_output.zs(tmp0_desc, 2, value.h6i_1);
        tmp1_output.zs(tmp0_desc, 3, value.i6i_1);
        tmp1_output.bt(tmp0_desc, 4, $serializer_getInstance_3(), value.j6i_1);
        tmp1_output.dt(tmp0_desc, 5, StringSerializer_getInstance(), value.k6i_1);
        tmp1_output.vs(tmp0_desc, 6, value.l6i_1);
        tmp1_output.mr(tmp0_desc);
    };
    protoOf($serializer_4).zn = function(encoder, value) {
        return this.b6q(encoder, value instanceof ValidatedRequestJwt ? value : THROW_CCE());
    };
    protoOf($serializer_4).ao = function(decoder) {
        var tmp0_desc = this.a6q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = new Long(0, 0);
        var tmp11_input = decoder.lr(tmp0_desc);
        if (tmp11_input.as()) {
            tmp4_local0 = tmp11_input.xr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            tmp5_local1 = tmp11_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            tmp6_local2 = tmp11_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            tmp7_local3 = tmp11_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            tmp8_local4 = tmp11_input.xr(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            tmp9_local5 = tmp11_input.zr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            tmp10_local6 = tmp11_input.rr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else while(tmp1_flag){
            tmp2_index = tmp11_input.bs(tmp0_desc);
            switch(tmp2_index){
                case -1:
                    tmp1_flag = false;
                    break;
                case 0:
                    tmp4_local0 = tmp11_input.xr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
                    tmp3_bitMask0 = tmp3_bitMask0 | 1;
                    break;
                case 1:
                    tmp5_local1 = tmp11_input.vr(tmp0_desc, 1);
                    tmp3_bitMask0 = tmp3_bitMask0 | 2;
                    break;
                case 2:
                    tmp6_local2 = tmp11_input.vr(tmp0_desc, 2);
                    tmp3_bitMask0 = tmp3_bitMask0 | 4;
                    break;
                case 3:
                    tmp7_local3 = tmp11_input.vr(tmp0_desc, 3);
                    tmp3_bitMask0 = tmp3_bitMask0 | 8;
                    break;
                case 4:
                    tmp8_local4 = tmp11_input.xr(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
                    tmp3_bitMask0 = tmp3_bitMask0 | 16;
                    break;
                case 5:
                    tmp9_local5 = tmp11_input.zr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                    tmp3_bitMask0 = tmp3_bitMask0 | 32;
                    break;
                case 6:
                    tmp10_local6 = tmp11_input.rr(tmp0_desc, 6);
                    tmp3_bitMask0 = tmp3_bitMask0 | 64;
                    break;
                default:
                    throw UnknownFieldException_init_$Create$(tmp2_index);
            }
        }
        tmp11_input.mr(tmp0_desc);
        return ValidatedRequestJwt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
    };
    protoOf($serializer_4).yn = function() {
        return this.a6q_1;
    };
    protoOf($serializer_4).lz = function() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [
            $serializer_getInstance_2(),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            StringSerializer_getInstance(),
            $serializer_getInstance_3(),
            get_nullable(StringSerializer_getInstance()),
            LongSerializer_getInstance()
        ];
    };
    var $serializer_instance_4;
    function $serializer_getInstance_9() {
        if ($serializer_instance_4 == null) new $serializer_4();
        return $serializer_instance_4;
    }
    function ValidatedRequestJwt_init_$Init$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker, $this) {
        if (!(127 === (127 & seen0))) throwMissingFieldException(seen0, 127, $serializer_getInstance_9().a6q_1);
        $this.f6i_1 = jws;
        $this.g6i_1 = responseUri;
        $this.h6i_1 = iss;
        $this.i6i_1 = nonce;
        $this.j6i_1 = presentationDefinition;
        $this.k6i_1 = state;
        $this.l6i_1 = expAt;
        return $this;
    }
    function ValidatedRequestJwt_init_$Create$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker) {
        return ValidatedRequestJwt_init_$Init$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker, objectCreate(protoOf(ValidatedRequestJwt)));
    }
    function ValidatedRequestJwt(jws, responseUri, iss, nonce, presentationDefinition, state, expAt) {
        this.f6i_1 = jws;
        this.g6i_1 = responseUri;
        this.h6i_1 = iss;
        this.i6i_1 = nonce;
        this.j6i_1 = presentationDefinition;
        this.k6i_1 = state;
        this.l6i_1 = expAt;
    }
    protoOf(ValidatedRequestJwt).toString = function() {
        return "ValidatedRequestJwt(jws=" + this.f6i_1.toString() + ", responseUri=" + this.g6i_1 + ", iss=" + this.h6i_1 + ", nonce=" + this.i6i_1 + ", presentationDefinition=" + this.j6i_1.toString() + ", state=" + this.k6i_1 + ", expAt=" + this.l6i_1.toString() + ")";
    };
    protoOf(ValidatedRequestJwt).hashCode = function() {
        var result = this.f6i_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g6i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h6i_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i6i_1) | 0;
        result = imul(result, 31) + this.j6i_1.hashCode() | 0;
        result = imul(result, 31) + (this.k6i_1 == null ? 0 : getStringHashCode(this.k6i_1)) | 0;
        result = imul(result, 31) + this.l6i_1.hashCode() | 0;
        return result;
    };
    protoOf(ValidatedRequestJwt).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof ValidatedRequestJwt)) return false;
        var tmp0_other_with_cast = other instanceof ValidatedRequestJwt ? other : THROW_CCE();
        if (!this.f6i_1.equals(tmp0_other_with_cast.f6i_1)) return false;
        if (!(this.g6i_1 === tmp0_other_with_cast.g6i_1)) return false;
        if (!(this.h6i_1 === tmp0_other_with_cast.h6i_1)) return false;
        if (!(this.i6i_1 === tmp0_other_with_cast.i6i_1)) return false;
        if (!this.j6i_1.equals(tmp0_other_with_cast.j6i_1)) return false;
        if (!(this.k6i_1 == tmp0_other_with_cast.k6i_1)) return false;
        if (!this.l6i_1.equals(tmp0_other_with_cast.l6i_1)) return false;
        return true;
    };
    function JsHttpProxy(scheme, host, port) {
        this.scheme = scheme;
        this.host = host;
        this.port = port;
    }
    protoOf(JsHttpProxy).c6q = function() {
        return this.scheme;
    };
    protoOf(JsHttpProxy).d6q = function() {
        return this.host;
    };
    protoOf(JsHttpProxy).f4i = function() {
        return this.port;
    };
    protoOf(JsHttpProxy).ba = function() {
        return this.scheme;
    };
    protoOf(JsHttpProxy).ca = function() {
        return this.host;
    };
    protoOf(JsHttpProxy).qj = function() {
        return this.port;
    };
    protoOf(JsHttpProxy).e6q = function(scheme, host, port) {
        return new JsHttpProxy(scheme, host, port);
    };
    protoOf(JsHttpProxy).copy = function(scheme, host, port, $super) {
        scheme = scheme === VOID ? this.scheme : scheme;
        host = host === VOID ? this.host : host;
        port = port === VOID ? this.port : port;
        return this.e6q(scheme, host, port);
    };
    protoOf(JsHttpProxy).toString = function() {
        return "JsHttpProxy(scheme=" + this.scheme + ", host=" + this.host + ", port=" + this.port + ")";
    };
    protoOf(JsHttpProxy).hashCode = function() {
        var result = getStringHashCode(this.scheme);
        result = imul(result, 31) + getStringHashCode(this.host) | 0;
        result = imul(result, 31) + this.port | 0;
        return result;
    };
    protoOf(JsHttpProxy).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsHttpProxy)) return false;
        var tmp0_other_with_cast = other instanceof JsHttpProxy ? other : THROW_CCE();
        if (!(this.scheme === tmp0_other_with_cast.scheme)) return false;
        if (!(this.host === tmp0_other_with_cast.host)) return false;
        if (!(this.port === tmp0_other_with_cast.port)) return false;
        return true;
    };
    function createCredentialIssuerLoader(proxyConfig) {
        proxyConfig = proxyConfig === VOID ? null : proxyConfig;
        var tmp;
        if (!(proxyConfig == null)) tmp = createEngine(proxyConfig);
        else tmp = Js_instance.y4z();
        var engine = tmp;
        var tmp_0 = System_instance;
        return new JsCredentialIssuerLoader(new DefaultCredentialIssuerLoader(tmp_0, HttpClient(engine, createCredentialIssuerLoader$lambda)));
    }
    function createCredentialIssuerStore() {
        return new JsCredentialIssuerStore(new LocalStorageCredentialIssuerStore());
    }
    function createVerifiableCredentialStore() {
        return new JsVerifiableCredentialStore(new LocalStorageVerifiableCredentialStore());
    }
    function createOAuthClient(id, redirectUri, secret) {
        return new OAuthClient(id, redirectUri, secret);
    }
    function createCredentialIssuanceCoordinator(oAuthClient, httpProxy, credentialIssuerLoader) {
        var tmp = System_instance;
        var tmp_0 = new CompositeDidResolver(listOf(new JwkDidResolver()));
        var tmp_1 = new BrowserWindowOAuthAuthorizer();
        var tmp_2 = createEngine(httpProxy);
        return new JsCredentialIssuanceCoordinator(new CredentialIssuanceCoordinator(tmp, oAuthClient, tmp_0, tmp_1, tmp_2, credentialIssuerLoader.inner, new DefaultVcSdJwtIssuerMetadataLoader(HttpClient_0(createCredentialIssuanceCoordinator$lambda))));
    }
    function createPreRegisteredClientStore() {
        return new JsPreRegisteredClientStore(new InMemoryPreRegisteredClientStore());
    }
    function createVerifierClient(httpProxy, preRegisteredClientStore) {
        return new JsVerifierClient(httpProxy, preRegisteredClientStore);
    }
    function createCredentialFinder(jsCredentialStore) {
        return new JsOpenIdWalletAuthenticatorCredentialFinder(jsCredentialStore);
    }
    function createPresentationResponseCreator(keyAliasStore, keyStore) {
        var tmp = System_instance;
        return new JsPresentationResponseCreator(new PresentationResponseCreator(tmp, keyAliasStore.f6q_1, (keyStore instanceof JsDefaultKeyStore ? keyStore : THROW_CCE()).f2b_1));
    }
    function newUserCancellationException() {
        return new UserCancellationException();
    }
    function createRequestJwtStore(cleanupPeriod) {
        return new JsRequestJwtStore(new LocalStorageRequestJwtStore(VOID, cleanupPeriod));
    }
    function createKeyStore() {
        return new JsDefaultKeyStore();
    }
    function createInMemoryKeyAliasStore() {
        return new JsKeyAliasStore(new InMemoryKeyAliasStore());
    }
    function createEngine(config) {
        var tmp = Js_instance.y4z();
        // Inline function 'kotlin.apply' call
        var this_0 = new ProxyPluginConfig();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'createEngine.<anonymous>' call
        var tmp_0 = this_0;
        var tmp_1;
        switch(config.scheme){
            case "http":
                tmp_1 = Companion_getInstance_1().q4h_1;
                break;
            case "https":
                tmp_1 = Companion_getInstance_1().r4h_1;
                break;
            default:
                var reason = "unsupported protocol";
                throw new NotImplementedError("An operation is not implemented: " + reason);
        }
        tmp_0.g6q_1 = tmp_1;
        this_0.h6q_1 = config.host;
        this_0.i6q_1 = config.port;
        return new ProxyEngine(tmp, this_0);
    }
    function createCredentialIssuerLoader$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, createCredentialIssuerLoader$lambda$lambda);
        return Unit_instance;
    }
    function createCredentialIssuerLoader$lambda$lambda($this$install) {
        json($this$install, Json(VOID, createCredentialIssuerLoader$lambda$lambda$lambda));
        return Unit_instance;
    }
    function createCredentialIssuerLoader$lambda$lambda$lambda($this$Json) {
        $this$Json.u19_1 = true;
        return Unit_instance;
    }
    function createCredentialIssuanceCoordinator$lambda($this$HttpClient) {
        var tmp = Plugin_getInstance();
        $this$HttpClient.t4u(tmp, createCredentialIssuanceCoordinator$lambda$lambda);
        return Unit_instance;
    }
    function createCredentialIssuanceCoordinator$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function get_ProxyPlugin() {
        _init_properties_ProxyPlugin_kt__by34kx();
        return ProxyPlugin;
    }
    var ProxyPlugin;
    function ProxyPluginConfig() {
        this.g6q_1 = Companion_getInstance_1().q4h_1;
        this.h6q_1 = "localhost";
        this.i6q_1 = 1234;
        this.j6q_1 = "ProxyTo";
        this.k6q_1 = "proxy";
    }
    function ProxyEngine(inner, proxyConfig) {
        this.l6q_1 = inner;
        this.m6q_1 = proxyConfig;
    }
    protoOf(ProxyEngine).a4u = function() {
        return this.l6q_1.a4u();
    };
    protoOf(ProxyEngine).v1m = function() {
        return this.l6q_1.v1m();
    };
    protoOf(ProxyEngine).v3w = function() {
        this.l6q_1.v3w();
    };
    protoOf(ProxyEngine).x4z = function(data, $completion) {
        // Inline function 'kotlin.apply' call
        var this_0 = new HttpRequestBuilder();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'vc_js.ProxyEngine.execute.<anonymous>' call
        this_0.n4t_1 = data.l4y_1;
        this_0.m4t_1.n4g_1 = this.m6q_1.g6q_1;
        this_0.m4t_1.o4g_1 = this.m6q_1.h6q_1;
        this_0.m4t_1.p4g_1 = this.m6q_1.i6q_1;
        path(this_0.m4t_1, [
            this.m6q_1.k6q_1 + joinToString(data.k4y_1.c4h_1, "/")
        ]);
        this_0.o4t_1.x43(data.m4y_1);
        var header = data.k4y_1.z4g_1.x4g_1 + "://" + get_authority(data.k4y_1);
        this_0.o4t_1.w43(this.m6q_1.j6q_1, header);
        putAll(this_0.r4t_1, data.p4y_1);
        this_0.p4t_1 = data.n4y_1;
        var newReq = this_0.c3r();
        return this.l6q_1.x4z(newReq, $completion);
    };
    function ProxyPluginConfig$_init_$ref_4o7kf2() {
        var l = function() {
            return new ProxyPluginConfig();
        };
        l.callableName = "<init>";
        return l;
    }
    function ProxyPlugin$lambda($this$createClientPlugin) {
        _init_properties_ProxyPlugin_kt__by34kx();
        var config = $this$createClientPlugin.l5f_1;
        $this$createClientPlugin.o5f(ProxyPlugin$lambda$slambda_0(config, null));
        return Unit_instance;
    }
    function ProxyPlugin$lambda$slambda($config, resultContinuation) {
        this.v6q_1 = $config;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(ProxyPlugin$lambda$slambda).z6q = function($this$onRequest, req, _unused_var__etf5q3, $completion) {
        var tmp = this.a6r($this$onRequest, req, _unused_var__etf5q3, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(ProxyPlugin$lambda$slambda).b6r = function(p1, p2, p3, $completion) {
        var tmp = p1 instanceof OnRequestContext ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
        return this.z6q(tmp, tmp_0, !(p3 == null) ? p3 : THROW_CCE(), $completion);
    };
    protoOf(ProxyPlugin$lambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            if (tmp === 0) {
                this.w8_1 = 1;
                var header = this.x6q_1.m4t_1.n4g_1.x4g_1 + "://" + get_authority_0(this.x6q_1.m4t_1);
                this.x6q_1.o4t_1.u43(this.v6q_1.j6q_1, header);
                this.x6q_1.m4t_1.n4g_1 = this.v6q_1.g6q_1;
                this.x6q_1.m4t_1.o4g_1 = this.v6q_1.h6q_1;
                set_port(this.x6q_1, this.v6q_1.i6q_1);
                path(this.x6q_1.m4t_1, [
                    this.v6q_1.k6q_1 + joinToString(this.x6q_1.m4t_1.b4i(), "/")
                ]);
                return Unit_instance;
            } else if (tmp === 1) throw this.y8_1;
        } catch ($p) {
            var e = $p;
            throw e;
        }
        while (true);
    };
    protoOf(ProxyPlugin$lambda$slambda).a6r = function($this$onRequest, req, _unused_var__etf5q3, completion) {
        var i = new ProxyPlugin$lambda$slambda(this.v6q_1, completion);
        i.w6q_1 = $this$onRequest;
        i.x6q_1 = req;
        i.y6q_1 = _unused_var__etf5q3;
        return i;
    };
    function ProxyPlugin$lambda$slambda_0($config, resultContinuation) {
        var i = new ProxyPlugin$lambda$slambda($config, resultContinuation);
        var l = function($this$onRequest, req, _unused_var__etf5q3, $completion) {
            return i.z6q($this$onRequest, req, _unused_var__etf5q3, $completion);
        };
        l.$arity = 3;
        return l;
    }
    var properties_initialized_ProxyPlugin_kt_gl075b;
    function _init_properties_ProxyPlugin_kt__by34kx() {
        if (!properties_initialized_ProxyPlugin_kt_gl075b) {
            properties_initialized_ProxyPlugin_kt_gl075b = true;
            var tmp = ProxyPluginConfig$_init_$ref_4o7kf2();
            ProxyPlugin = createClientPlugin("ProxyPlugin", tmp, ProxyPlugin$lambda);
        }
    }
    function JsVcClient$requestJwtVcJsonCredential$slambda(this$0, $request, resultContinuation) {
        this.k6r_1 = this$0;
        this.l6r_1 = $request;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).m6r = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).o6r = function($completion) {
        return this.m6r($completion);
    };
    protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.k6r_1.q6r_1.y62(convertJwtVcJsonRequest(this.l6r_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var validatedResponse = suspendResult;
                    return convertJwtVcJsonResponse(validatedResponse.j31());
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).n6r = function(completion) {
        return new JsVcClient$requestJwtVcJsonCredential$slambda(this.k6r_1, this.l6r_1, completion);
    };
    function JsVcClient$requestJwtVcJsonCredential$slambda_0(this$0, $request, resultContinuation) {
        var i = new JsVcClient$requestJwtVcJsonCredential$slambda(this$0, $request, resultContinuation);
        var l = function($completion) {
            return i.m6r($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsVcClient$requestJwtVcJsonLdCredential$slambda(this$0, $request, resultContinuation) {
        this.z6r_1 = this$0;
        this.a6s_1 = $request;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).b6s = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).o6r = function($completion) {
        return this.b6s($completion);
    };
    protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.z6r_1.q6r_1.h6d(convertJwtVcJsonLdRequest(this.a6s_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var validatedResponse = suspendResult;
                    return convertJwtVcJsonLdResponse(validatedResponse.j31());
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).n6r = function(completion) {
        return new JsVcClient$requestJwtVcJsonLdCredential$slambda(this.z6r_1, this.a6s_1, completion);
    };
    function JsVcClient$requestJwtVcJsonLdCredential$slambda_0(this$0, $request, resultContinuation) {
        var i = new JsVcClient$requestJwtVcJsonLdCredential$slambda(this$0, $request, resultContinuation);
        var l = function($completion) {
            return i.b6s($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsVcClient$requestLdpVcJsonCredential$slambda(this$0, $request, resultContinuation) {
        this.k6s_1 = this$0;
        this.l6s_1 = $request;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).m6s = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).o6r = function($completion) {
        return this.m6s($completion);
    };
    protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.k6s_1.q6r_1.i6d(convertLdpVcJsonRequest(this.l6s_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var validatedResponse = suspendResult;
                    return convertLdpVcJsonResponse(validatedResponse.j31());
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).n6r = function(completion) {
        return new JsVcClient$requestLdpVcJsonCredential$slambda(this.k6s_1, this.l6s_1, completion);
    };
    function JsVcClient$requestLdpVcJsonCredential$slambda_0(this$0, $request, resultContinuation) {
        var i = new JsVcClient$requestLdpVcJsonCredential$slambda(this$0, $request, resultContinuation);
        var l = function($completion) {
            return i.m6s($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsVcClient(vcServerMetadata, oauthSupport, proxy) {
        this.p6r_1 = createJsClient(oauthSupport, proxy);
        var tmp = this;
        var tmp_0 = inner(vcServerMetadata);
        throw new NotImplementedError();
    }
    protoOf(JsVcClient).requestJwtVcJsonCredential = function(request) {
        return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestJwtVcJsonCredential$slambda_0(this, request, null));
    };
    protoOf(JsVcClient).requestJwtVcJsonLdCredential = function(request) {
        return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestJwtVcJsonLdCredential$slambda_0(this, request, null));
    };
    protoOf(JsVcClient).requestLdpVcJsonCredential = function(request) {
        return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestLdpVcJsonCredential$slambda_0(this, request, null));
    };
    function UserCancellationException() {
        CancellationException_init_$Init$(this);
        captureStack(this, UserCancellationException);
    }
    function safePromise(_this__u8e3s4, description, action) {
        description = description === VOID ? "" : description;
        return promise(_this__u8e3s4, VOID, VOID, safePromise$slambda_0(action, description, null));
    }
    function safePromise$slambda($action, $description, resultContinuation) {
        this.v6s_1 = $action;
        this.w6s_1 = $description;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(safePromise$slambda).z6s = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(safePromise$slambda).y9 = function(p1, $completion) {
        return this.z6s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(safePromise$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 3;
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.v6s_1(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    this.y6s_1 = suspendResult;
                    this.w8_1 = 3;
                    this.v8_1 = 4;
                    continue $sm;
                case 2:
                    this.w8_1 = 3;
                    var tmp_0 = this.y8_1;
                    if (tmp_0 instanceof Error) {
                        var e = this.y8_1;
                        var tmp_1 = this;
                        if (!(e instanceof UserCancellationException)) printStackTrace(e);
                        var this_0 = this.w6s_1;
                        var tmp_2;
                        if (isBlank(this_0)) tmp_2 = "unknown location";
                        else tmp_2 = this_0;
                        var location = tmp_2;
                        throw Exception_init_$Create$("Error at '" + location + "': " + getRootCause(e).toString());
                    } else throw this.y8_1;
                case 3:
                    throw this.y8_1;
                case 4:
                    this.w8_1 = 3;
                    return this.y6s_1;
            }
        } catch ($p) {
            var e_0 = $p;
            if (this.w8_1 === 3) throw e_0;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e_0;
            }
        }
        while (true);
    };
    protoOf(safePromise$slambda).e2b = function($this$promise, completion) {
        var i = new safePromise$slambda(this.v6s_1, this.w6s_1, completion);
        i.x6s_1 = $this$promise;
        return i;
    };
    function safePromise$slambda_0($action, $description, resultContinuation) {
        var i = new safePromise$slambda($action, $description, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.z6s($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsProxy(scheme, host, port) {
        this.scheme = scheme;
        this.host = host;
        this.port = port;
    }
    protoOf(JsProxy).c6q = function() {
        return this.scheme;
    };
    protoOf(JsProxy).d6q = function() {
        return this.host;
    };
    protoOf(JsProxy).f4i = function() {
        return this.port;
    };
    protoOf(JsProxy).ba = function() {
        return this.scheme;
    };
    protoOf(JsProxy).ca = function() {
        return this.host;
    };
    protoOf(JsProxy).qj = function() {
        return this.port;
    };
    protoOf(JsProxy).e6q = function(scheme, host, port) {
        return new JsProxy(scheme, host, port);
    };
    protoOf(JsProxy).copy = function(scheme, host, port, $super) {
        scheme = scheme === VOID ? this.scheme : scheme;
        host = host === VOID ? this.host : host;
        port = port === VOID ? this.port : port;
        return this.e6q(scheme, host, port);
    };
    protoOf(JsProxy).toString = function() {
        return "JsProxy(scheme=" + this.scheme + ", host=" + this.host + ", port=" + this.port + ")";
    };
    protoOf(JsProxy).hashCode = function() {
        var result = getStringHashCode(this.scheme);
        result = imul(result, 31) + getStringHashCode(this.host) | 0;
        result = imul(result, 31) + this.port | 0;
        return result;
    };
    protoOf(JsProxy).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsProxy)) return false;
        var tmp0_other_with_cast = other instanceof JsProxy ? other : THROW_CCE();
        if (!(this.scheme === tmp0_other_with_cast.scheme)) return false;
        if (!(this.host === tmp0_other_with_cast.host)) return false;
        if (!(this.port === tmp0_other_with_cast.port)) return false;
        return true;
    };
    function createJsClient(oauthSupport, proxyConfig) {
        // Inline function 'kotlin.apply' call
        var tmp = Js_instance.y4z();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'createJsClient.<anonymous>' call
        return HttpClient(tmp, createJsClient$lambda(proxyConfig));
    }
    function createJsClient$lambda$lambda($this$install) {
        json($this$install);
        return Unit_instance;
    }
    function createJsClient$lambda$lambda_0($proxyConfig) {
        return function($this$install) {
            var tmp = $this$install;
            var tmp_0;
            switch($proxyConfig.scheme){
                case "http":
                    tmp_0 = Companion_getInstance_1().q4h_1;
                    break;
                case "https":
                    tmp_0 = Companion_getInstance_1().r4h_1;
                    break;
                default:
                    var reason = "unsupported protocol";
                    throw new NotImplementedError("An operation is not implemented: " + reason);
            }
            tmp.g6q_1 = tmp_0;
            $this$install.h6q_1 = $proxyConfig.host;
            $this$install.i6q_1 = $proxyConfig.port;
            return Unit_instance;
        };
    }
    function createJsClient$lambda($proxyConfig) {
        return function($this$HttpClient) {
            var tmp = Plugin_getInstance();
            $this$HttpClient.t4u(tmp, createJsClient$lambda$lambda);
            var tmp_0 = get_ProxyPlugin();
            $this$HttpClient.t4u(tmp_0, createJsClient$lambda$lambda_0($proxyConfig));
            return Unit_instance;
        };
    }
    function addEventListener($this, continuation, externalWindow, expectedState, abortSignal) {
        var tmp = window;
        var tmp_0 = EventListener(BrowserWindowOAuthAuthorizer$addEventListener$lambda(externalWindow, expectedState, continuation));
        // Inline function 'js.core.jso' call
        // Inline function 'kotlin.apply' call
        // Inline function 'js.core.jso' call
        var this_0 = {};
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'vc_js.services.BrowserWindowOAuthAuthorizer.addEventListener.<anonymous>' call
        this_0.signal = abortSignal;
        tmp.addEventListener("message", tmp_0, this_0);
    }
    function BrowserWindowOAuthAuthorizer$authorize$lambda($authorizationRequest) {
        return function($this$parameters) {
            appendParameters($this$parameters, $authorizationRequest);
            return Unit_instance;
        };
    }
    function BrowserWindowOAuthAuthorizer$addEventListener$lambda($externalWindow, $expectedState, $continuation) {
        return function(event) {
            if (!(event instanceof MessageEvent)) THROW_CCE();
            var data = event.data;
            var tmp;
            try {
                tmp = new URLSearchParams(data);
            } catch ($p) {
                var tmp_0;
                if ($p instanceof Exception) {
                    var ex = $p;
                    tmp_0 = null;
                } else throw $p;
                tmp = tmp_0;
            }
            var receivedParams = tmp;
            var tmp_1;
            if ((equals(event.source, $externalWindow) || $externalWindow == null) && !(receivedParams == null) && $expectedState == receivedParams.get("state")) {
                var tmp3_safe_receiver = $externalWindow;
                if (tmp3_safe_receiver == null) ;
                else tmp3_safe_receiver.close();
                // Inline function 'kotlin.coroutines.resume' call
                var this_0 = $continuation;
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$0 = _Result___init__impl__xyqfz8(receivedParams);
                this_0.g9(tmp$ret$0);
                tmp_1 = Unit_instance;
            }
            return Unit_instance;
        };
    }
    function $authorizeCOROUTINE$29(_this__u8e3s4, authorizationEndpoint, authorizationRequest, resultContinuation) {
        CoroutineImpl.call(this, resultContinuation);
        this.i6t_1 = _this__u8e3s4;
        this.j6t_1 = authorizationEndpoint;
        this.k6t_1 = authorizationRequest;
    }
    protoOf($authorizeCOROUTINE$29).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 7;
                    var tmp_0 = this;
                    tmp_0.l6t_1 = formUrlEncode(parameters(BrowserWindowOAuthAuthorizer$authorize$lambda(this.k6t_1)));
                    this.m6t_1 = window.open(this.j6t_1 + "?" + this.l6t_1);
                    this.n6t_1 = new AbortController();
                    this.v8_1 = 1;
                    continue $sm;
                case 1:
                    this.v8_1 = 2;
                    continue $sm;
                case 2:
                    this.w8_1 = 6;
                    this.v8_1 = 3;
                    var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
                    cancellable.l1r();
                    addEventListener(this.i6t_1, cancellable, this.m6t_1, this.k6t_1.state, this.n6t_1.signal);
                    suspendResult = returnIfSuspended(cancellable.s1r(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 3:
                    var authorizationResponseParams = suspendResult;
                    var tmp_1 = this;
                    var tmp0_elvis_lhs = authorizationResponseParams.get("state");
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) throw Exception_init_$Create$("missing state");
                    else tmp_2 = tmp0_elvis_lhs;
                    var tmp_3 = tmp_2;
                    var tmp1_elvis_lhs = authorizationResponseParams.get("code");
                    var tmp_4;
                    if (tmp1_elvis_lhs == null) throw Exception_init_$Create$("missing code");
                    else tmp_4 = tmp1_elvis_lhs;
                    tmp_1.o6t_1 = new OAuthAuthorizationResponse(tmp_3, tmp_4);
                    this.w8_1 = 7;
                    this.v8_1 = 4;
                    var tmp_5 = this;
                    continue $sm;
                case 4:
                    var tmp_6 = this.o6t_1;
                    this.w8_1 = 7;
                    var tmp2_safe_receiver = this.m6t_1;
                    if (tmp2_safe_receiver == null) ;
                    else tmp2_safe_receiver.close();
                    this.n6t_1.abort();
                    return tmp_6;
                case 5:
                    this.w8_1 = 7;
                    var tmp2_safe_receiver_0 = this.m6t_1;
                    if (tmp2_safe_receiver_0 == null) ;
                    else tmp2_safe_receiver_0.close();
                    this.n6t_1.abort();
                    return Unit_instance;
                case 6:
                    this.w8_1 = 7;
                    var t = this.y8_1;
                    var tmp2_safe_receiver_1 = this.m6t_1;
                    if (tmp2_safe_receiver_1 == null) ;
                    else tmp2_safe_receiver_1.close();
                    this.n6t_1.abort();
                    throw t;
                case 7:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 7) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    function BrowserWindowOAuthAuthorizer() {}
    protoOf(BrowserWindowOAuthAuthorizer).s62 = function(authorizationEndpoint, authorizationRequest, $completion) {
        var tmp = new $authorizeCOROUTINE$29(this, authorizationEndpoint, authorizationRequest, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    function createBrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint, onAuthorizationDone) {
        var tmp;
        if (onAuthorizationDone === VOID) tmp = createBrowserWindowOAuthSupport$lambda;
        else tmp = onAuthorizationDone;
        onAuthorizationDone = tmp;
        return new JsOAuthSupport(new BrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint));
    }
    function JsOAuthSupport(delegate) {
        this.p6t_1 = delegate;
    }
    protoOf(JsOAuthSupport).q6t = function() {
        return this.p6t_1;
    };
    function BrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint) {
        this.r6t_1 = authorizationRequest;
        this.s6t_1 = oauthClient;
        this.t6t_1 = authorizationEndpoint;
        this.u6t_1 = tokenEndpoint;
    }
    function createBrowserWindowOAuthSupport$lambda() {
        return Unit_instance;
    }
    function JsKeyAliasStore$add$slambda(this$0, $alias, $kid, resultContinuation) {
        this.d6u_1 = this$0;
        this.e6u_1 = $alias;
        this.f6u_1 = $kid;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsKeyAliasStore$add$slambda).h6u = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsKeyAliasStore$add$slambda).y9 = function(p1, $completion) {
        return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsKeyAliasStore$add$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.d6u_1.f6q_1.j68(this.e6u_1, this.f6u_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return true;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsKeyAliasStore$add$slambda).e2b = function($this$promise, completion) {
        var i = new JsKeyAliasStore$add$slambda(this.d6u_1, this.e6u_1, this.f6u_1, completion);
        i.g6u_1 = $this$promise;
        return i;
    };
    function JsKeyAliasStore$add$slambda_0(this$0, $alias, $kid, resultContinuation) {
        var i = new JsKeyAliasStore$add$slambda(this$0, $alias, $kid, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.h6u($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsKeyAliasStore$get$slambda(this$0, $alias, resultContinuation) {
        this.q6u_1 = this$0;
        this.r6u_1 = $alias;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsKeyAliasStore$get$slambda).t6u = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsKeyAliasStore$get$slambda).y9 = function(p1, $completion) {
        return this.t6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsKeyAliasStore$get$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.q6u_1.f6q_1.k68(this.r6u_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsKeyAliasStore$get$slambda).e2b = function($this$promise, completion) {
        var i = new JsKeyAliasStore$get$slambda(this.q6u_1, this.r6u_1, completion);
        i.s6u_1 = $this$promise;
        return i;
    };
    function JsKeyAliasStore$get$slambda_0(this$0, $alias, resultContinuation) {
        var i = new JsKeyAliasStore$get$slambda(this$0, $alias, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.t6u($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsKeyAliasStore(inner) {
        this.f6q_1 = inner;
    }
    protoOf(JsKeyAliasStore).u6u = function() {
        return this.f6q_1;
    };
    protoOf(JsKeyAliasStore).add = function(alias, kid) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsKeyAliasStore$add$slambda_0(this, alias, kid, null));
    };
    protoOf(JsKeyAliasStore).get = function(alias) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsKeyAliasStore$get$slambda_0(this, alias, null));
    };
    function JsCredentialIssuerLoader$load$slambda(this$0, $issuerId, resultContinuation) {
        this.d6v_1 = this$0;
        this.e6v_1 = $issuerId;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuerLoader$load$slambda).g6v = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuerLoader$load$slambda).y9 = function(p1, $completion) {
        return this.g6v((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuerLoader$load$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.d6v_1.inner.g61(this.e6v_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return createJsCredentialIssuer(ARGUMENT);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuerLoader$load$slambda).e2b = function($this$promise, completion) {
        var i = new JsCredentialIssuerLoader$load$slambda(this.d6v_1, this.e6v_1, completion);
        i.f6v_1 = $this$promise;
        return i;
    };
    function JsCredentialIssuerLoader$load$slambda_0(this$0, $issuerId, resultContinuation) {
        var i = new JsCredentialIssuerLoader$load$slambda(this$0, $issuerId, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.g6v($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuerLoader(inner) {
        this.inner = inner;
    }
    protoOf(JsCredentialIssuerLoader).o3h = function() {
        return this.inner;
    };
    protoOf(JsCredentialIssuerLoader).load = function(issuerId) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsCredentialIssuerLoader$load$slambda_0(this, issuerId, null));
    };
    function JsCredentialIssuerStore$upsert$slambda($credentialIssuer, this$0, resultContinuation) {
        this.p6v_1 = $credentialIssuer;
        this.q6v_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuerStore$upsert$slambda).h6u = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuerStore$upsert$slambda).y9 = function(p1, $completion) {
        return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuerStore$upsert$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    var tmp_0 = this;
                    var tmp_1 = this.p6v_1;
                    var tmp0_elvis_lhs = tmp_1 instanceof JsCredentialIssuer ? tmp_1 : null;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) throw new NotImplementedError("An operation is not implemented: ");
                    else tmp_2 = tmp0_elvis_lhs;
                    tmp_0.s6v_1 = tmp_2;
                    this.v8_1 = 1;
                    suspendResult = this.q6v_1.t6v_1.u6v(this.s6v_1.credentialIssuer, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return true;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuerStore$upsert$slambda).e2b = function($this$promise, completion) {
        var i = new JsCredentialIssuerStore$upsert$slambda(this.p6v_1, this.q6v_1, completion);
        i.r6v_1 = $this$promise;
        return i;
    };
    function JsCredentialIssuerStore$upsert$slambda_0($credentialIssuer, this$0, resultContinuation) {
        var i = new JsCredentialIssuerStore$upsert$slambda($credentialIssuer, this$0, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.h6u($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuerStore$getAll$slambda(this$0, resultContinuation) {
        this.d6w_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuerStore$getAll$slambda).f6w = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuerStore$getAll$slambda).y9 = function(p1, $completion) {
        return this.f6w((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuerStore$getAll$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.d6w_1.t6v_1.g6w(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var this_0 = suspendResult;
                    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
                    var tmp0_iterator = this_0.j();
                    while(tmp0_iterator.k()){
                        var item = tmp0_iterator.l();
                        destination.e(createJsCredentialIssuer(item));
                    }
                    return copyToArray(destination);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuerStore$getAll$slambda).e2b = function($this$promise, completion) {
        var i = new JsCredentialIssuerStore$getAll$slambda(this.d6w_1, completion);
        i.e6w_1 = $this$promise;
        return i;
    };
    function JsCredentialIssuerStore$getAll$slambda_0(this$0, resultContinuation) {
        var i = new JsCredentialIssuerStore$getAll$slambda(this$0, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.f6w($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuerStore$getById$slambda(this$0, $id, resultContinuation) {
        this.p6w_1 = this$0;
        this.q6w_1 = $id;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuerStore$getById$slambda).s6w = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuerStore$getById$slambda).y9 = function(p1, $completion) {
        return this.s6w((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuerStore$getById$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.p6w_1.t6v_1.t6w(this.q6w_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var tmp4_safe_receiver = suspendResult;
                    var tmp_0;
                    if (tmp4_safe_receiver == null) tmp_0 = null;
                    else tmp_0 = createJsCredentialIssuer(tmp4_safe_receiver);
                    return tmp_0;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuerStore$getById$slambda).e2b = function($this$promise, completion) {
        var i = new JsCredentialIssuerStore$getById$slambda(this.p6w_1, this.q6w_1, completion);
        i.r6w_1 = $this$promise;
        return i;
    };
    function JsCredentialIssuerStore$getById$slambda_0(this$0, $id, resultContinuation) {
        var i = new JsCredentialIssuerStore$getById$slambda(this$0, $id, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.s6w($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuerStore$removeById$slambda(this$0, $id, resultContinuation) {
        this.c6x_1 = this$0;
        this.d6x_1 = $id;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuerStore$removeById$slambda).h6u = function($this$promise, $completion) {
        var tmp = this.e2b($this$promise, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuerStore$removeById$slambda).y9 = function(p1, $completion) {
        return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuerStore$removeById$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.c6x_1.t6v_1.f6x(this.d6x_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return true;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuerStore$removeById$slambda).e2b = function($this$promise, completion) {
        var i = new JsCredentialIssuerStore$removeById$slambda(this.c6x_1, this.d6x_1, completion);
        i.e6x_1 = $this$promise;
        return i;
    };
    function JsCredentialIssuerStore$removeById$slambda_0(this$0, $id, resultContinuation) {
        var i = new JsCredentialIssuerStore$removeById$slambda(this$0, $id, resultContinuation);
        var l = function($this$promise, $completion) {
            return i.h6u($this$promise, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuerStore(store) {
        this.t6v_1 = store;
    }
    protoOf(JsCredentialIssuerStore).upsert = function(credentialIssuer) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsCredentialIssuerStore$upsert$slambda_0(credentialIssuer, this, null));
    };
    protoOf(JsCredentialIssuerStore).getAll = function() {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsCredentialIssuerStore$getAll$slambda_0(this, null));
    };
    protoOf(JsCredentialIssuerStore).getById = function(id) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsCredentialIssuerStore$getById$slambda_0(this, id, null));
    };
    protoOf(JsCredentialIssuerStore).removeById = function(id) {
        var tmp = GlobalScope_instance;
        return promise(tmp, VOID, VOID, JsCredentialIssuerStore$removeById$slambda_0(this, id, null));
    };
    function JsVerifiableCredentialStore(inner) {
        this.inner = inner;
    }
    protoOf(JsVerifiableCredentialStore).o3h = function() {
        return this.inner;
    };
    protoOf(JsVerifiableCredentialStore).insert = function(credential) {
        this.inner.p68(inner_0(credential));
    };
    protoOf(JsVerifiableCredentialStore).delete = function(credentialId) {
        this.inner.q68(credentialId);
    };
    protoOf(JsVerifiableCredentialStore).getById = function(credentialId) {
        var tmp5_safe_receiver = this.inner.r68(credentialId);
        var tmp;
        if (tmp5_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsVerifiableCredentialStore.getById.<anonymous>' call
        tmp = createJsUserVerifiableCredential(tmp5_safe_receiver);
        return tmp;
    };
    protoOf(JsVerifiableCredentialStore).getByName = function(namePrefix) {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.inner.s68(namePrefix);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JsVerifiableCredentialStore.getByName.<anonymous>' call
            var tmp$ret$0 = createJsUserVerifiableCredential(item);
            destination.e(tmp$ret$0);
        }
        return copyToArray(destination);
    };
    protoOf(JsVerifiableCredentialStore).getByIssuer = function(issuerId) {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.inner.t68(issuerId);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JsVerifiableCredentialStore.getByIssuer.<anonymous>' call
            var tmp$ret$0 = createJsUserVerifiableCredential(item);
            destination.e(tmp$ret$0);
        }
        return copyToArray(destination);
    };
    protoOf(JsVerifiableCredentialStore).getAll = function() {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.inner.u68();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JsVerifiableCredentialStore.getAll.<anonymous>' call
            var tmp$ret$0 = createJsUserVerifiableCredential(item);
            destination.e(tmp$ret$0);
        }
        return copyToArray(destination);
    };
    function JsResolvedOffer$issuer$delegate$lambda(this$0) {
        return function() {
            return createJsCredentialIssuer(this$0.g6x_1.f5y_1);
        };
    }
    function JsResolvedOffer$credentialsSupported$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = this$0.g6x_1.g5y_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsResolvedOffer.credentialsSupported$delegate.<anonymous>.<anonymous>' call
                var tmp$ret$0 = createJsCredentialIssuerSupportedCredential(item);
                destination.e(tmp$ret$0);
            }
            return copyToArray(destination);
        };
    }
    function JsResolvedOffer$txCode$delegate$lambda(this$0) {
        return function() {
            var tmp6_safe_receiver = this$0.g6x_1.h5y_1;
            var tmp;
            if (tmp6_safe_receiver == null) tmp = null;
            else // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'JsResolvedOffer.txCode$delegate.<anonymous>.<anonymous>' call
            tmp = new JsTxCode(tmp6_safe_receiver.r31_1, tmp6_safe_receiver.s31_1, tmp6_safe_receiver.t31_1);
            return tmp;
        };
    }
    function JsResolvedOffer(inner) {
        this.g6x_1 = inner;
        var tmp = this;
        tmp.h6x_1 = lazy(JsResolvedOffer$issuer$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.i6x_1 = lazy(JsResolvedOffer$credentialsSupported$delegate$lambda(this));
        var tmp_1 = this;
        tmp_1.j6x_1 = lazy(JsResolvedOffer$txCode$delegate$lambda(this));
    }
    protoOf(JsResolvedOffer).u6u = function() {
        return this.g6x_1;
    };
    protoOf(JsResolvedOffer).e3c = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.h6x_1;
        issuer$factory();
        return this_0.b1();
    };
    protoOf(JsResolvedOffer).i3h = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.i6x_1;
        credentialsSupported$factory();
        return this_0.b1();
    };
    protoOf(JsResolvedOffer).k6x = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.j6x_1;
        txCode$factory();
        return this_0.b1();
    };
    function JsTxCode(inputMode, length, description) {
        this.inputMode = inputMode;
        this.length = length;
        this.description = description;
    }
    protoOf(JsTxCode).l6x = function() {
        return this.inputMode;
    };
    protoOf(JsTxCode).a = function() {
        return this.length;
    };
    protoOf(JsTxCode).t3h = function() {
        return this.description;
    };
    function JsOfferResult$issuedCredentials$delegate$lambda(this$0) {
        return function() {
            var tmp = this$0.m6x_1;
            var tmp7_safe_receiver = tmp instanceof IssuedCredentials ? tmp : null;
            var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.b63_1;
            var tmp_0;
            if (tmp8_safe_receiver == null) tmp_0 = null;
            else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp8_safe_receiver, 10));
                var tmp0_iterator = tmp8_safe_receiver.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsOfferResult.issuedCredentials$delegate.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = createJsUserVerifiableCredential(item);
                    destination.e(tmp$ret$0);
                }
                tmp_0 = destination;
            }
            var tmp9_safe_receiver = tmp_0;
            var tmp_1;
            if (tmp9_safe_receiver == null) tmp_1 = null;
            else // Inline function 'kotlin.collections.toTypedArray' call
            tmp_1 = copyToArray(tmp9_safe_receiver);
            return tmp_1;
        };
    }
    function JsOfferResult(inner) {
        this.m6x_1 = inner;
        var tmp = this;
        tmp.n6x_1 = lazy(JsOfferResult$issuedCredentials$delegate$lambda(this));
        var tmp_0 = this;
        var tmp_1 = this.m6x_1;
        tmp_0.invalidOfferOrUserCode = tmp_1 instanceof InvalidOfferOrUserCode;
    }
    protoOf(JsOfferResult).o6x = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.n6x_1;
        issuedCredentials$factory();
        return this_0.b1();
    };
    protoOf(JsOfferResult).p6x = function() {
        return this.invalidOfferOrUserCode;
    };
    function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda$lambda($this_coroutineScope) {
        return function(it) {
            cancel($this_coroutineScope);
            return Unit_instance;
        };
    }
    function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda($abortSignal, this$0, $offerString, resultContinuation) {
        this.y6x_1 = $abortSignal;
        this.z6x_1 = this$0;
        this.a6y_1 = $offerString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).c6y = function($this$coroutineScope, $completion) {
        var tmp = this.e2b($this$coroutineScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).y9 = function(p1, $completion) {
        return this.c6y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.y6x_1.onabort = JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda$lambda(this.b6y_1);
                    this.v8_1 = 1;
                    suspendResult = this.z6x_1.d6y_1.z62(this.a6y_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var resolvedOffer = suspendResult;
                    return new JsResolvedOffer(resolvedOffer);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).e2b = function($this$coroutineScope, completion) {
        var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda(this.y6x_1, this.z6x_1, this.a6y_1, completion);
        i.b6y_1 = $this$coroutineScope;
        return i;
    };
    function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda_0($abortSignal, this$0, $offerString, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda($abortSignal, this$0, $offerString, resultContinuation);
        var l = function($this$coroutineScope, $completion) {
            return i.c6y($this$coroutineScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda$lambda($this_coroutineScope) {
        return function(it) {
            cancel($this_coroutineScope);
            return Unit_instance;
        };
    }
    function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
        this.m6y_1 = $abortSignal;
        this.n6y_1 = this$0;
        this.o6y_1 = $resolvedOffer;
        this.p6y_1 = $credentialsSupported;
        this.q6y_1 = $userCode;
        this.r6y_1 = $signingKeyPair;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).t6y = function($this$coroutineScope, $completion) {
        var tmp = this.e2b($this$coroutineScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).y9 = function(p1, $completion) {
        return this.t6y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.m6y_1.onabort = JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda$lambda(this.s6y_1);
                    this.v8_1 = 1;
                    var this_0 = this.p6y_1;
                    var destination = ArrayList_init_$Create$(this_0.length);
                    var inductionVariable = 0;
                    var last = this_0.length;
                    while(inductionVariable < last){
                        var item = this_0[inductionVariable];
                        inductionVariable = inductionVariable + 1 | 0;
                        destination.e(inner_1(item));
                    }
                    var tmp_0 = toList(destination);
                    var tmp_1 = this.r6y_1.signingKey;
                    var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
                    var tmp_3 = this.r6y_1.verificationKey;
                    suspendResult = this.n6y_1.d6y_1.a63(this.o6y_1.g6x_1, tmp_0, this.q6y_1, new SigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), this.r6y_1.id), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var ARGUMENT = suspendResult;
                    return new JsOfferResult(ARGUMENT);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).e2b = function($this$coroutineScope, completion) {
        var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda(this.m6y_1, this.n6y_1, this.o6y_1, this.p6y_1, this.q6y_1, this.r6y_1, completion);
        i.s6y_1 = $this$coroutineScope;
        return i;
    };
    function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda_0($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation);
        var l = function($this$coroutineScope, $completion) {
            return i.t6y($this$coroutineScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda$lambda($abortSignal, $this_coroutineScope) {
        return function(it) {
            var tmp = $abortSignal.reason;
            var cause = tmp instanceof CancellationException ? tmp : null;
            cancel($this_coroutineScope, cause);
            return Unit_instance;
        };
    }
    function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
        this.c6z_1 = $abortSignal;
        this.d6z_1 = this$0;
        this.e6z_1 = $issuer;
        this.f6z_1 = $credentialSupported;
        this.g6z_1 = $signingKeyPair;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).i6z = function($this$coroutineScope, $completion) {
        var tmp = this.e2b($this$coroutineScope, $completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).y9 = function(p1, $completion) {
        return this.i6z((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.c6z_1.onabort = JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda$lambda(this.c6z_1, this.h6z_1);
                    this.v8_1 = 1;
                    var tmp_0 = inner_1(this.f6z_1);
                    var tmp_1 = this.g6z_1.signingKey;
                    var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
                    var tmp_3 = this.g6z_1.verificationKey;
                    suspendResult = this.d6z_1.d6y_1.y61(this.e6z_1.credentialIssuer, tmp_0, new SigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), this.g6z_1.id), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var this_0 = suspendResult;
                    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
                    var tmp0_iterator = this_0.j();
                    while(tmp0_iterator.k()){
                        var item = tmp0_iterator.l();
                        destination.e(createJsUserVerifiableCredential(item));
                    }
                    return copyToArray(destination);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).e2b = function($this$coroutineScope, completion) {
        var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda(this.c6z_1, this.d6z_1, this.e6z_1, this.f6z_1, this.g6z_1, completion);
        i.h6z_1 = $this$coroutineScope;
        return i;
    };
    function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda_0($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation);
        var l = function($this$coroutineScope, $completion) {
            return i.i6z($this$coroutineScope, $completion);
        };
        l.$arity = 1;
        return l;
    }
    function JsCredentialIssuanceCoordinator$startHandleOffer$slambda($abortSignal, this$0, $offerString, resultContinuation) {
        this.r6z_1 = $abortSignal;
        this.s6z_1 = this$0;
        this.t6z_1 = $offerString;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).u6z = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).o6r = function($completion) {
        return this.u6z($completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda_0(this.r6z_1, this.s6z_1, this.t6z_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).n6r = function(completion) {
        return new JsCredentialIssuanceCoordinator$startHandleOffer$slambda(this.r6z_1, this.s6z_1, this.t6z_1, completion);
    };
    function JsCredentialIssuanceCoordinator$startHandleOffer$slambda_0($abortSignal, this$0, $offerString, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda($abortSignal, this$0, $offerString, resultContinuation);
        var l = function($completion) {
            return i.u6z($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
        this.d70_1 = $abortSignal;
        this.e70_1 = this$0;
        this.f70_1 = $resolvedOffer;
        this.g70_1 = $credentialsSupported;
        this.h70_1 = $userCode;
        this.i70_1 = $signingKeyPair;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).j70 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).o6r = function($completion) {
        return this.j70($completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda_0(this.d70_1, this.e70_1, this.f70_1, this.g70_1, this.h70_1, this.i70_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).n6r = function(completion) {
        return new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda(this.d70_1, this.e70_1, this.f70_1, this.g70_1, this.h70_1, this.i70_1, completion);
    };
    function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda_0($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation);
        var l = function($completion) {
            return i.j70($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsCredentialIssuanceCoordinator$requestCredentials$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
        this.s70_1 = $abortSignal;
        this.t70_1 = this$0;
        this.u70_1 = $issuer;
        this.v70_1 = $credentialSupported;
        this.w70_1 = $signingKeyPair;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).x70 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).o6r = function($completion) {
        return this.x70($completion);
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda_0(this.s70_1, this.t70_1, this.u70_1, this.v70_1, this.w70_1, null), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return suspendResult;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).n6r = function(completion) {
        return new JsCredentialIssuanceCoordinator$requestCredentials$slambda(this.s70_1, this.t70_1, this.u70_1, this.v70_1, this.w70_1, completion);
    };
    function JsCredentialIssuanceCoordinator$requestCredentials$slambda_0($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
        var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation);
        var l = function($completion) {
            return i.x70($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsCredentialIssuanceCoordinator(inner) {
        this.d6y_1 = inner;
    }
    protoOf(JsCredentialIssuanceCoordinator).startHandleOffer = function(offerString, abortSignal) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$startHandleOffer$slambda_0(abortSignal, this, offerString, null));
    };
    protoOf(JsCredentialIssuanceCoordinator).continueHandleOffer = function(resolvedOffer, credentialsSupported, userCode, signingKeyPair, abortSignal) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$continueHandleOffer$slambda_0(abortSignal, this, resolvedOffer, credentialsSupported, userCode, signingKeyPair, null));
    };
    protoOf(JsCredentialIssuanceCoordinator).requestCredentials = function(issuer, credentialSupported, signingKeyPair, abortSignal) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$requestCredentials$slambda_0(abortSignal, this, issuer, credentialSupported, signingKeyPair, null));
    };
    function issuer$factory() {
        return getPropertyCallableRef("issuer", 1, KProperty1, function(receiver) {
            return receiver.issuer;
        }, null);
    }
    function credentialsSupported$factory() {
        return getPropertyCallableRef("credentialsSupported", 1, KProperty1, function(receiver) {
            return receiver.credentialsSupported;
        }, null);
    }
    function txCode$factory() {
        return getPropertyCallableRef("txCode", 1, KProperty1, function(receiver) {
            return receiver.txCode;
        }, null);
    }
    function issuedCredentials$factory() {
        return getPropertyCallableRef("issuedCredentials", 1, KProperty1, function(receiver) {
            return receiver.issuedCredentials;
        }, null);
    }
    function LocalStorageCredentialIssuerStore$Companion$json$lambda($this$Json) {
        $this$Json.u19_1 = true;
        return Unit_instance;
    }
    function loadFromLocalStorage($this) {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'vc_js.decodeFromLocalStorageOrNull' call
            var this_0 = Companion_getInstance_18().z70_1;
            var key = "issuer-store";
            // Inline function 'org.w3c.dom.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = localStorage[key];
            var tmp;
            if (tmp0_elvis_lhs == null) {
                tmp$ret$2 = null;
                break $l$block;
            } else tmp = tmp0_elvis_lhs;
            var storedValue = tmp;
            var tmp_0;
            try {
                // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
                // Inline function 'kotlinx.serialization.serializer' call
                var this_1 = this_0.dp();
                // Inline function 'kotlinx.serialization.internal.cast' call
                var this_2 = serializer(this_1, createKType(getKClass(KtMutableMap), arrayOf([
                    createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)),
                    createInvariantKTypeProjection(createKType(getKClass(JsonCredentialIssuer), arrayOf([]), false))
                ]), true));
                var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
                tmp_0 = this_0.cp(tmp$ret$4, storedValue);
            } catch ($p) {
                var tmp_1;
                if ($p instanceof Exception) {
                    var ex = $p;
                    console.log("Ignoring localStorage key '" + key + "'");
                    tmp_1 = null;
                } else throw $p;
                tmp_0 = tmp_1;
            }
            tmp$ret$2 = tmp_0;
        }
        var tmp0_elvis_lhs_0 = tmp$ret$2;
        var tmp_2;
        if (tmp0_elvis_lhs_0 == null) // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_2 = LinkedHashMap_init_$Create$_0();
        else tmp_2 = tmp0_elvis_lhs_0;
        return tmp_2;
    }
    function saveIntoLocalStorage($this) {
        var tmp = localStorage;
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Companion_getInstance_18().z70_1;
        var value = $this.a71_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(KtMutableMap), arrayOf([
            createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)),
            createInvariantKTypeProjection(createKType(getKClass(JsonCredentialIssuer), arrayOf([]), false))
        ]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        tmp.setItem("issuer-store", tmp$ret$2);
    }
    function Companion_11() {
        Companion_instance_20 = this;
        this.y70_1 = "issuer-store";
        var tmp = this;
        tmp.z70_1 = Json(VOID, LocalStorageCredentialIssuerStore$Companion$json$lambda);
    }
    var Companion_instance_20;
    function Companion_getInstance_18() {
        if (Companion_instance_20 == null) new Companion_11();
        return Companion_instance_20;
    }
    function LocalStorageCredentialIssuerStore() {
        Companion_getInstance_18();
        this.a71_1 = loadFromLocalStorage(this);
    }
    protoOf(LocalStorageCredentialIssuerStore).u6v = function(credentialIssuer, $completion) {
        // Inline function 'kotlin.collections.set' call
        var this_0 = this.a71_1;
        var key = credentialIssuer.t32_1.u33_1;
        this_0.m2(key, credentialIssuer);
        saveIntoLocalStorage(this);
        return Unit_instance;
    };
    protoOf(LocalStorageCredentialIssuerStore).f6x = function(id, $completion) {
        this.a71_1.n2(id);
        saveIntoLocalStorage(this);
        return Unit_instance;
    };
    protoOf(LocalStorageCredentialIssuerStore).g6w = function($completion) {
        return toList(this.a71_1.g2());
    };
    protoOf(LocalStorageCredentialIssuerStore).t6w = function(id, $completion) {
        return this.a71_1.e2(id);
    };
    function loadFromLocalStorage_0($this) {
        var tmp$ret$2;
        $l$block: {
            // Inline function 'vc_js.decodeFromLocalStorageOrNull' call
            var this_0 = Default_getInstance();
            var key = "credential-store";
            // Inline function 'org.w3c.dom.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = localStorage[key];
            var tmp;
            if (tmp0_elvis_lhs == null) {
                tmp$ret$2 = null;
                break $l$block;
            } else tmp = tmp0_elvis_lhs;
            var storedValue = tmp;
            var tmp_0;
            try {
                // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
                // Inline function 'kotlinx.serialization.serializer' call
                var this_1 = this_0.dp();
                // Inline function 'kotlinx.serialization.internal.cast' call
                var this_2 = serializer(this_1, createKType(getKClass(InMemoryVerifiableCredentialStore), arrayOf([]), true));
                var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
                tmp_0 = this_0.cp(tmp$ret$4, storedValue);
            } catch ($p) {
                var tmp_1;
                if ($p instanceof Exception) {
                    var ex = $p;
                    console.log("Ignoring localStorage key '" + key + "'");
                    tmp_1 = null;
                } else throw $p;
                tmp_0 = tmp_1;
            }
            tmp$ret$2 = tmp_0;
        }
        var tmp0_elvis_lhs_0 = tmp$ret$2;
        return tmp0_elvis_lhs_0 == null ? new InMemoryVerifiableCredentialStore() : tmp0_elvis_lhs_0;
    }
    function Companion_12() {
        this.b71_1 = "credential-store";
    }
    var Companion_instance_21;
    function Companion_getInstance_19() {
        return Companion_instance_21;
    }
    function saveIntoLocalStorage_0($this) {
        var tmp = localStorage;
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        var value = $this.c71_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(InMemoryVerifiableCredentialStore), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        tmp.setItem("credential-store", tmp$ret$2);
    }
    function LocalStorageVerifiableCredentialStore(delegate) {
        delegate = delegate === VOID ? loadFromLocalStorage_0(Companion_instance_21) : delegate;
        this.c71_1 = delegate;
    }
    protoOf(LocalStorageVerifiableCredentialStore).r68 = function(localId) {
        return this.c71_1.r68(localId);
    };
    protoOf(LocalStorageVerifiableCredentialStore).s68 = function(namePrefix) {
        return this.c71_1.s68(namePrefix);
    };
    protoOf(LocalStorageVerifiableCredentialStore).t68 = function(issuerId) {
        return this.c71_1.t68(issuerId);
    };
    protoOf(LocalStorageVerifiableCredentialStore).u68 = function() {
        return this.c71_1.u68();
    };
    protoOf(LocalStorageVerifiableCredentialStore).p68 = function(credential) {
        this.c71_1.p68(credential);
        saveIntoLocalStorage_0(this);
    };
    protoOf(LocalStorageVerifiableCredentialStore).q68 = function(localId) {
        this.c71_1.q68(localId);
        saveIntoLocalStorage_0(this);
    };
    function JsValidatedRequestJwt(inner) {
        this.inner = inner;
        this.jws = new JsJwsHeaderAndPayload(this.inner.f6i_1);
        this.responseUri = this.inner.g6i_1;
        this.iss = this.inner.h6i_1;
        this.presentationDefinition = new JsPresentationDefinition(this.inner.j6i_1);
        this.state = this.inner.k6i_1;
        this.expAt = this.inner.l6i_1;
    }
    protoOf(JsValidatedRequestJwt).o3h = function() {
        return this.inner;
    };
    protoOf(JsValidatedRequestJwt).d71 = function() {
        return this.jws;
    };
    protoOf(JsValidatedRequestJwt).e71 = function() {
        return this.responseUri;
    };
    protoOf(JsValidatedRequestJwt).f71 = function() {
        return this.iss;
    };
    protoOf(JsValidatedRequestJwt).g71 = function() {
        return this.presentationDefinition;
    };
    protoOf(JsValidatedRequestJwt).n5v = function() {
        return this.state;
    };
    protoOf(JsValidatedRequestJwt).h71 = function() {
        return this.expAt;
    };
    function JsPresentationDefinition$format$delegate$lambda(this$0) {
        return function() {
            var innerFormat = this$0.inner.j3d_1;
            var tmp;
            if (!(innerFormat == null)) tmp = new JsFormat(innerFormat);
            else tmp = null;
            return tmp;
        };
    }
    function JsPresentationDefinition$inputDescriptors$delegate$lambda(this$0) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = this$0.inner.k3d_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsPresentationDefinition.inputDescriptors$delegate.<anonymous>.<anonymous>' call
                var tmp$ret$0 = new JsInputDescriptor(item);
                destination.e(tmp$ret$0);
            }
            return copyToArray(destination);
        };
    }
    function JsPresentationDefinition(inner) {
        this.inner = inner;
        this.id = this.inner.g3d_1;
        this.name = this.inner.h3d_1;
        this.purpose = this.inner.i3d_1;
        var tmp = this;
        tmp.i71_1 = lazy(JsPresentationDefinition$format$delegate$lambda(this));
        var tmp_0 = this;
        tmp_0.j71_1 = lazy(JsPresentationDefinition$inputDescriptors$delegate$lambda(this));
    }
    protoOf(JsPresentationDefinition).o3h = function() {
        return this.inner;
    };
    protoOf(JsPresentationDefinition).k2a = function() {
        return this.id;
    };
    protoOf(JsPresentationDefinition).r2 = function() {
        return this.name;
    };
    protoOf(JsPresentationDefinition).k71 = function() {
        return this.purpose;
    };
    protoOf(JsPresentationDefinition).z33 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.i71_1;
        format$factory();
        return this_0.b1();
    };
    protoOf(JsPresentationDefinition).l71 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.j71_1;
        inputDescriptors$factory();
        return this_0.b1();
    };
    function JsFormat$jwtVcJson$delegate$lambda($inner) {
        return function() {
            var innerJwtVcJson = $inner.s3e_1;
            var tmp;
            if (!(innerJwtVcJson == null)) tmp = new JsAlgFormat(innerJwtVcJson);
            else tmp = null;
            return tmp;
        };
    }
    function JsFormat$jwtVpJson$delegate$lambda($inner) {
        return function() {
            var innerJwtVpJson = $inner.t3e_1;
            var tmp;
            if (!(innerJwtVpJson == null)) tmp = new JsAlgFormat(innerJwtVpJson);
            else tmp = null;
            return tmp;
        };
    }
    function JsFormat$ldpVc$delegate$lambda($inner) {
        return function() {
            var innerLdpVc = $inner.v3e_1;
            var tmp;
            if (!(innerLdpVc == null)) tmp = new JsProofTypeFormat(innerLdpVc);
            else tmp = null;
            return tmp;
        };
    }
    function JsFormat$ldpVp$delegate$lambda($inner) {
        return function() {
            var innerLdpVc = $inner.v3e_1;
            var tmp;
            if (!(innerLdpVc == null)) tmp = new JsProofTypeFormat(innerLdpVc);
            else tmp = null;
            return tmp;
        };
    }
    function JsFormat$customFormats$delegate$lambda($inner) {
        return function() {
            return createJSObject($inner.x3e_1);
        };
    }
    function JsFormat(inner) {
        var tmp = this;
        tmp.m71_1 = lazy(JsFormat$jwtVcJson$delegate$lambda(inner));
        var tmp_0 = this;
        tmp_0.n71_1 = lazy(JsFormat$jwtVpJson$delegate$lambda(inner));
        var tmp_1 = this;
        tmp_1.o71_1 = lazy(JsFormat$ldpVc$delegate$lambda(inner));
        var tmp_2 = this;
        tmp_2.p71_1 = lazy(JsFormat$ldpVp$delegate$lambda(inner));
        var tmp_3 = this;
        tmp_3.q71_1 = lazy(JsFormat$customFormats$delegate$lambda(inner));
    }
    protoOf(JsFormat).a3j = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.m71_1;
        jwtVcJson$factory();
        return this_0.b1();
    };
    protoOf(JsFormat).r71 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.n71_1;
        jwtVpJson$factory();
        return this_0.b1();
    };
    protoOf(JsFormat).s71 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.o71_1;
        ldpVc$factory();
        return this_0.b1();
    };
    protoOf(JsFormat).t71 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.p71_1;
        ldpVp$factory();
        return this_0.b1();
    };
    protoOf(JsFormat).u71 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.q71_1;
        customFormats$factory();
        return this_0.b1();
    };
    function JsAlgFormat(inner) {
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = inner.b3f_1;
        tmp.alg = copyToArray(this_0);
    }
    protoOf(JsAlgFormat).v71 = function() {
        return this.alg;
    };
    function JsProofTypeFormat(inner) {
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = inner.c3f_1;
        tmp.proofType = copyToArray(this_0);
    }
    protoOf(JsProofTypeFormat).w71 = function() {
        return this.proofType;
    };
    function JsInputDescriptor$format$delegate$lambda(this$0) {
        return function() {
            var innerFormat = this$0.inner.r3d_1;
            var tmp;
            if (!(innerFormat == null)) tmp = new JsFormat(innerFormat);
            else tmp = null;
            return tmp;
        };
    }
    function JsInputDescriptor(inner) {
        this.inner = inner;
        this.id = this.inner.n3d_1;
        this.name = this.inner.o3d_1;
        this.purpose = this.inner.p3d_1;
        this.constraints = new JsConstraint(this.inner.q3d_1);
        var tmp = this;
        tmp.x71_1 = lazy(JsInputDescriptor$format$delegate$lambda(this));
    }
    protoOf(JsInputDescriptor).o3h = function() {
        return this.inner;
    };
    protoOf(JsInputDescriptor).k2a = function() {
        return this.id;
    };
    protoOf(JsInputDescriptor).r2 = function() {
        return this.name;
    };
    protoOf(JsInputDescriptor).k71 = function() {
        return this.purpose;
    };
    protoOf(JsInputDescriptor).y71 = function() {
        return this.constraints;
    };
    protoOf(JsInputDescriptor).z33 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.x71_1;
        format$factory_0();
        return this_0.b1();
    };
    function JsConstraint$fields$delegate$lambda($inner) {
        return function() {
            var innerFields = $inner.v3d_1;
            var tmp;
            if (innerFields == null) tmp = null;
            else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var destination = ArrayList_init_$Create$(collectionSizeOrDefault(innerFields, 10));
                var tmp0_iterator = innerFields.j();
                while(tmp0_iterator.k()){
                    var item = tmp0_iterator.l();
                    // Inline function 'JsConstraint.fields$delegate.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = new JsField(item);
                    destination.e(tmp$ret$0);
                }
                tmp = destination;
            }
            var tmp11_safe_receiver = tmp;
            var tmp_0;
            if (tmp11_safe_receiver == null) tmp_0 = null;
            else // Inline function 'kotlin.collections.toTypedArray' call
            tmp_0 = copyToArray(tmp11_safe_receiver);
            return tmp_0;
        };
    }
    function JsConstraint(inner) {
        var tmp = this;
        tmp.z71_1 = lazy(JsConstraint$fields$delegate$lambda(inner));
        this.limitDisclosure = inner.w3d_1;
    }
    protoOf(JsConstraint).a72 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.z71_1;
        fields$factory();
        return this_0.b1();
    };
    protoOf(JsConstraint).b72 = function() {
        return this.limitDisclosure;
    };
    function JsField$filter$delegate$lambda($inner) {
        return function() {
            var innerFilter = $inner.e3e_1;
            var tmp;
            if (!(innerFilter == null)) tmp = Companion_instance_22.c72(innerFilter);
            else tmp = null;
            return tmp;
        };
    }
    function JsField(inner) {
        this.id = inner.a3e_1;
        this.name = inner.b3e_1;
        this.purpose = inner.c3e_1;
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = inner.d3e_1;
        tmp.path = copyToArray(this_0);
        var tmp_0 = this;
        tmp_0.d72_1 = lazy(JsField$filter$delegate$lambda(inner));
        this.optional = inner.f3e_1;
    }
    protoOf(JsField).k2a = function() {
        return this.id;
    };
    protoOf(JsField).r2 = function() {
        return this.name;
    };
    protoOf(JsField).k71 = function() {
        return this.purpose;
    };
    protoOf(JsField).e72 = function() {
        return this.path;
    };
    protoOf(JsField).f72 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.d72_1;
        filter$factory();
        return this_0.b1();
    };
    protoOf(JsField).g72 = function() {
        return this.optional;
    };
    function Companion_13() {}
    protoOf(Companion_13).c72 = function(jsonFilter) {
        var tmp;
        if (jsonFilter instanceof JsonStringFilter) tmp = new JsStringFilter(jsonFilter);
        else if (jsonFilter instanceof JsonArrayContainsFilter) tmp = new JsArrayContainsFilter(jsonFilter);
        else noWhenBranchMatchedException();
        return tmp;
    };
    var Companion_instance_22;
    function Companion_getInstance_20() {
        return Companion_instance_22;
    }
    function AbstractJsfilter() {}
    function JsStringFilter(inner) {
        AbstractJsfilter.call(this);
        this.h72_1 = inner.q3e_1;
        this.pattern = inner.r3e_1;
    }
    protoOf(JsStringFilter).g36 = function() {
        return this.h72_1;
    };
    protoOf(JsStringFilter).i72 = function() {
        return this.pattern;
    };
    function JsArrayContainsFilter(inner) {
        AbstractJsfilter.call(this);
        this.j72_1 = inner.i3e_1;
        this.contains = new JsContains(inner.j3e_1);
    }
    protoOf(JsArrayContainsFilter).g36 = function() {
        return this.j72_1;
    };
    protoOf(JsArrayContainsFilter).k72 = function() {
        return this.contains;
    };
    function JsContains(inner) {
        this.type = inner.m3e_1;
        this.pattern = inner.n3e_1;
    }
    protoOf(JsContains).g36 = function() {
        return this.type;
    };
    protoOf(JsContains).i72 = function() {
        return this.pattern;
    };
    function JsVerifiablePresentationResponseParameters(inner) {
        this.inner = inner;
    }
    protoOf(JsVerifiablePresentationResponseParameters).o3h = function() {
        return this.inner;
    };
    function JsPresentationSubmission$descriptorMap$delegate$lambda($inner) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = $inner.w3c_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsPresentationSubmission.descriptorMap$delegate.<anonymous>.<anonymous>' call
                var tmp$ret$0 = new JsDescriptorMapObject(item);
                destination.e(tmp$ret$0);
            }
            return copyToArray(destination);
        };
    }
    function JsPresentationSubmission(inner) {
        this.id = inner.u3c_1;
        this.definitionId = inner.v3c_1;
        var tmp = this;
        tmp.l72_1 = lazy(JsPresentationSubmission$descriptorMap$delegate$lambda(inner));
    }
    protoOf(JsPresentationSubmission).k2a = function() {
        return this.id;
    };
    protoOf(JsPresentationSubmission).m72 = function() {
        return this.definitionId;
    };
    protoOf(JsPresentationSubmission).n72 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.l72_1;
        descriptorMap$factory();
        return this_0.b1();
    };
    function JsDescriptorMapObject(inner) {
        this.id = inner.z3c_1;
        this.format = inner.a3d_1;
        this.path = inner.b3d_1;
        var tmp = this;
        var tmp13_safe_receiver = inner.c3d_1;
        var tmp_0;
        if (tmp13_safe_receiver == null) tmp_0 = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsDescriptorMapObject.pathNested.<anonymous>' call
        tmp_0 = new JsPathNested(tmp13_safe_receiver);
        tmp.pathNested = tmp_0;
    }
    protoOf(JsDescriptorMapObject).k2a = function() {
        return this.id;
    };
    protoOf(JsDescriptorMapObject).z33 = function() {
        return this.format;
    };
    protoOf(JsDescriptorMapObject).e72 = function() {
        return this.path;
    };
    protoOf(JsDescriptorMapObject).o72 = function() {
        return this.pathNested;
    };
    function JsPathNested(inner) {
        this.format = inner.h3f_1;
        this.path = inner.i3f_1;
    }
    protoOf(JsPathNested).z33 = function() {
        return this.format;
    };
    protoOf(JsPathNested).e72 = function() {
        return this.path;
    };
    function JsVerifierDirectPostAuthorizationResponse(inner) {
        this.redirectUri = inner.u3f();
    }
    protoOf(JsVerifierDirectPostAuthorizationResponse).u3f = function() {
        return this.redirectUri;
    };
    function JsUserSelectedCredentials(data) {
        this.data = data;
    }
    protoOf(JsUserSelectedCredentials).p72 = function() {
        return this.data;
    };
    function JsUserSelectedCredential(descriptor, credential, presentationDisclosures) {
        this.descriptor = descriptor;
        this.credential = credential;
        this.presentationDisclosures = presentationDisclosures;
    }
    protoOf(JsUserSelectedCredential).yn = function() {
        return this.descriptor;
    };
    protoOf(JsUserSelectedCredential).n38 = function() {
        return this.credential;
    };
    protoOf(JsUserSelectedCredential).q72 = function() {
        return this.presentationDisclosures;
    };
    function JsPresentationDisclosure(disclosures) {
        this.disclosures = disclosures;
    }
    protoOf(JsPresentationDisclosure).a2z = function() {
        return this.disclosures;
    };
    function format$factory() {
        return getPropertyCallableRef("format", 1, KProperty1, function(receiver) {
            return receiver.format;
        }, null);
    }
    function inputDescriptors$factory() {
        return getPropertyCallableRef("inputDescriptors", 1, KProperty1, function(receiver) {
            return receiver.inputDescriptors;
        }, null);
    }
    function jwtVcJson$factory() {
        return getPropertyCallableRef("jwtVcJson", 1, KProperty1, function(receiver) {
            return receiver.jwtVcJson;
        }, null);
    }
    function jwtVpJson$factory() {
        return getPropertyCallableRef("jwtVpJson", 1, KProperty1, function(receiver) {
            return receiver.jwtVpJson;
        }, null);
    }
    function ldpVc$factory() {
        return getPropertyCallableRef("ldpVc", 1, KProperty1, function(receiver) {
            return receiver.ldpVc;
        }, null);
    }
    function ldpVp$factory() {
        return getPropertyCallableRef("ldpVp", 1, KProperty1, function(receiver) {
            return receiver.ldpVp;
        }, null);
    }
    function customFormats$factory() {
        return getPropertyCallableRef("customFormats", 1, KProperty1, function(receiver) {
            return receiver.customFormats;
        }, null);
    }
    function format$factory_0() {
        return getPropertyCallableRef("format", 1, KProperty1, function(receiver) {
            return receiver.format;
        }, null);
    }
    function fields$factory() {
        return getPropertyCallableRef("fields", 1, KProperty1, function(receiver) {
            return receiver.fields;
        }, null);
    }
    function filter$factory() {
        return getPropertyCallableRef("filter", 1, KProperty1, function(receiver) {
            return receiver.filter;
        }, null);
    }
    function descriptorMap$factory() {
        return getPropertyCallableRef("descriptorMap", 1, KProperty1, function(receiver) {
            return receiver.descriptorMap;
        }, null);
    }
    function convertToUserSelectCredentials($this, userSelectedCredentials) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = userSelectedCredentials.data;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(this_0.length);
        var inductionVariable = 0;
        var last = this_0.length;
        while(inductionVariable < last){
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'Companion.convertToUserSelectCredentials.<anonymous>' call
            var tmp$ret$0 = new UserSelectedCredential(item.descriptor.inner, inner_0(item.credential), new PresentationDisclosure(toList_0(item.presentationDisclosures.disclosures)));
            destination.e(tmp$ret$0);
        }
        return new UserSelectedCredentials(destination);
    }
    function Companion_14() {}
    var Companion_instance_23;
    function Companion_getInstance_21() {
        return Companion_instance_23;
    }
    function JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation) {
        this.z72_1 = this$0;
        this.a73_1 = $validatedRequestJwt;
        this.b73_1 = $userSelectedCredentials;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).c73 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).o6r = function($completion) {
        return this.c73($completion);
    };
    protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.z72_1.d73_1.g6k(this.a73_1.inner, convertToUserSelectCredentials(Companion_instance_23, this.b73_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var params = suspendResult;
                    return new JsVerifiablePresentationResponseParameters(params);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).n6r = function(completion) {
        return new JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this.z72_1, this.a73_1, this.b73_1, completion);
    };
    function JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda_0(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation) {
        var i = new JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation);
        var l = function($completion) {
            return i.c73($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsPresentationResponseCreator(inner) {
        this.d73_1 = inner;
    }
    protoOf(JsPresentationResponseCreator).createVerifiablePresentationResponse = function(validatedRequestJwt, userSelectedCredentials) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda_0(this, validatedRequestJwt, userSelectedCredentials, null));
    };
    function JsRequestJwtStore(inner) {
        this.inner = inner;
    }
    protoOf(JsRequestJwtStore).o3h = function() {
        return this.inner;
    };
    protoOf(JsRequestJwtStore).insert = function(id, requestJwt) {
        this.inner.i6f(id, requestJwt.inner);
    };
    protoOf(JsRequestJwtStore).delete = function(id) {
        this.inner.q68(id);
    };
    protoOf(JsRequestJwtStore).getById = function(id) {
        var tmp14_safe_receiver = this.inner.r68(id);
        var tmp;
        if (tmp14_safe_receiver == null) tmp = null;
        else // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsRequestJwtStore.getById.<anonymous>' call
        tmp = new JsValidatedRequestJwt(tmp14_safe_receiver);
        return tmp;
    };
    protoOf(JsRequestJwtStore).getAll = function() {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.inner.u68();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var tmp0_iterator = this_0.j();
        while(tmp0_iterator.k()){
            var item = tmp0_iterator.l();
            // Inline function 'JsRequestJwtStore.getAll.<anonymous>' call
            var tmp$ret$0 = new JsPair(item.z9_1, new JsValidatedRequestJwt(item.aa_1));
            destination.e(tmp$ret$0);
        }
        return copyToArray(destination);
    };
    protoOf(JsRequestJwtStore).cleanupIfAfterPeriod = function() {
        this.inner.g73();
    };
    function JsVerifierClient$fetchRequestObjectJwt$slambda(this$0, $uri, resultContinuation) {
        this.p73_1 = this$0;
        this.q73_1 = $uri;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).r73 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).o6r = function($completion) {
        return this.r73($completion);
    };
    protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.p73_1.t73_1.b6m(this.q73_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var validatedResponse = suspendResult;
                    return new JsValidatedRequestJwt(validatedResponse);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).n6r = function(completion) {
        return new JsVerifierClient$fetchRequestObjectJwt$slambda(this.p73_1, this.q73_1, completion);
    };
    function JsVerifierClient$fetchRequestObjectJwt$slambda_0(this$0, $uri, resultContinuation) {
        var i = new JsVerifierClient$fetchRequestObjectJwt$slambda(this$0, $uri, resultContinuation);
        var l = function($completion) {
            return i.r73($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this$0, $uri, $params, resultContinuation) {
        this.c74_1 = this$0;
        this.d74_1 = $uri;
        this.e74_1 = $params;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).f74 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).o6r = function($completion) {
        return this.f74($completion);
    };
    protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.c74_1.t73_1.c6m(this.d74_1, this.e74_1.inner, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var response = suspendResult;
                    return new JsVerifierDirectPostAuthorizationResponse(response);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).n6r = function(completion) {
        return new JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this.c74_1, this.d74_1, this.e74_1, completion);
    };
    function JsVerifierClient$postDirectPostAuthorizationResponse$slambda_0(this$0, $uri, $params, resultContinuation) {
        var i = new JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this$0, $uri, $params, resultContinuation);
        var l = function($completion) {
            return i.f74($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsVerifierClient(proxy, clientStore) {
        this.s73_1 = createJsClient(null, proxy);
        this.t73_1 = new VerifierClient(this.s73_1, new HaipRequestObjectJwtValidator(clientStore.inner, System_instance, this.s73_1));
    }
    protoOf(JsVerifierClient).fetchRequestObjectJwt = function(uri) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsVerifierClient$fetchRequestObjectJwt$slambda_0(this, uri, null));
    };
    protoOf(JsVerifierClient).postDirectPostAuthorizationResponse = function(uri, params) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsVerifierClient$postDirectPostAuthorizationResponse$slambda_0(this, uri, params, null));
    };
    function loadFromLocalStorage_1($this) {
        var tmp15_safe_receiver = localStorage.getItem("request-jwt-store");
        var tmp;
        if (tmp15_safe_receiver == null) tmp = null;
        else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'Companion.loadFromLocalStorage.<anonymous>' call
            var tmp_0;
            try {
                // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
                var this_0 = Default_getInstance();
                // Inline function 'kotlinx.serialization.serializer' call
                var this_1 = this_0.dp();
                // Inline function 'kotlinx.serialization.internal.cast' call
                var this_2 = serializer(this_1, createKType(getKClass(InMemoryRequestJwtStore), arrayOf([]), true));
                var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
                tmp_0 = this_0.cp(tmp$ret$1, tmp15_safe_receiver);
            } catch ($p) {
                var tmp_1;
                if ($p instanceof SerializationException) {
                    var e = $p;
                    tmp_1 = new InMemoryRequestJwtStore();
                } else throw $p;
                tmp_0 = tmp_1;
            }
            tmp = tmp_0;
        }
        var tmp0_elvis_lhs = tmp;
        return tmp0_elvis_lhs == null ? new InMemoryRequestJwtStore() : tmp0_elvis_lhs;
    }
    function Companion_15() {
        this.g74_1 = "request-jwt-store";
        this.h74_1 = "request-jwt-store-last-cleanup";
    }
    var Companion_instance_24;
    function Companion_getInstance_22() {
        return Companion_instance_24;
    }
    function saveIntoLocalStorage_1($this) {
        var tmp = localStorage;
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = Default_getInstance();
        var value = $this.e73_1;
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(InMemoryRequestJwtStore), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
        tmp.setItem("request-jwt-store", tmp$ret$2);
    }
    function LocalStorageRequestJwtStore(delegate, cleanupPeriodInSeconds) {
        delegate = delegate === VOID ? loadFromLocalStorage_1(Companion_instance_24) : delegate;
        this.e73_1 = delegate;
        this.f73_1 = cleanupPeriodInSeconds;
    }
    protoOf(LocalStorageRequestJwtStore).r68 = function(id) {
        return this.e73_1.r68(id);
    };
    protoOf(LocalStorageRequestJwtStore).u68 = function() {
        return this.e73_1.u68();
    };
    protoOf(LocalStorageRequestJwtStore).g73 = function() {
        var nowEpochSeconds = System_instance.u1l().f1m();
        var lastCleanup = localStorage.getItem("request-jwt-store-last-cleanup");
        var tmp;
        if (lastCleanup == null) tmp = true;
        else {
            // Inline function 'kotlin.Long.plus' call
            var this_0 = toLong_0(lastCleanup);
            var other = this.f73_1;
            tmp = this_0.y2(toLong(other)).j1(nowEpochSeconds) < 0;
        }
        if (tmp) {
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator = this.u68().j();
            while(tmp0_iterator.k()){
                var element = tmp0_iterator.l();
                // Inline function 'LocalStorageRequestJwtStore.cleanupIfAfterPeriod.<anonymous>' call
                var id = element.z9_1;
                var requestJwt = element.aa_1;
                if (requestJwt.l6i_1.j1(System_instance.u1l().f1m()) < 0) this.e73_1.q68(id);
            }
            saveIntoLocalStorage_1(this);
            localStorage.setItem("request-jwt-store-last-cleanup", nowEpochSeconds.toString());
        }
    };
    protoOf(LocalStorageRequestJwtStore).i6f = function(id, requestJwt) {
        this.e73_1.i6f(id, requestJwt);
        saveIntoLocalStorage_1(this);
    };
    protoOf(LocalStorageRequestJwtStore).q68 = function(id) {
        this.e73_1.q68(id);
        saveIntoLocalStorage_1(this);
    };
    function JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this$0, $presentationDefinition, resultContinuation) {
        this.q74_1 = this$0;
        this.r74_1 = $presentationDefinition;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).s74 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).o6r = function($completion) {
        return this.s74($completion);
    };
    protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.q74_1.t74_1.s6f(this.r74_1.inner, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var credentialFinderResult = suspendResult;
                    return new JsCredentialFinderResult(credentialFinderResult);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).n6r = function(completion) {
        return new JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this.q74_1, this.r74_1, completion);
    };
    function JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda_0(this$0, $presentationDefinition, resultContinuation) {
        var i = new JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this$0, $presentationDefinition, resultContinuation);
        var l = function($completion) {
            return i.s74($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsOpenIdWalletAuthenticatorCredentialFinder(verifiableCredentialStore) {
        this.t74_1 = new OpenIdWalletAuthenticatorCredentialFinder(verifiableCredentialStore.inner);
    }
    protoOf(JsOpenIdWalletAuthenticatorCredentialFinder).find = function(presentationDefinition) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda_0(this, presentationDefinition, null));
    };
    function JsCredentialFinderResult$data$delegate$lambda($inner) {
        return function() {
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'kotlin.collections.map' call
            var this_0 = $inner.v6e_1;
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while(tmp0_iterator.k()){
                var item = tmp0_iterator.l();
                // Inline function 'JsCredentialFinderResult.data$delegate.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.toTypedArray' call
                // Inline function 'kotlin.collections.map' call
                var this_1 = item.aa_1;
                // Inline function 'kotlin.collections.mapTo' call
                var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
                var tmp0_iterator_0 = this_1.j();
                while(tmp0_iterator_0.k()){
                    var item_0 = tmp0_iterator_0.l();
                    // Inline function 'JsCredentialFinderResult.data$delegate.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$0 = createJsUserVerifiableCredential(item_0);
                    destination_0.e(tmp$ret$0);
                }
                var credentials = copyToArray(destination_0);
                var tmp$ret$4 = new JsPair(new JsInputDescriptor(item.z9_1), credentials);
                destination.e(tmp$ret$4);
            }
            return copyToArray(destination);
        };
    }
    function JsCredentialFinderResult(inner) {
        var tmp = this;
        tmp.u74_1 = lazy(JsCredentialFinderResult$data$delegate$lambda(inner));
    }
    protoOf(JsCredentialFinderResult).p72 = function() {
        // Inline function 'kotlin.getValue' call
        var this_0 = this.u74_1;
        data$factory();
        return this_0.b1();
    };
    function data$factory() {
        return getPropertyCallableRef("data", 1, KProperty1, function(receiver) {
            return receiver.data;
        }, null);
    }
    function JsPreRegisteredClientStore$getByClientId$slambda(this$0, $clientId, resultContinuation) {
        this.d75_1 = this$0;
        this.e75_1 = $clientId;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsPreRegisteredClientStore$getByClientId$slambda).f75 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsPreRegisteredClientStore$getByClientId$slambda).o6r = function($completion) {
        return this.f75($completion);
    };
    protoOf(JsPreRegisteredClientStore$getByClientId$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.d75_1.inner.x6e(this.e75_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var tmp16_safe_receiver = suspendResult;
                    var tmp_0;
                    if (tmp16_safe_receiver == null) tmp_0 = null;
                    else {
                        var this_0 = tmp16_safe_receiver.c6f_1;
                        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
                        var tmp0_iterator = this_0.j();
                        while(tmp0_iterator.k()){
                            var item = tmp0_iterator.l();
                            var this_1 = item.k6m_1;
                            destination.e(new JsVpFormat(item.j6m_1, copyToArray(this_1)));
                        }
                        tmp_0 = new JsPreRegisteredClient(tmp16_safe_receiver.z6e_1, tmp16_safe_receiver.a6f_1, tmp16_safe_receiver.b6f_1, copyToArray(destination));
                    }
                    return tmp_0;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsPreRegisteredClientStore$getByClientId$slambda).n6r = function(completion) {
        return new JsPreRegisteredClientStore$getByClientId$slambda(this.d75_1, this.e75_1, completion);
    };
    function JsPreRegisteredClientStore$getByClientId$slambda_0(this$0, $clientId, resultContinuation) {
        var i = new JsPreRegisteredClientStore$getByClientId$slambda(this$0, $clientId, resultContinuation);
        var l = function($completion) {
            return i.f75($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsPreRegisteredClientStore$upsert$slambda(this$0, $preRegistredClient, resultContinuation) {
        this.o75_1 = this$0;
        this.p75_1 = $preRegistredClient;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsPreRegisteredClientStore$upsert$slambda).q75 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsPreRegisteredClientStore$upsert$slambda).o6r = function($completion) {
        return this.q75($completion);
    };
    protoOf(JsPreRegisteredClientStore$upsert$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    var this_0 = this.p75_1.vpFormatsSupported;
                    var destination = ArrayList_init_$Create$(this_0.length);
                    var inductionVariable = 0;
                    var last = this_0.length;
                    while(inductionVariable < last){
                        var item = this_0[inductionVariable];
                        inductionVariable = inductionVariable + 1 | 0;
                        destination.e(new VpFormat(item.format, toSet_0(item.algs)));
                    }
                    suspendResult = this.o75_1.inner.y6e(new PreRegisteredClient(this.p75_1.clientId, this.p75_1.jwksUri, this.p75_1.redirectUri, destination), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    return Unit_instance;
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsPreRegisteredClientStore$upsert$slambda).n6r = function(completion) {
        return new JsPreRegisteredClientStore$upsert$slambda(this.o75_1, this.p75_1, completion);
    };
    function JsPreRegisteredClientStore$upsert$slambda_0(this$0, $preRegistredClient, resultContinuation) {
        var i = new JsPreRegisteredClientStore$upsert$slambda(this$0, $preRegistredClient, resultContinuation);
        var l = function($completion) {
            return i.q75($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsPreRegisteredClientStore$getAll$slambda(this$0, resultContinuation) {
        this.z75_1 = this$0;
        CoroutineImpl.call(this, resultContinuation);
    }
    protoOf(JsPreRegisteredClientStore$getAll$slambda).a76 = function($completion) {
        var tmp = this.n6r($completion);
        tmp.x8_1 = Unit_instance;
        tmp.y8_1 = null;
        return tmp.d9();
    };
    protoOf(JsPreRegisteredClientStore$getAll$slambda).o6r = function($completion) {
        return this.a76($completion);
    };
    protoOf(JsPreRegisteredClientStore$getAll$slambda).d9 = function() {
        var suspendResult = this.x8_1;
        $sm: do try {
            var tmp = this.v8_1;
            switch(tmp){
                case 0:
                    this.w8_1 = 2;
                    this.v8_1 = 1;
                    suspendResult = this.z75_1.inner.d6f(this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) return suspendResult;
                    continue $sm;
                case 1:
                    var this_0 = suspendResult;
                    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
                    var tmp0_iterator = this_0.j();
                    while(tmp0_iterator.k()){
                        var item = tmp0_iterator.l();
                        var this_1 = item.c6f_1;
                        var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
                        var tmp0_iterator_0 = this_1.j();
                        while(tmp0_iterator_0.k()){
                            var item_0 = tmp0_iterator_0.l();
                            var this_2 = item_0.k6m_1;
                            destination_0.e(new JsVpFormat(item_0.j6m_1, copyToArray(this_2)));
                        }
                        destination.e(new JsPreRegisteredClient(item.z6e_1, item.a6f_1, item.b6f_1, copyToArray(destination_0)));
                    }
                    return copyToArray(destination);
                case 2:
                    throw this.y8_1;
            }
        } catch ($p) {
            var e = $p;
            if (this.w8_1 === 2) throw e;
            else {
                this.v8_1 = this.w8_1;
                this.y8_1 = e;
            }
        }
        while (true);
    };
    protoOf(JsPreRegisteredClientStore$getAll$slambda).n6r = function(completion) {
        return new JsPreRegisteredClientStore$getAll$slambda(this.z75_1, completion);
    };
    function JsPreRegisteredClientStore$getAll$slambda_0(this$0, resultContinuation) {
        var i = new JsPreRegisteredClientStore$getAll$slambda(this$0, resultContinuation);
        var l = function($completion) {
            return i.a76($completion);
        };
        l.$arity = 0;
        return l;
    }
    function JsPreRegisteredClientStore(inner) {
        this.inner = inner;
    }
    protoOf(JsPreRegisteredClientStore).o3h = function() {
        return this.inner;
    };
    protoOf(JsPreRegisteredClientStore).getByClientId = function(clientId) {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsPreRegisteredClientStore$getByClientId$slambda_0(this, clientId, null));
    };
    protoOf(JsPreRegisteredClientStore).upsert = function(preRegistredClient) {
        var tmp = GlobalScope_instance;
        safePromise(tmp, VOID, JsPreRegisteredClientStore$upsert$slambda_0(this, preRegistredClient, null));
    };
    protoOf(JsPreRegisteredClientStore).getAll = function() {
        var tmp = GlobalScope_instance;
        return safePromise(tmp, VOID, JsPreRegisteredClientStore$getAll$slambda_0(this, null));
    };
    function JsPreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported) {
        this.clientId = clientId;
        this.jwksUri = jwksUri;
        this.redirectUri = redirectUri;
        this.vpFormatsSupported = vpFormatsSupported;
    }
    protoOf(JsPreRegisteredClient).b76 = function() {
        return this.clientId;
    };
    protoOf(JsPreRegisteredClient).c76 = function() {
        return this.jwksUri;
    };
    protoOf(JsPreRegisteredClient).u3f = function() {
        return this.redirectUri;
    };
    protoOf(JsPreRegisteredClient).d76 = function() {
        return this.vpFormatsSupported;
    };
    protoOf(JsPreRegisteredClient).ba = function() {
        return this.clientId;
    };
    protoOf(JsPreRegisteredClient).ca = function() {
        return this.jwksUri;
    };
    protoOf(JsPreRegisteredClient).qj = function() {
        return this.redirectUri;
    };
    protoOf(JsPreRegisteredClient).q5v = function() {
        return this.vpFormatsSupported;
    };
    protoOf(JsPreRegisteredClient).e76 = function(clientId, jwksUri, redirectUri, vpFormatsSupported) {
        return new JsPreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported);
    };
    protoOf(JsPreRegisteredClient).copy = function(clientId, jwksUri, redirectUri, vpFormatsSupported, $super) {
        clientId = clientId === VOID ? this.clientId : clientId;
        jwksUri = jwksUri === VOID ? this.jwksUri : jwksUri;
        redirectUri = redirectUri === VOID ? this.redirectUri : redirectUri;
        vpFormatsSupported = vpFormatsSupported === VOID ? this.vpFormatsSupported : vpFormatsSupported;
        return this.e76(clientId, jwksUri, redirectUri, vpFormatsSupported);
    };
    protoOf(JsPreRegisteredClient).toString = function() {
        return "JsPreRegisteredClient(clientId=" + this.clientId + ", jwksUri=" + this.jwksUri + ", redirectUri=" + this.redirectUri + ", vpFormatsSupported=" + toString(this.vpFormatsSupported) + ")";
    };
    protoOf(JsPreRegisteredClient).hashCode = function() {
        var result = getStringHashCode(this.clientId);
        result = imul(result, 31) + getStringHashCode(this.jwksUri) | 0;
        result = imul(result, 31) + getStringHashCode(this.redirectUri) | 0;
        result = imul(result, 31) + hashCode(this.vpFormatsSupported) | 0;
        return result;
    };
    protoOf(JsPreRegisteredClient).equals = function(other) {
        if (this === other) return true;
        if (!(other instanceof JsPreRegisteredClient)) return false;
        var tmp0_other_with_cast = other instanceof JsPreRegisteredClient ? other : THROW_CCE();
        if (!(this.clientId === tmp0_other_with_cast.clientId)) return false;
        if (!(this.jwksUri === tmp0_other_with_cast.jwksUri)) return false;
        if (!(this.redirectUri === tmp0_other_with_cast.redirectUri)) return false;
        if (!equals(this.vpFormatsSupported, tmp0_other_with_cast.vpFormatsSupported)) return false;
        return true;
    };
    function JsVpFormat(format, algs) {
        this.format = format;
        this.algs = algs;
    }
    protoOf(JsVpFormat).z33 = function() {
        return this.format;
    };
    protoOf(JsVpFormat).f76 = function() {
        return this.algs;
    };
    //region block: post-declaration
    protoOf($serializer).mz = typeParametersSerializers;
    protoOf($serializer_0).mz = typeParametersSerializers;
    protoOf($serializer_1).mz = typeParametersSerializers;
    protoOf($serializer_2).mz = typeParametersSerializers;
    protoOf($serializer_3).mz = typeParametersSerializers;
    protoOf($serializer_4).mz = typeParametersSerializers;
    protoOf(ProxyEngine).r4y = get_supportedCapabilities;
    protoOf(ProxyEngine).b4u = install;
    defineProp(protoOf(JsResolvedOffer), "issuer", protoOf(JsResolvedOffer).e3c);
    defineProp(protoOf(JsResolvedOffer), "credentialsSupported", protoOf(JsResolvedOffer).i3h);
    defineProp(protoOf(JsResolvedOffer), "txCode", protoOf(JsResolvedOffer).k6x);
    defineProp(protoOf(JsOfferResult), "issuedCredentials", protoOf(JsOfferResult).o6x);
    defineProp(protoOf(JsPresentationDefinition), "format", protoOf(JsPresentationDefinition).z33);
    defineProp(protoOf(JsPresentationDefinition), "inputDescriptors", protoOf(JsPresentationDefinition).l71);
    defineProp(protoOf(JsFormat), "jwtVcJson", protoOf(JsFormat).a3j);
    defineProp(protoOf(JsFormat), "jwtVpJson", protoOf(JsFormat).r71);
    defineProp(protoOf(JsFormat), "ldpVc", protoOf(JsFormat).s71);
    defineProp(protoOf(JsFormat), "ldpVp", protoOf(JsFormat).t71);
    defineProp(protoOf(JsFormat), "customFormats", protoOf(JsFormat).u71);
    defineProp(protoOf(JsInputDescriptor), "format", protoOf(JsInputDescriptor).z33);
    defineProp(protoOf(JsConstraint), "fields", protoOf(JsConstraint).a72);
    defineProp(protoOf(JsField), "filter", protoOf(JsField).f72);
    defineProp(protoOf(AbstractJsfilter), "type", function() {
        return this.g36();
    });
    defineProp(protoOf(JsPresentationSubmission), "descriptorMap", protoOf(JsPresentationSubmission).n72);
    defineProp(protoOf(JsCredentialFinderResult), "data", protoOf(JsCredentialFinderResult).p72);
    //endregion
    //region block: init
    ProofOfPossessionBuilder_instance = new ProofOfPossessionBuilder();
    Companion_instance_10 = new Companion_1();
    Companion_instance_11 = new Companion_2();
    JwtCredentialValidationHelper_instance = new JwtCredentialValidationHelper();
    Companion_instance_14 = new Companion_5();
    Companion_instance_18 = new Companion_9();
    Companion_instance_19 = new Companion_10();
    Companion_instance_21 = new Companion_12();
    Companion_instance_22 = new Companion_13();
    Companion_instance_23 = new Companion_14();
    Companion_instance_24 = new Companion_15();
    //endregion
    //region block: exports
    function $jsExportAll$(_) {
        _.JsHttpProxy = JsHttpProxy;
        _.createCredentialIssuerLoader = createCredentialIssuerLoader;
        _.createCredentialIssuerStore = createCredentialIssuerStore;
        _.createVerifiableCredentialStore = createVerifiableCredentialStore;
        _.createOAuthClient = createOAuthClient;
        _.createCredentialIssuanceCoordinator = createCredentialIssuanceCoordinator;
        _.createPreRegisteredClientStore = createPreRegisteredClientStore;
        _.createVerifierClient = createVerifierClient;
        _.createCredentialFinder = createCredentialFinder;
        _.createPresentationResponseCreator = createPresentationResponseCreator;
        _.newUserCancellationException = newUserCancellationException;
        _.createRequestJwtStore = createRequestJwtStore;
        _.createKeyStore = createKeyStore;
        _.createInMemoryKeyAliasStore = createInMemoryKeyAliasStore;
        _.JsVcClient = JsVcClient;
        _.UserCancellationException = UserCancellationException;
        _.JsProxy = JsProxy;
        var $vc_js = _.vc_js || (_.vc_js = {});
        var $vc_js$services = $vc_js.services || ($vc_js.services = {});
        $vc_js$services.createBrowserWindowOAuthSupport = createBrowserWindowOAuthSupport;
        $vc_js$services.JsOAuthSupport = JsOAuthSupport;
        var $vc_js = _.vc_js || (_.vc_js = {});
        var $vc_js$services = $vc_js.services || ($vc_js.services = {});
        $vc_js$services.JsKeyAliasStore = JsKeyAliasStore;
        _.JsCredentialIssuerLoader = JsCredentialIssuerLoader;
        _.JsCredentialIssuerStore = JsCredentialIssuerStore;
        _.JsVerifiableCredentialStore = JsVerifiableCredentialStore;
        _.JsResolvedOffer = JsResolvedOffer;
        _.JsTxCode = JsTxCode;
        _.JsOfferResult = JsOfferResult;
        _.JsCredentialIssuanceCoordinator = JsCredentialIssuanceCoordinator;
        _.JsValidatedRequestJwt = JsValidatedRequestJwt;
        _.JsPresentationDefinition = JsPresentationDefinition;
        _.JsFormat = JsFormat;
        _.JsAlgFormat = JsAlgFormat;
        _.JsProofTypeFormat = JsProofTypeFormat;
        _.JsInputDescriptor = JsInputDescriptor;
        _.JsConstraint = JsConstraint;
        _.JsField = JsField;
        _.AbstractJsfilter = AbstractJsfilter;
        defineProp(_.AbstractJsfilter, "Companion", Companion_getInstance_20);
        _.JsStringFilter = JsStringFilter;
        _.JsArrayContainsFilter = JsArrayContainsFilter;
        _.JsContains = JsContains;
        _.JsVerifiablePresentationResponseParameters = JsVerifiablePresentationResponseParameters;
        _.JsPresentationSubmission = JsPresentationSubmission;
        _.JsDescriptorMapObject = JsDescriptorMapObject;
        _.JsPathNested = JsPathNested;
        _.JsVerifierDirectPostAuthorizationResponse = JsVerifierDirectPostAuthorizationResponse;
        _.JsUserSelectedCredentials = JsUserSelectedCredentials;
        _.JsUserSelectedCredential = JsUserSelectedCredential;
        _.JsPresentationDisclosure = JsPresentationDisclosure;
        _.JsPresentationResponseCreator = JsPresentationResponseCreator;
        defineProp(_.JsPresentationResponseCreator, "Companion", Companion_getInstance_21);
        _.JsRequestJwtStore = JsRequestJwtStore;
        _.JsVerifierClient = JsVerifierClient;
        _.JsOpenIdWalletAuthenticatorCredentialFinder = JsOpenIdWalletAuthenticatorCredentialFinder;
        _.JsCredentialFinderResult = JsCredentialFinderResult;
        _.JsPreRegisteredClientStore = JsPreRegisteredClientStore;
        _.JsPreRegisteredClient = JsPreRegisteredClient;
        _.JsVpFormat = JsVpFormat;
    }
    $jsExportAll$(_);
    kotlin_io_curity_ssi_jose.$jsExportAll$(_);
    kotlin_io_curity_ssi_sd_jwt.$jsExportAll$(_);
    kotlin_io_curity_ssi_vc_ks_data.$jsExportAll$(_);
    kotlin_io_curity_ssi_oauth.$jsExportAll$(_);
    //endregion
    return _;
});


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ /*
 * Functions and types related to wallet initialization, i.e., actions that should be done
 * on the wallet side only once.
 */ const $5bb70efb130a275d$var$KEY_LOCAL_STORAGE = "init-state";
const $5bb70efb130a275d$var$MAX_AGE = 604800000;
const $5bb70efb130a275d$var$VERSION = "2";
function $5bb70efb130a275d$var$checkSchema(initState) {
    // TODO check schema
    return typeof initState["version"] == "string" && typeof initState["changedAt"] == "number" && Array.isArray(initState["loadedIssuers"]);
}
function $5bb70efb130a275d$export$380a4b810b856cab() {
    const initDataString = localStorage.getItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
    if (!initDataString) return;
    let initData;
    try {
        initData = JSON.parse(initDataString);
    } catch (e) {
        localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
        return;
    }
    if (!(typeof initData == "object")) {
        localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
        return;
    }
    if (!$5bb70efb130a275d$var$checkSchema(initData)) {
        localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
        return;
    }
    if ($5bb70efb130a275d$var$VERSION != initData.version) {
        localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
        return;
    }
    const now = Date.now();
    if (now > initData.changedAt + $5bb70efb130a275d$var$MAX_AGE) {
        localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
        return;
    }
    return initData;
}
function $5bb70efb130a275d$export$de3df0e27584f7f7(issuerId) {
    const initState = $5bb70efb130a275d$export$380a4b810b856cab() || {
        changedAt: Date.now(),
        version: $5bb70efb130a275d$var$VERSION,
        loadedIssuers: []
    };
    initState.changedAt = Date.now();
    initState.loadedIssuers.push(issuerId);
    localStorage.setItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE, JSON.stringify(initState));
}
function $5bb70efb130a275d$export$aad8462122ac592b() {
    localStorage.removeItem($5bb70efb130a275d$var$KEY_LOCAL_STORAGE);
}


class $8877b1f4697d14b0$export$2350abf13b9c6e7d {
    constructor(delegate, loader, issuersToPreLoad){
        this.delegate = delegate;
        this.loader = loader;
        this.issuersToPreLoad = issuersToPreLoad;
    }
    async upsert(credentialIssuer) {
        await this.ensureInit();
        return this.delegate.upsert(credentialIssuer);
    }
    async getAll() {
        await this.ensureInit();
        return this.delegate.getAll();
    }
    async getById(id) {
        await this.ensureInit();
        return this.delegate.getById(id);
    }
    async removeById(id) {
        await this.ensureInit();
        return this.delegate.removeById(id);
    }
    async init() {
        // gets the initialization state of the wallet and for each issuer to pre-load
        const initState = (0, $5bb70efb130a275d$export$380a4b810b856cab)();
        for (const issuerId of this.issuersToPreLoad)try {
            // checks if the issuer was already loaded in the past
            if (initState && initState.loadedIssuers.includes(issuerId)) continue;
            // checks if the issuer is stored
            if (await this.delegate.getById(issuerId)) continue;
            // try to load the issuer
            const issuer = await this.loader.load(issuerId);
            await this.delegate.upsert(issuer);
            (0, $5bb70efb130a275d$export$de3df0e27584f7f7)(issuerId);
            console.log(`Pre-loaded issuer '${issuerId}'`);
        } catch (ex) {
            // unable to load or store an issuer, logging and moving to next
            console.log(`Unable to pre-load issuer '${issuerId}'`);
        }
    }
    async ensureInit() {
        if (!this.initPromise) // the first one to arrive starts the initialization process
        this.initPromise = this.init();
        // all the calls wait for the initialization process to complete
        await this.initPromise;
    }
}


const $c02206712fb92858$var$isElectron = window.location.protocol !== "http:" && window.location.protocol !== "https:";
const $c02206712fb92858$var$isBrowser = !$c02206712fb92858$var$isElectron;
// The HTTP proxy to use
const $c02206712fb92858$var$proxy = $c02206712fb92858$var$isBrowser ? new (0, $8b4eb369eb8605c9$exports.JsProxy)(window.location.protocol.substring(0, window.location.protocol.length - 1), window.location.hostname, Number(window.location.port)) : new (0, $8b4eb369eb8605c9$exports.JsProxy)("http", "localhost", 1234);
// Key store
const $c02206712fb92858$var$JWK_P256 = `
{
  "kty": "EC",
  "d": "d_PpSCGQWWgUc1t4iLLH8bKYlYfc9Zy_M7TsfOAcbg8",
  "use": "sig",
  "crv": "P-256",
  "x": "ngy44T1vxAT6Di4nr-UaM9K3Tlnz9pkoksDokKFkmNc",
  "y": "QCRfOKlSM31GTkb4JHx3nXB4G_jSPMsbdjzlkT_UpPc",
  "alg": "ES256"
}`;
const $c02206712fb92858$var$DID_URL = "did:jwk:eyJrdHkiOiJFQyIsInVzZSI6InNpZyIsImFsZyI6IkVTMjU2IiwiY3J2IjoiUC0yNTYiLCJ4Ijoibmd5NDRUMXZ4QVQ2RGk0bnItVWFNOUszVGxuejlwa29rc0Rva0tGa21OYyIsInkiOiJRQ1JmT0tsU00zMUdUa2I0Skh4M25YQjRHX2pTUE1zYmRqemxrVF9VcFBjIiwia2lkIjoic2lnbmluZ0tleVBhaXJJZCJ9#0";
const $c02206712fb92858$var$keyStore = (0, $8b4eb369eb8605c9$exports.createKeyStore)();
const $c02206712fb92858$var$signingKeyPairId = "signingKeyPairId";
const $c02206712fb92858$export$48ab3e8a44de5f81 = $c02206712fb92858$var$keyStore.importSigningKeySpec($c02206712fb92858$var$signingKeyPairId, $c02206712fb92858$var$JWK_P256);
const $c02206712fb92858$var$keyAliasStore = (0, $8b4eb369eb8605c9$exports.createInMemoryKeyAliasStore)();
$c02206712fb92858$var$keyAliasStore.add($c02206712fb92858$var$DID_URL, $c02206712fb92858$var$signingKeyPairId).catch((err)=>console.log(err));
const $c02206712fb92858$export$238c44a402494d7b = (0, $8b4eb369eb8605c9$exports.createCredentialIssuerLoader)();
const $c02206712fb92858$export$7311d7bc08dcdc86 = new (0, $8877b1f4697d14b0$export$2350abf13b9c6e7d)((0, $8b4eb369eb8605c9$exports.createCredentialIssuerStore)(), $c02206712fb92858$export$238c44a402494d7b, // EDIT with the issuers to preload
[
    "https://login-demo.curity.io/oauth/v2/oauth-anonymous"
]);
const $c02206712fb92858$export$ba679c5cdb4741c4 = (0, $8b4eb369eb8605c9$exports.createVerifiableCredentialStore)();
const $c02206712fb92858$export$a3f6b50fc634f9ec = (0, $8b4eb369eb8605c9$exports.createPresentationResponseCreator)($c02206712fb92858$var$keyAliasStore, $c02206712fb92858$var$keyStore);
// Wallet configuration dependent services
const $c02206712fb92858$var$localStorageConfigKey = "wallet-config";
function $c02206712fb92858$var$computeRedirectUriFromLocation() {
    const redirectUri = new URL(window.location.toString());
    redirectUri.pathname = "/oauth/callback";
    redirectUri.hash = "";
    redirectUri.search = "";
    return redirectUri.toString();
}
const $c02206712fb92858$export$472007267a19777f = $c02206712fb92858$var$isBrowser ? $c02206712fb92858$var$computeRedirectUriFromLocation() : "dev-wallet://app/oauth/callback";
function $c02206712fb92858$var$createCredentialIssuanceCoordinatorFromWalletConfig(walletConfig) {
    return (0, $8b4eb369eb8605c9$exports.createCredentialIssuanceCoordinator)((0, $8b4eb369eb8605c9$exports.createOAuthClient)(walletConfig.oauthClient.id, $c02206712fb92858$export$472007267a19777f, walletConfig.oauthClient.secret), $c02206712fb92858$var$proxy, $c02206712fb92858$export$238c44a402494d7b);
}
const $c02206712fb92858$export$1bfb5d7f4794f009 = (0, $8b4eb369eb8605c9$exports.createPreRegisteredClientStore)();
const $c02206712fb92858$var$SUPPORTED_ALGS = [
    "EdDSA",
    "ES256",
    "ES384",
    "ES512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512"
];
const $c02206712fb92858$var$SUPPORTED_VP_FORMATS = [
    new (0, $8b4eb369eb8605c9$exports.JsVpFormat)("jwt_vp_json", $c02206712fb92858$var$SUPPORTED_ALGS)
];
$c02206712fb92858$var$updatePreRegisteredClientStore($c02206712fb92858$export$dd5bc6957e8aa49a());
const $c02206712fb92858$export$43f9926bdf4a1bde = (0, $8b4eb369eb8605c9$exports.createVerifierClient)($c02206712fb92858$var$proxy, $c02206712fb92858$export$1bfb5d7f4794f009);
const $c02206712fb92858$export$791f310f53465dc = (0, $8b4eb369eb8605c9$exports.createCredentialFinder)($c02206712fb92858$export$ba679c5cdb4741c4);
const $c02206712fb92858$var$requestJwtStoreCleanupPeriodInSeconds = 86400; // 1 day
const $c02206712fb92858$export$a5f7d70093347642 = (0, $8b4eb369eb8605c9$exports.createRequestJwtStore)($c02206712fb92858$var$requestJwtStoreCleanupPeriodInSeconds);
$c02206712fb92858$export$a5f7d70093347642.cleanupIfAfterPeriod();
function $c02206712fb92858$export$dd5bc6957e8aa49a() {
    const retrievedConfig = localStorage.getItem($c02206712fb92858$var$localStorageConfigKey);
    if (retrievedConfig) // TODO use a validation framework
    try {
        return JSON.parse(retrievedConfig);
    } catch (e) {
        console.log("Invalid wallet configuration, using a default one");
    }
    // No available config, use default one...
    const defaultConfig = $c02206712fb92858$var$isBrowser ? {
        oauthClient: {
            id: "client-one",
            // TODO REMOVE REMOVE REMOVE
            secret: "0ne!Secret"
        },
        preRegisteredClient: {
            id: "openid-wallet-authenticator-client",
            jwksUri: "https://login-demo.curity.io/authn/anonymous/wallet/jwks"
        }
    } : {
        oauthClient: {
            id: "client-one",
            // TODO REMOVE REMOVE REMOVE
            secret: "0ne!Secret"
        },
        preRegisteredClient: {
            id: "openid-wallet-authenticator-client",
            jwksUri: "https://login-demo.curity.io/authn/anonymous/wallet/jwks"
        }
    };
    // ... and save it
    localStorage.setItem($c02206712fb92858$var$localStorageConfigKey, JSON.stringify(defaultConfig));
    return defaultConfig;
}
let $c02206712fb92858$export$61c3b26555c145ea = $c02206712fb92858$var$createCredentialIssuanceCoordinatorFromWalletConfig($c02206712fb92858$export$dd5bc6957e8aa49a());
function $c02206712fb92858$export$9628a8ca36420503(config) {
    localStorage.setItem($c02206712fb92858$var$localStorageConfigKey, JSON.stringify(config));
    // Side effect: update the mutable `credentialIssuanceClient` to reflect the new config
    const walletConf = $c02206712fb92858$export$dd5bc6957e8aa49a();
    $c02206712fb92858$export$61c3b26555c145ea = $c02206712fb92858$var$createCredentialIssuanceCoordinatorFromWalletConfig(walletConf);
    $c02206712fb92858$var$updatePreRegisteredClientStore(walletConf);
}
function $c02206712fb92858$var$updatePreRegisteredClientStore(walletConf) {
    $c02206712fb92858$export$1bfb5d7f4794f009.upsert(new (0, $8b4eb369eb8605c9$exports.JsPreRegisteredClient)(walletConf.preRegisteredClient.id, walletConf.preRegisteredClient.jwksUri, "", $c02206712fb92858$var$SUPPORTED_VP_FORMATS));
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 


var $acw62 = parcelRequire("acw62");
const $a51ba634029c0920$export$305f76953b1aadeb = /*#__PURE__*/ (0, $acw62.createContext)({
    languages: [
        ...navigator.languages
    ]
});
function $a51ba634029c0920$export$38be4353f99148d() {
    return (0, $acw62.useContext)($a51ba634029c0920$export$305f76953b1aadeb).languages;
}
function $a51ba634029c0920$export$7b481c2df9e2f440({ children: children }) {
    const [languages, setLanguages] = (0, $acw62.useState)([
        ...navigator.languages
    ]);
    (0, $acw62.useEffect)(()=>{
        const abortController = new AbortController();
        window.addEventListener("languagechange", ()=>setLanguages([
                ...navigator.languages
            ]), {
            signal: abortController.signal
        });
        return ()=>{
            abortController.abort();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a51ba634029c0920$export$305f76953b1aadeb.Provider, {
        value: {
            languages: languages
        },
        children: children
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ /*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $f1fd6b08239b2839$export$bcca3ea514774656 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        className: "lucide lucide-wallet",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 12V7H5a2 2 0 010-4h14v4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3 5v14a2 2 0 002 2h16v-5"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 12a2 2 0 000 4h4v-4z"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $47807695c0c70127$export$c4868e4a24d48fad = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        className: "lucide lucide-info",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 16v-4M12 8h.01"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $fc564cfa6ab5c665$export$1095c93890fce526 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $81835d564a2f474a$export$5631afde407885cb = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        className: "lucide lucide-qr-code",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "5",
                height: "5",
                x: "3",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "5",
                height: "5",
                x: "16",
                y: "3",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "5",
                height: "5",
                x: "3",
                y: "16",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M21 16h-3a2 2 0 00-2 2v3M21 21v.01M12 7v3a2 2 0 01-2 2H7M3 12h.01M12 3h.01M12 16v.01M16 12h1M21 12v.01M12 21v-1"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $572f845dd9b8a749$export$ed059cf85de854b3 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-scan",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 7V5a2 2 0 0 1 2-2h2M17 3h2a2 2 0 0 1 2 2v2M21 17v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2"
        })
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $45830f57d8e8c2ef$export$f39c2d165cd861fe = ({ width: width = "24px", height: height = "24px", color: color = "currentColor" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        className: "lucide lucide-x-circle",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 9l-6 6M9 9l6 6"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $b5d1ede17663f7d4$export$24493ea34167a6d8 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 165.17 107.96",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#626c87",
                d: "M148.27 68.46l-1.67 1.67c-9.41 9.41-21.25 14.82-32.48 14.82-17.81 0-30.74-13-30.74-30.91s12.61-30.89 29.99-30.89c10.07 0 21.99 4.69 30.36 11.94l1.68 1.46 16.66-17.41-1.88-1.6C147.42 6.57 129.24 0 111.6 0 92.16 0 75.7 8.84 65.92 22.82H35.21l-1.8 15.12h25.22c-.81 2.73-1.37 5.57-1.75 8.49H19.16l-1.8 15.11h39.53c.37 2.92.93 5.77 1.72 8.48H1.8L0 85.14h65.79c9.79 14.09 26.46 22.82 46.56 22.82 25.24 0 42.83-12.91 51.07-20.6l1.75-1.64-16.9-17.26z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#626c87",
                d: "M14.88 46.43L3.76 46.43 1.96 61.54 13.09 61.54 14.88 46.43z"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $226727377a2f3309$export$6ed0965c9443aaa6 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-pencil",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5ZM15 5l4 4"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $2c5f9b7cc968e411$export$99442c433de1441d = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2M10 11v6M14 11v6"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $855d32422e9b26c5$export$25e48ac541203d4a = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-arrow-left",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "m12 19-7-7 7-7M19 12H5"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $0364876b260e5843$export$d9b273488cd8ce6f = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-more-vertical",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 5,
                r: 1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 19,
                r: 1
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $911efbd418e06a2a$export$a472f9f6fa55fec4 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        className: "lucide lucide-school",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m4 6 8-4 8 4M18 10l4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4M18 5v17M6 5v17"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 12,
                cy: 9,
                r: 2
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $2538f26e6fc984c0$export$ec91da630f36d5ea = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $2b6bd709a2dba9be$export$d0265b2c425512d6 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 12h14M12 5v14"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $e32da6f3553b8846$export$fd56217de116e11b = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 231.32 219.38",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#99a2b5",
                d: "M229.52 145.97h-64.05c-10.58 0-19.15-8.57-19.15-19.15v-.39c0-10.58 8.57-19.15 19.15-19.15h64.05v38.68Z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 165.51,
                cy: 126.63,
                r: 7.8,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                fill: "none",
                stroke: "#626c87",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        strokeWidth: 11.38,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M65.77 139.04c-18.61 0-33.7-15.09-33.7-33.7 0-18.61 15.09-33.7 33.7-33.7 18.61 0 33.7 15.09 33.7 33.7 0 18.61-15.09 33.7-33.7 33.7M5.69 213.69c0-29.88 26.9-54.11 60.08-54.11s60.08 24.23 60.08 54.11"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        strokeWidth: 11.38,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M37.09 35.9V15.12c0-5.21 4.22-9.43 9.43-9.43h141.4V43.4h28.28c5.21 0 9.43 4.22 9.43 9.43v113.13c0 5.21-4.22 9.43-9.43 9.43h-66.33M187.92 43.4H83.59"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        strokeWidth: 12.83,
                        d: "M188.48 81.59h-67.01"
                    })
                ]
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $bcd643c7c0dee46c$export$1f74963c34e8bfec = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#ebebeb",
        "data-name": "Empty",
        viewBox: "0 0 473.28 256",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 72.92,
                cy: 59.42,
                r: 24.76,
                className: "cls-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 323.32,
                height: 44,
                x: 121.07,
                y: 37.42,
                className: "cls-1",
                rx: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 72.92,
                cy: 131.18,
                r: 24.76,
                className: "cls-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 280.67,
                height: 44,
                x: 121.07,
                y: 109.18,
                className: "cls-1",
                rx: 22
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 72.92,
                cy: 202.94,
                r: 24.76,
                className: "cls-1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 247.65,
                height: 44,
                x: 121.07,
                y: 180.94,
                className: "cls-1",
                rx: 22
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $7d79279f7e8a50e4$export$92ce62e1201c4fc0 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-copy",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: 14,
                height: 14,
                x: 8,
                y: 8,
                rx: 2,
                ry: 2
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $8506d362ee659335$export$60bffc6e2a50e7f9 = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6 9 17l-5-5"
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $ee1790168eebbcf3$export$65be7b63f510f362 = ({ width: width = "24px", height: height = "24px" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 9l6 6 6-6"
        })
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $6f9134ed37f21b5c$export$2631022cf909144e = ({ width: width = "100%", height: height = "100%" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 67.44 97.99",
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#fff",
                d: "M35.97 24.77h-4.51c-2.74 0-4.96-2.23-4.96-4.96V4.96C26.5 2.22 28.73 0 31.46 0h4.51c2.74 0 4.96 2.23 4.96 4.96V19.8c0 2.74-2.23 4.96-4.96 4.96zm-.04-19.8l-4.47.04.04 14.8 4.43-.04V4.96zm.04 14.8z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fill: "#fff",
                d: "M62.24 97.99H5.2c-2.87 0-5.2-2.33-5.2-5.2V12.84c0-2.87 2.33-5.2 5.2-5.2h13.26a2.5 2.5 0 010 5H5.2c-.11 0-.2.1-.2.2v79.95c0 .11.1.2.2.2h57.04c.11 0 .2-.1.2-.2V12.84c0-.11-.1-.2-.2-.2H49.96a2.5 2.5 0 010-5h12.28c2.87 0 5.2 2.33 5.2 5.2v79.95c0 2.87-2.33 5.2-5.2 5.2z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                fill: "#fff",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M49.96 50.31h-31.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h31.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM49.96 61.02h-31.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h31.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM32.15 71.73H18.46c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h13.69c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                })
            })
        ]
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $2e2fba9128c49e04$export$2d9ac7aa84f97a08 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 12h8M12 8v8"
            })
        ]
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $8ef4af422f0b4aa6$export$c9915453de10000b = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 6L12 2 8 6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2L12 15"
            })
        ]
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $9d67ff43850561b6$export$c5dda59a24f0b250 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "5",
                r: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "12",
                cy: "19",
                r: "1"
            })
        ]
    });


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $967880c1f22d9524$export$153e5dc2c098b35c = ({ width: width = "24px", height: height = "24px", color: color = "currentColor" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        className: "lucide lucide-bug",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "m8 2 1.88 1.88M14.12 3.88 16 2M9 7.13v-1a3.003 3.003 0 1 1 6 0v1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6M12 20v-9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.53 9C4.6 8.8 3 7.1 3 5M6 13H2M3 21c0-2.1 1.7-3.9 3.8-4M20.97 5c0 2.1-1.6 3.8-3.5 4M22 13h-4M17.2 17c2.1.1 3.8 1.9 3.8 4"
            })
        ]
    });





const $39c40562225f6f25$var$colorList = [
    {
        letter: "A",
        color: "#2e87ba"
    },
    {
        letter: "B",
        color: "#2e87ba"
    },
    {
        letter: "C",
        color: "#27b197"
    },
    {
        letter: "D",
        color: "#65a30d"
    },
    {
        letter: "E",
        color: "#26415a"
    },
    {
        letter: "F",
        color: "#4451a3"
    },
    {
        letter: "G",
        color: "#6778a5"
    },
    {
        letter: "H",
        color: "#7b181a"
    },
    {
        letter: "I",
        color: "#ba3a17"
    },
    {
        letter: "J",
        color: "#7a2c52"
    },
    {
        letter: "K",
        color: "#9333ea"
    },
    {
        letter: "L",
        color: "#b02929"
    },
    {
        letter: "M",
        color: "#10b981"
    },
    {
        letter: "N",
        color: "#6366f1"
    },
    {
        letter: "O",
        color: "#5799a8"
    },
    {
        letter: "P",
        color: "#8EB29A"
    },
    {
        letter: "Q",
        color: "#c00000"
    },
    {
        letter: "R",
        color: "#00549f"
    },
    {
        letter: "S",
        color: "#fdba31"
    },
    {
        letter: "T",
        color: "#fdba31"
    },
    {
        letter: "U",
        color: "#cf3da4"
    },
    {
        letter: "V",
        color: "#fb7185"
    },
    {
        letter: "W",
        color: "#dbc6ec"
    },
    {
        letter: "X",
        color: "#a351a9"
    },
    {
        letter: "Y",
        color: "#c6e2ff"
    },
    {
        letter: "Z",
        color: "#92a8d1"
    }
];
const $39c40562225f6f25$export$f1a9f8480ead6b1a = (letter)=>{
    const selectedColor = $39c40562225f6f25$var$colorList.find((color)=>color.letter === letter);
    const darkColor = "rgba(0,0,0,0.0725)";
    return `repeating-radial-gradient(circle at 0 0, transparent 0, ${darkColor} 10px), repeating-linear-gradient(${darkColor}, ${selectedColor.color})`;
};


var $ae98580914bba820$export$c95979b960f4acea;
var $ae98580914bba820$export$147cadf8450371c5;
var $ae98580914bba820$export$44507472b8c82c69;
var $ae98580914bba820$export$b3fd76504d11e6fb;
var $ae98580914bba820$export$c0efd8de904f9541;
var $ae98580914bba820$export$168c4cb1d6da36d2;
var $ae98580914bba820$export$8739e2fda76f188c;
$ae98580914bba820$export$c95979b960f4acea = `sefA7W_fade-in`;
$ae98580914bba820$export$147cadf8450371c5 = `sefA7W_fade-in-bounce`;
$ae98580914bba820$export$147cadf8450371c5;
$ae98580914bba820$export$44507472b8c82c69 = `sefA7W_grid-container`;
$ae98580914bba820$export$b3fd76504d11e6fb = `sefA7W_wallet-card`;
$ae98580914bba820$export$c0efd8de904f9541 = `sefA7W_wallet-card-detailed`;
$ae98580914bba820$export$168c4cb1d6da36d2 = `sefA7W_wallet-card-name-only`;
$ae98580914bba820$export$8739e2fda76f188c = `sefA7W_wallet-card-summary`;


const $f74cb26e90b69662$export$af24f5c464ce2910 = ({ name: name, mode: mode, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `br-8 ${$ae98580914bba820$export$b3fd76504d11e6fb} ${$ae98580914bba820$export$b3fd76504d11e6fb}-${mode} ${$ae98580914bba820$export$c95979b960f4acea}`,
        style: {
            backgroundImage: `${(0, $39c40562225f6f25$export$f1a9f8480ead6b1a)(name.charAt(0)).toString()}`
        },
        children: children
    });
};


function $f7b2a8e1eda04839$export$65247218c32d517c({ userDefinedName: userDefinedName, credential: credential, detailLevel: detailLevel, onClick: onClick }) {
    const languages = (0, $a51ba634029c0920$export$38be4353f99148d)();
    const claimsTranslationMap = (0, $acw62.useMemo)(()=>{
        const translationMap = new Map();
        if (!credential.claimDisplayables) return translationMap;
        credential.claimDisplayables.forEach((value, key)=>{
            const bestMatch = value.getBestMatchForLocales(languages);
            translationMap.set(key, bestMatch.name);
        });
        return translationMap;
    }, [
        credential,
        languages
    ]);
    const localizedCredentialDisplay = credential.credentialDisplay.getBestMatchForLocales(languages);
    const credentialName = localizedCredentialDisplay.name;
    const credentialDescription = localizedCredentialDisplay.description;
    const renderLogo = ()=>localizedCredentialDisplay.logo?.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: localizedCredentialDisplay.logo?.url,
            alt: `Logotype for ${credentialName}`,
            width: "48",
            height: "48"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f9134ed37f21b5c$export$2631022cf909144e), {
            width: "48",
            height: "48"
        });
    function translate(key) {
        return claimsTranslationMap.get(key) || key;
    }
    const onClickHandler = onClick || (()=>{});
    // Because we don't want to show the 'id', which is a DID
    const uiProperties = Array.from(credential.subjectStringProperties.entries()).filter(([key])=>key !== "id");
    switch(detailLevel){
        case "name-only":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "name-only",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `flex ${!userDefinedName ? "flex-center" : ""} flex-gap-3`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "white",
                                children: renderLogo()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "m0 white uppercasecaps",
                                        children: credentialName
                                    }),
                                    userDefinedName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: userDefinedName
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            });
        case "summary":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "summary",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row flex-gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "white",
                                    children: renderLogo()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "m0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: credentialName
                                        })
                                    })
                                })
                            ]
                        }),
                        uiProperties.slice(0, 2).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid-container",
                            columns: "2",
                            children: uiProperties.slice(0, 2).map(([name, value])=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "m0 white uppercasecaps",
                                            children: translate(name)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "m0 white",
                                            children: value
                                        })
                                    ]
                                }, name);
                            })
                        })
                    ]
                })
            });
        case "detailed":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "detailed",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row flex-gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "white",
                                    children: renderLogo()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "m0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: credentialName
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "m0 white",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                children: credentialDescription
                            })
                        }),
                        uiProperties.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid-container",
                            columns: "2",
                            children: uiProperties.map(([name, value])=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "m0 white uppercasecaps",
                                            children: translate(name)
                                        }, `dt-${name}`),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "m0 white",
                                            children: value
                                        }, `dd-${name}`)
                                    ]
                                }, name);
                            })
                        })
                    ]
                })
            });
    }
}


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 


var $acw62 = parcelRequire("acw62");


function $e64bd531bd27491f$export$48e248122c104320({ userDefinedName: userDefinedName, credential: credential, detailLevel: detailLevel, onClick: onClick }) {
    const languages = (0, $a51ba634029c0920$export$38be4353f99148d)();
    const claimsTranslationMap = (0, $acw62.useMemo)(()=>{
        const translationMap = new Map();
        if (!credential.claimDisplayables) return translationMap;
        credential.claimDisplayables.forEach((value, key)=>{
            const bestMatch = value.getBestMatchForLocales(languages);
            translationMap.set(key, bestMatch.name);
        });
        return translationMap;
    }, [
        credential,
        languages
    ]);
    const localizedCredentialDisplay = credential.credentialDisplay.getBestMatchForLocales(languages);
    const credentialName = localizedCredentialDisplay.name;
    const credentialDescription = localizedCredentialDisplay.description;
    const renderLogo = ()=>localizedCredentialDisplay.logo?.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: localizedCredentialDisplay.logo?.url,
            alt: `Logotype for ${credentialName}`,
            width: "48",
            height: "48"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f9134ed37f21b5c$export$2631022cf909144e), {
            width: "48",
            height: "48"
        });
    function translate(key) {
        return claimsTranslationMap.get(key) || key;
    }
    const onClickHandler = onClick || (()=>{});
    // Because we don't want to show these system-ish claims
    const uiProperties = Array.from(credential.customStringClaims).filter((claim)=>claim.name !== "vct" && claim.name !== "purpose");
    switch(detailLevel){
        case "name-only":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "name-only",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `flex ${!userDefinedName ? "flex-center" : ""} flex-gap-3`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "white",
                                children: renderLogo()
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "m0 white uppercasecaps",
                                        children: credentialName
                                    }),
                                    userDefinedName ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "mb0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: userDefinedName
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            });
        case "summary":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "summary",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row flex-gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "white",
                                    children: renderLogo()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "m0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: credentialName
                                        })
                                    })
                                })
                            ]
                        }),
                        uiProperties.slice(0, 2).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid-container",
                            columns: "2",
                            children: uiProperties.slice(0, 2).map((claim)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "m0 white uppercasecaps",
                                            children: translate(claim.name)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "m0 white",
                                            children: claim.value
                                        })
                                    ]
                                }, claim.name);
                            })
                        })
                    ]
                })
            });
        case "detailed":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
                name: credentialName,
                mode: "detailed",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-column flex-gap-2",
                    onClick: ()=>onClickHandler(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row flex-gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "white",
                                    children: renderLogo()
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "m0 white uppercasecaps",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                            children: credentialName
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "m0 white",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                children: credentialDescription
                            })
                        }),
                        uiProperties.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid-container",
                            columns: "2",
                            children: uiProperties.map((claim)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                            className: "m0 white uppercasecaps",
                                            children: translate(claim.name) + (claim.isSelectivelyDiscloseable ? "*" : "")
                                        }, `dt-${claim.name}`),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "m0 white",
                                            children: claim.value
                                        }, `dd-${claim.name}`)
                                    ]
                                }, claim.name);
                            })
                        })
                    ]
                })
            });
    }
}


function $5cd55c368b3a0052$export$be16376032ac4bf({ credential: credential, detailLevel: detailLevel, onClick: onClick }) {
    const level = detailLevel || "summary";
    const didJwtVcJsonCredential = credential.credential.didJwtVcJson;
    const vcSdJwtCredential = credential.credential.vcSdJwt;
    if (didJwtVcJsonCredential) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7b2a8e1eda04839$export$65247218c32d517c), {
        userDefinedName: credential.userDefinedName,
        credential: didJwtVcJsonCredential,
        detailLevel: level,
        onClick: ()=>onClick && onClick(credential)
    });
    if (vcSdJwtCredential) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e64bd531bd27491f$export$48e248122c104320), {
        userDefinedName: credential.userDefinedName,
        credential: vcSdJwtCredential,
        detailLevel: level,
        onClick: ()=>onClick && onClick(credential)
    });
    else return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Credential format not supported"
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 


const $23eaea0ba786435d$export$fddf379e22a74b00 = ({ text: text, heading: heading, link: link, cta: cta })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-column  border-light button-fullwidth p3 br-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcd643c7c0dee46c$export$1f74963c34e8bfec), {
                    width: "68",
                    height: "68"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "mt0",
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: text
            }),
            link && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "button button-medium button-primary-outline button-fullwidth",
                to: link,
                children: cta
            })
        ]
    });



/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");
var $c2d8d6e9db0b63fe$export$d280ec02710f0306;
var $c2d8d6e9db0b63fe$export$523c27b16364df71;
var $c2d8d6e9db0b63fe$export$1c72d3f30934c4bd;
var $c2d8d6e9db0b63fe$export$3197a78bb1659583;
var $c2d8d6e9db0b63fe$export$f9d95f8ec4c12325;
var $c2d8d6e9db0b63fe$export$9f9e2a002fe568ac;
var $c2d8d6e9db0b63fe$export$9c1db559f9df210d;
$c2d8d6e9db0b63fe$export$d280ec02710f0306 = `_68oDka_lock-scroll`;
$c2d8d6e9db0b63fe$export$523c27b16364df71 = `_68oDka_pwa-prompt-background`;
$c2d8d6e9db0b63fe$export$1c72d3f30934c4bd = `_68oDka_pwa-prompt-content`;
$c2d8d6e9db0b63fe$export$3197a78bb1659583 = `_68oDka_pwa-prompt-content-copy`;
$c2d8d6e9db0b63fe$export$f9d95f8ec4c12325 = `_68oDka_pwa-prompt-content-header`;
$c2d8d6e9db0b63fe$export$9f9e2a002fe568ac = `_68oDka_pwa-prompt-content-header-heading`;
$c2d8d6e9db0b63fe$export$9c1db559f9df210d = `_68oDka_slide-up`;
$c2d8d6e9db0b63fe$export$9c1db559f9df210d;




const $027b691230a31c62$export$46f21afe2f552aae = ()=>{
    const isiOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    const isAndroid = /android/.test(window.navigator.userAgent.toLowerCase());
    const isHiddenByUserPreference = localStorage.getItem("pwa-prompt-status") === "hidden";
    const [isVisible, setVisibility] = (0, $acw62.useState)(Boolean);
    (0, $acw62.useEffect)(()=>{
        const activeElement = document.activeElement;
        if (activeElement) activeElement.blur();
        setVisibility(isiOS || isAndroid);
    }, [
        isiOS,
        isAndroid
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isVisible) document.body.classList.add($c2d8d6e9db0b63fe$export$d280ec02710f0306);
    }, [
        isVisible
    ]);
    const dismissPrompt = ()=>{
        document.body.classList.remove($c2d8d6e9db0b63fe$export$d280ec02710f0306);
        setVisibility(false);
        localStorage.setItem("pwa-prompt-status", "hidden");
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: isVisible && !isHiddenByUserPreference ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `${$c2d8d6e9db0b63fe$export$523c27b16364df71}`,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `${$c2d8d6e9db0b63fe$export$1c72d3f30934c4bd}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: `${$c2d8d6e9db0b63fe$export$f9d95f8ec4c12325}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                className: `m0 flex flex-gap-2 flex-center ${$c2d8d6e9db0b63fe$export$9f9e2a002fe568ac}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5d1ede17663f7d4$export$24493ea34167a6d8), {
                                        width: "24",
                                        height: "24"
                                    }),
                                    "Add Wallet to Home Screen"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                "aria-label": "Close",
                                className: "button button-tiny button-transparent",
                                onClick: dismissPrompt,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45830f57d8e8c2ef$export$f39c2d165cd861fe), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `p2 ${$c2d8d6e9db0b63fe$export$3197a78bb1659583}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "This Wallet application can be used as a Progressive Web App PWA. You can add it to your home screen and use it in full screen."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "m0 list-reset",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "flex flex-gap-2 p2",
                                        children: isAndroid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d67ff43850561b6$export$c5dda59a24f0b250), {}),
                                                "In Chrome click the menu button"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ef4af422f0b4aa6$export$c9915453de10000b), {}),
                                                "Press the Share button"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        className: "flex flex-gap-2 p2",
                                        children: isAndroid ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e2fba9128c49e04$export$2d9ac7aa84f97a08), {}),
                                                "Press Install Application"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e2fba9128c49e04$export$2d9ac7aa84f97a08), {}),
                                                "Press Add to Home screen"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};


function $1ddabedec9b02645$var$getCredentialOfferFromQuery(queryString) {
    if (queryString) {
        // If the query contains an offer request, then go to the offer resolution page
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has("credential_offer") || queryParams.has("credential_offer_uri")) return queryParams.toString();
        // To support PWA protocol handlers
        try {
            const url = new URL(decodeURIComponent(location.search.substring(1)));
            if (url.protocol === "web+openidcredentialoffer:") {
                const queryParams = new URLSearchParams(url.search);
                if (queryParams.has("credential_offer") || queryParams.has("credential_offer_uri")) return queryParams.toString();
            }
        } catch (error) {
        // ignore
        }
        return undefined;
    }
}
function $1ddabedec9b02645$var$getPresentationRequestString(queryString) {
    if (queryString) {
        // If the query contains a presentation request, then go to the presentation resolution page
        const queryParams = new URLSearchParams(location.search);
        if (queryParams.has("request_uri")) return queryParams.toString();
        // To support PWA protocol handlers
        try {
            const url = new URL(decodeURIComponent(location.search.substring(1)));
            if (url.protocol === "web+haip:") {
                const queryParams = new URLSearchParams(url.search);
                if (queryParams.has("request_uri")) return queryParams.toString();
            }
        } catch (error) {
        // ignore
        }
        return undefined;
    }
}
function $1ddabedec9b02645$export$b94310965bed44e6() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const onClick = (0, $acw62.useCallback)((credential)=>{
        navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_CREDENTIAL_DETAIL(credential.id));
    }, [
        navigate
    ]);
    const credentials = (0, $acw62.useMemo)(()=>(0, $c02206712fb92858$export$ba679c5cdb4741c4).getAll(), []);
    const location1 = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    // Check if URL contains a credential offer
    const offerQueryString = $1ddabedec9b02645$var$getCredentialOfferFromQuery(location1.search);
    if (offerQueryString) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_OFFER_RESOLVE(offerQueryString)
    });
    // Check if URL contains a presentation request
    const presentationRequestString = $1ddabedec9b02645$var$getPresentationRequestString(location1.search);
    if (presentationRequestString) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_PRESENTATION_RESOLVE(presentationRequestString)
    });
    return credentials.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mx-auto-w-3 h-3 mt2 mb2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32da6f3553b8846$export$fd56217de116e11b), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                className: "h3 mt0 mb3 center",
                children: [
                    "Welcome to the ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    " Curity Demo Wallet"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "uppercasecaps",
                children: "Credentials"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-column flex-gap-1",
                children: credentials.map((credential)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                        credential: credential,
                        detailLevel: "name-only",
                        onClick: onClick
                    }, credential.id))
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $027b691230a31c62$export$46f21afe2f552aae), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "mx-auto-w-7 h-7 mt2 mb2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e32da6f3553b8846$export$fd56217de116e11b), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23eaea0ba786435d$export$fddf379e22a74b00), {
                heading: "Looks you don't have any credentials",
                text: "A way to obtain credentials is by going to the issuers and using one of its supported credentials.",
                link: "/issuers/",
                cta: "Get my first credential"
            })
        ]
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
const $fb1f982b375c0798$export$c8424c4d8ba2150 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-column h100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Curity Demo Wallet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Copyright (C) 2023 Curity AB. All rights reserved."
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 





var $acw62 = parcelRequire("acw62");


var $3ad0b18550639ba2$export$88c285a36b461963;
$3ad0b18550639ba2$export$88c285a36b461963 = `HCkZgq_issuer-card`;


const $4a1979e6ee060a6e$export$89098fbd097123dd = ({ name: name, link: link })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `br-8 ${$3ad0b18550639ba2$export$88c285a36b461963}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex flex-gap-2 justify-between",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-center justify-between",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    className: "border-light p3 br-8",
                    to: link,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "mt0",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "button button-tiny button-primary-outline",
                            children: "View supported credentials"
                        })
                    ]
                })
            })
        })
    });
};


function $432c0bfca372dee0$export$ef50156decfcbb20() {
    const issuers = (0, $7939e29d663dd3ed$export$1448a5050d252c4d)();
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const filteredIssuers = issuers.filter((issuer)=>issuer.name.toLowerCase().includes(searchText.toLowerCase()));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: issuers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-center justify-between flex-gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                            className: "flex flex-center flex-gap-1",
                            children: [
                                "Credential Issuers",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "pill pill-bright",
                                    children: issuers.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                className: "button button-tiny button-primary-outline",
                                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_ADD,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b6bd709a2dba9be$export$d0265b2c425512d6), {
                                    width: "20",
                                    height: "20"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-gap-1 justify-between bg-light-grey mt2 mb2 p1 br-8",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "search",
                        placeholder: "Search Credential Issuers",
                        className: "field w100",
                        value: searchText,
                        onChange: (e)=>setSearchText(e.target.value)
                    })
                }),
                filteredIssuers.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        searchText && filteredIssuers.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "Found ",
                                filteredIssuers.length,
                                " issuer ",
                                filteredIssuers.length > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "(s)"
                                }) : null
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "list-reset m0 flex flex-column justify-between flex-gap-1",
                            children: issuers.filter((issuer)=>issuer.name.toLowerCase().includes(searchText.toLowerCase())).map((issuer)=>{
                                const encodedId = encodeURIComponent(issuer.id);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a1979e6ee060a6e$export$89098fbd097123dd), {
                                        name: issuer.name,
                                        link: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_ISSUER_DETAIL(encodedId)
                                    })
                                }, issuer.id);
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "No search results"
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23eaea0ba786435d$export$fddf379e22a74b00), {
            heading: "Looks you don't have any credential issuers",
            text: " Fortunately, it's very easy to create one. Click + button above to add your first credential issuer. ",
            link: "/issuers/add",
            cta: "Create your first issuer"
        })
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



var $acw62 = parcelRequire("acw62");

/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



function $69fbcf1ee0c90a58$export$930e19b45454fbda({ supportedCredential: supportedCredential, children: children }) {
    const languages = (0, $a51ba634029c0920$export$38be4353f99148d)();
    const display = supportedCredential.display.getBestMatchForLocales(languages);
    const name = display?.name;
    const description = display?.description;
    const renderLogo = ()=>display.logo?.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            src: display.logo?.url,
            alt: `Logotype for ${name}`,
            width: "48",
            height: "48"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6f9134ed37f21b5c$export$2631022cf909144e), {
            width: "48",
            height: "48"
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f74cb26e90b69662$export$af24f5c464ce2910), {
        name: name,
        mode: "summary",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-column flex-gap-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row flex-gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "white",
                            children: renderLogo()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "mt0 white uppercasecaps",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "m0 white",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: description
                                    })
                                })
                            ]
                        })
                    ]
                }),
                children && children
            ]
        })
    });
}


function $df49e9cdff620df4$export$8344fe541c6cf9d2({ issuer: issuer, SupportedCredentialAction: SupportedCredentialAction }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: issuer.name
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: "Credentials supported by this issuer:"
            }),
            issuer.credentialsSupported.size > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-column flex-gap-1 mb2",
                children: Array.from(issuer.credentialsSupported, ([id, credentialSupported])=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69fbcf1ee0c90a58$export$930e19b45454fbda), {
                            supportedCredential: credentialSupported,
                            children: SupportedCredentialAction && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SupportedCredentialAction, {
                                issuer: issuer,
                                id: id,
                                credentialSupported: credentialSupported
                            })
                        })
                    }, id);
                })
            })
        ]
    });
}



const $f169731e77dd4f03$export$84c41a61aa1cc56c = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "cta-success",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex justify-center flex-column flex-center p2",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                className: "success-checkmark",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 52 52",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                        className: "success-checkmark-circle",
                        cx: "26",
                        cy: "26",
                        r: "25",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        className: "success-checkmark-check",
                        fill: "none",
                        d: "M14.1 27.2l7.1 7.2 16.7-16.8"
                    })
                ]
            })
        })
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

const $1f73490bdf36048c$export$caec2af78bcc877f = ({ kind: kind, title: title, errorMessage: errorMessage, link: link, linkText: linkText, classes: classes = "" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `alert alert-${kind} ${classes}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                className: "mt0",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "mb0",
                children: errorMessage
            }),
            link && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "",
                to: link,
                children: linkText
            })
        ]
    });


function $51fd8781ec849bae$var$reducer(state, action) {
    switch(state.state){
        case "loaded":
            if (action.type == "remove") return {
                state: "removal-confirmation"
            };
            break;
        case "removal-confirmation":
            if (action.type == "removing") return {
                state: "removing"
            };
            if (action.type == "cancel-remove") return {
                state: "loaded"
            };
            break;
        case "removing":
            if (action.type == "removed") return {
                state: "removed"
            };
            if (action.type == "error") return {
                state: "error",
                message: action.message
            };
            break;
        case "removed":
            break;
        case "error":
            break;
    }
}
function $51fd8781ec849bae$export$5abe2a56a0207b63() {
    const issuer = (0, $7939e29d663dd3ed$export$1448a5050d252c4d)();
    const [state, dispatch] = (0, $acw62.useReducer)($51fd8781ec849bae$var$reducer, {
        state: "loaded"
    });
    const handleRemove = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: "remove"
        });
    }, [
        dispatch
    ]);
    const handleRemovalConfirmation = (0, $acw62.useCallback)(async ()=>{
        dispatch({
            type: "removing"
        });
        try {
            await (0, $c02206712fb92858$export$7311d7bc08dcdc86).removeById(issuer.id);
            dispatch({
                type: "removed"
            });
        } catch (ex) {
            dispatch({
                type: "error",
                message: ex.message
            });
        }
    }, [
        dispatch,
        issuer?.id
    ]);
    const handleRemovalCancellation = (0, $acw62.useCallback)(async ()=>{
        dispatch({
            type: "cancel-remove"
        });
    }, [
        dispatch
    ]);
    if (issuer == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "No issuer found with that identifier"
    });
    switch(state.state){
        case "loaded":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df49e9cdff620df4$export$8344fe541c6cf9d2), {
                        issuer: issuer,
                        SupportedCredentialAction: $51fd8781ec849bae$var$LinkToCredentialIssue
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-fullwidth button-danger",
                        onClick: handleRemove,
                        children: "Remove issuer"
                    })
                ]
            });
        case "removal-confirmation":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Are you sure you want to remove this credential issuer?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-gap flex-column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button button-medium button-fullwidth button-danger",
                                onClick: handleRemovalConfirmation,
                                children: "Remove"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "button button-medium button-fullwidth button-transparent",
                                onClick: handleRemovalCancellation,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            });
        case "removing":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "Removing..."
                })
            });
        case "removed":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "h100 flex flex-column flex-center justify-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                    className: "h3 mt0",
                                    children: "Success"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Credential Issuer was successfully removed"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_LIST,
                            className: "button button-medium button-primary button-fullwidth",
                            children: "View Credential Issuers"
                        })
                    ]
                })
            });
        case "error":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "There was an error removing the issuer",
                errorMessage: state.message,
                link: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_LIST,
                linkText: "View Issuers"
            });
    }
}
function $51fd8781ec849bae$var$LinkToCredentialIssue({ issuer: issuer, id: id }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
        className: "button button-small button-white-outline",
        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_CREDENTIAL_ISSUANCE(issuer.id, id),
        children: "Get Credential"
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");






const $c3ea38996be51ba1$export$7f7cbe89f1eacd2 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "spinner-container py2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "spinner spinner-medium",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "spinner-circle"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    "aria-hidden": "true",
                    width: "1.25em",
                    height: "1.25em",
                    viewBox: "0 0 91.08 58.46",
                    fill: "none",
                    strokeLinecap: "round",
                    strokeLinejoin: "bevel",
                    className: "spinner-logo",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            className: "a",
                            d: "M82 37l-.9.9c-5.09 5.09-11.49 8-17.55 8-9.63 0-16.62-7-16.62-16.7s6.77-16.66 16.16-16.66A26.77 26.77 0 0 1 79.51 19l.9.79 9-9.41-1-.86A39.66 39.66 0 0 0 62.13 0c-38.33 1.27-41.28 55.09.4 58.35 13.6 1.06 23.15-7 27.6-11.14l1-.88z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            className: "spinner-middle-line",
                            d: "M31.29 25.11H10.18l-1 8.17H30.9a30.4 30.4 0 0 1 .39-8.17z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            className: "spinner-top-line",
                            d: "M19.15 12.35l-1 8.17H32a36.37 36.37 0 0 1 3.72-8.17z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            className: "spinner-bottom-line",
                            d: "M32 37.86H1L0 46h35.93a26 26 0 0 1-4-8.17z"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            className: "spinner-tiny-line",
                            d: "M7.86 25.11H1.84l-.97 8.17h6.02l.97-8.17z"
                        })
                    ]
                })
            ]
        })
    });



function $e71e4428a17df563$var$reducer(state, action) {
    switch(state.state){
        case "begin":
            switch(action.type){
                case "load":
                    return {
                        state: "loading",
                        issuerId: action.issuerId
                    };
                default:
                    return state;
            }
        case "loading":
            switch(action.type){
                case "loaded":
                    return {
                        state: "loaded",
                        issuerId: action.issuerId,
                        issuer: action.issuer
                    };
                case "load-error":
                    return {
                        state: "load-error",
                        issuerId: action.issuerId,
                        message: action.message
                    };
                default:
                    return state;
            }
        case "loaded":
            switch(action.type){
                case "load":
                    return {
                        state: "loading",
                        issuerId: action.issuerId
                    };
                case "save":
                    return {
                        state: "saving",
                        issuerId: state.issuerId,
                        issuer: state.issuer
                    };
                case "clear":
                    return {
                        state: "begin"
                    };
                default:
                    return state;
            }
        case "load-error":
            switch(action.type){
                case "load":
                    return {
                        state: "loading",
                        issuerId: action.issuerId
                    };
                default:
                    return state;
            }
        case "saving":
            switch(action.type){
                case "saved":
                    return {
                        state: "saved",
                        issuer: state.issuer
                    };
                case "save-error":
                    return {
                        state: "save-error",
                        message: action.message,
                        issuer: state.issuer,
                        issuerId: state.issuerId
                    };
                default:
                    return state;
            }
        case "save-error":
            switch(action.type){
                case "save":
                    return {
                        state: "saving",
                        issuerId: state.issuerId,
                        issuer: state.issuer
                    };
                default:
                    return state;
            }
        case "saved":
            break;
    }
}
async function $e71e4428a17df563$var$operLoad(issuerId, dispatch) {
    dispatch({
        type: "load",
        issuerId: issuerId
    });
    try {
        const issuer = await (0, $c02206712fb92858$export$238c44a402494d7b).load(issuerId);
        dispatch({
            type: "loaded",
            issuerId: issuerId,
            issuer: issuer
        });
    } catch (e) {
        dispatch({
            type: "load-error",
            issuerId: issuerId,
            message: e.message
        });
    }
}
async function $e71e4428a17df563$var$operSave(issuer, dispatch) {
    dispatch({
        type: "save",
        issuer: issuer
    });
    try {
        await (0, $c02206712fb92858$export$7311d7bc08dcdc86).upsert(issuer);
        dispatch({
            type: "saved",
            issuer: issuer
        });
    } catch (e) {
        dispatch({
            type: "save-error",
            issuer: issuer,
            message: e.message
        });
    }
}
function $e71e4428a17df563$export$93f2f36e171ad6f7() {
    const [state, dispatch] = (0, $acw62.useReducer)($e71e4428a17df563$var$reducer, {
        state: "begin"
    });
    switch(state.state){
        case "begin":
        case "loading":
        case "load-error":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e71e4428a17df563$var$LoadForm, {
                state: state,
                dispatch: dispatch
            });
        case "loaded":
        case "saving":
        case "save-error":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e71e4428a17df563$var$ShowIssuer, {
                state: state,
                dispatch: dispatch,
                issuer: state.issuer
            });
        case "saved":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e71e4428a17df563$var$ShowSaved, {});
    }
}
function $e71e4428a17df563$var$LoadForm({ state: state, dispatch: dispatch }) {
    const handleSubmit = (0, $acw62.useCallback)((ev)=>{
        ev.preventDefault();
        const formData = new FormData(ev.target);
        const issuerId = formData.get("issuerId").valueOf();
        $e71e4428a17df563$var$operLoad(issuerId, dispatch);
    }, [
        dispatch
    ]);
    const enabled = state.state === "begin" || state.state === "loaded" || state.state === "load-error";
    const errorMessage = state.state === "load-error" && state.message;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Add a Credential Issuer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Only issuers that support the OpenID for Verifiable Credential Issuance spec are supported."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: (e)=>handleSubmit(e),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block",
                        htmlFor: "credential-issuer-url",
                        children: "Credential Issuer Identifier"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        className: "field w100 mb2",
                        id: "credential-issuer-url",
                        placeholder: "Enter URL",
                        name: "issuerId",
                        disabled: !enabled
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-column flex-gap-2 flex-align-normal",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                className: "button button-medium button-primary button-fullwidth",
                                type: "submit",
                                value: "Load credentials",
                                disabled: !enabled
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "button button-medium button-transparent button-fullwidth",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            state.state == "loading" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {}),
            errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "There was an error adding the issuer",
                errorMessage: errorMessage
            })
        ]
    });
}
function $e71e4428a17df563$var$ShowIssuer({ state: state, dispatch: dispatch, issuer: issuer }) {
    const handleClick = (0, $acw62.useCallback)(async ()=>{
        $e71e4428a17df563$var$operSave(issuer, dispatch);
    }, [
        issuer,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df49e9cdff620df4$export$8344fe541c6cf9d2), {
                issuer: issuer
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "button button-medium button-primary button-fullwidth",
                onClick: handleClick,
                disabled: false,
                children: "Save Issuer"
            }),
            state.state == "save-error" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Error: ",
                    state.message
                ]
            })
        ]
    });
}
function $e71e4428a17df563$var$ShowSaved() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h100 flex flex-column flex-center justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        className: "h3 mt0",
                        children: "Success"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Credential Issuer added successfully"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_LIST,
                className: "button button-medium button-primary button-fullwidth",
                children: "View Credential Issuers"
            })
        ]
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
function $b8861fdd32a45cce$export$b187bfb7762ed1d1() {
    return (0, $c02206712fb92858$export$7311d7bc08dcdc86).getAll();
}
function $b8861fdd32a45cce$export$59dd5c9438358cde({ params: params }) {
    const decodedId = decodeURIComponent(params.id);
    return (0, $c02206712fb92858$export$7311d7bc08dcdc86).getById(decodedId);
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 




var $acw62 = parcelRequire("acw62");






/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ var $fd664e149db4c2ea$exports = {};
"use strict";
function $fd664e149db4c2ea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fd664e149db4c2ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fd664e149db4c2ea$var$_typeof(obj);
}
Object.defineProperty($fd664e149db4c2ea$exports, "__esModule", {
    value: true
});
$fd664e149db4c2ea$exports["default"] = $fd664e149db4c2ea$exports.ReactGAImplementation = void 0;

var $fd664e149db4c2ea$var$_ga = $fd664e149db4c2ea$var$_interopRequireWildcard((parcelRequire("hdGlG")));
function $fd664e149db4c2ea$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fd664e149db4c2ea$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fd664e149db4c2ea$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fd664e149db4c2ea$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $fd664e149db4c2ea$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $fd664e149db4c2ea$var$ReactGAImplementation = $fd664e149db4c2ea$var$_ga.GA4;
$fd664e149db4c2ea$exports.ReactGAImplementation = $fd664e149db4c2ea$var$ReactGAImplementation;
var $fd664e149db4c2ea$var$_default = $fd664e149db4c2ea$var$_ga["default"];
$fd664e149db4c2ea$exports["default"] = $fd664e149db4c2ea$var$_default;


const $9fd44832378de894$export$888e567f63ec7c8b = (category, action, label)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fd664e149db4c2ea$exports))).event({
        category: category,
        action: action,
        label: label
    });
};


function $ee7a4117102a85c8$var$reducer(state, action) {
    switch(action.type){
        case "cancel-credential-request":
            return {
                state: "waiting-for-cancel"
            };
        case "start-credential-request":
            return {
                state: "waiting-for-credential",
                abortController: action.abortController
            };
        case "error":
            if (state.state === "waiting-for-cancel") // an error is expected in this case
            return {
                state: "begin"
            };
            return {
                state: "begin",
                errorMessage: action.message
            };
        case "credential-issued":
            return {
                state: "credential-issued",
                credential: action.credential,
                credentialName: ""
            };
        case "credential-name-assigned":
            if (state.state != "credential-issued") // don't do anything
            return state;
            return {
                ...state,
                credentialName: action.credentialName
            };
        case "credential-stored":
            if (state.state != "credential-issued") // don't do anything
            return state;
            return {
                state: "credential-stored",
                credential: state.credential
            };
    }
    return state;
}
async function $ee7a4117102a85c8$var$operStartCredentialRequest(issuer, credential, dispatcher) {
    const abortController = new AbortController();
    try {
        const signingKeyPair = await (0, $c02206712fb92858$export$48ab3e8a44de5f81);
        dispatcher({
            type: "start-credential-request",
            abortController: abortController
        });
        const credentials = await (0, $c02206712fb92858$export$61c3b26555c145ea).requestCredentials(issuer, credential, signingKeyPair, abortController.signal);
        const issuedCredential = credentials[0];
        if (!issuedCredential || credentials.length > 1) dispatcher({
            type: "error",
            message: "response must have a single credential"
        });
        dispatcher({
            type: "credential-issued",
            credential: issuedCredential
        });
    } catch (error) {
        dispatcher({
            type: "error",
            message: error.message
        });
    }
}
function $ee7a4117102a85c8$var$operCancelAuthorization(state, dispatcher) {
    if (state.state == "waiting-for-credential") {
        dispatcher({
            type: "cancel-credential-request"
        });
        state.abortController.abort((0, $8b4eb369eb8605c9$exports.newUserCancellationException)());
    }
}
function $ee7a4117102a85c8$export$b386a42a92ea432d() {
    const issuer = (0, $7939e29d663dd3ed$export$1448a5050d252c4d)();
    const [state, dispatcher] = (0, $acw62.useReducer)($ee7a4117102a85c8$var$reducer, {
        state: "begin"
    });
    const params = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    if (issuer == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "No issuer found with provided identifier"
    });
    const credentialSupported = issuer.credentialsSupported.get(params.credentialId);
    if (credentialSupported == null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "No supported credential found with provided identifier"
    });
    return $ee7a4117102a85c8$var$render(state, dispatcher, issuer, credentialSupported);
}
function $ee7a4117102a85c8$var$render(state, dispatcher, issuer, credentialSupported) {
    switch(state.state){
        case "begin":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69fbcf1ee0c90a58$export$930e19b45454fbda), {
                        supportedCredential: credentialSupported,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button button-white-outline button-fullwidth mt2",
                            onClick: ()=>$ee7a4117102a85c8$var$operStartCredentialRequest(issuer, credentialSupported, dispatcher),
                            children: "Request Credential"
                        })
                    }),
                    state.errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                        kind: "danger",
                        title: "Error",
                        errorMessage: state.errorMessage,
                        classes: "mt2 mb2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "During the credential request a browser window may be opened to perform authentication and credential issuance consent on the credential issuer."
                    })
                ]
            });
        case "waiting-for-credential":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69fbcf1ee0c90a58$export$930e19b45454fbda), {
                        supportedCredential: credentialSupported,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: "button button-small button-white-outline button-fullwidth mt2",
                            onClick: ()=>$ee7a4117102a85c8$var$operCancelAuthorization(state, dispatcher),
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {})
                ]
            });
        case "credential-issued":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Do you want to save this credential in the wallet?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                        credential: state.credential,
                        detailLevel: "detailed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        htmlFor: "optionalname",
                        className: "label block mt2",
                        children: "Name (Optional)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: "field w100",
                        id: "optionalname",
                        type: "text",
                        value: state.credentialName,
                        placeholder: "Credential name",
                        onChange: (ev)=>dispatcher({
                                type: "credential-name-assigned",
                                credentialName: ev.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-primary button-fullwidth mt2",
                        onClick: ()=>{
                            const credential = state.credential;
                            (0, $c02206712fb92858$export$ba679c5cdb4741c4).insert(credential.withUserDefinedName(state.credentialName));
                            (0, $9fd44832378de894$export$888e567f63ec7c8b)("User actions", "Credential", "stored");
                            dispatcher({
                                type: "credential-stored"
                            });
                        },
                        children: "Save Credential"
                    })
                ]
            });
        case "credential-stored":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "This credential is now stored in the wallet"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "button button-primary-outline button-medium w100 mb2",
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        children: "View my credentials"
                    })
                ]
            });
    }
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");

function $6ad8734dfcdf3d44$export$8364ea6a3924dcdf() {
    const [error, setError] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        // FIXME on a firefox/android PWA, the window.opener is null
        if (window.opener) window.opener.postMessage(window.location.search);
        else setError("Unsupported PWA browser, please close window.");
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "OAuth Callback"
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "There was an error performing the authorization",
                errorMessage: error
            })
        ]
    });
}




/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



var $d85a30050adbd2ae$export$adb608be33961c98;
var $d85a30050adbd2ae$export$bd3648cdeb8cd2fd;
$d85a30050adbd2ae$export$adb608be33961c98 = `TcDlAG_footer`;
$d85a30050adbd2ae$export$bd3648cdeb8cd2fd = `TcDlAG_footer-button-qrcode`;


const $58dcafbbd6a14d1d$export$a06f1c675e846f6f = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: `${$d85a30050adbd2ae$export$adb608be33961c98} flex flex-center justify-center absolute w100 primary z-2`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "button button-small button-transparent",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1fd6b08239b2839$export$bcca3ea514774656), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_LIST,
                className: "button button-small button-transparent",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $911efbd418e06a2a$export$a472f9f6fa55fec4), {
                    width: "24",
                    height: "24"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ABOUT,
                className: "button button-small button-transparent",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47807695c0c70127$export$c4868e4a24d48fad), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).SETTINGS,
                className: "button button-small button-transparent",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc564cfa6ab5c665$export$1095c93890fce526), {
                    width: "24",
                    height: "24"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).START,
                className: `button ${$d85a30050adbd2ae$export$bd3648cdeb8cd2fd} w-2 h-2 flex flex-center justify-center white`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81835d564a2f474a$export$5631afde407885cb), {
                    width: "24",
                    height: "24"
                })
            })
        ]
    });



var $3bf9de8aa6b8f674$export$b3219800bda33a1f;
$3bf9de8aa6b8f674$export$b3219800bda33a1f = `A2BXWG_layout`;


const $2799a6352e628d99$export$c84671f46d6a1ca = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$3bf9de8aa6b8f674$export$b3219800bda33a1f} relative`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $58dcafbbd6a14d1d$export$a06f1c675e846f6f), {})
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 




var $acw62 = parcelRequire("acw62");


function $73b03cf1a79c4eaa$export$957aea9438988dfb() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const onClick = (0, $acw62.useCallback)((credential)=>{
        navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_CREDENTIAL_DETAIL(credential.id));
    }, [
        navigate
    ]);
    const credentials = (0, $acw62.useMemo)(()=>(0, $c02206712fb92858$export$ba679c5cdb4741c4).getAll(), []);
    return credentials.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            credentials.map((credential)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                    credential: credential,
                    detailLevel: "summary",
                    onClick: onClick
                }, credential.id)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                children: "Home"
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23eaea0ba786435d$export$fddf379e22a74b00), {
        heading: "Looks you don't have any credentials",
        text: "A way to obtain credentials is by going to the issuers and using one of its supported credentials."
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



var $acw62 = parcelRequire("acw62");




function $5ed4dfdf7a9f6cec$var$reducer(state, action) {
    switch(state.tag){
        case "loaded":
            if (action.type == "remove") return {
                tag: "removal-confirmation"
            };
            break;
        case "removal-confirmation":
            if (action.type == "removed") return {
                tag: "removed"
            };
            if (action.type == "cancel-remove") return {
                tag: "loaded"
            };
            if (action.type == "error") return {
                tag: "error",
                message: action.message
            };
            break;
    }
    return state;
}
function $5ed4dfdf7a9f6cec$export$75d757922a6a242c() {
    const credentialId = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)().id;
    const [state, dispatch] = (0, $acw62.useReducer)($5ed4dfdf7a9f6cec$var$reducer, {
        tag: "loaded"
    });
    const credential = (0, $acw62.useMemo)(()=>(0, $c02206712fb92858$export$ba679c5cdb4741c4).getById(credentialId), [
        credentialId
    ]);
    if (!credential) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "h100 flex flex-column flex-center justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Oops, credential not found"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "button button-primary-outline button-medium button-fullwidth",
                to: "/",
                children: "Home"
            })
        ]
    });
    switch(state.tag){
        case "loaded":
            return $5ed4dfdf7a9f6cec$var$renderLoaded(credential, dispatch);
        case "removal-confirmation":
            return $5ed4dfdf7a9f6cec$var$renderRemovalConfirmation(credential, dispatch);
        case "removed":
            return $5ed4dfdf7a9f6cec$var$renderRemoved();
        case "error":
            return $5ed4dfdf7a9f6cec$var$renderRemovalError(state.message);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
        credential: credential,
        detailLevel: "detailed"
    });
}
function $5ed4dfdf7a9f6cec$var$renderLoaded(credential, dispatch) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                credential: credential,
                detailLevel: "detailed"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "button button-medium button-fullwidth button-danger mt2",
                onClick: ()=>dispatch({
                        type: "remove"
                    }),
                children: "Remove credential"
            })
        ]
    });
}
function $5ed4dfdf7a9f6cec$var$renderRemovalConfirmation(credential, dispatch) {
    function handleRemove() {
        try {
            (0, $c02206712fb92858$export$ba679c5cdb4741c4).delete(credential.id);
            dispatch({
                type: "removed"
            });
        } catch (error) {
            dispatch({
                type: "error",
                message: error.message
            });
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                credential: credential,
                detailLevel: "detailed"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-column flex-gap-2 mt2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-fullwidth button-danger",
                        onClick: handleRemove,
                        children: "Confirm credential removal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-fullwidth button-primary-outline",
                        onClick: ()=>dispatch({
                                type: "cancel-remove"
                            }),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
function $5ed4dfdf7a9f6cec$var$renderRemoved() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "h100 flex flex-column flex-center justify-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "h3 mt0",
                            children: "Success"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Credential was successfully removed"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                    className: "button button-medium button-primary button-fullwidth",
                    children: "View Credentials"
                })
            ]
        })
    });
}
function $5ed4dfdf7a9f6cec$var$renderRemovalError(errorMessage) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
        kind: "danger",
        title: "There was an error removing the credential",
        errorMessage: errorMessage,
        link: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
        linkText: "Credential list"
    });
}



/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 


var $76832ef07398afd0$export$38e42c68cf43b5d4;
var $76832ef07398afd0$export$f6d6795961566b71;
$76832ef07398afd0$export$38e42c68cf43b5d4 = `o781xq_header`;
$76832ef07398afd0$export$f6d6795961566b71 = `o781xq_header-button`;


const $40220613d8d83c2f$export$8b251419efc915eb = ({ title: title, backButton: backButton })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: `${$76832ef07398afd0$export$38e42c68cf43b5d4} px2 flex flex-center flex-gap-1 justify-center absolute w100`,
        children: [
            backButton == -1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: `${$76832ef07398afd0$export$f6d6795961566b71} button button-tiny button-transparent`,
                onClick: ()=>navigate(-1),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $855d32422e9b26c5$export$25e48ac541203d4a), {
                    width: "24",
                    height: "24"
                })
            }) : backButton ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "button button-tiny button-transparent",
                to: backButton,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $855d32422e9b26c5$export$25e48ac541203d4a), {
                    width: "24",
                    height: "24"
                })
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b5d1ede17663f7d4$export$24493ea34167a6d8), {
                width: "24",
                height: "24"
            }),
            title
        ]
    });
};


var $50f3fed48a2d60a0$export$4ae363f1d88fb658;
var $50f3fed48a2d60a0$export$5f8d3589eb8441ca;
$50f3fed48a2d60a0$export$4ae363f1d88fb658 = `HoVzNa_inner`;
$50f3fed48a2d60a0$export$5f8d3589eb8441ca = `HoVzNa_video`;


const $c6b7e032aded9a09$export$6955bcca4cd3539f = ({ children: children, title: title, backButton: backButton })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40220613d8d83c2f$export$8b251419efc915eb), {
                title: title,
                backButton: backButton
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${$50f3fed48a2d60a0$export$4ae363f1d88fb658} absolute p2`,
                children: children
            })
        ]
    });


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

const $b7f94c3e68863c5c$export$2e6ef246283472d6 = ({ textToCopy: textToCopy })=>{
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const handleCopyToClipboard = async (event)=>{
        event.preventDefault();
        try {
            await navigator.clipboard.writeText(textToCopy);
            setIsCopied(true);
            setTimeout(()=>{
                setIsCopied(false);
            }, 1000);
        } catch (error) {
            console.error("Failed to copy to clipboard:", error);
            setIsCopied(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: "button button-small button-transparent",
        onClick: handleCopyToClipboard,
        children: isCopied ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8506d362ee659335$export$60bffc6e2a50e7f9), {
            width: "24",
            height: "24"
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d79279f7e8a50e4$export$92ce62e1201c4fc0), {
            width: "24",
            height: "24"
        })
    });
};




var $acw62 = parcelRequire("acw62");

const $37f74ddab9fbb377$export$dca24b03814f6d29 = ()=>{
    const [isCleared, setIsCleared] = (0, $acw62.useState)(false);
    const handleClearLocalStorage = async (event)=>{
        event.preventDefault();
        try {
            localStorage.clear();
            setIsCleared(true);
            setTimeout(()=>{
                setIsCleared(false);
                location.reload();
            }, 1000);
        } catch (error) {
            console.error("Failed to clear Local Storage:", error);
            setIsCleared(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
            className: "button button-tiny button-danger",
            onClick: handleClearLocalStorage,
            children: [
                isCleared ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8506d362ee659335$export$60bffc6e2a50e7f9), {
                    width: "24",
                    height: "24"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c5f9b7cc968e411$export$99442c433de1441d), {
                    width: "24",
                    height: "24"
                }),
                isCleared ? "Cleared" : "Clear Local Storage"
            ]
        })
    });
};


function $97e9c2760dd1027f$export$c72f6eaae7b9adff() {
    const walletConfig = (0, $c02206712fb92858$export$dd5bc6957e8aa49a)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleSubmit = (0, $acw62.useCallback)((ev)=>{
        ev.preventDefault();
        const formData = new FormData(ev.target);
        // input type and validation should ensure correct type for 'id' and 'secret'
        const id = formData.get("id");
        const secret = formData.get("secret");
        const preRegisteredClientId = formData.get("pre-registered-client-id");
        const preRegisteredClientJwksUri = formData.get("pre-registered-client-jwks");
        (0, $c02206712fb92858$export$9628a8ca36420503)({
            oauthClient: {
                id: id,
                secret: secret
            },
            preRegisteredClient: {
                id: preRegisteredClientId,
                jwksUri: preRegisteredClientJwksUri
            }
        });
        navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME);
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "OAuth 2.0 client settings"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: (ev)=>handleSubmit(ev),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block",
                        htmlFor: "oauth-client-id",
                        children: "Client ID"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        placeholder: "OAuth client ID",
                        className: "field w100",
                        name: "id",
                        id: "oauth-client-id",
                        required: true,
                        defaultValue: walletConfig.oauthClient.id
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block",
                        htmlFor: "oauth-client-secret",
                        children: "Client Secret"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "password",
                        placeholder: "OAuth client secret",
                        className: "field w100",
                        name: "secret",
                        id: "oauth-client-secret",
                        required: true,
                        defaultValue: walletConfig.oauthClient.secret
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Make sure the following redirect URI is configured for this client on the used Authorization Servers:"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-gap-1 flex-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                            children: (0, $c02206712fb92858$export$472007267a19777f)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7f94c3e68863c5c$export$2e6ef246283472d6), {
                                            textToCopy: (0, $c02206712fb92858$export$472007267a19777f)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: "Pre-Registered Client Settings"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block",
                        htmlFor: "pre-registered-client-id",
                        children: "Client ID"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        placeholder: "Pre-registered client ID",
                        className: "field w100",
                        name: "pre-registered-client-id",
                        id: "pre-registered-client-id",
                        required: true,
                        defaultValue: walletConfig.preRegisteredClient?.id
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                        className: "block",
                        htmlFor: "pre-registered-client-jwks",
                        children: "JWKS URI"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        placeholder: "Pre-registered client JWKS URI",
                        className: "field w100",
                        name: "pre-registered-client-jwks",
                        id: "pre-registered-client-jwks",
                        required: true,
                        defaultValue: walletConfig.preRegisteredClient?.jwksUri
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex flex-column flex-gap-2 flex-align-normal",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            className: "button button-medium button-primary ",
                            type: "submit",
                            value: "Save"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
                        className: "mt2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                                children: "Clear App Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Removes all the Local Storage items for the current domain. "
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37f74ddab9fbb377$export$dca24b03814f6d29), {})
                        ]
                    })
                ]
            })
        ]
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");




function $094438c0fe134892$export$568b89e600fc77eb() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [error, setError] = (0, $acw62.useState)("");
    const onSubmit = (ev)=>{
        ev.preventDefault();
        const request = new FormData(ev.currentTarget).get("url");
        try {
            const queryString = new URL(request).searchParams.toString();
            // TODO HACK
            // We are using this extra initial navigation just to add history state to the offer/presentation screen.
            // (notice the {state: {request: request, replace: true})
            // This way, if the user presses back the app comes back to this screen with the last edited offer/presentation URL
            // Is there a better way to achieve this?
            navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).START, {
                state: {
                    request: request,
                    replace: true
                }
            });
            if (request.startsWith("openid-credential-offer://?")) // Goes to the offer resolution path
            navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_OFFER_RESOLVE(queryString));
            else if (request.startsWith("web+haip://?")) navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_PRESENTATION_RESOLVE(queryString));
            else setError("Provided URL is not recognized as a valid offer or presentation request");
        } catch (e) {
            setError(e.message);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Start from a URL"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Handle a credential offer or a presentation request by pasting a URL"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                        className: "field w100",
                        placeholder: "Enter or paste a URL including the uri scheme",
                        name: "url",
                        rows: 5,
                        cols: 15,
                        defaultValue: location.state?.request
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-primary w100 mb1",
                        type: "submit",
                        children: "Continue"
                    }),
                    error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                        kind: "danger",
                        title: "There was an error",
                        errorMessage: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "or mt2 mb2",
                children: "or"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "h3",
                children: "Scan a QR Code"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Open the camera on your device to scan a QR Code."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).SCAN,
                className: "button button-medium button-primary-outline w100",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $572f845dd9b8a749$export$ed059cf85de854b3), {
                        width: "24",
                        height: "24"
                    }),
                    "Open camera"
                ]
            })
        ]
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 



var $acw62 = parcelRequire("acw62");







function $69dd42c1497226e6$var$unexpectedAction(state, action) {
    return new Error(`Unexpected action '${action.type}' on state '${state.state}'`);
}
function $69dd42c1497226e6$var$reducer(state, action) {
    switch(state.state){
        case "begin":
            switch(action.type){
                case "start-offer-handling":
                    return {
                        state: "waiting-for-offer-handling",
                        abortController: action.abortController,
                        offer: action.offer
                    };
                case "error":
                    // ignore it
                    return state;
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
        case "waiting-for-offer-handling":
            switch(action.type){
                case "cancel":
                    return {
                        ...state,
                        cancelling: true
                    };
                case "offer-handled":
                    return {
                        state: "show-offer",
                        resolvedOffer: action.resolvedOffer
                    };
                case "error":
                    return {
                        state: "begin",
                        offer: state.offer,
                        errorMessage: !state.cancelling && action.message
                    };
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
        case "show-offer":
            switch(action.type){
                case "start-credential-request":
                    return {
                        state: "waiting-for-credential-issuance",
                        resolvedOffer: state.resolvedOffer,
                        abortController: action.abortController
                    };
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
        case "waiting-for-credential-issuance":
            switch(action.type){
                case "cancel":
                    return {
                        ...state,
                        cancelling: true
                    };
                case "credential-issued":
                    return {
                        state: "credential-issued",
                        credential: action.credential,
                        credentialName: ""
                    };
                case "error":
                    return {
                        state: "show-offer",
                        resolvedOffer: state.resolvedOffer,
                        errorMessage: !state.cancelling && action.message
                    };
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
        case "credential-issued":
            switch(action.type){
                case "credential-name-assigned":
                    return {
                        ...state,
                        credentialName: action.credentialName
                    };
                case "credential-stored":
                    return {
                        state: "credential-stored",
                        credential: state.credential
                    };
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
        case "credential-stored":
            switch(action.type){
                case "credential-stored":
                    return {
                        state: "credential-stored",
                        credential: state.credential
                    };
                default:
                    throw $69dd42c1497226e6$var$unexpectedAction(state, action);
            }
    }
}
async function $69dd42c1497226e6$var$operationStartOfferHandling(offer, dispatcher, providedAbortController) {
    const abortController = providedAbortController || new AbortController();
    try {
        dispatcher({
            type: "start-offer-handling",
            abortController: abortController,
            offer: offer
        });
        const resolvedOffer = await (0, $c02206712fb92858$export$61c3b26555c145ea).startHandleOffer(offer, abortController.signal);
        dispatcher({
            type: "offer-handled",
            resolvedOffer: resolvedOffer
        });
    } catch (e) {
        dispatcher({
            type: "error",
            message: e.message
        });
    }
}
async function $69dd42c1497226e6$var$operationStartCredentialRequest(resolvedOffer, credential, userCode, dispatcher) {
    const abortController = new AbortController();
    try {
        const signingKeyPair = await (0, $c02206712fb92858$export$48ab3e8a44de5f81);
        dispatcher({
            type: "start-credential-request",
            abortController: abortController
        });
        const offerResult = await (0, $c02206712fb92858$export$61c3b26555c145ea).continueHandleOffer(resolvedOffer, [
            credential
        ], userCode, signingKeyPair, abortController.signal);
        if (offerResult.issuedCredentials) {
            const issuedCredential = offerResult.issuedCredentials[0];
            if (!issuedCredential || offerResult.issuedCredentials.length > 1) dispatcher({
                type: "error",
                message: "response must have a single credential"
            });
            dispatcher({
                type: "credential-issued",
                credential: issuedCredential
            });
        } else dispatcher({
            type: "error",
            message: "offer or user code invalid"
        });
    } catch (error) {
        dispatcher({
            type: "error",
            message: error.message
        });
    }
}
function $69dd42c1497226e6$var$operationCancel(state, dispatcher) {
    if (state.state === "waiting-for-offer-handling" || state.state === "waiting-for-credential-issuance") {
        dispatcher({
            type: "cancel"
        });
        state.abortController.abort((0, $8b4eb369eb8605c9$exports.newUserCancellationException)());
    }
}
function $69dd42c1497226e6$export$eafe3800aa6503f9() {
    const [state, dispatcher] = (0, $acw62.useReducer)($69dd42c1497226e6$var$reducer, {
        state: "begin"
    });
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        const offer = "openid-credential-offer://" + location.search;
        const abortController = new AbortController();
        $69dd42c1497226e6$var$operationStartOfferHandling(offer, dispatcher, abortController);
        return ()=>{
            // This will happen when the component is unmounted, so we consider it a user cancellation
            abortController.abort((0, $8b4eb369eb8605c9$exports.newUserCancellationException)());
        };
    }, [
        location.search
    ]);
    return $69dd42c1497226e6$var$render(state, dispatcher);
}
function $69dd42c1497226e6$var$renderBegin(state, dispatcher) {
    const onSubmit = (ev)=>{
        ev.preventDefault();
        $69dd42c1497226e6$var$operationStartOfferHandling(state.offer, dispatcher);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Retrieving Offer"
            }),
            state.errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "Error when Retrieving Offer",
                errorMessage: state.errorMessage
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "button button-primary-outline w100",
                    type: "submit",
                    children: "Retry retrieve offer"
                })
            })
        ]
    });
}
function $69dd42c1497226e6$var$renderWaitingForOfferHandling(state, dispatcher) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Resolving offer..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>$69dd42c1497226e6$var$operationCancel(state, dispatcher),
                children: "Cancel"
            })
        ]
    });
}
function $69dd42c1497226e6$var$renderShowOffer(state, dispatcher) {
    const credentialSupported = state.resolvedOffer.credentialsSupported[0];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $69fbcf1ee0c90a58$export$930e19b45454fbda), {
                supportedCredential: credentialSupported,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($69dd42c1497226e6$var$RequestCredential, {
                        buttonText: "Request Credential",
                        txCode: state.resolvedOffer.txCode && {
                            // Using "numeric" if not or "text" if unknown
                            inputMode: (state.resolvedOffer.txCode?.inputMode || "numeric") == "numeric" ? "numeric" : "text",
                            length: state.resolvedOffer.txCode?.length,
                            description: state.resolvedOffer.txCode?.description
                        },
                        onSubmit: (userCode)=>$69dd42c1497226e6$var$operationStartCredentialRequest(state.resolvedOffer, state.resolvedOffer.credentialsSupported[0], userCode, dispatcher)
                    }),
                    state.errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "white",
                        children: [
                            "Error: ",
                            state.errorMessage
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "During the credential request a browser window may be opened to perform authentication and credential issuance consent on the credential issuer."
            })
        ]
    });
}
function $69dd42c1497226e6$var$renderWaitingForCredentialIssuance(state, dispatcher) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69fbcf1ee0c90a58$export$930e19b45454fbda), {
                supportedCredential: state.resolvedOffer.credentialsSupported[0],
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "button button-small button-white-outline button-fullwidth mt2",
                    onClick: ()=>$69dd42c1497226e6$var$operationCancel(state, dispatcher),
                    children: "Cancel"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {})
        ]
    });
}
function $69dd42c1497226e6$var$renderCredentialIssued(state, dispatcher) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Do you want to save this credential in the wallet?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5cd55c368b3a0052$export$be16376032ac4bf), {
                credential: state.credential,
                detailLevel: "detailed"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: "optionalname",
                className: "label block",
                children: "Name (Optional)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "field w100",
                id: "optionalname",
                type: "text",
                value: state.credentialName,
                placeholder: "Credential name",
                onChange: (ev)=>dispatcher({
                        type: "credential-name-assigned",
                        credentialName: ev.target.value
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "button button-primary button-fullwidth mt2",
                onClick: ()=>{
                    const credential = state.credential;
                    if (state.credentialName) credential.withUserDefinedName(state.credentialName);
                    (0, $c02206712fb92858$export$ba679c5cdb4741c4).insert(credential.withUserDefinedName(state.credentialName));
                    dispatcher({
                        type: "credential-stored"
                    });
                },
                children: "Save Credential"
            })
        ]
    });
}
function $69dd42c1497226e6$var$renderCredentialStored() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "This credential is now stored in the wallet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                className: "button button-primary-outline button-medium w100 mb2",
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                children: "View my credentials"
            })
        ]
    });
}
function $69dd42c1497226e6$var$render(state, dispatcher) {
    switch(state.state){
        case "begin":
            return $69dd42c1497226e6$var$renderBegin(state, dispatcher);
        case "waiting-for-offer-handling":
            return $69dd42c1497226e6$var$renderWaitingForOfferHandling(state, dispatcher);
        case "show-offer":
            return $69dd42c1497226e6$var$renderShowOffer(state, dispatcher);
        case "waiting-for-credential-issuance":
            return $69dd42c1497226e6$var$renderWaitingForCredentialIssuance(state, dispatcher);
        case "credential-issued":
            return $69dd42c1497226e6$var$renderCredentialIssued(state, dispatcher);
        case "credential-stored":
            return $69dd42c1497226e6$var$renderCredentialStored();
    }
}
function $69dd42c1497226e6$var$RequestCredential({ buttonText: buttonText, txCode: txCode, onSubmit: onSubmit }) {
    const [input, setInput] = (0, $acw62.useState)("");
    const needsTxCode = !!txCode;
    const minLength = txCode?.length || 2;
    const maxLength = txCode?.length || 20;
    const pattern = txCode?.inputMode == "numeric" || !txCode?.inputMode ? "[0-9]*" : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            needsTxCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "white",
                        children: "Insert provided code for the offer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        className: "field w100",
                        type: "text",
                        pattern: pattern,
                        value: input,
                        minLength: minLength,
                        maxLength: maxLength,
                        onChange: (ev)=>setInput(ev.target.value),
                        placeholder: "Enter code"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "button button-white-outline button-fullwidth mt2",
                onClick: ()=>onSubmit(input),
                disabled: needsTxCode && (input.length < minLength || txCode.length && input.length != txCode.length),
                children: buttonText
            })
        ]
    });
}


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");

class $75fa6a8d357af38e$var$e {
    constructor(a, b, c, d, f){
        this._legacyCanvasSize = $75fa6a8d357af38e$var$e.DEFAULT_CANVAS_SIZE;
        this._preferredCamera = "environment";
        this._maxScansPerSecond = 25;
        this._lastScanTimestamp = -1;
        this._destroyed = this._flashOn = this._paused = this._active = !1;
        this.$video = a;
        this.$canvas = document.createElement("canvas");
        c && "object" === typeof c ? this._onDecode = b : (c || d || f ? console.warn("You're using a deprecated version of the QrScanner constructor which will be removed in the future") : console.warn("Note that the type of the scan result passed to onDecode will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true."), this._legacyOnDecode = b);
        b = "object" === typeof c ? c : {};
        this._onDecodeError = b.onDecodeError || ("function" === typeof c ? c : this._onDecodeError);
        this._calculateScanRegion = b.calculateScanRegion || ("function" === typeof d ? d : this._calculateScanRegion);
        this._preferredCamera = b.preferredCamera || f || this._preferredCamera;
        this._legacyCanvasSize = "number" === typeof c ? c : "number" === typeof d ? d : this._legacyCanvasSize;
        this._maxScansPerSecond = b.maxScansPerSecond || this._maxScansPerSecond;
        this._onPlay = this._onPlay.bind(this);
        this._onLoadedMetaData = this._onLoadedMetaData.bind(this);
        this._onVisibilityChange = this._onVisibilityChange.bind(this);
        this._updateOverlay = this._updateOverlay.bind(this);
        a.disablePictureInPicture = !0;
        a.playsInline = !0;
        a.muted = !0;
        let h = !1;
        a.hidden && (a.hidden = !1, h = !0);
        document.body.contains(a) || (document.body.appendChild(a), h = !0);
        c = a.parentElement;
        if (b.highlightScanRegion || b.highlightCodeOutline) {
            d = !!b.overlay;
            this.$overlay = b.overlay || document.createElement("div");
            f = this.$overlay.style;
            f.position = "absolute";
            f.display = "none";
            f.pointerEvents = "none";
            this.$overlay.classList.add("scan-region-highlight");
            if (!d && b.highlightScanRegion) {
                this.$overlay.innerHTML = '<svg class="scan-region-highlight-svg" viewBox="0 0 238 238" preserveAspectRatio="none" style="position:absolute;width:100%;height:100%;left:0;top:0;fill:none;stroke:#e9b213;stroke-width:4;stroke-linecap:round;stroke-linejoin:round"><path d="M31 2H10a8 8 0 0 0-8 8v21M207 2h21a8 8 0 0 1 8 8v21m0 176v21a8 8 0 0 1-8 8h-21m-176 0H10a8 8 0 0 1-8-8v-21"/></svg>';
                try {
                    this.$overlay.firstElementChild.animate({
                        transform: [
                            "scale(.98)",
                            "scale(1.01)"
                        ]
                    }, {
                        duration: 400,
                        iterations: Infinity,
                        direction: "alternate",
                        easing: "ease-in-out"
                    });
                } catch (m) {}
                c.insertBefore(this.$overlay, this.$video.nextSibling);
            }
            b.highlightCodeOutline && (this.$overlay.insertAdjacentHTML("beforeend", '<svg class="code-outline-highlight" preserveAspectRatio="none" style="display:none;width:100%;height:100%;fill:none;stroke:#e9b213;stroke-width:5;stroke-dasharray:25;stroke-linecap:round;stroke-linejoin:round"><polygon/></svg>'), this.$codeOutlineHighlight = this.$overlay.lastElementChild);
        }
        this._scanRegion = this._calculateScanRegion(a);
        requestAnimationFrame(()=>{
            let m = window.getComputedStyle(a);
            "none" === m.display && (a.style.setProperty("display", "block", "important"), h = !0);
            "visible" !== m.visibility && (a.style.setProperty("visibility", "visible", "important"), h = !0);
            h && (console.warn("QrScanner has overwritten the video hiding style to avoid Safari stopping the playback."), a.style.opacity = "0", a.style.width = "0", a.style.height = "0", this.$overlay && this.$overlay.parentElement && this.$overlay.parentElement.removeChild(this.$overlay), delete this.$overlay, delete this.$codeOutlineHighlight);
            this.$overlay && this._updateOverlay();
        });
        a.addEventListener("play", this._onPlay);
        a.addEventListener("loadedmetadata", this._onLoadedMetaData);
        document.addEventListener("visibilitychange", this._onVisibilityChange);
        window.addEventListener("resize", this._updateOverlay);
        this._qrEnginePromise = $75fa6a8d357af38e$var$e.createQrEngine();
    }
    static set WORKER_PATH(a) {
        console.warn("Setting QrScanner.WORKER_PATH is not required and not supported anymore. Have a look at the README for new setup instructions.");
    }
    static async hasCamera() {
        try {
            return !!(await $75fa6a8d357af38e$var$e.listCameras(!1)).length;
        } catch (a) {
            return !1;
        }
    }
    static async listCameras(a = !1) {
        if (!navigator.mediaDevices) return [];
        let b = async ()=>(await navigator.mediaDevices.enumerateDevices()).filter((d)=>"videoinput" === d.kind), c;
        try {
            a && (await b()).every((d)=>!d.label) && (c = await navigator.mediaDevices.getUserMedia({
                audio: !1,
                video: !0
            }));
        } catch (d) {}
        try {
            return (await b()).map((d, f)=>({
                    id: d.deviceId,
                    label: d.label || (0 === f ? "Default Camera" : `Camera ${f + 1}`)
                }));
        } finally{
            c && (console.warn("Call listCameras after successfully starting a QR scanner to avoid creating a temporary video stream"), $75fa6a8d357af38e$var$e._stopVideoStream(c));
        }
    }
    async hasFlash() {
        let a;
        try {
            if (this.$video.srcObject) {
                if (!(this.$video.srcObject instanceof MediaStream)) return !1;
                a = this.$video.srcObject;
            } else a = (await this._getCameraStream()).stream;
            return "torch" in a.getVideoTracks()[0].getSettings();
        } catch (b) {
            return !1;
        } finally{
            a && a !== this.$video.srcObject && (console.warn("Call hasFlash after successfully starting the scanner to avoid creating a temporary video stream"), $75fa6a8d357af38e$var$e._stopVideoStream(a));
        }
    }
    isFlashOn() {
        return this._flashOn;
    }
    async toggleFlash() {
        this._flashOn ? await this.turnFlashOff() : await this.turnFlashOn();
    }
    async turnFlashOn() {
        if (!this._flashOn && !this._destroyed && (this._flashOn = !0, this._active && !this._paused)) try {
            if (!await this.hasFlash()) throw "No flash available";
            await this.$video.srcObject.getVideoTracks()[0].applyConstraints({
                advanced: [
                    {
                        torch: !0
                    }
                ]
            });
        } catch (a) {
            throw this._flashOn = !1, a;
        }
    }
    async turnFlashOff() {
        this._flashOn && (this._flashOn = !1, await this._restartVideoStream());
    }
    destroy() {
        this.$video.removeEventListener("loadedmetadata", this._onLoadedMetaData);
        this.$video.removeEventListener("play", this._onPlay);
        document.removeEventListener("visibilitychange", this._onVisibilityChange);
        window.removeEventListener("resize", this._updateOverlay);
        this._destroyed = !0;
        this._flashOn = !1;
        this.stop();
        $75fa6a8d357af38e$var$e._postWorkerMessage(this._qrEnginePromise, "close");
    }
    async start() {
        if (this._destroyed) throw Error("The QR scanner can not be started as it had been destroyed.");
        if (!this._active || this._paused) {
            if ("https:" !== window.location.protocol && console.warn("The camera stream is only accessible if the page is transferred via https."), this._active = !0, !document.hidden) {
                if (this._paused = !1, this.$video.srcObject) await this.$video.play();
                else try {
                    let { stream: a, facingMode: b } = await this._getCameraStream();
                    !this._active || this._paused ? $75fa6a8d357af38e$var$e._stopVideoStream(a) : (this._setVideoMirror(b), this.$video.srcObject = a, await this.$video.play(), this._flashOn && (this._flashOn = !1, this.turnFlashOn().catch(()=>{})));
                } catch (a) {
                    if (!this._paused) throw this._active = !1, a;
                }
            }
        }
    }
    stop() {
        this.pause();
        this._active = !1;
    }
    async pause(a = !1) {
        this._paused = !0;
        if (!this._active) return !0;
        this.$video.pause();
        this.$overlay && (this.$overlay.style.display = "none");
        let b = ()=>{
            this.$video.srcObject instanceof MediaStream && ($75fa6a8d357af38e$var$e._stopVideoStream(this.$video.srcObject), this.$video.srcObject = null);
        };
        if (a) return b(), !0;
        await new Promise((c)=>setTimeout(c, 300));
        if (!this._paused) return !1;
        b();
        return !0;
    }
    async setCamera(a) {
        a !== this._preferredCamera && (this._preferredCamera = a, await this._restartVideoStream());
    }
    static async scanImage(a, b, c, d, f = !1, h = !1) {
        let m, n = !1;
        b && ("scanRegion" in b || "qrEngine" in b || "canvas" in b || "disallowCanvasResizing" in b || "alsoTryWithoutScanRegion" in b || "returnDetailedScanResult" in b) ? (m = b.scanRegion, c = b.qrEngine, d = b.canvas, f = b.disallowCanvasResizing || !1, h = b.alsoTryWithoutScanRegion || !1, n = !0) : b || c || d || f || h ? console.warn("You're using a deprecated api for scanImage which will be removed in the future.") : console.warn("Note that the return type of scanImage will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true.");
        b = !!c;
        try {
            let p, k;
            [c, p] = await Promise.all([
                c || $75fa6a8d357af38e$var$e.createQrEngine(),
                $75fa6a8d357af38e$var$e._loadImage(a)
            ]);
            [d, k] = $75fa6a8d357af38e$var$e._drawToCanvas(p, m, d, f);
            let q;
            if (c instanceof Worker) {
                let g = c;
                b || $75fa6a8d357af38e$var$e._postWorkerMessageSync(g, "inversionMode", "both");
                q = await new Promise((l, v)=>{
                    let w, u, r, y = -1;
                    u = (t)=>{
                        t.data.id === y && (g.removeEventListener("message", u), g.removeEventListener("error", r), clearTimeout(w), null !== t.data.data ? l({
                            data: t.data.data,
                            cornerPoints: $75fa6a8d357af38e$var$e._convertPoints(t.data.cornerPoints, m)
                        }) : v($75fa6a8d357af38e$var$e.NO_QR_CODE_FOUND));
                    };
                    r = (t)=>{
                        g.removeEventListener("message", u);
                        g.removeEventListener("error", r);
                        clearTimeout(w);
                        v("Scanner error: " + (t ? t.message || t : "Unknown Error"));
                    };
                    g.addEventListener("message", u);
                    g.addEventListener("error", r);
                    w = setTimeout(()=>r("timeout"), 1E4);
                    let x = k.getImageData(0, 0, d.width, d.height);
                    y = $75fa6a8d357af38e$var$e._postWorkerMessageSync(g, "decode", x, [
                        x.data.buffer
                    ]);
                });
            } else q = await Promise.race([
                new Promise((g, l)=>window.setTimeout(()=>l("Scanner error: timeout"), 1E4)),
                (async ()=>{
                    try {
                        var [g] = await c.detect(d);
                        if (!g) throw $75fa6a8d357af38e$var$e.NO_QR_CODE_FOUND;
                        return {
                            data: g.rawValue,
                            cornerPoints: $75fa6a8d357af38e$var$e._convertPoints(g.cornerPoints, m)
                        };
                    } catch (l) {
                        g = l.message || l;
                        if (/not implemented|service unavailable/.test(g)) return $75fa6a8d357af38e$var$e._disableBarcodeDetector = !0, $75fa6a8d357af38e$var$e.scanImage(a, {
                            scanRegion: m,
                            canvas: d,
                            disallowCanvasResizing: f,
                            alsoTryWithoutScanRegion: h
                        });
                        throw `Scanner error: ${g}`;
                    }
                })()
            ]);
            return n ? q : q.data;
        } catch (p) {
            if (!m || !h) throw p;
            let k = await $75fa6a8d357af38e$var$e.scanImage(a, {
                qrEngine: c,
                canvas: d,
                disallowCanvasResizing: f
            });
            return n ? k : k.data;
        } finally{
            b || $75fa6a8d357af38e$var$e._postWorkerMessage(c, "close");
        }
    }
    setGrayscaleWeights(a, b, c, d = !0) {
        $75fa6a8d357af38e$var$e._postWorkerMessage(this._qrEnginePromise, "grayscaleWeights", {
            red: a,
            green: b,
            blue: c,
            useIntegerApproximation: d
        });
    }
    setInversionMode(a) {
        $75fa6a8d357af38e$var$e._postWorkerMessage(this._qrEnginePromise, "inversionMode", a);
    }
    static async createQrEngine(a) {
        a && console.warn("Specifying a worker path is not required and not supported anymore.");
        a = ()=>(parcelRequire("8zRdb")).then((c)=>c.createWorker());
        if (!(!$75fa6a8d357af38e$var$e._disableBarcodeDetector && "BarcodeDetector" in window && BarcodeDetector.getSupportedFormats && (await BarcodeDetector.getSupportedFormats()).includes("qr_code"))) return a();
        let b = navigator.userAgentData;
        return b && b.brands.some(({ brand: c })=>/Chromium/i.test(c)) && /mac ?OS/i.test(b.platform) && await b.getHighEntropyValues([
            "architecture",
            "platformVersion"
        ]).then(({ architecture: c, platformVersion: d })=>/arm/i.test(c || "arm") && 13 <= parseInt(d || "13")).catch(()=>!0) ? a() : new BarcodeDetector({
            formats: [
                "qr_code"
            ]
        });
    }
    _onPlay() {
        this._scanRegion = this._calculateScanRegion(this.$video);
        this._updateOverlay();
        this.$overlay && (this.$overlay.style.display = "");
        this._scanFrame();
    }
    _onLoadedMetaData() {
        this._scanRegion = this._calculateScanRegion(this.$video);
        this._updateOverlay();
    }
    _onVisibilityChange() {
        document.hidden ? this.pause() : this._active && this.start();
    }
    _calculateScanRegion(a) {
        let b = Math.round(2 / 3 * Math.min(a.videoWidth, a.videoHeight));
        return {
            x: Math.round((a.videoWidth - b) / 2),
            y: Math.round((a.videoHeight - b) / 2),
            width: b,
            height: b,
            downScaledWidth: this._legacyCanvasSize,
            downScaledHeight: this._legacyCanvasSize
        };
    }
    _updateOverlay() {
        requestAnimationFrame(()=>{
            if (this.$overlay) {
                var a = this.$video, b = a.videoWidth, c = a.videoHeight, d = a.offsetWidth, f = a.offsetHeight, h = a.offsetLeft, m = a.offsetTop, n = window.getComputedStyle(a), p = n.objectFit, k = b / c, q = d / f;
                switch(p){
                    case "none":
                        var g = b;
                        var l = c;
                        break;
                    case "fill":
                        g = d;
                        l = f;
                        break;
                    default:
                        ("cover" === p ? k > q : k < q) ? (l = f, g = l * k) : (g = d, l = g / k), "scale-down" === p && (g = Math.min(g, b), l = Math.min(l, c));
                }
                var [v, w] = n.objectPosition.split(" ").map((r, y)=>{
                    const x = parseFloat(r);
                    return r.endsWith("%") ? (y ? f - l : d - g) * x / 100 : x;
                });
                n = this._scanRegion.width || b;
                q = this._scanRegion.height || c;
                p = this._scanRegion.x || 0;
                var u = this._scanRegion.y || 0;
                k = this.$overlay.style;
                k.width = `${n / b * g}px`;
                k.height = `${q / c * l}px`;
                k.top = `${m + w + u / c * l}px`;
                c = /scaleX\(-1\)/.test(a.style.transform);
                k.left = `${h + (c ? d - v - g : v) + (c ? b - p - n : p) / b * g}px`;
                k.transform = a.style.transform;
            }
        });
    }
    static _convertPoints(a, b) {
        if (!b) return a;
        let c = b.x || 0, d = b.y || 0, f = b.width && b.downScaledWidth ? b.width / b.downScaledWidth : 1;
        b = b.height && b.downScaledHeight ? b.height / b.downScaledHeight : 1;
        for (let h of a)h.x = h.x * f + c, h.y = h.y * b + d;
        return a;
    }
    _scanFrame() {
        !this._active || this.$video.paused || this.$video.ended || ("requestVideoFrameCallback" in this.$video ? this.$video.requestVideoFrameCallback.bind(this.$video) : requestAnimationFrame)(async ()=>{
            if (!(1 >= this.$video.readyState)) {
                var a = Date.now() - this._lastScanTimestamp, b = 1E3 / this._maxScansPerSecond;
                a < b && await new Promise((d)=>setTimeout(d, b - a));
                this._lastScanTimestamp = Date.now();
                try {
                    var c = await $75fa6a8d357af38e$var$e.scanImage(this.$video, {
                        scanRegion: this._scanRegion,
                        qrEngine: this._qrEnginePromise,
                        canvas: this.$canvas
                    });
                } catch (d) {
                    if (!this._active) return;
                    this._onDecodeError(d);
                }
                !$75fa6a8d357af38e$var$e._disableBarcodeDetector || await this._qrEnginePromise instanceof Worker || (this._qrEnginePromise = $75fa6a8d357af38e$var$e.createQrEngine());
                c ? (this._onDecode ? this._onDecode(c) : this._legacyOnDecode && this._legacyOnDecode(c.data), this.$codeOutlineHighlight && (clearTimeout(this._codeOutlineHighlightRemovalTimeout), this._codeOutlineHighlightRemovalTimeout = void 0, this.$codeOutlineHighlight.setAttribute("viewBox", `${this._scanRegion.x || 0} ` + `${this._scanRegion.y || 0} ` + `${this._scanRegion.width || this.$video.videoWidth} ` + `${this._scanRegion.height || this.$video.videoHeight}`), this.$codeOutlineHighlight.firstElementChild.setAttribute("points", c.cornerPoints.map(({ x: d, y: f })=>`${d},${f}`).join(" ")), this.$codeOutlineHighlight.style.display = "")) : this.$codeOutlineHighlight && !this._codeOutlineHighlightRemovalTimeout && (this._codeOutlineHighlightRemovalTimeout = setTimeout(()=>this.$codeOutlineHighlight.style.display = "none", 100));
            }
            this._scanFrame();
        });
    }
    _onDecodeError(a) {
        a !== $75fa6a8d357af38e$var$e.NO_QR_CODE_FOUND && console.log(a);
    }
    async _getCameraStream() {
        if (!navigator.mediaDevices) throw "Camera not found.";
        let a = /^(environment|user)$/.test(this._preferredCamera) ? "facingMode" : "deviceId", b = [
            {
                width: {
                    min: 1024
                }
            },
            {
                width: {
                    min: 768
                }
            },
            {}
        ], c = b.map((d)=>Object.assign({}, d, {
                [a]: {
                    exact: this._preferredCamera
                }
            }));
        for (let d of [
            ...c,
            ...b
        ])try {
            let f = await navigator.mediaDevices.getUserMedia({
                video: d,
                audio: !1
            }), h = this._getFacingMode(f) || (d.facingMode ? this._preferredCamera : "environment" === this._preferredCamera ? "user" : "environment");
            return {
                stream: f,
                facingMode: h
            };
        } catch (f) {}
        throw "Camera not found.";
    }
    async _restartVideoStream() {
        let a = this._paused;
        await this.pause(!0) && !a && this._active && await this.start();
    }
    static _stopVideoStream(a) {
        for (let b of a.getTracks())b.stop(), a.removeTrack(b);
    }
    _setVideoMirror(a) {
        this.$video.style.transform = "scaleX(" + ("user" === a ? -1 : 1) + ")";
    }
    _getFacingMode(a) {
        return (a = a.getVideoTracks()[0]) ? /rear|back|environment/i.test(a.label) ? "environment" : /front|user|face/i.test(a.label) ? "user" : null : null;
    }
    static _drawToCanvas(a, b, c, d = !1) {
        c = c || document.createElement("canvas");
        let f = b && b.x ? b.x : 0, h = b && b.y ? b.y : 0, m = b && b.width ? b.width : a.videoWidth || a.width, n = b && b.height ? b.height : a.videoHeight || a.height;
        d || (d = b && b.downScaledWidth ? b.downScaledWidth : m, b = b && b.downScaledHeight ? b.downScaledHeight : n, c.width !== d && (c.width = d), c.height !== b && (c.height = b));
        b = c.getContext("2d", {
            alpha: !1
        });
        b.imageSmoothingEnabled = !1;
        b.drawImage(a, f, h, m, n, 0, 0, c.width, c.height);
        return [
            c,
            b
        ];
    }
    static async _loadImage(a) {
        if (a instanceof Image) return await $75fa6a8d357af38e$var$e._awaitImageLoad(a), a;
        if (a instanceof HTMLVideoElement || a instanceof HTMLCanvasElement || a instanceof SVGImageElement || "OffscreenCanvas" in window && a instanceof OffscreenCanvas || "ImageBitmap" in window && a instanceof ImageBitmap) return a;
        if (a instanceof File || a instanceof Blob || a instanceof URL || "string" === typeof a) {
            let b = new Image;
            b.src = a instanceof File || a instanceof Blob ? URL.createObjectURL(a) : a.toString();
            try {
                return await $75fa6a8d357af38e$var$e._awaitImageLoad(b), b;
            } finally{
                (a instanceof File || a instanceof Blob) && URL.revokeObjectURL(b.src);
            }
        } else throw "Unsupported image type.";
    }
    static async _awaitImageLoad(a) {
        a.complete && 0 !== a.naturalWidth || await new Promise((b, c)=>{
            let d = (f)=>{
                a.removeEventListener("load", d);
                a.removeEventListener("error", d);
                f instanceof ErrorEvent ? c("Image load error") : b();
            };
            a.addEventListener("load", d);
            a.addEventListener("error", d);
        });
    }
    static async _postWorkerMessage(a, b, c, d) {
        return $75fa6a8d357af38e$var$e._postWorkerMessageSync(await a, b, c, d);
    }
    static _postWorkerMessageSync(a, b, c, d) {
        if (!(a instanceof Worker)) return -1;
        let f = $75fa6a8d357af38e$var$e._workerMessageId++;
        a.postMessage({
            id: f,
            type: b,
            data: c
        }, d);
        return f;
    }
}
$75fa6a8d357af38e$var$e.DEFAULT_CANVAS_SIZE = 400;
$75fa6a8d357af38e$var$e.NO_QR_CODE_FOUND = "No QR code found";
$75fa6a8d357af38e$var$e._disableBarcodeDetector = !1;
$75fa6a8d357af38e$var$e._workerMessageId = 0;
var $75fa6a8d357af38e$export$2e2bcd8739ae039 = $75fa6a8d357af38e$var$e;






function $c475912c2fba10b1$var$parseQrCode(code) {
    try {
        const url = new URL(code);
        const searchParams = url.searchParams;
        if (url.protocol === "openid-credential-offer:") {
            if (searchParams.has("credential_offer") || searchParams.has("credential_offer_uri")) return {
                tag: "valid-offer",
                queryString: url.search.substring(1)
            };
            return {
                tag: "error",
                message: "missing required parameters"
            };
        } else if (searchParams.has("request_uri")) return {
            tag: "valid-presentation",
            queryString: url.search.substring(1)
        };
        return {
            tag: "error",
            message: "URI not recognized"
        };
    } catch (error) {
        return {
            tag: "error",
            message: "not an URI"
        };
    }
}
function $c475912c2fba10b1$var$reducer(state, action) {
    if (action.type === "unrecoverable-error") return {
        tag: "unrecoverable-error",
        message: action.message
    };
    switch(state.tag){
        case "start":
            if (action.type === "started-scan") return {
                tag: "scanning",
                message: "scanning"
            };
            return state;
        case "scanning":
            if (action.type === "scan-event") return {
                tag: "scanning",
                message: action.message
            };
            else if (action.type === "scanned-offer") return {
                tag: "scanned-offer",
                queryString: action.queryString
            };
            else if (action.type === "scanned-presentation") return {
                tag: "scanned-presentation",
                queryString: action.queryString
            };
            return state;
        case "unrecoverable-error":
        case "scanned-offer":
        case "scanned-presentation":
            // end state
            return state;
    }
}
function $c475912c2fba10b1$var$renderMessage(state) {
    switch(state.tag){
        case "start":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {});
        case "scanning":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "Scanning: ",
                    state.message
                ]
            });
        case "unrecoverable-error":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Unrecoverable error"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        className: "button button-medium button-transparent button-fullwidth",
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        children: "Cancel"
                    })
                ]
            });
        case "scanned-offer":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_OFFER_RESOLVE(state.queryString)
            });
        case "scanned-presentation":
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_PRESENTATION_RESOLVE(state.queryString)
            });
    }
}
const $c475912c2fba10b1$export$f2b7c70641756fd4 = ()=>{
    const webcamRef = (0, $acw62.useRef)(null);
    const [state, dispatch] = (0, $acw62.useReducer)($c475912c2fba10b1$var$reducer, {
        tag: "start"
    });
    (0, $acw62.useEffect)(()=>{
        const currentWebcamRef = webcamRef.current;
        if (!currentWebcamRef) {
            dispatch({
                type: "unrecoverable-error",
                message: "unexpected error: video ref is undefined"
            });
            return;
        }
        let qrScanner;
        const startWebcam = async ()=>{
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: "environment"
                    }
                });
                currentWebcamRef.srcObject = stream;
                qrScanner = new (0, $75fa6a8d357af38e$export$2e2bcd8739ae039)(currentWebcamRef, (result)=>{
                    const parseResult = $c475912c2fba10b1$var$parseQrCode(result.data);
                    if (parseResult.tag === "valid-offer") {
                        dispatch({
                            type: "scanned-offer",
                            queryString: parseResult.queryString
                        });
                        qrScanner.stop();
                        qrScanner.destroy();
                        qrScanner = null;
                    } else if (parseResult.tag === "valid-presentation") {
                        dispatch({
                            type: "scanned-presentation",
                            queryString: parseResult.queryString
                        });
                        qrScanner.stop();
                        qrScanner.destroy();
                        qrScanner = null;
                    } else dispatch({
                        type: "scan-event",
                        message: `invalid QR code '${parseResult.message}', continuing`
                    });
                }, {
                    onDecodeError: ()=>{
                        dispatch({
                            type: "scan-event",
                            message: `unable to scan, continuing...`
                        });
                    },
                    maxScansPerSecond: 10,
                    highlightCodeOutline: true,
                    highlightScanRegion: true
                });
                await qrScanner.start();
                dispatch({
                    type: "started-scan"
                });
            } catch (error) {
                dispatch({
                    type: "unrecoverable-error",
                    message: "unable to access camera"
                });
            }
        };
        startWebcam();
        return ()=>{
            const tracks = currentWebcamRef.srcObject?.getTracks() || [];
            tracks.forEach((track)=>track.stop());
            if (qrScanner) {
                qrScanner.stop();
                qrScanner.destroy();
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("video", {
                className: `${$50f3fed48a2d60a0$export$5f8d3589eb8441ca} br-8`,
                ref: webcamRef,
                autoPlay: true,
                playsInline: true
            }),
            $c475912c2fba10b1$var$renderMessage(state)
        ]
    });
};


/*
 * Copyright (C) 2023 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");

var $9a0ca9bdc2920152$export$70cc9a28a6c819c0;
var $9a0ca9bdc2920152$export$9c6be21ba6891a6d;
var $9a0ca9bdc2920152$export$a3ff96a524f373ff;
var $9a0ca9bdc2920152$export$61419bb05c687ee3;
$9a0ca9bdc2920152$export$70cc9a28a6c819c0 = `xzc0LG_debug-pane`;
$9a0ca9bdc2920152$export$9c6be21ba6891a6d = `xzc0LG_debug-pane-close`;
$9a0ca9bdc2920152$export$a3ff96a524f373ff = `xzc0LG_debug-pane-header`;
$9a0ca9bdc2920152$export$61419bb05c687ee3 = `xzc0LG_debug-pane-minimized`;



var $acw62 = parcelRequire("acw62");
var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bc9a7bbcf9a2a3b$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;


var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1e0ecff44bad0ea1$exports(arr);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1e0ecff44bad0ea1$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1e0ecff44bad0ea1$exports(o, minLen);
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(arr) {
    return $41f5c206613f56c9$exports(arr) || $cce79e023a3a67e7$exports(arr) || $51f08ebed50a2438$exports(arr) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;


var $bb7ca61ce45563c4$exports = {};
var $010f4e0e13c82e16$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $010f4e0e13c82e16$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
var $b77c8068776c2a21$exports = {};

var $b77c8068776c2a21$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : String(i);
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $010f4e0e13c82e16$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;



var $acw62 = parcelRequire("acw62");
var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;




var $acw62 = parcelRequire("acw62");
function $35b076aa3d5f5fcb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $35b076aa3d5f5fcb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $35b076aa3d5f5fcb$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $35b076aa3d5f5fcb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $35b076aa3d5f5fcb$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $35b076aa3d5f5fcb$var$classNameCombinations = {};
function $35b076aa3d5f5fcb$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join(".");
    if (!$35b076aa3d5f5fcb$var$classNameCombinations[key]) $35b076aa3d5f5fcb$var$classNameCombinations[key] = $35b076aa3d5f5fcb$var$powerSetPermutations(classNames);
    return $35b076aa3d5f5fcb$var$classNameCombinations[key];
}
function $35b076aa3d5f5fcb$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== "token";
    });
    var classNamesCombinations = $35b076aa3d5f5fcb$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(" ");
}
function $35b076aa3d5f5fcb$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $35b076aa3d5f5fcb$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $35b076aa3d5f5fcb$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === "text") return value;
    else if (TagName) {
        var childrenCreator = $35b076aa3d5f5fcb$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, properties), {}, {
            className: $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split(".").forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes("token") ? [
                "token"
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $35b076aa3d5f5fcb$var$_objectSpread($35b076aa3d5f5fcb$var$_objectSpread({}, properties), {}, {
                className: $35b076aa3d5f5fcb$export$d0f1f443a3b7b5(className) || undefined,
                style: $35b076aa3d5f5fcb$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TagName, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({
            key: key
        }, props), children);
    }
}


var $20f4867013ee8e7f$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};


var $b94dbc74b29e9f13$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $b94dbc74b29e9f13$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b94dbc74b29e9f13$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b94dbc74b29e9f13$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b94dbc74b29e9f13$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b94dbc74b29e9f13$var$newLineRegex = /\n/g;
function $b94dbc74b29e9f13$var$getNewLines(str) {
    return str.match($b94dbc74b29e9f13$var$newLineRegex);
}
function $b94dbc74b29e9f13$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === "function" ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $b94dbc74b29e9f13$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": "left",
        paddingRight: "10px"
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $b94dbc74b29e9f13$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, "").split("\n"),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $b94dbc74b29e9f13$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: "element",
        tagName: "span",
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                "comment",
                "linenumber",
                "react-syntax-highlighter-line-number"
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: "text",
                value: lineNumber
            }
        ]
    };
}
function $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: "inline-block",
        minWidth: $b94dbc74b29e9f13$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: "1em",
        textAlign: "right",
        userSelect: "none"
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === "function" ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $b94dbc74b29e9f13$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === "function" ? lineProps(lineNumber) : lineProps;
    properties["className"] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, properties.style), {}, {
        display: "flex"
    });
    return {
        type: "element",
        tagName: "span",
        properties: properties,
        children: children
    };
}
function $b94dbc74b29e9f13$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === "text") newTree.push($b94dbc74b29e9f13$var$createLineElement({
            children: [
                node
            ],
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            $b94dbc74b29e9f13$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $b94dbc74b29e9f13$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $b94dbc74b29e9f13$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $b94dbc74b29e9f13$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $b94dbc74b29e9f13$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($b94dbc74b29e9f13$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $b94dbc74b29e9f13$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split("\n");
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: "text",
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($b94dbc74b29e9f13$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: "text",
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $b94dbc74b29e9f13$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $b94dbc74b29e9f13$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $35b076aa3d5f5fcb$export$2e2bcd8739ae039)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function $b94dbc74b29e9f13$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== "undefined";
}
function $b94dbc74b29e9f13$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($b94dbc74b29e9f13$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $20f4867013ee8e7f$export$2e2bcd8739ae039)(astGenerator, language);
        if (language === "text") return {
            value: defaultCodeValue,
            language: "text"
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== "text" ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $b94dbc74b29e9f13$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref7, $b94dbc74b29e9f13$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b94dbc74b29e9f13$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: "#fff"
        };
        var generatorClassName = $b94dbc74b29e9f13$var$isHighlightJs(astGenerator) ? "hljs" : "prismjs";
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre-wrap"
        });
        else codeTagProps.style = $b94dbc74b29e9f13$var$_objectSpread($b94dbc74b29e9f13$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre"
        });
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $b94dbc74b29e9f13$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: "text",
                value: code
            }
        ];
        var codeTree = $b94dbc74b29e9f13$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
         // determine largest line number so that we can force minWidth on all linenumber elements
        var largestLineNumber = codeTree.value.length + startingLineNumber;
        var rows = $b94dbc74b29e9f13$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}


var $52d829bfc3e728d7$export$2e2bcd8739ae039 = {
    "hljs": {
        "display": "block",
        "overflowX": "auto",
        "padding": "0.5em",
        "background": "#F0F0F0",
        "color": "#444"
    },
    "hljs-subst": {
        "color": "#444"
    },
    "hljs-comment": {
        "color": "#888888"
    },
    "hljs-keyword": {
        "fontWeight": "bold"
    },
    "hljs-attribute": {
        "fontWeight": "bold"
    },
    "hljs-selector-tag": {
        "fontWeight": "bold"
    },
    "hljs-meta-keyword": {
        "fontWeight": "bold"
    },
    "hljs-doctag": {
        "fontWeight": "bold"
    },
    "hljs-name": {
        "fontWeight": "bold"
    },
    "hljs-type": {
        "color": "#880000"
    },
    "hljs-string": {
        "color": "#880000"
    },
    "hljs-number": {
        "color": "#880000"
    },
    "hljs-selector-id": {
        "color": "#880000"
    },
    "hljs-selector-class": {
        "color": "#880000"
    },
    "hljs-quote": {
        "color": "#880000"
    },
    "hljs-template-tag": {
        "color": "#880000"
    },
    "hljs-deletion": {
        "color": "#880000"
    },
    "hljs-title": {
        "color": "#880000",
        "fontWeight": "bold"
    },
    "hljs-section": {
        "color": "#880000",
        "fontWeight": "bold"
    },
    "hljs-regexp": {
        "color": "#BC6060"
    },
    "hljs-symbol": {
        "color": "#BC6060"
    },
    "hljs-variable": {
        "color": "#BC6060"
    },
    "hljs-template-variable": {
        "color": "#BC6060"
    },
    "hljs-link": {
        "color": "#BC6060"
    },
    "hljs-selector-attr": {
        "color": "#BC6060"
    },
    "hljs-selector-pseudo": {
        "color": "#BC6060"
    },
    "hljs-literal": {
        "color": "#78A960"
    },
    "hljs-built_in": {
        "color": "#397300"
    },
    "hljs-bullet": {
        "color": "#397300"
    },
    "hljs-code": {
        "color": "#397300"
    },
    "hljs-addition": {
        "color": "#397300"
    },
    "hljs-meta": {
        "color": "#1f7199"
    },
    "hljs-meta-string": {
        "color": "#4d99bf"
    },
    "hljs-emphasis": {
        "fontStyle": "italic"
    },
    "hljs-strong": {
        "fontWeight": "bold"
    }
};


var $ea32d90378aa2fb5$exports = {};
"use strict";
var $bd598f23a65af4c7$exports = {};

$parcel$export($bd598f23a65af4c7$exports, "highlight", () => $bd598f23a65af4c7$export$e4043f67d36cbb26, (v) => $bd598f23a65af4c7$export$e4043f67d36cbb26 = v);
$parcel$export($bd598f23a65af4c7$exports, "highlightAuto", () => $bd598f23a65af4c7$export$a6bd8adaea6db17d, (v) => $bd598f23a65af4c7$export$a6bd8adaea6db17d = v);
$parcel$export($bd598f23a65af4c7$exports, "registerLanguage", () => $bd598f23a65af4c7$export$b5daeabefb05ee6b, (v) => $bd598f23a65af4c7$export$b5daeabefb05ee6b = v);
$parcel$export($bd598f23a65af4c7$exports, "listLanguages", () => $bd598f23a65af4c7$export$bef285e71abac9c, (v) => $bd598f23a65af4c7$export$bef285e71abac9c = v);
$parcel$export($bd598f23a65af4c7$exports, "registerAlias", () => $bd598f23a65af4c7$export$51e83cf7ba679d8d, (v) => $bd598f23a65af4c7$export$51e83cf7ba679d8d = v);
var $bd598f23a65af4c7$export$e4043f67d36cbb26;
var $bd598f23a65af4c7$export$a6bd8adaea6db17d;
var $bd598f23a65af4c7$export$b5daeabefb05ee6b;
var $bd598f23a65af4c7$export$bef285e71abac9c;
var $bd598f23a65af4c7$export$51e83cf7ba679d8d;
"use strict";
var $f4840ac5e98a0872$exports = {};
function $f4840ac5e98a0872$var$deepFreeze(obj) {
    if (obj instanceof Map) obj.clear = obj.delete = obj.set = function() {
        throw new Error("map is read-only");
    };
    else if (obj instanceof Set) obj.add = obj.clear = obj.delete = function() {
        throw new Error("set is read-only");
    };
    // Freeze self
    Object.freeze(obj);
    Object.getOwnPropertyNames(obj).forEach(function(name) {
        var prop = obj[name];
        // Freeze prop if it is an object
        if (typeof prop == "object" && !Object.isFrozen(prop)) $f4840ac5e98a0872$var$deepFreeze(prop);
    });
    return obj;
}
var $f4840ac5e98a0872$var$deepFreezeEs6 = $f4840ac5e98a0872$var$deepFreeze;
var $f4840ac5e98a0872$var$_default = $f4840ac5e98a0872$var$deepFreeze;
$f4840ac5e98a0872$var$deepFreezeEs6.default = $f4840ac5e98a0872$var$_default;
/** @implements CallbackResponse */ class $f4840ac5e98a0872$var$Response {
    /**
   * @param {CompiledMode} mode
   */ constructor(mode){
        // eslint-disable-next-line no-undefined
        if (mode.data === undefined) mode.data = {};
        this.data = mode.data;
        this.isMatchIgnored = false;
    }
    ignoreMatch() {
        this.isMatchIgnored = true;
    }
}
/**
 * @param {string} value
 * @returns {string}
 */ function $f4840ac5e98a0872$var$escapeHTML(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
/**
 * performs a shallow merge of multiple objects into one
 *
 * @template T
 * @param {T} original
 * @param {Record<string,any>[]} objects
 * @returns {T} a single new object
 */ function $f4840ac5e98a0872$var$inherit(original, ...objects) {
    /** @type Record<string,any> */ const result = Object.create(null);
    for(const key in original)result[key] = original[key];
    objects.forEach(function(obj) {
        for(const key in obj)result[key] = obj[key];
    });
    return /** @type {T} */ result;
}
/**
 * @typedef {object} Renderer
 * @property {(text: string) => void} addText
 * @property {(node: Node) => void} openNode
 * @property {(node: Node) => void} closeNode
 * @property {() => string} value
 */ /** @typedef {{kind?: string, sublanguage?: boolean}} Node */ /** @typedef {{walk: (r: Renderer) => void}} Tree */ /** */ const $f4840ac5e98a0872$var$SPAN_CLOSE = "</span>";
/**
 * Determines if a node needs to be wrapped in <span>
 *
 * @param {Node} node */ const $f4840ac5e98a0872$var$emitsWrappingTags = (node)=>{
    return !!node.kind;
};
/** @type {Renderer} */ class $f4840ac5e98a0872$var$HTMLRenderer {
    /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */ constructor(parseTree, options){
        this.buffer = "";
        this.classPrefix = options.classPrefix;
        parseTree.walk(this);
    }
    /**
   * Adds texts to the output stream
   *
   * @param {string} text */ addText(text) {
        this.buffer += $f4840ac5e98a0872$var$escapeHTML(text);
    }
    /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */ openNode(node) {
        if (!$f4840ac5e98a0872$var$emitsWrappingTags(node)) return;
        let className = node.kind;
        if (!node.sublanguage) className = `${this.classPrefix}${className}`;
        this.span(className);
    }
    /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */ closeNode(node) {
        if (!$f4840ac5e98a0872$var$emitsWrappingTags(node)) return;
        this.buffer += $f4840ac5e98a0872$var$SPAN_CLOSE;
    }
    /**
   * returns the accumulated buffer
  */ value() {
        return this.buffer;
    }
    // helpers
    /**
   * Builds a span element
   *
   * @param {string} className */ span(className) {
        this.buffer += `<span class="${className}">`;
    }
}
/** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} | string} Node */ /** @typedef {{kind?: string, sublanguage?: boolean, children: Node[]} } DataNode */ /**  */ class $f4840ac5e98a0872$var$TokenTree {
    constructor(){
        /** @type DataNode */ this.rootNode = {
            children: []
        };
        this.stack = [
            this.rootNode
        ];
    }
    get top() {
        return this.stack[this.stack.length - 1];
    }
    get root() {
        return this.rootNode;
    }
    /** @param {Node} node */ add(node) {
        this.top.children.push(node);
    }
    /** @param {string} kind */ openNode(kind) {
        /** @type Node */ const node = {
            kind: kind,
            children: []
        };
        this.add(node);
        this.stack.push(node);
    }
    closeNode() {
        if (this.stack.length > 1) return this.stack.pop();
        // eslint-disable-next-line no-undefined
        return undefined;
    }
    closeAllNodes() {
        while(this.closeNode());
    }
    toJSON() {
        return JSON.stringify(this.rootNode, null, 4);
    }
    /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */ walk(builder) {
        // this does not
        return this.constructor._walk(builder, this.rootNode);
    // this works
    // return TokenTree._walk(builder, this.rootNode);
    }
    /**
   * @param {Renderer} builder
   * @param {Node} node
   */ static _walk(builder, node) {
        if (typeof node === "string") builder.addText(node);
        else if (node.children) {
            builder.openNode(node);
            node.children.forEach((child)=>this._walk(builder, child));
            builder.closeNode(node);
        }
        return builder;
    }
    /**
   * @param {Node} node
   */ static _collapse(node) {
        if (typeof node === "string") return;
        if (!node.children) return;
        if (node.children.every((el)=>typeof el === "string")) // node.text = node.children.join("");
        // delete node.children;
        node.children = [
            node.children.join("")
        ];
        else node.children.forEach((child)=>{
            $f4840ac5e98a0872$var$TokenTree._collapse(child);
        });
    }
}
/**
  Currently this is all private API, but this is the minimal API necessary
  that an Emitter must implement to fully support the parser.

  Minimal interface:

  - addKeyword(text, kind)
  - addText(text)
  - addSublanguage(emitter, subLanguageName)
  - finalize()
  - openNode(kind)
  - closeNode()
  - closeAllNodes()
  - toHTML()

*/ /**
 * @implements {Emitter}
 */ class $f4840ac5e98a0872$var$TokenTreeEmitter extends $f4840ac5e98a0872$var$TokenTree {
    /**
   * @param {*} options
   */ constructor(options){
        super();
        this.options = options;
    }
    /**
   * @param {string} text
   * @param {string} kind
   */ addKeyword(text, kind) {
        if (text === "") return;
        this.openNode(kind);
        this.addText(text);
        this.closeNode();
    }
    /**
   * @param {string} text
   */ addText(text) {
        if (text === "") return;
        this.add(text);
    }
    /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */ addSublanguage(emitter, name) {
        /** @type DataNode */ const node = emitter.root;
        node.kind = name;
        node.sublanguage = true;
        this.add(node);
    }
    toHTML() {
        const renderer = new $f4840ac5e98a0872$var$HTMLRenderer(this, this.options);
        return renderer.value();
    }
    finalize() {
        return true;
    }
}
/**
 * @param {string} value
 * @returns {RegExp}
 * */ function $f4840ac5e98a0872$var$escape(value) {
    return new RegExp(value.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
}
/**
 * @param {RegExp | string } re
 * @returns {string}
 */ function $f4840ac5e98a0872$var$source(re) {
    if (!re) return null;
    if (typeof re === "string") return re;
    return re.source;
}
/**
 * @param {...(RegExp | string) } args
 * @returns {string}
 */ function $f4840ac5e98a0872$var$concat(...args) {
    const joined = args.map((x)=>$f4840ac5e98a0872$var$source(x)).join("");
    return joined;
}
/**
 * Any of the passed expresssions may match
 *
 * Creates a huge this | this | that | that match
 * @param {(RegExp | string)[] } args
 * @returns {string}
 */ function $f4840ac5e98a0872$var$either(...args) {
    const joined = "(" + args.map((x)=>$f4840ac5e98a0872$var$source(x)).join("|") + ")";
    return joined;
}
/**
 * @param {RegExp} re
 * @returns {number}
 */ function $f4840ac5e98a0872$var$countMatchGroups(re) {
    return new RegExp(re.toString() + "|").exec("").length - 1;
}
/**
 * Does lexeme start with a regular expression match at the beginning
 * @param {RegExp} re
 * @param {string} lexeme
 */ function $f4840ac5e98a0872$var$startsWith(re, lexeme) {
    const match = re && re.exec(lexeme);
    return match && match.index === 0;
}
// BACKREF_RE matches an open parenthesis or backreference. To avoid
// an incorrect parse, it additionally matches the following:
// - [...] elements, where the meaning of parentheses and escapes change
// - other escape sequences, so we do not misparse escape sequences as
//   interesting elements
// - non-matching or lookahead parentheses, which do not capture. These
//   follow the '(' with a '?'.
const $f4840ac5e98a0872$var$BACKREF_RE = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
// join logically computes regexps.join(separator), but fixes the
// backreferences so they continue to match.
// it also places each individual regular expression into it's own
// match group, keeping track of the sequencing of those match groups
// is currently an exercise for the caller. :-)
/**
 * @param {(string | RegExp)[]} regexps
 * @param {string} separator
 * @returns {string}
 */ function $f4840ac5e98a0872$var$join(regexps, separator = "|") {
    let numCaptures = 0;
    return regexps.map((regex)=>{
        numCaptures += 1;
        const offset = numCaptures;
        let re = $f4840ac5e98a0872$var$source(regex);
        let out = "";
        while(re.length > 0){
            const match = $f4840ac5e98a0872$var$BACKREF_RE.exec(re);
            if (!match) {
                out += re;
                break;
            }
            out += re.substring(0, match.index);
            re = re.substring(match.index + match[0].length);
            if (match[0][0] === "\\" && match[1]) // Adjust the backreference.
            out += "\\" + String(Number(match[1]) + offset);
            else {
                out += match[0];
                if (match[0] === "(") numCaptures++;
            }
        }
        return out;
    }).map((re)=>`(${re})`).join(separator);
}
// Common regexps
const $f4840ac5e98a0872$var$MATCH_NOTHING_RE = /\b\B/;
const $f4840ac5e98a0872$var$IDENT_RE = "[a-zA-Z]\\w*";
const $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE = "[a-zA-Z_]\\w*";
const $f4840ac5e98a0872$var$NUMBER_RE = "\\b\\d+(\\.\\d+)?";
const $f4840ac5e98a0872$var$C_NUMBER_RE = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)"; // 0x..., 0..., decimal, float
const $f4840ac5e98a0872$var$BINARY_NUMBER_RE = "\\b(0b[01]+)"; // 0b...
const $f4840ac5e98a0872$var$RE_STARTERS_RE = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~";
/**
* @param { Partial<Mode> & {binary?: string | RegExp} } opts
*/ const $f4840ac5e98a0872$var$SHEBANG = (opts = {})=>{
    const beginShebang = /^#![ ]*\//;
    if (opts.binary) opts.begin = $f4840ac5e98a0872$var$concat(beginShebang, /.*\b/, opts.binary, /\b.*/);
    return $f4840ac5e98a0872$var$inherit({
        className: "meta",
        begin: beginShebang,
        end: /$/,
        relevance: 0,
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            if (m.index !== 0) resp.ignoreMatch();
        }
    }, opts);
};
// Common modes
const $f4840ac5e98a0872$var$BACKSLASH_ESCAPE = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
};
const $f4840ac5e98a0872$var$APOS_STRING_MODE = {
    className: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [
        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
    ]
};
const $f4840ac5e98a0872$var$QUOTE_STRING_MODE = {
    className: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [
        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
    ]
};
const $f4840ac5e98a0872$var$PHRASAL_WORDS_MODE = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
};
/**
 * Creates a comment mode
 *
 * @param {string | RegExp} begin
 * @param {string | RegExp} end
 * @param {Mode | {}} [modeOptions]
 * @returns {Partial<Mode>}
 */ const $f4840ac5e98a0872$var$COMMENT = function(begin, end, modeOptions = {}) {
    const mode = $f4840ac5e98a0872$var$inherit({
        className: "comment",
        begin: begin,
        end: end,
        contains: []
    }, modeOptions);
    mode.contains.push($f4840ac5e98a0872$var$PHRASAL_WORDS_MODE);
    mode.contains.push({
        className: "doctag",
        begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
        relevance: 0
    });
    return mode;
};
const $f4840ac5e98a0872$var$C_LINE_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT("//", "$");
const $f4840ac5e98a0872$var$C_BLOCK_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT("/\\*", "\\*/");
const $f4840ac5e98a0872$var$HASH_COMMENT_MODE = $f4840ac5e98a0872$var$COMMENT("#", "$");
const $f4840ac5e98a0872$var$NUMBER_MODE = {
    className: "number",
    begin: $f4840ac5e98a0872$var$NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$C_NUMBER_MODE = {
    className: "number",
    begin: $f4840ac5e98a0872$var$C_NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$BINARY_NUMBER_MODE = {
    className: "number",
    begin: $f4840ac5e98a0872$var$BINARY_NUMBER_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$CSS_NUMBER_MODE = {
    className: "number",
    begin: $f4840ac5e98a0872$var$NUMBER_RE + "(" + "%|em|ex|ch|rem" + "|vw|vh|vmin|vmax" + "|cm|mm|in|pt|pc|px" + "|deg|grad|rad|turn" + "|s|ms" + "|Hz|kHz" + "|dpi|dpcm|dppx" + ")?",
    relevance: 0
};
const $f4840ac5e98a0872$var$REGEXP_MODE = {
    // this outer rule makes sure we actually have a WHOLE regex and not simply
    // an expression such as:
    //
    //     3 / something
    //
    // (which will then blow up when regex's `illegal` sees the newline)
    begin: /(?=\/[^/\n]*\/)/,
    contains: [
        {
            className: "regexp",
            begin: /\//,
            end: /\/[gimuy]*/,
            illegal: /\n/,
            contains: [
                $f4840ac5e98a0872$var$BACKSLASH_ESCAPE,
                {
                    begin: /\[/,
                    end: /\]/,
                    relevance: 0,
                    contains: [
                        $f4840ac5e98a0872$var$BACKSLASH_ESCAPE
                    ]
                }
            ]
        }
    ]
};
const $f4840ac5e98a0872$var$TITLE_MODE = {
    className: "title",
    begin: $f4840ac5e98a0872$var$IDENT_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$UNDERSCORE_TITLE_MODE = {
    className: "title",
    begin: $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
const $f4840ac5e98a0872$var$METHOD_GUARD = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    relevance: 0
};
/**
 * Adds end same as begin mechanics to a mode
 *
 * Your mode must include at least a single () match group as that first match
 * group is what is used for comparison
 * @param {Partial<Mode>} mode
 */ const $f4840ac5e98a0872$var$END_SAME_AS_BEGIN = function(mode) {
    return Object.assign(mode, {
        /** @type {ModeCallback} */ "on:begin": (m, resp)=>{
            resp.data._beginMatch = m[1];
        },
        /** @type {ModeCallback} */ "on:end": (m, resp)=>{
            if (resp.data._beginMatch !== m[1]) resp.ignoreMatch();
        }
    });
};
var $f4840ac5e98a0872$var$MODES = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MATCH_NOTHING_RE: $f4840ac5e98a0872$var$MATCH_NOTHING_RE,
    IDENT_RE: $f4840ac5e98a0872$var$IDENT_RE,
    UNDERSCORE_IDENT_RE: $f4840ac5e98a0872$var$UNDERSCORE_IDENT_RE,
    NUMBER_RE: $f4840ac5e98a0872$var$NUMBER_RE,
    C_NUMBER_RE: $f4840ac5e98a0872$var$C_NUMBER_RE,
    BINARY_NUMBER_RE: $f4840ac5e98a0872$var$BINARY_NUMBER_RE,
    RE_STARTERS_RE: $f4840ac5e98a0872$var$RE_STARTERS_RE,
    SHEBANG: $f4840ac5e98a0872$var$SHEBANG,
    BACKSLASH_ESCAPE: $f4840ac5e98a0872$var$BACKSLASH_ESCAPE,
    APOS_STRING_MODE: $f4840ac5e98a0872$var$APOS_STRING_MODE,
    QUOTE_STRING_MODE: $f4840ac5e98a0872$var$QUOTE_STRING_MODE,
    PHRASAL_WORDS_MODE: $f4840ac5e98a0872$var$PHRASAL_WORDS_MODE,
    COMMENT: $f4840ac5e98a0872$var$COMMENT,
    C_LINE_COMMENT_MODE: $f4840ac5e98a0872$var$C_LINE_COMMENT_MODE,
    C_BLOCK_COMMENT_MODE: $f4840ac5e98a0872$var$C_BLOCK_COMMENT_MODE,
    HASH_COMMENT_MODE: $f4840ac5e98a0872$var$HASH_COMMENT_MODE,
    NUMBER_MODE: $f4840ac5e98a0872$var$NUMBER_MODE,
    C_NUMBER_MODE: $f4840ac5e98a0872$var$C_NUMBER_MODE,
    BINARY_NUMBER_MODE: $f4840ac5e98a0872$var$BINARY_NUMBER_MODE,
    CSS_NUMBER_MODE: $f4840ac5e98a0872$var$CSS_NUMBER_MODE,
    REGEXP_MODE: $f4840ac5e98a0872$var$REGEXP_MODE,
    TITLE_MODE: $f4840ac5e98a0872$var$TITLE_MODE,
    UNDERSCORE_TITLE_MODE: $f4840ac5e98a0872$var$UNDERSCORE_TITLE_MODE,
    METHOD_GUARD: $f4840ac5e98a0872$var$METHOD_GUARD,
    END_SAME_AS_BEGIN: $f4840ac5e98a0872$var$END_SAME_AS_BEGIN
});
// Grammar extensions / plugins
// See: https://github.com/highlightjs/highlight.js/issues/2833
// Grammar extensions allow "syntactic sugar" to be added to the grammar modes
// without requiring any underlying changes to the compiler internals.
// `compileMatch` being the perfect small example of now allowing a grammar
// author to write `match` when they desire to match a single expression rather
// than being forced to use `begin`.  The extension then just moves `match` into
// `begin` when it runs.  Ie, no features have been added, but we've just made
// the experience of writing (and reading grammars) a little bit nicer.
// ------
// TODO: We need negative look-behind support to do this properly
/**
 * Skip a match if it has a preceding dot
 *
 * This is used for `beginKeywords` to prevent matching expressions such as
 * `bob.keyword.do()`. The mode compiler automatically wires this up as a
 * special _internal_ 'on:begin' callback for modes with `beginKeywords`
 * @param {RegExpMatchArray} match
 * @param {CallbackResponse} response
 */ function $f4840ac5e98a0872$var$skipIfhasPrecedingDot(match, response) {
    const before = match.input[match.index - 1];
    if (before === ".") response.ignoreMatch();
}
/**
 * `beginKeywords` syntactic sugar
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$beginKeywords(mode, parent) {
    if (!parent) return;
    if (!mode.beginKeywords) return;
    // for languages with keywords that include non-word characters checking for
    // a word boundary is not sufficient, so instead we check for a word boundary
    // or whitespace - this does no harm in any case since our keyword engine
    // doesn't allow spaces in keywords anyways and we still check for the boundary
    // first
    mode.begin = "\\b(" + mode.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)";
    mode.__beforeBegin = $f4840ac5e98a0872$var$skipIfhasPrecedingDot;
    mode.keywords = mode.keywords || mode.beginKeywords;
    delete mode.beginKeywords;
    // prevents double relevance, the keywords themselves provide
    // relevance, the mode doesn't need to double it
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 0;
}
/**
 * Allow `illegal` to contain an array of illegal values
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileIllegal(mode, _parent) {
    if (!Array.isArray(mode.illegal)) return;
    mode.illegal = $f4840ac5e98a0872$var$either(...mode.illegal);
}
/**
 * `match` to match a single expression for readability
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileMatch(mode, _parent) {
    if (!mode.match) return;
    if (mode.begin || mode.end) throw new Error("begin & end are not supported with match");
    mode.begin = mode.match;
    delete mode.match;
}
/**
 * provides the default 1 relevance to all modes
 * @type {CompilerExt}
 */ function $f4840ac5e98a0872$var$compileRelevance(mode, _parent) {
    // eslint-disable-next-line no-undefined
    if (mode.relevance === undefined) mode.relevance = 1;
}
// keywords that should have no default relevance value
const $f4840ac5e98a0872$var$COMMON_KEYWORDS = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    "list",
    "value" // common variable name
];
const $f4840ac5e98a0872$var$DEFAULT_KEYWORD_CLASSNAME = "keyword";
/**
 * Given raw keywords from a language definition, compile them.
 *
 * @param {string | Record<string,string|string[]> | Array<string>} rawKeywords
 * @param {boolean} caseInsensitive
 */ function $f4840ac5e98a0872$var$compileKeywords(rawKeywords, caseInsensitive, className = $f4840ac5e98a0872$var$DEFAULT_KEYWORD_CLASSNAME) {
    /** @type KeywordDict */ const compiledKeywords = {};
    // input can be a string of keywords, an array of keywords, or a object with
    // named keys representing className (which can then point to a string or array)
    if (typeof rawKeywords === "string") compileList(className, rawKeywords.split(" "));
    else if (Array.isArray(rawKeywords)) compileList(className, rawKeywords);
    else Object.keys(rawKeywords).forEach(function(className) {
        // collapse all our objects back into the parent object
        Object.assign(compiledKeywords, $f4840ac5e98a0872$var$compileKeywords(rawKeywords[className], caseInsensitive, className));
    });
    return compiledKeywords;
    // ---
    /**
   * Compiles an individual list of keywords
   *
   * Ex: "for if when while|5"
   *
   * @param {string} className
   * @param {Array<string>} keywordList
   */ function compileList(className, keywordList) {
        if (caseInsensitive) keywordList = keywordList.map((x)=>x.toLowerCase());
        keywordList.forEach(function(keyword) {
            const pair = keyword.split("|");
            compiledKeywords[pair[0]] = [
                className,
                $f4840ac5e98a0872$var$scoreForKeyword(pair[0], pair[1])
            ];
        });
    }
}
/**
 * Returns the proper score for a given keyword
 *
 * Also takes into account comment keywords, which will be scored 0 UNLESS
 * another score has been manually assigned.
 * @param {string} keyword
 * @param {string} [providedScore]
 */ function $f4840ac5e98a0872$var$scoreForKeyword(keyword, providedScore) {
    // manual scores always win over common keywords
    // so you can force a score of 1 if you really insist
    if (providedScore) return Number(providedScore);
    return $f4840ac5e98a0872$var$commonKeyword(keyword) ? 0 : 1;
}
/**
 * Determines if a given keyword is common or not
 *
 * @param {string} keyword */ function $f4840ac5e98a0872$var$commonKeyword(keyword) {
    return $f4840ac5e98a0872$var$COMMON_KEYWORDS.includes(keyword.toLowerCase());
}
// compilation
/**
 * Compiles a language definition result
 *
 * Given the raw result of a language definition (Language), compiles this so
 * that it is ready for highlighting code.
 * @param {Language} language
 * @param {{plugins: HLJSPlugin[]}} opts
 * @returns {CompiledLanguage}
 */ function $f4840ac5e98a0872$var$compileLanguage(language, { plugins: plugins }) {
    /**
   * Builds a regex with the case sensativility of the current language
   *
   * @param {RegExp | string} value
   * @param {boolean} [global]
   */ function langRe(value, global) {
        return new RegExp($f4840ac5e98a0872$var$source(value), "m" + (language.case_insensitive ? "i" : "") + (global ? "g" : ""));
    }
    /**
    Stores multiple regular expressions and allows you to quickly search for
    them all in a string simultaneously - returning the first match.  It does
    this by creating a huge (a|b|c) regex - each individual item wrapped with ()
    and joined by `|` - using match groups to track position.  When a match is
    found checking which position in the array has content allows us to figure
    out which of the original regexes / match groups triggered the match.

    The match object itself (the result of `Regex.exec`) is returned but also
    enhanced by merging in any meta-data that was registered with the regex.
    This is how we keep track of which mode matched, and what type of rule
    (`illegal`, `begin`, end, etc).
  */ class MultiRegex {
        constructor(){
            this.matchIndexes = {};
            // @ts-ignore
            this.regexes = [];
            this.matchAt = 1;
            this.position = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            opts.position = this.position++;
            // @ts-ignore
            this.matchIndexes[this.matchAt] = opts;
            this.regexes.push([
                opts,
                re
            ]);
            this.matchAt += $f4840ac5e98a0872$var$countMatchGroups(re) + 1;
        }
        compile() {
            if (this.regexes.length === 0) // avoids the need to check length every time exec is called
            // @ts-ignore
            this.exec = ()=>null;
            const terminators = this.regexes.map((el)=>el[1]);
            this.matcherRe = langRe($f4840ac5e98a0872$var$join(terminators), true);
            this.lastIndex = 0;
        }
        /** @param {string} s */ exec(s) {
            this.matcherRe.lastIndex = this.lastIndex;
            const match = this.matcherRe.exec(s);
            if (!match) return null;
            // eslint-disable-next-line no-undefined
            const i = match.findIndex((el, i)=>i > 0 && el !== undefined);
            // @ts-ignore
            const matchData = this.matchIndexes[i];
            // trim off any earlier non-relevant match groups (ie, the other regex
            // match groups that make up the multi-matcher)
            match.splice(0, i);
            return Object.assign(match, matchData);
        }
    }
    /*
    Created to solve the key deficiently with MultiRegex - there is no way to
    test for multiple matches at a single location.  Why would we need to do
    that?  In the future a more dynamic engine will allow certain matches to be
    ignored.  An example: if we matched say the 3rd regex in a large group but
    decided to ignore it - we'd need to started testing again at the 4th
    regex... but MultiRegex itself gives us no real way to do that.

    So what this class creates MultiRegexs on the fly for whatever search
    position they are needed.

    NOTE: These additional MultiRegex objects are created dynamically.  For most
    grammars most of the time we will never actually need anything more than the
    first MultiRegex - so this shouldn't have too much overhead.

    Say this is our search group, and we match regex3, but wish to ignore it.

      regex1 | regex2 | regex3 | regex4 | regex5    ' ie, startAt = 0

    What we need is a new MultiRegex that only includes the remaining
    possibilities:

      regex4 | regex5                               ' ie, startAt = 3

    This class wraps all that complexity up in a simple API... `startAt` decides
    where in the array of expressions to start doing the matching. It
    auto-increments, so if a match is found at position 2, then startAt will be
    set to 3.  If the end is reached startAt will return to 0.

    MOST of the time the parser will be setting startAt manually to 0.
  */ class ResumableMultiRegex {
        constructor(){
            // @ts-ignore
            this.rules = [];
            // @ts-ignore
            this.multiRegexes = [];
            this.count = 0;
            this.lastIndex = 0;
            this.regexIndex = 0;
        }
        // @ts-ignore
        getMatcher(index) {
            if (this.multiRegexes[index]) return this.multiRegexes[index];
            const matcher = new MultiRegex();
            this.rules.slice(index).forEach(([re, opts])=>matcher.addRule(re, opts));
            matcher.compile();
            this.multiRegexes[index] = matcher;
            return matcher;
        }
        resumingScanAtSamePosition() {
            return this.regexIndex !== 0;
        }
        considerAll() {
            this.regexIndex = 0;
        }
        // @ts-ignore
        addRule(re, opts) {
            this.rules.push([
                re,
                opts
            ]);
            if (opts.type === "begin") this.count++;
        }
        /** @param {string} s */ exec(s) {
            const m = this.getMatcher(this.regexIndex);
            m.lastIndex = this.lastIndex;
            let result = m.exec(s);
            // The following is because we have no easy way to say "resume scanning at the
            // existing position but also skip the current rule ONLY". What happens is
            // all prior rules are also skipped which can result in matching the wrong
            // thing. Example of matching "booger":
            // our matcher is [string, "booger", number]
            //
            // ....booger....
            // if "booger" is ignored then we'd really need a regex to scan from the
            // SAME position for only: [string, number] but ignoring "booger" (if it
            // was the first match), a simple resume would scan ahead who knows how
            // far looking only for "number", ignoring potential string matches (or
            // future "booger" matches that might be valid.)
            // So what we do: We execute two matchers, one resuming at the same
            // position, but the second full matcher starting at the position after:
            //     /--- resume first regex match here (for [number])
            //     |/---- full match here for [string, "booger", number]
            //     vv
            // ....booger....
            // Which ever results in a match first is then used. So this 3-4 step
            // process essentially allows us to say "match at this position, excluding
            // a prior rule that was ignored".
            //
            // 1. Match "booger" first, ignore. Also proves that [string] does non match.
            // 2. Resume matching for [number]
            // 3. Match at index + 1 for [string, "booger", number]
            // 4. If #2 and #3 result in matches, which came first?
            if (this.resumingScanAtSamePosition()) {
                if (result && result.index === this.lastIndex) ;
                else {
                    const m2 = this.getMatcher(0);
                    m2.lastIndex = this.lastIndex + 1;
                    result = m2.exec(s);
                }
            }
            if (result) {
                this.regexIndex += result.position + 1;
                if (this.regexIndex === this.count) // wrap-around to considering all matches again
                this.considerAll();
            }
            return result;
        }
    }
    /**
   * Given a mode, builds a huge ResumableMultiRegex that can be used to walk
   * the content and find matches.
   *
   * @param {CompiledMode} mode
   * @returns {ResumableMultiRegex}
   */ function buildModeRegex(mode) {
        const mm = new ResumableMultiRegex();
        mode.contains.forEach((term)=>mm.addRule(term.begin, {
                rule: term,
                type: "begin"
            }));
        if (mode.terminatorEnd) mm.addRule(mode.terminatorEnd, {
            type: "end"
        });
        if (mode.illegal) mm.addRule(mode.illegal, {
            type: "illegal"
        });
        return mm;
    }
    /** skip vs abort vs ignore
   *
   * @skip   - The mode is still entered and exited normally (and contains rules apply),
   *           but all content is held and added to the parent buffer rather than being
   *           output when the mode ends.  Mostly used with `sublanguage` to build up
   *           a single large buffer than can be parsed by sublanguage.
   *
   *             - The mode begin ands ends normally.
   *             - Content matched is added to the parent mode buffer.
   *             - The parser cursor is moved forward normally.
   *
   * @abort  - A hack placeholder until we have ignore.  Aborts the mode (as if it
   *           never matched) but DOES NOT continue to match subsequent `contains`
   *           modes.  Abort is bad/suboptimal because it can result in modes
   *           farther down not getting applied because an earlier rule eats the
   *           content but then aborts.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is added to the mode buffer.
   *             - The parser cursor is moved forward accordingly.
   *
   * @ignore - Ignores the mode (as if it never matched) and continues to match any
   *           subsequent `contains` modes.  Ignore isn't technically possible with
   *           the current parser implementation.
   *
   *             - The mode does not begin.
   *             - Content matched by `begin` is ignored.
   *             - The parser cursor is not moved forward.
   */ /**
   * Compiles an individual mode
   *
   * This can raise an error if the mode contains certain detectable known logic
   * issues.
   * @param {Mode} mode
   * @param {CompiledMode | null} [parent]
   * @returns {CompiledMode | never}
   */ function compileMode(mode, parent) {
        const cmode = /** @type CompiledMode */ mode;
        if (mode.isCompiled) return cmode;
        [
            // do this early so compiler extensions generally don't have to worry about
            // the distinction between match/begin
            $f4840ac5e98a0872$var$compileMatch
        ].forEach((ext)=>ext(mode, parent));
        language.compilerExtensions.forEach((ext)=>ext(mode, parent));
        // __beforeBegin is considered private API, internal use only
        mode.__beforeBegin = null;
        [
            $f4840ac5e98a0872$var$beginKeywords,
            // do this later so compiler extensions that come earlier have access to the
            // raw array if they wanted to perhaps manipulate it, etc.
            $f4840ac5e98a0872$var$compileIllegal,
            // default to 1 relevance if not specified
            $f4840ac5e98a0872$var$compileRelevance
        ].forEach((ext)=>ext(mode, parent));
        mode.isCompiled = true;
        let keywordPattern = null;
        if (typeof mode.keywords === "object") {
            keywordPattern = mode.keywords.$pattern;
            delete mode.keywords.$pattern;
        }
        if (mode.keywords) mode.keywords = $f4840ac5e98a0872$var$compileKeywords(mode.keywords, language.case_insensitive);
        // both are not allowed
        if (mode.lexemes && keywordPattern) throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
        // `mode.lexemes` was the old standard before we added and now recommend
        // using `keywords.$pattern` to pass the keyword pattern
        keywordPattern = keywordPattern || mode.lexemes || /\w+/;
        cmode.keywordPatternRe = langRe(keywordPattern, true);
        if (parent) {
            if (!mode.begin) mode.begin = /\B|\b/;
            cmode.beginRe = langRe(mode.begin);
            if (mode.endSameAsBegin) mode.end = mode.begin;
            if (!mode.end && !mode.endsWithParent) mode.end = /\B|\b/;
            if (mode.end) cmode.endRe = langRe(mode.end);
            cmode.terminatorEnd = $f4840ac5e98a0872$var$source(mode.end) || "";
            if (mode.endsWithParent && parent.terminatorEnd) cmode.terminatorEnd += (mode.end ? "|" : "") + parent.terminatorEnd;
        }
        if (mode.illegal) cmode.illegalRe = langRe(/** @type {RegExp | string} */ mode.illegal);
        if (!mode.contains) mode.contains = [];
        mode.contains = [].concat(...mode.contains.map(function(c) {
            return $f4840ac5e98a0872$var$expandOrCloneMode(c === "self" ? mode : c);
        }));
        mode.contains.forEach(function(c) {
            compileMode(/** @type Mode */ c, cmode);
        });
        if (mode.starts) compileMode(mode.starts, parent);
        cmode.matcher = buildModeRegex(cmode);
        return cmode;
    }
    if (!language.compilerExtensions) language.compilerExtensions = [];
    // self is not valid at the top-level
    if (language.contains && language.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    // we need a null object, which inherit will guarantee
    language.classNameAliases = $f4840ac5e98a0872$var$inherit(language.classNameAliases || {});
    return compileMode(/** @type Mode */ language);
}
/**
 * Determines if a mode has a dependency on it's parent or not
 *
 * If a mode does have a parent dependency then often we need to clone it if
 * it's used in multiple places so that each copy points to the correct parent,
 * where-as modes without a parent can often safely be re-used at the bottom of
 * a mode chain.
 *
 * @param {Mode | null} mode
 * @returns {boolean} - is there a dependency on the parent?
 * */ function $f4840ac5e98a0872$var$dependencyOnParent(mode) {
    if (!mode) return false;
    return mode.endsWithParent || $f4840ac5e98a0872$var$dependencyOnParent(mode.starts);
}
/**
 * Expands a mode or clones it if necessary
 *
 * This is necessary for modes with parental dependenceis (see notes on
 * `dependencyOnParent`) and for nodes that have `variants` - which must then be
 * exploded into their own individual modes at compile time.
 *
 * @param {Mode} mode
 * @returns {Mode | Mode[]}
 * */ function $f4840ac5e98a0872$var$expandOrCloneMode(mode) {
    if (mode.variants && !mode.cachedVariants) mode.cachedVariants = mode.variants.map(function(variant) {
        return $f4840ac5e98a0872$var$inherit(mode, {
            variants: null
        }, variant);
    });
    // EXPAND
    // if we have variants then essentially "replace" the mode with the variants
    // this happens in compileMode, where this function is called from
    if (mode.cachedVariants) return mode.cachedVariants;
    // CLONE
    // if we have dependencies on parents then we need a unique
    // instance of ourselves, so we can be reused with many
    // different parents without issue
    if ($f4840ac5e98a0872$var$dependencyOnParent(mode)) return $f4840ac5e98a0872$var$inherit(mode, {
        starts: mode.starts ? $f4840ac5e98a0872$var$inherit(mode.starts) : null
    });
    if (Object.isFrozen(mode)) return $f4840ac5e98a0872$var$inherit(mode);
    // no special dependency issues, just return ourselves
    return mode;
}
var $f4840ac5e98a0872$var$version = "10.7.3";
// @ts-nocheck
function $f4840ac5e98a0872$var$hasValueOrEmptyAttribute(value) {
    return Boolean(value || value === "");
}
function $f4840ac5e98a0872$var$BuildVuePlugin(hljs) {
    const Component = {
        props: [
            "language",
            "code",
            "autodetect"
        ],
        data: function() {
            return {
                detectedLanguage: "",
                unknownLanguage: false
            };
        },
        computed: {
            className () {
                if (this.unknownLanguage) return "";
                return "hljs " + this.detectedLanguage;
            },
            highlighted () {
                // no idea what language to use, return raw code
                if (!this.autoDetect && !hljs.getLanguage(this.language)) {
                    console.warn(`The language "${this.language}" you specified could not be found.`);
                    this.unknownLanguage = true;
                    return $f4840ac5e98a0872$var$escapeHTML(this.code);
                }
                let result = {};
                if (this.autoDetect) {
                    result = hljs.highlightAuto(this.code);
                    this.detectedLanguage = result.language;
                } else {
                    result = hljs.highlight(this.language, this.code, this.ignoreIllegals);
                    this.detectedLanguage = this.language;
                }
                return result.value;
            },
            autoDetect () {
                return !this.language || $f4840ac5e98a0872$var$hasValueOrEmptyAttribute(this.autodetect);
            },
            ignoreIllegals () {
                return true;
            }
        },
        // this avoids needing to use a whole Vue compilation pipeline just
        // to build Highlight.js
        render (createElement) {
            return createElement("pre", {}, [
                createElement("code", {
                    class: this.className,
                    domProps: {
                        innerHTML: this.highlighted
                    }
                })
            ]);
        }
    };
    const VuePlugin = {
        install (Vue) {
            Vue.component("highlightjs", Component);
        }
    };
    return {
        Component: Component,
        VuePlugin: VuePlugin
    };
}
/* plugin itself */ /** @type {HLJSPlugin} */ const $f4840ac5e98a0872$var$mergeHTMLPlugin = {
    "after:highlightElement": ({ el: el, result: result, text: text })=>{
        const originalStream = $f4840ac5e98a0872$var$nodeStream(el);
        if (!originalStream.length) return;
        const resultNode = document.createElement("div");
        resultNode.innerHTML = result.value;
        result.value = $f4840ac5e98a0872$var$mergeStreams(originalStream, $f4840ac5e98a0872$var$nodeStream(resultNode), text);
    }
};
/* Stream merging support functions */ /**
 * @typedef Event
 * @property {'start'|'stop'} event
 * @property {number} offset
 * @property {Node} node
 */ /**
 * @param {Node} node
 */ function $f4840ac5e98a0872$var$tag(node) {
    return node.nodeName.toLowerCase();
}
/**
 * @param {Node} node
 */ function $f4840ac5e98a0872$var$nodeStream(node) {
    /** @type Event[] */ const result = [];
    (function _nodeStream(node, offset) {
        for(let child = node.firstChild; child; child = child.nextSibling){
            if (child.nodeType === 3) offset += child.nodeValue.length;
            else if (child.nodeType === 1) {
                result.push({
                    event: "start",
                    offset: offset,
                    node: child
                });
                offset = _nodeStream(child, offset);
                // Prevent void elements from having an end tag that would actually
                // double them in the output. There are more void elements in HTML
                // but we list only those realistically expected in code display.
                if (!$f4840ac5e98a0872$var$tag(child).match(/br|hr|img|input/)) result.push({
                    event: "stop",
                    offset: offset,
                    node: child
                });
            }
        }
        return offset;
    })(node, 0);
    return result;
}
/**
 * @param {any} original - the original stream
 * @param {any} highlighted - stream of the highlighted source
 * @param {string} value - the original source itself
 */ function $f4840ac5e98a0872$var$mergeStreams(original, highlighted, value) {
    let processed = 0;
    let result = "";
    const nodeStack = [];
    function selectStream() {
        if (!original.length || !highlighted.length) return original.length ? original : highlighted;
        if (original[0].offset !== highlighted[0].offset) return original[0].offset < highlighted[0].offset ? original : highlighted;
        /*
    To avoid starting the stream just before it should stop the order is
    ensured that original always starts first and closes last:

    if (event1 == 'start' && event2 == 'start')
      return original;
    if (event1 == 'start' && event2 == 'stop')
      return highlighted;
    if (event1 == 'stop' && event2 == 'start')
      return original;
    if (event1 == 'stop' && event2 == 'stop')
      return highlighted;

    ... which is collapsed to:
    */ return highlighted[0].event === "start" ? original : highlighted;
    }
    /**
   * @param {Node} node
   */ function open(node) {
        /** @param {Attr} attr */ function attributeString(attr) {
            return " " + attr.nodeName + '="' + $f4840ac5e98a0872$var$escapeHTML(attr.value) + '"';
        }
        // @ts-ignore
        result += "<" + $f4840ac5e98a0872$var$tag(node) + [].map.call(node.attributes, attributeString).join("") + ">";
    }
    /**
   * @param {Node} node
   */ function close(node) {
        result += "</" + $f4840ac5e98a0872$var$tag(node) + ">";
    }
    /**
   * @param {Event} event
   */ function render(event) {
        (event.event === "start" ? open : close)(event.node);
    }
    while(original.length || highlighted.length){
        let stream = selectStream();
        result += $f4840ac5e98a0872$var$escapeHTML(value.substring(processed, stream[0].offset));
        processed = stream[0].offset;
        if (stream === original) {
            /*
      On any opening or closing tag of the original markup we first close
      the entire highlighted node stack, then render the original tag along
      with all the following original tags at the same offset and then
      reopen all the tags on the highlighted stack.
      */ nodeStack.reverse().forEach(close);
            do {
                render(stream.splice(0, 1)[0]);
                stream = selectStream();
            }while (stream === original && stream.length && stream[0].offset === processed);
            nodeStack.reverse().forEach(open);
        } else {
            if (stream[0].event === "start") nodeStack.push(stream[0].node);
            else nodeStack.pop();
            render(stream.splice(0, 1)[0]);
        }
    }
    return result + $f4840ac5e98a0872$var$escapeHTML(value.substr(processed));
}
/*

For the reasoning behind this please see:
https://github.com/highlightjs/highlight.js/issues/2880#issuecomment-747275419

*/ /**
 * @type {Record<string, boolean>}
 */ const $f4840ac5e98a0872$var$seenDeprecations = {};
/**
 * @param {string} message
 */ const $f4840ac5e98a0872$var$error = (message)=>{
    console.error(message);
};
/**
 * @param {string} message
 * @param {any} args
 */ const $f4840ac5e98a0872$var$warn = (message, ...args)=>{
    console.log(`WARN: ${message}`, ...args);
};
/**
 * @param {string} version
 * @param {string} message
 */ const $f4840ac5e98a0872$var$deprecated = (version, message)=>{
    if ($f4840ac5e98a0872$var$seenDeprecations[`${version}/${message}`]) return;
    console.log(`Deprecated as of ${version}. ${message}`);
    $f4840ac5e98a0872$var$seenDeprecations[`${version}/${message}`] = true;
};
/*
Syntax highlighting with language autodetection.
https://highlightjs.org/
*/ const $f4840ac5e98a0872$var$escape$1 = $f4840ac5e98a0872$var$escapeHTML;
const $f4840ac5e98a0872$var$inherit$1 = $f4840ac5e98a0872$var$inherit;
const $f4840ac5e98a0872$var$NO_MATCH = Symbol("nomatch");
/**
 * @param {any} hljs - object that is extended (legacy)
 * @returns {HLJSApi}
 */ const $f4840ac5e98a0872$var$HLJS = function(hljs) {
    // Global internal variables used within the highlight.js library.
    /** @type {Record<string, Language>} */ const languages = Object.create(null);
    /** @type {Record<string, string>} */ const aliases = Object.create(null);
    /** @type {HLJSPlugin[]} */ const plugins = [];
    // safe/production mode - swallows more errors, tries to keep running
    // even if a single syntax or parse hits a fatal error
    let SAFE_MODE = true;
    const fixMarkupRe = /(^(<[^>]+>|\t|)+|\n)/gm;
    const LANGUAGE_NOT_FOUND = "Could not find the language '{}', did you forget to load/include a language module?";
    /** @type {Language} */ const PLAINTEXT_LANGUAGE = {
        disableAutodetect: true,
        name: "Plain text",
        contains: []
    };
    // Global options used when within external APIs. This is modified when
    // calling the `hljs.configure` function.
    /** @type HLJSOptions */ let options = {
        noHighlightRe: /^(no-?highlight)$/i,
        languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
        classPrefix: "hljs-",
        tabReplace: null,
        useBR: false,
        languages: null,
        // beta configuration options, subject to change, welcome to discuss
        // https://github.com/highlightjs/highlight.js/issues/1086
        __emitter: $f4840ac5e98a0872$var$TokenTreeEmitter
    };
    /* Utility functions */ /**
   * Tests a language name to see if highlighting should be skipped
   * @param {string} languageName
   */ function shouldNotHighlight(languageName) {
        return options.noHighlightRe.test(languageName);
    }
    /**
   * @param {HighlightedHTMLElement} block - the HTML element to determine language for
   */ function blockLanguage(block) {
        let classes = block.className + " ";
        classes += block.parentNode ? block.parentNode.className : "";
        // language-* takes precedence over non-prefixed class names.
        const match = options.languageDetectRe.exec(classes);
        if (match) {
            const language = getLanguage(match[1]);
            if (!language) {
                $f4840ac5e98a0872$var$warn(LANGUAGE_NOT_FOUND.replace("{}", match[1]));
                $f4840ac5e98a0872$var$warn("Falling back to no-highlight mode for this block.", block);
            }
            return language ? match[1] : "no-highlight";
        }
        return classes.split(/\s+/).find((_class)=>shouldNotHighlight(_class) || getLanguage(_class));
    }
    /**
   * Core highlighting function.
   *
   * OLD API
   * highlight(lang, code, ignoreIllegals, continuation)
   *
   * NEW API
   * highlight(code, {lang, ignoreIllegals})
   *
   * @param {string} codeOrlanguageName - the language to use for highlighting
   * @param {string | HighlightOptions} optionsOrCode - the code to highlight
   * @param {boolean} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode} [continuation] - current continuation mode, if any
   *
   * @returns {HighlightResult} Result - an object that represents the result
   * @property {string} language - the language name
   * @property {number} relevance - the relevance score
   * @property {string} value - the highlighted HTML code
   * @property {string} code - the original raw code
   * @property {CompiledMode} top - top of the current mode stack
   * @property {boolean} illegal - indicates whether any illegal matches were found
  */ function highlight(codeOrlanguageName, optionsOrCode, ignoreIllegals, continuation) {
        let code = "";
        let languageName = "";
        if (typeof optionsOrCode === "object") {
            code = codeOrlanguageName;
            ignoreIllegals = optionsOrCode.ignoreIllegals;
            languageName = optionsOrCode.language;
            // continuation not supported at all via the new API
            // eslint-disable-next-line no-undefined
            continuation = undefined;
        } else {
            // old API
            $f4840ac5e98a0872$var$deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated.");
            $f4840ac5e98a0872$var$deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277");
            languageName = codeOrlanguageName;
            code = optionsOrCode;
        }
        /** @type {BeforeHighlightContext} */ const context = {
            code: code,
            language: languageName
        };
        // the plugin can change the desired language or the code to be highlighted
        // just be changing the object it was passed
        fire("before:highlight", context);
        // a before plugin can usurp the result completely by providing it's own
        // in which case we don't even need to call highlight
        const result = context.result ? context.result : _highlight(context.language, context.code, ignoreIllegals, continuation);
        result.code = context.code;
        // the plugin can change anything in result to suite it
        fire("after:highlight", result);
        return result;
    }
    /**
   * private highlight that's used internally and does not fire callbacks
   *
   * @param {string} languageName - the language to use for highlighting
   * @param {string} codeToHighlight - the code to highlight
   * @param {boolean?} [ignoreIllegals] - whether to ignore illegal matches, default is to bail
   * @param {CompiledMode?} [continuation] - current continuation mode, if any
   * @returns {HighlightResult} - result of the highlight operation
  */ function _highlight(languageName, codeToHighlight, ignoreIllegals, continuation) {
        /**
     * Return keyword data if a match is a keyword
     * @param {CompiledMode} mode - current mode
     * @param {RegExpMatchArray} match - regexp match data
     * @returns {KeywordData | false}
     */ function keywordData(mode, match) {
            const matchText = language.case_insensitive ? match[0].toLowerCase() : match[0];
            return Object.prototype.hasOwnProperty.call(mode.keywords, matchText) && mode.keywords[matchText];
        }
        function processKeywords() {
            if (!top.keywords) {
                emitter.addText(modeBuffer);
                return;
            }
            let lastIndex = 0;
            top.keywordPatternRe.lastIndex = 0;
            let match = top.keywordPatternRe.exec(modeBuffer);
            let buf = "";
            while(match){
                buf += modeBuffer.substring(lastIndex, match.index);
                const data = keywordData(top, match);
                if (data) {
                    const [kind, keywordRelevance] = data;
                    emitter.addText(buf);
                    buf = "";
                    relevance += keywordRelevance;
                    if (kind.startsWith("_")) // _ implied for relevance only, do not highlight
                    // by applying a class name
                    buf += match[0];
                    else {
                        const cssClass = language.classNameAliases[kind] || kind;
                        emitter.addKeyword(match[0], cssClass);
                    }
                } else buf += match[0];
                lastIndex = top.keywordPatternRe.lastIndex;
                match = top.keywordPatternRe.exec(modeBuffer);
            }
            buf += modeBuffer.substr(lastIndex);
            emitter.addText(buf);
        }
        function processSubLanguage() {
            if (modeBuffer === "") return;
            /** @type HighlightResult */ let result = null;
            if (typeof top.subLanguage === "string") {
                if (!languages[top.subLanguage]) {
                    emitter.addText(modeBuffer);
                    return;
                }
                result = _highlight(top.subLanguage, modeBuffer, true, continuations[top.subLanguage]);
                continuations[top.subLanguage] = /** @type {CompiledMode} */ result.top;
            } else result = highlightAuto(modeBuffer, top.subLanguage.length ? top.subLanguage : null);
            // Counting embedded language score towards the host language may be disabled
            // with zeroing the containing mode relevance. Use case in point is Markdown that
            // allows XML everywhere and makes every XML snippet to have a much larger Markdown
            // score.
            if (top.relevance > 0) relevance += result.relevance;
            emitter.addSublanguage(result.emitter, result.language);
        }
        function processBuffer() {
            if (top.subLanguage != null) processSubLanguage();
            else processKeywords();
            modeBuffer = "";
        }
        /**
     * @param {Mode} mode - new mode to start
     */ function startNewMode(mode) {
            if (mode.className) emitter.openNode(language.classNameAliases[mode.className] || mode.className);
            top = Object.create(mode, {
                parent: {
                    value: top
                }
            });
            return top;
        }
        /**
     * @param {CompiledMode } mode - the mode to potentially end
     * @param {RegExpMatchArray} match - the latest match
     * @param {string} matchPlusRemainder - match plus remainder of content
     * @returns {CompiledMode | void} - the next mode, or if void continue on in current mode
     */ function endOfMode(mode, match, matchPlusRemainder) {
            let matched = $f4840ac5e98a0872$var$startsWith(mode.endRe, matchPlusRemainder);
            if (matched) {
                if (mode["on:end"]) {
                    const resp = new $f4840ac5e98a0872$var$Response(mode);
                    mode["on:end"](match, resp);
                    if (resp.isMatchIgnored) matched = false;
                }
                if (matched) {
                    while(mode.endsParent && mode.parent)mode = mode.parent;
                    return mode;
                }
            }
            // even if on:end fires an `ignore` it's still possible
            // that we might trigger the end node because of a parent mode
            if (mode.endsWithParent) return endOfMode(mode.parent, match, matchPlusRemainder);
        }
        /**
     * Handle matching but then ignoring a sequence of text
     *
     * @param {string} lexeme - string containing full match text
     */ function doIgnore(lexeme) {
            if (top.matcher.regexIndex === 0) {
                // no more regexs to potentially match here, so we move the cursor forward one
                // space
                modeBuffer += lexeme[0];
                return 1;
            } else {
                // no need to move the cursor, we still have additional regexes to try and
                // match at this very spot
                resumeScanAtSamePosition = true;
                return 0;
            }
        }
        /**
     * Handle the start of a new potential mode match
     *
     * @param {EnhancedMatch} match - the current match
     * @returns {number} how far to advance the parse cursor
     */ function doBeginMatch(match) {
            const lexeme = match[0];
            const newMode = match.rule;
            const resp = new $f4840ac5e98a0872$var$Response(newMode);
            // first internal before callbacks, then the public ones
            const beforeCallbacks = [
                newMode.__beforeBegin,
                newMode["on:begin"]
            ];
            for (const cb of beforeCallbacks){
                if (!cb) continue;
                cb(match, resp);
                if (resp.isMatchIgnored) return doIgnore(lexeme);
            }
            if (newMode && newMode.endSameAsBegin) newMode.endRe = $f4840ac5e98a0872$var$escape(lexeme);
            if (newMode.skip) modeBuffer += lexeme;
            else {
                if (newMode.excludeBegin) modeBuffer += lexeme;
                processBuffer();
                if (!newMode.returnBegin && !newMode.excludeBegin) modeBuffer = lexeme;
            }
            startNewMode(newMode);
            // if (mode["after:begin"]) {
            //   let resp = new Response(mode);
            //   mode["after:begin"](match, resp);
            // }
            return newMode.returnBegin ? 0 : lexeme.length;
        }
        /**
     * Handle the potential end of mode
     *
     * @param {RegExpMatchArray} match - the current match
     */ function doEndMatch(match) {
            const lexeme = match[0];
            const matchPlusRemainder = codeToHighlight.substr(match.index);
            const endMode = endOfMode(top, match, matchPlusRemainder);
            if (!endMode) return $f4840ac5e98a0872$var$NO_MATCH;
            const origin = top;
            if (origin.skip) modeBuffer += lexeme;
            else {
                if (!(origin.returnEnd || origin.excludeEnd)) modeBuffer += lexeme;
                processBuffer();
                if (origin.excludeEnd) modeBuffer = lexeme;
            }
            do {
                if (top.className) emitter.closeNode();
                if (!top.skip && !top.subLanguage) relevance += top.relevance;
                top = top.parent;
            }while (top !== endMode.parent);
            if (endMode.starts) {
                if (endMode.endSameAsBegin) endMode.starts.endRe = endMode.endRe;
                startNewMode(endMode.starts);
            }
            return origin.returnEnd ? 0 : lexeme.length;
        }
        function processContinuations() {
            const list = [];
            for(let current = top; current !== language; current = current.parent)if (current.className) list.unshift(current.className);
            list.forEach((item)=>emitter.openNode(item));
        }
        /** @type {{type?: MatchType, index?: number, rule?: Mode}}} */ let lastMatch = {};
        /**
     *  Process an individual match
     *
     * @param {string} textBeforeMatch - text preceeding the match (since the last match)
     * @param {EnhancedMatch} [match] - the match itself
     */ function processLexeme(textBeforeMatch, match) {
            const lexeme = match && match[0];
            // add non-matched text to the current mode buffer
            modeBuffer += textBeforeMatch;
            if (lexeme == null) {
                processBuffer();
                return 0;
            }
            // we've found a 0 width match and we're stuck, so we need to advance
            // this happens when we have badly behaved rules that have optional matchers to the degree that
            // sometimes they can end up matching nothing at all
            // Ref: https://github.com/highlightjs/highlight.js/issues/2140
            if (lastMatch.type === "begin" && match.type === "end" && lastMatch.index === match.index && lexeme === "") {
                // spit the "skipped" character that our regex choked on back into the output sequence
                modeBuffer += codeToHighlight.slice(match.index, match.index + 1);
                if (!SAFE_MODE) {
                    /** @type {AnnotatedError} */ const err = new Error("0 width match regex");
                    err.languageName = languageName;
                    err.badRule = lastMatch.rule;
                    throw err;
                }
                return 1;
            }
            lastMatch = match;
            if (match.type === "begin") return doBeginMatch(match);
            else if (match.type === "illegal" && !ignoreIllegals) {
                // illegal match, we do not continue processing
                /** @type {AnnotatedError} */ const err = new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || "<unnamed>") + '"');
                err.mode = top;
                throw err;
            } else if (match.type === "end") {
                const processed = doEndMatch(match);
                if (processed !== $f4840ac5e98a0872$var$NO_MATCH) return processed;
            }
            // edge case for when illegal matches $ (end of line) which is technically
            // a 0 width match but not a begin/end match so it's not caught by the
            // first handler (when ignoreIllegals is true)
            if (match.type === "illegal" && lexeme === "") // advance so we aren't stuck in an infinite loop
            return 1;
            // infinite loops are BAD, this is a last ditch catch all. if we have a
            // decent number of iterations yet our index (cursor position in our
            // parsing) still 3x behind our index then something is very wrong
            // so we bail
            if (iterations > 100000 && iterations > match.index * 3) {
                const err = new Error("potential infinite loop, way more iterations than matches");
                throw err;
            }
            /*
      Why might be find ourselves here?  Only one occasion now.  An end match that was
      triggered but could not be completed.  When might this happen?  When an `endSameasBegin`
      rule sets the end rule to a specific match.  Since the overall mode termination rule that's
      being used to scan the text isn't recompiled that means that any match that LOOKS like
      the end (but is not, because it is not an exact match to the beginning) will
      end up here.  A definite end match, but when `doEndMatch` tries to "reapply"
      the end rule and fails to match, we wind up here, and just silently ignore the end.

      This causes no real harm other than stopping a few times too many.
      */ modeBuffer += lexeme;
            return lexeme.length;
        }
        const language = getLanguage(languageName);
        if (!language) {
            $f4840ac5e98a0872$var$error(LANGUAGE_NOT_FOUND.replace("{}", languageName));
            throw new Error('Unknown language: "' + languageName + '"');
        }
        const md = $f4840ac5e98a0872$var$compileLanguage(language, {
            plugins: plugins
        });
        let result = "";
        /** @type {CompiledMode} */ let top = continuation || md;
        /** @type Record<string,CompiledMode> */ const continuations = {}; // keep continuations for sub-languages
        const emitter = new options.__emitter(options);
        processContinuations();
        let modeBuffer = "";
        let relevance = 0;
        let index = 0;
        let iterations = 0;
        let resumeScanAtSamePosition = false;
        try {
            top.matcher.considerAll();
            for(;;){
                iterations++;
                if (resumeScanAtSamePosition) // only regexes not matched previously will now be
                // considered for a potential match
                resumeScanAtSamePosition = false;
                else top.matcher.considerAll();
                top.matcher.lastIndex = index;
                const match = top.matcher.exec(codeToHighlight);
                // console.log("match", match[0], match.rule && match.rule.begin)
                if (!match) break;
                const beforeMatch = codeToHighlight.substring(index, match.index);
                const processedCount = processLexeme(beforeMatch, match);
                index = match.index + processedCount;
            }
            processLexeme(codeToHighlight.substr(index));
            emitter.closeAllNodes();
            emitter.finalize();
            result = emitter.toHTML();
            return {
                // avoid possible breakage with v10 clients expecting
                // this to always be an integer
                relevance: Math.floor(relevance),
                value: result,
                language: languageName,
                illegal: false,
                emitter: emitter,
                top: top
            };
        } catch (err) {
            if (err.message && err.message.includes("Illegal")) return {
                illegal: true,
                illegalBy: {
                    msg: err.message,
                    context: codeToHighlight.slice(index - 100, index + 100),
                    mode: err.mode
                },
                sofar: result,
                relevance: 0,
                value: $f4840ac5e98a0872$var$escape$1(codeToHighlight),
                emitter: emitter
            };
            else if (SAFE_MODE) return {
                illegal: false,
                relevance: 0,
                value: $f4840ac5e98a0872$var$escape$1(codeToHighlight),
                emitter: emitter,
                language: languageName,
                top: top,
                errorRaised: err
            };
            else throw err;
        }
    }
    /**
   * returns a valid highlight result, without actually doing any actual work,
   * auto highlight starts with this and it's possible for small snippets that
   * auto-detection may not find a better match
   * @param {string} code
   * @returns {HighlightResult}
   */ function justTextHighlightResult(code) {
        const result = {
            relevance: 0,
            emitter: new options.__emitter(options),
            value: $f4840ac5e98a0872$var$escape$1(code),
            illegal: false,
            top: PLAINTEXT_LANGUAGE
        };
        result.emitter.addText(code);
        return result;
    }
    /**
  Highlighting with language detection. Accepts a string with the code to
  highlight. Returns an object with the following properties:

  - language (detected language)
  - relevance (int)
  - value (an HTML string with highlighting markup)
  - second_best (object with the same structure for second-best heuristically
    detected language, may be absent)

    @param {string} code
    @param {Array<string>} [languageSubset]
    @returns {AutoHighlightResult}
  */ function highlightAuto(code, languageSubset) {
        languageSubset = languageSubset || options.languages || Object.keys(languages);
        const plaintext = justTextHighlightResult(code);
        const results = languageSubset.filter(getLanguage).filter(autoDetection).map((name)=>_highlight(name, code, false));
        results.unshift(plaintext); // plaintext is always an option
        const sorted = results.sort((a, b)=>{
            // sort base on relevance
            if (a.relevance !== b.relevance) return b.relevance - a.relevance;
            // always award the tie to the base language
            // ie if C++ and Arduino are tied, it's more likely to be C++
            if (a.language && b.language) {
                if (getLanguage(a.language).supersetOf === b.language) return 1;
                else if (getLanguage(b.language).supersetOf === a.language) return -1;
            }
            // otherwise say they are equal, which has the effect of sorting on
            // relevance while preserving the original ordering - which is how ties
            // have historically been settled, ie the language that comes first always
            // wins in the case of a tie
            return 0;
        });
        const [best, secondBest] = sorted;
        /** @type {AutoHighlightResult} */ const result = best;
        result.second_best = secondBest;
        return result;
    }
    /**
  Post-processing of the highlighted markup:

  - replace TABs with something more useful
  - replace real line-breaks with '<br>' for non-pre containers

    @param {string} html
    @returns {string}
  */ function fixMarkup(html) {
        if (!(options.tabReplace || options.useBR)) return html;
        return html.replace(fixMarkupRe, (match)=>{
            if (match === "\n") return options.useBR ? "<br>" : match;
            else if (options.tabReplace) return match.replace(/\t/g, options.tabReplace);
            return match;
        });
    }
    /**
   * Builds new class name for block given the language name
   *
   * @param {HTMLElement} element
   * @param {string} [currentLang]
   * @param {string} [resultLang]
   */ function updateClassName(element, currentLang, resultLang) {
        const language = currentLang ? aliases[currentLang] : resultLang;
        element.classList.add("hljs");
        if (language) element.classList.add(language);
    }
    /** @type {HLJSPlugin} */ const brPlugin = {
        "before:highlightElement": ({ el: el })=>{
            if (options.useBR) el.innerHTML = el.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, "\n");
        },
        "after:highlightElement": ({ result: result })=>{
            if (options.useBR) result.value = result.value.replace(/\n/g, "<br>");
        }
    };
    const TAB_REPLACE_RE = /^(<[^>]+>|\t)+/gm;
    /** @type {HLJSPlugin} */ const tabReplacePlugin = {
        "after:highlightElement": ({ result: result })=>{
            if (options.tabReplace) result.value = result.value.replace(TAB_REPLACE_RE, (m)=>m.replace(/\t/g, options.tabReplace));
        }
    };
    /**
   * Applies highlighting to a DOM node containing code. Accepts a DOM node and
   * two optional parameters for fixMarkup.
   *
   * @param {HighlightedHTMLElement} element - the HTML element to highlight
  */ function highlightElement(element) {
        /** @type HTMLElement */ let node = null;
        const language = blockLanguage(element);
        if (shouldNotHighlight(language)) return;
        // support for v10 API
        fire("before:highlightElement", {
            el: element,
            language: language
        });
        node = element;
        const text = node.textContent;
        const result = language ? highlight(text, {
            language: language,
            ignoreIllegals: true
        }) : highlightAuto(text);
        // support for v10 API
        fire("after:highlightElement", {
            el: element,
            result: result,
            text: text
        });
        element.innerHTML = result.value;
        updateClassName(element, language, result.language);
        element.result = {
            language: result.language,
            // TODO: remove with version 11.0
            re: result.relevance,
            relavance: result.relevance
        };
        if (result.second_best) element.second_best = {
            language: result.second_best.language,
            // TODO: remove with version 11.0
            re: result.second_best.relevance,
            relavance: result.second_best.relevance
        };
    }
    /**
   * Updates highlight.js global options with the passed options
   *
   * @param {Partial<HLJSOptions>} userOptions
   */ function configure(userOptions) {
        if (userOptions.useBR) {
            $f4840ac5e98a0872$var$deprecated("10.3.0", "'useBR' will be removed entirely in v11.0");
            $f4840ac5e98a0872$var$deprecated("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559");
        }
        options = $f4840ac5e98a0872$var$inherit$1(options, userOptions);
    }
    /**
   * Highlights to all <pre><code> blocks on a page
   *
   * @type {Function & {called?: boolean}}
   */ // TODO: remove v12, deprecated
    const initHighlighting = ()=>{
        if (initHighlighting.called) return;
        initHighlighting.called = true;
        $f4840ac5e98a0872$var$deprecated("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");
        const blocks = document.querySelectorAll("pre code");
        blocks.forEach(highlightElement);
    };
    // Higlights all when DOMContentLoaded fires
    // TODO: remove v12, deprecated
    function initHighlightingOnLoad() {
        $f4840ac5e98a0872$var$deprecated("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead.");
        wantsHighlight = true;
    }
    let wantsHighlight = false;
    /**
   * auto-highlights all pre>code elements on the page
   */ function highlightAll() {
        // if we are called too early in the loading process
        if (document.readyState === "loading") {
            wantsHighlight = true;
            return;
        }
        const blocks = document.querySelectorAll("pre code");
        blocks.forEach(highlightElement);
    }
    function boot() {
        // if a highlight was requested before DOM was loaded, do now
        if (wantsHighlight) highlightAll();
    }
    // make sure we are in the browser environment
    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("DOMContentLoaded", boot, false);
    /**
   * Register a language grammar module
   *
   * @param {string} languageName
   * @param {LanguageFn} languageDefinition
   */ function registerLanguage(languageName, languageDefinition) {
        let lang = null;
        try {
            lang = languageDefinition(hljs);
        } catch (error$1) {
            $f4840ac5e98a0872$var$error("Language definition for '{}' could not be registered.".replace("{}", languageName));
            // hard or soft error
            if (!SAFE_MODE) throw error$1;
            else $f4840ac5e98a0872$var$error(error$1);
            // languages that have serious errors are replaced with essentially a
            // "plaintext" stand-in so that the code blocks will still get normal
            // css classes applied to them - and one bad language won't break the
            // entire highlighter
            lang = PLAINTEXT_LANGUAGE;
        }
        // give it a temporary name if it doesn't have one in the meta-data
        if (!lang.name) lang.name = languageName;
        languages[languageName] = lang;
        lang.rawDefinition = languageDefinition.bind(null, hljs);
        if (lang.aliases) registerAliases(lang.aliases, {
            languageName: languageName
        });
    }
    /**
   * Remove a language grammar module
   *
   * @param {string} languageName
   */ function unregisterLanguage(languageName) {
        delete languages[languageName];
        for (const alias of Object.keys(aliases))if (aliases[alias] === languageName) delete aliases[alias];
    }
    /**
   * @returns {string[]} List of language internal names
   */ function listLanguages() {
        return Object.keys(languages);
    }
    /**
    intended usage: When one language truly requires another

    Unlike `getLanguage`, this will throw when the requested language
    is not available.

    @param {string} name - name of the language to fetch/require
    @returns {Language | never}
  */ function requireLanguage(name) {
        $f4840ac5e98a0872$var$deprecated("10.4.0", "requireLanguage will be removed entirely in v11.");
        $f4840ac5e98a0872$var$deprecated("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
        const lang = getLanguage(name);
        if (lang) return lang;
        const err = new Error("The '{}' language is required, but not loaded.".replace("{}", name));
        throw err;
    }
    /**
   * @param {string} name - name of the language to retrieve
   * @returns {Language | undefined}
   */ function getLanguage(name) {
        name = (name || "").toLowerCase();
        return languages[name] || languages[aliases[name]];
    }
    /**
   *
   * @param {string|string[]} aliasList - single alias or list of aliases
   * @param {{languageName: string}} opts
   */ function registerAliases(aliasList, { languageName: languageName }) {
        if (typeof aliasList === "string") aliasList = [
            aliasList
        ];
        aliasList.forEach((alias)=>{
            aliases[alias.toLowerCase()] = languageName;
        });
    }
    /**
   * Determines if a given language has auto-detection enabled
   * @param {string} name - name of the language
   */ function autoDetection(name) {
        const lang = getLanguage(name);
        return lang && !lang.disableAutodetect;
    }
    /**
   * Upgrades the old highlightBlock plugins to the new
   * highlightElement API
   * @param {HLJSPlugin} plugin
   */ function upgradePluginAPI(plugin) {
        // TODO: remove with v12
        if (plugin["before:highlightBlock"] && !plugin["before:highlightElement"]) plugin["before:highlightElement"] = (data)=>{
            plugin["before:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
        if (plugin["after:highlightBlock"] && !plugin["after:highlightElement"]) plugin["after:highlightElement"] = (data)=>{
            plugin["after:highlightBlock"](Object.assign({
                block: data.el
            }, data));
        };
    }
    /**
   * @param {HLJSPlugin} plugin
   */ function addPlugin(plugin) {
        upgradePluginAPI(plugin);
        plugins.push(plugin);
    }
    /**
   *
   * @param {PluginEvent} event
   * @param {any} args
   */ function fire(event, args) {
        const cb = event;
        plugins.forEach(function(plugin) {
            if (plugin[cb]) plugin[cb](args);
        });
    }
    /**
  Note: fixMarkup is deprecated and will be removed entirely in v11

  @param {string} arg
  @returns {string}
  */ function deprecateFixMarkup(arg) {
        $f4840ac5e98a0872$var$deprecated("10.2.0", "fixMarkup will be removed entirely in v11.0");
        $f4840ac5e98a0872$var$deprecated("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534");
        return fixMarkup(arg);
    }
    /**
   *
   * @param {HighlightedHTMLElement} el
   */ function deprecateHighlightBlock(el) {
        $f4840ac5e98a0872$var$deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0");
        $f4840ac5e98a0872$var$deprecated("10.7.0", "Please use highlightElement now.");
        return highlightElement(el);
    }
    /* Interface definition */ Object.assign(hljs, {
        highlight: highlight,
        highlightAuto: highlightAuto,
        highlightAll: highlightAll,
        fixMarkup: deprecateFixMarkup,
        highlightElement: highlightElement,
        // TODO: Remove with v12 API
        highlightBlock: deprecateHighlightBlock,
        configure: configure,
        initHighlighting: initHighlighting,
        initHighlightingOnLoad: initHighlightingOnLoad,
        registerLanguage: registerLanguage,
        unregisterLanguage: unregisterLanguage,
        listLanguages: listLanguages,
        getLanguage: getLanguage,
        registerAliases: registerAliases,
        requireLanguage: requireLanguage,
        autoDetection: autoDetection,
        inherit: $f4840ac5e98a0872$var$inherit$1,
        addPlugin: addPlugin,
        // plugins for frameworks
        vuePlugin: $f4840ac5e98a0872$var$BuildVuePlugin(hljs).VuePlugin
    });
    hljs.debugMode = function() {
        SAFE_MODE = false;
    };
    hljs.safeMode = function() {
        SAFE_MODE = true;
    };
    hljs.versionString = $f4840ac5e98a0872$var$version;
    for(const key in $f4840ac5e98a0872$var$MODES)// @ts-ignore
    if (typeof $f4840ac5e98a0872$var$MODES[key] === "object") // @ts-ignore
    $f4840ac5e98a0872$var$deepFreezeEs6($f4840ac5e98a0872$var$MODES[key]);
    // merge all the modes/regexs into our main object
    Object.assign(hljs, $f4840ac5e98a0872$var$MODES);
    // built-in plugins, likely to be moved out of core in the future
    hljs.addPlugin(brPlugin); // slated to be removed in v11
    hljs.addPlugin($f4840ac5e98a0872$var$mergeHTMLPlugin);
    hljs.addPlugin(tabReplacePlugin);
    return hljs;
};
// export an "instance" of the highlighter
var $f4840ac5e98a0872$var$highlight = $f4840ac5e98a0872$var$HLJS({});
$f4840ac5e98a0872$exports = $f4840ac5e98a0872$var$highlight;


var $dc01a5b92d52f0c6$exports = {};
"use strict";
var $19d6a55b320ee521$exports = {};
//
// format - printf-like string formatting for JavaScript
// github.com/samsonjs/format
// @_sjs
//
// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
//
// MIT License
// http://sjs.mit-license.org
//
(function() {
    //// Export the API
    var namespace;
    namespace = $19d6a55b320ee521$exports = format;
    namespace.format = format;
    namespace.vsprintf = vsprintf;
    if (typeof console !== "undefined" && typeof console.log === "function") namespace.printf = printf;
    function printf() {
        console.log(format.apply(null, arguments));
    }
    function vsprintf(fmt, replacements) {
        return format.apply(null, [
            fmt
        ].concat(replacements));
    }
    function format(fmt) {
        var argIndex = 1 // skip initial format argument
        , args = [].slice.call(arguments), i = 0, n = fmt.length, result = "", c, escaped = false, arg, tmp, leadingZero = false, precision, nextArg = function() {
            return args[argIndex++];
        }, slurpNumber = function() {
            var digits = "";
            while(/\d/.test(fmt[i])){
                digits += fmt[i++];
                c = fmt[i];
            }
            return digits.length > 0 ? parseInt(digits) : null;
        };
        for(; i < n; ++i){
            c = fmt[i];
            if (escaped) {
                escaped = false;
                if (c == ".") {
                    leadingZero = false;
                    c = fmt[++i];
                } else if (c == "0" && fmt[i + 1] == ".") {
                    leadingZero = true;
                    i += 2;
                    c = fmt[i];
                } else leadingZero = true;
                precision = slurpNumber();
                switch(c){
                    case "b":
                        result += parseInt(nextArg(), 10).toString(2);
                        break;
                    case "c":
                        arg = nextArg();
                        if (typeof arg === "string" || arg instanceof String) result += arg;
                        else result += String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                        result += parseInt(nextArg(), 10);
                        break;
                    case "f":
                        tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
                        result += leadingZero ? tmp : tmp.replace(/^0/, "");
                        break;
                    case "j":
                        result += JSON.stringify(nextArg());
                        break;
                    case "o":
                        result += "0" + parseInt(nextArg(), 10).toString(8);
                        break;
                    case "s":
                        result += nextArg();
                        break;
                    case "x":
                        result += "0x" + parseInt(nextArg(), 10).toString(16);
                        break;
                    case "X":
                        result += "0x" + parseInt(nextArg(), 10).toString(16).toUpperCase();
                        break;
                    default:
                        result += c;
                        break;
                }
            } else if (c === "%") escaped = true;
            else result += c;
        }
        return result;
    }
})();


var $dc01a5b92d52f0c6$var$fault = $dc01a5b92d52f0c6$var$create(Error);
$dc01a5b92d52f0c6$exports = $dc01a5b92d52f0c6$var$fault;
$dc01a5b92d52f0c6$var$fault.eval = $dc01a5b92d52f0c6$var$create(EvalError);
$dc01a5b92d52f0c6$var$fault.range = $dc01a5b92d52f0c6$var$create(RangeError);
$dc01a5b92d52f0c6$var$fault.reference = $dc01a5b92d52f0c6$var$create(ReferenceError);
$dc01a5b92d52f0c6$var$fault.syntax = $dc01a5b92d52f0c6$var$create(SyntaxError);
$dc01a5b92d52f0c6$var$fault.type = $dc01a5b92d52f0c6$var$create(TypeError);
$dc01a5b92d52f0c6$var$fault.uri = $dc01a5b92d52f0c6$var$create(URIError);
$dc01a5b92d52f0c6$var$fault.create = $dc01a5b92d52f0c6$var$create;
// Create a new `EConstructor`, with the formatted `format` as a first argument.
function $dc01a5b92d52f0c6$var$create(EConstructor) {
    FormattedError.displayName = EConstructor.displayName || EConstructor.name;
    return FormattedError;
    function FormattedError(format) {
        if (format) format = $19d6a55b320ee521$exports.apply(null, arguments);
        return new EConstructor(format);
    }
}


$bd598f23a65af4c7$export$e4043f67d36cbb26 = $bd598f23a65af4c7$var$highlight;
$bd598f23a65af4c7$export$a6bd8adaea6db17d = $bd598f23a65af4c7$var$highlightAuto;
$bd598f23a65af4c7$export$b5daeabefb05ee6b = $bd598f23a65af4c7$var$registerLanguage;
$bd598f23a65af4c7$export$bef285e71abac9c = $bd598f23a65af4c7$var$listLanguages;
$bd598f23a65af4c7$export$51e83cf7ba679d8d = $bd598f23a65af4c7$var$registerAlias;
$bd598f23a65af4c7$var$Emitter.prototype.addText = $bd598f23a65af4c7$var$text;
$bd598f23a65af4c7$var$Emitter.prototype.addKeyword = $bd598f23a65af4c7$var$addKeyword;
$bd598f23a65af4c7$var$Emitter.prototype.addSublanguage = $bd598f23a65af4c7$var$addSublanguage;
$bd598f23a65af4c7$var$Emitter.prototype.openNode = $bd598f23a65af4c7$var$open;
$bd598f23a65af4c7$var$Emitter.prototype.closeNode = $bd598f23a65af4c7$var$close;
$bd598f23a65af4c7$var$Emitter.prototype.closeAllNodes = $bd598f23a65af4c7$var$noop;
$bd598f23a65af4c7$var$Emitter.prototype.finalize = $bd598f23a65af4c7$var$noop;
$bd598f23a65af4c7$var$Emitter.prototype.toHTML = $bd598f23a65af4c7$var$toHtmlNoop;
var $bd598f23a65af4c7$var$defaultPrefix = "hljs-";
// Highlighting `value` in the language `name`.
function $bd598f23a65af4c7$var$highlight(name, value, options) {
    var before = $f4840ac5e98a0872$exports.configure({});
    var settings = options || {};
    var prefix = settings.prefix;
    var result;
    if (typeof name !== "string") throw $dc01a5b92d52f0c6$exports("Expected `string` for name, got `%s`", name);
    if (!$f4840ac5e98a0872$exports.getLanguage(name)) throw $dc01a5b92d52f0c6$exports("Unknown language: `%s` is not registered", name);
    if (typeof value !== "string") throw $dc01a5b92d52f0c6$exports("Expected `string` for value, got `%s`", value);
    if (prefix === null || prefix === undefined) prefix = $bd598f23a65af4c7$var$defaultPrefix;
    $f4840ac5e98a0872$exports.configure({
        __emitter: $bd598f23a65af4c7$var$Emitter,
        classPrefix: prefix
    });
    result = $f4840ac5e98a0872$exports.highlight(value, {
        language: name,
        ignoreIllegals: true
    });
    $f4840ac5e98a0872$exports.configure(before || {});
    /* istanbul ignore if - Highlight.js seems to use this (currently) for broken
   * grammars, so let’s keep it in there just to be sure. */ if (result.errorRaised) throw result.errorRaised;
    return {
        relevance: result.relevance,
        language: result.language,
        value: result.emitter.rootNode.children
    };
}
function $bd598f23a65af4c7$var$highlightAuto(value, options) {
    var settings = options || {};
    var subset = settings.subset || $f4840ac5e98a0872$exports.listLanguages();
    var prefix = settings.prefix;
    var length = subset.length;
    var index = -1;
    var result;
    var secondBest;
    var current;
    var name;
    if (prefix === null || prefix === undefined) prefix = $bd598f23a65af4c7$var$defaultPrefix;
    if (typeof value !== "string") throw $dc01a5b92d52f0c6$exports("Expected `string` for value, got `%s`", value);
    secondBest = {
        relevance: 0,
        language: null,
        value: []
    };
    result = {
        relevance: 0,
        language: null,
        value: []
    };
    while(++index < length){
        name = subset[index];
        if (!$f4840ac5e98a0872$exports.getLanguage(name)) continue;
        current = $bd598f23a65af4c7$var$highlight(name, value, options);
        current.language = name;
        if (current.relevance > secondBest.relevance) secondBest = current;
        if (current.relevance > result.relevance) {
            secondBest = result;
            result = current;
        }
    }
    if (secondBest.language) result.secondBest = secondBest;
    return result;
}
// Register a language.
function $bd598f23a65af4c7$var$registerLanguage(name, syntax) {
    $f4840ac5e98a0872$exports.registerLanguage(name, syntax);
}
// Get a list of all registered languages.
function $bd598f23a65af4c7$var$listLanguages() {
    return $f4840ac5e98a0872$exports.listLanguages();
}
// Register more aliases for an already registered language.
function $bd598f23a65af4c7$var$registerAlias(name, alias) {
    var map = name;
    var key;
    if (alias) {
        map = {};
        map[name] = alias;
    }
    for(key in map)$f4840ac5e98a0872$exports.registerAliases(map[key], {
        languageName: key
    });
}
function $bd598f23a65af4c7$var$Emitter(options) {
    this.options = options;
    this.rootNode = {
        children: []
    };
    this.stack = [
        this.rootNode
    ];
}
function $bd598f23a65af4c7$var$addKeyword(value, name) {
    this.openNode(name);
    this.addText(value);
    this.closeNode();
}
function $bd598f23a65af4c7$var$addSublanguage(other, name) {
    var stack = this.stack;
    var current = stack[stack.length - 1];
    var results = other.rootNode.children;
    var node = name ? {
        type: "element",
        tagName: "span",
        properties: {
            className: [
                name
            ]
        },
        children: results
    } : results;
    current.children = current.children.concat(node);
}
function $bd598f23a65af4c7$var$text(value) {
    var stack = this.stack;
    var current;
    var tail;
    if (value === "") return;
    current = stack[stack.length - 1];
    tail = current.children[current.children.length - 1];
    if (tail && tail.type === "text") tail.value += value;
    else current.children.push({
        type: "text",
        value: value
    });
}
function $bd598f23a65af4c7$var$open(name) {
    var stack = this.stack;
    var className = this.options.classPrefix + name;
    var current = stack[stack.length - 1];
    var child = {
        type: "element",
        tagName: "span",
        properties: {
            className: [
                className
            ]
        },
        children: []
    };
    current.children.push(child);
    stack.push(child);
}
function $bd598f23a65af4c7$var$close() {
    this.stack.pop();
}
function $bd598f23a65af4c7$var$toHtmlNoop() {
    return "";
}
function $bd598f23a65af4c7$var$noop() {}


$ea32d90378aa2fb5$exports = $bd598f23a65af4c7$exports;

$bd598f23a65af4c7$exports.registerLanguage("1c", (parcelRequire("8m5tQ")));

$bd598f23a65af4c7$exports.registerLanguage("abnf", (parcelRequire("jzZa4")));

$bd598f23a65af4c7$exports.registerLanguage("accesslog", (parcelRequire("ePTdO")));

$bd598f23a65af4c7$exports.registerLanguage("actionscript", (parcelRequire("jYOgV")));

$bd598f23a65af4c7$exports.registerLanguage("ada", (parcelRequire("7wzO7")));

$bd598f23a65af4c7$exports.registerLanguage("angelscript", (parcelRequire("2PUwx")));

$bd598f23a65af4c7$exports.registerLanguage("apache", (parcelRequire("9hmTb")));

$bd598f23a65af4c7$exports.registerLanguage("applescript", (parcelRequire("8Vvqc")));

$bd598f23a65af4c7$exports.registerLanguage("arcade", (parcelRequire("j1C1h")));

$bd598f23a65af4c7$exports.registerLanguage("arduino", (parcelRequire("hlBw7")));

$bd598f23a65af4c7$exports.registerLanguage("armasm", (parcelRequire("dlNkY")));

$bd598f23a65af4c7$exports.registerLanguage("xml", (parcelRequire("kB1SH")));

$bd598f23a65af4c7$exports.registerLanguage("asciidoc", (parcelRequire("gkbm1")));

$bd598f23a65af4c7$exports.registerLanguage("aspectj", (parcelRequire("63yFf")));

$bd598f23a65af4c7$exports.registerLanguage("autohotkey", (parcelRequire("8BAsx")));

$bd598f23a65af4c7$exports.registerLanguage("autoit", (parcelRequire("hfevr")));

$bd598f23a65af4c7$exports.registerLanguage("avrasm", (parcelRequire("6w0Vy")));

$bd598f23a65af4c7$exports.registerLanguage("awk", (parcelRequire("4FtHV")));

$bd598f23a65af4c7$exports.registerLanguage("axapta", (parcelRequire("HfSOx")));

$bd598f23a65af4c7$exports.registerLanguage("bash", (parcelRequire("cheUk")));

$bd598f23a65af4c7$exports.registerLanguage("basic", (parcelRequire("ahe0r")));

$bd598f23a65af4c7$exports.registerLanguage("bnf", (parcelRequire("MnP3I")));

$bd598f23a65af4c7$exports.registerLanguage("brainfuck", (parcelRequire("5IOyj")));

$bd598f23a65af4c7$exports.registerLanguage("c-like", (parcelRequire("fCRY0")));

$bd598f23a65af4c7$exports.registerLanguage("c", (parcelRequire("cpOKh")));

$bd598f23a65af4c7$exports.registerLanguage("cal", (parcelRequire("ixHQI")));

$bd598f23a65af4c7$exports.registerLanguage("capnproto", (parcelRequire("74F4K")));

$bd598f23a65af4c7$exports.registerLanguage("ceylon", (parcelRequire("jfjbY")));

$bd598f23a65af4c7$exports.registerLanguage("clean", (parcelRequire("bNu1a")));

$bd598f23a65af4c7$exports.registerLanguage("clojure", (parcelRequire("8Pjhc")));

$bd598f23a65af4c7$exports.registerLanguage("clojure-repl", (parcelRequire("4GKer")));

$bd598f23a65af4c7$exports.registerLanguage("cmake", (parcelRequire("e8EoF")));

$bd598f23a65af4c7$exports.registerLanguage("coffeescript", (parcelRequire("aK6iY")));

$bd598f23a65af4c7$exports.registerLanguage("coq", (parcelRequire("jlnGk")));

$bd598f23a65af4c7$exports.registerLanguage("cos", (parcelRequire("dUE2d")));

$bd598f23a65af4c7$exports.registerLanguage("cpp", (parcelRequire("lmzvz")));

$bd598f23a65af4c7$exports.registerLanguage("crmsh", (parcelRequire("6QJGt")));

$bd598f23a65af4c7$exports.registerLanguage("crystal", (parcelRequire("2jJYq")));

$bd598f23a65af4c7$exports.registerLanguage("csharp", (parcelRequire("gazCZ")));

$bd598f23a65af4c7$exports.registerLanguage("csp", (parcelRequire("jrFBM")));

$bd598f23a65af4c7$exports.registerLanguage("css", (parcelRequire("jRcsb")));

$bd598f23a65af4c7$exports.registerLanguage("d", (parcelRequire("4N24D")));

$bd598f23a65af4c7$exports.registerLanguage("markdown", (parcelRequire("c1rMz")));

$bd598f23a65af4c7$exports.registerLanguage("dart", (parcelRequire("iUUCy")));

$bd598f23a65af4c7$exports.registerLanguage("delphi", (parcelRequire("7Nt9h")));

$bd598f23a65af4c7$exports.registerLanguage("diff", (parcelRequire("7CY40")));

$bd598f23a65af4c7$exports.registerLanguage("django", (parcelRequire("hSwnX")));

$bd598f23a65af4c7$exports.registerLanguage("dns", (parcelRequire("eb8CG")));

$bd598f23a65af4c7$exports.registerLanguage("dockerfile", (parcelRequire("5nRkt")));

$bd598f23a65af4c7$exports.registerLanguage("dos", (parcelRequire("9jpnQ")));

$bd598f23a65af4c7$exports.registerLanguage("dsconfig", (parcelRequire("3ipgz")));

$bd598f23a65af4c7$exports.registerLanguage("dts", (parcelRequire("gntgi")));

$bd598f23a65af4c7$exports.registerLanguage("dust", (parcelRequire("4CIEe")));

$bd598f23a65af4c7$exports.registerLanguage("ebnf", (parcelRequire("ahRAo")));

$bd598f23a65af4c7$exports.registerLanguage("elixir", (parcelRequire("b2fxC")));

$bd598f23a65af4c7$exports.registerLanguage("elm", (parcelRequire("j8dfG")));

$bd598f23a65af4c7$exports.registerLanguage("ruby", (parcelRequire("6ykfy")));

$bd598f23a65af4c7$exports.registerLanguage("erb", (parcelRequire("dliKk")));

$bd598f23a65af4c7$exports.registerLanguage("erlang-repl", (parcelRequire("ldUmx")));

$bd598f23a65af4c7$exports.registerLanguage("erlang", (parcelRequire("lpGxw")));

$bd598f23a65af4c7$exports.registerLanguage("excel", (parcelRequire("jetw7")));

$bd598f23a65af4c7$exports.registerLanguage("fix", (parcelRequire("2gdJp")));

$bd598f23a65af4c7$exports.registerLanguage("flix", (parcelRequire("gh4Hb")));

$bd598f23a65af4c7$exports.registerLanguage("fortran", (parcelRequire("b6Sro")));

$bd598f23a65af4c7$exports.registerLanguage("fsharp", (parcelRequire("l9gyx")));

$bd598f23a65af4c7$exports.registerLanguage("gams", (parcelRequire("dsDLC")));

$bd598f23a65af4c7$exports.registerLanguage("gauss", (parcelRequire("7BbCT")));

$bd598f23a65af4c7$exports.registerLanguage("gcode", (parcelRequire("iB6Fn")));

$bd598f23a65af4c7$exports.registerLanguage("gherkin", (parcelRequire("3BTtX")));

$bd598f23a65af4c7$exports.registerLanguage("glsl", (parcelRequire("gp7HK")));

$bd598f23a65af4c7$exports.registerLanguage("gml", (parcelRequire("3jkHQ")));

$bd598f23a65af4c7$exports.registerLanguage("go", (parcelRequire("eCnIO")));

$bd598f23a65af4c7$exports.registerLanguage("golo", (parcelRequire("fItrr")));

$bd598f23a65af4c7$exports.registerLanguage("gradle", (parcelRequire("l8Fwd")));

$bd598f23a65af4c7$exports.registerLanguage("groovy", (parcelRequire("8cUJC")));

$bd598f23a65af4c7$exports.registerLanguage("haml", (parcelRequire("higtC")));

$bd598f23a65af4c7$exports.registerLanguage("handlebars", (parcelRequire("hkha6")));

$bd598f23a65af4c7$exports.registerLanguage("haskell", (parcelRequire("ciB8y")));

$bd598f23a65af4c7$exports.registerLanguage("haxe", (parcelRequire("freT9")));

$bd598f23a65af4c7$exports.registerLanguage("hsp", (parcelRequire("fWLHt")));

$bd598f23a65af4c7$exports.registerLanguage("htmlbars", (parcelRequire("3lp2P")));

$bd598f23a65af4c7$exports.registerLanguage("http", (parcelRequire("dFhmZ")));

$bd598f23a65af4c7$exports.registerLanguage("hy", (parcelRequire("43oHJ")));

$bd598f23a65af4c7$exports.registerLanguage("inform7", (parcelRequire("c9gLT")));

$bd598f23a65af4c7$exports.registerLanguage("ini", (parcelRequire("3oDqc")));

$bd598f23a65af4c7$exports.registerLanguage("irpf90", (parcelRequire("gM8oT")));

$bd598f23a65af4c7$exports.registerLanguage("isbl", (parcelRequire("ewc1c")));

$bd598f23a65af4c7$exports.registerLanguage("java", (parcelRequire("lhbPW")));

$bd598f23a65af4c7$exports.registerLanguage("javascript", (parcelRequire("hXeXQ")));

$bd598f23a65af4c7$exports.registerLanguage("jboss-cli", (parcelRequire("14ZtH")));

$bd598f23a65af4c7$exports.registerLanguage("json", (parcelRequire("hIDeD")));

$bd598f23a65af4c7$exports.registerLanguage("julia", (parcelRequire("lMPba")));

$bd598f23a65af4c7$exports.registerLanguage("julia-repl", (parcelRequire("b58C8")));

$bd598f23a65af4c7$exports.registerLanguage("kotlin", (parcelRequire("kJmbc")));

$bd598f23a65af4c7$exports.registerLanguage("lasso", (parcelRequire("fcj0z")));

$bd598f23a65af4c7$exports.registerLanguage("latex", (parcelRequire("aZs14")));

$bd598f23a65af4c7$exports.registerLanguage("ldif", (parcelRequire("e6tv5")));

$bd598f23a65af4c7$exports.registerLanguage("leaf", (parcelRequire("1zfr3")));

$bd598f23a65af4c7$exports.registerLanguage("less", (parcelRequire("hL458")));

$bd598f23a65af4c7$exports.registerLanguage("lisp", (parcelRequire("atsIb")));

$bd598f23a65af4c7$exports.registerLanguage("livecodeserver", (parcelRequire("16j1K")));

$bd598f23a65af4c7$exports.registerLanguage("livescript", (parcelRequire("5bJQY")));

$bd598f23a65af4c7$exports.registerLanguage("llvm", (parcelRequire("lCRAk")));

$bd598f23a65af4c7$exports.registerLanguage("lsl", (parcelRequire("9Re3w")));

$bd598f23a65af4c7$exports.registerLanguage("lua", (parcelRequire("7rY7i")));

$bd598f23a65af4c7$exports.registerLanguage("makefile", (parcelRequire("6YHAI")));

$bd598f23a65af4c7$exports.registerLanguage("mathematica", (parcelRequire("9e07y")));

$bd598f23a65af4c7$exports.registerLanguage("matlab", (parcelRequire("2DX6A")));

$bd598f23a65af4c7$exports.registerLanguage("maxima", (parcelRequire("aUT8O")));

$bd598f23a65af4c7$exports.registerLanguage("mel", (parcelRequire("z4A3a")));

$bd598f23a65af4c7$exports.registerLanguage("mercury", (parcelRequire("jU8Uv")));

$bd598f23a65af4c7$exports.registerLanguage("mipsasm", (parcelRequire("bwGfp")));

$bd598f23a65af4c7$exports.registerLanguage("mizar", (parcelRequire("fQkZ1")));

$bd598f23a65af4c7$exports.registerLanguage("perl", (parcelRequire("8MPLA")));

$bd598f23a65af4c7$exports.registerLanguage("mojolicious", (parcelRequire("fkIyq")));

$bd598f23a65af4c7$exports.registerLanguage("monkey", (parcelRequire("adFFh")));

$bd598f23a65af4c7$exports.registerLanguage("moonscript", (parcelRequire("6QlzV")));

$bd598f23a65af4c7$exports.registerLanguage("n1ql", (parcelRequire("39pDl")));

$bd598f23a65af4c7$exports.registerLanguage("nginx", (parcelRequire("gPoTD")));

$bd598f23a65af4c7$exports.registerLanguage("nim", (parcelRequire("gRhge")));

$bd598f23a65af4c7$exports.registerLanguage("nix", (parcelRequire("1m60g")));

$bd598f23a65af4c7$exports.registerLanguage("node-repl", (parcelRequire("i57b6")));

$bd598f23a65af4c7$exports.registerLanguage("nsis", (parcelRequire("dHmDc")));

$bd598f23a65af4c7$exports.registerLanguage("objectivec", (parcelRequire("dCB9T")));

$bd598f23a65af4c7$exports.registerLanguage("ocaml", (parcelRequire("f6CSv")));

$bd598f23a65af4c7$exports.registerLanguage("openscad", (parcelRequire("1vj8j")));

$bd598f23a65af4c7$exports.registerLanguage("oxygene", (parcelRequire("amStw")));

$bd598f23a65af4c7$exports.registerLanguage("parser3", (parcelRequire("caY3R")));

$bd598f23a65af4c7$exports.registerLanguage("pf", (parcelRequire("2YmYa")));

$bd598f23a65af4c7$exports.registerLanguage("pgsql", (parcelRequire("5h1Dk")));

$bd598f23a65af4c7$exports.registerLanguage("php", (parcelRequire("5CEHT")));

$bd598f23a65af4c7$exports.registerLanguage("php-template", (parcelRequire("aGPf1")));

$bd598f23a65af4c7$exports.registerLanguage("plaintext", (parcelRequire("1FKm9")));

$bd598f23a65af4c7$exports.registerLanguage("pony", (parcelRequire("7jCd3")));

$bd598f23a65af4c7$exports.registerLanguage("powershell", (parcelRequire("5SMky")));

$bd598f23a65af4c7$exports.registerLanguage("processing", (parcelRequire("8wTNK")));

$bd598f23a65af4c7$exports.registerLanguage("profile", (parcelRequire("9W4AC")));

$bd598f23a65af4c7$exports.registerLanguage("prolog", (parcelRequire("cRudC")));

$bd598f23a65af4c7$exports.registerLanguage("properties", (parcelRequire("iF6qb")));

$bd598f23a65af4c7$exports.registerLanguage("protobuf", (parcelRequire("6vldq")));

$bd598f23a65af4c7$exports.registerLanguage("puppet", (parcelRequire("3Lh4K")));

$bd598f23a65af4c7$exports.registerLanguage("purebasic", (parcelRequire("5JTQt")));

$bd598f23a65af4c7$exports.registerLanguage("python", (parcelRequire("ly5Ff")));

$bd598f23a65af4c7$exports.registerLanguage("python-repl", (parcelRequire("34yz7")));

$bd598f23a65af4c7$exports.registerLanguage("q", (parcelRequire("bzIMw")));

$bd598f23a65af4c7$exports.registerLanguage("qml", (parcelRequire("6fYUw")));

$bd598f23a65af4c7$exports.registerLanguage("r", (parcelRequire("bqL6M")));

$bd598f23a65af4c7$exports.registerLanguage("reasonml", (parcelRequire("fKypu")));

$bd598f23a65af4c7$exports.registerLanguage("rib", (parcelRequire("f88HE")));

$bd598f23a65af4c7$exports.registerLanguage("roboconf", (parcelRequire("gbKHl")));

$bd598f23a65af4c7$exports.registerLanguage("routeros", (parcelRequire("iQUn5")));

$bd598f23a65af4c7$exports.registerLanguage("rsl", (parcelRequire("2mZxq")));

$bd598f23a65af4c7$exports.registerLanguage("ruleslanguage", (parcelRequire("gfBOr")));

$bd598f23a65af4c7$exports.registerLanguage("rust", (parcelRequire("bfORy")));

$bd598f23a65af4c7$exports.registerLanguage("sas", (parcelRequire("2bWJg")));

$bd598f23a65af4c7$exports.registerLanguage("scala", (parcelRequire("gJPco")));

$bd598f23a65af4c7$exports.registerLanguage("scheme", (parcelRequire("2kAZn")));

$bd598f23a65af4c7$exports.registerLanguage("scilab", (parcelRequire("k3MqZ")));

$bd598f23a65af4c7$exports.registerLanguage("scss", (parcelRequire("3qcwH")));

$bd598f23a65af4c7$exports.registerLanguage("shell", (parcelRequire("68ktp")));

$bd598f23a65af4c7$exports.registerLanguage("smali", (parcelRequire("2htv8")));

$bd598f23a65af4c7$exports.registerLanguage("smalltalk", (parcelRequire("le1df")));

$bd598f23a65af4c7$exports.registerLanguage("sml", (parcelRequire("eKuVF")));

$bd598f23a65af4c7$exports.registerLanguage("sqf", (parcelRequire("16hNA")));

$bd598f23a65af4c7$exports.registerLanguage("sql_more", (parcelRequire("dpe6f")));

$bd598f23a65af4c7$exports.registerLanguage("sql", (parcelRequire("5VO9I")));

$bd598f23a65af4c7$exports.registerLanguage("stan", (parcelRequire("djWDs")));

$bd598f23a65af4c7$exports.registerLanguage("stata", (parcelRequire("czGB8")));

$bd598f23a65af4c7$exports.registerLanguage("step21", (parcelRequire("lsJDk")));

$bd598f23a65af4c7$exports.registerLanguage("stylus", (parcelRequire("6hHNE")));

$bd598f23a65af4c7$exports.registerLanguage("subunit", (parcelRequire("7JIKd")));

$bd598f23a65af4c7$exports.registerLanguage("swift", (parcelRequire("3Vwbc")));

$bd598f23a65af4c7$exports.registerLanguage("taggerscript", (parcelRequire("95S8w")));

$bd598f23a65af4c7$exports.registerLanguage("yaml", (parcelRequire("9Q3uF")));

$bd598f23a65af4c7$exports.registerLanguage("tap", (parcelRequire("e9h52")));

$bd598f23a65af4c7$exports.registerLanguage("tcl", (parcelRequire("5a08n")));

$bd598f23a65af4c7$exports.registerLanguage("thrift", (parcelRequire("7FuCM")));

$bd598f23a65af4c7$exports.registerLanguage("tp", (parcelRequire("fZGmp")));

$bd598f23a65af4c7$exports.registerLanguage("twig", (parcelRequire("2NhyA")));

$bd598f23a65af4c7$exports.registerLanguage("typescript", (parcelRequire("1loeR")));

$bd598f23a65af4c7$exports.registerLanguage("vala", (parcelRequire("c7YeD")));

$bd598f23a65af4c7$exports.registerLanguage("vbnet", (parcelRequire("ctiKc")));

$bd598f23a65af4c7$exports.registerLanguage("vbscript", (parcelRequire("aCEs1")));

$bd598f23a65af4c7$exports.registerLanguage("vbscript-html", (parcelRequire("i3NKp")));

$bd598f23a65af4c7$exports.registerLanguage("verilog", (parcelRequire("e1Vbh")));

$bd598f23a65af4c7$exports.registerLanguage("vhdl", (parcelRequire("fqQ9v")));

$bd598f23a65af4c7$exports.registerLanguage("vim", (parcelRequire("gs6c3")));

$bd598f23a65af4c7$exports.registerLanguage("x86asm", (parcelRequire("1shLC")));

$bd598f23a65af4c7$exports.registerLanguage("xl", (parcelRequire("2Q6SU")));

$bd598f23a65af4c7$exports.registerLanguage("xquery", (parcelRequire("in7A8")));

$bd598f23a65af4c7$exports.registerLanguage("zephir", (parcelRequire("2c2Kl")));


//
// This file has been auto-generated by the `npm run build-languages-hljs` task
//
var $8bee6e99d338b0bb$export$2e2bcd8739ae039 = [
    "1c",
    "abnf",
    "accesslog",
    "actionscript",
    "ada",
    "angelscript",
    "apache",
    "applescript",
    "arcade",
    "arduino",
    "armasm",
    "asciidoc",
    "aspectj",
    "autohotkey",
    "autoit",
    "avrasm",
    "awk",
    "axapta",
    "bash",
    "basic",
    "bnf",
    "brainfuck",
    "c-like",
    "c",
    "cal",
    "capnproto",
    "ceylon",
    "clean",
    "clojure-repl",
    "clojure",
    "cmake",
    "coffeescript",
    "coq",
    "cos",
    "cpp",
    "crmsh",
    "crystal",
    "csharp",
    "csp",
    "css",
    "d",
    "dart",
    "delphi",
    "diff",
    "django",
    "dns",
    "dockerfile",
    "dos",
    "dsconfig",
    "dts",
    "dust",
    "ebnf",
    "elixir",
    "elm",
    "erb",
    "erlang-repl",
    "erlang",
    "excel",
    "fix",
    "flix",
    "fortran",
    "fsharp",
    "gams",
    "gauss",
    "gcode",
    "gherkin",
    "glsl",
    "gml",
    "go",
    "golo",
    "gradle",
    "groovy",
    "haml",
    "handlebars",
    "haskell",
    "haxe",
    "hsp",
    "htmlbars",
    "http",
    "hy",
    "inform7",
    "ini",
    "irpf90",
    "isbl",
    "java",
    "javascript",
    "jboss-cli",
    "json",
    "julia-repl",
    "julia",
    "kotlin",
    "lasso",
    "latex",
    "ldif",
    "leaf",
    "less",
    "lisp",
    "livecodeserver",
    "livescript",
    "llvm",
    "lsl",
    "lua",
    "makefile",
    "markdown",
    "mathematica",
    "matlab",
    "maxima",
    "mel",
    "mercury",
    "mipsasm",
    "mizar",
    "mojolicious",
    "monkey",
    "moonscript",
    "n1ql",
    "nginx",
    "nim",
    "nix",
    "node-repl",
    "nsis",
    "objectivec",
    "ocaml",
    "openscad",
    "oxygene",
    "parser3",
    "perl",
    "pf",
    "pgsql",
    "php-template",
    "php",
    "plaintext",
    "pony",
    "powershell",
    "processing",
    "profile",
    "prolog",
    "properties",
    "protobuf",
    "puppet",
    "purebasic",
    "python-repl",
    "python",
    "q",
    "qml",
    "r",
    "reasonml",
    "rib",
    "roboconf",
    "routeros",
    "rsl",
    "ruby",
    "ruleslanguage",
    "rust",
    "sas",
    "scala",
    "scheme",
    "scilab",
    "scss",
    "shell",
    "smali",
    "smalltalk",
    "sml",
    "sqf",
    "sql",
    "sql_more",
    "stan",
    "stata",
    "step21",
    "stylus",
    "subunit",
    "swift",
    "taggerscript",
    "tap",
    "tcl",
    "thrift",
    "tp",
    "twig",
    "typescript",
    "vala",
    "vbnet",
    "vbscript-html",
    "vbscript",
    "verilog",
    "vhdl",
    "vim",
    "x86asm",
    "xl",
    "xml",
    "xquery",
    "yaml",
    "zephir"
];


var $f82fa76f7cd6c66f$var$highlighter = (0, $b94dbc74b29e9f13$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($ea32d90378aa2fb5$exports))), (0, $52d829bfc3e728d7$export$2e2bcd8739ae039));
$f82fa76f7cd6c66f$var$highlighter.supportedLanguages = (0, $8bee6e99d338b0bb$export$2e2bcd8739ae039);
var $f82fa76f7cd6c66f$export$2e2bcd8739ae039 = $f82fa76f7cd6c66f$var$highlighter;


var $cc80cfec0bf62955$export$2e2bcd8739ae039 = {
    "hljs": {
        "display": "block",
        "overflowX": "auto",
        "padding": "0.5em",
        "background": "#011627",
        "color": "#d6deeb"
    },
    "hljs-keyword": {
        "color": "#c792ea",
        "fontStyle": "italic"
    },
    "hljs-built_in": {
        "color": "#addb67",
        "fontStyle": "italic"
    },
    "hljs-type": {
        "color": "#82aaff"
    },
    "hljs-literal": {
        "color": "#ff5874"
    },
    "hljs-number": {
        "color": "#F78C6C"
    },
    "hljs-regexp": {
        "color": "#5ca7e4"
    },
    "hljs-string": {
        "color": "#ecc48d"
    },
    "hljs-subst": {
        "color": "#d3423e"
    },
    "hljs-symbol": {
        "color": "#82aaff"
    },
    "hljs-class": {
        "color": "#ffcb8b"
    },
    "hljs-function": {
        "color": "#82AAFF"
    },
    "hljs-title": {
        "color": "#DCDCAA",
        "fontStyle": "italic"
    },
    "hljs-params": {
        "color": "#7fdbca"
    },
    "hljs-comment": {
        "color": "#637777",
        "fontStyle": "italic"
    },
    "hljs-doctag": {
        "color": "#7fdbca"
    },
    "hljs-meta": {
        "color": "#82aaff"
    },
    "hljs-meta-keyword": {
        "color": "#82aaff"
    },
    "hljs-meta-string": {
        "color": "#ecc48d"
    },
    "hljs-section": {
        "color": "#82b1ff"
    },
    "hljs-tag": {
        "color": "#7fdbca"
    },
    "hljs-name": {
        "color": "#7fdbca"
    },
    "hljs-builtin-name": {
        "color": "#7fdbca"
    },
    "hljs-attr": {
        "color": "#7fdbca"
    },
    "hljs-attribute": {
        "color": "#80cbc4"
    },
    "hljs-variable": {
        "color": "#addb67"
    },
    "hljs-bullet": {
        "color": "#d9f5dd"
    },
    "hljs-code": {
        "color": "#80CBC4"
    },
    "hljs-emphasis": {
        "color": "#c792ea",
        "fontStyle": "italic"
    },
    "hljs-strong": {
        "color": "#addb67",
        "fontWeight": "bold"
    },
    "hljs-formula": {
        "color": "#c792ea"
    },
    "hljs-link": {
        "color": "#ff869a"
    },
    "hljs-quote": {
        "color": "#697098",
        "fontStyle": "italic"
    },
    "hljs-selector-tag": {
        "color": "#ff6363"
    },
    "hljs-selector-id": {
        "color": "#fad430"
    },
    "hljs-selector-class": {
        "color": "#addb67",
        "fontStyle": "italic"
    },
    "hljs-selector-attr": {
        "color": "#c792ea",
        "fontStyle": "italic"
    },
    "hljs-selector-pseudo": {
        "color": "#c792ea",
        "fontStyle": "italic"
    },
    "hljs-template-tag": {
        "color": "#c792ea"
    },
    "hljs-template-variable": {
        "color": "#addb67"
    },
    "hljs-addition": {
        "color": "#addb67ff",
        "fontStyle": "italic"
    },
    "hljs-deletion": {
        "color": "#EF535090",
        "fontStyle": "italic"
    }
};



const $31654cd1dbe40fbe$export$88ca206278a45434 = ({ data: data, title: title })=>{
    const [isMinmized, setIsMinmized] = (0, $acw62.useState)(true);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$9a0ca9bdc2920152$export$70cc9a28a6c819c0}  ${isMinmized ? $9a0ca9bdc2920152$export$61419bb05c687ee3 : ""}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: `flex flex-center justify-between ${$9a0ca9bdc2920152$export$a3ff96a524f373ff}`,
                onClick: ()=>setIsMinmized(!isMinmized),
                children: [
                    "Debug",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            transform: `rotate(${isMinmized ? "180" : "0"})`
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee1790168eebbcf3$export$65be7b63f510f362), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                className: "p2",
                children: [
                    data.length && title ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "white",
                        children: title
                    }) : null,
                    data.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f82fa76f7cd6c66f$export$2e2bcd8739ae039), {
                        language: "javascript",
                        style: (0, $cc80cfec0bf62955$export$2e2bcd8739ae039),
                        wrapLongLines: true,
                        children: JSON.stringify(data, null, 2)
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                        className: "white",
                        children: "No data passed to the Debug Pane."
                    })
                ]
            })
        ]
    });
};








/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 
/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ 

var $acw62 = parcelRequire("acw62");


var $b09fa11bbab2e6c3$export$f9f39c6c13ec0e21;
var $b09fa11bbab2e6c3$export$46ca3e9f3d219720;
var $b09fa11bbab2e6c3$export$4d16178ab09a8b0;
var $b09fa11bbab2e6c3$export$8f9bd17e3a898bbb;
$b09fa11bbab2e6c3$export$f9f39c6c13ec0e21 = `r1vTpa_picker-button`;
$b09fa11bbab2e6c3$export$46ca3e9f3d219720 = `r1vTpa_picker-button-item`;
$b09fa11bbab2e6c3$export$4d16178ab09a8b0 = `r1vTpa_picker-button-item-label`;
$b09fa11bbab2e6c3$export$8f9bd17e3a898bbb = `r1vTpa_picker-button-list`;


/*
 * Copyright (C) 2024 Curity AB. All rights reserved.
 *
 * The contents of this file are the property of Curity AB.
 * You may not copy or use this file, in either source code
 * or executable form, except in compliance with terms
 * set by Curity AB.
 *
 * For further information, please contact Curity AB.
 */ function $9b91ad5c4a00d4b3$export$cbc6006367cb5d5d(credential, languages) {
    return credential.userDefinedName || $9b91ad5c4a00d4b3$var$getCredentialName(credential, languages);
}
function $9b91ad5c4a00d4b3$var$getCredentialName(credential, languages) {
    const didJwtVcJsonCredential = credential.credential.didJwtVcJson;
    if (didJwtVcJsonCredential) return didJwtVcJsonCredential.credentialDisplay.getBestMatchForLocales(languages).name;
    else // TODO have a fallback value to show
    return "credential";
}



const $c7dd81570d314681$export$ba25329847403e11 = ({ credentials: credentials, callToAction: callToAction, viewMessage: viewMessage, onCredentialSelected: onCredentialSelected })=>{
    const [isMenuOpen, setMenuOpen] = (0, $acw62.useState)(false);
    const languages = (0, $a51ba634029c0920$export$38be4353f99148d)();
    const toggleMenu = ()=>setMenuOpen(!isMenuOpen);
    const closeMenu = ()=>setMenuOpen(false);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") closeMenu();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: `button button-primary-outline flex-column p0 w100 relative ${$b09fa11bbab2e6c3$export$f9f39c6c13ec0e21}`,
        "aria-controls": "popup-menu",
        "aria-expanded": isMenuOpen,
        "aria-haspopup": "true",
        onClick: toggleMenu,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-center justify-between p2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: callToAction
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            transition: "150ms ease-in-out",
                            transformOrigin: "center",
                            transform: `${isMenuOpen ? "rotate(180deg)" : "rotate(0)"}`
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee1790168eebbcf3$export$65be7b63f510f362), {})
                    })
                ]
            }),
            isMenuOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                id: "popup-menu",
                className: `m0 list-reset absolute w100 br-8 ${$b09fa11bbab2e6c3$export$8f9bd17e3a898bbb}`,
                children: credentials.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "flex flex-center justify-between hover-bg-light",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    role: "button",
                                    "aria-pressed": "false",
                                    "aria-label": callToAction,
                                    className: `button button-tiny button-link justify-start w100 p2 ${$b09fa11bbab2e6c3$export$46ca3e9f3d219720}`,
                                    onClick: ()=>onCredentialSelected(item),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: `${$b09fa11bbab2e6c3$export$4d16178ab09a8b0}`,
                                        title: (0, $9b91ad5c4a00d4b3$export$cbc6006367cb5d5d)(item, languages),
                                        children: (0, $9b91ad5c4a00d4b3$export$cbc6006367cb5d5d)(item, languages)
                                    })
                                })
                            }),
                            viewMessage && item.id ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                    to: `/credentials/${item.id}`,
                                    className: "button button-tiny button-transparent",
                                    "aria-label": viewMessage,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                            children: viewMessage
                                        })
                                    })
                                })
                            }) : null
                        ]
                    }, item.id))
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");



function $cbeaf9487d318270$export$b29165f610f3efdc({ inputDescriptor: inputDescriptor, credentials: credentials, onSelectCredential: onSelectCredential }) {
    const [selectedCredential, setSelectedCredential] = (0, $acw62.useState)(null);
    const languages = (0, $a51ba634029c0920$export$38be4353f99148d)();
    const handleCredentialSelected = (credential)=>{
        setSelectedCredential(credential);
        onSelectCredential(credential);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            credentials.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7dd81570d314681$export$ba25329847403e11), {
                credentials: credentials,
                callToAction: selectedCredential ? (0, $9b91ad5c4a00d4b3$export$cbc6006367cb5d5d)(selectedCredential, languages) : "Select credential",
                viewMessage: "View details",
                onCredentialSelected: handleCredentialSelected
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "warning",
                title: "No matching credentials found",
                errorMessage: "Get credentials meeting your specified criteria from existing issuers, or initiate the process by adding a new issuer."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: inputDescriptor.purpose
            })
        ]
    });
}




/**
 * The state machine reducer
 * @param state the current state
 * @param action the action describing the last occuring event
 * @return the new state
 */ function $85711a47428f07e0$var$reducer(state, action) {
    switch(action.type){
        case "error":
            return {
                state: "error",
                message: action.message
            };
        case "submit-error":
            return {
                state: "submit-error",
                message: action.message,
                selectedCredential: action.selectedCredential,
                validatedRequestJwt: action.validatedRequestJwt,
                credentialFinderResult: action.credentialFinderResult
            };
        case "presentation-request-fetched":
            return {
                state: "presentation-request-fetched",
                validatedRequestJwt: action.validatedRequestJwt,
                credentialFinderResult: action.credentialFinderResult
            };
        case "start-fetch":
            return {
                state: "fetching-presentation-request"
            };
        case "select-disclosures":
            if (state.state == "presentation-request-fetched") return {
                state: "select-disclosures",
                validatedRequestJwt: state.validatedRequestJwt,
                credentialFinderResult: state.credentialFinderResult,
                selectedCredential: action.selectedCredential,
                disclosures: []
            };
            // this should not happen
            return state;
        case "add-disclosure":
            if (state.state == "select-disclosures") return {
                ...state,
                disclosures: state.disclosures.concat(action.disclosure)
            };
            // this should not happen
            return state;
        case "remove-disclosures":
            if (state.state == "select-disclosures") return {
                ...state,
                disclosures: state.disclosures.filter((it)=>!action.disclosures.includes(it))
            };
            // this should not happen
            return state;
        case "submit-presentation":
            return {
                state: "submitting-presentation",
                validatedRequestJwt: action.validatedRequestJwt,
                credentialFinderResult: action.credentialFinderResult
            };
        case "submitting-done":
            return {
                state: "presentation-submitted"
            };
    }
}
/*
 * Utility functions
 */ async function $85711a47428f07e0$var$resolvePresentationRequest(uri, requestId, dispatcher, navigate) {
    try {
        const validatedRequestJwt = await $85711a47428f07e0$var$getValidatedRequestJwt(uri, requestId, navigate);
        const credentialFinderResult = await (0, $c02206712fb92858$export$791f310f53465dc).find(validatedRequestJwt.presentationDefinition);
        dispatcher({
            type: "presentation-request-fetched",
            validatedRequestJwt: validatedRequestJwt,
            credentialFinderResult: credentialFinderResult
        });
    } catch (error) {
        const msg = $85711a47428f07e0$var$sanitizeErrorMessage(error);
        dispatcher({
            type: "error",
            message: msg
        });
    }
}
async function $85711a47428f07e0$var$getValidatedRequestJwt(uri, requestId, navigate) {
    // try from the store first
    if (requestId == null) throw new Error("Invalid presentation request uri");
    let validatedRequestJwt = (0, $c02206712fb92858$export$a5f7d70093347642).getById(requestId);
    if (validatedRequestJwt == null) {
        if (uri == null) throw new Error("Invalid presentation request");
        validatedRequestJwt = await (0, $c02206712fb92858$export$43f9926bdf4a1bde).fetchRequestObjectJwt(uri);
        if (validatedRequestJwt != null) {
            // put the request jwt into the store
            (0, $c02206712fb92858$export$a5f7d70093347642).insert(requestId, validatedRequestJwt);
            // go to this page with request-id in path
            navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_PRESENTATION_RESOLVE_WITH_ID(requestId));
        }
    } else if (uri != null) // validatedRequestJwt was found and uri was in the search params
    // go to this page with request-id in path
    navigate((0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).TO_PRESENTATION_RESOLVE_WITH_ID(requestId));
    return validatedRequestJwt;
}
function $85711a47428f07e0$var$sanitizeErrorMessage(error) {
    let msg = error["message"] || "Generic error.";
    if (msg == "Parent job is Cancelled" && error["cause"]?.message != null) msg = error["cause"]?.message;
    msg = msg?.replace("Error at 'unknown location': RuntimeException:", "");
    msg = msg?.replace("Error at 'unknown location': Exception:", "");
    msg = msg?.replace("Error at 'unknown location': TypeError:", "");
    return msg;
}
function $85711a47428f07e0$var$getRequestUriAndId(location) {
    if (location.search) {
        const queryParams = new URLSearchParams(location.search);
        const requestUri = queryParams.get("request_uri");
        const requestUrl = new URL(requestUri);
        const requestId = requestUrl.searchParams.get("id");
        return [
            requestUri,
            requestId
        ];
    }
    // get last part of path, which should be the request id
    const requestId = location.pathname.split("/").pop();
    return [
        null,
        requestId
    ];
}
async function $85711a47428f07e0$var$submitResponse(selectedCredential, state, dispatcher, location) {
    // if 'vc+sd-jwt' go to the select disclosure state...
    if (selectedCredential.credential.vcSdJwt && state.state == "presentation-request-fetched") {
        dispatcher({
            type: "select-disclosures",
            selectedCredential: selectedCredential
        });
        return;
    }
    // ... else create and submit the presentation immediately
    // So that the UI reflects the ongoing submission
    dispatcher({
        type: "submit-presentation",
        validatedRequestJwt: state.validatedRequestJwt,
        credentialFinderResult: state.credentialFinderResult
    });
    const disclosures = state.state == "select-disclosures" ? state.disclosures : [];
    const userSelectedCredentials = new (0, $8b4eb369eb8605c9$exports.JsUserSelectedCredentials)(state.credentialFinderResult.data.map((pair)=>{
        return new (0, $8b4eb369eb8605c9$exports.JsUserSelectedCredential)(pair.first, selectedCredential, new (0, $8b4eb369eb8605c9$exports.JsPresentationDisclosure)(disclosures));
    }));
    const uri = state.validatedRequestJwt.responseUri;
    const params = await (0, $c02206712fb92858$export$a3f6b50fc634f9ec).createVerifiablePresentationResponse(state.validatedRequestJwt, userSelectedCredentials);
    try {
        await (0, $c02206712fb92858$export$43f9926bdf4a1bde).postDirectPostAuthorizationResponse(uri, params);
        (0, $9fd44832378de894$export$888e567f63ec7c8b)("User actions", "Credential", "presented");
        dispatcher({
            type: "submitting-done"
        });
        const [, requestId] = $85711a47428f07e0$var$getRequestUriAndId(location);
        (0, $c02206712fb92858$export$a5f7d70093347642).delete(requestId);
    } catch (error) {
        dispatcher({
            type: "submit-error",
            message: $85711a47428f07e0$var$sanitizeErrorMessage(error),
            selectedCredential: selectedCredential,
            validatedRequestJwt: state.validatedRequestJwt,
            credentialFinderResult: state.credentialFinderResult
        });
    }
}
function $85711a47428f07e0$export$7eee8cc1110d74fa() {
    const [state, dispatch] = (0, $acw62.useReducer)($85711a47428f07e0$var$reducer, {
        state: "fetching-presentation-request"
    });
    const [selectedCredential, setSelectedCredential] = $acw62.useState(null);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleCredentialSelected = (credential)=>{
        setSelectedCredential(credential);
    };
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    (0, $acw62.useEffect)(()=>{
        const [requestUri, requestId] = $85711a47428f07e0$var$getRequestUriAndId(location);
        $85711a47428f07e0$var$resolvePresentationRequest(requestUri, requestId, dispatch, navigate);
    }, [
        location,
        navigate,
        location.search
    ]);
    return $85711a47428f07e0$var$render(state, dispatch, selectedCredential, handleCredentialSelected, location, navigate);
}
/**
 * Render function
 */ function $85711a47428f07e0$var$render(state, dispatcher, selectedCredential, handleCredentialSelected, location, navigate) {
    switch(state.state){
        case "fetching-presentation-request":
            return $85711a47428f07e0$var$renderSpinner("Please wait. Resolving presentation request...");
        case "presentation-request-fetched":
            return $85711a47428f07e0$var$renderSelectCredentials(state, dispatcher, state.validatedRequestJwt, state.credentialFinderResult, selectedCredential, handleCredentialSelected, location);
        case "error":
            return $85711a47428f07e0$var$renderError(state, dispatcher, location, navigate);
        case "submit-error":
            return $85711a47428f07e0$var$renderSubmitError(state, dispatcher, location);
        case "select-disclosures":
            return $85711a47428f07e0$var$renderSelectDisclosures(state, dispatcher, location);
        case "submitting-presentation":
            return $85711a47428f07e0$var$renderSpinner("Please wait. Submitting presentation...");
        case "presentation-submitted":
            return $85711a47428f07e0$var$renderDone();
    }
}
function $85711a47428f07e0$var$renderSpinner(message) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "h4 center",
                children: message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ea38996be51ba1$export$7f7cbe89f1eacd2), {})
        ]
    });
}
function $85711a47428f07e0$var$renderDone() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f169731e77dd4f03$export$84c41a61aa1cc56c), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "You are done!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Please continue at the Verifier..."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        className: "button button-medium button-primary-outline w100",
                        children: "OK"
                    })
                ]
            })
        ]
    });
}
function $85711a47428f07e0$var$renderSelectCredentials(state, dispatcher, validatedRequestJwt, credentialFinderResult, selectedCredential, handleCredentialSelected, location) {
    const submitButtonText = "Accept and continue";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: validatedRequestJwt.presentationDefinition.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: validatedRequestJwt.presentationDefinition.purpose
            }),
            credentialFinderResult.data.length !== 0 ? credentialFinderResult.data.map((descriptorCredentialsPair)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cbeaf9487d318270$export$b29165f610f3efdc), {
                    inputDescriptor: descriptorCredentialsPair.first,
                    credentials: descriptorCredentialsPair.second,
                    onSelectCredential: handleCredentialSelected
                }, descriptorCredentialsPair.first.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "info",
                title: "No credentials",
                errorMessage: "No matching credentials found"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-column flex-gap-2",
                children: [
                    credentialFinderResult.data.length !== 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-primary w100",
                        onClick: ()=>$85711a47428f07e0$var$submitResponse(selectedCredential, state, dispatcher, location),
                        disabled: selectedCredential == null,
                        children: submitButtonText
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        className: "button button-medium button-primary-outline ",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
function $85711a47428f07e0$var$renderSelectDisclosures(state, dispatcher, location) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "select-disclosures",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Choose Credential Information to Disclose"
                    }),
                    $85711a47428f07e0$var$renderSdValue(dispatcher, state.selectedCredential.credential.vcSdJwt.customSdClaims, true, state.disclosures),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-primary w100 mt2",
                        onClick: ()=>$85711a47428f07e0$var$submitResponse(state.selectedCredential, state, dispatcher, location),
                        children: "Accept and continue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31654cd1dbe40fbe$export$88ca206278a45434), {
                title: "Disclosures",
                data: state.disclosures
            })
        ]
    });
}
function $85711a47428f07e0$var$renderSdValue(dispatcher, value, isDisclosed, disclosures) {
    if (value instanceof (0, $8b4eb369eb8605c9$exports.JsSdObject)) return $85711a47428f07e0$var$renderSdObject(dispatcher, value, isDisclosed, disclosures);
    else if (value instanceof (0, $8b4eb369eb8605c9$exports.JsSdArray)) return $85711a47428f07e0$var$renderSdArray(dispatcher, value, isDisclosed, disclosures);
    else if (value instanceof (0, $8b4eb369eb8605c9$exports.JsSdPrimitive)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: value.value
    });
}
function $85711a47428f07e0$var$renderSdObject(dispatcher, obj, isDisclosed, disclosures) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: Array.from(obj.members.values()).map((property)=>{
            return $85711a47428f07e0$var$renderSdProperty(dispatcher, property, isDisclosed, disclosures);
        })
    });
}
function $85711a47428f07e0$var$renderSdProperty(dispatcher, property, isParentDisclosed, disclosures) {
    const isCheckboxDisabled = !isParentDisclosed || !property.isSelectivelyDisclosable;
    const isChecked = isParentDisclosed && (!property.isSelectivelyDisclosable || property.isDisclosedBy(disclosures));
    const isDisclosed = isChecked;
    function handleClick() {
        if (!isDisclosed) dispatcher({
            type: "add-disclosure",
            disclosure: property.disclosureString
        });
        else dispatcher({
            type: "remove-disclosures",
            disclosures: property.value.getNestedDisclosures().concat([
                property.disclosureString
            ])
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "sd-property",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                disabled: isCheckboxDisabled,
                checked: isChecked,
                onClick: handleClick
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "sd-property-value",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: property.name
                    }),
                    $85711a47428f07e0$var$renderSdValue(dispatcher, property.value, isDisclosed, disclosures)
                ]
            })
        ]
    }, property.name);
}
function $85711a47428f07e0$var$renderSdArray(dispatcher, array, isDisclosed, disclosures) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "sd-array",
        children: array.elements.map((element, ix)=>$85711a47428f07e0$var$renderSdArrayValue(dispatcher, element, ix, isDisclosed, disclosures))
    });
}
function $85711a47428f07e0$var$renderSdArrayValue(dispatcher, arrayValue, index, isParentDisclosed, disclosures) {
    const isCheckboxDisabled = !isParentDisclosed || !arrayValue.isSelectivelyDisclosable;
    const isChecked = isParentDisclosed && (!arrayValue.isSelectivelyDisclosable || arrayValue.isDisclosedBy(disclosures));
    const isDisclosed = isChecked;
    function handleClick() {
        if (!isDisclosed) dispatcher({
            type: "add-disclosure",
            disclosure: arrayValue.disclosureString
        });
        else dispatcher({
            type: "remove-disclosures",
            disclosures: arrayValue.value.getNestedDisclosures().concat([
                arrayValue.disclosureString
            ])
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "sd-array-value",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "checkbox",
                disabled: isCheckboxDisabled,
                checked: isChecked,
                onClick: handleClick
            }),
            $85711a47428f07e0$var$renderSdValue(dispatcher, arrayValue.value, isDisclosed, disclosures)
        ]
    }, index);
}
function $85711a47428f07e0$var$renderError(state, dispatcher, location, navigate) {
    function onClick() {
        dispatcher({
            type: "start-fetch"
        });
        const [requestUri, requestId] = $85711a47428f07e0$var$getRequestUriAndId(location);
        $85711a47428f07e0$var$resolvePresentationRequest(requestUri, requestId, dispatcher, navigate);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "There was an error resolving presentation request",
                errorMessage: state.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-column flex-gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-primary w100",
                        onClick: onClick,
                        children: "Try again"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        className: "button button-medium button-primary-outline ",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
function $85711a47428f07e0$var$renderSubmitError(state, dispatcher, location) {
    function onClick() {
        const fetchedState = {
            state: "presentation-request-fetched",
            validatedRequestJwt: state.validatedRequestJwt,
            credentialFinderResult: state.credentialFinderResult
        };
        $85711a47428f07e0$var$submitResponse(state.selectedCredential, fetchedState, dispatcher, location);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f73490bdf36048c$export$caec2af78bcc877f), {
                kind: "danger",
                title: "There was an error sending presentation to verifier",
                errorMessage: state.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-column flex-gap-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "button button-medium button-primary w100",
                        onClick: onClick,
                        children: "Try again"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                        className: "button button-medium button-primary-outline ",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");
var $ae921eff144f1916$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $ae921eff144f1916$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});



var $acw62 = parcelRequire("acw62");
/**
 * A function to wrap elements with a "wrapper" on a condition
 * @param {object} wrappingOptions
 *  condition == boolean condition, when to wrap
 *  wrapper == style to wrap. e.g <div>{children}</div>
 *  children == react passes whatever is between tags as children. Don't supply this yourself.
 */ var $49354de8006ddfc2$export$39aecc95f0365819 = function ConditionalWrapper(_ref) {
    var condition = _ref.condition, wrapper = _ref.wrapper, children = _ref.children;
    return condition ? wrapper(children) : children;
};
function $49354de8006ddfc2$var$_extends() {
    $49354de8006ddfc2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49354de8006ddfc2$var$_extends.apply(this, arguments);
}
function $49354de8006ddfc2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $49354de8006ddfc2$var$_setPrototypeOf(subClass, superClass);
}
function $49354de8006ddfc2$var$_setPrototypeOf(o, p) {
    $49354de8006ddfc2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $49354de8006ddfc2$var$_setPrototypeOf(o, p);
}
function $49354de8006ddfc2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $49354de8006ddfc2$export$8eb3892b442747bd = {
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none"
};
var $49354de8006ddfc2$export$a83cc8fc1e235be1;
(function(SAME_SITE_OPTIONS) {
    SAME_SITE_OPTIONS["STRICT"] = "strict";
    SAME_SITE_OPTIONS["LAX"] = "lax";
    SAME_SITE_OPTIONS["NONE"] = "none";
})($49354de8006ddfc2$export$a83cc8fc1e235be1 || ($49354de8006ddfc2$export$a83cc8fc1e235be1 = {}));
var $49354de8006ddfc2$export$294703df038a1b6f = {
    HIDDEN: "hidden",
    SHOW: "show",
    BY_COOKIE_VALUE: "byCookieValue"
};
var $49354de8006ddfc2$export$2ba1cf4ce66b15cf = "CookieConsent";
var $49354de8006ddfc2$var$_excluded = [
    "children"
];
var $49354de8006ddfc2$var$DefaultButtonComponent = function DefaultButtonComponent(_ref) {
    var children = _ref.children, props = $49354de8006ddfc2$var$_objectWithoutPropertiesLoose(_ref, $49354de8006ddfc2$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, props), children);
};
var $49354de8006ddfc2$var$defaultCookieConsentProps = {
    disableStyles: false,
    hideOnAccept: true,
    hideOnDecline: true,
    location: $49354de8006ddfc2$export$8eb3892b442747bd.BOTTOM,
    visible: $49354de8006ddfc2$export$294703df038a1b6f.BY_COOKIE_VALUE,
    onAccept: function onAccept(_acceptedByScrolling) {},
    onDecline: function onDecline() {},
    cookieName: $49354de8006ddfc2$export$2ba1cf4ce66b15cf,
    cookieValue: "true",
    declineCookieValue: "false",
    setDeclineCookie: true,
    buttonText: "I understand",
    declineButtonText: "I decline",
    debug: false,
    expires: 365,
    containerClasses: "CookieConsent",
    contentClasses: "",
    buttonClasses: "",
    buttonWrapperClasses: "",
    declineButtonClasses: "",
    buttonId: "rcc-confirm-button",
    declineButtonId: "rcc-decline-button",
    extraCookieOptions: {},
    disableButtonStyles: false,
    enableDeclineButton: false,
    flipButtons: false,
    sameSite: $49354de8006ddfc2$export$a83cc8fc1e235be1.LAX,
    ButtonComponent: $49354de8006ddfc2$var$DefaultButtonComponent,
    overlay: false,
    overlayClasses: "",
    onOverlayClick: function onOverlayClick() {},
    acceptOnOverlayClick: false,
    ariaAcceptLabel: "Accept cookies",
    ariaDeclineLabel: "Decline cookies",
    acceptOnScroll: false,
    acceptOnScrollPercentage: 25,
    customContentAttributes: {},
    customContainerAttributes: {},
    customButtonProps: {},
    customDeclineButtonProps: {},
    customButtonWrapperAttributes: {},
    style: {},
    buttonStyle: {},
    declineButtonStyle: {},
    contentStyle: {},
    overlayStyle: {}
};
var $49354de8006ddfc2$var$defaultState = {
    visible: false,
    style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
    },
    buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    declineButtonStyle: {
        background: "#c12a2a",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "#e5e5e5",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
    },
    overlayStyle: {
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: "999",
        backgroundColor: "rgba(0,0,0,0.3)"
    }
};
/**
 * Returns the value of the consent cookie
 * Retrieves the regular value first and if not found the legacy one according
 * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
 * @param {*} name optional name of the cookie
 */ var $49354de8006ddfc2$export$a8e4ce6c059bdd6b = function getCookieConsentValue(name) {
    if (name === void 0) name = $49354de8006ddfc2$export$2ba1cf4ce66b15cf;
    var cookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).get(name);
    // if the cookieValue is undefined check for the legacy cookie
    if (cookieValue === undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).get($49354de8006ddfc2$export$ee149ea8a5f63691(name));
    return cookieValue;
};
/**
 * Reset the consent cookie
 * Remove the cookie on browser in order to allow user to change their consent
 * @param {*} name optional name of the cookie
 */ var $49354de8006ddfc2$export$f3238b6dfe3e6b67 = function resetCookieConsentValue(name) {
    if (name === void 0) name = $49354de8006ddfc2$export$2ba1cf4ce66b15cf;
    (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).remove(name);
};
/**
 * Get the legacy cookie name by the regular cookie name
 * @param {string} name of cookie to get
 */ var $49354de8006ddfc2$export$ee149ea8a5f63691 = function getLegacyCookieName(name) {
    return name + "-legacy";
};
var $49354de8006ddfc2$export$e06767a507a85916 = /*#__PURE__*/ function(_Component) {
    $49354de8006ddfc2$var$_inheritsLoose(CookieConsent, _Component);
    function CookieConsent() {
        var _this;
        _this = _Component.apply(this, arguments) || this;
        _this.state = $49354de8006ddfc2$var$defaultState;
        /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */ _this.handleScroll = function() {
            var _defaultCookieConsent = $49354de8006ddfc2$var$_extends({}, $49354de8006ddfc2$var$defaultCookieConsentProps, _this.props), acceptOnScrollPercentage = _defaultCookieConsent.acceptOnScrollPercentage;
            // (top / height) - height * 100
            var rootNode = document.documentElement;
            var body = document.body;
            var top = "scrollTop";
            var height = "scrollHeight";
            var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
            if (percentage > acceptOnScrollPercentage) _this.accept(true);
        };
        _this.removeScrollListener = function() {
            var acceptOnScroll = _this.props.acceptOnScroll;
            if (acceptOnScroll) window.removeEventListener("scroll", _this.handleScroll);
        };
        return _this;
    }
    var _proto = CookieConsent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var debug = this.props.debug;
        // if cookie undefined or debug
        if (this.getCookieValue() === undefined || debug) {
            this.setState({
                visible: true
            });
            // if acceptOnScroll is set to true and (cookie is undefined or debug is set to true), add a listener.
            if (this.props.acceptOnScroll) window.addEventListener("scroll", this.handleScroll, {
                passive: true
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // remove listener if still set
        this.removeScrollListener();
    } /**
   * Set a persistent accept cookie
   */ ;
    _proto.accept = function accept(acceptedByScrolling) {
        var _acceptedByScrolling;
        if (acceptedByScrolling === void 0) acceptedByScrolling = false;
        var _defaultCookieConsent2 = $49354de8006ddfc2$var$_extends({}, $49354de8006ddfc2$var$defaultCookieConsentProps, this.props), cookieName = _defaultCookieConsent2.cookieName, cookieValue = _defaultCookieConsent2.cookieValue, hideOnAccept = _defaultCookieConsent2.hideOnAccept, onAccept = _defaultCookieConsent2.onAccept;
        this.setCookie(cookieName, cookieValue);
        onAccept((_acceptedByScrolling = acceptedByScrolling) != null ? _acceptedByScrolling : false);
        if (hideOnAccept) {
            this.setState({
                visible: false
            });
            this.removeScrollListener();
        }
    } /**
   * Handle a click on the overlay
   */ ;
    _proto.overlayClick = function overlayClick() {
        var _defaultCookieConsent3 = $49354de8006ddfc2$var$_extends({}, $49354de8006ddfc2$var$defaultCookieConsentProps, this.props), acceptOnOverlayClick = _defaultCookieConsent3.acceptOnOverlayClick, onOverlayClick = _defaultCookieConsent3.onOverlayClick;
        if (acceptOnOverlayClick) this.accept();
        onOverlayClick();
    } /**
   * Set a persistent decline cookie
   */ ;
    _proto.decline = function decline() {
        var _defaultCookieConsent4 = $49354de8006ddfc2$var$_extends({}, $49354de8006ddfc2$var$defaultCookieConsentProps, this.props), cookieName = _defaultCookieConsent4.cookieName, declineCookieValue = _defaultCookieConsent4.declineCookieValue, hideOnDecline = _defaultCookieConsent4.hideOnDecline, onDecline = _defaultCookieConsent4.onDecline, setDeclineCookie = _defaultCookieConsent4.setDeclineCookie;
        if (setDeclineCookie) this.setCookie(cookieName, declineCookieValue);
        onDecline();
        if (hideOnDecline) this.setState({
            visible: false
        });
    } /**
   * Function to set the consent cookie based on the provided variables
   * Sets two cookies to handle incompatible browsers, more details:
   * https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.setCookie = function setCookie(cookieName, cookieValue) {
        var _this$props = this.props, extraCookieOptions = _this$props.extraCookieOptions, expires = _this$props.expires, sameSite = _this$props.sameSite;
        var cookieSecurity = this.props.cookieSecurity;
        if (cookieSecurity === undefined) cookieSecurity = window.location ? window.location.protocol === "https:" : true;
        var cookieOptions = $49354de8006ddfc2$var$_extends({
            expires: expires
        }, extraCookieOptions, {
            sameSite: sameSite,
            secure: cookieSecurity
        });
        // Fallback for older browsers where can not set SameSite=None,
        // SEE: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
        if (sameSite === $49354de8006ddfc2$export$a83cc8fc1e235be1.NONE) (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).set($49354de8006ddfc2$export$ee149ea8a5f63691(cookieName), cookieValue, cookieOptions);
        // set the regular cookie
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).set(cookieName, cookieValue, cookieOptions);
    } /**
   * Returns the value of the consent cookie
   * Retrieves the regular value first and if not found the legacy one according
   * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
   */ ;
    _proto.getCookieValue = function getCookieValue() {
        var cookieName = this.props.cookieName;
        return $49354de8006ddfc2$export$a8e4ce6c059bdd6b(cookieName);
    };
    _proto.render = function render() {
        var _this2 = this;
        // If the bar shouldn't be visible don't render anything.
        switch(this.props.visible){
            case $49354de8006ddfc2$export$294703df038a1b6f.HIDDEN:
                return null;
            case $49354de8006ddfc2$export$294703df038a1b6f.BY_COOKIE_VALUE:
                if (!this.state.visible) return null;
                break;
        }
        var _this$props2 = this.props, location = _this$props2.location, style = _this$props2.style, buttonStyle = _this$props2.buttonStyle, declineButtonStyle = _this$props2.declineButtonStyle, contentStyle = _this$props2.contentStyle, disableStyles = _this$props2.disableStyles, buttonText = _this$props2.buttonText, declineButtonText = _this$props2.declineButtonText, containerClasses = _this$props2.containerClasses, contentClasses = _this$props2.contentClasses, buttonClasses = _this$props2.buttonClasses, buttonWrapperClasses = _this$props2.buttonWrapperClasses, declineButtonClasses = _this$props2.declineButtonClasses, buttonId = _this$props2.buttonId, declineButtonId = _this$props2.declineButtonId, disableButtonStyles = _this$props2.disableButtonStyles, enableDeclineButton = _this$props2.enableDeclineButton, flipButtons = _this$props2.flipButtons, ButtonComponent = _this$props2.ButtonComponent, overlay = _this$props2.overlay, overlayClasses = _this$props2.overlayClasses, overlayStyle = _this$props2.overlayStyle, ariaAcceptLabel = _this$props2.ariaAcceptLabel, ariaDeclineLabel = _this$props2.ariaDeclineLabel, customContainerAttributes = _this$props2.customContainerAttributes, customContentAttributes = _this$props2.customContentAttributes, customButtonProps = _this$props2.customButtonProps, customDeclineButtonProps = _this$props2.customDeclineButtonProps, customButtonWrapperAttributes = _this$props2.customButtonWrapperAttributes;
        var myStyle = {};
        var myButtonStyle = {};
        var myDeclineButtonStyle = {};
        var myContentStyle = {};
        var myOverlayStyle = {};
        if (disableStyles) {
            // if styles are disabled use the provided styles (or none)
            myStyle = Object.assign({}, style);
            myButtonStyle = Object.assign({}, buttonStyle);
            myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            myContentStyle = Object.assign({}, contentStyle);
            myOverlayStyle = Object.assign({}, overlayStyle);
        } else {
            // if styles aren't disabled merge them with the styles that are provided (or use default styles)
            myStyle = Object.assign({}, $49354de8006ddfc2$var$_extends({}, this.state.style, style));
            myContentStyle = Object.assign({}, $49354de8006ddfc2$var$_extends({}, this.state.contentStyle, contentStyle));
            myOverlayStyle = Object.assign({}, $49354de8006ddfc2$var$_extends({}, this.state.overlayStyle, overlayStyle));
            // switch to disable JUST the button styles
            if (disableButtonStyles) {
                myButtonStyle = Object.assign({}, buttonStyle);
                myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            } else {
                myButtonStyle = Object.assign({}, $49354de8006ddfc2$var$_extends({}, this.state.buttonStyle, buttonStyle));
                myDeclineButtonStyle = Object.assign({}, $49354de8006ddfc2$var$_extends({}, this.state.declineButtonStyle, declineButtonStyle));
            }
        }
        // syntactic sugar to enable user to easily select top / bottom
        switch(location){
            case $49354de8006ddfc2$export$8eb3892b442747bd.TOP:
                myStyle.top = "0";
                break;
            case $49354de8006ddfc2$export$8eb3892b442747bd.BOTTOM:
                myStyle.bottom = "0";
                break;
        }
        var buttonsToRender = [];
        // add decline button
        enableDeclineButton && buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ButtonComponent, Object.assign({
            key: "declineButton",
            style: myDeclineButtonStyle,
            className: declineButtonClasses,
            id: declineButtonId,
            "aria-label": ariaDeclineLabel,
            onClick: function onClick() {
                _this2.decline();
            }
        }, customDeclineButtonProps), declineButtonText));
        // add accept button
        buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ButtonComponent, Object.assign({
            key: "acceptButton",
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            "aria-label": ariaAcceptLabel,
            onClick: function onClick() {
                _this2.accept();
            }
        }, customButtonProps), buttonText));
        if (flipButtons) buttonsToRender.reverse();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($49354de8006ddfc2$export$39aecc95f0365819, {
            condition: overlay,
            wrapper: function wrapper(children) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    style: myOverlayStyle,
                    className: overlayClasses,
                    onClick: function onClick() {
                        _this2.overlayClick();
                    }
                }, children);
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            className: "" + containerClasses,
            style: myStyle
        }, customContainerAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            style: myContentStyle,
            className: contentClasses
        }, customContentAttributes), this.props.children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
            className: "" + buttonWrapperClasses
        }, customButtonWrapperAttributes), buttonsToRender.map(function(button) {
            return button;
        }))));
    };
    return CookieConsent;
}((0, $acw62.Component));
$49354de8006ddfc2$export$e06767a507a85916.defaultProps = $49354de8006ddfc2$var$defaultCookieConsentProps;
var $49354de8006ddfc2$export$2e2bcd8739ae039 = $49354de8006ddfc2$export$e06767a507a85916;




const $6d6a3e52cb046298$var$PRODUCTION_HOST = "wallet.decentralized-identity.io";
const $6d6a3e52cb046298$var$initGA = (id)=>{
    if ($6d6a3e52cb046298$var$PRODUCTION_HOST === location.host) (0, (/*@__PURE__*/$parcel$interopDefault($fd664e149db4c2ea$exports))).initialize(id);
};
const $6d6a3e52cb046298$export$2b3af6baec22bd98 = ()=>{
    const handleAcceptCookie = ()=>{
        $6d6a3e52cb046298$var$initGA("G-W7SE1RM42D");
    };
    const handleDeclineCookie = ()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).remove("_ga");
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).remove("_gat");
        (0, (/*@__PURE__*/$parcel$interopDefault($ae921eff144f1916$exports))).remove("_gid");
    };
    (0, $acw62.useEffect)(()=>{
        const isConsent = (0, $49354de8006ddfc2$export$a8e4ce6c059bdd6b)();
        if (isConsent === "true") handleAcceptCookie();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49354de8006ddfc2$export$2e2bcd8739ae039), {
        disableStyles: true,
        enableDeclineButton: true,
        onAccept: handleAcceptCookie,
        onDecline: handleDeclineCookie,
        children: [
            "We use cookies to enhance your online experience and help personalize your visit so you are receiving the most relevant content.",
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: "https://curity.io/terms-of-service/",
                target: "_blank",
                rel: "noreferrer",
                children: "Privacy Policy"
            })
        ]
    });
};


const $cd93687958c8007e$var$router = (0, $040dbb9c344a508d$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2799a6352e628d99$export$c84671f46d6a1ca), {}),
        children: [
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).HOME,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Curity Demo Wallet",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ddabedec9b02645$export$b94310965bed44e6), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ABOUT,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "About",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb1f982b375c0798$export$c8424c4d8ba2150), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).START,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Start",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $094438c0fe134892$export$568b89e600fc77eb), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).OFFER_RESOLVE,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Resolve Offer",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69dd42c1497226e6$export$eafe3800aa6503f9), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).SCAN,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Scan QR Code",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c475912c2fba10b1$export$f2b7c70641756fd4), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_LIST,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Issuers",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $432c0bfca372dee0$export$ef50156decfcbb20), {})
                }),
                loader: (0, $b8861fdd32a45cce$export$b187bfb7762ed1d1)
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).SETTINGS,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Settings",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $97e9c2760dd1027f$export$c72f6eaae7b9adff), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_DETAIL,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Issuer",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51fd8781ec849bae$export$5abe2a56a0207b63), {})
                }),
                loader: (0, $b8861fdd32a45cce$export$59dd5c9438358cde)
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).ISSUER_ADD,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Add issuer",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e71e4428a17df563$export$93f2f36e171ad6f7), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).CREDENTIAL_ISSUANCE,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Request credential",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee7a4117102a85c8$export$b386a42a92ea432d), {})
                }),
                loader: (0, $b8861fdd32a45cce$export$59dd5c9438358cde)
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).CREDENTIAL_LIST,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Credentials",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73b03cf1a79c4eaa$export$957aea9438988dfb), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).CREDENTIAL_DETAIL,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Credential",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ed4dfdf7a9f6cec$export$75d757922a6a242c), {})
                })
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).OAUTH_CALLBACK,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ad8734dfcdf3d44$export$8364ea6a3924dcdf), {})
            },
            {
                path: (0, $f8409e0880c5cb17$export$66b32f6f30eb4b4).PRESENTATION_RESOLVE,
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6b7e032aded9a09$export$6955bcca4cd3539f), {
                    title: "Present Credentials",
                    backButton: -1,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85711a47428f07e0$export$7eee8cc1110d74fa), {})
                })
            }
        ]
    },
    {
        // fallback route (not sure if needed)
        path: "*",
        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
            to: "/"
        })
    }
]);
function $cd93687958c8007e$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51ba634029c0920$export$7b481c2df9e2f440), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$323e4fc2fa4753fb), {
                router: $cd93687958c8007e$var$router
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d6a3e52cb046298$export$2b3af6baec22bd98), {})
        ]
    });
}


var $2857dc952d963d0e$exports = {};
$2857dc952d963d0e$exports = new URL("service-worker.js", import.meta.url).toString();


// Load service worker
if ("serviceWorker" in navigator) navigator.serviceWorker.register($2857dc952d963d0e$exports, {
    scope: "/"
});
// Start UI controlled by React
const $a88ea9323d3a23c8$var$container = document.getElementById("app");
const $a88ea9323d3a23c8$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($a88ea9323d3a23c8$var$container);
$a88ea9323d3a23c8$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.3da163ae.js.map
